/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			var _m = moreModules[moduleId];
/******/
/******/ 			// Check if module is deduplicated
/******/ 			switch(typeof _m) {
/******/ 			case "object":
/******/ 				// Module can be created from a template
/******/ 				modules[moduleId] = (function(_m) {
/******/ 					var args = _m.slice(1), templateId = _m[0];
/******/ 					return function (a,b,c) {
/******/ 						modules[templateId].apply(this, [a,b,c].concat(args));
/******/ 					};
/******/ 				}(_m));
/******/ 				break;
/******/ 			case "function":
/******/ 				// Normal module
/******/ 				modules[moduleId] = _m;
/******/ 				break;
/******/ 			default:
/******/ 				// Module is a copy of another module
/******/ 				modules[moduleId] = modules[_m];
/******/ 				break;
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "." + ({"7":"app","8":"libs"}[chunkId]||chunkId) + ".bundle.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "assets/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	__webpack_require__(144);
	__webpack_require__(74);
	__webpack_require__(135);
	__webpack_require__(127);
	__webpack_require__(124);
	__webpack_require__(141);
	__webpack_require__(75);
	__webpack_require__(819);
	__webpack_require__(142);
	__webpack_require__(128);
	__webpack_require__(130);
	__webpack_require__(133);
	__webpack_require__(149);
	__webpack_require__(145);
	__webpack_require__(46);
	__webpack_require__(837);
	__webpack_require__(136);
	__webpack_require__(131);
	__webpack_require__(148);
	__webpack_require__(139);
	__webpack_require__(822);
	module.exports = __webpack_require__(823);


/***/ },

/***/ 1:
/***/ function(module, exports) {

	module.exports = angular;

/***/ },

/***/ 4:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.silentRejection = exports.silenceUncaughtInPromise = exports._extend = exports.copy = exports.tail = exports.applyPairs = exports.arrayTuples = exports.pairs = exports.assertFn = exports.assertMap = exports.assertPredicate = exports.flatten = exports.unnest = exports.uniqR = exports.pushR = exports.flattenR = exports.unnestR = exports.anyTrueR = exports.allTrueR = exports.values = exports.map = exports.mapObj = exports.find = exports.filter = exports.pluck = exports.omit = exports.pick = exports.ancestors = exports.mergeR = exports.defaults = exports.deregAll = exports._pushTo = exports.pushTo = exports._removeFrom = exports.removeFrom = exports._inArray = exports.inArray = exports.inherit = exports.createProxyFunctions = exports.noop = exports.identity = exports.equals = exports.extend = exports.forEach = exports.toJson = exports.fromJson = exports.root = void 0;
	/**
	 * Random utility functions used in the UI-Router code
	 *
	 * These functions are exported, but are subject to change without notice.
	 *
	 * @packageDocumentation
	 * @preferred
	 */
	var predicates_1 = __webpack_require__(5);
	var hof_1 = __webpack_require__(6);
	var coreservices_1 = __webpack_require__(8);
	exports.root = (typeof self === 'object' && self.self === self && self) ||
	    (typeof global === 'object' && global.global === global && global) ||
	    this;
	var angular = exports.root.angular || {};
	exports.fromJson = angular.fromJson || JSON.parse.bind(JSON);
	exports.toJson = angular.toJson || JSON.stringify.bind(JSON);
	exports.forEach = angular.forEach || _forEach;
	exports.extend = Object.assign || _extend;
	exports.equals = angular.equals || _equals;
	function identity(x) {
	    return x;
	}
	exports.identity = identity;
	function noop() { }
	exports.noop = noop;
	/**
	 * Builds proxy functions on the `to` object which pass through to the `from` object.
	 *
	 * For each key in `fnNames`, creates a proxy function on the `to` object.
	 * The proxy function calls the real function on the `from` object.
	 *
	 *
	 * #### Example:
	 * This example creates an new class instance whose functions are prebound to the new'd object.
	 * ```js
	 * class Foo {
	 *   constructor(data) {
	 *     // Binds all functions from Foo.prototype to 'this',
	 *     // then copies them to 'this'
	 *     bindFunctions(Foo.prototype, this, this);
	 *     this.data = data;
	 *   }
	 *
	 *   log() {
	 *     console.log(this.data);
	 *   }
	 * }
	 *
	 * let myFoo = new Foo([1,2,3]);
	 * var logit = myFoo.log;
	 * logit(); // logs [1, 2, 3] from the myFoo 'this' instance
	 * ```
	 *
	 * #### Example:
	 * This example creates a bound version of a service function, and copies it to another object
	 * ```
	 *
	 * var SomeService = {
	 *   this.data = [3, 4, 5];
	 *   this.log = function() {
	 *     console.log(this.data);
	 *   }
	 * }
	 *
	 * // Constructor fn
	 * function OtherThing() {
	 *   // Binds all functions from SomeService to SomeService,
	 *   // then copies them to 'this'
	 *   bindFunctions(SomeService, this, SomeService);
	 * }
	 *
	 * let myOtherThing = new OtherThing();
	 * myOtherThing.log(); // logs [3, 4, 5] from SomeService's 'this'
	 * ```
	 *
	 * @param source A function that returns the source object which contains the original functions to be bound
	 * @param target A function that returns the target object which will receive the bound functions
	 * @param bind A function that returns the object which the functions will be bound to
	 * @param fnNames The function names which will be bound (Defaults to all the functions found on the 'from' object)
	 * @param latebind If true, the binding of the function is delayed until the first time it's invoked
	 */
	function createProxyFunctions(source, target, bind, fnNames, latebind) {
	    if (latebind === void 0) { latebind = false; }
	    var bindFunction = function (fnName) { return source()[fnName].bind(bind()); };
	    var makeLateRebindFn = function (fnName) {
	        return function lateRebindFunction() {
	            target[fnName] = bindFunction(fnName);
	            return target[fnName].apply(null, arguments);
	        };
	    };
	    fnNames = fnNames || Object.keys(source());
	    return fnNames.reduce(function (acc, name) {
	        acc[name] = latebind ? makeLateRebindFn(name) : bindFunction(name);
	        return acc;
	    }, target);
	}
	exports.createProxyFunctions = createProxyFunctions;
	/**
	 * prototypal inheritance helper.
	 * Creates a new object which has `parent` object as its prototype, and then copies the properties from `extra` onto it
	 */
	exports.inherit = function (parent, extra) { return exports.extend(Object.create(parent), extra); };
	/** Given an array, returns true if the object is found in the array, (using indexOf) */
	exports.inArray = hof_1.curry(_inArray);
	function _inArray(array, obj) {
	    return array.indexOf(obj) !== -1;
	}
	exports._inArray = _inArray;
	/**
	 * Given an array, and an item, if the item is found in the array, it removes it (in-place).
	 * The same array is returned
	 */
	exports.removeFrom = hof_1.curry(_removeFrom);
	function _removeFrom(array, obj) {
	    var idx = array.indexOf(obj);
	    if (idx >= 0)
	        array.splice(idx, 1);
	    return array;
	}
	exports._removeFrom = _removeFrom;
	/** pushes a values to an array and returns the value */
	exports.pushTo = hof_1.curry(_pushTo);
	function _pushTo(arr, val) {
	    return arr.push(val), val;
	}
	exports._pushTo = _pushTo;
	/** Given an array of (deregistration) functions, calls all functions and removes each one from the source array */
	exports.deregAll = function (functions) {
	    return functions.slice().forEach(function (fn) {
	        typeof fn === 'function' && fn();
	        exports.removeFrom(functions, fn);
	    });
	};
	/**
	 * Applies a set of defaults to an options object.  The options object is filtered
	 * to only those properties of the objects in the defaultsList.
	 * Earlier objects in the defaultsList take precedence when applying defaults.
	 */
	function defaults(opts) {
	    var defaultsList = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        defaultsList[_i - 1] = arguments[_i];
	    }
	    var defaultVals = exports.extend.apply(void 0, __spreadArrays([{}], defaultsList.reverse()));
	    return exports.extend(defaultVals, pick(opts || {}, Object.keys(defaultVals)));
	}
	exports.defaults = defaults;
	/** Reduce function that merges each element of the list into a single object, using extend */
	exports.mergeR = function (memo, item) { return exports.extend(memo, item); };
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	    var path = [];
	    // tslint:disable-next-line:forin
	    for (var n in first.path) {
	        if (first.path[n] !== second.path[n])
	            break;
	        path.push(first.path[n]);
	    }
	    return path;
	}
	exports.ancestors = ancestors;
	/**
	 * Return a copy of the object only containing the whitelisted properties.
	 *
	 * #### Example:
	 * ```
	 * var foo = { a: 1, b: 2, c: 3 };
	 * var ab = pick(foo, ['a', 'b']); // { a: 1, b: 2 }
	 * ```
	 * @param obj the source object
	 * @param propNames an Array of strings, which are the whitelisted property names
	 */
	function pick(obj, propNames) {
	    var objCopy = {};
	    for (var _prop in obj) {
	        if (propNames.indexOf(_prop) !== -1) {
	            objCopy[_prop] = obj[_prop];
	        }
	    }
	    return objCopy;
	}
	exports.pick = pick;
	/**
	 * Return a copy of the object omitting the blacklisted properties.
	 *
	 * @example
	 * ```
	 *
	 * var foo = { a: 1, b: 2, c: 3 };
	 * var ab = omit(foo, ['a', 'b']); // { c: 3 }
	 * ```
	 * @param obj the source object
	 * @param propNames an Array of strings, which are the blacklisted property names
	 */
	function omit(obj, propNames) {
	    return Object.keys(obj)
	        .filter(hof_1.not(exports.inArray(propNames)))
	        .reduce(function (acc, key) { return ((acc[key] = obj[key]), acc); }, {});
	}
	exports.omit = omit;
	/**
	 * Maps an array, or object to a property (by name)
	 */
	function pluck(collection, propName) {
	    return map(collection, hof_1.prop(propName));
	}
	exports.pluck = pluck;
	/** Filters an Array or an Object's properties based on a predicate */
	function filter(collection, callback) {
	    var arr = predicates_1.isArray(collection), result = arr ? [] : {};
	    var accept = arr ? function (x) { return result.push(x); } : function (x, key) { return (result[key] = x); };
	    exports.forEach(collection, function (item, i) {
	        if (callback(item, i))
	            accept(item, i);
	    });
	    return result;
	}
	exports.filter = filter;
	/** Finds an object from an array, or a property of an object, that matches a predicate */
	function find(collection, callback) {
	    var result;
	    exports.forEach(collection, function (item, i) {
	        if (result)
	            return;
	        if (callback(item, i))
	            result = item;
	    });
	    return result;
	}
	exports.find = find;
	/** Given an object, returns a new object, where each property is transformed by the callback function */
	exports.mapObj = map;
	/** Maps an array or object properties using a callback function */
	function map(collection, callback, target) {
	    target = target || (predicates_1.isArray(collection) ? [] : {});
	    exports.forEach(collection, function (item, i) { return (target[i] = callback(item, i)); });
	    return target;
	}
	exports.map = map;
	/**
	 * Given an object, return its enumerable property values
	 *
	 * @example
	 * ```
	 *
	 * let foo = { a: 1, b: 2, c: 3 }
	 * let vals = values(foo); // [ 1, 2, 3 ]
	 * ```
	 */
	exports.values = function (obj) { return Object.keys(obj).map(function (key) { return obj[key]; }); };
	/**
	 * Reduce function that returns true if all of the values are truthy.
	 *
	 * @example
	 * ```
	 *
	 * let vals = [ 1, true, {}, "hello world"];
	 * vals.reduce(allTrueR, true); // true
	 *
	 * vals.push(0);
	 * vals.reduce(allTrueR, true); // false
	 * ```
	 */
	exports.allTrueR = function (memo, elem) { return memo && elem; };
	/**
	 * Reduce function that returns true if any of the values are truthy.
	 *
	 *  * @example
	 * ```
	 *
	 * let vals = [ 0, null, undefined ];
	 * vals.reduce(anyTrueR, true); // false
	 *
	 * vals.push("hello world");
	 * vals.reduce(anyTrueR, true); // true
	 * ```
	 */
	exports.anyTrueR = function (memo, elem) { return memo || elem; };
	/**
	 * Reduce function which un-nests a single level of arrays
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
	 * ```
	 */
	exports.unnestR = function (memo, elem) { return memo.concat(elem); };
	/**
	 * Reduce function which recursively un-nests all arrays
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", "double, "nested" ]
	 * ```
	 */
	exports.flattenR = function (memo, elem) {
	    return predicates_1.isArray(elem) ? memo.concat(elem.reduce(exports.flattenR, [])) : pushR(memo, elem);
	};
	/**
	 * Reduce function that pushes an object to an array, then returns the array.
	 * Mostly just for [[flattenR]] and [[uniqR]]
	 */
	function pushR(arr, obj) {
	    arr.push(obj);
	    return arr;
	}
	exports.pushR = pushR;
	/** Reduce function that filters out duplicates */
	exports.uniqR = function (acc, token) { return (exports.inArray(acc, token) ? acc : pushR(acc, token)); };
	/**
	 * Return a new array with a single level of arrays unnested.
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * unnest(input) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
	 * ```
	 */
	exports.unnest = function (arr) { return arr.reduce(exports.unnestR, []); };
	/**
	 * Return a completely flattened version of an array.
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * flatten(input) // [ "a", "b", "c", "d", "double, "nested" ]
	 * ```
	 */
	exports.flatten = function (arr) { return arr.reduce(exports.flattenR, []); };
	/**
	 * Given a .filter Predicate, builds a .filter Predicate which throws an error if any elements do not pass.
	 * @example
	 * ```
	 *
	 * let isNumber = (obj) => typeof(obj) === 'number';
	 * let allNumbers = [ 1, 2, 3, 4, 5 ];
	 * allNumbers.filter(assertPredicate(isNumber)); //OK
	 *
	 * let oneString = [ 1, 2, 3, 4, "5" ];
	 * oneString.filter(assertPredicate(isNumber, "Not all numbers")); // throws Error(""Not all numbers"");
	 * ```
	 */
	exports.assertPredicate = assertFn;
	/**
	 * Given a .map function, builds a .map function which throws an error if any mapped elements do not pass a truthyness test.
	 * @example
	 * ```
	 *
	 * var data = { foo: 1, bar: 2 };
	 *
	 * let keys = [ 'foo', 'bar' ]
	 * let values = keys.map(assertMap(key => data[key], "Key not found"));
	 * // values is [1, 2]
	 *
	 * let keys = [ 'foo', 'bar', 'baz' ]
	 * let values = keys.map(assertMap(key => data[key], "Key not found"));
	 * // throws Error("Key not found")
	 * ```
	 */
	exports.assertMap = assertFn;
	function assertFn(predicateOrMap, errMsg) {
	    if (errMsg === void 0) { errMsg = 'assert failure'; }
	    return function (obj) {
	        var result = predicateOrMap(obj);
	        if (!result) {
	            throw new Error(predicates_1.isFunction(errMsg) ? errMsg(obj) : errMsg);
	        }
	        return result;
	    };
	}
	exports.assertFn = assertFn;
	/**
	 * Like _.pairs: Given an object, returns an array of key/value pairs
	 *
	 * @example
	 * ```
	 *
	 * pairs({ foo: "FOO", bar: "BAR }) // [ [ "foo", "FOO" ], [ "bar": "BAR" ] ]
	 * ```
	 */
	exports.pairs = function (obj) { return Object.keys(obj).map(function (key) { return [key, obj[key]]; }); };
	/**
	 * Given two or more parallel arrays, returns an array of tuples where
	 * each tuple is composed of [ a[i], b[i], ... z[i] ]
	 *
	 * @example
	 * ```
	 *
	 * let foo = [ 0, 2, 4, 6 ];
	 * let bar = [ 1, 3, 5, 7 ];
	 * let baz = [ 10, 30, 50, 70 ];
	 * arrayTuples(foo, bar);       // [ [0, 1], [2, 3], [4, 5], [6, 7] ]
	 * arrayTuples(foo, bar, baz);  // [ [0, 1, 10], [2, 3, 30], [4, 5, 50], [6, 7, 70] ]
	 * ```
	 */
	function arrayTuples() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    if (args.length === 0)
	        return [];
	    var maxArrayLen = args.reduce(function (min, arr) { return Math.min(arr.length, min); }, 9007199254740991); // aka 2^53 − 1 aka Number.MAX_SAFE_INTEGER
	    var result = [];
	    var _loop_1 = function (i) {
	        // This is a hot function
	        // Unroll when there are 1-4 arguments
	        switch (args.length) {
	            case 1:
	                result.push([args[0][i]]);
	                break;
	            case 2:
	                result.push([args[0][i], args[1][i]]);
	                break;
	            case 3:
	                result.push([args[0][i], args[1][i], args[2][i]]);
	                break;
	            case 4:
	                result.push([args[0][i], args[1][i], args[2][i], args[3][i]]);
	                break;
	            default:
	                result.push(args.map(function (array) { return array[i]; }));
	                break;
	        }
	    };
	    for (var i = 0; i < maxArrayLen; i++) {
	        _loop_1(i);
	    }
	    return result;
	}
	exports.arrayTuples = arrayTuples;
	/**
	 * Reduce function which builds an object from an array of [key, value] pairs.
	 *
	 * Each iteration sets the key/val pair on the memo object, then returns the memo for the next iteration.
	 *
	 * Each keyValueTuple should be an array with values [ key: string, value: any ]
	 *
	 * @example
	 * ```
	 *
	 * var pairs = [ ["fookey", "fooval"], ["barkey", "barval"] ]
	 *
	 * var pairsToObj = pairs.reduce((memo, pair) => applyPairs(memo, pair), {})
	 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
	 *
	 * // Or, more simply:
	 * var pairsToObj = pairs.reduce(applyPairs, {})
	 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
	 * ```
	 */
	function applyPairs(memo, keyValTuple) {
	    var key, value;
	    if (predicates_1.isArray(keyValTuple))
	        key = keyValTuple[0], value = keyValTuple[1];
	    if (!predicates_1.isString(key))
	        throw new Error('invalid parameters to applyPairs');
	    memo[key] = value;
	    return memo;
	}
	exports.applyPairs = applyPairs;
	/** Get the last element of an array */
	function tail(arr) {
	    return (arr.length && arr[arr.length - 1]) || undefined;
	}
	exports.tail = tail;
	/**
	 * shallow copy from src to dest
	 */
	function copy(src, dest) {
	    if (dest)
	        Object.keys(dest).forEach(function (key) { return delete dest[key]; });
	    if (!dest)
	        dest = {};
	    return exports.extend(dest, src);
	}
	exports.copy = copy;
	/** Naive forEach implementation works with Objects or Arrays */
	function _forEach(obj, cb, _this) {
	    if (predicates_1.isArray(obj))
	        return obj.forEach(cb, _this);
	    Object.keys(obj).forEach(function (key) { return cb(obj[key], key); });
	}
	function _extend(toObj) {
	    for (var i = 1; i < arguments.length; i++) {
	        var obj = arguments[i];
	        if (!obj)
	            continue;
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; j++) {
	            toObj[keys[j]] = obj[keys[j]];
	        }
	    }
	    return toObj;
	}
	exports._extend = _extend;
	function _equals(o1, o2) {
	    if (o1 === o2)
	        return true;
	    if (o1 === null || o2 === null)
	        return false;
	    if (o1 !== o1 && o2 !== o2)
	        return true; // NaN === NaN
	    var t1 = typeof o1, t2 = typeof o2;
	    if (t1 !== t2 || t1 !== 'object')
	        return false;
	    var tup = [o1, o2];
	    if (hof_1.all(predicates_1.isArray)(tup))
	        return _arraysEq(o1, o2);
	    if (hof_1.all(predicates_1.isDate)(tup))
	        return o1.getTime() === o2.getTime();
	    if (hof_1.all(predicates_1.isRegExp)(tup))
	        return o1.toString() === o2.toString();
	    if (hof_1.all(predicates_1.isFunction)(tup))
	        return true; // meh
	    var predicates = [predicates_1.isFunction, predicates_1.isArray, predicates_1.isDate, predicates_1.isRegExp];
	    if (predicates.map(hof_1.any).reduce(function (b, fn) { return b || !!fn(tup); }, false))
	        return false;
	    var keys = {};
	    // tslint:disable-next-line:forin
	    for (var key in o1) {
	        if (!_equals(o1[key], o2[key]))
	            return false;
	        keys[key] = true;
	    }
	    for (var key in o2) {
	        if (!keys[key])
	            return false;
	    }
	    return true;
	}
	function _arraysEq(a1, a2) {
	    if (a1.length !== a2.length)
	        return false;
	    return arrayTuples(a1, a2).reduce(function (b, t) { return b && _equals(t[0], t[1]); }, true);
	}
	// issue #2676
	exports.silenceUncaughtInPromise = function (promise) { return promise.catch(function (e) { return 0; }) && promise; };
	exports.silentRejection = function (error) { return exports.silenceUncaughtInPromise(coreservices_1.services.$q.reject(error)); };
	//# sourceMappingURL=common.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 5:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isPromise = exports.isInjectable = exports.isRegExp = exports.isDate = exports.isArray = exports.isObject = exports.isString = exports.isNumber = exports.isFunction = exports.isNullOrUndefined = exports.isNull = exports.isDefined = exports.isUndefined = void 0;
	/**
	 * Predicates
	 *
	 * These predicates return true/false based on the input.
	 * Although these functions are exported, they are subject to change without notice.
	 *
	 * @packageDocumentation
	 */
	var hof_1 = __webpack_require__(6);
	var toStr = Object.prototype.toString;
	var tis = function (t) { return function (x) { return typeof x === t; }; };
	exports.isUndefined = tis('undefined');
	exports.isDefined = hof_1.not(exports.isUndefined);
	exports.isNull = function (o) { return o === null; };
	exports.isNullOrUndefined = hof_1.or(exports.isNull, exports.isUndefined);
	exports.isFunction = tis('function');
	exports.isNumber = tis('number');
	exports.isString = tis('string');
	exports.isObject = function (x) { return x !== null && typeof x === 'object'; };
	exports.isArray = Array.isArray;
	exports.isDate = (function (x) { return toStr.call(x) === '[object Date]'; });
	exports.isRegExp = (function (x) { return toStr.call(x) === '[object RegExp]'; });
	/**
	 * Predicate which checks if a value is injectable
	 *
	 * A value is "injectable" if it is a function, or if it is an ng1 array-notation-style array
	 * where all the elements in the array are Strings, except the last one, which is a Function
	 */
	function isInjectable(val) {
	    if (exports.isArray(val) && val.length) {
	        var head = val.slice(0, -1), tail = val.slice(-1);
	        return !(head.filter(hof_1.not(exports.isString)).length || tail.filter(hof_1.not(exports.isFunction)).length);
	    }
	    return exports.isFunction(val);
	}
	exports.isInjectable = isInjectable;
	/**
	 * Predicate which checks if a value looks like a Promise
	 *
	 * It is probably a Promise if it's an object, and it has a `then` property which is a Function
	 */
	exports.isPromise = hof_1.and(exports.isObject, hof_1.pipe(hof_1.prop('then'), exports.isFunction));
	//# sourceMappingURL=predicates.js.map

/***/ },

/***/ 6:
/***/ function(module, exports) {

	"use strict";
	/**
	 * Higher order functions
	 *
	 * These utility functions are exported, but are subject to change without notice.
	 *
	 * @packageDocumentation
	 */
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pattern = exports.invoke = exports.val = exports.eq = exports.is = exports.any = exports.all = exports.or = exports.and = exports.not = exports.parse = exports.propEq = exports.prop = exports.pipe = exports.compose = exports.curry = void 0;
	/**
	 * Returns a new function for [Partial Application](https://en.wikipedia.org/wiki/Partial_application) of the original function.
	 *
	 * Given a function with N parameters, returns a new function that supports partial application.
	 * The new function accepts anywhere from 1 to N parameters.  When that function is called with M parameters,
	 * where M is less than N, it returns a new function that accepts the remaining parameters.  It continues to
	 * accept more parameters until all N parameters have been supplied.
	 *
	 *
	 * This contrived example uses a partially applied function as an predicate, which returns true
	 * if an object is found in both arrays.
	 * @example
	 * ```
	 * // returns true if an object is in both of the two arrays
	 * function inBoth(array1, array2, object) {
	 *   return array1.indexOf(object) !== -1 &&
	 *          array2.indexOf(object) !== 1;
	 * }
	 * let obj1, obj2, obj3, obj4, obj5, obj6, obj7
	 * let foos = [obj1, obj3]
	 * let bars = [obj3, obj4, obj5]
	 *
	 * // A curried "copy" of inBoth
	 * let curriedInBoth = curry(inBoth);
	 * // Partially apply both the array1 and array2
	 * let inFoosAndBars = curriedInBoth(foos, bars);
	 *
	 * // Supply the final argument; since all arguments are
	 * // supplied, the original inBoth function is then called.
	 * let obj1InBoth = inFoosAndBars(obj1); // false
	 *
	 * // Use the inFoosAndBars as a predicate.
	 * // Filter, on each iteration, supplies the final argument
	 * let allObjs = [ obj1, obj2, obj3, obj4, obj5, obj6, obj7 ];
	 * let foundInBoth = allObjs.filter(inFoosAndBars); // [ obj3 ]
	 *
	 * ```
	 *
	 * @param fn
	 * @returns {*|function(): (*|any)}
	 */
	function curry(fn) {
	    return function curried() {
	        if (arguments.length >= fn.length) {
	            return fn.apply(this, arguments);
	        }
	        var args = Array.prototype.slice.call(arguments);
	        return curried.bind.apply(curried, __spreadArrays([this], args));
	    };
	}
	exports.curry = curry;
	/**
	 * Given a varargs list of functions, returns a function that composes the argument functions, right-to-left
	 * given: f(x), g(x), h(x)
	 * let composed = compose(f,g,h)
	 * then, composed is: f(g(h(x)))
	 */
	function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function () {
	        var i = start, result = args[start].apply(this, arguments);
	        while (i--)
	            result = args[i].call(this, result);
	        return result;
	    };
	}
	exports.compose = compose;
	/**
	 * Given a varargs list of functions, returns a function that is composes the argument functions, left-to-right
	 * given: f(x), g(x), h(x)
	 * let piped = pipe(f,g,h);
	 * then, piped is: h(g(f(x)))
	 */
	function pipe() {
	    var funcs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        funcs[_i] = arguments[_i];
	    }
	    return compose.apply(null, [].slice.call(arguments).reverse());
	}
	exports.pipe = pipe;
	/**
	 * Given a property name, returns a function that returns that property from an object
	 * let obj = { foo: 1, name: "blarg" };
	 * let getName = prop("name");
	 * getName(obj) === "blarg"
	 */
	exports.prop = function (name) { return function (obj) { return obj && obj[name]; }; };
	/**
	 * Given a property name and a value, returns a function that returns a boolean based on whether
	 * the passed object has a property that matches the value
	 * let obj = { foo: 1, name: "blarg" };
	 * let getName = propEq("name", "blarg");
	 * getName(obj) === true
	 */
	exports.propEq = curry(function (name, _val, obj) { return obj && obj[name] === _val; });
	/**
	 * Given a dotted property name, returns a function that returns a nested property from an object, or undefined
	 * let obj = { id: 1, nestedObj: { foo: 1, name: "blarg" }, };
	 * let getName = prop("nestedObj.name");
	 * getName(obj) === "blarg"
	 * let propNotFound = prop("this.property.doesnt.exist");
	 * propNotFound(obj) === undefined
	 */
	exports.parse = function (name) { return pipe.apply(null, name.split('.').map(exports.prop)); };
	/**
	 * Given a function that returns a truthy or falsey value, returns a
	 * function that returns the opposite (falsey or truthy) value given the same inputs
	 */
	exports.not = function (fn) { return function () {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return !fn.apply(null, args);
	}; };
	/**
	 * Given two functions that return truthy or falsey values, returns a function that returns truthy
	 * if both functions return truthy for the given arguments
	 */
	function and(fn1, fn2) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return fn1.apply(null, args) && fn2.apply(null, args);
	    };
	}
	exports.and = and;
	/**
	 * Given two functions that return truthy or falsey values, returns a function that returns truthy
	 * if at least one of the functions returns truthy for the given arguments
	 */
	function or(fn1, fn2) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return fn1.apply(null, args) || fn2.apply(null, args);
	    };
	}
	exports.or = or;
	/**
	 * Check if all the elements of an array match a predicate function
	 *
	 * @param fn1 a predicate function `fn1`
	 * @returns a function which takes an array and returns true if `fn1` is true for all elements of the array
	 */
	exports.all = function (fn1) { return function (arr) { return arr.reduce(function (b, x) { return b && !!fn1(x); }, true); }; };
	// tslint:disable-next-line:variable-name
	exports.any = function (fn1) { return function (arr) { return arr.reduce(function (b, x) { return b || !!fn1(x); }, false); }; };
	/** Given a class, returns a Predicate function that returns true if the object is of that class */
	exports.is = function (ctor) { return function (obj) {
	    return (obj != null && obj.constructor === ctor) || obj instanceof ctor;
	}; };
	/** Given a value, returns a Predicate function that returns true if another value is === equal to the original value */
	exports.eq = function (value) { return function (other) { return value === other; }; };
	/** Given a value, returns a function which returns the value */
	exports.val = function (v) { return function () { return v; }; };
	function invoke(fnName, args) {
	    return function (obj) { return obj[fnName].apply(obj, args); };
	}
	exports.invoke = invoke;
	/**
	 * Sorta like Pattern Matching (a functional programming conditional construct)
	 *
	 * See http://c2.com/cgi/wiki?PatternMatching
	 *
	 * This is a conditional construct which allows a series of predicates and output functions
	 * to be checked and then applied.  Each predicate receives the input.  If the predicate
	 * returns truthy, then its matching output function (mapping function) is provided with
	 * the input and, then the result is returned.
	 *
	 * Each combination (2-tuple) of predicate + output function should be placed in an array
	 * of size 2: [ predicate, mapFn ]
	 *
	 * These 2-tuples should be put in an outer array.
	 *
	 * @example
	 * ```
	 *
	 * // Here's a 2-tuple where the first element is the isString predicate
	 * // and the second element is a function that returns a description of the input
	 * let firstTuple = [ angular.isString, (input) => `Heres your string ${input}` ];
	 *
	 * // Second tuple: predicate "isNumber", mapfn returns a description
	 * let secondTuple = [ angular.isNumber, (input) => `(${input}) That's a number!` ];
	 *
	 * let third = [ (input) => input === null,  (input) => `Oh, null...` ];
	 *
	 * let fourth = [ (input) => input === undefined,  (input) => `notdefined` ];
	 *
	 * let descriptionOf = pattern([ firstTuple, secondTuple, third, fourth ]);
	 *
	 * console.log(descriptionOf(undefined)); // 'notdefined'
	 * console.log(descriptionOf(55)); // '(55) That's a number!'
	 * console.log(descriptionOf("foo")); // 'Here's your string foo'
	 * ```
	 *
	 * @param struct A 2D array.  Each element of the array should be an array, a 2-tuple,
	 * with a Predicate and a mapping/output function
	 * @returns {function(any): *}
	 */
	function pattern(struct) {
	    return function (x) {
	        for (var i = 0; i < struct.length; i++) {
	            if (struct[i][0](x))
	                return struct[i][1](x);
	        }
	    };
	}
	exports.pattern = pattern;
	//# sourceMappingURL=hof.js.map

/***/ },

/***/ 7:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(4), exports);
	__exportStar(__webpack_require__(8), exports);
	__exportStar(__webpack_require__(28), exports);
	__exportStar(__webpack_require__(6), exports);
	__exportStar(__webpack_require__(5), exports);
	__exportStar(__webpack_require__(29), exports);
	__exportStar(__webpack_require__(10), exports);
	__exportStar(__webpack_require__(12), exports);
	//# sourceMappingURL=index.js.map

/***/ },

/***/ 8:
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.services = exports.makeStub = void 0;
	var noImpl = function (fnname) { return function () {
	    throw new Error("No implementation for " + fnname + ". The framework specific code did not implement this method.");
	}; };
	exports.makeStub = function (service, methods) {
	    return methods.reduce(function (acc, key) { return ((acc[key] = noImpl(service + "." + key + "()")), acc); }, {});
	};
	var services = {
	    $q: undefined,
	    $injector: undefined,
	};
	exports.services = services;
	//# sourceMappingURL=coreservices.js.map

/***/ },

/***/ 10:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Functions that manipulate strings
	 *
	 * Although these functions are exported, they are subject to change without notice.
	 *
	 * @packageDocumentation
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.joinNeighborsR = exports.splitOnDelim = exports.trimHashVal = exports.splitEqual = exports.splitQuery = exports.splitHash = exports.stripLastPathElement = exports.hostRegex = exports.beforeAfterSubstr = exports.stringify = exports.fnToString = exports.functionToString = exports.kebobString = exports.padString = exports.maxLength = void 0;
	var predicates_1 = __webpack_require__(5);
	var rejectFactory_1 = __webpack_require__(14);
	var common_1 = __webpack_require__(4);
	var hof_1 = __webpack_require__(6);
	/**
	 * Returns a string shortened to a maximum length
	 *
	 * If the string is already less than the `max` length, return the string.
	 * Else return the string, shortened to `max - 3` and append three dots ("...").
	 *
	 * @param max the maximum length of the string to return
	 * @param str the input string
	 */
	function maxLength(max, str) {
	    if (str.length <= max)
	        return str;
	    return str.substr(0, max - 3) + '...';
	}
	exports.maxLength = maxLength;
	/**
	 * Returns a string, with spaces added to the end, up to a desired str length
	 *
	 * If the string is already longer than the desired length, return the string.
	 * Else returns the string, with extra spaces on the end, such that it reaches `length` characters.
	 *
	 * @param length the desired length of the string to return
	 * @param str the input string
	 */
	function padString(length, str) {
	    while (str.length < length)
	        str += ' ';
	    return str;
	}
	exports.padString = padString;
	function kebobString(camelCase) {
	    return camelCase
	        .replace(/^([A-Z])/, function ($1) { return $1.toLowerCase(); }) // replace first char
	        .replace(/([A-Z])/g, function ($1) { return '-' + $1.toLowerCase(); }); // replace rest
	}
	exports.kebobString = kebobString;
	function functionToString(fn) {
	    var fnStr = fnToString(fn);
	    var namedFunctionMatch = fnStr.match(/^(function [^ ]+\([^)]*\))/);
	    var toStr = namedFunctionMatch ? namedFunctionMatch[1] : fnStr;
	    var fnName = fn['name'] || '';
	    if (fnName && toStr.match(/function \(/)) {
	        return 'function ' + fnName + toStr.substr(9);
	    }
	    return toStr;
	}
	exports.functionToString = functionToString;
	function fnToString(fn) {
	    var _fn = predicates_1.isArray(fn) ? fn.slice(-1)[0] : fn;
	    return (_fn && _fn.toString()) || 'undefined';
	}
	exports.fnToString = fnToString;
	function stringify(o) {
	    var seen = [];
	    var isRejection = rejectFactory_1.Rejection.isRejectionPromise;
	    var hasToString = function (obj) {
	        return predicates_1.isObject(obj) && !predicates_1.isArray(obj) && obj.constructor !== Object && predicates_1.isFunction(obj.toString);
	    };
	    var stringifyPattern = hof_1.pattern([
	        [predicates_1.isUndefined, hof_1.val('undefined')],
	        [predicates_1.isNull, hof_1.val('null')],
	        [predicates_1.isPromise, hof_1.val('[Promise]')],
	        [isRejection, function (x) { return x._transitionRejection.toString(); }],
	        [hasToString, function (x) { return x.toString(); }],
	        [predicates_1.isInjectable, functionToString],
	        [hof_1.val(true), common_1.identity],
	    ]);
	    function format(value) {
	        if (predicates_1.isObject(value)) {
	            if (seen.indexOf(value) !== -1)
	                return '[circular ref]';
	            seen.push(value);
	        }
	        return stringifyPattern(value);
	    }
	    if (predicates_1.isUndefined(o)) {
	        // Workaround for IE & Edge Spec incompatibility where replacer function would not be called when JSON.stringify
	        // is given `undefined` as value. To work around that, we simply detect `undefined` and bail out early by
	        // manually stringifying it.
	        return format(o);
	    }
	    return JSON.stringify(o, function (key, value) { return format(value); }).replace(/\\"/g, '"');
	}
	exports.stringify = stringify;
	/** Returns a function that splits a string on a character or substring */
	exports.beforeAfterSubstr = function (char) {
	    return function (str) {
	        if (!str)
	            return ['', ''];
	        var idx = str.indexOf(char);
	        if (idx === -1)
	            return [str, ''];
	        return [str.substr(0, idx), str.substr(idx + 1)];
	    };
	};
	exports.hostRegex = new RegExp('^(?:[a-z]+:)?//[^/]+/');
	exports.stripLastPathElement = function (str) { return str.replace(/\/[^/]*$/, ''); };
	exports.splitHash = exports.beforeAfterSubstr('#');
	exports.splitQuery = exports.beforeAfterSubstr('?');
	exports.splitEqual = exports.beforeAfterSubstr('=');
	exports.trimHashVal = function (str) { return (str ? str.replace(/^#/, '') : ''); };
	/**
	 * Splits on a delimiter, but returns the delimiters in the array
	 *
	 * #### Example:
	 * ```js
	 * var splitOnSlashes = splitOnDelim('/');
	 * splitOnSlashes("/foo"); // ["/", "foo"]
	 * splitOnSlashes("/foo/"); // ["/", "foo", "/"]
	 * ```
	 */
	function splitOnDelim(delim) {
	    var re = new RegExp('(' + delim + ')', 'g');
	    return function (str) { return str.split(re).filter(common_1.identity); };
	}
	exports.splitOnDelim = splitOnDelim;
	/**
	 * Reduce fn that joins neighboring strings
	 *
	 * Given an array of strings, returns a new array
	 * where all neighboring strings have been joined.
	 *
	 * #### Example:
	 * ```js
	 * let arr = ["foo", "bar", 1, "baz", "", "qux" ];
	 * arr.reduce(joinNeighborsR, []) // ["foobar", 1, "bazqux" ]
	 * ```
	 */
	function joinNeighborsR(acc, x) {
	    if (predicates_1.isString(common_1.tail(acc)) && predicates_1.isString(x))
	        return acc.slice(0, -1).concat(common_1.tail(acc) + x);
	    return common_1.pushR(acc, x);
	}
	exports.joinNeighborsR = joinNeighborsR;
	//# sourceMappingURL=strings.js.map

/***/ },

/***/ 12:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.trace = exports.Trace = exports.Category = void 0;
	/**
	 * # Transition tracing (debug)
	 *
	 * Enable transition tracing to print transition information to the console,
	 * in order to help debug your application.
	 * Tracing logs detailed information about each Transition to your console.
	 *
	 * To enable tracing, import the [[Trace]] singleton and enable one or more categories.
	 *
	 * ### ES6
	 * ```js
	 * import {trace} from "@uirouter/core";
	 * trace.enable(1, 5); // TRANSITION and VIEWCONFIG
	 * ```
	 *
	 * ### CJS
	 * ```js
	 * let trace = require("@uirouter/core").trace;
	 * trace.enable("TRANSITION", "VIEWCONFIG");
	 * ```
	 *
	 * ### Globals
	 * ```js
	 * let trace = window["@uirouter/core"].trace;
	 * trace.enable(); // Trace everything (very verbose)
	 * ```
	 *
	 * ### Angular 1:
	 * ```js
	 * app.run($trace => $trace.enable());
	 * ```
	 *
	 * @packageDocumentation
	 */
	var hof_1 = __webpack_require__(6);
	var predicates_1 = __webpack_require__(5);
	var strings_1 = __webpack_require__(10);
	var safeConsole_1 = __webpack_require__(47);
	function uiViewString(uiview) {
	    if (!uiview)
	        return 'ui-view (defunct)';
	    var state = uiview.creationContext ? uiview.creationContext.name || '(root)' : '(none)';
	    return "[ui-view#" + uiview.id + " " + uiview.$type + ":" + uiview.fqn + " (" + uiview.name + "@" + state + ")]";
	}
	var viewConfigString = function (viewConfig) {
	    var view = viewConfig.viewDecl;
	    var state = view.$context.name || '(root)';
	    return "[View#" + viewConfig.$id + " from '" + state + "' state]: target ui-view: '" + view.$uiViewName + "@" + view.$uiViewContextAnchor + "'";
	};
	function normalizedCat(input) {
	    return predicates_1.isNumber(input) ? Category[input] : Category[Category[input]];
	}
	/**
	 * Trace categories Enum
	 *
	 * Enable or disable a category using [[Trace.enable]] or [[Trace.disable]]
	 *
	 * `trace.enable(Category.TRANSITION)`
	 *
	 * These can also be provided using a matching string, or position ordinal
	 *
	 * `trace.enable("TRANSITION")`
	 *
	 * `trace.enable(1)`
	 */
	var Category;
	(function (Category) {
	    Category[Category["RESOLVE"] = 0] = "RESOLVE";
	    Category[Category["TRANSITION"] = 1] = "TRANSITION";
	    Category[Category["HOOK"] = 2] = "HOOK";
	    Category[Category["UIVIEW"] = 3] = "UIVIEW";
	    Category[Category["VIEWCONFIG"] = 4] = "VIEWCONFIG";
	})(Category || (Category = {}));
	exports.Category = Category;
	var _tid = hof_1.parse('$id');
	var _rid = hof_1.parse('router.$id');
	var transLbl = function (trans) { return "Transition #" + _tid(trans) + "-" + _rid(trans); };
	/**
	 * Prints UI-Router Transition trace information to the console.
	 */
	var Trace = /** @class */ (function () {
	    /** @internal */
	    function Trace() {
	        /** @internal */
	        this._enabled = {};
	        this.approximateDigests = 0;
	    }
	    /** @internal */
	    Trace.prototype._set = function (enabled, categories) {
	        var _this = this;
	        if (!categories.length) {
	            categories = Object.keys(Category)
	                .map(function (k) { return parseInt(k, 10); })
	                .filter(function (k) { return !isNaN(k); })
	                .map(function (key) { return Category[key]; });
	        }
	        categories.map(normalizedCat).forEach(function (category) { return (_this._enabled[category] = enabled); });
	    };
	    Trace.prototype.enable = function () {
	        var categories = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            categories[_i] = arguments[_i];
	        }
	        this._set(true, categories);
	    };
	    Trace.prototype.disable = function () {
	        var categories = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            categories[_i] = arguments[_i];
	        }
	        this._set(false, categories);
	    };
	    /**
	     * Retrieves the enabled stateus of a [[Category]]
	     *
	     * ```js
	     * trace.enabled("VIEWCONFIG"); // true or false
	     * ```
	     *
	     * @returns boolean true if the category is enabled
	     */
	    Trace.prototype.enabled = function (category) {
	        return !!this._enabled[normalizedCat(category)];
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceTransitionStart = function (trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": Started  -> " + strings_1.stringify(trans));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceTransitionIgnored = function (trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": Ignored  <> " + strings_1.stringify(trans));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceHookInvocation = function (step, trans, options) {
	        if (!this.enabled(Category.HOOK))
	            return;
	        var event = hof_1.parse('traceData.hookType')(options) || 'internal', context = hof_1.parse('traceData.context.state.name')(options) || hof_1.parse('traceData.context')(options) || 'unknown', name = strings_1.functionToString(step.registeredHook.callback);
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":   Hook -> " + event + " context: " + context + ", " + strings_1.maxLength(200, name));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceHookResult = function (hookResult, trans, transitionOptions) {
	        if (!this.enabled(Category.HOOK))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":   <- Hook returned: " + strings_1.maxLength(200, strings_1.stringify(hookResult)));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceResolvePath = function (path, when, trans) {
	        if (!this.enabled(Category.RESOLVE))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":         Resolving " + path + " (" + when + ")");
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceResolvableResolved = function (resolvable, trans) {
	        if (!this.enabled(Category.RESOLVE))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":               <- Resolved  " + resolvable + " to: " + strings_1.maxLength(200, strings_1.stringify(resolvable.data)));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceError = function (reason, trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": <- Rejected " + strings_1.stringify(trans) + ", reason: " + reason);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceSuccess = function (finalState, trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": <- Success  " + strings_1.stringify(trans) + ", final state: " + finalState.name);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceUIViewEvent = function (event, viewData, extra) {
	        if (extra === void 0) { extra = ''; }
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        safeConsole_1.safeConsole.log("ui-view: " + strings_1.padString(30, event) + " " + uiViewString(viewData) + extra);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceUIViewConfigUpdated = function (viewData, context) {
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        this.traceUIViewEvent('Updating', viewData, " with ViewConfig from context='" + context + "'");
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceUIViewFill = function (viewData, html) {
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        this.traceUIViewEvent('Fill', viewData, " with: " + strings_1.maxLength(200, html));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceViewSync = function (pairs) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        var uivheader = 'uiview component fqn';
	        var cfgheader = 'view config state (view name)';
	        var mapping = pairs
	            .map(function (_a) {
	            var _b;
	            var uiView = _a.uiView, viewConfig = _a.viewConfig;
	            var uiv = uiView && uiView.fqn;
	            var cfg = viewConfig && viewConfig.viewDecl.$context.name + ": (" + viewConfig.viewDecl.$name + ")";
	            return _b = {}, _b[uivheader] = uiv, _b[cfgheader] = cfg, _b;
	        })
	            .sort(function (a, b) { return (a[uivheader] || '').localeCompare(b[uivheader] || ''); });
	        safeConsole_1.safeConsole.table(mapping);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceViewServiceEvent = function (event, viewConfig) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        safeConsole_1.safeConsole.log("VIEWCONFIG: " + event + " " + viewConfigString(viewConfig));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceViewServiceUIViewEvent = function (event, viewData) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        safeConsole_1.safeConsole.log("VIEWCONFIG: " + event + " " + uiViewString(viewData));
	    };
	    return Trace;
	}());
	exports.Trace = Trace;
	/**
	 * The [[Trace]] singleton
	 *
	 * #### Example:
	 * ```js
	 * import {trace} from "@uirouter/core";
	 * trace.enable(1, 5);
	 * ```
	 */
	var trace = new Trace();
	exports.trace = trace;
	//# sourceMappingURL=trace.js.map

/***/ },

/***/ 13:
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionHookScope = exports.TransitionHookPhase = void 0;
	var TransitionHookPhase;
	(function (TransitionHookPhase) {
	    TransitionHookPhase[TransitionHookPhase["CREATE"] = 0] = "CREATE";
	    TransitionHookPhase[TransitionHookPhase["BEFORE"] = 1] = "BEFORE";
	    TransitionHookPhase[TransitionHookPhase["RUN"] = 2] = "RUN";
	    TransitionHookPhase[TransitionHookPhase["SUCCESS"] = 3] = "SUCCESS";
	    TransitionHookPhase[TransitionHookPhase["ERROR"] = 4] = "ERROR";
	})(TransitionHookPhase || (TransitionHookPhase = {}));
	exports.TransitionHookPhase = TransitionHookPhase;
	var TransitionHookScope;
	(function (TransitionHookScope) {
	    TransitionHookScope[TransitionHookScope["TRANSITION"] = 0] = "TRANSITION";
	    TransitionHookScope[TransitionHookScope["STATE"] = 1] = "STATE";
	})(TransitionHookScope || (TransitionHookScope = {}));
	exports.TransitionHookScope = TransitionHookScope;
	//# sourceMappingURL=interface.js.map

/***/ },

/***/ 14:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Rejection = exports.RejectType = void 0;
	var common_1 = __webpack_require__(4);
	var strings_1 = __webpack_require__(10);
	var hof_1 = __webpack_require__(6);
	/** An enum for Transition Rejection reasons */
	var RejectType;
	(function (RejectType) {
	    /**
	     * A new transition superseded this one.
	     *
	     * While this transition was running, a new transition started.
	     * This transition is cancelled because it was superseded by new transition.
	     */
	    RejectType[RejectType["SUPERSEDED"] = 2] = "SUPERSEDED";
	    /**
	     * The transition was aborted
	     *
	     * The transition was aborted by a hook which returned `false`
	     */
	    RejectType[RejectType["ABORTED"] = 3] = "ABORTED";
	    /**
	     * The transition was invalid
	     *
	     * The transition was never started because it was invalid
	     */
	    RejectType[RejectType["INVALID"] = 4] = "INVALID";
	    /**
	     * The transition was ignored
	     *
	     * The transition was ignored because it would have no effect.
	     *
	     * Either:
	     *
	     * - The transition is targeting the current state and parameter values
	     * - The transition is targeting the same state and parameter values as the currently running transition.
	     */
	    RejectType[RejectType["IGNORED"] = 5] = "IGNORED";
	    /**
	     * The transition errored.
	     *
	     * This generally means a hook threw an error or returned a rejected promise
	     */
	    RejectType[RejectType["ERROR"] = 6] = "ERROR";
	})(RejectType || (RejectType = {}));
	exports.RejectType = RejectType;
	/** @internal */
	var id = 0;
	var Rejection = /** @class */ (function () {
	    function Rejection(type, message, detail) {
	        /** @internal */
	        this.$id = id++;
	        this.type = type;
	        this.message = message;
	        this.detail = detail;
	    }
	    /** Returns true if the obj is a rejected promise created from the `asPromise` factory */
	    Rejection.isRejectionPromise = function (obj) {
	        return obj && typeof obj.then === 'function' && hof_1.is(Rejection)(obj._transitionRejection);
	    };
	    /** Returns a Rejection due to transition superseded */
	    Rejection.superseded = function (detail, options) {
	        var message = 'The transition has been superseded by a different transition';
	        var rejection = new Rejection(RejectType.SUPERSEDED, message, detail);
	        if (options && options.redirected) {
	            rejection.redirected = true;
	        }
	        return rejection;
	    };
	    /** Returns a Rejection due to redirected transition */
	    Rejection.redirected = function (detail) {
	        return Rejection.superseded(detail, { redirected: true });
	    };
	    /** Returns a Rejection due to invalid transition */
	    Rejection.invalid = function (detail) {
	        var message = 'This transition is invalid';
	        return new Rejection(RejectType.INVALID, message, detail);
	    };
	    /** Returns a Rejection due to ignored transition */
	    Rejection.ignored = function (detail) {
	        var message = 'The transition was ignored';
	        return new Rejection(RejectType.IGNORED, message, detail);
	    };
	    /** Returns a Rejection due to aborted transition */
	    Rejection.aborted = function (detail) {
	        var message = 'The transition has been aborted';
	        return new Rejection(RejectType.ABORTED, message, detail);
	    };
	    /** Returns a Rejection due to aborted transition */
	    Rejection.errored = function (detail) {
	        var message = 'The transition errored';
	        return new Rejection(RejectType.ERROR, message, detail);
	    };
	    /**
	     * Returns a Rejection
	     *
	     * Normalizes a value as a Rejection.
	     * If the value is already a Rejection, returns it.
	     * Otherwise, wraps and returns the value as a Rejection (Rejection type: ERROR).
	     *
	     * @returns `detail` if it is already a `Rejection`, else returns an ERROR Rejection.
	     */
	    Rejection.normalize = function (detail) {
	        return hof_1.is(Rejection)(detail) ? detail : Rejection.errored(detail);
	    };
	    Rejection.prototype.toString = function () {
	        var detailString = function (d) { return (d && d.toString !== Object.prototype.toString ? d.toString() : strings_1.stringify(d)); };
	        var detail = detailString(this.detail);
	        var _a = this, $id = _a.$id, type = _a.type, message = _a.message;
	        return "Transition Rejection($id: " + $id + " type: " + type + ", message: " + message + ", detail: " + detail + ")";
	    };
	    Rejection.prototype.toPromise = function () {
	        return common_1.extend(common_1.silentRejection(this), { _transitionRejection: this });
	    };
	    return Rejection;
	}());
	exports.Rejection = Rejection;
	//# sourceMappingURL=rejectFactory.js.map

/***/ },

/***/ 15:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Param = exports.DefType = void 0;
	var common_1 = __webpack_require__(4);
	var hof_1 = __webpack_require__(6);
	var predicates_1 = __webpack_require__(5);
	var coreservices_1 = __webpack_require__(8);
	var paramType_1 = __webpack_require__(31);
	var hasOwn = Object.prototype.hasOwnProperty;
	var isShorthand = function (cfg) {
	    return ['value', 'type', 'squash', 'array', 'dynamic'].filter(hasOwn.bind(cfg || {})).length === 0;
	};
	var DefType;
	(function (DefType) {
	    DefType[DefType["PATH"] = 0] = "PATH";
	    DefType[DefType["SEARCH"] = 1] = "SEARCH";
	    DefType[DefType["CONFIG"] = 2] = "CONFIG";
	})(DefType || (DefType = {}));
	exports.DefType = DefType;
	function getParamDeclaration(paramName, location, state) {
	    var noReloadOnSearch = (state.reloadOnSearch === false && location === DefType.SEARCH) || undefined;
	    var dynamic = common_1.find([state.dynamic, noReloadOnSearch], predicates_1.isDefined);
	    var defaultConfig = predicates_1.isDefined(dynamic) ? { dynamic: dynamic } : {};
	    var paramConfig = unwrapShorthand(state && state.params && state.params[paramName]);
	    return common_1.extend(defaultConfig, paramConfig);
	}
	function unwrapShorthand(cfg) {
	    cfg = isShorthand(cfg) ? { value: cfg } : cfg;
	    getStaticDefaultValue['__cacheable'] = true;
	    function getStaticDefaultValue() {
	        return cfg.value;
	    }
	    var $$fn = predicates_1.isInjectable(cfg.value) ? cfg.value : getStaticDefaultValue;
	    return common_1.extend(cfg, { $$fn: $$fn });
	}
	function getType(cfg, urlType, location, id, paramTypes) {
	    if (cfg.type && urlType && urlType.name !== 'string')
	        throw new Error("Param '" + id + "' has two type configurations.");
	    if (cfg.type && urlType && urlType.name === 'string' && paramTypes.type(cfg.type))
	        return paramTypes.type(cfg.type);
	    if (urlType)
	        return urlType;
	    if (!cfg.type) {
	        var type = location === DefType.CONFIG
	            ? 'any'
	            : location === DefType.PATH
	                ? 'path'
	                : location === DefType.SEARCH
	                    ? 'query'
	                    : 'string';
	        return paramTypes.type(type);
	    }
	    return cfg.type instanceof paramType_1.ParamType ? cfg.type : paramTypes.type(cfg.type);
	}
	/** returns false, true, or the squash value to indicate the "default parameter url squash policy". */
	function getSquashPolicy(config, isOptional, defaultPolicy) {
	    var squash = config.squash;
	    if (!isOptional || squash === false)
	        return false;
	    if (!predicates_1.isDefined(squash) || squash == null)
	        return defaultPolicy;
	    if (squash === true || predicates_1.isString(squash))
	        return squash;
	    throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	}
	function getReplace(config, arrayMode, isOptional, squash) {
	    var defaultPolicy = [
	        { from: '', to: isOptional || arrayMode ? undefined : '' },
	        { from: null, to: isOptional || arrayMode ? undefined : '' },
	    ];
	    var replace = predicates_1.isArray(config.replace) ? config.replace : [];
	    if (predicates_1.isString(squash))
	        replace.push({ from: squash, to: undefined });
	    var configuredKeys = common_1.map(replace, hof_1.prop('from'));
	    return common_1.filter(defaultPolicy, function (item) { return configuredKeys.indexOf(item.from) === -1; }).concat(replace);
	}
	var Param = /** @class */ (function () {
	    function Param(id, type, location, urlConfig, state) {
	        var config = getParamDeclaration(id, location, state);
	        type = getType(config, type, location, id, urlConfig.paramTypes);
	        var arrayMode = getArrayMode();
	        type = arrayMode ? type.$asArray(arrayMode, location === DefType.SEARCH) : type;
	        var isOptional = config.value !== undefined || location === DefType.SEARCH;
	        var dynamic = predicates_1.isDefined(config.dynamic) ? !!config.dynamic : !!type.dynamic;
	        var raw = predicates_1.isDefined(config.raw) ? !!config.raw : !!type.raw;
	        var squash = getSquashPolicy(config, isOptional, urlConfig.defaultSquashPolicy());
	        var replace = getReplace(config, arrayMode, isOptional, squash);
	        var inherit = predicates_1.isDefined(config.inherit) ? !!config.inherit : !!type.inherit;
	        // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	        function getArrayMode() {
	            var arrayDefaults = { array: location === DefType.SEARCH ? 'auto' : false };
	            var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	            return common_1.extend(arrayDefaults, arrayParamNomenclature, config).array;
	        }
	        common_1.extend(this, { id: id, type: type, location: location, isOptional: isOptional, dynamic: dynamic, raw: raw, squash: squash, replace: replace, inherit: inherit, array: arrayMode, config: config });
	    }
	    Param.values = function (params, values) {
	        if (values === void 0) { values = {}; }
	        var paramValues = {};
	        for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
	            var param = params_1[_i];
	            paramValues[param.id] = param.value(values[param.id]);
	        }
	        return paramValues;
	    };
	    /**
	     * Finds [[Param]] objects which have different param values
	     *
	     * Filters a list of [[Param]] objects to only those whose parameter values differ in two param value objects
	     *
	     * @param params: The list of Param objects to filter
	     * @param values1: The first set of parameter values
	     * @param values2: the second set of parameter values
	     *
	     * @returns any Param objects whose values were different between values1 and values2
	     */
	    Param.changed = function (params, values1, values2) {
	        if (values1 === void 0) { values1 = {}; }
	        if (values2 === void 0) { values2 = {}; }
	        return params.filter(function (param) { return !param.type.equals(values1[param.id], values2[param.id]); });
	    };
	    /**
	     * Checks if two param value objects are equal (for a set of [[Param]] objects)
	     *
	     * @param params The list of [[Param]] objects to check
	     * @param values1 The first set of param values
	     * @param values2 The second set of param values
	     *
	     * @returns true if the param values in values1 and values2 are equal
	     */
	    Param.equals = function (params, values1, values2) {
	        if (values1 === void 0) { values1 = {}; }
	        if (values2 === void 0) { values2 = {}; }
	        return Param.changed(params, values1, values2).length === 0;
	    };
	    /** Returns true if a the parameter values are valid, according to the Param definitions */
	    Param.validates = function (params, values) {
	        if (values === void 0) { values = {}; }
	        return params.map(function (param) { return param.validates(values[param.id]); }).reduce(common_1.allTrueR, true);
	    };
	    Param.prototype.isDefaultValue = function (value) {
	        return this.isOptional && this.type.equals(this.value(), value);
	    };
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    Param.prototype.value = function (value) {
	        var _this = this;
	        /**
	         * [Internal] Get the default value of a parameter, which may be an injectable function.
	         */
	        var getDefaultValue = function () {
	            if (_this._defaultValueCache)
	                return _this._defaultValueCache.defaultValue;
	            if (!coreservices_1.services.$injector)
	                throw new Error('Injectable functions cannot be called at configuration time');
	            var defaultValue = coreservices_1.services.$injector.invoke(_this.config.$$fn);
	            if (defaultValue !== null && defaultValue !== undefined && !_this.type.is(defaultValue))
	                throw new Error("Default value (" + defaultValue + ") for parameter '" + _this.id + "' is not an instance of ParamType (" + _this.type.name + ")");
	            if (_this.config.$$fn['__cacheable']) {
	                _this._defaultValueCache = { defaultValue: defaultValue };
	            }
	            return defaultValue;
	        };
	        var replaceSpecialValues = function (val) {
	            for (var _i = 0, _a = _this.replace; _i < _a.length; _i++) {
	                var tuple = _a[_i];
	                if (tuple.from === val)
	                    return tuple.to;
	            }
	            return val;
	        };
	        value = replaceSpecialValues(value);
	        return predicates_1.isUndefined(value) ? getDefaultValue() : this.type.$normalize(value);
	    };
	    Param.prototype.isSearch = function () {
	        return this.location === DefType.SEARCH;
	    };
	    Param.prototype.validates = function (value) {
	        // There was no parameter value, but the param is optional
	        if ((predicates_1.isUndefined(value) || value === null) && this.isOptional)
	            return true;
	        // The value was not of the correct ParamType, and could not be decoded to the correct ParamType
	        var normalized = this.type.$normalize(value);
	        if (!this.type.is(normalized))
	            return false;
	        // The value was of the correct type, but when encoded, did not match the ParamType's regexp
	        var encoded = this.type.encode(normalized);
	        return !(predicates_1.isString(encoded) && !this.type.pattern.exec(encoded));
	    };
	    Param.prototype.toString = function () {
	        return "{Param:" + this.id + " " + this.type + " squash: '" + this.squash + "' optional: " + this.isOptional + "}";
	    };
	    return Param;
	}());
	exports.Param = Param;
	//# sourceMappingURL=param.js.map

/***/ },

/***/ 16:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TargetState = void 0;
	var predicates_1 = __webpack_require__(5);
	var strings_1 = __webpack_require__(10);
	var common_1 = __webpack_require__(7);
	/**
	 * Encapsulate the target (destination) state/params/options of a [[Transition]].
	 *
	 * This class is frequently used to redirect a transition to a new destination.
	 *
	 * See:
	 *
	 * - [[HookResult]]
	 * - [[TransitionHookFn]]
	 * - [[TransitionService.onStart]]
	 *
	 * To create a `TargetState`, use [[StateService.target]].
	 *
	 * ---
	 *
	 * This class wraps:
	 *
	 * 1) an identifier for a state
	 * 2) a set of parameters
	 * 3) and transition options
	 * 4) the registered state object (the [[StateDeclaration]])
	 *
	 * Many UI-Router APIs such as [[StateService.go]] take a [[StateOrName]] argument which can
	 * either be a *state object* (a [[StateDeclaration]] or [[StateObject]]) or a *state name* (a string).
	 * The `TargetState` class normalizes those options.
	 *
	 * A `TargetState` may be valid (the state being targeted exists in the registry)
	 * or invalid (the state being targeted is not registered).
	 */
	var TargetState = /** @class */ (function () {
	    /**
	     * The TargetState constructor
	     *
	     * Note: Do not construct a `TargetState` manually.
	     * To create a `TargetState`, use the [[StateService.target]] factory method.
	     *
	     * @param _stateRegistry The StateRegistry to use to look up the _definition
	     * @param _identifier An identifier for a state.
	     *    Either a fully-qualified state name, or the object used to define the state.
	     * @param _params Parameters for the target state
	     * @param _options Transition options.
	     *
	     * @internal
	     */
	    function TargetState(_stateRegistry, _identifier, _params, _options) {
	        this._stateRegistry = _stateRegistry;
	        this._identifier = _identifier;
	        this._identifier = _identifier;
	        this._params = common_1.extend({}, _params || {});
	        this._options = common_1.extend({}, _options || {});
	        this._definition = _stateRegistry.matcher.find(_identifier, this._options.relative);
	    }
	    /** The name of the state this object targets */
	    TargetState.prototype.name = function () {
	        return (this._definition && this._definition.name) || this._identifier;
	    };
	    /** The identifier used when creating this TargetState */
	    TargetState.prototype.identifier = function () {
	        return this._identifier;
	    };
	    /** The target parameter values */
	    TargetState.prototype.params = function () {
	        return this._params;
	    };
	    /** The internal state object (if it was found) */
	    TargetState.prototype.$state = function () {
	        return this._definition;
	    };
	    /** The internal state declaration (if it was found) */
	    TargetState.prototype.state = function () {
	        return this._definition && this._definition.self;
	    };
	    /** The target options */
	    TargetState.prototype.options = function () {
	        return this._options;
	    };
	    /** True if the target state was found */
	    TargetState.prototype.exists = function () {
	        return !!(this._definition && this._definition.self);
	    };
	    /** True if the object is valid */
	    TargetState.prototype.valid = function () {
	        return !this.error();
	    };
	    /** If the object is invalid, returns the reason why */
	    TargetState.prototype.error = function () {
	        var base = this.options().relative;
	        if (!this._definition && !!base) {
	            var stateName = base.name ? base.name : base;
	            return "Could not resolve '" + this.name() + "' from state '" + stateName + "'";
	        }
	        if (!this._definition)
	            return "No such state '" + this.name() + "'";
	        if (!this._definition.self)
	            return "State '" + this.name() + "' has an invalid definition";
	    };
	    TargetState.prototype.toString = function () {
	        return "'" + this.name() + "'" + strings_1.stringify(this.params());
	    };
	    /**
	     * Returns a copy of this TargetState which targets a different state.
	     * The new TargetState has the same parameter values and transition options.
	     *
	     * @param state The new state that should be targeted
	     */
	    TargetState.prototype.withState = function (state) {
	        return new TargetState(this._stateRegistry, state, this._params, this._options);
	    };
	    /**
	     * Returns a copy of this TargetState, using the specified parameter values.
	     *
	     * @param params the new parameter values to use
	     * @param replace When false (default) the new parameter values will be merged with the current values.
	     *                When true the parameter values will be used instead of the current values.
	     */
	    TargetState.prototype.withParams = function (params, replace) {
	        if (replace === void 0) { replace = false; }
	        var newParams = replace ? params : common_1.extend({}, this._params, params);
	        return new TargetState(this._stateRegistry, this._identifier, newParams, this._options);
	    };
	    /**
	     * Returns a copy of this TargetState, using the specified Transition Options.
	     *
	     * @param options the new options to use
	     * @param replace When false (default) the new options will be merged with the current options.
	     *                When true the options will be used instead of the current options.
	     */
	    TargetState.prototype.withOptions = function (options, replace) {
	        if (replace === void 0) { replace = false; }
	        var newOpts = replace ? options : common_1.extend({}, this._options, options);
	        return new TargetState(this._stateRegistry, this._identifier, this._params, newOpts);
	    };
	    /** Returns true if the object has a state property that might be a state or state name */
	    TargetState.isDef = function (obj) {
	        return obj && obj.state && (predicates_1.isString(obj.state) || (predicates_1.isObject(obj.state) && predicates_1.isString(obj.state.name)));
	    };
	    return TargetState;
	}());
	exports.TargetState = TargetState;
	//# sourceMappingURL=targetState.js.map

/***/ },

/***/ 17:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionHook = void 0;
	var interface_1 = __webpack_require__(13);
	var common_1 = __webpack_require__(4);
	var strings_1 = __webpack_require__(10);
	var predicates_1 = __webpack_require__(5);
	var hof_1 = __webpack_require__(6);
	var trace_1 = __webpack_require__(12);
	var coreservices_1 = __webpack_require__(8);
	var rejectFactory_1 = __webpack_require__(14);
	var targetState_1 = __webpack_require__(16);
	var defaultOptions = {
	    current: common_1.noop,
	    transition: null,
	    traceData: {},
	    bind: null,
	};
	var TransitionHook = /** @class */ (function () {
	    function TransitionHook(transition, stateContext, registeredHook, options) {
	        var _this = this;
	        this.transition = transition;
	        this.stateContext = stateContext;
	        this.registeredHook = registeredHook;
	        this.options = options;
	        this.isSuperseded = function () { return _this.type.hookPhase === interface_1.TransitionHookPhase.RUN && !_this.options.transition.isActive(); };
	        this.options = common_1.defaults(options, defaultOptions);
	        this.type = registeredHook.eventType;
	    }
	    /**
	     * Chains together an array of TransitionHooks.
	     *
	     * Given a list of [[TransitionHook]] objects, chains them together.
	     * Each hook is invoked after the previous one completes.
	     *
	     * #### Example:
	     * ```js
	     * var hooks: TransitionHook[] = getHooks();
	     * let promise: Promise<any> = TransitionHook.chain(hooks);
	     *
	     * promise.then(handleSuccess, handleError);
	     * ```
	     *
	     * @param hooks the list of hooks to chain together
	     * @param waitFor if provided, the chain is `.then()`'ed off this promise
	     * @returns a `Promise` for sequentially invoking the hooks (in order)
	     */
	    TransitionHook.chain = function (hooks, waitFor) {
	        // Chain the next hook off the previous
	        var createHookChainR = function (prev, nextHook) { return prev.then(function () { return nextHook.invokeHook(); }); };
	        return hooks.reduce(createHookChainR, waitFor || coreservices_1.services.$q.when());
	    };
	    /**
	     * Invokes all the provided TransitionHooks, in order.
	     * Each hook's return value is checked.
	     * If any hook returns a promise, then the rest of the hooks are chained off that promise, and the promise is returned.
	     * If no hook returns a promise, then all hooks are processed synchronously.
	     *
	     * @param hooks the list of TransitionHooks to invoke
	     * @param doneCallback a callback that is invoked after all the hooks have successfully completed
	     *
	     * @returns a promise for the async result, or the result of the callback
	     */
	    TransitionHook.invokeHooks = function (hooks, doneCallback) {
	        for (var idx = 0; idx < hooks.length; idx++) {
	            var hookResult = hooks[idx].invokeHook();
	            if (predicates_1.isPromise(hookResult)) {
	                var remainingHooks = hooks.slice(idx + 1);
	                return TransitionHook.chain(remainingHooks, hookResult).then(doneCallback);
	            }
	        }
	        return doneCallback();
	    };
	    /**
	     * Run all TransitionHooks, ignoring their return value.
	     */
	    TransitionHook.runAllHooks = function (hooks) {
	        hooks.forEach(function (hook) { return hook.invokeHook(); });
	    };
	    TransitionHook.prototype.logError = function (err) {
	        this.transition.router.stateService.defaultErrorHandler()(err);
	    };
	    TransitionHook.prototype.invokeHook = function () {
	        var _this = this;
	        var hook = this.registeredHook;
	        if (hook._deregistered)
	            return;
	        var notCurrent = this.getNotCurrentRejection();
	        if (notCurrent)
	            return notCurrent;
	        var options = this.options;
	        trace_1.trace.traceHookInvocation(this, this.transition, options);
	        var invokeCallback = function () { return hook.callback.call(options.bind, _this.transition, _this.stateContext); };
	        var normalizeErr = function (err) { return rejectFactory_1.Rejection.normalize(err).toPromise(); };
	        var handleError = function (err) { return hook.eventType.getErrorHandler(_this)(err); };
	        var handleResult = function (result) { return hook.eventType.getResultHandler(_this)(result); };
	        try {
	            var result = invokeCallback();
	            if (!this.type.synchronous && predicates_1.isPromise(result)) {
	                return result.catch(normalizeErr).then(handleResult, handleError);
	            }
	            else {
	                return handleResult(result);
	            }
	        }
	        catch (err) {
	            // If callback throws (synchronously)
	            return handleError(rejectFactory_1.Rejection.normalize(err));
	        }
	        finally {
	            if (hook.invokeLimit && ++hook.invokeCount >= hook.invokeLimit) {
	                hook.deregister();
	            }
	        }
	    };
	    /**
	     * This method handles the return value of a Transition Hook.
	     *
	     * A hook can return false (cancel), a TargetState (redirect),
	     * or a promise (which may later resolve to false or a redirect)
	     *
	     * This also handles "transition superseded" -- when a new transition
	     * was started while the hook was still running
	     */
	    TransitionHook.prototype.handleHookResult = function (result) {
	        var _this = this;
	        var notCurrent = this.getNotCurrentRejection();
	        if (notCurrent)
	            return notCurrent;
	        // Hook returned a promise
	        if (predicates_1.isPromise(result)) {
	            // Wait for the promise, then reprocess with the resulting value
	            return result.then(function (val) { return _this.handleHookResult(val); });
	        }
	        trace_1.trace.traceHookResult(result, this.transition, this.options);
	        // Hook returned false
	        if (result === false) {
	            // Abort this Transition
	            return rejectFactory_1.Rejection.aborted('Hook aborted transition').toPromise();
	        }
	        var isTargetState = hof_1.is(targetState_1.TargetState);
	        // hook returned a TargetState
	        if (isTargetState(result)) {
	            // Halt the current Transition and redirect (a new Transition) to the TargetState.
	            return rejectFactory_1.Rejection.redirected(result).toPromise();
	        }
	    };
	    /**
	     * Return a Rejection promise if the transition is no longer current due
	     * to a stopped router (disposed), or a new transition has started and superseded this one.
	     */
	    TransitionHook.prototype.getNotCurrentRejection = function () {
	        var router = this.transition.router;
	        // The router is stopped
	        if (router._disposed) {
	            return rejectFactory_1.Rejection.aborted("UIRouter instance #" + router.$id + " has been stopped (disposed)").toPromise();
	        }
	        if (this.transition._aborted) {
	            return rejectFactory_1.Rejection.aborted().toPromise();
	        }
	        // This transition is no longer current.
	        // Another transition started while this hook was still running.
	        if (this.isSuperseded()) {
	            // Abort this transition
	            return rejectFactory_1.Rejection.superseded(this.options.current()).toPromise();
	        }
	    };
	    TransitionHook.prototype.toString = function () {
	        var _a = this, options = _a.options, registeredHook = _a.registeredHook;
	        var event = hof_1.parse('traceData.hookType')(options) || 'internal', context = hof_1.parse('traceData.context.state.name')(options) || hof_1.parse('traceData.context')(options) || 'unknown', name = strings_1.fnToString(registeredHook.callback);
	        return event + " context: " + context + ", " + strings_1.maxLength(200, name);
	    };
	    /**
	     * These GetResultHandler(s) are used by [[invokeHook]] below
	     * Each HookType chooses a GetResultHandler (See: [[TransitionService._defineCoreEvents]])
	     */
	    TransitionHook.HANDLE_RESULT = function (hook) { return function (result) {
	        return hook.handleHookResult(result);
	    }; };
	    /**
	     * If the result is a promise rejection, log it.
	     * Otherwise, ignore the result.
	     */
	    TransitionHook.LOG_REJECTED_RESULT = function (hook) { return function (result) {
	        predicates_1.isPromise(result) && result.catch(function (err) { return hook.logError(rejectFactory_1.Rejection.normalize(err)); });
	        return undefined;
	    }; };
	    /**
	     * These GetErrorHandler(s) are used by [[invokeHook]] below
	     * Each HookType chooses a GetErrorHandler (See: [[TransitionService._defineCoreEvents]])
	     */
	    TransitionHook.LOG_ERROR = function (hook) { return function (error) { return hook.logError(error); }; };
	    TransitionHook.REJECT_ERROR = function (hook) { return function (error) { return common_1.silentRejection(error); }; };
	    TransitionHook.THROW_ERROR = function (hook) { return function (error) {
	        throw error;
	    }; };
	    return TransitionHook;
	}());
	exports.TransitionHook = TransitionHook;
	//# sourceMappingURL=transitionHook.js.map

/***/ },

/***/ 20:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PathUtils = void 0;
	var common_1 = __webpack_require__(4);
	var hof_1 = __webpack_require__(6);
	var targetState_1 = __webpack_require__(16);
	var pathNode_1 = __webpack_require__(32);
	/**
	 * This class contains functions which convert TargetStates, Nodes and paths from one type to another.
	 */
	var PathUtils = /** @class */ (function () {
	    function PathUtils() {
	    }
	    /** Given a PathNode[], create an TargetState */
	    PathUtils.makeTargetState = function (registry, path) {
	        var state = common_1.tail(path).state;
	        return new targetState_1.TargetState(registry, state, path.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}), {});
	    };
	    PathUtils.buildPath = function (targetState) {
	        var toParams = targetState.params();
	        return targetState.$state().path.map(function (state) { return new pathNode_1.PathNode(state).applyRawParams(toParams); });
	    };
	    /** Given a fromPath: PathNode[] and a TargetState, builds a toPath: PathNode[] */
	    PathUtils.buildToPath = function (fromPath, targetState) {
	        var toPath = PathUtils.buildPath(targetState);
	        if (targetState.options().inherit) {
	            return PathUtils.inheritParams(fromPath, toPath, Object.keys(targetState.params()));
	        }
	        return toPath;
	    };
	    /**
	     * Creates ViewConfig objects and adds to nodes.
	     *
	     * On each [[PathNode]], creates ViewConfig objects from the views: property of the node's state
	     */
	    PathUtils.applyViewConfigs = function ($view, path, states) {
	        // Only apply the viewConfigs to the nodes for the given states
	        path
	            .filter(function (node) { return common_1.inArray(states, node.state); })
	            .forEach(function (node) {
	            var viewDecls = common_1.values(node.state.views || {});
	            var subPath = PathUtils.subPath(path, function (n) { return n === node; });
	            var viewConfigs = viewDecls.map(function (view) { return $view.createViewConfig(subPath, view); });
	            node.views = viewConfigs.reduce(common_1.unnestR, []);
	        });
	    };
	    /**
	     * Given a fromPath and a toPath, returns a new to path which inherits parameters from the fromPath
	     *
	     * For a parameter in a node to be inherited from the from path:
	     * - The toPath's node must have a matching node in the fromPath (by state).
	     * - The parameter name must not be found in the toKeys parameter array.
	     *
	     * Note: the keys provided in toKeys are intended to be those param keys explicitly specified by some
	     * caller, for instance, $state.transitionTo(..., toParams).  If a key was found in toParams,
	     * it is not inherited from the fromPath.
	     */
	    PathUtils.inheritParams = function (fromPath, toPath, toKeys) {
	        if (toKeys === void 0) { toKeys = []; }
	        function nodeParamVals(path, state) {
	            var node = common_1.find(path, hof_1.propEq('state', state));
	            return common_1.extend({}, node && node.paramValues);
	        }
	        var noInherit = fromPath
	            .map(function (node) { return node.paramSchema; })
	            .reduce(common_1.unnestR, [])
	            .filter(function (param) { return !param.inherit; })
	            .map(hof_1.prop('id'));
	        /**
	         * Given an [[PathNode]] "toNode", return a new [[PathNode]] with param values inherited from the
	         * matching node in fromPath.  Only inherit keys that aren't found in "toKeys" from the node in "fromPath""
	         */
	        function makeInheritedParamsNode(toNode) {
	            // All param values for the node (may include default key/vals, when key was not found in toParams)
	            var toParamVals = common_1.extend({}, toNode && toNode.paramValues);
	            // limited to only those keys found in toParams
	            var incomingParamVals = common_1.pick(toParamVals, toKeys);
	            toParamVals = common_1.omit(toParamVals, toKeys);
	            var fromParamVals = common_1.omit(nodeParamVals(fromPath, toNode.state) || {}, noInherit);
	            // extend toParamVals with any fromParamVals, then override any of those those with incomingParamVals
	            var ownParamVals = common_1.extend(toParamVals, fromParamVals, incomingParamVals);
	            return new pathNode_1.PathNode(toNode.state).applyRawParams(ownParamVals);
	        }
	        // The param keys specified by the incoming toParams
	        return toPath.map(makeInheritedParamsNode);
	    };
	    /**
	     * Computes the tree changes (entering, exiting) between a fromPath and toPath.
	     */
	    PathUtils.treeChanges = function (fromPath, toPath, reloadState) {
	        var max = Math.min(fromPath.length, toPath.length);
	        var keep = 0;
	        var nodesMatch = function (node1, node2) { return node1.equals(node2, PathUtils.nonDynamicParams); };
	        while (keep < max && fromPath[keep].state !== reloadState && nodesMatch(fromPath[keep], toPath[keep])) {
	            keep++;
	        }
	        /** Given a retained node, return a new node which uses the to node's param values */
	        function applyToParams(retainedNode, idx) {
	            var cloned = retainedNode.clone();
	            cloned.paramValues = toPath[idx].paramValues;
	            return cloned;
	        }
	        var from, retained, exiting, entering, to;
	        from = fromPath;
	        retained = from.slice(0, keep);
	        exiting = from.slice(keep);
	        // Create a new retained path (with shallow copies of nodes) which have the params of the toPath mapped
	        var retainedWithToParams = retained.map(applyToParams);
	        entering = toPath.slice(keep);
	        to = retainedWithToParams.concat(entering);
	        return { from: from, to: to, retained: retained, retainedWithToParams: retainedWithToParams, exiting: exiting, entering: entering };
	    };
	    /**
	     * Returns a new path which is: the subpath of the first path which matches the second path.
	     *
	     * The new path starts from root and contains any nodes that match the nodes in the second path.
	     * It stops before the first non-matching node.
	     *
	     * Nodes are compared using their state property and their parameter values.
	     * If a `paramsFn` is provided, only the [[Param]] returned by the function will be considered when comparing nodes.
	     *
	     * @param pathA the first path
	     * @param pathB the second path
	     * @param paramsFn a function which returns the parameters to consider when comparing
	     *
	     * @returns an array of PathNodes from the first path which match the nodes in the second path
	     */
	    PathUtils.matching = function (pathA, pathB, paramsFn) {
	        var done = false;
	        var tuples = common_1.arrayTuples(pathA, pathB);
	        return tuples.reduce(function (matching, _a) {
	            var nodeA = _a[0], nodeB = _a[1];
	            done = done || !nodeA.equals(nodeB, paramsFn);
	            return done ? matching : matching.concat(nodeA);
	        }, []);
	    };
	    /**
	     * Returns true if two paths are identical.
	     *
	     * @param pathA
	     * @param pathB
	     * @param paramsFn a function which returns the parameters to consider when comparing
	     * @returns true if the the states and parameter values for both paths are identical
	     */
	    PathUtils.equals = function (pathA, pathB, paramsFn) {
	        return pathA.length === pathB.length && PathUtils.matching(pathA, pathB, paramsFn).length === pathA.length;
	    };
	    /**
	     * Return a subpath of a path, which stops at the first matching node
	     *
	     * Given an array of nodes, returns a subset of the array starting from the first node,
	     * stopping when the first node matches the predicate.
	     *
	     * @param path a path of [[PathNode]]s
	     * @param predicate a [[Predicate]] fn that matches [[PathNode]]s
	     * @returns a subpath up to the matching node, or undefined if no match is found
	     */
	    PathUtils.subPath = function (path, predicate) {
	        var node = common_1.find(path, predicate);
	        var elementIdx = path.indexOf(node);
	        return elementIdx === -1 ? undefined : path.slice(0, elementIdx + 1);
	    };
	    PathUtils.nonDynamicParams = function (node) {
	        return node.state.parameters({ inherit: false }).filter(function (param) { return !param.dynamic; });
	    };
	    /** Gets the raw parameter values from a path */
	    PathUtils.paramValues = function (path) { return path.reduce(function (acc, node) { return common_1.extend(acc, node.paramValues); }, {}); };
	    return PathUtils;
	}());
	exports.PathUtils = PathUtils;
	//# sourceMappingURL=pathUtils.js.map

/***/ },

/***/ 21:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Resolvable = exports.defaultResolvePolicy = void 0;
	var common_1 = __webpack_require__(4);
	var coreservices_1 = __webpack_require__(8);
	var trace_1 = __webpack_require__(12);
	var strings_1 = __webpack_require__(10);
	var predicates_1 = __webpack_require__(5);
	var predicates_2 = __webpack_require__(5);
	// TODO: explicitly make this user configurable
	exports.defaultResolvePolicy = {
	    when: 'LAZY',
	    async: 'WAIT',
	};
	/**
	 * The basic building block for the resolve system.
	 *
	 * Resolvables encapsulate a state's resolve's resolveFn, the resolveFn's declared dependencies, the wrapped (.promise),
	 * and the unwrapped-when-complete (.data) result of the resolveFn.
	 *
	 * Resolvable.get() either retrieves the Resolvable's existing promise, or else invokes resolve() (which invokes the
	 * resolveFn) and returns the resulting promise.
	 *
	 * Resolvable.get() and Resolvable.resolve() both execute within a context path, which is passed as the first
	 * parameter to those fns.
	 */
	var Resolvable = /** @class */ (function () {
	    function Resolvable(arg1, resolveFn, deps, policy, data) {
	        this.resolved = false;
	        this.promise = undefined;
	        if (arg1 instanceof Resolvable) {
	            common_1.extend(this, arg1);
	        }
	        else if (predicates_1.isFunction(resolveFn)) {
	            if (predicates_2.isNullOrUndefined(arg1))
	                throw new Error('new Resolvable(): token argument is required');
	            if (!predicates_1.isFunction(resolveFn))
	                throw new Error('new Resolvable(): resolveFn argument must be a function');
	            this.token = arg1;
	            this.policy = policy;
	            this.resolveFn = resolveFn;
	            this.deps = deps || [];
	            this.data = data;
	            this.resolved = data !== undefined;
	            this.promise = this.resolved ? coreservices_1.services.$q.when(this.data) : undefined;
	        }
	        else if (predicates_1.isObject(arg1) && arg1.token && (arg1.hasOwnProperty('resolveFn') || arg1.hasOwnProperty('data'))) {
	            var literal = arg1;
	            return new Resolvable(literal.token, literal.resolveFn, literal.deps, literal.policy, literal.data);
	        }
	    }
	    Resolvable.prototype.getPolicy = function (state) {
	        var thisPolicy = this.policy || {};
	        var statePolicy = (state && state.resolvePolicy) || {};
	        return {
	            when: thisPolicy.when || statePolicy.when || exports.defaultResolvePolicy.when,
	            async: thisPolicy.async || statePolicy.async || exports.defaultResolvePolicy.async,
	        };
	    };
	    /**
	     * Asynchronously resolve this Resolvable's data
	     *
	     * Given a ResolveContext that this Resolvable is found in:
	     * Wait for this Resolvable's dependencies, then invoke this Resolvable's function
	     * and update the Resolvable's state
	     */
	    Resolvable.prototype.resolve = function (resolveContext, trans) {
	        var _this = this;
	        var $q = coreservices_1.services.$q;
	        // Gets all dependencies from ResolveContext and wait for them to be resolved
	        var getResolvableDependencies = function () {
	            return $q.all(resolveContext.getDependencies(_this).map(function (resolvable) { return resolvable.get(resolveContext, trans); }));
	        };
	        // Invokes the resolve function passing the resolved dependencies as arguments
	        var invokeResolveFn = function (resolvedDeps) { return _this.resolveFn.apply(null, resolvedDeps); };
	        var node = resolveContext.findNode(this);
	        var state = node && node.state;
	        var asyncPolicy = this.getPolicy(state).async;
	        var customAsyncPolicy = predicates_1.isFunction(asyncPolicy) ? asyncPolicy : common_1.identity;
	        // After the final value has been resolved, update the state of the Resolvable
	        var applyResolvedValue = function (resolvedValue) {
	            _this.data = resolvedValue;
	            _this.resolved = true;
	            _this.resolveFn = null;
	            trace_1.trace.traceResolvableResolved(_this, trans);
	            return _this.data;
	        };
	        // Sets the promise property first, then getsResolvableDependencies in the context of the promise chain. Always waits one tick.
	        return (this.promise = $q
	            .when()
	            .then(getResolvableDependencies)
	            .then(invokeResolveFn)
	            .then(customAsyncPolicy)
	            .then(applyResolvedValue));
	    };
	    /**
	     * Gets a promise for this Resolvable's data.
	     *
	     * Fetches the data and returns a promise.
	     * Returns the existing promise if it has already been fetched once.
	     */
	    Resolvable.prototype.get = function (resolveContext, trans) {
	        return this.promise || this.resolve(resolveContext, trans);
	    };
	    Resolvable.prototype.toString = function () {
	        return "Resolvable(token: " + strings_1.stringify(this.token) + ", requires: [" + this.deps.map(strings_1.stringify) + "])";
	    };
	    Resolvable.prototype.clone = function () {
	        return new Resolvable(this);
	    };
	    Resolvable.fromData = function (token, data) { return new Resolvable(token, function () { return data; }, null, null, data); };
	    return Resolvable;
	}());
	exports.Resolvable = Resolvable;
	//# sourceMappingURL=resolvable.js.map

/***/ },

/***/ 22:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ResolveContext = exports.NATIVE_INJECTOR_TOKEN = void 0;
	var common_1 = __webpack_require__(4);
	var hof_1 = __webpack_require__(6);
	var trace_1 = __webpack_require__(12);
	var coreservices_1 = __webpack_require__(8);
	var interface_1 = __webpack_require__(52);
	var resolvable_1 = __webpack_require__(21);
	var pathUtils_1 = __webpack_require__(20);
	var strings_1 = __webpack_require__(10);
	var common_2 = __webpack_require__(7);
	var whens = interface_1.resolvePolicies.when;
	var ALL_WHENS = [whens.EAGER, whens.LAZY];
	var EAGER_WHENS = [whens.EAGER];
	// tslint:disable-next-line:no-inferrable-types
	exports.NATIVE_INJECTOR_TOKEN = 'Native Injector';
	/**
	 * Encapsulates Dependency Injection for a path of nodes
	 *
	 * UI-Router states are organized as a tree.
	 * A nested state has a path of ancestors to the root of the tree.
	 * When a state is being activated, each element in the path is wrapped as a [[PathNode]].
	 * A `PathNode` is a stateful object that holds things like parameters and resolvables for the state being activated.
	 *
	 * The ResolveContext closes over the [[PathNode]]s, and provides DI for the last node in the path.
	 */
	var ResolveContext = /** @class */ (function () {
	    function ResolveContext(_path) {
	        this._path = _path;
	    }
	    /** Gets all the tokens found in the resolve context, de-duplicated */
	    ResolveContext.prototype.getTokens = function () {
	        return this._path.reduce(function (acc, node) { return acc.concat(node.resolvables.map(function (r) { return r.token; })); }, []).reduce(common_1.uniqR, []);
	    };
	    /**
	     * Gets the Resolvable that matches the token
	     *
	     * Gets the last Resolvable that matches the token in this context, or undefined.
	     * Throws an error if it doesn't exist in the ResolveContext
	     */
	    ResolveContext.prototype.getResolvable = function (token) {
	        var matching = this._path
	            .map(function (node) { return node.resolvables; })
	            .reduce(common_1.unnestR, [])
	            .filter(function (r) { return r.token === token; });
	        return common_1.tail(matching);
	    };
	    /** Returns the [[ResolvePolicy]] for the given [[Resolvable]] */
	    ResolveContext.prototype.getPolicy = function (resolvable) {
	        var node = this.findNode(resolvable);
	        return resolvable.getPolicy(node.state);
	    };
	    /**
	     * Returns a ResolveContext that includes a portion of this one
	     *
	     * Given a state, this method creates a new ResolveContext from this one.
	     * The new context starts at the first node (root) and stops at the node for the `state` parameter.
	     *
	     * #### Why
	     *
	     * When a transition is created, the nodes in the "To Path" are injected from a ResolveContext.
	     * A ResolveContext closes over a path of [[PathNode]]s and processes the resolvables.
	     * The "To State" can inject values from its own resolvables, as well as those from all its ancestor state's (node's).
	     * This method is used to create a narrower context when injecting ancestor nodes.
	     *
	     * @example
	     * `let ABCD = new ResolveContext([A, B, C, D]);`
	     *
	     * Given a path `[A, B, C, D]`, where `A`, `B`, `C` and `D` are nodes for states `a`, `b`, `c`, `d`:
	     * When injecting `D`, `D` should have access to all resolvables from `A`, `B`, `C`, `D`.
	     * However, `B` should only be able to access resolvables from `A`, `B`.
	     *
	     * When resolving for the `B` node, first take the full "To Path" Context `[A,B,C,D]` and limit to the subpath `[A,B]`.
	     * `let AB = ABCD.subcontext(a)`
	     */
	    ResolveContext.prototype.subContext = function (state) {
	        return new ResolveContext(pathUtils_1.PathUtils.subPath(this._path, function (node) { return node.state === state; }));
	    };
	    /**
	     * Adds Resolvables to the node that matches the state
	     *
	     * This adds a [[Resolvable]] (generally one created on the fly; not declared on a [[StateDeclaration.resolve]] block).
	     * The resolvable is added to the node matching the `state` parameter.
	     *
	     * These new resolvables are not automatically fetched.
	     * The calling code should either fetch them, fetch something that depends on them,
	     * or rely on [[resolvePath]] being called when some state is being entered.
	     *
	     * Note: each resolvable's [[ResolvePolicy]] is merged with the state's policy, and the global default.
	     *
	     * @param newResolvables the new Resolvables
	     * @param state Used to find the node to put the resolvable on
	     */
	    ResolveContext.prototype.addResolvables = function (newResolvables, state) {
	        var node = common_1.find(this._path, hof_1.propEq('state', state));
	        var keys = newResolvables.map(function (r) { return r.token; });
	        node.resolvables = node.resolvables.filter(function (r) { return keys.indexOf(r.token) === -1; }).concat(newResolvables);
	    };
	    /**
	     * Returns a promise for an array of resolved path Element promises
	     *
	     * @param when
	     * @param trans
	     * @returns {Promise<any>|any}
	     */
	    ResolveContext.prototype.resolvePath = function (when, trans) {
	        var _this = this;
	        if (when === void 0) { when = 'LAZY'; }
	        // This option determines which 'when' policy Resolvables we are about to fetch.
	        var whenOption = common_1.inArray(ALL_WHENS, when) ? when : 'LAZY';
	        // If the caller specified EAGER, only the EAGER Resolvables are fetched.
	        // if the caller specified LAZY, both EAGER and LAZY Resolvables are fetched.`
	        var matchedWhens = whenOption === interface_1.resolvePolicies.when.EAGER ? EAGER_WHENS : ALL_WHENS;
	        // get the subpath to the state argument, if provided
	        trace_1.trace.traceResolvePath(this._path, when, trans);
	        var matchesPolicy = function (acceptedVals, whenOrAsync) { return function (resolvable) {
	            return common_1.inArray(acceptedVals, _this.getPolicy(resolvable)[whenOrAsync]);
	        }; };
	        // Trigger all the (matching) Resolvables in the path
	        // Reduce all the "WAIT" Resolvables into an array
	        var promises = this._path.reduce(function (acc, node) {
	            var nodeResolvables = node.resolvables.filter(matchesPolicy(matchedWhens, 'when'));
	            var nowait = nodeResolvables.filter(matchesPolicy(['NOWAIT'], 'async'));
	            var wait = nodeResolvables.filter(hof_1.not(matchesPolicy(['NOWAIT'], 'async')));
	            // For the matching Resolvables, start their async fetch process.
	            var subContext = _this.subContext(node.state);
	            var getResult = function (r) {
	                return r
	                    .get(subContext, trans)
	                    // Return a tuple that includes the Resolvable's token
	                    .then(function (value) { return ({ token: r.token, value: value }); });
	            };
	            nowait.forEach(getResult);
	            return acc.concat(wait.map(getResult));
	        }, []);
	        // Wait for all the "WAIT" resolvables
	        return coreservices_1.services.$q.all(promises);
	    };
	    ResolveContext.prototype.injector = function () {
	        return this._injector || (this._injector = new UIInjectorImpl(this));
	    };
	    ResolveContext.prototype.findNode = function (resolvable) {
	        return common_1.find(this._path, function (node) { return common_1.inArray(node.resolvables, resolvable); });
	    };
	    /**
	     * Gets the async dependencies of a Resolvable
	     *
	     * Given a Resolvable, returns its dependencies as a Resolvable[]
	     */
	    ResolveContext.prototype.getDependencies = function (resolvable) {
	        var _this = this;
	        var node = this.findNode(resolvable);
	        // Find which other resolvables are "visible" to the `resolvable` argument
	        // subpath stopping at resolvable's node, or the whole path (if the resolvable isn't in the path)
	        var subPath = pathUtils_1.PathUtils.subPath(this._path, function (x) { return x === node; }) || this._path;
	        var availableResolvables = subPath
	            .reduce(function (acc, _node) { return acc.concat(_node.resolvables); }, []) // all of subpath's resolvables
	            .filter(function (res) { return res !== resolvable; }); // filter out the `resolvable` argument
	        var getDependency = function (token) {
	            var matching = availableResolvables.filter(function (r) { return r.token === token; });
	            if (matching.length)
	                return common_1.tail(matching);
	            var fromInjector = _this.injector().getNative(token);
	            if (common_2.isUndefined(fromInjector)) {
	                throw new Error('Could not find Dependency Injection token: ' + strings_1.stringify(token));
	            }
	            return new resolvable_1.Resolvable(token, function () { return fromInjector; }, [], fromInjector);
	        };
	        return resolvable.deps.map(getDependency);
	    };
	    return ResolveContext;
	}());
	exports.ResolveContext = ResolveContext;
	/** @internal */
	var UIInjectorImpl = /** @class */ (function () {
	    function UIInjectorImpl(context) {
	        this.context = context;
	        this.native = this.get(exports.NATIVE_INJECTOR_TOKEN) || coreservices_1.services.$injector;
	    }
	    UIInjectorImpl.prototype.get = function (token) {
	        var resolvable = this.context.getResolvable(token);
	        if (resolvable) {
	            if (this.context.getPolicy(resolvable).async === 'NOWAIT') {
	                return resolvable.get(this.context);
	            }
	            if (!resolvable.resolved) {
	                throw new Error('Resolvable async .get() not complete:' + strings_1.stringify(resolvable.token));
	            }
	            return resolvable.data;
	        }
	        return this.getNative(token);
	    };
	    UIInjectorImpl.prototype.getAsync = function (token) {
	        var resolvable = this.context.getResolvable(token);
	        if (resolvable)
	            return resolvable.get(this.context);
	        return coreservices_1.services.$q.when(this.native.get(token));
	    };
	    UIInjectorImpl.prototype.getNative = function (token) {
	        return this.native && this.native.get(token);
	    };
	    return UIInjectorImpl;
	}());
	//# sourceMappingURL=resolveContext.js.map

/***/ },

/***/ 23:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlMatcher = void 0;
	var common_1 = __webpack_require__(4);
	var hof_1 = __webpack_require__(6);
	var predicates_1 = __webpack_require__(5);
	var param_1 = __webpack_require__(15);
	var strings_1 = __webpack_require__(10);
	var common_2 = __webpack_require__(7);
	function quoteRegExp(str, param) {
	    var surroundPattern = ['', ''], result = str.replace(/[\\\[\]\^$*+?.()|{}]/g, '\\$&');
	    if (!param)
	        return result;
	    switch (param.squash) {
	        case false:
	            surroundPattern = ['(', ')' + (param.isOptional ? '?' : '')];
	            break;
	        case true:
	            result = result.replace(/\/$/, '');
	            surroundPattern = ['(?:/(', ')|/)?'];
	            break;
	        default:
	            surroundPattern = ["(" + param.squash + "|", ')?'];
	            break;
	    }
	    return result + surroundPattern[0] + param.type.pattern.source + surroundPattern[1];
	}
	var memoizeTo = function (obj, _prop, fn) { return (obj[_prop] = obj[_prop] || fn()); };
	var splitOnSlash = strings_1.splitOnDelim('/');
	var defaultConfig = {
	    state: { params: {} },
	    strict: true,
	    caseInsensitive: true,
	    decodeParams: true,
	};
	/**
	 * Matches URLs against patterns.
	 *
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL.
	 *
	 * A URL pattern consists of a path pattern, optionally followed by '?' and a list of search (query)
	 * parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by [[UrlMatcher.exec]].
	 *
	 * - *Path parameters* are defined using curly brace placeholders (`/somepath/{param}`)
	 * or colon placeholders (`/somePath/:param`).
	 *
	 * - *A parameter RegExp* may be defined for a param after a colon
	 * (`/somePath/{param:[a-zA-Z0-9]+}`) in a curly brace placeholder.
	 * The regexp must match for the url to be matched.
	 * Should the regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Note: a RegExp parameter will encode its value using either [[ParamTypes.path]] or [[ParamTypes.query]].
	 *
	 * - *Custom parameter types* may also be specified after a colon (`/somePath/{param:int}`) in curly brace parameters.
	 *   See [[UrlMatcherFactory.type]] for more information.
	 *
	 * - *Catch-all parameters* are defined using an asterisk placeholder (`/somepath/*catchallparam`).
	 *   A catch-all * parameter value will contain the remainder of the URL.
	 *
	 * ---
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters).
	 * A path parameter matches any number of characters other than '/'. For catch-all
	 * placeholders the path parameter matches any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` ParamType matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 */
	var UrlMatcher = /** @class */ (function () {
	    /**
	     * @param pattern The pattern to compile into a matcher.
	     * @param paramTypes The [[ParamTypes]] registry
	     * @param paramFactory A [[ParamFactory]] object
	     * @param config  A [[UrlMatcherCompileConfig]] configuration object
	     */
	    function UrlMatcher(pattern, paramTypes, paramFactory, config) {
	        var _this = this;
	        /** @internal */
	        this._cache = { path: [this] };
	        /** @internal */
	        this._children = [];
	        /** @internal */
	        this._params = [];
	        /** @internal */
	        this._segments = [];
	        /** @internal */
	        this._compiled = [];
	        this.config = config = common_2.defaults(config, defaultConfig);
	        this.pattern = pattern;
	        // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	        //   '*' name
	        //   ':' name
	        //   '{' name '}'
	        //   '{' name ':' regexp '}'
	        // The regular expression is somewhat complicated due to the need to allow curly braces
	        // inside the regular expression. The placeholder regexp breaks down as follows:
	        //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	        //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	        //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	        //    [^{}\\]+                       - anything other than curly braces or backslash
	        //    \\.                            - a backslash escape
	        //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	        var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
	        var searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
	        var patterns = [];
	        var last = 0;
	        var matchArray;
	        var checkParamErrors = function (id) {
	            if (!UrlMatcher.nameValidator.test(id))
	                throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	            if (common_1.find(_this._params, hof_1.propEq('id', id)))
	                throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	        };
	        // Split into static segments separated by path parameter placeholders.
	        // The number of segments is always 1 more than the number of parameters.
	        var matchDetails = function (m, isSearch) {
	            // IE[78] returns '' for unmatched groups instead of null
	            var id = m[2] || m[3];
	            var regexp = isSearch ? m[4] : m[4] || (m[1] === '*' ? '[\\s\\S]*' : null);
	            var makeRegexpType = function (str) {
	                return common_1.inherit(paramTypes.type(isSearch ? 'query' : 'path'), {
	                    pattern: new RegExp(str, _this.config.caseInsensitive ? 'i' : undefined),
	                });
	            };
	            return {
	                id: id,
	                regexp: regexp,
	                segment: pattern.substring(last, m.index),
	                type: !regexp ? null : paramTypes.type(regexp) || makeRegexpType(regexp),
	            };
	        };
	        var details;
	        var segment;
	        // tslint:disable-next-line:no-conditional-assignment
	        while ((matchArray = placeholder.exec(pattern))) {
	            details = matchDetails(matchArray, false);
	            if (details.segment.indexOf('?') >= 0)
	                break; // we're into the search part
	            checkParamErrors(details.id);
	            this._params.push(paramFactory.fromPath(details.id, details.type, config.state));
	            this._segments.push(details.segment);
	            patterns.push([details.segment, common_1.tail(this._params)]);
	            last = placeholder.lastIndex;
	        }
	        segment = pattern.substring(last);
	        // Find any search parameter names and remove them from the last segment
	        var i = segment.indexOf('?');
	        if (i >= 0) {
	            var search = segment.substring(i);
	            segment = segment.substring(0, i);
	            if (search.length > 0) {
	                last = 0;
	                // tslint:disable-next-line:no-conditional-assignment
	                while ((matchArray = searchPlaceholder.exec(search))) {
	                    details = matchDetails(matchArray, true);
	                    checkParamErrors(details.id);
	                    this._params.push(paramFactory.fromSearch(details.id, details.type, config.state));
	                    last = placeholder.lastIndex;
	                    // check if ?&
	                }
	            }
	        }
	        this._segments.push(segment);
	        this._compiled = patterns.map(function (_pattern) { return quoteRegExp.apply(null, _pattern); }).concat(quoteRegExp(segment));
	    }
	    /** @internal */
	    UrlMatcher.encodeDashes = function (str) {
	        // Replace dashes with encoded "\-"
	        return encodeURIComponent(str).replace(/-/g, function (c) { return "%5C%" + c.charCodeAt(0).toString(16).toUpperCase(); });
	    };
	    /** @internal Given a matcher, return an array with the matcher's path segments and path params, in order */
	    UrlMatcher.pathSegmentsAndParams = function (matcher) {
	        var staticSegments = matcher._segments;
	        var pathParams = matcher._params.filter(function (p) { return p.location === param_1.DefType.PATH; });
	        return common_1.arrayTuples(staticSegments, pathParams.concat(undefined))
	            .reduce(common_1.unnestR, [])
	            .filter(function (x) { return x !== '' && predicates_1.isDefined(x); });
	    };
	    /** @internal Given a matcher, return an array with the matcher's query params */
	    UrlMatcher.queryParams = function (matcher) {
	        return matcher._params.filter(function (p) { return p.location === param_1.DefType.SEARCH; });
	    };
	    /**
	     * Compare two UrlMatchers
	     *
	     * This comparison function converts a UrlMatcher into static and dynamic path segments.
	     * Each static path segment is a static string between a path separator (slash character).
	     * Each dynamic segment is a path parameter.
	     *
	     * The comparison function sorts static segments before dynamic ones.
	     */
	    UrlMatcher.compare = function (a, b) {
	        /**
	         * Turn a UrlMatcher and all its parent matchers into an array
	         * of slash literals '/', string literals, and Param objects
	         *
	         * This example matcher matches strings like "/foo/:param/tail":
	         * var matcher = $umf.compile("/foo").append($umf.compile("/:param")).append($umf.compile("/")).append($umf.compile("tail"));
	         * var result = segments(matcher); // [ '/', 'foo', '/', Param, '/', 'tail' ]
	         *
	         * Caches the result as `matcher._cache.segments`
	         */
	        var segments = function (matcher) {
	            return (matcher._cache.segments =
	                matcher._cache.segments ||
	                    matcher._cache.path
	                        .map(UrlMatcher.pathSegmentsAndParams)
	                        .reduce(common_1.unnestR, [])
	                        .reduce(strings_1.joinNeighborsR, [])
	                        .map(function (x) { return (predicates_1.isString(x) ? splitOnSlash(x) : x); })
	                        .reduce(common_1.unnestR, []));
	        };
	        /**
	         * Gets the sort weight for each segment of a UrlMatcher
	         *
	         * Caches the result as `matcher._cache.weights`
	         */
	        var weights = function (matcher) {
	            return (matcher._cache.weights =
	                matcher._cache.weights ||
	                    segments(matcher).map(function (segment) {
	                        // Sort slashes first, then static strings, the Params
	                        if (segment === '/')
	                            return 1;
	                        if (predicates_1.isString(segment))
	                            return 2;
	                        if (segment instanceof param_1.Param)
	                            return 3;
	                    }));
	        };
	        /**
	         * Pads shorter array in-place (mutates)
	         */
	        var padArrays = function (l, r, padVal) {
	            var len = Math.max(l.length, r.length);
	            while (l.length < len)
	                l.push(padVal);
	            while (r.length < len)
	                r.push(padVal);
	        };
	        var weightsA = weights(a), weightsB = weights(b);
	        padArrays(weightsA, weightsB, 0);
	        var _pairs = common_1.arrayTuples(weightsA, weightsB);
	        var cmp, i;
	        for (i = 0; i < _pairs.length; i++) {
	            cmp = _pairs[i][0] - _pairs[i][1];
	            if (cmp !== 0)
	                return cmp;
	        }
	        return 0;
	    };
	    /**
	     * Creates a new concatenated UrlMatcher
	     *
	     * Builds a new UrlMatcher by appending another UrlMatcher to this one.
	     *
	     * @param url A `UrlMatcher` instance to append as a child of the current `UrlMatcher`.
	     */
	    UrlMatcher.prototype.append = function (url) {
	        this._children.push(url);
	        url._cache = {
	            path: this._cache.path.concat(url),
	            parent: this,
	            pattern: null,
	        };
	        return url;
	    };
	    /** @internal */
	    UrlMatcher.prototype.isRoot = function () {
	        return this._cache.path[0] === this;
	    };
	    /** Returns the input pattern string */
	    UrlMatcher.prototype.toString = function () {
	        return this.pattern;
	    };
	    UrlMatcher.prototype._getDecodedParamValue = function (value, param) {
	        if (predicates_1.isDefined(value)) {
	            if (this.config.decodeParams && !param.type.raw) {
	                if (predicates_1.isArray(value)) {
	                    value = value.map(function (paramValue) { return decodeURIComponent(paramValue); });
	                }
	                else {
	                    value = decodeURIComponent(value);
	                }
	            }
	            value = param.type.decode(value);
	        }
	        return param.value(value);
	    };
	    /**
	     * Tests the specified url/path against this matcher.
	     *
	     * Tests if the given url matches this matcher's pattern, and returns an object containing the captured
	     * parameter values.  Returns null if the path does not match.
	     *
	     * The returned object contains the values
	     * of any search parameters that are mentioned in the pattern, but their value may be null if
	     * they are not present in `search`. This means that search parameters are always treated
	     * as optional.
	     *
	     * #### Example:
	     * ```js
	     * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	     *   x: '1', q: 'hello'
	     * });
	     * // returns { id: 'bob', q: 'hello', r: null }
	     * ```
	     *
	     * @param path    The URL path to match, e.g. `$location.path()`.
	     * @param search  URL search parameters, e.g. `$location.search()`.
	     * @param hash    URL hash e.g. `$location.hash()`.
	     * @param options
	     *
	     * @returns The captured parameter values.
	     */
	    UrlMatcher.prototype.exec = function (path, search, hash, options) {
	        var _this = this;
	        if (search === void 0) { search = {}; }
	        if (options === void 0) { options = {}; }
	        var match = memoizeTo(this._cache, 'pattern', function () {
	            return new RegExp([
	                '^',
	                common_1.unnest(_this._cache.path.map(hof_1.prop('_compiled'))).join(''),
	                _this.config.strict === false ? '/?' : '',
	                '$',
	            ].join(''), _this.config.caseInsensitive ? 'i' : undefined);
	        }).exec(path);
	        if (!match)
	            return null;
	        // options = defaults(options, { isolate: false });
	        var allParams = this.parameters(), pathParams = allParams.filter(function (param) { return !param.isSearch(); }), searchParams = allParams.filter(function (param) { return param.isSearch(); }), nPathSegments = this._cache.path.map(function (urlm) { return urlm._segments.length - 1; }).reduce(function (a, x) { return a + x; }), values = {};
	        if (nPathSegments !== match.length - 1)
	            throw new Error("Unbalanced capture group in route '" + this.pattern + "'");
	        function decodePathArray(paramVal) {
	            var reverseString = function (str) { return str.split('').reverse().join(''); };
	            var unquoteDashes = function (str) { return str.replace(/\\-/g, '-'); };
	            var split = reverseString(paramVal).split(/-(?!\\)/);
	            var allReversed = common_1.map(split, reverseString);
	            return common_1.map(allReversed, unquoteDashes).reverse();
	        }
	        for (var i = 0; i < nPathSegments; i++) {
	            var param = pathParams[i];
	            var value = match[i + 1];
	            // if the param value matches a pre-replace pair, replace the value before decoding.
	            for (var j = 0; j < param.replace.length; j++) {
	                if (param.replace[j].from === value)
	                    value = param.replace[j].to;
	            }
	            if (value && param.array === true)
	                value = decodePathArray(value);
	            values[param.id] = this._getDecodedParamValue(value, param);
	        }
	        searchParams.forEach(function (param) {
	            var value = search[param.id];
	            for (var j = 0; j < param.replace.length; j++) {
	                if (param.replace[j].from === value)
	                    value = param.replace[j].to;
	            }
	            values[param.id] = _this._getDecodedParamValue(value, param);
	        });
	        if (hash)
	            values['#'] = hash;
	        return values;
	    };
	    /**
	     * @internal
	     * Returns all the [[Param]] objects of all path and search parameters of this pattern in order of appearance.
	     *
	     * @returns {Array.<Param>}  An array of [[Param]] objects. Must be treated as read-only. If the
	     *    pattern has no parameters, an empty array is returned.
	     */
	    UrlMatcher.prototype.parameters = function (opts) {
	        if (opts === void 0) { opts = {}; }
	        if (opts.inherit === false)
	            return this._params;
	        return common_1.unnest(this._cache.path.map(function (matcher) { return matcher._params; }));
	    };
	    /**
	     * @internal
	     * Returns a single parameter from this UrlMatcher by id
	     *
	     * @param id
	     * @param opts
	     * @returns {T|Param|any|boolean|UrlMatcher|null}
	     */
	    UrlMatcher.prototype.parameter = function (id, opts) {
	        var _this = this;
	        if (opts === void 0) { opts = {}; }
	        var findParam = function () {
	            for (var _i = 0, _a = _this._params; _i < _a.length; _i++) {
	                var param = _a[_i];
	                if (param.id === id)
	                    return param;
	            }
	        };
	        var parent = this._cache.parent;
	        return findParam() || (opts.inherit !== false && parent && parent.parameter(id, opts)) || null;
	    };
	    /**
	     * Validates the input parameter values against this UrlMatcher
	     *
	     * Checks an object hash of parameters to validate their correctness according to the parameter
	     * types of this `UrlMatcher`.
	     *
	     * @param params The object hash of parameters to validate.
	     * @returns Returns `true` if `params` validates, otherwise `false`.
	     */
	    UrlMatcher.prototype.validates = function (params) {
	        var validParamVal = function (param, val) { return !param || param.validates(val); };
	        params = params || {};
	        // I'm not sure why this checks only the param keys passed in, and not all the params known to the matcher
	        var paramSchema = this.parameters().filter(function (paramDef) { return params.hasOwnProperty(paramDef.id); });
	        return paramSchema.map(function (paramDef) { return validParamVal(paramDef, params[paramDef.id]); }).reduce(common_1.allTrueR, true);
	    };
	    /**
	     * Given a set of parameter values, creates a URL from this UrlMatcher.
	     *
	     * Creates a URL that matches this pattern by substituting the specified values
	     * for the path and search parameters.
	     *
	     * #### Example:
	     * ```js
	     * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	     * // returns '/user/bob?q=yes'
	     * ```
	     *
	     * @param values  the values to substitute for the parameters in this pattern.
	     * @returns the formatted URL (path and optionally search part).
	     */
	    UrlMatcher.prototype.format = function (values) {
	        if (values === void 0) { values = {}; }
	        // Build the full path of UrlMatchers (including all parent UrlMatchers)
	        var urlMatchers = this._cache.path;
	        // Extract all the static segments and Params (processed as ParamDetails)
	        // into an ordered array
	        var pathSegmentsAndParams = urlMatchers
	            .map(UrlMatcher.pathSegmentsAndParams)
	            .reduce(common_1.unnestR, [])
	            .map(function (x) { return (predicates_1.isString(x) ? x : getDetails(x)); });
	        // Extract the query params into a separate array
	        var queryParams = urlMatchers
	            .map(UrlMatcher.queryParams)
	            .reduce(common_1.unnestR, [])
	            .map(getDetails);
	        var isInvalid = function (param) { return param.isValid === false; };
	        if (pathSegmentsAndParams.concat(queryParams).filter(isInvalid).length) {
	            return null;
	        }
	        /**
	         * Given a Param, applies the parameter value, then returns detailed information about it
	         */
	        function getDetails(param) {
	            // Normalize to typed value
	            var value = param.value(values[param.id]);
	            var isValid = param.validates(value);
	            var isDefaultValue = param.isDefaultValue(value);
	            // Check if we're in squash mode for the parameter
	            var squash = isDefaultValue ? param.squash : false;
	            // Allow the Parameter's Type to encode the value
	            var encoded = param.type.encode(value);
	            return { param: param, value: value, isValid: isValid, isDefaultValue: isDefaultValue, squash: squash, encoded: encoded };
	        }
	        // Build up the path-portion from the list of static segments and parameters
	        var pathString = pathSegmentsAndParams.reduce(function (acc, x) {
	            // The element is a static segment (a raw string); just append it
	            if (predicates_1.isString(x))
	                return acc + x;
	            // Otherwise, it's a ParamDetails.
	            var squash = x.squash, encoded = x.encoded, param = x.param;
	            // If squash is === true, try to remove a slash from the path
	            if (squash === true)
	                return acc.match(/\/$/) ? acc.slice(0, -1) : acc;
	            // If squash is a string, use the string for the param value
	            if (predicates_1.isString(squash))
	                return acc + squash;
	            if (squash !== false)
	                return acc; // ?
	            if (encoded == null)
	                return acc;
	            // If this parameter value is an array, encode the value using encodeDashes
	            if (predicates_1.isArray(encoded))
	                return acc + common_1.map(encoded, UrlMatcher.encodeDashes).join('-');
	            // If the parameter type is "raw", then do not encodeURIComponent
	            if (param.raw)
	                return acc + encoded;
	            // Encode the value
	            return acc + encodeURIComponent(encoded);
	        }, '');
	        // Build the query string by applying parameter values (array or regular)
	        // then mapping to key=value, then flattening and joining using "&"
	        var queryString = queryParams
	            .map(function (paramDetails) {
	            var param = paramDetails.param, squash = paramDetails.squash, encoded = paramDetails.encoded, isDefaultValue = paramDetails.isDefaultValue;
	            if (encoded == null || (isDefaultValue && squash !== false))
	                return;
	            if (!predicates_1.isArray(encoded))
	                encoded = [encoded];
	            if (encoded.length === 0)
	                return;
	            if (!param.raw)
	                encoded = common_1.map(encoded, encodeURIComponent);
	            return encoded.map(function (val) { return param.id + "=" + val; });
	        })
	            .filter(common_1.identity)
	            .reduce(common_1.unnestR, [])
	            .join('&');
	        // Concat the pathstring with the queryString (if exists) and the hashString (if exists)
	        return pathString + (queryString ? "?" + queryString : '') + (values['#'] ? '#' + values['#'] : '');
	    };
	    /** @internal */
	    UrlMatcher.nameValidator = /^\w+([-.]+\w+)*(?:\[\])?$/;
	    return UrlMatcher;
	}());
	exports.UrlMatcher = UrlMatcher;
	//# sourceMappingURL=urlMatcher.js.map

/***/ },

/***/ 24:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BaseLocationServices = void 0;
	var common_1 = __webpack_require__(7);
	var utils_1 = __webpack_require__(39);
	/** A base `LocationServices` */
	var BaseLocationServices = /** @class */ (function () {
	    function BaseLocationServices(router, fireAfterUpdate) {
	        var _this = this;
	        this.fireAfterUpdate = fireAfterUpdate;
	        this._listeners = [];
	        this._listener = function (evt) { return _this._listeners.forEach(function (cb) { return cb(evt); }); };
	        this.hash = function () { return utils_1.parseUrl(_this._get()).hash; };
	        this.path = function () { return utils_1.parseUrl(_this._get()).path; };
	        this.search = function () { return utils_1.getParams(utils_1.parseUrl(_this._get()).search); };
	        this._location = common_1.root.location;
	        this._history = common_1.root.history;
	    }
	    BaseLocationServices.prototype.url = function (url, replace) {
	        if (replace === void 0) { replace = true; }
	        if (common_1.isDefined(url) && url !== this._get()) {
	            this._set(null, null, url, replace);
	            if (this.fireAfterUpdate) {
	                this._listeners.forEach(function (cb) { return cb({ url: url }); });
	            }
	        }
	        return utils_1.buildUrl(this);
	    };
	    BaseLocationServices.prototype.onChange = function (cb) {
	        var _this = this;
	        this._listeners.push(cb);
	        return function () { return common_1.removeFrom(_this._listeners, cb); };
	    };
	    BaseLocationServices.prototype.dispose = function (router) {
	        common_1.deregAll(this._listeners);
	    };
	    return BaseLocationServices;
	}());
	exports.BaseLocationServices = BaseLocationServices;
	//# sourceMappingURL=baseLocationService.js.map

/***/ },

/***/ 28:
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Glob = void 0;
	/**
	 * Matches state names using glob-like pattern strings.
	 *
	 * Globs can be used in specific APIs including:
	 *
	 * - [[StateService.is]]
	 * - [[StateService.includes]]
	 * - The first argument to Hook Registration functions like [[TransitionService.onStart]]
	 *    - [[HookMatchCriteria]] and [[HookMatchCriterion]]
	 *
	 * A `Glob` string is a pattern which matches state names.
	 * Nested state names are split into segments (separated by a dot) when processing.
	 * The state named `foo.bar.baz` is split into three segments ['foo', 'bar', 'baz']
	 *
	 * Globs work according to the following rules:
	 *
	 * ### Exact match:
	 *
	 * The glob `'A.B'` matches the state named exactly `'A.B'`.
	 *
	 * | Glob        |Matches states named|Does not match state named|
	 * |:------------|:--------------------|:---------------------|
	 * | `'A'`       | `'A'`               | `'B'` , `'A.C'`      |
	 * | `'A.B'`     | `'A.B'`             | `'A'` , `'A.B.C'`    |
	 * | `'foo'`     | `'foo'`             | `'FOO'` , `'foo.bar'`|
	 *
	 * ### Single star (`*`)
	 *
	 * A single star (`*`) is a wildcard that matches exactly one segment.
	 *
	 * | Glob        |Matches states named  |Does not match state named |
	 * |:------------|:---------------------|:--------------------------|
	 * | `'*'`       | `'A'` , `'Z'`        | `'A.B'` , `'Z.Y.X'`       |
	 * | `'A.*'`     | `'A.B'` , `'A.C'`    | `'A'` , `'A.B.C'`         |
	 * | `'A.*.*'`   | `'A.B.C'` , `'A.X.Y'`| `'A'`, `'A.B'` , `'Z.Y.X'`|
	 *
	 * ### Double star (`**`)
	 *
	 * A double star (`'**'`) is a wildcard that matches *zero or more segments*
	 *
	 * | Glob        |Matches states named                           |Does not match state named         |
	 * |:------------|:----------------------------------------------|:----------------------------------|
	 * | `'**'`      | `'A'` , `'A.B'`, `'Z.Y.X'`                    | (matches all states)              |
	 * | `'A.**'`    | `'A'` , `'A.B'` , `'A.C.X'`                   | `'Z.Y.X'`                         |
	 * | `'**.X'`    | `'X'` , `'A.X'` , `'Z.Y.X'`                   | `'A'` , `'A.login.Z'`             |
	 * | `'A.**.X'`  | `'A.X'` , `'A.B.X'` , `'A.B.C.X'`             | `'A'` , `'A.B.C'`                 |
	 *
	 * @packageDocumentation
	 */
	var Glob = /** @class */ (function () {
	    function Glob(text) {
	        this.text = text;
	        this.glob = text.split('.');
	        var regexpString = this.text
	            .split('.')
	            .map(function (seg) {
	            if (seg === '**')
	                return '(?:|(?:\\.[^.]*)*)';
	            if (seg === '*')
	                return '\\.[^.]*';
	            return '\\.' + seg;
	        })
	            .join('');
	        this.regexp = new RegExp('^' + regexpString + '$');
	    }
	    /** Returns true if the string has glob-like characters in it */
	    Glob.is = function (text) {
	        return !!/[!,*]+/.exec(text);
	    };
	    /** Returns a glob from the string, or null if the string isn't Glob-like */
	    Glob.fromString = function (text) {
	        return Glob.is(text) ? new Glob(text) : null;
	    };
	    Glob.prototype.matches = function (name) {
	        return this.regexp.test('.' + name);
	    };
	    return Glob;
	}());
	exports.Glob = Glob;
	//# sourceMappingURL=glob.js.map

/***/ },

/***/ 29:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Queue = void 0;
	var common_1 = __webpack_require__(4);
	var Queue = /** @class */ (function () {
	    function Queue(_items, _limit) {
	        if (_items === void 0) { _items = []; }
	        if (_limit === void 0) { _limit = null; }
	        this._items = _items;
	        this._limit = _limit;
	        this._evictListeners = [];
	        this.onEvict = common_1.pushTo(this._evictListeners);
	    }
	    Queue.prototype.enqueue = function (item) {
	        var items = this._items;
	        items.push(item);
	        if (this._limit && items.length > this._limit)
	            this.evict();
	        return item;
	    };
	    Queue.prototype.evict = function () {
	        var item = this._items.shift();
	        this._evictListeners.forEach(function (fn) { return fn(item); });
	        return item;
	    };
	    Queue.prototype.dequeue = function () {
	        if (this.size())
	            return this._items.splice(0, 1)[0];
	    };
	    Queue.prototype.clear = function () {
	        var current = this._items;
	        this._items = [];
	        return current;
	    };
	    Queue.prototype.size = function () {
	        return this._items.length;
	    };
	    Queue.prototype.remove = function (item) {
	        var idx = this._items.indexOf(item);
	        return idx > -1 && this._items.splice(idx, 1)[0];
	    };
	    Queue.prototype.peekTail = function () {
	        return this._items[this._items.length - 1];
	    };
	    Queue.prototype.peekHead = function () {
	        if (this.size())
	            return this._items[0];
	    };
	    return Queue;
	}());
	exports.Queue = Queue;
	//# sourceMappingURL=queue.js.map

/***/ },

/***/ 30:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * This module contains code for State Parameters.
	 *
	 * See [[ParamDeclaration]]
	 *
	 * @packageDocumentation @preferred
	 */
	__exportStar(__webpack_require__(109), exports);
	__exportStar(__webpack_require__(15), exports);
	__exportStar(__webpack_require__(110), exports);
	__exportStar(__webpack_require__(50), exports);
	__exportStar(__webpack_require__(31), exports);
	//# sourceMappingURL=index.js.map

/***/ },

/***/ 31:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParamType = void 0;
	var common_1 = __webpack_require__(4);
	var predicates_1 = __webpack_require__(5);
	/**
	 * An internal class which implements [[ParamTypeDefinition]].
	 *
	 * A [[ParamTypeDefinition]] is a plain javascript object used to register custom parameter types.
	 * When a param type definition is registered, an instance of this class is created internally.
	 *
	 * This class has naive implementations for all the [[ParamTypeDefinition]] methods.
	 *
	 * Used by [[UrlMatcher]] when matching or formatting URLs, or comparing and validating parameter values.
	 *
	 * #### Example:
	 * ```js
	 * var paramTypeDef = {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) && isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 *
	 * var paramType = new ParamType(paramTypeDef);
	 * ```
	 */
	var ParamType = /** @class */ (function () {
	    /**
	     * @param def  A configuration object which contains the custom type definition.  The object's
	     *        properties will override the default methods and/or pattern in `ParamType`'s public interface.
	     * @returns a new ParamType object
	     */
	    function ParamType(def) {
	        /** @inheritdoc */
	        this.pattern = /.*/;
	        /** @inheritdoc */
	        this.inherit = true;
	        common_1.extend(this, def);
	    }
	    // consider these four methods to be "abstract methods" that should be overridden
	    /** @inheritdoc */
	    ParamType.prototype.is = function (val, key) {
	        return true;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.encode = function (val, key) {
	        return val;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.decode = function (val, key) {
	        return val;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.equals = function (a, b) {
	        // tslint:disable-next-line:triple-equals
	        return a == b;
	    };
	    ParamType.prototype.$subPattern = function () {
	        var sub = this.pattern.toString();
	        return sub.substr(1, sub.length - 2);
	    };
	    ParamType.prototype.toString = function () {
	        return "{ParamType:" + this.name + "}";
	    };
	    /** Given an encoded string, or a decoded object, returns a decoded object */
	    ParamType.prototype.$normalize = function (val) {
	        return this.is(val) ? val : this.decode(val);
	    };
	    /**
	     * Wraps an existing custom ParamType as an array of ParamType, depending on 'mode'.
	     * e.g.:
	     * - urlmatcher pattern "/path?{queryParam[]:int}"
	     * - url: "/path?queryParam=1&queryParam=2
	     * - $stateParams.queryParam will be [1, 2]
	     * if `mode` is "auto", then
	     * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	     * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	     */
	    ParamType.prototype.$asArray = function (mode, isSearch) {
	        if (!mode)
	            return this;
	        if (mode === 'auto' && !isSearch)
	            throw new Error("'auto' array mode is for query parameters only");
	        return new ArrayType(this, mode);
	    };
	    return ParamType;
	}());
	exports.ParamType = ParamType;
	/** Wraps up a `ParamType` object to handle array values. */
	function ArrayType(type, mode) {
	    var _this = this;
	    // Wrap non-array value as array
	    function arrayWrap(val) {
	        return predicates_1.isArray(val) ? val : predicates_1.isDefined(val) ? [val] : [];
	    }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	        switch (val.length) {
	            case 0:
	                return undefined;
	            case 1:
	                return mode === 'auto' ? val[0] : val;
	            default:
	                return val;
	        }
	    }
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	        return function handleArray(val) {
	            if (predicates_1.isArray(val) && val.length === 0)
	                return val;
	            var arr = arrayWrap(val);
	            var result = common_1.map(arr, callback);
	            return allTruthyMode === true ? common_1.filter(result, function (x) { return !x; }).length === 0 : arrayUnwrap(result);
	        };
	    }
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	        return function handleArray(val1, val2) {
	            var left = arrayWrap(val1), right = arrayWrap(val2);
	            if (left.length !== right.length)
	                return false;
	            for (var i = 0; i < left.length; i++) {
	                if (!callback(left[i], right[i]))
	                    return false;
	            }
	            return true;
	        };
	    }
	    ['encode', 'decode', 'equals', '$normalize'].forEach(function (name) {
	        var paramTypeFn = type[name].bind(type);
	        var wrapperFn = name === 'equals' ? arrayEqualsHandler : arrayHandler;
	        _this[name] = wrapperFn(paramTypeFn);
	    });
	    common_1.extend(this, {
	        dynamic: type.dynamic,
	        name: type.name,
	        pattern: type.pattern,
	        inherit: type.inherit,
	        raw: type.raw,
	        is: arrayHandler(type.is.bind(type), true),
	        $arrayMode: mode,
	    });
	}
	//# sourceMappingURL=paramType.js.map

/***/ },

/***/ 32:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PathNode = void 0;
	var common_1 = __webpack_require__(4);
	var hof_1 = __webpack_require__(6);
	var param_1 = __webpack_require__(15);
	/**
	 * A node in a [[TreeChanges]] path
	 *
	 * For a [[TreeChanges]] path, this class holds the stateful information for a single node in the path.
	 * Each PathNode corresponds to a state being entered, exited, or retained.
	 * The stateful information includes parameter values and resolve data.
	 */
	var PathNode = /** @class */ (function () {
	    function PathNode(stateOrNode) {
	        if (stateOrNode instanceof PathNode) {
	            var node = stateOrNode;
	            this.state = node.state;
	            this.paramSchema = node.paramSchema.slice();
	            this.paramValues = common_1.extend({}, node.paramValues);
	            this.resolvables = node.resolvables.slice();
	            this.views = node.views && node.views.slice();
	        }
	        else {
	            var state = stateOrNode;
	            this.state = state;
	            this.paramSchema = state.parameters({ inherit: false });
	            this.paramValues = {};
	            this.resolvables = state.resolvables.map(function (res) { return res.clone(); });
	        }
	    }
	    PathNode.prototype.clone = function () {
	        return new PathNode(this);
	    };
	    /** Sets [[paramValues]] for the node, from the values of an object hash */
	    PathNode.prototype.applyRawParams = function (params) {
	        var getParamVal = function (paramDef) { return [paramDef.id, paramDef.value(params[paramDef.id])]; };
	        this.paramValues = this.paramSchema.reduce(function (memo, pDef) { return common_1.applyPairs(memo, getParamVal(pDef)); }, {});
	        return this;
	    };
	    /** Gets a specific [[Param]] metadata that belongs to the node */
	    PathNode.prototype.parameter = function (name) {
	        return common_1.find(this.paramSchema, hof_1.propEq('id', name));
	    };
	    /**
	     * @returns true if the state and parameter values for another PathNode are
	     * equal to the state and param values for this PathNode
	     */
	    PathNode.prototype.equals = function (node, paramsFn) {
	        var diff = this.diff(node, paramsFn);
	        return diff && diff.length === 0;
	    };
	    /**
	     * Finds Params with different parameter values on another PathNode.
	     *
	     * Given another node (of the same state), finds the parameter values which differ.
	     * Returns the [[Param]] (schema objects) whose parameter values differ.
	     *
	     * Given another node for a different state, returns `false`
	     *
	     * @param node The node to compare to
	     * @param paramsFn A function that returns which parameters should be compared.
	     * @returns The [[Param]]s which differ, or null if the two nodes are for different states
	     */
	    PathNode.prototype.diff = function (node, paramsFn) {
	        if (this.state !== node.state)
	            return false;
	        var params = paramsFn ? paramsFn(this) : this.paramSchema;
	        return param_1.Param.changed(params, this.paramValues, node.paramValues);
	    };
	    /**
	     * Returns a clone of the PathNode
	     * @deprecated use instance method `node.clone()`
	     */
	    PathNode.clone = function (node) { return node.clone(); };
	    return PathNode;
	}());
	exports.PathNode = PathNode;
	//# sourceMappingURL=pathNode.js.map

/***/ },

/***/ 33:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * # The state subsystem
	 *
	 * This subsystem implements the ui-router state tree
	 *
	 * - The [[StateService]] has state-related service methods such as:
	 *   - [[StateService.get]]: Get a registered [[StateDeclaration]] object
	 *   - [[StateService.go]]: Transition from the current state to a new state
	 *   - [[StateService.reload]]: Reload the current state
	 *   - [[StateService.target]]: Get a [[TargetState]] (useful when redirecting from a Transition Hook)
	 *   - [[StateService.onInvalid]]: Register a callback for when a transition to an invalid state is started
	 *   - [[StateService.defaultErrorHandler]]: Register a global callback for when a transition errors
	 * - The [[StateDeclaration]] interface defines the shape of a state declaration
	 * - The [[StateRegistry]] contains all the registered states
	 *   - States can be added/removed using the [[StateRegistry.register]] and [[StateRegistry.deregister]]
	 *     - Note: Bootstrap state registration differs by front-end framework.
	 *   - Get notified of state registration/deregistration using [[StateRegistry.onStatesChanged]].
	 *
	 * @packageDocumentation
	 */
	__exportStar(__webpack_require__(112), exports);
	__exportStar(__webpack_require__(54), exports);
	__exportStar(__webpack_require__(34), exports);
	__exportStar(__webpack_require__(55), exports);
	__exportStar(__webpack_require__(56), exports);
	__exportStar(__webpack_require__(57), exports);
	__exportStar(__webpack_require__(58), exports);
	__exportStar(__webpack_require__(16), exports);
	//# sourceMappingURL=index.js.map

/***/ },

/***/ 34:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateObject = void 0;
	var common_1 = __webpack_require__(4);
	var hof_1 = __webpack_require__(6);
	var glob_1 = __webpack_require__(28);
	var predicates_1 = __webpack_require__(5);
	/**
	 * Internal representation of a UI-Router state.
	 *
	 * Instances of this class are created when a [[StateDeclaration]] is registered with the [[StateRegistry]].
	 *
	 * A registered [[StateDeclaration]] is augmented with a getter ([[StateDeclaration.$$state]]) which returns the corresponding [[StateObject]] object.
	 *
	 * This class prototypally inherits from the corresponding [[StateDeclaration]].
	 * Each of its own properties (i.e., `hasOwnProperty`) are built using builders from the [[StateBuilder]].
	 */
	var StateObject = /** @class */ (function () {
	    /** @deprecated use State.create() */
	    function StateObject(config) {
	        return StateObject.create(config || {});
	    }
	    /**
	     * Create a state object to put the private/internal implementation details onto.
	     * The object's prototype chain looks like:
	     * (Internal State Object) -> (Copy of State.prototype) -> (State Declaration object) -> (State Declaration's prototype...)
	     *
	     * @param stateDecl the user-supplied State Declaration
	     * @returns {StateObject} an internal State object
	     */
	    StateObject.create = function (stateDecl) {
	        stateDecl = StateObject.isStateClass(stateDecl) ? new stateDecl() : stateDecl;
	        var state = common_1.inherit(common_1.inherit(stateDecl, StateObject.prototype));
	        stateDecl.$$state = function () { return state; };
	        state.self = stateDecl;
	        state.__stateObjectCache = {
	            nameGlob: glob_1.Glob.fromString(state.name),
	        };
	        return state;
	    };
	    /**
	     * Returns true if the provided parameter is the same state.
	     *
	     * Compares the identity of the state against the passed value, which is either an object
	     * reference to the actual `State` instance, the original definition object passed to
	     * `$stateProvider.state()`, or the fully-qualified name.
	     *
	     * @param ref Can be one of (a) a `State` instance, (b) an object that was passed
	     *        into `$stateProvider.state()`, (c) the fully-qualified name of a state as a string.
	     * @returns Returns `true` if `ref` matches the current `State` instance.
	     */
	    StateObject.prototype.is = function (ref) {
	        return this === ref || this.self === ref || this.fqn() === ref;
	    };
	    /**
	     * @deprecated this does not properly handle dot notation
	     * @returns Returns a dot-separated name of the state.
	     */
	    StateObject.prototype.fqn = function () {
	        if (!this.parent || !(this.parent instanceof this.constructor))
	            return this.name;
	        var name = this.parent.fqn();
	        return name ? name + '.' + this.name : this.name;
	    };
	    /**
	     * Returns the root node of this state's tree.
	     *
	     * @returns The root of this state's tree.
	     */
	    StateObject.prototype.root = function () {
	        return (this.parent && this.parent.root()) || this;
	    };
	    /**
	     * Gets the state's `Param` objects
	     *
	     * Gets the list of [[Param]] objects owned by the state.
	     * If `opts.inherit` is true, it also includes the ancestor states' [[Param]] objects.
	     * If `opts.matchingKeys` exists, returns only `Param`s whose `id` is a key on the `matchingKeys` object
	     *
	     * @param opts options
	     */
	    StateObject.prototype.parameters = function (opts) {
	        opts = common_1.defaults(opts, { inherit: true, matchingKeys: null });
	        var inherited = (opts.inherit && this.parent && this.parent.parameters()) || [];
	        return inherited
	            .concat(common_1.values(this.params))
	            .filter(function (param) { return !opts.matchingKeys || opts.matchingKeys.hasOwnProperty(param.id); });
	    };
	    /**
	     * Returns a single [[Param]] that is owned by the state
	     *
	     * If `opts.inherit` is true, it also searches the ancestor states` [[Param]]s.
	     * @param id the name of the [[Param]] to return
	     * @param opts options
	     */
	    StateObject.prototype.parameter = function (id, opts) {
	        if (opts === void 0) { opts = {}; }
	        return ((this.url && this.url.parameter(id, opts)) ||
	            common_1.find(common_1.values(this.params), hof_1.propEq('id', id)) ||
	            (opts.inherit && this.parent && this.parent.parameter(id)));
	    };
	    StateObject.prototype.toString = function () {
	        return this.fqn();
	    };
	    /** Predicate which returns true if the object is an class with @State() decorator */
	    StateObject.isStateClass = function (stateDecl) {
	        return predicates_1.isFunction(stateDecl) && stateDecl['__uiRouterState'] === true;
	    };
	    /** Predicate which returns true if the object is a [[StateDeclaration]] object */
	    StateObject.isStateDeclaration = function (obj) { return predicates_1.isFunction(obj['$$state']); };
	    /** Predicate which returns true if the object is an internal [[StateObject]] object */
	    StateObject.isState = function (obj) { return predicates_1.isObject(obj['__stateObjectCache']); };
	    return StateObject;
	}());
	exports.StateObject = StateObject;
	//# sourceMappingURL=stateObject.js.map

/***/ },

/***/ 35:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.makeEvent = exports.RegisteredHook = exports.matchState = void 0;
	var common_1 = __webpack_require__(7);
	var interface_1 = __webpack_require__(13);
	/**
	 * Determines if the given state matches the matchCriteria
	 *
	 * @internal
	 *
	 * @param state a State Object to test against
	 * @param criterion
	 * - If a string, matchState uses the string as a glob-matcher against the state name
	 * - If an array (of strings), matchState uses each string in the array as a glob-matchers against the state name
	 *   and returns a positive match if any of the globs match.
	 * - If a function, matchState calls the function with the state and returns true if the function's result is truthy.
	 * @returns {boolean}
	 */
	function matchState(state, criterion, transition) {
	    var toMatch = common_1.isString(criterion) ? [criterion] : criterion;
	    function matchGlobs(_state) {
	        var globStrings = toMatch;
	        for (var i = 0; i < globStrings.length; i++) {
	            var glob = new common_1.Glob(globStrings[i]);
	            if ((glob && glob.matches(_state.name)) || (!glob && globStrings[i] === _state.name)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    var matchFn = (common_1.isFunction(toMatch) ? toMatch : matchGlobs);
	    return !!matchFn(state, transition);
	}
	exports.matchState = matchState;
	/**
	 * The registration data for a registered transition hook
	 */
	var RegisteredHook = /** @class */ (function () {
	    function RegisteredHook(tranSvc, eventType, callback, matchCriteria, removeHookFromRegistry, options) {
	        if (options === void 0) { options = {}; }
	        this.tranSvc = tranSvc;
	        this.eventType = eventType;
	        this.callback = callback;
	        this.matchCriteria = matchCriteria;
	        this.removeHookFromRegistry = removeHookFromRegistry;
	        this.invokeCount = 0;
	        this._deregistered = false;
	        this.priority = options.priority || 0;
	        this.bind = options.bind || null;
	        this.invokeLimit = options.invokeLimit;
	    }
	    /**
	     * Gets the matching [[PathNode]]s
	     *
	     * Given an array of [[PathNode]]s, and a [[HookMatchCriterion]], returns an array containing
	     * the [[PathNode]]s that the criteria matches, or `null` if there were no matching nodes.
	     *
	     * Returning `null` is significant to distinguish between the default
	     * "match-all criterion value" of `true` compared to a `() => true` function,
	     * when the nodes is an empty array.
	     *
	     * This is useful to allow a transition match criteria of `entering: true`
	     * to still match a transition, even when `entering === []`.  Contrast that
	     * with `entering: (state) => true` which only matches when a state is actually
	     * being entered.
	     */
	    RegisteredHook.prototype._matchingNodes = function (nodes, criterion, transition) {
	        if (criterion === true)
	            return nodes;
	        var matching = nodes.filter(function (node) { return matchState(node.state, criterion, transition); });
	        return matching.length ? matching : null;
	    };
	    /**
	     * Gets the default match criteria (all `true`)
	     *
	     * Returns an object which has all the criteria match paths as keys and `true` as values, i.e.:
	     *
	     * ```js
	     * {
	     *   to: true,
	     *   from: true,
	     *   entering: true,
	     *   exiting: true,
	     *   retained: true,
	     * }
	     */
	    RegisteredHook.prototype._getDefaultMatchCriteria = function () {
	        return common_1.mapObj(this.tranSvc._pluginapi._getPathTypes(), function () { return true; });
	    };
	    /**
	     * Gets matching nodes as [[IMatchingNodes]]
	     *
	     * Create a IMatchingNodes object from the TransitionHookTypes that is roughly equivalent to:
	     *
	     * ```js
	     * let matches: IMatchingNodes = {
	     *   to:       _matchingNodes([tail(treeChanges.to)],   mc.to),
	     *   from:     _matchingNodes([tail(treeChanges.from)], mc.from),
	     *   exiting:  _matchingNodes(treeChanges.exiting,      mc.exiting),
	     *   retained: _matchingNodes(treeChanges.retained,     mc.retained),
	     *   entering: _matchingNodes(treeChanges.entering,     mc.entering),
	     * };
	     * ```
	     */
	    RegisteredHook.prototype._getMatchingNodes = function (treeChanges, transition) {
	        var _this = this;
	        var criteria = common_1.extend(this._getDefaultMatchCriteria(), this.matchCriteria);
	        var paths = common_1.values(this.tranSvc._pluginapi._getPathTypes());
	        return paths.reduce(function (mn, pathtype) {
	            // STATE scope criteria matches against every node in the path.
	            // TRANSITION scope criteria matches against only the last node in the path
	            var isStateHook = pathtype.scope === interface_1.TransitionHookScope.STATE;
	            var path = treeChanges[pathtype.name] || [];
	            var nodes = isStateHook ? path : [common_1.tail(path)];
	            mn[pathtype.name] = _this._matchingNodes(nodes, criteria[pathtype.name], transition);
	            return mn;
	        }, {});
	    };
	    /**
	     * Determines if this hook's [[matchCriteria]] match the given [[TreeChanges]]
	     *
	     * @returns an IMatchingNodes object, or null. If an IMatchingNodes object is returned, its values
	     * are the matching [[PathNode]]s for each [[HookMatchCriterion]] (to, from, exiting, retained, entering)
	     */
	    RegisteredHook.prototype.matches = function (treeChanges, transition) {
	        var matches = this._getMatchingNodes(treeChanges, transition);
	        // Check if all the criteria matched the TreeChanges object
	        var allMatched = common_1.values(matches).every(common_1.identity);
	        return allMatched ? matches : null;
	    };
	    RegisteredHook.prototype.deregister = function () {
	        this.removeHookFromRegistry(this);
	        this._deregistered = true;
	    };
	    return RegisteredHook;
	}());
	exports.RegisteredHook = RegisteredHook;
	/** Return a registration function of the requested type. */
	function makeEvent(registry, transitionService, eventType) {
	    // Create the object which holds the registered transition hooks.
	    var _registeredHooks = (registry._registeredHooks = registry._registeredHooks || {});
	    var hooks = (_registeredHooks[eventType.name] = []);
	    var removeHookFn = common_1.removeFrom(hooks);
	    // Create hook registration function on the IHookRegistry for the event
	    registry[eventType.name] = hookRegistrationFn;
	    function hookRegistrationFn(matchObject, callback, options) {
	        if (options === void 0) { options = {}; }
	        var registeredHook = new RegisteredHook(transitionService, eventType, callback, matchObject, removeHookFn, options);
	        hooks.push(registeredHook);
	        return registeredHook.deregister.bind(registeredHook);
	    }
	    return hookRegistrationFn;
	}
	exports.makeEvent = makeEvent;
	//# sourceMappingURL=hookRegistry.js.map

/***/ },

/***/ 36:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Transition = void 0;
	var trace_1 = __webpack_require__(12);
	var coreservices_1 = __webpack_require__(8);
	var strings_1 = __webpack_require__(10);
	var common_1 = __webpack_require__(4);
	var predicates_1 = __webpack_require__(5);
	var hof_1 = __webpack_require__(6);
	var interface_1 = __webpack_require__(13); // has or is using
	var transitionHook_1 = __webpack_require__(17);
	var hookRegistry_1 = __webpack_require__(35);
	var hookBuilder_1 = __webpack_require__(59);
	var pathUtils_1 = __webpack_require__(20);
	var param_1 = __webpack_require__(15);
	var resolvable_1 = __webpack_require__(21);
	var resolveContext_1 = __webpack_require__(22);
	var rejectFactory_1 = __webpack_require__(14);
	var common_2 = __webpack_require__(7);
	/** @internal */
	var stateSelf = hof_1.prop('self');
	/**
	 * Represents a transition between two states.
	 *
	 * When navigating to a state, we are transitioning **from** the current state **to** the new state.
	 *
	 * This object contains all contextual information about the to/from states, parameters, resolves.
	 * It has information about all states being entered and exited as a result of the transition.
	 */
	var Transition = /** @class */ (function () {
	    /**
	     * Creates a new Transition object.
	     *
	     * If the target state is not valid, an error is thrown.
	     *
	     * @internal
	     *
	     * @param fromPath The path of [[PathNode]]s from which the transition is leaving.  The last node in the `fromPath`
	     *        encapsulates the "from state".
	     * @param targetState The target state and parameters being transitioned to (also, the transition options)
	     * @param router The [[UIRouter]] instance
	     * @internal
	     */
	    function Transition(fromPath, targetState, router) {
	        var _this = this;
	        /** @internal */
	        this._deferred = coreservices_1.services.$q.defer();
	        /**
	         * This promise is resolved or rejected based on the outcome of the Transition.
	         *
	         * When the transition is successful, the promise is resolved
	         * When the transition is unsuccessful, the promise is rejected with the [[Rejection]] or javascript error
	         */
	        this.promise = this._deferred.promise;
	        /** @internal Holds the hook registration functions such as those passed to Transition.onStart() */
	        this._registeredHooks = {};
	        /** @internal */
	        this._hookBuilder = new hookBuilder_1.HookBuilder(this);
	        /** Checks if this transition is currently active/running. */
	        this.isActive = function () { return _this.router.globals.transition === _this; };
	        this.router = router;
	        this._targetState = targetState;
	        if (!targetState.valid()) {
	            throw new Error(targetState.error());
	        }
	        // current() is assumed to come from targetState.options, but provide a naive implementation otherwise.
	        this._options = common_1.extend({ current: hof_1.val(this) }, targetState.options());
	        this.$id = router.transitionService._transitionCount++;
	        var toPath = pathUtils_1.PathUtils.buildToPath(fromPath, targetState);
	        this._treeChanges = pathUtils_1.PathUtils.treeChanges(fromPath, toPath, this._options.reloadState);
	        this.createTransitionHookRegFns();
	        var onCreateHooks = this._hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.CREATE);
	        transitionHook_1.TransitionHook.invokeHooks(onCreateHooks, function () { return null; });
	        this.applyViewConfigs(router);
	    }
	    /** @internal */
	    Transition.prototype.onBefore = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onStart = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onExit = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onRetain = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onEnter = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onFinish = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onSuccess = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onError = function (criteria, callback, options) {
	        return;
	    };
	    /** @internal
	     * Creates the transition-level hook registration functions
	     * (which can then be used to register hooks)
	     */
	    Transition.prototype.createTransitionHookRegFns = function () {
	        var _this = this;
	        this.router.transitionService._pluginapi
	            ._getEvents()
	            .filter(function (type) { return type.hookPhase !== interface_1.TransitionHookPhase.CREATE; })
	            .forEach(function (type) { return hookRegistry_1.makeEvent(_this, _this.router.transitionService, type); });
	    };
	    /** @internal */
	    Transition.prototype.getHooks = function (hookName) {
	        return this._registeredHooks[hookName];
	    };
	    Transition.prototype.applyViewConfigs = function (router) {
	        var enteringStates = this._treeChanges.entering.map(function (node) { return node.state; });
	        pathUtils_1.PathUtils.applyViewConfigs(router.transitionService.$view, this._treeChanges.to, enteringStates);
	    };
	    /**
	     * @internal
	     * @returns the internal from [State] object
	     */
	    Transition.prototype.$from = function () {
	        return common_1.tail(this._treeChanges.from).state;
	    };
	    /**
	     * @internal
	     * @returns the internal to [State] object
	     */
	    Transition.prototype.$to = function () {
	        return common_1.tail(this._treeChanges.to).state;
	    };
	    /**
	     * Returns the "from state"
	     *
	     * Returns the state that the transition is coming *from*.
	     *
	     * @returns The state declaration object for the Transition's ("from state").
	     */
	    Transition.prototype.from = function () {
	        return this.$from().self;
	    };
	    /**
	     * Returns the "to state"
	     *
	     * Returns the state that the transition is going *to*.
	     *
	     * @returns The state declaration object for the Transition's target state ("to state").
	     */
	    Transition.prototype.to = function () {
	        return this.$to().self;
	    };
	    /**
	     * Gets the Target State
	     *
	     * A transition's [[TargetState]] encapsulates the [[to]] state, the [[params]], and the [[options]] as a single object.
	     *
	     * @returns the [[TargetState]] of this Transition
	     */
	    Transition.prototype.targetState = function () {
	        return this._targetState;
	    };
	    /**
	     * Determines whether two transitions are equivalent.
	     * @deprecated
	     */
	    Transition.prototype.is = function (compare) {
	        if (compare instanceof Transition) {
	            // TODO: Also compare parameters
	            return this.is({ to: compare.$to().name, from: compare.$from().name });
	        }
	        return !((compare.to && !hookRegistry_1.matchState(this.$to(), compare.to, this)) ||
	            (compare.from && !hookRegistry_1.matchState(this.$from(), compare.from, this)));
	    };
	    Transition.prototype.params = function (pathname) {
	        if (pathname === void 0) { pathname = 'to'; }
	        return Object.freeze(this._treeChanges[pathname].map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}));
	    };
	    Transition.prototype.paramsChanged = function () {
	        var fromParams = this.params('from');
	        var toParams = this.params('to');
	        // All the parameters declared on both the "to" and "from" paths
	        var allParamDescriptors = []
	            .concat(this._treeChanges.to)
	            .concat(this._treeChanges.from)
	            .map(function (pathNode) { return pathNode.paramSchema; })
	            .reduce(common_2.flattenR, [])
	            .reduce(common_2.uniqR, []);
	        var changedParamDescriptors = param_1.Param.changed(allParamDescriptors, fromParams, toParams);
	        return changedParamDescriptors.reduce(function (changedValues, descriptor) {
	            changedValues[descriptor.id] = toParams[descriptor.id];
	            return changedValues;
	        }, {});
	    };
	    /**
	     * Creates a [[UIInjector]] Dependency Injector
	     *
	     * Returns a Dependency Injector for the Transition's target state (to state).
	     * The injector provides resolve values which the target state has access to.
	     *
	     * The `UIInjector` can also provide values from the native root/global injector (ng1/ng2).
	     *
	     * #### Example:
	     * ```js
	     * .onEnter({ entering: 'myState' }, trans => {
	     *   var myResolveValue = trans.injector().get('myResolve');
	     *   // Inject a global service from the global/native injector (if it exists)
	     *   var MyService = trans.injector().get('MyService');
	     * })
	     * ```
	     *
	     * In some cases (such as `onBefore`), you may need access to some resolve data but it has not yet been fetched.
	     * You can use [[UIInjector.getAsync]] to get a promise for the data.
	     * #### Example:
	     * ```js
	     * .onBefore({}, trans => {
	     *   return trans.injector().getAsync('myResolve').then(myResolveValue =>
	     *     return myResolveValue !== 'ABORT';
	     *   });
	     * });
	     * ```
	     *
	     * If a `state` is provided, the injector that is returned will be limited to resolve values that the provided state has access to.
	     * This can be useful if both a parent state `foo` and a child state `foo.bar` have both defined a resolve such as `data`.
	     * #### Example:
	     * ```js
	     * .onEnter({ to: 'foo.bar' }, trans => {
	     *   // returns result of `foo` state's `myResolve` resolve
	     *   // even though `foo.bar` also has a `myResolve` resolve
	     *   var fooData = trans.injector('foo').get('myResolve');
	     * });
	     * ```
	     *
	     * If you need resolve data from the exiting states, pass `'from'` as `pathName`.
	     * The resolve data from the `from` path will be returned.
	     * #### Example:
	     * ```js
	     * .onExit({ exiting: 'foo.bar' }, trans => {
	     *   // Gets the resolve value of `myResolve` from the state being exited
	     *   var fooData = trans.injector(null, 'from').get('myResolve');
	     * });
	     * ```
	     *
	     *
	     * @param state Limits the resolves provided to only the resolves the provided state has access to.
	     * @param pathName Default: `'to'`: Chooses the path for which to create the injector. Use this to access resolves for `exiting` states.
	     *
	     * @returns a [[UIInjector]]
	     */
	    Transition.prototype.injector = function (state, pathName) {
	        if (pathName === void 0) { pathName = 'to'; }
	        var path = this._treeChanges[pathName];
	        if (state)
	            path = pathUtils_1.PathUtils.subPath(path, function (node) { return node.state === state || node.state.name === state; });
	        return new resolveContext_1.ResolveContext(path).injector();
	    };
	    /**
	     * Gets all available resolve tokens (keys)
	     *
	     * This method can be used in conjunction with [[injector]] to inspect the resolve values
	     * available to the Transition.
	     *
	     * This returns all the tokens defined on [[StateDeclaration.resolve]] blocks, for the states
	     * in the Transition's [[TreeChanges.to]] path.
	     *
	     * #### Example:
	     * This example logs all resolve values
	     * ```js
	     * let tokens = trans.getResolveTokens();
	     * tokens.forEach(token => console.log(token + " = " + trans.injector().get(token)));
	     * ```
	     *
	     * #### Example:
	     * This example creates promises for each resolve value.
	     * This triggers fetches of resolves (if any have not yet been fetched).
	     * When all promises have all settled, it logs the resolve values.
	     * ```js
	     * let tokens = trans.getResolveTokens();
	     * let promise = tokens.map(token => trans.injector().getAsync(token));
	     * Promise.all(promises).then(values => console.log("Resolved values: " + values));
	     * ```
	     *
	     * Note: Angular 1 users whould use `$q.all()`
	     *
	     * @param pathname resolve context's path name (e.g., `to` or `from`)
	     *
	     * @returns an array of resolve tokens (keys)
	     */
	    Transition.prototype.getResolveTokens = function (pathname) {
	        if (pathname === void 0) { pathname = 'to'; }
	        return new resolveContext_1.ResolveContext(this._treeChanges[pathname]).getTokens();
	    };
	    /**
	     * Dynamically adds a new [[Resolvable]] (i.e., [[StateDeclaration.resolve]]) to this transition.
	     *
	     * Allows a transition hook to dynamically add a Resolvable to this Transition.
	     *
	     * Use the [[Transition.injector]] to retrieve the resolved data in subsequent hooks ([[UIInjector.get]]).
	     *
	     * If a `state` argument is provided, the Resolvable is processed when that state is being entered.
	     * If no `state` is provided then the root state is used.
	     * If the given `state` has already been entered, the Resolvable is processed when any child state is entered.
	     * If no child states will be entered, the Resolvable is processed during the `onFinish` phase of the Transition.
	     *
	     * The `state` argument also scopes the resolved data.
	     * The resolved data is available from the injector for that `state` and any children states.
	     *
	     * #### Example:
	     * ```js
	     * transitionService.onBefore({}, transition => {
	     *   transition.addResolvable({
	     *     token: 'myResolve',
	     *     deps: ['MyService'],
	     *     resolveFn: myService => myService.getData()
	     *   });
	     * });
	     * ```
	     *
	     * @param resolvable a [[ResolvableLiteral]] object (or a [[Resolvable]])
	     * @param state the state in the "to path" which should receive the new resolve (otherwise, the root state)
	     */
	    Transition.prototype.addResolvable = function (resolvable, state) {
	        if (state === void 0) { state = ''; }
	        resolvable = hof_1.is(resolvable_1.Resolvable)(resolvable) ? resolvable : new resolvable_1.Resolvable(resolvable);
	        var stateName = typeof state === 'string' ? state : state.name;
	        var topath = this._treeChanges.to;
	        var targetNode = common_1.find(topath, function (node) { return node.state.name === stateName; });
	        var resolveContext = new resolveContext_1.ResolveContext(topath);
	        resolveContext.addResolvables([resolvable], targetNode.state);
	    };
	    /**
	     * Gets the transition from which this transition was redirected.
	     *
	     * If the current transition is a redirect, this method returns the transition that was redirected.
	     *
	     * #### Example:
	     * ```js
	     * let transitionA = $state.go('A').transition
	     * transitionA.onStart({}, () => $state.target('B'));
	     * $transitions.onSuccess({ to: 'B' }, (trans) => {
	     *   trans.to().name === 'B'; // true
	     *   trans.redirectedFrom() === transitionA; // true
	     * });
	     * ```
	     *
	     * @returns The previous Transition, or null if this Transition is not the result of a redirection
	     */
	    Transition.prototype.redirectedFrom = function () {
	        return this._options.redirectedFrom || null;
	    };
	    /**
	     * Gets the original transition in a redirect chain
	     *
	     * A transition might belong to a long chain of multiple redirects.
	     * This method walks the [[redirectedFrom]] chain back to the original (first) transition in the chain.
	     *
	     * #### Example:
	     * ```js
	     * // states
	     * registry.register({ name: 'A', redirectTo: 'B' });
	     * registry.register({ name: 'B', redirectTo: 'C' });
	     * registry.register({ name: 'C', redirectTo: 'D' });
	     * registry.register({ name: 'D' });
	     *
	     * let transitionA = $state.go('A').transition
	     *
	     * $transitions.onSuccess({ to: 'D' }, (trans) => {
	     *   trans.to().name === 'D'; // true
	     *   trans.redirectedFrom().to().name === 'C'; // true
	     *   trans.originalTransition() === transitionA; // true
	     *   trans.originalTransition().to().name === 'A'; // true
	     * });
	     * ```
	     *
	     * @returns The original Transition that started a redirect chain
	     */
	    Transition.prototype.originalTransition = function () {
	        var rf = this.redirectedFrom();
	        return (rf && rf.originalTransition()) || this;
	    };
	    /**
	     * Get the transition options
	     *
	     * @returns the options for this Transition.
	     */
	    Transition.prototype.options = function () {
	        return this._options;
	    };
	    /**
	     * Gets the states being entered.
	     *
	     * @returns an array of states that will be entered during this transition.
	     */
	    Transition.prototype.entering = function () {
	        return common_1.map(this._treeChanges.entering, hof_1.prop('state')).map(stateSelf);
	    };
	    /**
	     * Gets the states being exited.
	     *
	     * @returns an array of states that will be exited during this transition.
	     */
	    Transition.prototype.exiting = function () {
	        return common_1.map(this._treeChanges.exiting, hof_1.prop('state')).map(stateSelf).reverse();
	    };
	    /**
	     * Gets the states being retained.
	     *
	     * @returns an array of states that are already entered from a previous Transition, that will not be
	     *    exited during this Transition
	     */
	    Transition.prototype.retained = function () {
	        return common_1.map(this._treeChanges.retained, hof_1.prop('state')).map(stateSelf);
	    };
	    /**
	     * Get the [[ViewConfig]]s associated with this Transition
	     *
	     * Each state can define one or more views (template/controller), which are encapsulated as `ViewConfig` objects.
	     * This method fetches the `ViewConfigs` for a given path in the Transition (e.g., "to" or "entering").
	     *
	     * @param pathname the name of the path to fetch views for:
	     *   (`'to'`, `'from'`, `'entering'`, `'exiting'`, `'retained'`)
	     * @param state If provided, only returns the `ViewConfig`s for a single state in the path
	     *
	     * @returns a list of ViewConfig objects for the given path.
	     */
	    Transition.prototype.views = function (pathname, state) {
	        if (pathname === void 0) { pathname = 'entering'; }
	        var path = this._treeChanges[pathname];
	        path = !state ? path : path.filter(hof_1.propEq('state', state));
	        return path.map(hof_1.prop('views')).filter(common_1.identity).reduce(common_1.unnestR, []);
	    };
	    Transition.prototype.treeChanges = function (pathname) {
	        return pathname ? this._treeChanges[pathname] : this._treeChanges;
	    };
	    /**
	     * Creates a new transition that is a redirection of the current one.
	     *
	     * This transition can be returned from a [[TransitionService]] hook to
	     * redirect a transition to a new state and/or set of parameters.
	     *
	     * @internal
	     *
	     * @returns Returns a new [[Transition]] instance.
	     */
	    Transition.prototype.redirect = function (targetState) {
	        var redirects = 1, trans = this;
	        // tslint:disable-next-line:no-conditional-assignment
	        while ((trans = trans.redirectedFrom()) != null) {
	            if (++redirects > 20)
	                throw new Error("Too many consecutive Transition redirects (20+)");
	        }
	        var redirectOpts = { redirectedFrom: this, source: 'redirect' };
	        // If the original transition was caused by URL sync, then use { location: 'replace' }
	        // on the new transition (unless the target state explicitly specifies location: false).
	        // This causes the original url to be replaced with the url for the redirect target
	        // so the original url disappears from the browser history.
	        if (this.options().source === 'url' && targetState.options().location !== false) {
	            redirectOpts.location = 'replace';
	        }
	        var newOptions = common_1.extend({}, this.options(), targetState.options(), redirectOpts);
	        targetState = targetState.withOptions(newOptions, true);
	        var newTransition = this.router.transitionService.create(this._treeChanges.from, targetState);
	        var originalEnteringNodes = this._treeChanges.entering;
	        var redirectEnteringNodes = newTransition._treeChanges.entering;
	        // --- Re-use resolve data from original transition ---
	        // When redirecting from a parent state to a child state where the parent parameter values haven't changed
	        // (because of the redirect), the resolves fetched by the original transition are still valid in the
	        // redirected transition.
	        //
	        // This allows you to define a redirect on a parent state which depends on an async resolve value.
	        // You can wait for the resolve, then redirect to a child state based on the result.
	        // The redirected transition does not have to re-fetch the resolve.
	        // ---------------------------------------------------------
	        var nodeIsReloading = function (reloadState) { return function (node) {
	            return reloadState && node.state.includes[reloadState.name];
	        }; };
	        // Find any "entering" nodes in the redirect path that match the original path and aren't being reloaded
	        var matchingEnteringNodes = pathUtils_1.PathUtils.matching(redirectEnteringNodes, originalEnteringNodes, pathUtils_1.PathUtils.nonDynamicParams).filter(hof_1.not(nodeIsReloading(targetState.options().reloadState)));
	        // Use the existing (possibly pre-resolved) resolvables for the matching entering nodes.
	        matchingEnteringNodes.forEach(function (node, idx) {
	            node.resolvables = originalEnteringNodes[idx].resolvables;
	        });
	        return newTransition;
	    };
	    /** @internal If a transition doesn't exit/enter any states, returns any [[Param]] whose value changed */
	    Transition.prototype._changedParams = function () {
	        var tc = this._treeChanges;
	        /** Return undefined if it's not a "dynamic" transition, for the following reasons */
	        // If user explicitly wants a reload
	        if (this._options.reload)
	            return undefined;
	        // If any states are exiting or entering
	        if (tc.exiting.length || tc.entering.length)
	            return undefined;
	        // If to/from path lengths differ
	        if (tc.to.length !== tc.from.length)
	            return undefined;
	        // If the to/from paths are different
	        var pathsDiffer = common_1.arrayTuples(tc.to, tc.from)
	            .map(function (tuple) { return tuple[0].state !== tuple[1].state; })
	            .reduce(common_1.anyTrueR, false);
	        if (pathsDiffer)
	            return undefined;
	        // Find any parameter values that differ
	        var nodeSchemas = tc.to.map(function (node) { return node.paramSchema; });
	        var _a = [tc.to, tc.from].map(function (path) { return path.map(function (x) { return x.paramValues; }); }), toValues = _a[0], fromValues = _a[1];
	        var tuples = common_1.arrayTuples(nodeSchemas, toValues, fromValues);
	        return tuples.map(function (_a) {
	            var schema = _a[0], toVals = _a[1], fromVals = _a[2];
	            return param_1.Param.changed(schema, toVals, fromVals);
	        }).reduce(common_1.unnestR, []);
	    };
	    /**
	     * Returns true if the transition is dynamic.
	     *
	     * A transition is dynamic if no states are entered nor exited, but at least one dynamic parameter has changed.
	     *
	     * @returns true if the Transition is dynamic
	     */
	    Transition.prototype.dynamic = function () {
	        var changes = this._changedParams();
	        return !changes ? false : changes.map(function (x) { return x.dynamic; }).reduce(common_1.anyTrueR, false);
	    };
	    /**
	     * Returns true if the transition is ignored.
	     *
	     * A transition is ignored if no states are entered nor exited, and no parameter values have changed.
	     *
	     * @returns true if the Transition is ignored.
	     */
	    Transition.prototype.ignored = function () {
	        return !!this._ignoredReason();
	    };
	    /** @internal */
	    Transition.prototype._ignoredReason = function () {
	        var pending = this.router.globals.transition;
	        var reloadState = this._options.reloadState;
	        var same = function (pathA, pathB) {
	            if (pathA.length !== pathB.length)
	                return false;
	            var matching = pathUtils_1.PathUtils.matching(pathA, pathB);
	            return pathA.length === matching.filter(function (node) { return !reloadState || !node.state.includes[reloadState.name]; }).length;
	        };
	        var newTC = this.treeChanges();
	        var pendTC = pending && pending.treeChanges();
	        if (pendTC && same(pendTC.to, newTC.to) && same(pendTC.exiting, newTC.exiting))
	            return 'SameAsPending';
	        if (newTC.exiting.length === 0 && newTC.entering.length === 0 && same(newTC.from, newTC.to))
	            return 'SameAsCurrent';
	    };
	    /**
	     * Runs the transition
	     *
	     * This method is generally called from the [[StateService.transitionTo]]
	     *
	     * @internal
	     *
	     * @returns a promise for a successful transition.
	     */
	    Transition.prototype.run = function () {
	        var _this = this;
	        var runAllHooks = transitionHook_1.TransitionHook.runAllHooks;
	        // Gets transition hooks array for the given phase
	        var getHooksFor = function (phase) { return _this._hookBuilder.buildHooksForPhase(phase); };
	        // When the chain is complete, then resolve or reject the deferred
	        var transitionSuccess = function () {
	            trace_1.trace.traceSuccess(_this.$to(), _this);
	            _this.success = true;
	            _this._deferred.resolve(_this.to());
	            runAllHooks(getHooksFor(interface_1.TransitionHookPhase.SUCCESS));
	        };
	        var transitionError = function (reason) {
	            trace_1.trace.traceError(reason, _this);
	            _this.success = false;
	            _this._deferred.reject(reason);
	            _this._error = reason;
	            runAllHooks(getHooksFor(interface_1.TransitionHookPhase.ERROR));
	        };
	        var runTransition = function () {
	            // Wait to build the RUN hook chain until the BEFORE hooks are done
	            // This allows a BEFORE hook to dynamically add additional RUN hooks via the Transition object.
	            var allRunHooks = getHooksFor(interface_1.TransitionHookPhase.RUN);
	            var done = function () { return coreservices_1.services.$q.when(undefined); };
	            return transitionHook_1.TransitionHook.invokeHooks(allRunHooks, done);
	        };
	        var startTransition = function () {
	            var globals = _this.router.globals;
	            globals.lastStartedTransitionId = _this.$id;
	            globals.transition = _this;
	            globals.transitionHistory.enqueue(_this);
	            trace_1.trace.traceTransitionStart(_this);
	            return coreservices_1.services.$q.when(undefined);
	        };
	        var allBeforeHooks = getHooksFor(interface_1.TransitionHookPhase.BEFORE);
	        transitionHook_1.TransitionHook.invokeHooks(allBeforeHooks, startTransition)
	            .then(runTransition)
	            .then(transitionSuccess, transitionError);
	        return this.promise;
	    };
	    /**
	     * Checks if the Transition is valid
	     *
	     * @returns true if the Transition is valid
	     */
	    Transition.prototype.valid = function () {
	        return !this.error() || this.success !== undefined;
	    };
	    /**
	     * Aborts this transition
	     *
	     * Imperative API to abort a Transition.
	     * This only applies to Transitions that are not yet complete.
	     */
	    Transition.prototype.abort = function () {
	        // Do not set flag if the transition is already complete
	        if (predicates_1.isUndefined(this.success)) {
	            this._aborted = true;
	        }
	    };
	    /**
	     * The Transition error reason.
	     *
	     * If the transition is invalid (and could not be run), returns the reason the transition is invalid.
	     * If the transition was valid and ran, but was not successful, returns the reason the transition failed.
	     *
	     * @returns a transition rejection explaining why the transition is invalid, or the reason the transition failed.
	     */
	    Transition.prototype.error = function () {
	        var state = this.$to();
	        if (state.self.abstract) {
	            return rejectFactory_1.Rejection.invalid("Cannot transition to abstract state '" + state.name + "'");
	        }
	        var paramDefs = state.parameters();
	        var values = this.params();
	        var invalidParams = paramDefs.filter(function (param) { return !param.validates(values[param.id]); });
	        if (invalidParams.length) {
	            var invalidValues = invalidParams.map(function (param) { return "[" + param.id + ":" + strings_1.stringify(values[param.id]) + "]"; }).join(', ');
	            var detail = "The following parameter values are not valid for state '" + state.name + "': " + invalidValues;
	            return rejectFactory_1.Rejection.invalid(detail);
	        }
	        if (this.success === false)
	            return this._error;
	    };
	    /**
	     * A string representation of the Transition
	     *
	     * @returns A string representation of the Transition
	     */
	    Transition.prototype.toString = function () {
	        var fromStateOrName = this.from();
	        var toStateOrName = this.to();
	        var avoidEmptyHash = function (params) {
	            return params['#'] !== null && params['#'] !== undefined ? params : common_1.omit(params, ['#']);
	        };
	        // (X) means the to state is invalid.
	        var id = this.$id, from = predicates_1.isObject(fromStateOrName) ? fromStateOrName.name : fromStateOrName, fromParams = strings_1.stringify(avoidEmptyHash(this._treeChanges.from.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}))), toValid = this.valid() ? '' : '(X) ', to = predicates_1.isObject(toStateOrName) ? toStateOrName.name : toStateOrName, toParams = strings_1.stringify(avoidEmptyHash(this.params()));
	        return "Transition#" + id + "( '" + from + "'" + fromParams + " -> " + toValid + "'" + to + "'" + toParams + " )";
	    };
	    /** @internal */
	    Transition.diToken = Transition;
	    return Transition;
	}());
	exports.Transition = Transition;
	//# sourceMappingURL=transition.js.map

/***/ },

/***/ 37:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionService = exports.defaultTransOpts = void 0;
	var interface_1 = __webpack_require__(13);
	var transition_1 = __webpack_require__(36);
	var hookRegistry_1 = __webpack_require__(35);
	var coreResolvables_1 = __webpack_require__(98);
	var redirectTo_1 = __webpack_require__(102);
	var onEnterExitRetain_1 = __webpack_require__(101);
	var resolve_1 = __webpack_require__(103);
	var views_1 = __webpack_require__(106);
	var updateGlobals_1 = __webpack_require__(104);
	var url_1 = __webpack_require__(105);
	var lazyLoad_1 = __webpack_require__(49);
	var transitionEventType_1 = __webpack_require__(60);
	var transitionHook_1 = __webpack_require__(17);
	var predicates_1 = __webpack_require__(5);
	var common_1 = __webpack_require__(4);
	var hof_1 = __webpack_require__(6);
	var ignoredTransition_1 = __webpack_require__(99);
	var invalidTransition_1 = __webpack_require__(100);
	/**
	 * The default [[Transition]] options.
	 *
	 * Include this object when applying custom defaults:
	 * let reloadOpts = { reload: true, notify: true }
	 * let options = defaults(theirOpts, customDefaults, defaultOptions);
	 */
	exports.defaultTransOpts = {
	    location: true,
	    relative: null,
	    inherit: false,
	    notify: true,
	    reload: false,
	    supercede: true,
	    custom: {},
	    current: function () { return null; },
	    source: 'unknown',
	};
	/**
	 * This class provides services related to Transitions.
	 *
	 * - Most importantly, it allows global Transition Hooks to be registered.
	 * - It allows the default transition error handler to be set.
	 * - It also has a factory function for creating new [[Transition]] objects, (used internally by the [[StateService]]).
	 *
	 * At bootstrap, [[UIRouter]] creates a single instance (singleton) of this class.
	 *
	 * This API is located at `router.transitionService` ([[UIRouter.transitionService]])
	 */
	var TransitionService = /** @class */ (function () {
	    /** @internal */
	    function TransitionService(_router) {
	        /** @internal */
	        this._transitionCount = 0;
	        /** The transition hook types, such as `onEnter`, `onStart`, etc */
	        this._eventTypes = [];
	        /** @internal The registered transition hooks */
	        this._registeredHooks = {};
	        /** The  paths on a criteria object */
	        this._criteriaPaths = {};
	        this._router = _router;
	        this.$view = _router.viewService;
	        this._deregisterHookFns = {};
	        this._pluginapi = (common_1.createProxyFunctions(hof_1.val(this), {}, hof_1.val(this), [
	            '_definePathType',
	            '_defineEvent',
	            '_getPathTypes',
	            '_getEvents',
	            'getHooks',
	        ]));
	        this._defineCorePaths();
	        this._defineCoreEvents();
	        this._registerCoreTransitionHooks();
	        _router.globals.successfulTransitions.onEvict(coreResolvables_1.treeChangesCleanup);
	    }
	    /**
	     * Registers a [[TransitionHookFn]], called *while a transition is being constructed*.
	     *
	     * Registers a transition lifecycle hook, which is invoked during transition construction.
	     *
	     * This low level hook should only be used by plugins.
	     * This can be a useful time for plugins to add resolves or mutate the transition as needed.
	     * The Sticky States plugin uses this hook to modify the treechanges.
	     *
	     * ### Lifecycle
	     *
	     * `onCreate` hooks are invoked *while a transition is being constructed*.
	     *
	     * ### Return value
	     *
	     * The hook's return value is ignored
	     *
	     * @internal
	     * @param criteria defines which Transitions the Hook should be invoked for.
	     * @param callback the hook function which will be invoked.
	     * @param options the registration options
	     * @returns a function which deregisters the hook.
	     */
	    TransitionService.prototype.onCreate = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onBefore = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onStart = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onExit = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onRetain = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onEnter = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onFinish = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onSuccess = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onError = function (criteria, callback, options) {
	        return;
	    };
	    /**
	     * dispose
	     * @internal
	     */
	    TransitionService.prototype.dispose = function (router) {
	        common_1.values(this._registeredHooks).forEach(function (hooksArray) {
	            return hooksArray.forEach(function (hook) {
	                hook._deregistered = true;
	                common_1.removeFrom(hooksArray, hook);
	            });
	        });
	    };
	    /**
	     * Creates a new [[Transition]] object
	     *
	     * This is a factory function for creating new Transition objects.
	     * It is used internally by the [[StateService]] and should generally not be called by application code.
	     *
	     * @internal
	     * @param fromPath the path to the current state (the from state)
	     * @param targetState the target state (destination)
	     * @returns a Transition
	     */
	    TransitionService.prototype.create = function (fromPath, targetState) {
	        return new transition_1.Transition(fromPath, targetState, this._router);
	    };
	    /** @internal */
	    TransitionService.prototype._defineCoreEvents = function () {
	        var Phase = interface_1.TransitionHookPhase;
	        var TH = transitionHook_1.TransitionHook;
	        var paths = this._criteriaPaths;
	        var NORMAL_SORT = false, REVERSE_SORT = true;
	        var SYNCHRONOUS = true;
	        this._defineEvent('onCreate', Phase.CREATE, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.THROW_ERROR, SYNCHRONOUS);
	        this._defineEvent('onBefore', Phase.BEFORE, 0, paths.to);
	        this._defineEvent('onStart', Phase.RUN, 0, paths.to);
	        this._defineEvent('onExit', Phase.RUN, 100, paths.exiting, REVERSE_SORT);
	        this._defineEvent('onRetain', Phase.RUN, 200, paths.retained);
	        this._defineEvent('onEnter', Phase.RUN, 300, paths.entering);
	        this._defineEvent('onFinish', Phase.RUN, 400, paths.to);
	        this._defineEvent('onSuccess', Phase.SUCCESS, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
	        this._defineEvent('onError', Phase.ERROR, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
	    };
	    /** @internal */
	    TransitionService.prototype._defineCorePaths = function () {
	        var STATE = interface_1.TransitionHookScope.STATE, TRANSITION = interface_1.TransitionHookScope.TRANSITION;
	        this._definePathType('to', TRANSITION);
	        this._definePathType('from', TRANSITION);
	        this._definePathType('exiting', STATE);
	        this._definePathType('retained', STATE);
	        this._definePathType('entering', STATE);
	    };
	    /** @internal */
	    TransitionService.prototype._defineEvent = function (name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
	        if (reverseSort === void 0) { reverseSort = false; }
	        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
	        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
	        if (synchronous === void 0) { synchronous = false; }
	        var eventType = new transitionEventType_1.TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous);
	        this._eventTypes.push(eventType);
	        hookRegistry_1.makeEvent(this, this, eventType);
	    };
	    /** @internal */
	    TransitionService.prototype._getEvents = function (phase) {
	        var transitionHookTypes = predicates_1.isDefined(phase)
	            ? this._eventTypes.filter(function (type) { return type.hookPhase === phase; })
	            : this._eventTypes.slice();
	        return transitionHookTypes.sort(function (l, r) {
	            var cmpByPhase = l.hookPhase - r.hookPhase;
	            return cmpByPhase === 0 ? l.hookOrder - r.hookOrder : cmpByPhase;
	        });
	    };
	    /**
	     * Adds a Path to be used as a criterion against a TreeChanges path
	     *
	     * For example: the `exiting` path in [[HookMatchCriteria]] is a STATE scoped path.
	     * It was defined by calling `defineTreeChangesCriterion('exiting', TransitionHookScope.STATE)`
	     * Each state in the exiting path is checked against the criteria and returned as part of the match.
	     *
	     * Another example: the `to` path in [[HookMatchCriteria]] is a TRANSITION scoped path.
	     * It was defined by calling `defineTreeChangesCriterion('to', TransitionHookScope.TRANSITION)`
	     * Only the tail of the `to` path is checked against the criteria and returned as part of the match.
	     *
	     * @internal
	     */
	    TransitionService.prototype._definePathType = function (name, hookScope) {
	        this._criteriaPaths[name] = { name: name, scope: hookScope };
	    };
	    /** @internal */
	    // tslint:disable-next-line
	    TransitionService.prototype._getPathTypes = function () {
	        return this._criteriaPaths;
	    };
	    /** @internal */
	    TransitionService.prototype.getHooks = function (hookName) {
	        return this._registeredHooks[hookName];
	    };
	    /** @internal */
	    TransitionService.prototype._registerCoreTransitionHooks = function () {
	        var fns = this._deregisterHookFns;
	        fns.addCoreResolves = coreResolvables_1.registerAddCoreResolvables(this);
	        fns.ignored = ignoredTransition_1.registerIgnoredTransitionHook(this);
	        fns.invalid = invalidTransition_1.registerInvalidTransitionHook(this);
	        // Wire up redirectTo hook
	        fns.redirectTo = redirectTo_1.registerRedirectToHook(this);
	        // Wire up onExit/Retain/Enter state hooks
	        fns.onExit = onEnterExitRetain_1.registerOnExitHook(this);
	        fns.onRetain = onEnterExitRetain_1.registerOnRetainHook(this);
	        fns.onEnter = onEnterExitRetain_1.registerOnEnterHook(this);
	        // Wire up Resolve hooks
	        fns.eagerResolve = resolve_1.registerEagerResolvePath(this);
	        fns.lazyResolve = resolve_1.registerLazyResolveState(this);
	        fns.resolveAll = resolve_1.registerResolveRemaining(this);
	        // Wire up the View management hooks
	        fns.loadViews = views_1.registerLoadEnteringViews(this);
	        fns.activateViews = views_1.registerActivateViews(this);
	        // Updates global state after a transition
	        fns.updateGlobals = updateGlobals_1.registerUpdateGlobalState(this);
	        // After globals.current is updated at priority: 10000
	        fns.updateUrl = url_1.registerUpdateUrl(this);
	        // Lazy load state trees
	        fns.lazyLoad = lazyLoad_1.registerLazyLoadHook(this);
	    };
	    return TransitionService;
	}());
	exports.TransitionService = TransitionService;
	//# sourceMappingURL=transitionService.js.map

/***/ },

/***/ 38:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BaseUrlRule = exports.UrlRuleFactory = void 0;
	var urlMatcher_1 = __webpack_require__(23);
	var predicates_1 = __webpack_require__(5);
	var common_1 = __webpack_require__(4);
	var hof_1 = __webpack_require__(6);
	var stateObject_1 = __webpack_require__(34);
	/**
	 * Creates a [[UrlRule]]
	 *
	 * Creates a [[UrlRule]] from a:
	 *
	 * - `string`
	 * - [[UrlMatcher]]
	 * - `RegExp`
	 * - [[StateObject]]
	 */
	var UrlRuleFactory = /** @class */ (function () {
	    function UrlRuleFactory(router) {
	        this.router = router;
	    }
	    UrlRuleFactory.prototype.compile = function (str) {
	        return this.router.urlMatcherFactory.compile(str);
	    };
	    UrlRuleFactory.prototype.create = function (what, handler) {
	        var _this = this;
	        var isState = stateObject_1.StateObject.isState, isStateDeclaration = stateObject_1.StateObject.isStateDeclaration;
	        var makeRule = hof_1.pattern([
	            [predicates_1.isString, function (_what) { return makeRule(_this.compile(_what)); }],
	            [hof_1.is(urlMatcher_1.UrlMatcher), function (_what) { return _this.fromUrlMatcher(_what, handler); }],
	            [hof_1.or(isState, isStateDeclaration), function (_what) { return _this.fromState(_what, _this.router); }],
	            [hof_1.is(RegExp), function (_what) { return _this.fromRegExp(_what, handler); }],
	            [predicates_1.isFunction, function (_what) { return new BaseUrlRule(_what, handler); }],
	        ]);
	        var rule = makeRule(what);
	        if (!rule)
	            throw new Error("invalid 'what' in when()");
	        return rule;
	    };
	    /**
	     * A UrlRule which matches based on a UrlMatcher
	     *
	     * The `handler` may be either a `string`, a [[UrlRuleHandlerFn]] or another [[UrlMatcher]]
	     *
	     * ## Handler as a function
	     *
	     * If `handler` is a function, the function is invoked with:
	     *
	     * - matched parameter values ([[RawParams]] from [[UrlMatcher.exec]])
	     * - url: the current Url ([[UrlParts]])
	     * - router: the router object ([[UIRouter]])
	     *
	     * #### Example:
	     * ```js
	     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
	     * var rule = factory.fromUrlMatcher(urlMatcher, match => "/home/" + match.fooId + "/" + match.barId);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match); // '/home/123/456'
	     * ```
	     *
	     * ## Handler as UrlMatcher
	     *
	     * If `handler` is a UrlMatcher, the handler matcher is used to create the new url.
	     * The `handler` UrlMatcher is formatted using the matched param from the first matcher.
	     * The url is replaced with the result.
	     *
	     * #### Example:
	     * ```js
	     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
	     * var handler = $umf.compile("/home/:fooId/:barId");
	     * var rule = factory.fromUrlMatcher(urlMatcher, handler);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match); // '/home/123/456'
	     * ```
	     */
	    UrlRuleFactory.prototype.fromUrlMatcher = function (urlMatcher, handler) {
	        var _handler = handler;
	        if (predicates_1.isString(handler))
	            handler = this.router.urlMatcherFactory.compile(handler);
	        if (hof_1.is(urlMatcher_1.UrlMatcher)(handler))
	            _handler = function (match) { return handler.format(match); };
	        function matchUrlParamters(url) {
	            var params = urlMatcher.exec(url.path, url.search, url.hash);
	            return urlMatcher.validates(params) && params;
	        }
	        // Prioritize URLs, lowest to highest:
	        // - Some optional URL parameters, but none matched
	        // - No optional parameters in URL
	        // - Some optional parameters, some matched
	        // - Some optional parameters, all matched
	        function matchPriority(params) {
	            var optional = urlMatcher.parameters().filter(function (param) { return param.isOptional; });
	            if (!optional.length)
	                return 0.000001;
	            var matched = optional.filter(function (param) { return params[param.id]; });
	            return matched.length / optional.length;
	        }
	        var details = { urlMatcher: urlMatcher, matchPriority: matchPriority, type: 'URLMATCHER' };
	        return common_1.extend(new BaseUrlRule(matchUrlParamters, _handler), details);
	    };
	    /**
	     * A UrlRule which matches a state by its url
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromState($state.get('foo'), router);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match);
	     * // Starts a transition to 'foo' with params: { fooId: '123', barId: '456' }
	     * ```
	     */
	    UrlRuleFactory.prototype.fromState = function (stateOrDecl, router) {
	        var state = stateObject_1.StateObject.isStateDeclaration(stateOrDecl) ? stateOrDecl.$$state() : stateOrDecl;
	        /**
	         * Handles match by transitioning to matched state
	         *
	         * First checks if the router should start a new transition.
	         * A new transition is not required if the current state's URL
	         * and the new URL are already identical
	         */
	        var handler = function (match) {
	            var $state = router.stateService;
	            var globals = router.globals;
	            if ($state.href(state, match) !== $state.href(globals.current, globals.params)) {
	                $state.transitionTo(state, match, { inherit: true, source: 'url' });
	            }
	        };
	        var details = { state: state, type: 'STATE' };
	        return common_1.extend(this.fromUrlMatcher(state.url, handler), details);
	    };
	    /**
	     * A UrlRule which matches based on a regular expression
	     *
	     * The `handler` may be either a [[UrlRuleHandlerFn]] or a string.
	     *
	     * ## Handler as a function
	     *
	     * If `handler` is a function, the function is invoked with:
	     *
	     * - regexp match array (from `regexp`)
	     * - url: the current Url ([[UrlParts]])
	     * - router: the router object ([[UIRouter]])
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, match => "/home/" + match[1])
	     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
	     * var result = rule.handler(match); // '/home/bar'
	     * ```
	     *
	     * ## Handler as string
	     *
	     * If `handler` is a string, the url is *replaced by the string* when the Rule is invoked.
	     * The string is first interpolated using `string.replace()` style pattern.
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, "/home/$1")
	     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
	     * var result = rule.handler(match); // '/home/bar'
	     * ```
	     */
	    UrlRuleFactory.prototype.fromRegExp = function (regexp, handler) {
	        if (regexp.global || regexp.sticky)
	            throw new Error('Rule RegExp must not be global or sticky');
	        /**
	         * If handler is a string, the url will be replaced by the string.
	         * If the string has any String.replace() style variables in it (like `$2`),
	         * they will be replaced by the captures from [[match]]
	         */
	        var redirectUrlTo = function (match) {
	            // Interpolates matched values into $1 $2, etc using a String.replace()-style pattern
	            return handler.replace(/\$(\$|\d{1,2})/, function (m, what) { return match[what === '$' ? 0 : Number(what)]; });
	        };
	        var _handler = predicates_1.isString(handler) ? redirectUrlTo : handler;
	        var matchParamsFromRegexp = function (url) { return regexp.exec(url.path); };
	        var details = { regexp: regexp, type: 'REGEXP' };
	        return common_1.extend(new BaseUrlRule(matchParamsFromRegexp, _handler), details);
	    };
	    UrlRuleFactory.isUrlRule = function (obj) { return obj && ['type', 'match', 'handler'].every(function (key) { return predicates_1.isDefined(obj[key]); }); };
	    return UrlRuleFactory;
	}());
	exports.UrlRuleFactory = UrlRuleFactory;
	/**
	 * A base rule which calls `match`
	 *
	 * The value from the `match` function is passed through to the `handler`.
	 * @internal
	 */
	var BaseUrlRule = /** @class */ (function () {
	    function BaseUrlRule(match, handler) {
	        var _this = this;
	        this.match = match;
	        this.type = 'RAW';
	        this.matchPriority = function (match) { return 0 - _this.$id; };
	        this.handler = handler || common_1.identity;
	    }
	    return BaseUrlRule;
	}());
	exports.BaseUrlRule = BaseUrlRule;
	//# sourceMappingURL=urlRule.js.map

/***/ },

/***/ 39:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.locationPluginFactory = exports.buildUrl = exports.parseUrl = exports.getParams = exports.keyValsToObjectR = void 0;
	var common_1 = __webpack_require__(7);
	exports.keyValsToObjectR = function (accum, _a) {
	    var key = _a[0], val = _a[1];
	    if (!accum.hasOwnProperty(key)) {
	        accum[key] = val;
	    }
	    else if (common_1.isArray(accum[key])) {
	        accum[key].push(val);
	    }
	    else {
	        accum[key] = [accum[key], val];
	    }
	    return accum;
	};
	exports.getParams = function (queryString) {
	    return queryString.split('&').filter(common_1.identity).map(common_1.splitEqual).reduce(exports.keyValsToObjectR, {});
	};
	function parseUrl(url) {
	    var orEmptyString = function (x) { return x || ''; };
	    var _a = common_1.splitHash(url).map(orEmptyString), beforehash = _a[0], hash = _a[1];
	    var _b = common_1.splitQuery(beforehash).map(orEmptyString), path = _b[0], search = _b[1];
	    return { path: path, search: search, hash: hash, url: url };
	}
	exports.parseUrl = parseUrl;
	exports.buildUrl = function (loc) {
	    var path = loc.path();
	    var searchObject = loc.search();
	    var hash = loc.hash();
	    var search = Object.keys(searchObject)
	        .map(function (key) {
	        var param = searchObject[key];
	        var vals = common_1.isArray(param) ? param : [param];
	        return vals.map(function (val) { return key + '=' + val; });
	    })
	        .reduce(common_1.unnestR, [])
	        .join('&');
	    return path + (search ? '?' + search : '') + (hash ? '#' + hash : '');
	};
	function locationPluginFactory(name, isHtml5, serviceClass, configurationClass) {
	    return function (uiRouter) {
	        var service = (uiRouter.locationService = new serviceClass(uiRouter));
	        var configuration = (uiRouter.locationConfig = new configurationClass(uiRouter, isHtml5));
	        function dispose(router) {
	            router.dispose(service);
	            router.dispose(configuration);
	        }
	        return { name: name, service: service, configuration: configuration, dispose: dispose };
	    };
	}
	exports.locationPluginFactory = locationPluginFactory;
	//# sourceMappingURL=utils.js.map

/***/ },

/***/ 46:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * State-based routing for AngularJS 1.x
	 * This bundle requires the ui-router-core.js bundle from the @uirouter/core package.
	 * @version v1.0.30
	 * @link https://ui-router.github.io
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function (global, factory) {
	     true ? factory(exports, __webpack_require__(1), __webpack_require__(107)) :
	    typeof define === 'function' && define.amd ? define(['exports', 'angular', '@uirouter/core'], factory) :
	    (global = global || self, factory(global['@uirouter/angularjs'] = {}, global.angular, global['@uirouter/core']));
	}(this, (function (exports, ng_from_import, core) { 'use strict';
	
	    /** @publicapi @module ng1 */ /** */
	    /** @hidden */ var ng_from_global = angular;
	    /** @hidden */ var ng = ng_from_import && ng_from_import.module ? ng_from_import : ng_from_global;
	
	    /** @publicapi @module ng1 */ /** */
	    /** @internalapi */
	    function getNg1ViewConfigFactory() {
	        var templateFactory = null;
	        return function (path, view) {
	            templateFactory = templateFactory || core.services.$injector.get('$templateFactory');
	            return [new Ng1ViewConfig(path, view, templateFactory)];
	        };
	    }
	    /** @internalapi */
	    var hasAnyKey = function (keys, obj) { return keys.reduce(function (acc, key) { return acc || core.isDefined(obj[key]); }, false); };
	    /**
	     * This is a [[StateBuilder.builder]] function for angular1 `views`.
	     *
	     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	     * handles the `views` property with logic specific to @uirouter/angularjs (ng1).
	     *
	     * If no `views: {}` property exists on the [[StateDeclaration]], then it creates the `views` object
	     * and applies the state-level configuration to a view named `$default`.
	     *
	     * @internalapi
	     */
	    function ng1ViewsBuilder(state) {
	        // Do not process root state
	        if (!state.parent)
	            return {};
	        var tplKeys = ['templateProvider', 'templateUrl', 'template', 'notify', 'async'], ctrlKeys = ['controller', 'controllerProvider', 'controllerAs', 'resolveAs'], compKeys = ['component', 'bindings', 'componentProvider'], nonCompKeys = tplKeys.concat(ctrlKeys), allViewKeys = compKeys.concat(nonCompKeys);
	        // Do not allow a state to have both state-level props and also a `views: {}` property.
	        // A state without a `views: {}` property can declare properties for the `$default` view as properties of the state.
	        // However, the `$default` approach should not be mixed with a separate `views: ` block.
	        if (core.isDefined(state.views) && hasAnyKey(allViewKeys, state)) {
	            throw new Error("State '" + state.name + "' has a 'views' object. " +
	                "It cannot also have \"view properties\" at the state level.  " +
	                "Move the following properties into a view (in the 'views' object): " +
	                (" " + allViewKeys.filter(function (key) { return core.isDefined(state[key]); }).join(', ')));
	        }
	        var views = {}, viewsObject = state.views || { $default: core.pick(state, allViewKeys) };
	        core.forEach(viewsObject, function (config, name) {
	            // Account for views: { "": { template... } }
	            name = name || '$default';
	            // Account for views: { header: "headerComponent" }
	            if (core.isString(config))
	                config = { component: config };
	            // Make a shallow copy of the config object
	            config = core.extend({}, config);
	            // Do not allow a view to mix props for component-style view with props for template/controller-style view
	            if (hasAnyKey(compKeys, config) && hasAnyKey(nonCompKeys, config)) {
	                throw new Error("Cannot combine: " + compKeys.join('|') + " with: " + nonCompKeys.join('|') + " in stateview: '" + name + "@" + state.name + "'");
	            }
	            config.resolveAs = config.resolveAs || '$resolve';
	            config.$type = 'ng1';
	            config.$context = state;
	            config.$name = name;
	            var normalized = core.ViewService.normalizeUIViewTarget(config.$context, config.$name);
	            config.$uiViewName = normalized.uiViewName;
	            config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
	            views[name] = config;
	        });
	        return views;
	    }
	    /** @hidden */
	    var id = 0;
	    /** @internalapi */
	    var Ng1ViewConfig = /** @class */ (function () {
	        function Ng1ViewConfig(path, viewDecl, factory) {
	            var _this = this;
	            this.path = path;
	            this.viewDecl = viewDecl;
	            this.factory = factory;
	            this.$id = id++;
	            this.loaded = false;
	            this.getTemplate = function (uiView, context) {
	                return _this.component
	                    ? _this.factory.makeComponentTemplate(uiView, context, _this.component, _this.viewDecl.bindings)
	                    : _this.template;
	            };
	        }
	        Ng1ViewConfig.prototype.load = function () {
	            var _this = this;
	            var $q = core.services.$q;
	            var context = new core.ResolveContext(this.path);
	            var params = this.path.reduce(function (acc, node) { return core.extend(acc, node.paramValues); }, {});
	            var promises = {
	                template: $q.when(this.factory.fromConfig(this.viewDecl, params, context)),
	                controller: $q.when(this.getController(context)),
	            };
	            return $q.all(promises).then(function (results) {
	                core.trace.traceViewServiceEvent('Loaded', _this);
	                _this.controller = results.controller;
	                core.extend(_this, results.template); // Either { template: "tpl" } or { component: "cmpName" }
	                return _this;
	            });
	        };
	        /**
	         * Gets the controller for a view configuration.
	         *
	         * @returns {Function|Promise.<Function>} Returns a controller, or a promise that resolves to a controller.
	         */
	        Ng1ViewConfig.prototype.getController = function (context) {
	            var provider = this.viewDecl.controllerProvider;
	            if (!core.isInjectable(provider))
	                return this.viewDecl.controller;
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        return Ng1ViewConfig;
	    }());
	
	    /** @publicapi @module view */ /** */
	    /**
	     * Service which manages loading of templates from a ViewConfig.
	     */
	    var TemplateFactory = /** @class */ (function () {
	        function TemplateFactory() {
	            var _this = this;
	            /** @hidden */ this._useHttp = ng.version.minor < 3;
	            /** @hidden */ this.$get = [
	                '$http',
	                '$templateCache',
	                '$injector',
	                function ($http, $templateCache, $injector) {
	                    _this.$templateRequest = $injector.has && $injector.has('$templateRequest') && $injector.get('$templateRequest');
	                    _this.$http = $http;
	                    _this.$templateCache = $templateCache;
	                    return _this;
	                },
	            ];
	        }
	        /** @hidden */
	        TemplateFactory.prototype.useHttpService = function (value) {
	            this._useHttp = value;
	        };
	        /**
	         * Creates a template from a configuration object.
	         *
	         * @param config Configuration object for which to load a template.
	         * The following properties are search in the specified order, and the first one
	         * that is defined is used to create the template:
	         *
	         * @param params  Parameters to pass to the template function.
	         * @param context The resolve context associated with the template's view
	         *
	         * @return {string|object}  The template html as a string, or a promise for
	         * that string,or `null` if no template is configured.
	         */
	        TemplateFactory.prototype.fromConfig = function (config, params, context) {
	            var defaultTemplate = '<ui-view></ui-view>';
	            var asTemplate = function (result) { return core.services.$q.when(result).then(function (str) { return ({ template: str }); }); };
	            var asComponent = function (result) { return core.services.$q.when(result).then(function (str) { return ({ component: str }); }); };
	            return core.isDefined(config.template)
	                ? asTemplate(this.fromString(config.template, params))
	                : core.isDefined(config.templateUrl)
	                    ? asTemplate(this.fromUrl(config.templateUrl, params))
	                    : core.isDefined(config.templateProvider)
	                        ? asTemplate(this.fromProvider(config.templateProvider, params, context))
	                        : core.isDefined(config.component)
	                            ? asComponent(config.component)
	                            : core.isDefined(config.componentProvider)
	                                ? asComponent(this.fromComponentProvider(config.componentProvider, params, context))
	                                : asTemplate(defaultTemplate);
	        };
	        /**
	         * Creates a template from a string or a function returning a string.
	         *
	         * @param template html template as a string or function that returns an html template as a string.
	         * @param params Parameters to pass to the template function.
	         *
	         * @return {string|object} The template html as a string, or a promise for that
	         * string.
	         */
	        TemplateFactory.prototype.fromString = function (template, params) {
	            return core.isFunction(template) ? template(params) : template;
	        };
	        /**
	         * Loads a template from the a URL via `$http` and `$templateCache`.
	         *
	         * @param {string|Function} url url of the template to load, or a function
	         * that returns a url.
	         * @param {Object} params Parameters to pass to the url function.
	         * @return {string|Promise.<string>} The template html as a string, or a promise
	         * for that string.
	         */
	        TemplateFactory.prototype.fromUrl = function (url, params) {
	            if (core.isFunction(url))
	                url = url(params);
	            if (url == null)
	                return null;
	            if (this._useHttp) {
	                return this.$http
	                    .get(url, { cache: this.$templateCache, headers: { Accept: 'text/html' } })
	                    .then(function (response) {
	                    return response.data;
	                });
	            }
	            return this.$templateRequest(url);
	        };
	        /**
	         * Creates a template by invoking an injectable provider function.
	         *
	         * @param provider Function to invoke via `locals`
	         * @param {Function} injectFn a function used to invoke the template provider
	         * @return {string|Promise.<string>} The template html as a string, or a promise
	         * for that string.
	         */
	        TemplateFactory.prototype.fromProvider = function (provider, params, context) {
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        /**
	         * Creates a component's template by invoking an injectable provider function.
	         *
	         * @param provider Function to invoke via `locals`
	         * @param {Function} injectFn a function used to invoke the template provider
	         * @return {string} The template html as a string: "<component-name input1='::$resolve.foo'></component-name>".
	         */
	        TemplateFactory.prototype.fromComponentProvider = function (provider, params, context) {
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        /**
	         * Creates a template from a component's name
	         *
	         * This implements route-to-component.
	         * It works by retrieving the component (directive) metadata from the injector.
	         * It analyses the component's bindings, then constructs a template that instantiates the component.
	         * The template wires input and output bindings to resolves or from the parent component.
	         *
	         * @param uiView {object} The parent ui-view (for binding outputs to callbacks)
	         * @param context The ResolveContext (for binding outputs to callbacks returned from resolves)
	         * @param component {string} Component's name in camel case.
	         * @param bindings An object defining the component's bindings: {foo: '<'}
	         * @return {string} The template as a string: "<component-name input1='::$resolve.foo'></component-name>".
	         */
	        TemplateFactory.prototype.makeComponentTemplate = function (uiView, context, component, bindings) {
	            bindings = bindings || {};
	            // Bind once prefix
	            var prefix = ng.version.minor >= 3 ? '::' : '';
	            // Convert to kebob name. Add x- prefix if the string starts with `x-` or `data-`
	            var kebob = function (camelCase) {
	                var kebobed = core.kebobString(camelCase);
	                return /^(x|data)-/.exec(kebobed) ? "x-" + kebobed : kebobed;
	            };
	            var attributeTpl = function (input) {
	                var name = input.name, type = input.type;
	                var attrName = kebob(name);
	                // If the ui-view has an attribute which matches a binding on the routed component
	                // then pass that attribute through to the routed component template.
	                // Prefer ui-view wired mappings to resolve data, unless the resolve was explicitly bound using `bindings:`
	                if (uiView.attr(attrName) && !bindings[name])
	                    return attrName + "='" + uiView.attr(attrName) + "'";
	                var resolveName = bindings[name] || name;
	                // Pre-evaluate the expression for "@" bindings by enclosing in {{ }}
	                // some-attr="{{ ::$resolve.someResolveName }}"
	                if (type === '@')
	                    return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
	                // Wire "&" callbacks to resolves that return a callback function
	                // Get the result of the resolve (should be a function) and annotate it to get its arguments.
	                // some-attr="$resolve.someResolveResultName(foo, bar)"
	                if (type === '&') {
	                    var res = context.getResolvable(resolveName);
	                    var fn = res && res.data;
	                    var args = (fn && core.services.$injector.annotate(fn)) || [];
	                    // account for array style injection, i.e., ['foo', function(foo) {}]
	                    var arrayIdxStr = core.isArray(fn) ? "[" + (fn.length - 1) + "]" : '';
	                    return attrName + "='$resolve." + resolveName + arrayIdxStr + "(" + args.join(',') + ")'";
	                }
	                // some-attr="::$resolve.someResolveName"
	                return attrName + "='" + prefix + "$resolve." + resolveName + "'";
	            };
	            var attrs = getComponentBindings(component).map(attributeTpl).join(' ');
	            var kebobName = kebob(component);
	            return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
	        };
	        return TemplateFactory;
	    }());
	    // Gets all the directive(s)' inputs ('@', '=', and '<') and outputs ('&')
	    function getComponentBindings(name) {
	        var cmpDefs = core.services.$injector.get(name + 'Directive'); // could be multiple
	        if (!cmpDefs || !cmpDefs.length)
	            throw new Error("Unable to find component named '" + name + "'");
	        return cmpDefs.map(getBindings).reduce(core.unnestR, []);
	    }
	    // Given a directive definition, find its object input attributes
	    // Use different properties, depending on the type of directive (component, bindToController, normal)
	    var getBindings = function (def) {
	        if (core.isObject(def.bindToController))
	            return scopeBindings(def.bindToController);
	        return scopeBindings(def.scope);
	    };
	    // for ng 1.2 style, process the scope: { input: "=foo" }
	    // for ng 1.3 through ng 1.5, process the component's bindToController: { input: "=foo" } object
	    var scopeBindings = function (bindingsObj) {
	        return Object.keys(bindingsObj || {})
	            // [ 'input', [ '=foo', '=', 'foo' ] ]
	            .map(function (key) { return [key, /^([=<@&])[?]?(.*)/.exec(bindingsObj[key])]; })
	            // skip malformed values
	            .filter(function (tuple) { return core.isDefined(tuple) && core.isArray(tuple[1]); })
	            // { name: ('foo' || 'input'), type: '=' }
	            .map(function (tuple) { return ({ name: tuple[1][2] || tuple[0], type: tuple[1][1] }); });
	    };
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * The Angular 1 `StateProvider`
	     *
	     * The `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	     * on state.
	     *
	     * A state corresponds to a "place" in the application in terms of the overall UI and
	     * navigation. A state describes (via the controller / template / view properties) what
	     * the UI looks like and does at that place.
	     *
	     * States often have things in common, and the primary way of factoring out these
	     * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	     * nested states.
	     *
	     * The `$stateProvider` provides interfaces to declare these states for your app.
	     */
	    var StateProvider = /** @class */ (function () {
	        function StateProvider(stateRegistry, stateService) {
	            this.stateRegistry = stateRegistry;
	            this.stateService = stateService;
	            core.createProxyFunctions(core.val(StateProvider.prototype), this, core.val(this));
	        }
	        /**
	         * Decorates states when they are registered
	         *
	         * Allows you to extend (carefully) or override (at your own peril) the
	         * `stateBuilder` object used internally by [[StateRegistry]].
	         * This can be used to add custom functionality to ui-router,
	         * for example inferring templateUrl based on the state name.
	         *
	         * When passing only a name, it returns the current (original or decorated) builder
	         * function that matches `name`.
	         *
	         * The builder functions that can be decorated are listed below. Though not all
	         * necessarily have a good use case for decoration, that is up to you to decide.
	         *
	         * In addition, users can attach custom decorators, which will generate new
	         * properties within the state's internal definition. There is currently no clear
	         * use-case for this beyond accessing internal states (i.e. $state.$current),
	         * however, expect this to become increasingly relevant as we introduce additional
	         * meta-programming features.
	         *
	         * **Warning**: Decorators should not be interdependent because the order of
	         * execution of the builder functions in non-deterministic. Builder functions
	         * should only be dependent on the state definition object and super function.
	         *
	         *
	         * Existing builder functions and current return values:
	         *
	         * - **parent** `{object}` - returns the parent state object.
	         * - **data** `{object}` - returns state data, including any inherited data that is not
	         *   overridden by own values (if any).
	         * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	         *   or `null`.
	         * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is
	         *   navigable).
	         * - **params** `{object}` - returns an array of state params that are ensured to
	         *   be a super-set of parent's params.
	         * - **views** `{object}` - returns a views object where each key is an absolute view
	         *   name (i.e. "viewName@stateName") and each value is the config object
	         *   (template, controller) for the view. Even when you don't use the views object
	         *   explicitly on a state config, one is still created for you internally.
	         *   So by decorating this builder function you have access to decorating template
	         *   and controller properties.
	         * - **ownParams** `{object}` - returns an array of params that belong to the state,
	         *   not including any params defined by ancestor states.
	         * - **path** `{string}` - returns the full path from the root down to this state.
	         *   Needed for state activation.
	         * - **includes** `{object}` - returns an object that includes every state that
	         *   would pass a `$state.includes()` test.
	         *
	         * #### Example:
	         * Override the internal 'views' builder with a function that takes the state
	         * definition, and a reference to the internal function being overridden:
	         * ```js
	         * $stateProvider.decorator('views', function (state, parent) {
	         *   let result = {},
	         *       views = parent(state);
	         *
	         *   angular.forEach(views, function (config, name) {
	         *     let autoName = (state.name + '.' + name).replace('.', '/');
	         *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	         *     result[name] = config;
	         *   });
	         *   return result;
	         * });
	         *
	         * $stateProvider.state('home', {
	         *   views: {
	         *     'contact.list': { controller: 'ListController' },
	         *     'contact.item': { controller: 'ItemController' }
	         *   }
	         * });
	         * ```
	         *
	         *
	         * ```js
	         * // Auto-populates list and item views with /partials/home/contact/list.html,
	         * // and /partials/home/contact/item.html, respectively.
	         * $state.go('home');
	         * ```
	         *
	         * @param {string} name The name of the builder function to decorate.
	         * @param {object} func A function that is responsible for decorating the original
	         * builder function. The function receives two parameters:
	         *
	         *   - `{object}` - state - The state config object.
	         *   - `{object}` - super - The original builder function.
	         *
	         * @return {object} $stateProvider - $stateProvider instance
	         */
	        StateProvider.prototype.decorator = function (name, func) {
	            return this.stateRegistry.decorator(name, func) || this;
	        };
	        StateProvider.prototype.state = function (name, definition) {
	            if (core.isObject(name)) {
	                definition = name;
	            }
	            else {
	                definition.name = name;
	            }
	            this.stateRegistry.register(definition);
	            return this;
	        };
	        /**
	         * Registers an invalid state handler
	         *
	         * This is a passthrough to [[StateService.onInvalid]] for ng1.
	         */
	        StateProvider.prototype.onInvalid = function (callback) {
	            return this.stateService.onInvalid(callback);
	        };
	        return StateProvider;
	    }());
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * This is a [[StateBuilder.builder]] function for angular1 `onEnter`, `onExit`,
	     * `onRetain` callback hooks on a [[Ng1StateDeclaration]].
	     *
	     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	     * ensures that those hooks are injectable for @uirouter/angularjs (ng1).
	     *
	     * @internalapi
	     */
	    var getStateHookBuilder = function (hookName) {
	        return function stateHookBuilder(stateObject) {
	            var hook = stateObject[hookName];
	            var pathname = hookName === 'onExit' ? 'from' : 'to';
	            function decoratedNg1Hook(trans, state) {
	                var resolveContext = new core.ResolveContext(trans.treeChanges(pathname));
	                var subContext = resolveContext.subContext(state.$$state());
	                var locals = core.extend(getLocals(subContext), { $state$: state, $transition$: trans });
	                return core.services.$injector.invoke(hook, this, locals);
	            }
	            return hook ? decoratedNg1Hook : undefined;
	        };
	    };
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * Implements UI-Router LocationServices and LocationConfig using Angular 1's $location service
	     * @internalapi
	     */
	    var Ng1LocationServices = /** @class */ (function () {
	        function Ng1LocationServices($locationProvider) {
	            // .onChange() registry
	            this._urlListeners = [];
	            this.$locationProvider = $locationProvider;
	            var _lp = core.val($locationProvider);
	            core.createProxyFunctions(_lp, this, _lp, ['hashPrefix']);
	        }
	        /**
	         * Applys ng1-specific path parameter encoding
	         *
	         * The Angular 1 `$location` service is a bit weird.
	         * It doesn't allow slashes to be encoded/decoded bi-directionally.
	         *
	         * See the writeup at https://github.com/angular-ui/ui-router/issues/2598
	         *
	         * This code patches the `path` parameter type so it encoded/decodes slashes as ~2F
	         *
	         * @param router
	         */
	        Ng1LocationServices.monkeyPatchPathParameterType = function (router) {
	            var pathType = router.urlMatcherFactory.type('path');
	            pathType.encode = function (x) {
	                return x != null ? x.toString().replace(/(~|\/)/g, function (m) { return ({ '~': '~~', '/': '~2F' }[m]); }) : x;
	            };
	            pathType.decode = function (x) {
	                return x != null ? x.toString().replace(/(~~|~2F)/g, function (m) { return ({ '~~': '~', '~2F': '/' }[m]); }) : x;
	            };
	        };
	        // eslint-disable-next-line @typescript-eslint/no-empty-function
	        Ng1LocationServices.prototype.dispose = function () { };
	        Ng1LocationServices.prototype.onChange = function (callback) {
	            var _this = this;
	            this._urlListeners.push(callback);
	            return function () { return core.removeFrom(_this._urlListeners)(callback); };
	        };
	        Ng1LocationServices.prototype.html5Mode = function () {
	            var html5Mode = this.$locationProvider.html5Mode();
	            html5Mode = core.isObject(html5Mode) ? html5Mode.enabled : html5Mode;
	            return html5Mode && this.$sniffer.history;
	        };
	        Ng1LocationServices.prototype.baseHref = function () {
	            return this._baseHref || (this._baseHref = this.$browser.baseHref() || this.$window.location.pathname);
	        };
	        Ng1LocationServices.prototype.url = function (newUrl, replace, state) {
	            if (replace === void 0) { replace = false; }
	            if (core.isDefined(newUrl))
	                this.$location.url(newUrl);
	            if (replace)
	                this.$location.replace();
	            if (state)
	                this.$location.state(state);
	            return this.$location.url();
	        };
	        Ng1LocationServices.prototype._runtimeServices = function ($rootScope, $location, $sniffer, $browser, $window) {
	            var _this = this;
	            this.$location = $location;
	            this.$sniffer = $sniffer;
	            this.$browser = $browser;
	            this.$window = $window;
	            // Bind $locationChangeSuccess to the listeners registered in LocationService.onChange
	            $rootScope.$on('$locationChangeSuccess', function (evt) { return _this._urlListeners.forEach(function (fn) { return fn(evt); }); });
	            var _loc = core.val($location);
	            // Bind these LocationService functions to $location
	            core.createProxyFunctions(_loc, this, _loc, ['replace', 'path', 'search', 'hash']);
	            // Bind these LocationConfig functions to $location
	            core.createProxyFunctions(_loc, this, _loc, ['port', 'protocol', 'host']);
	        };
	        return Ng1LocationServices;
	    }());
	
	    /** @publicapi @module url */ /** */
	    /**
	     * Manages rules for client-side URL
	     *
	     * ### Deprecation warning:
	     * This class is now considered to be an internal API
	     * Use the [[UrlService]] instead.
	     * For configuring URL rules, use the [[UrlRulesApi]] which can be found as [[UrlService.rules]].
	     *
	     * This class manages the router rules for what to do when the URL changes.
	     *
	     * This provider remains for backwards compatibility.
	     *
	     * @internalapi
	     * @deprecated
	     */
	    var UrlRouterProvider = /** @class */ (function () {
	        /** @hidden */
	        function UrlRouterProvider(/** @hidden */ router) {
	            this.router = router;
	        }
	        UrlRouterProvider.injectableHandler = function (router, handler) {
	            return function (match) { return core.services.$injector.invoke(handler, null, { $match: match, $stateParams: router.globals.params }); };
	        };
	        /** @hidden */
	        UrlRouterProvider.prototype.$get = function () {
	            var urlService = this.router.urlService;
	            this.router.urlRouter.update(true);
	            if (!urlService.interceptDeferred)
	                urlService.listen();
	            return this.router.urlRouter;
	        };
	        /**
	         * Registers a url handler function.
	         *
	         * Registers a low level url handler (a `rule`).
	         * A rule detects specific URL patterns and returns a redirect, or performs some action.
	         *
	         * If a rule returns a string, the URL is replaced with the string, and all rules are fired again.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // Here's an example of how you might allow case insensitive urls
	         *   $urlRouterProvider.rule(function ($injector, $location) {
	         *     var path = $location.path(),
	         *         normalized = path.toLowerCase();
	         *
	         *     if (path !== normalized) {
	         *       return normalized;
	         *     }
	         *   });
	         * });
	         * ```
	         *
	         * @param ruleFn
	         * Handler function that takes `$injector` and `$location` services as arguments.
	         * You can use them to detect a url and return a different url as a string.
	         *
	         * @return [[UrlRouterProvider]] (`this`)
	         */
	        UrlRouterProvider.prototype.rule = function (ruleFn) {
	            var _this = this;
	            if (!core.isFunction(ruleFn))
	                throw new Error("'rule' must be a function");
	            var match = function () { return ruleFn(core.services.$injector, _this.router.locationService); };
	            var rule = new core.BaseUrlRule(match, core.identity);
	            this.router.urlService.rules.rule(rule);
	            return this;
	        };
	        /**
	         * Defines the path or behavior to use when no url can be matched.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // if the path doesn't match any of the urls you configured
	         *   // otherwise will take care of routing the user to the
	         *   // specified url
	         *   $urlRouterProvider.otherwise('/index');
	         *
	         *   // Example of using function rule as param
	         *   $urlRouterProvider.otherwise(function ($injector, $location) {
	         *     return '/a/valid/url';
	         *   });
	         * });
	         * ```
	         *
	         * @param rule
	         * The url path you want to redirect to or a function rule that returns the url path or performs a `$state.go()`.
	         * The function version is passed two params: `$injector` and `$location` services, and should return a url string.
	         *
	         * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	         */
	        UrlRouterProvider.prototype.otherwise = function (rule) {
	            var _this = this;
	            var urlRules = this.router.urlService.rules;
	            if (core.isString(rule)) {
	                urlRules.otherwise(rule);
	            }
	            else if (core.isFunction(rule)) {
	                urlRules.otherwise(function () { return rule(core.services.$injector, _this.router.locationService); });
	            }
	            else {
	                throw new Error("'rule' must be a string or function");
	            }
	            return this;
	        };
	        /**
	         * Registers a handler for a given url matching.
	         *
	         * If the handler is a string, it is
	         * treated as a redirect, and is interpolated according to the syntax of match
	         * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	         *
	         * If the handler is a function, it is injectable.
	         * It gets invoked if `$location` matches.
	         * You have the option of inject the match object as `$match`.
	         *
	         * The handler can return
	         *
	         * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	         *   will continue trying to find another one that matches.
	         * - **string** which is treated as a redirect and passed to `$location.url()`
	         * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	         *     if ($state.$current.navigable !== state ||
	         *         !equalForKeys($match, $stateParams) {
	         *      $state.transitionTo(state, $match, false);
	         *     }
	         *   });
	         * });
	         * ```
	         *
	         * @param what A pattern string to match, compiled as a [[UrlMatcher]].
	         * @param handler The path (or function that returns a path) that you want to redirect your user to.
	         * @param ruleCallback [optional] A callback that receives the `rule` registered with [[UrlMatcher.rule]]
	         *
	         * Note: the handler may also invoke arbitrary code, such as `$state.go()`
	         */
	        UrlRouterProvider.prototype.when = function (what, handler) {
	            if (core.isArray(handler) || core.isFunction(handler)) {
	                handler = UrlRouterProvider.injectableHandler(this.router, handler);
	            }
	            this.router.urlService.rules.when(what, handler);
	            return this;
	        };
	        /**
	         * Disables monitoring of the URL.
	         *
	         * Call this method before UI-Router has bootstrapped.
	         * It will stop UI-Router from performing the initial url sync.
	         *
	         * This can be useful to perform some asynchronous initialization before the router starts.
	         * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // Prevent $urlRouter from automatically intercepting URL changes;
	         *   $urlRouterProvider.deferIntercept();
	         * })
	         *
	         * app.run(function (MyService, $urlRouter, $http) {
	         *   $http.get("/stuff").then(function(resp) {
	         *     MyService.doStuff(resp.data);
	         *     $urlRouter.listen();
	         *     $urlRouter.sync();
	         *   });
	         * });
	         * ```
	         *
	         * @param defer Indicates whether to defer location change interception.
	         *        Passing no parameter is equivalent to `true`.
	         */
	        UrlRouterProvider.prototype.deferIntercept = function (defer) {
	            this.router.urlService.deferIntercept(defer);
	        };
	        return UrlRouterProvider;
	    }());
	
	    /* eslint-disable @typescript-eslint/no-empty-function */
	    ng.module('ui.router.angular1', []);
	    var mod_init = ng.module('ui.router.init', ['ng']);
	    var mod_util = ng.module('ui.router.util', ['ui.router.init']);
	    var mod_rtr = ng.module('ui.router.router', ['ui.router.util']);
	    var mod_state = ng.module('ui.router.state', ['ui.router.router', 'ui.router.util', 'ui.router.angular1']);
	    var mod_main = ng.module('ui.router', ['ui.router.init', 'ui.router.state', 'ui.router.angular1']);
	    var mod_cmpt = ng.module('ui.router.compat', ['ui.router']);
	    var router = null;
	    $uiRouterProvider.$inject = ['$locationProvider'];
	    /** This angular 1 provider instantiates a Router and exposes its services via the angular injector */
	    function $uiRouterProvider($locationProvider) {
	        // Create a new instance of the Router when the $uiRouterProvider is initialized
	        router = this.router = new core.UIRouter();
	        router.stateProvider = new StateProvider(router.stateRegistry, router.stateService);
	        // Apply ng1 specific StateBuilder code for `views`, `resolve`, and `onExit/Retain/Enter` properties
	        router.stateRegistry.decorator('views', ng1ViewsBuilder);
	        router.stateRegistry.decorator('onExit', getStateHookBuilder('onExit'));
	        router.stateRegistry.decorator('onRetain', getStateHookBuilder('onRetain'));
	        router.stateRegistry.decorator('onEnter', getStateHookBuilder('onEnter'));
	        router.viewService._pluginapi._viewConfigFactory('ng1', getNg1ViewConfigFactory());
	        // Disable decoding of params by UrlMatcherFactory because $location already handles this
	        router.urlService.config._decodeParams = false;
	        var ng1LocationService = (router.locationService = router.locationConfig = new Ng1LocationServices($locationProvider));
	        Ng1LocationServices.monkeyPatchPathParameterType(router);
	        // backwards compat: also expose router instance as $uiRouterProvider.router
	        router['router'] = router;
	        router['$get'] = $get;
	        $get.$inject = ['$location', '$browser', '$window', '$sniffer', '$rootScope', '$http', '$templateCache'];
	        function $get($location, $browser, $window, $sniffer, $rootScope, $http, $templateCache) {
	            ng1LocationService._runtimeServices($rootScope, $location, $sniffer, $browser, $window);
	            delete router['router'];
	            delete router['$get'];
	            return router;
	        }
	        return router;
	    }
	    var getProviderFor = function (serviceName) { return [
	        '$uiRouterProvider',
	        function ($urp) {
	            var service = $urp.router[serviceName];
	            service['$get'] = function () { return service; };
	            return service;
	        },
	    ]; };
	    // This effectively calls $get() on `$uiRouterProvider` to trigger init (when ng enters runtime)
	    runBlock.$inject = ['$injector', '$q', '$uiRouter'];
	    function runBlock($injector, $q, $uiRouter) {
	        core.services.$injector = $injector;
	        core.services.$q = $q;
	        // https://github.com/angular-ui/ui-router/issues/3678
	        if (!Object.prototype.hasOwnProperty.call($injector, 'strictDi')) {
	            try {
	                $injector.invoke(function (checkStrictDi) { });
	            }
	            catch (error) {
	                $injector.strictDi = !!/strict mode/.exec(error && error.toString());
	            }
	        }
	        // The $injector is now available.
	        // Find any resolvables that had dependency annotation deferred
	        $uiRouter.stateRegistry
	            .get()
	            .map(function (x) { return x.$$state().resolvables; })
	            .reduce(core.unnestR, [])
	            .filter(function (x) { return x.deps === 'deferred'; })
	            .forEach(function (resolvable) { return (resolvable.deps = $injector.annotate(resolvable.resolveFn, $injector.strictDi)); });
	    }
	    // $urlRouter service and $urlRouterProvider
	    var getUrlRouterProvider = function (uiRouter) { return (uiRouter.urlRouterProvider = new UrlRouterProvider(uiRouter)); };
	    // $state service and $stateProvider
	    // $urlRouter service and $urlRouterProvider
	    var getStateProvider = function () { return core.extend(router.stateProvider, { $get: function () { return router.stateService; } }); };
	    watchDigests.$inject = ['$rootScope'];
	    function watchDigests($rootScope) {
	        $rootScope.$watch(function () {
	            core.trace.approximateDigests++;
	        });
	    }
	    mod_init.provider('$uiRouter', $uiRouterProvider);
	    mod_rtr.provider('$urlRouter', ['$uiRouterProvider', getUrlRouterProvider]);
	    mod_util.provider('$urlService', getProviderFor('urlService'));
	    mod_util.provider('$urlMatcherFactory', ['$uiRouterProvider', function () { return router.urlMatcherFactory; }]);
	    mod_util.provider('$templateFactory', function () { return new TemplateFactory(); });
	    mod_state.provider('$stateRegistry', getProviderFor('stateRegistry'));
	    mod_state.provider('$uiRouterGlobals', getProviderFor('globals'));
	    mod_state.provider('$transitions', getProviderFor('transitionService'));
	    mod_state.provider('$state', ['$uiRouterProvider', getStateProvider]);
	    mod_state.factory('$stateParams', ['$uiRouter', function ($uiRouter) { return $uiRouter.globals.params; }]);
	    mod_main.factory('$view', function () { return router.viewService; });
	    mod_main.service('$trace', function () { return core.trace; });
	    mod_main.run(watchDigests);
	    mod_util.run(['$urlMatcherFactory', function ($urlMatcherFactory) { }]);
	    mod_state.run(['$state', function ($state) { }]);
	    mod_rtr.run(['$urlRouter', function ($urlRouter) { }]);
	    mod_init.run(runBlock);
	    /** @hidden TODO: find a place to move this */
	    var getLocals = function (ctx) {
	        var tokens = ctx.getTokens().filter(core.isString);
	        var tuples = tokens.map(function (key) {
	            var resolvable = ctx.getResolvable(key);
	            var waitPolicy = ctx.getPolicy(resolvable).async;
	            return [key, waitPolicy === 'NOWAIT' ? resolvable.promise : resolvable.data];
	        });
	        return tuples.reduce(core.applyPairs, {});
	    };
	
	    /* eslint-disable @typescript-eslint/no-empty-interface */
	    /** @hidden */
	    function parseStateRef(ref) {
	        var paramsOnly = ref.match(/^\s*({[^}]*})\s*$/);
	        if (paramsOnly)
	            ref = '(' + paramsOnly[1] + ')';
	        var parsed = ref.replace(/\n/g, ' ').match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
	        if (!parsed || parsed.length !== 4)
	            throw new Error("Invalid state ref '" + ref + "'");
	        return { state: parsed[1] || null, paramExpr: parsed[3] || null };
	    }
	    /** @hidden */
	    function stateContext(el) {
	        var $uiView = el.parent().inheritedData('$uiView');
	        var path = core.parse('$cfg.path')($uiView);
	        return path ? core.tail(path).state.name : undefined;
	    }
	    /** @hidden */
	    function processedDef($state, $element, def) {
	        var uiState = def.uiState || $state.current.name;
	        var uiStateOpts = core.extend(defaultOpts($element, $state), def.uiStateOpts || {});
	        var href = $state.href(uiState, def.uiStateParams, uiStateOpts);
	        return { uiState: uiState, uiStateParams: def.uiStateParams, uiStateOpts: uiStateOpts, href: href };
	    }
	    /** @hidden */
	    function getTypeInfo(el) {
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	        var isForm = el[0].nodeName === 'FORM';
	        return {
	            attr: isForm ? 'action' : isSvg ? 'xlink:href' : 'href',
	            isAnchor: el.prop('tagName').toUpperCase() === 'A',
	            clickable: !isForm,
	        };
	    }
	    /** @hidden */
	    function clickHook(el, $state, $timeout, type, getDef) {
	        return function (e) {
	            var button = e.which || e.button, target = getDef();
	            if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || el.attr('target'))) {
	                // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	                var transition_1 = $timeout(function () {
	                    if (!el.attr('disabled')) {
	                        $state.go(target.uiState, target.uiStateParams, target.uiStateOpts);
	                    }
	                });
	                e.preventDefault();
	                // if the state has no URL, ignore one preventDefault from the <a> directive.
	                var ignorePreventDefaultCount_1 = type.isAnchor && !target.href ? 1 : 0;
	                e.preventDefault = function () {
	                    if (ignorePreventDefaultCount_1-- <= 0)
	                        $timeout.cancel(transition_1);
	                };
	            }
	        };
	    }
	    /** @hidden */
	    function defaultOpts(el, $state) {
	        return {
	            relative: stateContext(el) || $state.$current,
	            inherit: true,
	            source: 'sref',
	        };
	    }
	    /** @hidden */
	    function bindEvents(element, scope, hookFn, uiStateOpts) {
	        var events;
	        if (uiStateOpts) {
	            events = uiStateOpts.events;
	        }
	        if (!core.isArray(events)) {
	            events = ['click'];
	        }
	        var on = element.on ? 'on' : 'bind';
	        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
	            var event_1 = events_1[_i];
	            element[on](event_1, hookFn);
	        }
	        scope.$on('$destroy', function () {
	            var off = element.off ? 'off' : 'unbind';
	            for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
	                var event_2 = events_2[_i];
	                element[off](event_2, hookFn);
	            }
	        });
	    }
	    /**
	     * `ui-sref`: A directive for linking to a state
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * ### Linked State
	     * The attribute value of the `ui-sref` is the name of the state to link to.
	     *
	     * #### Example:
	     * This will activate the `home` state when the link is clicked.
	     * ```html
	     * <a ui-sref="home">Home</a>
	     * ```
	     *
	     * ### Relative Links
	     * You can also use relative state paths within `ui-sref`, just like a relative path passed to `$state.go()` ([[StateService.go]]).
	     * You just need to be aware that the path is relative to the state that *created* the link.
	     * This allows a state to create a relative `ui-sref` which always targets the same destination.
	     *
	     * #### Example:
	     * Both these links are relative to the parent state, even when a child state is currently active.
	     * ```html
	     * <a ui-sref=".child1">child 1 state</a>
	     * <a ui-sref=".child2">child 2 state</a>
	     * ```
	     *
	     * This link activates the parent state.
	     * ```html
	     * <a ui-sref="^">Return</a>
	     * ```
	     *
	     * ### hrefs
	     * If the linked state has a URL, the directive will automatically generate and
	     * update the `href` attribute (using the [[StateService.href]]  method).
	     *
	     * #### Example:
	     * Assuming the `users` state has a url of `/users/`
	     * ```html
	     * <a ui-sref="users" href="/users/">Users</a>
	     * ```
	     *
	     * ### Parameter Values
	     * In addition to the state name, a `ui-sref` can include parameter values which are applied when activating the state.
	     * Param values can be provided in the `ui-sref` value after the state name, enclosed by parentheses.
	     * The content inside the parentheses is an expression, evaluated to the parameter values.
	     *
	     * #### Example:
	     * This example renders a list of links to users.
	     * The state's `userId` parameter value comes from each user's `user.id` property.
	     * ```html
	     * <li ng-repeat="user in users">
	     *   <a ui-sref="users.detail({ userId: user.id })">{{ user.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * Note:
	     * The parameter values expression is `$watch`ed for updates.
	     *
	     * ### Transition Options
	     * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-sref-opts` attribute.
	     * Options are restricted to `location`, `inherit`, and `reload`.
	     *
	     * #### Example:
	     * ```html
	     * <a ui-sref="home" ui-sref-opts="{ reload: true }">Home</a>
	     * ```
	     *
	     * ### Other DOM Events
	     *
	     * You can also customize which DOM events to respond to (instead of `click`) by
	     * providing an `events` array in the `ui-sref-opts` attribute.
	     *
	     * #### Example:
	     * ```html
	     * <input type="text" ui-sref="contacts" ui-sref-opts="{ events: ['change', 'blur'] }">
	     * ```
	     *
	     * ### Highlighting the active link
	     * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
	     *
	     * ### Examples
	     * If you have the following template:
	     *
	     * ```html
	     * <a ui-sref="home">Home</a>
	     * <a ui-sref="about">About</a>
	     * <a ui-sref="{page: 2}">Next page</a>
	     *
	     * <ul>
	     *     <li ng-repeat="contact in contacts">
	     *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	     *     </li>
	     * </ul>
	     * ```
	     *
	     * Then (assuming the current state is `contacts`) the rendered html including hrefs would be:
	     *
	     * ```html
	     * <a href="#/home" ui-sref="home">Home</a>
	     * <a href="#/about" ui-sref="about">About</a>
	     * <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	     *
	     * <ul>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	     *     </li>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	     *     </li>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	     *     </li>
	     * </ul>
	     *
	     * <a href="#/home" ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	     * ```
	     *
	     * ### Notes
	     *
	     * - You can use `ui-sref` to change **only the parameter values** by omitting the state name and parentheses.
	     * #### Example:
	     * Sets the `lang` parameter to `en` and remains on the same state.
	     *
	     * ```html
	     * <a ui-sref="{ lang: 'en' }">English</a>
	     * ```
	     *
	     * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
	     *
	     * - Unlike the parameter values expression, the state name is not `$watch`ed (for performance reasons).
	     * If you need to dynamically update the state being linked to, use the fully dynamic [[uiState]] directive.
	     */
	    var uiSrefDirective;
	    uiSrefDirective = [
	        '$uiRouter',
	        '$timeout',
	        function $StateRefDirective($uiRouter, $timeout) {
	            var $state = $uiRouter.stateService;
	            return {
	                restrict: 'A',
	                require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	                link: function (scope, element, attrs, uiSrefActive) {
	                    var type = getTypeInfo(element);
	                    var active = uiSrefActive[1] || uiSrefActive[0];
	                    var unlinkInfoFn = null;
	                    var rawDef = {};
	                    var getDef = function () { return processedDef($state, element, rawDef); };
	                    var ref = parseStateRef(attrs.uiSref);
	                    rawDef.uiState = ref.state;
	                    rawDef.uiStateOpts = attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {};
	                    function update() {
	                        var def = getDef();
	                        if (unlinkInfoFn)
	                            unlinkInfoFn();
	                        if (active)
	                            unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
	                        if (def.href != null)
	                            attrs.$set(type.attr, def.href);
	                    }
	                    if (ref.paramExpr) {
	                        scope.$watch(ref.paramExpr, function (val) {
	                            rawDef.uiStateParams = core.extend({}, val);
	                            update();
	                        }, true);
	                        rawDef.uiStateParams = core.extend({}, scope.$eval(ref.paramExpr));
	                    }
	                    update();
	                    scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
	                    scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
	                    if (!type.clickable)
	                        return;
	                    var hookFn = clickHook(element, $state, $timeout, type, getDef);
	                    bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
	                },
	            };
	        },
	    ];
	    /**
	     * `ui-state`: A fully dynamic directive for linking to a state
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * **This directive is very similar to [[uiSref]], but it `$observe`s and `$watch`es/evaluates all its inputs.**
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * ### Linked State
	     * The attribute value of `ui-state` is an expression which is `$watch`ed and evaluated as the state to link to.
	     * **This is in contrast with `ui-sref`, which takes a state name as a string literal.**
	     *
	     * #### Example:
	     * Create a list of links.
	     * ```html
	     * <li ng-repeat="link in navlinks">
	     *   <a ui-state="link.state">{{ link.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Relative Links
	     * If the expression evaluates to a relative path, it is processed like [[uiSref]].
	     * You just need to be aware that the path is relative to the state that *created* the link.
	     * This allows a state to create relative `ui-state` which always targets the same destination.
	     *
	     * ### hrefs
	     * If the linked state has a URL, the directive will automatically generate and
	     * update the `href` attribute (using the [[StateService.href]]  method).
	     *
	     * ### Parameter Values
	     * In addition to the state name expression, a `ui-state` can include parameter values which are applied when activating the state.
	     * Param values should be provided using the `ui-state-params` attribute.
	     * The `ui-state-params` attribute value is `$watch`ed and evaluated as an expression.
	     *
	     * #### Example:
	     * This example renders a list of links with param values.
	     * The state's `userId` parameter value comes from each user's `user.id` property.
	     * ```html
	     * <li ng-repeat="link in navlinks">
	     *   <a ui-state="link.state" ui-state-params="link.params">{{ link.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Transition Options
	     * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-state-opts` attribute.
	     * Options are restricted to `location`, `inherit`, and `reload`.
	     * The value of the `ui-state-opts` is `$watch`ed and evaluated as an expression.
	     *
	     * #### Example:
	     * ```html
	     * <a ui-state="returnto.state" ui-state-opts="{ reload: true }">Home</a>
	     * ```
	     *
	     * ### Other DOM Events
	     *
	     * You can also customize which DOM events to respond to (instead of `click`) by
	     * providing an `events` array in the `ui-state-opts` attribute.
	     *
	     * #### Example:
	     * ```html
	     * <input type="text" ui-state="contacts" ui-state-opts="{ events: ['change', 'blur'] }">
	     * ```
	     *
	     * ### Highlighting the active link
	     * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
	     *
	     * ### Notes
	     *
	     * - You can use `ui-params` to change **only the parameter values** by omitting the state name and supplying only `ui-state-params`.
	     *   However, it might be simpler to use [[uiSref]] parameter-only links.
	     *
	     * #### Example:
	     * Sets the `lang` parameter to `en` and remains on the same state.
	     *
	     * ```html
	     * <a ui-state="" ui-state-params="{ lang: 'en' }">English</a>
	     * ```
	     *
	     * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
	     * ```
	     */
	    var uiStateDirective;
	    uiStateDirective = [
	        '$uiRouter',
	        '$timeout',
	        function $StateRefDynamicDirective($uiRouter, $timeout) {
	            var $state = $uiRouter.stateService;
	            return {
	                restrict: 'A',
	                require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	                link: function (scope, element, attrs, uiSrefActive) {
	                    var type = getTypeInfo(element);
	                    var active = uiSrefActive[1] || uiSrefActive[0];
	                    var unlinkInfoFn = null;
	                    var hookFn;
	                    var rawDef = {};
	                    var getDef = function () { return processedDef($state, element, rawDef); };
	                    var inputAttrs = ['uiState', 'uiStateParams', 'uiStateOpts'];
	                    var watchDeregFns = inputAttrs.reduce(function (acc, attr) { return ((acc[attr] = core.noop), acc); }, {});
	                    function update() {
	                        var def = getDef();
	                        if (unlinkInfoFn)
	                            unlinkInfoFn();
	                        if (active)
	                            unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
	                        if (def.href != null)
	                            attrs.$set(type.attr, def.href);
	                    }
	                    inputAttrs.forEach(function (field) {
	                        rawDef[field] = attrs[field] ? scope.$eval(attrs[field]) : null;
	                        attrs.$observe(field, function (expr) {
	                            watchDeregFns[field]();
	                            watchDeregFns[field] = scope.$watch(expr, function (newval) {
	                                rawDef[field] = newval;
	                                update();
	                            }, true);
	                        });
	                    });
	                    update();
	                    scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
	                    scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
	                    if (!type.clickable)
	                        return;
	                    hookFn = clickHook(element, $state, $timeout, type, getDef);
	                    bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
	                },
	            };
	        },
	    ];
	    /**
	     * `ui-sref-active` and `ui-sref-active-eq`: A directive that adds a CSS class when a `ui-sref` is active
	     *
	     * A directive working alongside [[uiSref]] and [[uiState]] to add classes to an element when the
	     * related directive's state is active (and remove them when it is inactive).
	     *
	     * The primary use-case is to highlight the active link in navigation menus,
	     * distinguishing it from the inactive menu items.
	     *
	     * ### Linking to a `ui-sref` or `ui-state`
	     * `ui-sref-active` can live on the same element as `ui-sref`/`ui-state`, or it can be on a parent element.
	     * If a `ui-sref-active` is a parent to more than one `ui-sref`/`ui-state`, it will apply the CSS class when **any of the links are active**.
	     *
	     * ### Matching
	     *
	     * The `ui-sref-active` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state **or any child state is active**.
	     * This is a "fuzzy match" which uses [[StateService.includes]].
	     *
	     * The `ui-sref-active-eq` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state is directly active (not when child states are active).
	     * This is an "exact match" which uses [[StateService.is]].
	     *
	     * ### Parameter values
	     * If the `ui-sref`/`ui-state` includes parameter values, the current parameter values must match the link's values for the link to be highlighted.
	     * This allows a list of links to the same state with different parameters to be rendered, and the correct one highlighted.
	     *
	     * #### Example:
	     * ```html
	     * <li ng-repeat="user in users" ui-sref-active="active">
	     *   <a ui-sref="user.details({ userId: user.id })">{{ user.lastName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Examples
	     *
	     * Given the following template:
	     * #### Example:
	     * ```html
	     * <ul>
	     *   <li ui-sref-active="active" class="item">
	     *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	     *   </li>
	     * </ul>
	     * ```
	     *
	     * When the app state is `app.user` (or any child state),
	     * and contains the state parameter "user" with value "bilbobaggins",
	     * the resulting HTML will appear as (note the 'active' class):
	     *
	     * ```html
	     * <ul>
	     *   <li ui-sref-active="active" class="item active">
	     *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	     *   </li>
	     * </ul>
	     * ```
	     *
	     * ### Glob mode
	     *
	     * It is possible to pass `ui-sref-active` an expression that evaluates to an object.
	     * The objects keys represent active class names and values represent the respective state names/globs.
	     * `ui-sref-active` will match if the current active state **includes** any of
	     * the specified state names/globs, even the abstract ones.
	     *
	     * #### Example:
	     * Given the following template, with "admin" being an abstract state:
	     * ```html
	     * <div ui-sref-active="{'active': 'admin.**'}">
	     *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	     * </div>
	     * ```
	     *
	     * Arrays are also supported as values in the `ngClass`-like interface.
	     * This allows multiple states to add `active` class.
	     *
	     * #### Example:
	     * Given the following template, with "admin.roles" being the current state, the class will be added too:
	     * ```html
	     * <div ui-sref-active="{'active': ['owner.**', 'admin.**']}">
	     *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	     * </div>
	     * ```
	     *
	     * When the current state is "admin.roles" the "active" class will be applied to both the `<div>` and `<a>` elements.
	     * It is important to note that the state names/globs passed to `ui-sref-active` override any state provided by a linked `ui-sref`.
	     *
	     * ### Notes:
	     *
	     * - The class name is interpolated **once** during the directives link time (any further changes to the
	     * interpolated value are ignored).
	     *
	     * - Multiple classes may be specified in a space-separated format: `ui-sref-active='class1 class2 class3'`
	     */
	    var uiSrefActiveDirective;
	    uiSrefActiveDirective = [
	        '$state',
	        '$stateParams',
	        '$interpolate',
	        '$uiRouter',
	        function $StateRefActiveDirective($state, $stateParams, $interpolate, $uiRouter) {
	            return {
	                restrict: 'A',
	                controller: [
	                    '$scope',
	                    '$element',
	                    '$attrs',
	                    function ($scope, $element, $attrs) {
	                        var states = [];
	                        var activeEqClass;
	                        var uiSrefActive;
	                        // There probably isn't much point in $observing this
	                        // uiSrefActive and uiSrefActiveEq share the same directive object with some
	                        // slight difference in logic routing
	                        activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	                        try {
	                            uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	                        }
	                        catch (e) {
	                            // Do nothing. uiSrefActive is not a valid expression.
	                            // Fall back to using $interpolate below
	                        }
	                        uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	                        setStatesFromDefinitionObject(uiSrefActive);
	                        // Allow uiSref to communicate with uiSrefActive[Equals]
	                        this.$$addStateInfo = function (newState, newParams) {
	                            // we already got an explicit state provided by ui-sref-active, so we
	                            // shadow the one that comes from ui-sref
	                            if (core.isObject(uiSrefActive) && states.length > 0) {
	                                return;
	                            }
	                            var deregister = addState(newState, newParams, uiSrefActive);
	                            update();
	                            return deregister;
	                        };
	                        function updateAfterTransition(trans) {
	                            trans.promise.then(update, core.noop);
	                        }
	                        $scope.$on('$destroy', setupEventListeners());
	                        if ($uiRouter.globals.transition) {
	                            updateAfterTransition($uiRouter.globals.transition);
	                        }
	                        function setupEventListeners() {
	                            var deregisterStatesChangedListener = $uiRouter.stateRegistry.onStatesChanged(handleStatesChanged);
	                            var deregisterOnStartListener = $uiRouter.transitionService.onStart({}, updateAfterTransition);
	                            var deregisterStateChangeSuccessListener = $scope.$on('$stateChangeSuccess', update);
	                            return function cleanUp() {
	                                deregisterStatesChangedListener();
	                                deregisterOnStartListener();
	                                deregisterStateChangeSuccessListener();
	                            };
	                        }
	                        function handleStatesChanged() {
	                            setStatesFromDefinitionObject(uiSrefActive);
	                        }
	                        function setStatesFromDefinitionObject(statesDefinition) {
	                            if (core.isObject(statesDefinition)) {
	                                states = [];
	                                core.forEach(statesDefinition, function (stateOrName, activeClass) {
	                                    // Helper function to abstract adding state.
	                                    var addStateForClass = function (stateOrName, activeClass) {
	                                        var ref = parseStateRef(stateOrName);
	                                        addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	                                    };
	                                    if (core.isString(stateOrName)) {
	                                        // If state is string, just add it.
	                                        addStateForClass(stateOrName, activeClass);
	                                    }
	                                    else if (core.isArray(stateOrName)) {
	                                        // If state is an array, iterate over it and add each array item individually.
	                                        core.forEach(stateOrName, function (stateOrName) {
	                                            addStateForClass(stateOrName, activeClass);
	                                        });
	                                    }
	                                });
	                            }
	                        }
	                        function addState(stateName, stateParams, activeClass) {
	                            var state = $state.get(stateName, stateContext($element));
	                            var stateInfo = {
	                                state: state || { name: stateName },
	                                params: stateParams,
	                                activeClass: activeClass,
	                            };
	                            states.push(stateInfo);
	                            return function removeState() {
	                                core.removeFrom(states)(stateInfo);
	                            };
	                        }
	                        // Update route state
	                        function update() {
	                            var splitClasses = function (str) { return str.split(/\s/).filter(core.identity); };
	                            var getClasses = function (stateList) {
	                                return stateList
	                                    .map(function (x) { return x.activeClass; })
	                                    .map(splitClasses)
	                                    .reduce(core.unnestR, []);
	                            };
	                            var allClasses = getClasses(states).concat(splitClasses(activeEqClass)).reduce(core.uniqR, []);
	                            var fuzzyClasses = getClasses(states.filter(function (x) { return $state.includes(x.state.name, x.params); }));
	                            var exactlyMatchesAny = !!states.filter(function (x) { return $state.is(x.state.name, x.params); }).length;
	                            var exactClasses = exactlyMatchesAny ? splitClasses(activeEqClass) : [];
	                            var addClasses = fuzzyClasses.concat(exactClasses).reduce(core.uniqR, []);
	                            var removeClasses = allClasses.filter(function (cls) { return !core.inArray(addClasses, cls); });
	                            $scope.$evalAsync(function () {
	                                addClasses.forEach(function (className) { return $element.addClass(className); });
	                                removeClasses.forEach(function (className) { return $element.removeClass(className); });
	                            });
	                        }
	                        update();
	                    },
	                ],
	            };
	        },
	    ];
	    ng
	        .module('ui.router.state')
	        .directive('uiSref', uiSrefDirective)
	        .directive('uiSrefActive', uiSrefActiveDirective)
	        .directive('uiSrefActiveEq', uiSrefActiveDirective)
	        .directive('uiState', uiStateDirective);
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * `isState` Filter: truthy if the current state is the parameter
	     *
	     * Translates to [[StateService.is]] `$state.is("stateName")`.
	     *
	     * #### Example:
	     * ```html
	     * <div ng-if="'stateName' | isState">show if state is 'stateName'</div>
	     * ```
	     */
	    $IsStateFilter.$inject = ['$state'];
	    function $IsStateFilter($state) {
	        var isFilter = function (state, params, options) {
	            return $state.is(state, params, options);
	        };
	        isFilter.$stateful = true;
	        return isFilter;
	    }
	    /**
	     * `includedByState` Filter: truthy if the current state includes the parameter
	     *
	     * Translates to [[StateService.includes]]` $state.is("fullOrPartialStateName")`.
	     *
	     * #### Example:
	     * ```html
	     * <div ng-if="'fullOrPartialStateName' | includedByState">show if state includes 'fullOrPartialStateName'</div>
	     * ```
	     */
	    $IncludedByStateFilter.$inject = ['$state'];
	    function $IncludedByStateFilter($state) {
	        var includesFilter = function (state, params, options) {
	            return $state.includes(state, params, options);
	        };
	        includesFilter.$stateful = true;
	        return includesFilter;
	    }
	    ng.module('ui.router.state').filter('isState', $IsStateFilter).filter('includedByState', $IncludedByStateFilter);
	
	    /** @publicapi @module directives */ /** */
	    /**
	     * `ui-view`: A viewport directive which is filled in by a view from the active state.
	     *
	     * ### Attributes
	     *
	     * - `name`: (Optional) A view name.
	     *   The name should be unique amongst the other views in the same state.
	     *   You can have views of the same name that live in different states.
	     *   The ui-view can be targeted in a View using the name ([[Ng1StateDeclaration.views]]).
	     *
	     * - `autoscroll`: an expression. When it evaluates to true, the `ui-view` will be scrolled into view when it is activated.
	     *   Uses [[$uiViewScroll]] to do the scrolling.
	     *
	     * - `onload`: Expression to evaluate whenever the view updates.
	     *
	     * #### Example:
	     * A view can be unnamed or named.
	     * ```html
	     * <!-- Unnamed -->
	     * <div ui-view></div>
	     *
	     * <!-- Named -->
	     * <div ui-view="viewName"></div>
	     *
	     * <!-- Named (different style) -->
	     * <ui-view name="viewName"></ui-view>
	     * ```
	     *
	     * You can only have one unnamed view within any template (or root html). If you are only using a
	     * single view and it is unnamed then you can populate it like so:
	     *
	     * ```html
	     * <div ui-view></div>
	     * $stateProvider.state("home", {
	     *   template: "<h1>HELLO!</h1>"
	     * })
	     * ```
	     *
	     * The above is a convenient shortcut equivalent to specifying your view explicitly with the
	     * [[Ng1StateDeclaration.views]] config property, by name, in this case an empty name:
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "": {
	     *       template: "<h1>HELLO!</h1>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * But typically you'll only use the views property if you name your view or have more than one view
	     * in the same template. There's not really a compelling reason to name a view if its the only one,
	     * but you could if you wanted, like so:
	     *
	     * ```html
	     * <div ui-view="main"></div>
	     * ```
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "main": {
	     *       template: "<h1>HELLO!</h1>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * Really though, you'll use views to set up multiple views:
	     *
	     * ```html
	     * <div ui-view></div>
	     * <div ui-view="chart"></div>
	     * <div ui-view="data"></div>
	     * ```
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "": {
	     *       template: "<h1>HELLO!</h1>"
	     *     },
	     *     "chart": {
	     *       template: "<chart_thing/>"
	     *     },
	     *     "data": {
	     *       template: "<data_thing/>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * #### Examples for `autoscroll`:
	     * ```html
	     * <!-- If autoscroll present with no expression,
	     *      then scroll ui-view into view -->
	     * <ui-view autoscroll/>
	     *
	     * <!-- If autoscroll present with valid expression,
	     *      then scroll ui-view into view if expression evaluates to true -->
	     * <ui-view autoscroll='true'/>
	     * <ui-view autoscroll='false'/>
	     * <ui-view autoscroll='scopeVariable'/>
	     * ```
	     *
	     * Resolve data:
	     *
	     * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
	     * can be customized using [[Ng1ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
	     *
	     * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
	     * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
	     * depends on `$resolve` data.
	     *
	     * #### Example:
	     * ```js
	     * $stateProvider.state('home', {
	     *   template: '<my-component user="$resolve.user"></my-component>',
	     *   resolve: {
	     *     user: function(UserService) { return UserService.fetchUser(); }
	     *   }
	     * });
	     * ```
	     */
	    var uiView;
	    // eslint-disable-next-line prefer-const
	    uiView = [
	        '$view',
	        '$animate',
	        '$uiViewScroll',
	        '$interpolate',
	        '$q',
	        function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
	            function getRenderer() {
	                return {
	                    enter: function (element, target, cb) {
	                        if (ng.version.minor > 2) {
	                            $animate.enter(element, null, target).then(cb);
	                        }
	                        else {
	                            $animate.enter(element, null, target, cb);
	                        }
	                    },
	                    leave: function (element, cb) {
	                        if (ng.version.minor > 2) {
	                            $animate.leave(element).then(cb);
	                        }
	                        else {
	                            $animate.leave(element, cb);
	                        }
	                    },
	                };
	            }
	            function configsEqual(config1, config2) {
	                return config1 === config2;
	            }
	            var rootData = {
	                $cfg: { viewDecl: { $context: $view._pluginapi._rootViewContext() } },
	                $uiView: {},
	            };
	            var directive = {
	                count: 0,
	                restrict: 'ECA',
	                terminal: true,
	                priority: 400,
	                transclude: 'element',
	                compile: function (tElement, tAttrs, $transclude) {
	                    return function (scope, $element, attrs) {
	                        var onloadExp = attrs['onload'] || '', autoScrollExp = attrs['autoscroll'], renderer = getRenderer(), inherited = $element.inheritedData('$uiView') || rootData, name = $interpolate(attrs['uiView'] || attrs['name'] || '')(scope) || '$default';
	                        var previousEl, currentEl, currentScope, viewConfig;
	                        var activeUIView = {
	                            $type: 'ng1',
	                            id: directive.count++,
	                            name: name,
	                            fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + '.' + name : name,
	                            config: null,
	                            configUpdated: configUpdatedCallback,
	                            get creationContext() {
	                                // The context in which this ui-view "tag" was created
	                                var fromParentTagConfig = core.parse('$cfg.viewDecl.$context')(inherited);
	                                // Allow <ui-view name="foo"><ui-view name="bar"></ui-view></ui-view>
	                                // See https://github.com/angular-ui/ui-router/issues/3355
	                                var fromParentTag = core.parse('$uiView.creationContext')(inherited);
	                                return fromParentTagConfig || fromParentTag;
	                            },
	                        };
	                        core.trace.traceUIViewEvent('Linking', activeUIView);
	                        function configUpdatedCallback(config) {
	                            if (config && !(config instanceof Ng1ViewConfig))
	                                return;
	                            if (configsEqual(viewConfig, config))
	                                return;
	                            core.trace.traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
	                            viewConfig = config;
	                            updateView(config);
	                        }
	                        $element.data('$uiView', { $uiView: activeUIView });
	                        updateView();
	                        var unregister = $view.registerUIView(activeUIView);
	                        scope.$on('$destroy', function () {
	                            core.trace.traceUIViewEvent('Destroying/Unregistering', activeUIView);
	                            unregister();
	                        });
	                        function cleanupLastView() {
	                            if (previousEl) {
	                                core.trace.traceUIViewEvent('Removing (previous) el', previousEl.data('$uiView'));
	                                previousEl.remove();
	                                previousEl = null;
	                            }
	                            if (currentScope) {
	                                core.trace.traceUIViewEvent('Destroying scope', activeUIView);
	                                currentScope.$destroy();
	                                currentScope = null;
	                            }
	                            if (currentEl) {
	                                var _viewData_1 = currentEl.data('$uiViewAnim');
	                                core.trace.traceUIViewEvent('Animate out', _viewData_1);
	                                renderer.leave(currentEl, function () {
	                                    _viewData_1.$$animLeave.resolve();
	                                    previousEl = null;
	                                });
	                                previousEl = currentEl;
	                                currentEl = null;
	                            }
	                        }
	                        function updateView(config) {
	                            var newScope = scope.$new();
	                            var animEnter = $q.defer(), animLeave = $q.defer();
	                            var $uiViewData = {
	                                $cfg: config,
	                                $uiView: activeUIView,
	                            };
	                            var $uiViewAnim = {
	                                $animEnter: animEnter.promise,
	                                $animLeave: animLeave.promise,
	                                $$animLeave: animLeave,
	                            };
	                            /**
	                             * @ngdoc event
	                             * @name ui.router.state.directive:ui-view#$viewContentLoading
	                             * @eventOf ui.router.state.directive:ui-view
	                             * @eventType emits on ui-view directive scope
	                             * @description
	                             *
	                             * Fired once the view **begins loading**, *before* the DOM is rendered.
	                             *
	                             * @param {Object} event Event object.
	                             * @param {string} viewName Name of the view.
	                             */
	                            newScope.$emit('$viewContentLoading', name);
	                            var cloned = $transclude(newScope, function (clone) {
	                                clone.data('$uiViewAnim', $uiViewAnim);
	                                clone.data('$uiView', $uiViewData);
	                                renderer.enter(clone, $element, function onUIViewEnter() {
	                                    animEnter.resolve();
	                                    if (currentScope)
	                                        currentScope.$emit('$viewContentAnimationEnded');
	                                    if ((core.isDefined(autoScrollExp) && !autoScrollExp) || scope.$eval(autoScrollExp)) {
	                                        $uiViewScroll(clone);
	                                    }
	                                });
	                                cleanupLastView();
	                            });
	                            currentEl = cloned;
	                            currentScope = newScope;
	                            /**
	                             * @ngdoc event
	                             * @name ui.router.state.directive:ui-view#$viewContentLoaded
	                             * @eventOf ui.router.state.directive:ui-view
	                             * @eventType emits on ui-view directive scope
	                             * @description           *
	                             * Fired once the view is **loaded**, *after* the DOM is rendered.
	                             *
	                             * @param {Object} event Event object.
	                             */
	                            currentScope.$emit('$viewContentLoaded', config || viewConfig);
	                            currentScope.$eval(onloadExp);
	                        }
	                    };
	                },
	            };
	            return directive;
	        },
	    ];
	    $ViewDirectiveFill.$inject = ['$compile', '$controller', '$transitions', '$view', '$q'];
	    /** @hidden */
	    function $ViewDirectiveFill($compile, $controller, $transitions, $view, $q) {
	        var getControllerAs = core.parse('viewDecl.controllerAs');
	        var getResolveAs = core.parse('viewDecl.resolveAs');
	        return {
	            restrict: 'ECA',
	            priority: -400,
	            compile: function (tElement) {
	                var initial = tElement.html();
	                tElement.empty();
	                return function (scope, $element) {
	                    var data = $element.data('$uiView');
	                    if (!data) {
	                        $element.html(initial);
	                        $compile($element.contents())(scope);
	                        return;
	                    }
	                    var cfg = data.$cfg || { viewDecl: {}, getTemplate: core.noop };
	                    var resolveCtx = cfg.path && new core.ResolveContext(cfg.path);
	                    $element.html(cfg.getTemplate($element, resolveCtx) || initial);
	                    core.trace.traceUIViewFill(data.$uiView, $element.html());
	                    var link = $compile($element.contents());
	                    var controller = cfg.controller;
	                    var controllerAs = getControllerAs(cfg);
	                    var resolveAs = getResolveAs(cfg);
	                    var locals = resolveCtx && getLocals(resolveCtx);
	                    scope[resolveAs] = locals;
	                    if (controller) {
	                        var controllerInstance = ($controller(controller, core.extend({}, locals, { $scope: scope, $element: $element })));
	                        if (controllerAs) {
	                            scope[controllerAs] = controllerInstance;
	                            scope[controllerAs][resolveAs] = locals;
	                        }
	                        // TODO: Use $view service as a central point for registering component-level hooks
	                        // Then, when a component is created, tell the $view service, so it can invoke hooks
	                        // $view.componentLoaded(controllerInstance, { $scope: scope, $element: $element });
	                        // scope.$on('$destroy', () => $view.componentUnloaded(controllerInstance, { $scope: scope, $element: $element }));
	                        $element.data('$ngControllerController', controllerInstance);
	                        $element.children().data('$ngControllerController', controllerInstance);
	                        registerControllerCallbacks($q, $transitions, controllerInstance, scope, cfg);
	                    }
	                    // Wait for the component to appear in the DOM
	                    if (core.isString(cfg.component)) {
	                        var kebobName = core.kebobString(cfg.component);
	                        var tagRegexp_1 = new RegExp("^(x-|data-)?" + kebobName + "$", 'i');
	                        var getComponentController = function () {
	                            var directiveEl = [].slice
	                                .call($element[0].children)
	                                .filter(function (el) { return el && el.tagName && tagRegexp_1.exec(el.tagName); });
	                            return directiveEl && ng.element(directiveEl).data("$" + cfg.component + "Controller");
	                        };
	                        var deregisterWatch_1 = scope.$watch(getComponentController, function (ctrlInstance) {
	                            if (!ctrlInstance)
	                                return;
	                            registerControllerCallbacks($q, $transitions, ctrlInstance, scope, cfg);
	                            deregisterWatch_1();
	                        });
	                    }
	                    link(scope);
	                };
	            },
	        };
	    }
	    /** @hidden */
	    var hasComponentImpl = typeof ng.module('ui.router')['component'] === 'function';
	    /** @hidden incrementing id */
	    var _uiCanExitId = 0;
	    /** @hidden TODO: move these callbacks to $view and/or `/hooks/components.ts` or something */
	    function registerControllerCallbacks($q, $transitions, controllerInstance, $scope, cfg) {
	        // Call $onInit() ASAP
	        if (core.isFunction(controllerInstance.$onInit) &&
	            !((cfg.viewDecl.component || cfg.viewDecl.componentProvider) && hasComponentImpl)) {
	            controllerInstance.$onInit();
	        }
	        var viewState = core.tail(cfg.path).state.self;
	        var hookOptions = { bind: controllerInstance };
	        // Add component-level hook for onUiParamsChanged
	        if (core.isFunction(controllerInstance.uiOnParamsChanged)) {
	            var resolveContext = new core.ResolveContext(cfg.path);
	            var viewCreationTrans_1 = resolveContext.getResolvable('$transition$').data;
	            // Fire callback on any successful transition
	            var paramsUpdated = function ($transition$) {
	                // Exit early if the $transition$ is the same as the view was created within.
	                // Exit early if the $transition$ will exit the state the view is for.
	                if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1)
	                    return;
	                var toParams = $transition$.params('to');
	                var fromParams = $transition$.params('from');
	                var getNodeSchema = function (node) { return node.paramSchema; };
	                var toSchema = $transition$.treeChanges('to').map(getNodeSchema).reduce(core.unnestR, []);
	                var fromSchema = $transition$.treeChanges('from').map(getNodeSchema).reduce(core.unnestR, []);
	                // Find the to params that have different values than the from params
	                var changedToParams = toSchema.filter(function (param) {
	                    var idx = fromSchema.indexOf(param);
	                    return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
	                });
	                // Only trigger callback if a to param has changed or is new
	                if (changedToParams.length) {
	                    var changedKeys_1 = changedToParams.map(function (x) { return x.id; });
	                    // Filter the params to only changed/new to params.  `$transition$.params()` may be used to get all params.
	                    var newValues = core.filter(toParams, function (val, key) { return changedKeys_1.indexOf(key) !== -1; });
	                    controllerInstance.uiOnParamsChanged(newValues, $transition$);
	                }
	            };
	            $scope.$on('$destroy', $transitions.onSuccess({}, paramsUpdated, hookOptions));
	        }
	        // Add component-level hook for uiCanExit
	        if (core.isFunction(controllerInstance.uiCanExit)) {
	            var id_1 = _uiCanExitId++;
	            var cacheProp_1 = '_uiCanExitIds';
	            // Returns true if a redirect transition already answered truthy
	            var prevTruthyAnswer_1 = function (trans) {
	                return !!trans && ((trans[cacheProp_1] && trans[cacheProp_1][id_1] === true) || prevTruthyAnswer_1(trans.redirectedFrom()));
	            };
	            // If a user answered yes, but the transition was later redirected, don't also ask for the new redirect transition
	            var wrappedHook = function (trans) {
	                var promise;
	                var ids = (trans[cacheProp_1] = trans[cacheProp_1] || {});
	                if (!prevTruthyAnswer_1(trans)) {
	                    promise = $q.when(controllerInstance.uiCanExit(trans));
	                    promise.then(function (val) { return (ids[id_1] = val !== false); });
	                }
	                return promise;
	            };
	            var criteria = { exiting: viewState.name };
	            $scope.$on('$destroy', $transitions.onBefore(criteria, wrappedHook, hookOptions));
	        }
	    }
	    ng.module('ui.router.state').directive('uiView', uiView);
	    ng.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	    /** @publicapi @module ng1 */ /** */
	    /** @hidden */
	    function $ViewScrollProvider() {
	        var useAnchorScroll = false;
	        this.useAnchorScroll = function () {
	            useAnchorScroll = true;
	        };
	        this.$get = [
	            '$anchorScroll',
	            '$timeout',
	            function ($anchorScroll, $timeout) {
	                if (useAnchorScroll) {
	                    return $anchorScroll;
	                }
	                return function ($element) {
	                    return $timeout(function () {
	                        $element[0].scrollIntoView();
	                    }, 0, false);
	                };
	            },
	        ];
	    }
	    ng.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	    /**
	     * Main entry point for angular 1.x build
	     * @publicapi @module ng1
	     */ /** */
	    var index = 'ui.router';
	
	    Object.keys(core).forEach(function (k) {
	        if (k !== 'default') Object.defineProperty(exports, k, {
	            enumerable: true,
	            get: function () {
	                return core[k];
	            }
	        });
	    });
	    exports.core = core;
	    exports.Ng1ViewConfig = Ng1ViewConfig;
	    exports.StateProvider = StateProvider;
	    exports.UrlRouterProvider = UrlRouterProvider;
	    exports.default = index;
	    exports.getLocals = getLocals;
	    exports.getNg1ViewConfigFactory = getNg1ViewConfigFactory;
	    exports.ng1ViewsBuilder = ng1ViewsBuilder;
	    exports.watchDigests = watchDigests;
	
	    Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=ui-router-angularjs.js.map


/***/ },

/***/ 47:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.safeConsole = void 0;
	/**
	 * workaround for missing console object in IE9 when dev tools haven't been opened o_O
	 * @packageDocumentation
	 */
	/* tslint:disable:no-console */
	var common_1 = __webpack_require__(4);
	var noopConsoleStub = { log: common_1.noop, error: common_1.noop, table: common_1.noop };
	function ie9Console(console) {
	    var bound = function (fn) { return Function.prototype.bind.call(fn, console); };
	    return {
	        log: bound(console.log),
	        error: bound(console.log),
	        table: bound(console.log),
	    };
	}
	function fallbackConsole(console) {
	    var log = console.log.bind(console);
	    var error = console.error ? console.error.bind(console) : log;
	    var table = console.table ? console.table.bind(console) : log;
	    return { log: log, error: error, table: table };
	}
	function getSafeConsole() {
	    // @ts-ignore
	    var isIE9 = typeof document !== 'undefined' && document.documentMode && document.documentMode === 9;
	    if (isIE9) {
	        return window && window.console ? ie9Console(window.console) : noopConsoleStub;
	    }
	    else if (!console.table || !console.error) {
	        return fallbackConsole(console);
	    }
	    else {
	        return console;
	    }
	}
	exports.safeConsole = getSafeConsole();
	//# sourceMappingURL=safeConsole.js.map

/***/ },

/***/ 48:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UIRouterGlobals = void 0;
	var stateParams_1 = __webpack_require__(50);
	var queue_1 = __webpack_require__(29);
	/**
	 * Global router state
	 *
	 * This is where we hold the global mutable state such as current state, current
	 * params, current transition, etc.
	 */
	var UIRouterGlobals = /** @class */ (function () {
	    function UIRouterGlobals() {
	        /**
	         * Current parameter values
	         *
	         * The parameter values from the latest successful transition
	         */
	        this.params = new stateParams_1.StateParams();
	        /** @internal */
	        this.lastStartedTransitionId = -1;
	        /** @internal */
	        this.transitionHistory = new queue_1.Queue([], 1);
	        /** @internal */
	        this.successfulTransitions = new queue_1.Queue([], 1);
	    }
	    UIRouterGlobals.prototype.dispose = function () {
	        this.transitionHistory.clear();
	        this.successfulTransitions.clear();
	        this.transition = null;
	    };
	    return UIRouterGlobals;
	}());
	exports.UIRouterGlobals = UIRouterGlobals;
	//# sourceMappingURL=globals.js.map

/***/ },

/***/ 49:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.lazyLoadState = exports.registerLazyLoadHook = void 0;
	var coreservices_1 = __webpack_require__(8);
	/**
	 * A [[TransitionHookFn]] that performs lazy loading
	 *
	 * When entering a state "abc" which has a `lazyLoad` function defined:
	 * - Invoke the `lazyLoad` function (unless it is already in process)
	 *   - Flag the hook function as "in process"
	 *   - The function should return a promise (that resolves when lazy loading is complete)
	 * - Wait for the promise to settle
	 *   - If the promise resolves to a [[LazyLoadResult]], then register those states
	 *   - Flag the hook function as "not in process"
	 * - If the hook was successful
	 *   - Remove the `lazyLoad` function from the state declaration
	 * - If all the hooks were successful
	 *   - Retry the transition (by returning a TargetState)
	 *
	 * ```
	 * .state('abc', {
	 *   component: 'fooComponent',
	 *   lazyLoad: () => import('./fooComponent')
	 *   });
	 * ```
	 *
	 * See [[StateDeclaration.lazyLoad]]
	 */
	var lazyLoadHook = function (transition) {
	    var router = transition.router;
	    function retryTransition() {
	        if (transition.originalTransition().options().source !== 'url') {
	            // The original transition was not triggered via url sync
	            // The lazy state should be loaded now, so re-try the original transition
	            var orig = transition.targetState();
	            return router.stateService.target(orig.identifier(), orig.params(), orig.options());
	        }
	        // The original transition was triggered via url sync
	        // Run the URL rules and find the best match
	        var $url = router.urlService;
	        var result = $url.match($url.parts());
	        var rule = result && result.rule;
	        // If the best match is a state, redirect the transition (instead
	        // of calling sync() which supersedes the current transition)
	        if (rule && rule.type === 'STATE') {
	            var state = rule.state;
	            var params = result.match;
	            return router.stateService.target(state, params, transition.options());
	        }
	        // No matching state found, so let .sync() choose the best non-state match/otherwise
	        router.urlService.sync();
	    }
	    var promises = transition
	        .entering()
	        .filter(function (state) { return !!state.$$state().lazyLoad; })
	        .map(function (state) { return lazyLoadState(transition, state); });
	    return coreservices_1.services.$q.all(promises).then(retryTransition);
	};
	exports.registerLazyLoadHook = function (transitionService) {
	    return transitionService.onBefore({ entering: function (state) { return !!state.lazyLoad; } }, lazyLoadHook);
	};
	/**
	 * Invokes a state's lazy load function
	 *
	 * @param transition a Transition context
	 * @param state the state to lazy load
	 * @returns A promise for the lazy load result
	 */
	function lazyLoadState(transition, state) {
	    var lazyLoadFn = state.$$state().lazyLoad;
	    // Store/get the lazy load promise on/from the hookfn so it doesn't get re-invoked
	    var promise = lazyLoadFn['_promise'];
	    if (!promise) {
	        var success = function (result) {
	            delete state.lazyLoad;
	            delete state.$$state().lazyLoad;
	            delete lazyLoadFn['_promise'];
	            return result;
	        };
	        var error = function (err) {
	            delete lazyLoadFn['_promise'];
	            return coreservices_1.services.$q.reject(err);
	        };
	        promise = lazyLoadFn['_promise'] = coreservices_1.services.$q
	            .when(lazyLoadFn(transition, state))
	            .then(updateStateRegistry)
	            .then(success, error);
	    }
	    /** Register any lazy loaded state definitions */
	    function updateStateRegistry(result) {
	        if (result && Array.isArray(result.states)) {
	            result.states.forEach(function (_state) { return transition.router.stateRegistry.register(_state); });
	        }
	        return result;
	    }
	    return promise;
	}
	exports.lazyLoadState = lazyLoadState;
	//# sourceMappingURL=lazyLoad.js.map

/***/ },

/***/ 50:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateParams = void 0;
	var common_1 = __webpack_require__(4);
	var StateParams = /** @class */ (function () {
	    function StateParams(params) {
	        if (params === void 0) { params = {}; }
	        common_1.extend(this, params);
	    }
	    /**
	     * Merges a set of parameters with all parameters inherited between the common parents of the
	     * current state and a given destination state.
	     *
	     * @param {Object} newParams The set of parameters which will be composited with inherited params.
	     * @param {Object} $current Internal definition of object representing the current state.
	     * @param {Object} $to Internal definition of object representing state to transition to.
	     */
	    StateParams.prototype.$inherit = function (newParams, $current, $to) {
	        var parentParams;
	        var parents = common_1.ancestors($current, $to), inherited = {}, inheritList = [];
	        for (var i in parents) {
	            if (!parents[i] || !parents[i].params)
	                continue;
	            parentParams = Object.keys(parents[i].params);
	            if (!parentParams.length)
	                continue;
	            for (var j in parentParams) {
	                if (inheritList.indexOf(parentParams[j]) >= 0)
	                    continue;
	                inheritList.push(parentParams[j]);
	                inherited[parentParams[j]] = this[parentParams[j]];
	            }
	        }
	        return common_1.extend({}, inherited, newParams);
	    };
	    return StateParams;
	}());
	exports.StateParams = StateParams;
	//# sourceMappingURL=stateParams.js.map

/***/ },

/***/ 51:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(52), exports);
	__exportStar(__webpack_require__(21), exports);
	__exportStar(__webpack_require__(22), exports);
	//# sourceMappingURL=index.js.map

/***/ },

/***/ 52:
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.resolvePolicies = void 0;
	exports.resolvePolicies = {
	    when: {
	        LAZY: 'LAZY',
	        EAGER: 'EAGER',
	    },
	    async: {
	        WAIT: 'WAIT',
	        NOWAIT: 'NOWAIT',
	    },
	};
	//# sourceMappingURL=interface.js.map

/***/ },

/***/ 53:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UIRouter = void 0;
	var urlMatcherFactory_1 = __webpack_require__(62);
	var urlRouter_1 = __webpack_require__(63);
	var transitionService_1 = __webpack_require__(37);
	var view_1 = __webpack_require__(73);
	var stateRegistry_1 = __webpack_require__(57);
	var stateService_1 = __webpack_require__(58);
	var globals_1 = __webpack_require__(48);
	var common_1 = __webpack_require__(4);
	var predicates_1 = __webpack_require__(5);
	var urlService_1 = __webpack_require__(65);
	var trace_1 = __webpack_require__(12);
	var common_2 = __webpack_require__(7);
	/** @internal */
	var _routerInstance = 0;
	/** @internal */
	var locSvcFns = ['url', 'path', 'search', 'hash', 'onChange'];
	/** @internal */
	var locCfgFns = ['port', 'protocol', 'host', 'baseHref', 'html5Mode', 'hashPrefix'];
	/** @internal */
	var locationServiceStub = common_2.makeStub('LocationServices', locSvcFns);
	/** @internal */
	var locationConfigStub = common_2.makeStub('LocationConfig', locCfgFns);
	/**
	 * An instance of UI-Router.
	 *
	 * This object contains references to service APIs which define your application's routing behavior.
	 */
	var UIRouter = /** @class */ (function () {
	    /**
	     * Creates a new `UIRouter` object
	     *
	     * @param locationService a [[LocationServices]] implementation
	     * @param locationConfig a [[LocationConfig]] implementation
	     * @internal
	     */
	    function UIRouter(locationService, locationConfig) {
	        if (locationService === void 0) { locationService = locationServiceStub; }
	        if (locationConfig === void 0) { locationConfig = locationConfigStub; }
	        this.locationService = locationService;
	        this.locationConfig = locationConfig;
	        /** @internal */ this.$id = _routerInstance++;
	        /** @internal */ this._disposed = false;
	        /** @internal */ this._disposables = [];
	        /** Enable/disable tracing to the javascript console */
	        this.trace = trace_1.trace;
	        /** Provides services related to ui-view synchronization */
	        this.viewService = new view_1.ViewService(this);
	        /** An object that contains global router state, such as the current state and params */
	        this.globals = new globals_1.UIRouterGlobals();
	        /** A service that exposes global Transition Hooks */
	        this.transitionService = new transitionService_1.TransitionService(this);
	        /**
	         * Deprecated for public use. Use [[urlService]] instead.
	         * @deprecated Use [[urlService]] instead
	         */
	        this.urlMatcherFactory = new urlMatcherFactory_1.UrlMatcherFactory(this);
	        /**
	         * Deprecated for public use. Use [[urlService]] instead.
	         * @deprecated Use [[urlService]] instead
	         */
	        this.urlRouter = new urlRouter_1.UrlRouter(this);
	        /** Provides services related to the URL */
	        this.urlService = new urlService_1.UrlService(this);
	        /** Provides a registry for states, and related registration services */
	        this.stateRegistry = new stateRegistry_1.StateRegistry(this);
	        /** Provides services related to states */
	        this.stateService = new stateService_1.StateService(this);
	        /** @internal plugin instances are registered here */
	        this._plugins = {};
	        this.viewService._pluginapi._rootViewContext(this.stateRegistry.root());
	        this.globals.$current = this.stateRegistry.root();
	        this.globals.current = this.globals.$current.self;
	        this.disposable(this.globals);
	        this.disposable(this.stateService);
	        this.disposable(this.stateRegistry);
	        this.disposable(this.transitionService);
	        this.disposable(this.urlService);
	        this.disposable(locationService);
	        this.disposable(locationConfig);
	    }
	    /** Registers an object to be notified when the router is disposed */
	    UIRouter.prototype.disposable = function (disposable) {
	        this._disposables.push(disposable);
	    };
	    /**
	     * Disposes this router instance
	     *
	     * When called, clears resources retained by the router by calling `dispose(this)` on all
	     * registered [[disposable]] objects.
	     *
	     * Or, if a `disposable` object is provided, calls `dispose(this)` on that object only.
	     *
	     * @internal
	     * @param disposable (optional) the disposable to dispose
	     */
	    UIRouter.prototype.dispose = function (disposable) {
	        var _this = this;
	        if (disposable && predicates_1.isFunction(disposable.dispose)) {
	            disposable.dispose(this);
	            return undefined;
	        }
	        this._disposed = true;
	        this._disposables.slice().forEach(function (d) {
	            try {
	                typeof d.dispose === 'function' && d.dispose(_this);
	                common_1.removeFrom(_this._disposables, d);
	            }
	            catch (ignored) { }
	        });
	    };
	    /**
	     * Adds a plugin to UI-Router
	     *
	     * This method adds a UI-Router Plugin.
	     * A plugin can enhance or change UI-Router behavior using any public API.
	     *
	     * #### Example:
	     * ```js
	     * import { MyCoolPlugin } from "ui-router-cool-plugin";
	     *
	     * var plugin = router.addPlugin(MyCoolPlugin);
	     * ```
	     *
	     * ### Plugin authoring
	     *
	     * A plugin is simply a class (or constructor function) which accepts a [[UIRouter]] instance and (optionally) an options object.
	     *
	     * The plugin can implement its functionality using any of the public APIs of [[UIRouter]].
	     * For example, it may configure router options or add a Transition Hook.
	     *
	     * The plugin can then be published as a separate module.
	     *
	     * #### Example:
	     * ```js
	     * export class MyAuthPlugin implements UIRouterPlugin {
	     *   constructor(router: UIRouter, options: any) {
	     *     this.name = "MyAuthPlugin";
	     *     let $transitions = router.transitionService;
	     *     let $state = router.stateService;
	     *
	     *     let authCriteria = {
	     *       to: (state) => state.data && state.data.requiresAuth
	     *     };
	     *
	     *     function authHook(transition: Transition) {
	     *       let authService = transition.injector().get('AuthService');
	     *       if (!authService.isAuthenticated()) {
	     *         return $state.target('login');
	     *       }
	     *     }
	     *
	     *     $transitions.onStart(authCriteria, authHook);
	     *   }
	     * }
	     * ```
	     *
	     * @param plugin one of:
	     *        - a plugin class which implements [[UIRouterPlugin]]
	     *        - a constructor function for a [[UIRouterPlugin]] which accepts a [[UIRouter]] instance
	     *        - a factory function which accepts a [[UIRouter]] instance and returns a [[UIRouterPlugin]] instance
	     * @param options options to pass to the plugin class/factory
	     * @returns the registered plugin instance
	     */
	    UIRouter.prototype.plugin = function (plugin, options) {
	        if (options === void 0) { options = {}; }
	        var pluginInstance = new plugin(this, options);
	        if (!pluginInstance.name)
	            throw new Error('Required property `name` missing on plugin: ' + pluginInstance);
	        this._disposables.push(pluginInstance);
	        return (this._plugins[pluginInstance.name] = pluginInstance);
	    };
	    UIRouter.prototype.getPlugin = function (pluginName) {
	        return pluginName ? this._plugins[pluginName] : common_1.values(this._plugins);
	    };
	    return UIRouter;
	}());
	exports.UIRouter = UIRouter;
	//# sourceMappingURL=router.js.map

/***/ },

/***/ 54:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateBuilder = exports.resolvablesBuilder = void 0;
	var common_1 = __webpack_require__(4);
	var predicates_1 = __webpack_require__(5);
	var strings_1 = __webpack_require__(10);
	var hof_1 = __webpack_require__(6);
	var resolvable_1 = __webpack_require__(21);
	var coreservices_1 = __webpack_require__(8);
	var parseUrl = function (url) {
	    if (!predicates_1.isString(url))
	        return false;
	    var root = url.charAt(0) === '^';
	    return { val: root ? url.substring(1) : url, root: root };
	};
	function nameBuilder(state) {
	    return state.name;
	}
	function selfBuilder(state) {
	    state.self.$$state = function () { return state; };
	    return state.self;
	}
	function dataBuilder(state) {
	    if (state.parent && state.parent.data) {
	        state.data = state.self.data = common_1.inherit(state.parent.data, state.data);
	    }
	    return state.data;
	}
	var getUrlBuilder = function ($urlMatcherFactoryProvider, root) {
	    return function urlBuilder(stateObject) {
	        var stateDec = stateObject.self;
	        // For future states, i.e., states whose name ends with `.**`,
	        // match anything that starts with the url prefix
	        if (stateDec && stateDec.url && stateDec.name && stateDec.name.match(/\.\*\*$/)) {
	            var newStateDec = {};
	            common_1.copy(stateDec, newStateDec);
	            newStateDec.url += '{remainder:any}'; // match any path (.*)
	            stateDec = newStateDec;
	        }
	        var parent = stateObject.parent;
	        var parsed = parseUrl(stateDec.url);
	        var url = !parsed ? stateDec.url : $urlMatcherFactoryProvider.compile(parsed.val, { state: stateDec });
	        if (!url)
	            return null;
	        if (!$urlMatcherFactoryProvider.isMatcher(url))
	            throw new Error("Invalid url '" + url + "' in state '" + stateObject + "'");
	        return parsed && parsed.root ? url : ((parent && parent.navigable) || root()).url.append(url);
	    };
	};
	var getNavigableBuilder = function (isRoot) {
	    return function navigableBuilder(state) {
	        return !isRoot(state) && state.url ? state : state.parent ? state.parent.navigable : null;
	    };
	};
	var getParamsBuilder = function (paramFactory) {
	    return function paramsBuilder(state) {
	        var makeConfigParam = function (config, id) { return paramFactory.fromConfig(id, null, state.self); };
	        var urlParams = (state.url && state.url.parameters({ inherit: false })) || [];
	        var nonUrlParams = common_1.values(common_1.mapObj(common_1.omit(state.params || {}, urlParams.map(hof_1.prop('id'))), makeConfigParam));
	        return urlParams
	            .concat(nonUrlParams)
	            .map(function (p) { return [p.id, p]; })
	            .reduce(common_1.applyPairs, {});
	    };
	};
	function pathBuilder(state) {
	    return state.parent ? state.parent.path.concat(state) : /*root*/ [state];
	}
	function includesBuilder(state) {
	    var includes = state.parent ? common_1.extend({}, state.parent.includes) : {};
	    includes[state.name] = true;
	    return includes;
	}
	/**
	 * This is a [[StateBuilder.builder]] function for the `resolve:` block on a [[StateDeclaration]].
	 *
	 * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	 * validates the `resolve` property and converts it to a [[Resolvable]] array.
	 *
	 * resolve: input value can be:
	 *
	 * {
	 *   // analyzed but not injected
	 *   myFooResolve: function() { return "myFooData"; },
	 *
	 *   // function.toString() parsed, "DependencyName" dep as string (not min-safe)
	 *   myBarResolve: function(DependencyName) { return DependencyName.fetchSomethingAsPromise() },
	 *
	 *   // Array split; "DependencyName" dep as string
	 *   myBazResolve: [ "DependencyName", function(dep) { return dep.fetchSomethingAsPromise() },
	 *
	 *   // Array split; DependencyType dep as token (compared using ===)
	 *   myQuxResolve: [ DependencyType, function(dep) { return dep.fetchSometingAsPromise() },
	 *
	 *   // val.$inject used as deps
	 *   // where:
	 *   //     corgeResolve.$inject = ["DependencyName"];
	 *   //     function corgeResolve(dep) { dep.fetchSometingAsPromise() }
	 *   // then "DependencyName" dep as string
	 *   myCorgeResolve: corgeResolve,
	 *
	 *  // inject service by name
	 *  // When a string is found, desugar creating a resolve that injects the named service
	 *   myGraultResolve: "SomeService"
	 * }
	 *
	 * or:
	 *
	 * [
	 *   new Resolvable("myFooResolve", function() { return "myFooData" }),
	 *   new Resolvable("myBarResolve", function(dep) { return dep.fetchSomethingAsPromise() }, [ "DependencyName" ]),
	 *   { provide: "myBazResolve", useFactory: function(dep) { dep.fetchSomethingAsPromise() }, deps: [ "DependencyName" ] }
	 * ]
	 */
	function resolvablesBuilder(state) {
	    /** convert resolve: {} and resolvePolicy: {} objects to an array of tuples */
	    var objects2Tuples = function (resolveObj, resolvePolicies) {
	        return Object.keys(resolveObj || {}).map(function (token) { return ({
	            token: token,
	            val: resolveObj[token],
	            deps: undefined,
	            policy: resolvePolicies[token],
	        }); });
	    };
	    /** fetch DI annotations from a function or ng1-style array */
	    var annotate = function (fn) {
	        var $injector = coreservices_1.services.$injector;
	        // ng1 doesn't have an $injector until runtime.
	        // If the $injector doesn't exist, use "deferred" literal as a
	        // marker indicating they should be annotated when runtime starts
	        return fn['$inject'] || ($injector && $injector.annotate(fn, $injector.strictDi)) || 'deferred';
	    };
	    /** true if the object has both `token` and `resolveFn`, and is probably a [[ResolveLiteral]] */
	    var isResolveLiteral = function (obj) { return !!(obj.token && obj.resolveFn); };
	    /** true if the object looks like a provide literal, or a ng2 Provider */
	    var isLikeNg2Provider = function (obj) {
	        return !!((obj.provide || obj.token) && (obj.useValue || obj.useFactory || obj.useExisting || obj.useClass));
	    };
	    /** true if the object looks like a tuple from obj2Tuples */
	    var isTupleFromObj = function (obj) {
	        return !!(obj && obj.val && (predicates_1.isString(obj.val) || predicates_1.isArray(obj.val) || predicates_1.isFunction(obj.val)));
	    };
	    /** extracts the token from a Provider or provide literal */
	    var getToken = function (p) { return p.provide || p.token; };
	    // prettier-ignore: Given a literal resolve or provider object, returns a Resolvable
	    var literal2Resolvable = hof_1.pattern([
	        [hof_1.prop('resolveFn'), function (p) { return new resolvable_1.Resolvable(getToken(p), p.resolveFn, p.deps, p.policy); }],
	        [hof_1.prop('useFactory'), function (p) { return new resolvable_1.Resolvable(getToken(p), p.useFactory, p.deps || p.dependencies, p.policy); }],
	        [hof_1.prop('useClass'), function (p) { return new resolvable_1.Resolvable(getToken(p), function () { return new p.useClass(); }, [], p.policy); }],
	        [hof_1.prop('useValue'), function (p) { return new resolvable_1.Resolvable(getToken(p), function () { return p.useValue; }, [], p.policy, p.useValue); }],
	        [hof_1.prop('useExisting'), function (p) { return new resolvable_1.Resolvable(getToken(p), common_1.identity, [p.useExisting], p.policy); }],
	    ]);
	    // prettier-ignore
	    var tuple2Resolvable = hof_1.pattern([
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isString), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.identity, [tuple.val], tuple.policy); }],
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isArray), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.tail(tuple.val), tuple.val.slice(0, -1), tuple.policy); }],
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isFunction), function (tuple) { return new resolvable_1.Resolvable(tuple.token, tuple.val, annotate(tuple.val), tuple.policy); }],
	    ]);
	    // prettier-ignore
	    var item2Resolvable = hof_1.pattern([
	        [hof_1.is(resolvable_1.Resolvable), function (r) { return r; }],
	        [isResolveLiteral, literal2Resolvable],
	        [isLikeNg2Provider, literal2Resolvable],
	        [isTupleFromObj, tuple2Resolvable],
	        [hof_1.val(true), function (obj) { throw new Error('Invalid resolve value: ' + strings_1.stringify(obj)); },],
	    ]);
	    // If resolveBlock is already an array, use it as-is.
	    // Otherwise, assume it's an object and convert to an Array of tuples
	    var decl = state.resolve;
	    var items = predicates_1.isArray(decl) ? decl : objects2Tuples(decl, state.resolvePolicy || {});
	    return items.map(item2Resolvable);
	}
	exports.resolvablesBuilder = resolvablesBuilder;
	/**
	 * A internal global service
	 *
	 * StateBuilder is a factory for the internal [[StateObject]] objects.
	 *
	 * When you register a state with the [[StateRegistry]], you register a plain old javascript object which
	 * conforms to the [[StateDeclaration]] interface.  This factory takes that object and builds the corresponding
	 * [[StateObject]] object, which has an API and is used internally.
	 *
	 * Custom properties or API may be added to the internal [[StateObject]] object by registering a decorator function
	 * using the [[builder]] method.
	 */
	var StateBuilder = /** @class */ (function () {
	    function StateBuilder(matcher, urlMatcherFactory) {
	        this.matcher = matcher;
	        var self = this;
	        var root = function () { return matcher.find(''); };
	        var isRoot = function (state) { return state.name === ''; };
	        function parentBuilder(state) {
	            if (isRoot(state))
	                return null;
	            return matcher.find(self.parentName(state)) || root();
	        }
	        this.builders = {
	            name: [nameBuilder],
	            self: [selfBuilder],
	            parent: [parentBuilder],
	            data: [dataBuilder],
	            // Build a URLMatcher if necessary, either via a relative or absolute URL
	            url: [getUrlBuilder(urlMatcherFactory, root)],
	            // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	            navigable: [getNavigableBuilder(isRoot)],
	            params: [getParamsBuilder(urlMatcherFactory.paramFactory)],
	            // Each framework-specific ui-router implementation should define its own `views` builder
	            // e.g., src/ng1/statebuilders/views.ts
	            views: [],
	            // Keep a full path from the root down to this state as this is needed for state activation.
	            path: [pathBuilder],
	            // Speed up $state.includes() as it's used a lot
	            includes: [includesBuilder],
	            resolvables: [resolvablesBuilder],
	        };
	    }
	    StateBuilder.prototype.builder = function (name, fn) {
	        var builders = this.builders;
	        var array = builders[name] || [];
	        // Backwards compat: if only one builder exists, return it, else return whole arary.
	        if (predicates_1.isString(name) && !predicates_1.isDefined(fn))
	            return array.length > 1 ? array : array[0];
	        if (!predicates_1.isString(name) || !predicates_1.isFunction(fn))
	            return;
	        builders[name] = array;
	        builders[name].push(fn);
	        return function () { return builders[name].splice(builders[name].indexOf(fn, 1)) && null; };
	    };
	    /**
	     * Builds all of the properties on an essentially blank State object, returning a State object which has all its
	     * properties and API built.
	     *
	     * @param state an uninitialized State object
	     * @returns the built State object
	     */
	    StateBuilder.prototype.build = function (state) {
	        var _a = this, matcher = _a.matcher, builders = _a.builders;
	        var parent = this.parentName(state);
	        if (parent && !matcher.find(parent, undefined, false)) {
	            return null;
	        }
	        for (var key in builders) {
	            if (!builders.hasOwnProperty(key))
	                continue;
	            var chain = builders[key].reduce(function (parentFn, step) { return function (_state) { return step(_state, parentFn); }; }, common_1.noop);
	            state[key] = chain(state);
	        }
	        return state;
	    };
	    StateBuilder.prototype.parentName = function (state) {
	        // name = 'foo.bar.baz.**'
	        var name = state.name || '';
	        // segments = ['foo', 'bar', 'baz', '.**']
	        var segments = name.split('.');
	        // segments = ['foo', 'bar', 'baz']
	        var lastSegment = segments.pop();
	        // segments = ['foo', 'bar'] (ignore .** segment for future states)
	        if (lastSegment === '**')
	            segments.pop();
	        if (segments.length) {
	            if (state.parent) {
	                throw new Error("States that specify the 'parent:' property should not have a '.' in their name (" + name + ")");
	            }
	            // 'foo.bar'
	            return segments.join('.');
	        }
	        if (!state.parent)
	            return '';
	        return predicates_1.isString(state.parent) ? state.parent : state.parent.name;
	    };
	    StateBuilder.prototype.name = function (state) {
	        var name = state.name;
	        if (name.indexOf('.') !== -1 || !state.parent)
	            return name;
	        var parentName = predicates_1.isString(state.parent) ? state.parent : state.parent.name;
	        return parentName ? parentName + '.' + name : name;
	    };
	    return StateBuilder;
	}());
	exports.StateBuilder = StateBuilder;
	//# sourceMappingURL=stateBuilder.js.map

/***/ },

/***/ 55:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateMatcher = void 0;
	var predicates_1 = __webpack_require__(5);
	var common_1 = __webpack_require__(4);
	var safeConsole_1 = __webpack_require__(47);
	var StateMatcher = /** @class */ (function () {
	    function StateMatcher(_states) {
	        this._states = _states;
	    }
	    StateMatcher.prototype.isRelative = function (stateName) {
	        stateName = stateName || '';
	        return stateName.indexOf('.') === 0 || stateName.indexOf('^') === 0;
	    };
	    StateMatcher.prototype.find = function (stateOrName, base, matchGlob) {
	        if (matchGlob === void 0) { matchGlob = true; }
	        if (!stateOrName && stateOrName !== '')
	            return undefined;
	        var isStr = predicates_1.isString(stateOrName);
	        var name = isStr ? stateOrName : stateOrName.name;
	        if (this.isRelative(name))
	            name = this.resolvePath(name, base);
	        var state = this._states[name];
	        if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	            return state;
	        }
	        else if (isStr && matchGlob) {
	            var _states = common_1.values(this._states);
	            var matches = _states.filter(function (_state) { return _state.__stateObjectCache.nameGlob && _state.__stateObjectCache.nameGlob.matches(name); });
	            if (matches.length > 1) {
	                safeConsole_1.safeConsole.error("stateMatcher.find: Found multiple matches for " + name + " using glob: ", matches.map(function (match) { return match.name; }));
	            }
	            return matches[0];
	        }
	        return undefined;
	    };
	    StateMatcher.prototype.resolvePath = function (name, base) {
	        if (!base)
	            throw new Error("No reference point given for path '" + name + "'");
	        var baseState = this.find(base);
	        var splitName = name.split('.');
	        var pathLength = splitName.length;
	        var i = 0, current = baseState;
	        for (; i < pathLength; i++) {
	            if (splitName[i] === '' && i === 0) {
	                current = baseState;
	                continue;
	            }
	            if (splitName[i] === '^') {
	                if (!current.parent)
	                    throw new Error("Path '" + name + "' not valid for state '" + baseState.name + "'");
	                current = current.parent;
	                continue;
	            }
	            break;
	        }
	        var relName = splitName.slice(i).join('.');
	        return current.name + (current.name && relName ? '.' : '') + relName;
	    };
	    return StateMatcher;
	}());
	exports.StateMatcher = StateMatcher;
	//# sourceMappingURL=stateMatcher.js.map

/***/ },

/***/ 56:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateQueueManager = void 0;
	var common_1 = __webpack_require__(7);
	var stateObject_1 = __webpack_require__(34);
	var StateQueueManager = /** @class */ (function () {
	    function StateQueueManager(router, states, builder, listeners) {
	        this.router = router;
	        this.states = states;
	        this.builder = builder;
	        this.listeners = listeners;
	        this.queue = [];
	    }
	    StateQueueManager.prototype.dispose = function () {
	        this.queue = [];
	    };
	    StateQueueManager.prototype.register = function (stateDecl) {
	        var queue = this.queue;
	        var state = stateObject_1.StateObject.create(stateDecl);
	        var name = state.name;
	        if (!common_1.isString(name))
	            throw new Error('State must have a valid name');
	        if (this.states.hasOwnProperty(name) || common_1.inArray(queue.map(common_1.prop('name')), name))
	            throw new Error("State '" + name + "' is already defined");
	        queue.push(state);
	        this.flush();
	        return state;
	    };
	    StateQueueManager.prototype.flush = function () {
	        var _this = this;
	        var _a = this, queue = _a.queue, states = _a.states, builder = _a.builder;
	        var registered = [], // states that got registered
	        orphans = [], // states that don't yet have a parent registered
	        previousQueueLength = {}; // keep track of how long the queue when an orphan was first encountered
	        var getState = function (name) { return _this.states.hasOwnProperty(name) && _this.states[name]; };
	        var notifyListeners = function () {
	            if (registered.length) {
	                _this.listeners.forEach(function (listener) {
	                    return listener('registered', registered.map(function (s) { return s.self; }));
	                });
	            }
	        };
	        while (queue.length > 0) {
	            var state = queue.shift();
	            var name_1 = state.name;
	            var result = builder.build(state);
	            var orphanIdx = orphans.indexOf(state);
	            if (result) {
	                var existingState = getState(name_1);
	                if (existingState && existingState.name === name_1) {
	                    throw new Error("State '" + name_1 + "' is already defined");
	                }
	                var existingFutureState = getState(name_1 + '.**');
	                if (existingFutureState) {
	                    // Remove future state of the same name
	                    this.router.stateRegistry.deregister(existingFutureState);
	                }
	                states[name_1] = state;
	                this.attachRoute(state);
	                if (orphanIdx >= 0)
	                    orphans.splice(orphanIdx, 1);
	                registered.push(state);
	                continue;
	            }
	            var prev = previousQueueLength[name_1];
	            previousQueueLength[name_1] = queue.length;
	            if (orphanIdx >= 0 && prev === queue.length) {
	                // Wait until two consecutive iterations where no additional states were dequeued successfully.
	                // throw new Error(`Cannot register orphaned state '${name}'`);
	                queue.push(state);
	                notifyListeners();
	                return states;
	            }
	            else if (orphanIdx < 0) {
	                orphans.push(state);
	            }
	            queue.push(state);
	        }
	        notifyListeners();
	        return states;
	    };
	    StateQueueManager.prototype.attachRoute = function (state) {
	        if (state.abstract || !state.url)
	            return;
	        var rulesApi = this.router.urlService.rules;
	        rulesApi.rule(rulesApi.urlRuleFactory.create(state));
	    };
	    return StateQueueManager;
	}());
	exports.StateQueueManager = StateQueueManager;
	//# sourceMappingURL=stateQueueManager.js.map

/***/ },

/***/ 57:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateRegistry = void 0;
	var stateMatcher_1 = __webpack_require__(55);
	var stateBuilder_1 = __webpack_require__(54);
	var stateQueueManager_1 = __webpack_require__(56);
	var common_1 = __webpack_require__(4);
	var hof_1 = __webpack_require__(6);
	/**
	 * A registry for all of the application's [[StateDeclaration]]s
	 *
	 * This API is found at `router.stateRegistry` ([[UIRouter.stateRegistry]])
	 */
	var StateRegistry = /** @class */ (function () {
	    /** @internal */
	    function StateRegistry(router) {
	        this.router = router;
	        this.states = {};
	        /** @internal */
	        this.listeners = [];
	        this.matcher = new stateMatcher_1.StateMatcher(this.states);
	        this.builder = new stateBuilder_1.StateBuilder(this.matcher, router.urlMatcherFactory);
	        this.stateQueue = new stateQueueManager_1.StateQueueManager(router, this.states, this.builder, this.listeners);
	        this._registerRoot();
	    }
	    /** @internal */
	    StateRegistry.prototype._registerRoot = function () {
	        var rootStateDef = {
	            name: '',
	            url: '^',
	            views: null,
	            params: {
	                '#': { value: null, type: 'hash', dynamic: true },
	            },
	            abstract: true,
	        };
	        var _root = (this._root = this.stateQueue.register(rootStateDef));
	        _root.navigable = null;
	    };
	    /** @internal */
	    StateRegistry.prototype.dispose = function () {
	        var _this = this;
	        this.stateQueue.dispose();
	        this.listeners = [];
	        this.get().forEach(function (state) { return _this.get(state) && _this.deregister(state); });
	    };
	    /**
	     * Listen for a State Registry events
	     *
	     * Adds a callback that is invoked when states are registered or deregistered with the StateRegistry.
	     *
	     * #### Example:
	     * ```js
	     * let allStates = registry.get();
	     *
	     * // Later, invoke deregisterFn() to remove the listener
	     * let deregisterFn = registry.onStatesChanged((event, states) => {
	     *   switch(event) {
	     *     case: 'registered':
	     *       states.forEach(state => allStates.push(state));
	     *       break;
	     *     case: 'deregistered':
	     *       states.forEach(state => {
	     *         let idx = allStates.indexOf(state);
	     *         if (idx !== -1) allStates.splice(idx, 1);
	     *       });
	     *       break;
	     *   }
	     * });
	     * ```
	     *
	     * @param listener a callback function invoked when the registered states changes.
	     *        The function receives two parameters, `event` and `state`.
	     *        See [[StateRegistryListener]]
	     * @return a function that deregisters the listener
	     */
	    StateRegistry.prototype.onStatesChanged = function (listener) {
	        this.listeners.push(listener);
	        return function deregisterListener() {
	            common_1.removeFrom(this.listeners)(listener);
	        }.bind(this);
	    };
	    /**
	     * Gets the implicit root state
	     *
	     * Gets the root of the state tree.
	     * The root state is implicitly created by UI-Router.
	     * Note: this returns the internal [[StateObject]] representation, not a [[StateDeclaration]]
	     *
	     * @return the root [[StateObject]]
	     */
	    StateRegistry.prototype.root = function () {
	        return this._root;
	    };
	    /**
	     * Adds a state to the registry
	     *
	     * Registers a [[StateDeclaration]] or queues it for registration.
	     *
	     * Note: a state will be queued if the state's parent isn't yet registered.
	     *
	     * @param stateDefinition the definition of the state to register.
	     * @returns the internal [[StateObject]] object.
	     *          If the state was successfully registered, then the object is fully built (See: [[StateBuilder]]).
	     *          If the state was only queued, then the object is not fully built.
	     */
	    StateRegistry.prototype.register = function (stateDefinition) {
	        return this.stateQueue.register(stateDefinition);
	    };
	    /** @internal */
	    StateRegistry.prototype._deregisterTree = function (state) {
	        var _this = this;
	        var all = this.get().map(function (s) { return s.$$state(); });
	        var getChildren = function (states) {
	            var _children = all.filter(function (s) { return states.indexOf(s.parent) !== -1; });
	            return _children.length === 0 ? _children : _children.concat(getChildren(_children));
	        };
	        var children = getChildren([state]);
	        var deregistered = [state].concat(children).reverse();
	        deregistered.forEach(function (_state) {
	            var rulesApi = _this.router.urlService.rules;
	            // Remove URL rule
	            rulesApi
	                .rules()
	                .filter(hof_1.propEq('state', _state))
	                .forEach(function (rule) { return rulesApi.removeRule(rule); });
	            // Remove state from registry
	            delete _this.states[_state.name];
	        });
	        return deregistered;
	    };
	    /**
	     * Removes a state from the registry
	     *
	     * This removes a state from the registry.
	     * If the state has children, they are are also removed from the registry.
	     *
	     * @param stateOrName the state's name or object representation
	     * @returns {StateObject[]} a list of removed states
	     */
	    StateRegistry.prototype.deregister = function (stateOrName) {
	        var _state = this.get(stateOrName);
	        if (!_state)
	            throw new Error("Can't deregister state; not found: " + stateOrName);
	        var deregisteredStates = this._deregisterTree(_state.$$state());
	        this.listeners.forEach(function (listener) {
	            return listener('deregistered', deregisteredStates.map(function (s) { return s.self; }));
	        });
	        return deregisteredStates;
	    };
	    StateRegistry.prototype.get = function (stateOrName, base) {
	        var _this = this;
	        if (arguments.length === 0)
	            return Object.keys(this.states).map(function (name) { return _this.states[name].self; });
	        var found = this.matcher.find(stateOrName, base);
	        return (found && found.self) || null;
	    };
	    /**
	     * Registers a [[BuilderFunction]] for a specific [[StateObject]] property (e.g., `parent`, `url`, or `path`).
	     * More than one BuilderFunction can be registered for a given property.
	     *
	     * The BuilderFunction(s) will be used to define the property on any subsequently built [[StateObject]] objects.
	     *
	     * @param property The name of the State property being registered for.
	     * @param builderFunction The BuilderFunction which will be used to build the State property
	     * @returns a function which deregisters the BuilderFunction
	     */
	    StateRegistry.prototype.decorator = function (property, builderFunction) {
	        return this.builder.builder(property, builderFunction);
	    };
	    return StateRegistry;
	}());
	exports.StateRegistry = StateRegistry;
	//# sourceMappingURL=stateRegistry.js.map

/***/ },

/***/ 58:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateService = void 0;
	var common_1 = __webpack_require__(4);
	var predicates_1 = __webpack_require__(5);
	var queue_1 = __webpack_require__(29);
	var coreservices_1 = __webpack_require__(8);
	var pathUtils_1 = __webpack_require__(20);
	var pathNode_1 = __webpack_require__(32);
	var transitionService_1 = __webpack_require__(37);
	var rejectFactory_1 = __webpack_require__(14);
	var targetState_1 = __webpack_require__(16);
	var param_1 = __webpack_require__(15);
	var glob_1 = __webpack_require__(28);
	var resolveContext_1 = __webpack_require__(22);
	var lazyLoad_1 = __webpack_require__(49);
	var hof_1 = __webpack_require__(6);
	/**
	 * Provides services related to ui-router states.
	 *
	 * This API is located at `router.stateService` ([[UIRouter.stateService]])
	 */
	var StateService = /** @class */ (function () {
	    /** @internal */
	    function StateService(/** @internal */ router) {
	        this.router = router;
	        /** @internal */
	        this.invalidCallbacks = [];
	        /** @internal */
	        this._defaultErrorHandler = function $defaultErrorHandler($error$) {
	            if ($error$ instanceof Error && $error$.stack) {
	                console.error($error$);
	                console.error($error$.stack);
	            }
	            else if ($error$ instanceof rejectFactory_1.Rejection) {
	                console.error($error$.toString());
	                if ($error$.detail && $error$.detail.stack)
	                    console.error($error$.detail.stack);
	            }
	            else {
	                console.error($error$);
	            }
	        };
	        var getters = ['current', '$current', 'params', 'transition'];
	        var boundFns = Object.keys(StateService.prototype).filter(hof_1.not(common_1.inArray(getters)));
	        common_1.createProxyFunctions(hof_1.val(StateService.prototype), this, hof_1.val(this), boundFns);
	    }
	    Object.defineProperty(StateService.prototype, "transition", {
	        /**
	         * The [[Transition]] currently in progress (or null)
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.transition]]
	         */
	        get: function () {
	            return this.router.globals.transition;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "params", {
	        /**
	         * The latest successful state parameters
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.params]]
	         */
	        get: function () {
	            return this.router.globals.params;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "current", {
	        /**
	         * The current [[StateDeclaration]]
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.current]]
	         */
	        get: function () {
	            return this.router.globals.current;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "$current", {
	        /**
	         * The current [[StateObject]] (an internal API)
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.$current]]
	         */
	        get: function () {
	            return this.router.globals.$current;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /** @internal */
	    StateService.prototype.dispose = function () {
	        this.defaultErrorHandler(common_1.noop);
	        this.invalidCallbacks = [];
	    };
	    /**
	     * Handler for when [[transitionTo]] is called with an invalid state.
	     *
	     * Invokes the [[onInvalid]] callbacks, in natural order.
	     * Each callback's return value is checked in sequence until one of them returns an instance of TargetState.
	     * The results of the callbacks are wrapped in $q.when(), so the callbacks may return promises.
	     *
	     * If a callback returns an TargetState, then it is used as arguments to $state.transitionTo() and the result returned.
	     *
	     * @internal
	     */
	    StateService.prototype._handleInvalidTargetState = function (fromPath, toState) {
	        var _this = this;
	        var fromState = pathUtils_1.PathUtils.makeTargetState(this.router.stateRegistry, fromPath);
	        var globals = this.router.globals;
	        var latestThing = function () { return globals.transitionHistory.peekTail(); };
	        var latest = latestThing();
	        var callbackQueue = new queue_1.Queue(this.invalidCallbacks.slice());
	        var injector = new resolveContext_1.ResolveContext(fromPath).injector();
	        var checkForRedirect = function (result) {
	            if (!(result instanceof targetState_1.TargetState)) {
	                return;
	            }
	            var target = result;
	            // Recreate the TargetState, in case the state is now defined.
	            target = _this.target(target.identifier(), target.params(), target.options());
	            if (!target.valid()) {
	                return rejectFactory_1.Rejection.invalid(target.error()).toPromise();
	            }
	            if (latestThing() !== latest) {
	                return rejectFactory_1.Rejection.superseded().toPromise();
	            }
	            return _this.transitionTo(target.identifier(), target.params(), target.options());
	        };
	        function invokeNextCallback() {
	            var nextCallback = callbackQueue.dequeue();
	            if (nextCallback === undefined)
	                return rejectFactory_1.Rejection.invalid(toState.error()).toPromise();
	            var callbackResult = coreservices_1.services.$q.when(nextCallback(toState, fromState, injector));
	            return callbackResult.then(checkForRedirect).then(function (result) { return result || invokeNextCallback(); });
	        }
	        return invokeNextCallback();
	    };
	    /**
	     * Registers an Invalid State handler
	     *
	     * Registers a [[OnInvalidCallback]] function to be invoked when [[StateService.transitionTo]]
	     * has been called with an invalid state reference parameter
	     *
	     * Example:
	     * ```js
	     * stateService.onInvalid(function(to, from, injector) {
	     *   if (to.name() === 'foo') {
	     *     let lazyLoader = injector.get('LazyLoadService');
	     *     return lazyLoader.load('foo')
	     *         .then(() => stateService.target('foo'));
	     *   }
	     * });
	     * ```
	     *
	     * @param {function} callback invoked when the toState is invalid
	     *   This function receives the (invalid) toState, the fromState, and an injector.
	     *   The function may optionally return a [[TargetState]] or a Promise for a TargetState.
	     *   If one is returned, it is treated as a redirect.
	     *
	     * @returns a function which deregisters the callback
	     */
	    StateService.prototype.onInvalid = function (callback) {
	        this.invalidCallbacks.push(callback);
	        return function deregisterListener() {
	            common_1.removeFrom(this.invalidCallbacks)(callback);
	        }.bind(this);
	    };
	    /**
	     * Reloads the current state
	     *
	     * A method that force reloads the current state, or a partial state hierarchy.
	     * All resolves are re-resolved, and components reinstantiated.
	     *
	     * #### Example:
	     * ```js
	     * let app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * ```
	     *
	     * Note: `reload()` is just an alias for:
	     *
	     * ```js
	     * $state.transitionTo($state.current, $state.params, {
	     *   reload: true, inherit: false
	     * });
	     * ```
	     *
	     * @param reloadState A state name or a state object.
	     *    If present, this state and all its children will be reloaded, but ancestors will not reload.
	     *
	     * #### Example:
	     * ```js
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item'
	     * //and current state is 'contacts.detail.item'
	     * let app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and nested 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * ```
	     *
	     * @returns A promise representing the state of the new transition. See [[StateService.go]]
	     */
	    StateService.prototype.reload = function (reloadState) {
	        return this.transitionTo(this.current, this.params, {
	            reload: predicates_1.isDefined(reloadState) ? reloadState : true,
	            inherit: false,
	            notify: false,
	        });
	    };
	    /**
	     * Transition to a different state and/or parameters
	     *
	     * Convenience method for transitioning to a new state.
	     *
	     * `$state.go` calls `$state.transitionTo` internally but automatically sets options to
	     * `{ location: true, inherit: true, relative: router.globals.$current, notify: true }`.
	     * This allows you to use either an absolute or relative `to` argument (because of `relative: router.globals.$current`).
	     * It also allows you to specify * only the parameters you'd like to update, while letting unspecified parameters
	     * inherit from the current parameter values (because of `inherit: true`).
	     *
	     * #### Example:
	     * ```js
	     * let app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * ```
	     *
	     * @param to Absolute state name, state object, or relative state path (relative to current state).
	     *
	     * Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to the parent state
	     * - `$state.go('^.sibling')` - if current state is `home.child`, will go to the `home.sibling` state
	     * - `$state.go('.child.grandchild')` - if current state is home, will go to the `home.child.grandchild` state
	     *
	     * @param params A map of the parameters that will be sent to the state, will populate $stateParams.
	     *
	     *    Any parameters that are not specified will be inherited from current parameter values (because of `inherit: true`).
	     *    This allows, for example, going to a sibling state that shares parameters defined by a parent state.
	     *
	     * @param options Transition options
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     */
	    StateService.prototype.go = function (to, params, options) {
	        var defautGoOpts = { relative: this.$current, inherit: true };
	        var transOpts = common_1.defaults(options, defautGoOpts, transitionService_1.defaultTransOpts);
	        return this.transitionTo(to, params, transOpts);
	    };
	    /**
	     * Creates a [[TargetState]]
	     *
	     * This is a factory method for creating a TargetState
	     *
	     * This may be returned from a Transition Hook to redirect a transition, for example.
	     */
	    StateService.prototype.target = function (identifier, params, options) {
	        if (options === void 0) { options = {}; }
	        // If we're reloading, find the state object to reload from
	        if (predicates_1.isObject(options.reload) && !options.reload.name)
	            throw new Error('Invalid reload state object');
	        var reg = this.router.stateRegistry;
	        options.reloadState =
	            options.reload === true ? reg.root() : reg.matcher.find(options.reload, options.relative);
	        if (options.reload && !options.reloadState)
	            throw new Error("No such reload state '" + (predicates_1.isString(options.reload) ? options.reload : options.reload.name) + "'");
	        return new targetState_1.TargetState(this.router.stateRegistry, identifier, params, options);
	    };
	    /** @internal */
	    StateService.prototype.getCurrentPath = function () {
	        var _this = this;
	        var globals = this.router.globals;
	        var latestSuccess = globals.successfulTransitions.peekTail();
	        var rootPath = function () { return [new pathNode_1.PathNode(_this.router.stateRegistry.root())]; };
	        return latestSuccess ? latestSuccess.treeChanges().to : rootPath();
	    };
	    /**
	     * Low-level method for transitioning to a new state.
	     *
	     * The [[go]] method (which uses `transitionTo` internally) is recommended in most situations.
	     *
	     * #### Example:
	     * ```js
	     * let app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * ```
	     *
	     * @param to State name or state object.
	     * @param toParams A map of the parameters that will be sent to the state,
	     *      will populate $stateParams.
	     * @param options Transition options
	     *
	     * @returns A promise representing the state of the new transition. See [[go]]
	     */
	    StateService.prototype.transitionTo = function (to, toParams, options) {
	        var _this = this;
	        if (toParams === void 0) { toParams = {}; }
	        if (options === void 0) { options = {}; }
	        var router = this.router;
	        var globals = router.globals;
	        options = common_1.defaults(options, transitionService_1.defaultTransOpts);
	        var getCurrent = function () { return globals.transition; };
	        options = common_1.extend(options, { current: getCurrent });
	        var ref = this.target(to, toParams, options);
	        var currentPath = this.getCurrentPath();
	        if (!ref.exists())
	            return this._handleInvalidTargetState(currentPath, ref);
	        if (!ref.valid())
	            return common_1.silentRejection(ref.error());
	        if (options.supercede === false && getCurrent()) {
	            return (rejectFactory_1.Rejection.ignored('Another transition is in progress and supercede has been set to false in TransitionOptions for the transition. So the transition was ignored in favour of the existing one in progress.').toPromise());
	        }
	        /**
	         * Special handling for Ignored, Aborted, and Redirected transitions
	         *
	         * The semantics for the transition.run() promise and the StateService.transitionTo()
	         * promise differ. For instance, the run() promise may be rejected because it was
	         * IGNORED, but the transitionTo() promise is resolved because from the user perspective
	         * no error occurred.  Likewise, the transition.run() promise may be rejected because of
	         * a Redirect, but the transitionTo() promise is chained to the new Transition's promise.
	         */
	        var rejectedTransitionHandler = function (trans) { return function (error) {
	            if (error instanceof rejectFactory_1.Rejection) {
	                var isLatest = router.globals.lastStartedTransitionId <= trans.$id;
	                if (error.type === rejectFactory_1.RejectType.IGNORED) {
	                    isLatest && router.urlRouter.update();
	                    // Consider ignored `Transition.run()` as a successful `transitionTo`
	                    return coreservices_1.services.$q.when(globals.current);
	                }
	                var detail = error.detail;
	                if (error.type === rejectFactory_1.RejectType.SUPERSEDED && error.redirected && detail instanceof targetState_1.TargetState) {
	                    // If `Transition.run()` was redirected, allow the `transitionTo()` promise to resolve successfully
	                    // by returning the promise for the new (redirect) `Transition.run()`.
	                    var redirect = trans.redirect(detail);
	                    return redirect.run().catch(rejectedTransitionHandler(redirect));
	                }
	                if (error.type === rejectFactory_1.RejectType.ABORTED) {
	                    isLatest && router.urlRouter.update();
	                    return coreservices_1.services.$q.reject(error);
	                }
	            }
	            var errorHandler = _this.defaultErrorHandler();
	            errorHandler(error);
	            return coreservices_1.services.$q.reject(error);
	        }; };
	        var transition = this.router.transitionService.create(currentPath, ref);
	        var transitionToPromise = transition.run().catch(rejectedTransitionHandler(transition));
	        common_1.silenceUncaughtInPromise(transitionToPromise); // issue #2676
	        // Return a promise for the transition, which also has the transition object on it.
	        return common_1.extend(transitionToPromise, { transition: transition });
	    };
	    /**
	     * Checks if the current state *is* the provided state
	     *
	     * Similar to [[includes]] but only checks for the full state name.
	     * If params is supplied then it will be tested for strict equality against the current
	     * active params object, so all params must match with none missing and no extras.
	     *
	     * #### Example:
	     * ```js
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     * ```
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * ```html
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * ```
	     *
	     * @param stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param options An options object. The options are:
	     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     *     test relative to `options.relative` state (or name).
	     *
	     * @returns Returns true if it is the state.
	     */
	    StateService.prototype.is = function (stateOrName, params, options) {
	        options = common_1.defaults(options, { relative: this.$current });
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
	        if (!predicates_1.isDefined(state))
	            return undefined;
	        if (this.$current !== state)
	            return false;
	        if (!params)
	            return true;
	        var schema = state.parameters({ inherit: true, matchingKeys: params });
	        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
	    };
	    /**
	     * Checks if the current state *includes* the provided state
	     *
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * #### Example when `$state.$current.name === 'contacts.details.item'`
	     * ```js
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     * ```
	     *
	     * #### Glob Examples when `* $state.$current.name === 'contacts.details.item.url'`:
	     * ```js
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * ```
	     *
	     * @param stateOrName A partial name, relative name, glob pattern,
	     *   or state object to be searched for within the current state name.
	     * @param params A param object, e.g. `{sectionId: section.id}`,
	     *   that you'd like to test against the current active state.
	     * @param options An options object. The options are:
	     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     *     test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    StateService.prototype.includes = function (stateOrName, params, options) {
	        options = common_1.defaults(options, { relative: this.$current });
	        var glob = predicates_1.isString(stateOrName) && glob_1.Glob.fromString(stateOrName);
	        if (glob) {
	            if (!glob.matches(this.$current.name))
	                return false;
	            stateOrName = this.$current.name;
	        }
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative), include = this.$current.includes;
	        if (!predicates_1.isDefined(state))
	            return undefined;
	        if (!predicates_1.isDefined(include[state.name]))
	            return false;
	        if (!params)
	            return true;
	        var schema = state.parameters({ inherit: true, matchingKeys: params });
	        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
	    };
	    /**
	     * Generates a URL for a state and parameters
	     *
	     * Returns the url for the given state populated with the given params.
	     *
	     * #### Example:
	     * ```js
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * ```
	     *
	     * @param stateOrName The state name or state object you'd like to generate a url from.
	     * @param params An object of parameter values to fill the state's required parameters.
	     * @param options Options object. The options are:
	     *
	     * @returns {string} compiled state url
	     */
	    StateService.prototype.href = function (stateOrName, params, options) {
	        var defaultHrefOpts = {
	            lossy: true,
	            inherit: true,
	            absolute: false,
	            relative: this.$current,
	        };
	        options = common_1.defaults(options, defaultHrefOpts);
	        params = params || {};
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
	        if (!predicates_1.isDefined(state))
	            return null;
	        if (options.inherit)
	            params = this.params.$inherit(params, this.$current, state);
	        var nav = state && options.lossy ? state.navigable : state;
	        if (!nav || nav.url === undefined || nav.url === null) {
	            return null;
	        }
	        return this.router.urlRouter.href(nav.url, params, { absolute: options.absolute });
	    };
	    /**
	     * Sets or gets the default [[transitionTo]] error handler.
	     *
	     * The error handler is called when a [[Transition]] is rejected or when any error occurred during the Transition.
	     * This includes errors caused by resolves and transition hooks.
	     *
	     * Note:
	     * This handler does not receive certain Transition rejections.
	     * Redirected and Ignored Transitions are not considered to be errors by [[StateService.transitionTo]].
	     *
	     * The built-in default error handler logs the error to the console.
	     *
	     * You can provide your own custom handler.
	     *
	     * #### Example:
	     * ```js
	     * stateService.defaultErrorHandler(function() {
	     *   // Do not log transitionTo errors
	     * });
	     * ```
	     *
	     * @param handler a global error handler function
	     * @returns the current global error handler
	     */
	    StateService.prototype.defaultErrorHandler = function (handler) {
	        return (this._defaultErrorHandler = handler || this._defaultErrorHandler);
	    };
	    StateService.prototype.get = function (stateOrName, base) {
	        var reg = this.router.stateRegistry;
	        if (arguments.length === 0)
	            return reg.get();
	        return reg.get(stateOrName, base || this.$current);
	    };
	    /**
	     * Lazy loads a state
	     *
	     * Explicitly runs a state's [[StateDeclaration.lazyLoad]] function.
	     *
	     * @param stateOrName the state that should be lazy loaded
	     * @param transition the optional Transition context to use (if the lazyLoad function requires an injector, etc)
	     * Note: If no transition is provided, a noop transition is created using the from the current state to the current state.
	     * This noop transition is not actually run.
	     *
	     * @returns a promise to lazy load
	     */
	    StateService.prototype.lazyLoad = function (stateOrName, transition) {
	        var state = this.get(stateOrName);
	        if (!state || !state.lazyLoad)
	            throw new Error('Can not lazy load ' + stateOrName);
	        var currentPath = this.getCurrentPath();
	        var target = pathUtils_1.PathUtils.makeTargetState(this.router.stateRegistry, currentPath);
	        transition = transition || this.router.transitionService.create(currentPath, target);
	        return lazyLoad_1.lazyLoadState(transition, state);
	    };
	    return StateService;
	}());
	exports.StateService = StateService;
	//# sourceMappingURL=stateService.js.map

/***/ },

/***/ 59:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HookBuilder = void 0;
	var common_1 = __webpack_require__(4);
	var predicates_1 = __webpack_require__(5);
	var interface_1 = __webpack_require__(13);
	var transitionHook_1 = __webpack_require__(17);
	/**
	 * This class returns applicable TransitionHooks for a specific Transition instance.
	 *
	 * Hooks ([[RegisteredHook]]) may be registered globally, e.g., $transitions.onEnter(...), or locally, e.g.
	 * myTransition.onEnter(...).  The HookBuilder finds matching RegisteredHooks (where the match criteria is
	 * determined by the type of hook)
	 *
	 * The HookBuilder also converts RegisteredHooks objects to TransitionHook objects, which are used to run a Transition.
	 *
	 * The HookBuilder constructor is given the $transitions service and a Transition instance.  Thus, a HookBuilder
	 * instance may only be used for one specific Transition object. (side note: the _treeChanges accessor is private
	 * in the Transition class, so we must also provide the Transition's _treeChanges)
	 */
	var HookBuilder = /** @class */ (function () {
	    function HookBuilder(transition) {
	        this.transition = transition;
	    }
	    HookBuilder.prototype.buildHooksForPhase = function (phase) {
	        var _this = this;
	        var $transitions = this.transition.router.transitionService;
	        return $transitions._pluginapi
	            ._getEvents(phase)
	            .map(function (type) { return _this.buildHooks(type); })
	            .reduce(common_1.unnestR, [])
	            .filter(common_1.identity);
	    };
	    /**
	     * Returns an array of newly built TransitionHook objects.
	     *
	     * - Finds all RegisteredHooks registered for the given `hookType` which matched the transition's [[TreeChanges]].
	     * - Finds [[PathNode]] (or `PathNode[]`) to use as the TransitionHook context(s)
	     * - For each of the [[PathNode]]s, creates a TransitionHook
	     *
	     * @param hookType the type of the hook registration function, e.g., 'onEnter', 'onFinish'.
	     */
	    HookBuilder.prototype.buildHooks = function (hookType) {
	        var transition = this.transition;
	        var treeChanges = transition.treeChanges();
	        // Find all the matching registered hooks for a given hook type
	        var matchingHooks = this.getMatchingHooks(hookType, treeChanges, transition);
	        if (!matchingHooks)
	            return [];
	        var baseHookOptions = {
	            transition: transition,
	            current: transition.options().current,
	        };
	        var makeTransitionHooks = function (hook) {
	            // Fetch the Nodes that caused this hook to match.
	            var matches = hook.matches(treeChanges, transition);
	            // Select the PathNode[] that will be used as TransitionHook context objects
	            var matchingNodes = matches[hookType.criteriaMatchPath.name];
	            // Return an array of HookTuples
	            return matchingNodes.map(function (node) {
	                var _options = common_1.extend({
	                    bind: hook.bind,
	                    traceData: { hookType: hookType.name, context: node },
	                }, baseHookOptions);
	                var state = hookType.criteriaMatchPath.scope === interface_1.TransitionHookScope.STATE ? node.state.self : null;
	                var transitionHook = new transitionHook_1.TransitionHook(transition, state, hook, _options);
	                return { hook: hook, node: node, transitionHook: transitionHook };
	            });
	        };
	        return matchingHooks
	            .map(makeTransitionHooks)
	            .reduce(common_1.unnestR, [])
	            .sort(tupleSort(hookType.reverseSort))
	            .map(function (tuple) { return tuple.transitionHook; });
	    };
	    /**
	     * Finds all RegisteredHooks from:
	     * - The Transition object instance hook registry
	     * - The TransitionService ($transitions) global hook registry
	     *
	     * which matched:
	     * - the eventType
	     * - the matchCriteria (to, from, exiting, retained, entering)
	     *
	     * @returns an array of matched [[RegisteredHook]]s
	     */
	    HookBuilder.prototype.getMatchingHooks = function (hookType, treeChanges, transition) {
	        var isCreate = hookType.hookPhase === interface_1.TransitionHookPhase.CREATE;
	        // Instance and Global hook registries
	        var $transitions = this.transition.router.transitionService;
	        var registries = isCreate ? [$transitions] : [this.transition, $transitions];
	        return registries
	            .map(function (reg) { return reg.getHooks(hookType.name); }) // Get named hooks from registries
	            .filter(common_1.assertPredicate(predicates_1.isArray, "broken event named: " + hookType.name)) // Sanity check
	            .reduce(common_1.unnestR, []) // Un-nest RegisteredHook[][] to RegisteredHook[] array
	            .filter(function (hook) { return hook.matches(treeChanges, transition); }); // Only those satisfying matchCriteria
	    };
	    return HookBuilder;
	}());
	exports.HookBuilder = HookBuilder;
	/**
	 * A factory for a sort function for HookTuples.
	 *
	 * The sort function first compares the PathNode depth (how deep in the state tree a node is), then compares
	 * the EventHook priority.
	 *
	 * @param reverseDepthSort a boolean, when true, reverses the sort order for the node depth
	 * @returns a tuple sort function
	 */
	function tupleSort(reverseDepthSort) {
	    if (reverseDepthSort === void 0) { reverseDepthSort = false; }
	    return function nodeDepthThenPriority(l, r) {
	        var factor = reverseDepthSort ? -1 : 1;
	        var depthDelta = (l.node.state.path.length - r.node.state.path.length) * factor;
	        return depthDelta !== 0 ? depthDelta : r.hook.priority - l.hook.priority;
	    };
	}
	//# sourceMappingURL=hookBuilder.js.map

/***/ },

/***/ 60:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionEventType = void 0;
	var transitionHook_1 = __webpack_require__(17);
	/**
	 * This class defines a type of hook, such as `onBefore` or `onEnter`.
	 * Plugins can define custom hook types, such as sticky states does for `onInactive`.
	 */
	var TransitionEventType = /** @class */ (function () {
	    /* tslint:disable:no-inferrable-types */
	    function TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
	        if (reverseSort === void 0) { reverseSort = false; }
	        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
	        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
	        if (synchronous === void 0) { synchronous = false; }
	        this.name = name;
	        this.hookPhase = hookPhase;
	        this.hookOrder = hookOrder;
	        this.criteriaMatchPath = criteriaMatchPath;
	        this.reverseSort = reverseSort;
	        this.getResultHandler = getResultHandler;
	        this.getErrorHandler = getErrorHandler;
	        this.synchronous = synchronous;
	    }
	    return TransitionEventType;
	}());
	exports.TransitionEventType = TransitionEventType;
	//# sourceMappingURL=transitionEventType.js.map

/***/ },

/***/ 61:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlConfig = void 0;
	var params_1 = __webpack_require__(30);
	var common_1 = __webpack_require__(7);
	/**
	 * An API to customize the URL behavior and retrieve URL configuration
	 *
	 * This API is used to customize the behavior of the URL.
	 * This includes optional trailing slashes ([[strictMode]]), case sensitivity ([[caseInsensitive]]),
	 * and custom parameter encoding (custom [[type]]).
	 *
	 * It also has information about the location (url) configuration such as [[port]] and [[baseHref]].
	 * This information can be used to build absolute URLs, such as
	 * `https://example.com:443/basepath/state/substate?param1=a#hashvalue`;
	 *
	 * This API is found at `router.urlService.config` (see: [[UIRouter.urlService]], [[URLService.config]])
	 */
	var UrlConfig = /** @class */ (function () {
	    /** @internal */ function UrlConfig(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** @internal */ this.paramTypes = new params_1.ParamTypes();
	        /** @internal */ this._decodeParams = true;
	        /** @internal */ this._isCaseInsensitive = false;
	        /** @internal */ this._isStrictMode = true;
	        /** @internal */ this._defaultSquashPolicy = false;
	        /** @internal */ this.dispose = function () { return _this.paramTypes.dispose(); };
	        // Delegate these calls to the current LocationConfig implementation
	        /**
	         * Gets the base Href, e.g., `http://localhost/approot/`
	         *
	         * @return the application's base href
	         */
	        this.baseHref = function () { return _this.router.locationConfig.baseHref(); };
	        /**
	         * Gets or sets the hashPrefix
	         *
	         * This only applies when not running in [[html5Mode]] (pushstate mode)
	         *
	         * If the current url is `http://localhost/app#!/uirouter/path/#anchor`, it returns `!` which is the prefix for the "hashbang" portion.
	         *
	         * @return the hash prefix
	         */
	        this.hashPrefix = function (newprefix) { return _this.router.locationConfig.hashPrefix(newprefix); };
	        /**
	         * Gets the host, e.g., `localhost`
	         *
	         * @return the protocol
	         */
	        this.host = function () { return _this.router.locationConfig.host(); };
	        /**
	         * Returns true when running in pushstate mode
	         *
	         * @return true when running in html5 mode (pushstate mode).
	         */
	        this.html5Mode = function () { return _this.router.locationConfig.html5Mode(); };
	        /**
	         * Gets the port, e.g., `80`
	         *
	         * @return the port number
	         */
	        this.port = function () { return _this.router.locationConfig.port(); };
	        /**
	         * Gets the protocol, e.g., `http`
	         *
	         * @return the protocol
	         */
	        this.protocol = function () { return _this.router.locationConfig.protocol(); };
	    }
	    /**
	     * Defines whether URL matching should be case sensitive (the default behavior), or not.
	     *
	     * #### Example:
	     * ```js
	     * // Allow case insensitive url matches
	     * urlService.config.caseInsensitive(true);
	     * ```
	     *
	     * @param value `false` to match URL in a case sensitive manner; otherwise `true`;
	     * @returns the current value of caseInsensitive
	     */
	    UrlConfig.prototype.caseInsensitive = function (value) {
	        return (this._isCaseInsensitive = common_1.isDefined(value) ? value : this._isCaseInsensitive);
	    };
	    /**
	     * Sets the default behavior when generating or matching URLs with default parameter values.
	     *
	     * #### Example:
	     * ```js
	     * // Remove default parameter values from the url
	     * urlService.config.defaultSquashPolicy(true);
	     * ```
	     *
	     * @param value A string that defines the default parameter URL squashing behavior.
	     *    - `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	     *    - `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	     *      parameter is surrounded by slashes, squash (remove) one slash from the URL
	     *    - any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	     *      the parameter value from the URL and replace it with this string.
	     * @returns the current value of defaultSquashPolicy
	     */
	    UrlConfig.prototype.defaultSquashPolicy = function (value) {
	        if (common_1.isDefined(value) && value !== true && value !== false && !common_1.isString(value))
	            throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	        return (this._defaultSquashPolicy = common_1.isDefined(value) ? value : this._defaultSquashPolicy);
	    };
	    /**
	     * Defines whether URLs should match trailing slashes, or not (the default behavior).
	     *
	     * #### Example:
	     * ```js
	     * // Allow optional trailing slashes
	     * urlService.config.strictMode(false);
	     * ```
	     *
	     * @param value `false` to match trailing slashes in URLs, otherwise `true`.
	     * @returns the current value of strictMode
	     */
	    UrlConfig.prototype.strictMode = function (value) {
	        return (this._isStrictMode = common_1.isDefined(value) ? value : this._isStrictMode);
	    };
	    /**
	     * Creates and registers a custom [[ParamType]] object
	     *
	     * A custom parameter type can be used to generate URLs with typed parameters or custom encoding/decoding.
	     *
	     * #### Note: Register custom types *before using them* in a state definition.
	     *
	     * #### Example:
	     * ```js
	     * // Encode object parameter as JSON string
	     * urlService.config.type('myjson', {
	     *   encode: (obj) => JSON.stringify(obj),
	     *   decode: (str) => JSON.parse(str),
	     *   is: (val) => typeof(val) === 'object',
	     *   pattern: /[^/]+/,
	     *   equals: (a, b) => _.isEqual(a, b),
	     * });
	     * ```
	     *
	     * See [[ParamTypeDefinition]] for more examples
	     *
	     * @param name The type name.
	     * @param definition The type definition. See [[ParamTypeDefinition]] for information on the values accepted.
	     * @param definitionFn A function that is injected before the app runtime starts.
	     *        The result of this function should be a [[ParamTypeDefinition]].
	     *        The result is merged into the existing `definition`.
	     *        See [[ParamType]] for information on the values accepted.
	     *
	     * @returns if only the `name` parameter was specified: the currently registered [[ParamType]] object, or undefined
	     */
	    UrlConfig.prototype.type = function (name, definition, definitionFn) {
	        var type = this.paramTypes.type(name, definition, definitionFn);
	        return !common_1.isDefined(definition) ? type : this;
	    };
	    return UrlConfig;
	}());
	exports.UrlConfig = UrlConfig;
	//# sourceMappingURL=urlConfig.js.map

/***/ },

/***/ 62:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlMatcherFactory = exports.ParamFactory = void 0;
	var common_1 = __webpack_require__(7);
	var urlMatcher_1 = __webpack_require__(23);
	var params_1 = __webpack_require__(30);
	var ParamFactory = /** @class */ (function () {
	    function ParamFactory(router) {
	        this.router = router;
	    }
	    ParamFactory.prototype.fromConfig = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.CONFIG, this.router.urlService.config, state);
	    };
	    ParamFactory.prototype.fromPath = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.PATH, this.router.urlService.config, state);
	    };
	    ParamFactory.prototype.fromSearch = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.SEARCH, this.router.urlService.config, state);
	    };
	    return ParamFactory;
	}());
	exports.ParamFactory = ParamFactory;
	/**
	 * Factory for [[UrlMatcher]] instances.
	 *
	 * The factory is available to ng1 services as
	 * `$urlMatcherFactory` or ng1 providers as `$urlMatcherFactoryProvider`.
	 */
	var UrlMatcherFactory = /** @class */ (function () {
	    // TODO: move implementations to UrlConfig (urlService.config)
	    function UrlMatcherFactory(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** Creates a new [[Param]] for a given location (DefType) */
	        this.paramFactory = new ParamFactory(this.router);
	        // TODO: Check if removal of this will break anything, then remove these
	        this.UrlMatcher = urlMatcher_1.UrlMatcher;
	        this.Param = params_1.Param;
	        /** @deprecated use [[UrlConfig.caseInsensitive]] */
	        this.caseInsensitive = function (value) { return _this.router.urlService.config.caseInsensitive(value); };
	        /** @deprecated use [[UrlConfig.defaultSquashPolicy]] */
	        this.defaultSquashPolicy = function (value) { return _this.router.urlService.config.defaultSquashPolicy(value); };
	        /** @deprecated use [[UrlConfig.strictMode]] */
	        this.strictMode = function (value) { return _this.router.urlService.config.strictMode(value); };
	        /** @deprecated use [[UrlConfig.type]] */
	        this.type = function (name, definition, definitionFn) {
	            return _this.router.urlService.config.type(name, definition, definitionFn) || _this;
	        };
	    }
	    /**
	     * Creates a [[UrlMatcher]] for the specified pattern.
	     *
	     * @param pattern  The URL pattern.
	     * @param config  The config object hash.
	     * @returns The UrlMatcher.
	     */
	    UrlMatcherFactory.prototype.compile = function (pattern, config) {
	        var urlConfig = this.router.urlService.config;
	        // backward-compatible support for config.params -> config.state.params
	        var params = config && !config.state && config.params;
	        config = params ? __assign({ state: { params: params } }, config) : config;
	        var globalConfig = {
	            strict: urlConfig._isStrictMode,
	            caseInsensitive: urlConfig._isCaseInsensitive,
	            decodeParams: urlConfig._decodeParams,
	        };
	        return new urlMatcher_1.UrlMatcher(pattern, urlConfig.paramTypes, this.paramFactory, common_1.extend(globalConfig, config));
	    };
	    /**
	     * Returns true if the specified object is a [[UrlMatcher]], or false otherwise.
	     *
	     * @param object  The object to perform the type check against.
	     * @returns `true` if the object matches the `UrlMatcher` interface, by
	     *          implementing all the same methods.
	     */
	    UrlMatcherFactory.prototype.isMatcher = function (object) {
	        // TODO: typeof?
	        if (!common_1.isObject(object))
	            return false;
	        var result = true;
	        common_1.forEach(urlMatcher_1.UrlMatcher.prototype, function (val, name) {
	            if (common_1.isFunction(val))
	                result = result && common_1.isDefined(object[name]) && common_1.isFunction(object[name]);
	        });
	        return result;
	    };
	    /** @internal */
	    UrlMatcherFactory.prototype.$get = function () {
	        var urlConfig = this.router.urlService.config;
	        urlConfig.paramTypes.enqueue = false;
	        urlConfig.paramTypes._flushTypeQueue();
	        return this;
	    };
	    return UrlMatcherFactory;
	}());
	exports.UrlMatcherFactory = UrlMatcherFactory;
	//# sourceMappingURL=urlMatcherFactory.js.map

/***/ },

/***/ 63:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlRouter = void 0;
	var common_1 = __webpack_require__(7);
	var urlRule_1 = __webpack_require__(38);
	function appendBasePath(url, isHtml5, absolute, baseHref) {
	    if (baseHref === '/')
	        return url;
	    if (isHtml5)
	        return common_1.stripLastPathElement(baseHref) + url;
	    if (absolute)
	        return baseHref.slice(1) + url;
	    return url;
	}
	/**
	 * Updates URL and responds to URL changes
	 *
	 * ### Deprecation warning:
	 * This class is now considered to be an internal API
	 * Use the [[UrlService]] instead.
	 * For configuring URL rules, use the [[UrlRules]] which can be found as [[UrlService.rules]].
	 */
	var UrlRouter = /** @class */ (function () {
	    /** @internal */
	    function UrlRouter(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        // Delegate these calls to [[UrlService]]
	        /** @deprecated use [[UrlService.sync]]*/
	        this.sync = function (evt) { return _this.router.urlService.sync(evt); };
	        /** @deprecated use [[UrlService.listen]]*/
	        this.listen = function (enabled) { return _this.router.urlService.listen(enabled); };
	        /** @deprecated use [[UrlService.deferIntercept]]*/
	        this.deferIntercept = function (defer) { return _this.router.urlService.deferIntercept(defer); };
	        /** @deprecated use [[UrlService.match]]*/
	        this.match = function (urlParts) { return _this.router.urlService.match(urlParts); };
	        // Delegate these calls to [[UrlRules]]
	        /** @deprecated use [[UrlRules.initial]]*/
	        this.initial = function (handler) {
	            return _this.router.urlService.rules.initial(handler);
	        };
	        /** @deprecated use [[UrlRules.otherwise]]*/
	        this.otherwise = function (handler) {
	            return _this.router.urlService.rules.otherwise(handler);
	        };
	        /** @deprecated use [[UrlRules.removeRule]]*/
	        this.removeRule = function (rule) { return _this.router.urlService.rules.removeRule(rule); };
	        /** @deprecated use [[UrlRules.rule]]*/
	        this.rule = function (rule) { return _this.router.urlService.rules.rule(rule); };
	        /** @deprecated use [[UrlRules.rules]]*/
	        this.rules = function () { return _this.router.urlService.rules.rules(); };
	        /** @deprecated use [[UrlRules.sort]]*/
	        this.sort = function (compareFn) { return _this.router.urlService.rules.sort(compareFn); };
	        /** @deprecated use [[UrlRules.when]]*/
	        this.when = function (matcher, handler, options) { return _this.router.urlService.rules.when(matcher, handler, options); };
	        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
	    }
	    /** Internal API. */
	    UrlRouter.prototype.update = function (read) {
	        var $url = this.router.locationService;
	        if (read) {
	            this.location = $url.url();
	            return;
	        }
	        if ($url.url() === this.location)
	            return;
	        $url.url(this.location, true);
	    };
	    /**
	     * Internal API.
	     *
	     * Pushes a new location to the browser history.
	     *
	     * @internal
	     * @param urlMatcher
	     * @param params
	     * @param options
	     */
	    UrlRouter.prototype.push = function (urlMatcher, params, options) {
	        var replace = options && !!options.replace;
	        this.router.urlService.url(urlMatcher.format(params || {}), replace);
	    };
	    /**
	     * Builds and returns a URL with interpolated parameters
	     *
	     * #### Example:
	     * ```js
	     * matcher = $umf.compile("/about/:person");
	     * params = { person: "bob" };
	     * $bob = $urlRouter.href(matcher, params);
	     * // $bob == "/about/bob";
	     * ```
	     *
	     * @param urlMatcher The [[UrlMatcher]] object which is used as the template of the URL to generate.
	     * @param params An object of parameter values to fill the matcher's required parameters.
	     * @param options Options object. The options are:
	     *
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     *
	     * @returns Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	     */
	    UrlRouter.prototype.href = function (urlMatcher, params, options) {
	        var url = urlMatcher.format(params);
	        if (url == null)
	            return null;
	        options = options || { absolute: false };
	        var cfg = this.router.urlService.config;
	        var isHtml5 = cfg.html5Mode();
	        if (!isHtml5 && url !== null) {
	            url = '#' + cfg.hashPrefix() + url;
	        }
	        url = appendBasePath(url, isHtml5, options.absolute, cfg.baseHref());
	        if (!options.absolute || !url) {
	            return url;
	        }
	        var slash = !isHtml5 && url ? '/' : '';
	        var cfgPort = cfg.port();
	        var port = (cfgPort === 80 || cfgPort === 443 ? '' : ':' + cfgPort);
	        return [cfg.protocol(), '://', cfg.host(), port, slash, url].join('');
	    };
	    Object.defineProperty(UrlRouter.prototype, "interceptDeferred", {
	        /** @deprecated use [[UrlService.interceptDeferred]]*/
	        get: function () {
	            return this.router.urlService.interceptDeferred;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return UrlRouter;
	}());
	exports.UrlRouter = UrlRouter;
	//# sourceMappingURL=urlRouter.js.map

/***/ },

/***/ 64:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlRules = void 0;
	var state_1 = __webpack_require__(33);
	var urlMatcher_1 = __webpack_require__(23);
	var common_1 = __webpack_require__(7);
	var urlRule_1 = __webpack_require__(38);
	var prioritySort = function (a, b) { return (b.priority || 0) - (a.priority || 0); };
	var typeSort = function (a, b) {
	    var weights = { STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1 };
	    return (weights[a.type] || 0) - (weights[b.type] || 0);
	};
	var urlMatcherSort = function (a, b) {
	    return !a.urlMatcher || !b.urlMatcher ? 0 : urlMatcher_1.UrlMatcher.compare(a.urlMatcher, b.urlMatcher);
	};
	var idSort = function (a, b) {
	    // Identically sorted STATE and URLMATCHER best rule will be chosen by `matchPriority` after each rule matches the URL
	    var useMatchPriority = { STATE: true, URLMATCHER: true };
	    var equal = useMatchPriority[a.type] && useMatchPriority[b.type];
	    return equal ? 0 : (a.$id || 0) - (b.$id || 0);
	};
	/**
	 * Default rule priority sorting function.
	 *
	 * Sorts rules by:
	 *
	 * - Explicit priority (set rule priority using [[UrlRules.when]])
	 * - Rule type (STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1)
	 * - `UrlMatcher` specificity ([[UrlMatcher.compare]]): works for STATE and URLMATCHER types to pick the most specific rule.
	 * - Rule registration order (for rule types other than STATE and URLMATCHER)
	 *   - Equally sorted State and UrlMatcher rules will each match the URL.
	 *     Then, the *best* match is chosen based on how many parameter values were matched.
	 */
	var defaultRuleSortFn;
	defaultRuleSortFn = function (a, b) {
	    var cmp = prioritySort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    cmp = typeSort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    cmp = urlMatcherSort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    return idSort(a, b);
	};
	function getHandlerFn(handler) {
	    if (!common_1.isFunction(handler) && !common_1.isString(handler) && !common_1.is(state_1.TargetState)(handler) && !state_1.TargetState.isDef(handler)) {
	        throw new Error("'handler' must be a string, function, TargetState, or have a state: 'newtarget' property");
	    }
	    return common_1.isFunction(handler) ? handler : common_1.val(handler);
	}
	/**
	 * API for managing URL rules
	 *
	 * This API is used to create and manage URL rules.
	 * URL rules are a mechanism to respond to specific URL patterns.
	 *
	 * The most commonly used methods are [[otherwise]] and [[when]].
	 *
	 * This API is found at `router.urlService.rules` (see: [[UIRouter.urlService]], [[URLService.rules]])
	 */
	var UrlRules = /** @class */ (function () {
	    /** @internal */
	    function UrlRules(/** @internal */ router) {
	        this.router = router;
	        /** @internal */ this._sortFn = defaultRuleSortFn;
	        /** @internal */ this._rules = [];
	        /** @internal */ this._id = 0;
	        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
	    }
	    /** @internal */
	    UrlRules.prototype.dispose = function (router) {
	        this._rules = [];
	        delete this._otherwiseFn;
	    };
	    /**
	     * Defines the initial state, path, or behavior to use when the app starts.
	     *
	     * This rule defines the initial/starting state for the application.
	     *
	     * This rule is triggered the first time the URL is checked (when the app initially loads).
	     * The rule is triggered only when the url matches either `""` or `"/"`.
	     *
	     * Note: The rule is intended to be used when the root of the application is directly linked to.
	     * When the URL is *not* `""` or `"/"` and doesn't match other rules, the [[otherwise]] rule is triggered.
	     * This allows 404-like behavior when an unknown URL is deep-linked.
	     *
	     * #### Example:
	     * Start app at `home` state.
	     * ```js
	     * .initial({ state: 'home' });
	     * ```
	     *
	     * #### Example:
	     * Start app at `/home` (by url)
	     * ```js
	     * .initial('/home');
	     * ```
	     *
	     * #### Example:
	     * When no other url rule matches, go to `home` state
	     * ```js
	     * .initial((matchValue, url, router) => {
	     *   console.log('initial state');
	     *   return { state: 'home' };
	     * })
	     * ```
	     *
	     * @param handler The initial state or url path, or a function which returns the state or url path (or performs custom logic).
	     */
	    UrlRules.prototype.initial = function (handler) {
	        var handlerFn = getHandlerFn(handler);
	        var matchFn = function (urlParts, router) {
	            return router.globals.transitionHistory.size() === 0 && !!/^\/?$/.exec(urlParts.path);
	        };
	        this.rule(this.urlRuleFactory.create(matchFn, handlerFn));
	    };
	    /**
	     * Defines the state, url, or behavior to use when no other rule matches the URL.
	     *
	     * This rule is matched when *no other rule* matches.
	     * It is generally used to handle unknown URLs (similar to "404" behavior, but on the client side).
	     *
	     * - If `handler` a string, it is treated as a url redirect
	     *
	     * #### Example:
	     * When no other url rule matches, redirect to `/index`
	     * ```js
	     * .otherwise('/index');
	     * ```
	     *
	     * - If `handler` is an object with a `state` property, the state is activated.
	     *
	     * #### Example:
	     * When no other url rule matches, redirect to `home` and provide a `dashboard` parameter value.
	     * ```js
	     * .otherwise({ state: 'home', params: { dashboard: 'default' } });
	     * ```
	     *
	     * - If `handler` is a function, the function receives the current url ([[UrlParts]]) and the [[UIRouter]] object.
	     *   The function can perform actions, and/or return a value.
	     *
	     * #### Example:
	     * When no other url rule matches, manually trigger a transition to the `home` state
	     * ```js
	     * .otherwise((matchValue, urlParts, router) => {
	     *   router.stateService.go('home');
	     * });
	     * ```
	     *
	     * #### Example:
	     * When no other url rule matches, go to `home` state
	     * ```js
	     * .otherwise((matchValue, urlParts, router) => {
	     *   return { state: 'home' };
	     * });
	     * ```
	     *
	     * @param handler The url path to redirect to, or a function which returns the url path (or performs custom logic).
	     */
	    UrlRules.prototype.otherwise = function (handler) {
	        var handlerFn = getHandlerFn(handler);
	        this._otherwiseFn = this.urlRuleFactory.create(common_1.val(true), handlerFn);
	        this._sorted = false;
	    };
	    /**
	     * Remove a rule previously registered
	     *
	     * @param rule the matcher rule that was previously registered using [[rule]]
	     */
	    UrlRules.prototype.removeRule = function (rule) {
	        common_1.removeFrom(this._rules, rule);
	    };
	    /**
	     * Manually adds a URL Rule.
	     *
	     * Usually, a url rule is added using [[StateDeclaration.url]] or [[when]].
	     * This api can be used directly for more control (to register a [[BaseUrlRule]], for example).
	     * Rules can be created using [[urlRuleFactory]], or created manually as simple objects.
	     *
	     * A rule should have a `match` function which returns truthy if the rule matched.
	     * It should also have a `handler` function which is invoked if the rule is the best match.
	     *
	     * @return a function that deregisters the rule
	     */
	    UrlRules.prototype.rule = function (rule) {
	        var _this = this;
	        if (!urlRule_1.UrlRuleFactory.isUrlRule(rule))
	            throw new Error('invalid rule');
	        rule.$id = this._id++;
	        rule.priority = rule.priority || 0;
	        this._rules.push(rule);
	        this._sorted = false;
	        return function () { return _this.removeRule(rule); };
	    };
	    /**
	     * Gets all registered rules
	     *
	     * @returns an array of all the registered rules
	     */
	    UrlRules.prototype.rules = function () {
	        this.ensureSorted();
	        return this._rules.concat(this._otherwiseFn ? [this._otherwiseFn] : []);
	    };
	    /**
	     * Defines URL Rule priorities
	     *
	     * More than one rule ([[UrlRule]]) might match a given URL.
	     * This `compareFn` is used to sort the rules by priority.
	     * Higher priority rules should sort earlier.
	     *
	     * The [[defaultRuleSortFn]] is used by default.
	     *
	     * You only need to call this function once.
	     * The `compareFn` will be used to sort the rules as each is registered.
	     *
	     * If called without any parameter, it will re-sort the rules.
	     *
	     * ---
	     *
	     * Url rules may come from multiple sources: states's urls ([[StateDeclaration.url]]), [[when]], and [[rule]].
	     * Each rule has a (user-provided) [[UrlRule.priority]], a [[UrlRule.type]], and a [[UrlRule.$id]]
	     * The `$id` is is the order in which the rule was registered.
	     *
	     * The sort function should use these data, or data found on a specific type
	     * of [[UrlRule]] (such as [[StateRule.state]]), to order the rules as desired.
	     *
	     * #### Example:
	     * This compare function prioritizes rules by the order in which the rules were registered.
	     * A rule registered earlier has higher priority.
	     *
	     * ```js
	     * function compareFn(a, b) {
	     *   return a.$id - b.$id;
	     * }
	     * ```
	     *
	     * @param compareFn a function that compares to [[UrlRule]] objects.
	     *    The `compareFn` should abide by the `Array.sort` compare function rules.
	     *    Given two rules, `a` and `b`, return a negative number if `a` should be higher priority.
	     *    Return a positive number if `b` should be higher priority.
	     *    Return `0` if the rules are identical.
	     *
	     *    See the [mozilla reference](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Description)
	     *    for details.
	     */
	    UrlRules.prototype.sort = function (compareFn) {
	        var sorted = this.stableSort(this._rules, (this._sortFn = compareFn || this._sortFn));
	        // precompute _sortGroup values and apply to each rule
	        var group = 0;
	        for (var i = 0; i < sorted.length; i++) {
	            sorted[i]._group = group;
	            if (i < sorted.length - 1 && this._sortFn(sorted[i], sorted[i + 1]) !== 0) {
	                group++;
	            }
	        }
	        this._rules = sorted;
	        this._sorted = true;
	    };
	    /** @internal */
	    UrlRules.prototype.ensureSorted = function () {
	        this._sorted || this.sort();
	    };
	    /** @internal */
	    UrlRules.prototype.stableSort = function (arr, compareFn) {
	        var arrOfWrapper = arr.map(function (elem, idx) { return ({ elem: elem, idx: idx }); });
	        arrOfWrapper.sort(function (wrapperA, wrapperB) {
	            var cmpDiff = compareFn(wrapperA.elem, wrapperB.elem);
	            return cmpDiff === 0 ? wrapperA.idx - wrapperB.idx : cmpDiff;
	        });
	        return arrOfWrapper.map(function (wrapper) { return wrapper.elem; });
	    };
	    /**
	     * Registers a `matcher` and `handler` for custom URLs handling.
	     *
	     * The `matcher` can be:
	     *
	     * - a [[UrlMatcher]]: See: [[UrlMatcherFactory.compile]]
	     * - a `string`: The string is compiled to a [[UrlMatcher]]
	     * - a `RegExp`: The regexp is used to match the url.
	     *
	     * The `handler` can be:
	     *
	     * - a string: The url is redirected to the value of the string.
	     * - a function: The url is redirected to the return value of the function.
	     *
	     * ---
	     *
	     * When the `handler` is a `string` and the `matcher` is a `UrlMatcher` (or string), the redirect
	     * string is interpolated with parameter values.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when("/foo/:param1", "/bar/:param1")
	     * ```
	     *
	     * ---
	     *
	     * When the `handler` is a string and the `matcher` is a `RegExp`, the redirect string is
	     * interpolated with capture groups from the RegExp.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when(new RegExp("^/foo/(.*)$"), "/bar/$1");
	     * ```
	     *
	     * ---
	     *
	     * When the handler is a function, it receives the matched value, the current URL, and the `UIRouter` object (See [[UrlRuleHandlerFn]]).
	     * The "matched value" differs based on the `matcher`.
	     * For [[UrlMatcher]]s, it will be the matched state params.
	     * For `RegExp`, it will be the match array from `regexp.exec()`.
	     *
	     * If the handler returns a string, the URL is redirected to the string.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when(new RegExp("^/foo/(.*)$"), match => "/bar/" + match[1]);
	     * ```
	     *
	     * Note: the `handler` may also invoke arbitrary code, such as `$state.go()`
	     *
	     * @param matcher A pattern `string` to match, compiled as a [[UrlMatcher]], or a `RegExp`.
	     * @param handler The path to redirect to, or a function that returns the path.
	     * @param options `{ priority: number }`
	     *
	     * @return the registered [[UrlRule]]
	     */
	    UrlRules.prototype.when = function (matcher, handler, options) {
	        var rule = this.urlRuleFactory.create(matcher, handler);
	        if (common_1.isDefined(options && options.priority))
	            rule.priority = options.priority;
	        this.rule(rule);
	        return rule;
	    };
	    return UrlRules;
	}());
	exports.UrlRules = UrlRules;
	//# sourceMappingURL=urlRules.js.map

/***/ },

/***/ 65:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlService = void 0;
	var common_1 = __webpack_require__(7);
	var urlRules_1 = __webpack_require__(64);
	var urlConfig_1 = __webpack_require__(61);
	var state_1 = __webpack_require__(33);
	/**
	 * API for URL management
	 */
	var UrlService = /** @class */ (function () {
	    /** @internal */
	    function UrlService(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** @internal */ this.interceptDeferred = false;
	        /**
	         * The nested [[UrlRules]] API for managing URL rules and rewrites
	         *
	         * See: [[UrlRules]] for details
	         */
	        this.rules = new urlRules_1.UrlRules(this.router);
	        /**
	         * The nested [[UrlConfig]] API to configure the URL and retrieve URL information
	         *
	         * See: [[UrlConfig]] for details
	         */
	        this.config = new urlConfig_1.UrlConfig(this.router);
	        // Delegate these calls to the current LocationServices implementation
	        /**
	         * Gets the current url, or updates the url
	         *
	         * ### Getting the current URL
	         *
	         * When no arguments are passed, returns the current URL.
	         * The URL is normalized using the internal [[path]]/[[search]]/[[hash]] values.
	         *
	         * For example, the URL may be stored in the hash ([[HashLocationServices]]) or
	         * have a base HREF prepended ([[PushStateLocationServices]]).
	         *
	         * The raw URL in the browser might be:
	         *
	         * ```
	         * http://mysite.com/somepath/index.html#/internal/path/123?param1=foo#anchor
	         * ```
	         *
	         * or
	         *
	         * ```
	         * http://mysite.com/basepath/internal/path/123?param1=foo#anchor
	         * ```
	         *
	         * then this method returns:
	         *
	         * ```
	         * /internal/path/123?param1=foo#anchor
	         * ```
	         *
	         *
	         * #### Example:
	         * ```js
	         * locationServices.url(); // "/some/path?query=value#anchor"
	         * ```
	         *
	         * ### Updating the URL
	         *
	         * When `newurl` arguments is provided, changes the URL to reflect `newurl`
	         *
	         * #### Example:
	         * ```js
	         * locationServices.url("/some/path?query=value#anchor", true);
	         * ```
	         *
	         * @param newurl The new value for the URL.
	         *               This url should reflect only the new internal [[path]], [[search]], and [[hash]] values.
	         *               It should not include the protocol, site, port, or base path of an absolute HREF.
	         * @param replace When true, replaces the current history entry (instead of appending it) with this new url
	         * @param state The history's state object, i.e., pushState (if the LocationServices implementation supports it)
	         *
	         * @return the url (after potentially being processed)
	         */
	        this.url = function (newurl, replace, state) {
	            return _this.router.locationService.url(newurl, replace, state);
	        };
	        /**
	         * Gets the path part of the current url
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `/some/path`
	         *
	         * @return the path portion of the url
	         */
	        this.path = function () { return _this.router.locationService.path(); };
	        /**
	         * Gets the search part of the current url as an object
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `{ query: 'value' }`
	         *
	         * @return the search (query) portion of the url, as an object
	         */
	        this.search = function () { return _this.router.locationService.search(); };
	        /**
	         * Gets the hash part of the current url
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `anchor`
	         *
	         * @return the hash (anchor) portion of the url
	         */
	        this.hash = function () { return _this.router.locationService.hash(); };
	        /**
	         * @internal
	         *
	         * Registers a low level url change handler
	         *
	         * Note: Because this is a low level handler, it's not recommended for general use.
	         *
	         * #### Example:
	         * ```js
	         * let deregisterFn = locationServices.onChange((evt) => console.log("url change", evt));
	         * ```
	         *
	         * @param callback a function that will be called when the url is changing
	         * @return a function that de-registers the callback
	         */
	        this.onChange = function (callback) { return _this.router.locationService.onChange(callback); };
	    }
	    /** @internal */
	    UrlService.prototype.dispose = function () {
	        this.listen(false);
	        this.rules.dispose();
	    };
	    /**
	     * Gets the current URL parts
	     *
	     * This method returns the different parts of the current URL (the [[path]], [[search]], and [[hash]]) as a [[UrlParts]] object.
	     */
	    UrlService.prototype.parts = function () {
	        return { path: this.path(), search: this.search(), hash: this.hash() };
	    };
	    /**
	     * Activates the best rule for the current URL
	     *
	     * Checks the current URL for a matching [[UrlRule]], then invokes that rule's handler.
	     * This method is called internally any time the URL has changed.
	     *
	     * This effectively activates the state (or redirect, etc) which matches the current URL.
	     *
	     * #### Example:
	     * ```js
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   urlService.listen();
	     *   // Find the matching URL and invoke the handler.
	     *   urlService.sync();
	     * });
	     * ```
	     */
	    UrlService.prototype.sync = function (evt) {
	        if (evt && evt.defaultPrevented)
	            return;
	        var _a = this.router, urlService = _a.urlService, stateService = _a.stateService;
	        var url = { path: urlService.path(), search: urlService.search(), hash: urlService.hash() };
	        var best = this.match(url);
	        var applyResult = common_1.pattern([
	            [common_1.isString, function (newurl) { return urlService.url(newurl, true); }],
	            [state_1.TargetState.isDef, function (def) { return stateService.go(def.state, def.params, def.options); }],
	            [common_1.is(state_1.TargetState), function (target) { return stateService.go(target.state(), target.params(), target.options()); }],
	        ]);
	        applyResult(best && best.rule.handler(best.match, url, this.router));
	    };
	    /**
	     * Starts or stops listening for URL changes
	     *
	     * Call this sometime after calling [[deferIntercept]] to start monitoring the url.
	     * This causes UI-Router to start listening for changes to the URL, if it wasn't already listening.
	     *
	     * If called with `false`, UI-Router will stop listening (call listen(true) to start listening again).
	     *
	     * #### Example:
	     * ```js
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   // Start responding to URL changes
	     *   urlService.listen();
	     *   urlService.sync();
	     * });
	     * ```
	     *
	     * @param enabled `true` or `false` to start or stop listening to URL changes
	     */
	    UrlService.prototype.listen = function (enabled) {
	        var _this = this;
	        if (enabled === false) {
	            this._stopListeningFn && this._stopListeningFn();
	            delete this._stopListeningFn;
	        }
	        else {
	            return (this._stopListeningFn =
	                this._stopListeningFn || this.router.urlService.onChange(function (evt) { return _this.sync(evt); }));
	        }
	    };
	    /**
	     * Disables monitoring of the URL.
	     *
	     * Call this method before UI-Router has bootstrapped.
	     * It will stop UI-Router from performing the initial url sync.
	     *
	     * This can be useful to perform some asynchronous initialization before the router starts.
	     * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
	     *
	     * #### Example:
	     * ```js
	     * // Prevent UI-Router from automatically intercepting URL changes when it starts;
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   urlService.listen();
	     *   urlService.sync();
	     * });
	     * ```
	     *
	     * @param defer Indicates whether to defer location change interception.
	     *        Passing no parameter is equivalent to `true`.
	     */
	    UrlService.prototype.deferIntercept = function (defer) {
	        if (defer === undefined)
	            defer = true;
	        this.interceptDeferred = defer;
	    };
	    /**
	     * Matches a URL
	     *
	     * Given a URL (as a [[UrlParts]] object), check all rules and determine the best matching rule.
	     * Return the result as a [[MatchResult]].
	     */
	    UrlService.prototype.match = function (url) {
	        var _this = this;
	        url = common_1.extend({ path: '', search: {}, hash: '' }, url);
	        var rules = this.rules.rules();
	        // Checks a single rule. Returns { rule: rule, match: match, weight: weight } if it matched, or undefined
	        var checkRule = function (rule) {
	            var match = rule.match(url, _this.router);
	            return match && { match: match, rule: rule, weight: rule.matchPriority(match) };
	        };
	        // The rules are pre-sorted.
	        // - Find the first matching rule.
	        // - Find any other matching rule that sorted *exactly the same*, according to `.sort()`.
	        // - Choose the rule with the highest match weight.
	        var best;
	        for (var i = 0; i < rules.length; i++) {
	            // Stop when there is a 'best' rule and the next rule sorts differently than it.
	            if (best && best.rule._group !== rules[i]._group)
	                break;
	            var current = checkRule(rules[i]);
	            // Pick the best MatchResult
	            best = !best || (current && current.weight > best.weight) ? current : best;
	        }
	        return best;
	    };
	    return UrlService;
	}());
	exports.UrlService = UrlService;
	//# sourceMappingURL=urlService.js.map

/***/ },

/***/ 66:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BrowserLocationConfig = void 0;
	var predicates_1 = __webpack_require__(5);
	/** A `LocationConfig` that delegates to the browser's `location` object */
	var BrowserLocationConfig = /** @class */ (function () {
	    function BrowserLocationConfig(router, _isHtml5) {
	        if (_isHtml5 === void 0) { _isHtml5 = false; }
	        this._isHtml5 = _isHtml5;
	        this._baseHref = undefined;
	        this._hashPrefix = '';
	    }
	    BrowserLocationConfig.prototype.port = function () {
	        if (location.port) {
	            return Number(location.port);
	        }
	        return this.protocol() === 'https' ? 443 : 80;
	    };
	    BrowserLocationConfig.prototype.protocol = function () {
	        return location.protocol.replace(/:/g, '');
	    };
	    BrowserLocationConfig.prototype.host = function () {
	        return location.hostname;
	    };
	    BrowserLocationConfig.prototype.html5Mode = function () {
	        return this._isHtml5;
	    };
	    BrowserLocationConfig.prototype.hashPrefix = function (newprefix) {
	        return predicates_1.isDefined(newprefix) ? (this._hashPrefix = newprefix) : this._hashPrefix;
	    };
	    BrowserLocationConfig.prototype.baseHref = function (href) {
	        if (predicates_1.isDefined(href))
	            this._baseHref = href;
	        if (predicates_1.isUndefined(this._baseHref))
	            this._baseHref = this.getBaseHref();
	        return this._baseHref;
	    };
	    BrowserLocationConfig.prototype.getBaseHref = function () {
	        var baseTag = document.getElementsByTagName('base')[0];
	        if (baseTag && baseTag.href) {
	            return baseTag.href.replace(/^([^/:]*:)?\/\/[^/]*/, '');
	        }
	        return this._isHtml5 ? '/' : location.pathname || '/';
	    };
	    BrowserLocationConfig.prototype.dispose = function () { };
	    return BrowserLocationConfig;
	}());
	exports.BrowserLocationConfig = BrowserLocationConfig;
	//# sourceMappingURL=browserLocationConfig.js.map

/***/ },

/***/ 67:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HashLocationService = void 0;
	var common_1 = __webpack_require__(7);
	var baseLocationService_1 = __webpack_require__(24);
	/** A `LocationServices` that uses the browser hash "#" to get/set the current location */
	var HashLocationService = /** @class */ (function (_super) {
	    __extends(HashLocationService, _super);
	    function HashLocationService(router) {
	        var _this = _super.call(this, router, false) || this;
	        common_1.root.addEventListener('hashchange', _this._listener, false);
	        return _this;
	    }
	    HashLocationService.prototype._get = function () {
	        return common_1.trimHashVal(this._location.hash);
	    };
	    HashLocationService.prototype._set = function (state, title, url, replace) {
	        this._location.hash = url;
	    };
	    HashLocationService.prototype.dispose = function (router) {
	        _super.prototype.dispose.call(this, router);
	        common_1.root.removeEventListener('hashchange', this._listener);
	    };
	    return HashLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.HashLocationService = HashLocationService;
	//# sourceMappingURL=hashLocationService.js.map

/***/ },

/***/ 68:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.$injector = void 0;
	var index_1 = __webpack_require__(7);
	// globally available injectables
	var globals = {};
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/gm;
	var ARGUMENT_NAMES = /([^\s,]+)/g;
	/**
	 * A basic angular1-like injector api
	 *
	 * This object implements four methods similar to the
	 * [angular 1 dependency injector](https://docs.angularjs.org/api/auto/service/$injector)
	 *
	 * UI-Router evolved from an angular 1 library to a framework agnostic library.
	 * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
	 *
	 * This object provides a naive implementation of a globally scoped dependency injection system.
	 * It supports the following DI approaches:
	 *
	 * ### Function parameter names
	 *
	 * A function's `.toString()` is called, and the parameter names are parsed.
	 * This only works when the parameter names aren't "mangled" by a minifier such as UglifyJS.
	 *
	 * ```js
	 * function injectedFunction(FooService, BarService) {
	 *   // FooService and BarService are injected
	 * }
	 * ```
	 *
	 * ### Function annotation
	 *
	 * A function may be annotated with an array of dependency names as the `$inject` property.
	 *
	 * ```js
	 * injectedFunction.$inject = [ 'FooService', 'BarService' ];
	 * function injectedFunction(fs, bs) {
	 *   // FooService and BarService are injected as fs and bs parameters
	 * }
	 * ```
	 *
	 * ### Array notation
	 *
	 * An array provides the names of the dependencies to inject (as strings).
	 * The function is the last element of the array.
	 *
	 * ```js
	 * [ 'FooService', 'BarService', function (fs, bs) {
	 *   // FooService and BarService are injected as fs and bs parameters
	 * }]
	 * ```
	 *
	 * @type {$InjectorLike}
	 */
	exports.$injector = {
	    /** Gets an object from DI based on a string token */
	    get: function (name) { return globals[name]; },
	    /** Returns true if an object named `name` exists in global DI */
	    has: function (name) { return exports.$injector.get(name) != null; },
	    /**
	     * Injects a function
	     *
	     * @param fn the function to inject
	     * @param context the function's `this` binding
	     * @param locals An object with additional DI tokens and values, such as `{ someToken: { foo: 1 } }`
	     */
	    invoke: function (fn, context, locals) {
	        var all = index_1.extend({}, globals, locals || {});
	        var params = exports.$injector.annotate(fn);
	        var ensureExist = index_1.assertPredicate(function (key) { return all.hasOwnProperty(key); }, function (key) { return "DI can't find injectable: '" + key + "'"; });
	        var args = params.filter(ensureExist).map(function (x) { return all[x]; });
	        if (index_1.isFunction(fn))
	            return fn.apply(context, args);
	        else
	            return fn.slice(-1)[0].apply(context, args);
	    },
	    /**
	     * Returns a function's dependencies
	     *
	     * Analyzes a function (or array) and returns an array of DI tokens that the function requires.
	     * @return an array of `string`s
	     */
	    annotate: function (fn) {
	        if (!index_1.isInjectable(fn))
	            throw new Error("Not an injectable function: " + fn);
	        if (fn && fn.$inject)
	            return fn.$inject;
	        if (index_1.isArray(fn))
	            return fn.slice(0, -1);
	        var fnStr = fn.toString().replace(STRIP_COMMENTS, '');
	        var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(ARGUMENT_NAMES);
	        return result || [];
	    },
	};
	//# sourceMappingURL=injector.js.map

/***/ },

/***/ 69:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MemoryLocationConfig = void 0;
	var predicates_1 = __webpack_require__(5);
	var common_1 = __webpack_require__(4);
	/** A `LocationConfig` mock that gets/sets all config from an in-memory object */
	var MemoryLocationConfig = /** @class */ (function () {
	    function MemoryLocationConfig() {
	        var _this = this;
	        this.dispose = common_1.noop;
	        this._baseHref = '';
	        this._port = 80;
	        this._protocol = 'http';
	        this._host = 'localhost';
	        this._hashPrefix = '';
	        this.port = function () { return _this._port; };
	        this.protocol = function () { return _this._protocol; };
	        this.host = function () { return _this._host; };
	        this.baseHref = function () { return _this._baseHref; };
	        this.html5Mode = function () { return false; };
	        this.hashPrefix = function (newval) { return (predicates_1.isDefined(newval) ? (_this._hashPrefix = newval) : _this._hashPrefix); };
	    }
	    return MemoryLocationConfig;
	}());
	exports.MemoryLocationConfig = MemoryLocationConfig;
	//# sourceMappingURL=memoryLocationConfig.js.map

/***/ },

/***/ 70:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MemoryLocationService = void 0;
	var baseLocationService_1 = __webpack_require__(24);
	/** A `LocationServices` that gets/sets the current location from an in-memory object */
	var MemoryLocationService = /** @class */ (function (_super) {
	    __extends(MemoryLocationService, _super);
	    function MemoryLocationService(router) {
	        return _super.call(this, router, true) || this;
	    }
	    MemoryLocationService.prototype._get = function () {
	        return this._url;
	    };
	    MemoryLocationService.prototype._set = function (state, title, url, replace) {
	        this._url = url;
	    };
	    return MemoryLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.MemoryLocationService = MemoryLocationService;
	//# sourceMappingURL=memoryLocationService.js.map

/***/ },

/***/ 71:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PushStateLocationService = void 0;
	var baseLocationService_1 = __webpack_require__(24);
	var common_1 = __webpack_require__(7);
	/**
	 * A `LocationServices` that gets/sets the current location using the browser's `location` and `history` apis
	 *
	 * Uses `history.pushState` and `history.replaceState`
	 */
	var PushStateLocationService = /** @class */ (function (_super) {
	    __extends(PushStateLocationService, _super);
	    function PushStateLocationService(router) {
	        var _this = _super.call(this, router, true) || this;
	        _this._config = router.urlService.config;
	        common_1.root.addEventListener('popstate', _this._listener, false);
	        return _this;
	    }
	    /**
	     * Gets the base prefix without:
	     * - trailing slash
	     * - trailing filename
	     * - protocol and hostname
	     *
	     * If <base href='/base/'>, this returns '/base'.
	     * If <base href='/foo/base/'>, this returns '/foo/base'.
	     * If <base href='/base/index.html'>, this returns '/base'.
	     * If <base href='http://localhost:8080/base/index.html'>, this returns '/base'.
	     * If <base href='/base'>, this returns ''.
	     * If <base href='http://localhost:8080'>, this returns ''.
	     * If <base href='http://localhost:8080/'>, this returns ''.
	     *
	     * See: https://html.spec.whatwg.org/dev/semantics.html#the-base-element
	     */
	    PushStateLocationService.prototype._getBasePrefix = function () {
	        return common_1.stripLastPathElement(this._config.baseHref());
	    };
	    PushStateLocationService.prototype._get = function () {
	        var _a = this._location, pathname = _a.pathname, hash = _a.hash, search = _a.search;
	        search = common_1.splitQuery(search)[1]; // strip ? if found
	        hash = common_1.splitHash(hash)[1]; // strip # if found
	        var basePrefix = this._getBasePrefix();
	        var exactBaseHrefMatch = pathname === this._config.baseHref();
	        var startsWithBase = pathname.substr(0, basePrefix.length) === basePrefix;
	        pathname = exactBaseHrefMatch ? '/' : startsWithBase ? pathname.substring(basePrefix.length) : pathname;
	        return pathname + (search ? '?' + search : '') + (hash ? '#' + hash : '');
	    };
	    PushStateLocationService.prototype._set = function (state, title, url, replace) {
	        var basePrefix = this._getBasePrefix();
	        var slash = url && url[0] !== '/' ? '/' : '';
	        var fullUrl = url === '' || url === '/' ? this._config.baseHref() : basePrefix + slash + url;
	        if (replace) {
	            this._history.replaceState(state, title, fullUrl);
	        }
	        else {
	            this._history.pushState(state, title, fullUrl);
	        }
	    };
	    PushStateLocationService.prototype.dispose = function (router) {
	        _super.prototype.dispose.call(this, router);
	        common_1.root.removeEventListener('popstate', this._listener);
	    };
	    return PushStateLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.PushStateLocationService = PushStateLocationService;
	//# sourceMappingURL=pushStateLocationService.js.map

/***/ },

/***/ 72:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.$q = void 0;
	var index_1 = __webpack_require__(7);
	/**
	 * An angular1-like promise api
	 *
	 * This object implements four methods similar to the
	 * [angular 1 promise api](https://docs.angularjs.org/api/ng/service/$q)
	 *
	 * UI-Router evolved from an angular 1 library to a framework agnostic library.
	 * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
	 *
	 * This API provides native ES6 promise support wrapped as a $q-like API.
	 * Internally, UI-Router uses this $q object to perform promise operations.
	 * The `angular-ui-router` (ui-router for angular 1) uses the $q API provided by angular.
	 *
	 * $q-like promise api
	 */
	exports.$q = {
	    /** Normalizes a value as a promise */
	    when: function (val) { return new Promise(function (resolve, reject) { return resolve(val); }); },
	    /** Normalizes a value as a promise rejection */
	    reject: function (val) {
	        return new Promise(function (resolve, reject) {
	            reject(val);
	        });
	    },
	    /** @returns a deferred object, which has `resolve` and `reject` functions */
	    defer: function () {
	        var deferred = {};
	        deferred.promise = new Promise(function (resolve, reject) {
	            deferred.resolve = resolve;
	            deferred.reject = reject;
	        });
	        return deferred;
	    },
	    /** Like Promise.all(), but also supports object key/promise notation like $q */
	    all: function (promises) {
	        if (index_1.isArray(promises)) {
	            return Promise.all(promises);
	        }
	        if (index_1.isObject(promises)) {
	            // Convert promises map to promises array.
	            // When each promise resolves, map it to a tuple { key: key, val: val }
	            var chain = Object.keys(promises).map(function (key) { return promises[key].then(function (val) { return ({ key: key, val: val }); }); });
	            // Then wait for all promises to resolve, and convert them back to an object
	            return exports.$q.all(chain).then(function (values) {
	                return values.reduce(function (acc, tuple) {
	                    acc[tuple.key] = tuple.val;
	                    return acc;
	                }, {});
	            });
	        }
	    },
	};
	//# sourceMappingURL=q.js.map

/***/ },

/***/ 73:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ViewService = void 0;
	var common_1 = __webpack_require__(4);
	var hof_1 = __webpack_require__(6);
	var predicates_1 = __webpack_require__(5);
	var trace_1 = __webpack_require__(12);
	/**
	 * The View service
	 *
	 * This service pairs existing `ui-view` components (which live in the DOM)
	 * with view configs (from the state declaration objects: [[StateDeclaration.views]]).
	 *
	 * - After a successful Transition, the views from the newly entered states are activated via [[activateViewConfig]].
	 *   The views from exited states are deactivated via [[deactivateViewConfig]].
	 *   (See: the [[registerActivateViews]] Transition Hook)
	 *
	 * - As `ui-view` components pop in and out of existence, they register themselves using [[registerUIView]].
	 *
	 * - When the [[sync]] function is called, the registered `ui-view`(s) ([[ActiveUIView]])
	 * are configured with the matching [[ViewConfig]](s)
	 *
	 */
	var ViewService = /** @class */ (function () {
	    /** @internal */
	    function ViewService(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** @internal */ this._uiViews = [];
	        /** @internal */ this._viewConfigs = [];
	        /** @internal */ this._viewConfigFactories = {};
	        /** @internal */ this._listeners = [];
	        /** @internal */
	        this._pluginapi = {
	            _rootViewContext: this._rootViewContext.bind(this),
	            _viewConfigFactory: this._viewConfigFactory.bind(this),
	            _registeredUIView: function (id) { return common_1.find(_this._uiViews, function (view) { return _this.router.$id + "." + view.id === id; }); },
	            _registeredUIViews: function () { return _this._uiViews; },
	            _activeViewConfigs: function () { return _this._viewConfigs; },
	            _onSync: function (listener) {
	                _this._listeners.push(listener);
	                return function () { return common_1.removeFrom(_this._listeners, listener); };
	            },
	        };
	    }
	    /**
	     * Normalizes a view's name from a state.views configuration block.
	     *
	     * This should be used by a framework implementation to calculate the values for
	     * [[_ViewDeclaration.$uiViewName]] and [[_ViewDeclaration.$uiViewContextAnchor]].
	     *
	     * @param context the context object (state declaration) that the view belongs to
	     * @param rawViewName the name of the view, as declared in the [[StateDeclaration.views]]
	     *
	     * @returns the normalized uiViewName and uiViewContextAnchor that the view targets
	     */
	    ViewService.normalizeUIViewTarget = function (context, rawViewName) {
	        if (rawViewName === void 0) { rawViewName = ''; }
	        // TODO: Validate incoming view name with a regexp to allow:
	        // ex: "view.name@foo.bar" , "^.^.view.name" , "view.name@^.^" , "" ,
	        // "@" , "$default@^" , "!$default.$default" , "!foo.bar"
	        var viewAtContext = rawViewName.split('@');
	        var uiViewName = viewAtContext[0] || '$default'; // default to unnamed view
	        var uiViewContextAnchor = predicates_1.isString(viewAtContext[1]) ? viewAtContext[1] : '^'; // default to parent context
	        // Handle relative view-name sugar syntax.
	        // Matches rawViewName "^.^.^.foo.bar" into array: ["^.^.^.foo.bar", "^.^.^", "foo.bar"],
	        var relativeViewNameSugar = /^(\^(?:\.\^)*)\.(.*$)/.exec(uiViewName);
	        if (relativeViewNameSugar) {
	            // Clobbers existing contextAnchor (rawViewName validation will fix this)
	            uiViewContextAnchor = relativeViewNameSugar[1]; // set anchor to "^.^.^"
	            uiViewName = relativeViewNameSugar[2]; // set view-name to "foo.bar"
	        }
	        if (uiViewName.charAt(0) === '!') {
	            uiViewName = uiViewName.substr(1);
	            uiViewContextAnchor = ''; // target absolutely from root
	        }
	        // handle parent relative targeting "^.^.^"
	        var relativeMatch = /^(\^(?:\.\^)*)$/;
	        if (relativeMatch.exec(uiViewContextAnchor)) {
	            var anchorState = uiViewContextAnchor.split('.').reduce(function (anchor, x) { return anchor.parent; }, context);
	            uiViewContextAnchor = anchorState.name;
	        }
	        else if (uiViewContextAnchor === '.') {
	            uiViewContextAnchor = context.name;
	        }
	        return { uiViewName: uiViewName, uiViewContextAnchor: uiViewContextAnchor };
	    };
	    /** @internal */
	    ViewService.prototype._rootViewContext = function (context) {
	        return (this._rootContext = context || this._rootContext);
	    };
	    /** @internal */
	    ViewService.prototype._viewConfigFactory = function (viewType, factory) {
	        this._viewConfigFactories[viewType] = factory;
	    };
	    ViewService.prototype.createViewConfig = function (path, decl) {
	        var cfgFactory = this._viewConfigFactories[decl.$type];
	        if (!cfgFactory)
	            throw new Error('ViewService: No view config factory registered for type ' + decl.$type);
	        var cfgs = cfgFactory(path, decl);
	        return predicates_1.isArray(cfgs) ? cfgs : [cfgs];
	    };
	    /**
	     * Deactivates a ViewConfig.
	     *
	     * This function deactivates a `ViewConfig`.
	     * After calling [[sync]], it will un-pair from any `ui-view` with which it is currently paired.
	     *
	     * @param viewConfig The ViewConfig view to deregister.
	     */
	    ViewService.prototype.deactivateViewConfig = function (viewConfig) {
	        trace_1.trace.traceViewServiceEvent('<- Removing', viewConfig);
	        common_1.removeFrom(this._viewConfigs, viewConfig);
	    };
	    ViewService.prototype.activateViewConfig = function (viewConfig) {
	        trace_1.trace.traceViewServiceEvent('-> Registering', viewConfig);
	        this._viewConfigs.push(viewConfig);
	    };
	    ViewService.prototype.sync = function () {
	        var _this = this;
	        var uiViewsByFqn = this._uiViews.map(function (uiv) { return [uiv.fqn, uiv]; }).reduce(common_1.applyPairs, {});
	        // Return a weighted depth value for a uiView.
	        // The depth is the nesting depth of ui-views (based on FQN; times 10,000)
	        // plus the depth of the state that is populating the uiView
	        function uiViewDepth(uiView) {
	            var stateDepth = function (context) { return (context && context.parent ? stateDepth(context.parent) + 1 : 1); };
	            return uiView.fqn.split('.').length * 10000 + stateDepth(uiView.creationContext);
	        }
	        // Return the ViewConfig's context's depth in the context tree.
	        function viewConfigDepth(config) {
	            var context = config.viewDecl.$context, count = 0;
	            while (++count && context.parent)
	                context = context.parent;
	            return count;
	        }
	        // Given a depth function, returns a compare function which can return either ascending or descending order
	        var depthCompare = hof_1.curry(function (depthFn, posNeg, left, right) { return posNeg * (depthFn(left) - depthFn(right)); });
	        var matchingConfigPair = function (uiView) {
	            var matchingConfigs = _this._viewConfigs.filter(ViewService.matches(uiViewsByFqn, uiView));
	            if (matchingConfigs.length > 1) {
	                // This is OK.  Child states can target a ui-view that the parent state also targets (the child wins)
	                // Sort by depth and return the match from the deepest child
	                // console.log(`Multiple matching view configs for ${uiView.fqn}`, matchingConfigs);
	                matchingConfigs.sort(depthCompare(viewConfigDepth, -1)); // descending
	            }
	            return { uiView: uiView, viewConfig: matchingConfigs[0] };
	        };
	        var configureUIView = function (tuple) {
	            // If a parent ui-view is reconfigured, it could destroy child ui-views.
	            // Before configuring a child ui-view, make sure it's still in the active uiViews array.
	            if (_this._uiViews.indexOf(tuple.uiView) !== -1)
	                tuple.uiView.configUpdated(tuple.viewConfig);
	        };
	        // Sort views by FQN and state depth. Process uiviews nearest the root first.
	        var uiViewTuples = this._uiViews.sort(depthCompare(uiViewDepth, 1)).map(matchingConfigPair);
	        var matchedViewConfigs = uiViewTuples.map(function (tuple) { return tuple.viewConfig; });
	        var unmatchedConfigTuples = this._viewConfigs
	            .filter(function (config) { return !common_1.inArray(matchedViewConfigs, config); })
	            .map(function (viewConfig) { return ({ uiView: undefined, viewConfig: viewConfig }); });
	        uiViewTuples.forEach(configureUIView);
	        var allTuples = uiViewTuples.concat(unmatchedConfigTuples);
	        this._listeners.forEach(function (cb) { return cb(allTuples); });
	        trace_1.trace.traceViewSync(allTuples);
	    };
	    /**
	     * Registers a `ui-view` component
	     *
	     * When a `ui-view` component is created, it uses this method to register itself.
	     * After registration the [[sync]] method is used to ensure all `ui-view` are configured with the proper [[ViewConfig]].
	     *
	     * Note: the `ui-view` component uses the `ViewConfig` to determine what view should be loaded inside the `ui-view`,
	     * and what the view's state context is.
	     *
	     * Note: There is no corresponding `deregisterUIView`.
	     *       A `ui-view` should hang on to the return value of `registerUIView` and invoke it to deregister itself.
	     *
	     * @param uiView The metadata for a UIView
	     * @return a de-registration function used when the view is destroyed.
	     */
	    ViewService.prototype.registerUIView = function (uiView) {
	        trace_1.trace.traceViewServiceUIViewEvent('-> Registering', uiView);
	        var uiViews = this._uiViews;
	        var fqnAndTypeMatches = function (uiv) { return uiv.fqn === uiView.fqn && uiv.$type === uiView.$type; };
	        if (uiViews.filter(fqnAndTypeMatches).length)
	            trace_1.trace.traceViewServiceUIViewEvent('!!!! duplicate uiView named:', uiView);
	        uiViews.push(uiView);
	        this.sync();
	        return function () {
	            var idx = uiViews.indexOf(uiView);
	            if (idx === -1) {
	                trace_1.trace.traceViewServiceUIViewEvent('Tried removing non-registered uiView', uiView);
	                return;
	            }
	            trace_1.trace.traceViewServiceUIViewEvent('<- Deregistering', uiView);
	            common_1.removeFrom(uiViews)(uiView);
	        };
	    };
	    /**
	     * Returns the list of views currently available on the page, by fully-qualified name.
	     *
	     * @return {Array} Returns an array of fully-qualified view names.
	     */
	    ViewService.prototype.available = function () {
	        return this._uiViews.map(hof_1.prop('fqn'));
	    };
	    /**
	     * Returns the list of views on the page containing loaded content.
	     *
	     * @return {Array} Returns an array of fully-qualified view names.
	     */
	    ViewService.prototype.active = function () {
	        return this._uiViews.filter(hof_1.prop('$config')).map(hof_1.prop('name'));
	    };
	    /**
	     * Given a ui-view and a ViewConfig, determines if they "match".
	     *
	     * A ui-view has a fully qualified name (fqn) and a context object.  The fqn is built from its overall location in
	     * the DOM, describing its nesting relationship to any parent ui-view tags it is nested inside of.
	     *
	     * A ViewConfig has a target ui-view name and a context anchor.  The ui-view name can be a simple name, or
	     * can be a segmented ui-view path, describing a portion of a ui-view fqn.
	     *
	     * In order for a ui-view to match ViewConfig, ui-view's $type must match the ViewConfig's $type
	     *
	     * If the ViewConfig's target ui-view name is a simple name (no dots), then a ui-view matches if:
	     * - the ui-view's name matches the ViewConfig's target name
	     * - the ui-view's context matches the ViewConfig's anchor
	     *
	     * If the ViewConfig's target ui-view name is a segmented name (with dots), then a ui-view matches if:
	     * - There exists a parent ui-view where:
	     *    - the parent ui-view's name matches the first segment (index 0) of the ViewConfig's target name
	     *    - the parent ui-view's context matches the ViewConfig's anchor
	     * - And the remaining segments (index 1..n) of the ViewConfig's target name match the tail of the ui-view's fqn
	     *
	     * Example:
	     *
	     * DOM:
	     * <ui-view>                        <!-- created in the root context (name: "") -->
	     *   <ui-view name="foo">                <!-- created in the context named: "A"      -->
	     *     <ui-view>                    <!-- created in the context named: "A.B"    -->
	     *       <ui-view name="bar">            <!-- created in the context named: "A.B.C"  -->
	     *       </ui-view>
	     *     </ui-view>
	     *   </ui-view>
	     * </ui-view>
	     *
	     * uiViews: [
	     *  { fqn: "$default",                  creationContext: { name: "" } },
	     *  { fqn: "$default.foo",              creationContext: { name: "A" } },
	     *  { fqn: "$default.foo.$default",     creationContext: { name: "A.B" } }
	     *  { fqn: "$default.foo.$default.bar", creationContext: { name: "A.B.C" } }
	     * ]
	     *
	     * These four view configs all match the ui-view with the fqn: "$default.foo.$default.bar":
	     *
	     * - ViewConfig1: { uiViewName: "bar",                       uiViewContextAnchor: "A.B.C" }
	     * - ViewConfig2: { uiViewName: "$default.bar",              uiViewContextAnchor: "A.B" }
	     * - ViewConfig3: { uiViewName: "foo.$default.bar",          uiViewContextAnchor: "A" }
	     * - ViewConfig4: { uiViewName: "$default.foo.$default.bar", uiViewContextAnchor: "" }
	     *
	     * Using ViewConfig3 as an example, it matches the ui-view with fqn "$default.foo.$default.bar" because:
	     * - The ViewConfig's segmented target name is: [ "foo", "$default", "bar" ]
	     * - There exists a parent ui-view (which has fqn: "$default.foo") where:
	     *    - the parent ui-view's name "foo" matches the first segment "foo" of the ViewConfig's target name
	     *    - the parent ui-view's context "A" matches the ViewConfig's anchor context "A"
	     * - And the remaining segments [ "$default", "bar" ].join("."_ of the ViewConfig's target name match
	     *   the tail of the ui-view's fqn "default.bar"
	     *
	     * @internal
	     */
	    ViewService.matches = function (uiViewsByFqn, uiView) { return function (viewConfig) {
	        // Don't supply an ng1 ui-view with an ng2 ViewConfig, etc
	        if (uiView.$type !== viewConfig.viewDecl.$type)
	            return false;
	        // Split names apart from both viewConfig and uiView into segments
	        var vc = viewConfig.viewDecl;
	        var vcSegments = vc.$uiViewName.split('.');
	        var uivSegments = uiView.fqn.split('.');
	        // Check if the tails of the segment arrays match. ex, these arrays' tails match:
	        // vc: ["foo", "bar"], uiv fqn: ["$default", "foo", "bar"]
	        if (!common_1.equals(vcSegments, uivSegments.slice(0 - vcSegments.length)))
	            return false;
	        // Now check if the fqn ending at the first segment of the viewConfig matches the context:
	        // ["$default", "foo"].join(".") == "$default.foo", does the ui-view $default.foo context match?
	        var negOffset = 1 - vcSegments.length || undefined;
	        var fqnToFirstSegment = uivSegments.slice(0, negOffset).join('.');
	        var uiViewContext = uiViewsByFqn[fqnToFirstSegment].creationContext;
	        return vc.$uiViewContextAnchor === (uiViewContext && uiViewContext.name);
	    }; };
	    return ViewService;
	}());
	exports.ViewService = ViewService;
	//# sourceMappingURL=view.js.map

/***/ },

/***/ 74:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(122);
	module.exports = 'ngAnimate';


/***/ },

/***/ 75:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(123);
	module.exports = 'ngAria';


/***/ },

/***/ 97:
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },

/***/ 98:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.treeChangesCleanup = exports.registerAddCoreResolvables = void 0;
	var transition_1 = __webpack_require__(36);
	var router_1 = __webpack_require__(53);
	var resolve_1 = __webpack_require__(51);
	var common_1 = __webpack_require__(7);
	function addCoreResolvables(trans) {
	    trans.addResolvable(resolve_1.Resolvable.fromData(router_1.UIRouter, trans.router), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData(transition_1.Transition, trans), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData('$transition$', trans), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData('$stateParams', trans.params()), '');
	    trans.entering().forEach(function (state) {
	        trans.addResolvable(resolve_1.Resolvable.fromData('$state$', state), state);
	    });
	}
	exports.registerAddCoreResolvables = function (transitionService) {
	    return transitionService.onCreate({}, addCoreResolvables);
	};
	var TRANSITION_TOKENS = ['$transition$', transition_1.Transition];
	var isTransition = common_1.inArray(TRANSITION_TOKENS);
	// References to Transition in the treeChanges pathnodes makes all
	// previous Transitions reachable in memory, causing a memory leak
	// This function removes resolves for '$transition$' and `Transition` from the treeChanges.
	// Do not use this on current transitions, only on old ones.
	exports.treeChangesCleanup = function (trans) {
	    var nodes = common_1.values(trans.treeChanges()).reduce(common_1.unnestR, []).reduce(common_1.uniqR, []);
	    // If the resolvable is a Transition, return a new resolvable with null data
	    var replaceTransitionWithNull = function (r) {
	        return isTransition(r.token) ? resolve_1.Resolvable.fromData(r.token, null) : r;
	    };
	    nodes.forEach(function (node) {
	        node.resolvables = node.resolvables.map(replaceTransitionWithNull);
	    });
	};
	//# sourceMappingURL=coreResolvables.js.map

/***/ },

/***/ 99:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerIgnoredTransitionHook = void 0;
	var trace_1 = __webpack_require__(12);
	var rejectFactory_1 = __webpack_require__(14);
	/**
	 * A [[TransitionHookFn]] that skips a transition if it should be ignored
	 *
	 * This hook is invoked at the end of the onBefore phase.
	 *
	 * If the transition should be ignored (because no parameter or states changed)
	 * then the transition is ignored and not processed.
	 */
	function ignoredHook(trans) {
	    var ignoredReason = trans._ignoredReason();
	    if (!ignoredReason)
	        return;
	    trace_1.trace.traceTransitionIgnored(trans);
	    var pending = trans.router.globals.transition;
	    // The user clicked a link going back to the *current state* ('A')
	    // However, there is also a pending transition in flight (to 'B')
	    // Abort the transition to 'B' because the user now wants to be back at 'A'.
	    if (ignoredReason === 'SameAsCurrent' && pending) {
	        pending.abort();
	    }
	    return rejectFactory_1.Rejection.ignored().toPromise();
	}
	exports.registerIgnoredTransitionHook = function (transitionService) {
	    return transitionService.onBefore({}, ignoredHook, { priority: -9999 });
	};
	//# sourceMappingURL=ignoredTransition.js.map

/***/ },

/***/ 100:
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerInvalidTransitionHook = void 0;
	/**
	 * A [[TransitionHookFn]] that rejects the Transition if it is invalid
	 *
	 * This hook is invoked at the end of the onBefore phase.
	 * If the transition is invalid (for example, param values do not validate)
	 * then the transition is rejected.
	 */
	function invalidTransitionHook(trans) {
	    if (!trans.valid()) {
	        throw new Error(trans.error().toString());
	    }
	}
	exports.registerInvalidTransitionHook = function (transitionService) {
	    return transitionService.onBefore({}, invalidTransitionHook, { priority: -10000 });
	};
	//# sourceMappingURL=invalidTransition.js.map

/***/ },

/***/ 101:
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerOnEnterHook = exports.registerOnRetainHook = exports.registerOnExitHook = void 0;
	/**
	 * A factory which creates an onEnter, onExit or onRetain transition hook function
	 *
	 * The returned function invokes the (for instance) state.onEnter hook when the
	 * state is being entered.
	 */
	function makeEnterExitRetainHook(hookName) {
	    return function (transition, state) {
	        var _state = state.$$state();
	        var hookFn = _state[hookName];
	        return hookFn(transition, state);
	    };
	}
	/**
	 * The [[TransitionStateHookFn]] for onExit
	 *
	 * When the state is being exited, the state's .onExit function is invoked.
	 *
	 * Registered using `transitionService.onExit({ exiting: (state) => !!state.onExit }, onExitHook);`
	 *
	 * See: [[IHookRegistry.onExit]]
	 */
	var onExitHook = makeEnterExitRetainHook('onExit');
	exports.registerOnExitHook = function (transitionService) {
	    return transitionService.onExit({ exiting: function (state) { return !!state.onExit; } }, onExitHook);
	};
	/**
	 * The [[TransitionStateHookFn]] for onRetain
	 *
	 * When the state was already entered, and is not being exited or re-entered, the state's .onRetain function is invoked.
	 *
	 * Registered using `transitionService.onRetain({ retained: (state) => !!state.onRetain }, onRetainHook);`
	 *
	 * See: [[IHookRegistry.onRetain]]
	 */
	var onRetainHook = makeEnterExitRetainHook('onRetain');
	exports.registerOnRetainHook = function (transitionService) {
	    return transitionService.onRetain({ retained: function (state) { return !!state.onRetain; } }, onRetainHook);
	};
	/**
	 * The [[TransitionStateHookFn]] for onEnter
	 *
	 * When the state is being entered, the state's .onEnter function is invoked.
	 *
	 * Registered using `transitionService.onEnter({ entering: (state) => !!state.onEnter }, onEnterHook);`
	 *
	 * See: [[IHookRegistry.onEnter]]
	 */
	var onEnterHook = makeEnterExitRetainHook('onEnter');
	exports.registerOnEnterHook = function (transitionService) {
	    return transitionService.onEnter({ entering: function (state) { return !!state.onEnter; } }, onEnterHook);
	};
	//# sourceMappingURL=onEnterExitRetain.js.map

/***/ },

/***/ 102:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerRedirectToHook = void 0;
	var predicates_1 = __webpack_require__(5);
	var coreservices_1 = __webpack_require__(8);
	var targetState_1 = __webpack_require__(16);
	/**
	 * A [[TransitionHookFn]] that redirects to a different state or params
	 *
	 * Registered using `transitionService.onStart({ to: (state) => !!state.redirectTo }, redirectHook);`
	 *
	 * See [[StateDeclaration.redirectTo]]
	 */
	var redirectToHook = function (trans) {
	    var redirect = trans.to().redirectTo;
	    if (!redirect)
	        return;
	    var $state = trans.router.stateService;
	    function handleResult(result) {
	        if (!result)
	            return;
	        if (result instanceof targetState_1.TargetState)
	            return result;
	        if (predicates_1.isString(result))
	            return $state.target(result, trans.params(), trans.options());
	        if (result['state'] || result['params'])
	            return $state.target(result['state'] || trans.to(), result['params'] || trans.params(), trans.options());
	    }
	    if (predicates_1.isFunction(redirect)) {
	        return coreservices_1.services.$q.when(redirect(trans)).then(handleResult);
	    }
	    return handleResult(redirect);
	};
	exports.registerRedirectToHook = function (transitionService) {
	    return transitionService.onStart({ to: function (state) { return !!state.redirectTo; } }, redirectToHook);
	};
	//# sourceMappingURL=redirectTo.js.map

/***/ },

/***/ 103:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerResolveRemaining = exports.registerLazyResolveState = exports.registerEagerResolvePath = exports.RESOLVE_HOOK_PRIORITY = void 0;
	var common_1 = __webpack_require__(4);
	var resolveContext_1 = __webpack_require__(22);
	var hof_1 = __webpack_require__(6);
	exports.RESOLVE_HOOK_PRIORITY = 1000;
	/**
	 * A [[TransitionHookFn]] which resolves all EAGER Resolvables in the To Path
	 *
	 * Registered using `transitionService.onStart({}, eagerResolvePath, { priority: 1000 });`
	 *
	 * When a Transition starts, this hook resolves all the EAGER Resolvables, which the transition then waits for.
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var eagerResolvePath = function (trans) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).resolvePath('EAGER', trans).then(common_1.noop);
	};
	exports.registerEagerResolvePath = function (transitionService) {
	    return transitionService.onStart({}, eagerResolvePath, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	/**
	 * A [[TransitionHookFn]] which resolves all LAZY Resolvables for the state (and all its ancestors) in the To Path
	 *
	 * Registered using `transitionService.onEnter({ entering: () => true }, lazyResolveState, { priority: 1000 });`
	 *
	 * When a State is being entered, this hook resolves all the Resolvables for this state, which the transition then waits for.
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var lazyResolveState = function (trans, state) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).subContext(state.$$state()).resolvePath('LAZY', trans).then(common_1.noop);
	};
	exports.registerLazyResolveState = function (transitionService) {
	    return transitionService.onEnter({ entering: hof_1.val(true) }, lazyResolveState, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	/**
	 * A [[TransitionHookFn]] which resolves any dynamically added (LAZY or EAGER) Resolvables.
	 *
	 * Registered using `transitionService.onFinish({}, eagerResolvePath, { priority: 1000 });`
	 *
	 * After all entering states have been entered, this hook resolves any remaining Resolvables.
	 * These are typically dynamic resolves which were added by some Transition Hook using [[Transition.addResolvable]].
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var resolveRemaining = function (trans) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).resolvePath('LAZY', trans).then(common_1.noop);
	};
	exports.registerResolveRemaining = function (transitionService) {
	    return transitionService.onFinish({}, resolveRemaining, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	//# sourceMappingURL=resolve.js.map

/***/ },

/***/ 104:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerUpdateGlobalState = void 0;
	var common_1 = __webpack_require__(4);
	/**
	 * A [[TransitionHookFn]] which updates global UI-Router state
	 *
	 * Registered using `transitionService.onBefore({}, updateGlobalState);`
	 *
	 * Before a [[Transition]] starts, updates the global value of "the current transition" ([[Globals.transition]]).
	 * After a successful [[Transition]], updates the global values of "the current state"
	 * ([[Globals.current]] and [[Globals.$current]]) and "the current param values" ([[Globals.params]]).
	 *
	 * See also the deprecated properties:
	 * [[StateService.transition]], [[StateService.current]], [[StateService.params]]
	 */
	var updateGlobalState = function (trans) {
	    var globals = trans.router.globals;
	    var transitionSuccessful = function () {
	        globals.successfulTransitions.enqueue(trans);
	        globals.$current = trans.$to();
	        globals.current = globals.$current.self;
	        common_1.copy(trans.params(), globals.params);
	    };
	    var clearCurrentTransition = function () {
	        // Do not clear globals.transition if a different transition has started in the meantime
	        if (globals.transition === trans)
	            globals.transition = null;
	    };
	    trans.onSuccess({}, transitionSuccessful, { priority: 10000 });
	    trans.promise.then(clearCurrentTransition, clearCurrentTransition);
	};
	exports.registerUpdateGlobalState = function (transitionService) {
	    return transitionService.onCreate({}, updateGlobalState);
	};
	//# sourceMappingURL=updateGlobals.js.map

/***/ },

/***/ 105:
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerUpdateUrl = void 0;
	/**
	 * A [[TransitionHookFn]] which updates the URL after a successful transition
	 *
	 * Registered using `transitionService.onSuccess({}, updateUrl);`
	 */
	var updateUrl = function (transition) {
	    var options = transition.options();
	    var $state = transition.router.stateService;
	    var $urlRouter = transition.router.urlRouter;
	    // Dont update the url in these situations:
	    // The transition was triggered by a URL sync (options.source === 'url')
	    // The user doesn't want the url to update (options.location === false)
	    // The destination state, and all parents have no navigable url
	    if (options.source !== 'url' && options.location && $state.$current.navigable) {
	        var urlOptions = { replace: options.location === 'replace' };
	        $urlRouter.push($state.$current.navigable.url, $state.params, urlOptions);
	    }
	    $urlRouter.update(true);
	};
	exports.registerUpdateUrl = function (transitionService) {
	    return transitionService.onSuccess({}, updateUrl, { priority: 9999 });
	};
	//# sourceMappingURL=url.js.map

/***/ },

/***/ 106:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerActivateViews = exports.registerLoadEnteringViews = void 0;
	var common_1 = __webpack_require__(4);
	var coreservices_1 = __webpack_require__(8);
	/**
	 * A [[TransitionHookFn]] which waits for the views to load
	 *
	 * Registered using `transitionService.onStart({}, loadEnteringViews);`
	 *
	 * Allows the views to do async work in [[ViewConfig.load]] before the transition continues.
	 * In angular 1, this includes loading the templates.
	 */
	var loadEnteringViews = function (transition) {
	    var $q = coreservices_1.services.$q;
	    var enteringViews = transition.views('entering');
	    if (!enteringViews.length)
	        return;
	    return $q.all(enteringViews.map(function (view) { return $q.when(view.load()); })).then(common_1.noop);
	};
	exports.registerLoadEnteringViews = function (transitionService) {
	    return transitionService.onFinish({}, loadEnteringViews);
	};
	/**
	 * A [[TransitionHookFn]] which activates the new views when a transition is successful.
	 *
	 * Registered using `transitionService.onSuccess({}, activateViews);`
	 *
	 * After a transition is complete, this hook deactivates the old views from the previous state,
	 * and activates the new views from the destination state.
	 *
	 * See [[ViewService]]
	 */
	var activateViews = function (transition) {
	    var enteringViews = transition.views('entering');
	    var exitingViews = transition.views('exiting');
	    if (!enteringViews.length && !exitingViews.length)
	        return;
	    var $view = transition.router.viewService;
	    exitingViews.forEach(function (vc) { return $view.deactivateViewConfig(vc); });
	    enteringViews.forEach(function (vc) { return $view.activateViewConfig(vc); });
	    $view.sync();
	};
	exports.registerActivateViews = function (transitionService) {
	    return transitionService.onSuccess({}, activateViews);
	};
	//# sourceMappingURL=views.js.map

/***/ },

/***/ 107:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(7), exports);
	__exportStar(__webpack_require__(30), exports);
	__exportStar(__webpack_require__(111), exports);
	__exportStar(__webpack_require__(51), exports);
	__exportStar(__webpack_require__(33), exports);
	__exportStar(__webpack_require__(113), exports);
	__exportStar(__webpack_require__(114), exports);
	__exportStar(__webpack_require__(120), exports);
	__exportStar(__webpack_require__(48), exports);
	__exportStar(__webpack_require__(53), exports);
	__exportStar(__webpack_require__(116), exports);
	__exportStar(__webpack_require__(108), exports);
	//# sourceMappingURL=index.js.map

/***/ },

/***/ 108:
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UIRouterPluginBase = void 0;
	var UIRouterPluginBase = /** @class */ (function () {
	    function UIRouterPluginBase() {
	    }
	    UIRouterPluginBase.prototype.dispose = function (router) { };
	    return UIRouterPluginBase;
	}());
	exports.UIRouterPluginBase = UIRouterPluginBase;
	//# sourceMappingURL=interface.js.map

/***/ },

/***/ 109:
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//# sourceMappingURL=interface.js.map

/***/ },

/***/ 110:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParamTypes = void 0;
	var common_1 = __webpack_require__(4);
	var predicates_1 = __webpack_require__(5);
	var hof_1 = __webpack_require__(6);
	var coreservices_1 = __webpack_require__(8);
	var paramType_1 = __webpack_require__(31);
	/**
	 * A registry for parameter types.
	 *
	 * This registry manages the built-in (and custom) parameter types.
	 *
	 * The built-in parameter types are:
	 *
	 * - [[string]]
	 * - [[path]]
	 * - [[query]]
	 * - [[hash]]
	 * - [[int]]
	 * - [[bool]]
	 * - [[date]]
	 * - [[json]]
	 * - [[any]]
	 *
	 * To register custom parameter types, use [[UrlConfig.type]], i.e.,
	 *
	 * ```js
	 * router.urlService.config.type(customType)
	 * ```
	 */
	var ParamTypes = /** @class */ (function () {
	    function ParamTypes() {
	        this.enqueue = true;
	        this.typeQueue = [];
	        this.defaultTypes = common_1.pick(ParamTypes.prototype, [
	            'hash',
	            'string',
	            'query',
	            'path',
	            'int',
	            'bool',
	            'date',
	            'json',
	            'any',
	        ]);
	        // Register default types. Store them in the prototype of this.types.
	        var makeType = function (definition, name) { return new paramType_1.ParamType(common_1.extend({ name: name }, definition)); };
	        this.types = common_1.inherit(common_1.map(this.defaultTypes, makeType), {});
	    }
	    ParamTypes.prototype.dispose = function () {
	        this.types = {};
	    };
	    /**
	     * Registers a parameter type
	     *
	     * End users should call [[UrlMatcherFactory.type]], which delegates to this method.
	     */
	    ParamTypes.prototype.type = function (name, definition, definitionFn) {
	        if (!predicates_1.isDefined(definition))
	            return this.types[name];
	        if (this.types.hasOwnProperty(name))
	            throw new Error("A type named '" + name + "' has already been defined.");
	        this.types[name] = new paramType_1.ParamType(common_1.extend({ name: name }, definition));
	        if (definitionFn) {
	            this.typeQueue.push({ name: name, def: definitionFn });
	            if (!this.enqueue)
	                this._flushTypeQueue();
	        }
	        return this;
	    };
	    ParamTypes.prototype._flushTypeQueue = function () {
	        while (this.typeQueue.length) {
	            var type = this.typeQueue.shift();
	            if (type.pattern)
	                throw new Error("You cannot override a type's .pattern at runtime.");
	            common_1.extend(this.types[type.name], coreservices_1.services.$injector.invoke(type.def));
	        }
	    };
	    return ParamTypes;
	}());
	exports.ParamTypes = ParamTypes;
	function initDefaultTypes() {
	    var makeDefaultType = function (def) {
	        var valToString = function (val) { return (val != null ? val.toString() : val); };
	        var defaultTypeBase = {
	            encode: valToString,
	            decode: valToString,
	            is: hof_1.is(String),
	            pattern: /.*/,
	            // tslint:disable-next-line:triple-equals
	            equals: function (a, b) { return a == b; },
	        };
	        return common_1.extend({}, defaultTypeBase, def);
	    };
	    // Default Parameter Type Definitions
	    common_1.extend(ParamTypes.prototype, {
	        string: makeDefaultType({}),
	        path: makeDefaultType({
	            pattern: /[^/]*/,
	        }),
	        query: makeDefaultType({}),
	        hash: makeDefaultType({
	            inherit: false,
	        }),
	        int: makeDefaultType({
	            decode: function (val) { return parseInt(val, 10); },
	            is: function (val) {
	                return !predicates_1.isNullOrUndefined(val) && this.decode(val.toString()) === val;
	            },
	            pattern: /-?\d+/,
	        }),
	        bool: makeDefaultType({
	            encode: function (val) { return (val && 1) || 0; },
	            decode: function (val) { return parseInt(val, 10) !== 0; },
	            is: hof_1.is(Boolean),
	            pattern: /0|1/,
	        }),
	        date: makeDefaultType({
	            encode: function (val) {
	                return !this.is(val)
	                    ? undefined
	                    : [val.getFullYear(), ('0' + (val.getMonth() + 1)).slice(-2), ('0' + val.getDate()).slice(-2)].join('-');
	            },
	            decode: function (val) {
	                if (this.is(val))
	                    return val;
	                var match = this.capture.exec(val);
	                return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	            },
	            is: function (val) { return val instanceof Date && !isNaN(val.valueOf()); },
	            equals: function (l, r) {
	                return ['getFullYear', 'getMonth', 'getDate'].reduce(function (acc, fn) { return acc && l[fn]() === r[fn](); }, true);
	            },
	            pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	            capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/,
	        }),
	        json: makeDefaultType({
	            encode: common_1.toJson,
	            decode: common_1.fromJson,
	            is: hof_1.is(Object),
	            equals: common_1.equals,
	            pattern: /[^/]*/,
	        }),
	        // does not encode/decode
	        any: makeDefaultType({
	            encode: common_1.identity,
	            decode: common_1.identity,
	            is: function () { return true; },
	            equals: common_1.equals,
	        }),
	    });
	}
	initDefaultTypes();
	//# sourceMappingURL=paramTypes.js.map

/***/ },

/***/ 111:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(32), exports);
	__exportStar(__webpack_require__(20), exports);
	//# sourceMappingURL=index.js.map

/***/ },

/***/ 112:
109,

/***/ 113:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * # Transition subsystem
	 *
	 * This module contains APIs related to a Transition.
	 *
	 * See:
	 * - [[TransitionService]]
	 * - [[Transition]]
	 * - [[HookFn]], [[TransitionHookFn]], [[TransitionStateHookFn]], [[HookMatchCriteria]], [[HookResult]]
	 *
	 * @packageDocumentation @preferred
	 */
	__exportStar(__webpack_require__(13), exports);
	__exportStar(__webpack_require__(59), exports);
	__exportStar(__webpack_require__(35), exports);
	__exportStar(__webpack_require__(14), exports);
	__exportStar(__webpack_require__(36), exports);
	__exportStar(__webpack_require__(17), exports);
	__exportStar(__webpack_require__(60), exports);
	__exportStar(__webpack_require__(37), exports);
	//# sourceMappingURL=index.js.map

/***/ },

/***/ 114:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(115), exports);
	__exportStar(__webpack_require__(23), exports);
	__exportStar(__webpack_require__(62), exports);
	__exportStar(__webpack_require__(63), exports);
	__exportStar(__webpack_require__(38), exports);
	__exportStar(__webpack_require__(65), exports);
	var urlRules_1 = __webpack_require__(64);
	Object.defineProperty(exports, "UrlRules", { enumerable: true, get: function () { return urlRules_1.UrlRules; } });
	var urlConfig_1 = __webpack_require__(61);
	Object.defineProperty(exports, "UrlConfig", { enumerable: true, get: function () { return urlConfig_1.UrlConfig; } });
	//# sourceMappingURL=index.js.map

/***/ },

/***/ 115:
109,

/***/ 116:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(117), exports);
	//# sourceMappingURL=vanilla.js.map

/***/ },

/***/ 117:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Naive, pure JS implementation of core ui-router services
	 *
	 * @packageDocumentation
	 */
	__exportStar(__webpack_require__(118), exports);
	__exportStar(__webpack_require__(72), exports);
	__exportStar(__webpack_require__(68), exports);
	__exportStar(__webpack_require__(24), exports);
	__exportStar(__webpack_require__(67), exports);
	__exportStar(__webpack_require__(70), exports);
	__exportStar(__webpack_require__(71), exports);
	__exportStar(__webpack_require__(69), exports);
	__exportStar(__webpack_require__(66), exports);
	__exportStar(__webpack_require__(39), exports);
	__exportStar(__webpack_require__(119), exports);
	//# sourceMappingURL=index.js.map

/***/ },

/***/ 118:
109,

/***/ 119:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.memoryLocationPlugin = exports.pushStateLocationPlugin = exports.hashLocationPlugin = exports.servicesPlugin = void 0;
	var browserLocationConfig_1 = __webpack_require__(66);
	var hashLocationService_1 = __webpack_require__(67);
	var utils_1 = __webpack_require__(39);
	var pushStateLocationService_1 = __webpack_require__(71);
	var memoryLocationService_1 = __webpack_require__(70);
	var memoryLocationConfig_1 = __webpack_require__(69);
	var injector_1 = __webpack_require__(68);
	var q_1 = __webpack_require__(72);
	var coreservices_1 = __webpack_require__(8);
	function servicesPlugin(router) {
	    coreservices_1.services.$injector = injector_1.$injector;
	    coreservices_1.services.$q = q_1.$q;
	    return { name: 'vanilla.services', $q: q_1.$q, $injector: injector_1.$injector, dispose: function () { return null; } };
	}
	exports.servicesPlugin = servicesPlugin;
	/** A `UIRouterPlugin` uses the browser hash to get/set the current location */
	exports.hashLocationPlugin = utils_1.locationPluginFactory('vanilla.hashBangLocation', false, hashLocationService_1.HashLocationService, browserLocationConfig_1.BrowserLocationConfig);
	/** A `UIRouterPlugin` that gets/sets the current location using the browser's `location` and `history` apis */
	exports.pushStateLocationPlugin = utils_1.locationPluginFactory('vanilla.pushStateLocation', true, pushStateLocationService_1.PushStateLocationService, browserLocationConfig_1.BrowserLocationConfig);
	/** A `UIRouterPlugin` that gets/sets the current location from an in-memory object */
	exports.memoryLocationPlugin = utils_1.locationPluginFactory('vanilla.memoryLocation', false, memoryLocationService_1.MemoryLocationService, memoryLocationConfig_1.MemoryLocationConfig);
	//# sourceMappingURL=plugins.js.map

/***/ },

/***/ 120:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(121), exports);
	__exportStar(__webpack_require__(73), exports);
	//# sourceMappingURL=index.js.map

/***/ },

/***/ 121:
109,

/***/ 122:
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.6.6
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var ELEMENT_NODE = 1;
	var COMMENT_NODE = 8;
	
	var ADD_CLASS_SUFFIX = '-add';
	var REMOVE_CLASS_SUFFIX = '-remove';
	var EVENT_CLASS_PREFIX = 'ng-';
	var ACTIVE_CLASS_SUFFIX = '-active';
	var PREPARE_CLASS_SUFFIX = '-prepare';
	
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';
	
	// Detect proper transitionend/animationend event names.
	var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;
	
	// If unprefixed events are not supported but webkit-prefixed are, use the latter.
	// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
	// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
	// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
	// Register both events in case `window.onanimationend` is not supported because of that,
	// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
	// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
	// therefore there is no reason to test anymore for other vendor prefixes:
	// http://caniuse.com/#search=transition
	if ((window.ontransitionend === undefined) && (window.onwebkittransitionend !== undefined)) {
	  CSS_PREFIX = '-webkit-';
	  TRANSITION_PROP = 'WebkitTransition';
	  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
	} else {
	  TRANSITION_PROP = 'transition';
	  TRANSITIONEND_EVENT = 'transitionend';
	}
	
	if ((window.onanimationend === undefined) && (window.onwebkitanimationend !== undefined)) {
	  CSS_PREFIX = '-webkit-';
	  ANIMATION_PROP = 'WebkitAnimation';
	  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
	} else {
	  ANIMATION_PROP = 'animation';
	  ANIMATIONEND_EVENT = 'animationend';
	}
	
	var DURATION_KEY = 'Duration';
	var PROPERTY_KEY = 'Property';
	var DELAY_KEY = 'Delay';
	var TIMING_KEY = 'TimingFunction';
	var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
	var ANIMATION_PLAYSTATE_KEY = 'PlayState';
	var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;
	
	var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
	var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
	var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
	var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;
	
	var ngMinErr = angular.$$minErr('ng');
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function packageStyles(options) {
	  var styles = {};
	  if (options && (options.to || options.from)) {
	    styles.to = options.to;
	    styles.from = options.from;
	  }
	  return styles;
	}
	
	function pendClasses(classes, fix, isPrefix) {
	  var className = '';
	  classes = isArray(classes)
	      ? classes
	      : classes && isString(classes) && classes.length
	          ? classes.split(/\s+/)
	          : [];
	  forEach(classes, function(klass, i) {
	    if (klass && klass.length > 0) {
	      className += (i > 0) ? ' ' : '';
	      className += isPrefix ? fix + klass
	                            : klass + fix;
	    }
	  });
	  return className;
	}
	
	function removeFromArray(arr, val) {
	  var index = arr.indexOf(val);
	  if (val >= 0) {
	    arr.splice(index, 1);
	  }
	}
	
	function stripCommentsFromElement(element) {
	  if (element instanceof jqLite) {
	    switch (element.length) {
	      case 0:
	        return element;
	
	      case 1:
	        // there is no point of stripping anything if the element
	        // is the only element within the jqLite wrapper.
	        // (it's important that we retain the element instance.)
	        if (element[0].nodeType === ELEMENT_NODE) {
	          return element;
	        }
	        break;
	
	      default:
	        return jqLite(extractElementNode(element));
	    }
	  }
	
	  if (element.nodeType === ELEMENT_NODE) {
	    return jqLite(element);
	  }
	}
	
	function extractElementNode(element) {
	  if (!element[0]) return element;
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function $$addClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.addClass(elm, className);
	  });
	}
	
	function $$removeClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.removeClass(elm, className);
	  });
	}
	
	function applyAnimationClassesFactory($$jqLite) {
	  return function(element, options) {
	    if (options.addClass) {
	      $$addClass($$jqLite, element, options.addClass);
	      options.addClass = null;
	    }
	    if (options.removeClass) {
	      $$removeClass($$jqLite, element, options.removeClass);
	      options.removeClass = null;
	    }
	  };
	}
	
	function prepareAnimationOptions(options) {
	  options = options || {};
	  if (!options.$$prepared) {
	    var domOperation = options.domOperation || noop;
	    options.domOperation = function() {
	      options.$$domOperationFired = true;
	      domOperation();
	      domOperation = noop;
	    };
	    options.$$prepared = true;
	  }
	  return options;
	}
	
	function applyAnimationStyles(element, options) {
	  applyAnimationFromStyles(element, options);
	  applyAnimationToStyles(element, options);
	}
	
	function applyAnimationFromStyles(element, options) {
	  if (options.from) {
	    element.css(options.from);
	    options.from = null;
	  }
	}
	
	function applyAnimationToStyles(element, options) {
	  if (options.to) {
	    element.css(options.to);
	    options.to = null;
	  }
	}
	
	function mergeAnimationDetails(element, oldAnimation, newAnimation) {
	  var target = oldAnimation.options || {};
	  var newOptions = newAnimation.options || {};
	
	  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
	  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
	  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);
	
	  if (newOptions.preparationClasses) {
	    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
	    delete newOptions.preparationClasses;
	  }
	
	  // noop is basically when there is no callback; otherwise something has been set
	  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;
	
	  extend(target, newOptions);
	
	  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
	  if (realDomOperation) {
	    target.domOperation = realDomOperation;
	  }
	
	  if (classes.addClass) {
	    target.addClass = classes.addClass;
	  } else {
	    target.addClass = null;
	  }
	
	  if (classes.removeClass) {
	    target.removeClass = classes.removeClass;
	  } else {
	    target.removeClass = null;
	  }
	
	  oldAnimation.addClass = target.addClass;
	  oldAnimation.removeClass = target.removeClass;
	
	  return target;
	}
	
	function resolveElementClasses(existing, toAdd, toRemove) {
	  var ADD_CLASS = 1;
	  var REMOVE_CLASS = -1;
	
	  var flags = {};
	  existing = splitClassesToLookup(existing);
	
	  toAdd = splitClassesToLookup(toAdd);
	  forEach(toAdd, function(value, key) {
	    flags[key] = ADD_CLASS;
	  });
	
	  toRemove = splitClassesToLookup(toRemove);
	  forEach(toRemove, function(value, key) {
	    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
	  });
	
	  var classes = {
	    addClass: '',
	    removeClass: ''
	  };
	
	  forEach(flags, function(val, klass) {
	    var prop, allow;
	    if (val === ADD_CLASS) {
	      prop = 'addClass';
	      allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
	    } else if (val === REMOVE_CLASS) {
	      prop = 'removeClass';
	      allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
	    }
	    if (allow) {
	      if (classes[prop].length) {
	        classes[prop] += ' ';
	      }
	      classes[prop] += klass;
	    }
	  });
	
	  function splitClassesToLookup(classes) {
	    if (isString(classes)) {
	      classes = classes.split(' ');
	    }
	
	    var obj = {};
	    forEach(classes, function(klass) {
	      // sometimes the split leaves empty string values
	      // incase extra spaces were applied to the options
	      if (klass.length) {
	        obj[klass] = true;
	      }
	    });
	    return obj;
	  }
	
	  return classes;
	}
	
	function getDomNode(element) {
	  return (element instanceof jqLite) ? element[0] : element;
	}
	
	function applyGeneratedPreparationClasses(element, event, options) {
	  var classes = '';
	  if (event) {
	    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
	  }
	  if (options.addClass) {
	    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
	  }
	  if (options.removeClass) {
	    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
	  }
	  if (classes.length) {
	    options.preparationClasses = classes;
	    element.addClass(classes);
	  }
	}
	
	function clearGeneratedClasses(element, options) {
	  if (options.preparationClasses) {
	    element.removeClass(options.preparationClasses);
	    options.preparationClasses = null;
	  }
	  if (options.activeClasses) {
	    element.removeClass(options.activeClasses);
	    options.activeClasses = null;
	  }
	}
	
	function blockTransitions(node, duration) {
	  // we use a negative delay value since it performs blocking
	  // yet it doesn't kill any existing transitions running on the
	  // same element which makes this safe for class-based animations
	  var value = duration ? '-' + duration + 's' : '';
	  applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
	  return [TRANSITION_DELAY_PROP, value];
	}
	
	function blockKeyframeAnimations(node, applyBlock) {
	  var value = applyBlock ? 'paused' : '';
	  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
	  applyInlineStyle(node, [key, value]);
	  return [key, value];
	}
	
	function applyInlineStyle(node, styleTuple) {
	  var prop = styleTuple[0];
	  var value = styleTuple[1];
	  node.style[prop] = value;
	}
	
	function concatWithSpace(a,b) {
	  if (!a) return b;
	  if (!b) return a;
	  return a + ' ' + b;
	}
	
	var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
	  var queue, cancelFn;
	
	  function scheduler(tasks) {
	    // we make a copy since RAFScheduler mutates the state
	    // of the passed in array variable and this would be difficult
	    // to track down on the outside code
	    queue = queue.concat(tasks);
	    nextTick();
	  }
	
	  queue = scheduler.queue = [];
	
	  /* waitUntilQuiet does two things:
	   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
	   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
	   *
	   * The motivation here is that animation code can request more time from the scheduler
	   * before the next wave runs. This allows for certain DOM properties such as classes to
	   * be resolved in time for the next animation to run.
	   */
	  scheduler.waitUntilQuiet = function(fn) {
	    if (cancelFn) cancelFn();
	
	    cancelFn = $$rAF(function() {
	      cancelFn = null;
	      fn();
	      nextTick();
	    });
	  };
	
	  return scheduler;
	
	  function nextTick() {
	    if (!queue.length) return;
	
	    var items = queue.shift();
	    for (var i = 0; i < items.length; i++) {
	      items[i]();
	    }
	
	    if (!cancelFn) {
	      $$rAF(function() {
	        if (!cancelFn) nextTick();
	      });
	    }
	  }
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateChildren
	 * @restrict AE
	 * @element ANY
	 *
	 * @description
	 *
	 * ngAnimateChildren allows you to specify that children of this element should animate even if any
	 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
	 * (structural) animation, child elements that also have an active structural animation are not animated.
	 *
	 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
	 *
	 *
	 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
	 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
	 *
	 * @example
	 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	       <div ng-controller="MainController as main">
	         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
	         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
	         <hr>
	         <div ng-animate-children="{{main.animateChildren}}">
	           <div ng-if="main.enterElement" class="container">
	             List of items:
	             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
	           </div>
	         </div>
	       </div>
	     </file>
	     <file name="animations.css">
	
	      .container.ng-enter,
	      .container.ng-leave {
	        transition: all ease 1.5s;
	      }
	
	      .container.ng-enter,
	      .container.ng-leave-active {
	        opacity: 0;
	      }
	
	      .container.ng-leave,
	      .container.ng-enter-active {
	        opacity: 1;
	      }
	
	      .item {
	        background: firebrick;
	        color: #FFF;
	        margin-bottom: 10px;
	      }
	
	      .item.ng-enter,
	      .item.ng-leave {
	        transition: transform 1.5s ease;
	      }
	
	      .item.ng-enter {
	        transform: translateX(50px);
	      }
	
	      .item.ng-enter-active {
	        transform: translateX(0);
	      }
	    </file>
	    <file name="script.js">
	      angular.module('ngAnimateChildren', ['ngAnimate'])
	        .controller('MainController', function MainController() {
	          this.animateChildren = false;
	          this.enterElement = false;
	        });
	    </file>
	  </example>
	 */
	var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
	  return {
	    link: function(scope, element, attrs) {
	      var val = attrs.ngAnimateChildren;
	      if (isString(val) && val.length === 0) { //empty attribute
	        element.data(NG_ANIMATE_CHILDREN_DATA, true);
	      } else {
	        // Interpolate and set the value, so that it is available to
	        // animations that run right after compilation
	        setData($interpolate(val)(scope));
	        attrs.$observe('ngAnimateChildren', setData);
	      }
	
	      function setData(value) {
	        value = value === 'on' || value === 'true';
	        element.data(NG_ANIMATE_CHILDREN_DATA, value);
	      }
	    }
	  };
	}];
	
	/* exported $AnimateCssProvider */
	
	var ANIMATE_TIMER_KEY = '$$animateCss';
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 *
	 * @description
	 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
	 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
	 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
	 * directives to create more complex animations that can be purely driven using CSS code.
	 *
	 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
	 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
	 *
	 * ## Usage
	 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
	 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
	 * any automatic control over cancelling animations and/or preventing animations from being run on
	 * child elements will not be handled by Angular. For this to work as expected, please use `$animate` to
	 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
	 * the CSS animation.
	 *
	 * The example below shows how we can create a folding animation on an element using `ng-if`:
	 *
	 * ```html
	 * <!-- notice the `fold-animation` CSS class -->
	 * <div ng-if="onOff" class="fold-animation">
	 *   This element will go BOOM
	 * </div>
	 * <button ng-click="onOff=true">Fold In</button>
	 * ```
	 *
	 * Now we create the **JavaScript animation** that will trigger the CSS transition:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## More Advanced Uses
	 *
	 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
	 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
	 *
	 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
	 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
	 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
	 * to provide a working animation that will run in CSS.
	 *
	 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         addClass: 'red large-text pulse-twice',
	 *         easing: 'ease-out',
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
	 *
	 * ```css
	 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
	 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
	 * .red { background:red; }
	 * .large-text { font-size:20px; }
	 *
	 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
	 * .pulse-twice {
	 *   animation: 0.5s pulse linear 2;
	 *   -webkit-animation: 0.5s pulse linear 2;
	 * }
	 *
	 * @keyframes pulse {
	 *   from { transform: scale(0.5); }
	 *   to { transform: scale(1.5); }
	 * }
	 *
	 * @-webkit-keyframes pulse {
	 *   from { -webkit-transform: scale(0.5); }
	 *   to { -webkit-transform: scale(1.5); }
	 * }
	 * ```
	 *
	 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
	 *
	 * ## How the Options are handled
	 *
	 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
	 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
	 * styles using the `from` and `to` properties.
	 *
	 * ```js
	 * var animator = $animateCss(element, {
	 *   from: { background:'red' },
	 *   to: { background:'blue' }
	 * });
	 * animator.start();
	 * ```
	 *
	 * ```css
	 * .rotating-animation {
	 *   animation:0.5s rotate linear;
	 *   -webkit-animation:0.5s rotate linear;
	 * }
	 *
	 * @keyframes rotate {
	 *   from { transform: rotate(0deg); }
	 *   to { transform: rotate(360deg); }
	 * }
	 *
	 * @-webkit-keyframes rotate {
	 *   from { -webkit-transform: rotate(0deg); }
	 *   to { -webkit-transform: rotate(360deg); }
	 * }
	 * ```
	 *
	 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
	 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
	 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
	 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
	 * and spread across the transition and keyframe animation.
	 *
	 * ## What is returned
	 *
	 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
	 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
	 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
	 *
	 * ```js
	 * var animator = $animateCss(element, { ... });
	 * ```
	 *
	 * Now what do the contents of our `animator` variable look like:
	 *
	 * ```js
	 * {
	 *   // starts the animation
	 *   start: Function,
	 *
	 *   // ends (aborts) the animation
	 *   end: Function
	 * }
	 * ```
	 *
	 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
	 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
	 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
	 * and that changing them will not reconfigure the parameters of the animation.
	 *
	 * ### runner.done() vs runner.then()
	 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
	 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
	 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
	 * unless you really need a digest to kick off afterwards.
	 *
	 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
	 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
	 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
	 *
	 * @param {DOMElement} element the element that will be animated
	 * @param {object} options the animation-related options that will be applied during the animation
	 *
	 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
	 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
	 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
	 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
	 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
	 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
	 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
	 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
	 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
	 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
	 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
	 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
	 * is provided then the animation will be skipped entirely.
	 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
	 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
	 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
	 * CSS delay value.
	 * * `stagger` - A numeric time value representing the delay between successively animated elements
	 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
	 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
	 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
	 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
	 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
	 *    the animation is closed. This is useful for when the styles are used purely for the sake of
	 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
	 *    By default this value is set to `false`.
	 *
	 * @return {object} an object with start and end methods and details about the animation.
	 *
	 * * `start` - The method to start the animation. This will return a `Promise` when called.
	 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
	 */
	var ONE_SECOND = 1000;
	
	var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
	var CLOSING_TIME_BUFFER = 1.5;
	
	var DETECT_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP,
	  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
	};
	
	var DETECT_STAGGER_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP
	};
	
	function getCssKeyframeDurationStyle(duration) {
	  return [ANIMATION_DURATION_PROP, duration + 's'];
	}
	
	function getCssDelayStyle(delay, isKeyframeAnimation) {
	  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
	  return [prop, delay + 's'];
	}
	
	function computeCssStyles($window, element, properties) {
	  var styles = Object.create(null);
	  var detectedStyles = $window.getComputedStyle(element) || {};
	  forEach(properties, function(formalStyleName, actualStyleName) {
	    var val = detectedStyles[formalStyleName];
	    if (val) {
	      var c = val.charAt(0);
	
	      // only numerical-based values have a negative sign or digit as the first value
	      if (c === '-' || c === '+' || c >= 0) {
	        val = parseMaxTime(val);
	      }
	
	      // by setting this to null in the event that the delay is not set or is set directly as 0
	      // then we can still allow for negative values to be used later on and not mistake this
	      // value for being greater than any other negative value.
	      if (val === 0) {
	        val = null;
	      }
	      styles[actualStyleName] = val;
	    }
	  });
	
	  return styles;
	}
	
	function parseMaxTime(str) {
	  var maxValue = 0;
	  var values = str.split(/\s*,\s*/);
	  forEach(values, function(value) {
	    // it's always safe to consider only second values and omit `ms` values since
	    // getComputedStyle will always handle the conversion for us
	    if (value.charAt(value.length - 1) === 's') {
	      value = value.substring(0, value.length - 1);
	    }
	    value = parseFloat(value) || 0;
	    maxValue = maxValue ? Math.max(value, maxValue) : value;
	  });
	  return maxValue;
	}
	
	function truthyTimingValue(val) {
	  return val === 0 || val != null;
	}
	
	function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
	  var style = TRANSITION_PROP;
	  var value = duration + 's';
	  if (applyOnlyDuration) {
	    style += DURATION_KEY;
	  } else {
	    value += ' linear all';
	  }
	  return [style, value];
	}
	
	function createLocalCacheLookup() {
	  var cache = Object.create(null);
	  return {
	    flush: function() {
	      cache = Object.create(null);
	    },
	
	    count: function(key) {
	      var entry = cache[key];
	      return entry ? entry.total : 0;
	    },
	
	    get: function(key) {
	      var entry = cache[key];
	      return entry && entry.value;
	    },
	
	    put: function(key, value) {
	      if (!cache[key]) {
	        cache[key] = { total: 1, value: value };
	      } else {
	        cache[key].total++;
	      }
	    }
	  };
	}
	
	// we do not reassign an already present style value since
	// if we detect the style property value again we may be
	// detecting styles that were added via the `from` styles.
	// We make use of `isDefined` here since an empty string
	// or null value (which is what getPropertyValue will return
	// for a non-existing style) will still be marked as a valid
	// value for the style (a falsy value implies that the style
	// is to be removed at the end of the animation). If we had a simple
	// "OR" statement then it would not be enough to catch that.
	function registerRestorableStyles(backup, node, properties) {
	  forEach(properties, function(prop) {
	    backup[prop] = isDefined(backup[prop])
	        ? backup[prop]
	        : node.style.getPropertyValue(prop);
	  });
	}
	
	var $AnimateCssProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var gcsLookup = createLocalCacheLookup();
	  var gcsStaggerLookup = createLocalCacheLookup();
	
	  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout',
	               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
	       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,
	                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    var parentCounter = 0;
	    function gcsHashFn(node, extraClasses) {
	      var KEY = '$$ngAnimateParentKey';
	      var parentNode = node.parentNode;
	      var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
	      return parentID + '-' + node.getAttribute('class') + '-' + extraClasses;
	    }
	
	    function computeCachedCssStyles(node, className, cacheKey, properties) {
	      var timings = gcsLookup.get(cacheKey);
	
	      if (!timings) {
	        timings = computeCssStyles($window, node, properties);
	        if (timings.animationIterationCount === 'infinite') {
	          timings.animationIterationCount = 1;
	        }
	      }
	
	      // we keep putting this in multiple times even though the value and the cacheKey are the same
	      // because we're keeping an internal tally of how many duplicate animations are detected.
	      gcsLookup.put(cacheKey, timings);
	      return timings;
	    }
	
	    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
	      var stagger;
	
	      // if we have one or more existing matches of matching elements
	      // containing the same parent + CSS styles (which is how cacheKey works)
	      // then staggering is possible
	      if (gcsLookup.count(cacheKey) > 0) {
	        stagger = gcsStaggerLookup.get(cacheKey);
	
	        if (!stagger) {
	          var staggerClassName = pendClasses(className, '-stagger');
	
	          $$jqLite.addClass(node, staggerClassName);
	
	          stagger = computeCssStyles($window, node, properties);
	
	          // force the conversion of a null value to zero incase not set
	          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
	          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);
	
	          $$jqLite.removeClass(node, staggerClassName);
	
	          gcsStaggerLookup.put(cacheKey, stagger);
	        }
	      }
	
	      return stagger || {};
	    }
	
	    var rafWaitQueue = [];
	    function waitUntilQuiet(callback) {
	      rafWaitQueue.push(callback);
	      $$rAFScheduler.waitUntilQuiet(function() {
	        gcsLookup.flush();
	        gcsStaggerLookup.flush();
	
	        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	        var pageWidth = $$forceReflow();
	
	        // we use a for loop to ensure that if the queue is changed
	        // during this looping then it will consider new requests
	        for (var i = 0; i < rafWaitQueue.length; i++) {
	          rafWaitQueue[i](pageWidth);
	        }
	        rafWaitQueue.length = 0;
	      });
	    }
	
	    function computeTimings(node, className, cacheKey) {
	      var timings = computeCachedCssStyles(node, className, cacheKey, DETECT_CSS_PROPERTIES);
	      var aD = timings.animationDelay;
	      var tD = timings.transitionDelay;
	      timings.maxDelay = aD && tD
	          ? Math.max(aD, tD)
	          : (aD || tD);
	      timings.maxDuration = Math.max(
	          timings.animationDuration * timings.animationIterationCount,
	          timings.transitionDuration);
	
	      return timings;
	    }
	
	    return function init(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = prepareAnimationOptions(copy(options));
	      }
	
	      var restoreStyles = {};
	      var node = getDomNode(element);
	      if (!node
	          || !node.parentNode
	          || !$$animateQueue.enabled()) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var temporaryStyles = [];
	      var classes = element.attr('class');
	      var styles = packageStyles(options);
	      var animationClosed;
	      var animationPaused;
	      var animationCompleted;
	      var runner;
	      var runnerHost;
	      var maxDelay;
	      var maxDelayTime;
	      var maxDuration;
	      var maxDurationTime;
	      var startTime;
	      var events = [];
	
	      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var method = options.event && isArray(options.event)
	            ? options.event.join(' ')
	            : options.event;
	
	      var isStructural = method && options.structural;
	      var structuralClassName = '';
	      var addRemoveClassName = '';
	
	      if (isStructural) {
	        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
	      } else if (method) {
	        structuralClassName = method;
	      }
	
	      if (options.addClass) {
	        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
	      }
	
	      if (options.removeClass) {
	        if (addRemoveClassName.length) {
	          addRemoveClassName += ' ';
	        }
	        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
	      }
	
	      // there may be a situation where a structural animation is combined together
	      // with CSS classes that need to resolve before the animation is computed.
	      // However this means that there is no explicit CSS code to block the animation
	      // from happening (by setting 0s none in the class name). If this is the case
	      // we need to apply the classes before the first rAF so we know to continue if
	      // there actually is a detected transition or keyframe animation
	      if (options.applyClassesEarly && addRemoveClassName.length) {
	        applyAnimationClasses(element, options);
	      }
	
	      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
	      var fullClassName = classes + ' ' + preparationClasses;
	      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
	      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
	      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;
	
	      // there is no way we can trigger an animation if no styles and
	      // no classes are being applied which would then trigger a transition,
	      // unless there a is raw keyframe value that is applied to the element.
	      if (!containsKeyframeAnimation
	           && !hasToStyles
	           && !preparationClasses) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var cacheKey, stagger;
	      if (options.stagger > 0) {
	        var staggerVal = parseFloat(options.stagger);
	        stagger = {
	          transitionDelay: staggerVal,
	          animationDelay: staggerVal,
	          transitionDuration: 0,
	          animationDuration: 0
	        };
	      } else {
	        cacheKey = gcsHashFn(node, fullClassName);
	        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
	      }
	
	      if (!options.$$skipPreparationClasses) {
	        $$jqLite.addClass(element, preparationClasses);
	      }
	
	      var applyOnlyDuration;
	
	      if (options.transitionStyle) {
	        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
	        applyInlineStyle(node, transitionStyle);
	        temporaryStyles.push(transitionStyle);
	      }
	
	      if (options.duration >= 0) {
	        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
	        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);
	
	        // we set the duration so that it will be picked up by getComputedStyle later
	        applyInlineStyle(node, durationStyle);
	        temporaryStyles.push(durationStyle);
	      }
	
	      if (options.keyframeStyle) {
	        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
	        applyInlineStyle(node, keyframeStyle);
	        temporaryStyles.push(keyframeStyle);
	      }
	
	      var itemIndex = stagger
	          ? options.staggerIndex >= 0
	              ? options.staggerIndex
	              : gcsLookup.count(cacheKey)
	          : 0;
	
	      var isFirst = itemIndex === 0;
	
	      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
	      // without causing any combination of transitions to kick in. By adding a negative delay value
	      // it forces the setup class' transition to end immediately. We later then remove the negative
	      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
	      // that if there is no transition defined then nothing will happen and this will also allow
	      // other transitions to be stacked on top of each other without any chopping them out.
	      if (isFirst && !options.skipBlocking) {
	        blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
	      }
	
	      var timings = computeTimings(node, fullClassName, cacheKey);
	      var relativeDelay = timings.maxDelay;
	      maxDelay = Math.max(relativeDelay, 0);
	      maxDuration = timings.maxDuration;
	
	      var flags = {};
	      flags.hasTransitions          = timings.transitionDuration > 0;
	      flags.hasAnimations           = timings.animationDuration > 0;
	      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty === 'all';
	      flags.applyTransitionDuration = hasToStyles && (
	                                        (flags.hasTransitions && !flags.hasTransitionAll)
	                                         || (flags.hasAnimations && !flags.hasTransitions));
	      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
	      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
	      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
	      flags.recalculateTimingStyles = addRemoveClassName.length > 0;
	
	      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
	        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;
	
	        if (flags.applyTransitionDuration) {
	          flags.hasTransitions = true;
	          timings.transitionDuration = maxDuration;
	          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
	          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
	        }
	
	        if (flags.applyAnimationDuration) {
	          flags.hasAnimations = true;
	          timings.animationDuration = maxDuration;
	          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
	        }
	      }
	
	      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      if (options.delay != null) {
	        var delayStyle;
	        if (typeof options.delay !== 'boolean') {
	          delayStyle = parseFloat(options.delay);
	          // number in options.delay means we have to recalculate the delay for the closing timeout
	          maxDelay = Math.max(delayStyle, 0);
	        }
	
	        if (flags.applyTransitionDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle));
	        }
	
	        if (flags.applyAnimationDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
	        }
	      }
	
	      // we need to recalculate the delay value since we used a pre-emptive negative
	      // delay value and the delay value is required for the final event checking. This
	      // property will ensure that this will happen after the RAF phase has passed.
	      if (options.duration == null && timings.transitionDuration > 0) {
	        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
	      }
	
	      maxDelayTime = maxDelay * ONE_SECOND;
	      maxDurationTime = maxDuration * ONE_SECOND;
	      if (!options.skipBlocking) {
	        flags.blockTransition = timings.transitionDuration > 0;
	        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
	                                       stagger.animationDelay > 0 &&
	                                       stagger.animationDuration === 0;
	      }
	
	      if (options.from) {
	        if (options.cleanupStyles) {
	          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
	        }
	        applyAnimationFromStyles(element, options);
	      }
	
	      if (flags.blockTransition || flags.blockKeyframeAnimation) {
	        applyBlocking(maxDuration);
	      } else if (!options.skipBlocking) {
	        blockTransitions(node, false);
	      }
	
	      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
	      return {
	        $$willAnimate: true,
	        end: endFn,
	        start: function() {
	          if (animationClosed) return;
	
	          runnerHost = {
	            end: endFn,
	            cancel: cancelFn,
	            resume: null, //this will be set during the start() phase
	            pause: null
	          };
	
	          runner = new $$AnimateRunner(runnerHost);
	
	          waitUntilQuiet(start);
	
	          // we don't have access to pause/resume the animation
	          // since it hasn't run yet. AnimateRunner will therefore
	          // set noop functions for resume and pause and they will
	          // later be overridden once the animation is triggered
	          return runner;
	        }
	      };
	
	      function endFn() {
	        close();
	      }
	
	      function cancelFn() {
	        close(true);
	      }
	
	      function close(rejected) {
	        // if the promise has been called already then we shouldn't close
	        // the animation again
	        if (animationClosed || (animationCompleted && animationPaused)) return;
	        animationClosed = true;
	        animationPaused = false;
	
	        if (!options.$$skipPreparationClasses) {
	          $$jqLite.removeClass(element, preparationClasses);
	        }
	        $$jqLite.removeClass(element, activeClasses);
	
	        blockKeyframeAnimations(node, false);
	        blockTransitions(node, false);
	
	        forEach(temporaryStyles, function(entry) {
	          // There is only one way to remove inline style properties entirely from elements.
	          // By using `removeProperty` this works, but we need to convert camel-cased CSS
	          // styles down to hyphenated values.
	          node.style[entry[0]] = '';
	        });
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	
	        if (Object.keys(restoreStyles).length) {
	          forEach(restoreStyles, function(value, prop) {
	            if (value) {
	              node.style.setProperty(prop, value);
	            } else {
	              node.style.removeProperty(prop);
	            }
	          });
	        }
	
	        // the reason why we have this option is to allow a synchronous closing callback
	        // that is fired as SOON as the animation ends (when the CSS is removed) or if
	        // the animation never takes off at all. A good example is a leave animation since
	        // the element must be removed just after the animation is over or else the element
	        // will appear on screen for one animation frame causing an overbearing flicker.
	        if (options.onDone) {
	          options.onDone();
	        }
	
	        if (events && events.length) {
	          // Remove the transitionend / animationend listener(s)
	          element.off(events.join(' '), onAnimationProgress);
	        }
	
	        //Cancel the fallback closing timeout and remove the timer data
	        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
	        if (animationTimerData) {
	          $timeout.cancel(animationTimerData[0].timer);
	          element.removeData(ANIMATE_TIMER_KEY);
	        }
	
	        // if the preparation function fails then the promise is not setup
	        if (runner) {
	          runner.complete(!rejected);
	        }
	      }
	
	      function applyBlocking(duration) {
	        if (flags.blockTransition) {
	          blockTransitions(node, duration);
	        }
	
	        if (flags.blockKeyframeAnimation) {
	          blockKeyframeAnimations(node, !!duration);
	        }
	      }
	
	      function closeAndReturnNoopAnimator() {
	        runner = new $$AnimateRunner({
	          end: endFn,
	          cancel: cancelFn
	        });
	
	        // should flush the cache animation
	        waitUntilQuiet(noop);
	        close();
	
	        return {
	          $$willAnimate: false,
	          start: function() {
	            return runner;
	          },
	          end: endFn
	        };
	      }
	
	      function onAnimationProgress(event) {
	        event.stopPropagation();
	        var ev = event.originalEvent || event;
	
	        // we now always use `Date.now()` due to the recent changes with
	        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
	        var timeStamp = ev.$manualTimeStamp || Date.now();
	
	        /* Firefox (or possibly just Gecko) likes to not round values up
	         * when a ms measurement is used for the animation */
	        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));
	
	        /* $manualTimeStamp is a mocked timeStamp value which is set
	         * within browserTrigger(). This is only here so that tests can
	         * mock animations properly. Real events fallback to event.timeStamp,
	         * or, if they don't, then a timeStamp is automatically created for them.
	         * We're checking to see if the timeStamp surpasses the expected delay,
	         * but we're using elapsedTime instead of the timeStamp on the 2nd
	         * pre-condition since animationPauseds sometimes close off early */
	        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	          // we set this flag to ensure that if the transition is paused then, when resumed,
	          // the animation will automatically close itself since transitions cannot be paused.
	          animationCompleted = true;
	          close();
	        }
	      }
	
	      function start() {
	        if (animationClosed) return;
	        if (!node.parentNode) {
	          close();
	          return;
	        }
	
	        // even though we only pause keyframe animations here the pause flag
	        // will still happen when transitions are used. Only the transition will
	        // not be paused since that is not possible. If the animation ends when
	        // paused then it will not complete until unpaused or cancelled.
	        var playPause = function(playAnimation) {
	          if (!animationCompleted) {
	            animationPaused = !playAnimation;
	            if (timings.animationDuration) {
	              var value = blockKeyframeAnimations(node, animationPaused);
	              if (animationPaused) {
	                temporaryStyles.push(value);
	              } else {
	                removeFromArray(temporaryStyles, value);
	              }
	            }
	          } else if (animationPaused && playAnimation) {
	            animationPaused = false;
	            close();
	          }
	        };
	
	        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
	        // being inherited from the parent. If the transition duration is zero then we can safely
	        // rely that the delay value is an intentional stagger delay style.
	        var maxStagger = itemIndex > 0
	                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
	                            (timings.animationDuration && stagger.animationDuration === 0))
	                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
	        if (maxStagger) {
	          $timeout(triggerAnimationStart,
	                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
	                   false);
	        } else {
	          triggerAnimationStart();
	        }
	
	        // this will decorate the existing promise runner with pause/resume methods
	        runnerHost.resume = function() {
	          playPause(true);
	        };
	
	        runnerHost.pause = function() {
	          playPause(false);
	        };
	
	        function triggerAnimationStart() {
	          // just incase a stagger animation kicks in when the animation
	          // itself was cancelled entirely
	          if (animationClosed) return;
	
	          applyBlocking(false);
	
	          forEach(temporaryStyles, function(entry) {
	            var key = entry[0];
	            var value = entry[1];
	            node.style[key] = value;
	          });
	
	          applyAnimationClasses(element, options);
	          $$jqLite.addClass(element, activeClasses);
	
	          if (flags.recalculateTimingStyles) {
	            fullClassName = node.getAttribute('class') + ' ' + preparationClasses;
	            cacheKey = gcsHashFn(node, fullClassName);
	
	            timings = computeTimings(node, fullClassName, cacheKey);
	            relativeDelay = timings.maxDelay;
	            maxDelay = Math.max(relativeDelay, 0);
	            maxDuration = timings.maxDuration;
	
	            if (maxDuration === 0) {
	              close();
	              return;
	            }
	
	            flags.hasTransitions = timings.transitionDuration > 0;
	            flags.hasAnimations = timings.animationDuration > 0;
	          }
	
	          if (flags.applyAnimationDelay) {
	            relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay)
	                  ? parseFloat(options.delay)
	                  : relativeDelay;
	
	            maxDelay = Math.max(relativeDelay, 0);
	            timings.animationDelay = relativeDelay;
	            delayStyle = getCssDelayStyle(relativeDelay, true);
	            temporaryStyles.push(delayStyle);
	            node.style[delayStyle[0]] = delayStyle[1];
	          }
	
	          maxDelayTime = maxDelay * ONE_SECOND;
	          maxDurationTime = maxDuration * ONE_SECOND;
	
	          if (options.easing) {
	            var easeProp, easeVal = options.easing;
	            if (flags.hasTransitions) {
	              easeProp = TRANSITION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	            if (flags.hasAnimations) {
	              easeProp = ANIMATION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	          }
	
	          if (timings.transitionDuration) {
	            events.push(TRANSITIONEND_EVENT);
	          }
	
	          if (timings.animationDuration) {
	            events.push(ANIMATIONEND_EVENT);
	          }
	
	          startTime = Date.now();
	          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
	          var endTime = startTime + timerTime;
	
	          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
	          var setupFallbackTimer = true;
	          if (animationsData.length) {
	            var currentTimerData = animationsData[0];
	            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
	            if (setupFallbackTimer) {
	              $timeout.cancel(currentTimerData.timer);
	            } else {
	              animationsData.push(close);
	            }
	          }
	
	          if (setupFallbackTimer) {
	            var timer = $timeout(onAnimationExpired, timerTime, false);
	            animationsData[0] = {
	              timer: timer,
	              expectedEndTime: endTime
	            };
	            animationsData.push(close);
	            element.data(ANIMATE_TIMER_KEY, animationsData);
	          }
	
	          if (events.length) {
	            element.on(events.join(' '), onAnimationProgress);
	          }
	
	          if (options.to) {
	            if (options.cleanupStyles) {
	              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
	            }
	            applyAnimationToStyles(element, options);
	          }
	        }
	
	        function onAnimationExpired() {
	          var animationsData = element.data(ANIMATE_TIMER_KEY);
	
	          // this will be false in the event that the element was
	          // removed from the DOM (via a leave animation or something
	          // similar)
	          if (animationsData) {
	            for (var i = 1; i < animationsData.length; i++) {
	              animationsData[i]();
	            }
	            element.removeData(ANIMATE_TIMER_KEY);
	          }
	        }
	      }
	    };
	  }];
	}];
	
	var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateCssDriver');
	
	  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
	  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';
	
	  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
	  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';
	
	  function isDocumentFragment(node) {
	    return node.parentNode && node.parentNode.nodeType === 11;
	  }
	
	  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
	       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {
	
	    // only browsers that support these properties can render animations
	    if (!$sniffer.animations && !$sniffer.transitions) return noop;
	
	    var bodyNode = $document[0].body;
	    var rootNode = getDomNode($rootElement);
	
	    var rootBodyElement = jqLite(
	      // this is to avoid using something that exists outside of the body
	      // we also special case the doc fragment case because our unit test code
	      // appends the $rootElement to the body after the app has been bootstrapped
	      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
	    );
	
	    return function initDriverFn(animationDetails) {
	      return animationDetails.from && animationDetails.to
	          ? prepareFromToAnchorAnimation(animationDetails.from,
	                                         animationDetails.to,
	                                         animationDetails.classes,
	                                         animationDetails.anchors)
	          : prepareRegularAnimation(animationDetails);
	    };
	
	    function filterCssClasses(classes) {
	      //remove all the `ng-` stuff
	      return classes.replace(/\bng-\S+\b/g, '');
	    }
	
	    function getUniqueValues(a, b) {
	      if (isString(a)) a = a.split(' ');
	      if (isString(b)) b = b.split(' ');
	      return a.filter(function(val) {
	        return b.indexOf(val) === -1;
	      }).join(' ');
	    }
	
	    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
	      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
	      var startingClasses = filterCssClasses(getClassVal(clone));
	
	      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	
	      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);
	
	      rootBodyElement.append(clone);
	
	      var animatorIn, animatorOut = prepareOutAnimation();
	
	      // the user may not end up using the `out` animation and
	      // only making use of the `in` animation or vice-versa.
	      // In either case we should allow this and not assume the
	      // animation is over unless both animations are not used.
	      if (!animatorOut) {
	        animatorIn = prepareInAnimation();
	        if (!animatorIn) {
	          return end();
	        }
	      }
	
	      var startingAnimator = animatorOut || animatorIn;
	
	      return {
	        start: function() {
	          var runner;
	
	          var currentAnimation = startingAnimator.start();
	          currentAnimation.done(function() {
	            currentAnimation = null;
	            if (!animatorIn) {
	              animatorIn = prepareInAnimation();
	              if (animatorIn) {
	                currentAnimation = animatorIn.start();
	                currentAnimation.done(function() {
	                  currentAnimation = null;
	                  end();
	                  runner.complete();
	                });
	                return currentAnimation;
	              }
	            }
	            // in the event that there is no `in` animation
	            end();
	            runner.complete();
	          });
	
	          runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn
	          });
	
	          return runner;
	
	          function endFn() {
	            if (currentAnimation) {
	              currentAnimation.end();
	            }
	          }
	        }
	      };
	
	      function calculateAnchorStyles(anchor) {
	        var styles = {};
	
	        var coords = getDomNode(anchor).getBoundingClientRect();
	
	        // we iterate directly since safari messes up and doesn't return
	        // all the keys for the coords object when iterated
	        forEach(['width','height','top','left'], function(key) {
	          var value = coords[key];
	          switch (key) {
	            case 'top':
	              value += bodyNode.scrollTop;
	              break;
	            case 'left':
	              value += bodyNode.scrollLeft;
	              break;
	          }
	          styles[key] = Math.floor(value) + 'px';
	        });
	        return styles;
	      }
	
	      function prepareOutAnimation() {
	        var animator = $animateCss(clone, {
	          addClass: NG_OUT_ANCHOR_CLASS_NAME,
	          delay: true,
	          from: calculateAnchorStyles(outAnchor)
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function getClassVal(element) {
	        return element.attr('class') || '';
	      }
	
	      function prepareInAnimation() {
	        var endingClasses = filterCssClasses(getClassVal(inAnchor));
	        var toAdd = getUniqueValues(endingClasses, startingClasses);
	        var toRemove = getUniqueValues(startingClasses, endingClasses);
	
	        var animator = $animateCss(clone, {
	          to: calculateAnchorStyles(inAnchor),
	          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
	          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
	          delay: true
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function end() {
	        clone.remove();
	        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      }
	    }
	
	    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
	      var fromAnimation = prepareRegularAnimation(from, noop);
	      var toAnimation = prepareRegularAnimation(to, noop);
	
	      var anchorAnimations = [];
	      forEach(anchors, function(anchor) {
	        var outElement = anchor['out'];
	        var inElement = anchor['in'];
	        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
	        if (animator) {
	          anchorAnimations.push(animator);
	        }
	      });
	
	      // no point in doing anything when there are no elements to animate
	      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;
	
	      return {
	        start: function() {
	          var animationRunners = [];
	
	          if (fromAnimation) {
	            animationRunners.push(fromAnimation.start());
	          }
	
	          if (toAnimation) {
	            animationRunners.push(toAnimation.start());
	          }
	
	          forEach(anchorAnimations, function(animation) {
	            animationRunners.push(animation.start());
	          });
	
	          var runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
	          });
	
	          $$AnimateRunner.all(animationRunners, function(status) {
	            runner.complete(status);
	          });
	
	          return runner;
	
	          function endFn() {
	            forEach(animationRunners, function(runner) {
	              runner.end();
	            });
	          }
	        }
	      };
	    }
	
	    function prepareRegularAnimation(animationDetails) {
	      var element = animationDetails.element;
	      var options = animationDetails.options || {};
	
	      if (animationDetails.structural) {
	        options.event = animationDetails.event;
	        options.structural = true;
	        options.applyClassesEarly = true;
	
	        // we special case the leave animation since we want to ensure that
	        // the element is removed as soon as the animation is over. Otherwise
	        // a flicker might appear or the element may not be removed at all
	        if (animationDetails.event === 'leave') {
	          options.onDone = options.domOperation;
	        }
	      }
	
	      // We assign the preparationClasses as the actual animation event since
	      // the internals of $animateCss will just suffix the event token values
	      // with `-active` to trigger the animation.
	      if (options.preparationClasses) {
	        options.event = concatWithSpace(options.event, options.preparationClasses);
	      }
	
	      var animator = $animateCss(element, options);
	
	      // the driver lookup code inside of $$animation attempts to spawn a
	      // driver one by one until a driver returns a.$$willAnimate animator object.
	      // $animateCss will always return an object, however, it will pass in
	      // a flag as a hint as to whether an animation was detected or not
	      return animator.$$willAnimate ? animator : null;
	    }
	  }];
	}];
	
	// TODO(matsko): use caching here to speed things up for detection
	// TODO(matsko): add documentation
	//  by the time...
	
	var $$AnimateJsProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
	       function($injector,   $$AnimateRunner,   $$jqLite) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	         // $animateJs(element, 'enter');
	    return function(element, event, classes, options) {
	      var animationClosed = false;
	
	      // the `classes` argument is optional and if it is not used
	      // then the classes will be resolved from the element's className
	      // property as well as options.addClass/options.removeClass.
	      if (arguments.length === 3 && isObject(classes)) {
	        options = classes;
	        classes = null;
	      }
	
	      options = prepareAnimationOptions(options);
	      if (!classes) {
	        classes = element.attr('class') || '';
	        if (options.addClass) {
	          classes += ' ' + options.addClass;
	        }
	        if (options.removeClass) {
	          classes += ' ' + options.removeClass;
	        }
	      }
	
	      var classesToAdd = options.addClass;
	      var classesToRemove = options.removeClass;
	
	      // the lookupAnimations function returns a series of animation objects that are
	      // matched up with one or more of the CSS classes. These animation objects are
	      // defined via the module.animation factory function. If nothing is detected then
	      // we don't return anything which then makes $animation query the next driver.
	      var animations = lookupAnimations(classes);
	      var before, after;
	      if (animations.length) {
	        var afterFn, beforeFn;
	        if (event === 'leave') {
	          beforeFn = 'leave';
	          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
	        } else {
	          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
	          afterFn = event;
	        }
	
	        if (event !== 'enter' && event !== 'move') {
	          before = packageAnimations(element, event, options, animations, beforeFn);
	        }
	        after  = packageAnimations(element, event, options, animations, afterFn);
	      }
	
	      // no matching animations
	      if (!before && !after) return;
	
	      function applyOptions() {
	        options.domOperation();
	        applyAnimationClasses(element, options);
	      }
	
	      function close() {
	        animationClosed = true;
	        applyOptions();
	        applyAnimationStyles(element, options);
	      }
	
	      var runner;
	
	      return {
	        $$willAnimate: true,
	        end: function() {
	          if (runner) {
	            runner.end();
	          } else {
	            close();
	            runner = new $$AnimateRunner();
	            runner.complete(true);
	          }
	          return runner;
	        },
	        start: function() {
	          if (runner) {
	            return runner;
	          }
	
	          runner = new $$AnimateRunner();
	          var closeActiveAnimations;
	          var chain = [];
	
	          if (before) {
	            chain.push(function(fn) {
	              closeActiveAnimations = before(fn);
	            });
	          }
	
	          if (chain.length) {
	            chain.push(function(fn) {
	              applyOptions();
	              fn(true);
	            });
	          } else {
	            applyOptions();
	          }
	
	          if (after) {
	            chain.push(function(fn) {
	              closeActiveAnimations = after(fn);
	            });
	          }
	
	          runner.setHost({
	            end: function() {
	              endAnimations();
	            },
	            cancel: function() {
	              endAnimations(true);
	            }
	          });
	
	          $$AnimateRunner.chain(chain, onComplete);
	          return runner;
	
	          function onComplete(success) {
	            close(success);
	            runner.complete(success);
	          }
	
	          function endAnimations(cancelled) {
	            if (!animationClosed) {
	              (closeActiveAnimations || noop)(cancelled);
	              onComplete(cancelled);
	            }
	          }
	        }
	      };
	
	      function executeAnimationFn(fn, element, event, options, onDone) {
	        var args;
	        switch (event) {
	          case 'animate':
	            args = [element, options.from, options.to, onDone];
	            break;
	
	          case 'setClass':
	            args = [element, classesToAdd, classesToRemove, onDone];
	            break;
	
	          case 'addClass':
	            args = [element, classesToAdd, onDone];
	            break;
	
	          case 'removeClass':
	            args = [element, classesToRemove, onDone];
	            break;
	
	          default:
	            args = [element, onDone];
	            break;
	        }
	
	        args.push(options);
	
	        var value = fn.apply(fn, args);
	        if (value) {
	          if (isFunction(value.start)) {
	            value = value.start();
	          }
	
	          if (value instanceof $$AnimateRunner) {
	            value.done(onDone);
	          } else if (isFunction(value)) {
	            // optional onEnd / onCancel callback
	            return value;
	          }
	        }
	
	        return noop;
	      }
	
	      function groupEventedAnimations(element, event, options, animations, fnName) {
	        var operations = [];
	        forEach(animations, function(ani) {
	          var animation = ani[fnName];
	          if (!animation) return;
	
	          // note that all of these animations will run in parallel
	          operations.push(function() {
	            var runner;
	            var endProgressCb;
	
	            var resolved = false;
	            var onAnimationComplete = function(rejected) {
	              if (!resolved) {
	                resolved = true;
	                (endProgressCb || noop)(rejected);
	                runner.complete(!rejected);
	              }
	            };
	
	            runner = new $$AnimateRunner({
	              end: function() {
	                onAnimationComplete();
	              },
	              cancel: function() {
	                onAnimationComplete(true);
	              }
	            });
	
	            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
	              var cancelled = result === false;
	              onAnimationComplete(cancelled);
	            });
	
	            return runner;
	          });
	        });
	
	        return operations;
	      }
	
	      function packageAnimations(element, event, options, animations, fnName) {
	        var operations = groupEventedAnimations(element, event, options, animations, fnName);
	        if (operations.length === 0) {
	          var a, b;
	          if (fnName === 'beforeSetClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
	          } else if (fnName === 'setClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
	          }
	
	          if (a) {
	            operations = operations.concat(a);
	          }
	          if (b) {
	            operations = operations.concat(b);
	          }
	        }
	
	        if (operations.length === 0) return;
	
	        // TODO(matsko): add documentation
	        return function startAnimation(callback) {
	          var runners = [];
	          if (operations.length) {
	            forEach(operations, function(animateFn) {
	              runners.push(animateFn());
	            });
	          }
	
	          if (runners.length) {
	            $$AnimateRunner.all(runners, callback);
	          }  else {
	            callback();
	          }
	
	          return function endFn(reject) {
	            forEach(runners, function(runner) {
	              if (reject) {
	                runner.cancel();
	              } else {
	                runner.end();
	              }
	            });
	          };
	        };
	      }
	    };
	
	    function lookupAnimations(classes) {
	      classes = isArray(classes) ? classes : classes.split(' ');
	      var matches = [], flagMap = {};
	      for (var i = 0; i < classes.length; i++) {
	        var klass = classes[i],
	            animationFactory = $animateProvider.$$registeredAnimations[klass];
	        if (animationFactory && !flagMap[klass]) {
	          matches.push($injector.get(animationFactory));
	          flagMap[klass] = true;
	        }
	      }
	      return matches;
	    }
	  }];
	}];
	
	var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateJsDriver');
	  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
	    return function initDriverFn(animationDetails) {
	      if (animationDetails.from && animationDetails.to) {
	        var fromAnimation = prepareAnimation(animationDetails.from);
	        var toAnimation = prepareAnimation(animationDetails.to);
	        if (!fromAnimation && !toAnimation) return;
	
	        return {
	          start: function() {
	            var animationRunners = [];
	
	            if (fromAnimation) {
	              animationRunners.push(fromAnimation.start());
	            }
	
	            if (toAnimation) {
	              animationRunners.push(toAnimation.start());
	            }
	
	            $$AnimateRunner.all(animationRunners, done);
	
	            var runner = new $$AnimateRunner({
	              end: endFnFactory(),
	              cancel: endFnFactory()
	            });
	
	            return runner;
	
	            function endFnFactory() {
	              return function() {
	                forEach(animationRunners, function(runner) {
	                  // at this point we cannot cancel animations for groups just yet. 1.5+
	                  runner.end();
	                });
	              };
	            }
	
	            function done(status) {
	              runner.complete(status);
	            }
	          }
	        };
	      } else {
	        return prepareAnimation(animationDetails);
	      }
	    };
	
	    function prepareAnimation(animationDetails) {
	      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
	      var element = animationDetails.element;
	      var event = animationDetails.event;
	      var options = animationDetails.options;
	      var classes = animationDetails.classes;
	      return $$animateJs(element, event, classes, options);
	    }
	  }];
	}];
	
	var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
	var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
	var $$AnimateQueueProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var PRE_DIGEST_STATE = 1;
	  var RUNNING_STATE = 2;
	  var ONE_SPACE = ' ';
	
	  var rules = this.rules = {
	    skip: [],
	    cancel: [],
	    join: []
	  };
	
	  function makeTruthyCssClassMap(classString) {
	    if (!classString) {
	      return null;
	    }
	
	    var keys = classString.split(ONE_SPACE);
	    var map = Object.create(null);
	
	    forEach(keys, function(key) {
	      map[key] = true;
	    });
	    return map;
	  }
	
	  function hasMatchingClasses(newClassString, currentClassString) {
	    if (newClassString && currentClassString) {
	      var currentClassMap = makeTruthyCssClassMap(currentClassString);
	      return newClassString.split(ONE_SPACE).some(function(className) {
	        return currentClassMap[className];
	      });
	    }
	  }
	
	  function isAllowed(ruleType, currentAnimation, previousAnimation) {
	    return rules[ruleType].some(function(fn) {
	      return fn(currentAnimation, previousAnimation);
	    });
	  }
	
	  function hasAnimationClasses(animation, and) {
	    var a = (animation.addClass || '').length > 0;
	    var b = (animation.removeClass || '').length > 0;
	    return and ? a && b : a || b;
	  }
	
	  rules.join.push(function(newAnimation, currentAnimation) {
	    // if the new animation is class-based then we can just tack that on
	    return !newAnimation.structural && hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(newAnimation, currentAnimation) {
	    // there is no need to animate anything if no classes are being added and
	    // there is no structural animation that will be triggered
	    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(newAnimation, currentAnimation) {
	    // why should we trigger a new structural animation if the element will
	    // be removed from the DOM anyway?
	    return currentAnimation.event === 'leave' && newAnimation.structural;
	  });
	
	  rules.skip.push(function(newAnimation, currentAnimation) {
	    // if there is an ongoing current animation then don't even bother running the class-based animation
	    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
	  });
	
	  rules.cancel.push(function(newAnimation, currentAnimation) {
	    // there can never be two structural animations running at the same time
	    return currentAnimation.structural && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(newAnimation, currentAnimation) {
	    // if the previous animation is already running, but the new animation will
	    // be triggered, but the new animation is structural
	    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(newAnimation, currentAnimation) {
	    // cancel the animation if classes added / removed in both animation cancel each other out,
	    // but only if the current animation isn't structural
	
	    if (currentAnimation.structural) return false;
	
	    var nA = newAnimation.addClass;
	    var nR = newAnimation.removeClass;
	    var cA = currentAnimation.addClass;
	    var cR = currentAnimation.removeClass;
	
	    // early detection to save the global CPU shortage :)
	    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
	      return false;
	    }
	
	    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
	  });
	
	  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$Map',
	               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
	               '$$isDocumentHidden',
	       function($$rAF,   $rootScope,   $rootElement,   $document,   $$Map,
	                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow,
	                $$isDocumentHidden) {
	
	    var activeAnimationsLookup = new $$Map();
	    var disabledElementsLookup = new $$Map();
	    var animationsEnabled = null;
	
	    function postDigestTaskFactory() {
	      var postDigestCalled = false;
	      return function(fn) {
	        // we only issue a call to postDigest before
	        // it has first passed. This prevents any callbacks
	        // from not firing once the animation has completed
	        // since it will be out of the digest cycle.
	        if (postDigestCalled) {
	          fn();
	        } else {
	          $rootScope.$$postDigest(function() {
	            postDigestCalled = true;
	            fn();
	          });
	        }
	      };
	    }
	
	    // Wait until all directive and route-related templates are downloaded and
	    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
	    // all of the remote templates being currently downloaded. If there are no
	    // templates currently downloading then the watcher will still fire anyway.
	    var deregisterWatch = $rootScope.$watch(
	      function() { return $templateRequest.totalPendingRequests === 0; },
	      function(isEmpty) {
	        if (!isEmpty) return;
	        deregisterWatch();
	
	        // Now that all templates have been downloaded, $animate will wait until
	        // the post digest queue is empty before enabling animations. By having two
	        // calls to $postDigest calls we can ensure that the flag is enabled at the
	        // very end of the post digest queue. Since all of the animations in $animate
	        // use $postDigest, it's important that the code below executes at the end.
	        // This basically means that the page is fully downloaded and compiled before
	        // any animations are triggered.
	        $rootScope.$$postDigest(function() {
	          $rootScope.$$postDigest(function() {
	            // we check for null directly in the event that the application already called
	            // .enabled() with whatever arguments that it provided it with
	            if (animationsEnabled === null) {
	              animationsEnabled = true;
	            }
	          });
	        });
	      }
	    );
	
	    var callbackRegistry = Object.create(null);
	
	    // remember that the `customFilter`/`classNameFilter` are set during the
	    // provider/config stage therefore we can optimize here and setup helper functions
	    var customFilter = $animateProvider.customFilter();
	    var classNameFilter = $animateProvider.classNameFilter();
	    var returnTrue = function() { return true; };
	
	    var isAnimatableByFilter = customFilter || returnTrue;
	    var isAnimatableClassName = !classNameFilter ? returnTrue : function(node, options) {
	      var className = [node.getAttribute('class'), options.addClass, options.removeClass].join(' ');
	      return classNameFilter.test(className);
	    };
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function normalizeAnimationDetails(element, animation) {
	      return mergeAnimationDetails(element, animation, {});
	    }
	
	    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	    var contains = window.Node.prototype.contains || /** @this */ function(arg) {
	      // eslint-disable-next-line no-bitwise
	      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
	    };
	
	    function findCallbacks(targetParentNode, targetNode, event) {
	      var matches = [];
	      var entries = callbackRegistry[event];
	      if (entries) {
	        forEach(entries, function(entry) {
	          if (contains.call(entry.node, targetNode)) {
	            matches.push(entry.callback);
	          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
	            matches.push(entry.callback);
	          }
	        });
	      }
	
	      return matches;
	    }
	
	    function filterFromRegistry(list, matchContainer, matchCallback) {
	      var containerNode = extractElementNode(matchContainer);
	      return list.filter(function(entry) {
	        var isMatch = entry.node === containerNode &&
	                        (!matchCallback || entry.callback === matchCallback);
	        return !isMatch;
	      });
	    }
	
	    function cleanupEventListeners(phase, node) {
	      if (phase === 'close' && !node.parentNode) {
	        // If the element is not attached to a parentNode, it has been removed by
	        // the domOperation, and we can safely remove the event callbacks
	        $animate.off(node);
	      }
	    }
	
	    var $animate = {
	      on: function(event, container, callback) {
	        var node = extractElementNode(container);
	        callbackRegistry[event] = callbackRegistry[event] || [];
	        callbackRegistry[event].push({
	          node: node,
	          callback: callback
	        });
	
	        // Remove the callback when the element is removed from the DOM
	        jqLite(container).on('$destroy', function() {
	          var animationDetails = activeAnimationsLookup.get(node);
	
	          if (!animationDetails) {
	            // If there's an animation ongoing, the callback calling code will remove
	            // the event listeners. If we'd remove here, the callbacks would be removed
	            // before the animation ends
	            $animate.off(event, container, callback);
	          }
	        });
	      },
	
	      off: function(event, container, callback) {
	        if (arguments.length === 1 && !isString(arguments[0])) {
	          container = arguments[0];
	          for (var eventType in callbackRegistry) {
	            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
	          }
	
	          return;
	        }
	
	        var entries = callbackRegistry[event];
	        if (!entries) return;
	
	        callbackRegistry[event] = arguments.length === 1
	            ? null
	            : filterFromRegistry(entries, container, callback);
	      },
	
	      pin: function(element, parentElement) {
	        assertArg(isElement(element), 'element', 'not an element');
	        assertArg(isElement(parentElement), 'parentElement', 'not an element');
	        element.data(NG_ANIMATE_PIN_DATA, parentElement);
	      },
	
	      push: function(element, event, options, domOperation) {
	        options = options || {};
	        options.domOperation = domOperation;
	        return queueAnimation(element, event, options);
	      },
	
	      // this method has four signatures:
	      //  () - global getter
	      //  (bool) - global setter
	      //  (element) - element getter
	      //  (element, bool) - element setter<F37>
	      enabled: function(element, bool) {
	        var argCount = arguments.length;
	
	        if (argCount === 0) {
	          // () - Global getter
	          bool = !!animationsEnabled;
	        } else {
	          var hasElement = isElement(element);
	
	          if (!hasElement) {
	            // (bool) - Global setter
	            bool = animationsEnabled = !!element;
	          } else {
	            var node = getDomNode(element);
	
	            if (argCount === 1) {
	              // (element) - Element getter
	              bool = !disabledElementsLookup.get(node);
	            } else {
	              // (element, bool) - Element setter
	              disabledElementsLookup.set(node, !bool);
	            }
	          }
	        }
	
	        return bool;
	      }
	    };
	
	    return $animate;
	
	    function queueAnimation(originalElement, event, initialOptions) {
	      // we always make a copy of the options since
	      // there should never be any side effects on
	      // the input data when running `$animateCss`.
	      var options = copy(initialOptions);
	
	      var element = stripCommentsFromElement(originalElement);
	      var node = getDomNode(element);
	      var parentNode = node && node.parentNode;
	
	      options = prepareAnimationOptions(options);
	
	      // we create a fake runner with a working promise.
	      // These methods will become available after the digest has passed
	      var runner = new $$AnimateRunner();
	
	      // this is used to trigger callbacks in postDigest mode
	      var runInNextPostDigestOrNow = postDigestTaskFactory();
	
	      if (isArray(options.addClass)) {
	        options.addClass = options.addClass.join(' ');
	      }
	
	      if (options.addClass && !isString(options.addClass)) {
	        options.addClass = null;
	      }
	
	      if (isArray(options.removeClass)) {
	        options.removeClass = options.removeClass.join(' ');
	      }
	
	      if (options.removeClass && !isString(options.removeClass)) {
	        options.removeClass = null;
	      }
	
	      if (options.from && !isObject(options.from)) {
	        options.from = null;
	      }
	
	      if (options.to && !isObject(options.to)) {
	        options.to = null;
	      }
	
	      // If animations are hard-disabled for the whole application there is no need to continue.
	      // There are also situations where a directive issues an animation for a jqLite wrapper that
	      // contains only comment nodes. In this case, there is no way we can perform an animation.
	      if (!animationsEnabled ||
	          !node ||
	          !isAnimatableByFilter(node, event, initialOptions) ||
	          !isAnimatableClassName(node, options)) {
	        close();
	        return runner;
	      }
	
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      var documentHidden = $$isDocumentHidden();
	
	      // This is a hard disable of all animations the element itself, therefore  there is no need to
	      // continue further past this point if not enabled
	      // Animations are also disabled if the document is currently hidden (page is not visible
	      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
	      var skipAnimations = documentHidden || disabledElementsLookup.get(node);
	      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
	      var hasExistingAnimation = !!existingAnimation.state;
	
	      // there is no point in traversing the same collection of parent ancestors if a followup
	      // animation will be run on the same element that already did all that checking work
	      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
	        skipAnimations = !areAnimationsAllowed(node, parentNode, event);
	      }
	
	      if (skipAnimations) {
	        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
	        if (documentHidden) notifyProgress(runner, event, 'start');
	        close();
	        if (documentHidden) notifyProgress(runner, event, 'close');
	        return runner;
	      }
	
	      if (isStructural) {
	        closeChildAnimations(node);
	      }
	
	      var newAnimation = {
	        structural: isStructural,
	        element: element,
	        event: event,
	        addClass: options.addClass,
	        removeClass: options.removeClass,
	        close: close,
	        options: options,
	        runner: runner
	      };
	
	      if (hasExistingAnimation) {
	        var skipAnimationFlag = isAllowed('skip', newAnimation, existingAnimation);
	        if (skipAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            close();
	            return runner;
	          } else {
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	            return existingAnimation.runner;
	          }
	        }
	        var cancelAnimationFlag = isAllowed('cancel', newAnimation, existingAnimation);
	        if (cancelAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            // this will end the animation right away and it is safe
	            // to do so since the animation is already running and the
	            // runner callback code will run in async
	            existingAnimation.runner.end();
	          } else if (existingAnimation.structural) {
	            // this means that the animation is queued into a digest, but
	            // hasn't started yet. Therefore it is safe to run the close
	            // method which will call the runner methods in async.
	            existingAnimation.close();
	          } else {
	            // this will merge the new animation options into existing animation options
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	            return existingAnimation.runner;
	          }
	        } else {
	          // a joined animation means that this animation will take over the existing one
	          // so an example would involve a leave animation taking over an enter. Then when
	          // the postDigest kicks in the enter will be ignored.
	          var joinAnimationFlag = isAllowed('join', newAnimation, existingAnimation);
	          if (joinAnimationFlag) {
	            if (existingAnimation.state === RUNNING_STATE) {
	              normalizeAnimationDetails(element, newAnimation);
	            } else {
	              applyGeneratedPreparationClasses(element, isStructural ? event : null, options);
	
	              event = newAnimation.event = existingAnimation.event;
	              options = mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	              //we return the same runner since only the option values of this animation will
	              //be fed into the `existingAnimation`.
	              return existingAnimation.runner;
	            }
	          }
	        }
	      } else {
	        // normalization in this case means that it removes redundant CSS classes that
	        // already exist (addClass) or do not exist (removeClass) on the element
	        normalizeAnimationDetails(element, newAnimation);
	      }
	
	      // when the options are merged and cleaned up we may end up not having to do
	      // an animation at all, therefore we should check this before issuing a post
	      // digest callback. Structural animations will always run no matter what.
	      var isValidAnimation = newAnimation.structural;
	      if (!isValidAnimation) {
	        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
	        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
	                            || hasAnimationClasses(newAnimation);
	      }
	
	      if (!isValidAnimation) {
	        close();
	        clearElementAnimationState(node);
	        return runner;
	      }
	
	      // the counter keeps track of cancelled animations
	      var counter = (existingAnimation.counter || 0) + 1;
	      newAnimation.counter = counter;
	
	      markElementAnimationState(node, PRE_DIGEST_STATE, newAnimation);
	
	      $rootScope.$$postDigest(function() {
	        // It is possible that the DOM nodes inside `originalElement` have been replaced. This can
	        // happen if the animated element is a transcluded clone and also has a `templateUrl`
	        // directive on it. Therefore, we must recreate `element` in order to interact with the
	        // actual DOM nodes.
	        // Note: We still need to use the old `node` for certain things, such as looking up in
	        //       HashMaps where it was used as the key.
	
	        element = stripCommentsFromElement(originalElement);
	
	        var animationDetails = activeAnimationsLookup.get(node);
	        var animationCancelled = !animationDetails;
	        animationDetails = animationDetails || {};
	
	        // if addClass/removeClass is called before something like enter then the
	        // registered parent element may not be present. The code below will ensure
	        // that a final value for parent element is obtained
	        var parentElement = element.parent() || [];
	
	        // animate/structural/class-based animations all have requirements. Otherwise there
	        // is no point in performing an animation. The parent node must also be set.
	        var isValidAnimation = parentElement.length > 0
	                                && (animationDetails.event === 'animate'
	                                    || animationDetails.structural
	                                    || hasAnimationClasses(animationDetails));
	
	        // this means that the previous animation was cancelled
	        // even if the follow-up animation is the same event
	        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
	          // if another animation did not take over then we need
	          // to make sure that the domOperation and options are
	          // handled accordingly
	          if (animationCancelled) {
	            applyAnimationClasses(element, options);
	            applyAnimationStyles(element, options);
	          }
	
	          // if the event changed from something like enter to leave then we do
	          // it, otherwise if it's the same then the end result will be the same too
	          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
	            options.domOperation();
	            runner.end();
	          }
	
	          // in the event that the element animation was not cancelled or a follow-up animation
	          // isn't allowed to animate from here then we need to clear the state of the element
	          // so that any future animations won't read the expired animation data.
	          if (!isValidAnimation) {
	            clearElementAnimationState(node);
	          }
	
	          return;
	        }
	
	        // this combined multiple class to addClass / removeClass into a setClass event
	        // so long as a structural event did not take over the animation
	        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
	            ? 'setClass'
	            : animationDetails.event;
	
	        markElementAnimationState(node, RUNNING_STATE);
	        var realRunner = $$animation(element, event, animationDetails.options);
	
	        // this will update the runner's flow-control events based on
	        // the `realRunner` object.
	        runner.setHost(realRunner);
	        notifyProgress(runner, event, 'start', {});
	
	        realRunner.done(function(status) {
	          close(!status);
	          var animationDetails = activeAnimationsLookup.get(node);
	          if (animationDetails && animationDetails.counter === counter) {
	            clearElementAnimationState(node);
	          }
	          notifyProgress(runner, event, 'close', {});
	        });
	      });
	
	      return runner;
	
	      function notifyProgress(runner, event, phase, data) {
	        runInNextPostDigestOrNow(function() {
	          var callbacks = findCallbacks(parentNode, node, event);
	          if (callbacks.length) {
	            // do not optimize this call here to RAF because
	            // we don't know how heavy the callback code here will
	            // be and if this code is buffered then this can
	            // lead to a performance regression.
	            $$rAF(function() {
	              forEach(callbacks, function(callback) {
	                callback(element, phase, data);
	              });
	              cleanupEventListeners(phase, node);
	            });
	          } else {
	            cleanupEventListeners(phase, node);
	          }
	        });
	        runner.progress(event, phase, data);
	      }
	
	      function close(reject) {
	        clearGeneratedClasses(element, options);
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	        runner.complete(!reject);
	      }
	    }
	
	    function closeChildAnimations(node) {
	      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
	      forEach(children, function(child) {
	        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
	        var animationDetails = activeAnimationsLookup.get(child);
	        if (animationDetails) {
	          switch (state) {
	            case RUNNING_STATE:
	              animationDetails.runner.end();
	              /* falls through */
	            case PRE_DIGEST_STATE:
	              activeAnimationsLookup.delete(child);
	              break;
	          }
	        }
	      });
	    }
	
	    function clearElementAnimationState(node) {
	      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
	      activeAnimationsLookup.delete(node);
	    }
	
	    /**
	     * This fn returns false if any of the following is true:
	     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
	     * b) a parent element has an ongoing structural animation, and animateChildren is false
	     * c) the element is not a child of the body
	     * d) the element is not a child of the $rootElement
	     */
	    function areAnimationsAllowed(node, parentNode, event) {
	      var bodyNode = $document[0].body;
	      var rootNode = getDomNode($rootElement);
	
	      var bodyNodeDetected = (node === bodyNode) || node.nodeName === 'HTML';
	      var rootNodeDetected = (node === rootNode);
	      var parentAnimationDetected = false;
	      var elementDisabled = disabledElementsLookup.get(node);
	      var animateChildren;
	
	      var parentHost = jqLite.data(node, NG_ANIMATE_PIN_DATA);
	      if (parentHost) {
	        parentNode = getDomNode(parentHost);
	      }
	
	      while (parentNode) {
	        if (!rootNodeDetected) {
	          // angular doesn't want to attempt to animate elements outside of the application
	          // therefore we need to ensure that the rootElement is an ancestor of the current element
	          rootNodeDetected = (parentNode === rootNode);
	        }
	
	        if (parentNode.nodeType !== ELEMENT_NODE) {
	          // no point in inspecting the #document element
	          break;
	        }
	
	        var details = activeAnimationsLookup.get(parentNode) || {};
	        // either an enter, leave or move animation will commence
	        // therefore we can't allow any animations to take place
	        // but if a parent animation is class-based then that's ok
	        if (!parentAnimationDetected) {
	          var parentNodeDisabled = disabledElementsLookup.get(parentNode);
	
	          if (parentNodeDisabled === true && elementDisabled !== false) {
	            // disable animations if the user hasn't explicitly enabled animations on the
	            // current element
	            elementDisabled = true;
	            // element is disabled via parent element, no need to check anything else
	            break;
	          } else if (parentNodeDisabled === false) {
	            elementDisabled = false;
	          }
	          parentAnimationDetected = details.structural;
	        }
	
	        if (isUndefined(animateChildren) || animateChildren === true) {
	          var value = jqLite.data(parentNode, NG_ANIMATE_CHILDREN_DATA);
	          if (isDefined(value)) {
	            animateChildren = value;
	          }
	        }
	
	        // there is no need to continue traversing at this point
	        if (parentAnimationDetected && animateChildren === false) break;
	
	        if (!bodyNodeDetected) {
	          // we also need to ensure that the element is or will be a part of the body element
	          // otherwise it is pointless to even issue an animation to be rendered
	          bodyNodeDetected = (parentNode === bodyNode);
	        }
	
	        if (bodyNodeDetected && rootNodeDetected) {
	          // If both body and root have been found, any other checks are pointless,
	          // as no animation data should live outside the application
	          break;
	        }
	
	        if (!rootNodeDetected) {
	          // If `rootNode` is not detected, check if `parentNode` is pinned to another element
	          parentHost = jqLite.data(parentNode, NG_ANIMATE_PIN_DATA);
	          if (parentHost) {
	            // The pin target element becomes the next parent element
	            parentNode = getDomNode(parentHost);
	            continue;
	          }
	        }
	
	        parentNode = parentNode.parentNode;
	      }
	
	      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
	      return allowAnimation && rootNodeDetected && bodyNodeDetected;
	    }
	
	    function markElementAnimationState(node, state, details) {
	      details = details || {};
	      details.state = state;
	
	      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);
	
	      var oldValue = activeAnimationsLookup.get(node);
	      var newValue = oldValue
	          ? extend(oldValue, details)
	          : details;
	      activeAnimationsLookup.set(node, newValue);
	    }
	  }];
	}];
	
	/* exported $$AnimationProvider */
	
	var $$AnimationProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';
	
	  var drivers = this.drivers = [];
	
	  var RUNNER_STORAGE_KEY = '$$animationRunner';
	
	  function setRunner(element, runner) {
	    element.data(RUNNER_STORAGE_KEY, runner);
	  }
	
	  function removeRunner(element) {
	    element.removeData(RUNNER_STORAGE_KEY);
	  }
	
	  function getRunner(element) {
	    return element.data(RUNNER_STORAGE_KEY);
	  }
	
	  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$Map', '$$rAFScheduler',
	       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$Map,   $$rAFScheduler) {
	
	    var animationQueue = [];
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function sortAnimations(animations) {
	      var tree = { children: [] };
	      var i, lookup = new $$Map();
	
	      // this is done first beforehand so that the map
	      // is filled with a list of the elements that will be animated
	      for (i = 0; i < animations.length; i++) {
	        var animation = animations[i];
	        lookup.set(animation.domNode, animations[i] = {
	          domNode: animation.domNode,
	          fn: animation.fn,
	          children: []
	        });
	      }
	
	      for (i = 0; i < animations.length; i++) {
	        processNode(animations[i]);
	      }
	
	      return flatten(tree);
	
	      function processNode(entry) {
	        if (entry.processed) return entry;
	        entry.processed = true;
	
	        var elementNode = entry.domNode;
	        var parentNode = elementNode.parentNode;
	        lookup.set(elementNode, entry);
	
	        var parentEntry;
	        while (parentNode) {
	          parentEntry = lookup.get(parentNode);
	          if (parentEntry) {
	            if (!parentEntry.processed) {
	              parentEntry = processNode(parentEntry);
	            }
	            break;
	          }
	          parentNode = parentNode.parentNode;
	        }
	
	        (parentEntry || tree).children.push(entry);
	        return entry;
	      }
	
	      function flatten(tree) {
	        var result = [];
	        var queue = [];
	        var i;
	
	        for (i = 0; i < tree.children.length; i++) {
	          queue.push(tree.children[i]);
	        }
	
	        var remainingLevelEntries = queue.length;
	        var nextLevelEntries = 0;
	        var row = [];
	
	        for (i = 0; i < queue.length; i++) {
	          var entry = queue[i];
	          if (remainingLevelEntries <= 0) {
	            remainingLevelEntries = nextLevelEntries;
	            nextLevelEntries = 0;
	            result.push(row);
	            row = [];
	          }
	          row.push(entry.fn);
	          entry.children.forEach(function(childEntry) {
	            nextLevelEntries++;
	            queue.push(childEntry);
	          });
	          remainingLevelEntries--;
	        }
	
	        if (row.length) {
	          result.push(row);
	        }
	
	        return result;
	      }
	    }
	
	    // TODO(matsko): document the signature in a better way
	    return function(element, event, options) {
	      options = prepareAnimationOptions(options);
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      // there is no animation at the current moment, however
	      // these runner methods will get later updated with the
	      // methods leading into the driver's end/cancel methods
	      // for now they just stop the animation from starting
	      var runner = new $$AnimateRunner({
	        end: function() { close(); },
	        cancel: function() { close(true); }
	      });
	
	      if (!drivers.length) {
	        close();
	        return runner;
	      }
	
	      setRunner(element, runner);
	
	      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
	      var tempClasses = options.tempClasses;
	      if (tempClasses) {
	        classes += ' ' + tempClasses;
	        options.tempClasses = null;
	      }
	
	      var prepareClassName;
	      if (isStructural) {
	        prepareClassName = 'ng-' + event + PREPARE_CLASS_SUFFIX;
	        $$jqLite.addClass(element, prepareClassName);
	      }
	
	      animationQueue.push({
	        // this data is used by the postDigest code and passed into
	        // the driver step function
	        element: element,
	        classes: classes,
	        event: event,
	        structural: isStructural,
	        options: options,
	        beforeStart: beforeStart,
	        close: close
	      });
	
	      element.on('$destroy', handleDestroyedElement);
	
	      // we only want there to be one function called within the post digest
	      // block. This way we can group animations for all the animations that
	      // were apart of the same postDigest flush call.
	      if (animationQueue.length > 1) return runner;
	
	      $rootScope.$$postDigest(function() {
	        var animations = [];
	        forEach(animationQueue, function(entry) {
	          // the element was destroyed early on which removed the runner
	          // form its storage. This means we can't animate this element
	          // at all and it already has been closed due to destruction.
	          if (getRunner(entry.element)) {
	            animations.push(entry);
	          } else {
	            entry.close();
	          }
	        });
	
	        // now any future animations will be in another postDigest
	        animationQueue.length = 0;
	
	        var groupedAnimations = groupAnimations(animations);
	        var toBeSortedAnimations = [];
	
	        forEach(groupedAnimations, function(animationEntry) {
	          toBeSortedAnimations.push({
	            domNode: getDomNode(animationEntry.from ? animationEntry.from.element : animationEntry.element),
	            fn: function triggerAnimationStart() {
	              // it's important that we apply the `ng-animate` CSS class and the
	              // temporary classes before we do any driver invoking since these
	              // CSS classes may be required for proper CSS detection.
	              animationEntry.beforeStart();
	
	              var startAnimationFn, closeFn = animationEntry.close;
	
	              // in the event that the element was removed before the digest runs or
	              // during the RAF sequencing then we should not trigger the animation.
	              var targetElement = animationEntry.anchors
	                  ? (animationEntry.from.element || animationEntry.to.element)
	                  : animationEntry.element;
	
	              if (getRunner(targetElement)) {
	                var operation = invokeFirstDriver(animationEntry);
	                if (operation) {
	                  startAnimationFn = operation.start;
	                }
	              }
	
	              if (!startAnimationFn) {
	                closeFn();
	              } else {
	                var animationRunner = startAnimationFn();
	                animationRunner.done(function(status) {
	                  closeFn(!status);
	                });
	                updateAnimationRunners(animationEntry, animationRunner);
	              }
	            }
	          });
	        });
	
	        // we need to sort each of the animations in order of parent to child
	        // relationships. This ensures that the child classes are applied at the
	        // right time.
	        $$rAFScheduler(sortAnimations(toBeSortedAnimations));
	      });
	
	      return runner;
	
	      // TODO(matsko): change to reference nodes
	      function getAnchorNodes(node) {
	        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
	        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
	              ? [node]
	              : node.querySelectorAll(SELECTOR);
	        var anchors = [];
	        forEach(items, function(node) {
	          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
	          if (attr && attr.length) {
	            anchors.push(node);
	          }
	        });
	        return anchors;
	      }
	
	      function groupAnimations(animations) {
	        var preparedAnimations = [];
	        var refLookup = {};
	        forEach(animations, function(animation, index) {
	          var element = animation.element;
	          var node = getDomNode(element);
	          var event = animation.event;
	          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
	          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];
	
	          if (anchorNodes.length) {
	            var direction = enterOrMove ? 'to' : 'from';
	
	            forEach(anchorNodes, function(anchor) {
	              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
	              refLookup[key] = refLookup[key] || {};
	              refLookup[key][direction] = {
	                animationID: index,
	                element: jqLite(anchor)
	              };
	            });
	          } else {
	            preparedAnimations.push(animation);
	          }
	        });
	
	        var usedIndicesLookup = {};
	        var anchorGroups = {};
	        forEach(refLookup, function(operations, key) {
	          var from = operations.from;
	          var to = operations.to;
	
	          if (!from || !to) {
	            // only one of these is set therefore we can't have an
	            // anchor animation since all three pieces are required
	            var index = from ? from.animationID : to.animationID;
	            var indexKey = index.toString();
	            if (!usedIndicesLookup[indexKey]) {
	              usedIndicesLookup[indexKey] = true;
	              preparedAnimations.push(animations[index]);
	            }
	            return;
	          }
	
	          var fromAnimation = animations[from.animationID];
	          var toAnimation = animations[to.animationID];
	          var lookupKey = from.animationID.toString();
	          if (!anchorGroups[lookupKey]) {
	            var group = anchorGroups[lookupKey] = {
	              structural: true,
	              beforeStart: function() {
	                fromAnimation.beforeStart();
	                toAnimation.beforeStart();
	              },
	              close: function() {
	                fromAnimation.close();
	                toAnimation.close();
	              },
	              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
	              from: fromAnimation,
	              to: toAnimation,
	              anchors: [] // TODO(matsko): change to reference nodes
	            };
	
	            // the anchor animations require that the from and to elements both have at least
	            // one shared CSS class which effectively marries the two elements together to use
	            // the same animation driver and to properly sequence the anchor animation.
	            if (group.classes.length) {
	              preparedAnimations.push(group);
	            } else {
	              preparedAnimations.push(fromAnimation);
	              preparedAnimations.push(toAnimation);
	            }
	          }
	
	          anchorGroups[lookupKey].anchors.push({
	            'out': from.element, 'in': to.element
	          });
	        });
	
	        return preparedAnimations;
	      }
	
	      function cssClassesIntersection(a,b) {
	        a = a.split(' ');
	        b = b.split(' ');
	        var matches = [];
	
	        for (var i = 0; i < a.length; i++) {
	          var aa = a[i];
	          if (aa.substring(0,3) === 'ng-') continue;
	
	          for (var j = 0; j < b.length; j++) {
	            if (aa === b[j]) {
	              matches.push(aa);
	              break;
	            }
	          }
	        }
	
	        return matches.join(' ');
	      }
	
	      function invokeFirstDriver(animationDetails) {
	        // we loop in reverse order since the more general drivers (like CSS and JS)
	        // may attempt more elements, but custom drivers are more particular
	        for (var i = drivers.length - 1; i >= 0; i--) {
	          var driverName = drivers[i];
	          var factory = $injector.get(driverName);
	          var driver = factory(animationDetails);
	          if (driver) {
	            return driver;
	          }
	        }
	      }
	
	      function beforeStart() {
	        element.addClass(NG_ANIMATE_CLASSNAME);
	        if (tempClasses) {
	          $$jqLite.addClass(element, tempClasses);
	        }
	        if (prepareClassName) {
	          $$jqLite.removeClass(element, prepareClassName);
	          prepareClassName = null;
	        }
	      }
	
	      function updateAnimationRunners(animation, newRunner) {
	        if (animation.from && animation.to) {
	          update(animation.from.element);
	          update(animation.to.element);
	        } else {
	          update(animation.element);
	        }
	
	        function update(element) {
	          var runner = getRunner(element);
	          if (runner) runner.setHost(newRunner);
	        }
	      }
	
	      function handleDestroyedElement() {
	        var runner = getRunner(element);
	        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
	          runner.end();
	        }
	      }
	
	      function close(rejected) {
	        element.off('$destroy', handleDestroyedElement);
	        removeRunner(element);
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	
	        if (tempClasses) {
	          $$jqLite.removeClass(element, tempClasses);
	        }
	
	        element.removeClass(NG_ANIMATE_CLASSNAME);
	        runner.complete(!rejected);
	      }
	    };
	  }];
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateSwap
	 * @restrict A
	 * @scope
	 *
	 * @description
	 *
	 * ngAnimateSwap is a animation-oriented directive that allows for the container to
	 * be removed and entered in whenever the associated expression changes. A
	 * common usecase for this directive is a rotating banner or slider component which
	 * contains one image being present at a time. When the active image changes
	 * then the old image will perform a `leave` animation and the new element
	 * will be inserted via an `enter` animation.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|--------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
	 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
	 *
	 * @example
	 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
	 *          deps="angular-animate.js"
	 *          animations="true" fixBase="true">
	 *   <file name="index.html">
	 *     <div class="container" ng-controller="AppCtrl">
	 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
	 *         {{ number }}
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="script.js">
	 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
	 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
	 *         $scope.number = 0;
	 *         $interval(function() {
	 *           $scope.number++;
	 *         }, 1000);
	 *
	 *         var colors = ['red','blue','green','yellow','orange'];
	 *         $scope.colorClass = function(number) {
	 *           return colors[number % colors.length];
	 *         };
	 *       }]);
	 *   </file>
	 *  <file name="animations.css">
	 *  .container {
	 *    height:250px;
	 *    width:250px;
	 *    position:relative;
	 *    overflow:hidden;
	 *    border:2px solid black;
	 *  }
	 *  .container .cell {
	 *    font-size:150px;
	 *    text-align:center;
	 *    line-height:250px;
	 *    position:absolute;
	 *    top:0;
	 *    left:0;
	 *    right:0;
	 *    border-bottom:2px solid black;
	 *  }
	 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
	 *    transition:0.5s linear all;
	 *  }
	 *  .swap-animation.ng-enter {
	 *    top:-250px;
	 *  }
	 *  .swap-animation.ng-enter-active {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave-active {
	 *    top:250px;
	 *  }
	 *  .red { background:red; }
	 *  .green { background:green; }
	 *  .blue { background:blue; }
	 *  .yellow { background:yellow; }
	 *  .orange { background:orange; }
	 *  </file>
	 * </example>
	 */
	var ngAnimateSwapDirective = ['$animate', '$rootScope', function($animate, $rootScope) {
	  return {
	    restrict: 'A',
	    transclude: 'element',
	    terminal: true,
	    priority: 600, // we use 600 here to ensure that the directive is caught before others
	    link: function(scope, $element, attrs, ctrl, $transclude) {
	      var previousElement, previousScope;
	      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
	        if (previousElement) {
	          $animate.leave(previousElement);
	        }
	        if (previousScope) {
	          previousScope.$destroy();
	          previousScope = null;
	        }
	        if (value || value === 0) {
	          previousScope = scope.$new();
	          $transclude(previousScope, function(element) {
	            previousElement = element;
	            $animate.enter(element, null, $element);
	          });
	        }
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc module
	 * @name ngAnimate
	 * @description
	 *
	 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
	 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an Angular app.
	 *
	 * <div doc-module-components="ngAnimate"></div>
	 *
	 * # Usage
	 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
	 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
	 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
	 * the HTML element that the animation will be triggered on.
	 *
	 * ## Directive Support
	 * The following directives are "animation aware":
	 *
	 * | Directive                                                                                                | Supported Animations                                                     |
	 * |----------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------------|
	 * | {@link ng.directive:ngRepeat#animations ngRepeat}                                                        | enter, leave and move                                                    |
	 * | {@link ngRoute.directive:ngView#animations ngView}                                                       | enter and leave                                                          |
	 * | {@link ng.directive:ngInclude#animations ngInclude}                                                      | enter and leave                                                          |
	 * | {@link ng.directive:ngSwitch#animations ngSwitch}                                                        | enter and leave                                                          |
	 * | {@link ng.directive:ngIf#animations ngIf}                                                                | enter and leave                                                          |
	 * | {@link ng.directive:ngClass#animations ngClass}                                                          | add and remove (the CSS class(es) present)                               |
	 * | {@link ng.directive:ngShow#animations ngShow} & {@link ng.directive:ngHide#animations ngHide}            | add and remove (the ng-hide class value)                                 |
	 * | {@link ng.directive:form#animation-hooks form} & {@link ng.directive:ngModel#animation-hooks ngModel}    | add and remove (dirty, pristine, valid, invalid & all other validations) |
	 * | {@link module:ngMessages#animations ngMessages}                                                          | add and remove (ng-active & ng-inactive)                                 |
	 * | {@link module:ngMessages#animations ngMessage}                                                           | enter and leave                                                          |
	 *
	 * (More information can be found by visiting each the documentation associated with each directive.)
	 *
	 * ## CSS-based Animations
	 *
	 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
	 * and CSS code we can create an animation that will be picked up by Angular when an underlying directive performs an operation.
	 *
	 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
	 *
	 * ```html
	 * <div ng-if="bool" class="fade">
	 *    Fade me in out
	 * </div>
	 * <button ng-click="bool=true">Fade In!</button>
	 * <button ng-click="bool=false">Fade Out!</button>
	 * ```
	 *
	 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
	 *
	 * ```css
	 * /&#42; The starting CSS styles for the enter animation &#42;/
	 * .fade.ng-enter {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 *
	 * /&#42; The finishing CSS styles for the enter animation &#42;/
	 * .fade.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
	 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
	 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
	 *
	 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
	 *
	 * ```css
	 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
	 * .fade.ng-leave {
	 *   transition:0.5s linear all;
	 *   opacity:1;
	 * }
	 * .fade.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
	 *
	 * ```css
	 * /&#42; there is no need to define anything inside of the destination
	 * CSS class since the keyframe will take charge of the animation &#42;/
	 * .fade.ng-leave {
	 *   animation: my_fade_animation 0.5s linear;
	 *   -webkit-animation: my_fade_animation 0.5s linear;
	 * }
	 *
	 * @keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 *
	 * @-webkit-keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 * ```
	 *
	 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
	 *
	 * ### CSS Class-based Animations
	 *
	 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
	 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
	 * and removed.
	 *
	 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
	 *
	 * ```html
	 * <div ng-show="bool" class="fade">
	 *   Show and hide me
	 * </div>
	 * <button ng-click="bool=!bool">Toggle</button>
	 *
	 * <style>
	 * .fade.ng-hide {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 * </style>
	 * ```
	 *
	 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
	 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
	 *
	 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
	 * with CSS styles.
	 *
	 * ```html
	 * <div ng-class="{on:onOff}" class="highlight">
	 *   Highlight this box
	 * </div>
	 * <button ng-click="onOff=!onOff">Toggle</button>
	 *
	 * <style>
	 * .highlight {
	 *   transition:0.5s linear all;
	 * }
	 * .highlight.on-add {
	 *   background:white;
	 * }
	 * .highlight.on {
	 *   background:yellow;
	 * }
	 * .highlight.on-remove {
	 *   background:black;
	 * }
	 * </style>
	 * ```
	 *
	 * We can also make use of CSS keyframes by placing them within the CSS classes.
	 *
	 *
	 * ### CSS Staggering Animations
	 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
	 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
	 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
	 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
	 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
	 *
	 * ```css
	 * .my-animation.ng-enter {
	 *   /&#42; standard transition code &#42;/
	 *   transition: 1s linear all;
	 *   opacity:0;
	 * }
	 * .my-animation.ng-enter-stagger {
	 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
	 *   transition-delay: 0.1s;
	 *
	 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
	 *     to not accidentally inherit a delay property from another CSS class &#42;/
	 *   transition-duration: 0s;
	 *
	 *   /&#42; if you are using animations instead of transitions you should configure as follows:
	 *     animation-delay: 0.1s;
	 *     animation-duration: 0s; &#42;/
	 * }
	 * .my-animation.ng-enter.ng-enter-active {
	 *   /&#42; standard transition styles &#42;/
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
	 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
	 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
	 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
	 *
	 * The following code will issue the **ng-leave-stagger** event on the element provided:
	 *
	 * ```js
	 * var kids = parent.children();
	 *
	 * $animate.leave(kids[0]); //stagger index=0
	 * $animate.leave(kids[1]); //stagger index=1
	 * $animate.leave(kids[2]); //stagger index=2
	 * $animate.leave(kids[3]); //stagger index=3
	 * $animate.leave(kids[4]); //stagger index=4
	 *
	 * window.requestAnimationFrame(function() {
	 *   //stagger has reset itself
	 *   $animate.leave(kids[5]); //stagger index=0
	 *   $animate.leave(kids[6]); //stagger index=1
	 *
	 *   $scope.$digest();
	 * });
	 * ```
	 *
	 * Stagger animations are currently only supported within CSS-defined animations.
	 *
	 * ### The `ng-animate` CSS class
	 *
	 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
	 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
	 *
	 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
	 *
	 * ```css
	 * .zipper.ng-animate {
	 *   transition:0.5s linear all;
	 * }
	 * .zipper.ng-enter {
	 *   opacity:0;
	 * }
	 * .zipper.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
	 * the CSS class once an animation has completed.)
	 *
	 *
	 * ### The `ng-[event]-prepare` class
	 *
	 * This is a special class that can be used to prevent unwanted flickering / flash of content before
	 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
	 * before the actual animation starts (after waiting for a $digest).
	 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
	 *
	 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
	 * into elements that have class-based animations such as `ngClass`.
	 *
	 * ```html
	 * <div ng-class="{red: myProp}">
	 *   <div ng-class="{blue: myProp}">
	 *     <div class="message" ng-if="myProp"></div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
	 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
	 *
	 * ```css
	 * .message.ng-enter-prepare {
	 *   opacity: 0;
	 * }
	 *
	 * ```
	 *
	 * ## JavaScript-based Animations
	 *
	 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
	 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
	 * `module.animation()` module function we can register the animation.
	 *
	 * Let's see an example of a enter/leave animation using `ngRepeat`:
	 *
	 * ```html
	 * <div ng-repeat="item in items" class="slide">
	 *   {{ item }}
	 * </div>
	 * ```
	 *
	 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     // make note that other events (like addClass/removeClass)
	 *     // have different function input parameters
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *
	 *       // remember to call doneFn so that angular
	 *       // knows that the animation has concluded
	 *     },
	 *
	 *     move: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *     },
	 *
	 *     leave: function(element, doneFn) {
	 *       jQuery(element).fadeOut(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
	 * greensock.js and velocity.js.
	 *
	 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
	 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
	 *
	 * ```html
	 * <div ng-class="color" class="colorful">
	 *   this box is moody
	 * </div>
	 * <button ng-click="color='red'">Change to red</button>
	 * <button ng-click="color='blue'">Change to blue</button>
	 * <button ng-click="color='green'">Change to green</button>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.colorful', [function() {
	 *   return {
	 *     addClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     removeClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     setClass: function(element, addedClass, removedClass, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## CSS + JS Animations Together
	 *
	 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of Angular,
	 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
	 * charge of the animation**:
	 *
	 * ```html
	 * <div ng-if="bool" class="slide">
	 *   Slide in and out
	 * </div>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).slideIn(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ```css
	 * .slide.ng-enter {
	 *   transition:0.5s linear all;
	 *   transform:translateY(-100px);
	 * }
	 * .slide.ng-enter.ng-enter-active {
	 *   transform:translateY(0);
	 * }
	 * ```
	 *
	 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
	 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
	 * our own JS-based animation code:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
	 *
	 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
	 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
	 * data into `$animateCss` directly:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true,
	 *         addClass: 'maroon-setting',
	 *         from: { height:0 },
	 *         to: { height: 200 }
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Now we can fill in the rest via our transition CSS code:
	 *
	 * ```css
	 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
	 * .slide.ng-enter { transition:0.5s linear all; }
	 *
	 * /&#42; this extra CSS class will be absorbed into the transition
	 * since the $animateCss code is adding the class &#42;/
	 * .maroon-setting { background:red; }
	 * ```
	 *
	 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
	 *
	 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
	 *
	 * ## Animation Anchoring (via `ng-animate-ref`)
	 *
	 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
	 * structural areas of an application (like views) by pairing up elements using an attribute
	 * called `ng-animate-ref`.
	 *
	 * Let's say for example we have two views that are managed by `ng-view` and we want to show
	 * that there is a relationship between two components situated in within these views. By using the
	 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
	 * can then attach an animation, which is triggered when the view changes.
	 *
	 * Say for example we have the following template code:
	 *
	 * ```html
	 * <!-- index.html -->
	 * <div ng-view class="view-animation">
	 * </div>
	 *
	 * <!-- home.html -->
	 * <a href="#/banner-page">
	 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * </a>
	 *
	 * <!-- banner-page.html -->
	 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * ```
	 *
	 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
	 * HTML contents to see if there is a match reference between any components in the view
	 * that is leaving and the view that is entering. It will scan both the view which is being
	 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
	 * contain a matching ref value.
	 *
	 * The two images match since they share the same ref value. ngAnimate will now create a
	 * transport element (which is a clone of the first image element) and it will then attempt
	 * to animate to the position of the second image element in the next view. For the animation to
	 * work a special CSS class called `ng-anchor` will be added to the transported element.
	 *
	 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
	 * ngAnimate will handle the entire transition for us as well as the addition and removal of
	 * any changes of CSS classes between the elements:
	 *
	 * ```css
	 * .banner.ng-anchor {
	 *   /&#42; this animation will last for 1 second since there are
	 *          two phases to the animation (an `in` and an `out` phase) &#42;/
	 *   transition:0.5s linear all;
	 * }
	 * ```
	 *
	 * We also **must** include animations for the views that are being entered and removed
	 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
	 *
	 * ```css
	 * .view-animation.ng-enter, .view-animation.ng-leave {
	 *   transition:0.5s linear all;
	 *   position:fixed;
	 *   left:0;
	 *   top:0;
	 *   width:100%;
	 * }
	 * .view-animation.ng-enter {
	 *   transform:translateX(100%);
	 * }
	 * .view-animation.ng-leave,
	 * .view-animation.ng-enter.ng-enter-active {
	 *   transform:translateX(0%);
	 * }
	 * .view-animation.ng-leave.ng-leave-active {
	 *   transform:translateX(-100%);
	 * }
	 * ```
	 *
	 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
	 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
	 * from its origin. Once that animation is over then the `in` stage occurs which animates the
	 * element to its destination. The reason why there are two animations is to give enough time
	 * for the enter animation on the new element to be ready.
	 *
	 * The example above sets up a transition for both the in and out phases, but we can also target the out or
	 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
	 *
	 * ```css
	 * .banner.ng-anchor-out {
	 *   transition: 0.5s linear all;
	 *
	 *   /&#42; the scale will be applied during the out animation,
	 *          but will be animated away when the in animation runs &#42;/
	 *   transform: scale(1.2);
	 * }
	 *
	 * .banner.ng-anchor-in {
	 *   transition: 1s linear all;
	 * }
	 * ```
	 *
	 *
	 *
	 *
	 * ### Anchoring Demo
	 *
	  <example module="anchoringExample"
	           name="anchoringExample"
	           id="anchoringExample"
	           deps="angular-animate.js;angular-route.js"
	           animations="true">
	    <file name="index.html">
	      <a href="#!/">Home</a>
	      <hr />
	      <div class="view-container">
	        <div ng-view class="view"></div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
	        .config(['$routeProvider', function($routeProvider) {
	          $routeProvider.when('/', {
	            templateUrl: 'home.html',
	            controller: 'HomeController as home'
	          });
	          $routeProvider.when('/profile/:id', {
	            templateUrl: 'profile.html',
	            controller: 'ProfileController as profile'
	          });
	        }])
	        .run(['$rootScope', function($rootScope) {
	          $rootScope.records = [
	            { id: 1, title: 'Miss Beulah Roob' },
	            { id: 2, title: 'Trent Morissette' },
	            { id: 3, title: 'Miss Ava Pouros' },
	            { id: 4, title: 'Rod Pouros' },
	            { id: 5, title: 'Abdul Rice' },
	            { id: 6, title: 'Laurie Rutherford Sr.' },
	            { id: 7, title: 'Nakia McLaughlin' },
	            { id: 8, title: 'Jordon Blanda DVM' },
	            { id: 9, title: 'Rhoda Hand' },
	            { id: 10, title: 'Alexandrea Sauer' }
	          ];
	        }])
	        .controller('HomeController', [function() {
	          //empty
	        }])
	        .controller('ProfileController', ['$rootScope', '$routeParams',
	            function ProfileController($rootScope, $routeParams) {
	          var index = parseInt($routeParams.id, 10);
	          var record = $rootScope.records[index - 1];
	
	          this.title = record.title;
	          this.id = record.id;
	        }]);
	    </file>
	    <file name="home.html">
	      <h2>Welcome to the home page</h1>
	      <p>Please click on an element</p>
	      <a class="record"
	         ng-href="#!/profile/{{ record.id }}"
	         ng-animate-ref="{{ record.id }}"
	         ng-repeat="record in records">
	        {{ record.title }}
	      </a>
	    </file>
	    <file name="profile.html">
	      <div class="profile record" ng-animate-ref="{{ profile.id }}">
	        {{ profile.title }}
	      </div>
	    </file>
	    <file name="animations.css">
	      .record {
	        display:block;
	        font-size:20px;
	      }
	      .profile {
	        background:black;
	        color:white;
	        font-size:100px;
	      }
	      .view-container {
	        position:relative;
	      }
	      .view-container > .view.ng-animate {
	        position:absolute;
	        top:0;
	        left:0;
	        width:100%;
	        min-height:500px;
	      }
	      .view.ng-enter, .view.ng-leave,
	      .record.ng-anchor {
	        transition:0.5s linear all;
	      }
	      .view.ng-enter {
	        transform:translateX(100%);
	      }
	      .view.ng-enter.ng-enter-active, .view.ng-leave {
	        transform:translateX(0%);
	      }
	      .view.ng-leave.ng-leave-active {
	        transform:translateX(-100%);
	      }
	      .record.ng-anchor-out {
	        background:red;
	      }
	    </file>
	  </example>
	 *
	 * ### How is the element transported?
	 *
	 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
	 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
	 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
	 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
	 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
	 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
	 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
	 * will become visible since the shim class will be removed.
	 *
	 * ### How is the morphing handled?
	 *
	 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
	 * what CSS classes differ between the starting element and the destination element. These different CSS classes
	 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
	 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
	 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
	 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
	 * the cloned element is placed inside of root element which is likely close to the body element).
	 *
	 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
	 *
	 *
	 * ## Using $animate in your directive code
	 *
	 * So far we've explored how to feed in animations into an Angular application, but how do we trigger animations within our own directives in our application?
	 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
	 * imagine we have a greeting box that shows and hides itself when the data changes
	 *
	 * ```html
	 * <greeting-box active="onOrOff">Hi there</greeting-box>
	 * ```
	 *
	 * ```js
	 * ngModule.directive('greetingBox', ['$animate', function($animate) {
	 *   return function(scope, element, attrs) {
	 *     attrs.$observe('active', function(value) {
	 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
	 *     });
	 *   });
	 * }]);
	 * ```
	 *
	 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
	 * in our HTML code then we can trigger a CSS or JS animation to happen.
	 *
	 * ```css
	 * /&#42; normally we would create a CSS class to reference on the element &#42;/
	 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
	 * ```
	 *
	 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
	 * possible be sure to visit the {@link ng.$animate $animate service API page}.
	 *
	 *
	 * ## Callbacks and Promises
	 *
	 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
	 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
	 * ended by chaining onto the returned promise that animation method returns.
	 *
	 * ```js
	 * // somewhere within the depths of the directive
	 * $animate.enter(element, parent).then(function() {
	 *   //the animation has completed
	 * });
	 * ```
	 *
	 * (Note that earlier versions of Angular prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
	 * anymore.)
	 *
	 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
	 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
	 * routing controller to hook into that:
	 *
	 * ```js
	 * ngModule.controller('HomePageController', ['$animate', function($animate) {
	 *   $animate.on('enter', ngViewElement, function(element) {
	 *     // the animation for this route has completed
	 *   }]);
	 * }])
	 * ```
	 *
	 * (Note that you will need to trigger a digest within the callback to get angular to notice any scope-related changes.)
	 */
	
	var copy;
	var extend;
	var forEach;
	var isArray;
	var isDefined;
	var isElement;
	var isFunction;
	var isObject;
	var isString;
	var isUndefined;
	var jqLite;
	var noop;
	
	/**
	 * @ngdoc service
	 * @name $animate
	 * @kind object
	 *
	 * @description
	 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
	 *
	 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
	 */
	angular.module('ngAnimate', [], function initAngularHelpers() {
	  // Access helpers from angular core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  noop        = angular.noop;
	  copy        = angular.copy;
	  extend      = angular.extend;
	  jqLite      = angular.element;
	  forEach     = angular.forEach;
	  isArray     = angular.isArray;
	  isString    = angular.isString;
	  isObject    = angular.isObject;
	  isUndefined = angular.isUndefined;
	  isDefined   = angular.isDefined;
	  isFunction  = angular.isFunction;
	  isElement   = angular.isElement;
	})
	  .info({ angularVersion: '1.6.6' })
	  .directive('ngAnimateSwap', ngAnimateSwapDirective)
	
	  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
	  .factory('$$rAFScheduler', $$rAFSchedulerFactory)
	
	  .provider('$$animateQueue', $$AnimateQueueProvider)
	  .provider('$$animation', $$AnimationProvider)
	
	  .provider('$animateCss', $AnimateCssProvider)
	  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)
	
	  .provider('$$animateJs', $$AnimateJsProvider)
	  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);
	
	
	})(window, window.angular);


/***/ },

/***/ 123:
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.6.6
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngAria
	 * @description
	 *
	 * The `ngAria` module provides support for common
	 * [<abbr title="Accessible Rich Internet Applications">ARIA</abbr>](http://www.w3.org/TR/wai-aria/)
	 * attributes that convey state or semantic information about the application for users
	 * of assistive technologies, such as screen readers.
	 *
	 * <div doc-module-components="ngAria"></div>
	 *
	 * ## Usage
	 *
	 * For ngAria to do its magic, simply include the module `ngAria` as a dependency. The following
	 * directives are supported:
	 * `ngModel`, `ngChecked`, `ngReadonly`, `ngRequired`, `ngValue`, `ngDisabled`, `ngShow`, `ngHide`, `ngClick`,
	 * `ngDblClick`, and `ngMessages`.
	 *
	 * Below is a more detailed breakdown of the attributes handled by ngAria:
	 *
	 * | Directive                                   | Supported Attributes                                                                                |
	 * |---------------------------------------------|-----------------------------------------------------------------------------------------------------|
	 * | {@link ng.directive:ngModel ngModel}        | aria-checked, aria-valuemin, aria-valuemax, aria-valuenow, aria-invalid, aria-required, input roles |
	 * | {@link ng.directive:ngDisabled ngDisabled}  | aria-disabled                                                                                       |
	 * | {@link ng.directive:ngRequired ngRequired}  | aria-required                                                                                       |
	 * | {@link ng.directive:ngChecked ngChecked}    | aria-checked                                                                                        |
	 * | {@link ng.directive:ngReadonly ngReadonly}  | aria-readonly                                                                                       |
	 * | {@link ng.directive:ngValue ngValue}        | aria-checked                                                                                        |
	 * | {@link ng.directive:ngShow ngShow}          | aria-hidden                                                                                         |
	 * | {@link ng.directive:ngHide ngHide}          | aria-hidden                                                                                         |
	 * | {@link ng.directive:ngDblclick ngDblclick}  | tabindex                                                                                            |
	 * | {@link module:ngMessages ngMessages}        | aria-live                                                                                           |
	 * | {@link ng.directive:ngClick ngClick}        | tabindex, keydown event, button role                                                                |
	 *
	 * Find out more information about each directive by reading the
	 * {@link guide/accessibility ngAria Developer Guide}.
	 *
	 * ## Example
	 * Using ngDisabled with ngAria:
	 * ```html
	 * <md-checkbox ng-disabled="disabled">
	 * ```
	 * Becomes:
	 * ```html
	 * <md-checkbox ng-disabled="disabled" aria-disabled="true">
	 * ```
	 *
	 * ## Disabling Attributes
	 * It's possible to disable individual attributes added by ngAria with the
	 * {@link ngAria.$ariaProvider#config config} method. For more details, see the
	 * {@link guide/accessibility Developer Guide}.
	 */
	var ngAriaModule = angular.module('ngAria', ['ng']).
	                        info({ angularVersion: '1.6.6' }).
	                        provider('$aria', $AriaProvider);
	
	/**
	* Internal Utilities
	*/
	var nodeBlackList = ['BUTTON', 'A', 'INPUT', 'TEXTAREA', 'SELECT', 'DETAILS', 'SUMMARY'];
	
	var isNodeOneOf = function(elem, nodeTypeArray) {
	  if (nodeTypeArray.indexOf(elem[0].nodeName) !== -1) {
	    return true;
	  }
	};
	/**
	 * @ngdoc provider
	 * @name $ariaProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the ARIA attributes injected and managed by ngAria.
	 *
	 * ```js
	 * angular.module('myApp', ['ngAria'], function config($ariaProvider) {
	 *   $ariaProvider.config({
	 *     ariaValue: true,
	 *     tabindex: false
	 *   });
	 * });
	 *```
	 *
	 * ## Dependencies
	 * Requires the {@link ngAria} module to be installed.
	 *
	 */
	function $AriaProvider() {
	  var config = {
	    ariaHidden: true,
	    ariaChecked: true,
	    ariaReadonly: true,
	    ariaDisabled: true,
	    ariaRequired: true,
	    ariaInvalid: true,
	    ariaValue: true,
	    tabindex: true,
	    bindKeydown: true,
	    bindRoleForClick: true
	  };
	
	  /**
	   * @ngdoc method
	   * @name $ariaProvider#config
	   *
	   * @param {object} config object to enable/disable specific ARIA attributes
	   *
	   *  - **ariaHidden** – `{boolean}` – Enables/disables aria-hidden tags
	   *  - **ariaChecked** – `{boolean}` – Enables/disables aria-checked tags
	   *  - **ariaReadonly** – `{boolean}` – Enables/disables aria-readonly tags
	   *  - **ariaDisabled** – `{boolean}` – Enables/disables aria-disabled tags
	   *  - **ariaRequired** – `{boolean}` – Enables/disables aria-required tags
	   *  - **ariaInvalid** – `{boolean}` – Enables/disables aria-invalid tags
	   *  - **ariaValue** – `{boolean}` – Enables/disables aria-valuemin, aria-valuemax and
	   *    aria-valuenow tags
	   *  - **tabindex** – `{boolean}` – Enables/disables tabindex tags
	   *  - **bindKeydown** – `{boolean}` – Enables/disables keyboard event binding on non-interactive
	   *    elements (such as `div` or `li`) using ng-click, making them more accessible to users of
	   *    assistive technologies
	   *  - **bindRoleForClick** – `{boolean}` – Adds role=button to non-interactive elements (such as
	   *    `div` or `li`) using ng-click, making them more accessible to users of assistive
	   *    technologies
	   *
	   * @description
	   * Enables/disables various ARIA attributes
	   */
	  this.config = function(newConfig) {
	    config = angular.extend(config, newConfig);
	  };
	
	  function watchExpr(attrName, ariaAttr, nodeBlackList, negate) {
	    return function(scope, elem, attr) {
	      var ariaCamelName = attr.$normalize(ariaAttr);
	      if (config[ariaCamelName] && !isNodeOneOf(elem, nodeBlackList) && !attr[ariaCamelName]) {
	        scope.$watch(attr[attrName], function(boolVal) {
	          // ensure boolean value
	          boolVal = negate ? !boolVal : !!boolVal;
	          elem.attr(ariaAttr, boolVal);
	        });
	      }
	    };
	  }
	  /**
	   * @ngdoc service
	   * @name $aria
	   *
	   * @description
	   * @priority 200
	   *
	   * The $aria service contains helper methods for applying common
	   * [ARIA](http://www.w3.org/TR/wai-aria/) attributes to HTML directives.
	   *
	   * ngAria injects common accessibility attributes that tell assistive technologies when HTML
	   * elements are enabled, selected, hidden, and more. To see how this is performed with ngAria,
	   * let's review a code snippet from ngAria itself:
	   *
	   *```js
	   * ngAriaModule.directive('ngDisabled', ['$aria', function($aria) {
	   *   return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
	   * }])
	   *```
	   * Shown above, the ngAria module creates a directive with the same signature as the
	   * traditional `ng-disabled` directive. But this ngAria version is dedicated to
	   * solely managing accessibility attributes on custom elements. The internal `$aria` service is
	   * used to watch the boolean attribute `ngDisabled`. If it has not been explicitly set by the
	   * developer, `aria-disabled` is injected as an attribute with its value synchronized to the
	   * value in `ngDisabled`.
	   *
	   * Because ngAria hooks into the `ng-disabled` directive, developers do not have to do
	   * anything to enable this feature. The `aria-disabled` attribute is automatically managed
	   * simply as a silent side-effect of using `ng-disabled` with the ngAria module.
	   *
	   * The full list of directives that interface with ngAria:
	   * * **ngModel**
	   * * **ngChecked**
	   * * **ngReadonly**
	   * * **ngRequired**
	   * * **ngDisabled**
	   * * **ngValue**
	   * * **ngShow**
	   * * **ngHide**
	   * * **ngClick**
	   * * **ngDblclick**
	   * * **ngMessages**
	   *
	   * Read the {@link guide/accessibility ngAria Developer Guide} for a thorough explanation of each
	   * directive.
	   *
	   *
	   * ## Dependencies
	   * Requires the {@link ngAria} module to be installed.
	   */
	  this.$get = function() {
	    return {
	      config: function(key) {
	        return config[key];
	      },
	      $$watchExpr: watchExpr
	    };
	  };
	}
	
	
	ngAriaModule.directive('ngShow', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngShow', 'aria-hidden', [], true);
	}])
	.directive('ngHide', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngHide', 'aria-hidden', [], false);
	}])
	.directive('ngValue', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngValue', 'aria-checked', nodeBlackList, false);
	}])
	.directive('ngChecked', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngChecked', 'aria-checked', nodeBlackList, false);
	}])
	.directive('ngReadonly', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngReadonly', 'aria-readonly', nodeBlackList, false);
	}])
	.directive('ngRequired', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngRequired', 'aria-required', nodeBlackList, false);
	}])
	.directive('ngModel', ['$aria', function($aria) {
	
	  function shouldAttachAttr(attr, normalizedAttr, elem, allowBlacklistEls) {
	    return $aria.config(normalizedAttr) && !elem.attr(attr) && (allowBlacklistEls || !isNodeOneOf(elem, nodeBlackList));
	  }
	
	  function shouldAttachRole(role, elem) {
	    // if element does not have role attribute
	    // AND element type is equal to role (if custom element has a type equaling shape) <-- remove?
	    // AND element is not in nodeBlackList
	    return !elem.attr('role') && (elem.attr('type') === role) && !isNodeOneOf(elem, nodeBlackList);
	  }
	
	  function getShape(attr, elem) {
	    var type = attr.type,
	        role = attr.role;
	
	    return ((type || role) === 'checkbox' || role === 'menuitemcheckbox') ? 'checkbox' :
	           ((type || role) === 'radio'    || role === 'menuitemradio') ? 'radio' :
	           (type === 'range'              || role === 'progressbar' || role === 'slider') ? 'range' : '';
	  }
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    priority: 200, //Make sure watches are fired after any other directives that affect the ngModel value
	    compile: function(elem, attr) {
	      var shape = getShape(attr, elem);
	
	      return {
	        post: function(scope, elem, attr, ngModel) {
	          var needsTabIndex = shouldAttachAttr('tabindex', 'tabindex', elem, false);
	
	          function ngAriaWatchModelValue() {
	            return ngModel.$modelValue;
	          }
	
	          function getRadioReaction(newVal) {
	            // Strict comparison would cause a BC
	            // eslint-disable-next-line eqeqeq
	            var boolVal = (attr.value == ngModel.$viewValue);
	            elem.attr('aria-checked', boolVal);
	          }
	
	          function getCheckboxReaction() {
	            elem.attr('aria-checked', !ngModel.$isEmpty(ngModel.$viewValue));
	          }
	
	          switch (shape) {
	            case 'radio':
	            case 'checkbox':
	              if (shouldAttachRole(shape, elem)) {
	                elem.attr('role', shape);
	              }
	              if (shouldAttachAttr('aria-checked', 'ariaChecked', elem, false)) {
	                scope.$watch(ngAriaWatchModelValue, shape === 'radio' ?
	                    getRadioReaction : getCheckboxReaction);
	              }
	              if (needsTabIndex) {
	                elem.attr('tabindex', 0);
	              }
	              break;
	            case 'range':
	              if (shouldAttachRole(shape, elem)) {
	                elem.attr('role', 'slider');
	              }
	              if ($aria.config('ariaValue')) {
	                var needsAriaValuemin = !elem.attr('aria-valuemin') &&
	                    (attr.hasOwnProperty('min') || attr.hasOwnProperty('ngMin'));
	                var needsAriaValuemax = !elem.attr('aria-valuemax') &&
	                    (attr.hasOwnProperty('max') || attr.hasOwnProperty('ngMax'));
	                var needsAriaValuenow = !elem.attr('aria-valuenow');
	
	                if (needsAriaValuemin) {
	                  attr.$observe('min', function ngAriaValueMinReaction(newVal) {
	                    elem.attr('aria-valuemin', newVal);
	                  });
	                }
	                if (needsAriaValuemax) {
	                  attr.$observe('max', function ngAriaValueMinReaction(newVal) {
	                    elem.attr('aria-valuemax', newVal);
	                  });
	                }
	                if (needsAriaValuenow) {
	                  scope.$watch(ngAriaWatchModelValue, function ngAriaValueNowReaction(newVal) {
	                    elem.attr('aria-valuenow', newVal);
	                  });
	                }
	              }
	              if (needsTabIndex) {
	                elem.attr('tabindex', 0);
	              }
	              break;
	          }
	
	          if (!attr.hasOwnProperty('ngRequired') && ngModel.$validators.required
	            && shouldAttachAttr('aria-required', 'ariaRequired', elem, false)) {
	            // ngModel.$error.required is undefined on custom controls
	            attr.$observe('required', function() {
	              elem.attr('aria-required', !!attr['required']);
	            });
	          }
	
	          if (shouldAttachAttr('aria-invalid', 'ariaInvalid', elem, true)) {
	            scope.$watch(function ngAriaInvalidWatch() {
	              return ngModel.$invalid;
	            }, function ngAriaInvalidReaction(newVal) {
	              elem.attr('aria-invalid', !!newVal);
	            });
	          }
	        }
	      };
	    }
	  };
	}])
	.directive('ngDisabled', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
	}])
	.directive('ngMessages', function() {
	  return {
	    restrict: 'A',
	    require: '?ngMessages',
	    link: function(scope, elem, attr, ngMessages) {
	      if (!elem.attr('aria-live')) {
	        elem.attr('aria-live', 'assertive');
	      }
	    }
	  };
	})
	.directive('ngClick',['$aria', '$parse', function($aria, $parse) {
	  return {
	    restrict: 'A',
	    compile: function(elem, attr) {
	      var fn = $parse(attr.ngClick);
	      return function(scope, elem, attr) {
	
	        if (!isNodeOneOf(elem, nodeBlackList)) {
	
	          if ($aria.config('bindRoleForClick') && !elem.attr('role')) {
	            elem.attr('role', 'button');
	          }
	
	          if ($aria.config('tabindex') && !elem.attr('tabindex')) {
	            elem.attr('tabindex', 0);
	          }
	
	          if ($aria.config('bindKeydown') && !attr.ngKeydown && !attr.ngKeypress && !attr.ngKeyup) {
	            elem.on('keydown', function(event) {
	              var keyCode = event.which || event.keyCode;
	              if (keyCode === 32 || keyCode === 13) {
	                scope.$apply(callback);
	              }
	
	              function callback() {
	                fn(scope, { $event: event });
	              }
	            });
	          }
	        }
	      };
	    }
	  };
	}])
	.directive('ngDblclick', ['$aria', function($aria) {
	  return function(scope, elem, attr) {
	    if ($aria.config('tabindex') && !elem.attr('tabindex') && !isNodeOneOf(elem, nodeBlackList)) {
	      elem.attr('tabindex', 0);
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ },

/***/ 124:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(125);
	module.exports = 'naif.base64';


/***/ },

/***/ 125:
/***/ function(module, exports) {

	(function(window, undefined) {
	
	  'use strict';
	
	  /* istanbul ignore next */
	  //http://stackoverflow.com/questions/9267899/arraybuffer-to-base64-encoded-string
	  window._arrayBufferToBase64 = function(buffer) {
	    var binary = '';
	    var bytes = new Uint8Array(buffer);
	    var len = bytes.byteLength;
	
	    for (var i = 0; i < len; i += 1) {
	      binary += String.fromCharCode(bytes[i]);
	    }
	    return window.btoa(binary);
	  };
	
	
	  var mod = window.angular.module('naif.base64', []);
	
	  mod.directive('baseSixtyFourInput', [
	    '$window',
	    '$q',
	    function($window, $q) {
	
	      var isolateScope = {
	        onChange: '&',
	        onAfterValidate: '&',
	        parser: '&'
	      };
	
	      var FILE_READER_EVENTS = ['onabort', 'onerror', 'onloadstart', 'onloadend', 'onprogress', 'onload'];
	
	      FILE_READER_EVENTS.forEach(function(e) {
	        isolateScope[e] = '&';
	      });
	
	      return {
	        restrict: 'A',
	        require: 'ngModel',
	        scope: isolateScope,
	        link: function(scope, elem, attrs, ngModel) {
	
	          var rawFiles = [];
	          var fileObjects = [];
	
	          /* istanbul ignore if */
	          if (!ngModel) {
	            return;
	          }
	
	          // VALIDATIONS =========================================================
	
	          function _maxnum(val) {
	            if (attrs.maxnum && attrs.multiple && val) {
	              var valid = val.length <= parseInt(attrs.maxnum);
	              ngModel.$setValidity('maxnum', valid);
	            }
	            return val;
	          }
	
	          function _minnum(val) {
	            if (attrs.minnum && attrs.multiple && val) {
	              var valid = val.length >= parseInt(attrs.minnum);
	              ngModel.$setValidity('minnum', valid);
	            }
	            return val;
	          }
	
	          function _maxsize(val) {
	            var valid = true;
	
	            if (attrs.maxsize && val) {
	              var max = parseFloat(attrs.maxsize) * 1000;
	
	              if (attrs.multiple) {
	                for (var i = 0; i < val.length; i++) {
	                  var file = val[i];
	                  if (file.filesize > max) {
	                    valid = false;
	                    break;
	                  }
	                }
	              } else {
	                valid = val.filesize <= max;
	              }
	              ngModel.$setValidity('maxsize', valid);
	            }
	
	            return val;
	          }
	
	          function _minsize(val) {
	            var valid = true;
	            var min = parseFloat(attrs.minsize) * 1000;
	
	            if (attrs.minsize && val) {
	              if (attrs.multiple) {
	                for (var i = 0; i < val.length; i++) {
	                  var file = val[i];
	                  if (file.filesize < min) {
	                    valid = false;
	                    break;
	                  }
	                }
	              } else {
	                valid = val.filesize >= min;
	              }
	              ngModel.$setValidity('minsize', valid);
	            }
	
	            return val;
	          }
	
	          function _accept(val) {
	            var valid = true;
	            var regExp, exp, fileExt;
	            if (attrs.accept) {
	              exp = attrs.accept.trim().replace(/[,\s]+/gi, "|").replace(/\./g, "\\.").replace(/\/\*/g, "/.*");
	              regExp = new RegExp(exp);
	            }
	
	            if (attrs.accept && val) {
	              if (attrs.multiple) {
	                for (var i = 0; i < val.length; i++) {
	                  var file = val[i];
	                  fileExt = "." + file.filename.split('.').pop();
	                  valid = regExp.test(file.filetype) || regExp.test(fileExt);
	
	                  if (!valid) {
	                    break;
	                  }
	                }
	              } else {
	                fileExt = "." + val.filename.split('.').pop();
	                valid = regExp.test(val.filetype) || regExp.test(fileExt);
	              }
	              ngModel.$setValidity('accept', valid);
	            }
	
	            return val;
	          }
	
	          //end validations ===============
	
	          function _setViewValue() {
	            var newVal = attrs.multiple ? fileObjects : fileObjects[0];
	            ngModel.$setViewValue(newVal);
	            _maxsize(newVal);
	            _minsize(newVal);
	            _maxnum(newVal);
	            _minnum(newVal);
	            _accept(newVal);
	          }
	
	          function _attachHandlerForEvent(eventName, handler, fReader, file, fileObject) {
	            fReader[eventName] = function(e) {
	              handler()(e, fReader, file, rawFiles, fileObjects, fileObject);
	            };
	          }
	
	          function _readerOnLoad(fReader, file, fileObject) {
	
	            return function(e) {
	
	              var buffer = e.target.result;
	              var promise;
	
	              // do not convert the image to base64 if it exceeds the maximum
	              // size to prevent the browser from freezing
	              var exceedsMaxSize = attrs.maxsize && file.size > attrs.maxsize * 1024;
	              if (attrs.doNotParseIfOversize !== undefined && exceedsMaxSize) {
	                fileObject.base64 = null;
	              } else {
	                fileObject.base64 = $window._arrayBufferToBase64(buffer);
	              }
	
	              if (attrs.parser) {
	                promise = $q.when(scope.parser()(file, fileObject));
	              } else {
	                promise = $q.when(fileObject);
	              }
	
	              promise.then(function(fileObj) {
	                fileObjects.push(fileObj);
	                // fulfill the promise here.
	                file.deferredObj.resolve();
	              });
	
	              if (attrs.onload) {
	                if (scope.onload && typeof scope.onload() === "function") {
	                  scope.onload()(e, fReader, file, rawFiles, fileObjects, fileObject);
	                } else {
	                  scope.onload(e, rawFiles);
	                }
	              }
	
	            };
	
	          }
	
	          function _attachEventHandlers(fReader, file, fileObject) {
	
	            for (var i = FILE_READER_EVENTS.length - 1; i >= 0; i--) {
	              var e = FILE_READER_EVENTS[i];
	              if (attrs[e] && e !== 'onload') { // don't attach handler to onload yet
	                _attachHandlerForEvent(e, scope[e], fReader, file, fileObject);
	              }
	            }
	
	            fReader.onload = _readerOnLoad(fReader, file, fileObject);
	          }
	
	          function _readFiles() {
	            var promises = [];
	            var i;
	            for (i = rawFiles.length - 1; i >= 0; i--) {
	              // append file a new promise, that waits until resolved
	              rawFiles[i].deferredObj = $q.defer();
	              promises.push(rawFiles[i].deferredObj.promise);
	              // TODO: Make sure all promises are resolved even during file reader error, otherwise view value wont be updated
	            }
	
	            // set view value once all files are read
	            $q.all(promises).then(_setViewValue);
	
	            for (i = rawFiles.length - 1; i >= 0; i--) {
	              var reader = new $window.FileReader();
	              var file = rawFiles[i];
	              var fileObject = {};
	
	              fileObject.filetype = file.type;
	              fileObject.filename = file.name;
	              fileObject.filesize = file.size;
	
	              _attachEventHandlers(reader, file, fileObject);
	              reader.readAsArrayBuffer(file);
	            }
	          }
	
	          function _onChange(e) {
	            if (attrs.onChange) {
	              if (scope.onChange && typeof scope.onChange() === "function") {
	                scope.onChange()(e, rawFiles);
	              } else {
	                scope.onChange(e, rawFiles);
	              }
	            }
	          }
	
	          function _onAfterValidate(e) {
	            if (attrs.onAfterValidate) {
	              // wait for all promises, in rawFiles,
	              //   then call onAfterValidate
	              var promises = [];
	              for (var i = rawFiles.length - 1; i >= 0; i--) {
	                promises.push(rawFiles[i].deferredObj.promise);
	              }
	              $q.all(promises).then(function() {
	                if (scope.onAfterValidate && typeof scope.onAfterValidate() === "function") {
	                  scope.onAfterValidate()(e, fileObjects, rawFiles);
	                } else {
	                  scope.onAfterValidate(e, fileObjects, rawFiles);
	                }
	              });
	            }
	          }
	
	          ngModel.$isEmpty = function(val) {
	            return !val || (angular.isArray(val) ? val.length === 0 : !val.base64);
	          };
	
	          // http://stackoverflow.com/questions/1703228/how-can-i-clear-an-html-file-input-with-javascript
	          scope._clearInput = function() {
	            elem[0].value = '';
	          };
	
	          scope.$watch(function() {
	            return ngModel.$viewValue;
	          }, function(val) {
	            if (ngModel.$isEmpty(val) && ngModel.$dirty) {
	              scope._clearInput();
	              // Remove validation errors
	              ngModel.$setValidity('maxnum', true);
	              ngModel.$setValidity('minnum', true);
	              ngModel.$setValidity('maxsize', true);
	              ngModel.$setValidity('minsize', true);
	              ngModel.$setValidity('accept', true);
	            }
	          });
	
	          elem.on('change', function(e) {
	
	            fileObjects = [];
	            fileObjects = angular.copy(fileObjects);
	
	            if (e.target.files.length === 0) {
	              rawFiles = [];
	              _setViewValue();
	            } else {
	              rawFiles = e.target.files; // use event target so we can mock the files from test
	              _readFiles();
	              _onChange(e);
	              _onAfterValidate(e);
	            }
	
	            if (attrs.allowSameFile) {
	              scope._clearInput();
	            }
	
	          });
	
	        }
	      };
	
	    }
	  ]);
	
	})(window);


/***/ },

/***/ 126:
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.8.3
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngCookies
	 * @description
	 *
	 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
	 *
	 * See {@link ngCookies.$cookies `$cookies`} for usage.
	 */
	
	
	angular.module('ngCookies', ['ng']).
	  info({ angularVersion: '1.8.3' }).
	  /**
	   * @ngdoc provider
	   * @name $cookiesProvider
	   * @description
	   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
	   * */
	   provider('$cookies', [/** @this */function $CookiesProvider() {
	    /**
	     * @ngdoc property
	     * @name $cookiesProvider#defaults
	     * @description
	     *
	     * Object containing default options to pass when setting cookies.
	     *
	     * The object may have following properties:
	     *
	     * - **path** - `{string}` - The cookie will be available only for this path and its
	     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
	     * - **domain** - `{string}` - The cookie will be available only for this domain and
	     *   its sub-domains. For security reasons the user agent will not accept the cookie
	     *   if the current domain is not a sub-domain of this domain or equal to it.
	     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
	     *   or a Date object indicating the exact date/time this cookie will expire.
	     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
	     *   secured connection.
	     * - **samesite** - `{string}` - prevents the browser from sending the cookie along with cross-site requests.
	     *   Accepts the values `lax` and `strict`. See the [OWASP Wiki](https://www.owasp.org/index.php/SameSite)
	     *   for more info. Note that as of May 2018, not all browsers support `SameSite`,
	     *   so it cannot be used as a single measure against Cross-Site-Request-Forgery (CSRF) attacks.
	     *
	     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
	     * This is important so that cookies will be visible for all routes when html5mode is enabled.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesProviderExample', ['ngCookies'])
	     *   .config(['$cookiesProvider', function($cookiesProvider) {
	     *     // Setting default options
	     *     $cookiesProvider.defaults.domain = 'foo.com';
	     *     $cookiesProvider.defaults.secure = true;
	     *   }]);
	     * ```
	     **/
	    var defaults = this.defaults = {};
	
	    function calcOptions(options) {
	      return options ? angular.extend({}, defaults, options) : defaults;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $cookies
	     *
	     * @description
	     * Provides read/write access to browser's cookies.
	     *
	     * <div class="alert alert-info">
	     * Up until AngularJS 1.3, `$cookies` exposed properties that represented the
	     * current browser cookie values. In version 1.4, this behavior has changed, and
	     * `$cookies` now provides a standard api of getters, setters etc.
	     * </div>
	     *
	     * Requires the {@link ngCookies `ngCookies`} module to be installed.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesExample', ['ngCookies'])
	     *   .controller('ExampleController', ['$cookies', function($cookies) {
	     *     // Retrieving a cookie
	     *     var favoriteCookie = $cookies.get('myFavorite');
	     *     // Setting a cookie
	     *     $cookies.put('myFavorite', 'oatmeal');
	     *   }]);
	     * ```
	     */
	    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
	      return {
	        /**
	         * @ngdoc method
	         * @name $cookies#get
	         *
	         * @description
	         * Returns the value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {string} Raw cookie value.
	         */
	        get: function(key) {
	          return $$cookieReader()[key];
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getObject
	         *
	         * @description
	         * Returns the deserialized value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {Object} Deserialized cookie value.
	         */
	        getObject: function(key) {
	          var value = this.get(key);
	          return value ? angular.fromJson(value) : value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getAll
	         *
	         * @description
	         * Returns a key value object with all the cookies
	         *
	         * @returns {Object} All cookies
	         */
	        getAll: function() {
	          return $$cookieReader();
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#put
	         *
	         * @description
	         * Sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {string} value Raw value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        put: function(key, value, options) {
	          $$cookieWriter(key, value, calcOptions(options));
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#putObject
	         *
	         * @description
	         * Serializes and sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {Object} value Value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        putObject: function(key, value, options) {
	          this.put(key, angular.toJson(value), options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#remove
	         *
	         * @description
	         * Remove given cookie
	         *
	         * @param {string} key Id of the key-value pair to delete.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        remove: function(key, options) {
	          $$cookieWriter(key, undefined, calcOptions(options));
	        }
	      };
	    }];
	  }]);
	
	/**
	 * @name $$cookieWriter
	 * @requires $document
	 *
	 * @description
	 * This is a private service for writing cookies
	 *
	 * @param {string} name Cookie name
	 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
	 * @param {Object=} options Object with options that need to be stored for the cookie.
	 */
	function $$CookieWriter($document, $log, $browser) {
	  var cookiePath = $browser.baseHref();
	  var rawDocument = $document[0];
	
	  function buildCookieString(name, value, options) {
	    var path, expires;
	    options = options || {};
	    expires = options.expires;
	    path = angular.isDefined(options.path) ? options.path : cookiePath;
	    if (angular.isUndefined(value)) {
	      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
	      value = '';
	    }
	    if (angular.isString(expires)) {
	      expires = new Date(expires);
	    }
	
	    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
	    str += path ? ';path=' + path : '';
	    str += options.domain ? ';domain=' + options.domain : '';
	    str += expires ? ';expires=' + expires.toUTCString() : '';
	    str += options.secure ? ';secure' : '';
	    str += options.samesite ? ';samesite=' + options.samesite : '';
	
	    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
	    // - 300 cookies
	    // - 20 cookies per unique domain
	    // - 4096 bytes per cookie
	    var cookieLength = str.length + 1;
	    if (cookieLength > 4096) {
	      $log.warn('Cookie \'' + name +
	        '\' possibly not set or overflowed because it was too large (' +
	        cookieLength + ' > 4096 bytes)!');
	    }
	
	    return str;
	  }
	
	  return function(name, value, options) {
	    rawDocument.cookie = buildCookieString(name, value, options);
	  };
	}
	
	$$CookieWriter.$inject = ['$document', '$log', '$browser'];
	
	angular.module('ngCookies').provider('$$cookieWriter', /** @this */ function $$CookieWriterProvider() {
	  this.$get = $$CookieWriter;
	});
	
	
	})(window, window.angular);


/***/ },

/***/ 127:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(126);
	module.exports = 'ngCookies';


/***/ },

/***/ 128:
/***/ function(module, exports) {

	/*! angular-google-maps 2.4.1 2017-01-05
	 *  AngularJS directives for Google Maps
	 *  git: https://github.com/angular-ui/angular-google-maps.git
	 */
	;
	(function( window, angular, _, undefined ){
	  'use strict';
	/*
	!
	The MIT License
	
	Copyright (c) 2010-2013 Google, Inc. http://angularjs.org
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the 'Software'), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	
	angular-google-maps
	https://github.com/angular-ui/angular-google-maps
	
	@authors
	Nicolas Laplante - https://plus.google.com/108189012221374960701
	Nicholas McCready - https://twitter.com/nmccready
	 */
	
	(function() {
	  angular.module('uiGmapgoogle-maps.providers', ['nemLogging']);
	
	  angular.module('uiGmapgoogle-maps.wrapped', []);
	
	  angular.module('uiGmapgoogle-maps.extensions', ['uiGmapgoogle-maps.wrapped', 'uiGmapgoogle-maps.providers']);
	
	  angular.module('uiGmapgoogle-maps.directives.api.utils', ['uiGmapgoogle-maps.extensions']);
	
	  angular.module('uiGmapgoogle-maps.directives.api.managers', []);
	
	  angular.module('uiGmapgoogle-maps.directives.api.options', ['uiGmapgoogle-maps.directives.api.utils']);
	
	  angular.module('uiGmapgoogle-maps.directives.api.options.builders', []);
	
	  angular.module('uiGmapgoogle-maps.directives.api.models.child', ['uiGmapgoogle-maps.directives.api.utils', 'uiGmapgoogle-maps.directives.api.options', 'uiGmapgoogle-maps.directives.api.options.builders']);
	
	  angular.module('uiGmapgoogle-maps.directives.api.models.parent', ['uiGmapgoogle-maps.directives.api.managers', 'uiGmapgoogle-maps.directives.api.models.child', 'uiGmapgoogle-maps.providers']);
	
	  angular.module('uiGmapgoogle-maps.directives.api', ['uiGmapgoogle-maps.directives.api.models.parent']);
	
	  angular.module('uiGmapgoogle-maps', ['uiGmapgoogle-maps.directives.api', 'uiGmapgoogle-maps.providers']);
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps.providers').factory('uiGmapMapScriptLoader', [
	    '$q', 'uiGmapuuid', function($q, uuid) {
	      var getScriptUrl, includeScript, isGoogleMapsLoaded, scriptId, usedConfiguration;
	      scriptId = void 0;
	      usedConfiguration = void 0;
	      getScriptUrl = function(options) {
	        if (options.china) {
	          return 'http://maps.google.cn/maps/api/js?';
	        } else {
	          if (options.transport === 'auto') {
	            return '//maps.googleapis.com/maps/api/js?';
	          } else {
	            return options.transport + '://maps.googleapis.com/maps/api/js?';
	          }
	        }
	      };
	      includeScript = function(options) {
	        var omitOptions, query, script, scriptElem;
	        omitOptions = ['transport', 'isGoogleMapsForWork', 'china', 'preventLoad'];
	        if (options.isGoogleMapsForWork) {
	          omitOptions.push('key');
	        }
	        query = _.map(_.omit(options, omitOptions), function(v, k) {
	          return k + '=' + v;
	        });
	        if (scriptId) {
	          scriptElem = document.getElementById(scriptId);
	          scriptElem.parentNode.removeChild(scriptElem);
	        }
	        query = query.join('&');
	        script = document.createElement('script');
	        script.id = scriptId = "ui_gmap_map_load_" + (uuid.generate());
	        script.type = 'text/javascript';
	        script.src = getScriptUrl(options) + query;
	        return document.head.appendChild(script);
	      };
	      isGoogleMapsLoaded = function() {
	        return angular.isDefined(window.google) && angular.isDefined(window.google.maps);
	      };
	      return {
	        load: function(options) {
	          var deferred, randomizedFunctionName;
	          deferred = $q.defer();
	          if (isGoogleMapsLoaded()) {
	            deferred.resolve(window.google.maps);
	            return deferred.promise;
	          }
	          randomizedFunctionName = options.callback = 'onGoogleMapsReady' + Math.round(Math.random() * 1000);
	          window[randomizedFunctionName] = function() {
	            window[randomizedFunctionName] = null;
	            deferred.resolve(window.google.maps);
	          };
	          if (window.navigator.connection && window.Connection && window.navigator.connection.type === window.Connection.NONE && !options.preventLoad) {
	            document.addEventListener('online', function() {
	              if (!isGoogleMapsLoaded()) {
	                return includeScript(options);
	              }
	            });
	          } else if (!options.preventLoad) {
	            includeScript(options);
	          }
	          usedConfiguration = options;
	          usedConfiguration.randomizedFunctionName = randomizedFunctionName;
	          return deferred.promise;
	        },
	        manualLoad: function() {
	          var config;
	          config = usedConfiguration;
	          if (!isGoogleMapsLoaded()) {
	            return includeScript(config);
	          } else {
	            if (window[config.randomizedFunctionName]) {
	              return window[config.randomizedFunctionName]();
	            }
	          }
	        }
	      };
	    }
	  ]).provider('uiGmapGoogleMapApi', function() {
	    this.options = {
	      transport: 'https',
	      isGoogleMapsForWork: false,
	      china: false,
	      v: '3',
	      libraries: '',
	      language: 'en',
	      preventLoad: false
	    };
	    this.configure = function(options) {
	      angular.extend(this.options, options);
	    };
	    this.$get = [
	      'uiGmapMapScriptLoader', (function(_this) {
	        return function(loader) {
	          return loader.load(_this.options);
	        };
	      })(this)
	    ];
	    return this;
	  }).service('uiGmapGoogleMapApiManualLoader', [
	    'uiGmapMapScriptLoader', function(loader) {
	      return {
	        load: function() {
	          loader.manualLoad();
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.extensions').service('uiGmapExtendGWin', function() {
	    return {
	      init: _.once(function() {
	        var uiGmapInfoBox;
	        if (!(google || (typeof google !== "undefined" && google !== null ? google.maps : void 0) || (google.maps.InfoWindow != null))) {
	          return;
	        }
	        google.maps.InfoWindow.prototype._open = google.maps.InfoWindow.prototype.open;
	        google.maps.InfoWindow.prototype._close = google.maps.InfoWindow.prototype.close;
	        google.maps.InfoWindow.prototype._isOpen = false;
	        google.maps.InfoWindow.prototype.open = function(map, anchor, recurse) {
	          if (recurse != null) {
	            return;
	          }
	          this._isOpen = true;
	          this._open(map, anchor, true);
	        };
	        google.maps.InfoWindow.prototype.close = function(recurse) {
	          if (recurse != null) {
	            return;
	          }
	          this._isOpen = false;
	          this._close(true);
	        };
	        google.maps.InfoWindow.prototype.isOpen = function(val) {
	          if (val == null) {
	            val = void 0;
	          }
	          if (val == null) {
	            return this._isOpen;
	          } else {
	            return this._isOpen = val;
	          }
	        };
	
	        /*
	        Do the same for InfoBox
	        TODO: Clean this up so the logic is defined once, wait until develop becomes master as this will be easier
	         */
	        if (window.InfoBox) {
	          window.InfoBox.prototype._open = window.InfoBox.prototype.open;
	          window.InfoBox.prototype._close = window.InfoBox.prototype.close;
	          window.InfoBox.prototype._isOpen = false;
	          window.InfoBox.prototype.open = function(map, anchor) {
	            this._isOpen = true;
	            this._open(map, anchor);
	          };
	          window.InfoBox.prototype.close = function() {
	            this._isOpen = false;
	            this._close();
	          };
	          window.InfoBox.prototype.isOpen = function(val) {
	            if (val == null) {
	              val = void 0;
	            }
	            if (val == null) {
	              return this._isOpen;
	            } else {
	              return this._isOpen = val;
	            }
	          };
	          uiGmapInfoBox = (function(superClass) {
	            extend(uiGmapInfoBox, superClass);
	
	            function uiGmapInfoBox(opts) {
	              this.getOrigCloseBoxImg_ = bind(this.getOrigCloseBoxImg_, this);
	              this.getCloseBoxDiv_ = bind(this.getCloseBoxDiv_, this);
	              var box;
	              box = new window.InfoBox(opts);
	              _.extend(this, box);
	              if (opts.closeBoxDiv != null) {
	                this.closeBoxDiv_ = opts.closeBoxDiv;
	              }
	            }
	
	            uiGmapInfoBox.prototype.getCloseBoxDiv_ = function() {
	              return this.closeBoxDiv_;
	            };
	
	            uiGmapInfoBox.prototype.getCloseBoxImg_ = function() {
	              var div, img;
	              div = this.getCloseBoxDiv_();
	              img = this.getOrigCloseBoxImg_();
	              return div || img;
	            };
	
	            uiGmapInfoBox.prototype.getOrigCloseBoxImg_ = function() {
	              var img;
	              img = "";
	              if (this.closeBoxURL_ !== "") {
	                img = "<img";
	                img += " src='" + this.closeBoxURL_ + "'";
	                img += " align=right";
	                img += " style='";
	                img += " position: relative;";
	                img += " cursor: pointer;";
	                img += " margin: " + this.closeBoxMargin_ + ";";
	                img += "'>";
	              }
	              return img;
	            };
	
	            return uiGmapInfoBox;
	
	          })(window.InfoBox);
	          window.uiGmapInfoBox = uiGmapInfoBox;
	        }
	        if (window.MarkerLabel_) {
	          return window.MarkerLabel_.prototype.setContent = function() {
	            var content;
	            content = this.marker_.get('labelContent');
	            if (!content || _.isEqual(this.oldContent, content)) {
	              return;
	            }
	            if (typeof (content != null ? content.nodeType : void 0) === 'undefined') {
	              this.labelDiv_.innerHTML = content;
	              this.eventDiv_.innerHTML = this.labelDiv_.innerHTML;
	              this.oldContent = content;
	            } else {
	              this.labelDiv_.innerHTML = '';
	              this.labelDiv_.appendChild(content);
	              content = content.cloneNode(true);
	              this.labelDiv_.innerHTML = '';
	              this.eventDiv_.appendChild(content);
	              this.oldContent = content;
	            }
	          };
	        }
	      })
	    };
	  });
	
	}).call(this);
	;
	/*global _:true, angular:true */
	
	(function() {
	  angular.module('uiGmapgoogle-maps.extensions').service('uiGmapLodash', function() {
	    var baseGet, baseToString, fixLodash, get, reEscapeChar, rePropName, toObject, toPath;
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	    reEscapeChar = /\\(\\)?/g;
	
	    /*
	        For Lodash 4 compatibility (some aliases are removed)
	     */
	    fixLodash = function(arg) {
	      var isProto, missingName, swapName;
	      missingName = arg.missingName, swapName = arg.swapName, isProto = arg.isProto;
	      if (_[missingName] == null) {
	        _[missingName] = _[swapName];
	        if (isProto) {
	          return _.prototype[missingName] = _[swapName];
	        }
	      }
	    };
	    [
	      {
	        missingName: 'contains',
	        swapName: 'includes',
	        isProto: true
	      }, {
	        missingName: 'includes',
	        swapName: 'contains',
	        isProto: true
	      }, {
	        missingName: 'object',
	        swapName: 'zipObject'
	      }, {
	        missingName: 'zipObject',
	        swapName: 'object'
	      }, {
	        missingName: 'all',
	        swapName: 'every'
	      }, {
	        missingName: 'every',
	        swapName: 'all'
	      }, {
	        missingName: 'any',
	        swapName: 'some'
	      }, {
	        missingName: 'some',
	        swapName: 'any'
	      }, {
	        missingName: 'first',
	        swapName: 'head'
	      }, {
	        missingName: 'head',
	        swapName: 'first'
	      }
	    ].forEach(function(toMonkeyPatch) {
	      return fixLodash(toMonkeyPatch);
	    });
	    if (_.get == null) {
	
	      /**
	       * Converts `value` to an object if it's not one.
	       *
	       * @private
	       * @param {*} value The value to process.
	       * @returns {Object} Returns the object.
	       */
	      toObject = function(value) {
	        if (_.isObject(value)) {
	          return value;
	        } else {
	          return Object(value);
	        }
	      };
	
	      /**
	       * Converts `value` to a string if it's not one. An empty string is returned
	       * for `null` or `undefined` values.
	       *
	       * @private
	       * @param {*} value The value to process.
	       * @returns {string} Returns the string.
	       */
	      baseToString = function(value) {
	        if (value === null) {
	          return '';
	        } else {
	          return value + '';
	        }
	      };
	
	      /**
	       * Converts `value` to property path array if it's not one.
	       *
	       * @private
	       * @param {*} value The value to process.
	       * @returns {Array} Returns the property path array.
	       */
	      toPath = function(value) {
	        var result;
	        if (_.isArray(value)) {
	          return value;
	        }
	        result = [];
	        baseToString(value).replace(rePropName, function(match, number, quote, string) {
	          result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
	        });
	        return result;
	      };
	
	      /**
	       * The base implementation of `get` without support for string paths
	       * and default values.
	       *
	       * @private
	       * @param {Object} object The object to query.
	       * @param {Array} path The path of the property to get.
	       * @param {string} [pathKey] The key representation of path.
	       * @returns {*} Returns the resolved value.
	       */
	      baseGet = function(object, path, pathKey) {
	        var index, length;
	        if (object === null) {
	          return;
	        }
	        if (pathKey !== void 0 && pathKey in toObject(object)) {
	          path = [pathKey];
	        }
	        index = 0;
	        length = path.length;
	        while (!_.isUndefined(object) && index < length) {
	          object = object[path[index++]];
	        }
	        if (index && index === length) {
	          return object;
	        } else {
	          return void 0;
	        }
	      };
	
	      /**
	       * Gets the property value at `path` of `object`. If the resolved value is
	       * `undefined` the `defaultValue` is used in its place.
	       *
	       * @static
	       * @memberOf _
	       * @category Object
	       * @param {Object} object The object to query.
	       * @param {Array|string} path The path of the property to get.
	       * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	       * @returns {*} Returns the resolved value.
	       * @example
	       *
	       * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	       *
	       * _.get(object, 'a[0].b.c');
	       * // => 3
	       *
	       * _.get(object, ['a', '0', 'b', 'c']);
	       * // => 3
	       *
	       * _.get(object, 'a.b.c', 'default');
	       * // => 'default'
	       */
	      get = function(object, path, defaultValue) {
	        var result;
	        result = object === null ? void 0 : baseGet(object, toPath(path), path + '');
	        if (result === void 0) {
	          return defaultValue;
	        } else {
	          return result;
	        }
	      };
	      _.get = get;
	    }
	
	    /*
	        Author Nick McCready
	        Intersection of Objects if the arrays have something in common each intersecting object will be returned
	        in an new array.
	     */
	    this.intersectionObjects = function(array1, array2, comparison) {
	      var res;
	      if (comparison == null) {
	        comparison = void 0;
	      }
	      res = _.map(array1, function(obj1) {
	        return _.find(array2, function(obj2) {
	          if (comparison != null) {
	            return comparison(obj1, obj2);
	          } else {
	            return _.isEqual(obj1, obj2);
	          }
	        });
	      });
	      return _.filter(res, function(o) {
	        return o != null;
	      });
	    };
	    this.containsObject = _.includeObject = function(obj, target, comparison) {
	      if (comparison == null) {
	        comparison = void 0;
	      }
	      if (obj === null) {
	        return false;
	      }
	      return _.some(obj, function(value) {
	        if (comparison != null) {
	          return comparison(value, target);
	        } else {
	          return _.isEqual(value, target);
	        }
	      });
	    };
	    this.differenceObjects = function(array1, array2, comparison) {
	      if (comparison == null) {
	        comparison = void 0;
	      }
	      return _.filter(array1, (function(_this) {
	        return function(value) {
	          return !_this.containsObject(array2, value, comparison);
	        };
	      })(this));
	    };
	    this.withoutObjects = this.differenceObjects;
	    this.indexOfObject = function(array, item, comparison, isSorted) {
	      var i, length;
	      if (array == null) {
	        return -1;
	      }
	      i = 0;
	      length = array.length;
	      if (isSorted) {
	        if (typeof isSorted === "number") {
	          i = (isSorted < 0 ? Math.max(0, length + isSorted) : isSorted);
	        } else {
	          i = _.sortedIndex(array, item);
	          return (array[i] === item ? i : -1);
	        }
	      }
	      while (i < length) {
	        if (comparison != null) {
	          if (comparison(array[i], item)) {
	            return i;
	          }
	        } else {
	          if (_.isEqual(array[i], item)) {
	            return i;
	          }
	        }
	        i++;
	      }
	      return -1;
	    };
	    this.isNullOrUndefined = function(thing) {
	      return _.isNull(thing || _.isUndefined(thing));
	    };
	    return this;
	  });
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps.extensions').factory('uiGmapString', function() {
	    return function(str) {
	      this.contains = function(value, fromIndex) {
	        return str.indexOf(value, fromIndex) !== -1;
	      };
	      return this;
	    };
	  });
	
	}).call(this);
	;
	/*global _:true,angular:true, */
	
	(function() {
	  angular.module('uiGmapgoogle-maps.directives.api.utils').service('uiGmap_sync', [
	    function() {
	      return {
	        fakePromise: function() {
	          var _cb;
	          _cb = void 0;
	          return {
	            then: function(cb) {
	              return _cb = cb;
	            },
	            resolve: function() {
	              return _cb.apply(void 0, arguments);
	            }
	          };
	        }
	      };
	    }
	  ]).service('uiGmap_async', [
	    '$timeout', 'uiGmapPromise', 'uiGmapLogger', '$q', 'uiGmapDataStructures', 'uiGmapGmapUtil', function($timeout, uiGmapPromise, $log, $q, uiGmapDataStructures, uiGmapGmapUtil) {
	      var ExposedPromise, PromiseQueueManager, SniffedPromise, _getIterateeValue, _ignoreFields, defaultChunkSize, doChunk, doSkippPromise, each, errorObject, getArrayAndKeys, isInProgress, kickPromise, logTryCatch, managePromiseQueue, map, maybeCancelPromises, promiseStatus, promiseTypes, tryCatch;
	      promiseTypes = uiGmapPromise.promiseTypes;
	      isInProgress = uiGmapPromise.isInProgress;
	      promiseStatus = uiGmapPromise.promiseStatus;
	      ExposedPromise = uiGmapPromise.ExposedPromise;
	      SniffedPromise = uiGmapPromise.SniffedPromise;
	      kickPromise = function(sniffedPromise, cancelCb) {
	        var promise;
	        promise = sniffedPromise.promise();
	        promise.promiseType = sniffedPromise.promiseType;
	        if (promise.$$state) {
	          $log.debug("promiseType: " + promise.promiseType + ", state: " + (promiseStatus(promise.$$state.status)));
	        }
	        promise.cancelCb = cancelCb;
	        return promise;
	      };
	      doSkippPromise = function(sniffedPromise, lastPromise) {
	        if (sniffedPromise.promiseType === promiseTypes.create && lastPromise.promiseType !== promiseTypes["delete"] && lastPromise.promiseType !== promiseTypes.init) {
	          $log.debug("lastPromise.promiseType " + lastPromise.promiseType + ", newPromiseType: " + sniffedPromise.promiseType + ", SKIPPED MUST COME AFTER DELETE ONLY");
	          return true;
	        }
	        return false;
	      };
	      maybeCancelPromises = function(queue, sniffedPromise, lastPromise) {
	        var first;
	        if (sniffedPromise.promiseType === promiseTypes["delete"] && lastPromise.promiseType !== promiseTypes["delete"]) {
	          if ((lastPromise.cancelCb != null) && _.isFunction(lastPromise.cancelCb) && isInProgress(lastPromise)) {
	            $log.debug("promiseType: " + sniffedPromise.promiseType + ", CANCELING LAST PROMISE type: " + lastPromise.promiseType);
	            lastPromise.cancelCb('cancel safe');
	            first = queue.peek();
	            if ((first != null) && isInProgress(first)) {
	              if (first.hasOwnProperty("cancelCb") && _.isFunction(first.cancelCb)) {
	                $log.debug("promiseType: " + first.promiseType + ", CANCELING FIRST PROMISE type: " + first.promiseType);
	                return first.cancelCb('cancel safe');
	              } else {
	                return $log.warn('first promise was not cancelable');
	              }
	            }
	          }
	        }
	      };
	
	      /*
	      From a High Level:
	        This is a SniffedPromiseQueueManager (looking to rename) where the queue is existingPiecesObj.existingPieces.
	        This is a function and should not be considered a class.
	        So it is run to manage the state (cancel, skip, link) as needed.
	      Purpose:
	      The whole point is to check if there is existing async work going on. If so we wait on it.
	      
	      arguments:
	      - existingPiecesObj =  Queue<Promises>
	      - sniffedPromise = object wrapper holding a function to a pending (function) promise (promise: fnPromise)
	      with its intended type.
	      - cancelCb = callback which accepts a string, this string is intended to be returned at the end of _async.each iterator
	      
	        Where the cancelCb passed msg is 'cancel safe' _async.each will drop out and fall through. Thus canceling the promise
	        gracefully without messing up state.
	      
	      Synopsis:
	      
	       - Promises have been broken down to 4 states create, update,delete (3 main) and init. (Helps boil down problems in ordering)
	        where (init) is special to indicate that it is one of the first or to allow a create promise to work beyond being after a delete
	      
	       - Every Promise that comes in is enqueued and linked to the last promise in the queue.
	      
	       - A promise can be skipped or canceled to save cycles.
	      
	      Saved Cycles:
	        - Skipped - This will only happen if async work comes in out of order. Where a pending create promise (un-executed) comes in
	          after a delete promise.
	        - Canceled - Where an incoming promise (un-executed promise) is of type delete and the any lastPromise is not a delete type.
	      
	      
	      NOTE:
	      - You should not muck with existingPieces as its state is dependent on this functional loop.
	      - PromiseQueueManager should not be thought of as a class that has a life expectancy (it has none). It's sole
	      purpose is to link, skip, and kill promises. It also manages the promise queue existingPieces.
	       */
	      PromiseQueueManager = function(existingPiecesObj, sniffedPromise, cancelCb) {
	        var lastPromise, newPromise;
	        if (!existingPiecesObj.existingPieces) {
	          existingPiecesObj.existingPieces = new uiGmapDataStructures.Queue();
	          return existingPiecesObj.existingPieces.enqueue(kickPromise(sniffedPromise, cancelCb));
	        } else {
	          lastPromise = _.last(existingPiecesObj.existingPieces._content);
	          if (doSkippPromise(sniffedPromise, lastPromise)) {
	            return;
	          }
	          maybeCancelPromises(existingPiecesObj.existingPieces, sniffedPromise, lastPromise);
	          newPromise = ExposedPromise(lastPromise["finally"](function() {
	            return kickPromise(sniffedPromise, cancelCb);
	          }));
	          newPromise.cancelCb = cancelCb;
	          newPromise.promiseType = sniffedPromise.promiseType;
	          existingPiecesObj.existingPieces.enqueue(newPromise);
	          return lastPromise["finally"](function() {
	            return existingPiecesObj.existingPieces.dequeue();
	          });
	        }
	      };
	      managePromiseQueue = function(objectToLock, promiseType, msg, cancelCb, fnPromise) {
	        var cancelLogger;
	        if (msg == null) {
	          msg = '';
	        }
	        cancelLogger = function(msg) {
	          $log.debug(msg + ": " + msg);
	          if ((cancelCb != null) && _.isFunction(cancelCb)) {
	            return cancelCb(msg);
	          }
	        };
	        return PromiseQueueManager(objectToLock, SniffedPromise(fnPromise, promiseType), cancelLogger);
	      };
	      defaultChunkSize = 80;
	      errorObject = {
	        value: null
	      };
	      tryCatch = function(fn, ctx, args) {
	        var e, error1;
	        try {
	          return fn.apply(ctx, args);
	        } catch (error1) {
	          e = error1;
	          errorObject.value = e;
	          return errorObject;
	        }
	      };
	      logTryCatch = function(fn, ctx, deferred, args) {
	        var msg, result;
	        result = tryCatch(fn, ctx, args);
	        if (result === errorObject) {
	          msg = "error within chunking iterator: " + errorObject.value;
	          $log.error(msg);
	          deferred.reject(msg);
	        }
	        if (result === 'cancel safe') {
	          return false;
	        }
	        return true;
	      };
	      _getIterateeValue = function(collection, array, index) {
	        var _isArray, valOrKey;
	        _isArray = collection === array;
	        valOrKey = array[index];
	        if (_isArray) {
	          return valOrKey;
	        }
	        return collection[valOrKey];
	      };
	      _ignoreFields = ['length', 'forEach', 'map'];
	      getArrayAndKeys = function(collection, keys, bailOutCb, cb) {
	        var array, propName, val;
	        if (angular.isArray(collection)) {
	          array = collection;
	        } else {
	          if (keys) {
	            array = keys;
	          } else {
	            array = [];
	            for (propName in collection) {
	              val = collection[propName];
	              if (collection.hasOwnProperty(propName) && !_.includes(_ignoreFields, propName)) {
	                array.push(propName);
	              }
	            }
	          }
	        }
	        if (cb == null) {
	          cb = bailOutCb;
	        }
	        if (angular.isArray(array) && !(array != null ? array.length : void 0)) {
	          if (cb !== bailOutCb) {
	            return bailOutCb();
	          }
	        }
	        return cb(array, keys);
	      };
	
	      /*
	        Author: Nicholas McCready & jfriend00
	        _async handles things asynchronous-like :), to allow the UI to be free'd to do other things
	        Code taken from http://stackoverflow.com/questions/10344498/best-way-to-iterate-over-an-array-without-blocking-the-ui
	      
	        The design of any functionality of _async is to be like lodash/underscore and replicate it but call things
	        asynchronously underneath. Each should be sufficient for most things to be derived from.
	      
	        Optional Asynchronous Chunking via promises.
	       */
	      doChunk = function(collection, chunkSizeOrDontChunk, pauseMilli, chunkCb, pauseCb, overallD, index, _keys) {
	        return getArrayAndKeys(collection, _keys, function(array, keys) {
	          var cnt, i, keepGoing, val;
	          if (chunkSizeOrDontChunk && chunkSizeOrDontChunk < array.length) {
	            cnt = chunkSizeOrDontChunk;
	          } else {
	            cnt = array.length;
	          }
	          i = index;
	          keepGoing = true;
	          while (keepGoing && cnt-- && i < (array ? array.length : i + 1)) {
	            val = _getIterateeValue(collection, array, i);
	            keepGoing = angular.isFunction(val) ? true : logTryCatch(chunkCb, void 0, overallD, [val, i]);
	            ++i;
	          }
	          if (array) {
	            if (keepGoing && i < array.length) {
	              index = i;
	              if (chunkSizeOrDontChunk) {
	                if ((pauseCb != null) && _.isFunction(pauseCb)) {
	                  logTryCatch(pauseCb, void 0, overallD, []);
	                }
	                return $timeout(function() {
	                  return doChunk(collection, chunkSizeOrDontChunk, pauseMilli, chunkCb, pauseCb, overallD, index, keys);
	                }, pauseMilli, false);
	              }
	            } else {
	              return overallD.resolve();
	            }
	          }
	        });
	      };
	      each = function(collection, chunk, chunkSizeOrDontChunk, pauseCb, index, pauseMilli, _keys) {
	        var error, overallD, ret;
	        if (chunkSizeOrDontChunk == null) {
	          chunkSizeOrDontChunk = defaultChunkSize;
	        }
	        if (index == null) {
	          index = 0;
	        }
	        if (pauseMilli == null) {
	          pauseMilli = 1;
	        }
	        ret = void 0;
	        overallD = uiGmapPromise.defer();
	        ret = overallD.promise;
	        if (!pauseMilli) {
	          error = 'pause (delay) must be set from _async!';
	          $log.error(error);
	          overallD.reject(error);
	          return ret;
	        }
	        return getArrayAndKeys(collection, _keys, function() {
	          overallD.resolve();
	          return ret;
	        }, function(array, keys) {
	          doChunk(collection, chunkSizeOrDontChunk, pauseMilli, chunk, pauseCb, overallD, index, keys);
	          return ret;
	        });
	      };
	      map = function(collection, iterator, chunkSizeOrDontChunk, pauseCb, index, pauseMilli, _keys) {
	        var results;
	        results = [];
	        return getArrayAndKeys(collection, _keys, function() {
	          return uiGmapPromise.resolve(results);
	        }, function(array, keys) {
	          return each(collection, function(o) {
	            return results.push(iterator(o));
	          }, chunkSizeOrDontChunk, pauseCb, index, pauseMilli, keys).then(function() {
	            return results;
	          });
	        });
	      };
	      return {
	        each: each,
	        map: map,
	        managePromiseQueue: managePromiseQueue,
	        promiseLock: managePromiseQueue,
	        defaultChunkSize: defaultChunkSize,
	        getArrayAndKeys: getArrayAndKeys,
	        chunkSizeFrom: function(fromSize, ret) {
	          if (ret == null) {
	            ret = void 0;
	          }
	          if (_.isNumber(fromSize)) {
	            ret = fromSize;
	          }
	          if (uiGmapGmapUtil.isFalse(fromSize) || fromSize === false) {
	            ret = false;
	          }
	          return ret;
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	  angular.module('uiGmapgoogle-maps.directives.api.utils').factory('uiGmapBaseObject', function() {
	    var BaseObject, baseObjectKeywords;
	    baseObjectKeywords = ['extended', 'included'];
	    BaseObject = (function() {
	      function BaseObject() {}
	
	      BaseObject.extend = function(obj) {
	        var key, ref, value;
	        for (key in obj) {
	          value = obj[key];
	          if (indexOf.call(baseObjectKeywords, key) < 0) {
	            this[key] = value;
	          }
	        }
	        if ((ref = obj.extended) != null) {
	          ref.apply(this);
	        }
	        return this;
	      };
	
	      BaseObject.include = function(obj) {
	        var key, ref, value;
	        for (key in obj) {
	          value = obj[key];
	          if (indexOf.call(baseObjectKeywords, key) < 0) {
	            this.prototype[key] = value;
	          }
	        }
	        if ((ref = obj.included) != null) {
	          ref.apply(this);
	        }
	        return this;
	      };
	
	      return BaseObject;
	
	    })();
	    return BaseObject;
	  });
	
	}).call(this);
	;
	/*
	    Useful function callbacks that should be defined at later time.
	    Mainly to be used for specs to verify creation / linking.
	
	    This is to lead a common design in notifying child stuff.
	 */
	
	(function() {
	  angular.module('uiGmapgoogle-maps.directives.api.utils').factory('uiGmapChildEvents', function() {
	    return {
	      onChildCreation: function(child) {}
	    };
	  });
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps.directives.api.utils').service('uiGmapCtrlHandle', [
	    '$q', function($q) {
	      var CtrlHandle;
	      return CtrlHandle = {
	        handle: function($scope, $element) {
	          $scope.$on('$destroy', function() {
	            return CtrlHandle.handle($scope);
	          });
	          $scope.deferred = $q.defer();
	          return {
	            getScope: function() {
	              return $scope;
	            }
	          };
	        },
	        mapPromise: function(scope, ctrl) {
	          var mapScope;
	          mapScope = ctrl.getScope();
	          mapScope.deferred.promise.then(function(map) {
	            return scope.map = map;
	          });
	          return mapScope.deferred.promise;
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module("uiGmapgoogle-maps.directives.api.utils").service("uiGmapEventsHelper", [
	    "uiGmapLogger", function($log) {
	      var _getEventsObj, _hasEvents;
	      _hasEvents = function(obj) {
	        return angular.isDefined(obj.events) && (obj.events != null) && angular.isObject(obj.events);
	      };
	      _getEventsObj = function(scope, model) {
	        if (_hasEvents(scope)) {
	          return scope;
	        }
	        if (_hasEvents(model)) {
	          return model;
	        }
	      };
	      return {
	        setEvents: function(gObject, scope, model, ignores) {
	          var eventObj;
	          eventObj = _getEventsObj(scope, model);
	          if (eventObj != null) {
	            return _.compact(_.map(eventObj.events, function(eventHandler, eventName) {
	              var doIgnore;
	              if (ignores) {
	                doIgnore = _(ignores).includes(eventName);
	              }
	              if (eventObj.events.hasOwnProperty(eventName) && angular.isFunction(eventObj.events[eventName]) && !doIgnore) {
	                return google.maps.event.addListener(gObject, eventName, function() {
	                  if (!scope.$evalAsync) {
	                    scope.$evalAsync = function() {};
	                  }
	                  return scope.$evalAsync(eventHandler.apply(scope, [gObject, eventName, model, arguments]));
	                });
	              }
	            }));
	          }
	        },
	        removeEvents: function(listeners) {
	          var key, l;
	          if (!listeners) {
	            return;
	          }
	          for (key in listeners) {
	            l = listeners[key];
	            if (l && listeners.hasOwnProperty(key)) {
	              google.maps.event.removeListener(l);
	            }
	          }
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps.directives.api.utils').service('uiGmapFitHelper', [
	    'uiGmapLogger', '$timeout', function($log, $timeout) {
	      return {
	        fit: function(markersOrPoints, gMap) {
	          var bounds, everSet, key, markerOrPoint, point;
	          if (gMap && (markersOrPoints != null ? markersOrPoints.length : void 0)) {
	            bounds = new google.maps.LatLngBounds();
	            everSet = false;
	            for (key in markersOrPoints) {
	              markerOrPoint = markersOrPoints[key];
	              if (markerOrPoint) {
	                if (!everSet) {
	                  everSet = true;
	                }
	                point = _.isFunction(markerOrPoint.getPosition) ? markerOrPoint.getPosition() : markerOrPoint;
	              }
	              bounds.extend(point);
	            }
	            if (everSet) {
	              return $timeout(function() {
	                return gMap.fitBounds(bounds);
	              });
	            }
	          }
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;
	/*global _:true, angular:true, google:true */
	
	(function() {
	  angular.module('uiGmapgoogle-maps.directives.api.utils').service('uiGmapGmapUtil', [
	    'uiGmapLogger', '$compile', function(Logger, $compile) {
	      var _isFalse, _isTruthy, getCoords, getLatitude, getLongitude, validateCoords;
	      _isTruthy = function(value, bool, optionsArray) {
	        return value === bool || optionsArray.indexOf(value) !== -1;
	      };
	      _isFalse = function(value) {
	        return _isTruthy(value, false, ['false', 'FALSE', 0, 'n', 'N', 'no', 'NO']);
	      };
	      getLatitude = function(value) {
	        if (Array.isArray(value) && value.length === 2) {
	          return value[1];
	        } else if (angular.isDefined(value.type) && value.type === 'Point') {
	          return value.coordinates[1];
	        } else {
	          return value.latitude;
	        }
	      };
	      getLongitude = function(value) {
	        if (Array.isArray(value) && value.length === 2) {
	          return value[0];
	        } else if (angular.isDefined(value.type) && value.type === 'Point') {
	          return value.coordinates[0];
	        } else {
	          return value.longitude;
	        }
	      };
	      getCoords = function(value) {
	        if (!value) {
	          return;
	        }
	        if (value instanceof google.maps.LatLng) {
	          return value;
	        } else if (Array.isArray(value) && value.length === 2) {
	          return new google.maps.LatLng(value[1], value[0]);
	        } else if (angular.isDefined(value.type) && value.type === 'Point') {
	          return new google.maps.LatLng(value.coordinates[1], value.coordinates[0]);
	        } else {
	          return new google.maps.LatLng(value.latitude, value.longitude);
	        }
	      };
	      validateCoords = function(coords) {
	        if (angular.isUndefined(coords)) {
	          return false;
	        }
	        if (_.isArray(coords)) {
	          if (coords.length === 2) {
	            return true;
	          }
	        } else if ((coords != null) && (coords != null ? coords.type : void 0)) {
	          if (coords.type === 'Point' && _.isArray(coords.coordinates) && coords.coordinates.length === 2) {
	            return true;
	          }
	        }
	        if (coords && angular.isDefined((coords != null ? coords.latitude : void 0) && angular.isDefined(coords != null ? coords.longitude : void 0))) {
	          return true;
	        }
	        return false;
	      };
	      return {
	        setCoordsFromEvent: function(prevValue, newLatLon) {
	          if (!prevValue) {
	            return;
	          }
	          if (Array.isArray(prevValue) && prevValue.length === 2) {
	            prevValue[1] = newLatLon.lat();
	            prevValue[0] = newLatLon.lng();
	          } else if (angular.isDefined(prevValue.type) && prevValue.type === 'Point') {
	            prevValue.coordinates[1] = newLatLon.lat();
	            prevValue.coordinates[0] = newLatLon.lng();
	          } else {
	            prevValue.latitude = newLatLon.lat();
	            prevValue.longitude = newLatLon.lng();
	          }
	          return prevValue;
	        },
	        getLabelPositionPoint: function(anchor) {
	          var xPos, yPos;
	          if (anchor === void 0) {
	            return void 0;
	          }
	          anchor = /^([-\d\.]+)\s([-\d\.]+)$/.exec(anchor);
	          xPos = parseFloat(anchor[1]);
	          yPos = parseFloat(anchor[2]);
	          if ((xPos != null) && (yPos != null)) {
	            return new google.maps.Point(xPos, yPos);
	          }
	        },
	        createWindowOptions: function(gMarker, scope, content, defaults) {
	          var options;
	          if ((content != null) && (defaults != null) && ($compile != null)) {
	            options = angular.extend({}, defaults, {
	              content: this.buildContent(scope, defaults, content),
	              position: defaults.position != null ? defaults.position : angular.isObject(gMarker) ? gMarker.getPosition() : getCoords(scope.coords)
	            });
	            if ((gMarker != null) && ((options != null ? options.pixelOffset : void 0) == null)) {
	              if (options.boxClass == null) {
	
	              } else {
	                options.pixelOffset = {
	                  height: 0,
	                  width: -2
	                };
	              }
	            }
	            return options;
	          } else {
	            if (!defaults) {
	              Logger.error('infoWindow defaults not defined');
	              if (!content) {
	                return Logger.error('infoWindow content not defined');
	              }
	            } else {
	              return defaults;
	            }
	          }
	        },
	        buildContent: function(scope, defaults, content) {
	          var parsed, ret;
	          if (defaults.content != null) {
	            ret = defaults.content;
	          } else {
	            if ($compile != null) {
	              content = content.replace(/^\s+|\s+$/g, '');
	              parsed = content === '' ? '' : $compile(content)(scope);
	              if (parsed.length > 0) {
	                ret = parsed[0];
	              }
	            } else {
	              ret = content;
	            }
	          }
	          return ret;
	        },
	        defaultDelay: 50,
	        isTrue: function(value) {
	          return _isTruthy(value, true, ['true', 'TRUE', 1, 'y', 'Y', 'yes', 'YES']);
	        },
	        isFalse: _isFalse,
	        isFalsy: function(value) {
	          return _isTruthy(value, false, [void 0, null]) || _isFalse(value);
	        },
	        getCoords: getCoords,
	        validateCoords: validateCoords,
	        equalCoords: function(coord1, coord2) {
	          return getLatitude(coord1) === getLatitude(coord2) && getLongitude(coord1) === getLongitude(coord2);
	        },
	        validatePath: function(path) {
	          var array, i, polygon, trackMaxVertices;
	          i = 0;
	          if (angular.isUndefined(path.type)) {
	            if (!Array.isArray(path) || path.length < 2) {
	              return false;
	            }
	            while (i < path.length) {
	              if (!((angular.isDefined(path[i].latitude) && angular.isDefined(path[i].longitude)) || (typeof path[i].lat === 'function' && typeof path[i].lng === 'function'))) {
	                return false;
	              }
	              i++;
	            }
	            return true;
	          } else {
	            if (angular.isUndefined(path.coordinates)) {
	              return false;
	            }
	            if (path.type === 'Polygon') {
	              if (path.coordinates[0].length < 4) {
	                return false;
	              }
	              array = path.coordinates[0];
	            } else if (path.type === 'MultiPolygon') {
	              trackMaxVertices = {
	                max: 0,
	                index: 0
	              };
	              _.forEach(path.coordinates, function(polygon, index) {
	                if (polygon[0].length > this.max) {
	                  this.max = polygon[0].length;
	                  return this.index = index;
	                }
	              }, trackMaxVertices);
	              polygon = path.coordinates[trackMaxVertices.index];
	              array = polygon[0];
	              if (array.length < 4) {
	                return false;
	              }
	            } else if (path.type === 'LineString') {
	              if (path.coordinates.length < 2) {
	                return false;
	              }
	              array = path.coordinates;
	            } else {
	              return false;
	            }
	            while (i < array.length) {
	              if (array[i].length !== 2) {
	                return false;
	              }
	              i++;
	            }
	            return true;
	          }
	        },
	        convertPathPoints: function(path) {
	          var array, i, latlng, result, trackMaxVertices;
	          i = 0;
	          result = new google.maps.MVCArray();
	          if (angular.isUndefined(path.type)) {
	            while (i < path.length) {
	              latlng;
	              if (angular.isDefined(path[i].latitude) && angular.isDefined(path[i].longitude)) {
	                latlng = new google.maps.LatLng(path[i].latitude, path[i].longitude);
	              } else if (typeof path[i].lat === 'function' && typeof path[i].lng === 'function') {
	                latlng = path[i];
	              }
	              result.push(latlng);
	              i++;
	            }
	          } else {
	            array;
	            if (path.type === 'Polygon') {
	              array = path.coordinates[0];
	            } else if (path.type === 'MultiPolygon') {
	              trackMaxVertices = {
	                max: 0,
	                index: 0
	              };
	              _.forEach(path.coordinates, function(polygon, index) {
	                if (polygon[0].length > this.max) {
	                  this.max = polygon[0].length;
	                  return this.index = index;
	                }
	              }, trackMaxVertices);
	              array = path.coordinates[trackMaxVertices.index][0];
	            } else if (path.type === 'LineString') {
	              array = path.coordinates;
	            }
	            while (i < array.length) {
	              result.push(new google.maps.LatLng(array[i][1], array[i][0]));
	              i++;
	            }
	          }
	          return result;
	        },
	        getPath: function(object, key) {
	          var obj;
	          if ((key == null) || !_.isString(key)) {
	            return key;
	          }
	          obj = object;
	          _.each(key.split('.'), function(value) {
	            if (obj) {
	              return obj = obj[value];
	            }
	          });
	          return obj;
	        },
	        validateBoundPoints: function(bounds) {
	          if (angular.isUndefined(bounds.sw.latitude) || angular.isUndefined(bounds.sw.longitude) || angular.isUndefined(bounds.ne.latitude) || angular.isUndefined(bounds.ne.longitude)) {
	            return false;
	          }
	          return true;
	        },
	        convertBoundPoints: function(bounds) {
	          var result;
	          result = new google.maps.LatLngBounds(new google.maps.LatLng(bounds.sw.latitude, bounds.sw.longitude), new google.maps.LatLng(bounds.ne.latitude, bounds.ne.longitude));
	          return result;
	        },
	        fitMapBounds: function(map, bounds) {
	          return map.fitBounds(bounds);
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps.directives.api.utils').service('uiGmapIsReady', [
	    '$q', '$timeout', function($q, $timeout) {
	      var _checkIfReady, _ctr, _promises, _proms;
	      _ctr = 0;
	      _proms = [];
	      _promises = function() {
	        return $q.all(_proms);
	      };
	      _checkIfReady = function(deferred, expectedInstances, retriesLeft) {
	        return $timeout(function() {
	          if (retriesLeft <= 0) {
	            deferred.reject('Your maps are not found we have checked the maximum amount of times. :)');
	            return;
	          }
	          if (_ctr !== expectedInstances) {
	            _checkIfReady(deferred, expectedInstances, retriesLeft - 1);
	          } else {
	            deferred.resolve(_promises());
	          }
	        }, 100);
	      };
	      return {
	        spawn: function() {
	          var d;
	          d = $q.defer();
	          _proms.push(d.promise);
	          _ctr += 1;
	          return {
	            instance: _ctr,
	            deferred: d
	          };
	        },
	        promises: _promises,
	        instances: function() {
	          return _ctr;
	        },
	        promise: function(expectedInstances, numRetries) {
	          var d;
	          if (expectedInstances == null) {
	            expectedInstances = 1;
	          }
	          if (numRetries == null) {
	            numRetries = 50;
	          }
	          d = $q.defer();
	          _checkIfReady(d, expectedInstances, numRetries);
	          return d.promise;
	        },
	        reset: function() {
	          _ctr = 0;
	          _proms.length = 0;
	        },
	        decrement: function() {
	          if (_ctr > 0) {
	            _ctr -= 1;
	          }
	          if (_proms.length) {
	            _proms.length -= 1;
	          }
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module("uiGmapgoogle-maps.directives.api.utils").factory("uiGmapLinked", [
	    "uiGmapBaseObject", function(BaseObject) {
	      var Linked;
	      Linked = (function(superClass) {
	        extend(Linked, superClass);
	
	        function Linked(scope, element, attrs, ctrls) {
	          this.scope = scope;
	          this.element = element;
	          this.attrs = attrs;
	          this.ctrls = ctrls;
	        }
	
	        return Linked;
	
	      })(BaseObject);
	      return Linked;
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps.directives.api.utils').service('uiGmapLogger', [
	    'nemSimpleLogger', function(nemSimpleLogger) {
	      return nemSimpleLogger.spawn();
	    }
	  ]);
	
	}).call(this);
	;
	/*global _:true, angular:true */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api.utils').factory('uiGmapModelKey', [
	    'uiGmapBaseObject', 'uiGmapGmapUtil', function(BaseObject, GmapUtil) {
	      return (function(superClass) {
	        extend(_Class, superClass);
	
	        function _Class(scope1, _interface) {
	          this.scope = scope1;
	          this["interface"] = _interface != null ? _interface : {
	            scopeKeys: []
	          };
	          this.modelsLength = bind(this.modelsLength, this);
	          this.updateChild = bind(this.updateChild, this);
	          this.destroy = bind(this.destroy, this);
	          this.setChildScope = bind(this.setChildScope, this);
	          this.getChanges = bind(this.getChanges, this);
	          this.getProp = bind(this.getProp, this);
	          this.setIdKey = bind(this.setIdKey, this);
	          this.modelKeyComparison = bind(this.modelKeyComparison, this);
	          _Class.__super__.constructor.call(this);
	          this.defaultIdKey = 'id';
	          this.idKey = void 0;
	        }
	
	        _Class.prototype.evalModelHandle = function(model, modelKey) {
	          if ((model == null) || (modelKey == null)) {
	            return;
	          }
	          if (modelKey === 'self') {
	            return model;
	          } else {
	            if (_.isFunction(modelKey)) {
	              modelKey = modelKey();
	            }
	            return GmapUtil.getPath(model, modelKey);
	          }
	        };
	
	        _Class.prototype.modelKeyComparison = function(model1, model2) {
	          var coord1, coord2, hasCoords, isEqual, scope, without;
	          hasCoords = this["interface"].scopeKeys.indexOf('coords') >= 0;
	          if (hasCoords && (this.scope.coords != null) || !hasCoords) {
	            scope = this.scope;
	          }
	          if (scope == null) {
	            throw 'No scope set!';
	          }
	          if (hasCoords) {
	            coord1 = this.scopeOrModelVal('coords', scope, model1);
	            coord2 = this.scopeOrModelVal('coords', scope, model2);
	            isEqual = GmapUtil.equalCoords(coord1, coord2);
	            if (!isEqual) {
	              return isEqual;
	            }
	          }
	          without = _.without(this["interface"].scopeKeys, 'coords');
	          isEqual = _.every(without, (function(_this) {
	            return function(k) {
	              var m1, m2;
	              m1 = _this.scopeOrModelVal(scope[k], scope, model1);
	              m2 = _this.scopeOrModelVal(scope[k], scope, model2);
	              if (scope.deepComparison) {
	                return _.isEqual(m1, m2);
	              } else {
	                return m1 === m2;
	              }
	            };
	          })(this));
	          return isEqual;
	        };
	
	        _Class.prototype.setIdKey = function(scope) {
	          return this.idKey = scope.idKey != null ? scope.idKey : this.defaultIdKey;
	        };
	
	        _Class.prototype.setVal = function(model, key, newValue) {
	          this.modelOrKey(model, key = newValue);
	          return model;
	        };
	
	        _Class.prototype.modelOrKey = function(model, key) {
	          if (key == null) {
	            return;
	          }
	          if (key !== 'self') {
	            return GmapUtil.getPath(model, key);
	          }
	          return model;
	        };
	
	        _Class.prototype.getProp = function(propName, scope, model) {
	          return this.scopeOrModelVal(propName, scope, model);
	        };
	
	
	        /*
	        For the cases were watching a large object we only want to know the list of props
	        that actually changed.
	        Also we want to limit the amount of props we analyze to whitelisted props that are
	        actually tracked by scope. (should make things faster with whitelisted)
	         */
	
	        _Class.prototype.getChanges = function(now, prev, whitelistedProps) {
	          var c, changes, prop;
	          if (whitelistedProps) {
	            prev = _.pick(prev, whitelistedProps);
	            now = _.pick(now, whitelistedProps);
	          }
	          changes = {};
	          prop = {};
	          c = {};
	          for (prop in now) {
	            if (!prev || prev[prop] !== now[prop]) {
	              if (_.isArray(now[prop])) {
	                changes[prop] = now[prop];
	              } else if (_.isObject(now[prop])) {
	                c = this.getChanges(now[prop], (prev ? prev[prop] : null));
	                if (!_.isEmpty(c)) {
	                  changes[prop] = c;
	                }
	              } else {
	                changes[prop] = now[prop];
	              }
	            }
	          }
	          return changes;
	        };
	
	        _Class.prototype.scopeOrModelVal = function(key, scope, model, doWrap) {
	          var maybeWrap, modelKey, modelProp, scopeProp;
	          if (doWrap == null) {
	            doWrap = false;
	          }
	          maybeWrap = function(isScope, ret, doWrap) {
	            if (doWrap == null) {
	              doWrap = false;
	            }
	            if (doWrap) {
	              return {
	                isScope: isScope,
	                value: ret
	              };
	            }
	            return ret;
	          };
	          scopeProp = _.get(scope, key);
	          if (_.isFunction(scopeProp)) {
	            return maybeWrap(true, scopeProp(model), doWrap);
	          }
	          if (_.isObject(scopeProp)) {
	            return maybeWrap(true, scopeProp, doWrap);
	          }
	          if (!_.isString(scopeProp)) {
	            return maybeWrap(true, scopeProp, doWrap);
	          }
	          modelKey = scopeProp;
	          if (!modelKey) {
	            modelProp = _.get(model, key);
	          } else {
	            modelProp = modelKey === 'self' ? model : _.get(model, modelKey);
	          }
	          if (_.isFunction(modelProp)) {
	            return maybeWrap(false, modelProp(), doWrap);
	          }
	          return maybeWrap(false, modelProp, doWrap);
	        };
	
	        _Class.prototype.setChildScope = function(keys, childScope, model) {
	          var isScopeObj, key, name, newValue;
	          for (key in keys) {
	            name = keys[key];
	            isScopeObj = this.scopeOrModelVal(name, childScope, model, true);
	            if ((isScopeObj != null ? isScopeObj.value : void 0) != null) {
	              newValue = isScopeObj.value;
	              if (newValue !== childScope[name]) {
	                childScope[name] = newValue;
	              }
	            }
	          }
	          return childScope.model = model;
	        };
	
	        _Class.prototype.onDestroy = function(scope) {};
	
	        _Class.prototype.destroy = function(manualOverride) {
	          var ref;
	          if (manualOverride == null) {
	            manualOverride = false;
	          }
	          if ((this.scope != null) && !((ref = this.scope) != null ? ref.$$destroyed : void 0) && (this.needToManualDestroy || manualOverride)) {
	            return this.scope.$destroy();
	          } else {
	            return this.clean();
	          }
	        };
	
	        _Class.prototype.updateChild = function(child, model) {
	          if (model[this.idKey] == null) {
	            this.$log.error("Model has no id to assign a child to. This is required for performance. Please assign id, or redirect id to a different key.");
	            return;
	          }
	          return child.updateModel(model);
	        };
	
	        _Class.prototype.modelsLength = function(arrayOrObjModels) {
	          var len, toCheck;
	          if (arrayOrObjModels == null) {
	            arrayOrObjModels = void 0;
	          }
	          len = 0;
	          toCheck = arrayOrObjModels ? arrayOrObjModels : this.scope.models;
	          if (toCheck == null) {
	            return len;
	          }
	          if (angular.isArray(toCheck) || (toCheck.length != null)) {
	            len = toCheck.length;
	          } else {
	            len = Object.keys(toCheck).length;
	          }
	          return len;
	        };
	
	        return _Class;
	
	      })(BaseObject);
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps.directives.api.utils').factory('uiGmapModelsWatcher', [
	    'uiGmapLogger', 'uiGmap_async', '$q', 'uiGmapPromise', function(Logger, _async, $q, uiGmapPromise) {
	      return {
	        didQueueInitPromise: function(existingPiecesObj, scope) {
	          if (scope.models.length === 0) {
	            _async.promiseLock(existingPiecesObj, uiGmapPromise.promiseTypes.init, null, null, (function() {
	              return uiGmapPromise.resolve();
	            }));
	            return true;
	          }
	          return false;
	        },
	        figureOutState: function(idKey, scope, childObjects, comparison, callBack) {
	          var adds, children, mappedScopeModelIds, removals, updates;
	          adds = [];
	          mappedScopeModelIds = {};
	          removals = [];
	          updates = [];
	          scope.models.forEach(function(m) {
	            var child;
	            if (m[idKey] != null) {
	              mappedScopeModelIds[m[idKey]] = {};
	              if (childObjects.get(m[idKey]) == null) {
	                return adds.push(m);
	              } else {
	                child = childObjects.get(m[idKey]);
	                if (!comparison(m, child.clonedModel, scope)) {
	                  return updates.push({
	                    model: m,
	                    child: child
	                  });
	                }
	              }
	            } else {
	              return Logger.error(' id missing for model #{m.toString()},\ncan not use do comparison/insertion');
	            }
	          });
	          children = childObjects.values();
	          children.forEach(function(c) {
	            var id;
	            if (c == null) {
	              Logger.error('child undefined in ModelsWatcher.');
	              return;
	            }
	            if (c.model == null) {
	              Logger.error('child.model undefined in ModelsWatcher.');
	              return;
	            }
	            id = c.model[idKey];
	            if (mappedScopeModelIds[id] == null) {
	              return removals.push(c);
	            }
	          });
	          return {
	            adds: adds,
	            removals: removals,
	            updates: updates
	          };
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps.directives.api.utils').service('uiGmapPromise', [
	    '$q', '$timeout', 'uiGmapLogger', function($q, $timeout, $log) {
	      var ExposedPromise, SniffedPromise, defer, isInProgress, isResolved, promise, promiseStatus, promiseStatuses, promiseTypes, resolve, strPromiseStatuses;
	      promiseTypes = {
	        create: 'create',
	        update: 'update',
	        "delete": 'delete',
	        init: 'init'
	      };
	      promiseStatuses = {
	        IN_PROGRESS: 0,
	        RESOLVED: 1,
	        REJECTED: 2
	      };
	      strPromiseStatuses = (function() {
	        var obj;
	        obj = {};
	        obj["" + promiseStatuses.IN_PROGRESS] = 'in-progress';
	        obj["" + promiseStatuses.RESOLVED] = 'resolved';
	        obj["" + promiseStatuses.REJECTED] = 'rejected';
	        return obj;
	      })();
	      isInProgress = function(promise) {
	        if (promise.$$state) {
	          return promise.$$state.status === promiseStatuses.IN_PROGRESS;
	        }
	        if (!promise.hasOwnProperty("$$v")) {
	          return true;
	        }
	      };
	      isResolved = function(promise) {
	        if (promise.$$state) {
	          return promise.$$state.status === promiseStatuses.RESOLVED;
	        }
	        if (promise.hasOwnProperty("$$v")) {
	          return true;
	        }
	      };
	      promiseStatus = function(status) {
	        return strPromiseStatuses[status] || 'done w error';
	      };
	      ExposedPromise = function(promise) {
	        var cancelDeferred, combined, wrapped;
	        cancelDeferred = $q.defer();
	        combined = $q.all([promise, cancelDeferred.promise]);
	        wrapped = $q.defer();
	        promise.then(cancelDeferred.resolve, (function() {}), function(notify) {
	          cancelDeferred.notify(notify);
	          return wrapped.notify(notify);
	        });
	        combined.then(function(successes) {
	          return wrapped.resolve(successes[0] || successes[1]);
	        }, function(error) {
	          return wrapped.reject(error);
	        });
	        wrapped.promise.cancel = function(reason) {
	          if (reason == null) {
	            reason = 'canceled';
	          }
	          return cancelDeferred.reject(reason);
	        };
	        wrapped.promise.notify = function(msg) {
	          if (msg == null) {
	            msg = 'cancel safe';
	          }
	          wrapped.notify(msg);
	          if (promise.hasOwnProperty('notify')) {
	            return promise.notify(msg);
	          }
	        };
	        if (promise.promiseType != null) {
	          wrapped.promise.promiseType = promise.promiseType;
	        }
	        return wrapped.promise;
	      };
	      SniffedPromise = function(fnPromise, promiseType) {
	        return {
	          promise: fnPromise,
	          promiseType: promiseType
	        };
	      };
	      defer = function() {
	        return $q.defer();
	      };
	      resolve = function() {
	        var d;
	        d = $q.defer();
	        d.resolve.apply(void 0, arguments);
	        return d.promise;
	      };
	      promise = function(fnToWrap) {
	        var d;
	        if (!_.isFunction(fnToWrap)) {
	          $log.error("uiGmapPromise.promise() only accepts functions");
	          return;
	        }
	        d = $q.defer();
	        $timeout(function() {
	          var result;
	          result = fnToWrap();
	          return d.resolve(result);
	        });
	        return d.promise;
	      };
	      return {
	        defer: defer,
	        promise: promise,
	        resolve: resolve,
	        promiseTypes: promiseTypes,
	        isInProgress: isInProgress,
	        isResolved: isResolved,
	        promiseStatus: promiseStatus,
	        ExposedPromise: ExposedPromise,
	        SniffedPromise: SniffedPromise
	      };
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	  angular.module("uiGmapgoogle-maps.directives.api.utils").factory("uiGmapPropMap", function() {
	
	    /*
	      Simple Object Map with a length property to make it easy to track length/size
	     */
	    var PropMap;
	    return PropMap = (function() {
	      function PropMap() {
	        this.removeAll = bind(this.removeAll, this);
	        this.slice = bind(this.slice, this);
	        this.push = bind(this.push, this);
	        this.keys = bind(this.keys, this);
	        this.values = bind(this.values, this);
	        this.remove = bind(this.remove, this);
	        this.put = bind(this.put, this);
	        this.stateChanged = bind(this.stateChanged, this);
	        this.get = bind(this.get, this);
	        this.length = 0;
	        this.dict = {};
	        this.didValsStateChange = false;
	        this.didKeysStateChange = false;
	        this.allVals = [];
	        this.allKeys = [];
	      }
	
	      PropMap.prototype.get = function(key) {
	        return this.dict[key];
	      };
	
	      PropMap.prototype.stateChanged = function() {
	        this.didValsStateChange = true;
	        return this.didKeysStateChange = true;
	      };
	
	      PropMap.prototype.put = function(key, value) {
	        if (this.get(key) == null) {
	          this.length++;
	        }
	        this.stateChanged();
	        return this.dict[key] = value;
	      };
	
	      PropMap.prototype.remove = function(key, isSafe) {
	        var value;
	        if (isSafe == null) {
	          isSafe = false;
	        }
	        if (isSafe && !this.get(key)) {
	          return void 0;
	        }
	        value = this.dict[key];
	        delete this.dict[key];
	        this.length--;
	        this.stateChanged();
	        return value;
	      };
	
	      PropMap.prototype.valuesOrKeys = function(str) {
	        var keys, vals;
	        if (str == null) {
	          str = 'Keys';
	        }
	        if (!this["did" + str + "StateChange"]) {
	          return this['all' + str];
	        }
	        vals = [];
	        keys = [];
	        _.each(this.dict, function(v, k) {
	          vals.push(v);
	          return keys.push(k);
	        });
	        this.didKeysStateChange = false;
	        this.didValsStateChange = false;
	        this.allVals = vals;
	        this.allKeys = keys;
	        return this['all' + str];
	      };
	
	      PropMap.prototype.values = function() {
	        return this.valuesOrKeys('Vals');
	      };
	
	      PropMap.prototype.keys = function() {
	        return this.valuesOrKeys();
	      };
	
	      PropMap.prototype.push = function(obj, key) {
	        if (key == null) {
	          key = "key";
	        }
	        return this.put(obj[key], obj);
	      };
	
	      PropMap.prototype.slice = function() {
	        return this.keys().map((function(_this) {
	          return function(k) {
	            return _this.remove(k);
	          };
	        })(this));
	      };
	
	      PropMap.prototype.removeAll = function() {
	        return this.slice();
	      };
	
	      PropMap.prototype.each = function(cb) {
	        return _.each(this.dict, function(v, k) {
	          return cb(v);
	        });
	      };
	
	      PropMap.prototype.map = function(cb) {
	        return _.map(this.dict, function(v, k) {
	          return cb(v);
	        });
	      };
	
	      return PropMap;
	
	    })();
	  });
	
	}).call(this);
	;
	/*globals angular,_ */
	
	(function() {
	  angular.module("uiGmapgoogle-maps.directives.api.utils").factory("uiGmapPropertyAction", [
	    "uiGmapLogger", function(Logger) {
	      var PropertyAction;
	      PropertyAction = function(setterFn) {
	        this.setIfChange = function(callingKey) {
	          return function(newVal, oldVal) {
	            if (!_.isEqual(oldVal, newVal)) {
	              return setterFn(callingKey, newVal);
	            }
	          };
	        };
	        this.sic = this.setIfChange;
	        return this;
	      };
	      return PropertyAction;
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	  angular.module('uiGmapgoogle-maps.directives.api.managers').factory('uiGmapClustererMarkerManager', [
	    'uiGmapLogger', 'uiGmapFitHelper', 'uiGmapPropMap', 'uiGmapEventsHelper', function($log, FitHelper, PropMap, EventsHelper) {
	      var ClustererMarkerManager;
	      ClustererMarkerManager = (function() {
	        ClustererMarkerManager.type = 'ClustererMarkerManager';
	
	        function ClustererMarkerManager(gMap, opt_markers, opt_options, opt_events) {
	          if (opt_markers == null) {
	            opt_markers = {};
	          }
	          this.opt_options = opt_options != null ? opt_options : {};
	          this.opt_events = opt_events;
	          this.getGMarkers = bind(this.getGMarkers, this);
	          this.fit = bind(this.fit, this);
	          this.destroy = bind(this.destroy, this);
	          this.attachEvents = bind(this.attachEvents, this);
	          this.clear = bind(this.clear, this);
	          this.draw = bind(this.draw, this);
	          this.removeMany = bind(this.removeMany, this);
	          this.remove = bind(this.remove, this);
	          this.addMany = bind(this.addMany, this);
	          this.update = bind(this.update, this);
	          this.add = bind(this.add, this);
	          this.type = ClustererMarkerManager.type;
	          this.clusterer = new NgMapMarkerClusterer(gMap, opt_markers, this.opt_options);
	          this.propMapGMarkers = new PropMap();
	          this.attachEvents(this.opt_events, 'opt_events');
	          this.clusterer.setIgnoreHidden(true);
	          this.noDrawOnSingleAddRemoves = true;
	          $log.info(this);
	        }
	
	        ClustererMarkerManager.prototype.checkKey = function(gMarker) {
	          var msg;
	          if (gMarker.key == null) {
	            msg = 'gMarker.key undefined and it is REQUIRED!!';
	            return $log.error(msg);
	          }
	        };
	
	        ClustererMarkerManager.prototype.add = function(gMarker) {
	          this.checkKey(gMarker);
	          this.clusterer.addMarker(gMarker, this.noDrawOnSingleAddRemoves);
	          this.propMapGMarkers.put(gMarker.key, gMarker);
	          return this.checkSync();
	        };
	
	        ClustererMarkerManager.prototype.update = function(gMarker) {
	          this.remove(gMarker);
	          return this.add(gMarker);
	        };
	
	        ClustererMarkerManager.prototype.addMany = function(gMarkers) {
	          return gMarkers.forEach((function(_this) {
	            return function(gMarker) {
	              return _this.add(gMarker);
	            };
	          })(this));
	        };
	
	        ClustererMarkerManager.prototype.remove = function(gMarker) {
	          var exists;
	          this.checkKey(gMarker);
	          exists = this.propMapGMarkers.get(gMarker.key);
	          if (exists) {
	            this.clusterer.removeMarker(gMarker, this.noDrawOnSingleAddRemoves);
	            this.propMapGMarkers.remove(gMarker.key);
	          }
	          return this.checkSync();
	        };
	
	        ClustererMarkerManager.prototype.removeMany = function(gMarkers) {
	          return gMarkers.forEach((function(_this) {
	            return function(gMarker) {
	              return _this.remove(gMarker);
	            };
	          })(this));
	        };
	
	        ClustererMarkerManager.prototype.draw = function() {
	          return this.clusterer.repaint();
	        };
	
	        ClustererMarkerManager.prototype.clear = function() {
	          this.removeMany(this.getGMarkers());
	          return this.clusterer.repaint();
	        };
	
	        ClustererMarkerManager.prototype.attachEvents = function(options, optionsName) {
	          var eventHandler, eventName, results;
	          this.listeners = [];
	          if (angular.isDefined(options) && (options != null) && angular.isObject(options)) {
	            results = [];
	            for (eventName in options) {
	              eventHandler = options[eventName];
	              if (options.hasOwnProperty(eventName) && angular.isFunction(options[eventName])) {
	                $log.info(optionsName + ": Attaching event: " + eventName + " to clusterer");
	                results.push(this.listeners.push(google.maps.event.addListener(this.clusterer, eventName, options[eventName])));
	              } else {
	                results.push(void 0);
	              }
	            }
	            return results;
	          }
	        };
	
	        ClustererMarkerManager.prototype.clearEvents = function() {
	          EventsHelper.removeEvents(this.listeners);
	          return this.listeners = [];
	        };
	
	        ClustererMarkerManager.prototype.destroy = function() {
	          this.clearEvents();
	          return this.clear();
	        };
	
	        ClustererMarkerManager.prototype.fit = function() {
	          return FitHelper.fit(this.getGMarkers(), this.clusterer.getMap());
	        };
	
	        ClustererMarkerManager.prototype.getGMarkers = function() {
	          return this.clusterer.getMarkers().values();
	        };
	
	        ClustererMarkerManager.prototype.checkSync = function() {};
	
	        return ClustererMarkerManager;
	
	      })();
	      return ClustererMarkerManager;
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps.directives.api.managers').service('uiGmapGoogleMapObjectManager', [
	    function() {
	      var _availableInstances, _usedInstances;
	      _availableInstances = [];
	      _usedInstances = [];
	      return {
	        createMapInstance: function(parentElement, options) {
	          var instance;
	          instance = null;
	          if (_availableInstances.length === 0) {
	            instance = new google.maps.Map(parentElement, options);
	            _usedInstances.push(instance);
	          } else {
	            instance = _availableInstances.pop();
	            angular.element(parentElement).append(instance.getDiv());
	            instance.setOptions(options);
	            _usedInstances.push(instance);
	          }
	          return instance;
	        },
	        recycleMapInstance: function(instance) {
	          var index;
	          index = _usedInstances.indexOf(instance);
	          if (index < 0) {
	            throw new Error('Expected map instance to be a previously used instance');
	          }
	          _usedInstances.splice(index, 1);
	          return _availableInstances.push(instance);
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	  angular.module("uiGmapgoogle-maps.directives.api.managers").factory("uiGmapMarkerManager", [
	    "uiGmapLogger", "uiGmapFitHelper", "uiGmapPropMap", function(Logger, FitHelper, PropMap) {
	      var MarkerManager;
	      MarkerManager = (function() {
	        MarkerManager.type = 'MarkerManager';
	
	        function MarkerManager(gMap, opt_markers, opt_options) {
	          this.getGMarkers = bind(this.getGMarkers, this);
	          this.fit = bind(this.fit, this);
	          this.handleOptDraw = bind(this.handleOptDraw, this);
	          this.clear = bind(this.clear, this);
	          this.destroy = bind(this.destroy, this);
	          this.draw = bind(this.draw, this);
	          this.removeMany = bind(this.removeMany, this);
	          this.remove = bind(this.remove, this);
	          this.addMany = bind(this.addMany, this);
	          this.update = bind(this.update, this);
	          this.add = bind(this.add, this);
	          this.type = MarkerManager.type;
	          this.gMap = gMap;
	          this.gMarkers = new PropMap();
	          this.$log = Logger;
	          this.$log.info(this);
	        }
	
	        MarkerManager.prototype.add = function(gMarker, optDraw) {
	          var exists, msg;
	          if (optDraw == null) {
	            optDraw = true;
	          }
	          if (gMarker.key == null) {
	            msg = "gMarker.key undefined and it is REQUIRED!!";
	            Logger.error(msg);
	            throw msg;
	          }
	          exists = this.gMarkers.get(gMarker.key);
	          if (!exists) {
	            this.handleOptDraw(gMarker, optDraw, true);
	            return this.gMarkers.put(gMarker.key, gMarker);
	          }
	        };
	
	        MarkerManager.prototype.update = function(gMarker, optDraw) {
	          if (optDraw == null) {
	            optDraw = true;
	          }
	          this.remove(gMarker, optDraw);
	          return this.add(gMarker, optDraw);
	        };
	
	        MarkerManager.prototype.addMany = function(gMarkers) {
	          return gMarkers.forEach((function(_this) {
	            return function(gMarker) {
	              return _this.add(gMarker);
	            };
	          })(this));
	        };
	
	        MarkerManager.prototype.remove = function(gMarker, optDraw) {
	          if (optDraw == null) {
	            optDraw = true;
	          }
	          this.handleOptDraw(gMarker, optDraw, false);
	          if (this.gMarkers.get(gMarker.key)) {
	            return this.gMarkers.remove(gMarker.key);
	          }
	        };
	
	        MarkerManager.prototype.removeMany = function(gMarkers) {
	          return gMarkers.forEach((function(_this) {
	            return function(marker) {
	              return _this.remove(marker);
	            };
	          })(this));
	        };
	
	        MarkerManager.prototype.draw = function() {
	          var deletes;
	          deletes = [];
	          this.gMarkers.each((function(_this) {
	            return function(gMarker) {
	              if (!gMarker.isDrawn) {
	                if (gMarker.doAdd) {
	                  gMarker.setMap(_this.gMap);
	                  return gMarker.isDrawn = true;
	                } else {
	                  return deletes.push(gMarker);
	                }
	              }
	            };
	          })(this));
	          return deletes.forEach((function(_this) {
	            return function(gMarker) {
	              gMarker.isDrawn = false;
	              return _this.remove(gMarker, true);
	            };
	          })(this));
	        };
	
	        MarkerManager.prototype.destroy = function() {
	          return this.clear();
	        };
	
	        MarkerManager.prototype.clear = function() {
	          this.gMarkers.each(function(gMarker) {
	            return gMarker.setMap(null);
	          });
	          delete this.gMarkers;
	          return this.gMarkers = new PropMap();
	        };
	
	        MarkerManager.prototype.handleOptDraw = function(gMarker, optDraw, doAdd) {
	          if (optDraw === true) {
	            if (doAdd) {
	              gMarker.setMap(this.gMap);
	            } else {
	              gMarker.setMap(null);
	            }
	            return gMarker.isDrawn = true;
	          } else {
	            gMarker.isDrawn = false;
	            return gMarker.doAdd = doAdd;
	          }
	        };
	
	        MarkerManager.prototype.fit = function() {
	          return FitHelper.fit(this.getGMarkers(), this.gMap);
	        };
	
	        MarkerManager.prototype.getGMarkers = function() {
	          return this.gMarkers.values();
	        };
	
	        return MarkerManager;
	
	      })();
	      return MarkerManager;
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	  angular.module('uiGmapgoogle-maps.directives.api.managers').factory('uiGmapSpiderfierMarkerManager', [
	    'uiGmapLogger', 'uiGmapFitHelper', 'uiGmapPropMap', 'uiGmapMarkerSpiderfier', function($log, FitHelper, PropMap, MarkerSpiderfier) {
	      var SpiderfierMarkerManager;
	      return SpiderfierMarkerManager = (function() {
	        SpiderfierMarkerManager.type = 'SpiderfierMarkerManager';
	
	        function SpiderfierMarkerManager(gMap, opt_markers, opt_options, opt_events, scope) {
	          if (opt_markers == null) {
	            opt_markers = {};
	          }
	          this.opt_options = opt_options != null ? opt_options : {};
	          this.opt_events = opt_events;
	          this.scope = scope;
	          this.isSpiderfied = bind(this.isSpiderfied, this);
	          this.getGMarkers = bind(this.getGMarkers, this);
	          this.fit = bind(this.fit, this);
	          this.destroy = bind(this.destroy, this);
	          this.attachEvents = bind(this.attachEvents, this);
	          this.clear = bind(this.clear, this);
	          this.removeMany = bind(this.removeMany, this);
	          this.remove = bind(this.remove, this);
	          this.addMany = bind(this.addMany, this);
	          this.update = bind(this.update, this);
	          this.add = bind(this.add, this);
	          this.type = SpiderfierMarkerManager.type;
	          this.markerSpiderfier = new MarkerSpiderfier(gMap, this.opt_options);
	          this.propMapGMarkers = new PropMap();
	          this.attachEvents(this.opt_events, 'opt_events');
	          this.noDrawOnSingleAddRemoves = true;
	          $log.info(this);
	        }
	
	        SpiderfierMarkerManager.prototype.checkKey = function(gMarker) {
	          var msg;
	          if (gMarker.key == null) {
	            msg = 'gMarker.key undefined and it is REQUIRED!!';
	            return $log.error(msg);
	          }
	        };
	
	        SpiderfierMarkerManager.prototype.add = function(gMarker) {
	          gMarker.setMap(this.markerSpiderfier.map);
	          this.checkKey(gMarker);
	          this.markerSpiderfier.addMarker(gMarker, this.noDrawOnSingleAddRemoves);
	          this.propMapGMarkers.put(gMarker.key, gMarker);
	          return this.checkSync();
	        };
	
	        SpiderfierMarkerManager.prototype.update = function(gMarker) {
	          this.remove(gMarker);
	          return this.add(gMarker);
	        };
	
	        SpiderfierMarkerManager.prototype.addMany = function(gMarkers) {
	          return gMarkers.forEach((function(_this) {
	            return function(gMarker) {
	              return _this.add(gMarker);
	            };
	          })(this));
	        };
	
	        SpiderfierMarkerManager.prototype.remove = function(gMarker) {
	          var exists;
	          this.checkKey(gMarker);
	          exists = this.propMapGMarkers.get(gMarker.key);
	          if (exists) {
	            gMarker.setMap(null);
	            this.markerSpiderfier.removeMarker(gMarker, this.noDrawOnSingleAddRemoves);
	            this.propMapGMarkers.remove(gMarker.key);
	          }
	          return this.checkSync();
	        };
	
	        SpiderfierMarkerManager.prototype.removeMany = function(gMarkers) {
	          return gMarkers.forEach((function(_this) {
	            return function(gMarker) {
	              return _this.remove(gMarker);
	            };
	          })(this));
	        };
	
	        SpiderfierMarkerManager.prototype.draw = function() {};
	
	        SpiderfierMarkerManager.prototype.clear = function() {
	          return this.removeMany(this.getGMarkers());
	        };
	
	        SpiderfierMarkerManager.prototype.attachEvents = function(options, optionsName) {
	          if (angular.isDefined(options) && (options != null) && angular.isObject(options)) {
	            return _.each(options, (function(_this) {
	              return function(eventHandler, eventName) {
	                if (options.hasOwnProperty(eventName) && angular.isFunction(options[eventName])) {
	                  $log.info(optionsName + ": Attaching event: " + eventName + " to markerSpiderfier");
	                  return _this.markerSpiderfier.addListener(eventName, function() {
	                    if (eventName === 'spiderfy' || eventName === 'unspiderfy') {
	                      return _this.scope.$evalAsync(options[eventName].apply(options, arguments));
	                    } else {
	                      return _this.scope.$evalAsync(options[eventName].apply(options, [arguments[0], eventName, arguments[0].model, arguments]));
	                    }
	                  });
	                }
	              };
	            })(this));
	          }
	        };
	
	        SpiderfierMarkerManager.prototype.clearEvents = function(options, optionsName) {
	          var eventHandler, eventName;
	          if (angular.isDefined(options) && (options != null) && angular.isObject(options)) {
	            for (eventName in options) {
	              eventHandler = options[eventName];
	              if (options.hasOwnProperty(eventName) && angular.isFunction(options[eventName])) {
	                $log.info(optionsName + ": Clearing event: " + eventName + " to markerSpiderfier");
	                this.markerSpiderfier.clearListeners(eventName);
	              }
	            }
	          }
	        };
	
	        SpiderfierMarkerManager.prototype.destroy = function() {
	          this.clearEvents(this.opt_events, 'opt_events');
	          return this.clear();
	        };
	
	        SpiderfierMarkerManager.prototype.fit = function() {
	          return FitHelper.fit(this.getGMarkers(), this.markerSpiderfier.map);
	        };
	
	        SpiderfierMarkerManager.prototype.getGMarkers = function() {
	          return this.markerSpiderfier.getMarkers();
	        };
	
	        SpiderfierMarkerManager.prototype.isSpiderfied = function() {
	          return _.find(this.getGMarkers(), function(gMarker) {
	            return (gMarker != null ? gMarker._omsData : void 0) != null;
	          });
	        };
	
	        SpiderfierMarkerManager.prototype.checkSync = function() {};
	
	        return SpiderfierMarkerManager;
	
	      })();
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps').factory('uiGmapadd-events', [
	    '$timeout', function($timeout) {
	      var addEvent, addEvents;
	      addEvent = function(target, eventName, handler) {
	        return google.maps.event.addListener(target, eventName, function() {
	          handler.apply(this, arguments);
	          return $timeout((function() {}), true);
	        });
	      };
	      addEvents = function(target, eventName, handler) {
	        var remove;
	        if (handler) {
	          return addEvent(target, eventName, handler);
	        }
	        remove = [];
	        angular.forEach(eventName, function(_handler, key) {
	          return remove.push(addEvent(target, key, _handler));
	        });
	        return function() {
	          angular.forEach(remove, function(listener) {
	            return google.maps.event.removeListener(listener);
	          });
	          return remove = null;
	        };
	      };
	      return addEvents;
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps').factory('uiGmaparray-sync', [
	    'uiGmapadd-events', function(mapEvents) {
	      return function(mapArray, scope, pathEval, pathChangedFn) {
	        var geojsonArray, geojsonHandlers, geojsonWatcher, isSetFromScope, legacyHandlers, legacyWatcher, mapArrayListener, scopePath, watchListener;
	        isSetFromScope = false;
	        scopePath = scope.$eval(pathEval);
	        if (!scope["static"]) {
	          legacyHandlers = {
	            set_at: function(index) {
	              var value;
	              if (isSetFromScope) {
	                return;
	              }
	              value = mapArray.getAt(index);
	              if (!value) {
	                return;
	              }
	              if (!value.lng || !value.lat) {
	                return scopePath[index] = value;
	              } else {
	                scopePath[index].latitude = value.lat();
	                return scopePath[index].longitude = value.lng();
	              }
	            },
	            insert_at: function(index) {
	              var value;
	              if (isSetFromScope) {
	                return;
	              }
	              value = mapArray.getAt(index);
	              if (!value) {
	                return;
	              }
	              if (!value.lng || !value.lat) {
	                return scopePath.splice(index, 0, value);
	              } else {
	                return scopePath.splice(index, 0, {
	                  latitude: value.lat(),
	                  longitude: value.lng()
	                });
	              }
	            },
	            remove_at: function(index) {
	              if (isSetFromScope) {
	                return;
	              }
	              return scopePath.splice(index, 1);
	            }
	          };
	          geojsonArray;
	          if (scopePath.type === 'Polygon') {
	            geojsonArray = scopePath.coordinates[0];
	          } else if (scopePath.type === 'LineString') {
	            geojsonArray = scopePath.coordinates;
	          }
	          geojsonHandlers = {
	            set_at: function(index) {
	              var value;
	              if (isSetFromScope) {
	                return;
	              }
	              value = mapArray.getAt(index);
	              if (!(value && value.lng && value.lat)) {
	                return;
	              }
	              geojsonArray[index][1] = value.lat();
	              return geojsonArray[index][0] = value.lng();
	            },
	            insert_at: function(index) {
	              var value;
	              if (isSetFromScope) {
	                return;
	              }
	              value = mapArray.getAt(index);
	              if (!value) {
	                return;
	              }
	              if (!value.lng || !value.lat) {
	                return;
	              }
	              return geojsonArray.splice(index, 0, [value.lng(), value.lat()]);
	            },
	            remove_at: function(index) {
	              if (isSetFromScope) {
	                return;
	              }
	              return geojsonArray.splice(index, 1);
	            }
	          };
	          mapArrayListener = mapEvents(mapArray, angular.isUndefined(scopePath.type) ? legacyHandlers : geojsonHandlers);
	        }
	        legacyWatcher = function(newPath) {
	          var changed, i, l, newLength, newValue, oldArray, oldLength, oldValue;
	          isSetFromScope = true;
	          oldArray = mapArray;
	          changed = false;
	          if (newPath) {
	            i = 0;
	            oldLength = oldArray.getLength();
	            newLength = newPath.length;
	            l = Math.min(oldLength, newLength);
	            newValue = void 0;
	            while (i < l) {
	              oldValue = oldArray.getAt(i);
	              newValue = newPath[i];
	              if (typeof newValue.equals === 'function') {
	                if (!newValue.equals(oldValue)) {
	                  oldArray.setAt(i, newValue);
	                  changed = true;
	                }
	              } else {
	                if ((oldValue.lat() !== newValue.latitude) || (oldValue.lng() !== newValue.longitude)) {
	                  oldArray.setAt(i, new google.maps.LatLng(newValue.latitude, newValue.longitude));
	                  changed = true;
	                }
	              }
	              i++;
	            }
	            while (i < newLength) {
	              newValue = newPath[i];
	              if (typeof newValue.lat === 'function' && typeof newValue.lng === 'function') {
	                oldArray.push(newValue);
	              } else {
	                oldArray.push(new google.maps.LatLng(newValue.latitude, newValue.longitude));
	              }
	              changed = true;
	              i++;
	            }
	            while (i < oldLength) {
	              oldArray.pop();
	              changed = true;
	              i++;
	            }
	          }
	          isSetFromScope = false;
	          if (changed) {
	            return pathChangedFn(oldArray);
	          }
	        };
	        geojsonWatcher = function(newPath) {
	          var array, changed, i, l, newLength, newValue, oldArray, oldLength, oldValue;
	          isSetFromScope = true;
	          oldArray = mapArray;
	          changed = false;
	          if (newPath) {
	            array;
	            if (scopePath.type === 'Polygon') {
	              array = newPath.coordinates[0];
	            } else if (scopePath.type === 'LineString') {
	              array = newPath.coordinates;
	            }
	            i = 0;
	            oldLength = oldArray.getLength();
	            newLength = array.length;
	            l = Math.min(oldLength, newLength);
	            newValue = void 0;
	            while (i < l) {
	              oldValue = oldArray.getAt(i);
	              newValue = array[i];
	              if ((oldValue.lat() !== newValue[1]) || (oldValue.lng() !== newValue[0])) {
	                oldArray.setAt(i, new google.maps.LatLng(newValue[1], newValue[0]));
	                changed = true;
	              }
	              i++;
	            }
	            while (i < newLength) {
	              newValue = array[i];
	              oldArray.push(new google.maps.LatLng(newValue[1], newValue[0]));
	              changed = true;
	              i++;
	            }
	            while (i < oldLength) {
	              oldArray.pop();
	              changed = true;
	              i++;
	            }
	          }
	          isSetFromScope = false;
	          if (changed) {
	            return pathChangedFn(oldArray);
	          }
	        };
	        watchListener;
	        if (!scope["static"]) {
	          if (angular.isUndefined(scopePath.type)) {
	            watchListener = scope.$watchCollection(pathEval, legacyWatcher);
	          } else {
	            watchListener = scope.$watch(pathEval, geojsonWatcher, true);
	          }
	        }
	        return function() {
	          if (mapArrayListener) {
	            mapArrayListener();
	            mapArrayListener = null;
	          }
	          if (watchListener) {
	            watchListener();
	            return watchListener = null;
	          }
	        };
	      };
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module("uiGmapgoogle-maps.directives.api.utils").factory("uiGmapChromeFixes", [
	    '$timeout', function($timeout) {
	      return {
	        maybeRepaint: function(el) {
	          if (el) {
	            el.style.opacity = 0.9;
	            return $timeout(function() {
	              return el.style.opacity = 1;
	            });
	          }
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps').service('uiGmapObjectIterators', function() {
	    var _ignores, _iterators, _slapForEach, _slapMap;
	    _ignores = ['length', 'forEach', 'map'];
	    _iterators = [];
	    _slapForEach = function(object) {
	      object.forEach = function(cb) {
	        return _.each(_.omit(object, _ignores), function(val) {
	          if (!_.isFunction(val)) {
	            return cb(val);
	          }
	        });
	      };
	      return object;
	    };
	    _iterators.push(_slapForEach);
	    _slapMap = function(object) {
	      object.map = function(cb) {
	        return _.map(_.omit(object, _ignores), function(val) {
	          if (!_.isFunction(val)) {
	            return cb(val);
	          }
	        });
	      };
	      return object;
	    };
	    _iterators.push(_slapMap);
	    return {
	      slapMap: _slapMap,
	      slapForEach: _slapForEach,
	      slapAll: function(object) {
	        _iterators.forEach(function(it) {
	          return it(object);
	        });
	        return object;
	      }
	    };
	  });
	
	}).call(this);
	;(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api.options.builders').service('uiGmapCommonOptionsBuilder', [
	    'uiGmapBaseObject', 'uiGmapLogger', 'uiGmapModelKey', function(BaseObject, $log, ModelKey) {
	      var CommonOptionsBuilder;
	      return CommonOptionsBuilder = (function(superClass) {
	        extend(CommonOptionsBuilder, superClass);
	
	        function CommonOptionsBuilder() {
	          this.watchProps = bind(this.watchProps, this);
	          this.buildOpts = bind(this.buildOpts, this);
	          return CommonOptionsBuilder.__super__.constructor.apply(this, arguments);
	        }
	
	        CommonOptionsBuilder.prototype.props = [
	          'clickable', 'draggable', 'editable', 'visible', {
	            prop: 'stroke',
	            isColl: true
	          }
	        ];
	
	        CommonOptionsBuilder.prototype.getCorrectModel = function(scope) {
	          if (angular.isDefined(scope != null ? scope.model : void 0)) {
	            return scope.model;
	          } else {
	            return scope;
	          }
	        };
	
	        CommonOptionsBuilder.prototype.buildOpts = function(customOpts, cachedEval, forEachOpts) {
	          var model, opts, stroke;
	          if (customOpts == null) {
	            customOpts = {};
	          }
	          if (forEachOpts == null) {
	            forEachOpts = {};
	          }
	          if (!this.scope) {
	            $log.error('this.scope not defined in CommonOptionsBuilder can not buildOpts');
	            return;
	          }
	          if (!this.gMap) {
	            $log.error('this.map not defined in CommonOptionsBuilder can not buildOpts');
	            return;
	          }
	          model = this.getCorrectModel(this.scope);
	          stroke = this.scopeOrModelVal('stroke', this.scope, model);
	          opts = angular.extend(customOpts, this.DEFAULTS, {
	            map: this.gMap,
	            strokeColor: stroke != null ? stroke.color : void 0,
	            strokeOpacity: stroke != null ? stroke.opacity : void 0,
	            strokeWeight: stroke != null ? stroke.weight : void 0
	          });
	          angular.forEach(angular.extend(forEachOpts, {
	            clickable: true,
	            draggable: false,
	            editable: false,
	            "static": false,
	            fit: false,
	            visible: true,
	            zIndex: 0,
	            icons: []
	          }), (function(_this) {
	            return function(defaultValue, key) {
	              var val;
	              val = cachedEval ? cachedEval[key] : _this.scopeOrModelVal(key, _this.scope, model);
	              if (angular.isUndefined(val)) {
	                return opts[key] = defaultValue;
	              } else {
	                return opts[key] = model[key];
	              }
	            };
	          })(this));
	          if (opts["static"]) {
	            opts.editable = false;
	          }
	          return opts;
	        };
	
	        CommonOptionsBuilder.prototype.watchProps = function(props) {
	          if (props == null) {
	            props = this.props;
	          }
	          return props.forEach((function(_this) {
	            return function(prop) {
	              if ((_this.attrs[prop] != null) || (_this.attrs[prop != null ? prop.prop : void 0] != null)) {
	                if (prop != null ? prop.isColl : void 0) {
	                  return _this.scope.$watchCollection(prop.prop, _this.setMyOptions);
	                } else {
	                  return _this.scope.$watch(prop, _this.setMyOptions);
	                }
	              }
	            };
	          })(this));
	        };
	
	        return CommonOptionsBuilder;
	
	      })(ModelKey);
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api.options.builders').factory('uiGmapPolylineOptionsBuilder', [
	    'uiGmapCommonOptionsBuilder', function(CommonOptionsBuilder) {
	      var PolylineOptionsBuilder;
	      return PolylineOptionsBuilder = (function(superClass) {
	        extend(PolylineOptionsBuilder, superClass);
	
	        function PolylineOptionsBuilder() {
	          return PolylineOptionsBuilder.__super__.constructor.apply(this, arguments);
	        }
	
	        PolylineOptionsBuilder.prototype.buildOpts = function(pathPoints, cachedEval) {
	          return PolylineOptionsBuilder.__super__.buildOpts.call(this, {
	            path: pathPoints
	          }, cachedEval, {
	            geodesic: false
	          });
	        };
	
	        return PolylineOptionsBuilder;
	
	      })(CommonOptionsBuilder);
	    }
	  ]).factory('uiGmapShapeOptionsBuilder', [
	    'uiGmapCommonOptionsBuilder', function(CommonOptionsBuilder) {
	      var ShapeOptionsBuilder;
	      return ShapeOptionsBuilder = (function(superClass) {
	        extend(ShapeOptionsBuilder, superClass);
	
	        function ShapeOptionsBuilder() {
	          return ShapeOptionsBuilder.__super__.constructor.apply(this, arguments);
	        }
	
	        ShapeOptionsBuilder.prototype.buildOpts = function(customOpts, cachedEval, forEachOpts) {
	          var fill, model;
	          model = this.getCorrectModel(this.scope);
	          fill = cachedEval ? cachedEval['fill'] : this.scopeOrModelVal('fill', this.scope, model);
	          customOpts = angular.extend(customOpts, {
	            fillColor: fill != null ? fill.color : void 0,
	            fillOpacity: fill != null ? fill.opacity : void 0
	          });
	          return ShapeOptionsBuilder.__super__.buildOpts.call(this, customOpts, cachedEval, forEachOpts);
	        };
	
	        return ShapeOptionsBuilder;
	
	      })(CommonOptionsBuilder);
	    }
	  ]).factory('uiGmapPolygonOptionsBuilder', [
	    'uiGmapShapeOptionsBuilder', function(ShapeOptionsBuilder) {
	      var PolygonOptionsBuilder;
	      return PolygonOptionsBuilder = (function(superClass) {
	        extend(PolygonOptionsBuilder, superClass);
	
	        function PolygonOptionsBuilder() {
	          return PolygonOptionsBuilder.__super__.constructor.apply(this, arguments);
	        }
	
	        PolygonOptionsBuilder.prototype.buildOpts = function(pathPoints, cachedEval) {
	          return PolygonOptionsBuilder.__super__.buildOpts.call(this, {
	            path: pathPoints
	          }, cachedEval, {
	            geodesic: false
	          });
	        };
	
	        return PolygonOptionsBuilder;
	
	      })(ShapeOptionsBuilder);
	    }
	  ]).factory('uiGmapRectangleOptionsBuilder', [
	    'uiGmapShapeOptionsBuilder', function(ShapeOptionsBuilder) {
	      var RectangleOptionsBuilder;
	      return RectangleOptionsBuilder = (function(superClass) {
	        extend(RectangleOptionsBuilder, superClass);
	
	        function RectangleOptionsBuilder() {
	          return RectangleOptionsBuilder.__super__.constructor.apply(this, arguments);
	        }
	
	        RectangleOptionsBuilder.prototype.buildOpts = function(bounds, cachedEval) {
	          return RectangleOptionsBuilder.__super__.buildOpts.call(this, {
	            bounds: bounds
	          }, cachedEval);
	        };
	
	        return RectangleOptionsBuilder;
	
	      })(ShapeOptionsBuilder);
	    }
	  ]).factory('uiGmapCircleOptionsBuilder', [
	    'uiGmapShapeOptionsBuilder', function(ShapeOptionsBuilder) {
	      var CircleOptionsBuilder;
	      return CircleOptionsBuilder = (function(superClass) {
	        extend(CircleOptionsBuilder, superClass);
	
	        function CircleOptionsBuilder() {
	          return CircleOptionsBuilder.__super__.constructor.apply(this, arguments);
	        }
	
	        CircleOptionsBuilder.prototype.buildOpts = function(center, radius, cachedEval) {
	          return CircleOptionsBuilder.__super__.buildOpts.call(this, {
	            center: center,
	            radius: radius
	          }, cachedEval);
	        };
	
	        return CircleOptionsBuilder;
	
	      })(ShapeOptionsBuilder);
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps.directives.api.options').service('uiGmapMarkerOptions', [
	    'uiGmapLogger', 'uiGmapGmapUtil', function($log, GmapUtil) {
	      return _.extend(GmapUtil, {
	        createOptions: function(coords, icon, defaults, map) {
	          var opts;
	          if (defaults == null) {
	            defaults = {};
	          }
	          opts = angular.extend({}, defaults, {
	            position: defaults.position != null ? defaults.position : GmapUtil.getCoords(coords),
	            visible: defaults.visible != null ? defaults.visible : GmapUtil.validateCoords(coords)
	          });
	          if ((defaults.icon != null) || (icon != null)) {
	            opts = angular.extend(opts, {
	              icon: defaults.icon != null ? defaults.icon : icon
	            });
	          }
	          if (map != null) {
	            opts.map = map;
	          }
	          return opts;
	        },
	        isLabel: function(options) {
	          if (options == null) {
	            return false;
	          }
	          return (options.labelContent != null) || (options.labelAnchor != null) || (options.labelClass != null) || (options.labelStyle != null) || (options.labelVisible != null);
	        }
	      });
	    }
	  ]);
	
	}).call(this);
	;
	/*global _,angular */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapBasePolyChildModel', [
	    'uiGmapLogger', '$timeout', 'uiGmaparray-sync', 'uiGmapGmapUtil', 'uiGmapEventsHelper', function($log, $timeout, arraySync, GmapUtil, EventsHelper) {
	      return function(Builder, gFactory) {
	        var BasePolyChildModel;
	        return BasePolyChildModel = (function(superClass) {
	          extend(BasePolyChildModel, superClass);
	
	          BasePolyChildModel.include(GmapUtil);
	
	          function BasePolyChildModel(arg) {
	            var create, gObjectChangeCb, ref;
	            this.scope = arg.scope, this.attrs = arg.attrs, this.gMap = arg.gMap, this.defaults = arg.defaults, this.model = arg.model, gObjectChangeCb = arg.gObjectChangeCb, this.isScopeModel = (ref = arg.isScopeModel) != null ? ref : false;
	            this.clean = bind(this.clean, this);
	            if (this.isScopeModel) {
	              this.clonedModel = _.clone(this.model, true);
	            }
	            this.isDragging = false;
	            this.internalEvents = {
	              dragend: (function(_this) {
	                return function() {
	                  return _.defer(function() {
	                    return _this.isDragging = false;
	                  });
	                };
	              })(this),
	              dragstart: (function(_this) {
	                return function() {
	                  return _this.isDragging = true;
	                };
	              })(this)
	            };
	            create = (function(_this) {
	              return function() {
	                var maybeCachedEval;
	                if (_this.isDragging) {
	                  return;
	                }
	                _this.pathPoints = _this.convertPathPoints(_this.scope.path);
	                if (_this.gObject != null) {
	                  _this.clean();
	                }
	                if (_this.scope.model != null) {
	                  maybeCachedEval = _this.scope;
	                }
	                if (_this.pathPoints.length > 0) {
	                  _this.gObject = gFactory(_this.buildOpts(_this.pathPoints, maybeCachedEval));
	                }
	                if (_this.gObject) {
	                  arraySync(_this.gObject.getPath(), _this.scope, 'path', function(pathPoints) {
	                    _this.pathPoints = pathPoints;
	                    if (gObjectChangeCb != null) {
	                      return gObjectChangeCb();
	                    }
	                  });
	                  if (angular.isDefined(_this.scope.events) && angular.isObject(_this.scope.events)) {
	                    _this.listeners = _this.model ? EventsHelper.setEvents(_this.gObject, _this.scope, _this.model) : EventsHelper.setEvents(_this.gObject, _this.scope, _this.scope);
	                  }
	                  return _this.internalListeners = _this.model ? EventsHelper.setEvents(_this.gObject, {
	                    events: _this.internalEvents
	                  }, _this.model) : EventsHelper.setEvents(_this.gObject, {
	                    events: _this.internalEvents
	                  }, _this.scope);
	                }
	              };
	            })(this);
	            create();
	            this.scope.$watch('path', (function(_this) {
	              return function(newValue, oldValue) {
	                if (!_.isEqual(newValue, oldValue) || !_this.gObject) {
	                  return create();
	                }
	              };
	            })(this), true);
	            if (!this.scope["static"] && angular.isDefined(this.scope.editable)) {
	              this.scope.$watch('editable', (function(_this) {
	                return function(newValue, oldValue) {
	                  var ref1;
	                  if (newValue !== oldValue) {
	                    newValue = !_this.isFalse(newValue);
	                    return (ref1 = _this.gObject) != null ? ref1.setEditable(newValue) : void 0;
	                  }
	                };
	              })(this), true);
	            }
	            if (angular.isDefined(this.scope.draggable)) {
	              this.scope.$watch('draggable', (function(_this) {
	                return function(newValue, oldValue) {
	                  var ref1;
	                  if (newValue !== oldValue) {
	                    newValue = !_this.isFalse(newValue);
	                    return (ref1 = _this.gObject) != null ? ref1.setDraggable(newValue) : void 0;
	                  }
	                };
	              })(this), true);
	            }
	            if (angular.isDefined(this.scope.visible)) {
	              this.scope.$watch('visible', (function(_this) {
	                return function(newValue, oldValue) {
	                  var ref1;
	                  if (newValue !== oldValue) {
	                    newValue = !_this.isFalse(newValue);
	                  }
	                  return (ref1 = _this.gObject) != null ? ref1.setVisible(newValue) : void 0;
	                };
	              })(this), true);
	            }
	            if (angular.isDefined(this.scope.geodesic)) {
	              this.scope.$watch('geodesic', (function(_this) {
	                return function(newValue, oldValue) {
	                  var ref1;
	                  if (newValue !== oldValue) {
	                    newValue = !_this.isFalse(newValue);
	                    return (ref1 = _this.gObject) != null ? ref1.setOptions(_this.buildOpts(_this.gObject.getPath())) : void 0;
	                  }
	                };
	              })(this), true);
	            }
	            if (angular.isDefined(this.scope.stroke) && angular.isDefined(this.scope.stroke.weight)) {
	              this.scope.$watch('stroke.weight', (function(_this) {
	                return function(newValue, oldValue) {
	                  var ref1;
	                  if (newValue !== oldValue) {
	                    return (ref1 = _this.gObject) != null ? ref1.setOptions(_this.buildOpts(_this.gObject.getPath())) : void 0;
	                  }
	                };
	              })(this), true);
	            }
	            if (angular.isDefined(this.scope.stroke) && angular.isDefined(this.scope.stroke.color)) {
	              this.scope.$watch('stroke.color', (function(_this) {
	                return function(newValue, oldValue) {
	                  var ref1;
	                  if (newValue !== oldValue) {
	                    return (ref1 = _this.gObject) != null ? ref1.setOptions(_this.buildOpts(_this.gObject.getPath())) : void 0;
	                  }
	                };
	              })(this), true);
	            }
	            if (angular.isDefined(this.scope.stroke) && angular.isDefined(this.scope.stroke.opacity)) {
	              this.scope.$watch('stroke.opacity', (function(_this) {
	                return function(newValue, oldValue) {
	                  var ref1;
	                  if (newValue !== oldValue) {
	                    return (ref1 = _this.gObject) != null ? ref1.setOptions(_this.buildOpts(_this.gObject.getPath())) : void 0;
	                  }
	                };
	              })(this), true);
	            }
	            if (angular.isDefined(this.scope.icons)) {
	              this.scope.$watch('icons', (function(_this) {
	                return function(newValue, oldValue) {
	                  var ref1;
	                  if (newValue !== oldValue) {
	                    return (ref1 = _this.gObject) != null ? ref1.setOptions(_this.buildOpts(_this.gObject.getPath())) : void 0;
	                  }
	                };
	              })(this), true);
	            }
	            this.scope.$on('$destroy', (function(_this) {
	              return function() {
	                _this.clean();
	                return _this.scope = null;
	              };
	            })(this));
	            if (angular.isDefined(this.scope.fill) && angular.isDefined(this.scope.fill.color)) {
	              this.scope.$watch('fill.color', (function(_this) {
	                return function(newValue, oldValue) {
	                  if (newValue !== oldValue) {
	                    return _this.gObject.setOptions(_this.buildOpts(_this.gObject.getPath()));
	                  }
	                };
	              })(this));
	            }
	            if (angular.isDefined(this.scope.fill) && angular.isDefined(this.scope.fill.opacity)) {
	              this.scope.$watch('fill.opacity', (function(_this) {
	                return function(newValue, oldValue) {
	                  if (newValue !== oldValue) {
	                    return _this.gObject.setOptions(_this.buildOpts(_this.gObject.getPath()));
	                  }
	                };
	              })(this));
	            }
	            if (angular.isDefined(this.scope.zIndex)) {
	              this.scope.$watch('zIndex', (function(_this) {
	                return function(newValue, oldValue) {
	                  if (newValue !== oldValue) {
	                    return _this.gObject.setOptions(_this.buildOpts(_this.gObject.getPath()));
	                  }
	                };
	              })(this));
	            }
	          }
	
	          BasePolyChildModel.prototype.clean = function() {
	            var ref;
	            EventsHelper.removeEvents(this.listeners);
	            EventsHelper.removeEvents(this.internalListeners);
	            if ((ref = this.gObject) != null) {
	              ref.setMap(null);
	            }
	            return this.gObject = null;
	          };
	
	          return BasePolyChildModel;
	
	        })(Builder);
	      };
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors
	Nicholas McCready - https://twitter.com/nmccready
	Original idea from: http://stackoverflow.com/questions/22758950/google-map-drawing-freehand  , &
	  http://jsfiddle.net/YsQdh/88/
	 */
	
	(function() {
	  angular.module('uiGmapgoogle-maps.directives.api.models.child').factory('uiGmapDrawFreeHandChildModel', [
	    'uiGmapLogger', '$q', function($log, $q) {
	      var drawFreeHand, freeHandMgr;
	      drawFreeHand = function(map, polys, done) {
	        var move, poly;
	        poly = new google.maps.Polyline({
	          map: map,
	          clickable: false
	        });
	        move = google.maps.event.addListener(map, 'mousemove', function(e) {
	          return poly.getPath().push(e.latLng);
	        });
	        google.maps.event.addListenerOnce(map, 'mouseup', function(e) {
	          var path;
	          google.maps.event.removeListener(move);
	          path = poly.getPath();
	          poly.setMap(null);
	          polys.push(new google.maps.Polygon({
	            map: map,
	            path: path
	          }));
	          poly = null;
	          google.maps.event.clearListeners(map.getDiv(), 'mousedown');
	          return done();
	        });
	        return void 0;
	      };
	      freeHandMgr = function(map1, scope) {
	        var disableMap, enableMap;
	        this.map = map1;
	        disableMap = (function(_this) {
	          return function() {
	            var mapOptions;
	            mapOptions = {
	              draggable: false,
	              disableDefaultUI: true,
	              scrollwheel: false,
	              disableDoubleClickZoom: false
	            };
	            $log.info('disabling map move');
	            return _this.map.setOptions(mapOptions);
	          };
	        })(this);
	        enableMap = (function(_this) {
	          return function() {
	            var mapOptions, ref;
	            mapOptions = {
	              draggable: true,
	              disableDefaultUI: false,
	              scrollwheel: true,
	              disableDoubleClickZoom: true
	            };
	            if ((ref = _this.deferred) != null) {
	              ref.resolve();
	            }
	            return _.defer(function() {
	              return _this.map.setOptions(_.extend(mapOptions, scope.options));
	            });
	          };
	        })(this);
	        this.engage = (function(_this) {
	          return function(polys1) {
	            _this.polys = polys1;
	            _this.deferred = $q.defer();
	            disableMap();
	            $log.info('DrawFreeHandChildModel is engaged (drawing).');
	            google.maps.event.addDomListener(_this.map.getDiv(), 'mousedown', function(e) {
	              return drawFreeHand(_this.map, _this.polys, enableMap);
	            });
	            return _this.deferred.promise;
	          };
	        })(this);
	        return this;
	      };
	      return freeHandMgr;
	    }
	  ]);
	
	}).call(this);
	;
	/*global _:true,angular:true,google:true, RichMarker:true */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api.models.child').factory('uiGmapMarkerChildModel', [
	    'uiGmapModelKey', 'uiGmapGmapUtil', 'uiGmapLogger', 'uiGmapEventsHelper', 'uiGmapPropertyAction', 'uiGmapMarkerOptions', 'uiGmapIMarker', 'uiGmapMarkerManager', 'uiGmapPromise', function(ModelKey, GmapUtil, $log, EventsHelper, PropertyAction, MarkerOptions, IMarker, MarkerManager, uiGmapPromise) {
	      var MarkerChildModel;
	      MarkerChildModel = (function(superClass) {
	        var destroy;
	
	        extend(MarkerChildModel, superClass);
	
	        MarkerChildModel.include(GmapUtil);
	
	        MarkerChildModel.include(EventsHelper);
	
	        MarkerChildModel.include(MarkerOptions);
	
	        destroy = function(child) {
	          if ((child != null ? child.gObject : void 0) != null) {
	            child.removeEvents(child.externalListeners);
	            child.removeEvents(child.internalListeners);
	            if (child != null ? child.gObject : void 0) {
	              if (child.removeFromManager) {
	                child.gManager.remove(child.gObject);
	              }
	              child.gObject.setMap(null);
	              return child.gObject = null;
	            }
	          }
	        };
	
	        function MarkerChildModel(opts) {
	          this.internalEvents = bind(this.internalEvents, this);
	          this.setLabelOptions = bind(this.setLabelOptions, this);
	          this.setOptions = bind(this.setOptions, this);
	          this.setIcon = bind(this.setIcon, this);
	          this.setCoords = bind(this.setCoords, this);
	          this.isNotValid = bind(this.isNotValid, this);
	          this.maybeSetScopeValue = bind(this.maybeSetScopeValue, this);
	          this.createMarker = bind(this.createMarker, this);
	          this.setMyScope = bind(this.setMyScope, this);
	          this.updateModel = bind(this.updateModel, this);
	          this.handleModelChanges = bind(this.handleModelChanges, this);
	          this.destroy = bind(this.destroy, this);
	          var action, ref, ref1, ref2, ref3, ref4, scope;
	          scope = opts.scope, this.model = opts.model, this.keys = opts.keys, this.gMap = opts.gMap, this.defaults = (ref = opts.defaults) != null ? ref : {}, this.doClick = opts.doClick, this.gManager = opts.gManager, this.doDrawSelf = (ref1 = opts.doDrawSelf) != null ? ref1 : true, this.trackModel = (ref2 = opts.trackModel) != null ? ref2 : true, this.needRedraw = (ref3 = opts.needRedraw) != null ? ref3 : false, this.isScopeModel = (ref4 = opts.isScopeModel) != null ? ref4 : false;
	          if (this.isScopeModel) {
	            this.clonedModel = _.clone(this.model, true);
	          }
	          this.deferred = uiGmapPromise.defer();
	          _.each(this.keys, (function(_this) {
	            return function(v, k) {
	              var keyValue;
	              keyValue = _this.keys[k];
	              if ((keyValue != null) && !_.isFunction(keyValue) && _.isString(keyValue)) {
	                return _this[k + 'Key'] = keyValue;
	              }
	            };
	          })(this));
	          this.idKey = this.idKeyKey || 'id';
	          if (this.model[this.idKey] != null) {
	            this.id = this.model[this.idKey];
	          }
	          MarkerChildModel.__super__.constructor.call(this, scope);
	          this.scope.getGMarker = (function(_this) {
	            return function() {
	              return _this.gObject;
	            };
	          })(this);
	          this.firstTime = true;
	          if (this.trackModel) {
	            this.scope.model = this.model;
	            this.scope.$watch('model', (function(_this) {
	              return function(newValue, oldValue) {
	                if (newValue !== oldValue) {
	                  return _this.handleModelChanges(newValue, oldValue);
	                }
	              };
	            })(this), true);
	          } else {
	            action = new PropertyAction((function(_this) {
	              return function(calledKey) {
	                if (_.isFunction(calledKey)) {
	                  calledKey = 'all';
	                }
	                if (!_this.firstTime) {
	                  return _this.setMyScope(calledKey, scope);
	                }
	              };
	            })(this), false);
	            _.each(this.keys, function(v, k) {
	              return scope.$watch(k, action.sic(k), true);
	            });
	          }
	          this.scope.$on('$destroy', (function(_this) {
	            return function() {
	              return destroy(_this);
	            };
	          })(this));
	          this.createMarker(this.model);
	          $log.info(this);
	        }
	
	        MarkerChildModel.prototype.destroy = function(removeFromManager) {
	          if (removeFromManager == null) {
	            removeFromManager = true;
	          }
	          this.removeFromManager = removeFromManager;
	          return this.scope.$destroy();
	        };
	
	        MarkerChildModel.prototype.handleModelChanges = function(newValue, oldValue) {
	          var changes, ctr, len;
	          changes = this.getChanges(newValue, oldValue, IMarker.keys);
	          if (!this.firstTime) {
	            ctr = 0;
	            len = _.keys(changes).length;
	            return _.each(changes, (function(_this) {
	              return function(v, k) {
	                var doDraw;
	                ctr += 1;
	                doDraw = len === ctr;
	                _this.setMyScope(k, newValue, oldValue, false, true, doDraw);
	                return _this.needRedraw = true;
	              };
	            })(this));
	          }
	        };
	
	        MarkerChildModel.prototype.updateModel = function(model) {
	          if (this.isScopeModel) {
	            this.clonedModel = _.clone(model, true);
	          }
	          return this.setMyScope('all', model, this.model);
	        };
	
	        MarkerChildModel.prototype.renderGMarker = function(doDraw, validCb) {
	          var coords, isSpiderfied, ref;
	          if (doDraw == null) {
	            doDraw = true;
	          }
	          coords = this.getProp('coords', this.scope, this.model);
	          if (((ref = this.gManager) != null ? ref.isSpiderfied : void 0) != null) {
	            isSpiderfied = this.gManager.isSpiderfied();
	          }
	          if (coords != null) {
	            if (!this.validateCoords(coords)) {
	              $log.debug('MarkerChild does not have coords yet. They may be defined later.');
	              return;
	            }
	            if (validCb != null) {
	              validCb();
	            }
	            if (doDraw && this.gObject) {
	              this.gManager.add(this.gObject);
	            }
	            if (isSpiderfied) {
	              return this.gManager.markerSpiderfier.spiderListener(this.gObject, window.event);
	            }
	          } else {
	            if (doDraw && this.gObject) {
	              return this.gManager.remove(this.gObject);
	            }
	          }
	        };
	
	        MarkerChildModel.prototype.setMyScope = function(thingThatChanged, model, oldModel, isInit, doDraw) {
	          var justCreated;
	          if (oldModel == null) {
	            oldModel = void 0;
	          }
	          if (isInit == null) {
	            isInit = false;
	          }
	          if (doDraw == null) {
	            doDraw = true;
	          }
	          if (model == null) {
	            model = this.model;
	          } else {
	            this.model = model;
	          }
	          if (!this.gObject) {
	            this.setOptions(this.scope, doDraw);
	            justCreated = true;
	          }
	          switch (thingThatChanged) {
	            case 'all':
	              return _.each(this.keys, (function(_this) {
	                return function(v, k) {
	                  return _this.setMyScope(k, model, oldModel, isInit, doDraw);
	                };
	              })(this));
	            case 'icon':
	              return this.maybeSetScopeValue({
	                gSetter: this.setIcon,
	                doDraw: doDraw
	              });
	            case 'coords':
	              return this.maybeSetScopeValue({
	                gSetter: this.setCoords,
	                doDraw: doDraw
	              });
	            case 'options':
	              if (!justCreated) {
	                return this.createMarker(model, oldModel, isInit, doDraw);
	              }
	          }
	        };
	
	        MarkerChildModel.prototype.createMarker = function(model, oldModel, isInit, doDraw) {
	          if (oldModel == null) {
	            oldModel = void 0;
	          }
	          if (isInit == null) {
	            isInit = false;
	          }
	          if (doDraw == null) {
	            doDraw = true;
	          }
	          this.maybeSetScopeValue({
	            gSetter: this.setOptions,
	            doDraw: doDraw
	          });
	          return this.firstTime = false;
	        };
	
	        MarkerChildModel.prototype.maybeSetScopeValue = function(arg) {
	          var doDraw, gSetter, ref;
	          gSetter = arg.gSetter, doDraw = (ref = arg.doDraw) != null ? ref : true;
	          if (gSetter != null) {
	            gSetter(this.scope, doDraw);
	          }
	          if (this.doDrawSelf && doDraw) {
	            return this.gManager.draw();
	          }
	        };
	
	        MarkerChildModel.prototype.isNotValid = function(scope, doCheckGmarker) {
	          var hasIdenticalScopes, hasNoGmarker;
	          if (doCheckGmarker == null) {
	            doCheckGmarker = true;
	          }
	          hasNoGmarker = !doCheckGmarker ? false : this.gObject === void 0;
	          hasIdenticalScopes = !this.trackModel ? scope.$id !== this.scope.$id : false;
	          return hasIdenticalScopes || hasNoGmarker;
	        };
	
	        MarkerChildModel.prototype.setCoords = function(scope, doDraw) {
	          if (doDraw == null) {
	            doDraw = true;
	          }
	          if (this.isNotValid(scope) || (this.gObject == null)) {
	            return;
	          }
	          return this.renderGMarker(doDraw, (function(_this) {
	            return function() {
	              var newGValue, newModelVal, oldGValue;
	              newModelVal = _this.getProp('coords', scope, _this.model);
	              newGValue = _this.getCoords(newModelVal);
	              oldGValue = _this.gObject.getPosition();
	              if ((oldGValue != null) && (newGValue != null)) {
	                if (newGValue.lng() === oldGValue.lng() && newGValue.lat() === oldGValue.lat()) {
	                  return;
	                }
	              }
	              _this.gObject.setPosition(newGValue);
	              return _this.gObject.setVisible(_this.validateCoords(newModelVal));
	            };
	          })(this));
	        };
	
	        MarkerChildModel.prototype.setIcon = function(scope, doDraw) {
	          if (doDraw == null) {
	            doDraw = true;
	          }
	          if (this.isNotValid(scope) || (this.gObject == null)) {
	            return;
	          }
	          return this.renderGMarker(doDraw, (function(_this) {
	            return function() {
	              var coords, newValue, oldValue;
	              oldValue = _this.gObject.getIcon();
	              newValue = _this.getProp('icon', scope, _this.model);
	              if (oldValue === newValue) {
	                return;
	              }
	              _this.gObject.setIcon(newValue);
	              coords = _this.getProp('coords', scope, _this.model);
	              _this.gObject.setPosition(_this.getCoords(coords));
	              return _this.gObject.setVisible(_this.validateCoords(coords));
	            };
	          })(this));
	        };
	
	        MarkerChildModel.prototype.setOptions = function(scope, doDraw) {
	          var ref;
	          if (doDraw == null) {
	            doDraw = true;
	          }
	          if (this.isNotValid(scope, false)) {
	            return;
	          }
	          this.renderGMarker(doDraw, (function(_this) {
	            return function() {
	              var _options, coords, icon;
	              coords = _this.getProp('coords', scope, _this.model);
	              icon = _this.getProp('icon', scope, _this.model);
	              _options = _this.getProp('options', scope, _this.model);
	              _this.opts = _this.createOptions(coords, icon, _options);
	              if (_this.isLabel(_this.gObject) !== _this.isLabel(_this.opts) && (_this.gObject != null)) {
	                _this.gManager.remove(_this.gObject);
	                _this.gObject = void 0;
	              }
	              if (_this.gObject != null) {
	                _this.gObject.setOptions(_this.setLabelOptions(_this.opts));
	              }
	              if (!_this.gObject) {
	                if (_this.isLabel(_this.opts)) {
	                  _this.gObject = new MarkerWithLabel(_this.setLabelOptions(_this.opts));
	                } else if (_this.opts.content) {
	                  _this.gObject = new RichMarker(_this.opts);
	                  _this.gObject.getIcon = _this.gObject.getContent;
	                  _this.gObject.setIcon = _this.gObject.setContent;
	                } else {
	                  _this.gObject = new google.maps.Marker(_this.opts);
	                }
	                _.extend(_this.gObject, {
	                  model: _this.model
	                });
	              }
	              if (_this.externalListeners) {
	                _this.removeEvents(_this.externalListeners);
	              }
	              if (_this.internalListeners) {
	                _this.removeEvents(_this.internalListeners);
	              }
	              _this.externalListeners = _this.setEvents(_this.gObject, _this.scope, _this.model, ['dragend']);
	              _this.internalListeners = _this.setEvents(_this.gObject, {
	                events: _this.internalEvents(),
	                $evalAsync: function() {}
	              }, _this.model);
	              if (_this.id != null) {
	                return _this.gObject.key = _this.id;
	              }
	            };
	          })(this));
	          if (this.gObject && (this.gObject.getMap() || this.gManager.type !== MarkerManager.type)) {
	            this.deferred.resolve(this.gObject);
	          } else {
	            if (!this.gObject) {
	              return this.deferred.reject('gObject is null');
	            }
	            if (!(((ref = this.gObject) != null ? ref.getMap() : void 0) && this.gManager.type === MarkerManager.type)) {
	              $log.debug('gObject has no map yet');
	              this.deferred.resolve(this.gObject);
	            }
	          }
	          if (this.model[this.fitKey]) {
	            return this.gManager.fit();
	          }
	        };
	
	        MarkerChildModel.prototype.setLabelOptions = function(opts) {
	          if (opts.labelAnchor) {
	            opts.labelAnchor = this.getLabelPositionPoint(opts.labelAnchor);
	          }
	          return opts;
	        };
	
	        MarkerChildModel.prototype.internalEvents = function() {
	          return {
	            dragend: (function(_this) {
	              return function(marker, eventName, model, mousearg) {
	                var events, modelToSet, newCoords;
	                modelToSet = _this.trackModel ? _this.scope.model : _this.model;
	                newCoords = _this.setCoordsFromEvent(_this.modelOrKey(modelToSet, _this.coordsKey), _this.gObject.getPosition());
	                modelToSet = _this.setVal(model, _this.coordsKey, newCoords);
	                events = _this.scope.events;
	                if ((events != null ? events.dragend : void 0) != null) {
	                  events.dragend(marker, eventName, modelToSet, mousearg);
	                }
	                return _this.scope.$apply();
	              };
	            })(this),
	            click: (function(_this) {
	              return function(marker, eventName, model, mousearg) {
	                var click;
	                click = _this.getProp('click', _this.scope, _this.model);
	                if (_this.doClick && angular.isFunction(click)) {
	                  return _this.scope.$evalAsync(click(marker, eventName, _this.model, mousearg));
	                }
	              };
	            })(this)
	          };
	        };
	
	        return MarkerChildModel;
	
	      })(ModelKey);
	      return MarkerChildModel;
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapPolygonChildModel', [
	    'uiGmapBasePolyChildModel', 'uiGmapPolygonOptionsBuilder', function(BaseGen, Builder) {
	      var PolygonChildModel, base, gFactory;
	      gFactory = function(opts) {
	        return new google.maps.Polygon(opts);
	      };
	      base = new BaseGen(Builder, gFactory);
	      return PolygonChildModel = (function(superClass) {
	        extend(PolygonChildModel, superClass);
	
	        function PolygonChildModel() {
	          return PolygonChildModel.__super__.constructor.apply(this, arguments);
	        }
	
	        return PolygonChildModel;
	
	      })(base);
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapPolylineChildModel', [
	    'uiGmapBasePolyChildModel', 'uiGmapPolylineOptionsBuilder', function(BaseGen, Builder) {
	      var PolylineChildModel, base, gFactory;
	      gFactory = function(opts) {
	        return new google.maps.Polyline(opts);
	      };
	      base = BaseGen(Builder, gFactory);
	      return PolylineChildModel = (function(superClass) {
	        extend(PolylineChildModel, superClass);
	
	        function PolylineChildModel() {
	          return PolylineChildModel.__super__.constructor.apply(this, arguments);
	        }
	
	        return PolylineChildModel;
	
	      })(base);
	    }
	  ]);
	
	}).call(this);
	;
	/*global _:true,angular:true,google:true */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api.models.child').factory('uiGmapWindowChildModel', [
	    'uiGmapBaseObject', 'uiGmapGmapUtil', 'uiGmapLogger', '$compile', '$http', '$templateCache', 'uiGmapChromeFixes', 'uiGmapEventsHelper', function(BaseObject, GmapUtil, $log, $compile, $http, $templateCache, ChromeFixes, EventsHelper) {
	      var WindowChildModel;
	      WindowChildModel = (function(superClass) {
	        extend(WindowChildModel, superClass);
	
	        WindowChildModel.include(GmapUtil);
	
	        WindowChildModel.include(EventsHelper);
	
	        function WindowChildModel(opts) {
	          this.updateModel = bind(this.updateModel, this);
	          this.destroy = bind(this.destroy, this);
	          this.remove = bind(this.remove, this);
	          this.getLatestPosition = bind(this.getLatestPosition, this);
	          this.hideWindow = bind(this.hideWindow, this);
	          this.showWindow = bind(this.showWindow, this);
	          this.handleClick = bind(this.handleClick, this);
	          this.watchOptions = bind(this.watchOptions, this);
	          this.watchCoords = bind(this.watchCoords, this);
	          this.createGWin = bind(this.createGWin, this);
	          this.watchElement = bind(this.watchElement, this);
	          this.watchAndDoShow = bind(this.watchAndDoShow, this);
	          this.doShow = bind(this.doShow, this);
	          var maybeMarker, ref, ref1, ref2, ref3;
	          this.model = (ref = opts.model) != null ? ref : {}, this.scope = opts.scope, this.opts = opts.opts, this.isIconVisibleOnClick = opts.isIconVisibleOnClick, this.gMap = opts.gMap, this.markerScope = opts.markerScope, this.element = opts.element, this.needToManualDestroy = (ref1 = opts.needToManualDestroy) != null ? ref1 : false, this.markerIsVisibleAfterWindowClose = (ref2 = opts.markerIsVisibleAfterWindowClose) != null ? ref2 : true, this.isScopeModel = (ref3 = opts.isScopeModel) != null ? ref3 : false;
	          if (this.isScopeModel) {
	            this.clonedModel = _.clone(this.model, true);
	          }
	          this.getGmarker = function() {
	            var ref4, ref5;
	            if (((ref4 = this.markerScope) != null ? ref4['getGMarker'] : void 0) != null) {
	              return (ref5 = this.markerScope) != null ? ref5.getGMarker() : void 0;
	            }
	          };
	          this.listeners = [];
	          this.createGWin();
	          maybeMarker = this.getGmarker();
	          if (maybeMarker != null) {
	            maybeMarker.setClickable(true);
	          }
	          this.watchElement();
	          this.watchOptions();
	          this.watchCoords();
	          this.watchAndDoShow();
	          this.scope.$on('$destroy', (function(_this) {
	            return function() {
	              return _this.destroy();
	            };
	          })(this));
	          $log.info(this);
	        }
	
	        WindowChildModel.prototype.doShow = function(wasOpen) {
	          if (this.scope.show === true || wasOpen) {
	            return this.showWindow();
	          } else {
	            return this.hideWindow();
	          }
	        };
	
	        WindowChildModel.prototype.watchAndDoShow = function() {
	          if (this.model.show != null) {
	            this.scope.show = this.model.show;
	          }
	          this.scope.$watch('show', this.doShow, true);
	          return this.doShow();
	        };
	
	        WindowChildModel.prototype.watchElement = function() {
	          return this.scope.$watch((function(_this) {
	            return function() {
	              var ref, wasOpen;
	              if (!(_this.element || _this.html)) {
	                return;
	              }
	              if (_this.html !== _this.element.html() && _this.gObject) {
	                if ((ref = _this.opts) != null) {
	                  ref.content = void 0;
	                }
	                wasOpen = _this.gObject.isOpen();
	                _this.remove();
	                return _this.createGWin(wasOpen);
	              }
	            };
	          })(this));
	        };
	
	        WindowChildModel.prototype.createGWin = function(isOpen) {
	          var _opts, defaults, maybeMarker, ref, ref1;
	          if (isOpen == null) {
	            isOpen = false;
	          }
	          maybeMarker = this.getGmarker();
	          defaults = {};
	          if (this.opts != null) {
	            if (this.scope.coords) {
	              this.opts.position = this.getCoords(this.scope.coords);
	            }
	            defaults = this.opts;
	          }
	          if (this.element) {
	            this.html = _.isObject(this.element) ? this.element.html() : this.element;
	          }
	          _opts = this.scope.options ? this.scope.options : defaults;
	          this.opts = this.createWindowOptions(maybeMarker, this.markerScope || this.scope, this.html, _opts);
	          if (this.opts != null) {
	            if (!this.gObject) {
	              if (this.opts.boxClass && (window.InfoBox && typeof window.InfoBox === 'function')) {
	                this.gObject = new window.InfoBox(this.opts);
	              } else {
	                this.gObject = new google.maps.InfoWindow(this.opts);
	              }
	              this.listeners.push(google.maps.event.addListener(this.gObject, 'domready', function() {
	                return ChromeFixes.maybeRepaint(this.content);
	              }));
	              this.listeners.push(google.maps.event.addListener(this.gObject, 'closeclick', (function(_this) {
	                return function() {
	                  if (maybeMarker) {
	                    maybeMarker.setAnimation(_this.oldMarkerAnimation);
	                    if (_this.markerIsVisibleAfterWindowClose) {
	                      _.delay(function() {
	                        maybeMarker.setVisible(false);
	                        return maybeMarker.setVisible(_this.markerIsVisibleAfterWindowClose);
	                      }, 250);
	                    }
	                  }
	                  _this.gObject.close();
	                  _this.model.show = false;
	                  if (_this.scope.closeClick != null) {
	                    return _this.scope.$evalAsync(_this.scope.closeClick());
	                  } else {
	                    return _this.scope.$evalAsync();
	                  }
	                };
	              })(this)));
	            }
	            this.gObject.setContent(this.opts.content);
	            this.handleClick(((ref = this.scope) != null ? (ref1 = ref.options) != null ? ref1.forceClick : void 0 : void 0) || isOpen);
	            return this.doShow(this.gObject.isOpen());
	          }
	        };
	
	        WindowChildModel.prototype.watchCoords = function() {
	          var scope;
	          scope = this.markerScope != null ? this.markerScope : this.scope;
	          return scope.$watch('coords', (function(_this) {
	            return function(newValue, oldValue) {
	              var pos;
	              if (newValue !== oldValue) {
	                if (newValue == null) {
	                  _this.hideWindow();
	                } else if (!_this.validateCoords(newValue)) {
	                  $log.error("WindowChildMarker cannot render marker as scope.coords as no position on marker: " + (JSON.stringify(_this.model)));
	                  return;
	                }
	                pos = _this.getCoords(newValue);
	                _this.doShow();
	                _this.gObject.setPosition(pos);
	                if (_this.opts) {
	                  return _this.opts.position = pos;
	                }
	              }
	            };
	          })(this), true);
	        };
	
	        WindowChildModel.prototype.watchOptions = function() {
	          return this.scope.$watch('options', (function(_this) {
	            return function(newValue, oldValue) {
	              if (newValue !== oldValue) {
	                _this.opts = newValue;
	                if (_this.gObject != null) {
	                  _this.gObject.setOptions(_this.opts);
	                  if ((_this.opts.visible != null) && _this.opts.visible) {
	                    return _this.showWindow();
	                  } else if (_this.opts.visible != null) {
	                    return _this.hideWindow();
	                  }
	                }
	              }
	            };
	          })(this), true);
	        };
	
	        WindowChildModel.prototype.handleClick = function(forceClick) {
	          var click, maybeMarker;
	          if (this.gObject == null) {
	            return;
	          }
	          maybeMarker = this.getGmarker();
	          click = (function(_this) {
	            return function() {
	              if (_this.gObject == null) {
	                _this.createGWin();
	              }
	              _this.showWindow();
	              if (maybeMarker != null) {
	                _this.initialMarkerVisibility = maybeMarker.getVisible();
	                _this.oldMarkerAnimation = maybeMarker.getAnimation();
	                return maybeMarker.setVisible(_this.isIconVisibleOnClick);
	              }
	            };
	          })(this);
	          if (forceClick) {
	            click();
	          }
	          if (maybeMarker) {
	            return this.listeners = this.listeners.concat(this.setEvents(maybeMarker, {
	              events: {
	                click: click
	              }
	            }, this.model));
	          }
	        };
	
	        WindowChildModel.prototype.showWindow = function() {
	          var compiled, show, templateScope;
	          if (this.gObject == null) {
	            return;
	          }
	          templateScope = null;
	          show = (function(_this) {
	            return function() {
	              var isOpen, maybeMarker, pos;
	              if (!_this.gObject.isOpen()) {
	                maybeMarker = _this.getGmarker();
	                if ((_this.gObject != null) && (_this.gObject.getPosition != null)) {
	                  pos = _this.gObject.getPosition();
	                }
	                if (maybeMarker) {
	                  pos = maybeMarker.getPosition();
	                }
	                if (!pos) {
	                  return;
	                }
	                _this.gObject.open(_this.gMap, maybeMarker);
	                isOpen = _this.gObject.isOpen();
	                if (_this.model.show !== isOpen) {
	                  return _this.model.show = isOpen;
	                }
	              }
	            };
	          })(this);
	          if (this.scope.templateUrl) {
	            $http.get(this.scope.templateUrl, {
	              cache: $templateCache
	            }).then((function(_this) {
	              return function(content) {
	                var compiled;
	                templateScope = _this.scope.$new();
	                if (angular.isDefined(_this.scope.templateParameter)) {
	                  templateScope.parameter = _this.scope.templateParameter;
	                }
	                compiled = $compile(content.data)(templateScope);
	                _this.gObject.setContent(compiled[0]);
	                return show();
	              };
	            })(this));
	          } else if (this.scope.template) {
	            templateScope = this.scope.$new();
	            if (angular.isDefined(this.scope.templateParameter)) {
	              templateScope.parameter = this.scope.templateParameter;
	            }
	            compiled = $compile(this.scope.template)(templateScope);
	            this.gObject.setContent(compiled[0]);
	            show();
	          } else {
	            show();
	          }
	          return this.scope.$on('destroy', function() {
	            return templateScope.$destroy();
	          });
	        };
	
	        WindowChildModel.prototype.hideWindow = function() {
	          if ((this.gObject != null) && this.gObject.isOpen()) {
	            return this.gObject.close();
	          }
	        };
	
	        WindowChildModel.prototype.getLatestPosition = function(overridePos) {
	          var maybeMarker;
	          maybeMarker = this.getGmarker();
	          if ((this.gObject != null) && (maybeMarker != null) && !overridePos) {
	            return this.gObject.setPosition(maybeMarker.getPosition());
	          } else {
	            if (overridePos) {
	              return this.gObject.setPosition(overridePos);
	            }
	          }
	        };
	
	        WindowChildModel.prototype.remove = function() {
	          this.hideWindow();
	          this.removeEvents(this.listeners);
	          this.listeners.length = 0;
	          delete this.gObject;
	          return delete this.opts;
	        };
	
	        WindowChildModel.prototype.destroy = function(manualOverride) {
	          var ref;
	          if (manualOverride == null) {
	            manualOverride = false;
	          }
	          this.remove();
	          if (((this.scope != null) && !((ref = this.scope) != null ? ref.$$destroyed : void 0)) && (this.needToManualDestroy || manualOverride)) {
	            return this.scope.$destroy();
	          }
	        };
	
	        WindowChildModel.prototype.updateModel = function(model) {
	          if (this.isScopeModel) {
	            this.clonedModel = _.clone(model, true);
	          }
	          return _.extend(this.model, this.clonedModel || model);
	        };
	
	        return WindowChildModel;
	
	      })(BaseObject);
	      return WindowChildModel;
	    }
	  ]);
	
	}).call(this);
	;
	/*global _, angular */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapBasePolysParentModel', [
	    '$timeout', 'uiGmapLogger', 'uiGmapModelKey', 'uiGmapModelsWatcher', 'uiGmapPropMap', 'uiGmap_async', 'uiGmapPromise', 'uiGmapFitHelper', function($timeout, $log, ModelKey, ModelsWatcher, PropMap, _async, uiGmapPromise, FitHelper) {
	      return function(IPoly, PolyChildModel, gObjectName) {
	        var BasePolysParentModel;
	        return BasePolysParentModel = (function(superClass) {
	          extend(BasePolysParentModel, superClass);
	
	          BasePolysParentModel.include(ModelsWatcher);
	
	          function BasePolysParentModel(scope, element, attrs, gMap1, defaults) {
	            this.element = element;
	            this.attrs = attrs;
	            this.gMap = gMap1;
	            this.defaults = defaults;
	            this.maybeFit = bind(this.maybeFit, this);
	            this.createChild = bind(this.createChild, this);
	            this.pieceMeal = bind(this.pieceMeal, this);
	            this.createAllNew = bind(this.createAllNew, this);
	            this.watchIdKey = bind(this.watchIdKey, this);
	            this.createChildScopes = bind(this.createChildScopes, this);
	            this.watchDestroy = bind(this.watchDestroy, this);
	            this.onDestroy = bind(this.onDestroy, this);
	            this.rebuildAll = bind(this.rebuildAll, this);
	            this.doINeedToWipe = bind(this.doINeedToWipe, this);
	            this.watchModels = bind(this.watchModels, this);
	            BasePolysParentModel.__super__.constructor.call(this, scope);
	            this["interface"] = IPoly;
	            this.$log = $log;
	            this.plurals = new PropMap();
	            _.each(IPoly.scopeKeys, (function(_this) {
	              return function(name) {
	                return _this[name + 'Key'] = void 0;
	              };
	            })(this));
	            this.models = void 0;
	            this.firstTime = true;
	            this.$log.info(this);
	            this.createChildScopes();
	          }
	
	          BasePolysParentModel.prototype.watchModels = function(scope) {
	
	            /*
	              This was watchCollection but not all model changes were being caught.
	              TODO: Make the directive flexible in overriding whether we watch models (and depth) via watch or watchColleciton.
	             */
	            return scope.$watch('models', (function(_this) {
	              return function(newValue, oldValue) {
	                if (newValue !== oldValue) {
	                  if (_this.doINeedToWipe(newValue) || scope.doRebuildAll) {
	                    return _this.rebuildAll(scope, true, true);
	                  } else {
	                    return _this.createChildScopes(false);
	                  }
	                }
	              };
	            })(this), true);
	          };
	
	          BasePolysParentModel.prototype.doINeedToWipe = function(newValue) {
	            var newValueIsEmpty;
	            newValueIsEmpty = newValue != null ? newValue.length === 0 : true;
	            return this.plurals.length > 0 && newValueIsEmpty;
	          };
	
	          BasePolysParentModel.prototype.rebuildAll = function(scope, doCreate, doDelete) {
	            return this.onDestroy(doDelete).then((function(_this) {
	              return function() {
	                if (doCreate) {
	                  return _this.createChildScopes();
	                }
	              };
	            })(this));
	          };
	
	          BasePolysParentModel.prototype.onDestroy = function() {
	            BasePolysParentModel.__super__.onDestroy.call(this, this.scope);
	            return _async.promiseLock(this, uiGmapPromise.promiseTypes["delete"], void 0, void 0, (function(_this) {
	              return function() {
	                return _async.each(_this.plurals.values(), function(child) {
	                  return child.destroy(true);
	                }, _async.chunkSizeFrom(_this.scope.cleanchunk, false)).then(function() {
	                  var ref;
	                  return (ref = _this.plurals) != null ? ref.removeAll() : void 0;
	                });
	              };
	            })(this));
	          };
	
	          BasePolysParentModel.prototype.watchDestroy = function(scope) {
	            return scope.$on('$destroy', (function(_this) {
	              return function() {
	                return _this.rebuildAll(scope, false, true);
	              };
	            })(this));
	          };
	
	          BasePolysParentModel.prototype.createChildScopes = function(isCreatingFromScratch) {
	            if (isCreatingFromScratch == null) {
	              isCreatingFromScratch = true;
	            }
	            if (angular.isUndefined(this.scope.models)) {
	              this.$log.error("No models to create " + gObjectName + "s from! I Need direct models!");
	              return;
	            }
	            if ((this.gMap == null) || (this.scope.models == null)) {
	              return;
	            }
	            this.watchIdKey(this.scope);
	            if (isCreatingFromScratch) {
	              return this.createAllNew(this.scope, false);
	            } else {
	              return this.pieceMeal(this.scope, false);
	            }
	          };
	
	          BasePolysParentModel.prototype.watchIdKey = function(scope) {
	            this.setIdKey(scope);
	            return scope.$watch('idKey', (function(_this) {
	              return function(newValue, oldValue) {
	                if (newValue !== oldValue && (newValue == null)) {
	                  _this.idKey = newValue;
	                  return _this.rebuildAll(scope, true, true);
	                }
	              };
	            })(this));
	          };
	
	          BasePolysParentModel.prototype.createAllNew = function(scope, isArray) {
	            var maybeCanceled;
	            if (isArray == null) {
	              isArray = false;
	            }
	            this.models = scope.models;
	            if (this.firstTime) {
	              this.watchModels(scope);
	              this.watchDestroy(scope);
	            }
	            if (this.didQueueInitPromise(this, scope)) {
	              return;
	            }
	            maybeCanceled = null;
	            return _async.promiseLock(this, uiGmapPromise.promiseTypes.create, 'createAllNew', (function(canceledMsg) {
	              return maybeCanceled = canceledMsg;
	            }), (function(_this) {
	              return function() {
	                return _async.map(scope.models, function(model) {
	                  var child;
	                  child = _this.createChild(model, _this.gMap);
	                  if (maybeCanceled) {
	                    $log.debug('createNew should fall through safely');
	                    child.isEnabled = false;
	                  }
	                  maybeCanceled;
	                  return child.pathPoints.getArray();
	                }, _async.chunkSizeFrom(scope.chunk)).then(function(pathPoints) {
	                  _this.maybeFit(pathPoints);
	                  return _this.firstTime = false;
	                });
	              };
	            })(this));
	          };
	
	          BasePolysParentModel.prototype.pieceMeal = function(scope, isArray) {
	            var maybeCanceled, payload;
	            if (isArray == null) {
	              isArray = true;
	            }
	            if (scope.$$destroyed) {
	              return;
	            }
	            maybeCanceled = null;
	            payload = null;
	            this.models = scope.models;
	            if ((scope != null) && this.modelsLength() && this.plurals.length) {
	              return _async.promiseLock(this, uiGmapPromise.promiseTypes.update, 'pieceMeal', (function(canceledMsg) {
	                return maybeCanceled = canceledMsg;
	              }), (function(_this) {
	                return function() {
	                  return uiGmapPromise.promise(function() {
	                    return _this.figureOutState(_this.idKey, scope, _this.plurals, _this.modelKeyComparison);
	                  }).then(function(state) {
	                    payload = state;
	                    if (payload.updates.length) {
	                      _async.each(payload.updates, function(obj) {
	                        _.extend(obj.child.scope, obj.model);
	                        return obj.child.model = obj.model;
	                      });
	                    }
	                    return _async.each(payload.removals, function(child) {
	                      if (child != null) {
	                        child.destroy();
	                        _this.plurals.remove(child.model[_this.idKey]);
	                        return maybeCanceled;
	                      }
	                    }, _async.chunkSizeFrom(scope.chunk));
	                  }).then(function() {
	                    return _async.each(payload.adds, function(modelToAdd) {
	                      if (maybeCanceled) {
	                        $log.debug('pieceMeal should fall through safely');
	                      }
	                      _this.createChild(modelToAdd, _this.gMap);
	                      return maybeCanceled;
	                    }, _async.chunkSizeFrom(scope.chunk)).then(function() {
	                      return _this.maybeFit();
	                    });
	                  });
	                };
	              })(this));
	            } else {
	              this.inProgress = false;
	              return this.rebuildAll(this.scope, true, true);
	            }
	          };
	
	          BasePolysParentModel.prototype.createChild = function(model, gMap) {
	            var child, childScope;
	            childScope = this.scope.$new(false);
	            this.setChildScope(IPoly.scopeKeys, childScope, model);
	            childScope.$watch('model', (function(_this) {
	              return function(newValue, oldValue) {
	                if (newValue !== oldValue) {
	                  return _this.setChildScope(IPoly.scopeKeys, childScope, newValue);
	                }
	              };
	            })(this), true);
	            childScope["static"] = this.scope["static"];
	            child = new PolyChildModel({
	              isScopeModel: true,
	              scope: childScope,
	              attrs: this.attrs,
	              gMap: gMap,
	              defaults: this.defaults,
	              model: model,
	              gObjectChangeCb: (function(_this) {
	                return function() {
	                  return _this.maybeFit();
	                };
	              })(this)
	            });
	            if (model[this.idKey] == null) {
	              this.$log.error(gObjectName + " model has no id to assign a child to.\nThis is required for performance. Please assign id,\nor redirect id to a different key.");
	              return;
	            }
	            this.plurals.put(model[this.idKey], child);
	            return child;
	          };
	
	          BasePolysParentModel.prototype.maybeFit = function(pathPoints) {
	            if (pathPoints == null) {
	              pathPoints = this.plurals.map(function(p) {
	                return p.pathPoints;
	              });
	            }
	            if (this.scope.fit) {
	              pathPoints = _.flatten(pathPoints);
	              return FitHelper.fit(pathPoints, this.gMap);
	            }
	          };
	
	          return BasePolysParentModel;
	
	        })(ModelKey);
	      };
	    }
	  ]);
	
	}).call(this);
	;
	/*globals angular, _, google */
	
	(function() {
	  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapCircleParentModel', [
	    'uiGmapLogger', '$timeout', 'uiGmapGmapUtil', 'uiGmapEventsHelper', 'uiGmapCircleOptionsBuilder', function($log, $timeout, GmapUtil, EventsHelper, Builder) {
	      var CircleParentModel, _settingFromDirective;
	      _settingFromDirective = function(scope, fn) {
	        scope.settingFromDirective = true;
	        fn();
	        return $timeout(function() {
	          return scope.settingFromDirective = false;
	        });
	      };
	      return CircleParentModel = (function(superClass) {
	        extend(CircleParentModel, superClass);
	
	        CircleParentModel.include(GmapUtil);
	
	        CircleParentModel.include(EventsHelper);
	
	        function CircleParentModel(scope, element, attrs, gMap, DEFAULTS) {
	          var clean, gObject, lastRadius;
	          this.attrs = attrs;
	          this.gMap = gMap;
	          this.DEFAULTS = DEFAULTS;
	          this.scope = scope;
	          lastRadius = null;
	          clean = (function(_this) {
	            return function() {
	              lastRadius = null;
	              if (_this.listeners != null) {
	                _this.removeEvents(_this.listeners);
	                return _this.listeners = void 0;
	              }
	            };
	          })(this);
	          gObject = new google.maps.Circle(this.buildOpts(GmapUtil.getCoords(scope.center), scope.radius));
	          this.setMyOptions = (function(_this) {
	            return function(newVals, oldVals) {
	              if (scope.settingFromDirective) {
	                return;
	              }
	              if (!(_.isEqual(newVals, oldVals) && newVals === oldVals && ((newVals != null) && (oldVals != null) ? newVals.coordinates === oldVals.coordinates : true))) {
	                return gObject.setOptions(_this.buildOpts(GmapUtil.getCoords(scope.center), scope.radius));
	              }
	            };
	          })(this);
	          this.props = this.props.concat([
	            {
	              prop: 'center',
	              isColl: true
	            }, {
	              prop: 'fill',
	              isColl: true
	            }, 'radius', 'zIndex'
	          ]);
	          this.watchProps();
	          if (this.scope.control != null) {
	            this.scope.control.getCircle = function() {
	              return gObject;
	            };
	          }
	          clean();
	          this.listeners = this.setEvents(gObject, scope, scope, ['radius_changed']) || [];
	          this.listeners.push(google.maps.event.addListener(gObject, 'radius_changed', function() {
	
	            /*
	              possible google bug, and or because a circle has two radii
	              radius_changed appears to fire twice (original and new) which is not too helpful
	              therefore we will check for radius changes manually and bail out if nothing has changed
	             */
	            var newRadius, work;
	            newRadius = gObject.getRadius();
	            if (newRadius === lastRadius) {
	              return;
	            }
	            lastRadius = newRadius;
	            work = function() {
	              return _settingFromDirective(scope, function() {
	                var ref, ref1;
	                if (newRadius !== scope.radius) {
	                  scope.radius = newRadius;
	                }
	                if (((ref = scope.events) != null ? ref.radius_changed : void 0) && _.isFunction((ref1 = scope.events) != null ? ref1.radius_changed : void 0)) {
	                  return scope.events.radius_changed(gObject, 'radius_changed', scope, arguments);
	                }
	              });
	            };
	            if (!angular.mock) {
	              return scope.$evalAsync(function() {
	                return work();
	              });
	            } else {
	              return work();
	            }
	          }));
	          this.listeners.push(google.maps.event.addListener(gObject, 'center_changed', function() {
	            return scope.$evalAsync(function() {
	              return _settingFromDirective(scope, function() {
	                if (angular.isDefined(scope.center.type)) {
	                  scope.center.coordinates[1] = gObject.getCenter().lat();
	                  return scope.center.coordinates[0] = gObject.getCenter().lng();
	                } else {
	                  scope.center.latitude = gObject.getCenter().lat();
	                  return scope.center.longitude = gObject.getCenter().lng();
	                }
	              });
	            });
	          }));
	          scope.$on('$destroy', function() {
	            clean();
	            return gObject.setMap(null);
	          });
	          $log.info(this);
	        }
	
	        return CircleParentModel;
	
	      })(Builder);
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapDrawingManagerParentModel', [
	    'uiGmapLogger', '$timeout', 'uiGmapBaseObject', 'uiGmapEventsHelper', function($log, $timeout, BaseObject, EventsHelper) {
	      var DrawingManagerParentModel;
	      return DrawingManagerParentModel = (function(superClass) {
	        extend(DrawingManagerParentModel, superClass);
	
	        DrawingManagerParentModel.include(EventsHelper);
	
	        function DrawingManagerParentModel(scope, element, attrs, map) {
	          var gObject, listeners;
	          this.scope = scope;
	          this.attrs = attrs;
	          this.map = map;
	          gObject = new google.maps.drawing.DrawingManager(this.scope.options);
	          gObject.setMap(this.map);
	          listeners = void 0;
	          if (this.scope.control != null) {
	            this.scope.control.getDrawingManager = function() {
	              return gObject;
	            };
	          }
	          if (!this.scope["static"] && this.scope.options) {
	            this.scope.$watch('options', function(newValue) {
	              return gObject != null ? gObject.setOptions(newValue) : void 0;
	            }, true);
	          }
	          if (this.scope.events != null) {
	            listeners = this.setEvents(gObject, this.scope, this.scope);
	            this.scope.$watch('events', (function(_this) {
	              return function(newValue, oldValue) {
	                if (!_.isEqual(newValue, oldValue)) {
	                  if (listeners != null) {
	                    _this.removeEvents(listeners);
	                  }
	                  return listeners = _this.setEvents(gObject, _this.scope, _this.scope);
	                }
	              };
	            })(this));
	          }
	          this.scope.$on('$destroy', (function(_this) {
	            return function() {
	              if (listeners != null) {
	                _this.removeEvents(listeners);
	              }
	              gObject.setMap(null);
	              return gObject = null;
	            };
	          })(this));
	        }
	
	        return DrawingManagerParentModel;
	
	      })(BaseObject);
	    }
	  ]);
	
	}).call(this);
	;
	/*
		- interface for all markers to derrive from
	 	- to enforce a minimum set of requirements
	 		- attributes
	 			- coords
	 			- icon
			- implementation needed on watches
	 */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module("uiGmapgoogle-maps.directives.api.models.parent").factory("uiGmapIMarkerParentModel", [
	    "uiGmapModelKey", "uiGmapLogger", function(ModelKey, Logger) {
	      var IMarkerParentModel;
	      IMarkerParentModel = (function(superClass) {
	        extend(IMarkerParentModel, superClass);
	
	        IMarkerParentModel.prototype.DEFAULTS = {};
	
	        function IMarkerParentModel(scope1, element, attrs, map) {
	          this.scope = scope1;
	          this.element = element;
	          this.attrs = attrs;
	          this.map = map;
	          this.onWatch = bind(this.onWatch, this);
	          this.watch = bind(this.watch, this);
	          this.validateScope = bind(this.validateScope, this);
	          IMarkerParentModel.__super__.constructor.call(this, this.scope);
	          this.$log = Logger;
	          if (!this.validateScope(this.scope)) {
	            throw new String("Unable to construct IMarkerParentModel due to invalid scope");
	          }
	          this.doClick = angular.isDefined(this.attrs.click);
	          if (this.scope.options != null) {
	            this.DEFAULTS = this.scope.options;
	          }
	          this.watch('coords', this.scope);
	          this.watch('icon', this.scope);
	          this.watch('options', this.scope);
	          this.scope.$on("$destroy", (function(_this) {
	            return function() {
	              return _this.onDestroy(_this.scope);
	            };
	          })(this));
	        }
	
	        IMarkerParentModel.prototype.validateScope = function(scope) {
	          var ret;
	          if (scope == null) {
	            this.$log.error(this.constructor.name + ": invalid scope used");
	            return false;
	          }
	          ret = scope.coords != null;
	          if (!ret) {
	            this.$log.error(this.constructor.name + ": no valid coords attribute found");
	            return false;
	          }
	          return ret;
	        };
	
	        IMarkerParentModel.prototype.watch = function(propNameToWatch, scope, equalityCheck) {
	          if (equalityCheck == null) {
	            equalityCheck = true;
	          }
	          return scope.$watch(propNameToWatch, (function(_this) {
	            return function(newValue, oldValue) {
	              if (!_.isEqual(newValue, oldValue)) {
	                return _this.onWatch(propNameToWatch, scope, newValue, oldValue);
	              }
	            };
	          })(this), equalityCheck);
	        };
	
	        IMarkerParentModel.prototype.onWatch = function(propNameToWatch, scope, newValue, oldValue) {};
	
	        return IMarkerParentModel;
	
	      })(ModelKey);
	      return IMarkerParentModel;
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module("uiGmapgoogle-maps.directives.api.models.parent").factory("uiGmapIWindowParentModel", [
	    "uiGmapModelKey", "uiGmapGmapUtil", "uiGmapLogger", function(ModelKey, GmapUtil, Logger) {
	      var IWindowParentModel;
	      return IWindowParentModel = (function(superClass) {
	        extend(IWindowParentModel, superClass);
	
	        IWindowParentModel.include(GmapUtil);
	
	        function IWindowParentModel(scope, element, attrs, ctrls, $timeout, $compile, $http, $templateCache) {
	          IWindowParentModel.__super__.constructor.call(this, scope);
	          this.$log = Logger;
	          this.$timeout = $timeout;
	          this.$compile = $compile;
	          this.$http = $http;
	          this.$templateCache = $templateCache;
	          this.DEFAULTS = {};
	          if (scope.options != null) {
	            this.DEFAULTS = scope.options;
	          }
	        }
	
	        IWindowParentModel.prototype.getItem = function(scope, modelsPropToIterate, index) {
	          if (modelsPropToIterate === 'models') {
	            return scope[modelsPropToIterate][index];
	          }
	          return scope[modelsPropToIterate].get(index);
	        };
	
	        return IWindowParentModel;
	
	      })(ModelKey);
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapLayerParentModel', [
	    'uiGmapBaseObject', 'uiGmapLogger', '$timeout', function(BaseObject, Logger, $timeout) {
	      var LayerParentModel;
	      LayerParentModel = (function(superClass) {
	        extend(LayerParentModel, superClass);
	
	        function LayerParentModel(scope, element, attrs, gMap, onLayerCreated, $log) {
	          this.scope = scope;
	          this.element = element;
	          this.attrs = attrs;
	          this.gMap = gMap;
	          this.onLayerCreated = onLayerCreated != null ? onLayerCreated : void 0;
	          this.$log = $log != null ? $log : Logger;
	          this.createGoogleLayer = bind(this.createGoogleLayer, this);
	          if (this.attrs.type == null) {
	            this.$log.info('type attribute for the layer directive is mandatory. Layer creation aborted!!');
	            return;
	          }
	          this.createGoogleLayer();
	          this.doShow = true;
	          if (angular.isDefined(this.attrs.show)) {
	            this.doShow = this.scope.show;
	          }
	          if (this.doShow && (this.gMap != null)) {
	            this.gObject.setMap(this.gMap);
	          }
	          this.scope.$watch('show', (function(_this) {
	            return function(newValue, oldValue) {
	              if (newValue !== oldValue) {
	                _this.doShow = newValue;
	                if (newValue) {
	                  return _this.gObject.setMap(_this.gMap);
	                } else {
	                  return _this.gObject.setMap(null);
	                }
	              }
	            };
	          })(this), true);
	          this.scope.$watch('options', (function(_this) {
	            return function(newValue, oldValue) {
	              if (newValue !== oldValue && _this.doShow) {
	                return _this.gObject.setOptions(newValue);
	              }
	            };
	          })(this), true);
	          this.scope.$on('$destroy', (function(_this) {
	            return function() {
	              return _this.gObject.setMap(null);
	            };
	          })(this));
	        }
	
	        LayerParentModel.prototype.createGoogleLayer = function() {
	          var base;
	          if (this.attrs.options == null) {
	            this.gObject = this.attrs.namespace === void 0 ? new google.maps[this.attrs.type]() : new google.maps[this.attrs.namespace][this.attrs.type]();
	          } else {
	            this.gObject = this.attrs.namespace === void 0 ? new google.maps[this.attrs.type](this.scope.options) : new google.maps[this.attrs.namespace][this.attrs.type](this.scope.options);
	          }
	          if ((this.gObject != null) && this.doShow) {
	            this.gObject.setMap(this.gMap);
	          }
	          if ((this.gObject != null) && (this.onLayerCreated != null)) {
	            return typeof (base = this.onLayerCreated(this.scope, this.gObject)) === "function" ? base(this.gObject) : void 0;
	          }
	        };
	
	        return LayerParentModel;
	
	      })(BaseObject);
	      return LayerParentModel;
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapMapTypeParentModel', [
	    'uiGmapBaseObject', 'uiGmapLogger', function(BaseObject, Logger) {
	      var MapTypeParentModel;
	      MapTypeParentModel = (function(superClass) {
	        extend(MapTypeParentModel, superClass);
	
	        function MapTypeParentModel(scope, element, attrs, gMap, $log, childModel, propMap) {
	          var watchChildModelOptions, watchChildModelShow, watchOptions, watchShow;
	          this.scope = scope;
	          this.element = element;
	          this.attrs = attrs;
	          this.gMap = gMap;
	          this.$log = $log != null ? $log : Logger;
	          this.childModel = childModel;
	          this.propMap = propMap;
	          this.refreshShown = bind(this.refreshShown, this);
	          this.hideOverlay = bind(this.hideOverlay, this);
	          this.showOverlay = bind(this.showOverlay, this);
	          this.refreshMapType = bind(this.refreshMapType, this);
	          this.createMapType = bind(this.createMapType, this);
	          if (this.scope.options == null) {
	            this.$log.info('options attribute for the map-type directive is mandatory. Map type creation aborted!!');
	            return;
	          }
	          this.id = this.gMap.overlayMapTypesCount = this.gMap.overlayMapTypesCount + 1 || 0;
	          this.doShow = true;
	          this.createMapType();
	          this.refreshShown();
	          if (this.doShow && (this.gMap != null)) {
	            this.showOverlay();
	          }
	          watchChildModelShow = (function(_this) {
	            return function() {
	              return _this.childModel[_this.attrs.show];
	            };
	          })(this);
	          watchShow = this.childModel ? watchChildModelShow : 'show';
	          this.scope.$watch(watchShow, (function(_this) {
	            return function(newValue, oldValue) {
	              if (newValue !== oldValue) {
	                _this.doShow = newValue;
	                if (newValue) {
	                  return _this.showOverlay();
	                } else {
	                  return _this.hideOverlay();
	                }
	              }
	            };
	          })(this));
	          watchChildModelOptions = (function(_this) {
	            return function() {
	              return _this.childModel[_this.attrs.options];
	            };
	          })(this);
	          watchOptions = this.childModel ? watchChildModelOptions : 'options';
	          this.scope.$watchCollection(watchOptions, (function(_this) {
	            return function(newValue, oldValue) {
	              var different, mapTypeProps;
	              if (!_.isEqual(newValue, oldValue)) {
	                mapTypeProps = ['tileSize', 'maxZoom', 'minZoom', 'name', 'alt'];
	                different = _.some(mapTypeProps, function(prop) {
	                  return !oldValue || !newValue || !_.isEqual(newValue[prop], oldValue[prop]);
	                });
	                if (different) {
	                  return _this.refreshMapType();
	                }
	              }
	            };
	          })(this));
	          if (angular.isDefined(this.attrs.refresh)) {
	            this.scope.$watch('refresh', (function(_this) {
	              return function(newValue, oldValue) {
	                if (!_.isEqual(newValue, oldValue)) {
	                  return _this.refreshMapType();
	                }
	              };
	            })(this), true);
	          }
	          this.scope.$on('$destroy', (function(_this) {
	            return function() {
	              _this.hideOverlay();
	              return _this.mapType = null;
	            };
	          })(this));
	        }
	
	        MapTypeParentModel.prototype.createMapType = function() {
	          var id, idAttr, mapType;
	          mapType = this.childModel ? (this.attrs.options ? this.childModel[this.attrs.options] : this.childModel) : this.scope.options;
	          if (mapType.getTile != null) {
	            this.mapType = mapType;
	          } else if (mapType.getTileUrl != null) {
	            this.mapType = new google.maps.ImageMapType(mapType);
	          } else {
	            this.$log.info('options should provide either getTile or getTileUrl methods. Map type creation aborted!!');
	            return;
	          }
	          idAttr = this.attrs.id ? (this.childModel ? this.attrs.id : 'id') : void 0;
	          id = idAttr ? (this.childModel ? this.childModel[idAttr] : this.scope[idAttr]) : void 0;
	          if (id) {
	            this.gMap.mapTypes.set(id, this.mapType);
	            if (!angular.isDefined(this.attrs.show)) {
	              this.doShow = false;
	            }
	          }
	          this.mapType.layerId = this.id;
	          if (this.childModel && angular.isDefined(this.scope.index)) {
	            return this.propMap.put(this.mapType.layerId, this.scope.index);
	          }
	        };
	
	        MapTypeParentModel.prototype.refreshMapType = function() {
	          this.hideOverlay();
	          this.mapType = null;
	          this.createMapType();
	          if (this.doShow && (this.gMap != null)) {
	            return this.showOverlay();
	          }
	        };
	
	        MapTypeParentModel.prototype.showOverlay = function() {
	          var found;
	          if (angular.isDefined(this.scope.index)) {
	            found = false;
	            if (this.gMap.overlayMapTypes.getLength()) {
	              this.gMap.overlayMapTypes.forEach((function(_this) {
	                return function(mapType, index) {
	                  var layerIndex;
	                  if (!found) {
	                    layerIndex = _this.propMap.get(mapType.layerId.toString());
	                    if (layerIndex > _this.scope.index || !angular.isDefined(layerIndex)) {
	                      found = true;
	                      _this.gMap.overlayMapTypes.insertAt(index, _this.mapType);
	                    }
	                  }
	                };
	              })(this));
	              if (!found) {
	                return this.gMap.overlayMapTypes.push(this.mapType);
	              }
	            } else {
	              return this.gMap.overlayMapTypes.push(this.mapType);
	            }
	          } else {
	            return this.gMap.overlayMapTypes.push(this.mapType);
	          }
	        };
	
	        MapTypeParentModel.prototype.hideOverlay = function() {
	          var found;
	          found = false;
	          return this.gMap.overlayMapTypes.forEach((function(_this) {
	            return function(mapType, index) {
	              if (!found && mapType.layerId === _this.id) {
	                found = true;
	                _this.gMap.overlayMapTypes.removeAt(index);
	              }
	            };
	          })(this));
	        };
	
	        MapTypeParentModel.prototype.refreshShown = function() {
	          return this.doShow = angular.isDefined(this.attrs.show) ? (this.childModel ? this.childModel[this.attrs.show] : this.scope.show) : true;
	        };
	
	        return MapTypeParentModel;
	
	      })(BaseObject);
	      return MapTypeParentModel;
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapMapTypesParentModel', [
	    'uiGmapBaseObject', 'uiGmapLogger', 'uiGmapMapTypeParentModel', 'uiGmapPropMap', function(BaseObject, Logger, MapTypeParentModel, PropMap) {
	      var MapTypesParentModel;
	      MapTypesParentModel = (function(superClass) {
	        extend(MapTypesParentModel, superClass);
	
	        function MapTypesParentModel(scope, element, attrs, gMap, $log) {
	          var pMap;
	          this.scope = scope;
	          this.element = element;
	          this.attrs = attrs;
	          this.gMap = gMap;
	          this.$log = $log != null ? $log : Logger;
	          if (this.attrs.mapTypes == null) {
	            this.$log.info('layers attribute for the map-types directive is mandatory. Map types creation aborted!!');
	            return;
	          }
	          pMap = new PropMap;
	          this.scope.mapTypes.forEach((function(_this) {
	            return function(l, i) {
	              var childScope, mockAttr;
	              mockAttr = {
	                options: _this.scope.options,
	                show: _this.scope.show,
	                refresh: _this.scope.refresh
	              };
	              childScope = _this.scope.$new();
	              childScope.index = i;
	              new MapTypeParentModel(childScope, null, mockAttr, _this.gMap, _this.$log, l, pMap);
	            };
	          })(this));
	        }
	
	        return MapTypesParentModel;
	
	      })(BaseObject);
	      return MapTypesParentModel;
	    }
	  ]);
	
	}).call(this);
	;
	/*global _:true,angular:true, */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module("uiGmapgoogle-maps.directives.api.models.parent").factory("uiGmapMarkersParentModel", [
	    "uiGmapIMarkerParentModel", "uiGmapModelsWatcher", "uiGmapPropMap", "uiGmapMarkerChildModel", "uiGmap_async", "uiGmapClustererMarkerManager", "uiGmapMarkerManager", "$timeout", "uiGmapIMarker", "uiGmapPromise", "uiGmapGmapUtil", "uiGmapLogger", "uiGmapSpiderfierMarkerManager", function(IMarkerParentModel, ModelsWatcher, PropMap, MarkerChildModel, _async, ClustererMarkerManager, MarkerManager, $timeout, IMarker, uiGmapPromise, GmapUtil, $log, SpiderfierMarkerManager) {
	      var MarkersParentModel, _setPlurals;
	      _setPlurals = function(val, objToSet) {
	        objToSet.plurals = new PropMap();
	        objToSet.scope.plurals = objToSet.plurals;
	        return objToSet;
	      };
	      MarkersParentModel = (function(superClass) {
	        extend(MarkersParentModel, superClass);
	
	        MarkersParentModel.include(GmapUtil);
	
	        MarkersParentModel.include(ModelsWatcher);
	
	        function MarkersParentModel(scope, element, attrs, map) {
	          this.maybeExecMappedEvent = bind(this.maybeExecMappedEvent, this);
	          this.onDestroy = bind(this.onDestroy, this);
	          this.newChildMarker = bind(this.newChildMarker, this);
	          this.pieceMeal = bind(this.pieceMeal, this);
	          this.rebuildAll = bind(this.rebuildAll, this);
	          this.createAllNew = bind(this.createAllNew, this);
	          this.bindToTypeEvents = bind(this.bindToTypeEvents, this);
	          this.createChildScopes = bind(this.createChildScopes, this);
	          this.validateScope = bind(this.validateScope, this);
	          this.onWatch = bind(this.onWatch, this);
	          MarkersParentModel.__super__.constructor.call(this, scope, element, attrs, map);
	          this["interface"] = IMarker;
	          _setPlurals(new PropMap(), this);
	          this.scope.pluralsUpdate = {
	            updateCtr: 0
	          };
	          this.$log.info(this);
	          this.doRebuildAll = this.scope.doRebuildAll != null ? this.scope.doRebuildAll : false;
	          this.setIdKey(this.scope);
	          this.scope.$watch('doRebuildAll', (function(_this) {
	            return function(newValue, oldValue) {
	              if (newValue !== oldValue) {
	                return _this.doRebuildAll = newValue;
	              }
	            };
	          })(this));
	          if (!this.modelsLength()) {
	            this.modelsRendered = false;
	          }
	          this.scope.$watch('models', (function(_this) {
	            return function(newValue, oldValue) {
	              if (!_.isEqual(newValue, oldValue) || !_this.modelsRendered) {
	                if (newValue.length === 0 && oldValue.length === 0) {
	                  return;
	                }
	                _this.modelsRendered = true;
	                return _this.onWatch('models', _this.scope, newValue, oldValue);
	              }
	            };
	          })(this), !this.isTrue(attrs.modelsbyref));
	          this.watch('doCluster', this.scope);
	          this.watch('type', this.scope);
	          this.watch('clusterOptions', this.scope);
	          this.watch('clusterEvents', this.scope);
	          this.watch('typeOptions', this.scope);
	          this.watch('typeEvents', this.scope);
	          this.watch('fit', this.scope);
	          this.watch('idKey', this.scope);
	          this.gManager = void 0;
	          this.createAllNew(this.scope);
	        }
	
	        MarkersParentModel.prototype.onWatch = function(propNameToWatch, scope, newValue, oldValue) {
	          if (propNameToWatch === "idKey" && newValue !== oldValue) {
	            this.idKey = newValue;
	          }
	          if (this.doRebuildAll || (propNameToWatch === 'doCluster' || propNameToWatch === 'type')) {
	            return this.rebuildAll(scope);
	          } else {
	            return this.pieceMeal(scope);
	          }
	        };
	
	        MarkersParentModel.prototype.validateScope = function(scope) {
	          var modelsNotDefined;
	          modelsNotDefined = angular.isUndefined(scope.models) || scope.models === void 0;
	          if (modelsNotDefined) {
	            this.$log.error(this.constructor.name + ": no valid models attribute found");
	          }
	          return MarkersParentModel.__super__.validateScope.call(this, scope) || modelsNotDefined;
	        };
	
	
	        /*
	        Not used internally by this parent
	        created for consistency for external control in the API
	         */
	
	        MarkersParentModel.prototype.createChildScopes = function(isCreatingFromScratch) {
	          if ((this.gMap == null) || (this.scope.models == null)) {
	            return;
	          }
	          if (isCreatingFromScratch) {
	            return this.createAllNew(this.scope, false);
	          } else {
	            return this.pieceMeal(this.scope, false);
	          }
	        };
	
	        MarkersParentModel.prototype.bindToTypeEvents = function(typeEvents, events) {
	          var internalHandles, self;
	          if (events == null) {
	            events = ['click', 'mouseout', 'mouseover'];
	          }
	
	          /*
	            You should only be binding to events that produce groups/clusters of somthing.
	            Otherwise use the orginal event handle.
	            For Example: Click on a cluster pushes a cluster/group obj through which has getMarkers
	            However Spiderfy's click is for a single marker so this is not ideal for that.
	           */
	          self = this;
	          if (!this.origTypeEvents) {
	            this.origTypeEvents = {};
	            _.each(events, (function(_this) {
	              return function(eventName) {
	                return _this.origTypeEvents[eventName] = typeEvents != null ? typeEvents[eventName] : void 0;
	              };
	            })(this));
	          } else {
	            angular.extend(typeEvents, this.origTypeEvents);
	          }
	          internalHandles = {};
	          _.each(events, function(eventName) {
	            return internalHandles[eventName] = function(group) {
	              return self.maybeExecMappedEvent(group, eventName);
	            };
	          });
	          return angular.extend(typeEvents, internalHandles);
	        };
	
	        MarkersParentModel.prototype.createAllNew = function(scope) {
	          var isSpiderfied, maybeCanceled, typeEvents, typeOptions;
	          if (this.gManager != null) {
	            if (this.gManager instanceof SpiderfierMarkerManager) {
	              isSpiderfied = this.gManager.isSpiderfied();
	            }
	            this.gManager.clear();
	            delete this.gManager;
	          }
	          typeEvents = scope.typeEvents || scope.clusterEvents;
	          typeOptions = scope.typeOptions || scope.clusterOptions;
	          if (scope.doCluster || scope.type === 'cluster') {
	            if (typeEvents != null) {
	              this.bindToTypeEvents(typeEvents);
	            }
	            this.gManager = new ClustererMarkerManager(this.map, void 0, typeOptions, typeEvents);
	          } else if (scope.type === 'spider') {
	            if (typeEvents != null) {
	              this.bindToTypeEvents(typeEvents, ['spiderfy', 'unspiderfy']);
	            }
	            this.gManager = new SpiderfierMarkerManager(this.map, void 0, typeOptions, typeEvents, this.scope);
	            if (isSpiderfied) {
	              this.gManager.spiderfy();
	            }
	          } else {
	            this.gManager = new MarkerManager(this.map);
	          }
	          if (this.didQueueInitPromise(this, scope)) {
	            return;
	          }
	          maybeCanceled = null;
	          return _async.promiseLock(this, uiGmapPromise.promiseTypes.create, 'createAllNew', (function(canceledMsg) {
	            return maybeCanceled = canceledMsg;
	          }), (function(_this) {
	            return function() {
	              return _async.each(scope.models, function(model) {
	                _this.newChildMarker(model, scope);
	                return maybeCanceled;
	              }, _async.chunkSizeFrom(scope.chunk)).then(function() {
	                _this.modelsRendered = true;
	                if (scope.fit) {
	                  _this.gManager.fit();
	                }
	                _this.gManager.draw();
	                return _this.scope.pluralsUpdate.updateCtr += 1;
	              }, _async.chunkSizeFrom(scope.chunk));
	            };
	          })(this));
	        };
	
	        MarkersParentModel.prototype.rebuildAll = function(scope) {
	          var ref;
	          if (!scope.doRebuild && scope.doRebuild !== void 0) {
	            return;
	          }
	          if ((ref = this.scope.plurals) != null ? ref.length : void 0) {
	            return this.onDestroy(scope).then((function(_this) {
	              return function() {
	                return _this.createAllNew(scope);
	              };
	            })(this));
	          } else {
	            return this.createAllNew(scope);
	          }
	        };
	
	        MarkersParentModel.prototype.pieceMeal = function(scope) {
	          var maybeCanceled, payload;
	          if (scope.$$destroyed) {
	            return;
	          }
	          maybeCanceled = null;
	          payload = null;
	          if (this.modelsLength() && this.scope.plurals.length) {
	            return _async.promiseLock(this, uiGmapPromise.promiseTypes.update, 'pieceMeal', (function(canceledMsg) {
	              return maybeCanceled = canceledMsg;
	            }), (function(_this) {
	              return function() {
	                return uiGmapPromise.promise((function() {
	                  return _this.figureOutState(_this.idKey, scope, _this.scope.plurals, _this.modelKeyComparison);
	                })).then(function(state) {
	                  payload = state;
	                  return _async.each(payload.removals, function(child) {
	                    if (child != null) {
	                      if (child.destroy != null) {
	                        child.destroy();
	                      }
	                      _this.scope.plurals.remove(child.id);
	                      return maybeCanceled;
	                    }
	                  }, _async.chunkSizeFrom(scope.chunk));
	                }).then(function() {
	                  return _async.each(payload.adds, function(modelToAdd) {
	                    _this.newChildMarker(modelToAdd, scope);
	                    return maybeCanceled;
	                  }, _async.chunkSizeFrom(scope.chunk));
	                }).then(function() {
	                  return _async.each(payload.updates, function(update) {
	                    _this.updateChild(update.child, update.model);
	                    return maybeCanceled;
	                  }, _async.chunkSizeFrom(scope.chunk));
	                }).then(function() {
	                  if (payload.adds.length > 0 || payload.removals.length > 0 || payload.updates.length > 0) {
	                    scope.plurals = _this.scope.plurals;
	                    if (scope.fit) {
	                      _this.gManager.fit();
	                    }
	                    _this.gManager.draw();
	                  }
	                  return _this.scope.pluralsUpdate.updateCtr += 1;
	                });
	              };
	            })(this));
	          } else {
	            this.inProgress = false;
	            return this.rebuildAll(scope);
	          }
	        };
	
	        MarkersParentModel.prototype.newChildMarker = function(model, scope) {
	          var child, childScope, keys;
	          if (!model) {
	            throw 'model undefined';
	          }
	          if (model[this.idKey] == null) {
	            this.$log.error("Marker model has no id to assign a child to. This is required for performance. Please assign id, or redirect id to a different key.");
	            return;
	          }
	          this.$log.info('child', child, 'markers', this.scope.markerModels);
	          childScope = scope.$new(false);
	          childScope.events = scope.events;
	          keys = {};
	          IMarker.scopeKeys.forEach(function(k) {
	            return keys[k] = scope[k];
	          });
	          child = new MarkerChildModel({
	            scope: childScope,
	            model: model,
	            keys: keys,
	            gMap: this.map,
	            defaults: this.DEFAULTS,
	            doClick: this.doClick,
	            gManager: this.gManager,
	            doDrawSelf: false,
	            isScopeModel: true
	          });
	          this.scope.plurals.put(model[this.idKey], child);
	          return child;
	        };
	
	        MarkersParentModel.prototype.onDestroy = function(scope) {
	          MarkersParentModel.__super__.onDestroy.call(this, scope);
	          return _async.promiseLock(this, uiGmapPromise.promiseTypes["delete"], void 0, void 0, (function(_this) {
	            return function() {
	              return _async.each(_this.scope.plurals.values(), function(model) {
	                if (model != null) {
	                  return model.destroy(false);
	                }
	              }, _async.chunkSizeFrom(_this.scope.cleanchunk, false)).then(function() {
	                if (_this.gManager != null) {
	                  _this.gManager.destroy();
	                }
	                _this.plurals.removeAll();
	                if (_this.plurals !== _this.scope.plurals) {
	                  console.error('plurals out of sync for MarkersParentModel');
	                }
	                return _this.scope.pluralsUpdate.updateCtr += 1;
	              });
	            };
	          })(this));
	        };
	
	        MarkersParentModel.prototype.maybeExecMappedEvent = function(group, fnName) {
	          var pair, typeEvents;
	          if (this.scope.$$destroyed) {
	            return;
	          }
	          typeEvents = this.scope.typeEvents || this.scope.clusterEvents;
	          if (_.isFunction(typeEvents != null ? typeEvents[fnName] : void 0)) {
	            pair = this.mapTypeToPlurals(group);
	            if (this.origTypeEvents[fnName]) {
	              return this.origTypeEvents[fnName](pair.group, pair.mapped);
	            }
	          }
	        };
	
	        MarkersParentModel.prototype.mapTypeToPlurals = function(group) {
	          var arrayToMap, mapped, ref;
	          if (_.isArray(group)) {
	            arrayToMap = group;
	          } else if (_.isFunction(group.getMarkers)) {
	            arrayToMap = group.getMarkers();
	          }
	          if (arrayToMap == null) {
	            $log.error("Unable to map event as we cannot find the array group to map");
	            return;
	          }
	          if ((ref = this.scope.plurals.values()) != null ? ref.length : void 0) {
	            mapped = arrayToMap.map((function(_this) {
	              return function(g) {
	                return _this.scope.plurals.get(g.key).model;
	              };
	            })(this));
	          } else {
	            mapped = [];
	          }
	          return {
	            cluster: group,
	            mapped: mapped,
	            group: group
	          };
	        };
	
	        MarkersParentModel.prototype.getItem = function(scope, modelsPropToIterate, index) {
	          if (modelsPropToIterate === 'models') {
	            return scope[modelsPropToIterate][index];
	          }
	          return scope[modelsPropToIterate].get(index);
	        };
	
	        return MarkersParentModel;
	
	      })(IMarkerParentModel);
	      return MarkersParentModel;
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  ['Polygon', 'Polyline'].forEach(function(name) {
	    return angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory("uiGmap" + name + "sParentModel", [
	      'uiGmapBasePolysParentModel', "uiGmap" + name + "ChildModel", "uiGmapI" + name, function(BasePolysParentModel, ChildModel, IPoly) {
	        return BasePolysParentModel(IPoly, ChildModel, name);
	      }
	    ]);
	  });
	
	}).call(this);
	;
	/*globals angular, _, google */
	
	(function() {
	  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapRectangleParentModel', [
	    'uiGmapLogger', 'uiGmapGmapUtil', 'uiGmapEventsHelper', 'uiGmapRectangleOptionsBuilder', function($log, GmapUtil, EventsHelper, Builder) {
	      var RectangleParentModel;
	      return RectangleParentModel = (function(superClass) {
	        extend(RectangleParentModel, superClass);
	
	        RectangleParentModel.include(GmapUtil);
	
	        RectangleParentModel.include(EventsHelper);
	
	        function RectangleParentModel(scope, element, attrs, gMap, DEFAULTS) {
	          var bounds, clear, createBounds, dragging, fit, gObject, init, listeners, myListeners, settingBoundsFromScope, updateBounds;
	          this.scope = scope;
	          this.attrs = attrs;
	          this.gMap = gMap;
	          this.DEFAULTS = DEFAULTS;
	          bounds = void 0;
	          dragging = false;
	          myListeners = [];
	          listeners = void 0;
	          fit = (function(_this) {
	            return function() {
	              if (_this.isTrue(_this.attrs.fit)) {
	                return _this.fitMapBounds(_this.gMap, bounds);
	              }
	            };
	          })(this);
	          createBounds = (function(_this) {
	            return function() {
	              var ref, ref1, ref2;
	              if ((_this.scope.bounds != null) && (((ref = _this.scope.bounds) != null ? ref.sw : void 0) != null) && (((ref1 = _this.scope.bounds) != null ? ref1.ne : void 0) != null) && _this.validateBoundPoints(_this.scope.bounds)) {
	                bounds = _this.convertBoundPoints(_this.scope.bounds);
	                return $log.info("new new bounds created: " + (JSON.stringify(bounds)));
	              } else if ((_this.scope.bounds.getNorthEast != null) && (_this.scope.bounds.getSouthWest != null)) {
	                return bounds = _this.scope.bounds;
	              } else {
	                if (_this.scope.bounds != null) {
	                  return $log.error("Invalid bounds for newValue: " + (JSON.stringify((ref2 = _this.scope) != null ? ref2.bounds : void 0)));
	                }
	              }
	            };
	          })(this);
	          createBounds();
	          gObject = new google.maps.Rectangle(this.buildOpts(bounds));
	          $log.info("gObject (rectangle) created: " + gObject);
	          settingBoundsFromScope = false;
	          updateBounds = (function(_this) {
	            return function() {
	              var b, ne, sw;
	              b = gObject.getBounds();
	              ne = b.getNorthEast();
	              sw = b.getSouthWest();
	              if (settingBoundsFromScope) {
	                return;
	              }
	              return _this.scope.$evalAsync(function(s) {
	                if ((s.bounds != null) && (s.bounds.sw != null) && (s.bounds.ne != null)) {
	                  s.bounds.ne = {
	                    latitude: ne.lat(),
	                    longitude: ne.lng()
	                  };
	                  s.bounds.sw = {
	                    latitude: sw.lat(),
	                    longitude: sw.lng()
	                  };
	                }
	                if ((s.bounds.getNorthEast != null) && (s.bounds.getSouthWest != null)) {
	                  return s.bounds = b;
	                }
	              });
	            };
	          })(this);
	          init = (function(_this) {
	            return function() {
	              fit();
	              _this.removeEvents(myListeners);
	              myListeners.push(google.maps.event.addListener(gObject, 'dragstart', function() {
	                return dragging = true;
	              }));
	              myListeners.push(google.maps.event.addListener(gObject, 'dragend', function() {
	                dragging = false;
	                return updateBounds();
	              }));
	              return myListeners.push(google.maps.event.addListener(gObject, 'bounds_changed', function() {
	                if (dragging) {
	                  return;
	                }
	                return updateBounds();
	              }));
	            };
	          })(this);
	          clear = (function(_this) {
	            return function() {
	              _this.removeEvents(myListeners);
	              if (listeners != null) {
	                _this.removeEvents(listeners);
	              }
	              return gObject.setMap(null);
	            };
	          })(this);
	          if (bounds != null) {
	            init();
	          }
	          this.scope.$watch('bounds', (function(newValue, oldValue) {
	            var isNew;
	            if (_.isEqual(newValue, oldValue) && (bounds != null) || dragging) {
	              return;
	            }
	            settingBoundsFromScope = true;
	            if (newValue == null) {
	              clear();
	              return;
	            }
	            if (bounds == null) {
	              isNew = true;
	            } else {
	              fit();
	            }
	            createBounds();
	            gObject.setBounds(bounds);
	            settingBoundsFromScope = false;
	            if (isNew && (bounds != null)) {
	              return init();
	            }
	          }), true);
	          this.setMyOptions = (function(_this) {
	            return function(newVals, oldVals) {
	              if (!_.isEqual(newVals, oldVals)) {
	                if ((bounds != null) && (newVals != null)) {
	                  return gObject.setOptions(_this.buildOpts(bounds));
	                }
	              }
	            };
	          })(this);
	          this.props.push('bounds');
	          this.watchProps(this.props);
	          if (this.attrs.events != null) {
	            listeners = this.setEvents(gObject, this.scope, this.scope);
	            this.scope.$watch('events', (function(_this) {
	              return function(newValue, oldValue) {
	                if (!_.isEqual(newValue, oldValue)) {
	                  if (listeners != null) {
	                    _this.removeEvents(listeners);
	                  }
	                  return listeners = _this.setEvents(gObject, _this.scope, _this.scope);
	                }
	              };
	            })(this));
	          }
	          this.scope.$on('$destroy', function() {
	            return clear();
	          });
	          $log.info(this);
	        }
	
	        return RectangleParentModel;
	
	      })(Builder);
	    }
	  ]);
	
	}).call(this);
	;
	/*global angular:true, google:true */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapSearchBoxParentModel', [
	    'uiGmapBaseObject', 'uiGmapLogger', 'uiGmapEventsHelper', function(BaseObject, Logger, EventsHelper) {
	      var SearchBoxParentModel;
	      SearchBoxParentModel = (function(superClass) {
	        extend(SearchBoxParentModel, superClass);
	
	        SearchBoxParentModel.include(EventsHelper);
	
	        function SearchBoxParentModel(scope, element, attrs, gMap, ctrlPosition, template, $log) {
	          var controlDiv;
	          this.scope = scope;
	          this.element = element;
	          this.attrs = attrs;
	          this.gMap = gMap;
	          this.ctrlPosition = ctrlPosition;
	          this.template = template;
	          this.$log = $log != null ? $log : Logger;
	          this.setVisibility = bind(this.setVisibility, this);
	          this.getBounds = bind(this.getBounds, this);
	          this.setBounds = bind(this.setBounds, this);
	          this.createSearchBox = bind(this.createSearchBox, this);
	          this.addToParentDiv = bind(this.addToParentDiv, this);
	          this.addAsMapControl = bind(this.addAsMapControl, this);
	          this.init = bind(this.init, this);
	          if (this.attrs.template == null) {
	            this.$log.error('template attribute for the search-box directive is mandatory. Places Search Box creation aborted!!');
	            return;
	          }
	          if (angular.isUndefined(this.scope.options)) {
	            this.scope.options = {};
	            this.scope.options.visible = true;
	          }
	          if (angular.isUndefined(this.scope.options.visible)) {
	            this.scope.options.visible = true;
	          }
	          if (angular.isUndefined(this.scope.options.autocomplete)) {
	            this.scope.options.autocomplete = false;
	          }
	          this.visible = this.scope.options.visible;
	          this.autocomplete = this.scope.options.autocomplete;
	          controlDiv = angular.element('<div></div>');
	          controlDiv.append(this.template);
	          this.input = controlDiv.find('input')[0];
	          this.init();
	        }
	
	        SearchBoxParentModel.prototype.init = function() {
	          this.createSearchBox();
	          this.scope.$watch('options', (function(_this) {
	            return function(newValue, oldValue) {
	              if (angular.isObject(newValue)) {
	                if (newValue.bounds != null) {
	                  _this.setBounds(newValue.bounds);
	                }
	                if (newValue.visible != null) {
	                  if (_this.visible !== newValue.visible) {
	                    return _this.setVisibility(newValue.visible);
	                  }
	                }
	              }
	            };
	          })(this), true);
	          if (this.attrs.parentdiv != null) {
	            this.addToParentDiv();
	          } else {
	            this.addAsMapControl();
	          }
	          if (!this.visible) {
	            this.setVisibility(this.visible);
	          }
	          if (this.autocomplete) {
	            this.listener = google.maps.event.addListener(this.gObject, 'place_changed', (function(_this) {
	              return function() {
	                return _this.places = _this.gObject.getPlace();
	              };
	            })(this));
	          } else {
	            this.listener = google.maps.event.addListener(this.gObject, 'places_changed', (function(_this) {
	              return function() {
	                return _this.places = _this.gObject.getPlaces();
	              };
	            })(this));
	          }
	          this.listeners = this.setEvents(this.gObject, this.scope, this.scope);
	          this.$log.info(this);
	          this.scope.$on('$stateChangeSuccess', (function(_this) {
	            return function() {
	              if (_this.attrs.parentdiv != null) {
	                return _this.addToParentDiv();
	              }
	            };
	          })(this));
	          return this.scope.$on('$destroy', (function(_this) {
	            return function() {
	              return _this.gObject = null;
	            };
	          })(this));
	        };
	
	        SearchBoxParentModel.prototype.addAsMapControl = function() {
	          return this.gMap.controls[google.maps.ControlPosition[this.ctrlPosition]].push(this.input);
	        };
	
	        SearchBoxParentModel.prototype.addToParentDiv = function() {
	          var ref;
	          this.parentDiv = angular.element(document.getElementById(this.scope.parentdiv));
	          if ((ref = this.parentDiv) != null ? ref.length : void 0) {
	            return this.parentDiv.append(this.input);
	          }
	        };
	
	        SearchBoxParentModel.prototype.createSearchBox = function() {
	          if (this.autocomplete) {
	            return this.gObject = new google.maps.places.Autocomplete(this.input, this.scope.options);
	          } else {
	            return this.gObject = new google.maps.places.SearchBox(this.input, this.scope.options);
	          }
	        };
	
	        SearchBoxParentModel.prototype.setBounds = function(bounds) {
	          if (angular.isUndefined(bounds.isEmpty)) {
	            this.$log.error('Error: SearchBoxParentModel setBounds. Bounds not an instance of LatLngBounds.');
	          } else {
	            if (bounds.isEmpty() === false) {
	              if (this.gObject != null) {
	                return this.gObject.setBounds(bounds);
	              }
	            }
	          }
	        };
	
	        SearchBoxParentModel.prototype.getBounds = function() {
	          return this.gObject.getBounds();
	        };
	
	        SearchBoxParentModel.prototype.setVisibility = function(val) {
	          if (this.attrs.parentdiv != null) {
	            if (val === false) {
	              this.parentDiv.addClass("ng-hide");
	            } else {
	              this.parentDiv.removeClass("ng-hide");
	            }
	          } else {
	            if (val === false) {
	              this.gMap.controls[google.maps.ControlPosition[this.ctrlPosition]].clear();
	            } else {
	              this.gMap.controls[google.maps.ControlPosition[this.ctrlPosition]].push(this.input);
	            }
	          }
	          return this.visible = val;
	        };
	
	        return SearchBoxParentModel;
	
	      })(BaseObject);
	      return SearchBoxParentModel;
	    }
	  ]);
	
	}).call(this);
	;
	/*global _,angular */
	
	
	/*
		WindowsChildModel generator where there are many ChildModels to a parent.
	 */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapWindowsParentModel', [
	    'uiGmapIWindowParentModel', 'uiGmapModelsWatcher', 'uiGmapPropMap', 'uiGmapWindowChildModel', 'uiGmapLinked', 'uiGmap_async', 'uiGmapLogger', '$timeout', '$compile', '$http', '$templateCache', '$interpolate', 'uiGmapPromise', 'uiGmapIWindow', 'uiGmapGmapUtil', function(IWindowParentModel, ModelsWatcher, PropMap, WindowChildModel, Linked, _async, $log, $timeout, $compile, $http, $templateCache, $interpolate, uiGmapPromise, IWindow, GmapUtil) {
	      var WindowsParentModel;
	      WindowsParentModel = (function(superClass) {
	        extend(WindowsParentModel, superClass);
	
	        WindowsParentModel.include(ModelsWatcher);
	
	        function WindowsParentModel(scope, element, attrs, ctrls, gMap1, markersScope) {
	          this.gMap = gMap1;
	          this.markersScope = markersScope;
	          this.modelKeyComparison = bind(this.modelKeyComparison, this);
	          this.interpolateContent = bind(this.interpolateContent, this);
	          this.setChildScope = bind(this.setChildScope, this);
	          this.createWindow = bind(this.createWindow, this);
	          this.setContentKeys = bind(this.setContentKeys, this);
	          this.pieceMeal = bind(this.pieceMeal, this);
	          this.createAllNew = bind(this.createAllNew, this);
	          this.watchIdKey = bind(this.watchIdKey, this);
	          this.createChildScopes = bind(this.createChildScopes, this);
	          this.watchOurScope = bind(this.watchOurScope, this);
	          this.watchDestroy = bind(this.watchDestroy, this);
	          this.onDestroy = bind(this.onDestroy, this);
	          this.rebuildAll = bind(this.rebuildAll, this);
	          this.doINeedToWipe = bind(this.doINeedToWipe, this);
	          this.watchModels = bind(this.watchModels, this);
	          this.go = bind(this.go, this);
	          WindowsParentModel.__super__.constructor.call(this, scope, element, attrs, ctrls, $timeout, $compile, $http, $templateCache);
	          this["interface"] = IWindow;
	          this.plurals = new PropMap();
	          _.each(IWindow.scopeKeys, (function(_this) {
	            return function(name) {
	              return _this[name + 'Key'] = void 0;
	            };
	          })(this));
	          this.linked = new Linked(scope, element, attrs, ctrls);
	          this.contentKeys = void 0;
	          this.isIconVisibleOnClick = void 0;
	          this.firstTime = true;
	          this.firstWatchModels = true;
	          this.$log.info(self);
	          this.parentScope = void 0;
	          this.go(scope);
	        }
	
	        WindowsParentModel.prototype.go = function(scope) {
	          this.watchOurScope(scope);
	          this.doRebuildAll = this.scope.doRebuildAll != null ? this.scope.doRebuildAll : false;
	          scope.$watch('doRebuildAll', (function(_this) {
	            return function(newValue, oldValue) {
	              if (newValue !== oldValue) {
	                return _this.doRebuildAll = newValue;
	              }
	            };
	          })(this));
	          return this.createChildScopes();
	        };
	
	        WindowsParentModel.prototype.watchModels = function(scope) {
	          var itemToWatch;
	          itemToWatch = this.markersScope != null ? 'pluralsUpdate' : 'models';
	          return scope.$watch(itemToWatch, (function(_this) {
	            return function(newValue, oldValue) {
	              var doScratch;
	              if (!_.isEqual(newValue, oldValue) || _this.firstWatchModels) {
	                _this.firstWatchModels = false;
	                if (_this.doRebuildAll || _this.doINeedToWipe(scope.models)) {
	                  return _this.rebuildAll(scope, true, true);
	                } else {
	                  doScratch = _this.plurals.length === 0;
	                  if (_this.existingPieces != null) {
	                    return _.last(_this.existingPieces._content).then(function() {
	                      return _this.createChildScopes(doScratch);
	                    });
	                  } else {
	                    return _this.createChildScopes(doScratch);
	                  }
	                }
	              }
	            };
	          })(this), true);
	        };
	
	        WindowsParentModel.prototype.doINeedToWipe = function(newValue) {
	          var newValueIsEmpty;
	          newValueIsEmpty = newValue != null ? newValue.length === 0 : true;
	          return this.plurals.length > 0 && newValueIsEmpty;
	        };
	
	        WindowsParentModel.prototype.rebuildAll = function(scope, doCreate, doDelete) {
	          return this.onDestroy(doDelete).then((function(_this) {
	            return function() {
	              if (doCreate) {
	                return _this.createChildScopes();
	              }
	            };
	          })(this));
	        };
	
	        WindowsParentModel.prototype.onDestroy = function(scope) {
	          WindowsParentModel.__super__.onDestroy.call(this, this.scope);
	          return _async.promiseLock(this, uiGmapPromise.promiseTypes["delete"], void 0, void 0, (function(_this) {
	            return function() {
	              return _async.each(_this.plurals.values(), function(child) {
	                return child.destroy(true);
	              }, _async.chunkSizeFrom(_this.scope.cleanchunk, false)).then(function() {
	                var ref;
	                return (ref = _this.plurals) != null ? ref.removeAll() : void 0;
	              });
	            };
	          })(this));
	        };
	
	        WindowsParentModel.prototype.watchDestroy = function(scope) {
	          return scope.$on('$destroy', (function(_this) {
	            return function() {
	              _this.firstWatchModels = true;
	              _this.firstTime = true;
	              return _this.rebuildAll(scope, false, true);
	            };
	          })(this));
	        };
	
	        WindowsParentModel.prototype.watchOurScope = function(scope) {
	          return _.each(IWindow.scopeKeys, (function(_this) {
	            return function(name) {
	              var nameKey;
	              nameKey = name + 'Key';
	              return _this[nameKey] = typeof scope[name] === 'function' ? scope[name]() : scope[name];
	            };
	          })(this));
	        };
	
	        WindowsParentModel.prototype.createChildScopes = function(isCreatingFromScratch) {
	          var modelsNotDefined, ref, ref1;
	          if (isCreatingFromScratch == null) {
	            isCreatingFromScratch = true;
	          }
	
	          /*
	          being that we cannot tell the difference in Key String vs. a normal value string (TemplateUrl)
	          we will assume that all scope values are string expressions either pointing to a key (propName) or using
	          'self' to point the model as container/object of interest.
	          
	          This may force redundant information into the model, but this appears to be the most flexible approach.
	           */
	          this.isIconVisibleOnClick = true;
	          if (angular.isDefined(this.linked.attrs.isiconvisibleonclick)) {
	            this.isIconVisibleOnClick = this.linked.scope.isIconVisibleOnClick;
	          }
	          modelsNotDefined = angular.isUndefined(this.linked.scope.models);
	          if (modelsNotDefined && (this.markersScope === void 0 || (((ref = this.markersScope) != null ? ref.plurals : void 0) === void 0 || ((ref1 = this.markersScope) != null ? ref1.models : void 0) === void 0))) {
	            this.$log.error('No models to create windows from! Need direct models or models derived from markers!');
	            return;
	          }
	          if (this.gMap != null) {
	            if (this.linked.scope.models != null) {
	              this.watchIdKey(this.linked.scope);
	              if (isCreatingFromScratch) {
	                return this.createAllNew(this.linked.scope, false);
	              } else {
	                return this.pieceMeal(this.linked.scope, false);
	              }
	            } else {
	              this.parentScope = this.markersScope;
	              this.watchIdKey(this.parentScope);
	              if (isCreatingFromScratch) {
	                return this.createAllNew(this.markersScope, true, 'plurals', false);
	              } else {
	                return this.pieceMeal(this.markersScope, true, 'plurals', false);
	              }
	            }
	          }
	        };
	
	        WindowsParentModel.prototype.watchIdKey = function(scope) {
	          this.setIdKey(scope);
	          return scope.$watch('idKey', (function(_this) {
	            return function(newValue, oldValue) {
	              if (newValue !== oldValue && (newValue == null)) {
	                _this.idKey = newValue;
	                return _this.rebuildAll(scope, true, true);
	              }
	            };
	          })(this));
	        };
	
	        WindowsParentModel.prototype.createAllNew = function(scope, hasGMarker, modelsPropToIterate, isArray) {
	          var maybeCanceled;
	          if (modelsPropToIterate == null) {
	            modelsPropToIterate = 'models';
	          }
	          if (isArray == null) {
	            isArray = false;
	          }
	          if (this.firstTime) {
	            this.watchModels(scope);
	            this.watchDestroy(scope);
	          }
	          this.setContentKeys(scope.models);
	          if (this.didQueueInitPromise(this, scope)) {
	            return;
	          }
	          maybeCanceled = null;
	          return _async.promiseLock(this, uiGmapPromise.promiseTypes.create, 'createAllNew', (function(canceledMsg) {
	            return maybeCanceled = canceledMsg;
	          }), (function(_this) {
	            return function() {
	              return _async.each(scope.models, function(model) {
	                var gMarker, ref;
	                gMarker = hasGMarker ? (ref = _this.getItem(scope, modelsPropToIterate, model[_this.idKey])) != null ? ref.gObject : void 0 : void 0;
	                if (!maybeCanceled) {
	                  if (!gMarker && _this.markersScope) {
	                    $log.error('Unable to get gMarker from markersScope!');
	                  }
	                  _this.createWindow(model, gMarker, _this.gMap);
	                }
	                return maybeCanceled;
	              }, _async.chunkSizeFrom(scope.chunk)).then(function() {
	                return _this.firstTime = false;
	              });
	            };
	          })(this));
	        };
	
	        WindowsParentModel.prototype.pieceMeal = function(scope, hasGMarker, modelsPropToIterate, isArray) {
	          var maybeCanceled, payload;
	          if (modelsPropToIterate == null) {
	            modelsPropToIterate = 'models';
	          }
	          if (isArray == null) {
	            isArray = true;
	          }
	          if (scope.$$destroyed) {
	            return;
	          }
	          maybeCanceled = null;
	          payload = null;
	          if ((scope != null) && this.modelsLength() && this.plurals.length) {
	            return _async.promiseLock(this, uiGmapPromise.promiseTypes.update, 'pieceMeal', (function(canceledMsg) {
	              return maybeCanceled = canceledMsg;
	            }), (function(_this) {
	              return function() {
	                return uiGmapPromise.promise((function() {
	                  return _this.figureOutState(_this.idKey, scope, _this.plurals, _this.modelKeyComparison);
	                })).then(function(state) {
	                  payload = state;
	                  return _async.each(payload.removals, function(child) {
	                    if (child != null) {
	                      _this.plurals.remove(child.id);
	                      if (child.destroy != null) {
	                        child.destroy(true);
	                      }
	                      return maybeCanceled;
	                    }
	                  }, _async.chunkSizeFrom(scope.chunk));
	                }).then(function() {
	                  return _async.each(payload.adds, function(modelToAdd) {
	                    var gMarker, ref;
	                    gMarker = (ref = _this.getItem(scope, modelsPropToIterate, modelToAdd[_this.idKey])) != null ? ref.gObject : void 0;
	                    if (!gMarker) {
	                      throw 'Gmarker undefined';
	                    }
	                    _this.createWindow(modelToAdd, gMarker, _this.gMap);
	                    return maybeCanceled;
	                  });
	                }).then(function() {
	                  return _async.each(payload.updates, function(update) {
	                    _this.updateChild(update.child, update.model);
	                    return maybeCanceled;
	                  }, _async.chunkSizeFrom(scope.chunk));
	                });
	              };
	            })(this));
	          } else {
	            $log.debug('pieceMeal: rebuildAll');
	            return this.rebuildAll(this.scope, true, true);
	          }
	        };
	
	        WindowsParentModel.prototype.setContentKeys = function(models) {
	          if (this.modelsLength(models)) {
	            return this.contentKeys = Object.keys(models[0]);
	          }
	        };
	
	        WindowsParentModel.prototype.createWindow = function(model, gMarker, gMap) {
	          var child, childScope, fakeElement, opts, ref, ref1;
	          childScope = this.linked.scope.$new(false);
	          this.setChildScope(childScope, model);
	          childScope.$watch('model', (function(_this) {
	            return function(newValue, oldValue) {
	              if (newValue !== oldValue) {
	                return _this.setChildScope(childScope, newValue);
	              }
	            };
	          })(this), true);
	          fakeElement = {
	            html: (function(_this) {
	              return function() {
	                return _this.interpolateContent(_this.linked.element.html(), model);
	              };
	            })(this)
	          };
	          this.DEFAULTS = this.scopeOrModelVal(this.optionsKey, this.scope, model) || {};
	          opts = this.createWindowOptions(gMarker, childScope, fakeElement.html(), this.DEFAULTS);
	          child = new WindowChildModel({
	            model: model,
	            scope: childScope,
	            opts: opts,
	            isIconVisibleOnClick: this.isIconVisibleOnClick,
	            gMap: gMap,
	            markerScope: (ref = this.markersScope) != null ? (ref1 = ref.plurals.get(model[this.idKey])) != null ? ref1.scope : void 0 : void 0,
	            element: fakeElement,
	            needToManualDestroy: false,
	            markerIsVisibleAfterWindowClose: true,
	            isScopeModel: true
	          });
	          if (model[this.idKey] == null) {
	            this.$log.error('Window model has no id to assign a child to. This is required for performance. Please assign id, or redirect id to a different key.');
	            return;
	          }
	          this.plurals.put(model[this.idKey], child);
	          return child;
	        };
	
	        WindowsParentModel.prototype.setChildScope = function(childScope, model) {
	          _.each(IWindow.scopeKeys, (function(_this) {
	            return function(name) {
	              var nameKey, newValue;
	              nameKey = name + 'Key';
	              newValue = _this[nameKey] === 'self' ? model : model[_this[nameKey]];
	              if (newValue !== childScope[name]) {
	                return childScope[name] = newValue;
	              }
	            };
	          })(this));
	          return childScope.model = model;
	        };
	
	        WindowsParentModel.prototype.interpolateContent = function(content, model) {
	          var exp, i, interpModel, key, len, ref;
	          if (this.contentKeys === void 0 || this.contentKeys.length === 0) {
	            return;
	          }
	          exp = $interpolate(content);
	          interpModel = {};
	          ref = this.contentKeys;
	          for (i = 0, len = ref.length; i < len; i++) {
	            key = ref[i];
	            interpModel[key] = model[key];
	          }
	          return exp(interpModel);
	        };
	
	        WindowsParentModel.prototype.modelKeyComparison = function(model1, model2) {
	          var isEqual, scope;
	          scope = this.scope.coords != null ? this.scope : this.parentScope;
	          if (scope == null) {
	            throw 'No scope or parentScope set!';
	          }
	          isEqual = GmapUtil.equalCoords(this.evalModelHandle(model1, scope.coords), this.evalModelHandle(model2, scope.coords));
	          if (!isEqual) {
	            return isEqual;
	          }
	          isEqual = _.every(_.without(this["interface"].scopeKeys, 'coords'), (function(_this) {
	            return function(k) {
	              return _this.evalModelHandle(model1, scope[k]) === _this.evalModelHandle(model2, scope[k]);
	            };
	          })(this));
	          return isEqual;
	        };
	
	        return WindowsParentModel;
	
	      })(IWindowParentModel);
	      return WindowsParentModel;
	    }
	  ]);
	
	}).call(this);
	;
	/*global angular, _ */
	
	(function() {
	  angular.module("uiGmapgoogle-maps.directives.api").factory("uiGmapCircle", [
	    "uiGmapICircle", "uiGmapCircleParentModel", function(ICircle, CircleParentModel) {
	      return _.extend(ICircle, {
	        link: function(scope, element, attrs, mapCtrl) {
	          return mapCtrl.getScope().deferred.promise.then(function(gMap) {
	            return new CircleParentModel(scope, element, attrs, gMap);
	          });
	        }
	      });
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module("uiGmapgoogle-maps.directives.api").factory("uiGmapControl", [
	    "uiGmapIControl", "$http", "$templateCache", "$compile", "$controller", 'uiGmapGoogleMapApi', function(IControl, $http, $templateCache, $compile, $controller, GoogleMapApi) {
	      var Control;
	      return Control = (function(superClass) {
	        extend(Control, superClass);
	
	        function Control() {
	          this.link = bind(this.link, this);
	          Control.__super__.constructor.call(this);
	        }
	
	        Control.prototype.transclude = true;
	
	        Control.prototype.link = function(scope, element, attrs, ctrl, transclude) {
	          return GoogleMapApi.then((function(_this) {
	            return function(maps) {
	              var hasTranscludedContent, index, position;
	              hasTranscludedContent = angular.isUndefined(scope.template);
	              index = angular.isDefined(scope.index && !isNaN(parseInt(scope.index))) ? parseInt(scope.index) : void 0;
	              position = angular.isDefined(scope.position) ? scope.position.toUpperCase().replace(/-/g, '_') : 'TOP_CENTER';
	              if (!maps.ControlPosition[position]) {
	                _this.$log.error('mapControl: invalid position property');
	                return;
	              }
	              return IControl.mapPromise(scope, ctrl).then(function(map) {
	                var control, controlDiv, pushControl;
	                control = void 0;
	                controlDiv = angular.element('<div></div>');
	                pushControl = function(map, control, index) {
	                  if (index) {
	                    control[0].index = index;
	                  }
	                  return map.controls[google.maps.ControlPosition[position]].push(control[0]);
	                };
	                if (hasTranscludedContent) {
	                  return transclude(function(transcludeEl) {
	                    controlDiv.append(transcludeEl);
	                    return pushControl(map, controlDiv.children(), index);
	                  });
	                } else {
	                  return $http.get(scope.template, {
	                    cache: $templateCache
	                  }).then(function(arg) {
	                    var data, templateCtrl, templateScope;
	                    data = arg.data;
	                    templateScope = scope.$new();
	                    controlDiv.append(data);
	                    if (angular.isDefined(scope.controller)) {
	                      templateCtrl = $controller(scope.controller, {
	                        $scope: templateScope
	                      });
	                      controlDiv.children().data('$ngControllerController', templateCtrl);
	                    }
	                    return control = $compile(controlDiv.children())(templateScope);
	                  })["catch"](function(error) {
	                    return _this.$log.error('mapControl: template could not be found');
	                  }).then(function() {
	                    return pushControl(map, control, index);
	                  });
	                }
	              });
	            };
	          })(this));
	        };
	
	        return Control;
	
	      })(IControl);
	    }
	  ]);
	
	}).call(this);
	;
	/*globals angular, _ */
	
	(function() {
	  angular.module('uiGmapgoogle-maps.directives.api').service('uiGmapDragZoom', [
	    'uiGmapCtrlHandle', 'uiGmapPropertyAction', function(CtrlHandle, PropertyAction) {
	      return {
	        restrict: 'EMA',
	        transclude: true,
	        template: '<div class="angular-google-map-dragzoom" ng-transclude style="display: none"></div>',
	        require: '^' + 'uiGmapGoogleMap',
	        scope: {
	          keyboardkey: '=',
	          options: '=',
	          spec: '='
	        },
	        controller: [
	          '$scope', '$element', function($scope, $element) {
	            $scope.ctrlType = 'uiGmapDragZoom';
	            return _.extend(this, CtrlHandle.handle($scope, $element));
	          }
	        ],
	        link: function(scope, element, attrs, ctrl) {
	          return CtrlHandle.mapPromise(scope, ctrl).then(function(map) {
	            var enableKeyDragZoom, setKeyAction, setOptionsAction;
	            enableKeyDragZoom = function(opts) {
	              return map.enableKeyDragZoom(opts);
	            };
	            setKeyAction = new PropertyAction(function(key, newVal) {
	              if (newVal) {
	                return enableKeyDragZoom({
	                  key: newVal
	                });
	              } else {
	                return enableKeyDragZoom();
	              }
	            });
	            setOptionsAction = new PropertyAction(function(key, newVal) {
	              if (newVal) {
	                return enableKeyDragZoom(newVal);
	              }
	            });
	            scope.$watch('keyboardkey', setKeyAction.sic('keyboardkey'));
	            setKeyAction.sic(scope.keyboardkey);
	            scope.$watch('options', setOptionsAction.sic('options'));
	            return setOptionsAction.sic(scope.options);
	          });
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module("uiGmapgoogle-maps.directives.api").factory("uiGmapDrawingManager", [
	    "uiGmapIDrawingManager", "uiGmapDrawingManagerParentModel", function(IDrawingManager, DrawingManagerParentModel) {
	      return _.extend(IDrawingManager, {
	        link: function(scope, element, attrs, mapCtrl) {
	          return mapCtrl.getScope().deferred.promise.then(function(map) {
	            return new DrawingManagerParentModel(scope, element, attrs, map);
	          });
	        }
	      });
	    }
	  ]);
	
	}).call(this);
	;
	/*
	  - Link up Polygons to be sent back to a controller
	  - inject the draw function into a controllers scope so that controller can call the directive to draw on demand
	  - draw function creates the DrawFreeHandChildModel which manages itself
	 */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapApiFreeDrawPolygons', [
	    'uiGmapLogger', 'uiGmapBaseObject', 'uiGmapCtrlHandle', 'uiGmapDrawFreeHandChildModel', 'uiGmapLodash', function($log, BaseObject, CtrlHandle, DrawFreeHandChildModel, uiGmapLodash) {
	      var FreeDrawPolygons;
	      return FreeDrawPolygons = (function(superClass) {
	        extend(FreeDrawPolygons, superClass);
	
	        function FreeDrawPolygons() {
	          this.link = bind(this.link, this);
	          return FreeDrawPolygons.__super__.constructor.apply(this, arguments);
	        }
	
	        FreeDrawPolygons.include(CtrlHandle);
	
	        FreeDrawPolygons.prototype.restrict = 'EMA';
	
	        FreeDrawPolygons.prototype.replace = true;
	
	        FreeDrawPolygons.prototype.require = '^' + 'uiGmapGoogleMap';
	
	        FreeDrawPolygons.prototype.scope = {
	          polygons: '=',
	          draw: '='
	        };
	
	        FreeDrawPolygons.prototype.link = function(scope, element, attrs, ctrl) {
	          return this.mapPromise(scope, ctrl).then((function(_this) {
	            return function(map) {
	              var freeHand, listener;
	              if (!scope.polygons) {
	                return $log.error('No polygons to bind to!');
	              }
	              if (!_.isArray(scope.polygons)) {
	                return $log.error('Free Draw Polygons must be of type Array!');
	              }
	              freeHand = new DrawFreeHandChildModel(map, ctrl.getScope());
	              listener = void 0;
	              return scope.draw = function() {
	                if (typeof listener === "function") {
	                  listener();
	                }
	                return freeHand.engage(scope.polygons).then(function() {
	                  var firstTime;
	                  firstTime = true;
	                  return listener = scope.$watchCollection('polygons', function(newValue, oldValue) {
	                    var removals;
	                    if (firstTime || newValue === oldValue) {
	                      firstTime = false;
	                      return;
	                    }
	                    removals = uiGmapLodash.differenceObjects(oldValue, newValue);
	                    return removals.forEach(function(p) {
	                      return p.setMap(null);
	                    });
	                  });
	                });
	              };
	            };
	          })(this));
	        };
	
	        return FreeDrawPolygons;
	
	      })(BaseObject);
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module("uiGmapgoogle-maps.directives.api").service("uiGmapICircle", [
	    function() {
	      return {
	        restrict: "EA",
	        replace: true,
	        require: '^' + 'uiGmapGoogleMap',
	        scope: {
	          center: "=center",
	          radius: "=radius",
	          stroke: "=stroke",
	          fill: "=fill",
	          clickable: "=",
	          draggable: "=",
	          editable: "=",
	          geodesic: "=",
	          icons: "=icons",
	          visible: "=",
	          events: "=",
	          control: "=",
	          zIndex: "=zindex"
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;
	/*
	 - interface for all controls to derive from
	 - to enforce a minimum set of requirements
		- attributes
			- template
			- position
			- controller
			- index
	 */
	
	(function() {
	  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module("uiGmapgoogle-maps.directives.api").factory("uiGmapIControl", [
	    "uiGmapBaseObject", "uiGmapLogger", "uiGmapCtrlHandle", function(BaseObject, Logger, CtrlHandle) {
	      var IControl;
	      return IControl = (function(superClass) {
	        extend(IControl, superClass);
	
	        IControl.extend(CtrlHandle);
	
	        function IControl() {
	          this.restrict = 'EA';
	          this.replace = true;
	          this.require = '^' + 'uiGmapGoogleMap';
	          this.scope = {
	            template: '@template',
	            position: '@position',
	            controller: '@controller',
	            index: '@index'
	          };
	          this.$log = Logger;
	        }
	
	        IControl.prototype.link = function(scope, element, attrs, ctrl) {
	          throw new Error("Not implemented!!");
	        };
	
	        return IControl;
	
	      })(BaseObject);
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps.directives.api').service('uiGmapIDrawingManager', [
	    function() {
	      return {
	        restrict: 'EA',
	        replace: true,
	        require: '^' + 'uiGmapGoogleMap',
	        scope: {
	          "static": '@',
	          control: '=',
	          options: '=',
	          events: '='
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapIMarker', [
	    'uiGmapBaseObject', 'uiGmapCtrlHandle', function(BaseObject, CtrlHandle) {
	      var IMarker;
	      return IMarker = (function(superClass) {
	        extend(IMarker, superClass);
	
	        IMarker.scope = {
	          coords: '=coords',
	          icon: '=icon',
	          click: '&click',
	          options: '=options',
	          events: '=events',
	          fit: '=fit',
	          idKey: '=idkey',
	          control: '=control'
	        };
	
	        IMarker.scopeKeys = _.keys(IMarker.scope);
	
	        IMarker.keys = IMarker.scopeKeys;
	
	        IMarker.extend(CtrlHandle);
	
	        function IMarker() {
	          this.restrict = 'EMA';
	          this.require = '^' + 'uiGmapGoogleMap';
	          this.priority = -1;
	          this.transclude = true;
	          this.replace = true;
	          this.scope = _.extend(this.scope || {}, IMarker.scope);
	        }
	
	        return IMarker;
	
	      })(BaseObject);
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapIPolygon', [
	    'uiGmapGmapUtil', 'uiGmapBaseObject', 'uiGmapLogger', 'uiGmapCtrlHandle', function(GmapUtil, BaseObject, Logger, CtrlHandle) {
	      var IPolygon;
	      return IPolygon = (function(superClass) {
	        extend(IPolygon, superClass);
	
	        IPolygon.scope = {
	          path: '=path',
	          stroke: '=stroke',
	          clickable: '=',
	          draggable: '=',
	          editable: '=',
	          geodesic: '=',
	          fill: '=',
	          icons: '=icons',
	          visible: '=',
	          "static": '=',
	          events: '=',
	          zIndex: '=zindex',
	          fit: '=',
	          control: '=control'
	        };
	
	        IPolygon.scopeKeys = _.keys(IPolygon.scope);
	
	        IPolygon.include(GmapUtil);
	
	        IPolygon.extend(CtrlHandle);
	
	        function IPolygon() {}
	
	        IPolygon.prototype.restrict = 'EMA';
	
	        IPolygon.prototype.replace = true;
	
	        IPolygon.prototype.require = '^' + 'uiGmapGoogleMap';
	
	        IPolygon.prototype.scope = IPolygon.scope;
	
	        IPolygon.prototype.DEFAULTS = {};
	
	        IPolygon.prototype.$log = Logger;
	
	        return IPolygon;
	
	      })(BaseObject);
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapIPolyline', [
	    'uiGmapGmapUtil', 'uiGmapBaseObject', 'uiGmapLogger', 'uiGmapCtrlHandle', function(GmapUtil, BaseObject, Logger, CtrlHandle) {
	      var IPolyline;
	      return IPolyline = (function(superClass) {
	        extend(IPolyline, superClass);
	
	        IPolyline.scope = {
	          path: '=',
	          stroke: '=',
	          clickable: '=',
	          draggable: '=',
	          editable: '=',
	          geodesic: '=',
	          icons: '=',
	          visible: '=',
	          "static": '=',
	          fit: '=',
	          events: '=',
	          zIndex: '=zindex'
	        };
	
	        IPolyline.scopeKeys = _.keys(IPolyline.scope);
	
	        IPolyline.include(GmapUtil);
	
	        IPolyline.extend(CtrlHandle);
	
	        function IPolyline() {}
	
	        IPolyline.prototype.restrict = 'EMA';
	
	        IPolyline.prototype.replace = true;
	
	        IPolyline.prototype.require = '^' + 'uiGmapGoogleMap';
	
	        IPolyline.prototype.scope = IPolyline.scope;
	
	        IPolyline.prototype.DEFAULTS = {};
	
	        IPolyline.prototype.$log = Logger;
	
	        return IPolyline;
	
	      })(BaseObject);
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps.directives.api').service('uiGmapIRectangle', [
	    function() {
	      'use strict';
	      return {
	        restrict: 'EMA',
	        require: '^' + 'uiGmapGoogleMap',
	        replace: true,
	        scope: {
	          bounds: '=',
	          stroke: '=',
	          clickable: '=',
	          draggable: '=',
	          editable: '=',
	          fill: '=',
	          visible: '=',
	          events: '='
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapIWindow', [
	    'uiGmapBaseObject', 'uiGmapChildEvents', 'uiGmapCtrlHandle', function(BaseObject, ChildEvents, CtrlHandle) {
	      var IWindow;
	      return IWindow = (function(superClass) {
	        extend(IWindow, superClass);
	
	        IWindow.scope = {
	          coords: '=coords',
	          template: '=template',
	          templateUrl: '=templateurl',
	          templateParameter: '=templateparameter',
	          isIconVisibleOnClick: '=isiconvisibleonclick',
	          closeClick: '&closeclick',
	          options: '=options',
	          control: '=control',
	          show: '=show'
	        };
	
	        IWindow.scopeKeys = _.keys(IWindow.scope);
	
	        IWindow.include(ChildEvents);
	
	        IWindow.extend(CtrlHandle);
	
	        function IWindow() {
	          this.restrict = 'EMA';
	          this.template = void 0;
	          this.transclude = true;
	          this.priority = -100;
	          this.require = '^' + 'uiGmapGoogleMap';
	          this.replace = true;
	          this.scope = _.extend(this.scope || {}, IWindow.scope);
	        }
	
	        return IWindow;
	
	      })(BaseObject);
	    }
	  ]);
	
	}).call(this);
	;
	/*globals angular,_,google */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapMap', ['$timeout', '$q', '$log', 'uiGmapGmapUtil', 'uiGmapBaseObject', 'uiGmapCtrlHandle', 'uiGmapIsReady', 'uiGmapuuid', 'uiGmapExtendGWin', 'uiGmapExtendMarkerClusterer', 'uiGmapGoogleMapsUtilV3', 'uiGmapGoogleMapApi', 'uiGmapEventsHelper', 'uiGmapGoogleMapObjectManager', function($timeout, $q, $log, uiGmapGmapUtil, uiGmapBaseObject, uiGmapCtrlHandle, uiGmapIsReady, uiGmapuuid, uiGmapExtendGWin, uiGmapExtendMarkerClusterer, uiGmapGoogleMapsUtilV3, uiGmapGoogleMapApi, uiGmapEventsHelper, uiGmapGoogleMapObjectManager) {
	    var DEFAULTS, Map, initializeItems;
	    DEFAULTS = void 0;
	    initializeItems = [uiGmapGoogleMapsUtilV3, uiGmapExtendGWin, uiGmapExtendMarkerClusterer];
	    return Map = (function(superClass) {
	      extend(Map, superClass);
	
	      Map.include(uiGmapGmapUtil);
	
	      function Map() {
	        this.link = bind(this.link, this);
	        var ctrlFn;
	        ctrlFn = function($scope) {
	          var ctrlObj, retCtrl;
	          retCtrl = void 0;
	          $scope.$on('$destroy', function() {
	            return uiGmapIsReady.decrement();
	          });
	          ctrlObj = uiGmapCtrlHandle.handle($scope);
	          $scope.ctrlType = 'Map';
	          $scope.deferred.promise.then(function() {
	            return initializeItems.forEach(function(i) {
	              return i.init();
	            });
	          });
	          ctrlObj.getMap = function() {
	            return $scope.map;
	          };
	          retCtrl = _.extend(this, ctrlObj);
	          return retCtrl;
	        };
	        this.controller = ['$scope', ctrlFn];
	      }
	
	      Map.prototype.restrict = 'EMA';
	
	      Map.prototype.transclude = true;
	
	      Map.prototype.replace = false;
	
	      Map.prototype.template = "<div class=\"angular-google-map\"><div class=\"angular-google-map-container\">\n</div><div ng-transclude style=\"display: none\"></div></div>";
	
	      Map.prototype.scope = {
	        center: '=',
	        zoom: '=',
	        dragging: '=',
	        control: '=',
	        options: '=',
	        events: '=',
	        eventOpts: '=',
	        styles: '=',
	        bounds: '=',
	        update: '='
	      };
	
	      Map.prototype.link = function(scope, element, attrs) {
	        var listeners;
	        listeners = [];
	        scope.$on('$destroy', function() {
	          uiGmapEventsHelper.removeEvents(listeners);
	          if (attrs.recycleMapInstance === 'true' && scope.map) {
	            uiGmapGoogleMapObjectManager.recycleMapInstance(scope.map);
	            return scope.map = null;
	          }
	        });
	        scope.idleAndZoomChanged = false;
	        return uiGmapGoogleMapApi.then((function(_this) {
	          return function(maps) {
	            var _gMap, customListeners, disabledEvents, dragging, el, eventName, getEventHandler, mapOptions, maybeHookToEvent, opts, ref, resolveSpawned, settingFromDirective, spawned, type, updateCenter, zoomPromise;
	            DEFAULTS = {
	              mapTypeId: maps.MapTypeId.ROADMAP
	            };
	            spawned = uiGmapIsReady.spawn();
	            resolveSpawned = function() {
	              return spawned.deferred.resolve({
	                instance: spawned.instance,
	                map: _gMap
	              });
	            };
	            if (!angular.isDefined(scope.center) && !angular.isDefined(scope.bounds)) {
	              $log.error('angular-google-maps: a center or bounds property is required');
	              return;
	            }
	            if (!angular.isDefined(scope.center)) {
	              scope.center = new google.maps.LatLngBounds(_this.getCoords(scope.bounds.southwest), _this.getCoords(scope.bounds.northeast)).getCenter();
	            }
	            if (!angular.isDefined(scope.zoom)) {
	              scope.zoom = 10;
	            }
	            el = angular.element(element);
	            el.addClass('angular-google-map');
	            opts = {
	              options: {}
	            };
	            if (attrs.options) {
	              opts.options = scope.options;
	            }
	            if (attrs.styles) {
	              opts.styles = scope.styles;
	            }
	            if (attrs.type) {
	              type = attrs.type.toUpperCase();
	              if (google.maps.MapTypeId.hasOwnProperty(type)) {
	                opts.mapTypeId = google.maps.MapTypeId[attrs.type.toUpperCase()];
	              } else {
	                $log.error("angular-google-maps: invalid map type '" + attrs.type + "'");
	              }
	            }
	            mapOptions = angular.extend({}, DEFAULTS, opts, {
	              center: _this.getCoords(scope.center),
	              zoom: scope.zoom,
	              bounds: scope.bounds
	            });
	            if (attrs.recycleMapInstance === 'true') {
	              _gMap = uiGmapGoogleMapObjectManager.createMapInstance(el.find('div')[1], mapOptions);
	            } else {
	              _gMap = new google.maps.Map(el.find('div')[1], mapOptions);
	            }
	            _gMap['uiGmap_id'] = uiGmapuuid.generate();
	            dragging = false;
	            listeners.push(google.maps.event.addListenerOnce(_gMap, 'idle', function() {
	              scope.deferred.resolve(_gMap);
	              return resolveSpawned();
	            }));
	            disabledEvents = attrs.events && (((ref = scope.events) != null ? ref.blacklist : void 0) != null) ? scope.events.blacklist : [];
	            if (_.isString(disabledEvents)) {
	              disabledEvents = [disabledEvents];
	            }
	            maybeHookToEvent = function(eventName, fn, prefn) {
	              if (!_.includes(disabledEvents, eventName)) {
	                if (prefn) {
	                  prefn();
	                }
	                return listeners.push(google.maps.event.addListener(_gMap, eventName, function() {
	                  var ref1;
	                  if (!((ref1 = scope.update) != null ? ref1.lazy : void 0)) {
	                    return fn();
	                  }
	                }));
	              }
	            };
	            if (!_.includes(disabledEvents, 'all')) {
	              maybeHookToEvent('dragstart', function() {
	                dragging = true;
	                return scope.$evalAsync(function(s) {
	                  if (s.dragging != null) {
	                    return s.dragging = dragging;
	                  }
	                });
	              });
	              maybeHookToEvent('dragend', function() {
	                dragging = false;
	                return scope.$evalAsync(function(s) {
	                  if (s.dragging != null) {
	                    return s.dragging = dragging;
	                  }
	                });
	              });
	              updateCenter = function(c, s) {
	                var cLat, cLng;
	                if (c == null) {
	                  c = _gMap.center;
	                }
	                if (s == null) {
	                  s = scope;
	                }
	                if (!_.includes(disabledEvents, 'center')) {
	                  cLat = c.lat();
	                  cLng = c.lng();
	                  if (angular.isDefined(s.center.type)) {
	                    if (s.center.coordinates[1] !== cLat) {
	                      s.center.coordinates[1] = cLat;
	                    }
	                    if (s.center.coordinates[0] !== cLng) {
	                      return s.center.coordinates[0] = cLng;
	                    }
	                  } else {
	                    if (s.center.latitude !== cLat) {
	                      s.center.latitude = cLat;
	                    }
	                    if (s.center.longitude !== cLng) {
	                      return s.center.longitude = cLng;
	                    }
	                  }
	                }
	              };
	              settingFromDirective = false;
	              maybeHookToEvent('idle', function() {
	                var b, ne, sw;
	                b = _gMap.getBounds();
	                ne = b.getNorthEast();
	                sw = b.getSouthWest();
	                settingFromDirective = true;
	                return scope.$evalAsync(function(s) {
	                  updateCenter();
	                  if (!_.isUndefined(s.bounds) && !_.includes(disabledEvents, 'bounds')) {
	                    s.bounds.northeast = {
	                      latitude: ne.lat(),
	                      longitude: ne.lng()
	                    };
	                    s.bounds.southwest = {
	                      latitude: sw.lat(),
	                      longitude: sw.lng()
	                    };
	                  }
	                  if (!_.includes(disabledEvents, 'zoom')) {
	                    s.zoom = _gMap.zoom;
	                    scope.idleAndZoomChanged = !scope.idleAndZoomChanged;
	                  }
	                  return settingFromDirective = false;
	                });
	              });
	            }
	            if (angular.isDefined(scope.events) && scope.events !== null && angular.isObject(scope.events)) {
	              getEventHandler = function(eventName) {
	                return function() {
	                  return scope.events[eventName].apply(scope, [_gMap, eventName, arguments]);
	                };
	              };
	              customListeners = [];
	              for (eventName in scope.events) {
	                if (scope.events.hasOwnProperty(eventName) && angular.isFunction(scope.events[eventName])) {
	                  customListeners.push(google.maps.event.addListener(_gMap, eventName, getEventHandler(eventName)));
	                }
	              }
	              listeners.concat(customListeners);
	            }
	            _gMap.getOptions = function() {
	              return mapOptions;
	            };
	            scope.map = _gMap;
	            if ((attrs.control != null) && (scope.control != null)) {
	              scope.control.refresh = function(maybeCoords) {
	                var coords, ref1, ref2;
	                if (_gMap == null) {
	                  return;
	                }
	                if (((typeof google !== "undefined" && google !== null ? (ref1 = google.maps) != null ? (ref2 = ref1.event) != null ? ref2.trigger : void 0 : void 0 : void 0) != null) && (_gMap != null)) {
	                  google.maps.event.trigger(_gMap, 'resize');
	                }
	                if (((maybeCoords != null ? maybeCoords.latitude : void 0) != null) && ((maybeCoords != null ? maybeCoords.longitude : void 0) != null)) {
	                  coords = _this.getCoords(maybeCoords);
	                  if (_this.isTrue(attrs.pan)) {
	                    return _gMap.panTo(coords);
	                  } else {
	                    return _gMap.setCenter(coords);
	                  }
	                }
	              };
	              scope.control.getGMap = function() {
	                return _gMap;
	              };
	              scope.control.getMapOptions = function() {
	                return mapOptions;
	              };
	              scope.control.getCustomEventListeners = function() {
	                return customListeners;
	              };
	              scope.control.removeEvents = function(yourListeners) {
	                return uiGmapEventsHelper.removeEvents(yourListeners);
	              };
	            }
	            scope.$watch('center', function(newValue, oldValue) {
	              var coords;
	              if (newValue === oldValue || settingFromDirective) {
	                return;
	              }
	              coords = _this.getCoords(scope.center);
	              if (coords.lat() === _gMap.center.lat() && coords.lng() === _gMap.center.lng()) {
	                return;
	              }
	              if (!dragging) {
	                if (!_this.validateCoords(newValue)) {
	                  $log.error("Invalid center for newValue: " + (JSON.stringify(newValue)));
	                }
	                if (_this.isTrue(attrs.pan) && scope.zoom === _gMap.zoom) {
	                  return _gMap.panTo(coords);
	                } else {
	                  return _gMap.setCenter(coords);
	                }
	              }
	            }, true);
	            zoomPromise = null;
	            scope.$watch('zoom', function(newValue, oldValue) {
	              var ref1, ref2;
	              if (newValue == null) {
	                return;
	              }
	              if (_.isEqual(newValue, oldValue) || (_gMap != null ? _gMap.getZoom() : void 0) === (scope != null ? scope.zoom : void 0) || settingFromDirective) {
	                return;
	              }
	              if (zoomPromise != null) {
	                $timeout.cancel(zoomPromise);
	              }
	              return zoomPromise = $timeout(function() {
	                return _gMap.setZoom(newValue);
	              }, ((ref1 = scope.eventOpts) != null ? (ref2 = ref1.debounce) != null ? ref2.zoomMs : void 0 : void 0) + 20, false);
	            });
	            scope.$watch('bounds', function(newValue, oldValue) {
	              var bounds, ne, ref1, ref2, ref3, ref4, sw;
	              if (newValue === oldValue) {
	                return;
	              }
	              if (((newValue != null ? (ref1 = newValue.northeast) != null ? ref1.latitude : void 0 : void 0) == null) || ((newValue != null ? (ref2 = newValue.northeast) != null ? ref2.longitude : void 0 : void 0) == null) || ((newValue != null ? (ref3 = newValue.southwest) != null ? ref3.latitude : void 0 : void 0) == null) || ((newValue != null ? (ref4 = newValue.southwest) != null ? ref4.longitude : void 0 : void 0) == null)) {
	                $log.error("Invalid map bounds for new value: " + (JSON.stringify(newValue)));
	                return;
	              }
	              ne = new google.maps.LatLng(newValue.northeast.latitude, newValue.northeast.longitude);
	              sw = new google.maps.LatLng(newValue.southwest.latitude, newValue.southwest.longitude);
	              bounds = new google.maps.LatLngBounds(sw, ne);
	              return _gMap.fitBounds(bounds);
	            });
	            return ['options', 'styles'].forEach(function(toWatch) {
	              return scope.$watch(toWatch, function(newValue, oldValue) {
	                if (_.isEqual(newValue, oldValue)) {
	                  return;
	                }
	                if (toWatch === 'options') {
	                  opts.options = newValue;
	                } else {
	                  opts.options[toWatch] = newValue;
	                }
	                if (_gMap != null) {
	                  return _gMap.setOptions(opts);
	                }
	              }, true);
	            });
	          };
	        })(this));
	      };
	
	      return Map;
	
	    })(uiGmapBaseObject);
	  }]);
	
	}).call(this);
	;
	/*global _:true,angular:true */
	
	(function() {
	  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module("uiGmapgoogle-maps.directives.api").factory("uiGmapMarker", [
	    "uiGmapIMarker", "uiGmapMarkerChildModel", "uiGmapMarkerManager", "uiGmapLogger", function(IMarker, MarkerChildModel, MarkerManager, $log) {
	      var Marker;
	      return Marker = (function(superClass) {
	        extend(Marker, superClass);
	
	        function Marker() {
	          Marker.__super__.constructor.call(this);
	          this.template = '<span class="angular-google-map-marker" ng-transclude></span>';
	          $log.info(this);
	        }
	
	        Marker.prototype.controller = [
	          '$scope', '$element', function($scope, $element) {
	            $scope.ctrlType = 'Marker';
	            return _.extend(this, IMarker.handle($scope, $element));
	          }
	        ];
	
	        Marker.prototype.link = function(scope, element, attrs, ctrl) {
	          var mapPromise;
	          mapPromise = IMarker.mapPromise(scope, ctrl);
	          mapPromise.then(function(gMap) {
	            var gManager, keys, m;
	            gManager = new MarkerManager(gMap);
	            keys = _.object(IMarker.keys, IMarker.keys);
	            m = new MarkerChildModel({
	              scope: scope,
	              model: scope,
	              keys: keys,
	              gMap: gMap,
	              doClick: true,
	              gManager: gManager,
	              doDrawSelf: false,
	              trackModel: false
	            });
	            m.deferred.promise.then(function(gMarker) {
	              return scope.deferred.resolve(gMarker);
	            });
	            if (scope.control != null) {
	              return scope.control.getGMarkers = gManager.getGMarkers;
	            }
	          });
	          return scope.$on('$destroy', function() {
	            var gManager;
	            if (typeof gManager !== "undefined" && gManager !== null) {
	              gManager.clear();
	            }
	            return gManager = null;
	          });
	        };
	
	        return Marker;
	
	      })(IMarker);
	    }
	  ]);
	
	}).call(this);
	;
	/*global _:true,angular:true */
	
	(function() {
	  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module("uiGmapgoogle-maps.directives.api").factory("uiGmapMarkers", [
	    "uiGmapIMarker", "uiGmapPlural", "uiGmapMarkersParentModel", "uiGmap_sync", "uiGmapLogger", function(IMarker, Plural, MarkersParentModel, _sync, $log) {
	      var Markers;
	      return Markers = (function(superClass) {
	        extend(Markers, superClass);
	
	        function Markers() {
	          Markers.__super__.constructor.call(this);
	          this.template = '<span class="angular-google-map-markers" ng-transclude></span>';
	          Plural.extend(this, {
	            doCluster: '=?docluster',
	            clusterOptions: '=clusteroptions',
	            clusterEvents: '=clusterevents',
	            modelsByRef: '=modelsbyref',
	            type: '=?type',
	            typeOptions: '=?typeoptions',
	            typeEvents: '=?typeevents',
	            deepComparison: '=?deepcomparison'
	          });
	          $log.info(this);
	        }
	
	        Markers.prototype.controller = [
	          '$scope', '$element', function($scope, $element) {
	            $scope.ctrlType = 'Markers';
	            return _.extend(this, IMarker.handle($scope, $element));
	          }
	        ];
	
	        Markers.prototype.link = function(scope, element, attrs, ctrl) {
	          var parentModel, ready;
	          parentModel = void 0;
	          ready = function() {
	            return scope.deferred.resolve();
	          };
	          return IMarker.mapPromise(scope, ctrl).then(function(map) {
	            var mapScope;
	            mapScope = ctrl.getScope();
	            mapScope.$watch('idleAndZoomChanged', function() {
	              return _.defer(parentModel.gManager.draw);
	            });
	            parentModel = new MarkersParentModel(scope, element, attrs, map);
	            Plural.link(scope, parentModel);
	            if (scope.control != null) {
	              scope.control.getGMarkers = function() {
	                var ref;
	                return (ref = parentModel.gManager) != null ? ref.getGMarkers() : void 0;
	              };
	              scope.control.getChildMarkers = function() {
	                return parentModel.plurals;
	              };
	            }
	            return _.last(parentModel.existingPieces._content).then(function() {
	              return ready();
	            });
	          });
	        };
	
	        return Markers;
	
	      })(IMarker);
	    }
	  ]);
	
	}).call(this);
	;
	/*global angular */
	
	(function() {
	  angular.module('uiGmapgoogle-maps.directives.api').service('uiGmapPlural', [
	    function() {
	      var _initControl;
	      _initControl = function(scope, parent) {
	        if (scope.control == null) {
	          return;
	        }
	        scope.control.updateModels = function(models) {
	          scope.models = models;
	          return parent.createChildScopes(false);
	        };
	        scope.control.newModels = function(models) {
	          scope.models = models;
	          return parent.rebuildAll(scope, true, true);
	        };
	        scope.control.clean = function() {
	          return parent.rebuildAll(scope, false, true);
	        };
	        scope.control.getPlurals = function() {
	          return parent.plurals;
	        };
	        scope.control.getManager = function() {
	          return parent.gManager;
	        };
	        scope.control.hasManager = function() {
	          return (parent.gManager != null) === true;
	        };
	        return scope.control.managerDraw = function() {
	          var ref;
	          if (scope.control.hasManager()) {
	            return (ref = scope.control.getManager()) != null ? ref.draw() : void 0;
	          }
	        };
	      };
	      return {
	        extend: function(obj, obj2) {
	          return _.extend(obj.scope || {}, obj2 || {}, {
	            idKey: '=idkey',
	            doRebuildAll: '=dorebuildall',
	            models: '=models',
	            chunk: '=chunk',
	            cleanchunk: '=cleanchunk',
	            control: '=control',
	            deepComparison: '=deepcomparison'
	          });
	        },
	        link: function(scope, parent) {
	          return _initControl(scope, parent);
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;
	/*global angular */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapPolygon', [
	    'uiGmapIPolygon', '$timeout', 'uiGmapPolygonChildModel', function(IPolygon, $timeout, PolygonChild) {
	      var Polygon;
	      return Polygon = (function(superClass) {
	        extend(Polygon, superClass);
	
	        function Polygon() {
	          this.link = bind(this.link, this);
	          return Polygon.__super__.constructor.apply(this, arguments);
	        }
	
	        Polygon.prototype.link = function(scope, element, attrs, mapCtrl) {
	          var children, promise;
	          children = [];
	          promise = IPolygon.mapPromise(scope, mapCtrl);
	          if (scope.control != null) {
	            scope.control.getInstance = this;
	            scope.control.polygons = children;
	            scope.control.promise = promise;
	          }
	          return promise.then((function(_this) {
	            return function(gMap) {
	              return children.push(new PolygonChild({
	                scope: scope,
	                attrs: attrs,
	                gMap: gMap,
	                defaults: _this.DEFAULTS
	              }));
	            };
	          })(this));
	        };
	
	        return Polygon;
	
	      })(IPolygon);
	    }
	  ]);
	
	}).call(this);
	;
	/*global angular:true */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapPolygons', [
	    'uiGmapIPolygon', '$timeout', 'uiGmapPolygonsParentModel', 'uiGmapPlural', function(Interface, $timeout, ParentModel, Plural) {
	      var Polygons;
	      return Polygons = (function(superClass) {
	        extend(Polygons, superClass);
	
	        function Polygons() {
	          this.link = bind(this.link, this);
	          Polygons.__super__.constructor.call(this);
	          Plural.extend(this);
	          this.$log.info(this);
	        }
	
	        Polygons.prototype.link = function(scope, element, attrs, mapCtrl) {
	          return mapCtrl.getScope().deferred.promise.then((function(_this) {
	            return function(map) {
	              if (angular.isUndefined(scope.path) || scope.path === null) {
	                _this.$log.warn('polygons: no valid path attribute found');
	              }
	              if (!scope.models) {
	                _this.$log.warn('polygons: no models found to create from');
	              }
	              return Plural.link(scope, new ParentModel(scope, element, attrs, map, _this.DEFAULTS));
	            };
	          })(this));
	        };
	
	        return Polygons;
	
	      })(Interface);
	    }
	  ]);
	
	}).call(this);
	;
	/*global angular */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapPolyline', [
	    'uiGmapIPolyline', '$timeout', 'uiGmapPolylineChildModel', function(IPolyline, $timeout, PolylineChildModel) {
	      var Polyline;
	      return Polyline = (function(superClass) {
	        extend(Polyline, superClass);
	
	        function Polyline() {
	          this.link = bind(this.link, this);
	          return Polyline.__super__.constructor.apply(this, arguments);
	        }
	
	        Polyline.prototype.link = function(scope, element, attrs, mapCtrl) {
	          return IPolyline.mapPromise(scope, mapCtrl).then((function(_this) {
	            return function(gMap) {
	              if (angular.isUndefined(scope.path) || scope.path === null || !_this.validatePath(scope.path)) {
	                _this.$log.warn('polyline: no valid path attribute found');
	              }
	              return new PolylineChildModel({
	                scope: scope,
	                attrs: attrs,
	                gMap: gMap,
	                defaults: _this.DEFAULTS
	              });
	            };
	          })(this));
	        };
	
	        return Polyline;
	
	      })(IPolyline);
	    }
	  ]);
	
	}).call(this);
	;
	/*global angular */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapPolylines', [
	    'uiGmapIPolyline', '$timeout', 'uiGmapPolylinesParentModel', 'uiGmapPlural', function(IPolyline, $timeout, PolylinesParentModel, Plural) {
	      var Polylines;
	      return Polylines = (function(superClass) {
	        extend(Polylines, superClass);
	
	        function Polylines() {
	          this.link = bind(this.link, this);
	          Polylines.__super__.constructor.call(this);
	          Plural.extend(this);
	          this.$log.info(this);
	        }
	
	        Polylines.prototype.link = function(scope, element, attrs, mapCtrl) {
	          return mapCtrl.getScope().deferred.promise.then((function(_this) {
	            return function(gMap) {
	              if (angular.isUndefined(scope.path) || scope.path === null) {
	                _this.$log.warn('polylines: no valid path attribute found');
	              }
	              if (!scope.models) {
	                _this.$log.warn('polylines: no models found to create from');
	              }
	              return Plural.link(scope, new PolylinesParentModel(scope, element, attrs, gMap, _this.DEFAULTS));
	            };
	          })(this));
	        };
	
	        return Polylines;
	
	      })(IPolyline);
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapRectangle', [
	    'uiGmapLogger', 'uiGmapGmapUtil', 'uiGmapIRectangle', 'uiGmapRectangleParentModel', function($log, GmapUtil, IRectangle, RectangleParentModel) {
	      return _.extend(IRectangle, {
	        link: function(scope, element, attrs, mapCtrl) {
	          return mapCtrl.getScope().deferred.promise.then(function(gMap) {
	            return new RectangleParentModel(scope, element, attrs, gMap);
	          });
	        }
	      });
	    }
	  ]);
	
	}).call(this);
	;
	/*global angular:true */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapWindow', [
	    'uiGmapIWindow', 'uiGmapGmapUtil', 'uiGmapWindowChildModel', 'uiGmapLodash', 'uiGmapLogger', function(IWindow, GmapUtil, WindowChildModel, uiGmapLodash, $log) {
	      var Window;
	      return Window = (function(superClass) {
	        extend(Window, superClass);
	
	        Window.include(GmapUtil);
	
	        function Window() {
	          this.link = bind(this.link, this);
	          Window.__super__.constructor.call(this);
	          this.require = ['^' + 'uiGmapGoogleMap', '^?' + 'uiGmapMarker'];
	          this.template = '<span class="angular-google-maps-window" ng-transclude></span>';
	          $log.debug(this);
	          this.childWindows = [];
	        }
	
	        Window.prototype.link = function(scope, element, attrs, ctrls) {
	          var markerCtrl, markerScope;
	          markerCtrl = ctrls.length > 1 && (ctrls[1] != null) ? ctrls[1] : void 0;
	          markerScope = markerCtrl != null ? markerCtrl.getScope() : void 0;
	          this.mapPromise = IWindow.mapPromise(scope, ctrls[0]);
	          return this.mapPromise.then((function(_this) {
	            return function(gMap) {
	              var isIconVisibleOnClick;
	              isIconVisibleOnClick = true;
	              if (angular.isDefined(attrs.isiconvisibleonclick)) {
	                isIconVisibleOnClick = scope.isIconVisibleOnClick;
	              }
	              if (!markerCtrl) {
	                _this.init(scope, element, isIconVisibleOnClick, gMap);
	                return;
	              }
	              return markerScope.deferred.promise.then(function(gMarker) {
	                return _this.init(scope, element, isIconVisibleOnClick, gMap, markerScope);
	              });
	            };
	          })(this));
	        };
	
	        Window.prototype.init = function(scope, element, isIconVisibleOnClick, gMap, markerScope) {
	          var childWindow, defaults, gMarker, hasScopeCoords, opts;
	          defaults = scope.options != null ? scope.options : {};
	          hasScopeCoords = (scope != null) && this.validateCoords(scope.coords);
	          if ((markerScope != null ? markerScope['getGMarker'] : void 0) != null) {
	            gMarker = markerScope.getGMarker();
	          }
	          opts = hasScopeCoords ? this.createWindowOptions(gMarker, scope, element.html(), defaults) : defaults;
	          if (gMap != null) {
	            childWindow = new WindowChildModel({
	              scope: scope,
	              opts: opts,
	              isIconVisibleOnClick: isIconVisibleOnClick,
	              gMap: gMap,
	              markerScope: markerScope,
	              element: element
	            });
	            this.childWindows.push(childWindow);
	            scope.$on('$destroy', (function(_this) {
	              return function() {
	                _this.childWindows = uiGmapLodash.withoutObjects(_this.childWindows, [childWindow], function(child1, child2) {
	                  return child1.scope.$id === child2.scope.$id;
	                });
	                return _this.childWindows.length = 0;
	              };
	            })(this));
	          }
	          if (scope.control != null) {
	            scope.control.getGWindows = (function(_this) {
	              return function() {
	                return _this.childWindows.map(function(child) {
	                  return child.gObject;
	                });
	              };
	            })(this);
	            scope.control.getChildWindows = (function(_this) {
	              return function() {
	                return _this.childWindows;
	              };
	            })(this);
	            scope.control.getPlurals = scope.control.getChildWindows;
	            scope.control.showWindow = (function(_this) {
	              return function() {
	                return _this.childWindows.map(function(child) {
	                  return child.showWindow();
	                });
	              };
	            })(this);
	            scope.control.hideWindow = (function(_this) {
	              return function() {
	                return _this.childWindows.map(function(child) {
	                  return child.hideWindow();
	                });
	              };
	            })(this);
	          }
	          if ((this.onChildCreation != null) && (childWindow != null)) {
	            return this.onChildCreation(childWindow);
	          }
	        };
	
	        return Window;
	
	      })(IWindow);
	    }
	  ]);
	
	}).call(this);
	;
	/*global angular */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapWindows', [
	    'uiGmapIWindow', 'uiGmapPlural', 'uiGmapWindowsParentModel', 'uiGmapPromise', 'uiGmapLogger', function(IWindow, Plural, WindowsParentModel, uiGmapPromise, $log) {
	
	      /*
	      Windows directive where many windows map to the models property
	       */
	      var Windows;
	      return Windows = (function(superClass) {
	        extend(Windows, superClass);
	
	        function Windows() {
	          this.link = bind(this.link, this);
	          Windows.__super__.constructor.call(this);
	          this.require = ['^' + 'uiGmapGoogleMap', '^?' + 'uiGmapMarkers'];
	          this.template = '<span class="angular-google-maps-windows" ng-transclude></span>';
	          Plural.extend(this);
	          $log.debug(this);
	        }
	
	        Windows.prototype.link = function(scope, element, attrs, ctrls) {
	          var mapScope, markerCtrl, markerScope;
	          mapScope = ctrls[0].getScope();
	          markerCtrl = ctrls.length > 1 && (ctrls[1] != null) ? ctrls[1] : void 0;
	          markerScope = markerCtrl != null ? markerCtrl.getScope() : void 0;
	          return mapScope.deferred.promise.then((function(_this) {
	            return function(map) {
	              var promise, ref;
	              promise = (markerScope != null ? (ref = markerScope.deferred) != null ? ref.promise : void 0 : void 0) || uiGmapPromise.resolve();
	              return promise.then(function() {
	                var pieces, ref1;
	                pieces = (ref1 = _this.parentModel) != null ? ref1.existingPieces : void 0;
	                if (pieces) {
	                  return pieces.then(function() {
	                    return _this.init(scope, element, attrs, ctrls, map, markerScope);
	                  });
	                } else {
	                  return _this.init(scope, element, attrs, ctrls, map, markerScope);
	                }
	              });
	            };
	          })(this));
	        };
	
	        Windows.prototype.init = function(scope, element, attrs, ctrls, map, additionalScope) {
	          var parentModel;
	          parentModel = new WindowsParentModel(scope, element, attrs, ctrls, map, additionalScope);
	          Plural.link(scope, parentModel);
	          if (scope.control != null) {
	            scope.control.getGWindows = function() {
	              return parentModel.plurals.map(function(child) {
	                return child.gObject;
	              });
	            };
	            return scope.control.getChildWindows = function() {
	              return parentModel.plurals;
	            };
	          }
	        };
	
	        return Windows;
	
	      })(IWindow);
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors
	Nicolas Laplante - https://plus.google.com/108189012221374960701
	Nicholas McCready - https://twitter.com/nmccready
	Nick Baugh - https://github.com/niftylettuce
	 */
	
	
	/*globals angular */
	
	(function() {
	  angular.module("uiGmapgoogle-maps").directive("uiGmapGoogleMap", ['uiGmapMap', function(uiGmapMap) {
	    return new uiGmapMap();
	  }]);
	
	}).call(this);
	;
	/*
	@authors
	Nicolas Laplante - https://plus.google.com/108189012221374960701
	Nicholas McCready - https://twitter.com/nmccready
	 */
	
	
	/*
	Map marker directive
	
	This directive is used to create a marker on an existing map.
	This directive creates a new scope.
	
	{attribute coords required}  object containing latitude and longitude properties
	{attribute icon optional}    string url to image used for marker icon
	{attribute animate optional} if set to false, the marker won't be animated (on by default)
	 */
	
	(function() {
	  angular.module('uiGmapgoogle-maps').directive('uiGmapMarker', [
	    '$timeout', 'uiGmapMarker', function($timeout, Marker) {
	      return new Marker($timeout);
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors
	Nicolas Laplante - https://plus.google.com/108189012221374960701
	Nicholas McCready - https://twitter.com/nmccready
	 */
	
	
	/*
	Map marker directive
	
	This directive is used to create a marker on an existing map.
	This directive creates a new scope.
	
	{attribute coords required}  object containing latitude and longitude properties
	{attribute icon optional}    string url to image used for marker icon
	{attribute animate optional} if set to false, the marker won't be animated (on by default)
	 */
	
	(function() {
	  angular.module('uiGmapgoogle-maps').directive('uiGmapMarkers', [
	    '$timeout', 'uiGmapMarkers', function($timeout, Markers) {
	      return new Markers($timeout);
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors
	Nicolas Laplante - https://plus.google.com/108189012221374960701
	Nicholas McCready - https://twitter.com/nmccready
	Rick Huizinga - https://plus.google.com/+RickHuizinga
	 */
	
	(function() {
	  angular.module('uiGmapgoogle-maps').directive('uiGmapPolygon', [
	    'uiGmapPolygon', function(Polygon) {
	      return new Polygon();
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors
	Julian Popescu - https://github.com/jpopesculian
	Rick Huizinga - https://plus.google.com/+RickHuizinga
	 */
	
	(function() {
	  angular.module('uiGmapgoogle-maps').directive("uiGmapCircle", [
	    "uiGmapCircle", function(Circle) {
	      return Circle;
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors
	Nicolas Laplante - https://plus.google.com/108189012221374960701
	Nicholas McCready - https://twitter.com/nmccready
	 */
	
	(function() {
	  angular.module("uiGmapgoogle-maps").directive("uiGmapPolyline", [
	    "uiGmapPolyline", function(Polyline) {
	      return new Polyline();
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors
	Nicolas Laplante - https://plus.google.com/108189012221374960701
	Nicholas McCready - https://twitter.com/nmccready
	 */
	
	(function() {
	  angular.module('uiGmapgoogle-maps').directive('uiGmapPolylines', [
	    'uiGmapPolylines', function(Polylines) {
	      return new Polylines();
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors
	Nicolas Laplante - https://plus.google.com/108189012221374960701
	Nicholas McCready - https://twitter.com/nmccready
	Chentsu Lin - https://github.com/ChenTsuLin
	 */
	
	(function() {
	  angular.module("uiGmapgoogle-maps").directive("uiGmapRectangle", [
	    "uiGmapLogger", "uiGmapRectangle", function($log, Rectangle) {
	      return Rectangle;
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors
	Nicolas Laplante - https://plus.google.com/108189012221374960701
	Nicholas McCready - https://twitter.com/nmccready
	 */
	
	
	/*
	Map info window directive
	
	This directive is used to create an info window on an existing map.
	This directive creates a new scope.
	
	{attribute coords required}  object containing latitude and longitude properties
	{attribute show optional}    map will show when this expression returns true
	 */
	
	(function() {
	  angular.module("uiGmapgoogle-maps").directive("uiGmapWindow", [
	    "$timeout", "$compile", "$http", "$templateCache", "uiGmapWindow", function($timeout, $compile, $http, $templateCache, Window) {
	      return new Window($timeout, $compile, $http, $templateCache);
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors
	Nicolas Laplante - https://plus.google.com/108189012221374960701
	Nicholas McCready - https://twitter.com/nmccready
	 */
	
	
	/*
	Map info window directive
	
	This directive is used to create an info window on an existing map.
	This directive creates a new scope.
	
	{attribute coords required}  object containing latitude and longitude properties
	{attribute show optional}    map will show when this expression returns true
	 */
	
	(function() {
	  angular.module("uiGmapgoogle-maps").directive("uiGmapWindows", [
	    "$timeout", "$compile", "$http", "$templateCache", "$interpolate", "uiGmapWindows", function($timeout, $compile, $http, $templateCache, $interpolate, Windows) {
	      return new Windows($timeout, $compile, $http, $templateCache, $interpolate);
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors:
	- Nicolas Laplante https://plus.google.com/108189012221374960701
	- Nicholas McCready - https://twitter.com/nmccready
	 */
	
	
	/*
	Map Layer directive
	
	This directive is used to create any type of Layer from the google maps sdk.
	This directive creates a new scope.
	
	{attribute show optional}  true (default) shows the trafficlayer otherwise it is hidden
	 */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	  angular.module('uiGmapgoogle-maps').directive('uiGmapLayer', [
	    '$timeout', 'uiGmapLogger', 'uiGmapLayerParentModel', function($timeout, Logger, LayerParentModel) {
	      var Layer;
	      Layer = (function() {
	        function Layer() {
	          this.link = bind(this.link, this);
	          this.$log = Logger;
	          this.restrict = 'EMA';
	          this.require = '^' + 'uiGmapGoogleMap';
	          this.priority = -1;
	          this.transclude = true;
	          this.template = '<span class=\'angular-google-map-layer\' ng-transclude></span>';
	          this.replace = true;
	          this.scope = {
	            show: '=show',
	            type: '=type',
	            namespace: '=namespace',
	            options: '=options',
	            onCreated: '&oncreated'
	          };
	        }
	
	        Layer.prototype.link = function(scope, element, attrs, mapCtrl) {
	          return mapCtrl.getScope().deferred.promise.then((function(_this) {
	            return function(map) {
	              if (scope.onCreated != null) {
	                return new LayerParentModel(scope, element, attrs, map, scope.onCreated);
	              } else {
	                return new LayerParentModel(scope, element, attrs, map);
	              }
	            };
	          })(this));
	        };
	
	        return Layer;
	
	      })();
	      return new Layer();
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors
	Adam Kreitals, kreitals@hotmail.com
	 */
	
	
	/*
	mapControl directive
	
	This directive is used to create a custom control element on an existing map.
	This directive creates a new scope.
	
	{attribute template required}  	string url of the template to be used for the control
	{attribute position optional}  	string position of the control of the form top-left or TOP_LEFT defaults to TOP_CENTER
	{attribute controller optional}	string controller to be applied to the template
	{attribute index optional}		number index for controlling the order of similarly positioned mapControl elements
	 */
	
	(function() {
	  angular.module("uiGmapgoogle-maps").directive("uiGmapMapControl", [
	    "uiGmapControl", function(Control) {
	      return new Control();
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors
	Nicholas McCready - https://twitter.com/nmccready
	 */
	
	(function() {
	  angular.module('uiGmapgoogle-maps').directive('uiGmapDragZoom', [
	    'uiGmapDragZoom', function(DragZoom) {
	      return DragZoom;
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps').directive("uiGmapDrawingManager", [
	    "uiGmapDrawingManager", function(DrawingManager) {
	      return DrawingManager;
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors
	Nicholas McCready - https://twitter.com/nmccready
	 * Brunt of the work is in DrawFreeHandChildModel
	 */
	
	(function() {
	  angular.module('uiGmapgoogle-maps').directive('uiGmapFreeDrawPolygons', [
	    'uiGmapApiFreeDrawPolygons', function(FreeDrawPolygons) {
	      return new FreeDrawPolygons();
	    }
	  ]);
	
	}).call(this);
	;
	/*
	Map Layer directive
	
	This directive is used to create any type of Layer from the google maps sdk.
	This directive creates a new scope.
	
	{attribute show optional}  true (default) shows the trafficlayer otherwise it is hidden
	 */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	  angular.module("uiGmapgoogle-maps").directive("uiGmapMapType", [
	    "$timeout", "uiGmapLogger", "uiGmapMapTypeParentModel", function($timeout, Logger, MapTypeParentModel) {
	      var MapType;
	      MapType = (function() {
	        function MapType() {
	          this.link = bind(this.link, this);
	          this.$log = Logger;
	          this.restrict = "EMA";
	          this.require = '^' + 'uiGmapGoogleMap';
	          this.priority = -1;
	          this.transclude = true;
	          this.template = '<span class=\"angular-google-map-layer\" ng-transclude></span>';
	          this.replace = true;
	          this.scope = {
	            show: "=show",
	            options: '=options',
	            refresh: '=refresh',
	            id: '@'
	          };
	        }
	
	        MapType.prototype.link = function(scope, element, attrs, mapCtrl) {
	          return mapCtrl.getScope().deferred.promise.then((function(_this) {
	            return function(map) {
	              return new MapTypeParentModel(scope, element, attrs, map);
	            };
	          })(this));
	        };
	
	        return MapType;
	
	      })();
	      return new MapType();
	    }
	  ]);
	
	}).call(this);
	;
	/*
	Map Layers directive
	
	This directive is used to create any type of Layer from the google maps sdk.
	This directive creates a new scope.
	 */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	  angular.module('uiGmapgoogle-maps').directive("uiGmapMapTypes", [
	    "$timeout", "uiGmapLogger", "uiGmapMapTypesParentModel", function($timeout, Logger, MapTypesParentModel) {
	      var MapTypes;
	      MapTypes = (function() {
	        function MapTypes() {
	          this.link = bind(this.link, this);
	          this.$log = Logger;
	          this.restrict = "EMA";
	          this.require = '^' + 'uiGmapGoogleMap';
	          this.priority = -1;
	          this.transclude = true;
	          this.template = '<span class=\"angular-google-map-layers\" ng-transclude></span>';
	          this.scope = {
	            mapTypes: "=mapTypes",
	            show: "=show",
	            options: "=options",
	            refresh: "=refresh",
	            id: "=idKey"
	          };
	        }
	
	        MapTypes.prototype.link = function(scope, element, attrs, mapCtrl) {
	          return mapCtrl.getScope().deferred.promise.then((function(_this) {
	            return function(map) {
	              return new MapTypesParentModel(scope, element, attrs, map);
	            };
	          })(this));
	        };
	
	        return MapTypes;
	
	      })();
	      return new MapTypes();
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors
	Nicolas Laplante - https://plus.google.com/108189012221374960701
	Nicholas McCready - https://twitter.com/nmccready
	Rick Huizinga - https://plus.google.com/+RickHuizinga
	 */
	
	(function() {
	  angular.module('uiGmapgoogle-maps').directive('uiGmapPolygons', [
	    'uiGmapPolygons', function(Polygons) {
	      return new Polygons();
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors:
	- Nicolas Laplante https://plus.google.com/108189012221374960701
	- Nicholas McCready - https://twitter.com/nmccready
	- Carrie Kengle - http://about.me/carrie
	 */
	
	
	/*
	Places Search Box directive
	
	This directive is used to create a Places Search Box.
	This directive creates a new scope.
	
	{attribute input required}  HTMLInputElement
	{attribute options optional} The options that can be set on a SearchBox object (google.maps.places.SearchBoxOptions object specification)
	 */
	
	(function() {
	  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	  angular.module('uiGmapgoogle-maps').directive('uiGmapSearchBox', [
	    'uiGmapGoogleMapApi', 'uiGmapLogger', 'uiGmapSearchBoxParentModel', '$http', '$templateCache', '$compile', function(GoogleMapApi, Logger, SearchBoxParentModel, $http, $templateCache, $compile) {
	      var SearchBox;
	      SearchBox = (function() {
	        SearchBox.prototype.require = 'ngModel';
	
	        function SearchBox() {
	          this.link = bind(this.link, this);
	          this.$log = Logger;
	          this.restrict = 'EMA';
	          this.require = '^' + 'uiGmapGoogleMap';
	          this.priority = -1;
	          this.transclude = true;
	          this.template = '<span class=\'angular-google-map-search\' ng-transclude></span>';
	          this.replace = true;
	          this.scope = {
	            template: '=template',
	            events: '=events',
	            position: '=?position',
	            options: '=?options',
	            parentdiv: '=?parentdiv',
	            ngModel: "=?"
	          };
	        }
	
	        SearchBox.prototype.link = function(scope, element, attrs, mapCtrl) {
	          return GoogleMapApi.then((function(_this) {
	            return function(maps) {
	              if (scope.template == null) {
	                $templateCache.put('uigmap-searchbox-default.tpl.html', '<input type="text">');
	                scope.template = 'uigmap-searchbox-default.tpl.html';
	              }
	              return $http.get(scope.template, {
	                cache: $templateCache
	              }).then(function(arg) {
	                var data;
	                data = arg.data;
	                if (angular.isUndefined(scope.events)) {
	                  _this.$log.error('searchBox: the events property is required');
	                  return;
	                }
	                return mapCtrl.getScope().deferred.promise.then(function(map) {
	                  var ctrlPosition;
	                  ctrlPosition = angular.isDefined(scope.position) ? scope.position.toUpperCase().replace(/-/g, '_') : 'TOP_LEFT';
	                  if (!maps.ControlPosition[ctrlPosition]) {
	                    _this.$log.error('searchBox: invalid position property');
	                    return;
	                  }
	                  return new SearchBoxParentModel(scope, element, attrs, map, ctrlPosition, $compile(data)(scope));
	                });
	              });
	            };
	          })(this));
	        };
	
	        return SearchBox;
	
	      })();
	      return new SearchBox();
	    }
	  ]);
	
	}).call(this);
	;(function() {
	  angular.module('uiGmapgoogle-maps').directive('uiGmapShow', [
	    '$animate', 'uiGmapLogger', function($animate, $log) {
	      return {
	        scope: {
	          'uiGmapShow': '=',
	          'uiGmapAfterShow': '&',
	          'uiGmapAfterHide': '&'
	        },
	        link: function(scope, element) {
	          var angular_post_1_3_handle, angular_pre_1_3_handle, handle;
	          angular_post_1_3_handle = function(animateAction, cb) {
	            return $animate[animateAction](element, 'ng-hide').then(function() {
	              return cb();
	            });
	          };
	          angular_pre_1_3_handle = function(animateAction, cb) {
	            return $animate[animateAction](element, 'ng-hide', cb);
	          };
	          handle = function(animateAction, cb) {
	            if (angular.version.major > 1) {
	              return $log.error("uiGmapShow is not supported for Angular Major greater than 1.\nYour Major is " + angular.version.major + "\"");
	            }
	            if (angular.version.major === 1 && angular.version.minor < 3) {
	              return angular_pre_1_3_handle(animateAction, cb);
	            }
	            return angular_post_1_3_handle(animateAction, cb);
	          };
	          return scope.$watch('uiGmapShow', function(show) {
	            if (show) {
	              handle('removeClass', scope.uiGmapAfterShow);
	            }
	            if (!show) {
	              return handle('addClass', scope.uiGmapAfterHide);
	            }
	          });
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;
	/*
	@authors:
	- Nicholas McCready - https://twitter.com/nmccready
	 */
	
	
	/*
	StreetViewPanorama Directive to care of basic initialization of StreetViewPanorama
	 */
	
	(function() {
	  angular.module('uiGmapgoogle-maps').directive('uiGmapStreetViewPanorama', [
	    'uiGmapGoogleMapApi', 'uiGmapLogger', 'uiGmapGmapUtil', 'uiGmapEventsHelper', function(GoogleMapApi, $log, GmapUtil, EventsHelper) {
	      var name;
	      name = 'uiGmapStreetViewPanorama';
	      return {
	        restrict: 'EMA',
	        template: '<div class="angular-google-map-street-view-panorama"></div>',
	        replace: true,
	        scope: {
	          focalcoord: '=',
	          radius: '=?',
	          events: '=?',
	          options: '=?',
	          control: '=?',
	          povoptions: '=?',
	          imagestatus: '='
	        },
	        link: function(scope, element, attrs) {
	          return GoogleMapApi.then((function(_this) {
	            return function(maps) {
	              var clean, create, didCreateOptionsFromDirective, firstTime, handleSettings, listeners, opts, pano, povOpts, sv;
	              pano = void 0;
	              sv = void 0;
	              didCreateOptionsFromDirective = false;
	              listeners = void 0;
	              opts = null;
	              povOpts = null;
	              clean = function() {
	                EventsHelper.removeEvents(listeners);
	                if (pano != null) {
	                  pano.unbind('position');
	                  pano.setVisible(false);
	                }
	                if (sv != null) {
	                  if ((sv != null ? sv.setVisible : void 0) != null) {
	                    sv.setVisible(false);
	                  }
	                  return sv = void 0;
	                }
	              };
	              handleSettings = function(perspectivePoint, focalPoint) {
	                var heading;
	                heading = google.maps.geometry.spherical.computeHeading(perspectivePoint, focalPoint);
	                didCreateOptionsFromDirective = true;
	                scope.radius = scope.radius || 50;
	                povOpts = angular.extend({
	                  heading: heading,
	                  zoom: 1,
	                  pitch: 0
	                }, scope.povoptions || {});
	                opts = opts = angular.extend({
	                  navigationControl: false,
	                  addressControl: false,
	                  linksControl: false,
	                  position: perspectivePoint,
	                  pov: povOpts,
	                  visible: true
	                }, scope.options || {});
	                return didCreateOptionsFromDirective = false;
	              };
	              create = function() {
	                var focalPoint;
	                if (!scope.focalcoord) {
	                  $log.error(name + ": focalCoord needs to be defined");
	                  return;
	                }
	                if (!scope.radius) {
	                  $log.error(name + ": needs a radius to set the camera view from its focal target.");
	                  return;
	                }
	                clean();
	                if (sv == null) {
	                  sv = new google.maps.StreetViewService();
	                }
	                if (scope.events) {
	                  listeners = EventsHelper.setEvents(sv, scope, scope);
	                }
	                focalPoint = GmapUtil.getCoords(scope.focalcoord);
	                return sv.getPanoramaByLocation(focalPoint, scope.radius, function(streetViewPanoramaData, status) {
	                  var ele, perspectivePoint, ref;
	                  if (scope.imagestatus != null) {
	                    scope.imagestatus = status;
	                  }
	                  if (((ref = scope.events) != null ? ref.image_status_changed : void 0) != null) {
	                    scope.events.image_status_changed(sv, 'image_status_changed', scope, status);
	                  }
	                  if (status === "OK") {
	                    perspectivePoint = streetViewPanoramaData.location.latLng;
	                    handleSettings(perspectivePoint, focalPoint);
	                    ele = element[0];
	                    return pano = new google.maps.StreetViewPanorama(ele, opts);
	                  }
	                });
	              };
	              if (scope.control != null) {
	                scope.control.getOptions = function() {
	                  return opts;
	                };
	                scope.control.getPovOptions = function() {
	                  return povOpts;
	                };
	                scope.control.getGObject = function() {
	                  return sv;
	                };
	                scope.control.getGPano = function() {
	                  return pano;
	                };
	              }
	              scope.$watch('options', function(newValue, oldValue) {
	                if (newValue === oldValue || newValue === opts || didCreateOptionsFromDirective) {
	                  return;
	                }
	                return create();
	              });
	              firstTime = true;
	              scope.$watch('focalcoord', function(newValue, oldValue) {
	                if (newValue === oldValue && !firstTime) {
	                  return;
	                }
	                if (newValue == null) {
	                  return;
	                }
	                firstTime = false;
	                return create();
	              });
	              return scope.$on('$destroy', function() {
	                return clean();
	              });
	            };
	          })(this));
	        }
	      };
	    }
	  ]);
	
	}).call(this);
	;angular.module('uiGmapgoogle-maps.wrapped')
	.service('uiGmapuuid', function() {
	  //BEGIN REPLACE
	  /* istanbul ignore next */
	  /*
	 Version: core-1.0
	 The MIT License: Copyright (c) 2012 LiosK.
	*/
	function UUID(){}UUID.generate=function(){var a=UUID._gri,b=UUID._ha;return b(a(32),8)+"-"+b(a(16),4)+"-"+b(16384|a(12),4)+"-"+b(32768|a(14),4)+"-"+b(a(48),12)};UUID._gri=function(a){return 0>a?NaN:30>=a?0|Math.random()*(1<<a):53>=a?(0|1073741824*Math.random())+1073741824*(0|Math.random()*(1<<a-30)):NaN};UUID._ha=function(a,b){for(var c=a.toString(16),d=b-c.length,e="0";0<d;d>>>=1,e+=e)d&1&&(c=e+c);return c};
	
	  //END REPLACE
	return UUID;
	});
	;// wrap the utility libraries needed in ./lib
	// http://google-maps-utility-library-v3.googlecode.com/svn/
	angular.module('uiGmapgoogle-maps.wrapped')
	.service('uiGmapGoogleMapsUtilV3', function () {
	  return {
	    init: _.once(function () {
	      //BEGIN REPLACE
	      /* istanbul ignore next */
	      +function(){
	      function ClusterIcon(cluster,styles){cluster.getMarkerClusterer().extend(ClusterIcon,google.maps.OverlayView),this.cluster_=cluster,this.className_=cluster.getMarkerClusterer().getClusterClass(),this.styles_=styles,this.center_=null,this.div_=null,this.sums_=null,this.visible_=!1,this.setMap(cluster.getMap())}function Cluster(mc){this.markerClusterer_=mc,this.map_=mc.getMap(),this.gridSize_=mc.getGridSize(),this.minClusterSize_=mc.getMinimumClusterSize(),this.averageCenter_=mc.getAverageCenter(),this.hideLabel_=mc.getHideLabel(),this.markers_=[],this.center_=null,this.bounds_=null,this.clusterIcon_=new ClusterIcon(this,mc.getStyles())}function MarkerClusterer(map,opt_markers,opt_options){this.extend(MarkerClusterer,google.maps.OverlayView),opt_markers=opt_markers||[],opt_options=opt_options||{},this.markers_=[],this.clusters_=[],this.listeners_=[],this.activeMap_=null,this.ready_=!1,this.gridSize_=opt_options.gridSize||60,this.minClusterSize_=opt_options.minimumClusterSize||2,this.maxZoom_=opt_options.maxZoom||null,this.styles_=opt_options.styles||[],this.title_=opt_options.title||"",this.zoomOnClick_=!0,void 0!==opt_options.zoomOnClick&&(this.zoomOnClick_=opt_options.zoomOnClick),this.averageCenter_=!1,void 0!==opt_options.averageCenter&&(this.averageCenter_=opt_options.averageCenter),this.ignoreHidden_=!1,void 0!==opt_options.ignoreHidden&&(this.ignoreHidden_=opt_options.ignoreHidden),this.enableRetinaIcons_=!1,void 0!==opt_options.enableRetinaIcons&&(this.enableRetinaIcons_=opt_options.enableRetinaIcons),this.hideLabel_=!1,void 0!==opt_options.hideLabel&&(this.hideLabel_=opt_options.hideLabel),this.imagePath_=opt_options.imagePath||MarkerClusterer.IMAGE_PATH,this.imageExtension_=opt_options.imageExtension||MarkerClusterer.IMAGE_EXTENSION,this.imageSizes_=opt_options.imageSizes||MarkerClusterer.IMAGE_SIZES,this.calculator_=opt_options.calculator||MarkerClusterer.CALCULATOR,this.batchSize_=opt_options.batchSize||MarkerClusterer.BATCH_SIZE,this.batchSizeIE_=opt_options.batchSizeIE||MarkerClusterer.BATCH_SIZE_IE,this.clusterClass_=opt_options.clusterClass||"cluster",-1!==navigator.userAgent.toLowerCase().indexOf("msie")&&(this.batchSize_=this.batchSizeIE_),this.setupStyles_(),this.addMarkers(opt_markers,!0),this.setMap(map)}ClusterIcon.prototype.onAdd=function(){var cMouseDownInCluster,cDraggingMapByCluster,cClusterIcon=this;this.div_=document.createElement("div"),this.div_.className=this.className_,this.visible_&&this.show(),this.getPanes().overlayMouseTarget.appendChild(this.div_),this.boundsChangedListener_=google.maps.event.addListener(this.getMap(),"bounds_changed",function(){cDraggingMapByCluster=cMouseDownInCluster}),google.maps.event.addDomListener(this.div_,"mousedown",function(){cMouseDownInCluster=!0,cDraggingMapByCluster=!1}),google.maps.event.addDomListener(this.div_,"click",function(e){if(cMouseDownInCluster=!1,!cDraggingMapByCluster){var theBounds,mz,mc=cClusterIcon.cluster_.getMarkerClusterer();google.maps.event.trigger(mc,"click",cClusterIcon.cluster_),google.maps.event.trigger(mc,"clusterclick",cClusterIcon.cluster_),mc.getZoomOnClick()&&(mz=mc.getMaxZoom(),theBounds=cClusterIcon.cluster_.getBounds(),mc.getMap().fitBounds(theBounds),setTimeout(function(){mc.getMap().fitBounds(theBounds),null!==mz&&mc.getMap().getZoom()>mz&&mc.getMap().setZoom(mz+1)},100)),e.cancelBubble=!0,e.stopPropagation&&e.stopPropagation()}}),google.maps.event.addDomListener(this.div_,"mouseover",function(){var mc=cClusterIcon.cluster_.getMarkerClusterer();google.maps.event.trigger(mc,"mouseover",cClusterIcon.cluster_)}),google.maps.event.addDomListener(this.div_,"mouseout",function(){var mc=cClusterIcon.cluster_.getMarkerClusterer();google.maps.event.trigger(mc,"mouseout",cClusterIcon.cluster_)})},ClusterIcon.prototype.onRemove=function(){this.div_&&this.div_.parentNode&&(this.hide(),google.maps.event.removeListener(this.boundsChangedListener_),google.maps.event.clearInstanceListeners(this.div_),this.div_.parentNode.removeChild(this.div_),this.div_=null)},ClusterIcon.prototype.draw=function(){if(this.visible_){var pos=this.getPosFromLatLng_(this.center_);this.div_.style.top=pos.y+"px",this.div_.style.left=pos.x+"px"}},ClusterIcon.prototype.hide=function(){this.div_&&(this.div_.style.display="none"),this.visible_=!1},ClusterIcon.prototype.show=function(){if(this.div_){var img="",bp=this.backgroundPosition_.split(" "),spriteH=parseInt(bp[0].trim(),10),spriteV=parseInt(bp[1].trim(),10),pos=this.getPosFromLatLng_(this.center_);this.div_.style.cssText=this.createCss(pos),img="<img src='"+this.url_+"' style='position: absolute; top: "+spriteV+"px; left: "+spriteH+"px; ",img+=this.cluster_.getMarkerClusterer().enableRetinaIcons_?"width: "+this.width_+"px;height: "+this.height_+"px;":"clip: rect("+-1*spriteV+"px, "+(-1*spriteH+this.width_)+"px, "+(-1*spriteV+this.height_)+"px, "+-1*spriteH+"px);",img+="'>",this.div_.innerHTML=img+"<div style='position: absolute;top: "+this.anchorText_[0]+"px;left: "+this.anchorText_[1]+"px;color: "+this.textColor_+";font-size: "+this.textSize_+"px;font-family: "+this.fontFamily_+";font-weight: "+this.fontWeight_+";font-style: "+this.fontStyle_+";text-decoration: "+this.textDecoration_+";text-align: center;width: "+this.width_+"px;line-height:"+this.height_+"px;'>"+(this.cluster_.hideLabel_?" ":this.sums_.text)+"</div>",this.div_.title="undefined"==typeof this.sums_.title||""===this.sums_.title?this.cluster_.getMarkerClusterer().getTitle():this.sums_.title,this.div_.style.display=""}this.visible_=!0},ClusterIcon.prototype.useStyle=function(sums){this.sums_=sums;var index=Math.max(0,sums.index-1);index=Math.min(this.styles_.length-1,index);var style=this.styles_[index];this.url_=style.url,this.height_=style.height,this.width_=style.width,this.anchorText_=style.anchorText||[0,0],this.anchorIcon_=style.anchorIcon||[parseInt(this.height_/2,10),parseInt(this.width_/2,10)],this.textColor_=style.textColor||"black",this.textSize_=style.textSize||11,this.textDecoration_=style.textDecoration||"none",this.fontWeight_=style.fontWeight||"bold",this.fontStyle_=style.fontStyle||"normal",this.fontFamily_=style.fontFamily||"Arial,sans-serif",this.backgroundPosition_=style.backgroundPosition||"0 0"},ClusterIcon.prototype.setCenter=function(center){this.center_=center},ClusterIcon.prototype.createCss=function(pos){var style=[];return style.push("cursor: pointer;"),style.push("position: absolute; top: "+pos.y+"px; left: "+pos.x+"px;"),style.push("width: "+this.width_+"px; height: "+this.height_+"px;"),style.join("")},ClusterIcon.prototype.getPosFromLatLng_=function(latlng){var pos=this.getProjection().fromLatLngToDivPixel(latlng);return pos.x-=this.anchorIcon_[1],pos.y-=this.anchorIcon_[0],pos.x=parseInt(pos.x,10),pos.y=parseInt(pos.y,10),pos},Cluster.prototype.getSize=function(){return this.markers_.length},Cluster.prototype.getMarkers=function(){return this.markers_},Cluster.prototype.getCenter=function(){return this.center_},Cluster.prototype.getMap=function(){return this.map_},Cluster.prototype.getMarkerClusterer=function(){return this.markerClusterer_},Cluster.prototype.getBounds=function(){var i,bounds=new google.maps.LatLngBounds(this.center_,this.center_),markers=this.getMarkers();for(i=0;i<markers.length;i++)bounds.extend(markers[i].getPosition());return bounds},Cluster.prototype.remove=function(){this.clusterIcon_.setMap(null),this.markers_=[],delete this.markers_},Cluster.prototype.addMarker=function(marker){var i,mCount,mz;if(this.isMarkerAlreadyAdded_(marker))return!1;if(this.center_){if(this.averageCenter_){var l=this.markers_.length+1,lat=(this.center_.lat()*(l-1)+marker.getPosition().lat())/l,lng=(this.center_.lng()*(l-1)+marker.getPosition().lng())/l;this.center_=new google.maps.LatLng(lat,lng),this.calculateBounds_()}}else this.center_=marker.getPosition(),this.calculateBounds_();if(marker.isAdded=!0,this.markers_.push(marker),mCount=this.markers_.length,mz=this.markerClusterer_.getMaxZoom(),null!==mz&&this.map_.getZoom()>mz)marker.getMap()!==this.map_&&marker.setMap(this.map_);else if(mCount<this.minClusterSize_)marker.getMap()!==this.map_&&marker.setMap(this.map_);else if(mCount===this.minClusterSize_)for(i=0;mCount>i;i++)this.markers_[i].setMap(null);else marker.setMap(null);return!0},Cluster.prototype.isMarkerInClusterBounds=function(marker){return this.bounds_.contains(marker.getPosition())},Cluster.prototype.calculateBounds_=function(){var bounds=new google.maps.LatLngBounds(this.center_,this.center_);this.bounds_=this.markerClusterer_.getExtendedBounds(bounds)},Cluster.prototype.updateIcon_=function(){var mCount=this.markers_.length,mz=this.markerClusterer_.getMaxZoom();if(null!==mz&&this.map_.getZoom()>mz)return void this.clusterIcon_.hide();if(mCount<this.minClusterSize_)return void this.clusterIcon_.hide();var numStyles=this.markerClusterer_.getStyles().length,sums=this.markerClusterer_.getCalculator()(this.markers_,numStyles);this.clusterIcon_.setCenter(this.center_),this.clusterIcon_.useStyle(sums),this.clusterIcon_.show()},Cluster.prototype.isMarkerAlreadyAdded_=function(marker){for(var i=0,n=this.markers_.length;n>i;i++)if(marker===this.markers_[i])return!0;return!1},MarkerClusterer.prototype.onAdd=function(){var cMarkerClusterer=this;this.activeMap_=this.getMap(),this.ready_=!0,this.repaint(),this.listeners_=[google.maps.event.addListener(this.getMap(),"zoom_changed",function(){cMarkerClusterer.resetViewport_(!1),(this.getZoom()===(this.get("minZoom")||0)||this.getZoom()===this.get("maxZoom"))&&google.maps.event.trigger(this,"idle")}),google.maps.event.addListener(this.getMap(),"idle",function(){cMarkerClusterer.redraw_()})]},MarkerClusterer.prototype.onRemove=function(){var i;for(i=0;i<this.markers_.length;i++)this.markers_[i].getMap()!==this.activeMap_&&this.markers_[i].setMap(this.activeMap_);for(i=0;i<this.clusters_.length;i++)this.clusters_[i].remove();for(this.clusters_=[],i=0;i<this.listeners_.length;i++)google.maps.event.removeListener(this.listeners_[i]);this.listeners_=[],this.activeMap_=null,this.ready_=!1},MarkerClusterer.prototype.draw=function(){},MarkerClusterer.prototype.setupStyles_=function(){var i,size;if(!(this.styles_.length>0))for(i=0;i<this.imageSizes_.length;i++)size=this.imageSizes_[i],this.styles_.push({url:this.imagePath_+(i+1)+"."+this.imageExtension_,height:size,width:size})},MarkerClusterer.prototype.fitMapToMarkers=function(){var i,markers=this.getMarkers(),bounds=new google.maps.LatLngBounds;for(i=0;i<markers.length;i++)bounds.extend(markers[i].getPosition());this.getMap().fitBounds(bounds)},MarkerClusterer.prototype.getGridSize=function(){return this.gridSize_},MarkerClusterer.prototype.setGridSize=function(gridSize){this.gridSize_=gridSize},MarkerClusterer.prototype.getMinimumClusterSize=function(){return this.minClusterSize_},MarkerClusterer.prototype.setMinimumClusterSize=function(minimumClusterSize){this.minClusterSize_=minimumClusterSize},MarkerClusterer.prototype.getMaxZoom=function(){return this.maxZoom_},MarkerClusterer.prototype.setMaxZoom=function(maxZoom){this.maxZoom_=maxZoom},MarkerClusterer.prototype.getStyles=function(){return this.styles_},MarkerClusterer.prototype.setStyles=function(styles){this.styles_=styles},MarkerClusterer.prototype.getTitle=function(){return this.title_},MarkerClusterer.prototype.setTitle=function(title){this.title_=title},MarkerClusterer.prototype.getZoomOnClick=function(){return this.zoomOnClick_},MarkerClusterer.prototype.setZoomOnClick=function(zoomOnClick){this.zoomOnClick_=zoomOnClick},MarkerClusterer.prototype.getAverageCenter=function(){return this.averageCenter_},MarkerClusterer.prototype.setAverageCenter=function(averageCenter){this.averageCenter_=averageCenter},MarkerClusterer.prototype.getIgnoreHidden=function(){return this.ignoreHidden_},MarkerClusterer.prototype.setIgnoreHidden=function(ignoreHidden){this.ignoreHidden_=ignoreHidden},MarkerClusterer.prototype.getEnableRetinaIcons=function(){return this.enableRetinaIcons_},MarkerClusterer.prototype.setEnableRetinaIcons=function(enableRetinaIcons){this.enableRetinaIcons_=enableRetinaIcons},MarkerClusterer.prototype.getImageExtension=function(){return this.imageExtension_},MarkerClusterer.prototype.setImageExtension=function(imageExtension){this.imageExtension_=imageExtension},MarkerClusterer.prototype.getImagePath=function(){return this.imagePath_},MarkerClusterer.prototype.setImagePath=function(imagePath){this.imagePath_=imagePath},MarkerClusterer.prototype.getImageSizes=function(){return this.imageSizes_},MarkerClusterer.prototype.setImageSizes=function(imageSizes){this.imageSizes_=imageSizes},MarkerClusterer.prototype.getCalculator=function(){return this.calculator_},MarkerClusterer.prototype.setCalculator=function(calculator){this.calculator_=calculator},MarkerClusterer.prototype.setHideLabel=function(hideLabel){this.hideLabel_=hideLabel},MarkerClusterer.prototype.getHideLabel=function(){return this.hideLabel_},MarkerClusterer.prototype.getBatchSizeIE=function(){return this.batchSizeIE_},MarkerClusterer.prototype.setBatchSizeIE=function(batchSizeIE){this.batchSizeIE_=batchSizeIE},MarkerClusterer.prototype.getClusterClass=function(){return this.clusterClass_},MarkerClusterer.prototype.setClusterClass=function(clusterClass){this.clusterClass_=clusterClass},MarkerClusterer.prototype.getMarkers=function(){return this.markers_},MarkerClusterer.prototype.getTotalMarkers=function(){return this.markers_.length},MarkerClusterer.prototype.getClusters=function(){return this.clusters_},MarkerClusterer.prototype.getTotalClusters=function(){return this.clusters_.length},MarkerClusterer.prototype.addMarker=function(marker,opt_nodraw){this.pushMarkerTo_(marker),opt_nodraw||this.redraw_()},MarkerClusterer.prototype.addMarkers=function(markers,opt_nodraw){var key;for(key in markers)markers.hasOwnProperty(key)&&this.pushMarkerTo_(markers[key]);opt_nodraw||this.redraw_()},MarkerClusterer.prototype.pushMarkerTo_=function(marker){if(marker.getDraggable()){var cMarkerClusterer=this;google.maps.event.addListener(marker,"dragend",function(){cMarkerClusterer.ready_&&(this.isAdded=!1,cMarkerClusterer.repaint())})}marker.isAdded=!1,this.markers_.push(marker)},MarkerClusterer.prototype.removeMarker=function(marker,opt_nodraw,opt_noMapRemove){var removeFromMap=!0&&!opt_noMapRemove,removed=this.removeMarker_(marker,removeFromMap);return!opt_nodraw&&removed&&this.repaint(),removed},MarkerClusterer.prototype.removeMarkers=function(markers,opt_nodraw,opt_noMapRemove){var i,r,removed=!1,removeFromMap=!0&&!opt_noMapRemove;for(i=0;i<markers.length;i++)r=this.removeMarker_(markers[i],removeFromMap),removed=removed||r;return!opt_nodraw&&removed&&this.repaint(),removed},MarkerClusterer.prototype.removeMarker_=function(marker,removeFromMap){var i,index=-1;if(this.markers_.indexOf)index=this.markers_.indexOf(marker);else for(i=0;i<this.markers_.length;i++)if(marker===this.markers_[i]){index=i;break}return-1===index?!1:(removeFromMap&&marker.setMap(null),this.markers_.splice(index,1),!0)},MarkerClusterer.prototype.clearMarkers=function(){this.resetViewport_(!0),this.markers_=[]},MarkerClusterer.prototype.repaint=function(){var oldClusters=this.clusters_.slice();this.clusters_=[],this.resetViewport_(!1),this.redraw_(),setTimeout(function(){var i;for(i=0;i<oldClusters.length;i++)oldClusters[i].remove()},0)},MarkerClusterer.prototype.getExtendedBounds=function(bounds){var projection=this.getProjection(),tr=new google.maps.LatLng(bounds.getNorthEast().lat(),bounds.getNorthEast().lng()),bl=new google.maps.LatLng(bounds.getSouthWest().lat(),bounds.getSouthWest().lng()),trPix=projection.fromLatLngToDivPixel(tr);trPix.x+=this.gridSize_,trPix.y-=this.gridSize_;var blPix=projection.fromLatLngToDivPixel(bl);blPix.x-=this.gridSize_,blPix.y+=this.gridSize_;var ne=projection.fromDivPixelToLatLng(trPix),sw=projection.fromDivPixelToLatLng(blPix);return bounds.extend(ne),bounds.extend(sw),bounds},MarkerClusterer.prototype.redraw_=function(){this.createClusters_(0)},MarkerClusterer.prototype.resetViewport_=function(opt_hide){var i,marker;for(i=0;i<this.clusters_.length;i++)this.clusters_[i].remove();for(this.clusters_=[],i=0;i<this.markers_.length;i++)marker=this.markers_[i],marker.isAdded=!1,opt_hide&&marker.setMap(null)},MarkerClusterer.prototype.distanceBetweenPoints_=function(p1,p2){var R=6371,dLat=(p2.lat()-p1.lat())*Math.PI/180,dLon=(p2.lng()-p1.lng())*Math.PI/180,a=Math.sin(dLat/2)*Math.sin(dLat/2)+Math.cos(p1.lat()*Math.PI/180)*Math.cos(p2.lat()*Math.PI/180)*Math.sin(dLon/2)*Math.sin(dLon/2),c=2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a)),d=R*c;return d},MarkerClusterer.prototype.isMarkerInBounds_=function(marker,bounds){return bounds.contains(marker.getPosition())},MarkerClusterer.prototype.addToClosestCluster_=function(marker){var i,d,cluster,center,distance=4e4,clusterToAddTo=null;for(i=0;i<this.clusters_.length;i++)cluster=this.clusters_[i],center=cluster.getCenter(),center&&(d=this.distanceBetweenPoints_(center,marker.getPosition()),distance>d&&(distance=d,clusterToAddTo=cluster));clusterToAddTo&&clusterToAddTo.isMarkerInClusterBounds(marker)?clusterToAddTo.addMarker(marker):(cluster=new Cluster(this),cluster.addMarker(marker),this.clusters_.push(cluster))},MarkerClusterer.prototype.createClusters_=function(iFirst){var i,marker,mapBounds,cMarkerClusterer=this;if(this.ready_){0===iFirst&&(google.maps.event.trigger(this,"clusteringbegin",this),"undefined"!=typeof this.timerRefStatic&&(clearTimeout(this.timerRefStatic),delete this.timerRefStatic)),mapBounds=this.getMap().getZoom()>3?new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(),this.getMap().getBounds().getNorthEast()):new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472,-178.48388434375),new google.maps.LatLng(-85.08136444384544,178.00048865625));var bounds=this.getExtendedBounds(mapBounds),iLast=Math.min(iFirst+this.batchSize_,this.markers_.length);for(i=iFirst;iLast>i;i++)marker=this.markers_[i],!marker.isAdded&&this.isMarkerInBounds_(marker,bounds)&&(!this.ignoreHidden_||this.ignoreHidden_&&marker.getVisible())&&this.addToClosestCluster_(marker);if(iLast<this.markers_.length)this.timerRefStatic=setTimeout(function(){cMarkerClusterer.createClusters_(iLast)},0);else for(delete this.timerRefStatic,google.maps.event.trigger(this,"clusteringend",this),i=0;i<this.clusters_.length;i++)this.clusters_[i].updateIcon_()}},MarkerClusterer.prototype.extend=function(obj1,obj2){return function(object){var property;for(property in object.prototype)this.prototype[property]=object.prototype[property];return this}.apply(obj1,[obj2])},MarkerClusterer.CALCULATOR=function(markers,numStyles){for(var index=0,title="",count=markers.length.toString(),dv=count;0!==dv;)dv=parseInt(dv/10,10),index++;return index=Math.min(index,numStyles),{text:count,index:index,title:title}},MarkerClusterer.BATCH_SIZE=2e3,MarkerClusterer.BATCH_SIZE_IE=500,MarkerClusterer.IMAGE_PATH="//cdn.rawgit.com/mahnunchik/markerclustererplus/master/images/m",MarkerClusterer.IMAGE_EXTENSION="png",MarkerClusterer.IMAGE_SIZES=[53,56,66,78,90],"function"!=typeof String.prototype.trim&&(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")});
	/**
	 *  google-maps-utility-library-v3-infobox
	 *
	 * @version: 1.1.14
	 * @author: Gary Little (inspired by proof-of-concept code from Pamela Fox of Google)
	 * @contributors: Nicholas McCready
	 * @date: Fri May 13 2016 16:35:27 GMT-0400 (EDT)
	 * @license: Apache License 2.0
	 */
	/**
	 * @fileoverview InfoBox extends the Google Maps JavaScript API V3 <tt>OverlayView</tt> class.
	 *  <p>
	 *  An InfoBox behaves like a <tt>google.maps.InfoWindow</tt>, but it supports several
	 *  additional properties for advanced styling. An InfoBox can also be used as a map label.
	 *  <p>
	 *  An InfoBox also fires the same events as a <tt>google.maps.InfoWindow</tt>.
	 */
	
	/*jslint browser:true */
	/*global google */
	
	/**
	 * @name InfoBoxOptions
	 * @class This class represents the optional parameter passed to the {@link InfoBox} constructor.
	 * @property {string|Node} content The content of the InfoBox (plain text or an HTML DOM node).
	 * @property {boolean} [disableAutoPan=false] Disable auto-pan on <tt>open</tt>.
	 * @property {number} maxWidth The maximum width (in pixels) of the InfoBox. Set to 0 if no maximum.
	 * @property {Size} pixelOffset The offset (in pixels) from the top left corner of the InfoBox
	 *  (or the bottom left corner if the <code>alignBottom</code> property is <code>true</code>)
	 *  to the map pixel corresponding to <tt>position</tt>.
	 * @property {LatLng} position The geographic location at which to display the InfoBox.
	 * @property {number} zIndex The CSS z-index style value for the InfoBox.
	 *  Note: This value overrides a zIndex setting specified in the <tt>boxStyle</tt> property.
	 * @property {string} [boxClass="infoBox"] The name of the CSS class defining the styles for the InfoBox container.
	 * @property {Object} [boxStyle] An object literal whose properties define specific CSS
	 *  style values to be applied to the InfoBox. Style values defined here override those that may
	 *  be defined in the <code>boxClass</code> style sheet. If this property is changed after the
	 *  InfoBox has been created, all previously set styles (except those defined in the style sheet)
	 *  are removed from the InfoBox before the new style values are applied.
	 * @property {string} closeBoxMargin The CSS margin style value for the close box.
	 *  The default is "2px" (a 2-pixel margin on all sides).
	 * @property {string} closeBoxURL The URL of the image representing the close box.
	 *  Note: The default is the URL for Google's standard close box.
	 *  Set this property to "" if no close box is required.
	 * @property {Size} infoBoxClearance Minimum offset (in pixels) from the InfoBox to the
	 *  map edge after an auto-pan.
	 * @property {boolean} [isHidden=false] Hide the InfoBox on <tt>open</tt>.
	 *  [Deprecated in favor of the <tt>visible</tt> property.]
	 * @property {boolean} [visible=true] Show the InfoBox on <tt>open</tt>.
	 * @property {boolean} alignBottom Align the bottom left corner of the InfoBox to the <code>position</code>
	 *  location (default is <tt>false</tt> which means that the top left corner of the InfoBox is aligned).
	 * @property {string} pane The pane where the InfoBox is to appear (default is "floatPane").
	 *  Set the pane to "mapPane" if the InfoBox is being used as a map label.
	 *  Valid pane names are the property names for the <tt>google.maps.MapPanes</tt> object.
	 * @property {boolean} enableEventPropagation Propagate mousedown, mousemove, mouseover, mouseout,
	 *  mouseup, click, dblclick, touchstart, touchend, touchmove, and contextmenu events in the InfoBox
	 *  (default is <tt>false</tt> to mimic the behavior of a <tt>google.maps.InfoWindow</tt>). Set
	 *  this property to <tt>true</tt> if the InfoBox is being used as a map label.
	 */
	
	/**
	 * Creates an InfoBox with the options specified in {@link InfoBoxOptions}.
	 *  Call <tt>InfoBox.open</tt> to add the box to the map.
	 * @constructor
	 * @param {InfoBoxOptions} [opt_opts]
	 */
	function InfoBox(opt_opts) {
	
	  opt_opts = opt_opts || {};
	
	  google.maps.OverlayView.apply(this, arguments);
	
	  // Standard options (in common with google.maps.InfoWindow):
	  //
	  this.content_ = opt_opts.content || "";
	  this.disableAutoPan_ = opt_opts.disableAutoPan || false;
	  this.maxWidth_ = opt_opts.maxWidth || 0;
	  this.pixelOffset_ = opt_opts.pixelOffset || new google.maps.Size(0, 0);
	  this.position_ = opt_opts.position || new google.maps.LatLng(0, 0);
	  this.zIndex_ = opt_opts.zIndex || null;
	
	  // Additional options (unique to InfoBox):
	  //
	  this.boxClass_ = opt_opts.boxClass || "infoBox";
	  this.boxStyle_ = opt_opts.boxStyle || {};
	  this.closeBoxMargin_ = opt_opts.closeBoxMargin || "2px";
	  this.closeBoxURL_ = opt_opts.closeBoxURL || "http://www.google.com/intl/en_us/mapfiles/close.gif";
	  if (opt_opts.closeBoxURL === "") {
	    this.closeBoxURL_ = "";
	  }
	  this.infoBoxClearance_ = opt_opts.infoBoxClearance || new google.maps.Size(1, 1);
	
	  if (typeof opt_opts.visible === "undefined") {
	    if (typeof opt_opts.isHidden === "undefined") {
	      opt_opts.visible = true;
	    } else {
	      opt_opts.visible = !opt_opts.isHidden;
	    }
	  }
	  this.isHidden_ = !opt_opts.visible;
	
	  this.alignBottom_ = opt_opts.alignBottom || false;
	  this.pane_ = opt_opts.pane || "floatPane";
	  this.enableEventPropagation_ = opt_opts.enableEventPropagation || false;
	
	  this.div_ = null;
	  this.closeListener_ = null;
	  this.moveListener_ = null;
	  this.contextListener_ = null;
	  this.eventListeners_ = null;
	  this.fixedWidthSet_ = null;
	}
	
	/* InfoBox extends OverlayView in the Google Maps API v3.
	 */
	InfoBox.prototype = new google.maps.OverlayView();
	
	/**
	 * Creates the DIV representing the InfoBox.
	 * @private
	 */
	InfoBox.prototype.createInfoBoxDiv_ = function () {
	
	  var i;
	  var events;
	  var bw;
	  var me = this;
	
	  // This handler prevents an event in the InfoBox from being passed on to the map.
	  //
	  var cancelHandler = function (e) {
	    e.cancelBubble = true;
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    }
	  };
	
	  // This handler ignores the current event in the InfoBox and conditionally prevents
	  // the event from being passed on to the map. It is used for the contextmenu event.
	  //
	  var ignoreHandler = function (e) {
	
	    e.returnValue = false;
	
	    if (e.preventDefault) {
	
	      e.preventDefault();
	    }
	
	    if (!me.enableEventPropagation_) {
	
	      cancelHandler(e);
	    }
	  };
	
	  if (!this.div_) {
	
	    this.div_ = document.createElement("div");
	
	    this.setBoxStyle_();
	
	    if (typeof this.content_.nodeType === "undefined") {
	      this.div_.innerHTML = this.getCloseBoxImg_() + this.content_;
	    } else {
	      this.div_.innerHTML = this.getCloseBoxImg_();
	      this.div_.appendChild(this.content_);
	    }
	
	    // Add the InfoBox DIV to the DOM
	    this.getPanes()[this.pane_].appendChild(this.div_);
	
	    this.addClickHandler_();
	
	    if (this.div_.style.width) {
	
	      this.fixedWidthSet_ = true;
	
	    } else {
	
	      if (this.maxWidth_ !== 0 && this.div_.offsetWidth > this.maxWidth_) {
	
	        this.div_.style.width = this.maxWidth_;
	        this.div_.style.overflow = "auto";
	        this.fixedWidthSet_ = true;
	
	      } else { // The following code is needed to overcome problems with MSIE
	
	        bw = this.getBoxWidths_();
	
	        this.div_.style.width = (this.div_.offsetWidth - bw.left - bw.right) + "px";
	        this.fixedWidthSet_ = false;
	      }
	    }
	
	    this.panBox_(this.disableAutoPan_);
	
	    if (!this.enableEventPropagation_) {
	
	      this.eventListeners_ = [];
	
	      // Cancel event propagation.
	      //
	      // Note: mousemove not included (to resolve Issue 152)
	      events = ["mousedown", "mouseover", "mouseout", "mouseup",
	      "click", "dblclick", "touchstart", "touchend", "touchmove"];
	
	      for (i = 0; i < events.length; i++) {
	
	        this.eventListeners_.push(google.maps.event.addDomListener(this.div_, events[i], cancelHandler));
	      }
	
	      // Workaround for Google bug that causes the cursor to change to a pointer
	      // when the mouse moves over a marker underneath InfoBox.
	      this.eventListeners_.push(google.maps.event.addDomListener(this.div_, "mouseover", function (e) {
	        this.style.cursor = "default";
	      }));
	    }
	
	    this.contextListener_ = google.maps.event.addDomListener(this.div_, "contextmenu", ignoreHandler);
	
	    /**
	     * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
	     * @name InfoBox#domready
	     * @event
	     */
	    google.maps.event.trigger(this, "domready");
	  }
	};
	
	/**
	 * Returns the HTML <IMG> tag for the close box.
	 * @private
	 */
	InfoBox.prototype.getCloseBoxImg_ = function () {
	
	  var img = "";
	
	  if (this.closeBoxURL_ !== "") {
	
	    img  = "<img";
	    img += " src='" + this.closeBoxURL_ + "'";
	    img += " align=right"; // Do this because Opera chokes on style='float: right;'
	    img += " style='";
	    img += " position: relative;"; // Required by MSIE
	    img += " cursor: pointer;";
	    img += " margin: " + this.closeBoxMargin_ + ";";
	    img += "'>";
	  }
	
	  return img;
	};
	
	/**
	 * Adds the click handler to the InfoBox close box.
	 * @private
	 */
	InfoBox.prototype.addClickHandler_ = function () {
	
	  var closeBox;
	
	  if (this.closeBoxURL_ !== "") {
	
	    closeBox = this.div_.firstChild;
	    this.closeListener_ = google.maps.event.addDomListener(closeBox, "click", this.getCloseClickHandler_());
	
	  } else {
	
	    this.closeListener_ = null;
	  }
	};
	
	/**
	 * Returns the function to call when the user clicks the close box of an InfoBox.
	 * @private
	 */
	InfoBox.prototype.getCloseClickHandler_ = function () {
	
	  var me = this;
	
	  return function (e) {
	
	    // 1.0.3 fix: Always prevent propagation of a close box click to the map:
	    e.cancelBubble = true;
	
	    if (e.stopPropagation) {
	
	      e.stopPropagation();
	    }
	
	    /**
	     * This event is fired when the InfoBox's close box is clicked.
	     * @name InfoBox#closeclick
	     * @event
	     */
	    google.maps.event.trigger(me, "closeclick");
	
	    me.close();
	  };
	};
	
	/**
	 * Pans the map so that the InfoBox appears entirely within the map's visible area.
	 * @private
	 */
	InfoBox.prototype.panBox_ = function (disablePan) {
	
	  var map;
	  var bounds;
	  var xOffset = 0, yOffset = 0;
	
	  if (!disablePan) {
	
	    map = this.getMap();
	
	    if (map instanceof google.maps.Map) { // Only pan if attached to map, not panorama
	
	      if (!map.getBounds().contains(this.position_)) {
	      // Marker not in visible area of map, so set center
	      // of map to the marker position first.
	        map.setCenter(this.position_);
	      }
	
	      bounds = map.getBounds();
	
	      var mapDiv = map.getDiv();
	      var mapWidth = mapDiv.offsetWidth;
	      var mapHeight = mapDiv.offsetHeight;
	      var iwOffsetX = this.pixelOffset_.width;
	      var iwOffsetY = this.pixelOffset_.height;
	      var iwWidth = this.div_.offsetWidth;
	      var iwHeight = this.div_.offsetHeight;
	      var padX = this.infoBoxClearance_.width;
	      var padY = this.infoBoxClearance_.height;
	      var pixPosition = this.getProjection().fromLatLngToContainerPixel(this.position_);
	
	      if (pixPosition.x < (-iwOffsetX + padX)) {
	        xOffset = pixPosition.x + iwOffsetX - padX;
	      } else if ((pixPosition.x + iwWidth + iwOffsetX + padX) > mapWidth) {
	        xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
	      }
	      if (this.alignBottom_) {
	        if (pixPosition.y < (-iwOffsetY + padY + iwHeight)) {
	          yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
	        } else if ((pixPosition.y + iwOffsetY + padY) > mapHeight) {
	          yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
	        }
	      } else {
	        if (pixPosition.y < (-iwOffsetY + padY)) {
	          yOffset = pixPosition.y + iwOffsetY - padY;
	        } else if ((pixPosition.y + iwHeight + iwOffsetY + padY) > mapHeight) {
	          yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
	        }
	      }
	
	      if (!(xOffset === 0 && yOffset === 0)) {
	
	        // Move the map to the shifted center.
	        //
	        var c = map.getCenter();
	        map.panBy(xOffset, yOffset);
	      }
	    }
	  }
	};
	
	/**
	 * Sets the style of the InfoBox by setting the style sheet and applying
	 * other specific styles requested.
	 * @private
	 */
	InfoBox.prototype.setBoxStyle_ = function () {
	
	  var i, boxStyle;
	
	  if (this.div_) {
	
	    // Apply style values from the style sheet defined in the boxClass parameter:
	    this.div_.className = this.boxClass_;
	
	    // Clear existing inline style values:
	    this.div_.style.cssText = "";
	
	    // Apply style values defined in the boxStyle parameter:
	    boxStyle = this.boxStyle_;
	    for (i in boxStyle) {
	
	      if (boxStyle.hasOwnProperty(i)) {
	
	        this.div_.style[i] = boxStyle[i];
	      }
	    }
	
	    // Fix for iOS disappearing InfoBox problem.
	    // See http://stackoverflow.com/questions/9229535/google-maps-markers-disappear-at-certain-zoom-level-only-on-iphone-ipad
	    this.div_.style.WebkitTransform = "translateZ(0)";
	
	    // Fix up opacity style for benefit of MSIE:
	    //
	    if (typeof this.div_.style.opacity !== "undefined" && this.div_.style.opacity !== "") {
	      // See http://www.quirksmode.org/css/opacity.html
	      this.div_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(Opacity=" + (this.div_.style.opacity * 100) + ")\"";
	      this.div_.style.filter = "alpha(opacity=" + (this.div_.style.opacity * 100) + ")";
	    }
	
	    // Apply required styles:
	    //
	    this.div_.style.position = "absolute";
	    this.div_.style.visibility = 'hidden';
	    if (this.zIndex_ !== null) {
	
	      this.div_.style.zIndex = this.zIndex_;
	    }
	  }
	};
	
	/**
	 * Get the widths of the borders of the InfoBox.
	 * @private
	 * @return {Object} widths object (top, bottom left, right)
	 */
	InfoBox.prototype.getBoxWidths_ = function () {
	
	  var computedStyle;
	  var bw = {top: 0, bottom: 0, left: 0, right: 0};
	  var box = this.div_;
	
	  if (document.defaultView && document.defaultView.getComputedStyle) {
	
	    computedStyle = box.ownerDocument.defaultView.getComputedStyle(box, "");
	
	    if (computedStyle) {
	
	      // The computed styles are always in pixel units (good!)
	      bw.top = parseInt(computedStyle.borderTopWidth, 10) || 0;
	      bw.bottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
	      bw.left = parseInt(computedStyle.borderLeftWidth, 10) || 0;
	      bw.right = parseInt(computedStyle.borderRightWidth, 10) || 0;
	    }
	
	  } else if (document.documentElement.currentStyle) { // MSIE
	
	    if (box.currentStyle) {
	
	      // The current styles may not be in pixel units, but assume they are (bad!)
	      bw.top = parseInt(box.currentStyle.borderTopWidth, 10) || 0;
	      bw.bottom = parseInt(box.currentStyle.borderBottomWidth, 10) || 0;
	      bw.left = parseInt(box.currentStyle.borderLeftWidth, 10) || 0;
	      bw.right = parseInt(box.currentStyle.borderRightWidth, 10) || 0;
	    }
	  }
	
	  return bw;
	};
	
	/**
	 * Invoked when <tt>close</tt> is called. Do not call it directly.
	 */
	InfoBox.prototype.onRemove = function () {
	
	  if (this.div_) {
	
	    this.div_.parentNode.removeChild(this.div_);
	    this.div_ = null;
	  }
	};
	
	/**
	 * Draws the InfoBox based on the current map projection and zoom level.
	 */
	InfoBox.prototype.draw = function () {
	
	  this.createInfoBoxDiv_();
	
	  var pixPosition = this.getProjection().fromLatLngToDivPixel(this.position_);
	
	  this.div_.style.left = (pixPosition.x + this.pixelOffset_.width) + "px";
	
	  if (this.alignBottom_) {
	    this.div_.style.bottom = -(pixPosition.y + this.pixelOffset_.height) + "px";
	  } else {
	    this.div_.style.top = (pixPosition.y + this.pixelOffset_.height) + "px";
	  }
	
	  if (this.isHidden_) {
	
	    this.div_.style.visibility = "hidden";
	
	  } else {
	
	    this.div_.style.visibility = "visible";
	  }
	};
	
	/**
	 * Sets the options for the InfoBox. Note that changes to the <tt>maxWidth</tt>,
	 *  <tt>closeBoxMargin</tt>, <tt>closeBoxURL</tt>, and <tt>enableEventPropagation</tt>
	 *  properties have no affect until the current InfoBox is <tt>close</tt>d and a new one
	 *  is <tt>open</tt>ed.
	 * @param {InfoBoxOptions} opt_opts
	 */
	InfoBox.prototype.setOptions = function (opt_opts) {
	  if (typeof opt_opts.boxClass !== "undefined") { // Must be first
	
	    this.boxClass_ = opt_opts.boxClass;
	    this.setBoxStyle_();
	  }
	  if (typeof opt_opts.boxStyle !== "undefined") { // Must be second
	
	    this.boxStyle_ = opt_opts.boxStyle;
	    this.setBoxStyle_();
	  }
	  if (typeof opt_opts.content !== "undefined") {
	
	    this.setContent(opt_opts.content);
	  }
	  if (typeof opt_opts.disableAutoPan !== "undefined") {
	
	    this.disableAutoPan_ = opt_opts.disableAutoPan;
	  }
	  if (typeof opt_opts.maxWidth !== "undefined") {
	
	    this.maxWidth_ = opt_opts.maxWidth;
	  }
	  if (typeof opt_opts.pixelOffset !== "undefined") {
	
	    this.pixelOffset_ = opt_opts.pixelOffset;
	  }
	  if (typeof opt_opts.alignBottom !== "undefined") {
	
	    this.alignBottom_ = opt_opts.alignBottom;
	  }
	  if (typeof opt_opts.position !== "undefined") {
	
	    this.setPosition(opt_opts.position);
	  }
	  if (typeof opt_opts.zIndex !== "undefined") {
	
	    this.setZIndex(opt_opts.zIndex);
	  }
	  if (typeof opt_opts.closeBoxMargin !== "undefined") {
	
	    this.closeBoxMargin_ = opt_opts.closeBoxMargin;
	  }
	  if (typeof opt_opts.closeBoxURL !== "undefined") {
	
	    this.closeBoxURL_ = opt_opts.closeBoxURL;
	  }
	  if (typeof opt_opts.infoBoxClearance !== "undefined") {
	
	    this.infoBoxClearance_ = opt_opts.infoBoxClearance;
	  }
	  if (typeof opt_opts.isHidden !== "undefined") {
	
	    this.isHidden_ = opt_opts.isHidden;
	  }
	  if (typeof opt_opts.visible !== "undefined") {
	
	    this.isHidden_ = !opt_opts.visible;
	  }
	  if (typeof opt_opts.enableEventPropagation !== "undefined") {
	
	    this.enableEventPropagation_ = opt_opts.enableEventPropagation;
	  }
	
	  if (this.div_) {
	
	    this.draw();
	  }
	};
	
	/**
	 * Sets the content of the InfoBox.
	 *  The content can be plain text or an HTML DOM node.
	 * @param {string|Node} content
	 */
	InfoBox.prototype.setContent = function (content) {
	  this.content_ = content;
	
	  if (this.div_) {
	
	    if (this.closeListener_) {
	
	      google.maps.event.removeListener(this.closeListener_);
	      this.closeListener_ = null;
	    }
	
	    // Odd code required to make things work with MSIE.
	    //
	    if (!this.fixedWidthSet_) {
	
	      this.div_.style.width = "";
	    }
	
	    if (typeof content.nodeType === "undefined") {
	      this.div_.innerHTML = this.getCloseBoxImg_() + content;
	    } else {
	      this.div_.innerHTML = this.getCloseBoxImg_();
	      this.div_.appendChild(content);
	    }
	
	    // Perverse code required to make things work with MSIE.
	    // (Ensures the close box does, in fact, float to the right.)
	    //
	    if (!this.fixedWidthSet_) {
	      this.div_.style.width = this.div_.offsetWidth + "px";
	      if (typeof content.nodeType === "undefined") {
	        this.div_.innerHTML = this.getCloseBoxImg_() + content;
	      } else {
	        this.div_.innerHTML = this.getCloseBoxImg_();
	        this.div_.appendChild(content);
	      }
	    }
	
	    this.addClickHandler_();
	  }
	
	  /**
	   * This event is fired when the content of the InfoBox changes.
	   * @name InfoBox#content_changed
	   * @event
	   */
	  google.maps.event.trigger(this, "content_changed");
	};
	
	/**
	 * Sets the geographic location of the InfoBox.
	 * @param {LatLng} latlng
	 */
	InfoBox.prototype.setPosition = function (latlng) {
	
	  this.position_ = latlng;
	
	  if (this.div_) {
	
	    this.draw();
	  }
	
	  /**
	   * This event is fired when the position of the InfoBox changes.
	   * @name InfoBox#position_changed
	   * @event
	   */
	  google.maps.event.trigger(this, "position_changed");
	};
	
	/**
	 * Sets the zIndex style for the InfoBox.
	 * @param {number} index
	 */
	InfoBox.prototype.setZIndex = function (index) {
	
	  this.zIndex_ = index;
	
	  if (this.div_) {
	
	    this.div_.style.zIndex = index;
	  }
	
	  /**
	   * This event is fired when the zIndex of the InfoBox changes.
	   * @name InfoBox#zindex_changed
	   * @event
	   */
	  google.maps.event.trigger(this, "zindex_changed");
	};
	
	/**
	 * Sets the visibility of the InfoBox.
	 * @param {boolean} isVisible
	 */
	InfoBox.prototype.setVisible = function (isVisible) {
	
	  this.isHidden_ = !isVisible;
	  if (this.div_) {
	    this.div_.style.visibility = (this.isHidden_ ? "hidden" : "visible");
	  }
	};
	
	/**
	 * Returns the content of the InfoBox.
	 * @returns {string}
	 */
	InfoBox.prototype.getContent = function () {
	
	  return this.content_;
	};
	
	/**
	 * Returns the geographic location of the InfoBox.
	 * @returns {LatLng}
	 */
	InfoBox.prototype.getPosition = function () {
	
	  return this.position_;
	};
	
	/**
	 * Returns the zIndex for the InfoBox.
	 * @returns {number}
	 */
	InfoBox.prototype.getZIndex = function () {
	
	  return this.zIndex_;
	};
	
	/**
	 * Returns a flag indicating whether the InfoBox is visible.
	 * @returns {boolean}
	 */
	InfoBox.prototype.getVisible = function () {
	
	  var isVisible;
	
	  if ((typeof this.getMap() === "undefined") || (this.getMap() === null)) {
	    isVisible = false;
	  } else {
	    isVisible = !this.isHidden_;
	  }
	  return isVisible;
	};
	
	/**
	 * Shows the InfoBox. [Deprecated; use <tt>setVisible</tt> instead.]
	 */
	InfoBox.prototype.show = function () {
	
	  this.isHidden_ = false;
	  if (this.div_) {
	    this.div_.style.visibility = "visible";
	  }
	};
	
	/**
	 * Hides the InfoBox. [Deprecated; use <tt>setVisible</tt> instead.]
	 */
	InfoBox.prototype.hide = function () {
	
	  this.isHidden_ = true;
	  if (this.div_) {
	    this.div_.style.visibility = "hidden";
	  }
	};
	
	/**
	 * Adds the InfoBox to the specified map or Street View panorama. If <tt>anchor</tt>
	 *  (usually a <tt>google.maps.Marker</tt>) is specified, the position
	 *  of the InfoBox is set to the position of the <tt>anchor</tt>. If the
	 *  anchor is dragged to a new location, the InfoBox moves as well.
	 * @param {Map|StreetViewPanorama} map
	 * @param {MVCObject} [anchor]
	 */
	InfoBox.prototype.open = function (map, anchor) {
	
	  var me = this;
	
	  if (anchor) {
	
	    this.position_ = anchor.getPosition();
	    this.moveListener_ = google.maps.event.addListener(anchor, "position_changed", function () {
	      me.setPosition(this.getPosition());
	    });
	  }
	
	  this.setMap(map);
	
	  if (this.div_) {
	
	    this.panBox_();
	  }
	};
	
	/**
	 * Removes the InfoBox from the map.
	 */
	InfoBox.prototype.close = function () {
	
	  var i;
	
	  if (this.closeListener_) {
	
	    google.maps.event.removeListener(this.closeListener_);
	    this.closeListener_ = null;
	  }
	
	  if (this.eventListeners_) {
	
	    for (i = 0; i < this.eventListeners_.length; i++) {
	
	      google.maps.event.removeListener(this.eventListeners_[i]);
	    }
	    this.eventListeners_ = null;
	  }
	
	  if (this.moveListener_) {
	
	    google.maps.event.removeListener(this.moveListener_);
	    this.moveListener_ = null;
	  }
	
	  if (this.contextListener_) {
	
	    google.maps.event.removeListener(this.contextListener_);
	    this.contextListener_ = null;
	  }
	
	  this.setMap(null);
	};
	
	/**
	 *  google-maps-utility-library-v3-keydragzoom
	 *
	 * @version: 2.0.9
	 * @author: Nianwei Liu [nianwei at gmail dot com] & Gary Little [gary at luxcentral dot com]
	 * @contributors: undefined
	 * @date: Fri May 13 2016 13:45:18 GMT-0400 (EDT)
	 * @license: Apache License 2.0
	 */
	/**
	 * @fileoverview This library adds a drag zoom capability to a V3 Google map.
	 *  When drag zoom is enabled, holding down a designated hot key <code>(shift | ctrl | alt)</code>
	 *  while dragging a box around an area of interest will zoom the map in to that area when
	 *  the mouse button is released. Optionally, a visual control can also be supplied for turning
	 *  a drag zoom operation on and off.
	 *  Only one line of code is needed: <code>google.maps.Map.enableKeyDragZoom();</code>
	 *  <p>
	 *  NOTE: Do not use Ctrl as the hot key with Google Maps JavaScript API V3 since, unlike with V2,
	 *  it causes a context menu to appear when running on the Macintosh.
	 *  <p>
	 *  Note that if the map's container has a border around it, the border widths must be specified
	 *  in pixel units (or as thin, medium, or thick). This is required because of an MSIE limitation.
	 *   <p>NL: 2009-05-28: initial port to core API V3.
	 *  <br>NL: 2009-11-02: added a temp fix for -moz-transform for FF3.5.x using code from Paul Kulchenko (http://notebook.kulchenko.com/maps/gridmove).
	 *  <br>NL: 2010-02-02: added a fix for IE flickering on divs onmousemove, caused by scroll value when get mouse position.
	 *  <br>GL: 2010-06-15: added a visual control option.
	 */
	(function () {
	  /*jslint browser:true */
	  /*global window,google */
	  /* Utility functions use "var funName=function()" syntax to allow use of the */
	  /* Dean Edwards Packer compression tool (with Shrink variables, without Base62 encode). */
	
	  /**
	   * Converts "thin", "medium", and "thick" to pixel widths
	   * in an MSIE environment. Not called for other browsers
	   * because getComputedStyle() returns pixel widths automatically.
	   * @param {string} widthValue The value of the border width parameter.
	   */
	  var toPixels = function (widthValue) {
	    var px;
	    switch (widthValue) {
	    case "thin":
	      px = "2px";
	      break;
	    case "medium":
	      px = "4px";
	      break;
	    case "thick":
	      px = "6px";
	      break;
	    default:
	      px = widthValue;
	    }
	    return px;
	  };
	 /**
	  * Get the widths of the borders of an HTML element.
	  *
	  * @param {Node} h  The HTML element.
	  * @return {Object} The width object {top, bottom left, right}.
	  */
	  var getBorderWidths = function (h) {
	    var computedStyle;
	    var bw = {};
	    if (document.defaultView && document.defaultView.getComputedStyle) {
	      computedStyle = h.ownerDocument.defaultView.getComputedStyle(h, "");
	      if (computedStyle) {
	        // The computed styles are always in pixel units (good!)
	        bw.top = parseInt(computedStyle.borderTopWidth, 10) || 0;
	        bw.bottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
	        bw.left = parseInt(computedStyle.borderLeftWidth, 10) || 0;
	        bw.right = parseInt(computedStyle.borderRightWidth, 10) || 0;
	        return bw;
	      }
	    } else if (document.documentElement.currentStyle) { // MSIE
	      if (h.currentStyle) {
	        // The current styles may not be in pixel units so try to convert (bad!)
	        bw.top = parseInt(toPixels(h.currentStyle.borderTopWidth), 10) || 0;
	        bw.bottom = parseInt(toPixels(h.currentStyle.borderBottomWidth), 10) || 0;
	        bw.left = parseInt(toPixels(h.currentStyle.borderLeftWidth), 10) || 0;
	        bw.right = parseInt(toPixels(h.currentStyle.borderRightWidth), 10) || 0;
	        return bw;
	      }
	    }
	    // Shouldn't get this far for any modern browser
	    bw.top = parseInt(h.style["border-top-width"], 10) || 0;
	    bw.bottom = parseInt(h.style["border-bottom-width"], 10) || 0;
	    bw.left = parseInt(h.style["border-left-width"], 10) || 0;
	    bw.right = parseInt(h.style["border-right-width"], 10) || 0;
	    return bw;
	  };
	
	  // Page scroll values for use by getMousePosition. To prevent flickering on MSIE
	  // they are calculated only when the document actually scrolls, not every time the
	  // mouse moves (as they would be if they were calculated inside getMousePosition).
	  var scroll = {
	    x: 0,
	    y: 0
	  };
	  var getScrollValue = function (e) {
	    scroll.x = (typeof document.documentElement.scrollLeft !== "undefined" ? document.documentElement.scrollLeft : document.body.scrollLeft);
	    scroll.y = (typeof document.documentElement.scrollTop !== "undefined" ? document.documentElement.scrollTop : document.body.scrollTop);
	  };
	  getScrollValue();
	
	  /**
	   * Get the position of the mouse relative to the document.
	   * @param {Event} e  The mouse event.
	   * @return {Object} The position object {left, top}.
	   */
	  var getMousePosition = function (e) {
	    var posX = 0, posY = 0;
	    e = e || window.event;
	    if (typeof e.pageX !== "undefined") {
	      posX = e.pageX;
	      posY = e.pageY;
	    } else if (typeof e.clientX !== "undefined") { // MSIE
	      posX = e.clientX + scroll.x;
	      posY = e.clientY + scroll.y;
	    }
	    return {
	      left: posX,
	      top: posY
	    };
	  };
	  /**
	   * Get the position of an HTML element relative to the document.
	   * @param {Node} h  The HTML element.
	   * @return {Object} The position object {left, top}.
	   */
	  var getElementPosition = function (h) {
	    var posX = h.offsetLeft;
	    var posY = h.offsetTop;
	    var parent = h.offsetParent;
	    // Add offsets for all ancestors in the hierarchy
	    while (parent !== null) {
	      // Adjust for scrolling elements which may affect the map position.
	      //
	      // See http://www.howtocreate.co.uk/tutorials/javascript/browserspecific
	      //
	      // "...make sure that every element [on a Web page] with an overflow
	      // of anything other than visible also has a position style set to
	      // something other than the default static..."
	      if (parent !== document.body && parent !== document.documentElement) {
	        posX -= parent.scrollLeft;
	        posY -= parent.scrollTop;
	      }
	      // See http://groups.google.com/group/google-maps-js-api-v3/browse_thread/thread/4cb86c0c1037a5e5
	      // Example: http://notebook.kulchenko.com/maps/gridmove
	      var m = parent;
	      // This is the "normal" way to get offset information:
	      var moffx = m.offsetLeft;
	      var moffy = m.offsetTop;
	      // This covers those cases where a transform is used:
	      if (!moffx && !moffy && window.getComputedStyle) {
	        var matrix = document.defaultView.getComputedStyle(m, null).MozTransform ||
	        document.defaultView.getComputedStyle(m, null).WebkitTransform;
	        if (matrix) {
	          if (typeof matrix === "string") {
	            var parms = matrix.split(",");
	            moffx += parseInt(parms[4], 10) || 0;
	            moffy += parseInt(parms[5], 10) || 0;
	          }
	        }
	      }
	      posX += moffx;
	      posY += moffy;
	      parent = parent.offsetParent;
	    }
	    return {
	      left: posX,
	      top: posY
	    };
	  };
	  /**
	   * Set the properties of an object to those from another object.
	   * @param {Object} obj The target object.
	   * @param {Object} vals The source object.
	   */
	  var setVals = function (obj, vals) {
	    if (obj && vals) {
	      for (var x in vals) {
	        if (vals.hasOwnProperty(x)) {
	          obj[x] = vals[x];
	        }
	      }
	    }
	    return obj;
	  };
	  /**
	   * Set the opacity. If op is not passed in, this function just performs an MSIE fix.
	   * @param {Node} h The HTML element.
	   * @param {number} op The opacity value (0-1).
	   */
	  var setOpacity = function (h, op) {
	    if (typeof op !== "undefined") {
	      h.style.opacity = op;
	    }
	    if (typeof h.style.opacity !== "undefined" && h.style.opacity !== "") {
	      h.style.filter = "alpha(opacity=" + (h.style.opacity * 100) + ")";
	    }
	  };
	  /**
	   * @name KeyDragZoomOptions
	   * @class This class represents the optional parameter passed into <code>google.maps.Map.enableKeyDragZoom</code>.
	   * @property {string} [key="shift"] The hot key to hold down to activate a drag zoom, <code>shift | ctrl | alt</code>.
	   *  NOTE: Do not use Ctrl as the hot key with Google Maps JavaScript API V3 since, unlike with V2,
	   *  it causes a context menu to appear when running on the Macintosh. Also note that the
	   *  <code>alt</code> hot key refers to the Option key on a Macintosh.
	   * @property {Object} [boxStyle={border: "4px solid #736AFF"}]
	   *  An object literal defining the CSS styles of the zoom box.
	   *  Border widths must be specified in pixel units (or as thin, medium, or thick).
	   * @property {Object} [veilStyle={backgroundColor: "gray", opacity: 0.25, cursor: "crosshair"}]
	   *  An object literal defining the CSS styles of the veil pane which covers the map when a drag
	   *  zoom is activated. The previous name for this property was <code>paneStyle</code> but the use
	   *  of this name is now deprecated.
	   * @property {boolean} [noZoom=false] A flag indicating whether to disable zooming after an area is
	   *  selected. Set this to <code>true</code> to allow KeyDragZoom to be used as a simple area
	   *  selection tool.
	   * @property {boolean} [visualEnabled=false] A flag indicating whether a visual control is to be used.
	   * @property {string} [visualClass=""] The name of the CSS class defining the styles for the visual
	   *  control. To prevent the visual control from being printed, set this property to the name of
	   *  a class, defined inside a <code>@media print</code> rule, which sets the CSS
	   *  <code>display</code> style to <code>none</code>.
	   * @property {ControlPosition} [visualPosition=google.maps.ControlPosition.LEFT_TOP]
	   *  The position of the visual control.
	   * @property {Size} [visualPositionOffset=google.maps.Size(35, 0)] The width and height values
	   *  provided by this property are the offsets (in pixels) from the location at which the control
	   *  would normally be drawn to the desired drawing location.
	   * @property {number} [visualPositionIndex=null] The index of the visual control.
	   *  The index is for controlling the placement of the control relative to other controls at the
	   *  position given by <code>visualPosition</code>; controls with a lower index are placed first.
	   *  Use a negative value to place the control <i>before</i> any default controls. No index is
	   *  generally required.
	   * @property {String} [visualSprite="http://maps.gstatic.com/mapfiles/ftr/controls/dragzoom_btn.png"]
	   *  The URL of the sprite image used for showing the visual control in the on, off, and hot
	   *  (i.e., when the mouse is over the control) states. The three images within the sprite must
	   *  be the same size and arranged in on-hot-off order in a single row with no spaces between images.
	   * @property {Size} [visualSize=google.maps.Size(20, 20)] The width and height values provided by
	   *  this property are the size (in pixels) of each of the images within <code>visualSprite</code>.
	   * @property {Object} [visualTips={off: "Turn on drag zoom mode", on: "Turn off drag zoom mode"}]
	   *  An object literal defining the help tips that appear when
	   *  the mouse moves over the visual control. The <code>off</code> property is the tip to be shown
	   *  when the control is off and the <code>on</code> property is the tip to be shown when the
	   *  control is on.
	   */
	  /**
	   * @name DragZoom
	   * @class This class represents a drag zoom object for a map. The object is activated by holding down the hot key
	   * or by turning on the visual control.
	   * This object is created when <code>google.maps.Map.enableKeyDragZoom</code> is called; it cannot be created directly.
	   * Use <code>google.maps.Map.getDragZoomObject</code> to gain access to this object in order to attach event listeners.
	   * @param {Map} map The map to which the DragZoom object is to be attached.
	   * @param {KeyDragZoomOptions} [opt_zoomOpts] The optional parameters.
	   */
	  function DragZoom(map, opt_zoomOpts) {
	    var me = this;
	    var ov = new google.maps.OverlayView();
	    ov.onAdd = function () {
	      me.init_(map, opt_zoomOpts);
	    };
	    ov.draw = function () {
	    };
	    ov.onRemove = function () {
	    };
	    ov.setMap(map);
	    this.prjov_ = ov;
	  }
	  /**
	   * Initialize the tool.
	   * @param {Map} map The map to which the DragZoom object is to be attached.
	   * @param {KeyDragZoomOptions} [opt_zoomOpts] The optional parameters.
	   */
	  DragZoom.prototype.init_ = function (map, opt_zoomOpts) {
	    var i;
	    var me = this;
	    this.map_ = map;
	    opt_zoomOpts = opt_zoomOpts || {};
	    this.key_ = opt_zoomOpts.key || "shift";
	    this.key_ = this.key_.toLowerCase();
	    this.borderWidths_ = getBorderWidths(this.map_.getDiv());
	    this.veilDiv_ = [];
	    for (i = 0; i < 4; i++) {
	      this.veilDiv_[i] = document.createElement("div");
	      // Prevents selection of other elements on the webpage
	      // when a drag zoom operation is in progress:
	      this.veilDiv_[i].onselectstart = function () {
	        return false;
	      };
	      // Apply default style values for the veil:
	      setVals(this.veilDiv_[i].style, {
	        backgroundColor: "gray",
	        opacity: 0.25,
	        cursor: "crosshair"
	      });
	      // Apply style values specified in veilStyle parameter:
	      setVals(this.veilDiv_[i].style, opt_zoomOpts.paneStyle); // Old option name was "paneStyle"
	      setVals(this.veilDiv_[i].style, opt_zoomOpts.veilStyle); // New name is "veilStyle"
	      // Apply mandatory style values:
	      setVals(this.veilDiv_[i].style, {
	        position: "absolute",
	        overflow: "hidden",
	        display: "none"
	      });
	      // Workaround for Firefox Shift-Click problem:
	      if (this.key_ === "shift") {
	        this.veilDiv_[i].style.MozUserSelect = "none";
	      }
	      setOpacity(this.veilDiv_[i]);
	      // An IE fix: If the background is transparent it cannot capture mousedown
	      // events, so if it is, change the background to white with 0 opacity.
	      if (this.veilDiv_[i].style.backgroundColor === "transparent") {
	        this.veilDiv_[i].style.backgroundColor = "white";
	        setOpacity(this.veilDiv_[i], 0);
	      }
	      this.map_.getDiv().appendChild(this.veilDiv_[i]);
	    }
	
	    this.noZoom_ = opt_zoomOpts.noZoom || false;
	    this.visualEnabled_ = opt_zoomOpts.visualEnabled || false;
	    this.visualClass_ = opt_zoomOpts.visualClass || "";
	    this.visualPosition_ = opt_zoomOpts.visualPosition || google.maps.ControlPosition.LEFT_TOP;
	    this.visualPositionOffset_ = opt_zoomOpts.visualPositionOffset || new google.maps.Size(35, 0);
	    this.visualPositionIndex_ = opt_zoomOpts.visualPositionIndex || null;
	    this.visualSprite_ = opt_zoomOpts.visualSprite || "http" + (document.location.protocol === "https:" ? "s" : "") + "://maps.gstatic.com/mapfiles/ftr/controls/dragzoom_btn.png";
	    this.visualSize_ = opt_zoomOpts.visualSize || new google.maps.Size(20, 20);
	    this.visualTips_ = opt_zoomOpts.visualTips || {};
	    this.visualTips_.off =  this.visualTips_.off || "Turn on drag zoom mode";
	    this.visualTips_.on =  this.visualTips_.on || "Turn off drag zoom mode";
	
	    this.boxDiv_ = document.createElement("div");
	    // Apply default style values for the zoom box:
	    setVals(this.boxDiv_.style, {
	      border: "4px solid #736AFF"
	    });
	    // Apply style values specified in boxStyle parameter:
	    setVals(this.boxDiv_.style, opt_zoomOpts.boxStyle);
	    // Apply mandatory style values:
	    setVals(this.boxDiv_.style, {
	      position: "absolute",
	      display: "none"
	    });
	    setOpacity(this.boxDiv_);
	    this.map_.getDiv().appendChild(this.boxDiv_);
	    this.boxBorderWidths_ = getBorderWidths(this.boxDiv_);
	
	    this.listeners_ = [
	      google.maps.event.addDomListener(document, "keydown", function (e) {
	        me.onKeyDown_(e);
	      }),
	      google.maps.event.addDomListener(document, "keyup", function (e) {
	        me.onKeyUp_(e);
	      }),
	      google.maps.event.addDomListener(this.veilDiv_[0], "mousedown", function (e) {
	        me.onMouseDown_(e);
	      }),
	      google.maps.event.addDomListener(this.veilDiv_[1], "mousedown", function (e) {
	        me.onMouseDown_(e);
	      }),
	      google.maps.event.addDomListener(this.veilDiv_[2], "mousedown", function (e) {
	        me.onMouseDown_(e);
	      }),
	      google.maps.event.addDomListener(this.veilDiv_[3], "mousedown", function (e) {
	        me.onMouseDown_(e);
	      }),
	      google.maps.event.addDomListener(document, "mousedown", function (e) {
	        me.onMouseDownDocument_(e);
	      }),
	      google.maps.event.addDomListener(document, "mousemove", function (e) {
	        me.onMouseMove_(e);
	      }),
	      google.maps.event.addDomListener(document, "mouseup", function (e) {
	        me.onMouseUp_(e);
	      }),
	      google.maps.event.addDomListener(window, "scroll", getScrollValue)
	    ];
	
	    this.hotKeyDown_ = false;
	    this.mouseDown_ = false;
	    this.dragging_ = false;
	    this.startPt_ = null;
	    this.endPt_ = null;
	    this.mapWidth_ = null;
	    this.mapHeight_ = null;
	    this.mousePosn_ = null;
	    this.mapPosn_ = null;
	
	    if (this.visualEnabled_) {
	      this.buttonDiv_ = this.initControl_(this.visualPositionOffset_);
	      if (this.visualPositionIndex_ !== null) {
	        this.buttonDiv_.index = this.visualPositionIndex_;
	      }
	      this.map_.controls[this.visualPosition_].push(this.buttonDiv_);
	      this.controlIndex_ = this.map_.controls[this.visualPosition_].length - 1;
	    }
	  };
	  /**
	   * Initializes the visual control and returns its DOM element.
	   * @param {Size} offset The offset of the control from its normal position.
	   * @return {Node} The DOM element containing the visual control.
	   */
	  DragZoom.prototype.initControl_ = function (offset) {
	    var control;
	    var image;
	    var me = this;
	
	    control = document.createElement("div");
	    control.className = this.visualClass_;
	    control.style.position = "relative";
	    control.style.overflow = "hidden";
	    control.style.height = this.visualSize_.height + "px";
	    control.style.width = this.visualSize_.width + "px";
	    control.title = this.visualTips_.off;
	    image = document.createElement("img");
	    image.src = this.visualSprite_;
	    image.style.position = "absolute";
	    image.style.left = -(this.visualSize_.width * 2) + "px";
	    image.style.top = 0 + "px";
	    control.appendChild(image);
	    control.onclick = function (e) {
	      me.hotKeyDown_ = !me.hotKeyDown_;
	      if (me.hotKeyDown_) {
	        me.buttonDiv_.firstChild.style.left = -(me.visualSize_.width * 0) + "px";
	        me.buttonDiv_.title = me.visualTips_.on;
	        me.activatedByControl_ = true;
	        google.maps.event.trigger(me, "activate");
	      } else {
	        me.buttonDiv_.firstChild.style.left = -(me.visualSize_.width * 2) + "px";
	        me.buttonDiv_.title = me.visualTips_.off;
	        google.maps.event.trigger(me, "deactivate");
	      }
	      me.onMouseMove_(e); // Updates the veil
	    };
	    control.onmouseover = function () {
	      me.buttonDiv_.firstChild.style.left = -(me.visualSize_.width * 1) + "px";
	    };
	    control.onmouseout = function () {
	      if (me.hotKeyDown_) {
	        me.buttonDiv_.firstChild.style.left = -(me.visualSize_.width * 0) + "px";
	        me.buttonDiv_.title = me.visualTips_.on;
	      } else {
	        me.buttonDiv_.firstChild.style.left = -(me.visualSize_.width * 2) + "px";
	        me.buttonDiv_.title = me.visualTips_.off;
	      }
	    };
	    control.ondragstart = function () {
	      return false;
	    };
	    setVals(control.style, {
	      cursor: "pointer",
	      marginTop: offset.height + "px",
	      marginLeft: offset.width + "px"
	    });
	    return control;
	  };
	  /**
	   * Returns <code>true</code> if the hot key is being pressed when an event occurs.
	   * @param {Event} e The keyboard event.
	   * @return {boolean} Flag indicating whether the hot key is down.
	   */
	  DragZoom.prototype.isHotKeyDown_ = function (e) {
	    var isHot;
	    e = e || window.event;
	    isHot = (e.shiftKey && this.key_ === "shift") || (e.altKey && this.key_ === "alt") || (e.ctrlKey && this.key_ === "ctrl");
	    if (!isHot) {
	      // Need to look at keyCode for Opera because it
	      // doesn't set the shiftKey, altKey, ctrlKey properties
	      // unless a non-modifier event is being reported.
	      //
	      // See http://cross-browser.com/x/examples/shift_mode.php
	      // Also see http://unixpapa.com/js/key.html
	      switch (e.keyCode) {
	      case 16:
	        if (this.key_ === "shift") {
	          isHot = true;
	        }
	        break;
	      case 17:
	        if (this.key_ === "ctrl") {
	          isHot = true;
	        }
	        break;
	      case 18:
	        if (this.key_ === "alt") {
	          isHot = true;
	        }
	        break;
	      }
	    }
	    return isHot;
	  };
	  /**
	   * Returns <code>true</code> if the mouse is on top of the map div.
	   * The position is captured in onMouseMove_.
	   * @return {boolean}
	   */
	  DragZoom.prototype.isMouseOnMap_ = function () {
	    var mousePosn = this.mousePosn_;
	    if (mousePosn) {
	      var mapPosn = this.mapPosn_;
	      var mapDiv = this.map_.getDiv();
	      return mousePosn.left > mapPosn.left && mousePosn.left < (mapPosn.left + mapDiv.offsetWidth) &&
	      mousePosn.top > mapPosn.top && mousePosn.top < (mapPosn.top + mapDiv.offsetHeight);
	    } else {
	      // if user never moved mouse
	      return false;
	    }
	  };
	  /**
	   * Show the veil if the hot key is down and the mouse is over the map,
	   * otherwise hide the veil.
	   */
	  DragZoom.prototype.setVeilVisibility_ = function () {
	    var i;
	    if (this.map_ && this.hotKeyDown_ && this.isMouseOnMap_()) {
	      var mapDiv = this.map_.getDiv();
	      this.mapWidth_ = mapDiv.offsetWidth - (this.borderWidths_.left + this.borderWidths_.right);
	      this.mapHeight_ = mapDiv.offsetHeight - (this.borderWidths_.top + this.borderWidths_.bottom);
	      if (this.activatedByControl_) { // Veil covers entire map (except control)
	        var left = parseInt(this.buttonDiv_.style.left, 10) + this.visualPositionOffset_.width;
	        var top = parseInt(this.buttonDiv_.style.top, 10) + this.visualPositionOffset_.height;
	        var width = this.visualSize_.width;
	        var height = this.visualSize_.height;
	        // Left veil rectangle:
	        this.veilDiv_[0].style.top = "0px";
	        this.veilDiv_[0].style.left = "0px";
	        this.veilDiv_[0].style.width = left + "px";
	        this.veilDiv_[0].style.height = this.mapHeight_ + "px";
	        // Right veil rectangle:
	        this.veilDiv_[1].style.top = "0px";
	        this.veilDiv_[1].style.left = (left + width) + "px";
	        this.veilDiv_[1].style.width = (this.mapWidth_ - (left + width)) + "px";
	        this.veilDiv_[1].style.height = this.mapHeight_ + "px";
	        // Top veil rectangle:
	        this.veilDiv_[2].style.top = "0px";
	        this.veilDiv_[2].style.left = left + "px";
	        this.veilDiv_[2].style.width = width + "px";
	        this.veilDiv_[2].style.height = top + "px";
	        // Bottom veil rectangle:
	        this.veilDiv_[3].style.top = (top + height) + "px";
	        this.veilDiv_[3].style.left = left + "px";
	        this.veilDiv_[3].style.width = width + "px";
	        this.veilDiv_[3].style.height = (this.mapHeight_ - (top + height)) + "px";
	        for (i = 0; i < this.veilDiv_.length; i++) {
	          this.veilDiv_[i].style.display = "block";
	        }
	      } else {
	        this.veilDiv_[0].style.left = "0px";
	        this.veilDiv_[0].style.top = "0px";
	        this.veilDiv_[0].style.width = this.mapWidth_ + "px";
	        this.veilDiv_[0].style.height = this.mapHeight_ + "px";
	        for (i = 1; i < this.veilDiv_.length; i++) {
	          this.veilDiv_[i].style.width = "0px";
	          this.veilDiv_[i].style.height = "0px";
	        }
	        for (i = 0; i < this.veilDiv_.length; i++) {
	          this.veilDiv_[i].style.display = "block";
	        }
	      }
	    } else {
	      for (i = 0; i < this.veilDiv_.length; i++) {
	        this.veilDiv_[i].style.display = "none";
	      }
	    }
	  };
	  /**
	   * Handle key down. Show the veil if the hot key has been pressed.
	   * @param {Event} e The keyboard event.
	   */
	  DragZoom.prototype.onKeyDown_ = function (e) {
	    if (this.map_ && !this.hotKeyDown_ && this.isHotKeyDown_(e)) {
	      this.mapPosn_ = getElementPosition(this.map_.getDiv());
	      this.hotKeyDown_ = true;
	      this.activatedByControl_ = false;
	      this.setVeilVisibility_();
	     /**
	       * This event is fired when the hot key is pressed.
	       * @name DragZoom#activate
	       * @event
	       */
	      google.maps.event.trigger(this, "activate");
	    }
	  };
	  /**
	   * Get the <code>google.maps.Point</code> of the mouse position.
	   * @param {Event} e The mouse event.
	   * @return {Point} The mouse position.
	   */
	  DragZoom.prototype.getMousePoint_ = function (e) {
	    var mousePosn = getMousePosition(e);
	    var p = new google.maps.Point();
	    p.x = mousePosn.left - this.mapPosn_.left - this.borderWidths_.left;
	    p.y = mousePosn.top - this.mapPosn_.top - this.borderWidths_.top;
	    p.x = Math.min(p.x, this.mapWidth_);
	    p.y = Math.min(p.y, this.mapHeight_);
	    p.x = Math.max(p.x, 0);
	    p.y = Math.max(p.y, 0);
	    return p;
	  };
	  /**
	   * Handle mouse down.
	   * @param {Event} e The mouse event.
	   */
	  DragZoom.prototype.onMouseDown_ = function (e) {
	    if (this.map_ && this.hotKeyDown_) {
	      this.mapPosn_ = getElementPosition(this.map_.getDiv());
	      this.dragging_ = true;
	      this.startPt_ = this.endPt_ = this.getMousePoint_(e);
	      this.boxDiv_.style.width = this.boxDiv_.style.height = "0px";
	      var prj = this.prjov_.getProjection();
	      var latlng = prj.fromContainerPixelToLatLng(this.startPt_);
	      /**
	       * This event is fired when the drag operation begins.
	       * The parameter passed is the geographic position of the starting point.
	       * @name DragZoom#dragstart
	       * @param {LatLng} latlng The geographic position of the starting point.
	       * @event
	       */
	      google.maps.event.trigger(this, "dragstart", latlng);
	    }
	  };
	  /**
	   * Handle mouse down at the document level.
	   * @param {Event} e The mouse event.
	   */
	  DragZoom.prototype.onMouseDownDocument_ = function (e) {
	    this.mouseDown_ = true;
	  };
	  /**
	   * Handle mouse move.
	   * @param {Event} e The mouse event.
	   */
	  DragZoom.prototype.onMouseMove_ = function (e) {
	    this.mousePosn_ = getMousePosition(e);
	    if (this.dragging_) {
	      this.endPt_ = this.getMousePoint_(e);
	      var left = Math.min(this.startPt_.x, this.endPt_.x);
	      var top = Math.min(this.startPt_.y, this.endPt_.y);
	      var width = Math.abs(this.startPt_.x - this.endPt_.x);
	      var height = Math.abs(this.startPt_.y - this.endPt_.y);
	      // For benefit of MSIE 7/8 ensure following values are not negative:
	      var boxWidth = Math.max(0, width - (this.boxBorderWidths_.left + this.boxBorderWidths_.right));
	      var boxHeight = Math.max(0, height - (this.boxBorderWidths_.top + this.boxBorderWidths_.bottom));
	      // Left veil rectangle:
	      this.veilDiv_[0].style.top = "0px";
	      this.veilDiv_[0].style.left = "0px";
	      this.veilDiv_[0].style.width = left + "px";
	      this.veilDiv_[0].style.height = this.mapHeight_ + "px";
	      // Right veil rectangle:
	      this.veilDiv_[1].style.top = "0px";
	      this.veilDiv_[1].style.left = (left + width) + "px";
	      this.veilDiv_[1].style.width = (this.mapWidth_ - (left + width)) + "px";
	      this.veilDiv_[1].style.height = this.mapHeight_ + "px";
	      // Top veil rectangle:
	      this.veilDiv_[2].style.top = "0px";
	      this.veilDiv_[2].style.left = left + "px";
	      this.veilDiv_[2].style.width = width + "px";
	      this.veilDiv_[2].style.height = top + "px";
	      // Bottom veil rectangle:
	      this.veilDiv_[3].style.top = (top + height) + "px";
	      this.veilDiv_[3].style.left = left + "px";
	      this.veilDiv_[3].style.width = width + "px";
	      this.veilDiv_[3].style.height = (this.mapHeight_ - (top + height)) + "px";
	      // Selection rectangle:
	      this.boxDiv_.style.top = top + "px";
	      this.boxDiv_.style.left = left + "px";
	      this.boxDiv_.style.width = boxWidth + "px";
	      this.boxDiv_.style.height = boxHeight + "px";
	      this.boxDiv_.style.display = "block";
	      /**
	       * This event is fired repeatedly while the user drags a box across the area of interest.
	       * The southwest and northeast point are passed as parameters of type <code>google.maps.Point</code>
	       * (for performance reasons), relative to the map container. Also passed is the projection object
	       * so that the event listener, if necessary, can convert the pixel positions to geographic
	       * coordinates using <code>google.maps.MapCanvasProjection.fromContainerPixelToLatLng</code>.
	       * @name DragZoom#drag
	       * @param {Point} southwestPixel The southwest point of the selection area.
	       * @param {Point} northeastPixel The northeast point of the selection area.
	       * @param {MapCanvasProjection} prj The projection object.
	       * @event
	       */
	      google.maps.event.trigger(this, "drag", new google.maps.Point(left, top + height), new google.maps.Point(left + width, top), this.prjov_.getProjection());
	    } else if (!this.mouseDown_) {
	      this.mapPosn_ = getElementPosition(this.map_.getDiv());
	      this.setVeilVisibility_();
	    }
	  };
	  /**
	   * Handle mouse up.
	   * @param {Event} e The mouse event.
	   */
	  DragZoom.prototype.onMouseUp_ = function (e) {
	    var z;
	    var me = this;
	    this.mouseDown_ = false;
	    if (this.dragging_) {
	      if ((this.getMousePoint_(e).x === this.startPt_.x) && (this.getMousePoint_(e).y === this.startPt_.y)) {
	        this.onKeyUp_(e); // Cancel event
	        return;
	      }
	      var left = Math.min(this.startPt_.x, this.endPt_.x);
	      var top = Math.min(this.startPt_.y, this.endPt_.y);
	      var width = Math.abs(this.startPt_.x - this.endPt_.x);
	      var height = Math.abs(this.startPt_.y - this.endPt_.y);
	      // Google Maps API bug: setCenter() doesn't work as expected if the map has a
	      // border on the left or top. The code here includes a workaround for this problem.
	      var kGoogleCenteringBug = true;
	      if (kGoogleCenteringBug) {
	        left += this.borderWidths_.left;
	        top += this.borderWidths_.top;
	      }
	
	      var prj = this.prjov_.getProjection();
	      var sw = prj.fromContainerPixelToLatLng(new google.maps.Point(left, top + height));
	      var ne = prj.fromContainerPixelToLatLng(new google.maps.Point(left + width, top));
	      var bnds = new google.maps.LatLngBounds(sw, ne);
	
	      if (this.noZoom_) {
	        this.boxDiv_.style.display = "none";
	      } else {
	        // Sometimes fitBounds causes a zoom OUT, so restore original zoom level if this happens.
	        z = this.map_.getZoom();
	        this.map_.fitBounds(bnds);
	        if (this.map_.getZoom() < z) {
	          this.map_.setZoom(z);
	        }
	
	        // Redraw box after zoom:
	        var swPt = prj.fromLatLngToContainerPixel(sw);
	        var nePt = prj.fromLatLngToContainerPixel(ne);
	        if (kGoogleCenteringBug) {
	          swPt.x -= this.borderWidths_.left;
	          swPt.y -= this.borderWidths_.top;
	          nePt.x -= this.borderWidths_.left;
	          nePt.y -= this.borderWidths_.top;
	        }
	        this.boxDiv_.style.left = swPt.x + "px";
	        this.boxDiv_.style.top = nePt.y + "px";
	        this.boxDiv_.style.width = (Math.abs(nePt.x - swPt.x) - (this.boxBorderWidths_.left + this.boxBorderWidths_.right)) + "px";
	        this.boxDiv_.style.height = (Math.abs(nePt.y - swPt.y) - (this.boxBorderWidths_.top + this.boxBorderWidths_.bottom)) + "px";
	        // Hide box asynchronously after 1 second:
	        setTimeout(function () {
	          me.boxDiv_.style.display = "none";
	        }, 1000);
	      }
	      this.dragging_ = false;
	      this.onMouseMove_(e); // Updates the veil
	      /**
	       * This event is fired when the drag operation ends.
	       * The parameter passed is the geographic bounds of the selected area.
	       * Note that this event is <i>not</i> fired if the hot key is released before the drag operation ends.
	       * @name DragZoom#dragend
	       * @param {LatLngBounds} bnds The geographic bounds of the selected area.
	       * @event
	       */
	      google.maps.event.trigger(this, "dragend", bnds);
	      // if the hot key isn't down, the drag zoom must have been activated by turning
	      // on the visual control. In this case, finish up by simulating a key up event.
	      if (!this.isHotKeyDown_(e)) {
	        this.onKeyUp_(e);
	      }
	    }
	  };
	  /**
	   * Handle key up.
	   * @param {Event} e The keyboard event.
	   */
	  DragZoom.prototype.onKeyUp_ = function (e) {
	    var i;
	    var left, top, width, height, prj, sw, ne;
	    var bnds = null;
	    if (this.map_ && this.hotKeyDown_) {
	      this.hotKeyDown_ = false;
	      if (this.dragging_) {
	        this.boxDiv_.style.display = "none";
	        this.dragging_ = false;
	        // Calculate the bounds when drag zoom was cancelled
	        left = Math.min(this.startPt_.x, this.endPt_.x);
	        top = Math.min(this.startPt_.y, this.endPt_.y);
	        width = Math.abs(this.startPt_.x - this.endPt_.x);
	        height = Math.abs(this.startPt_.y - this.endPt_.y);
	        prj = this.prjov_.getProjection();
	        sw = prj.fromContainerPixelToLatLng(new google.maps.Point(left, top + height));
	        ne = prj.fromContainerPixelToLatLng(new google.maps.Point(left + width, top));
	        bnds = new google.maps.LatLngBounds(sw, ne);
	      }
	      for (i = 0; i < this.veilDiv_.length; i++) {
	        this.veilDiv_[i].style.display = "none";
	      }
	      if (this.visualEnabled_) {
	        this.buttonDiv_.firstChild.style.left = -(this.visualSize_.width * 2) + "px";
	        this.buttonDiv_.title = this.visualTips_.off;
	        this.buttonDiv_.style.display = "";
	      }
	      /**
	       * This event is fired when the hot key is released.
	       * The parameter passed is the geographic bounds of the selected area immediately
	       * before the hot key was released.
	       * @name DragZoom#deactivate
	       * @param {LatLngBounds} bnds The geographic bounds of the selected area immediately
	       *  before the hot key was released.
	       * @event
	       */
	      google.maps.event.trigger(this, "deactivate", bnds);
	    }
	  };
	  /**
	   * @name google.maps.Map
	   * @class These are new methods added to the Google Maps JavaScript API V3's
	   * <a href="http://code.google.com/apis/maps/documentation/javascript/reference.html#Map">Map</a>
	   * class.
	   */
	  /**
	   * Enables drag zoom. The user can zoom to an area of interest by holding down the hot key
	   * <code>(shift | ctrl | alt )</code> while dragging a box around the area or by turning
	   * on the visual control then dragging a box around the area.
	   * @param {KeyDragZoomOptions} opt_zoomOpts The optional parameters.
	   */
	  google.maps.Map.prototype.enableKeyDragZoom = function (opt_zoomOpts) {
	    this.dragZoom_ = new DragZoom(this, opt_zoomOpts);
	  };
	  /**
	   * Disables drag zoom.
	   */
	  google.maps.Map.prototype.disableKeyDragZoom = function () {
	    var i;
	    var d = this.dragZoom_;
	    if (d) {
	      for (i = 0; i < d.listeners_.length; ++i) {
	        google.maps.event.removeListener(d.listeners_[i]);
	      }
	      this.getDiv().removeChild(d.boxDiv_);
	      for (i = 0; i < d.veilDiv_.length; i++) {
	        this.getDiv().removeChild(d.veilDiv_[i]);
	      }
	      if (d.visualEnabled_) {
	        // Remove the custom control:
	        this.controls[d.visualPosition_].removeAt(d.controlIndex_);
	      }
	      d.prjov_.setMap(null);
	      this.dragZoom_ = null;
	    }
	  };
	  /**
	   * Returns <code>true</code> if the drag zoom feature has been enabled.
	   * @return {boolean}
	   */
	  google.maps.Map.prototype.keyDragZoomEnabled = function () {
	    return this.dragZoom_ !== null;
	  };
	  /**
	   * Returns the DragZoom object which is created when <code>google.maps.Map.enableKeyDragZoom</code> is called.
	   * With this object you can use <code>google.maps.event.addListener</code> to attach event listeners
	   * for the "activate", "deactivate", "dragstart", "drag", and "dragend" events.
	   * @return {DragZoom}
	   */
	  google.maps.Map.prototype.getDragZoomObject = function () {
	    return this.dragZoom_;
	  };
	})();
	
	/**
	 *  google-maps-utility-library-v3-markerwithlabel
	 *
	 * @version: 1.1.10
	 * @author: Gary Little (inspired by code from Marc Ridey of Google).
	 * @contributors: Nicholas McCready
	 * @date: Fri May 13 2016 16:29:58 GMT-0400 (EDT)
	 * @license: Apache License 2.0
	 */
	/**
	 *  MarkerWithLabel allows you to define markers with associated labels. As you would expect,
	 *  if the marker is draggable, so too will be the label. In addition, a marker with a label
	 *  responds to all mouse events in the same manner as a regular marker. It also fires mouse
	 *  events and "property changed" events just as a regular marker would. Version 1.1 adds
	 *  support for the raiseOnDrag feature introduced in API V3.3.
	 *  <p>
	 *  If you drag a marker by its label, you can cancel the drag and return the marker to its
	 *  original position by pressing the <code>Esc</code> key. This doesn't work if you drag the marker
	 *  itself because this feature is not (yet) supported in the <code>google.maps.Marker</code> class.
	 */
	
	/*jslint browser:true */
	/*global document,google */
	
	/**
	 * @param {Function} childCtor Child class.
	 * @param {Function} parentCtor Parent class.
	 * @private
	 */
	function inherits(childCtor, parentCtor) {
	  /* @constructor */
	  function tempCtor() {}
	  tempCtor.prototype = parentCtor.prototype;
	  childCtor.superClass_ = parentCtor.prototype;
	  childCtor.prototype = new tempCtor();
	  /* @override */
	  childCtor.prototype.constructor = childCtor;
	}
	
	/**
	 * This constructor creates a label and associates it with a marker.
	 * It is for the private use of the MarkerWithLabel class.
	 * @constructor
	 * @param {Marker} marker The marker with which the label is to be associated.
	 * @param {string} crossURL The URL of the cross image =.
	 * @param {string} handCursor The URL of the hand cursor.
	 * @private
	 */
	function MarkerLabel_(marker, crossURL, handCursorURL) {
	  this.marker_ = marker;
	  this.handCursorURL_ = marker.handCursorURL;
	
	  this.labelDiv_ = document.createElement("div");
	  this.labelDiv_.style.cssText = "position: absolute; overflow: hidden;";
	
	  // Set up the DIV for handling mouse events in the label. This DIV forms a transparent veil
	  // in the "overlayMouseTarget" pane, a veil that covers just the label. This is done so that
	  // events can be captured even if the label is in the shadow of a google.maps.InfoWindow.
	  // Code is included here to ensure the veil is always exactly the same size as the label.
	  this.eventDiv_ = document.createElement("div");
	  this.eventDiv_.style.cssText = this.labelDiv_.style.cssText;
	
	  // This is needed for proper behavior on MSIE:
	  this.eventDiv_.setAttribute("onselectstart", "return false;");
	  this.eventDiv_.setAttribute("ondragstart", "return false;");
	
	  // Get the DIV for the "X" to be displayed when the marker is raised.
	  this.crossDiv_ = MarkerLabel_.getSharedCross(crossURL);
	}
	
	inherits(MarkerLabel_, google.maps.OverlayView);
	
	/**
	 * Returns the DIV for the cross used when dragging a marker when the
	 * raiseOnDrag parameter set to true. One cross is shared with all markers.
	 * @param {string} crossURL The URL of the cross image =.
	 * @private
	 */
	MarkerLabel_.getSharedCross = function (crossURL) {
	  var div;
	  if (typeof MarkerLabel_.getSharedCross.crossDiv === "undefined") {
	    div = document.createElement("img");
	    div.style.cssText = "position: absolute; z-index: 1000002; display: none;";
	    // Hopefully Google never changes the standard "X" attributes:
	    div.style.marginLeft = "-8px";
	    div.style.marginTop = "-9px";
	    div.src = crossURL;
	    MarkerLabel_.getSharedCross.crossDiv = div;
	  }
	  return MarkerLabel_.getSharedCross.crossDiv;
	};
	
	/**
	 * Adds the DIV representing the label to the DOM. This method is called
	 * automatically when the marker's <code>setMap</code> method is called.
	 * @private
	 */
	MarkerLabel_.prototype.onAdd = function () {
	  var me = this;
	  var cMouseIsDown = false;
	  var cDraggingLabel = false;
	  var cSavedZIndex;
	  var cLatOffset, cLngOffset;
	  var cIgnoreClick;
	  var cRaiseEnabled;
	  var cStartPosition;
	  var cStartCenter;
	  // Constants:
	  var cRaiseOffset = 20;
	  var cDraggingCursor = "url(" + this.handCursorURL_ + ")";
	
	  // Stops all processing of an event.
	  //
	  var cAbortEvent = function (e) {
	    if (e.preventDefault) {
	      e.preventDefault();
	    }
	    e.cancelBubble = true;
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    }
	  };
	
	  var cStopBounce = function () {
	    me.marker_.setAnimation(null);
	  };
	
	  this.getPanes().overlayImage.appendChild(this.labelDiv_);
	  this.getPanes().overlayMouseTarget.appendChild(this.eventDiv_);
	  // One cross is shared with all markers, so only add it once:
	  if (typeof MarkerLabel_.getSharedCross.processed === "undefined") {
	    this.getPanes().overlayImage.appendChild(this.crossDiv_);
	    MarkerLabel_.getSharedCross.processed = true;
	  }
	
	  this.listeners_ = [
	    google.maps.event.addDomListener(this.eventDiv_, "mouseover", function (e) {
	      if (me.marker_.getDraggable() || me.marker_.getClickable()) {
	        this.style.cursor = "pointer";
	        google.maps.event.trigger(me.marker_, "mouseover", e);
	      }
	    }),
	    google.maps.event.addDomListener(this.eventDiv_, "mouseout", function (e) {
	      if ((me.marker_.getDraggable() || me.marker_.getClickable()) && !cDraggingLabel) {
	        this.style.cursor = me.marker_.getCursor();
	        google.maps.event.trigger(me.marker_, "mouseout", e);
	      }
	    }),
	    google.maps.event.addDomListener(this.eventDiv_, "mousedown", function (e) {
	      cDraggingLabel = false;
	      if (me.marker_.getDraggable()) {
	        cMouseIsDown = true;
	        this.style.cursor = cDraggingCursor;
	      }
	      if (me.marker_.getDraggable() || me.marker_.getClickable()) {
	        google.maps.event.trigger(me.marker_, "mousedown", e);
	        cAbortEvent(e); // Prevent map pan when starting a drag on a label
	      }
	    }),
	    google.maps.event.addDomListener(document, "mouseup", function (mEvent) {
	      var position;
	      if (cMouseIsDown) {
	        cMouseIsDown = false;
	        me.eventDiv_.style.cursor = "pointer";
	        google.maps.event.trigger(me.marker_, "mouseup", mEvent);
	      }
	      if (cDraggingLabel) {
	        if (cRaiseEnabled) { // Lower the marker & label
	          position = me.getProjection().fromLatLngToDivPixel(me.marker_.getPosition());
	          position.y += cRaiseOffset;
	          me.marker_.setPosition(me.getProjection().fromDivPixelToLatLng(position));
	          // This is not the same bouncing style as when the marker portion is dragged,
	          // but it will have to do:
	          try { // Will fail if running Google Maps API earlier than V3.3
	            me.marker_.setAnimation(google.maps.Animation.BOUNCE);
	            setTimeout(cStopBounce, 1406);
	          } catch (e) {}
	        }
	        me.crossDiv_.style.display = "none";
	        me.marker_.setZIndex(cSavedZIndex);
	        cIgnoreClick = true; // Set flag to ignore the click event reported after a label drag
	        cDraggingLabel = false;
	        mEvent.latLng = me.marker_.getPosition();
	        google.maps.event.trigger(me.marker_, "dragend", mEvent);
	      }
	    }),
	    google.maps.event.addListener(me.marker_.getMap(), "mousemove", function (mEvent) {
	      var position;
	      if (cMouseIsDown) {
	        if (cDraggingLabel) {
	          // Change the reported location from the mouse position to the marker position:
	          mEvent.latLng = new google.maps.LatLng(mEvent.latLng.lat() - cLatOffset, mEvent.latLng.lng() - cLngOffset);
	          position = me.getProjection().fromLatLngToDivPixel(mEvent.latLng);
	          if (cRaiseEnabled) {
	            me.crossDiv_.style.left = position.x + "px";
	            me.crossDiv_.style.top = position.y + "px";
	            me.crossDiv_.style.display = "";
	            position.y -= cRaiseOffset;
	          }
	          me.marker_.setPosition(me.getProjection().fromDivPixelToLatLng(position));
	          if (cRaiseEnabled) { // Don't raise the veil; this hack needed to make MSIE act properly
	            me.eventDiv_.style.top = (position.y + cRaiseOffset) + "px";
	          }
	          google.maps.event.trigger(me.marker_, "drag", mEvent);
	        } else {
	          // Calculate offsets from the click point to the marker position:
	          cLatOffset = mEvent.latLng.lat() - me.marker_.getPosition().lat();
	          cLngOffset = mEvent.latLng.lng() - me.marker_.getPosition().lng();
	          cSavedZIndex = me.marker_.getZIndex();
	          cStartPosition = me.marker_.getPosition();
	          cStartCenter = me.marker_.getMap().getCenter();
	          cRaiseEnabled = me.marker_.get("raiseOnDrag");
	          cDraggingLabel = true;
	          me.marker_.setZIndex(1000000); // Moves the marker & label to the foreground during a drag
	          mEvent.latLng = me.marker_.getPosition();
	          google.maps.event.trigger(me.marker_, "dragstart", mEvent);
	        }
	      }
	    }),
	    google.maps.event.addDomListener(document, "keydown", function (e) {
	      if (cDraggingLabel) {
	        if (e.keyCode === 27) { // Esc key
	          cRaiseEnabled = false;
	          me.marker_.setPosition(cStartPosition);
	          me.marker_.getMap().setCenter(cStartCenter);
	          google.maps.event.trigger(document, "mouseup", e);
	        }
	      }
	    }),
	    google.maps.event.addDomListener(this.eventDiv_, "click", function (e) {
	      if (me.marker_.getDraggable() || me.marker_.getClickable()) {
	        if (cIgnoreClick) { // Ignore the click reported when a label drag ends
	          cIgnoreClick = false;
	        } else {
	          google.maps.event.trigger(me.marker_, "click", e);
	          cAbortEvent(e); // Prevent click from being passed on to map
	        }
	      }
	    }),
	    google.maps.event.addDomListener(this.eventDiv_, "dblclick", function (e) {
	      if (me.marker_.getDraggable() || me.marker_.getClickable()) {
	        google.maps.event.trigger(me.marker_, "dblclick", e);
	        cAbortEvent(e); // Prevent map zoom when double-clicking on a label
	      }
	    }),
	    google.maps.event.addListener(this.marker_, "dragstart", function (mEvent) {
	      if (!cDraggingLabel) {
	        cRaiseEnabled = this.get("raiseOnDrag");
	      }
	    }),
	    google.maps.event.addListener(this.marker_, "drag", function (mEvent) {
	      if (!cDraggingLabel) {
	        if (cRaiseEnabled) {
	          me.setPosition(cRaiseOffset);
	          // During a drag, the marker's z-index is temporarily set to 1000000 to
	          // ensure it appears above all other markers. Also set the label's z-index
	          // to 1000000 (plus or minus 1 depending on whether the label is supposed
	          // to be above or below the marker).
	          me.labelDiv_.style.zIndex = 1000000 + (this.get("labelInBackground") ? -1 : +1);
	        }
	      }
	    }),
	    google.maps.event.addListener(this.marker_, "dragend", function (mEvent) {
	      if (!cDraggingLabel) {
	        if (cRaiseEnabled) {
	          me.setPosition(0); // Also restores z-index of label
	        }
	      }
	    }),
	    google.maps.event.addListener(this.marker_, "position_changed", function () {
	      me.setPosition();
	    }),
	    google.maps.event.addListener(this.marker_, "zindex_changed", function () {
	      me.setZIndex();
	    }),
	    google.maps.event.addListener(this.marker_, "visible_changed", function () {
	      me.setVisible();
	    }),
	    google.maps.event.addListener(this.marker_, "labelvisible_changed", function () {
	      me.setVisible();
	    }),
	    google.maps.event.addListener(this.marker_, "title_changed", function () {
	      me.setTitle();
	    }),
	    google.maps.event.addListener(this.marker_, "labelcontent_changed", function () {
	      me.setContent();
	    }),
	    google.maps.event.addListener(this.marker_, "labelanchor_changed", function () {
	      me.setAnchor();
	    }),
	    google.maps.event.addListener(this.marker_, "labelclass_changed", function () {
	      me.setStyles();
	    }),
	    google.maps.event.addListener(this.marker_, "labelstyle_changed", function () {
	      me.setStyles();
	    })
	  ];
	};
	
	/**
	 * Removes the DIV for the label from the DOM. It also removes all event handlers.
	 * This method is called automatically when the marker's <code>setMap(null)</code>
	 * method is called.
	 * @private
	 */
	MarkerLabel_.prototype.onRemove = function () {
	  var i;
	  this.labelDiv_.parentNode.removeChild(this.labelDiv_);
	  this.eventDiv_.parentNode.removeChild(this.eventDiv_);
	
	  // Remove event listeners:
	  for (i = 0; i < this.listeners_.length; i++) {
	    google.maps.event.removeListener(this.listeners_[i]);
	  }
	};
	
	/**
	 * Draws the label on the map.
	 * @private
	 */
	MarkerLabel_.prototype.draw = function () {
	  this.setContent();
	  this.setTitle();
	  this.setStyles();
	};
	
	/**
	 * Sets the content of the label.
	 * The content can be plain text or an HTML DOM node.
	 * @private
	 */
	MarkerLabel_.prototype.setContent = function () {
	  var content = this.marker_.get("labelContent");
	  if (typeof content.nodeType === "undefined") {
	    this.labelDiv_.innerHTML = content;
	    this.eventDiv_.innerHTML = this.labelDiv_.innerHTML;
	  } else {
	    this.labelDiv_.innerHTML = ""; // Remove current content
	    this.labelDiv_.appendChild(content);
	    content = content.cloneNode(true);
	    this.eventDiv_.innerHTML = ""; // Remove current content
	    this.eventDiv_.appendChild(content);
	  }
	};
	
	/**
	 * Sets the content of the tool tip for the label. It is
	 * always set to be the same as for the marker itself.
	 * @private
	 */
	MarkerLabel_.prototype.setTitle = function () {
	  this.eventDiv_.title = this.marker_.getTitle() || "";
	};
	
	/**
	 * Sets the style of the label by setting the style sheet and applying
	 * other specific styles requested.
	 * @private
	 */
	MarkerLabel_.prototype.setStyles = function () {
	  var i, labelStyle;
	
	  // Apply style values from the style sheet defined in the labelClass parameter:
	  this.labelDiv_.className = this.marker_.get("labelClass");
	  this.eventDiv_.className = this.labelDiv_.className;
	
	  // Clear existing inline style values:
	  this.labelDiv_.style.cssText = "";
	  this.eventDiv_.style.cssText = "";
	  // Apply style values defined in the labelStyle parameter:
	  labelStyle = this.marker_.get("labelStyle");
	  for (i in labelStyle) {
	    if (labelStyle.hasOwnProperty(i)) {
	      this.labelDiv_.style[i] = labelStyle[i];
	      this.eventDiv_.style[i] = labelStyle[i];
	    }
	  }
	  this.setMandatoryStyles();
	};
	
	/**
	 * Sets the mandatory styles to the DIV representing the label as well as to the
	 * associated event DIV. This includes setting the DIV position, z-index, and visibility.
	 * @private
	 */
	MarkerLabel_.prototype.setMandatoryStyles = function () {
	  this.labelDiv_.style.position = "absolute";
	  this.labelDiv_.style.overflow = "hidden";
	  // Make sure the opacity setting causes the desired effect on MSIE:
	  if (typeof this.labelDiv_.style.opacity !== "undefined" && this.labelDiv_.style.opacity !== "") {
	    this.labelDiv_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(opacity=" + (this.labelDiv_.style.opacity * 100) + ")\"";
	    this.labelDiv_.style.filter = "alpha(opacity=" + (this.labelDiv_.style.opacity * 100) + ")";
	  }
	
	  this.eventDiv_.style.position = this.labelDiv_.style.position;
	  this.eventDiv_.style.overflow = this.labelDiv_.style.overflow;
	  this.eventDiv_.style.opacity = 0.01; // Don't use 0; DIV won't be clickable on MSIE
	  this.eventDiv_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(opacity=1)\"";
	  this.eventDiv_.style.filter = "alpha(opacity=1)"; // For MSIE
	
	  this.setAnchor();
	  this.setPosition(); // This also updates z-index, if necessary.
	  this.setVisible();
	};
	
	/**
	 * Sets the anchor point of the label.
	 * @private
	 */
	MarkerLabel_.prototype.setAnchor = function () {
	  var anchor = this.marker_.get("labelAnchor");
	  this.labelDiv_.style.marginLeft = -anchor.x + "px";
	  this.labelDiv_.style.marginTop = -anchor.y + "px";
	  this.eventDiv_.style.marginLeft = -anchor.x + "px";
	  this.eventDiv_.style.marginTop = -anchor.y + "px";
	};
	
	/**
	 * Sets the position of the label. The z-index is also updated, if necessary.
	 * @private
	 */
	MarkerLabel_.prototype.setPosition = function (yOffset) {
	  var position = this.getProjection().fromLatLngToDivPixel(this.marker_.getPosition());
	  if (typeof yOffset === "undefined") {
	    yOffset = 0;
	  }
	  this.labelDiv_.style.left = Math.round(position.x) + "px";
	  this.labelDiv_.style.top = Math.round(position.y - yOffset) + "px";
	  this.eventDiv_.style.left = this.labelDiv_.style.left;
	  this.eventDiv_.style.top = this.labelDiv_.style.top;
	
	  this.setZIndex();
	};
	
	/**
	 * Sets the z-index of the label. If the marker's z-index property has not been defined, the z-index
	 * of the label is set to the vertical coordinate of the label. This is in keeping with the default
	 * stacking order for Google Maps: markers to the south are in front of markers to the north.
	 * @private
	 */
	MarkerLabel_.prototype.setZIndex = function () {
	  var zAdjust = (this.marker_.get("labelInBackground") ? -1 : +1);
	  if (typeof this.marker_.getZIndex() === "undefined") {
	    this.labelDiv_.style.zIndex = parseInt(this.labelDiv_.style.top, 10) + zAdjust;
	    this.eventDiv_.style.zIndex = this.labelDiv_.style.zIndex;
	  } else {
	    this.labelDiv_.style.zIndex = this.marker_.getZIndex() + zAdjust;
	    this.eventDiv_.style.zIndex = this.labelDiv_.style.zIndex;
	  }
	};
	
	/**
	 * Sets the visibility of the label. The label is visible only if the marker itself is
	 * visible (i.e., its visible property is true) and the labelVisible property is true.
	 * @private
	 */
	MarkerLabel_.prototype.setVisible = function () {
	  if (this.marker_.get("labelVisible")) {
	    this.labelDiv_.style.display = this.marker_.getVisible() ? "block" : "none";
	  } else {
	    this.labelDiv_.style.display = "none";
	  }
	  this.eventDiv_.style.display = this.labelDiv_.style.display;
	};
	
	/**
	 * @name MarkerWithLabelOptions
	 * @class This class represents the optional parameter passed to the {@link MarkerWithLabel} constructor.
	 *  The properties available are the same as for <code>google.maps.Marker</code> with the addition
	 *  of the properties listed below. To change any of these additional properties after the labeled
	 *  marker has been created, call <code>google.maps.Marker.set(propertyName, propertyValue)</code>.
	 *  <p>
	 *  When any of these properties changes, a property changed event is fired. The names of these
	 *  events are derived from the name of the property and are of the form <code>propertyname_changed</code>.
	 *  For example, if the content of the label changes, a <code>labelcontent_changed</code> event
	 *  is fired.
	 *  <p>
	 * @property {string|Node} [labelContent] The content of the label (plain text or an HTML DOM node).
	 * @property {Point} [labelAnchor] By default, a label is drawn with its anchor point at (0,0) so
	 *  that its top left corner is positioned at the anchor point of the associated marker. Use this
	 *  property to change the anchor point of the label. For example, to center a 50px-wide label
	 *  beneath a marker, specify a <code>labelAnchor</code> of <code>google.maps.Point(25, 0)</code>.
	 *  (Note: x-values increase to the right and y-values increase to the top.)
	 * @property {string} [labelClass] The name of the CSS class defining the styles for the label.
	 *  Note that style values for <code>position</code>, <code>overflow</code>, <code>top</code>,
	 *  <code>left</code>, <code>zIndex</code>, <code>display</code>, <code>marginLeft</code>, and
	 *  <code>marginTop</code> are ignored; these styles are for internal use only.
	 * @property {Object} [labelStyle] An object literal whose properties define specific CSS
	 *  style values to be applied to the label. Style values defined here override those that may
	 *  be defined in the <code>labelClass</code> style sheet. If this property is changed after the
	 *  label has been created, all previously set styles (except those defined in the style sheet)
	 *  are removed from the label before the new style values are applied.
	 *  Note that style values for <code>position</code>, <code>overflow</code>, <code>top</code>,
	 *  <code>left</code>, <code>zIndex</code>, <code>display</code>, <code>marginLeft</code>, and
	 *  <code>marginTop</code> are ignored; these styles are for internal use only.
	 * @property {boolean} [labelInBackground] A flag indicating whether a label that overlaps its
	 *  associated marker should appear in the background (i.e., in a plane below the marker).
	 *  The default is <code>false</code>, which causes the label to appear in the foreground.
	 * @property {boolean} [labelVisible] A flag indicating whether the label is to be visible.
	 *  The default is <code>true</code>. Note that even if <code>labelVisible</code> is
	 *  <code>true</code>, the label will <i>not</i> be visible unless the associated marker is also
	 *  visible (i.e., unless the marker's <code>visible</code> property is <code>true</code>).
	 * @property {boolean} [raiseOnDrag] A flag indicating whether the label and marker are to be
	 *  raised when the marker is dragged. The default is <code>true</code>. If a draggable marker is
	 *  being created and a version of Google Maps API earlier than V3.3 is being used, this property
	 *  must be set to <code>false</code>.
	 * @property {boolean} [optimized] A flag indicating whether rendering is to be optimized for the
	 *  marker. <b>Important: The optimized rendering technique is not supported by MarkerWithLabel,
	 *  so the value of this parameter is always forced to <code>false</code>.
	 * @property {string} [crossImage="http://maps.gstatic.com/intl/en_us/mapfiles/drag_cross_67_16.png"]
	 *  The URL of the cross image to be displayed while dragging a marker.
	 * @property {string} [handCursor="http://maps.gstatic.com/intl/en_us/mapfiles/closedhand_8_8.cur"]
	 *  The URL of the cursor to be displayed while dragging a marker.
	 */
	/**
	 * Creates a MarkerWithLabel with the options specified in {@link MarkerWithLabelOptions}.
	 * @constructor
	 * @param {MarkerWithLabelOptions} [opt_options] The optional parameters.
	 */
	function MarkerWithLabel(opt_options) {
	  opt_options = opt_options || {};
	  opt_options.labelContent = opt_options.labelContent || "";
	  opt_options.labelAnchor = opt_options.labelAnchor || new google.maps.Point(0, 0);
	  opt_options.labelClass = opt_options.labelClass || "markerLabels";
	  opt_options.labelStyle = opt_options.labelStyle || {};
	  opt_options.labelInBackground = opt_options.labelInBackground || false;
	  if (typeof opt_options.labelVisible === "undefined") {
	    opt_options.labelVisible = true;
	  }
	  if (typeof opt_options.raiseOnDrag === "undefined") {
	    opt_options.raiseOnDrag = true;
	  }
	  if (typeof opt_options.clickable === "undefined") {
	    opt_options.clickable = true;
	  }
	  if (typeof opt_options.draggable === "undefined") {
	    opt_options.draggable = false;
	  }
	  if (typeof opt_options.optimized === "undefined") {
	    opt_options.optimized = false;
	  }
	  opt_options.crossImage = opt_options.crossImage || "http" + (document.location.protocol === "https:" ? "s" : "") + "://maps.gstatic.com/intl/en_us/mapfiles/drag_cross_67_16.png";
	  opt_options.handCursor = opt_options.handCursor || "http" + (document.location.protocol === "https:" ? "s" : "") + "://maps.gstatic.com/intl/en_us/mapfiles/closedhand_8_8.cur";
	  opt_options.optimized = false; // Optimized rendering is not supported
	
	  this.label = new MarkerLabel_(this, opt_options.crossImage, opt_options.handCursor); // Bind the label to the marker
	
	  // Call the parent constructor. It calls Marker.setValues to initialize, so all
	  // the new parameters are conveniently saved and can be accessed with get/set.
	  // Marker.set triggers a property changed event (called "propertyname_changed")
	  // that the marker label listens for in order to react to state changes.
	  google.maps.Marker.apply(this, arguments);
	}
	
	inherits(MarkerWithLabel, google.maps.Marker);
	
	/**
	 * Overrides the standard Marker setMap function.
	 * @param {Map} theMap The map to which the marker is to be added.
	 * @private
	 */
	MarkerWithLabel.prototype.setMap = function (theMap) {
	
	  // Call the inherited function...
	  google.maps.Marker.prototype.setMap.apply(this, arguments);
	
	  // ... then deal with the label:
	  this.label.setMap(theMap);
	};
	
	// ==ClosureCompiler==
	// @compilation_level ADVANCED_OPTIMIZATIONS
	// @externs_url http://closure-compiler.googlecode.com/svn/trunk/contrib/externs/maps/google_maps_api_v3.js
	// @output_wrapper (function() {%output%})();
	// ==/ClosureCompiler==
	
	/**
	 * @license
	 * Copyright 2013 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * A RichMarker that allows any HTML/DOM to be added to a map and be draggable.
	 *
	 * @param {Object.<string, *>=} opt_options Optional properties to set.
	 * @extends {google.maps.OverlayView}
	 * @constructor
	 */
	function RichMarker(opt_options) {
	  var options = opt_options || {};
	
	  /**
	   * @type {boolean}
	   * @private
	   */
	  this.ready_ = false;
	
	  /**
	   * @type {boolean}
	   * @private
	   */
	  this.dragging_ = false;
	
	  if (opt_options['visible'] == undefined) {
	    opt_options['visible'] = true;
	  }
	
	  if (opt_options['shadow'] == undefined) {
	    opt_options['shadow'] = '7px -3px 5px rgba(88,88,88,0.7)';
	  }
	
	  if (opt_options['anchor'] == undefined) {
	    opt_options['anchor'] = RichMarkerPosition['BOTTOM'];
	  }
	
	  this.setValues(options);
	}
	RichMarker.prototype = new google.maps.OverlayView();
	window['RichMarker'] = RichMarker;
	
	
	/**
	 * Returns the current visibility state of the marker.
	 *
	 * @return {boolean} The visiblity of the marker.
	 */
	RichMarker.prototype.getVisible = function() {
	  return /** @type {boolean} */ (this.get('visible'));
	};
	RichMarker.prototype['getVisible'] = RichMarker.prototype.getVisible;
	
	
	/**
	 * Sets the visiblility state of the marker.
	 *
	 * @param {boolean} visible The visiblilty of the marker.
	 */
	RichMarker.prototype.setVisible = function(visible) {
	  this.set('visible', visible);
	};
	RichMarker.prototype['setVisible'] = RichMarker.prototype.setVisible;
	
	
	/**
	 *  The visible changed event.
	 */
	RichMarker.prototype.visible_changed = function() {
	  if (this.ready_) {
	    this.markerWrapper_.style['display'] = this.getVisible() ? '' : 'none';
	    this.draw();
	  }
	};
	RichMarker.prototype['visible_changed'] = RichMarker.prototype.visible_changed;
	
	
	/**
	 * Sets the marker to be flat.
	 *
	 * @param {boolean} flat If the marker is to be flat or not.
	 */
	RichMarker.prototype.setFlat = function(flat) {
	  this.set('flat', !!flat);
	};
	RichMarker.prototype['setFlat'] = RichMarker.prototype.setFlat;
	
	
	/**
	 * If the makrer is flat or not.
	 *
	 * @return {boolean} True the marker is flat.
	 */
	RichMarker.prototype.getFlat = function() {
	  return /** @type {boolean} */ (this.get('flat'));
	};
	RichMarker.prototype['getFlat'] = RichMarker.prototype.getFlat;
	
	
	/**
	 * Get the width of the marker.
	 *
	 * @return {Number} The width of the marker.
	 */
	RichMarker.prototype.getWidth = function() {
	  return /** @type {Number} */ (this.get('width'));
	};
	RichMarker.prototype['getWidth'] = RichMarker.prototype.getWidth;
	
	
	/**
	 * Get the height of the marker.
	 *
	 * @return {Number} The height of the marker.
	 */
	RichMarker.prototype.getHeight = function() {
	  return /** @type {Number} */ (this.get('height'));
	};
	RichMarker.prototype['getHeight'] = RichMarker.prototype.getHeight;
	
	
	/**
	 * Sets the marker's box shadow.
	 *
	 * @param {string} shadow The box shadow to set.
	 */
	RichMarker.prototype.setShadow = function(shadow) {
	  this.set('shadow', shadow);
	  this.flat_changed();
	};
	RichMarker.prototype['setShadow'] = RichMarker.prototype.setShadow;
	
	
	/**
	 * Gets the marker's box shadow.
	 *
	 * @return {string} The box shadow.
	 */
	RichMarker.prototype.getShadow = function() {
	  return /** @type {string} */ (this.get('shadow'));
	};
	RichMarker.prototype['getShadow'] = RichMarker.prototype.getShadow;
	
	
	/**
	 * Flat changed event.
	 */
	RichMarker.prototype.flat_changed = function() {
	  if (!this.ready_) {
	    return;
	  }
	
	  this.markerWrapper_.style['boxShadow'] =
	      this.markerWrapper_.style['webkitBoxShadow'] =
	      this.markerWrapper_.style['MozBoxShadow'] =
	      this.getFlat() ? '' : this.getShadow();
	};
	RichMarker.prototype['flat_changed'] = RichMarker.prototype.flat_changed;
	
	
	/**
	 * Sets the zIndex of the marker.
	 *
	 * @param {Number} index The index to set.
	 */
	RichMarker.prototype.setZIndex = function(index) {
	  this.set('zIndex', index);
	};
	RichMarker.prototype['setZIndex'] = RichMarker.prototype.setZIndex;
	
	
	/**
	 * Gets the zIndex of the marker.
	 *
	 * @return {Number} The zIndex of the marker.
	 */
	RichMarker.prototype.getZIndex = function() {
	  return /** @type {Number} */ (this.get('zIndex'));
	};
	RichMarker.prototype['getZIndex'] = RichMarker.prototype.getZIndex;
	
	
	/**
	 * zIndex changed event.
	 */
	RichMarker.prototype.zIndex_changed = function() {
	  if (this.getZIndex() && this.ready_) {
	    this.markerWrapper_.style.zIndex = this.getZIndex();
	  }
	};
	RichMarker.prototype['zIndex_changed'] = RichMarker.prototype.zIndex_changed;
	
	/**
	 * Whether the marker is draggable or not.
	 *
	 * @return {boolean} True if the marker is draggable.
	 */
	RichMarker.prototype.getDraggable = function() {
	  return /** @type {boolean} */ (this.get('draggable'));
	};
	RichMarker.prototype['getDraggable'] = RichMarker.prototype.getDraggable;
	
	
	/**
	 * Sets the marker to be draggable or not.
	 *
	 * @param {boolean} draggable If the marker is draggable or not.
	 */
	RichMarker.prototype.setDraggable = function(draggable) {
	  this.set('draggable', !!draggable);
	};
	RichMarker.prototype['setDraggable'] = RichMarker.prototype.setDraggable;
	
	
	/**
	 * Draggable property changed callback.
	 */
	RichMarker.prototype.draggable_changed = function() {
	  if (this.ready_) {
	    if (this.getDraggable()) {
	      this.addDragging_(this.markerWrapper_);
	    } else {
	      this.removeDragListeners_();
	    }
	  }
	};
	RichMarker.prototype['draggable_changed'] =
	    RichMarker.prototype.draggable_changed;
	
	
	/**
	 * Gets the postiton of the marker.
	 *
	 * @return {google.maps.LatLng} The position of the marker.
	 */
	RichMarker.prototype.getPosition = function() {
	  return /** @type {google.maps.LatLng} */ (this.get('position'));
	};
	RichMarker.prototype['getPosition'] = RichMarker.prototype.getPosition;
	
	
	/**
	 * Sets the position of the marker.
	 *
	 * @param {google.maps.LatLng} position The position to set.
	 */
	RichMarker.prototype.setPosition = function(position) {
	  this.set('position', position);
	};
	RichMarker.prototype['setPosition'] = RichMarker.prototype.setPosition;
	
	
	/**
	 * Position changed event.
	 */
	RichMarker.prototype.position_changed = function() {
	  this.draw();
	};
	RichMarker.prototype['position_changed'] =
	    RichMarker.prototype.position_changed;
	
	
	/**
	 * Gets the anchor.
	 *
	 * @return {google.maps.Size} The position of the anchor.
	 */
	RichMarker.prototype.getAnchor = function() {
	  return /** @type {google.maps.Size} */ (this.get('anchor'));
	};
	RichMarker.prototype['getAnchor'] = RichMarker.prototype.getAnchor;
	
	
	/**
	 * Sets the anchor.
	 *
	 * @param {RichMarkerPosition|google.maps.Size} anchor The anchor to set.
	 */
	RichMarker.prototype.setAnchor = function(anchor) {
	  this.set('anchor', anchor);
	};
	RichMarker.prototype['setAnchor'] = RichMarker.prototype.setAnchor;
	
	
	/**
	 * Anchor changed event.
	 */
	RichMarker.prototype.anchor_changed = function() {
	  this.draw();
	};
	RichMarker.prototype['anchor_changed'] = RichMarker.prototype.anchor_changed;
	
	
	/**
	 * Converts a HTML string to a document fragment.
	 *
	 * @param {string} htmlString The HTML string to convert.
	 * @return {Node} A HTML document fragment.
	 * @private
	 */
	RichMarker.prototype.htmlToDocumentFragment_ = function(htmlString) {
	  var tempDiv = document.createElement('DIV');
	  tempDiv.innerHTML = htmlString;
	  if (tempDiv.childNodes.length == 1) {
	    return /** @type {!Node} */ (tempDiv.removeChild(tempDiv.firstChild));
	  } else {
	    var fragment = document.createDocumentFragment();
	    while (tempDiv.firstChild) {
	      fragment.appendChild(tempDiv.firstChild);
	    }
	    return fragment;
	  }
	};
	
	
	/**
	 * Removes all children from the node.
	 *
	 * @param {Node} node The node to remove all children from.
	 * @private
	 */
	RichMarker.prototype.removeChildren_ = function(node) {
	  if (!node) {
	    return;
	  }
	
	  var child;
	  while (child = node.firstChild) {
	    node.removeChild(child);
	  }
	};
	
	
	/**
	 * Sets the content of the marker.
	 *
	 * @param {string|Node} content The content to set.
	 */
	RichMarker.prototype.setContent = function(content) {
	  this.set('content', content);
	};
	RichMarker.prototype['setContent'] = RichMarker.prototype.setContent;
	
	
	/**
	 * Get the content of the marker.
	 *
	 * @return {string|Node} The marker content.
	 */
	RichMarker.prototype.getContent = function() {
	  return /** @type {Node|string} */ (this.get('content'));
	};
	RichMarker.prototype['getContent'] = RichMarker.prototype.getContent;
	
	
	/**
	 * Sets the marker content and adds loading events to images
	 */
	RichMarker.prototype.content_changed = function() {
	  if (!this.markerContent_) {
	    // Marker content area doesnt exist.
	    return;
	  }
	
	  this.removeChildren_(this.markerContent_);
	  var content = this.getContent();
	  if (content) {
	    if (typeof content == 'string') {
	      content = content.replace(/^\s*([\S\s]*)\b\s*$/, '$1');
	      content = this.htmlToDocumentFragment_(content);
	    }
	    this.markerContent_.appendChild(content);
	
	    var that = this;
	    var images = this.markerContent_.getElementsByTagName('IMG');
	    for (var i = 0, image; image = images[i]; i++) {
	      // By default, a browser lets a image be dragged outside of the browser,
	      // so by calling preventDefault we stop this behaviour and allow the image
	      // to be dragged around the map and now out of the browser and onto the
	      // desktop.
	      google.maps.event.addDomListener(image, 'mousedown', function(e) {
	        if (that.getDraggable()) {
	          if (e.preventDefault) {
	            e.preventDefault();
	          }
	          e.returnValue = false;
	        }
	      });
	
	      // Because we don't know the size of an image till it loads, add a
	      // listener to the image load so the marker can resize and reposition
	      // itself to be the correct height.
	      google.maps.event.addDomListener(image, 'load', function() {
	        that.draw();
	      });
	    }
	
	    google.maps.event.trigger(this, 'domready');
	  }
	
	  if (this.ready_) {
	    this.draw();
	  }
	};
	RichMarker.prototype['content_changed'] = RichMarker.prototype.content_changed;
	
	/**
	 * Sets the cursor.
	 *
	 * @param {string} whichCursor What cursor to show.
	 * @private
	 */
	RichMarker.prototype.setCursor_ = function(whichCursor) {
	  if (!this.ready_) {
	    return;
	  }
	
	  var cursor = '';
	  if (navigator.userAgent.indexOf('Gecko/') !== -1) {
	    // Moz has some nice cursors :)
	    if (whichCursor == 'dragging') {
	      cursor = '-moz-grabbing';
	    }
	
	    if (whichCursor == 'dragready') {
	      cursor = '-moz-grab';
	    }
	
	    if (whichCursor == 'draggable') {
	      cursor = 'pointer';
	    }
	  } else {
	    if (whichCursor == 'dragging' || whichCursor == 'dragready') {
	      cursor = 'move';
	    }
	
	    if (whichCursor == 'draggable') {
	      cursor = 'pointer';
	    }
	  }
	
	  if (this.markerWrapper_.style.cursor != cursor) {
	    this.markerWrapper_.style.cursor = cursor;
	  }
	};
	
	/**
	 * Start dragging.
	 *
	 * @param {Event} e The event.
	 */
	RichMarker.prototype.startDrag = function(e) {
	  if (!this.getDraggable()) {
	    return;
	  }
	
	  if (!this.dragging_) {
	    this.dragging_ = true;
	    var map = this.getMap();
	    this.mapDraggable_ = map.get('draggable');
	    map.set('draggable', false);
	
	    // Store the current mouse position
	    this.mouseX_ = e.clientX;
	    this.mouseY_ = e.clientY;
	
	    this.setCursor_('dragready');
	
	    // Stop the text from being selectable while being dragged
	    this.markerWrapper_.style['MozUserSelect'] = 'none';
	    this.markerWrapper_.style['KhtmlUserSelect'] = 'none';
	    this.markerWrapper_.style['WebkitUserSelect'] = 'none';
	
	    this.markerWrapper_['unselectable'] = 'on';
	    this.markerWrapper_['onselectstart'] = function() {
	      return false;
	    };
	
	    this.addDraggingListeners_();
	
	    google.maps.event.trigger(this, 'dragstart');
	  }
	};
	
	
	/**
	 * Stop dragging.
	 */
	RichMarker.prototype.stopDrag = function() {
	  if (!this.getDraggable()) {
	    return;
	  }
	
	  if (this.dragging_) {
	    this.dragging_ = false;
	    this.getMap().set('draggable', this.mapDraggable_);
	    this.mouseX_ = this.mouseY_ = this.mapDraggable_ = null;
	
	    // Allow the text to be selectable again
	    this.markerWrapper_.style['MozUserSelect'] = '';
	    this.markerWrapper_.style['KhtmlUserSelect'] = '';
	    this.markerWrapper_.style['WebkitUserSelect'] = '';
	    this.markerWrapper_['unselectable'] = 'off';
	    this.markerWrapper_['onselectstart'] = function() {};
	
	    this.removeDraggingListeners_();
	
	    this.setCursor_('draggable');
	    google.maps.event.trigger(this, 'dragend');
	
	    this.draw();
	  }
	};
	
	
	/**
	 * Handles the drag event.
	 *
	 * @param {Event} e The event.
	 */
	RichMarker.prototype.drag = function(e) {
	  if (!this.getDraggable() || !this.dragging_) {
	    // This object isn't draggable or we have stopped dragging
	    this.stopDrag();
	    return;
	  }
	
	  var dx = this.mouseX_ - e.clientX;
	  var dy = this.mouseY_ - e.clientY;
	
	  this.mouseX_ = e.clientX;
	  this.mouseY_ = e.clientY;
	
	  var left = parseInt(this.markerWrapper_.style['left'], 10) - dx;
	  var top = parseInt(this.markerWrapper_.style['top'], 10) - dy;
	
	  this.markerWrapper_.style['left'] = left + 'px';
	  this.markerWrapper_.style['top'] = top + 'px';
	
	  var offset = this.getOffset_();
	
	  // Set the position property and adjust for the anchor offset
	  var point = new google.maps.Point(left - offset.width, top - offset.height);
	  var projection = this.getProjection();
	  this.setPosition(projection.fromDivPixelToLatLng(point));
	
	  this.setCursor_('dragging');
	  google.maps.event.trigger(this, 'drag');
	};
	
	
	/**
	 * Removes the drag listeners associated with the marker.
	 *
	 * @private
	 */
	RichMarker.prototype.removeDragListeners_ = function() {
	  if (this.draggableListener_) {
	    google.maps.event.removeListener(this.draggableListener_);
	    delete this.draggableListener_;
	  }
	  this.setCursor_('');
	};
	
	
	/**
	 * Add dragability events to the marker.
	 *
	 * @param {Node} node The node to apply dragging to.
	 * @private
	 */
	RichMarker.prototype.addDragging_ = function(node) {
	  if (!node) {
	    return;
	  }
	
	  var that = this;
	  this.draggableListener_ =
	    google.maps.event.addDomListener(node, 'mousedown', function(e) {
	      that.startDrag(e);
	    });
	
	  this.setCursor_('draggable');
	};
	
	
	/**
	 * Add dragging listeners.
	 *
	 * @private
	 */
	RichMarker.prototype.addDraggingListeners_ = function() {
	  var that = this;
	  if (this.markerWrapper_.setCapture) {
	    this.markerWrapper_.setCapture(true);
	    this.draggingListeners_ = [
	      google.maps.event.addDomListener(this.markerWrapper_, 'mousemove', function(e) {
	        that.drag(e);
	      }, true),
	      google.maps.event.addDomListener(this.markerWrapper_, 'mouseup', function() {
	        that.stopDrag();
	        that.markerWrapper_.releaseCapture();
	      }, true)
	    ];
	  } else {
	    this.draggingListeners_ = [
	      google.maps.event.addDomListener(window, 'mousemove', function(e) {
	        that.drag(e);
	      }, true),
	      google.maps.event.addDomListener(window, 'mouseup', function() {
	        that.stopDrag();
	      }, true)
	    ];
	  }
	};
	
	
	/**
	 * Remove dragging listeners.
	 *
	 * @private
	 */
	RichMarker.prototype.removeDraggingListeners_ = function() {
	  if (this.draggingListeners_) {
	    for (var i = 0, listener; listener = this.draggingListeners_[i]; i++) {
	      google.maps.event.removeListener(listener);
	    }
	    this.draggingListeners_.length = 0;
	  }
	};
	
	
	/**
	 * Get the anchor offset.
	 *
	 * @return {google.maps.Size} The size offset.
	 * @private
	 */
	RichMarker.prototype.getOffset_ = function() {
	  var anchor = this.getAnchor();
	  if (typeof anchor == 'object') {
	    return /** @type {google.maps.Size} */ (anchor);
	  }
	
	  var offset = new google.maps.Size(0, 0);
	  if (!this.markerContent_) {
	    return offset;
	  }
	
	  var width = this.markerContent_.offsetWidth;
	  var height = this.markerContent_.offsetHeight;
	
	  switch (anchor) {
	   case RichMarkerPosition['TOP_LEFT']:
	     break;
	   case RichMarkerPosition['TOP']:
	     offset.width = -width / 2;
	     break;
	   case RichMarkerPosition['TOP_RIGHT']:
	     offset.width = -width;
	     break;
	   case RichMarkerPosition['LEFT']:
	     offset.height = -height / 2;
	     break;
	   case RichMarkerPosition['MIDDLE']:
	     offset.width = -width / 2;
	     offset.height = -height / 2;
	     break;
	   case RichMarkerPosition['RIGHT']:
	     offset.width = -width;
	     offset.height = -height / 2;
	     break;
	   case RichMarkerPosition['BOTTOM_LEFT']:
	     offset.height = -height;
	     break;
	   case RichMarkerPosition['BOTTOM']:
	     offset.width = -width / 2;
	     offset.height = -height;
	     break;
	   case RichMarkerPosition['BOTTOM_RIGHT']:
	     offset.width = -width;
	     offset.height = -height;
	     break;
	  }
	
	  return offset;
	};
	
	
	/**
	 * Adding the marker to a map.
	 * Implementing the interface.
	 */
	RichMarker.prototype.onAdd = function() {
	  if (!this.markerWrapper_) {
	    this.markerWrapper_ = document.createElement('DIV');
	    this.markerWrapper_.style['position'] = 'absolute';
	  }
	
	  if (this.getZIndex()) {
	    this.markerWrapper_.style['zIndex'] = this.getZIndex();
	  }
	
	  this.markerWrapper_.style['display'] = this.getVisible() ? '' : 'none';
	
	  if (!this.markerContent_) {
	    this.markerContent_ = document.createElement('DIV');
	    this.markerWrapper_.appendChild(this.markerContent_);
	
	    var that = this;
	    google.maps.event.addDomListener(this.markerContent_, 'click', function(e) {
	      google.maps.event.trigger(that, 'click');
	    });
	    google.maps.event.addDomListener(this.markerContent_, 'mouseover', function(e) {
	      google.maps.event.trigger(that, 'mouseover');
	    });
	    google.maps.event.addDomListener(this.markerContent_, 'mouseout', function(e) {
	      google.maps.event.trigger(that, 'mouseout');
	    });
	  }
	
	  this.ready_ = true;
	  this.content_changed();
	  this.flat_changed();
	  this.draggable_changed();
	
	  var panes = this.getPanes();
	  if (panes) {
	    panes.overlayMouseTarget.appendChild(this.markerWrapper_);
	  }
	
	  google.maps.event.trigger(this, 'ready');
	};
	RichMarker.prototype['onAdd'] = RichMarker.prototype.onAdd;
	
	
	/**
	 * Impelementing the interface.
	 */
	RichMarker.prototype.draw = function() {
	  if (!this.ready_ || this.dragging_) {
	    return;
	  }
	
	  var projection = this.getProjection();
	
	  if (!projection) {
	    // The map projection is not ready yet so do nothing
	    return;
	  }
	
	  var latLng = /** @type {google.maps.LatLng} */ (this.get('position'));
	  var pos = projection.fromLatLngToDivPixel(latLng);
	
	  var offset = this.getOffset_();
	  this.markerWrapper_.style['top'] = (pos.y + offset.height) + 'px';
	  this.markerWrapper_.style['left'] = (pos.x + offset.width) + 'px';
	
	  var height = this.markerContent_.offsetHeight;
	  var width = this.markerContent_.offsetWidth;
	
	  if (width != this.get('width')) {
	    this.set('width', width);
	  }
	
	  if (height != this.get('height')) {
	    this.set('height', height);
	  }
	};
	RichMarker.prototype['draw'] = RichMarker.prototype.draw;
	
	
	/**
	 * Removing a marker from the map.
	 * Implementing the interface.
	 */
	RichMarker.prototype.onRemove = function() {
	  if (this.markerWrapper_ && this.markerWrapper_.parentNode) {
	    this.markerWrapper_.parentNode.removeChild(this.markerWrapper_);
	  }
	  this.removeDragListeners_();
	};
	RichMarker.prototype['onRemove'] = RichMarker.prototype.onRemove;
	
	
	/**
	 * RichMarker Anchor positions
	 * @enum {number}
	 */
	var RichMarkerPosition = {
	  'TOP_LEFT': 1,
	  'TOP': 2,
	  'TOP_RIGHT': 3,
	  'LEFT': 4,
	  'MIDDLE': 5,
	  'RIGHT': 6,
	  'BOTTOM_LEFT': 7,
	  'BOTTOM': 8,
	  'BOTTOM_RIGHT': 9
	};
	window['RichMarkerPosition'] = RichMarkerPosition;
	
	
	        //TODO: export / passthese on in the service instead of window
	        window.InfoBox = InfoBox;
	        window.Cluster = Cluster;
	        window.ClusterIcon = ClusterIcon;
	        window.MarkerClusterer = MarkerClusterer;
	        window.MarkerLabel_ = MarkerLabel_;
	        window.MarkerWithLabel = MarkerWithLabel;
	        window.RichMarker = RichMarker;
	      }();
	      //END REPLACE
	    })
	  };
	});
	;/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* istanbul ignore next */
		angular.module('uiGmapgoogle-maps.wrapped')
		.service('uiGmapDataStructures', function() {
		return {
		  Graph: __webpack_require__(1).Graph,
		  Queue: __webpack_require__(1).Queue
		};
		});
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		(function() {
		  module.exports = {
		    Graph: __webpack_require__(2),
		    Heap: __webpack_require__(3),
		    LinkedList: __webpack_require__(4),
		    Map: __webpack_require__(5),
		    Queue: __webpack_require__(6),
		    RedBlackTree: __webpack_require__(7),
		    Trie: __webpack_require__(8)
		  };
	
		}).call(this);
	
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		/*
		Graph implemented as a modified incidence list. O(1) for every typical
		operation except `removeNode()` at O(E) where E is the number of edges.
	
		## Overview example:
	
		```js
		var graph = new Graph;
		graph.addNode('A'); // => a node object. For more info, log the output or check
		                    // the documentation for addNode
		graph.addNode('B');
		graph.addNode('C');
		graph.addEdge('A', 'C'); // => an edge object
		graph.addEdge('A', 'B');
		graph.getEdge('B', 'A'); // => undefined. Directed edge!
		graph.getEdge('A', 'B'); // => the edge object previously added
		graph.getEdge('A', 'B').weight = 2 // weight is the only built-in handy property
		                                   // of an edge object. Feel free to attach
		                                   // other properties
		graph.getInEdgesOf('B'); // => array of edge objects, in this case only one;
		                         // connecting A to B
		graph.getOutEdgesOf('A'); // => array of edge objects, one to B and one to C
		graph.getAllEdgesOf('A'); // => all the in and out edges. Edge directed toward
		                          // the node itself are only counted once
		forEachNode(function(nodeObject) {
		  console.log(node);
		});
		forEachEdge(function(edgeObject) {
		  console.log(edgeObject);
		});
		graph.removeNode('C'); // => 'C'. The edge between A and C also removed
		graph.removeEdge('A', 'B'); // => the edge object removed
		```
	
		## Properties:
	
		- nodeSize: total number of nodes.
		- edgeSize: total number of edges.
		*/
	
	
		(function() {
		  var Graph,
		    __hasProp = {}.hasOwnProperty;
	
		  Graph = (function() {
		    function Graph() {
		      this._nodes = {};
		      this.nodeSize = 0;
		      this.edgeSize = 0;
		    }
	
		    Graph.prototype.addNode = function(id) {
		      /*
		      The `id` is a unique identifier for the node, and should **not** change
		      after it's added. It will be used for adding, retrieving and deleting
		      related edges too.
		      
		      **Note** that, internally, the ids are kept in an object. JavaScript's
		      object hashes the id `'2'` and `2` to the same key, so please stick to a
		      simple id data type such as number or string.
		      
		      _Returns:_ the node object. Feel free to attach additional custom properties
		      on it for graph algorithms' needs. **Undefined if node id already exists**,
		      as to avoid accidental overrides.
		      */
	
		      if (!this._nodes[id]) {
		        this.nodeSize++;
		        return this._nodes[id] = {
		          _outEdges: {},
		          _inEdges: {}
		        };
		      }
		    };
	
		    Graph.prototype.getNode = function(id) {
		      /*
		      _Returns:_ the node object. Feel free to attach additional custom properties
		      on it for graph algorithms' needs.
		      */
	
		      return this._nodes[id];
		    };
	
		    Graph.prototype.removeNode = function(id) {
		      /*
		      _Returns:_ the node object removed, or undefined if it didn't exist in the
		      first place.
		      */
	
		      var inEdgeId, nodeToRemove, outEdgeId, _ref, _ref1;
		      nodeToRemove = this._nodes[id];
		      if (!nodeToRemove) {
		        return;
		      } else {
		        _ref = nodeToRemove._outEdges;
		        for (outEdgeId in _ref) {
		          if (!__hasProp.call(_ref, outEdgeId)) continue;
		          this.removeEdge(id, outEdgeId);
		        }
		        _ref1 = nodeToRemove._inEdges;
		        for (inEdgeId in _ref1) {
		          if (!__hasProp.call(_ref1, inEdgeId)) continue;
		          this.removeEdge(inEdgeId, id);
		        }
		        this.nodeSize--;
		        delete this._nodes[id];
		      }
		      return nodeToRemove;
		    };
	
		    Graph.prototype.addEdge = function(fromId, toId, weight) {
		      var edgeToAdd, fromNode, toNode;
		      if (weight == null) {
		        weight = 1;
		      }
		      /*
		      `fromId` and `toId` are the node id specified when it was created using
		      `addNode()`. `weight` is optional and defaults to 1. Ignoring it effectively
		      makes this an unweighted graph. Under the hood, `weight` is just a normal
		      property of the edge object.
		      
		      _Returns:_ the edge object created. Feel free to attach additional custom
		      properties on it for graph algorithms' needs. **Or undefined** if the nodes
		      of id `fromId` or `toId` aren't found, or if an edge already exists between
		      the two nodes.
		      */
	
		      if (this.getEdge(fromId, toId)) {
		        return;
		      }
		      fromNode = this._nodes[fromId];
		      toNode = this._nodes[toId];
		      if (!fromNode || !toNode) {
		        return;
		      }
		      edgeToAdd = {
		        weight: weight
		      };
		      fromNode._outEdges[toId] = edgeToAdd;
		      toNode._inEdges[fromId] = edgeToAdd;
		      this.edgeSize++;
		      return edgeToAdd;
		    };
	
		    Graph.prototype.getEdge = function(fromId, toId) {
		      /*
		      _Returns:_ the edge object, or undefined if the nodes of id `fromId` or
		      `toId` aren't found.
		      */
	
		      var fromNode, toNode;
		      fromNode = this._nodes[fromId];
		      toNode = this._nodes[toId];
		      if (!fromNode || !toNode) {
	
		      } else {
		        return fromNode._outEdges[toId];
		      }
		    };
	
		    Graph.prototype.removeEdge = function(fromId, toId) {
		      /*
		      _Returns:_ the edge object removed, or undefined of edge wasn't found.
		      */
	
		      var edgeToDelete, fromNode, toNode;
		      fromNode = this._nodes[fromId];
		      toNode = this._nodes[toId];
		      edgeToDelete = this.getEdge(fromId, toId);
		      if (!edgeToDelete) {
		        return;
		      }
		      delete fromNode._outEdges[toId];
		      delete toNode._inEdges[fromId];
		      this.edgeSize--;
		      return edgeToDelete;
		    };
	
		    Graph.prototype.getInEdgesOf = function(nodeId) {
		      /*
		      _Returns:_ an array of edge objects that are directed toward the node, or
		      empty array if no such edge or node exists.
		      */
	
		      var fromId, inEdges, toNode, _ref;
		      toNode = this._nodes[nodeId];
		      inEdges = [];
		      _ref = toNode != null ? toNode._inEdges : void 0;
		      for (fromId in _ref) {
		        if (!__hasProp.call(_ref, fromId)) continue;
		        inEdges.push(this.getEdge(fromId, nodeId));
		      }
		      return inEdges;
		    };
	
		    Graph.prototype.getOutEdgesOf = function(nodeId) {
		      /*
		      _Returns:_ an array of edge objects that go out of the node, or empty array
		      if no such edge or node exists.
		      */
	
		      var fromNode, outEdges, toId, _ref;
		      fromNode = this._nodes[nodeId];
		      outEdges = [];
		      _ref = fromNode != null ? fromNode._outEdges : void 0;
		      for (toId in _ref) {
		        if (!__hasProp.call(_ref, toId)) continue;
		        outEdges.push(this.getEdge(nodeId, toId));
		      }
		      return outEdges;
		    };
	
		    Graph.prototype.getAllEdgesOf = function(nodeId) {
		      /*
		      **Note:** not the same as concatenating `getInEdgesOf()` and
		      `getOutEdgesOf()`. Some nodes might have an edge pointing toward itself.
		      This method solves that duplication.
		      
		      _Returns:_ an array of edge objects linked to the node, no matter if they're
		      outgoing or coming. Duplicate edge created by self-pointing nodes are
		      removed. Only one copy stays. Empty array if node has no edge.
		      */
	
		      var i, inEdges, outEdges, selfEdge, _i, _ref, _ref1;
		      inEdges = this.getInEdgesOf(nodeId);
		      outEdges = this.getOutEdgesOf(nodeId);
		      if (inEdges.length === 0) {
		        return outEdges;
		      }
		      selfEdge = this.getEdge(nodeId, nodeId);
		      for (i = _i = 0, _ref = inEdges.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
		        if (inEdges[i] === selfEdge) {
		          _ref1 = [inEdges[inEdges.length - 1], inEdges[i]], inEdges[i] = _ref1[0], inEdges[inEdges.length - 1] = _ref1[1];
		          inEdges.pop();
		          break;
		        }
		      }
		      return inEdges.concat(outEdges);
		    };
	
		    Graph.prototype.forEachNode = function(operation) {
		      /*
		      Traverse through the graph in an arbitrary manner, visiting each node once.
		      Pass a function of the form `fn(nodeObject, nodeId)`.
		      
		      _Returns:_ undefined.
		      */
	
		      var nodeId, nodeObject, _ref;
		      _ref = this._nodes;
		      for (nodeId in _ref) {
		        if (!__hasProp.call(_ref, nodeId)) continue;
		        nodeObject = _ref[nodeId];
		        operation(nodeObject, nodeId);
		      }
		    };
	
		    Graph.prototype.forEachEdge = function(operation) {
		      /*
		      Traverse through the graph in an arbitrary manner, visiting each edge once.
		      Pass a function of the form `fn(edgeObject)`.
		      
		      _Returns:_ undefined.
		      */
	
		      var edgeObject, nodeId, nodeObject, toId, _ref, _ref1;
		      _ref = this._nodes;
		      for (nodeId in _ref) {
		        if (!__hasProp.call(_ref, nodeId)) continue;
		        nodeObject = _ref[nodeId];
		        _ref1 = nodeObject._outEdges;
		        for (toId in _ref1) {
		          if (!__hasProp.call(_ref1, toId)) continue;
		          edgeObject = _ref1[toId];
		          operation(edgeObject);
		        }
		      }
		    };
	
		    return Graph;
	
		  })();
	
		  module.exports = Graph;
	
		}).call(this);
	
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		/*
		Minimum heap, i.e. smallest node at root.
	
		**Note:** does not accept null or undefined. This is by design. Those values
		cause comparison problems and might report false negative during extraction.
	
		## Overview example:
	
		```js
		var heap = new Heap([5, 6, 3, 4]);
		heap.add(10); // => 10
		heap.removeMin(); // => 3
		heap.peekMin(); // => 4
		```
	
		## Properties:
	
		- size: total number of items.
		*/
	
	
		(function() {
		  var Heap, _leftChild, _parent, _rightChild;
	
		  Heap = (function() {
		    function Heap(dataToHeapify) {
		      var i, item, _i, _j, _len, _ref;
		      if (dataToHeapify == null) {
		        dataToHeapify = [];
		      }
		      /*
		      Pass an optional array to be heapified. Takes only O(n) time.
		      */
	
		      this._data = [void 0];
		      for (_i = 0, _len = dataToHeapify.length; _i < _len; _i++) {
		        item = dataToHeapify[_i];
		        if (item != null) {
		          this._data.push(item);
		        }
		      }
		      if (this._data.length > 1) {
		        for (i = _j = 2, _ref = this._data.length; 2 <= _ref ? _j < _ref : _j > _ref; i = 2 <= _ref ? ++_j : --_j) {
		          this._upHeap(i);
		        }
		      }
		      this.size = this._data.length - 1;
		    }
	
		    Heap.prototype.add = function(value) {
		      /*
		      **Remember:** rejects null and undefined for mentioned reasons.
		      
		      _Returns:_ the value added.
		      */
	
		      if (value == null) {
		        return;
		      }
		      this._data.push(value);
		      this._upHeap(this._data.length - 1);
		      this.size++;
		      return value;
		    };
	
		    Heap.prototype.removeMin = function() {
		      /*
		      _Returns:_ the smallest item (the root).
		      */
	
		      var min;
		      if (this._data.length === 1) {
		        return;
		      }
		      this.size--;
		      if (this._data.length === 2) {
		        return this._data.pop();
		      }
		      min = this._data[1];
		      this._data[1] = this._data.pop();
		      this._downHeap();
		      return min;
		    };
	
		    Heap.prototype.peekMin = function() {
		      /*
		      Check the smallest item without removing it.
		      
		      _Returns:_ the smallest item (the root).
		      */
	
		      return this._data[1];
		    };
	
		    Heap.prototype._upHeap = function(index) {
		      var valueHolder, _ref;
		      valueHolder = this._data[index];
		      while (this._data[index] < this._data[_parent(index)] && index > 1) {
		        _ref = [this._data[_parent(index)], this._data[index]], this._data[index] = _ref[0], this._data[_parent(index)] = _ref[1];
		        index = _parent(index);
		      }
		    };
	
		    Heap.prototype._downHeap = function() {
		      var currentIndex, smallerChildIndex, _ref;
		      currentIndex = 1;
		      while (_leftChild(currentIndex < this._data.length)) {
		        smallerChildIndex = _leftChild(currentIndex);
		        if (smallerChildIndex < this._data.length - 1) {
		          if (this._data[_rightChild(currentIndex)] < this._data[smallerChildIndex]) {
		            smallerChildIndex = _rightChild(currentIndex);
		          }
		        }
		        if (this._data[smallerChildIndex] < this._data[currentIndex]) {
		          _ref = [this._data[currentIndex], this._data[smallerChildIndex]], this._data[smallerChildIndex] = _ref[0], this._data[currentIndex] = _ref[1];
		          currentIndex = smallerChildIndex;
		        } else {
		          break;
		        }
		      }
		    };
	
		    return Heap;
	
		  })();
	
		  _parent = function(index) {
		    return index >> 1;
		  };
	
		  _leftChild = function(index) {
		    return index << 1;
		  };
	
		  _rightChild = function(index) {
		    return (index << 1) + 1;
		  };
	
		  module.exports = Heap;
	
		}).call(this);
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		/*
		Doubly Linked.
	
		## Overview example:
	
		```js
		var list = new LinkedList([5, 4, 9]);
		list.add(12); // => 12
		list.head.next.value; // => 4
		list.tail.value; // => 12
		list.at(-1); // => 12
		list.removeAt(2); // => 9
		list.remove(4); // => 4
		list.indexOf(5); // => 0
		list.add(5, 1); // => 5. Second 5 at position 1.
		list.indexOf(5, 1); // => 1
		```
	
		## Properties:
	
		- head: first item.
		- tail: last item.
		- size: total number of items.
		- item.value: value passed to the item when calling `add()`.
		- item.prev: previous item.
		- item.next: next item.
		*/
	
	
		(function() {
		  var LinkedList;
	
		  LinkedList = (function() {
		    function LinkedList(valuesToAdd) {
		      var value, _i, _len;
		      if (valuesToAdd == null) {
		        valuesToAdd = [];
		      }
		      /*
		      Can pass an array of elements to link together during `new LinkedList()`
		      initiation.
		      */
	
		      this.head = {
		        prev: void 0,
		        value: void 0,
		        next: void 0
		      };
		      this.tail = {
		        prev: void 0,
		        value: void 0,
		        next: void 0
		      };
		      this.size = 0;
		      for (_i = 0, _len = valuesToAdd.length; _i < _len; _i++) {
		        value = valuesToAdd[_i];
		        this.add(value);
		      }
		    }
	
		    LinkedList.prototype.at = function(position) {
		      /*
		      Get the item at `position` (optional). Accepts negative index:
		      
		      ```js
		      myList.at(-1); // Returns the last element.
		      ```
		      However, passing a negative index that surpasses the boundary will return
		      undefined:
		      
		      ```js
		      myList = new LinkedList([2, 6, 8, 3])
		      myList.at(-5); // Undefined.
		      myList.at(-4); // 2.
		      ```
		      _Returns:_ item gotten, or undefined if not found.
		      */
	
		      var currentNode, i, _i, _j, _ref;
		      if (!((-this.size <= position && position < this.size))) {
		        return;
		      }
		      position = this._adjust(position);
		      if (position * 2 < this.size) {
		        currentNode = this.head;
		        for (i = _i = 1; _i <= position; i = _i += 1) {
		          currentNode = currentNode.next;
		        }
		      } else {
		        currentNode = this.tail;
		        for (i = _j = 1, _ref = this.size - position - 1; _j <= _ref; i = _j += 1) {
		          currentNode = currentNode.prev;
		        }
		      }
		      return currentNode;
		    };
	
		    LinkedList.prototype.add = function(value, position) {
		      var currentNode, nodeToAdd, _ref, _ref1, _ref2;
		      if (position == null) {
		        position = this.size;
		      }
		      /*
		      Add a new item at `position` (optional). Defaults to adding at the end.
		      `position`, just like in `at()`, can be negative (within the negative
		      boundary). Position specifies the place the value's going to be, and the old
		      node will be pushed higher. `add(-2)` on list of size 7 is the same as
		      `add(5)`.
		      
		      _Returns:_ item added.
		      */
	
		      if (!((-this.size <= position && position <= this.size))) {
		        return;
		      }
		      nodeToAdd = {
		        value: value
		      };
		      position = this._adjust(position);
		      if (this.size === 0) {
		        this.head = nodeToAdd;
		      } else {
		        if (position === 0) {
		          _ref = [nodeToAdd, this.head, nodeToAdd], this.head.prev = _ref[0], nodeToAdd.next = _ref[1], this.head = _ref[2];
		        } else {
		          currentNode = this.at(position - 1);
		          _ref1 = [currentNode.next, nodeToAdd, nodeToAdd, currentNode], nodeToAdd.next = _ref1[0], (_ref2 = currentNode.next) != null ? _ref2.prev = _ref1[1] : void 0, currentNode.next = _ref1[2], nodeToAdd.prev = _ref1[3];
		        }
		      }
		      if (position === this.size) {
		        this.tail = nodeToAdd;
		      }
		      this.size++;
		      return value;
		    };
	
		    LinkedList.prototype.removeAt = function(position) {
		      var currentNode, valueToReturn, _ref;
		      if (position == null) {
		        position = this.size - 1;
		      }
		      /*
		      Remove an item at index `position` (optional). Defaults to the last item.
		      Index can be negative (within the boundary).
		      
		      _Returns:_ item removed.
		      */
	
		      if (!((-this.size <= position && position < this.size))) {
		        return;
		      }
		      if (this.size === 0) {
		        return;
		      }
		      position = this._adjust(position);
		      if (this.size === 1) {
		        valueToReturn = this.head.value;
		        this.head.value = this.tail.value = void 0;
		      } else {
		        if (position === 0) {
		          valueToReturn = this.head.value;
		          this.head = this.head.next;
		          this.head.prev = void 0;
		        } else {
		          currentNode = this.at(position);
		          valueToReturn = currentNode.value;
		          currentNode.prev.next = currentNode.next;
		          if ((_ref = currentNode.next) != null) {
		            _ref.prev = currentNode.prev;
		          }
		          if (position === this.size - 1) {
		            this.tail = currentNode.prev;
		          }
		        }
		      }
		      this.size--;
		      return valueToReturn;
		    };
	
		    LinkedList.prototype.remove = function(value) {
		      /*
		      Remove the item using its value instead of position. **Will remove the fist
		      occurrence of `value`.**
		      
		      _Returns:_ the value, or undefined if value's not found.
		      */
	
		      var currentNode;
		      if (value == null) {
		        return;
		      }
		      currentNode = this.head;
		      while (currentNode && currentNode.value !== value) {
		        currentNode = currentNode.next;
		      }
		      if (!currentNode) {
		        return;
		      }
		      if (this.size === 1) {
		        this.head.value = this.tail.value = void 0;
		      } else if (currentNode === this.head) {
		        this.head = this.head.next;
		        this.head.prev = void 0;
		      } else if (currentNode === this.tail) {
		        this.tail = this.tail.prev;
		        this.tail.next = void 0;
		      } else {
		        currentNode.prev.next = currentNode.next;
		        currentNode.next.prev = currentNode.prev;
		      }
		      this.size--;
		      return value;
		    };
	
		    LinkedList.prototype.indexOf = function(value, startingPosition) {
		      var currentNode, position;
		      if (startingPosition == null) {
		        startingPosition = 0;
		      }
		      /*
		      Find the index of an item, similarly to `array.indexOf()`. Defaults to start
		      searching from the beginning, by can start at another position by passing
		      `startingPosition`. This parameter can also be negative; but unlike the
		      other methods of this class, `startingPosition` (optional) can be as small
		      as desired; a value of -999 for a list of size 5 will start searching
		      normally, at the beginning.
		      
		      **Note:** searches forwardly, **not** backwardly, i.e:
		      
		      ```js
		      var myList = new LinkedList([2, 3, 1, 4, 3, 5])
		      myList.indexOf(3, -3); // Returns 4, not 1
		      ```
		      _Returns:_ index of item found, or -1 if not found.
		      */
	
		      if (((this.head.value == null) && !this.head.next) || startingPosition >= this.size) {
		        return -1;
		      }
		      startingPosition = Math.max(0, this._adjust(startingPosition));
		      currentNode = this.at(startingPosition);
		      position = startingPosition;
		      while (currentNode) {
		        if (currentNode.value === value) {
		          break;
		        }
		        currentNode = currentNode.next;
		        position++;
		      }
		      if (position === this.size) {
		        return -1;
		      } else {
		        return position;
		      }
		    };
	
		    LinkedList.prototype._adjust = function(position) {
		      if (position < 0) {
		        return this.size + position;
		      } else {
		        return position;
		      }
		    };
	
		    return LinkedList;
	
		  })();
	
		  module.exports = LinkedList;
	
		}).call(this);
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		/*
		Kind of a stopgap measure for the upcoming [JavaScript
		Map](http://wiki.ecmascript.org/doku.php?id=harmony:simple_maps_and_sets)
	
		**Note:** due to JavaScript's limitations, hashing something other than Boolean,
		Number, String, Undefined, Null, RegExp, Function requires a hack that inserts a
		hidden unique property into the object. This means `set`, `get`, `has` and
		`delete` must employ the same object, and not a mere identical copy as in the
		case of, say, a string.
	
		## Overview example:
	
		```js
		var map = new Map({'alice': 'wonderland', 20: 'ok'});
		map.set('20', 5); // => 5
		map.get('20'); // => 5
		map.has('alice'); // => true
		map.delete(20) // => true
		var arr = [1, 2];
		map.add(arr, 'goody'); // => 'goody'
		map.has(arr); // => true
		map.has([1, 2]); // => false. Needs to compare by reference
		map.forEach(function(key, value) {
		  console.log(key, value);
		});
		```
	
		## Properties:
	
		- size: The total number of `(key, value)` pairs.
		*/
	
	
		(function() {
		  var Map, SPECIAL_TYPE_KEY_PREFIX, _extractDataType, _isSpecialType,
		    __hasProp = {}.hasOwnProperty;
	
		  SPECIAL_TYPE_KEY_PREFIX = '_mapId_';
	
		  Map = (function() {
		    Map._mapIdTracker = 0;
	
		    Map._newMapId = function() {
		      return this._mapIdTracker++;
		    };
	
		    function Map(objectToMap) {
		      /*
		      Pass an optional object whose (key, value) pair will be hashed. **Careful**
		      not to pass something like {5: 'hi', '5': 'hello'}, since JavaScript's
		      native object behavior will crush the first 5 property before it gets to
		      constructor.
		      */
	
		      var key, value;
		      this._content = {};
		      this._itemId = 0;
		      this._id = Map._newMapId();
		      this.size = 0;
		      for (key in objectToMap) {
		        if (!__hasProp.call(objectToMap, key)) continue;
		        value = objectToMap[key];
		        this.set(key, value);
		      }
		    }
	
		    Map.prototype.hash = function(key, makeHash) {
		      var propertyForMap, type;
		      if (makeHash == null) {
		        makeHash = false;
		      }
		      /*
		      The hash function for hashing keys is public. Feel free to replace it with
		      your own. The `makeHash` parameter is optional and accepts a boolean
		      (defaults to `false`) indicating whether or not to produce a new hash (for
		      the first use, naturally).
		      
		      _Returns:_ the hash.
		      */
	
		      type = _extractDataType(key);
		      if (_isSpecialType(key)) {
		        propertyForMap = SPECIAL_TYPE_KEY_PREFIX + this._id;
		        if (makeHash && !key[propertyForMap]) {
		          key[propertyForMap] = this._itemId++;
		        }
		        return propertyForMap + '_' + key[propertyForMap];
		      } else {
		        return type + '_' + key;
		      }
		    };
	
		    Map.prototype.set = function(key, value) {
		      /*
		      _Returns:_ value.
		      */
	
		      if (!this.has(key)) {
		        this.size++;
		      }
		      this._content[this.hash(key, true)] = [value, key];
		      return value;
		    };
	
		    Map.prototype.get = function(key) {
		      /*
		      _Returns:_ value corresponding to the key, or undefined if not found.
		      */
	
		      var _ref;
		      return (_ref = this._content[this.hash(key)]) != null ? _ref[0] : void 0;
		    };
	
		    Map.prototype.has = function(key) {
		      /*
		      Check whether a value exists for the key.
		      
		      _Returns:_ true or false.
		      */
	
		      return this.hash(key) in this._content;
		    };
	
		    Map.prototype["delete"] = function(key) {
		      /*
		      Remove the (key, value) pair.
		      
		      _Returns:_ **true or false**. Unlike most of this library, this method
		      doesn't return the deleted value. This is so that it conforms to the future
		      JavaScript `map.delete()`'s behavior.
		      */
	
		      var hashedKey;
		      hashedKey = this.hash(key);
		      if (hashedKey in this._content) {
		        delete this._content[hashedKey];
		        if (_isSpecialType(key)) {
		          delete key[SPECIAL_TYPE_KEY_PREFIX + this._id];
		        }
		        this.size--;
		        return true;
		      }
		      return false;
		    };
	
		    Map.prototype.forEach = function(operation) {
		      /*
		      Traverse through the map. Pass a function of the form `fn(key, value)`.
		      
		      _Returns:_ undefined.
		      */
	
		      var key, value, _ref;
		      _ref = this._content;
		      for (key in _ref) {
		        if (!__hasProp.call(_ref, key)) continue;
		        value = _ref[key];
		        operation(value[1], value[0]);
		      }
		    };
	
		    return Map;
	
		  })();
	
		  _isSpecialType = function(key) {
		    var simpleHashableTypes, simpleType, type, _i, _len;
		    simpleHashableTypes = ['Boolean', 'Number', 'String', 'Undefined', 'Null', 'RegExp', 'Function'];
		    type = _extractDataType(key);
		    for (_i = 0, _len = simpleHashableTypes.length; _i < _len; _i++) {
		      simpleType = simpleHashableTypes[_i];
		      if (type === simpleType) {
		        return false;
		      }
		    }
		    return true;
		  };
	
		  _extractDataType = function(type) {
		    return Object.prototype.toString.apply(type).match(/\[object (.+)\]/)[1];
		  };
	
		  module.exports = Map;
	
		}).call(this);
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		/*
		Amortized O(1) dequeue!
	
		## Overview example:
	
		```js
		var queue = new Queue([1, 6, 4]);
		queue.enqueue(10); // => 10
		queue.dequeue(); // => 1
		queue.dequeue(); // => 6
		queue.dequeue(); // => 4
		queue.peek(); // => 10
		queue.dequeue(); // => 10
		queue.peek(); // => undefined
		```
	
		## Properties:
	
		- size: The total number of items.
		*/
	
	
		(function() {
		  var Queue;
	
		  Queue = (function() {
		    function Queue(initialArray) {
		      if (initialArray == null) {
		        initialArray = [];
		      }
		      /*
		      Pass an optional array to be transformed into a queue. The item at index 0
		      is the first to be dequeued.
		      */
	
		      this._content = initialArray;
		      this._dequeueIndex = 0;
		      this.size = this._content.length;
		    }
	
		    Queue.prototype.enqueue = function(item) {
		      /*
		      _Returns:_ the item.
		      */
	
		      this.size++;
		      this._content.push(item);
		      return item;
		    };
	
		    Queue.prototype.dequeue = function() {
		      /*
		      _Returns:_ the dequeued item.
		      */
	
		      var itemToDequeue;
		      if (this.size === 0) {
		        return;
		      }
		      this.size--;
		      itemToDequeue = this._content[this._dequeueIndex];
		      this._dequeueIndex++;
		      if (this._dequeueIndex * 2 > this._content.length) {
		        this._content = this._content.slice(this._dequeueIndex);
		        this._dequeueIndex = 0;
		      }
		      return itemToDequeue;
		    };
	
		    Queue.prototype.peek = function() {
		      /*
		      Check the next item to be dequeued, without removing it.
		      
		      _Returns:_ the item.
		      */
	
		      return this._content[this._dequeueIndex];
		    };
	
		    return Queue;
	
		  })();
	
		  module.exports = Queue;
	
		}).call(this);
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		/*
		Credit to Wikipedia's article on [Red-black
		tree](http://en.wikipedia.org/wiki/Red–black_tree)
	
		**Note:** doesn't handle duplicate entries, undefined and null. This is by
		design.
	
		## Overview example:
	
		```js
		var rbt = new RedBlackTree([7, 5, 1, 8]);
		rbt.add(2); // => 2
		rbt.add(10); // => 10
		rbt.has(5); // => true
		rbt.peekMin(); // => 1
		rbt.peekMax(); // => 10
		rbt.removeMin(); // => 1
		rbt.removeMax(); // => 10
		rbt.remove(8); // => 8
		```
	
		## Properties:
	
		- size: The total number of items.
		*/
	
	
		(function() {
		  var BLACK, NODE_FOUND, NODE_TOO_BIG, NODE_TOO_SMALL, RED, RedBlackTree, STOP_SEARCHING, _findNode, _grandParentOf, _isLeft, _leftOrRight, _peekMaxNode, _peekMinNode, _siblingOf, _uncleOf;
	
		  NODE_FOUND = 0;
	
		  NODE_TOO_BIG = 1;
	
		  NODE_TOO_SMALL = 2;
	
		  STOP_SEARCHING = 3;
	
		  RED = 1;
	
		  BLACK = 2;
	
		  RedBlackTree = (function() {
		    function RedBlackTree(valuesToAdd) {
		      var value, _i, _len;
		      if (valuesToAdd == null) {
		        valuesToAdd = [];
		      }
		      /*
		      Pass an optional array to be turned into binary tree. **Note:** does not
		      accept duplicate, undefined and null.
		      */
	
		      this._root;
		      this.size = 0;
		      for (_i = 0, _len = valuesToAdd.length; _i < _len; _i++) {
		        value = valuesToAdd[_i];
		        if (value != null) {
		          this.add(value);
		        }
		      }
		    }
	
		    RedBlackTree.prototype.add = function(value) {
		      /*
		      Again, make sure to not pass a value already in the tree, or undefined, or
		      null.
		      
		      _Returns:_ value added.
		      */
	
		      var currentNode, foundNode, nodeToInsert, _ref;
		      if (value == null) {
		        return;
		      }
		      this.size++;
		      nodeToInsert = {
		        value: value,
		        _color: RED
		      };
		      if (!this._root) {
		        this._root = nodeToInsert;
		      } else {
		        foundNode = _findNode(this._root, function(node) {
		          if (value === node.value) {
		            return NODE_FOUND;
		          } else {
		            if (value < node.value) {
		              if (node._left) {
		                return NODE_TOO_BIG;
		              } else {
		                nodeToInsert._parent = node;
		                node._left = nodeToInsert;
		                return STOP_SEARCHING;
		              }
		            } else {
		              if (node._right) {
		                return NODE_TOO_SMALL;
		              } else {
		                nodeToInsert._parent = node;
		                node._right = nodeToInsert;
		                return STOP_SEARCHING;
		              }
		            }
		          }
		        });
		        if (foundNode != null) {
		          return;
		        }
		      }
		      currentNode = nodeToInsert;
		      while (true) {
		        if (currentNode === this._root) {
		          currentNode._color = BLACK;
		          break;
		        }
		        if (currentNode._parent._color === BLACK) {
		          break;
		        }
		        if (((_ref = _uncleOf(currentNode)) != null ? _ref._color : void 0) === RED) {
		          currentNode._parent._color = BLACK;
		          _uncleOf(currentNode)._color = BLACK;
		          _grandParentOf(currentNode)._color = RED;
		          currentNode = _grandParentOf(currentNode);
		          continue;
		        }
		        if (!_isLeft(currentNode) && _isLeft(currentNode._parent)) {
		          this._rotateLeft(currentNode._parent);
		          currentNode = currentNode._left;
		        } else if (_isLeft(currentNode) && !_isLeft(currentNode._parent)) {
		          this._rotateRight(currentNode._parent);
		          currentNode = currentNode._right;
		        }
		        currentNode._parent._color = BLACK;
		        _grandParentOf(currentNode)._color = RED;
		        if (_isLeft(currentNode)) {
		          this._rotateRight(_grandParentOf(currentNode));
		        } else {
		          this._rotateLeft(_grandParentOf(currentNode));
		        }
		        break;
		      }
		      return value;
		    };
	
		    RedBlackTree.prototype.has = function(value) {
		      /*
		      _Returns:_ true or false.
		      */
	
		      var foundNode;
		      foundNode = _findNode(this._root, function(node) {
		        if (value === node.value) {
		          return NODE_FOUND;
		        } else if (value < node.value) {
		          return NODE_TOO_BIG;
		        } else {
		          return NODE_TOO_SMALL;
		        }
		      });
		      if (foundNode) {
		        return true;
		      } else {
		        return false;
		      }
		    };
	
		    RedBlackTree.prototype.peekMin = function() {
		      /*
		      Check the minimum value without removing it.
		      
		      _Returns:_ the minimum value.
		      */
	
		      var _ref;
		      return (_ref = _peekMinNode(this._root)) != null ? _ref.value : void 0;
		    };
	
		    RedBlackTree.prototype.peekMax = function() {
		      /*
		      Check the maximum value without removing it.
		      
		      _Returns:_ the maximum value.
		      */
	
		      var _ref;
		      return (_ref = _peekMaxNode(this._root)) != null ? _ref.value : void 0;
		    };
	
		    RedBlackTree.prototype.remove = function(value) {
		      /*
		      _Returns:_ the value removed, or undefined if the value's not found.
		      */
	
		      var foundNode;
		      foundNode = _findNode(this._root, function(node) {
		        if (value === node.value) {
		          return NODE_FOUND;
		        } else if (value < node.value) {
		          return NODE_TOO_BIG;
		        } else {
		          return NODE_TOO_SMALL;
		        }
		      });
		      if (!foundNode) {
		        return;
		      }
		      this._removeNode(this._root, foundNode);
		      this.size--;
		      return value;
		    };
	
		    RedBlackTree.prototype.removeMin = function() {
		      /*
		      _Returns:_ smallest item removed, or undefined if tree's empty.
		      */
	
		      var nodeToRemove, valueToReturn;
		      nodeToRemove = _peekMinNode(this._root);
		      if (!nodeToRemove) {
		        return;
		      }
		      valueToReturn = nodeToRemove.value;
		      this._removeNode(this._root, nodeToRemove);
		      return valueToReturn;
		    };
	
		    RedBlackTree.prototype.removeMax = function() {
		      /*
		      _Returns:_ biggest item removed, or undefined if tree's empty.
		      */
	
		      var nodeToRemove, valueToReturn;
		      nodeToRemove = _peekMaxNode(this._root);
		      if (!nodeToRemove) {
		        return;
		      }
		      valueToReturn = nodeToRemove.value;
		      this._removeNode(this._root, nodeToRemove);
		      return valueToReturn;
		    };
	
		    RedBlackTree.prototype._removeNode = function(root, node) {
		      var sibling, successor, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;
		      if (node._left && node._right) {
		        successor = _peekMinNode(node._right);
		        node.value = successor.value;
		        node = successor;
		      }
		      successor = node._left || node._right;
		      if (!successor) {
		        successor = {
		          color: BLACK,
		          _right: void 0,
		          _left: void 0,
		          isLeaf: true
		        };
		      }
		      successor._parent = node._parent;
		      if ((_ref = node._parent) != null) {
		        _ref[_leftOrRight(node)] = successor;
		      }
		      if (node._color === BLACK) {
		        if (successor._color === RED) {
		          successor._color = BLACK;
		          if (!successor._parent) {
		            this._root = successor;
		          }
		        } else {
		          while (true) {
		            if (!successor._parent) {
		              if (!successor.isLeaf) {
		                this._root = successor;
		              } else {
		                this._root = void 0;
		              }
		              break;
		            }
		            sibling = _siblingOf(successor);
		            if ((sibling != null ? sibling._color : void 0) === RED) {
		              successor._parent._color = RED;
		              sibling._color = BLACK;
		              if (_isLeft(successor)) {
		                this._rotateLeft(successor._parent);
		              } else {
		                this._rotateRight(successor._parent);
		              }
		            }
		            sibling = _siblingOf(successor);
		            if (successor._parent._color === BLACK && (!sibling || (sibling._color === BLACK && (!sibling._left || sibling._left._color === BLACK) && (!sibling._right || sibling._right._color === BLACK)))) {
		              if (sibling != null) {
		                sibling._color = RED;
		              }
		              if (successor.isLeaf) {
		                successor._parent[_leftOrRight(successor)] = void 0;
		              }
		              successor = successor._parent;
		              continue;
		            }
		            if (successor._parent._color === RED && (!sibling || (sibling._color === BLACK && (!sibling._left || ((_ref1 = sibling._left) != null ? _ref1._color : void 0) === BLACK) && (!sibling._right || ((_ref2 = sibling._right) != null ? _ref2._color : void 0) === BLACK)))) {
		              if (sibling != null) {
		                sibling._color = RED;
		              }
		              successor._parent._color = BLACK;
		              break;
		            }
		            if ((sibling != null ? sibling._color : void 0) === BLACK) {
		              if (_isLeft(successor) && (!sibling._right || sibling._right._color === BLACK) && ((_ref3 = sibling._left) != null ? _ref3._color : void 0) === RED) {
		                sibling._color = RED;
		                if ((_ref4 = sibling._left) != null) {
		                  _ref4._color = BLACK;
		                }
		                this._rotateRight(sibling);
		              } else if (!_isLeft(successor) && (!sibling._left || sibling._left._color === BLACK) && ((_ref5 = sibling._right) != null ? _ref5._color : void 0) === RED) {
		                sibling._color = RED;
		                if ((_ref6 = sibling._right) != null) {
		                  _ref6._color = BLACK;
		                }
		                this._rotateLeft(sibling);
		              }
		              break;
		            }
		            sibling = _siblingOf(successor);
		            sibling._color = successor._parent._color;
		            if (_isLeft(successor)) {
		              sibling._right._color = BLACK;
		              this._rotateRight(successor._parent);
		            } else {
		              sibling._left._color = BLACK;
		              this._rotateLeft(successor._parent);
		            }
		          }
		        }
		      }
		      if (successor.isLeaf) {
		        return (_ref7 = successor._parent) != null ? _ref7[_leftOrRight(successor)] = void 0 : void 0;
		      }
		    };
	
		    RedBlackTree.prototype._rotateLeft = function(node) {
		      var _ref, _ref1;
		      if ((_ref = node._parent) != null) {
		        _ref[_leftOrRight(node)] = node._right;
		      }
		      node._right._parent = node._parent;
		      node._parent = node._right;
		      node._right = node._right._left;
		      node._parent._left = node;
		      if ((_ref1 = node._right) != null) {
		        _ref1._parent = node;
		      }
		      if (node._parent._parent == null) {
		        return this._root = node._parent;
		      }
		    };
	
		    RedBlackTree.prototype._rotateRight = function(node) {
		      var _ref, _ref1;
		      if ((_ref = node._parent) != null) {
		        _ref[_leftOrRight(node)] = node._left;
		      }
		      node._left._parent = node._parent;
		      node._parent = node._left;
		      node._left = node._left._right;
		      node._parent._right = node;
		      if ((_ref1 = node._left) != null) {
		        _ref1._parent = node;
		      }
		      if (node._parent._parent == null) {
		        return this._root = node._parent;
		      }
		    };
	
		    return RedBlackTree;
	
		  })();
	
		  _isLeft = function(node) {
		    return node === node._parent._left;
		  };
	
		  _leftOrRight = function(node) {
		    if (_isLeft(node)) {
		      return '_left';
		    } else {
		      return '_right';
		    }
		  };
	
		  _findNode = function(startingNode, comparator) {
		    var comparisonResult, currentNode, foundNode;
		    currentNode = startingNode;
		    foundNode = void 0;
		    while (currentNode) {
		      comparisonResult = comparator(currentNode);
		      if (comparisonResult === NODE_FOUND) {
		        foundNode = currentNode;
		        break;
		      }
		      if (comparisonResult === NODE_TOO_BIG) {
		        currentNode = currentNode._left;
		      } else if (comparisonResult === NODE_TOO_SMALL) {
		        currentNode = currentNode._right;
		      } else if (comparisonResult === STOP_SEARCHING) {
		        break;
		      }
		    }
		    return foundNode;
		  };
	
		  _peekMinNode = function(startingNode) {
		    return _findNode(startingNode, function(node) {
		      if (node._left) {
		        return NODE_TOO_BIG;
		      } else {
		        return NODE_FOUND;
		      }
		    });
		  };
	
		  _peekMaxNode = function(startingNode) {
		    return _findNode(startingNode, function(node) {
		      if (node._right) {
		        return NODE_TOO_SMALL;
		      } else {
		        return NODE_FOUND;
		      }
		    });
		  };
	
		  _grandParentOf = function(node) {
		    var _ref;
		    return (_ref = node._parent) != null ? _ref._parent : void 0;
		  };
	
		  _uncleOf = function(node) {
		    if (!_grandParentOf(node)) {
		      return;
		    }
		    if (_isLeft(node._parent)) {
		      return _grandParentOf(node)._right;
		    } else {
		      return _grandParentOf(node)._left;
		    }
		  };
	
		  _siblingOf = function(node) {
		    if (_isLeft(node)) {
		      return node._parent._right;
		    } else {
		      return node._parent._left;
		    }
		  };
	
		  module.exports = RedBlackTree;
	
		}).call(this);
	
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		/*
		Good for fast insertion/removal/lookup of strings.
	
		## Overview example:
	
		```js
		var trie = new Trie(['bear', 'beer']);
		trie.add('hello'); // => 'hello'
		trie.add('helloha!'); // => 'helloha!'
		trie.has('bears'); // => false
		trie.longestPrefixOf('beatrice'); // => 'bea'
		trie.wordsWithPrefix('hel'); // => ['hello', 'helloha!']
		trie.remove('beers'); // => undefined. 'beer' still exists
		trie.remove('Beer') // => undefined. Case-sensitive
		trie.remove('beer') // => 'beer'. Removed
		```
	
		## Properties:
	
		- size: The total number of words.
		*/
	
	
		(function() {
		  var Queue, Trie, WORD_END, _hasAtLeastNChildren,
		    __hasProp = {}.hasOwnProperty;
	
		  Queue = __webpack_require__(6);
	
		  WORD_END = 'end';
	
		  Trie = (function() {
		    function Trie(words) {
		      var word, _i, _len;
		      if (words == null) {
		        words = [];
		      }
		      /*
		      Pass an optional array of strings to be inserted initially.
		      */
	
		      this._root = {};
		      this.size = 0;
		      for (_i = 0, _len = words.length; _i < _len; _i++) {
		        word = words[_i];
		        this.add(word);
		      }
		    }
	
		    Trie.prototype.add = function(word) {
		      /*
		      Add a whole string to the trie.
		      
		      _Returns:_ the word added. Will return undefined (without adding the value)
		      if the word passed is null or undefined.
		      */
	
		      var currentNode, letter, _i, _len;
		      if (word == null) {
		        return;
		      }
		      this.size++;
		      currentNode = this._root;
		      for (_i = 0, _len = word.length; _i < _len; _i++) {
		        letter = word[_i];
		        if (currentNode[letter] == null) {
		          currentNode[letter] = {};
		        }
		        currentNode = currentNode[letter];
		      }
		      currentNode[WORD_END] = true;
		      return word;
		    };
	
		    Trie.prototype.has = function(word) {
		      /*
		      __Returns:_ true or false.
		      */
	
		      var currentNode, letter, _i, _len;
		      if (word == null) {
		        return false;
		      }
		      currentNode = this._root;
		      for (_i = 0, _len = word.length; _i < _len; _i++) {
		        letter = word[_i];
		        if (currentNode[letter] == null) {
		          return false;
		        }
		        currentNode = currentNode[letter];
		      }
		      if (currentNode[WORD_END]) {
		        return true;
		      } else {
		        return false;
		      }
		    };
	
		    Trie.prototype.longestPrefixOf = function(word) {
		      /*
		      Find all words containing the prefix. The word itself counts as a prefix.
		      
		      ```js
		      var trie = new Trie;
		      trie.add('hello');
		      trie.longestPrefixOf('he'); // 'he'
		      trie.longestPrefixOf('hello'); // 'hello'
		      trie.longestPrefixOf('helloha!'); // 'hello'
		      ```
		      
		      _Returns:_ the prefix string, or empty string if no prefix found.
		      */
	
		      var currentNode, letter, prefix, _i, _len;
		      if (word == null) {
		        return '';
		      }
		      currentNode = this._root;
		      prefix = '';
		      for (_i = 0, _len = word.length; _i < _len; _i++) {
		        letter = word[_i];
		        if (currentNode[letter] == null) {
		          break;
		        }
		        prefix += letter;
		        currentNode = currentNode[letter];
		      }
		      return prefix;
		    };
	
		    Trie.prototype.wordsWithPrefix = function(prefix) {
		      /*
		      Find all words containing the prefix. The word itself counts as a prefix.
		      **Watch out for edge cases.**
		      
		      ```js
		      var trie = new Trie;
		      trie.wordsWithPrefix(''); // []. Check later case below.
		      trie.add('');
		      trie.wordsWithPrefix(''); // ['']
		      trie.add('he');
		      trie.add('hello');
		      trie.add('hell');
		      trie.add('bear');
		      trie.add('z');
		      trie.add('zebra');
		      trie.wordsWithPrefix('hel'); // ['hell', 'hello']
		      ```
		      
		      _Returns:_ an array of strings, or empty array if no word found.
		      */
	
		      var accumulatedLetters, currentNode, letter, node, queue, subNode, words, _i, _len, _ref;
		      if (prefix == null) {
		        return [];
		      }
		      (prefix != null) || (prefix = '');
		      words = [];
		      currentNode = this._root;
		      for (_i = 0, _len = prefix.length; _i < _len; _i++) {
		        letter = prefix[_i];
		        currentNode = currentNode[letter];
		        if (currentNode == null) {
		          return [];
		        }
		      }
		      queue = new Queue();
		      queue.enqueue([currentNode, '']);
		      while (queue.size !== 0) {
		        _ref = queue.dequeue(), node = _ref[0], accumulatedLetters = _ref[1];
		        if (node[WORD_END]) {
		          words.push(prefix + accumulatedLetters);
		        }
		        for (letter in node) {
		          if (!__hasProp.call(node, letter)) continue;
		          subNode = node[letter];
		          queue.enqueue([subNode, accumulatedLetters + letter]);
		        }
		      }
		      return words;
		    };
	
		    Trie.prototype.remove = function(word) {
		      /*
		      _Returns:_ the string removed, or undefined if the word in its whole doesn't
		      exist. **Note:** this means removing `beers` when only `beer` exists will
		      return undefined and conserve `beer`.
		      */
	
		      var currentNode, i, letter, prefix, _i, _j, _len, _ref;
		      if (word == null) {
		        return;
		      }
		      currentNode = this._root;
		      prefix = [];
		      for (_i = 0, _len = word.length; _i < _len; _i++) {
		        letter = word[_i];
		        if (currentNode[letter] == null) {
		          return;
		        }
		        currentNode = currentNode[letter];
		        prefix.push([letter, currentNode]);
		      }
		      if (!currentNode[WORD_END]) {
		        return;
		      }
		      this.size--;
		      delete currentNode[WORD_END];
		      if (_hasAtLeastNChildren(currentNode, 1)) {
		        return word;
		      }
		      for (i = _j = _ref = prefix.length - 1; _ref <= 1 ? _j <= 1 : _j >= 1; i = _ref <= 1 ? ++_j : --_j) {
		        if (!_hasAtLeastNChildren(prefix[i][1], 1)) {
		          delete prefix[i - 1][1][prefix[i][0]];
		        } else {
		          break;
		        }
		      }
		      if (!_hasAtLeastNChildren(this._root[prefix[0][0]], 1)) {
		        delete this._root[prefix[0][0]];
		      }
		      return word;
		    };
	
		    return Trie;
	
		  })();
	
		  _hasAtLeastNChildren = function(node, n) {
		    var child, childCount;
		    if (n === 0) {
		      return true;
		    }
		    childCount = 0;
		    for (child in node) {
		      if (!__hasProp.call(node, child)) continue;
		      childCount++;
		      if (childCount >= n) {
		        return true;
		      }
		    }
		    return false;
		  };
	
		  module.exports = Trie;
	
		}).call(this);
	
	
	/***/ }
	/******/ ]);;angular.module('uiGmapgoogle-maps.wrapped')
	.service('uiGmapMarkerSpiderfier', [ 'uiGmapGoogleMapApi', function(GoogleMapApi) {
	  var self = this;
	  /* istanbul ignore next */
	  +function(){
	    
	/** @preserve OverlappingMarkerSpiderfier
	https://github.com/jawj/OverlappingMarkerSpiderfier
	Copyright (c) 2011 - 2013 George MacKerron
	Released under the MIT licence: http://opensource.org/licenses/mit-license
	Note: The Google Maps API v3 must be included *before* this code
	 */
	var hasProp = {}.hasOwnProperty,
	  slice = [].slice;
	
	this['OverlappingMarkerSpiderfier'] = (function() {
	  var ge, gm, j, lcH, lcU, len, mt, p, ref, twoPi, x;
	
	  p = _Class.prototype;
	
	  ref = [_Class, p];
	  for (j = 0, len = ref.length; j < len; j++) {
	    x = ref[j];
	    x['VERSION'] = '0.3.3';
	  }
	
	  gm = void 0;
	
	  ge = void 0;
	
	  mt = void 0;
	
	  twoPi = Math.PI * 2;
	
	  p['keepSpiderfied'] = false;
	
	  p['markersWontHide'] = false;
	
	  p['markersWontMove'] = false;
	
	  p['nearbyDistance'] = 20;
	
	  p['circleSpiralSwitchover'] = 9;
	
	  p['circleFootSeparation'] = 23;
	
	  p['circleStartAngle'] = twoPi / 12;
	
	  p['spiralFootSeparation'] = 26;
	
	  p['spiralLengthStart'] = 11;
	
	  p['spiralLengthFactor'] = 4;
	
	  p['spiderfiedZIndex'] = 1000;
	
	  p['usualLegZIndex'] = 10;
	
	  p['highlightedLegZIndex'] = 20;
	
	  p['event'] = 'click';
	
	  p['minZoomLevel'] = false;
	
	  p['legWeight'] = 1.5;
	
	  p['legColors'] = {
	    'usual': {},
	    'highlighted': {}
	  };
	
	  lcU = p['legColors']['usual'];
	
	  lcH = p['legColors']['highlighted'];
	
	  _Class['initializeGoogleMaps'] = function(google) {
	    gm = google.maps;
	    ge = gm.event;
	    mt = gm.MapTypeId;
	    lcU[mt.HYBRID] = lcU[mt.SATELLITE] = '#fff';
	    lcH[mt.HYBRID] = lcH[mt.SATELLITE] = '#f00';
	    lcU[mt.TERRAIN] = lcU[mt.ROADMAP] = '#444';
	    lcH[mt.TERRAIN] = lcH[mt.ROADMAP] = '#f00';
	    this.ProjHelper = function(map) {
	      return this.setMap(map);
	    };
	    this.ProjHelper.prototype = new gm.OverlayView();
	    return this.ProjHelper.prototype['draw'] = function() {};
	  };
	
	  function _Class(map1, opts) {
	    var e, k, l, len1, ref1, v;
	    this.map = map1;
	    if (opts == null) {
	      opts = {};
	    }
	    for (k in opts) {
	      if (!hasProp.call(opts, k)) continue;
	      v = opts[k];
	      this[k] = v;
	    }
	    this.projHelper = new this.constructor.ProjHelper(this.map);
	    this.initMarkerArrays();
	    this.listeners = {};
	    ref1 = ['click', 'zoom_changed', 'maptypeid_changed'];
	    for (l = 0, len1 = ref1.length; l < len1; l++) {
	      e = ref1[l];
	      ge.addListener(this.map, e, (function(_this) {
	        return function() {
	          return _this['unspiderfy']();
	        };
	      })(this));
	    }
	  }
	
	  p.initMarkerArrays = function() {
	    this.markers = [];
	    return this.markerListenerRefs = [];
	  };
	
	  p['addMarker'] = function(marker) {
	    var listenerRefs;
	    if (marker['_oms'] != null) {
	      return this;
	    }
	    marker['_oms'] = true;
	    listenerRefs = [
	      ge.addListener(marker, this['event'], (function(_this) {
	        return function(event) {
	          return _this.spiderListener(marker, event);
	        };
	      })(this))
	    ];
	    if (!this['markersWontHide']) {
	      listenerRefs.push(ge.addListener(marker, 'visible_changed', (function(_this) {
	        return function() {
	          return _this.markerChangeListener(marker, false);
	        };
	      })(this)));
	    }
	    if (!this['markersWontMove']) {
	      listenerRefs.push(ge.addListener(marker, 'position_changed', (function(_this) {
	        return function() {
	          return _this.markerChangeListener(marker, true);
	        };
	      })(this)));
	    }
	    this.markerListenerRefs.push(listenerRefs);
	    this.markers.push(marker);
	    return this;
	  };
	
	  p.markerChangeListener = function(marker, positionChanged) {
	    if ((marker['_omsData'] != null) && (positionChanged || !marker.getVisible()) && !((this.spiderfying != null) || (this.unspiderfying != null))) {
	      return this['unspiderfy'](positionChanged ? marker : null);
	    }
	  };
	
	  p['getMarkers'] = function() {
	    return this.markers.slice(0);
	  };
	
	  p['removeMarker'] = function(marker) {
	    var i, l, len1, listenerRef, listenerRefs;
	    if (marker['_omsData'] != null) {
	      this['unspiderfy']();
	    }
	    i = this.arrIndexOf(this.markers, marker);
	    if (i < 0) {
	      return this;
	    }
	    listenerRefs = this.markerListenerRefs.splice(i, 1)[0];
	    for (l = 0, len1 = listenerRefs.length; l < len1; l++) {
	      listenerRef = listenerRefs[l];
	      ge.removeListener(listenerRef);
	    }
	    delete marker['_oms'];
	    this.markers.splice(i, 1);
	    return this;
	  };
	
	  p['clearMarkers'] = function() {
	    var i, l, len1, len2, listenerRef, listenerRefs, marker, n, ref1;
	    this['unspiderfy']();
	    ref1 = this.markers;
	    for (i = l = 0, len1 = ref1.length; l < len1; i = ++l) {
	      marker = ref1[i];
	      listenerRefs = this.markerListenerRefs[i];
	      for (n = 0, len2 = listenerRefs.length; n < len2; n++) {
	        listenerRef = listenerRefs[n];
	        ge.removeListener(listenerRef);
	      }
	      delete marker['_oms'];
	    }
	    this.initMarkerArrays();
	    return this;
	  };
	
	  p['addListener'] = function(event, func) {
	    var base;
	    ((base = this.listeners)[event] != null ? base[event] : base[event] = []).push(func);
	    return this;
	  };
	
	  p['removeListener'] = function(event, func) {
	    var i;
	    i = this.arrIndexOf(this.listeners[event], func);
	    if (!(i < 0)) {
	      this.listeners[event].splice(i, 1);
	    }
	    return this;
	  };
	
	  p['clearListeners'] = function(event) {
	    this.listeners[event] = [];
	    return this;
	  };
	
	  p.trigger = function() {
	    var args, event, func, l, len1, ref1, ref2, results;
	    event = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	    ref2 = (ref1 = this.listeners[event]) != null ? ref1 : [];
	    results = [];
	    for (l = 0, len1 = ref2.length; l < len1; l++) {
	      func = ref2[l];
	      results.push(func.apply(null, args));
	    }
	    return results;
	  };
	
	  p.generatePtsCircle = function(count, centerPt) {
	    var angle, angleStep, circumference, i, l, legLength, ref1, results;
	    circumference = this['circleFootSeparation'] * (2 + count);
	    legLength = circumference / twoPi;
	    angleStep = twoPi / count;
	    results = [];
	    for (i = l = 0, ref1 = count; 0 <= ref1 ? l < ref1 : l > ref1; i = 0 <= ref1 ? ++l : --l) {
	      angle = this['circleStartAngle'] + i * angleStep;
	      results.push(new gm.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle)));
	    }
	    return results;
	  };
	
	  p.generatePtsSpiral = function(count, centerPt) {
	    var angle, i, l, legLength, pt, ref1, results;
	    legLength = this['spiralLengthStart'];
	    angle = 0;
	    results = [];
	    for (i = l = 0, ref1 = count; 0 <= ref1 ? l < ref1 : l > ref1; i = 0 <= ref1 ? ++l : --l) {
	      angle += this['spiralFootSeparation'] / legLength + i * 0.0005;
	      pt = new gm.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle));
	      legLength += twoPi * this['spiralLengthFactor'] / angle;
	      results.push(pt);
	    }
	    return results;
	  };
	
	  p.spiderListener = function(marker, event) {
	    var $this, clear, l, len1, m, mPt, markerPt, markerSpiderfied, nDist, nearbyMarkerData, nonNearbyMarkers, pxSq, ref1;
	    markerSpiderfied = marker['_omsData'] != null;
	    if (!(markerSpiderfied && this['keepSpiderfied'])) {
	      if (this['event'] === 'mouseover') {
	        $this = this;
	        clear = function() {
	          return $this['unspiderfy']();
	        };
	        window.clearTimeout(p.timeout);
	        p.timeout = setTimeout(clear, 3000);
	      } else {
	        this['unspiderfy']();
	      }
	    }
	    if (markerSpiderfied || this.map.getStreetView().getVisible() || this.map.getMapTypeId() === 'GoogleEarthAPI') {
	      return this.trigger('click', marker, event);
	    } else {
	      nearbyMarkerData = [];
	      nonNearbyMarkers = [];
	      nDist = this['nearbyDistance'];
	      pxSq = nDist * nDist;
	      markerPt = this.llToPt(marker.position);
	      ref1 = this.markers;
	      for (l = 0, len1 = ref1.length; l < len1; l++) {
	        m = ref1[l];
	        if (!((m.map != null) && m.getVisible())) {
	          continue;
	        }
	        mPt = this.llToPt(m.position);
	        if (this.ptDistanceSq(mPt, markerPt) < pxSq) {
	          nearbyMarkerData.push({
	            marker: m,
	            markerPt: mPt
	          });
	        } else {
	          nonNearbyMarkers.push(m);
	        }
	      }
	      if (nearbyMarkerData.length === 1) {
	        return this.trigger('click', marker, event);
	      } else {
	        return this.spiderfy(nearbyMarkerData, nonNearbyMarkers);
	      }
	    }
	  };
	
	  p['markersNearMarker'] = function(marker, firstOnly) {
	    var l, len1, m, mPt, markerPt, markers, nDist, pxSq, ref1, ref2, ref3;
	    if (firstOnly == null) {
	      firstOnly = false;
	    }
	    if (this.projHelper.getProjection() == null) {
	      throw "Must wait for 'idle' event on map before calling markersNearMarker";
	    }
	    nDist = this['nearbyDistance'];
	    pxSq = nDist * nDist;
	    markerPt = this.llToPt(marker.position);
	    markers = [];
	    ref1 = this.markers;
	    for (l = 0, len1 = ref1.length; l < len1; l++) {
	      m = ref1[l];
	      if (m === marker || (m.map == null) || !m.getVisible()) {
	        continue;
	      }
	      mPt = this.llToPt((ref2 = (ref3 = m['_omsData']) != null ? ref3.usualPosition : void 0) != null ? ref2 : m.position);
	      if (this.ptDistanceSq(mPt, markerPt) < pxSq) {
	        markers.push(m);
	        if (firstOnly) {
	          break;
	        }
	      }
	    }
	    return markers;
	  };
	
	  p['markersNearAnyOtherMarker'] = function() {
	    var i, i1, i2, l, len1, len2, len3, m, m1, m1Data, m2, m2Data, mData, n, nDist, pxSq, q, ref1, ref2, ref3, results;
	    if (this.projHelper.getProjection() == null) {
	      throw "Must wait for 'idle' event on map before calling markersNearAnyOtherMarker";
	    }
	    nDist = this['nearbyDistance'];
	    pxSq = nDist * nDist;
	    mData = (function() {
	      var l, len1, ref1, ref2, ref3, results;
	      ref1 = this.markers;
	      results = [];
	      for (l = 0, len1 = ref1.length; l < len1; l++) {
	        m = ref1[l];
	        results.push({
	          pt: this.llToPt((ref2 = (ref3 = m['_omsData']) != null ? ref3.usualPosition : void 0) != null ? ref2 : m.position),
	          willSpiderfy: false
	        });
	      }
	      return results;
	    }).call(this);
	    ref1 = this.markers;
	    for (i1 = l = 0, len1 = ref1.length; l < len1; i1 = ++l) {
	      m1 = ref1[i1];
	      if (!((m1.map != null) && m1.getVisible())) {
	        continue;
	      }
	      m1Data = mData[i1];
	      if (m1Data.willSpiderfy) {
	        continue;
	      }
	      ref2 = this.markers;
	      for (i2 = n = 0, len2 = ref2.length; n < len2; i2 = ++n) {
	        m2 = ref2[i2];
	        if (i2 === i1) {
	          continue;
	        }
	        if (!((m2.map != null) && m2.getVisible())) {
	          continue;
	        }
	        m2Data = mData[i2];
	        if (i2 < i1 && !m2Data.willSpiderfy) {
	          continue;
	        }
	        if (this.ptDistanceSq(m1Data.pt, m2Data.pt) < pxSq) {
	          m1Data.willSpiderfy = m2Data.willSpiderfy = true;
	          break;
	        }
	      }
	    }
	    ref3 = this.markers;
	    results = [];
	    for (i = q = 0, len3 = ref3.length; q < len3; i = ++q) {
	      m = ref3[i];
	      if (mData[i].willSpiderfy) {
	        results.push(m);
	      }
	    }
	    return results;
	  };
	
	  p.makeHighlightListenerFuncs = function(marker) {
	    return {
	      highlight: (function(_this) {
	        return function() {
	          return marker['_omsData'].leg.setOptions({
	            strokeColor: _this['legColors']['highlighted'][_this.map.mapTypeId],
	            zIndex: _this['highlightedLegZIndex']
	          });
	        };
	      })(this),
	      unhighlight: (function(_this) {
	        return function() {
	          return marker['_omsData'].leg.setOptions({
	            strokeColor: _this['legColors']['usual'][_this.map.mapTypeId],
	            zIndex: _this['usualLegZIndex']
	          });
	        };
	      })(this)
	    };
	  };
	
	  p.spiderfy = function(markerData, nonNearbyMarkers) {
	    var bodyPt, footLl, footPt, footPts, highlightListenerFuncs, leg, marker, md, nearestMarkerDatum, numFeet, spiderfiedMarkers;
	    if (this['minZoomLevel'] && this.map.getZoom() < this['minZoomLevel']) {
	      return false;
	    }
	    this.spiderfying = true;
	    numFeet = markerData.length;
	    bodyPt = this.ptAverage((function() {
	      var l, len1, results;
	      results = [];
	      for (l = 0, len1 = markerData.length; l < len1; l++) {
	        md = markerData[l];
	        results.push(md.markerPt);
	      }
	      return results;
	    })());
	    footPts = numFeet >= this['circleSpiralSwitchover'] ? this.generatePtsSpiral(numFeet, bodyPt).reverse() : this.generatePtsCircle(numFeet, bodyPt);
	    spiderfiedMarkers = (function() {
	      var l, len1, results;
	      results = [];
	      for (l = 0, len1 = footPts.length; l < len1; l++) {
	        footPt = footPts[l];
	        footLl = this.ptToLl(footPt);
	        nearestMarkerDatum = this.minExtract(markerData, (function(_this) {
	          return function(md) {
	            return _this.ptDistanceSq(md.markerPt, footPt);
	          };
	        })(this));
	        marker = nearestMarkerDatum.marker;
	        leg = new gm.Polyline({
	          map: this.map,
	          path: [marker.position, footLl],
	          strokeColor: this['legColors']['usual'][this.map.mapTypeId],
	          strokeWeight: this['legWeight'],
	          zIndex: this['usualLegZIndex']
	        });
	        marker['_omsData'] = {
	          usualPosition: marker.position,
	          leg: leg
	        };
	        if (this['legColors']['highlighted'][this.map.mapTypeId] !== this['legColors']['usual'][this.map.mapTypeId]) {
	          highlightListenerFuncs = this.makeHighlightListenerFuncs(marker);
	          marker['_omsData'].hightlightListeners = {
	            highlight: ge.addListener(marker, 'mouseover', highlightListenerFuncs.highlight),
	            unhighlight: ge.addListener(marker, 'mouseout', highlightListenerFuncs.unhighlight)
	          };
	        }
	        marker.setPosition(footLl);
	        marker.setZIndex(Math.round(this['spiderfiedZIndex'] + footPt.y));
	        results.push(marker);
	      }
	      return results;
	    }).call(this);
	    delete this.spiderfying;
	    this.spiderfied = true;
	    return this.trigger('spiderfy', spiderfiedMarkers, nonNearbyMarkers);
	  };
	
	  p['unspiderfy'] = function(markerNotToMove) {
	    var l, len1, listeners, marker, nonNearbyMarkers, ref1, unspiderfiedMarkers;
	    if (markerNotToMove == null) {
	      markerNotToMove = null;
	    }
	    if (this.spiderfied == null) {
	      return this;
	    }
	    this.unspiderfying = true;
	    unspiderfiedMarkers = [];
	    nonNearbyMarkers = [];
	    ref1 = this.markers;
	    for (l = 0, len1 = ref1.length; l < len1; l++) {
	      marker = ref1[l];
	      if (marker['_omsData'] != null) {
	        marker['_omsData'].leg.setMap(null);
	        if (marker !== markerNotToMove) {
	          marker.setPosition(marker['_omsData'].usualPosition);
	        }
	        marker.setZIndex(null);
	        listeners = marker['_omsData'].hightlightListeners;
	        if (listeners != null) {
	          ge.removeListener(listeners.highlight);
	          ge.removeListener(listeners.unhighlight);
	        }
	        delete marker['_omsData'];
	        unspiderfiedMarkers.push(marker);
	      } else {
	        nonNearbyMarkers.push(marker);
	      }
	    }
	    delete this.unspiderfying;
	    delete this.spiderfied;
	    this.trigger('unspiderfy', unspiderfiedMarkers, nonNearbyMarkers);
	    return this;
	  };
	
	  p.ptDistanceSq = function(pt1, pt2) {
	    var dx, dy;
	    dx = pt1.x - pt2.x;
	    dy = pt1.y - pt2.y;
	    return dx * dx + dy * dy;
	  };
	
	  p.ptAverage = function(pts) {
	    var l, len1, numPts, pt, sumX, sumY;
	    sumX = sumY = 0;
	    for (l = 0, len1 = pts.length; l < len1; l++) {
	      pt = pts[l];
	      sumX += pt.x;
	      sumY += pt.y;
	    }
	    numPts = pts.length;
	    return new gm.Point(sumX / numPts, sumY / numPts);
	  };
	
	  p.llToPt = function(ll) {
	    return this.projHelper.getProjection().fromLatLngToDivPixel(ll);
	  };
	
	  p.ptToLl = function(pt) {
	    return this.projHelper.getProjection().fromDivPixelToLatLng(pt);
	  };
	
	  p.minExtract = function(set, func) {
	    var bestIndex, bestVal, index, item, l, len1, val;
	    for (index = l = 0, len1 = set.length; l < len1; index = ++l) {
	      item = set[index];
	      val = func(item);
	      if ((typeof bestIndex === "undefined" || bestIndex === null) || val < bestVal) {
	        bestVal = val;
	        bestIndex = index;
	      }
	    }
	    return set.splice(bestIndex, 1)[0];
	  };
	
	  p.arrIndexOf = function(arr, obj) {
	    var i, l, len1, o;
	    if (arr.indexOf != null) {
	      return arr.indexOf(obj);
	    }
	    for (i = l = 0, len1 = arr.length; l < len1; i = ++l) {
	      o = arr[i];
	      if (o === obj) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  return _Class;
	
	})();
	
	  }.apply(self);
	
	  GoogleMapApi.then(function(){
	    self.OverlappingMarkerSpiderfier.initializeGoogleMaps(window.google);
	  });
	  return this.OverlappingMarkerSpiderfier;
	}]);
	;/**
	 * Performance overrides on MarkerClusterer custom to Angular Google Maps
	 *
	 * Created by Petr Bruna ccg1415 and Nick McCready on 7/13/14.
	 */
	angular.module('uiGmapgoogle-maps.extensions')
	.service('uiGmapExtendMarkerClusterer',['uiGmapLodash', 'uiGmapPropMap', function (uiGmapLodash, PropMap) {
	  return {
	    init: _.once(function () {
	      (function () {
	        var __hasProp = {}.hasOwnProperty,
	          __extends = function (child, parent) {
	            for (var key in parent) {
	              if (__hasProp.call(parent, key)) child[key] = parent[key];
	            }
	            function ctor() {
	              this.constructor = child;
	            }
	
	            ctor.prototype = parent.prototype;
	            child.prototype = new ctor();
	            child.__super__ = parent.prototype;
	            return child;
	          };
	
	        window.NgMapCluster = (function (_super) {
	          __extends(NgMapCluster, _super);
	
	          function NgMapCluster(opts) {
	            NgMapCluster.__super__.constructor.call(this, opts);
	            this.markers_ = new PropMap();
	          }
	
	          /**
	           * Adds a marker to the cluster.
	           *
	           * @param {google.maps.Marker} marker The marker to be added.
	           * @return {boolean} True if the marker was added.
	           * @ignore
	           */
	          NgMapCluster.prototype.addMarker = function (marker) {
	            var i;
	            var mCount;
	            var mz;
	
	            if (this.isMarkerAlreadyAdded_(marker)) {
	              var oldMarker = this.markers_.get(marker.key);
	              if (oldMarker.getPosition().lat() == marker.getPosition().lat() && oldMarker.getPosition().lon() == marker.getPosition().lon()) //if nothing has changed
	                return false;
	            }
	
	            if (!this.center_) {
	              this.center_ = marker.getPosition();
	              this.calculateBounds_();
	            } else {
	              if (this.averageCenter_) {
	                var l = this.markers_.length + 1;
	                var lat = (this.center_.lat() * (l - 1) + marker.getPosition().lat()) / l;
	                var lng = (this.center_.lng() * (l - 1) + marker.getPosition().lng()) / l;
	                this.center_ = new google.maps.LatLng(lat, lng);
	                this.calculateBounds_();
	              }
	            }
	            marker.isAdded = true;
	            this.markers_.push(marker);
	
	            mCount = this.markers_.length;
	            mz = this.markerClusterer_.getMaxZoom();
	            if (mz !== null && this.map_.getZoom() > mz) {
	              // Zoomed in past max zoom, so show the marker.
	              if (marker.getMap() !== this.map_) {
	                marker.setMap(this.map_);
	              }
	            } else if (mCount < this.minClusterSize_) {
	              // Min cluster size not reached so show the marker.
	              if (marker.getMap() !== this.map_) {
	                marker.setMap(this.map_);
	              }
	            } else if (mCount === this.minClusterSize_) {
	              // Hide the markers that were showing.
	              this.markers_.each(function (m) {
	                m.setMap(null);
	              });
	            } else {
	              marker.setMap(null);
	            }
	
	            //this.updateIcon_();
	            return true;
	          };
	
	          /**
	           * Determines if a marker has already been added to the cluster.
	           *
	           * @param {google.maps.Marker} marker The marker to check.
	           * @return {boolean} True if the marker has already been added.
	           */
	          NgMapCluster.prototype.isMarkerAlreadyAdded_ = function (marker) {
	            return uiGmapLodash.isNullOrUndefined(this.markers_.get(marker.key));
	          };
	
	
	          /**
	           * Returns the bounds of the cluster.
	           *
	           * @return {google.maps.LatLngBounds} the cluster bounds.
	           * @ignore
	           */
	          NgMapCluster.prototype.getBounds = function () {
	            var i;
	            var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
	            this.getMarkers().each(function(m){
	              bounds.extend(m.getPosition());
	            });
	            return bounds;
	          };
	
	
	          /**
	           * Removes the cluster from the map.
	           *
	           * @ignore
	           */
	          NgMapCluster.prototype.remove = function () {
	            this.clusterIcon_.setMap(null);
	            this.markers_ = new PropMap();
	            delete this.markers_;
	          };
	
	
	          return NgMapCluster;
	
	        })(Cluster);
	
	
	        window.NgMapMarkerClusterer = (function (_super) {
	          __extends(NgMapMarkerClusterer, _super);
	
	          function NgMapMarkerClusterer(map, opt_markers, opt_options) {
	            NgMapMarkerClusterer.__super__.constructor.call(this, map, opt_markers, opt_options);
	            this.markers_ = new PropMap();
	          }
	
	          /**
	           * Removes all clusters and markers from the map and also removes all markers
	           *  managed by the clusterer.
	           */
	          NgMapMarkerClusterer.prototype.clearMarkers = function () {
	            this.resetViewport_(true);
	            this.markers_ = new PropMap();
	          };
	          /**
	           * Removes a marker and returns true if removed, false if not.
	           *
	           * @param {google.maps.Marker} marker The marker to remove
	           * @return {boolean} Whether the marker was removed or not
	           */
	          NgMapMarkerClusterer.prototype.removeMarker_ = function (marker) {
	            if (!this.markers_.get(marker.key)) {
	              return false;
	            }
	            marker.setMap(null);
	            this.markers_.remove(marker.key); // Remove the marker from the list of managed markers
	            return true;
	          };
	
	          /**
	           * Creates the clusters. This is done in batches to avoid timeout errors
	           *  in some browsers when there is a huge number of markers.
	           *
	           * @param {number} iFirst The index of the first marker in the batch of
	           *  markers to be added to clusters.
	           */
	          NgMapMarkerClusterer.prototype.createClusters_ = function (iFirst) {
	            var i, marker;
	            var mapBounds;
	            var cMarkerClusterer = this;
	            if (!this.ready_) {
	              return;
	            }
	
	            // Cancel previous batch processing if we're working on the first batch:
	            if (iFirst === 0) {
	              /**
	               * This event is fired when the <code>MarkerClusterer</code> begins
	               *  clustering markers.
	               * @name MarkerClusterer#clusteringbegin
	               * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
	               * @event
	               */
	              google.maps.event.trigger(this, 'clusteringbegin', this);
	
	              if (typeof this.timerRefStatic !== 'undefined') {
	                clearTimeout(this.timerRefStatic);
	                delete this.timerRefStatic;
	              }
	            }
	
	            // Get our current map view bounds.
	            // Create a new bounds object so we don't affect the map.
	            //
	            // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
	            if (this.getMap().getZoom() > 3) {
	              mapBounds = new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(),
	                this.getMap().getBounds().getNorthEast());
	            } else {
	              mapBounds = new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
	            }
	            var bounds = this.getExtendedBounds(mapBounds);
	
	            var iLast = Math.min(iFirst + this.batchSize_, this.markers_.length);
	
	            var _ms = this.markers_.values();
	            for (i = iFirst; i < iLast; i++) {
	              marker = _ms[i];
	              if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
	                if (!this.ignoreHidden_ || (this.ignoreHidden_ && marker.getVisible())) {
	                  this.addToClosestCluster_(marker);
	                }
	              }
	            }
	
	            if (iLast < this.markers_.length) {
	              this.timerRefStatic = setTimeout(function () {
	                cMarkerClusterer.createClusters_(iLast);
	              }, 0);
	            } else {
	              // custom addition by ui-gmap
	              // update icon for all clusters
	              for (i = 0; i < this.clusters_.length; i++) {
	                this.clusters_[i].updateIcon_();
	              }
	
	              delete this.timerRefStatic;
	
	              /**
	               * This event is fired when the <code>MarkerClusterer</code> stops
	               *  clustering markers.
	               * @name MarkerClusterer#clusteringend
	               * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
	               * @event
	               */
	              google.maps.event.trigger(this, 'clusteringend', this);
	            }
	          };
	
	          /**
	           * Adds a marker to a cluster, or creates a new cluster.
	           *
	           * @param {google.maps.Marker} marker The marker to add.
	           */
	          NgMapMarkerClusterer.prototype.addToClosestCluster_ = function (marker) {
	            var i, d, cluster, center;
	            var distance = 40000; // Some large number
	            var clusterToAddTo = null;
	            for (i = 0; i < this.clusters_.length; i++) {
	              cluster = this.clusters_[i];
	              center = cluster.getCenter();
	              if (center) {
	                d = this.distanceBetweenPoints_(center, marker.getPosition());
	                if (d < distance) {
	                  distance = d;
	                  clusterToAddTo = cluster;
	                }
	              }
	            }
	
	            if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
	              clusterToAddTo.addMarker(marker);
	            } else {
	              cluster = new NgMapCluster(this);
	              cluster.addMarker(marker);
	              this.clusters_.push(cluster);
	            }
	          };
	
	          /**
	           * Redraws all the clusters.
	           */
	          NgMapMarkerClusterer.prototype.redraw_ = function () {
	            this.createClusters_(0);
	          };
	
	
	          /**
	           * Removes all clusters from the map. The markers are also removed from the map
	           *  if <code>opt_hide</code> is set to <code>true</code>.
	           *
	           * @param {boolean} [opt_hide] Set to <code>true</code> to also remove the markers
	           *  from the map.
	           */
	          NgMapMarkerClusterer.prototype.resetViewport_ = function (opt_hide) {
	            var i, marker;
	            // Remove all the clusters
	            for (i = 0; i < this.clusters_.length; i++) {
	              this.clusters_[i].remove();
	            }
	            this.clusters_ = [];
	
	            // Reset the markers to not be added and to be removed from the map.
	            this.markers_.each(function (marker) {
	              marker.isAdded = false;
	              if (opt_hide) {
	                marker.setMap(null);
	              }
	            });
	          };
	
	          /**
	           * Extends an object's prototype by another's.
	           *
	           * @param {Object} obj1 The object to be extended.
	           * @param {Object} obj2 The object to extend with.
	           * @return {Object} The new extended object.
	           * @ignore
	           */
	          NgMapMarkerClusterer.prototype.extend = function (obj1, obj2) {
	            return (function (object) {
	              var property;
	              for (property in object.prototype) {
	                if (property !== 'constructor')
	                  this.prototype[property] = object.prototype[property];
	              }
	              return this;
	            }).apply(obj1, [obj2]);
	          };
	          ////////////////////////////////////////////////////////////////////////////////
	          /*
	          Other overrides relevant to MarkerClusterPlus
	          */
	          ////////////////////////////////////////////////////////////////////////////////
	          /**
	          * Positions and shows the icon.
	          */
	          ClusterIcon.prototype.show = function () {
	            if (this.div_) {
	              var img = "";
	              // NOTE: values must be specified in px units
	              var bp = this.backgroundPosition_.split(" ");
	              var spriteH = parseInt(bp[0].trim(), 10);
	              var spriteV = parseInt(bp[1].trim(), 10);
	              var pos = this.getPosFromLatLng_(this.center_);
	              this.div_.style.cssText = this.createCss(pos);
	              img = "<img src='" + this.url_ + "' style='position: absolute; top: " + spriteV + "px; left: " + spriteH + "px; ";
	              if (!this.cluster_.getMarkerClusterer().enableRetinaIcons_) {
	                img += "clip: rect(" + (-1 * spriteV) + "px, " + ((-1 * spriteH) + this.width_) + "px, " +
	                ((-1 * spriteV) + this.height_) + "px, " + (-1 * spriteH) + "px);";
	              }
	              // ADDED FOR RETINA SUPPORT
	              else {
	                img += "width: " + this.width_ + "px;" + "height: " + this.height_ + "px;";
	              }
	              // END ADD
	              img += "'>";
	              this.div_.innerHTML = img + "<div style='" +
	              "position: absolute;" +
	              "top: " + this.anchorText_[0] + "px;" +
	              "left: " + this.anchorText_[1] + "px;" +
	              "color: " + this.textColor_ + ";" +
	              "font-size: " + this.textSize_ + "px;" +
	              "font-family: " + this.fontFamily_ + ";" +
	              "font-weight: " + this.fontWeight_ + ";" +
	              "font-style: " + this.fontStyle_ + ";" +
	              "text-decoration: " + this.textDecoration_ + ";" +
	              "text-align: center;" +
	              "width: " + this.width_ + "px;" +
	              "line-height:" + this.height_ + "px;" +
	              "'>" + this.sums_.text + "</div>";
	              if (typeof this.sums_.title === "undefined" || this.sums_.title === "") {
	                this.div_.title = this.cluster_.getMarkerClusterer().getTitle();
	              } else {
	                this.div_.title = this.sums_.title;
	              }
	              this.div_.style.display = "";
	            }
	            this.visible_ = true;
	          };
	          //END OTHER OVERRIDES
	          ////////////////////////////////////////////////////////////////////////////////
	
	          return NgMapMarkerClusterer;
	
	        })(MarkerClusterer);
	      }).call(this);
	    })
	  };
	}]);
	}( window, angular, _));

/***/ },

/***/ 129:
/***/ function(module, exports) {

	(function() {
	
	
	// Create all modules and define dependencies to make sure they exist
	// and are loaded in the correct order to satisfy dependency injection
	// before all nested files are concatenated by Grunt
	
	// Modules
	angular.module('angular-jwt',
	    [
	        'angular-jwt.interceptor',
	        'angular-jwt.jwt'
	    ]);
	
	 angular.module('angular-jwt.interceptor', [])
	  .provider('jwtInterceptor', function() {
	
	    this.urlParam = null;
	    this.authHeader = 'Authorization';
	    this.authPrefix = 'Bearer ';
	    this.tokenGetter = function() {
	      return null;
	    }
	
	    var config = this;
	
	    this.$get = ["$q", "$injector", "$rootScope", function ($q, $injector, $rootScope) {
	      return {
	        request: function (request) {
	          if (request.skipAuthorization) {
	            return request;
	          }
	
	          if (config.urlParam) {
	            request.params = request.params || {};
	            // Already has the token in the url itself
	            if (request.params[config.urlParam]) {
	              return request;
	            }
	          } else {
	            request.headers = request.headers || {};
	            // Already has an Authorization header
	            if (request.headers[config.authHeader]) {
	              return request;
	            }
	          }
	
	          var tokenPromise = $q.when($injector.invoke(config.tokenGetter, this, {
	            config: request
	          }));
	
	          return tokenPromise.then(function(token) {
	            if (token) {
	              if (config.urlParam) {
	                request.params[config.urlParam] = token;
	              } else {
	                request.headers[config.authHeader] = config.authPrefix + token;
	              }
	            }
	            return request;
	          });
	        },
	        responseError: function (response) {
	          // handle the case where the user is not authenticated
	          if (response.status === 401) {
	            $rootScope.$broadcast('unauthenticated', response);
	          }
	          return $q.reject(response);
	        }
	      };
	    }];
	  });
	
	 angular.module('angular-jwt.jwt', [])
	  .service('jwtHelper', function() {
	
	    this.urlBase64Decode = function(str) {
	      var output = str.replace(/-/g, '+').replace(/_/g, '/');
	      switch (output.length % 4) {
	        case 0: { break; }
	        case 2: { output += '=='; break; }
	        case 3: { output += '='; break; }
	        default: {
	          throw 'Illegal base64url string!';
	        }
	      }
	      return decodeURIComponent(escape(window.atob(output))); //polifyll https://github.com/davidchambers/Base64.js
	    }
	
	
	    this.decodeToken = function(token) {
	      var parts = token.split('.');
	
	      if (parts.length !== 3) {
	        throw new Error('JWT must have 3 parts');
	      }
	
	      var decoded = this.urlBase64Decode(parts[1]);
	      if (!decoded) {
	        throw new Error('Cannot decode the token');
	      }
	
	      return JSON.parse(decoded);
	    }
	
	    this.getTokenExpirationDate = function(token) {
	      var decoded;
	      decoded = this.decodeToken(token);
	
	      if(typeof decoded.exp === "undefined") {
	        return null;
	      }
	
	      var d = new Date(0); // The 0 here is the key, which sets the date to the epoch
	      d.setUTCSeconds(decoded.exp);
	
	      return d;
	    };
	
	    this.isTokenExpired = function(token, offsetSeconds) {
	      var d = this.getTokenExpirationDate(token);
	      offsetSeconds = offsetSeconds || 0;
	      if (d === null) {
	        return false;
	      }
	
	      // Token expired?
	      return !(d.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
	    };
	  });
	
	}());

/***/ },

/***/ 130:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(129);
	module.exports = 'angular-jwt';
	


/***/ },

/***/ 131:
/***/ function(module, exports) {

	/* global angular */
	(function() {
	'use strict';
	
	angular.module('MassAutoComplete', [])
	
	.provider('massAutocompleteConfig', function() {
	  var config = this;
	
	  config.KEYS = {
	    TAB: 9,
	    ESC: 27,
	    ENTER: 13,
	    UP: 38,
	    DOWN: 40
	  };
	
	  config.EVENTS = {
	    KEYDOWN: 'keydown',
	    RESIZE: 'resize',
	    BLUR: 'blur'
	  };
	
	  config.DEBOUNCE = {
	    position: 150,
	    attach: 300,
	    suggest: 200,
	    blur: 150
	  };
	
	  config.generate_random_id = function(prefix) {
	    return prefix + '_' + Math.random().toString().substring(2);
	  };
	
	  // Position ac container given a target element
	  config.position_autocomplete = function(container, target) {
	    var rect = target[0].getBoundingClientRect(),
	        scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset,
	        scrollLeft = document.body.scrollLeft || document.documentElement.scrollLeft || window.pageXOffset;
	
	    container[0].style.top = rect.top + rect.height + scrollTop + 'px';
	    container[0].style.left = rect.left + scrollLeft + 'px';
	    container[0].style.width = rect.width + 'px';
	  };
	
	  this.$get = function() {
	    return config;
	  };
	})
	
	.directive('massAutocomplete', ['massAutocompleteConfig', '$timeout', '$window', '$document', '$q', function(config, $timeout, $window, $document, $q) {
	  return {
	    restrict: 'A',
	    scope: {
	      options: '&massAutocomplete'
	    },
	    transclude: true,
	    template:
	      '<span ng-transclude></span>' +
	
	      '<div class="ac-container" ' +
	           'aria-autocomplete="list" ' +
	           'role="listbox" ' +
	           'ng-show="show_autocomplete">' +
	
	        '<ul class="ac-menu"> ' +
	          '<li ng-repeat="result in results" ng-if="$index > 0" ' +
	            'class="ac-menu-item" ' +
	            'role="option" ' +
	            'id="{{result.id}}" ' +
	            'ng-class="$index == selected_index ? \'ac-state-focus\': \'\'">' +
	            '<a href ng-click="apply_selection($index)" ng-bind-html="result.label"></a>' +
	          '</li>' +
	        '</ul>' +
	
	      '</div>',
	
	    link: function(scope, element) {
	      scope.container = angular.element(element[0].getElementsByClassName('ac-container')[0]);
	      scope.container[0].style.position = 'absolute';
	    },
	
	    controller: ['$scope', function($scope) {
	      var that = this;
	
	      var bound_events = {};
	      bound_events[config.EVENTS.BLUR] = null;
	      bound_events[config.EVENTS.KEYDOWN] = null;
	      bound_events[config.EVENTS.RESIZE] = null;
	
	      var _user_options = $scope.options() || {};
	      var user_options = {
	        debounce_position: _user_options.debounce_position || config.DEBOUNCE.position,
	        debounce_attach: _user_options.debounce_attach || config.DEBOUNCE.attach,
	        debounce_suggest: _user_options.debounce_suggest || config.DEBOUNCE.suggest,
	        debounce_blur: _user_options.debounce_blur || config.DEBOUNCE.blur
	      };
	
	      var current_element,
	          current_model,
	          current_options,
	          previous_value,
	          value_watch,
	          last_selected_value,
	          current_element_random_id_set;
	
	      $scope.show_autocomplete = false;
	
	      function show_autocomplete() {
	        $scope.show_autocomplete = true;
	      }
	
	      function hide_autocomplete() {
	        $scope.show_autocomplete = false;
	        clear_selection();
	      }
	
	      // Debounce - taken from underscore.
	      function debounce(func, wait, immediate) {
	        var timeoutPromise;
	        return function() {
	          var context = this, args = arguments;
	          var later = function() {
	            timeoutPromise = null;
	            if (!immediate) {
	              func.apply(context, args);
	            }
	          };
	          var callNow = immediate && !timeoutPromise;
	          $timeout.cancel(timeoutPromise);
	          timeoutPromise = $timeout(later, wait);
	          if (callNow) {
	            func.apply(context, args);
	          }
	        };
	      }
	
	      // Make sure an element has id.
	      // Return true if id was generated.
	      function ensure_element_id(element) {
	        if (!element.id || element.id === '') {
	          element.id = config.generate_random_id('ac_element');
	          return true;
	        }
	        return false;
	      }
	
	      function _position_autocomplete() {
	        config.position_autocomplete($scope.container, current_element);
	      }
	      var position_autocomplete = debounce(_position_autocomplete, user_options.debounce_position);
	
	      function _suggest(term, target_element) {
	        $scope.selected_index = 0;
	        $scope.waiting_for_suggestion = true;
	
	        if (typeof(term) === 'string' && term.length > 0) {
	          $q.when(current_options.suggest(term),
	            function suggest_succeeded(suggestions) {
	              // Make sure the suggestion we are processing is of the current element.
	              // When using remote sources for example, a suggestion cycle might be
	              // triggered at a later time (When a different field is in focus).
	              if (!current_element || current_element !== target_element) {
	                return;
	              }
	
	              if (suggestions && suggestions.length > 0) {
	                // Set unique id to each suggestion so we can
	                // reference them (aria)
	                suggestions.forEach(function(s) {
	                  if (!s.id) {
	                    s.id = config.generate_random_id('ac_item');
	                  }
	                });
	                // Add the original term as the first value to enable the user
	                // to return to his original expression after suggestions were made.
	                $scope.results = [{ value: term, label: '', id: ''}].concat(suggestions);
	                show_autocomplete();
	                if (current_options.auto_select_first) {
	                  set_selection(1);
	                }
	              } else {
	                $scope.results = [];
	                hide_autocomplete();
	              }
	            },
	            function suggest_failed(error) {
	              hide_autocomplete();
	              if (current_options.on_error) {
	                current_options.on_error(error);
	              }
	            }
	          ).finally(function suggest_finally() {
	            $scope.waiting_for_suggestion = false;
	          });
	        } else {
	          $scope.waiting_for_suggestion = false;
	          hide_autocomplete();
	          $scope.$apply();
	        }
	      }
	      var suggest = debounce(_suggest, user_options.debounce_suggest);
	
	      // Attach autocomplete behavior to an input element.
	      function _attach(ngmodel, target_element, options) {
	        // Element is already attached.
	        if (current_element === target_element) {
	          return;
	        }
	
	        // Safe: clear previously attached elements.
	        if (current_element) {
	          that.detach();
	        }
	
	        // The element is still the active element.
	        if (target_element[0] !== $document[0].activeElement) {
	          return;
	        }
	
	        if (options.on_attach) {
	          options.on_attach();
	        }
	
	        current_element = target_element;
	        current_model = ngmodel;
	        current_options = options;
	        previous_value = ngmodel.$viewValue;
	        current_element_random_id_set = ensure_element_id(target_element);
	        $scope.container[0].setAttribute('aria-labelledby', current_element.id);
	
	        $scope.results = [];
	        $scope.selected_index = -1;
	        bind_element();
	
	        value_watch = $scope.$watch(
	          function() {
	            return ngmodel.$modelValue;
	          },
	          function(nv) {
	            // Prevent suggestion cycle when the value is the last value selected.
	            // When selecting from the menu the ng-model is updated and this watch
	            // is triggered. This causes another suggestion cycle that will provide as
	            // suggestion the value that is currently selected - this is unnecessary.
	            if (nv === last_selected_value) {
	              return;
	            }
	
	            _position_autocomplete();
	            suggest(nv, current_element);
	          }
	        );
	      }
	      that.attach = debounce(_attach, user_options.debounce_attach);
	
	      // Trigger end of editing and remove all attachments made by
	      // this directive to the input element.
	      that.detach = function() {
	        if (current_element) {
	          var value = current_element.val();
	          update_model_value(value);
	          if (current_options.on_detach) {
	            current_options.on_detach(value);
	          }
	          current_element.unbind(config.EVENTS.KEYDOWN, bound_events[config.EVENTS.KEYDOWN]);
	          current_element.unbind(config.EVENTS.BLUR, bound_events[config.EVENTS.BLUR]);
	          if (current_element_random_id_set) {
	            current_element[0].removeAttribute('id');
	          }
	        }
	        hide_autocomplete();
	        $scope.container[0].removeAttribute('aria-labelledby');
	        // Clear references and config.events.
	        angular.element($window).unbind(config.EVENTS.RESIZE, bound_events[config.EVENTS.RESIZE]);
	        if (value_watch) {
	          value_watch();
	        }
	        $scope.selected_index = $scope.results = undefined;
	        current_model = current_element = previous_value = undefined;
	      };
	
	      // Update angular's model view value.
	      // It is important that before triggering hooks the model's view
	      // value will be synced with the visible value to the user. This will
	      // allow the consumer controller to rely on its local ng-model.
	      function update_model_value(value) {
	        if (current_model.$modelValue !== value) {
	          current_model.$setViewValue(value);
	          current_model.$render();
	        }
	      }
	
	      function clear_selection() {
	        $scope.selected_index = -1;
	        $scope.container[0].removeAttribute('aria-activedescendant');
	      }
	
	      // Set the current selection while navigating through the menu.
	      function set_selection(i) {
	        // We use value instead of setting the model's view value
	        // because we watch the model value and setting it will trigger
	        // a new suggestion cycle.
	        var selected = $scope.results[i];
	        current_element.val(selected.value);
	        $scope.selected_index = i;
	        $scope.container[0].setAttribute('aria-activedescendant', selected.id);
	        return selected;
	      }
	
	      // Apply and accept the current selection made from the menu.
	      // When selecting from the menu directly (using click or touch) the
	      // selection is directly applied.
	      $scope.apply_selection = function(i) {
	        current_element[0].focus();
	        if (!$scope.show_autocomplete || i > $scope.results.length || i < 0) {
	          return;
	        }
	
	        var selected = set_selection(i);
	        last_selected_value = selected.value;
	        update_model_value(selected.value);
	        hide_autocomplete();
	
	        if (current_options.on_select) {
	          current_options.on_select(selected);
	        }
	      };
	
	      function bind_element() {
	        angular.element($window).bind(config.EVENTS.RESIZE, position_autocomplete);
	
	        bound_events[config.EVENTS.BLUR] = function() {
	          // Detach the element from the auto complete when input loses focus.
	          // Focus is lost when a selection is made from the auto complete menu
	          // using the mouse (or touch). In that case we don't want to detach so
	          // we wait several ms for the input to regain focus.
	          $timeout(function() {
	            if (!current_element || current_element[0] !== $document[0].activeElement) {
	              that.detach();
	            }
	          }, user_options.debounce_blur);
	        };
	        current_element.bind(config.EVENTS.BLUR, bound_events[config.EVENTS.BLUR]);
	
	        bound_events[config.EVENTS.KEYDOWN] = function(e) {
	          // Reserve key combinations with shift for different purposes.
	          if (e.shiftKey) {
	            return;
	          }
	
	          switch (e.keyCode) {
	            // Close the menu if it's open. Or, undo changes made to the value
	            // if the menu is closed.
	            case config.KEYS.ESC:
	              if ($scope.show_autocomplete) {
	                hide_autocomplete();
	                $scope.$apply();
	              } else {
	                current_element.val(previous_value);
	              }
	              break;
	
	            // Select an element and close the menu. Or, if a selection is
	            // unavailable let the event propagate.
	            case config.KEYS.ENTER:
	              // Accept a selection only if results exist, the menu is
	              // displayed and the results are valid (no current request
	              // for new suggestions is active).
	              if ($scope.show_autocomplete &&
	                  $scope.selected_index > 0 &&
	                  !$scope.waiting_for_suggestion) {
	                $scope.apply_selection($scope.selected_index);
	                // When selecting an item from the AC list the focus is set on
	                // the input element. So the enter will cause a keypress event
	                // on the input itself. Since this enter is not intended for the
	                // input but for the AC result we prevent propagation to parent
	                // elements because this event is not of their concern. We cannot
	                // prevent events from firing when the event was registered on
	                // the input itself.
	                e.stopPropagation();
	                e.preventDefault();
	              }
	
	              hide_autocomplete();
	              $scope.$apply();
	              break;
	
	            // Navigate the menu when it's open. When it's not open fall back
	            // to default behavior.
	            case config.KEYS.TAB:
	              if (!$scope.show_autocomplete) {
	                break;
	              }
	
	              e.preventDefault();
	
	            // Open the menu when results exists but are not displayed. Or,
	            // select the next element when the menu is open. When reaching
	            // bottom wrap to top.
	            /* falls through */
	            case config.KEYS.DOWN:
	              if ($scope.results.length > 0) {
	                if ($scope.show_autocomplete) {
	                  set_selection($scope.selected_index + 1 > $scope.results.length - 1 ? 0 : $scope.selected_index + 1);
	                } else {
	                  show_autocomplete();
	                  set_selection(0);
	                }
	                $scope.$apply();
	              }
	              break;
	
	            // Navigate up in the menu. When reaching the top wrap to bottom.
	            case config.KEYS.UP:
	              if ($scope.show_autocomplete) {
	                e.preventDefault();
	                set_selection($scope.selected_index - 1 >= 0 ? $scope.selected_index - 1 : $scope.results.length - 1);
	                $scope.$apply();
	              }
	              break;
	          }
	        };
	        current_element.bind(config.EVENTS.KEYDOWN, bound_events[config.EVENTS.KEYDOWN]);
	      }
	
	      $scope.$on('$destroy', function() {
	        that.detach();
	        $scope.container.remove();
	      });
	    }]
	  };
	}])
	
	.directive('massAutocompleteItem', function() {
	  return {
	    restrict: 'A',
	    require: [
	      '^massAutocomplete',
	      'ngModel'
	    ],
	    scope: {
	      'massAutocompleteItem' : '&'
	    },
	    link: function(scope, element, attrs, required) {
	      // Prevent html5/browser auto completion.
	      attrs.$set('autocomplete', 'off');
	
	      var acContainer = required[0];
	      var ngModel = required[1];
	
	      element.bind('focus', function() {
	        var options = scope.massAutocompleteItem();
	        if (!options) {
	          throw new Error('Invalid options');
	        }
	        acContainer.attach(ngModel, element, options);
	      });
	    }
	  };
	});
	})();


/***/ },

/***/ 132:
/***/ function(module, exports) {

	/*!
	 * AngularJS Material Design
	 * https://github.com/angular/material
	 * @license MIT
	 * v1.2.5
	 */
	(function( window, angular, undefined ){
	"use strict";
	
	(function(){
	"use strict";
	
	angular.module('ngMaterial', ["ng","ngAnimate","ngAria","material.core","material.core.animate","material.core.gestures","material.core.interaction","material.core.layout","material.core.meta","material.core.theming.palette","material.core.theming","material.components.autocomplete","material.components.backdrop","material.components.bottomSheet","material.components.button","material.components.card","material.components.checkbox","material.components.chips","material.components.colors","material.components.content","material.components.datepicker","material.components.dialog","material.components.divider","material.components.fabActions","material.components.fabShared","material.components.fabSpeedDial","material.components.fabToolbar","material.components.gridList","material.components.icon","material.components.input","material.components.list","material.components.menu","material.components.menuBar","material.components.navBar","material.components.panel","material.components.progressCircular","material.components.progressLinear","material.components.radioButton","material.components.select","material.components.showHide","material.components.sidenav","material.components.slider","material.components.sticky","material.components.subheader","material.components.swipe","material.components.switch","material.components.tabs","material.components.toast","material.components.toolbar","material.components.tooltip","material.components.truncate","material.components.virtualRepeat","material.components.whiteframe"]);
	})();
	(function(){
	"use strict";
	
	/**
	 * Initialization function that validates environment
	 * requirements.
	 */
	DetectNgTouch.$inject = ["$log", "$injector"];
	MdCoreConfigure.$inject = ["$provide", "$mdThemingProvider"];
	rAFDecorator.$inject = ["$delegate"];
	qDecorator.$inject = ["$delegate"];
	angular
	  .module('material.core', [
	    'ngAnimate',
	    'material.core.animate',
	    'material.core.layout',
	    'material.core.interaction',
	    'material.core.gestures',
	    'material.core.theming'
	  ])
	  .config(MdCoreConfigure)
	  .run(DetectNgTouch);
	
	
	/**
	 * Detect if the ng-Touch module is also being used.
	 * Warn if detected.
	 * @ngInject
	 */
	function DetectNgTouch($log, $injector) {
	  if ($injector.has('$swipe')) {
	    var msg = "" +
	      "You are using the ngTouch module. \n" +
	      "AngularJS Material already has mobile click, tap, and swipe support... \n" +
	      "ngTouch is not supported with AngularJS Material!";
	    $log.warn(msg);
	  }
	}
	
	/**
	 * @ngInject
	 */
	function MdCoreConfigure($provide, $mdThemingProvider) {
	
	  $provide.decorator('$$rAF', ['$delegate', rAFDecorator]);
	  $provide.decorator('$q', ['$delegate', qDecorator]);
	
	  $mdThemingProvider.theme('default')
	    .primaryPalette('indigo')
	    .accentPalette('pink')
	    .warnPalette('deep-orange')
	    .backgroundPalette('grey');
	}
	
	/**
	 * @ngInject
	 */
	function rAFDecorator($delegate) {
	  /**
	   * Use this to throttle events that come in often.
	   * The throttled function will always use the *last* invocation before the
	   * coming frame.
	   *
	   * For example, window resize events that fire many times a second:
	   * If we set to use an raf-throttled callback on window resize, then
	   * our callback will only be fired once per frame, with the last resize
	   * event that happened before that frame.
	   *
	   * @param {function} cb function to debounce
	   */
	  $delegate.throttle = function(cb) {
	    var queuedArgs, alreadyQueued, queueCb, context;
	    return function debounced() {
	      queuedArgs = arguments;
	      context = this;
	      queueCb = cb;
	      if (!alreadyQueued) {
	        alreadyQueued = true;
	        $delegate(function() {
	          queueCb.apply(context, Array.prototype.slice.call(queuedArgs));
	          alreadyQueued = false;
	        });
	      }
	    };
	  };
	  return $delegate;
	}
	
	/**
	 * @ngInject
	 */
	function qDecorator($delegate) {
	  /**
	   * Adds a shim for $q.resolve for AngularJS version that don't have it,
	   * so we don't have to think about it.
	   *
	   * via https://github.com/angular/angular.js/pull/11987
	   */
	
	  // TODO(crisbeto): this won't be necessary once we drop AngularJS 1.3
	  if (!$delegate.resolve) {
	    $delegate.resolve = $delegate.when;
	  }
	  return $delegate;
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutofocusDirective.$inject = ["$parse"];angular.module('material.core')
	  .directive('mdAutofocus', MdAutofocusDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdAutofocus
	 * @module material.core.util
	 *
	 * @description
	 *
	 * `[md-autofocus]` provides an optional way to identify the focused element when a `$mdDialog`,
	 * `$mdBottomSheet`, `$mdMenu` or `$mdSidenav` opens or upon page load for input-like elements.
	 *
	 * When one of these opens, it will find the first nested element with the `[md-autofocus]`
	 * attribute directive and optional expression. An expression may be specified as the directive
	 * value to enable conditional activation of the autofocus.
	 *
	 * @usage
	 *
	 * ### Dialog
	 * <hljs lang="html">
	 * <md-dialog>
	 *   <form>
	 *     <md-input-container>
	 *       <label for="testInput">Label</label>
	 *       <input id="testInput" type="text" md-autofocus>
	 *     </md-input-container>
	 *   </form>
	 * </md-dialog>
	 * </hljs>
	 *
	 * ### Bottomsheet
	 * <hljs lang="html">
	 * <md-bottom-sheet class="md-list md-has-header">
	 *  <md-subheader>Comment Actions</md-subheader>
	 *  <md-list>
	 *    <md-list-item ng-repeat="item in items">
	 *
	 *      <md-button md-autofocus="$index == 2">
	 *        <md-icon md-svg-src="{{item.icon}}"></md-icon>
	 *        <span class="md-inline-list-icon-label">{{ item.name }}</span>
	 *      </md-button>
	 *
	 *    </md-list-item>
	 *  </md-list>
	 * </md-bottom-sheet>
	 * </hljs>
	 *
	 * ### Autocomplete
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-autofocus
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 * ### Sidenav
	 * <hljs lang="html">
	 * <div layout="row" ng-controller="MyController">
	 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
	 *     Left Nav!
	 *   </md-sidenav>
	 *
	 *   <md-content>
	 *     Center Content
	 *     <md-button ng-click="openLeftMenu()">
	 *       Open Left Menu
	 *     </md-button>
	 *   </md-content>
	 *
	 *   <md-sidenav md-component-id="right"
	 *     md-is-locked-open="$mdMedia('min-width: 333px')"
	 *     class="md-sidenav-right">
	 *     <form>
	 *       <md-input-container>
	 *         <label for="testInput">Test input</label>
	 *         <input id="testInput" type="text"
	 *                ng-model="data" md-autofocus>
	 *       </md-input-container>
	 *     </form>
	 *   </md-sidenav>
	 * </div>
	 * </hljs>
	 **/
	function MdAutofocusDirective($parse) {
	  return {
	    restrict: 'A',
	    link: {
	      pre: preLink
	    }
	  };
	
	  function preLink(scope, element, attr) {
	    var attrExp = attr.mdAutoFocus || attr.mdAutofocus || attr.mdSidenavFocus;
	
	    // Initially update the expression by manually parsing the expression as per $watch source.
	    updateExpression($parse(attrExp)(scope));
	
	    // Only watch the expression if it is not empty.
	    if (attrExp) {
	      scope.$watch(attrExp, updateExpression);
	    }
	
	    /**
	     * Updates the autofocus class which is used to determine whether the attribute
	     * expression evaluates to true or false.
	     * @param {string|boolean} value Attribute Value
	     */
	    function updateExpression(value) {
	
	      // Rather than passing undefined to the jqLite toggle class function we explicitly set the
	      // value to true. Otherwise the class will be just toggled instead of being forced.
	      if (angular.isUndefined(value)) {
	        value = true;
	      }
	
	      element.toggleClass('md-autofocus', !!value);
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.colorUtil
	 * @description
	 * Color Util
	 */
	angular
	  .module('material.core')
	  .factory('$mdColorUtil', ColorUtilFactory);
	
	function ColorUtilFactory() {
	  /**
	   * Converts hex value to RGBA string
	   * @param color {string}
	   * @returns {string}
	   */
	  function hexToRgba (color) {
	    var hex   = color[ 0 ] === '#' ? color.substr(1) : color,
	      dig   = hex.length / 3,
	      red   = hex.substr(0, dig),
	      green = hex.substr(dig, dig),
	      blue  = hex.substr(dig * 2);
	    if (dig === 1) {
	      red += red;
	      green += green;
	      blue += blue;
	    }
	    return 'rgba(' + parseInt(red, 16) + ',' + parseInt(green, 16) + ',' + parseInt(blue, 16) + ',0.1)';
	  }
	
	  /**
	   * Converts rgba value to hex string
	   * @param {string} color
	   * @returns {string}
	   */
	  function rgbaToHex(color) {
	    color = color.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
	
	    var hex = (color && color.length === 4) ? "#" +
	    ("0" + parseInt(color[1],10).toString(16)).slice(-2) +
	    ("0" + parseInt(color[2],10).toString(16)).slice(-2) +
	    ("0" + parseInt(color[3],10).toString(16)).slice(-2) : '';
	
	    return hex.toUpperCase();
	  }
	
	  /**
	   * Converts an RGB color to RGBA
	   * @param {string} color
	   * @returns {string}
	   */
	  function rgbToRgba (color) {
	    return color.replace(')', ', 0.1)').replace('(', 'a(');
	  }
	
	  /**
	   * Converts an RGBA color to RGB
	   * @param {string} color
	   * @returns {string}
	   */
	  function rgbaToRgb (color) {
	    return color
	      ? color.replace('rgba', 'rgb').replace(/,[^),]+\)/, ')')
	      : 'rgb(0,0,0)';
	  }
	
	  return {
	    rgbaToHex: rgbaToHex,
	    hexToRgba: hexToRgba,
	    rgbToRgba: rgbToRgba,
	    rgbaToRgb: rgbaToRgb
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core')
	.factory('$mdConstant', MdConstantFactory);
	
	/**
	 * Factory function that creates the grab-bag $mdConstant service.
	 * @ngInject
	 */
	function MdConstantFactory() {
	
	  var prefixTestEl = document.createElement('div');
	  var vendorPrefix = getVendorPrefix(prefixTestEl);
	  var isWebkit = /webkit/i.test(vendorPrefix);
	  var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;
	
	  /**
	   * @param {string} name CSS property name
	   * @return {string} the property name supported by the browser
	   */
	  function vendorProperty(name) {
	    // Add a dash between the prefix and name, to be able to transform the string into camelcase.
	    var prefixedName = vendorPrefix + '-' + name;
	    var ucPrefix = camelCase(prefixedName);
	    var lcPrefix = ucPrefix.charAt(0).toLowerCase() + ucPrefix.substring(1);
	
	    return hasStyleProperty(prefixTestEl, name)     ? name     :       // The current browser supports the un-prefixed property
	           hasStyleProperty(prefixTestEl, ucPrefix) ? ucPrefix :       // The current browser only supports the prefixed property.
	           hasStyleProperty(prefixTestEl, lcPrefix) ? lcPrefix : name; // Some browsers are only supporting the prefix in lowercase.
	  }
	
	  function hasStyleProperty(testElement, property) {
	    return angular.isDefined(testElement.style[property]);
	  }
	
	  /**
	   * @param {!string} input value to convert to camelCase
	   * @return {string} camelCased version of the input string
	   */
	  function camelCase(input) {
	    return input.replace(SPECIAL_CHARS_REGEXP, function(matches, separator, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    });
	  }
	
	  function getVendorPrefix(testElement) {
	    var prop, match;
	    var vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/;
	
	    for (prop in testElement.style) {
	      if (match = vendorRegex.exec(prop)) {
	        return match[0];
	      }
	    }
	  }
	
	  var self = {
	    isInputKey : function(e) { return (e.keyCode >= 31 && e.keyCode <= 90); },
	    isNumPadKey : function(e) { return (3 === e.location && e.keyCode >= 97 && e.keyCode <= 105); },
	    isMetaKey: function(e) { return (e.keyCode >= 91 && e.keyCode <= 93); },
	    isFnLockKey: function(e) { return (e.keyCode >= 112 && e.keyCode <= 145); },
	    isNavigationKey : function(e) {
	      var kc = self.KEY_CODE, NAVIGATION_KEYS =  [kc.SPACE, kc.ENTER, kc.UP_ARROW, kc.DOWN_ARROW];
	      return (NAVIGATION_KEYS.indexOf(e.keyCode) != -1);
	    },
	    hasModifierKey: function(e) {
	      return e.ctrlKey || e.metaKey || e.altKey;
	    },
	
	    /**
	     * Maximum size, in pixels, that can be explicitly set to an element. The actual value varies
	     * between browsers, but IE11 has the very lowest size at a mere 1,533,917px. Ideally we could
	     * compute this value, but Firefox always reports an element to have a size of zero if it
	     * goes over the max, meaning that we'd have to binary search for the value.
	     */
	    ELEMENT_MAX_PIXELS: 1533917,
	
	    /**
	     * Priority for a directive that should run before the directives from ngAria.
	     */
	    BEFORE_NG_ARIA: 210,
	
	    /**
	     * Common Keyboard actions and their associated keycode.
	     */
	    KEY_CODE: {
	      COMMA: 188,
	      SEMICOLON : 186,
	      ENTER: 13,
	      ESCAPE: 27,
	      SPACE: 32,
	      PAGE_UP: 33,
	      PAGE_DOWN: 34,
	      END: 35,
	      HOME: 36,
	      LEFT_ARROW : 37,
	      UP_ARROW : 38,
	      RIGHT_ARROW : 39,
	      DOWN_ARROW : 40,
	      TAB : 9,
	      BACKSPACE: 8,
	      DELETE: 46
	    },
	
	    /**
	     * Vendor prefixed CSS properties to be used to support the given functionality in older browsers
	     * as well.
	     */
	    CSS: {
	      /* Constants */
	      TRANSITIONEND: 'transitionend' + (isWebkit ? ' webkitTransitionEnd' : ''),
	      ANIMATIONEND: 'animationend' + (isWebkit ? ' webkitAnimationEnd' : ''),
	
	      TRANSFORM: vendorProperty('transform'),
	      TRANSFORM_ORIGIN: vendorProperty('transformOrigin'),
	      TRANSITION: vendorProperty('transition'),
	      TRANSITION_DURATION: vendorProperty('transitionDuration'),
	      ANIMATION_PLAY_STATE: vendorProperty('animationPlayState'),
	      ANIMATION_DURATION: vendorProperty('animationDuration'),
	      ANIMATION_NAME: vendorProperty('animationName'),
	      ANIMATION_TIMING: vendorProperty('animationTimingFunction'),
	      ANIMATION_DIRECTION: vendorProperty('animationDirection')
	    },
	
	    /**
	     * As defined in core/style/_variables.scss
	     *
	     * $layout-breakpoint-xs:     600px !default;
	     * $layout-breakpoint-sm:     960px !default;
	     * $layout-breakpoint-md:     1280px !default;
	     * $layout-breakpoint-lg:     1920px !default;
	     *
	     */
	    MEDIA: {
	      'xs'        : '(max-width: 599px)'                         ,
	      'gt-xs'     : '(min-width: 600px)'                         ,
	      'sm'        : '(min-width: 600px) and (max-width: 959px)'  ,
	      'gt-sm'     : '(min-width: 960px)'                         ,
	      'md'        : '(min-width: 960px) and (max-width: 1279px)' ,
	      'gt-md'     : '(min-width: 1280px)'                        ,
	      'lg'        : '(min-width: 1280px) and (max-width: 1919px)',
	      'gt-lg'     : '(min-width: 1920px)'                        ,
	      'xl'        : '(min-width: 1920px)'                        ,
	      'landscape' : '(orientation: landscape)'                   ,
	      'portrait'  : '(orientation: portrait)'                    ,
	      'print' : 'print'
	    },
	
	    MEDIA_PRIORITY: [
	      'xl',
	      'gt-lg',
	      'lg',
	      'gt-md',
	      'md',
	      'gt-sm',
	      'sm',
	      'gt-xs',
	      'xs',
	      'landscape',
	      'portrait',
	      'print'
	    ]
	  };
	
	  return self;
	}
	
	})();
	(function(){
	"use strict";
	
	  angular
	    .module('material.core')
	    .config(["$provide", function($provide){
	       $provide.decorator('$mdUtil', ['$delegate', function ($delegate){
	           /**
	            * Inject the iterator facade to easily support iteration and accessors
	            * @see iterator below
	            */
	           $delegate.iterator = MdIterator;
	
	           return $delegate;
	         }
	       ]);
	     }]);
	
	  /**
	   * iterator is a list facade to easily support iteration and accessors/
	   *
	   * @param {any[]} items Array list which this iterator will enumerate
	   * @param {boolean=} reloop enables iterator to consider the list as an endless loop
	   * @return {{add: add, next: (function()), last: (function(): any|null), previous: (function()), count: (function(): number), hasNext: (function(*=): Array.length|*|number|boolean), inRange: (function(*): boolean), remove: remove, contains: (function(*=): *|boolean), itemAt: (function(*=): any|null), findBy: (function(*, *): *[]), hasPrevious: (function(*=): Array.length|*|number|boolean), items: (function(): *[]), indexOf: (function(*=): number), first: (function(): any|null)}}
	   * @constructor
	   */
	  function MdIterator(items, reloop) {
	    var trueFn = function() { return true; };
	
	    if (items && !angular.isArray(items)) {
	      items = Array.prototype.slice.call(items);
	    }
	
	    reloop = !!reloop;
	    var _items = items || [];
	
	    // Published API
	    return {
	      items: getItems,
	      count: count,
	
	      inRange: inRange,
	      contains: contains,
	      indexOf: indexOf,
	      itemAt: itemAt,
	
	      findBy: findBy,
	
	      add: add,
	      remove: remove,
	
	      first: first,
	      last: last,
	      next: angular.bind(null, findSubsequentItem, false),
	      previous: angular.bind(null, findSubsequentItem, true),
	
	      hasPrevious: hasPrevious,
	      hasNext: hasNext
	    };
	
	    /**
	     * Publish copy of the enumerable set
	     * @returns {Array|*}
	     */
	    function getItems() {
	      return [].concat(_items);
	    }
	
	    /**
	     * Determine length of the list
	     * @returns {Array.length|*|number}
	     */
	    function count() {
	      return _items.length;
	    }
	
	    /**
	     * Is the index specified valid
	     * @param index
	     * @returns {Array.length|*|number|boolean}
	     */
	    function inRange(index) {
	      return _items.length && (index > -1) && (index < _items.length);
	    }
	
	    /**
	     * Can the iterator proceed to the next item in the list; relative to
	     * the specified item.
	     *
	     * @param item
	     * @returns {Array.length|*|number|boolean}
	     */
	    function hasNext(item) {
	      return item ? inRange(indexOf(item) + 1) : false;
	    }
	
	    /**
	     * Can the iterator proceed to the previous item in the list; relative to
	     * the specified item.
	     *
	     * @param item
	     * @returns {Array.length|*|number|boolean}
	     */
	    function hasPrevious(item) {
	      return item ? inRange(indexOf(item) - 1) : false;
	    }
	
	    /**
	     * Get item at specified index/position
	     * @param index
	     * @returns {*}
	     */
	    function itemAt(index) {
	      return inRange(index) ? _items[index] : null;
	    }
	
	    /**
	     * Find all elements matching the key/value pair
	     * otherwise return null
	     *
	     * @param val
	     * @param key
	     *
	     * @return array
	     */
	    function findBy(key, val) {
	      return _items.filter(function(item) {
	        return item[key] === val;
	      });
	    }
	
	    /**
	     * Add item to list
	     * @param item
	     * @param index
	     * @returns {*}
	     */
	    function add(item, index) {
	      if (!item) return -1;
	
	      if (!angular.isNumber(index)) {
	        index = _items.length;
	      }
	
	      _items.splice(index, 0, item);
	
	      return indexOf(item);
	    }
	
	    /**
	     * Remove item from list...
	     * @param item
	     */
	    function remove(item) {
	      if (contains(item)){
	        _items.splice(indexOf(item), 1);
	      }
	    }
	
	    /**
	     * Get the zero-based index of the target item
	     * @param item
	     * @returns {*}
	     */
	    function indexOf(item) {
	      return _items.indexOf(item);
	    }
	
	    /**
	     * Boolean existence check
	     * @param item
	     * @returns {boolean}
	     */
	    function contains(item) {
	      return item && (indexOf(item) > -1);
	    }
	
	    /**
	     * Return first item in the list
	     * @returns {*}
	     */
	    function first() {
	      return _items.length ? _items[0] : null;
	    }
	
	    /**
	     * Return last item in the list...
	     * @returns {*}
	     */
	    function last() {
	      return _items.length ? _items[_items.length - 1] : null;
	    }
	
	    /**
	     * Find the next item. If reloop is true and at the end of the list, it will go back to the
	     * first item. If given, the `validate` callback will be used to determine whether the next item
	     * is valid. If not valid, it will try to find the next item again.
	     *
	     * @param {boolean} backwards Specifies the direction of searching (forwards/backwards)
	     * @param {*} item The item whose subsequent item we are looking for
	     * @param {Function=} validate The `validate` function
	     * @param {integer=} limit The recursion limit
	     *
	     * @returns {*} The subsequent item or null
	     */
	    function findSubsequentItem(backwards, item, validate, limit) {
	      validate = validate || trueFn;
	
	      var curIndex = indexOf(item);
	      while (true) {
	        if (!inRange(curIndex)) return null;
	
	        var nextIndex = curIndex + (backwards ? -1 : 1);
	        var foundItem = null;
	        if (inRange(nextIndex)) {
	          foundItem = _items[nextIndex];
	        } else if (reloop) {
	          foundItem = backwards ? last() : first();
	          nextIndex = indexOf(foundItem);
	        }
	
	        if ((foundItem === null) || (nextIndex === limit)) return null;
	        if (validate(foundItem)) return foundItem;
	
	        if (angular.isUndefined(limit)) limit = nextIndex;
	
	        curIndex = nextIndex;
	      }
	    }
	  }
	
	
	})();
	(function(){
	"use strict";
	
	
	mdMediaFactory.$inject = ["$mdConstant", "$rootScope", "$window"];angular.module('material.core')
	.factory('$mdMedia', mdMediaFactory);
	
	/**
	 * @ngdoc service
	 * @name $mdMedia
	 * @module material.core
	 *
	 * @description
	 * `$mdMedia` is used to evaluate whether a given media query is true or false given the
	 * current device's screen / window size. The media query will be re-evaluated on resize, allowing
	 * you to register a watch.
	 *
	 * `$mdMedia` also has pre-programmed support for media queries that match the layout breakpoints:
	 *
	 *  <table class="md-api-table">
	 *    <thead>
	 *    <tr>
	 *      <th>Breakpoint</th>
	 *      <th>mediaQuery</th>
	 *    </tr>
	 *    </thead>
	 *    <tbody>
	 *    <tr>
	 *      <td>xs</td>
	 *      <td>(max-width: 599px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-xs</td>
	 *      <td>(min-width: 600px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>sm</td>
	 *      <td>(min-width: 600px) and (max-width: 959px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-sm</td>
	 *      <td>(min-width: 960px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>md</td>
	 *      <td>(min-width: 960px) and (max-width: 1279px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-md</td>
	 *      <td>(min-width: 1280px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>lg</td>
	 *      <td>(min-width: 1280px) and (max-width: 1919px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-lg</td>
	 *      <td>(min-width: 1920px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>xl</td>
	 *      <td>(min-width: 1920px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>landscape</td>
	 *      <td>landscape</td>
	 *    </tr>
	 *    <tr>
	 *      <td>portrait</td>
	 *      <td>portrait</td>
	 *    </tr>
	 *    <tr>
	 *      <td>print</td>
	 *      <td>print</td>
	 *    </tr>
	 *    </tbody>
	 *  </table>
	 *
	 *  See Material Design's <a href="https://material.google.com/layout/responsive-ui.html">Layout - Adaptive UI</a> for more details.
	 *
	 *  <a href="https://material.io/archive/guidelines/layout/responsive-ui.html#">
	 *  <img src="https://material-design.storage.googleapis.com/publish/material_v_4/material_ext_publish/0B8olV15J7abPSGFxemFiQVRtb1k/layout_adaptive_breakpoints_01.png" width="100%" height="100%"></img>
	 *  </a>
	 *
	 * @returns {boolean} a boolean representing whether or not the given media query is true or false.
	 *
	 * @usage
	 * <hljs lang="js">
	 * app.controller('MyController', function($mdMedia, $scope) {
	 *   $scope.$watch(function() { return $mdMedia('lg'); }, function(big) {
	 *     $scope.bigScreen = big;
	 *   });
	 *
	 *   $scope.screenIsSmall = $mdMedia('sm');
	 *   $scope.customQuery = $mdMedia('(min-width: 1234px)');
	 *   $scope.anotherCustom = $mdMedia('max-width: 300px');
	 * });
	 * </hljs>
	 */
	
	/* @ngInject */
	function mdMediaFactory($mdConstant, $rootScope, $window) {
	  var queries = {};
	  var mqls = {};
	  var results = {};
	  var normalizeCache = {};
	
	  $mdMedia.getResponsiveAttribute = getResponsiveAttribute;
	  $mdMedia.getQuery = getQuery;
	  $mdMedia.watchResponsiveAttributes = watchResponsiveAttributes;
	
	  return $mdMedia;
	
	  function $mdMedia(query) {
	    var validated = queries[query];
	    if (angular.isUndefined(validated)) {
	      validated = queries[query] = validate(query);
	    }
	
	    var result = results[validated];
	    if (angular.isUndefined(result)) {
	      result = add(validated);
	    }
	
	    return result;
	  }
	
	  function validate(query) {
	    return $mdConstant.MEDIA[query] ||
	           ((query.charAt(0) !== '(') ? ('(' + query + ')') : query);
	  }
	
	  function add(query) {
	    var result = mqls[query];
	    if (!result) {
	      result = mqls[query] = $window.matchMedia(query);
	    }
	
	    result.addListener(onQueryChange);
	    return (results[result.media] = !!result.matches);
	  }
	
	  function onQueryChange(query) {
	    $rootScope.$evalAsync(function() {
	      results[query.media] = !!query.matches;
	    });
	  }
	
	  function getQuery(name) {
	    return mqls[name];
	  }
	
	  function getResponsiveAttribute(attrs, attrName) {
	    for (var i = 0; i < $mdConstant.MEDIA_PRIORITY.length; i++) {
	      var mediaName = $mdConstant.MEDIA_PRIORITY[i];
	      if (!mqls[queries[mediaName]].matches) {
	        continue;
	      }
	
	      var normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
	      if (attrs[normalizedName]) {
	        return attrs[normalizedName];
	      }
	    }
	
	    // fallback on unprefixed
	    return attrs[getNormalizedName(attrs, attrName)];
	  }
	
	  function watchResponsiveAttributes(attrNames, attrs, watchFn) {
	    var unwatchFns = [];
	    attrNames.forEach(function(attrName) {
	      var normalizedName = getNormalizedName(attrs, attrName);
	      if (angular.isDefined(attrs[normalizedName])) {
	        unwatchFns.push(
	            attrs.$observe(normalizedName, angular.bind(void 0, watchFn, null)));
	      }
	
	      for (var mediaName in $mdConstant.MEDIA) {
	        normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
	        if (angular.isDefined(attrs[normalizedName])) {
	          unwatchFns.push(
	              attrs.$observe(normalizedName, angular.bind(void 0, watchFn, mediaName)));
	        }
	      }
	    });
	
	    return function unwatch() {
	      unwatchFns.forEach(function(fn) { fn(); });
	    };
	  }
	
	  // Improves performance dramatically
	  function getNormalizedName(attrs, attrName) {
	    return normalizeCache[attrName] ||
	        (normalizeCache[attrName] = attrs.$normalize(attrName));
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	  .module('material.core')
	  .config(["$provide", function($provide) {
	    $provide.decorator('$mdUtil', ['$delegate', function ($delegate) {
	
	      // Inject the prefixer into our original $mdUtil service.
	      $delegate.prefixer = MdPrefixer;
	
	      return $delegate;
	    }]);
	  }]);
	
	/**
	 * @param {string|string[]} initialAttributes
	 * @param {boolean} buildSelector
	 * @return {string|string[]|{buildSelector: (function(string|string[]): string),
	 *   buildList: (function(string|string[]): string[]),
	 *   hasAttribute: (function(JQLite|Element, string): HTMLElement),
	 *   removeAttribute: (function(JQLite|Element, string): void)}}
	 * @constructor
	 */
	function MdPrefixer(initialAttributes, buildSelector) {
	  var PREFIXES = ['data', 'x'];
	
	  if (initialAttributes) {
	    // The prefixer also accepts attributes as a parameter, and immediately builds a list or selector for
	    // the specified attributes.
	    return buildSelector ? _buildSelector(initialAttributes) : _buildList(initialAttributes);
	  }
	
	  return {
	    buildList: _buildList,
	    buildSelector: _buildSelector,
	    hasAttribute: _hasAttribute,
	    removeAttribute: _removeAttribute
	  };
	
	  function _buildList(attributes) {
	    attributes = angular.isArray(attributes) ? attributes : [attributes];
	
	    attributes.forEach(function(item) {
	      PREFIXES.forEach(function(prefix) {
	        attributes.push(prefix + '-' + item);
	      });
	    });
	
	    return attributes;
	  }
	
	  function _buildSelector(attributes) {
	    attributes = angular.isArray(attributes) ? attributes : [attributes];
	
	    return _buildList(attributes)
	      .map(function(item) {
	        return '[' + item + ']';
	      })
	      .join(',');
	  }
	
	  function _hasAttribute(element, attribute) {
	    element = _getNativeElement(element);
	
	    if (!element) {
	      return false;
	    }
	
	    var prefixedAttrs = _buildList(attribute);
	
	    for (var i = 0; i < prefixedAttrs.length; i++) {
	      if (element.hasAttribute(prefixedAttrs[i])) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  function _removeAttribute(element, attribute) {
	    element = _getNativeElement(element);
	
	    if (!element) {
	      return;
	    }
	
	    _buildList(attribute).forEach(function(prefixedAttribute) {
	      element.removeAttribute(prefixedAttribute);
	    });
	  }
	
	  /**
	   * Transforms a jqLite or DOM element into a HTML element.
	   * This is useful when supporting jqLite elements and DOM elements at
	   * same time.
	   * @param element {JQLite|Element} Element to be parsed
	   * @returns {HTMLElement} Parsed HTMLElement
	   */
	  function _getNativeElement(element) {
	    element =  element[0] || element;
	
	    if (element.nodeType) {
	      return element;
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/*
	 * This var has to be outside the angular factory, otherwise when
	 * there are multiple material apps on the same page, each app
	 * will create its own instance of this array and the app's IDs
	 * will not be unique.
	 */
	UtilFactory.$inject = ["$document", "$timeout", "$compile", "$rootScope", "$$mdAnimate", "$interpolate", "$log", "$rootElement", "$window", "$$rAF"];
	var nextUniqueId = 0, isIos, isAndroid, isFirefox;
	
	// Support material-tools builds.
	if (window.navigator) {
	  var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
	  isIos = userAgent.match(/ipad|iphone|ipod/i);
	  isAndroid = userAgent.match(/android/i);
	  isFirefox = userAgent.match(/(firefox|minefield)/i);
	}
	
	/**
	 * @ngdoc module
	 * @name material.core.util
	 * @description
	 * Util
	 */
	angular
	.module('material.core')
	.factory('$mdUtil', UtilFactory);
	
	/**
	 * @ngInject
	 */
	function UtilFactory($document, $timeout, $compile, $rootScope, $$mdAnimate, $interpolate, $log,
	                     $rootElement, $window, $$rAF) {
	  // Setup some core variables for the processTemplate method
	  var startSymbol = $interpolate.startSymbol(),
	    endSymbol = $interpolate.endSymbol(),
	    usesStandardSymbols = ((startSymbol === '{{') && (endSymbol === '}}'));
	
	  // Polyfill document.contains for IE11.
	  document.contains || (document.contains = function (node) {
	    return document.body.contains(node);
	  });
	
	  /**
	   * Checks if the target element has the requested style by key
	   * @param {DOMElement|JQLite} target Target element
	   * @param {string} key Style key
	   * @param {string=} expectedVal Optional expected value
	   * @returns {boolean} Whether the target element has the style or not
	   */
	  var hasComputedStyle = function (target, key, expectedVal) {
	    var hasValue = false;
	
	    if (target && target.length) {
	      var computedStyles = $window.getComputedStyle(target[0]);
	      hasValue = angular.isDefined(computedStyles[key]) &&
	        (expectedVal ? computedStyles[key] == expectedVal : true);
	    }
	
	    return hasValue;
	  };
	
	  function validateCssValue(value) {
	    return !value ? '0' :
	      hasPx(value) || hasPercent(value) ? value : value + 'px';
	  }
	
	  function hasPx(value) {
	    return String(value).indexOf('px') > -1;
	  }
	
	  function hasPercent(value) {
	    return String(value).indexOf('%') > -1;
	  }
	
	  var $mdUtil = {
	    dom: {},
	    isIos: isIos,
	    isAndroid: isAndroid,
	    now: window.performance && window.performance.now ?
	      angular.bind(window.performance, window.performance.now) : Date.now || function() {
	      return new Date().getTime();
	    },
	
	    /**
	     * Cross-version compatibility method to retrieve an option of a ngModel controller,
	     * which supports the breaking changes in the AngularJS snapshot (SHA 87a2ff76af5d0a9268d8eb84db5755077d27c84c).
	     * @param {!ngModel.NgModelController} ngModelCtrl
	     * @param {!string} optionName
	     * @returns {string|number|boolean|Object|undefined}
	     */
	    getModelOption: function (ngModelCtrl, optionName) {
	      if (!ngModelCtrl.$options) {
	        return;
	      }
	
	      var $options = ngModelCtrl.$options;
	
	      // The newer versions of AngularJS introduced a getOption function and made the option values
	      // no longer visible on the $options object.
	      return $options.getOption ? $options.getOption(optionName) : $options[optionName];
	    },
	
	    /**
	     * Determines the current 'dir'ectional value based on the value of 'dir'
	     * attribute of the element. If that is not defined, it will try to use
	     * a 'dir' attribute of the body or html tag.
	     *
	     * @param {Object=} attrs a hash object with key-value pairs of normalized
	     *     attribute names and their corresponding attribute values.
	     * @returns {boolean} true if the element's passed in attributes,
	     *     the document, or the body indicates RTL mode, false otherwise.
	     */
	    isRtl: function(attrs) {
	      var dir = angular.isDefined(attrs) && attrs.hasOwnProperty('dir') && attrs.dir;
	
	      switch (dir) {
	        case 'ltr':
	          return false;
	
	        case 'rtl':
	          return true;
	      }
	
	      return ($document[0].dir === 'rtl' || $document[0].body.dir === 'rtl');
	    },
	
	    /**
	     * Bi-directional accessor/mutator used to easily update an element's
	     * property based on the current 'dir'ectional value.
	     */
	    bidi: function(element, property, lValue, rValue) {
	      var ltr = !this.isRtl();
	
	      // If accessor
	      if (arguments.length == 0) return ltr ? 'ltr' : 'rtl';
	
	      // If mutator
	      var elem = angular.element(element);
	
	      if (ltr && angular.isDefined(lValue)) {
	        elem.css(property, validateCssValue(lValue));
	      }
	      else if (!ltr && angular.isDefined(rValue)) {
	        elem.css(property, validateCssValue(rValue));
	      }
	    },
	
	    bidiProperty: function (element, lProperty, rProperty, value) {
	      var ltr = !this.isRtl();
	
	      var elem = angular.element(element);
	
	      if (ltr && angular.isDefined(lProperty)) {
	        elem.css(lProperty, validateCssValue(value));
	        elem.css(rProperty, '');
	      }
	      else if (!ltr && angular.isDefined(rProperty)) {
	        elem.css(rProperty, validateCssValue(value));
	        elem.css(lProperty, '');
	      }
	    },
	
	    clientRect: function(element, offsetParent, isOffsetRect) {
	      var node = getNode(element);
	      offsetParent = getNode(offsetParent || node.offsetParent || document.body);
	      var nodeRect = node.getBoundingClientRect();
	
	      // The user can ask for an offsetRect: a rect relative to the offsetParent,
	      // or a clientRect: a rect relative to the page
	      var offsetRect = isOffsetRect ?
	        offsetParent.getBoundingClientRect() :
	        {left: 0, top: 0, width: 0, height: 0};
	      return {
	        left: nodeRect.left - offsetRect.left,
	        top: nodeRect.top - offsetRect.top,
	        width: nodeRect.width,
	        height: nodeRect.height
	      };
	    },
	    offsetRect: function(element, offsetParent) {
	      return $mdUtil.clientRect(element, offsetParent, true);
	    },
	
	    /**
	     * Annoying method to copy nodes to an array, thanks to IE.
	     * @param nodes
	     * @return {Array}
	     */
	    nodesToArray: function(nodes) {
	      var results = [], i;
	      nodes = nodes || [];
	
	      for (i = 0; i < nodes.length; ++i) {
	        results.push(nodes.item(i));
	      }
	      return results;
	    },
	
	    /**
	     * Determines the absolute position of the viewport.
	     * Useful when making client rectangles absolute.
	     * @returns {number}
	     */
	    getViewportTop: function() {
	      // If body scrolling is disabled, then use the cached viewport top value, otherwise get it
	      // fresh from the $window.
	      if ($mdUtil.disableScrollAround._count && $mdUtil.disableScrollAround._viewPortTop) {
	        return $mdUtil.disableScrollAround._viewPortTop;
	      } else {
	        return $window.scrollY || $window.pageYOffset || 0;
	      }
	    },
	
	    /**
	     * Finds the proper focus target by searching the DOM.
	     *
	     * @param {!JQLite} containerEl
	     * @param {string=} attributeVal
	     * @returns {JQLite|undefined}
	     */
	    findFocusTarget: function(containerEl, attributeVal) {
	      var AUTO_FOCUS = this.prefixer('md-autofocus', true);
	      var elToFocus;
	
	      elToFocus = scanForFocusable(containerEl, attributeVal || AUTO_FOCUS);
	
	      // Scan for fallback to 'universal' API
	      if (!elToFocus) {
	        elToFocus = scanForFocusable(containerEl, AUTO_FOCUS);
	      }
	
	      return elToFocus;
	
	      /**
	       * Can target and nested children for specified Selector (attribute)
	       * whose value may be an expression that evaluates to True/False.
	       * @param {!JQLite} target
	       * @param {!string} selector
	       * @return {JQLite|undefined}
	       */
	      function scanForFocusable(target, selector) {
	        var elFound, items = target[0].querySelectorAll(selector);
	
	        // Find the last child element with the focus attribute
	        if (items && items.length) {
	          items.length && angular.forEach(items, function(it) {
	            it = angular.element(it);
	
	            // Check the element for the md-autofocus class to ensure any associated expression
	            // evaluated to true.
	            var isFocusable = it.hasClass('md-autofocus');
	            if (isFocusable) elFound = it;
	          });
	        }
	        return elFound;
	      }
	    },
	
	    /**
	     * Disables scroll around the passed parent element.
	     * @param {Element|JQLite=} element Origin Element (not used)
	     * @param {Element|JQLite=} parent Element to disable scrolling within.
	     *   Defaults to body if none supplied.
	     * @param {Object=} options Object of options to modify functionality
	     *   - disableScrollMask Boolean of whether or not to create a scroll mask element or
	     *     use the passed parent element.
	     */
	    disableScrollAround: function(element, parent, options) {
	      options = options || {};
	
	      $mdUtil.disableScrollAround._count = Math.max(0, $mdUtil.disableScrollAround._count || 0);
	      $mdUtil.disableScrollAround._count++;
	
	      if ($mdUtil.disableScrollAround._restoreScroll) {
	        return $mdUtil.disableScrollAround._restoreScroll;
	      }
	
	      var body = $document[0].body;
	      var restoreBody = disableBodyScroll();
	      var restoreElement = disableElementScroll(parent, options);
	
	      return $mdUtil.disableScrollAround._restoreScroll = function() {
	        if (--$mdUtil.disableScrollAround._count <= 0) {
	          delete $mdUtil.disableScrollAround._viewPortTop;
	          restoreBody();
	          restoreElement();
	          delete $mdUtil.disableScrollAround._restoreScroll;
	        }
	      };
	
	      /**
	       * Creates a virtual scrolling mask to prevent touchmove, keyboard, scrollbar clicking,
	       * and wheel events.
	       * @param {!Element|!JQLite} elementToDisable
	       * @param {Object=} scrollMaskOptions Object of options to modify functionality
	       *   - disableScrollMask Boolean of whether or not to create a scroll mask element or
	       *     use the passed parent element.
	       * @returns {Function}
	       */
	      function disableElementScroll(elementToDisable, scrollMaskOptions) {
	        var scrollMask;
	        var wrappedElementToDisable = angular.element(elementToDisable || body);
	
	        if (scrollMaskOptions.disableScrollMask) {
	          scrollMask = wrappedElementToDisable;
	        } else {
	          scrollMask = angular.element(
	            '<div class="md-scroll-mask">' +
	            '  <div class="md-scroll-mask-bar"></div>' +
	            '</div>');
	          wrappedElementToDisable.append(scrollMask);
	        }
	
	        /**
	         * @param {Event} $event
	         */
	        function preventDefault($event) {
	          $event.preventDefault();
	        }
	
	        scrollMask.on('wheel touchmove', preventDefault);
	
	        return function restoreElementScroll() {
	          scrollMask.off('wheel touchmove', preventDefault);
	
	          if (!scrollMaskOptions.disableScrollMask && scrollMask[0].parentNode) {
	            scrollMask[0].parentNode.removeChild(scrollMask[0]);
	          }
	        };
	      }
	
	      // Converts the body to a position fixed block and translate it to the proper scroll position
	      function disableBodyScroll() {
	        var documentElement = $document[0].documentElement;
	
	        var prevDocumentStyle = documentElement.style.cssText || '';
	        var prevBodyStyle = body.style.cssText || '';
	
	        var viewportTop = $mdUtil.getViewportTop();
	        $mdUtil.disableScrollAround._viewPortTop = viewportTop;
	        var clientWidth = body.clientWidth;
	        var hasVerticalScrollbar = body.scrollHeight > body.clientHeight + 1;
	
	        // Scroll may be set on <html> element (for example by overflow-y: scroll)
	        // but Chrome is reporting the scrollTop position always on <body>.
	        // scrollElement will allow to restore the scrollTop position to proper target.
	        var scrollElement = documentElement.scrollTop > 0 ? documentElement : body;
	
	        if (hasVerticalScrollbar) {
	          angular.element(body).css({
	            position: 'fixed',
	            width: '100%',
	            top: -viewportTop + 'px'
	          });
	        }
	
	        if (body.clientWidth < clientWidth) {
	          body.style.overflow = 'hidden';
	        }
	
	        return function restoreScroll() {
	          // Reset the inline style CSS to the previous.
	          body.style.cssText = prevBodyStyle;
	          documentElement.style.cssText = prevDocumentStyle;
	
	          // The scroll position while being fixed
	          scrollElement.scrollTop = viewportTop;
	        };
	      }
	
	    },
	
	    enableScrolling: function() {
	      var restoreFn = this.disableScrollAround._restoreScroll;
	      restoreFn && restoreFn();
	    },
	
	    floatingScrollbars: function() {
	      if (this.floatingScrollbars.cached === undefined) {
	        var tempNode = angular.element('<div><div></div></div>').css({
	          width: '100%',
	          'z-index': -1,
	          position: 'absolute',
	          height: '35px',
	          'overflow-y': 'scroll'
	        });
	        tempNode.children().css('height', '60px');
	
	        $document[0].body.appendChild(tempNode[0]);
	        this.floatingScrollbars.cached =
	          (tempNode[0].offsetWidth === tempNode[0].childNodes[0].offsetWidth);
	        tempNode.remove();
	      }
	      return this.floatingScrollbars.cached;
	    },
	
	    /**
	     * Mobile safari only allows you to set focus in click event listeners.
	     * @param {Element|JQLite} element to focus
	     */
	    forceFocus: function(element) {
	      var node = element[0] || element;
	
	      document.addEventListener('click', function focusOnClick(ev) {
	        if (ev.target === node && ev.$focus) {
	          node.focus();
	          ev.stopImmediatePropagation();
	          ev.preventDefault();
	          node.removeEventListener('click', focusOnClick);
	        }
	      }, true);
	
	      var newEvent = document.createEvent('MouseEvents');
	      newEvent.initMouseEvent('click', false, true, window, {}, 0, 0, 0, 0,
	        false, false, false, false, 0, null);
	      newEvent.$material = true;
	      newEvent.$focus = true;
	      node.dispatchEvent(newEvent);
	    },
	
	    /**
	     * facade to build md-backdrop element with desired styles
	     * NOTE: Use $compile to trigger backdrop postLink function
	     */
	    createBackdrop: function(scope, addClass) {
	      return $compile($mdUtil.supplant('<md-backdrop class="{0}">', [addClass]))(scope);
	    },
	
	    /**
	     * supplant() method from Crockford's `Remedial Javascript`
	     * Equivalent to use of $interpolate; without dependency on
	     * interpolation symbols and scope. Note: the '{<token>}' can
	     * be property names, property chains, or array indices.
	     */
	    supplant: function(template, values, pattern) {
	      pattern = pattern || /\{([^{}]*)\}/g;
	      return template.replace(pattern, function(a, b) {
	        var p = b.split('.'),
	          r = values;
	        try {
	          for (var s in p) {
	            if (p.hasOwnProperty(s)) {
	              r = r[p[s]];
	            }
	          }
	        } catch (e) {
	          r = a;
	        }
	        return (typeof r === 'string' || typeof r === 'number') ? r : a;
	      });
	    },
	
	    fakeNgModel: function() {
	      return {
	        $fake: true,
	        $setTouched: angular.noop,
	        $setViewValue: function(value) {
	          this.$viewValue = value;
	          this.$render(value);
	          this.$viewChangeListeners.forEach(function(cb) {
	            cb();
	          });
	        },
	        $isEmpty: function(value) {
	          return ('' + value).length === 0;
	        },
	        $parsers: [],
	        $formatters: [],
	        $viewChangeListeners: [],
	        $render: angular.noop
	      };
	    },
	
	    /**
	     * @param {Function} func original function to be debounced
	     * @param {number} wait number of milliseconds to delay (since last debounce reset).
	     *  Default value 10 msecs.
	     * @param {Object} scope in which to apply the function after debouncing ends
	     * @param {boolean} invokeApply should the $timeout trigger $digest() dirty checking
	     * @return {Function} A function, that, as long as it continues to be invoked, will not be
	     *  triggered. The function will be called after it stops being called for N milliseconds.
	     */
	    debounce: function(func, wait, scope, invokeApply) {
	      var timer;
	
	      return function debounced() {
	        var context = scope,
	            args = Array.prototype.slice.call(arguments);
	
	        $timeout.cancel(timer);
	        timer = $timeout(function() {
	
	          timer = undefined;
	          func.apply(context, args);
	
	        }, wait || 10, invokeApply);
	      };
	    },
	
	    /**
	     * The function will not be called unless it has been more than `delay` milliseconds since the
	     * last call.
	     * @param {Function} func original function to throttle
	     * @param {number} delay number of milliseconds to delay
	     * @return {Function} a function that can only be triggered every `delay` milliseconds.
	     */
	    throttle: function throttle(func, delay) {
	      var recent;
	      return function throttled() {
	        var context = this;
	        var args = arguments;
	        var now = $mdUtil.now();
	
	        if (!recent || (now - recent > delay)) {
	          func.apply(context, args);
	          recent = now;
	        }
	      };
	    },
	
	    /**
	     * Measures the number of milliseconds taken to run the provided callback
	     * function. Uses a high-precision timer if available.
	     */
	    time: function time(cb) {
	      var start = $mdUtil.now();
	      cb();
	      return $mdUtil.now() - start;
	    },
	
	    /**
	     * Create an implicit getter that caches its `getter()`
	     * lookup value
	     */
	    valueOnUse : function (scope, key, getter) {
	      var value = null, args = Array.prototype.slice.call(arguments);
	      var params = (args.length > 3) ? args.slice(3) : [];
	
	      Object.defineProperty(scope, key, {
	        get: function () {
	          if (value === null) value = getter.apply(scope, params);
	          return value;
	        }
	      });
	    },
	
	    /**
	     * Get a unique ID.
	     *
	     * @returns {string} an unique numeric string
	     */
	    nextUid: function() {
	      return '' + nextUniqueId++;
	    },
	
	    /**
	     * Stop watchers and events from firing on a scope without destroying it,
	     * by disconnecting it from its parent and its siblings' linked lists.
	     * @param {Object} scope to disconnect
	     */
	    disconnectScope: function disconnectScope(scope) {
	      if (!scope) return;
	
	      // we can't destroy the root scope or a scope that has been already destroyed
	      if (scope.$root === scope) return;
	      if (scope.$$destroyed) return;
	
	      var parent = scope.$parent;
	      scope.$$disconnected = true;
	
	      // See Scope.$destroy
	      if (parent.$$childHead === scope) parent.$$childHead = scope.$$nextSibling;
	      if (parent.$$childTail === scope) parent.$$childTail = scope.$$prevSibling;
	      if (scope.$$prevSibling) scope.$$prevSibling.$$nextSibling = scope.$$nextSibling;
	      if (scope.$$nextSibling) scope.$$nextSibling.$$prevSibling = scope.$$prevSibling;
	
	      scope.$$nextSibling = scope.$$prevSibling = null;
	
	    },
	
	    /**
	     * Undo the effects of disconnectScope().
	     * @param {Object} scope to reconnect
	     */
	    reconnectScope: function reconnectScope(scope) {
	      if (!scope) return;
	
	      // we can't disconnect the root node or scope already disconnected
	      if (scope.$root === scope) return;
	      if (!scope.$$disconnected) return;
	
	      var child = scope;
	
	      var parent = child.$parent;
	      child.$$disconnected = false;
	      // See Scope.$new for this logic...
	      child.$$prevSibling = parent.$$childTail;
	      if (parent.$$childHead) {
	        parent.$$childTail.$$nextSibling = child;
	        parent.$$childTail = child;
	      } else {
	        parent.$$childHead = parent.$$childTail = child;
	      }
	    },
	
	    /**
	     * Get an element's siblings matching a given tag name.
	     *
	     * @param {JQLite|angular.element|HTMLElement} element Element to start walking the DOM from
	     * @param {string} tagName HTML tag name to match against
	     * @returns {Object[]} JQLite
	     */
	    getSiblings: function getSiblings(element, tagName) {
	      var upperCasedTagName = tagName.toUpperCase();
	      if (element instanceof angular.element) {
	        element = element[0];
	      }
	      var siblings = Array.prototype.filter.call(element.parentNode.children, function(node) {
	        return element !== node && node.tagName.toUpperCase() === upperCasedTagName;
	      });
	      return siblings.map(function (sibling) {
	        return angular.element(sibling);
	      });
	    },
	
	    /**
	     * getClosest replicates jQuery.closest() to walk up the DOM tree until it finds a matching
	     * nodeName.
	     *
	     * @param {Node} el Element to start walking the DOM from
	     * @param {string|function} validateWith If a string is passed, it will be evaluated against
	     * each of the parent nodes' tag name. If a function is passed, the loop will call it with each
	     * of the parents and will use the return value to determine whether the node is a match.
	     * @param {boolean=} onlyParent Only start checking from the parent element, not `el`.
	     * @returns {Node|null} closest matching parent Node or null if not found
	     */
	    getClosest: function getClosest(el, validateWith, onlyParent) {
	      if (angular.isString(validateWith)) {
	        var tagName = validateWith.toUpperCase();
	        validateWith = function(el) {
	          return el.nodeName.toUpperCase() === tagName;
	        };
	      }
	
	      if (el instanceof angular.element) el = el[0];
	      if (onlyParent) el = el.parentNode;
	      if (!el) return null;
	
	      do {
	        if (validateWith(el)) {
	          return el;
	        }
	      } while (el = el.parentNode);
	
	      return null;
	    },
	
	    /**
	     * Build polyfill for the Node.contains feature (if needed)
	     * @param {Node} node
	     * @param {Node} child
	     * @returns {Node}
	     */
	    elementContains: function(node, child) {
	      var hasContains = (window.Node && window.Node.prototype && Node.prototype.contains);
	      var findFn = hasContains ? angular.bind(node, node.contains) : angular.bind(node, function(arg) {
	        // compares the positions of two nodes and returns a bitmask
	        return (node === child) || !!(this.compareDocumentPosition(arg) & 16);
	      });
	
	      return findFn(child);
	    },
	
	    /**
	     * Functional equivalent for $element.filter(‘md-bottom-sheet’)
	     * useful with interimElements where the element and its container are important...
	     *
	     * @param {JQLite} element to scan
	     * @param {string} nodeName of node to find (e.g. 'md-dialog')
	     * @param {boolean=} scanDeep optional flag to allow deep scans; defaults to 'false'.
	     * @param {boolean=} warnNotFound optional flag to enable log warnings; defaults to false
	     */
	    extractElementByName: function(element, nodeName, scanDeep, warnNotFound) {
	      var found = scanTree(element);
	      if (!found && !!warnNotFound) {
	        $log.warn($mdUtil.supplant("Unable to find node '{0}' in element '{1}'.",[nodeName, element[0].outerHTML]));
	      }
	
	      return angular.element(found || element);
	
	      /**
	       * Breadth-First tree scan for element with matching `nodeName`
	       */
	      function scanTree(element) {
	        return scanLevel(element) || (scanDeep ? scanChildren(element) : null);
	      }
	
	      /**
	       * Case-insensitive scan of current elements only (do not descend).
	       */
	      function scanLevel(element) {
	        if (element) {
	          for (var i = 0, len = element.length; i < len; i++) {
	            if (element[i].nodeName.toLowerCase() === nodeName) {
	              return element[i];
	            }
	          }
	        }
	        return null;
	      }
	
	      /**
	       * Scan children of specified node
	       */
	      function scanChildren(element) {
	        var found;
	        if (element) {
	          for (var i = 0, len = element.length; i < len; i++) {
	            var target = element[i];
	            if (!found) {
	              for (var j = 0, numChild = target.childNodes.length; j < numChild; j++) {
	                found = found || scanTree([target.childNodes[j]]);
	              }
	            }
	          }
	        }
	        return found;
	      }
	
	    },
	
	    /**
	     * Give optional properties with no value a boolean true if attr provided or false otherwise
	     */
	    initOptionalProperties: function(scope, attr, defaults) {
	      defaults = defaults || {};
	      angular.forEach(scope.$$isolateBindings, function(binding, key) {
	        if (binding.optional && angular.isUndefined(scope[key])) {
	          var attrIsDefined = angular.isDefined(attr[binding.attrName]);
	          scope[key] = angular.isDefined(defaults[key]) ? defaults[key] : attrIsDefined;
	        }
	      });
	    },
	
	    /**
	     * Alternative to $timeout calls with 0 delay.
	     * nextTick() coalesces all calls within a single frame
	     * to minimize $digest thrashing
	     *
	     * @param {Function} callback function to be called after the tick
	     * @param {boolean=} digest true to call $rootScope.$digest() after callback
	     * @param {Object=} scope associated with callback. If the scope is destroyed, the callback will
	     *  be skipped.
	     * @returns {*}
	     */
	    nextTick: function(callback, digest, scope) {
	      // grab function reference for storing state details
	      var nextTick = $mdUtil.nextTick;
	      var timeout = nextTick.timeout;
	      var queue = nextTick.queue || [];
	
	      // add callback to the queue
	      queue.push({scope: scope, callback: callback});
	
	      // set default value for digest
	      if (digest == null) digest = true;
	
	      // store updated digest/queue values
	      nextTick.digest = nextTick.digest || digest;
	      nextTick.queue = queue;
	
	      // either return existing timeout or create a new one
	      return timeout || (nextTick.timeout = $timeout(processQueue, 0, false));
	
	      /**
	       * Grab a copy of the current queue
	       * Clear the queue for future use
	       * Process the existing queue
	       * Trigger digest if necessary
	       */
	      function processQueue() {
	        var queue = nextTick.queue;
	        var digest = nextTick.digest;
	
	        nextTick.queue = [];
	        nextTick.timeout = null;
	        nextTick.digest = false;
	
	        queue.forEach(function(queueItem) {
	          var skip = queueItem.scope && queueItem.scope.$$destroyed;
	          if (!skip) {
	            queueItem.callback();
	          }
	        });
	
	        if (digest) $rootScope.$digest();
	      }
	    },
	
	    /**
	     * Processes a template and replaces the start/end symbols if the application has
	     * overridden them.
	     *
	     * @param template The template to process whose start/end tags may be replaced.
	     * @returns {*}
	     */
	    processTemplate: function(template) {
	      if (usesStandardSymbols) {
	        return template;
	      } else {
	        if (!template || !angular.isString(template)) return template;
	        return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	      }
	    },
	
	    /**
	     * Scan up dom hierarchy for enabled parent;
	     */
	    getParentWithPointerEvents: function (element) {
	      var parent = element.parent();
	
	      // jqLite might return a non-null, but still empty, parent; so check for parent and length
	      while (hasComputedStyle(parent, 'pointer-events', 'none')) {
	        parent = parent.parent();
	      }
	
	      return parent;
	    },
	
	    getNearestContentElement: function (element) {
	      var current = element.parent()[0];
	      // Look for the nearest parent md-content, stopping at the rootElement.
	      while (current && current !== $rootElement[0] && current !== document.body && current.nodeName.toUpperCase() !== 'MD-CONTENT') {
	        current = current.parentNode;
	      }
	      return current;
	    },
	
	    /**
	     * Checks if the current browser is natively supporting the `sticky` position.
	     * @returns {string} supported sticky property name
	     */
	    checkStickySupport: function() {
	      var stickyProp;
	      var testEl = angular.element('<div>');
	      $document[0].body.appendChild(testEl[0]);
	
	      var stickyProps = ['sticky', '-webkit-sticky'];
	      for (var i = 0; i < stickyProps.length; ++i) {
	        testEl.css({
	          position: stickyProps[i],
	          top: 0,
	          'z-index': 2
	        });
	
	        if (testEl.css('position') == stickyProps[i]) {
	          stickyProp = stickyProps[i];
	          break;
	        }
	      }
	
	      testEl.remove();
	
	      return stickyProp;
	    },
	
	    /**
	     * Parses an attribute value, mostly a string.
	     * By default checks for negated values and returns `false´ if present.
	     * Negated values are: (native falsy) and negative strings like:
	     * `false` or `0`.
	     * @param value Attribute value which should be parsed.
	     * @param negatedCheck When set to false, won't check for negated values.
	     * @returns {boolean}
	     */
	    parseAttributeBoolean: function(value, negatedCheck) {
	      return value === '' || !!value && (negatedCheck === false || value !== 'false' && value !== '0');
	    },
	
	    hasComputedStyle: hasComputedStyle,
	
	    /**
	     * Returns true if the parent form of the element has been submitted.
	     * @param element An AngularJS or HTML5 element.
	     * @returns {boolean}
	     */
	    isParentFormSubmitted: function(element) {
	      var parent = $mdUtil.getClosest(element, 'form');
	      var form = parent ? angular.element(parent).controller('form') : null;
	
	      return form ? form.$submitted : false;
	    },
	
	    /**
	     * Animate the requested element's scrollTop to the requested scrollPosition with basic easing.
	     * @param {!Element} element The element to scroll.
	     * @param {number} scrollEnd The new/final scroll position.
	     * @param {number=} duration Duration of the scroll. Default is 1000ms.
	     */
	    animateScrollTo: function(element, scrollEnd, duration) {
	      var scrollStart = element.scrollTop;
	      var scrollChange = scrollEnd - scrollStart;
	      var scrollingDown = scrollStart < scrollEnd;
	      var startTime = $mdUtil.now();
	
	      $$rAF(scrollChunk);
	
	      function scrollChunk() {
	        var newPosition = calculateNewPosition();
	
	        element.scrollTop = newPosition;
	
	        if (scrollingDown ? newPosition < scrollEnd : newPosition > scrollEnd) {
	          $$rAF(scrollChunk);
	        }
	      }
	
	      function calculateNewPosition() {
	        var easeDuration = duration || 1000;
	        var currentTime = $mdUtil.now() - startTime;
	
	        return ease(currentTime, scrollStart, scrollChange, easeDuration);
	      }
	
	      function ease(currentTime, start, change, duration) {
	        // If the duration has passed (which can occur if our app loses focus due to $$rAF), jump
	        // straight to the proper position
	        if (currentTime > duration) {
	          return start + change;
	        }
	
	        var ts = (currentTime /= duration) * currentTime;
	        var tc = ts * currentTime;
	
	        return start + change * (-2 * tc + 3 * ts);
	      }
	    },
	
	    /**
	     * Provides an easy mechanism for removing duplicates from an array.
	     *
	     *    var myArray = [1, 2, 2, 3, 3, 3, 4, 4, 4, 4];
	     *
	     *    $mdUtil.uniq(myArray) => [1, 2, 3, 4]
	     *
	     * @param {Array} array The array whose unique values should be returned.
	     * @returns {Array|void} A copy of the array containing only unique values.
	     */
	    uniq: function(array) {
	      if (!array) { return; }
	
	      return array.filter(function(value, index, self) {
	        return self.indexOf(value) === index;
	      });
	    },
	
	    /**
	     * Gets the inner HTML content of the given HTMLElement.
	     * Only intended for use with SVG or Symbol elements in IE11.
	     * @param {Element} element
	     * @returns {string} the inner HTML of the element passed in
	     */
	    getInnerHTML: function(element) {
	      // For SVG or Symbol elements, innerHTML returns `undefined` in IE.
	      // Reference: https://stackoverflow.com/q/28129956/633107
	      // The XMLSerializer API is supported on IE11 and is the recommended workaround.
	      var serializer = new XMLSerializer();
	
	      return Array.prototype.map.call(element.childNodes, function (child) {
	        return serializer.serializeToString(child);
	      }).join('');
	    },
	
	    /**
	     * Gets the outer HTML content of the given HTMLElement.
	     * Only intended for use with SVG or Symbol elements in IE11.
	     * @param {Element} element
	     * @returns {string} the outer HTML of the element passed in
	     */
	    getOuterHTML: function(element) {
	      // For SVG or Symbol elements, outerHTML returns `undefined` in IE.
	      // Reference: https://stackoverflow.com/q/29888050/633107
	      // The XMLSerializer API is supported on IE11 and is the recommended workaround.
	      var serializer = new XMLSerializer();
	      return serializer.serializeToString(element);
	    },
	
	    /**
	     * Support: IE 9-11 only
	     * documentMode is an IE-only property
	     * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	     */
	    msie: window.document.documentMode,
	
	    getTouchAction: function() {
	      var testEl = document.createElement('div');
	      var vendorPrefixes = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	
	      for (var i = 0; i < vendorPrefixes.length; i++) {
	        var prefix = vendorPrefixes[i];
	        var property = prefix ? prefix + 'TouchAction' : 'touchAction';
	        if (angular.isDefined(testEl.style[property])) {
	          return property;
	        }
	      }
	    },
	
	    /**
	     * @param {Event} event the event to calculate the bubble path for
	     * @return {EventTarget[]} the set of nodes that this event could bubble up to
	     */
	    getEventPath: function(event) {
	      var path = [];
	      var currentTarget = event.target;
	      while (currentTarget) {
	        path.push(currentTarget);
	        currentTarget = currentTarget.parentElement;
	      }
	      if (path.indexOf(window) === -1 && path.indexOf(document) === -1)
	        path.push(document);
	      if (path.indexOf(window) === -1)
	        path.push(window);
	      return path;
	    },
	
	    /**
	     * Gets the string the user has entered and removes Regex identifiers
	     * @param {string} term
	     * @returns {string} sanitized string
	     */
	    sanitize: function(term) {
	      if (!term) return term;
	      return term.replace(/[\\^$*+?.()|{}[]/g, '\\$&');
	    },
	
	    /**********************************************************************************************
	     * The following functions were sourced from
	     * https://github.com/angular/components/blob/3c37e4b1c1cb74a3d0a90d173240fc730d21d9d4/src/cdk/a11y/interactivity-checker/interactivity-checker.ts
	     **********************************************************************************************/
	
	    /**
	     * Gets whether an element is disabled.
	     * @param {HTMLElement} element Element to be checked.
	     * @returns {boolean} Whether the element is disabled.
	     */
	    isDisabled: function(element) {
	      // This does not capture some cases, such as a non-form control with a disabled attribute or
	      // a form control inside of a disabled form, but should capture the most common cases.
	      return element.hasAttribute('disabled');
	    },
	
	    /**
	     * Gets whether an element is visible for the purposes of interactivity.
	     *
	     * This will capture states like `display: none` and `visibility: hidden`, but not things like
	     * being clipped by an `overflow: hidden` parent or being outside the viewport.
	     *
	     * @param {HTMLElement} element
	     * @returns {boolean} Whether the element is visible.
	     */
	    isVisible: function(element) {
	      return $mdUtil.hasGeometry(element) && getComputedStyle(element).visibility === 'visible';
	    },
	
	    /**
	     * Gets whether an element can be reached via Tab key.
	     * Assumes that the element has already been checked with isFocusable.
	     * @param {HTMLElement} element Element to be checked.
	     * @returns {boolean} Whether the element is tabbable.
	     */
	    isTabbable: function(element) {
	      var frameElement = $mdUtil.getFrameElement($mdUtil.getWindow(element));
	
	      if (frameElement) {
	        // Frame elements inherit their tabindex onto all child elements.
	        if ($mdUtil.getTabIndexValue(frameElement) === -1) {
	          return false;
	        }
	
	        // Browsers disable tabbing to an element inside of an invisible frame.
	        if (!$mdUtil.isVisible(frameElement)) {
	          return false;
	        }
	      }
	
	      var nodeName = element.nodeName.toLowerCase();
	      var tabIndexValue = $mdUtil.getTabIndexValue(element);
	
	      if (element.hasAttribute('contenteditable')) {
	        return tabIndexValue !== -1;
	      }
	
	      if (nodeName === 'iframe' || nodeName === 'object') {
	        // The frame or object's content may be tabbable depending on the content, but it's
	        // not possibly to reliably detect the content of the frames. We always consider such
	        // elements as non-tabbable.
	        return false;
	      }
	
	      // In iOS, the browser only considers some specific elements as tabbable.
	      if (isIos && !$mdUtil.isPotentiallyTabbableIOS(element)) {
	        return false;
	      }
	
	      if (nodeName === 'audio') {
	        // Audio elements without controls enabled are never tabbable, regardless
	        // of the tabindex attribute explicitly being set.
	        if (!element.hasAttribute('controls')) {
	          return false;
	        }
	        // Audio elements with controls are by default tabbable unless the
	        // tabindex attribute is set to `-1` explicitly.
	        return tabIndexValue !== -1;
	      }
	
	      if (nodeName === 'video') {
	        // For all video elements, if the tabindex attribute is set to `-1`, the video
	        // is not tabbable. Note: We cannot rely on the default `HTMLElement.tabIndex`
	        // property as that one is set to `-1` in Chrome, Edge and Safari v13.1. The
	        // tabindex attribute is the source of truth here.
	        if (tabIndexValue === -1) {
	          return false;
	        }
	        // If the tabindex is explicitly set, and not `-1` (as per check before), the
	        // video element is always tabbable (regardless of whether it has controls or not).
	        if (tabIndexValue !== null) {
	          return true;
	        }
	        // Otherwise (when no explicit tabindex is set), a video is only tabbable if it
	        // has controls enabled. Firefox is special as videos are always tabbable regardless
	        // of whether there are controls or not.
	        return isFirefox || element.hasAttribute('controls');
	      }
	
	      return element.tabIndex >= 0;
	    },
	
	    /**
	     * Gets whether an element can be focused by the user.
	     * @param {HTMLElement} element Element to be checked.
	     * @returns {boolean} Whether the element is focusable.
	     */
	    isFocusable: function(element) {
	      // Perform checks in order of left to most expensive.
	      // Again, naive approach that does not capture many edge cases and browser quirks.
	      return $mdUtil.isPotentiallyFocusable(element) && !$mdUtil.isDisabled(element) &&
	        $mdUtil.isVisible(element);
	    },
	
	    /**
	     * Gets whether an element is potentially focusable without taking current visible/disabled
	     * state into account.
	     * @param {HTMLElement} element
	     * @returns {boolean}
	     */
	    isPotentiallyFocusable: function(element) {
	      // Inputs are potentially focusable *unless* they're type="hidden".
	      if ($mdUtil.isHiddenInput(element)) {
	        return false;
	      }
	
	      return $mdUtil.isNativeFormElement(element) ||
	        $mdUtil.isAnchorWithHref(element) ||
	        element.hasAttribute('contenteditable') ||
	        $mdUtil.hasValidTabIndex(element);
	    },
	
	    /**
	     * Checks whether the specified element is potentially tabbable on iOS.
	     * @param {HTMLElement} element
	     * @returns {boolean}
	     */
	    isPotentiallyTabbableIOS: function(element) {
	      var nodeName = element.nodeName.toLowerCase();
	        var inputType = nodeName === 'input' && element.type;
	
	      return inputType === 'text'
	        || inputType === 'password'
	        || nodeName === 'select'
	        || nodeName === 'textarea';
	    },
	
	    /**
	     * Returns the parsed tabindex from the element attributes instead of returning the
	     * evaluated tabindex from the browsers defaults.
	     * @param {HTMLElement} element
	     * @returns {null|number}
	     */
	    getTabIndexValue: function(element) {
	      if (!$mdUtil.hasValidTabIndex(element)) {
	        return null;
	      }
	
	      // See browser issue in Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
	      var tabIndex = parseInt(element.getAttribute('tabindex') || '', 10);
	
	      return isNaN(tabIndex) ? -1 : tabIndex;
	    },
	
	    /**
	     * Gets whether an element has a valid tabindex.
	     * @param {HTMLElement} element
	     * @returns {boolean}
	     */
	    hasValidTabIndex: function(element) {
	      if (!element.hasAttribute('tabindex') || element.tabIndex === undefined) {
	        return false;
	      }
	
	      var tabIndex = element.getAttribute('tabindex');
	
	      // IE11 parses tabindex="" as the value "-32768"
	      if (tabIndex == '-32768') {
	        return false;
	      }
	
	      return !!(tabIndex && !isNaN(parseInt(tabIndex, 10)));
	    },
	
	    /**
	     * Checks whether the specified element has any geometry / rectangles.
	     * @param {HTMLElement} element
	     * @returns {boolean}
	     */
	    hasGeometry: function(element) {
	      // Use logic from jQuery to check for an invisible element.
	      // See https://github.com/jquery/jquery/blob/8969732518470a7f8e654d5bc5be0b0076cb0b87/src/css/hiddenVisibleSelectors.js#L9
	      return !!(element.offsetWidth || element.offsetHeight ||
	        (typeof element.getClientRects === 'function' && element.getClientRects().length));
	    },
	
	    /**
	     * Returns the frame element from a window object. Since browsers like MS Edge throw errors if
	     * the frameElement property is being accessed from a different host address, this property
	     * should be accessed carefully.
	     * @param {Window} window
	     * @returns {null|HTMLElement}
	     */
	    getFrameElement: function(window) {
	      try {
	        return window.frameElement;
	      } catch (error) {
	        return null;
	      }
	    },
	
	    /**
	     * Gets the parent window of a DOM node with regards of being inside of an iframe.
	     * @param {HTMLElement} node
	     * @returns {Window}
	     */
	    getWindow: function(node) {
	      // ownerDocument is null if `node` itself *is* a document.
	      return node.ownerDocument && node.ownerDocument.defaultView || window;
	    },
	
	    /**
	     * Gets whether an element's
	     * @param {Node} element
	     * @returns {boolean}
	     */
	    isNativeFormElement: function(element) {
	      var nodeName = element.nodeName.toLowerCase();
	      return nodeName === 'input' ||
	        nodeName === 'select' ||
	        nodeName === 'button' ||
	        nodeName === 'textarea';
	    },
	
	    /**
	     * Gets whether an element is an `<input type="hidden">`.
	     * @param {HTMLElement} element
	     * @returns {boolean}
	     */
	    isHiddenInput: function(element) {
	      return $mdUtil.isInputElement(element) && element.type == 'hidden';
	    },
	
	    /**
	     * Gets whether an element is an anchor that has an href attribute.
	     * @param {HTMLElement} element
	     * @returns {boolean}
	     */
	    isAnchorWithHref: function(element) {
	      return $mdUtil.isAnchorElement(element) && element.hasAttribute('href');
	    },
	
	    /**
	     * Gets whether an element is an input element.
	     * @param {HTMLElement} element
	     * @returns {boolean}
	     */
	    isInputElement: function(element) {
	      return element.nodeName.toLowerCase() == 'input';
	    },
	
	    /**
	     * Gets whether an element is an anchor element.
	     * @param {HTMLElement} element
	     * @returns {boolean}
	     */
	    isAnchorElement: function(element) {
	      return element.nodeName.toLowerCase() == 'a';
	    },
	
	    /**********************************************************************************************
	     * The following two functions were sourced from
	     * https://github.com/angular/components/blob/3c37e4b1c1cb74a3d0a90d173240fc730d21d9d4/src/cdk/a11y/focus-trap/focus-trap.ts#L268-L311
	     **********************************************************************************************/
	
	    /**
	     * Get the first tabbable element from a DOM subtree (inclusive).
	     * @param {HTMLElement} root
	     * @returns {HTMLElement|null}
	     */
	    getFirstTabbableElement: function(root) {
	      if ($mdUtil.isFocusable(root) && $mdUtil.isTabbable(root)) {
	        return root;
	      }
	
	      // Iterate in DOM order. Note that IE doesn't have `children` for SVG so we fall
	      // back to `childNodes` which includes text nodes, comments etc.
	      var children = root.children || root.childNodes;
	
	      for (var i = 0; i < children.length; i++) {
	        var tabbableChild = children[i].nodeType === $document[0].ELEMENT_NODE ?
	          $mdUtil.getFirstTabbableElement(children[i]) : null;
	
	        if (tabbableChild) {
	          return tabbableChild;
	        }
	      }
	
	      return null;
	    },
	
	    /**
	     * Get the last tabbable element from a DOM subtree (inclusive).
	     * @param {HTMLElement} root
	     * @returns {HTMLElement|null}
	     */
	    getLastTabbableElement: function(root) {
	      if ($mdUtil.isFocusable(root) && $mdUtil.isTabbable(root)) {
	        return root;
	      }
	
	      // Iterate in reverse DOM order.
	      var children = root.children || root.childNodes;
	
	      for (var i = children.length - 1; i >= 0; i--) {
	        var tabbableChild = children[i].nodeType === $document[0].ELEMENT_NODE ?
	          $mdUtil.getLastTabbableElement(children[i]) : null;
	
	        if (tabbableChild) {
	          return tabbableChild;
	        }
	      }
	
	      return null;
	    }
	  };
	
	  // Instantiate other namespace utility methods
	
	  $mdUtil.dom.animator = $$mdAnimate($mdUtil);
	
	  return $mdUtil;
	
	  function getNode(el) {
	    return el[0] || el;
	  }
	}
	
	/**
	 * Since removing jQuery from the demos, some code that uses `element.focus()` is broken.
	 * We need to add `element.focus()`, because it's testable unlike `element[0].focus`.
	 */
	angular.element.prototype.focus = angular.element.prototype.focus || function() {
	  if (this.length) {
	    this[0].focus();
	  }
	  return this;
	};
	
	angular.element.prototype.blur = angular.element.prototype.blur || function() {
	  if (this.length) {
	    this[0].blur();
	  }
	  return this;
	};
	
	})();
	(function(){
	"use strict";
	
	// Polyfill angular < 1.4 (provide $animateCss)
	angular
	  .module('material.core')
	  .factory('$$mdAnimate', ["$q", "$timeout", "$mdConstant", "$animateCss", function($q, $timeout, $mdConstant, $animateCss) {
	     // Since $$mdAnimate is injected into $mdUtil... use a wrapper function
	     // to subsequently inject $mdUtil as an argument to the AnimateDomUtils
	     return function($mdUtil) {
	       return AnimateDomUtils($mdUtil, $q, $timeout, $mdConstant, $animateCss);
	     };
	   }]);
	
	/**
	 * Factory function that requires special injections
	 */
	function AnimateDomUtils($mdUtil, $q, $timeout, $mdConstant, $animateCss) {
	  var self;
	  return self = {
	    translate3d : function(target, from, to, options) {
	      return $animateCss(target, {
	        from: from,
	        to: to,
	        addClass: options.transitionInClass,
	        removeClass: options.transitionOutClass,
	        duration: options.duration
	      })
	      .start()
	      .then(function() {
	          // Resolve with reverser function...
	          return reverseTranslate;
	      });
	
	      /**
	       * Specific reversal of the request translate animation above...
	       */
	      function reverseTranslate (newFrom) {
	        return $animateCss(target, {
	           to: newFrom || from,
	           addClass: options.transitionOutClass,
	           removeClass: options.transitionInClass,
	           duration: options.duration
	        }).start();
	      }
	    },
	
	    /**
	     * Listen for transitionEnd event (with optional timeout)
	     * Announce completion or failure via promise handlers
	     */
	    waitTransitionEnd: function (element, opts) {
	      var TIMEOUT = 3000; // fallback is 3 secs
	
	      return $q(function(resolve, reject){
	        opts = opts || { };
	
	        // If there is no transition is found, resolve immediately
	        //
	        // NOTE: using $mdUtil.nextTick() causes delays/issues
	        if (noTransitionFound(opts.cachedTransitionStyles)) {
	          TIMEOUT = 0;
	        }
	
	        var timer = $timeout(finished, opts.timeout || TIMEOUT);
	        element.on($mdConstant.CSS.TRANSITIONEND, finished);
	
	        /**
	         * Upon timeout or transitionEnd, reject or resolve (respectively) this promise.
	         * NOTE: Make sure this transitionEnd didn't bubble up from a child
	         */
	        function finished(ev) {
	          if (ev && ev.target !== element[0]) return;
	
	          if (ev) $timeout.cancel(timer);
	          element.off($mdConstant.CSS.TRANSITIONEND, finished);
	
	          // Never reject since ngAnimate may cause timeouts due missed transitionEnd events
	          resolve();
	        }
	
	        /**
	         * Checks whether or not there is a transition.
	         *
	         * @param styles The cached styles to use for the calculation. If null, getComputedStyle()
	         * will be used.
	         *
	         * @returns {boolean} True if there is no transition/duration; false otherwise.
	         */
	        function noTransitionFound(styles) {
	          styles = styles || window.getComputedStyle(element[0]);
	
	          return styles.transitionDuration === '0s' ||
	            (!styles.transition && !styles.transitionProperty);
	        }
	      });
	    },
	
	    calculateTransformValues: function (element, originator) {
	      var origin = originator.element;
	      var bounds = originator.bounds;
	
	      if (origin || bounds) {
	        var originBnds = origin ? self.clientRect(origin) || currentBounds() : self.copyRect(bounds);
	        var dialogRect = self.copyRect(element[0].getBoundingClientRect());
	        var dialogCenterPt = self.centerPointFor(dialogRect);
	        var originCenterPt = self.centerPointFor(originBnds);
	
	        return {
	          centerX: originCenterPt.x - dialogCenterPt.x,
	          centerY: originCenterPt.y - dialogCenterPt.y,
	          scaleX: Math.round(100 * Math.min(0.5, originBnds.width / dialogRect.width)) / 100,
	          scaleY: Math.round(100 * Math.min(0.5, originBnds.height / dialogRect.height)) / 100
	        };
	      }
	      return {centerX: 0, centerY: 0, scaleX: 0.5, scaleY: 0.5};
	
	      /**
	       * This is a fallback if the origin information is no longer valid, then the
	       * origin bounds simply becomes the current bounds for the dialogContainer's parent.
	       * @returns {null|DOMRect}
	       */
	      function currentBounds() {
	        var container = element ? element.parent() : null;
	        var parent = container ? container.parent() : null;
	
	        return parent ? self.clientRect(parent) : null;
	      }
	    },
	
	    /**
	     * Calculate the zoom transform from dialog to origin.
	     *
	     * We use this to set the dialog position immediately;
	     * then the md-transition-in actually translates back to
	     * `translate3d(0,0,0) scale(1.0)`...
	     *
	     * NOTE: all values are rounded to the nearest integer
	     */
	    calculateZoomToOrigin: function (element, originator) {
	      var zoomTemplate = "translate3d( {centerX}px, {centerY}px, 0 ) scale( {scaleX}, {scaleY} )";
	      var buildZoom = angular.bind(null, $mdUtil.supplant, zoomTemplate);
	
	      return buildZoom(self.calculateTransformValues(element, originator));
	    },
	
	    /**
	     * Calculate the slide transform from panel to origin.
	     * NOTE: all values are rounded to the nearest integer
	     */
	    calculateSlideToOrigin: function (element, originator) {
	      var slideTemplate = "translate3d( {centerX}px, {centerY}px, 0 )";
	      var buildSlide = angular.bind(null, $mdUtil.supplant, slideTemplate);
	
	      return buildSlide(self.calculateTransformValues(element, originator));
	    },
	
	    /**
	     * Enhance raw values to represent valid css stylings...
	     */
	    toCss : function(raw) {
	      var css = { };
	      var lookups = 'left top right bottom width height x y min-width min-height max-width max-height';
	
	      angular.forEach(raw, function(value,key) {
	        if (angular.isUndefined(value)) return;
	
	        if (lookups.indexOf(key) >= 0) {
	          css[key] = value + 'px';
	        } else {
	          switch (key) {
	            case 'transition':
	              convertToVendor(key, $mdConstant.CSS.TRANSITION, value);
	              break;
	            case 'transform':
	              convertToVendor(key, $mdConstant.CSS.TRANSFORM, value);
	              break;
	            case 'transformOrigin':
	              convertToVendor(key, $mdConstant.CSS.TRANSFORM_ORIGIN, value);
	              break;
	            case 'font-size':
	              css['font-size'] = value; // font sizes aren't always in px
	              break;
	          }
	        }
	      });
	
	      return css;
	
	      function convertToVendor(key, vendor, value) {
	        angular.forEach(vendor.split(' '), function (key) {
	          css[key] = value;
	        });
	      }
	    },
	
	    /**
	     * Convert the translate CSS value to key/value pair(s).
	     * @param {string} transform
	     * @param {boolean=} addTransition
	     * @param {string=} transition
	     * @return {Object} object containing CSS translate key/value pair(s)
	     */
	    toTransformCss: function (transform, addTransition, transition) {
	      var css = {};
	      angular.forEach($mdConstant.CSS.TRANSFORM.split(' '), function (key) {
	        css[key] = transform;
	      });
	
	      if (addTransition) {
	        transition = transition || "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1) !important";
	        css.transition = transition;
	      }
	
	      return css;
	    },
	
	    /**
	     * Clone the Rect and calculate the height/width if needed.
	     * @param {DOMRect} source
	     * @param {DOMRect=} destination
	     * @returns {null|DOMRect}
	     */
	    copyRect: function (source, destination) {
	      if (!source) return null;
	
	      destination = destination || {};
	
	      angular.forEach('left top right bottom width height'.split(' '), function (key) {
	        destination[key] = Math.round(source[key]);
	      });
	
	      destination.width = destination.width || (destination.right - destination.left);
	      destination.height = destination.height || (destination.bottom - destination.top);
	
	      return destination;
	    },
	
	    /**
	     * Calculate ClientRect of element; return null if hidden or zero size.
	     * @param {Element|string} element
	     * @returns {null|DOMRect}
	     */
	    clientRect: function (element) {
	      var bounds = angular.element(element)[0].getBoundingClientRect();
	      var isPositiveSizeClientRect = function (rect) {
	        return rect && (rect.width > 0) && (rect.height > 0);
	      };
	
	      // If the event origin element has zero size, it has probably been hidden.
	      return isPositiveSizeClientRect(bounds) ? self.copyRect(bounds) : null;
	    },
	
	    /**
	     * Calculate 'rounded' center point of Rect
	     * @param {DOMRect} targetRect
	     * @returns {{x: number, y: number}}
	     */
	    centerPointFor: function (targetRect) {
	      return targetRect ? {
	        x: Math.round(targetRect.left + (targetRect.width / 2)),
	        y: Math.round(targetRect.top + (targetRect.height / 2))
	      } : { x : 0, y : 0 };
	    }
	  };
	}
	
	
	})();
	(function(){
	"use strict";
	
	if (angular.version.minor >= 4) {
	  angular.module('material.core.animate', []);
	} else {
	(function() {
	  "use strict";
	
	  var forEach = angular.forEach;
	
	  var WEBKIT = angular.isDefined(document.documentElement.style.WebkitAppearance);
	  var TRANSITION_PROP = WEBKIT ? 'WebkitTransition' : 'transition';
	  var ANIMATION_PROP = WEBKIT ? 'WebkitAnimation' : 'animation';
	  var PREFIX = WEBKIT ? '-webkit-' : '';
	
	  var TRANSITION_EVENTS = (WEBKIT ? 'webkitTransitionEnd ' : '') + 'transitionend';
	  var ANIMATION_EVENTS = (WEBKIT ? 'webkitAnimationEnd ' : '') + 'animationend';
	
	  var $$ForceReflowFactory = ['$document', function($document) {
	    return function() {
	      return $document[0].body.clientWidth + 1;
	    };
	  }];
	
	  var $$rAFMutexFactory = ['$$rAF', function($$rAF) {
	    return function() {
	      var passed = false;
	      $$rAF(function() {
	        passed = true;
	      });
	      return function(fn) {
	        passed ? fn() : $$rAF(fn);
	      };
	    };
	  }];
	
	  var $$AnimateRunnerFactory = ['$q', '$$rAFMutex', function($q, $$rAFMutex) {
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      this._doneCallbacks = [];
	      this._runInAnimationFrame = $$rAFMutex();
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: angular.noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              status === false ? reject() : resolve();
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._runInAnimationFrame(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    // Polyfill AnimateRunner.all which is used by input animations
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	
	  angular
	    .module('material.core.animate', [])
	    .factory('$$forceReflow', $$ForceReflowFactory)
	    .factory('$$AnimateRunner', $$AnimateRunnerFactory)
	    .factory('$$rAFMutex', $$rAFMutexFactory)
	    .factory('$animateCss', ['$window', '$$rAF', '$$AnimateRunner', '$$forceReflow', '$$jqLite', '$timeout', '$animate',
	                     function($window,   $$rAF,   $$AnimateRunner,   $$forceReflow,   $$jqLite,   $timeout, $animate) {
	
	      function init(element, options) {
	
	        var temporaryStyles = [];
	        var node = getDomNode(element);
	        var areAnimationsAllowed = node && $animate.enabled();
	
	        var hasCompleteStyles = false;
	        var hasCompleteClasses = false;
	
	        if (areAnimationsAllowed) {
	          if (options.transitionStyle) {
	            temporaryStyles.push([PREFIX + 'transition', options.transitionStyle]);
	          }
	
	          if (options.keyframeStyle) {
	            temporaryStyles.push([PREFIX + 'animation', options.keyframeStyle]);
	          }
	
	          if (options.delay) {
	            temporaryStyles.push([PREFIX + 'transition-delay', options.delay + 's']);
	          }
	
	          if (options.duration) {
	            temporaryStyles.push([PREFIX + 'transition-duration', options.duration + 's']);
	          }
	
	          hasCompleteStyles = options.keyframeStyle ||
	              (options.to && (options.duration > 0 || options.transitionStyle));
	          hasCompleteClasses = !!options.addClass || !!options.removeClass;
	
	          blockTransition(element, true);
	        }
	
	        var hasCompleteAnimation = areAnimationsAllowed && (hasCompleteStyles || hasCompleteClasses);
	
	        applyAnimationFromStyles(element, options);
	
	        var animationClosed = false;
	        var events, eventFn;
	
	        return {
	          close: $window.close,
	          start: function() {
	            var runner = new $$AnimateRunner();
	            waitUntilQuiet(function() {
	              blockTransition(element, false);
	              if (!hasCompleteAnimation) {
	                return close();
	              }
	
	              forEach(temporaryStyles, function(entry) {
	                var key = entry[0];
	                var value = entry[1];
	                node.style[camelCase(key)] = value;
	              });
	
	              applyClasses(element, options);
	
	              var timings = computeTimings(element);
	              if (timings.duration === 0) {
	                return close();
	              }
	
	              var moreStyles = [];
	
	              if (options.easing) {
	                if (timings.transitionDuration) {
	                  moreStyles.push([PREFIX + 'transition-timing-function', options.easing]);
	                }
	                if (timings.animationDuration) {
	                  moreStyles.push([PREFIX + 'animation-timing-function', options.easing]);
	                }
	              }
	
	              if (options.delay && timings.animationDelay) {
	                moreStyles.push([PREFIX + 'animation-delay', options.delay + 's']);
	              }
	
	              if (options.duration && timings.animationDuration) {
	                moreStyles.push([PREFIX + 'animation-duration', options.duration + 's']);
	              }
	
	              forEach(moreStyles, function(entry) {
	                var key = entry[0];
	                var value = entry[1];
	                node.style[camelCase(key)] = value;
	                temporaryStyles.push(entry);
	              });
	
	              var maxDelay = timings.delay;
	              var maxDelayTime = maxDelay * 1000;
	              var maxDuration = timings.duration;
	              var maxDurationTime = maxDuration * 1000;
	              var startTime = Date.now();
	
	              events = [];
	              if (timings.transitionDuration) {
	                events.push(TRANSITION_EVENTS);
	              }
	              if (timings.animationDuration) {
	                events.push(ANIMATION_EVENTS);
	              }
	              events = events.join(' ');
	              eventFn = function(event) {
	                event.stopPropagation();
	                var ev = event.originalEvent || event;
	                var timeStamp = ev.timeStamp || Date.now();
	                var elapsedTime = parseFloat(ev.elapsedTime.toFixed(3));
	                if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	                  close();
	                }
	              };
	              element.on(events, eventFn);
	
	              applyAnimationToStyles(element, options);
	
	              $timeout(close, maxDelayTime + maxDurationTime * 1.5, false);
	            });
	
	            return runner;
	
	            function close() {
	              if (animationClosed) return;
	              animationClosed = true;
	
	              if (events && eventFn) {
	                element.off(events, eventFn);
	              }
	              applyClasses(element, options);
	              applyAnimationStyles(element, options);
	              forEach(temporaryStyles, function(entry) {
	                node.style[camelCase(entry[0])] = '';
	              });
	              runner.complete(true);
	              return runner;
	            }
	          }
	        };
	      }
	
	      function applyClasses(element, options) {
	        if (options.addClass) {
	          $$jqLite.addClass(element, options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          $$jqLite.removeClass(element, options.removeClass);
	          options.removeClass = null;
	        }
	      }
	
	      function computeTimings(element) {
	        var node = getDomNode(element);
	        var cs = $window.getComputedStyle(node);
	        var tdr = parseMaxTime(cs[prop('transitionDuration')]);
	        var adr = parseMaxTime(cs[prop('animationDuration')]);
	        var tdy = parseMaxTime(cs[prop('transitionDelay')]);
	        var ady = parseMaxTime(cs[prop('animationDelay')]);
	
	        adr *= (parseInt(cs[prop('animationIterationCount')], 10) || 1);
	        var duration = Math.max(adr, tdr);
	        var delay = Math.max(ady, tdy);
	
	        return {
	          duration: duration,
	          delay: delay,
	          animationDuration: adr,
	          transitionDuration: tdr,
	          animationDelay: ady,
	          transitionDelay: tdy
	        };
	
	        function prop(key) {
	          return WEBKIT ? 'Webkit' + key.charAt(0).toUpperCase() + key.substr(1)
	                        : key;
	        }
	      }
	
	      function parseMaxTime(str) {
	        var maxValue = 0;
	        var values = (str || "").split(/\s*,\s*/);
	        forEach(values, function(value) {
	          // it's always safe to consider only second values and omit `ms` values since
	          // getComputedStyle will always handle the conversion for us
	          if (value.charAt(value.length - 1) == 's') {
	            value = value.substring(0, value.length - 1);
	          }
	          value = parseFloat(value) || 0;
	          maxValue = maxValue ? Math.max(value, maxValue) : value;
	        });
	        return maxValue;
	      }
	
	      var cancelLastRAFRequest;
	      var rafWaitQueue = [];
	      function waitUntilQuiet(callback) {
	        if (cancelLastRAFRequest) {
	          cancelLastRAFRequest(); // cancels the request
	        }
	        rafWaitQueue.push(callback);
	        cancelLastRAFRequest = $$rAF(function() {
	          cancelLastRAFRequest = null;
	
	          // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	          // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	          var pageWidth = $$forceReflow();
	
	          // we use a for loop to ensure that if the queue is changed
	          // during this looping then it will consider new requests
	          for (var i = 0; i < rafWaitQueue.length; i++) {
	            rafWaitQueue[i](pageWidth);
	          }
	          rafWaitQueue.length = 0;
	        });
	      }
	
	      function applyAnimationStyles(element, options) {
	        applyAnimationFromStyles(element, options);
	        applyAnimationToStyles(element, options);
	      }
	
	      function applyAnimationFromStyles(element, options) {
	        if (options.from) {
	          element.css(options.from);
	          options.from = null;
	        }
	      }
	
	      function applyAnimationToStyles(element, options) {
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	
	      function getDomNode(element) {
	        for (var i = 0; i < element.length; i++) {
	          if (element[i].nodeType === 1) return element[i];
	        }
	      }
	
	      function blockTransition(element, bool) {
	        var node = getDomNode(element);
	        var key = camelCase(PREFIX + 'transition-delay');
	        node.style[key] = bool ? '-9999s' : '';
	      }
	
	      return init;
	    }]);
	
	  /**
	   * Older browsers [FF31] expect camelCase
	   * property keys.
	   * e.g.
	   *  animation-duration --> animationDuration
	   */
	  function camelCase(str) {
	    return str.replace(/-[a-z]/g, function(str) {
	      return str.charAt(1).toUpperCase();
	    });
	  }
	
	})();
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.aria
	 * @description
	 * Aria Expectations for AngularJS Material components.
	 */
	MdAriaService.$inject = ["$$rAF", "$log", "$window", "$interpolate"];
	angular
	  .module('material.core')
	  .provider('$mdAria', MdAriaProvider);
	
	/**
	 * @ngdoc service
	 * @name $mdAriaProvider
	 * @module material.core.aria
	 *
	 * @description
	 *
	 * Modify options of the `$mdAria` service, which will be used by most of the AngularJS Material
	 * components.
	 *
	 * You are able to disable `$mdAria` warnings, by using the following markup.
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdAriaProvider) {
	 *     // Globally disables all ARIA warnings.
	 *     $mdAriaProvider.disableWarnings();
	 *   });
	 * </hljs>
	 *
	 */
	function MdAriaProvider() {
	
	  var config = {
	    /** Whether we should show ARIA warnings in the console if labels are missing on the element */
	    showWarnings: true
	  };
	
	  return {
	    disableWarnings: disableWarnings,
	    $get: ["$$rAF", "$log", "$window", "$interpolate", function($$rAF, $log, $window, $interpolate) {
	      return MdAriaService.apply(config, arguments);
	    }]
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdAriaProvider#disableWarnings
	   * @description Disables all ARIA warnings generated by AngularJS Material.
	   */
	  function disableWarnings() {
	    config.showWarnings = false;
	  }
	}
	
	/*
	 * @ngInject
	 */
	function MdAriaService($$rAF, $log, $window, $interpolate) {
	
	  // Load the showWarnings option from the current context and store it inside of a scope variable,
	  // because the context will be probably lost in some function calls.
	  var showWarnings = this.showWarnings;
	
	  return {
	    expect: expect,
	    expectAsync: expectAsync,
	    expectWithText: expectWithText,
	    expectWithoutText: expectWithoutText,
	    getText: getText,
	    hasAriaLabel: hasAriaLabel,
	    parentHasAriaLabel: parentHasAriaLabel
	  };
	
	  /**
	   * Check if expected attribute has been specified on the target element or child
	   * @param {string|JQLite} element
	   * @param {string} attrName
	   * @param {string=} defaultValue What to set the attr to if no value is found
	   */
	  function expect(element, attrName, defaultValue) {
	
	    var node = angular.element(element)[0] || element;
	
	    // if node exists and neither it nor its children have the attribute
	    if (node &&
	       ((!node.hasAttribute(attrName) ||
	        node.getAttribute(attrName).length === 0) &&
	        !childHasAttribute(node, attrName))) {
	
	      defaultValue = angular.isString(defaultValue) ? defaultValue.trim() : '';
	      if (defaultValue.length) {
	        element.attr(attrName, defaultValue);
	      } else if (showWarnings) {
	        $log.warn('ARIA: Attribute "', attrName, '", required for accessibility, is missing on node:', node);
	      }
	
	    }
	  }
	
	  function expectAsync(element, attrName, defaultValueGetter) {
	    // Problem: when retrieving the element's contents synchronously to find the label,
	    // the text may not be defined yet in the case of a binding.
	    // There is a higher chance that a binding will be defined if we wait one frame.
	    $$rAF(function() {
	        expect(element, attrName, defaultValueGetter());
	    });
	  }
	
	  function expectWithText(element, attrName) {
	    var content = getText(element) || "";
	    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;
	
	    if (hasBinding) {
	      expectAsync(element, attrName, function() {
	        return getText(element);
	      });
	    } else {
	      expect(element, attrName, content);
	    }
	  }
	
	  function expectWithoutText(element, attrName) {
	    var content = getText(element);
	    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;
	
	    if (!hasBinding && !content) {
	      expect(element, attrName, content);
	    }
	  }
	
	  /**
	   * @param {Element|JQLite} element
	   * @returns {string}
	   */
	  function getText(element) {
	    element = element[0] || element;
	    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
	    var text = '';
	
	    var node;
	    while (node = walker.nextNode()) {
	      if (!isAriaHiddenNode(node)) {
	        text += node.textContent;
	      }
	    }
	
	    return text.trim() || '';
	
	    /**
	     * @param {Node} node
	     * @returns {boolean}
	     */
	    function isAriaHiddenNode(node) {
	      while (node.parentNode && (node = node.parentNode) !== element) {
	        if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
	          return true;
	        }
	      }
	    }
	  }
	
	  function childHasAttribute(node, attrName) {
	    var hasChildren = node.hasChildNodes(),
	        hasAttr = false;
	
	    function isHidden(el) {
	      var style = el.currentStyle ? el.currentStyle : $window.getComputedStyle(el);
	      return (style.display === 'none');
	    }
	
	    if (hasChildren) {
	      var children = node.childNodes;
	      for (var i=0; i < children.length; i++) {
	        var child = children[i];
	        if (child.nodeType === 1 && child.hasAttribute(attrName)) {
	          if (!isHidden(child)) {
	            hasAttr = true;
	          }
	        }
	      }
	    }
	    return hasAttr;
	  }
	
	  /**
	   * Check if expected element has aria label attribute
	   * @param element
	   */
	  function hasAriaLabel(element) {
	    var node = angular.element(element)[0] || element;
	
	    /* Check if compatible node type (ie: not HTML Document node) */
	    if (!node.hasAttribute) {
	      return false;
	    }
	
	    /* Check label or description attributes */
	    return node.hasAttribute('aria-label') || node.hasAttribute('aria-labelledby') || node.hasAttribute('aria-describedby');
	  }
	
	  /**
	   * Check if expected element's parent has aria label attribute and has valid role and tagName
	   * @param {string|JQLite|Node & ParentNode} element
	   * @param {number=} level Number of levels deep search should be performed
	   */
	  function parentHasAriaLabel(element, level) {
	    level = level || 1;
	    var node = angular.element(element)[0] || element;
	    if (!node.parentNode) {
	      return false;
	    }
	    if (performCheck(node.parentNode)) {
	      return true;
	    }
	    level--;
	    if (level) {
	      return parentHasAriaLabel(node.parentNode, level);
	    }
	    return false;
	
	    function performCheck(parentNode) {
	      if (!hasAriaLabel(parentNode)) {
	        return false;
	      }
	      /* Perform role block-list check */
	      if (parentNode.hasAttribute('role')) {
	        switch (parentNode.getAttribute('role').toLowerCase()) {
	          case 'command':
	          case 'definition':
	          case 'directory':
	          case 'grid':
	          case 'list':
	          case 'listitem':
	          case 'log':
	          case 'marquee':
	          case 'menu':
	          case 'menubar':
	          case 'note':
	          case 'presentation':
	          case 'separator':
	          case 'scrollbar':
	          case 'status':
	          case 'tablist':
	            return false;
	        }
	      }
	      /* Perform tagName block-list check */
	      switch (parentNode.tagName.toLowerCase()) {
	        case 'abbr':
	        case 'acronym':
	        case 'address':
	        case 'applet':
	        case 'audio':
	        case 'b':
	        case 'bdi':
	        case 'bdo':
	        case 'big':
	        case 'blockquote':
	        case 'br':
	        case 'canvas':
	        case 'caption':
	        case 'center':
	        case 'cite':
	        case 'code':
	        case 'col':
	        case 'data':
	        case 'dd':
	        case 'del':
	        case 'dfn':
	        case 'dir':
	        case 'div':
	        case 'dl':
	        case 'em':
	        case 'embed':
	        case 'fieldset':
	        case 'figcaption':
	        case 'font':
	        case 'h1':
	        case 'h2':
	        case 'h3':
	        case 'h4':
	        case 'h5':
	        case 'h6':
	        case 'hgroup':
	        case 'html':
	        case 'i':
	        case 'ins':
	        case 'isindex':
	        case 'kbd':
	        case 'keygen':
	        case 'label':
	        case 'legend':
	        case 'li':
	        case 'map':
	        case 'mark':
	        case 'menu':
	        case 'object':
	        case 'ol':
	        case 'output':
	        case 'pre':
	        case 'presentation':
	        case 'q':
	        case 'rt':
	        case 'ruby':
	        case 'samp':
	        case 'small':
	        case 'source':
	        case 'span':
	        case 'status':
	        case 'strike':
	        case 'strong':
	        case 'sub':
	        case 'sup':
	        case 'svg':
	        case 'tbody':
	        case 'td':
	        case 'th':
	        case 'thead':
	        case 'time':
	        case 'tr':
	        case 'track':
	        case 'tt':
	        case 'ul':
	        case 'var':
	          return false;
	      }
	      return true;
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.compiler
	 * @description
	 * AngularJS Material template and element compiler.
	 */
	angular
	  .module('material.core')
	  .provider('$mdCompiler', MdCompilerProvider);
	
	MdCompilerProvider.$inject = ['$compileProvider'];
	function MdCompilerProvider() {
	
	  this.$get = ["$q", "$templateRequest", "$injector", "$compile", "$controller",
	    function($q, $templateRequest, $injector, $compile, $controller) {
	      return new MdCompilerService($q, $templateRequest, $injector, $compile, $controller);
	    }];
	
	  /**
	   * @ngdoc service
	   * @name $mdCompiler
	   * @module material.core.compiler
	   * @description
	   * The $mdCompiler service is an abstraction of AngularJS's compiler, that allows developers
	   * to compile an element with options like in a Directive Definition Object.
	   *
	   * > The compiler powers a lot of components inside of AngularJS Material.
	   * > Like the `$mdPanel` or `$mdDialog` services.
	   *
	   * @usage
	   *
	   * Basic Usage with a template
	   *
	   * <hljs lang="js">
	   *   $mdCompiler.compile({
	   *     templateUrl: 'modal.html',
	   *     controller: 'ModalCtrl',
	   *     locals: {
	   *       modal: myModalInstance;
	   *     }
	   *   }).then(function (compileData) {
	   *     compileData.element; // Compiled DOM element
	   *     compileData.link(myScope); // Instantiate controller and link element to scope.
	   *   });
	   * </hljs>
	   *
	   * Example with a content element
	   *
	   * <hljs lang="js">
	   *
	   *   // Create a virtual element and link it manually.
	   *   // The compiler doesn't need to recompile the element each time.
	   *   var myElement = $compile('<span>Test</span>')(myScope);
	   *
	   *   $mdCompiler.compile({
	   *     contentElement: myElement
	   *   }).then(function (compileData) {
	   *     compileData.element // Content Element (same as above)
	   *     compileData.link // This does nothing when using a contentElement.
	   *   });
	   * </hljs>
	   *
	   * > Content Element is a significant performance improvement when the developer already knows
	   * > that the compiled element will be always the same and the scope will not change either.
	   *
	   * The `contentElement` option also supports DOM elements which will be temporary removed and
	   * restored at its old position.
	   *
	   * <hljs lang="js">
	   *   var domElement = document.querySelector('#myElement');
	   *
	   *   $mdCompiler.compile({
	   *     contentElement: myElement
	   *   }).then(function (compileData) {
	   *     compileData.element // Content Element (same as above)
	   *     compileData.link // This does nothing when using a contentElement.
	   *   });
	   * </hljs>
	   *
	   * The `$mdCompiler` can also query for the element in the DOM itself.
	   *
	   * <hljs lang="js">
	   *   $mdCompiler.compile({
	   *     contentElement: '#myElement'
	   *   }).then(function (compileData) {
	   *     compileData.element // Content Element (same as above)
	   *     compileData.link // This does nothing when using a contentElement.
	   *   });
	   * </hljs>
	   *
	   */
	  function MdCompilerService($q, $templateRequest, $injector, $compile, $controller) {
	
	    /**
	     * @private @const
	     * @type {!IQService}
	     */
	    this.$q = $q;
	
	    /**
	     * @private @const
	     * @type {!ITemplateRequestService}
	     */
	    this.$templateRequest = $templateRequest;
	
	    /**
	     * @private @const
	     * @type {!IInjectorService}
	     */
	    this.$injector = $injector;
	
	    /**
	     * @private @const
	     * @type{!ICompileService}
	     */
	    this.$compile = $compile;
	
	    /**
	     * @private @const
	     * @type {!IControllerService}
	     */
	    this.$controller = $controller;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $mdCompiler#compile
	   * @description
	   *
	   * A method to compile a HTML template with the AngularJS compiler.
	   * The `$mdCompiler` is wrapper around the AngularJS compiler and provides extra functionality
	   * like controller instantiation or async resolves.
	   *
	   * @param {!Object} options An options object, with the following properties:
	   *
	   *    - `controller` - `{string|function}` Controller fn that should be associated with
	   *         newly created scope or the name of a registered controller if passed as a string.
	   *    - `controllerAs` - `{string=}` A controller alias name. If present the controller will be
	   *         published to scope under the `controllerAs` name.
	   *    - `contentElement` - `{string|Element}`: Instead of using a template, which will be
	   *         compiled each time, you can also use a DOM element.<br/>
	   *    - `template` - `{string=}` An html template as a string.
	   *    - `templateUrl` - `{string=}` A path to an html template.
	   *    - `transformTemplate` - `{function(template)=}` A function which transforms the template after
	   *        it is loaded. It will be given the template string as a parameter, and should
	   *        return a a new string representing the transformed template.
	   *    - `resolve` - `{Object.<string, function>=}` - An optional map of dependencies which should
	   *        be injected into the controller. If any of these dependencies are promises, the compiler
	   *        will wait for them all to be resolved, or if one is rejected before the controller is
	   *        instantiated `compile()` will fail..
	   *      * `key` - `{string}`: a name of a dependency to be injected into the controller.
	   *      * `factory` - `{string|function}`: If `string` then it is an alias for a service.
	   *        Otherwise if function, then it is injected and the return value is treated as the
	   *        dependency. If the result is a promise, it is resolved before its value is
	   *        injected into the controller.
	   *
	   * @returns {Q.Promise<{element: JQLite, link: Function, locals: Object, cleanup: any,
	   *  controller: Object=}>} promise A promise, which will be resolved with a `compileData` object.
	   *  `compileData` has the following properties:
	   *
	   *   - `element` - `{JQLite}`: an uncompiled element matching the provided template.
	   *   - `link` - `{function(scope)}`: A link function, which, when called, will compile
	   *     the element and instantiate the provided controller (if given).
	   *   - `locals` - `{Object}`: The locals which will be passed into the controller once `link` is
	   *     called. If `bindToController` is true, they will be copied to the ctrl instead
	   */
	  MdCompilerService.prototype.compile = function(options) {
	    if (options.contentElement) {
	      return this._prepareContentElement(options);
	    } else {
	      return this._compileTemplate(options);
	    }
	  };
	
	  /**
	   * Instead of compiling any template, the compiler just fetches an existing HTML element from the
	   * DOM and provides a restore function to put the element back it old DOM position.
	   * @param {!Object} options Options to be used for the compiler.
	   * @returns {Q.Promise<{element: JQLite, link: Function, locals: Object, cleanup: any}>}
	   */
	  MdCompilerService.prototype._prepareContentElement = function(options) {
	
	    var contentElement = this._fetchContentElement(options);
	
	    return this.$q.resolve({
	      element: contentElement.element,
	      cleanup: contentElement.restore,
	      locals: {},
	      link: function() {
	        return contentElement.element;
	      }
	    });
	
	  };
	
	  /**
	   * Compiles a template by considering all options and waiting for all resolves to be ready.
	   * @param {!Object} options Compile options
	   * @returns {!Q.Promise<{element: JQLite, link: Function, locals: Object, cleanup: any}>} Compile
	   *  data with link function.
	   */
	  MdCompilerService.prototype._compileTemplate = function(options) {
	
	    var self = this;
	    var templateUrl = options.templateUrl;
	    var template = options.template || '';
	    var resolve = angular.extend({}, options.resolve);
	    var locals = angular.extend({}, options.locals);
	    var transformTemplate = options.transformTemplate || angular.identity;
	
	    // Take resolve values and invoke them.
	    // Resolves can either be a string (value: 'MyRegisteredAngularConst'),
	    // or an invokable 'factory' of sorts: (value: function ValueGetter($dependency) {})
	    angular.forEach(resolve, function(value, key) {
	      if (angular.isString(value)) {
	        resolve[key] = self.$injector.get(value);
	      } else {
	        resolve[key] = self.$injector.invoke(value);
	      }
	    });
	
	    // Add the locals, which are just straight values to inject
	    // eg locals: { three: 3 }, will inject three into the controller
	    angular.extend(resolve, locals);
	
	    if (templateUrl) {
	      resolve.$$ngTemplate = this.$templateRequest(templateUrl);
	    } else {
	      resolve.$$ngTemplate = this.$q.when(template);
	    }
	
	
	    // Wait for all the resolves to finish if they are promises
	    return this.$q.all(resolve).then(function(locals) {
	
	      var template = transformTemplate(locals.$$ngTemplate, options);
	      var element = options.element || angular.element('<div>').html(template.trim()).contents();
	
	      return self._compileElement(locals, element, options);
	    });
	
	  };
	
	  /**
	   * Method to compile an element with the given options.
	   * @param {!Object} locals Locals to be injected to the controller if present
	   * @param {!JQLite} element Element to be compiled and linked
	   * @param {!Object} options Options to be used for linking.
	   * @returns {!{element: JQLite, link: Function, locals: Object, cleanup: any, controller: Object}} Compile data with link function.
	   */
	  MdCompilerService.prototype._compileElement = function(locals, element, options) {
	    var self = this;
	    var ngLinkFn = this.$compile(element);
	
	    var compileData = {
	      element: element,
	      cleanup: element.remove.bind(element),
	      locals: locals,
	      link: linkFn
	    };
	
	    function linkFn(scope) {
	      locals.$scope = scope;
	
	      // Instantiate controller if the developer provided one.
	      if (options.controller) {
	
	        var injectLocals = angular.extend({}, locals, {
	          $element: element
	        });
	
	        // Create the specified controller instance.
	        var ctrl = self._createController(options, injectLocals, locals);
	
	        // Registering extra $destroy listeners should be avoided.
	        // Only register the listener if the controller implements a $onDestroy hook.
	        if (angular.isFunction(ctrl.$onDestroy)) {
	          scope.$on('$destroy', function() {
	            // Call the $onDestroy hook if it's present on the controller.
	            angular.isFunction(ctrl.$onDestroy) && ctrl.$onDestroy();
	          });
	        }
	
	        // Unique identifier for AngularJS Route ngView controllers.
	        element.data('$ngControllerController', ctrl);
	        element.children().data('$ngControllerController', ctrl);
	
	        // Expose the instantiated controller to the compile data
	        compileData.controller = ctrl;
	      }
	
	      // Invoke the AngularJS $compile link function.
	      return ngLinkFn(scope);
	    }
	
	    return compileData;
	
	  };
	
	  /**
	   * Creates and instantiates a new controller with the specified options.
	   * @param {!Object} options Options that include the controller function or string.
	   * @param {!Object} injectLocals Locals to to be provided in the controller DI.
	   * @param {!Object} locals Locals to be injected to the controller.
	   * @returns {!Object} Created controller instance.
	   */
	  MdCompilerService.prototype._createController = function(options, injectLocals, locals) {
	    var ctrl = this.$controller(options.controller, injectLocals);
	
	    if (options.bindToController) {
	      angular.extend(ctrl, locals);
	    }
	
	    if (options.controllerAs) {
	      injectLocals.$scope[options.controllerAs] = ctrl;
	    }
	
	    // Call the $onInit hook if it's present on the controller.
	    angular.isFunction(ctrl.$onInit) && ctrl.$onInit();
	
	    return ctrl;
	  };
	
	  /**
	   * Fetches an element removing it from the DOM and using it temporary for the compiler.
	   * Elements which were fetched will be restored after use.
	   * @param {!Object} options Options to be used for the compilation.
	   * @returns {{element: !JQLite, restore: !function}}
	   */
	  MdCompilerService.prototype._fetchContentElement = function(options) {
	    var contentEl = options.contentElement;
	    var restoreFn;
	
	    if (angular.isString(contentEl)) {
	      contentEl = document.querySelector(contentEl);
	      restoreFn = createRestoreFn(contentEl);
	    } else {
	      contentEl = contentEl[0] || contentEl;
	
	      // When the element is visible in the DOM, then we restore it at close of the dialog.
	      // Otherwise it will be removed from the DOM after close.
	      if (document.contains(contentEl)) {
	        restoreFn = createRestoreFn(contentEl);
	      } else {
	        restoreFn = function() {
	          if (contentEl.parentNode) {
	            contentEl.parentNode.removeChild(contentEl);
	          }
	        };
	      }
	    }
	
	    return {
	      element: angular.element(contentEl),
	      restore: restoreFn
	    };
	
	    function createRestoreFn(element) {
	      var parent = element.parentNode;
	      var nextSibling = element.nextElementSibling;
	
	      return function() {
	        if (!nextSibling) {
	          // When the element didn't had any sibling, then it can be simply appended to the
	          // parent, because it plays no role, which index it had before.
	          parent.appendChild(element);
	        } else {
	          // When the element had a sibling, which marks the previous position of the element
	          // in the DOM, we insert it correctly before the sibling, to have the same index as
	          // before.
	          parent.insertBefore(element, nextSibling);
	        }
	      };
	    }
	  };
	}
	
	
	})();
	(function(){
	"use strict";
	
	
	MdGesture.$inject = ["$$MdGestureHandler", "$$rAF", "$timeout", "$mdUtil"];
	attachToDocument.$inject = ["$mdGesture", "$$MdGestureHandler", "$mdUtil"];var HANDLERS = {};
	
	/**
	 * The state of the current 'pointer'. The pointer represents the state of the current touch.
	 * It contains normalized x and y coordinates from DOM events,
	 * as well as other information abstracted from the DOM.
	 */
	var pointer, lastPointer, maxClickDistance = 6;
	var forceSkipClickHijack = false, disableAllGestures = false;
	
	/**
	 * The position of the most recent click if that click was on a label element.
	 * @type {{x: number, y: number}|null}
	 */
	var lastLabelClickPos = null;
	
	/**
	 * Used to attach event listeners once when multiple ng-apps are running.
	 * @type {boolean}
	 */
	var isInitialized = false;
	
	/**
	 * @ngdoc module
	 * @name material.core.gestures
	 * @description
	 * AngularJS Material Gesture handling for touch devices.
	 * This module replaced the usage of the HammerJS library.
	 */
	angular
	  .module('material.core.gestures', [])
	  .provider('$mdGesture', MdGestureProvider)
	  .factory('$$MdGestureHandler', MdGestureHandler)
	  .run(attachToDocument);
	
	/**
	 * @ngdoc service
	 * @name $mdGestureProvider
	 * @module material.core.gestures
	 *
	 * @description
	 * In some scenarios on mobile devices (without jQuery), the click events should NOT be hijacked.
	 * `$mdGestureProvider` is used to configure the Gesture module to ignore or skip click hijacking
	 * on mobile devices.
	 *
	 * You can also change the max click distance, `6px` by default, if you have issues on some touch
	 * screens.
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdGestureProvider) {
	 *
	 *     // For mobile devices without jQuery loaded, do not
	 *     // intercept click events during the capture phase.
	 *     $mdGestureProvider.skipClickHijack();
	 *
	 *     // If hijacking clicks, you may want to change the default click distance
	 *     $mdGestureProvider.setMaxClickDistance(12);
	 *   });
	 * </hljs>
	 *
	 */
	function MdGestureProvider() { }
	
	MdGestureProvider.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name $mdGestureProvider#disableAll
	   *
	   * @description
	   * Disable all gesture detection. This can be beneficial to application performance
	   * and memory usage.
	   */
	  disableAll: function () {
	    disableAllGestures = true;
	  },
	
	  // Publish access to setter to configure a variable BEFORE the
	  // $mdGesture service is instantiated...
	  /**
	   * @ngdoc method
	   * @name $mdGestureProvider#skipClickHijack
	   *
	   * @description
	   * Tell the AngularJS Material Gesture module to skip (or ignore) click hijacking on mobile devices.
	   */
	  skipClickHijack: function() {
	    return forceSkipClickHijack = true;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $mdGestureProvider#setMaxClickDistance
	   * @param clickDistance {string} Distance in pixels. I.e. `12px`.
	   * @description
	   * Set the max distance from the origin of the touch event to trigger touch handlers.
	   */
	  setMaxClickDistance: function(clickDistance) {
	    maxClickDistance = parseInt(clickDistance);
	  },
	
	  /**
	   * $get is used to build an instance of $mdGesture
	   * @ngInject
	   */
	  $get : ["$$MdGestureHandler", "$$rAF", "$timeout", "$mdUtil", function($$MdGestureHandler, $$rAF, $timeout, $mdUtil) {
	       return new MdGesture($$MdGestureHandler, $$rAF, $timeout, $mdUtil);
	  }]
	};
	
	
	
	/**
	 * MdGesture factory construction function
	 * @ngInject
	 */
	function MdGesture($$MdGestureHandler, $$rAF, $timeout, $mdUtil) {
	  var touchActionProperty = $mdUtil.getTouchAction();
	  var hasJQuery = (typeof window.jQuery !== 'undefined') && (angular.element === window.jQuery);
	
	  var self = {
	    handler: addHandler,
	    register: register,
	    isAndroid: $mdUtil.isAndroid,
	    isIos: $mdUtil.isIos,
	    // On mobile w/out jQuery, we normally intercept clicks. Should we skip that?
	    isHijackingClicks: ($mdUtil.isIos || $mdUtil.isAndroid) && !hasJQuery && !forceSkipClickHijack
	  };
	
	  if (self.isHijackingClicks) {
	    self.handler('click', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: checkDistanceAndEmit('click')
	    });
	
	    self.handler('focus', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: function(ev, pointer) {
	        if (pointer.distance < this.state.options.maxDistance && canFocus(ev.target)) {
	          this.dispatchEvent(ev, 'focus', pointer);
	          ev.target.focus();
	        }
	      }
	    });
	
	    self.handler('mouseup', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: checkDistanceAndEmit('mouseup')
	    });
	
	    self.handler('mousedown', {
	      onStart: function(ev) {
	        this.dispatchEvent(ev, 'mousedown');
	      }
	    });
	  }
	
	  function checkDistanceAndEmit(eventName) {
	    return function(ev, pointer) {
	      if (pointer.distance < this.state.options.maxDistance) {
	        this.dispatchEvent(ev, eventName, pointer);
	      }
	    };
	  }
	
	  /**
	   * Register an element to listen for a handler.
	   * This allows an element to override the default options for a handler.
	   * Additionally, some handlers like drag and hold only dispatch events if
	   * the domEvent happens inside an element that's registered to listen for these events.
	   *
	   * @see GestureHandler for how overriding of default options works.
	   * @example $mdGesture.register(myElement, 'drag', { minDistance: 20, horizontal: false })
	   */
	  function register(element, handlerName, options) {
	    var handler = HANDLERS[handlerName.replace(/^\$md./, '')];
	    if (!handler) {
	      throw new Error('Failed to register element with handler ' + handlerName + '. ' +
	      'Available handlers: ' + Object.keys(HANDLERS).join(', '));
	    }
	    return handler.registerElement(element, options);
	  }
	
	  /*
	   * add a handler to $mdGesture. see below.
	   */
	  function addHandler(name, definition) {
	    var handler = new $$MdGestureHandler(name);
	    angular.extend(handler, definition);
	    HANDLERS[name] = handler;
	
	    return self;
	  }
	
	  /**
	   * Register handlers. These listen to touch/start/move events, interpret them,
	   * and dispatch gesture events depending on options & conditions. These are all
	   * instances of GestureHandler.
	   * @see GestureHandler
	   */
	  return self
	    /*
	     * The press handler dispatches an event on touchdown/touchend.
	     * It's a simple abstraction of touch/mouse/pointer start and end.
	     */
	    .handler('press', {
	      onStart: function (ev, pointer) {
	        this.dispatchEvent(ev, '$md.pressdown');
	      },
	      onEnd: function (ev, pointer) {
	        this.dispatchEvent(ev, '$md.pressup');
	      }
	    })
	
	    /*
	     * The hold handler dispatches an event if the user keeps their finger within
	     * the same <maxDistance> area for <delay> ms.
	     * The hold handler will only run if a parent of the touch target is registered
	     * to listen for hold events through $mdGesture.register()
	     */
	    .handler('hold', {
	      options: {
	        maxDistance: 6,
	        delay: 500
	      },
	      onCancel: function () {
	        $timeout.cancel(this.state.timeout);
	      },
	      onStart: function (ev, pointer) {
	        // For hold, require a parent to be registered with $mdGesture.register()
	        // Because we prevent scroll events, this is necessary.
	        if (!this.state.registeredParent) return this.cancel();
	
	        this.state.pos = {x: pointer.x, y: pointer.y};
	        this.state.timeout = $timeout(angular.bind(this, function holdDelayFn() {
	          this.dispatchEvent(ev, '$md.hold');
	          this.cancel(); // we're done!
	        }), this.state.options.delay, false);
	      },
	      onMove: function (ev, pointer) {
	        // Don't scroll while waiting for hold.
	        // If we don't preventDefault touchmove events here, Android will assume we don't
	        // want to listen to anymore touch events. It will start scrolling and stop sending
	        // touchmove events.
	        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();
	
	        // If the user moves greater than <maxDistance> pixels, stop the hold timer
	        // set in onStart
	        var dx = this.state.pos.x - pointer.x;
	        var dy = this.state.pos.y - pointer.y;
	        if (Math.sqrt(dx * dx + dy * dy) > this.options.maxDistance) {
	          this.cancel();
	        }
	      },
	      onEnd: function () {
	        this.onCancel();
	      }
	    })
	
	    /*
	     * The drag handler dispatches a drag event if the user holds and moves his finger greater than
	     * <minDistance> px in the x or y direction, depending on options.horizontal.
	     * The drag will be cancelled if the user moves his finger greater than <minDistance>*<cancelMultiplier> in
	     * the perpendicular direction. Eg if the drag is horizontal and the user moves his finger <minDistance>*<cancelMultiplier>
	     * pixels vertically, this handler won't consider the move part of a drag.
	     */
	    .handler('drag', {
	      options: {
	        minDistance: 6,
	        horizontal: true,
	        cancelMultiplier: 1.5
	      },
	      /**
	       * @param {angular.JQLite} element where touch action styles need to be adjusted
	       * @param {{horizontal: boolean}=} options object whose horizontal property can specify to
	       *  apply 'pan-y' or 'pan-x' touch actions.
	       */
	      onSetup: function(element, options) {
	        if (touchActionProperty) {
	          // We check for horizontal to be false, because otherwise we would overwrite the default opts.
	          this.oldTouchAction = element[0].style[touchActionProperty];
	          element[0].style[touchActionProperty] = options.horizontal ? 'pan-y' : 'pan-x';
	        }
	      },
	      /**
	       * @param {angular.JQLite} element where styles need to be cleaned up
	       */
	      onCleanup: function(element) {
	        if (this.oldTouchAction) {
	          element[0].style[touchActionProperty] = this.oldTouchAction;
	        } else {
	          element[0].style[touchActionProperty] = null;
	        }
	      },
	      onStart: function (ev) {
	        // For drag, require a parent to be registered with $mdGesture.register()
	        if (!this.state.registeredParent) this.cancel();
	      },
	      onMove: function (ev, pointer) {
	        var shouldStartDrag, shouldCancel;
	        // Don't scroll while deciding if this touchmove qualifies as a drag event.
	        // If we don't preventDefault touchmove events here, Android will assume we don't
	        // want to listen to anymore touch events. It will start scrolling and stop sending
	        // touchmove events.
	        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();
	
	        if (!this.state.dragPointer) {
	          if (this.state.options.horizontal) {
	            shouldStartDrag = Math.abs(pointer.distanceX) > this.state.options.minDistance;
	            shouldCancel = Math.abs(pointer.distanceY) > this.state.options.minDistance * this.state.options.cancelMultiplier;
	          } else {
	            shouldStartDrag = Math.abs(pointer.distanceY) > this.state.options.minDistance;
	            shouldCancel = Math.abs(pointer.distanceX) > this.state.options.minDistance * this.state.options.cancelMultiplier;
	          }
	
	          if (shouldStartDrag) {
	            // Create a new pointer representing this drag, starting at this point where the drag started.
	            this.state.dragPointer = makeStartPointer(ev);
	            updatePointerState(ev, this.state.dragPointer);
	            this.dispatchEvent(ev, '$md.dragstart', this.state.dragPointer);
	
	          } else if (shouldCancel) {
	            this.cancel();
	          }
	        } else {
	          this.dispatchDragMove(ev);
	        }
	      },
	      // Only dispatch dragmove events every frame; any more is unnecessary
	      dispatchDragMove: $$rAF.throttle(function (ev) {
	        // Make sure the drag didn't stop while waiting for the next frame
	        if (this.state.isRunning) {
	          updatePointerState(ev, this.state.dragPointer);
	          this.dispatchEvent(ev, '$md.drag', this.state.dragPointer);
	        }
	      }),
	      onEnd: function (ev, pointer) {
	        if (this.state.dragPointer) {
	          updatePointerState(ev, this.state.dragPointer);
	          this.dispatchEvent(ev, '$md.dragend', this.state.dragPointer);
	        }
	      }
	    })
	
	    /*
	     * The swipe handler will dispatch a swipe event if, on the end of a touch,
	     * the velocity and distance were high enough.
	     */
	    .handler('swipe', {
	      options: {
	        minVelocity: 0.65,
	        minDistance: 10
	      },
	      onEnd: function (ev, pointer) {
	        var eventType;
	
	        if (Math.abs(pointer.velocityX) > this.state.options.minVelocity &&
	          Math.abs(pointer.distanceX) > this.state.options.minDistance) {
	          eventType = pointer.directionX == 'left' ? '$md.swipeleft' : '$md.swiperight';
	          this.dispatchEvent(ev, eventType);
	        }
	        else if (Math.abs(pointer.velocityY) > this.state.options.minVelocity &&
	          Math.abs(pointer.distanceY) > this.state.options.minDistance) {
	          eventType = pointer.directionY == 'up' ? '$md.swipeup' : '$md.swipedown';
	          this.dispatchEvent(ev, eventType);
	        }
	      }
	    });
	}
	
	/**
	 * MdGestureHandler
	 * A GestureHandler is an object which is able to dispatch custom dom events
	 * based on native dom {touch,pointer,mouse}{start,move,end} events.
	 *
	 * A gesture will manage its lifecycle through the start,move,end, and cancel
	 * functions, which are called by native dom events.
	 *
	 * A gesture has the concept of 'options' (eg. a swipe's required velocity), which can be
	 * overridden by elements registering through $mdGesture.register().
	 */
	function GestureHandler (name) {
	  this.name = name;
	  this.state = {};
	}
	
	function MdGestureHandler() {
	  var hasJQuery =  (typeof window.jQuery !== 'undefined') && (angular.element === window.jQuery);
	
	  GestureHandler.prototype = {
	    options: {},
	    // jQuery listeners don't work with custom DOMEvents, so we have to dispatch events
	    // differently when jQuery is loaded
	    dispatchEvent: hasJQuery ?  jQueryDispatchEvent : nativeDispatchEvent,
	
	    // These are overridden by the registered handler
	    onSetup: angular.noop,
	    onCleanup: angular.noop,
	    onStart: angular.noop,
	    onMove: angular.noop,
	    onEnd: angular.noop,
	    onCancel: angular.noop,
	
	    // onStart sets up a new state for the handler, which includes options from the
	    // nearest registered parent element of ev.target.
	    start: function (ev, pointer) {
	      if (this.state.isRunning) return;
	      var parentTarget = this.getNearestParent(ev.target);
	      // Get the options from the nearest registered parent
	      var parentTargetOptions = parentTarget && parentTarget.$mdGesture[this.name] || {};
	
	      this.state = {
	        isRunning: true,
	        // Override the default options with the nearest registered parent's options
	        options: angular.extend({}, this.options, parentTargetOptions),
	        // Pass in the registered parent node to the state so the onStart listener can use
	        registeredParent: parentTarget
	      };
	      this.onStart(ev, pointer);
	    },
	    move: function (ev, pointer) {
	      if (!this.state.isRunning) return;
	      this.onMove(ev, pointer);
	    },
	    end: function (ev, pointer) {
	      if (!this.state.isRunning) return;
	      this.state.isRunning = false;
	      this.onEnd(ev, pointer);
	    },
	    cancel: function (ev, pointer) {
	      this.onCancel(ev, pointer);
	      this.state = {};
	    },
	
	    // Find and return the nearest parent element that has been registered to
	    // listen for this handler via $mdGesture.register(element, 'handlerName').
	    getNearestParent: function (node) {
	      var current = node;
	      while (current) {
	        if ((current.$mdGesture || {})[this.name]) {
	          return current;
	        }
	        current = current.parentNode;
	      }
	      return null;
	    },
	
	    // Called from $mdGesture.register when an element registers itself with a handler.
	    // Store the options the user gave on the DOMElement itself. These options will
	    // be retrieved with getNearestParent when the handler starts.
	    registerElement: function (element, options) {
	      var self = this;
	      element[0].$mdGesture = element[0].$mdGesture || {};
	      element[0].$mdGesture[this.name] = options || {};
	      element.on('$destroy', onDestroy);
	
	      self.onSetup(element, options || {});
	
	      return onDestroy;
	
	      function onDestroy() {
	        delete element[0].$mdGesture[self.name];
	        element.off('$destroy', onDestroy);
	
	        self.onCleanup(element, options || {});
	      }
	    }
	  };
	
	  return GestureHandler;
	
	  /**
	   * Dispatch an event with jQuery
	   * TODO: Make sure this sends bubbling events
	   *
	   * @param srcEvent the original DOM touch event that started this.
	   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
	   * @param eventPointer the pointer object that matches this event.
	   */
	  function jQueryDispatchEvent(srcEvent, eventType, eventPointer) {
	    eventPointer = eventPointer || pointer;
	    var eventObj = new angular.element.Event(eventType);
	
	    eventObj.$material = true;
	    eventObj.pointer = eventPointer;
	    eventObj.srcEvent = srcEvent;
	
	    angular.extend(eventObj, {
	      clientX: eventPointer.x,
	      clientY: eventPointer.y,
	      screenX: eventPointer.x,
	      screenY: eventPointer.y,
	      pageX: eventPointer.x,
	      pageY: eventPointer.y,
	      ctrlKey: srcEvent.ctrlKey,
	      altKey: srcEvent.altKey,
	      shiftKey: srcEvent.shiftKey,
	      metaKey: srcEvent.metaKey
	    });
	    angular.element(eventPointer.target).trigger(eventObj);
	  }
	
	  /**
	   * NOTE: nativeDispatchEvent is very performance sensitive.
	   * @param srcEvent the original DOM touch event that started this.
	   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
	   * @param eventPointer the pointer object that matches this event.
	   */
	  function nativeDispatchEvent(srcEvent, eventType, eventPointer) {
	    eventPointer = eventPointer || pointer;
	    var eventObj;
	
	    if (eventType === 'click' || eventType === 'mouseup' || eventType === 'mousedown') {
	      if (typeof window.MouseEvent === "function") {
	        eventObj = new MouseEvent(eventType, {
	          bubbles: true,
	          cancelable: true,
	          screenX: Number(srcEvent.screenX),
	          screenY: Number(srcEvent.screenY),
	          clientX: Number(eventPointer.x),
	          clientY: Number(eventPointer.y),
	          ctrlKey: srcEvent.ctrlKey,
	          altKey: srcEvent.altKey,
	          shiftKey: srcEvent.shiftKey,
	          metaKey: srcEvent.metaKey,
	          button: srcEvent.button,
	          buttons: srcEvent.buttons,
	          relatedTarget: srcEvent.relatedTarget || null
	        });
	      } else {
	        eventObj = document.createEvent('MouseEvents');
	        // This has been deprecated
	        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/initMouseEvent
	        eventObj.initMouseEvent(
	          eventType, true, true, window, srcEvent.detail,
	          eventPointer.x, eventPointer.y, eventPointer.x, eventPointer.y,
	          srcEvent.ctrlKey, srcEvent.altKey, srcEvent.shiftKey, srcEvent.metaKey,
	          srcEvent.button, srcEvent.relatedTarget || null
	        );
	      }
	    } else {
	      if (typeof window.CustomEvent === "function") {
	        eventObj = new CustomEvent(eventType, {
	          bubbles: true,
	          cancelable: true,
	          detail: {}
	        });
	      } else {
	        // This has been deprecated
	        // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/initCustomEvent
	        eventObj = document.createEvent('CustomEvent');
	        eventObj.initCustomEvent(eventType, true, true, {});
	      }
	    }
	    eventObj.$material = true;
	    eventObj.pointer = eventPointer;
	    eventObj.srcEvent = srcEvent;
	    eventPointer.target.dispatchEvent(eventObj);
	  }
	}
	
	/**
	 * Attach Gestures: hook document and check shouldHijack clicks
	 * @ngInject
	 */
	function attachToDocument($mdGesture, $$MdGestureHandler, $mdUtil) {
	  if (disableAllGestures) {
	    return;
	  }
	
	  if (!isInitialized && $mdGesture.isHijackingClicks) {
	    /*
	     * If hijack clicks is true, we preventDefault any click that wasn't
	     * sent by AngularJS Material. This is because on older Android & iOS, a false, or 'ghost',
	     * click event will be sent ~400ms after a touchend event happens.
	     * The only way to know if this click is real is to prevent any normal
	     * click events, and add a flag to events sent by material so we know not to prevent those.
	     *
	     * Two exceptions to click events that should be prevented are:
	     *  - click events sent by the keyboard (eg form submit)
	     *  - events that originate from an Ionic app
	     */
	    document.addEventListener('click'    , clickHijacker     , true);
	    document.addEventListener('mouseup'  , mouseInputHijacker, true);
	    document.addEventListener('mousedown', mouseInputHijacker, true);
	    document.addEventListener('focus'    , mouseInputHijacker, true);
	
	    isInitialized = true;
	  }
	
	  function mouseInputHijacker(ev) {
	    var isKeyClick = !ev.clientX && !ev.clientY;
	
	    if (
	      !isKeyClick &&
	      !ev.$material &&
	      !ev.isIonicTap &&
	      !isInputEventFromLabelClick(ev) &&
	      (ev.type !== 'mousedown' || (!canFocus(ev.target) && !canFocus(document.activeElement)))
	    ) {
	      ev.preventDefault();
	      ev.stopPropagation();
	    }
	  }
	
	  /**
	   * Ignore click events that don't come from AngularJS Material, Ionic, Input Label clicks,
	   * or key presses that generate click events. This helps to ignore the ghost tap events on
	   * older mobile browsers that get sent after a 300-400ms delay.
	   * @param ev MouseEvent or modified MouseEvent with $material, pointer, and other fields
	   */
	  function clickHijacker(ev) {
	    var isKeyClick;
	    if ($mdUtil.isIos) {
	      isKeyClick = angular.isDefined(ev.webkitForce) && ev.webkitForce === 0;
	    } else {
	      isKeyClick = ev.clientX === 0 && ev.clientY === 0;
	    }
	    if (!isKeyClick && !ev.$material && !ev.isIonicTap && !isInputEventFromLabelClick(ev)) {
	      ev.preventDefault();
	      ev.stopPropagation();
	      lastLabelClickPos = null;
	    } else {
	      lastLabelClickPos = null;
	      if (ev.target.tagName.toLowerCase() === 'label') {
	        lastLabelClickPos = {x: ev.x, y: ev.y};
	      }
	    }
	  }
	
	
	  // Listen to all events to cover all platforms.
	  var START_EVENTS = 'mousedown touchstart pointerdown';
	  var MOVE_EVENTS = 'mousemove touchmove pointermove';
	  var END_EVENTS = 'mouseup mouseleave touchend touchcancel pointerup pointercancel';
	
	  angular.element(document)
	    .on(START_EVENTS, gestureStart)
	    .on(MOVE_EVENTS, gestureMove)
	    .on(END_EVENTS, gestureEnd)
	    // For testing
	    .on('$$mdGestureReset', function gestureClearCache () {
	      lastPointer = pointer = null;
	    });
	
	  /**
	   * When a DOM event happens, run all registered gesture handlers' lifecycle
	   * methods which match the DOM event.
	   * Eg. when a 'touchstart' event happens, runHandlers('start') will call and
	   * run `handler.cancel()` and `handler.start()` on all registered handlers.
	   */
	  function runHandlers(handlerEvent, event) {
	    var handler;
	    for (var name in HANDLERS) {
	      handler = HANDLERS[name];
	      if (handler instanceof $$MdGestureHandler) {
	
	        if (handlerEvent === 'start') {
	          // Run cancel to reset any handlers' state
	          handler.cancel();
	        }
	        handler[handlerEvent](event, pointer);
	      }
	    }
	  }
	
	  /*
	   * gestureStart vets if a start event is legitimate (and not part of a 'ghost click' from iOS/Android)
	   * If it is legitimate, we initiate the pointer state and mark the current pointer's type
	   * For example, for a touchstart event, mark the current pointer as a 'touch' pointer, so mouse events
	   * won't effect it.
	   */
	  function gestureStart(ev) {
	    // If we're already touched down, abort
	    if (pointer) return;
	
	    var now = +Date.now();
	
	    // iOS & old android bug: after a touch event, a click event is sent 350 ms later.
	    // If <400ms have passed, don't allow an event of a different type than the previous event
	    if (lastPointer && !typesMatch(ev, lastPointer) && (now - lastPointer.endTime < 1500)) {
	      return;
	    }
	
	    pointer = makeStartPointer(ev);
	
	    runHandlers('start', ev);
	  }
	
	  /**
	   * If a move event happens of the right type, update the pointer and run all the move handlers.
	   * "of the right type": if a mousemove happens but our pointer started with a touch event, do
	   * nothing.
	   */
	  function gestureMove(ev) {
	    if (!pointer || !typesMatch(ev, pointer)) return;
	
	    updatePointerState(ev, pointer);
	    runHandlers('move', ev);
	  }
	
	  /**
	   * If an end event happens of the right type, update the pointer, run endHandlers, and save the
	   * pointer as 'lastPointer'.
	   */
	  function gestureEnd(ev) {
	    if (!pointer || !typesMatch(ev, pointer)) return;
	
	    updatePointerState(ev, pointer);
	    pointer.endTime = +Date.now();
	
	    if (ev.type !== 'pointercancel') {
	      runHandlers('end', ev);
	    }
	
	    lastPointer = pointer;
	    pointer = null;
	  }
	
	}
	
	// ********************
	// Module Functions
	// ********************
	
	/*
	 * Initiate the pointer. x, y, and the pointer's type.
	 */
	function makeStartPointer(ev) {
	  var point = getEventPoint(ev);
	  var startPointer = {
	    startTime: +Date.now(),
	    target: ev.target,
	    // 'p' for pointer events, 'm' for mouse, 't' for touch
	    type: ev.type.charAt(0)
	  };
	  startPointer.startX = startPointer.x = point.pageX;
	  startPointer.startY = startPointer.y = point.pageY;
	  return startPointer;
	}
	
	/*
	 * return whether the pointer's type matches the event's type.
	 * Eg if a touch event happens but the pointer has a mouse type, return false.
	 */
	function typesMatch(ev, pointer) {
	  return ev && pointer && ev.type.charAt(0) === pointer.type;
	}
	
	/**
	 * Gets whether the given event is an input event that was caused by clicking on an
	 * associated label element.
	 *
	 * This is necessary because the browser will, upon clicking on a label element, fire an
	 * *extra* click event on its associated input (if any). mdGesture is able to flag the label
	 * click as with `$material` correctly, but not the second input click.
	 *
	 * In order to determine whether an input event is from a label click, we compare the (x, y) for
	 * the event to the (x, y) for the most recent label click (which is cleared whenever a non-label
	 * click occurs). Unfortunately, there are no event properties that tie the input and the label
	 * together (such as relatedTarget).
	 *
	 * @param {MouseEvent} event
	 * @returns {boolean}
	 */
	function isInputEventFromLabelClick(event) {
	  return lastLabelClickPos
	      && lastLabelClickPos.x === event.x
	      && lastLabelClickPos.y === event.y;
	}
	
	/*
	 * Update the given pointer based upon the given DOMEvent.
	 * Distance, velocity, direction, duration, etc
	 */
	function updatePointerState(ev, pointer) {
	  var point = getEventPoint(ev);
	  var x = pointer.x = point.pageX;
	  var y = pointer.y = point.pageY;
	
	  pointer.distanceX = x - pointer.startX;
	  pointer.distanceY = y - pointer.startY;
	  pointer.distance = Math.sqrt(
	    pointer.distanceX * pointer.distanceX + pointer.distanceY * pointer.distanceY
	  );
	
	  pointer.directionX = pointer.distanceX > 0 ? 'right' : pointer.distanceX < 0 ? 'left' : '';
	  pointer.directionY = pointer.distanceY > 0 ? 'down' : pointer.distanceY < 0 ? 'up' : '';
	
	  pointer.duration = +Date.now() - pointer.startTime;
	  pointer.velocityX = pointer.distanceX / pointer.duration;
	  pointer.velocityY = pointer.distanceY / pointer.duration;
	}
	
	/**
	 * Normalize the point where the DOM event happened whether it's touch or mouse.
	 * @returns point event obj with pageX and pageY on it.
	 */
	function getEventPoint(ev) {
	  ev = ev.originalEvent || ev; // support jQuery events
	  return (ev.touches && ev.touches[0]) ||
	    (ev.changedTouches && ev.changedTouches[0]) ||
	    ev;
	}
	
	/** Checks whether an element can be focused. */
	function canFocus(element) {
	  return (
	    !!element &&
	    element.getAttribute('tabindex') !== '-1' &&
	    !element.hasAttribute('disabled') &&
	    (
	      element.hasAttribute('tabindex') ||
	      element.hasAttribute('href') ||
	      element.isContentEditable ||
	      ['INPUT', 'SELECT', 'BUTTON', 'TEXTAREA', 'VIDEO', 'AUDIO'].indexOf(element.nodeName) !== -1
	    )
	  );
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.interaction
	 * @description
	 * User interaction detection to provide proper accessibility.
	 */
	MdInteractionService.$inject = ["$timeout", "$mdUtil", "$rootScope"];
	angular
	  .module('material.core.interaction', [])
	  .service('$mdInteraction', MdInteractionService);
	
	
	/**
	 * @ngdoc service
	 * @name $mdInteraction
	 * @module material.core.interaction
	 *
	 * @description
	 *
	 * Service which keeps track of the last interaction type and validates them for several browsers.
	 * The service hooks into the document's body and listens for touch, mouse and keyboard events.
	 *
	 * The most recent interaction type can be retrieved by calling the `getLastInteractionType` method.
	 *
	 * Here is an example markup for using the interaction service.
	 *
	 * <hljs lang="js">
	 *   var lastType = $mdInteraction.getLastInteractionType();
	 *
	 *   if (lastType === 'keyboard') {
	 *     // We only restore the focus for keyboard users.
	 *     restoreFocus();
	 *   }
	 * </hljs>
	 *
	 */
	function MdInteractionService($timeout, $mdUtil, $rootScope) {
	  this.$timeout = $timeout;
	  this.$mdUtil = $mdUtil;
	  this.$rootScope = $rootScope;
	
	  // IE browsers can also trigger pointer events, which also leads to an interaction.
	  this.pointerEvent = 'MSPointerEvent' in window ? 'MSPointerDown' : 'PointerEvent' in window ? 'pointerdown' : null;
	  this.bodyElement = angular.element(document.body);
	  this.isBuffering = false;
	  this.bufferTimeout = null;
	  this.lastInteractionType = null;
	  this.lastInteractionTime = null;
	  this.inputHandler = this.onInputEvent.bind(this);
	  this.bufferedInputHandler = this.onBufferInputEvent.bind(this);
	
	  // Type Mappings for the different events
	  // There will be three three interaction types
	  // `keyboard`, `mouse` and `touch`
	  // type `pointer` will be evaluated in `pointerMap` for IE Browser events
	  this.inputEventMap = {
	    'keydown': 'keyboard',
	    'mousedown': 'mouse',
	    'mouseenter': 'mouse',
	    'touchstart': 'touch',
	    'pointerdown': 'pointer',
	    'MSPointerDown': 'pointer'
	  };
	
	  // IE PointerDown events will be validated in `touch` or `mouse`
	  // Index numbers referenced here: https://msdn.microsoft.com/library/windows/apps/hh466130.aspx
	  this.iePointerMap = {
	    2: 'touch',
	    3: 'touch',
	    4: 'mouse'
	  };
	
	  this.initializeEvents();
	  this.$rootScope.$on('$destroy', this.deregister.bind(this));
	}
	
	/**
	 * Removes all event listeners created by $mdInteration on the
	 * body element.
	 */
	MdInteractionService.prototype.deregister = function() {
	
	    this.bodyElement.off('keydown mousedown', this.inputHandler);
	
	    if ('ontouchstart' in document.documentElement) {
	      this.bodyElement.off('touchstart', this.bufferedInputHandler);
	    }
	
	    if (this.pointerEvent) {
	      this.bodyElement.off(this.pointerEvent, this.inputHandler);
	    }
	
	};
	
	/**
	 * Initializes the interaction service, by registering all interaction events to the
	 * body element.
	 */
	MdInteractionService.prototype.initializeEvents = function() {
	
	  this.bodyElement.on('keydown mousedown', this.inputHandler);
	
	  if ('ontouchstart' in document.documentElement) {
	    this.bodyElement.on('touchstart', this.bufferedInputHandler);
	  }
	
	  if (this.pointerEvent) {
	    this.bodyElement.on(this.pointerEvent, this.inputHandler);
	  }
	
	};
	
	/**
	 * Event listener for normal interaction events, which should be tracked.
	 * @param event {MouseEvent|KeyboardEvent|PointerEvent|TouchEvent}
	 */
	MdInteractionService.prototype.onInputEvent = function(event) {
	  if (this.isBuffering) {
	    return;
	  }
	
	  var type = this.inputEventMap[event.type];
	
	  if (type === 'pointer') {
	    type = this.iePointerMap[event.pointerType] || event.pointerType;
	  }
	
	  this.lastInteractionType = type;
	  this.lastInteractionTime = this.$mdUtil.now();
	};
	
	/**
	 * Event listener for interaction events which should be buffered (touch events).
	 * @param event {TouchEvent}
	 */
	MdInteractionService.prototype.onBufferInputEvent = function(event) {
	  this.$timeout.cancel(this.bufferTimeout);
	
	  this.onInputEvent(event);
	  this.isBuffering = true;
	
	  // The timeout of 650ms is needed to delay the touchstart, because otherwise the touch will call
	  // the `onInput` function multiple times.
	  this.bufferTimeout = this.$timeout(function() {
	    this.isBuffering = false;
	  }.bind(this), 650, false);
	
	};
	
	/**
	 * @ngdoc method
	 * @name $mdInteraction#getLastInteractionType
	 * @description Retrieves the last interaction type triggered in body.
	 * @returns {string|null} Last interaction type.
	 */
	MdInteractionService.prototype.getLastInteractionType = function() {
	  return this.lastInteractionType;
	};
	
	/**
	 * @ngdoc method
	 * @name $mdInteraction#isUserInvoked
	 * @description Method to detect whether any interaction happened recently or not.
	 * @param {number=} checkDelay Time to check for any interaction to have been triggered.
	 * @returns {boolean} Whether there was any interaction or not.
	 */
	MdInteractionService.prototype.isUserInvoked = function(checkDelay) {
	  var delay = angular.isNumber(checkDelay) ? checkDelay : 15;
	
	  // Check for any interaction to be within the specified check time.
	  return this.lastInteractionTime >= this.$mdUtil.now() - delay;
	};
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core')
	  .provider('$$interimElement', InterimElementProvider);
	
	/**
	 * @ngdoc service
	 * @name $$interimElementProvider
	 * @module material.core.interimElement
	 *
	 * @description
	 *
	 * Factory that constructs `$$interimElement.$service` services.
	 * Used internally in material design for elements that appear on screen temporarily.
	 * The service provides a promise-like API for interacting with the temporary
	 * elements.
	 *
	 * <hljs lang="js">
	 *   app.service('$mdToast', function($$interimElement) {
	 *     var $mdToast = $$interimElement(toastDefaultOptions);
	 *     return $mdToast;
	 *   });
	 * </hljs>
	 *
	 * @param {object=} defaultOptions Options used by default for the `show` method on the service.
	 *
	 * @returns {$$interimElement.$service}
	 */
	
	function InterimElementProvider() {
	  InterimElementFactory.$inject = ["$document", "$q", "$rootScope", "$timeout", "$rootElement", "$animate", "$mdUtil", "$mdCompiler", "$mdTheming", "$injector", "$exceptionHandler"];
	  createInterimElementProvider.$get = InterimElementFactory;
	  return createInterimElementProvider;
	
	  /**
	   * Returns a new provider which allows configuration of a new interimElement
	   * service. Allows configuration of default options & methods for options,
	   * as well as configuration of 'preset' methods (eg dialog.basic(): basic is a preset method)
	   */
	  function createInterimElementProvider(interimFactoryName) {
	    factory.$inject = ["$$interimElement", "$injector"];
	    var EXPOSED_METHODS = ['onHide', 'onShow', 'onRemove'];
	
	    var customMethods = {};
	    var providerConfig = {
	      presets: {}
	    };
	
	    var provider = {
	      setDefaults: setDefaults,
	      addPreset: addPreset,
	      addMethod: addMethod,
	      $get: factory
	    };
	
	    /**
	     * all interim elements will come with the 'build' preset
	     */
	    provider.addPreset('build', {
	      methods: ['controller', 'controllerAs', 'resolve', 'multiple',
	        'template', 'templateUrl', 'themable', 'transformTemplate', 'parent', 'contentElement']
	    });
	
	    return provider;
	
	    /**
	     * Save the configured defaults to be used when the factory is instantiated
	     */
	    function setDefaults(definition) {
	      providerConfig.optionsFactory = definition.options;
	      providerConfig.methods = (definition.methods || []).concat(EXPOSED_METHODS);
	      return provider;
	    }
	
	    /**
	     * Add a method to the factory that isn't specific to any interim element operations
	     */
	    function addMethod(name, fn) {
	      customMethods[name] = fn;
	      return provider;
	    }
	
	    /**
	     * Save the configured preset to be used when the factory is instantiated
	     */
	    function addPreset(name, definition) {
	      definition = definition || {};
	      definition.methods = definition.methods || [];
	      definition.options = definition.options || function() { return {}; };
	
	      if (/^cancel|hide|show$/.test(name)) {
	        throw new Error("Preset '" + name + "' in " + interimFactoryName + " is reserved!");
	      }
	      if (definition.methods.indexOf('_options') > -1) {
	        throw new Error("Method '_options' in " + interimFactoryName + " is reserved!");
	      }
	      providerConfig.presets[name] = {
	        methods: definition.methods.concat(EXPOSED_METHODS),
	        optionsFactory: definition.options,
	        argOption: definition.argOption
	      };
	      return provider;
	    }
	
	    function addPresetMethod(presetName, methodName, method) {
	      providerConfig.presets[presetName][methodName] = method;
	    }
	
	    /**
	     * Create a factory that has the given methods & defaults implementing interimElement
	     */
	    /* @ngInject */
	    function factory($$interimElement, $injector) {
	      var defaultMethods;
	      var defaultOptions;
	      var interimElementService = $$interimElement();
	
	      /*
	       * publicService is what the developer will be using.
	       * It has methods hide(), cancel(), show(), build(), and any other
	       * presets which were set during the config phase.
	       */
	      var publicService = {
	        hide: interimElementService.hide,
	        cancel: interimElementService.cancel,
	        show: showInterimElement,
	
	        // Special internal method to destroy an interim element without animations
	        // used when navigation changes causes a $scope.$destroy() action
	        destroy : destroyInterimElement
	      };
	
	
	      defaultMethods = providerConfig.methods || [];
	      // This must be invoked after the publicService is initialized
	      defaultOptions = invokeFactory(providerConfig.optionsFactory, {});
	
	      // Copy over the simple custom methods
	      angular.forEach(customMethods, function(fn, name) {
	        publicService[name] = fn;
	      });
	
	      angular.forEach(providerConfig.presets, function(definition, name) {
	        var presetDefaults = invokeFactory(definition.optionsFactory, {});
	        var presetMethods = (definition.methods || []).concat(defaultMethods);
	
	        // Every interimElement built with a preset has a field called `$type`,
	        // which matches the name of the preset.
	        // Eg in preset 'confirm', options.$type === 'confirm'
	        angular.extend(presetDefaults, { $type: name });
	
	        // This creates a preset class which has setter methods for every
	        // method given in the `.addPreset()` function, as well as every
	        // method given in the `.setDefaults()` function.
	        //
	        // @example
	        // .setDefaults({
	        //   methods: ['hasBackdrop', 'clickOutsideToClose', 'escapeToClose', 'targetEvent'],
	        //   options: dialogDefaultOptions
	        // })
	        // .addPreset('alert', {
	        //   methods: ['title', 'ok'],
	        //   options: alertDialogOptions
	        // })
	        //
	        // Set values will be passed to the options when interimElement.show() is called.
	        function Preset(opts) {
	          this._options = angular.extend({}, presetDefaults, opts);
	        }
	        angular.forEach(presetMethods, function(name) {
	          Preset.prototype[name] = function(value) {
	            this._options[name] = value;
	            return this;
	          };
	        });
	
	        // Create shortcut method for one-linear methods
	        if (definition.argOption) {
	          var methodName = 'show' + name.charAt(0).toUpperCase() + name.slice(1);
	          publicService[methodName] = function(arg) {
	            var config = publicService[name](arg);
	            return publicService.show(config);
	          };
	        }
	
	        // eg $mdDialog.alert() will return a new alert preset
	        publicService[name] = function(arg) {
	          // If argOption is supplied, eg `argOption: 'content'`, then we assume
	          // if the argument is not an options object then it is the `argOption` option.
	          //
	          // @example `$mdToast.simple('hello')` // sets options.content to hello
	          //                                     // because argOption === 'content'
	          if (arguments.length && definition.argOption &&
	              !angular.isObject(arg) && !angular.isArray(arg))  {
	
	            return (new Preset())[definition.argOption](arg);
	
	          } else {
	            return new Preset(arg);
	          }
	
	        };
	      });
	
	      return publicService;
	
	      /**
	       *
	       */
	      function showInterimElement(opts) {
	        // opts is either a preset which stores its options on an _options field,
	        // or just an object made up of options
	        opts = opts || { };
	        if (opts._options) opts = opts._options;
	
	        return interimElementService.show(
	          angular.extend({}, defaultOptions, opts)
	        );
	      }
	
	      /**
	       *  Special method to hide and destroy an interimElement WITHOUT
	       *  any 'leave` or hide animations ( an immediate force hide/remove )
	       *
	       *  NOTE: This calls the onRemove() subclass method for each component...
	       *  which must have code to respond to `options.$destroy == true`
	       */
	      function destroyInterimElement(opts) {
	          return interimElementService.destroy(opts);
	      }
	
	      /**
	       * Helper to call $injector.invoke with a local of the factory name for
	       * this provider.
	       * If an $mdDialog is providing options for a dialog and tries to inject
	       * $mdDialog, a circular dependency error will happen.
	       * We get around that by manually injecting $mdDialog as a local.
	       */
	      function invokeFactory(factory, defaultVal) {
	        var locals = {};
	        locals[interimFactoryName] = publicService;
	        return $injector.invoke(factory || function() { return defaultVal; }, {}, locals);
	      }
	    }
	  }
	
	  /* @ngInject */
	  function InterimElementFactory($document, $q, $rootScope, $timeout, $rootElement, $animate,
	                                 $mdUtil, $mdCompiler, $mdTheming, $injector, $exceptionHandler) {
	    return function createInterimElementService() {
	      var SHOW_CANCELLED = false;
	
	      /**
	       * @ngdoc service
	       * @name $$interimElementProvider.$service
	       *
	       * @description
	       * A service used to control inserting and removing of an element from the DOM.
	       * It is used by $mdBottomSheet, $mdDialog, $mdToast, $mdMenu, $mdPanel, and $mdSelect.
	       */
	      var service;
	
	      var showPromises = []; // Promises for the interim's which are currently opening.
	      var hidePromises = []; // Promises for the interim's which are currently hiding.
	      var showingInterims = []; // Interim elements which are currently showing up.
	
	      // Publish instance $$interimElement service;
	      return service = {
	        show: show,
	        hide: waitForInterim(hide),
	        cancel: waitForInterim(cancel),
	        destroy : destroy,
	        $injector_: $injector
	      };
	
	      /**
	       * @ngdoc method
	       * @name $$interimElementProvider.$service#show
	       * @kind function
	       *
	       * @description
	       * Adds the `$interimElement` to the DOM and returns a special promise that will be resolved
	       * or rejected with hide or cancel, respectively.
	       *
	       * @param {Object} options map of options and values
	       * @returns {Promise} a Promise that will be resolved when hide() is called or rejected when
	       *  cancel() is called.
	       */
	      function show(options) {
	        options = options || {};
	        var interimElement = new InterimElement(options || {});
	
	        // When an interim element is currently showing, we have to cancel it.
	        // Just hiding it, will resolve the InterimElement's promise, the promise should be
	        // rejected instead.
	        var hideAction = options.multiple ? $q.resolve() : $q.all(showPromises);
	
	        if (!options.multiple) {
	          // Wait for all opening interim's to finish their transition.
	          hideAction = hideAction.then(function() {
	            // Wait for all closing and showing interim's to be completely closed.
	            var promiseArray = hidePromises.concat(showingInterims.map(service.cancel));
	            return $q.all(promiseArray);
	          });
	        }
	
	        var showAction = hideAction.then(function() {
	
	          return interimElement
	            .show()
	            .then(function () {
	              showingInterims.push(interimElement);
	            })
	            .catch(function (reason) {
	              return reason;
	            })
	            .finally(function() {
	              showPromises.splice(showPromises.indexOf(showAction), 1);
	            });
	
	        });
	
	        showPromises.push(showAction);
	
	        // In AngularJS 1.6+, exceptions inside promises will cause a rejection. We need to handle
	        // the rejection and only log it if it's an error.
	        interimElement.deferred.promise.catch(function(fault) {
	          if (fault instanceof Error) {
	            $exceptionHandler(fault);
	          }
	
	          return fault;
	        });
	
	        // Return a promise that will be resolved when the interim
	        // element is hidden or cancelled...
	        return interimElement.deferred.promise;
	      }
	
	      /**
	       * @ngdoc method
	       * @name $$interimElementProvider.$service#hide
	       * @kind function
	       *
	       * @description
	       * Removes the `$interimElement` from the DOM and resolves the Promise returned from `show()`.
	       *
	       * @param {*} reason Data used to resolve the Promise
	       * @param {object} options map of options and values
	       * @returns {Promise} a Promise that will be resolved after the element has been removed
	       *  from the DOM.
	       */
	      function hide(reason, options) {
	        options = options || {};
	
	        if (options.closeAll) {
	          // We have to make a shallow copy of the array, because otherwise the map will break.
	          return $q.all(showingInterims.slice().reverse().map(closeElement));
	        } else if (options.closeTo !== undefined) {
	          return $q.all(showingInterims.slice(options.closeTo).map(closeElement));
	        }
	
	        // Hide the latest showing interim element.
	        return closeElement(showingInterims[showingInterims.length - 1]);
	
	        /**
	         * @param {InterimElement} interim element to close
	         * @returns {Promise<InterimElement>}
	         */
	        function closeElement(interim) {
	          if (!interim) {
	            return $q.when(reason);
	          }
	
	          var hideAction = interim
	            .remove(reason, false, options || { })
	            .catch(function(reason) { return reason; })
	            .finally(function() {
	              hidePromises.splice(hidePromises.indexOf(hideAction), 1);
	            });
	
	          showingInterims.splice(showingInterims.indexOf(interim), 1);
	          hidePromises.push(hideAction);
	
	          return interim.deferred.promise;
	        }
	      }
	
	      /**
	       * @ngdoc method
	       * @name $$interimElementProvider.$service#cancel
	       * @kind function
	       *
	       * @description
	       * Removes the `$interimElement` from the DOM and rejects the Promise returned from `show()`.
	       *
	       * @param {*} reason Data used to resolve the Promise
	       * @param {object} options map of options and values
	       * @returns {Promise} Promise that will be resolved after the element has been removed
	       *  from the DOM.
	       */
	      function cancel(reason, options) {
	        var interim = showingInterims.pop();
	        if (!interim) {
	          return $q.when(reason);
	        }
	
	        var cancelAction = interim
	          .remove(reason, true, options || {})
	          .catch(function(reason) { return reason; })
	          .finally(function() {
	            hidePromises.splice(hidePromises.indexOf(cancelAction), 1);
	          });
	
	        hidePromises.push(cancelAction);
	
	        // Since AngularJS 1.6.7, promises will be logged to $exceptionHandler when the promise
	        // is not handling the rejection. We create a pseudo catch handler, which will prevent the
	        // promise from being logged to the $exceptionHandler.
	        return interim.deferred.promise.catch(angular.noop);
	      }
	
	      /**
	       * Creates a function to wait for at least one interim element to be available.
	       * @param callbackFn Function to be used as callback
	       * @returns {Function}
	       */
	      function waitForInterim(callbackFn) {
	        return function() {
	          var fnArguments = arguments;
	
	          if (!showingInterims.length) {
	            // When there are still interim's opening, then wait for the first interim element to
	            // finish its open animation.
	            if (showPromises.length) {
	              return showPromises[0].finally(function () {
	                return callbackFn.apply(service, fnArguments);
	              });
	            }
	
	            return $q.when("No interim elements currently showing up.");
	          }
	
	          return callbackFn.apply(service, fnArguments);
	        };
	      }
	
	      /**
	       * @ngdoc method
	       * @name $$interimElementProvider.$service#destroy
	       * @kind function
	       *
	       * Special method to quick-remove the interim element without running animations. This is
	       * useful when the parent component has been or is being destroyed.
	       *
	       * Note: interim elements are in "interim containers".
	       */
	      function destroy(targetEl) {
	        var interim = !targetEl ? showingInterims.shift() : null;
	
	        var parentEl = angular.element(targetEl).length && angular.element(targetEl)[0].parentNode;
	
	        if (parentEl) {
	          // Try to find the interim in the stack which corresponds to the supplied DOM element.
	          var filtered = showingInterims.filter(function(entry) {
	            return entry.options.element[0] === parentEl;
	          });
	
	          // Note: This function might be called when the element already has been removed,
	          // in which case we won't find any matches.
	          if (filtered.length) {
	            interim = filtered[0];
	            showingInterims.splice(showingInterims.indexOf(interim), 1);
	          }
	        }
	
	        return interim ? interim.remove(SHOW_CANCELLED, false, { '$destroy': true }) :
	                         $q.when(SHOW_CANCELLED);
	      }
	
	      /*
	       * Internal Interim Element Object
	       * Used internally to manage the DOM element and related data
	       */
	      function InterimElement(options) {
	        var self, element, showAction = $q.when(true);
	
	        options = configureScopeAndTransitions(options);
	
	        return self = {
	          options : options,
	          deferred: $q.defer(),
	          show    : createAndTransitionIn,
	          remove  : transitionOutAndRemove
	        };
	
	        /**
	         * Compile, link, and show this interim element. Use optional autoHide and transition-in
	         * effects.
	         * @return {Q.Promise}
	         */
	        function createAndTransitionIn() {
	          return $q(function(resolve, reject) {
	
	            // Trigger onCompiling callback before the compilation starts.
	            // This is useful, when modifying options, which can be influenced by developers.
	            options.onCompiling && options.onCompiling(options);
	
	            compileElement(options)
	              .then(function(compiledData) {
	                element = linkElement(compiledData, options);
	
	                // Expose the cleanup function from the compiler.
	                options.cleanupElement = compiledData.cleanup;
	
	                showAction = showElement(element, options, compiledData.controller)
	                  .then(resolve, rejectAll);
	              }).catch(rejectAll);
	
	            function rejectAll(fault) {
	              // Force the '$md<xxx>.show()' promise to reject
	              self.deferred.reject(fault);
	
	              // Continue rejection propagation
	              reject(fault);
	            }
	          });
	        }
	
	        /**
	         * After the show process has finished/rejected:
	         * - announce 'removing',
	         * - perform the transition-out, and
	         * - perform optional clean up scope.
	         */
	        function transitionOutAndRemove(response, isCancelled, opts) {
	
	          // abort if the show() and compile failed
	          if (!element) return $q.when(false);
	
	          options = angular.extend(options || {}, opts || {});
	          options.cancelAutoHide && options.cancelAutoHide();
	          options.element.triggerHandler('$mdInterimElementRemove');
	
	          if (options.$destroy === true) {
	
	            return hideElement(options.element, options).then(function(){
	              (isCancelled && rejectAll(response)) || resolveAll(response);
	            });
	
	          } else {
	            $q.when(showAction).finally(function() {
	              hideElement(options.element, options).then(function() {
	                isCancelled ? rejectAll(response) : resolveAll(response);
	              }, rejectAll);
	            });
	
	            return self.deferred.promise;
	          }
	
	
	          /**
	           * The `show()` returns a promise that will be resolved when the interim
	           * element is hidden or cancelled...
	           */
	          function resolveAll(response) {
	            self.deferred.resolve(response);
	          }
	
	          /**
	           * Force the '$md<xxx>.show()' promise to reject
	           */
	          function rejectAll(fault) {
	            self.deferred.reject(fault);
	          }
	        }
	
	        /**
	         * Prepare optional isolated scope and prepare $animate with default enter and leave
	         * transitions for the new element instance.
	         */
	        function configureScopeAndTransitions(options) {
	          options = options || { };
	          if (options.template) {
	            options.template = $mdUtil.processTemplate(options.template);
	          }
	
	          return angular.extend({
	            preserveScope: false,
	            cancelAutoHide : angular.noop,
	            scope: options.scope || $rootScope.$new(options.isolateScope),
	
	            /**
	             * Default usage to enable $animate to transition-in; can be easily overridden via 'options'
	             */
	            onShow: function transitionIn(scope, element, options) {
	              return $animate.enter(element, options.parent);
	            },
	
	            /**
	             * Default usage to enable $animate to transition-out; can be easily overridden via 'options'
	             */
	            onRemove: function transitionOut(scope, element) {
	              // Element could be undefined if a new element is shown before
	              // the old one finishes compiling.
	              return element && $animate.leave(element) || $q.when();
	            }
	          }, options);
	
	        }
	
	        /**
	         * Compile an element with a templateUrl, controller, and locals
	         * @param {Object} options
	         * @return {Q.Promise<{element: JQLite=, link: Function, locals: Object, cleanup: any=,
	         *  controller: Object=}>}
	         */
	        function compileElement(options) {
	
	          var compiled = !options.skipCompile ? $mdCompiler.compile(options) : null;
	
	          return compiled || $q(function (resolve) {
	              resolve({
	                locals: {},
	                link: function () {
	                  return options.element;
	                }
	              });
	            });
	        }
	
	        /**
	         * Link an element with compiled configuration
	         * @param {{element: JQLite=, link: Function, locals: Object, controller: Object=}} compileData
	         * @param {Object} options
	         * @return {JQLite}
	         */
	        function linkElement(compileData, options) {
	          angular.extend(compileData.locals, options);
	
	          var element = compileData.link(options.scope);
	
	          // Search for parent at insertion time, if not specified
	          options.element = element;
	          options.parent = findParent(element, options);
	          if (options.themable) $mdTheming(element);
	
	          return element;
	        }
	
	        /**
	         * Search for parent at insertion time, if not specified.
	         * @param {JQLite} element
	         * @param {Object} options
	         * @return {JQLite}
	         */
	        function findParent(element, options) {
	          var parent = options.parent;
	
	          // Search for parent at insertion time, if not specified
	          if (angular.isFunction(parent)) {
	            parent = parent(options.scope, element, options);
	          } else if (angular.isString(parent)) {
	            parent = angular.element($document[0].querySelector(parent));
	          } else {
	            parent = angular.element(parent);
	          }
	
	          // If parent querySelector/getter function fails, or it's just null,
	          // find a default.
	          if (!(parent || {}).length) {
	            var el;
	            if ($rootElement[0] && $rootElement[0].querySelector) {
	              el = $rootElement[0].querySelector(':not(svg) > body');
	            }
	            if (!el) el = $rootElement[0];
	            if (el.nodeName === '#comment') {
	              el = $document[0].body;
	            }
	            return angular.element(el);
	          }
	
	          return parent;
	        }
	
	        /**
	         * If auto-hide is enabled, start timer and prepare cancel function
	         */
	        function startAutoHide() {
	          var autoHideTimer, cancelAutoHide = angular.noop;
	
	          if (options.hideDelay) {
	            autoHideTimer = $timeout(service.hide, options.hideDelay) ;
	            cancelAutoHide = function() {
	              $timeout.cancel(autoHideTimer);
	            };
	          }
	
	          // Cache for subsequent use
	          options.cancelAutoHide = function() {
	            cancelAutoHide();
	            options.cancelAutoHide = undefined;
	          };
	        }
	
	        /**
	         * Show the element (with transitions), notify complete and start optional auto hiding
	         * timer.
	         * @param {JQLite} element
	         * @param {Object} options
	         * @param {Object} controller
	         * @return {Q.Promise<JQLite>}
	         */
	        function showElement(element, options, controller) {
	          // Trigger onShowing callback before the `show()` starts
	          var notifyShowing = options.onShowing || angular.noop;
	          // Trigger onComplete callback when the `show()` finishes
	          var notifyComplete = options.onComplete || angular.noop;
	
	          // Necessary for consistency between AngularJS 1.5 and 1.6.
	          try {
	            // This fourth controller parameter is used by $mdDialog in beforeShow().
	            notifyShowing(options.scope, element, options, controller);
	          } catch (e) {
	            return $q.reject(e);
	          }
	
	          return $q(function (resolve, reject) {
	            try {
	              // Start transitionIn
	              $q.when(options.onShow(options.scope, element, options))
	                .then(function () {
	                  notifyComplete(options.scope, element, options);
	                  startAutoHide();
	
	                  resolve(element);
	                }, reject);
	
	            } catch (e) {
	              reject(e.message);
	            }
	          });
	        }
	
	        function hideElement(element, options) {
	          var announceRemoving = options.onRemoving || angular.noop;
	
	          return $q(function (resolve, reject) {
	            try {
	              // Start transitionIn
	              var action = $q.when(options.onRemove(options.scope, element, options) || true);
	
	              // Trigger callback *before* the remove operation starts
	              announceRemoving(element, action);
	
	              if (options.$destroy) {
	                // For $destroy, onRemove should be synchronous
	                resolve(element);
	
	                if (!options.preserveScope && options.scope) {
	                  // scope destroy should still be be done after the current digest is done
	                  action.then(function() { options.scope.$destroy(); });
	                }
	              } else {
	                // Wait until transition-out is done
	                action.then(function () {
	                  if (!options.preserveScope && options.scope) {
	                    options.scope.$destroy();
	                  }
	
	                  resolve(element);
	                }, reject);
	              }
	            } catch (e) {
	              reject(e.message);
	            }
	          });
	        }
	
	      }
	    };
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  var $mdUtil, $interpolate, $log;
	
	  var SUFFIXES = /(-gt)?-(sm|md|lg|print)/g;
	  var WHITESPACE = /\s+/g;
	
	  var FLEX_OPTIONS = ['grow', 'initial', 'auto', 'none', 'noshrink', 'nogrow'];
	  var LAYOUT_OPTIONS = ['row', 'column'];
	  var ALIGNMENT_MAIN_AXIS= ["", "start", "center", "end", "stretch", "space-around", "space-between"];
	  var ALIGNMENT_CROSS_AXIS= ["", "start", "center", "end", "stretch"];
	
	  var config = {
	    /**
	     * Enable directive attribute-to-class conversions
	     * Developers can use `<body md-layout-css />` to quickly
	     * disable the Layout directives and prohibit the injection of Layout classNames
	     */
	    enabled: true,
	
	    /**
	     * List of mediaQuery breakpoints and associated suffixes
	     *   [
	     *    { suffix: "sm", mediaQuery: "screen and (max-width: 599px)" },
	     *    { suffix: "md", mediaQuery: "screen and (min-width: 600px) and (max-width: 959px)" }
	     *   ]
	     */
	    breakpoints: []
	  };
	
	  registerLayoutAPI(angular.module('material.core.layout', ['ng']));
	
	  /**
	   *   registerLayoutAPI()
	   *
	   *   The original AngularJS Material Layout solution used attribute selectors and CSS.
	   *
	   *  ```html
	   *  <div layout="column"> My Content </div>
	   *  ```
	   *
	   *  ```css
	   *  [layout] {
	   *    box-sizing: border-box;
	   *    display:flex;
	   *  }
	   *  [layout=column] {
	   *    flex-direction : column
	   *  }
	   *  ```
	   *
	   *  Use of attribute selectors creates significant performance impacts in some
	   *  browsers... mainly IE.
	   *
	   *  This module registers directives that allow the same layout attributes to be
	   *  interpreted and converted to class selectors. The directive will add equivalent classes to
	   *  each element that contains a Layout directive.
	   *
	   * ```html
	   *   <div layout="column" class="layout layout-column"> My Content </div>
	   * ```
	   *
	   *  ```css
	   *  .layout {
	   *    box-sizing: border-box;
	   *    display:flex;
	   *  }
	   *  .layout-column {
	   *    flex-direction : column
	   *  }
	   *  ```
	   */
	  function registerLayoutAPI(module){
	    var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	    var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;
	
	    // NOTE: these are also defined in constants::MEDIA_PRIORITY and constants::MEDIA
	    var BREAKPOINTS     = ["", "xs", "gt-xs", "sm", "gt-sm", "md", "gt-md", "lg", "gt-lg", "xl", "print"];
	    var API_WITH_VALUES = ["layout", "flex", "flex-order", "flex-offset", "layout-align"];
	    var API_NO_VALUES   = ["show", "hide", "layout-padding", "layout-margin"];
	
	
	    // Build directive registration functions for the standard Layout API... for all breakpoints.
	    angular.forEach(BREAKPOINTS, function(mqb) {
	
	      // Attribute directives with expected, observable value(s)
	      angular.forEach(API_WITH_VALUES, function(name){
	        var fullName = mqb ? name + "-" + mqb : name;
	        module.directive(directiveNormalize(fullName), attributeWithObserve(fullName));
	      });
	
	      // Attribute directives with no expected value(s)
	      angular.forEach(API_NO_VALUES, function(name){
	        var fullName = mqb ? name + "-" + mqb : name;
	        module.directive(directiveNormalize(fullName), attributeWithoutValue(fullName));
	      });
	
	    });
	
	    // Register other, special directive functions for the Layout features:
	    module
	      .provider('$$mdLayout', function() {
	        // Publish internal service for Layouts
	        return {
	          $get : angular.noop,
	          validateAttributeValue : validateAttributeValue,
	          validateAttributeUsage : validateAttributeUsage,
	          /**
	           * Easy way to disable/enable the Layout API.
	           * When disabled, this stops all attribute-to-classname generations
	           */
	          disableLayouts  : function(isDisabled) {
	            config.enabled =  (isDisabled !== true);
	          }
	        };
	      })
	
	      .directive('mdLayoutCss'        , disableLayoutDirective)
	      .directive('ngCloak'            , buildCloakInterceptor('ng-cloak'))
	
	      .directive('layoutWrap'   , attributeWithoutValue('layout-wrap'))
	      .directive('layoutNowrap' , attributeWithoutValue('layout-nowrap'))
	      .directive('layoutNoWrap' , attributeWithoutValue('layout-no-wrap'))
	      .directive('layoutFill'   , attributeWithoutValue('layout-fill'))
	
	      // Determine if
	      .config(detectDisabledLayouts);
	
	    /**
	     * Converts snake_case to camelCase.
	     * Also there is special case for Moz prefix starting with upper case letter.
	     * @param name Name to normalize
	     */
	    function directiveNormalize(name) {
	      return name
	        .replace(PREFIX_REGEXP, '')
	        .replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	          return offset ? letter.toUpperCase() : letter;
	        });
	    }
	  }
	
	
	  /**
	    * Detect if any of the HTML tags has a [md-layouts-disabled] attribute;
	    * If yes, then immediately disable all layout API features
	    *
	    * Note: this attribute should be specified on either the HTML or BODY tags
	    * @ngInject
	    */
	   function detectDisabledLayouts() {
	     var isDisabled = !!document.querySelector('[md-layouts-disabled]');
	     config.enabled = !isDisabled;
	   }
	
	  /**
	   * Special directive that will disable ALL Layout conversions of layout
	   * attribute(s) to classname(s).
	   *
	   * <link rel="stylesheet" href="angular-material.min.css">
	   * <link rel="stylesheet" href="angular-material.layout.css">
	   *
	   * <body md-layout-css>
	   *  ...
	   * </body>
	   *
	   * Note: Using md-layout-css directive requires the developer to load the Material
	   * Layout Attribute stylesheet (which only uses attribute selectors):
	   *
	   *       `angular-material.layout.css`
	   *
	   * Another option is to use the LayoutProvider to configure and disable the attribute
	   * conversions; this would obviate the use of the `md-layout-css` directive
	   */
	  function disableLayoutDirective() {
	    // Return a 1x-only, first-match attribute directive
	    config.enabled = false;
	
	    return {
	      restrict : 'A',
	      priority : '900'
	    };
	  }
	
	  /**
	   * Tail-hook ngCloak to delay the uncloaking while Layout transformers
	   * finish processing. Eliminates flicker with Material.Layouts
	   */
	  function buildCloakInterceptor(className) {
	    return ['$timeout', function($timeout){
	      return {
	        restrict : 'A',
	        priority : -10,   // run after normal ng-cloak
	        compile  : function(element) {
	          if (!config.enabled) return angular.noop;
	
	          // Re-add the cloak
	          element.addClass(className);
	
	          return function(scope, element) {
	            // Wait while layout injectors configure, then uncloak
	            // NOTE: $rAF does not delay enough... and this is a 1x-only event,
	            //       $timeout is acceptable.
	            $timeout(function(){
	              element.removeClass(className);
	            }, 10, false);
	          };
	        }
	      };
	    }];
	  }
	
	
	  // *********************************************************************************
	  //
	  // These functions create registration functions for AngularJS Material Layout attribute
	  // directives. This provides easy translation to switch AngularJS Material attribute selectors to
	  // CLASS selectors and directives; which has huge performance implications for IE Browsers.
	  //
	  // *********************************************************************************
	
	  /**
	   * Creates a directive registration function where a possible dynamic attribute
	   * value will be observed/watched.
	   * @param {string} className attribute name; eg `layout-gt-md` with value ="row"
	   */
	  function attributeWithObserve(className) {
	
	    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
	      $mdUtil = _$mdUtil_;
	      $interpolate = _$interpolate_;
	      $log = _$log_;
	
	      return {
	        restrict: 'A',
	        compile: function(element, attr) {
	          var linkFn;
	          if (config.enabled) {
	            // immediately replace static (non-interpolated) invalid values...
	
	            validateAttributeUsage(className, attr, element, $log);
	
	            validateAttributeValue(className,
	              getNormalizedAttrValue(className, attr, ""),
	              buildUpdateFn(element, className, attr)
	            );
	
	            linkFn = translateWithValueToCssClass;
	          }
	
	          // Use for postLink to account for transforms after ng-transclude.
	          return linkFn || angular.noop;
	        }
	      };
	    }];
	
	    /**
	     * Observe deprecated layout attributes and update the element's layout classes to match.
	     */
	    function translateWithValueToCssClass(scope, element, attrs) {
	      var updateFn = updateClassWithValue(element, className, attrs);
	      var unwatch = attrs.$observe(attrs.$normalize(className), updateFn);
	
	      updateFn(getNormalizedAttrValue(className, attrs, ""));
	      scope.$on("$destroy", function() { unwatch(); });
	    }
	  }
	
	  /**
	   * Creates a registration function for AngularJS Material Layout attribute directive.
	   * This is a `simple` transpose of attribute usage to class usage; where we ignore
	   * any attribute value.
	   */
	  function attributeWithoutValue(className) {
	    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
	      $mdUtil = _$mdUtil_;
	      $interpolate = _$interpolate_;
	      $log = _$log_;
	
	      return {
	        restrict: 'A',
	        compile: function(element, attr) {
	          var linkFn;
	          if (config.enabled) {
	            // immediately replace static (non-interpolated) invalid values...
	
	            validateAttributeValue(className,
	              getNormalizedAttrValue(className, attr, ""),
	              buildUpdateFn(element, className, attr)
	            );
	
	            translateToCssClass(null, element);
	
	            // Use for postLink to account for transforms after ng-transclude.
	            linkFn = translateToCssClass;
	          }
	
	          return linkFn || angular.noop;
	        }
	      };
	    }];
	
	    /**
	     * Add transformed class selector.
	     */
	    function translateToCssClass(scope, element) {
	      element.addClass(className);
	    }
	  }
	
	  /**
	   * After link-phase, do NOT remove deprecated layout attribute selector.
	   * Instead watch the attribute so interpolated data-bindings to layout
	   * selectors will continue to be supported.
	   *
	   * $observe() the className and update with new class (after removing the last one)
	   *
	   * e.g. `layout="{{layoutDemo.direction}}"` will update...
	   *
	   * NOTE: The value must match one of the specified styles in the CSS.
	   * For example `flex-gt-md="{{size}}`  where `scope.size == 47` will NOT work since
	   * only breakpoints for 0, 5, 10, 15... 100, 33, 34, 66, 67 are defined.
	   */
	  function updateClassWithValue(element, className) {
	    var lastClass;
	
	    return function updateClassFn(newValue) {
	      var value = validateAttributeValue(className, newValue || "");
	      if (angular.isDefined(value)) {
	        if (lastClass) element.removeClass(lastClass);
	        lastClass = !value ? className : className + "-" + value.trim().replace(WHITESPACE, "-");
	        element.addClass(lastClass);
	      }
	    };
	  }
	
	  /**
	   * Centralize warnings for known flexbox issues (especially IE-related issues)
	   */
	  function validateAttributeUsage(className, attr, element, $log){
	    var message, usage, url;
	    var nodeName = element[0].nodeName.toLowerCase();
	
	    switch (className.replace(SUFFIXES,"")) {
	      case "flex":
	        if ((nodeName === "md-button") || (nodeName === "fieldset")){
	          // @see https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers
	          // Use <div flex> wrapper inside (preferred) or outside
	
	          usage = "<" + nodeName + " " + className + "></" + nodeName + ">";
	          url = "https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers";
	          message = "Markup '{0}' may not work as expected in IE Browsers. Consult '{1}' for details.";
	
	          $log.warn($mdUtil.supplant(message, [usage, url]));
	        }
	    }
	  }
	
	
	  /**
	   * For the Layout attribute value, validate or replace with default fallback value.
	   */
	  function validateAttributeValue(className, value, updateFn) {
	    var origValue = value;
	
	    if (!needsInterpolation(value)) {
	      switch (className.replace(SUFFIXES,"")) {
	        case 'layout'        :
	          if (!findIn(value, LAYOUT_OPTIONS)) {
	            value = LAYOUT_OPTIONS[0];    // 'row';
	          }
	          break;
	
	        case 'flex'          :
	          if (!findIn(value, FLEX_OPTIONS)) {
	            if (isNaN(value)) {
	              value = '';
	            }
	          }
	          break;
	
	        case 'flex-offset' :
	        case 'flex-order'    :
	          if (!value || isNaN(+value)) {
	            value = '0';
	          }
	          break;
	
	        case 'layout-align'  :
	          var axis = extractAlignAxis(value);
	          value = $mdUtil.supplant("{main}-{cross}",axis);
	          break;
	
	        case 'layout-padding' :
	        case 'layout-margin'  :
	        case 'layout-fill'    :
	        case 'layout-wrap'    :
	        case 'layout-nowrap' :
	          value = '';
	          break;
	      }
	
	      if (value !== origValue) {
	        (updateFn || angular.noop)(value);
	      }
	    }
	
	    return value ? value.trim() : "";
	  }
	
	  /**
	   * Replace current attribute value with fallback value
	   */
	  function buildUpdateFn(element, className, attrs) {
	    return function updateAttrValue(fallback) {
	      if (!needsInterpolation(fallback)) {
	        // Do not modify the element's attribute value; so
	        // uses '<ui-layout layout="/api/sidebar.html" />' will not
	        // be affected. Just update the attrs value.
	        attrs[attrs.$normalize(className)] = fallback;
	      }
	    };
	  }
	
	  /**
	   * See if the original value has interpolation symbols:
	   * e.g.  flex-gt-md="{{triggerPoint}}"
	   */
	  function needsInterpolation(value) {
	    return (value || "").indexOf($interpolate.startSymbol()) > -1;
	  }
	
	  function getNormalizedAttrValue(className, attrs, defaultVal) {
	    var normalizedAttr = attrs.$normalize(className);
	    return attrs[normalizedAttr] ? attrs[normalizedAttr].trim().replace(WHITESPACE, "-") :
	      defaultVal || null;
	  }
	
	  function findIn(item, list, replaceWith) {
	    item = replaceWith && item ? item.replace(WHITESPACE, replaceWith) : item;
	
	    var found = false;
	    if (item) {
	      list.forEach(function(it) {
	        it = replaceWith ? it.replace(WHITESPACE, replaceWith) : it;
	        found = found || (it === item);
	      });
	    }
	    return found;
	  }
	
	  function extractAlignAxis(attrValue) {
	    var axis = {
	      main : "start",
	      cross: "stretch"
	    }, values;
	
	    attrValue = (attrValue || "");
	
	    if (attrValue.indexOf("-") === 0 || attrValue.indexOf(" ") === 0) {
	      // For missing main-axis values
	      attrValue = "none" + attrValue;
	    }
	
	    values = attrValue.toLowerCase().trim().replace(WHITESPACE, "-").split("-");
	    if (values.length && (values[0] === "space")) {
	      // for main-axis values of "space-around" or "space-between"
	      values = [values[0]+"-"+values[1],values[2]];
	    }
	
	    if (values.length > 0) axis.main  = values[0] || axis.main;
	    if (values.length > 1) axis.cross = values[1] || axis.cross;
	
	    if (ALIGNMENT_MAIN_AXIS.indexOf(axis.main) < 0)   axis.main = "start";
	    if (ALIGNMENT_CROSS_AXIS.indexOf(axis.cross) < 0) axis.cross = "stretch";
	
	    return axis;
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.liveannouncer
	 * @description
	 * AngularJS Material Live Announcer to provide accessibility for Voice Readers.
	 */
	MdLiveAnnouncer.$inject = ["$timeout"];
	angular
	  .module('material.core')
	  .service('$mdLiveAnnouncer', MdLiveAnnouncer);
	
	/**
	 * @ngdoc service
	 * @name $mdLiveAnnouncer
	 * @module material.core.liveannouncer
	 *
	 * @description
	 *
	 * Service to announce messages to supported screenreaders.
	 *
	 * > The `$mdLiveAnnouncer` service is internally used for components to provide proper accessibility.
	 *
	 * <hljs lang="js">
	 *   module.controller('AppCtrl', function($mdLiveAnnouncer) {
	 *     // Basic announcement (Polite Mode)
	 *     $mdLiveAnnouncer.announce('Hey Google');
	 *
	 *     // Custom announcement (Assertive Mode)
	 *     $mdLiveAnnouncer.announce('Hey Google', 'assertive');
	 *   });
	 * </hljs>
	 *
	 */
	function MdLiveAnnouncer($timeout) {
	  /** @private @const @type {!angular.$timeout} */
	  this._$timeout = $timeout;
	
	  /** @private @const @type {!HTMLElement} */
	  this._liveElement = this._createLiveElement();
	
	  /** @private @const @type {!number} */
	  this._announceTimeout = 100;
	}
	
	/**
	 * @ngdoc method
	 * @name $mdLiveAnnouncer#announce
	 * @description Announces messages to supported screenreaders.
	 * @param {string} message Message to be announced to the screenreader
	 * @param {'off'|'polite'|'assertive'} politeness The politeness of the announcer element.
	 */
	MdLiveAnnouncer.prototype.announce = function(message, politeness) {
	  if (!politeness) {
	    politeness = 'polite';
	  }
	
	  var self = this;
	
	  self._liveElement.textContent = '';
	  self._liveElement.setAttribute('aria-live', politeness);
	
	  // This 100ms timeout is necessary for some browser + screen-reader combinations:
	  // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
	  // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
	  //   second time without clearing and then using a non-zero delay.
	  // (using JAWS 17 at time of this writing).
	  self._$timeout(function() {
	    self._liveElement.textContent = message;
	  }, self._announceTimeout, false);
	};
	
	/**
	 * Creates a live announcer element, which listens for DOM changes and announces them
	 * to the screenreaders.
	 * @returns {!HTMLElement}
	 * @private
	 */
	MdLiveAnnouncer.prototype._createLiveElement = function() {
	  var liveEl = document.createElement('div');
	
	  liveEl.classList.add('md-visually-hidden');
	  liveEl.setAttribute('role', 'status');
	  liveEl.setAttribute('aria-atomic', 'true');
	  liveEl.setAttribute('aria-live', 'polite');
	
	  document.body.appendChild(liveEl);
	
	  return liveEl;
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc service
	 * @name $$mdMeta
	 * @module material.core.meta
	 *
	 * @description
	 *
	 * A provider and a service that simplifies meta tags access
	 *
	 * Note: This is intended only for use with dynamic meta tags such as browser color and title.
	 * Tags that are only processed when the page is rendered (such as `charset`, and `http-equiv`)
	 * will not work since `$$mdMeta` adds the tags after the page has already been loaded.
	 *
	 * ```js
	 * app.config(function($$mdMetaProvider) {
	 *   var removeMeta = $$mdMetaProvider.setMeta('meta-name', 'content');
	 *   var metaValue  = $$mdMetaProvider.getMeta('meta-name'); // -> 'content'
	 *
	 *   removeMeta();
	 * });
	 *
	 * app.controller('myController', function($$mdMeta) {
	 *   var removeMeta = $$mdMeta.setMeta('meta-name', 'content');
	 *   var metaValue  = $$mdMeta.getMeta('meta-name'); // -> 'content'
	 *
	 *   removeMeta();
	 * });
	 * ```
	 *
	 * @returns {$$mdMeta.$service}
	 *
	 */
	angular.module('material.core.meta', [])
	  .provider('$$mdMeta', function () {
	    var head = angular.element(document.head);
	    var metaElements = {};
	
	    /**
	     * Checks if the requested element was written manually and maps it
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @returns {boolean} returns true if there is an element with the requested name
	     */
	    function mapExistingElement(name) {
	      if (metaElements[name]) {
	        return true;
	      }
	
	      var element = document.getElementsByName(name)[0];
	
	      if (!element) {
	        return false;
	      }
	
	      metaElements[name] = angular.element(element);
	
	      return true;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $$mdMeta#setMeta
	     *
	     * @description
	     * Creates meta element with the 'name' and 'content' attributes,
	     * if the meta tag is already created than we replace the 'content' value
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @param {string} content meta tag 'content' attribute value
	     * @returns {function} remove function
	     *
	     */
	    function setMeta(name, content) {
	      mapExistingElement(name);
	
	      if (!metaElements[name]) {
	        var newMeta = angular.element('<meta name="' + name + '" content="' + content + '"/>');
	        head.append(newMeta);
	        metaElements[name] = newMeta;
	      }
	      else {
	        metaElements[name].attr('content', content);
	      }
	
	      return function () {
	        metaElements[name].attr('content', '');
	        metaElements[name].remove();
	        delete metaElements[name];
	      };
	    }
	
	    /**
	     * @ngdoc method
	     * @name $$mdMeta#getMeta
	     *
	     * @description
	     * Gets the 'content' attribute value of the wanted meta element
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @returns {string} content attribute value
	     */
	    function getMeta(name) {
	      if (!mapExistingElement(name)) {
	        throw Error('$$mdMeta: could not find a meta tag with the name \'' + name + '\'');
	      }
	
	      return metaElements[name].attr('content');
	    }
	
	    var module = {
	      setMeta: setMeta,
	      getMeta: getMeta
	    };
	
	    return angular.extend({}, module, {
	      $get: function () {
	        return module;
	      }
	    });
	  });
	})();
	(function(){
	"use strict";
	
	  /**
	   * @ngdoc module
	   * @name material.core.componentRegistry
	   *
	   * @description
	   * A component instance registration service.
	   * Note: currently this as a private service in the SideNav component.
	   */
	  ComponentRegistry.$inject = ["$log", "$q"];
	  angular.module('material.core')
	    .factory('$mdComponentRegistry', ComponentRegistry);
	
	  /*
	   * @private
	   * @ngdoc factory
	   * @name ComponentRegistry
	   * @module material.core.componentRegistry
	   *
	   */
	  function ComponentRegistry($log, $q) {
	
	    var self;
	    var instances = [];
	    var pendings = { };
	
	    return self = {
	      /**
	       * Used to print an error when an instance for a handle isn't found.
	       */
	      notFoundError: function(handle, msgContext) {
	        $log.error((msgContext || "") + 'No instance found for handle', handle);
	      },
	      /**
	       * Return all registered instances as an array.
	       */
	      getInstances: function() {
	        return instances;
	      },
	
	      /**
	       * Get a registered instance.
	       * @param handle the String handle to look up for a registered instance.
	       */
	      get: function(handle) {
	        if (!isValidID(handle)) return null;
	
	        var i, j, instance;
	        for (i = 0, j = instances.length; i < j; i++) {
	          instance = instances[i];
	          if (instance.$$mdHandle === handle) {
	            return instance;
	          }
	        }
	        return null;
	      },
	
	      /**
	       * Register an instance.
	       * @param instance the instance to register
	       * @param handle the handle to identify the instance under.
	       */
	      register: function(instance, handle) {
	        if (!handle) return angular.noop;
	
	        instance.$$mdHandle = handle;
	        instances.push(instance);
	        resolveWhen();
	
	        return deregister;
	
	        /**
	         * Remove registration for an instance
	         */
	        function deregister() {
	          var index = instances.indexOf(instance);
	          if (index !== -1) {
	            instances.splice(index, 1);
	          }
	        }
	
	        /**
	         * Resolve any pending promises for this instance
	         */
	        function resolveWhen() {
	          var dfd = pendings[handle];
	          if (dfd) {
	            dfd.forEach(function (promise) {
	              promise.resolve(instance);
	            });
	            delete pendings[handle];
	          }
	        }
	      },
	
	      /**
	       * Async accessor to registered component instance
	       * If not available then a promise is created to notify
	       * all listeners when the instance is registered.
	       */
	      when : function(handle) {
	        if (isValidID(handle)) {
	          var deferred = $q.defer();
	          var instance = self.get(handle);
	
	          if (instance)  {
	            deferred.resolve(instance);
	          } else {
	            if (pendings[handle] === undefined) {
	              pendings[handle] = [];
	            }
	            pendings[handle].push(deferred);
	          }
	
	          return deferred.promise;
	        }
	        return $q.reject("Invalid `md-component-id` value.");
	      }
	
	    };
	
	    function isValidID(handle){
	      return handle && (handle !== "");
	    }
	
	  }
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdButtonInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-button.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the default ripple configuration
	   */
	
	  MdButtonInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdButtonInkRipple', MdButtonInkRipple);
	
	  function MdButtonInkRipple($mdInkRipple) {
	    return {
	      attach: function attachRipple(scope, element, options) {
	        options = angular.extend(optionsForElement(element), options);
	
	        return $mdInkRipple.attach(scope, element, options);
	      }
	    };
	
	    function optionsForElement(element) {
	      if (element.hasClass('md-icon-button')) {
	        return {
	          isMenuItem: element.hasClass('md-menu-item'),
	          fitRipple: true,
	          center: true
	        };
	      } else {
	        return {
	          isMenuItem: element.hasClass('md-menu-item'),
	          dimBackground: true
	        };
	      }
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	    /**
	   * @ngdoc service
	   * @name $mdCheckboxInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-checkbox.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdCheckboxInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdCheckboxInkRipple', MdCheckboxInkRipple);
	
	  function MdCheckboxInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: true,
	        dimBackground: false,
	        fitRipple: true
	      }, options));
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdListInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-list.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdListInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdListInkRipple', MdListInkRipple);
	
	  function MdListInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: false,
	        dimBackground: true,
	        outline: false,
	        rippleSize: 'full'
	      }, options));
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.ripple
	 * @description
	 * Ripple
	 */
	InkRippleCtrl.$inject = ["$scope", "$element", "rippleOptions", "$window", "$timeout", "$mdUtil", "$mdColorUtil"];
	InkRippleDirective.$inject = ["$mdButtonInkRipple", "$mdCheckboxInkRipple"];
	angular.module('material.core')
	    .provider('$mdInkRipple', InkRippleProvider)
	    .directive('mdInkRipple', InkRippleDirective)
	    .directive('mdNoInk', attrNoDirective)
	    .directive('mdNoBar', attrNoDirective)
	    .directive('mdNoStretch', attrNoDirective);
	
	var DURATION = 450;
	
	/**
	 * @ngdoc directive
	 * @name mdInkRipple
	 * @module material.core.ripple
	 *
	 * @description
	 * The `md-ink-ripple` directive allows you to specify the ripple color or if a ripple is allowed.
	 *
	 * @param {string|boolean} md-ink-ripple A color string `#FF0000` or boolean (`false` or `0`) for
	 *  preventing ripple
	 *
	 * @usage
	 * ### String values
	 * <hljs lang="html">
	 *   <ANY md-ink-ripple="#FF0000">
	 *     Ripples in red
	 *   </ANY>
	 *
	 *   <ANY md-ink-ripple="false">
	 *     Not rippling
	 *   </ANY>
	 * </hljs>
	 *
	 * ### Interpolated values
	 * <hljs lang="html">
	 *   <ANY md-ink-ripple="{{ randomColor() }}">
	 *     Ripples with the return value of 'randomColor' function
	 *   </ANY>
	 *
	 *   <ANY md-ink-ripple="{{ canRipple() }}">
	 *     Ripples if 'canRipple' function return value is not 'false' or '0'
	 *   </ANY>
	 * </hljs>
	 */
	function InkRippleDirective ($mdButtonInkRipple, $mdCheckboxInkRipple) {
	  return {
	    controller: angular.noop,
	    link:       function (scope, element, attr) {
	      attr.hasOwnProperty('mdInkRippleCheckbox')
	          ? $mdCheckboxInkRipple.attach(scope, element)
	          : $mdButtonInkRipple.attach(scope, element);
	    }
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $mdInkRipple
	 * @module material.core.ripple
	 *
	 * @description
	 * `$mdInkRipple` is a service for adding ripples to any element.
	 *
	 * @usage
	 * <hljs lang="js">
	 * app.factory('$myElementInkRipple', function($mdInkRipple) {
	 *   return {
	 *     attach: function (scope, element, options) {
	 *       return $mdInkRipple.attach(scope, element, angular.extend({
	 *         center: false,
	 *         dimBackground: true
	 *       }, options));
	 *     }
	 *   };
	 * });
	 *
	 * app.controller('myController', function ($scope, $element, $myElementInkRipple) {
	 *   $scope.onClick = function (ev) {
	 *     $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true });
	 *   }
	 * });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc service
	 * @name $mdInkRippleProvider
	 * @module material.core.ripple
	 *
	 * @description
	  * If you want to disable ink ripples globally, for all components, you can call the
	 * `disableInkRipple` method in your app's config.
	 *
	 *
	 * @usage
	 * <hljs lang="js">
	 * app.config(function ($mdInkRippleProvider) {
	 *   $mdInkRippleProvider.disableInkRipple();
	 * });
	 * </hljs>
	 */
	
	function InkRippleProvider () {
	  var isDisabledGlobally = false;
	
	  return {
	    disableInkRipple: disableInkRipple,
	    $get: ["$injector", function($injector) {
	      return { attach: attach };
	
	      /**
	       * @ngdoc method
	       * @name $mdInkRipple#attach
	       *
	       * @description
	       * Attaching given scope, element and options to inkRipple controller
	       *
	       * @param {object=} scope Scope within the current context
	       * @param {object=} element The element the ripple effect should be applied to
	       * @param {object=} options (Optional) Configuration options to override the defaultRipple configuration
	       * * `center` -  Whether the ripple should start from the center of the container element
	       * * `dimBackground` - Whether the background should be dimmed with the ripple color
	       * * `colorElement` - The element the ripple should take its color from, defined by css property `color`
	       * * `fitRipple` - Whether the ripple should fill the element
	       */
	      function attach (scope, element, options) {
	        if (isDisabledGlobally || element.controller('mdNoInk')) return angular.noop;
	        return $injector.instantiate(InkRippleCtrl, {
	          $scope:        scope,
	          $element:      element,
	          rippleOptions: options
	        });
	      }
	    }]
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdInkRippleProvider#disableInkRipple
	   *
	   * @description
	   * A config-time method that, when called, disables ripples globally.
	   */
	  function disableInkRipple () {
	    isDisabledGlobally = true;
	  }
	}
	
	/**
	 * Controller used by the ripple service in order to apply ripples
	 * @ngInject
	 */
	function InkRippleCtrl ($scope, $element, rippleOptions, $window, $timeout, $mdUtil, $mdColorUtil) {
	  this.$window    = $window;
	  this.$timeout   = $timeout;
	  this.$mdUtil    = $mdUtil;
	  this.$mdColorUtil    = $mdColorUtil;
	  this.$scope     = $scope;
	  this.$element   = $element;
	  this.options    = rippleOptions;
	  this.mousedown  = false;
	  this.ripples    = [];
	  this.timeout    = null; // Stores a reference to the most-recent ripple timeout
	  this.lastRipple = null;
	
	  $mdUtil.valueOnUse(this, 'container', this.createContainer);
	
	  this.$element.addClass('md-ink-ripple');
	
	  // attach method for unit tests
	  ($element.controller('mdInkRipple') || {}).createRipple = angular.bind(this, this.createRipple);
	  ($element.controller('mdInkRipple') || {}).setColor = angular.bind(this, this.color);
	
	  this.bindEvents();
	}
	
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
	 * mouseup or mouseleave event)
	 */
	function autoCleanup (self, cleanupFn) {
	  if (self.mousedown || self.lastRipple) {
	    self.mousedown = false;
	    self.$mdUtil.nextTick(angular.bind(self, cleanupFn), false);
	  }
	}
	
	
	/**
	 * Returns the color that the ripple should be (either based on CSS or hard-coded)
	 * @returns {string}
	 */
	InkRippleCtrl.prototype.color = function (value) {
	  var self = this;
	
	  // If assigning a color value, apply it to background and the ripple color
	  if (angular.isDefined(value)) {
	    self._color = self._parseColor(value);
	  }
	
	  // If color lookup, use assigned, defined, or inherited
	  return self._color || self._parseColor(self.inkRipple()) || self._parseColor(getElementColor());
	
	  /**
	   * Finds the color element and returns its text color for use as default ripple color
	   * @returns {string}
	   */
	  function getElementColor () {
	    var items = self.options && self.options.colorElement ? self.options.colorElement : [];
	    var elem =  items.length ? items[ 0 ] : self.$element[ 0 ];
	
	    return elem ? self.$window.getComputedStyle(elem).color : 'rgb(0,0,0)';
	  }
	};
	
	/**
	 * Updating the ripple colors based on the current inkRipple value
	 * or the element's computed style color
	 */
	InkRippleCtrl.prototype.calculateColor = function () {
	  return this.color();
	};
	
	
	/**
	 * Takes a string color and converts it to RGBA format
	 * @param {string} color
	 * @param {number} multiplier
	 * @returns {string}
	 */
	InkRippleCtrl.prototype._parseColor = function parseColor (color, multiplier) {
	  multiplier = multiplier || 1;
	  var colorUtil = this.$mdColorUtil;
	
	  if (!color) return;
	  if (color.indexOf('rgba') === 0) return color.replace(/\d?\.?\d*\s*\)\s*$/, (0.1 * multiplier).toString() + ')');
	  if (color.indexOf('rgb') === 0) return colorUtil.rgbToRgba(color);
	  if (color.indexOf('#') === 0) return colorUtil.hexToRgba(color);
	
	};
	
	/**
	 * Binds events to the root element for
	 */
	InkRippleCtrl.prototype.bindEvents = function () {
	  this.$element.on('mousedown', angular.bind(this, this.handleMousedown));
	  this.$element.on('mouseup touchend', angular.bind(this, this.handleMouseup));
	  this.$element.on('mouseleave', angular.bind(this, this.handleMouseup));
	  this.$element.on('touchmove', angular.bind(this, this.handleTouchmove));
	};
	
	/**
	 * Create a new ripple on every mousedown event from the root element
	 * @param event {MouseEvent}
	 */
	InkRippleCtrl.prototype.handleMousedown = function (event) {
	  if (this.mousedown) return;
	
	  // When jQuery is loaded, we have to get the original event
	  if (event.hasOwnProperty('originalEvent')) event = event.originalEvent;
	  this.mousedown = true;
	  if (this.options.center) {
	    this.createRipple(this.container.prop('clientWidth') / 2, this.container.prop('clientWidth') / 2);
	  } else {
	
	    // We need to calculate the relative coordinates if the target is a sublayer of the ripple element
	    if (event.srcElement !== this.$element[0]) {
	      var layerRect = this.$element[0].getBoundingClientRect();
	      var layerX = event.clientX - layerRect.left;
	      var layerY = event.clientY - layerRect.top;
	
	      this.createRipple(layerX, layerY);
	    } else {
	      this.createRipple(event.offsetX, event.offsetY);
	    }
	  }
	};
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
	 * mouseup, touchend or mouseleave event)
	 */
	InkRippleCtrl.prototype.handleMouseup = function () {
	  this.$timeout(function () {
	    autoCleanup(this, this.clearRipples);
	  }.bind(this));
	};
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (by
	 * touchmove)
	 */
	InkRippleCtrl.prototype.handleTouchmove = function () {
	  autoCleanup(this, this.deleteRipples);
	};
	
	/**
	 * Cycles through all ripples and attempts to remove them.
	 */
	InkRippleCtrl.prototype.deleteRipples = function () {
	  for (var i = 0; i < this.ripples.length; i++) {
	    this.ripples[ i ].remove();
	  }
	};
	
	/**
	 * Cycles through all ripples and attempts to remove them with fade.
	 * Depending on logic within `fadeInComplete`, some removals will be postponed.
	 */
	InkRippleCtrl.prototype.clearRipples = function () {
	  for (var i = 0; i < this.ripples.length; i++) {
	    this.fadeInComplete(this.ripples[ i ]);
	  }
	};
	
	/**
	 * Creates the ripple container element
	 * @returns {*}
	 */
	InkRippleCtrl.prototype.createContainer = function () {
	  var container = angular.element('<div class="md-ripple-container"></div>');
	  this.$element.append(container);
	  return container;
	};
	
	InkRippleCtrl.prototype.clearTimeout = function () {
	  if (this.timeout) {
	    this.$timeout.cancel(this.timeout);
	    this.timeout = null;
	  }
	};
	
	InkRippleCtrl.prototype.isRippleAllowed = function () {
	  var element = this.$element[0];
	  do {
	    if (!element.tagName || element.tagName === 'BODY') break;
	
	    if (element && angular.isFunction(element.hasAttribute)) {
	      if (element.hasAttribute('disabled')) return false;
	      if (this.inkRipple() === 'false' || this.inkRipple() === '0') return false;
	    }
	
	  } while (element = element.parentNode);
	  return true;
	};
	
	/**
	 * The attribute `md-ink-ripple` may be a static or interpolated
	 * color value OR a boolean indicator (used to disable ripples)
	 */
	InkRippleCtrl.prototype.inkRipple = function () {
	  return this.$element.attr('md-ink-ripple');
	};
	
	/**
	 * Creates a new ripple and adds it to the container.  Also tracks ripple in `this.ripples`.
	 * @param left
	 * @param top
	 */
	InkRippleCtrl.prototype.createRipple = function (left, top) {
	  if (!this.isRippleAllowed()) return;
	
	  var ctrl        = this;
	  var colorUtil   = ctrl.$mdColorUtil;
	  var ripple      = angular.element('<div class="md-ripple"></div>');
	  var width       = this.$element.prop('clientWidth');
	  var height      = this.$element.prop('clientHeight');
	  var x           = Math.max(Math.abs(width - left), left) * 2;
	  var y           = Math.max(Math.abs(height - top), top) * 2;
	  var size        = getSize(this.options.fitRipple, x, y);
	  var color       = this.calculateColor();
	
	  ripple.css({
	    left:            left + 'px',
	    top:             top + 'px',
	    background:      'black',
	    width:           size + 'px',
	    height:          size + 'px',
	    backgroundColor: colorUtil.rgbaToRgb(color),
	    borderColor:     colorUtil.rgbaToRgb(color)
	  });
	  this.lastRipple = ripple;
	
	  // we only want one timeout to be running at a time
	  this.clearTimeout();
	  this.timeout    = this.$timeout(function () {
	    ctrl.clearTimeout();
	    if (!ctrl.mousedown) ctrl.fadeInComplete(ripple);
	  }, DURATION * 0.35, false);
	
	  if (this.options.dimBackground) this.container.css({ backgroundColor: color });
	  this.container.append(ripple);
	  this.ripples.push(ripple);
	  ripple.addClass('md-ripple-placed');
	
	  this.$mdUtil.nextTick(function () {
	
	    ripple.addClass('md-ripple-scaled md-ripple-active');
	    ctrl.$timeout(function () {
	      ctrl.clearRipples();
	    }, DURATION, false);
	
	  }, false);
	
	  function getSize (fit, x, y) {
	    return fit
	        ? Math.max(x, y)
	        : Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
	  }
	};
	
	
	
	/**
	 * After fadeIn finishes, either kicks off the fade-out animation or queues the element for removal on mouseup
	 * @param ripple
	 */
	InkRippleCtrl.prototype.fadeInComplete = function (ripple) {
	  if (this.lastRipple === ripple) {
	    if (!this.timeout && !this.mousedown) {
	      this.removeRipple(ripple);
	    }
	  } else {
	    this.removeRipple(ripple);
	  }
	};
	
	/**
	 * Kicks off the animation for removing a ripple
	 * @param ripple {Element}
	 */
	InkRippleCtrl.prototype.removeRipple = function (ripple) {
	  var ctrl  = this;
	  var index = this.ripples.indexOf(ripple);
	  if (index < 0) return;
	  this.ripples.splice(this.ripples.indexOf(ripple), 1);
	  ripple.removeClass('md-ripple-active');
	  ripple.addClass('md-ripple-remove');
	  if (this.ripples.length === 0) this.container.css({ backgroundColor: '' });
	  // use a 2-second timeout in order to allow for the animation to finish
	  // we don't actually care how long the animation takes
	  this.$timeout(function () {
	    ctrl.fadeOutComplete(ripple);
	  }, DURATION, false);
	};
	
	/**
	 * Removes the provided ripple from the DOM
	 * @param ripple
	 */
	InkRippleCtrl.prototype.fadeOutComplete = function (ripple) {
	  ripple.remove();
	  this.lastRipple = null;
	};
	
	/**
	 * Used to create an empty directive.  This is used to track flag-directives whose children may have
	 * functionality based on them.
	 *
	 * Example: `md-no-ink` will potentially be used by all child directives.
	 */
	function attrNoDirective () {
	  return { controller: angular.noop };
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	    /**
	   * @ngdoc service
	   * @name $mdTabInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-tabs.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdTabInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdTabInkRipple', MdTabInkRipple);
	
	  function MdTabInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: false,
	        dimBackground: true,
	        outline: false,
	        rippleSize: 'full'
	      }, options));
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core.theming.palette', [])
	.constant('$mdColorPalette', {
	  'red': {
	    '50': '#ffebee',
	    '100': '#ffcdd2',
	    '200': '#ef9a9a',
	    '300': '#e57373',
	    '400': '#ef5350',
	    '500': '#f44336',
	    '600': '#e53935',
	    '700': '#d32f2f',
	    '800': '#c62828',
	    '900': '#b71c1c',
	    'A100': '#ff8a80',
	    'A200': '#ff5252',
	    'A400': '#ff1744',
	    'A700': '#d50000',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 400 500 600 A100 A200 A400',
	    'contrastStrongLightColors': '700 800 900 A700'
	  },
	  'pink': {
	    '50': '#fce4ec',
	    '100': '#f8bbd0',
	    '200': '#f48fb1',
	    '300': '#f06292',
	    '400': '#ec407a',
	    '500': '#e91e63',
	    '600': '#d81b60',
	    '700': '#c2185b',
	    '800': '#ad1457',
	    '900': '#880e4f',
	    'A100': '#ff80ab',
	    'A200': '#ff4081',
	    'A400': '#f50057',
	    'A700': '#c51162',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 400 A100 A200 A400',
	    // White on 500 does not meet the minimum 4.5 contrast ratio (at 4.34),
	    // but it's worse with a dark foreground (3.61).
	    'contrastStrongLightColors': '500 600 700 800 900 A700'
	  },
	  'purple': {
	    '50': '#f3e5f5',
	    '100': '#e1bee7',
	    '200': '#ce93d8',
	    '300': '#ba68c8',
	    '400': '#ab47bc',
	    '500': '#9c27b0',
	    '600': '#8e24aa',
	    '700': '#7b1fa2',
	    '800': '#6a1b9a',
	    '900': '#4a148c',
	    'A100': '#ea80fc',
	    'A200': '#e040fb',
	    'A400': '#d500f9',
	    'A700': '#aa00ff',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 A100 A200 A400',
	    'contrastStrongLightColors': '400 500 600 700 800 900 A700'
	  },
	  'deep-purple': {
	    '50': '#ede7f6',
	    '100': '#d1c4e9',
	    '200': '#b39ddb',
	    '300': '#9575cd',
	    '400': '#7e57c2',
	    '500': '#673ab7',
	    '600': '#5e35b1',
	    '700': '#512da8',
	    '800': '#4527a0',
	    '900': '#311b92',
	    'A100': '#b388ff',
	    'A200': '#7c4dff',
	    'A400': '#651fff',
	    'A700': '#6200ea',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 A100',
	    'contrastStrongLightColors': '400 500 600 700 800 900 A200 A400 A700'
	  },
	  'indigo': {
	    '50': '#e8eaf6',
	    '100': '#c5cae9',
	    '200': '#9fa8da',
	    '300': '#7986cb',
	    '400': '#5c6bc0',
	    '500': '#3f51b5',
	    '600': '#3949ab',
	    '700': '#303f9f',
	    '800': '#283593',
	    '900': '#1a237e',
	    'A100': '#8c9eff',
	    'A200': '#536dfe',
	    'A400': '#3d5afe',
	    'A700': '#304ffe',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 A100 A200',
	    'contrastStrongLightColors': '400 500 600 700 800 900 A400 A700'
	  },
	  'blue': {
	    '50': '#e3f2fd',
	    '100': '#bbdefb',
	    '200': '#90caf9',
	    '300': '#64b5f6',
	    '400': '#42a5f5',
	    '500': '#2196f3',
	    '600': '#1e88e5',
	    '700': '#1976d2',
	    '800': '#1565c0',
	    '900': '#0d47a1',
	    'A100': '#82b1ff',
	    'A200': '#448aff',
	    'A400': '#2979ff',
	    'A700': '#2962ff',
	    'contrastDefaultColor': 'light',
	    // White on A400 does not meet the minimum 4.5 contrast ratio (at 3.98),
	    // but it's worse with a dark foreground (3.94).
	    'contrastDarkColors': '50 100 200 300 400 500 600 A100 A200',
	    'contrastStrongLightColors': '700 800 900 A400 A700'
	  },
	  'light-blue': {
	    '50': '#e1f5fe',
	    '100': '#b3e5fc',
	    '200': '#81d4fa',
	    '300': '#4fc3f7',
	    '400': '#29b6f6',
	    '500': '#03a9f4',
	    '600': '#039be5',
	    '700': '#0288d1',
	    '800': '#0277bd',
	    '900': '#01579b',
	    'A100': '#80d8ff',
	    'A200': '#40c4ff',
	    'A400': '#00b0ff',
	    'A700': '#0091ea',
	    'contrastDefaultColor': 'dark',
	    // Dark on 700 does not meet the minimum 4.5 contrast ratio (at 4.07),
	    // but it's worse with a white foreground (3.85).
	    'contrastStrongLightColors': '800 900 A700'
	  },
	  'cyan': {
	    '50': '#e0f7fa',
	    '100': '#b2ebf2',
	    '200': '#80deea',
	    '300': '#4dd0e1',
	    '400': '#26c6da',
	    '500': '#00bcd4',
	    '600': '#00acc1',
	    '700': '#0097a7',
	    '800': '#00838f',
	    '900': '#006064',
	    'A100': '#84ffff',
	    'A200': '#18ffff',
	    'A400': '#00e5ff',
	    'A700': '#00b8d4',
	    'contrastDefaultColor': 'dark',
	    // Dark on 700 does not meet the minimum 4.5 contrast ratio (at 4.47),
	    // but it's worse with a white foreground (3.5).
	    'contrastStrongLightColors': '800 900'
	  },
	  'teal': {
	    '50': '#e0f2f1',
	    '100': '#b2dfdb',
	    '200': '#80cbc4',
	    '300': '#4db6ac',
	    '400': '#26a69a',
	    '500': '#009688',
	    '600': '#00897b',
	    '700': '#00796b',
	    '800': '#00695c',
	    '900': '#004d40',
	    'A100': '#a7ffeb',
	    'A200': '#64ffda',
	    'A400': '#1de9b6',
	    'A700': '#00bfa5',
	    'contrastDefaultColor': 'dark',
	    // Dark on 500 does not meet the minimum 4.5 contrast ratio (at 4.27),
	    // but it's worse with a white foreground (3.67).
	    // White on 600 does not meet the minimum 4.5 contrast ratio (at 4.31),
	    // but it's worse with a dark foreground (3.64).
	    'contrastStrongLightColors': '600 700 800 900'
	  },
	  'green': {
	    '50': '#e8f5e9',
	    '100': '#c8e6c9',
	    '200': '#a5d6a7',
	    '300': '#81c784',
	    '400': '#66bb6a',
	    '500': '#4caf50',
	    '600': '#43a047',
	    '700': '#388e3c',
	    '800': '#2e7d32',
	    '900': '#1b5e20',
	    'A100': '#b9f6ca',
	    'A200': '#69f0ae',
	    'A400': '#00e676',
	    'A700': '#00c853',
	    'contrastDefaultColor': 'dark',
	    // White on 700 does not meet the minimum 4.5 contrast ratio (at 4.11),
	    // but it's worse with a dark foreground (3.81).
	    'contrastStrongLightColors': '700 800 900'
	  },
	  'light-green': {
	    '50': '#f1f8e9',
	    '100': '#dcedc8',
	    '200': '#c5e1a5',
	    '300': '#aed581',
	    '400': '#9ccc65',
	    '500': '#8bc34a',
	    '600': '#7cb342',
	    '700': '#689f38',
	    '800': '#558b2f',
	    '900': '#33691e',
	    'A100': '#ccff90',
	    'A200': '#b2ff59',
	    'A400': '#76ff03',
	    'A700': '#64dd17',
	    'contrastDefaultColor': 'dark',
	    'contrastStrongLightColors': '800 900'
	  },
	  'lime': {
	    '50': '#f9fbe7',
	    '100': '#f0f4c3',
	    '200': '#e6ee9c',
	    '300': '#dce775',
	    '400': '#d4e157',
	    '500': '#cddc39',
	    '600': '#c0ca33',
	    '700': '#afb42b',
	    '800': '#9e9d24',
	    '900': '#827717',
	    'A100': '#f4ff81',
	    'A200': '#eeff41',
	    'A400': '#c6ff00',
	    'A700': '#aeea00',
	    'contrastDefaultColor': 'dark',
	    'contrastStrongLightColors': '900'
	  },
	  'yellow': {
	    '50': '#fffde7',
	    '100': '#fff9c4',
	    '200': '#fff59d',
	    '300': '#fff176',
	    '400': '#ffee58',
	    '500': '#ffeb3b',
	    '600': '#fdd835',
	    '700': '#fbc02d',
	    '800': '#f9a825',
	    '900': '#f57f17',
	    'A100': '#ffff8d',
	    'A200': '#ffff00',
	    'A400': '#ffea00',
	    'A700': '#ffd600',
	    'contrastDefaultColor': 'dark'
	  },
	  'amber': {
	    '50': '#fff8e1',
	    '100': '#ffecb3',
	    '200': '#ffe082',
	    '300': '#ffd54f',
	    '400': '#ffca28',
	    '500': '#ffc107',
	    '600': '#ffb300',
	    '700': '#ffa000',
	    '800': '#ff8f00',
	    '900': '#ff6f00',
	    'A100': '#ffe57f',
	    'A200': '#ffd740',
	    'A400': '#ffc400',
	    'A700': '#ffab00',
	    'contrastDefaultColor': 'dark'
	  },
	  'orange': {
	    '50': '#fff3e0',
	    '100': '#ffe0b2',
	    '200': '#ffcc80',
	    '300': '#ffb74d',
	    '400': '#ffa726',
	    '500': '#ff9800',
	    '600': '#fb8c00',
	    '700': '#f57c00',
	    '800': '#ef6c00',
	    '900': '#e65100',
	    'A100': '#ffd180',
	    'A200': '#ffab40',
	    'A400': '#ff9100',
	    'A700': '#ff6d00',
	    'contrastDefaultColor': 'dark',
	    'contrastStrongLightColors': '900'
	  },
	  'deep-orange': {
	    '50': '#fbe9e7',
	    '100': '#ffccbc',
	    '200': '#ffab91',
	    '300': '#ff8a65',
	    '400': '#ff7043',
	    '500': '#ff5722',
	    '600': '#f4511e',
	    '700': '#e64a19',
	    '800': '#d84315',
	    '900': '#bf360c',
	    'A100': '#ff9e80',
	    'A200': '#ff6e40',
	    'A400': '#ff3d00',
	    'A700': '#dd2c00',
	    'contrastDefaultColor': 'dark',
	    // Dark on 700 does not meet the minimum 4.5 contrast ratio (at 4.01),
	    // but it's worse with a white foreground (3.91).
	    // White on 800 does not meet the minimum 4.5 contrast ratio (at 4.43),
	    // but it's worse with a dark foreground (3.54).
	    'contrastStrongLightColors': '800 900 A400 A700',
	  },
	  'brown': {
	    '50': '#efebe9',
	    '100': '#d7ccc8',
	    '200': '#bcaaa4',
	    '300': '#a1887f',
	    '400': '#8d6e63',
	    '500': '#795548',
	    '600': '#6d4c41',
	    '700': '#5d4037',
	    '800': '#4e342e',
	    '900': '#3e2723',
	    'A100': '#d7ccc8',
	    'A200': '#bcaaa4',
	    'A400': '#8d6e63',
	    'A700': '#5d4037',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 A100 A200',
	    'contrastStrongLightColors': '400 500 600 700 800 900 A400 A700'
	  },
	  'grey': {
	    '50': '#fafafa',
	    '100': '#f5f5f5',
	    '200': '#eeeeee',
	    '300': '#e0e0e0',
	    '400': '#bdbdbd',
	    '500': '#9e9e9e',
	    '600': '#757575',
	    '700': '#616161',
	    '800': '#424242',
	    '900': '#212121',
	    'A100': '#ffffff',
	    'A200': '#000000',
	    'A400': '#303030',
	    'A700': '#616161',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '700 800 900 A200 A400 A700',
	    'contrastStrongLightColors': '600'
	  },
	  'blue-grey': {
	    '50': '#eceff1',
	    '100': '#cfd8dc',
	    '200': '#b0bec5',
	    '300': '#90a4ae',
	    '400': '#78909c',
	    '500': '#607d8b',
	    '600': '#546e7a',
	    '700': '#455a64',
	    '800': '#37474f',
	    '900': '#263238',
	    'A100': '#cfd8dc',
	    'A200': '#b0bec5',
	    'A400': '#78909c',
	    'A700': '#455a64',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 400 A100 A200 A400',
	    // White on 500 does not meet the minimum 4.5 contrast ratio (at 4.37),
	    // but it's worse with a dark foreground.
	    'contrastStrongLightColors': '500 600 700 800 900 A700'
	  }
	});
	
	})();
	(function(){
	"use strict";
	
	(function(angular) {
	  'use strict';
	/**
	 * @ngdoc module
	 * @name material.core.theming
	 * @description
	 * Theming
	 */
	detectDisabledThemes.$inject = ["$mdThemingProvider"];
	ThemingDirective.$inject = ["$mdTheming", "$interpolate", "$parse", "$mdUtil", "$q", "$log"];
	ThemableDirective.$inject = ["$mdTheming"];
	ThemingProvider.$inject = ["$mdColorPalette", "$$mdMetaProvider"];
	generateAllThemes.$inject = ["$injector", "$mdTheming"];
	angular.module('material.core.theming', ['material.core.theming.palette', 'material.core.meta'])
	  .directive('mdTheme', ThemingDirective)
	  .directive('mdThemable', ThemableDirective)
	  .directive('mdThemesDisabled', disableThemesDirective)
	  .provider('$mdTheming', ThemingProvider)
	  .config(detectDisabledThemes)
	  .run(generateAllThemes);
	
	/**
	 * Detect if the HTML or the BODY tags has a [md-themes-disabled] attribute
	 * If yes, then immediately disable all theme stylesheet generation and DOM injection
	 */
	/**
	 * @ngInject
	 */
	function detectDisabledThemes($mdThemingProvider) {
	  var isDisabled = !!document.querySelector('[md-themes-disabled]');
	  $mdThemingProvider.disableTheming(isDisabled);
	}
	
	/**
	 * @ngdoc service
	 * @name $mdThemingProvider
	 * @module material.core.theming
	 *
	 * @description Provider to configure the `$mdTheming` service.
	 *
	 * ### Default Theme
	 * The `$mdThemingProvider` uses by default the following theme configuration:
	 *
	 * - Primary Palette: `Blue`
	 * - Accent Palette: `Pink`
	 * - Warn Palette: `Deep-Orange`
	 * - Background Palette: `Grey`
	 *
	 * If you don't want to use the `md-theme` directive on the elements itself, you may want to overwrite
	 * the default theme.<br/>
	 * This can be done by using the following markup.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     $mdThemingProvider
	 *       .theme('default')
	 *       .primaryPalette('blue')
	 *       .accentPalette('teal')
	 *       .warnPalette('red')
	 *       .backgroundPalette('grey');
	 *   });
	 * </hljs>
	 *
	
	 * ### Dynamic Themes
	 *
	 * By default, if you change a theme at runtime, the `$mdTheming` service will not detect those changes.<br/>
	 * If you have an application, which changes its theme on runtime, you have to enable theme watching.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Enable theme watching.
	 *     $mdThemingProvider.alwaysWatchTheme(true);
	 *   });
	 * </hljs>
	 *
	 * ### Custom Theme Styles
	 *
	 * Sometimes you may want to use your own theme styles for some custom components.<br/>
	 * You are able to register your own styles by using the following markup.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Register our custom stylesheet into the theming provider.
	 *     $mdThemingProvider.registerStyles(STYLESHEET);
	 *   });
	 * </hljs>
	 *
	 * The `registerStyles` method only accepts strings as value, so you're actually not able to load an external
	 * stylesheet file into the `$mdThemingProvider`.
	 *
	 * If it's necessary to load an external stylesheet, we suggest using a bundler, which supports including raw content,
	 * like [raw-loader](https://github.com/webpack/raw-loader) for `webpack`.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Register your custom stylesheet into the theming provider.
	 *     $mdThemingProvider.registerStyles(require('../styles/my-component.theme.css'));
	 *   });
	 * </hljs>
	 *
	 * ### Browser color
	 *
	 * Enables browser header coloring
	 * for more info please visit:
	 * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
	 *
	 * Options parameter: <br/>
	 * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
	 * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	 *             'accent', 'background' and 'warn'. Default is `primary`. <br/>
	 * `hue`     - The hue from the selected palette. Default is `800`<br/>
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Enable browser color
	 *     $mdThemingProvider.enableBrowserColor({
	 *       theme: 'myTheme', // Default is 'default'
	 *       palette: 'accent', // Default is 'primary', any basic material palette and extended palettes are available
	 *       hue: '200' // Default is '800'
	 *     });
	 *   });
	 * </hljs>
	 */
	
	/**
	 * Some Example Valid Theming Expressions
	 * =======================================
	 *
	 * Intention group expansion: (valid for primary, accent, warn, background)
	 *
	 * {{primary-100}} - grab shade 100 from the primary palette
	 * {{primary-100-0.7}} - grab shade 100, apply opacity of 0.7
	 * {{primary-100-contrast}} - grab shade 100's contrast color
	 * {{primary-hue-1}} - grab the shade assigned to hue-1 from the primary palette
	 * {{primary-hue-1-0.7}} - apply 0.7 opacity to primary-hue-1
	 * {{primary-color}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured shades set for each hue
	 * {{primary-color-0.7}} - Apply 0.7 opacity to each of the above rules
	 * {{primary-contrast}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured contrast (ie. text) color shades set for each hue
	 * {{primary-contrast-0.7}} - Apply 0.7 opacity to each of the above rules
	 * {{primary-contrast-divider}} - Apply divider opacity to contrast color
	 *
	 * Foreground expansion: Applies rgba to black/white foreground text
	 *
	 * Old Foreground Expressions:
	 * {{foreground-1}} - used for primary text
	 * {{foreground-2}} - used for secondary text/divider
	 * {{foreground-3}} - used for disabled text
	 * {{foreground-4}} - used for dividers
	 *
	 * New Foreground Expressions:
	 *
	 * Apply primary text color for contrasting with default background
	 *  {{background-default-contrast}} - default opacity
	 *  {{background-default-contrast-secondary}} - opacity for secondary text
	 *  {{background-default-contrast-hint}} - opacity for hints and placeholders
	 *  {{background-default-contrast-disabled}} - opacity for disabled text
	 *  {{background-default-contrast-divider}} - opacity for dividers
	 *
	 * Apply contrast color for specific shades
	 *  {{background-50-contrast-icon}} - Apply contrast color for icon on background's shade 50 hue
	 */
	
	// In memory generated CSS rules; registered by theme.name
	var GENERATED = { };
	
	// In memory storage of defined themes and color palettes (both loaded by CSS, and user specified)
	var PALETTES;
	
	// Text colors are automatically generated based on background color when not specified
	// Custom palettes can provide override colors
	// @see https://material.io/archive/guidelines/style/color.html#color-usability
	var DARK_FOREGROUND = {
	  name: 'dark',
	};
	var LIGHT_FOREGROUND = {
	  name: 'light',
	};
	
	var DARK_SHADOW = '1px 1px 0px rgba(0,0,0,0.4), -1px -1px 0px rgba(0,0,0,0.4)';
	var LIGHT_SHADOW = '';
	
	var DARK_CONTRAST_COLOR = colorToRgbaArray('rgba(0,0,0,0.87)');
	var LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgba(255,255,255,0.87)');
	var STRONG_LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgb(255,255,255)');
	
	var THEME_COLOR_TYPES = ['primary', 'accent', 'warn', 'background'];
	var DEFAULT_COLOR_TYPE = 'primary';
	
	// A color in a theme will use these hues by default, if not specified by user.
	var LIGHT_DEFAULT_HUES = {
	  'accent': {
	    'default': 'A200',
	    'hue-1': 'A100',
	    'hue-2': 'A400',
	    'hue-3': 'A700'
	  },
	  'background': {
	    'default': '50',
	    'hue-1': 'A100',
	    'hue-2': '100',
	    'hue-3': '300'
	  }
	};
	
	var DARK_DEFAULT_HUES = {
	  'background': {
	    'default': 'A400',
	    'hue-1': '800',
	    'hue-2': '900',
	    'hue-3': 'A200'
	  }
	};
	
	// Icon opacity values (active/inactive) from
	// https://material.io/archive/guidelines/style/color.html#color-usability
	var DARK_CONTRAST_OPACITY = {
	  'icon': 0.54,
	  'secondary': 0.54,
	  'disabled': 0.38,
	  'hint': 0.38,
	  'divider': 0.12,
	};
	
	var LIGHT_CONTRAST_OPACITY = {
	  'icon': 0.87,
	  'secondary': 0.7,
	  'disabled': 0.5,
	  'hint': 0.5,
	  'divider': 0.12
	};
	
	// Icon opacity values (active/inactive) from
	// https://material.io/archive/guidelines/style/color.html#color-usability
	var STRONG_LIGHT_CONTRAST_OPACITY = {
	  'icon': 1.0,
	  'secondary': 0.7,
	  'disabled': 0.5,
	  'hint': 0.5,
	  'divider': 0.12
	};
	
	THEME_COLOR_TYPES.forEach(function(colorType) {
	  // Color types with unspecified default hues will use these default hue values
	  var defaultDefaultHues = {
	    'default': '500',
	    'hue-1': '300',
	    'hue-2': '800',
	    'hue-3': 'A100'
	  };
	  if (!LIGHT_DEFAULT_HUES[colorType]) LIGHT_DEFAULT_HUES[colorType] = defaultDefaultHues;
	  if (!DARK_DEFAULT_HUES[colorType]) DARK_DEFAULT_HUES[colorType] = defaultDefaultHues;
	});
	
	var VALID_HUE_VALUES = [
	  '50', '100', '200', '300', '400', '500', '600',
	  '700', '800', '900', 'A100', 'A200', 'A400', 'A700'
	];
	
	var themeConfig = {
	  disableTheming : false,   // Generate our themes at run time; also disable stylesheet DOM injection
	  generateOnDemand : false, // Whether or not themes are to be generated on-demand (vs. eagerly).
	  registeredStyles : [],    // Custom styles registered to be used in the theming of custom components.
	  nonce : null              // Nonce to be added as an attribute to the generated themes style tags.
	};
	
	/**
	 *
	 */
	function ThemingProvider($mdColorPalette, $$mdMetaProvider) {
	  ThemingService.$inject = ["$rootScope", "$mdUtil", "$q", "$log"];
	  PALETTES = { };
	  var THEMES = { };
	
	  var themingProvider;
	
	  var alwaysWatchTheme = false;
	  var defaultTheme = 'default';
	
	  // Load JS Defined Palettes
	  angular.extend(PALETTES, $mdColorPalette);
	
	  // Default theme defined in core.js
	
	  /**
	   * Adds `theme-color` and `msapplication-navbutton-color` meta tags with the color parameter
	   * @param {string} color Hex value of the wanted browser color
	   * @returns {function} Remove function of the meta tags
	   */
	  var setBrowserColor = function (color) {
	    // Chrome, Firefox OS and Opera
	    var removeChrome = $$mdMetaProvider.setMeta('theme-color', color);
	    // Windows Phone
	    var removeWindows = $$mdMetaProvider.setMeta('msapplication-navbutton-color', color);
	
	    return function () {
	      removeChrome();
	      removeWindows();
	    };
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdThemingProvider#enableBrowserColor
	   * @description
	   * Enables browser header coloring. For more info please visit
	   * <a href="https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color">
	   *   Web Fundamentals</a>.
	   * @param {object=} options Options for the browser color, which include:<br/>
	   * - `theme` - `{string}`: A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
	   * - `palette` - `{string}`:  Can be any one of the basic material design palettes, extended defined palettes, or `primary`,
	   *  `accent`, `background`, and `warn`. Default is `primary`.<br/>
	   * - `hue` -  `{string}`: The hue from the selected palette. Default is `800`.<br/>
	   * @returns {function} Function that removes the browser coloring when called.
	   */
	  var enableBrowserColor = function (options) {
	    options = angular.isObject(options) ? options : {};
	
	    var theme = options.theme || 'default';
	    var hue = options.hue || '800';
	
	    var palette = PALETTES[options.palette] ||
	      PALETTES[THEMES[theme].colors[options.palette || 'primary'].name];
	
	    var color = angular.isObject(palette[hue]) ? palette[hue].hex : palette[hue];
	    if (color.substr(0, 1) !== '#') color = '#' + color;
	
	    return setBrowserColor(color);
	  };
	
	  return themingProvider = {
	    definePalette: definePalette,
	    extendPalette: extendPalette,
	    theme: registerTheme,
	
	    /**
	     * return a read-only clone of the current theme configuration
	     */
	    configuration : function() {
	      return angular.extend({ }, themeConfig, {
	        defaultTheme : defaultTheme,
	        alwaysWatchTheme : alwaysWatchTheme,
	        registeredStyles : [].concat(themeConfig.registeredStyles)
	      });
	    },
	
	    /**
	     * @ngdoc method
	     * @name $mdThemingProvider#disableTheming
	     * @description
	     * An easier way to disable theming without having to use `.constant("$MD_THEME_CSS","");`.
	     * This disables all dynamic theme style sheet generations and injections.
	     * @param {boolean=} isDisabled Disable all dynamic theme style sheet generations and injections
	     *  if `true` or `undefined`.
	     */
	    disableTheming: function(isDisabled) {
	      themeConfig.disableTheming = angular.isUndefined(isDisabled) || !!isDisabled;
	    },
	
	    /**
	     * @ngdoc method
	     * @name $mdThemingProvider#registerStyles
	     * @param {string} styles The styles to be appended to AngularJS Material's built in theme CSS.
	     */
	    registerStyles: function(styles) {
	      themeConfig.registeredStyles.push(styles);
	    },
	
	    /**
	     * @ngdoc method
	     * @name $mdThemingProvider#setNonce
	     * @param {string} nonceValue The nonce to be added as an attribute to the theme style tags.
	     * Setting a value allows the use of CSP policy without using the `'unsafe-inline'` directive.
	     * The string must already be base64 encoded. You can use `btoa(string)` to do this encoding.
	     * In your CSP's `style-src`, you would then add an entry for `'nonce-nonceValue'`.
	     */
	    setNonce: function(nonceValue) {
	      themeConfig.nonce = nonceValue;
	    },
	
	    generateThemesOnDemand: function(onDemand) {
	      themeConfig.generateOnDemand = onDemand;
	    },
	
	    /**
	     * @ngdoc method
	     * @name $mdThemingProvider#setDefaultTheme
	     * @param {string} theme Default theme name to be applied to elements.
	     *  Default value is `default`.
	     */
	    setDefaultTheme: function(theme) {
	      defaultTheme = theme;
	    },
	
	    /**
	     * @ngdoc method
	     * @name $mdThemingProvider#alwaysWatchTheme
	     * @param {boolean} alwaysWatch Whether or not to always watch themes for changes and re-apply
	     * classes when they change. Default is `false`. Enabling can reduce performance.
	     */
	    alwaysWatchTheme: function(alwaysWatch) {
	      alwaysWatchTheme = alwaysWatch;
	    },
	
	    enableBrowserColor: enableBrowserColor,
	
	    $get: ThemingService,
	    _LIGHT_DEFAULT_HUES: LIGHT_DEFAULT_HUES,
	    _DARK_DEFAULT_HUES: DARK_DEFAULT_HUES,
	    _PALETTES: PALETTES,
	    _THEMES: THEMES,
	    _parseRules: parseRules,
	    _rgba: rgba
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdThemingProvider#definePalette
	   * @description
	   * In the event that you need to define a custom color palette, you can use this function to
	   * make it available to your theme for use in its intention groups.<br>
	   * Note that you must specify all hues in the definition map.
	   * @param {string} name Name of palette being defined
	   * @param {object} map Palette definition that includes hue definitions and contrast colors:
	   * - `'50'` - `{string}`: HEX color
	   * - `'100'` - `{string}`: HEX color
	   * - `'200'` - `{string}`: HEX color
	   * - `'300'` - `{string}`: HEX color
	   * - `'400'` - `{string}`: HEX color
	   * - `'500'` - `{string}`: HEX color
	   * - `'600'` - `{string}`: HEX color
	   * - `'700'` - `{string}`: HEX color
	   * - `'800'` - `{string}`: HEX color
	   * - `'900'` - `{string}`: HEX color
	   * - `'A100'` - `{string}`: HEX color
	   * - `'A200'` - `{string}`: HEX color
	   * - `'A400'` - `{string}`: HEX color
	   * - `'A700'` - `{string}`: HEX color
	   * - `'contrastDefaultColor'` - `{string}`: `light` or `dark`
	   * - `'contrastDarkColors'` - `{string[]}`: Hues which should use dark contrast colors (i.e. raised button text).
	   *  For example: `['50', '100', '200', '300', '400', 'A100']`.
	   * - `'contrastLightColors'` - `{string[]}`: Hues which should use light contrast colors (i.e. raised button text).
	   *  For example: `['500', '600', '700', '800', '900', 'A200', 'A400', 'A700']`.
	   */
	  function definePalette(name, map) {
	    map = map || {};
	    PALETTES[name] = checkPaletteValid(name, map);
	    return themingProvider;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $mdThemingProvider#extendPalette
	   * @description
	   * Sometimes it is easier to extend an existing color palette and then change a few properties,
	   * rather than defining a whole new palette.
	   * @param {string} name Name of palette being extended
	   * @param {object} map Palette definition that includes optional hue definitions and contrast colors:
	   * - `'50'` - `{string}`: HEX color
	   * - `'100'` - `{string}`: HEX color
	   * - `'200'` - `{string}`: HEX color
	   * - `'300'` - `{string}`: HEX color
	   * - `'400'` - `{string}`: HEX color
	   * - `'500'` - `{string}`: HEX color
	   * - `'600'` - `{string}`: HEX color
	   * - `'700'` - `{string}`: HEX color
	   * - `'800'` - `{string}`: HEX color
	   * - `'900'` - `{string}`: HEX color
	   * - `'A100'` - `{string}`: HEX color
	   * - `'A200'` - `{string}`: HEX color
	   * - `'A400'` - `{string}`: HEX color
	   * - `'A700'` - `{string}`: HEX color
	   * - `'contrastDefaultColor'` - `{string}`: `light` or `dark`
	   * - `'contrastDarkColors'` - `{string[]}`: Hues which should use dark contrast colors (i.e. raised button text).
	   *  For example: `['50', '100', '200', '300', '400', 'A100']`.
	   * - `'contrastLightColors'` - `{string[]}`: Hues which should use light contrast colors (i.e. raised button text).
	   *  For example: `['500', '600', '700', '800', '900', 'A200', 'A400', 'A700']`.
	   *  @returns {object} A new object which is a copy of the given palette, `name`,
	   *    with variables from `map` overwritten.
	   */
	  function extendPalette(name, map) {
	    return checkPaletteValid(name,  angular.extend({}, PALETTES[name] || {}, map));
	  }
	
	  // Make sure that palette has all required hues
	  function checkPaletteValid(name, map) {
	    var missingColors = VALID_HUE_VALUES.filter(function(field) {
	      return !map[field];
	    });
	    if (missingColors.length) {
	      throw new Error("Missing colors %1 in palette %2!"
	                      .replace('%1', missingColors.join(', '))
	                      .replace('%2', name));
	    }
	
	    return map;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $mdThemingProvider#theme
	   * @description
	   * Register a theme (which is a collection of color palettes); i.e. `warn`, `accent`,
	   * `background`, and `primary`.<br>
	   * Optionally inherit from an existing theme.
	   * @param {string} name Name of theme being registered
	   * @param {string=} inheritFrom Existing theme name to inherit from
	   */
	  function registerTheme(name, inheritFrom) {
	    if (THEMES[name]) return THEMES[name];
	
	    inheritFrom = inheritFrom || 'default';
	
	    var parentTheme = typeof inheritFrom === 'string' ? THEMES[inheritFrom] : inheritFrom;
	    var theme = new Theme(name);
	
	    if (parentTheme) {
	      angular.forEach(parentTheme.colors, function(color, colorType) {
	        theme.colors[colorType] = {
	          name: color.name,
	          // Make sure a COPY of the hues is given to the child color,
	          // not the same reference.
	          hues: angular.extend({}, color.hues)
	        };
	      });
	    }
	    THEMES[name] = theme;
	
	    return theme;
	  }
	
	  function Theme(name) {
	    var self = this;
	    self.name = name;
	    self.colors = {};
	
	    self.dark = setDark;
	    setDark(false);
	
	    function setDark(isDark) {
	      isDark = arguments.length === 0 ? true : !!isDark;
	
	      // If no change, abort
	      if (isDark === self.isDark) return;
	
	      self.isDark = isDark;
	
	      self.foregroundPalette = self.isDark ? LIGHT_FOREGROUND : DARK_FOREGROUND;
	      self.foregroundShadow = self.isDark ? DARK_SHADOW : LIGHT_SHADOW;
	
	      // Light and dark themes have different default hues.
	      // Go through each existing color type for this theme, and for every
	      // hue value that is still the default hue value from the previous light/dark setting,
	      // set it to the default hue value from the new light/dark setting.
	      var newDefaultHues = self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES;
	      var oldDefaultHues = self.isDark ? LIGHT_DEFAULT_HUES : DARK_DEFAULT_HUES;
	      angular.forEach(newDefaultHues, function(newDefaults, colorType) {
	        var color = self.colors[colorType];
	        var oldDefaults = oldDefaultHues[colorType];
	        if (color) {
	          for (var hueName in color.hues) {
	            if (color.hues[hueName] === oldDefaults[hueName]) {
	              color.hues[hueName] = newDefaults[hueName];
	            }
	          }
	        }
	      });
	
	      return self;
	    }
	
	    THEME_COLOR_TYPES.forEach(function(colorType) {
	      var defaultHues = (self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES)[colorType];
	      self[colorType + 'Palette'] = function setPaletteType(paletteName, hues) {
	        var color = self.colors[colorType] = {
	          name: paletteName,
	          hues: angular.extend({}, defaultHues, hues)
	        };
	
	        Object.keys(color.hues).forEach(function(name) {
	          if (!defaultHues[name]) {
	            throw new Error("Invalid hue name '%1' in theme %2's %3 color %4. Available hue names: %4"
	              .replace('%1', name)
	              .replace('%2', self.name)
	              .replace('%3', paletteName)
	              .replace('%4', Object.keys(defaultHues).join(', '))
	            );
	          }
	        });
	        Object.keys(color.hues).map(function(key) {
	          return color.hues[key];
	        }).forEach(function(hueValue) {
	          if (VALID_HUE_VALUES.indexOf(hueValue) === -1) {
	            throw new Error("Invalid hue value '%1' in theme %2's %3 color %4. Available hue values: %5"
	              .replace('%1', hueValue)
	              .replace('%2', self.name)
	              .replace('%3', colorType)
	              .replace('%4', paletteName)
	              .replace('%5', VALID_HUE_VALUES.join(', '))
	            );
	          }
	        });
	        return self;
	      };
	    });
	  }
	
	  /**
	   * @ngdoc service
	   * @name $mdTheming
	   * @module material.core.theming
	   * @description
	   * Service that makes an element apply theming related <b>classes</b> to itself.
	   *
	   * For more information on the hue objects, their default values, as well as valid hue values, please visit <a ng-href="Theming/03_configuring_a_theme#specifying-custom-hues-for-color-intentions">the custom hues section of Configuring a Theme</a>.
	   *
	   * <hljs lang="js">
	   * // Example component directive that we want to apply theming classes to.
	   * app.directive('myFancyDirective', function($mdTheming) {
	   *   return {
	   *     restrict: 'AE',
	   *     link: function(scope, element, attrs) {
	   *       // Initialize the service using our directive's element
	   *       $mdTheming(element);
	   *
	   *       $mdTheming.defineTheme('myTheme', {
	   *         primary: 'blue',
	   *         primaryHues: {
	   *           default: '500',
	   *           hue-1: '300',
	   *           hue-2: '900',
	   *           hue-3: 'A100'
	   *         },
	   *         accent: 'pink',
	   *         accentHues: {
	   *           default: '600',
	   *           hue-1: '300',
	   *           hue-2: '200',
	   *           hue-3: 'A500'
	   *         },
	   *         warn: 'red',
	   *         // It's not necessary to specify all hues in the object.
	   *         warnHues: {
	   *           default: '200',
	   *           hue-3: 'A100'
	   *         },
	   *         // It's not necessary to specify custom hues at all.
	   *         background: 'grey',
	   *         dark: true
	   *       });
	   *       // Your directive's custom code here.
	   *     }
	   *   };
	   * });
	   * </hljs>
	   * @param {element=} element Element that will have theming classes applied to it.
	   */
	
	  /**
	   * @ngdoc property
	   * @name $mdTheming#THEMES
	   * @description
	   * Property to get all the themes defined
	   * @returns {object} All the themes defined with their properties.
	   */
	
	  /**
	   * @ngdoc property
	   * @name $mdTheming#PALETTES
	   * @description
	   * Property to get all the palettes defined
	   * @returns {object} All the palettes defined with their colors.
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#registered
	   * @description
	   * Determine is specified theme name is a valid, registered theme
	   * @param {string} themeName the theme to check if registered
	   * @returns {boolean} whether the theme is registered or not
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#defaultTheme
	   * @description
	   * Returns the default theme
	   * @returns {string} The default theme
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#generateTheme
	   * @description
	   * Lazy generate themes - by default, every theme is generated when defined.
	   * You can disable this in the configuration section using the
	   * `$mdThemingProvider.generateThemesOnDemand(true);`
	   *
	   * The theme name that is passed in must match the name of the theme that was defined as part of
	   * the configuration block.
	   *
	   * @param {string} name theme name to generate
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#setBrowserColor
	   * @description
	   * Enables browser header coloring. For more info please visit
	   * <a href="https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color">
	   *   Web Fundamentals</a>.
	   * @param {object=} options Options for the browser color, which include:<br/>
	   * - `theme` - `{string}`: A defined theme via `$mdThemeProvider` to use the palettes from.
	   *    Default is `default` theme. <br/>
	   * - `palette` - `{string}`:  Can be any one of the basic material design palettes, extended
	   *    defined palettes, or `primary`, `accent`, `background`, and `warn`. Default is `primary`.
	   * <br/>
	   * - `hue` -  `{string}`: The hue from the selected palette. Default is `800`.<br/>
	   * @returns {function} Function that removes the browser coloring when called.
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#defineTheme
	   * @description
	   * Dynamically define a theme by using an options object that contains palette names.
	   *
	   * @param {string} name Theme name to define
	   * @param {object} options Theme definition options
	   *
	   * Options are:<br/>
	   * - `primary` - `{string}`: The name of the primary palette to use in the theme.<br/>
	   * - `primaryHues` - `{object=}`: Override hues for primary palette.<br/>
	   * - `accent` - `{string}`: The name of the accent palette to use in the theme.<br/>
	   * - `accentHues` - `{object=}`: Override hues for accent palette.<br/>
	   * - `warn` - `{string}`: The name of the warn palette to use in the theme.<br/>
	   * - `warnHues` - `{object=}`: Override hues for warn palette.<br/>
	   * - `background` - `{string}`: The name of the background palette to use in the theme.<br/>
	   * - `backgroundHues` - `{object=}`: Override hues for background palette.<br/>
	   * - `dark` - `{boolean}`: Indicates if it's a dark theme.<br/>
	   * @returns {Promise<string>} A resolved promise with the new theme name.
	   */
	
	  /* @ngInject */
	  function ThemingService($rootScope, $mdUtil, $q, $log) {
	    // Allow us to be invoked via a linking function signature.
	    var applyTheme = function (scope, el) {
	      if (el === undefined) { el = scope; scope = undefined; }
	      if (scope === undefined) { scope = $rootScope; }
	      applyTheme.inherit(el, el);
	    };
	
	    Object.defineProperty(applyTheme, 'THEMES', {
	      get: function () {
	        return angular.extend({}, THEMES);
	      }
	    });
	    Object.defineProperty(applyTheme, 'PALETTES', {
	      get: function () {
	        return angular.extend({}, PALETTES);
	      }
	    });
	    Object.defineProperty(applyTheme, 'ALWAYS_WATCH', {
	      get: function () {
	        return alwaysWatchTheme;
	      }
	    });
	    applyTheme.inherit = inheritTheme;
	    applyTheme.registered = registered;
	    applyTheme.defaultTheme = function() { return defaultTheme; };
	    applyTheme.generateTheme = function(name) { generateTheme(THEMES[name], name, themeConfig.nonce); };
	    applyTheme.defineTheme = function(name, options) {
	      options = options || {};
	
	      var theme = registerTheme(name);
	
	      if (options.primary) {
	        theme.primaryPalette(options.primary, options.primaryHues);
	      }
	      if (options.accent) {
	        theme.accentPalette(options.accent, options.accentHues);
	      }
	      if (options.warn) {
	        theme.warnPalette(options.warn, options.warnHues);
	      }
	      if (options.background) {
	        theme.backgroundPalette(options.background, options.backgroundHues);
	      }
	      if (options.dark){
	        theme.dark();
	      }
	
	      this.generateTheme(name);
	
	      return $q.resolve(name);
	    };
	    applyTheme.setBrowserColor = enableBrowserColor;
	
	    return applyTheme;
	
	    /**
	     * Determine is specified theme name is a valid, registered theme
	     */
	    function registered(themeName) {
	      if (themeName === undefined || themeName === '') return true;
	      return applyTheme.THEMES[themeName] !== undefined;
	    }
	
	    /**
	     * Get theme name for the element, then update with Theme CSS class
	     */
	    function inheritTheme (el, parent) {
	      var ctrl = parent.controller('mdTheme') || el.data('$mdThemeController');
	      var scope = el.scope();
	
	      updateThemeClass(lookupThemeName());
	
	      if (ctrl) {
	        var watchTheme = alwaysWatchTheme ||
	                         ctrl.$shouldWatch ||
	                         $mdUtil.parseAttributeBoolean(el.attr('md-theme-watch'));
	
	        if (watchTheme || ctrl.isAsyncTheme) {
	          var clearNameWatcher = function () {
	            if (unwatch) {
	              unwatch();
	              unwatch = undefined;
	            }
	          };
	
	          var unwatch = ctrl.registerChanges(function(name) {
	            updateThemeClass(name);
	
	            if (!watchTheme) {
	              clearNameWatcher();
	            }
	          });
	
	          if (scope) {
	            scope.$on('$destroy', clearNameWatcher);
	          } else {
	            el.on('$destroy', clearNameWatcher);
	          }
	        }
	      }
	
	      /**
	       * Find the theme name from the parent controller or element data
	       */
	      function lookupThemeName() {
	        // As a few components (dialog) add their controllers later, we should also watch for a controller init.
	        return ctrl && ctrl.$mdTheme || (defaultTheme === 'default' ? '' : defaultTheme);
	      }
	
	      /**
	       * Remove old theme class and apply a new one
	       * NOTE: if not a valid theme name, then the current name is not changed
	       */
	      function updateThemeClass(theme) {
	        if (!theme) return;
	        if (!registered(theme)) {
	          $log.warn('Attempted to use unregistered theme \'' + theme + '\'. ' +
	                    'Register it with $mdThemingProvider.theme().');
	        }
	
	        var oldTheme = el.data('$mdThemeName');
	        if (oldTheme) el.removeClass('md-' + oldTheme +'-theme');
	        el.addClass('md-' + theme + '-theme');
	        el.data('$mdThemeName', theme);
	        if (ctrl) {
	          el.data('$mdThemeController', ctrl);
	        }
	      }
	    }
	
	  }
	}
	
	function ThemingDirective($mdTheming, $interpolate, $parse, $mdUtil, $q, $log) {
	  return {
	    priority: 101, // has to be more than 100 to be before interpolation (issue on IE)
	    link: {
	      pre: function(scope, el, attrs) {
	        var registeredCallbacks = [];
	
	        var startSymbol = $interpolate.startSymbol();
	        var endSymbol = $interpolate.endSymbol();
	
	        var theme = attrs.mdTheme.trim();
	
	        var hasInterpolation =
	          theme.substr(0, startSymbol.length) === startSymbol &&
	          theme.lastIndexOf(endSymbol) === theme.length - endSymbol.length;
	
	        var oneTimeOperator = '::';
	        var oneTimeBind = attrs.mdTheme
	            .split(startSymbol).join('')
	            .split(endSymbol).join('')
	            .trim()
	            .substr(0, oneTimeOperator.length) === oneTimeOperator;
	
	        var getTheme = function () {
	          var interpolation = $interpolate(attrs.mdTheme)(scope);
	          return $parse(interpolation)(scope) || interpolation;
	        };
	
	        var ctrl = {
	          isAsyncTheme: angular.isFunction(getTheme()) || angular.isFunction(getTheme().then),
	          registerChanges: function (cb, context) {
	            if (context) {
	              cb = angular.bind(context, cb);
	            }
	
	            registeredCallbacks.push(cb);
	
	            return function () {
	              var index = registeredCallbacks.indexOf(cb);
	
	              if (index > -1) {
	                registeredCallbacks.splice(index, 1);
	              }
	            };
	          },
	          $setTheme: function (theme) {
	            if (!$mdTheming.registered(theme)) {
	              $log.warn('attempted to use unregistered theme \'' + theme + '\'');
	            }
	
	            ctrl.$mdTheme = theme;
	
	            // Iterating backwards to support unregistering during iteration
	            // http://stackoverflow.com/a/9882349/890293
	            // we don't use `reverse()` of array because it mutates the array and we don't want it
	            // to get re-indexed
	            for (var i = registeredCallbacks.length; i--;) {
	              registeredCallbacks[i](theme);
	            }
	          },
	          $shouldWatch: $mdUtil.parseAttributeBoolean(el.attr('md-theme-watch')) ||
	                        $mdTheming.ALWAYS_WATCH ||
	                        (hasInterpolation && !oneTimeBind)
	        };
	
	        el.data('$mdThemeController', ctrl);
	
	        var setParsedTheme = function (theme) {
	          if (typeof theme === 'string') {
	            return ctrl.$setTheme(theme);
	          }
	
	          $q.when(angular.isFunction(theme) ?  theme() : theme)
	            .then(function(name) {
	              ctrl.$setTheme(name);
	            });
	        };
	
	        setParsedTheme(getTheme());
	
	        var unwatch = scope.$watch(getTheme, function(theme) {
	          if (theme) {
	            setParsedTheme(theme);
	
	            if (!ctrl.$shouldWatch) {
	              unwatch();
	            }
	          }
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Special directive that will disable ALL runtime Theme style generation and DOM injection
	 *
	 * <link rel="stylesheet" href="angular-material.min.css">
	 * <link rel="stylesheet" href="angular-material.themes.css">
	 *
	 * <body md-themes-disabled>
	 *  ...
	 * </body>
	 *
	 * Note: Using md-themes-css directive requires the developer to load external
	 * theme stylesheets; e.g. custom themes from Material-Tools:
	 *
	 *       `angular-material.themes.css`
	 *
	 * Another option is to use the ThemingProvider to configure and disable the attribute
	 * conversions; this would obviate the use of the `md-themes-css` directive
	 *
	 */
	function disableThemesDirective() {
	  themeConfig.disableTheming = true;
	
	  // Return a 1x-only, first-match attribute directive
	  return {
	    restrict : 'A',
	    priority : '900'
	  };
	}
	
	function ThemableDirective($mdTheming) {
	  return $mdTheming;
	}
	
	function parseRules(theme, colorType, rules) {
	  checkValidPalette(theme, colorType);
	
	  rules = rules.replace(/THEME_NAME/g, theme.name);
	  var themeNameRegex = new RegExp('\\.md-' + theme.name + '-theme', 'g');
	  // Matches '{{ primary-color }}', etc
	  var hueRegex = new RegExp('([\'"])?{{\\s*([a-zA-Z]+)-?(color|default)?-?(contrast)?-?((?:\\d\\.?\\d*)|(?:[a-zA-Z]+))?\\s*}}(["\'])?','g');
	  var simpleVariableRegex = /'?"?{{\s*([a-zA-Z]+)-(A?\d+|hue-[0-3]|shadow|default)-?(contrast)?-?((?:\d\.?\d*)|(?:[a-zA-Z]+))?\s*}}'?"?/g;
	  var defaultBgHue = theme.colors['background'].hues['default'];
	  var defaultBgContrastType = PALETTES[theme.colors['background'].name][defaultBgHue].contrastType;
	
	  // find and replace simple variables where we use a specific hue, not an entire palette
	  // eg. "{{primary-100}}"
	  // \(' + THEME_COLOR_TYPES.join('\|') + '\)'
	  rules = rules.replace(simpleVariableRegex, function(match, colorType, hue, contrast, opacity) {
	    var regexColorType = colorType;
	    if (colorType === 'foreground') {
	      if (hue === 'shadow') {
	        return theme.foregroundShadow;
	      } else if (theme.foregroundPalette[hue]) {
	        // Use user defined palette number (ie: foreground-2)
	        return rgba(colorToRgbaArray(theme.foregroundPalette[hue]));
	      } else if (theme.foregroundPalette['1']){
	        return rgba(colorToRgbaArray(theme.foregroundPalette['1']));
	      }
	      // Default to background-default-contrast-{opacity}
	      colorType = 'background';
	      contrast = 'contrast';
	      if (!opacity && hue) {
	        // Convert references to legacy hues to opacities (i.e. foreground-4 to *-divider)
	        switch (hue) {
	          // hue-1 uses default opacity
	          case '2':
	            opacity = 'secondary';
	            break;
	          case '3':
	            opacity = 'disabled';
	            break;
	          case '4':
	            opacity = 'divider';
	        }
	      }
	      hue = 'default';
	    }
	
	    // `default` is also accepted as a hue-value, because the background palettes are
	    // using it as a name for the default hue.
	    if (hue.indexOf('hue') === 0 || hue === 'default') {
	      hue = theme.colors[colorType].hues[hue];
	    }
	
	    var colorDetails = (PALETTES[ theme.colors[colorType].name ][hue] || '');
	
	    // If user has specified a foreground color, use those
	    if (colorType === 'background' && contrast && regexColorType !== 'foreground' &&
	        colorDetails.contrastType === defaultBgContrastType) {
	      // Don't process if colorType was changed
	      switch (opacity) {
	        case 'secondary':
	        case 'icon':
	          if (theme.foregroundPalette['2']) {
	            return rgba(colorToRgbaArray(theme.foregroundPalette['2']));
	          }
	          break;
	        case 'disabled':
	        case 'hint':
	          if (theme.foregroundPalette['3']) {
	            return rgba(colorToRgbaArray(theme.foregroundPalette['3']));
	          }
	          break;
	        case 'divider':
	          if (theme.foregroundPalette['4']) {
	            return rgba(colorToRgbaArray(theme.foregroundPalette['4']));
	          }
	          break;
	        default:
	          if (theme.foregroundPalette['1']) {
	            return rgba(colorToRgbaArray(theme.foregroundPalette['1']));
	          }
	          break;
	      }
	    }
	
	    if (contrast && opacity) {
	      opacity = colorDetails.opacity[opacity] || opacity;
	    }
	
	    return rgba(colorDetails[contrast ? 'contrast' : 'value'], opacity);
	  });
	
	  var generatedRules = [];
	
	  // For each type, generate rules for each hue (ie. default, md-hue-1, md-hue-2, md-hue-3)
	  angular.forEach(['default', 'hue-1', 'hue-2', 'hue-3'], function(hueName) {
	    var newRule = rules
	      .replace(hueRegex, function(match, _, matchedColorType, hueType, contrast, opacity) {
	        var color = theme.colors[matchedColorType];
	        var palette = PALETTES[color.name];
	        var hueValue = color.hues[hueName];
	        if (contrast && opacity) {
	          opacity = palette[hueValue].opacity[opacity] || opacity;
	        }
	        return rgba(palette[hueValue][hueType === 'color' ? 'value' : 'contrast'], opacity);
	      });
	    if (hueName !== 'default') {
	      newRule = newRule.replace(themeNameRegex, '.md-' + theme.name + '-theme.md-' + hueName);
	    }
	
	    // Don't apply a selector rule to the default theme, making it easier to override
	    // styles of the base-component
	    if (theme.name === 'default') {
	      var themeRuleRegex = /((?:\s|>|\.|\w|-|:|\(|\)|\[|]|"|'|=)*)\.md-default-theme((?:\s|>|\.|\w|-|:|\(|\)|\[|]|"|'|=)*)/g;
	
	      newRule = newRule.replace(themeRuleRegex, function(match, start, end) {
	        return match + ', ' + start + end;
	      });
	    }
	    generatedRules.push(newRule);
	  });
	
	  return generatedRules;
	}
	
	var rulesByType = {};
	
	// Generate our themes at run time given the state of THEMES and PALETTES
	function generateAllThemes($injector, $mdTheming) {
	  var head = document.head;
	  var firstChild = head ? head.firstElementChild : null;
	  var themeCss = !themeConfig.disableTheming && $injector.has('$MD_THEME_CSS') ? $injector.get('$MD_THEME_CSS') : '';
	
	  // Append our custom registered styles to the theme stylesheet.
	  themeCss += themeConfig.registeredStyles.join('');
	
	  if (!firstChild) return;
	  if (themeCss.length === 0) return; // no rules, so no point in running this expensive task
	
	  // Expose contrast colors for palettes to ensure that text is always readable
	  angular.forEach(PALETTES, sanitizePalette);
	
	  // MD_THEME_CSS is a string generated by the build process that includes all the themeable
	  // components as templates
	
	  // Break the CSS into individual rules
	  var rules = splitCss(themeCss).map(function(rule) {
	    return rule.trim();
	  });
	
	  THEME_COLOR_TYPES.forEach(function(type) {
	    rulesByType[type] = '';
	  });
	
	  // Sort the rules based on type, allowing us to do color substitution on a per-type basis
	  rules.forEach(function(rule) {
	    // First: test that if the rule has '.md-accent', it goes into the accent set of rules
	    for (var i = 0, type; type = THEME_COLOR_TYPES[i]; i++) {
	      if (rule.indexOf('.md-' + type) > -1) {
	        return rulesByType[type] += rule;
	      }
	    }
	
	    // If no eg 'md-accent' class is found, try to just find 'accent' in the rule and guess from
	    // there
	    for (i = 0; type = THEME_COLOR_TYPES[i]; i++) {
	      if (rule.indexOf(type) > -1) {
	        return rulesByType[type] += rule;
	      }
	    }
	
	    // Default to the primary array
	    return rulesByType[DEFAULT_COLOR_TYPE] += rule;
	  });
	
	  // If themes are being generated on-demand, quit here. The user will later manually
	  // call generateTheme to do this on a theme-by-theme basis.
	  if (themeConfig.generateOnDemand) return;
	
	  angular.forEach($mdTheming.THEMES, function(theme) {
	    if (!GENERATED[theme.name] && !($mdTheming.defaultTheme() !== 'default' && theme.name === 'default')) {
	      generateTheme(theme, theme.name, themeConfig.nonce);
	    }
	  });
	
	
	  // *************************
	  // Internal functions
	  // *************************
	
	  /**
	   * The user specifies a 'default' contrast color as either light or dark, then explicitly lists
	   * which hues are the opposite contrast (eg. A100 has dark, A200 has light).
	   * @param {!object} palette to sanitize
	   */
	  function sanitizePalette(palette) {
	    var defaultContrast = palette.contrastDefaultColor;
	    var lightColors = palette.contrastLightColors || [];
	    var strongLightColors = palette.contrastStrongLightColors || [];
	    var darkColors = palette.contrastDarkColors || [];
	
	    // These colors are provided as space-separated lists
	    if (typeof lightColors === 'string') lightColors = lightColors.split(' ');
	    if (typeof strongLightColors === 'string') strongLightColors = strongLightColors.split(' ');
	    if (typeof darkColors === 'string') darkColors = darkColors.split(' ');
	
	    // Cleanup after ourselves
	    delete palette.contrastDefaultColor;
	    delete palette.contrastLightColors;
	    delete palette.contrastStrongLightColors;
	    delete palette.contrastDarkColors;
	
	    /**
	     * @param {string} hueName
	     * @return {'dark'|'light'|'strongLight'}
	     */
	    function getContrastType(hueName) {
	      if (defaultContrast === 'light' ? darkColors.indexOf(hueName) !== -1  :
	        (lightColors.indexOf(hueName) === -1 && strongLightColors.indexOf(hueName) === -1)) {
	        return 'dark';
	      }
	      if (strongLightColors.indexOf(hueName) !== -1) {
	        return 'strongLight';
	      }
	      return 'light';
	    }
	
	    /**
	     * @param {'dark'|'light'|'strongLight'} contrastType
	     * @return {[number, number, number]} [red, green, blue] array
	     */
	    function getContrastColor(contrastType) {
	      switch (contrastType) {
	        default:
	        case 'strongLight':
	          return STRONG_LIGHT_CONTRAST_COLOR;
	        case 'light':
	          return LIGHT_CONTRAST_COLOR;
	        case 'dark':
	          return DARK_CONTRAST_COLOR;
	      }
	    }
	
	    /**
	     * @param {'dark'|'light'|'strongLight'} contrastType
	     * @return {{secondary: number, divider: number, hint: number, icon: number, disabled: number}}
	     */
	    function getOpacityValues(contrastType) {
	      switch (contrastType) {
	        default:
	        case 'strongLight':
	          return STRONG_LIGHT_CONTRAST_OPACITY;
	        case 'light':
	          return LIGHT_CONTRAST_OPACITY;
	        case 'dark':
	          return DARK_CONTRAST_OPACITY;
	      }
	    }
	    // Change { 'A100': '#fffeee' } to { 'A100': { value: '#fffeee', contrast:DARK_CONTRAST_COLOR }
	    angular.forEach(palette, function(hueValue, hueName) {
	      if (angular.isObject(hueValue)) return; // Already converted
	      // Map everything to rgb colors
	      var rgbValue = colorToRgbaArray(hueValue);
	      if (!rgbValue) {
	        throw new Error("Color %1, in palette %2's hue %3, is invalid. Hex or rgb(a) color expected."
	                        .replace('%1', hueValue)
	                        .replace('%2', palette.name)
	                        .replace('%3', hueName));
	      }
	
	      var contrastType = getContrastType(hueName);
	      palette[hueName] = {
	        hex: palette[hueName],
	        value: rgbValue,
	        contrastType: contrastType,
	        contrast: getContrastColor(contrastType),
	        opacity: getOpacityValues(contrastType)
	      };
	    });
	  }
	
	  /**
	   * @param {string} themeCss
	   * @returns {[]} a string representing a CSS file that is split, producing an array with a rule
	   *  at each index.
	   */
	  function splitCss(themeCss) {
	    var result = [];
	    var currentRule = '';
	    var openedCurlyBrackets = 0;
	    var closedCurlyBrackets = 0;
	
	    for (var i = 0; i < themeCss.length; i++) {
	      var character = themeCss.charAt(i);
	
	      // Check for content in quotes
	      if (character === '\'' || character === '"') {
	        // Append text in quotes to current rule
	        var textInQuotes = themeCss.substring(i, themeCss.indexOf(character, i + 1));
	        currentRule += textInQuotes;
	
	        // Jump to the closing quote char
	        i += textInQuotes.length;
	      } else {
	        currentRule += character;
	
	        if (character === '}') {
	          closedCurlyBrackets++;
	          if (closedCurlyBrackets === openedCurlyBrackets) {
	            closedCurlyBrackets = 0;
	            openedCurlyBrackets = 0;
	            result.push(currentRule);
	            currentRule = '';
	          }
	        } else if (character === '{') {
	          openedCurlyBrackets++;
	        }
	      }
	    }
	    // Add comments added after last valid rule.
	    if (currentRule !== '') {
	      result.push(currentRule);
	    }
	
	    return result;
	  }
	}
	
	function generateTheme(theme, name, nonce) {
	  var head = document.head;
	  var firstChild = head ? head.firstElementChild : null;
	
	  if (!GENERATED[name]) {
	    // For each theme, use the color palettes specified for
	    // `primary`, `warn` and `accent` to generate CSS rules.
	    THEME_COLOR_TYPES.forEach(function(colorType) {
	      var styleStrings = parseRules(theme, colorType, rulesByType[colorType]);
	      while (styleStrings.length) {
	        var styleContent = styleStrings.shift();
	        if (styleContent) {
	          var style = document.createElement('style');
	          style.setAttribute('md-theme-style', '');
	          if (nonce) {
	            style.setAttribute('nonce', nonce);
	          }
	          style.appendChild(document.createTextNode(styleContent));
	          head.insertBefore(style, firstChild);
	        }
	      }
	    });
	
	    GENERATED[theme.name] = true;
	  }
	
	}
	
	
	function checkValidPalette(theme, colorType) {
	  // If theme attempts to use a palette that doesnt exist, throw error
	  if (!PALETTES[ (theme.colors[colorType] || {}).name ]) {
	    throw new Error(
	      "You supplied an invalid color palette for theme %1's %2 palette. Available palettes: %3"
	                    .replace('%1', theme.name)
	                    .replace('%2', colorType)
	                    .replace('%3', Object.keys(PALETTES).join(', '))
	    );
	  }
	}
	
	/**
	 * @param {string} clr rbg or rgba color
	 * @return {number[]|undefined} [red, green, blue] array if it can be computed
	 */
	function colorToRgbaArray(clr) {
	  if (angular.isArray(clr) && clr.length === 3) return clr;
	  if (/^rgb/.test(clr)) {
	    return clr.replace(/(^\s*rgba?\(|\)\s*$)/g, '').split(',').map(function(value, i) {
	      return i === 3 ? parseFloat(value) : parseInt(value, 10);
	    });
	  }
	  if (clr.charAt(0) === '#') clr = clr.substring(1);
	  if (!/^([a-fA-F0-9]{3}){1,2}$/g.test(clr)) return;
	
	  var dig = clr.length / 3;
	  var red = clr.substr(0, dig);
	  var grn = clr.substr(dig, dig);
	  var blu = clr.substr(dig * 2);
	  if (dig === 1) {
	    red += red;
	    grn += grn;
	    blu += blu;
	  }
	  return [parseInt(red, 16), parseInt(grn, 16), parseInt(blu, 16)];
	}
	
	function rgba(rgbArray, opacity) {
	  if (!rgbArray) return "rgb('0,0,0')";
	
	  if (rgbArray.length === 4) {
	    rgbArray = angular.copy(rgbArray);
	    opacity ? rgbArray.pop() : opacity = rgbArray.pop();
	  }
	  return opacity && (typeof opacity == 'number' || (typeof opacity == 'string' && opacity.length)) ?
	    'rgba(' + rgbArray.join(',') + ',' + opacity + ')' :
	    'rgb(' + rgbArray.join(',') + ')';
	}
	
	
	})(window.angular);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.autocomplete
	 */
	/*
	 * @see js folder for autocomplete implementation
	 */
	angular.module('material.components.autocomplete', [
	  'material.core',
	  'material.components.icon',
	  'material.components.virtualRepeat'
	]);
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocompleteCtrl.$inject = ["$scope", "$element", "$mdUtil", "$mdConstant", "$mdTheming", "$window", "$animate", "$rootElement", "$attrs", "$q", "$log", "$mdLiveAnnouncer"];angular
	    .module('material.components.autocomplete')
	    .controller('MdAutocompleteCtrl', MdAutocompleteCtrl);
	
	var ITEM_HEIGHT   = 48,
	    MAX_ITEMS     = 5,
	    MENU_PADDING  = 8,
	    INPUT_PADDING = 2, // Padding provided by `md-input-container`
	    MODE_STANDARD = 'standard',
	    MODE_VIRTUAL = 'virtual';
	
	function MdAutocompleteCtrl ($scope, $element, $mdUtil, $mdConstant, $mdTheming, $window,
	                             $animate, $rootElement, $attrs, $q, $log, $mdLiveAnnouncer) {
	
	  // Internal Variables.
	  var ctrl                 = this,
	      itemParts            = $scope.itemsExpr.split(/ in /i),
	      itemExpr             = itemParts[ 1 ],
	      elements             = null,
	      cache                = {},
	      noBlur               = false,
	      selectedItemWatchers = [],
	      hasFocus             = false,
	      fetchesInProgress    = 0,
	      enableWrapScroll     = null,
	      inputModelCtrl       = null,
	      debouncedOnResize    = $mdUtil.debounce(onWindowResize),
	      mode                 = MODE_VIRTUAL; // default
	
	  /**
	   * The root document element. This is used for attaching a top-level click handler to
	   * close the options panel when a click outside said panel occurs. We use `documentElement`
	   * instead of body because, when scrolling is disabled, some browsers consider the body element
	   * to be completely off the screen and propagate events directly to the html element.
	   * @type {!Object} angular.JQLite
	   */
	  ctrl.documentElement = angular.element(document.documentElement);
	
	  // Public Exported Variables with handlers
	  defineProperty('hidden', handleHiddenChange, true);
	
	  // Public Exported Variables
	  ctrl.scope = $scope;
	  ctrl.parent = $scope.$parent;
	  ctrl.itemName = itemParts[0];
	  ctrl.matches = [];
	  ctrl.loading = false;
	  ctrl.hidden = true;
	  ctrl.index = -1;
	  ctrl.activeOption = null;
	  ctrl.id = $mdUtil.nextUid();
	  ctrl.isDisabled = null;
	  ctrl.isRequired = null;
	  ctrl.isReadonly = null;
	  ctrl.hasNotFound = false;
	  ctrl.selectedMessage = $scope.selectedMessage || 'selected';
	  ctrl.noMatchMessage = $scope.noMatchMessage || 'There are no matches available.';
	  ctrl.singleMatchMessage = $scope.singleMatchMessage || 'There is 1 match available.';
	  ctrl.multipleMatchStartMessage = $scope.multipleMatchStartMessage || 'There are ';
	  ctrl.multipleMatchEndMessage = $scope.multipleMatchEndMessage || ' matches available.';
	  ctrl.defaultEscapeOptions = 'clear';
	
	  // Public Exported Methods
	  ctrl.keydown = keydown;
	  ctrl.blur = blur;
	  ctrl.focus = focus;
	  ctrl.clear = clearValue;
	  ctrl.select = select;
	  ctrl.listEnter = onListEnter;
	  ctrl.listLeave = onListLeave;
	  ctrl.focusInput = focusInputElement;
	  ctrl.getCurrentDisplayValue = getCurrentDisplayValue;
	  ctrl.registerSelectedItemWatcher = registerSelectedItemWatcher;
	  ctrl.unregisterSelectedItemWatcher = unregisterSelectedItemWatcher;
	  ctrl.notFoundVisible = notFoundVisible;
	  ctrl.loadingIsVisible = loadingIsVisible;
	  ctrl.positionDropdown = positionDropdown;
	
	  /**
	   * Report types to be used for the $mdLiveAnnouncer
	   * @enum {number} Unique flag id.
	   */
	  var ReportType = {
	    Count: 1,
	    Selected: 2
	  };
	
	  return init();
	
	  // initialization methods
	
	  /**
	   * Initialize the controller, setup watchers, gather elements
	   */
	  function init () {
	
	    $mdUtil.initOptionalProperties($scope, $attrs, {
	      searchText: '',
	      selectedItem: null,
	      clearButton: false,
	      disableVirtualRepeat: false,
	    });
	
	    $mdTheming($element);
	    configureWatchers();
	    $mdUtil.nextTick(function () {
	
	      gatherElements();
	      moveDropdown();
	
	      // Touch devices often do not send a click event on tap. We still want to focus the input
	      // and open the options pop-up in these cases.
	      $element.on('touchstart', focusInputElement);
	
	      // Forward all focus events to the input element when autofocus is enabled
	      if ($scope.autofocus) {
	        $element.on('focus', focusInputElement);
	      }
	      if ($scope.inputAriaDescribedBy) {
	        elements.input.setAttribute('aria-describedby', $scope.inputAriaDescribedBy);
	      }
	      if (!$scope.floatingLabel) {
	        if ($scope.inputAriaLabel) {
	          elements.input.setAttribute('aria-label', $scope.inputAriaLabel);
	        } else if ($scope.inputAriaLabelledBy) {
	          elements.input.setAttribute('aria-labelledby', $scope.inputAriaLabelledBy);
	        } else if ($scope.placeholder) {
	          // If no aria-label or aria-labelledby references are defined, then just label using the
	          // placeholder.
	          elements.input.setAttribute('aria-label', $scope.placeholder);
	        }
	      }
	    });
	  }
	
	  function updateModelValidators() {
	    if (!$scope.requireMatch || !inputModelCtrl) return;
	
	    inputModelCtrl.$setValidity('md-require-match', !!$scope.selectedItem || !$scope.searchText);
	  }
	
	  /**
	   * Calculates the dropdown's position and applies the new styles to the menu element
	   * @returns {*}
	   */
	  function positionDropdown () {
	    if (!elements) {
	      return $mdUtil.nextTick(positionDropdown, false, $scope);
	    }
	
	    var dropdownHeight = ($scope.dropdownItems || MAX_ITEMS) * ITEM_HEIGHT;
	    var hrect  = elements.wrap.getBoundingClientRect(),
	        vrect  = elements.snap.getBoundingClientRect(),
	        root   = elements.root.getBoundingClientRect(),
	        top    = vrect.bottom - root.top,
	        bot    = root.bottom - vrect.top,
	        left   = hrect.left - root.left,
	        width  = hrect.width,
	        offset = getVerticalOffset(),
	        position = $scope.dropdownPosition,
	        styles, enoughBottomSpace, enoughTopSpace;
	    var bottomSpace = root.bottom - vrect.bottom - MENU_PADDING + $mdUtil.getViewportTop();
	    var topSpace = vrect.top - MENU_PADDING;
	
	    // Automatically determine dropdown placement based on available space in viewport.
	    if (!position) {
	      enoughTopSpace = topSpace > dropdownHeight;
	      enoughBottomSpace = bottomSpace > dropdownHeight;
	      if (enoughBottomSpace) {
	        position = 'bottom';
	      } else if (enoughTopSpace) {
	        position = 'top';
	      } else {
	        position = topSpace > bottomSpace ? 'top' : 'bottom';
	      }
	    }
	    // Adjust the width to account for the padding provided by `md-input-container`
	    if ($attrs.mdFloatingLabel) {
	      left += INPUT_PADDING;
	      width -= INPUT_PADDING * 2;
	    }
	    styles = {
	      left:     left + 'px',
	      minWidth: width + 'px',
	      maxWidth: Math.max(hrect.right - root.left, root.right - hrect.left) - MENU_PADDING + 'px'
	    };
	
	    if (position === 'top') {
	      styles.top       = 'auto';
	      styles.bottom    = bot + 'px';
	      styles.maxHeight = Math.min(dropdownHeight, topSpace) + 'px';
	    } else {
	      bottomSpace = root.bottom - hrect.bottom - MENU_PADDING + $mdUtil.getViewportTop();
	
	      styles.top       = (top - offset) + 'px';
	      styles.bottom    = 'auto';
	      styles.maxHeight = Math.min(dropdownHeight, bottomSpace) + 'px';
	    }
	
	    elements.$.scrollContainer.css(styles);
	    $mdUtil.nextTick(correctHorizontalAlignment, false, $scope);
	
	    /**
	     * Calculates the vertical offset for floating label examples to account for ngMessages
	     * @returns {number}
	     */
	    function getVerticalOffset () {
	      var offset = 0;
	      var inputContainer = $element.find('md-input-container');
	      if (inputContainer.length) {
	        var input = inputContainer.find('input');
	        offset = inputContainer.prop('offsetHeight');
	        offset -= input.prop('offsetTop');
	        offset -= input.prop('offsetHeight');
	        // add in the height left up top for the floating label text
	        offset += inputContainer.prop('offsetTop');
	      }
	      return offset;
	    }
	
	    /**
	     * Makes sure that the menu doesn't go off of the screen on either side.
	     */
	    function correctHorizontalAlignment () {
	      var dropdown = elements.scrollContainer.getBoundingClientRect(),
	          styles   = {};
	      if (dropdown.right > root.right) {
	        styles.left = (hrect.right - dropdown.width) + 'px';
	      }
	      elements.$.scrollContainer.css(styles);
	    }
	  }
	
	  /**
	   * Moves the dropdown menu to the body tag in order to avoid z-index and overflow issues.
	   */
	  function moveDropdown () {
	    if (!elements.$.root.length) return;
	    $mdTheming(elements.$.scrollContainer);
	    elements.$.scrollContainer.detach();
	    elements.$.root.append(elements.$.scrollContainer);
	    if ($animate.pin) $animate.pin(elements.$.scrollContainer, $rootElement);
	  }
	
	  /**
	   * Sends focus to the input element.
	   */
	  function focusInputElement () {
	    elements.input.focus();
	  }
	
	  /**
	   * Update the activeOption based on the selected item in the listbox.
	   * The activeOption is used in the template to set the aria-activedescendant attribute, which
	   * enables screen readers to properly handle visual focus within the listbox and announce the
	   * item's place in the list. I.e. "List item 3 of 50". Anytime that `ctrl.index` changes, this
	   * function needs to be called to update the activeOption.
	   */
	  function updateActiveOption() {
	    var selectedOption = elements.scroller.querySelector('.selected');
	    if (selectedOption) {
	      ctrl.activeOption = selectedOption.id;
	    } else {
	      ctrl.activeOption = null;
	    }
	  }
	
	  /**
	   * Sets up any watchers used by autocomplete
	   */
	  function configureWatchers () {
	    var wait = parseInt($scope.delay, 10) || 0;
	
	    $attrs.$observe('disabled', function (value) { ctrl.isDisabled = $mdUtil.parseAttributeBoolean(value, false); });
	    $attrs.$observe('required', function (value) { ctrl.isRequired = $mdUtil.parseAttributeBoolean(value, false); });
	    $attrs.$observe('readonly', function (value) { ctrl.isReadonly = $mdUtil.parseAttributeBoolean(value, false); });
	
	    $scope.$watch('searchText', wait ? $mdUtil.debounce(handleSearchText, wait) : handleSearchText);
	    $scope.$watch('selectedItem', selectedItemChange);
	
	    angular.element($window).on('resize', debouncedOnResize);
	
	    $scope.$on('$destroy', cleanup);
	  }
	
	  /**
	   * Removes any events or leftover elements created by this controller
	   */
	  function cleanup () {
	    if (!ctrl.hidden) {
	      $mdUtil.enableScrolling();
	    }
	
	    angular.element($window).off('resize', debouncedOnResize);
	
	    if (elements){
	      var items = ['ul', 'scroller', 'scrollContainer', 'input'];
	      angular.forEach(items, function(key){
	        elements.$[key].remove();
	      });
	    }
	  }
	
	  /**
	   * Event handler to be called whenever the window resizes.
	   */
	  function onWindowResize() {
	    if (!ctrl.hidden) {
	      positionDropdown();
	    }
	  }
	
	  /**
	   * Gathers all of the elements needed for this controller
	   */
	  function gatherElements () {
	
	    var snapWrap = gatherSnapWrap();
	
	    elements = {
	      main:  $element[0],
	      scrollContainer: $element[0].querySelector('.md-virtual-repeat-container, .md-standard-list-container'),
	      scroller: $element[0].querySelector('.md-virtual-repeat-scroller, .md-standard-list-scroller'),
	      ul:    $element.find('ul')[0],
	      input: $element.find('input')[0],
	      wrap:  snapWrap.wrap,
	      snap:  snapWrap.snap,
	      root:  document.body,
	    };
	
	    elements.li   = elements.ul.getElementsByTagName('li');
	    elements.$    = getAngularElements(elements);
	    mode = elements.scrollContainer.classList.contains('md-standard-list-container') ? MODE_STANDARD : MODE_VIRTUAL;
	    inputModelCtrl = elements.$.input.controller('ngModel');
	  }
	
	  /**
	   * Gathers the snap and wrap elements
	   *
	   */
	  function gatherSnapWrap() {
	    var element;
	    var value;
	    for (element = $element; element.length; element = element.parent()) {
	      value = element.attr('md-autocomplete-snap');
	      if (angular.isDefined(value)) break;
	    }
	
	    if (element.length) {
	      return {
	        snap: element[0],
	        wrap: (value.toLowerCase() === 'width') ? element[0] : $element.find('md-autocomplete-wrap')[0]
	      };
	    }
	
	    var wrap = $element.find('md-autocomplete-wrap')[0];
	    return {
	      snap: wrap,
	      wrap: wrap
	    };
	  }
	
	  /**
	   * Gathers angular-wrapped versions of each element
	   * @param elements
	   * @returns {{}}
	   */
	  function getAngularElements (elements) {
	    var obj = {};
	    for (var key in elements) {
	      if (elements.hasOwnProperty(key)) obj[ key ] = angular.element(elements[ key ]);
	    }
	    return obj;
	  }
	
	  // event/change handlers
	
	  /**
	   * @param {Event} $event
	   */
	  function preventDefault($event) {
	    $event.preventDefault();
	  }
	
	  /**
	   * @param {Event} $event
	   */
	  function stopPropagation($event) {
	    $event.stopPropagation();
	  }
	
	  /**
	   * Handles changes to the `hidden` property.
	   * @param {boolean} hidden true to hide the options pop-up, false to show it.
	   * @param {boolean} oldHidden the previous value of hidden
	   */
	  function handleHiddenChange (hidden, oldHidden) {
	    var scrollContainerElement;
	
	    if (elements) {
	      scrollContainerElement = angular.element(elements.scrollContainer);
	    }
	    if (!hidden && oldHidden) {
	      positionDropdown();
	
	      // Report in polite mode, because the screen reader should finish the default description of
	      // the input element.
	      reportMessages(true, ReportType.Count | ReportType.Selected);
	
	      if (elements) {
	        $mdUtil.disableScrollAround(elements.scrollContainer);
	        enableWrapScroll = disableElementScrollEvents(elements.wrap);
	        if ($mdUtil.isIos) {
	          ctrl.documentElement.on('touchend', handleTouchOutsidePanel);
	          if (scrollContainerElement) {
	            scrollContainerElement.on('touchstart touchmove touchend', stopPropagation);
	          }
	        }
	        ctrl.index = getDefaultIndex();
	        $mdUtil.nextTick(function() {
	          updateActiveOption();
	          updateScroll();
	        });
	      }
	    } else if (hidden && !oldHidden) {
	      if ($mdUtil.isIos) {
	        ctrl.documentElement.off('touchend', handleTouchOutsidePanel);
	        if (scrollContainerElement) {
	          scrollContainerElement.off('touchstart touchmove touchend', stopPropagation);
	        }
	      }
	      $mdUtil.enableScrolling();
	
	      if (enableWrapScroll) {
	        enableWrapScroll();
	        enableWrapScroll = null;
	      }
	    }
	  }
	
	  /**
	   * Handling touch events that bubble up to the document is required for closing the dropdown
	   * panel on touch outside of the options pop-up panel on iOS.
	   * @param {Event} $event
	   */
	  function handleTouchOutsidePanel($event) {
	    ctrl.hidden = true;
	    // iOS does not blur the pop-up for touches on the scroll mask, so we have to do it.
	    doBlur(true);
	  }
	
	  /**
	   * Disables scrolling for a specific element.
	   * @param {!string|!DOMElement} element to disable scrolling
	   * @return {Function} function to call to re-enable scrolling for the element
	   */
	  function disableElementScrollEvents(element) {
	    var elementToDisable = angular.element(element);
	    elementToDisable.on('wheel touchmove', preventDefault);
	
	    return function() {
	      elementToDisable.off('wheel touchmove', preventDefault);
	    };
	  }
	
	  /**
	   * When the user mouses over the dropdown menu, ignore blur events.
	   */
	  function onListEnter () {
	    noBlur = true;
	  }
	
	  /**
	   * When the user's mouse leaves the menu, blur events may hide the menu again.
	   */
	  function onListLeave () {
	    if (!hasFocus && !ctrl.hidden) elements.input.focus();
	    noBlur = false;
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * Handles changes to the selected item.
	   * @param selectedItem
	   * @param previousSelectedItem
	   */
	  function selectedItemChange (selectedItem, previousSelectedItem) {
	
	    updateModelValidators();
	
	    if (selectedItem) {
	      getDisplayValue(selectedItem).then(function (val) {
	        $scope.searchText = val;
	        handleSelectedItemChange(selectedItem, previousSelectedItem);
	      });
	    } else if (previousSelectedItem && $scope.searchText) {
	      getDisplayValue(previousSelectedItem).then(function(displayValue) {
	        // Clear the searchText, when the selectedItem is set to null.
	        // Do not clear the searchText, when the searchText isn't matching with the previous
	        // selected item.
	        if (angular.isString($scope.searchText)
	          && displayValue.toString().toLowerCase() === $scope.searchText.toLowerCase()) {
	          $scope.searchText = '';
	        }
	      });
	    }
	
	    if (selectedItem !== previousSelectedItem) {
	      announceItemChange();
	    }
	  }
	
	  /**
	   * Use the user-defined expression to announce changes each time a new item is selected
	   */
	  function announceItemChange () {
	    angular.isFunction($scope.itemChange) &&
	      $scope.itemChange(getItemAsNameVal($scope.selectedItem));
	  }
	
	  /**
	   * Use the user-defined expression to announce changes each time the search text is changed
	   */
	  function announceTextChange () {
	    angular.isFunction($scope.textChange) && $scope.textChange();
	  }
	
	  /**
	   * Calls any external watchers listening for the selected item.  Used in conjunction with
	   * `registerSelectedItemWatcher`.
	   * @param selectedItem
	   * @param previousSelectedItem
	   */
	  function handleSelectedItemChange (selectedItem, previousSelectedItem) {
	    selectedItemWatchers.forEach(function (watcher) {
	      watcher(selectedItem, previousSelectedItem);
	    });
	  }
	
	  /**
	   * Register a function to be called when the selected item changes.
	   * @param cb
	   */
	  function registerSelectedItemWatcher (cb) {
	    if (selectedItemWatchers.indexOf(cb) === -1) {
	      selectedItemWatchers.push(cb);
	    }
	  }
	
	  /**
	   * Unregister a function previously registered for selected item changes.
	   * @param cb
	   */
	  function unregisterSelectedItemWatcher (cb) {
	    var i = selectedItemWatchers.indexOf(cb);
	    if (i !== -1) {
	      selectedItemWatchers.splice(i, 1);
	    }
	  }
	
	  /**
	   * Handles changes to the searchText property.
	   * @param {string} searchText
	   * @param {string} previousSearchText
	   */
	  function handleSearchText (searchText, previousSearchText) {
	    ctrl.index = getDefaultIndex();
	
	    // do nothing on init
	    if (searchText === previousSearchText) return;
	
	    updateModelValidators();
	
	    getDisplayValue($scope.selectedItem).then(function (val) {
	      // clear selected item if search text no longer matches it
	      if (searchText !== val) {
	        $scope.selectedItem = null;
	
	        // trigger change event if available
	        if (searchText !== previousSearchText) {
	          announceTextChange();
	        }
	
	        // cancel results if search text is not long enough
	        if (!isMinLengthMet()) {
	          ctrl.matches = [];
	
	          setLoading(false);
	          reportMessages(true, ReportType.Count);
	
	        } else {
	          handleQuery();
	        }
	      }
	    });
	
	  }
	
	  /**
	   * Handles input blur event, determines if the dropdown should hide.
	   * @param {Event=} $event
	   */
	  function blur($event) {
	    hasFocus = false;
	
	    if (!noBlur) {
	      ctrl.hidden = shouldHide();
	      evalAttr('ngBlur', { $event: $event });
	    } else if (angular.isObject($event)) {
	      $event.stopImmediatePropagation();
	    }
	  }
	
	  /**
	   * Force blur on input element
	   * @param {boolean} forceBlur
	   */
	  function doBlur(forceBlur) {
	    if (forceBlur) {
	      noBlur = false;
	      hasFocus = false;
	    }
	    elements.input.blur();
	  }
	
	  /**
	   * Handles input focus event, determines if the dropdown should show.
	   */
	  function focus($event) {
	    hasFocus = true;
	
	    if (isSearchable() && isMinLengthMet()) {
	      handleQuery();
	    }
	
	    ctrl.hidden = shouldHide();
	
	    evalAttr('ngFocus', { $event: $event });
	  }
	
	  /**
	   * Handles keyboard input.
	   * @param event
	   */
	  function keydown (event) {
	    switch (event.keyCode) {
	      case $mdConstant.KEY_CODE.DOWN_ARROW:
	        if (ctrl.loading || hasSelection()) return;
	        event.stopPropagation();
	        event.preventDefault();
	        ctrl.index = ctrl.index + 1 > ctrl.matches.length - 1 ? 0 : Math.min(ctrl.index + 1, ctrl.matches.length - 1);
	        $mdUtil.nextTick(updateActiveOption);
	        updateScroll();
	        break;
	      case $mdConstant.KEY_CODE.UP_ARROW:
	        if (ctrl.loading || hasSelection()) return;
	        event.stopPropagation();
	        event.preventDefault();
	        ctrl.index = ctrl.index - 1 < 0 ? ctrl.matches.length - 1 : Math.max(0, ctrl.index - 1);
	        $mdUtil.nextTick(updateActiveOption);
	        updateScroll();
	        break;
	      case $mdConstant.KEY_CODE.TAB:
	        // If we hit tab, assume that we've left the list so it will close
	        onListLeave();
	
	        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
	        select(ctrl.index);
	        break;
	      case $mdConstant.KEY_CODE.ENTER:
	        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
	        if (hasSelection()) return;
	        event.stopImmediatePropagation();
	        event.preventDefault();
	        select(ctrl.index);
	        break;
	      case $mdConstant.KEY_CODE.ESCAPE:
	        event.preventDefault(); // Prevent browser from always clearing input
	        if (!shouldProcessEscape()) return;
	        event.stopPropagation();
	
	        clearSelectedItem();
	        if ($scope.searchText && hasEscapeOption('clear')) {
	          clearSearchText();
	        }
	
	        // Manually hide (needed for mdNotFound support)
	        ctrl.hidden = true;
	
	        if (hasEscapeOption('blur')) {
	          // Force the component to blur if they hit escape
	          doBlur(true);
	        }
	
	        break;
	      default:
	    }
	  }
	
	  // getters
	
	  /**
	   * Returns the minimum length needed to display the dropdown.
	   * @returns {*}
	   */
	  function getMinLength () {
	    return angular.isNumber($scope.minLength) ? $scope.minLength : 1;
	  }
	
	  /**
	   * Returns the display value for an item.
	   * @param {*} item
	   * @returns {*}
	   */
	  function getDisplayValue (item) {
	    return $q.when(getItemText(item) || item).then(function(itemText) {
	      if (itemText && !angular.isString(itemText)) {
	        $log.warn('md-autocomplete: Could not resolve display value to a string. ' +
	          'Please check the `md-item-text` attribute.');
	      }
	
	      return itemText;
	    });
	
	    /**
	     * Getter function to invoke user-defined expression (in the directive)
	     * to convert your object to a single string.
	     * @param {*} item
	     * @returns {string|null}
	     */
	    function getItemText (item) {
	      return (item && $scope.itemText) ? $scope.itemText(getItemAsNameVal(item)) : null;
	    }
	  }
	
	  /**
	   * Returns the locals object for compiling item templates.
	   * @param {*} item
	   * @returns {Object|undefined}
	   */
	  function getItemAsNameVal (item) {
	    if (!item) {
	      return undefined;
	    }
	
	    var locals = {};
	    if (ctrl.itemName) {
	      locals[ ctrl.itemName ] = item;
	    }
	
	    return locals;
	  }
	
	  /**
	   * Returns the default index based on whether or not autoselect is enabled.
	   * @returns {number} 0 if autoselect is enabled, -1 if not.
	   */
	  function getDefaultIndex () {
	    return $scope.autoselect ? 0 : -1;
	  }
	
	  /**
	   * Sets the loading parameter and updates the hidden state.
	   * @param value {boolean} Whether or not the component is currently loading.
	   */
	  function setLoading(value) {
	    if (ctrl.loading !== value) {
	      ctrl.loading = value;
	    }
	
	    // Always refresh the hidden variable as something else might have changed
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * Determines if the menu should be hidden.
	   * @returns {boolean} true if the menu should be hidden
	   */
	  function shouldHide () {
	    return !shouldShow();
	  }
	
	  /**
	   * Determines whether the autocomplete is able to query within the current state.
	   * @returns {boolean} true if the query can be run
	   */
	  function isSearchable() {
	    if (ctrl.loading && !hasMatches()) {
	      // No query when query is in progress.
	      return false;
	    } else if (hasSelection()) {
	      // No query if there is already a selection
	      return false;
	    }
	    else if (!hasFocus) {
	      // No query if the input does not have focus
	      return false;
	    }
	    return true;
	  }
	
	  /**
	   * @returns {boolean} if the escape keydown should be processed, return true.
	   *  Otherwise return false.
	   */
	  function shouldProcessEscape() {
	    return hasEscapeOption('blur') || !ctrl.hidden || ctrl.loading || hasEscapeOption('clear') && $scope.searchText;
	  }
	
	  /**
	   * @param {string} option check if this option is set
	   * @returns {boolean} if the specified escape option is set, return true. Return false otherwise.
	   */
	  function hasEscapeOption(option) {
	    if (!angular.isString($scope.escapeOptions)) {
	      return ctrl.defaultEscapeOptions.indexOf(option) !== -1;
	    } else {
	      return $scope.escapeOptions.toLowerCase().indexOf(option) !== -1;
	    }
	  }
	
	  /**
	   * Determines if the menu should be shown.
	   * @returns {boolean} true if the menu should be shown
	   */
	  function shouldShow() {
	    if (ctrl.isReadonly) {
	      // Don't show if read only is set
	      return false;
	    } else if (!isSearchable()) {
	      // Don't show if a query is in progress, there is already a selection,
	      // or the input is not focused.
	      return false;
	    }
	    return (isMinLengthMet() && hasMatches()) || notFoundVisible();
	  }
	
	  /**
	   * @returns {boolean} true if the search text has matches.
	   */
	  function hasMatches() {
	    return ctrl.matches.length ? true : false;
	  }
	
	  /**
	   * @returns {boolean} true if the autocomplete has a valid selection.
	   */
	  function hasSelection() {
	    return ctrl.scope.selectedItem ? true : false;
	  }
	
	  /**
	   * @returns {boolean} true if the loading indicator is, or should be, visible.
	   */
	  function loadingIsVisible() {
	    return ctrl.loading && !hasSelection();
	  }
	
	  /**
	   * @returns {*} the display value of the current item.
	   */
	  function getCurrentDisplayValue () {
	    return getDisplayValue(ctrl.matches[ ctrl.index ]);
	  }
	
	  /**
	   * Determines if the minimum length is met by the search text.
	   * @returns {*} true if the minimum length is met by the search text
	   */
	  function isMinLengthMet () {
	    return ($scope.searchText || '').length >= getMinLength();
	  }
	
	  // actions
	
	  /**
	   * Defines a public property with a handler and a default value.
	   * @param {string} key
	   * @param {Function} handler function
	   * @param {*} defaultValue default value
	   */
	  function defineProperty (key, handler, defaultValue) {
	    Object.defineProperty(ctrl, key, {
	      get: function () { return defaultValue; },
	      set: function (newValue) {
	        var oldValue = defaultValue;
	        defaultValue        = newValue;
	        handler(newValue, oldValue);
	      }
	    });
	  }
	
	  /**
	   * Selects the item at the given index.
	   * @param {number} index to select
	   */
	  function select (index) {
	    // force form to update state for validation
	    $mdUtil.nextTick(function () {
	      getDisplayValue(ctrl.matches[ index ]).then(function (val) {
	        var ngModel = elements.$.input.controller('ngModel');
	        $mdLiveAnnouncer.announce(val + ' ' + ctrl.selectedMessage, 'assertive');
	        ngModel.$setViewValue(val);
	        ngModel.$render();
	      }).finally(function () {
	        $scope.selectedItem = ctrl.matches[ index ];
	        setLoading(false);
	      });
	    }, false);
	  }
	
	  /**
	   * Clears the searchText value and selected item.
	   * @param {Event} $event
	   */
	  function clearValue ($event) {
	    if ($event) {
	      $event.stopPropagation();
	    }
	    clearSelectedItem();
	    clearSearchText();
	  }
	
	  /**
	   * Clears the selected item
	   */
	  function clearSelectedItem () {
	    // Reset our variables
	    ctrl.index = -1;
	    $mdUtil.nextTick(updateActiveOption);
	    ctrl.matches = [];
	  }
	
	  /**
	   * Clears the searchText value
	   */
	  function clearSearchText () {
	    // Set the loading to true so we don't see flashes of content.
	    // The flashing will only occur when an async request is running.
	    // So the loading process will stop when the results had been retrieved.
	    setLoading(true);
	
	    $scope.searchText = '';
	
	    // Normally, triggering the change / input event is unnecessary, because the browser detects it properly.
	    // But some browsers are not detecting it properly, which means that we have to trigger the event.
	    // Using the `input` is not working properly, because for example IE11 is not supporting the `input` event.
	    // The `change` event is a good alternative and is supported by all supported browsers.
	    var eventObj = document.createEvent('CustomEvent');
	    eventObj.initCustomEvent('change', true, true, { value: '' });
	    elements.input.dispatchEvent(eventObj);
	
	    // For some reason, firing the above event resets the value of $scope.searchText if
	    // $scope.searchText has a space character at the end, so we blank it one more time and then
	    // focus.
	    elements.input.blur();
	    $scope.searchText = '';
	    elements.input.focus();
	  }
	
	  /**
	   * Fetches the results for the provided search text.
	   * @param searchText
	   */
	  function fetchResults (searchText) {
	    var items = $scope.$parent.$eval(itemExpr),
	        term  = searchText.toLowerCase(),
	        isList = angular.isArray(items),
	        isPromise = !!items.then; // Every promise should contain a `then` property
	
	    if (isList) onResultsRetrieved(items);
	    else if (isPromise) handleAsyncResults(items);
	
	    function handleAsyncResults(items) {
	      if (!items) return;
	
	      items = $q.when(items);
	      fetchesInProgress++;
	      setLoading(true);
	
	      $mdUtil.nextTick(function () {
	          items
	            .then(onResultsRetrieved)
	            .finally(function(){
	              if (--fetchesInProgress === 0) {
	                setLoading(false);
	              }
	            });
	      },true, $scope);
	    }
	
	    function onResultsRetrieved(matches) {
	      cache[term] = matches;
	
	      // Just cache the results if the request is now outdated.
	      // The request becomes outdated, when the new searchText has changed during the result fetching.
	      if ((searchText || '') !== ($scope.searchText || '')) {
	        return;
	      }
	
	      handleResults(matches);
	    }
	  }
	
	
	  /**
	   * Reports given message types to supported screen readers.
	   * @param {boolean} isPolite Whether the announcement should be polite.
	   * @param {!number} types Message flags to be reported to the screen reader.
	   */
	  function reportMessages(isPolite, types) {
	    var politeness = isPolite ? 'polite' : 'assertive';
	    var messages = [];
	
	    if (types & ReportType.Selected && ctrl.index !== -1) {
	      messages.push(getCurrentDisplayValue());
	    }
	
	    if (types & ReportType.Count) {
	      messages.push($q.resolve(getCountMessage()));
	    }
	
	    $q.all(messages).then(function(data) {
	      $mdLiveAnnouncer.announce(data.join(' '), politeness);
	    });
	  }
	
	  /**
	   * @returns {string} the ARIA message for how many results match the current query.
	   */
	  function getCountMessage () {
	    switch (ctrl.matches.length) {
	      case 0:
	        return ctrl.noMatchMessage;
	      case 1:
	        return ctrl.singleMatchMessage;
	      default:
	        return ctrl.multipleMatchStartMessage + ctrl.matches.length + ctrl.multipleMatchEndMessage;
	    }
	  }
	
	  /**
	   * Makes sure that the focused element is within view.
	   */
	  function updateScroll () {
	    if (!elements.li[0]) return;
	    if (mode === MODE_STANDARD) {
	      updateStandardScroll();
	    } else {
	      updateVirtualScroll();
	    }
	  }
	
	  function updateVirtualScroll() {
	    // elements in virtual scroll have consistent heights
	    var optionHeight = elements.li[0].offsetHeight,
	        top = optionHeight * Math.max(0, ctrl.index),
	        bottom = top + optionHeight,
	        containerHeight = elements.scroller.clientHeight,
	        scrollTop = elements.scroller.scrollTop;
	
	    if (top < scrollTop) {
	      scrollTo(top);
	    } else if (bottom > scrollTop + containerHeight) {
	      scrollTo(bottom - containerHeight);
	    }
	  }
	
	  function updateStandardScroll() {
	    // elements in standard scroll have variable heights
	    var selected =  elements.li[Math.max(0, ctrl.index)];
	    var containerHeight = elements.scrollContainer.offsetHeight,
	        top = selected && selected.offsetTop || 0,
	        bottom = top + selected.clientHeight,
	        scrollTop = elements.scrollContainer.scrollTop;
	
	    if (top < scrollTop) {
	      scrollTo(top);
	    } else if (bottom > scrollTop + containerHeight) {
	      scrollTo(bottom - containerHeight);
	    }
	  }
	
	  function isPromiseFetching() {
	    return fetchesInProgress !== 0;
	  }
	
	  function scrollTo (offset) {
	    if (mode === MODE_STANDARD) {
	      elements.scrollContainer.scrollTop = offset;
	    } else {
	      elements.$.scrollContainer.controller('mdVirtualRepeatContainer').scrollTo(offset);
	    }
	  }
	
	  function notFoundVisible () {
	    var textLength = (ctrl.scope.searchText || '').length;
	
	    return ctrl.hasNotFound && !hasMatches() && (!ctrl.loading || isPromiseFetching()) && textLength >= getMinLength() && (hasFocus || noBlur) && !hasSelection();
	  }
	
	  /**
	   * Starts the query to gather the results for the current searchText.  Attempts to return cached
	   * results first, then forwards the process to `fetchResults` if necessary.
	   */
	  function handleQuery () {
	    var searchText = $scope.searchText || '';
	    var term = searchText.toLowerCase();
	
	    // If caching is enabled and the current searchText is stored in the cache
	    if (!$scope.noCache && cache[term]) {
	      // The results should be handled as same as a normal un-cached request does.
	      handleResults(cache[term]);
	    } else {
	      fetchResults(searchText);
	    }
	
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * Handles the retrieved results by showing them in the autocompletes dropdown.
	   * @param results Retrieved results
	   */
	  function handleResults(results) {
	    ctrl.matches = results;
	    ctrl.hidden  = shouldHide();
	
	    // If loading is in progress, then we'll end the progress. This is needed for example,
	    // when the `clear` button was clicked, because there we always show the loading process, to prevent flashing.
	    if (ctrl.loading) setLoading(false);
	
	    if ($scope.selectOnMatch) selectItemOnMatch();
	
	    positionDropdown();
	    reportMessages(true, ReportType.Count);
	  }
	
	  /**
	   * If there is only one matching item and the search text matches its display value exactly,
	   * automatically select that item.  Note: This function is only called if the user uses the
	   * `md-select-on-match` flag.
	   */
	  function selectItemOnMatch () {
	    var searchText = $scope.searchText,
	        matches    = ctrl.matches,
	        item       = matches[ 0 ];
	    if (matches.length === 1) getDisplayValue(item).then(function (displayValue) {
	      var isMatching = searchText === displayValue;
	      if ($scope.matchInsensitive && !isMatching) {
	        isMatching = searchText.toLowerCase() === displayValue.toLowerCase();
	      }
	
	      if (isMatching) {
	        select(0);
	      }
	    });
	  }
	
	  /**
	   * Evaluates an attribute expression against the parent scope.
	   * @param {String} attr Name of the attribute to be evaluated.
	   * @param {Object?} locals Properties to be injected into the evaluation context.
	   */
	 function evalAttr(attr, locals) {
	    if ($attrs[attr]) {
	      $scope.$parent.$eval($attrs[attr], locals || {});
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocomplete.$inject = ["$$mdSvgRegistry"];angular
	    .module('material.components.autocomplete')
	    .directive('mdAutocomplete', MdAutocomplete);
	
	/**
	 * @ngdoc directive
	 * @name mdAutocomplete
	 * @module material.components.autocomplete
	 *
	 * @description
	 * `<md-autocomplete>` is a special input component with a drop-down of all possible matches to a
	 *     custom query. This component allows you to provide real-time suggestions as the user types
	 *     in the input area.
	 *
	 * To start, you will need to specify the required parameters and provide a template for your
	 *     results. The content inside `md-autocomplete` will be treated as a template.
	 *
	 * In more complex cases, you may want to include other content such as a message to display when
	 *     no matches were found.  You can do this by wrapping your template in `md-item-template` and
	 *     adding a tag for `md-not-found`.  An example of this is shown below.
	 *
	 * To reset the displayed value you must clear both values for `md-search-text` and
	 * `md-selected-item`.
	 *
	 * ### Validation
	 *
	 * You can use `ng-messages` to include validation the same way that you would normally validate;
	 *     however, if you want to replicate a standard input with a floating label, you will have to
	 *     do the following:
	 *
	 * - Make sure that your template is wrapped in `md-item-template`
	 * - Add your `ng-messages` code inside of `md-autocomplete`
	 * - Add your validation properties to `md-autocomplete` (ie. `required`)
	 * - Add a `name` to `md-autocomplete` (to be used on the generated `input`)
	 *
	 * There is an example below of how this should look.
	 *
	 * ### Snapping Drop-Down
	 *
	 * You can cause the autocomplete drop-down to snap to an ancestor element by applying the
	 *     `md-autocomplete-snap` attribute to that element. You can also snap to the width of
	 *     the `md-autocomplete-snap` element by setting the attribute's value to `width`
	 *     (ie. `md-autocomplete-snap="width"`).
	 *
	 * ### Notes
	 *
	 * **Autocomplete Dropdown Items Rendering**
	 *
	 * The `md-autocomplete` uses the the <a ng-href="api/directive/mdVirtualRepeat">
	 *   mdVirtualRepeat</a> directive for displaying the results inside of the dropdown.<br/>
	 *
	 * > When encountering issues regarding the item template please take a look at the
	 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation.
	 *
	 * **Autocomplete inside of a Virtual Repeat**
	 *
	 * When using the `md-autocomplete` directive inside of a
	 * <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> the dropdown items
	 * might not update properly, because caching of the results is enabled by default.
	 *
	 * The autocomplete will then show invalid dropdown items, because the Virtual Repeat only updates
	 * the scope bindings rather than re-creating the `md-autocomplete`. This means that the previous
	 * cached results will be used.
	 *
	 * > To avoid such problems, ensure that the autocomplete does not cache any results via
	 * `md-no-cache="true"`:
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-no-cache="true"
	 *       md-selected-item="selectedItem"
	 *       md-items="item in items"
	 *       md-search-text="searchText"
	 *       md-item-text="item.display">
	 *     <span>{{ item.display }}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 *
	 * @param {expression} md-items An expression in the format of `item in results` to iterate over
	 *     matches for your search.<br/><br/>
	 *     The `results` expression can be also a function, which returns the results synchronously
	 *     or asynchronously (per Promise).
	 * @param {expression=} md-selected-item-change An expression to be run each time a new item is
	 *     selected.
	 * @param {expression=} md-search-text-change An expression to be run each time the search text
	 *     updates.
	 * @param {expression=} md-search-text A model to bind the search query text to.
	 * @param {object=} md-selected-item A model to bind the selected item to.
	 * @param {expression=} md-item-text An expression that will convert your object to a single string.
	 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	 * @param {boolean=} md-no-cache Disables the internal caching that happens in autocomplete.
	 * @param {boolean=} ng-disabled Determines whether or not to disable the input field.
	 * @param {boolean=} md-require-match When set to true, the autocomplete will add a validator,
	 *     which will evaluate to false, when no item is currently selected.
	 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
	 *     make suggestions.
	 * @param {number=} md-delay Specifies the amount of time (in milliseconds) to wait before looking
	 *     for results.
	 * @param {boolean=} md-clear-button Whether the clear button for the autocomplete input should show
	 *     up or not. When `md-floating-label` is set, defaults to false, defaults to true otherwise.
	 * @param {boolean=} md-autofocus If true, the autocomplete will be automatically focused when a
	 *     `$mdDialog`, `$mdBottomsheet` or `$mdSidenav`, which contains the autocomplete, is opening.
	 *     <br/><br/>
	 *     Also the autocomplete will immediately focus the input element.
	 * @param {boolean=} md-no-asterisk When present, asterisk will not be appended to the floating
	 *     label.
	 * @param {boolean=} md-autoselect If set to true, the first item will be automatically selected
	 *     in the dropdown upon open.
	 * @param {string=} md-input-name The name attribute given to the input element to be used with
	 *     FormController.
	 * @param {string=} md-menu-class This class will be applied to the dropdown menu for styling.
	 * @param {string=} md-menu-container-class This class will be applied to the parent container
	 *     of the dropdown panel.
	 * @param {string=} md-input-class This will be applied to the input for styling. This attribute
	 *     is only valid when a `md-floating-label` is defined.
	 * @param {string=} md-floating-label This will add a floating label to autocomplete and wrap it in
	 *     `md-input-container`.
	 * @param {string=} md-select-on-focus When present the input's text will be automatically selected
	 *     on focus.
	 * @param {string=} md-input-id An ID to be added to the input element.
	 * @param {number=} md-input-minlength The minimum length for the input's value for validation.
	 * @param {number=} md-input-maxlength The maximum length for the input's value for validation.
	 * @param {boolean=} md-select-on-match When set, autocomplete will automatically select
	 *     the item if the search text is an exact match. <br/><br/>
	 *     An exact match is when only one match is displayed.
	 * @param {boolean=} md-match-case-insensitive When set and using `md-select-on-match`, autocomplete
	 *     will select on case-insensitive match.
	 * @param {string=} md-escape-options Override escape key logic. Default is `clear`.<br/>
	 *     Options: `blur`, `clear`, `none`.
	 * @param {string=} md-dropdown-items Specifies the maximum amount of items to be shown in
	 *     the dropdown.<br/><br/>
	 *     When the dropdown doesn't fit into the viewport, the dropdown will shrink
	 *     as much as possible.
	 * @param {string=} md-dropdown-position Overrides the default dropdown position. Options: `top`,
	 *    `bottom`.
	 * @param {string=} input-aria-describedby A space-separated list of element IDs. This should
	 *     contain the IDs of any elements that describe this autocomplete. Screen readers will read the
	 *     content of these elements at the end of announcing that the autocomplete has been selected
	 *     and describing its current state. The descriptive elements do not need to be visible on the
	 *     page.
	 * @param {string=} input-aria-labelledby A space-separated list of element IDs. The ideal use case
	 *     is that this would contain the ID of a `<label>` element that is associated with this
	 *     autocomplete. This will only have affect when `md-floating-label` is not defined.<br><br>
	 *     For `<label id="state">US State</label>`, you would set this to
	 *     `input-aria-labelledby="state"`.
	 * @param {string=} input-aria-label A label that will be applied to the autocomplete's input.
	 *    This will be announced by screen readers before the placeholder.
	 *    This will only have affect when `md-floating-label` is not defined. If you define both
	 *    `input-aria-label` and `input-aria-labelledby`, then `input-aria-label` will take precedence.
	 * @param {string=} md-selected-message Attribute to specify the text that the screen reader will
	 *    announce after a value is selected. Default is: "selected". If `Alaska` is selected in the
	 *    options panel, it will read "Alaska selected". You will want to override this when your app
	 *    runs in a non-English locale.
	 * @param {string=} md-no-match-message Attribute to specify the text that the screen reader will
	 *    announce after a query returns no matching results.
	 *    Default is: "There are no matches available.". You will want to override this when your app
	 *    runs in a non-English locale.
	 * @param {string=} md-single-match-message Attribute to specify the text that the screen reader
	 *    will announce after a query returns a single matching result.
	 *    Default is: "There is 1 match available.". You will want to override this when your app
	 *    runs in a non-English locale.
	 * @param {string=} md-multiple-match-start-message Attribute to specify the text that the screen
	 *    reader will announce after a query returns multiple matching results. The number of matching
	 *    results will be read after this text. Default is: "There are ". You will want to override this
	 *    when your app runs in a non-English locale.
	 * @param {string=} md-multiple-match-end-message Attribute to specify the text that the screen
	 *    reader will announce after a query returns multiple matching results. The number of matching
	 *    results will be read before this text. Default is: " matches available.". You will want to
	 *    override this when your app runs in a non-English locale.
	 * @param {boolean=} ng-trim If set to false, the search text will be not trimmed automatically.
	 *     Defaults to true.
	 * @param {string=} ng-pattern Adds the pattern validator to the ngModel of the search text.
	 *     See the [ngPattern Directive](https://docs.angularjs.org/api/ng/directive/ngPattern)
	 *     for more details.
	 * @param {string=} md-mode Specify the repeat mode for suggestion lists. Acceptable values include
	 *     `virtual` (md-virtual-repeat) and `standard` (ng-repeat). See the
	 *     `Specifying Repeat Mode` example for mode details. Default is `virtual`.
	 *
	 * @usage
	 * ### Basic Example
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 * ### Example with "not found" message
	 * <hljs lang="html">
	 * <md-autocomplete
	 *     md-selected-item="selectedItem"
	 *     md-search-text="searchText"
	 *     md-items="item in getMatches(searchText)"
	 *     md-item-text="item.display">
	 *   <md-item-template>
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-item-template>
	 *   <md-not-found>
	 *     No matches found.
	 *   </md-not-found>
	 * </md-autocomplete>
	 * </hljs>
	 *
	 * In this example, our code utilizes `md-item-template` and `md-not-found` to specify the
	 *     different parts that make up our component.
	 *
	 * ### Clear button for the input
	 * By default, the clear button is displayed when there is input. This aligns with the spec's
	 * [Search Pattern](https://material.io/archive/guidelines/patterns/search.html#search-in-app-search).
	 * In floating label mode, when `md-floating-label="My Label"` is applied, the clear button is not
	 * displayed by default (see the spec's
	 * [Autocomplete Text Field](https://material.io/archive/guidelines/components/text-fields.html#text-fields-layout)).
	 *
	 * Nevertheless, developers are able to explicitly toggle the clear button for all autocomplete
	 * components with `md-clear-button`.
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete ... md-clear-button="true"></md-autocomplete>
	 *   <md-autocomplete ... md-clear-button="false"></md-autocomplete>
	 * </hljs>
	 *
	 * In previous versions, the clear button was always hidden when the component was disabled.
	 * This changed in `1.1.5` to give the developer control of this behavior. This example
	 * will hide the clear button only when the component is disabled.
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete ... ng-disabled="disabled" md-clear-button="!disabled"></md-autocomplete>
	 * </hljs>
	 *
	 * ### Example with validation
	 * <hljs lang="html">
	 * <form name="autocompleteForm">
	 *   <md-autocomplete
	 *       required
	 *       md-input-name="autocomplete"
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <md-item-template>
	 *       <span md-highlight-text="searchText">{{item.display}}</span>
	 *     </md-item-template>
	 *     <div ng-messages="autocompleteForm.autocomplete.$error">
	 *       <div ng-message="required">This field is required</div>
	 *     </div>
	 *   </md-autocomplete>
	 * </form>
	 * </hljs>
	 *
	 * In this example, our code utilizes `md-item-template` and `ng-messages` to specify
	 *     input validation for the field.
	 *
	 * ### Asynchronous Results
	 * The autocomplete items expression also supports promises, which will resolve with the query
	 * results.
	 *
	 * <hljs lang="js">
	 *   function AppController($scope, $http) {
	 *     $scope.query = function(searchText) {
	 *       return $http
	 *         .get(BACKEND_URL + '/items/' + searchText)
	 *         .then(function(data) {
	 *           // Map the response object to the data object.
	 *           return data;
	 *         });
	 *     };
	 *   }
	 * </hljs>
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in query(searchText)">
	 *     <md-item-template>
	 *       <span md-highlight-text="searchText">{{item}}</span>
	 *     </md-item-template>
	 * </md-autocomplete>
	 * </hljs>
	 *
	 * ### Specifying Repeat Mode
	 * You can use `md-mode` to specify whether to use standard or virtual lists for
	 * rendering autocomplete options.
	 * The `md-mode` accepts two values:
	 * - `virtual` (default) Uses `md-virtual-repeat` to render list items. Virtual
	 *    mode requires you to have consistent heights for all suggestions.
	 * - `standard` uses `ng-repeat` to render list items. This allows you to have
	 *    options of varying heights.
	 *
	 * Note that using 'standard' mode will require you to address any list
	 * performance issues (e.g. pagination) separately within your application.
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display"
	 *       md-mode="standard">
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 */
	function MdAutocomplete ($$mdSvgRegistry) {
	  var REPEAT_STANDARD = 'standard';
	  var REPEAT_VIRTUAL = 'virtual';
	  var REPEAT_MODES = [REPEAT_STANDARD, REPEAT_VIRTUAL];
	
	  /** get a valid repeat mode from an md-mode attribute string. */
	  function getRepeatMode(modeStr) {
	    if (!modeStr) { return REPEAT_VIRTUAL; }
	    modeStr = modeStr.toLowerCase();
	    return  REPEAT_MODES.indexOf(modeStr) > -1 ? modeStr : REPEAT_VIRTUAL;
	  }
	
	  return {
	    controller:   'MdAutocompleteCtrl',
	    controllerAs: '$mdAutocompleteCtrl',
	    scope:        {
	      inputName:          '@mdInputName',
	      inputMinlength:     '@mdInputMinlength',
	      inputMaxlength:     '@mdInputMaxlength',
	      searchText:         '=?mdSearchText',
	      selectedItem:       '=?mdSelectedItem',
	      itemsExpr:          '@mdItems',
	      itemText:           '&mdItemText',
	      placeholder:        '@placeholder',
	      inputAriaDescribedBy: '@?inputAriaDescribedby',
	      inputAriaLabelledBy: '@?inputAriaLabelledby',
	      inputAriaLabel:     '@?inputAriaLabel',
	      noCache:            '=?mdNoCache',
	      requireMatch:       '=?mdRequireMatch',
	      selectOnMatch:      '=?mdSelectOnMatch',
	      matchInsensitive:   '=?mdMatchCaseInsensitive',
	      itemChange:         '&?mdSelectedItemChange',
	      textChange:         '&?mdSearchTextChange',
	      minLength:          '=?mdMinLength',
	      delay:              '=?mdDelay',
	      autofocus:          '=?mdAutofocus',
	      floatingLabel:      '@?mdFloatingLabel',
	      autoselect:         '=?mdAutoselect',
	      menuClass:          '@?mdMenuClass',
	      menuContainerClass: '@?mdMenuContainerClass',
	      inputClass:         '@?mdInputClass',
	      inputId:            '@?mdInputId',
	      escapeOptions:      '@?mdEscapeOptions',
	      dropdownItems:      '=?mdDropdownItems',
	      dropdownPosition:   '@?mdDropdownPosition',
	      clearButton:        '=?mdClearButton',
	      selectedMessage:    '@?mdSelectedMessage',
	      noMatchMessage:     '@?mdNoMatchMessage',
	      singleMatchMessage: '@?mdSingleMatchMessage',
	      multipleMatchStartMessage: '@?mdMultipleMatchStartMessage',
	      multipleMatchEndMessage: '@?mdMultipleMatchEndMessage',
	      mdMode: '=?mdMode'
	    },
	    compile: function(tElement, tAttrs) {
	      var attributes = ['md-select-on-focus', 'md-no-asterisk', 'ng-trim', 'ng-pattern'];
	      var input = tElement.find('input');
	
	      attributes.forEach(function(attribute) {
	        var attrValue = tAttrs[tAttrs.$normalize(attribute)];
	
	        if (attrValue !== null) {
	          input.attr(attribute, attrValue);
	        }
	      });
	
	      return function(scope, element, attrs, ctrl) {
	        // Retrieve the state of using a md-not-found template by using our attribute, which will
	        // be added to the element in the template function.
	        ctrl.hasNotFound = !!element.attr('md-has-not-found');
	
	        // By default the inset autocomplete should show the clear button when not explicitly
	        // overwritten or in floating label mode.
	        if (!angular.isDefined(attrs.mdClearButton) && !scope.floatingLabel) {
	          scope.clearButton = true;
	        }
	
	        scope.mdMode = getRepeatMode(attrs.mdMode);
	
	        // Stop click events from bubbling up to the document and triggering a flicker of the
	        // options panel while still supporting ng-click to be placed on md-autocomplete.
	        element.on('click touchstart touchend', function(event) {
	          event.stopPropagation();
	        });
	      };
	    },
	    template: function (element, attr) {
	      var noItemsTemplate = getNoItemsTemplate(),
	          itemTemplate    = getItemTemplate(),
	          leftover        = element.html(),
	          tabindex        = attr.tabindex;
	
	      // Set our attribute for the link function above which runs later.
	      // We will set an attribute, because otherwise the stored variables will be trashed when
	      // removing the element is hidden while retrieving the template. For example when using ngIf.
	      if (noItemsTemplate) element.attr('md-has-not-found', true);
	
	      // Always set our tabindex of the autocomplete directive to -1, because our input
	      // will hold the actual tabindex.
	      element.attr('tabindex', '-1');
	
	      return '\
	        <md-autocomplete-wrap\
	            ng-class="{ \'md-whiteframe-z1\': !floatingLabel, \
	                        \'md-menu-showing\': !$mdAutocompleteCtrl.hidden, \
	                        \'md-show-clear-button\': !!clearButton }">\
	          ' + getInputElement() + '\
	          ' + getClearButton() + '\
	          <md-progress-linear\
	              class="' + (attr.mdFloatingLabel ? 'md-inline' : '') + '"\
	              ng-if="$mdAutocompleteCtrl.loadingIsVisible()"\
	              md-mode="indeterminate"></md-progress-linear>\
	          ' + getContainer(attr.mdMenuContainerClass, attr.mdMode) + '\
	            <ul class="md-autocomplete-suggestions"\
	                ng-class="::menuClass"\
	                id="ul-{{$mdAutocompleteCtrl.id}}"\
	                ng-mouseup="$mdAutocompleteCtrl.focusInput()"\
	                role="listbox">\
	              <li class="md-autocomplete-suggestion" ' + getRepeatType(attr.mdMode) + ' ="item in $mdAutocompleteCtrl.matches"\
	                  ng-class="{ selected: $index === $mdAutocompleteCtrl.index }"\
	                  ng-attr-id="{{\'md-option-\' + $mdAutocompleteCtrl.id + \'-\' + $index}}"\
	                  ng-click="$mdAutocompleteCtrl.select($index)"\
	                  role="option"\
	                  aria-setsize="{{$mdAutocompleteCtrl.matches.length}}"\
	                  aria-posinset="{{$index+1}}"\
	                  aria-selected="{{$index === $mdAutocompleteCtrl.index ? true : false}}" \
	                  md-extra-name="$mdAutocompleteCtrl.itemName">\
	                  ' + itemTemplate + '\
	                  </li>' + noItemsTemplate + '\
	            </ul>\
	          '  + getContainerClosingTags(attr.mdMode) + '\
	        </md-autocomplete-wrap>';
	
	      function getItemTemplate() {
	        var templateTag = element.find('md-item-template').detach(),
	            html = templateTag.length ? templateTag.html() : element.html();
	        if (!templateTag.length) element.empty();
	        return '<md-autocomplete-parent-scope md-autocomplete-replace>' + html +
	               '</md-autocomplete-parent-scope>';
	      }
	
	      function getNoItemsTemplate() {
	        var templateTag = element.find('md-not-found').detach(),
	            template = templateTag.length ? templateTag.html() : '';
	        return template
	            ? '<li ng-if="$mdAutocompleteCtrl.notFoundVisible()" class="md-autocomplete-suggestion"\
	                         md-autocomplete-parent-scope>' + template + '</li>'
	            : '';
	      }
	
	      function getContainer(menuContainerClass, repeatMode) {
	        // prepend a space if needed
	        menuContainerClass = menuContainerClass ? ' ' + menuContainerClass : '';
	
	        if (isVirtualRepeatDisabled(repeatMode)) {
	          return '\
	            <div \
	                ng-hide="$mdAutocompleteCtrl.hidden"\
	                class="md-standard-list-container md-autocomplete-suggestions-container md-whiteframe-z1' + menuContainerClass + '"\
	                ng-class="{ \'md-not-found\': $mdAutocompleteCtrl.notFoundVisible() }"\
	                ng-mouseenter="$mdAutocompleteCtrl.listEnter()"\
	                ng-mouseleave="$mdAutocompleteCtrl.listLeave()"\
	                role="presentation">\
	              <div class="md-standard-list-scroller" role="presentation">';
	        }
	
	        return '\
	          <md-virtual-repeat-container\
	              md-auto-shrink\
	              md-auto-shrink-min="1"\
	              ng-hide="$mdAutocompleteCtrl.hidden"\
	              class="md-virtual-repeat-container md-autocomplete-suggestions-container md-whiteframe-z1' + menuContainerClass + '"\
	              ng-class="{ \'md-not-found\': $mdAutocompleteCtrl.notFoundVisible() }"\
	              ng-mouseenter="$mdAutocompleteCtrl.listEnter()"\
	              ng-mouseleave="$mdAutocompleteCtrl.listLeave()"\
	              role="presentation">';
	      }
	
	      function getContainerClosingTags(repeatMode) {
	        return isVirtualRepeatDisabled(repeatMode) ?
	            '   </div>\
	              </div>\
	            </div>' : '</md-virtual-repeat-container>';
	      }
	
	      function getRepeatType(repeatMode) {
	        return isVirtualRepeatDisabled(repeatMode)  ?
	          'ng-repeat' : 'md-virtual-repeat';
	      }
	
	      function isVirtualRepeatDisabled(repeatMode) {
	        // ensure we have a valid repeat mode
	        var correctedRepeatMode = getRepeatMode(repeatMode);
	        return correctedRepeatMode !== REPEAT_VIRTUAL;
	      }
	
	      function getInputElement () {
	        if (attr.mdFloatingLabel) {
	          return '\
	            <md-input-container ng-if="floatingLabel">\
	              <label>{{floatingLabel}}</label>\
	              <input type="text"\
	                ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
	                id="{{inputId || \'fl-input-\' + $mdAutocompleteCtrl.id}}"\
	                name="{{inputName || \'fl-input-\' + $mdAutocompleteCtrl.id }}"\
	                ng-class="::inputClass"\
	                autocomplete="off"\
	                ng-required="$mdAutocompleteCtrl.isRequired"\
	                ng-readonly="$mdAutocompleteCtrl.isReadonly"\
	                ng-minlength="inputMinlength"\
	                ng-maxlength="inputMaxlength"\
	                ng-disabled="$mdAutocompleteCtrl.isDisabled"\
	                ng-model="$mdAutocompleteCtrl.scope.searchText"\
	                ng-model-options="{ allowInvalid: true }"\
	                ng-mousedown="$mdAutocompleteCtrl.focusInput()"\
	                ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
	                ng-blur="$mdAutocompleteCtrl.blur($event)"\
	                ng-focus="$mdAutocompleteCtrl.focus($event)"\
	                aria-label="{{floatingLabel}}"\
	                ng-attr-aria-autocomplete="{{$mdAutocompleteCtrl.isDisabled ? undefined : \'list\'}}"\
	                ng-attr-role="{{$mdAutocompleteCtrl.isDisabled ? undefined : \'combobox\'}}"\
	                aria-haspopup="{{!$mdAutocompleteCtrl.isDisabled}}"\
	                aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"\
	                ng-attr-aria-owns="{{$mdAutocompleteCtrl.hidden || $mdAutocompleteCtrl.isDisabled ? undefined : \'ul-\' + $mdAutocompleteCtrl.id}}"\
	                ng-attr-aria-activedescendant="{{!$mdAutocompleteCtrl.hidden && $mdAutocompleteCtrl.activeOption ? $mdAutocompleteCtrl.activeOption : undefined}}">\
	              <div md-autocomplete-parent-scope md-autocomplete-replace>' + leftover + '</div>\
	            </md-input-container>';
	        } else {
	          return '\
	            <input type="text"\
	              ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
	              id="{{inputId || \'input-\' + $mdAutocompleteCtrl.id}}"\
	              name="{{inputName || \'input-\' + $mdAutocompleteCtrl.id }}"\
	              ng-class="::inputClass"\
	              ng-if="!floatingLabel"\
	              autocomplete="off"\
	              ng-required="$mdAutocompleteCtrl.isRequired"\
	              ng-disabled="$mdAutocompleteCtrl.isDisabled"\
	              ng-readonly="$mdAutocompleteCtrl.isReadonly"\
	              ng-minlength="inputMinlength"\
	              ng-maxlength="inputMaxlength"\
	              ng-model="$mdAutocompleteCtrl.scope.searchText"\
	              ng-mousedown="$mdAutocompleteCtrl.focusInput()"\
	              ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
	              ng-blur="$mdAutocompleteCtrl.blur($event)"\
	              ng-focus="$mdAutocompleteCtrl.focus($event)"\
	              placeholder="{{placeholder}}"\
	              aria-label="{{placeholder}}"\
	              ng-attr-aria-autocomplete="{{$mdAutocompleteCtrl.isDisabled ? undefined : \'list\'}}"\
	              ng-attr-role="{{$mdAutocompleteCtrl.isDisabled ? undefined : \'combobox\'}}"\
	              aria-haspopup="{{!$mdAutocompleteCtrl.isDisabled}}"\
	              aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"\
	              ng-attr-aria-owns="{{$mdAutocompleteCtrl.hidden || $mdAutocompleteCtrl.isDisabled ? undefined : \'ul-\' + $mdAutocompleteCtrl.id}}"\
	              ng-attr-aria-activedescendant="{{!$mdAutocompleteCtrl.hidden && $mdAutocompleteCtrl.activeOption ? $mdAutocompleteCtrl.activeOption : undefined}}">';
	        }
	      }
	
	      function getClearButton() {
	        return '' +
	          '<button ' +
	              'type="button" ' +
	              'aria-label="Clear Input" ' +
	              'tabindex="0" ' +
	              'ng-if="clearButton && $mdAutocompleteCtrl.scope.searchText" ' +
	              'ng-click="$mdAutocompleteCtrl.clear($event)">' +
	            '<md-icon md-svg-src="' + $$mdSvgRegistry.mdClose + '"></md-icon>' +
	          '</button>';
	        }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocompleteItemScopeDirective.$inject = ["$compile", "$mdUtil"];angular
	  .module('material.components.autocomplete')
	  .directive('mdAutocompleteParentScope', MdAutocompleteItemScopeDirective);
	
	function MdAutocompleteItemScopeDirective($compile, $mdUtil) {
	  return {
	    restrict: 'AE',
	    compile: compile,
	    terminal: true,
	    transclude: 'element'
	  };
	
	  function compile(tElement, tAttr, transclude) {
	    return function postLink(scope, element, attr) {
	      var ctrl = scope.$mdAutocompleteCtrl;
	      var newScope = ctrl.parent.$new();
	      var itemName = ctrl.itemName;
	
	      // Watch for changes to our scope's variables and copy them to the new scope
	      watchVariable('$index', '$index');
	      watchVariable('item', itemName);
	
	      // Ensure that $digest calls on our scope trigger $digest on newScope.
	      connectScopes();
	
	      // Link the element against newScope.
	      transclude(newScope, function(clone) {
	        element.after(clone);
	      });
	
	      /**
	       * Creates a watcher for variables that are copied from the parent scope
	       * @param variable
	       * @param alias
	       */
	      function watchVariable(variable, alias) {
	        newScope[alias] = scope[variable];
	
	        scope.$watch(variable, function(value) {
	          $mdUtil.nextTick(function() {
	            newScope[alias] = value;
	          });
	        });
	      }
	
	      /**
	       * Creates watchers on scope and newScope that ensure that for any
	       * $digest of scope, newScope is also $digested.
	       */
	      function connectScopes() {
	        var scopeDigesting = false;
	        var newScopeDigesting = false;
	
	        scope.$watch(function() {
	          if (newScopeDigesting || scopeDigesting) {
	            return;
	          }
	
	          scopeDigesting = true;
	          scope.$$postDigest(function() {
	            if (!newScopeDigesting) {
	              newScope.$digest();
	            }
	
	            scopeDigesting = newScopeDigesting = false;
	          });
	        });
	
	        newScope.$watch(function() {
	          newScopeDigesting = true;
	        });
	      }
	    };
	  }
	}
	})();
	(function(){
	"use strict";
	
	
	MdHighlightCtrl.$inject = ["$scope", "$element", "$attrs", "$mdUtil"];angular
	    .module('material.components.autocomplete')
	    .controller('MdHighlightCtrl', MdHighlightCtrl);
	
	function MdHighlightCtrl ($scope, $element, $attrs, $mdUtil) {
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$mdUtil = $mdUtil;
	
	  // Cache the Regex to avoid rebuilding each time.
	  this.regex = null;
	}
	
	MdHighlightCtrl.prototype.init = function(unsafeTermFn, unsafeContentFn) {
	
	  this.flags = this.$attrs.mdHighlightFlags || '';
	
	  this.unregisterFn = this.$scope.$watch(function($scope) {
	    return {
	      term: unsafeTermFn($scope),
	      contentText: unsafeContentFn($scope)
	    };
	  }.bind(this), this.onRender.bind(this), true);
	
	  this.$element.on('$destroy', this.unregisterFn);
	};
	
	/**
	 * Triggered once a new change has been recognized and the highlighted
	 * text needs to be updated.
	 */
	MdHighlightCtrl.prototype.onRender = function(state, prevState) {
	
	  var contentText = state.contentText;
	
	  /* Update the regex if it's outdated, because we don't want to rebuilt it constantly. */
	  if (this.regex === null || state.term !== prevState.term) {
	    this.regex = this.createRegex(state.term, this.flags);
	  }
	
	  /* If a term is available apply the regex to the content */
	  if (state.term) {
	    this.applyRegex(contentText);
	  } else {
	    this.$element.text(contentText);
	  }
	
	};
	
	/**
	 * Decomposes the specified text into different tokens (whether match or not).
	 * Breaking down the string guarantees proper XSS protection due to the native browser
	 * escaping of unsafe text.
	 */
	MdHighlightCtrl.prototype.applyRegex = function(text) {
	  var tokens = this.resolveTokens(text);
	
	  this.$element.empty();
	
	  tokens.forEach(function (token) {
	
	    if (token.isMatch) {
	      var tokenEl = angular.element('<span class="highlight">').text(token.text);
	
	      this.$element.append(tokenEl);
	    } else {
	      this.$element.append(document.createTextNode(token));
	    }
	
	  }.bind(this));
	
	};
	
	  /**
	 * Decomposes the specified text into different tokens by running the regex against the text.
	 */
	MdHighlightCtrl.prototype.resolveTokens = function(string) {
	  var tokens = [];
	  var lastIndex = 0;
	
	  // Use replace here, because it supports global and single regular expressions at same time.
	  string.replace(this.regex, function(match, index) {
	    appendToken(lastIndex, index);
	
	    tokens.push({
	      text: match,
	      isMatch: true
	    });
	
	    lastIndex = index + match.length;
	  });
	
	  // Append the missing text as a token.
	  appendToken(lastIndex);
	
	  return tokens;
	
	  function appendToken(from, to) {
	    var targetText = string.slice(from, to);
	    targetText && tokens.push(targetText);
	  }
	};
	
	/** Creates a regex for the specified text with the given flags. */
	MdHighlightCtrl.prototype.createRegex = function(term, flags) {
	  var startFlag = '', endFlag = '';
	  var regexTerm = this.$mdUtil.sanitize(term);
	
	  if (flags.indexOf('^') >= 0) startFlag = '^';
	  if (flags.indexOf('$') >= 0) endFlag = '$';
	
	  return new RegExp(startFlag + regexTerm + endFlag, flags.replace(/[$^]/g, ''));
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdHighlight.$inject = ["$interpolate", "$parse"];angular
	    .module('material.components.autocomplete')
	    .directive('mdHighlightText', MdHighlight);
	
	/**
	 * @ngdoc directive
	 * @name mdHighlightText
	 * @module material.components.autocomplete
	 *
	 * @description
	 * The `md-highlight-text` directive allows you to specify text that should be highlighted within
	 *     an element.  Highlighted text will be wrapped in `<span class="highlight"></span>` which can
	 *     be styled through CSS.  Please note that child elements may not be used with this directive.
	 *
	 * @param {string} md-highlight-text A model to be searched for
	 * @param {string=} md-highlight-flags A list of flags (loosely based on JavaScript RexExp flags).
	 * #### **Supported flags**:
	 * - `g`: Find all matches within the provided text
	 * - `i`: Ignore case when searching for matches
	 * - `$`: Only match if the text ends with the search term
	 * - `^`: Only match if the text begins with the search term
	 *
	 * @usage
	 * <hljs lang="html">
	 * <input placeholder="Enter a search term..." ng-model="searchTerm" type="text" />
	 * <ul>
	 *   <li ng-repeat="result in results" md-highlight-text="searchTerm" md-highlight-flags="i">
	 *     {{result.text}}
	 *   </li>
	 * </ul>
	 * </hljs>
	 */
	
	function MdHighlight ($interpolate, $parse) {
	  return {
	    terminal: true,
	    controller: 'MdHighlightCtrl',
	    compile: function mdHighlightCompile(tElement, tAttr) {
	      var termExpr = $parse(tAttr.mdHighlightText);
	      var unsafeContentExpr = $interpolate(tElement.html());
	
	      return function mdHighlightLink(scope, element, attr, ctrl) {
	        ctrl.init(termExpr, unsafeContentExpr);
	      };
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/*
	 * @ngdoc module
	 * @name material.components.backdrop
	 * @description Backdrop
	 */
	
	/**
	 * @ngdoc directive
	 * @name mdBackdrop
	 * @module material.components.backdrop
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-backdrop>` is a backdrop element used by other components, such as dialog and bottom sheet.
	 * Apply class `opaque` to make the backdrop use the theme backdrop color.
	 *
	 */
	
	angular
	  .module('material.components.backdrop', ['material.core'])
	  .directive('mdBackdrop', ["$mdTheming", "$mdUtil", "$animate", "$rootElement", "$window", "$log", "$$rAF", "$document", function BackdropDirective($mdTheming, $mdUtil, $animate, $rootElement, $window, $log, $$rAF, $document) {
	    var ERROR_CSS_POSITION = '<md-backdrop> may not work properly in a scrolled, static-positioned parent container.';
	
	    return {
	      restrict: 'E',
	      link: postLink
	    };
	
	    function postLink(scope, element, attrs) {
	      // backdrop may be outside the $rootElement, tell ngAnimate to animate regardless
	      if ($animate.pin) $animate.pin(element, $rootElement);
	
	      var bodyStyles;
	
	      $$rAF(function() {
	        // If body scrolling has been disabled using mdUtil.disableBodyScroll(),
	        // adjust the 'backdrop' height to account for the fixed 'body' top offset.
	        // Note that this can be pretty expensive and is better done inside the $$rAF.
	        bodyStyles = $window.getComputedStyle($document[0].body);
	
	        if (bodyStyles.position === 'fixed') {
	          var resizeHandler = $mdUtil.debounce(function(){
	            bodyStyles = $window.getComputedStyle($document[0].body);
	            resize();
	          }, 60, null, false);
	
	          resize();
	          angular.element($window).on('resize', resizeHandler);
	
	          scope.$on('$destroy', function() {
	            angular.element($window).off('resize', resizeHandler);
	          });
	        }
	
	        // Often $animate.enter() is used to append the backDrop element
	        // so let's wait until $animate is done...
	        var parent = element.parent();
	
	        if (parent.length) {
	          if (parent[0].nodeName === 'BODY') {
	            element.css('position', 'fixed');
	          }
	
	          var styles = $window.getComputedStyle(parent[0]);
	
	          if (styles.position === 'static') {
	            // backdrop uses position:absolute and will not work properly with parent position:static (default)
	            $log.warn(ERROR_CSS_POSITION);
	          }
	
	          // Only inherit the parent if the backdrop has a parent.
	          $mdTheming.inherit(element, parent);
	        }
	      });
	
	      function resize() {
	        var viewportHeight = parseInt(bodyStyles.height, 10) + Math.abs(parseInt(bodyStyles.top, 10));
	        element.css('height', viewportHeight + 'px');
	      }
	    }
	
	  }]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.bottomSheet
	 * @description
	 * BottomSheet
	 */
	MdBottomSheetDirective.$inject = ["$mdBottomSheet"];
	MdBottomSheetProvider.$inject = ["$$interimElementProvider"];
	angular
	  .module('material.components.bottomSheet', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdBottomSheet', MdBottomSheetDirective)
	  .provider('$mdBottomSheet', MdBottomSheetProvider);
	
	/* @ngInject */
	function MdBottomSheetDirective($mdBottomSheet) {
	  return {
	    restrict: 'E',
	    link : function postLink(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      // When navigation force destroys an interimElement, then
	      // listen and $destroy() that interim instance...
	      scope.$on('$destroy', function() {
	        $mdBottomSheet.destroy();
	      });
	    }
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $mdBottomSheet
	 * @module material.components.bottomSheet
	 *
	 * @description
	 * `$mdBottomSheet` opens a bottom sheet over the app and provides a simple promise API.
	 *
	 * ## Restrictions
	 *
	 * - The bottom sheet's template must have an outer `<md-bottom-sheet>` element.
	 * - Add the `md-grid` class to the bottom sheet for a grid layout.
	 * - Add the `md-list` class to the bottom sheet for a list layout.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div ng-controller="MyController">
	 *   <md-button ng-click="openBottomSheet()">
	 *     Open a Bottom Sheet!
	 *   </md-button>
	 * </div>
	 * </hljs>
	 * <hljs lang="js">
	 * var app = angular.module('app', ['ngMaterial']);
	 * app.controller('MyController', function($scope, $mdBottomSheet) {
	 *   $scope.openBottomSheet = function() {
	 *     $mdBottomSheet.show({
	 *       template: '<md-bottom-sheet>' +
	 *       'Hello! <md-button ng-click="closeBottomSheet()">Close</md-button>' +
	 *       '</md-bottom-sheet>'
	 *     })
	 *
	 *     // Fires when the hide() method is used
	 *     .then(function() {
	 *       console.log('You clicked the button to close the bottom sheet!');
	 *     })
	 *
	 *     // Fires when the cancel() method is used
	 *     .catch(function() {
	 *       console.log('You hit escape or clicked the backdrop to close.');
	 *     });
	 *   };
	 *
	 *   $scope.closeBottomSheet = function($scope, $mdBottomSheet) {
	 *     $mdBottomSheet.hide();
	 *   }
	 *
	 * });
	 * </hljs>
	 *
	 * ### Custom Presets
	 * Developers are also able to create their own preset, which can be easily used without repeating
	 * their options each time.
	 *
	 * <hljs lang="js">
	 *   $mdBottomSheetProvider.addPreset('testPreset', {
	 *     options: function() {
	 *       return {
	 *         template:
	 *           '<md-bottom-sheet>' +
	 *             'This is a custom preset' +
	 *           '</md-bottom-sheet>',
	 *         controllerAs: 'bottomSheet',
	 *         bindToController: true,
	 *         clickOutsideToClose: true,
	 *         escapeToClose: true
	 *       };
	 *     }
	 *   });
	 * </hljs>
	 *
	 * After you create your preset during the config phase, you can easily access it.
	 *
	 * <hljs lang="js">
	 *   $mdBottomSheet.show(
	 *     $mdBottomSheet.testPreset()
	 *   );
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdBottomSheet#show
	 *
	 * @description
	 * Show a bottom sheet with the specified options.
	 *
	 * <em><b>Note:</b> You should <b>always</b> provide a `.catch()` method in case the user hits the
	 * `esc` key or clicks the background to close. In this case, the `cancel()` method will
	 * automatically be called on the bottom sheet which will `reject()` the promise. See the @usage
	 * section above for an example.
	 *
	 * Newer versions of Angular will throw a `Possibly unhandled rejection` exception if you forget
	 * this.</em>
	 *
	 * @param {Object} optionsOrPreset Either provide an `$mdBottomSheetPreset` defined during the
	 * config phase or an options object, with the following properties:
	 *
	 *   - `templateUrl` - `{string=}`: The url of an html template file that will
	 *   be used as the content of the bottom sheet. Restrictions: the template must
	 *   have an outer `md-bottom-sheet` element.
	 *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
	 *   template string.
	 *   - `scope` - `{Object=}`: the scope to link the template / controller to. If none is specified,
	 *   it will create a new child scope. This scope will be destroyed when the bottom sheet is
	 *   removed unless `preserveScope` is set to true.
	 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed.
	 *   Default is false
	 *   - `controller` - `{string=}`: The controller to associate with this bottom sheet.
	 *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will be used as names
	 *   of values to inject into the controller. For example, `locals: {three: 3}` would inject
	 *   `three` into the controller with the value of 3.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the bottom sheet to
	 *     close it. Default true.
	 *   - `bindToController` - `{boolean=}`: When set to true, the locals will be bound to the
	 *   controller instance and available in it's $onInit function.
	 *   - `disableBackdrop` - `{boolean=}`: When set to true, the bottomsheet will not show a backdrop.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the bottom sheet.
	 *     Default true.
	 *   - `isLockedOpen` - `{boolean=}`: Disables all default ways of closing the bottom sheet.
	 *   **Note:** this will override the `clickOutsideToClose` and `escapeToClose` options, leaving
	 *   only the `hide` and `cancel` methods as ways of closing the bottom sheet. Defaults to false.
	 *   - `resolve` - `{Object=}`: Similar to locals, except it takes promises as values
	 *   and the bottom sheet will not open until the promises resolve.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	 *   - `parent` - `{element=}`: The element to append the bottom sheet to. The `parent` may be a
	 *   `function`, `string`, `Object`, or null. Defaults to appending to the body of the root element
	 *   (or the root element) of the application.
	 *   e.g. angular.element(document.getElementById('content')) or "#content"
	 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the bottom sheet is
	 *   open. Default true.
	 *
	 * @returns {promise} A promise that can be resolved with `$mdBottomSheet.hide()` or
	 * rejected with `$mdBottomSheet.cancel()`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdBottomSheet#hide
	 *
	 * @description
	 * Hide the existing bottom sheet and resolve the promise returned from
	 * `$mdBottomSheet.show()`. This call will close the most recently opened/current bottom sheet (if
	 * any).
	 *
	 * <em><b>Note:</b> Use a `.then()` on your `.show()` to handle this callback.</em>
	 *
	 * @param {*=} response An argument for the resolved promise.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdBottomSheet#cancel
	 *
	 * @description
	 * Hide the existing bottom sheet and reject the promise returned from
	 * `$mdBottomSheet.show()`.
	 *
	 * <em><b>Note:</b> Use a `.catch()` on your `.show()` to handle this callback.</em>
	 *
	 * @param {*=} response An argument for the rejected promise.
	 *
	 */
	
	function MdBottomSheetProvider($$interimElementProvider) {
	  // how fast we need to flick down to close the sheet, pixels/ms
	  bottomSheetDefaults.$inject = ["$animate", "$mdConstant", "$mdUtil", "$mdTheming", "$mdBottomSheet", "$rootElement", "$mdGesture", "$log"];
	  var CLOSING_VELOCITY = 0.5;
	  var PADDING = 80; // same as css
	
	  return $$interimElementProvider('$mdBottomSheet')
	    .setDefaults({
	      methods: ['disableParentScroll', 'escapeToClose', 'clickOutsideToClose'],
	      options: bottomSheetDefaults
	    });
	
	  /* @ngInject */
	  function bottomSheetDefaults($animate, $mdConstant, $mdUtil, $mdTheming, $mdBottomSheet, $rootElement,
	                               $mdGesture, $log) {
	    var backdrop;
	
	    return {
	      themable: true,
	      onShow: onShow,
	      onRemove: onRemove,
	      disableBackdrop: false,
	      escapeToClose: true,
	      clickOutsideToClose: true,
	      disableParentScroll: true,
	      isLockedOpen: false
	    };
	
	    function onShow(scope, element, options) {
	      element = $mdUtil.extractElementByName(element, 'md-bottom-sheet');
	
	      // prevent tab focus or click focus on the bottom-sheet container
	      element.attr('tabindex', '-1');
	
	      // Once the md-bottom-sheet has `ng-cloak` applied on his template the opening animation will not work properly.
	      // This is a very common problem, so we have to notify the developer about this.
	      if (element.hasClass('ng-cloak')) {
	        var message = '$mdBottomSheet: using `<md-bottom-sheet ng-cloak>` will affect the bottom-sheet opening animations.';
	        $log.warn(message, element[0]);
	      }
	
	      if (options.isLockedOpen) {
	        options.clickOutsideToClose = false;
	        options.escapeToClose = false;
	      } else {
	        options.cleanupGestures = registerGestures(element, options.parent);
	      }
	
	      if (!options.disableBackdrop) {
	        // Add a backdrop that will close on click
	        backdrop = $mdUtil.createBackdrop(scope, "md-bottom-sheet-backdrop md-opaque");
	
	        // Prevent mouse focus on backdrop; ONLY programmatic focus allowed.
	        // This allows clicks on backdrop to propagate to the $rootElement and
	        // ESC key events to be detected properly.
	        backdrop[0].tabIndex = -1;
	
	        if (options.clickOutsideToClose) {
	          backdrop.on('click', function() {
	            $mdUtil.nextTick($mdBottomSheet.cancel, true);
	          });
	        }
	
	        $mdTheming.inherit(backdrop, options.parent);
	
	        $animate.enter(backdrop, options.parent, null);
	      }
	
	      $mdTheming.inherit(element, options.parent);
	
	      if (options.disableParentScroll) {
	        options.restoreScroll = $mdUtil.disableScrollAround(element, options.parent);
	      }
	
	      return $animate.enter(element, options.parent, backdrop)
	        .then(function() {
	          var focusable = $mdUtil.findFocusTarget(element) || angular.element(
	            element[0].querySelector('button') ||
	            element[0].querySelector('a') ||
	            element[0].querySelector($mdUtil.prefixer('ng-click', true))
	          ) || backdrop;
	
	          if (options.escapeToClose) {
	            options.rootElementKeyupCallback = function(e) {
	              if (e.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
	                $mdUtil.nextTick($mdBottomSheet.cancel, true);
	              }
	            };
	
	            $rootElement.on('keyup', options.rootElementKeyupCallback);
	            focusable && focusable.focus();
	          }
	        });
	
	    }
	
	    function onRemove(scope, element, options) {
	      if (!options.disableBackdrop) $animate.leave(backdrop);
	
	      return $animate.leave(element).then(function() {
	        if (options.disableParentScroll) {
	          options.restoreScroll();
	          delete options.restoreScroll;
	        }
	
	        options.cleanupGestures && options.cleanupGestures();
	      });
	    }
	
	    /**
	     * Adds the drag gestures to the bottom sheet.
	     * @param {JQLite} element where CSS transitions will be applied
	     * @param {JQLite} parent used for registering gesture listeners
	     * @return {Function} function that removes gesture listeners that were set up by
	     *  registerGestures()
	     */
	    function registerGestures(element, parent) {
	      var deregister = $mdGesture.register(parent, 'drag', { horizontal: false });
	      parent.on('$md.dragstart', onDragStart)
	        .on('$md.drag', onDrag)
	        .on('$md.dragend', onDragEnd);
	
	      return function cleanupGestures() {
	        deregister();
	        parent.off('$md.dragstart', onDragStart);
	        parent.off('$md.drag', onDrag);
	        parent.off('$md.dragend', onDragEnd);
	      };
	
	      function onDragStart() {
	        // Disable transitions on transform so that it feels fast
	        element.css($mdConstant.CSS.TRANSITION_DURATION, '0ms');
	      }
	
	      function onDrag(ev) {
	        var transform = ev.pointer.distanceY;
	        if (transform < 5) {
	          // Slow down drag when trying to drag up, and stop after PADDING
	          transform = Math.max(-PADDING, transform / 2);
	        }
	        element.css($mdConstant.CSS.TRANSFORM, 'translate3d(0,' + (PADDING + transform) + 'px,0)');
	      }
	
	      function onDragEnd(ev) {
	        if (ev.pointer.distanceY > 0 &&
	            (ev.pointer.distanceY > 20 || Math.abs(ev.pointer.velocityY) > CLOSING_VELOCITY)) {
	          var distanceRemaining = element.prop('offsetHeight') - ev.pointer.distanceY;
	          var transitionDuration = Math.min(distanceRemaining / ev.pointer.velocityY * 0.75, 500);
	          element.css($mdConstant.CSS.TRANSITION_DURATION, transitionDuration + 'ms');
	          $mdUtil.nextTick($mdBottomSheet.cancel, true);
	        } else {
	          element.css($mdConstant.CSS.TRANSITION_DURATION, '');
	          element.css($mdConstant.CSS.TRANSFORM, '');
	        }
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.button
	 * @description
	 *
	 * Button
	 */
	MdButtonDirective.$inject = ["$mdButtonInkRipple", "$mdTheming", "$mdAria", "$mdInteraction"];
	MdAnchorDirective.$inject = ["$mdTheming"];
	angular
	    .module('material.components.button', ['material.core'])
	    .directive('mdButton', MdButtonDirective)
	    .directive('a', MdAnchorDirective);
	
	
	/**
	 * @private
	 * @restrict E
	 *
	 * @description
	 * `a` is an anchor directive used to inherit theme colors for md-primary, md-accent, etc.
	 *
	 * @usage
	 *
	 * <hljs lang="html">
	 *  <md-content md-theme="myTheme">
	 *    <a href="#chapter1" class="md-accent"></a>
	 *  </md-content>
	 * </hljs>
	 */
	function MdAnchorDirective($mdTheming) {
	  return {
	    restrict : 'E',
	    link : function postLink(scope, element) {
	      // Make sure to inherit theme so stand-alone anchors
	      // support theme colors for md-primary, md-accent, etc.
	      $mdTheming(element);
	    }
	  };
	}
	
	
	/**
	 * @ngdoc directive
	 * @name mdButton
	 * @module material.components.button
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-button>` is a button directive with optional ink ripples (default enabled).
	 *
	 * If you supply a `href` or `ng-href` attribute, it will become an `<a>` element. Otherwise, it
	 * will become a `<button>` element. As per the
	 * [Material Design specifications](https://material.google.com/style/color.html#color-color-palette)
	 * the FAB button background is filled with the accent color [by default]. The primary color palette
	 * may be used with the `md-primary` class.
	 *
	 * Developers can also change the color palette of the button, by using the following classes
	 * - `md-primary`
	 * - `md-accent`
	 * - `md-warn`
	 *
	 * See for example
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-primary">Primary Button</md-button>
	 * </hljs>
	 *
	 * Button can be also raised, which means that they will use the current color palette to fill the button.
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-accent md-raised">Raised and Accent Button</md-button>
	 * </hljs>
	 *
	 * It is also possible to disable the focus effect on the button, by using the following markup.
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-no-focus">No Focus Style</md-button>
	 * </hljs>
	 *
	 * @param {string=} aria-label Adds alternative text to button for accessibility, useful for icon buttons.
	 * If no default text is found, a warning will be logged.
	 * @param {boolean=} md-no-ink If present, disable ink ripple effects.
	 * @param {string=} md-ripple-size Overrides the default ripple size logic. Options: `full`, `partial`, `auto`.
	 * @param {expression=} ng-disabled Disable the button when the expression is truthy.
	 * @param {expression=} ng-blur Expression evaluated when focus is removed from the button.
	 *
	 * @usage
	 *
	 * Regular buttons:
	 *
	 * <hljs lang="html">
	 *  <md-button> Flat Button </md-button>
	 *  <md-button href="http://google.com"> Flat link </md-button>
	 *  <md-button class="md-raised"> Raised Button </md-button>
	 *  <md-button ng-disabled="true"> Disabled Button </md-button>
	 *  <md-button>
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *    Register Now
	 *  </md-button>
	 * </hljs>
	 *
	 * FAB buttons:
	 *
	 * <hljs lang="html">
	 *  <md-button class="md-fab" aria-label="FAB">
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *  </md-button>
	 *  <!-- mini-FAB -->
	 *  <md-button class="md-fab md-mini" aria-label="Mini FAB">
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *  </md-button>
	 *  <!-- Button with SVG Icon -->
	 *  <md-button class="md-icon-button" aria-label="Custom Icon Button">
	 *    <md-icon md-svg-icon="path/to/your.svg"></md-icon>
	 *  </md-button>
	 * </hljs>
	 */
	function MdButtonDirective($mdButtonInkRipple, $mdTheming, $mdAria, $mdInteraction) {
	
	  return {
	    restrict: 'EA',
	    replace: true,
	    transclude: true,
	    template: getTemplate,
	    link: postLink
	  };
	
	  function isAnchor(attr) {
	    return angular.isDefined(attr.href) || angular.isDefined(attr.ngHref) || angular.isDefined(attr.ngLink) || angular.isDefined(attr.uiSref);
	  }
	
	  function getTemplate(element, attr) {
	    if (isAnchor(attr)) {
	      return '<a class="md-button" ng-transclude></a>';
	    } else {
	      // If buttons don't have type="button", they will submit forms automatically.
	      var btnType = (typeof attr.type === 'undefined') ? 'button' : attr.type;
	      return '<button class="md-button" type="' + btnType + '" ng-transclude></button>';
	    }
	  }
	
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	    $mdButtonInkRipple.attach(scope, element);
	
	    // Use async expect to support possible bindings in the button label
	    $mdAria.expectWithoutText(element, 'aria-label');
	
	    // For anchor elements, we have to set tabindex manually when the element is disabled.
	    // We don't do this for md-nav-bar anchors as the component manages its own tabindex values.
	    if (isAnchor(attr) && angular.isDefined(attr.ngDisabled) &&
	        !element.hasClass('_md-nav-button')) {
	      scope.$watch(attr.ngDisabled, function(isDisabled) {
	        element.attr('tabindex', isDisabled ? -1 : 0);
	      });
	    }
	
	    // disabling click event when disabled is true
	    element.on('click', function(e){
	      if (attr.disabled === true) {
	        e.preventDefault();
	        e.stopImmediatePropagation();
	      }
	    });
	
	    if (!element.hasClass('md-no-focus')) {
	
	      element.on('focus', function() {
	
	        // Only show the focus effect when being focused through keyboard interaction or programmatically
	        if (!$mdInteraction.isUserInvoked() || $mdInteraction.getLastInteractionType() === 'keyboard') {
	          element.addClass('md-focused');
	        }
	
	      });
	
	      element.on('blur', function() {
	        element.removeClass('md-focused');
	      });
	    }
	
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.card
	 *
	 * @description
	 * Card components.
	 */
	mdCardDirective.$inject = ["$mdTheming"];
	angular.module('material.components.card', [
	    'material.core'
	  ])
	  .directive('mdCard', mdCardDirective);
	
	
	/**
	 * @ngdoc directive
	 * @name mdCard
	 * @module material.components.card
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-card>` directive is a container element used within `<md-content>` containers.
	 *
	 * An image included as a direct descendant will fill the card's width. If you want to avoid this,
	 * you can add the `md-image-no-fill` class to the parent element. The `<md-card-content>`
	 * container will wrap text content and provide padding. An `<md-card-footer>` element can be
	 * optionally included to put content flush against the bottom edge of the card.
	 *
	 * Action buttons can be included in an `<md-card-actions>` element, similar to `<md-dialog-actions>`.
	 * You can then position buttons using layout attributes.
	 *
	 * Card is built with:
	 * * `<md-card-header>` - Header for the card, holds avatar, text and squared image
	 *  - `<md-card-avatar>` - Card avatar
	 *    - `md-user-avatar` - Class for user image
	 *    - `<md-icon>`
	 *  - `<md-card-header-text>` - Contains elements for the card description
	 *    - `md-title` - Class for the card title
	 *    - `md-subhead` - Class for the card sub header
	 * * `<img>` - Image for the card
	 * * `<md-card-title>` - Card content title
	 *  - `<md-card-title-text>`
	 *    - `md-headline` - Class for the card content title
	 *    - `md-subhead` - Class for the card content sub header
	 *  - `<md-card-title-media>` - Squared image within the title
	 *    - `md-media-sm` - Class for small image
	 *    - `md-media-md` - Class for medium image
	 *    - `md-media-lg` - Class for large image
	 *    - `md-media-xl` - Class for extra large image
	 * * `<md-card-content>` - Card content
	 * * `<md-card-actions>` - Card actions
	 *  - `<md-card-icon-actions>` - Icon actions
	 *
	 * Cards have constant width and variable heights; where the maximum height is limited to what can
	 * fit within a single view on a platform, but it can temporarily expand as needed.
	 *
	 * @usage
	 * ### Card with optional footer
	 * <hljs lang="html">
	 * <md-card>
	 *  <img src="card-image.png" class="md-card-image" alt="image caption">
	 *  <md-card-content>
	 *    <h2>Card headline</h2>
	 *    <p>Card content</p>
	 *  </md-card-content>
	 *  <md-card-footer>
	 *    Card footer
	 *  </md-card-footer>
	 * </md-card>
	 * </hljs>
	 *
	 * ### Card with actions
	 * <hljs lang="html">
	 * <md-card>
	 *  <img src="card-image.png" class="md-card-image" alt="image caption">
	 *  <md-card-content>
	 *    <h2>Card headline</h2>
	 *    <p>Card content</p>
	 *  </md-card-content>
	 *  <md-card-actions layout="row" layout-align="end center">
	 *    <md-button>Action 1</md-button>
	 *    <md-button>Action 2</md-button>
	 *  </md-card-actions>
	 * </md-card>
	 * </hljs>
	 *
	 * ### Card with header, image, title actions and content
	 * <hljs lang="html">
	 * <md-card>
	 *   <md-card-header>
	 *     <md-card-avatar>
	 *       <img class="md-user-avatar" src="avatar.png"/>
	 *     </md-card-avatar>
	 *     <md-card-header-text>
	 *       <span class="md-title">Title</span>
	 *       <span class="md-subhead">Sub header</span>
	 *     </md-card-header-text>
	 *   </md-card-header>
	 *   <img ng-src="card-image.png" class="md-card-image" alt="image caption">
	 *   <md-card-title>
	 *     <md-card-title-text>
	 *       <span class="md-headline">Card headline</span>
	 *       <span class="md-subhead">Card subheader</span>
	 *     </md-card-title-text>
	 *   </md-card-title>
	 *   <md-card-actions layout="row" layout-align="start center">
	 *     <md-button>Action 1</md-button>
	 *     <md-button>Action 2</md-button>
	 *     <md-card-icon-actions>
	 *       <md-button class="md-icon-button" aria-label="icon">
	 *         <md-icon md-svg-icon="icon"></md-icon>
	 *       </md-button>
	 *     </md-card-icon-actions>
	 *   </md-card-actions>
	 *   <md-card-content>
	 *     <p>
	 *      Card content
	 *     </p>
	 *   </md-card-content>
	 * </md-card>
	 * </hljs>
	 */
	function mdCardDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    link: function ($scope, $element, attr) {
	      $element.addClass('_md');     // private md component indicator for styling
	      $mdTheming($element);
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.checkbox
	 * @description Checkbox module!
	 */
	MdCheckboxDirective.$inject = ["inputDirective", "$mdAria", "$mdConstant", "$mdTheming", "$mdUtil", "$mdInteraction"];
	angular
	  .module('material.components.checkbox', ['material.core'])
	  .directive('mdCheckbox', MdCheckboxDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdCheckbox
	 * @module material.components.checkbox
	 * @restrict E
	 *
	 * @description
	 * The checkbox directive is used like the normal
	 * [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
	 *
	 * As per the [Material Design spec](https://material.io/archive/guidelines/style/color.html#color-color-palette)
	 * the checkbox is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * @param {expression} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
	 * @param {expression=} ng-false-value The value to which the expression should be set when not
	 *    selected.
	 * @param {expression=} ng-change Expression to be executed when the model value changes.
	 * @param {boolean=} md-no-ink If present, disable ink ripple effects.
	 * @param {string=} aria-label Adds label to checkbox for accessibility.
	 *    Defaults to checkbox's text. If no default text is found, a warning will be logged.
	 * @param {expression=} md-indeterminate This determines when the checkbox should be rendered as
	 *    'indeterminate'. If a truthy expression or no value is passed in the checkbox renders in the
	 *    md-indeterminate state. If falsy expression is passed in it just looks like a normal unchecked
	 *    checkbox. The indeterminate, checked, and unchecked states are mutually exclusive. A box
	 *    cannot be in any two states at the same time. Adding the 'md-indeterminate' attribute
	 *    overrides any checked/unchecked rendering logic. When using the 'md-indeterminate' attribute
	 *    use 'ng-checked' to define rendering logic instead of using 'ng-model'.
	 * @param {expression=} ng-checked If this expression evaluates as truthy, the 'md-checked' css
	 *    class is added to the checkbox and it will appear checked.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-checkbox ng-model="isChecked" aria-label="Finished?">
	 *   Finished ?
	 * </md-checkbox>
	 *
	 * <md-checkbox md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
	 *   No Ink Effects
	 * </md-checkbox>
	 *
	 * <md-checkbox ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
	 *   Disabled
	 * </md-checkbox>
	 *
	 * </hljs>
	 *
	 */
	function MdCheckboxDirective(inputDirective, $mdAria, $mdConstant, $mdTheming, $mdUtil, $mdInteraction) {
	  inputDirective = inputDirective[0];
	
	  return {
	    restrict: 'E',
	    transclude: true,
	    require: ['^?mdInputContainer', '?ngModel', '?^form'],
	    priority: $mdConstant.BEFORE_NG_ARIA,
	    template:
	      '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
	        '<div class="md-icon"></div>' +
	      '</div>' +
	      '<div ng-transclude class="md-label"></div>',
	    compile: compile
	  };
	
	  // **********************************************************
	  // Private Methods
	  // **********************************************************
	
	  function compile (tElement, tAttrs) {
	    tAttrs.$set('tabindex', tAttrs.tabindex || '0');
	    tAttrs.$set('type', 'checkbox');
	    tAttrs.$set('role', tAttrs.type);
	    tElement.addClass('md-auto-horizontal-margin');
	
	    return  {
	      pre: function(scope, element) {
	        // Attach a click handler during preLink, in order to immediately stop propagation
	        // (especially for ng-click) when the checkbox is disabled.
	        element.on('click', function(e) {
	          if (this.hasAttribute('disabled')) {
	            e.stopImmediatePropagation();
	          }
	        });
	      },
	      post: postLink
	    };
	
	    function postLink(scope, element, attr, ctrls) {
	      var isIndeterminate;
	      var containerCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
	      var formCtrl = ctrls[2];
	      var labelHasLink = element.find('a').length > 0;
	
	      // The original component structure is not accessible when the checkbox's label contains a link.
	      // In order to keep backwards compatibility, we're only changing the structure of the component
	      // when we detect a link within the label. Using a span after the md-checkbox and attaching it
	      // via aria-labelledby allows screen readers to find and work with the link within the label.
	      if (labelHasLink) {
	        var labelId = 'label-' + $mdUtil.nextUid();
	        attr.$set('aria-labelledby', labelId);
	
	        var label = element.children()[1];
	        // Use jQLite here since ChildNode.remove() is not supported in IE11.
	        angular.element(label).remove();
	        label.removeAttribute('ng-transclude');
	        label.className = 'md-checkbox-link-label';
	        label.setAttribute('id', labelId);
	        element.after(label);
	        // Make sure that clicking on the label still causes the checkbox to be toggled, when appropriate.
	        var externalLabel = element.next();
	        externalLabel.on('click', listener);
	      }
	
	      if (containerCtrl) {
	        var isErrorGetter = containerCtrl.isErrorGetter || function() {
	          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
	        };
	
	        containerCtrl.input = element;
	
	        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	      }
	
	      $mdTheming(element);
	
	      // Redirect focus events to the root element, because IE11 is always focusing the container element instead
	      // of the md-checkbox element. This causes issues when using ngModelOptions: `updateOnBlur`
	      element.children().on('focus', function() {
	        element.focus();
	      });
	
	      if ($mdUtil.parseAttributeBoolean(attr.mdIndeterminate)) {
	        setIndeterminateState();
	        scope.$watch(attr.mdIndeterminate, setIndeterminateState);
	      }
	
	      if (attr.ngChecked) {
	        scope.$watch(scope.$eval.bind(scope, attr.ngChecked), function(value) {
	          ngModelCtrl.$setViewValue(value);
	          ngModelCtrl.$render();
	        });
	      }
	
	      $$watchExpr('ngDisabled', 'tabindex', {
	        true: '-1',
	        false: attr.tabindex
	      });
	
	      // Don't emit a warning when the label has a link within it. In that case we'll use
	      // aria-labelledby to point to another span that should be read as the label.
	      if (!labelHasLink) {
	        $mdAria.expectWithText(element, 'aria-label');
	      }
	
	      // Reuse the original input[type=checkbox] directive from AngularJS core.
	      // This is a bit hacky as we need our own event listener and own render
	      // function.
	      inputDirective.link.pre(scope, {
	        on: angular.noop,
	        0: {}
	      }, attr, [ngModelCtrl]);
	
	      element.on('click', listener)
	        .on('keypress', keypressHandler)
	        .on('focus', function() {
	          if ($mdInteraction.getLastInteractionType() === 'keyboard') {
	            element.addClass('md-focused');
	          }
	        })
	        .on('blur', function() {
	          element.removeClass('md-focused');
	        });
	
	      ngModelCtrl.$render = render;
	
	      function $$watchExpr(expr, htmlAttr, valueOpts) {
	        if (attr[expr]) {
	          scope.$watch(attr[expr], function(val) {
	            if (valueOpts[val]) {
	              element.attr(htmlAttr, valueOpts[val]);
	            }
	          });
	        }
	      }
	
	      /**
	       * @param {KeyboardEvent} ev 'keypress' event to handle
	       */
	      function keypressHandler(ev) {
	        var keyCode = ev.which || ev.keyCode;
	        var submit, form;
	
	        ev.preventDefault();
	        switch (keyCode) {
	          case $mdConstant.KEY_CODE.SPACE:
	            element.addClass('md-focused');
	            listener(ev);
	            break;
	          case $mdConstant.KEY_CODE.ENTER:
	            // Match the behavior of the native <input type="checkbox">.
	            // When the enter key is pressed while focusing a native checkbox inside a form,
	            // the browser will trigger a `click` on the first non-disabled submit button/input
	            // in the form. Note that this is different from text inputs, which
	            // will directly submit the form without needing a submit button/input to be present.
	            form = $mdUtil.getClosest(ev.target, 'form');
	            if (form) {
	              submit = form.querySelector('button[type="submit"]:enabled, input[type="submit"]:enabled');
	              if (submit) {
	                submit.click();
	              }
	            }
	            break;
	        }
	      }
	
	      function listener(ev) {
	        // skipToggle boolean is used by the switch directive to prevent the click event
	        // when releasing the drag. There will be always a click if releasing the drag over the checkbox.
	        // If the click came from a link in the checkbox, don't toggle the value.
	        // We want the link to be opened without changing the value in this case.
	        if (element[0].hasAttribute('disabled') || scope.skipToggle || ev.target.tagName === 'A') {
	          return;
	        }
	
	        scope.$apply(function() {
	          // Toggle the checkbox value...
	          var viewValue = attr.ngChecked && attr.ngClick ? attr.checked : !ngModelCtrl.$viewValue;
	
	          ngModelCtrl.$setViewValue(viewValue, ev && ev.type);
	          ngModelCtrl.$render();
	        });
	      }
	
	      function render() {
	        // Cast the $viewValue to a boolean since it could be undefined
	        var checked = !!ngModelCtrl.$viewValue && !isIndeterminate;
	        element.toggleClass('md-checked', checked);
	        if (!isIndeterminate) {
	          if (checked) {
	            element.attr('aria-checked', 'true');
	          } else {
	            element.attr('aria-checked', 'false');
	          }
	        }
	      }
	
	      /**
	       * @param {string=} newValue
	       */
	      function setIndeterminateState(newValue) {
	        isIndeterminate = newValue !== false;
	        if (isIndeterminate) {
	          element.attr('aria-checked', 'mixed');
	        }
	        element.toggleClass('md-indeterminate', isIndeterminate);
	        ngModelCtrl.$render();
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.chips
	 */
	/*
	 * @see js folder for chips implementation
	 */
	angular.module('material.components.chips', [
	  'material.core',
	  'material.components.autocomplete'
	]);
	
	})();
	(function(){
	"use strict";
	
	
	MdChipCtrl.$inject = ["$scope", "$element", "$mdConstant", "$timeout", "$mdUtil"];angular
	  .module('material.components.chips')
	  .controller('MdChipCtrl', MdChipCtrl);
	
	/**
	 * Controller for the MdChip component. Responsible for handling keyboard
	 * events and editing the chip if needed.
	 *
	 * @param $scope
	 * @param $element
	 * @param $mdConstant
	 * @param $timeout
	 * @param $mdUtil
	 * @constructor
	 */
	function MdChipCtrl ($scope, $element, $mdConstant, $timeout, $mdUtil) {
	  /**
	   * @type {$scope}
	   */
	  this.$scope = $scope;
	
	  /**
	   * @type {$element}
	   */
	  this.$element = $element;
	
	  /**
	   * @type {$mdConstant}
	   */
	  this.$mdConstant = $mdConstant;
	
	  /**
	   * @type {$timeout}
	   */
	  this.$timeout = $timeout;
	
	  /**
	   * @type {$mdUtil}
	   */
	  this.$mdUtil = $mdUtil;
	
	  /**
	   * @type {boolean}
	   */
	  this.isEditing = false;
	
	  /**
	   * @type {MdChipsCtrl}
	   */
	  this.parentController = undefined;
	
	  /**
	   * @type {boolean}
	   */
	  this.enableChipEdit = false;
	}
	
	
	/**
	 * @param {MdChipsCtrl} controller
	 */
	MdChipCtrl.prototype.init = function(controller) {
	  this.parentController = controller;
	  this.enableChipEdit = this.parentController.enableChipEdit;
	
	  if (this.enableChipEdit) {
	    this.$element.on('keydown', this.chipKeyDown.bind(this));
	    this.$element.on('dblclick', this.chipMouseDoubleClick.bind(this));
	    this.getChipContent().addClass('_md-chip-content-edit-is-enabled');
	  }
	};
	
	
	/**
	 * @return {Object} first element with the md-chip-content class
	 */
	MdChipCtrl.prototype.getChipContent = function() {
	  var chipContents = this.$element[0].getElementsByClassName('md-chip-content');
	  return angular.element(chipContents[0]);
	};
	
	
	/**
	 * When editing the chip, if the user modifies the existing contents, we'll get a span back and
	 * need to ignore text elements as they only contain blank space.
	 * `children()` ignores text elements.
	 *
	 * When editing the chip, if the user deletes the contents and then enters some new content
	 * we'll only get a text element back.
	 * @return {Object} jQuery object representing the content element of the chip
	 */
	MdChipCtrl.prototype.getContentElement = function() {
	  var contentElement = angular.element(this.getChipContent().children()[0]);
	  if (!contentElement || contentElement.length === 0) {
	    contentElement = angular.element(this.getChipContent().contents()[0]);
	  }
	  return contentElement;
	};
	
	
	/**
	 * @return {number} index of this chip
	 */
	MdChipCtrl.prototype.getChipIndex = function() {
	  return parseInt(this.$element.attr('index'));
	};
	
	
	/**
	 * Update the chip's contents, focus the chip if it's selected, and exit edit mode.
	 * If the contents were updated to be empty, remove the chip and re-focus the input element.
	 */
	MdChipCtrl.prototype.goOutOfEditMode = function() {
	  if (!this.isEditing) {
	    return;
	  }
	
	  this.isEditing = false;
	  this.$element.removeClass('_md-chip-editing');
	  this.getChipContent()[0].contentEditable = 'false';
	  var chipIndex = this.getChipIndex();
	
	  var content = this.getContentElement().text();
	  if (content) {
	    this.parentController.updateChipContents(chipIndex, content);
	
	    this.$mdUtil.nextTick(function() {
	      if (this.parentController.selectedChip === chipIndex) {
	        this.parentController.focusChip(chipIndex);
	      }
	    }.bind(this));
	  } else {
	    this.parentController.removeChipAndFocusInput(chipIndex);
	  }
	};
	
	
	/**
	 * Given an HTML element. Selects contents of it.
	 * @param {Element} node
	 */
	MdChipCtrl.prototype.selectNodeContents = function(node) {
	  var range, selection;
	  if (document.body.createTextRange) {
	    range = document.body.createTextRange();
	    range.moveToElementText(node);
	    range.select();
	  } else if (window.getSelection) {
	    selection = window.getSelection();
	    range = document.createRange();
	    range.selectNodeContents(node);
	    selection.removeAllRanges();
	    selection.addRange(range);
	  }
	};
	
	
	/**
	 * Presents an input element to edit the contents of the chip.
	 */
	MdChipCtrl.prototype.goInEditMode = function() {
	  this.isEditing = true;
	  this.$element.addClass('_md-chip-editing');
	  this.getChipContent()[0].contentEditable = 'true';
	  this.getChipContent().on('blur', function() {
	    this.goOutOfEditMode();
	  }.bind(this));
	
	  this.selectNodeContents(this.getChipContent()[0]);
	};
	
	
	/**
	 * Handles the keydown event on the chip element. If enable-chip-edit attribute is
	 * set to true, space or enter keys can trigger going into edit mode. Enter can also
	 * trigger submitting if the chip is already being edited.
	 * @param {KeyboardEvent} event
	 */
	MdChipCtrl.prototype.chipKeyDown = function(event) {
	  if (!this.isEditing &&
	    (event.keyCode === this.$mdConstant.KEY_CODE.ENTER ||
	      event.keyCode === this.$mdConstant.KEY_CODE.SPACE)) {
	    event.preventDefault();
	    this.goInEditMode();
	  } else if (this.isEditing && event.keyCode === this.$mdConstant.KEY_CODE.ENTER) {
	    event.preventDefault();
	    this.goOutOfEditMode();
	  }
	};
	
	
	/**
	 * Enter edit mode if we're not already editing and the enable-chip-edit attribute is enabled.
	 */
	MdChipCtrl.prototype.chipMouseDoubleClick = function() {
	  if (this.enableChipEdit && !this.isEditing) {
	    this.goInEditMode();
	  }
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdChip.$inject = ["$mdTheming", "$mdUtil", "$compile", "$timeout"];angular
	  .module('material.components.chips')
	  .directive('mdChip', MdChip);
	
	/**
	 * @ngdoc directive
	 * @name mdChip
	 * @module material.components.chips
	 *
	 * @description
	 * `<md-chip>` is a component used within `<md-chips>`. It is responsible for rendering an
	 * individual chip.
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-chips>
	 *     <md-chip>{{$chip}}</md-chip>
	 *   </md-chips>
	 * </hljs>
	 *
	 */
	
	/**
	 * MDChip Directive Definition
	 *
	 * @param $mdTheming
	 * @param $mdUtil
	 * @param $compile
	 * @param $timeout
	 * @ngInject
	 */
	function MdChip($mdTheming, $mdUtil, $compile, $timeout) {
	  return {
	    restrict: 'E',
	    require: ['^?mdChips', 'mdChip'],
	    link: postLink,
	    controller: 'MdChipCtrl'
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	    var chipsController = ctrls.shift();
	    var chipController = ctrls.shift();
	    var chipContentElement = angular.element(element[0].querySelector('.md-chip-content'));
	
	    $mdTheming(element);
	
	    if (chipsController) {
	      chipController.init(chipsController);
	
	      // When a chip is blurred, make sure to unset (or reset) the selected chip so that tabbing
	      // through elements works properly
	      chipContentElement.on('blur', function() {
	        chipsController.resetSelectedChip();
	        chipsController.$scope.$applyAsync();
	      });
	    }
	
	    // Use $timeout to ensure we run AFTER the element has been added to the DOM so we can focus it.
	    $timeout(function() {
	      if (!chipsController) {
	        return;
	      }
	
	      if (chipsController.shouldFocusLastChip) {
	        chipsController.focusLastChipThenInput();
	      }
	    });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipRemove.$inject = ["$timeout"];angular
	    .module('material.components.chips')
	    .directive('mdChipRemove', MdChipRemove);
	
	/**
	 * @ngdoc directive
	 * @name mdChipRemove
	 * @restrict A
	 * @module material.components.chips
	 *
	 * @description
	 * Indicates that the associated element should be used as the delete button template for all chips.
	 * The associated element must be a child of `md-chips`.
	 *
	 * The provided button template will be appended to each chip and will remove the associated chip
	 * on click.
	 *
	 * The button is not styled or themed based on the theme set on the `md-chips` component. A theme
	 * class and custom icon can be specified in your template.
	 *
	 * You can also specify the `type` of the button in your template.
	 *
	 * @usage
	 * ### With Standard Chips
	 * <hljs lang="html">
	 *   <md-chips ...>
	 *     <button md-chip-remove type="button" aria-label="Remove {{$chip}}">
	 *       <md-icon md-svg-icon="md-cancel"></md-icon>
	 *     </button>
	 *   </md-chips>
	 * </hljs>
	 *
	 * ### With Object Chips
	 * <hljs lang="html">
	 *   <md-chips ...>
	 *     <button md-chip-remove type="button" aria-label="Remove {{$chip.name}}">
	 *       <md-icon md-svg-icon="md-cancel"></md-icon>
	 *     </button>
	 *   </md-chips>
	 * </hljs>
	 */
	
	
	/**
	 * MdChipRemove Directive Definition.
	 *
	 * @param $timeout
	 * @returns {{restrict: string, require: string[], link: Function, scope: boolean}}
	 * @constructor
	 */
	function MdChipRemove ($timeout) {
	  return {
	    restrict: 'A',
	    require: '^mdChips',
	    scope: false,
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrl) {
	    element.on('click', function() {
	      scope.$apply(function() {
	        ctrl.removeChip(scope.$$replacedScope.$index);
	      });
	    });
	
	    // Child elements aren't available until after a $timeout tick as they are hidden by an
	    // `ng-if`. see http://goo.gl/zIWfuw
	    $timeout(function() {
	      element.attr({ 'tabindex': '-1', 'aria-hidden': 'true' });
	      element.find('button').attr('tabindex', '-1');
	    });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipTransclude.$inject = ["$compile"];angular
	    .module('material.components.chips')
	    .directive('mdChipTransclude', MdChipTransclude);
	
	function MdChipTransclude ($compile) {
	  return {
	    restrict: 'EA',
	    terminal: true,
	    link: link,
	    scope: false
	  };
	  function link (scope, element, attr) {
	    var ctrl = scope.$parent.$mdChipsCtrl,
	        newScope = ctrl.parent.$new(false, ctrl.parent);
	    newScope.$$replacedScope = scope;
	    newScope.$chip = scope.$chip;
	    newScope.$index = scope.$index;
	    newScope.$mdChipsCtrl = ctrl;
	
	    var newHtml = ctrl.$scope.$eval(attr.mdChipTransclude);
	
	    element.html(newHtml);
	    $compile(element.contents())(newScope);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * The default chip append delay.
	 *
	 * @type {number}
	 */
	MdChipsCtrl.$inject = ["$scope", "$attrs", "$mdConstant", "$log", "$element", "$timeout", "$mdUtil", "$mdLiveAnnouncer", "$exceptionHandler"];
	var DEFAULT_CHIP_APPEND_DELAY = 300;
	
	angular
	    .module('material.components.chips')
	    .controller('MdChipsCtrl', MdChipsCtrl);
	
	/**
	 * Controller for the MdChips component. Responsible for adding to and
	 * removing from the list of chips, marking chips as selected, and binding to
	 * the models of various input components.
	 *
	 * @param $scope
	 * @param $attrs
	 * @param $mdConstant
	 * @param $log
	 * @param $element
	 * @param $timeout
	 * @param $mdUtil
	 * @param $mdLiveAnnouncer
	 * @param $exceptionHandler
	 * @constructor
	 */
	function MdChipsCtrl ($scope, $attrs, $mdConstant, $log, $element, $timeout, $mdUtil,
	                      $mdLiveAnnouncer, $exceptionHandler) {
	  /** @type {Function} **/
	  this.$timeout = $timeout;
	
	  /** @type {Object} */
	  this.$mdConstant = $mdConstant;
	
	  /** @type {angular.$scope} */
	  this.$scope = $scope;
	
	  /** @type {angular.$scope} */
	  this.parent = $scope.$parent;
	
	  /** @type {$mdUtil} */
	  this.$mdUtil = $mdUtil;
	
	  /** @type {$log} */
	  this.$log = $log;
	
	  /** @type {$mdLiveAnnouncer} */
	  this.$mdLiveAnnouncer = $mdLiveAnnouncer;
	
	  /** @type {$exceptionHandler} */
	  this.$exceptionHandler = $exceptionHandler;
	
	  /** @type {$element} */
	  this.$element = $element;
	
	  /** @type {$attrs} */
	  this.$attrs = $attrs;
	
	  /** @type {angular.NgModelController} */
	  this.ngModelCtrl = null;
	
	  /** @type {angular.NgModelController} */
	  this.userInputNgModelCtrl = null;
	
	  /** @type {MdAutocompleteCtrl} */
	  this.autocompleteCtrl = null;
	
	  /** @type {Element} */
	  this.userInputElement = null;
	
	  /** @type {Array.<Object>} */
	  this.items = [];
	
	  /** @type {number} */
	  this.selectedChip = -1;
	
	  /** @type {string} */
	  this.enableChipEdit = $mdUtil.parseAttributeBoolean($attrs.mdEnableChipEdit);
	
	  /** @type {string} */
	  this.addOnBlur = $mdUtil.parseAttributeBoolean($attrs.mdAddOnBlur);
	
	  /**
	   * The class names to apply to the autocomplete or input.
	   * @type {string}
	   */
	  this.inputClass = '';
	
	  /**
	   * The text to be used as the aria-label for the input.
	   * @type {string}
	   */
	  this.inputAriaLabel = 'Chips input.';
	
	  /**
	   * Label text to describe the chips container. Used to give context and instructions to screen
	   * reader users when the chips container is selected.
	   * @type {string}
	   */
	  this.containerHint = 'Chips container. Use arrow keys to select chips.';
	
	  /**
	   * Label text to describe the chips container when it is empty. Used to give context and
	   * instructions to screen reader users when the chips container is selected and it contains
	   * no chips.
	   * @type {string}
	   */
	  this.containerEmptyHint =
	    'Chips container. Enter the text area, then type text, and press enter to add a chip.';
	
	  /**
	   * Hidden hint text for how to delete a chip. Used to give context to screen readers.
	   * @type {string}
	   */
	  this.deleteHint = 'Press delete to remove this chip.';
	
	  /**
	   * Hidden label for the delete button. Used to give context to screen readers.
	   * @type {string}
	   */
	  this.deleteButtonLabel = 'Remove';
	
	  /**
	   * Model used by the input element.
	   * @type {string}
	   */
	  this.chipBuffer = '';
	
	  /**
	   * Whether to use the transformChip expression to transform the chip buffer
	   * before appending it to the list.
	   * @type {boolean}
	   */
	  this.useTransformChip = false;
	
	  /**
	   * Whether to use the onAdd expression to notify of chip additions.
	   * @type {boolean}
	   */
	  this.useOnAdd = false;
	
	  /**
	   * Whether to use the onRemove expression to notify of chip removals.
	   * @type {boolean}
	   */
	  this.useOnRemove = false;
	
	  /**
	   * The ID of the chips wrapper which is used to build unique IDs for the chips and the aria-owns
	   * attribute.
	   *
	   * Defaults to '_md-chips-wrapper-' plus a unique number.
	   *
	   * @type {string}
	   */
	  this.wrapperId = '';
	
	  /**
	   * Array of unique numbers which will be auto-generated any time the items change, and is used to
	   * create unique IDs for the aria-owns attribute.
	   *
	   * @type {Array<number>}
	   */
	  this.contentIds = [];
	
	  /**
	   * The index of the chip that should have it's `tabindex` property set to `0` so it is selectable
	   * via the keyboard.
	   *
	   * @type {number|null}
	   */
	  this.ariaTabIndex = null;
	
	  /**
	   * After appending a chip, the chip will be focused for this number of milliseconds before the
	   * input is refocused.
	   *
	   * **Note:** This is **required** for compatibility with certain screen readers in order for
	   * them to properly allow keyboard access.
	   *
	   * @type {number}
	   */
	  this.chipAppendDelay = DEFAULT_CHIP_APPEND_DELAY;
	
	  /**
	   * Collection of functions to call to un-register watchers
	   *
	   * @type {Array}
	   */
	  this.deRegister = [];
	
	  /**
	   * The screen reader will announce the chip content followed by this message when a chip is added.
	   * @type {string}
	   */
	  this.addedMessage = 'added';
	
	  /**
	   * The screen reader will announce the chip content followed by this message when a chip is
	   * removed.
	   * @type {string}
	   */
	  this.removedMessage = 'removed';
	
	  this.init();
	}
	
	/**
	 * Initializes variables and sets up watchers
	 */
	MdChipsCtrl.prototype.init = function() {
	  var ctrl = this;
	
	  // Set the wrapper ID
	  this.wrapperId = '_md-chips-wrapper-' + this.$mdUtil.nextUid();
	
	  // If we're using static chips, then we need to initialize a few things.
	  if (!this.$element.attr('ng-model')) {
	    this.setupStaticChips();
	  }
	
	  // Setup a watcher which manages the role and aria-owns attributes.
	  // This is never called for static chips since items is not defined.
	  this.deRegister.push(
	    this.$scope.$watchCollection('$mdChipsCtrl.items', function() {
	      // Make sure our input and wrapper have the correct ARIA attributes
	      ctrl.setupInputAria();
	      ctrl.setupWrapperAria();
	    })
	  );
	
	  this.deRegister.push(
	    this.$attrs.$observe('mdChipAppendDelay', function(newValue) {
	      ctrl.chipAppendDelay = parseInt(newValue) || DEFAULT_CHIP_APPEND_DELAY;
	    })
	  );
	};
	
	/**
	 * Destructor for cleanup
	 */
	MdChipsCtrl.prototype.$onDestroy = function $onDestroy() {
	  var $destroyFn;
	  while (($destroyFn = this.deRegister.pop())) {
	    $destroyFn.call(this);
	  }
	};
	
	/**
	 * If we have an input, ensure it has the appropriate ARIA attributes.
	 */
	MdChipsCtrl.prototype.setupInputAria = function() {
	  var input = this.$element.find('input');
	
	  // If we have no input, just return
	  if (!input) {
	    return;
	  }
	
	  input.attr('role', 'textbox');
	  input.attr('aria-multiline', true);
	  if (this.inputAriaDescribedBy) {
	    input.attr('aria-describedby', this.inputAriaDescribedBy);
	  }
	  if (this.inputAriaLabelledBy) {
	    input.attr('aria-labelledby', this.inputAriaLabelledBy);
	    input.removeAttr('aria-label');
	  } else {
	    input.attr('aria-label', this.inputAriaLabel);
	  }
	};
	
	/**
	 * Ensure our wrapper has the appropriate ARIA attributes.
	 */
	MdChipsCtrl.prototype.setupWrapperAria = function() {
	  var ctrl = this,
	      wrapper = this.$element.find('md-chips-wrap');
	
	  if (this.items && this.items.length) {
	    // Dynamically add the listbox role on every change because it must be removed when there are
	    // no items.
	    wrapper.attr('role', 'listbox');
	
	    // Generate some random (but unique) IDs for each chip
	    this.contentIds = this.items.map(function() {
	      return ctrl.wrapperId + '-chip-' + ctrl.$mdUtil.nextUid();
	    });
	
	    // Use the contentIDs above to generate the aria-owns attribute
	    wrapper.attr('aria-owns', this.contentIds.join(' '));
	    wrapper.attr('aria-label', this.containerHint);
	  } else {
	    // If we have no items, then the role and aria-owns attributes MUST be removed
	    wrapper.removeAttr('role');
	    wrapper.removeAttr('aria-owns');
	    wrapper.attr('aria-label', this.containerEmptyHint);
	  }
	};
	
	/**
	 * Apply specific roles and aria attributes for static chips
	 */
	MdChipsCtrl.prototype.setupStaticChips = function() {
	  var ctrl = this, i, staticChips;
	  var wrapper = this.$element.find('md-chips-wrap');
	
	  this.$timeout(function() {
	    wrapper.attr('role', 'list');
	    staticChips = wrapper[0].children;
	    for (i = 0; i < staticChips.length; i++) {
	      staticChips[i].setAttribute('role', 'listitem');
	      staticChips[i].setAttribute('aria-setsize', staticChips.length);
	    }
	    if (ctrl.inputAriaDescribedBy) {
	      wrapper.attr('aria-describedby', ctrl.inputAriaDescribedBy);
	    }
	    if (ctrl.inputAriaLabelledBy) {
	      wrapper.attr('aria-labelledby', ctrl.inputAriaLabelledBy);
	      wrapper.removeAttr('aria-label');
	    } else {
	      wrapper.attr('aria-label', ctrl.inputAriaLabel);
	    }
	  }, 10);
	};
	
	/**
	 * Handles the keydown event on the input element: by default <enter> appends
	 * the buffer to the chip list, while backspace removes the last chip in the
	 * list if the current buffer is empty.
	 * @param {jQuery.Event|KeyboardEvent} event
	 */
	MdChipsCtrl.prototype.inputKeydown = function(event) {
	  var chipBuffer = this.getChipBuffer();
	
	  // If we have an autocomplete, and it handled the event, we have nothing to do
	  if (this.autocompleteCtrl && event.isDefaultPrevented && event.isDefaultPrevented()) {
	    return;
	  }
	
	  if (event.keyCode === this.$mdConstant.KEY_CODE.BACKSPACE) {
	    // Only select and focus the previous chip, if the current caret position of the
	    // input element is at the beginning.
	    if (this.getCursorPosition(event.target) !== 0) {
	      return;
	    }
	
	    event.preventDefault();
	    event.stopPropagation();
	
	    if (this.items.length) {
	      this.selectAndFocusChipSafe(this.items.length - 1);
	    }
	
	    return;
	  }
	
	  // By default <enter> appends the buffer to the chip list.
	  if (!this.separatorKeys || this.separatorKeys.length < 1) {
	    this.separatorKeys = [this.$mdConstant.KEY_CODE.ENTER];
	  }
	
	  // Support additional separator key codes in an array of `md-separator-keys`.
	  if (this.separatorKeys.indexOf(event.keyCode) !== -1) {
	    if ((this.autocompleteCtrl && this.requireMatch) || !chipBuffer) return;
	    event.preventDefault();
	
	    // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
	    if (this.hasMaxChipsReached()) return;
	
	    this.appendChip(chipBuffer.trim());
	    this.resetChipBuffer();
	
	    return false;
	  }
	};
	
	/**
	 * Returns the cursor position of the specified input element.
	 * @param {HTMLInputElement} element relevant input element
	 * @returns {Number} Cursor Position of the input.
	 */
	MdChipsCtrl.prototype.getCursorPosition = function(element) {
	  /*
	   * Figure out whether the current input for the chips buffer is valid for using
	   * the selectionStart / end property to retrieve the cursor position.
	   * Some browsers do not allow the use of those attributes, on different input types.
	   */
	  try {
	    if (element.selectionStart === element.selectionEnd) {
	      return element.selectionStart;
	    }
	  } catch (e) {
	    if (!element.value) {
	      return 0;
	    }
	  }
	};
	
	
	/**
	 * Updates the content of the chip at given index
	 * @param {number} chipIndex
	 * @param {string} chipContents
	 */
	MdChipsCtrl.prototype.updateChipContents = function(chipIndex, chipContents) {
	  if (chipIndex >= 0 && chipIndex < this.items.length) {
	    this.items[chipIndex] = chipContents;
	    this.updateNgModel(true);
	  }
	};
	
	
	/**
	 * @return {boolean} true if a chip is currently being edited. False otherwise.
	 */
	MdChipsCtrl.prototype.isEditingChip = function() {
	  return !!this.$element[0].querySelector('._md-chip-editing');
	};
	
	/**
	 * @param {string|Object} chip contents of a single chip
	 * @returns {boolean} true if the chip is an Object, false otherwise.
	 * @private
	 */
	MdChipsCtrl.prototype._isChipObject = function(chip) {
	  return angular.isObject(chip);
	};
	
	/**
	 * @returns {boolean} true if chips can be removed, false otherwise.
	 */
	MdChipsCtrl.prototype.isRemovable = function() {
	  // Return false if we have static chips
	  if (!this.ngModelCtrl) {
	    return false;
	  }
	
	  return this.readonly ? this.removable :
	         angular.isDefined(this.removable) ? this.removable : true;
	};
	
	/**
	 * Handles the keydown event on the chip elements: backspace removes the selected chip, arrow
	 * keys switch which chip is active.
	 * @param {KeyboardEvent} event
	 */
	MdChipsCtrl.prototype.chipKeydown = function (event) {
	  if (this.getChipBuffer()) return;
	  if (this.isEditingChip()) return;
	
	  switch (event.keyCode) {
	    case this.$mdConstant.KEY_CODE.BACKSPACE:
	    case this.$mdConstant.KEY_CODE.DELETE:
	      if (this.selectedChip < 0) return;
	      event.preventDefault();
	      // Cancel the delete action only after the event cancel. Otherwise the page will go back.
	      if (!this.isRemovable()) return;
	      this.removeAndSelectAdjacentChip(this.selectedChip, event);
	      break;
	    case this.$mdConstant.KEY_CODE.LEFT_ARROW:
	      event.preventDefault();
	      // By default, allow selection of -1 which will focus the input; if we're readonly, don't go
	      // below 0.
	      if (this.selectedChip < 0 || (this.readonly && this.selectedChip === 0)) {
	        this.selectedChip = this.items.length;
	      }
	      if (this.items.length) this.selectAndFocusChipSafe(this.selectedChip - 1);
	      break;
	    case this.$mdConstant.KEY_CODE.RIGHT_ARROW:
	      event.preventDefault();
	      this.selectAndFocusChipSafe(this.selectedChip + 1);
	      break;
	    case this.$mdConstant.KEY_CODE.ESCAPE:
	    case this.$mdConstant.KEY_CODE.TAB:
	      if (this.selectedChip < 0) return;
	      event.preventDefault();
	      this.onFocus();
	      break;
	  }
	};
	
	/**
	 * Get the input's placeholder - uses `placeholder` when list is empty and `secondary-placeholder`
	 * when the list is non-empty. If `secondary-placeholder` is not provided, `placeholder` is used
	 * always.
	 * @returns {string}
	 */
	MdChipsCtrl.prototype.getPlaceholder = function() {
	  // Allow `secondary-placeholder` to be blank.
	  var useSecondary = (this.items && this.items.length &&
	      (this.secondaryPlaceholder === '' || this.secondaryPlaceholder));
	  return useSecondary ? this.secondaryPlaceholder : this.placeholder;
	};
	
	/**
	 * Removes chip at {@code index} and selects the adjacent chip.
	 * @param {number} index adjacent chip to select
	 * @param {Event=} event
	 */
	MdChipsCtrl.prototype.removeAndSelectAdjacentChip = function(index, event) {
	  var self = this;
	  var selIndex = self.getAdjacentChipIndex(index);
	  var wrap = this.$element[0].querySelector('md-chips-wrap');
	  var chip = this.$element[0].querySelector('md-chip[index="' + index + '"]');
	
	  self.removeChip(index, event);
	
	  // The double-timeout is currently necessary to ensure that the DOM has finalized and the select()
	  // will find the proper chip since the selection is index-based.
	  //
	  // TODO: Investigate calling from within chip $scope.$on('$destroy') to reduce/remove timeouts
	  self.$timeout(function() {
	    self.$timeout(function() {
	      self.selectAndFocusChipSafe(selIndex);
	    });
	  });
	};
	
	/**
	 * Sets the selected chip index to -1.
	 */
	MdChipsCtrl.prototype.resetSelectedChip = function() {
	  this.selectedChip = -1;
	  this.ariaTabIndex = null;
	};
	
	/**
	 * Gets the index of an adjacent chip to select after deletion. Adjacency is
	 * determined as the next chip in the list, unless the target chip is the
	 * last in the list, then it is the chip immediately preceding the target. If
	 * there is only one item in the list, -1 is returned (select none).
	 * The number returned is the index to select AFTER the target has been removed.
	 * If the current chip is not selected, then -1 is returned to select none.
	 * @param {number} index
	 * @returns {number}
	 */
	MdChipsCtrl.prototype.getAdjacentChipIndex = function(index) {
	  var len = this.items.length - 1;
	  return (len === 0) ? -1 :
	      (index === len) ? index - 1 : index;
	};
	
	/**
	 * Append the contents of the buffer to the chip list. This method will first
	 * call out to the md-transform-chip method, if provided.
	 * @param {string} newChip chip buffer contents that will be used to create the new chip
	 */
	MdChipsCtrl.prototype.appendChip = function(newChip) {
	  this.shouldFocusLastChip = !this.addOnBlur;
	  if (this.useTransformChip && this.transformChip) {
	    var transformedChip = this.transformChip({'$chip': newChip});
	
	    // Check to make sure the chip is defined before assigning it, otherwise, we'll just assume
	    // they want the string version.
	    if (angular.isDefined(transformedChip)) {
	      newChip = transformedChip;
	    }
	  }
	
	  // If items contains an identical object to newChip, do not append
	  if (angular.isObject(newChip)) {
	    var identical = this.items.some(function(item) {
	      return angular.equals(newChip, item);
	    });
	    if (identical) return;
	  }
	
	  // Check for a null (but not undefined), or existing chip and cancel appending
	  if (newChip == null || this.items.indexOf(newChip) + 1) return;
	
	  // Append the new chip onto our list
	  var length = this.items.push(newChip);
	  var index = length - 1;
	
	  this.updateNgModel();
	
	  // Tell screen reader users that the chip was successfully added.
	  // TODO add a way for developers to specify which field of the object should be announced here.
	  var chipContent = angular.isObject(newChip) ? '' : newChip;
	  this.$mdLiveAnnouncer.announce(chipContent + ' ' + this.addedMessage, 'assertive');
	
	  // If the md-on-add attribute is specified, send a chip addition event
	  if (this.useOnAdd && this.onAdd) {
	    this.onAdd({ '$chip': newChip, '$index': index });
	  }
	};
	
	/**
	 * Sets whether to use the md-transform-chip expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code transformChip}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useTransformChipExpression = function() {
	  this.useTransformChip = true;
	};
	
	/**
	 * Sets whether to use the md-on-add expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onAdd}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnAddExpression = function() {
	  this.useOnAdd = true;
	};
	
	/**
	 * Sets whether to use the md-on-remove expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onRemove}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnRemoveExpression = function() {
	  this.useOnRemove = true;
	};
	
	/**
	 * Sets whether to use the md-on-select expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onSelect}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnSelectExpression = function() {
	  this.useOnSelect = true;
	};
	
	/**
	 * Gets the input buffer. The input buffer can be the model bound to the
	 * default input item {@code this.chipBuffer}, the {@code selectedItem}
	 * model of an {@code md-autocomplete}, or, through some magic, the model
	 * bound to any input or text area element found within a
	 * {@code md-input-container} element.
	 * @return {string} the input buffer
	 */
	MdChipsCtrl.prototype.getChipBuffer = function() {
	  var chipBuffer =  !this.userInputElement ? this.chipBuffer :
	                     this.userInputNgModelCtrl ? this.userInputNgModelCtrl.$viewValue :
	                     this.userInputElement[0].value;
	
	  // Ensure that the chip buffer is always a string. For example, the input element buffer
	  // might be falsy.
	  return angular.isString(chipBuffer) ? chipBuffer : '';
	};
	
	/**
	 * Resets the input buffer for either the internal input or user provided input element.
	 */
	MdChipsCtrl.prototype.resetChipBuffer = function() {
	  if (this.userInputElement) {
	    if (this.userInputNgModelCtrl) {
	      this.userInputNgModelCtrl.$setViewValue('');
	      this.userInputNgModelCtrl.$render();
	    } else {
	      this.userInputElement[0].value = '';
	    }
	  } else {
	    this.chipBuffer = '';
	  }
	};
	
	/**
	 * @returns {boolean} true if the max chips limit has been reached, false otherwise.
	 */
	MdChipsCtrl.prototype.hasMaxChipsReached = function() {
	  if (angular.isString(this.maxChips)) {
	    this.maxChips = parseInt(this.maxChips, 10) || 0;
	  }
	
	  return this.maxChips > 0 && this.items.length >= this.maxChips;
	};
	
	/**
	 * Updates the validity properties for the ngModel.
	 *
	 * TODO add the md-max-chips validator to this.ngModelCtrl.validators so that the validation will
	 * be performed automatically.
	 */
	MdChipsCtrl.prototype.validateModel = function() {
	  this.ngModelCtrl.$setValidity('md-max-chips', !this.hasMaxChipsReached());
	  this.ngModelCtrl.$validate(); // rerun any registered validators
	};
	
	/**
	 * Function to handle updating the model, validation, and change notification when a chip
	 * is added, removed, or changed.
	 * @param {boolean=} skipValidation true to skip calling validateModel()
	 */
	MdChipsCtrl.prototype.updateNgModel = function(skipValidation) {
	  if (!skipValidation) {
	    this.validateModel();
	  }
	  // This will trigger ng-change to fire, even in cases where $setViewValue() would not.
	  angular.forEach(this.ngModelCtrl.$viewChangeListeners, function(listener) {
	    try {
	      listener();
	    } catch (e) {
	      this.$exceptionHandler(e);
	    }
	  });
	};
	
	/**
	 * Removes the chip at the given index.
	 * @param {number} index of chip to remove
	 * @param {Event=} event optionally passed to the onRemove callback
	 */
	MdChipsCtrl.prototype.removeChip = function(index, event) {
	  var removed = this.items.splice(index, 1);
	
	  this.updateNgModel();
	  this.ngModelCtrl.$setDirty();
	
	  // Tell screen reader users that the chip was successfully removed.
	  // TODO add a way for developers to specify which field of the object should be announced here.
	  var chipContent = angular.isObject(removed[0]) ? '' : removed[0];
	  this.$mdLiveAnnouncer.announce(chipContent + ' ' + this.removedMessage, 'assertive');
	
	  if (removed && removed.length && this.useOnRemove && this.onRemove) {
	    this.onRemove({ '$chip': removed[0], '$index': index, '$event': event });
	  }
	};
	
	/**
	 * @param {number} index location of chip to remove
	 * @param {Event=} $event
	 */
	MdChipsCtrl.prototype.removeChipAndFocusInput = function (index, $event) {
	  this.removeChip(index, $event);
	
	  if (this.autocompleteCtrl) {
	    // Always hide the autocomplete dropdown before focusing the autocomplete input.
	    // Wait for the input to move horizontally, because the chip was removed.
	    // This can lead to an incorrect dropdown position.
	    this.autocompleteCtrl.hidden = true;
	    this.$mdUtil.nextTick(this.onFocus.bind(this));
	  } else {
	    this.onFocus();
	  }
	
	};
	/**
	 * Selects the chip at `index`,
	 * @param {number} index location of chip to select and focus
	 */
	MdChipsCtrl.prototype.selectAndFocusChipSafe = function(index) {
	  // If we have no chips, or are asked to select a chip before the first, just focus the input
	  if (!this.items.length || index === -1) {
	    return this.focusInput();
	  }
	
	  // If we are asked to select a chip greater than the number of chips...
	  if (index >= this.items.length) {
	    if (this.readonly) {
	      // If we are readonly, jump back to the start (because we have no input)
	      index = 0;
	    } else {
	      // If we are not readonly, we should attempt to focus the input
	      return this.onFocus();
	    }
	  }
	
	  index = Math.max(index, 0);
	  index = Math.min(index, this.items.length - 1);
	
	  this.selectChip(index);
	  this.focusChip(index);
	};
	
	/**
	 * Focus last chip, then focus the input. This is needed for screen reader support.
	 */
	MdChipsCtrl.prototype.focusLastChipThenInput = function() {
	  var ctrl = this;
	
	  ctrl.shouldFocusLastChip = false;
	
	  ctrl.focusChip(this.items.length - 1);
	
	  ctrl.$timeout(function() {
	    ctrl.focusInput();
	  }, ctrl.chipAppendDelay);
	};
	
	/**
	 * Focus the input element.
	 */
	MdChipsCtrl.prototype.focusInput = function() {
	  this.selectChip(-1);
	  this.onFocus();
	};
	
	/**
	 * Marks the chip at the given index as selected.
	 * @param {number} index location of chip to select
	 */
	MdChipsCtrl.prototype.selectChip = function(index) {
	  if (index >= -1 && index <= this.items.length) {
	    this.selectedChip = index;
	
	    // Fire the onSelect if provided
	    if (this.useOnSelect && this.onSelect) {
	      this.onSelect({'$chip': this.items[index] });
	    }
	  } else {
	    this.$log.warn('Selected Chip index out of bounds; ignoring.');
	  }
	};
	
	/**
	 * Call {@code focus()} on the chip at {@code index}
	 * @param {number} index location of chip to focus
	 */
	MdChipsCtrl.prototype.focusChip = function(index) {
	  var chipContent = this.$element[0].querySelector(
	    'md-chip[index="' + index + '"] .md-chip-content'
	  );
	
	  this.ariaTabIndex = index;
	
	  chipContent.focus();
	};
	
	/**
	 * Configures the required interactions with the ngModel Controller.
	 * Specifically, set {@code this.items} to the {@code NgModelController#$viewValue}.
	 * @param {NgModelController} ngModelCtrl
	 */
	MdChipsCtrl.prototype.configureNgModel = function(ngModelCtrl) {
	  this.ngModelCtrl = ngModelCtrl;
	
	  var self = this;
	
	  // in chips the meaning of $isEmpty changes
	  ngModelCtrl.$isEmpty = function(value) {
	    return !value || value.length === 0;
	  };
	
	  ngModelCtrl.$render = function() {
	    // model is updated. do something.
	    self.items = self.ngModelCtrl.$viewValue;
	  };
	};
	
	MdChipsCtrl.prototype.onFocus = function () {
	  var input = this.$element[0].querySelector('input');
	  input && input.focus();
	  this.resetSelectedChip();
	};
	
	MdChipsCtrl.prototype.onInputFocus = function () {
	  this.inputHasFocus = true;
	
	  // Make sure we have the appropriate ARIA attributes
	  this.setupInputAria();
	
	  // Make sure we don't have any chips selected
	  this.resetSelectedChip();
	};
	
	MdChipsCtrl.prototype.onInputBlur = function () {
	  this.inputHasFocus = false;
	
	  if (this.shouldAddOnBlur()) {
	    this.appendChip(this.getChipBuffer().trim());
	    this.resetChipBuffer();
	  }
	};
	
	/**
	 * Configure event bindings on input element.
	 * @param {angular.element} inputElement
	 */
	MdChipsCtrl.prototype.configureInput = function configureInput(inputElement) {
	  // Find the NgModelCtrl for the input element
	  var ngModelCtrl = inputElement.controller('ngModel');
	  var ctrl = this;
	
	  if (ngModelCtrl) {
	
	    // sync touched-state from inner input to chips-element
	    this.deRegister.push(
	      this.$scope.$watch(
	        function() {
	          return ngModelCtrl.$touched;
	        },
	        function(isTouched) {
	          isTouched && ctrl.ngModelCtrl.$setTouched();
	        }
	      )
	    );
	
	    // sync dirty-state from inner input to chips-element
	    this.deRegister.push(
	      this.$scope.$watch(
	        function() {
	          return ngModelCtrl.$dirty;
	        },
	        function(isDirty) {
	          isDirty && ctrl.ngModelCtrl.$setDirty();
	        }
	      )
	    );
	  }
	};
	
	/**
	 * Configure event bindings on a user-provided input element.
	 * @param {angular.element} inputElement
	 */
	MdChipsCtrl.prototype.configureUserInput = function(inputElement) {
	  this.userInputElement = inputElement;
	
	  // Find the NgModelCtrl for the input element
	  var ngModelCtrl = inputElement.controller('ngModel');
	  // `.controller` will look in the parent as well.
	  if (ngModelCtrl !== this.ngModelCtrl) {
	    this.userInputNgModelCtrl = ngModelCtrl;
	  }
	
	  var scope = this.$scope;
	  var ctrl = this;
	
	  // Run all of the events using evalAsync because a focus may fire a blur in the same digest loop
	  var scopeApplyFn = function(event, fn) {
	    scope.$evalAsync(angular.bind(ctrl, fn, event));
	  };
	
	  // Bind to keydown and focus events of input
	  inputElement
	      .attr({ tabindex: 0 })
	      .on('keydown', function(event) { scopeApplyFn(event, ctrl.inputKeydown); })
	      .on('focus', function(event) { scopeApplyFn(event, ctrl.onInputFocus); })
	      .on('blur', function(event) { scopeApplyFn(event, ctrl.onInputBlur); });
	};
	
	/**
	 * @param {MdAutocompleteCtrl} ctrl controller from the autocomplete component
	 */
	MdChipsCtrl.prototype.configureAutocomplete = function(ctrl) {
	  if (ctrl) {
	    this.autocompleteCtrl = ctrl;
	    // Update the default container empty hint when we're inside of an autocomplete.
	    if (!this.$element.attr('container-empty-hint')) {
	      this.containerEmptyHint = 'Chips container with autocompletion. Enter the text area, ' +
	        'type text to search, and then use the up and down arrow keys to select an option. ' +
	        'Press enter to add the selected option as a chip.';
	      this.setupWrapperAria();
	    }
	
	    ctrl.registerSelectedItemWatcher(angular.bind(this, function (item) {
	      if (item) {
	        // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
	        if (this.hasMaxChipsReached()) return;
	
	        this.appendChip(item);
	        this.resetChipBuffer();
	      }
	    }));
	
	    this.$element.find('input')
	        .on('focus',angular.bind(this, this.onInputFocus))
	        .on('blur', angular.bind(this, this.onInputBlur));
	  }
	};
	
	/**
	 * @returns {boolean} Whether the current chip buffer should be added on input blur or not.
	 */
	MdChipsCtrl.prototype.shouldAddOnBlur = function() {
	
	  // Update the custom ngModel validators from the chips component.
	  this.validateModel();
	
	  var chipBuffer = this.getChipBuffer().trim();
	  // If the model value is empty and required is set on the element, then the model will be invalid.
	  // In that case, we still want to allow adding the chip. The main (but not only) case we want
	  // to disallow is adding a chip on blur when md-max-chips validation fails.
	  var isModelValid = this.ngModelCtrl.$isEmpty(this.ngModelCtrl.$modelValue) ||
	    this.ngModelCtrl.$valid;
	  var isAutocompleteShowing = this.autocompleteCtrl && !this.autocompleteCtrl.hidden;
	
	  if (this.userInputNgModelCtrl) {
	    isModelValid = isModelValid && this.userInputNgModelCtrl.$valid;
	  }
	
	  return this.addOnBlur && !this.requireMatch && chipBuffer && isModelValid &&
	    !isAutocompleteShowing;
	};
	
	/**
	 * @returns {boolean} true if the input or a chip is focused. False otherwise.
	 */
	MdChipsCtrl.prototype.hasFocus = function () {
	  return this.inputHasFocus || this.selectedChip >= 0;
	};
	
	/**
	 * @param {number} index location of content id
	 * @returns {number} unique id for the aria-owns attribute
	 */
	MdChipsCtrl.prototype.contentIdFor = function(index) {
	  return this.contentIds[index];
	};
	
	})();
	(function(){
	"use strict";
	
	  
	  MdChips.$inject = ["$mdTheming", "$mdUtil", "$compile", "$log", "$timeout", "$$mdSvgRegistry"];angular
	      .module('material.components.chips')
	      .directive('mdChips', MdChips);
	
	  /**
	   * @ngdoc directive
	   * @name mdChips
	   * @module material.components.chips
	   *
	   * @description
	   * `<md-chips>` is an input component for building lists of strings or objects. The list items are
	   * displayed as 'chips'. This component can make use of an `<input>` element or an
	   * `<md-autocomplete>` element.
	   *
	   * ### Custom templates
	   * A custom template may be provided to render the content of each chip. This is achieved by
	   * specifying an `<md-chip-template>` element containing the custom content as a child of
	   * `<md-chips>`.
	   *
	   * Note: Any attributes on
	   * `<md-chip-template>` will be dropped as only the innerHTML is used for the chip template. The
	   * variables `$chip` and `$index` are available in the scope of `<md-chip-template>`, representing
	   * the chip object and its index in the list of chips, respectively.
	   * To override the chip delete control, include an element (ideally a button) with the attribute
	   * `md-chip-remove`. A click listener to remove the chip will be added automatically. The element
	   * is also placed as a sibling to the chip content (on which there are also click listeners) to
	   * avoid a nested ng-click situation.
	   *
	   * <!-- Note: We no longer want to include this in the site docs; but it should remain here for
	   * future developers and those looking at the documentation.
	   *
	   * <h3> Pending Features </h3>
	   * <ul style="padding-left:20px;">
	   *
	   *   <ul>Style
	   *     <li>Colors for hover, press states (ripple?).</li>
	   *   </ul>
	   *
	   *   <ul>Validation
	   *     <li>allow a validation callback</li>
	   *     <li>highlighting style for invalid chips</li>
	   *   </ul>
	   *
	   *   <ul>Item mutation
	   *     <li>Support `
	   *       <md-chip-edit>` template, show/hide the edit element on tap/click? double tap/double
	   *       click?
	   *     </li>
	   *   </ul>
	   *
	   *   <ul>Truncation and Disambiguation (?)
	   *     <li>Truncate chip text where possible, but do not truncate entries such that two are
	   *     indistinguishable.</li>
	   *   </ul>
	   *
	   *   <ul>Drag and Drop
	   *     <li>Drag and drop chips between related `<md-chips>` elements.
	   *     </li>
	   *   </ul>
	   * </ul>
	   *
	   * //-->
	   *
	   * Sometimes developers want to limit the amount of possible chips.<br/>
	   * You can specify the maximum amount of chips by using the following markup.
	   *
	   * <hljs lang="html">
	   *   <md-chips
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       md-max-chips="5">
	   *   </md-chips>
	   * </hljs>
	   *
	   * In some cases, you have an autocomplete inside of the `md-chips`.<br/>
	   * When the maximum amount of chips has been reached, you can also disable the autocomplete
	   * selection.<br/>
	   * Here is an example markup.
	   *
	   * <hljs lang="html">
	   *   <md-chips ng-model="myItems" md-max-chips="5">
	   *     <md-autocomplete ng-hide="myItems.length > 5" ...></md-autocomplete>
	   *   </md-chips>
	   * </hljs>
	   *
	   * ### Accessibility
	   *
	   * The `md-chips` component supports keyboard and screen reader users since Version 1.1.2. In
	   * order to achieve this, we modified the chips behavior to select newly appended chips for
	   * `300ms` before re-focusing the input and allowing the user to type.
	   *
	   * For most users, this delay is small enough that it will not be noticeable but allows certain
	   * screen readers to function properly (JAWS and NVDA in particular).
	   *
	   * We introduced a new `md-chip-append-delay` option to allow developers to better control this
	   * behavior.
	   *
	   * Please refer to the documentation of this option (below) for more information.
	   *
	   * @param {expression} ng-model Assignable AngularJS expression to be data-bound to the list of
	   *    chips. The expression should evaluate to a `string` or `Object` Array. The type of this
	   *    array should align with the return value of `md-transform-chip`.
	   * @param {expression=} ng-change AngularJS expression to be executed on chip addition, removal,
	   *    or content change.
	   * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	   * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
	   *    displayed when there is at least one item in the list
	   * @param {boolean=} md-removable Enables or disables the deletion of chips through the
	   *    removal icon or the Delete/Backspace key. Defaults to true.
	   * @param {boolean=} readonly Disables list manipulation (deleting or adding list items), hiding
	   *    the input and delete buttons. If no `ng-model` is provided, the chips will automatically be
	   *    marked as readonly.<br/><br/>
	   *    When `md-removable` is not defined, the `md-remove` behavior will be overwritten and
	   *    disabled.
	   * @param {boolean=} md-enable-chip-edit Set this to `"true"` to enable editing of chip contents.
	   *    The user can go into edit mode by pressing the `space` or `enter` keys, or by double
	   *    clicking on the chip. Chip editing is only supported for chips using the basic template.
	   *    **Note:** This attribute is only evaluated once; it is not watched.
	   * @param {boolean=} ng-required Whether ng-model is allowed to be empty or not.
	   * @param {number=} md-max-chips The maximum number of chips allowed to add through user input.
	   *    <br/><br/>The validation property `md-max-chips` can be used when the max chips
	   *    amount is reached.
	   * @param {boolean=} md-add-on-blur When set to `"true"`, the remaining text inside of the input
	   *    will be converted into a new chip on blur.
	   *    **Note:** This attribute is only evaluated once; it is not watched.
	   * @param {expression} md-transform-chip An expression of form `myFunction($chip)` that when
	   *    called expects one of the following return values:
	   *    - an object representing the `$chip` input string
	   *    - `undefined` to simply add the `$chip` input string, or
	   *    - `null` to prevent the chip from being appended
	   * @param {expression=} md-on-add An expression which will be called when a chip has been
	   *    added with `$chip` and `$index` available as parameters.
	   * @param {expression=} md-on-remove An expression which will be called when a chip has been
	   *    removed with `$chip`, `$index`, and `$event` available as parameters.
	   * @param {expression=} md-on-select An expression which will be called when a chip is selected.
	   * @param {boolean=} md-require-match If true, and the chips template contains an autocomplete,
	   *    only allow selection of pre-defined chips (i.e. you cannot add new ones).
	   * @param {string=} md-input-class This class will be applied to the child input for custom
	   *    styling. If you are using an `md-autocomplete`, then you need to put this attribute on the
	   *    `md-autocomplete` rather than the `md-chips`.
	   * @param {string=} input-aria-describedby A space-separated list of element IDs. This should
	   *     contain the IDs of any elements that describe this autocomplete. Screen readers will read
	   *     the content of these elements at the end of announcing that the chips input has been
	   *     selected and describing its current state. The descriptive elements do not need to be
	   *     visible on the page.
	   * @param {string=} input-aria-labelledby A space-separated list of element IDs. The ideal use
	   *    case is that this would contain the ID of a `<label>` element that is associated with these
	   *    chips.<br><br>
	   *    For `<label id="state">US State</label>`, you would set this to
	   *    `input-aria-labelledby="state"`.
	   * @param {string=} input-aria-label A string read by screen readers to identify the input.
	   *    For static chips, this will be applied to the chips container.
	   * @param {string=} container-hint A string read by screen readers informing users of how to
	   *    navigate the chips when there are chips. Only applies when `ng-model` is defined.
	   * @param {string=} container-empty-hint A string read by screen readers informing users of how to
	   *    add chips when there are no chips. You will want to use this to override the default when
	   *    in a non-English locale. Only applies when `ng-model` is defined.
	   * @param {string=} delete-hint A string read by screen readers instructing users that pressing
	   *    the delete key will remove the chip. You will want to use this to override the default when
	   *    in a non-English locale.
	   * @param {string=} delete-button-label Text for the `aria-label` of the button with the
	   *    `md-chip-remove` class. If the chip is an Object, then this will be the only text in the
	   *    label. Otherwise, this is prepended to the string representation of the chip. Defaults to
	   *    "Remove", which would be "Remove Apple" for a chip that contained the string "Apple".
	   *    You will want to use this to override the default when in a non-English locale.
	   * @param {string=} md-removed-message Screen readers will announce this message following the
	   *    chips contents. The default is `"removed"`. If a chip with the content of "Apple" was
	   *    removed, the screen reader would read "Apple removed". You will want to use this to override
	   *    the default when in a non-English locale.
	   * @param {string=} md-added-message Screen readers will announce this message following the
	   *    chips contents. The default is `"added"`. If a chip with the content of "Apple" was
	   *    created, the screen reader would read "Apple added". You will want to use this to override
	   *    the default when in a non-English locale.
	   * @param {expression=} md-separator-keys An array of key codes used to separate chips.
	   * @param {string=} md-chip-append-delay The number of milliseconds that the component will select
	   *    a newly appended chip before allowing a user to type into the input. This is **necessary**
	   *    for keyboard accessibility for screen readers. It defaults to 300ms and any number less than
	   *    300 can cause issues with screen readers (particularly JAWS and sometimes NVDA).
	   *
	   *    _Available since Version 1.1.2._
	   *
	   *    **Note:** You can safely set this to `0` in one of the following two instances:
	   *
	   *    1. You are targeting an iOS or Safari-only application (where users would use VoiceOver) or
	   *    only ChromeVox users.
	   *
	   *    2. If you have utilized the `md-separator-keys` to disable the `enter` keystroke in
	   *    favor of another one (such as `,` or `;`).
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <md-chips
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       readonly="isReadOnly">
	   *   </md-chips>
	   * </hljs>
	   *
	   * <h3>Validation</h3>
	   * When using [ngMessages](https://docs.angularjs.org/api/ngMessages), you can show errors based
	   * on our custom validators.
	   * <hljs lang="html">
	   *   <form name="userForm">
	   *     <md-chips
	   *       name="fruits"
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       md-max-chips="5">
	   *     </md-chips>
	   *     <div ng-messages="userForm.fruits.$error" ng-if="userForm.$dirty">
	   *       <div ng-message="md-max-chips">You reached the maximum amount of chips</div>
	   *    </div>
	   *   </form>
	   * </hljs>
	   *
	   */
	
	  // TODO add a way for developers to specify which field of the object should used in the
	  // aria-label.
	  var MD_CHIPS_TEMPLATE = '\
	      <md-chips-wrap\
	          id="{{$mdChipsCtrl.wrapperId}}"\
	          tabindex="{{$mdChipsCtrl.readonly ? 0 : -1}}"\
	          ng-keydown="$mdChipsCtrl.chipKeydown($event)"\
	          ng-class="{ \'md-focused\': $mdChipsCtrl.hasFocus(), \
	                      \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly,\
	                      \'md-removable\': $mdChipsCtrl.isRemovable() }"\
	          class="md-chips">\
	        <md-chip ng-repeat="$chip in $mdChipsCtrl.items"\
	            index="{{$index}}" \
	            ng-class="{\'md-focused\': $mdChipsCtrl.selectedChip == $index, \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}">\
	          <div class="md-chip-content"\
	              tabindex="{{$mdChipsCtrl.ariaTabIndex === $index ? 0 : -1}}"\
	              id="{{$mdChipsCtrl.contentIdFor($index)}}"\
	              role="option"\
	              aria-selected="{{$mdChipsCtrl.selectedChip === $index}}"\
	              aria-setsize="{{$mdChipsCtrl.items.length}}"\
	              aria-posinset="{{$index+1}}"\
	              ng-click="!$mdChipsCtrl.readonly && $mdChipsCtrl.focusChip($index)"\
	              aria-label="{{$mdChipsCtrl._isChipObject($chip) ? \'\' : $chip + \'. \'}}{{$mdChipsCtrl.isRemovable() ? \'\' + $mdChipsCtrl.deleteHint : \'\'}}" \
	              ng-focus="!$mdChipsCtrl.readonly && $mdChipsCtrl.selectChip($index)"\
	              md-chip-transclude="$mdChipsCtrl.chipContentsTemplate"></div>\
	          <div ng-if="$mdChipsCtrl.isRemovable()"\
	               class="md-chip-remove-container"\
	               tabindex="-1"\
	               md-chip-transclude="$mdChipsCtrl.chipRemoveTemplate"></div>\
	        </md-chip>\
	        <div class="md-chip-input-container" ng-if="!$mdChipsCtrl.readonly && $mdChipsCtrl.ngModelCtrl">\
	          <div md-chip-transclude="$mdChipsCtrl.chipInputTemplate"></div>\
	        </div>\
	      </md-chips-wrap>';
	
	  var CHIP_INPUT_TEMPLATE = '\
	        <input\
	            class="md-input{{ $mdChipsCtrl.inputClass ? \' \' + $mdChipsCtrl.inputClass: \'\'}}"\
	            tabindex="0"\
	            aria-label="{{$mdChipsCtrl.inputAriaLabel}}"\
	            placeholder="{{$mdChipsCtrl.getPlaceholder()}}"\
	            ng-model="$mdChipsCtrl.chipBuffer"\
	            ng-focus="$mdChipsCtrl.onInputFocus()"\
	            ng-blur="$mdChipsCtrl.onInputBlur()"\
	            ng-keydown="$mdChipsCtrl.inputKeydown($event)">';
	
	  var CHIP_DEFAULT_TEMPLATE = '\
	      <span>{{$chip}}</span>';
	
	  var CHIP_REMOVE_TEMPLATE = '\
	      <button\
	          class="md-chip-remove"\
	          ng-if="$mdChipsCtrl.isRemovable()"\
	          ng-click="$mdChipsCtrl.removeChipAndFocusInput($$replacedScope.$index, $event)"\
	          type="button"\
	          tabindex="-1"\
	          aria-label="{{$mdChipsCtrl.deleteButtonLabel}}{{$mdChipsCtrl._isChipObject($chip) ? \'\' : \' \' + $chip}}">\
	        <md-icon md-svg-src="{{$mdChipsCtrl.mdCloseIcon}}" aria-hidden="true"></md-icon>\
	      </button>';
	
	  /**
	   * MDChips Directive Definition
	   */
	  function MdChips ($mdTheming, $mdUtil, $compile, $log, $timeout, $$mdSvgRegistry) {
	    // Run our templates through $mdUtil.processTemplate() to allow custom start/end symbols
	    var templates = getTemplates();
	
	    return {
	      template: function(element, attrs) {
	        // Clone the element into an attribute. By prepending the attribute
	        // name with '$', AngularJS won't write it into the DOM. The cloned
	        // element propagates to the link function via the attrs argument,
	        // where various contained-elements can be consumed.
	        attrs['$mdUserTemplate'] = element.clone();
	        return templates.chips;
	      },
	      require: ['mdChips'],
	      restrict: 'E',
	      controller: 'MdChipsCtrl',
	      controllerAs: '$mdChipsCtrl',
	      bindToController: true,
	      compile: compile,
	      scope: {
	        readonly: '=?readonly',
	        removable: '=?mdRemovable',
	        placeholder: '@?',
	        secondaryPlaceholder: '@?',
	        maxChips: '@?mdMaxChips',
	        transformChip: '&mdTransformChip',
	        onAdd: '&?mdOnAdd',
	        onRemove: '&?mdOnRemove',
	        addedMessage: '@?mdAddedMessage',
	        removedMessage: '@?mdRemovedMessage',
	        onSelect: '&?mdOnSelect',
	        inputClass: '@?mdInputClass',
	        inputAriaDescribedBy: '@?inputAriaDescribedby',
	        inputAriaLabelledBy: '@?inputAriaLabelledby',
	        inputAriaLabel: '@?',
	        containerHint: '@?',
	        containerEmptyHint: '@?',
	        deleteHint: '@?',
	        deleteButtonLabel: '@?',
	        separatorKeys: '=?mdSeparatorKeys',
	        requireMatch: '=?mdRequireMatch',
	        chipAppendDelayString: '@?mdChipAppendDelay',
	        ngChange: '&?'
	      }
	    };
	
	    /**
	     * Builds the final template for `md-chips` and returns the postLink function.
	     *
	     * Building the template involves 3 key components:
	     * static chips
	     * chip template
	     * input control
	     *
	     * If no `ng-model` is provided, only the static chip work needs to be done.
	     *
	     * If no user-passed `md-chip-template` exists, the default template is used. This resulting
	     * template is appended to the chip content element.
	     *
	     * The remove button may be overridden by passing an element with an md-chip-remove attribute.
	     *
	     * If an `input` or `md-autocomplete` element is provided by the caller, it is set aside for
	     * transclusion later. The transclusion happens in `postLink` as the parent scope is required.
	     * If no user input is provided, a default one is appended to the input container node in the
	     * template.
	     *
	     * Static Chips (i.e. `md-chip` elements passed from the caller) are gathered and set aside for
	     * transclusion in the `postLink` function.
	     *
	     *
	     * @param element
	     * @param attr
	     * @returns {Function}
	     */
	    function compile(element, attr) {
	      // Grab the user template from attr and reset the attribute to null.
	      var userTemplate = attr['$mdUserTemplate'];
	      attr['$mdUserTemplate'] = null;
	
	      var chipTemplate = getTemplateByQuery('md-chips>md-chip-template');
	
	      var chipRemoveSelector = $mdUtil
	        .prefixer()
	        .buildList('md-chip-remove')
	        .map(function(attr) {
	          return 'md-chips>*[' + attr + ']';
	        })
	        .join(',');
	
	      // Set the chip remove, chip contents and chip input templates. The link function will put
	      // them on the scope for transclusion later.
	      var chipRemoveTemplate   = getTemplateByQuery(chipRemoveSelector) || templates.remove,
	          chipContentsTemplate = chipTemplate || templates.default,
	          chipInputTemplate    = getTemplateByQuery('md-chips>md-autocomplete')
	              || getTemplateByQuery('md-chips>input')
	              || templates.input,
	          staticChips = userTemplate.find('md-chip');
	
	      // Warn of malformed template. See #2545
	      if (userTemplate[0].querySelector('md-chip-template>*[md-chip-remove]')) {
	        $log.warn('invalid placement of md-chip-remove within md-chip-template.');
	      }
	
	      function getTemplateByQuery (query) {
	        if (!attr.ngModel) return;
	        var element = userTemplate[0].querySelector(query);
	        return element && element.outerHTML;
	      }
	
	      /**
	       * Configures controller and transcludes.
	       */
	      return function postLink(scope, element, attrs, controllers) {
	        $mdUtil.initOptionalProperties(scope, attr);
	
	        $mdTheming(element);
	        var mdChipsCtrl = controllers[0];
	        if (chipTemplate) {
	          // Chip editing functionality assumes we are using the default chip template.
	          mdChipsCtrl.enableChipEdit = false;
	        }
	
	        mdChipsCtrl.chipContentsTemplate = chipContentsTemplate;
	        mdChipsCtrl.chipRemoveTemplate   = chipRemoveTemplate;
	        mdChipsCtrl.chipInputTemplate    = chipInputTemplate;
	
	        mdChipsCtrl.mdCloseIcon = $$mdSvgRegistry.mdCancel;
	
	        element
	            .attr({ tabindex: -1 })
	            .on('focus', function () { mdChipsCtrl.onFocus(); })
	            .on('click', function () {
	              if (!mdChipsCtrl.readonly && mdChipsCtrl.selectedChip === -1) {
	                mdChipsCtrl.onFocus();
	              }
	            });
	
	        if (attr.ngModel) {
	          mdChipsCtrl.configureNgModel(element.controller('ngModel'));
	
	          // If an `md-transform-chip` attribute was set, tell the controller to use the expression
	          // before appending chips.
	          if (attrs.mdTransformChip) mdChipsCtrl.useTransformChipExpression();
	
	          // If an `md-on-add` attribute was set, tell the controller to use the expression
	          // when adding chips.
	          if (attrs.mdOnAdd) mdChipsCtrl.useOnAddExpression();
	
	          // If an `md-on-remove` attribute was set, tell the controller to use the expression
	          // when removing chips.
	          if (attrs.mdOnRemove) mdChipsCtrl.useOnRemoveExpression();
	
	          // If an `md-on-select` attribute was set, tell the controller to use the expression
	          // when selecting chips.
	          if (attrs.mdOnSelect) mdChipsCtrl.useOnSelectExpression();
	
	          // The md-autocomplete and input elements won't be compiled until after this directive
	          // is complete (due to their nested nature). Wait a tick before looking for them to
	          // configure the controller.
	          if (chipInputTemplate !== templates.input) {
	            // The autocomplete will not appear until the readonly attribute is not true (i.e.
	            // false or undefined), so we have to watch the readonly and then on the next tick
	            // after the chip transclusion has run, we can configure the autocomplete and user
	            // input.
	            scope.$watch('$mdChipsCtrl.readonly', function(readonly) {
	              if (!readonly) {
	
	                $mdUtil.nextTick(function(){
	
	                  if (chipInputTemplate.indexOf('<md-autocomplete') === 0) {
	                    var autocompleteEl = element.find('md-autocomplete');
	                    mdChipsCtrl.configureAutocomplete(autocompleteEl.controller('mdAutocomplete'));
	                  }
	
	                  mdChipsCtrl.configureUserInput(element.find('input'));
	                });
	              }
	            });
	          }
	
	          // At the next tick, if we find an input, make sure it has the md-input class
	          $mdUtil.nextTick(function() {
	            var input = element.find('input');
	
	            if (input) {
	              mdChipsCtrl.configureInput(input);
	              input.toggleClass('md-input', true);
	            }
	          });
	        }
	
	        // Compile with the parent's scope and prepend any static chips to the wrapper.
	        if (staticChips.length > 0) {
	          var compiledStaticChips = $compile(staticChips.clone())(scope.$parent);
	          $timeout(function() { element.find('md-chips-wrap').prepend(compiledStaticChips); });
	        }
	      };
	    }
	
	    function getTemplates() {
	      return {
	        chips: $mdUtil.processTemplate(MD_CHIPS_TEMPLATE),
	        input: $mdUtil.processTemplate(CHIP_INPUT_TEMPLATE),
	        default: $mdUtil.processTemplate(CHIP_DEFAULT_TEMPLATE),
	        remove: $mdUtil.processTemplate(CHIP_REMOVE_TEMPLATE)
	      };
	    }
	  }
	
	})();
	(function(){
	"use strict";
	
	
	MdContactChipsCtrl.$inject = ["$attrs", "$element", "$timeout"];angular
	    .module('material.components.chips')
	    .controller('MdContactChipsCtrl', MdContactChipsCtrl);
	
	/**
	 * Controller for the MdContactChips component
	 * @constructor
	 */
	function MdContactChipsCtrl ($attrs, $element, $timeout) {
	  /** @type {$element} */
	  this.$element = $element;
	
	  /** @type {$attrs} */
	  this.$attrs = $attrs;
	
	  /** @type {Function} */
	  this.$timeout = $timeout;
	
	  /** @type {Object} */
	  this.selectedItem = null;
	
	  /** @type {string} */
	  this.searchText = '';
	
	  /**
	   * Collection of functions to call to un-register watchers
	   * @type {Array}
	   */
	  this.deRegister = [];
	
	  this.init();
	}
	
	MdContactChipsCtrl.prototype.init = function() {
	  var ctrl = this;
	  var deRegister = this.deRegister;
	  var element = this.$element;
	
	  // Setup a watcher which manages chips a11y messages and autocomplete aria.
	  // Timeout required to allow the child elements to be compiled.
	  this.$timeout(function() {
	    deRegister.push(
	      element.find('md-chips').controller('mdChips').$scope.$watchCollection('$mdChipsCtrl.items', function() {
	        // Make sure our input and wrapper have the correct ARIA attributes
	        ctrl.setupChipsAria();
	        ctrl.setupAutocompleteAria();
	      })
	    );
	  });
	};
	
	MdContactChipsCtrl.prototype.setupChipsAria = function() {
	  var chips = this.$element.find('md-chips');
	  var chipsCtrl = chips.controller('mdChips');
	
	  // Configure MdChipsCtrl
	  if (this.removedMessage) {
	    chipsCtrl.removedMessage = this.removedMessage;
	  }
	  if (this.containerHint) {
	    chipsCtrl.containerHint = this.containerHint;
	  }
	  if (this.containerEmptyHint) {
	    // Apply attribute to avoid the hint being overridden by MdChipsCtrl.configureAutocomplete()
	    chips.attr('container-empty-hint', this.containerEmptyHint);
	    chipsCtrl.containerEmptyHint = this.containerEmptyHint;
	  }
	  if (this.deleteHint) {
	    chipsCtrl.deleteHint = this.deleteHint;
	  }
	  if (this.inputAriaLabel) {
	    chipsCtrl.inputAriaLabel = this.inputAriaLabel;
	  }
	  if (this.inputClass) {
	    chipsCtrl.inputClass = this.inputClass;
	  }
	};
	
	MdContactChipsCtrl.prototype.setupAutocompleteAria = function() {
	  var autocompleteInput = this.$element.find('md-chips-wrap').find('md-autocomplete').find('input');
	
	  // Set attributes on the input of the md-autocomplete
	  if (this.inputAriaDescribedBy) {
	    autocompleteInput.attr('aria-describedby', this.inputAriaDescribedBy);
	  }
	  if (this.inputAriaLabelledBy) {
	    autocompleteInput.removeAttr('aria-label');
	    autocompleteInput.attr('aria-labelledby', this.inputAriaLabelledBy);
	  }
	};
	
	MdContactChipsCtrl.prototype.queryContact = function(searchText) {
	  return this.contactQuery({'$query': searchText});
	};
	
	MdContactChipsCtrl.prototype.inputKeydown = function(event) {
	  if (!this.separatorKeys || this.separatorKeys.indexOf(event.keyCode) < 0) {
	    return;
	  }
	
	  event.stopPropagation();
	  event.preventDefault();
	
	  var autocompleteCtrl = angular.element(event.target).controller('mdAutocomplete');
	  autocompleteCtrl.select(autocompleteCtrl.index);
	};
	
	MdContactChipsCtrl.prototype.itemName = function(item) {
	  return item[this.contactName];
	};
	
	/**
	 * Destructor for cleanup
	 */
	MdContactChipsCtrl.prototype.$onDestroy = function $onDestroy() {
	  var $destroyFn;
	  while (($destroyFn = this.deRegister.pop())) {
	    $destroyFn.call(this);
	  }
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdContactChips.$inject = ["$mdTheming", "$mdUtil"];angular
	  .module('material.components.chips')
	  .directive('mdContactChips', MdContactChips);
	
	/**
	 * @ngdoc directive
	 * @name mdContactChips
	 * @module material.components.chips
	 *
	 * @description
	 * `<md-contact-chips>` is an input component based on `md-chips` and makes use of an
	 * `md-autocomplete` element. The component allows the caller to supply a query expression which
	 * returns  a list of possible contacts. The user can select one of these and add it to the list of
	 * chips.
	 *
	 * You may also use the <a ng-href="api/directive/mdHighlightText">md-highlight-flags</a> attribute
	 * along with its parameters to control the appearance of the matched text inside of the contacts'
	 * autocomplete popup.
	 *
	 * @param {expression} ng-model Assignable AngularJS expression to be data-bound to the list of
	 *    contact chips. The expression should evaluate to an `Object` Array.
	 * @param {expression=} ng-change AngularJS expression to be executed on chip addition, removal,
	 *    or content change.
	 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	 * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
	 *    displayed when there is at least on item in the list
	 * @param {expression} md-contacts An expression expected to return contacts matching the search
	 *    test, `$query`. If this expression involves a promise, a loading bar is displayed while
	 *    waiting for it to resolve.
	 * @param {string} md-contact-name The field name of the contact object representing the
	 *    contact's name.
	 * @param {string} md-contact-email The field name of the contact object representing the
	 *    contact's email address.
	 * @param {string} md-contact-image The field name of the contact object representing the
	 *    contact's image.
	 * @param {number=} md-max-chips The maximum number of chips allowed to add through user input.
	 *    <br/><br/>The validation property `md-max-chips` can be used when the max chips
	 *    amount is reached.
	 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
	 *    make suggestions
	 * @param {string=} md-input-class This class will be applied to the child `md-autocomplete` for
	 *    custom styling.
	 * @param {string=} input-aria-describedby A space-separated list of element IDs. This should
	 *     contain the IDs of any elements that describe this autocomplete. Screen readers will read
	 *     the content of these elements at the end of announcing that the chips input has been
	 *     selected and describing its current state. The descriptive elements do not need to be
	 *     visible on the page.
	 * @param {string=} input-aria-labelledby A space-separated list of element IDs. The ideal use
	 *    case is that this would contain the ID of a `<label>` element that is associated with these
	 *    chips.<br><br>
	 *    For `<label id="state">US State</label>`, you would set this to
	 *    `input-aria-labelledby="state"`.
	 * @param {string=} input-aria-label A string read by screen readers to identify the input.
	 *    For static chips, this will be applied to the chips container.
	 * @param {string=} container-hint A string read by screen readers informing users of how to
	 *    navigate the chips when there are chips.
	 * @param {string=} container-empty-hint A string read by screen readers informing users of how to
	 *    add chips when there are no chips. You will want to use this to override the default when
	 *    in a non-English locale.
	 * @param {string=} delete-hint A string read by screen readers instructing users that pressing
	 *    the delete key will remove the chip. You will want to use this to override the default when
	 *    in a non-English locale.
	 * @param {string=} md-removed-message Screen readers will announce this message following the
	 *    chips contents. The default is `"removed"`. If a chip with the content of "Apple" was
	 *    removed, the screen reader would read "Apple removed". You will want to use this to override
	 *    the default when in a non-English locale.
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-contact-chips
	 *       ng-model="ctrl.contacts"
	 *       md-contacts="ctrl.querySearch($query)"
	 *       md-contact-name="name"
	 *       md-contact-image="image"
	 *       md-contact-email="email"
	 *       placeholder="To">
	 *   </md-contact-chips>
	 * </hljs>
	 *
	 */
	
	
	var MD_CONTACT_CHIPS_TEMPLATE = '\
	      <md-chips class="md-contact-chips"\
	          ng-model="$mdContactChipsCtrl.contacts"\
	          ng-change="$mdContactChipsCtrl.ngChange($mdContactChipsCtrl.contacts)"\
	          md-require-match="$mdContactChipsCtrl.requireMatch"\
	          md-max-chips="{{$mdContactChipsCtrl.maxChips}}"\
	          md-chip-append-delay="{{$mdContactChipsCtrl.chipAppendDelay}}"\
	          md-separator-keys="$mdContactChipsCtrl.separatorKeys"\
	          md-autocomplete-snap>\
	          <md-autocomplete\
	              md-menu-class="md-contact-chips-suggestions"\
	              md-selected-item="$mdContactChipsCtrl.selectedItem"\
	              md-search-text="$mdContactChipsCtrl.searchText"\
	              md-items="item in $mdContactChipsCtrl.queryContact($mdContactChipsCtrl.searchText)"\
	              md-item-text="$mdContactChipsCtrl.itemName(item)"\
	              md-no-cache="true"\
	              md-min-length="$mdContactChipsCtrl.minLength"\
	              md-autoselect\
	              ng-attr-md-input-class="{{$mdContactChipsCtrl.inputClass}}"\
	              ng-keydown="$mdContactChipsCtrl.inputKeydown($event)"\
	              placeholder="{{$mdContactChipsCtrl.contacts.length === 0 ?\
	                  $mdContactChipsCtrl.placeholder : $mdContactChipsCtrl.secondaryPlaceholder}}">\
	            <div class="md-contact-suggestion">\
	              <img \
	                  ng-src="{{item[$mdContactChipsCtrl.contactImage]}}"\
	                  alt="{{item[$mdContactChipsCtrl.contactName]}}"\
	                  ng-if="item[$mdContactChipsCtrl.contactImage]" />\
	              <span class="md-contact-name" md-highlight-text="$mdContactChipsCtrl.searchText"\
	                    md-highlight-flags="{{$mdContactChipsCtrl.highlightFlags}}">\
	                {{item[$mdContactChipsCtrl.contactName]}}\
	              </span>\
	              <span class="md-contact-email" >{{item[$mdContactChipsCtrl.contactEmail]}}</span>\
	            </div>\
	          </md-autocomplete>\
	          <md-chip-template>\
	            <div class="md-contact-avatar">\
	              <img \
	                  ng-src="{{$chip[$mdContactChipsCtrl.contactImage]}}"\
	                  alt="{{$chip[$mdContactChipsCtrl.contactName]}}"\
	                  ng-if="$chip[$mdContactChipsCtrl.contactImage]" />\
	            </div>\
	            <div class="md-contact-name">\
	              {{$chip[$mdContactChipsCtrl.contactName]}}\
	            </div>\
	          </md-chip-template>\
	      </md-chips>';
	
	
	/**
	 * MDContactChips Directive Definition
	 *
	 * @param $mdTheming
	 * @param $mdUtil
	 * @returns {*}
	 * @ngInject
	 */
	function MdContactChips($mdTheming, $mdUtil) {
	  return {
	    template: function(element, attrs) {
	      return MD_CONTACT_CHIPS_TEMPLATE;
	    },
	    restrict: 'E',
	    controller: 'MdContactChipsCtrl',
	    controllerAs: '$mdContactChipsCtrl',
	    bindToController: true,
	    compile: compile,
	    scope: {
	      contactQuery: '&mdContacts',
	      placeholder: '@?',
	      secondaryPlaceholder: '@?',
	      contactName: '@mdContactName',
	      contactImage: '@mdContactImage',
	      contactEmail: '@mdContactEmail',
	      contacts: '=ngModel',
	      ngChange: '&?',
	      requireMatch: '=?mdRequireMatch',
	      minLength: '=?mdMinLength',
	      maxChips: '=?mdMaxChips',
	      highlightFlags: '@?mdHighlightFlags',
	      chipAppendDelay: '@?mdChipAppendDelay',
	      separatorKeys: '=?mdSeparatorKeys',
	      removedMessage: '@?mdRemovedMessage',
	      inputClass: '@?mdInputClass',
	      inputAriaDescribedBy: '@?inputAriaDescribedby',
	      inputAriaLabelledBy: '@?inputAriaLabelledby',
	      inputAriaLabel: '@?',
	      containerHint: '@?',
	      containerEmptyHint: '@?',
	      deleteHint: '@?'
	    }
	  };
	
	  function compile(element, attr) {
	    return function postLink(scope, element, attrs, controllers) {
	      var contactChipsController = controllers;
	
	      $mdUtil.initOptionalProperties(scope, attr);
	      $mdTheming(element);
	
	      element.attr('tabindex', '-1');
	
	      attrs.$observe('mdChipAppendDelay', function(newValue) {
	        contactChipsController.chipAppendDelay = newValue;
	      });
	    };
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	(function () {
	  "use strict";
	
	  /**
	   *  Use a RegExp to check if the `md-colors="<expression>"` is static string
	   *  or one that should be observed and dynamically interpolated.
	   */
	  MdColorsDirective.$inject = ["$mdColors", "$mdUtil", "$log", "$parse"];
	  MdColorsService.$inject = ["$mdTheming", "$mdUtil", "$log"];
	  var STATIC_COLOR_EXPRESSION = /^{((\s|,)*?["'a-zA-Z-]+?\s*?:\s*?(['"])[a-zA-Z0-9-.]*(['"]))+\s*}$/;
	  var colorPalettes = null;
	
	  /**
	   * @ngdoc module
	   * @name material.components.colors
	   *
	   * @description
	   * Define $mdColors service and a `md-colors=""` attribute directive
	   */
	  angular
	    .module('material.components.colors', ['material.core'])
	    .directive('mdColors', MdColorsDirective)
	    .service('$mdColors', MdColorsService);
	
	  /**
	   * @ngdoc service
	   * @name $mdColors
	   * @module material.components.colors
	   *
	   * @description
	   * By default, defining a theme does not make its colors available for applying to non AngularJS
	   * Material elements. The `$mdColors` service is used by the `md-color` directive to convert a
	   * set of color expressions to RGBA values and then apply those values to the element as CSS
	   * property values.
	   *
	   * @usage
	   * Getting a color based on a theme
	   *
	   *  <hljs lang="js">
	   *    angular.controller('myCtrl', function ($mdColors) {
	   *      var color = $mdColors.getThemeColor('myTheme-primary-900-0.5');
	   *      ...
	   *    });
	   *  </hljs>
	   *
	   * Applying a color from a palette to an element
	   * <hljs lang="js">
	   *   app.directive('myDirective', function($mdColors) {
	   *     return {
	   *       ...
	   *       link: function (scope, elem) {
	   *         $mdColors.applyThemeColors(elem, {color: 'red-A200-0.2'});
	   *       }
	   *    }
	   *   });
	   * </hljs>
	   */
	  function MdColorsService($mdTheming, $mdUtil, $log) {
	    colorPalettes = colorPalettes || Object.keys($mdTheming.PALETTES);
	
	    // Publish service instance
	    return {
	      applyThemeColors: applyThemeColors,
	      getThemeColor: getThemeColor,
	      hasTheme: hasTheme
	    };
	
	    // ********************************************
	    // Internal Methods
	    // ********************************************
	
	    /**
	     * @ngdoc method
	     * @name $mdColors#applyThemeColors
	     *
	     * @description
	     * Lookup a set of colors by hue, theme, and palette, then apply those colors
	     * with the provided opacity (via `rgba()`) to the specified CSS property.
	     *
	     * @param {angular.element} element the element to apply the styles to
	     * @param {Object} colorExpression Keys are CSS properties and values are strings representing
	     * the `theme-palette-hue-opacity` of the desired color. For example:
	     * `{'color': 'red-A200-0.3', 'background-color': 'myTheme-primary-700-0.8'}`. Theme, hue, and
	     * opacity are optional.
	     */
	    function applyThemeColors(element, colorExpression) {
	      try {
	        if (colorExpression) {
	          // Assign the calculate RGBA color values directly as inline CSS
	          element.css(interpolateColors(colorExpression));
	        }
	      } catch (e) {
	        $log.error(e.message);
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $mdColors#getThemeColor
	     *
	     * @description
	     * Get a parsed RGBA color using a string representing the `theme-palette-hue-opacity` of the
	     * desired color.
	     *
	     * @param {string} expression color expression like `'red-A200-0.3'` or
	     *  `'myTheme-primary-700-0.8'`. Theme, hue, and opacity are optional.
	     * @returns {string} a CSS color value like `rgba(211, 47, 47, 0.8)`
	     */
	    function getThemeColor(expression) {
	      var color = extractColorOptions(expression);
	
	      return parseColor(color);
	    }
	
	    /**
	     * Return the parsed color
	     * @param {{hue: *, theme: any, palette: *, opacity: (*|string|number)}} color hash map of color
	     *  definitions
	     * @param {boolean=} contrast whether use contrast color for foreground. Defaults to false.
	     * @returns {string} rgba color string
	     */
	    function parseColor(color, contrast) {
	      contrast = contrast || false;
	      var rgbValues = $mdTheming.PALETTES[color.palette][color.hue];
	
	      rgbValues = contrast ? rgbValues.contrast : rgbValues.value;
	
	      return $mdUtil.supplant('rgba({0}, {1}, {2}, {3})',
	        [rgbValues[0], rgbValues[1], rgbValues[2], rgbValues[3] || color.opacity]
	      );
	    }
	
	    /**
	     * Convert the color expression into an object with scope-interpolated values
	     * Then calculate the rgba() values based on the theme color parts
	     * @param {Object} themeColors json object, keys are css properties and values are string of
	     * the wanted color, for example: `{color: 'red-A200-0.3'}`.
	     * @return {Object} Hashmap of CSS properties with associated `rgba()` string values
	     */
	    function interpolateColors(themeColors) {
	      var rgbColors = {};
	
	      var hasColorProperty = themeColors.hasOwnProperty('color');
	
	      angular.forEach(themeColors, function (value, key) {
	        var color = extractColorOptions(value);
	        var hasBackground = key.indexOf('background') > -1;
	
	        rgbColors[key] = parseColor(color);
	        if (hasBackground && !hasColorProperty) {
	          rgbColors.color = parseColor(color, true);
	        }
	      });
	
	      return rgbColors;
	    }
	
	    /**
	     * Check if expression has defined theme
	     * For instance:
	     *   'myTheme-primary' => true
	     *   'red-800' => false
	     * @param {string} expression color expression like 'red-800', 'red-A200-0.3',
	     *   'myTheme-primary', or 'myTheme-primary-400'
	     * @return {boolean} true if the expression has a theme part, false otherwise.
	     */
	    function hasTheme(expression) {
	      return angular.isDefined($mdTheming.THEMES[expression.split('-')[0]]);
	    }
	
	    /**
	     * For the evaluated expression, extract the color parts into a hash map
	     * @param {string} expression color expression like 'red-800', 'red-A200-0.3',
	     *   'myTheme-primary', or 'myTheme-primary-400'
	     * @returns {{hue: *, theme: any, palette: *, opacity: (*|string|number)}}
	     */
	    function extractColorOptions(expression) {
	      var parts = expression.split('-');
	      var hasTheme = angular.isDefined($mdTheming.THEMES[parts[0]]);
	      var theme = hasTheme ? parts.splice(0, 1)[0] : $mdTheming.defaultTheme();
	
	      return {
	        theme: theme,
	        palette: extractPalette(parts, theme),
	        hue: extractHue(parts, theme),
	        opacity: parts[2] || 1
	      };
	    }
	
	    /**
	     * Calculate the theme palette name
	     * @param {Array} parts
	     * @param {string} theme name
	     * @return {string}
	     */
	    function extractPalette(parts, theme) {
	      // If the next section is one of the palettes we assume it's a two word palette
	      // Two word palette can be also written in camelCase, forming camelCase to dash-case
	
	      var isTwoWord = parts.length > 1 && colorPalettes.indexOf(parts[1]) !== -1;
	      var palette = parts[0].replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	
	      if (isTwoWord)  palette = parts[0] + '-' + parts.splice(1, 1);
	
	      if (colorPalettes.indexOf(palette) === -1) {
	        // If the palette is not in the palette list it's one of primary/accent/warn/background
	        var scheme = $mdTheming.THEMES[theme].colors[palette];
	        if (!scheme) {
	          throw new Error($mdUtil.supplant(
	            'mdColors: couldn\'t find \'{palette}\' in the palettes.',
	            {palette: palette}));
	        }
	        palette = scheme.name;
	      }
	
	      return palette;
	    }
	
	    /**
	     * @param {Array} parts
	     * @param {string} theme name
	     * @return {*}
	     */
	    function extractHue(parts, theme) {
	      var themeColors = $mdTheming.THEMES[theme].colors;
	
	      if (parts[1] === 'hue') {
	        var hueNumber = parseInt(parts.splice(2, 1)[0], 10);
	
	        if (hueNumber < 1 || hueNumber > 3) {
	          throw new Error($mdUtil.supplant(
	            'mdColors: \'hue-{hueNumber}\' is not a valid hue, can be only \'hue-1\', \'hue-2\' and \'hue-3\'',
	            {hueNumber: hueNumber}));
	        }
	        parts[1] = 'hue-' + hueNumber;
	
	        if (!(parts[0] in themeColors)) {
	          throw new Error($mdUtil.supplant(
	            'mdColors: \'hue-x\' can only be used with [{availableThemes}], but was used with \'{usedTheme}\'',
	            {
	            availableThemes: Object.keys(themeColors).join(', '),
	            usedTheme: parts[0]
	          }));
	        }
	
	        return themeColors[parts[0]].hues[parts[1]];
	      }
	
	      return parts[1] || themeColors[parts[0] in themeColors ? parts[0] : 'primary'].hues['default'];
	    }
	  }
	
	  /**
	   * @ngdoc directive
	   * @name mdColors
	   * @module material.components.colors
	   *
	   * @restrict A
	   *
	   * @description
	   * `mdColors` directive will apply the theme-based color expression as RGBA CSS style values.
	   *
	   *   The format will be similar to the colors defined in the Sass files:
	   *
	   *   ## `[?theme]-[palette]-[?hue]-[?opacity]`
	   *   - [theme]    - default value is the default theme
	   *   - [palette]  - can be either palette name or primary/accent/warn/background
	   *   - [hue]      - default is 500 (hue-x can be used with primary/accent/warn/background)
	   *   - [opacity]  - default is 1
	   *
	   *
	   *   > `?` indicates optional parameter
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <div md-colors="{background: 'myTheme-accent-900-0.43'}">
	   *     <div md-colors="{color: 'red-A100', 'border-color': 'primary-600'}">
	   *       <span>Color demo</span>
	   *     </div>
	   *   </div>
	   * </hljs>
	   *
	   * The `mdColors` directive will automatically watch for changes in the expression if it recognizes
	   * an interpolation expression or a function. For performance options, you can use `::` prefix to
	   * the `md-colors` expression to indicate a one-time data binding.
	   *
	   * <hljs lang="html">
	   *   <md-card md-colors="::{background: '{{theme}}-primary-700'}">
	   *   </md-card>
	   * </hljs>
	   */
	  function MdColorsDirective($mdColors, $mdUtil, $log, $parse) {
	    return {
	      restrict: 'A',
	      require: ['^?mdTheme'],
	      compile: function (tElem, tAttrs) {
	        var shouldWatch = shouldColorsWatch();
	
	        return function (scope, element, attrs, ctrl) {
	          var mdThemeController = ctrl[0];
	
	          var lastColors = {};
	
	          /**
	           * @param {string=} theme
	           * @return {Object} colors found in the specified theme
	           */
	          var parseColors = function (theme) {
	            if (typeof theme !== 'string') {
	              theme = '';
	            }
	
	            if (!attrs.mdColors) {
	              attrs.mdColors = '{}';
	            }
	
	            /**
	             * Json.parse() does not work because the keys are not quoted;
	             * use $parse to convert to a hash map
	             */
	            var colors = $parse(attrs.mdColors)(scope);
	
	            /**
	             * If mdTheme is defined higher up the DOM tree,
	             * we add mdTheme's theme to the colors which don't specify a theme.
	             *
	             * @example
	             * <hljs lang="html">
	             *   <div md-theme="myTheme">
	             *     <div md-colors="{background: 'primary-600'}">
	             *       <span md-colors="{background: 'mySecondTheme-accent-200'}">Color demo</span>
	             *     </div>
	             *   </div>
	             * </hljs>
	             *
	             * 'primary-600' will be changed to 'myTheme-primary-600',
	             * but 'mySecondTheme-accent-200' will not be changed since it has a theme defined.
	             */
	            if (mdThemeController) {
	              Object.keys(colors).forEach(function (prop) {
	                var color = colors[prop];
	                if (!$mdColors.hasTheme(color)) {
	                  colors[prop] = (theme || mdThemeController.$mdTheme) + '-' + color;
	                }
	              });
	            }
	
	            cleanElement(colors);
	
	            return colors;
	          };
	
	          /**
	           * @param {Object} colors
	           */
	          var cleanElement = function (colors) {
	            if (!angular.equals(colors, lastColors)) {
	              var keys = Object.keys(lastColors);
	
	              if (lastColors.background && !keys.color) {
	                keys.push('color');
	              }
	
	              keys.forEach(function (key) {
	                element.css(key, '');
	              });
	            }
	
	            lastColors = colors;
	          };
	
	          /**
	           * Registering for mgTheme changes and asking mdTheme controller run our callback whenever
	           * a theme changes.
	           */
	          var unregisterChanges = angular.noop;
	
	          if (mdThemeController) {
	            unregisterChanges = mdThemeController.registerChanges(function (theme) {
	              $mdColors.applyThemeColors(element, parseColors(theme));
	            });
	          }
	
	          scope.$on('$destroy', function () {
	            unregisterChanges();
	          });
	
	          try {
	            if (shouldWatch) {
	              scope.$watch(parseColors, angular.bind(this,
	                $mdColors.applyThemeColors, element
	              ), true);
	            }
	            else {
	              $mdColors.applyThemeColors(element, parseColors());
	            }
	
	          }
	          catch (e) {
	            $log.error(e.message);
	          }
	
	        };
	
	        /**
	         * @return {boolean}
	         */
	        function shouldColorsWatch() {
	          // Simulate 1x binding and mark mdColorsWatch == false
	          var rawColorExpression = tAttrs.mdColors;
	          var bindOnce = rawColorExpression.indexOf('::') > -1;
	          var isStatic = bindOnce ? true : STATIC_COLOR_EXPRESSION.test(tAttrs.mdColors);
	
	          // Remove it for the postLink...
	          tAttrs.mdColors = rawColorExpression.replace('::', '');
	
	          var hasWatchAttr = angular.isDefined(tAttrs.mdColorsWatch);
	
	          return (bindOnce || isStatic) ? false :
	            hasWatchAttr ? $mdUtil.parseAttributeBoolean(tAttrs.mdColorsWatch) : true;
	        }
	      }
	    };
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.content
	 *
	 * @description
	 * Scrollable content
	 */
	mdContentDirective.$inject = ["$mdTheming"];
	angular.module('material.components.content', [
	  'material.core'
	])
	  .directive('mdContent', mdContentDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdContent
	 * @module material.components.content
	 *
	 * @restrict E
	 *
	 * @description
	 *
	 * The `<md-content>` directive is a container element useful for scrollable content. It achieves
	 * this by setting the CSS `overflow` property to `auto` so that content can properly scroll.
	 *
	 * In general, `<md-content>` components are not designed to be nested inside one another. If
	 * possible, it is better to make them siblings. This often results in a better user experience as
	 * having nested scrollbars may confuse the user.
	 *
	 * ## Troubleshooting
	 *
	 * In some cases, you may wish to apply the `md-no-momentum` class to ensure that Safari's
	 * momentum scrolling is disabled. Momentum scrolling can cause flickering issues while scrolling
	 * SVG icons and some other components.
	 *
	 * Additionally, we now also offer the `md-no-flicker` class which can be applied to any element
	 * and uses a Webkit-specific filter of `blur(0px)` that forces GPU rendering of all elements
	 * inside (which eliminates the flicker on iOS devices).
	 *
	 * _<b>Note:</b> Forcing an element to render on the GPU can have unintended side-effects, especially
	 * related to the z-index of elements. Please use with caution and only on the elements needed._
	 *
	 * @usage
	 *
	 * Add the `[layout-padding]` attribute to make the content padded.
	 *
	 * <hljs lang="html">
	 *  <md-content layout-padding>
	 *      Lorem ipsum dolor sit amet, ne quod novum mei.
	 *  </md-content>
	 * </hljs>
	 */
	
	function mdContentDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    controller: ['$scope', '$element', ContentController],
	    link: function(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      $mdTheming(element);
	      scope.$broadcast('$mdContentLoaded', element);
	
	      iosScrollFix(element[0]);
	    }
	  };
	
	  function ContentController($scope, $element) {
	    this.$scope = $scope;
	    this.$element = $element;
	  }
	}
	
	function iosScrollFix(node) {
	  // IOS FIX:
	  // If we scroll where there is no more room for the webview to scroll,
	  // by default the webview itself will scroll up and down, this looks really
	  // bad.  So if we are scrolling to the very top or bottom, add/subtract one
	  angular.element(node).on('$md.pressdown', function(ev) {
	    // Only touch events
	    if (ev.pointer.type !== 't') return;
	    // Don't let a child content's touchstart ruin it for us.
	    if (ev.$materialScrollFixed) return;
	    ev.$materialScrollFixed = true;
	
	    if (node.scrollTop === 0) {
	      node.scrollTop = 1;
	    } else if (node.scrollHeight === node.scrollTop + node.offsetHeight) {
	      node.scrollTop -= 1;
	    }
	  });
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.datepicker
	 * @description Module for the datepicker component.
	 */
	
	angular.module('material.components.datepicker', [
	  'material.core',
	  'material.components.icon',
	  'material.components.virtualRepeat'
	]);
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc directive
	   * @name mdCalendar
	   * @module material.components.datepicker
	   *
	   * @param {Date} ng-model The component's model. Should be a Date object.
	   * @param {Object=} ng-model-options Allows tuning of the way in which `ng-model` is being
	   *  updated. Also allows for a timezone to be specified.
	   *  <a href="https://docs.angularjs.org/api/ng/directive/ngModelOptions#usage">Read more at the
	   *  ngModelOptions docs.</a>
	   * @param {Date=} md-min-date Expression representing the minimum date.
	   * @param {Date=} md-max-date Expression representing the maximum date.
	   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a
	   *  boolean whether it can be selected in "day" mode or not.
	   * @param {(function(Date): boolean)=} md-month-filter Function expecting a date and returning a
	   *  boolean whether it can be selected in "month" mode or not.
	   * @param {String=} md-current-view Current view of the calendar. Can be either "month" or "year".
	   * @param {String=} md-mode Restricts the user to only selecting a value from a particular view.
	   *  This option can be used if the user is only supposed to choose from a certain date type
	   *  (e.g. only selecting the month). Can be either "month" or "day". **Note** that this will
	   *  overwrite the `md-current-view` value.
	   *
	   * @description
	   * `<md-calendar>` is a component that renders a calendar that can be used to select a date.
	   * It is a part of the `<md-datepicker>` pane, however it can also be used on it's own.
	   *
	   * @usage
	   *
	   * <hljs lang="html">
	   *   <md-calendar ng-model="birthday"></md-calendar>
	   * </hljs>
	   */
	  CalendarCtrl.$inject = ["$element", "$scope", "$$mdDateUtil", "$mdUtil", "$mdConstant", "$mdTheming", "$$rAF", "$attrs", "$mdDateLocale", "$filter", "$document"];
	  calendarDirective.$inject = ["inputDirective"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendar', calendarDirective);
	
	  // TODO(jelbourn): Mac Cmd + left / right == Home / End
	  // TODO(jelbourn): Refactor month element creation to use cloneNode (performance).
	  // TODO(jelbourn): Define virtual scrolling constants (compactness) users can override.
	  // TODO(jelbourn): Animated month transition on ng-model change (virtual-repeat)
	  // TODO(jelbourn): Scroll snapping (virtual repeat)
	  // TODO(jelbourn): Remove superfluous row from short months (virtual-repeat)
	  // TODO(jelbourn): Month headers stick to top when scrolling.
	  // TODO(jelbourn): Previous month opacity is lowered when partially scrolled out of view.
	  // TODO(jelbourn): Support md-calendar standalone on a page (as a tabstop w/ aria-live
	  //     announcement and key handling).
	  // TODO Read-only calendar (not just date-picker).
	
	  function calendarDirective(inputDirective) {
	    return {
	      template: function(tElement, tAttr) {
	        // This allows the calendar to work, without a datepicker. This ensures that the virtual
	        // repeater scrolls to the proper place on load by deferring the execution until the next
	        // digest. It's necessary only if the calendar is used without a datepicker, otherwise it's
	        // already wrapped in an ngIf.
	        var extraAttrs = tAttr.hasOwnProperty('ngIf') ? '' : 'ng-if="calendarCtrl.isInitialized"';
	        return '' +
	          '<div ng-switch="calendarCtrl.currentView" ' + extraAttrs + '>' +
	            '<md-calendar-year ng-switch-when="year"></md-calendar-year>' +
	            '<md-calendar-month ng-switch-default></md-calendar-month>' +
	          '</div>';
	      },
	      scope: {
	        minDate: '=mdMinDate',
	        maxDate: '=mdMaxDate',
	        dateFilter: '=mdDateFilter',
	        monthFilter: '=mdMonthFilter',
	
	        // These need to be prefixed, because Angular resets
	        // any changes to the value due to bindToController.
	        _mode: '@mdMode',
	        _currentView: '@mdCurrentView'
	      },
	      require: ['ngModel', 'mdCalendar'],
	      controller: CalendarCtrl,
	      controllerAs: 'calendarCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var ngModelCtrl = controllers[0];
	        var mdCalendarCtrl = controllers[1];
	        mdCalendarCtrl.configureNgModel(ngModelCtrl, inputDirective);
	      }
	    };
	  }
	
	  /**
	   * Occasionally the hideVerticalScrollbar method might read an element's
	   * width as 0, because it hasn't been laid out yet. This value will be used
	   * as a fallback, in order to prevent scenarios where the element's width
	   * would otherwise have been set to 0. This value is the "usual" width of a
	   * calendar within a floating calendar pane.
	   */
	  var FALLBACK_WIDTH = 340;
	
	  /** Next identifier for calendar instance. */
	  var nextUniqueId = 0;
	
	  /** Maps the `md-mode` values to their corresponding calendar views. */
	  var MODE_MAP = {
	    day: 'month',
	    month: 'year'
	  };
	
	  /**
	   * Controller for the mdCalendar component.
	   * @ngInject @constructor
	   */
	  function CalendarCtrl($element, $scope, $$mdDateUtil, $mdUtil, $mdConstant, $mdTheming, $$rAF,
	                        $attrs, $mdDateLocale, $filter, $document) {
	    $mdTheming($element);
	
	    /**
	     * @final
	     * @type {!JQLite}
	     */
	    this.$element = $element;
	
	    /**
	     * @final
	     * @type {!angular.Scope}
	     */
	    this.$scope = $scope;
	
	    /**
	     * @final
	     * @type {!angular.$attrs} Current attributes object for the element
	     */
	    this.$attrs = $attrs;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.$mdUtil = $mdUtil;
	
	    /** @final */
	    this.keyCode = $mdConstant.KEY_CODE;
	
	    /** @final */
	    this.$$rAF = $$rAF;
	
	    /** @final */
	    this.$mdDateLocale = $mdDateLocale;
	
	    /** @final The built-in Angular date filter. */
	    this.ngDateFilter = $filter('date');
	
	    /**
	     * @final
	     * @type {Date}
	     */
	    this.today = this.dateUtil.createDateAtMidnight();
	
	    /** @type {!ngModel.NgModelController} */
	    this.ngModelCtrl = undefined;
	
	    /** @type {string} Class applied to the selected date cell. */
	    this.SELECTED_DATE_CLASS = 'md-calendar-selected-date';
	
	    /** @type {string} Class applied to the cell for today. */
	    this.TODAY_CLASS = 'md-calendar-date-today';
	
	    /** @type {string} Class applied to the focused cell. */
	    this.FOCUSED_DATE_CLASS = 'md-focus';
	
	    /**
	     * @final
	     * @type {number} Unique ID for this calendar instance.
	     */
	    this.id = nextUniqueId++;
	
	    /**
	     * The date that is currently focused or showing in the calendar. This will initially be set
	     * to the ng-model value if set, otherwise to today. It will be updated as the user navigates
	     * to other months. The cell corresponding to the displayDate does not necessarily always have
	     * focus in the document (such as for cases when the user is scrolling the calendar).
	     * @type {Date}
	     */
	    this.displayDate = null;
	
	    /**
	     * Allows restricting the calendar to only allow selecting a month or a day.
	     * @type {'month'|'day'|null}
	     */
	    this.mode = null;
	
	    /**
	     * The selected date. Keep track of this separately from the ng-model value so that we
	     * can know, when the ng-model value changes, what the previous value was before it's updated
	     * in the component's UI.
	     *
	     * @type {Date}
	     */
	    this.selectedDate = null;
	
	    /**
	     * The first date that can be rendered by the calendar. The default is taken
	     * from the mdDateLocale provider and is limited by the mdMinDate.
	     * @type {Date}
	     */
	    this.firstRenderableDate = null;
	
	    /**
	     * The last date that can be rendered by the calendar. The default comes
	     * from the mdDateLocale provider and is limited by the maxDate.
	     * @type {Date}
	     */
	    this.lastRenderableDate = null;
	
	    /**
	     * Used to toggle initialize the root element in the next digest.
	     * @type {boolean}
	     */
	    this.isInitialized = false;
	
	    /**
	     * Cache for the  width of the element without a scrollbar. Used to hide the scrollbar later on
	     * and to avoid extra reflows when switching between views.
	     * @type {number}
	     */
	    this.width = 0;
	
	    /**
	     * Caches the width of the scrollbar in order to be used when hiding it and to avoid extra reflows.
	     * @type {number}
	     */
	    this.scrollbarWidth = 0;
	
	    /**
	     * @type {boolean} set to true if the calendar is being used "standalone" (outside of a
	     *  md-datepicker).
	     */
	    this.standaloneMode = false;
	
	    // Unless the user specifies so, the calendar should not be a tab stop.
	    // This is necessary because ngAria might add a tabindex to anything with an ng-model
	    // (based on whether or not the user has turned that particular feature on/off).
	    if (!$attrs.tabindex) {
	      $element.attr('tabindex', '-1');
	    }
	
	    var boundKeyHandler = angular.bind(this, this.handleKeyEvent);
	
	    // If use the md-calendar directly in the body without datepicker,
	    // handleKeyEvent will disable other inputs on the page.
	    // So only apply the handleKeyEvent on the body when the md-calendar inside datepicker,
	    // otherwise apply on the calendar element only.
	
	    var handleKeyElement;
	    if ($element.parent().hasClass('md-datepicker-calendar')) {
	      handleKeyElement = angular.element($document[0].body);
	    } else {
	      this.standaloneMode = true;
	      handleKeyElement = $element;
	    }
	
	    // Bind the keydown handler to the body, in order to handle cases where the focused
	    // element gets removed from the DOM and stops propagating click events.
	    handleKeyElement.on('keydown', boundKeyHandler);
	
	    $scope.$on('$destroy', function() {
	      handleKeyElement.off('keydown', boundKeyHandler);
	    });
	
	    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	    // manually call the $onInit hook.
	    if (angular.version.major === 1 && angular.version.minor <= 4) {
	      this.$onInit();
	    }
	  }
	
	  /**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the
	   * $onInit hook.
	   */
	  CalendarCtrl.prototype.$onInit = function() {
	    /**
	     * The currently visible calendar view. Note the prefix on the scope value,
	     * which is necessary, because the datepicker seems to reset the real one value if the
	     * calendar is open, but the `currentView` on the datepicker's scope is empty.
	     * @type {String}
	     */
	    if (this._mode && MODE_MAP.hasOwnProperty(this._mode)) {
	      this.currentView = MODE_MAP[this._mode];
	      this.mode = this._mode;
	    } else {
	      this.currentView = this._currentView || 'month';
	      this.mode = null;
	    }
	
	    if (this.minDate && this.minDate > this.$mdDateLocale.firstRenderableDate) {
	      this.firstRenderableDate = this.minDate;
	    } else {
	      this.firstRenderableDate = this.$mdDateLocale.firstRenderableDate;
	    }
	
	    if (this.maxDate && this.maxDate < this.$mdDateLocale.lastRenderableDate) {
	      this.lastRenderableDate = this.maxDate;
	    } else {
	      this.lastRenderableDate = this.$mdDateLocale.lastRenderableDate;
	    }
	  };
	
	  /**
	   * Sets up the controller's reference to ngModelController.
	   * @param {!ngModel.NgModelController} ngModelCtrl Instance of the ngModel controller.
	   * @param {Object} inputDirective Config for AngularJS's `input` directive.
	   */
	  CalendarCtrl.prototype.configureNgModel = function(ngModelCtrl, inputDirective) {
	    var self = this;
	    self.ngModelCtrl = ngModelCtrl;
	
	    // The component needs to be [type="date"] in order to be picked up by AngularJS.
	    this.$attrs.$set('type', 'date');
	
	    // Invoke the `input` directive link function, adding a stub for the element.
	    // This allows us to re-use AngularJS' logic for setting the timezone via ng-model-options.
	    // It works by calling the link function directly which then adds the proper `$parsers` and
	    // `$formatters` to the NgModelController.
	    inputDirective[0].link.pre(this.$scope, {
	      on: angular.noop,
	      val: angular.noop,
	      0: {}
	    }, this.$attrs, [ngModelCtrl]);
	
	    ngModelCtrl.$render = function() {
	      var value = this.$viewValue, convertedDate;
	
	      // In the case where a conversion is needed, the $viewValue here will be a string like
	      // "2020-05-10" instead of a Date object.
	      if (!self.dateUtil.isValidDate(value)) {
	        convertedDate = self.dateUtil.removeLocalTzAndReparseDate(new Date(value));
	        if (self.dateUtil.isValidDate(convertedDate)) {
	          value = convertedDate;
	        }
	      }
	
	      // Notify the child scopes of any changes.
	      self.$scope.$broadcast('md-calendar-parent-changed', value);
	
	      // Set up the selectedDate if it hasn't been already.
	      if (!self.selectedDate) {
	        self.selectedDate = value;
	      }
	
	      // Also set up the displayDate.
	      if (!self.displayDate) {
	        self.displayDate = self.selectedDate || self.today;
	      }
	    };
	
	    self.$mdUtil.nextTick(function() {
	      self.isInitialized = true;
	    });
	  };
	
	  /**
	   * Sets the ng-model value for the calendar and emits a change event.
	   * @param {Date} date new value for the calendar
	   */
	  CalendarCtrl.prototype.setNgModelValue = function(date) {
	    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');
	    var value = this.dateUtil.createDateAtMidnight(date);
	    this.focusDate(value);
	    this.$scope.$emit('md-calendar-change', value);
	    // Using the timezone when the offset is negative (GMT+X) causes the previous day to be
	    // selected here. This check avoids that.
	    if (timezone == null || value.getTimezoneOffset() < 0) {
	      this.ngModelCtrl.$setViewValue(this.ngDateFilter(value, 'yyyy-MM-dd'), 'default');
	    } else {
	      this.ngModelCtrl.$setViewValue(this.ngDateFilter(value, 'yyyy-MM-dd', timezone), 'default');
	    }
	    this.ngModelCtrl.$render();
	    return value;
	  };
	
	  /**
	   * Sets the current view that should be visible in the calendar
	   * @param {string} newView View name to be set.
	   * @param {number|Date} time Date object or a timestamp for the new display date.
	   */
	  CalendarCtrl.prototype.setCurrentView = function(newView, time) {
	    var self = this;
	
	    self.$mdUtil.nextTick(function() {
	      self.currentView = newView;
	
	      if (time) {
	        self.displayDate = angular.isDate(time) ? time : new Date(time);
	      }
	    });
	  };
	
	  /**
	   * Focus the cell corresponding to the given date.
	   * @param {Date=} date The date to be focused.
	   */
	  CalendarCtrl.prototype.focusDate = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var previousFocus = this.$element[0].querySelector('.' + this.FOCUSED_DATE_CLASS);
	      if (previousFocus) {
	        previousFocus.classList.remove(this.FOCUSED_DATE_CLASS);
	      }
	
	      var cellId = this.getDateId(date, this.currentView);
	      var cell = document.getElementById(cellId);
	      if (cell) {
	        cell.classList.add(this.FOCUSED_DATE_CLASS);
	        cell.focus();
	        this.displayDate = date;
	      }
	    } else {
	      var rootElement = this.$element[0].querySelector('[ng-switch]');
	
	      if (rootElement) {
	        rootElement.focus();
	      }
	    }
	  };
	
	  /**
	   * Highlights a date cell on the calendar and changes the selected date.
	   * @param {Date=} date Date to be marked as selected.
	   */
	  CalendarCtrl.prototype.changeSelectedDate = function(date) {
	    var selectedDateClass = this.SELECTED_DATE_CLASS;
	    var prevDateCell = this.$element[0].querySelector('.' + selectedDateClass);
	
	    // Remove the selected class from the previously selected date, if any.
	    if (prevDateCell) {
	      prevDateCell.classList.remove(selectedDateClass);
	      prevDateCell.setAttribute('aria-selected', 'false');
	    }
	
	    // Apply the select class to the new selected date if it is set.
	    if (date) {
	      var dateCell = document.getElementById(this.getDateId(date, this.currentView));
	      if (dateCell) {
	        dateCell.classList.add(selectedDateClass);
	        dateCell.setAttribute('aria-selected', 'true');
	      }
	    }
	
	    this.selectedDate = date;
	  };
	
	  /**
	   * Normalizes the key event into an action name. The action will be broadcast
	   * to the child controllers.
	   * @param {KeyboardEvent} event
	   * @returns {string} The action that should be taken, or null if the key
	   *  does not match a calendar shortcut.
	   */
	  CalendarCtrl.prototype.getActionFromKeyEvent = function(event) {
	    var keyCode = this.keyCode;
	
	    switch (event.which) {
	      case keyCode.ENTER: return 'select';
	
	      case keyCode.RIGHT_ARROW: return 'move-right';
	      case keyCode.LEFT_ARROW: return 'move-left';
	
	      case keyCode.DOWN_ARROW: return event.metaKey ? 'move-page-down' : 'move-row-down';
	      case keyCode.UP_ARROW: return event.metaKey ? 'move-page-up' : 'move-row-up';
	
	      case keyCode.PAGE_DOWN: return 'move-page-down';
	      case keyCode.PAGE_UP: return 'move-page-up';
	
	      case keyCode.HOME: return 'start';
	      case keyCode.END: return 'end';
	
	      default: return null;
	    }
	  };
	
	  /**
	   * Handles a key event in the calendar with the appropriate action.
	   * The action will either
	   *  - select the focused date
	   *  - navigate to focus a new date
	   *  - emit a md-calendar-close event if in a md-datepicker panel
	   *  - emit a md-calendar-parent-action
	   *  - delegate to normal tab order if the TAB key is pressed in standalone mode
	   * @param {KeyboardEvent} event
	   */
	  CalendarCtrl.prototype.handleKeyEvent = function(event) {
	    var self = this;
	
	    this.$scope.$apply(function() {
	      // Capture escape and emit back up so that a wrapping component
	      // (such as a date-picker) can decide to close.
	      if (event.which === self.keyCode.ESCAPE ||
	          (event.which === self.keyCode.TAB && !self.standaloneMode)) {
	        self.$scope.$emit('md-calendar-close');
	
	        if (event.which === self.keyCode.TAB) {
	          event.preventDefault();
	        }
	
	        return;
	      } else if (event.which === self.keyCode.TAB && self.standaloneMode) {
	        // delegate to the normal tab order if the TAB key is pressed in standalone mode
	        return;
	      }
	
	      // Broadcast the action that any child controllers should take.
	      var action = self.getActionFromKeyEvent(event);
	      if (action) {
	        event.preventDefault();
	        event.stopPropagation();
	        self.$scope.$broadcast('md-calendar-parent-action', action);
	      }
	    });
	  };
	
	  /**
	   * Hides the vertical scrollbar on the calendar scroller of a child controller by
	   * setting the width on the calendar scroller and the `overflow: hidden` wrapper
	   * around the scroller, and then setting a padding-right on the scroller equal
	   * to the width of the browser's scrollbar.
	   *
	   * This will cause a reflow.
	   *
	   * @param {object} childCtrl The child controller whose scrollbar should be hidden.
	   */
	  CalendarCtrl.prototype.hideVerticalScrollbar = function(childCtrl) {
	    var self = this;
	    var element = childCtrl.$element[0];
	    var scrollMask = element.querySelector('.md-calendar-scroll-mask');
	
	    if (self.width > 0) {
	      setWidth();
	    } else {
	      self.$$rAF(function() {
	        var scroller = childCtrl.calendarScroller;
	
	        self.scrollbarWidth = scroller.offsetWidth - scroller.clientWidth;
	        self.width = element.querySelector('table').offsetWidth;
	        setWidth();
	      });
	    }
	
	    function setWidth() {
	      var width = self.width || FALLBACK_WIDTH;
	      var scrollbarWidth = self.scrollbarWidth;
	      var scroller = childCtrl.calendarScroller;
	
	      scrollMask.style.width = width + 'px';
	      scroller.style.width = (width + scrollbarWidth) + 'px';
	      scroller.style.paddingRight = scrollbarWidth + 'px';
	    }
	  };
	
	  /**
	   * Gets an identifier for a date unique to the calendar instance for internal
	   * purposes. Not to be displayed.
	   * @param {Date} date The date for which the id is being generated
	   * @param {string} namespace Namespace for the id. (month, year etc.)
	   * @returns {string}
	   */
	  CalendarCtrl.prototype.getDateId = function(date, namespace) {
	    if (!namespace) {
	      throw new Error('A namespace for the date id has to be specified.');
	    }
	
	    return [
	      'md',
	      this.id,
	      namespace,
	      date.getFullYear(),
	      date.getMonth(),
	      date.getDate()
	    ].join('-');
	  };
	
	  /**
	   * Util to trigger an extra digest on a parent scope, in order to to ensure that
	   * any child virtual repeaters have updated. This is necessary, because the virtual
	   * repeater doesn't update the $index the first time around since the content isn't
	   * in place yet. The case, in which this is an issue, is when the repeater has less
	   * than a page of content (e.g. a month or year view has a min or max date).
	   */
	  CalendarCtrl.prototype.updateVirtualRepeat = function() {
	    var scope = this.$scope;
	    var virtualRepeatResizeListener = scope.$on('$md-resize-enable', function() {
	      if (!scope.$$phase) {
	        scope.$apply();
	      }
	
	      virtualRepeatResizeListener();
	    });
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarMonthCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendarMonth', calendarDirective);
	
	  /**
	   * Height of one calendar month tbody. This must be made known to the virtual-repeat and is
	   * subsequently used for scrolling to specific months.
	   */
	  var TBODY_HEIGHT = 265;
	
	  /**
	   * Height of a calendar month with a single row. This is needed to calculate the offset for
	   * rendering an extra month in virtual-repeat that only contains one row.
	   */
	  var TBODY_SINGLE_ROW_HEIGHT = 45;
	
	  /** Private directive that represents a list of months inside the calendar. */
	  function calendarDirective() {
	    return {
	      template:
	        '<table aria-hidden="true" class="md-calendar-day-header"><thead></thead></table>' +
	        '<div class="md-calendar-scroll-mask">' +
	        '<md-virtual-repeat-container class="md-calendar-scroll-container" ' +
	              'md-offset-size="' + (TBODY_SINGLE_ROW_HEIGHT - TBODY_HEIGHT) + '">' +
	            '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
	              '<tbody ' +
	                  'md-calendar-month-body ' +
	                  'role="rowgroup" ' +
	                  'md-virtual-repeat="i in monthCtrl.items" ' +
	                  'md-month-offset="$index" ' +
	                  'class="md-calendar-month" ' +
	                  'md-start-index="monthCtrl.getSelectedMonthIndex()" ' +
	                  'md-item-size="' + TBODY_HEIGHT + '">' +
	
	                // The <tr> ensures that the <tbody> will always have the
	                // proper height, even if it's empty. If it's content is
	                // compiled, the <tr> will be overwritten.
	                '<tr aria-hidden="true" md-force-height="\'' + TBODY_HEIGHT + 'px\'"></tr>' +
	              '</tbody>' +
	            '</table>' +
	          '</md-virtual-repeat-container>' +
	        '</div>',
	      require: ['^^mdCalendar', 'mdCalendarMonth'],
	      controller: CalendarMonthCtrl,
	      controllerAs: 'monthCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var monthCtrl = controllers[1];
	        monthCtrl.initialize(calendarCtrl);
	      }
	    };
	  }
	
	  /**
	   * Controller for the calendar month component.
	   * @ngInject @constructor
	   */
	  function CalendarMonthCtrl($element, $scope, $animate, $q,
	    $$mdDateUtil, $mdDateLocale) {
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @final {!angular.$animate} */
	    this.$animate = $animate;
	
	    /** @final {!angular.$q} */
	    this.$q = $q;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @final {HTMLElement} */
	    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	
	    /** @type {boolean} */
	    this.isInitialized = false;
	
	    /** @type {boolean} */
	    this.isMonthTransitionInProgress = false;
	
	    var self = this;
	
	    /**
	     * Handles a click event on a date cell.
	     * Created here so that every cell can use the same function instance.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.cellClickHandler = function() {
	      var timestamp = $$mdDateUtil.getTimestampFromNode(this);
	      self.$scope.$apply(function() {
	        // The timestamp has to be converted to a valid date.
	        self.calendarCtrl.setNgModelValue(new Date(timestamp));
	      });
	    };
	
	    /**
	     * Handles click events on the month headers. Switches
	     * the calendar to the year view.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.headerClickHandler = function() {
	      self.calendarCtrl.setCurrentView('year', $$mdDateUtil.getTimestampFromNode(this));
	    };
	  }
	
	  /** Initialization **/
	
	  /**
	   * Initialize the controller by saving a reference to the calendar and
	   * setting up the object that will be iterated by the virtual repeater.
	   */
	  CalendarMonthCtrl.prototype.initialize = function(calendarCtrl) {
	    /**
	     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
	     * number of months that can be viewed. We add 2 months: one to include the current month
	     * and one for the last dummy month.
	     *
	     * This is shorter than ideal because of a (potential) Firefox bug
	     * https://bugzilla.mozilla.org/show_bug.cgi?id=1181658.
	     */
	
	    this.items = {
	      length: this.dateUtil.getMonthDistance(
	        calendarCtrl.firstRenderableDate,
	        calendarCtrl.lastRenderableDate
	      ) + 2
	    };
	
	    this.calendarCtrl = calendarCtrl;
	    this.attachScopeListeners();
	    calendarCtrl.updateVirtualRepeat();
	
	    // Fire the initial render, since we might have missed it the first time it fired.
	    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
	  };
	
	  /**
	   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
	   * @returns {number} the "index" of the currently selected date
	   */
	  CalendarMonthCtrl.prototype.getSelectedMonthIndex = function() {
	    var calendarCtrl = this.calendarCtrl;
	
	    return this.dateUtil.getMonthDistance(
	      calendarCtrl.firstRenderableDate,
	      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
	    );
	  };
	
	  /**
	   * Change the date that is being shown in the calendar. If the given date is in a different
	   * month, the displayed month will be transitioned.
	   * @param {Date} date
	   */
	  CalendarMonthCtrl.prototype.changeDisplayDate = function(date) {
	    // Initialization is deferred until this function is called because we want to reflect
	    // the starting value of ngModel.
	    if (!this.isInitialized) {
	      this.buildWeekHeader();
	      this.calendarCtrl.hideVerticalScrollbar(this);
	      this.isInitialized = true;
	      return this.$q.when();
	    }
	
	    // If trying to show an invalid date or a transition is in progress, do nothing.
	    if (!this.dateUtil.isValidDate(date) || this.isMonthTransitionInProgress) {
	      return this.$q.when();
	    }
	
	    this.isMonthTransitionInProgress = true;
	    var animationPromise = this.animateDateChange(date);
	
	    this.calendarCtrl.displayDate = date;
	
	    var self = this;
	    animationPromise.then(function() {
	      self.isMonthTransitionInProgress = false;
	    });
	
	    return animationPromise;
	  };
	
	  /**
	   * Animates the transition from the calendar's current month to the given month.
	   * @param {Date} date
	   * @returns {angular.$q.Promise} The animation promise.
	   */
	  CalendarMonthCtrl.prototype.animateDateChange = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var monthDistance = this.dateUtil.getMonthDistance(this.calendarCtrl.firstRenderableDate, date);
	      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
	    }
	
	    return this.$q.when();
	  };
	
	  /**
	   * Builds and appends a day-of-the-week header to the calendar.
	   * This should only need to be called once during initialization.
	   */
	  CalendarMonthCtrl.prototype.buildWeekHeader = function() {
	    var firstDayOfWeek = this.dateLocale.firstDayOfWeek;
	    var shortDays = this.dateLocale.shortDays;
	
	    var row = document.createElement('tr');
	    for (var i = 0; i < 7; i++) {
	      var th = document.createElement('th');
	      th.textContent = shortDays[(i + firstDayOfWeek) % 7];
	      row.appendChild(th);
	    }
	
	    this.$element.find('thead').append(row);
	  };
	
	  /**
	   * Attaches listeners for the scope events that are broadcast by the calendar.
	   */
	  CalendarMonthCtrl.prototype.attachScopeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
	      self.calendarCtrl.changeSelectedDate(value);
	      self.changeDisplayDate(value);
	    });
	
	    self.$scope.$on('md-calendar-parent-action', angular.bind(this, this.handleKeyEvent));
	  };
	
	  /**
	   * Handles the month-specific keyboard interactions.
	   * @param {Object} event Scope event object passed by the calendar.
	   * @param {String} action Action, corresponding to the key that was pressed.
	   */
	  CalendarMonthCtrl.prototype.handleKeyEvent = function(event, action) {
	    var calendarCtrl = this.calendarCtrl;
	    var displayDate = calendarCtrl.displayDate;
	
	    if (action === 'select') {
	      calendarCtrl.setNgModelValue(displayDate);
	    } else {
	      var date = null;
	      var dateUtil = this.dateUtil;
	
	      switch (action) {
	        case 'move-right': date = dateUtil.incrementDays(displayDate, 1); break;
	        case 'move-left': date = dateUtil.incrementDays(displayDate, -1); break;
	
	        case 'move-page-down': date = dateUtil.incrementMonths(displayDate, 1); break;
	        case 'move-page-up': date = dateUtil.incrementMonths(displayDate, -1); break;
	
	        case 'move-row-down': date = dateUtil.incrementDays(displayDate, 7); break;
	        case 'move-row-up': date = dateUtil.incrementDays(displayDate, -7); break;
	
	        case 'start': date = dateUtil.getFirstDateOfMonth(displayDate); break;
	        case 'end': date = dateUtil.getLastDateOfMonth(displayDate); break;
	      }
	
	      if (date) {
	        date = this.dateUtil.clampDate(date, calendarCtrl.minDate, calendarCtrl.maxDate);
	
	        this.changeDisplayDate(date).then(function() {
	          calendarCtrl.focusDate(date);
	        });
	      }
	    }
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  mdCalendarMonthBodyDirective.$inject = ["$compile", "$$mdSvgRegistry"];
	  CalendarMonthBodyCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	      .directive('mdCalendarMonthBody', mdCalendarMonthBodyDirective);
	
	  /**
	   * Private directive consumed by md-calendar-month. Having this directive lets the calender use
	   * md-virtual-repeat and also cleanly separates the month DOM construction functions from
	   * the rest of the calendar controller logic.
	   * @ngInject
	   */
	  function mdCalendarMonthBodyDirective($compile, $$mdSvgRegistry) {
	    var ARROW_ICON = $compile('<md-icon md-svg-src="' +
	      $$mdSvgRegistry.mdTabsArrow + '"></md-icon>')({})[0];
	
	    return {
	      require: ['^^mdCalendar', '^^mdCalendarMonth', 'mdCalendarMonthBody'],
	      scope: { offset: '=mdMonthOffset' },
	      controller: CalendarMonthBodyCtrl,
	      controllerAs: 'mdMonthBodyCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var monthCtrl = controllers[1];
	        var monthBodyCtrl = controllers[2];
	
	        monthBodyCtrl.calendarCtrl = calendarCtrl;
	        monthBodyCtrl.monthCtrl = monthCtrl;
	        monthBodyCtrl.arrowIcon = ARROW_ICON.cloneNode(true);
	
	        // The virtual-repeat re-uses the same DOM elements, so there are only a limited number
	        // of repeated items that are linked, and then those elements have their bindings updated.
	        // Since the months are not generated by bindings, we simply regenerate the entire thing
	        // when the binding (offset) changes.
	        scope.$watch(function() { return monthBodyCtrl.offset; }, function(offset) {
	          if (angular.isNumber(offset)) {
	            monthBodyCtrl.generateContent();
	          }
	        });
	      }
	    };
	  }
	
	  /**
	   * Controller for a single calendar month.
	   * @ngInject @constructor
	   */
	  function CalendarMonthBodyCtrl($element, $$mdDateUtil, $mdDateLocale) {
	    /**
	     * @final
	     * @type {!JQLite}
	     */
	    this.$element = $element;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @type {Object} Reference to the month view. */
	    this.monthCtrl = null;
	
	    /** @type {Object} Reference to the calendar. */
	    this.calendarCtrl = null;
	
	    /**
	     * Number of months from the start of the month "items" that the currently rendered month
	     * occurs. Set via angular data binding.
	     * @type {number|null}
	     */
	    this.offset = null;
	
	    /**
	     * Date cell to focus after appending the month to the document.
	     * @type {HTMLElement}
	     */
	    this.focusAfterAppend = null;
	  }
	
	  /** Generate and append the content for this month to the directive element. */
	  CalendarMonthBodyCtrl.prototype.generateContent = function() {
	    var date = this.dateUtil.incrementMonths(this.calendarCtrl.firstRenderableDate, this.offset);
	
	    this.$element
	      .empty()
	      .append(this.buildCalendarForMonth(date));
	
	    if (this.focusAfterAppend) {
	      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
	      this.focusAfterAppend = null;
	    }
	  };
	
	  /**
	   * Creates a single cell to contain a date in the calendar with all appropriate
	   * attributes and classes added. If a date is given, the cell content will be set
	   * based on the date.
	   * @param {Date=} opt_date
	   * @returns {HTMLElement}
	   */
	  CalendarMonthBodyCtrl.prototype.buildDateCell = function(opt_date) {
	    var monthCtrl = this.monthCtrl;
	    var calendarCtrl = this.calendarCtrl;
	
	    // TODO(jelbourn): cloneNode is likely a faster way of doing this.
	    var cell = document.createElement('td');
	    cell.tabIndex = -1;
	    cell.classList.add('md-calendar-date');
	    cell.setAttribute('role', 'gridcell');
	
	    if (opt_date) {
	      cell.setAttribute('tabindex', '-1');
	      cell.setAttribute('aria-label', this.dateLocale.longDateFormatter(opt_date));
	      cell.id = calendarCtrl.getDateId(opt_date, 'month');
	
	      // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
	      cell.setAttribute('data-timestamp', opt_date.getTime());
	
	      // TODO(jelourn): Doing these comparisons for class addition during generation might be slow.
	      // It may be better to finish the construction and then query the node and add the class.
	      if (this.dateUtil.isSameDay(opt_date, calendarCtrl.today)) {
	        cell.classList.add(calendarCtrl.TODAY_CLASS);
	      }
	
	      if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
	          this.dateUtil.isSameDay(opt_date, calendarCtrl.selectedDate)) {
	        cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
	        cell.setAttribute('aria-selected', 'true');
	      }
	
	      var cellText = this.dateLocale.dates[opt_date.getDate()];
	
	      if (this.isDateEnabled(opt_date)) {
	        // Add a indicator for select, hover, and focus states.
	        var selectionIndicator = document.createElement('span');
	        selectionIndicator.classList.add('md-calendar-date-selection-indicator');
	        selectionIndicator.textContent = cellText;
	        cell.appendChild(selectionIndicator);
	        cell.addEventListener('click', monthCtrl.cellClickHandler);
	
	        if (calendarCtrl.displayDate && this.dateUtil.isSameDay(opt_date, calendarCtrl.displayDate)) {
	          this.focusAfterAppend = cell;
	        }
	      } else {
	        cell.classList.add('md-calendar-date-disabled');
	        cell.textContent = cellText;
	      }
	    }
	
	    return cell;
	  };
	
	  /**
	   * Check whether date is in range and enabled
	   * @param {Date=} opt_date
	   * @return {boolean} Whether the date is enabled.
	   */
	  CalendarMonthBodyCtrl.prototype.isDateEnabled = function(opt_date) {
	    return this.dateUtil.isDateWithinRange(opt_date,
	          this.calendarCtrl.minDate, this.calendarCtrl.maxDate) &&
	          (!angular.isFunction(this.calendarCtrl.dateFilter)
	           || this.calendarCtrl.dateFilter(opt_date));
	  };
	
	  /**
	   * Builds a `tr` element for the calendar grid.
	   * @param rowNumber The week number within the month.
	   * @returns {HTMLElement}
	   */
	  CalendarMonthBodyCtrl.prototype.buildDateRow = function(rowNumber) {
	    var row = document.createElement('tr');
	    row.setAttribute('role', 'row');
	
	    // Because of an NVDA bug (with Firefox), the row needs an aria-label in order
	    // to prevent the entire row being read aloud when the user moves between rows.
	    // See http://community.nvda-project.org/ticket/4643.
	    row.setAttribute('aria-label', this.dateLocale.weekNumberFormatter(rowNumber));
	
	    return row;
	  };
	
	  /**
	   * Builds the <tbody> content for the given date's month.
	   * @param {Date=} opt_dateInMonth
	   * @returns {DocumentFragment} A document fragment containing the <tr> elements.
	   */
	  CalendarMonthBodyCtrl.prototype.buildCalendarForMonth = function(opt_dateInMonth) {
	    var date = this.dateUtil.isValidDate(opt_dateInMonth) ? opt_dateInMonth : new Date();
	
	    var firstDayOfMonth = this.dateUtil.getFirstDateOfMonth(date);
	    var firstDayOfTheWeek = this.getLocaleDay_(firstDayOfMonth);
	    var numberOfDaysInMonth = this.dateUtil.getNumberOfDaysInMonth(date);
	
	    // Store rows for the month in a document fragment so that we can append them all at once.
	    var monthBody = document.createDocumentFragment();
	
	    var rowNumber = 1;
	    var row = this.buildDateRow(rowNumber);
	    monthBody.appendChild(row);
	
	    // If this is the final month in the list of items, only the first week should render,
	    // so we should return immediately after the first row is complete and has been
	    // attached to the body.
	    var isFinalMonth = this.offset === this.monthCtrl.items.length - 1;
	
	    // Add a label for the month. If the month starts on a Sun/Mon/Tues, the month label
	    // goes on a row above the first of the month. Otherwise, the month label takes up the first
	    // two cells of the first row.
	    var blankCellOffset = 0;
	    var monthLabelCell = document.createElement('td');
	    var monthLabelCellContent = document.createElement('span');
	    var calendarCtrl = this.calendarCtrl;
	
	    monthLabelCellContent.textContent = this.dateLocale.monthHeaderFormatter(date);
	    monthLabelCell.appendChild(monthLabelCellContent);
	    monthLabelCell.classList.add('md-calendar-month-label');
	    // If the entire month is after the max date, render the label as a disabled state.
	    if (calendarCtrl.maxDate && firstDayOfMonth > calendarCtrl.maxDate) {
	      monthLabelCell.classList.add('md-calendar-month-label-disabled');
	    // If the user isn't supposed to be able to change views, render the
	    // label as usual, but disable the clicking functionality.
	    } else if (!calendarCtrl.mode) {
	      monthLabelCell.addEventListener('click', this.monthCtrl.headerClickHandler);
	      monthLabelCell.setAttribute('data-timestamp', firstDayOfMonth.getTime());
	      monthLabelCell.setAttribute('aria-label', this.dateLocale.monthFormatter(date));
	      monthLabelCell.classList.add('md-calendar-label-clickable');
	      monthLabelCell.appendChild(this.arrowIcon.cloneNode(true));
	    }
	
	    if (firstDayOfTheWeek <= 2) {
	      monthLabelCell.setAttribute('colspan', '7');
	
	      var monthLabelRow = this.buildDateRow();
	      monthLabelRow.appendChild(monthLabelCell);
	      monthBody.insertBefore(monthLabelRow, row);
	
	      if (isFinalMonth) {
	        return monthBody;
	      }
	    } else {
	      blankCellOffset = 3;
	      monthLabelCell.setAttribute('colspan', '3');
	      row.appendChild(monthLabelCell);
	    }
	
	    // Add a blank cell for each day of the week that occurs before the first of the month.
	    // For example, if the first day of the month is a Tuesday, add blank cells for Sun and Mon.
	    // The blankCellOffset is needed in cases where the first N cells are used by the month label.
	    for (var i = blankCellOffset; i < firstDayOfTheWeek; i++) {
	      row.appendChild(this.buildDateCell());
	    }
	
	    // Add a cell for each day of the month, keeping track of the day of the week so that
	    // we know when to start a new row.
	    var dayOfWeek = firstDayOfTheWeek;
	    var iterationDate = firstDayOfMonth;
	    for (var d = 1; d <= numberOfDaysInMonth; d++) {
	      // If we've reached the end of the week, start a new row.
	      if (dayOfWeek === 7) {
	        // We've finished the first row, so we're done if this is the final month.
	        if (isFinalMonth) {
	          return monthBody;
	        }
	        dayOfWeek = 0;
	        rowNumber++;
	        row = this.buildDateRow(rowNumber);
	        monthBody.appendChild(row);
	      }
	
	      iterationDate.setDate(d);
	      var cell = this.buildDateCell(iterationDate);
	      row.appendChild(cell);
	
	      dayOfWeek++;
	    }
	
	    // Ensure that the last row of the month has 7 cells.
	    while (row.childNodes.length < 7) {
	      row.appendChild(this.buildDateCell());
	    }
	
	    // Ensure that all months have 6 rows. This is necessary for now because the virtual-repeat
	    // requires that all items have exactly the same height.
	    while (monthBody.childNodes.length < 6) {
	      var whitespaceRow = this.buildDateRow();
	      for (var j = 0; j < 7; j++) {
	        whitespaceRow.appendChild(this.buildDateCell());
	      }
	      monthBody.appendChild(whitespaceRow);
	    }
	
	    return monthBody;
	  };
	
	  /**
	   * Gets the day-of-the-week index for a date for the current locale.
	   * @private
	   * @param {Date} date
	   * @returns {number} The column index of the date in the calendar.
	   */
	  CalendarMonthBodyCtrl.prototype.getLocaleDay_ = function(date) {
	    return (date.getDay() + (7 - this.dateLocale.firstDayOfWeek)) % 7;
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarYearCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil", "$mdUtil"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendarYear', calendarDirective);
	
	  /**
	   * Height of one calendar year tbody. This must be made known to the virtual-repeat and is
	   * subsequently used for scrolling to specific years.
	   */
	  var TBODY_HEIGHT = 88;
	
	  /** Private component, representing a list of years in the calendar. */
	  function calendarDirective() {
	    return {
	      template:
	        '<div class="md-calendar-scroll-mask">' +
	          '<md-virtual-repeat-container class="md-calendar-scroll-container">' +
	            '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
	              '<tbody ' +
	                  'md-calendar-year-body ' +
	                  'role="rowgroup" ' +
	                  'md-virtual-repeat="i in yearCtrl.items" ' +
	                  'md-year-offset="$index" class="md-calendar-year" ' +
	                  'md-start-index="yearCtrl.getFocusedYearIndex()" ' +
	                  'md-item-size="' + TBODY_HEIGHT + '">' +
	                // The <tr> ensures that the <tbody> will have the proper
	                // height, even though it may be empty.
	                '<tr aria-hidden="true" md-force-height="\'' + TBODY_HEIGHT + 'px\'"></tr>' +
	              '</tbody>' +
	            '</table>' +
	          '</md-virtual-repeat-container>' +
	        '</div>',
	      require: ['^^mdCalendar', 'mdCalendarYear'],
	      controller: CalendarYearCtrl,
	      controllerAs: 'yearCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var yearCtrl = controllers[1];
	        yearCtrl.initialize(calendarCtrl);
	      }
	    };
	  }
	
	  /**
	   * Controller for the mdCalendar component.
	   * @ngInject @constructor
	   */
	  function CalendarYearCtrl($element, $scope, $animate, $q, $$mdDateUtil, $mdUtil) {
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @final {!angular.$animate} */
	    this.$animate = $animate;
	
	    /** @final {!angular.$q} */
	    this.$q = $q;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final {HTMLElement} */
	    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	
	    /** @type {boolean} */
	    this.isInitialized = false;
	
	    /** @type {boolean} */
	    this.isMonthTransitionInProgress = false;
	
	    /** @final */
	    this.$mdUtil = $mdUtil;
	
	    var self = this;
	
	    /**
	     * Handles a click event on a date cell.
	     * Created here so that every cell can use the same function instance.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.cellClickHandler = function() {
	      self.onTimestampSelected($$mdDateUtil.getTimestampFromNode(this));
	    };
	  }
	
	  /**
	   * Initialize the controller by saving a reference to the calendar and
	   * setting up the object that will be iterated by the virtual repeater.
	   */
	  CalendarYearCtrl.prototype.initialize = function(calendarCtrl) {
	    /**
	     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
	     * number of years that can be viewed. We add 1 extra in order to include the current year.
	     */
	
	    this.items = {
	      length: this.dateUtil.getYearDistance(
	        calendarCtrl.firstRenderableDate,
	        calendarCtrl.lastRenderableDate
	      ) + 1
	    };
	
	    this.calendarCtrl = calendarCtrl;
	    this.attachScopeListeners();
	    calendarCtrl.updateVirtualRepeat();
	
	    // Fire the initial render, since we might have missed it the first time it fired.
	    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
	  };
	
	  /**
	   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
	   * @returns {number}
	   */
	  CalendarYearCtrl.prototype.getFocusedYearIndex = function() {
	    var calendarCtrl = this.calendarCtrl;
	
	    return this.dateUtil.getYearDistance(
	      calendarCtrl.firstRenderableDate,
	      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
	    );
	  };
	
	  /**
	   * Change the date that is highlighted in the calendar.
	   * @param {Date} date
	   */
	  CalendarYearCtrl.prototype.changeDate = function(date) {
	    // Initialization is deferred until this function is called because we want to reflect
	    // the starting value of ngModel.
	    if (!this.isInitialized) {
	      this.calendarCtrl.hideVerticalScrollbar(this);
	      this.isInitialized = true;
	      return this.$q.when();
	    } else if (this.dateUtil.isValidDate(date) && !this.isMonthTransitionInProgress) {
	      var self = this;
	      var animationPromise = this.animateDateChange(date);
	
	      self.isMonthTransitionInProgress = true;
	      self.calendarCtrl.displayDate = date;
	
	      return animationPromise.then(function() {
	        self.isMonthTransitionInProgress = false;
	      });
	    }
	  };
	
	  /**
	   * Animates the transition from the calendar's current month to the given month.
	   * @param {Date} date
	   * @returns {angular.$q.Promise} The animation promise.
	   */
	  CalendarYearCtrl.prototype.animateDateChange = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var monthDistance = this.dateUtil.getYearDistance(this.calendarCtrl.firstRenderableDate, date);
	      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
	    }
	
	    return this.$q.when();
	  };
	
	  /**
	   * Handles the year-view-specific keyboard interactions.
	   * @param {Object} event Scope event object passed by the calendar.
	   * @param {String} action Action, corresponding to the key that was pressed.
	   */
	  CalendarYearCtrl.prototype.handleKeyEvent = function(event, action) {
	    var self = this;
	    var calendarCtrl = self.calendarCtrl;
	    var displayDate = calendarCtrl.displayDate;
	
	    if (action === 'select') {
	      self.changeDate(displayDate).then(function() {
	        self.onTimestampSelected(displayDate);
	      });
	    } else {
	      var date = null;
	      var dateUtil = self.dateUtil;
	
	      switch (action) {
	        case 'move-right': date = dateUtil.incrementMonths(displayDate, 1); break;
	        case 'move-left': date = dateUtil.incrementMonths(displayDate, -1); break;
	
	        case 'move-row-down': date = dateUtil.incrementMonths(displayDate, 6); break;
	        case 'move-row-up': date = dateUtil.incrementMonths(displayDate, -6); break;
	      }
	
	      if (date) {
	        var min = calendarCtrl.minDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.minDate) : null;
	        var max = calendarCtrl.maxDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.maxDate) : null;
	        date = dateUtil.getFirstDateOfMonth(self.dateUtil.clampDate(date, min, max));
	
	        self.changeDate(date).then(function() {
	          calendarCtrl.focusDate(date);
	        });
	      }
	    }
	  };
	
	  /**
	   * Attaches listeners for the scope events that are broadcast by the calendar.
	   */
	  CalendarYearCtrl.prototype.attachScopeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
	      self.calendarCtrl.changeSelectedDate(value ? self.dateUtil.getFirstDateOfMonth(value) : value);
	      self.changeDate(value);
	    });
	
	    self.$scope.$on('md-calendar-parent-action', angular.bind(self, self.handleKeyEvent));
	  };
	
	  /**
	   * Handles the behavior when a date is selected. Depending on the `mode`
	   * of the calendar, this can either switch back to the calendar view or
	   * set the model value.
	   * @param {number} timestamp The selected timestamp.
	   */
	  CalendarYearCtrl.prototype.onTimestampSelected = function(timestamp) {
	    var calendarCtrl = this.calendarCtrl;
	
	    if (calendarCtrl.mode) {
	      this.$mdUtil.nextTick(function() {
	        // The timestamp has to be converted to a valid date.
	        calendarCtrl.setNgModelValue(new Date(timestamp));
	      });
	    } else {
	      calendarCtrl.setCurrentView('month', timestamp);
	    }
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarYearBodyCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	      .directive('mdCalendarYearBody', mdCalendarYearDirective);
	
	  /**
	   * Private component, consumed by the md-calendar-year, which separates the DOM construction logic
	   * and allows for the year view to use md-virtual-repeat.
	   */
	  function mdCalendarYearDirective() {
	    return {
	      require: ['^^mdCalendar', '^^mdCalendarYear', 'mdCalendarYearBody'],
	      scope: { offset: '=mdYearOffset' },
	      controller: CalendarYearBodyCtrl,
	      controllerAs: 'mdYearBodyCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var yearCtrl = controllers[1];
	        var yearBodyCtrl = controllers[2];
	
	        yearBodyCtrl.calendarCtrl = calendarCtrl;
	        yearBodyCtrl.yearCtrl = yearCtrl;
	
	        scope.$watch(function() { return yearBodyCtrl.offset; }, function(offset) {
	          if (angular.isNumber(offset)) {
	            yearBodyCtrl.generateContent();
	          }
	        });
	      }
	    };
	  }
	
	  /**
	   * Controller for a single year.
	   * @ngInject @constructor
	   */
	  function CalendarYearBodyCtrl($element, $$mdDateUtil, $mdDateLocale) {
	    /**
	     * @final
	     * @type {!JQLite}
	     */
	    this.$element = $element;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @type {Object} Reference to the calendar. */
	    this.calendarCtrl = null;
	
	    /** @type {Object} Reference to the year view. */
	    this.yearCtrl = null;
	
	    /**
	     * Number of months from the start of the month "items" that the currently rendered month
	     * occurs. Set via angular data binding.
	     * @type {number|null}
	     */
	    this.offset = null;
	
	    /**
	     * Date cell to focus after appending the month to the document.
	     * @type {HTMLElement}
	     */
	    this.focusAfterAppend = null;
	  }
	
	  /** Generate and append the content for this year to the directive element. */
	  CalendarYearBodyCtrl.prototype.generateContent = function() {
	    var date = this.dateUtil.incrementYears(this.calendarCtrl.firstRenderableDate, this.offset);
	
	    this.$element
	      .empty()
	      .append(this.buildCalendarForYear(date));
	
	    if (this.focusAfterAppend) {
	      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
	      this.focusAfterAppend = null;
	    }
	  };
	
	  /**
	   * Creates a single cell to contain a year in the calendar.
	   * @param {number} year Four-digit year.
	   * @param {number} month Zero-indexed month.
	   * @returns {HTMLElement}
	   */
	  CalendarYearBodyCtrl.prototype.buildMonthCell = function(year, month) {
	    var calendarCtrl = this.calendarCtrl;
	    var yearCtrl = this.yearCtrl;
	    var cell = this.buildBlankCell();
	
	    // Represent this month/year as a date.
	    var firstOfMonth = new Date(year, month, 1);
	    cell.setAttribute('aria-label', this.dateLocale.monthFormatter(firstOfMonth));
	    cell.id = calendarCtrl.getDateId(firstOfMonth, 'year');
	
	    // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
	    cell.setAttribute('data-timestamp', String(firstOfMonth.getTime()));
	
	    if (this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.today)) {
	      cell.classList.add(calendarCtrl.TODAY_CLASS);
	    }
	
	    if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
	        this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.selectedDate)) {
	      cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
	      cell.setAttribute('aria-selected', 'true');
	    }
	
	    var cellText = this.dateLocale.shortMonths[month];
	
	    if (this.dateUtil.isMonthWithinRange(
	          firstOfMonth, calendarCtrl.minDate, calendarCtrl.maxDate) &&
	      (!angular.isFunction(calendarCtrl.monthFilter) ||
	        calendarCtrl.monthFilter(firstOfMonth))) {
	      var selectionIndicator = document.createElement('span');
	      selectionIndicator.classList.add('md-calendar-date-selection-indicator');
	      selectionIndicator.textContent = cellText;
	      cell.appendChild(selectionIndicator);
	      cell.addEventListener('click', yearCtrl.cellClickHandler);
	
	      if (calendarCtrl.displayDate &&
	          this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.displayDate)) {
	        this.focusAfterAppend = cell;
	      }
	    } else {
	      cell.classList.add('md-calendar-date-disabled');
	      cell.textContent = cellText;
	    }
	
	    return cell;
	  };
	
	  /**
	   * Builds a blank cell.
	   * @return {HTMLElement}
	   */
	  CalendarYearBodyCtrl.prototype.buildBlankCell = function() {
	    var cell = document.createElement('td');
	    cell.tabIndex = -1;
	    cell.classList.add('md-calendar-date');
	    cell.setAttribute('role', 'gridcell');
	
	    cell.setAttribute('tabindex', '-1');
	    return cell;
	  };
	
	  /**
	   * Builds the <tbody> content for the given year.
	   * @param {Date} date Date for which the content should be built.
	   * @returns {DocumentFragment} A document fragment containing the months within the year.
	   */
	  CalendarYearBodyCtrl.prototype.buildCalendarForYear = function(date) {
	    // Store rows for the month in a document fragment so that we can append them all at once.
	    var year = date.getFullYear();
	    var yearBody = document.createDocumentFragment();
	
	    var monthCell, i;
	    // First row contains label and Jan-Jun.
	    var firstRow = document.createElement('tr');
	    var labelCell = document.createElement('td');
	    labelCell.className = 'md-calendar-month-label';
	    labelCell.textContent = String(year);
	    firstRow.appendChild(labelCell);
	
	    for (i = 0; i < 6; i++) {
	      firstRow.appendChild(this.buildMonthCell(year, i));
	    }
	    yearBody.appendChild(firstRow);
	
	    // Second row contains a blank cell and Jul-Dec.
	    var secondRow = document.createElement('tr');
	    secondRow.appendChild(this.buildBlankCell());
	    for (i = 6; i < 12; i++) {
	      secondRow.appendChild(this.buildMonthCell(year, i));
	    }
	    yearBody.appendChild(secondRow);
	
	    return yearBody;
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdDateLocaleProvider
	   * @module material.components.datepicker
	   *
	   * @description
	   * The `$mdDateLocaleProvider` is the provider that creates the `$mdDateLocale` service.
	   * This provider that allows the user to specify messages, formatters, and parsers for date
	   * internationalization. The `$mdDateLocale` service itself is consumed by AngularJS Material
	   * components that deal with dates
	   * (i.e. <a ng-href="api/directive/mdDatepicker">mdDatepicker</a>).
	   *
	   * @property {Array<string>} months Array of month names (in order).
	   * @property {Array<string>} shortMonths Array of abbreviated month names.
	   * @property {Array<string>} days Array of the days of the week (in order).
	   * @property {Array<string>} shortDays Array of abbreviated days of the week.
	   * @property {Array<string>} dates Array of dates of the month. Only necessary for locales
	   *  using a numeral system other than [1, 2, 3...].
	   * @property {Array<string>} firstDayOfWeek The first day of the week. Sunday = 0, Monday = 1,
	   *  etc.
	   * @property {function(string): Date} parseDate Function that converts a date string to a Date
	   *  object (the date portion).
	   * @property {function(Date, string): string} formatDate Function to format a date object to a
	   *  string. The datepicker directive also provides the time zone, if it was specified.
	   * @property {function(Date): string} monthHeaderFormatter Function that returns the label for
	   *  a month given a date.
	   * @property {function(Date): string} monthFormatter Function that returns the full name of a month
	   *  for a given date.
	   * @property {function(number): string} weekNumberFormatter Function that returns a label for
	   *  a week given the week number.
	   * @property {function(Date): string} longDateFormatter Function that formats a date into a long
	   *  `aria-label` that is read by the screen reader when the focused date changes.
	   * @property {string} msgCalendar Translation of the label "Calendar" for the current locale.
	   * @property {string} msgOpenCalendar Translation of the button label "Open calendar" for the
	   *  current locale.
	   * @property {Date} firstRenderableDate The date from which the datepicker calendar will begin
	   *  rendering. Note that this will be ignored if a minimum date is set.
	   *  Defaults to January 1st 1880.
	   * @property {Date} lastRenderableDate The last date that will be rendered by the datepicker
	   *  calendar. Note that this will be ignored if a maximum date is set.
	   *  Defaults to January 1st 2130.
	   * @property {function(string): boolean} isDateComplete Function to determine whether a string
	   *  makes sense to be parsed to a `Date` object. Returns `true` if the date appears to be complete
	   *  and parsing should occur. By default, this checks for 3 groups of text or numbers separated
	   *  by delimiters. This means that by default, date strings must include a month, day, and year
	   *  to be parsed and for the model to be updated.
	   *
	   * @usage
	   * <hljs lang="js">
	   * myAppModule.config(function($mdDateLocaleProvider) {
	   *
	   *     // Example of a French localization.
	   *     $mdDateLocaleProvider.months = ['janvier', 'février', 'mars', ...];
	   *     $mdDateLocaleProvider.shortMonths = ['janv', 'févr', 'mars', ...];
	   *     $mdDateLocaleProvider.days = ['dimanche', 'lundi', 'mardi', ...];
	   *     $mdDateLocaleProvider.shortDays = ['Di', 'Lu', 'Ma', ...];
	   *
	   *     // Can change week display to start on Monday.
	   *     $mdDateLocaleProvider.firstDayOfWeek = 1;
	   *
	   *     // Optional.
	   *     $mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, ...];
	   *
	   *     // Example uses moment.js to parse and format dates.
	   *     $mdDateLocaleProvider.parseDate = function(dateString) {
	   *       var m = moment(dateString, 'L', true);
	   *       return m.isValid() ? m.toDate() : new Date(NaN);
	   *     };
	   *
	   *     $mdDateLocaleProvider.formatDate = function(date) {
	   *       var m = moment(date);
	   *       return m.isValid() ? m.format('L') : '';
	   *     };
	   *
	   *     // Allow only a day and month to be specified.
	   *     // This is required if using the 'M/D' format with moment.js.
	   *     $mdDateLocaleProvider.isDateComplete = function(dateString) {
	   *       dateString = dateString.trim();
	   *
	   *       // Look for two chunks of content (either numbers or text) separated by delimiters.
	   *       var re = /^(([a-zA-Z]{3,}|[0-9]{1,4})([ .,]+|[/-]))([a-zA-Z]{3,}|[0-9]{1,4})/;
	   *       return re.test(dateString);
	   *     };
	   *
	   *     $mdDateLocaleProvider.monthHeaderFormatter = function(date) {
	   *       return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
	   *     };
	   *
	   *     // In addition to date display, date components also need localized messages
	   *     // for aria-labels for screen-reader users.
	   *
	   *     $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
	   *       return 'Semaine ' + weekNumber;
	   *     };
	   *
	   *     $mdDateLocaleProvider.msgCalendar = 'Calendrier';
	   *     $mdDateLocaleProvider.msgOpenCalendar = 'Ouvrir le calendrier';
	   *
	   *     // You can also set when your calendar begins and ends.
	   *     $mdDateLocaleProvider.firstRenderableDate = new Date(1776, 6, 4);
	   *     $mdDateLocaleProvider.lastRenderableDate = new Date(2012, 11, 21);
	   * });
	   * </hljs>
	   *
	   */
	  angular.module('material.components.datepicker').config(["$provide", function($provide) {
	    // TODO(jelbourn): Assert provided values are correctly formatted. Need assertions.
	
	    /** @constructor */
	    function DateLocaleProvider() {
	      /** Array of full month names. E.g., ['January', 'February', ...] */
	      this.months = null;
	
	      /** Array of abbreviated month names. E.g., ['Jan', 'Feb', ...] */
	      this.shortMonths = null;
	
	      /** Array of full day of the week names. E.g., ['Monday', 'Tuesday', ...] */
	      this.days = null;
	
	      /** Array of abbreviated dat of the week names. E.g., ['M', 'T', ...] */
	      this.shortDays = null;
	
	      /** Array of dates of a month (1 - 31). Characters might be different in some locales. */
	      this.dates = null;
	
	      /** Index of the first day of the week. 0 = Sunday, 1 = Monday, etc. */
	      this.firstDayOfWeek = 0;
	
	      /**
	       * Function that converts the date portion of a Date to a string.
	       * @type {(function(Date): string)}
	       */
	      this.formatDate = null;
	
	      /**
	       * Function that converts a date string to a Date object (the date portion)
	       * @type {function(string): Date}
	       */
	      this.parseDate = null;
	
	      /**
	       * Function that formats a Date into a month header string.
	       * @type {function(Date): string}
	       */
	      this.monthHeaderFormatter = null;
	
	      /**
	       * Function that formats a week number into a label for the week.
	       * @type {function(number): string}
	       */
	      this.weekNumberFormatter = null;
	
	      /**
	       * Function that formats a date into a long aria-label that is read
	       * when the focused date changes.
	       * @type {function(Date): string}
	       */
	      this.longDateFormatter = null;
	
	      /**
	       * Function to determine whether a string makes sense to be
	       * parsed to a Date object.
	       * @type {function(string): boolean}
	       */
	      this.isDateComplete = null;
	
	      /**
	       * ARIA label for the calendar "dialog" used in the datepicker.
	       * @type {string}
	       */
	      this.msgCalendar = '';
	
	      /**
	       * ARIA label for the datepicker's "Open calendar" buttons.
	       * @type {string}
	       */
	      this.msgOpenCalendar = '';
	    }
	
	    /**
	     * Factory function that returns an instance of the dateLocale service.
	     * @ngInject
	     * @param $locale
	     * @param $filter
	     * @returns {DateLocale}
	     */
	    DateLocaleProvider.prototype.$get = function($locale, $filter) {
	      /**
	       * Default date-to-string formatting function.
	       * @param {!Date} date
	       * @param {string=} timezone
	       * @returns {string}
	       */
	      function defaultFormatDate(date, timezone) {
	        if (!date) {
	          return '';
	        }
	
	        // All of the dates created through ng-material *should* be set to midnight.
	        // If we encounter a date where the localeTime shows at 11pm instead of midnight,
	        // we have run into an issue with DST where we need to increment the hour by one:
	        // var d = new Date(1992, 9, 8, 0, 0, 0);
	        // d.toLocaleString(); // == "10/7/1992, 11:00:00 PM"
	        var localeTime = date.toLocaleTimeString();
	        var formatDate = date;
	        if (date.getHours() === 0 &&
	            (localeTime.indexOf('11:') !== -1 || localeTime.indexOf('23:') !== -1)) {
	          formatDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 1, 0, 0);
	        }
	
	        return $filter('date')(formatDate, 'M/d/yyyy', timezone);
	      }
	
	      /**
	       * Default string-to-date parsing function.
	       * @param {string|number} dateString
	       * @returns {!Date}
	       */
	      function defaultParseDate(dateString) {
	        return new Date(dateString);
	      }
	
	      /**
	       * Default function to determine whether a string makes sense to be
	       * parsed to a Date object.
	       *
	       * This is very permissive and is just a basic check to ensure that
	       * things like single integers aren't able to be parsed into dates.
	       * @param {string} dateString
	       * @returns {boolean}
	       */
	      function defaultIsDateComplete(dateString) {
	        dateString = dateString.trim();
	
	        // Looks for three chunks of content (either numbers or text) separated
	        // by delimiters.
	        var re = /^(([a-zA-Z]{3,}|[0-9]{1,4})([ .,]+|[/-])){2}([a-zA-Z]{3,}|[0-9]{1,4})$/;
	        return re.test(dateString);
	      }
	
	      /**
	       * Default date-to-string formatter to get a month header.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultMonthHeaderFormatter(date) {
	        return service.shortMonths[date.getMonth()] + ' ' + date.getFullYear();
	      }
	
	      /**
	       * Default formatter for a month.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultMonthFormatter(date) {
	        return service.months[date.getMonth()] + ' ' + date.getFullYear();
	      }
	
	      /**
	       * Default week number formatter.
	       * @param number
	       * @returns {string}
	       */
	      function defaultWeekNumberFormatter(number) {
	        return 'Week ' + number;
	      }
	
	      /**
	       * Default formatter for date cell aria-labels.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultLongDateFormatter(date) {
	        // Example: 'Thursday June 18 2015'
	        return [
	          service.days[date.getDay()],
	          service.months[date.getMonth()],
	          service.dates[date.getDate()],
	          date.getFullYear()
	        ].join(' ');
	      }
	
	      // The default "short" day strings are the first character of each day,
	      // e.g., "Monday" => "M".
	      var defaultShortDays = $locale.DATETIME_FORMATS.SHORTDAY.map(function(day) {
	        return day.substring(0, 1);
	      });
	
	      // The default dates are simply the numbers 1 through 31.
	      var defaultDates = Array(32);
	      for (var i = 1; i <= 31; i++) {
	        defaultDates[i] = i;
	      }
	
	      // Default ARIA messages are in English (US).
	      var defaultMsgCalendar = 'Calendar';
	      var defaultMsgOpenCalendar = 'Open calendar';
	
	      // Default start/end dates that are rendered in the calendar.
	      var defaultFirstRenderableDate = new Date(1880, 0, 1);
	      var defaultLastRendereableDate = new Date(defaultFirstRenderableDate.getFullYear() + 250, 0, 1);
	
	      var service = {
	        months: this.months || $locale.DATETIME_FORMATS.MONTH,
	        shortMonths: this.shortMonths || $locale.DATETIME_FORMATS.SHORTMONTH,
	        days: this.days || $locale.DATETIME_FORMATS.DAY,
	        shortDays: this.shortDays || defaultShortDays,
	        dates: this.dates || defaultDates,
	        firstDayOfWeek: this.firstDayOfWeek || 0,
	        formatDate: this.formatDate || defaultFormatDate,
	        parseDate: this.parseDate || defaultParseDate,
	        isDateComplete: this.isDateComplete || defaultIsDateComplete,
	        monthHeaderFormatter: this.monthHeaderFormatter || defaultMonthHeaderFormatter,
	        monthFormatter: this.monthFormatter || defaultMonthFormatter,
	        weekNumberFormatter: this.weekNumberFormatter || defaultWeekNumberFormatter,
	        longDateFormatter: this.longDateFormatter || defaultLongDateFormatter,
	        msgCalendar: this.msgCalendar || defaultMsgCalendar,
	        msgOpenCalendar: this.msgOpenCalendar || defaultMsgOpenCalendar,
	        firstRenderableDate: this.firstRenderableDate || defaultFirstRenderableDate,
	        lastRenderableDate: this.lastRenderableDate || defaultLastRendereableDate
	      };
	
	      return service;
	    };
	    DateLocaleProvider.prototype.$get.$inject = ["$locale", "$filter"];
	
	    $provide.provider('$mdDateLocale', new DateLocaleProvider());
	  }]);
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * Utility for performing date calculations to facilitate operation of the calendar and
	   * datepicker.
	   */
	  angular.module('material.components.datepicker').factory('$$mdDateUtil', ["$mdDateLocale", function($mdDateLocale) {
	    return {
	      getFirstDateOfMonth: getFirstDateOfMonth,
	      getNumberOfDaysInMonth: getNumberOfDaysInMonth,
	      getDateInNextMonth: getDateInNextMonth,
	      getDateInPreviousMonth: getDateInPreviousMonth,
	      isInNextMonth: isInNextMonth,
	      isInPreviousMonth: isInPreviousMonth,
	      getDateMidpoint: getDateMidpoint,
	      isSameMonthAndYear: isSameMonthAndYear,
	      getWeekOfMonth: getWeekOfMonth,
	      incrementDays: incrementDays,
	      incrementMonths: incrementMonths,
	      getLastDateOfMonth: getLastDateOfMonth,
	      isSameDay: isSameDay,
	      getMonthDistance: getMonthDistance,
	      isValidDate: isValidDate,
	      setDateTimeToMidnight: setDateTimeToMidnight,
	      createDateAtMidnight: createDateAtMidnight,
	      isDateWithinRange: isDateWithinRange,
	      incrementYears: incrementYears,
	      getYearDistance: getYearDistance,
	      clampDate: clampDate,
	      getTimestampFromNode: getTimestampFromNode,
	      isMonthWithinRange: isMonthWithinRange,
	      removeLocalTzAndReparseDate: removeLocalTzAndReparseDate
	    };
	
	    /**
	     * Gets the first day of the month for the given date's month.
	     * @param {Date} date
	     * @returns {Date}
	     */
	    function getFirstDateOfMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth(), 1);
	    }
	
	    /**
	     * Gets the number of days in the month for the given date's month.
	     * @param date
	     * @returns {number}
	     */
	    function getNumberOfDaysInMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
	    }
	
	    /**
	     * Get an arbitrary date in the month after the given date's month.
	     * @param date
	     * @returns {Date}
	     */
	    function getDateInNextMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() + 1, 1);
	    }
	
	    /**
	     * Get an arbitrary date in the month before the given date's month.
	     * @param date
	     * @returns {Date}
	     */
	    function getDateInPreviousMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() - 1, 1);
	    }
	
	    /**
	     * Gets whether two dates have the same month and year.
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {boolean}
	     */
	    function isSameMonthAndYear(d1, d2) {
	      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
	    }
	
	    /**
	     * Gets whether two dates are the same day (not not necessarily the same time).
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {boolean}
	     */
	    function isSameDay(d1, d2) {
	      return d1.getDate() == d2.getDate() && isSameMonthAndYear(d1, d2);
	    }
	
	    /**
	     * Gets whether a date is in the month immediately after some date.
	     * @param {Date} startDate The date from which to compare.
	     * @param {Date} endDate The date to check.
	     * @returns {boolean}
	     */
	    function isInNextMonth(startDate, endDate) {
	      var nextMonth = getDateInNextMonth(startDate);
	      return isSameMonthAndYear(nextMonth, endDate);
	    }
	
	    /**
	     * Gets whether a date is in the month immediately before some date.
	     * @param {Date} startDate The date from which to compare.
	     * @param {Date} endDate The date to check.
	     * @returns {boolean}
	     */
	    function isInPreviousMonth(startDate, endDate) {
	      var previousMonth = getDateInPreviousMonth(startDate);
	      return isSameMonthAndYear(endDate, previousMonth);
	    }
	
	    /**
	     * Gets the midpoint between two dates.
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {Date}
	     */
	    function getDateMidpoint(d1, d2) {
	      return createDateAtMidnight((d1.getTime() + d2.getTime()) / 2);
	    }
	
	    /**
	     * Gets the week of the month that a given date occurs in.
	     * @param {Date} date
	     * @returns {number} Index of the week of the month (zero-based).
	     */
	    function getWeekOfMonth(date) {
	      var firstDayOfMonth = getFirstDateOfMonth(date);
	      return Math.floor((firstDayOfMonth.getDay() + date.getDate() - 1) / 7);
	    }
	
	    /**
	     * Gets a new date incremented by the given number of days. Number of days can be negative.
	     * @param {Date} date
	     * @param {number} numberOfDays
	     * @returns {Date}
	     */
	    function incrementDays(date, numberOfDays) {
	      return new Date(date.getFullYear(), date.getMonth(), date.getDate() + numberOfDays);
	    }
	
	    /**
	     * Gets a new date incremented by the given number of months. Number of months can be negative.
	     * If the date of the given month does not match the target month, the date will be set to the
	     * last day of the month.
	     * @param {Date} date
	     * @param {number} numberOfMonths
	     * @returns {Date}
	     */
	    function incrementMonths(date, numberOfMonths) {
	      // If the same date in the target month does not actually exist, the Date object will
	      // automatically advance *another* month by the number of missing days.
	      // For example, if you try to go from Jan. 30 to Feb. 30, you'll end up on March 2.
	      // So, we check if the month overflowed and go to the last day of the target month instead.
	      var dateInTargetMonth = new Date(date.getFullYear(), date.getMonth() + numberOfMonths, 1);
	      var numberOfDaysInMonth = getNumberOfDaysInMonth(dateInTargetMonth);
	      if (numberOfDaysInMonth < date.getDate()) {
	        dateInTargetMonth.setDate(numberOfDaysInMonth);
	      } else {
	        dateInTargetMonth.setDate(date.getDate());
	      }
	
	      return dateInTargetMonth;
	    }
	
	    /**
	     * Get the integer distance between two months. This *only* considers the month and year
	     * portion of the Date instances.
	     *
	     * @param {Date} start
	     * @param {Date} end
	     * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
	     *     chronologically, this number will be negative.
	     */
	    function getMonthDistance(start, end) {
	      return (12 * (end.getFullYear() - start.getFullYear())) + (end.getMonth() - start.getMonth());
	    }
	
	    /**
	     * Gets the last day of the month for the given date.
	     * @param {Date} date
	     * @returns {Date}
	     */
	    function getLastDateOfMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth(), getNumberOfDaysInMonth(date));
	    }
	
	    /**
	     * Checks whether a date is valid.
	     * @param {Date} date
	     * @return {boolean} Whether the date is a valid Date.
	     */
	    function isValidDate(date) {
	      return date && date.getTime && !isNaN(date.getTime());
	    }
	
	    /**
	     * Sets a date's time to midnight.
	     * @param {Date} date
	     */
	    function setDateTimeToMidnight(date) {
	      if (isValidDate(date)) {
	        date.setHours(0, 0, 0, 0);
	      }
	    }
	
	    /**
	     * Creates a date with the time set to midnight.
	     * Drop-in replacement for two forms of the Date constructor via opt_value.
	     * @param {number|Date=} opt_value Leave undefined for a Date representing now. Or use a
	     *  single value representing the number of seconds since the Unix Epoch or a Date object.
	     * @return {Date} New date with time set to midnight.
	     */
	    function createDateAtMidnight(opt_value) {
	      var date;
	      if (angular.isDate(opt_value)) {
	        date = opt_value;
	      } else if (angular.isNumber(opt_value)) {
	        date = new Date(opt_value);
	      } else {
	        date = new Date();
	      }
	      setDateTimeToMidnight(date);
	      return date;
	    }
	
	     /**
	      * Checks if a date is within a min and max range, ignoring the time component.
	      * If minDate or maxDate are not dates, they are ignored.
	      * @param {Date} date
	      * @param {Date} minDate
	      * @param {Date} maxDate
	      */
	     function isDateWithinRange(date, minDate, maxDate) {
	       var dateAtMidnight = createDateAtMidnight(date);
	       var minDateAtMidnight = isValidDate(minDate) ? createDateAtMidnight(minDate) : null;
	       var maxDateAtMidnight = isValidDate(maxDate) ? createDateAtMidnight(maxDate) : null;
	       return (!minDateAtMidnight || minDateAtMidnight <= dateAtMidnight) &&
	           (!maxDateAtMidnight || maxDateAtMidnight >= dateAtMidnight);
	     }
	
	    /**
	     * Gets a new date incremented by the given number of years. Number of years can be negative.
	     * See `incrementMonths` for notes on overflow for specific dates.
	     * @param {Date} date
	     * @param {number} numberOfYears
	     * @returns {Date}
	     */
	     function incrementYears(date, numberOfYears) {
	       return incrementMonths(date, numberOfYears * 12);
	     }
	
	     /**
	      * Get the integer distance between two years. This *only* considers the year portion of the
	      * Date instances.
	      *
	      * @param {Date} start
	      * @param {Date} end
	      * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
	      *     chronologically, this number will be negative.
	      */
	     function getYearDistance(start, end) {
	       return end.getFullYear() - start.getFullYear();
	     }
	
	     /**
	      * Clamps a date between a minimum and a maximum date.
	      * @param {Date} date Date to be clamped
	      * @param {Date=} minDate Minimum date
	      * @param {Date=} maxDate Maximum date
	      * @return {Date}
	      */
	     function clampDate(date, minDate, maxDate) {
	       var boundDate = date;
	       if (minDate && date < minDate) {
	         boundDate = new Date(minDate.getTime());
	       }
	       if (maxDate && date > maxDate) {
	         boundDate = new Date(maxDate.getTime());
	       }
	       return boundDate;
	     }
	
	     /**
	      * Extracts and parses the timestamp from a DOM node.
	      * @param  {HTMLElement} node Node from which the timestamp will be extracted.
	      * @return {number} Time since epoch.
	      */
	     function getTimestampFromNode(node) {
	       if (node && node.hasAttribute('data-timestamp')) {
	         return Number(node.getAttribute('data-timestamp'));
	       }
	     }
	
	     /**
	      * Checks if a month is within a min and max range, ignoring the date and time components.
	      * If minDate or maxDate are not dates, they are ignored.
	      * @param {Date} date
	      * @param {Date} minDate
	      * @param {Date} maxDate
	      */
	     function isMonthWithinRange(date, minDate, maxDate) {
	       var month = date.getMonth();
	       var year = date.getFullYear();
	
	       return (!minDate || minDate.getFullYear() < year || minDate.getMonth() <= month) &&
	        (!maxDate || maxDate.getFullYear() > year || maxDate.getMonth() >= month);
	     }
	
	    /**
	     * @param {Date} value date in local timezone
	     * @return {Date} date with local timezone offset removed
	     */
	    function removeLocalTzAndReparseDate(value) {
	      var dateValue, formattedDate;
	      // Remove the local timezone offset before calling formatDate.
	      dateValue = new Date(value.getTime() + 60000 * value.getTimezoneOffset());
	      formattedDate = $mdDateLocale.formatDate(dateValue);
	      // parseDate only works with a date formatted by formatDate when using Moment validation.
	      return $mdDateLocale.parseDate(formattedDate);
	    }
	  }]);
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  // TODO(jelbourn): forward more attributes to the internal input (required, autofocus, etc.)
	  // TODO(jelbourn): something better for mobile (calendar panel takes up entire screen?)
	  // TODO(jelbourn): input behavior (masking? auto-complete?)
	
	  DatePickerCtrl.$inject = ["$scope", "$element", "$attrs", "$window", "$mdConstant", "$mdTheming", "$mdUtil", "$mdDateLocale", "$$mdDateUtil", "$$rAF", "$filter", "$timeout"];
	  datePickerDirective.$inject = ["$$mdSvgRegistry", "$mdUtil", "$mdAria", "inputDirective"];
	  angular.module('material.components.datepicker')
	      .directive('mdDatepicker', datePickerDirective);
	
	  /**
	   * @ngdoc directive
	   * @name mdDatepicker
	   * @module material.components.datepicker
	   *
	   * @param {Date} ng-model The component's model. Expects either a JavaScript Date object or a
	   *  value that can be parsed into one (e.g. a ISO 8601 string).
	   * @param {Object=} ng-model-options Allows tuning of the way in which `ng-model` is being
	   *  updated. Also allows for a timezone to be specified.
	   *  <a href="https://docs.angularjs.org/api/ng/directive/ngModelOptions#usage">
	   *    Read more at the ngModelOptions docs.</a>
	   * @param {expression=} ng-change Expression evaluated when the model value changes.
	   * @param {expression=} ng-focus Expression evaluated when the input is focused or the calendar
	   *  is opened.
	   * @param {expression=} ng-blur Expression evaluated when focus is removed from the input or the
	   *  calendar is closed.
	   * @param {boolean=} ng-disabled Whether the datepicker is disabled.
	   * @param {boolean=} ng-required Whether a value is required for the datepicker.
	   * @param {Date=} md-min-date Expression representing a min date (inclusive).
	   * @param {Date=} md-max-date Expression representing a max date (inclusive).
	   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a
	   *  boolean whether it can be selected in "day" mode or not. Returning false will also trigger a
	   *  `filtered` model validation error.
	   * @param {(function(Date): boolean)=} md-month-filter Function expecting a date and returning a
	   *  boolean whether it can be selected in "month" mode or not. Returning false will also trigger a
	   *  `filtered` model validation error.
	   * @param {string=} md-placeholder The date input placeholder value.
	   * @param {string=} md-open-on-focus When present, the calendar will be opened when the input
	   *  is focused.
	   * @param {Boolean=} md-is-open Expression that can be used to open the datepicker's calendar
	   *  on-demand.
	   * @param {string=} md-current-view Default open view of the calendar pane. Can be either
	   *  "month" or "year".
	   * @param {string=} md-mode Restricts the user to only selecting a value from a particular view.
	   *  This option can be used if the user is only supposed to choose from a certain date type
	   *  (e.g. only selecting the month).
	   * Can be either "month" or "day". **Note** that this will overwrite the `md-current-view` value.
	   * @param {string=} md-hide-icons Determines which datepicker icons should be hidden. Note that
	   *  this may cause the datepicker to not align properly with other components.
	   *  **Use at your own risk.** Possible values are:
	   * * `"all"` - Hides all icons.
	   * * `"calendar"` - Only hides the calendar icon.
	   * * `"triangle"` - Only hides the triangle icon.
	   * @param {Object=} md-date-locale Allows for the values from the `$mdDateLocaleProvider` to be
	   * overwritten on a per-element basis (e.g. `msgOpenCalendar` can be overwritten with
	   * `md-date-locale="{ msgOpenCalendar: 'Open a special calendar' }"`).
	   * @param {string=} input-aria-describedby A space-separated list of element IDs. This should
	   *  contain the IDs of any elements that describe this datepicker. Screen readers will read the
	   *  content of these elements at the end of announcing that the datepicker has been selected
	   *  and describing its current state. The descriptive elements do not need to be visible on the
	   *  page.
	   * @param {string=} input-aria-labelledby A space-separated list of element IDs. The ideal use
	   *  case is that this would contain the ID of a `<label>` element should be associated with this
	   *  datepicker. This is necessary when using `md-datepicker` inside of an `md-input-container`
	   *  with a `<label>`.<br><br>
	   *  For `<label id="start-date">Start Date</label>`, you would set this to
	   *  `input-aria-labelledby="start-date"`.
	   *
	   * @description
	   * `<md-datepicker>` is a component used to select a single date.
	   * For information on how to configure internationalization for the date picker,
	   * see <a ng-href="api/service/$mdDateLocaleProvider">$mdDateLocaleProvider</a>.
	   *
	   * This component supports
	   * [ngMessages](https://docs.angularjs.org/api/ngMessages/directive/ngMessages).
	   * Supported attributes are:
	   * * `required`: whether a required date is not set.
	   * * `mindate`: whether the selected date is before the minimum allowed date.
	   * * `maxdate`: whether the selected date is after the maximum allowed date.
	   * * `debounceInterval`: ms to delay input processing (since last debounce reset);
	   *    default value 500ms
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <md-datepicker ng-model="birthday"></md-datepicker>
	   * </hljs>
	   *
	   */
	
	  function datePickerDirective($$mdSvgRegistry, $mdUtil, $mdAria, inputDirective) {
	    return {
	      template: function(tElement, tAttrs) {
	        // Buttons are not in the tab order because users can open the calendar via keyboard
	        // interaction on the text input, and multiple tab stops for one component (picker)
	        // may be confusing.
	        var hiddenIcons = tAttrs.mdHideIcons;
	        var inputAriaDescribedby = tAttrs.inputAriaDescribedby;
	        var inputAriaLabelledby = tAttrs.inputAriaLabelledby;
	        var ariaLabelValue = tAttrs.ariaLabel || tAttrs.mdPlaceholder;
	        var ngModelOptions = tAttrs.ngModelOptions;
	
	        var calendarButton = (hiddenIcons === 'all' || hiddenIcons === 'calendar') ? '' :
	          '<md-button class="md-datepicker-button md-icon-button" type="button" ' +
	              'tabindex="-1" aria-hidden="true" ' +
	              'ng-click="ctrl.openCalendarPane($event)">' +
	            '<md-icon class="md-datepicker-calendar-icon" aria-label="md-calendar" ' +
	                     'md-svg-src="' + $$mdSvgRegistry.mdCalendar + '"></md-icon>' +
	          '</md-button>';
	
	        var triangleButton = '';
	
	        if (hiddenIcons !== 'all' && hiddenIcons !== 'triangle') {
	          triangleButton = '' +
	            '<md-button type="button" md-no-ink ' +
	              'class="md-datepicker-triangle-button md-icon-button" ' +
	              'ng-click="ctrl.openCalendarPane($event)" ' +
	              'aria-label="{{::ctrl.locale.msgOpenCalendar}}">' +
	            '<div class="md-datepicker-expand-triangle"></div>' +
	          '</md-button>';
	
	          tElement.addClass(HAS_TRIANGLE_ICON_CLASS);
	        }
	
	        return calendarButton +
	        '<div class="md-datepicker-input-container" ng-class="{\'md-datepicker-focused\': ctrl.isFocused}">' +
	          '<input ' +
	            (ariaLabelValue ? 'aria-label="' + ariaLabelValue + '" ' : '') +
	            (inputAriaDescribedby ? 'aria-describedby="' + inputAriaDescribedby + '" ' : '') +
	            (inputAriaLabelledby ? 'aria-labelledby="' + inputAriaLabelledby + '" ' : '') +
	            'class="md-datepicker-input" ' +
	            'aria-haspopup="dialog" ' +
	            'ng-focus="ctrl.setFocused(true)" ' +
	            'ng-blur="ctrl.setFocused(false)"> ' +
	            triangleButton +
	        '</div>' +
	
	        // This pane will be detached from here and re-attached to the document body.
	        '<div class="md-datepicker-calendar-pane md-whiteframe-z1" id="{{::ctrl.calendarPaneId}}">' +
	          '<div class="md-datepicker-input-mask">' +
	            '<div class="md-datepicker-input-mask-opaque"></div>' +
	          '</div>' +
	          '<div class="md-datepicker-calendar">' +
	            '<md-calendar role="dialog" aria-label="{{::ctrl.locale.msgCalendar}}" ' +
	                'md-current-view="{{::ctrl.currentView}}" ' +
	                'md-mode="{{::ctrl.mode}}" ' +
	                'md-min-date="ctrl.minDate" ' +
	                'md-max-date="ctrl.maxDate" ' +
	                'md-date-filter="ctrl.dateFilter" ' +
	                'md-month-filter="ctrl.monthFilter" ' +
	                (ngModelOptions ? 'ng-model-options="' + ngModelOptions + '" ' : '') +
	                'ng-model="ctrl.date" ng-if="ctrl.isCalendarOpen">' +
	            '</md-calendar>' +
	          '</div>' +
	        '</div>';
	      },
	      require: ['ngModel', 'mdDatepicker', '?^mdInputContainer', '?^form'],
	      scope: {
	        minDate: '=mdMinDate',
	        maxDate: '=mdMaxDate',
	        placeholder: '@mdPlaceholder',
	        currentView: '@mdCurrentView',
	        mode: '@mdMode',
	        dateFilter: '=mdDateFilter',
	        monthFilter: '=mdMonthFilter',
	        isOpen: '=?mdIsOpen',
	        debounceInterval: '=mdDebounceInterval',
	        dateLocale: '=mdDateLocale'
	      },
	      controller: DatePickerCtrl,
	      controllerAs: 'ctrl',
	      bindToController: true,
	      link: function(scope, element, attr, controllers) {
	        var ngModelCtrl = controllers[0];
	        var mdDatePickerCtrl = controllers[1];
	        var mdInputContainer = controllers[2];
	        var parentForm = controllers[3];
	        var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
	
	        mdDatePickerCtrl.configureNgModel(ngModelCtrl, mdInputContainer, inputDirective);
	
	        if (mdInputContainer) {
	          // We need to move the spacer after the datepicker itself,
	          // because md-input-container adds it after the
	          // md-datepicker-input by default. The spacer gets wrapped in a
	          // div, because it floats and gets aligned next to the datepicker.
	          // There are easier ways of working around this with CSS (making the
	          // datepicker 100% wide, change the `display` etc.), however they
	          // break the alignment with any other form controls.
	          var spacer = element[0].querySelector('.md-errors-spacer');
	
	          if (spacer) {
	            element.after(angular.element('<div>').append(spacer));
	          }
	
	          mdInputContainer.setHasPlaceholder(attr.mdPlaceholder);
	          mdInputContainer.input = element;
	          mdInputContainer.element
	            .addClass(INPUT_CONTAINER_CLASS)
	            .toggleClass(HAS_CALENDAR_ICON_CLASS,
	              attr.mdHideIcons !== 'calendar' && attr.mdHideIcons !== 'all');
	
	          if (!mdInputContainer.label) {
	            $mdAria.expect(element, 'aria-label', attr.mdPlaceholder);
	          } else if (!mdNoAsterisk) {
	            attr.$observe('required', function(value) {
	              mdInputContainer.label.toggleClass('md-required', !!value);
	            });
	          }
	
	          scope.$watch(mdInputContainer.isErrorGetter || function() {
	            return ngModelCtrl.$invalid && (ngModelCtrl.$touched ||
	              (parentForm && parentForm.$submitted));
	          }, mdInputContainer.setInvalid);
	        } else if (parentForm) {
	          // If invalid, highlights the input when the parent form is submitted.
	          var parentSubmittedWatcher = scope.$watch(function() {
	            return parentForm.$submitted;
	          }, function(isSubmitted) {
	            if (isSubmitted) {
	              mdDatePickerCtrl.updateErrorState();
	              parentSubmittedWatcher();
	            }
	          });
	        }
	      }
	    };
	  }
	
	  /** Additional offset for the input's `size` attribute, which is updated based on its content. */
	  var EXTRA_INPUT_SIZE = 3;
	
	  /** Class applied to the container if the date is invalid. */
	  var INVALID_CLASS = 'md-datepicker-invalid';
	
	  /** Class applied to the datepicker when it's open. */
	  var OPEN_CLASS = 'md-datepicker-open';
	
	  /** Class applied to the md-input-container, if a datepicker is placed inside it */
	  var INPUT_CONTAINER_CLASS = '_md-datepicker-floating-label';
	
	  /** Class to be applied when the calendar icon is enabled. */
	  var HAS_CALENDAR_ICON_CLASS = '_md-datepicker-has-calendar-icon';
	
	  /** Class to be applied when the triangle icon is enabled. */
	  var HAS_TRIANGLE_ICON_CLASS = '_md-datepicker-has-triangle-icon';
	
	  /** Default time in ms to debounce input event by. */
	  var DEFAULT_DEBOUNCE_INTERVAL = 500;
	
	  /**
	   * Height of the calendar pane used to check if the pane is going outside the boundary of
	   * the viewport. See calendar.scss for how $md-calendar-height is computed; an extra 20px is
	   * also added to space the pane away from the exact edge of the screen.
	   *
	   *  This is computed statically now, but can be changed to be measured if the circumstances
	   *  of calendar sizing are changed.
	   */
	  var CALENDAR_PANE_HEIGHT = 368;
	
	  /**
	   * Width of the calendar pane used to check if the pane is going outside the boundary of
	   * the viewport. See calendar.scss for how $md-calendar-width is computed; an extra 20px is
	   * also added to space the pane away from the exact edge of the screen.
	   *
	   *  This is computed statically now, but can be changed to be measured if the circumstances
	   *  of calendar sizing are changed.
	   */
	  var CALENDAR_PANE_WIDTH = 360;
	
	  /** Used for checking whether the current user agent is on iOS or Android. */
	  var IS_MOBILE_REGEX = /ipad|iphone|ipod|android/i;
	
	  /**
	   * Controller for md-datepicker.
	   *
	   * @ngInject @constructor
	   */
	  function DatePickerCtrl($scope, $element, $attrs, $window, $mdConstant, $mdTheming, $mdUtil,
	                          $mdDateLocale, $$mdDateUtil, $$rAF, $filter, $timeout) {
	
	    /** @final */
	    this.$window = $window;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.$mdConstant = $mdConstant;
	
	    /** @final */
	    this.$mdUtil = $mdUtil;
	
	    /** @final */
	    this.$$rAF = $$rAF;
	
	    /** @final */
	    this.$mdDateLocale = $mdDateLocale;
	
	    /** @final */
	    this.$timeout = $timeout;
	
	    /**
	     * The root document element. This is used for attaching a top-level click handler to
	     * close the calendar panel when a click outside said panel occurs. We use `documentElement`
	     * instead of body because, when scrolling is disabled, some browsers consider the body element
	     * to be completely off the screen and propagate events directly to the html element.
	     * @type {!JQLite}
	     */
	    this.documentElement = angular.element(document.documentElement);
	
	    /** @type {!ngModel.NgModelController} */
	    this.ngModelCtrl = null;
	
	    /** @type {HTMLInputElement} */
	    this.inputElement = $element[0].querySelector('input');
	
	    /**
	     * @final
	     * @type {!JQLite}
	     */
	    this.ngInputElement = angular.element(this.inputElement);
	
	    /** @type {HTMLElement} */
	    this.inputContainer = $element[0].querySelector('.md-datepicker-input-container');
	
	    /** @type {HTMLElement} Floating calendar pane. */
	    this.calendarPane = $element[0].querySelector('.md-datepicker-calendar-pane');
	
	    /** @type {HTMLElement} Calendar icon button. */
	    this.calendarButton = $element[0].querySelector('.md-datepicker-button');
	
	    /**
	     * Element covering everything but the input in the top of the floating calendar pane.
	     * @type {!JQLite}
	     */
	    this.inputMask = angular.element($element[0].querySelector('.md-datepicker-input-mask-opaque'));
	
	    /**
	     * @final
	     * @type {!JQLite}
	     */
	    this.$element = $element;
	
	    /**
	     * @final
	     * @type {!angular.Attributes}
	     */
	    this.$attrs = $attrs;
	
	    /**
	     * @final
	     * @type {!angular.Scope}
	     */
	    this.$scope = $scope;
	
	    /**
	     * This holds the model that will be used by the calendar.
	     * @type {Date|null|undefined}
	     */
	    this.date = null;
	
	    /** @type {boolean} */
	    this.isFocused = false;
	
	    /** @type {boolean} */
	    this.isDisabled = undefined;
	    this.setDisabled($element[0].disabled || angular.isString($attrs.disabled));
	
	    /** @type {boolean} Whether the date-picker's calendar pane is open. */
	    this.isCalendarOpen = false;
	
	    /** @type {boolean} Whether the calendar should open when the input is focused. */
	    this.openOnFocus = $attrs.hasOwnProperty('mdOpenOnFocus');
	
	    /** @type {Object} Instance of the mdInputContainer controller */
	    this.mdInputContainer = null;
	
	    /**
	     * Element from which the calendar pane was opened. Keep track of this so that we can return
	     * focus to it when the pane is closed.
	     * @type {HTMLElement}
	     */
	    this.calendarPaneOpenedFrom = null;
	
	    /** @type {String} Unique id for the calendar pane. */
	    this.calendarPaneId = 'md-date-pane-' + $mdUtil.nextUid();
	
	    /** Pre-bound click handler is saved so that the event listener can be removed. */
	    this.bodyClickHandler = angular.bind(this, this.handleBodyClick);
	
	    /**
	     * Name of the event that will trigger a close. Necessary to sniff the browser, because
	     * the resize event doesn't make sense on mobile and can have a negative impact since it
	     * triggers whenever the browser zooms in on a focused input.
	     */
	    this.windowEventName = IS_MOBILE_REGEX.test(
	      navigator.userAgent || navigator.vendor || window.opera
	    ) ? 'orientationchange' : 'resize';
	
	    /** Pre-bound close handler so that the event listener can be removed. */
	    this.windowEventHandler = $mdUtil.debounce(angular.bind(this, this.closeCalendarPane), 100);
	
	    /** Pre-bound handler for the window blur event. Allows for it to be removed later. */
	    this.windowBlurHandler = angular.bind(this, this.handleWindowBlur);
	
	    /** The built-in AngularJS date filter. */
	    this.ngDateFilter = $filter('date');
	
	    /** @type {Number} Extra margin for the left side of the floating calendar pane. */
	    this.leftMargin = 20;
	
	    /** @type {Number} Extra margin for the top of the floating calendar. Gets determined on the first open. */
	    this.topMargin = null;
	
	    // Unless the user specifies so, the datepicker should not be a tab stop.
	    // This is necessary because ngAria might add a tabindex to anything with an ng-model
	    // (based on whether or not the user has turned that particular feature on/off).
	    if ($attrs.tabindex) {
	      this.ngInputElement.attr('tabindex', $attrs.tabindex);
	      $attrs.$set('tabindex', null);
	    } else {
	      $attrs.$set('tabindex', '-1');
	    }
	
	    $attrs.$set('aria-owns', this.calendarPaneId);
	
	    $mdTheming($element);
	    $mdTheming(angular.element(this.calendarPane));
	
	    var self = this;
	
	    $scope.$on('$destroy', function() {
	      self.detachCalendarPane();
	    });
	
	    if ($attrs.mdIsOpen) {
	      $scope.$watch('ctrl.isOpen', function(shouldBeOpen) {
	        if (shouldBeOpen) {
	          self.openCalendarPane({
	            target: self.inputElement
	          });
	        } else {
	          self.closeCalendarPane();
	        }
	      });
	    }
	
	    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are
	    // pre-assigned, manually call the $onInit hook.
	    if (angular.version.major === 1 && angular.version.minor <= 4) {
	      this.$onInit();
	    }
	  }
	
	  /**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the
	   * $onInit hook.
	   */
	  DatePickerCtrl.prototype.$onInit = function() {
	
	    /**
	     * Holds locale-specific formatters, parsers, labels etc. Allows
	     * the user to override specific ones from the $mdDateLocale provider.
	     * @type {!Object}
	     */
	    this.locale = this.dateLocale ? angular.extend({}, this.$mdDateLocale, this.dateLocale)
	      : this.$mdDateLocale;
	
	    this.installPropertyInterceptors();
	    this.attachChangeListeners();
	    this.attachInteractionListeners();
	  };
	
	  /**
	   * Sets up the controller's reference to ngModelController and
	   * applies AngularJS's `input[type="date"]` directive.
	   * @param {!angular.NgModelController} ngModelCtrl Instance of the ngModel controller.
	   * @param {Object} mdInputContainer Instance of the mdInputContainer controller.
	   * @param {Object} inputDirective Config for AngularJS's `input` directive.
	   */
	  DatePickerCtrl.prototype.configureNgModel = function(ngModelCtrl, mdInputContainer, inputDirective) {
	    this.ngModelCtrl = ngModelCtrl;
	    this.mdInputContainer = mdInputContainer;
	
	    // The input needs to be [type="date"] in order to be picked up by AngularJS.
	    this.$attrs.$set('type', 'date');
	
	    // Invoke the `input` directive link function, adding a stub for the element.
	    // This allows us to re-use AngularJS's logic for setting the timezone via ng-model-options.
	    // It works by calling the link function directly which then adds the proper `$parsers` and
	    // `$formatters` to the ngModel controller.
	    inputDirective[0].link.pre(this.$scope, {
	      on: angular.noop,
	      val: angular.noop,
	      0: {}
	    }, this.$attrs, [ngModelCtrl]);
	
	    var self = this;
	
	    // Responds to external changes to the model value.
	    self.ngModelCtrl.$formatters.push(function(value) {
	      var parsedValue = angular.isDefined(value) ? value : null;
	
	      if (!(value instanceof Date)) {
	        parsedValue = Date.parse(value);
	
	        // `parsedValue` is the time since epoch if valid or `NaN` if invalid.
	        if (!isNaN(parsedValue) && angular.isNumber(parsedValue)) {
	          value = new Date(parsedValue);
	        }
	
	        if (value && !(value instanceof Date)) {
	          throw Error(
	            'The ng-model for md-datepicker must be a Date instance or a value ' +
	              'that can be parsed into a date. Currently the model is of type: ' + typeof value
	          );
	        }
	      }
	
	      self.onExternalChange(value);
	
	      return value;
	    });
	
	    // Responds to external error state changes (e.g. ng-required based on another input).
	    ngModelCtrl.$viewChangeListeners.unshift(angular.bind(this, this.updateErrorState));
	
	    // Forwards any events from the input to the root element. This is necessary to get `updateOn`
	    // working for events that don't bubble (e.g. 'blur') since AngularJS binds the handlers to
	    // the `<md-datepicker>`.
	    var updateOn = self.$mdUtil.getModelOption(ngModelCtrl, 'updateOn');
	
	    if (updateOn) {
	      this.ngInputElement.on(
	        updateOn,
	        angular.bind(this.$element, this.$element.triggerHandler, updateOn)
	      );
	    }
	  };
	
	  /**
	   * Attach event listeners for both the text input and the md-calendar.
	   * Events are used instead of ng-model so that updates don't infinitely update the other
	   * on a change. This should also be more performant than using a $watch.
	   */
	  DatePickerCtrl.prototype.attachChangeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-change', function(event, date) {
	      self.setModelValue(date);
	      self.onExternalChange(date);
	      self.closeCalendarPane();
	    });
	
	    self.ngInputElement.on('input', angular.bind(self, self.resizeInputElement));
	
	    var debounceInterval = angular.isDefined(this.debounceInterval) ?
	        this.debounceInterval : DEFAULT_DEBOUNCE_INTERVAL;
	    self.ngInputElement.on('input', self.$mdUtil.debounce(self.handleInputEvent,
	        debounceInterval, self));
	  };
	
	  /** Attach event listeners for user interaction. */
	  DatePickerCtrl.prototype.attachInteractionListeners = function() {
	    var self = this;
	    var $scope = this.$scope;
	    var keyCodes = this.$mdConstant.KEY_CODE;
	
	    // Add event listener through angular so that we can triggerHandler in unit tests.
	    self.ngInputElement.on('keydown', function(event) {
	      if (event.altKey && event.keyCode === keyCodes.DOWN_ARROW) {
	        self.openCalendarPane(event);
	        $scope.$digest();
	      }
	    });
	
	    if (self.openOnFocus) {
	      self.ngInputElement.on('focus', angular.bind(self, self.openCalendarPane));
	      self.ngInputElement.on('click', function(event) {
	        event.stopPropagation();
	      });
	      self.ngInputElement.on('pointerdown',function(event) {
	        if (event.target && event.target.setPointerCapture) {
	          event.target.setPointerCapture(event.pointerId);
	        }
	      });
	
	      angular.element(self.$window).on('blur', self.windowBlurHandler);
	
	      $scope.$on('$destroy', function() {
	        angular.element(self.$window).off('blur', self.windowBlurHandler);
	      });
	    }
	
	    $scope.$on('md-calendar-close', function() {
	      self.closeCalendarPane();
	    });
	  };
	
	  /**
	   * Capture properties set to the date-picker and imperatively handle internal changes.
	   * This is done to avoid setting up additional $watches.
	   */
	  DatePickerCtrl.prototype.installPropertyInterceptors = function() {
	    var self = this;
	
	    if (this.$attrs.ngDisabled) {
	      // The expression is to be evaluated against the directive element's scope and not
	      // the directive's isolate scope.
	      var scope = this.$scope.$parent;
	
	      if (scope) {
	        scope.$watch(this.$attrs.ngDisabled, function(isDisabled) {
	          self.setDisabled(isDisabled);
	        });
	      }
	    }
	
	    Object.defineProperty(this, 'placeholder', {
	      get: function() { return self.inputElement.placeholder; },
	      set: function(value) { self.inputElement.placeholder = value || ''; }
	    });
	  };
	
	  /**
	   * Sets whether the date-picker is disabled.
	   * @param {boolean} isDisabled
	   */
	  DatePickerCtrl.prototype.setDisabled = function(isDisabled) {
	    this.isDisabled = isDisabled;
	    this.inputElement.disabled = isDisabled;
	
	    if (this.calendarButton) {
	      this.calendarButton.disabled = isDisabled;
	    }
	  };
	
	  /**
	   * Sets the custom ngModel.$error flags to be consumed by ngMessages. Flags are:
	   *   - mindate: whether the selected date is before the minimum date.
	   *   - maxdate: whether the selected flag is after the maximum date.
	   *   - filtered: whether the selected date is allowed by the custom filtering function.
	   *   - valid: whether the entered text input is a valid date
	   *
	   * The 'required' flag is handled automatically by ngModel.
	   *
	   * @param {Date=} opt_date Date to check. If not given, defaults to the datepicker's model value.
	   */
	  DatePickerCtrl.prototype.updateErrorState = function(opt_date) {
	    var date;
	    if (opt_date) {
	      date = new Date(opt_date.valueOf());
	    } else {
	      if (angular.isString(this.ngModelCtrl.$modelValue)) {
	        date = new Date(this.ngModelCtrl.$modelValue);
	      } else {
	        date = angular.copy(this.ngModelCtrl.$modelValue);
	      }
	    }
	
	    // Clear any existing errors to get rid of anything that's no longer relevant.
	    this.clearErrorState();
	
	    if (this.dateUtil.isValidDate(date)) {
	      // Force all dates to midnight in order to ignore the time portion.
	      date = this.dateUtil.createDateAtMidnight(date);
	
	      if (this.dateUtil.isValidDate(this.minDate)) {
	        var minDate = this.dateUtil.createDateAtMidnight(this.minDate);
	        this.ngModelCtrl.$setValidity('mindate', date >= minDate);
	      }
	
	      if (this.dateUtil.isValidDate(this.maxDate)) {
	        var maxDate = this.dateUtil.createDateAtMidnight(this.maxDate);
	        this.ngModelCtrl.$setValidity('maxdate', date <= maxDate);
	      }
	
	      if (angular.isFunction(this.dateFilter)) {
	        this.ngModelCtrl.$setValidity('filtered', this.dateFilter(date));
	      }
	
	      if (angular.isFunction(this.monthFilter)) {
	        this.ngModelCtrl.$setValidity('filtered', this.monthFilter(date));
	      }
	    } else {
	      // The date is seen as "not a valid date" if there is *something* set
	      // (i.e.., not null or undefined), but that something isn't a valid date.
	      this.ngModelCtrl.$setValidity('valid', date == null);
	    }
	
	    var input = this.inputElement.value;
	    var parsedDate = this.locale.parseDate(input);
	
	    if (!this.isInputValid(input, parsedDate) && this.ngModelCtrl.$valid) {
	      this.ngModelCtrl.$setValidity('valid', date == null);
	    }
	
	    angular.element(this.inputContainer).toggleClass(INVALID_CLASS,
	      this.ngModelCtrl.$invalid && (this.ngModelCtrl.$touched || this.ngModelCtrl.$submitted));
	  };
	
	  /**
	   * Check to see if the input is valid, as the validation should fail if the model is invalid.
	   *
	   * @param {string} inputString
	   * @param {Date} parsedDate
	   * @return {boolean} Whether the input is valid
	   */
	  DatePickerCtrl.prototype.isInputValid = function (inputString, parsedDate) {
	    return inputString === '' || (
	      this.dateUtil.isValidDate(parsedDate) &&
	      this.locale.isDateComplete(inputString) &&
	      this.isDateEnabled(parsedDate)
	    );
	  };
	
	  /** Clears any error flags set by `updateErrorState`. */
	  DatePickerCtrl.prototype.clearErrorState = function() {
	    this.inputContainer.classList.remove(INVALID_CLASS);
	    ['mindate', 'maxdate', 'filtered', 'valid'].forEach(function(field) {
	      this.ngModelCtrl.$setValidity(field, true);
	    }, this);
	  };
	
	  /** Resizes the input element based on the size of its content. */
	  DatePickerCtrl.prototype.resizeInputElement = function() {
	    this.inputElement.size = this.inputElement.value.length + EXTRA_INPUT_SIZE;
	  };
	
	  /**
	   * Sets the model value if the user input is a valid date.
	   * Adds an invalid class to the input element if not.
	   */
	  DatePickerCtrl.prototype.handleInputEvent = function() {
	    var inputString = this.inputElement.value;
	    var parsedDate = inputString ? this.locale.parseDate(inputString) : null;
	    this.dateUtil.setDateTimeToMidnight(parsedDate);
	
	    // An input string is valid if it is either empty (representing no date)
	    // or if it parses to a valid date that the user is allowed to select.
	    var isValidInput = this.isInputValid(inputString, parsedDate);
	
	    // The datepicker's model is only updated when there is a valid input.
	    if (isValidInput) {
	      this.setModelValue(parsedDate);
	      this.date = parsedDate;
	    }
	
	    this.updateErrorState(parsedDate);
	  };
	
	  /**
	   * Check whether date is in range and enabled
	   * @param {Date=} opt_date
	   * @return {boolean} Whether the date is enabled.
	   */
	  DatePickerCtrl.prototype.isDateEnabled = function(opt_date) {
	    return this.dateUtil.isDateWithinRange(opt_date, this.minDate, this.maxDate) &&
	          (!angular.isFunction(this.dateFilter) || this.dateFilter(opt_date)) &&
	          (!angular.isFunction(this.monthFilter) || this.monthFilter(opt_date));
	  };
	
	  /** Position and attach the floating calendar to the document. */
	  DatePickerCtrl.prototype.attachCalendarPane = function() {
	    var calendarPane = this.calendarPane;
	    var body = document.body;
	
	    calendarPane.style.transform = '';
	    this.$element.addClass(OPEN_CLASS);
	    this.mdInputContainer && this.mdInputContainer.element.addClass(OPEN_CLASS);
	    angular.element(body).addClass('md-datepicker-is-showing');
	
	    var elementRect = this.inputContainer.getBoundingClientRect();
	    var bodyRect = body.getBoundingClientRect();
	
	    if (!this.topMargin || this.topMargin < 0) {
	      this.topMargin =
	        (this.inputMask.parent().prop('clientHeight')
	          - this.ngInputElement.prop('clientHeight')) / 2;
	    }
	
	    // Check to see if the calendar pane would go off the screen. If so, adjust position
	    // accordingly to keep it within the viewport.
	    var paneTop = elementRect.top - bodyRect.top - this.topMargin;
	    var paneLeft = elementRect.left - bodyRect.left - this.leftMargin;
	
	    // If ng-material has disabled body scrolling (for example, if a dialog is open),
	    // then it's possible that the already-scrolled body has a negative top/left. In this case,
	    // we want to treat the "real" top as (0 - bodyRect.top). In a normal scrolling situation,
	    // though, the top of the viewport should just be the body's scroll position.
	    var viewportTop = (bodyRect.top < 0 && document.body.scrollTop === 0) ?
	        -bodyRect.top :
	        document.body.scrollTop;
	
	    var viewportLeft = (bodyRect.left < 0 && document.body.scrollLeft === 0) ?
	        -bodyRect.left :
	        document.body.scrollLeft;
	
	    var viewportBottom = viewportTop + this.$window.innerHeight;
	    var viewportRight = viewportLeft + this.$window.innerWidth;
	
	    // Creates an overlay with a hole the same size as element. We remove a pixel or two
	    // on each end to make it overlap slightly. The overlay's background is added in
	    // the theme in the form of a box-shadow with a huge spread.
	    this.inputMask.css({
	      position: 'absolute',
	      left: this.leftMargin + 'px',
	      top: this.topMargin + 'px',
	      width: (elementRect.width - 1) + 'px',
	      height: (elementRect.height - 2) + 'px'
	    });
	
	    // If the right edge of the pane would be off the screen and shifting it left by the
	    // difference would not go past the left edge of the screen. If the calendar pane is too
	    // big to fit on the screen at all, move it to the left of the screen and scale the entire
	    // element down to fit.
	    if (paneLeft + CALENDAR_PANE_WIDTH > viewportRight) {
	      if (viewportRight - CALENDAR_PANE_WIDTH > 0) {
	        paneLeft = viewportRight - CALENDAR_PANE_WIDTH;
	      } else {
	        paneLeft = viewportLeft;
	        var scale = this.$window.innerWidth / CALENDAR_PANE_WIDTH;
	        calendarPane.style.transform = 'scale(' + scale + ')';
	      }
	
	      calendarPane.classList.add('md-datepicker-pos-adjusted');
	    }
	
	    // If the bottom edge of the pane would be off the screen and shifting it up by the
	    // difference would not go past the top edge of the screen.
	    if (paneTop + CALENDAR_PANE_HEIGHT > viewportBottom &&
	        viewportBottom - CALENDAR_PANE_HEIGHT > viewportTop) {
	      paneTop = viewportBottom - CALENDAR_PANE_HEIGHT;
	      calendarPane.classList.add('md-datepicker-pos-adjusted');
	    }
	
	    calendarPane.style.left = paneLeft + 'px';
	    calendarPane.style.top = paneTop + 'px';
	    document.body.appendChild(calendarPane);
	
	    // Add CSS class after one frame to trigger open animation.
	    this.$$rAF(function() {
	      calendarPane.classList.add('md-pane-open');
	    });
	  };
	
	  /** Detach the floating calendar pane from the document. */
	  DatePickerCtrl.prototype.detachCalendarPane = function() {
	    this.$element.removeClass(OPEN_CLASS);
	    this.mdInputContainer && this.mdInputContainer.element.removeClass(OPEN_CLASS);
	    angular.element(document.body).removeClass('md-datepicker-is-showing');
	    this.calendarPane.classList.remove('md-pane-open');
	    this.calendarPane.classList.remove('md-datepicker-pos-adjusted');
	
	    if (this.isCalendarOpen) {
	      this.$mdUtil.enableScrolling();
	    }
	
	    if (this.calendarPane.parentNode) {
	      // Use native DOM removal because we do not want any of the
	      // angular state of this element to be disposed.
	      this.calendarPane.parentNode.removeChild(this.calendarPane);
	    }
	  };
	
	  /**
	   * Open the floating calendar pane.
	   * @param {MouseEvent|KeyboardEvent|{target: HTMLInputElement}} event
	   */
	  DatePickerCtrl.prototype.openCalendarPane = function(event) {
	    if (!this.isCalendarOpen && !this.isDisabled && !this.inputFocusedOnWindowBlur) {
	      this.isCalendarOpen = this.isOpen = true;
	      this.calendarPaneOpenedFrom = event.target;
	
	      // Because the calendar pane is attached directly to the body, it is possible that the
	      // rest of the component (input, etc) is in a different scrolling container, such as
	      // an md-content. This means that, if the container is scrolled, the pane would remain
	      // stationary. To remedy this, we disable scrolling while the calendar pane is open, which
	      // also matches the native behavior for things like `<select>` on Mac and Windows.
	      this.$mdUtil.disableScrollAround(this.calendarPane);
	
	      this.attachCalendarPane();
	      this.focusCalendar();
	      this.evalAttr('ngFocus');
	
	      // Attach click listener inside of a timeout because, if this open call was triggered by a
	      // click, we don't want it to be immediately propagated up to the body and handled.
	      var self = this;
	      this.$mdUtil.nextTick(function() {
	        // Use 'touchstart` in addition to click in order to work on iOS Safari, where click
	        // events aren't propagated under most circumstances.
	        // See http://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	        self.documentElement.on('click touchstart', self.bodyClickHandler);
	      }, false);
	
	      window.addEventListener(this.windowEventName, this.windowEventHandler);
	    } else if (this.inputFocusedOnWindowBlur) {
	      this.resetInputFocused();
	    }
	  };
	
	  /** Close the floating calendar pane. */
	  DatePickerCtrl.prototype.closeCalendarPane = function() {
	    if (this.isCalendarOpen) {
	      var self = this;
	
	      self.detachCalendarPane();
	      self.ngModelCtrl.$setTouched();
	      self.evalAttr('ngBlur');
	
	      self.documentElement.off('click touchstart', self.bodyClickHandler);
	      window.removeEventListener(self.windowEventName, self.windowEventHandler);
	
	      self.calendarPaneOpenedFrom.focus();
	      self.calendarPaneOpenedFrom = null;
	
	      if (self.openOnFocus) {
	        // Ensures that all focus events have fired before resetting
	        // the calendar. Prevents the calendar from reopening immediately
	        // in IE when md-open-on-focus is set. Also it needs to trigger
	        // a digest, in order to prevent issues where the calendar wasn't
	        // showing up on the next open.
	        self.$timeout(reset);
	      } else {
	        reset();
	      }
	    }
	
	    function reset() {
	      self.isCalendarOpen = self.isOpen = false;
	    }
	  };
	
	  /** Gets the controller instance for the calendar in the floating pane. */
	  DatePickerCtrl.prototype.getCalendarCtrl = function() {
	    return angular.element(this.calendarPane.querySelector('md-calendar')).controller('mdCalendar');
	  };
	
	  /** Focus the calendar in the floating pane. */
	  DatePickerCtrl.prototype.focusCalendar = function() {
	    // Use a timeout in order to allow the calendar to be rendered, as it is gated behind an ng-if.
	    var self = this;
	    this.$mdUtil.nextTick(function() {
	      self.getCalendarCtrl().focusDate(self.date);
	    }, false);
	  };
	
	  /**
	   * Sets whether the input is currently focused.
	   * @param {boolean} isFocused
	   */
	  DatePickerCtrl.prototype.setFocused = function(isFocused) {
	    if (!isFocused) {
	      this.ngModelCtrl.$setTouched();
	    }
	
	    // The ng* expressions shouldn't be evaluated when mdOpenOnFocus is on,
	    // because they also get called when the calendar is opened/closed.
	    if (!this.openOnFocus) {
	      this.evalAttr(isFocused ? 'ngFocus' : 'ngBlur');
	    }
	
	    this.isFocused = isFocused;
	  };
	
	  /**
	   * Handles a click on the document body when the floating calendar pane is open.
	   * Closes the floating calendar pane if the click is not inside of it.
	   * @param {MouseEvent} event
	   */
	  DatePickerCtrl.prototype.handleBodyClick = function(event) {
	    if (this.isCalendarOpen) {
	      var isInCalendar = this.$mdUtil.getClosest(event.target, 'md-calendar');
	
	      if (!isInCalendar) {
	        this.closeCalendarPane();
	      }
	
	      this.$scope.$digest();
	    }
	  };
	
	  /**
	   * Handles the event when the user navigates away from the current tab. Keeps track of
	   * whether the input was focused when the event happened, in order to prevent the calendar
	   * from re-opening.
	   */
	  DatePickerCtrl.prototype.handleWindowBlur = function() {
	    this.inputFocusedOnWindowBlur = document.activeElement === this.inputElement;
	  };
	
	  /**
	   * Reset the flag inputFocusedOnWindowBlur to default state, to permit user to open calendar
	   * again when he back to tab with calendar focused.
	   */
	  DatePickerCtrl.prototype.resetInputFocused = function() {
	    this.inputFocusedOnWindowBlur = false;
	  };
	
	  /**
	   * Evaluates an attribute expression against the parent scope.
	   * @param {String} attr Name of the attribute to be evaluated.
	   */
	  DatePickerCtrl.prototype.evalAttr = function(attr) {
	    if (this.$attrs[attr]) {
	      this.$scope.$parent.$eval(this.$attrs[attr]);
	    }
	  };
	
	  /**
	   * Sets the ng-model value by first converting the date object into a string. Converting it
	   * is necessary, in order to pass AngularJS's `input[type="date"]` validations. AngularJS turns
	   * the value into a Date object afterwards, before setting it on the model.
	   * @param {Date=} value Date to be set as the model value.
	   */
	  DatePickerCtrl.prototype.setModelValue = function(value) {
	    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');
	    // Using the timezone when the offset is negative (GMT+X) causes the previous day to be
	    // set as the model value here. This check avoids that.
	    if (timezone == null || value == null || value.getTimezoneOffset() < 0) {
	      this.ngModelCtrl.$setViewValue(this.ngDateFilter(value, 'yyyy-MM-dd'), 'default');
	    } else {
	      this.ngModelCtrl.$setViewValue(this.ngDateFilter(value, 'yyyy-MM-dd', timezone), 'default');
	    }
	  };
	
	  /**
	   * Updates the datepicker when a model change occurred externally.
	   * @param {Date=} value Value that was set to the model.
	   */
	  DatePickerCtrl.prototype.onExternalChange = function(value) {
	    var self = this;
	    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');
	
	    // Update the model used by the calendar.
	    if (this.dateUtil.isValidDate(value) && timezone != null && value.getTimezoneOffset() >= 0) {
	      this.date = this.dateUtil.removeLocalTzAndReparseDate(value);
	    } else {
	      this.date = value;
	    }
	    // Using the timezone when the offset is negative (GMT+X) causes the previous day to be
	    // used here. This check avoids that.
	    if (timezone == null || value == null || value.getTimezoneOffset() < 0) {
	      this.inputElement.value = this.locale.formatDate(value);
	    } else {
	      this.inputElement.value = this.locale.formatDate(value, timezone);
	    }
	    this.mdInputContainer && this.mdInputContainer.setHasValue(!!value);
	    this.resizeInputElement();
	    // This is often called from the $formatters section of the $validators pipeline.
	    // In that case, we need to delay to let $render and $validate run, so that the checks for
	    // error state are accurate.
	    this.$mdUtil.nextTick(function() {self.updateErrorState();}, false, self.$scope);
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.dialog
	 */
	MdDialogDirective.$inject = ["$$rAF", "$mdTheming", "$mdDialog"];
	MdDialogProvider.$inject = ["$$interimElementProvider"];
	angular
	  .module('material.components.dialog', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdDialog', MdDialogDirective)
	  .provider('$mdDialog', MdDialogProvider);
	
	/**
	 * @ngdoc directive
	 * @name mdDialog
	 * @module material.components.dialog
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-dialog>` - The dialog's template must be inside this element.
	 *
	 * Inside, use an `<md-dialog-content>` element for the dialog's content, and use
	 * an `<md-dialog-actions>` element for the dialog's actions.
	 *
	 * ## CSS
	 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
	 *
	 * ## Notes
	 * - If you specify an `id` for the `<md-dialog>`, the `<md-dialog-content>` will have the same `id`
	 * prefixed with `dialogContent_`.
	 *
	 * @usage
	 * ### Dialog template
	 * <hljs lang="html">
	 * <md-dialog aria-label="List dialog">
	 *   <md-dialog-content>
	 *     <md-list>
	 *       <md-list-item ng-repeat="item in items">
	 *         <p>Number {{item}}</p>
	 *       </md-list-item>
	 *     </md-list>
	 *   </md-dialog-content>
	 *   <md-dialog-actions>
	 *     <md-button ng-click="closeDialog()" class="md-primary">Close Dialog</md-button>
	 *   </md-dialog-actions>
	 * </md-dialog>
	 * </hljs>
	 */
	function MdDialogDirective($$rAF, $mdTheming, $mdDialog) {
	  return {
	    restrict: 'E',
	    link: function(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      $mdTheming(element);
	      $$rAF(function() {
	        var images;
	        var content = element[0].querySelector('md-dialog-content');
	
	        if (content) {
	          images = content.getElementsByTagName('img');
	          addOverflowClass();
	          // delayed image loading may impact scroll height, check after images are loaded
	          angular.element(images).on('load', addOverflowClass);
	        }
	
	        scope.$on('$destroy', function() {
	          $mdDialog.destroy(element);
	        });
	
	        /**
	         *
	         */
	        function addOverflowClass() {
	          element.toggleClass('md-content-overflow', content.scrollHeight > content.clientHeight);
	        }
	
	
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $mdDialog
	 * @module material.components.dialog
	 *
	 * @description
	 * `$mdDialog` opens a dialog over the app to inform users about critical information or require
	 *  them to make decisions. There are two approaches for setup: a simple promise API
	 *  and regular object syntax.
	 *
	 * ## Restrictions
	 *
	 * - The dialog is always given an isolate scope.
	 * - The dialog's template must have an outer `<md-dialog>` element.
	 *   Inside, use an `<md-dialog-content>` element for the dialog's content, and use
	 *   an `<md-dialog-actions>` element for the dialog's actions.
	 * - Dialogs must cover the entire application to keep interactions inside of them.
	 * Use the `parent` option to change where dialogs are appended.
	 *
	 * ## Sizing
	 * - Complex dialogs can be sized with `flex="percentage"`, i.e. `flex="66"`.
	 * - Default max-width is 80% of the `rootElement` or `parent`.
	 *
	 * ## CSS
	 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div ng-app="demoApp" ng-controller="AppController as ctrl">
	 *   <div>
	 *     <md-button ng-click="ctrl.showAlert()" class="md-raised md-warn">
	 *       Basic Alert!
	 *       </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="ctrl.showDialog($event)" class="md-raised">
	 *       Custom Dialog
	 *       </md-button>
	 *   </div>
	 * </div>
	 * </hljs>
	 *
	 * ### JavaScript: object syntax
	 * <hljs lang="js">
	 * (function(angular, undefined) {
	 *   "use strict";
	 *
	 *   angular
	 *    .module('demoApp', ['ngMaterial'])
	 *    .controller('AppCtrl', AppController);
	 *
	 *   function AppController($mdDialog) {
	 *     var alert;
	 *     var ctrl = this;
	 *     ctrl.showAlert = showAlert;
	 *     ctrl.showDialog = showDialog;
	 *     ctrl.items = [1, 2, 3];
	 *
	 *     // Internal method
	 *     function showAlert() {
	 *       alert = $mdDialog.alert({
	 *         title: 'Attention',
	 *         textContent: 'This is an example of how simple dialogs can be!',
	 *         ok: 'Close'
	 *       });
	 *
	 *       $mdDialog
	 *         .show( alert )
	 *         .finally(function() {
	 *           alert = undefined;
	 *         });
	 *     }
	 *
	 *     function showDialog($event) {
	 *        var parentEl = angular.element(document.body);
	 *        $mdDialog.show({
	 *          parent: parentEl,
	 *          targetEvent: $event,
	 *          template:
	 *            '<md-dialog aria-label="List dialog">' +
	 *            '  <md-dialog-content>'+
	 *            '    <md-list>'+
	 *            '      <md-list-item ng-repeat="item in ctrl.items">'+
	 *            '       <p>Number {{item}}</p>' +
	 *            '      </md-item>'+
	 *            '    </md-list>'+
	 *            '  </md-dialog-content>' +
	 *            '  <md-dialog-actions>' +
	 *            '    <md-button ng-click="ctrl.closeDialog()" class="md-primary">' +
	 *            '      Close Dialog' +
	 *            '    </md-button>' +
	 *            '  </md-dialog-actions>' +
	 *            '</md-dialog>',
	 *          locals: {
	 *            items: ctrl.items
	 *          },
	 *          controller: DialogController
	 *          controllerAs: 'ctrl'
	 *       });
	 *       function DialogController($mdDialog) {
	 *         this.closeDialog = function() {
	 *           $mdDialog.hide();
	 *         }
	 *       }
	 *     }
	 *   }
	 * })(angular);
	 * </hljs>
	 *
	 * ### Multiple Dialogs
	 * Using the `multiple` option for the `$mdDialog` service allows developers to show multiple
	 * dialogs at the same time.
	 *
	 * <hljs lang="js">
	 *   // From plain options
	 *   $mdDialog.show({
	 *     multiple: true
	 *   });
	 *
	 *   // From a dialog preset
	 *   $mdDialog.show(
	 *     $mdDialog
	 *       .alert()
	 *       .multiple(true)
	 *   );
	 *
	 * </hljs>
	 *
	 * ### Pre-Rendered Dialogs
	 * By using the `contentElement` option, it is possible to use an already existing element in the
	 * DOM.
	 *
	 * > Pre-rendered dialogs will be not linked to any scope and will not instantiate any new
	 * > controller.<br/>
	 * > You can manually link the elements to a scope or instantiate a controller from the template
	 * > (using `ng-controller`).
	 *
	 * <hljs lang="js">
	 *   function showPrerenderedDialog() {
	 *     $mdDialog.show({
	 *       contentElement: '#myStaticDialog',
	 *       parent: angular.element(document.body)
	 *     });
	 *   }
	 * </hljs>
	 *
	 * When using a string as value, `$mdDialog` will automatically query the DOM for the specified CSS
	 * selector.
	 *
	 * <hljs lang="html">
	 *   <div style="visibility: hidden">
	 *     <div class="md-dialog-container" id="myStaticDialog">
	 *       <md-dialog>
	 *         This is a pre-rendered dialog.
	 *       </md-dialog>
	 *     </div>
	 *   </div>
	 * </hljs>
	 *
	 * **Notice**: It is important, to use the `.md-dialog-container` as the content element, otherwise
	 * the dialog will not show up.
	 *
	 * It also possible to use a DOM element for the `contentElement` option.
	 * - `contentElement: document.querySelector('#myStaticDialog')`
	 * - `contentElement: angular.element(TEMPLATE)`
	 *
	 * When using a `template` as content element, it will be not compiled upon open.
	 * This allows you to compile the element yourself and use it each time the dialog opens.
	 *
	 * ### Custom Presets
	 * Developers are also able to create their own preset, which can be used without repeating
	 * their options each time.
	 *
	 * <hljs lang="js">
	 *   $mdDialogProvider.addPreset('testPreset', {
	 *     options: function() {
	 *       return {
	 *         template:
	 *           '<md-dialog>' +
	 *             'This is a custom preset' +
	 *           '</md-dialog>',
	 *         controllerAs: 'dialog',
	 *         bindToController: true,
	 *         clickOutsideToClose: true,
	 *         escapeToClose: true
	 *       };
	 *     }
	 *   });
	 * </hljs>
	 *
	 * After creating your preset in the `config` phase, you can access it.
	 *
	 * <hljs lang="js">
	 *   $mdDialog.show(
	 *     $mdDialog.testPreset()
	 *   );
	 * </hljs>
	 *
	 * ### JavaScript: promise API syntax, custom dialog template
	 *
	 * <hljs lang="js">
	 * (function(angular, undefined) {
	 *   "use strict";
	 *
	 *   angular
	 *     .module('demoApp', ['ngMaterial'])
	 *     .controller('EmployeeController', EmployeeController)
	 *     .controller('GreetingController', GreetingController);
	 *
	 *   // Fictitious Employee Editor to show how to use simple and complex dialogs.
	 *
	 *   function EmployeeController($mdDialog) {
	 *     var alert;
	 *     var ctrl = this;
	 *
	 *     ctrl.showAlert = showAlert;
	 *     ctrl.showGreeting = showCustomGreeting;
	 *
	 *     ctrl.hasAlert = function() { return !!alert };
	 *     ctrl.userName = ctrl.userName || 'Bobby';
	 *
	 *     // Dialog #1 - Show simple alert dialog and cache reference to dialog instance
	 *
	 *     function showAlert() {
	 *       alert = $mdDialog.alert()
	 *         .title('Attention, ' + ctrl.userName)
	 *         .textContent('This is an example of how simple dialogs can be!')
	 *         .ok('Close');
	 *
	 *       $mdDialog
	 *         .show(alert)
	 *         .finally(function() {
	 *           alert = undefined;
	 *         });
	 *     }
	 *
	 *     // Dialog #2 - Demonstrate more complex dialogs construction and popup.
	 *
	 *     function showCustomGreeting($event) {
	 *       $mdDialog.show({
	 *         targetEvent: $event,
	 *         template:
	 *           '<md-dialog>' +
	 *           '  <md-dialog-content>Hello {{ ctrl.employee }}!</md-dialog-content>' +
	 *           '  <md-dialog-actions>' +
	 *           '    <md-button ng-click="ctrl.closeDialog()" class="md-primary">' +
	 *           '      Close Greeting' +
	 *           '    </md-button>' +
	 *           '  </md-dialog-actions>' +
	 *           '</md-dialog>',
	 *         controller: GreetingController,
	 *         controllerAs: 'ctrl',
	 *         onComplete: afterShowAnimation,
	 *         locals: { employee: ctrl.userName }
	 *       });
	 *
	 *       // When the 'enter' animation finishes...
	 *       function afterShowAnimation(scope, element, options) {
	 *         // post-show code here: DOM element focus, etc.
	 *       }
	 *     }
	 *   }
	 *
	 *   // Greeting controller used with the 'showCustomGreeting()' custom dialog
	 *   function GreetingController($mdDialog, $log) {
	 *     var ctrl = this;
	 *     this.$log = $log;
	 *
	 *     ctrl.closeDialog = function() {
	 *       // Hides the most recent dialog shown.
	 *       // No specific dialog instance reference is needed.
	 *       $mdDialog.hide();
	 *     };
	 *   }
	 *
	 *   GreetingController.prototype.$onInit = function() {
	 *     // Assigned from the locals options passed to $mdDialog.show.
	 *     this.$log.log('Employee Name: ', ctrl.employee);
	 *   };
	 *
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#alert
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message.
	 *
	 * @returns {Object} a dialog preset with the chainable configuration methods:
	 *
	 * - `title(string)` - Sets the alert title.
	 * - `textContent(string)` - Sets the alert message.
	 * - `htmlContent(string)` - Sets the alert message as HTML. Requires the `ngSanitize`
	 *     module to be loaded. HTML is not run through AngularJS' compiler.
	 * - `ok(string)` - Sets the alert "Okay" button text.
	 * - `theme(string)` - Sets the theme of the alert dialog.
	 * - `targetEvent(DOMClickEvent=)` - A click's event object. When passed in as an
	 *     option, the location of the click will be used as the starting point for the opening
	 *     animation of the the dialog.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#confirm
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message. You can call show and the promise
	 * returned will be resolved if the user clicks the confirm action on the dialog. The promise will
	 * be rejected if the user clicks the cancel action or dismisses the dialog.
	 *
	 * @returns {Object} a dialog preset with the chainable configuration methods:
	 *
	 * Additionally, it supports the following methods:
	 *
	 * - `title(string)` - Sets the confirm title.
	 * - `textContent(string)` - Sets the confirm message.
	 * - `htmlContent(string)` - Sets the confirm message as HTML. Requires the `ngSanitize`
	 *     module to be loaded. HTML is not run through AngularJS' compiler.
	 * - `ok(string)` - Sets the confirm "Okay" button text.
	 * - `cancel(string)` - Sets the confirm "Cancel" button text.
	 * - `theme(string)` - Sets the theme of the confirm dialog.
	 * - `targetEvent(DOMClickEvent=)` - A click's event object. When passed in as an
	 *     option, the location of the click will be used as the starting point for the opening
	 *     animation of the the dialog.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#prompt
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message and input box. You can call show and the
	 * promise returned will be resolved, if the user clicks the prompt action on the dialog, passing
	 * the input value as the first argument. The promise will be rejected if the user clicks the cancel
	 * action or dismisses the dialog.
	 *
	 * @returns {Object} a dialog preset with the chainable configuration methods:
	 *
	 * Additionally, it supports the following methods:
	 *
	 * - `title(string)` - Sets the prompt title.
	 * - `textContent(string)` - Sets the prompt message.
	 * - `htmlContent(string)` - Sets the prompt message as HTML. Requires the `ngSanitize`
	 *     module to be loaded. HTML is not run through AngularJS' compiler.
	 * - `placeholder(string)` - Sets the placeholder text for the input.
	 * - `required(boolean)` - Sets the input required value.
	 * - `initialValue(string)` - Sets the initial value for the prompt input.
	 * - `ok(string)` - Sets the prompt "Okay" button text.
	 * - `cancel(string)` - Sets the prompt "Cancel" button text.
	 * - `theme(string)` - Sets the theme of the prompt dialog.
	 * - `targetEvent(DOMClickEvent=)` - A click's event object. When passed in as an
	 *     option, the location of the click will be used as the starting point for the opening
	 *     animation of the the dialog.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#show
	 *
	 * @description
	 * Show a dialog with the specified options.
	 *
	 * @param {Object} optionsOrPreset Either provide a dialog preset returned from `alert()`,
	 * `prompt()`, or `confirm()`; or an options object with the following properties:
	 *   - `templateUrl` - `{string=}`: The url of a template that will be used as the content
	 *      of the dialog.
	 *   - `template` - `{string=}`: HTML template to show in the dialog. This **must** be trusted HTML
	 *      with respect to AngularJS' [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
	 *      This template should **never** be constructed with any kind of user input or user data.
	 *   - `contentElement` - `{string|Element}`: Instead of using a template, which will be compiled
	 *      each time a dialog opens, you can also use a DOM element.<br/>
	 *     * When specifying an element, which is present on the DOM, `$mdDialog` will temporary fetch
	 *     the element into the dialog and restores it at the old DOM position upon close.
	 *     * When specifying a string, the string be used as a CSS selector, to lookup for the element
	 *     in the DOM.
	 *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template with a
	 *     `<md-dialog>` tag if one is not provided. Defaults to true. Can be disabled if you provide a
	 *     custom dialog directive.
	 *   - `targetEvent` - `{DOMClickEvent=}`: A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *   - `openFrom` - `{string|Element|Object}`: The query selector, DOM element or the Rect object
	 *     that is used to determine the bounds (top, left, height, width) from which the Dialog will
	 *     originate.
	 *   - `closeTo` - `{string|Element|Object}`: The query selector, DOM element or the Rect object
	 *     that is used to determine the bounds (top, left, height, width) to which the Dialog will
	 *     target.
	 *   - `scope` - `{Object=}`: the scope to link the template / controller to. If none is specified,
	 *     it will create a new isolate scope.
	 *     This scope will be destroyed when the dialog is removed unless `preserveScope` is set to
	 *     true.
	 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed.
	 *     Default is false
	 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the dialog is open.
	 *     Default true.
	 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop behind the dialog.
	 *     Default true.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the dialog to
	 *     close it. Default false.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the dialog.
	 *     Default true.
	 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on open. Only disable if
	 *     focusing some other way, as focus management is required for dialogs to be accessible.
	 *     Defaults to true.
	 *   - `controller` - `{Function|string=}`: The controller to associate with the dialog. The
	 *     controller will be injected with the local `$mdDialog`, which passes along a scope for the
	 *     dialog.
	 *   - `locals` - `{Object=}`: An object containing key/value pairs. The keys will be used as names
	 *     of values to inject into the controller. For example, `locals: {three: 3}` would inject
	 *     `three` into the controller, with the value 3. If `bindToController` is true, they will be
	 *     copied to the controller instead.
	 *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
	 *   - `resolve` - `{Function=}`: Similar to locals, except it takes as values functions that return
	 *     promises, and the dialog will not open until all of the promises resolve.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	 *   - `parent` - `{element=}`: The element to append the dialog to. Defaults to appending
	 *     to the root element of the application.
	 *   - `onShowing` - `Function(scope, element, options: Object=, controller: Object)=`: Callback
	 *     function used to notify the show() animation is starting.
	 *   - `onComplete` - `Function(scope, element, options: Object=)=`: Callback function used to
	 *     notify when the show() animation is finished.
	 *   - `onRemoving` - `Function(element, removePromise)`: Callback function used to announce the
	 *      close/hide() action is starting. This allows developers to run custom animations
	 *      in parallel with the close animations.
	 *   - `fullscreen` `{boolean=}`: An option to toggle whether the dialog should show in fullscreen
	 *      or not. Defaults to `false`.
	 *   - `multiple` `{boolean=}`: An option to allow this dialog to display over one that's currently
	 *     open.
	 * @returns {Promise} A promise that can be resolved with `$mdDialog.hide()` or
	 * rejected with `$mdDialog.cancel()`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#hide
	 *
	 * @description
	 * Hide an existing dialog and resolve the promise returned from `$mdDialog.show()`.
	 *
	 * @param {*=} response An argument for the resolved promise.
	 *
	 * @returns {promise} A promise that is resolved when the dialog has been closed.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#cancel
	 *
	 * @description
	 * Hide an existing dialog and reject the promise returned from `$mdDialog.show()`.
	 *
	 * @param {*=} response An argument for the rejected promise.
	 *
	 * @returns {promise} A promise that is resolved when the dialog has been closed.
	 */
	
	function MdDialogProvider($$interimElementProvider) {
	  // Elements to capture and redirect focus when the user presses tab at the dialog boundary.
	  MdDialogController.$inject = ["$mdDialog", "$mdConstant"];
	  dialogDefaultOptions.$inject = ["$mdDialog", "$mdAria", "$mdUtil", "$mdConstant", "$animate", "$document", "$window", "$rootElement", "$log", "$injector", "$mdTheming", "$interpolate", "$mdInteraction"];
	  var topFocusTrap, bottomFocusTrap;
	  var removeFocusTrap;
	
	  return $$interimElementProvider('$mdDialog')
	    .setDefaults({
	      methods: ['disableParentScroll', 'hasBackdrop', 'clickOutsideToClose', 'escapeToClose',
	          'targetEvent', 'closeTo', 'openFrom', 'parent', 'fullscreen', 'multiple'],
	      options: dialogDefaultOptions
	    })
	    .addPreset('alert', {
	      methods: ['title', 'htmlContent', 'textContent', 'ariaLabel', 'ok', 'theme',
	          'css'],
	      options: advancedDialogOptions
	    })
	    .addPreset('confirm', {
	      methods: ['title', 'htmlContent', 'textContent', 'ariaLabel', 'ok', 'cancel',
	          'theme', 'css'],
	      options: advancedDialogOptions
	    })
	    .addPreset('prompt', {
	      methods: ['title', 'htmlContent', 'textContent', 'initialValue', 'placeholder', 'ariaLabel',
	          'ok', 'cancel', 'theme', 'css', 'required'],
	      options: advancedDialogOptions
	    });
	
	  /* @ngInject */
	  function advancedDialogOptions() {
	    return {
	      template: [
	        '<md-dialog md-theme="{{ dialog.theme || dialog.defaultTheme }}" aria-label="{{ dialog.ariaLabel }}" ng-class="dialog.css">',
	        '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
	        '    <h2 class="md-title">{{ dialog.title }}</h2>',
	        '    <div ng-if="::dialog.mdHtmlContent" class="md-dialog-content-body" ',
	        '        ng-bind-html="::dialog.mdHtmlContent"></div>',
	        '    <div ng-if="::!dialog.mdHtmlContent" class="md-dialog-content-body">',
	        '      <p>{{::dialog.mdTextContent}}</p>',
	        '    </div>',
	        '    <md-input-container md-no-float ng-if="::dialog.$type == \'prompt\'" class="md-prompt-input-container">',
	        '      <input ng-keypress="dialog.keypress($event)" md-autofocus ng-model="dialog.result" ' +
	        '             placeholder="{{::dialog.placeholder}}" ng-required="dialog.required">',
	        '    </md-input-container>',
	        '  </md-dialog-content>',
	        '  <md-dialog-actions>',
	        '    <md-button ng-if="dialog.$type === \'confirm\' || dialog.$type === \'prompt\'"' +
	        '               ng-click="dialog.abort()" class="md-primary md-cancel-button">',
	        '      {{ dialog.cancel }}',
	        '    </md-button>',
	        '    <md-button ng-click="dialog.hide()" class="md-primary md-confirm-button" md-autofocus="dialog.$type===\'alert\'"' +
	        '               ng-disabled="dialog.required && !dialog.result">',
	        '      {{ dialog.ok }}',
	        '    </md-button>',
	        '  </md-dialog-actions>',
	        '</md-dialog>'
	      ].join('').replace(/\s\s+/g, ''),
	      controller: MdDialogController,
	      controllerAs: 'dialog',
	      bindToController: true,
	    };
	  }
	
	  /**
	   * Controller for the md-dialog interim elements
	   * @ngInject
	   */
	  function MdDialogController($mdDialog, $mdConstant) {
	    // For compatibility with AngularJS 1.6+, we should always use the $onInit hook in
	    // interimElements. The $mdCompiler simulates the $onInit hook for all versions.
	    this.$onInit = function() {
	      var isPrompt = this.$type === 'prompt';
	
	      if (isPrompt && this.initialValue) {
	        this.result = this.initialValue;
	      }
	
	      this.hide = function() {
	        $mdDialog.hide(isPrompt ? this.result : true);
	      };
	      this.abort = function() {
	        $mdDialog.cancel();
	      };
	      this.keypress = function($event) {
	        var invalidPrompt = isPrompt && this.required && !angular.isDefined(this.result);
	
	        if ($event.keyCode === $mdConstant.KEY_CODE.ENTER && !invalidPrompt) {
	          $mdDialog.hide(this.result);
	        }
	      };
	    };
	  }
	
	  /* @ngInject */
	  function dialogDefaultOptions($mdDialog, $mdAria, $mdUtil, $mdConstant, $animate, $document,
	                                $window, $rootElement, $log, $injector, $mdTheming, $interpolate,
	                                $mdInteraction) {
	    return {
	      hasBackdrop: true,
	      isolateScope: true,
	      onCompiling: beforeCompile,
	      onShow: onShow,
	      onShowing: beforeShow,
	      onRemove: onRemove,
	      clickOutsideToClose: false,
	      escapeToClose: true,
	      targetEvent: null,
	      closeTo: null,
	      openFrom: null,
	      focusOnOpen: true,
	      disableParentScroll: true,
	      autoWrap: true,
	      fullscreen: false,
	      transformTemplate: function(template, options) {
	        // Make the dialog container focusable, because otherwise the focus will be always
	        // redirected to an element outside of the container, and the focus trap won't work.
	        // Also the tabindex is needed for the `escapeToClose` functionality, because
	        // the keyDown event can't be triggered when the focus is outside of the container.
	        var startSymbol = $interpolate.startSymbol();
	        var endSymbol = $interpolate.endSymbol();
	        var theme = startSymbol + (options.themeWatch ? '' : '::') + 'theme' + endSymbol;
	        var themeAttr = (options.hasTheme) ? 'md-theme="'+theme+'"': '';
	        return '<div class="md-dialog-container" tabindex="-1" ' + themeAttr + '>' + validatedTemplate(template) + '</div>';
	
	        /**
	         * The specified template should contain a <md-dialog> wrapper element....
	         */
	        function validatedTemplate(template) {
	          if (options.autoWrap && !/<\/md-dialog>/g.test(template)) {
	            return '<md-dialog>' + (template || '') + '</md-dialog>';
	          } else {
	            return template || '';
	          }
	        }
	      }
	    };
	
	    function beforeCompile(options) {
	      // Automatically apply the theme, if the user didn't specify a theme explicitly.
	      // Those option changes need to be done, before the compilation has started, because otherwise
	      // the option changes will be not available in the $mdCompilers locales.
	      options.defaultTheme = $mdTheming.defaultTheme();
	
	      detectTheming(options);
	    }
	
	    function beforeShow(scope, element, options, controller) {
	
	      if (controller) {
	        var mdHtmlContent = controller.htmlContent || options.htmlContent || '';
	        var mdTextContent = controller.textContent || options.textContent || '';
	
	        if (mdHtmlContent && !$injector.has('$sanitize')) {
	          throw Error('The ngSanitize module must be loaded in order to use htmlContent.');
	        }
	
	        if (mdHtmlContent && mdTextContent) {
	          throw Error('md-dialog cannot have both `htmlContent` and `textContent`');
	        }
	
	        // Only assign the content if nothing throws, otherwise it'll still be compiled.
	        controller.mdHtmlContent = mdHtmlContent;
	        controller.mdTextContent = mdTextContent;
	      }
	    }
	
	    /** Show method for dialogs */
	    function onShow(scope, element, options) {
	      angular.element($document[0].body).addClass('md-dialog-is-showing');
	
	      var dialogElement = element.find('md-dialog');
	
	      // Once a dialog has `ng-cloak` applied on his template the dialog animation will not work
	      // properly. This is a very common problem, so we have to notify the developer about this.
	      if (dialogElement.hasClass('ng-cloak')) {
	        var message =
	          '$mdDialog: using `<md-dialog ng-cloak>` will affect the dialog opening animations.';
	        $log.warn(message, element[0]);
	      }
	
	      captureParentAndFromToElements(options);
	      configureAria(dialogElement, options);
	      showBackdrop(scope, element, options);
	      activateListeners(element, options);
	
	      return dialogPopIn(element, options)
	        .then(function() {
	          lockScreenReader(element, options);
	          focusOnOpen();
	        });
	
	      /**
	       * For alerts, focus on content... otherwise focus on the close button (or equivalent)
	       */
	      function focusOnOpen() {
	        if (options.focusOnOpen) {
	          var target = $mdUtil.findFocusTarget(element) || findCloseButton() || dialogElement;
	          target.focus();
	        }
	
	        /**
	         * If no element with class dialog-close, try to find the last
	         * button child in md-dialog-actions and assume it is a close button.
	         *
	         * If we find no actions at all, log a warning to the console.
	         */
	        function findCloseButton() {
	          return element[0].querySelector('.dialog-close, md-dialog-actions button:last-child');
	        }
	      }
	    }
	
	    /**
	     * Remove function for all dialogs
	     */
	    function onRemove(scope, element, options) {
	      options.deactivateListeners();
	      options.unlockScreenReader();
	      options.hideBackdrop(options.$destroy);
	
	      // Remove the focus traps that we added earlier for keeping focus within the dialog.
	      if (removeFocusTrap) {
	        removeFocusTrap();
	        removeFocusTrap = null;
	      }
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	      return options.$destroy ? detachAndClean() : animateRemoval().then(detachAndClean);
	
	      /**
	       * For normal closes, animate the removal.
	       * For forced closes (like $destroy events), skip the animations
	       */
	      function animateRemoval() {
	        return dialogPopOut(element, options);
	      }
	
	      /**
	       * Detach the element
	       */
	      function detachAndClean() {
	        angular.element($document[0].body).removeClass('md-dialog-is-showing');
	
	        // Reverse the container stretch if using a content element.
	        if (options.contentElement) {
	          options.reverseContainerStretch();
	        }
	
	        // Exposed cleanup function from the $mdCompiler.
	        options.cleanupElement();
	
	        // Restores the focus to the origin element if the last interaction upon opening was a keyboard.
	        if (!options.$destroy && options.originInteraction === 'keyboard') {
	          options.origin.focus();
	        }
	      }
	    }
	
	    function detectTheming(options) {
	      // Once the user specifies a targetEvent, we will automatically try to find the correct
	      // nested theme.
	      var targetEl;
	      if (options.targetEvent && options.targetEvent.target) {
	        targetEl = angular.element(options.targetEvent.target);
	      }
	
	      var themeCtrl = targetEl && targetEl.controller('mdTheme');
	
	      options.hasTheme = (!!themeCtrl);
	
	      if (!options.hasTheme) {
	        return;
	      }
	
	      options.themeWatch = themeCtrl.$shouldWatch;
	
	      var theme = options.theme || themeCtrl.$mdTheme;
	
	      if (theme) {
	        options.scope.theme = theme;
	      }
	
	      var unwatch = themeCtrl.registerChanges(function (newTheme) {
	        options.scope.theme = newTheme;
	
	        if (!options.themeWatch) {
	          unwatch();
	        }
	      });
	    }
	
	    /**
	     * Capture originator/trigger/from/to element information (if available)
	     * and the parent container for the dialog; defaults to the $rootElement
	     * unless overridden in the options.parent
	     */
	    function captureParentAndFromToElements(options) {
	          options.origin = angular.extend({
	            element: null,
	            bounds: null,
	            focus: angular.noop
	          }, options.origin || {});
	
	          options.parent   = getDomElement(options.parent, $rootElement);
	          options.closeTo  = getBoundingClientRect(getDomElement(options.closeTo));
	          options.openFrom = getBoundingClientRect(getDomElement(options.openFrom));
	
	          if (options.targetEvent) {
	            options.origin = getBoundingClientRect(options.targetEvent.target, options.origin);
	            options.originInteraction = $mdInteraction.getLastInteractionType();
	          }
	
	
	          /**
	           * Identify the bounding RECT for the target element
	           *
	           */
	          function getBoundingClientRect (element, orig) {
	            var source = angular.element((element || {}));
	            if (source && source.length) {
	              // Compute and save the target element's bounding rect, so that if the
	              // element is hidden when the dialog closes, we can shrink the dialog
	              // back to the same position it expanded from.
	              //
	              // Checking if the source is a rect object or a DOM element
	              var bounds = {top:0,left:0,height:0,width:0};
	              var hasFn = angular.isFunction(source[0].getBoundingClientRect);
	
	              return angular.extend(orig || {}, {
	                  element : hasFn ? source : undefined,
	                  bounds  : hasFn ? source[0].getBoundingClientRect() : angular.extend({}, bounds, source[0]),
	                  focus   : angular.bind(source, source.focus),
	              });
	            }
	          }
	
	          /**
	           * If the specifier is a simple string selector, then query for
	           * the DOM element.
	           */
	          function getDomElement(element, defaultElement) {
	            if (angular.isString(element)) {
	              element = $document[0].querySelector(element);
	            }
	
	            // If we have a reference to a raw dom element, always wrap it in jqLite
	            return angular.element(element || defaultElement);
	          }
	
	        }
	
	    /**
	     * Listen for escape keys and outside clicks to auto close
	     */
	    function activateListeners(element, options) {
	      var window = angular.element($window);
	      var onWindowResize = $mdUtil.debounce(function() {
	        stretchDialogContainerToViewport(element, options);
	      }, 60);
	
	      var removeListeners = [];
	      var smartClose = function() {
	        // Only 'confirm' dialogs have a cancel button... escape/clickOutside will
	        // cancel or fallback to hide.
	        var closeFn = (options.$type === 'alert') ? $mdDialog.hide : $mdDialog.cancel;
	        $mdUtil.nextTick(closeFn, true);
	      };
	
	      if (options.escapeToClose) {
	        var parentTarget = options.parent;
	        var keyHandlerFn = function(ev) {
	          if (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
	            ev.stopImmediatePropagation();
	            ev.preventDefault();
	
	            smartClose();
	          }
	        };
	
	        // Add keydown listeners
	        element.on('keydown', keyHandlerFn);
	        parentTarget.on('keydown', keyHandlerFn);
	
	        // Queue remove listeners function
	        removeListeners.push(function() {
	          element.off('keydown', keyHandlerFn);
	          parentTarget.off('keydown', keyHandlerFn);
	        });
	      }
	
	      // Register listener to update dialog on window resize
	      window.on('resize', onWindowResize);
	
	      removeListeners.push(function() {
	        window.off('resize', onWindowResize);
	      });
	
	      if (options.clickOutsideToClose) {
	        var target = element;
	        var sourceElem;
	
	        // Keep track of the element on which the mouse originally went down
	        // so that we can only close the backdrop when the 'click' started on it.
	        // A simple 'click' handler does not work,
	        // it sets the target object as the element the mouse went down on.
	        var mousedownHandler = function(ev) {
	          sourceElem = ev.target;
	        };
	
	        // We check if our original element and the target is the backdrop
	        // because if the original was the backdrop and the target was inside the dialog
	        // we don't want to dialog to close.
	        var mouseupHandler = function(ev) {
	          if (sourceElem === target[0] && ev.target === target[0]) {
	            ev.stopPropagation();
	            ev.preventDefault();
	
	            smartClose();
	          }
	        };
	
	        // Add listeners
	        target.on('mousedown', mousedownHandler);
	        target.on('mouseup', mouseupHandler);
	
	        // Queue remove listeners function
	        removeListeners.push(function() {
	          target.off('mousedown', mousedownHandler);
	          target.off('mouseup', mouseupHandler);
	        });
	      }
	
	      // Attach specific `remove` listener handler
	      options.deactivateListeners = function() {
	        removeListeners.forEach(function(removeFn) {
	          removeFn();
	        });
	        options.deactivateListeners = null;
	      };
	    }
	
	    /**
	     * Show modal backdrop element...
	     */
	    function showBackdrop(scope, element, options) {
	
	      if (options.disableParentScroll) {
	        // !! DO this before creating the backdrop; since disableScrollAround()
	        //    configures the scroll offset; which is used by mdBackDrop postLink()
	        options.restoreScroll = $mdUtil.disableScrollAround(element, options.parent);
	      }
	
	      if (options.hasBackdrop) {
	        options.backdrop = $mdUtil.createBackdrop(scope, "md-dialog-backdrop md-opaque");
	        $animate.enter(options.backdrop, options.parent);
	      }
	
	      /**
	       * Hide modal backdrop element...
	       */
	      options.hideBackdrop = function hideBackdrop($destroy) {
	        if (options.backdrop) {
	          if ($destroy) {
	            options.backdrop.remove();
	          } else {
	            $animate.leave(options.backdrop);
	          }
	        }
	
	        if (options.disableParentScroll) {
	          options.restoreScroll && options.restoreScroll();
	          delete options.restoreScroll;
	        }
	
	        options.hideBackdrop = null;
	      };
	    }
	
	    /**
	     * Inject ARIA-specific attributes appropriate for Dialogs
	     */
	    function configureAria(element, options) {
	
	      var role = (options.$type === 'alert') ? 'alertdialog' : 'dialog';
	      var dialogContent = element.find('md-dialog-content');
	      var existingDialogId = element.attr('id');
	      var dialogContentId = 'dialogContent_' + (existingDialogId || $mdUtil.nextUid());
	
	      element.attr({
	        'role': role,
	        'tabIndex': '-1'
	      });
	
	      if (dialogContent.length === 0) {
	        dialogContent = element;
	        // If the dialog element already had an ID, don't clobber it.
	        if (existingDialogId) {
	          dialogContentId = existingDialogId;
	        }
	      }
	
	      dialogContent.attr('id', dialogContentId);
	      element.attr('aria-describedby', dialogContentId);
	
	      if (options.ariaLabel) {
	        $mdAria.expect(element, 'aria-label', options.ariaLabel);
	      }
	      else {
	        $mdAria.expectAsync(element, 'aria-label', function() {
	          // If dialog title is specified, set aria-label with it
	          // See https://github.com/angular/material/issues/10582
	          if (options.title) {
	            return options.title;
	          } else {
	            var words = dialogContent.text().split(/\s+/);
	            if (words.length > 3) words = words.slice(0, 3).concat('...');
	            return words.join(' ');
	          }
	        });
	      }
	
	      // Set up elements before and after the dialog content to capture focus and
	      // redirect back into the dialog.
	      topFocusTrap = document.createElement('div');
	      topFocusTrap.classList.add('md-dialog-focus-trap');
	      topFocusTrap.tabIndex = 0;
	
	      bottomFocusTrap = topFocusTrap.cloneNode(false);
	
	      /**
	       * When focus is about to move out of the end of the dialog, we intercept it and redirect it
	       * back to the md-dialog element.
	       * When focus is about to move out of the start of the dialog, we intercept it and redirect it
	       * back to the last focusable element in the md-dialog.
	       * @param {FocusEvent} event
	       */
	      var focusHandler = function(event) {
	        if (event.target && event.target.nextSibling &&
	            event.target.nextSibling.nodeName === 'MD-DIALOG') {
	          var lastFocusableElement = $mdUtil.getLastTabbableElement(element[0]);
	          if (angular.isElement(lastFocusableElement)) {
	            lastFocusableElement.focus();
	          }
	        } else {
	          element.focus();
	        }
	      };
	
	      topFocusTrap.addEventListener('focus', focusHandler);
	      bottomFocusTrap.addEventListener('focus', focusHandler);
	
	      removeFocusTrap = function () {
	        topFocusTrap.removeEventListener('focus', focusHandler);
	        bottomFocusTrap.removeEventListener('focus', focusHandler);
	
	        if (topFocusTrap && topFocusTrap.parentNode) {
	          topFocusTrap.parentNode.removeChild(topFocusTrap);
	        }
	
	        if (bottomFocusTrap && bottomFocusTrap.parentNode) {
	          bottomFocusTrap.parentNode.removeChild(bottomFocusTrap);
	        }
	      };
	
	      // The top focus trap inserted immediately before the md-dialog element (as a sibling).
	      // The bottom focus trap is inserted immediately after the md-dialog element (as a sibling).
	      element[0].parentNode.insertBefore(topFocusTrap, element[0]);
	      element.after(bottomFocusTrap);
	    }
	
	    /**
	     * Prevents screen reader interaction behind modal window on swipe interfaces.
	     */
	    function lockScreenReader(element, options) {
	      var isHidden = true;
	
	      // get raw DOM node
	      walkDOM(element[0]);
	
	      options.unlockScreenReader = function () {
	        isHidden = false;
	        walkDOM(element[0]);
	
	        options.unlockScreenReader = null;
	      };
	
	      /**
	       * Get all of an element's parent elements up the DOM tree.
	       * @param {Node & ParentNode} element the element to start from
	       * @return {Element[]} The parent elements
	       */
	      function getParents(element) {
	        var parents = [];
	        while (element.parentNode) {
	          if (element === document.body) {
	            return parents;
	          }
	          var children = element.parentNode.children;
	          for (var i = 0; i < children.length; i++) {
	            // skip over child if it is an ascendant of the dialog
	            // a script or style tag, or a live region.
	            if (element !== children[i] &&
	                !isNodeOneOf(children[i], ['SCRIPT', 'STYLE']) &&
	                !children[i].hasAttribute('aria-live')) {
	              parents.push(children[i]);
	            }
	          }
	          element = element.parentNode;
	        }
	        return parents;
	      }
	
	      /**
	       * Walk DOM to apply or remove aria-hidden on sibling nodes and parent sibling nodes.
	       * @param {Element} element the element to start from when walking up the DOM
	       * @returns {void}
	       */
	      function walkDOM(element) {
	        var elements = getParents(element);
	        for (var i = 0; i < elements.length; i++) {
	          elements[i].setAttribute('aria-hidden', isHidden);
	        }
	      }
	    }
	
	    /**
	     * Ensure the dialog container fill-stretches to the viewport.
	     * @param {JQLite} container dialog container
	     * @param {Object} options
	     * @returns {function(): void} function that reverts the modified styles
	     */
	    function stretchDialogContainerToViewport(container, options) {
	      var isFixed = $window.getComputedStyle($document[0].body).position === 'fixed';
	      var backdrop = options.backdrop ? $window.getComputedStyle(options.backdrop[0]) : null;
	      var height = backdrop ?
	        Math.min($document[0].body.clientHeight, Math.ceil(Math.abs(parseInt(backdrop.height, 10))))
	        : 0;
	
	      var previousStyles = {
	        top: container.css('top'),
	        height: container.css('height')
	      };
	
	      // If the body is fixed, determine the distance to the viewport in relative from the parent.
	      var parentTop = Math.abs(options.parent[0].getBoundingClientRect().top);
	
	      container.css({
	        top: (isFixed ? parentTop : 0) + 'px',
	        height: height ? height + 'px' : '100%'
	      });
	
	      return function() {
	        // Reverts the modified styles back to the previous values.
	        // This is needed for contentElements, which should have the same styles after close
	        // as before.
	        container.css(previousStyles);
	      };
	    }
	
	    /**
	     * Dialog open and pop-in animation.
	     * @param {JQLite} container dialog container
	     * @param {Object} options
	     * @returns {*}
	     */
	    function dialogPopIn(container, options) {
	      // Add the `md-dialog-container` to the DOM
	      options.parent.append(container);
	      options.reverseContainerStretch = stretchDialogContainerToViewport(container, options);
	
	      var dialogEl = container.find('md-dialog');
	      var animator = $mdUtil.dom.animator;
	      var buildTranslateToOrigin = animator.calculateZoomToOrigin;
	      var translateOptions = {transitionInClass: 'md-transition-in', transitionOutClass: 'md-transition-out'};
	      var from = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.openFrom || options.origin));
	      var to = animator.toTransformCss("");  // defaults to center display (or parent or $rootElement)
	
	      dialogEl.toggleClass('md-dialog-fullscreen', !!options.fullscreen);
	
	      return animator
	        .translate3d(dialogEl, from, to, translateOptions)
	        .then(function(animateReversal) {
	
	          // Build a reversal translate function synced to this translation...
	          options.reverseAnimate = function() {
	            delete options.reverseAnimate;
	
	            if (options.closeTo) {
	              // Using the opposite classes to create a close animation to the closeTo element
	              translateOptions = {transitionInClass: 'md-transition-out', transitionOutClass: 'md-transition-in'};
	              from = to;
	              to = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.closeTo));
	
	              return animator
	                .translate3d(dialogEl, from, to,translateOptions);
	            }
	
	            return animateReversal(
	              to = animator.toTransformCss(
	                // in case the origin element has moved or is hidden,
	                // let's recalculate the translateCSS
	                buildTranslateToOrigin(dialogEl, options.origin)
	              )
	            );
	          };
	
	          // Function to revert the generated animation styles on the dialog element.
	          // Useful when using a contentElement instead of a template.
	          options.clearAnimate = function() {
	            delete options.clearAnimate;
	
	            // Remove the transition classes, added from $animateCSS, since those can't be removed
	            // by reversely running the animator.
	            dialogEl.removeClass([
	              translateOptions.transitionOutClass,
	              translateOptions.transitionInClass
	            ].join(' '));
	
	            // Run the animation reversely to remove the previous added animation styles.
	            return animator.translate3d(dialogEl, to, animator.toTransformCss(''), {});
	          };
	
	          return true;
	        });
	    }
	
	    /**
	     * Dialog close and pop-out animation.
	     * @param {JQLite} container dialog container
	     * @param {Object} options
	     * @returns {*}
	     */
	    function dialogPopOut(container, options) {
	      return options.reverseAnimate().then(function() {
	        if (options.contentElement) {
	          // When we use a contentElement, we want the element to be the same as before.
	          // That means, that we have to clear all the animation properties, like transform.
	          options.clearAnimate();
	        }
	      });
	    }
	
	    /**
	     * Utility function to filter out raw DOM nodes.
	     * @param {Node} elem
	     * @param {string[]} nodeTypeArray
	     * @returns {boolean}
	     */
	    function isNodeOneOf(elem, nodeTypeArray) {
	      return nodeTypeArray.indexOf(elem.nodeName) !== -1;
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.divider
	 * @description Divider module!
	 */
	MdDividerDirective.$inject = ["$mdTheming"];
	angular.module('material.components.divider', [
	  'material.core'
	])
	  .directive('mdDivider', MdDividerDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdDivider
	 * @module material.components.divider
	 * @restrict E
	 *
	 * @description
	 * Dividers group and separate content within lists and page layouts using strong visual and spatial distinctions. This divider is a thin rule, lightweight enough to not distract the user from content.
	 *
	 * @param {boolean=} md-inset Add this attribute to activate the inset divider style.
	 * @usage
	 * <hljs lang="html">
	 * <md-divider></md-divider>
	 *
	 * <md-divider md-inset></md-divider>
	 * </hljs>
	 *
	 */
	function MdDividerDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    link: $mdTheming
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabActions
	   */
	  MdFabActionsDirective.$inject = ["$mdUtil"];
	  angular
	    .module('material.components.fabActions', ['material.core'])
	    .directive('mdFabActions', MdFabActionsDirective);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabActions
	   * @module material.components.fabActions
	   *
	   * @restrict E
	   *
	   * @description
	   * The `<md-fab-actions>` directive is used inside of a `<md-fab-speed-dial>` or
	   * `<md-fab-toolbar>` directive to mark an element (or elements) as the actions and setup the
	   * proper event listeners.
	   *
	   * @usage
	   * See the `<md-fab-speed-dial>` or `<md-fab-toolbar>` directives for example usage.
	   */
	  function MdFabActionsDirective($mdUtil) {
	    return {
	      restrict: 'E',
	
	      require: ['^?mdFabSpeedDial', '^?mdFabToolbar'],
	
	      compile: function(element, attributes) {
	        var children = element.children();
	        var actionItemButtons;
	        var hasNgRepeat = $mdUtil.prefixer().hasAttribute(children, 'ng-repeat');
	
	        // Action item buttons should not be in the tab order when the speed dial is closed.
	        actionItemButtons = element.find('md-button');
	        angular.forEach(actionItemButtons, function(button) {
	          button.setAttribute('tabindex', -1);
	        });
	
	        // Support both ng-repeat and static content
	        if (hasNgRepeat) {
	          children.addClass('md-fab-action-item');
	        } else {
	          // Wrap every child in a new div and add a class that we can scale/fling independently
	          children.wrap('<div class="md-fab-action-item">');
	        }
	      }
	    };
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  MdFabController.$inject = ["$scope", "$element", "$animate", "$mdUtil", "$mdConstant", "$timeout"];
	  angular.module('material.components.fabShared', ['material.core'])
	    .controller('MdFabController', MdFabController);
	
	  function MdFabController($scope, $element, $animate, $mdUtil, $mdConstant, $timeout) {
	    var ctrl = this;
	    var initialAnimationAttempts = 0;
	
	    // NOTE: We use async eval(s) below to avoid conflicts with any existing digest loops
	
	    ctrl.open = function() {
	      $scope.$evalAsync("ctrl.isOpen = true");
	    };
	
	    ctrl.close = function() {
	      // Async eval to avoid conflicts with existing digest loops
	      $scope.$evalAsync("ctrl.isOpen = false");
	
	      // Focus the trigger when the element closes so users can still tab to the next item
	      $element.find('md-fab-trigger')[0].focus();
	    };
	
	    // Toggle the open/close state when the trigger is clicked
	    ctrl.toggle = function() {
	      $scope.$evalAsync("ctrl.isOpen = !ctrl.isOpen");
	    };
	
	    /*
	     * AngularJS Lifecycle hook for newer AngularJS versions.
	     * Bindings are not guaranteed to have been assigned in the controller, but they are in the
	     * $onInit hook.
	     */
	    ctrl.$onInit = function() {
	      setupDefaults();
	      setupListeners();
	      setupWatchers();
	
	      fireInitialAnimations();
	    };
	
	    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	    // manually call the $onInit hook.
	    if (angular.version.major === 1 && angular.version.minor <= 4) {
	      this.$onInit();
	    }
	
	    function setupDefaults() {
	      // Set the default direction to 'down' if none is specified
	      ctrl.direction = ctrl.direction || 'down';
	
	      // Set the default to be closed
	      ctrl.isOpen = ctrl.isOpen || false;
	
	      // Start the keyboard interaction at the first action
	      resetActionIndex();
	
	      // Add an animations waiting class so we know not to run
	      $element.addClass('md-animations-waiting');
	    }
	
	    function setupListeners() {
	      var eventTypes = [
	        'click', 'focusin', 'focusout'
	      ];
	
	      // Add our listeners
	      angular.forEach(eventTypes, function(eventType) {
	        $element.on(eventType, parseEvents);
	      });
	
	      // Remove our listeners when destroyed
	      $scope.$on('$destroy', function() {
	        angular.forEach(eventTypes, function(eventType) {
	          $element.off(eventType, parseEvents);
	        });
	
	        // remove any attached keyboard handlers in case element is removed while
	        // speed dial is open
	        disableKeyboard();
	      });
	    }
	
	    var closeTimeout;
	
	    /**
	     * @param {MouseEvent} event
	     */
	    function parseEvents(event) {
	      // If the event is a click, just handle it
	      if (event.type == 'click') {
	        handleItemClick(event);
	      }
	
	      // If we focusout, set a timeout to close the element
	      if (event.type == 'focusout' && !closeTimeout) {
	        closeTimeout = $timeout(function() {
	          ctrl.close();
	        }, 100, false);
	      }
	
	      // If we see a focusin and there is a timeout about to run, cancel it so we stay open
	      if (event.type == 'focusin' && closeTimeout) {
	        $timeout.cancel(closeTimeout);
	        closeTimeout = null;
	      }
	    }
	
	    function resetActionIndex() {
	      ctrl.currentActionIndex = -1;
	    }
	
	    function setupWatchers() {
	      // Watch for changes to the direction and update classes/attributes
	      $scope.$watch('ctrl.direction', function(newDir, oldDir) {
	        // Add the appropriate classes so we can target the direction in the CSS
	        $animate.removeClass($element, 'md-' + oldDir);
	        $animate.addClass($element, 'md-' + newDir);
	
	        // Reset the action index since it may have changed
	        resetActionIndex();
	      });
	
	      var trigger, actions;
	
	      // Watch for changes to md-open
	      $scope.$watch('ctrl.isOpen', function(isOpen) {
	        // Reset the action index since it may have changed
	        resetActionIndex();
	
	        // We can't get the trigger/actions outside of the watch because the component hasn't been
	        // linked yet, so we wait until the first watch fires to cache them.
	        if (!trigger || !actions) {
	          trigger = getTriggerElement();
	          actions = getActionsElement();
	        }
	
	        if (isOpen) {
	          enableKeyboard();
	        } else {
	          disableKeyboard();
	        }
	
	        var toAdd = isOpen ? 'md-is-open' : '';
	        var toRemove = isOpen ? '' : 'md-is-open';
	
	        // Set the proper ARIA attributes
	        trigger.attr('aria-haspopup', true);
	        trigger.attr('aria-expanded', isOpen);
	        actions.attr('aria-hidden', !isOpen);
	
	        // Animate the CSS classes
	        $animate.setClass($element, toAdd, toRemove);
	      });
	    }
	
	    function fireInitialAnimations() {
	      // If the element is actually visible on the screen
	      if ($element[0].scrollHeight > 0) {
	        // Fire our animation
	        $animate.addClass($element, '_md-animations-ready').then(function() {
	          // Remove the waiting class
	          $element.removeClass('md-animations-waiting');
	        });
	      }
	
	      // Otherwise, try for up to 1 second before giving up
	      else if (initialAnimationAttempts < 10) {
	        $timeout(fireInitialAnimations, 100);
	
	        // Increment our counter
	        initialAnimationAttempts = initialAnimationAttempts + 1;
	      }
	    }
	
	    function enableKeyboard() {
	      $element.on('keydown', keyPressed);
	
	      // On the next tick, setup a check for outside clicks; we do this on the next tick to avoid
	      // clicks/touches that result in the isOpen attribute changing (e.g. a bound radio button)
	      $mdUtil.nextTick(function() {
	        angular.element(document).on('click touchend', checkForOutsideClick);
	      });
	    }
	
	    function disableKeyboard() {
	      $element.off('keydown', keyPressed);
	      angular.element(document).off('click touchend', checkForOutsideClick);
	    }
	
	    function checkForOutsideClick(event) {
	      if (event.target) {
	        var closestTrigger = $mdUtil.getClosest(event.target, 'md-fab-trigger');
	        var closestActions = $mdUtil.getClosest(event.target, 'md-fab-actions');
	
	        if (!closestTrigger && !closestActions) {
	          ctrl.close();
	        }
	      }
	    }
	
	    /**
	     * @param {KeyboardEvent} event
	     * @returns {boolean}
	     */
	    function keyPressed(event) {
	      switch (event.which) {
	        case $mdConstant.KEY_CODE.ESCAPE: ctrl.close(); event.preventDefault(); return false;
	        case $mdConstant.KEY_CODE.LEFT_ARROW: doKeyLeft(event); return false;
	        case $mdConstant.KEY_CODE.UP_ARROW: doKeyUp(event); return false;
	        case $mdConstant.KEY_CODE.RIGHT_ARROW: doKeyRight(event); return false;
	        case $mdConstant.KEY_CODE.DOWN_ARROW: doKeyDown(event); return false;
	        case $mdConstant.KEY_CODE.TAB: doShift(event); return false;
	      }
	    }
	
	    function doActionPrev(event) {
	      focusAction(event, -1);
	    }
	
	    function doActionNext(event) {
	      focusAction(event, 1);
	    }
	
	    function focusAction(event, direction) {
	      var actions = getActionsElement()[0].querySelectorAll('.md-fab-action-item');
	      var previousActionIndex = ctrl.currentActionIndex;
	
	      // Increment/decrement the counter with restrictions
	      ctrl.currentActionIndex = ctrl.currentActionIndex + direction;
	      ctrl.currentActionIndex = Math.min(actions.length - 1, ctrl.currentActionIndex);
	      ctrl.currentActionIndex = Math.max(0, ctrl.currentActionIndex);
	
	      // Let Tab and Shift+Tab escape if we're trying to move past the start/end.
	      if (event.which !== $mdConstant.KEY_CODE.TAB ||
	          previousActionIndex !== ctrl.currentActionIndex) {
	        // Focus the element
	        var focusElement = angular.element(actions[ctrl.currentActionIndex]).children()[0];
	        focusElement.focus();
	
	        // Make sure the event doesn't bubble and cause something else
	        event.preventDefault();
	        event.stopImmediatePropagation();
	      }
	    }
	
	    function doKeyLeft(event) {
	      if (ctrl.direction === 'left') {
	        doActionNext(event);
	      } else {
	        doActionPrev(event);
	      }
	    }
	
	    function doKeyUp(event) {
	      if (ctrl.direction === 'down') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function doKeyRight(event) {
	      if (ctrl.direction === 'left') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function doKeyDown(event) {
	      if (ctrl.direction === 'up') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function doShift(event) {
	      if (event.shiftKey) {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    /**
	     * @param {Node} element
	     * @returns {Node|null}
	     */
	    function getClosestButton(element) {
	      return $mdUtil.getClosest(element, 'button') || $mdUtil.getClosest(element, 'md-button');
	    }
	
	    /**
	     * @param {Node} element
	     * @returns {Node|null}
	     */
	    function getClosestTrigger(element) {
	      return $mdUtil.getClosest(element, 'md-fab-trigger');
	    }
	
	    /**
	     * @param {Node} element
	     * @returns {Node|null}
	     */
	    function getClosestAction(element) {
	      return $mdUtil.getClosest(element, 'md-fab-actions');
	    }
	
	    /**
	     * @param {MouseEvent|FocusEvent} event
	     */
	    function handleItemClick(event) {
	      var closestButton = event.target ? getClosestButton(event.target) : null;
	
	      // Check that the button in the trigger is not disabled
	      if (closestButton && !closestButton.disabled) {
	        if (getClosestTrigger(event.target)) {
	          ctrl.toggle();
	        }
	      }
	
	      if (getClosestAction(event.target)) {
	        ctrl.close();
	      }
	    }
	
	    function getTriggerElement() {
	      return $element.find('md-fab-trigger');
	    }
	
	    function getActionsElement() {
	      return $element.find('md-fab-actions');
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * The duration of the CSS animation in milliseconds.
	   *
	   * @type {number}
	   */
	  MdFabSpeedDialFlingAnimation.$inject = ["$timeout"];
	  MdFabSpeedDialScaleAnimation.$inject = ["$timeout"];
	  var cssAnimationDuration = 300;
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabSpeedDial
	   */
	  angular
	    // Declare our module
	    .module('material.components.fabSpeedDial', [
	      'material.core',
	      'material.components.fabShared',
	      'material.components.fabActions'
	    ])
	
	    // Register our directive
	    .directive('mdFabSpeedDial', MdFabSpeedDialDirective)
	
	    // Register our custom animations
	    .animation('.md-fling', MdFabSpeedDialFlingAnimation)
	    .animation('.md-scale', MdFabSpeedDialScaleAnimation)
	
	    // Register a service for each animation so that we can easily inject them into unit tests
	    .service('mdFabSpeedDialFlingAnimation', MdFabSpeedDialFlingAnimation)
	    .service('mdFabSpeedDialScaleAnimation', MdFabSpeedDialScaleAnimation);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabSpeedDial
	   * @module material.components.fabSpeedDial
	   *
	   * @restrict E
	   *
	   * @description
	   * The `<md-fab-speed-dial>` directive is used to present a series of popup elements (usually
	   * `<md-button>`s) for quick access to common actions.
	   *
	   * There are currently two animations available by applying one of the following classes to
	   * the component:
	   *
	   *  - `md-fling` - The speed dial items appear from underneath the trigger and move into their
	   *    appropriate positions.
	   *  - `md-scale` - The speed dial items appear in their proper places by scaling from 0% to 100%.
	   *
	   * You may also easily position the trigger by applying one one of the following classes to the
	   * `<md-fab-speed-dial>` element:
	   *  - `md-fab-top-left`
	   *  - `md-fab-top-right`
	   *  - `md-fab-bottom-left`
	   *  - `md-fab-bottom-right`
	   *
	   * These CSS classes use `position: absolute`, so you need to ensure that the container element
	   * also uses `position: absolute` or `position: relative` in order for them to work.
	   *
	   * Additionally, you may use the standard `ng-mouseenter` and `ng-mouseleave` directives to
	   * open or close the speed dial. However, if you wish to allow users to hover over the empty
	   * space where the actions will appear, you must also add the `md-hover-full` class to the speed
	   * dial element. Without this, the hover effect will only occur on top of the trigger.
	   *
	   * See the demos for more information.
	   *
	   * ## Troubleshooting
	   *
	   * If your speed dial shows the closing animation upon launch, you may need to use `ng-cloak` on
	   * the parent container to ensure that it is only visible once ready. We have plans to remove this
	   * necessity in the future.
	   *
	   * @usage
	   * <hljs lang="html">
	   * <md-fab-speed-dial md-direction="up" class="md-fling">
	   *   <md-fab-trigger>
	   *     <md-button aria-label="Add..."><md-icon md-svg-src="/img/icons/plus.svg"></md-icon></md-button>
	   *   </md-fab-trigger>
	   *
	   *   <md-fab-actions>
	   *     <md-button aria-label="Add User">
	   *       <md-icon md-svg-src="/img/icons/user.svg"></md-icon>
	   *     </md-button>
	   *
	   *     <md-button aria-label="Add Group">
	   *       <md-icon md-svg-src="/img/icons/group.svg"></md-icon>
	   *     </md-button>
	   *   </md-fab-actions>
	   * </md-fab-speed-dial>
	   * </hljs>
	   *
	   * @param {string} md-direction From which direction you would like the speed dial to appear
	   * relative to the trigger element.
	   * @param {expression=} md-open Programmatically control whether or not the speed-dial is visible.
	   */
	  function MdFabSpeedDialDirective() {
	    return {
	      restrict: 'E',
	
	      scope: {
	        direction: '@?mdDirection',
	        isOpen: '=?mdOpen'
	      },
	
	      bindToController: true,
	      controller: 'MdFabController',
	      controllerAs: 'ctrl',
	
	      link: FabSpeedDialLink
	    };
	
	    function FabSpeedDialLink(scope, element) {
	      // Prepend an element to hold our CSS variables so we can use them in the animations below
	      element.prepend('<div class="_md-css-variables"></div>');
	    }
	  }
	
	  function MdFabSpeedDialFlingAnimation($timeout) {
	    function delayDone(done) { $timeout(done, cssAnimationDuration, false); }
	
	    function runAnimation(element) {
	      // Don't run if we are still waiting and we are not ready
	      if (element.hasClass('md-animations-waiting') && !element.hasClass('_md-animations-ready')) {
	        return;
	      }
	
	      var el = element[0];
	      var ctrl = element.controller('mdFabSpeedDial');
	      var items = el.querySelectorAll('.md-fab-action-item');
	
	      // Grab our trigger element
	      var triggerElement = el.querySelector('md-fab-trigger');
	
	      // Grab our element which stores CSS variables
	      var variablesElement = el.querySelector('._md-css-variables');
	
	      // Setup JS variables based on our CSS variables
	      var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);
	
	      // Always reset the items to their natural position/state
	      angular.forEach(items, function(item, index) {
	        var styles = item.style;
	
	        styles.transform = styles.webkitTransform = '';
	        styles.transitionDelay = '';
	        styles.opacity = ctrl.isOpen ? 1 : 0;
	
	        // Make the items closest to the trigger have the highest z-index
	        styles.zIndex = (items.length - index) + startZIndex;
	      });
	
	      // Set the trigger to be above all of the actions so they disappear behind it.
	      triggerElement.style.zIndex = startZIndex + items.length + 1;
	
	      // If the control is closed, hide the items behind the trigger
	      if (!ctrl.isOpen) {
	        angular.forEach(items, function(item, index) {
	          var newPosition, axis;
	          var styles = item.style;
	
	          // Make sure to account for differences in the dimensions of the trigger verses the items
	          // so that we can properly center everything; this helps hide the item's shadows behind
	          // the trigger.
	          var triggerItemHeightOffset = (triggerElement.clientHeight - item.clientHeight) / 2;
	          var triggerItemWidthOffset = (triggerElement.clientWidth - item.clientWidth) / 2;
	
	          switch (ctrl.direction) {
	            case 'up':
	              newPosition = (item.scrollHeight * (index + 1) + triggerItemHeightOffset);
	              axis = 'Y';
	              break;
	            case 'down':
	              newPosition = -(item.scrollHeight * (index + 1) + triggerItemHeightOffset);
	              axis = 'Y';
	              break;
	            case 'left':
	              newPosition = (item.scrollWidth * (index + 1) + triggerItemWidthOffset);
	              axis = 'X';
	              break;
	            case 'right':
	              newPosition = -(item.scrollWidth * (index + 1) + triggerItemWidthOffset);
	              axis = 'X';
	              break;
	          }
	
	          var newTranslate = 'translate' + axis + '(' + newPosition + 'px)';
	
	          styles.transform = styles.webkitTransform = newTranslate;
	        });
	      }
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        if (element.hasClass('md-fling')) {
	          runAnimation(element);
	          delayDone(done);
	        } else {
	          done();
	        }
	      },
	      removeClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      }
	    };
	  }
	
	  function MdFabSpeedDialScaleAnimation($timeout) {
	    function delayDone(done) { $timeout(done, cssAnimationDuration, false); }
	
	    var delay = 65;
	
	    function runAnimation(element) {
	      var el = element[0];
	      var ctrl = element.controller('mdFabSpeedDial');
	      var items = el.querySelectorAll('.md-fab-action-item');
	
	      // Grab our element which stores CSS variables
	      var variablesElement = el.querySelector('._md-css-variables');
	
	      // Setup JS variables based on our CSS variables
	      var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);
	
	      // Always reset the items to their natural position/state
	      angular.forEach(items, function(item, index) {
	        var styles = item.style,
	          offsetDelay = index * delay;
	
	        styles.opacity = ctrl.isOpen ? 1 : 0;
	        styles.transform = styles.webkitTransform = ctrl.isOpen ? 'scale(1)' : 'scale(0)';
	        styles.transitionDelay = (ctrl.isOpen ? offsetDelay : (items.length - offsetDelay)) + 'ms';
	
	        // Make the items closest to the trigger have the highest z-index
	        styles.zIndex = (items.length - index) + startZIndex;
	      });
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      },
	
	      removeClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      }
	    };
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabToolbar
	   */
	  angular
	    // Declare our module
	    .module('material.components.fabToolbar', [
	      'material.core',
	      'material.components.fabShared',
	      'material.components.fabActions'
	    ])
	
	    // Register our directive
	    .directive('mdFabToolbar', MdFabToolbarDirective)
	
	    // Register our custom animations
	    .animation('.md-fab-toolbar', MdFabToolbarAnimation)
	
	    // Register a service for the animation so that we can easily inject it into unit tests
	    .service('mdFabToolbarAnimation', MdFabToolbarAnimation);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabToolbar
	   * @module material.components.fabToolbar
	   *
	   * @restrict E
	   *
	   * @description
	   *
	   * The `<md-fab-toolbar>` directive is used to present a toolbar of elements (usually `<md-button>`s)
	   * for quick access to common actions when a floating action button is activated (via click or
	   * keyboard navigation).
	   *
	   * You may also easily position the trigger by applying one one of the following classes to the
	   * `<md-fab-toolbar>` element:
	   *  - `md-fab-top-left`
	   *  - `md-fab-top-right`
	   *  - `md-fab-bottom-left`
	   *  - `md-fab-bottom-right`
	   *
	   * These CSS classes use `position: absolute`, so you need to ensure that the container element
	   * also uses `position: absolute` or `position: relative` in order for them to work.
	   *
	   * @usage
	   *
	   * <hljs lang="html">
	   * <md-fab-toolbar md-direction='left'>
	   *   <md-fab-trigger>
	   *     <md-button aria-label="Add..."><md-icon md-svg-src="/img/icons/plus.svg"></md-icon></md-button>
	   *   </md-fab-trigger>
	   *
	   *   <md-toolbar>
	   *    <md-fab-actions>
	   *      <md-button aria-label="Add User">
	   *        <md-icon md-svg-src="/img/icons/user.svg"></md-icon>
	   *      </md-button>
	   *
	   *      <md-button aria-label="Add Group">
	   *        <md-icon md-svg-src="/img/icons/group.svg"></md-icon>
	   *      </md-button>
	   *    </md-fab-actions>
	   *   </md-toolbar>
	   * </md-fab-toolbar>
	   * </hljs>
	   *
	   * @param {string} md-direction From which direction you would like the toolbar items to appear
	   * relative to the trigger element. Supports `left` and `right` directions.
	   * @param {expression=} md-open Programmatically control whether or not the toolbar is visible.
	   */
	  function MdFabToolbarDirective() {
	    return {
	      restrict: 'E',
	      transclude: true,
	      template: '<div class="md-fab-toolbar-wrapper">' +
	      '  <div class="md-fab-toolbar-content" ng-transclude></div>' +
	      '</div>',
	
	      scope: {
	        direction: '@?mdDirection',
	        isOpen: '=?mdOpen'
	      },
	
	      bindToController: true,
	      controller: 'MdFabController',
	      controllerAs: 'ctrl',
	
	      link: link
	    };
	
	    function link(scope, element, attributes) {
	      // Add the base class for animations
	      element.addClass('md-fab-toolbar');
	
	      // Prepend the background element to the trigger's button
	      element.find('md-fab-trigger').find('button')
	        .prepend('<div class="md-fab-toolbar-background"></div>');
	    }
	  }
	
	  function MdFabToolbarAnimation() {
	
	    function runAnimation(element, className, done) {
	      // If no className was specified, don't do anything
	      if (!className) {
	        return;
	      }
	
	      var el = element[0];
	      var ctrl = element.controller('mdFabToolbar');
	
	      // Grab the relevant child elements
	      var backgroundElement = el.querySelector('.md-fab-toolbar-background');
	      var triggerElement = el.querySelector('md-fab-trigger button');
	      var toolbarElement = el.querySelector('md-toolbar');
	      var iconElement = el.querySelector('md-fab-trigger button md-icon');
	      var actions = element.find('md-fab-actions').children();
	
	      // If we have both elements, use them to position the new background
	      if (triggerElement && backgroundElement) {
	        // Get our variables
	        var color = window.getComputedStyle(triggerElement).getPropertyValue('background-color');
	        var width = el.offsetWidth;
	        var height = el.offsetHeight;
	
	        // Make it twice as big as it should be since we scale from the center
	        var scale = 2 * (width / triggerElement.offsetWidth);
	
	        // Set some basic styles no matter what animation we're doing
	        backgroundElement.style.backgroundColor = color;
	        backgroundElement.style.borderRadius = width + 'px';
	
	        // If we're open
	        if (ctrl.isOpen) {
	          // Turn on toolbar pointer events when closed
	          toolbarElement.style.pointerEvents = 'inherit';
	
	          backgroundElement.style.width = triggerElement.offsetWidth + 'px';
	          backgroundElement.style.height = triggerElement.offsetHeight + 'px';
	          backgroundElement.style.transform = 'scale(' + scale + ')';
	
	          // Set the next close animation to have the proper delays
	          backgroundElement.style.transitionDelay = '0ms';
	          iconElement && (iconElement.style.transitionDelay = '.3s');
	
	          // Apply a transition delay to actions
	          angular.forEach(actions, function(action, index) {
	            action.style.transitionDelay = (actions.length - index) * 25 + 'ms';
	          });
	        } else {
	          // Turn off toolbar pointer events when closed
	          toolbarElement.style.pointerEvents = 'none';
	
	          // Scale it back down to the trigger's size
	          backgroundElement.style.transform = 'scale(1)';
	
	          // Reset the position
	          backgroundElement.style.top = '0';
	
	          if (element.hasClass('md-right')) {
	            backgroundElement.style.left = '0';
	            backgroundElement.style.right = null;
	          }
	
	          if (element.hasClass('md-left')) {
	            backgroundElement.style.right = '0';
	            backgroundElement.style.left = null;
	          }
	
	          // Set the next open animation to have the proper delays
	          backgroundElement.style.transitionDelay = '200ms';
	          iconElement && (iconElement.style.transitionDelay = '0ms');
	
	          // Apply a transition delay to actions
	          angular.forEach(actions, function(action, index) {
	            action.style.transitionDelay = 200 + (index * 25) + 'ms';
	          });
	        }
	      }
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        runAnimation(element, className, done);
	        done();
	      },
	
	      removeClass: function(element, className, done) {
	        runAnimation(element, className, done);
	        done();
	      }
	    };
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.gridList
	 */
	GridListController.$inject = ["$mdUtil"];
	GridLayoutFactory.$inject = ["$mdUtil"];
	GridListDirective.$inject = ["$interpolate", "$mdConstant", "$mdGridLayout", "$mdMedia", "$mdUtil"];
	GridTileDirective.$inject = ["$mdMedia"];
	angular.module('material.components.gridList', ['material.core'])
	       .directive('mdGridList', GridListDirective)
	       .directive('mdGridTile', GridTileDirective)
	       .directive('mdGridTileFooter', GridTileCaptionDirective)
	       .directive('mdGridTileHeader', GridTileCaptionDirective)
	       .factory('$mdGridLayout', GridLayoutFactory);
	
	/**
	 * @ngdoc directive
	 * @name mdGridList
	 * @module material.components.gridList
	 * @restrict E
	 * @description
	 * Grid lists are an alternative to standard list views. Grid lists are distinct
	 * from grids used for layouts and other visual presentations.
	 *
	 * A grid list is best suited to presenting a homogenous data type, typically
	 * images, and is optimized for visual comprehension and differentiating between
	 * like data types.
	 *
	 * A grid list is a continuous element consisting of tessellated, regular
	 * subdivisions called cells that contain tiles (`md-grid-tile`).
	 *
	 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7OVlEaXZ5YmU1Xzg/components_grids_usage2.png"
	 *    style="width: 300px; height: auto; margin-right: 16px;" alt="Concept of grid explained visually">
	 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7VGhsOE5idWlJWXM/components_grids_usage3.png"
	 *    style="width: 300px; height: auto;" alt="Grid concepts legend">
	 *
	 * Cells are arrayed vertically and horizontally within the grid.
	 *
	 * Tiles hold content and can span one or more cells vertically or horizontally.
	 *
	 * ### Responsive Attributes
	 *
	 * The `md-grid-list` directive supports "responsive" attributes, which allow
	 * different `md-cols`, `md-gutter` and `md-row-height` values depending on the
	 * currently matching media query.
	 *
	 * In order to set a responsive attribute, first define the fallback value with
	 * the standard attribute name, then add additional attributes with the
	 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
	 * (ie. `md-cols-lg="8"`)
	 *
	 * @param {number} md-cols Number of columns in the grid.
	 * @param {string} md-row-height One of
	 * <ul>
	 *   <li>CSS length - Fixed height rows (eg. `8px` or `1rem`)</li>
	 *   <li>`{width}:{height}` - Ratio of width to height (eg.
	 *   `md-row-height="16:9"`)</li>
	 *   <li>`"fit"` - Height will be determined by subdividing the available
	 *   height by the number of rows</li>
	 * </ul>
	 * @param {string=} md-gutter The amount of space between tiles in CSS units
	 *     (default 1px)
	 * @param {expression=} md-on-layout Expression to evaluate after layout. Event
	 *     object is available as `$event`, and contains performance information.
	 *
	 * @usage
	 * Basic:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="5" md-gutter="1em" md-row-height="4:3">
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Fixed-height rows:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="4" md-row-height="200px" ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Fit rows:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="4" md-row-height="fit" style="height: 400px;" ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Using responsive attributes:
	 * <hljs lang="html">
	 * <md-grid-list
	 *     md-cols-sm="2"
	 *     md-cols-md="4"
	 *     md-cols-lg="8"
	 *     md-cols-gt-lg="12"
	 *     ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 */
	function GridListDirective($interpolate, $mdConstant, $mdGridLayout, $mdMedia, $mdUtil) {
	  return {
	    restrict: 'E',
	    controller: GridListController,
	    scope: {
	      mdOnLayout: '&'
	    },
	    link: postLink
	  };
	
	  function postLink(scope, element, attrs, ctrl) {
	    element.addClass('_md');     // private md component indicator for styling
	
	    // Apply semantics
	    element.attr('role', 'list');
	
	    // Provide the controller with a way to trigger layouts.
	    ctrl.layoutDelegate = layoutDelegate;
	
	    var invalidateLayout = angular.bind(ctrl, ctrl.invalidateLayout),
	        unwatchAttrs = watchMedia();
	      scope.$on('$destroy', unwatchMedia);
	
	    /**
	     * Watches for changes in media, invalidating layout as necessary.
	     */
	    function watchMedia() {
	      for (var mediaName in $mdConstant.MEDIA) {
	        $mdMedia(mediaName); // initialize
	        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
	            .addListener(invalidateLayout);
	      }
	      return $mdMedia.watchResponsiveAttributes(
	          ['md-cols', 'md-row-height', 'md-gutter'], attrs, layoutIfMediaMatch);
	    }
	
	    function unwatchMedia() {
	      ctrl.layoutDelegate = angular.noop;
	
	      unwatchAttrs();
	      for (var mediaName in $mdConstant.MEDIA) {
	        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
	            .removeListener(invalidateLayout);
	      }
	    }
	
	    /**
	     * Performs grid layout if the provided mediaName matches the currently
	     * active media type.
	     */
	    function layoutIfMediaMatch(mediaName) {
	      if (mediaName == null) {
	        // TODO(shyndman): It would be nice to only layout if we have
	        // instances of attributes using this media type
	        ctrl.invalidateLayout();
	      } else if ($mdMedia(mediaName)) {
	        ctrl.invalidateLayout();
	      }
	    }
	
	    var lastLayoutProps;
	
	    /**
	     * Invokes the layout engine, and uses its results to lay out our
	     * tile elements.
	     *
	     * @param {boolean} tilesInvalidated Whether tiles have been
	     *    added/removed/moved since the last layout. This is to avoid situations
	     *    where tiles are replaced with properties identical to their removed
	     *    counterparts.
	     */
	    function layoutDelegate(tilesInvalidated) {
	      var tiles = getTileElements();
	      var props = {
	        tileSpans: getTileSpans(tiles),
	        colCount: getColumnCount(),
	        rowMode: getRowMode(),
	        rowHeight: getRowHeight(),
	        gutter: getGutter()
	      };
	
	      if (!tilesInvalidated && angular.equals(props, lastLayoutProps)) {
	        return;
	      }
	
	      var performance =
	        $mdGridLayout(props.colCount, props.tileSpans, tiles)
	          .map(function(tilePositions, rowCount) {
	            return {
	              grid: {
	                element: element,
	                style: getGridStyle(props.colCount, rowCount,
	                    props.gutter, props.rowMode, props.rowHeight)
	              },
	              tiles: tilePositions.map(function(ps, i) {
	                return {
	                  element: angular.element(tiles[i]),
	                  style: getTileStyle(ps.position, ps.spans,
	                      props.colCount, rowCount,
	                      props.gutter, props.rowMode, props.rowHeight)
	                };
	              })
	            };
	          })
	          .reflow()
	          .performance();
	
	      // Report layout
	      scope.mdOnLayout({
	        $event: {
	          performance: performance
	        }
	      });
	
	      lastLayoutProps = props;
	    }
	
	    // Use $interpolate to do some simple string interpolation as a convenience.
	
	    var startSymbol = $interpolate.startSymbol();
	    var endSymbol = $interpolate.endSymbol();
	
	    // Returns an expression wrapped in the interpolator's start and end symbols.
	    function expr(exprStr) {
	      return startSymbol + exprStr + endSymbol;
	    }
	
	    // The amount of space a single 1x1 tile would take up (either width or height), used as
	    // a basis for other calculations. This consists of taking the base size percent (as would be
	    // if evenly dividing the size between cells), and then subtracting the size of one gutter.
	    // However, since there are no gutters on the edges, each tile only uses a fration
	    // (gutterShare = numGutters / numCells) of the gutter size. (Imagine having one gutter per
	    // tile, and then breaking up the extra gutter on the edge evenly among the cells).
	    var UNIT = $interpolate(expr('share') + '% - (' + expr('gutter') + ' * ' + expr('gutterShare') + ')');
	
	    // The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
	    // The position comes the size of a 1x1 tile plus gutter for each previous tile in the
	    // row/column (offset).
	    var POSITION  = $interpolate('calc((' + expr('unit') + ' + ' + expr('gutter') + ') * ' + expr('offset') + ')');
	
	    // The actual size of a tile, e.g., width or height, taking rowSpan or colSpan into account.
	    // This is computed by multiplying the base unit by the rowSpan/colSpan, and then adding back
	    // in the space that the gutter would normally have used (which was already accounted for in
	    // the base unit calculation).
	    var DIMENSION = $interpolate('calc((' + expr('unit') + ') * ' + expr('span') + ' + (' + expr('span') + ' - 1) * ' + expr('gutter') + ')');
	
	    /**
	     * Gets the styles applied to a tile element described by the given parameters.
	     * @param {{row: number, col: number}} position The row and column indices of the tile.
	     * @param {{row: number, col: number}} spans The rowSpan and colSpan of the tile.
	     * @param {number} colCount The number of columns.
	     * @param {number} rowCount The number of rows.
	     * @param {string} gutter The amount of space between tiles. This will be something like
	     *     '5px' or '2em'.
	     * @param {string} rowMode The row height mode. Can be one of:
	     *     'fixed': all rows have a fixed size, given by rowHeight,
	     *     'ratio': row height defined as a ratio to width, or
	     *     'fit': fit to the grid-list element height, divinding evenly among rows.
	     * @param {string|number} rowHeight The height of a row. This is only used for 'fixed' mode and
	     *     for 'ratio' mode. For 'ratio' mode, this is the *ratio* of width-to-height (e.g., 0.75).
	     * @returns {Object} Map of CSS properties to be applied to the style element. Will define
	     *     values for top, left, width, height, marginTop, and paddingTop.
	     */
	    function getTileStyle(position, spans, colCount, rowCount, gutter, rowMode, rowHeight) {
	      // TODO(shyndman): There are style caching opportunities here.
	
	      // Percent of the available horizontal space that one column takes up.
	      var hShare = (1 / colCount) * 100;
	
	      // Fraction of the gutter size that each column takes up.
	      var hGutterShare = (colCount - 1) / colCount;
	
	      // Base horizontal size of a column.
	      var hUnit = UNIT({share: hShare, gutterShare: hGutterShare, gutter: gutter});
	
	      // The width and horizontal position of each tile is always calculated the same way, but the
	      // height and vertical position depends on the rowMode.
	      var style = (!$mdUtil.isRtl(attrs)) ? {
	          left: POSITION({ unit: hUnit, offset: position.col, gutter: gutter }),
	          width: DIMENSION({ unit: hUnit, span: spans.col, gutter: gutter }),
	          // resets
	          paddingTop: '',
	          marginTop: '',
	          top: '',
	          height: ''
	        } : {
	        right: POSITION({ unit: hUnit, offset: position.col, gutter: gutter }),
	        width: DIMENSION({ unit: hUnit, span: spans.col, gutter: gutter }),
	        // resets
	        paddingTop: '',
	        marginTop: '',
	        top: '',
	        height: ''
	      };
	
	      switch (rowMode) {
	        case 'fixed':
	          // In fixed mode, simply use the given rowHeight.
	          style.top = POSITION({ unit: rowHeight, offset: position.row, gutter: gutter });
	          style.height = DIMENSION({ unit: rowHeight, span: spans.row, gutter: gutter });
	          break;
	
	        case 'ratio':
	          // Percent of the available vertical space that one row takes up. Here, rowHeight holds
	          // the ratio value. For example, if the width:height ratio is 4:3, rowHeight = 1.333.
	          var vShare = hShare / rowHeight;
	
	          // Base veritcal size of a row.
	          var vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });
	
	          // padidngTop and marginTop are used to maintain the given aspect ratio, as
	          // a percentage-based value for these properties is applied to the *width* of the
	          // containing block. See http://www.w3.org/TR/CSS2/box.html#margin-properties
	          style.paddingTop = DIMENSION({ unit: vUnit, span: spans.row, gutter: gutter});
	          style.marginTop = POSITION({ unit: vUnit, offset: position.row, gutter: gutter });
	          break;
	
	        case 'fit':
	          // Fraction of the gutter size that each column takes up.
	          var vGutterShare = (rowCount - 1) / rowCount;
	
	          // Percent of the available vertical space that one row takes up.
	          vShare = (1 / rowCount) * 100;
	
	          // Base vertical size of a row.
	          vUnit = UNIT({share: vShare, gutterShare: vGutterShare, gutter: gutter});
	
	          style.top = POSITION({unit: vUnit, offset: position.row, gutter: gutter});
	          style.height = DIMENSION({unit: vUnit, span: spans.row, gutter: gutter});
	          break;
	      }
	
	      return style;
	    }
	
	    function getGridStyle(colCount, rowCount, gutter, rowMode, rowHeight) {
	      var style = {};
	
	      switch (rowMode) {
	        case 'fixed':
	          style.height = DIMENSION({ unit: rowHeight, span: rowCount, gutter: gutter });
	          style.paddingBottom = '';
	          break;
	
	        case 'ratio':
	          // rowHeight is width / height
	          var hGutterShare = colCount === 1 ? 0 : (colCount - 1) / colCount,
	              hShare = (1 / colCount) * 100,
	              vShare = hShare * (1 / rowHeight),
	              vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });
	
	          style.height = '';
	          style.paddingBottom = DIMENSION({ unit: vUnit, span: rowCount, gutter: gutter});
	          break;
	
	        case 'fit':
	          // noop, as the height is user set
	          break;
	      }
	
	      return style;
	    }
	
	    function getTileElements() {
	      return [].filter.call(element.children(), function(ele) {
	        return ele.tagName == 'MD-GRID-TILE' && !ele.$$mdDestroyed;
	      });
	    }
	
	    /**
	     * Gets an array of objects containing the rowspan and colspan for each tile.
	     * @returns {Array<{row: number, col: number}>}
	     */
	    function getTileSpans(tileElements) {
	      return [].map.call(tileElements, function(ele) {
	        var ctrl = angular.element(ele).controller('mdGridTile');
	        return {
	          row: parseInt(
	              $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-rowspan'), 10) || 1,
	          col: parseInt(
	              $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-colspan'), 10) || 1
	        };
	      });
	    }
	
	    function getColumnCount() {
	      var colCount = parseInt($mdMedia.getResponsiveAttribute(attrs, 'md-cols'), 10);
	      if (isNaN(colCount)) {
	        throw 'md-grid-list: md-cols attribute was not found, or contained a non-numeric value';
	      }
	      return colCount;
	    }
	
	    function getGutter() {
	      return applyDefaultUnit($mdMedia.getResponsiveAttribute(attrs, 'md-gutter') || 1);
	    }
	
	    function getRowHeight() {
	      var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
	      if (!rowHeight) {
	        throw 'md-grid-list: md-row-height attribute was not found';
	      }
	
	      switch (getRowMode()) {
	        case 'fixed':
	          return applyDefaultUnit(rowHeight);
	        case 'ratio':
	          var whRatio = rowHeight.split(':');
	          return parseFloat(whRatio[0]) / parseFloat(whRatio[1]);
	        case 'fit':
	          return 0; // N/A
	      }
	    }
	
	    function getRowMode() {
	      var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
	      if (!rowHeight) {
	        throw 'md-grid-list: md-row-height attribute was not found';
	      }
	
	      if (rowHeight == 'fit') {
	        return 'fit';
	      } else if (rowHeight.indexOf(':') !== -1) {
	        return 'ratio';
	      } else {
	        return 'fixed';
	      }
	    }
	
	    function applyDefaultUnit(val) {
	      return /\D$/.test(val) ? val : val + 'px';
	    }
	  }
	}
	
	/* @ngInject */
	function GridListController($mdUtil) {
	  this.layoutInvalidated = false;
	  this.tilesInvalidated = false;
	  this.$timeout_ = $mdUtil.nextTick;
	  this.layoutDelegate = angular.noop;
	}
	
	GridListController.prototype = {
	  invalidateTiles: function() {
	    this.tilesInvalidated = true;
	    this.invalidateLayout();
	  },
	
	  invalidateLayout: function() {
	    if (this.layoutInvalidated) {
	      return;
	    }
	    this.layoutInvalidated = true;
	    this.$timeout_(angular.bind(this, this.layout));
	  },
	
	  layout: function() {
	    try {
	      this.layoutDelegate(this.tilesInvalidated);
	    } finally {
	      this.layoutInvalidated = false;
	      this.tilesInvalidated = false;
	    }
	  }
	};
	
	
	/* @ngInject */
	function GridLayoutFactory($mdUtil) {
	  var defaultAnimator = GridTileAnimator;
	
	  /**
	   * Set the reflow animator callback
	   */
	  GridLayout.animateWith = function(customAnimator) {
	    defaultAnimator = !angular.isFunction(customAnimator) ? GridTileAnimator : customAnimator;
	  };
	
	  return GridLayout;
	
	  /**
	   * Publish layout function
	   */
	  function GridLayout(colCount, tileSpans) {
	      var self, layoutInfo, gridStyles, layoutTime, mapTime, reflowTime;
	
	      layoutTime = $mdUtil.time(function() {
	        layoutInfo = calculateGridFor(colCount, tileSpans);
	      });
	
	      return self = {
	
	        /**
	         * An array of objects describing each tile's position in the grid.
	         */
	        layoutInfo: function() {
	          return layoutInfo;
	        },
	
	        /**
	         * Maps grid positioning to an element and a set of styles using the
	         * provided updateFn.
	         */
	        map: function(updateFn) {
	          mapTime = $mdUtil.time(function() {
	            var info = self.layoutInfo();
	            gridStyles = updateFn(info.positioning, info.rowCount);
	          });
	          return self;
	        },
	
	        /**
	         * Default animator simply sets the element.css( <styles> ). An alternate
	         * animator can be provided as an argument. The function has the following
	         * signature:
	         *
	         *    function({grid: {element: JQLite, style: Object}, tiles: Array<{element: JQLite, style: Object}>)
	         */
	        reflow: function(animatorFn) {
	          reflowTime = $mdUtil.time(function() {
	            var animator = animatorFn || defaultAnimator;
	            animator(gridStyles.grid, gridStyles.tiles);
	          });
	          return self;
	        },
	
	        /**
	         * Timing for the most recent layout run.
	         */
	        performance: function() {
	          return {
	            tileCount: tileSpans.length,
	            layoutTime: layoutTime,
	            mapTime: mapTime,
	            reflowTime: reflowTime,
	            totalTime: layoutTime + mapTime + reflowTime
	          };
	        }
	      };
	    }
	
	  /**
	   * Default Gridlist animator simple sets the css for each element;
	   * NOTE: any transitions effects must be manually set in the CSS.
	   * e.g.
	   *
	   *  md-grid-tile {
	   *    transition: all 700ms ease-out 50ms;
	   *  }
	   *
	   */
	  function GridTileAnimator(grid, tiles) {
	    grid.element.css(grid.style);
	    tiles.forEach(function(t) {
	      t.element.css(t.style);
	    });
	  }
	
	  /**
	   * Calculates the positions of tiles.
	   *
	   * The algorithm works as follows:
	   *    An Array<Number> with length colCount (spaceTracker) keeps track of
	   *    available tiling positions, where elements of value 0 represents an
	   *    empty position. Space for a tile is reserved by finding a sequence of
	   *    0s with length <= than the tile's colspan. When such a space has been
	   *    found, the occupied tile positions are incremented by the tile's
	   *    rowspan value, as these positions have become unavailable for that
	   *    many rows.
	   *
	   *    If the end of a row has been reached without finding space for the
	   *    tile, spaceTracker's elements are each decremented by 1 to a minimum
	   *    of 0. Rows are searched in this fashion until space is found.
	   */
	  function calculateGridFor(colCount, tileSpans) {
	    var curCol = 0,
	        curRow = 0,
	        spaceTracker = newSpaceTracker();
	
	    return {
	      positioning: tileSpans.map(function(spans, i) {
	        return {
	          spans: spans,
	          position: reserveSpace(spans, i)
	        };
	      }),
	      rowCount: curRow + Math.max.apply(Math, spaceTracker)
	    };
	
	    function reserveSpace(spans, i) {
	      if (spans.col > colCount) {
	        throw 'md-grid-list: Tile at position ' + i + ' has a colspan ' +
	            '(' + spans.col + ') that exceeds the column count ' +
	            '(' + colCount + ')';
	      }
	
	      var start = 0,
	          end = 0;
	
	      // TODO(shyndman): This loop isn't strictly necessary if you can
	      // determine the minimum number of rows before a space opens up. To do
	      // this, recognize that you've iterated across an entire row looking for
	      // space, and if so fast-forward by the minimum rowSpan count. Repeat
	      // until the required space opens up.
	      while (end - start < spans.col) {
	        if (curCol >= colCount) {
	          nextRow();
	          continue;
	        }
	
	        start = spaceTracker.indexOf(0, curCol);
	        if (start === -1 || (end = findEnd(start + 1)) === -1) {
	          start = end = 0;
	          nextRow();
	          continue;
	        }
	
	        curCol = end + 1;
	      }
	
	      adjustRow(start, spans.col, spans.row);
	      curCol = start + spans.col;
	
	      return {
	        col: start,
	        row: curRow
	      };
	    }
	
	    function nextRow() {
	      curCol = 0;
	      curRow++;
	      adjustRow(0, colCount, -1); // Decrement row spans by one
	    }
	
	    function adjustRow(from, cols, by) {
	      for (var i = from; i < from + cols; i++) {
	        spaceTracker[i] = Math.max(spaceTracker[i] + by, 0);
	      }
	    }
	
	    function findEnd(start) {
	      var i;
	      for (i = start; i < spaceTracker.length; i++) {
	        if (spaceTracker[i] !== 0) {
	          return i;
	        }
	      }
	
	      if (i === spaceTracker.length) {
	        return i;
	      }
	    }
	
	    function newSpaceTracker() {
	      var tracker = [];
	      for (var i = 0; i < colCount; i++) {
	        tracker.push(0);
	      }
	      return tracker;
	    }
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name mdGridTile
	 * @module material.components.gridList
	 * @restrict E
	 * @description
	 * Tiles contain the content of an `md-grid-list`. They span one or more grid
	 * cells vertically or horizontally, and use `md-grid-tile-{footer,header}` to
	 * display secondary content.
	 *
	 * ### Responsive Attributes
	 *
	 * The `md-grid-tile` directive supports "responsive" attributes, which allow
	 * different `md-rowspan` and `md-colspan` values depending on the currently
	 * matching media query.
	 *
	 * In order to set a responsive attribute, first define the fallback value with
	 * the standard attribute name, then add additional attributes with the
	 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
	 * (ie. `md-colspan-sm="4"`)
	 *
	 * @param {number=} md-colspan The number of columns to span (default 1). Cannot
	 *    exceed the number of columns in the grid. Supports interpolation.
	 * @param {number=} md-rowspan The number of rows to span (default 1). Supports
	 *     interpolation.
	 *
	 * @usage
	 * With header:
	 * <hljs lang="html">
	 * <md-grid-tile>
	 *   <md-grid-tile-header>
	 *     <h3>This is a header</h3>
	 *   </md-grid-tile-header>
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * With footer:
	 * <hljs lang="html">
	 * <md-grid-tile>
	 *   <md-grid-tile-footer>
	 *     <h3>This is a footer</h3>
	 *   </md-grid-tile-footer>
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * Spanning multiple rows/columns:
	 * <hljs lang="html">
	 * <md-grid-tile md-colspan="2" md-rowspan="3">
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * Responsive attributes:
	 * <hljs lang="html">
	 * <md-grid-tile md-colspan="1" md-colspan-sm="3" md-colspan-md="5">
	 * </md-grid-tile>
	 * </hljs>
	 */
	function GridTileDirective($mdMedia) {
	  return {
	    restrict: 'E',
	    require: '^mdGridList',
	    template: '<figure ng-transclude></figure>',
	    transclude: true,
	    scope: {},
	    // Simple controller that exposes attributes to the grid directive
	    controller: ["$attrs", function($attrs) {
	      this.$attrs = $attrs;
	    }],
	    link: postLink
	  };
	
	  function postLink(scope, element, attrs, gridCtrl) {
	    // Apply semantics
	    element.attr('role', 'listitem');
	
	    // If our colspan or rowspan changes, trigger a layout
	    var unwatchAttrs = $mdMedia.watchResponsiveAttributes(['md-colspan', 'md-rowspan'],
	        attrs, angular.bind(gridCtrl, gridCtrl.invalidateLayout));
	
	    // Tile registration/deregistration
	    gridCtrl.invalidateTiles();
	    scope.$on('$destroy', function() {
	      // Mark the tile as destroyed so it is no longer considered in layout,
	      // even if the DOM element sticks around (like during a leave animation)
	      element[0].$$mdDestroyed = true;
	      unwatchAttrs();
	      gridCtrl.invalidateLayout();
	    });
	
	    if (angular.isDefined(scope.$parent.$index)) {
	      scope.$watch(function() { return scope.$parent.$index; },
	        function indexChanged(newIdx, oldIdx) {
	          if (newIdx === oldIdx) {
	            return;
	          }
	          gridCtrl.invalidateTiles();
	        });
	    }
	  }
	}
	
	
	function GridTileCaptionDirective() {
	  return {
	    template: '<figcaption ng-transclude></figcaption>',
	    transclude: true
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.icon
	 * @description
	 * Icon
	 */
	angular.module('material.components.icon', ['material.core']);
	
	})();
	(function(){
	"use strict";
	
	angular
	  .module('material.components.icon')
	  .directive('mdIcon', ['$mdIcon', '$mdTheming', '$mdAria', '$sce', mdIconDirective]);
	
	/**
	 * @ngdoc directive
	 * @name mdIcon
	 * @module material.components.icon
	 *
	 * @restrict E
	 *
	 * @description
	 * The `md-icon` directive makes it easier to use vector-based icons in your app (as opposed to
	 * raster-based icons types like PNG). The directive supports both icon fonts and SVG icons.
	 *
	 * Icons should be considered view-only elements that should not be used directly as buttons; instead nest a `<md-icon>`
	 * inside a `md-button` to add hover and click features.
	 *
	 * ### Icon fonts
	 * Icon fonts are a technique in which you use a font where the glyphs in the font are
	 * your icons instead of text. Benefits include a straightforward way to bundle everything into a
	 * single HTTP request, simple scaling, easy color changing, and more.
	 *
	 * `md-icon` lets you consume an icon font by letting you reference specific icons in that font
	 * by name rather than character code.
	 *
	 * When using font-icons, developers must follow three (3) simple steps:
	 *
	 * <ol>
	 * <li>Load the font library. e.g.<br/>
	 *    `<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">`
	 * </li>
	 * <li>
	 *   Use either (a) font-icon class names or (b) a fontset and a font ligature to render the font glyph by
	 *   using its textual name _or_ numerical character reference. Note that `material-icons` is the default fontset when
	 *   none is specified.
	 * </li>
	 * <li> Use any of the following templates: <br/>
	 *   <ul>
	 *     <li>`<md-icon md-font-icon="classname"></md-icon>`</li>
	 *     <li>`<md-icon md-font-set="font library classname or alias">textual_name</md-icon>`</li>
	 *     <li>`<md-icon> numerical_character_reference </md-icon>`</li>
	 *     <li>`<md-icon ng_bind="'textual_name'"></md-icon>`</li>
	 *     <li>`<md-icon ng-bind="scopeVariable"></md-icon>`</li>
	 *   </ul>
	 * </li>
	 * </ol>
	 *
	 * Full details for these steps can be found in the
	 * <a href="http://google.github.io/material-design-icons/#icon-font-for-the-web" target="_blank">
	 * Material Design Icon font for the web docs</a>.
	 *
	 * You can browse and search the Material Design icon style <code>.material-icons</code>
	 * in the <a href="https://material.io/tools/icons/" target="_blank">Material Design Icons tool</a>.
	 *
	 * ### SVG
	 * For SVGs, the problem with using `<img>` or a CSS `background-image` is that you can't take
	 * advantage of some SVG features, such as styling specific parts of the icon with CSS or SVG
	 * animation.
	 *
	 * `md-icon` makes it easier to use SVG icons by *inlining* the SVG into an `<svg>` element in the
	 * document. The most straightforward way of referencing an SVG icon is via URL, just like a
	 * traditional `<img>`. `$mdIconProvider`, as a convenience, lets you _name_ an icon so you can
	 * reference it by name instead of URL throughout your templates.
	 *
	 * Additionally, you may not want to make separate HTTP requests for every icon, so you can bundle
	 * your SVG icons together and pre-load them with `$mdIconProvider` as an icon set. An icon set can
	 * also be given a name, which acts as a namespace for individual icons, so you can reference them
	 * like `"social:cake"`.
	 *
	 * When using SVGs, both external SVGs (via URLs) or sets of SVGs (from icon sets) can be
	 * easily loaded and used.
	 *
	 * ### Localization
	 *
	 * Because an `md-icon` element's text content is not intended to be translated, it is recommended
	 * to declare the text content for an `md-icon` element in its start tag. Instead of using the HTML
	 * text content, consider using `ng-bind` with a scope variable or literal string.
	 *
	 * Examples:
	 *
	 * <ul>
	 *   <li>`<md-icon ng-bind="myIconVariable"></md-icon>`</li>
	 *   <li>`<md-icon ng-bind="'menu'"></md-icon>`
	 * </ul>
	 *
	 * <h2 id="material_design_icons">Material Design Icons tool</h2>
	 * Using the Material Design Icons tool, developers can easily and quickly search for a specific
	 * open source Material Design icon. The search is in the top left. Below search, you can select
	 * from the new icon themes or filter by icon category.
	 *
	 * <a href="https://material.io/tools/icons/" target="_blank" style="border-bottom:none;">
	 * <img src="https://user-images.githubusercontent.com/3506071/41942584-ef0695d0-796d-11e8-9436-44f25023a111.png"
	 *      aria-label="Material Design Icons tool" style="max-width:95%">
	 * </a>
	 *
	 * <div class="md-caption" style="text-align: center; margin-bottom: 24px">
	 *  Click on the image above to open the
	 *  <a href="https://material.io/tools/icons/" target="_blank">Material Design Icons tool</a>.
	 * </div>
	 *
	 * Click on any icon, then click on the "Selected Icon" chevron to see the slide-up
	 * information panel with details regarding a SVG download and information on the font-icon's
	 * textual name. This panel also allows you to select a black on transparent or white on transparent
	 * icon and to change the icon size. These settings only affect the downloaded icons.
	 *
	 * @param {string} md-font-icon String name of CSS icon associated with the font-face will be used
	 *  to render the icon. Requires the fonts and the named CSS styles to be preloaded.
	 * @param {string} md-font-set CSS style name associated with the font library; which will be assigned as
	 *  the class for the font-icon ligature. This value may also be an alias that is used to lookup the classname;
	 *  internally use `$mdIconProvider.fontSet(<alias>)` to determine the style name.
	 * @param {string} md-svg-src String URL (or expression) used to load, cache, and display an
	 *  external SVG.
	 * @param {string} md-svg-icon md-svg-icon String name used for lookup of the icon from the internal cache;
	 *  interpolated strings or expressions may also be used. Specific set names can be used with
	 *  the syntax `<set name>:<icon name>`.<br/><br/>
	 *  To use icon sets, developers are required to pre-register the sets using the `$mdIconProvider` service.
	 * @param {string=} aria-label Labels the icon for accessibility. If an empty string is provided,
	 *  the icon will be hidden from the accessibility layer with `aria-hidden="true"`. If there is no
	 *  `aria-label` attribute on the icon, we check the following, in order: the `alt` attribute, the
	 *  `aria-label` from the parent element, the icon's `md-font-icon` or `md-svg-icon` string, and the
	 *  text content inside `<md-icon></md-icon>`. If none of these have any text, the icon is hidden
	 *  from the accessibility layer with `aria-hidden="true"`.
	 * @param {string=} alt Labels the icon for accessibility. If an empty string is provided and the
	 *  icon has no `aria-label`, then the icon will be hidden from accessibility layer with
	 *  `aria-hidden="true"`.
	 *
	 * @usage
	 * When using SVGs:
	 * <hljs lang="html">
	 *
	 *<!-- Icon ID; may contain optional icon set prefix.
	 *     Icons must be registered using $mdIconProvider. -->
	 *<md-icon md-svg-icon="social:android"    aria-label="android " ></md-icon>
	 *
	 *<!-- Icon urls; may be preloaded in templateCache -->
	 *<md-icon md-svg-src="/android.svg"       aria-label="android " ></md-icon>
	 *<md-icon md-svg-src="{{ getAndroid() }}" aria-label="android " ></md-icon>
	 *
	 * </hljs>
	 *
	 * Use the <code>$mdIconProvider</code> to configure your application with
	 * SVG icon sets.
	 *
	 * <hljs lang="js">
	 * angular.module('appSvgIconSets', ['ngMaterial'])
	 *   .controller('DemoCtrl', function($scope) {})
	 *   .config(function($mdIconProvider) {
	 *     $mdIconProvider
	 *       .iconSet('social', 'img/icons/sets/social-icons.svg', 24)
	 *       .defaultIconSet('img/icons/sets/core-icons.svg', 24);
	 *    });
	 * </hljs>
	 *
	 *
	 * When using Font Icons with classnames:
	 * <hljs lang="html">
	 *
	 * <md-icon md-font-icon="android" aria-label="android" ></md-icon>
	 * <md-icon class="icon_home" aria-label="Home"></md-icon>
	 *
	 * </hljs>
	 *
	 * When using Material Font Icons with ligatures:
	 * <hljs lang="html">
	 *  <!--
	 *  For Material Design Icons
	 *  The class '.material-icons' is auto-added if a style has NOT been specified
	 *  since `material-icons` is the default fontset. So your markup:
	 *  -->
	 *  <md-icon> face </md-icon>
	 *  <!-- becomes this at runtime: -->
	 *  <md-icon md-font-set="material-icons"> face </md-icon>
	 *  <!-- If the fontset does not support ligature names, then we need to use the ligature unicode.-->
	 *  <md-icon> &#xE87C; </md-icon>
	 *  <!-- The class '.material-icons' must be manually added if other styles are also specified-->
	 *  <md-icon class="material-icons md-light md-48"> face </md-icon>
	 * </hljs>
	 *
	 * When using other Font-Icon libraries:
	 *
	 * <hljs lang="js">
	 *  // Specify a font-icon style alias
	 *  angular.config(function($mdIconProvider) {
	 *    $mdIconProvider.fontSet('md', 'material-icons');
	 *  });
	 * </hljs>
	 *
	 * <hljs lang="html">
	 *  <md-icon md-font-set="md">favorite</md-icon>
	 * </hljs>
	 *
	 */
	function mdIconDirective($mdIcon, $mdTheming, $mdAria, $sce) {
	
	  return {
	    restrict: 'E',
	    link : postLink
	  };
	
	
	  /**
	   * Directive postLink
	   * Supports embedded SVGs, font-icons, & external SVGs.
	   * @param {IScope} scope
	   * @param {JQLite} element
	   * @param {IAttributes} attr
	   */
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	    var lastFontIcon = attr.mdFontIcon;
	    var lastFontSet = $mdIcon.fontSet(attr.mdFontSet);
	
	    prepareForFontIcon();
	
	    attr.$observe('mdFontIcon', fontIconChanged);
	    attr.$observe('mdFontSet', fontIconChanged);
	
	    /* Provide a default accessibility role of img */
	    if (!attr.role) {
	      $mdAria.expect(element, 'role', 'img');
	      /* manually update attr variable */
	      attr.role = 'img';
	    }
	
	    // If the aria-label is explicitly set to the empty string, then hide this element from the
	    // accessibility layer.
	    if (element[0].hasAttribute('aria-label') && attr.ariaLabel === '') {
	      element.attr('aria-hidden', true);
	    }
	
	    /* Don't process ARIA if already valid */
	    if (attr.role === "img" && !attr.ariaHidden && !$mdAria.hasAriaLabel(element)) {
	      // If the developer signals to hide this icon from the accessibility layer, do so.
	      if (element[0].hasAttribute('alt') && attr.alt === '') {
	        element.attr('aria-hidden', true);
	      } else if (attr.alt) {
	        /* Use the alt text for the aria-label by default, if available. */
	        $mdAria.expect(element, 'aria-label', attr.alt);
	      } else if ($mdAria.parentHasAriaLabel(element, 2)) {
	        /* Parent has ARIA so we will assume it will describe the icon. */
	        $mdAria.expect(element, 'aria-hidden', 'true');
	      } else if (attr.mdFontIcon || attr.mdSvgIcon || element.text()) {
	        /* Use icon name or node's text content as the aria-label */
	        $mdAria.expect(element, 'aria-label', attr.mdFontIcon || attr.mdSvgIcon || element.text());
	      } else {
	        /* No label found, hide this icon from the accessibility layer */
	        $mdAria.expect(element, 'aria-hidden', 'true');
	      }
	    }
	
	    var attrName = attr.$normalize(attr.$attr.mdSvgIcon || attr.$attr.mdSvgSrc || '');
	    if (attrName) {
	      // Use either pre-configured SVG or URL source, respectively.
	      attr.$observe(attrName, function(attrVal) {
	        element.empty();
	        if (attrVal) {
	          $mdIcon(attrVal)
	            .then(function(svg) {
	            element.empty();
	            element.append(svg);
	          });
	        }
	      });
	    }
	
	    function prepareForFontIcon() {
	      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
	        if (attr.mdFontIcon) {
	          element.addClass('md-font ' + attr.mdFontIcon);
	        }
	
	        element.addClass(lastFontSet);
	      }
	    }
	
	    function fontIconChanged() {
	      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
	        if (attr.mdFontIcon) {
	          element.removeClass(lastFontIcon);
	          element.addClass(attr.mdFontIcon);
	
	          lastFontIcon = attr.mdFontIcon;
	        }
	
	        var fontSet = $mdIcon.fontSet(attr.mdFontSet);
	
	        if (lastFontSet !== fontSet) {
	          element.removeClass(lastFontSet);
	          element.addClass(fontSet);
	
	          lastFontSet = fontSet;
	        }
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	  
	MdIconService.$inject = ["config", "$templateRequest", "$q", "$log", "$mdUtil", "$sce"];angular
	    .module('material.components.icon')
	    .constant('$$mdSvgRegistry', {
	        'mdTabsArrow':   'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwb2x5Z29uIHBvaW50cz0iMTUuNCw3LjQgMTQsNiA4LDEyIDE0LDE4IDE1LjQsMTYuNiAxMC44LDEyICIvPjwvZz48L3N2Zz4=',
	        'mdClose':       'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=',
	        'mdCancel':      'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xMiAyYy01LjUzIDAtMTAgNC40Ny0xMCAxMHM0LjQ3IDEwIDEwIDEwIDEwLTQuNDcgMTAtMTAtNC40Ny0xMC0xMC0xMHptNSAxMy41OWwtMS40MSAxLjQxLTMuNTktMy41OS0zLjU5IDMuNTktMS40MS0xLjQxIDMuNTktMy41OS0zLjU5LTMuNTkgMS40MS0xLjQxIDMuNTkgMy41OSAzLjU5LTMuNTkgMS40MSAxLjQxLTMuNTkgMy41OSAzLjU5IDMuNTl6Ii8+PC9nPjwvc3ZnPg==',
	        'mdMenu':        'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0zLDZIMjFWOEgzVjZNMywxMUgyMVYxM0gzVjExTTMsMTZIMjFWMThIM1YxNloiIC8+PC9zdmc+',
	        'mdToggleArrow': 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiPjxwYXRoIGQ9Ik0yNCAxNmwtMTIgMTIgMi44MyAyLjgzIDkuMTctOS4xNyA5LjE3IDkuMTcgMi44My0yLjgzeiIvPjxwYXRoIGQ9Ik0wIDBoNDh2NDhoLTQ4eiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg==',
	        'mdCalendar':    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkgM2gtMVYxaC0ydjJIOFYxSDZ2Mkg1Yy0xLjExIDAtMS45OS45LTEuOTkgMkwzIDE5YzAgMS4xLjg5IDIgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjVjMC0xLjEtLjktMi0yLTJ6bTAgMTZINVY4aDE0djExek03IDEwaDV2NUg3eiIvPjwvc3ZnPg==',
	        'mdChecked':     'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik05IDE2LjE3TDQuODMgMTJsLTEuNDIgMS40MUw5IDE5IDIxIDdsLTEuNDEtMS40MXoiLz48L2c+PC9zdmc+'
	    })
	    .provider('$mdIcon', MdIconProvider);
	
	/**
	 * @ngdoc service
	 * @name $mdIconProvider
	 * @module material.components.icon
	 *
	 * @description
	 * `$mdIconProvider` is used only to register icon IDs with URLs. These configuration features allow
	 * icons and icon sets to be pre-registered and associated with source URLs **before** the
	 * `<md-icon />` directives are compiled.
	 *
	 * If using font-icons, the developer is responsible for loading the fonts.
	 *
	 * If using SVGs, loading of the actual svg files are deferred to on-demand requests and are loaded
	 * internally by the `$mdIcon` service using the `$templateRequest` service. When an SVG is
	 * requested by name/ID, the `$mdIcon` service searches its registry for the associated source URL;
	 * that URL is used to on-demand load and parse the SVG dynamically.
	 *
	 * The `$templateRequest` service expects the icons source to be loaded over trusted URLs.<br/>
	 * This means, when loading icons from an external URL, you have to trust the URL in the
	 * `$sceDelegateProvider`.
	 *
	 * <hljs lang="js">
	 *   app.config(function($sceDelegateProvider) {
	 *     $sceDelegateProvider.trustedResourceUrlList([
	 *       // Adding 'self' to the allow-list, will allow requests from the current origin.
	 *       'self',
	 *       // Using double asterisks here, will allow all URLs to load.
	 *       // However, we recommend only specifying the given domain you want to allow.
	 *       '**'
	 *     ]);
	 *   });
	 * </hljs>
	 *
	 * Read more about the [$sceDelegateProvider](https://docs.angularjs.org/api/ng/provider/$sceDelegateProvider).
	 *
	 * **Notice:** Most font-icon libraries do not support ligatures (for example `fontawesome`).<br/>
	 *  In such cases you are not able to use the icon's ligature name - Like so:
	 *
	 *  <hljs lang="html">
	 *    <md-icon md-font-set="fa">fa-bell</md-icon>
	 *  </hljs>
	 *
	 * You should instead use the given unicode, instead of the ligature name.
	 *
	 * <p ng-hide="true"> ##// Notice we can't use a hljs element here, because the characters will be escaped.</p>
	 *  ```html
	 *    <md-icon md-font-set="fa">&#xf0f3</md-icon>
	 *  ```
	 *
	 * All unicode ligatures are prefixed with the `&#x` string.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	 *
	 *     // Configure URLs for icons specified by [set:]id.
	 *     $mdIconProvider
	 *       .defaultFontSet( 'fa' )                   // This sets our default fontset className.
	 *       .defaultIconSet('my/app/icons.svg')       // Register a default set of SVG icons
	 *       .iconSet('social', 'my/app/social.svg')   // Register a named icon set of SVGs
	 *       .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
	 *       .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
	 *   });
	 * </hljs>
	 *
	 * SVG icons and icon sets can be easily pre-loaded and cached using either (a) a build process or
	 * (b) a runtime **startup** process (shown below):
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	 *
	 *     // Register a default set of SVG icon definitions
	 *     $mdIconProvider.defaultIconSet('my/app/icons.svg')
	 *   })
	 *   .run(function($templateRequest) {
	 *
	 *     // Pre-fetch icons sources by URL and cache in the $templateCache...
	 *     // subsequent $templateRequest calls will look there first.
	 *     var urls = [ 'imy/app/icons.svg', 'img/icons/android.svg'];
	 *
	 *     angular.forEach(urls, function(url) {
	 *       $templateRequest(url);
	 *     });
	 *   });
	 *
	 * </hljs>
	 *
	 * > <b>Note:</b> The loaded SVG data is subsequently cached internally for future requests.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#icon
	 *
	 * @description
	 * Register a source URL for a specific icon name; the name may include optional 'icon set' name
	 * prefix. These icons will later be retrieved from the cache using `$mdIcon(<icon name>)`.
	 *
	 * @param {string} id Icon name/id used to register the icon
	 * @param {string} url specifies the external location for the data file. Used internally by
	 *  `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 *  was configured.
	 * @param {number=} viewBoxSize Sets the width and height the icon's viewBox.
	 *  It is ignored for icons with an existing viewBox. Default size is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	 *
	 *     // Configure URLs for icons specified by [set:]id.
	 *     $mdIconProvider
	 *       .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
	 *       .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
	 *   });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#iconSet
	 *
	 * @description
	 * Register a source URL for a 'named' set of icons; group of SVG definitions where each definition
	 * has an icon id. Individual icons can be subsequently retrieved from this cached set using
	 * `$mdIcon(<icon set name>:<icon name>)`
	 *
	 * @param {string} id Icon name/id used to register the iconset
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
	 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
	 * Default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	 *
	 *     // Configure URLs for icons specified by [set:]id.
	 *     $mdIconProvider
	 *       .iconSet('social', 'my/app/social.svg');   // Register a named icon set
	 *   });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultIconSet
	 *
	 * @description
	 * Register a source URL for the default 'named' set of icons. Unless explicitly registered,
	 * subsequent lookups of icons will fail over to search this 'default' icon set.
	 * Icon can be retrieved from this cached, default set using `$mdIcon(<name>)`
	 *
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
	 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same
	 * size. Default value is 24.
	 *
	 * @returns {Object} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	 *
	 *     // Configure URLs for icons specified by [set:]id.
	 *     $mdIconProvider
	 *       .defaultIconSet('my/app/social.svg');   // Register a default icon set
	 *   });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultFontSet
	 *
	 * @description
	 * When using Font-Icons, AngularJS Material assumes the the Material Design icons will be used and
	 * automatically configures the default `font-set == 'material-icons'`. Note that the font-set
	 * references the font-icon library class style that should be applied to the `<md-icon>`.
	 *
	 * Configuring the default means that the attributes
	 * `md-font-set="material-icons"` or `class="material-icons"` do not need to be explicitly declared
	 * on the `<md-icon>` markup.
	 *
	 * For example:<br/>
	 * `<md-icon>face</md-icon>` will render as `<span class="material-icons">face</span>`,<br/>
	 * and<br/>
	 * `<md-icon md-font-set="fa">face</md-icon>` will render as `<span class="fa">face</span>`
	 *
	 * @param {string} name Name of the font-library style that should be applied to the md-icon DOM
	 *  element.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	 *     $mdIconProvider.defaultFontSet('fa');
	 *   });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#fontSet
	 *
	 * @description
	 * When using a font-set for `<md-icon>` you must specify the correct font classname in the
	 * `md-font-set` attribute. If the font-set className is really long, your markup may become
	 * cluttered... an easy solution is to define an `alias` for your font-set:
	 *
	 * @param {string} alias Alias name of the specified font-set.
	 * @param {string} className Name of the class for the font-set.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	 *     // In this case, we set an alias for the `material-icons` font-set.
	 *     $mdIconProvider.fontSet('md', 'material-icons');
	 *   });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultViewBoxSize
	 *
	 * @description
	 * While `<md-icon>` markup can also be styled with sizing CSS, this method configures
	 * the default width **and** height used for all icons; unless overridden by specific CSS.
	 * The default sizing is (`24px`, `24px`).
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox for an icon or an icon set.
	 * All icons in a set should be the same size. The default value is 24.
	 *
	 * @returns {Object} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	 *
	 *     // Configure URLs for icons specified by [set:]id.
	 *     $mdIconProvider
	 *       .defaultViewBoxSize(36);   // Register a default icon size (width == height)
	 *   });
	 * </hljs>
	 */
	
	var config = {
	  defaultViewBoxSize: 24,
	  defaultFontSet: 'material-icons',
	  fontSets: []
	};
	
	function MdIconProvider() {
	}
	
	MdIconProvider.prototype = {
	  icon: function(id, url, viewBoxSize) {
	    if (id.indexOf(':') == -1) id = '$default:' + id;
	
	    config[id] = new ConfigurationItem(url, viewBoxSize);
	    return this;
	  },
	
	  iconSet: function(id, url, viewBoxSize) {
	    config[id] = new ConfigurationItem(url, viewBoxSize);
	    return this;
	  },
	
	  defaultIconSet: function(url, viewBoxSize) {
	    var setName = '$default';
	
	    if (!config[setName]) {
	      config[setName] = new ConfigurationItem(url, viewBoxSize);
	    }
	
	    config[setName].viewBoxSize = viewBoxSize || config.defaultViewBoxSize;
	
	    return this;
	  },
	
	  defaultViewBoxSize: function(viewBoxSize) {
	    config.defaultViewBoxSize = viewBoxSize;
	    return this;
	  },
	
	  /**
	   * Register an alias name associated with a font-icon library style ;
	   */
	  fontSet: function fontSet(alias, className) {
	    config.fontSets.push({
	      alias: alias,
	      fontSet: className || alias
	    });
	    return this;
	  },
	
	  /**
	   * Specify a default style name associated with a font-icon library
	   * fallback to Material Icons.
	   *
	   */
	  defaultFontSet: function defaultFontSet(className) {
	    config.defaultFontSet = !className ? '' : className;
	    return this;
	  },
	
	  defaultIconSize: function defaultIconSize(iconSize) {
	    config.defaultIconSize = iconSize;
	    return this;
	  },
	
	  $get: ['$templateRequest', '$q', '$log', '$mdUtil', '$sce', function($templateRequest, $q, $log, $mdUtil, $sce) {
	    return MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce);
	  }]
	};
	
	  /**
	   * Configuration item stored in the Icon registry; used for lookups
	   * to load if not already cached in the `loaded` cache
	   * @param {string} url
	   * @param {=number} viewBoxSize
	   * @constructor
	   */
	  function ConfigurationItem(url, viewBoxSize) {
	    this.url = url;
	    this.viewBoxSize = viewBoxSize || config.defaultViewBoxSize;
	  }
	
	/**
	 * @ngdoc service
	 * @name $mdIcon
	 * @module material.components.icon
	 *
	 * @description
	 * The `$mdIcon` service is a function used to lookup SVG icons.
	 *
	 * @param {string} id Query value for a unique Id or URL. If the argument is a URL, then the service will retrieve the icon element
	 * from its internal cache or load the icon and cache it first. If the value is not a URL-type string, then an ID lookup is
	 * performed. The Id may be a unique icon ID or may include an iconSet ID prefix.
	 *
	 * For the **id** query to work properly, this means that all id-to-URL mappings must have been previously configured
	 * using the `$mdIconProvider`.
	 *
	 * @returns {angular.$q.Promise} A promise that gets resolved to a clone of the initial SVG DOM element; which was
	 * created from the SVG markup in the SVG data file. If an error occurs (e.g. the icon cannot be found) the promise
	 * will get rejected.
	 *
	 * @usage
	 * <hljs lang="js">
	 * function SomeDirective($mdIcon) {
	 *
	 *   // See if the icon has already been loaded, if not then lookup the icon from the
	 *   // registry cache, load and cache it for future requests.
	 *   // NOTE: Non-URL queries require configuration with $mdIconProvider.
	 *   $mdIcon('android').then(function(iconEl)    { element.append(iconEl); });
	 *   $mdIcon('work:chair').then(function(iconEl) { element.append(iconEl); });
	 *
	 *   // Load and cache the external SVG using a URL.
	 *   $mdIcon('img/icons/android.svg').then(function(iconEl) {
	 *     element.append(iconEl);
	 *   });
	 * };
	 * </hljs>
	 *
	 * > <b>Note:</b> The `<md-icon>` directive internally uses the `$mdIcon` service to query, load,
	 *   and instantiate SVG DOM elements.
	 */
	
	/* @ngInject */
	function MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce) {
	  var iconCache = {};
	  var svgCache = {};
	  var urlRegex = /[-\w@:%+.~#?&//=]{2,}\.[a-z]{2,4}\b(\/[-\w@:%+.~#?&//=]*)?/i;
	  var dataUrlRegex = /^data:image\/svg\+xml[\s*;\w\-=]*?(base64)?,(.*)$/i;
	
	  Icon.prototype = {clone: cloneSVG, prepare: prepareAndStyle};
	  getIcon.fontSet = findRegisteredFontSet;
	
	  // Publish service...
	  return getIcon;
	
	  /**
	   * Actual $mdIcon service is essentially a lookup function
	   * @param {*} id $sce trust wrapper over a URL string, URL, icon registry id, or icon set id
	   * @returns {angular.$q.Promise}
	   */
	  function getIcon(id) {
	    id = id || '';
	
	    // If the "id" provided is not a string, the only other valid value is a $sce trust wrapper
	    // over a URL string. If the value is not trusted, this will intentionally throw an error
	    // because the user is attempted to use an unsafe URL, potentially opening themselves up
	    // to an XSS attack.
	    if (!angular.isString(id)) {
	      id = $sce.getTrustedUrl(id);
	    }
	
	    // If already loaded and cached, use a clone of the cached icon.
	    // Otherwise either load by URL, or lookup in the registry and then load by URL, and cache.
	
	    if (iconCache[id]) {
	      return $q.when(transformClone(iconCache[id]));
	    }
	
	    if (urlRegex.test(id) || dataUrlRegex.test(id)) {
	      return loadByURL(id).then(cacheIcon(id));
	    }
	
	    if (id.indexOf(':') === -1) {
	      id = '$default:' + id;
	    }
	
	    var load = config[id] ? loadByID : loadFromIconSet;
	    return load(id)
	      .then(cacheIcon(id));
	  }
	
	  /**
	   * Lookup a registered fontSet style using its alias.
	   * @param {string} alias used to lookup the alias in the array of fontSets
	   * @returns {*} matching fontSet or the defaultFontSet if that alias does not match
	   */
	  function findRegisteredFontSet(alias) {
	    var useDefault = angular.isUndefined(alias) || !(alias && alias.length);
	    if (useDefault) {
	      return config.defaultFontSet;
	    }
	
	    var result = alias;
	    angular.forEach(config.fontSets, function(fontSet) {
	      if (fontSet.alias === alias) {
	        result = fontSet.fontSet || result;
	      }
	    });
	
	    return result;
	  }
	
	  /**
	   * @param {!Icon} cacheElement cached icon from the iconCache
	   * @returns {Icon} cloned Icon element with unique ids
	   */
	  function transformClone(cacheElement) {
	    var clone = cacheElement.clone();
	    var newUid = $mdUtil.nextUid();
	    var cacheSuffix, svgUrlQuerySelector, i, xlinkHrefValue;
	    // These are SVG attributes that can reference element ids.
	    var svgUrlAttributes = [
	      'clip-path', 'color-profile', 'cursor', 'fill', 'filter', 'href', 'marker-start',
	      'marker-mid', 'marker-end', 'mask', 'stroke', 'style', 'vector-effect'
	    ];
	    var isIeSvg = clone.innerHTML === undefined;
	
	    // Verify that the newUid only contains a number and not some XSS content.
	    if (!isFinite(Number(newUid))) {
	      throw new Error('Unsafe and unexpected non-number result from $mdUtil.nextUid().');
	    }
	    cacheSuffix = '_cache' + newUid;
	
	    // For each cached icon, we need to modify the id attributes and references.
	    // This is needed because SVG ids are treated as normal DOM ids and should not be duplicated on
	    // the page.
	    if (clone.id) {
	      clone.id += cacheSuffix;
	    }
	
	    // Do as much as possible with querySelectorAll as it provides much greater performance
	    // than RegEx against serialized DOM.
	    angular.forEach(clone.querySelectorAll('[id]'), function(descendantElem) {
	      svgUrlQuerySelector = '';
	      for (i = 0; i < svgUrlAttributes.length; i++) {
	        svgUrlQuerySelector += '[' + svgUrlAttributes[i] + '="url(#' + descendantElem.id + ')"]';
	        if (i + 1 < svgUrlAttributes.length) {
	          svgUrlQuerySelector += ', ';
	        }
	      }
	      // Append the cacheSuffix to references of the element's id within url(#id) calls.
	      angular.forEach(clone.querySelectorAll(svgUrlQuerySelector), function(refItem) {
	        updateSvgIdReferences(descendantElem, refItem, isIeSvg, newUid);
	      });
	      // Handle usages of url(#id) in the SVG's stylesheets
	      angular.forEach(clone.querySelectorAll('style'), function(refItem) {
	        updateSvgIdReferences(descendantElem, refItem, isIeSvg, newUid);
	      });
	
	      // Update ids referenced by the deprecated (in SVG v2) xlink:href XML attribute. The now
	      // preferred href attribute is handled above. However, this non-standard XML namespaced
	      // attribute cannot be handled in the same way. Explanation of this query selector here:
	      // https://stackoverflow.com/q/23034283/633107.
	      angular.forEach(clone.querySelectorAll('[*|href]:not([href])'), function(refItem) {
	        xlinkHrefValue = refItem.getAttribute('xlink:href');
	        if (xlinkHrefValue) {
	          xlinkHrefValue = xlinkHrefValue.replace("#" + descendantElem.id, "#" + descendantElem.id + cacheSuffix);
	          refItem.setAttribute('xlink:href', xlinkHrefValue);
	        }
	      });
	
	      descendantElem.id += cacheSuffix;
	    });
	
	    return clone;
	  }
	
	  /**
	   * @param {Element} referencedElement element w/ id that needs to be updated
	   * @param {Element} referencingElement element that references the original id
	   * @param {boolean} isIeSvg true if we're dealing with an SVG in IE11, false otherwise
	   * @param {string} newUid the cache id to add as part of the cache suffix
	   */
	  function updateSvgIdReferences(referencedElement, referencingElement, isIeSvg, newUid) {
	    var svgElement, cacheSuffix;
	
	    // Verify that the newUid only contains a number and not some XSS content.
	    if (!isFinite(Number(newUid))) {
	      throw new Error('Unsafe and unexpected non-number result for newUid.');
	    }
	    cacheSuffix = '_cache' + newUid;
	
	    // outerHTML of SVG elements is not supported by IE11
	    if (isIeSvg) {
	      svgElement = $mdUtil.getOuterHTML(referencingElement);
	      svgElement = svgElement.replace("url(#" + referencedElement.id + ")",
	        "url(#" + referencedElement.id + cacheSuffix + ")");
	      referencingElement.textContent = angular.element(svgElement)[0].innerHTML;
	    } else {
	      // This use of outerHTML should be safe from XSS attack since we are only injecting the
	      // cacheSuffix with content from $mdUtil.nextUid which we verify is a finite number above.
	      referencingElement.outerHTML = referencingElement.outerHTML.replace(
	        "url(#" + referencedElement.id + ")",
	        "url(#" + referencedElement.id + cacheSuffix + ")");
	    }
	  }
	
	  /**
	   * Prepare and cache the loaded icon for the specified `id`.
	   * @param {string} id icon cache id
	   * @returns {function(*=): *}
	   */
	  function cacheIcon(id) {
	
	    return function updateCache(icon) {
	      iconCache[id] = isIcon(icon) ? icon : new Icon(icon, config[id]);
	
	      return transformClone(iconCache[id]);
	    };
	  }
	
	  /**
	   * Lookup the configuration in the registry, if !registered throw an error
	   * otherwise load the icon [on-demand] using the registered URL.
	   * @param {string} id icon registry id
	   * @returns {angular.$q.Promise}
	   */
	  function loadByID(id) {
	    var iconConfig = config[id];
	    return loadByURL(iconConfig.url).then(function(icon) {
	      return new Icon(icon, iconConfig);
	    });
	  }
	
	  /**
	   * Loads the file as XML and uses querySelector( <id> ) to find the desired node...
	   * @param {string} id icon id in icon set
	   * @returns {angular.$q.Promise}
	   */
	  function loadFromIconSet(id) {
	    var setName = id.substring(0, id.lastIndexOf(':')) || '$default';
	    var iconSetConfig = config[setName];
	
	    return !iconSetConfig ? announceIdNotFound(id) : loadByURL(iconSetConfig.url).then(extractFromSet);
	
	    function extractFromSet(set) {
	      var iconName = id.slice(id.lastIndexOf(':') + 1);
	      var icon = set.querySelector('#' + iconName);
	      return icon ? new Icon(icon, iconSetConfig) : announceIdNotFound(id);
	    }
	
	    function announceIdNotFound(id) {
	      var msg = 'icon ' + id + ' not found';
	      $log.warn(msg);
	
	      return $q.reject(msg || id);
	    }
	  }
	
	  /**
	   * Load the icon by URL (may use the $templateCache).
	   * Extract the data for later conversion to Icon
	   * @param {string} url icon URL
	   * @returns {angular.$q.Promise}
	   */
	  function loadByURL(url) {
	    /* Load the icon from embedded data URL. */
	    function loadByDataUrl(url) {
	      var results = dataUrlRegex.exec(url);
	      var isBase64 = /base64/i.test(url);
	      var data = isBase64 ? window.atob(results[2]) : results[2];
	
	      return $q.when(angular.element(data)[0]);
	    }
	
	    /* Load the icon by URL using HTTP. */
	    function loadByHttpUrl(url) {
	      return $q(function(resolve, reject) {
	        // Catch HTTP or generic errors not related to incorrect icon IDs.
	        var announceAndReject = function(err) {
	            var msg = angular.isString(err) ? err : (err.message || err.data || err.statusText);
	            $log.warn(msg);
	            reject(err);
	          },
	          extractSvg = function(response) {
	            if (!svgCache[url]) {
	              svgCache[url] = angular.element('<div>').append(response)[0].querySelector('svg');
	            }
	            resolve(svgCache[url]);
	          };
	
	        $templateRequest(url, true).then(extractSvg, announceAndReject);
	      });
	    }
	
	    return dataUrlRegex.test(url)
	      ? loadByDataUrl(url)
	      : loadByHttpUrl(url);
	  }
	
	  /**
	   * Check target signature to see if it is an Icon instance.
	   * @param {Icon|Element} target
	   * @returns {boolean} true if the specified target is an Icon object, false otherwise.
	   */
	  function isIcon(target) {
	    return angular.isDefined(target.element) && angular.isDefined(target.config);
	  }
	
	  /**
	   * Define the Icon class
	   * @param {Element} el
	   * @param {=ConfigurationItem} config
	   * @constructor
	   */
	  function Icon(el, config) {
	    // If the node is a <symbol>, it won't be rendered so we have to convert it into <svg>.
	    if (el && el.tagName.toLowerCase() === 'symbol') {
	      var viewbox = el.getAttribute('viewBox');
	      // // Check if innerHTML is supported as IE11 does not support innerHTML on SVG elements.
	      if (el.innerHTML) {
	        el = angular.element('<svg xmlns="http://www.w3.org/2000/svg">')
	          .html(el.innerHTML)[0];
	      } else {
	        el = angular.element('<svg xmlns="http://www.w3.org/2000/svg">')
	          .append($mdUtil.getInnerHTML(el))[0];
	      }
	      if (viewbox) el.setAttribute('viewBox', viewbox);
	    }
	
	    if (el && el.tagName.toLowerCase() !== 'svg') {
	      el = angular.element(
	        '<svg xmlns="http://www.w3.org/2000/svg">').append(el.cloneNode(true))[0];
	    }
	
	    // Inject the namespace if not available...
	    if (!el.getAttribute('xmlns')) {
	      el.setAttribute('xmlns', "http://www.w3.org/2000/svg");
	    }
	
	    this.element = el;
	    this.config = config;
	    this.prepare();
	  }
	
	  /**
	   *  Prepare the DOM element that will be cached in the
	   *  loaded iconCache store.
	   */
	  function prepareAndStyle() {
	    var viewBoxSize = this.config ? this.config.viewBoxSize : config.defaultViewBoxSize;
	    angular.forEach({
	      'fit': '',
	      'height': '100%',
	      'width': '100%',
	      'preserveAspectRatio': 'xMidYMid meet',
	      'viewBox': this.element.getAttribute('viewBox') || ('0 0 ' + viewBoxSize + ' ' + viewBoxSize),
	      'focusable': false // Disable IE11s default behavior to make SVGs focusable
	    }, function(val, attr) {
	      this.element.setAttribute(attr, val);
	    }, this);
	  }
	
	  /**
	   * Clone the Icon DOM element.
	   */
	  function cloneSVG() {
	    // If the element or any of its children have a style attribute, then a CSP policy without
	    // 'unsafe-inline' in the style-src directive, will result in a violation.
	    return this.element.cloneNode(true);
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.input
	 */
	mdInputContainerDirective.$inject = ["$mdTheming", "$parse", "$$rAF"];
	inputTextareaDirective.$inject = ["$mdUtil", "$window", "$mdAria", "$timeout", "$mdGesture"];
	mdMaxlengthDirective.$inject = ["$animate", "$mdUtil"];
	placeholderDirective.$inject = ["$compile"];
	ngMessageDirective.$inject = ["$mdUtil"];
	mdSelectOnFocusDirective.$inject = ["$document", "$timeout"];
	mdInputInvalidMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil"];
	ngMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil"];
	ngMessageAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
	var inputModule = angular.module('material.components.input', [
	    'material.core'
	  ])
	  .directive('mdInputContainer', mdInputContainerDirective)
	  .directive('label', labelDirective)
	  .directive('input', inputTextareaDirective)
	  .directive('textarea', inputTextareaDirective)
	  .directive('mdMaxlength', mdMaxlengthDirective)
	  .directive('placeholder', placeholderDirective)
	  .directive('ngMessages', ngMessagesDirective)
	  .directive('ngMessage', ngMessageDirective)
	  .directive('ngMessageExp', ngMessageDirective)
	  .directive('mdSelectOnFocus', mdSelectOnFocusDirective)
	
	  .animation('.md-input-invalid', mdInputInvalidMessagesAnimation)
	  .animation('.md-input-messages-animation', ngMessagesAnimation)
	  .animation('.md-input-message-animation', ngMessageAnimation);
	
	// If we are running inside of tests; expose some extra services so that we can test them
	if (window._mdMocksIncluded) {
	  inputModule.service('$$mdInput', function() {
	    return {
	      // special accessor to internals... useful for testing
	      messages: {
	        getElement  : getMessagesElement
	      }
	    };
	  })
	
	  // Register a service for each animation so that we can easily inject them into unit tests
	  .service('mdInputInvalidAnimation', mdInputInvalidMessagesAnimation)
	  .service('mdInputMessagesAnimation', ngMessagesAnimation)
	  .service('mdInputMessageAnimation', ngMessageAnimation);
	}
	
	/**
	 * @ngdoc directive
	 * @name mdInputContainer
	 * @module material.components.input
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-input-container>` is the parent of any input or textarea element. It can also optionally
	 * wrap `<md-select>` elements so that they will be formatted for use in a form.
	 *
	 * Input and textarea elements will not behave properly unless the md-input-container parent is
	 * provided.
	 *
	 * A single `<md-input-container>` should contain only one `<input>` or `<md-select>` element,
	 * otherwise it will throw an error.
	 *
	 * <b>Exception:</b> Hidden inputs (`<input type="hidden" />`) are ignored and will not throw an
	 * error, so you may combine these with other inputs.
	 *
	 * <b>Note:</b> When using `ngMessages` with your input element, make sure the message and container
	 * elements are *block* elements, otherwise animations applied to the messages will not look as
	 * intended. Either use a `div` and apply the `ng-message` and `ng-messages` classes respectively,
	 * or use the `md-block` class on your element.
	 *
	 * @param {expression=} md-is-error When the given expression evaluates to `true`, the input
	 *   container will go into the error state. Defaults to erroring if the input has been touched and
	 *   is invalid.
	 * @param {boolean=} md-no-float When present, `placeholder` attributes on the input will not be
	 *   converted to floating labels.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-input-container>
	 *   <label>Username</label>
	 *   <input type="text" ng-model="user.name">
	 * </md-input-container>
	 *
	 * <md-input-container>
	 *   <label>Description</label>
	 *   <textarea ng-model="user.description"></textarea>
	 * </md-input-container>
	 *
	 * <md-input-container>
	 *   <md-select ng-model="user.state" placeholder="State of Residence">
	 *     <md-option ng-value="state" ng-repeat="state in states">{{ state }}</md-option>
	 *   </md-select>
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>When disabling floating labels</h3>
	 * <hljs lang="html">
	 * <md-input-container md-no-float>
	 *   <input type="text" placeholder="Non-Floating Label">
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>Aligning Form Elements</h3>
	 * Wrap your form elements with the `md-inline-form` class in order to align them horizontally
	 * within a form.
	 *
	 * <hljs lang="html">
	 * <form class="md-inline-form">
	 *   <md-input-container>
	 *     <label>Username</label>
	 *     <input type="text" ng-model="user.name">
	 *   </md-input-container>
	 *
	 *   <md-input-container>
	 *     <label>Description</label>
	 *     <textarea ng-model="user.description"></textarea>
	 *   </md-input-container>
	 *
	 *   <md-input-container>
	 *     <label>State of Residence</label>
	 *     <md-select ng-model="user.state">
	 *       <md-option ng-value="state" ng-repeat="state in states">{{ state }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 *
	 *   <md-input-container>
	 *     <label>Enter date</label>
	 *     <md-datepicker ng-model="user.submissionDate"></md-datepicker>
	 *   </md-input-container>
	 *
	 *   <md-input-container>
	 *     <md-checkbox ng-model="user.licenseAccepted">
	 *       I agree to the license terms.
	 *     </md-checkbox>
	 *   </md-input-container>
	 * </form>
	 * </hljs>
	 */
	function mdInputContainerDirective($mdTheming, $parse, $$rAF) {
	
	  ContainerCtrl.$inject = ["$scope", "$element", "$attrs", "$animate"];
	  var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT', 'MD-SELECT'];
	
	  var LEFT_SELECTORS = INPUT_TAGS.reduce(function(selectors, isel) {
	    return selectors.concat(['md-icon ~ ' + isel, '.md-icon ~ ' + isel]);
	  }, []).join(",");
	
	  var RIGHT_SELECTORS = INPUT_TAGS.reduce(function(selectors, isel) {
	    return selectors.concat([isel + ' ~ md-icon', isel + ' ~ .md-icon']);
	  }, []).join(",");
	
	  return {
	    restrict: 'E',
	    compile: compile,
	    controller: ContainerCtrl
	  };
	
	  function compile(tElement) {
	    // Check for both a left & right icon
	    var hasLeftIcon = tElement[0].querySelector(LEFT_SELECTORS);
	    var hasRightIcon = tElement[0].querySelector(RIGHT_SELECTORS);
	
	    return function postLink(scope, element) {
	      $mdTheming(element);
	
	      if (hasLeftIcon || hasRightIcon) {
	        // When accessing the element's contents synchronously, they may not be defined yet because
	        // of the use of ng-if. If we wait one frame, then the element should be there if the ng-if
	        // resolves to true.
	        $$rAF(function() {
	          // Handle the case where the md-icon element is initially hidden via ng-if from #9529.
	          // We don't want to preserve the space for the icon in the case of ng-if, like we do for
	          // ng-show.
	          // Note that we can't use the same selectors from above because the elements are no longer
	          // siblings for textareas at this point due to the insertion of the md-resize-wrapper.
	          var iconNotRemoved = element[0].querySelector('md-icon') ||
	            element[0].querySelector('.md-icon');
	          if (hasLeftIcon && iconNotRemoved) {
	            element.addClass('md-icon-left');
	          }
	          if (hasRightIcon && iconNotRemoved) {
	            element.addClass('md-icon-right');
	          }
	        });
	      }
	    };
	  }
	
	  function ContainerCtrl($scope, $element, $attrs, $animate) {
	    var self = this;
	
	    $element.addClass('md-auto-horizontal-margin');
	
	    self.isErrorGetter = $attrs.mdIsError && $parse($attrs.mdIsError);
	
	    self.delegateClick = function() {
	      self.input.focus();
	    };
	    self.element = $element;
	    self.setFocused = function(isFocused) {
	      $element.toggleClass('md-input-focused', !!isFocused);
	    };
	    self.setHasValue = function(hasValue) {
	      $element.toggleClass('md-input-has-value', !!hasValue);
	    };
	    self.setHasPlaceholder = function(hasPlaceholder) {
	      $element.toggleClass('md-input-has-placeholder', !!hasPlaceholder);
	    };
	    self.setInvalid = function(isInvalid) {
	      if (isInvalid) {
	        $animate.addClass($element, 'md-input-invalid');
	      } else {
	        $animate.removeClass($element, 'md-input-invalid');
	      }
	    };
	    $scope.$watch(function() {
	      return self.label && self.input;
	    }, function(hasLabelAndInput) {
	      if (hasLabelAndInput && !self.label.attr('for')) {
	        self.label.attr('for', self.input.attr('id'));
	      }
	    });
	  }
	}
	
	function labelDirective() {
	  return {
	    restrict: 'E',
	    require: '^?mdInputContainer',
	    link: function(scope, element, attr, containerCtrl) {
	      if (!containerCtrl || attr.mdNoFloat || element.hasClass('md-container-ignore')) return;
	
	      containerCtrl.label = element;
	      scope.$on('$destroy', function() {
	        containerCtrl.label = null;
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name mdInput
	 * @restrict E
	 * @module material.components.input
	 *
	 * @description
	 * You can use any `<input>` or `<textarea>` element as a child of an `<md-input-container>`. This
	 * allows you to build complex forms for data entry.
	 *
	 * When the input is required and uses a floating label, then the label will automatically contain
	 * an asterisk (`*`).<br/>
	 * This behavior can be disabled by using the `md-no-asterisk` attribute.
	 *
	 * @param {number=} md-maxlength The maximum number of characters allowed in this input. If this is
	 *   specified, a character counter will be shown underneath the input.<br/><br/>
	 *   The purpose of **`md-maxlength`** is exactly to show the max length counter text. If you don't
	 *   want the counter text and only need "plain" validation, you can use the "simple" `ng-maxlength`
	 *   or maxlength attributes.<br/><br/>
	 * @param {boolean=} ng-trim If set to false, the input text will be not trimmed automatically.
	 *     Defaults to true.
	 * @param {string=} aria-label Aria-label is required when no label is present.  A warning message
	 *   will be logged in the console if not present.
	 * @param {string=} placeholder An alternative approach to using aria-label when the label is not
	 *   PRESENT. The placeholder text is copied to the aria-label attribute.
	 * @param {boolean=} md-no-autogrow When present, textareas will not grow automatically.
	 * @param {boolean=} md-no-asterisk When present, an asterisk will not be appended to the inputs
	 *   floating label.
	 * @param {boolean=} md-no-resize Disables the textarea resize handle.
	 * @param {number=} max-rows The maximum amount of rows for a textarea.
	 * @param {boolean=} md-detect-hidden When present, textareas will be sized properly when they are
	 *   revealed after being hidden. This is off by default for performance reasons because it
	 *   guarantees a reflow every digest cycle.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-input-container>
	 *   <label>Color</label>
	 *   <input type="text" ng-model="color" required md-maxlength="10">
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>With Errors</h3>
	 *
	 * `md-input-container` also supports errors using the standard `ng-messages` directives and
	 * animates the messages when they become visible using from the `ngEnter`/`ngLeave` events or
	 * the `ngShow`/`ngHide` events.
	 *
	 * By default, the messages will be hidden until the input is in an error state. This is based off
	 * of the `md-is-error` expression of the `md-input-container`. This gives the user a chance to
	 * fill out the form before the errors become visible.
	 *
	 * <hljs lang="html">
	 * <form name="colorForm">
	 *   <md-input-container>
	 *     <label>Favorite Color</label>
	 *     <input name="favoriteColor" ng-model="favoriteColor" required>
	 *     <div ng-messages="colorForm.favoriteColor.$error">
	 *       <div ng-message="required">This is required!</div>
	 *     </div>
	 *   </md-input-container>
	 * </form>
	 * </hljs>
	 *
	 * We automatically disable this auto-hiding functionality if you provide any of the following
	 * visibility directives on the `ng-messages` container:
	 *
	 *  - `ng-if`
	 *  - `ng-show`/`ng-hide`
	 *  - `ng-switch-when`/`ng-switch-default`
	 *
	 * You can also disable this functionality manually by adding the `md-auto-hide="false"` expression
	 * to the `ng-messages` container. This may be helpful if you always want to see the error messages
	 * or if you are building your own visibility directive.
	 *
	 * _<b>Note:</b> The `md-auto-hide` attribute is a static string that is  only checked upon
	 * initialization of the `ng-messages` directive to see if it equals the string `false`._
	 *
	 * <hljs lang="html">
	 * <form name="userForm">
	 *   <md-input-container>
	 *     <label>Last Name</label>
	 *     <input name="lastName" ng-model="lastName" required md-maxlength="10" minlength="4">
	 *     <div ng-messages="userForm.lastName.$error" ng-show="userForm.lastName.$dirty">
	 *       <div ng-message="required">This is required!</div>
	 *       <div ng-message="md-maxlength">That's too long!</div>
	 *       <div ng-message="minlength">That's too short!</div>
	 *     </div>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <label>Biography</label>
	 *     <textarea name="bio" ng-model="biography" required md-maxlength="150"></textarea>
	 *     <div ng-messages="userForm.bio.$error" ng-show="userForm.bio.$dirty">
	 *       <div ng-message="required">This is required!</div>
	 *       <div ng-message="md-maxlength">That's too long!</div>
	 *     </div>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <input aria-label='title' ng-model='title'>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <input placeholder='title' ng-model='title'>
	 *   </md-input-container>
	 * </form>
	 * </hljs>
	 *
	 * <h3>Notes</h3>
	 *
	 * - Requires [ngMessages](https://docs.angularjs.org/api/ngMessages).
	 * - Behaves like the [AngularJS input directive](https://docs.angularjs.org/api/ng/directive/input).
	 *
	 * The `md-input` and `md-input-container` directives use very specific positioning to achieve the
	 * error animation effects. Therefore, it is *not* advised to use the Layout system inside of the
	 * `<md-input-container>` tags. Instead, use relative or absolute positioning.
	 *
	 *
	 * <h3>Textarea directive</h3>
	 * The `textarea` element within a `md-input-container` has the following specific behavior:
	 * - By default the `textarea` grows as the user types. This can be disabled via the `md-no-autogrow`
	 * attribute.
	 * - If a `textarea` has the `rows` attribute, it will treat the `rows` as the minimum height and will
	 * continue growing as the user types. For example a textarea with `rows="3"` will be 3 lines of text
	 * high initially. If no rows are specified, the directive defaults to 1.
	 * - The textarea's height gets set on initialization, as well as while the user is typing. In certain situations
	 * (e.g. while animating) the directive might have been initialized, before the element got it's final height. In
	 * those cases, you can trigger a resize manually by broadcasting a `md-resize-textarea` event on the scope.
	 * - If you want a `textarea` to stop growing at a certain point, you can specify the `max-rows` attribute.
	 * - The textarea's bottom border acts as a handle which users can drag, in order to resize the element vertically.
	 * Once the user has resized a `textarea`, the autogrowing functionality becomes disabled. If you don't want a
	 * `textarea` to be resizeable by the user, you can add the `md-no-resize` attribute.
	 */
	
	function inputTextareaDirective($mdUtil, $window, $mdAria, $timeout, $mdGesture) {
	  return {
	    restrict: 'E',
	    require: ['^?mdInputContainer', '?ngModel', '?^form'],
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	
	    var containerCtrl = ctrls[0];
	    var hasNgModel = !!ctrls[1];
	    var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
	    var parentForm = ctrls[2];
	    var isReadonly = angular.isDefined(attr.readonly);
	    var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
	    var tagName = element[0].tagName.toLowerCase();
	
	
	    if (!containerCtrl) return;
	    if (attr.type === 'hidden') {
	      element.attr('aria-hidden', 'true');
	      return;
	    } else if (containerCtrl.input) {
	      if (containerCtrl.input[0].contains(element[0])) {
	        return;
	      } else {
	        throw new Error("<md-input-container> can only have *one* <input>, <textarea> or <md-select> child element!");
	      }
	    }
	    containerCtrl.input = element;
	
	    setupAttributeWatchers();
	
	    // Add an error spacer div after our input to provide space for the char counter and any ng-messages
	    var errorsSpacer = angular.element('<div class="md-errors-spacer">');
	    element.after(errorsSpacer);
	
	    var placeholderText = angular.isString(attr.placeholder) ? attr.placeholder.trim() : '';
	    if (!containerCtrl.label && !placeholderText.length) {
	      $mdAria.expect(element, 'aria-label');
	    }
	
	    element.addClass('md-input');
	    if (!element.attr('id')) {
	      element.attr('id', 'input_' + $mdUtil.nextUid());
	    }
	
	    // This works around a Webkit issue where number inputs, placed in a flexbox, that have
	    // a `min` and `max` will collapse to about 1/3 of their proper width. Please check #7349
	    // for more info. Also note that we don't override the `step` if the user has specified it,
	    // in order to prevent some unexpected behaviour.
	    if (tagName === 'input' && attr.type === 'number' && attr.min && attr.max && !attr.step) {
	      element.attr('step', 'any');
	    } else if (tagName === 'textarea') {
	      setupTextarea();
	    }
	
	    // If the input doesn't have an ngModel, it may have a static value. For that case,
	    // we have to do one initial check to determine if the container should be in the
	    // "has a value" state.
	    if (!hasNgModel) {
	      inputCheckValue();
	    }
	
	    var isErrorGetter = containerCtrl.isErrorGetter || function() {
	      return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (parentForm && parentForm.$submitted));
	    };
	
	    scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	
	    // When the developer uses the ngValue directive for the input, we have to observe the attribute, because
	    // AngularJS's ngValue directive is just setting the `value` attribute.
	    if (attr.ngValue) {
	      attr.$observe('value', inputCheckValue);
	    }
	
	    ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
	    ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);
	
	    element.on('input', inputCheckValue);
	
	    if (!isReadonly) {
	      element
	        .on('focus', function(ev) {
	          $mdUtil.nextTick(function() {
	            containerCtrl.setFocused(true);
	          });
	        })
	        .on('blur', function(ev) {
	          $mdUtil.nextTick(function() {
	            containerCtrl.setFocused(false);
	            inputCheckValue();
	          });
	        });
	    }
	
	    scope.$on('$destroy', function() {
	      containerCtrl.setFocused(false);
	      containerCtrl.setHasValue(false);
	      containerCtrl.input = null;
	    });
	
	    /** Gets run through ngModel's pipeline and set the `has-value` class on the container. */
	    function ngModelPipelineCheckValue(arg) {
	      containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
	      return arg;
	    }
	
	    function setupAttributeWatchers() {
	      if (containerCtrl.label) {
	        attr.$observe('required', function (value) {
	          // We don't need to parse the required value, it's always a boolean because of AngularJS'
	          // required directive.
	          if (containerCtrl.label) {
	            containerCtrl.label.toggleClass('md-required', value && !mdNoAsterisk);
	          }
	        });
	      }
	    }
	
	    function inputCheckValue() {
	      // An input's value counts if its length > 0,
	      // or if the input's validity state says it has bad input (eg string in a number input)
	      containerCtrl.setHasValue(element.val().length > 0 || (element[0].validity || {}).badInput);
	    }
	
	    function setupTextarea() {
	      var isAutogrowing = !attr.hasOwnProperty('mdNoAutogrow');
	
	      attachResizeHandle();
	
	      if (!isAutogrowing) return;
	
	      // Can't check if height was or not explicity set,
	      // so rows attribute will take precedence if present
	      var minRows = attr.hasOwnProperty('rows') ? parseInt(attr.rows) : NaN;
	      var maxRows = attr.hasOwnProperty('maxRows') ? parseInt(attr.maxRows) : NaN;
	      var scopeResizeListener = scope.$on('md-resize-textarea', growTextarea);
	      var lineHeight = null;
	      var node = element[0];
	
	      // This timeout is necessary, because the browser needs a little bit
	      // of time to calculate the `clientHeight` and `scrollHeight`.
	      $timeout(function() {
	        $mdUtil.nextTick(growTextarea);
	      }, 10, false);
	
	      // We could leverage ngModel's $parsers here, however it
	      // isn't reliable, because AngularJS trims the input by default,
	      // which means that growTextarea won't fire when newlines and
	      // spaces are added.
	      element.on('input', growTextarea);
	
	      // We should still use the $formatters, because they fire when
	      // the value was changed from outside the textarea.
	      if (hasNgModel) {
	        ngModelCtrl.$formatters.push(formattersListener);
	      }
	
	      if (!minRows) {
	        element.attr('rows', 1);
	      }
	
	      angular.element($window).on('resize', growTextarea);
	      scope.$on('$destroy', disableAutogrow);
	
	      function growTextarea() {
	        // temporarily disables element's flex so its height 'runs free'
	        element
	          .attr('rows', 1)
	          .css('height', 'auto')
	          .addClass('md-no-flex');
	
	        var height = getHeight();
	
	        if (!lineHeight) {
	          // offsetHeight includes padding which can throw off our value
	          var originalPadding = element[0].style.padding || '';
	          lineHeight = element.css('padding', 0).prop('offsetHeight');
	          element[0].style.padding = originalPadding;
	        }
	
	        if (minRows && lineHeight) {
	          height = Math.max(height, lineHeight * minRows);
	        }
	
	        if (maxRows && lineHeight) {
	          var maxHeight = lineHeight * maxRows;
	
	          if (maxHeight < height) {
	            element.attr('md-no-autogrow', '');
	            height = maxHeight;
	          } else {
	            element.removeAttr('md-no-autogrow');
	          }
	        }
	
	        if (lineHeight) {
	          element.attr('rows', Math.round(height / lineHeight));
	        }
	
	        element
	          .css('height', height + 'px')
	          .removeClass('md-no-flex');
	      }
	
	      function getHeight() {
	        var offsetHeight = node.offsetHeight;
	        var line = node.scrollHeight - offsetHeight;
	        return offsetHeight + Math.max(line, 0);
	      }
	
	      function formattersListener(value) {
	        $mdUtil.nextTick(growTextarea);
	        return value;
	      }
	
	      function disableAutogrow() {
	        if (!isAutogrowing) return;
	
	        isAutogrowing = false;
	        angular.element($window).off('resize', growTextarea);
	        scopeResizeListener && scopeResizeListener();
	        element
	          .attr('md-no-autogrow', '')
	          .off('input', growTextarea);
	
	        if (hasNgModel) {
	          var listenerIndex = ngModelCtrl.$formatters.indexOf(formattersListener);
	
	          if (listenerIndex > -1) {
	            ngModelCtrl.$formatters.splice(listenerIndex, 1);
	          }
	        }
	      }
	
	      function attachResizeHandle() {
	        if (attr.hasOwnProperty('mdNoResize')) return;
	
	        var handle = angular.element('<div class="md-resize-handle"></div>');
	        var isDragging = false;
	        var dragStart = null;
	        var startHeight = 0;
	        var container = containerCtrl.element;
	        var dragGestureHandler = $mdGesture.register(handle, 'drag', { horizontal: false });
	
	
	        element.wrap('<div class="md-resize-wrapper">').after(handle);
	        handle.on('mousedown', onMouseDown);
	
	        container
	          .on('$md.dragstart', onDragStart)
	          .on('$md.drag', onDrag)
	          .on('$md.dragend', onDragEnd);
	
	        scope.$on('$destroy', function() {
	          handle
	            .off('mousedown', onMouseDown)
	            .remove();
	
	          container
	            .off('$md.dragstart', onDragStart)
	            .off('$md.drag', onDrag)
	            .off('$md.dragend', onDragEnd);
	
	          dragGestureHandler();
	          handle = null;
	          container = null;
	          dragGestureHandler = null;
	        });
	
	        function onMouseDown(ev) {
	          ev.preventDefault();
	          isDragging = true;
	          dragStart = ev.clientY;
	          startHeight = parseFloat(element.css('height')) || element.prop('offsetHeight');
	        }
	
	        function onDragStart(ev) {
	          if (!isDragging) return;
	          ev.preventDefault();
	          disableAutogrow();
	          container.addClass('md-input-resized');
	        }
	
	        function onDrag(ev) {
	          if (!isDragging) return;
	
	          element.css('height', (startHeight + ev.pointer.distanceY) + 'px');
	        }
	
	        function onDragEnd(ev) {
	          if (!isDragging) return;
	          isDragging = false;
	          container.removeClass('md-input-resized');
	        }
	      }
	
	      // Attach a watcher to detect when the textarea gets shown.
	      if (attr.hasOwnProperty('mdDetectHidden')) {
	
	        var handleHiddenChange = function() {
	          var wasHidden = false;
	
	          return function() {
	            var isHidden = node.offsetHeight === 0;
	
	            if (isHidden === false && wasHidden === true) {
	              growTextarea();
	            }
	
	            wasHidden = isHidden;
	          };
	        }();
	
	        // Check every digest cycle whether the visibility of the textarea has changed.
	        // Queue up to run after the digest cycle is complete.
	        scope.$watch(function() {
	          $mdUtil.nextTick(handleHiddenChange, false);
	          return true;
	        });
	      }
	    }
	  }
	}
	
	function mdMaxlengthDirective($animate, $mdUtil) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^mdInputContainer'],
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	    var maxlength = parseInt(attr.mdMaxlength);
	    if (isNaN(maxlength)) maxlength = -1;
	    var ngModelCtrl = ctrls[0];
	    var containerCtrl = ctrls[1];
	    var charCountEl, errorsSpacer;
	    var ngTrim = angular.isDefined(attr.ngTrim) ? $mdUtil.parseAttributeBoolean(attr.ngTrim) : true;
	    var isPasswordInput = attr.type === 'password';
	
	    scope.$watch(attr.mdMaxlength, function(value) {
	      maxlength = value;
	    });
	
	    ngModelCtrl.$validators['md-maxlength'] = function(modelValue, viewValue) {
	      if (!angular.isNumber(maxlength) || maxlength < 0) {
	        return true;
	      }
	
	      // We always update the char count, when the modelValue has changed.
	      // Using the $validators for triggering the update works very well.
	      renderCharCount();
	
	      var elementVal = element.val() || viewValue;
	      if (elementVal === undefined || elementVal === null) {
	        elementVal = '';
	      }
	      elementVal = ngTrim && !isPasswordInput && angular.isString(elementVal) ? elementVal.trim() : elementVal;
	      // Force the value into a string since it may be a number,
	      // which does not have a length property.
	      return String(elementVal).length <= maxlength;
	    };
	
	    /**
	     * Override the default NgModelController $isEmpty check to take ng-trim, password inputs,
	     * etc. into account.
	     * @param value {*} the input's value
	     * @returns {boolean} true if the input's value should be considered empty, false otherwise
	     */
	    ngModelCtrl.$isEmpty = function(value) {
	      return calculateInputValueLength(value) === 0;
	    };
	
	    // Wait until the next tick to ensure that the input has setup the errors spacer where we will
	    // append our counter
	    $mdUtil.nextTick(function() {
	      errorsSpacer = angular.element(containerCtrl.element[0].querySelector('.md-errors-spacer'));
	      charCountEl = angular.element('<div class="md-char-counter">');
	
	      // Append our character counter inside the errors spacer
	      errorsSpacer.append(charCountEl);
	
	      attr.$observe('ngTrim', function (value) {
	        ngTrim = angular.isDefined(value) ? $mdUtil.parseAttributeBoolean(value) : true;
	      });
	
	      scope.$watch(attr.mdMaxlength, function(value) {
	        if (angular.isNumber(value) && value > 0) {
	          if (!charCountEl.parent().length) {
	            $animate.enter(charCountEl, errorsSpacer);
	          }
	          renderCharCount();
	        } else {
	          $animate.leave(charCountEl);
	        }
	      });
	    });
	
	    /**
	     * Calculate the input value's length after coercing it to a string
	     * and trimming it if appropriate.
	     * @param value {*} the input's value
	     * @returns {number} calculated length of the input's value
	     */
	    function calculateInputValueLength(value) {
	      value = ngTrim && !isPasswordInput && angular.isString(value) ? value.trim() : value;
	      if (value === undefined || value === null) {
	        value = '';
	      }
	      return String(value).length;
	    }
	
	    function renderCharCount() {
	      // If we have not been initialized or appended to the body yet; do not render.
	      if (!charCountEl || !charCountEl.parent()) {
	        return;
	      }
	      // Force the value into a string since it may be a number,
	      // which does not have a length property.
	      charCountEl.text(calculateInputValueLength(element.val()) + ' / ' + maxlength);
	    }
	  }
	}
	
	function placeholderDirective($compile) {
	  return {
	    restrict: 'A',
	    require: '^^?mdInputContainer',
	    priority: 200,
	    link: {
	      // Note that we need to do this in the pre-link, as opposed to the post link, if we want to
	      // support data bindings in the placeholder. This is necessary, because we have a case where
	      // we transfer the placeholder value to the `<label>` and we remove it from the original `<input>`.
	      // If we did this in the post-link, AngularJS would have set up the observers already and would be
	      // re-adding the attribute, even though we removed it from the element.
	      pre: preLink
	    }
	  };
	
	  function preLink(scope, element, attr, inputContainer) {
	    // If there is no input container, just return
	    if (!inputContainer) return;
	
	    var label = inputContainer.element.find('label');
	    var noFloat = inputContainer.element.attr('md-no-float');
	
	    // If we have a label, or they specify the md-no-float attribute, just return
	    if ((label && label.length) || noFloat === '' || scope.$eval(noFloat)) {
	      // Add a placeholder class so we can target it in the CSS
	      inputContainer.setHasPlaceholder(true);
	      return;
	    }
	
	    // md-select handles placeholders on it's own
	    if (element[0].nodeName !== 'MD-SELECT') {
	      // Move the placeholder expression to the label
	      var newLabel = angular.element(
	        '<label ng-click="delegateClick()" tabindex="-1" aria-hidden="true">' + attr.placeholder +
	        '</label>');
	
	      // Note that we unset it via `attr`, in order to get AngularJS
	      // to remove any observers that it might have set up. Otherwise
	      // the attribute will be added on the next digest.
	      attr.$set('placeholder', null);
	
	      // We need to compile the label manually in case it has any bindings.
	      // A gotcha here is that we first add the element to the DOM and we compile
	      // it later. This is necessary, because if we compile the element beforehand,
	      // it won't be able to find the `mdInputContainer` controller.
	      inputContainer.element
	        .addClass('md-icon-float')
	        .prepend(newLabel);
	
	      $compile(newLabel)(scope);
	    }
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name mdSelectOnFocus
	 * @module material.components.input
	 *
	 * @restrict A
	 *
	 * @description
	 * The `md-select-on-focus` directive allows you to automatically select the element's input text on focus.
	 *
	 * <h3>Notes</h3>
	 * - The use of `md-select-on-focus` is restricted to `<input>` and `<textarea>` elements.
	 *
	 * @usage
	 * <h3>Using with an Input</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Auto Select</label>
	 *   <input type="text" md-select-on-focus>
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>Using with a Textarea</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Auto Select</label>
	 *   <textarea md-select-on-focus>This text will be selected on focus.</textarea>
	 * </md-input-container>
	 *
	 * </hljs>
	 */
	function mdSelectOnFocusDirective($document, $timeout) {
	
	  return {
	    restrict: 'A',
	    link: postLink
	  };
	
	  function postLink(scope, element, attr) {
	    if (element[0].nodeName !== 'INPUT' && element[0].nodeName !== "TEXTAREA") return;
	
	    var preventMouseUp = false;
	
	    element
	      .on('focus', onFocus)
	      .on('mouseup', onMouseUp);
	
	    scope.$on('$destroy', function() {
	      element
	        .off('focus', onFocus)
	        .off('mouseup', onMouseUp);
	    });
	
	    function onFocus() {
	      preventMouseUp = true;
	
	      $timeout(function() {
	
	        // Use HTMLInputElement#select to fix firefox select issues.
	        // The debounce is here for Edge's sake, otherwise the selection doesn't work.
	        // Since focus may already have been lost on the input (and because `select()`
	        // will re-focus), make sure the element is still active before applying.
	        if ($document[0].activeElement === element[0]) {
	          element[0].select();
	        }
	
	        // This should be reset from inside the `focus`, because the event might
	        // have originated from something different than a click, e.g. a keyboard event.
	        preventMouseUp = false;
	      }, 1, false);
	    }
	
	    // Prevents the default action of the first `mouseup` after a focus.
	    // This is necessary, because browsers fire a `mouseup` right after the element
	    // has been focused. In some browsers (Firefox in particular) this can clear the
	    // selection. There are examples of the problem in issue #7487.
	    function onMouseUp(event) {
	      if (preventMouseUp) {
	        event.preventDefault();
	      }
	    }
	  }
	}
	
	var visibilityDirectives = ['ngIf', 'ngShow', 'ngHide', 'ngSwitchWhen', 'ngSwitchDefault'];
	function ngMessagesDirective() {
	  return {
	    restrict: 'EA',
	    link: postLink,
	
	    // This is optional because we don't want target *all* ngMessage instances, just those inside of
	    // mdInputContainer.
	    require: '^^?mdInputContainer'
	  };
	
	  function postLink(scope, element, attrs, inputContainer) {
	    // If we are not a child of an input container, don't do anything
	    if (!inputContainer) return;
	
	    // Add our animation class
	    element.toggleClass('md-input-messages-animation', true);
	
	    // Add our md-auto-hide class to automatically hide/show messages when container is invalid
	    element.toggleClass('md-auto-hide', true);
	
	    // If we see some known visibility directives, remove the md-auto-hide class
	    if (attrs.mdAutoHide == 'false' || hasVisibiltyDirective(attrs)) {
	      element.toggleClass('md-auto-hide', false);
	    }
	  }
	
	  function hasVisibiltyDirective(attrs) {
	    return visibilityDirectives.some(function(attr) {
	      return attrs[attr];
	    });
	  }
	}
	
	function ngMessageDirective($mdUtil) {
	  return {
	    restrict: 'EA',
	    compile: compile,
	    priority: 100
	  };
	
	  function compile(tElement) {
	    if (!isInsideInputContainer(tElement)) {
	
	      // When the current element is inside of a document fragment, then we need to check for an input-container
	      // in the postLink, because the element will be later added to the DOM and is currently just in a temporary
	      // fragment, which causes the input-container check to fail.
	      if (isInsideFragment()) {
	        return function (scope, element) {
	          if (isInsideInputContainer(element)) {
	            // Inside of the postLink function, a ngMessage directive will be a comment element, because it's
	            // currently hidden. To access the shown element, we need to use the element from the compile function.
	            initMessageElement(tElement);
	          }
	        };
	      }
	    } else {
	      initMessageElement(tElement);
	    }
	
	    function isInsideFragment() {
	      var nextNode = tElement[0];
	      while (nextNode = nextNode.parentNode) {
	        if (nextNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    function isInsideInputContainer(element) {
	      return !!$mdUtil.getClosest(element, "md-input-container");
	    }
	
	    function initMessageElement(element) {
	      // Add our animation class
	      element.toggleClass('md-input-message-animation', true);
	    }
	  }
	}
	
	var $$AnimateRunner, $animateCss, $mdUtil;
	
	function mdInputInvalidMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil);
	
	  return {
	    addClass: function(element, className, done) {
	      showInputMessages(element, done);
	    }
	
	    // NOTE: We do not need the removeClass method, because the message ng-leave animation will fire
	  };
	}
	
	function ngMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil);
	
	  return {
	    enter: function(element, done) {
	      showInputMessages(element, done);
	    },
	
	    leave: function(element, done) {
	      hideInputMessages(element, done);
	    },
	
	    addClass: function(element, className, done) {
	      if (className == "ng-hide") {
	        hideInputMessages(element, done);
	      } else {
	        done();
	      }
	    },
	
	    removeClass: function(element, className, done) {
	      if (className == "ng-hide") {
	        showInputMessages(element, done);
	      } else {
	        done();
	      }
	    }
	  };
	}
	
	function ngMessageAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);
	
	  return {
	    enter: function(element, done) {
	      var animator = showMessage(element);
	
	      animator.start().done(done);
	    },
	
	    leave: function(element, done) {
	      var animator = hideMessage(element);
	
	      animator.start().done(done);
	    }
	  };
	}
	
	function showInputMessages(element, done) {
	  var animators = [], animator;
	  var messages = getMessagesElement(element);
	  var children = messages.children();
	
	  if (messages.length == 0 || children.length == 0) {
	    done();
	    return;
	  }
	
	  angular.forEach(children, function(child) {
	    animator = showMessage(angular.element(child));
	
	    animators.push(animator.start());
	  });
	
	  $$AnimateRunner.all(animators, done);
	}
	
	function hideInputMessages(element, done) {
	  var animators = [], animator;
	  var messages = getMessagesElement(element);
	  var children = messages.children();
	
	  if (messages.length == 0 || children.length == 0) {
	    done();
	    return;
	  }
	
	  angular.forEach(children, function(child) {
	    animator = hideMessage(angular.element(child));
	
	    animators.push(animator.start());
	  });
	
	  $$AnimateRunner.all(animators, done);
	}
	
	function showMessage(element) {
	  var height = parseInt(window.getComputedStyle(element[0]).height);
	  var topMargin = parseInt(window.getComputedStyle(element[0]).marginTop);
	
	  var messages = getMessagesElement(element);
	  var container = getInputElement(element);
	
	  // Check to see if the message is already visible so we can skip
	  var alreadyVisible = (topMargin > -height);
	
	  // If we have the md-auto-hide class, the md-input-invalid animation will fire, so we can skip
	  if (alreadyVisible || (messages.hasClass('md-auto-hide') && !container.hasClass('md-input-invalid'))) {
	    return $animateCss(element, {});
	  }
	
	  return $animateCss(element, {
	    event: 'enter',
	    structural: true,
	    from: {"opacity": 0, "margin-top": -height + "px"},
	    to: {"opacity": 1, "margin-top": "0"},
	    duration: 0.3
	  });
	}
	
	function hideMessage(element) {
	  var height = element[0].offsetHeight;
	  var styles = window.getComputedStyle(element[0]);
	
	  // If we are already hidden, just return an empty animation
	  if (parseInt(styles.opacity) === 0) {
	    return $animateCss(element, {});
	  }
	
	  // Otherwise, animate
	  return $animateCss(element, {
	    event: 'leave',
	    structural: true,
	    from: {"opacity": 1, "margin-top": 0},
	    to: {"opacity": 0, "margin-top": -height + "px"},
	    duration: 0.3
	  });
	}
	
	function getInputElement(element) {
	  var inputContainer = element.controller('mdInputContainer');
	
	  return inputContainer.element;
	}
	
	function getMessagesElement(element) {
	  // If we ARE the messages element, just return ourself
	  if (element.hasClass('md-input-messages-animation')) {
	    return element;
	  }
	
	  // If we are a ng-message element, we need to traverse up the DOM tree
	  if (element.hasClass('md-input-message-animation')) {
	    return angular.element($mdUtil.getClosest(element, function(node) {
	      return node.classList.contains('md-input-messages-animation');
	    }));
	  }
	
	  // Otherwise, we can traverse down
	  return angular.element(element[0].querySelector('.md-input-messages-animation'));
	}
	
	function saveSharedServices(_$$AnimateRunner_, _$animateCss_, _$mdUtil_) {
	  $$AnimateRunner = _$$AnimateRunner_;
	  $animateCss = _$animateCss_;
	  $mdUtil = _$mdUtil_;
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.list
	 * @description
	 * List module
	 */
	MdListController.$inject = ["$scope", "$element", "$mdListInkRipple"];
	mdListDirective.$inject = ["$mdTheming"];
	mdListItemDirective.$inject = ["$mdAria", "$mdConstant", "$mdUtil", "$timeout"];
	angular.module('material.components.list', [
	  'material.core'
	])
	  .controller('MdListController', MdListController)
	  .directive('mdList', mdListDirective)
	  .directive('mdListItem', mdListItemDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdList
	 * @module material.components.list
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-list>` directive is a list container for 1..n `<md-list-item>` tags.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-list>
	 *   <md-list-item class="md-2-line" ng-repeat="item in todos">
	 *     <md-checkbox ng-model="item.done"></md-checkbox>
	 *     <div class="md-list-item-text">
	 *       <h3>{{item.title}}</h3>
	 *       <p>{{item.description}}</p>
	 *     </div>
	 *   </md-list-item>
	 * </md-list>
	 * </hljs>
	 */
	
	function mdListDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    compile: function(tEl) {
	      tEl[0].setAttribute('role', 'list');
	      return $mdTheming;
	    }
	  };
	}
	/**
	 * @ngdoc directive
	 * @name mdListItem
	 * @module material.components.list
	 *
	 * @restrict E
	 *
	 * @description
	 * A `md-list-item` element can be used to represent some information in a row.<br/>
	 *
	 * @usage
	 * ### Single Row Item
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Multiple Lines
	 * By using the following markup, you will be able to have two lines inside of one `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-2-line">
	 *     <div class="md-list-item-text" layout="column">
	 *       <p>First Line</p>
	 *       <p>Second Line</p>
	 *     </div>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * It is also possible to have three lines inside of one list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-3-line">
	 *     <div class="md-list-item-text" layout="column">
	 *       <p>First Line</p>
	 *       <p>Second Line</p>
	 *       <p>Third Line</p>
	 *     </div>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Secondary Items
	 * Secondary items are elements which will be aligned at the end of the `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *     <md-button class="md-secondary">
	 *       Secondary Button
	 *     </md-button>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * It also possible to have multiple secondary items inside of one `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *     <md-button class="md-secondary">First Button</md-button>
	 *     <md-button class="md-secondary">Second Button</md-button>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Proxy Item
	 * Proxies are elements, which will execute their specific action on click<br/>
	 * Currently supported proxy items are
	 * - `md-checkbox` (Toggle)
	 * - `md-switch` (Toggle)
	 * - `md-menu` (Open)
	 *
	 * This means, when using a supported proxy item inside of `md-list-item`, the list item will
	 * automatically become clickable and executes the associated action of the proxy element on click.
	 *
	 * It is possible to disable this behavior by applying the `md-no-proxy` class to the list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-no-proxy">
	 *     <span>No Proxy List</span>
	 *     <md-checkbox class="md-secondary"></md-checkbox>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * Here are a few examples of proxy elements inside of a list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>First Line</span>
	 *     <md-checkbox class="md-secondary"></md-checkbox>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The `md-checkbox` element will be automatically detected as a proxy element and will toggle on
	 * click.
	 *
	 * If not provided, an `aria-label` will be applied using the text of the list item.
	 * In this case, the following will be applied to the `md-checkbox`:
	 * `aria-label="Toggle First Line"`.
	 * When localizing your application, you should supply a localized `aria-label`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>First Line</span>
	 *     <md-switch class="md-secondary"></md-switch>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The recognized `md-switch` will toggle its state, when the user clicks on the `md-list-item`.
	 *
	 * It is also possible to have a `md-menu` inside of a `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <p>Click anywhere to fire the secondary action</p>
	 *     <md-menu class="md-secondary">
	 *       <md-button class="md-icon-button">
	 *         <md-icon md-svg-icon="communication:message"></md-icon>
	 *       </md-button>
	 *       <md-menu-content width="4">
	 *         <md-menu-item>
	 *           <md-button>
	 *             Redial
	 *           </md-button>
	 *         </md-menu-item>
	 *         <md-menu-item>
	 *           <md-button>
	 *             Check voicemail
	 *           </md-button>
	 *         </md-menu-item>
	 *         <md-menu-divider></md-menu-divider>
	 *         <md-menu-item>
	 *           <md-button>
	 *             Notifications
	 *           </md-button>
	 *         </md-menu-item>
	 *       </md-menu-content>
	 *     </md-menu>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The menu will automatically open, when the users clicks on the `md-list-item`.<br/>
	 *
	 * If the developer didn't specify any position mode on the menu, the `md-list-item` will
	 * automatically detect the position mode and apply it to the `md-menu`.
	 *
	 * ### Avatars
	 * Sometimes you may want to have avatars inside of the `md-list-item `.<br/>
	 * You are able to create an optimized icon for the list item, by applying the `.md-avatar` class on
	 * the `<img>` element.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <img src="my-avatar.png" class="md-avatar">
	 *     <span>Alan Turing</span>
	 * </hljs>
	 *
	 * When using `<md-icon>` for an avatar, you have to use the `.md-avatar-icon` class.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <md-icon class="md-avatar-icon" md-svg-icon="social:person"></md-icon>
	 *     <span>Timothy Kopra</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * In cases where you have a `md-list-item`, which doesn't have an avatar,
	 * but you want to align it with the other avatar items, you need to use the `.md-offset` class.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-offset">
	 *     <span>Jon Doe</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### DOM modification
	 * The `md-list-item` component automatically detects if the list item should be clickable.
	 *
	 * ---
	 * If the `md-list-item` is clickable, we wrap all content inside of a `<div>` and create
	 * an overlaying button, which will will execute the given actions (like `ng-href`, `ng-click`).
	 *
	 * We create an overlaying button, instead of wrapping all content inside of the button,
	 * because otherwise some elements may not be clickable inside of the button.
	 *
	 * ---
	 * When using a secondary item inside of your list item, the `md-list-item` component will
	 * automatically create a secondary container at the end of the `md-list-item`, which contains all
	 * secondary items.
	 *
	 * The secondary item container is not static, because that would cause issues with the overflow
	 * of the list item.
	 */
	function mdListItemDirective($mdAria, $mdConstant, $mdUtil, $timeout) {
	  var proxiedTypes = ['md-checkbox', 'md-switch', 'md-menu'];
	  return {
	    restrict: 'E',
	    controller: 'MdListController',
	
	    compile: function(tElement, tAttrs) {
	
	      // Check for proxy controls (no ng-click on parent, and a control inside)
	      var secondaryItems = tElement[0].querySelectorAll('.md-secondary');
	      var hasProxiedElement;
	      var proxyElement;
	      var itemContainer = tElement;
	
	      tElement[0].setAttribute('role', 'listitem');
	
	      if (tAttrs.ngClick || tAttrs.ngDblclick ||  tAttrs.ngHref || tAttrs.href || tAttrs.uiSref || tAttrs.ngAttrUiSref) {
	        wrapIn('button');
	      } else if (!tElement.hasClass('md-no-proxy')) {
	
	        for (var i = 0, type; i < proxiedTypes.length; ++i) {
	          proxyElement = tElement[0].querySelector(proxiedTypes[i]);
	          if (proxyElement !== null) {
	            hasProxiedElement = true;
	            break;
	          }
	        }
	
	        if (hasProxiedElement) {
	          wrapIn('div');
	        } else {
	          tElement.addClass('md-no-proxy');
	        }
	      }
	
	      wrapSecondaryItems();
	      setupToggleAria();
	
	      if (hasProxiedElement && proxyElement.nodeName === "MD-MENU") {
	        setupProxiedMenu();
	      }
	
	      function setupToggleAria() {
	        var toggleTypes = ['md-switch', 'md-checkbox'];
	        var toggle;
	
	        for (var i = 0, toggleType; i < toggleTypes.length; ++i) {
	          toggle = tElement.find(toggleTypes[i])[0];
	          if (toggle) {
	            if (!toggle.hasAttribute('aria-label')) {
	              var labelElement = tElement.find('p')[0];
	              if (!labelElement) {
	                labelElement = tElement.find('span')[0];
	              }
	              if (!labelElement) return;
	              toggle.setAttribute('aria-label', 'Toggle ' + labelElement.textContent);
	            }
	          }
	        }
	      }
	
	      function setupProxiedMenu() {
	        var menuEl = angular.element(proxyElement);
	
	        var isEndAligned = menuEl.parent().hasClass('md-secondary-container') ||
	                           proxyElement.parentNode.firstElementChild !== proxyElement;
	
	        var xAxisPosition = 'left';
	
	        if (isEndAligned) {
	          // When the proxy item is aligned at the end of the list, we have to set the origin to the end.
	          xAxisPosition = 'right';
	        }
	
	        // Set the position mode / origin of the proxied menu.
	        if (!menuEl.attr('md-position-mode')) {
	          menuEl.attr('md-position-mode', xAxisPosition + ' target');
	        }
	
	        // Apply menu open binding to menu button
	        var menuOpenButton = menuEl.children().eq(0);
	        if (!hasClickEvent(menuOpenButton[0])) {
	          menuOpenButton.attr('ng-click', '$mdMenu.open($event)');
	        }
	
	        if (!menuOpenButton.attr('aria-label')) {
	          menuOpenButton.attr('aria-label', 'Open List Menu');
	        }
	      }
	
	      /**
	       * @param {'div'|'button'} type
	       */
	      function wrapIn(type) {
	        if (type === 'div') {
	          itemContainer = angular.element('<div class="md-no-style md-list-item-inner">');
	          itemContainer.append(tElement.contents());
	          tElement.addClass('md-proxy-focus');
	        } else {
	          // Element which holds the default list-item content.
	          itemContainer = angular.element(
	            '<div class="md-button md-no-style">' +
	            '   <div class="md-list-item-inner"></div>' +
	            '</div>'
	          );
	
	          // Button which shows ripple and executes primary action.
	          var buttonWrap = angular.element('<md-button class="md-no-style"></md-button>');
	
	          moveAttributes(tElement[0], buttonWrap[0]);
	
	          // If there is no aria-label set on the button (previously copied over if present)
	          // we determine the label from the content and copy it to the button.
	          if (!buttonWrap.attr('aria-label')) {
	            buttonWrap.attr('aria-label', $mdAria.getText(tElement));
	
	            // If we set the button's aria-label to the text content, then make the content hidden
	            // from screen readers so that it isn't read/traversed twice.
	            var listItemInner = itemContainer[0].querySelector('.md-list-item-inner');
	            if (listItemInner) {
	              listItemInner.setAttribute('aria-hidden', 'true');
	            }
	          }
	
	          // We allow developers to specify the `md-no-focus` class, to disable the focus style
	          // on the button executor. Once more classes should be forwarded, we should probably make
	          // the class forward more generic.
	          if (tElement.hasClass('md-no-focus')) {
	            buttonWrap.addClass('md-no-focus');
	          }
	
	          // Append the button wrap before our list-item content, because it will overlay in
	          // relative.
	          itemContainer.prepend(buttonWrap);
	          itemContainer.children().eq(1).append(tElement.contents());
	
	          tElement.addClass('_md-button-wrap');
	        }
	
	        tElement[0].setAttribute('tabindex', '-1');
	        tElement.append(itemContainer);
	      }
	
	      function wrapSecondaryItems() {
	        var secondaryItemsWrapper = angular.element('<div class="md-secondary-container">');
	
	        angular.forEach(secondaryItems, function(secondaryItem) {
	          wrapSecondaryItem(secondaryItem, secondaryItemsWrapper);
	        });
	
	        itemContainer.append(secondaryItemsWrapper);
	      }
	
	      /**
	       * @param {HTMLElement} secondaryItem
	       * @param {HTMLDivElement} container
	       */
	      function wrapSecondaryItem(secondaryItem, container) {
	        // If the current secondary item is not a button, but contains a ng-click attribute,
	        // the secondary item will be automatically wrapped inside of a button.
	        if (secondaryItem && !isButton(secondaryItem) && secondaryItem.hasAttribute('ng-click')) {
	
	          $mdAria.expect(secondaryItem, 'aria-label');
	          var buttonWrapper = angular.element('<md-button class="md-secondary md-icon-button">');
	
	          // Move the attributes from the secondary item to the generated button.
	          // We also support some additional attributes from the secondary item,
	          // because some developers may use a ngIf, ngHide, ngShow on their item.
	          moveAttributes(secondaryItem, buttonWrapper[0], ['ng-if', 'ng-hide', 'ng-show']);
	
	          secondaryItem.setAttribute('tabindex', '-1');
	          buttonWrapper.append(secondaryItem);
	
	          secondaryItem = buttonWrapper[0];
	        }
	
	        if (secondaryItem &&
	            (!hasClickEvent(secondaryItem) ||
	              (!tAttrs.ngClick && isProxiedElement(secondaryItem)))) {
	          // In this case we remove the secondary class, so we can identify it later, when searching
	          // for the proxy items.
	          angular.element(secondaryItem).removeClass('md-secondary');
	        }
	
	        tElement.addClass('md-with-secondary');
	        container.append(secondaryItem);
	      }
	
	      /**
	       * Moves attributes from a source element to the destination element.
	       * By default, the function will copy the most necessary attributes, supported
	       * by the button executor for clickable list items.
	       * @param {Element} source Element with the specified attributes
	       * @param {Element} destination Element which will receive the attributes
	       * @param {string|string[]} extraAttrs Additional attributes, which will be moved over
	       */
	      function moveAttributes(source, destination, extraAttrs) {
	        var copiedAttrs = $mdUtil.prefixer([
	          'ng-if', 'ng-click', 'ng-dblclick', 'aria-label', 'ng-disabled', 'ui-sref',
	          'href', 'ng-href', 'rel', 'target', 'ng-attr-ui-sref', 'ui-sref-opts', 'download'
	        ]);
	
	        if (extraAttrs) {
	          copiedAttrs = copiedAttrs.concat($mdUtil.prefixer(extraAttrs));
	        }
	
	        angular.forEach(copiedAttrs, function(attr) {
	          if (source.hasAttribute(attr)) {
	            destination.setAttribute(attr, source.getAttribute(attr));
	            source.removeAttribute(attr);
	          }
	        });
	      }
	
	      /**
	       * @param {HTMLElement} element
	       * @return {boolean} true if the element has one of the proxied tags, false otherwise
	       */
	      function isProxiedElement(element) {
	        return proxiedTypes.indexOf(element.nodeName.toLowerCase()) !== -1;
	      }
	
	      /**
	       * @param {HTMLElement} element
	       * @return {boolean} true if the element is a button or md-button, false otherwise
	       */
	      function isButton(element) {
	        var nodeName = element.nodeName.toUpperCase();
	
	        return nodeName === "MD-BUTTON" || nodeName === "BUTTON";
	      }
	
	      /**
	       * @param {Element} element
	       * @return {boolean} true if the element has an ng-click attribute, false otherwise
	       */
	      function hasClickEvent(element) {
	        var attr = element.attributes;
	        for (var i = 0; i < attr.length; i++) {
	          if (tAttrs.$normalize(attr[i].name) === 'ngClick') {
	            return true;
	          }
	        }
	        return false;
	      }
	
	      return postLink;
	
	      function postLink($scope, $element, $attr, ctrl) {
	        $element.addClass('_md');     // private md component indicator for styling
	
	        var proxies       = [],
	            firstElement  = $element[0].firstElementChild,
	            isButtonWrap  = $element.hasClass('_md-button-wrap'),
	            clickChild    = isButtonWrap ? firstElement.firstElementChild : firstElement,
	            hasClick      = clickChild && hasClickEvent(clickChild),
	            noProxies     = $element.hasClass('md-no-proxy');
	
	        computeProxies();
	        computeClickable();
	
	        if (proxies.length) {
	          angular.forEach(proxies, function(proxy) {
	            proxy = angular.element(proxy);
	
	            $scope.mouseActive = false;
	            proxy.on('mousedown', function() {
	              $scope.mouseActive = true;
	              $timeout(function() {
	                $scope.mouseActive = false;
	              }, 100);
	            })
	            .on('focus', function() {
	              if ($scope.mouseActive === false) { $element.addClass('md-focused'); }
	              proxy.on('blur', function proxyOnBlur() {
	                $element.removeClass('md-focused');
	                proxy.off('blur', proxyOnBlur);
	              });
	            });
	          });
	        }
	
	        function computeProxies() {
	          if (firstElement && firstElement.children && !hasClick && !noProxies) {
	
	            angular.forEach(proxiedTypes, function(type) {
	              // All elements which are not capable of being used as a proxy have the .md-secondary
	              // class applied. These items were identified in the secondary wrap function.
	              angular.forEach(firstElement.querySelectorAll(type + ':not(.md-secondary)'), function(child) {
	                proxies.push(child);
	              });
	            });
	          }
	        }
	
	        function computeClickable() {
	          if (proxies.length === 1 || hasClick) {
	            $element.addClass('md-clickable');
	
	            if (!hasClick) {
	              ctrl.attachRipple($scope, angular.element($element[0].querySelector('.md-no-style')));
	            }
	          }
	        }
	
	        /**
	         * @param {MouseEvent} event
	         * @return {boolean}
	         */
	        function isEventFromControl(event) {
	          var forbiddenControls = ['md-slider'];
	          var eventBubblePath = $mdUtil.getEventPath(event);
	
	          // If there is no bubble path, then the event was not bubbled.
	          if (!eventBubblePath || eventBubblePath.length === 0) {
	            return forbiddenControls.indexOf(event.target.tagName.toLowerCase()) !== -1;
	          }
	
	          // We iterate the event bubble path up and check for a possible component.
	          // Our maximum index to search, is the list item root.
	          var maxPath = eventBubblePath.indexOf($element.children()[0]);
	
	          for (var i = 0; i < maxPath; i++) {
	            if (forbiddenControls.indexOf(eventBubblePath[i].tagName.toLowerCase()) !== -1) {
	              return true;
	            }
	          }
	          return false;
	        }
	
	        /**
	         * @param {KeyboardEvent} keypressEvent
	         */
	        var clickChildKeypressListener = function(keypressEvent) {
	          if (keypressEvent.target.nodeName !== 'INPUT' &&
	              keypressEvent.target.nodeName !== 'TEXTAREA' &&
	              !keypressEvent.target.isContentEditable) {
	            var keyCode = keypressEvent.which || keypressEvent.keyCode;
	            if (keyCode === $mdConstant.KEY_CODE.SPACE) {
	              if (clickChild) {
	                clickChild.click();
	                keypressEvent.preventDefault();
	                keypressEvent.stopPropagation();
	              }
	            }
	          }
	        };
	
	        if (!hasClick && !proxies.length) {
	          clickChild && clickChild.addEventListener('keypress', clickChildKeypressListener);
	        }
	
	        $element.off('click');
	        $element.off('keypress');
	        // Disable ng-aria's "helpful" keydown event that causes our ng-click handlers to be called
	        // twice.
	        $element.off('keydown');
	
	        if (proxies.length === 1 && clickChild) {
	          $element.children().eq(0).on('click', function(clickEvent) {
	            // When the event is coming from a control and it should not trigger the proxied element
	            // then we are skipping.
	            if (isEventFromControl(clickEvent)) return;
	
	            var parentButton = $mdUtil.getClosest(clickEvent.target, 'BUTTON');
	            if (!parentButton && clickChild.contains(clickEvent.target)) {
	              angular.forEach(proxies, function(proxy) {
	                if (clickEvent.target !== proxy && !proxy.contains(clickEvent.target)) {
	                  if (proxy.nodeName === 'MD-MENU') {
	                    proxy = proxy.children[0];
	                  }
	                  angular.element(proxy).triggerHandler('click');
	                }
	              });
	            }
	          });
	        }
	
	        $scope.$on('$destroy', function () {
	          clickChild && clickChild.removeEventListener('keypress', clickChildKeypressListener);
	        });
	      }
	    }
	  };
	}
	
	/*
	 * @private
	 * @ngdoc controller
	 * @name MdListController
	 * @module material.components.list
	 */
	function MdListController($scope, $element, $mdListInkRipple) {
	  var ctrl = this;
	  ctrl.attachRipple = attachRipple;
	
	  function attachRipple (scope, element) {
	    var options = {};
	    $mdListInkRipple.attach(scope, element, options);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.menu
	 */
	
	angular.module('material.components.menu', [
	  'material.core',
	  'material.components.backdrop'
	]);
	
	})();
	(function(){
	"use strict";
	
	
	
	MenuController.$inject = ["$mdMenu", "$attrs", "$element", "$scope", "$mdUtil", "$timeout", "$rootScope", "$q", "$log"];
	angular
	    .module('material.components.menu')
	    .controller('mdMenuCtrl', MenuController);
	
	/**
	 * @ngInject
	 */
	function MenuController($mdMenu, $attrs, $element, $scope, $mdUtil, $timeout, $rootScope, $q, $log) {
	
	  var prefixer = $mdUtil.prefixer();
	  var menuContainer;
	  var self = this;
	  var triggerElement;
	
	  this.nestLevel = parseInt($attrs.mdNestLevel, 10) || 0;
	
	  /**
	   * Called by our linking fn to provide access to the menu-content
	   * element removed during link
	   */
	  this.init = function init(setMenuContainer, opts) {
	    opts = opts || {};
	    menuContainer = setMenuContainer;
	
	    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
	    triggerElement = $element[0].querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter']));
	    triggerElement.setAttribute('aria-expanded', 'false');
	
	    this.isInMenuBar = opts.isInMenuBar;
	    this.mdMenuBarCtrl = opts.mdMenuBarCtrl;
	    this.nestedMenus = $mdUtil.nodesToArray(menuContainer[0].querySelectorAll('.md-nested-menu'));
	
	    menuContainer.on('$mdInterimElementRemove', function() {
	      self.isOpen = false;
	      $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	    });
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	
	    var menuContainerId = 'menu_container_' + $mdUtil.nextUid();
	    menuContainer.attr('id', menuContainerId);
	    angular.element(triggerElement).attr({
	      'aria-owns': menuContainerId,
	      'aria-haspopup': 'true'
	    });
	
	    $scope.$on('$destroy', angular.bind(this, function() {
	      this.disableHoverListener();
	      $mdMenu.destroy();
	    }));
	
	    menuContainer.on('$destroy', function() {
	      $mdMenu.destroy();
	    });
	  };
	
	  var openMenuTimeout, menuItems, deregisterScopeListeners = [];
	  this.enableHoverListener = function() {
	    deregisterScopeListeners.push($rootScope.$on('$mdMenuOpen', function(event, el) {
	      if (menuContainer[0].contains(el[0])) {
	        self.currentlyOpenMenu = el.controller('mdMenu');
	        self.isAlreadyOpening = false;
	        self.currentlyOpenMenu.registerContainerProxy(self.triggerContainerProxy.bind(self));
	      }
	    }));
	    deregisterScopeListeners.push($rootScope.$on('$mdMenuClose', function(event, el) {
	      if (menuContainer[0].contains(el[0])) {
	        self.currentlyOpenMenu = undefined;
	      }
	    }));
	    menuItems = angular.element($mdUtil.nodesToArray(menuContainer[0].children[0].children));
	    menuItems.on('mouseenter', self.handleMenuItemHover);
	    menuItems.on('mouseleave', self.handleMenuItemMouseLeave);
	  };
	
	  this.disableHoverListener = function() {
	    while (deregisterScopeListeners.length) {
	      deregisterScopeListeners.shift()();
	    }
	    menuItems && menuItems.off('mouseenter', self.handleMenuItemHover);
	    menuItems && menuItems.off('mouseleave', self.handleMenuItemMouseLeave);
	  };
	
	  this.handleMenuItemHover = function(event) {
	    if (self.isAlreadyOpening) return;
	    var nestedMenu = (
	      event.target.querySelector('md-menu')
	        || $mdUtil.getClosest(event.target, 'MD-MENU')
	    );
	    openMenuTimeout = $timeout(function() {
	      if (nestedMenu) {
	        nestedMenu = angular.element(nestedMenu).controller('mdMenu');
	      }
	
	      if (self.currentlyOpenMenu && self.currentlyOpenMenu != nestedMenu) {
	        var closeTo = self.nestLevel + 1;
	        self.currentlyOpenMenu.close(true, { closeTo: closeTo });
	        self.isAlreadyOpening = !!nestedMenu;
	        nestedMenu && nestedMenu.open();
	      } else if (nestedMenu && !nestedMenu.isOpen && nestedMenu.open) {
	        self.isAlreadyOpening = !!nestedMenu;
	        nestedMenu && nestedMenu.open();
	      }
	    }, nestedMenu ? 100 : 250);
	    var focusableTarget = event.currentTarget.querySelector('.md-button:not([disabled])');
	    focusableTarget && focusableTarget.focus();
	  };
	
	  this.handleMenuItemMouseLeave = function() {
	    if (openMenuTimeout) {
	      $timeout.cancel(openMenuTimeout);
	      openMenuTimeout = undefined;
	    }
	  };
	
	
	  /**
	   * Uses the $mdMenu interim element service to open the menu contents
	   */
	  this.open = function openMenu(ev) {
	    ev && ev.stopPropagation();
	    ev && ev.preventDefault();
	    if (self.isOpen) return;
	    self.enableHoverListener();
	    self.isOpen = true;
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	    triggerElement = triggerElement || (ev ? ev.target : $element[0]);
	    triggerElement.setAttribute('aria-expanded', 'true');
	    $scope.$emit('$mdMenuOpen', $element);
	    $mdMenu.show({
	      scope: $scope,
	      mdMenuCtrl: self,
	      nestLevel: self.nestLevel,
	      element: menuContainer,
	      target: triggerElement,
	      preserveElement: true,
	      parent: 'body'
	    }).finally(function() {
	      triggerElement.setAttribute('aria-expanded', 'false');
	      self.disableHoverListener();
	    });
	  };
	
	  this.onIsOpenChanged = function(isOpen) {
	    if (isOpen) {
	      menuContainer.attr('aria-hidden', 'false');
	      $element[0].classList.add('md-open');
	      angular.forEach(self.nestedMenus, function(el) {
	        el.classList.remove('md-open');
	      });
	    } else {
	      menuContainer.attr('aria-hidden', 'true');
	      $element[0].classList.remove('md-open');
	    }
	    $scope.$mdMenuIsOpen = self.isOpen;
	  };
	
	  this.focusMenuContainer = function focusMenuContainer() {
	    var focusTarget = menuContainer[0]
	      .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));
	
	    if (!focusTarget) focusTarget = menuContainer[0].querySelector('.md-button:not([disabled])');
	    focusTarget.focus();
	  };
	
	  this.registerContainerProxy = function registerContainerProxy(handler) {
	    this.containerProxy = handler;
	  };
	
	  this.triggerContainerProxy = function triggerContainerProxy(ev) {
	    this.containerProxy && this.containerProxy(ev);
	  };
	
	  this.destroy = function() {
	    return self.isOpen ? $mdMenu.destroy() : $q.when(false);
	  };
	
	  // Use the $mdMenu interim element service to close the menu contents
	  this.close = function closeMenu(skipFocus, closeOpts) {
	    if (!self.isOpen) return;
	    self.isOpen = false;
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	
	    var eventDetails = angular.extend({}, closeOpts, { skipFocus: skipFocus });
	    $scope.$emit('$mdMenuClose', $element, eventDetails);
	    $mdMenu.hide(null, closeOpts);
	
	    if (!skipFocus) {
	      var el = self.restoreFocusTo || $element.find('button')[0];
	      if (el instanceof angular.element) el = el[0];
	      if (el) el.focus();
	    }
	  };
	
	  /**
	   * Build a nice object out of our string attribute which specifies the
	   * target mode for left and top positioning
	   */
	  this.positionMode = function positionMode() {
	    var attachment = ($attrs.mdPositionMode || 'target').split(' ');
	
	    // If attachment is a single item, duplicate it for our second value.
	    // ie. 'target' -> 'target target'
	    if (attachment.length === 1) {
	      attachment.push(attachment[0]);
	    }
	
	    return {
	      left: attachment[0],
	      top: attachment[1]
	    };
	  };
	
	  /**
	   * Build a nice object out of our string attribute which specifies
	   * the offset of top and left in pixels.
	   */
	  this.offsets = function offsets() {
	    var position = ($attrs.mdOffset || '0 0').split(' ').map(parseFloat);
	    if (position.length === 2) {
	      return {
	        left: position[0],
	        top: position[1]
	      };
	    } else if (position.length === 1) {
	      return {
	        top: position[0],
	        left: position[0]
	      };
	    } else {
	      throw Error('Invalid offsets specified. Please follow format <x, y> or <n>');
	    }
	  };
	
	  // Functionality that is exposed in the view.
	  $scope.$mdMenu = {
	    open: this.open,
	    close: this.close
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdMenu
	 * @module material.components.menu
	 * @restrict E
	 * @description
	 *
	 * Menus are elements that open when clicked. They are useful for displaying
	 * additional options within the context of an action.
	 *
	 * Every `md-menu` must specify exactly two child elements. The first element is what is
	 * left in the DOM and is used to open the menu. This element is called the trigger element.
	 * The trigger element's scope has access to `$mdMenu.open($event)`
	 * which it may call to open the menu. By passing $event as argument, the
	 * corresponding event is stopped from propagating up the DOM-tree. Similarly, `$mdMenu.close()`
	 * can be used to close the menu.
	 *
	 * The second element is the `md-menu-content` element which represents the
	 * contents of the menu when it is open. Typically this will contain `md-menu-item`s,
	 * but you can do custom content as well.
	 *
	 * <hljs lang="html">
	 * <md-menu>
	 *  <!-- Trigger element is a md-button with an icon -->
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open sample menu">
	 *    <md-icon md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	
	 * ## Sizing Menus
	 *
	 * The width of the menu when it is open may be specified by specifying a `width`
	 * attribute on the `md-menu-content` element.
	 * See the [Material Design Spec](https://material.io/archive/guidelines/components/menus.html#menus-simple-menus)
	 * for more information.
	 *
	 * ## Menu Density
	 *
	 * You can use dense menus by adding the `md-dense` class to the `md-menu-content` element.
	 * This reduces the height of menu items, their top and bottom padding, and default font size.
	 * Without the `md-dense` class, we use the "mobile" height of `48px`. With the `md-dense` class,
	 * we use the "desktop" height of `32px`. We do not support the "dense desktop" option in the spec,
	 * which uses a height of `24px`, at this time.
	 * See the [Menu Specs](https://material.io/archive/guidelines/components/menus.html#menus-specs)
	 * section of the Material Design Spec for more information.
	 *
	 * ## Aligning Menus
	 *
	 * When a menu opens, it is important that the content aligns with the trigger element.
	 * Failure to align menus can result in jarring experiences for users as content
	 * suddenly shifts. To help with this, `md-menu` provides several APIs to help
	 * with alignment.
	 *
	 * ### Target Mode
	 *
	 * By default, `md-menu` will attempt to align the `md-menu-content` by aligning
	 * designated child elements in both the trigger and the menu content.
	 *
	 * To specify the alignment element in the `trigger` you can use the `md-menu-origin`
	 * attribute on a child element. If no `md-menu-origin` is specified, the `md-menu`
	 * will be used as the origin element.
	 *
	 * Similarly, the `md-menu-content` may specify a `md-menu-align-target` for a
	 * `md-menu-item` to specify the node that it should try and align with.
	 *
	 * In this example code, we specify an icon to be our origin element, and an
	 * icon in our menu content to be our alignment target. This ensures that both
	 * icons are aligned when the menu opens.
	 *
	 * <hljs lang="html">
	 * <md-menu>
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open some menu">
	 *    <md-icon md-menu-origin md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item>
	 *      <md-button ng-click="doSomething()" aria-label="Do something">
	 *        <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
	 *        Do Something
	 *      </md-button>
	 *    </md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	 *
	 * ### Position Mode
	 *
	 * We can specify the origin of the menu by using the `md-position-mode` attribute.
	 * This attribute allows specifying the positioning by the `x` and `y` axes.
	 *
	 * The default mode is `target target`. This mode uses the left and top edges of the origin element
	 * to position the menu in LTR layouts. The `x` axis modes will adjust when in RTL layouts.
	 *
	 * Sometimes you want to specify alignment from the right side of a origin element. For example,
	 * if we have a menu on the right side a toolbar, we may want to right align our menu content.
	 * We can use `target-right target` to specify a right-oriented alignment target.
	 * There is a working example of this in the Menu Position Modes demo.
	 *
	 * #### Horizontal Positioning Options
	 * - `target`
	 * - `target-left`
	 * - `target-right`
	 * - `cascade`
	 * - `right`
	 * - `left`
	 *
	 * #### Vertical Positioning Options
	 * - `target`
	 * - `cascade`
	 * - `bottom`
	 *
	 * ### Menu Offsets
	 *
	 * It is sometimes unavoidable to need to have a deeper level of control for
	 * the positioning of a menu to ensure perfect alignment. `md-menu` provides
	 * the `md-offset` attribute to allow pixel-level specificity when adjusting
	 * menu positioning.
	 *
	 * This offset is provided in the format of `x y` or `n` where `n` will be used
	 * in both the `x` and `y` axis.
	 * For example, to move a menu by `2px` down from the top, we can use:
	 *
	 * <hljs lang="html">
	 * <md-menu md-offset="0 2">
	 *   <!-- menu-content -->
	 * </md-menu>
	 * </hljs>
	 *
	 * Specifying `md-offset="2 2"` would shift the menu two pixels down and two pixels to the right.
	 *
	 * ### Auto Focus
	 * By default, when a menu opens, `md-menu` focuses the first button in the menu content.
	 *
	 * Sometimes you would like to focus another menu item instead of the first.<br/>
	 * This can be done by applying the `md-autofocus` directive on the given element.
	 *
	 * <hljs lang="html">
	 * <md-menu-item>
	 *   <md-button md-autofocus ng-click="doSomething()">
	 *     Auto Focus
	 *   </md-button>
	 * </md-menu-item>
	 * </hljs>
	 *
	 *
	 * ### Preventing close
	 *
	 * Sometimes you would like to be able to click on a menu item without having the menu
	 * close. To do this, AngularJS Material exposes the `md-prevent-menu-close` attribute which
	 * can be added to a button inside a menu to stop the menu from automatically closing.
	 * You can then close the menu either by using `$mdMenu.close()` in the template,
	 * or programmatically by injecting `$mdMenu` and calling `$mdMenu.hide()`.
	 *
	 * <hljs lang="html">
	 * <md-menu-content ng-mouseleave="$mdMenu.close()">
	 *   <md-menu-item>
	 *     <md-button ng-click="doSomething()" aria-label="Do something" md-prevent-menu-close="md-prevent-menu-close">
	 *       <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
	 *       Do Something
	 *     </md-button>
	 *   </md-menu-item>
	 * </md-menu-content>
	 * </hljs>
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-menu>
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button">
	 *    <md-icon md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	 *
	 * @param {string=} md-position-mode Specify pre-defined position modes for the `x` and `y` axes.
	 *  The default modes are `target target`. This positions the origin of the menu using the left and top edges
	 *  of the origin element in LTR layouts.<br>
	 *  #### Valid modes for horizontal positioning
	 * - `target`
	 * - `target-left`
	 * - `target-right`
	 * - `cascade`
	 * - `right`
	 * - `left`<br>
	 *  #### Valid modes for vertical positioning
	 * - `target`
	 * - `cascade`
	 * - `bottom`
	 * @param {string=} md-offset An offset to apply to the dropdown on opening, after positioning.
	 *  Defined as `x` and `y` pixel offset values in the form of `x y`.<br>
	 *  The default value is `0 0`.
	 */
	MenuDirective.$inject = ["$mdUtil"];
	angular
	    .module('material.components.menu')
	    .directive('mdMenu', MenuDirective);
	
	/**
	 * @ngInject
	 */
	function MenuDirective($mdUtil) {
	  var INVALID_PREFIX = 'Invalid HTML for md-menu: ';
	  return {
	    restrict: 'E',
	    require: ['mdMenu', '?^mdMenuBar'],
	    controller: 'mdMenuCtrl', // empty function to be built by link
	    scope: true,
	    compile: compile
	  };
	
	  function compile(templateElement) {
	    templateElement.addClass('md-menu');
	
	    var triggerEl = templateElement.children()[0];
	    var prefixer = $mdUtil.prefixer();
	
	    if (!prefixer.hasAttribute(triggerEl, 'ng-click')) {
	      triggerEl = triggerEl
	          .querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter'])) || triggerEl;
	    }
	
	    var isButtonTrigger = triggerEl.nodeName === 'MD-BUTTON' || triggerEl.nodeName === 'BUTTON';
	
	    if (triggerEl && isButtonTrigger && !triggerEl.hasAttribute('type')) {
	      triggerEl.setAttribute('type', 'button');
	    }
	
	    if (!triggerEl) {
	      throw Error(INVALID_PREFIX + 'Expected the menu to have a trigger element.');
	    }
	
	    if (templateElement.children().length !== 2) {
	      throw Error(INVALID_PREFIX + 'Expected two children elements. The second element must have a `md-menu-content` element.');
	    }
	
	    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
	    triggerEl && triggerEl.setAttribute('aria-haspopup', 'true');
	
	    var nestedMenus = templateElement[0].querySelectorAll('md-menu');
	    var nestingDepth = parseInt(templateElement[0].getAttribute('md-nest-level'), 10) || 0;
	    if (nestedMenus) {
	      angular.forEach($mdUtil.nodesToArray(nestedMenus), function(menuEl) {
	        if (!menuEl.hasAttribute('md-position-mode')) {
	          menuEl.setAttribute('md-position-mode', 'cascade');
	        }
	        menuEl.classList.add('_md-nested-menu');
	        menuEl.setAttribute('md-nest-level', nestingDepth + 1);
	      });
	    }
	    return link;
	  }
	
	  function link(scope, element, attr, ctrls) {
	    var mdMenuCtrl = ctrls[0];
	    var isInMenuBar = !!ctrls[1];
	    var mdMenuBarCtrl = ctrls[1];
	    // Move everything into a md-menu-container and pass it to the controller
	    var menuContainer = angular.element('<div class="_md md-open-menu-container md-whiteframe-z2"></div>');
	    var menuContents = element.children()[1];
	
	    element.addClass('_md');     // private md component indicator for styling
	
	    if (!menuContents.hasAttribute('role')) {
	      menuContents.setAttribute('role', 'menu');
	    }
	    menuContainer.append(menuContents);
	
	    element.on('$destroy', function() {
	      menuContainer.remove();
	    });
	
	    element.append(menuContainer);
	    menuContainer[0].style.display = 'none';
	    mdMenuCtrl.init(menuContainer, { isInMenuBar: isInMenuBar, mdMenuBarCtrl: mdMenuBarCtrl });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MenuProvider.$inject = ["$$interimElementProvider"];angular
	  .module('material.components.menu')
	  .provider('$mdMenu', MenuProvider);
	
	/**
	 * Interim element provider for the menu.
	 * Handles behavior for a menu while it is open, including:
	 *    - handling animating the menu opening/closing
	 *    - handling key/mouse events on the menu element
	 *    - handling enabling/disabling scroll while the menu is open
	 *    - handling redrawing during resizes and orientation changes
	 *
	 */
	
	function MenuProvider($$interimElementProvider) {
	  menuDefaultOptions.$inject = ["$mdUtil", "$mdTheming", "$mdConstant", "$document", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$log"];
	  var MENU_EDGE_MARGIN = 8;
	
	  return $$interimElementProvider('$mdMenu')
	    .setDefaults({
	      methods: ['target'],
	      options: menuDefaultOptions
	    });
	
	  /* @ngInject */
	  function menuDefaultOptions($mdUtil, $mdTheming, $mdConstant, $document, $window, $q, $$rAF,
	                              $animateCss, $animate, $log) {
	
	    var prefixer = $mdUtil.prefixer();
	    var animator = $mdUtil.dom.animator;
	
	    return {
	      parent: 'body',
	      onShow: onShow,
	      onRemove: onRemove,
	      hasBackdrop: true,
	      disableParentScroll: true,
	      skipCompile: true,
	      preserveScope: true,
	      multiple: true,
	      themable: true
	    };
	
	    /**
	     * Show modal backdrop element...
	     * @returns {function(): void} A function that removes this backdrop
	     */
	    function showBackdrop(scope, element, options) {
	      if (options.nestLevel) return angular.noop;
	
	      // If we are not within a dialog...
	      if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
	        // !! DO this before creating the backdrop; since disableScrollAround()
	        //    configures the scroll offset; which is used by mdBackDrop postLink()
	        options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
	      } else {
	        options.disableParentScroll = false;
	      }
	
	      if (options.hasBackdrop) {
	        options.backdrop = $mdUtil.createBackdrop(scope, "md-menu-backdrop md-click-catcher");
	
	        $animate.enter(options.backdrop, options.backdropParent || $document[0].body);
	      }
	
	      /**
	       * Hide and destroys the backdrop created by showBackdrop()
	       */
	      return function hideBackdrop() {
	        if (options.backdrop) options.backdrop.remove();
	        if (options.disableParentScroll) options.restoreScroll();
	      };
	    }
	
	    /**
	     * Removing the menu element from the DOM and remove all associated event listeners
	     * and backdrop
	     */
	    function onRemove(scope, element, opts) {
	      opts.cleanupInteraction();
	      opts.cleanupBackdrop();
	      opts.cleanupResizing();
	      opts.hideBackdrop();
	
	      // Before the menu is closing remove the clickable class.
	      element.removeClass('md-clickable');
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	
	      return (opts.$destroy === true) ? detachAndClean() : animateRemoval().then(detachAndClean);
	
	      /**
	       * For normal closes, animate the removal.
	       * For forced closes (like $destroy events), skip the animations
	       */
	      function animateRemoval() {
	        return $animateCss(element, {addClass: 'md-leave'}).start();
	      }
	
	      /**
	       * Detach the element
	       */
	      function detachAndClean() {
	        element.removeClass('md-active');
	        detachElement(element, opts);
	        opts.alreadyOpen = false;
	      }
	
	    }
	
	    /**
	     * Inserts and configures the staged Menu element into the DOM, positioning it,
	     * and wiring up various interaction events
	     */
	    function onShow(scope, element, opts) {
	      sanitizeAndConfigure(opts);
	
	      if (opts.menuContentEl[0]) {
	        // Inherit the theme from the target element.
	        $mdTheming.inherit(opts.menuContentEl, opts.target);
	      } else {
	        $log.warn(
	          '$mdMenu: Menu elements should always contain a `md-menu-content` element,' +
	          'otherwise interactivity features will not work properly.',
	          element
	        );
	      }
	
	      // Register various listeners to move menu on resize/orientation change
	      opts.cleanupResizing = startRepositioningOnResize();
	      opts.hideBackdrop = showBackdrop(scope, element, opts);
	
	      // Return the promise for when our menu is done animating in
	      return showMenu()
	        .then(function(response) {
	          opts.alreadyOpen = true;
	          opts.cleanupInteraction = activateInteraction();
	          opts.cleanupBackdrop = setupBackdrop();
	
	          // Since the menu finished its animation, mark the menu as clickable.
	          element.addClass('md-clickable');
	
	          return response;
	        });
	
	      /**
	       * Place the menu into the DOM and call positioning related functions
	       */
	      function showMenu() {
	        opts.parent.append(element);
	        element[0].style.display = '';
	
	        return $q(function(resolve) {
	          var position = calculateMenuPosition(element, opts);
	
	          element.removeClass('md-leave');
	
	          // Animate the menu scaling, and opacity [from its position origin (default == top-left)]
	          // to normal scale.
	          $animateCss(element, {
	            addClass: 'md-active',
	            from: animator.toCss(position),
	            to: animator.toCss({transform: ''})
	          })
	          .start()
	          .then(resolve);
	
	        });
	      }
	
	      /**
	       * Check for valid opts and set some useful defaults
	       */
	      function sanitizeAndConfigure() {
	        if (!opts.target) {
	          throw Error(
	            '$mdMenu.show() expected a target to animate from in options.target'
	          );
	        }
	        angular.extend(opts, {
	          alreadyOpen: false,
	          isRemoved: false,
	          target: angular.element(opts.target), // make sure it's not a naked DOM node
	          parent: angular.element(opts.parent),
	          menuContentEl: angular.element(element[0].querySelector('md-menu-content'))
	        });
	      }
	
	      /**
	       * Configure various resize listeners for screen changes
	       */
	      function startRepositioningOnResize() {
	
	        var repositionMenu = (function(target, options) {
	          return $$rAF.throttle(function() {
	            if (opts.isRemoved) return;
	            var position = calculateMenuPosition(target, options);
	
	            target.css(animator.toCss(position));
	          });
	        })(element, opts);
	
	        $window.addEventListener('resize', repositionMenu);
	        $window.addEventListener('orientationchange', repositionMenu);
	
	        return function stopRepositioningOnResize() {
	
	          // Disable resizing handlers
	          $window.removeEventListener('resize', repositionMenu);
	          $window.removeEventListener('orientationchange', repositionMenu);
	
	        };
	      }
	
	      /**
	       * Sets up the backdrop and listens for click elements.
	       * Once the backdrop will be clicked, the menu will automatically close.
	       * @returns {!Function} Function to remove the backdrop.
	       */
	      function setupBackdrop() {
	        if (!opts.backdrop) return angular.noop;
	
	        opts.backdrop.on('click', onBackdropClick);
	
	        return function() {
	          opts.backdrop.off('click', onBackdropClick);
	        };
	      }
	
	      /**
	       * Function to be called whenever the backdrop is clicked.
	       * @param {!MouseEvent} event
	       */
	      function onBackdropClick(event) {
	        event.preventDefault();
	        event.stopPropagation();
	
	        scope.$apply(function() {
	          opts.mdMenuCtrl.close(true, { closeAll: true });
	        });
	      }
	
	      /**
	       * Activate interaction on the menu. Resolves the focus target and closes the menu on
	       * escape or option click.
	       * @returns {!Function} Function to deactivate the interaction listeners.
	       */
	      function activateInteraction() {
	        if (!opts.menuContentEl[0]) return angular.noop;
	
	        // Wire up keyboard listeners.
	        // - Close on escape,
	        // - focus next item on down arrow,
	        // - focus prev item on up
	        opts.menuContentEl.on('keydown', onMenuKeyDown);
	        opts.menuContentEl[0].addEventListener('click', captureClickListener, true);
	
	        // kick off initial focus in the menu on the first enabled element
	        var focusTarget = opts.menuContentEl[0]
	          .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));
	
	        if (!focusTarget) {
	          var childrenLen = opts.menuContentEl[0].children.length;
	          for (var childIndex = 0; childIndex < childrenLen; childIndex++) {
	            var child = opts.menuContentEl[0].children[childIndex];
	            focusTarget = child.querySelector('.md-button:not([disabled])');
	            if (focusTarget) {
	              break;
	            }
	            // Need to check the attribute as well since this might be a custom element whose
	            // disabled property is undefined.
	            if (child.firstElementChild && !child.firstElementChild.disabled &&
	                !child.firstElementChild.getAttribute('disabled')) {
	              focusTarget = child.firstElementChild;
	              break;
	            }
	          }
	        }
	
	        focusTarget && focusTarget.focus();
	
	        return function cleanupInteraction() {
	          opts.menuContentEl.off('keydown', onMenuKeyDown);
	          opts.menuContentEl[0].removeEventListener('click', captureClickListener, true);
	        };
	
	        // ************************************
	        // internal functions
	        // ************************************
	
	        function onMenuKeyDown(ev) {
	          var handled;
	          switch (ev.keyCode) {
	            case $mdConstant.KEY_CODE.ESCAPE:
	              if (opts.nestLevel) {
	                opts.mdMenuCtrl.close();
	              } else {
	                opts.mdMenuCtrl.close(false, { closeAll: true });
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.TAB:
	              opts.mdMenuCtrl.close(false, { closeAll: true });
	              // Don't prevent default or stop propagation on this event as we want tab
	              // to move the focus to the next focusable element on the page.
	              handled = false;
	              break;
	            case $mdConstant.KEY_CODE.UP_ARROW:
	              if (!focusMenuItem(ev, opts.menuContentEl, opts, -1) && !opts.nestLevel) {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.DOWN_ARROW:
	              if (!focusMenuItem(ev, opts.menuContentEl, opts, 1) && !opts.nestLevel) {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.LEFT_ARROW:
	              if (opts.nestLevel) {
	                opts.mdMenuCtrl.close();
	              } else {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.RIGHT_ARROW:
	              var parentMenu = $mdUtil.getClosest(ev.target, 'MD-MENU');
	              if (parentMenu && parentMenu != opts.parent[0]) {
	                ev.target.click();
	              } else {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	          }
	          if (handled) {
	            ev.preventDefault();
	            ev.stopImmediatePropagation();
	          }
	        }
	
	        function onBackdropClick(e) {
	          e.preventDefault();
	          e.stopPropagation();
	          scope.$apply(function() {
	            opts.mdMenuCtrl.close(true, { closeAll: true });
	          });
	        }
	
	        // Close menu on menu item click, if said menu-item is not disabled
	        function captureClickListener(e) {
	          var target = e.target;
	          // Traverse up the event until we get to the menuContentEl to see if
	          // there is an ng-click and that the ng-click is not disabled
	          do {
	            if (target == opts.menuContentEl[0]) return;
	            if ((hasAnyAttribute(target, ['ng-click', 'ng-href', 'ui-sref']) ||
	                target.nodeName == 'BUTTON' || target.nodeName == 'MD-BUTTON') && !hasAnyAttribute(target, ['md-prevent-menu-close'])) {
	              var closestMenu = $mdUtil.getClosest(target, 'MD-MENU');
	              if (!target.hasAttribute('disabled') && (!closestMenu || closestMenu == opts.parent[0])) {
	                close();
	              }
	              break;
	            }
	          } while (target = target.parentNode);
	
	          function close() {
	            scope.$apply(function() {
	              opts.mdMenuCtrl.close(true, { closeAll: true });
	            });
	          }
	
	          function hasAnyAttribute(target, attrs) {
	            if (!target) return false;
	
	            for (var i = 0, attr; attr = attrs[i]; ++i) {
	              if (prefixer.hasAttribute(target, attr)) {
	                return true;
	              }
	            }
	
	            return false;
	          }
	        }
	
	      }
	    }
	
	    /**
	     * Takes a keypress event and focuses the next/previous menu
	     * item from the emitting element
	     * @param {event} e - The origin keypress event
	     * @param {angular.element} menuEl - The menu element
	     * @param {object} opts - The interim element options for the mdMenu
	     * @param {number} direction - The direction to move in (+1 = next, -1 = prev)
	     */
	    function focusMenuItem(e, menuEl, opts, direction) {
	      var currentItem = $mdUtil.getClosest(e.target, 'MD-MENU-ITEM');
	
	      var items = $mdUtil.nodesToArray(menuEl[0].children);
	      var currentIndex = items.indexOf(currentItem);
	
	      // Traverse through our elements in the specified direction (+/-1) and try to
	      // focus them until we find one that accepts focus
	      var didFocus;
	      for (var i = currentIndex + direction; i >= 0 && i < items.length; i = i + direction) {
	        var focusTarget = items[i].querySelector('.md-button');
	        didFocus = attemptFocus(focusTarget);
	        if (didFocus) {
	          break;
	        }
	      }
	      return didFocus;
	    }
	
	    /**
	     * Attempts to focus an element. Checks whether that element is the currently
	     * focused element after attempting.
	     * @param {HTMLElement} el - the element to attempt focus on
	     * @returns {boolean} - whether the element was successfully focused
	     */
	    function attemptFocus(el) {
	      if (el && el.getAttribute('tabindex') != -1) {
	        el.focus();
	        return ($document[0].activeElement == el);
	      }
	    }
	
	    /**
	     * Use browser to remove this element without triggering a $destroy event
	     */
	    function detachElement(element, opts) {
	      if (!opts.preserveElement) {
	        if (toNode(element).parentNode === toNode(opts.parent)) {
	          toNode(opts.parent).removeChild(toNode(element));
	        }
	      } else {
	        toNode(element).style.display = 'none';
	      }
	    }
	
	    /**
	     * Computes menu position and sets the style on the menu container
	     * @param {HTMLElement} el - the menu container element
	     * @param {object} opts - the interim element options object
	     */
	    function calculateMenuPosition(el, opts) {
	
	      var containerNode = el[0],
	        openMenuNode = el[0].firstElementChild,
	        openMenuNodeRect = openMenuNode.getBoundingClientRect(),
	        boundryNode = $document[0].body,
	        boundryNodeRect = boundryNode.getBoundingClientRect();
	
	      var menuStyle = $window.getComputedStyle(openMenuNode);
	
	      var originNode = opts.target[0].querySelector(prefixer.buildSelector('md-menu-origin')) || opts.target[0],
	        originNodeRect = originNode.getBoundingClientRect();
	
	      var bounds = {
	        left: boundryNodeRect.left + MENU_EDGE_MARGIN,
	        top: Math.max(boundryNodeRect.top, 0) + MENU_EDGE_MARGIN,
	        bottom: Math.max(boundryNodeRect.bottom, Math.max(boundryNodeRect.top, 0) + boundryNodeRect.height) - MENU_EDGE_MARGIN,
	        right: boundryNodeRect.right - MENU_EDGE_MARGIN
	      };
	
	      var alignTarget, alignTargetRect = { top:0, left : 0, right:0, bottom:0 }, existingOffsets  = { top:0, left : 0, right:0, bottom:0  };
	      var positionMode = opts.mdMenuCtrl.positionMode();
	
	      if (positionMode.top === 'target' || positionMode.left === 'target' || positionMode.left === 'target-right') {
	        alignTarget = firstVisibleChild();
	        if (alignTarget) {
	          // TODO: Allow centering on an arbitrary node, for now center on first menu-item's child
	          alignTarget = alignTarget.firstElementChild || alignTarget;
	          alignTarget = alignTarget.querySelector(prefixer.buildSelector('md-menu-align-target')) || alignTarget;
	          alignTargetRect = alignTarget.getBoundingClientRect();
	
	          existingOffsets = {
	            top: parseFloat(containerNode.style.top || 0),
	            left: parseFloat(containerNode.style.left || 0)
	          };
	        }
	      }
	
	      var position = {};
	      var transformOrigin = 'top ';
	
	      switch (positionMode.top) {
	        case 'target':
	          position.top = existingOffsets.top + originNodeRect.top - alignTargetRect.top;
	          break;
	        case 'cascade':
	          position.top = originNodeRect.top - parseFloat(menuStyle.paddingTop) - originNode.style.top;
	          break;
	        case 'bottom':
	          position.top = originNodeRect.top + originNodeRect.height;
	          break;
	        default:
	          throw new Error('Invalid target mode "' + positionMode.top + '" specified for md-menu on Y axis.');
	      }
	
	      var rtl = $mdUtil.isRtl(el);
	
	      switch (positionMode.left) {
	        case 'target':
	          position.left = existingOffsets.left + originNodeRect.left - alignTargetRect.left;
	          transformOrigin += rtl ? 'right'  : 'left';
	          break;
	        case 'target-left':
	          position.left = originNodeRect.left;
	          transformOrigin += 'left';
	          break;
	        case 'target-right':
	          position.left = originNodeRect.right - openMenuNodeRect.width + (openMenuNodeRect.right - alignTargetRect.right);
	          transformOrigin += 'right';
	          break;
	        case 'cascade':
	          var willFitRight = rtl ? (originNodeRect.left - openMenuNodeRect.width) < bounds.left : (originNodeRect.right + openMenuNodeRect.width) < bounds.right;
	          position.left = willFitRight ? originNodeRect.right - originNode.style.left : originNodeRect.left - originNode.style.left - openMenuNodeRect.width;
	          transformOrigin += willFitRight ? 'left' : 'right';
	          break;
	        case 'right':
	          if (rtl) {
	            position.left = originNodeRect.right - originNodeRect.width;
	            transformOrigin += 'left';
	          } else {
	            position.left = originNodeRect.right - openMenuNodeRect.width;
	            transformOrigin += 'right';
	          }
	          break;
	        case 'left':
	          if (rtl) {
	            position.left = originNodeRect.right - openMenuNodeRect.width;
	            transformOrigin += 'right';
	          } else {
	            position.left = originNodeRect.left;
	            transformOrigin += 'left';
	          }
	          break;
	        default:
	          throw new Error('Invalid target mode "' + positionMode.left + '" specified for md-menu on X axis.');
	      }
	
	      var offsets = opts.mdMenuCtrl.offsets();
	      position.top += offsets.top;
	      position.left += offsets.left;
	
	      clamp(position);
	
	      var scaleX = Math.round(100 * Math.min(originNodeRect.width / containerNode.offsetWidth, 1.0)) / 100;
	      var scaleY = Math.round(100 * Math.min(originNodeRect.height / containerNode.offsetHeight, 1.0)) / 100;
	
	      return {
	        top: Math.round(position.top),
	        left: Math.round(position.left),
	        // Animate a scale out if we aren't just repositioning
	        transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : undefined,
	        transformOrigin: transformOrigin
	      };
	
	      /**
	       * Clamps the repositioning of the menu within the confines of
	       * bounding element (often the screen/body)
	       */
	      function clamp(pos) {
	        pos.top = Math.max(Math.min(pos.top, bounds.bottom - containerNode.offsetHeight), bounds.top);
	        pos.left = Math.max(Math.min(pos.left, bounds.right - containerNode.offsetWidth), bounds.left);
	      }
	
	      /**
	       * Gets the first visible child in the openMenuNode
	       * Necessary incase menu nodes are being dynamically hidden
	       */
	      function firstVisibleChild() {
	        for (var i = 0; i < openMenuNode.children.length; ++i) {
	          if ($window.getComputedStyle(openMenuNode.children[i]).display != 'none') {
	            return openMenuNode.children[i];
	          }
	        }
	      }
	    }
	  }
	  function toNode(el) {
	    if (el instanceof angular.element) {
	      el = el[0];
	    }
	    return el;
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.menuBar
	 */
	
	angular.module('material.components.menuBar', [
	  'material.core',
	  'material.components.icon',
	  'material.components.menu'
	]);
	
	})();
	(function(){
	"use strict";
	
	
	MenuBarController.$inject = ["$scope", "$rootScope", "$element", "$attrs", "$mdConstant", "$document", "$mdUtil", "$timeout"];
	angular
	  .module('material.components.menuBar')
	  .controller('MenuBarController', MenuBarController);
	
	var BOUND_MENU_METHODS = ['handleKeyDown', 'handleMenuHover', 'scheduleOpenHoveredMenu', 'cancelScheduledOpen'];
	
	/**
	 * @ngInject
	 */
	function MenuBarController($scope, $rootScope, $element, $attrs, $mdConstant, $document, $mdUtil, $timeout) {
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$mdConstant = $mdConstant;
	  this.$mdUtil = $mdUtil;
	  this.$document = $document;
	  this.$scope = $scope;
	  this.$rootScope = $rootScope;
	  this.$timeout = $timeout;
	
	  var self = this;
	  angular.forEach(BOUND_MENU_METHODS, function(methodName) {
	    self[methodName] = angular.bind(self, self[methodName]);
	  });
	}
	
	MenuBarController.prototype.init = function() {
	  var $element = this.$element;
	  var $mdUtil = this.$mdUtil;
	  var $scope = this.$scope;
	
	  var self = this;
	  var deregisterFns = [];
	  $element.on('keydown', this.handleKeyDown);
	  this.parentToolbar = $mdUtil.getClosest($element, 'MD-TOOLBAR');
	
	  deregisterFns.push(this.$rootScope.$on('$mdMenuOpen', function(event, el) {
	    if (self.getMenus().indexOf(el[0]) != -1) {
	      $element[0].classList.add('md-open');
	      el[0].classList.add('md-open');
	      self.currentlyOpenMenu = el.controller('mdMenu');
	      self.currentlyOpenMenu.registerContainerProxy(self.handleKeyDown);
	      self.enableOpenOnHover();
	    }
	  }));
	
	  deregisterFns.push(this.$rootScope.$on('$mdMenuClose', function(event, el, opts) {
	    var rootMenus = self.getMenus();
	    if (rootMenus.indexOf(el[0]) != -1) {
	      $element[0].classList.remove('md-open');
	      el[0].classList.remove('md-open');
	    }
	
	    var ctrl = angular.element(el[0]).controller('mdMenu');
	    if (ctrl.isInMenuBar && ctrl.mdMenuBarCtrl === self) {
	      var parentMenu = el[0];
	      while (parentMenu && rootMenus.indexOf(parentMenu) == -1) {
	        parentMenu = $mdUtil.getClosest(parentMenu, 'MD-MENU', true);
	      }
	      if (parentMenu) {
	        if (!opts.skipFocus) parentMenu.querySelector('button:not([disabled])').focus();
	        self.currentlyOpenMenu = undefined;
	      }
	      self.disableOpenOnHover();
	      self.setKeyboardMode(true);
	    }
	  }));
	
	  $scope.$on('$destroy', function() {
	    self.disableOpenOnHover();
	    while (deregisterFns.length) {
	      deregisterFns.shift()();
	    }
	  });
	
	
	  this.setKeyboardMode(true);
	};
	
	MenuBarController.prototype.setKeyboardMode = function(enabled) {
	  if (enabled) this.$element[0].classList.add('md-keyboard-mode');
	  else this.$element[0].classList.remove('md-keyboard-mode');
	};
	
	MenuBarController.prototype.enableOpenOnHover = function() {
	  if (this.openOnHoverEnabled) return;
	
	  var self = this;
	
	  self.openOnHoverEnabled = true;
	
	  if (self.parentToolbar) {
	    self.parentToolbar.classList.add('md-has-open-menu');
	
	    // Needs to be on the next tick so it doesn't close immediately.
	    self.$mdUtil.nextTick(function() {
	      angular.element(self.parentToolbar).on('click', self.handleParentClick);
	    }, false);
	  }
	
	  angular
	    .element(self.getMenus())
	    .on('mouseenter', self.handleMenuHover);
	};
	
	MenuBarController.prototype.handleMenuHover = function(e) {
	  this.setKeyboardMode(false);
	  if (this.openOnHoverEnabled) {
	    this.scheduleOpenHoveredMenu(e);
	  }
	};
	
	MenuBarController.prototype.disableOpenOnHover = function() {
	  if (!this.openOnHoverEnabled) return;
	
	  this.openOnHoverEnabled = false;
	
	  if (this.parentToolbar) {
	    this.parentToolbar.classList.remove('md-has-open-menu');
	    angular.element(this.parentToolbar).off('click', this.handleParentClick);
	  }
	
	  angular
	    .element(this.getMenus())
	    .off('mouseenter', this.handleMenuHover);
	};
	
	MenuBarController.prototype.scheduleOpenHoveredMenu = function(e) {
	  var menuEl = angular.element(e.currentTarget);
	  var menuCtrl = menuEl.controller('mdMenu');
	  this.setKeyboardMode(false);
	  this.scheduleOpenMenu(menuCtrl);
	};
	
	MenuBarController.prototype.scheduleOpenMenu = function(menuCtrl) {
	  var self = this;
	  var $timeout = this.$timeout;
	  if (menuCtrl != self.currentlyOpenMenu) {
	    $timeout.cancel(self.pendingMenuOpen);
	    self.pendingMenuOpen = $timeout(function() {
	      self.pendingMenuOpen = undefined;
	      if (self.currentlyOpenMenu) {
	        self.currentlyOpenMenu.close(true, { closeAll: true });
	      }
	      menuCtrl.open();
	    }, 200, false);
	  }
	};
	
	MenuBarController.prototype.handleKeyDown = function(e) {
	  var keyCodes = this.$mdConstant.KEY_CODE;
	  var currentMenu = this.currentlyOpenMenu;
	  var wasOpen = currentMenu && currentMenu.isOpen;
	  this.setKeyboardMode(true);
	  var handled, newMenu, newMenuCtrl;
	  switch (e.keyCode) {
	    case keyCodes.DOWN_ARROW:
	      if (currentMenu) {
	        currentMenu.focusMenuContainer();
	      } else {
	        this.openFocusedMenu();
	      }
	      handled = true;
	      break;
	    case keyCodes.UP_ARROW:
	      currentMenu && currentMenu.close();
	      handled = true;
	      break;
	    case keyCodes.LEFT_ARROW:
	      newMenu = this.focusMenu(-1);
	      if (wasOpen) {
	        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
	        this.scheduleOpenMenu(newMenuCtrl);
	      }
	      handled = true;
	      break;
	    case keyCodes.RIGHT_ARROW:
	      newMenu = this.focusMenu(+1);
	      if (wasOpen) {
	        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
	        this.scheduleOpenMenu(newMenuCtrl);
	      }
	      handled = true;
	      break;
	  }
	  if (handled) {
	    e && e.preventDefault && e.preventDefault();
	    e && e.stopImmediatePropagation && e.stopImmediatePropagation();
	  }
	};
	
	MenuBarController.prototype.focusMenu = function(direction) {
	  var menus = this.getMenus();
	  var focusedIndex = this.getFocusedMenuIndex();
	
	  if (focusedIndex == -1) { focusedIndex = this.getOpenMenuIndex(); }
	
	  var changed = false;
	
	  if (focusedIndex == -1) { focusedIndex = 0; changed = true; }
	  else if (
	    direction < 0 && focusedIndex > 0 ||
	    direction > 0 && focusedIndex < menus.length - direction
	  ) {
	    focusedIndex += direction;
	    changed = true;
	  }
	  if (changed) {
	    menus[focusedIndex].querySelector('button').focus();
	    return menus[focusedIndex];
	  }
	};
	
	MenuBarController.prototype.openFocusedMenu = function() {
	  var menu = this.getFocusedMenu();
	  menu && angular.element(menu).controller('mdMenu').open();
	};
	
	MenuBarController.prototype.getMenus = function() {
	  var $element = this.$element;
	  return this.$mdUtil.nodesToArray($element[0].children)
	    .filter(function(el) { return el.nodeName == 'MD-MENU'; });
	};
	
	MenuBarController.prototype.getFocusedMenu = function() {
	  return this.getMenus()[this.getFocusedMenuIndex()];
	};
	
	MenuBarController.prototype.getFocusedMenuIndex = function() {
	  var $mdUtil = this.$mdUtil;
	  var focusedEl = $mdUtil.getClosest(
	    this.$document[0].activeElement,
	    'MD-MENU'
	  );
	  if (!focusedEl) return -1;
	
	  var focusedIndex = this.getMenus().indexOf(focusedEl);
	  return focusedIndex;
	};
	
	MenuBarController.prototype.getOpenMenuIndex = function() {
	  var menus = this.getMenus();
	  for (var i = 0; i < menus.length; ++i) {
	    if (menus[i].classList.contains('md-open')) return i;
	  }
	  return -1;
	};
	
	MenuBarController.prototype.handleParentClick = function(event) {
	  var openMenu = this.querySelector('md-menu.md-open');
	
	  if (openMenu && !openMenu.contains(event.target)) {
	    angular.element(openMenu).controller('mdMenu').close(true, {
	      closeAll: true
	    });
	  }
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdMenuBar
	 * @module material.components.menuBar
	 * @restrict E
	 * @description
	 *
	 * Menu bars are containers that hold multiple menus. They change the behavior and appearance
	 * of the `md-menu` directive to behave similar to an operating system provided menu.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-menu-bar>
	 *   <md-menu>
	 *     <button ng-click="$mdMenu.open()">
	 *       File
	 *     </button>
	 *     <md-menu-content>
	 *       <md-menu-item>
	 *         <md-button ng-click="ctrl.sampleAction('share', $event)">
	 *           Share...
	 *         </md-button>
	 *       </md-menu-item>
	 *       <md-menu-divider></md-menu-divider>
	 *       <md-menu-item>
	 *       <md-menu-item>
	 *         <md-menu>
	 *           <md-button ng-click="$mdMenu.open()">New</md-button>
	 *           <md-menu-content>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
	 *           </md-menu-content>
	 *         </md-menu>
	 *       </md-menu-item>
	 *     </md-menu-content>
	 *   </md-menu>
	 * </md-menu-bar>
	 * </hljs>
	 *
	 * ## Menu Bar Controls
	 *
	 * You may place `md-menu-item`s that function as controls within menu bars.
	 * There are two modes that are exposed via the `type` attribute of the `md-menu-item`.
	 * `type="checkbox"` will function as a boolean control for the `ng-model` attribute of the
	 * `md-menu-item`. `type="radio"` will function like a radio button, setting the `ngModel`
	 * to the `string` value of the `value` attribute. If you need non-string values, you can use
	 * `ng-value` to provide an expression (this is similar to how angular's native `input[type=radio]`
	 * works.
	 *
	 * If you want either to disable closing the opened menu when clicked, you can add the
	 * `md-prevent-menu-close` attribute to the `md-menu-item`. The attribute will be forwarded to the
	 * `button` element that is generated.
	 *
	 * <hljs lang="html">
	 * <md-menu-bar>
	 *  <md-menu>
	 *    <button ng-click="$mdMenu.open()">
	 *      Sample Menu
	 *    </button>
	 *    <md-menu-content>
	 *      <md-menu-item type="checkbox" ng-model="settings.allowChanges" md-prevent-menu-close>
	 *        Allow changes
	 *      </md-menu-item>
	 *      <md-menu-divider></md-menu-divider>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 1</md-menu-item>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="2">Mode 2</md-menu-item>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="3">Mode 3</md-menu-item>
	 *    </md-menu-content>
	 *  </md-menu>
	 * </md-menu-bar>
	 * </hljs>
	 *
	 *
	 * ### Nesting Menus
	 *
	 * Menus may be nested within menu bars. This is commonly called cascading menus.
	 * To nest a menu place the nested menu inside the content of the `md-menu-item`.
	 * <hljs lang="html">
	 * <md-menu-item>
	 *   <md-menu>
	 *     <button ng-click="$mdMenu.open()">New</md-button>
	 *     <md-menu-content>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
	 *     </md-menu-content>
	 *   </md-menu>
	 * </md-menu-item>
	 * </hljs>
	 *
	 */
	
	MenuBarDirective.$inject = ["$mdUtil", "$mdTheming"];
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuBar', MenuBarDirective);
	
	/* @ngInject */
	function MenuBarDirective($mdUtil, $mdTheming) {
	  return {
	    restrict: 'E',
	    require: 'mdMenuBar',
	    controller: 'MenuBarController',
	
	    compile: function compile(templateEl, templateAttrs) {
	      if (!templateAttrs.ariaRole) {
	        templateEl[0].setAttribute('role', 'menubar');
	      }
	      angular.forEach(templateEl[0].children, function(menuEl) {
	        if (menuEl.nodeName == 'MD-MENU') {
	          if (!menuEl.hasAttribute('md-position-mode')) {
	            menuEl.setAttribute('md-position-mode', 'left bottom');
	
	            // Since we're in the compile function and actual `md-buttons` are not compiled yet,
	            // we need to query for possible `md-buttons` as well.
	            menuEl.querySelector('button, a, md-button').setAttribute('role', 'menuitem');
	          }
	          var contentEls = $mdUtil.nodesToArray(menuEl.querySelectorAll('md-menu-content'));
	          angular.forEach(contentEls, function(contentEl) {
	            contentEl.classList.add('md-menu-bar-menu');
	            contentEl.classList.add('md-dense');
	            if (!contentEl.hasAttribute('width')) {
	              contentEl.setAttribute('width', 5);
	            }
	          });
	        }
	      });
	
	      // Mark the child menu items that they're inside a menu bar. This is necessary,
	      // because mnMenuItem has special behaviour during compilation, depending on
	      // whether it is inside a mdMenuBar. We can usually figure this out via the DOM,
	      // however if a directive that uses documentFragment is applied to the child (e.g. ngRepeat),
	      // the element won't have a parent and won't compile properly.
	      templateEl.find('md-menu-item').addClass('md-in-menu-bar');
	
	      return function postLink(scope, el, attr, ctrl) {
	        el.addClass('_md');     // private md component indicator for styling
	        $mdTheming(scope, el);
	        ctrl.init();
	      };
	    }
	  };
	
	}
	
	})();
	(function(){
	"use strict";
	
	
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuDivider', MenuDividerDirective);
	
	
	function MenuDividerDirective() {
	  return {
	    restrict: 'E',
	    compile: function(templateEl, templateAttrs) {
	      if (!templateAttrs.role) {
	        templateEl[0].setAttribute('role', 'separator');
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MenuItemController.$inject = ["$scope", "$element", "$attrs"];
	angular
	  .module('material.components.menuBar')
	  .controller('MenuItemController', MenuItemController);
	
	
	/**
	 * @ngInject
	 */
	function MenuItemController($scope, $element, $attrs) {
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$scope = $scope;
	}
	
	MenuItemController.prototype.init = function(ngModel) {
	  var $element = this.$element;
	  var $attrs = this.$attrs;
	
	  this.ngModel = ngModel;
	  if ($attrs.type == 'checkbox' || $attrs.type == 'radio') {
	    this.mode  = $attrs.type;
	    this.iconEl = $element[0].children[0];
	    this.buttonEl = $element[0].children[1];
	    if (ngModel) {
	      // Clear ngAria set attributes
	      this.initClickListeners();
	    }
	  }
	};
	
	// ngAria auto sets attributes on a menu-item with a ngModel.
	// We don't want this because our content (buttons) get the focus
	// and set their own aria attributes appropritately. Having both
	// breaks NVDA / JAWS. This undeoes ngAria's attrs.
	MenuItemController.prototype.clearNgAria = function() {
	  var el = this.$element[0];
	  var clearAttrs = ['role', 'tabindex', 'aria-invalid', 'aria-checked'];
	  angular.forEach(clearAttrs, function(attr) {
	    el.removeAttribute(attr);
	  });
	};
	
	MenuItemController.prototype.initClickListeners = function() {
	  var self = this;
	  var ngModel = this.ngModel;
	  var $scope = this.$scope;
	  var $attrs = this.$attrs;
	  var $element = this.$element;
	  var mode = this.mode;
	
	  this.handleClick = angular.bind(this, this.handleClick);
	
	  var icon = this.iconEl;
	  var button = angular.element(this.buttonEl);
	  var handleClick = this.handleClick;
	
	  $attrs.$observe('disabled', setDisabled);
	  setDisabled($attrs.disabled);
	
	  ngModel.$render = function render() {
	    self.clearNgAria();
	    if (isSelected()) {
	      icon.style.display = '';
	      button.attr('aria-checked', 'true');
	    } else {
	      icon.style.display = 'none';
	      button.attr('aria-checked', 'false');
	    }
	  };
	
	  $scope.$$postDigest(ngModel.$render);
	
	  function isSelected() {
	    if (mode == 'radio') {
	      var val = $attrs.ngValue ? $scope.$eval($attrs.ngValue) : $attrs.value;
	      return ngModel.$modelValue == val;
	    } else {
	      return ngModel.$modelValue;
	    }
	  }
	
	  function setDisabled(disabled) {
	    if (disabled) {
	      button.off('click', handleClick);
	    } else {
	      button.on('click', handleClick);
	    }
	  }
	};
	
	MenuItemController.prototype.handleClick = function(e) {
	  var mode = this.mode;
	  var ngModel = this.ngModel;
	  var $attrs = this.$attrs;
	  var newVal;
	  if (mode == 'checkbox') {
	    newVal = !ngModel.$modelValue;
	  } else if (mode == 'radio') {
	    newVal = $attrs.ngValue ? this.$scope.$eval($attrs.ngValue) : $attrs.value;
	  }
	  ngModel.$setViewValue(newVal);
	  ngModel.$render();
	};
	
	})();
	(function(){
	"use strict";
	
	
	MenuItemDirective.$inject = ["$mdUtil", "$mdConstant", "$$mdSvgRegistry"];
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuItem', MenuItemDirective);
	
	 /* @ngInject */
	function MenuItemDirective($mdUtil, $mdConstant, $$mdSvgRegistry) {
	  return {
	    controller: 'MenuItemController',
	    require: ['mdMenuItem', '?ngModel'],
	    priority: $mdConstant.BEFORE_NG_ARIA,
	    compile: function(templateEl, templateAttrs) {
	      var type = templateAttrs.type;
	      var inMenuBarClass = 'md-in-menu-bar';
	
	      // Note: This allows us to show the `check` icon for the md-menu-bar items.
	      // The `md-in-menu-bar` class is set by the mdMenuBar directive.
	      if ((type === 'checkbox' || type === 'radio') && templateEl.hasClass(inMenuBarClass)) {
	        var text = templateEl[0].textContent;
	        var buttonEl = angular.element('<md-button type="button"></md-button>');
	        var iconTemplate = '<md-icon md-svg-src="' + $$mdSvgRegistry.mdChecked + '"></md-icon>';
	
	        buttonEl.html(text);
	        buttonEl.attr('tabindex', '0');
	
	        if (angular.isDefined(templateAttrs.mdPreventMenuClose)) {
	          buttonEl.attr('md-prevent-menu-close', templateAttrs.mdPreventMenuClose);
	        }
	
	        templateEl.html('');
	        templateEl.append(angular.element(iconTemplate));
	        templateEl.append(buttonEl);
	        templateEl.addClass('md-indent').removeClass(inMenuBarClass);
	
	        setDefault('role', type === 'checkbox' ? 'menuitemcheckbox' : 'menuitemradio', buttonEl);
	        moveAttrToButton('ng-disabled');
	
	      } else {
	        setDefault('role', 'menuitem', templateEl[0].querySelector('md-button, button, a'));
	      }
	
	
	      return function(scope, el, attrs, ctrls) {
	        var ctrl = ctrls[0];
	        var ngModel = ctrls[1];
	        ctrl.init(ngModel);
	      };
	
	      function setDefault(attr, val, el) {
	        el = el || templateEl;
	        if (el instanceof angular.element) {
	          el = el[0];
	        }
	        if (!el.hasAttribute(attr)) {
	          el.setAttribute(attr, val);
	        }
	      }
	
	      function moveAttrToButton(attribute) {
	        var attributes = $mdUtil.prefixer(attribute);
	
	        angular.forEach(attributes, function(attr) {
	          if (templateEl[0].hasAttribute(attr)) {
	            var val = templateEl[0].getAttribute(attr);
	            buttonEl[0].setAttribute(attr, val);
	            templateEl[0].removeAttribute(attr);
	          }
	        });
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.navBar
	 */
	MdNavBar.$inject = ["$mdAria", "$mdTheming", "$window", "$mdUtil"];
	MdNavBarController.$inject = ["$element", "$scope", "$timeout", "$mdConstant"];
	MdNavItem.$inject = ["$mdAria", "$$rAF", "$mdUtil", "$window"];
	MdNavItemController.$inject = ["$element"];
	angular.module('material.components.navBar', ['material.core'])
	    .controller('MdNavBarController', MdNavBarController)
	    .directive('mdNavBar', MdNavBar)
	    .controller('MdNavItemController', MdNavItemController)
	    .directive('mdNavItem', MdNavItem);
	
	/**
	 * @ngdoc directive
	 * @name mdNavBar
	 * @module material.components.navBar
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-nav-bar>` directive renders a list of material tabs that can be used
	 * for top-level page navigation. Unlike `<md-tabs>`, it has no concept of a tab
	 * body and no bar pagination.
	 *
	 * Because it deals with page navigation, certain routing concepts are built-in.
	 * Route changes via `ng-href`, `ui-sref`, or `ng-click` events are supported.
	 * Alternatively, the user could simply watch the value of `md-selected-nav-item`
	 * (`currentNavItem` in the below example) for changes.
	 *
	 * Accessibility functionality is implemented as a
	 * <a href="https://www.w3.org/TR/wai-aria-1.0/complete#tablist">
	 *   tablist</a> with
	 * <a href="https://www.w3.org/TR/wai-aria-1.0/complete#tab">tabs</a>.
	 * We've kept the `role="navigation"` on the `<nav>`, for backwards compatibility, even though
	 *  it is not required in the
	 * <a href="https://www.w3.org/TR/wai-aria-practices/#aria_lh_navigation">
	 *   latest Working Group Note from December 2017</a>.
	 *
	 * <h3>Keyboard Navigation</h3>
	 * - `Tab`/`Shift+Tab` moves the focus to the next/previous interactive element on the page
	 * - `Enter`/`Space` selects the focused nav item and navigates to display the item's contents
	 * - `Right`/`Down` moves focus to the next nav item, wrapping at the end
	 * - `Left`/`Up` moves focus to the previous nav item, wrapping at the end
	 * - `Home`/`End` moves the focus to the first/last nav item
	 *
	 * @param {string=} md-selected-nav-item The name of the current tab; this must
	 *     match the `name` attribute of `<md-nav-item>`.
	 * @param {boolean=} md-no-ink-bar If set to true, the ink bar will be hidden.
	 * @param {string=} nav-bar-aria-label An `aria-label` applied to the `md-nav-bar`'s tablist
	 * for accessibility.
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-nav-bar md-selected-nav-item="currentNavItem">
	 *    <md-nav-item md-nav-click="goto('page1')" name="page1">
	 *      Page One
	 *    </md-nav-item>
	 *    <md-nav-item md-nav-href="#page2" name="page3">Page Two</md-nav-item>
	 *    <md-nav-item md-nav-sref="page3" name="page2">Page Three</md-nav-item>
	 *    <md-nav-item
	 *      md-nav-sref="app.page4"
	 *      sref-opts="{reload: true, notify: true}"
	 *      name="page4">
	 *      Page Four
	 *    </md-nav-item>
	 *  </md-nav-bar>
	 *</hljs>
	 * <hljs lang="js">
	 * (function() {
	 *   'use strict';
	 *
	 *    $rootScope.$on('$routeChangeSuccess', function(event, current) {
	 *      $scope.currentLink = getCurrentLinkFromRoute(current);
	 *    });
	 * });
	 * </hljs>
	 */
	/**
	 * @param $mdAria
	 * @param $mdTheming
	 * @param $window
	 * @param $mdUtil
	 * @constructor
	 * @ngInject
	 */
	function MdNavBar($mdAria, $mdTheming, $window, $mdUtil) {
	  return {
	    restrict: 'E',
	    transclude: true,
	    controller: MdNavBarController,
	    controllerAs: 'ctrl',
	    bindToController: true,
	    scope: {
	      'mdSelectedNavItem': '=?',
	      'mdNoInkBar': '=?',
	      'navBarAriaLabel': '@?',
	    },
	    template:
	      '<div class="md-nav-bar">' +
	        '<nav role="navigation">' +
	          '<ul class="_md-nav-bar-list" ng-transclude role="tablist" ' +
	            'ng-focus="ctrl.onFocus()" ' + // Deprecated but kept for now in order to not break tests
	            'aria-label="{{ctrl.navBarAriaLabel}}">' +
	          '</ul>' +
	        '</nav>' +
	        '<md-nav-ink-bar ng-hide="ctrl.mdNoInkBar"></md-nav-ink-bar>' +
	      '</div>',
	    link: function(scope, element, attrs, ctrl) {
	
	      ctrl.width = $window.innerWidth;
	
	      function onResize() {
	        if (ctrl.width !== $window.innerWidth) {
	          ctrl.updateSelectedTabInkBar();
	          ctrl.width = $window.innerWidth;
	          scope.$digest();
	        }
	      }
	
	      function cleanUp() {
	        angular.element($window).off('resize', onResize);
	      }
	
	      angular.element($window).on('resize', $mdUtil.debounce(onResize, 300));
	      scope.$on('$destroy', cleanUp);
	
	      $mdTheming(element);
	      if (!ctrl.navBarAriaLabel) {
	        $mdAria.expectAsync(element, 'aria-label', angular.noop);
	      }
	    },
	  };
	}
	
	/**
	 * Controller for the nav-bar component.
	 * Accessibility functionality is implemented as a tablist
	 * (https://www.w3.org/TR/wai-aria-1.0/complete#tablist) and
	 * tabs (https://www.w3.org/TR/wai-aria-1.0/complete#tab).
	 *
	 * @param {!JQLite} $element
	 * @param {!IScope} $scope
	 * @param {!ITimeoutService} $timeout
	 * @param {!Object} $mdConstant
	 * @constructor
	 * @final
	 * @ngInject
	 */
	function MdNavBarController($element, $scope, $timeout, $mdConstant) {
	  // Injected variables
	  /**
	   * @private @const
	   * @type {!ITimeoutService}
	   */
	  this._$timeout = $timeout;
	
	  /**
	   * @private @const
	   * @type {!IScope}
	   */
	  this._$scope = $scope;
	
	  /**
	   * @private @const
	   * @type {!Object}
	   */
	  this._$mdConstant = $mdConstant;
	
	  // Data-bound variables.
	  /** @type {?string} */
	  this.mdSelectedNavItem;
	
	  /** @type {?string} */
	  this.navBarAriaLabel;
	
	  // State variables.
	  /** @type {?HTMLElement} */
	  this._navBarEl = $element[0];
	
	  /** @type {?JQLite} */
	  this._inkbar;
	
	  var self = this;
	  // need to wait for transcluded content to be available
	  var deregisterTabWatch = this._$scope.$watch(function() {
	    return self._navBarEl.querySelectorAll('._md-nav-button').length;
	  },
	  function(newLength) {
	    if (newLength > 0) {
	      self._initTabs();
	      deregisterTabWatch();
	    }
	  });
	}
	
	/**
	 * Initializes the tab components once they exist.
	 * @private
	 */
	MdNavBarController.prototype._initTabs = function() {
	  this._inkbar = angular.element(this._navBarEl.querySelector('md-nav-ink-bar'));
	
	  var self = this;
	  this._$timeout(function() {
	    self._updateTabs(self.mdSelectedNavItem, null);
	  });
	
	  this._$scope.$watch('ctrl.mdSelectedNavItem', function(newValue, oldValue) {
	    // Wait a digest before update tabs for products doing
	    // anything dynamic in the template.
	    self._$timeout(function() {
	      self._updateTabs(newValue, oldValue);
	    });
	  });
	};
	
	/**
	 * Set the current tab to be selected.
	 * @param {string|undefined} newValue New current tab name.
	 * @param {string|undefined|null} oldValue Previous tab name.
	 * @private
	 */
	MdNavBarController.prototype._updateTabs = function(newValue, oldValue) {
	  var self = this;
	  var tabs = this._getTabs();
	  var sameTab = newValue === oldValue;
	
	  // this._getTabs can return null if nav-bar has not yet been initialized
	  if (!tabs) return;
	
	  var newIndex = -1;
	  var newTab = this._getTabByName(newValue);
	  var oldTab = this._getTabByName(oldValue);
	
	  if (oldTab) {
	    oldTab.setSelected(false);
	  }
	
	  if (newTab) {
	    newTab.setSelected(true);
	    newIndex = tabs.indexOf(newTab);
	  }
	
	  this._$timeout(function() {
	    self._updateInkBarStyles(newTab, newIndex);
	    // Don't change focus when there is no newTab, the new and old tabs are the same, or when
	    // called from MdNavBarController._initTabs() which would have no oldTab defined.
	    if (newTab && oldTab && !sameTab) {
	      self._moveFocus(oldTab, newTab);
	    }
	  });
	};
	
	/**
	 * Repositions the ink bar to the selected tab.
	 * @param {MdNavItemController} tab the nav item that should have ink bar styles applied
	 * @param {number=} newIndex the index of the newly selected nav item
	 * @private
	 */
	MdNavBarController.prototype._updateInkBarStyles = function(tab, newIndex) {
	  this._inkbar.css({display: newIndex < 0 ? 'none' : ''});
	
	  if (tab) {
	    var tabEl = tab.getButtonEl();
	    var left = tabEl.offsetLeft;
	    var tabWidth = tabEl.offsetWidth;
	    var navBarWidth = this._navBarEl.getBoundingClientRect().width;
	    var scale = tabWidth / navBarWidth;
	    var translate = left / navBarWidth * 100;
	
	    this._inkbar.css({ transform: 'translateX(' + translate + '%) scaleX(' + scale + ')' });
	  }
	};
	
	/**
	 * Updates ink bar to match current tab.
	 */
	MdNavBarController.prototype.updateSelectedTabInkBar = function() {
	  this._updateInkBarStyles(this._getSelectedTab());
	};
	
	/**
	 * Returns an array of the current tabs.
	 * @return {Array<!MdNavItemController>}
	 * @private
	 */
	MdNavBarController.prototype._getTabs = function() {
	  var controllers = Array.prototype.slice.call(
	    this._navBarEl.querySelectorAll('.md-nav-item'))
	    .map(function(el) {
	      return angular.element(el).controller('mdNavItem');
	    });
	  return controllers.indexOf(undefined) ? controllers : [];
	};
	
	/**
	 * Returns the tab with the specified name.
	 * @param {string} name The name of the tab, found in its name attribute.
	 * @return {MdNavItemController}
	 * @private
	 */
	MdNavBarController.prototype._getTabByName = function(name) {
	  return this._findTab(function(tab) {
	    return tab.getName() === name;
	  });
	};
	
	/**
	 * Returns the selected tab.
	 * @return {MdNavItemController}
	 * @private
	 */
	MdNavBarController.prototype._getSelectedTab = function() {
	  return this._findTab(function(tab) {
	    return tab.isSelected();
	  });
	};
	
	/**
	 * Returns the focused tab.
	 * @return {MdNavItemController}
	 */
	MdNavBarController.prototype.getFocusedTab = function() {
	  return this._findTab(function(tab) {
	    return tab.hasFocus();
	  });
	};
	
	/**
	 * Find a tab that matches the specified function, starting from the first tab.
	 * @param {Function} fn
	 * @param {number=} startIndex index to start at. Defaults to 0.
	 * @returns {MdNavItemController|null}
	 * @private
	 */
	MdNavBarController.prototype._findTab = function(fn, startIndex) {
	  var tabs = this._getTabs(), i;
	  if (startIndex == null) {
	    startIndex = 0;
	  }
	  for (i = startIndex; i < tabs.length; i++) {
	    if (fn(tabs[i])) {
	      return tabs[i];
	    }
	  }
	  return null;
	};
	
	/**
	 * Find a tab that matches the specified function, going backwards from the end of the list.
	 * @param {Function} fn
	 * @param {number=} startIndex index to start at. Defaults to tabs.length - 1.
	 * @returns {MdNavItemController}
	 * @private
	 */
	MdNavBarController.prototype._findTabReverse = function(fn, startIndex) {
	  var tabs = this._getTabs();
	  if (startIndex === undefined || startIndex === null) {
	    startIndex = tabs.length - 1;
	  }
	  for (var i = startIndex; i >= 0 ; i--) {
	    if (fn(tabs[i])) {
	      return tabs[i];
	    }
	  }
	  return null;
	};
	
	/**
	 * Direct focus to the selected tab when focus enters the nav bar.
	 */
	MdNavBarController.prototype.onFocus = function() {
	  var tab = this._getSelectedTab();
	  if (tab && !tab.isFocused) {
	    tab.setFocused(true);
	  }
	};
	
	/**
	 * Move focus from oldTab to newTab.
	 * @param {!MdNavItemController} oldTab
	 * @param {!MdNavItemController} newTab
	 * @private
	 */
	MdNavBarController.prototype._moveFocus = function(oldTab, newTab) {
	  oldTab.setFocused(false);
	  newTab.setFocused(true);
	};
	
	/**
	 * Focus the first tab.
	 * @private
	 */
	MdNavBarController.prototype._focusFirstTab = function() {
	  var tabs = this._getTabs();
	  if (!tabs) return;
	  var tabToFocus = this._findTab(function(tab) {
	    return tab._isEnabled();
	  });
	  if (tabToFocus) {
	    this._moveFocus(this.getFocusedTab(), tabToFocus);
	  }
	};
	
	/**
	 * Focus the last tab.
	 * @private
	 */
	MdNavBarController.prototype._focusLastTab = function() {
	  var tabs = this._getTabs();
	  if (!tabs) return;
	  var tabToFocus = this._findTabReverse(function(tab) {
	    return tab._isEnabled();
	  });
	  if (tabToFocus) {
	    this._moveFocus(this.getFocusedTab(), tabToFocus);
	  }
	};
	
	/**
	 * Focus the next non-disabled tab.
	 * @param {number} focusedTabIndex the index of the currently focused tab
	 * @private
	 */
	MdNavBarController.prototype._focusNextTab = function(focusedTabIndex) {
	  var tabs = this._getTabs();
	  if (!tabs) return;
	  var tabToFocus = this._findTab(function(tab) {
	    return tab._isEnabled();
	  }, focusedTabIndex + 1);
	  if (tabToFocus) {
	    this._moveFocus(this.getFocusedTab(), tabToFocus);
	  } else {
	    this._focusFirstTab();
	  }
	};
	
	/**
	 * Focus the previous non-disabled tab.
	 * @param {number} focusedTabIndex the index of the currently focused tab
	 * @private
	 */
	MdNavBarController.prototype._focusPreviousTab = function(focusedTabIndex) {
	  var tabs = this._getTabs();
	  if (!tabs) return;
	  var tabToFocus = this._findTabReverse(function(tab) {
	    return tab._isEnabled();
	  }, focusedTabIndex - 1);
	  if (tabToFocus) {
	    this._moveFocus(this.getFocusedTab(), tabToFocus);
	  } else {
	    this._focusLastTab();
	  }
	};
	
	/**
	 * Responds to keydown events.
	 * Calls to preventDefault() stop the page from scrolling when changing focus in the nav-bar.
	 * @param {!KeyboardEvent} e
	 */
	MdNavBarController.prototype.onKeydown = function(e) {
	  var keyCodes = this._$mdConstant.KEY_CODE;
	  var tabs = this._getTabs();
	  var focusedTab = this.getFocusedTab();
	  if (!focusedTab || !tabs) return;
	
	  var focusedTabIndex = tabs.indexOf(focusedTab);
	
	  // use arrow keys to navigate between tabs
	  switch (e.keyCode) {
	    case keyCodes.UP_ARROW:
	    case keyCodes.LEFT_ARROW:
	      e.preventDefault();
	      this._focusPreviousTab(focusedTabIndex);
	      break;
	    case keyCodes.DOWN_ARROW:
	    case keyCodes.RIGHT_ARROW:
	      e.preventDefault();
	      this._focusNextTab(focusedTabIndex);
	      break;
	    case keyCodes.SPACE:
	    case keyCodes.ENTER:
	      // timeout to avoid a "digest already in progress" console error
	      this._$timeout(function() {
	        focusedTab.getButtonEl().click();
	      });
	      break;
	    case keyCodes.HOME:
	      e.preventDefault();
	      this._focusFirstTab();
	      break;
	    case keyCodes.END:
	      e.preventDefault();
	      this._focusLastTab();
	      break;
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @name mdNavItem
	 * @module material.components.navBar
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-nav-item>` describes a page navigation link within the `<md-nav-bar>` component.
	 * It renders an `<md-button>` as the actual link.
	 *
	 * Exactly one of the `md-nav-click`, `md-nav-href`, or `md-nav-sref` attributes are required
	 * to be specified.
	 *
	 * @param {string=} nav-item-aria-label Allows setting or overriding the label that is announced by
	 *     a screen reader for the nav item's button. If this is not set, the nav item's transcluded
	 *     content will be announced. Make sure to set this if the nav item's transcluded content does
	 *     not include descriptive text, for example only an icon.
	 * @param {expression=} md-nav-click Expression which will be evaluated when the
	 *     link is clicked to change the page. Renders as an `ng-click`.
	 * @param {string=} md-nav-href url to transition to when this link is clicked.
	 *     Renders as an `ng-href`.
	 * @param {string=} md-nav-sref UI-Router state to transition to when this link is
	 *     clicked. Renders as a `ui-sref`.
	 * @param {string} name The name of this link. Used by the nav bar to know
	 *     which link is currently selected.
	 * @param {!object=} sref-opts UI-Router options that are passed to the `$state.go()` function. See
	 *     the <a ng-href="https://ui-router.github.io/docs/latest/interfaces/transition.transitionoptions.html"
	 *     target="_blank">UI-Router documentation for details</a>.
	 *
	 * @usage
	 * See <a ng-href="api/directive/mdNavBar">md-nav-bar</a> for usage.
	 */
	/**
	 * @param $mdAria
	 * @param $$rAF
	 * @param $mdUtil
	 * @param $window
	 * @constructor
	 * @ngInject
	 */
	function MdNavItem($mdAria, $$rAF, $mdUtil, $window) {
	  return {
	    restrict: 'E',
	    require: ['mdNavItem', '^mdNavBar'],
	    controller: MdNavItemController,
	    bindToController: true,
	    controllerAs: 'ctrl',
	    replace: true,
	    transclude: true,
	    template: function(tElement, tAttrs) {
	      var hasNavClick = tAttrs.mdNavClick;
	      var hasNavHref = tAttrs.mdNavHref;
	      var hasNavSref = tAttrs.mdNavSref;
	      var hasSrefOpts = tAttrs.srefOpts;
	      var navigationAttribute;
	      var navigationOptions;
	      var buttonTemplate;
	
	      // Cannot specify more than one nav attribute
	      if ((hasNavClick ? 1 : 0) + (hasNavHref ? 1 : 0) + (hasNavSref ? 1 : 0) > 1) {
	        throw Error(
	          'Please do not specify more than one of the md-nav-click, md-nav-href, ' +
	          'or md-nav-sref attributes per nav-item directive.'
	        );
	      }
	
	      if (hasNavClick !== undefined && hasNavClick !== null) {
	        navigationAttribute = 'ng-click="ctrl.mdNavClick()"';
	      } else if (hasNavHref !== undefined && hasNavHref !== null) {
	        navigationAttribute = 'ng-href="{{ctrl.mdNavHref}}"';
	      } else if (hasNavSref !== undefined && hasNavSref !== null) {
	        navigationAttribute = 'ui-sref="{{ctrl.mdNavSref}}"';
	      } else {
	        throw Error(
	          'Please specify at least one of the md-nav-click, md-nav-href, or md-nav-sref ' +
	          'attributes per nav-item directive.');
	      }
	
	      navigationOptions = hasSrefOpts ? 'ui-sref-opts="{{ctrl.srefOpts}}" ' : '';
	
	      if (navigationAttribute) {
	        buttonTemplate = '' +
	          '<md-button class="_md-nav-button md-accent" ' +
	            'ng-class="ctrl.getNgClassMap()" ' +
	            'ng-blur="ctrl.setFocused(false)" ' +
	            'ng-disabled="ctrl.disabled" ' +
	            'tabindex="-1" ' +
	            'role="tab" ' +
	            'ng-attr-aria-label="{{ctrl.navItemAriaLabel ? ctrl.navItemAriaLabel : undefined}}" ' +
	            'aria-selected="{{ctrl.isSelected()}}" ' +
	            navigationOptions +
	            navigationAttribute + '>' +
	            '<span ng-transclude class="_md-nav-button-text"></span>' +
	          '</md-button>';
	      }
	
	      return '' +
	        '<li class="md-nav-item" ' +
	          'role="presentation">' +
	          (buttonTemplate || '') +
	        '</li>';
	    },
	    scope: {
	      'mdNavClick': '&?',
	      'mdNavHref': '@?',
	      'mdNavSref': '@?',
	      'srefOpts': '=?',
	      'name': '@',
	      'navItemAriaLabel': '@?',
	    },
	    link: function(scope, element, attrs, controllers) {
	      var disconnect;
	      var mdNavItem;
	      var mdNavBar;
	      var navButton;
	
	      // When accessing the element's contents synchronously, they
	      // may not be defined yet because of transclusion. There is a higher
	      // chance that it will be accessible if we wait one frame.
	      $$rAF(function() {
	        mdNavItem = controllers[0];
	        mdNavBar = controllers[1];
	        navButton = angular.element(element[0].querySelector('._md-nav-button'));
	
	        if (!mdNavItem.name) {
	          mdNavItem.name = angular.element(element[0]
	              .querySelector('._md-nav-button-text')).text().trim();
	        }
	
	        navButton.on('keydown', function($event) {
	          mdNavBar.onKeydown($event);
	        });
	
	        navButton.on('focus', function() {
	          mdNavItem._focused = true;
	        });
	
	        navButton.on('click', function() {
	          // This triggers a watcher on mdNavBar.mdSelectedNavItem which calls
	          // MdNavBarController._updateTabs() after a $timeout. That function calls
	          // MdNavItemController.setSelected() for the old tab with false and the new tab with true.
	          mdNavBar.mdSelectedNavItem = mdNavItem.name;
	          scope.$apply();
	        });
	
	        // Get the disabled attribute value first, then setup observing of value changes
	        mdNavItem.disabled = $mdUtil.parseAttributeBoolean(attrs['disabled'], false);
	        if ('MutationObserver' in $window) {
	          var config = {attributes: true, attributeFilter: ['disabled']};
	          var targetNode = element[0];
	          var mutationCallback = function(mutationList) {
	            $mdUtil.nextTick(function() {
	              mdNavItem.disabled = $mdUtil.parseAttributeBoolean(attrs[mutationList[0].attributeName], false);
	            });
	          };
	          var observer = new MutationObserver(mutationCallback);
	          observer.observe(targetNode, config);
	          disconnect = observer.disconnect.bind(observer);
	        } else {
	          attrs.$observe('disabled', function (value) {
	            mdNavItem.disabled = $mdUtil.parseAttributeBoolean(value, false);
	          });
	        }
	
	        if (!mdNavItem.navItemAriaLabel) {
	          $mdAria.expectWithText(navButton, 'aria-label');
	        }
	      });
	
	      scope.$on('destroy', function() {
	        navButton.off('keydown');
	        navButton.off('focus');
	        navButton.off('click');
	        disconnect();
	      });
	    }
	  };
	}
	
	/**
	 * Controller for the nav-item component.
	 * @param {!JQLite} $element
	 * @constructor
	 * @final
	 * @ngInject
	 */
	function MdNavItemController($element) {
	
	  /**
	   * @private @const
	   * @type {!JQLite}
	   */
	  this._$element = $element;
	
	  // Data-bound variables
	
	  /**
	   * @const
	   * @type {?Function}
	   */
	  this.mdNavClick;
	
	  /**
	   * @const
	   * @type {?string}
	   */
	  this.mdNavHref;
	
	  /**
	   * @const
	   * @type {?string}
	   */
	  this.mdNavSref;
	  /**
	   * @const
	   * @type {?Object}
	   */
	  this.srefOpts;
	  /**
	   * @const
	   * @type {?string}
	   */
	  this.name;
	
	  /**
	   * @const
	   * @type {string}
	   */
	  this.navItemAriaLabel;
	
	  // State variables
	  /**
	   * @private
	   * @type {boolean}
	   */
	  this._selected = false;
	
	  /**
	   * @type {boolean}
	   */
	  this.isFocused = false;
	}
	
	/**
	 * Returns a map of class names and values for use by ng-class.
	 * @return {!Object<string,boolean>}
	 */
	MdNavItemController.prototype.getNgClassMap = function() {
	  return {
	    'md-active': this._selected,
	    'md-primary': this._selected,
	    'md-unselected': !this._selected,
	    'md-focused': this.isFocused,
	  };
	};
	
	/**
	 * Get the name attribute of the tab.
	 * @return {string}
	 */
	MdNavItemController.prototype.getName = function() {
	  return this.name;
	};
	
	/**
	 * Get the button element associated with the tab.
	 * @return {!Element}
	 */
	MdNavItemController.prototype.getButtonEl = function() {
	  return this._$element[0].querySelector('._md-nav-button');
	};
	
	/**
	 * Set the selected state of the tab and updates the tabindex.
	 * This function is called for the oldTab and newTab when selection changes.
	 * @param {boolean} isSelected true to select the tab, false to deselect the tab
	 */
	MdNavItemController.prototype.setSelected = function(isSelected) {
	  this._selected = isSelected;
	  if (isSelected) {
	    // https://www.w3.org/TR/wai-aria-practices/examples/tabs/tabs-2/tabs.html suggests that we call
	    // removeAttribute('tabindex') here, but that causes our unit tests to fail due to
	    // document.activeElement staying set to the body instead of the focused nav button.
	    this.getButtonEl().setAttribute('tabindex', '0');
	  } else {
	    this.getButtonEl().setAttribute('tabindex', '-1');
	  }
	};
	
	/**
	 * @return {boolean}
	 */
	MdNavItemController.prototype.isSelected = function() {
	  return this._selected;
	};
	
	/**
	 * Set the focused state of the tab.
	 * @param {boolean} isFocused
	 */
	MdNavItemController.prototype.setFocused = function(isFocused) {
	  this.isFocused = isFocused;
	
	  if (isFocused) {
	    this.getButtonEl().focus();
	  }
	};
	
	/**
	 * @return {boolean} true if the tab has focus, false if not.
	 */
	MdNavItemController.prototype.hasFocus = function() {
	  return this.isFocused;
	};
	
	/**
	 * @return {boolean} true if the tab is enabled, false if disabled.
	 * @private
	 */
	MdNavItemController.prototype._isEnabled = function() {
	  return !this._$element.attr('disabled');
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.panel
	 */
	MdPanelService.$inject = ["presets", "$rootElement", "$rootScope", "$injector", "$window"];
	angular
	  .module('material.components.panel', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .provider('$mdPanel', MdPanelProvider);
	
	
	/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc service
	 * @name $mdPanelProvider
	 * @module material.components.panel
	 *
	 * @description
	 * `$mdPanelProvider` allows users to create configuration presets that will be
	 * stored within a cached presets object. When the configuration is needed, the
	 * user can request the preset by passing it as the first parameter in the
	 * `$mdPanel.create` or `$mdPanel.open` methods.
	 *
	 * @usage
	 * <hljs lang="js">
	 * (function(angular, undefined) {
	 *   'use strict';
	 *
	 *   angular
	 *       .module('demoApp', ['ngMaterial'])
	 *       .config(DemoConfig)
	 *       .controller('DemoCtrl', DemoCtrl)
	 *       .controller('DemoMenuCtrl', DemoMenuCtrl);
	 *
	 *   function DemoConfig($mdPanelProvider) {
	 *     $mdPanelProvider.definePreset('demoPreset', {
	 *       attachTo: angular.element(document.body),
	 *       controller: DemoMenuCtrl,
	 *       controllerAs: 'ctrl',
	 *       template: '' +
	 *           '<div class="menu-panel" md-whiteframe="4">' +
	 *           '  <div class="menu-content">' +
	 *           '    <div class="menu-item" ng-repeat="item in ctrl.items">' +
	 *           '      <button class="md-button">' +
	 *           '        <span>{{item}}</span>' +
	 *           '      </button>' +
	 *           '    </div>' +
	 *           '    <md-divider></md-divider>' +
	 *           '    <div class="menu-item">' +
	 *           '      <button class="md-button" ng-click="ctrl.closeMenu()">' +
	 *           '        <span>Close Menu</span>' +
	 *           '      </button>' +
	 *           '    </div>' +
	 *           '  </div>' +
	 *           '</div>',
	 *       panelClass: 'menu-panel-container',
	 *       focusOnOpen: false,
	 *       zIndex: 100,
	 *       propagateContainerEvents: true,
	 *       groupName: 'menus'
	 *     });
	 *   }
	 *
	 *   function PanelProviderCtrl($mdPanel) {
	 *     this.navigation = {
	 *       name: 'navigation',
	 *       items: [
	 *         'Home',
	 *         'About',
	 *         'Contact'
	 *       ]
	 *     };
	 *     this.favorites = {
	 *       name: 'favorites',
	 *       items: [
	 *         'Add to Favorites'
	 *       ]
	 *     };
	 *     this.more = {
	 *       name: 'more',
	 *       items: [
	 *         'Account',
	 *         'Sign Out'
	 *       ]
	 *     };
	 *
	 *     $mdPanel.newPanelGroup('menus', {
	 *       maxOpen: 2
	 *     });
	 *
	 *     this.showMenu = function($event, menu) {
	 *       $mdPanel.open('demoPreset', {
	 *         id: 'menu_' + menu.name,
	 *         position: $mdPanel.newPanelPosition()
	 *             .relativeTo($event.target)
	 *             .addPanelPosition(
	 *               $mdPanel.xPosition.ALIGN_START,
	 *               $mdPanel.yPosition.BELOW
	 *             ),
	 *         locals: {
	 *           items: menu.items
	 *         },
	 *         openFrom: $event
	 *       });
	 *     };
	 *   }
	 *
	 *   function PanelMenuCtrl(mdPanelRef) {
	 *     // 'mdPanelRef' is injected in the controller.
	 *     this.closeMenu = function() {
	 *       if (mdPanelRef) {
	 *         mdPanelRef.close();
	 *       }
	 *     };
	 *   }
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanelProvider#definePreset
	 * @description
	 * Takes the passed in preset name and preset configuration object and adds it
	 * to the `_presets` object of the provider. This `_presets` object is then
	 * passed along to the `$mdPanel` service.
	 *
	 * @param {string} name Preset name.
	 * @param {!Object} preset Specific configuration object that can contain any
	 *     and all of the parameters available within the `$mdPanel.create` method.
	 *     However, parameters that pertain to id, position, animation, and user
	 *     interaction are not allowed and will be removed from the preset
	 *     configuration.
	 */
	
	
	/*****************************************************************************
	 *                               MdPanel Service                             *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc service
	 * @name $mdPanel
	 * @module material.components.panel
	 *
	 * @description
	 * `$mdPanel` is a robust, low-level service for creating floating panels on
	 * the screen. It can be used to implement tooltips, dialogs, pop-ups, etc.
	 *
	 * The following types, referenced below, have separate documentation:
	 * - <a ng-href="api/type/MdPanelAnimation">MdPanelAnimation</a> from `$mdPanel.newPanelAnimation()`
	 * - <a ng-href="api/type/MdPanelPosition">MdPanelPosition</a> from `$mdPanel.newPanelPosition()`
	 * - <a ng-href="api/type/MdPanelRef">MdPanelRef</a> from the `$mdPanel.open()` Promise or
	 * injected in the panel's controller
	 *
	 * @usage
	 * <hljs lang="js">
	 * (function(angular, undefined) {
	 *   'use strict';
	 *
	 *   angular
	 *       .module('demoApp', ['ngMaterial'])
	 *       .controller('DemoDialogController', DialogController)
	 *       .controller('DemoCtrl', function($mdPanel) {
	 *
	 *     var panelRef;
	 *
	 *     function showPanel($event) {
	 *       var panelPosition = $mdPanel.newPanelPosition()
	 *           .absolute()
	 *           .top('50%')
	 *           .left('50%');
	 *
	 *       var panelAnimation = $mdPanel.newPanelAnimation()
	 *           .openFrom($event)
	 *           .duration(200)
	 *           .closeTo('.show-button')
	 *           .withAnimation($mdPanel.animation.SCALE);
	 *
	 *       var config = {
	 *         attachTo: angular.element(document.body),
	 *         controller: DialogController,
	 *         controllerAs: 'ctrl',
	 *         position: panelPosition,
	 *         animation: panelAnimation,
	 *         targetEvent: $event,
	 *         templateUrl: 'dialog-template.html',
	 *         clickOutsideToClose: true,
	 *         escapeToClose: true,
	 *         focusOnOpen: true
	 *       };
	 *
	 *       $mdPanel.open(config)
	 *           .then(function(result) {
	 *             panelRef = result;
	 *           });
	 *     }
	 *   }
	 *
	 *   function DialogController(MdPanelRef) {
	 *     function closeDialog() {
	 *       if (MdPanelRef) MdPanelRef.close();
	 *     }
	 *   }
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#create
	 * @description
	 * Creates a panel with the specified options.
	 *
	 * @param {!Object=} config Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `id` - `{string=}`: An ID to track the panel by. When an ID is provided,
	 *     the created panel is added to a tracked panels object. Any subsequent
	 *     requests made to create a panel with that ID are ignored. This is useful
	 *     in having the panel service not open multiple panels from the same user
	 *     interaction when there is no backdrop and events are propagated. Defaults
	 *     to an arbitrary string that is not tracked.
	 *   - `template` - `{string=}`: HTML template to show in the panel. This
	 *     **must** be trusted HTML with respect to AngularJS’s
	 *     [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
	 *   - `templateUrl` - `{string=}`: The URL that will be used as the content of
	 *     the panel.
	 *   - `contentElement` - `{(string|!JQLite|!Element)=}`: Pre-compiled
	 *     element to be used as the panel's content.
	 *   - `controller` - `{(function|string)=}`: The controller to associate with
	 *     the panel. The controller can inject a reference to the returned
	 *     panelRef, which allows the panel to be closed, hidden, and shown. Any
	 *     fields passed in through locals or resolve will be bound to the
	 *     controller.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on
	 *     the scope.
	 *   - `bindToController` - `{boolean=}`: Binds locals to the controller
	 *     instead of passing them in. Defaults to true, as this is a best
	 *     practice.
	 *   - `locals` - `{Object=}`: An object containing key/value pairs. The keys
	 *     will be used as names of values to inject into the controller. For
	 *     example, `locals: {three: 3}` would inject `three` into the controller,
	 *     with the value 3. 'mdPanelRef' is a reserved key, and will always
	 *     be set to the created `MdPanelRef` instance.
	 *   - `resolve` - `{Object=}`: Similar to locals, except it takes promises as
	 *     values. The panel will not open until all of the promises resolve.
	 *   - `attachTo` - `{(string|!JQLite|!Element)=}`: The element to
	 *     attach the panel to. Defaults to appending to the root element of the
	 *     application.
	 *   - `propagateContainerEvents` - `{boolean=}`: Whether pointer or touch
	 *     events should be allowed to propagate 'go through' the container, aka the
	 *     wrapper, of the panel. Defaults to false.
	 *   - `panelClass` - `{string=}`: A css class to apply to the panel element.
	 *     This class should define any borders, box-shadow, etc. for the panel.
	 *   - `zIndex` - `{number=}`: The z-index to place the panel at.
	 *     Defaults to 80.
	 *   - `position` - `{MdPanelPosition=}`: An MdPanelPosition object that
	 *     specifies the alignment of the panel. For more information, see
	 *     `MdPanelPosition`.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click
	 *     outside the panel to close it. Defaults to false.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to
	 *     close the panel. Defaults to false.
	 *   - `onCloseSuccess` - `{function(!panelRef, string)=}`: Function that is
	 *     called after the close successfully finishes. The first parameter passed
	 *     into this function is the current panelRef and the 2nd is an optional
	 *     string explaining the close reason. The currently supported closeReasons
	 *     can be found in the `MdPanelRef.closeReasons` enum. These are by default
	 *     passed along by the panel.
	 *   - `trapFocus` - `{boolean=}`: Whether focus should be trapped within the
	 *     panel. If `trapFocus` is true, the user will not be able to interact
	 *     with the rest of the page until the panel is dismissed. Defaults to
	 *     false.
	 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on
	 *     open. Only disable if focusing some other way, as focus management is
	 *     required for panels to be accessible. Defaults to true.
	 *   - `fullscreen` - `{boolean=}`: Whether the panel should be full screen.
	 *     Applies the class `._md-panel-fullscreen` to the panel on open. Defaults
	 *     to false.
	 *   - `animation` - `{MdPanelAnimation=}`: An MdPanelAnimation object that
	 *     specifies the animation of the panel. For more information, see
	 *     `MdPanelAnimation`.
	 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop
	 *     behind the panel. Defaults to false.
	 *   - `disableParentScroll` - `{boolean=}`: Whether the user can scroll the
	 *     page behind the panel. Defaults to false.
	 *   - `onDomAdded` - `{function=}`: Callback function used to announce when
	 *     the panel is added to the DOM.
	 *   - `onOpenComplete` - `{function=}`: Callback function used to announce
	 *     when the open() action is finished.
	 *   - `onRemoving` - `{function=}`: Callback function used to announce the
	 *     close/hide() action is starting.
	 *   - `onDomRemoved` - `{function=}`: Callback function used to announce when
	 *     the panel is removed from the DOM.
	 *   - `origin` - `{(string|!JQLite|!Element)=}`: The element to focus
	 *     on when the panel closes. This is commonly the element which triggered
	 *     the opening of the panel. If you do not use `origin`, you need to control
	 *     the focus manually.
	 *   - `groupName` - `{(string|!Array<string>)=}`: A group name or an array of
	 *     group names. The group name is used for creating a group of panels. The
	 *     group is used for configuring the number of open panels and identifying
	 *     specific behaviors for groups. For instance, all tooltips could be
	 *     identified using the same groupName.
	 *
	 * @returns {!MdPanelRef} panelRef
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#open
	 * @description
	 * Calls the create method above, then opens the panel. This is a shortcut for
	 * creating and then calling open manually. If custom methods need to be
	 * called when the panel is added to the DOM or opened, do not use this method.
	 * Instead create the panel, chain promises on the domAdded and openComplete
	 * methods, and call open from the returned panelRef.
	 *
	 * @param {!Object=} config Specific configuration object that may contain
	 *     the properties defined in `$mdPanel.create`.
	 * @returns {!Q.IPromise<!MdPanelRef>} panelRef A promise that resolves
	 *     to an instance of the panel.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelPosition
	 * @description
	 * Returns a new instance of the MdPanelPosition object. Use this to create
	 * the position config object.
	 *
	 * @returns {!MdPanelPosition} panelPosition
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelAnimation
	 * @description
	 * Returns a new instance of the MdPanelAnimation object. Use this to create
	 * the animation config object.
	 *
	 * @returns {!MdPanelAnimation} panelAnimation
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#setGroupMaxOpen
	 * @description
	 * Sets the maximum number of panels in a group that can be opened at a given
	 * time.
	 *
	 * @param {string} groupName The name of the group to configure.
	 * @param {number} maxOpen The maximum number of panels that can be
	 *     opened. Infinity can be passed in to remove the maxOpen limit.
	 */
	
	
	/*****************************************************************************
	 *                                 MdPanelRef                                *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelRef
	 * @module material.components.panel
	 * @description
	 * A reference to a created panel. This reference contains a unique id for the
	 * panel, along with the following properties:
	 *
	 *   - `id` - `{string}`: The unique id for the panel. This id is used to track
	 *     when a panel was interacted with.
	 *   - `config` - `{!Object=}`: The entire config object that was used in
	 *     create.
	 *   - `isAttached` - `{boolean}`: Whether the panel is attached to the DOM.
	 *     Visibility to the user does not factor into isAttached.
	 *   - `panelContainer` - `{JQLite}`: The wrapper element containing the
	 *     panel. This property is added in order to have access to the `addClass`,
	 *     `removeClass`, `toggleClass`, etc methods.
	 *   - `panelEl` - `{JQLite}`: The panel element. This property is added
	 *     in order to have access to the `addClass`, `removeClass`, `toggleClass`,
	 *     etc methods.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#open
	 * @description
	 * Attaches and shows the panel.
	 *
	 * @returns {!Q.IPromise} A promise that is resolved when the panel is
	 *     opened.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#close
	 * @description
	 * Hides and detaches the panel. Note that this will **not** destroy the panel.
	 * If you don't intend on using the panel again, call the {@link #destroy
	 * destroy} method afterwards.
	 *
	 * @returns {!Q.IPromise} A promise that is resolved when the panel is
	 *     closed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#attach
	 * @description
	 * Create the panel elements and attach them to the DOM. The panel will be
	 * hidden by default.
	 *
	 * @returns {!Q.IPromise} A promise that is resolved when the panel is
	 *     attached.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#detach
	 * @description
	 * Removes the panel from the DOM. This will NOT hide the panel before removing
	 * it.
	 *
	 * @returns {!Q.IPromise} A promise that is resolved when the panel is
	 *     detached.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#show
	 * @description
	 * Shows the panel.
	 *
	 * @returns {!Q.IPromise} A promise that is resolved when the panel has
	 *     shown and animations are completed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#hide
	 * @description
	 * Hides the panel.
	 *
	 * @returns {!Q.IPromise} A promise that is resolved when the panel has
	 *     hidden and animations are completed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#destroy
	 * @description
	 * Destroys the panel. The panel cannot be opened again after this is called.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#updatePosition
	 * @description
	 * Updates the position configuration of a panel. Use this to update the
	 * position of a panel that is open, without having to close and re-open the
	 * panel.
	 *
	 * @param {!MdPanelPosition} position
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#addToGroup
	 * @description
	 * Adds a panel to a group if the panel does not exist within the group already.
	 * A panel can only exist within a single group.
	 *
	 * @param {string} groupName The name of the group to add the panel to.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeFromGroup
	 * @description
	 * Removes a panel from a group if the panel exists within that group. The group
	 * must be created ahead of time.
	 *
	 * @param {string} groupName The name of the group.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#registerInterceptor
	 * @description
	 * Registers an interceptor with the panel. The callback should return a promise,
	 * which will allow the action to continue when it gets resolved, or will
	 * prevent an action if it is rejected. The interceptors are called sequentially
	 * and it reverse order. `type` must be one of the following
	 * values available on `$mdPanel.interceptorTypes`:
	 * * `CLOSE` - Gets called before the panel begins closing.
	 *
	 * @param {string} type Type of interceptor.
	 * @param {!Q.IPromise<any>} callback Callback to be registered.
	 * @returns {!MdPanelRef}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeInterceptor
	 * @description
	 * Removes a registered interceptor.
	 *
	 * @param {string} type Type of interceptor to be removed.
	 * @param {function(): !Q.IPromise<any>} callback Interceptor to be removed.
	 * @returns {!MdPanelRef}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeAllInterceptors
	 * @description
	 * Removes all interceptors. If a type is supplied, only the
	 * interceptors of that type will be cleared.
	 *
	 * @param {string=} type Type of interceptors to be removed.
	 * @returns {!MdPanelRef}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#updateAnimation
	 * @description
	 * Updates the animation configuration for a panel. You can use this to change
	 * the panel's animation without having to re-create it.
	 *
	 * @param {!MdPanelAnimation} animation
	 */
	
	
	/*****************************************************************************
	 *                               MdPanelPosition                            *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelPosition
	 * @module material.components.panel
	 * @description
	 *
	 * Object for configuring the position of the panel.
	 *
	 * @usage
	 *
	 * #### Centering the panel
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition().absolute().center();
	 * </hljs>
	 *
	 * #### Overlapping the panel with an element
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition()
	 *     .relativeTo(someElement)
	 *     .addPanelPosition(
	 *       $mdPanel.xPosition.ALIGN_START,
	 *       $mdPanel.yPosition.ALIGN_TOPS
	 *     );
	 * </hljs>
	 *
	 * #### Aligning the panel with the bottom of an element
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition()
	 *     .relativeTo(someElement)
	 *     .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#absolute
	 * @description
	 * Positions the panel absolutely relative to the parent element. If the parent
	 * is document.body, this is equivalent to positioning the panel absolutely
	 * within the viewport.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#relativeTo
	 * @description
	 * Positions the panel relative to a specific element.
	 *
	 * @param {string|!Element|!JQLite} element Query selector, DOM element,
	 *     or angular element to position the panel with respect to.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#top
	 * @description
	 * Sets the value of `top` for the panel. Clears any previously set vertical
	 * position.
	 *
	 * @param {string=} top Value of `top`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#bottom
	 * @description
	 * Sets the value of `bottom` for the panel. Clears any previously set vertical
	 * position.
	 *
	 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#start
	 * @description
	 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
	 * `rtl`. Clears any previously set horizontal position.
	 *
	 * @param {string=} start Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#end
	 * @description
	 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
	 * Clears any previously set horizontal position.
	 *
	 * @param {string=} end Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#left
	 * @description
	 * Sets the value of `left` for the panel. Clears any previously set
	 * horizontal position.
	 *
	 * @param {string=} left Value of `left`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#right
	 * @description
	 * Sets the value of `right` for the panel. Clears any previously set
	 * horizontal position.
	 *
	 * @param {string=} right Value of `right`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#centerHorizontally
	 * @description
	 * Centers the panel horizontally in the viewport. Clears any previously set
	 * horizontal position.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#centerVertically
	 * @description
	 * Centers the panel vertically in the viewport. Clears any previously set
	 * vertical position.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#center
	 * @description
	 * Centers the panel horizontally and vertically in the viewport. This is
	 * equivalent to calling both `centerHorizontally` and `centerVertically`.
	 * Clears any previously set horizontal and vertical positions.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#addPanelPosition
	 * @description
	 * Sets the x and y position for the panel relative to another element. Can be
	 * called multiple times to specify an ordered list of panel positions. The
	 * first position which allows the panel to be completely on-screen will be
	 * chosen; the last position will be chose whether it is on-screen or not.
	 *
	 * xPosition must be one of the following values available on
	 * $mdPanel.xPosition:
	 *
	 *
	 * CENTER | ALIGN_START | ALIGN_END | OFFSET_START | OFFSET_END
	 *
	 * <pre>
	 *    *************
	 *    *           *
	 *    *   PANEL   *
	 *    *           *
	 *    *************
	 *   A B    C    D E
	 *
	 * A: OFFSET_START (for LTR displays)
	 * B: ALIGN_START (for LTR displays)
	 * C: CENTER
	 * D: ALIGN_END (for LTR displays)
	 * E: OFFSET_END (for LTR displays)
	 * </pre>
	 *
	 * yPosition must be one of the following values available on
	 * $mdPanel.yPosition:
	 *
	 * CENTER | ALIGN_TOPS | ALIGN_BOTTOMS | ABOVE | BELOW
	 *
	 * <pre>
	 *   F
	 *   G *************
	 *     *           *
	 *   H *   PANEL   *
	 *     *           *
	 *   I *************
	 *   J
	 *
	 * F: BELOW
	 * G: ALIGN_TOPS
	 * H: CENTER
	 * I: ALIGN_BOTTOMS
	 * J: ABOVE
	 * </pre>
	 *
	 * @param {string} xPosition
	 * @param {string} yPosition
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#withOffsetX
	 * @description
	 * Sets the value of the offset in the x-direction.
	 *
	 * @param {string|number} offsetX
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#withOffsetY
	 * @description
	 * Sets the value of the offset in the y-direction.
	 *
	 * @param {string|number} offsetY
	 * @returns {!MdPanelPosition}
	 */
	
	
	/*****************************************************************************
	 *                               MdPanelAnimation                            *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelAnimation
	 * @module material.components.panel
	 * @description
	 * Animation configuration object. To use, create an MdPanelAnimation with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * @usage
	 *
	 * <hljs lang="js">
	 * var panelAnimation = new MdPanelAnimation()
	 *     .openFrom(myButtonEl)
	 *     .duration(1337)
	 *     .closeTo('.my-button')
	 *     .withAnimation($mdPanel.animation.SCALE);
	 *
	 * $mdPanel.create({
	 *   animation: panelAnimation
	 * });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#openFrom
	 * @description
	 * Specifies where to start the open animation. `openFrom` accepts a
	 * click event object, query selector, DOM element, or a Rect object that
	 * is used to determine the bounds. When passed a click event, the location
	 * of the click will be used as the position to start the animation.
	 *
	 * @param {string|!Element|!Event|{top: number, left: number}}
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#closeTo
	 * @description
	 * Specifies where to animate the panel close. `closeTo` accepts a
	 * query selector, DOM element, or a Rect object that is used to determine
	 * the bounds.
	 *
	 * @param {string|!Element|{top: number, left: number}}
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#withAnimation
	 * @description
	 * Specifies the animation class.
	 *
	 * There are several default animations that can be used: `$mdPanel.animation.`
	 *  - `SLIDE`: The panel slides in and out from the specified
	 *       elements. It will not fade in or out.
	 *  - `SCALE`: The panel scales in and out. Slide and fade are
	 *       included in this animation.
	 *  - `FADE`: The panel fades in and out.
	 *
	 * Custom classes will by default fade in and out unless
	 * `transition: opacity 1ms` is added to the to custom class.
	 *
	 * @param {string|{open: string, close: string}} cssClass
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#duration
	 * @description
	 * Specifies the duration of the animation in milliseconds. The `duration`
	 * method accepts either a number or an object with separate open and close
	 * durations.
	 *
	 * @param {number|{open: number, close: number}} duration
	 * @returns {!MdPanelAnimation}
	 */
	
	
	/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************/
	
	
	var MD_PANEL_Z_INDEX = 80;
	var MD_PANEL_HIDDEN = '_md-panel-hidden';
	var FOCUS_TRAP_TEMPLATE;
	
	var _presets = {};
	
	
	/**
	 * A provider that is used for creating presets for the panel API.
	 * @final @constructor @ngInject
	 */
	function MdPanelProvider() {
	  return {
	    'definePreset': definePreset,
	    'getAllPresets': getAllPresets,
	    'clearPresets': clearPresets,
	    '$get': $getProvider()
	  };
	}
	
	
	/**
	 * Takes the passed in panel configuration object and adds it to the `_presets`
	 * object at the specified name.
	 * @param {string} name Name of the preset to set.
	 * @param {!Object} preset Specific configuration object that can contain any
	 *     and all of the parameters available within the `$mdPanel.create` method.
	 *     However, parameters that pertain to id, position, animation, and user
	 *     interaction are not allowed and will be removed from the preset
	 *     configuration.
	 */
	function definePreset(name, preset) {
	  if (!name || !preset) {
	    throw new Error('mdPanelProvider: The panel preset definition is ' +
	        'malformed. The name and preset object are required.');
	  } else if (_presets.hasOwnProperty(name)) {
	    throw new Error('mdPanelProvider: The panel preset you have requested ' +
	        'has already been defined.');
	  }
	
	  // Delete any property on the preset that is not allowed.
	  delete preset.id;
	  delete preset.position;
	  delete preset.animation;
	
	  _presets[name] = preset;
	}
	
	
	/**
	 * Gets a clone of the `_presets`.
	 * @return {!Object}
	 */
	function getAllPresets() {
	  return angular.copy(_presets);
	}
	
	
	/**
	 * Clears all of the stored presets.
	 */
	function clearPresets() {
	  _presets = {};
	}
	
	
	/**
	 * Represents the `$get` method of the AngularJS provider. From here, a new
	 * reference to the MdPanelService is returned where the needed arguments are
	 * passed in including the MdPanelProvider `_presets`.
	 * @param {!Object} _presets
	 * @param {!JQLite} $rootElement
	 * @param {!angular.Scope} $rootScope
	 * @param {!IInjectorService} $injector
	 * @param {!IWindowService} $window
	 */
	function $getProvider() {
	  return [
	    '$rootElement', '$rootScope', '$injector', '$window',
	    function($rootElement, $rootScope, $injector, $window) {
	      return new MdPanelService(_presets, $rootElement, $rootScope,
	          $injector, $window);
	    }
	  ];
	}
	
	/**
	 * @param {string|[]} value
	 * @returns {[]} the input string wrapped in an Array or the original Array
	 */
	function coerceToArray(value) {
	  if (angular.isString(value)) {
	    value = [value];
	  }
	  return value;
	}
	
	/*****************************************************************************
	 *                               MdPanel Service                             *
	 *****************************************************************************/
	
	
	/**
	 * A service that is used for controlling/displaying panels on the screen.
	 * @param {!Object} presets
	 * @param {!JQLite} $rootElement
	 * @param {!angular.Scope} $rootScope
	 * @param {!IInjectorService} $injector
	 * @param {!IWindowService} $window
	 * @final @constructor @ngInject
	 */
	function MdPanelService(presets, $rootElement, $rootScope, $injector, $window) {
	  /**
	   * Default config options for the panel.
	   * Anything angular related needs to be done later. Therefore
	   *     scope: $rootScope.$new(true),
	   *     attachTo: $rootElement,
	   * are added later.
	   * @private {!Object}
	   */
	  this._defaultConfigOptions = {
	    bindToController: true,
	    clickOutsideToClose: false,
	    disableParentScroll: false,
	    escapeToClose: false,
	    focusOnOpen: true,
	    fullscreen: false,
	    hasBackdrop: false,
	    propagateContainerEvents: false,
	    transformTemplate: angular.bind(this, this._wrapTemplate),
	    trapFocus: false,
	    zIndex: MD_PANEL_Z_INDEX
	  };
	
	  /** @private {!Object} */
	  this._config = {};
	
	  /** @private {!Object} */
	  this._presets = presets;
	
	  /** @private @const */
	  this._$rootElement = $rootElement;
	
	  /** @private @const */
	  this._$rootScope = $rootScope;
	
	  /** @private @const */
	  this._$injector = $injector;
	
	  /** @private @const */
	  this._$window = $window;
	
	  /** @private @const */
	  this._$mdUtil = this._$injector.get('$mdUtil');
	
	  /** @private {!Object<string, !MdPanelRef>} */
	  this._trackedPanels = {};
	
	  /**
	   * @private {!Object<string,
	   *     {panels: !Array<!MdPanelRef>,
	   *     openPanels: !Array<!MdPanelRef>,
	   *     maxOpen: number}>}
	   */
	  this._groups = Object.create(null);
	
	  /**
	   * Default animations that can be used within the panel.
	   * @type {enum}
	   */
	  this.animation = MdPanelAnimation.animation;
	
	  /**
	   * Possible values of xPosition for positioning the panel relative to
	   * another element.
	   * @type {enum}
	   */
	  this.xPosition = MdPanelPosition.xPosition;
	
	  /**
	   * Possible values of yPosition for positioning the panel relative to
	   * another element.
	   * @type {enum}
	   */
	  this.yPosition = MdPanelPosition.yPosition;
	
	  /**
	   * Possible values for the interceptors that can be registered on a panel.
	   * @type {enum}
	   */
	  this.interceptorTypes = MdPanelRef.interceptorTypes;
	
	  /**
	   * Possible values for closing of a panel.
	   * @type {enum}
	   */
	  this.closeReasons = MdPanelRef.closeReasons;
	
	  /**
	   * Possible values of absolute position.
	   * @type {enum}
	   */
	  this.absPosition = MdPanelPosition.absPosition;
	}
	
	
	/**
	 * Creates a panel with the specified options.
	 * @param {string|Object=} preset Name of a preset configuration that can be used to
	 *     extend the panel configuration.
	 * @param {!Object=} config Configuration object for the panel.
	 * @returns {!MdPanelRef}
	 */
	MdPanelService.prototype.create = function(preset, config) {
	  if (typeof preset === 'string') {
	    preset = this._getPresetByName(preset);
	  } else if (typeof preset === 'object' &&
	      (angular.isUndefined(config) || !config)) {
	    config = preset;
	    preset = {};
	  }
	
	  preset = preset || {};
	  config = config || {};
	
	  // If the passed-in config contains an ID and the ID is within _trackedPanels,
	  // return the tracked panel after updating its config with the passed-in
	  // config.
	  if (angular.isDefined(config.id) && this._trackedPanels[config.id]) {
	    var trackedPanel = this._trackedPanels[config.id];
	    angular.extend(trackedPanel.config, config);
	    return trackedPanel;
	  }
	
	  // Combine the passed-in config, the _defaultConfigOptions, and the preset
	  // configuration into the `_config`.
	  this._config = angular.extend({
	    // If no ID is set within the passed-in config, then create an arbitrary ID.
	    id: config.id || 'panel_' + this._$mdUtil.nextUid(),
	    scope: this._$rootScope.$new(true),
	    attachTo: this._$rootElement
	  }, this._defaultConfigOptions, config, preset);
	
	  // Create the panelRef and add it to the `_trackedPanels` object.
	  var panelRef = new MdPanelRef(this._config, this._$injector);
	  this._trackedPanels[this._config.id] = panelRef;
	
	  // Add the panel to each of its requested groups.
	  if (this._config.groupName) {
	    this._config.groupName = coerceToArray(this._config.groupName);
	    angular.forEach(this._config.groupName, function(group) {
	      panelRef.addToGroup(group);
	    });
	  }
	
	  this._config.scope.$on('$destroy', angular.bind(panelRef, panelRef.detach));
	
	  return panelRef;
	};
	
	
	/**
	 * Creates and opens a panel with the specified options.
	 * @param {string=} preset Name of a preset configuration that can be used to
	 *     extend the panel configuration.
	 * @param {!Object=} config Configuration object for the panel.
	 * @returns {!Q.IPromise<!MdPanelRef>} The panel created from create.
	 */
	MdPanelService.prototype.open = function(preset, config) {
	  var panelRef = this.create(preset, config);
	  return panelRef.open().then(function() {
	    return panelRef;
	  });
	};
	
	
	/**
	 * Gets a specific preset configuration object saved within `_presets`.
	 * @param {string} preset Name of the preset to search for.
	 * @returns {!Object} The preset configuration object.
	 */
	MdPanelService.prototype._getPresetByName = function(preset) {
	  if (!this._presets[preset]) {
	    throw new Error('mdPanel: The panel preset configuration that you ' +
	        'requested does not exist. Use the $mdPanelProvider to create a ' +
	        'preset before requesting one.');
	  }
	  return this._presets[preset];
	};
	
	
	/**
	 * Returns a new instance of the MdPanelPosition. Use this to create the
	 * positioning object.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelService.prototype.newPanelPosition = function() {
	  return new MdPanelPosition(this._$injector);
	};
	
	
	/**
	 * Returns a new instance of the MdPanelAnimation. Use this to create the
	 * animation object.
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelService.prototype.newPanelAnimation = function() {
	  return new MdPanelAnimation(this._$injector);
	};
	
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelGroup
	 * @description
	 * Creates a panel group and adds it to a tracked list of panel groups.
	 * @param {string} groupName Name of the group to create.
	 * @param {{maxOpen: number}=} config Configuration object that may contain the following
	 *  properties:
	 *
	 *   - `maxOpen`: The maximum number of panels that are allowed open within a defined panel group.
	 *
	 * @returns {!{panels: !Array<!MdPanelRef>, openPanels: !Array<!MdPanelRef>, maxOpen: number}}
	 *  the new panel group
	 */
	MdPanelService.prototype.newPanelGroup = function(groupName, config) {
	  if (!this._groups[groupName]) {
	    config = config || {};
	    this._groups[groupName] = {
	      panels: [],
	      openPanels: [],
	      maxOpen: config.maxOpen > 0 ? config.maxOpen : Infinity
	    };
	  }
	  return this._groups[groupName];
	};
	
	
	/**
	 * Sets the maximum number of panels in a group that can be opened at a given
	 * time.
	 * @param {string} groupName The name of the group to configure.
	 * @param {number} maxOpen The maximum number of panels that can be
	 *     opened. Infinity can be passed in to remove the maxOpen limit.
	 */
	MdPanelService.prototype.setGroupMaxOpen = function(groupName, maxOpen) {
	  if (this._groups[groupName]) {
	    this._groups[groupName].maxOpen = maxOpen;
	  } else {
	    throw new Error('mdPanel: Group does not exist yet. Call newPanelGroup().');
	  }
	};
	
	
	/**
	 * Determines if the current number of open panels within a group exceeds the
	 * limit of allowed open panels.
	 * @param {string} groupName The name of the group to check.
	 * @returns {boolean} true if open count does exceed maxOpen and false if not.
	 * @private
	 */
	MdPanelService.prototype._openCountExceedsMaxOpen = function(groupName) {
	  if (this._groups[groupName]) {
	    var group = this._groups[groupName];
	    return group.maxOpen > 0 && group.openPanels.length > group.maxOpen;
	  }
	  return false;
	};
	
	
	/**
	 * Closes the first open panel within a specific group.
	 * @param {string} groupName The name of the group.
	 * @private
	 */
	MdPanelService.prototype._closeFirstOpenedPanel = function(groupName) {
	  var group = this._groups[groupName];
	  if (group && group.openPanels.length) {
	    group.openPanels[0].close();
	  }
	};
	
	
	/**
	 * Wraps the user's template in three elements:
	 * - md-panel-outer-wrapper - covers the entire `attachTo` element.
	 * - md-panel-inner-wrapper - handles the positioning.
	 * - md-panel - contains the user's content and deals with the animations.
	 * @param {string} origTemplate The original template.
	 * @returns {string} The wrapped template.
	 * @private
	 */
	MdPanelService.prototype._wrapTemplate = function(origTemplate) {
	  var template = origTemplate || '';
	
	  // The panel should be initially rendered offscreen so we can calculate
	  // height and width for positioning.
	  return '' +
	      '<div class="md-panel-outer-wrapper">' +
	        '<div class="md-panel-inner-wrapper _md-panel-offscreen">' +
	          '<div class="md-panel _md-panel-offscreen">' + template + '</div>' +
	        '</div>' +
	      '</div>';
	};
	
	
	/**
	 * Wraps a content element in a `md-panel-outer-wrapper`, as well as
	 * a `md-panel-inner-wrapper`, and positions it off-screen. Allows for
	 * proper control over positioning and animations.
	 * @param {!JQLite} contentElement Element to be wrapped.
	 * @return {!JQLite} Wrapper element.
	 * @private
	 */
	MdPanelService.prototype._wrapContentElement = function(contentElement) {
	  var outerWrapper = angular.element(
	    '<div class="md-panel-outer-wrapper">' +
	      '<div class="md-panel-inner-wrapper _md-panel-offscreen"></div>' +
	    '</div>'
	  );
	
	  contentElement.addClass('md-panel _md-panel-offscreen');
	  outerWrapper.children().eq(0).append(contentElement);
	
	  return outerWrapper;
	};
	
	
	/*****************************************************************************
	 *                                 MdPanelRef                                *
	 *****************************************************************************/
	
	
	/**
	 * A reference to a created panel. This reference contains a unique id for the
	 * panel, along with properties/functions used to control the panel.
	 * @param {!Object} config
	 * @param {!IInjectorService} $injector
	 * @final @constructor
	 */
	function MdPanelRef(config, $injector) {
	  // Injected variables.
	  /** @private @const {!IQService} */
	  this._$q = $injector.get('$q');
	
	  /** @private @const {!angular.$mdCompiler} */
	  this._$mdCompiler = $injector.get('$mdCompiler');
	
	  /** @private @const {!angular.$mdConstant} */
	  this._$mdConstant = $injector.get('$mdConstant');
	
	  /** @private @const {!angular.$mdUtil} */
	  this._$mdUtil = $injector.get('$mdUtil');
	
	  /** @private @const {!angular.$mdTheming} */
	  this._$mdTheming = $injector.get('$mdTheming');
	
	  /** @private @const {!IRootScopeService} */
	  this._$rootScope = $injector.get('$rootScope');
	
	  /** @private @const {!angular.$animate} */
	  this._$animate = $injector.get('$animate');
	
	  /** @private @const {!MdPanelRef} */
	  this._$mdPanel = $injector.get('$mdPanel');
	
	  /** @private @const {!ILogService} */
	  this._$log = $injector.get('$log');
	
	  /** @private @const {!IWindowService} */
	  this._$window = $injector.get('$window');
	
	  /** @private @const {!Function} */
	  this._$$rAF = $injector.get('$$rAF');
	
	  // Public variables.
	  /**
	   * Unique id for the panelRef.
	   * @type {string}
	   */
	  this.id = config.id;
	
	  /** @type {!Object} */
	  this.config = config;
	
	  /** @type {!JQLite|undefined} */
	  this.panelContainer = undefined;
	
	  /** @type {!JQLite|undefined} */
	  this.panelEl = undefined;
	
	  /** @type {!JQLite|undefined} */
	  this.innerWrapper = undefined;
	
	  /**
	   * Whether the panel is attached. This is synchronous. When attach is called,
	   * isAttached is set to true. When detach is called, isAttached is set to
	   * false.
	   * @type {boolean}
	   */
	  this.isAttached = false;
	
	  // Private variables.
	  /** @private {Array<function()>} */
	  this._removeListeners = [];
	
	  /** @private {!JQLite|undefined} */
	  this._topFocusTrap = undefined;
	
	  /** @private {!JQLite|undefined} */
	  this._bottomFocusTrap = undefined;
	
	  /** @private {!$mdPanel|undefined} */
	  this._backdropRef = undefined;
	
	  /** @private {Function?} */
	  this._restoreScroll = null;
	
	  /**
	   * Keeps track of all the panel interceptors.
	   * @private {!Object}
	   */
	  this._interceptors = Object.create(null);
	
	  /**
	   * Cleanup function, provided by `$mdCompiler` and assigned after the element
	   * has been compiled. When `contentElement` is used, the function is used to
	   * restore the element to it's proper place in the DOM.
	   * @private {Function|null}
	   */
	  this._compilerCleanup = null;
	
	  /**
	   * Cache for saving and restoring element inline styles, CSS classes etc.
	   * @type {{styles: string, classes: string}}
	   */
	  this._restoreCache = {
	    styles: '',
	    classes: ''
	  };
	}
	
	
	MdPanelRef.interceptorTypes = {
	  CLOSE: 'onClose'
	};
	
	
	/**
	 * Opens an already created and configured panel. If the panel is already
	 * visible, does nothing.
	 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is opened and animations finish.
	 */
	MdPanelRef.prototype.open = function() {
	  var self = this;
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var show = self._simpleBind(self.show, self);
	    var checkGroupMaxOpen = function() {
	      if (self.config.groupName) {
	        self.config.groupName = coerceToArray(self.config.groupName);
	        angular.forEach(self.config.groupName, function(group) {
	          if (self._$mdPanel._openCountExceedsMaxOpen(group)) {
	            self._$mdPanel._closeFirstOpenedPanel(group);
	          }
	        });
	      }
	    };
	
	    self.attach()
	        .then(show)
	        .then(checkGroupMaxOpen)
	        .then(done)
	        .catch(reject);
	  });
	};
	
	
	/**
	 * Closes the panel.
	 * @param {string} closeReason The event type that triggered the close.
	 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is closed and animations finish.
	 */
	MdPanelRef.prototype.close = function(closeReason) {
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    self._callInterceptors(MdPanelRef.interceptorTypes.CLOSE).then(function() {
	      var done = self._done(resolve, self);
	      var detach = self._simpleBind(self.detach, self);
	      var onCloseSuccess = self.config['onCloseSuccess'] || angular.noop;
	      onCloseSuccess = angular.bind(self, onCloseSuccess, self, closeReason);
	
	      self.hide()
	          .then(detach)
	          .then(done)
	          .then(onCloseSuccess)
	          .catch(reject);
	    }, reject);
	  });
	};
	
	
	/**
	 * Attaches the panel. The panel will be hidden afterwards.
	 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is attached.
	 */
	MdPanelRef.prototype.attach = function() {
	  if (this.isAttached && this.panelEl) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onDomAdded = self.config['onDomAdded'] || angular.noop;
	    var addListeners = function(response) {
	      self.isAttached = true;
	      self._addEventListeners();
	      return response;
	    };
	
	    self._$q.all([
	        self._createBackdrop(),
	        self._createPanel()
	            .then(addListeners)
	            .catch(reject)
	    ]).then(onDomAdded)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Only detaches the panel. Will NOT hide the panel first.
	 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is detached.
	 */
	MdPanelRef.prototype.detach = function() {
	  if (!this.isAttached) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  var onDomRemoved = self.config['onDomRemoved'] || angular.noop;
	
	  var detachFn = function() {
	    self._removeEventListeners();
	
	    // Remove the focus traps that we added earlier for keeping focus within
	    // the panel.
	    if (self._topFocusTrap && self._topFocusTrap.parentNode) {
	      self._topFocusTrap.parentNode.removeChild(self._topFocusTrap);
	    }
	
	    if (self._bottomFocusTrap && self._bottomFocusTrap.parentNode) {
	      self._bottomFocusTrap.parentNode.removeChild(self._bottomFocusTrap);
	    }
	
	    if (self._restoreCache.classes) {
	      self.panelEl[0].className = self._restoreCache.classes;
	    }
	
	    // Either restore the saved styles or clear the ones set by mdPanel.
	    self.panelEl[0].style.cssText = self._restoreCache.styles || '';
	
	    self._compilerCleanup();
	    self.panelContainer.remove();
	    self.isAttached = false;
	    return self._$q.when(self);
	  };
	
	  if (this._restoreScroll) {
	    this._restoreScroll();
	    this._restoreScroll = null;
	  }
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	
	    self._$q.all([
	      detachFn(),
	      self._backdropRef ? self._backdropRef.detach() : true
	    ]).then(onDomRemoved)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Destroys the panel. The Panel cannot be opened again after this.
	 */
	MdPanelRef.prototype.destroy = function() {
	  var self = this;
	  if (this.config.groupName) {
	    this.config.groupName = coerceToArray(this.config.groupName);
	    angular.forEach(this.config.groupName, function(group) {
	      self.removeFromGroup(group);
	    });
	  }
	  this.config.scope.$destroy();
	  this.config.locals = null;
	  this.config.onDomAdded = null;
	  this.config.onDomRemoved = null;
	  this.config.onRemoving = null;
	  this.config.onOpenComplete = null;
	  this._interceptors = undefined;
	};
	
	
	/**
	 * Shows the panel.
	 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
	 *     the panel has shown and animations finish.
	 */
	MdPanelRef.prototype.show = function() {
	  if (!this.panelContainer) {
	    return this._$q(function(resolve, reject) {
	      reject('mdPanel: Panel does not exist yet. Call open() or attach().');
	    });
	  }
	
	  if (!this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  var animatePromise = function() {
	    self.panelContainer.removeClass(MD_PANEL_HIDDEN);
	    return self._animateOpen();
	  };
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onOpenComplete = self.config['onOpenComplete'] || angular.noop;
	    var addToGroupOpen = function() {
	      if (self.config.groupName) {
	        self.config.groupName = coerceToArray(self.config.groupName);
	        angular.forEach(self.config.groupName, function(group) {
	          group = self._$mdPanel._groups[group];
	          if (group) {
	            group.openPanels.push(self);
	          }
	        });
	      }
	    };
	
	    self._$q.all([
	      self._backdropRef ? self._backdropRef.show() : self,
	      animatePromise().then(function() { self._focusOnOpen(); }, reject)
	    ]).then(onOpenComplete)
	      .then(addToGroupOpen)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Hides the panel.
	 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
	 *     the panel has hidden and animations finish.
	 */
	MdPanelRef.prototype.hide = function() {
	  if (!this.panelContainer) {
	    return this._$q(function(resolve, reject) {
	      reject('mdPanel: Panel does not exist yet. Call open() or attach().');
	    });
	  }
	
	  if (this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onRemoving = self.config['onRemoving'] || angular.noop;
	    var hidePanel = function() {
	      self.panelContainer.addClass(MD_PANEL_HIDDEN);
	    };
	    var removeFromGroupOpen = function() {
	      if (self.config.groupName) {
	        var index;
	        self.config.groupName = coerceToArray(self.config.groupName);
	        angular.forEach(self.config.groupName, function(group) {
	          group = self._$mdPanel._groups[group];
	          index = group.openPanels.indexOf(self);
	          if (index > -1) {
	            group.openPanels.splice(index, 1);
	          }
	        });
	      }
	    };
	    var focusOnOrigin = function() {
	      var origin = self.config['origin'];
	      if (origin) {
	        getElement(origin).focus();
	      }
	    };
	
	    self._$q.all([
	      self._backdropRef ? self._backdropRef.hide() : self,
	      self._animateClose()
	          .then(onRemoving)
	          .then(hidePanel)
	          .then(removeFromGroupOpen)
	          .then(focusOnOrigin)
	          .catch(reject)
	    ]).then(done, reject);
	  });
	};
	
	/**
	 * Compiles the panel, according to the passed in config and appends it to
	 * the DOM. Helps normalize differences in the compilation process between
	 * using a string template and a content element.
	 * @returns {!Q.IPromise<!MdPanelRef>} Promise that is resolved when
	 *     the element has been compiled and added to the DOM.
	 * @private
	 */
	MdPanelRef.prototype._compile = function() {
	  var self = this;
	
	  // Compile the element via $mdCompiler. Note that when using a
	  // contentElement, the element isn't actually being compiled, rather the
	  // compiler saves it's place in the DOM and provides a way of restoring it.
	  return self._$mdCompiler.compile(self.config).then(function(compileData) {
	    var config = self.config;
	
	    if (config.contentElement) {
	      var panelEl = compileData.element;
	
	      // Since mdPanel modifies the inline styles and CSS classes, we need
	      // to save them in order to be able to restore on close.
	      self._restoreCache.styles = panelEl[0].style.cssText;
	      self._restoreCache.classes = panelEl[0].className;
	
	      self.panelContainer = self._$mdPanel._wrapContentElement(panelEl);
	      self.panelEl = panelEl;
	    } else {
	      self.panelContainer = compileData.link(config['scope']);
	      self.panelEl = angular.element(
	        self.panelContainer[0].querySelector('.md-panel')
	      );
	    }
	
	    // Save a reference to the inner wrapper.
	    self.innerWrapper = angular.element(
	      self.panelContainer[0].querySelector('.md-panel-inner-wrapper')
	    );
	
	    // Save a reference to the cleanup function from the compiler.
	    self._compilerCleanup = compileData.cleanup;
	
	    // Attach the panel to the proper place in the DOM.
	    getElement(self.config['attachTo']).append(self.panelContainer);
	
	    return self;
	  });
	};
	
	
	/**
	 * Creates a panel and adds it to the dom.
	 * @returns {!Q.IPromise} A promise that is resolved when the panel is
	 *     created.
	 * @private
	 */
	MdPanelRef.prototype._createPanel = function() {
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    if (!self.config.locals) {
	      self.config.locals = {};
	    }
	
	    self.config.locals.mdPanelRef = self;
	
	    self._compile().then(function() {
	      if (self.config['disableParentScroll']) {
	        self._restoreScroll = self._$mdUtil.disableScrollAround(
	          null,
	          self.panelContainer,
	          { disableScrollMask: true }
	        );
	      }
	
	      // Add a custom CSS class to the panel element.
	      if (self.config['panelClass']) {
	        self.panelEl.addClass(self.config['panelClass']);
	      }
	
	      // Handle click and touch events for the panel container.
	      if (self.config['propagateContainerEvents']) {
	        self.panelContainer.css('pointer-events', 'none');
	        self.panelEl.css('pointer-events', 'all');
	      }
	
	      // Panel may be outside the $rootElement, tell ngAnimate to animate
	      // regardless.
	      if (self._$animate.pin) {
	        self._$animate.pin(
	          self.panelContainer,
	          getElement(self.config['attachTo'])
	        );
	      }
	
	      self._configureTrapFocus();
	      self._addStyles().then(function() {
	        resolve(self);
	      }, reject);
	    }, reject);
	
	  });
	};
	
	
	/**
	 * Adds the styles for the panel, such as positioning and z-index. Also,
	 * themes the panel element and panel container using `$mdTheming`.
	 * @returns {!Q.IPromise<!MdPanelRef>}
	 * @private
	 */
	MdPanelRef.prototype._addStyles = function() {
	  var self = this;
	  return this._$q(function(resolve) {
	    self.panelContainer.css('z-index', self.config['zIndex']);
	    self.innerWrapper.css('z-index', self.config['zIndex'] + 1);
	
	    var hideAndResolve = function() {
	      // Theme the element and container.
	      self._setTheming();
	
	      // Remove offscreen classes and add hidden class.
	      self.panelEl.removeClass('_md-panel-offscreen');
	      self.innerWrapper.removeClass('_md-panel-offscreen');
	      self.panelContainer.addClass(MD_PANEL_HIDDEN);
	
	      resolve(self);
	    };
	
	    if (self.config['fullscreen']) {
	      self.panelEl.addClass('_md-panel-fullscreen');
	      hideAndResolve();
	      return; // Don't setup positioning.
	    }
	
	    var positionConfig = self.config['position'];
	    if (!positionConfig) {
	      hideAndResolve();
	      return; // Don't setup positioning.
	    }
	
	    // Wait for angular to finish processing the template
	    self._$rootScope['$$postDigest'](function() {
	      // Position it correctly. This is necessary so that the panel will have a
	      // defined height and width.
	      self._updatePosition(true);
	
	      // Theme the element and container.
	      self._setTheming();
	
	      resolve(self);
	    });
	  });
	};
	
	
	/**
	 * Sets the `$mdTheming` classes on the `panelContainer` and `panelEl`.
	 * @private
	 */
	MdPanelRef.prototype._setTheming = function() {
	  this._$mdTheming(this.panelEl);
	  this._$mdTheming(this.panelContainer);
	};
	
	
	/**
	 * Updates the position configuration of a panel
	 * @param {!MdPanelPosition} position
	 */
	MdPanelRef.prototype.updatePosition = function(position) {
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  this.config['position'] = position;
	  this._updatePosition();
	};
	
	
	/**
	 * Calculates and updates the position of the panel.
	 * @param {boolean=} init
	 * @private
	 */
	MdPanelRef.prototype._updatePosition = function(init) {
	  var positionConfig = this.config['position'];
	
	  if (positionConfig) {
	    positionConfig._setPanelPosition(this.innerWrapper);
	
	    // Hide the panel now that position is known.
	    if (init) {
	      this.panelEl.removeClass('_md-panel-offscreen');
	      this.innerWrapper.removeClass('_md-panel-offscreen');
	      this.panelContainer.addClass(MD_PANEL_HIDDEN);
	    }
	
	    this.innerWrapper.css(
	      MdPanelPosition.absPosition.TOP,
	      positionConfig.getTop()
	    );
	    this.innerWrapper.css(
	      MdPanelPosition.absPosition.BOTTOM,
	      positionConfig.getBottom()
	    );
	    this.innerWrapper.css(
	      MdPanelPosition.absPosition.LEFT,
	      positionConfig.getLeft()
	    );
	    this.innerWrapper.css(
	      MdPanelPosition.absPosition.RIGHT,
	      positionConfig.getRight()
	    );
	  }
	};
	
	
	/**
	 * Focuses on the panel or the first focus target.
	 * @private
	 */
	MdPanelRef.prototype._focusOnOpen = function() {
	  if (this.config['focusOnOpen']) {
	    // Wait for the template to finish rendering to guarantee md-autofocus has
	    // finished adding the class md-autofocus, otherwise the focusable element
	    // isn't available to focus.
	    var self = this;
	    this._$rootScope['$$postDigest'](function() {
	      var target = self._$mdUtil.findFocusTarget(self.panelEl) ||
	          self.panelEl;
	      target.focus();
	    });
	  }
	};
	
	
	/**
	 * Shows the backdrop.
	 * @returns {!Q.IPromise} A promise that is resolved when the backdrop
	 *     is created and attached.
	 * @private
	 */
	MdPanelRef.prototype._createBackdrop = function() {
	  if (this.config.hasBackdrop) {
	    if (!this._backdropRef) {
	      var backdropAnimation = this._$mdPanel.newPanelAnimation()
	          .openFrom(this.config.attachTo)
	          .withAnimation({
	            open: '_md-opaque-enter',
	            close: '_md-opaque-leave'
	          });
	
	      if (this.config.animation) {
	        backdropAnimation.duration(this.config.animation._rawDuration);
	      }
	
	      var backdropConfig = {
	        animation: backdropAnimation,
	        attachTo: this.config.attachTo,
	        focusOnOpen: false,
	        panelClass: '_md-panel-backdrop',
	        zIndex: this.config.zIndex - 1
	      };
	
	      this._backdropRef = this._$mdPanel.create(backdropConfig);
	    }
	    if (!this._backdropRef.isAttached) {
	      return this._backdropRef.attach();
	    }
	  }
	};
	
	
	/**
	 * Listen for escape keys and outside clicks to auto close.
	 * @private
	 */
	MdPanelRef.prototype._addEventListeners = function() {
	  this._configureEscapeToClose();
	  this._configureClickOutsideToClose();
	  this._configureScrollListener();
	};
	
	
	/**
	 * Remove event listeners added in _addEventListeners.
	 * @private
	 */
	MdPanelRef.prototype._removeEventListeners = function() {
	  this._removeListeners && this._removeListeners.forEach(function(removeFn) {
	    removeFn();
	  });
	  this._removeListeners = [];
	};
	
	
	/**
	 * Setup the escapeToClose event listeners.
	 * @private
	 */
	MdPanelRef.prototype._configureEscapeToClose = function() {
	  if (this.config['escapeToClose']) {
	    var parentTarget = getElement(this.config['attachTo']);
	    var self = this;
	
	    var keyHandlerFn = function(ev) {
	      if (ev.keyCode === self._$mdConstant.KEY_CODE.ESCAPE) {
	        ev.stopPropagation();
	        ev.preventDefault();
	
	        self.close(MdPanelRef.closeReasons.ESCAPE);
	      }
	    };
	
	    // Add keydown listeners
	    this.panelContainer.on('keydown', keyHandlerFn);
	    parentTarget.on('keydown', keyHandlerFn);
	
	    // Queue remove listeners function
	    this._removeListeners.push(function() {
	      self.panelContainer.off('keydown', keyHandlerFn);
	      parentTarget.off('keydown', keyHandlerFn);
	    });
	  }
	};
	
	
	/**
	 * Setup the clickOutsideToClose event listeners.
	 * @private
	 */
	MdPanelRef.prototype._configureClickOutsideToClose = function() {
	  if (this.config['clickOutsideToClose']) {
	    var target = this.config['propagateContainerEvents'] ?
	        angular.element(document.body) :
	        this.panelContainer;
	    var sourceEl;
	
	    // Keep track of the element on which the mouse originally went down
	    // so that we can only close the backdrop when the 'click' started on it.
	    // A simple 'click' handler does not work, it sets the target object as the
	    // element the mouse went down on.
	    var mousedownHandler = function(ev) {
	      sourceEl = ev.target;
	    };
	
	    // We check if our original element and the target is the backdrop
	    // because if the original was the backdrop and the target was inside the
	    // panel we don't want to panel to close.
	    var self = this;
	    var mouseupHandler = function(ev) {
	      if (self.config['propagateContainerEvents']) {
	
	        // We check if the sourceEl of the event is the panel element or one
	        // of it's children. If it is not, then close the panel.
	        if (sourceEl !== self.panelEl[0] && !self.panelEl[0].contains(sourceEl)) {
	          self.close();
	        }
	
	      } else if (sourceEl === target[0] && ev.target === target[0]) {
	        ev.stopPropagation();
	        ev.preventDefault();
	
	        self.close(MdPanelRef.closeReasons.CLICK_OUTSIDE);
	      }
	    };
	
	    // Add listeners
	    target.on('mousedown', mousedownHandler);
	    target.on('mouseup', mouseupHandler);
	
	    // Queue remove listeners function
	    this._removeListeners.push(function() {
	      target.off('mousedown', mousedownHandler);
	      target.off('mouseup', mouseupHandler);
	    });
	  }
	};
	
	
	/**
	 * Configures the listeners for updating the panel position on scroll.
	 * @private
	*/
	MdPanelRef.prototype._configureScrollListener = function() {
	  // No need to bind the event if scrolling is disabled.
	  if (!this.config['disableParentScroll']) {
	    var updatePosition = angular.bind(this, this._updatePosition);
	    var debouncedUpdatePosition = this._$$rAF.throttle(updatePosition);
	    var self = this;
	
	    var onScroll = function() {
	      debouncedUpdatePosition();
	    };
	
	    // Add listeners.
	    this._$window.addEventListener('scroll', onScroll, true);
	
	    // Queue remove listeners function.
	    this._removeListeners.push(function() {
	      self._$window.removeEventListener('scroll', onScroll, true);
	    });
	  }
	};
	
	
	/**
	 * Setup the focus traps. These traps will wrap focus when tabbing past the
	 * panel. When shift-tabbing, the focus will stick in place.
	 * @private
	 */
	MdPanelRef.prototype._configureTrapFocus = function() {
	  // Focus doesn't remain inside of the panel without this.
	  this.panelEl.attr('tabIndex', '-1');
	  if (this.config['trapFocus']) {
	    var element = this.panelEl;
	    // Set up elements before and after the panel to capture focus and
	    // redirect back into the panel.
	    if (!FOCUS_TRAP_TEMPLATE) {
	      var template = document.createElement('div');
	      template.className = '_md-panel-focus-trap';
	      template.tabIndex = 0;
	      FOCUS_TRAP_TEMPLATE = angular.element(template);
	    }
	    this._topFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];
	    this._bottomFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];
	
	    // When focus is about to move out of the panel, we want to intercept it
	    // and redirect it back to the panel element.
	    var focusHandler = function() {
	      element.focus();
	    };
	    this._topFocusTrap.addEventListener('focus', focusHandler);
	    this._bottomFocusTrap.addEventListener('focus', focusHandler);
	
	    // Queue remove listeners function
	    this._removeListeners.push(this._simpleBind(function() {
	      this._topFocusTrap.removeEventListener('focus', focusHandler);
	      this._bottomFocusTrap.removeEventListener('focus', focusHandler);
	    }, this));
	
	    // The top focus trap inserted immediately before the md-panel element (as
	    // a sibling). The bottom focus trap inserted immediately after the
	    // md-panel element (as a sibling).
	    element[0].parentNode.insertBefore(this._topFocusTrap, element[0]);
	    element.after(this._bottomFocusTrap);
	  }
	};
	
	
	/**
	 * Updates the animation of a panel.
	 * @param {!MdPanelAnimation} animation
	 */
	MdPanelRef.prototype.updateAnimation = function(animation) {
	  this.config['animation'] = animation;
	
	  if (this._backdropRef) {
	    this._backdropRef.config.animation.duration(animation._rawDuration);
	  }
	};
	
	
	/**
	 * Animate the panel opening.
	 * @returns {!Q.IPromise} A promise that is resolved when the panel has
	 *     animated open.
	 * @private
	 */
	MdPanelRef.prototype._animateOpen = function() {
	  this.panelContainer.addClass('md-panel-is-showing');
	  var animationConfig = this.config['animation'];
	  if (!animationConfig) {
	    // Promise is in progress, return it.
	    this.panelContainer.addClass('_md-panel-shown');
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  return this._$q(function(resolve) {
	    var done = self._done(resolve, self);
	    var warnAndOpen = function() {
	      self._$log.warn(
	          'mdPanel: MdPanel Animations failed. ' +
	          'Showing panel without animating.');
	      done();
	    };
	
	    animationConfig.animateOpen(self.panelEl)
	        .then(done, warnAndOpen);
	  });
	};
	
	
	/**
	 * Animate the panel closing.
	 * @returns {!Q.IPromise} A promise that is resolved when the panel has animated closed.
	 * @private
	 */
	MdPanelRef.prototype._animateClose = function() {
	  var self = this;
	  var animationConfig = this.config['animation'];
	
	  if (!animationConfig) {
	    this.panelContainer.removeClass('md-panel-is-showing');
	    this.panelContainer.removeClass('_md-panel-shown');
	    return this._$q.when(this);
	  } else {
	    return this._$q(function (resolve) {
	      var done = function () {
	        self.panelContainer.removeClass('md-panel-is-showing');
	        // Remove the transform so that re-used panels don't accumulate transforms.
	        self.panelEl.css('transform', '');
	        resolve(self);
	      };
	      var warnAndClose = function () {
	        self._$log.warn(
	          'mdPanel: MdPanel Animations failed. Hiding panel without animating.');
	        done();
	      };
	
	      animationConfig.animateClose(self.panelEl).then(done, warnAndClose);
	    });
	  }
	};
	
	
	/**
	 * Registers a interceptor with the panel. The callback should return a promise,
	 * which will allow the action to continue when it gets resolved, or will
	 * prevent an action if it is rejected.
	 * @param {string} type Type of interceptor.
	 * @param {!Q.IPromise<!any>} callback Callback to be registered.
	 * @returns {!MdPanelRef}
	 */
	MdPanelRef.prototype.registerInterceptor = function(type, callback) {
	  var error = null;
	
	  if (!angular.isString(type)) {
	    error = 'Interceptor type must be a string, instead got ' + typeof type;
	  } else if (!angular.isFunction(callback)) {
	    error = 'Interceptor callback must be a function, instead got ' + typeof callback;
	  }
	
	  if (error) {
	    throw new Error('MdPanel: ' + error);
	  }
	
	  var interceptors = this._interceptors[type] = this._interceptors[type] || [];
	
	  if (interceptors.indexOf(callback) === -1) {
	    interceptors.push(callback);
	  }
	
	  return this;
	};
	
	
	/**
	 * Removes a registered interceptor.
	 * @param {string} type Type of interceptor to be removed.
	 * @param {Function} callback Interceptor to be removed.
	 * @returns {!MdPanelRef}
	 */
	MdPanelRef.prototype.removeInterceptor = function(type, callback) {
	  var index = this._interceptors[type] ?
	    this._interceptors[type].indexOf(callback) : -1;
	
	  if (index > -1) {
	    this._interceptors[type].splice(index, 1);
	  }
	
	  return this;
	};
	
	
	/**
	 * Removes all interceptors.
	 * @param {string=} type Type of interceptors to be removed.
	 *     If ommited, all interceptors types will be removed.
	 * @returns {!MdPanelRef}
	 */
	MdPanelRef.prototype.removeAllInterceptors = function(type) {
	  if (type) {
	    this._interceptors[type] = [];
	  } else {
	    this._interceptors = Object.create(null);
	  }
	
	  return this;
	};
	
	
	/**
	 * Invokes all the interceptors of a certain type sequantially in
	 *     reverse order. Works in a similar way to `$q.all`, except it
	 *     respects the order of the functions.
	 * @param {string} type Type of interceptors to be invoked.
	 * @returns {!Q.IPromise<!MdPanelRef>}
	 * @private
	 */
	MdPanelRef.prototype._callInterceptors = function(type) {
	  var self = this;
	  var $q = self._$q;
	  var interceptors = self._interceptors && self._interceptors[type] || [];
	
	  return interceptors.reduceRight(function(promise, interceptor) {
	    var isPromiseLike = interceptor && angular.isFunction(interceptor.then);
	    var response = isPromiseLike ? interceptor : null;
	
	    /**
	    * For interceptors to reject/cancel subsequent portions of the chain, simply
	    * return a `$q.reject(<value>)`
	    */
	    return promise.then(function() {
	      if (!response) {
	        try {
	          response = interceptor(self);
	        } catch (e) {
	          response = $q.reject(e);
	        }
	      }
	
	     return response;
	    });
	  }, $q.resolve(self));
	};
	
	
	/**
	 * Faster, more basic than angular.bind
	 * http://jsperf.com/angular-bind-vs-custom-vs-native
	 * @param {function} callback
	 * @param {!Object} self
	 * @return {function} Callback function with a bound self.
	 */
	MdPanelRef.prototype._simpleBind = function(callback, self) {
	  return function(value) {
	    return callback.apply(self, value);
	  };
	};
	
	
	/**
	 * @param {function|IQResolveReject} callback
	 * @param {!Object} self
	 * @return {function} Callback function with a self param.
	 */
	MdPanelRef.prototype._done = function(callback, self) {
	  return function() {
	    callback(self);
	  };
	};
	
	
	/**
	 * Adds a panel to a group if the panel does not exist within the group already.
	 * A panel can only exist within a single group.
	 * @param {string} groupName The name of the group.
	 */
	MdPanelRef.prototype.addToGroup = function(groupName) {
	  if (!this._$mdPanel._groups[groupName]) {
	    this._$mdPanel.newPanelGroup(groupName);
	  }
	
	  var group = this._$mdPanel._groups[groupName];
	  var index = group.panels.indexOf(this);
	
	  if (index < 0) {
	    group.panels.push(this);
	  }
	};
	
	
	/**
	 * Removes a panel from a group if the panel exists within that group. The group
	 * must be created ahead of time.
	 * @param {string} groupName The name of the group.
	 */
	MdPanelRef.prototype.removeFromGroup = function(groupName) {
	  if (!this._$mdPanel._groups[groupName]) {
	    throw new Error('mdPanel: The group ' + groupName + ' does not exist.');
	  }
	
	  var group = this._$mdPanel._groups[groupName];
	  var index = group.panels.indexOf(this);
	
	  if (index > -1) {
	    group.panels.splice(index, 1);
	  }
	};
	
	
	/**
	 * Possible default closeReasons for the close function.
	 * @enum {string}
	 */
	MdPanelRef.closeReasons = {
	  CLICK_OUTSIDE: 'clickOutsideToClose',
	  ESCAPE: 'escapeToClose',
	};
	
	
	/*****************************************************************************
	 *                               MdPanelPosition                             *
	 *****************************************************************************/
	
	
	/**
	 * Position configuration object. To use, create an MdPanelPosition with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * Example:
	 *
	 * var panelPosition = new MdPanelPosition()
	 *     .relativeTo(myButtonEl)
	 *     .addPanelPosition(
	 *       $mdPanel.xPosition.CENTER,
	 *       $mdPanel.yPosition.ALIGN_TOPS
	 *     );
	 *
	 * $mdPanel.create({
	 *   position: panelPosition
	 * });
	 *
	 * @param {!IInjectorService} $injector
	 * @final @constructor
	 */
	function MdPanelPosition($injector) {
	  /** @private @const {!IWindowService} */
	  this._$window = $injector.get('$window');
	
	  /** @private {boolean} */
	  this._isRTL = $injector.get('$mdUtil').isRtl();
	
	  /** @private @const {!angular.$mdConstant} */
	  this._$mdConstant = $injector.get('$mdConstant');
	
	  /** @private {boolean} */
	  this._absolute = false;
	
	  /** @private {!JQLite} */
	  this._relativeToEl = undefined;
	
	  /** @private {string} */
	  this._top = '';
	
	  /** @private {string} */
	  this._bottom = '';
	
	  /** @private {string} */
	  this._left = '';
	
	  /** @private {string} */
	  this._right = '';
	
	  /** @private {!Array<string>} */
	  this._translateX = [];
	
	  /** @private {!Array<string>} */
	  this._translateY = [];
	
	  /** @private {!Array<{x:string, y:string}>} */
	  this._positions = [];
	
	  /** @private {?{x:string, y:string}} */
	  this._actualPosition = undefined;
	}
	
	
	/**
	 * Possible values of xPosition.
	 * @enum {string}
	 */
	MdPanelPosition.xPosition = {
	  CENTER: 'center',
	  ALIGN_START: 'align-start',
	  ALIGN_END: 'align-end',
	  OFFSET_START: 'offset-start',
	  OFFSET_END: 'offset-end'
	};
	
	
	/**
	 * Possible values of yPosition.
	 * @enum {string}
	 */
	MdPanelPosition.yPosition = {
	  CENTER: 'center',
	  ALIGN_TOPS: 'align-tops',
	  ALIGN_BOTTOMS: 'align-bottoms',
	  ABOVE: 'above',
	  BELOW: 'below'
	};
	
	
	/**
	 * Possible values of absolute position.
	 * @enum {string}
	 */
	MdPanelPosition.absPosition = {
	  TOP: 'top',
	  RIGHT: 'right',
	  BOTTOM: 'bottom',
	  LEFT: 'left'
	};
	
	/**
	 * Margin between the edges of a panel and the viewport.
	 * @const {number}
	 */
	MdPanelPosition.viewportMargin = 8;
	
	
	/**
	 * Sets absolute positioning for the panel.
	 * @return {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.absolute = function() {
	  this._absolute = true;
	  return this;
	};
	
	
	/**
	 * Sets the value of a position for the panel. Clears any previously set
	 * position.
	 * @param {string} position Position to set
	 * @param {string=} value Value of the position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 * @private
	 */
	MdPanelPosition.prototype._setPosition = function(position, value) {
	  if (position === MdPanelPosition.absPosition.RIGHT ||
	      position === MdPanelPosition.absPosition.LEFT) {
	    this._left = this._right = '';
	  } else if (
	      position === MdPanelPosition.absPosition.BOTTOM ||
	      position === MdPanelPosition.absPosition.TOP) {
	    this._top = this._bottom = '';
	  } else {
	    var positions = Object.keys(MdPanelPosition.absPosition).join()
	        .toLowerCase();
	
	    throw new Error('mdPanel: Position must be one of ' + positions + '.');
	  }
	
	  this['_' +  position] = angular.isString(value) ? value : '0';
	
	  return this;
	};
	
	
	/**
	 * Sets the value of `top` for the panel. Clears any previously set vertical
	 * position.
	 * @param {string=} top Value of `top`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.top = function(top) {
	  return this._setPosition(MdPanelPosition.absPosition.TOP, top);
	};
	
	
	/**
	 * Sets the value of `bottom` for the panel. Clears any previously set vertical
	 * position.
	 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.bottom = function(bottom) {
	  return this._setPosition(MdPanelPosition.absPosition.BOTTOM, bottom);
	};
	
	
	/**
	 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
	 * `rtl`. Clears any previously set horizontal position.
	 * @param {string=} start Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.start = function(start) {
	  var position = this._isRTL ? MdPanelPosition.absPosition.RIGHT : MdPanelPosition.absPosition.LEFT;
	  return this._setPosition(position, start);
	};
	
	
	/**
	 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
	 * Clears any previously set horizontal position.
	 * @param {string=} end Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.end = function(end) {
	  var position = this._isRTL ? MdPanelPosition.absPosition.LEFT : MdPanelPosition.absPosition.RIGHT;
	  return this._setPosition(position, end);
	};
	
	
	/**
	 * Sets the value of `left` for the panel. Clears any previously set
	 * horizontal position.
	 * @param {string=} left Value of `left`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.left = function(left) {
	  return this._setPosition(MdPanelPosition.absPosition.LEFT, left);
	};
	
	
	/**
	 * Sets the value of `right` for the panel. Clears any previously set
	 * horizontal position.
	 * @param {string=} right Value of `right`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	*/
	MdPanelPosition.prototype.right = function(right) {
	  return this._setPosition(MdPanelPosition.absPosition.RIGHT, right);
	};
	
	
	/**
	 * Centers the panel horizontally in the viewport. Clears any previously set
	 * horizontal position.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.centerHorizontally = function() {
	  this._left = '50%';
	  this._right = '';
	  this._translateX = ['-50%'];
	  return this;
	};
	
	
	/**
	 * Centers the panel vertically in the viewport. Clears any previously set
	 * vertical position.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.centerVertically = function() {
	  this._top = '50%';
	  this._bottom = '';
	  this._translateY = ['-50%'];
	  return this;
	};
	
	
	/**
	 * Centers the panel horizontally and vertically in the viewport. This is
	 * equivalent to calling both `centerHorizontally` and `centerVertically`.
	 * Clears any previously set horizontal and vertical positions.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.center = function() {
	  return this.centerHorizontally().centerVertically();
	};
	
	
	/**
	 * Sets element for relative positioning.
	 * @param {string|!Element|!JQLite} element Query selector, DOM element,
	 *     or angular element to set the panel relative to.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.relativeTo = function(element) {
	  this._absolute = false;
	  this._relativeToEl = getElement(element);
	  return this;
	};
	
	
	/**
	 * Sets the x and y positions for the panel relative to another element.
	 * @param {string} xPosition must be one of the MdPanelPosition.xPosition
	 *     values.
	 * @param {string} yPosition must be one of the MdPanelPosition.yPosition
	 *     values.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.addPanelPosition = function(xPosition, yPosition) {
	  if (!this._relativeToEl) {
	    throw new Error('mdPanel: addPanelPosition can only be used with ' +
	        'relative positioning. Set relativeTo first.');
	  }
	
	  validatePosition(MdPanelPosition.xPosition, xPosition);
	  validatePosition(MdPanelPosition.yPosition, yPosition);
	
	  this._positions.push({
	    x: xPosition,
	    y: yPosition
	  });
	
	  return this;
	};
	
	
	/**
	 * Sets the value of the offset in the x-direction. This will add to any
	 * previously set offsets.
	 * @param {string|number|function(MdPanelPosition): string} offsetX
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.withOffsetX = function(offsetX) {
	  this._translateX.push(addUnits(offsetX));
	  return this;
	};
	
	
	/**
	 * Sets the value of the offset in the y-direction. This will add to any
	 * previously set offsets.
	 * @param {string|number|function(MdPanelPosition): string} offsetY
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.withOffsetY = function(offsetY) {
	  this._translateY.push(addUnits(offsetY));
	  return this;
	};
	
	
	/**
	 * Gets the value of `top` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getTop = function() {
	  return this._top;
	};
	
	
	/**
	 * Gets the value of `bottom` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getBottom = function() {
	  return this._bottom;
	};
	
	
	/**
	 * Gets the value of `left` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getLeft = function() {
	  return this._left;
	};
	
	
	/**
	 * Gets the value of `right` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getRight = function() {
	  return this._right;
	};
	
	
	/**
	 * Gets the value of `transform` for the panel.
	 * @returns {string} representation of the translateX and translateY rules and values
	 */
	MdPanelPosition.prototype.getTransform = function() {
	  var translateX = this._reduceTranslateValues('translateX', this._translateX);
	  var translateY = this._reduceTranslateValues('translateY', this._translateY);
	
	  // It's important to trim the result, because the browser will ignore the set
	  // operation if the string contains only whitespace.
	  return (translateX + ' ' + translateY).trim();
	};
	
	
	/**
	 * Sets the `transform` value for an element.
	 * @param {!JQLite} el
	 * @returns {!JQLite}
	 * @private
	 */
	MdPanelPosition.prototype._setTransform = function(el) {
	  return el.css(this._$mdConstant.CSS.TRANSFORM, this.getTransform());
	};
	
	
	/**
	 * True if the panel is completely on-screen with this positioning; false
	 * otherwise.
	 * @param {!JQLite} el
	 * @return {boolean}
	 * @private
	 */
	MdPanelPosition.prototype._isOnscreen = function(el) {
	  // this works because we always use fixed positioning for the panel,
	  // which is relative to the viewport.
	  var left = parseInt(this.getLeft());
	  var top = parseInt(this.getTop());
	
	  if (this._translateX.length || this._translateY.length) {
	    var prefixedTransform = this._$mdConstant.CSS.TRANSFORM;
	    var offsets = getComputedTranslations(el, prefixedTransform);
	    left += offsets.x;
	    top += offsets.y;
	  }
	
	  var right = left + el[0].offsetWidth;
	  var bottom = top + el[0].offsetHeight;
	
	  return (left >= 0) &&
	    (top >= 0) &&
	    (bottom <= this._$window.innerHeight) &&
	    (right <= this._$window.innerWidth);
	};
	
	
	/**
	 * Gets the first x/y position that can fit on-screen.
	 * @returns {{x: string, y: string}}
	 */
	MdPanelPosition.prototype.getActualPosition = function() {
	  return this._actualPosition;
	};
	
	
	/**
	 * Reduces a list of translate values to a string that can be used within
	 * transform.
	 * @param {string} translateFn
	 * @param {!Array<string>} values
	 * @returns {string}
	 * @private
	 */
	MdPanelPosition.prototype._reduceTranslateValues =
	    function(translateFn, values) {
	      return values.map(function(translation) {
	        var translationValue = angular.isFunction(translation) ?
	            addUnits(translation(this)) : translation;
	        return translateFn + '(' + translationValue + ')';
	      }, this).join(' ');
	    };
	
	
	/**
	 * Sets the panel position based on the created panel element and best x/y
	 * positioning.
	 * @param {!JQLite} el
	 * @private
	 */
	MdPanelPosition.prototype._setPanelPosition = function(el) {
	  // Remove the class in case it has been added before.
	  el.removeClass('_md-panel-position-adjusted');
	
	  // Only calculate the position if necessary.
	  if (this._absolute) {
	    this._setTransform(el);
	    return;
	  }
	
	  if (this._actualPosition) {
	    this._calculatePanelPosition(el, this._actualPosition);
	    this._setTransform(el);
	    this._constrainToViewport(el);
	    return;
	  }
	
	  for (var i = 0; i < this._positions.length; i++) {
	    this._actualPosition = this._positions[i];
	    this._calculatePanelPosition(el, this._actualPosition);
	    this._setTransform(el);
	
	    if (this._isOnscreen(el)) {
	      return;
	    }
	  }
	
	  this._constrainToViewport(el);
	};
	
	
	/**
	 * Constrains a panel's position to the viewport.
	 * @param {!JQLite} el
	 * @private
	 */
	MdPanelPosition.prototype._constrainToViewport = function(el) {
	  var margin = MdPanelPosition.viewportMargin;
	  var initialTop = this._top;
	  var initialLeft = this._left;
	
	  if (this.getTop()) {
	    var top = parseInt(this.getTop());
	    var bottom = el[0].offsetHeight + top;
	    var viewportHeight = this._$window.innerHeight;
	
	    if (top < margin) {
	      this._top = margin + 'px';
	    } else if (bottom > viewportHeight) {
	      this._top = top - (bottom - viewportHeight + margin) + 'px';
	    }
	  }
	
	  if (this.getLeft()) {
	    var left = parseInt(this.getLeft());
	    var right = el[0].offsetWidth + left;
	    var viewportWidth = this._$window.innerWidth;
	
	    if (left < margin) {
	      this._left = margin + 'px';
	    } else if (right > viewportWidth) {
	      this._left = left - (right - viewportWidth + margin) + 'px';
	    }
	  }
	
	  // Class that can be used to re-style the panel if it was repositioned.
	  el.toggleClass(
	    '_md-panel-position-adjusted',
	    this._top !== initialTop || this._left !== initialLeft
	  );
	};
	
	
	/**
	 * Switches between 'start' and 'end'.
	 * @param {string} position Horizontal position of the panel
	 * @returns {string} Reversed position
	 * @private
	 */
	MdPanelPosition.prototype._reverseXPosition = function(position) {
	  if (position === MdPanelPosition.xPosition.CENTER) {
	    return position;
	  }
	
	  var start = 'start';
	  var end = 'end';
	
	  return position.indexOf(start) > -1 ? position.replace(start, end) : position.replace(end, start);
	};
	
	
	/**
	 * Handles horizontal positioning in rtl or ltr environments.
	 * @param {string} position Horizontal position of the panel
	 * @returns {string} The correct position according the page direction
	 * @private
	 */
	MdPanelPosition.prototype._bidi = function(position) {
	  return this._isRTL ? this._reverseXPosition(position) : position;
	};
	
	
	/**
	 * Calculates the panel position based on the created panel element and the
	 * provided positioning.
	 * @param {!JQLite} el
	 * @param {!{x:string, y:string}} position
	 * @private
	 */
	MdPanelPosition.prototype._calculatePanelPosition = function(el, position) {
	
	  var panelBounds = el[0].getBoundingClientRect();
	  var panelWidth = Math.max(panelBounds.width, el[0].clientWidth);
	  var panelHeight = Math.max(panelBounds.height, el[0].clientHeight);
	
	  var targetBounds = this._relativeToEl[0].getBoundingClientRect();
	
	  var targetLeft = targetBounds.left;
	  var targetRight = targetBounds.right;
	  var targetWidth = targetBounds.width;
	
	  switch (this._bidi(position.x)) {
	    case MdPanelPosition.xPosition.OFFSET_START:
	      this._left = targetLeft - panelWidth + 'px';
	      break;
	    case MdPanelPosition.xPosition.ALIGN_END:
	      this._left = targetRight - panelWidth + 'px';
	      break;
	    case MdPanelPosition.xPosition.CENTER:
	      var left = targetLeft + (0.5 * targetWidth) - (0.5 * panelWidth);
	      this._left = left + 'px';
	      break;
	    case MdPanelPosition.xPosition.ALIGN_START:
	      this._left = targetLeft + 'px';
	      break;
	    case MdPanelPosition.xPosition.OFFSET_END:
	      this._left = targetRight + 'px';
	      break;
	  }
	
	  var targetTop = targetBounds.top;
	  var targetBottom = targetBounds.bottom;
	  var targetHeight = targetBounds.height;
	
	  switch (position.y) {
	    case MdPanelPosition.yPosition.ABOVE:
	      this._top = targetTop - panelHeight + 'px';
	      break;
	    case MdPanelPosition.yPosition.ALIGN_BOTTOMS:
	      this._top = targetBottom - panelHeight + 'px';
	      break;
	    case MdPanelPosition.yPosition.CENTER:
	      var top = targetTop + (0.5 * targetHeight) - (0.5 * panelHeight);
	      this._top = top + 'px';
	      break;
	    case MdPanelPosition.yPosition.ALIGN_TOPS:
	      this._top = targetTop + 'px';
	      break;
	    case MdPanelPosition.yPosition.BELOW:
	      this._top = targetBottom + 'px';
	      break;
	  }
	};
	
	
	/*****************************************************************************
	 *                               MdPanelAnimation                            *
	 *****************************************************************************/
	
	
	/**
	 * Animation configuration object. To use, create an MdPanelAnimation with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * Example:
	 *
	 * var panelAnimation = new MdPanelAnimation()
	 *     .openFrom(myButtonEl)
	 *     .closeTo('.my-button')
	 *     .withAnimation($mdPanel.animation.SCALE);
	 *
	 * $mdPanel.create({
	 *   animation: panelAnimation
	 * });
	 *
	 * @param {!IInjectorService} $injector
	 * @final @constructor
	 */
	function MdPanelAnimation($injector) {
	  /** @private @const {!angular.$mdUtil} */
	  this._$mdUtil = $injector.get('$mdUtil');
	
	  /**
	   * @private {{element: !JQLite|undefined, bounds: !DOMRect}|
	   *     undefined}
	   */
	  this._openFrom;
	
	  /**
	   * @private {{element: !JQLite|undefined, bounds: !DOMRect}|
	   *     undefined}
	   */
	  this._closeTo;
	
	  /** @private {string|{open: string, close: string}} */
	  this._animationClass = '';
	
	  /** @private {number} */
	  this._openDuration;
	
	  /** @private {number} */
	  this._closeDuration;
	
	  /** @private {number|{open: number, close: number}} */
	  this._rawDuration;
	}
	
	
	/**
	 * Possible default animations.
	 * @enum {string}
	 */
	MdPanelAnimation.animation = {
	  SLIDE: 'md-panel-animate-slide',
	  SCALE: 'md-panel-animate-scale',
	  FADE: 'md-panel-animate-fade'
	};
	
	
	/**
	 * Specifies where to start the open animation. `openFrom` accepts a
	 * click event object, query selector, DOM element, or a Rect object that
	 * is used to determine the bounds. When passed a click event, the location
	 * of the click will be used as the position to start the animation.
	 * @param {string|!Element|!Event|{top: number, left: number}} openFrom
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.openFrom = function(openFrom) {
	  // Check if 'openFrom' is an Event.
	  openFrom = openFrom.target ? openFrom.target : openFrom;
	
	  this._openFrom = this._getPanelAnimationTarget(openFrom);
	
	  if (!this._closeTo) {
	    this._closeTo = this._openFrom;
	  }
	  return this;
	};
	
	
	/**
	 * Specifies where to animate the panel close. `closeTo` accepts a
	 * query selector, DOM element, or a Rect object that is used to determine
	 * the bounds.
	 * @param {string|!Element|{top: number, left: number}} closeTo
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.closeTo = function(closeTo) {
	  this._closeTo = this._getPanelAnimationTarget(closeTo);
	  return this;
	};
	
	
	/**
	 * Specifies the duration of the animation in milliseconds.
	 * @param {number|{open: number, close: number}} duration
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.duration = function(duration) {
	  if (duration) {
	    if (angular.isNumber(duration)) {
	      this._openDuration = this._closeDuration = toSeconds(duration);
	    } else if (angular.isObject(duration)) {
	      this._openDuration = toSeconds(duration.open);
	      this._closeDuration = toSeconds(duration.close);
	    }
	  }
	
	  // Save the original value so it can be passed to the backdrop.
	  this._rawDuration = duration;
	
	  return this;
	
	  function toSeconds(value) {
	    if (angular.isNumber(value)) return value / 1000;
	  }
	};
	
	
	/**
	 * Returns the element and bounds for the animation target.
	 * @param {string|!Element|{top: number, left: number}} location
	 * @returns {{element: !JQLite|undefined, bounds: !DOMRect}}
	 * @private
	 */
	MdPanelAnimation.prototype._getPanelAnimationTarget = function(location) {
	  if (angular.isDefined(location.top) || angular.isDefined(location.left)) {
	    return {
	      element: undefined,
	      bounds: {
	        top: location.top || 0,
	        left: location.left || 0
	      }
	    };
	  } else {
	    return this._getBoundingClientRect(getElement(location));
	  }
	};
	
	
	/**
	 * Specifies the animation class.
	 *
	 * There are several default animations that can be used:
	 * (MdPanelAnimation.animation)
	 *   SLIDE: The panel slides in and out from the specified
	 *        elements.
	 *   SCALE: The panel scales in and out.
	 *   FADE: The panel fades in and out.
	 *
	 * @param {string|{open: string, close: string}} cssClass
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.withAnimation = function(cssClass) {
	  this._animationClass = cssClass;
	  return this;
	};
	
	
	/**
	 * Animate the panel open.
	 * @param {!JQLite} panelEl
	 * @returns {!Q.IPromise} A promise that is resolved when the open
	 *     animation is complete.
	 */
	MdPanelAnimation.prototype.animateOpen = function(panelEl) {
	  var animator = this._$mdUtil.dom.animator;
	
	  this._fixBounds(panelEl);
	  var animationOptions = {};
	
	  // Include the panel transformations when calculating the animations.
	  var panelTransform = panelEl[0].style.transform || '';
	
	  var openFrom = animator.toTransformCss(panelTransform);
	  var openTo = animator.toTransformCss(panelTransform);
	
	  switch (this._animationClass) {
	    case MdPanelAnimation.animation.SLIDE:
	      // Slide should start with opacity: 1.
	      panelEl.css('opacity', '1');
	
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter',
	        transitionOutClass: '_md-panel-animate-leave',
	      };
	
	      var openSlide = animator.calculateSlideToOrigin(
	              panelEl, this._openFrom) || '';
	      openFrom = animator.toTransformCss(openSlide + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.SCALE:
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter'
	      };
	
	      var openScale = animator.calculateZoomToOrigin(
	              panelEl, this._openFrom) || '';
	      openFrom = animator.toTransformCss(panelTransform + ' ' + openScale);
	      break;
	
	    case MdPanelAnimation.animation.FADE:
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter'
	      };
	      break;
	
	    default:
	      if (angular.isString(this._animationClass)) {
	        animationOptions = {
	          transitionInClass: this._animationClass
	        };
	      } else {
	        animationOptions = {
	          transitionInClass: this._animationClass['open'],
	          transitionOutClass: this._animationClass['close'],
	        };
	      }
	  }
	
	  animationOptions.duration = this._openDuration;
	
	  return animator
	      .translate3d(panelEl, openFrom, openTo, animationOptions);
	};
	
	
	/**
	 * Animate the panel close.
	 * @param {!JQLite} panelEl
	 * @returns {!Q.IPromise} A promise that resolves when the close animation is complete.
	 */
	MdPanelAnimation.prototype.animateClose = function(panelEl) {
	  var animator = this._$mdUtil.dom.animator;
	  var reverseAnimationOptions = {};
	
	  // Include the panel transformations when calculating the animations.
	  var panelTransform = panelEl[0].style.transform || '';
	
	  var closeFrom = animator.toTransformCss(panelTransform);
	  var closeTo = animator.toTransformCss(panelTransform);
	
	  switch (this._animationClass) {
	    case MdPanelAnimation.animation.SLIDE:
	      // Slide should start with opacity: 1.
	      panelEl.css('opacity', '1');
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-leave',
	        transitionOutClass: '_md-panel-animate-enter _md-panel-animate-leave'
	      };
	
	      var closeSlide = animator.calculateSlideToOrigin(panelEl, this._closeTo) || '';
	      closeTo = animator.toTransformCss(closeSlide + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.SCALE:
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-scale-out _md-panel-animate-leave',
	        transitionOutClass: '_md-panel-animate-scale-out _md-panel-animate-enter _md-panel-animate-leave'
	      };
	
	      var closeScale = animator.calculateZoomToOrigin(panelEl, this._closeTo) || '';
	      closeTo = animator.toTransformCss(panelTransform + ' ' + closeScale);
	      break;
	
	    case MdPanelAnimation.animation.FADE:
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-fade-out _md-panel-animate-leave',
	        transitionOutClass: '_md-panel-animate-fade-out _md-panel-animate-enter _md-panel-animate-leave'
	      };
	      break;
	
	    default:
	      if (angular.isString(this._animationClass)) {
	        reverseAnimationOptions = {
	          transitionOutClass: this._animationClass
	        };
	      } else {
	        reverseAnimationOptions = {
	          transitionInClass: this._animationClass['close'],
	          transitionOutClass: this._animationClass['open']
	        };
	      }
	  }
	
	  reverseAnimationOptions.duration = this._closeDuration;
	
	  return animator
	      .translate3d(panelEl, closeFrom, closeTo, reverseAnimationOptions);
	};
	
	
	/**
	 * Set the height and width to match the panel if not provided.
	 * @param {!JQLite} panelEl
	 * @private
	 */
	MdPanelAnimation.prototype._fixBounds = function(panelEl) {
	  var panelWidth = panelEl[0].offsetWidth;
	  var panelHeight = panelEl[0].offsetHeight;
	
	  if (this._openFrom && this._openFrom.bounds.height == null) {
	    this._openFrom.bounds.height = panelHeight;
	  }
	  if (this._openFrom && this._openFrom.bounds.width == null) {
	    this._openFrom.bounds.width = panelWidth;
	  }
	  if (this._closeTo && this._closeTo.bounds.height == null) {
	    this._closeTo.bounds.height = panelHeight;
	  }
	  if (this._closeTo && this._closeTo.bounds.width == null) {
	    this._closeTo.bounds.width = panelWidth;
	  }
	};
	
	
	/**
	 * Identify the bounding RECT for the target element.
	 * @param {!JQLite} element
	 * @returns {{element: !JQLite|undefined, bounds: !DOMRect}}
	 * @private
	 */
	MdPanelAnimation.prototype._getBoundingClientRect = function(element) {
	  if (element instanceof angular.element) {
	    return {
	      element: element,
	      bounds: element[0].getBoundingClientRect()
	    };
	  }
	};
	
	
	/*****************************************************************************
	 *                                Util Methods                               *
	 *****************************************************************************/
	
	
	/**
	 * Returns the angular element associated with a css selector or element.
	 * @param el {string|!JQLite|!Element}
	 * @returns {!JQLite}
	 */
	function getElement(el) {
	  var queryResult = angular.isString(el) ?
	      document.querySelector(el) : el;
	  return angular.element(queryResult);
	}
	
	/**
	 * Gets the computed values for an element's translateX and translateY in px.
	 * @param {!JQLite|!Element} el the element to evaluate
	 * @param {string} property
	 * @return {{x: number, y: number}} an element's translateX and translateY in px
	 */
	function getComputedTranslations(el, property) {
	  // The transform being returned by `getComputedStyle` is in the format:
	  // `matrix(a, b, c, d, translateX, translateY)` if defined and `none`
	  // if the element doesn't have a transform.
	  var transform = getComputedStyle(el[0] || el)[property];
	  var openIndex = transform.indexOf('(');
	  var closeIndex = transform.lastIndexOf(')');
	  var output = { x: 0, y: 0 };
	
	  if (openIndex > -1 && closeIndex > -1) {
	    var parsedValues = transform
	      .substring(openIndex + 1, closeIndex)
	      .split(', ')
	      .slice(-2);
	
	    output.x = parseInt(parsedValues[0]);
	    output.y = parseInt(parsedValues[1]);
	  }
	
	  return output;
	}
	
	/*
	 * Ensures that a value is a valid position name. Throw an exception if not.
	 * @param {Object} positionMap Object against which the value will be checked.
	 * @param {string} value
	 */
	function validatePosition(positionMap, value) {
	  // empty is ok
	  if (value === null || angular.isUndefined(value)) {
	    return;
	  }
	
	  var positionKeys = Object.keys(positionMap);
	  var positionValues = [];
	
	  for (var key, i = 0; key = positionKeys[i]; i++) {
	    var position = positionMap[key];
	    positionValues.push(position);
	
	    if (position === value) {
	      return;
	    }
	  }
	
	  throw new Error('Panel position only accepts the following values:\n' +
	    positionValues.join(' | '));
	}
	
	/**
	 * Adds units to a number value.
	 * @param {string|number} value
	 * @return {string}
	 */
	function addUnits(value) {
	  return angular.isNumber(value) ? value + 'px' : value;
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.progressCircular
	 * @description Module for a circular progressbar
	 */
	
	angular.module('material.components.progressCircular', ['material.core']);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdProgressCircular
	 * @module material.components.progressCircular
	 * @restrict E
	 *
	 * @description
	 * The circular progress directive is used to make loading content in your app as delightful and
	 * painless as possible by minimizing the amount of visual change a user sees before they can view
	 * and interact with content.
	 *
	 * For operations where the percentage of the operation completed can be determined, use a
	 * determinate indicator. They give users a quick sense of how long an operation will take.
	 *
	 * For operations where the user is asked to wait a moment while something finishes up, and it’s
	 * not necessary to expose what's happening behind the scenes and how long it will take, use an
	 * indeterminate indicator.
	 *
	 * @param {string} md-mode Select from one of two modes: **'determinate'** and **'indeterminate'**.
	 *
	 * Note: if the `md-mode` value is set as undefined or specified as not 1 of the two (2) valid modes, then **'indeterminate'**
	 * will be auto-applied as the mode.
	 *
	 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute.
	 * If `value=""` is also specified, however, then `md-mode="determinate"` would be auto-injected instead.
	 * @param {number=} value In determinate mode, this number represents the percentage of the
	 *     circular progress. Default: 0
	 * @param {number=} md-diameter This specifies the diameter of the circular progress. The value
	 * should be a pixel-size value (eg '100'). If this attribute is
	 * not present then a default value of '50px' is assumed.
	 *
	 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-progress-circular md-mode="determinate" value="..."></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="determinate" ng-value="..."></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="determinate" value="..." md-diameter="100"></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="indeterminate"></md-progress-circular>
	 * </hljs>
	 */
	
	MdProgressCircularDirective.$inject = ["$window", "$mdProgressCircular", "$mdTheming", "$mdUtil", "$interval", "$log"];
	angular
	  .module('material.components.progressCircular')
	  .directive('mdProgressCircular', MdProgressCircularDirective);
	
	/* @ngInject */
	function MdProgressCircularDirective($window, $mdProgressCircular, $mdTheming,
	                                     $mdUtil, $interval, $log) {
	
	  // Note that this shouldn't use use $$rAF, because it can cause an infinite loop
	  // in any tests that call $animate.flush.
	  var rAF = $window.requestAnimationFrame ||
	            $window.webkitRequestAnimationFrame ||
	            angular.noop;
	
	  var cAF = $window.cancelAnimationFrame ||
	            $window.webkitCancelAnimationFrame ||
	            $window.webkitCancelRequestAnimationFrame ||
	            angular.noop;
	
	  var MODE_DETERMINATE = 'determinate';
	  var MODE_INDETERMINATE = 'indeterminate';
	  var DISABLED_CLASS = '_md-progress-circular-disabled';
	  var INDETERMINATE_CLASS = 'md-mode-indeterminate';
	
	  return {
	    restrict: 'E',
	    scope: {
	      value: '@',
	      mdDiameter: '@',
	      mdMode: '@'
	    },
	    template:
	      '<svg xmlns="http://www.w3.org/2000/svg">' +
	        '<path fill="none"/>' +
	      '</svg>',
	    compile: function(element, attrs) {
	      element.attr({
	        'aria-valuemin': 0,
	        'aria-valuemax': 100,
	        'role': 'progressbar'
	      });
	
	      if (angular.isUndefined(attrs.mdMode)) {
	        var mode = attrs.hasOwnProperty('value') ? MODE_DETERMINATE : MODE_INDETERMINATE;
	        attrs.$set('mdMode', mode);
	      } else {
	        attrs.$set('mdMode', attrs.mdMode.trim());
	      }
	
	      return MdProgressCircularLink;
	    }
	  };
	
	  function MdProgressCircularLink(scope, element, attrs) {
	    var node = element[0];
	    var svg = angular.element(node.querySelector('svg'));
	    var path = angular.element(node.querySelector('path'));
	    var startIndeterminate = $mdProgressCircular.startIndeterminate;
	    var endIndeterminate = $mdProgressCircular.endIndeterminate;
	    var iterationCount = 0;
	    var lastAnimationId = 0;
	    var lastDrawFrame;
	    var interval;
	
	    $mdTheming(element);
	    element.toggleClass(DISABLED_CLASS, attrs.hasOwnProperty('disabled'));
	
	    // If the mode is indeterminate, it doesn't need to
	    // wait for the next digest. It can start right away.
	    if (scope.mdMode === MODE_INDETERMINATE){
	      startIndeterminateAnimation();
	    }
	
	    scope.$on('$destroy', function(){
	      cleanupIndeterminateAnimation();
	
	      if (lastDrawFrame) {
	        cAF(lastDrawFrame);
	      }
	    });
	
	    scope.$watchGroup(['value', 'mdMode', function() {
	      var isDisabled = node.disabled;
	
	      // Sometimes the browser doesn't return a boolean, in
	      // which case we should check whether the attribute is
	      // present.
	      if (isDisabled === true || isDisabled === false){
	        return isDisabled;
	      }
	
	      return angular.isDefined(element.attr('disabled'));
	    }], function(newValues, oldValues) {
	      var mode = newValues[1];
	      var isDisabled = newValues[2];
	      var wasDisabled = oldValues[2];
	      var diameter = 0;
	      var strokeWidth = 0;
	
	      if (isDisabled !== wasDisabled) {
	        element.toggleClass(DISABLED_CLASS, !!isDisabled);
	      }
	
	      if (isDisabled) {
	        cleanupIndeterminateAnimation();
	      } else {
	        if (mode !== MODE_DETERMINATE && mode !== MODE_INDETERMINATE) {
	          mode = MODE_INDETERMINATE;
	          attrs.$set('mdMode', mode);
	        }
	
	        if (mode === MODE_INDETERMINATE) {
	          if (oldValues[1] === MODE_DETERMINATE) {
	            diameter = getSize(scope.mdDiameter);
	            strokeWidth = getStroke(diameter);
	            path.attr('d', getSvgArc(diameter, strokeWidth, true));
	            path.attr('stroke-dasharray', getDashLength(diameter, strokeWidth, 75));
	          }
	          startIndeterminateAnimation();
	        } else {
	          var newValue = clamp(newValues[0]);
	          var oldValue = clamp(oldValues[0]);
	
	          cleanupIndeterminateAnimation();
	
	          if (oldValues[1] === MODE_INDETERMINATE) {
	            diameter = getSize(scope.mdDiameter);
	            strokeWidth = getStroke(diameter);
	            path.attr('d', getSvgArc(diameter, strokeWidth, false));
	            path.attr('stroke-dasharray', getDashLength(diameter, strokeWidth, 100));
	          }
	
	          element.attr('aria-valuenow', newValue);
	          renderCircle(oldValue, newValue);
	        }
	      }
	
	    });
	
	    // This is in a separate watch in order to avoid layout, unless
	    // the value has actually changed.
	    scope.$watch('mdDiameter', function(newValue) {
	      var diameter = getSize(newValue);
	      var strokeWidth = getStroke(diameter);
	      var value = clamp(scope.value);
	      var transformOrigin = (diameter / 2) + 'px';
	      var dimensions = {
	        width: diameter + 'px',
	        height: diameter + 'px'
	      };
	
	      // The viewBox has to be applied via setAttribute, because it is
	      // case-sensitive. If jQuery is included in the page, `.attr` lowercases
	      // all attribute names.
	      svg[0].setAttribute('viewBox', '0 0 ' + diameter + ' ' + diameter);
	
	      // Usually viewBox sets the dimensions for the SVG, however that doesn't
	      // seem to be the case on IE10.
	      // Important! The transform origin has to be set from here and it has to
	      // be in the format of "Ypx Ypx Ypx", otherwise the rotation wobbles in
	      // IE and Edge, because they don't account for the stroke width when
	      // rotating. Also "center" doesn't help in this case, it has to be a
	      // precise value.
	      svg
	        .css(dimensions)
	        .css('transform-origin', transformOrigin + ' ' + transformOrigin + ' ' + transformOrigin);
	
	      element.css(dimensions);
	
	      path.attr('stroke-width', strokeWidth);
	      path.attr('stroke-linecap', 'square');
	      if (scope.mdMode == MODE_INDETERMINATE) {
	        path.attr('d', getSvgArc(diameter, strokeWidth, true));
	        path.attr('stroke-dasharray', getDashLength(diameter, strokeWidth, 75));
	        path.attr('stroke-dashoffset', getDashOffset(diameter, strokeWidth, 1, 75));
	      } else {
	        path.attr('d', getSvgArc(diameter, strokeWidth, false));
	        path.attr('stroke-dasharray', getDashLength(diameter, strokeWidth, 100));
	        path.attr('stroke-dashoffset', getDashOffset(diameter, strokeWidth, 0, 100));
	        renderCircle(value, value);
	      }
	
	    });
	
	    function renderCircle(animateFrom, animateTo, easing, duration, iterationCount, maxValue) {
	      var id = ++lastAnimationId;
	      var startTime = $mdUtil.now();
	      var changeInValue = animateTo - animateFrom;
	      var diameter = getSize(scope.mdDiameter);
	      var strokeWidth = getStroke(diameter);
	      var ease = easing || $mdProgressCircular.easeFn;
	      var animationDuration = duration || $mdProgressCircular.duration;
	      var rotation = -90 * (iterationCount || 0);
	      var dashLimit = maxValue || 100;
	
	      // No need to animate it if the values are the same
	      if (animateTo === animateFrom) {
	        renderFrame(animateTo);
	      } else {
	        lastDrawFrame = rAF(function animation() {
	          var currentTime = $window.Math.max(0, $window.Math.min($mdUtil.now() - startTime, animationDuration));
	
	          renderFrame(ease(currentTime, animateFrom, changeInValue, animationDuration));
	
	          // Do not allow overlapping animations
	          if (id === lastAnimationId && currentTime < animationDuration) {
	            lastDrawFrame = rAF(animation);
	          }
	        });
	      }
	
	      function renderFrame(value) {
	        path.attr('stroke-dashoffset', getDashOffset(diameter, strokeWidth, value, dashLimit));
	        path.attr('transform','rotate(' + (rotation) + ' ' + diameter/2 + ' ' + diameter/2 + ')');
	      }
	    }
	
	    function animateIndeterminate() {
	      renderCircle(
	        startIndeterminate,
	        endIndeterminate,
	        $mdProgressCircular.easeFnIndeterminate,
	        $mdProgressCircular.durationIndeterminate,
	        iterationCount,
	        75
	      );
	
	      // The %4 technically isn't necessary, but it keeps the rotation
	      // under 360, instead of becoming a crazy large number.
	      iterationCount = ++iterationCount % 4;
	
	    }
	
	    function startIndeterminateAnimation() {
	      if (!interval) {
	        // Note that this interval isn't supposed to trigger a digest.
	        interval = $interval(
	          animateIndeterminate,
	          $mdProgressCircular.durationIndeterminate,
	          0,
	          false
	        );
	
	        animateIndeterminate();
	
	        element
	          .addClass(INDETERMINATE_CLASS)
	          .removeAttr('aria-valuenow');
	      }
	    }
	
	    function cleanupIndeterminateAnimation() {
	      if (interval) {
	        $interval.cancel(interval);
	        interval = null;
	        element.removeClass(INDETERMINATE_CLASS);
	      }
	    }
	  }
	
	  /**
	   * Returns SVG path data for progress circle
	   * Syntax spec: https://www.w3.org/TR/SVG/paths.html#PathDataEllipticalArcCommands
	   *
	   * @param {number} diameter Diameter of the container.
	   * @param {number} strokeWidth Stroke width to be used when drawing circle
	   * @param {boolean} indeterminate Use if progress circle will be used for indeterminate
	   *
	   * @returns {string} String representation of an SVG arc.
	   */
	  function getSvgArc(diameter, strokeWidth, indeterminate) {
	    var radius = diameter / 2;
	    var offset = strokeWidth / 2;
	    var start = radius + ',' + offset; // ie: (25, 2.5) or 12 o'clock
	    var end = offset + ',' + radius;   // ie: (2.5, 25) or  9 o'clock
	    var arcRadius = radius - offset;
	    return 'M' + start
	         + 'A' + arcRadius + ',' + arcRadius + ' 0 1 1 ' + end // 75% circle
	         + (indeterminate ? '' : 'A' + arcRadius + ',' + arcRadius + ' 0 0 1 ' + start); // loop to start
	  }
	
	  /**
	   * Return stroke length for progress circle
	   *
	   * @param {number} diameter Diameter of the container.
	   * @param {number} strokeWidth Stroke width to be used when drawing circle
	   * @param {number} value Percentage of circle (between 0 and 100)
	   * @param {number} maxArcLength Maximum length of arc as a percentage of circle (between 0 and 100)
	   *
	   * @returns {number} Stroke length for progress circle
	   */
	  function getDashOffset(diameter, strokeWidth, value, maxArcLength) {
	    return getSpinnerCircumference(diameter, strokeWidth) * ((maxArcLength - value) / 100);
	  }
	
	  /**
	   * Limits a value between 0 and 100.
	   */
	  function clamp(value) {
	    return $window.Math.max(0, $window.Math.min(value || 0, 100));
	  }
	
	  /**
	   * Determines the size of a progress circle, based on the provided
	   * value in the following formats: `X`, `Ypx`, `Z%`.
	   */
	  function getSize(value) {
	    var defaultValue = $mdProgressCircular.progressSize;
	
	    if (value) {
	      var parsed = parseFloat(value);
	
	      if (value.lastIndexOf('%') === value.length - 1) {
	        parsed = (parsed / 100) * defaultValue;
	      }
	
	      return parsed;
	    }
	
	    return defaultValue;
	  }
	
	  /**
	   * Determines the circle's stroke width, based on
	   * the provided diameter.
	   */
	  function getStroke(diameter) {
	    return $mdProgressCircular.strokeWidth / 100 * diameter;
	  }
	
	  /**
	   * Return length of the dash
	   *
	   * @param {number} diameter Diameter of the container.
	   * @param {number} strokeWidth Stroke width to be used when drawing circle
	   * @param {number} value Percentage of circle (between 0 and 100)
	   *
	   * @returns {number} Length of the dash
	   */
	  function getDashLength(diameter, strokeWidth, value) {
	    return getSpinnerCircumference(diameter, strokeWidth) * (value / 100);
	  }
	
	  /**
	   * Return circumference of the spinner
	   *
	   * @param {number} diameter Diameter of the container.
	   * @param {number} strokeWidth Stroke width to be used when drawing circle
	   *
	   * @returns {number} Circumference of the spinner
	   */
	  function getSpinnerCircumference(diameter, strokeWidth) {
	    return ((diameter - strokeWidth) * $window.Math.PI);
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc service
	 * @name $mdProgressCircular
	 * @module material.components.progressCircular
	 *
	 * @description
	 * Allows the user to specify the default options for the `progressCircular` directive.
	 *
	 * @property {number} progressSize Diameter of the progress circle in pixels.
	 * @property {number} strokeWidth Width of the circle's stroke as a percentage of the circle's size.
	 * @property {number} duration Length of the circle animation in milliseconds.
	 * @property {function} easeFn Default easing animation function.
	 * @property {object} easingPresets Collection of pre-defined easing functions.
	 *
	 * @property {number} durationIndeterminate Duration of the indeterminate animation.
	 * @property {number} startIndeterminate Indeterminate animation start point.
	 * @property {number} endIndeterminate Indeterminate animation end point.
	 * @property {function} easeFnIndeterminate Easing function to be used when animating
	 * between the indeterminate values.
	 *
	 * @property {(function(object): object)} configure Used to modify the default options.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdProgressCircularProvider) {
	 *
	 *     // Example of changing the default progress options.
	 *     $mdProgressCircularProvider.configure({
	 *       progressSize: 100,
	 *       strokeWidth: 20,
	 *       duration: 800
	 *     });
	 * });
	 * </hljs>
	 *
	 */
	
	angular
	  .module('material.components.progressCircular')
	  .provider("$mdProgressCircular", MdProgressCircularProvider);
	
	function MdProgressCircularProvider() {
	  var progressConfig = {
	    progressSize: 50,
	    strokeWidth: 10,
	    duration: 100,
	    easeFn: linearEase,
	
	    durationIndeterminate: 1333,
	    startIndeterminate: 1,
	    endIndeterminate: 149,
	    easeFnIndeterminate: materialEase,
	
	    easingPresets: {
	      linearEase: linearEase,
	      materialEase: materialEase
	    }
	  };
	
	  return {
	    configure: function(options) {
	      progressConfig = angular.extend(progressConfig, options || {});
	      return progressConfig;
	    },
	    $get: function() { return progressConfig; }
	  };
	
	  function linearEase(t, b, c, d) {
	    return c * t / d + b;
	  }
	
	  function materialEase(t, b, c, d) {
	    // via http://www.timotheegroleau.com/Flash/experiments/easing_function_generator.htm
	    // with settings of [0, 0, 1, 1]
	    var ts = (t /= d) * t;
	    var tc = ts * t;
	    return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.progressLinear
	 * @description Linear Progress module!
	 */
	MdProgressLinearDirective.$inject = ["$mdTheming", "$mdUtil", "$log"];
	angular.module('material.components.progressLinear', [
	  'material.core'
	])
	  .directive('mdProgressLinear', MdProgressLinearDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdProgressLinear
	 * @module material.components.progressLinear
	 * @restrict E
	 *
	 * @description
	 * The linear progress directive is used to make loading content
	 * in your app as delightful and painless as possible by minimizing
	 * the amount of visual change a user sees before they can view
	 * and interact with content.
	 *
	 * Each operation should only be represented by one activity indicator
	 * For example: one refresh operation should not display both a
	 * refresh bar and an activity circle.
	 *
	 * For operations where the percentage of the operation completed
	 * can be determined, use a determinate indicator. They give users
	 * a quick sense of how long an operation will take.
	 *
	 * For operations where the user is asked to wait a moment while
	 * something finishes up, and it’s not necessary to expose what's
	 * happening behind the scenes and how long it will take, use an
	 * indeterminate indicator.
	 *
	 * @param {string} md-mode Select from one of four modes: determinate, indeterminate, buffer or query.
	 *
	 * Note: if the `md-mode` value is set as undefined or specified as 1 of the four (4) valid modes, then `indeterminate`
	 * will be auto-applied as the mode.
	 *
	 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute. If `value=""` is also specified, however,
	 * then `md-mode="determinate"` would be auto-injected instead.
	 * @param {number=} value In determinate and buffer modes, this number represents the percentage of the primary progress bar. Default: 0
	 * @param {number=} md-buffer-value In the buffer mode, this number represents the percentage of the secondary progress bar. Default: 0
	 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-progress-linear md-mode="determinate" value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="determinate" ng-value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="indeterminate"></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="buffer" value="..." md-buffer-value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="query"></md-progress-linear>
	 * </hljs>
	 */
	function MdProgressLinearDirective($mdTheming, $mdUtil, $log) {
	  var MODE_DETERMINATE = "determinate";
	  var MODE_INDETERMINATE = "indeterminate";
	  var MODE_BUFFER = "buffer";
	  var MODE_QUERY = "query";
	  var DISABLED_CLASS = "_md-progress-linear-disabled";
	
	  return {
	    restrict: 'E',
	    template: '<div class="md-container">' +
	      '<div class="md-dashed"></div>' +
	      '<div class="md-bar md-bar1"></div>' +
	      '<div class="md-bar md-bar2"></div>' +
	      '</div>',
	    compile: compile
	  };
	
	  function compile(tElement, tAttrs, transclude) {
	    tElement.attr('aria-valuemin', 0);
	    tElement.attr('aria-valuemax', 100);
	    tElement.attr('role', 'progressbar');
	
	    return postLink;
	  }
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	
	    var lastMode;
	    var isDisabled = attr.hasOwnProperty('disabled');
	    var toVendorCSS = $mdUtil.dom.animator.toCss;
	    var bar1 = angular.element(element[0].querySelector('.md-bar1'));
	    var bar2 = angular.element(element[0].querySelector('.md-bar2'));
	    var container = angular.element(element[0].querySelector('.md-container'));
	
	    element
	      .attr('md-mode', mode())
	      .toggleClass(DISABLED_CLASS, isDisabled);
	
	    validateMode();
	    watchAttributes();
	
	    /**
	     * Watch the value, md-buffer-value, and md-mode attributes
	     */
	    function watchAttributes() {
	      attr.$observe('value', function(value) {
	        var percentValue = clamp(value);
	        element.attr('aria-valuenow', percentValue);
	
	        if (mode() != MODE_QUERY) animateIndicator(bar2, percentValue);
	      });
	
	      attr.$observe('mdBufferValue', function(value) {
	        animateIndicator(bar1, clamp(value));
	      });
	
	      attr.$observe('disabled', function(value) {
	        if (value === true || value === false) {
	          isDisabled = !!value;
	        } else {
	          isDisabled = angular.isDefined(value);
	        }
	
	        element.toggleClass(DISABLED_CLASS, isDisabled);
	        container.toggleClass(lastMode, !isDisabled);
	      });
	
	      attr.$observe('mdMode', function(mode) {
	        if (lastMode) container.removeClass(lastMode);
	
	        switch (mode) {
	          case MODE_QUERY:
	          case MODE_BUFFER:
	          case MODE_DETERMINATE:
	          case MODE_INDETERMINATE:
	            container.addClass(lastMode = "md-mode-" + mode);
	            break;
	          default:
	            container.addClass(lastMode = "md-mode-" + MODE_INDETERMINATE);
	            break;
	        }
	      });
	    }
	
	    /**
	     * Auto-defaults the mode to either `determinate` or `indeterminate` mode; if not specified
	     */
	    function validateMode() {
	      if (angular.isUndefined(attr.mdMode)) {
	        var hasValue = angular.isDefined(attr.value);
	        var mode = hasValue ? MODE_DETERMINATE : MODE_INDETERMINATE;
	        var info = "Auto-adding the missing md-mode='{0}' to the ProgressLinear element";
	        element.attr("md-mode", mode);
	        attr.mdMode = mode;
	      }
	    }
	
	    /**
	     * Is the md-mode a valid option?
	     */
	    function mode() {
	      var value = (attr.mdMode || "").trim();
	      if (value) {
	        switch (value) {
	          case MODE_DETERMINATE:
	          case MODE_INDETERMINATE:
	          case MODE_BUFFER:
	          case MODE_QUERY:
	            break;
	          default:
	            value = MODE_INDETERMINATE;
	            break;
	        }
	      }
	      return value;
	    }
	
	    /**
	     * Manually set CSS to animate the Determinate indicator based on the specified
	     * percentage value (0-100).
	     */
	    function animateIndicator(target, value) {
	      if (isDisabled || !mode()) return;
	
	      var to = $mdUtil.supplant("translateX({0}%) scale({1},1)", [(value-100)/2, value/100]);
	      var styles = toVendorCSS({ transform : to });
	      angular.element(target).css(styles);
	    }
	  }
	
	  /**
	   * Clamps the value to be between 0 and 100.
	   * @param {number} value The value to clamp.
	   * @returns {number}
	   */
	  function clamp(value) {
	    return Math.max(0, Math.min(value || 0, 100));
	  }
	}
	
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.radioButton
	 * @description radioButton module!
	 */
	mdRadioGroupDirective.$inject = ["$mdUtil", "$mdConstant", "$mdTheming", "$timeout"];
	mdRadioButtonDirective.$inject = ["$mdAria", "$mdUtil", "$mdTheming"];
	angular.module('material.components.radioButton', [
	  'material.core'
	])
	  .directive('mdRadioGroup', mdRadioGroupDirective)
	  .directive('mdRadioButton', mdRadioButtonDirective);
	
	/**
	 * @type {Readonly<{NEXT: number, CURRENT: number, PREVIOUS: number}>}
	 */
	var incrementSelection = Object.freeze({PREVIOUS: -1, CURRENT: 0, NEXT: 1});
	
	/**
	 * @ngdoc directive
	 * @module material.components.radioButton
	 * @name mdRadioGroup
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-radio-group>` directive identifies a grouping
	 * container for the 1..n grouped radio buttons; specified using nested
	 * `<md-radio-button>` elements.
	 *
	 * The radio button uses the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * Note: `<md-radio-group>` and `<md-radio-button>` handle `tabindex` differently
	 * than the native `<input type="radio">` controls. Whereas the native controls
	 * force the user to tab through all the radio buttons, `<md-radio-group>`
	 * is focusable and by default the `<md-radio-button>`s are not.
	 *
	 * @param {string} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} ng-change AngularJS expression to be executed when input changes due to user
	 *    interaction.
	 * @param {boolean=} md-no-ink If present, disables ink ripple effects.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-radio-group ng-model="selected">
	 *   <md-radio-button ng-repeat="item in items"
	 *                    ng-value="item.value" aria-label="{{item.label}}">
	 *     {{ item.label }}
	 *   </md-radio-button>
	 * </md-radio-group>
	 * </hljs>
	 */
	function mdRadioGroupDirective($mdUtil, $mdConstant, $mdTheming, $timeout) {
	  RadioGroupController.prototype = createRadioGroupControllerProto();
	
	  return {
	    restrict: 'E',
	    controller: ['$element', RadioGroupController],
	    require: ['mdRadioGroup', '?ngModel'],
	    link: { pre: linkRadioGroup }
	  };
	
	  function linkRadioGroup(scope, element, attr, controllers) {
	    // private md component indicator for styling
	    element.addClass('_md');
	    $mdTheming(element);
	
	    var radioGroupController = controllers[0];
	    var ngModelCtrl = controllers[1] || $mdUtil.fakeNgModel();
	
	    radioGroupController.init(ngModelCtrl);
	
	    scope.mouseActive = false;
	
	    element
	      .attr({
	        'role': 'radiogroup',
	        'tabIndex': element.attr('tabindex') || '0'
	      })
	      .on('keydown', keydownListener)
	      .on('mousedown', function() {
	        scope.mouseActive = true;
	        $timeout(function() {
	          scope.mouseActive = false;
	        }, 100);
	      })
	      .on('focus', function() {
	        if (scope.mouseActive === false) {
	          radioGroupController.$element.addClass('md-focused');
	        }
	      })
	      .on('blur', function() {
	        radioGroupController.$element.removeClass('md-focused');
	      });
	
	    // Initially set the first radio button as the aria-activedescendant. This will be overridden
	    // if a 'checked' radio button gets rendered. We need to wait for the nextTick here so that the
	    // radio buttons have their id values assigned.
	    $mdUtil.nextTick(function () {
	      var radioButtons = getRadioButtons(radioGroupController.$element);
	      if (radioButtons.count() &&
	          !radioGroupController.$element[0].hasAttribute('aria-activedescendant')) {
	        radioGroupController.setActiveDescendant(radioButtons.first().id);
	      }
	    });
	
	    /**
	     * Apply the md-focused class if it isn't already applied.
	     */
	    function setFocus() {
	      if (!element.hasClass('md-focused')) { element.addClass('md-focused'); }
	    }
	
	    /**
	     * @param {KeyboardEvent} keyboardEvent
	     */
	    function keydownListener(keyboardEvent) {
	      var keyCode = keyboardEvent.which || keyboardEvent.keyCode;
	
	      // Only listen to events that we originated ourselves
	      // so that we don't trigger on things like arrow keys in inputs.
	      if (keyCode !== $mdConstant.KEY_CODE.ENTER &&
	          keyboardEvent.currentTarget !== keyboardEvent.target) {
	        return;
	      }
	
	      switch (keyCode) {
	        case $mdConstant.KEY_CODE.LEFT_ARROW:
	        case $mdConstant.KEY_CODE.UP_ARROW:
	          keyboardEvent.preventDefault();
	          radioGroupController.selectPrevious();
	          setFocus();
	          break;
	
	        case $mdConstant.KEY_CODE.RIGHT_ARROW:
	        case $mdConstant.KEY_CODE.DOWN_ARROW:
	          keyboardEvent.preventDefault();
	          radioGroupController.selectNext();
	          setFocus();
	          break;
	
	        case $mdConstant.KEY_CODE.SPACE:
	          keyboardEvent.preventDefault();
	          radioGroupController.selectCurrent();
	          break;
	
	        case $mdConstant.KEY_CODE.ENTER:
	          var form = angular.element($mdUtil.getClosest(element[0], 'form'));
	          if (form.length > 0) {
	            form.triggerHandler('submit');
	          }
	          break;
	      }
	    }
	  }
	
	  /**
	   * @param {JQLite} $element
	   * @constructor
	   */
	  function RadioGroupController($element) {
	    this._radioButtonRenderFns = [];
	    this.$element = $element;
	  }
	
	  function createRadioGroupControllerProto() {
	    return {
	      init: function(ngModelCtrl) {
	        this._ngModelCtrl = ngModelCtrl;
	        this._ngModelCtrl.$render = angular.bind(this, this.render);
	      },
	      add: function(rbRender) {
	        this._radioButtonRenderFns.push(rbRender);
	      },
	      remove: function(rbRender) {
	        var index = this._radioButtonRenderFns.indexOf(rbRender);
	        if (index !== -1) {
	          this._radioButtonRenderFns.splice(index, 1);
	        }
	      },
	      render: function() {
	        this._radioButtonRenderFns.forEach(function(rbRender) {
	          rbRender();
	        });
	      },
	      setViewValue: function(value, eventType) {
	        this._ngModelCtrl.$setViewValue(value, eventType);
	        // update the other radio buttons as well
	        this.render();
	      },
	      getViewValue: function() {
	        return this._ngModelCtrl.$viewValue;
	      },
	      selectCurrent: function() {
	        return changeSelectedButton(this.$element, incrementSelection.CURRENT);
	      },
	      selectNext: function() {
	        return changeSelectedButton(this.$element, incrementSelection.NEXT);
	      },
	      selectPrevious: function() {
	        return changeSelectedButton(this.$element, incrementSelection.PREVIOUS);
	      },
	      setActiveDescendant: function (radioId) {
	        this.$element.attr('aria-activedescendant', radioId);
	      },
	      isDisabled: function() {
	        return this.$element[0].hasAttribute('disabled');
	      }
	    };
	  }
	
	  /**
	   * Coerce all child radio buttons into an array, then wrap them in an iterator.
	   * @param parent {!JQLite}
	   * @return {{add: add, next: (function()), last: (function(): any|null), previous: (function()), count: (function(): number), hasNext: (function(*=): Array.length|*|number|boolean), inRange: (function(*): boolean), remove: remove, contains: (function(*=): *|boolean), itemAt: (function(*=): any|null), findBy: (function(*, *): *[]), hasPrevious: (function(*=): Array.length|*|number|boolean), items: (function(): *[]), indexOf: (function(*=): number), first: (function(): any|null)}}
	   */
	  function getRadioButtons(parent) {
	    return $mdUtil.iterator(parent[0].querySelectorAll('md-radio-button'), true);
	  }
	
	  /**
	   * Change the radio group's selected button by a given increment.
	   * If no button is selected, select the first button.
	   * @param {JQLite} parent the md-radio-group
	   * @param {incrementSelection} increment enum that determines whether the next or
	   *  previous button is clicked. For current, only the first button is selected, otherwise the
	   *  current selection is maintained (by doing nothing).
	   */
	  function changeSelectedButton(parent, increment) {
	    var buttons = getRadioButtons(parent);
	    var target;
	
	    if (buttons.count()) {
	      var validate = function (button) {
	        // If disabled, then NOT valid
	        return !angular.element(button).attr("disabled");
	      };
	
	      var selected = parent[0].querySelector('md-radio-button.md-checked');
	      if (!selected) {
	        target = buttons.first();
	      } else if (increment === incrementSelection.PREVIOUS ||
	                 increment === incrementSelection.NEXT) {
	        target = buttons[
	          increment === incrementSelection.PREVIOUS ? 'previous' : 'next'
	        ](selected, validate);
	      }
	
	      if (target) {
	        // Activate radioButton's click listener (triggerHandler won't create a real click event)
	        angular.element(target).triggerHandler('click');
	      }
	    }
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @module material.components.radioButton
	 * @name mdRadioButton
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-radio-button>`directive is the child directive required to be used within `<md-radio-group>` elements.
	 *
	 * While similar to the `<input type="radio" ng-model="" value="">` directive,
	 * the `<md-radio-button>` directive provides ink effects, ARIA support, and
	 * supports use within named radio groups.
	 *
	 * One of `value` or `ng-value` must be set so that the `md-radio-group`'s model is set properly when the
	 * `md-radio-button` is selected.
	 *
	 * @param {string} value The value to which the model should be set when selected.
	 * @param {string} ng-value AngularJS expression which sets the value to which the model should
	 *    be set when selected.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} aria-label Adds label to radio button for accessibility.
	 *    Defaults to radio button's text. If no text content is available, a warning will be logged.
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-radio-button value="1" aria-label="Label 1">
	 *   Label 1
	 * </md-radio-button>
	 *
	 * <md-radio-button ng-value="specialValue" aria-label="Green">
	 *   Green
	 * </md-radio-button>
	 *
	 * </hljs>
	 *
	 */
	function mdRadioButtonDirective($mdAria, $mdUtil, $mdTheming) {
	
	  var CHECKED_CSS = 'md-checked';
	
	  return {
	    restrict: 'E',
	    require: '^mdRadioGroup',
	    transclude: true,
	    template: '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
	                '<div class="md-off"></div>' +
	                '<div class="md-on"></div>' +
	              '</div>' +
	              '<div ng-transclude class="md-label"></div>',
	    link: link
	  };
	
	  function link(scope, element, attr, radioGroupController) {
	    var lastChecked;
	
	    $mdTheming(element);
	    configureAria(element);
	    element.addClass('md-auto-horizontal-margin');
	
	    // ngAria overwrites the aria-checked inside a $watch for ngValue.
	    // We should defer the initialization until all the watches have fired.
	    // This can also be fixed by removing the `lastChecked` check, but that'll
	    // cause more DOM manipulation on each digest.
	    if (attr.ngValue) {
	      $mdUtil.nextTick(initialize, false);
	    } else {
	      initialize();
	    }
	
	    /**
	     * Initializes the component.
	     */
	    function initialize() {
	      if (!radioGroupController) {
	        throw 'RadioButton: No RadioGroupController could be found.';
	      }
	
	      radioGroupController.add(render);
	      attr.$observe('value', render);
	
	      element
	        .on('click', listener)
	        .on('$destroy', function() {
	          radioGroupController.remove(render);
	        });
	    }
	
	    /**
	     * On click functionality.
	     */
	    function listener(ev) {
	      if (element[0].hasAttribute('disabled') || radioGroupController.isDisabled()) return;
	
	      scope.$apply(function() {
	        radioGroupController.setViewValue(attr.value, ev && ev.type);
	      });
	    }
	
	    /**
	     * Add or remove the `.md-checked` class from the RadioButton (and conditionally its parent).
	     * Update the `aria-activedescendant` attribute.
	     */
	    function render() {
	      var checked = radioGroupController.getViewValue() == attr.value;
	
	      if (checked === lastChecked) return;
	
	      if (element[0] && element[0].parentNode &&
	          element[0].parentNode.nodeName.toLowerCase() !== 'md-radio-group') {
	        // If the radioButton is inside a div, then add class so highlighting will work.
	        element.parent().toggleClass(CHECKED_CSS, checked);
	      }
	
	      if (checked) {
	        radioGroupController.setActiveDescendant(element.attr('id'));
	      }
	
	      lastChecked = checked;
	
	      element
	        .attr('aria-checked', checked)
	        .toggleClass(CHECKED_CSS, checked);
	    }
	
	    /**
	     * Inject ARIA-specific attributes appropriate for each radio button
	     */
	    function configureAria(element) {
	      element.attr({
	        id: attr.id || 'radio_' + $mdUtil.nextUid(),
	        role: 'radio',
	        'aria-checked': 'false'
	      });
	
	      $mdAria.expectWithText(element, 'aria-label');
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.select
	 */
	
	/***************************************************
	
	 ### TODO ###
	 - [ ] Abstract placement logic in $mdSelect service to $mdMenu service
	
	 ***************************************************/
	
	SelectDirective.$inject = ["$mdSelect", "$mdUtil", "$mdConstant", "$mdTheming", "$mdAria", "$parse", "$sce"];
	SelectMenuDirective.$inject = ["$parse", "$mdUtil", "$mdConstant", "$mdTheming"];
	OptionDirective.$inject = ["$mdButtonInkRipple", "$mdUtil", "$mdTheming"];
	SelectProvider.$inject = ["$$interimElementProvider"];
	OptionController.$inject = ["$element"];
	var SELECT_EDGE_MARGIN = 8;
	var selectNextId = 0;
	var CHECKBOX_SELECTION_INDICATOR;
	
	angular.module('material.components.select', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdSelect', SelectDirective)
	  .directive('mdSelectMenu', SelectMenuDirective)
	  .directive('mdOption', OptionDirective)
	  .directive('mdOptgroup', OptgroupDirective)
	  .directive('mdSelectHeader', SelectHeaderDirective)
	  .provider('$mdSelect', SelectProvider);
	
	/**
	 * @ngdoc directive
	 * @name mdSelect
	 * @restrict E
	 * @module material.components.select
	 *
	 * @description Displays a select box, bound to an `ng-model`. Selectable options are defined using
	 * the <a ng-href="api/directive/mdOption">md-option</a> element directive. Options can be grouped
	 * using the <a ng-href="api/directive/mdOptgroup">md-optgroup</a> element directive.
	 *
	 * When the select is required and uses a floating label, then the label will automatically contain
	 * an asterisk (`*`). This behavior can be disabled by using the `md-no-asterisk` attribute.
	 *
	 * By default, the select will display with an underline to match other form elements. This can be
	 * disabled by applying the `md-no-underline` CSS class.
	 *
	 * @param {expression} ng-model Assignable angular expression to data-bind to.
	 * @param {expression=} ng-change Expression to be executed when the model value changes.
	 * @param {boolean=} multiple When present, allows for more than one option to be selected.
	 *  The model is an array with the selected choices. **Note:** This attribute is only evaluated
	 *  once; it is not watched.
	 * @param {expression=} md-on-close Expression to be evaluated when the select is closed.
	 * @param {expression=} md-on-open Expression to be evaluated when opening the select.
	 *  Will hide the select options and show a spinner until the evaluated promise resolves.
	 * @param {expression=} md-selected-text Expression to be evaluated that will return a string
	 *  to be displayed as a placeholder in the select input box when it is closed. The value
	 *  will be treated as *text* (not html).
	 * @param {expression=} md-selected-html Expression to be evaluated that will return a string
	 *  to be displayed as a placeholder in the select input box when it is closed. The value
	 *  will be treated as *html*. The value must either be explicitly marked as trustedHtml or
	 *  the ngSanitize module must be loaded.
	 * @param {string=} placeholder Placeholder hint text.
	 * @param {boolean=} md-no-asterisk When set to true, an asterisk will not be appended to the
	 *  floating label. **Note:** This attribute is only evaluated once; it is not watched.
	 * @param {string=} aria-label Optional label for accessibility. Only necessary if no explicit label
	 *  is present.
	 * @param {string=} md-container-class Class list to get applied to the `.md-select-menu-container`
	 *  element (for custom styling).
	 * @param {string=} md-select-only-option If specified, a `<md-select>` will automatically select
	 * it's first option, if it only has one.
	 *
	 * @usage
	 * With a placeholder (label and aria-label are added dynamically)
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <md-select
	 *       ng-model="someModel"
	 *       placeholder="Select a state">
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * With an explicit label
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <label>State</label>
	 *     <md-select
	 *       ng-model="someModel">
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * Using the `md-select-header` element directive
	 *
	 * When a developer needs to put more than just a text label in the `md-select-menu`, they should
	 * use one or more `md-select-header`s. These elements can contain custom HTML which can be styled
	 * as desired. Use cases for this element include a sticky search bar and custom option group
	 * labels.
	 *
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <md-select ng-model="someModel">
	 *       <md-select-header>
	 *         <span> Neighborhoods - </span>
	 *       </md-select-header>
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * ## Selects and object equality
	 * When using a `md-select` to pick from a list of objects, it is important to realize how javascript handles
	 * equality. Consider the following example:
	 * <hljs lang="js">
	 * angular.controller('MyCtrl', function($scope) {
	 *   $scope.users = [
	 *     { id: 1, name: 'Bob' },
	 *     { id: 2, name: 'Alice' },
	 *     { id: 3, name: 'Steve' }
	 *   ];
	 *   $scope.selectedUser = { id: 1, name: 'Bob' };
	 * });
	 * </hljs>
	 * <hljs lang="html">
	 * <div ng-controller="MyCtrl">
	 *   <md-select ng-model="selectedUser">
	 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
	 *   </md-select>
	 * </div>
	 * </hljs>
	 *
	 * At first one might expect that the select should be populated with "Bob" as the selected user.
	 * However, this is not true. To determine whether something is selected,
	 * `ngModelController` is looking at whether `$scope.selectedUser == (any user in $scope.users);`;
	 *
	 * Javascript's `==` operator does not check for deep equality (ie. that all properties
	 * on the object are the same), but instead whether the objects are *the same object in memory*.
	 * In this case, we have two instances of identical objects, but they exist in memory as unique
	 * entities. Because of this, the select will have no value populated for a selected user.
	 *
	 * To get around this, `ngModelController` provides a `track by` option that allows us to specify a
	 * different expression which will be used for the equality operator. As such, we can update our
	 * `html` to make use of this by specifying the `ng-model-options="{trackBy: '$value.id'}"` on the
	 * `md-select` element. This converts our equality expression to be
	 * `$scope.selectedUser.id == (any id in $scope.users.map(function(u) { return u.id; }));`
	 * which results in Bob being selected as desired.
	 *
	 * **Note:** We do not support AngularJS's `track by` syntax. For instance
	 *  `ng-options="user in users track by user.id"` will not work with `md-select`.
	 *
	 * Working HTML:
	 * <hljs lang="html">
	 * <div ng-controller="MyCtrl">
	 *   <md-select ng-model="selectedUser" ng-model-options="{trackBy: '$value.id'}">
	 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
	 *   </md-select>
	 * </div>
	 * </hljs>
	 */
	function SelectDirective($mdSelect, $mdUtil, $mdConstant, $mdTheming, $mdAria, $parse, $sce) {
	  return {
	    restrict: 'E',
	    require: ['^?mdInputContainer', 'mdSelect', 'ngModel', '?^form'],
	    compile: compile,
	    controller: function() {
	    } // empty placeholder controller to be initialized in link
	  };
	
	  /**
	   * @param {JQLite} tElement
	   * @param {IAttributes} tAttrs
	   * @return {postLink}
	   */
	  function compile(tElement, tAttrs) {
	    var isMultiple = $mdUtil.parseAttributeBoolean(tAttrs.multiple);
	    tElement.addClass('md-auto-horizontal-margin');
	
	    // add the select value that will hold our placeholder or selected option value
	    var valueEl = angular.element('<md-select-value><span></span></md-select-value>');
	    valueEl.append('<span class="md-select-icon" aria-hidden="true"></span>');
	    valueEl.addClass('md-select-value');
	    if (!valueEl[0].hasAttribute('id')) {
	      valueEl.attr('id', 'select_value_label_' + $mdUtil.nextUid());
	    }
	
	    // There's got to be an md-content inside. If there's not one, let's add it.
	    var mdContentEl = tElement.find('md-content');
	    if (!mdContentEl.length) {
	      tElement.append(angular.element('<md-content>').append(tElement.contents()));
	      mdContentEl = tElement.find('md-content');
	    }
	    mdContentEl.attr('role', 'listbox');
	    mdContentEl.attr('tabindex', '-1');
	
	    if (isMultiple) {
	      mdContentEl.attr('aria-multiselectable', 'true');
	    } else {
	      mdContentEl.attr('aria-multiselectable', 'false');
	    }
	
	    // Add progress spinner for md-options-loading
	    if (tAttrs.mdOnOpen) {
	
	      // Show progress indicator while loading async
	      // Use ng-hide for `display:none` so the indicator does not interfere with the options list
	      tElement
	        .find('md-content')
	        .prepend(angular.element(
	          '<div>' +
	          ' <md-progress-circular md-mode="indeterminate" ng-if="$$loadingAsyncDone === false"' +
	          ' md-diameter="25px"></md-progress-circular>' +
	          '</div>'
	        ));
	
	      // Hide list [of item options] while loading async
	      tElement
	        .find('md-option')
	        .attr('ng-show', '$$loadingAsyncDone');
	    }
	
	    if (tAttrs.name) {
	      var autofillClone = angular.element('<select class="md-visually-hidden"></select>');
	      autofillClone.attr({
	        'name': tAttrs.name,
	        'aria-hidden': 'true',
	        'tabindex': '-1'
	      });
	      var opts = tElement.find('md-option');
	      angular.forEach(opts, function(el) {
	        var newEl = angular.element('<option>' + el.innerHTML + '</option>');
	        if (el.hasAttribute('ng-value')) {
	          newEl.attr('ng-value', el.getAttribute('ng-value'));
	        }
	        else if (el.hasAttribute('value')) {
	          newEl.attr('value', el.getAttribute('value'));
	        }
	        autofillClone.append(newEl);
	      });
	
	      // Adds an extra option that will hold the selected value for the
	      // cases where the select is a part of a non-AngularJS form. This can be done with a ng-model,
	      // however if the `md-option` is being `ng-repeat`-ed, AngularJS seems to insert a similar
	      // `option` node, but with a value of `? string: <value> ?` which would then get submitted.
	      // This also goes around having to prepend a dot to the name attribute.
	      autofillClone.append(
	        '<option ng-value="' + tAttrs.ngModel + '" selected></option>'
	      );
	
	      tElement.parent().append(autofillClone);
	    }
	
	    // Use everything that's left inside element.contents() as the contents of the menu
	    var multipleContent = isMultiple ? 'multiple' : '';
	    var ngModelOptions = tAttrs.ngModelOptions ? $mdUtil.supplant('ng-model-options="{0}"', [tAttrs.ngModelOptions]) : '';
	    var selectTemplate = '' +
	      '<div class="md-select-menu-container" aria-hidden="true" role="presentation">' +
	      '  <md-select-menu role="presentation" {0} {1}>{2}</md-select-menu>' +
	      '</div>';
	
	    selectTemplate = $mdUtil.supplant(selectTemplate, [multipleContent, ngModelOptions,  tElement.html()]);
	    tElement.empty().append(valueEl);
	    tElement.append(selectTemplate);
	
	    if (!tAttrs.tabindex) {
	      tAttrs.$set('tabindex', 0);
	    }
	
	    return function postLink(scope, element, attrs, ctrls) {
	      var untouched = true;
	      var isDisabled;
	
	      var containerCtrl = ctrls[0];
	      var mdSelectCtrl = ctrls[1];
	      var ngModelCtrl = ctrls[2];
	      var formCtrl = ctrls[3];
	      // grab a reference to the select menu value label
	      var selectValueElement = element.find('md-select-value');
	      var isReadonly = angular.isDefined(attrs.readonly);
	      var disableAsterisk = $mdUtil.parseAttributeBoolean(attrs.mdNoAsterisk);
	      var stopMdMultipleWatch;
	      var userDefinedLabelledby = angular.isDefined(attrs.ariaLabelledby);
	      var listboxContentElement = element.find('md-content');
	      var initialPlaceholder = element.attr('placeholder');
	
	      if (disableAsterisk) {
	        element.addClass('md-no-asterisk');
	      }
	
	      if (containerCtrl) {
	        var isErrorGetter = containerCtrl.isErrorGetter || function() {
	          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
	        };
	
	        if (containerCtrl.input) {
	          // We ignore inputs that are in the md-select-header.
	          // One case where this might be useful would be adding as searchbox.
	          if (element.find('md-select-header').find('input')[0] !== containerCtrl.input[0]) {
	            throw new Error("<md-input-container> can only have *one* child <input>, <textarea>, or <select> element!");
	          }
	        }
	
	        containerCtrl.input = element;
	        if (!containerCtrl.label) {
	          $mdAria.expect(element, 'aria-label', initialPlaceholder);
	          var selectLabel = element.attr('aria-label');
	          if (!selectLabel) {
	            selectLabel = initialPlaceholder;
	          }
	          listboxContentElement.attr('aria-label', selectLabel);
	        } else {
	          containerCtrl.label.attr('aria-hidden', 'true');
	          listboxContentElement.attr('aria-label', containerCtrl.label.text());
	          containerCtrl.setHasPlaceholder(!!initialPlaceholder);
	        }
	
	        var stopInvalidWatch = scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	      }
	
	      var selectContainer, selectScope, selectMenuCtrl;
	
	      selectContainer = findSelectContainer();
	      $mdTheming(element);
	
	      var originalRender = ngModelCtrl.$render;
	      ngModelCtrl.$render = function() {
	        originalRender();
	        syncSelectValueText();
	        inputCheckValue();
	      };
	
	      var stopPlaceholderObserver = attrs.$observe('placeholder', ngModelCtrl.$render);
	
	      var stopRequiredObserver = attrs.$observe('required', function (value) {
	        if (containerCtrl && containerCtrl.label) {
	          // Toggle the md-required class on the input containers label, because the input container
	          // is automatically applying the asterisk indicator on the label.
	          containerCtrl.label.toggleClass('md-required', value && !disableAsterisk);
	        }
	        element.removeAttr('aria-required');
	        if (value) {
	          listboxContentElement.attr('aria-required', 'true');
	        } else {
	          listboxContentElement.removeAttr('aria-required');
	        }
	      });
	
	      /**
	       * Set the contents of the md-select-value element. This element's contents are announced by
	       * screen readers and used for displaying the value of the select in both single and multiple
	       * selection modes.
	       * @param {string=} text A sanitized and trusted HTML string or a pure text string from user
	       *  input.
	       */
	      mdSelectCtrl.setSelectValueText = function(text) {
	        var useDefaultText = text === undefined || text === '';
	        // Whether the select label has been given via user content rather than the internal
	        // template of <md-option>
	        var isSelectLabelFromUser = false;
	
	        mdSelectCtrl.setIsPlaceholder(!text);
	
	        if (attrs.mdSelectedText && attrs.mdSelectedHtml) {
	          throw Error('md-select cannot have both `md-selected-text` and `md-selected-html`');
	        }
	
	        if (attrs.mdSelectedText || attrs.mdSelectedHtml) {
	          text = $parse(attrs.mdSelectedText || attrs.mdSelectedHtml)(scope);
	          isSelectLabelFromUser = true;
	        } else if (useDefaultText) {
	          // Use placeholder attribute, otherwise fallback to the md-input-container label
	          var tmpPlaceholder = attrs.placeholder ||
	              (containerCtrl && containerCtrl.label ? containerCtrl.label.text() : '');
	
	          text = tmpPlaceholder || '';
	          isSelectLabelFromUser = true;
	        }
	
	        var target = selectValueElement.children().eq(0);
	
	        if (attrs.mdSelectedHtml) {
	          // Using getTrustedHtml will run the content through $sanitize if it is not already
	          // explicitly trusted. If the ngSanitize module is not loaded, this will
	          // *correctly* throw an sce error.
	          target.html($sce.getTrustedHtml(text));
	        } else if (isSelectLabelFromUser) {
	          target.text(text);
	        } else {
	          // If we've reached this point, the text is not user-provided.
	          target.html(text);
	        }
	
	        if (useDefaultText) {
	          // Avoid screen readers double announcing the label name when no value has been selected
	          selectValueElement.attr('aria-hidden', 'true');
	          if (!userDefinedLabelledby) {
	            element.removeAttr('aria-labelledby');
	          }
	        } else {
	          selectValueElement.removeAttr('aria-hidden');
	          if (!userDefinedLabelledby) {
	            element.attr('aria-labelledby', element[0].id + ' ' + selectValueElement[0].id);
	          }
	        }
	      };
	
	      /**
	       * @param {boolean} isPlaceholder true to mark the md-select-value element and
	       *  input container, if one exists, with classes for styling when a placeholder is present.
	       *  false to remove those classes.
	       */
	      mdSelectCtrl.setIsPlaceholder = function(isPlaceholder) {
	          if (isPlaceholder) {
	            selectValueElement.addClass('md-select-placeholder');
	            // Don't hide the floating label if the md-select has a placeholder.
	            if (containerCtrl && containerCtrl.label && !element.attr('placeholder')) {
	              containerCtrl.label.addClass('md-placeholder');
	            }
	          } else {
	            selectValueElement.removeClass('md-select-placeholder');
	            if (containerCtrl && containerCtrl.label && !element.attr('placeholder')) {
	              containerCtrl.label.removeClass('md-placeholder');
	            }
	          }
	      };
	
	      if (!isReadonly) {
	        var handleBlur = function(event) {
	          // Attach before ngModel's blur listener to stop propagation of blur event
	          // and prevent setting $touched.
	          if (untouched) {
	            untouched = false;
	            if (selectScope._mdSelectIsOpen) {
	              event.stopImmediatePropagation();
	            }
	          }
	
	          containerCtrl && containerCtrl.setFocused(false);
	          inputCheckValue();
	        };
	        var handleFocus = function() {
	          // Always focus the container (if we have one) so floating labels and other styles are
	          // applied properly
	          containerCtrl && containerCtrl.setFocused(true);
	        };
	
	        element.on('focus', handleFocus);
	        element.on('blur', handleBlur);
	      }
	
	      mdSelectCtrl.triggerClose = function() {
	        $parse(attrs.mdOnClose)(scope);
	      };
	
	      scope.$$postDigest(function() {
	        initAriaLabel();
	        syncSelectValueText();
	      });
	
	      function initAriaLabel() {
	        var labelText = element.attr('aria-label') || element.attr('placeholder');
	        if (!labelText && containerCtrl && containerCtrl.label) {
	          labelText = containerCtrl.label.text();
	        }
	        $mdAria.expect(element, 'aria-label', labelText);
	      }
	
	      var stopSelectedLabelsWatcher = scope.$watch(function() {
	        return selectMenuCtrl.getSelectedLabels();
	      }, syncSelectValueText);
	
	      function syncSelectValueText() {
	        selectMenuCtrl = selectMenuCtrl ||
	          selectContainer.find('md-select-menu').controller('mdSelectMenu');
	        mdSelectCtrl.setSelectValueText(selectMenuCtrl.getSelectedLabels());
	      }
	
	      // TODO add tests for mdMultiple
	      // TODO add docs for mdMultiple
	      var stopMdMultipleObserver = attrs.$observe('mdMultiple', function(val) {
	        if (stopMdMultipleWatch) {
	          stopMdMultipleWatch();
	        }
	        var parser = $parse(val);
	        stopMdMultipleWatch = scope.$watch(function() {
	          return parser(scope);
	        }, function(multiple, prevVal) {
	          var selectMenu = selectContainer.find('md-select-menu');
	          // assume compiler did a good job
	          if (multiple === undefined && prevVal === undefined) {
	            return;
	          }
	          if (multiple) {
	            var setMultipleAttrs = {'multiple': 'multiple'};
	            element.attr(setMultipleAttrs);
	            selectMenu.attr(setMultipleAttrs);
	          } else {
	            element.removeAttr('multiple');
	            selectMenu.removeAttr('multiple');
	          }
	          element.find('md-content').attr('aria-multiselectable', multiple ? 'true' : 'false');
	
	          if (selectContainer) {
	            selectMenuCtrl.setMultiple(Boolean(multiple));
	            originalRender = ngModelCtrl.$render;
	            ngModelCtrl.$render = function() {
	              originalRender();
	              syncSelectValueText();
	              inputCheckValue();
	            };
	            ngModelCtrl.$render();
	          }
	        });
	      });
	
	      var stopDisabledObserver = attrs.$observe('disabled', function(disabled) {
	        if (angular.isString(disabled)) {
	          disabled = true;
	        }
	        // Prevent click event being registered twice
	        if (isDisabled !== undefined && isDisabled === disabled) {
	          return;
	        }
	        isDisabled = disabled;
	        if (disabled) {
	          element
	            .attr({'aria-disabled': 'true'})
	            .removeAttr('tabindex')
	            .removeAttr('aria-expanded')
	            .removeAttr('aria-haspopup')
	            .off('click', openSelect)
	            .off('keydown', handleKeypress);
	        } else {
	          element
	            .attr({
	              'tabindex': attrs.tabindex,
	              'aria-haspopup': 'listbox'
	            })
	            .removeAttr('aria-disabled')
	            .on('click', openSelect)
	            .on('keydown', handleKeypress);
	        }
	      });
	
	      if (!attrs.hasOwnProperty('disabled') && !attrs.hasOwnProperty('ngDisabled')) {
	        element.attr({'aria-disabled': 'false'});
	        element.on('click', openSelect);
	        element.on('keydown', handleKeypress);
	      }
	
	      var ariaAttrs = {
	        role: 'button',
	        'aria-haspopup': 'listbox'
	      };
	
	      if (!element[0].hasAttribute('id')) {
	        ariaAttrs.id = 'select_' + $mdUtil.nextUid();
	      }
	
	      var containerId = 'select_container_' + $mdUtil.nextUid();
	      selectContainer.attr('id', containerId);
	      var listboxContentId = 'select_listbox_' + $mdUtil.nextUid();
	      selectContainer.find('md-content').attr('id', listboxContentId);
	      // Only add aria-owns if element ownership is NOT represented in the DOM.
	      if (!element.find('md-select-menu').length) {
	        ariaAttrs['aria-owns'] = listboxContentId;
	      }
	      element.attr(ariaAttrs);
	
	      scope.$on('$destroy', function() {
	        stopRequiredObserver && stopRequiredObserver();
	        stopDisabledObserver && stopDisabledObserver();
	        stopMdMultipleWatch && stopMdMultipleWatch();
	        stopMdMultipleObserver && stopMdMultipleObserver();
	        stopSelectedLabelsWatcher && stopSelectedLabelsWatcher();
	        stopPlaceholderObserver && stopPlaceholderObserver();
	        stopInvalidWatch && stopInvalidWatch();
	
	        element.off('focus');
	        element.off('blur');
	
	        $mdSelect
	          .destroy()
	          .finally(function() {
	            if (containerCtrl) {
	              containerCtrl.setFocused(false);
	              containerCtrl.setHasValue(false);
	              containerCtrl.input = null;
	            }
	            ngModelCtrl.$setTouched();
	          });
	      });
	
	      function inputCheckValue() {
	        // The select counts as having a value if one or more options are selected,
	        // or if the input's validity state says it has bad input (eg: string in a number input).
	        // We must do this on nextTick as the $render is sometimes invoked on nextTick.
	        $mdUtil.nextTick(function () {
	          containerCtrl && containerCtrl.setHasValue(
	            selectMenuCtrl.getSelectedLabels().length > 0 || (element[0].validity || {}).badInput);
	        });
	      }
	
	      function findSelectContainer() {
	        var selectContainer = angular.element(
	          element[0].querySelector('.md-select-menu-container')
	        );
	        selectScope = scope;
	        attrs.mdContainerClass && selectContainer.addClass(attrs.mdContainerClass);
	        selectMenuCtrl = selectContainer.find('md-select-menu').controller('mdSelectMenu');
	        selectMenuCtrl.init(ngModelCtrl, attrs);
	        element.on('$destroy', function() {
	          selectContainer.remove();
	        });
	        return selectContainer;
	      }
	
	      /**
	       * Determine if the select menu should be opened or an option in the select menu should be
	       * selected.
	       * @param {KeyboardEvent} e keyboard event to handle
	       */
	      function handleKeypress(e) {
	        if ($mdConstant.isNavigationKey(e)) {
	          // prevent page scrolling on interaction
	          e.preventDefault();
	          openSelect(e);
	        } else {
	          if (shouldHandleKey(e, $mdConstant)) {
	            e.preventDefault();
	
	            var node = selectMenuCtrl.optNodeForKeyboardSearch(e);
	            if (!node || node.hasAttribute('disabled')) {
	              return;
	            }
	            var optionCtrl = angular.element(node).controller('mdOption');
	            if (!selectMenuCtrl.isMultiple) {
	              angular.forEach(Object.keys(selectMenuCtrl.selected), function (key) {
	                selectMenuCtrl.deselect(key);
	              });
	            }
	            selectMenuCtrl.select(optionCtrl.hashKey, optionCtrl.value);
	            selectMenuCtrl.refreshViewValue();
	          }
	        }
	      }
	
	      function openSelect() {
	        selectScope._mdSelectIsOpen = true;
	        element.attr('aria-expanded', 'true');
	
	        $mdSelect.show({
	          scope: selectScope,
	          preserveScope: true,
	          skipCompile: true,
	          element: selectContainer,
	          target: element[0],
	          selectCtrl: mdSelectCtrl,
	          preserveElement: true,
	          hasBackdrop: true,
	          loadingAsync: attrs.mdOnOpen ? scope.$eval(attrs.mdOnOpen) || true : false
	        }).finally(function() {
	          selectScope._mdSelectIsOpen = false;
	          element.removeAttr('aria-expanded');
	          element.removeAttr('aria-activedescendant');
	          ngModelCtrl.$setTouched();
	        });
	      }
	
	    };
	  }
	}
	
	function SelectMenuDirective($parse, $mdUtil, $mdConstant, $mdTheming) {
	  // We want the scope to be set to 'false' so an isolated scope is not created
	  // which would interfere with the md-select-header's access to the
	  // parent scope.
	  SelectMenuController.$inject = ["$scope", "$attrs", "$element"];
	  return {
	    restrict: 'E',
	    require: ['mdSelectMenu'],
	    scope: false,
	    controller: SelectMenuController,
	    link: {pre: preLink}
	  };
	
	  // We use preLink instead of postLink to ensure that the select is initialized before
	  // its child options run postLink.
	  function preLink(scope, element, attrs, ctrls) {
	    var selectMenuCtrl = ctrls[0];
	
	    element.addClass('_md');     // private md component indicator for styling
	
	    $mdTheming(element);
	    element.on('click', clickListener);
	    element.on('keypress', keyListener);
	
	    /**
	     * @param {KeyboardEvent} keyboardEvent
	     */
	    function keyListener(keyboardEvent) {
	      if (keyboardEvent.keyCode === 13 || keyboardEvent.keyCode === 32) {
	        clickListener(keyboardEvent);
	      }
	    }
	
	    /**
	     * @param {Event} mouseEvent
	     * @return {void}
	     */
	    function clickListener(mouseEvent) {
	      var option = $mdUtil.getClosest(mouseEvent.target, 'md-option');
	      var optionCtrl = option && angular.element(option).data('$mdOptionController');
	
	      if (!option || !optionCtrl) {
	        // Avoid closing the menu when the select header's input is clicked
	        if (mouseEvent.target && mouseEvent.target.parentNode &&
	          mouseEvent.target.parentNode.tagName === 'MD-SELECT-HEADER') {
	          mouseEvent.stopImmediatePropagation();
	        }
	        return;
	      } else if (option.hasAttribute('disabled')) {
	        mouseEvent.stopImmediatePropagation();
	        return;
	      }
	
	      var optionHashKey = selectMenuCtrl.hashGetter(optionCtrl.value);
	      var isSelected = angular.isDefined(selectMenuCtrl.selected[optionHashKey]);
	
	      scope.$apply(function() {
	        if (selectMenuCtrl.isMultiple) {
	          if (isSelected) {
	            selectMenuCtrl.deselect(optionHashKey);
	          } else {
	            selectMenuCtrl.select(optionHashKey, optionCtrl.value);
	          }
	        } else {
	          if (!isSelected) {
	            angular.forEach(Object.keys(selectMenuCtrl.selected), function (key) {
	              selectMenuCtrl.deselect(key);
	            });
	            selectMenuCtrl.select(optionHashKey, optionCtrl.value);
	          }
	        }
	        selectMenuCtrl.refreshViewValue();
	      });
	    }
	  }
	
	  function SelectMenuController($scope, $attrs, $element) {
	    var self = this;
	    var defaultIsEmpty;
	    var searchStr = '';
	    var clearSearchTimeout, optNodes, optText;
	    var CLEAR_SEARCH_AFTER = 300;
	
	    self.isMultiple = angular.isDefined($attrs.multiple);
	    // selected is an object with keys matching all of the selected options' hashed values
	    self.selected = {};
	    // options is an object with keys matching every option's hash value,
	    // and values containing an instance of every option's controller.
	    self.options = {};
	
	    $scope.$watchCollection(function() {
	      return self.options;
	    }, function() {
	      self.ngModel.$render();
	      updateOptionSetSizeAndPosition();
	    });
	
	    /**
	     * @param {boolean} isMultiple
	     */
	    self.setMultiple = function(isMultiple) {
	      var ngModel = self.ngModel;
	      defaultIsEmpty = defaultIsEmpty || ngModel.$isEmpty;
	      self.isMultiple = isMultiple;
	
	      if (self.isMultiple) {
	        // We want to delay the render method so that the directive has a chance to load before
	        // rendering, this prevents the control being marked as dirty onload.
	        var loaded = false;
	        var delayedRender = function(val) {
	          if (!loaded) {
	            $mdUtil.nextTick(function () {
	              renderMultiple(val);
	              loaded = true;
	            });
	          } else {
	            renderMultiple(val);
	          }
	        };
	        ngModel.$validators['md-multiple'] = validateArray;
	        ngModel.$render = delayedRender;
	
	        // watchCollection on the model because by default ngModel only watches the model's
	        // reference. This allows the developer to also push and pop from their array.
	        $scope.$watchCollection(self.modelBinding, function(value) {
	          if (validateArray(value)) {
	            delayedRender(value);
	          }
	        });
	
	        ngModel.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	      } else {
	        delete ngModel.$validators['md-multiple'];
	        ngModel.$render = renderSingular;
	      }
	
	      function validateArray(modelValue, viewValue) {
	        // If a value is truthy but not an array, reject it.
	        // If value is undefined/falsy, accept that it's an empty array.
	        return angular.isArray(modelValue || viewValue || []);
	      }
	    };
	
	    /**
	     * @param {KeyboardEvent} keyboardEvent keyboard event to handle
	     * @return {Element|HTMLElement|undefined}
	     */
	    self.optNodeForKeyboardSearch = function(keyboardEvent) {
	      var search, i;
	      clearSearchTimeout && clearTimeout(clearSearchTimeout);
	      clearSearchTimeout = setTimeout(function() {
	        clearSearchTimeout = undefined;
	        searchStr = '';
	        optText = undefined;
	        optNodes = undefined;
	      }, CLEAR_SEARCH_AFTER);
	
	      searchStr += keyboardEvent.key;
	      search = new RegExp('^' + $mdUtil.sanitize(searchStr), 'i');
	      if (!optNodes) {
	        optNodes = $element.find('md-option');
	        optText = new Array(optNodes.length);
	        angular.forEach(optNodes, function(el, i) {
	          optText[i] = el.textContent.trim();
	        });
	      }
	
	      for (i = 0; i < optText.length; ++i) {
	        if (search.test(optText[i])) {
	          return optNodes[i];
	        }
	      }
	    };
	
	    self.init = function(ngModel, parentAttrs) {
	      self.ngModel = ngModel;
	      self.modelBinding = parentAttrs.ngModel;
	
	      // Setup a more robust version of isEmpty to ensure value is a valid option
	      self.ngModel.$isEmpty = function($viewValue) {
	        // We have to transform the viewValue into the hashKey, because otherwise the
	        // OptionCtrl may not exist. Developers may have specified a trackBy function.
	        var hashedValue = self.options[self.hashGetter($viewValue)] ? self.options[self.hashGetter($viewValue)].value : null;
	        // Base this check on the default AngularJS $isEmpty() function.
	        // eslint-disable-next-line no-self-compare
	        return !angular.isDefined(hashedValue) || hashedValue === null || hashedValue === '' || hashedValue !== hashedValue;
	      };
	
	      // Allow users to provide `ng-model="foo" ng-model-options="{trackBy: '$value.id'}"` so
	      // that we can properly compare objects set on the model to the available options
	      //
	      // If the user doesn't provide a trackBy, we automatically generate an id for every
	      // value passed in with the getId function
	      if ($attrs.ngModelOptions) {
	        self.hashGetter = function(value) {
	          var ngModelOptions = $parse($attrs.ngModelOptions)($scope);
	          var trackByOption = ngModelOptions && ngModelOptions.trackBy;
	
	          if (trackByOption) {
	            return $parse(trackByOption)($scope, { $value: value });
	          } else if (angular.isObject(value)) {
	            return getId(value);
	          }
	          return value;
	        };
	      } else {
	        self.hashGetter = getId;
	      }
	      self.setMultiple(self.isMultiple);
	
	      /**
	       * If the value is an object, get the unique, incremental id of the value.
	       * If it's not an object, the value will be converted to a string and then returned.
	       * @param value
	       * @returns {string}
	       */
	      function getId(value) {
	        if (angular.isObject(value) && !angular.isArray(value)) {
	          return 'object_' + (value.$$mdSelectId || (value.$$mdSelectId = ++selectNextId));
	        }
	        return value + '';
	      }
	
	      if (parentAttrs.hasOwnProperty('mdSelectOnlyOption')) {
	        $mdUtil.nextTick(function() {
	          var optionKeys = Object.keys(self.options);
	
	          if (optionKeys.length === 1) {
	            var option = self.options[optionKeys[0]];
	
	            self.deselect(Object.keys(self.selected)[0]);
	            self.select(self.hashGetter(option.value), option.value);
	            self.refreshViewValue();
	            self.ngModel.$setPristine();
	          }
	        }, false);
	      }
	    };
	
	    /**
	     * @param {string=} id
	     */
	    self.setActiveDescendant = function(id) {
	      if (angular.isDefined(id)) {
	        $element.find('md-content').attr('aria-activedescendant', id);
	      } else {
	        $element.find('md-content').removeAttr('aria-activedescendant');
	      }
	    };
	
	    /**
	     * @param {{mode: string}=} opts options object to allow specifying html (default) or aria mode.
	     * @return {string} comma separated set of selected values
	     */
	    self.getSelectedLabels = function(opts) {
	      opts = opts || {};
	      var mode = opts.mode || 'html';
	      var selectedOptionEls =
	        $mdUtil.nodesToArray($element[0].querySelectorAll('md-option[selected]'));
	
	      if (selectedOptionEls.length) {
	        var mapFn;
	
	        if (mode === 'html') {
	          // Map the given element to its innerHTML string. If the element has a child ripple
	          // container remove it from the HTML string, before returning the string.
	          mapFn = function(el) {
	            // If we do not have a `value` or `ng-value`, assume it is an empty option which clears
	            // the select.
	            if (el.hasAttribute('md-option-empty')) {
	              return '';
	            }
	
	            var html = el.innerHTML;
	
	            // Remove the ripple container from the selected option, copying it would cause a CSP
	            // violation.
	            var rippleContainer = el.querySelector('.md-ripple-container');
	            if (rippleContainer) {
	              html = html.replace(rippleContainer.outerHTML, '');
	            }
	
	            // Remove the checkbox container, because it will cause the label to wrap inside of the
	            // placeholder. It should be not displayed inside of the label element.
	            var checkboxContainer = el.querySelector('.md-container');
	            if (checkboxContainer) {
	              html = html.replace(checkboxContainer.outerHTML, '');
	            }
	
	            return html;
	          };
	        } else if (mode === 'aria') {
	          mapFn = function(el) {
	            return el.hasAttribute('aria-label') ? el.getAttribute('aria-label') : el.textContent;
	          };
	        }
	
	        // Ensure there are no duplicates; see https://github.com/angular/material/issues/9442
	        return $mdUtil.uniq(selectedOptionEls.map(mapFn)).join(', ');
	      } else {
	        return '';
	      }
	    };
	
	    /**
	     * Mark an option as selected
	     * @param {string} hashKey key within the SelectMenuController.options object, which is an
	     *  instance of OptionController.
	     * @param {OptionController} hashedValue value to associate with the key
	     */
	    self.select = function(hashKey, hashedValue) {
	      var option = self.options[hashKey];
	      option && option.setSelected(true, self.isMultiple);
	      self.selected[hashKey] = hashedValue;
	    };
	
	    /**
	     * Mark an option as not selected
	     * @param {string} hashKey key within the SelectMenuController.options object, which is an
	     *  instance of OptionController.
	     */
	    self.deselect = function(hashKey) {
	      var option = self.options[hashKey];
	      option && option.setSelected(false, self.isMultiple);
	      delete self.selected[hashKey];
	    };
	
	    /**
	     * Add an option to the select
	     * @param {string} hashKey key within the SelectMenuController.options object, which is an
	     *  instance of OptionController.
	     * @param {OptionController} optionCtrl instance to associate with the key
	     */
	    self.addOption = function(hashKey, optionCtrl) {
	      if (angular.isDefined(self.options[hashKey])) {
	        throw new Error('Duplicate md-option values are not allowed in a select. ' +
	          'Duplicate value "' + optionCtrl.value + '" found.');
	      }
	
	      self.options[hashKey] = optionCtrl;
	
	      // If this option's value was already in our ngModel, go ahead and select it.
	      if (angular.isDefined(self.selected[hashKey])) {
	        self.select(hashKey, optionCtrl.value);
	
	        // When the current $modelValue of the ngModel Controller is using the same hash as
	        // the current option, which will be added, then we can be sure, that the validation
	        // of the option has occurred before the option was added properly.
	        // This means, that we have to manually trigger a new validation of the current option.
	        if (angular.isDefined(self.ngModel.$$rawModelValue) &&
	            self.hashGetter(self.ngModel.$$rawModelValue) === hashKey) {
	          self.ngModel.$validate();
	        }
	
	        self.refreshViewValue();
	      }
	    };
	
	    /**
	     * Remove an option from the select
	     * @param {string} hashKey key within the SelectMenuController.options object, which is an
	     *  instance of OptionController.
	     */
	    self.removeOption = function(hashKey) {
	      delete self.options[hashKey];
	      // Don't deselect an option when it's removed - the user's ngModel should be allowed
	      // to have values that do not match a currently available option.
	    };
	
	    self.refreshViewValue = function() {
	      var values = [];
	      var option;
	      for (var hashKey in self.selected) {
	        // If this hashKey has an associated option, push that option's value to the model.
	        if ((option = self.options[hashKey])) {
	          values.push(option.value);
	        } else {
	          // Otherwise, the given hashKey has no associated option, and we got it
	          // from an ngModel value at an earlier time. Push the unhashed value of
	          // this hashKey to the model.
	          // This allows the developer to put a value in the model that doesn't yet have
	          // an associated option.
	          values.push(self.selected[hashKey]);
	        }
	      }
	
	      var newVal = self.isMultiple ? values : values[0];
	      var prevVal = self.ngModel.$modelValue;
	
	      if (!equals(prevVal, newVal)) {
	        self.ngModel.$setViewValue(newVal);
	        self.ngModel.$render();
	      }
	
	      function equals(prevVal, newVal) {
	        if (self.isMultiple) {
	          if (!angular.isArray(prevVal)) {
	            // newVal is always an array when self.isMultiple is true
	            // thus, if prevVal is not an array they are different
	            return false;
	          } else if (prevVal.length !== newVal.length) {
	            // they are different if they have different length
	            return false;
	          } else {
	            // if they have the same length, then they are different
	            // if an item in the newVal array can't be found in the prevVal
	            var prevValHashes = prevVal.map(function(prevValItem) {
	              return self.hashGetter(prevValItem);
	            });
	            return newVal.every(function(newValItem) {
	              var newValItemHash = self.hashGetter(newValItem);
	              return prevValHashes.some(function(prevValHash) {
	                return prevValHash === newValItemHash;
	              });
	            });
	          }
	        } else {
	          return self.hashGetter(prevVal) === self.hashGetter(newVal);
	        }
	      }
	    };
	
	    /**
	     * If the options include md-optgroups, then we need to apply aria-setsize and aria-posinset
	     * to help screen readers understand the indexes. When md-optgroups are not used, we save on
	     * perf and extra attributes by not applying these attributes as they are not needed by screen
	     * readers.
	     */
	    function updateOptionSetSizeAndPosition() {
	      var i, options;
	      var hasOptGroup = $element.find('md-optgroup');
	      if (!hasOptGroup.length) {
	        return;
	      }
	
	      options = $element.find('md-option');
	
	      for (i = 0; i < options.length; i++) {
	        options[i].setAttribute('aria-setsize', options.length);
	        options[i].setAttribute('aria-posinset', i + 1);
	      }
	    }
	
	    function renderMultiple() {
	      var newSelectedValues = self.ngModel.$modelValue || self.ngModel.$viewValue || [];
	      if (!angular.isArray(newSelectedValues)) {
	        return;
	      }
	
	      var oldSelected = Object.keys(self.selected);
	
	      var newSelectedHashes = newSelectedValues.map(self.hashGetter);
	      var deselected = oldSelected.filter(function(hash) {
	        return newSelectedHashes.indexOf(hash) === -1;
	      });
	
	      deselected.forEach(self.deselect);
	      newSelectedHashes.forEach(function(hashKey, i) {
	        self.select(hashKey, newSelectedValues[i]);
	      });
	    }
	
	    function renderSingular() {
	      var value = self.ngModel.$viewValue || self.ngModel.$modelValue;
	      Object.keys(self.selected).forEach(self.deselect);
	      self.select(self.hashGetter(value), value);
	    }
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name mdOption
	 * @restrict E
	 * @module material.components.select
	 *
	 * @description Displays an option in a <a ng-href="api/directive/mdSelect">md-select</a> box's
	 * dropdown menu. Options can be grouped using
	 * <a ng-href="api/directive/mdOptgroup">md-optgroup</a> element directives.
	 *
	 * ### Option Params
	 *
	 * When applied, `md-option-empty` will mark the option as "empty" allowing the option to clear the
	 * select and put it back in it's default state. You may supply this attribute on any option you
	 * wish, however, it is automatically applied to an option whose `value` or `ng-value` are not
	 * defined.
	 *
	 * **Automatically Applied**
	 *
	 *  - `<md-option>`
	 *  - `<md-option value>`
	 *  - `<md-option value="">`
	 *  - `<md-option ng-value>`
	 *  - `<md-option ng-value="">`
	 *
	 * **NOT Automatically Applied**
	 *
	 *  - `<md-option ng-value="1">`
	 *  - `<md-option ng-value="''">`
	 *  - `<md-option ng-value="undefined">`
	 *  - `<md-option value="undefined">` (this evaluates to the string `"undefined"`)
	 *  - <code ng-non-bindable>&lt;md-option ng-value="{{someValueThatMightBeUndefined}}"&gt;</code>
	 *
	 * **Note:** A value of `undefined` ***is considered a valid value*** (and does not auto-apply this
	 * attribute) since you may wish this to be your "Not Available" or "None" option.
	 *
	 * **Note:** Using the
	 * <a ng-href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/option#Attributes">value</a>
	 * attribute from the `<option>` element (as opposed to the `<md-option>` element's
	 * <a ng-href="https://docs.angularjs.org/api/ng/directive/ngValue">ng-value</a>) always evaluates
	 * to a `string`. This means that `value="null"` will cause a check against `myValue != "null"`
	 * rather than `!myValue` or `myValue != null`.
	 * Importantly, this also applies to `number` values. `value="1"` will not match up with an
	 * `ng-model` like `$scope.selectedValue = 1`. Use `ng-value="1"` in this case and other cases where
	 * you have values that are not strings.
	 *
	 * **Note:** Please see our <a ng-href="api/directive/mdSelect#selects-and-object-equality">docs on
	 * using objects with `md-select`</a> for additional guidance on using the `trackBy` option with
	 * `ng-model-options`.
	 *
	 * @param {expression=} ng-value Binds the given expression to the value of the option.
	 * @param {string=} value Attribute to set the value of the option.
	 * @param {expression=} ng-repeat <a ng-href="https://docs.angularjs.org/api/ng/directive/ngRepeat">
	 *  AngularJS directive</a> that instantiates a template once per item from a collection.
	 * @param {expression=} ng-selected <a ng-href="https://docs.angularjs.org/api/ng/directive/ngSelected">
	 *  AngularJS directive</a> that adds the `selected` attribute to the option when the expression
	 *  evaluates as truthy.
	 *
	 *  **Note:** Unlike native `option` elements used with AngularJS, `md-option` elements
	 *  watch their `selected` attributes for changes and trigger model value changes on `md-select`.
	 * @param {boolean=} md-option-empty If the attribute exists, mark the option as "empty" allowing
	 * the option to clear the select and put it back in it's default state. You may supply this
	 * attribute on any option you wish, however, it is automatically applied to an option whose `value`
	 * or `ng-value` are not defined.
	 * @param {number=} tabindex The `tabindex` of the option. Defaults to `0`.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-select ng-model="currentState" placeholder="Select a state">
	 *   <md-option ng-value="AL">Alabama</md-option>
	 *   <md-option ng-value="AK">Alaska</md-option>
	 *   <md-option ng-value="FL">Florida</md-option>
	 * </md-select>
	 * </hljs>
	 *
	 * With `ng-repeat`:
	 * <hljs lang="html">
	 * <md-select ng-model="currentState" placeholder="Select a state">
	 *   <md-option ng-value="state" ng-repeat="state in states">{{ state }}</md-option>
	 * </md-select>
	 * </hljs>
	 */
	function OptionDirective($mdButtonInkRipple, $mdUtil, $mdTheming) {
	
	  return {
	    restrict: 'E',
	    require: ['mdOption', '^^mdSelectMenu'],
	    controller: OptionController,
	    compile: compile
	  };
	
	  /**
	   * @param {JQLite} element
	   * @param {IAttributes} attrs
	   * @return {postLink}
	   */
	  function compile(element, attrs) {
	    // Manual transclusion to avoid the extra inner <span> that ng-transclude generates
	    element.append(angular.element('<div class="md-text">').append(element.contents()));
	
	    element.attr('tabindex', attrs.tabindex || '0');
	
	    if (!hasDefinedValue(attrs)) {
	      element.attr('md-option-empty', '');
	    }
	
	    return postLink;
	  }
	
	  /**
	   * @param {Object} attrs list of attributes from the compile function
	   * @return {string|undefined|null} if defined and non-empty, return the value of the option's
	   *  value attribute, otherwise return the value of the option's ng-value attribute.
	   */
	  function hasDefinedValue(attrs) {
	    var value = attrs.value;
	    var ngValue = attrs.ngValue;
	
	    return value || ngValue;
	  }
	
	  function postLink(scope, element, attrs, ctrls) {
	    var optionCtrl = ctrls[0];
	    var selectMenuCtrl = ctrls[1];
	
	    $mdTheming(element);
	
	    if (selectMenuCtrl.isMultiple) {
	      element.addClass('md-checkbox-enabled');
	      if (!CHECKBOX_SELECTION_INDICATOR) {
	        var indicator = document.createElement('div');
	        indicator.className = 'md-container';
	        indicator.appendChild(document.createElement('div'));
	        indicator.firstChild.className = 'md-icon';
	        CHECKBOX_SELECTION_INDICATOR = angular.element(indicator);
	      }
	      element.prepend(CHECKBOX_SELECTION_INDICATOR.clone());
	    }
	
	    if (angular.isDefined(attrs.ngValue)) {
	      scope.$watch(attrs.ngValue, function (newValue, oldValue) {
	        setOptionValue(newValue, oldValue);
	        element.removeAttr('aria-checked');
	      });
	    } else if (angular.isDefined(attrs.value)) {
	      setOptionValue(attrs.value);
	    } else {
	      scope.$watch(function() {
	        return element.text().trim();
	      }, setOptionValue);
	    }
	
	    attrs.$observe('disabled', function(disabled) {
	      if (disabled) {
	        element.attr('tabindex', '-1');
	      } else {
	        element.attr('tabindex', '0');
	      }
	    });
	
	    scope.$$postDigest(function() {
	      attrs.$observe('selected', function(selected) {
	        if (!angular.isDefined(selected)) return;
	        if (typeof selected == 'string') selected = true;
	        if (selected) {
	          if (!selectMenuCtrl.isMultiple) {
	            selectMenuCtrl.deselect(Object.keys(selectMenuCtrl.selected)[0]);
	          }
	          selectMenuCtrl.select(optionCtrl.hashKey, optionCtrl.value);
	        } else {
	          selectMenuCtrl.deselect(optionCtrl.hashKey);
	        }
	        selectMenuCtrl.refreshViewValue();
	      });
	    });
	
	    $mdButtonInkRipple.attach(scope, element);
	    configureAria();
	
	    /**
	     * @param {*} newValue the option's new value
	     * @param {*=} oldValue the option's previous value
	     * @param {boolean=} prevAttempt true if this had to be attempted again due to an undefined
	     *  hashGetter on the selectMenuCtrl, undefined otherwise.
	     */
	    function setOptionValue(newValue, oldValue, prevAttempt) {
	      if (!selectMenuCtrl.hashGetter) {
	        if (!prevAttempt) {
	          scope.$$postDigest(function() {
	            setOptionValue(newValue, oldValue, true);
	          });
	        }
	        return;
	      }
	      var oldHashKey = selectMenuCtrl.hashGetter(oldValue, scope);
	      var newHashKey = selectMenuCtrl.hashGetter(newValue, scope);
	
	      optionCtrl.hashKey = newHashKey;
	      optionCtrl.value = newValue;
	
	      selectMenuCtrl.removeOption(oldHashKey, optionCtrl);
	      selectMenuCtrl.addOption(newHashKey, optionCtrl);
	    }
	
	    scope.$on('$destroy', function() {
	      selectMenuCtrl.removeOption(optionCtrl.hashKey, optionCtrl);
	    });
	
	    function configureAria() {
	      var ariaAttrs = {
	        'role': 'option'
	      };
	
	      // We explicitly omit the `aria-selected` attribute from single-selection, unselected
	      // options. Including the `aria-selected="false"` attributes adds a significant amount of
	      // noise to screen-reader users without providing useful information.
	      if (selectMenuCtrl.isMultiple) {
	        ariaAttrs['aria-selected'] = 'false';
	      }
	
	      if (!element[0].hasAttribute('id')) {
	        ariaAttrs.id = 'select_option_' + $mdUtil.nextUid();
	      }
	      element.attr(ariaAttrs);
	    }
	  }
	}
	
	/**
	 * @param {JQLite} $element
	 * @constructor
	 */
	function OptionController($element) {
	  /**
	   * @param {boolean} isSelected
	   * @param {boolean=} isMultiple
	   */
	  this.setSelected = function(isSelected, isMultiple) {
	    if (isSelected) {
	      $element.attr({
	        'selected': 'true',
	        'aria-selected': 'true'
	      });
	    } else if (!isSelected) {
	      $element.removeAttr('selected');
	
	      if (isMultiple) {
	        $element.attr('aria-selected', 'false');
	      } else {
	        // We explicitly omit the `aria-selected` attribute from single-selection, unselected
	        // options. Including the `aria-selected="false"` attributes adds a significant amount of
	        // noise to screen-reader users without providing useful information.
	        $element.removeAttr('aria-selected');
	      }
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name mdOptgroup
	 * @restrict E
	 * @module material.components.select
	 *
	 * @description Displays a label separating groups of
	 * <a ng-href="api/directive/mdOption">md-option</a> element directives in a
	 * <a ng-href="api/directive/mdSelect">md-select</a> box's dropdown menu.
	 *
	 * **Note:** When using `md-select-header` element directives within a `md-select`, the labels that
	 * would normally be added to the <a ng-href="api/directive/mdOptgroup">md-optgroup</a> directives
	 * are omitted, allowing the `md-select-header` to represent the option group label
	 * (and possibly more).
	 *
	 * @usage
	 * With label attributes
	 * <hljs lang="html">
	 * <md-select ng-model="currentState" placeholder="Select a state">
	 *   <md-optgroup label="Southern">
	 *     <md-option ng-value="AL">Alabama</md-option>
	 *     <md-option ng-value="FL">Florida</md-option>
	 *   </md-optgroup>
	 *   <md-optgroup label="Northern">
	 *     <md-option ng-value="AK">Alaska</md-option>
	 *     <md-option ng-value="MA">Massachusetts</md-option>
	 *   </md-optgroup>
	 * </md-select>
	 * </hljs>
	 *
	 * With label elements
	 * <hljs lang="html">
	 * <md-select ng-model="currentState" placeholder="Select a state">
	 *   <md-optgroup>
	 *     <label>Southern</label>
	 *     <md-option ng-value="AL">Alabama</md-option>
	 *     <md-option ng-value="FL">Florida</md-option>
	 *   </md-optgroup>
	 *   <md-optgroup>
	 *     <label>Northern</label>
	 *     <md-option ng-value="AK">Alaska</md-option>
	 *     <md-option ng-value="MA">Massachusetts</md-option>
	 *   </md-optgroup>
	 * </md-select>
	 * </hljs>
	 *
	 * @param {string=} label The option group's label.
	 */
	function OptgroupDirective() {
	  return {
	    restrict: 'E',
	    compile: compile
	  };
	  function compile(element, attrs) {
	    // If we have a select header element, we don't want to add the normal label
	    // header.
	    if (!hasSelectHeader()) {
	      setupLabelElement();
	    }
	    element.attr('role', 'group');
	
	    function hasSelectHeader() {
	      return element.parent().find('md-select-header').length;
	    }
	
	    function setupLabelElement() {
	      var labelElement = element.find('label');
	      if (!labelElement.length) {
	        labelElement = angular.element('<label>');
	        element.prepend(labelElement);
	      }
	      labelElement.addClass('md-container-ignore');
	      labelElement.attr('aria-hidden', 'true');
	      if (attrs.label) {
	        labelElement.text(attrs.label);
	      }
	      element.attr('aria-label', labelElement.text());
	    }
	  }
	}
	
	function SelectHeaderDirective() {
	  return {
	    restrict: 'E',
	  };
	}
	
	function SelectProvider($$interimElementProvider) {
	  selectDefaultOptions.$inject = ["$mdSelect", "$mdConstant", "$mdUtil", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$document"];
	  return $$interimElementProvider('$mdSelect')
	    .setDefaults({
	      methods: ['target'],
	      options: selectDefaultOptions
	    });
	
	  /* @ngInject */
	  function selectDefaultOptions($mdSelect, $mdConstant, $mdUtil, $window, $q, $$rAF, $animateCss, $animate, $document) {
	    var ERROR_TARGET_EXPECTED = "$mdSelect.show() expected a target element in options.target but got '{0}'!";
	    var animator = $mdUtil.dom.animator;
	    var keyCodes = $mdConstant.KEY_CODE;
	
	    return {
	      parent: 'body',
	      themable: true,
	      onShow: onShow,
	      onRemove: onRemove,
	      hasBackdrop: true,
	      disableParentScroll: true
	    };
	
	    /**
	     * Interim-element onRemove logic....
	     */
	    function onRemove(scope, element, opts) {
	      var animationRunner = null;
	      var destroyListener = scope.$on('$destroy', function() {
	        // Listen for the case where the element was destroyed while there was an
	        // ongoing close animation. If this happens, we need to end the animation
	        // manually.
	        animationRunner.end();
	      });
	
	      opts = opts || { };
	      opts.cleanupInteraction();
	      opts.cleanupResizing();
	      opts.hideBackdrop();
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	      return (opts.$destroy === true) ? cleanElement() : animateRemoval().then(cleanElement);
	
	      /**
	       * For normal closes (eg clicks), animate the removal.
	       * For forced closes (like $destroy events from navigation),
	       * skip the animations.
	       */
	      function animateRemoval() {
	        animationRunner = $animateCss(element, {addClass: 'md-leave'});
	        return animationRunner.start();
	      }
	
	      /**
	       * Restore the element to a closed state
	       */
	      function cleanElement() {
	        destroyListener();
	
	        element
	          .removeClass('md-active')
	          .attr('aria-hidden', 'true')
	          .css({
	            'display': 'none',
	            'top': '',
	            'right': '',
	            'bottom': '',
	            'left': '',
	            'font-size': '',
	            'min-width': ''
	          });
	
	        announceClosed(opts);
	
	        if (!opts.$destroy) {
	          if (opts.restoreFocus) {
	            opts.target.focus();
	          } else {
	            // Make sure that the container's md-input-focused is removed on backdrop click.
	            $mdUtil.nextTick(function() {
	              opts.target.triggerHandler('blur');
	            }, true);
	          }
	        }
	      }
	    }
	
	    /**
	     * Interim-element onShow logic.
	     */
	    function onShow(scope, element, opts) {
	
	      watchAsyncLoad();
	      sanitizeAndConfigure(scope, opts);
	
	      opts.hideBackdrop = showBackdrop(scope, element, opts);
	
	      return showDropDown(scope, element, opts)
	        .then(function(response) {
	          element.attr('aria-hidden', 'false');
	          opts.alreadyOpen = true;
	          opts.cleanupInteraction = activateInteraction();
	          opts.cleanupResizing = activateResizing();
	          opts.contentEl[0].focus();
	
	          return response;
	        }, opts.hideBackdrop);
	
	      // ************************************
	      // Closure Functions
	      // ************************************
	
	      /**
	       * Attach the select DOM element(s) and animate to the correct positions and scale.
	       */
	      function showDropDown(scope, element, opts) {
	        if (opts.parent !== element.parent()) {
	          element.parent().attr('aria-owns', element.find('md-content').attr('id'));
	        }
	
	        opts.parent.append(element);
	
	        return $q(function(resolve, reject) {
	          try {
	            $animateCss(element, {removeClass: 'md-leave', duration: 0})
	              .start()
	              .then(positionAndFocusMenu)
	              .then(resolve);
	
	          } catch (e) {
	            reject(e);
	          }
	        });
	      }
	
	      /**
	       * Initialize container and dropDown menu positions/scale, then animate to show.
	       * @return {*} a Promise that resolves after the menu is animated in and an item is focused
	       */
	      function positionAndFocusMenu() {
	        return $q(function(resolve) {
	          if (opts.isRemoved) return $q.reject(false);
	
	          var info = calculateMenuPositions(scope, element, opts);
	
	          info.container.element.css(animator.toCss(info.container.styles));
	          info.dropDown.element.css(animator.toCss(info.dropDown.styles));
	
	          $$rAF(function() {
	            element.addClass('md-active');
	            info.dropDown.element.css(animator.toCss({transform: ''}));
	            autoFocus(opts.focusedNode);
	
	            resolve();
	          });
	
	        });
	      }
	
	      /**
	       * Show modal backdrop element.
	       */
	      function showBackdrop(scope, element, options) {
	
	        // If we are not within a dialog...
	        if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
	          // !! DO this before creating the backdrop; since disableScrollAround()
	          //    configures the scroll offset; which is used by mdBackDrop postLink()
	          options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
	        } else {
	          options.disableParentScroll = false;
	        }
	
	        if (options.hasBackdrop) {
	          // Override duration to immediately show invisible backdrop
	          options.backdrop = $mdUtil.createBackdrop(scope, "md-select-backdrop md-click-catcher");
	          $animate.enter(options.backdrop, $document[0].body, null, {duration: 0});
	        }
	
	        /**
	         * Hide modal backdrop element...
	         */
	        return function hideBackdrop() {
	          if (options.backdrop) options.backdrop.remove();
	          if (options.disableParentScroll) options.restoreScroll();
	
	          delete options.restoreScroll;
	        };
	      }
	
	      /**
	       * @param {Element|HTMLElement|null=} previousNode
	       * @param {Element|HTMLElement} node
	       * @param {SelectMenuController|Function|object=} menuController SelectMenuController instance
	       */
	      function focusOptionNode(previousNode, node, menuController) {
	        var listboxContentNode = opts.contentEl[0];
	
	        if (node) {
	          if (previousNode) {
	            previousNode.classList.remove('md-focused');
	          }
	
	          node.classList.add('md-focused');
	          if (menuController && menuController.setActiveDescendant) {
	            menuController.setActiveDescendant(node.id);
	          }
	
	          // Scroll the node into view if needed.
	          if (listboxContentNode.scrollHeight > listboxContentNode.clientHeight) {
	            var scrollBottom = listboxContentNode.clientHeight + listboxContentNode.scrollTop;
	            var nodeBottom = node.offsetTop + node.offsetHeight;
	            if (nodeBottom > scrollBottom) {
	              listboxContentNode.scrollTop = nodeBottom - listboxContentNode.clientHeight;
	            } else if (node.offsetTop < listboxContentNode.scrollTop) {
	              listboxContentNode.scrollTop = node.offsetTop;
	            }
	          }
	          opts.focusedNode = node;
	          if (menuController && menuController.refreshViewValue) {
	            menuController.refreshViewValue();
	          }
	        }
	      }
	
	      /**
	       * @param {Element|HTMLElement} nodeToFocus
	       */
	      function autoFocus(nodeToFocus) {
	        var selectMenuController;
	        if (nodeToFocus && !nodeToFocus.hasAttribute('disabled')) {
	          selectMenuController = opts.selectEl.controller('mdSelectMenu');
	          focusOptionNode(null, nodeToFocus, selectMenuController);
	        }
	      }
	
	      /**
	       * Check for valid opts and set some useful defaults
	       */
	      function sanitizeAndConfigure(scope, options) {
	        var selectMenuElement = element.find('md-select-menu');
	
	        if (!options.target) {
	          throw new Error($mdUtil.supplant(ERROR_TARGET_EXPECTED, [options.target]));
	        }
	
	        angular.extend(options, {
	          isRemoved: false,
	          target: angular.element(options.target), // make sure it's not a naked DOM node
	          parent: angular.element(options.parent),
	          selectEl: selectMenuElement,
	          contentEl: element.find('md-content'),
	          optionNodes: selectMenuElement[0].getElementsByTagName('md-option')
	        });
	      }
	
	      /**
	       * Configure various resize listeners for screen changes
	       */
	      function activateResizing() {
	        var debouncedOnResize = (function(scope, target, options) {
	
	          return function() {
	            if (options.isRemoved) return;
	
	            var updates = calculateMenuPositions(scope, target, options);
	            var container = updates.container;
	            var dropDown = updates.dropDown;
	
	            container.element.css(animator.toCss(container.styles));
	            dropDown.element.css(animator.toCss(dropDown.styles));
	          };
	
	        })(scope, element, opts);
	
	        var window = angular.element($window);
	        window.on('resize', debouncedOnResize);
	        window.on('orientationchange', debouncedOnResize);
	
	        // Publish deactivation closure...
	        return function deactivateResizing() {
	
	          // Disable resizing handlers
	          window.off('resize', debouncedOnResize);
	          window.off('orientationchange', debouncedOnResize);
	        };
	      }
	
	      /**
	       * If asynchronously loading, watch and update internal '$$loadingAsyncDone' flag.
	       */
	      function watchAsyncLoad() {
	        if (opts.loadingAsync && !opts.isRemoved) {
	          scope.$$loadingAsyncDone = false;
	
	          $q.when(opts.loadingAsync)
	            .then(function() {
	              scope.$$loadingAsyncDone = true;
	              delete opts.loadingAsync;
	            }).then(function() {
	              $$rAF(positionAndFocusMenu);
	            });
	        }
	      }
	
	      function activateInteraction() {
	        if (opts.isRemoved) {
	          return;
	        }
	
	        var dropDown = opts.selectEl;
	        var selectMenuController = dropDown.controller('mdSelectMenu') || {};
	
	        element.addClass('md-clickable');
	
	        // Close on backdrop click
	        opts.backdrop && opts.backdrop.on('click', onBackdropClick);
	
	        // Escape to close
	        // Cycling of options, and closing on enter
	        dropDown.on('keydown', onMenuKeyDown);
	        dropDown.on('click', checkCloseMenu);
	
	        return function cleanupInteraction() {
	          opts.backdrop && opts.backdrop.off('click', onBackdropClick);
	          dropDown.off('keydown', onMenuKeyDown);
	          dropDown.off('click', checkCloseMenu);
	
	          element.removeClass('md-clickable');
	          opts.isRemoved = true;
	        };
	
	        // ************************************
	        // Closure Functions
	        // ************************************
	
	        function onBackdropClick(e) {
	          e.preventDefault();
	          e.stopPropagation();
	          opts.restoreFocus = false;
	          $mdUtil.nextTick($mdSelect.hide, true);
	        }
	
	        function onMenuKeyDown(ev) {
	          ev.preventDefault();
	          ev.stopPropagation();
	
	          switch (ev.keyCode) {
	            case keyCodes.UP_ARROW:
	              return focusPrevOption();
	            case keyCodes.DOWN_ARROW:
	              return focusNextOption();
	            case keyCodes.SPACE:
	            case keyCodes.ENTER:
	              if (opts.focusedNode) {
	                dropDown.triggerHandler({
	                  type: 'click',
	                  target: opts.focusedNode
	                });
	                ev.preventDefault();
	              }
	              checkCloseMenu(ev);
	              break;
	            case keyCodes.TAB:
	            case keyCodes.ESCAPE:
	              ev.stopPropagation();
	              ev.preventDefault();
	              opts.restoreFocus = true;
	              $mdUtil.nextTick($mdSelect.hide, true);
	              break;
	            default:
	              if (shouldHandleKey(ev, $mdConstant)) {
	                var optNode = selectMenuController.optNodeForKeyboardSearch(ev);
	                if (optNode && !optNode.hasAttribute('disabled')) {
	                  focusOptionNode(opts.focusedNode, optNode, selectMenuController);
	                }
	              }
	          }
	        }
	
	        /**
	         * Change the focus to another option. If there is no focused option, focus the first
	         * option. If there is a focused option, then use the direction to determine if we should
	         * focus the previous or next option in the list.
	         * @param {'next'|'prev'} direction
	         */
	        function focusOption(direction) {
	          var optionsArray = $mdUtil.nodesToArray(opts.optionNodes);
	          var index = optionsArray.indexOf(opts.focusedNode);
	          var prevOption = optionsArray[index];
	          var newOption;
	
	          do {
	            if (index === -1) {
	              // We lost the previously focused element, reset to first option
	              index = 0;
	            } else if (direction === 'next' && index < optionsArray.length - 1) {
	              index++;
	            } else if (direction === 'prev' && index > 0) {
	              index--;
	            }
	            newOption = optionsArray[index];
	            if (newOption.hasAttribute('disabled')) {
	              newOption = null;
	            }
	          } while (!newOption && index < optionsArray.length - 1 && index > 0);
	
	          focusOptionNode(prevOption, newOption, selectMenuController);
	        }
	
	        function focusNextOption() {
	          focusOption('next');
	        }
	
	        function focusPrevOption() {
	          focusOption('prev');
	        }
	
	        /**
	         * @param {KeyboardEvent|MouseEvent} event
	         */
	        function checkCloseMenu(event) {
	          if (event && (event.type === 'click') && (event.currentTarget !== dropDown[0])) {
	            return;
	          }
	          if (mouseOnScrollbar()) {
	            return;
	          }
	
	          if (opts.focusedNode && opts.focusedNode.hasAttribute &&
	              !opts.focusedNode.hasAttribute('disabled')) {
	            event.preventDefault();
	            event.stopPropagation();
	            if (!selectMenuController.isMultiple) {
	              opts.restoreFocus = true;
	
	              $mdUtil.nextTick(function () {
	                $mdSelect.hide(selectMenuController.ngModel.$viewValue);
	                opts.focusedNode.classList.remove('md-focused');
	              }, true);
	            }
	          }
	
	          /**
	           * check if the mouseup event was on a scrollbar
	           */
	          function mouseOnScrollbar() {
	            var clickOnScrollbar = false;
	            if (event && (event.currentTarget.children.length > 0)) {
	              var child = event.currentTarget.children[0];
	              var hasScrollbar = child.scrollHeight > child.clientHeight;
	              if (hasScrollbar && child.children.length > 0) {
	                var relPosX = event.pageX - event.currentTarget.getBoundingClientRect().left;
	                if (relPosX > child.querySelector('md-option').offsetWidth)
	                  clickOnScrollbar = true;
	              }
	            }
	            return clickOnScrollbar;
	          }
	        }
	      }
	    }
	
	    /**
	     * To notify listeners that the Select menu has closed,
	     * trigger the [optional] user-defined expression
	     */
	    function announceClosed(opts) {
	      var mdSelect = opts.selectCtrl;
	      if (mdSelect) {
	        var menuController = opts.selectEl.controller('mdSelectMenu');
	        mdSelect.setSelectValueText(menuController ? menuController.getSelectedLabels() : '');
	        mdSelect.triggerClose();
	      }
	    }
	
	
	    /**
	     * Calculate the menu positions after an event like options changing, screen resizing, or
	     * animations finishing.
	     * @param {Object} scope
	     * @param element
	     * @param opts
	     * @return {{container: {styles: {top: number, left: number, 'font-size': *, 'min-width': number}, element: Object}, dropDown: {styles: {transform: string, transformOrigin: string}, element: Object}}}
	     */
	    function calculateMenuPositions(scope, element, opts) {
	      var
	        containerNode = element[0],
	        targetNode = opts.target[0].children[0], // target the label
	        parentNode = $document[0].body,
	        selectNode = opts.selectEl[0],
	        contentNode = opts.contentEl[0],
	        parentRect = parentNode.getBoundingClientRect(),
	        targetRect = targetNode.getBoundingClientRect(),
	        shouldOpenAroundTarget = false,
	        bounds = {
	          left: parentRect.left + SELECT_EDGE_MARGIN,
	          top: SELECT_EDGE_MARGIN,
	          bottom: parentRect.height - SELECT_EDGE_MARGIN,
	          right: parentRect.width - SELECT_EDGE_MARGIN - ($mdUtil.floatingScrollbars() ? 16 : 0)
	        },
	        spaceAvailable = {
	          top: targetRect.top - bounds.top,
	          left: targetRect.left - bounds.left,
	          right: bounds.right - (targetRect.left + targetRect.width),
	          bottom: bounds.bottom - (targetRect.top + targetRect.height)
	        },
	        maxWidth = parentRect.width - SELECT_EDGE_MARGIN * 2,
	        selectedNode = selectNode.querySelector('md-option[selected]'),
	        optionNodes = selectNode.getElementsByTagName('md-option'),
	        optgroupNodes = selectNode.getElementsByTagName('md-optgroup'),
	        isScrollable = calculateScrollable(element, contentNode),
	        centeredNode;
	
	      var loading = isPromiseLike(opts.loadingAsync);
	      if (!loading) {
	        // If a selected node, center around that
	        if (selectedNode) {
	          centeredNode = selectedNode;
	          // If there are option groups, center around the first option group
	        } else if (optgroupNodes.length) {
	          centeredNode = optgroupNodes[0];
	          // Otherwise - if we are not loading async - center around the first optionNode
	        } else if (optionNodes.length) {
	          centeredNode = optionNodes[0];
	          // In case there are no options, center on whatever's in there... (eg progress indicator)
	        } else {
	          centeredNode = contentNode.firstElementChild || contentNode;
	        }
	      } else {
	        // If loading, center on progress indicator
	        centeredNode = contentNode.firstElementChild || contentNode;
	      }
	
	      if (contentNode.offsetWidth > maxWidth) {
	        contentNode.style['max-width'] = maxWidth + 'px';
	      } else {
	        contentNode.style.maxWidth = null;
	      }
	      if (shouldOpenAroundTarget) {
	        contentNode.style['min-width'] = targetRect.width + 'px';
	      }
	
	      // Remove padding before we compute the position of the menu
	      if (isScrollable) {
	        selectNode.classList.add('md-overflow');
	      }
	
	      var focusedNode = centeredNode;
	      if ((focusedNode.tagName || '').toUpperCase() === 'MD-OPTGROUP') {
	        focusedNode = optionNodes[0] || contentNode.firstElementChild || contentNode;
	        centeredNode = focusedNode;
	      }
	      // Cache for autoFocus()
	      opts.focusedNode = focusedNode;
	
	      // Get the selectMenuRect *after* max-width is possibly set above
	      containerNode.style.display = 'block';
	      var selectMenuRect = selectNode.getBoundingClientRect();
	      var centeredRect = getOffsetRect(centeredNode);
	
	      if (centeredNode) {
	        var centeredStyle = $window.getComputedStyle(centeredNode);
	        centeredRect.paddingLeft = parseInt(centeredStyle.paddingLeft, 10) || 0;
	        centeredRect.paddingRight = parseInt(centeredStyle.paddingRight, 10) || 0;
	      }
	
	      if (isScrollable) {
	        var scrollBuffer = contentNode.offsetHeight / 2;
	        contentNode.scrollTop = centeredRect.top + centeredRect.height / 2 - scrollBuffer;
	
	        if (spaceAvailable.top < scrollBuffer) {
	          contentNode.scrollTop = Math.min(
	            centeredRect.top,
	            contentNode.scrollTop + scrollBuffer - spaceAvailable.top
	          );
	        } else if (spaceAvailable.bottom < scrollBuffer) {
	          contentNode.scrollTop = Math.max(
	            centeredRect.top + centeredRect.height - selectMenuRect.height,
	            contentNode.scrollTop - scrollBuffer + spaceAvailable.bottom
	          );
	        }
	      }
	
	      var left, top, transformOrigin, minWidth, fontSize;
	      if (shouldOpenAroundTarget) {
	        left = targetRect.left;
	        top = targetRect.top + targetRect.height;
	        transformOrigin = '50% 0';
	        if (top + selectMenuRect.height > bounds.bottom) {
	          top = targetRect.top - selectMenuRect.height;
	          transformOrigin = '50% 100%';
	        }
	      } else {
	        left = (targetRect.left + centeredRect.left - centeredRect.paddingLeft);
	        top = Math.floor(targetRect.top + targetRect.height / 2 - centeredRect.height / 2 -
	            centeredRect.top + contentNode.scrollTop) + 2;
	
	        transformOrigin = (centeredRect.left + targetRect.width / 2) + 'px ' +
	          (centeredRect.top + centeredRect.height / 2 - contentNode.scrollTop) + 'px 0px';
	
	        minWidth = Math.min(targetRect.width + centeredRect.paddingLeft + centeredRect.paddingRight, maxWidth);
	
	        fontSize = window.getComputedStyle(targetNode)['font-size'];
	      }
	
	      // Keep left and top within the window
	      var containerRect = containerNode.getBoundingClientRect();
	      var scaleX = Math.round(100 * Math.min(targetRect.width / selectMenuRect.width, 1.0)) / 100;
	      var scaleY = Math.round(100 * Math.min(targetRect.height / selectMenuRect.height, 1.0)) / 100;
	
	      return {
	        container: {
	          element: angular.element(containerNode),
	          styles: {
	            left: Math.floor(clamp(bounds.left, left, bounds.right - minWidth)),
	            top: Math.floor(clamp(bounds.top, top, bounds.bottom - containerRect.height)),
	            'min-width': minWidth,
	            'font-size': fontSize
	          }
	        },
	        dropDown: {
	          element: angular.element(selectNode),
	          styles: {
	            transformOrigin: transformOrigin,
	            transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : ""
	          }
	        }
	      };
	    }
	  }
	
	  function isPromiseLike(obj) {
	    return obj && angular.isFunction(obj.then);
	  }
	
	  function clamp(min, n, max) {
	    return Math.max(min, Math.min(n, max));
	  }
	
	  function getOffsetRect(node) {
	    return node ? {
	      left: node.offsetLeft,
	      top: node.offsetTop,
	      width: node.offsetWidth,
	      height: node.offsetHeight
	    } : {left: 0, top: 0, width: 0, height: 0};
	  }
	
	  function calculateScrollable(element, contentNode) {
	    var isScrollable = false;
	
	    try {
	      var oldDisplay = element[0].style.display;
	
	      // Set the element's display to block so that this calculation is correct
	      element[0].style.display = 'block';
	
	      isScrollable = contentNode.scrollHeight > contentNode.offsetHeight;
	
	      // Reset it back afterwards
	      element[0].style.display = oldDisplay;
	    } finally {
	      // Nothing to do
	    }
	    return isScrollable;
	  }
	}
	
	function shouldHandleKey(ev, $mdConstant) {
	  var char = String.fromCharCode(ev.keyCode);
	  var isNonUsefulKey = (ev.keyCode <= 31);
	
	  return (char && char.length && !isNonUsefulKey &&
	    !$mdConstant.isMetaKey(ev) && !$mdConstant.isFnLockKey(ev) && !$mdConstant.hasModifierKey(ev));
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.showHide
	 */
	
	// Add additional handlers to ng-show and ng-hide that notify directives
	// contained within that they should recompute their size.
	// These run in addition to AngularJS's built-in ng-hide and ng-show directives.
	angular.module('material.components.showHide', [
	  'material.core'
	])
	  .directive('ngShow', createDirective('ngShow', true))
	  .directive('ngHide', createDirective('ngHide', false));
	
	
	function createDirective(name, targetValue) {
	  return ['$mdUtil', '$window', function($mdUtil, $window) {
	    return {
	      restrict: 'A',
	      multiElement: true,
	      link: function($scope, $element, $attr) {
	        var unregister = $scope.$on('$md-resize-enable', function() {
	          unregister();
	
	          var node = $element[0];
	          var cachedTransitionStyles = node.nodeType === $window.Node.ELEMENT_NODE ?
	            $window.getComputedStyle(node) : {};
	
	          $scope.$watch($attr[name], function(value) {
	            if (!!value === targetValue) {
	              $mdUtil.nextTick(function() {
	                $scope.$broadcast('$md-resize');
	              });
	
	              var opts = {
	                cachedTransitionStyles: cachedTransitionStyles
	              };
	
	              $mdUtil.dom.animator.waitTransitionEnd($element, opts).then(function() {
	                $scope.$broadcast('$md-resize');
	              });
	            }
	          });
	        });
	      }
	    };
	  }];
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.sidenav
	 *
	 * @description
	 * A Sidenav component.
	 */
	SidenavService.$inject = ["$mdComponentRegistry", "$mdUtil", "$q", "$log"];
	SidenavDirective.$inject = ["$mdMedia", "$mdUtil", "$mdConstant", "$mdTheming", "$mdInteraction", "$animate", "$compile", "$parse", "$log", "$q", "$document", "$window", "$$rAF"];
	SidenavController.$inject = ["$scope", "$attrs", "$mdComponentRegistry", "$q", "$interpolate"];
	angular
	  .module('material.components.sidenav', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .factory('$mdSidenav', SidenavService)
	  .directive('mdSidenav', SidenavDirective)
	  .controller('$mdSidenavController', SidenavController);
	
	
	/**
	 * @ngdoc service
	 * @name $mdSidenav
	 * @module material.components.sidenav
	 *
	 * @description
	 * `$mdSidenav` makes it easy to interact with multiple sidenavs in an app. When looking up a
	 * sidenav instance, you can either look it up synchronously or wait for it to be initialized
	 * asynchronously. This is done by passing the second argument to `$mdSidenav`.
	 *
	 * @usage
	 * <hljs lang="js">
	 * // Async lookup for sidenav instance; will resolve when the instance is available
	 * $mdSidenav(componentId, true).then(function(instance) {
	 *   $log.debug( componentId + "is now ready" );
	 * });
	 * // Sync lookup for sidenav instance; this will resolve immediately.
	 * $mdSidenav(componentId).then(function(instance) {
	 *   $log.debug( componentId + "is now ready" );
	 * });
	 * // Async toggle the given sidenav;
	 * // when instance is known ready and lazy lookup is not needed.
	 * $mdSidenav(componentId)
	 *    .toggle()
	 *    .then(function(){
	 *      $log.debug('toggled');
	 *    });
	 * // Async open the given sidenav
	 * $mdSidenav(componentId)
	 *    .open()
	 *    .then(function(){
	 *      $log.debug('opened');
	 *    });
	 * // Async close the given sidenav
	 * $mdSidenav(componentId)
	 *    .close()
	 *    .then(function(){
	 *      $log.debug('closed');
	 *    });
	 * // Async lookup for sidenav instance
	 * $mdSidenav(componentId, true).then(function(instance) {
	 *   // On close callback to handle close, backdrop click, or escape key pressed.
	 *   // Callback happens BEFORE the close action occurs.
	 *   instance.onClose(function() {
	 *     $log.debug('closing');
	 *   });
	 * });
	 * // Sync check to see if the specified sidenav is set to be open
	 * $mdSidenav(componentId).isOpen();
	 * // Sync check to whether given sidenav is locked open
	 * // If this is true, the sidenav will be open regardless of close()
	 * $mdSidenav(componentId).isLockedOpen();
	 * </hljs>
	 */
	function SidenavService($mdComponentRegistry, $mdUtil, $q, $log) {
	  var errorMsg = "SideNav '{0}' is not available! Did you use md-component-id='{0}'?";
	  var service = {
	    find: findInstance,      //  sync  - returns proxy API
	    waitFor: waitForInstance //  async - returns promise
	  };
	
	  /**
	   * Service API that supports three (3) usages:
	   * $mdSidenav().find("left")               // sync (must already exist) or returns undefined
	   * $mdSidenav("left").toggle();            // sync (must already exist) or returns reject promise;
	   * $mdSidenav("left",true).then(function(left) { // async returns instance when available
	   *  left.toggle();
	   * });
	   */
	  return function(handle, enableWait) {
	    if (angular.isUndefined(handle)) {
	      return service;
	    }
	
	    var shouldWait = enableWait === true;
	    var instance = service.find(handle, shouldWait);
	    return !instance && shouldWait ? service.waitFor(handle) :
	           !instance && angular.isUndefined(enableWait) ? addLegacyAPI(service, handle) : instance;
	  };
	
	  /**
	   * For failed instance/handle lookups, older-clients expect an response object with noops
	   * that include `rejected promise APIs`
	   * @param service
	   * @param handle
	   * @returns {Object}
	   */
	  function addLegacyAPI(service, handle) {
	    var falseFn = function() {
	      return false;
	    };
	    var rejectFn = function() {
	      return $q.when($mdUtil.supplant(errorMsg, [handle || ""]));
	    };
	
	    return angular.extend({
	      isLockedOpen: falseFn,
	      isOpen: falseFn,
	      toggle: rejectFn,
	      open: rejectFn,
	      close: rejectFn,
	      onClose: angular.noop,
	      then: function(callback) {
	        return waitForInstance(handle).then(callback || angular.noop);
	      }
	    }, service);
	  }
	
	  /**
	   * Synchronously lookup the controller instance for the specified sidNav instance which has been
	   * registered with the markup `md-component-id`
	   */
	  function findInstance(handle, shouldWait) {
	    var instance = $mdComponentRegistry.get(handle);
	
	    if (!instance && !shouldWait) {
	      // Report missing instance
	      $log.error($mdUtil.supplant(errorMsg, [handle || ""]));
	
	      // The component has not registered itself... most like NOT yet created
	      // return null to indicate that the Sidenav is not in the DOM
	      return undefined;
	    }
	    return instance;
	  }
	
	  /**
	   * Asynchronously wait for the component instantiation,
	   * Deferred lookup of component instance using $component registry
	   */
	  function waitForInstance(handle) {
	    return $mdComponentRegistry.when(handle).catch($log.error);
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name mdSidenav
	 * @module material.components.sidenav
	 * @restrict E
	 *
	 * @description
	 * A Sidenav component that can be opened and closed programmatically.
	 *
	 * By default, upon opening it will slide out on top of the main content area.
	 *
	 * For keyboard and screen reader accessibility, focus is sent to the sidenav wrapper by default.
	 * It can be overridden with the `md-autofocus` directive on the child element you want focused.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div layout="row" ng-controller="MyController">
	 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
	 *     Left Nav!
	 *   </md-sidenav>
	 *
	 *   <md-content>
	 *     Center Content
	 *     <md-button ng-click="openLeftMenu()">
	 *       Open Left Menu
	 *     </md-button>
	 *   </md-content>
	 *
	 *   <md-sidenav md-component-id="right"
	 *     md-is-locked-open="$mdMedia('min-width: 333px')"
	 *     class="md-sidenav-right">
	 *     <form>
	 *       <md-input-container>
	 *         <label for="testInput">Test input</label>
	 *         <input id="testInput" type="text"
	 *                ng-model="data" md-autofocus>
	 *       </md-input-container>
	 *     </form>
	 *   </md-sidenav>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="js">
	 * var app = angular.module('myApp', ['ngMaterial']);
	 * app.controller('MyController', function($scope, $mdSidenav) {
	 *   $scope.openLeftMenu = function() {
	 *     $mdSidenav('left').toggle();
	 *   };
	 * });
	 * </hljs>
	 *
	 * @param {expression=} md-is-open A model bound to whether the sidenav is opened.
	 * @param {boolean=} md-disable-backdrop When present in the markup, the sidenav will not show a
	 *  backdrop.
	 * @param {boolean=} md-disable-close-events When present in the markup, clicking the backdrop or
	 *  pressing the 'Escape' key will not close the sidenav.
	 * @param {string=} md-component-id componentId to use with $mdSidenav service.
	 * @param {expression=} md-is-locked-open When this expression evaluates to true,
	 * the sidenav "locks open": it falls into the content's flow instead of appearing over it. This
	 * overrides the `md-is-open` attribute.
	 *
	 * The `$mdMedia()` service is exposed to the `md-is-locked-open` attribute, which
	 * can be given a media query or one of the `sm`, `gt-sm`, `md`, `gt-md`, `lg` or `gt-lg` presets.
	 * <br><br>Examples:
	 *
	 *   Lock open when `true`:<br>
	 *   `<md-sidenav md-is-locked-open="shouldLockOpen"></md-sidenav>`
	 *
	 *   Lock open when the width is `1000px` or greater:<br>
	 *   `<md-sidenav md-is-locked-open="$mdMedia('min-width: 1000px')"></md-sidenav>`
	 *
	 *   Lock open on small screens:<br>
	 *   `<md-sidenav md-is-locked-open="$mdMedia('sm')"></md-sidenav>`
	 *
	 * @param {string=} md-disable-scroll-target Selector, pointing to an element, whose scrolling will
	 * be disabled when the sidenav is opened. By default this is the sidenav's direct parent.
	 */
	function SidenavDirective($mdMedia, $mdUtil, $mdConstant, $mdTheming, $mdInteraction, $animate,
	                          $compile, $parse, $log, $q, $document, $window, $$rAF) {
	  return {
	    restrict: 'E',
	    scope: {
	      isOpen: '=?mdIsOpen'
	    },
	    controller: '$mdSidenavController',
	    compile: function(element) {
	      element.addClass('md-closed').attr('tabIndex', '-1');
	      return postLink;
	    }
	  };
	
	  /**
	   * Directive Post Link function...
	   */
	  function postLink(scope, element, attr, sidenavCtrl) {
	    var lastParentOverFlow;
	    var backdrop;
	    var disableScrollTarget = null;
	    var disableCloseEvents;
	    var triggeringInteractionType;
	    var triggeringElement = null;
	    var previousContainerStyles;
	    var promise = $q.when(true);
	    var isLockedOpenParsed = $parse(attr.mdIsLockedOpen);
	    var ngWindow = angular.element($window);
	    var isLocked = function() {
	      return isLockedOpenParsed(scope.$parent, {
	        $mdMedia: $mdMedia
	      });
	    };
	
	    if (attr.mdDisableScrollTarget) {
	      disableScrollTarget = $document[0].querySelector(attr.mdDisableScrollTarget);
	
	      if (disableScrollTarget) {
	        disableScrollTarget = angular.element(disableScrollTarget);
	      } else {
	        $log.warn($mdUtil.supplant('mdSidenav: couldn\'t find element matching ' +
	          'selector "{selector}". Falling back to parent.',
	          { selector: attr.mdDisableScrollTarget }));
	      }
	    }
	
	    if (!disableScrollTarget) {
	      disableScrollTarget = element.parent();
	    }
	
	    // Only create the backdrop if the backdrop isn't disabled.
	    if (!attr.hasOwnProperty('mdDisableBackdrop')) {
	      backdrop = $mdUtil.createBackdrop(scope, "md-sidenav-backdrop md-opaque ng-enter");
	    }
	
	    // If md-disable-close-events is set on the sidenav we will disable
	    // backdrop click and Escape key events
	    if (attr.hasOwnProperty('mdDisableCloseEvents')) {
	      disableCloseEvents = true;
	    }
	
	    element.addClass('_md');     // private md component indicator for styling
	    $mdTheming(element);
	
	    // The backdrop should inherit the sidenavs theme,
	    // because the backdrop will take its parent theme by default.
	    if (backdrop) $mdTheming.inherit(backdrop, element);
	
	    element.on('$destroy', function() {
	      backdrop && backdrop.remove();
	      sidenavCtrl.destroy();
	    });
	
	    scope.$on('$destroy', function(){
	      backdrop && backdrop.remove();
	    });
	
	    scope.$watch(isLocked, updateIsLocked);
	    scope.$watch('isOpen', updateIsOpen);
	
	
	    // Publish special accessor for the Controller instance
	    sidenavCtrl.$toggleOpen = toggleOpen;
	
	    /**
	     * Toggle the DOM classes to indicate `locked`
	     * @param isLocked
	     * @param oldValue
	     */
	    function updateIsLocked(isLocked, oldValue) {
	      scope.isLockedOpen = isLocked;
	      if (isLocked === oldValue) {
	        element.toggleClass('md-locked-open', !!isLocked);
	      } else {
	        $animate[isLocked ? 'addClass' : 'removeClass'](element, 'md-locked-open');
	      }
	      if (backdrop) {
	        backdrop.toggleClass('md-locked-open', !!isLocked);
	      }
	    }
	
	    /**
	     * Toggle the SideNav view and attach/detach listeners
	     * @param {boolean} isOpen
	     */
	    function updateIsOpen(isOpen) {
	      var focusEl = $mdUtil.findFocusTarget(element) || element;
	      var parent = element.parent();
	      var restorePositioning;
	
	      // If the user hasn't set the disable close events property we are adding
	      // click and escape events to close the sidenav
	      if (!disableCloseEvents) {
	        parent[isOpen ? 'on' : 'off']('keydown', onKeyDown);
	        if (backdrop) backdrop[isOpen ? 'on' : 'off']('click', close);
	      }
	
	      restorePositioning = updateContainerPositions(parent, isOpen);
	
	      if (isOpen) {
	        // Capture upon opening..
	        triggeringElement = $document[0].activeElement;
	        triggeringInteractionType = $mdInteraction.getLastInteractionType();
	      }
	
	      disableParentScroll(isOpen);
	
	      return promise = $q.all([
	        isOpen && backdrop ? $animate.enter(backdrop, parent) : backdrop ?
	                             $animate.leave(backdrop) : $q.when(true),
	        $animate[isOpen ? 'removeClass' : 'addClass'](element, 'md-closed')
	      ]).then(function() {
	        // Perform focus when animations are ALL done...
	        if (scope.isOpen) {
	          $$rAF(function() {
	            // Notifies child components that the sidenav was opened. Should wait
	            // a frame in order to allow for the element height to be computed.
	            ngWindow.triggerHandler('resize');
	          });
	
	          focusEl && focusEl.focus();
	        }
	
	        // Restores the positioning on the sidenav and backdrop.
	        restorePositioning && restorePositioning();
	      });
	    }
	
	    function updateContainerPositions(parent, willOpen) {
	      var drawerEl = element[0];
	      var scrollTop = parent[0].scrollTop;
	
	      if (willOpen && scrollTop) {
	        previousContainerStyles = {
	          top: drawerEl.style.top,
	          bottom: drawerEl.style.bottom,
	          height: drawerEl.style.height
	        };
	
	        // When the parent is scrolled down, then we want to be able to show the sidenav at the
	        // current scroll position. We're moving the sidenav down to the correct scroll position
	        // and apply the height of the parent, to increase the performance. Using 100% as height,
	        // will impact the performance heavily.
	        var positionStyle = {
	          top: scrollTop + 'px',
	          bottom: 'auto',
	          height: parent[0].clientHeight + 'px'
	        };
	
	        // Apply the new position styles to the sidenav and backdrop.
	        element.css(positionStyle);
	        backdrop.css(positionStyle);
	      }
	
	      // When the sidenav is closing and we have previous defined container styles,
	      // then we return a restore function, which resets the sidenav and backdrop.
	      if (!willOpen && previousContainerStyles) {
	        return function() {
	          drawerEl.style.top = previousContainerStyles.top;
	          drawerEl.style.bottom = previousContainerStyles.bottom;
	          drawerEl.style.height = previousContainerStyles.height;
	
	          backdrop[0].style.top = null;
	          backdrop[0].style.bottom = null;
	          backdrop[0].style.height = null;
	
	          previousContainerStyles = null;
	        };
	      }
	    }
	
	    /**
	     * Prevent parent scrolling (when the SideNav is open)
	     */
	    function disableParentScroll(disabled) {
	      if (disabled && !lastParentOverFlow) {
	        lastParentOverFlow = disableScrollTarget.css('overflow');
	        disableScrollTarget.css('overflow', 'hidden');
	      } else if (angular.isDefined(lastParentOverFlow)) {
	        disableScrollTarget.css('overflow', lastParentOverFlow);
	        lastParentOverFlow = undefined;
	      }
	    }
	
	    /**
	     * Toggle the sideNav view and publish a promise to be resolved when
	     * the view animation finishes.
	     * @param {boolean} isOpen true to open the sidenav, false to close it
	     * @returns {*} promise to be resolved when the view animation finishes
	     */
	    function toggleOpen(isOpen) {
	      if (scope.isOpen === isOpen) {
	        return $q.when(true);
	      } else {
	        if (scope.isOpen && sidenavCtrl.onCloseCb) sidenavCtrl.onCloseCb();
	
	        return $q(function(resolve) {
	          // Toggle value to force an async `updateIsOpen()` to run
	          scope.isOpen = isOpen;
	
	          $mdUtil.nextTick(function() {
	            // When the current `updateIsOpen()` animation finishes
	            promise.then(function(result) {
	
	              if (!scope.isOpen && triggeringElement && triggeringInteractionType === 'keyboard') {
	                // reset focus to originating element (if available) upon close
	                triggeringElement.focus();
	                triggeringElement = null;
	              }
	
	              resolve(result);
	            });
	          });
	        });
	      }
	    }
	
	    /**
	     * Auto-close sideNav when the `escape` key is pressed.
	     * @param {KeyboardEvent} ev keydown event
	     */
	    function onKeyDown(ev) {
	      var isEscape = (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE);
	      return isEscape ? close(ev) : $q.when(true);
	    }
	
	    /**
	     * With backdrop `clicks` or `escape` key-press, immediately apply the CSS close transition...
	     * Then notify the controller to close() and perform its own actions.
	     * @param {Event} ev
	     * @returns {*}
	     */
	    function close(ev) {
	      ev.preventDefault();
	
	      return sidenavCtrl.close();
	    }
	  }
	}
	
	/*
	 * @private
	 * @ngdoc controller
	 * @name SidenavController
	 * @module material.components.sidenav
	 */
	function SidenavController($scope, $attrs, $mdComponentRegistry, $q, $interpolate) {
	  var self = this;
	
	  // Use Default internal method until overridden by directive postLink
	
	  // Synchronous getters
	  self.isOpen = function() { return !!$scope.isOpen; };
	  self.isLockedOpen = function() { return !!$scope.isLockedOpen; };
	
	  // Synchronous setters
	  self.onClose = function (callback) {
	    self.onCloseCb = callback;
	    return self;
	  };
	
	  // Async actions
	  self.open   = function() { return self.$toggleOpen(true);  };
	  self.close  = function() { return self.$toggleOpen(false); };
	  self.toggle = function() { return self.$toggleOpen(!$scope.isOpen);  };
	  self.$toggleOpen = function(value) { return $q.when($scope.isOpen = value); };
	
	  // Evaluate the component id.
	  var rawId = $attrs.mdComponentId;
	  var hasDataBinding = rawId && rawId.indexOf($interpolate.startSymbol()) > -1;
	  var componentId = hasDataBinding ? $interpolate(rawId)($scope.$parent) : rawId;
	
	  // Register the component.
	  self.destroy = $mdComponentRegistry.register(self, componentId);
	
	  // Watch and update the component, if the id has changed.
	  if (hasDataBinding) {
	    $attrs.$observe('mdComponentId', function(id) {
	      if (id && id !== self.$$mdHandle) {
	        // `destroy` only deregisters the old component id so we can add the new one.
	        self.destroy();
	        self.destroy = $mdComponentRegistry.register(self, id);
	      }
	    });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.slider
	 */
	SliderDirective.$inject = ["$$rAF", "$window", "$mdAria", "$mdUtil", "$mdConstant", "$mdTheming", "$mdGesture", "$parse", "$log", "$timeout"];
	angular.module('material.components.slider', [
	  'material.core'
	])
	.directive('mdSlider', SliderDirective)
	.directive('mdSliderContainer', SliderContainerDirective);
	
	/**
	 * @type {number} the page size used for stepping when page up/down keys are pressed.
	 */
	var stepPageSize = 10;
	/**
	 * @type {number} the multiplier applied to a step when the arrow key is pressed along with
	 *  alt, meta, or ctrl.
	 */
	var modifierMultiplier = 4;
	
	/**
	 * @ngdoc directive
	 * @name mdSliderContainer
	 * @module material.components.slider
	 * @restrict E
	 * @description
	 * The `<md-slider-container>` can hold the slider with two other elements.
	 * In this case, the other elements are a `span` for the label and an `input` for displaying
	 * the model value.
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-slider-container>
	 *    <span>Red</span>
	 *    <md-slider min="0" max="255" ng-model="color.red" aria-label="red" id="red-slider">
	 *    </md-slider>
	 *    <md-input-container>
	 *      <input type="number" ng-model="color.red" aria-label="Red" aria-controls="red-slider">
	 *    </md-input-container>
	 *  </md-slider-container>
	 * </hljs>
	 */
	function SliderContainerDirective() {
	  return {
	    controller: function () {},
	    compile: function (elem) {
	      var slider = elem.find('md-slider');
	
	      if (!slider) {
	        return;
	      }
	
	      var vertical = slider.attr('md-vertical');
	
	      if (vertical !== undefined) {
	        elem.attr('md-vertical', '');
	      }
	
	      if (!slider.attr('flex')) {
	        slider.attr('flex', '');
	      }
	
	      return function postLink(scope, element, attr, ctrl) {
	        element.addClass('_md');     // private md component indicator for styling
	
	        // We have to manually stop the $watch on ngDisabled because it exists
	        // on the parent scope, and won't be automatically destroyed when
	        // the component is destroyed.
	        function setDisable(value) {
	          element.children().attr('disabled', value);
	          element.find('input').attr('disabled', value);
	        }
	
	        var stopDisabledWatch = angular.noop;
	
	        if (attr.disabled) {
	          setDisable(true);
	        }
	        else if (attr.ngDisabled) {
	          stopDisabledWatch = scope.$watch(attr.ngDisabled, function (value) {
	            setDisable(value);
	          });
	        }
	
	        scope.$on('$destroy', function () {
	          stopDisabledWatch();
	        });
	
	        var initialMaxWidth;
	
	        /**
	         * @param {number} length of the input's string value
	         */
	        ctrl.fitInputWidthToTextLength = function (length) {
	          var input = element[0].querySelector('md-input-container');
	
	          if (input) {
	            var computedStyle = getComputedStyle(input);
	            var minWidth = parseInt(computedStyle.minWidth);
	            var padding = parseInt(computedStyle.paddingLeft) + parseInt(computedStyle.paddingRight);
	
	            initialMaxWidth = initialMaxWidth || parseInt(computedStyle.maxWidth);
	            var newMaxWidth = Math.max(initialMaxWidth, minWidth + padding + (minWidth / 2 * length));
	
	            input.style.maxWidth = newMaxWidth + 'px';
	          }
	        };
	      };
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name mdSlider
	 * @module material.components.slider
	 * @restrict E
	 * @description
	 * The `<md-slider>` component allows the user to choose from a range of values.
	 *
	 * As per the [Material Design spec](https://material.io/archive/guidelines/style/color.html#color-color-system)
	 * the slider is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * The slider has two modes:
	 * - "normal" mode where the user slides between a wide range of values
	 * - "discrete" mode where the user slides between only a few select values
	 *
	 * To enable discrete mode, add the `md-discrete` attribute to a slider
	 * and use the `step` attribute to change the distance between
	 * values the user is allowed to pick.
	 *
	 * When using the keyboard:
	 * - pressing the arrow keys will increase or decrease the slider's value by one step
	 * - holding the Meta, Control, or Alt key while pressing the arrow keys will
	 *   move the slider four steps at a time
	 * - pressing the Home key will move the slider to the first allowed value
	 * - pressing the End key will move the slider to the last allowed value
	 * - pressing the Page Up key will increase the slider value by ten
	 * - pressing the Page Down key will decrease the slider value by ten
	 *
	 * @usage
	 * <h4>Normal Mode</h4>
	 * <hljs lang="html">
	 * <md-slider ng-model="myValue" min="5" max="500">
	 * </md-slider>
	 * </hljs>
	 * <h4>Discrete Mode</h4>
	 * <hljs lang="html">
	 * <md-slider md-discrete ng-model="myDiscreteValue" step="10" min="10" max="130">
	 * </md-slider>
	 * </hljs>
	 * <h4>Invert Mode</h4>
	 * <hljs lang="html">
	 * <md-slider md-invert ng-model="myValue" step="10" min="10" max="130">
	 * </md-slider>
	 * </hljs>
	 *
	 * @param {expression} ng-model Assignable angular expression to be data-bound.
	 *  The expression should evaluate to a `number`.
	 * @param {expression=} ng-disabled If this expression evaluates as truthy, the slider will be
	 *  disabled.
	 * @param {expression=} ng-readonly If this expression evaluates as truthy, the slider will be in
	 *  read only mode.
	 * @param {boolean=} md-discrete If this attribute exists during initialization, enable discrete
	 *  mode. Defaults to `false`.
	 * @param {boolean=} md-vertical If this attribute exists during initialization, enable vertical
	 *  orientation mode. Defaults to `false`.
	 * @param {boolean=} md-invert If this attribute exists during initialization, enable inverted mode.
	 *  Defaults to `false`.
	 * @param {number=} step The distance between values the user is allowed to pick. Defaults to `1`.
	 * @param {number=} min The minimum value the user is allowed to pick. Defaults to `0`.
	 * @param {number=} max The maximum value the user is allowed to pick. Defaults to `100`.
	 * @param {number=} round The amount of numbers after the decimal point. The maximum is 6 to
	 *  prevent scientific notation. Defaults to `3`.
	 */
	function SliderDirective($$rAF, $window, $mdAria, $mdUtil, $mdConstant, $mdTheming, $mdGesture,
	                         $parse, $log, $timeout) {
	  return {
	    scope: {},
	    require: ['?ngModel', '?^mdSliderContainer'],
	    template:
	      '<div class="md-slider-wrapper">' +
	        '<div class="md-slider-content">' +
	          '<div class="md-track-container">' +
	            '<div class="md-track"></div>' +
	            '<div class="md-track md-track-fill"></div>' +
	            '<div class="md-track-ticks"></div>' +
	          '</div>' +
	          '<div class="md-thumb-container">' +
	            '<div class="md-thumb"></div>' +
	            '<div class="md-focus-thumb"></div>' +
	            '<div class="md-focus-ring"></div>' +
	            '<div class="md-sign">' +
	              '<span class="md-thumb-text"></span>' +
	            '</div>' +
	            '<div class="md-disabled-thumb"></div>' +
	          '</div>' +
	        '</div>' +
	      '</div>',
	    compile: compile
	  };
	
	  // **********************************************************
	  // Private Methods
	  // **********************************************************
	
	  function compile (tElement, tAttrs) {
	    var wrapper = angular.element(tElement[0].getElementsByClassName('md-slider-wrapper'));
	
	    var tabIndex = tAttrs.tabindex || 0;
	    wrapper.attr('tabindex', tabIndex);
	
	    if (tAttrs.disabled || tAttrs.ngDisabled) wrapper.attr('tabindex', -1);
	
	    wrapper.attr('role', 'slider');
	
	    $mdAria.expect(tElement, 'aria-label');
	
	    return postLink;
	  }
	
	  function postLink(scope, element, attr, ctrls) {
	    $mdTheming(element);
	    var ngModelCtrl = ctrls[0] || {
	      // Mock ngModelController if it doesn't exist to give us
	      // the minimum functionality needed
	      $setViewValue: function(val) {
	        this.$viewValue = val;
	        this.$viewChangeListeners.forEach(function(cb) { cb(); });
	      },
	      $parsers: [],
	      $formatters: [],
	      $viewChangeListeners: []
	    };
	
	    var containerCtrl = ctrls[1];
	    var container = angular.element($mdUtil.getClosest(element, '_md-slider-container', true));
	    var isDisabled = attr.ngDisabled ? angular.bind(null, $parse(attr.ngDisabled), scope.$parent) : function () {
	          return element[0].hasAttribute('disabled');
	        };
	
	    var thumb = angular.element(element[0].querySelector('.md-thumb'));
	    var thumbText = angular.element(element[0].querySelector('.md-thumb-text'));
	    var thumbContainer = thumb.parent();
	    var trackContainer = angular.element(element[0].querySelector('.md-track-container'));
	    var activeTrack = angular.element(element[0].querySelector('.md-track-fill'));
	    var tickContainer = angular.element(element[0].querySelector('.md-track-ticks'));
	    var wrapper = angular.element(element[0].getElementsByClassName('md-slider-wrapper'));
	    var content = angular.element(element[0].getElementsByClassName('md-slider-content'));
	    var throttledRefreshDimensions = $mdUtil.throttle(refreshSliderDimensions, 5000);
	
	    // Default values, overridable by attrs
	    var DEFAULT_ROUND = 3;
	    var vertical = angular.isDefined(attr.mdVertical);
	    var discrete = angular.isDefined(attr.mdDiscrete);
	    var invert = angular.isDefined(attr.mdInvert);
	    angular.isDefined(attr.min) ? attr.$observe('min', updateMin) : updateMin(0);
	    angular.isDefined(attr.max) ? attr.$observe('max', updateMax) : updateMax(100);
	    angular.isDefined(attr.step)? attr.$observe('step', updateStep) : updateStep(1);
	    angular.isDefined(attr.round)? attr.$observe('round', updateRound) : updateRound(DEFAULT_ROUND);
	
	    // We have to manually stop the $watch on ngDisabled because it exists
	    // on the parent scope, and won't be automatically destroyed when
	    // the component is destroyed.
	    var stopDisabledWatch = angular.noop;
	    if (attr.ngDisabled) {
	      stopDisabledWatch = scope.$parent.$watch(attr.ngDisabled, updateAriaDisabled);
	    }
	
	    $mdGesture.register(wrapper, 'drag', { horizontal: !vertical });
	
	    scope.mouseActive = false;
	
	    wrapper
	      .on('keydown', keydownListener)
	      .on('mousedown', mouseDownListener)
	      .on('focus', focusListener)
	      .on('blur', blurListener)
	      .on('$md.pressdown', onPressDown)
	      .on('$md.pressup', onPressUp)
	      .on('$md.dragstart', onDragStart)
	      .on('$md.drag', onDrag)
	      .on('$md.dragend', onDragEnd);
	
	    // On resize, recalculate the slider's dimensions and re-render
	    function updateAll() {
	      refreshSliderDimensions();
	      ngModelRender();
	    }
	    setTimeout(updateAll, 0);
	
	    var debouncedUpdateAll = $$rAF.throttle(updateAll);
	    angular.element($window).on('resize', debouncedUpdateAll);
	
	    scope.$on('$destroy', function() {
	      angular.element($window).off('resize', debouncedUpdateAll);
	    });
	
	    ngModelCtrl.$render = ngModelRender;
	    ngModelCtrl.$viewChangeListeners.push(ngModelRender);
	    ngModelCtrl.$formatters.push(minMaxValidator);
	    ngModelCtrl.$formatters.push(stepValidator);
	
	    /**
	     * Attributes
	     */
	    var min;
	    var max;
	    var step;
	    var round;
	    function updateMin(value) {
	      min = parseFloat(value);
	      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$modelValue, min, max);
	      wrapper.attr('aria-valuemin', value);
	      updateAll();
	    }
	    function updateMax(value) {
	      max = parseFloat(value);
	      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$modelValue, min, max);
	      wrapper.attr('aria-valuemax', value);
	      updateAll();
	    }
	    function updateStep(value) {
	      step = parseFloat(value);
	    }
	    function updateRound(value) {
	      // Set max round digits to 6, after 6 the input uses scientific notation
	      round = minMaxValidator(parseInt(value), 0, 6);
	    }
	    function updateAriaDisabled() {
	      element.attr('aria-disabled', !!isDisabled());
	    }
	
	    // Draw the ticks with canvas.
	    // The alternative to drawing ticks with canvas is to draw one element for each tick,
	    // which could quickly become a performance bottleneck.
	    var tickCanvas, tickCtx;
	    function redrawTicks() {
	      if (!discrete || isDisabled()) return;
	      if (angular.isUndefined(step))         return;
	
	      if (step <= 0) {
	        var msg = 'Slider step value must be greater than zero when in discrete mode';
	        $log.error(msg);
	        throw new Error(msg);
	      }
	
	      var numSteps = Math.floor((max - min) / step);
	      if (!tickCanvas) {
	        tickCanvas = angular.element('<canvas>').css('position', 'absolute');
	        tickContainer.append(tickCanvas);
	
	        tickCtx = tickCanvas[0].getContext('2d');
	      }
	
	      var dimensions = getSliderDimensions();
	
	      // If `dimensions` doesn't have height and width it might be the first attempt so we will refresh dimensions
	      if (dimensions && !dimensions.height && !dimensions.width) {
	        refreshSliderDimensions();
	        dimensions = sliderDimensions;
	      }
	
	      tickCanvas[0].width = dimensions.width;
	      tickCanvas[0].height = dimensions.height;
	
	      var distance;
	      for (var i = 0; i <= numSteps; i++) {
	        var trackTicksStyle = $window.getComputedStyle(tickContainer[0]);
	        tickCtx.fillStyle = trackTicksStyle.color || 'black';
	
	        distance = Math.floor((vertical ? dimensions.height : dimensions.width) * (i / numSteps));
	
	        tickCtx.fillRect(vertical ? 0 : distance - 1,
	          vertical ? distance - 1 : 0,
	          vertical ? dimensions.width : 2,
	          vertical ? 2 : dimensions.height);
	      }
	    }
	
	    function clearTicks() {
	      if (tickCanvas && tickCtx) {
	        var dimensions = getSliderDimensions();
	        tickCtx.clearRect(0, 0, dimensions.width, dimensions.height);
	      }
	    }
	
	    /**
	     * Refreshing Dimensions
	     */
	    var sliderDimensions = {};
	    refreshSliderDimensions();
	    function refreshSliderDimensions() {
	      sliderDimensions = trackContainer[0].getBoundingClientRect();
	    }
	    function getSliderDimensions() {
	      throttledRefreshDimensions();
	      return sliderDimensions;
	    }
	
	    /**
	     * left/right/up/down arrow listener
	     * @param {!KeyboardEvent} ev
	     */
	    function keydownListener(ev) {
	      if (isDisabled()) return;
	      var keyCodes = $mdConstant.KEY_CODE;
	
	      var changeAmount;
	      switch (ev.keyCode) {
	        case keyCodes.DOWN_ARROW:
	        case keyCodes.LEFT_ARROW:
	          ev.preventDefault();
	          changeAmount = -step;
	          break;
	        case keyCodes.UP_ARROW:
	        case keyCodes.RIGHT_ARROW:
	          ev.preventDefault();
	          changeAmount = step;
	          break;
	        case keyCodes.PAGE_DOWN:
	          ev.preventDefault();
	          changeAmount = -step * stepPageSize;
	          break;
	        case keyCodes.PAGE_UP:
	          ev.preventDefault();
	          changeAmount = step * stepPageSize;
	          break;
	        case keyCodes.HOME:
	          ev.preventDefault();
	          ev.stopPropagation();
	          updateValue(min);
	          break;
	        case keyCodes.END:
	          ev.preventDefault();
	          ev.stopPropagation();
	          updateValue(max);
	          break;
	      }
	      if (changeAmount) {
	        changeAmount = invert ? -changeAmount : changeAmount;
	        if (ev.metaKey || ev.ctrlKey || ev.altKey) {
	          changeAmount *= modifierMultiplier;
	        }
	        ev.preventDefault();
	        ev.stopPropagation();
	        updateValue(ngModelCtrl.$viewValue + changeAmount);
	      }
	    }
	
	    /**
	     * @param value new slider value used for setting the model value
	     */
	    function updateValue(value) {
	      scope.$evalAsync(function() {
	        setModelValue(value);
	      });
	    }
	
	    function mouseDownListener() {
	      redrawTicks();
	
	      scope.mouseActive = true;
	      wrapper.removeClass('md-focused');
	
	      $timeout(function() {
	        scope.mouseActive = false;
	      }, 100);
	    }
	
	    function focusListener() {
	      if (scope.mouseActive === false) {
	        wrapper.addClass('md-focused');
	      }
	    }
	
	    function blurListener() {
	      wrapper.removeClass('md-focused');
	      element.removeClass('md-active');
	      clearTicks();
	    }
	
	    /**
	     * ngModel setters and validators
	     */
	    function setModelValue(value) {
	      ngModelCtrl.$setViewValue(minMaxValidator(stepValidator(value)));
	    }
	    function ngModelRender() {
	      if (isNaN(ngModelCtrl.$viewValue)) {
	        ngModelCtrl.$viewValue = ngModelCtrl.$modelValue;
	      }
	
	      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$viewValue);
	
	      var percent = valueToPercent(ngModelCtrl.$viewValue);
	      scope.modelValue = ngModelCtrl.$viewValue;
	      wrapper.attr('aria-valuenow', ngModelCtrl.$viewValue);
	      setSliderPercent(percent);
	      thumbText.text(ngModelCtrl.$viewValue);
	    }
	
	    function minMaxValidator(value, minValue, maxValue) {
	      if (angular.isNumber(value)) {
	        minValue = angular.isNumber(minValue) ? minValue : min;
	        maxValue = angular.isNumber(maxValue) ? maxValue : max;
	
	        return Math.max(minValue, Math.min(maxValue, value));
	      }
	    }
	
	    function stepValidator(value) {
	      if (angular.isNumber(value)) {
	        var formattedValue = (Math.round((value - min) / step) * step + min);
	        formattedValue = (Math.round(formattedValue * Math.pow(10, round)) / Math.pow(10, round));
	
	        if (containerCtrl && containerCtrl.fitInputWidthToTextLength) {
	          $mdUtil.debounce(function () {
	            containerCtrl.fitInputWidthToTextLength(formattedValue.toString().length);
	          }, 100)();
	        }
	
	        return formattedValue;
	      }
	    }
	
	    /**
	     * @param {number} percent 0-1
	     */
	    function setSliderPercent(percent) {
	
	      percent = clamp(percent);
	
	      var thumbPosition = (percent * 100) + '%';
	      var activeTrackPercent = invert ? (1 - percent) * 100 + '%' : thumbPosition;
	
	      if (vertical) {
	        thumbContainer.css('bottom', thumbPosition);
	      }
	      else {
	        $mdUtil.bidiProperty(thumbContainer, 'left', 'right', thumbPosition);
	      }
	
	
	      activeTrack.css(vertical ? 'height' : 'width', activeTrackPercent);
	
	      element.toggleClass((invert ? 'md-max' : 'md-min'), percent === 0);
	      element.toggleClass((invert ? 'md-min' : 'md-max'), percent === 1);
	    }
	
	    /**
	     * Slide listeners
	     */
	    var isDragging = false;
	
	    function onPressDown(ev) {
	      if (isDisabled()) return;
	
	      element.addClass('md-active');
	      element[0].focus();
	      refreshSliderDimensions();
	
	      var exactVal = percentToValue(positionToPercent(vertical ? ev.srcEvent.clientY : ev.srcEvent.clientX));
	      var closestVal = minMaxValidator(stepValidator(exactVal));
	      scope.$apply(function() {
	        setModelValue(closestVal);
	        setSliderPercent(valueToPercent(closestVal));
	      });
	    }
	    function onPressUp(ev) {
	      if (isDisabled()) return;
	
	      element.removeClass('md-dragging');
	
	      var exactVal = percentToValue(positionToPercent(vertical ? ev.srcEvent.clientY : ev.srcEvent.clientX));
	      var closestVal = minMaxValidator(stepValidator(exactVal));
	      scope.$apply(function() {
	        setModelValue(closestVal);
	        ngModelRender();
	      });
	    }
	    function onDragStart(ev) {
	      if (isDisabled()) return;
	      isDragging = true;
	
	      ev.stopPropagation();
	
	      element.addClass('md-dragging');
	      setSliderFromEvent(ev);
	    }
	    function onDrag(ev) {
	      if (!isDragging) return;
	      ev.stopPropagation();
	      setSliderFromEvent(ev);
	    }
	    function onDragEnd(ev) {
	      if (!isDragging) return;
	      ev.stopPropagation();
	      isDragging = false;
	    }
	
	    function setSliderFromEvent(ev) {
	      // While panning discrete, update only the
	      // visual positioning but not the model value.
	      if (discrete) adjustThumbPosition(vertical ? ev.srcEvent.clientY : ev.srcEvent.clientX);
	      else            doSlide(vertical ? ev.srcEvent.clientY : ev.srcEvent.clientX);
	    }
	
	    /**
	     * Slide the UI by changing the model value
	     * @param x
	     */
	    function doSlide(x) {
	      scope.$evalAsync(function() {
	        setModelValue(percentToValue(positionToPercent(x)));
	      });
	    }
	
	    /**
	     * Slide the UI without changing the model (while dragging/panning)
	     * @param x
	     */
	    function adjustThumbPosition(x) {
	      var exactVal = percentToValue(positionToPercent(x));
	      var closestVal = minMaxValidator(stepValidator(exactVal));
	      setSliderPercent(positionToPercent(x));
	      thumbText.text(closestVal);
	    }
	
	    /**
	    * Clamps the value to be between 0 and 1.
	    * @param {number} value The value to clamp.
	    * @returns {number}
	    */
	    function clamp(value) {
	      return Math.max(0, Math.min(value || 0, 1));
	    }
	
	    /**
	     * Convert position on slider to percentage value of offset from beginning...
	     * @param position
	     * @returns {number}
	     */
	    function positionToPercent(position) {
	      var offset = vertical ? sliderDimensions.top : sliderDimensions.left;
	      var size = vertical ? sliderDimensions.height : sliderDimensions.width;
	      var calc = (position - offset) / size;
	
	      if (!vertical && $mdUtil.isRtl(attr)) {
	        calc = 1 - calc;
	      }
	
	      return Math.max(0, Math.min(1, vertical ? 1 - calc : calc));
	    }
	
	    /**
	     * Convert percentage offset on slide to equivalent model value
	     * @param percent
	     * @returns {*}
	     */
	    function percentToValue(percent) {
	      var adjustedPercent = invert ? (1 - percent) : percent;
	      return (min + adjustedPercent * (max - min));
	    }
	
	    function valueToPercent(val) {
	      var percent = (val - min) / (max - min);
	      return invert ? (1 - percent) : percent;
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.sticky
	 * @description
	 * Sticky effects for md.
	 */
	MdSticky.$inject = ["$mdConstant", "$$rAF", "$mdUtil", "$compile"];
	angular
	  .module('material.components.sticky', [
	    'material.core',
	    'material.components.content'
	  ])
	  .factory('$mdSticky', MdSticky);
	
	/**
	 * @ngdoc service
	 * @name $mdSticky
	 * @module material.components.sticky
	 *
	 * @description
	 * The `$mdSticky` service provides the capability to make elements sticky, even when the browser
	 * does not support `position: sticky`.
	 *
	 * Whenever the current browser supports stickiness natively, the `$mdSticky` service will leverage
	 * the native browser's sticky functionality.
	 *
	 * By default the `$mdSticky` service compiles the cloned element, when not specified through the
	 * `stickyClone` parameter, in the same scope as the actual element lives.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   angular.module('myModule')
	 *     .directive('stickyText', function($mdSticky) {
	 *       return {
	 *         restrict: 'E',
	 *         template: '<span>Sticky Text</span>',
	 *         link: function(scope, element) {
	 *           $mdSticky(scope, element);
	 *         }
	 *       };
	 *     });
	 * </hljs>
	 *
	 * <h3>Notes</h3>
	 * When using an element which contains a compiled directive that changes the DOM structure
	 * during compilation, you should compile the clone yourself.
	 *
	 * An example of this usage can be found below:
	 * <hljs lang="js">
	 *   angular.module('myModule')
	 *     .directive('stickySelect', function($mdSticky, $compile) {
	 *       var SELECT_TEMPLATE =
	 *         '<md-select ng-model="selected">' +
	 *         '  <md-option>Option 1</md-option>' +
	 *         '</md-select>';
	 *
	 *       return {
	 *         restrict: 'E',
	 *         replace: true,
	 *         template: SELECT_TEMPLATE,
	 *         link: function(scope, element) {
	 *           $mdSticky(scope, element, $compile(SELECT_TEMPLATE)(scope));
	 *         }
	 *       };
	 *     });
	 * </hljs>
	 *
	 * @returns {function(IScope, JQLite, ITemplateLinkingFunction=): void} `$mdSticky` returns a
	 *   function that takes three arguments:
	 *   - `scope`: the scope to use when compiling the clone and listening for the `$destroy` event,
	 *      which triggers removal of the clone
	 *   - `element`: the element that will be 'sticky'
	 *   - `stickyClone`: An optional clone of the element (returned from AngularJS'
	 *      [$compile service](https://docs.angularjs.org/api/ng/service/$compile#usage)),
	 *      that will be shown when the user starts scrolling past the original element. If not
	 *      provided, the result of `element.clone()` will be used and compiled in the given scope.
	 */
	function MdSticky($mdConstant, $$rAF, $mdUtil, $compile) {
	
	  var browserStickySupport = $mdUtil.checkStickySupport();
	
	  /**
	   * Registers an element as sticky, used internally by directives to register themselves.
	   */
	  return function registerStickyElement(scope, element, stickyClone) {
	    var contentCtrl = element.controller('mdContent');
	    if (!contentCtrl) return;
	
	    if (browserStickySupport) {
	      element.css({
	        position: browserStickySupport,
	        top: 0,
	        'z-index': 2
	      });
	    } else {
	      var $$sticky = contentCtrl.$element.data('$$sticky');
	      if (!$$sticky) {
	        $$sticky = setupSticky(contentCtrl);
	        contentCtrl.$element.data('$$sticky', $$sticky);
	      }
	
	      // Compile our cloned element, when cloned in this service, into the given scope.
	      var cloneElement = stickyClone || $compile(element.clone())(scope);
	
	      var deregister = $$sticky.add(element, cloneElement);
	      scope.$on('$destroy', deregister);
	    }
	  };
	
	  function setupSticky(contentCtrl) {
	    var contentEl = contentCtrl.$element;
	
	    // Refresh elements is very expensive, so we use the debounced
	    // version when possible.
	    var debouncedRefreshElements = $$rAF.throttle(refreshElements);
	
	    // setupAugmentedScrollEvents gives us `$scrollstart` and `$scroll`,
	    // more reliable than `scroll` on android.
	    setupAugmentedScrollEvents(contentEl);
	    contentEl.on('$scrollstart', debouncedRefreshElements);
	    contentEl.on('$scroll', onScroll);
	
	    var self;
	    return self = {
	      prev: null,
	      current: null, // the currently stickied item
	      next: null,
	      items: [],
	      add: add,
	      refreshElements: refreshElements
	    };
	
	    /***************
	     * Public
	     ***************/
	    // Add an element and its sticky clone to this content's sticky collection
	    function add(element, stickyClone) {
	      stickyClone.addClass('md-sticky-clone');
	
	      var item = {
	        element: element,
	        clone: stickyClone
	      };
	      self.items.push(item);
	
	      $mdUtil.nextTick(function() {
	        contentEl.prepend(item.clone);
	      });
	
	      debouncedRefreshElements();
	
	      return function remove() {
	        self.items.forEach(function(item, index) {
	          if (item.element[0] === element[0]) {
	            self.items.splice(index, 1);
	            item.clone.remove();
	          }
	        });
	        debouncedRefreshElements();
	      };
	    }
	
	    function refreshElements() {
	      // Sort our collection of elements by their current position in the DOM.
	      // We need to do this because our elements' order of being added may not
	      // be the same as their order of display.
	      self.items.forEach(refreshPosition);
	      self.items = self.items.sort(function(a, b) {
	        return a.top < b.top ? -1 : 1;
	      });
	
	      // Find which item in the list should be active,
	      // based upon the content's current scroll position
	      var item;
	      var currentScrollTop = contentEl.prop('scrollTop');
	      for (var i = self.items.length - 1; i >= 0; i--) {
	        if (currentScrollTop > self.items[i].top) {
	          item = self.items[i];
	          break;
	        }
	      }
	      setCurrentItem(item);
	    }
	
	    /***************
	     * Private
	     ***************/
	
	    // Find the `top` of an item relative to the content element,
	    // and also the height.
	    function refreshPosition(item) {
	      // Find the top of an item by adding to the offsetHeight until we reach the
	      // content element.
	      var current = item.element[0];
	      item.top = 0;
	      item.left = 0;
	      item.right = 0;
	      while (current && current !== contentEl[0]) {
	        item.top += current.offsetTop;
	        item.left += current.offsetLeft;
	        if (current.offsetParent) {
	          // Compute offsetRight
	          item.right += current.offsetParent.offsetWidth - current.offsetWidth - current.offsetLeft;
	        }
	        current = current.offsetParent;
	      }
	      item.height = item.element.prop('offsetHeight');
	
	      var defaultVal = $mdUtil.floatingScrollbars() ? '0' : undefined;
	      $mdUtil.bidi(item.clone, 'margin-left', item.left, defaultVal);
	      $mdUtil.bidi(item.clone, 'margin-right', defaultVal, item.right);
	    }
	
	    // As we scroll, push in and select the correct sticky element.
	    function onScroll() {
	      var scrollTop = contentEl.prop('scrollTop');
	      var isScrollingDown = scrollTop > (onScroll.prevScrollTop || 0);
	
	      // Store the previous scroll so we know which direction we are scrolling
	      onScroll.prevScrollTop = scrollTop;
	
	      //
	      // AT TOP (not scrolling)
	      //
	      if (scrollTop === 0) {
	        // If we're at the top, just clear the current item and return
	        setCurrentItem(null);
	        return;
	      }
	
	      //
	      // SCROLLING DOWN (going towards the next item)
	      //
	      if (isScrollingDown) {
	
	        // If we've scrolled down past the next item's position, sticky it and return
	        if (self.next && self.next.top <= scrollTop) {
	          setCurrentItem(self.next);
	          return;
	        }
	
	        // If the next item is close to the current one, push the current one up out of the way
	        if (self.current && self.next && self.next.top - scrollTop <= self.next.height) {
	          translate(self.current, scrollTop + (self.next.top - self.next.height - scrollTop));
	          return;
	        }
	      }
	
	      //
	      // SCROLLING UP (not at the top & not scrolling down; must be scrolling up)
	      //
	      if (!isScrollingDown) {
	
	        // If we've scrolled up past the previous item's position, sticky it and return
	        if (self.current && self.prev && scrollTop < self.current.top) {
	          setCurrentItem(self.prev);
	          return;
	        }
	
	        // If the next item is close to the current one, pull the current one down into view
	        if (self.next && self.current && (scrollTop >= (self.next.top - self.current.height))) {
	          translate(self.current, scrollTop + (self.next.top - scrollTop - self.current.height));
	          return;
	        }
	      }
	
	      //
	      // Otherwise, just move the current item to the proper place (scrolling up or down)
	      //
	      if (self.current) {
	        translate(self.current, scrollTop);
	      }
	    }
	
	    function setCurrentItem(item) {
	      if (self.current === item) return;
	      // Deactivate currently active item
	      if (self.current) {
	        translate(self.current, null);
	        setStickyState(self.current, null);
	      }
	
	      // Activate new item if given
	      if (item) {
	        setStickyState(item, 'active');
	      }
	
	      self.current = item;
	      var index = self.items.indexOf(item);
	      // If index === -1, index + 1 = 0. It works out.
	      self.next = self.items[index + 1];
	      self.prev = self.items[index - 1];
	      setStickyState(self.next, 'next');
	      setStickyState(self.prev, 'prev');
	    }
	
	    function setStickyState(item, state) {
	      if (!item || item.state === state) return;
	      if (item.state) {
	        item.clone.attr('sticky-prev-state', item.state);
	        item.element.attr('sticky-prev-state', item.state);
	      }
	      item.clone.attr('sticky-state', state);
	      item.element.attr('sticky-state', state);
	      item.state = state;
	    }
	
	    function translate(item, amount) {
	      if (!item) return;
	      if (amount === null || amount === undefined) {
	        if (item.translateY) {
	          item.translateY = null;
	          item.clone.css($mdConstant.CSS.TRANSFORM, '');
	        }
	      } else {
	        item.translateY = amount;
	
	        $mdUtil.bidi(item.clone, $mdConstant.CSS.TRANSFORM,
	          'translate3d(' + item.left + 'px,' + amount + 'px,0)',
	          'translateY(' + amount + 'px)'
	        );
	      }
	    }
	  }
	
	
	  // Android 4.4 don't accurately give scroll events.
	  // To fix this problem, we setup a fake scroll event. We say:
	  // > If a scroll or touchmove event has happened in the last DELAY milliseconds,
	  //   then send a `$scroll` event every animationFrame.
	  // Additionally, we add $scrollstart and $scrollend events.
	  function setupAugmentedScrollEvents(element) {
	    var SCROLL_END_DELAY = 200;
	    var isScrolling;
	    var lastScrollTime;
	    element.on('scroll touchmove', function() {
	      if (!isScrolling) {
	        isScrolling = true;
	        $$rAF.throttle(loopScrollEvent);
	        element.triggerHandler('$scrollstart');
	      }
	      element.triggerHandler('$scroll');
	      lastScrollTime = +$mdUtil.now();
	    });
	
	    function loopScrollEvent() {
	      if (+$mdUtil.now() - lastScrollTime > SCROLL_END_DELAY) {
	        isScrolling = false;
	        element.triggerHandler('$scrollend');
	      } else {
	        element.triggerHandler('$scroll');
	        $$rAF.throttle(loopScrollEvent);
	      }
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.subheader
	 * @description
	 * SubHeader module
	 *
	 *  Subheaders are special list tiles that delineate distinct sections of a
	 *  list or grid list and are typically related to the current filtering or
	 *  sorting criteria. Subheader tiles are either displayed inline with tiles or
	 *  can be associated with content, for example, in an adjacent column.
	 *
	 *  Upon scrolling, subheaders remain pinned to the top of the screen and remain
	 *  pinned until pushed on or off screen by the next subheader. @see [Material
	 *  Design Specifications](https://material.io/archive/guidelines/components/subheaders.html)
	 *
	 *  > To improve the visual grouping of content, use the system color for your subheaders.
	 *
	 */
	MdSubheaderDirective.$inject = ["$mdSticky", "$compile", "$mdTheming", "$mdUtil", "$mdAria"];
	angular
	  .module('material.components.subheader', [
	    'material.core',
	    'material.components.sticky'
	  ])
	  .directive('mdSubheader', MdSubheaderDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdSubheader
	 * @module material.components.subheader
	 *
	 * @restrict E
	 *
	 * @description
	 * The `md-subheader` directive creates a sticky subheader for a section.
	 *
	 * Developers are able to disable the stickiness of the subheader by using the following markup
	 *
	 * <hljs lang="html">
	 *   <md-subheader class="md-no-sticky">Not Sticky</md-subheader>
	 * </hljs>
	 *
	 * ### Notes
	 * - The `md-subheader` directive uses the <a ng-href="api/service/$mdSticky">$mdSticky</a> service
	 * to make the subheader sticky.
	 *
	 * > Whenever the current browser doesn't support stickiness natively, the subheader
	 * will be compiled twice to create a sticky clone of the subheader.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-subheader>Online Friends</md-subheader>
	 * </hljs>
	 */
	
	function MdSubheaderDirective($mdSticky, $compile, $mdTheming, $mdUtil, $mdAria) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: true,
	    template: (
	    '<div class="md-subheader _md">' +
	    '  <div class="md-subheader-inner">' +
	    '    <div class="md-subheader-content"></div>' +
	    '  </div>' +
	    '</div>'
	    ),
	    link: function postLink(scope, element, attr, controllers, transclude) {
	      $mdTheming(element);
	      element.addClass('_md');
	
	      // Remove the ngRepeat attribute from the root element, because we don't want to compile
	      // the ngRepeat for the sticky clone again.
	      $mdUtil.prefixer().removeAttribute(element, 'ng-repeat');
	
	      var outerHTML = element[0].outerHTML;
	
	      function getContent(el) {
	        return angular.element(el[0].querySelector('.md-subheader-content'));
	      }
	
	      // Set the ARIA attributes on the original element since it keeps it's original place in
	      // the DOM, whereas the clones are in reverse order. Should be done after the outerHTML,
	      // in order to avoid having multiple element be marked as headers.
	      attr.$set('role', 'heading');
	      $mdAria.expect(element, 'aria-level', '2');
	
	      // Transclude the user-given contents of the subheader
	      // the conventional way.
	      transclude(scope, function(clone) {
	        getContent(element).append(clone);
	      });
	
	      // Create another clone, that uses the outer and inner contents
	      // of the element, that will be 'stickied' as the user scrolls.
	      if (!element.hasClass('md-no-sticky')) {
	        transclude(scope, function(clone) {
	          // If the user adds an ng-if or ng-repeat directly to the md-subheader element, the
	          // compiled clone below will only be a comment tag (since they replace their elements with
	          // a comment) which cannot be properly passed to the $mdSticky; so we wrap it in our own
	          // DIV to ensure we have something $mdSticky can use
	          var wrapper = $compile('<div class="md-subheader-wrapper" aria-hidden="true">' + outerHTML + '</div>')(scope);
	
	          // Delay initialization until after any `ng-if`/`ng-repeat`/etc has finished before
	          // attempting to create the clone
	          $mdUtil.nextTick(function() {
	            // Append our transcluded clone into the wrapper.
	            // We don't have to recompile the element again, because the clone is already
	            // compiled in it's transclusion scope. If we recompile the outerHTML of the new clone, we would lose
	            // our ngIf's and other previous registered bindings / properties.
	            getContent(wrapper).append(clone);
	          });
	
	          // Make the element sticky and provide the stickyClone our self, to avoid recompilation of the subheader
	          // element.
	          $mdSticky(scope, element, wrapper);
	        });
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.swipe
	 * @description Swipe module!
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeLeft
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-left directive allows you to specify custom behavior when an element is swiped
	 * left.
	 *
	 * ### Notes
	 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
	 * reference to the element that actually holds the `md-swipe-left` directive by using
	 * `$target.current`
	 *
	 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer
	 * Tools console while swiping).
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-left="onSwipeLeft($event, $target)">Swipe me left!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeRight
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-right directive allows you to specify custom behavior when an element is swiped
	 * right.
	 *
	 * ### Notes
	 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
	 * reference to the element that actually holds the `md-swipe-right` directive by using
	 * `$target.current`
	 *
	 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer
	 * Tools console while swiping).
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-right="onSwipeRight($event, $target)">Swipe me right!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeUp
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-up directive allows you to specify custom behavior when an element is swiped
	 * up.
	 *
	 * ### Notes
	 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
	 * reference to the element that actually holds the `md-swipe-up` directive by using
	 * `$target.current`
	 *
	 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer
	 * Tools console while swiping).
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-up="onSwipeUp($event, $target)">Swipe me up!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeDown
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-down directive allows you to specify custom behavior when an element is swiped
	 * down.
	 *
	 * ### Notes
	 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
	 * reference to the element that actually holds the `md-swipe-down` directive by using
	 * `$target.current`
	 *
	 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer
	 * Tools console while swiping).
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-down="onSwipeDown($event, $target)">Swipe me down!</div>
	 * </hljs>
	 */
	
	angular.module('material.components.swipe', ['material.core'])
	    .directive('mdSwipeLeft', getDirective('SwipeLeft'))
	    .directive('mdSwipeRight', getDirective('SwipeRight'))
	    .directive('mdSwipeUp', getDirective('SwipeUp'))
	    .directive('mdSwipeDown', getDirective('SwipeDown'));
	
	function getDirective(name) {
	    DirectiveFactory.$inject = ["$parse"];
	  var directiveName = 'md' + name;
	  var eventName = '$md.' + name.toLowerCase();
	
	  return DirectiveFactory;
	
	  /* @ngInject */
	  function DirectiveFactory($parse) {
	      return { restrict: 'A', link: postLink };
	      function postLink(scope, element, attr) {
	        var fn = $parse(attr[directiveName]);
	        element.on(eventName, function(ev) {
	          var currentTarget = ev.currentTarget;
	          scope.$applyAsync(function() { fn(scope, { $event: ev, $target: { current: currentTarget } }); });
	        });
	      }
	    }
	}
	
	
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.switch
	 */
	
	MdSwitch.$inject = ["mdCheckboxDirective", "$mdUtil", "$mdConstant", "$parse", "$$rAF", "$mdGesture", "$timeout"];
	angular.module('material.components.switch', [
	  'material.core',
	  'material.components.checkbox'
	])
	  .directive('mdSwitch', MdSwitch);
	
	/**
	 * @ngdoc directive
	 * @module material.components.switch
	 * @name mdSwitch
	 * @restrict E
	 *
	 * The switch directive is used very much like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
	 *
	 * As per the [Material Design spec](https://material.io/archive/guidelines/style/color.html#color-color-system)
	 * the switch is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * @param {expression} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
	 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
	 * @param {expression=} ng-change Expression to be executed when the model value changes.
	 * @param {expression=} ng-disabled En/Disable based on the expression.
	 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects.
	 * @param {string=} aria-label Publish the button label used by screen-readers for accessibility. Defaults to the switch's text.
	 * @param {boolean=} md-invert When set to true, the switch will be inverted.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-switch ng-model="isActive" aria-label="Finished?">
	 *   Finished ?
	 * </md-switch>
	 *
	 * <md-switch md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
	 *   No Ink Effects
	 * </md-switch>
	 *
	 * <md-switch ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
	 *   Disabled
	 * </md-switch>
	 *
	 * </hljs>
	 */
	function MdSwitch(mdCheckboxDirective, $mdUtil, $mdConstant, $parse, $$rAF, $mdGesture, $timeout) {
	  var checkboxDirective = mdCheckboxDirective[0];
	
	  return {
	    restrict: 'E',
	    priority: $mdConstant.BEFORE_NG_ARIA,
	    transclude: true,
	    template:
	      '<div class="md-container">' +
	        '<div class="md-bar"></div>' +
	        '<div class="md-thumb-container">' +
	          '<div class="md-thumb" md-ink-ripple md-ink-ripple-checkbox></div>' +
	        '</div>'+
	      '</div>' +
	      '<div ng-transclude class="md-label"></div>',
	    require: ['^?mdInputContainer', '?ngModel', '?^form'],
	    compile: mdSwitchCompile
	  };
	
	  function mdSwitchCompile(element, attr) {
	    var checkboxLink = checkboxDirective.compile(element, attr).post;
	    // No transition on initial load.
	    element.addClass('md-dragging');
	
	    return function (scope, element, attr, ctrls) {
	      var containerCtrl = ctrls[0];
	      var ngModel = ctrls[1] || $mdUtil.fakeNgModel();
	      var formCtrl = ctrls[2];
	
	      var disabledGetter = null;
	      if (attr.disabled != null) {
	        disabledGetter = function() { return true; };
	      } else if (attr.ngDisabled) {
	        disabledGetter = $parse(attr.ngDisabled);
	      }
	
	      var thumbContainer = angular.element(element[0].querySelector('.md-thumb-container'));
	      var switchContainer = angular.element(element[0].querySelector('.md-container'));
	      var labelContainer = angular.element(element[0].querySelector('.md-label'));
	
	      // no transition on initial load
	      $$rAF(function() {
	        element.removeClass('md-dragging');
	      });
	
	      checkboxLink(scope, element, attr, ctrls);
	
	      if (disabledGetter) {
	        scope.$watch(disabledGetter, function(isDisabled) {
	          element.attr('tabindex', isDisabled ? -1 : 0);
	        });
	      }
	
	      attr.$observe('mdInvert', function(newValue) {
	        var isInverted = $mdUtil.parseAttributeBoolean(newValue);
	
	        isInverted ? element.prepend(labelContainer) : element.prepend(switchContainer);
	
	        // Toggle a CSS class to update the margin.
	        element.toggleClass('md-inverted', isInverted);
	      });
	
	      // These events are triggered by setup drag
	      $mdGesture.register(switchContainer, 'drag');
	      switchContainer
	        .on('$md.dragstart', onDragStart)
	        .on('$md.drag', onDrag)
	        .on('$md.dragend', onDragEnd);
	
	      var drag;
	      function onDragStart(ev) {
	        // Don't go if the switch is disabled.
	        if (disabledGetter && disabledGetter(scope)) return;
	        ev.stopPropagation();
	
	        element.addClass('md-dragging');
	        drag = {width: thumbContainer.prop('offsetWidth')};
	      }
	
	      function onDrag(ev) {
	        if (!drag) return;
	        ev.stopPropagation();
	        ev.srcEvent && ev.srcEvent.preventDefault();
	
	        var percent = ev.pointer.distanceX / drag.width;
	
	        // if checked, start from right. else, start from left
	        var translate = ngModel.$viewValue ?  1 + percent : percent;
	        // Make sure the switch stays inside its bounds, 0-1%
	        translate = Math.max(0, Math.min(1, translate));
	
	        thumbContainer.css($mdConstant.CSS.TRANSFORM, 'translate3d(' + (100*translate) + '%,0,0)');
	        drag.translate = translate;
	      }
	
	      function onDragEnd(ev) {
	        if (!drag) return;
	        ev.stopPropagation();
	
	        element.removeClass('md-dragging');
	        thumbContainer.css($mdConstant.CSS.TRANSFORM, '');
	
	        // We changed if there is no distance (this is a click a click),
	        // or if the drag distance is >50% of the total.
	        var isChanged = ngModel.$viewValue ? drag.translate < 0.5 : drag.translate > 0.5;
	        if (isChanged) {
	          applyModelValue(!ngModel.$viewValue);
	        }
	        drag = null;
	
	        // Wait for incoming mouse click
	        scope.skipToggle = true;
	        $timeout(function() {
	          scope.skipToggle = false;
	        }, 1);
	      }
	
	      function applyModelValue(newValue) {
	        scope.$apply(function() {
	          ngModel.$setViewValue(newValue);
	          ngModel.$render();
	        });
	      }
	
	    };
	  }
	
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.tabs
	 * @description
	 *
	 *  Tabs, created with the `<md-tabs>` directive provide *tabbed* navigation with different styles.
	 *  The Tabs component consists of clickable tabs that are aligned horizontally side-by-side.
	 *
	 *  Features include support for:
	 *
	 *  - static or dynamic tabs,
	 *  - responsive designs,
	 *  - accessibility support (ARIA),
	 *  - tab pagination,
	 *  - external or internal tab content,
	 *  - focus indicators and arrow-key navigations,
	 *  - programmatic lookup and access to tab controllers, and
	 *  - dynamic transitions through different tab contents.
	 *
	 */
	/*
	 * @see js folder for tabs implementation
	 */
	angular.module('material.components.tabs', [
	  'material.core',
	  'material.components.icon'
	]);
	
	})();
	(function(){
	"use strict";
	
	angular
	.module('material.components.tabs')
	.service('MdTabsPaginationService', MdTabsPaginationService);
	
	/**
	 * @private
	 * @module material.components.tabs
	 * @name MdTabsPaginationService
	 * @description Provides many standalone functions to ease in pagination calculations.
	 *
	 * Most functions accept the elements and the current offset.
	 *
	 * The `elements` parameter is typically the value returned from the `getElements()` function of the
	 * tabsController.
	 *
	 * The `offset` parameter is always positive regardless of LTR or RTL (we simply make the LTR one
	 * negative when we apply our transform). This is typically the `ctrl.leftOffset` variable in the
	 * tabsController.
	 *
	 * @returns MdTabsPaginationService
	 * @constructor
	 */
	function MdTabsPaginationService() {
	  return {
	    decreasePageOffset: decreasePageOffset,
	    increasePageOffset: increasePageOffset,
	    getTabOffsets: getTabOffsets,
	    getTotalTabsWidth: getTotalTabsWidth
	  };
	
	  /**
	   * Returns the offset for the next decreasing page.
	   *
	   * @param elements
	   * @param currentOffset
	   * @returns {number}
	   */
	  function decreasePageOffset(elements, currentOffset) {
	    var canvas       = elements.canvas,
	        tabOffsets   = getTabOffsets(elements),
	        i, firstVisibleTabOffset;
	
	    // Find the first fully visible tab in offset range
	    for (i = 0; i < tabOffsets.length; i++) {
	      if (tabOffsets[i] >= currentOffset) {
	        firstVisibleTabOffset = tabOffsets[i];
	        break;
	      }
	    }
	
	    // Return (the first visible tab offset - the tabs container width) without going negative
	    return Math.max(0, firstVisibleTabOffset - canvas.clientWidth);
	  }
	
	  /**
	   * Returns the offset for the next increasing page.
	   *
	   * @param elements
	   * @param currentOffset
	   * @returns {number}
	   */
	  function increasePageOffset(elements, currentOffset) {
	    var canvas       = elements.canvas,
	        maxOffset    = getTotalTabsWidth(elements) - canvas.clientWidth,
	        tabOffsets   = getTabOffsets(elements),
	        i, firstHiddenTabOffset;
	
	    // Find the first partially (or fully) invisible tab
	    for (i = 0; i < tabOffsets.length, tabOffsets[i] <= currentOffset + canvas.clientWidth; i++) {
	      firstHiddenTabOffset = tabOffsets[i];
	    }
	
	    // Return the offset of the first hidden tab, or the maximum offset (whichever is smaller)
	    return Math.min(maxOffset, firstHiddenTabOffset);
	  }
	
	  /**
	   * Returns the offsets of all of the tabs based on their widths.
	   *
	   * @param elements
	   * @returns {number[]}
	   */
	  function getTabOffsets(elements) {
	    var i, tab, currentOffset = 0, offsets = [];
	
	    for (i = 0; i < elements.tabs.length; i++) {
	      tab = elements.tabs[i];
	      offsets.push(currentOffset);
	      currentOffset += tab.offsetWidth;
	    }
	
	    return offsets;
	  }
	
	  /**
	   * Sum the width of all tabs.
	   *
	   * @param elements
	   * @returns {number}
	   */
	  function getTotalTabsWidth(elements) {
	    var sum = 0, i, tab;
	
	    for (i = 0; i < elements.tabs.length; i++) {
	      tab = elements.tabs[i];
	      sum += tab.offsetWidth;
	    }
	
	    return sum;
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdTab
	 * @module material.components.tabs
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-tab>` is a nested directive used within `<md-tabs>` to specify a tab with a **label**
	 * and optional *view content*.
	 *
	 * If the `label` attribute is not specified, then an optional `<md-tab-label>` tag can be used to
	 * specify more complex tab header markup. If neither the **label** nor the **md-tab-label** are
	 * specified, then the nested markup of the `<md-tab>` is used as the tab header markup.
	 *
	 * Please note that if you use `<md-tab-label>`, your content **MUST** be wrapped in the
	 * `<md-tab-body>` tag.  This is to define a clear separation between the tab content and the tab
	 * label.
	 *
	 * This container is used by the TabsController to show/hide the active tab's content view. This
	 * synchronization is automatically managed by the internal TabsController whenever the tab
	 * selection changes. Selection changes can be initiated via data binding changes, programmatic
	 * invocation, or user gestures.
	 *
	 * @param {string=} label Optional attribute to specify a simple string as the tab label
	 * @param {boolean=} ng-disabled If present and expression evaluates to truthy, disabled tab
	 *  selection.
	 * @param {string=} md-tab-class Optional attribute to specify a class that will be applied to the
	 *  tab's button
	 * @param {expression=} md-on-deselect Expression to be evaluated after the tab has been
	 *  de-selected.
	 * @param {expression=} md-on-select Expression to be evaluated after the tab has been selected.
	 * @param {boolean=} md-active When true, sets the active tab.  Note: There can only be one active
	 *  tab at a time.
	 *
	 *
	 * @usage
	 *
	 * <hljs lang="html">
	 * <md-tab label="My Tab" md-tab-class="my-content-tab" ng-disabled md-on-select="onSelect()"
	 *         md-on-deselect="onDeselect()">
	 *   <h3>My Tab content</h3>
	 * </md-tab>
	 *
	 * <md-tab>
	 *   <md-tab-label>
	 *     <h3>My Tab</h3>
	 *   </md-tab-label>
	 *   <md-tab-body>
	 *     <p>
	 *       Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque
	 *       laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi
	 *       architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
	 *       aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione
	 *       voluptatem sequi nesciunt.
	 *     </p>
	 *   </md-tab-body>
	 * </md-tab>
	 * </hljs>
	 *
	 */
	angular
	    .module('material.components.tabs')
	    .directive('mdTab', MdTab);
	
	function MdTab () {
	  return {
	    require:  '^?mdTabs',
	    terminal: true,
	    compile:  function (element, attr) {
	      var label = firstChild(element, 'md-tab-label'),
	          body  = firstChild(element, 'md-tab-body');
	
	      if (label.length === 0) {
	        label = angular.element('<md-tab-label></md-tab-label>');
	        if (attr.label) label.text(attr.label);
	        else label.append(element.contents());
	
	        if (body.length === 0) {
	          var contents = element.contents().detach();
	          body         = angular.element('<md-tab-body></md-tab-body>');
	          body.append(contents);
	        }
	      }
	
	      element.append(label);
	      if (body.html()) element.append(body);
	
	      return postLink;
	    },
	    scope:    {
	      active:   '=?mdActive',
	      disabled: '=?ngDisabled',
	      select:   '&?mdOnSelect',
	      deselect: '&?mdOnDeselect',
	      tabClass: '@mdTabClass'
	    }
	  };
	
	  function postLink (scope, element, attr, ctrl) {
	    if (!ctrl) return;
	    var index = ctrl.getTabElementIndex(element),
	        body  = firstChild(element, 'md-tab-body').remove(),
	        label = firstChild(element, 'md-tab-label').remove(),
	        data  = ctrl.insertTab({
	          scope:    scope,
	          parent:   scope.$parent,
	          index:    index,
	          element:  element,
	          template: body.html(),
	          label:    label.html()
	        }, index);
	
	    scope.select   = scope.select || angular.noop;
	    scope.deselect = scope.deselect || angular.noop;
	
	    scope.$watch('active', function (active) { if (active) ctrl.select(data.getIndex(), true); });
	    scope.$watch('disabled', function () { ctrl.refreshIndex(); });
	    scope.$watch(
	        function () {
	          return ctrl.getTabElementIndex(element);
	        },
	        function (newIndex) {
	          data.index = newIndex;
	          ctrl.updateTabOrder();
	        }
	    );
	    scope.$on('$destroy', function () { ctrl.removeTab(data); });
	  }
	
	  function firstChild (element, tagName) {
	    var children = element[0].children;
	    for (var i = 0, len = children.length; i < len; i++) {
	      var child = children[i];
	      if (child.tagName === tagName.toUpperCase()) return angular.element(child);
	    }
	    return angular.element();
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	    .module('material.components.tabs')
	    .directive('mdTabItem', MdTabItem);
	
	function MdTabItem () {
	  return {
	    require: '^?mdTabs',
	    link:    function link (scope, element, attr, ctrl) {
	      if (!ctrl) return;
	      ctrl.attachRipple(scope, element);
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	    .module('material.components.tabs')
	    .directive('mdTabLabel', MdTabLabel);
	
	function MdTabLabel () {
	  return { terminal: true };
	}
	
	
	})();
	(function(){
	"use strict";
	
	
	MdTabScroll.$inject = ["$parse"];angular.module('material.components.tabs')
	    .directive('mdTabScroll', MdTabScroll);
	
	function MdTabScroll ($parse) {
	  return {
	    restrict: 'A',
	    compile: function ($element, attr) {
	      var fn = $parse(attr.mdTabScroll, null, true);
	      return function ngEventHandler (scope, element) {
	        element.on('wheel', function (event) {
	          scope.$apply(function () { fn(scope, { $event: event }); });
	        });
	      };
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsController.$inject = ["$scope", "$element", "$window", "$mdConstant", "$mdTabInkRipple", "$mdUtil", "$animateCss", "$attrs", "$compile", "$mdTheming", "$mdInteraction", "$timeout", "MdTabsPaginationService"];angular
	    .module('material.components.tabs')
	    .controller('MdTabsController', MdTabsController);
	
	/**
	 * @ngInject
	 */
	function MdTabsController ($scope, $element, $window, $mdConstant, $mdTabInkRipple, $mdUtil,
	                           $animateCss, $attrs, $compile, $mdTheming, $mdInteraction, $timeout,
	                           MdTabsPaginationService) {
	  // define private properties
	  var ctrl      = this,
	      locked    = false,
	      queue     = [],
	      destroyed = false,
	      loaded    = false;
	
	  // Define public methods
	  ctrl.$onInit            = $onInit;
	  ctrl.updatePagination   = $mdUtil.debounce(updatePagination, 100);
	  ctrl.redirectFocus      = redirectFocus;
	  ctrl.attachRipple       = attachRipple;
	  ctrl.insertTab          = insertTab;
	  ctrl.removeTab          = removeTab;
	  ctrl.select             = select;
	  ctrl.scroll             = scroll;
	  ctrl.nextPage           = nextPage;
	  ctrl.previousPage       = previousPage;
	  ctrl.keydown            = keydown;
	  ctrl.canPageForward     = canPageForward;
	  ctrl.canPageBack        = canPageBack;
	  ctrl.refreshIndex       = refreshIndex;
	  ctrl.incrementIndex     = incrementIndex;
	  ctrl.getTabElementIndex = getTabElementIndex;
	  ctrl.updateInkBarStyles = $mdUtil.debounce(updateInkBarStyles, 100);
	  ctrl.updateTabOrder     = $mdUtil.debounce(updateTabOrder, 100);
	  ctrl.getFocusedTabId    = getFocusedTabId;
	
	  // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	  // manually call the $onInit hook.
	  if (angular.version.major === 1 && angular.version.minor <= 4) {
	    this.$onInit();
	  }
	
	  /**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the
	   * $onInit hook.
	   */
	  function $onInit() {
	    // Define one-way bindings
	    defineOneWayBinding('stretchTabs', handleStretchTabs);
	
	    // Define public properties with change handlers
	    defineProperty('focusIndex', handleFocusIndexChange, ctrl.selectedIndex || 0);
	    defineProperty('offsetLeft', handleOffsetChange, 0);
	    defineProperty('hasContent', handleHasContent, false);
	    defineProperty('maxTabWidth', handleMaxTabWidth, getMaxTabWidth());
	    defineProperty('shouldPaginate', handleShouldPaginate, false);
	
	    // Define boolean attributes
	    defineBooleanAttribute('noInkBar', handleInkBar);
	    defineBooleanAttribute('dynamicHeight', handleDynamicHeight);
	    defineBooleanAttribute('noPagination');
	    defineBooleanAttribute('swipeContent');
	    defineBooleanAttribute('autoselect');
	    defineBooleanAttribute('noSelectClick');
	    defineBooleanAttribute('centerTabs', handleCenterTabs);
	    defineBooleanAttribute('enableDisconnect');
	
	    // Define public properties
	    ctrl.scope             = $scope;
	    ctrl.parent            = $scope.$parent;
	    ctrl.tabs              = [];
	    ctrl.lastSelectedIndex = null;
	    ctrl.hasFocus          = false;
	    ctrl.styleTabItemFocus = false;
	    ctrl.shouldCenterTabs  = shouldCenterTabs();
	    ctrl.tabContentPrefix  = 'tab-content-';
	    ctrl.navigationHint = 'Use the left and right arrow keys to navigate between tabs';
	
	    // Setup the tabs controller after all bindings are available.
	    setupTabsController();
	  }
	
	  /**
	   * Perform setup for the controller, setup events and watcher(s)
	   */
	  function setupTabsController () {
	    ctrl.selectedIndex = ctrl.selectedIndex || 0;
	    compileTemplate();
	    configureWatchers();
	    bindEvents();
	    $mdTheming($element);
	    $mdUtil.nextTick(function () {
	      updateHeightFromContent();
	      adjustOffset();
	      updateInkBarStyles();
	      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
	      loaded = true;
	      updatePagination();
	    });
	  }
	
	  /**
	   * Compiles the template provided by the user.  This is passed as an attribute from the tabs
	   * directive's template function.
	   */
	  function compileTemplate () {
	    var template = $attrs.$mdTabsTemplate,
	        element  = angular.element($element[0].querySelector('md-tab-data'));
	
	    element.html(template);
	    $compile(element.contents())(ctrl.parent);
	    delete $attrs.$mdTabsTemplate;
	  }
	
	  /**
	   * Binds events used by the tabs component.
	   */
	  function bindEvents () {
	    angular.element($window).on('resize', handleWindowResize);
	    $scope.$on('$destroy', cleanup);
	  }
	
	  /**
	   * Configure watcher(s) used by Tabs
	   */
	  function configureWatchers () {
	    $scope.$watch('$mdTabsCtrl.selectedIndex', handleSelectedIndexChange);
	  }
	
	  /**
	   * Creates a one-way binding manually rather than relying on AngularJS's isolated scope
	   * @param key
	   * @param handler
	   */
	  function defineOneWayBinding (key, handler) {
	    var attr = $attrs.$normalize('md-' + key);
	    if (handler) defineProperty(key, handler);
	    $attrs.$observe(attr, function (newValue) { ctrl[ key ] = newValue; });
	  }
	
	  /**
	   * Defines boolean attributes with default value set to true. I.e. md-stretch-tabs with no value
	   * will be treated as being truthy.
	   * @param {string} key
	   * @param {Function=} handler
	   */
	  function defineBooleanAttribute (key, handler) {
	    var attr = $attrs.$normalize('md-' + key);
	    if (handler) defineProperty(key, handler, undefined);
	    if ($attrs.hasOwnProperty(attr)) updateValue($attrs[attr]);
	    $attrs.$observe(attr, updateValue);
	    function updateValue (newValue) {
	      ctrl[ key ] = newValue !== 'false';
	    }
	  }
	
	  /**
	   * Remove any events defined by this controller
	   */
	  function cleanup () {
	    destroyed = true;
	    angular.element($window).off('resize', handleWindowResize);
	  }
	
	  // Change handlers
	
	  /**
	   * Toggles stretch tabs class and updates inkbar when tab stretching changes.
	   */
	  function handleStretchTabs () {
	    var elements = getElements();
	    angular.element(elements.wrapper).toggleClass('md-stretch-tabs', shouldStretchTabs());
	    updateInkBarStyles();
	  }
	
	  /**
	   * Update the value of ctrl.shouldCenterTabs.
	   */
	  function handleCenterTabs () {
	    ctrl.shouldCenterTabs = shouldCenterTabs();
	  }
	
	  /**
	   * @param {number} newWidth new max tab width in pixels
	   * @param {number} oldWidth previous max tab width in pixels
	   */
	  function handleMaxTabWidth (newWidth, oldWidth) {
	    if (newWidth !== oldWidth) {
	      var elements = getElements();
	
	      // Set the max width for the real tabs
	      angular.forEach(elements.tabs, function(tab) {
	        tab.style.maxWidth = newWidth + 'px';
	      });
	
	      // Set the max width for the dummy tabs too
	      angular.forEach(elements.dummies, function(tab) {
	        tab.style.maxWidth = newWidth + 'px';
	      });
	
	      $mdUtil.nextTick(ctrl.updateInkBarStyles);
	    }
	  }
	
	  function handleShouldPaginate (newValue, oldValue) {
	    if (newValue !== oldValue) {
	      ctrl.maxTabWidth      = getMaxTabWidth();
	      ctrl.shouldCenterTabs = shouldCenterTabs();
	      $mdUtil.nextTick(function () {
	        ctrl.maxTabWidth = getMaxTabWidth();
	        adjustOffset(ctrl.selectedIndex);
	      });
	    }
	  }
	
	  /**
	   * Add/remove the `md-no-tab-content` class depending on `ctrl.hasContent`
	   * @param {boolean} hasContent
	   */
	  function handleHasContent (hasContent) {
	    $element[ hasContent ? 'removeClass' : 'addClass' ]('md-no-tab-content');
	  }
	
	  /**
	   * Apply ctrl.offsetLeft to the paging element when it changes
	   * @param {string|number} left
	   */
	  function handleOffsetChange (left) {
	    var newValue = ((ctrl.shouldCenterTabs || isRtl() ? '' : '-') + left + 'px');
	
	    // Fix double-negative which can happen with RTL support
	    newValue = newValue.replace('--', '');
	
	    angular.element(getElements().paging).css($mdConstant.CSS.TRANSFORM,
	                                              'translate(' + newValue + ', 0)');
	    $scope.$broadcast('$mdTabsPaginationChanged');
	  }
	
	  /**
	   * Update the UI whenever `ctrl.focusIndex` is updated
	   * @param {number} newIndex
	   * @param {number} oldIndex
	   */
	  function handleFocusIndexChange (newIndex, oldIndex) {
	    if (newIndex === oldIndex) return;
	    if (!getElements().tabs[ newIndex ]) return;
	    adjustOffset();
	    redirectFocus();
	  }
	
	  /**
	   * Update the UI whenever the selected index changes. Calls user-defined select/deselect methods.
	   * @param {number} newValue selected index's new value
	   * @param {number} oldValue selected index's previous value
	   */
	  function handleSelectedIndexChange (newValue, oldValue) {
	    if (newValue === oldValue) return;
	
	    ctrl.selectedIndex     = getNearestSafeIndex(newValue);
	    ctrl.lastSelectedIndex = oldValue;
	    ctrl.updateInkBarStyles();
	    updateHeightFromContent();
	    adjustOffset(newValue);
	    $scope.$broadcast('$mdTabsChanged');
	    ctrl.tabs[ oldValue ] && ctrl.tabs[ oldValue ].scope.deselect();
	    ctrl.tabs[ newValue ] && ctrl.tabs[ newValue ].scope.select();
	  }
	
	  function getTabElementIndex(tabEl){
	    var tabs = $element[0].getElementsByTagName('md-tab');
	    return Array.prototype.indexOf.call(tabs, tabEl[0]);
	  }
	
	  /**
	   * Queues up a call to `handleWindowResize` when a resize occurs while the tabs component is
	   * hidden.
	   */
	  function handleResizeWhenVisible () {
	    // if there is already a watcher waiting for resize, do nothing
	    if (handleResizeWhenVisible.watcher) return;
	    // otherwise, we will abuse the $watch function to check for visible
	    handleResizeWhenVisible.watcher = $scope.$watch(function () {
	      // since we are checking for DOM size, we use $mdUtil.nextTick() to wait for after the DOM updates
	      $mdUtil.nextTick(function () {
	        // if the watcher has already run (ie. multiple digests in one cycle), do nothing
	        if (!handleResizeWhenVisible.watcher) return;
	
	        if ($element.prop('offsetParent')) {
	          handleResizeWhenVisible.watcher();
	          handleResizeWhenVisible.watcher = null;
	
	          handleWindowResize();
	        }
	      }, false);
	    });
	  }
	
	  // Event handlers / actions
	
	  /**
	   * Handle user keyboard interactions
	   * @param {KeyboardEvent} event keydown event
	   */
	  function keydown (event) {
	    switch (event.keyCode) {
	      case $mdConstant.KEY_CODE.LEFT_ARROW:
	        event.preventDefault();
	        incrementIndex(-1, true);
	        break;
	      case $mdConstant.KEY_CODE.RIGHT_ARROW:
	        event.preventDefault();
	        incrementIndex(1, true);
	        break;
	      case $mdConstant.KEY_CODE.SPACE:
	      case $mdConstant.KEY_CODE.ENTER:
	        event.preventDefault();
	        if (!locked) select(ctrl.focusIndex);
	        break;
	      case $mdConstant.KEY_CODE.TAB:
	        // On tabbing out of the tablist, reset hasFocus to reset ng-focused and
	        // its md-focused class if the focused tab is not the active tab.
	        if (ctrl.focusIndex !== ctrl.selectedIndex) {
	          ctrl.focusIndex = ctrl.selectedIndex;
	        }
	        break;
	    }
	  }
	
	  /**
	   * Update the selected index. Triggers a click event on the original `md-tab` element in order
	   * to fire user-added click events if canSkipClick or `md-no-select-click` are false.
	   * @param index
	   * @param canSkipClick Optionally allow not firing the click event if `md-no-select-click` is also true.
	   */
	  function select (index, canSkipClick) {
	    if (!locked) ctrl.focusIndex = ctrl.selectedIndex = index;
	    // skip the click event if noSelectClick is enabled
	    if (canSkipClick && ctrl.noSelectClick) return;
	    // nextTick is required to prevent errors in user-defined click events
	    $mdUtil.nextTick(function () {
	      ctrl.tabs[ index ].element.triggerHandler('click');
	    }, false);
	  }
	
	  /**
	   * When pagination is on, this makes sure the selected index is in view.
	   * @param {WheelEvent} event
	   */
	  function scroll (event) {
	    if (!ctrl.shouldPaginate) return;
	    event.preventDefault();
	    if (event.deltaY) {
	      ctrl.offsetLeft = fixOffset(ctrl.offsetLeft + event.deltaY);
	    } else if (event.deltaX) {
	      ctrl.offsetLeft = fixOffset(ctrl.offsetLeft + event.deltaX);
	    }
	  }
	
	  /**
	   * Slides the tabs over approximately one page forward.
	   */
	  function nextPage () {
	    if (!ctrl.canPageForward()) { return; }
	
	    var newOffset = MdTabsPaginationService.increasePageOffset(getElements(), ctrl.offsetLeft);
	
	    ctrl.offsetLeft = fixOffset(newOffset);
	  }
	
	  /**
	   * Slides the tabs over approximately one page backward.
	   */
	  function previousPage () {
	    if (!ctrl.canPageBack()) { return; }
	
	    var newOffset = MdTabsPaginationService.decreasePageOffset(getElements(), ctrl.offsetLeft);
	
	    // Set the new offset
	    ctrl.offsetLeft = fixOffset(newOffset);
	  }
	
	  /**
	   * Update size calculations when the window is resized.
	   */
	  function handleWindowResize () {
	    ctrl.lastSelectedIndex = ctrl.selectedIndex;
	    ctrl.offsetLeft        = fixOffset(ctrl.offsetLeft);
	
	    $mdUtil.nextTick(function () {
	      ctrl.updateInkBarStyles();
	      updatePagination();
	    });
	  }
	
	  /**
	   * Hides or shows the tabs ink bar.
	   * @param {boolean} hide A Boolean (not just truthy/falsy) value to determine whether the class
	   * should be added or removed.
	   */
	  function handleInkBar (hide) {
	    angular.element(getElements().inkBar).toggleClass('ng-hide', hide);
	  }
	
	  /**
	   * Enables or disables tabs dynamic height.
	   * @param {boolean} value A Boolean (not just truthy/falsy) value to determine whether the class
	   * should be added or removed.
	   */
	  function handleDynamicHeight (value) {
	    $element.toggleClass('md-dynamic-height', value);
	  }
	
	  /**
	   * Remove a tab from the data and select the nearest valid tab.
	   * @param {Object} tabData tab to remove
	   */
	  function removeTab (tabData) {
	    if (destroyed) return;
	    var selectedIndex = ctrl.selectedIndex,
	        tab           = ctrl.tabs.splice(tabData.getIndex(), 1)[ 0 ];
	    refreshIndex();
	    // when removing a tab, if the selected index did not change, we have to manually trigger the
	    //   tab select/deselect events
	    if (ctrl.selectedIndex === selectedIndex) {
	      tab.scope.deselect();
	      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
	    }
	    $mdUtil.nextTick(function () {
	      updatePagination();
	      ctrl.offsetLeft = fixOffset(ctrl.offsetLeft);
	    });
	  }
	
	  /**
	   * Create an entry in the tabs array for a new tab at the specified index.
	   * @param {Object} tabData tab to insert
	   * @param {number} index location to insert the new tab
	   * @returns {Object} the inserted tab
	   */
	  function insertTab (tabData, index) {
	    var hasLoaded = loaded;
	    var proto = {
	          getIndex:     function () { return ctrl.tabs.indexOf(tab); },
	          isActive:     function () { return this.getIndex() === ctrl.selectedIndex; },
	          isLeft:       function () { return this.getIndex() < ctrl.selectedIndex; },
	          isRight:      function () { return this.getIndex() > ctrl.selectedIndex; },
	          shouldRender: function () { return ctrl.dynamicHeight || this.isActive(); },
	          hasFocus:     function () {
	            return ctrl.styleTabItemFocus
	                && ctrl.hasFocus && this.getIndex() === ctrl.focusIndex;
	          },
	          id:           $mdUtil.nextUid(),
	          hasContent: !!(tabData.template && tabData.template.trim())
	    };
	    var tab = angular.extend(proto, tabData);
	
	    if (angular.isDefined(index)) {
	      ctrl.tabs.splice(index, 0, tab);
	    } else {
	      ctrl.tabs.push(tab);
	    }
	    processQueue();
	    updateHasContent();
	
	    $mdUtil.nextTick(function () {
	      updatePagination();
	      setAriaControls(tab);
	
	      // if autoselect is enabled, select the newly added tab
	      if (hasLoaded && ctrl.autoselect) {
	        $mdUtil.nextTick(function () {
	          $mdUtil.nextTick(function () { select(ctrl.tabs.indexOf(tab)); });
	        });
	      }
	    });
	    return tab;
	  }
	
	  // Getter methods
	
	  /**
	   * Gathers references to all of the DOM elements used by this controller.
	   * @returns {Object}
	   */
	  function getElements () {
	    var elements = {};
	    var node = $element[0];
	
	    // gather tab bar elements
	    elements.wrapper = node.querySelector('md-tabs-wrapper');
	    elements.canvas  = elements.wrapper.querySelector('md-tabs-canvas');
	    elements.paging  = elements.canvas.querySelector('md-pagination-wrapper');
	    elements.inkBar  = elements.paging.querySelector('md-ink-bar');
	    elements.nextButton = node.querySelector('md-next-button');
	    elements.prevButton = node.querySelector('md-prev-button');
	
	    elements.contents = node.querySelectorAll('md-tabs-content-wrapper > md-tab-content');
	    elements.tabs    = elements.paging.querySelectorAll('md-tab-item');
	    elements.dummies = elements.canvas.querySelectorAll('md-dummy-tab');
	
	    return elements;
	  }
	
	  /**
	   * Determines whether or not the left pagination arrow should be enabled.
	   * @returns {boolean}
	   */
	  function canPageBack () {
	    // This works for both LTR and RTL
	    return ctrl.offsetLeft > 0;
	  }
	
	  /**
	   * Determines whether or not the right pagination arrow should be enabled.
	   * @returns {*|boolean}
	   */
	  function canPageForward () {
	    var elements = getElements();
	    var lastTab = elements.tabs[ elements.tabs.length - 1 ];
	
	    if (isRtl()) {
	      return ctrl.offsetLeft < elements.paging.offsetWidth - elements.canvas.offsetWidth;
	    }
	
	    return lastTab && lastTab.offsetLeft + lastTab.offsetWidth > elements.canvas.clientWidth +
	        ctrl.offsetLeft;
	  }
	
	  /**
	   * Returns currently focused tab item's element ID
	   */
	  function getFocusedTabId() {
	    var focusedTab = ctrl.tabs[ctrl.focusIndex];
	    if (!focusedTab || !focusedTab.id) {
	      return null;
	    }
	    return 'tab-item-' + focusedTab.id;
	  }
	
	  /**
	   * Determines if the UI should stretch the tabs to fill the available space.
	   * @returns {*}
	   */
	  function shouldStretchTabs () {
	    switch (ctrl.stretchTabs) {
	      case 'always':
	        return true;
	      case 'never':
	        return false;
	      default:
	        return !ctrl.shouldPaginate
	            && $window.matchMedia('(max-width: 600px)').matches;
	    }
	  }
	
	  /**
	   * Determines if the tabs should appear centered.
	   * @returns {boolean}
	   */
	  function shouldCenterTabs () {
	    return ctrl.centerTabs && !ctrl.shouldPaginate;
	  }
	
	  /**
	   * Determines if pagination is necessary to display the tabs within the available space.
	   * @returns {boolean} true if pagination is necessary, false otherwise
	   */
	  function shouldPaginate () {
	    var shouldPaginate;
	    if (ctrl.noPagination || !loaded) return false;
	    var canvasWidth = $element.prop('clientWidth');
	
	    angular.forEach(getElements().tabs, function (tab) {
	      canvasWidth -= tab.offsetWidth;
	    });
	
	    shouldPaginate = canvasWidth < 0;
	    // Work around width calculation issues on IE11 when pagination is enabled.
	    // Don't do this on other browsers because it breaks scroll to new tab animation.
	    if ($mdUtil.msie) {
	      if (shouldPaginate) {
	        getElements().paging.style.width = '999999px';
	      } else {
	        getElements().paging.style.width = undefined;
	      }
	    }
	    return shouldPaginate;
	  }
	
	  /**
	   * Finds the nearest tab index that is available. This is primarily used for when the active
	   * tab is removed.
	   * @param newIndex
	   * @returns {*}
	   */
	  function getNearestSafeIndex (newIndex) {
	    if (newIndex === -1) return -1;
	    var maxOffset = Math.max(ctrl.tabs.length - newIndex, newIndex),
	        i, tab;
	    for (i = 0; i <= maxOffset; i++) {
	      tab = ctrl.tabs[ newIndex + i ];
	      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
	      tab = ctrl.tabs[ newIndex - i ];
	      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
	    }
	    return newIndex;
	  }
	
	  // Utility methods
	
	  /**
	   * Defines a property using a getter and setter in order to trigger a change handler without
	   * using `$watch` to observe changes.
	   * @param {PropertyKey} key
	   * @param {Function} handler
	   * @param {any} value
	   */
	  function defineProperty (key, handler, value) {
	    Object.defineProperty(ctrl, key, {
	      get: function () { return value; },
	      set: function (newValue) {
	        var oldValue = value;
	        value        = newValue;
	        handler && handler(newValue, oldValue);
	      }
	    });
	  }
	
	  /**
	   * Updates whether or not pagination should be displayed.
	   */
	  function updatePagination () {
	    ctrl.maxTabWidth = getMaxTabWidth();
	    ctrl.shouldPaginate = shouldPaginate();
	  }
	
	  /**
	   * @param {Array<HTMLElement>} tabs tab item elements for use in computing total width
	   * @returns {number} the width of the tabs in the specified array in pixels
	   */
	  function calcTabsWidth(tabs) {
	    var width = 0;
	
	    angular.forEach(tabs, function (tab) {
	      // Uses the larger value between `getBoundingClientRect().width` and `offsetWidth`.  This
	      // prevents `offsetWidth` value from being rounded down and causing wrapping issues, but
	      // also handles scenarios where `getBoundingClientRect()` is inaccurate (ie. tabs inside
	      // of a dialog).
	      width += Math.max(tab.offsetWidth, tab.getBoundingClientRect().width);
	    });
	
	    return Math.ceil(width);
	  }
	
	  /**
	   * @returns {number} either the max width as constrained by the container or the max width from
	   * the 2017 version of the Material Design spec.
	   */
	  function getMaxTabWidth() {
	    var elements = getElements(),
	      containerWidth = elements.canvas.clientWidth,
	
	      // See https://material.io/archive/guidelines/components/tabs.html#tabs-specs
	      specMax = 264;
	
	    // Do the spec maximum, or the canvas width; whichever is *smaller* (tabs larger than the canvas
	    // width can break the pagination) but not less than 0
	    return Math.max(0, Math.min(containerWidth - 1, specMax));
	  }
	
	  /**
	   * Re-orders the tabs and updates the selected and focus indexes to their new positions.
	   * This is triggered by `tabDirective.js` when the user's tabs have been re-ordered.
	   */
	  function updateTabOrder () {
	    var selectedItem   = ctrl.tabs[ ctrl.selectedIndex ],
	        focusItem      = ctrl.tabs[ ctrl.focusIndex ];
	    ctrl.tabs          = ctrl.tabs.sort(function (a, b) {
	      return a.index - b.index;
	    });
	    ctrl.selectedIndex = ctrl.tabs.indexOf(selectedItem);
	    ctrl.focusIndex    = ctrl.tabs.indexOf(focusItem);
	  }
	
	  /**
	   * This moves the selected or focus index left or right. This is used by the keydown handler.
	   * @param {number} inc amount to increment
	   * @param {boolean} focus true to increment the focus index, false to increment the selected index
	   */
	  function incrementIndex (inc, focus) {
	    var newIndex,
	        key   = focus ? 'focusIndex' : 'selectedIndex',
	        index = ctrl[ key ];
	    for (newIndex = index + inc;
	         ctrl.tabs[ newIndex ] && ctrl.tabs[ newIndex ].scope.disabled;
	         newIndex += inc) { /* do nothing */ }
	
	    newIndex = (index + inc + ctrl.tabs.length) % ctrl.tabs.length;
	
	    if (ctrl.tabs[ newIndex ]) {
	      ctrl[ key ] = newIndex;
	    }
	  }
	
	  /**
	   * This is used to forward focus to tab container elements. This method is necessary to avoid
	   * animation issues when attempting to focus an item that is out of view.
	   */
	  function redirectFocus () {
	    ctrl.styleTabItemFocus = ($mdInteraction.getLastInteractionType() === 'keyboard');
	    var tabToFocus = getElements().tabs[ctrl.focusIndex];
	    if (tabToFocus) {
	      tabToFocus.focus();
	    }
	  }
	
	  /**
	   * Forces the pagination to move the focused tab into view.
	   * @param {number=} index of tab to have its offset adjusted
	   */
	  function adjustOffset (index) {
	    var elements = getElements();
	
	    if (!angular.isNumber(index)) index = ctrl.focusIndex;
	    if (!elements.tabs[ index ]) return;
	    if (ctrl.shouldCenterTabs) return;
	    var tab         = elements.tabs[ index ],
	        left        = tab.offsetLeft,
	        right       = tab.offsetWidth + left,
	        extraOffset = 32;
	
	    // If we are selecting the first tab (in LTR and RTL), always set the offset to 0
	    if (index === 0) {
	      ctrl.offsetLeft = 0;
	      return;
	    }
	
	    if (isRtl()) {
	      var tabWidthsBefore = calcTabsWidth(Array.prototype.slice.call(elements.tabs, 0, index));
	      var tabWidthsIncluding = calcTabsWidth(Array.prototype.slice.call(elements.tabs, 0, index + 1));
	
	      ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(tabWidthsBefore));
	      ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(tabWidthsIncluding - elements.canvas.clientWidth));
	    } else {
	      ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(right - elements.canvas.clientWidth + extraOffset));
	      ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(left));
	    }
	  }
	
	  /**
	   * Iterates through all queued functions and clears the queue. This is used for functions that
	   * are called before the UI is ready, such as size calculations.
	   */
	  function processQueue () {
	    queue.forEach(function (func) { $mdUtil.nextTick(func); });
	    queue = [];
	  }
	
	  /**
	   * Determines if the tab content area is needed.
	   */
	  function updateHasContent () {
	    var hasContent = false;
	    var i;
	
	    for (i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].hasContent) {
	        hasContent = true;
	        break;
	      }
	    }
	
	    ctrl.hasContent = hasContent;
	  }
	
	  /**
	   * Moves the indexes to their nearest valid values.
	   */
	  function refreshIndex () {
	    ctrl.selectedIndex = getNearestSafeIndex(ctrl.selectedIndex);
	    ctrl.focusIndex    = getNearestSafeIndex(ctrl.focusIndex);
	  }
	
	  /**
	   * Calculates the content height of the current tab.
	   * @returns {*}
	   */
	  function updateHeightFromContent () {
	    if (!ctrl.dynamicHeight) return $element.css('height', '');
	    if (!ctrl.tabs.length) return queue.push(updateHeightFromContent);
	
	    var elements = getElements();
	
	    var tabContent    = elements.contents[ ctrl.selectedIndex ],
	        contentHeight = tabContent ? tabContent.offsetHeight : 0,
	        tabsHeight    = elements.wrapper.offsetHeight,
	        newHeight     = contentHeight + tabsHeight,
	        currentHeight = $element.prop('clientHeight');
	
	    if (currentHeight === newHeight) return;
	
	    // Adjusts calculations for when the buttons are bottom-aligned since this relies on absolute
	    // positioning.  This should probably be cleaned up if a cleaner solution is possible.
	    if ($element.attr('md-align-tabs') === 'bottom') {
	      currentHeight -= tabsHeight;
	      newHeight -= tabsHeight;
	      // Need to include bottom border in these calculations
	      if ($element.attr('md-border-bottom') !== undefined) {
	        ++currentHeight;
	      }
	    }
	
	    // Lock during animation so the user can't change tabs
	    locked = true;
	
	    var fromHeight = { height: currentHeight + 'px' },
	        toHeight = { height: newHeight + 'px' };
	
	    // Set the height to the current, specific pixel height to fix a bug on iOS where the height
	    // first animates to 0, then back to the proper height causing a visual glitch
	    $element.css(fromHeight);
	
	    // Animate the height from the old to the new
	    $animateCss($element, {
	      from: fromHeight,
	      to: toHeight,
	      easing: 'cubic-bezier(0.35, 0, 0.25, 1)',
	      duration: 0.5
	    }).start().done(function () {
	      // Then (to fix the same iOS issue as above), disable transitions and remove the specific
	      // pixel height so the height can size with browser width/content changes, etc.
	      $element.css({
	        transition: 'none',
	        height: ''
	      });
	
	      // In the next tick, re-allow transitions (if we do it all at once, $element.css is "smart"
	      // enough to batch it for us instead of doing it immediately, which undoes the original
	      // transition: none)
	      $mdUtil.nextTick(function() {
	        $element.css('transition', '');
	      });
	
	      // And unlock so tab changes can occur
	      locked = false;
	    });
	  }
	
	  /**
	   * Repositions the ink bar to the selected tab.
	   * Parameters are used when calling itself recursively when md-center-tabs is used as we need to
	   * run two passes to properly center the tabs. These parameters ensure that we only run two passes
	   * and that we don't run indefinitely.
	   * @param {number=} previousTotalWidth previous width of pagination wrapper
	   * @param {number=} previousWidthOfTabItems previous width of all tab items
	   */
	  function updateInkBarStyles (previousTotalWidth, previousWidthOfTabItems) {
	    if (ctrl.noInkBar) {
	      return;
	    }
	    var elements = getElements();
	
	    if (!elements.tabs[ ctrl.selectedIndex ]) {
	      angular.element(elements.inkBar).css({ left: 'auto', right: 'auto' });
	      return;
	    }
	
	    if (!ctrl.tabs.length) {
	      queue.push(ctrl.updateInkBarStyles);
	      return;
	    }
	    // If the element is not visible, we will not be able to calculate sizes until it becomes
	    // visible. We should treat that as a resize event rather than just updating the ink bar.
	    if (!$element.prop('offsetParent')) {
	      handleResizeWhenVisible();
	      return;
	    }
	
	    var index      = ctrl.selectedIndex,
	        totalWidth = elements.paging.offsetWidth,
	        tab        = elements.tabs[ index ],
	        left       = tab.offsetLeft,
	        right      = totalWidth - left - tab.offsetWidth;
	
	    if (ctrl.shouldCenterTabs) {
	      // We need to use the same calculate process as in the pagination wrapper, to avoid rounding
	      // deviations.
	      var totalWidthOfTabItems = calcTabsWidth(elements.tabs);
	
	      if (totalWidth > totalWidthOfTabItems &&
	          previousTotalWidth !== totalWidth &&
	          previousWidthOfTabItems !== totalWidthOfTabItems) {
	        $timeout(updateInkBarStyles, 0, true, totalWidth, totalWidthOfTabItems);
	      }
	    }
	    updateInkBarClassName();
	    angular.element(elements.inkBar).css({ left: left + 'px', right: right + 'px' });
	  }
	
	  /**
	   * Adds left/right classes so that the ink bar will animate properly.
	   */
	  function updateInkBarClassName () {
	    var elements = getElements();
	    var newIndex = ctrl.selectedIndex,
	        oldIndex = ctrl.lastSelectedIndex,
	        ink      = angular.element(elements.inkBar);
	    if (!angular.isNumber(oldIndex)) return;
	    ink
	        .toggleClass('md-left', newIndex < oldIndex)
	        .toggleClass('md-right', newIndex > oldIndex);
	  }
	
	  /**
	   * Takes an offset value and makes sure that it is within the min/max allowed values.
	   * @param {number} value
	   * @returns {number}
	   */
	  function fixOffset (value) {
	    var elements = getElements();
	
	    if (!elements.tabs.length || !ctrl.shouldPaginate) return 0;
	
	    var lastTab    = elements.tabs[ elements.tabs.length - 1 ],
	        totalWidth = lastTab.offsetLeft + lastTab.offsetWidth;
	
	    if (isRtl()) {
	      value = Math.min(elements.paging.offsetWidth - elements.canvas.clientWidth, value);
	      value = Math.max(0, value);
	    } else {
	      value = Math.max(0, value);
	      value = Math.min(totalWidth - elements.canvas.clientWidth, value);
	    }
	
	    return value;
	  }
	
	  /**
	   * Attaches a ripple to the tab item element.
	   * @param scope
	   * @param element
	   */
	  function attachRipple (scope, element) {
	    var elements = getElements();
	    var options = { colorElement: angular.element(elements.inkBar) };
	    $mdTabInkRipple.attach(scope, element, options);
	  }
	
	  /**
	   * Sets the `aria-controls` attribute to the elements that correspond to the passed-in tab.
	   * @param tab
	   */
	  function setAriaControls (tab) {
	    if (tab.hasContent) {
	      var nodes = $element[0].querySelectorAll('[md-tab-id="' + tab.id + '"]');
	      angular.element(nodes).attr('aria-controls', ctrl.tabContentPrefix + tab.id);
	    }
	  }
	
	  function isRtl() {
	    return $mdUtil.isRtl($attrs);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdTabs
	 * @module material.components.tabs
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-tabs>` directive serves as the container for 1..n
	 * <a ng-href="api/directive/mdTab">`<md-tab>`</a> child directives.
	 * In turn, the nested `<md-tab>` directive is used to specify a tab label for the
	 * **header button** and <i>optional</i> tab view content that will be associated with each tab
	 * button.
	 *
	 * Below is the markup for its simplest usage:
	 *
	 *  <hljs lang="html">
	 *  <md-tabs>
	 *    <md-tab label="Tab #1"></md-tab>
	 *    <md-tab label="Tab #2"></md-tab>
	 *    <md-tab label="Tab #3"></md-tab>
	 *  </md-tabs>
	 *  </hljs>
	 *
	 * Tabs support three (3) usage scenarios:
	 *
	 *  1. Tabs (buttons only)
	 *  2. Tabs with internal view content
	 *  3. Tabs with external view content
	 *
	 * **Tabs-only** support is useful when tab buttons are used for custom navigation regardless of any
	 * other components, content, or views.
	 *
	 * <blockquote><b>Note:</b> If you are using the Tabs component for page-level navigation, please
	 * use the <a ng-href="./api/directive/mdNavBar">NavBar component</a> instead. It handles this
	 * case a more natively and more performantly.</blockquote>
	 *
	 * **Tabs with internal views** are the traditional usage where each tab has associated view
	 * content and the view switching is managed internally by the Tabs component.
	 *
	 * **Tabs with external view content** is often useful when content associated with each tab is
	 * independently managed and data-binding notifications announce tab selection changes.
	 *
	 * Additional features include:
	 *
	 * *  Content can include any markup.
	 * *  If a tab is disabled while active/selected, then the next tab will be auto-selected.
	 *
	 * ### Theming
	 *
	 * By default, tabs use your app's accent color for the selected tab's text and ink bar.
	 *
	 * You can use the theming classes to change the color of the `md-tabs` background:
	 * * Applying `class="md-primary"` will use your app's primary color for the background, your
	 *   accent color for the ink bar, and your primary palette's contrast color for the text of the
	 *   selected tab.
	 *   * When using the `md-primary` class, you can add the `md-no-ink-bar-color` class to make the
	 *     ink bar use your theme's primary contrast color instead of the accent color.
	 * * Applying `class="md-accent"` will use your app's accent color for the background and your
	 *   accent palette's contrast color for the text and ink bar of the selected tab.
	 * * Applying `class="md-warn"` will use your app's warn color for the background and your
	 *   warn palette's contrast color for the text and ink bar of the selected tab.
	 *
	 * ### Explanation of tab stretching
	 *
	 * Initially, tabs will have an inherent size.  This size will either be defined by how much space
	 * is needed to accommodate their text or set by the user through CSS.
	 * Calculations will be based on this size.
	 *
	 * On mobile devices, tabs will be expanded to fill the available horizontal space.
	 * When this happens, all tabs will become the same size.
	 *
	 * On desktops, by default, stretching will never occur.
	 *
	 * This default behavior can be overridden through the `md-stretch-tabs` attribute.
	 * Here is a table showing when stretching will occur:
	 *
	 * `md-stretch-tabs` | mobile    | desktop
	 * ------------------|-----------|--------
	 * `auto`            | stretched | ---
	 * `always`          | stretched | stretched
	 * `never`           | ---       | ---
	 *
	 * @param {number=} md-selected Index of the active/selected tab.
	 * @param {expression=} md-no-ink-bar If `true` or no value, disables the selection ink bar.
	 * @param {string=} md-align-tabs Attribute to indicate position of tab buttons: `bottom` or `top`;
	 *  Default is `top`.
	 * @param {string=} md-stretch-tabs Attribute to indicate whether or not to stretch tabs: `auto`,
	 *  `always`, or `never`; Default is `auto`.
	 * @param {expression=} md-dynamic-height If `true` or no value, the tab wrapper will resize based
	 *  on the contents of the selected tab.
	 * @param {boolean=} md-border-bottom If the attribute is present, shows a solid `1px` border
	 *  between the tabs and their content.
	 * @param {boolean=} md-center-tabs If the attribute is present, tabs will be centered provided
	 *  there is no need for pagination.
	 * @param {boolean=} md-no-pagination If the attribute is present, pagination will remain off.
	 * @param {expression=} md-swipe-content When enabled, swipe gestures will be enabled for the content
	 *  area to allow swiping between tabs.
	 * @param {boolean=} md-enable-disconnect When enabled, scopes will be disconnected for tabs that
	 *  are not being displayed. This provides a performance boost, but may also cause unexpected
	 *  issues. It is not recommended for most users.
	 * @param {boolean=} md-autoselect If the attribute is present, any tabs added after the initial
	 *  load will be automatically selected.
	 * @param {boolean=} md-no-select-click When true, click events will not be fired when the value of
	 *  `md-active` on an `md-tab` changes. This is useful when using tabs with UI-Router's child
	 *  states, as triggering a click event in that case can cause an extra tab change to occur.
	 * @param {string=} md-navigation-hint Attribute to override the default `tablist` navigation hint
	 *  that screen readers will announce to provide instructions for navigating between tabs. This is
	 *  desirable when you want the hint to be in a different language. Default is "Use the left and
	 *  right arrow keys to navigate between tabs".
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-tabs md-selected="selectedIndex">
	 *   <img ng-src="img/angular.png" class="centered" alt="Angular icon">
	 *   <md-tab
	 *       ng-repeat="tab in tabs | orderBy:predicate:reversed"
	 *       md-on-select="onTabSelected(tab)"
	 *       md-on-deselect="announceDeselected(tab)"
	 *       ng-disabled="tab.disabled">
	 *     <md-tab-label>
	 *       {{tab.title}}
	 *       <img src="img/removeTab.png" ng-click="removeTab(tab)" class="delete" alt="Remove tab">
	 *     </md-tab-label>
	 *     <md-tab-body>
	 *       {{tab.content}}
	 *     </md-tab-body>
	 *   </md-tab>
	 * </md-tabs>
	 * </hljs>
	 *
	 */
	MdTabs.$inject = ["$$mdSvgRegistry"];
	angular
	    .module('material.components.tabs')
	    .directive('mdTabs', MdTabs);
	
	function MdTabs ($$mdSvgRegistry) {
	  return {
	    scope:            {
	      navigationHint: '@?mdNavigationHint',
	      selectedIndex: '=?mdSelected'
	    },
	    template:         function (element, attr) {
	      attr.$mdTabsTemplate = element.html();
	      return '' +
	        '<md-tabs-wrapper> ' +
	          '<md-tab-data></md-tab-data> ' +
	          '<md-prev-button ' +
	              'tabindex="-1" ' +
	              'role="button" ' +
	              'aria-label="Previous Page" ' +
	              'aria-disabled="{{!$mdTabsCtrl.canPageBack()}}" ' +
	              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageBack() }" ' +
	              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
	              'ng-click="$mdTabsCtrl.previousPage()"> ' +
	            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
	          '</md-prev-button> ' +
	          '<md-next-button ' +
	              'tabindex="-1" ' +
	              'role="button" ' +
	              'aria-label="Next Page" ' +
	              'aria-disabled="{{!$mdTabsCtrl.canPageForward()}}" ' +
	              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageForward() }" ' +
	              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
	              'ng-click="$mdTabsCtrl.nextPage()"> ' +
	            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
	          '</md-next-button> ' +
	          '<md-tabs-canvas ' +
	              'tabindex="{{ $mdTabsCtrl.hasFocus ? -1 : 0 }}" ' +
	              'ng-focus="$mdTabsCtrl.redirectFocus()" ' +
	              'ng-class="{ ' +
	                  '\'md-paginated\': $mdTabsCtrl.shouldPaginate, ' +
	                  '\'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs ' +
	              '}" ' +
	              'ng-keydown="$mdTabsCtrl.keydown($event)"> ' +
	            '<md-pagination-wrapper ' +
	                'ng-class="{ \'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs }" ' +
	                'md-tab-scroll="$mdTabsCtrl.scroll($event)" ' +
	                'role="tablist" ' +
	                'aria-label="{{::$mdTabsCtrl.navigationHint}}">' +
	              '<md-tab-item ' +
	                  'tabindex="{{ tab.isActive() ? 0 : -1 }}" ' +
	                  'class="md-tab {{::tab.scope.tabClass}}" ' +
	                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
	                  'role="tab" ' +
	                  'id="tab-item-{{::tab.id}}" ' +
	                  'md-tab-id="{{::tab.id}}" ' +
	                  'aria-selected="{{tab.isActive()}}" ' +
	                  'aria-disabled="{{tab.scope.disabled || \'false\'}}" ' +
	                  'ng-click="$mdTabsCtrl.select(tab.getIndex())" ' +
	                  'ng-focus="$mdTabsCtrl.hasFocus = true" ' +
	                  'ng-blur="$mdTabsCtrl.hasFocus = false" ' +
	                  'ng-class="{ ' +
	                      '\'md-active\':    tab.isActive(), ' +
	                      '\'md-focused\':   tab.hasFocus(), ' +
	                      '\'md-disabled\':  tab.scope.disabled ' +
	                  '}" ' +
	                  'ng-disabled="tab.scope.disabled" ' +
	                  'md-swipe-left="$mdTabsCtrl.nextPage()" ' +
	                  'md-swipe-right="$mdTabsCtrl.previousPage()" ' +
	                  'md-tabs-template="::tab.label" ' +
	                  'md-scope="::tab.parent"></md-tab-item> ' +
	              '<md-ink-bar></md-ink-bar> ' +
	            '</md-pagination-wrapper> ' +
	            '<md-tabs-dummy-wrapper aria-hidden="true" class="md-visually-hidden md-dummy-wrapper"> ' +
	              '<md-dummy-tab ' +
	                  'class="md-tab" ' +
	                  'tabindex="-1" ' +
	                  'ng-focus="$mdTabsCtrl.hasFocus = true" ' +
	                  'ng-blur="$mdTabsCtrl.hasFocus = false" ' +
	                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
	                  'md-tabs-template="::tab.label" ' +
	                  'md-scope="::tab.parent"></md-dummy-tab> ' +
	            '</md-tabs-dummy-wrapper> ' +
	          '</md-tabs-canvas> ' +
	        '</md-tabs-wrapper> ' +
	        '<md-tabs-content-wrapper ng-show="$mdTabsCtrl.hasContent && $mdTabsCtrl.selectedIndex >= 0" class="_md"> ' +
	          '<md-tab-content ' +
	              'id="{{:: $mdTabsCtrl.tabContentPrefix + tab.id}}" ' +
	              'class="_md" ' +
	              'role="tabpanel" ' +
	              'aria-labelledby="tab-item-{{::tab.id}}" ' +
	              'md-swipe-left="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(1)" ' +
	              'md-swipe-right="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(-1)" ' +
	              'ng-if="tab.hasContent" ' +
	              'ng-repeat="(index, tab) in $mdTabsCtrl.tabs" ' +
	              'ng-class="{ ' +
	                '\'md-no-transition\': $mdTabsCtrl.lastSelectedIndex == null, ' +
	                '\'md-active\':        tab.isActive(), ' +
	                '\'md-left\':          tab.isLeft(), ' +
	                '\'md-right\':         tab.isRight(), ' +
	                '\'md-no-scroll\':     $mdTabsCtrl.dynamicHeight ' +
	              '}"> ' +
	            '<div ' +
	                'md-tabs-template="::tab.template" ' +
	                'md-connected-if="tab.isActive()" ' +
	                'md-scope="::tab.parent" ' +
	                'ng-if="$mdTabsCtrl.enableDisconnect || tab.shouldRender()"></div> ' +
	          '</md-tab-content> ' +
	        '</md-tabs-content-wrapper>';
	    },
	    controller:       'MdTabsController',
	    controllerAs:     '$mdTabsCtrl',
	    bindToController: true
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsDummyWrapper.$inject = ["$mdUtil", "$window"];angular
	  .module('material.components.tabs')
	  .directive('mdTabsDummyWrapper', MdTabsDummyWrapper);
	
	/**
	 * @private
	 *
	 * @param $mdUtil
	 * @param $window
	 * @returns {{require: string, link: link}}
	 * @constructor
	 *
	 * @ngInject
	 */
	function MdTabsDummyWrapper ($mdUtil, $window) {
	  return {
	    require: '^?mdTabs',
	    link:    function link (scope, element, attr, ctrl) {
	      if (!ctrl) return;
	
	      var observer;
	      var disconnect;
	
	      var mutationCallback = function() {
	        ctrl.updatePagination();
	        ctrl.updateInkBarStyles();
	      };
	
	      if ('MutationObserver' in $window) {
	        var config = {
	          childList: true,
	          subtree: true,
	          // Per https://bugzilla.mozilla.org/show_bug.cgi?id=1138368, browsers will not fire
	          // the childList mutation, once a <span> element's innerText changes.
	          // The characterData of the <span> element will change.
	          characterData: true
	        };
	
	        observer = new MutationObserver(mutationCallback);
	        observer.observe(element[0], config);
	        disconnect = observer.disconnect.bind(observer);
	      } else {
	        var debounced = $mdUtil.debounce(mutationCallback, 15, null, false);
	
	        element.on('DOMSubtreeModified', debounced);
	        disconnect = element.off.bind(element, 'DOMSubtreeModified', debounced);
	      }
	
	      // Disconnect the observer
	      scope.$on('$destroy', function() {
	        disconnect();
	      });
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsTemplate.$inject = ["$compile", "$mdUtil"];angular
	    .module('material.components.tabs')
	    .directive('mdTabsTemplate', MdTabsTemplate);
	
	function MdTabsTemplate ($compile, $mdUtil) {
	  return {
	    restrict: 'A',
	    link:     link,
	    scope:    {
	      template:     '=mdTabsTemplate',
	      connected:    '=?mdConnectedIf',
	      compileScope: '=mdScope'
	    },
	    require:  '^?mdTabs'
	  };
	  function link (scope, element, attr, ctrl) {
	    if (!ctrl) return;
	
	    var compileScope = ctrl.enableDisconnect ? scope.compileScope.$new() : scope.compileScope;
	
	    element.html(scope.template);
	    $compile(element.contents())(compileScope);
	
	    return $mdUtil.nextTick(handleScope);
	
	    function handleScope () {
	      scope.$watch('connected', function (value) { value === false ? disconnect() : reconnect(); });
	      scope.$on('$destroy', reconnect);
	    }
	
	    function disconnect () {
	      if (ctrl.enableDisconnect) $mdUtil.disconnectScope(compileScope);
	    }
	
	    function reconnect () {
	      if (ctrl.enableDisconnect) $mdUtil.reconnectScope(compileScope);
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.toast
	 * @description
	 * Toast and Snackbar component.
	 */
	MdToastDirective.$inject = ["$mdToast"];
	MdToastProvider.$inject = ["$$interimElementProvider"];
	angular.module('material.components.toast', [
	  'material.core',
	  'material.components.button'
	])
	  .directive('mdToast', MdToastDirective)
	  .provider('$mdToast', MdToastProvider);
	
	/* @ngInject */
	function MdToastDirective($mdToast) {
	  return {
	    restrict: 'E',
	    link: function postLink(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      // When navigation force destroys an interimElement, then
	      // listen and $destroy() that interim instance...
	      scope.$on('$destroy', function() {
	        $mdToast.destroy();
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $mdToast
	 * @module material.components.toast
	 *
	 * @description
	 * `$mdToast` is a service to build a toast notification on any position
	 * on the screen with an optional duration, and provides a simple promise API.
	 *
	 * The toast will be always positioned at the `bottom`, when the screen size is
	 * between `600px` and `959px` (`sm` breakpoint)
	 *
	 * ## Restrictions on custom toasts
	 * - The toast's template must have an outer `<md-toast>` element.
	 * - For a toast action, use element with class `md-action`.
	 * - Add the class `md-capsule` for curved corners.
	 *
	 * ### Custom Presets
	 * Developers are also able to create their own preset, which can be easily used without repeating
	 * their options each time.
	 *
	 * <hljs lang="js">
	 *   $mdToastProvider.addPreset('testPreset', {
	 *     options: function() {
	 *       return {
	 *         template:
	 *           '<md-toast>' +
	 *             '<div class="md-toast-content">' +
	 *               'This is a custom preset' +
	 *             '</div>' +
	 *           '</md-toast>',
	 *         controllerAs: 'toast',
	 *         bindToController: true
	 *       };
	 *     }
	 *   });
	 * </hljs>
	 *
	 * After you created your preset at config phase, you can easily access it.
	 *
	 * <hljs lang="js">
	 *   $mdToast.show(
	 *     $mdToast.testPreset()
	 *   );
	 * </hljs>
	 *
	 * ## Parent container notes
	 *
	 * The toast is positioned using absolute positioning relative to its first non-static parent
	 * container. Thus, if the requested parent container uses static positioning, we will temporarily
	 * set its positioning to `relative` while the toast is visible and reset it when the toast is
	 * hidden.
	 *
	 * Because of this, it is usually best to ensure that the parent container has a fixed height and
	 * prevents scrolling by setting the `overflow: hidden;` style. Since the position is based off of
	 * the parent's height, the toast may be mispositioned if you allow the parent to scroll.
	 *
	 * You can, however, have a scrollable element inside of the container; just make sure the
	 * container itself does not scroll.
	 *
	 * <hljs lang="html">
	 * <div layout-fill id="toast-container">
	 *   <md-content>
	 *     I can have lots of content and scroll!
	 *   </md-content>
	 * </div>
	 * </hljs>
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div ng-controller="MyController">
	 *   <md-button ng-click="openToast()">
	 *     Open a Toast!
	 *   </md-button>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="js">
	 * var app = angular.module('app', ['ngMaterial']);
	 * app.controller('MyController', function($scope, $mdToast) {
	 *   $scope.openToast = function($event) {
	 *     $mdToast.show($mdToast.simple().textContent('Hello!'));
	 *     // Could also do $mdToast.showSimple('Hello');
	 *   };
	 * });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#showSimple
	 *
	 * @param {string} message The message to display inside the toast
	 * @description
	 * Convenience method which builds and shows a simple toast.
	 *
	 * @returns {promise} A promise that can be resolved with `$mdToast.hide()`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#simple
	 *
	 * @description
	 * Builds a preconfigured toast.
	 *
	 * @returns {obj} a `$mdToastPreset` with the following chainable configuration methods.
	 *
	 * _**Note:** These configuration methods are provided in addition to the methods provided by
	 * the `build()` and `show()` methods below._
	 *
	 * <table class="md-api-table methods">
	 *    <thead>
	 *      <tr>
	 *        <th>Method</th>
	 *        <th>Description</th>
	 *      </tr>
	 *    </thead>
	 *    <tbody>
	 *      <tr>
	 *        <td>`.textContent(string)`</td>
	 *        <td>Sets the toast content to the specified string</td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.action(string)`</td>
	 *        <td>
	 *          Adds an action button. <br/>
	 *          If clicked, the promise (returned from `show()`) will resolve with the value `'ok'`;
	 *          otherwise, it is resolved with `true` after a `hideDelay` timeout.
	 *        </td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.actionKey(string)`</td>
	 *        <td>
	 *          Adds a hotkey for the action button to the page. <br/>
	 *          If the `actionKey` and `Control` key are pressed, the toast's action will be triggered.
	 *        </td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.actionHint(string)`</td>
	 *        <td>
	 *          Text that a screen reader will announce to let the user know how to activate the
	 *          action. <br>
	 *          If an `actionKey` is defined, this defaults to:
	 *          'Press Control-"`actionKey`" to ' followed by the `action`.
	 *        </td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.dismissHint(string)`</td>
	 *        <td>
	 *          Text that a screen reader will announce to let the user know how to dismiss the toast.
	 *          <br>Defaults to: "Press Escape to dismiss."
	 *        </td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.highlightAction(boolean)`</td>
	 *        <td>
	 *          Whether or not the action button will have an additional highlight class.<br/>
	 *          By default the `accent` color will be applied to the action button.
	 *        </td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.highlightClass(string)`</td>
	 *        <td>
	 *          If set, the given class will be applied to the highlighted action button.<br/>
	 *          This allows you to specify the highlight color easily. Highlight classes are
	 *          `md-primary`, `md-warn`, and `md-accent`
	 *        </td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.capsule(boolean)`</td>
	 *        <td>
	 *          Whether or not to add the `md-capsule` class to the toast to provide rounded corners
	 *        </td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.theme(string)`</td>
	 *        <td>
	 *          Sets the theme on the toast to the requested theme. Default is `$mdThemingProvider`'s
	 *          default.
	 *        </td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.toastClass(string)`</td>
	 *        <td>Sets a class on the toast element</td>
	 *      </tr>
	 *    </tbody>
	 * </table>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#updateTextContent
	 *
	 * @description
	 * Updates the content of an existing toast. Useful for updating things like counts, etc.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#build
	 *
	 * @description
	 * Creates a custom `$mdToastPreset` that you can configure.
	 *
	 * @returns {obj} a `$mdToastPreset` with the chainable configuration methods for shows' options
	 *   (see below).
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#show
	 *
	 * @description Shows the toast.
	 *
	 * @param {Object} optionsOrPreset Either provide an `$mdToastPreset` returned from `simple()`
	 * and `build()`, or an options object with the following properties:
	 *
	 *   - `templateUrl` - `{string=}`: The url of an html template file that will
	 *     be used as the content of the toast. Restrictions: the template must
	 *     have an outer `md-toast` element.
	 *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
	 *     template string.
	 *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template content with a
	 *     `<div class="md-toast-content">` if one is not provided. Defaults to true. Can be disabled
	 *     if you provide a custom toast directive.
	 *   - `scope` - `{Object=}`: the scope to link the template / controller to. If none is specified,
	 *     it will create a new child scope. This scope will be destroyed when the toast is removed
	 *     unless `preserveScope` is set to true.
	 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed.
	 *     Default is false
	 *   - `hideDelay` - `{number=}`: The number of milliseconds the toast should stay active before
	 *     automatically closing. Set to `0` or `false` to have the toast stay open until closed
	 *     manually via an action in the toast, a hotkey, or a swipe gesture. For accessibility, toasts
	 *     should not automatically close when they contain an action.<br>
	 *     Defaults to: `3000`.
	 *   - `position` - `{string=}`: Sets the position of the toast. <br/>
	 *     Available: any combination of `'bottom'`, `'left'`, `'top'`, `'right'`, `'end'`, and
	 *     `'start'`. The properties `'end'` and `'start'` are dynamic and can be used for RTL support.
	 *     <br/>
	 *     Default combination: `'bottom left'`.
	 *   - `toastClass` - `{string=}`: A class to set on the toast element.
	 *   - `controller` - `{string=}`: The controller to associate with this toast.
	 *     The controller will be injected the local `$mdToast.hide()`, which is a function
	 *     used to hide the toast.
	 *   - `locals` - `{Object=}`: An object containing key/value pairs. The keys will be used as names
	 *     of values to inject into the controller. For example, `locals: {three: 3}` would inject
	 *     `three` into the controller with the value of 3.
	 *   - `bindToController` - `{boolean=}`: bind the locals to the controller, instead of passing
	 *     them in.
	 *   - `resolve` - `{Object=}`: Similar to locals, except it takes promises as values
	 *     and the toast will not open until the promises resolve.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	 *   - `parent` - `{element=}`: The element to append the toast to. Defaults to appending
	 *     to the root element of the application.
	 *
	 * @returns {promise} A promise that can be resolved with `$mdToast.hide()`. `$mdToast.hide()` will
	 * resolve either with the boolean value `true` or the value passed as an argument to
	 * `$mdToast.hide()`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#hide
	 *
	 * @description
	 * Hide an existing toast and resolve the promise returned from `$mdToast.show()`.
	 *
	 * @param {*=} response An argument for the resolved promise.
	 *
	 * @returns {promise} A promise that is called when the existing element is removed from the DOM.
	 * The promise is resolved with either the Boolean value `true` or the value passed as the
	 * argument to `$mdToast.hide()`.
	 */
	
	function MdToastProvider($$interimElementProvider) {
	  // Differentiate promise resolves: hide timeout (value == true) and hide action clicks
	  // (value == ok).
	  MdToastController.$inject = ["$mdToast", "$scope", "$log"];
	  toastDefaultOptions.$inject = ["$animate", "$mdToast", "$mdUtil", "$mdMedia", "$document", "$q"];
	  var ACTION_RESOLVE = 'ok';
	
	  var activeToastContent;
	  var $mdToast = $$interimElementProvider('$mdToast')
	    .setDefaults({
	      methods: ['position', 'hideDelay', 'capsule', 'parent', 'position', 'toastClass'],
	      options: toastDefaultOptions
	    })
	    .addPreset('simple', {
	      argOption: 'textContent',
	      methods: ['textContent', 'action', 'actionKey', 'actionHint', 'highlightAction',
	                'highlightClass', 'theme', 'parent', 'dismissHint'],
	      options: /* @ngInject */ ["$mdToast", "$mdTheming", function($mdToast, $mdTheming) {
	        return {
	          template:
	            '<md-toast md-theme="{{ toast.theme }}" ng-class="{\'md-capsule\': toast.capsule}">' +
	            '  <div class="md-toast-content" aria-live="polite" aria-relevant="all">' +
	            '    <span class="md-toast-text">' +
	            '      {{ toast.content }}' +
	            '    </span>' +
	            '    <span class="md-visually-hidden">{{ toast.dismissHint }}</span>' +
	            '    <span class="md-visually-hidden" ng-if="toast.action && toast.actionKey">' +
	            '      {{ toast.actionHint }}' +
	            '    </span>' +
	            '    <md-button class="md-action" ng-if="toast.action" ng-click="toast.resolve()" ' +
	            '               ng-class="highlightClasses">' +
	            '      {{ toast.action }}' +
	            '    </md-button>' +
	            '  </div>' +
	            '</md-toast>',
	          controller: MdToastController,
	          theme: $mdTheming.defaultTheme(),
	          controllerAs: 'toast',
	          bindToController: true
	        };
	      }]
	    })
	    .addMethod('updateTextContent', updateTextContent);
	
	    function updateTextContent(newContent) {
	      activeToastContent = newContent;
	    }
	
	    return $mdToast;
	
	  /**
	   * Controller for the Toast interim elements.
	   * @ngInject
	   */
	  function MdToastController($mdToast, $scope, $log) {
	    // For compatibility with AngularJS 1.6+, we should always use the $onInit hook in
	    // interimElements. The $mdCompiler simulates the $onInit hook for all versions.
	    this.$onInit = function() {
	      var self = this;
	
	      if (self.highlightAction) {
	        $scope.highlightClasses = [
	          'md-highlight',
	          self.highlightClass
	        ];
	      }
	
	      // If an action is defined and no actionKey is specified, then log a warning.
	      if (self.action && !self.actionKey) {
	        $log.warn('Toasts with actions should define an actionKey for accessibility.',
	          'Details: https://material.angularjs.org/latest/api/service/$mdToast#mdtoast-simple');
	      }
	
	      if (self.actionKey && !self.actionHint) {
	        self.actionHint = 'Press Control-"' + self.actionKey + '" to ';
	      }
	
	      if (!self.dismissHint) {
	        self.dismissHint = 'Press Escape to dismiss.';
	      }
	
	      $scope.$watch(function() { return activeToastContent; }, function() {
	        self.content = activeToastContent;
	      });
	
	      this.resolve = function() {
	        $mdToast.hide(ACTION_RESOLVE);
	      };
	    };
	  }
	
	  /* @ngInject */
	  function toastDefaultOptions($animate, $mdToast, $mdUtil, $mdMedia, $document, $q) {
	    var SWIPE_EVENTS = '$md.swipeleft $md.swiperight $md.swipeup $md.swipedown';
	    return {
	      onShow: onShow,
	      onRemove: onRemove,
	      toastClass: '',
	      position: 'bottom left',
	      themable: true,
	      hideDelay: 3000,
	      autoWrap: true,
	      transformTemplate: function(template, options) {
	        var shouldAddWrapper = options.autoWrap && template && !/md-toast-content/g.test(template);
	
	        if (shouldAddWrapper) {
	          // Root element of template will be <md-toast>. We need to wrap all of its content inside
	          // of <div class="md-toast-content">. All templates provided here should be static,
	          // developer-controlled content (meaning we're not attempting to guard against XSS).
	          var templateRoot = document.createElement('md-template');
	          templateRoot.innerHTML = template;
	
	          // Iterate through all root children, to detect possible md-toast directives.
	          for (var i = 0; i < templateRoot.children.length; i++) {
	            if (templateRoot.children[i].nodeName === 'MD-TOAST') {
	              var wrapper = angular.element('<div class="md-toast-content">');
	
	              // Wrap the children of the `md-toast` directive in jqLite, to be able to append
	              // multiple nodes with the same execution.
	              wrapper.append(angular.element(templateRoot.children[i].childNodes));
	
	              // Append the new wrapped element to the `md-toast` directive.
	              templateRoot.children[i].appendChild(wrapper[0]);
	            }
	          }
	
	          // We have to return the innerHTML, because we do not want to have the `md-template`
	          // element to be the root element of our interimElement.
	          return templateRoot.innerHTML;
	        }
	
	        return template || '';
	      }
	    };
	
	    /**
	     * @param {{toast: {actionKey: string=}}=} scope
	     * @param {JQLite} element
	     * @param {Object.<string, string>} options
	     * @return {*}
	     */
	    function onShow(scope, element, options) {
	      activeToastContent = options.textContent;
	
	      var isSmScreen = !$mdMedia('gt-sm');
	
	      element = $mdUtil.extractElementByName(element, 'md-toast', true);
	      options.element = element;
	
	      options.onSwipe = function(ev) {
	        // Add the relevant swipe class to the element so it can animate correctly
	        var swipe = ev.type.replace('$md.','');
	        var direction = swipe.replace('swipe', '');
	
	        // If the swipe direction is down/up but the toast came from top/bottom don't fade away
	        // Unless the screen is small, then the toast always on bottom
	        if ((direction === 'down' && options.position.indexOf('top') !== -1 && !isSmScreen) ||
	            (direction === 'up' && (options.position.indexOf('bottom') !== -1 || isSmScreen))) {
	          return;
	        }
	
	        if ((direction === 'left' || direction === 'right') && isSmScreen) {
	          return;
	        }
	
	        element.addClass('md-' + swipe);
	        $mdUtil.nextTick($mdToast.cancel);
	      };
	      options.openClass = toastOpenClass(options.position);
	
	      element.addClass(options.toastClass);
	
	      // 'top left' -> 'md-top md-left'
	      options.parent.addClass(options.openClass);
	
	      // static is the default position
	      if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
	        options.parent.css('position', 'relative');
	      }
	
	      setupActionKeyListener(scope.toast && scope.toast.actionKey ?
	        scope.toast.actionKey : undefined);
	
	      element.on(SWIPE_EVENTS, options.onSwipe);
	
	      var verticalPositionDefined = false;
	      var positionClasses = options.position.split(' ').map(function (position) {
	        if (position) {
	          var className = 'md-' + position;
	          if (className === 'md-top' || className === 'md-bottom') {
	            verticalPositionDefined = true;
	          }
	          return className;
	        }
	        return 'md-bottom';
	      });
	      // If only "right" or "left" are defined, default to a vertical position of "bottom"
	      // as documented.
	      if (!verticalPositionDefined) {
	        positionClasses.push('md-bottom');
	      }
	      element.addClass(isSmScreen ? 'md-bottom' : positionClasses.join(' '));
	
	      if (options.parent) {
	        options.parent.addClass('md-toast-animating');
	      }
	      return $animate.enter(element, options.parent).then(function() {
	        if (options.parent) {
	          options.parent.removeClass('md-toast-animating');
	        }
	      });
	    }
	
	    /**
	     * @param {Object} scope the toast's scope
	     * @param {JQLite} element the toast to be removed
	     * @param {Object} options
	     * @return {Promise<*>} a Promise to remove the element immediately or to animate it out.
	     */
	    function onRemove(scope, element, options) {
	      if (scope.toast && scope.toast.actionKey) {
	        removeActionKeyListener();
	      }
	      element.off(SWIPE_EVENTS, options.onSwipe);
	      if (options.parent) options.parent.addClass('md-toast-animating');
	      if (options.openClass) options.parent.removeClass(options.openClass);
	
	      // Don't run the leave animation if the element has already been destroyed.
	      return ((options.$destroy === true) ? $q.when(element.remove()) : $animate.leave(element))
	        .then(function () {
	          if (options.parent) options.parent.removeClass('md-toast-animating');
	          if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
	            options.parent.css('position', '');
	          }
	        });
	    }
	
	    function toastOpenClass(position) {
	      // For mobile, always open full-width on bottom
	      if (!$mdMedia('gt-xs')) {
	        return 'md-toast-open-bottom';
	      }
	
	      return 'md-toast-open-' + (position.indexOf('top') > -1 ? 'top' : 'bottom');
	    }
	
	    /**
	     * @param {string} actionKey
	     */
	    function setupActionKeyListener(actionKey) {
	      /**
	       * @param {KeyboardEvent} event
	       */
	      var handleKeyDown = function(event) {
	        if (event.key === 'Escape') {
	          $mdToast.hide(false);
	        }
	        if (actionKey && event.key === actionKey && event.ctrlKey) {
	          $mdToast.hide(ACTION_RESOLVE);
	        }
	      };
	      $document.on('keydown', handleKeyDown);
	    }
	
	    function removeActionKeyListener() {
	      $document.off('keydown');
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.toolbar
	 */
	mdToolbarDirective.$inject = ["$$rAF", "$mdConstant", "$mdUtil", "$mdTheming", "$animate", "$timeout"];
	angular.module('material.components.toolbar', [
	  'material.core',
	  'material.components.content'
	])
	  .directive('mdToolbar', mdToolbarDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdToolbar
	 * @module material.components.toolbar
	 * @restrict E
	 * @description
	 * `md-toolbar` is used to place a toolbar in your app.
	 *
	 * Toolbars are usually used above a content area to display the title of the
	 * current page, and show relevant action buttons for that page.
	 *
	 * You can change the height of the toolbar by adding either the
	 * `md-medium-tall` or `md-tall` class to the toolbar.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div layout="column" layout-fill>
	 *   <md-toolbar>
	 *
	 *     <div class="md-toolbar-tools">
	 *       <h2 md-truncate flex>My App's Title</h2>
	 *
	 *       <md-button>
	 *         Right Bar Button
	 *       </md-button>
	 *     </div>
	 *
	 *   </md-toolbar>
	 *   <md-content>
	 *     Hello!
	 *   </md-content>
	 * </div>
	 * </hljs>
	 *
	 * <i><b>Note:</b> The code above shows usage with the `md-truncate` component which provides an
	 * ellipsis if the title is longer than the width of the Toolbar.</i>
	 *
	 * ## CSS & Styles
	 *
	 * The `<md-toolbar>` provides a few custom CSS classes that you may use to enhance the
	 * functionality of your toolbar.
	 *
	 * <div>
	 * <docs-css-api-table>
	 *
	 *   <docs-css-selector code="md-toolbar .md-toolbar-tools">
	 *     The `md-toolbar-tools` class provides quite a bit of automatic styling for your toolbar
	 *     buttons and text. When applied, it will center the buttons and text vertically for you.
	 *   </docs-css-selector>
	 *
	 * </docs-css-api-table>
	 * </div>
	 *
	 * ### Private Classes
	 *
	 * Currently, the only private class is the `md-toolbar-transitions` class. All other classes are
	 * considered public.
	 *
	 * @param {boolean=} md-scroll-shrink Whether the header should shrink away as
	 * the user scrolls down, and reveal itself as the user scrolls up.
	 *
	 * _**Note (1):** for scrollShrink to work, the toolbar must be a sibling of a
	 * `md-content` element, placed before it. See the scroll shrink demo._
	 *
	 * _**Note (2):** The `md-scroll-shrink` attribute is only parsed on component
	 * initialization, it does not watch for scope changes._
	 *
	 *
	 * @param {number=} md-shrink-speed-factor How much to change the speed of the toolbar's
	 * shrinking by. For example, if 0.25 is given then the toolbar will shrink
	 * at one fourth the rate at which the user scrolls down. Default 0.5.
	 *
	 */
	
	function mdToolbarDirective($$rAF, $mdConstant, $mdUtil, $mdTheming, $animate, $timeout) {
	  var translateY = angular.bind(null, $mdUtil.supplant, 'translate3d(0,{0}px,0)');
	
	  return {
	    template: '',
	    restrict: 'E',
	
	    link: function(scope, element, attr) {
	
	      element.addClass('_md');     // private md component indicator for styling
	      $mdTheming(element);
	
	      $mdUtil.nextTick(function () {
	        element.addClass('_md-toolbar-transitions');     // adding toolbar transitions after digest
	      }, false);
	
	      if (angular.isDefined(attr.mdScrollShrink)) {
	        setupScrollShrink();
	      }
	
	      function setupScrollShrink() {
	
	        var toolbarHeight;
	        var contentElement;
	        var disableScrollShrink = angular.noop;
	
	        // Current "y" position of scroll
	        // Store the last scroll top position
	        var y = 0;
	        var prevScrollTop = 0;
	        var shrinkSpeedFactor = attr.mdShrinkSpeedFactor || 0.5;
	
	        var debouncedContentScroll = $$rAF.throttle(onContentScroll);
	        var debouncedUpdateHeight = $mdUtil.debounce(updateToolbarHeight, 5 * 1000);
	
	        // Wait for $mdContentLoaded event from mdContent directive.
	        // If the mdContent element is a sibling of our toolbar, hook it up
	        // to scroll events.
	
	        scope.$on('$mdContentLoaded', onMdContentLoad);
	
	        // If the toolbar is used inside an ng-if statement, we may miss the
	        // $mdContentLoaded event, so we attempt to fake it if we have a
	        // md-content close enough.
	
	        attr.$observe('mdScrollShrink', onChangeScrollShrink);
	
	        // If the toolbar has ngShow or ngHide we need to update height immediately as it changed
	        // and not wait for $mdUtil.debounce to happen
	
	        if (attr.ngShow) { scope.$watch(attr.ngShow, updateToolbarHeight); }
	        if (attr.ngHide) { scope.$watch(attr.ngHide, updateToolbarHeight); }
	
	        // If the scope is destroyed (which could happen with ng-if), make sure
	        // to disable scroll shrinking again
	
	        scope.$on('$destroy', disableScrollShrink);
	
	        /**
	         * @param {string} shrinkWithScroll value of md-scroll-shrink attribute
	         */
	        function onChangeScrollShrink(shrinkWithScroll) {
	          var closestContent = $mdUtil.getSiblings(element, 'md-content');
	
	          // If there are content elements, fake the call using the first content element.
	          // This might still fail if the content element isn't a sibling of the toolbar.
	          if (!contentElement && closestContent.length) {
	            onMdContentLoad(null, closestContent[0]);
	          }
	
	          // Evaluate the expression
	          shrinkWithScroll = scope.$eval(shrinkWithScroll);
	
	          // Disable only if the attribute's expression evaluates to false
	          if (shrinkWithScroll === false) {
	            disableScrollShrink();
	          } else {
	            disableScrollShrink = enableScrollShrink();
	          }
	        }
	
	        /**
	         * @param {null} $event $mdContentLoaded always has a null event
	         * @param {JQLite} newContentEl JQLite object containing an md-content
	         */
	        function onMdContentLoad($event, newContentEl) {
	          // Toolbar and content must be siblings
	          if (newContentEl && element.parent()[0] === newContentEl.parent()[0]) {
	            // unhook old content event listener if exists
	            if (contentElement) {
	              contentElement.off('scroll', debouncedContentScroll);
	            }
	
	            contentElement = newContentEl;
	            disableScrollShrink = enableScrollShrink();
	          }
	        }
	
	        /**
	         *
	         */
	        function onContentScroll(e) {
	          var scrollTop = e ? e.target.scrollTop : prevScrollTop;
	
	          debouncedUpdateHeight();
	
	          y = Math.min(
	            toolbarHeight / shrinkSpeedFactor,
	            Math.max(0, y + scrollTop - prevScrollTop)
	          );
	
	          element.css($mdConstant.CSS.TRANSFORM, translateY([-y * shrinkSpeedFactor]));
	          contentElement.css($mdConstant.CSS.TRANSFORM, translateY([(toolbarHeight - y) * shrinkSpeedFactor]));
	
	          prevScrollTop = scrollTop;
	
	          $mdUtil.nextTick(function() {
	            var hasWhiteFrame = element.hasClass('md-whiteframe-z1');
	
	            if (hasWhiteFrame && !y) {
	              $animate.removeClass(element, 'md-whiteframe-z1');
	            } else if (!hasWhiteFrame && y) {
	              $animate.addClass(element, 'md-whiteframe-z1');
	            }
	          });
	
	        }
	
	        /**
	         *
	         */
	        function enableScrollShrink() {
	          if (!contentElement)     return angular.noop;           // no md-content
	
	          contentElement.on('scroll', debouncedContentScroll);
	          contentElement.attr('scroll-shrink', 'true');
	
	          $timeout(updateToolbarHeight);
	
	          return function disableScrollShrink() {
	            contentElement.off('scroll', debouncedContentScroll);
	            contentElement.attr('scroll-shrink', 'false');
	
	            updateToolbarHeight();
	          };
	        }
	
	        /**
	         *
	         */
	        function updateToolbarHeight() {
	          toolbarHeight = element.prop('offsetHeight');
	          // Add a negative margin-top the size of the toolbar to the content el.
	          // The content will start transformed down the toolbarHeight amount,
	          // so everything looks normal.
	          //
	          // As the user scrolls down, the content will be transformed up slowly
	          // to put the content underneath where the toolbar was.
	          var margin = (-toolbarHeight * shrinkSpeedFactor) + 'px';
	
	          contentElement.css({
	            "margin-top": margin,
	            "margin-bottom": margin
	          });
	
	          onContentScroll();
	        }
	
	      }
	
	    }
	  };
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.tooltip
	 */
	MdTooltipDirective.$inject = ["$timeout", "$window", "$$rAF", "$document", "$interpolate", "$mdUtil", "$mdPanel", "$$mdTooltipRegistry"];
	angular
	    .module('material.components.tooltip', [
	      'material.core',
	      'material.components.panel'
	    ])
	    .directive('mdTooltip', MdTooltipDirective)
	    .service('$$mdTooltipRegistry', MdTooltipRegistry);
	
	
	/**
	 * @ngdoc directive
	 * @name mdTooltip
	 * @module material.components.tooltip
	 * @description
	 * Tooltips are used to describe elements that are interactive and primarily
	 * graphical (not textual).
	 *
	 * Place a `<md-tooltip>` as a child of the element it describes.
	 *
	 * A tooltip will activate when the user hovers over, focuses, or touches the
	 * parent element.
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-button class="md-fab md-accent" aria-label="Play">
	 *     <md-tooltip>Play Music</md-tooltip>
	 *     <md-icon md-svg-src="img/icons/ic_play_arrow_24px.svg"></md-icon>
	 *   </md-button>
	 * </hljs>
	 *
	 * @param {number=} md-z-index The visual level that the tooltip will appear
	 *     in comparison with the rest of the elements of the application.
	 * @param {expression=} md-visible Boolean bound to whether the tooltip is
	 *     currently visible.
	 * @param {number=} md-delay How many milliseconds to wait to show the tooltip
	 *     after the user hovers over, focuses, or touches the parent element.
	 *     Defaults to 0ms on non-touch devices and 75ms on touch.
	 * @param {boolean=} md-autohide If present or provided with a boolean value,
	 *     the tooltip will hide on mouse leave, regardless of focus.
	 * @param {string=} md-direction The direction that the tooltip is shown,
	 *     relative to the parent element. Supports top, right, bottom, and left.
	 *     Defaults to bottom.
	 */
	function MdTooltipDirective($timeout, $window, $$rAF, $document, $interpolate,
	    $mdUtil, $mdPanel, $$mdTooltipRegistry) {
	
	  var ENTER_EVENTS = 'focus touchstart mouseenter';
	  var LEAVE_EVENTS = 'blur touchcancel mouseleave';
	  var TOOLTIP_DEFAULT_Z_INDEX = 100;
	  var TOOLTIP_DEFAULT_SHOW_DELAY = 0;
	  var TOOLTIP_DEFAULT_DIRECTION = 'bottom';
	  var TOOLTIP_DIRECTIONS = {
	    top: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.ABOVE },
	    right: { x: $mdPanel.xPosition.OFFSET_END, y: $mdPanel.yPosition.CENTER },
	    bottom: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.BELOW },
	    left: { x: $mdPanel.xPosition.OFFSET_START, y: $mdPanel.yPosition.CENTER }
	  };
	
	  return {
	    restrict: 'E',
	    priority: 210, // Before ngAria
	    scope: {
	      mdZIndex: '=?mdZIndex',
	      mdDelay: '=?mdDelay',
	      mdVisible: '=?mdVisible',
	      mdAutohide: '=?mdAutohide',
	      mdDirection: '@?mdDirection' // Do not expect expressions.
	    },
	    link: linkFunc
	  };
	
	  function linkFunc(scope, element, attr) {
	    // Set constants.
	    var tooltipId = 'md-tooltip-' + $mdUtil.nextUid();
	    var parent = $mdUtil.getParentWithPointerEvents(element);
	    var debouncedOnResize = $$rAF.throttle(updatePosition);
	    var mouseActive = false;
	    var origin, position, panelPosition, panelRef, autohide, showTimeout,
	        elementFocusedOnWindowBlur = null;
	
	    // Set defaults
	    setDefaults();
	
	    // Set parent aria-label.
	    addAriaLabel();
	
	    // Remove the element from its current DOM position.
	    element.detach();
	
	    updatePosition();
	    bindEvents();
	    configureWatchers();
	
	    function setDefaults() {
	      scope.mdZIndex = scope.mdZIndex || TOOLTIP_DEFAULT_Z_INDEX;
	      scope.mdDelay = scope.mdDelay || TOOLTIP_DEFAULT_SHOW_DELAY;
	      if (!TOOLTIP_DIRECTIONS[scope.mdDirection]) {
	        scope.mdDirection = TOOLTIP_DEFAULT_DIRECTION;
	      }
	    }
	
	    function addAriaLabel(labelText) {
	      // Only interpolate the text from the HTML element because otherwise the custom text could
	      // be interpolated twice and cause XSS violations.
	      var interpolatedText = labelText || $interpolate(element.text().trim())(scope.$parent);
	
	      // Only add the `aria-label` to the parent if there isn't already one, if there isn't an
	      // already present `aria-labelledby`, or if the previous `aria-label` was added by the
	      // tooltip directive.
	      if (
	        (!parent.attr('aria-label') && !parent.attr('aria-labelledby')) ||
	        parent.attr('md-labeled-by-tooltip')
	      ) {
	        parent.attr('aria-label', interpolatedText);
	
	        // Set the `md-labeled-by-tooltip` attribute if it has not already been set.
	        if (!parent.attr('md-labeled-by-tooltip')) {
	          parent.attr('md-labeled-by-tooltip', tooltipId);
	        }
	      }
	    }
	
	    function updatePosition() {
	      setDefaults();
	
	      // If the panel has already been created, remove the current origin
	      // class from the panel element.
	      if (panelRef && panelRef.panelEl) {
	        panelRef.panelEl.removeClass(origin);
	      }
	
	      // Set the panel element origin class based off of the current
	      // mdDirection.
	      origin = 'md-origin-' + scope.mdDirection;
	
	      // Create the position of the panel based off of the mdDirection.
	      position = TOOLTIP_DIRECTIONS[scope.mdDirection];
	
	      // Using the newly created position object, use the MdPanel
	      // panelPosition API to build the panel's position.
	      panelPosition = $mdPanel.newPanelPosition()
	          .relativeTo(parent)
	          .addPanelPosition(position.x, position.y);
	
	      // If the panel has already been created, add the new origin class to
	      // the panel element and update it's position with the panelPosition.
	      if (panelRef && panelRef.panelEl) {
	        panelRef.panelEl.addClass(origin);
	        panelRef.updatePosition(panelPosition);
	      }
	    }
	
	    function bindEvents() {
	      // Add a mutationObserver where there is support for it and the need
	      // for it in the form of viable host(parent[0]).
	      if (parent[0] && 'MutationObserver' in $window) {
	        // Use a mutationObserver to tackle #2602.
	        var attributeObserver = new MutationObserver(function(mutations) {
	          if (isDisabledMutation(mutations)) {
	            $mdUtil.nextTick(function() {
	              setVisible(false);
	            });
	          }
	        });
	
	        attributeObserver.observe(parent[0], {
	          attributes: true
	        });
	      }
	
	      elementFocusedOnWindowBlur = false;
	
	      $$mdTooltipRegistry.register('scroll', windowScrollEventHandler, true);
	      $$mdTooltipRegistry.register('blur', windowBlurEventHandler);
	      $$mdTooltipRegistry.register('resize', debouncedOnResize);
	
	      scope.$on('$destroy', onDestroy);
	
	      // To avoid 'synthetic clicks', we listen to mousedown instead of
	      // 'click'.
	      parent.on('mousedown', mousedownEventHandler);
	      parent.on(ENTER_EVENTS, enterEventHandler);
	
	      function isDisabledMutation(mutations) {
	        mutations.some(function(mutation) {
	          return mutation.attributeName === 'disabled' && parent[0].disabled;
	        });
	        return false;
	      }
	
	      function windowScrollEventHandler() {
	        setVisible(false);
	      }
	
	      function windowBlurEventHandler() {
	        elementFocusedOnWindowBlur = document.activeElement === parent[0];
	      }
	
	      function enterEventHandler($event) {
	        // Prevent the tooltip from showing when the window is receiving
	        // focus.
	        if ($event.type === 'focus' && elementFocusedOnWindowBlur) {
	          elementFocusedOnWindowBlur = false;
	        } else if (!scope.mdVisible) {
	          parent.on(LEAVE_EVENTS, leaveEventHandler);
	          setVisible(true);
	
	          // If the user is on a touch device, we should bind the tap away
	          // after the 'touched' in order to prevent the tooltip being
	          // removed immediately.
	          if ($event.type === 'touchstart') {
	            parent.one('touchend', function() {
	              $mdUtil.nextTick(function() {
	                $document.one('touchend', leaveEventHandler);
	              }, false);
	            });
	          }
	        }
	      }
	
	      function leaveEventHandler() {
	        autohide = scope.hasOwnProperty('mdAutohide') ?
	            scope.mdAutohide :
	            attr.hasOwnProperty('mdAutohide');
	
	        if (autohide || mouseActive ||
	            $document[0].activeElement !== parent[0]) {
	          // When a show timeout is currently in progress, then we have
	          // to cancel it, otherwise the tooltip will remain showing
	          // without focus or hover.
	          if (showTimeout) {
	            $timeout.cancel(showTimeout);
	            setVisible.queued = false;
	            showTimeout = null;
	          }
	
	          parent.off(LEAVE_EVENTS, leaveEventHandler);
	          parent.triggerHandler('blur');
	          setVisible(false);
	        }
	        mouseActive = false;
	      }
	
	      function mousedownEventHandler() {
	        mouseActive = true;
	      }
	
	      function onDestroy() {
	        $$mdTooltipRegistry.deregister('scroll', windowScrollEventHandler, true);
	        $$mdTooltipRegistry.deregister('blur', windowBlurEventHandler);
	        $$mdTooltipRegistry.deregister('resize', debouncedOnResize);
	
	        parent
	            .off(ENTER_EVENTS, enterEventHandler)
	            .off(LEAVE_EVENTS, leaveEventHandler)
	            .off('mousedown', mousedownEventHandler);
	
	        // Trigger the handler in case any of the tooltips are
	        // still visible.
	        leaveEventHandler();
	        attributeObserver && attributeObserver.disconnect();
	      }
	    }
	
	    function configureWatchers() {
	      if (element[0] && 'MutationObserver' in $window) {
	        var attributeObserver = new MutationObserver(function(mutations) {
	          mutations.forEach(function(mutation) {
	            if (mutation.attributeName === 'md-visible' &&
	                !scope.visibleWatcher) {
	              scope.visibleWatcher = scope.$watch('mdVisible',
	                  onVisibleChanged);
	            }
	          });
	        });
	
	        attributeObserver.observe(element[0], {
	          attributes: true
	        });
	
	        // Build watcher only if mdVisible is being used.
	        if (attr.hasOwnProperty('mdVisible')) {
	          scope.visibleWatcher = scope.$watch('mdVisible',
	              onVisibleChanged);
	        }
	      } else {
	        // MutationObserver not supported
	        scope.visibleWatcher = scope.$watch('mdVisible', onVisibleChanged);
	      }
	
	      // Direction watcher
	      scope.$watch('mdDirection', updatePosition);
	
	      // Clean up if the element or parent was removed via jqLite's .remove.
	      // A couple of notes:
	      //   - In these cases the scope might not have been destroyed, which
	      //     is why we destroy it manually. An example of this can be having
	      //     `md-visible="false"` and adding tooltips while they're
	      //     invisible. If `md-visible` becomes true, at some point, you'd
	      //     usually get a lot of tooltips.
	      //   - We use `.one`, not `.on`, because this only needs to fire once.
	      //     If we were using `.on`, it would get thrown into an infinite
	      //     loop.
	      //   - This kicks off the scope's `$destroy` event which finishes the
	      //     cleanup.
	      element.one('$destroy', onElementDestroy);
	      parent.one('$destroy', onElementDestroy);
	      scope.$on('$destroy', function() {
	        setVisible(false);
	        panelRef && panelRef.destroy();
	        attributeObserver && attributeObserver.disconnect();
	        element.remove();
	      });
	
	      // Updates the aria-label when the element text changes. This watch
	      // doesn't need to be set up if the element doesn't have any data
	      // bindings.
	      if (element.text().indexOf($interpolate.startSymbol()) > -1) {
	        scope.$watch(function() {
	          return element.text().trim();
	        }, addAriaLabel);
	      }
	
	      function onElementDestroy() {
	        scope.$destroy();
	      }
	    }
	
	    function setVisible(value) {
	      // Break if passed value is already in queue or there is no queue and
	      // passed value is current in the controller.
	      if (setVisible.queued && setVisible.value === !!value ||
	          !setVisible.queued && scope.mdVisible === !!value) {
	        return;
	      }
	      setVisible.value = !!value;
	
	      if (!setVisible.queued) {
	        if (value) {
	          setVisible.queued = true;
	          showTimeout = $timeout(function() {
	            scope.mdVisible = setVisible.value;
	            setVisible.queued = false;
	            showTimeout = null;
	            if (!scope.visibleWatcher) {
	              onVisibleChanged(scope.mdVisible);
	            }
	          }, scope.mdDelay);
	        } else {
	          $mdUtil.nextTick(function() {
	            scope.mdVisible = false;
	            if (!scope.visibleWatcher) {
	              onVisibleChanged(false);
	            }
	          });
	        }
	      }
	    }
	
	    function onVisibleChanged(isVisible) {
	      isVisible ? showTooltip() : hideTooltip();
	    }
	
	    function showTooltip() {
	      // Do not show the tooltip if the text is empty.
	      if (!element[0].textContent.trim()) {
	        throw new Error('Text for the tooltip has not been provided. ' +
	            'Please include text within the mdTooltip element.');
	      }
	
	      if (!panelRef) {
	        var attachTo = angular.element(document.body);
	        var panelAnimation = $mdPanel.newPanelAnimation()
	            .openFrom(parent)
	            .closeTo(parent)
	            .withAnimation({
	              open: 'md-show',
	              close: 'md-hide'
	            });
	
	        var panelConfig = {
	          id: tooltipId,
	          attachTo: attachTo,
	          contentElement: element,
	          propagateContainerEvents: true,
	          panelClass: 'md-tooltip',
	          animation: panelAnimation,
	          position: panelPosition,
	          zIndex: scope.mdZIndex,
	          focusOnOpen: false,
	          onDomAdded: function() {
	            panelRef.panelEl.addClass(origin);
	          }
	        };
	
	        panelRef = $mdPanel.create(panelConfig);
	      }
	
	      panelRef.open().then(function() {
	        panelRef.panelEl.attr('role', 'tooltip');
	      });
	    }
	
	    function hideTooltip() {
	      panelRef && panelRef.close();
	    }
	  }
	
	}
	
	
	/**
	 * Service that is used to reduce the amount of listeners that are being
	 * registered on the `window` by the tooltip component. Works by collecting
	 * the individual event handlers and dispatching them from a global handler.
	 *
	 * @ngInject
	 */
	function MdTooltipRegistry() {
	  var listeners = {};
	  var ngWindow = angular.element(window);
	
	  return {
	    register: register,
	    deregister: deregister
	  };
	
	  /**
	   * Global event handler that dispatches the registered handlers in the
	   * service.
	   * @param {!Event} event Event object passed in by the browser
	   */
	  function globalEventHandler(event) {
	    if (listeners[event.type]) {
	      listeners[event.type].forEach(function(currentHandler) {
	        currentHandler.call(this, event);
	      }, this);
	    }
	  }
	
	  /**
	   * Registers a new handler with the service.
	   * @param {string} type Type of event to be registered.
	   * @param {!Function} handler Event handler.
	   * @param {boolean} useCapture Whether to use event capturing.
	   */
	  function register(type, handler, useCapture) {
	    var handlers = listeners[type] = listeners[type] || [];
	
	    if (!handlers.length) {
	      useCapture ? window.addEventListener(type, globalEventHandler, true) :
	          ngWindow.on(type, globalEventHandler);
	    }
	
	    if (handlers.indexOf(handler) === -1) {
	      handlers.push(handler);
	    }
	  }
	
	  /**
	   * Removes an event handler from the service.
	   * @param {string} type Type of event handler.
	   * @param {!Function} handler The event handler itself.
	   * @param {boolean} useCapture Whether the event handler used event capturing.
	   */
	  function deregister(type, handler, useCapture) {
	    var handlers = listeners[type];
	    var index = handlers ? handlers.indexOf(handler) : -1;
	
	    if (index > -1) {
	      handlers.splice(index, 1);
	
	      if (handlers.length === 0) {
	        useCapture ? window.removeEventListener(type, globalEventHandler, true) :
	            ngWindow.off(type, globalEventHandler);
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.truncate
	 */
	MdTruncateController.$inject = ["$element"];
	angular.module('material.components.truncate', ['material.core'])
	  .directive('mdTruncate', MdTruncateDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdTruncate
	 * @module material.components.truncate
	 * @restrict AE
	 * @description
	 *
	 * The `md-truncate` component displays a label that will automatically clip text which is wider
	 * than the component. By default, it displays an ellipsis, but you may apply the `md-clip` CSS
	 * class to override this default and use a standard "clipping" approach.
	 *
	 * <i><b>Note:</b> The `md-truncate` component does not automatically adjust it's width. You must
	 * provide the `flex` attribute, or some other CSS-based width management. See the
	 * <a ng-href="./demo/truncate">demos</a> for examples.</i>
	 *
	 * @usage
	 *
	 * ### As an Element
	 *
	 * <hljs lang="html">
	 *   <div layout="row">
	 *     <md-button>Back</md-button>
	 *
	 *     <md-truncate flex>Chapter 1 - The Way of the Old West</md-truncate>
	 *
	 *     <md-button>Forward</md-button>
	 *   </div>
	 * </hljs>
	 *
	 * ### As an Attribute
	 *
	 * <hljs lang="html">
	 *   <h2 md-truncate style="max-width: 100px;">Some Title With a Lot of Text</h2>
	 * </hljs>
	 *
	 * ## CSS & Styles
	 *
	 * `<md-truncate>` provides two CSS classes that you may use to control the type of clipping.
	 *
	 * <i><b>Note:</b> The `md-truncate` also applies a setting of `width: 0;` when used with the `flex`
	 * attribute to fix an issue with the flex element not shrinking properly.</i>
	 *
	 * <div>
	 * <docs-css-api-table>
	 *
	 *   <docs-css-selector code=".md-ellipsis">
	 *     Assigns the "ellipsis" behavior (default) which will cut off mid-word and append an ellipsis
	 *     (&hellip;) to the end of the text.
	 *   </docs-css-selector>
	 *
	 *   <docs-css-selector code=".md-clip">
	 *     Assigns the "clipping" behavior which will simply chop off the text. This may happen
	 *     mid-word or even mid-character.
	 *   </docs-css-selector>
	 *
	 * </docs-css-api-table>
	 * </div>
	 */
	function MdTruncateDirective() {
	  return {
	    restrict: 'AE',
	
	    controller: MdTruncateController
	  };
	}
	
	/**
	 * Controller for the <md-truncate> component.
	 *
	 * @param $element The md-truncate element.
	 *
	 * @constructor
	 * @ngInject
	 */
	function MdTruncateController($element) {
	  $element.addClass('md-truncate');
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.virtualRepeat
	 */
	VirtualRepeatContainerController.$inject = ["$$rAF", "$mdUtil", "$mdConstant", "$parse", "$rootScope", "$window", "$scope", "$element", "$attrs"];
	VirtualRepeatController.$inject = ["$scope", "$element", "$attrs", "$browser", "$document", "$rootScope", "$$rAF", "$mdUtil"];
	VirtualRepeatDirective.$inject = ["$parse"];
	angular.module('material.components.virtualRepeat', [
	  'material.core',
	  'material.components.showHide'
	])
	.directive('mdVirtualRepeatContainer', VirtualRepeatContainerDirective)
	.directive('mdVirtualRepeat', VirtualRepeatDirective)
	.directive('mdForceHeight', ForceHeightDirective);
	
	
	/**
	 * @ngdoc directive
	 * @name mdVirtualRepeatContainer
	 * @module material.components.virtualRepeat
	 * @restrict E
	 * @description
	 * `md-virtual-repeat-container` provides the scroll container for
	 * <a ng-href="api/directive/mdVirtualRepeat">md-virtual-repeat</a>.
	 *
	 * VirtualRepeat is a limited substitute for `ng-repeat` that renders only
	 * enough DOM nodes to fill the container, recycling them as the user scrolls.
	 *
	 * Once an element is not visible anymore, the Virtual Repeat recycles the element and reuses it
	 * for another visible item by replacing the previous data set with the set of currently visible
	 * elements.
	 *
	 * ### Common Issues
	 *
	 * - When having one-time bindings inside of the view template, the Virtual Repeat will not properly
	 *   update the bindings for new items, since the view will be recycled.
	 * - Directives inside of a Virtual Repeat will be only compiled (linked) once, because those
	 *   items will be recycled and used for other items.
	 *   The Virtual Repeat just updates the scope bindings.
	 *
	 *
	 * ### Notes
	 *
	 * > The VirtualRepeat is a similar implementation to the Android
	 * [RecyclerView](https://developer.android.com/reference/android/support/v7/widget/RecyclerView.html).
	 *
	 * <!-- This comment forces a break between blockquotes //-->
	 *
	 * > Please also review the <a ng-href="api/directive/mdVirtualRepeat">mdVirtualRepeat</a>
	 * documentation for more information.
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-virtual-repeat-container md-top-index="topIndex">
	 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 * </hljs>
	 *
	 * @param {boolean=} md-auto-shrink When present and the container will shrink to fit
	 *     the number of items in the `md-virtual-repeat`.
	 * @param {number=} md-auto-shrink-min Minimum number of items that md-auto-shrink
	 *     will shrink to. Default: `0`.
	 * @param {boolean=} md-orient-horizontal Whether the container should scroll horizontally.
	 *     The default is `false` which indicates vertical orientation and scrolling.
	 * @param {number=} md-top-index Binds the index of the item that is at the top of the scroll
	 *     container to `$scope`. It can both read and set the scroll position.
	 */
	function VirtualRepeatContainerDirective() {
	  return {
	    controller: VirtualRepeatContainerController,
	    template: virtualRepeatContainerTemplate,
	    compile: function virtualRepeatContainerCompile($element, $attrs) {
	      $element
	          .addClass('md-virtual-repeat-container')
	          .addClass($attrs.hasOwnProperty('mdOrientHorizontal')
	              ? 'md-orient-horizontal'
	              : 'md-orient-vertical');
	    }
	  };
	}
	
	
	function virtualRepeatContainerTemplate($element) {
	  return '<div class="md-virtual-repeat-scroller" role="presentation">' +
	    '<div class="md-virtual-repeat-sizer" role="presentation"></div>' +
	    '<div class="md-virtual-repeat-offsetter" role="presentation">' +
	      $element[0].innerHTML +
	    '</div></div>';
	}
	
	/**
	 * Number of additional elements to render above and below the visible area inside
	 * of the virtual repeat container. A higher number results in less flicker when scrolling
	 * very quickly in Safari, but comes with a higher rendering and dirty-checking cost.
	 * @const {number}
	 */
	var NUM_EXTRA = 3;
	
	/** @ngInject */
	function VirtualRepeatContainerController($$rAF, $mdUtil, $mdConstant, $parse, $rootScope, $window,
	                                          $scope, $element, $attrs) {
	  this.$rootScope = $rootScope;
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	
	  /** @type {number} The width or height of the container */
	  this.size = 0;
	  /** @type {number} The scroll width or height of the scroller */
	  this.scrollSize = 0;
	  /** @type {number} The scrollLeft or scrollTop of the scroller */
	  this.scrollOffset = 0;
	  /** @type {boolean} Whether the scroller is oriented horizontally */
	  this.horizontal = this.$attrs.hasOwnProperty('mdOrientHorizontal');
	  /** @type {!VirtualRepeatController} The repeater inside of this container */
	  this.repeater = null;
	  /** @type {boolean} Whether auto-shrink is enabled */
	  this.autoShrink = this.$attrs.hasOwnProperty('mdAutoShrink');
	  /** @type {number} Minimum number of items to auto-shrink to */
	  this.autoShrinkMin = parseInt(this.$attrs.mdAutoShrinkMin, 10) || 0;
	  /** @type {?number} Original container size when shrank */
	  this.originalSize = null;
	  /** @type {number} Amount to offset the total scroll size by. */
	  this.offsetSize = parseInt(this.$attrs.mdOffsetSize, 10) || 0;
	  /** @type {?string} height or width element style on the container prior to auto-shrinking. */
	  this.oldElementSize = null;
	  /** @type {!number} Maximum amount of pixels allowed for a single DOM element */
	  this.maxElementPixels = $mdConstant.ELEMENT_MAX_PIXELS;
	  /** @type {string}  Direction of the text */
	  this.ltr = !$mdUtil.isRtl(this.$attrs);
	
	  if (this.$attrs.mdTopIndex) {
	    /** @type {function(angular.Scope): number} Binds to topIndex on AngularJS scope */
	    this.bindTopIndex = $parse(this.$attrs.mdTopIndex);
	    /** @type {number} The index of the item that is at the top of the scroll container */
	    this.topIndex = this.bindTopIndex(this.$scope);
	
	    if (!angular.isDefined(this.topIndex)) {
	      this.topIndex = 0;
	      this.bindTopIndex.assign(this.$scope, 0);
	    }
	
	    this.$scope.$watch(this.bindTopIndex, angular.bind(this, function(newIndex) {
	      if (newIndex !== this.topIndex) {
	        this.scrollToIndex(newIndex);
	      }
	    }));
	  } else {
	    this.topIndex = 0;
	  }
	
	  this.scroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	  this.sizer = this.scroller.querySelector('.md-virtual-repeat-sizer');
	  this.offsetter = this.scroller.querySelector('.md-virtual-repeat-offsetter');
	
	  // After the DOM stabilizes, measure the initial size of the container and
	  // make a best effort at re-measuring as it changes.
	  var boundUpdateSize = angular.bind(this, this.updateSize);
	
	  $$rAF(angular.bind(this, function() {
	    boundUpdateSize();
	
	    var debouncedUpdateSize = $mdUtil.debounce(boundUpdateSize, 10, null, false);
	    var jWindow = angular.element($window);
	
	    // Make one more attempt to get the size if it is 0.
	    // This is not by any means a perfect approach, but there's really no
	    // silver bullet here.
	    if (!this.size) {
	      debouncedUpdateSize();
	    }
	
	    jWindow.on('resize', debouncedUpdateSize);
	    $scope.$on('$destroy', function() {
	      jWindow.off('resize', debouncedUpdateSize);
	    });
	
	    $scope.$emit('$md-resize-enable');
	    $scope.$on('$md-resize', boundUpdateSize);
	  }));
	}
	
	
	/** Called by the md-virtual-repeat inside of the container at startup. */
	VirtualRepeatContainerController.prototype.register = function(repeaterCtrl) {
	  this.repeater = repeaterCtrl;
	
	  angular.element(this.scroller)
	      .on('scroll wheel touchmove touchend', angular.bind(this, this.handleScroll_));
	};
	
	
	/** @return {boolean} Whether the container is configured for horizontal scrolling. */
	VirtualRepeatContainerController.prototype.isHorizontal = function() {
	  return this.horizontal;
	};
	
	
	/** @return {number} The size (width or height) of the container. */
	VirtualRepeatContainerController.prototype.getSize = function() {
	  return this.size;
	};
	
	
	/**
	 * Resizes the container.
	 * @private
	 * @param {number} size The new size to set.
	 */
	VirtualRepeatContainerController.prototype.setSize_ = function(size) {
	  var dimension = this.getDimensionName_();
	
	  this.size = size;
	  this.$element[0].style[dimension] = size + 'px';
	};
	
	
	VirtualRepeatContainerController.prototype.unsetSize_ = function() {
	  this.$element[0].style[this.getDimensionName_()] = this.oldElementSize;
	  this.oldElementSize = null;
	};
	
	
	/** Instructs the container to re-measure its size. */
	VirtualRepeatContainerController.prototype.updateSize = function() {
	  // If the original size is already determined, we can skip the update.
	  if (this.originalSize) return;
	
	  var size = this.isHorizontal()
	      ? this.$element[0].clientWidth
	      : this.$element[0].clientHeight;
	
	  if (size) {
	    this.size = size;
	  }
	
	  // Recheck the scroll position after updating the size. This resolves
	  // problems that can result if the scroll position was measured while the
	  // element was display: none or detached from the document.
	  this.handleScroll_();
	
	  this.repeater && this.repeater.containerUpdated();
	};
	
	
	/** @return {number} The container's scrollHeight or scrollWidth. */
	VirtualRepeatContainerController.prototype.getScrollSize = function() {
	  return this.scrollSize;
	};
	
	/**
	 * @returns {string} either width or height dimension
	 * @private
	 */
	VirtualRepeatContainerController.prototype.getDimensionName_ = function() {
	  return this.isHorizontal() ? 'width' : 'height';
	};
	
	
	/**
	 * Sets the scroller element to the specified size.
	 * @private
	 * @param {number} size The new size.
	 */
	VirtualRepeatContainerController.prototype.sizeScroller_ = function(size) {
	  var dimension =  this.getDimensionName_();
	  var crossDimension = this.isHorizontal() ? 'height' : 'width';
	
	  // Clear any existing dimensions.
	  this.sizer.innerHTML = '';
	
	  // If the size falls within the browser's maximum explicit size for a single element, we can
	  // set the size and be done. Otherwise, we have to create children that add up the the desired
	  // size.
	  if (size < this.maxElementPixels) {
	    this.sizer.style[dimension] = size + 'px';
	  } else {
	    this.sizer.style[dimension] = 'auto';
	    this.sizer.style[crossDimension] = 'auto';
	
	    // Divide the total size we have to render into N max-size pieces.
	    var numChildren = Math.floor(size / this.maxElementPixels);
	
	    // Element template to clone for each max-size piece.
	    var sizerChild = document.createElement('div');
	    sizerChild.style[dimension] = this.maxElementPixels + 'px';
	    sizerChild.style[crossDimension] = '1px';
	
	    for (var i = 0; i < numChildren; i++) {
	      this.sizer.appendChild(sizerChild.cloneNode(false));
	    }
	
	    // Re-use the element template for the remainder.
	    sizerChild.style[dimension] = (size - (numChildren * this.maxElementPixels)) + 'px';
	    this.sizer.appendChild(sizerChild);
	  }
	};
	
	
	/**
	 * If auto-shrinking is enabled, shrinks or unshrinks as appropriate.
	 * @private
	 * @param {number} size The new size.
	 */
	VirtualRepeatContainerController.prototype.autoShrink_ = function(size) {
	  var shrinkSize = Math.max(size, this.autoShrinkMin * this.repeater.getItemSize());
	
	  if (this.autoShrink && shrinkSize !== this.size) {
	    if (this.oldElementSize === null) {
	      this.oldElementSize = this.$element[0].style[this.getDimensionName_()];
	    }
	
	    var currentSize = this.originalSize || this.size;
	
	    if (!currentSize || shrinkSize < currentSize) {
	      if (!this.originalSize) {
	        this.originalSize = this.size;
	      }
	
	      // Now we update the containers size, because shrinking is enabled.
	      this.setSize_(shrinkSize);
	    } else if (this.originalSize !== null) {
	      // Set the size back to our initial size.
	      this.unsetSize_();
	
	      var _originalSize = this.originalSize;
	      this.originalSize = null;
	
	      // We determine the repeaters size again, if the original size was zero.
	      // The originalSize needs to be null, to be able to determine the size.
	      if (!_originalSize) this.updateSize();
	
	      // Apply the original size or the determined size back to the container, because
	      // it has been overwritten before, in the shrink block.
	      this.setSize_(_originalSize || this.size);
	    }
	
	    this.repeater.containerUpdated();
	  }
	};
	
	
	/**
	 * Sets the scrollHeight or scrollWidth. Called by the repeater based on
	 * its item count and item size.
	 * @param {number} itemsSize The total size of the items.
	 */
	VirtualRepeatContainerController.prototype.setScrollSize = function(itemsSize) {
	  var size = itemsSize + this.offsetSize;
	  if (this.scrollSize === size) return;
	
	  this.sizeScroller_(size);
	  this.autoShrink_(size);
	  this.scrollSize = size;
	};
	
	
	/** @return {number} The container's current scroll offset. */
	VirtualRepeatContainerController.prototype.getScrollOffset = function() {
	  return this.scrollOffset;
	};
	
	/**
	 * Scrolls to a given scrollTop position.
	 * @param {number} position
	 */
	VirtualRepeatContainerController.prototype.scrollTo = function(position) {
	  this.scroller[this.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = position;
	  this.handleScroll_();
	};
	
	/**
	 * Scrolls the item with the given index to the top of the scroll container.
	 * @param {number} index
	 */
	VirtualRepeatContainerController.prototype.scrollToIndex = function(index) {
	  var itemSize = this.repeater.getItemSize();
	  var itemsLength = this.repeater.itemsLength;
	  if (index > itemsLength) {
	    index = itemsLength - 1;
	  }
	  this.scrollTo(itemSize * index);
	};
	
	VirtualRepeatContainerController.prototype.resetScroll = function() {
	  this.scrollTo(0);
	};
	
	
	VirtualRepeatContainerController.prototype.handleScroll_ = function() {
	  if (!this.ltr && !this.maxSize) {
	    this.scroller.scrollLeft = this.scrollSize;
	    this.maxSize = this.scroller.scrollLeft;
	  }
	  var offset = this.isHorizontal() ?
	      (this.ltr ? this.scroller.scrollLeft : this.maxSize - this.scroller.scrollLeft)
	      : this.scroller.scrollTop;
	  if (this.scrollSize < this.size) return;
	  if (offset > this.scrollSize - this.size) {
	    offset = this.scrollSize - this.size;
	  }
	  if (offset === this.scrollOffset) return;
	
	  var itemSize = this.repeater.getItemSize();
	  if (!itemSize) return;
	
	  var numItems = Math.max(0, Math.floor(offset / itemSize) - NUM_EXTRA);
	
	  var transform = (this.isHorizontal() ? 'translateX(' : 'translateY(') +
	      (!this.isHorizontal() || this.ltr ? (numItems * itemSize) : - (numItems * itemSize))  + 'px)';
	
	  this.scrollOffset = offset;
	  this.offsetter.style.webkitTransform = transform;
	  this.offsetter.style.transform = transform;
	
	  if (this.bindTopIndex) {
	    var topIndex = Math.floor(offset / itemSize);
	    if (topIndex !== this.topIndex && topIndex < this.repeater.getItemCount()) {
	      this.topIndex = topIndex;
	      this.bindTopIndex.assign(this.$scope, topIndex);
	      if (!this.$rootScope.$$phase) this.$scope.$digest();
	    }
	  }
	
	  this.repeater.containerUpdated();
	};
	
	
	/**
	 * @ngdoc directive
	 * @name mdVirtualRepeat
	 * @module material.components.virtualRepeat
	 * @restrict A
	 * @priority 1000
	 * @description
	 * The `md-virtual-repeat` attribute is applied to a template that is repeated using virtual
	 * scrolling. This provides smooth and performant scrolling through very large lists of elements.
	 *
	 * Virtual repeat is a limited substitute for `ng-repeat` that renders only
	 * enough DOM nodes to fill the container, recycling them as the user scrolls.
	 *
	 * ### Notes
	 *
	 * - Arrays are supported for iteration by default.
	 * - An object can used use if `md-on-demand` is specified and the object implements the interface
	 *   described in the `md-on-demand` <a ng-href="#attributes">documentation</a>.
	 * - `trackBy`, `as` alias, and `(key, value)` syntax from `ng-repeat` are not supported.
	 *
	 * ### On-Demand Async Item Loading
	 *
	 * When using the `md-on-demand` attribute and loading some asynchronous data,
	 * the `getItemAtIndex` function will mostly return nothing.
	 *
	 * <hljs lang="js">
	 *   DynamicItems.prototype.getItemAtIndex = function(index) {
	 *     if (this.pages[index]) {
	 *       return this.pages[index];
	 *     } else {
	 *       // This is an asynchronous action and does not return any value.
	 *       this.loadPage(index);
	 *     }
	 *   };
	 * </hljs>
	 *
	 * This means that the Virtual Repeat will not have any value for the given index.<br/>
	 * After the data loading completes, the user expects the Virtual Repeat to recognize the change.
	 *
	 * To make sure that the Virtual Repeat properly detects any change, you need to run the operation
	 * in another digest.
	 *
	 * <hljs lang="js">
	 *   DynamicItems.prototype.loadPage = function(index) {
	 *     var self = this;
	 *
	 *     // Trigger a new digest by using $timeout
	 *     $timeout(function() {
	 *       self.pages[index] = Data;
	 *     });
	 *   };
	 * </hljs>
	 *
	 * > <b>Note:</b> Please also review the
	 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation
	 *   for more information.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-virtual-repeat-container>
	 *   <div md-virtual-repeat="i in items">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 *
	 * <md-virtual-repeat-container md-orient-horizontal>
	 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 * </hljs>
	 *
	 * @param {expression=} md-extra-name Evaluates to an additional name to which the current iterated
	 *   item can be assigned on the repeated scope (needed for use in `md-autocomplete`).
	 * @param {number=} md-item-size Optional height or width of the repeated elements (which **must be
	 *   identical for each element**). Virtual repeat will attempt to read the size from the DOM,
	 *   if missing, but it still assumes that all repeated nodes have the **same height**
	 *   (when scrolling vertically) or **same width** (when scrolling horizontally).
	 * @param {boolean=} md-on-demand When present, treats the `md-virtual-repeat` argument as an object
	 *   that can fetch rows rather than an array.
	 *
	 *   **NOTE:** This object **must** implement the following interface with two methods:
	 *
	 *   - `getItemAtIndex` - `{function(index): Object}`: The item at that `index` or `null` if it is
	 *     not yet loaded (it should start downloading the item in that case).
	 *   - `getLength` - `{function(): number}`: The data length to which the repeater container
	 *     should be sized. Ideally, when the count is known, this method should return it.
	 *     Otherwise, return a higher number than the currently loaded items to produce an
	 *     infinite-scroll behavior.
	 */
	function VirtualRepeatDirective($parse) {
	  return {
	    controller: VirtualRepeatController,
	    priority: 1000,
	    require: ['mdVirtualRepeat', '^^mdVirtualRepeatContainer'],
	    restrict: 'A',
	    terminal: true,
	    transclude: 'element',
	    compile: function VirtualRepeatCompile($element, $attrs) {
	      var expression = $attrs.mdVirtualRepeat;
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)\s*$/);
	      var repeatName = match[1];
	      var repeatListExpression = $parse(match[2]);
	      var extraName = $attrs.mdExtraName && $parse($attrs.mdExtraName);
	
	      return function VirtualRepeatLink($scope, $element, $attrs, ctrl, $transclude) {
	        ctrl[0].link_(ctrl[1], $transclude, repeatName, repeatListExpression, extraName);
	      };
	    }
	  };
	}
	
	
	/** @ngInject */
	function VirtualRepeatController($scope, $element, $attrs, $browser, $document, $rootScope,
	    $$rAF, $mdUtil) {
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$browser = $browser;
	  this.$document = $document;
	  this.$mdUtil = $mdUtil;
	  this.$rootScope = $rootScope;
	  this.$$rAF = $$rAF;
	
	  /** @type {boolean} Whether we are in on-demand mode. */
	  this.onDemand = $mdUtil.parseAttributeBoolean($attrs.mdOnDemand);
	  /** @type {!Function} Backup reference to $browser.$$checkUrlChange */
	  this.browserCheckUrlChange = $browser.$$checkUrlChange;
	  /** @type {number} Most recent starting repeat index (based on scroll offset) */
	  this.newStartIndex = 0;
	  /** @type {number} Most recent ending repeat index (based on scroll offset) */
	  this.newEndIndex = 0;
	  /** @type {number} Most recent end visible index (based on scroll offset) */
	  this.newVisibleEnd = 0;
	  /** @type {number} Previous starting repeat index (based on scroll offset) */
	  this.startIndex = 0;
	  /** @type {number} Previous ending repeat index (based on scroll offset) */
	  this.endIndex = 0;
	  /** @type {?number} Height/width of repeated elements. */
	  this.itemSize = $scope.$eval($attrs.mdItemSize) || null;
	
	  /** @type {boolean} Whether this is the first time that items are rendered. */
	  this.isFirstRender = true;
	
	  /**
	   * @private {boolean} Whether the items in the list are already being updated. Used to prevent
	   *     nested calls to virtualRepeatUpdate_.
	   */
	  this.isVirtualRepeatUpdating_ = false;
	
	  /** @type {number} Most recently seen length of items. */
	  this.itemsLength = 0;
	
	  /**
	   * @type {!Function} Unwatch callback for item size (when md-items-size is
	   *     not specified), or angular.noop otherwise.
	   */
	  this.unwatchItemSize_ = angular.noop;
	
	  /**
	   * Presently rendered blocks by repeat index.
	   * @type {Object<number, !VirtualRepeatController.Block>}
	   */
	  this.blocks = {};
	  /** @type {Array<!VirtualRepeatController.Block>} A pool of presently unused blocks. */
	  this.pooledBlocks = [];
	
	  $scope.$on('$destroy', angular.bind(this, this.cleanupBlocks_));
	}
	
	
	/**
	 * An object representing a repeated item.
	 * @typedef {{element: !jqLite, new: boolean, scope: !angular.Scope}}
	 */
	VirtualRepeatController.Block;
	
	
	/**
	 * Called at startup by the md-virtual-repeat postLink function.
	 * @param {!VirtualRepeatContainerController} container The container's controller.
	 * @param {!Function} transclude The repeated element's bound transclude function.
	 * @param {string} repeatName The left hand side of the repeat expression, indicating
	 *     the name for each item in the array.
	 * @param {!Function} repeatListExpression A compiled expression based on the right hand side
	 *     of the repeat expression. Points to the array to repeat over.
	 * @param {string|undefined} extraName The optional extra repeatName.
	 */
	VirtualRepeatController.prototype.link_ =
	    function(container, transclude, repeatName, repeatListExpression, extraName) {
	  this.container = container;
	  this.transclude = transclude;
	  this.repeatName = repeatName;
	  this.rawRepeatListExpression = repeatListExpression;
	  this.extraName = extraName;
	  this.sized = false;
	
	  this.repeatListExpression = angular.bind(this, this.repeatListExpression_);
	
	  this.container.register(this);
	};
	
	
	/** @private Cleans up unused blocks. */
	VirtualRepeatController.prototype.cleanupBlocks_ = function() {
	  angular.forEach(this.pooledBlocks, function cleanupBlock(block) {
	    block.element.remove();
	  });
	};
	
	
	/** @private Attempts to set itemSize by measuring a repeated element in the dom */
	VirtualRepeatController.prototype.readItemSize_ = function() {
	  if (this.itemSize) {
	    // itemSize was successfully read in a different asynchronous call.
	    return;
	  }
	
	  this.items = this.repeatListExpression(this.$scope);
	  this.parentNode = this.$element[0].parentNode;
	  var block = this.getBlock_(0);
	  if (!block.element[0].parentNode) {
	    this.parentNode.appendChild(block.element[0]);
	  }
	
	  this.itemSize = block.element[0][
	      this.container.isHorizontal() ? 'offsetWidth' : 'offsetHeight'] || null;
	
	  this.blocks[0] = block;
	  this.poolBlock_(0);
	
	  if (this.itemSize) {
	    this.containerUpdated();
	  }
	};
	
	
	/**
	 * Returns the user-specified repeat list, transforming it into an array-like
	 * object in the case of infinite scroll/dynamic load mode.
	 * @param {!angular.Scope} scope The scope.
	 * @return {!Array|!Object} An array or array-like object for iteration.
	 */
	VirtualRepeatController.prototype.repeatListExpression_ = function(scope) {
	  var repeatList = this.rawRepeatListExpression(scope);
	
	  if (this.onDemand && repeatList) {
	    var virtualList = new VirtualRepeatModelArrayLike(repeatList);
	    virtualList.$$includeIndexes(this.newStartIndex, this.newVisibleEnd);
	    return virtualList;
	  } else {
	    return repeatList;
	  }
	};
	
	
	/**
	 * Called by the container. Informs us that the container's scroll or size has
	 * changed.
	 */
	VirtualRepeatController.prototype.containerUpdated = function() {
	  // If itemSize is unknown, attempt to measure it.
	  if (!this.itemSize) {
	    // Make sure to clean up watchers if we can (see #8178)
	    if (this.unwatchItemSize_ && this.unwatchItemSize_ !== angular.noop){
	      this.unwatchItemSize_();
	    }
	    this.unwatchItemSize_ = this.$scope.$watchCollection(
	        this.repeatListExpression,
	        angular.bind(this, function(items) {
	          if (items && items.length) {
	            this.readItemSize_();
	          }
	        }));
	    if (!this.$rootScope.$$phase) this.$scope.$digest();
	
	    return;
	  } else if (!this.sized) {
	    this.items = this.repeatListExpression(this.$scope);
	  }
	
	  if (!this.sized) {
	    this.unwatchItemSize_();
	    this.sized = true;
	    this.$scope.$watchCollection(this.repeatListExpression,
	        angular.bind(this, function(items, oldItems) {
	          if (!this.isVirtualRepeatUpdating_) {
	            this.virtualRepeatUpdate_(items, oldItems);
	          }
	        }));
	  }
	
	  this.updateIndexes_();
	
	  if (this.newStartIndex !== this.startIndex ||
	      this.newEndIndex !== this.endIndex ||
	      this.container.getScrollOffset() > this.container.getScrollSize()) {
	    if (this.items instanceof VirtualRepeatModelArrayLike) {
	      this.items.$$includeIndexes(this.newStartIndex, this.newEndIndex);
	    }
	    this.virtualRepeatUpdate_(this.items, this.items);
	  }
	};
	
	
	/**
	 * Called by the container. Returns the size of a single repeated item.
	 * @return {?number} size of a repeated item.
	 */
	VirtualRepeatController.prototype.getItemSize = function() {
	  return this.itemSize;
	};
	
	
	/**
	 * Called by the container.
	 * @return {?number} the most recently seen length of items.
	 */
	VirtualRepeatController.prototype.getItemCount = function() {
	  return this.itemsLength;
	};
	
	
	/**
	 * Updates the order and visible offset of repeated blocks in response to scrolling
	 * or updates to `items`.
	 * @param {Array} items visible elements
	 * @param {Array} oldItems previously visible elements
	 * @private
	 */
	VirtualRepeatController.prototype.virtualRepeatUpdate_ = function(items, oldItems) {
	  this.isVirtualRepeatUpdating_ = true;
	
	  var itemsLength = items && items.length || 0;
	  var lengthChanged = false;
	
	  // If the number of items shrank, keep the scroll position.
	  if (this.items && itemsLength < this.items.length && this.container.getScrollOffset() !== 0) {
	    this.items = items;
	    var previousScrollOffset = this.container.getScrollOffset();
	    this.container.resetScroll();
	    this.container.scrollTo(previousScrollOffset);
	  }
	
	  if (itemsLength !== this.itemsLength) {
	    lengthChanged = true;
	    this.itemsLength = itemsLength;
	  }
	
	  this.items = items;
	  if (items !== oldItems || lengthChanged) {
	    this.updateIndexes_();
	  }
	
	  this.parentNode = this.$element[0].parentNode;
	
	  if (lengthChanged) {
	    this.container.setScrollSize(itemsLength * this.itemSize);
	  }
	
	  // Detach and pool any blocks that are no longer in the viewport.
	  Object.keys(this.blocks).forEach(function(blockIndex) {
	    var index = parseInt(blockIndex, 10);
	    if (index < this.newStartIndex || index >= this.newEndIndex) {
	      this.poolBlock_(index);
	    }
	  }, this);
	
	  // Add needed blocks.
	  // For performance reasons, temporarily block browser url checks as we digest
	  // the restored block scopes ($$checkUrlChange reads window.location to
	  // check for changes and trigger route change, etc, which we don't need when
	  // trying to scroll at 60fps).
	  this.$browser.$$checkUrlChange = angular.noop;
	
	  var i, block,
	      newStartBlocks = [],
	      newEndBlocks = [];
	
	  // Collect blocks at the top.
	  for (i = this.newStartIndex; i < this.newEndIndex && this.blocks[i] == null; i++) {
	    block = this.getBlock_(i);
	    this.updateBlock_(block, i);
	    newStartBlocks.push(block);
	  }
	
	  // Update blocks that are already rendered.
	  for (; this.blocks[i] != null; i++) {
	    this.updateBlock_(this.blocks[i], i);
	  }
	  var maxIndex = i - 1;
	
	  // Collect blocks at the end.
	  for (; i < this.newEndIndex; i++) {
	    block = this.getBlock_(i);
	    this.updateBlock_(block, i);
	    newEndBlocks.push(block);
	  }
	
	  // Attach collected blocks to the document.
	  if (newStartBlocks.length) {
	    this.parentNode.insertBefore(
	        this.domFragmentFromBlocks_(newStartBlocks),
	        this.$element[0].nextSibling);
	  }
	  if (newEndBlocks.length) {
	    this.parentNode.insertBefore(
	        this.domFragmentFromBlocks_(newEndBlocks),
	        this.blocks[maxIndex] && this.blocks[maxIndex].element[0].nextSibling);
	  }
	
	  // Restore $$checkUrlChange.
	  this.$browser.$$checkUrlChange = this.browserCheckUrlChange;
	
	  this.startIndex = this.newStartIndex;
	  this.endIndex = this.newEndIndex;
	
	  if (this.isFirstRender) {
	    this.isFirstRender = false;
	    var firstRenderStartIndex = this.$attrs.mdStartIndex ?
	      this.$scope.$eval(this.$attrs.mdStartIndex) :
	      this.container.topIndex;
	
	    // The first call to virtualRepeatUpdate_ may not be when the virtual repeater is ready.
	    // Introduce a slight delay so that the update happens when it is actually ready.
	    this.$mdUtil.nextTick(function() {
	      this.container.scrollToIndex(firstRenderStartIndex);
	    }.bind(this));
	  }
	
	  this.isVirtualRepeatUpdating_ = false;
	};
	
	
	/**
	 * @param {number} index Where the block is to be in the repeated list.
	 * @return {!VirtualRepeatController.Block} A new or pooled block to place at the specified index.
	 * @private
	 */
	VirtualRepeatController.prototype.getBlock_ = function(index) {
	  if (this.pooledBlocks.length) {
	    return this.pooledBlocks.pop();
	  }
	
	  var block;
	  this.transclude(angular.bind(this, function(clone, scope) {
	    block = {
	      element: clone,
	      new: true,
	      scope: scope
	    };
	
	    this.updateScope_(scope, index);
	    this.parentNode.appendChild(clone[0]);
	  }));
	
	  return block;
	};
	
	
	/**
	 * Updates and if not in a digest cycle, digests the specified block's scope to the data
	 * at the specified index.
	 * @param {!VirtualRepeatController.Block} block The block whose scope should be updated.
	 * @param {number} index The index to set.
	 * @private
	 */
	VirtualRepeatController.prototype.updateBlock_ = function(block, index) {
	  this.blocks[index] = block;
	
	  if (!block.new &&
	      (block.scope.$index === index && block.scope[this.repeatName] === this.items[index])) {
	    return;
	  }
	  block.new = false;
	
	  // Update and digest the block's scope.
	  this.updateScope_(block.scope, index);
	
	  // Perform digest before reattaching the block.
	  // Any resulting synchronous DOM mutations should be much faster as a result.
	  // This might break some directives.
	  if (!this.$rootScope.$$phase) {
	    block.scope.$digest();
	  }
	};
	
	
	/**
	 * Updates scope to the data at the specified index.
	 * @param {!angular.Scope} scope The scope which should be updated.
	 * @param {number} index The index to set.
	 * @private
	 */
	VirtualRepeatController.prototype.updateScope_ = function(scope, index) {
	  scope.$index = index;
	  scope[this.repeatName] = this.items && this.items[index];
	  if (this.extraName) scope[this.extraName(this.$scope)] = this.items[index];
	};
	
	
	/**
	 * Pools the block at the specified index (Pulls its element out of the dom and stores it).
	 * @param {number} index The index at which the block to pool is stored.
	 * @private
	 */
	VirtualRepeatController.prototype.poolBlock_ = function(index) {
	  this.pooledBlocks.push(this.blocks[index]);
	  this.parentNode.removeChild(this.blocks[index].element[0]);
	  delete this.blocks[index];
	};
	
	
	/**
	 * Produces a dom fragment containing the elements from the list of blocks.
	 * @param {!Array<!VirtualRepeatController.Block>} blocks The blocks whose elements
	 *     should be added to the document fragment.
	 * @return {DocumentFragment}
	 * @private
	 */
	VirtualRepeatController.prototype.domFragmentFromBlocks_ = function(blocks) {
	  var fragment = this.$document[0].createDocumentFragment();
	  blocks.forEach(function(block) {
	    fragment.appendChild(block.element[0]);
	  });
	  return fragment;
	};
	
	
	/**
	 * Updates start and end indexes based on length of repeated items and container size.
	 * @private
	 */
	VirtualRepeatController.prototype.updateIndexes_ = function() {
	  var itemsLength = this.items ? this.items.length : 0;
	  var containerLength = Math.ceil(this.container.getSize() / this.itemSize);
	
	  this.newStartIndex = Math.max(0, Math.min(
	      itemsLength - containerLength,
	      Math.floor(this.container.getScrollOffset() / this.itemSize)));
	  this.newVisibleEnd = this.newStartIndex + containerLength + NUM_EXTRA;
	  this.newEndIndex = Math.min(itemsLength, this.newVisibleEnd);
	  this.newStartIndex = Math.max(0, this.newStartIndex - NUM_EXTRA);
	};
	
	/**
	 * This VirtualRepeatModelArrayLike class enforces the interface requirements
	 * for infinite scrolling within a mdVirtualRepeatContainer.
	 *
	 * @param {Object} model An object with this interface must implement the following interface with
	 * two (2) methods:
	 *
	 * getItemAtIndex: function(index) -> item at that index or null if it is not yet
	 *     loaded (It should start downloading the item in that case).
	 *
	 * getLength: function() -> number The data length to which the repeater container
	 *     should be sized. Ideally, when the count is known, this method should return it.
	 *     Otherwise, return a higher number than the currently loaded items to produce an
	 *     infinite-scroll behavior.
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-virtual-repeat-container md-orient-horizontal>
	 *    <div md-virtual-repeat="i in items" md-on-demand>
	 *      Hello {{i}}!
	 *    </div>
	 *  </md-virtual-repeat-container>
	 * </hljs>
	 *
	 */
	function VirtualRepeatModelArrayLike(model) {
	  if (!angular.isFunction(model.getItemAtIndex) ||
	      !angular.isFunction(model.getLength)) {
	    throw Error('When md-on-demand is enabled, the Object passed to md-virtual-repeat must ' +
	        'implement functions getItemAtIndex() and getLength().');
	  }
	
	  this.model = model;
	}
	
	/**
	 * @param {number} start
	 * @param {number} end
	 */
	VirtualRepeatModelArrayLike.prototype.$$includeIndexes = function(start, end) {
	  for (var i = start; i < end; i++) {
	    if (!this.hasOwnProperty(i)) {
	      this[i] = this.model.getItemAtIndex(i);
	    }
	  }
	  this.length = this.model.getLength();
	};
	
	/**
	 * @ngdoc directive
	 * @name mdForceHeight
	 * @module material.components.virtualRepeat
	 * @restrict A
	 * @description
	 *
	 * Force an element to have a certain `px` height. This is used in place of a style tag in order to
	 * conform to the
	 * <a href="https://developer.mozilla.org/docs/Web/HTTP/Headers/Content-Security-Policy/script-src">
	 *   Content Security Policy</a> regarding `unsafe-inline` `<style>` tags.
	 *
	 * This directive is related to <a ng-href="api/directive/mdVirtualRepeat">mdVirtualRepeat</a>.
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <div md-force-height="'100px'"></div>
	 * </hljs>
	 */
	function ForceHeightDirective($mdUtil) {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      var height = scope.$eval(attrs.mdForceHeight) || null;
	
	      if (height && element) {
	        element[0].style.height = height;
	      }
	    }
	  };
	}
	ForceHeightDirective.$inject = ['$mdUtil'];
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.whiteframe
	 */
	MdWhiteframeDirective.$inject = ["$log"];
	angular
	  .module('material.components.whiteframe', ['material.core'])
	  .directive('mdWhiteframe', MdWhiteframeDirective);
	
	/**
	 * @ngdoc directive
	 * @module material.components.whiteframe
	 * @name mdWhiteframe
	 *
	 * @description
	 * The md-whiteframe directive allows you to apply an elevation shadow to an element.
	 *
	 * The attribute values needs to be a number between 1 and 24 or -1.
	 * When set to -1 no style is applied.
	 *
	 * ### Notes
	 * - If there is no value specified it defaults to 4dp.
	 * - If the value is not valid it defaults to 4dp.
	
	 * @usage
	 * <hljs lang="html">
	 * <div md-whiteframe="3">
	 *   <span>Elevation of 3dp</span>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="html">
	 * <div md-whiteframe="-1">
	 *   <span>No elevation shadow applied</span>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="html">
	 * <div ng-init="elevation = 5" md-whiteframe="{{elevation}}">
	 *   <span>Elevation of 5dp with an interpolated value</span>
	 * </div>
	 * </hljs>
	 */
	function MdWhiteframeDirective($log) {
	  var DISABLE_DP = -1;
	  var MIN_DP = 1;
	  var MAX_DP = 24;
	  var DEFAULT_DP = 4;
	
	  return {
	    link: postLink
	  };
	
	  function postLink(scope, element, attr) {
	    var oldClass = '';
	
	    attr.$observe('mdWhiteframe', function(elevation) {
	      elevation = parseInt(elevation, 10) || DEFAULT_DP;
	
	      if (elevation != DISABLE_DP && (elevation > MAX_DP || elevation < MIN_DP)) {
	        $log.warn('md-whiteframe attribute value is invalid. It should be a number between ' + MIN_DP + ' and ' + MAX_DP, element[0]);
	        elevation = DEFAULT_DP;
	      }
	
	      var newClass = elevation == DISABLE_DP ? '' : 'md-whiteframe-' + elevation + 'dp';
	      attr.$updateClass(newClass, oldClass);
	      oldClass = newClass;
	    });
	  }
	}
	
	
	})();
	(function(){ 
	angular.module("material.core").constant("$MD_THEME_CSS", "md-autocomplete.md-THEME_NAME-theme{background:\"{{background-hue-1}}\"}md-autocomplete.md-THEME_NAME-theme[disabled]:not([md-floating-label]){background:\"{{background-hue-2}}\"}md-autocomplete.md-THEME_NAME-theme button md-icon path{fill:\"{{background-600}}\"}md-autocomplete.md-THEME_NAME-theme button:after{background:\"{{background-600-0.3}}\"}md-autocomplete.md-THEME_NAME-theme input{color:\"{{foreground-1}}\"}md-autocomplete.md-THEME_NAME-theme.md-accent md-input-container.md-input-focused .md-input{border-color:\"{{accent-color}}\"}md-autocomplete.md-THEME_NAME-theme.md-accent md-input-container.md-input-focused label,md-autocomplete.md-THEME_NAME-theme.md-accent md-input-container.md-input-focused md-icon{color:\"{{accent-color}}\"}md-autocomplete.md-THEME_NAME-theme.md-accent md-progress-linear .md-container{background-color:\"{{accent-100}}\"}md-autocomplete.md-THEME_NAME-theme.md-accent md-progress-linear .md-bar{background-color:\"{{accent-color}}\"}md-autocomplete.md-THEME_NAME-theme.md-warn md-input-container.md-input-focused .md-input{border-color:\"{{warn-A700}}\"}md-autocomplete.md-THEME_NAME-theme.md-warn md-input-container.md-input-focused label,md-autocomplete.md-THEME_NAME-theme.md-warn md-input-container.md-input-focused md-icon{color:\"{{warn-A700}}\"}md-autocomplete.md-THEME_NAME-theme.md-warn md-progress-linear .md-container{background-color:\"{{warn-100}}\"}md-autocomplete.md-THEME_NAME-theme.md-warn md-progress-linear .md-bar{background-color:\"{{warn-color}}\"}.md-autocomplete-standard-list-container.md-THEME_NAME-theme,.md-autocomplete-suggestions-container.md-THEME_NAME-theme{background:\"{{background-hue-1}}\"}.md-autocomplete-standard-list-container.md-THEME_NAME-theme .md-autocomplete-suggestion,.md-autocomplete-suggestions-container.md-THEME_NAME-theme .md-autocomplete-suggestion{color:\"{{foreground-1}}\"}.md-autocomplete-standard-list-container.md-THEME_NAME-theme .md-autocomplete-suggestion.selected,.md-autocomplete-standard-list-container.md-THEME_NAME-theme .md-autocomplete-suggestion:hover,.md-autocomplete-suggestions-container.md-THEME_NAME-theme .md-autocomplete-suggestion.selected,.md-autocomplete-suggestions-container.md-THEME_NAME-theme .md-autocomplete-suggestion:hover{background:\"{{background-500-0.18}}\"}md-backdrop{background-color:\"{{background-900-0.0}}\"}md-backdrop.md-opaque.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-bottom-sheet.md-THEME_NAME-theme{background-color:\"{{background-color}}\";border-top-color:\"{{background-hue-3}}\"}md-bottom-sheet.md-THEME_NAME-theme.md-list md-list-item{color:\"{{foreground-1}}\"}md-bottom-sheet.md-THEME_NAME-theme .md-subheader{background-color:\"{{background-color}}\";color:\"{{foreground-1}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme:not([disabled]):hover{background-color:\"{{background-500-0.2}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-icon-button:hover{background-color:transparent}.md-button.md-THEME_NAME-theme.md-fab{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-fab:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab,.md-button.md-THEME_NAME-theme.md-primary.md-raised{background-color:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]) md-icon{color:\"{{primary-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]):hover{background-color:\"{{primary-600}}\"}.md-button.md-THEME_NAME-theme.md-primary:not([disabled]) md-icon{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-raised{background-color:\"{{background-50}}\";color:\"{{background-900}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]) md-icon{color:\"{{background-900}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]):hover{background-color:\"{{background-50}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]).md-focused{background-color:\"{{background-200}}\"}.md-button.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab,.md-button.md-THEME_NAME-theme.md-warn.md-raised{background-color:\"{{warn-color}}\";color:\"{{warn-contrast}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]) md-icon{color:\"{{warn-contrast}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]):hover{background-color:\"{{warn-600}}\"}.md-button.md-THEME_NAME-theme.md-warn:not([disabled]) md-icon{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab,.md-button.md-THEME_NAME-theme.md-accent.md-raised{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]) md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-accent:not([disabled]) md-icon{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent[disabled],.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled],.md-button.md-THEME_NAME-theme.md-warn[disabled],.md-button.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\";cursor:default}.md-button.md-THEME_NAME-theme.md-accent[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-fab[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-raised[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-warn[disabled] md-icon,.md-button.md-THEME_NAME-theme[disabled] md-icon{color:\"{{foreground-3}}\"}.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled]{background-color:\"{{foreground-4}}\"}.md-button.md-THEME_NAME-theme[disabled]{background-color:transparent}._md a.md-THEME_NAME-theme:not(.md-button).md-primary{color:\"{{primary-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-primary:hover{color:\"{{primary-700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent{color:\"{{accent-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent:hover{color:\"{{accent-A700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn{color:\"{{warn-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn:hover{color:\"{{warn-700}}\"}md-card.md-THEME_NAME-theme{background-color:\"{{background-hue-1}}\";border-radius:2px;color:\"{{foreground-1}}\"}md-card.md-THEME_NAME-theme .md-card-image{border-radius:2px 2px 0 0}md-card.md-THEME_NAME-theme md-card-header md-card-avatar md-icon{background-color:\"{{foreground-3}}\";color:\"{{background-color}}\"}md-card.md-THEME_NAME-theme md-card-header md-card-header-text .md-subhead,md-card.md-THEME_NAME-theme md-card-title md-card-title-text:not(:only-child) .md-subhead{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme .md-ripple{color:\"{{accent-A700}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme.md-checked.md-focused .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon{background-color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon:after{border-color:\"{{background-default}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ripple{color:\"{{primary-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon{background-color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked.md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ripple{color:\"{{warn-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon{background-color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked.md-focused:not([disabled]) .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme[disabled]:not(.md-checked) .md-icon{border-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon{background-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled] .md-label{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips{box-shadow:0 1px \"{{foreground-4}}\"}md-chips.md-THEME_NAME-theme .md-chips.md-focused{box-shadow:0 2px \"{{primary-color}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input{color:\"{{foreground-1}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-ms-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-ms-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-moz-placeholder,md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-moz-placeholder{color:\"{{foreground-3}}\";opacity:1}md-chips.md-THEME_NAME-theme md-chip{background:\"{{background-300}}\";color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme md-chip md-icon{color:\"{{background-700}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused{background:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused md-icon{color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip._md-chip-editing{background:transparent;color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme .md-chip-remove-container button.md-chip-remove md-icon,md-chips.md-THEME_NAME-theme .md-chip-remove-container buttonmd-chip-remove md-icon{fill:\"{{foreground-2}}\";color:\"{{foreground-2}}\"}.md-contact-suggestion span.md-contact-email{color:\"{{background-400}}\"}md-content.md-THEME_NAME-theme{background-color:\"{{background-default}}\";color:\"{{foreground-1}}\"}.md-THEME_NAME-theme .md-calendar{background:\"{{background-hue-1}}\";color:\"{{foreground-1-0.87}}\"}.md-THEME_NAME-theme .md-calendar tr:last-child td{border-bottom-color:\"{{background-hue-2}}\"}.md-THEME_NAME-theme .md-calendar-day-header{background:\"{{background-500-0.32}}\";color:\"{{foreground-1-0.87}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today .md-calendar-date-selection-indicator{border:1px solid \"{{primary-500}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today.md-calendar-date-disabled{color:\"{{primary-500-0.6}}\"}.md-calendar-date.md-focus .md-THEME_NAME-theme .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date-selection-indicator:hover{background:\"{{background-500-0.32}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-selected-date .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date.md-focus.md-calendar-selected-date .md-calendar-date-selection-indicator{background:\"{{primary-500}}\";border-color:transparent;color:\"{{primary-500-contrast}}\"}.md-THEME_NAME-theme .md-calendar-date-disabled,.md-THEME_NAME-theme .md-calendar-month-label-disabled{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-calendar-month-label md-icon,.md-THEME_NAME-theme .md-datepicker-input{color:\"{{foreground-1}}\"}.md-THEME_NAME-theme .md-datepicker-input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input:-ms-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input::-ms-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input::placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input:-moz-placeholder,.md-THEME_NAME-theme .md-datepicker-input::-moz-placeholder{color:\"{{foreground-3}}\";opacity:1}.md-THEME_NAME-theme .md-datepicker-input-container{border-bottom-color:\"{{foreground-4}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-invalid,.md-warn .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar-pane{border-color:\"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-triangle-button .md-datepicker-expand-triangle{border-top-color:\"{{foreground-2}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon,.md-THEME_NAME-theme .md-datepicker-open.md-accent .md-datepicker-calendar-icon{color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-open.md-warn .md-datepicker-calendar-icon,.md-warn .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar{background:\"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-input-mask-opaque{box-shadow:0 0 0 9999px \"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-input-container{background:\"{{background-hue-1}}\"}md-dialog.md-THEME_NAME-theme{background-color:\"{{background-hue-1}}\";border-radius:4px;color:\"{{foreground-1}}\"}md-dialog.md-THEME_NAME-theme.md-content-overflow md-dialog-actions{border-top-color:\"{{foreground-4}}\"}md-divider.md-THEME_NAME-theme{border-color:\"{{foreground-4}}\"}md-fab-speed-dial.md-THEME_NAME-theme md-fab-trigger .md-fab.md-button[disabled]{background-color:\"{{foreground-4}}\"}md-fab-speed-dial.md-THEME_NAME-theme md-fab-actions .md-fab-action-item .md-button.md-fab.md-raised.md-mini.md-focused,md-fab-speed-dial.md-THEME_NAME-theme md-fab-actions .md-fab-action-item .md-button.md-fab.md-raised.md-mini:hover{background-color:\"{{background-500}}\"}md-icon.md-THEME_NAME-theme{color:\"{{foreground-2}}\"}md-icon.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}md-icon.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}md-icon.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-input-container.md-THEME_NAME-theme .md-input{border-color:\"{{background-default-contrast-divider}}\";color:\"{{background-default-contrast}}\"}md-input-container.md-THEME_NAME-theme .md-input::-webkit-input-placeholder{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme .md-input:-ms-input-placeholder{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme .md-input::-ms-input-placeholder{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme .md-input::placeholder{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme .md-input::-moz-placeholder{color:\"{{background-default-contrast-secondary}}\";opacity:1}md-input-container.md-THEME_NAME-theme>md-icon{color:\"{{background-default-contrast}}\"}md-input-container.md-THEME_NAME-theme .md-placeholder,md-input-container.md-THEME_NAME-theme label{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme label.md-required:after{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-focused):not(.md-input-invalid) label.md-required:after{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation,md-input-container.md-THEME_NAME-theme .md-input-messages-animation{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation .md-char-counter,md-input-container.md-THEME_NAME-theme .md-input-messages-animation .md-char-counter{color:\"{{background-default-contrast}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-webkit-input-placeholder{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-ms-input-placeholder{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-ms-input-placeholder{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::placeholder{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-moz-placeholder{color:\"{{background-default-contrast-secondary}}\";opacity:1}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-has-value label{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused .md-input,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-resized .md-input{border-color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused md-icon{color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent .md-input{border-color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent md-icon{color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn md-icon{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-char-counter,md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input-message-animation,md-input-container.md-THEME_NAME-theme.md-input-invalid label{color:\"{{warn-A700}}\"}[disabled] md-input-container.md-THEME_NAME-theme .md-input,md-input-container.md-THEME_NAME-theme .md-input[disabled]{background-image:linear-gradient(90deg,\"{{background-default-contrast-disabled}}\" 0,\"{{background-default-contrast-disabled}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{background-default-contrast-disabled}}\" 100%);border-bottom-color:transparent;color:\"{{background-default-contrast-disabled}}\"}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h4,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h4{color:\"{{foreground-1}}\"}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text p,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text p{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme .md-proxy-focus.md-focused div.md-no-style{background-color:\"{{background-100}}\"}md-list.md-THEME_NAME-theme md-list-item .md-avatar-icon{background-color:\"{{foreground-3}}\";color:\"{{background-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight{color:\"{{primary-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight.md-accent{color:\"{{accent-color}}\"}md-menu-content.md-THEME_NAME-theme{background-color:\"{{background-hue-1}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item{color:\"{{foreground-1}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item md-icon{color:\"{{foreground-2}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled],md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled] md-icon{color:\"{{foreground-3}}\"}md-menu-content.md-THEME_NAME-theme md-menu-divider{background-color:\"{{foreground-4}}\"}md-menu-bar.md-THEME_NAME-theme>button.md-button{border-radius:2px;color:\"{{foreground-1}}\"}md-menu-bar.md-THEME_NAME-theme md-menu>button{color:\"{{foreground-1}}\"}md-menu-bar.md-THEME_NAME-theme md-menu.md-open>button,md-menu-bar.md-THEME_NAME-theme md-menu>button:focus{background-color:\"{{ background-500-0.18}}\";outline:none}md-menu-bar.md-THEME_NAME-theme.md-open:not(.md-keyboard-mode) md-menu:hover>button{background-color:\"{{ background-500-0.18}}\"}md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:focus,md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:hover{background:transparent}md-menu-content.md-THEME_NAME-theme .md-menu>.md-button:after{color:\"{{foreground-2}}\"}md-menu-content.md-THEME_NAME-theme .md-menu.md-open>.md-button{background-color:\"{{ background-500-0.18}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar{background-color:\"{{background-hue-1}}\";color:\"{{foreground-1}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler{background-color:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler md-icon{color:\"{{primary-contrast}}\"}md-nav-bar.md-THEME_NAME-theme .md-nav-bar{background-color:transparent;border-color:\"{{foreground-4}}\"}md-nav-bar.md-THEME_NAME-theme .md-button._md-nav-button.md-unselected{color:\"{{foreground-2}}\"}md-nav-bar.md-THEME_NAME-theme .md-button._md-nav-button[disabled]{color:\"{{foreground-3}}\"}md-nav-bar.md-THEME_NAME-theme md-nav-ink-bar{background:\"{{accent-color}}\";color:\"{{accent-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar{background-color:\"{{accent-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button{color:\"{{accent-A100}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{accent-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{accent-contrast-0.1}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar md-nav-ink-bar{background:\"{{primary-600-1}}\";color:\"{{primary-600-1}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar{background-color:\"{{warn-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button{color:\"{{warn-100}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{warn-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{warn-contrast-0.1}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar{background-color:\"{{primary-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button{color:\"{{primary-100}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{primary-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{primary-color}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{primary-100}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{primary-contrast}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{accent-color}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{accent-A100}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{accent-contrast}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{accent-contrast-0.1}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar md-nav-ink-bar{background:\"{{primary-600-1}}\";color:\"{{primary-600-1}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{warn-color}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{warn-100}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{warn-contrast}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{warn-contrast-0.1}}\"}._md-panel-backdrop.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-progress-circular.md-THEME_NAME-theme path{stroke:\"{{primary-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-warn path{stroke:\"{{warn-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-accent path{stroke:\"{{accent-color}}\"}md-progress-linear.md-THEME_NAME-theme .md-container{background-color:\"{{primary-100}}\"}md-progress-linear.md-THEME_NAME-theme .md-bar{background-color:\"{{primary-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-container{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-bar{background-color:\"{{warn-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-container{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-bar{background-color:\"{{accent-color}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-primary .md-bar1{background-color:\"{{primary-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-primary .md-dashed:before{background:radial-gradient(\"{{primary-100}}\" 0,\"{{primary-100}}\" 16%,transparent 42%)}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-bar1{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-dashed:before{background:radial-gradient(\"{{warn-100}}\" 0,\"{{warn-100}}\" 16%,transparent 42%)}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-bar1{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-dashed:before{background:radial-gradient(\"{{accent-100}}\" 0,\"{{accent-100}}\" 16%,transparent 42%)}md-radio-button.md-THEME_NAME-theme .md-off{border-color:\"{{foreground-2}}\"}md-radio-button.md-THEME_NAME-theme .md-on{background-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-off{border-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme .md-container .md-ripple{color:\"{{accent-A700}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on{background-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off{border-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple{color:\"{{primary-600}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on{background-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off{border-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple{color:\"{{warn-600}}\"}md-radio-button.md-THEME_NAME-theme[disabled],md-radio-group.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\"}md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-on,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-on{border-color:\"{{foreground-3}}\"}md-radio-group.md-THEME_NAME-theme .md-checked .md-ink-ripple{color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme .md-checked:not([disabled]).md-primary .md-ink-ripple,md-radio-group.md-THEME_NAME-theme.md-primary .md-checked:not([disabled]) .md-ink-ripple{color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused.ng-empty>md-radio-button:first-child .md-container:before{background-color:\"{{foreground-3-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-primary .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-primary .md-checked .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-warn .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-warn .md-checked .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-input-container md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-input-container:not(.md-input-focused):not(.md-input-invalid) md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{foreground-3}}\"}md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value,md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{primary-color}}\"}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme .md-select-value{border-bottom-color:\"{{warn-A700}}\"!important;color:\"{{warn-A700}}\"!important}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-input-container:not(.md-input-invalid).md-input-focused.md-accent .md-select-value{border-color:\"{{accent-color}}\"}md-input-container:not(.md-input-invalid).md-input-focused.md-accent .md-select-value span{color:\"{{accent-color}}\"}md-input-container:not(.md-input-invalid).md-input-focused.md-warn .md-select-value{border-color:\"{{warn-A700}}\"}md-input-container:not(.md-input-invalid).md-input-focused.md-warn .md-select-value span{color:\"{{warn-A700}}\"}md-select.md-THEME_NAME-theme[disabled] .md-select-value{background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%);border-bottom-color:transparent}md-select.md-THEME_NAME-theme .md-select-value{border-bottom-color:\"{{foreground-4}}\"}md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched .md-select-value{border-bottom-color:\"{{warn-A700}}\"!important;color:\"{{warn-A700}}\"!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value{border-bottom-color:\"{{primary-color}}\";color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value.md-select-placeholder{color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-accent .md-select-value{border-bottom-color:\"{{accent-color}}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-warn .md-select-value{border-bottom-color:\"{{warn-color}}\"}md-select.md-THEME_NAME-theme[disabled] .md-select-icon,md-select.md-THEME_NAME-theme[disabled] .md-select-value,md-select.md-THEME_NAME-theme[disabled] .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-icon{color:\"{{foreground-2}}\"}md-select-menu.md-THEME_NAME-theme md-content{background-color:\"{{background-hue-1}}\"}md-select-menu.md-THEME_NAME-theme md-content md-optgroup{color:\"{{foreground-2}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option{color:\"{{foreground-1}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[disabled] .md-text{color:\"{{foreground-3}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):hover{background-color:\"{{background-500-0.10}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]).md-focused,md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):focus{background-color:\"{{background-500-0.18}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]{color:\"{{primary-500}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-focused,md-select-menu.md-THEME_NAME-theme md-content md-option[selected]:focus{color:\"{{primary-600}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent{color:\"{{accent-color}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent.md-focused,md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent:focus{color:\"{{accent-A700}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ripple{color:\"{{primary-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ripple{color:\"{{background-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ink-ripple{color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon{background-color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected].md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}.md-checkbox-enabled.md-THEME_NAME-theme md-option .md-text{color:\"{{foreground-1}}\"}md-sidenav.md-THEME_NAME-theme,md-sidenav.md-THEME_NAME-theme md-content{background-color:\"{{background-hue-1}}\"}md-slider.md-THEME_NAME-theme .md-track{background-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme .md-track-ticks{color:\"{{background-contrast}}\"}md-slider.md-THEME_NAME-theme .md-focus-ring{background-color:\"{{accent-A200-0.2}}\"}md-slider.md-THEME_NAME-theme .md-disabled-thumb{background-color:\"{{background-color}}\";border-color:\"{{background-color}}\"}md-slider.md-THEME_NAME-theme.md-min .md-thumb:after{background-color:\"{{background-color}}\";border-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme.md-min .md-focus-ring{background-color:\"{{foreground-3-0.38}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-thumb:after{background-color:\"{{background-contrast}}\";border-color:transparent}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete][md-vertical] .md-sign:after{border-left-color:\"{{background-400}}\";border-top-color:transparent}md-slider.md-THEME_NAME-theme .md-track.md-track-fill{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-thumb:after{background-color:\"{{accent-color}}\";border-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign:after{border-top-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme[md-vertical] .md-sign:after{border-left-color:\"{{accent-color}}\";border-top-color:transparent}md-slider.md-THEME_NAME-theme .md-thumb-text{color:\"{{accent-contrast}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-focus-ring{background-color:\"{{warn-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-track.md-track-fill{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-thumb:after{background-color:\"{{warn-color}}\";border-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign:after{border-top-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn[md-vertical] .md-sign:after{border-left-color:\"{{warn-color}}\";border-top-color:transparent}md-slider.md-THEME_NAME-theme.md-warn .md-thumb-text{color:\"{{warn-contrast}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-focus-ring{background-color:\"{{primary-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-track.md-track-fill{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-thumb:after{background-color:\"{{primary-color}}\";border-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign:after{border-top-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary[md-vertical] .md-sign:after{border-left-color:\"{{primary-color}}\";border-top-color:transparent}md-slider.md-THEME_NAME-theme.md-primary .md-thumb-text{color:\"{{primary-contrast}}\"}md-slider.md-THEME_NAME-theme[disabled] .md-thumb:after{border-color:transparent}md-slider.md-THEME_NAME-theme[disabled]:not(.md-min) .md-thumb:after,md-slider.md-THEME_NAME-theme[disabled][md-discrete] .md-thumb:after{background-color:\"{{foreground-3}}\";border-color:transparent}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly][md-vertical] .md-sign:after{border-left-color:\"{{background-400}}\";border-top-color:transparent}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-disabled-thumb{background-color:transparent;border-color:transparent}md-slider-container[disabled]>:first-child:not(md-slider),md-slider-container[disabled]>:last-child:not(md-slider){color:\"{{foreground-3}}\"}.md-subheader.md-THEME_NAME-theme{background-color:\"{{background-default}}\";color:\"{{ foreground-2-0.54 }}\"}.md-subheader.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-subheader.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-subheader.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme .md-ink-ripple{color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme .md-thumb{background-color:\"{{background-50}}\"}md-switch.md-THEME_NAME-theme .md-bar{background-color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme.md-focused:not(.md-checked) .md-thumb:before,md-switch.md-THEME_NAME-theme.md-focused[disabled] .md-thumb:before{background-color:\"{{foreground-4}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]) .md-ink-ripple{color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]) .md-thumb{background-color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]) .md-bar{background-color:\"{{accent-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-focused .md-thumb:before{background-color:\"{{accent-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-primary .md-ink-ripple{color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-primary .md-thumb{background-color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-primary .md-bar{background-color:\"{{primary-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-primary.md-focused .md-thumb:before{background-color:\"{{primary-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-warn .md-ink-ripple{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-warn .md-thumb{background-color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-warn .md-bar{background-color:\"{{warn-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-warn.md-focused .md-thumb:before{background-color:\"{{warn-color-0.26}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-thumb{background-color:\"{{background-400}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-bar{background-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme md-tabs-wrapper{background-color:transparent;border-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme md-next-button md-icon,md-tabs.md-THEME_NAME-theme md-prev-button md-icon{color:\"{{foreground-2}}\"}md-tabs.md-THEME_NAME-theme md-ink-bar{background:\"{{accent-color}}\";color:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab{color:\"{{foreground-2}}\"}md-tabs.md-THEME_NAME-theme .md-tab[disabled],md-tabs.md-THEME_NAME-theme .md-tab[disabled] md-icon{color:\"{{foreground-3}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-active,md-tabs.md-THEME_NAME-theme .md-tab.md-active md-icon,md-tabs.md-THEME_NAME-theme .md-tab.md-focused,md-tabs.md-THEME_NAME-theme .md-tab.md-focused md-icon{color:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-focused{background:\"{{primary-color-0.1}}\"}md-tabs.md-THEME_NAME-theme .md-tab .md-ripple-container{color:\"{{accent-A100}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper{background-color:\"{{accent-500}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper md-next-button md-icon,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper md-prev-button md-icon{color:\"{{accent-500-contrast-0.7}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-500-contrast-1}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-500-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{background:\"{{accent-500-contrast}}\";color:\"{{accent-500-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper md-next-button md-icon,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper md-prev-button md-icon{color:\"{{primary-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-contrast-0.7}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{background:\"{{accent-color}}\";color:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme.md-primary.md-no-ink-bar-color>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{background:\"{{primary-contrast}}\";color:\"{{primary-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper{background-color:\"{{warn-500}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper md-next-button md-icon,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper md-prev-button md-icon{color:\"{{warn-500-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-500-contrast-0.7}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-500-contrast-1}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-500-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{background:\"{{warn-500-contrast}}\";color:\"{{warn-500-contrast}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper md-next-button md-icon,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper md-prev-button md-icon{color:\"{{primary-contrast}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-contrast-0.7}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{background:\"{{accent-color}}\";color:\"{{accent-color}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme.md-no-ink-bar-color>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{background:\"{{primary-contrast}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{accent-500}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper md-next-button md-icon,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper md-prev-button md-icon{color:\"{{accent-500-contrast-0.7}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-500-contrast-1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-500-contrast-0.1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{background:\"{{accent-500-contrast}}\";color:\"{{accent-500-contrast}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{warn-500}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper md-next-button md-icon,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper md-prev-button md-icon{color:\"{{warn-500-contrast}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-500-contrast-0.7}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-500-contrast-1}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-500-contrast-0.1}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{background:\"{{warn-500-contrast}}\";color:\"{{warn-500-contrast}}\"}md-toast.md-THEME_NAME-theme .md-toast-content{background-color:#323232;color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button{color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight{color:\"{{accent-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-primary{color:\"{{primary-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-warn{color:\"{{warn-color}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar){background-color:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-icon{fill:\"{{primary-contrast}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) .md-button[disabled] md-icon{fill:\"{{primary-contrast-0.26}}\";color:\"{{primary-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float] .md-input{border-color:\"{{primary-default-contrast-divider}}\";color:\"{{primary-default-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float] .md-input::-webkit-input-placeholder{color:\"{{primary-default-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float] .md-input:-ms-input-placeholder{color:\"{{primary-default-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float] .md-input::-ms-input-placeholder{color:\"{{primary-default-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float] .md-input::placeholder{color:\"{{primary-default-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float] .md-input:-moz-placeholder,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float] .md-input::-moz-placeholder{color:\"{{primary-default-contrast-hint}}\";opacity:1}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float].md-input-focused .md-input::-webkit-input-placeholder{color:\"{{primary-default-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float].md-input-focused .md-input:-ms-input-placeholder{color:\"{{primary-default-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float].md-input-focused .md-input::-ms-input-placeholder{color:\"{{primary-default-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float].md-input-focused .md-input::placeholder{color:\"{{primary-default-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float].md-input-focused .md-input:-moz-placeholder,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float].md-input-focused .md-input::-moz-placeholder{color:\"{{primary-default-contrast-secondary}}\";opacity:1}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused .md-input,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float]:not(.md-input-invalid).md-input-resized .md-input{border-color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused.md-accent .md-input{border-color:\"{{accent-color}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused.md-warn .md-input{border-color:\"{{warn-A700}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent{background-color:\"{{accent-500}}\";color:\"{{accent-500-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-ink-ripple{color:\"{{accent-500-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-icon{fill:\"{{accent-500-contrast}}\";color:\"{{accent-500-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-button[disabled] md-icon{fill:\"{{accent-500-contrast-0.26}}\";color:\"{{accent-500-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float] .md-input{border-color:\"{{accent-500-contrast-divider}}\";color:\"{{accent-500-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float] .md-input::-webkit-input-placeholder{color:\"{{accent-500-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float] .md-input:-ms-input-placeholder{color:\"{{accent-500-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float] .md-input::-ms-input-placeholder{color:\"{{accent-500-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float] .md-input::placeholder{color:\"{{accent-500-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float] .md-input:-moz-placeholder,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float] .md-input::-moz-placeholder{color:\"{{accent-500-contrast-hint}}\";opacity:1}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float].md-input-focused .md-input::-webkit-input-placeholder{color:\"{{accent-500-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float].md-input-focused .md-input:-ms-input-placeholder{color:\"{{accent-500-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float].md-input-focused .md-input::-ms-input-placeholder{color:\"{{accent-500-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float].md-input-focused .md-input::placeholder{color:\"{{accent-500-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float].md-input-focused .md-input:-moz-placeholder,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float].md-input-focused .md-input::-moz-placeholder{color:\"{{accent-500-contrast-secondary}}\";opacity:1}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused .md-input,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float]:not(.md-input-invalid).md-input-resized .md-input{border-color:\"{{primary-color}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused.md-accent .md-input{border-color:\"{{accent-500-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused.md-warn .md-input{border-color:\"{{warn-A700}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn{background-color:\"{{warn-500}}\";color:\"{{warn-500-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-icon{fill:\"{{warn-500-contrast}}\";color:\"{{warn-500-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float] .md-input{border-color:\"{{warn-500-contrast-divider}}\";color:\"{{warn-500-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float] .md-input::-webkit-input-placeholder{color:\"{{warn-500-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float] .md-input:-ms-input-placeholder{color:\"{{warn-500-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float] .md-input::-ms-input-placeholder{color:\"{{warn-500-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float] .md-input::placeholder{color:\"{{warn-500-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float] .md-input:-moz-placeholder,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float] .md-input::-moz-placeholder{color:\"{{warn-500-contrast-hint}}\";opacity:1}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float].md-input-focused .md-input::-webkit-input-placeholder{color:\"{{warn-500-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float].md-input-focused .md-input:-ms-input-placeholder{color:\"{{warn-500-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float].md-input-focused .md-input::-ms-input-placeholder{color:\"{{warn-500-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float].md-input-focused .md-input::placeholder{color:\"{{warn-500-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float].md-input-focused .md-input:-moz-placeholder,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float].md-input-focused .md-input::-moz-placeholder{color:\"{{warn-500-contrast-secondary}}\";opacity:1}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused .md-input,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float]:not(.md-input-invalid).md-input-resized .md-input{border-color:\"{{primary-color}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused.md-accent .md-input{border-color:\"{{accent-color}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused.md-warn .md-input{border-color:\"{{warn-500-contrast}}\"}.md-panel.md-tooltip.md-THEME_NAME-theme{background-color:\"{{background-700}}\";color:\"{{background-700-contrast}}\"}body.md-THEME_NAME-theme,html.md-THEME_NAME-theme{background-color:\"{{background-color}}\";color:\"{{foreground-1}}\"}"); 
	})();
	
	
	})(window, window.angular);;window.ngMaterial={version:{full: "1.2.5"}};

/***/ },

/***/ 133:
/***/ function(module, exports, __webpack_require__) {

	// Should already be required, here for clarity
	__webpack_require__(1);
	
	// Load Angular and dependent libs
	__webpack_require__(74);
	__webpack_require__(75);
	
	// Now load Angular Material
	__webpack_require__(132);
	
	// Export namespace
	module.exports = 'ngMaterial';


/***/ },

/***/ 134:
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.6.6
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var forEach;
	var isArray;
	var isString;
	var jqLite;
	
	/**
	 * @ngdoc module
	 * @name ngMessages
	 * @description
	 *
	 * The `ngMessages` module provides enhanced support for displaying messages within templates
	 * (typically within forms or when rendering message objects that return key/value data).
	 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
	 * show and hide error messages specific to the state of an input field, the `ngMessages` and
	 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
	 * sequencing based on the order of how the messages are defined in the template.
	 *
	 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
	 * `ngMessage` and `ngMessageExp` directives.
	 *
	 * # Usage
	 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
	 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
	 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
	 * {@link ngModel ngModel} directive.
	 *
	 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
	 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
	 * the `ngMessages` directive.
	 *
	 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
	 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
	 * directive.
	 *
	 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Enter text:
	 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
	 *   </label>
	 *   <div ng-messages="myForm.myField.$error" role="alert">
	 *     <div ng-message="required">Please enter a value for this field.</div>
	 *     <div ng-message="email">This field must be a valid email address.</div>
	 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
	 * set to the `$error` object owned by the `myField` input in our `myForm` form.
	 *
	 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
	 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
	 * setting `ng-message="required"` specifies that this particular element should be displayed when there
	 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
	 * `myForm.myField.$error`).
	 *
	 * ### Message order
	 *
	 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
	 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
	 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
	 * to prioritize messages using custom JavaScript code.
	 *
	 * Given the following error object for our example (which informs us that the field `myField` currently has both the
	 * `required` and `email` errors):
	 *
	 * ```javascript
	 * <!-- keep in mind that ngModel automatically sets these error flags -->
	 * myField.$error = { required : true, email: true, maxlength: false };
	 * ```
	 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
	 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
	 * but the `email` message will be visible because it is still applicable.
	 *
	 * ### Displaying multiple messages at the same time
	 *
	 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
	 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
	 *
	 * ```html
	 * <!-- attribute-style usage -->
	 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
	 *
	 * <!-- element-style usage -->
	 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
	 * ```
	 *
	 * ## Reusing and Overriding Messages
	 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
	 * template. This allows for generic collection of messages to be reused across multiple parts of an
	 * application.
	 *
	 * ```html
	 * <script type="text/ng-template" id="error-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <div ng-messages="myForm.myField.$error" role="alert">
	 *   <div ng-messages-include="error-messages"></div>
	 * </div>
	 * ```
	 *
	 * However, including generic messages may not be useful enough to match all input fields, therefore,
	 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
	 * them within the directive container.
	 *
	 * ```html
	 * <!-- a generic template of error messages known as "my-custom-messages" -->
	 * <script type="text/ng-template" id="my-custom-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            id="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
	 *        override the messages present in the ng-messages-include template -->
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <!-- this required message has overridden the template message -->
	 *     <div ng-message="required">You did not enter your email address</div>
	 *
	 *     <!-- this is a brand new message and will appear last in the prioritization -->
	 *     <div ng-message="email">Your email address is invalid</div>
	 *
	 *     <!-- and here are the generic error messages -->
	 *     <div ng-messages-include="my-custom-messages"></div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In the example HTML code above the message that is set on required will override the corresponding
	 * required message defined within the remote template. Therefore, with particular input fields (such
	 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
	 * while more generic messages can be used to handle other, more general input errors.
	 *
	 * ## Dynamic Messaging
	 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
	 * repeaters to list messages is also supported. This means that the code below will be able to
	 * fully adapt itself and display the appropriate message when any of the expression data changes:
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message="required">You did not enter your email address</div>
	 *     <div ng-repeat="errorMessage in errorMessages">
	 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
	 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
	 *     </div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * The `errorMessage.type` expression can be a string value or it can be an array so
	 * that multiple errors can be associated with a single error message:
	 *
	 * ```html
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            ng-model="data.email"
	 *            name="myEmail"
	 *            ng-minlength="5"
	 *            ng-maxlength="100"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message-exp="'required'">You did not enter your email address</div>
	 *     <div ng-message-exp="['minlength', 'maxlength']">
	 *       Your email must be between 5 and 100 characters long
	 *     </div>
	 *   </div>
	 * ```
	 *
	 * Feel free to use other structural directives such as ng-if and ng-switch to further control
	 * what messages are active and when. Be careful, if you place ng-message on the same element
	 * as these structural directives, Angular may not be able to determine if a message is active
	 * or not. Therefore it is best to place the ng-message on a child element of the structural
	 * directive.
	 *
	 * ```html
	 * <div ng-messages="myForm.myEmail.$error" role="alert">
	 *   <div ng-if="showRequiredError">
	 *     <div ng-message="required">Please enter something</div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * ## Animations
	 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
	 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
	 * the DOM by the `ngMessages` directive.
	 *
	 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
	 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
	 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
	 * hook into the animations whenever these classes are added/removed.
	 *
	 * Let's say that our HTML code for our messages container looks like so:
	 *
	 * ```html
	 * <div ng-messages="myMessages" class="my-messages" role="alert">
	 *   <div ng-message="alert" class="some-message">...</div>
	 *   <div ng-message="fail" class="some-message">...</div>
	 * </div>
	 * ```
	 *
	 * Then the CSS animation code for the message container looks like so:
	 *
	 * ```css
	 * .my-messages {
	 *   transition:1s linear all;
	 * }
	 * .my-messages.ng-active {
	 *   // messages are visible
	 * }
	 * .my-messages.ng-inactive {
	 *   // messages are hidden
	 * }
	 * ```
	 *
	 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
	 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
	 *
	 * Therefore, the CSS code for the inner messages looks like so:
	 *
	 * ```css
	 * .some-message {
	 *   transition:1s linear all;
	 * }
	 *
	 * .some-message.ng-enter {}
	 * .some-message.ng-enter.ng-enter-active {}
	 *
	 * .some-message.ng-leave {}
	 * .some-message.ng-leave.ng-leave-active {}
	 * ```
	 *
	 * {@link ngAnimate Click here} to learn how to use JavaScript animations or to learn more about ngAnimate.
	 */
	angular.module('ngMessages', [], function initAngularHelpers() {
	  // Access helpers from angular core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  forEach = angular.forEach;
	  isArray = angular.isArray;
	  isString = angular.isString;
	  jqLite = angular.element;
	})
	  .info({ angularVersion: '1.6.6' })
	
	  /**
	   * @ngdoc directive
	   * @module ngMessages
	   * @name ngMessages
	   * @restrict AE
	   *
	   * @description
	   * `ngMessages` is a directive that is designed to show and hide messages based on the state
	   * of a key/value object that it listens on. The directive itself complements error message
	   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
	   *
	   * `ngMessages` manages the state of internal messages within its container element. The internal
	   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
	   * on if they're present within the key/value object. By default, only one message will be displayed
	   * at a time and this depends on the prioritization of the messages within the template. (This can
	   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
	   *
	   * A remote template can also be used to promote message reusability and messages can also be
	   * overridden.
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {string} ngMessages an angular expression evaluating to a key/value object
	   *                 (this is typically the $error object on an ngModel instance).
	   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
	   *
	   * @example
	   * <example name="ngMessages-directive" module="ngMessagesExample"
	   *          deps="angular-messages.js"
	   *          animations="true" fixBase="true">
	   *   <file name="index.html">
	   *     <form name="myForm">
	   *       <label>
	   *         Enter your name:
	   *         <input type="text"
	   *                name="myName"
	   *                ng-model="name"
	   *                ng-minlength="5"
	   *                ng-maxlength="20"
	   *                required />
	   *       </label>
	   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
	   *
	   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
	   *         <div ng-message="required">You did not enter a field</div>
	   *         <div ng-message="minlength">Your field is too short</div>
	   *         <div ng-message="maxlength">Your field is too long</div>
	   *       </div>
	   *     </form>
	   *   </file>
	   *   <file name="script.js">
	   *     angular.module('ngMessagesExample', ['ngMessages']);
	   *   </file>
	   * </example>
	   */
	  .directive('ngMessages', ['$animate', function($animate) {
	    var ACTIVE_CLASS = 'ng-active';
	    var INACTIVE_CLASS = 'ng-inactive';
	
	    return {
	      require: 'ngMessages',
	      restrict: 'AE',
	      controller: ['$element', '$scope', '$attrs', function NgMessagesCtrl($element, $scope, $attrs) {
	        var ctrl = this;
	        var latestKey = 0;
	        var nextAttachId = 0;
	
	        this.getAttachId = function getAttachId() { return nextAttachId++; };
	
	        var messages = this.messages = {};
	        var renderLater, cachedCollection;
	
	        this.render = function(collection) {
	          collection = collection || {};
	
	          renderLater = false;
	          cachedCollection = collection;
	
	          // this is true if the attribute is empty or if the attribute value is truthy
	          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
	                         isAttrTruthy($scope, $attrs.multiple);
	
	          var unmatchedMessages = [];
	          var matchedKeys = {};
	          var messageItem = ctrl.head;
	          var messageFound = false;
	          var totalMessages = 0;
	
	          // we use != instead of !== to allow for both undefined and null values
	          while (messageItem != null) {
	            totalMessages++;
	            var messageCtrl = messageItem.message;
	
	            var messageUsed = false;
	            if (!messageFound) {
	              forEach(collection, function(value, key) {
	                if (!messageUsed && truthy(value) && messageCtrl.test(key)) {
	                  // this is to prevent the same error name from showing up twice
	                  if (matchedKeys[key]) return;
	                  matchedKeys[key] = true;
	
	                  messageUsed = true;
	                  messageCtrl.attach();
	                }
	              });
	            }
	
	            if (messageUsed) {
	              // unless we want to display multiple messages then we should
	              // set a flag here to avoid displaying the next message in the list
	              messageFound = !multiple;
	            } else {
	              unmatchedMessages.push(messageCtrl);
	            }
	
	            messageItem = messageItem.next;
	          }
	
	          forEach(unmatchedMessages, function(messageCtrl) {
	            messageCtrl.detach();
	          });
	
	          if (unmatchedMessages.length !== totalMessages) {
	            $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS);
	          } else {
	            $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
	          }
	        };
	
	        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);
	
	        // If the element is destroyed, proactively destroy all the currently visible messages
	        $element.on('$destroy', function() {
	          forEach(messages, function(item) {
	            item.message.detach();
	          });
	        });
	
	        this.reRender = function() {
	          if (!renderLater) {
	            renderLater = true;
	            $scope.$evalAsync(function() {
	              if (renderLater && cachedCollection) {
	                ctrl.render(cachedCollection);
	              }
	            });
	          }
	        };
	
	        this.register = function(comment, messageCtrl) {
	          var nextKey = latestKey.toString();
	          messages[nextKey] = {
	            message: messageCtrl
	          };
	          insertMessageNode($element[0], comment, nextKey);
	          comment.$$ngMessageNode = nextKey;
	          latestKey++;
	
	          ctrl.reRender();
	        };
	
	        this.deregister = function(comment) {
	          var key = comment.$$ngMessageNode;
	          delete comment.$$ngMessageNode;
	          removeMessageNode($element[0], comment, key);
	          delete messages[key];
	          ctrl.reRender();
	        };
	
	        function findPreviousMessage(parent, comment) {
	          var prevNode = comment;
	          var parentLookup = [];
	
	          while (prevNode && prevNode !== parent) {
	            var prevKey = prevNode.$$ngMessageNode;
	            if (prevKey && prevKey.length) {
	              return messages[prevKey];
	            }
	
	            // dive deeper into the DOM and examine its children for any ngMessage
	            // comments that may be in an element that appears deeper in the list
	            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
	              parentLookup.push(prevNode);
	              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
	            } else if (prevNode.previousSibling) {
	              prevNode = prevNode.previousSibling;
	            } else {
	              prevNode = prevNode.parentNode;
	              parentLookup.push(prevNode);
	            }
	          }
	        }
	
	        function insertMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	          if (!ctrl.head) {
	            ctrl.head = messageNode;
	          } else {
	            var match = findPreviousMessage(parent, comment);
	            if (match) {
	              messageNode.next = match.next;
	              match.next = messageNode;
	            } else {
	              messageNode.next = ctrl.head;
	              ctrl.head = messageNode;
	            }
	          }
	        }
	
	        function removeMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	
	          var match = findPreviousMessage(parent, comment);
	          if (match) {
	            match.next = messageNode.next;
	          } else {
	            ctrl.head = messageNode.next;
	          }
	        }
	      }]
	    };
	
	    function isAttrTruthy(scope, attr) {
	     return (isString(attr) && attr.length === 0) || //empty attribute
	            truthy(scope.$eval(attr));
	    }
	
	    function truthy(val) {
	      return isString(val) ? val.length : !!val;
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessagesInclude
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
	   * code from a remote template and place the downloaded template code into the exact spot
	   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
	   * for a series of pre-defined messages to be reused and also allows for the developer to
	   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-messages-include="remoteTplString">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
	   */
	  .directive('ngMessagesInclude',
	    ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {
	
	    return {
	      restrict: 'AE',
	      require: '^^ngMessages', // we only require this for validation sake
	      link: function($scope, element, attrs) {
	        var src = attrs.ngMessagesInclude || attrs.src;
	        $templateRequest(src).then(function(html) {
	          if ($scope.$$destroyed) return;
	
	          if (isString(html) && !html.trim()) {
	            // Empty template - nothing to compile
	            replaceElementWithMarker(element, src);
	          } else {
	            // Non-empty template - compile and link
	            $compile(html)($scope, function(contents) {
	              element.after(contents);
	              replaceElementWithMarker(element, src);
	            });
	          }
	        });
	      }
	    };
	
	    // Helpers
	    function replaceElementWithMarker(element, src) {
	      // A comment marker is placed for debugging purposes
	      var comment = $compile.$$createComment ?
	          $compile.$$createComment('ngMessagesInclude', src) :
	          $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
	      var marker = jqLite(comment);
	      element.after(marker);
	
	      // Don't pollute the DOM anymore by keeping an empty directive element
	      element.remove();
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessage
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessage` is a directive with the purpose to show and hide a particular message.
	   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
	   * must be situated since it determines which messages are visible based on the state
	   * of the provided key/value map that `ngMessages` listens on.
	   *
	   * More information about using `ngMessage` can be found in the
	   * {@link module:ngMessages `ngMessages` module documentation}.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {expression} ngMessage|when a string value corresponding to the message key.
	   */
	  .directive('ngMessage', ngMessageDirectiveFactory())
	
	
	  /**
	   * @ngdoc directive
	   * @name ngMessageExp
	   * @restrict AE
	   * @priority 1
	   * @scope
	   *
	   * @description
	   * `ngMessageExp` is the same as {@link directive:ngMessage `ngMessage`}, but instead of a static
	   * value, it accepts an expression to be evaluated for the message key.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression">
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression">
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
	   */
	  .directive('ngMessageExp', ngMessageDirectiveFactory());
	
	function ngMessageDirectiveFactory() {
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AE',
	      transclude: 'element',
	      priority: 1, // must run before ngBind, otherwise the text is set on the comment
	      terminal: true,
	      require: '^^ngMessages',
	      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
	        var commentNode = element[0];
	
	        var records;
	        var staticExp = attrs.ngMessage || attrs.when;
	        var dynamicExp = attrs.ngMessageExp || attrs.whenExp;
	        var assignRecords = function(items) {
	          records = items
	              ? (isArray(items)
	                  ? items
	                  : items.split(/[\s,]+/))
	              : null;
	          ngMessagesCtrl.reRender();
	        };
	
	        if (dynamicExp) {
	          assignRecords(scope.$eval(dynamicExp));
	          scope.$watchCollection(dynamicExp, assignRecords);
	        } else {
	          assignRecords(staticExp);
	        }
	
	        var currentElement, messageCtrl;
	        ngMessagesCtrl.register(commentNode, messageCtrl = {
	          test: function(name) {
	            return contains(records, name);
	          },
	          attach: function() {
	            if (!currentElement) {
	              $transclude(function(elm, newScope) {
	                $animate.enter(elm, null, element);
	                currentElement = elm;
	
	                // Each time we attach this node to a message we get a new id that we can match
	                // when we are destroying the node later.
	                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();
	
	                // in the event that the element or a parent element is destroyed
	                // by another structural directive then it's time
	                // to deregister the message from the controller
	                currentElement.on('$destroy', function() {
	                  if (currentElement && currentElement.$$attachId === $$attachId) {
	                    ngMessagesCtrl.deregister(commentNode);
	                    messageCtrl.detach();
	                  }
	                  newScope.$destroy();
	                });
	              });
	            }
	          },
	          detach: function() {
	            if (currentElement) {
	              var elm = currentElement;
	              currentElement = null;
	              $animate.leave(elm);
	            }
	          }
	        });
	      }
	    };
	  }];
	
	  function contains(collection, key) {
	    if (collection) {
	      return isArray(collection)
	          ? collection.indexOf(key) >= 0
	          : collection.hasOwnProperty(key);
	    }
	  }
	}
	
	
	})(window, window.angular);


/***/ },

/***/ 135:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(134);
	module.exports = 'ngMessages';


/***/ },

/***/ 136:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(137);
	module.exports = 'vcRecaptcha';


/***/ },

/***/ 137:
/***/ function(module, exports) {

	/**
	 * @license angular-recaptcha build:2018-05-09
	 * https://github.com/vividcortex/angular-recaptcha
	 * Copyright (c) 2018 VividCortex
	**/
	
	/*global angular, Recaptcha */
	(function (ng) {
	    'use strict';
	
	    ng.module('vcRecaptcha', []);
	
	}(angular));
	
	/*global angular */
	(function (ng) {
	    'use strict';
	
	    function throwNoKeyException() {
	        throw new Error('You need to set the "key" attribute to your public reCaptcha key. If you don\'t have a key, please get one from https://www.google.com/recaptcha/admin/create');
	    }
	
	    var app = ng.module('vcRecaptcha');
	
	    /**
	     * An angular service to wrap the reCaptcha API
	     */
	    app.provider('vcRecaptchaService', function(){
	        var provider = this;
	        var config = {};
	        provider.onLoadFunctionName = 'vcRecaptchaApiLoaded';
	
	        /**
	         * Sets the reCaptcha configuration values which will be used by default is not specified in a specific directive instance.
	         *
	         * @since 2.5.0
	         * @param defaults  object which overrides the current defaults object.
	         */
	        provider.setDefaults = function(defaults){
	            ng.copy(defaults, config);
	        };
	
	        /**
	         * Sets the reCaptcha key which will be used by default is not specified in a specific directive instance.
	         *
	         * @since 2.5.0
	         * @param siteKey  the reCaptcha public key (refer to the README file if you don't know what this is).
	         */
	        provider.setSiteKey = function(siteKey){
	            config.key = siteKey;
	        };
	
	        /**
	         * Sets the reCaptcha theme which will be used by default is not specified in a specific directive instance.
	         *
	         * @since 2.5.0
	         * @param theme  The reCaptcha theme.
	         */
	        provider.setTheme = function(theme){
	            config.theme = theme;
	        };
	
	        /**
	         * Sets the reCaptcha stoken which will be used by default is not specified in a specific directive instance.
	         *
	         * @since 2.5.0
	         * @param stoken  The reCaptcha stoken.
	         */
	        provider.setStoken = function(stoken){
	            config.stoken = stoken;
	        };
	
	        /**
	         * Sets the reCaptcha size which will be used by default is not specified in a specific directive instance.
	         *
	         * @since 2.5.0
	         * @param size  The reCaptcha size.
	         */
	        provider.setSize = function(size){
	            config.size = size;
	        };
	
	        /**
	         * Sets the reCaptcha type which will be used by default is not specified in a specific directive instance.
	         *
	         * @since 2.5.0
	         * @param type  The reCaptcha type.
	         */
	        provider.setType = function(type){
	            config.type = type;
	        };
	
	        /**
	         * Sets the reCaptcha language which will be used by default is not specified in a specific directive instance.
	         *
	         * @param lang  The reCaptcha language.
	         */
	        provider.setLang = function(lang){
	            config.lang = lang;
	        };
	
	        /**
	         * Sets the reCaptcha badge position which will be used by default if not specified in a specific directive instance.
	         *
	         * @param badge  The reCaptcha badge position.
	         */
	        provider.setBadge = function(badge){
	            config.badge = badge;
	        };
	
	        /**
	         * Sets the reCaptcha configuration values which will be used by default is not specified in a specific directive instance.
	         *
	         * @since 2.5.0
	         * @param onLoadFunctionName  string name which overrides the name of the onload function. Should match what is in the recaptcha script querystring onload value.
	         */
	        provider.setOnLoadFunctionName = function(onLoadFunctionName){
	            provider.onLoadFunctionName = onLoadFunctionName;
	        };
	
	        provider.$get = ['$rootScope','$window', '$q', '$document', '$interval', function ($rootScope, $window, $q, $document, $interval) {
	            var deferred = $q.defer(), promise = deferred.promise, instances = {}, recaptcha;
	
	            $window.vcRecaptchaApiLoadedCallback = $window.vcRecaptchaApiLoadedCallback || [];
	
	            var callback = function () {
	                recaptcha = $window.grecaptcha;
	
	                deferred.resolve(recaptcha);
	            };
	
	            $window.vcRecaptchaApiLoadedCallback.push(callback);
	
	            $window[provider.onLoadFunctionName] = function () {
	                $window.vcRecaptchaApiLoadedCallback.forEach(function(callback) {
	                    callback();
	                });
	            };
	
	
	            function getRecaptcha() {
	                if (!!recaptcha) {
	                    return $q.when(recaptcha);
	                }
	
	                return promise;
	            }
	
	            function validateRecaptchaInstance() {
	                if (!recaptcha) {
	                    throw new Error('reCaptcha has not been loaded yet.');
	                }
	            }
	
	            function isRenderFunctionAvailable() {
	                return ng.isFunction(($window.grecaptcha || {}).render);
	            }
	
	
	            // Check if grecaptcha.render is not defined already.
	            if (isRenderFunctionAvailable()) {
	                callback();
	            } else if ($window.document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]')) {
	                // wait for script to be loaded.
	                var intervalWait = $interval(function() {
	                    if (isRenderFunctionAvailable()) {
	                        $interval.cancel(intervalWait);
	                        callback();
	                    }
	                }, 25);
	            } else {
	                // Generate link on demand
	                var script = $window.document.createElement('script');
	                script.async = true;
	                script.defer = true;
	                script.src = 'https://www.google.com/recaptcha/api.js?onload='+provider.onLoadFunctionName+'&render=explicit';
	                $document.find('body')[0].appendChild(script);
	            }
	
	            return {
	
	                /**
	                 * Creates a new reCaptcha object
	                 *
	                 * @param elm  the DOM element where to put the captcha
	                 * @param conf the captcha object configuration
	                 * @throws NoKeyException    if no key is provided in the provider config or the directive instance (via attribute)
	                 */
	                create: function (elm, conf) {
	
	                    conf.sitekey = conf.key || config.key;
	                    conf.theme = conf.theme || config.theme;
	                    conf.stoken = conf.stoken || config.stoken;
	                    conf.size = conf.size || config.size;
	                    conf.type = conf.type || config.type;
	                    conf.hl = conf.lang || config.lang;
	                    conf.badge = conf.badge || config.badge;
	
	                    if (!conf.sitekey) {
	                        throwNoKeyException();
	                    }
	                    return getRecaptcha().then(function (recaptcha) {
	                        var widgetId = recaptcha.render(elm, conf);
	                        instances[widgetId] = elm;
	                        return widgetId;
	                    });
	                },
	
	                /**
	                 * Reloads the reCaptcha
	                 */
	                reload: function (widgetId) {
	                    validateRecaptchaInstance();
	
	                    recaptcha.reset(widgetId);
	
	                    // Let everyone know this widget has been reset.
	                    $rootScope.$broadcast('reCaptchaReset', widgetId);
	                },
	
	                /**
	                 * Executes the reCaptcha
	                 */
	                execute: function (widgetId) {
	                    validateRecaptchaInstance();
	
	                    recaptcha.execute(widgetId);
	                },
	
	                /**
	                 * Get/Set reCaptcha language
	                 */
	                useLang: function (widgetId, lang) {
	                    var instance = instances[widgetId];
	
	                    if (instance) {
	                        var iframe = instance.querySelector('iframe');
	                        if (lang) {
	                            // Setter
	                            if (iframe && iframe.src) {
	                                var s = iframe.src;
	                                if (/[?&]hl=/.test(s)) {
	                                    s = s.replace(/([?&]hl=)\w+/, '$1' + lang);
	                                } else {
	                                    s += ((s.indexOf('?') === -1) ? '?' : '&') + 'hl=' + lang;
	                                }
	
	                                iframe.src = s;
	                            }
	                        } else {
	                            // Getter
	                            if (iframe && iframe.src && /[?&]hl=\w+/.test(iframe.src)) {
	                                return iframe.src.replace(/.+[?&]hl=(\w+)([^\w].+)?/, '$1');
	                            } else {
	                                return null;
	                            }
	                        }
	                    } else {
	                        throw new Error('reCaptcha Widget ID not exists', widgetId);
	                    }
	                },
	
	                /**
	                 * Gets the response from the reCaptcha widget.
	                 *
	                 * @see https://developers.google.com/recaptcha/docs/display#js_api
	                 *
	                 * @returns {String}
	                 */
	                getResponse: function (widgetId) {
	                    validateRecaptchaInstance();
	
	                    return recaptcha.getResponse(widgetId);
	                },
	
	                /**
	                 * Gets reCaptcha instance and configuration
	                 */
	                getInstance: function (widgetId) {
	                    return instances[widgetId];
	                },
	
	                /**
	                 * Destroy reCaptcha instance.
	                 */
	                destroy: function (widgetId) {
	                    delete instances[widgetId];
	                }
	            };
	
	        }];
	    });
	
	}(angular));
	
	/*global angular, Recaptcha */
	(function (ng) {
	    'use strict';
	
	    var app = ng.module('vcRecaptcha');
	
	    app.directive('vcRecaptcha', ['$document', '$timeout', 'vcRecaptchaService', function ($document, $timeout, vcRecaptcha) {
	
	        return {
	            restrict: 'A',
	            require: "?^^form",
	            scope: {
	                response: '=?ngModel',
	                key: '=?',
	                stoken: '=?',
	                theme: '=?',
	                size: '=?',
	                type: '=?',
	                lang: '=?',
	                badge: '=?',
	                tabindex: '=?',
	                required: '=?',
	                onCreate: '&',
	                onSuccess: '&',
	                onExpire: '&'
	            },
	            link: function (scope, elm, attrs, ctrl) {
	                scope.widgetId = null;
	
	                if(ctrl && ng.isDefined(attrs.required)){
	                    scope.$watch('required', validate);
	                }
	
	                var removeCreationListener = scope.$watch('key', function (key) {
	                    var callback = function (gRecaptchaResponse) {
	                        // Safe $apply
	                        $timeout(function () {
	                            scope.response = gRecaptchaResponse;
	                            validate();
	
	                            // Notify about the response availability
	                            scope.onSuccess({response: gRecaptchaResponse, widgetId: scope.widgetId});
	                        });
	                    };
	
	                    vcRecaptcha.create(elm[0], {
	
	                        callback: callback,
	                        key: key,
	                        stoken: scope.stoken || attrs.stoken || null,
	                        theme: scope.theme || attrs.theme || null,
	                        type: scope.type || attrs.type || null,
	                        lang: scope.lang || attrs.lang || null,
	                        tabindex: scope.tabindex || attrs.tabindex || null,
	                        size: scope.size || attrs.size || null,
	                        badge: scope.badge || attrs.badge || null,
	                        'expired-callback': expired
	
	                    }).then(function (widgetId) {
	                        // The widget has been created
	                        validate();
	                        scope.widgetId = widgetId;
	                        scope.onCreate({widgetId: widgetId});
	
	                        scope.$on('$destroy', destroy);
	
	                        scope.$on('reCaptchaReset', function(event, resetWidgetId){
	                          if(ng.isUndefined(resetWidgetId) || widgetId === resetWidgetId){
	                            scope.response = "";
	                            validate();
	                          }
	                        })
	
	                    });
	
	                    // Remove this listener to avoid creating the widget more than once.
	                    removeCreationListener();
	                });
	
	                function destroy() {
	                  if (ctrl) {
	                    // reset the validity of the form if we were removed
	                    ctrl.$setValidity('recaptcha', null);
	                  }
	
	                  cleanup();
	                }
	
	                function expired(){
	                    // Safe $apply
	                    $timeout(function () {
	                        scope.response = "";
	                        validate();
	
	                        // Notify about the response availability
	                        scope.onExpire({ widgetId: scope.widgetId });
	                    });
	                }
	
	                function validate(){
	                    if(ctrl){
	                        ctrl.$setValidity('recaptcha', scope.required === false ? null : Boolean(scope.response));
	                    }
	                }
	
	                function cleanup(){
	                  vcRecaptcha.destroy(scope.widgetId);
	
	                  // removes elements reCaptcha added.
	                  ng.element($document[0].querySelectorAll('.pls-container')).parent().remove();
	                }
	            }
	        };
	    }]);
	
	}(angular));


/***/ },

/***/ 138:
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.8.3
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var $resourceMinErr = angular.$$minErr('$resource');
	
	// Helper functions and regex to lookup a dotted path on an object
	// stopping at undefined/null.  The path must be composed of ASCII
	// identifiers (just like $parse)
	var MEMBER_NAME_REGEX = /^(\.[a-zA-Z_$@][0-9a-zA-Z_$@]*)+$/;
	
	function isValidDottedPath(path) {
	  return (path != null && path !== '' && path !== 'hasOwnProperty' &&
	      MEMBER_NAME_REGEX.test('.' + path));
	}
	
	function lookupDottedPath(obj, path) {
	  if (!isValidDottedPath(path)) {
	    throw $resourceMinErr('badmember', 'Dotted member path "@{0}" is invalid.', path);
	  }
	  var keys = path.split('.');
	  for (var i = 0, ii = keys.length; i < ii && angular.isDefined(obj); i++) {
	    var key = keys[i];
	    obj = (obj !== null) ? obj[key] : undefined;
	  }
	  return obj;
	}
	
	/**
	 * Create a shallow copy of an object and clear other fields from the destination
	 */
	function shallowClearAndCopy(src, dst) {
	  dst = dst || {};
	
	  angular.forEach(dst, function(value, key) {
	    delete dst[key];
	  });
	
	  for (var key in src) {
	    if (src.hasOwnProperty(key) && !(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	      dst[key] = src[key];
	    }
	  }
	
	  return dst;
	}
	
	/**
	 * @ngdoc module
	 * @name ngResource
	 * @description
	 *
	 * The `ngResource` module provides interaction support with RESTful services
	 * via the $resource service.
	 *
	 * See {@link ngResource.$resourceProvider} and {@link ngResource.$resource} for usage.
	 */
	
	/**
	 * @ngdoc provider
	 * @name $resourceProvider
	 *
	 * @description
	 *
	 * Use `$resourceProvider` to change the default behavior of the {@link ngResource.$resource}
	 * service.
	 *
	 * ## Dependencies
	 * Requires the {@link ngResource } module to be installed.
	 *
	 */
	
	/**
	 * @ngdoc service
	 * @name $resource
	 * @requires $http
	 * @requires ng.$log
	 * @requires $q
	 * @requires ng.$timeout
	 *
	 * @description
	 * A factory which creates a resource object that lets you interact with
	 * [RESTful](http://en.wikipedia.org/wiki/Representational_State_Transfer) server-side data sources.
	 *
	 * The returned resource object has action methods which provide high-level behaviors without
	 * the need to interact with the low level {@link ng.$http $http} service.
	 *
	 * Requires the {@link ngResource `ngResource`} module to be installed.
	 *
	 * By default, trailing slashes will be stripped from the calculated URLs,
	 * which can pose problems with server backends that do not expect that
	 * behavior.  This can be disabled by configuring the `$resourceProvider` like
	 * this:
	 *
	 * ```js
	     app.config(['$resourceProvider', function($resourceProvider) {
	       // Don't strip trailing slashes from calculated URLs
	       $resourceProvider.defaults.stripTrailingSlashes = false;
	     }]);
	 * ```
	 *
	 * @param {string} url A parameterized URL template with parameters prefixed by `:` as in
	 *   `/user/:username`. If you are using a URL with a port number (e.g.
	 *   `http://example.com:8080/api`), it will be respected.
	 *
	 *   If you are using a url with a suffix, just add the suffix, like this:
	 *   `$resource('http://example.com/resource.json')` or `$resource('http://example.com/:id.json')`
	 *   or even `$resource('http://example.com/resource/:resource_id.:format')`
	 *   If the parameter before the suffix is empty, :resource_id in this case, then the `/.` will be
	 *   collapsed down to a single `.`.  If you need this sequence to appear and not collapse then you
	 *   can escape it with `/\.`.
	 *
	 * @param {Object=} paramDefaults Default values for `url` parameters. These can be overridden in
	 *   `actions` methods. If a parameter value is a function, it will be called every time
	 *   a param value needs to be obtained for a request (unless the param was overridden). The
	 *   function will be passed the current data value as an argument.
	 *
	 *   Each key value in the parameter object is first bound to url template if present and then any
	 *   excess keys are appended to the url search query after the `?`.
	 *
	 *   Given a template `/path/:verb` and parameter `{verb: 'greet', salutation: 'Hello'}` results in
	 *   URL `/path/greet?salutation=Hello`.
	 *
	 *   If the parameter value is prefixed with `@`, then the value for that parameter will be
	 *   extracted from the corresponding property on the `data` object (provided when calling actions
	 *   with a request body).
	 *   For example, if the `defaultParam` object is `{someParam: '@someProp'}` then the value of
	 *   `someParam` will be `data.someProp`.
	 *   Note that the parameter will be ignored, when calling a "GET" action method (i.e. an action
	 *   method that does not accept a request body).
	 *
	 * @param {Object.<Object>=} actions Hash with declaration of custom actions that will be available
	 *   in addition to the default set of resource actions (see below). If a custom action has the same
	 *   key as a default action (e.g. `save`), then the default action will be *overwritten*, and not
	 *   extended.
	 *
	 *   The declaration should be created in the format of {@link ng.$http#usage $http.config}:
	 *
	 *       {
	 *         action1: {method:?, params:?, isArray:?, headers:?, ...},
	 *         action2: {method:?, params:?, isArray:?, headers:?, ...},
	 *         ...
	 *       }
	 *
	 *   Where:
	 *
	 *   - **`action`** – {string} – The name of action. This name becomes the name of the method on
	 *     your resource object.
	 *   - **`method`** – {string} – Case insensitive HTTP method (e.g. `GET`, `POST`, `PUT`,
	 *     `DELETE`, `JSONP`, etc).
	 *   - **`params`** – {Object=} – Optional set of pre-bound parameters for this action. If any of
	 *     the parameter value is a function, it will be called every time when a param value needs to
	 *     be obtained for a request (unless the param was overridden). The function will be passed the
	 *     current data value as an argument.
	 *   - **`url`** – {string} – Action specific `url` override. The url templating is supported just
	 *     like for the resource-level urls.
	 *   - **`isArray`** – {boolean=} – If true then the returned object for this action is an array,
	 *     see `returns` section.
	 *   - **`transformRequest`** –
	 *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	 *     Transform function or an array of such functions. The transform function takes the http
	 *     request body and headers and returns its transformed (typically serialized) version.
	 *     By default, transformRequest will contain one function that checks if the request data is
	 *     an object and serializes it using `angular.toJson`. To prevent this behavior, set
	 *     `transformRequest` to an empty array: `transformRequest: []`
	 *   - **`transformResponse`** –
	 *     `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	 *     Transform function or an array of such functions. The transform function takes the HTTP
	 *     response body, headers and status and returns its transformed (typically deserialized)
	 *     version.
	 *     By default, transformResponse will contain one function that checks if the response looks
	 *     like a JSON string and deserializes it using `angular.fromJson`. To prevent this behavior,
	 *     set `transformResponse` to an empty array: `transformResponse: []`
	 *   - **`cache`** – `{boolean|Cache}` – A boolean value or object created with
	 *     {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	 *     See {@link $http#caching $http Caching} for more information.
	 *   - **`timeout`** – `{number}` – Timeout in milliseconds.<br />
	 *     **Note:** In contrast to {@link ng.$http#usage $http.config}, {@link ng.$q promises} are
	 *     **not** supported in `$resource`, because the same value would be used for multiple requests.
	 *     If you are looking for a way to cancel requests, you should use the `cancellable` option.
	 *   - **`cancellable`** – `{boolean}` – If true, the request made by a "non-instance" call will be
	 *     cancelled (if not already completed) by calling `$cancelRequest()` on the call's return
	 *     value. Calling `$cancelRequest()` for a non-cancellable or an already completed/cancelled
	 *     request will have no effect.
	 *   - **`withCredentials`** – `{boolean}` – Whether to set the `withCredentials` flag on the
	 *     XHR object. See
	 *     [XMLHttpRequest.withCredentials](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials)
	 *     for more information.
	 *   - **`responseType`** – `{string}` – See
	 *     [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseType).
	 *   - **`interceptor`** – `{Object=}` – The interceptor object has four optional methods -
	 *     `request`, `requestError`, `response`, and `responseError`. See
	 *     {@link ng.$http#interceptors $http interceptors} for details. Note that
	 *     `request`/`requestError` interceptors are applied before calling `$http`, thus before any
	 *     global `$http` interceptors. Also, rejecting or throwing an error inside the `request`
	 *     interceptor will result in calling the `responseError` interceptor.
	 *     The resource instance or collection is available on the `resource` property of the
	 *     `http response` object passed to `response`/`responseError` interceptors.
	 *     Keep in mind that the associated promise will be resolved with the value returned by the
	 *     response interceptors. Make sure you return an appropriate value and not the `response`
	 *     object passed as input. For reference, the default `response` interceptor (which gets applied
	 *     if you don't specify a custom one) returns `response.resource`.<br />
	 *     See {@link ngResource.$resource#using-interceptors below} for an example of using
	 *     interceptors in `$resource`.
	 *   - **`hasBody`** – `{boolean}` – If true, then the request will have a body.
	 *     If not specified, then only POST, PUT and PATCH requests will have a body. *
	 * @param {Object} options Hash with custom settings that should extend the
	 *   default `$resourceProvider` behavior.  The supported options are:
	 *
	 *   - **`stripTrailingSlashes`** – {boolean} – If true then the trailing
	 *   slashes from any calculated URL will be stripped. (Defaults to true.)
	 *   - **`cancellable`** – {boolean} – If true, the request made by a "non-instance" call will be
	 *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return value.
	 *   This can be overwritten per action. (Defaults to false.)
	 *
	 * @returns {Object} A resource "class" object with methods for the default set of resource actions
	 *   optionally extended with custom `actions`. The default set contains these actions:
	 *   ```js
	 *   {
	 *     'get':    {method: 'GET'},
	 *     'save':   {method: 'POST'},
	 *     'query':  {method: 'GET', isArray: true},
	 *     'remove': {method: 'DELETE'},
	 *     'delete': {method: 'DELETE'}
	 *   }
	 *   ```
	 *
	 *   Calling these methods invoke {@link ng.$http} with the specified http method, destination and
	 *   parameters. When the data is returned from the server then the object is an instance of the
	 *   resource class. The actions `save`, `remove` and `delete` are available on it as methods with
	 *   the `$` prefix. This allows you to easily perform CRUD operations (create, read, update,
	 *   delete) on server-side data like this:
	 *   ```js
	 *   var User = $resource('/user/:userId', {userId: '@id'});
	 *   User.get({userId: 123}).$promise.then(function(user) {
	 *     user.abc = true;
	 *     user.$save();
	 *   });
	 *   ```
	 *
	 *   It is important to realize that invoking a `$resource` object method immediately returns an
	 *   empty reference (object or array depending on `isArray`). Once the data is returned from the
	 *   server the existing reference is populated with the actual data. This is a useful trick since
	 *   usually the resource is assigned to a model which is then rendered by the view. Having an empty
	 *   object results in no rendering, once the data arrives from the server then the object is
	 *   populated with the data and the view automatically re-renders itself showing the new data. This
	 *   means that in most cases one never has to write a callback function for the action methods.
	 *
	 *   The action methods on the class object or instance object can be invoked with the following
	 *   parameters:
	 *
	 *   - "class" actions without a body: `Resource.action([parameters], [success], [error])`
	 *   - "class" actions with a body: `Resource.action([parameters], postData, [success], [error])`
	 *   - instance actions: `instance.$action([parameters], [success], [error])`
	 *
	 *
	 *   When calling instance methods, the instance itself is used as the request body (if the action
	 *   should have a body). By default, only actions using `POST`, `PUT` or `PATCH` have request
	 *   bodies, but you can use the `hasBody` configuration option to specify whether an action
	 *   should have a body or not (regardless of its HTTP method).
	 *
	 *
	 *   Success callback is called with (value (Object|Array), responseHeaders (Function),
	 *   status (number), statusText (string)) arguments, where `value` is the populated resource
	 *   instance or collection object. The error callback is called with (httpResponse) argument.
	 *
	 *   Class actions return an empty instance (with the additional properties listed below).
	 *   Instance actions return a promise for the operation.
	 *
	 *   The Resource instances and collections have these additional properties:
	 *
	 *   - `$promise`: The {@link ng.$q promise} of the original server interaction that created this
	 *     instance or collection.
	 *
	 *     On success, the promise is resolved with the same resource instance or collection object,
	 *     updated with data from server. This makes it easy to use in the
	 *     {@link ngRoute.$routeProvider `resolve` section of `$routeProvider.when()`} to defer view
	 *     rendering until the resource(s) are loaded.
	 *
	 *     On failure, the promise is rejected with the {@link ng.$http http response} object.
	 *
	 *     If an interceptor object was provided, the promise will instead be resolved with the value
	 *     returned by the response interceptor (on success) or responceError interceptor (on failure).
	 *
	 *   - `$resolved`: `true` after first server interaction is completed (either with success or
	 *      rejection), `false` before that. Knowing if the Resource has been resolved is useful in
	 *      data-binding. If there is a response/responseError interceptor and it returns a promise,
	 *      `$resolved` will wait for that too.
	 *
	 *   The Resource instances and collections have these additional methods:
	 *
	 *   - `$cancelRequest`: If there is a cancellable, pending request related to the instance or
	 *      collection, calling this method will abort the request.
	 *
	 *   The Resource instances have these additional methods:
	 *
	 *   - `toJSON`: It returns a simple object without any of the extra properties added as part of
	 *     the Resource API. This object can be serialized through {@link angular.toJson} safely
	 *     without attaching AngularJS-specific fields. Notice that `JSON.stringify` (and
	 *     `angular.toJson`) automatically use this method when serializing a Resource instance
	 *     (see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#toJSON%28%29_behavior)).
	 *
	 * @example
	 *
	 * ### Basic usage
	 *
	   ```js
	     // Define a CreditCard class
	     var CreditCard = $resource('/users/:userId/cards/:cardId',
	       {userId: 123, cardId: '@id'}, {
	         charge: {method: 'POST', params: {charge: true}}
	       });
	
	     // We can retrieve a collection from the server
	     var cards = CreditCard.query();
	         // GET: /users/123/cards
	         // server returns: [{id: 456, number: '1234', name: 'Smith'}]
	
	     // Wait for the request to complete
	     cards.$promise.then(function() {
	       var card = cards[0];
	
	       // Each item is an instance of CreditCard
	       expect(card instanceof CreditCard).toEqual(true);
	
	       // Non-GET methods are mapped onto the instances
	       card.name = 'J. Smith';
	       card.$save();
	           // POST: /users/123/cards/456 {id: 456, number: '1234', name: 'J. Smith'}
	           // server returns: {id: 456, number: '1234', name: 'J. Smith'}
	
	       // Our custom method is mapped as well (since it uses POST)
	       card.$charge({amount: 9.99});
	           // POST: /users/123/cards/456?amount=9.99&charge=true {id: 456, number: '1234', name: 'J. Smith'}
	     });
	
	     // We can create an instance as well
	     var newCard = new CreditCard({number: '0123'});
	     newCard.name = 'Mike Smith';
	
	     var savePromise = newCard.$save();
	         // POST: /users/123/cards {number: '0123', name: 'Mike Smith'}
	         // server returns: {id: 789, number: '0123', name: 'Mike Smith'}
	
	     savePromise.then(function() {
	       // Once the promise is resolved, the created instance
	       // is populated with the data returned by the server
	       expect(newCard.id).toEqual(789);
	     });
	   ```
	 *
	 * The object returned from a call to `$resource` is a resource "class" which has one "static"
	 * method for each action in the definition.
	 *
	 * Calling these methods invokes `$http` on the `url` template with the given HTTP `method`,
	 * `params` and `headers`.
	 *
	 * @example
	 *
	 * ### Accessing the response
	 *
	 * When the data is returned from the server then the object is an instance of the resource type and
	 * all of the non-GET methods are available with `$` prefix. This allows you to easily support CRUD
	 * operations (create, read, update, delete) on server-side data.
	 *
	   ```js
	     var User = $resource('/users/:userId', {userId: '@id'});
	     User.get({userId: 123}).$promise.then(function(user) {
	       user.abc = true;
	       user.$save();
	     });
	   ```
	 *
	 * It's worth noting that the success callback for `get`, `query` and other methods gets called with
	 * the resource instance (populated with the data that came from the server) as well as an `$http`
	 * header getter function, the HTTP status code and the response status text. So one could rewrite
	 * the above example and get access to HTTP headers as follows:
	 *
	   ```js
	     var User = $resource('/users/:userId', {userId: '@id'});
	     User.get({userId: 123}, function(user, getResponseHeaders) {
	       user.abc = true;
	       user.$save(function(user, putResponseHeaders) {
	         // `user` => saved `User` object
	         // `putResponseHeaders` => `$http` header getter
	       });
	     });
	   ```
	 *
	 * @example
	 *
	 * ### Creating custom actions
	 *
	 * In this example we create a custom method on our resource to make a PUT request:
	 *
	   ```js
	      var app = angular.module('app', ['ngResource']);
	
	      // Some APIs expect a PUT request in the format URL/object/ID
	      // Here we are creating an 'update' method
	      app.factory('Notes', ['$resource', function($resource) {
	        return $resource('/notes/:id', {id: '@id'}, {
	          update: {method: 'PUT'}
	        });
	      }]);
	
	      // In our controller we get the ID from the URL using `$location`
	      app.controller('NotesCtrl', ['$location', 'Notes', function($location, Notes) {
	        // First, retrieve the corresponding `Note` object from the server
	        // (Assuming a URL of the form `.../notes?id=XYZ`)
	        var noteId = $location.search().id;
	        var note = Notes.get({id: noteId});
	
	        note.$promise.then(function() {
	          note.content = 'Hello, world!';
	
	          // Now call `update` to save the changes on the server
	          Notes.update(note);
	              // This will PUT /notes/ID with the note object as the request payload
	
	          // Since `update` is a non-GET method, it will also be available on the instance
	          // (prefixed with `$`), so we could replace the `Note.update()` call with:
	          //note.$update();
	        });
	      }]);
	   ```
	 *
	 * @example
	 *
	 * ### Cancelling requests
	 *
	 * If an action's configuration specifies that it is cancellable, you can cancel the request related
	 * to an instance or collection (as long as it is a result of a "non-instance" call):
	 *
	   ```js
	     // ...defining the `Hotel` resource...
	     var Hotel = $resource('/api/hotels/:id', {id: '@id'}, {
	       // Let's make the `query()` method cancellable
	       query: {method: 'get', isArray: true, cancellable: true}
	     });
	
	     // ...somewhere in the PlanVacationController...
	     ...
	     this.onDestinationChanged = function onDestinationChanged(destination) {
	       // We don't care about any pending request for hotels
	       // in a different destination any more
	       if (this.availableHotels) {
	         this.availableHotels.$cancelRequest();
	       }
	
	       // Let's query for hotels in `destination`
	       // (calls: /api/hotels?location=<destination>)
	       this.availableHotels = Hotel.query({location: destination});
	     };
	   ```
	 *
	 * @example
	 *
	 * ### Using interceptors
	 *
	 * You can use interceptors to transform the request or response, perform additional operations, and
	 * modify the returned instance/collection. The following example, uses `request` and `response`
	 * interceptors to augment the returned instance with additional info:
	 *
	   ```js
	     var Thing = $resource('/api/things/:id', {id: '@id'}, {
	       save: {
	         method: 'POST',
	         interceptor: {
	           request: function(config) {
	             // Before the request is sent out, store a timestamp on the request config
	             config.requestTimestamp = Date.now();
	             return config;
	           },
	           response: function(response) {
	             // Get the instance from the response object
	             var instance = response.resource;
	
	             // Augment the instance with a custom `saveLatency` property, computed as the time
	             // between sending the request and receiving the response.
	             instance.saveLatency = Date.now() - response.config.requestTimestamp;
	
	             // Return the instance
	             return instance;
	           }
	         }
	       }
	     });
	
	     Thing.save({foo: 'bar'}).$promise.then(function(thing) {
	       console.log('That thing was saved in ' + thing.saveLatency + 'ms.');
	     });
	   ```
	 *
	 */
	angular.module('ngResource', ['ng']).
	  info({ angularVersion: '1.8.3' }).
	  provider('$resource', function ResourceProvider() {
	    var PROTOCOL_AND_IPV6_REGEX = /^https?:\/\/\[[^\]]*][^/]*/;
	
	    var provider = this;
	
	    /**
	     * @ngdoc property
	     * @name $resourceProvider#defaults
	     * @description
	     * Object containing default options used when creating `$resource` instances.
	     *
	     * The default values satisfy a wide range of usecases, but you may choose to overwrite any of
	     * them to further customize your instances. The available properties are:
	     *
	     * - **stripTrailingSlashes** – `{boolean}` – If true, then the trailing slashes from any
	     *   calculated URL will be stripped.<br />
	     *   (Defaults to true.)
	     * - **cancellable** – `{boolean}` – If true, the request made by a "non-instance" call will be
	     *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return
	     *   value. For more details, see {@link ngResource.$resource}. This can be overwritten per
	     *   resource class or action.<br />
	     *   (Defaults to false.)
	     * - **actions** - `{Object.<Object>}` - A hash with default actions declarations. Actions are
	     *   high-level methods corresponding to RESTful actions/methods on resources. An action may
	     *   specify what HTTP method to use, what URL to hit, if the return value will be a single
	     *   object or a collection (array) of objects etc. For more details, see
	     *   {@link ngResource.$resource}. The actions can also be enhanced or overwritten per resource
	     *   class.<br />
	     *   The default actions are:
	     *   ```js
	     *   {
	     *     get: {method: 'GET'},
	     *     save: {method: 'POST'},
	     *     query: {method: 'GET', isArray: true},
	     *     remove: {method: 'DELETE'},
	     *     delete: {method: 'DELETE'}
	     *   }
	     *   ```
	     *
	     * #### Example
	     *
	     * For example, you can specify a new `update` action that uses the `PUT` HTTP verb:
	     *
	     * ```js
	     *   angular.
	     *     module('myApp').
	     *     config(['$resourceProvider', function ($resourceProvider) {
	     *       $resourceProvider.defaults.actions.update = {
	     *         method: 'PUT'
	     *       };
	     *     }]);
	     * ```
	     *
	     * Or you can even overwrite the whole `actions` list and specify your own:
	     *
	     * ```js
	     *   angular.
	     *     module('myApp').
	     *     config(['$resourceProvider', function ($resourceProvider) {
	     *       $resourceProvider.defaults.actions = {
	     *         create: {method: 'POST'},
	     *         get:    {method: 'GET'},
	     *         getAll: {method: 'GET', isArray:true},
	     *         update: {method: 'PUT'},
	     *         delete: {method: 'DELETE'}
	     *       };
	     *     });
	     * ```
	     *
	     */
	    this.defaults = {
	      // Strip slashes by default
	      stripTrailingSlashes: true,
	
	      // Make non-instance requests cancellable (via `$cancelRequest()`)
	      cancellable: false,
	
	      // Default actions configuration
	      actions: {
	        'get': {method: 'GET'},
	        'save': {method: 'POST'},
	        'query': {method: 'GET', isArray: true},
	        'remove': {method: 'DELETE'},
	        'delete': {method: 'DELETE'}
	      }
	    };
	
	    this.$get = ['$http', '$log', '$q', '$timeout', function($http, $log, $q, $timeout) {
	
	      var noop = angular.noop,
	          forEach = angular.forEach,
	          extend = angular.extend,
	          copy = angular.copy,
	          isArray = angular.isArray,
	          isDefined = angular.isDefined,
	          isFunction = angular.isFunction,
	          isNumber = angular.isNumber,
	          encodeUriQuery = angular.$$encodeUriQuery,
	          encodeUriSegment = angular.$$encodeUriSegment;
	
	      function Route(template, defaults) {
	        this.template = template;
	        this.defaults = extend({}, provider.defaults, defaults);
	        this.urlParams = {};
	      }
	
	      Route.prototype = {
	        setUrlParams: function(config, params, actionUrl) {
	          var self = this,
	            url = actionUrl || self.template,
	            val,
	            encodedVal,
	            protocolAndIpv6 = '';
	
	          var urlParams = self.urlParams = Object.create(null);
	          forEach(url.split(/\W/), function(param) {
	            if (param === 'hasOwnProperty') {
	              throw $resourceMinErr('badname', 'hasOwnProperty is not a valid parameter name.');
	            }
	            if (!(new RegExp('^\\d+$').test(param)) && param &&
	              (new RegExp('(^|[^\\\\]):' + param + '(\\W|$)').test(url))) {
	              urlParams[param] = {
	                isQueryParamValue: (new RegExp('\\?.*=:' + param + '(?:\\W|$)')).test(url)
	              };
	            }
	          });
	          url = url.replace(/\\:/g, ':');
	          url = url.replace(PROTOCOL_AND_IPV6_REGEX, function(match) {
	            protocolAndIpv6 = match;
	            return '';
	          });
	
	          params = params || {};
	          forEach(self.urlParams, function(paramInfo, urlParam) {
	            val = params.hasOwnProperty(urlParam) ? params[urlParam] : self.defaults[urlParam];
	            if (isDefined(val) && val !== null) {
	              if (paramInfo.isQueryParamValue) {
	                encodedVal = encodeUriQuery(val, true);
	              } else {
	                encodedVal = encodeUriSegment(val);
	              }
	              url = url.replace(new RegExp(':' + urlParam + '(\\W|$)', 'g'), function(match, p1) {
	                return encodedVal + p1;
	              });
	            } else {
	              url = url.replace(new RegExp('(/?):' + urlParam + '(\\W|$)', 'g'), function(match,
	                  leadingSlashes, tail) {
	                if (tail.charAt(0) === '/') {
	                  return tail;
	                } else {
	                  return leadingSlashes + tail;
	                }
	              });
	            }
	          });
	
	          // strip trailing slashes and set the url (unless this behavior is specifically disabled)
	          if (self.defaults.stripTrailingSlashes) {
	            url = url.replace(/\/+$/, '') || '/';
	          }
	
	          // Collapse `/.` if found in the last URL path segment before the query.
	          // E.g. `http://url.com/id/.format?q=x` becomes `http://url.com/id.format?q=x`.
	          url = url.replace(/\/\.(?=\w+($|\?))/, '.');
	          // Replace escaped `/\.` with `/.`.
	          // (If `\.` comes from a param value, it will be encoded as `%5C.`.)
	          config.url = protocolAndIpv6 + url.replace(/\/(\\|%5C)\./, '/.');
	
	
	          // set params - delegate param encoding to $http
	          forEach(params, function(value, key) {
	            if (!self.urlParams[key]) {
	              config.params = config.params || {};
	              config.params[key] = value;
	            }
	          });
	        }
	      };
	
	
	      function resourceFactory(url, paramDefaults, actions, options) {
	        var route = new Route(url, options);
	
	        actions = extend({}, provider.defaults.actions, actions);
	
	        function extractParams(data, actionParams) {
	          var ids = {};
	          actionParams = extend({}, paramDefaults, actionParams);
	          forEach(actionParams, function(value, key) {
	            if (isFunction(value)) { value = value(data); }
	            ids[key] = value && value.charAt && value.charAt(0) === '@' ?
	              lookupDottedPath(data, value.substr(1)) : value;
	          });
	          return ids;
	        }
	
	        function defaultResponseInterceptor(response) {
	          return response.resource;
	        }
	
	        function Resource(value) {
	          shallowClearAndCopy(value || {}, this);
	        }
	
	        Resource.prototype.toJSON = function() {
	          var data = extend({}, this);
	          delete data.$promise;
	          delete data.$resolved;
	          delete data.$cancelRequest;
	          return data;
	        };
	
	        forEach(actions, function(action, name) {
	          var hasBody = action.hasBody === true || (action.hasBody !== false && /^(POST|PUT|PATCH)$/i.test(action.method));
	          var numericTimeout = action.timeout;
	          var cancellable = isDefined(action.cancellable) ?
	              action.cancellable : route.defaults.cancellable;
	
	          if (numericTimeout && !isNumber(numericTimeout)) {
	            $log.debug('ngResource:\n' +
	                       '  Only numeric values are allowed as `timeout`.\n' +
	                       '  Promises are not supported in $resource, because the same value would ' +
	                       'be used for multiple requests. If you are looking for a way to cancel ' +
	                       'requests, you should use the `cancellable` option.');
	            delete action.timeout;
	            numericTimeout = null;
	          }
	
	          Resource[name] = function(a1, a2, a3, a4) {
	            var params = {}, data, onSuccess, onError;
	
	            switch (arguments.length) {
	              case 4:
	                onError = a4;
	                onSuccess = a3;
	                // falls through
	              case 3:
	              case 2:
	                if (isFunction(a2)) {
	                  if (isFunction(a1)) {
	                    onSuccess = a1;
	                    onError = a2;
	                    break;
	                  }
	
	                  onSuccess = a2;
	                  onError = a3;
	                  // falls through
	                } else {
	                  params = a1;
	                  data = a2;
	                  onSuccess = a3;
	                  break;
	                }
	                // falls through
	              case 1:
	                if (isFunction(a1)) onSuccess = a1;
	                else if (hasBody) data = a1;
	                else params = a1;
	                break;
	              case 0: break;
	              default:
	                throw $resourceMinErr('badargs',
	                  'Expected up to 4 arguments [params, data, success, error], got {0} arguments',
	                  arguments.length);
	            }
	
	            var isInstanceCall = this instanceof Resource;
	            var value = isInstanceCall ? data : (action.isArray ? [] : new Resource(data));
	            var httpConfig = {};
	            var requestInterceptor = action.interceptor && action.interceptor.request || undefined;
	            var requestErrorInterceptor = action.interceptor && action.interceptor.requestError ||
	              undefined;
	            var responseInterceptor = action.interceptor && action.interceptor.response ||
	              defaultResponseInterceptor;
	            var responseErrorInterceptor = action.interceptor && action.interceptor.responseError ||
	              $q.reject;
	            var successCallback = onSuccess ? function(val) {
	              onSuccess(val, response.headers, response.status, response.statusText);
	            } : undefined;
	            var errorCallback = onError || undefined;
	            var timeoutDeferred;
	            var numericTimeoutPromise;
	            var response;
	
	            forEach(action, function(value, key) {
	              switch (key) {
	                default:
	                  httpConfig[key] = copy(value);
	                  break;
	                case 'params':
	                case 'isArray':
	                case 'interceptor':
	                case 'cancellable':
	                  break;
	              }
	            });
	
	            if (!isInstanceCall && cancellable) {
	              timeoutDeferred = $q.defer();
	              httpConfig.timeout = timeoutDeferred.promise;
	
	              if (numericTimeout) {
	                numericTimeoutPromise = $timeout(timeoutDeferred.resolve, numericTimeout);
	              }
	            }
	
	            if (hasBody) httpConfig.data = data;
	            route.setUrlParams(httpConfig,
	              extend({}, extractParams(data, action.params || {}), params),
	              action.url);
	
	            // Start the promise chain
	            var promise = $q.
	              resolve(httpConfig).
	              then(requestInterceptor).
	              catch(requestErrorInterceptor).
	              then($http);
	
	            promise = promise.then(function(resp) {
	              var data = resp.data;
	
	              if (data) {
	                // Need to convert action.isArray to boolean in case it is undefined
	                if (isArray(data) !== (!!action.isArray)) {
	                  throw $resourceMinErr('badcfg',
	                      'Error in resource configuration for action `{0}`. Expected response to ' +
	                      'contain an {1} but got an {2} (Request: {3} {4})', name, action.isArray ? 'array' : 'object',
	                    isArray(data) ? 'array' : 'object', httpConfig.method, httpConfig.url);
	                }
	                if (action.isArray) {
	                  value.length = 0;
	                  forEach(data, function(item) {
	                    if (typeof item === 'object') {
	                      value.push(new Resource(item));
	                    } else {
	                      // Valid JSON values may be string literals, and these should not be converted
	                      // into objects. These items will not have access to the Resource prototype
	                      // methods, but unfortunately there
	                      value.push(item);
	                    }
	                  });
	                } else {
	                  var promise = value.$promise;     // Save the promise
	                  shallowClearAndCopy(data, value);
	                  value.$promise = promise;         // Restore the promise
	                }
	              }
	
	              resp.resource = value;
	              response = resp;
	              return responseInterceptor(resp);
	            }, function(rejectionOrResponse) {
	              rejectionOrResponse.resource = value;
	              response = rejectionOrResponse;
	              return responseErrorInterceptor(rejectionOrResponse);
	            });
	
	            promise = promise['finally'](function() {
	              value.$resolved = true;
	              if (!isInstanceCall && cancellable) {
	                value.$cancelRequest = noop;
	                $timeout.cancel(numericTimeoutPromise);
	                timeoutDeferred = numericTimeoutPromise = httpConfig.timeout = null;
	              }
	            });
	
	            // Run the `success`/`error` callbacks, but do not let them affect the returned promise.
	            promise.then(successCallback, errorCallback);
	
	            if (!isInstanceCall) {
	              // we are creating instance / collection
	              // - set the initial promise
	              // - return the instance / collection
	              value.$promise = promise;
	              value.$resolved = false;
	              if (cancellable) value.$cancelRequest = cancelRequest;
	
	              return value;
	            }
	
	            // instance call
	            return promise;
	
	            function cancelRequest(value) {
	              promise.catch(noop);
	              if (timeoutDeferred !== null) {
	                timeoutDeferred.resolve(value);
	              }
	            }
	          };
	
	
	          Resource.prototype['$' + name] = function(params, success, error) {
	            if (isFunction(params)) {
	              error = success; success = params; params = {};
	            }
	            var result = Resource[name].call(this, params, this, success, error);
	            return result.$promise || result;
	          };
	        });
	
	        return Resource;
	      }
	
	      return resourceFactory;
	    }];
	  });
	
	
	})(window, window.angular);


/***/ },

/***/ 139:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(138);
	module.exports = 'ngResource';


/***/ },

/***/ 140:
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.8.3
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	var bind;
	var extend;
	var forEach;
	var isArray;
	var isDefined;
	var lowercase;
	var noop;
	var nodeContains;
	var htmlParser;
	var htmlSanitizeWriter;
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a trusted URI list) are
	 *   then serialized back to a properly escaped HTML string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The trusted URIs for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationTrustedUrlList` and `imgSrcSanitizationTrustedUrlList` of {@link $compileProvider}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 * @this
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var hasBeenInstantiated = false;
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    hasBeenInstantiated = true;
	    if (svgEnabled) {
	      extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
	   * @returns {boolean|$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#addValidElements
	   * @kind function
	   *
	   * @description
	   * Extends the built-in lists of valid HTML/SVG elements, i.e. elements that are considered safe
	   * and are not stripped off during sanitization. You can extend the following lists of elements:
	   *
	   * - `htmlElements`: A list of elements (tag names) to extend the current list of safe HTML
	   *   elements. HTML elements considered safe will not be removed during sanitization. All other
	   *   elements will be stripped off.
	   *
	   * - `htmlVoidElements`: This is similar to `htmlElements`, but marks the elements as
	   *   "void elements" (similar to HTML
	   *   [void elements](https://rawgit.com/w3c/html/html5.1-2/single-page.html#void-elements)). These
	   *   elements have no end tag and cannot have content.
	   *
	   * - `svgElements`: This is similar to `htmlElements`, but for SVG elements. This list is only
	   *   taken into account if SVG is {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for
	   *   `$sanitize`.
	   *
	   * <div class="alert alert-info">
	   *   This method must be called during the {@link angular.Module#config config} phase. Once the
	   *   `$sanitize` service has been instantiated, this method has no effect.
	   * </div>
	   *
	   * <div class="alert alert-warning">
	   *   Keep in mind that extending the built-in lists of elements may expose your app to XSS or
	   *   other vulnerabilities. Be very mindful of the elements you add.
	   * </div>
	   *
	   * @param {Array<String>|Object} elements - A list of valid HTML elements or an object with one or
	   *   more of the following properties:
	   *   - **htmlElements** - `{Array<String>}` - A list of elements to extend the current list of
	   *     HTML elements.
	   *   - **htmlVoidElements** - `{Array<String>}` - A list of elements to extend the current list of
	   *     void HTML elements; i.e. elements that do not have an end tag.
	   *   - **svgElements** - `{Array<String>}` - A list of elements to extend the current list of SVG
	   *     elements. The list of SVG elements is only taken into account if SVG is
	   *     {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for `$sanitize`.
	   *
	   * Passing an array (`[...]`) is equivalent to passing `{htmlElements: [...]}`.
	   *
	   * @return {$sanitizeProvider} Returns self for chaining.
	   */
	  this.addValidElements = function(elements) {
	    if (!hasBeenInstantiated) {
	      if (isArray(elements)) {
	        elements = {htmlElements: elements};
	      }
	
	      addElementsTo(svgElements, elements.svgElements);
	      addElementsTo(voidElements, elements.htmlVoidElements);
	      addElementsTo(validElements, elements.htmlVoidElements);
	      addElementsTo(validElements, elements.htmlElements);
	    }
	
	    return this;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#addValidAttrs
	   * @kind function
	   *
	   * @description
	   * Extends the built-in list of valid attributes, i.e. attributes that are considered safe and are
	   * not stripped off during sanitization.
	   *
	   * **Note**:
	   * The new attributes will not be treated as URI attributes, which means their values will not be
	   * sanitized as URIs using `$compileProvider`'s
	   * {@link ng.$compileProvider#aHrefSanitizationTrustedUrlList aHrefSanitizationTrustedUrlList} and
	   * {@link ng.$compileProvider#imgSrcSanitizationTrustedUrlList imgSrcSanitizationTrustedUrlList}.
	   *
	   * <div class="alert alert-info">
	   *   This method must be called during the {@link angular.Module#config config} phase. Once the
	   *   `$sanitize` service has been instantiated, this method has no effect.
	   * </div>
	   *
	   * <div class="alert alert-warning">
	   *   Keep in mind that extending the built-in list of attributes may expose your app to XSS or
	   *   other vulnerabilities. Be very mindful of the attributes you add.
	   * </div>
	   *
	   * @param {Array<String>} attrs - A list of valid attributes.
	   *
	   * @returns {$sanitizeProvider} Returns self for chaining.
	   */
	  this.addValidAttrs = function(attrs) {
	    if (!hasBeenInstantiated) {
	      extend(validAttrs, arrayToMap(attrs, true));
	    }
	    return this;
	  };
	
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	  // Private stuff
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	
	  bind = angular.bind;
	  extend = angular.extend;
	  forEach = angular.forEach;
	  isArray = angular.isArray;
	  isDefined = angular.isDefined;
	  lowercase = angular.$$lowercase;
	  noop = angular.noop;
	
	  htmlParser = htmlParserImpl;
	  htmlSanitizeWriter = htmlSanitizeWriterImpl;
	
	  nodeContains = window.Node.prototype.contains || /** @this */ function(arg) {
	    // eslint-disable-next-line no-bitwise
	    return !!(this.compareDocumentPosition(arg) & 16);
	  };
	
	  // Regular Expressions for parsing tags and attributes
	  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	    // Match everything outside of normal chars and " (quote character)
	    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;
	
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = stringToMap('area,br,col,hr,img,wbr');
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = stringToMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
	      optionalEndTagInlineElements = stringToMap('rp,rt'),
	      optionalEndTagElements = extend({},
	                                              optionalEndTagInlineElements,
	                                              optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = extend({}, optionalEndTagBlockElements, stringToMap('address,article,' +
	          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
	          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));
	
	  // Inline Elements - HTML5
	  var inlineElements = extend({}, optionalEndTagInlineElements, stringToMap('a,abbr,acronym,b,' +
	          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
	          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	  // They can potentially allow for arbitrary javascript to be executed. See #11290
	  var svgElements = stringToMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
	          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
	          'radialGradient,rect,stop,svg,switch,text,title,tspan');
	
	  // Blocked Elements (will be stripped)
	  var blockedElements = stringToMap('script,style');
	
	  var validElements = extend({},
	                                     voidElements,
	                                     blockElements,
	                                     inlineElements,
	                                     optionalEndTagElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = stringToMap('background,cite,href,longdesc,src,xlink:href,xml:base');
	
	  var htmlAttrs = stringToMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	      'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = stringToMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	  var validAttrs = extend({},
	                                  uriAttrs,
	                                  svgAttrs,
	                                  htmlAttrs);
	
	  function stringToMap(str, lowercaseKeys) {
	    return arrayToMap(str.split(','), lowercaseKeys);
	  }
	
	  function arrayToMap(items, lowercaseKeys) {
	    var obj = {}, i;
	    for (i = 0; i < items.length; i++) {
	      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
	    }
	    return obj;
	  }
	
	  function addElementsTo(elementsMap, newElements) {
	    if (newElements && newElements.length) {
	      extend(elementsMap, arrayToMap(newElements));
	    }
	  }
	
	  /**
	   * Create an inert document that contains the dirty HTML that needs sanitizing.
	   * We use the DOMParser API by default and fall back to createHTMLDocument if DOMParser is not
	   * available.
	   */
	  var getInertBodyElement /* function(html: string): HTMLBodyElement */ = (function(window, document) {
	    if (isDOMParserAvailable()) {
	      return getInertBodyElement_DOMParser;
	    }
	
	    if (!document || !document.implementation) {
	      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
	    }
	    var inertDocument = document.implementation.createHTMLDocument('inert');
	    var inertBodyElement = (inertDocument.documentElement || inertDocument.getDocumentElement()).querySelector('body');
	    return getInertBodyElement_InertDocument;
	
	    function isDOMParserAvailable() {
	      try {
	        return !!getInertBodyElement_DOMParser('');
	      } catch (e) {
	        return false;
	      }
	    }
	
	    function getInertBodyElement_DOMParser(html) {
	      // We add this dummy element to ensure that the rest of the content is parsed as expected
	      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
	      html = '<remove></remove>' + html;
	      try {
	        var body = new window.DOMParser().parseFromString(html, 'text/html').body;
	        body.firstChild.remove();
	        return body;
	      } catch (e) {
	        return undefined;
	      }
	    }
	
	    function getInertBodyElement_InertDocument(html) {
	      inertBodyElement.innerHTML = html;
	
	      // Support: IE 9-11 only
	      // strip custom-namespaced attributes on IE<=11
	      if (document.documentMode) {
	        stripCustomNsAttrs(inertBodyElement);
	      }
	
	      return inertBodyElement;
	    }
	  })(window, window.document);
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParserImpl(html, handler) {
	    if (html === null || html === undefined) {
	      html = '';
	    } else if (typeof html !== 'string') {
	      html = '' + html;
	    }
	
	    var inertBodyElement = getInertBodyElement(html);
	    if (!inertBodyElement) return '';
	
	    //mXSS protection
	    var mXSSAttempts = 5;
	    do {
	      if (mXSSAttempts === 0) {
	        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
	      }
	      mXSSAttempts--;
	
	      // trigger mXSS if it is going to happen by reading and writing the innerHTML
	      html = inertBodyElement.innerHTML;
	      inertBodyElement = getInertBodyElement(html);
	    } while (html !== inertBodyElement.innerHTML);
	
	    var node = inertBodyElement.firstChild;
	    while (node) {
	      switch (node.nodeType) {
	        case 1: // ELEMENT_NODE
	          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	          break;
	        case 3: // TEXT NODE
	          handler.chars(node.textContent);
	          break;
	      }
	
	      var nextNode;
	      if (!(nextNode = node.firstChild)) {
	        if (node.nodeType === 1) {
	          handler.end(node.nodeName.toLowerCase());
	        }
	        nextNode = getNonDescendant('nextSibling', node);
	        if (!nextNode) {
	          while (nextNode == null) {
	            node = getNonDescendant('parentNode', node);
	            if (node === inertBodyElement) break;
	            nextNode = getNonDescendant('nextSibling', node);
	            if (node.nodeType === 1) {
	              handler.end(node.nodeName.toLowerCase());
	            }
	          }
	        }
	      }
	      node = nextNode;
	    }
	
	    while ((node = inertBodyElement.firstChild)) {
	      inertBodyElement.removeChild(node);
	    }
	  }
	
	  function attrToMap(attrs) {
	    var map = {};
	    for (var i = 0, ii = attrs.length; i < ii; i++) {
	      var attr = attrs[i];
	      map[attr.name] = attr.value;
	    }
	    return map;
	  }
	
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.
	      replace(/&/g, '&amp;').
	      replace(SURROGATE_PAIR_REGEXP, function(value) {
	        var hi = value.charCodeAt(0);
	        var low = value.charCodeAt(1);
	        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	      }).
	      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	        return '&#' + value.charCodeAt(0) + ';';
	      }).
	      replace(/</g, '&lt;').
	      replace(/>/g, '&gt;');
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.join('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriterImpl(buf, uriValidator) {
	    var ignoreCurrentElement = false;
	    var out = bind(buf, buf.push);
	    return {
	      start: function(tag, attrs) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && blockedElements[tag]) {
	          ignoreCurrentElement = tag;
	        }
	        if (!ignoreCurrentElement && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          forEach(attrs, function(value, key) {
	            var lkey = lowercase(key);
	            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	            if (validAttrs[lkey] === true &&
	              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out('>');
	        }
	      },
	      end: function(tag) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        // eslint-disable-next-line eqeqeq
	        if (tag == ignoreCurrentElement) {
	          ignoreCurrentElement = false;
	        }
	      },
	      chars: function(chars) {
	        if (!ignoreCurrentElement) {
	          out(encodeEntities(chars));
	        }
	      }
	    };
	  }
	
	
	  /**
	   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	   * to allow any of these custom attributes. This method strips them all.
	   *
	   * @param node Root element to process
	   */
	  function stripCustomNsAttrs(node) {
	    while (node) {
	      if (node.nodeType === window.Node.ELEMENT_NODE) {
	        var attrs = node.attributes;
	        for (var i = 0, l = attrs.length; i < l; i++) {
	          var attrNode = attrs[i];
	          var attrName = attrNode.name.toLowerCase();
	          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
	            node.removeAttributeNode(attrNode);
	            i--;
	            l--;
	          }
	        }
	      }
	
	      var nextNode = node.firstChild;
	      if (nextNode) {
	        stripCustomNsAttrs(nextNode);
	      }
	
	      node = getNonDescendant('nextSibling', node);
	    }
	  }
	
	  function getNonDescendant(propName, node) {
	    // An element is clobbered if its `propName` property points to one of its descendants
	    var nextNode = node[propName];
	    if (nextNode && nodeContains.call(node, nextNode)) {
	      throw $sanitizeMinErr('elclob', 'Failed to sanitize html because the element is clobbered: {0}', node.outerHTML || node.outerText);
	    }
	    return nextNode;
	  }
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', [])
	  .provider('$sanitize', $SanitizeProvider)
	  .info({ angularVersion: '1.8.3' });
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/sftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} [target] Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n' +
	             'http://angularjs.org/,\n' +
	             'mailto:us@somewhere.org,\n' +
	             'another@somewhere.org,\n' +
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isDefined = angular.isDefined;
	  var isFunction = angular.isFunction;
	  var isObject = angular.isObject;
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var attributesFn =
	      isFunction(attributes) ? attributes :
	      isObject(attributes) ? function getAttributesObject() {return attributes;} :
	      function getEmptyAttributesObject() {return {};};
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key, linkAttributes = attributesFn(url);
	      html.push('<a ');
	
	      for (key in linkAttributes) {
	        html.push(key + '="' + linkAttributes[key] + '" ');
	      }
	
	      if (isDefined(target) && !('target' in linkAttributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ },

/***/ 141:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(140);
	module.exports = 'ngSanitize';


/***/ },

/***/ 142:
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  angular-simple-logger
	 *
	 * @version: 0.1.7
	 * @author: Nicholas McCready
	 * @date: Tue Jan 26 2016 10:15:01 GMT-0500 (EST)
	 * @license: MIT
	 */
	var angular = __webpack_require__(1);
	
	angular.module('nemLogging', []);
	
	angular.module('nemLogging').provider('nemDebug', function (){
	  var ourDebug = null;
	  ourDebug = __webpack_require__(570);
	
	  this.$get =  function(){
	    //avail as service
	    return ourDebug;
	  };
	
	  //avail at provider, config time
	  this.debug = ourDebug;
	
	  return this;
	});
	var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  slice = [].slice;
	
	angular.module('nemLogging').provider('nemSimpleLogger', [
	  'nemDebugProvider', function(nemDebugProvider) {
	    var LEVELS, Logger, _debugCache, _fns, _isValidLogObject, _maybeExecLevel, _wrapDebug, i, key, len, nemDebug, val;
	    nemDebug = nemDebugProvider.debug;
	    _debugCache = {};
	    _fns = ['debug', 'info', 'warn', 'error', 'log'];
	    LEVELS = {};
	    for (key = i = 0, len = _fns.length; i < len; key = ++i) {
	      val = _fns[key];
	      LEVELS[val] = key;
	    }
	    _maybeExecLevel = function(level, current, fn) {
	      if (level >= current) {
	        return fn();
	      }
	    };
	    _isValidLogObject = function(logObject) {
	      var isValid, j, len1;
	      isValid = false;
	      if (!logObject) {
	        return isValid;
	      }
	      for (j = 0, len1 = _fns.length; j < len1; j++) {
	        val = _fns[j];
	        isValid = (logObject[val] != null) && typeof logObject[val] === 'function';
	        if (!isValid) {
	          break;
	        }
	      }
	      return isValid;
	    };
	
	    /*
	      Overide logeObject.debug with a nemDebug instance
	      see: https://github.com/visionmedia/debug/blob/master/Readme.md
	     */
	    _wrapDebug = function(namespace, logObject) {
	      var debugInstance, j, len1, newLogger;
	      if (_debugCache[namespace] == null) {
	        _debugCache[namespace] = nemDebug(namespace);
	      }
	      debugInstance = _debugCache[namespace];
	      newLogger = {};
	      for (j = 0, len1 = _fns.length; j < len1; j++) {
	        val = _fns[j];
	        newLogger[val] = val === 'debug' ? debugInstance : logObject[val];
	      }
	      return newLogger;
	    };
	    Logger = (function() {
	      function Logger($log1) {
	        var fn1, j, len1, level, logFns;
	        this.$log = $log1;
	        this.spawn = bind(this.spawn, this);
	        if (!this.$log) {
	          throw 'internalLogger undefined';
	        }
	        if (!_isValidLogObject(this.$log)) {
	          throw '@$log is invalid';
	        }
	        this.doLog = true;
	        logFns = {};
	        fn1 = (function(_this) {
	          return function(level) {
	            logFns[level] = function() {
	              var args;
	              args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	              if (_this.doLog) {
	                return _maybeExecLevel(LEVELS[level], _this.currentLevel, function() {
	                  var ref;
	                  return (ref = _this.$log)[level].apply(ref, args);
	                });
	              }
	            };
	            return _this[level] = logFns[level];
	          };
	        })(this);
	        for (j = 0, len1 = _fns.length; j < len1; j++) {
	          level = _fns[j];
	          fn1(level);
	        }
	        this.LEVELS = LEVELS;
	        this.currentLevel = LEVELS.error;
	      }
	
	      Logger.prototype.spawn = function(newInternalLogger) {
	        if (typeof newInternalLogger === 'string') {
	          if (!_isValidLogObject(this.$log)) {
	            throw '@$log is invalid';
	          }
	          if (!nemDebug) {
	            throw 'nemDebug is undefined this is probably the light version of this library sep debug logggers is not supported!';
	          }
	          return _wrapDebug(newInternalLogger, this.$log);
	        }
	        return new Logger(newInternalLogger || this.$log);
	      };
	
	      return Logger;
	
	    })();
	    this.decorator = [
	      '$log', function($delegate) {
	        var log;
	        log = new Logger($delegate);
	        log.currentLevel = LEVELS.debug;
	        return log;
	      }
	    ];
	    this.$get = [
	      '$log', function($log) {
	        return new Logger($log);
	      }
	    ];
	    return this;
	  }
	]);


/***/ },

/***/ 143:
/***/ function(module, exports) {

	/*
	 * angular-ui-bootstrap
	 * http://angular-ui.github.io/bootstrap/
	
	 * Version: 2.5.6 - 2017-10-14
	 * License: MIT
	 */angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse","ui.bootstrap.tabindex","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.datepicker","ui.bootstrap.position","ui.bootstrap.datepickerPopup","ui.bootstrap.debounce","ui.bootstrap.multiMap","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.paging","ui.bootstrap.pager","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
	angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html","uib/template/accordion/accordion.html","uib/template/alert/alert.html","uib/template/carousel/carousel.html","uib/template/carousel/slide.html","uib/template/datepicker/datepicker.html","uib/template/datepicker/day.html","uib/template/datepicker/month.html","uib/template/datepicker/year.html","uib/template/datepickerPopup/popup.html","uib/template/modal/window.html","uib/template/pager/pager.html","uib/template/pagination/pagination.html","uib/template/tooltip/tooltip-html-popup.html","uib/template/tooltip/tooltip-popup.html","uib/template/tooltip/tooltip-template-popup.html","uib/template/popover/popover-html.html","uib/template/popover/popover-template.html","uib/template/popover/popover.html","uib/template/progressbar/bar.html","uib/template/progressbar/progress.html","uib/template/progressbar/progressbar.html","uib/template/rating/rating.html","uib/template/tabs/tab.html","uib/template/tabs/tabset.html","uib/template/timepicker/timepicker.html","uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html"]);
	angular.module('ui.bootstrap.collapse', [])
	
	  .directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function($animate, $q, $parse, $injector) {
	    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
	    return {
	      link: function(scope, element, attrs) {
	        var expandingExpr = $parse(attrs.expanding),
	          expandedExpr = $parse(attrs.expanded),
	          collapsingExpr = $parse(attrs.collapsing),
	          collapsedExpr = $parse(attrs.collapsed),
	          horizontal = false,
	          css = {},
	          cssTo = {};
	
	        init();
	
	        function init() {
	          horizontal = !!('horizontal' in attrs);
	          if (horizontal) {
	            css = {
	              width: ''
	            };
	            cssTo = {width: '0'};
	          } else {
	            css = {
	              height: ''
	            };
	            cssTo = {height: '0'};
	          }
	          if (!scope.$eval(attrs.uibCollapse)) {
	            element.addClass('in')
	              .addClass('collapse')
	              .attr('aria-expanded', true)
	              .attr('aria-hidden', false)
	              .css(css);
	          }
	        }
	
	        function getScrollFromElement(element) {
	          if (horizontal) {
	            return {width: element.scrollWidth + 'px'};
	          }
	          return {height: element.scrollHeight + 'px'};
	        }
	
	        function expand() {
	          if (element.hasClass('collapse') && element.hasClass('in')) {
	            return;
	          }
	
	          $q.resolve(expandingExpr(scope))
	            .then(function() {
	              element.removeClass('collapse')
	                .addClass('collapsing')
	                .attr('aria-expanded', true)
	                .attr('aria-hidden', false);
	
	              if ($animateCss) {
	                $animateCss(element, {
	                  addClass: 'in',
	                  easing: 'ease',
	                  css: {
	                    overflow: 'hidden'
	                  },
	                  to: getScrollFromElement(element[0])
	                }).start()['finally'](expandDone);
	              } else {
	                $animate.addClass(element, 'in', {
	                  css: {
	                    overflow: 'hidden'
	                  },
	                  to: getScrollFromElement(element[0])
	                }).then(expandDone);
	              }
	            }, angular.noop);
	        }
	
	        function expandDone() {
	          element.removeClass('collapsing')
	            .addClass('collapse')
	            .css(css);
	          expandedExpr(scope);
	        }
	
	        function collapse() {
	          if (!element.hasClass('collapse') && !element.hasClass('in')) {
	            return collapseDone();
	          }
	
	          $q.resolve(collapsingExpr(scope))
	            .then(function() {
	              element
	              // IMPORTANT: The width must be set before adding "collapsing" class.
	              // Otherwise, the browser attempts to animate from width 0 (in
	              // collapsing class) to the given width here.
	                .css(getScrollFromElement(element[0]))
	                // initially all panel collapse have the collapse class, this removal
	                // prevents the animation from jumping to collapsed state
	                .removeClass('collapse')
	                .addClass('collapsing')
	                .attr('aria-expanded', false)
	                .attr('aria-hidden', true);
	
	              if ($animateCss) {
	                $animateCss(element, {
	                  removeClass: 'in',
	                  to: cssTo
	                }).start()['finally'](collapseDone);
	              } else {
	                $animate.removeClass(element, 'in', {
	                  to: cssTo
	                }).then(collapseDone);
	              }
	            }, angular.noop);
	        }
	
	        function collapseDone() {
	          element.css(cssTo); // Required so that collapse works when animation is disabled
	          element.removeClass('collapsing')
	            .addClass('collapse');
	          collapsedExpr(scope);
	        }
	
	        scope.$watch(attrs.uibCollapse, function(shouldCollapse) {
	          if (shouldCollapse) {
	            collapse();
	          } else {
	            expand();
	          }
	        });
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.tabindex', [])
	
	.directive('uibTabindexToggle', function() {
	  return {
	    restrict: 'A',
	    link: function(scope, elem, attrs) {
	      attrs.$observe('disabled', function(disabled) {
	        attrs.$set('tabindex', disabled ? -1 : null);
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex'])
	
	.constant('uibAccordionConfig', {
	  closeOthers: true
	})
	
	.controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function($scope, $attrs, accordionConfig) {
	  // This array keeps track of the accordion groups
	  this.groups = [];
	
	  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	  this.closeOthers = function(openGroup) {
	    var closeOthers = angular.isDefined($attrs.closeOthers) ?
	      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
	    if (closeOthers) {
	      angular.forEach(this.groups, function(group) {
	        if (group !== openGroup) {
	          group.isOpen = false;
	        }
	      });
	    }
	  };
	
	  // This is called from the accordion-group directive to add itself to the accordion
	  this.addGroup = function(groupScope) {
	    var that = this;
	    this.groups.push(groupScope);
	
	    groupScope.$on('$destroy', function(event) {
	      that.removeGroup(groupScope);
	    });
	  };
	
	  // This is called from the accordion-group directive when to remove itself
	  this.removeGroup = function(group) {
	    var index = this.groups.indexOf(group);
	    if (index !== -1) {
	      this.groups.splice(index, 1);
	    }
	  };
	}])
	
	// The accordion directive simply sets up the directive controller
	// and adds an accordion CSS class to itself element.
	.directive('uibAccordion', function() {
	  return {
	    controller: 'UibAccordionController',
	    controllerAs: 'accordion',
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
	    }
	  };
	})
	
	// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
	.directive('uibAccordionGroup', function() {
	  return {
	    require: '^uibAccordion',         // We need this directive to be inside an accordion
	    transclude: true,              // It transcludes the contents of the directive into the template
	    restrict: 'A',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
	    },
	    scope: {
	      heading: '@',               // Interpolate the heading attribute onto this scope
	      panelClass: '@?',           // Ditto with panelClass
	      isOpen: '=?',
	      isDisabled: '=?'
	    },
	    controller: function() {
	      this.setHeading = function(element) {
	        this.heading = element;
	      };
	    },
	    link: function(scope, element, attrs, accordionCtrl) {
	      element.addClass('panel');
	      accordionCtrl.addGroup(scope);
	
	      scope.openClass = attrs.openClass || 'panel-open';
	      scope.panelClass = attrs.panelClass || 'panel-default';
	      scope.$watch('isOpen', function(value) {
	        element.toggleClass(scope.openClass, !!value);
	        if (value) {
	          accordionCtrl.closeOthers(scope);
	        }
	      });
	
	      scope.toggleOpen = function($event) {
	        if (!scope.isDisabled) {
	          if (!$event || $event.which === 32) {
	            scope.isOpen = !scope.isOpen;
	          }
	        }
	      };
	
	      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	      scope.headingId = id + '-tab';
	      scope.panelId = id + '-panel';
	    }
	  };
	})
	
	// Use accordion-heading below an accordion-group to provide a heading containing HTML
	.directive('uibAccordionHeading', function() {
	  return {
	    transclude: true,   // Grab the contents to be used as the heading
	    template: '',       // In effect remove this element!
	    replace: true,
	    require: '^uibAccordionGroup',
	    link: function(scope, element, attrs, accordionGroupCtrl, transclude) {
	      // Pass the heading to the accordion-group controller
	      // so that it can be transcluded into the right place in the template
	      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
	    }
	  };
	})
	
	// Use in the accordion-group template to indicate where you want the heading to be transcluded
	// You must provide the property on the accordion-group controller that will hold the transcluded element
	.directive('uibAccordionTransclude', function() {
	  return {
	    require: '^uibAccordionGroup',
	    link: function(scope, element, attrs, controller) {
	      scope.$watch(function() { return controller[attrs.uibAccordionTransclude]; }, function(heading) {
	        if (heading) {
	          var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
	          elem.html('');
	          elem.append(heading);
	        }
	      });
	    }
	  };
	
	  function getHeaderSelectors() {
	      return 'uib-accordion-header,' +
	          'data-uib-accordion-header,' +
	          'x-uib-accordion-header,' +
	          'uib\\:accordion-header,' +
	          '[uib-accordion-header],' +
	          '[data-uib-accordion-header],' +
	          '[x-uib-accordion-header]';
	  }
	});
	
	angular.module('ui.bootstrap.alert', [])
	
	.controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function($scope, $element, $attrs, $interpolate, $timeout) {
	  $scope.closeable = !!$attrs.close;
	  $element.addClass('alert');
	  $attrs.$set('role', 'alert');
	  if ($scope.closeable) {
	    $element.addClass('alert-dismissible');
	  }
	
	  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
	    $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;
	
	  if (dismissOnTimeout) {
	    $timeout(function() {
	      $scope.close();
	    }, parseInt(dismissOnTimeout, 10));
	  }
	}])
	
	.directive('uibAlert', function() {
	  return {
	    controller: 'UibAlertController',
	    controllerAs: 'alert',
	    restrict: 'A',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/alert/alert.html';
	    },
	    transclude: true,
	    scope: {
	      close: '&'
	    }
	  };
	});
	
	angular.module('ui.bootstrap.buttons', [])
	
	.constant('uibButtonConfig', {
	  activeClass: 'active',
	  toggleEvent: 'click'
	})
	
	.controller('UibButtonsController', ['uibButtonConfig', function(buttonConfig) {
	  this.activeClass = buttonConfig.activeClass || 'active';
	  this.toggleEvent = buttonConfig.toggleEvent || 'click';
	}])
	
	.directive('uibBtnRadio', ['$parse', function($parse) {
	  return {
	    require: ['uibBtnRadio', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'buttons',
	    link: function(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	      var uncheckableExpr = $parse(attrs.uibUncheckable);
	
	      element.find('input').css({display: 'none'});
	
	      //model -> UI
	      ngModelCtrl.$render = function() {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function() {
	        if (attrs.disabled) {
	          return;
	        }
	
	        var isActive = element.hasClass(buttonsCtrl.activeClass);
	
	        if (!isActive || angular.isDefined(attrs.uncheckable)) {
	          scope.$apply(function() {
	            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
	            ngModelCtrl.$render();
	          });
	        }
	      });
	
	      if (attrs.uibUncheckable) {
	        scope.$watch(uncheckableExpr, function(uncheckable) {
	          attrs.$set('uncheckable', uncheckable ? '' : undefined);
	        });
	      }
	    }
	  };
	}])
	
	.directive('uibBtnCheckbox', function() {
	  return {
	    require: ['uibBtnCheckbox', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'button',
	    link: function(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      element.find('input').css({display: 'none'});
	
	      function getTrueValue() {
	        return getCheckboxValue(attrs.btnCheckboxTrue, true);
	      }
	
	      function getFalseValue() {
	        return getCheckboxValue(attrs.btnCheckboxFalse, false);
	      }
	
	      function getCheckboxValue(attribute, defaultValue) {
	        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
	      }
	
	      //model -> UI
	      ngModelCtrl.$render = function() {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function() {
	        if (attrs.disabled) {
	          return;
	        }
	
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	          ngModelCtrl.$render();
	        });
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.carousel', [])
	
	.controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function($scope, $element, $interval, $timeout, $animate) {
	  var self = this,
	    slides = self.slides = $scope.slides = [],
	    SLIDE_DIRECTION = 'uib-slideDirection',
	    currentIndex = $scope.active,
	    currentInterval, isPlaying;
	
	  var destroyed = false;
	  $element.addClass('carousel');
	
	  self.addSlide = function(slide, element) {
	    slides.push({
	      slide: slide,
	      element: element
	    });
	    slides.sort(function(a, b) {
	      return +a.slide.index - +b.slide.index;
	    });
	    //if this is the first slide or the slide is set to active, select it
	    if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
	      if ($scope.$currentTransition) {
	        $scope.$currentTransition = null;
	      }
	
	      currentIndex = slide.index;
	      $scope.active = slide.index;
	      setActive(currentIndex);
	      self.select(slides[findSlideIndex(slide)]);
	      if (slides.length === 1) {
	        $scope.play();
	      }
	    }
	  };
	
	  self.getCurrentIndex = function() {
	    for (var i = 0; i < slides.length; i++) {
	      if (slides[i].slide.index === currentIndex) {
	        return i;
	      }
	    }
	  };
	
	  self.next = $scope.next = function() {
	    var newIndex = (self.getCurrentIndex() + 1) % slides.length;
	
	    if (newIndex === 0 && $scope.noWrap()) {
	      $scope.pause();
	      return;
	    }
	
	    return self.select(slides[newIndex], 'next');
	  };
	
	  self.prev = $scope.prev = function() {
	    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;
	
	    if ($scope.noWrap() && newIndex === slides.length - 1) {
	      $scope.pause();
	      return;
	    }
	
	    return self.select(slides[newIndex], 'prev');
	  };
	
	  self.removeSlide = function(slide) {
	    var index = findSlideIndex(slide);
	
	    //get the index of the slide inside the carousel
	    slides.splice(index, 1);
	    if (slides.length > 0 && currentIndex === index) {
	      if (index >= slides.length) {
	        currentIndex = slides.length - 1;
	        $scope.active = currentIndex;
	        setActive(currentIndex);
	        self.select(slides[slides.length - 1]);
	      } else {
	        currentIndex = index;
	        $scope.active = currentIndex;
	        setActive(currentIndex);
	        self.select(slides[index]);
	      }
	    } else if (currentIndex > index) {
	      currentIndex--;
	      $scope.active = currentIndex;
	    }
	
	    //clean the active value when no more slide
	    if (slides.length === 0) {
	      currentIndex = null;
	      $scope.active = null;
	    }
	  };
	
	  /* direction: "prev" or "next" */
	  self.select = $scope.select = function(nextSlide, direction) {
	    var nextIndex = findSlideIndex(nextSlide.slide);
	    //Decide direction if it's not given
	    if (direction === undefined) {
	      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
	    }
	    //Prevent this user-triggered transition from occurring if there is already one in progress
	    if (nextSlide.slide.index !== currentIndex &&
	      !$scope.$currentTransition) {
	      goNext(nextSlide.slide, nextIndex, direction);
	    }
	  };
	
	  /* Allow outside people to call indexOf on slides array */
	  $scope.indexOfSlide = function(slide) {
	    return +slide.slide.index;
	  };
	
	  $scope.isActive = function(slide) {
	    return $scope.active === slide.slide.index;
	  };
	
	  $scope.isPrevDisabled = function() {
	    return $scope.active === 0 && $scope.noWrap();
	  };
	
	  $scope.isNextDisabled = function() {
	    return $scope.active === slides.length - 1 && $scope.noWrap();
	  };
	
	  $scope.pause = function() {
	    if (!$scope.noPause) {
	      isPlaying = false;
	      resetTimer();
	    }
	  };
	
	  $scope.play = function() {
	    if (!isPlaying) {
	      isPlaying = true;
	      restartTimer();
	    }
	  };
	
	  $element.on('mouseenter', $scope.pause);
	  $element.on('mouseleave', $scope.play);
	
	  $scope.$on('$destroy', function() {
	    destroyed = true;
	    resetTimer();
	  });
	
	  $scope.$watch('noTransition', function(noTransition) {
	    $animate.enabled($element, !noTransition);
	  });
	
	  $scope.$watch('interval', restartTimer);
	
	  $scope.$watchCollection('slides', resetTransition);
	
	  $scope.$watch('active', function(index) {
	    if (angular.isNumber(index) && currentIndex !== index) {
	      for (var i = 0; i < slides.length; i++) {
	        if (slides[i].slide.index === index) {
	          index = i;
	          break;
	        }
	      }
	
	      var slide = slides[index];
	      if (slide) {
	        setActive(index);
	        self.select(slides[index]);
	        currentIndex = index;
	      }
	    }
	  });
	
	  function getSlideByIndex(index) {
	    for (var i = 0, l = slides.length; i < l; ++i) {
	      if (slides[i].index === index) {
	        return slides[i];
	      }
	    }
	  }
	
	  function setActive(index) {
	    for (var i = 0; i < slides.length; i++) {
	      slides[i].slide.active = i === index;
	    }
	  }
	
	  function goNext(slide, index, direction) {
	    if (destroyed) {
	      return;
	    }
	
	    angular.extend(slide, {direction: direction});
	    angular.extend(slides[currentIndex].slide || {}, {direction: direction});
	    if ($animate.enabled($element) && !$scope.$currentTransition &&
	      slides[index].element && self.slides.length > 1) {
	      slides[index].element.data(SLIDE_DIRECTION, slide.direction);
	      var currentIdx = self.getCurrentIndex();
	
	      if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
	        slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
	      }
	
	      $scope.$currentTransition = true;
	      $animate.on('addClass', slides[index].element, function(element, phase) {
	        if (phase === 'close') {
	          $scope.$currentTransition = null;
	          $animate.off('addClass', element);
	        }
	      });
	    }
	
	    $scope.active = slide.index;
	    currentIndex = slide.index;
	    setActive(index);
	
	    //every time you change slides, reset the timer
	    restartTimer();
	  }
	
	  function findSlideIndex(slide) {
	    for (var i = 0; i < slides.length; i++) {
	      if (slides[i].slide === slide) {
	        return i;
	      }
	    }
	  }
	
	  function resetTimer() {
	    if (currentInterval) {
	      $interval.cancel(currentInterval);
	      currentInterval = null;
	    }
	  }
	
	  function resetTransition(slides) {
	    if (!slides.length) {
	      $scope.$currentTransition = null;
	    }
	  }
	
	  function restartTimer() {
	    resetTimer();
	    var interval = +$scope.interval;
	    if (!isNaN(interval) && interval > 0) {
	      currentInterval = $interval(timerFn, interval);
	    }
	  }
	
	  function timerFn() {
	    var interval = +$scope.interval;
	    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
	      $scope.next();
	    } else {
	      $scope.pause();
	    }
	  }
	}])
	
	.directive('uibCarousel', function() {
	  return {
	    transclude: true,
	    controller: 'UibCarouselController',
	    controllerAs: 'carousel',
	    restrict: 'A',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/carousel/carousel.html';
	    },
	    scope: {
	      active: '=',
	      interval: '=',
	      noTransition: '=',
	      noPause: '=',
	      noWrap: '&'
	    }
	  };
	})
	
	.directive('uibSlide', ['$animate', function($animate) {
	  return {
	    require: '^uibCarousel',
	    restrict: 'A',
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/carousel/slide.html';
	    },
	    scope: {
	      actual: '=?',
	      index: '=?'
	    },
	    link: function (scope, element, attrs, carouselCtrl) {
	      element.addClass('item');
	      carouselCtrl.addSlide(scope, element);
	      //when the scope is destroyed then remove the slide from the current slides array
	      scope.$on('$destroy', function() {
	        carouselCtrl.removeSlide(scope);
	      });
	
	      scope.$watch('active', function(active) {
	        $animate[active ? 'addClass' : 'removeClass'](element, 'active');
	      });
	    }
	  };
	}])
	
	.animation('.item', ['$animateCss',
	function($animateCss) {
	  var SLIDE_DIRECTION = 'uib-slideDirection';
	
	  function removeClass(element, className, callback) {
	    element.removeClass(className);
	    if (callback) {
	      callback();
	    }
	  }
	
	  return {
	    beforeAddClass: function(element, className, done) {
	      if (className === 'active') {
	        var stopped = false;
	        var direction = element.data(SLIDE_DIRECTION);
	        var directionClass = direction === 'next' ? 'left' : 'right';
	        var removeClassFn = removeClass.bind(this, element,
	          directionClass + ' ' + direction, done);
	        element.addClass(direction);
	
	        $animateCss(element, {addClass: directionClass})
	          .start()
	          .done(removeClassFn);
	
	        return function() {
	          stopped = true;
	        };
	      }
	      done();
	    },
	    beforeRemoveClass: function (element, className, done) {
	      if (className === 'active') {
	        var stopped = false;
	        var direction = element.data(SLIDE_DIRECTION);
	        var directionClass = direction === 'next' ? 'left' : 'right';
	        var removeClassFn = removeClass.bind(this, element, directionClass, done);
	
	        $animateCss(element, {addClass: directionClass})
	          .start()
	          .done(removeClassFn);
	
	        return function() {
	          stopped = true;
	        };
	      }
	      done();
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.dateparser', [])
	
	.service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function($log, $locale, dateFilter, orderByFilter, filterFilter) {
	  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
	  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	  var localeId;
	  var formatCodeToRegex;
	
	  this.init = function() {
	    localeId = $locale.id;
	
	    this.parsers = {};
	    this.formatters = {};
	
	    formatCodeToRegex = [
	      {
	        key: 'yyyy',
	        regex: '\\d{4}',
	        apply: function(value) { this.year = +value; },
	        formatter: function(date) {
	          var _date = new Date();
	          _date.setFullYear(Math.abs(date.getFullYear()));
	          return dateFilter(_date, 'yyyy');
	        }
	      },
	      {
	        key: 'yy',
	        regex: '\\d{2}',
	        apply: function(value) { value = +value; this.year = value < 69 ? value + 2000 : value + 1900; },
	        formatter: function(date) {
	          var _date = new Date();
	          _date.setFullYear(Math.abs(date.getFullYear()));
	          return dateFilter(_date, 'yy');
	        }
	      },
	      {
	        key: 'y',
	        regex: '\\d{1,4}',
	        apply: function(value) { this.year = +value; },
	        formatter: function(date) {
	          var _date = new Date();
	          _date.setFullYear(Math.abs(date.getFullYear()));
	          return dateFilter(_date, 'y');
	        }
	      },
	      {
	        key: 'M!',
	        regex: '0?[1-9]|1[0-2]',
	        apply: function(value) { this.month = value - 1; },
	        formatter: function(date) {
	          var value = date.getMonth();
	          if (/^[0-9]$/.test(value)) {
	            return dateFilter(date, 'MM');
	          }
	
	          return dateFilter(date, 'M');
	        }
	      },
	      {
	        key: 'MMMM',
	        regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
	        apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); },
	        formatter: function(date) { return dateFilter(date, 'MMMM'); }
	      },
	      {
	        key: 'MMM',
	        regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	        apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); },
	        formatter: function(date) { return dateFilter(date, 'MMM'); }
	      },
	      {
	        key: 'MM',
	        regex: '0[1-9]|1[0-2]',
	        apply: function(value) { this.month = value - 1; },
	        formatter: function(date) { return dateFilter(date, 'MM'); }
	      },
	      {
	        key: 'M',
	        regex: '[1-9]|1[0-2]',
	        apply: function(value) { this.month = value - 1; },
	        formatter: function(date) { return dateFilter(date, 'M'); }
	      },
	      {
	        key: 'd!',
	        regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
	        apply: function(value) { this.date = +value; },
	        formatter: function(date) {
	          var value = date.getDate();
	          if (/^[1-9]$/.test(value)) {
	            return dateFilter(date, 'dd');
	          }
	
	          return dateFilter(date, 'd');
	        }
	      },
	      {
	        key: 'dd',
	        regex: '[0-2][0-9]{1}|3[0-1]{1}',
	        apply: function(value) { this.date = +value; },
	        formatter: function(date) { return dateFilter(date, 'dd'); }
	      },
	      {
	        key: 'd',
	        regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
	        apply: function(value) { this.date = +value; },
	        formatter: function(date) { return dateFilter(date, 'd'); }
	      },
	      {
	        key: 'EEEE',
	        regex: $locale.DATETIME_FORMATS.DAY.join('|'),
	        formatter: function(date) { return dateFilter(date, 'EEEE'); }
	      },
	      {
	        key: 'EEE',
	        regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
	        formatter: function(date) { return dateFilter(date, 'EEE'); }
	      },
	      {
	        key: 'HH',
	        regex: '(?:0|1)[0-9]|2[0-3]',
	        apply: function(value) { this.hours = +value; },
	        formatter: function(date) { return dateFilter(date, 'HH'); }
	      },
	      {
	        key: 'hh',
	        regex: '0[0-9]|1[0-2]',
	        apply: function(value) { this.hours = +value; },
	        formatter: function(date) { return dateFilter(date, 'hh'); }
	      },
	      {
	        key: 'H',
	        regex: '1?[0-9]|2[0-3]',
	        apply: function(value) { this.hours = +value; },
	        formatter: function(date) { return dateFilter(date, 'H'); }
	      },
	      {
	        key: 'h',
	        regex: '[0-9]|1[0-2]',
	        apply: function(value) { this.hours = +value; },
	        formatter: function(date) { return dateFilter(date, 'h'); }
	      },
	      {
	        key: 'mm',
	        regex: '[0-5][0-9]',
	        apply: function(value) { this.minutes = +value; },
	        formatter: function(date) { return dateFilter(date, 'mm'); }
	      },
	      {
	        key: 'm',
	        regex: '[0-9]|[1-5][0-9]',
	        apply: function(value) { this.minutes = +value; },
	        formatter: function(date) { return dateFilter(date, 'm'); }
	      },
	      {
	        key: 'sss',
	        regex: '[0-9][0-9][0-9]',
	        apply: function(value) { this.milliseconds = +value; },
	        formatter: function(date) { return dateFilter(date, 'sss'); }
	      },
	      {
	        key: 'ss',
	        regex: '[0-5][0-9]',
	        apply: function(value) { this.seconds = +value; },
	        formatter: function(date) { return dateFilter(date, 'ss'); }
	      },
	      {
	        key: 's',
	        regex: '[0-9]|[1-5][0-9]',
	        apply: function(value) { this.seconds = +value; },
	        formatter: function(date) { return dateFilter(date, 's'); }
	      },
	      {
	        key: 'a',
	        regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
	        apply: function(value) {
	          if (this.hours === 12) {
	            this.hours = 0;
	          }
	
	          if (value === 'PM') {
	            this.hours += 12;
	          }
	        },
	        formatter: function(date) { return dateFilter(date, 'a'); }
	      },
	      {
	        key: 'Z',
	        regex: '[+-]\\d{4}',
	        apply: function(value) {
	          var matches = value.match(/([+-])(\d{2})(\d{2})/),
	            sign = matches[1],
	            hours = matches[2],
	            minutes = matches[3];
	          this.hours += toInt(sign + hours);
	          this.minutes += toInt(sign + minutes);
	        },
	        formatter: function(date) {
	          return dateFilter(date, 'Z');
	        }
	      },
	      {
	        key: 'ww',
	        regex: '[0-4][0-9]|5[0-3]',
	        formatter: function(date) { return dateFilter(date, 'ww'); }
	      },
	      {
	        key: 'w',
	        regex: '[0-9]|[1-4][0-9]|5[0-3]',
	        formatter: function(date) { return dateFilter(date, 'w'); }
	      },
	      {
	        key: 'GGGG',
	        regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
	        formatter: function(date) { return dateFilter(date, 'GGGG'); }
	      },
	      {
	        key: 'GGG',
	        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	        formatter: function(date) { return dateFilter(date, 'GGG'); }
	      },
	      {
	        key: 'GG',
	        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	        formatter: function(date) { return dateFilter(date, 'GG'); }
	      },
	      {
	        key: 'G',
	        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	        formatter: function(date) { return dateFilter(date, 'G'); }
	      }
	    ];
	
	    if (angular.version.major >= 1 && angular.version.minor > 4) {
	      formatCodeToRegex.push({
	        key: 'LLLL',
	        regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
	        apply: function(value) { this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value); },
	        formatter: function(date) { return dateFilter(date, 'LLLL'); }
	      });
	    }
	  };
	
	  this.init();
	
	  function getFormatCodeToRegex(key) {
	    return filterFilter(formatCodeToRegex, {key: key}, true)[0];
	  }
	
	  this.getParser = function (key) {
	    var f = getFormatCodeToRegex(key);
	    return f && f.apply || null;
	  };
	
	  this.overrideParser = function (key, parser) {
	    var f = getFormatCodeToRegex(key);
	    if (f && angular.isFunction(parser)) {
	      this.parsers = {};
	      f.apply = parser;
	    }
	  }.bind(this);
	
	  function createParser(format) {
	    var map = [], regex = format.split('');
	
	    // check for literal values
	    var quoteIndex = format.indexOf('\'');
	    if (quoteIndex > -1) {
	      var inLiteral = false;
	      format = format.split('');
	      for (var i = quoteIndex; i < format.length; i++) {
	        if (inLiteral) {
	          if (format[i] === '\'') {
	            if (i + 1 < format.length && format[i+1] === '\'') { // escaped single quote
	              format[i+1] = '$';
	              regex[i+1] = '';
	            } else { // end of literal
	              regex[i] = '';
	              inLiteral = false;
	            }
	          }
	          format[i] = '$';
	        } else {
	          if (format[i] === '\'') { // start of literal
	            format[i] = '$';
	            regex[i] = '';
	            inLiteral = true;
	          }
	        }
	      }
	
	      format = format.join('');
	    }
	
	    angular.forEach(formatCodeToRegex, function(data) {
	      var index = format.indexOf(data.key);
	
	      if (index > -1) {
	        format = format.split('');
	
	        regex[index] = '(' + data.regex + ')';
	        format[index] = '$'; // Custom symbol to define consumed part of format
	        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
	          regex[i] = '';
	          format[i] = '$';
	        }
	        format = format.join('');
	
	        map.push({
	          index: index,
	          key: data.key,
	          apply: data.apply,
	          matcher: data.regex
	        });
	      }
	    });
	
	    return {
	      regex: new RegExp('^' + regex.join('') + '$'),
	      map: orderByFilter(map, 'index')
	    };
	  }
	
	  function createFormatter(format) {
	    var formatters = [];
	    var i = 0;
	    var formatter, literalIdx;
	    while (i < format.length) {
	      if (angular.isNumber(literalIdx)) {
	        if (format.charAt(i) === '\'') {
	          if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
	            formatters.push(constructLiteralFormatter(format, literalIdx, i));
	            literalIdx = null;
	          }
	        } else if (i === format.length) {
	          while (literalIdx < format.length) {
	            formatter = constructFormatterFromIdx(format, literalIdx);
	            formatters.push(formatter);
	            literalIdx = formatter.endIdx;
	          }
	        }
	
	        i++;
	        continue;
	      }
	
	      if (format.charAt(i) === '\'') {
	        literalIdx = i;
	        i++;
	        continue;
	      }
	
	      formatter = constructFormatterFromIdx(format, i);
	
	      formatters.push(formatter.parser);
	      i = formatter.endIdx;
	    }
	
	    return formatters;
	  }
	
	  function constructLiteralFormatter(format, literalIdx, endIdx) {
	    return function() {
	      return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
	    };
	  }
	
	  function constructFormatterFromIdx(format, i) {
	    var currentPosStr = format.substr(i);
	    for (var j = 0; j < formatCodeToRegex.length; j++) {
	      if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
	        var data = formatCodeToRegex[j];
	        return {
	          endIdx: i + data.key.length,
	          parser: data.formatter
	        };
	      }
	    }
	
	    return {
	      endIdx: i + 1,
	      parser: function() {
	        return currentPosStr.charAt(0);
	      }
	    };
	  }
	
	  this.filter = function(date, format) {
	    if (!angular.isDate(date) || isNaN(date) || !format) {
	      return '';
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.formatters[format]) {
	      this.formatters[format] = createFormatter(format);
	    }
	
	    var formatters = this.formatters[format];
	
	    return formatters.reduce(function(str, formatter) {
	      return str + formatter(date);
	    }, '');
	  };
	
	  this.parse = function(input, format, baseDate) {
	    if (!angular.isString(input) || !format) {
	      return input;
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.parsers[format]) {
	      this.parsers[format] = createParser(format, 'apply');
	    }
	
	    var parser = this.parsers[format],
	        regex = parser.regex,
	        map = parser.map,
	        results = input.match(regex),
	        tzOffset = false;
	    if (results && results.length) {
	      var fields, dt;
	      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
	        fields = {
	          year: baseDate.getFullYear(),
	          month: baseDate.getMonth(),
	          date: baseDate.getDate(),
	          hours: baseDate.getHours(),
	          minutes: baseDate.getMinutes(),
	          seconds: baseDate.getSeconds(),
	          milliseconds: baseDate.getMilliseconds()
	        };
	      } else {
	        if (baseDate) {
	          $log.warn('dateparser:', 'baseDate is not a valid date');
	        }
	        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
	      }
	
	      for (var i = 1, n = results.length; i < n; i++) {
	        var mapper = map[i - 1];
	        if (mapper.matcher === 'Z') {
	          tzOffset = true;
	        }
	
	        if (mapper.apply) {
	          mapper.apply.call(fields, results[i]);
	        }
	      }
	
	      var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
	        Date.prototype.setFullYear;
	      var timesetter = tzOffset ? Date.prototype.setUTCHours :
	        Date.prototype.setHours;
	
	      if (isValid(fields.year, fields.month, fields.date)) {
	        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
	          dt = new Date(baseDate);
	          datesetter.call(dt, fields.year, fields.month, fields.date);
	          timesetter.call(dt, fields.hours, fields.minutes,
	            fields.seconds, fields.milliseconds);
	        } else {
	          dt = new Date(0);
	          datesetter.call(dt, fields.year, fields.month, fields.date);
	          timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
	            fields.seconds || 0, fields.milliseconds || 0);
	        }
	      }
	
	      return dt;
	    }
	  };
	
	  // Check if date is valid for specific month (and year for February).
	  // Month: 0 = Jan, 1 = Feb, etc
	  function isValid(year, month, date) {
	    if (date < 1) {
	      return false;
	    }
	
	    if (month === 1 && date > 28) {
	      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
	    }
	
	    if (month === 3 || month === 5 || month === 8 || month === 10) {
	      return date < 31;
	    }
	
	    return true;
	  }
	
	  function toInt(str) {
	    return parseInt(str, 10);
	  }
	
	  this.toTimezone = toTimezone;
	  this.fromTimezone = fromTimezone;
	  this.timezoneToOffset = timezoneToOffset;
	  this.addDateMinutes = addDateMinutes;
	  this.convertTimezoneToLocal = convertTimezoneToLocal;
	
	  function toTimezone(date, timezone) {
	    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
	  }
	
	  function fromTimezone(date, timezone) {
	    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
	  }
	
	  //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
	  function timezoneToOffset(timezone, fallback) {
	    timezone = timezone.replace(/:/g, '');
	    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	  }
	
	  function addDateMinutes(date, minutes) {
	    date = new Date(date.getTime());
	    date.setMinutes(date.getMinutes() + minutes);
	    return date;
	  }
	
	  function convertTimezoneToLocal(date, timezone, reverse) {
	    reverse = reverse ? -1 : 1;
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	  }
	}]);
	
	// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
	// at most one element.
	angular.module('ui.bootstrap.isClass', [])
	.directive('uibIsClass', [
	         '$animate',
	function ($animate) {
	  //                    11111111          22222222
	  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
	  //                    11111111           22222222
	  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;
	
	  var dataPerTracked = {};
	
	  return {
	    restrict: 'A',
	    compile: function(tElement, tAttrs) {
	      var linkedScopes = [];
	      var instances = [];
	      var expToData = {};
	      var lastActivated = null;
	      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
	      var onExp = onExpMatches[2];
	      var expsStr = onExpMatches[1];
	      var exps = expsStr.split(',');
	
	      return linkFn;
	
	      function linkFn(scope, element, attrs) {
	        linkedScopes.push(scope);
	        instances.push({
	          scope: scope,
	          element: element
	        });
	
	        exps.forEach(function(exp, k) {
	          addForExp(exp, scope);
	        });
	
	        scope.$on('$destroy', removeScope);
	      }
	
	      function addForExp(exp, scope) {
	        var matches = exp.match(IS_REGEXP);
	        var clazz = scope.$eval(matches[1]);
	        var compareWithExp = matches[2];
	        var data = expToData[exp];
	        if (!data) {
	          var watchFn = function(compareWithVal) {
	            var newActivated = null;
	            instances.some(function(instance) {
	              var thisVal = instance.scope.$eval(onExp);
	              if (thisVal === compareWithVal) {
	                newActivated = instance;
	                return true;
	              }
	            });
	            if (data.lastActivated !== newActivated) {
	              if (data.lastActivated) {
	                $animate.removeClass(data.lastActivated.element, clazz);
	              }
	              if (newActivated) {
	                $animate.addClass(newActivated.element, clazz);
	              }
	              data.lastActivated = newActivated;
	            }
	          };
	          expToData[exp] = data = {
	            lastActivated: null,
	            scope: scope,
	            watchFn: watchFn,
	            compareWithExp: compareWithExp,
	            watcher: scope.$watch(compareWithExp, watchFn)
	          };
	        }
	        data.watchFn(scope.$eval(compareWithExp));
	      }
	
	      function removeScope(e) {
	        var removedScope = e.targetScope;
	        var index = linkedScopes.indexOf(removedScope);
	        linkedScopes.splice(index, 1);
	        instances.splice(index, 1);
	        if (linkedScopes.length) {
	          var newWatchScope = linkedScopes[0];
	          angular.forEach(expToData, function(data) {
	            if (data.scope === removedScope) {
	              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
	              data.scope = newWatchScope;
	            }
	          });
	        } else {
	          expToData = {};
	        }
	      }
	    }
	  };
	}]);
	angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass'])
	
	.value('$datepickerSuppressError', false)
	
	.value('$datepickerLiteralWarning', true)
	
	.constant('uibDatepickerConfig', {
	  datepickerMode: 'day',
	  formatDay: 'dd',
	  formatMonth: 'MMMM',
	  formatYear: 'yyyy',
	  formatDayHeader: 'EEE',
	  formatDayTitle: 'MMMM yyyy',
	  formatMonthTitle: 'yyyy',
	  maxDate: null,
	  maxMode: 'year',
	  minDate: null,
	  minMode: 'day',
	  monthColumns: 3,
	  ngModelOptions: {},
	  shortcutPropagation: false,
	  showWeeks: true,
	  yearColumns: 5,
	  yearRows: 4
	})
	
	.controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser',
	  function($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl;
	      ngModelOptions = {},
	      watchListeners = [];
	
	  $element.addClass('uib-datepicker');
	  $attrs.$set('role', 'application');
	
	  if (!$scope.datepickerOptions) {
	    $scope.datepickerOptions = {};
	  }
	
	  // Modes chain
	  this.modes = ['day', 'month', 'year'];
	
	  [
	    'customClass',
	    'dateDisabled',
	    'datepickerMode',
	    'formatDay',
	    'formatDayHeader',
	    'formatDayTitle',
	    'formatMonth',
	    'formatMonthTitle',
	    'formatYear',
	    'maxDate',
	    'maxMode',
	    'minDate',
	    'minMode',
	    'monthColumns',
	    'showWeeks',
	    'shortcutPropagation',
	    'startingDay',
	    'yearColumns',
	    'yearRows'
	  ].forEach(function(key) {
	    switch (key) {
	      case 'customClass':
	      case 'dateDisabled':
	        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
	        break;
	      case 'datepickerMode':
	        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
	          $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
	        break;
	      case 'formatDay':
	      case 'formatDayHeader':
	      case 'formatDayTitle':
	      case 'formatMonth':
	      case 'formatMonthTitle':
	      case 'formatYear':
	        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
	          $interpolate($scope.datepickerOptions[key])($scope.$parent) :
	          datepickerConfig[key];
	        break;
	      case 'monthColumns':
	      case 'showWeeks':
	      case 'shortcutPropagation':
	      case 'yearColumns':
	      case 'yearRows':
	        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
	          $scope.datepickerOptions[key] : datepickerConfig[key];
	        break;
	      case 'startingDay':
	        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
	          self.startingDay = $scope.datepickerOptions.startingDay;
	        } else if (angular.isNumber(datepickerConfig.startingDay)) {
	          self.startingDay = datepickerConfig.startingDay;
	        } else {
	          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
	        }
	
	        break;
	      case 'maxDate':
	      case 'minDate':
	        $scope.$watch('datepickerOptions.' + key, function(value) {
	          if (value) {
	            if (angular.isDate(value)) {
	              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
	            } else {
	              if ($datepickerLiteralWarning) {
	                $log.warn('Literal date support has been deprecated, please switch to date object usage');
	              }
	
	              self[key] = new Date(dateFilter(value, 'medium'));
	            }
	          } else {
	            self[key] = datepickerConfig[key] ?
	              dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) :
	              null;
	          }
	
	          self.refreshView();
	        });
	
	        break;
	      case 'maxMode':
	      case 'minMode':
	        if ($scope.datepickerOptions[key]) {
	          $scope.$watch(function() { return $scope.datepickerOptions[key]; }, function(value) {
	            self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
	            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
	              key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
	              $scope.datepickerMode = self[key];
	              $scope.datepickerOptions.datepickerMode = self[key];
	            }
	          });
	        } else {
	          self[key] = $scope[key] = datepickerConfig[key] || null;
	        }
	
	        break;
	    }
	  });
	
	  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
	
	  $scope.disabled = angular.isDefined($attrs.disabled) || false;
	  if (angular.isDefined($attrs.ngDisabled)) {
	    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function(disabled) {
	      $scope.disabled = disabled;
	      self.refreshView();
	    }));
	  }
	
	  $scope.isActive = function(dateObject) {
	    if (self.compare(dateObject.date, self.activeDate) === 0) {
	      $scope.activeDateId = dateObject.uid;
	      return true;
	    }
	    return false;
	  };
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelOptions = extractOptions(ngModelCtrl);
	
	    if ($scope.datepickerOptions.initDate) {
	      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
	      $scope.$watch('datepickerOptions.initDate', function(initDate) {
	        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
	          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
	          self.refreshView();
	        }
	      });
	    } else {
	      self.activeDate = new Date();
	    }
	
	    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
	    this.activeDate = !isNaN(date) ?
	      dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) :
	      dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	  };
	
	  this.render = function() {
	    if (ngModelCtrl.$viewValue) {
	      var date = new Date(ngModelCtrl.$viewValue),
	          isValid = !isNaN(date);
	
	      if (isValid) {
	        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
	      } else if (!$datepickerSuppressError) {
	        $log.error('Datepicker directive: "ng-model" value must be a Date object');
	      }
	    }
	    this.refreshView();
	  };
	
	  this.refreshView = function() {
	    if (this.element) {
	      $scope.selectedDt = null;
	      this._refreshView();
	      if ($scope.activeDt) {
	        $scope.activeDateId = $scope.activeDt.uid;
	      }
	
	      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	      date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
	      ngModelCtrl.$setValidity('dateDisabled', !date ||
	        this.element && !this.isDisabled(date));
	    }
	  };
	
	  this.createDateObject = function(date, format) {
	    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	    model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
	    var today = new Date();
	    today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
	    var time = this.compare(date, today);
	    var dt = {
	      date: date,
	      label: dateParser.filter(date, format),
	      selected: model && this.compare(date, model) === 0,
	      disabled: this.isDisabled(date),
	      past: time < 0,
	      current: time === 0,
	      future: time > 0,
	      customClass: this.customClass(date) || null
	    };
	
	    if (model && this.compare(date, model) === 0) {
	      $scope.selectedDt = dt;
	    }
	
	    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
	      $scope.activeDt = dt;
	    }
	
	    return dt;
	  };
	
	  this.isDisabled = function(date) {
	    return $scope.disabled ||
	      this.minDate && this.compare(date, this.minDate) < 0 ||
	      this.maxDate && this.compare(date, this.maxDate) > 0 ||
	      $scope.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode});
	  };
	
	  this.customClass = function(date) {
	    return $scope.customClass({date: date, mode: $scope.datepickerMode});
	  };
	
	  // Split array into smaller arrays
	  this.split = function(arr, size) {
	    var arrays = [];
	    while (arr.length > 0) {
	      arrays.push(arr.splice(0, size));
	    }
	    return arrays;
	  };
	
	  $scope.select = function(date) {
	    if ($scope.datepickerMode === self.minMode) {
	      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
	      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	      dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
	      ngModelCtrl.$setViewValue(dt);
	      ngModelCtrl.$render();
	    } else {
	      self.activeDate = date;
	      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);
	
	      $scope.$emit('uib:datepicker.mode');
	    }
	
	    $scope.$broadcast('uib:datepicker.focus');
	  };
	
	  $scope.move = function(direction) {
	    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
	        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
	    self.activeDate.setFullYear(year, month, 1);
	    self.refreshView();
	  };
	
	  $scope.toggleMode = function(direction) {
	    direction = direction || 1;
	
	    if ($scope.datepickerMode === self.maxMode && direction === 1 ||
	      $scope.datepickerMode === self.minMode && direction === -1) {
	      return;
	    }
	
	    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);
	
	    $scope.$emit('uib:datepicker.mode');
	  };
	
	  // Key event mapper
	  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };
	
	  var focusElement = function() {
	    self.element[0].focus();
	  };
	
	  // Listen for focus requests from popup directive
	  $scope.$on('uib:datepicker.focus', focusElement);
	
	  $scope.keydown = function(evt) {
	    var key = $scope.keys[evt.which];
	
	    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
	      return;
	    }
	
	    evt.preventDefault();
	    if (!self.shortcutPropagation) {
	      evt.stopPropagation();
	    }
	
	    if (key === 'enter' || key === 'space') {
	      if (self.isDisabled(self.activeDate)) {
	        return; // do nothing
	      }
	      $scope.select(self.activeDate);
	    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
	      $scope.toggleMode(key === 'up' ? 1 : -1);
	    } else {
	      self.handleKeyDown(key, evt);
	      self.refreshView();
	    }
	  };
	
	  $element.on('keydown', function(evt) {
	    $scope.$apply(function() {
	      $scope.keydown(evt);
	    });
	  });
	
	  $scope.$on('$destroy', function() {
	    //Clear all watch listeners on destroy
	    while (watchListeners.length) {
	      watchListeners.shift()();
	    }
	  });
	
	  function setMode(mode) {
	    $scope.datepickerMode = mode;
	    $scope.datepickerOptions.datepickerMode = mode;
	  }
	
	  function extractOptions(ngModelCtrl) {
	    var ngModelOptions;
	
	    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
	      // guarantee a value
	      ngModelOptions = ngModelCtrl.$options ||
	        $scope.datepickerOptions.ngModelOptions ||
	        datepickerConfig.ngModelOptions ||
	        {};
	
	      // mimic 1.6+ api
	      ngModelOptions.getOption = function (key) {
	        return ngModelOptions[key];
	      };
	    } else { // in angular >=1.6 $options is always present
	      // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
	      var timezone = ngModelCtrl.$options.getOption('timezone') ||
	        ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) ||
	        (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);
	
	      // values passed to createChild override existing values
	      ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
	        .createChild(datepickerConfig.ngModelOptions) // lowest precedence
	        .createChild($scope.datepickerOptions.ngModelOptions)
	        .createChild(ngModelCtrl.$options) // highest precedence
	        .createChild({timezone: timezone}); // to keep from squashing a non-null value
	    }
	
	    return ngModelOptions;
	  }
	}])
	
	.controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	  this.step = { months: 1 };
	  this.element = $element;
	  function getDaysInMonth(year, month) {
	    return month === 1 && year % 4 === 0 &&
	      (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
	  }
	
	  this.init = function(ctrl) {
	    angular.extend(ctrl, this);
	    scope.showWeeks = ctrl.showWeeks;
	    ctrl.refreshView();
	  };
	
	  this.getDates = function(startDate, n) {
	    var dates = new Array(n), current = new Date(startDate), i = 0, date;
	    while (i < n) {
	      date = new Date(current);
	      dates[i++] = date;
	      current.setDate(current.getDate() + 1);
	    }
	    return dates;
	  };
	
	  this._refreshView = function() {
	    var year = this.activeDate.getFullYear(),
	      month = this.activeDate.getMonth(),
	      firstDayOfMonth = new Date(this.activeDate);
	
	    firstDayOfMonth.setFullYear(year, month, 1);
	
	    var difference = this.startingDay - firstDayOfMonth.getDay(),
	      numDisplayedFromPreviousMonth = difference > 0 ?
	        7 - difference : - difference,
	      firstDate = new Date(firstDayOfMonth);
	
	    if (numDisplayedFromPreviousMonth > 0) {
	      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
	    }
	
	    // 42 is the number of days on a six-week calendar
	    var days = this.getDates(firstDate, 42);
	    for (var i = 0; i < 42; i ++) {
	      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
	        secondary: days[i].getMonth() !== month,
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.labels = new Array(7);
	    for (var j = 0; j < 7; j++) {
	      scope.labels[j] = {
	        abbr: dateFilter(days[j].date, this.formatDayHeader),
	        full: dateFilter(days[j].date, 'EEEE')
	      };
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
	    scope.rows = this.split(days, 7);
	
	    if (scope.showWeeks) {
	      scope.weekNumbers = [];
	      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
	          numWeeks = scope.rows.length;
	      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
	        scope.weekNumbers.push(
	          getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
	      }
	    }
	  };
	
	  this.compare = function(date1, date2) {
	    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
	    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	    _date1.setFullYear(date1.getFullYear());
	    _date2.setFullYear(date2.getFullYear());
	    return _date1 - _date2;
	  };
	
	  function getISO8601WeekNumber(date) {
	    var checkDate = new Date(date);
	    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
	    var time = checkDate.getTime();
	    checkDate.setMonth(0); // Compare with Jan 1
	    checkDate.setDate(1);
	    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	  }
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getDate();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - 7;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + 7;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var month = this.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
	      this.activeDate.setMonth(month, 1);
	      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
	    } else if (key === 'home') {
	      date = 1;
	    } else if (key === 'end') {
	      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
	    }
	    this.activeDate.setDate(date);
	  };
	}])
	
	.controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  this.step = { years: 1 };
	  this.element = $element;
	
	  this.init = function(ctrl) {
	    angular.extend(ctrl, this);
	    ctrl.refreshView();
	  };
	
	  this._refreshView = function() {
	    var months = new Array(12),
	        year = this.activeDate.getFullYear(),
	        date;
	
	    for (var i = 0; i < 12; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(year, i, 1);
	      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
	    scope.rows = this.split(months, this.monthColumns);
	    scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
	  };
	
	  this.compare = function(date1, date2) {
	    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
	    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
	    _date1.setFullYear(date1.getFullYear());
	    _date2.setFullYear(date2.getFullYear());
	    return _date1 - _date2;
	  };
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getMonth();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - this.monthColumns;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + this.monthColumns;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var year = this.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
	      this.activeDate.setFullYear(year);
	    } else if (key === 'home') {
	      date = 0;
	    } else if (key === 'end') {
	      date = 11;
	    }
	    this.activeDate.setMonth(date);
	  };
	}])
	
	.controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  var columns, range;
	  this.element = $element;
	
	  function getStartingYear(year) {
	    return parseInt((year - 1) / range, 10) * range + 1;
	  }
	
	  this.yearpickerInit = function() {
	    columns = this.yearColumns;
	    range = this.yearRows * columns;
	    this.step = { years: range };
	  };
	
	  this._refreshView = function() {
	    var years = new Array(range), date;
	
	    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(start + i, 0, 1);
	      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = [years[0].label, years[range - 1].label].join(' - ');
	    scope.rows = this.split(years, columns);
	    scope.columns = columns;
	  };
	
	  this.compare = function(date1, date2) {
	    return date1.getFullYear() - date2.getFullYear();
	  };
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getFullYear();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - columns;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + columns;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      date += (key === 'pageup' ? - 1 : 1) * range;
	    } else if (key === 'home') {
	      date = getStartingYear(this.activeDate.getFullYear());
	    } else if (key === 'end') {
	      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
	    }
	    this.activeDate.setFullYear(date);
	  };
	}])
	
	.directive('uibDatepicker', function() {
	  return {
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
	    },
	    scope: {
	      datepickerOptions: '=?'
	    },
	    require: ['uibDatepicker', '^ngModel'],
	    restrict: 'A',
	    controller: 'UibDatepickerController',
	    controllerAs: 'datepicker',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      datepickerCtrl.init(ngModelCtrl);
	    }
	  };
	})
	
	.directive('uibDaypicker', function() {
	  return {
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/day.html';
	    },
	    require: ['^uibDatepicker', 'uibDaypicker'],
	    restrict: 'A',
	    controller: 'UibDaypickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	        daypickerCtrl = ctrls[1];
	
	      daypickerCtrl.init(datepickerCtrl);
	    }
	  };
	})
	
	.directive('uibMonthpicker', function() {
	  return {
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/month.html';
	    },
	    require: ['^uibDatepicker', 'uibMonthpicker'],
	    restrict: 'A',
	    controller: 'UibMonthpickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	        monthpickerCtrl = ctrls[1];
	
	      monthpickerCtrl.init(datepickerCtrl);
	    }
	  };
	})
	
	.directive('uibYearpicker', function() {
	  return {
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/year.html';
	    },
	    require: ['^uibDatepicker', 'uibYearpicker'],
	    restrict: 'A',
	    controller: 'UibYearpickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var ctrl = ctrls[0];
	      angular.extend(ctrl, ctrls[1]);
	      ctrl.yearpickerInit();
	
	      ctrl.refreshView();
	    }
	  };
	});
	
	angular.module('ui.bootstrap.position', [])
	
	/**
	 * A set of utility methods for working with the DOM.
	 * It is meant to be used where we need to absolute-position elements in
	 * relation to another element (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
	    /**
	     * Used by scrollbarWidth() function to cache scrollbar's width.
	     * Do not access this variable directly, use scrollbarWidth() instead.
	     */
	    var SCROLLBAR_WIDTH;
	    /**
	     * scrollbar on body and html element in IE and Edge overlay
	     * content and should be considered 0 width.
	     */
	    var BODY_SCROLLBAR_WIDTH;
	    var OVERFLOW_REGEX = {
	      normal: /(auto|scroll)/,
	      hidden: /(auto|scroll|hidden)/
	    };
	    var PLACEMENT_REGEX = {
	      auto: /\s?auto?\s?/i,
	      primary: /^(top|bottom|left|right)$/,
	      secondary: /^(top|bottom|left|right|center)$/,
	      vertical: /^(top|bottom)$/
	    };
	    var BODY_REGEX = /(HTML|BODY)/;
	
	    return {
	
	      /**
	       * Provides a raw DOM element from a jQuery/jQLite element.
	       *
	       * @param {element} elem - The element to convert.
	       *
	       * @returns {element} A HTML element.
	       */
	      getRawNode: function(elem) {
	        return elem.nodeName ? elem : elem[0] || elem;
	      },
	
	      /**
	       * Provides a parsed number for a style property.  Strips
	       * units and casts invalid numbers to 0.
	       *
	       * @param {string} value - The style value to parse.
	       *
	       * @returns {number} A valid number.
	       */
	      parseStyle: function(value) {
	        value = parseFloat(value);
	        return isFinite(value) ? value : 0;
	      },
	
	      /**
	       * Provides the closest positioned ancestor.
	       *
	       * @param {element} element - The element to get the offest parent for.
	       *
	       * @returns {element} The closest positioned ancestor.
	       */
	      offsetParent: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var offsetParent = elem.offsetParent || $document[0].documentElement;
	
	        function isStaticPositioned(el) {
	          return ($window.getComputedStyle(el).position || 'static') === 'static';
	        }
	
	        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
	          offsetParent = offsetParent.offsetParent;
	        }
	
	        return offsetParent || $document[0].documentElement;
	      },
	
	      /**
	       * Provides the scrollbar width, concept from TWBS measureScrollbar()
	       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
	       * In IE and Edge, scollbar on body and html element overlay and should
	       * return a width of 0.
	       *
	       * @returns {number} The width of the browser scollbar.
	       */
	      scrollbarWidth: function(isBody) {
	        if (isBody) {
	          if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
	            var bodyElem = $document.find('body');
	            bodyElem.addClass('uib-position-body-scrollbar-measure');
	            BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
	            BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
	            bodyElem.removeClass('uib-position-body-scrollbar-measure');
	          }
	          return BODY_SCROLLBAR_WIDTH;
	        }
	
	        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
	          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
	          $document.find('body').append(scrollElem);
	          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
	          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
	          scrollElem.remove();
	        }
	
	        return SCROLLBAR_WIDTH;
	      },
	
	      /**
	       * Provides the padding required on an element to replace the scrollbar.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**scrollbarWidth**: the width of the scrollbar</li>
	       *     <li>**widthOverflow**: whether the the width is overflowing</li>
	       *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
	       *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
	       *     <li>**heightOverflow**: whether the the height is overflowing</li>
	       *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
	       *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
	       *   </ul>
	       */
	      scrollbarPadding: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var elemStyle = $window.getComputedStyle(elem);
	        var paddingRight = this.parseStyle(elemStyle.paddingRight);
	        var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
	        var scrollParent = this.scrollParent(elem, false, true);
	        var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));
	
	        return {
	          scrollbarWidth: scrollbarWidth,
	          widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
	          right: paddingRight + scrollbarWidth,
	          originalRight: paddingRight,
	          heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
	          bottom: paddingBottom + scrollbarWidth,
	          originalBottom: paddingBottom
	         };
	      },
	
	      /**
	       * Checks to see if the element is scrollable.
	       *
	       * @param {element} elem - The element to check.
	       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	       *   default is false.
	       *
	       * @returns {boolean} Whether the element is scrollable.
	       */
	      isScrollable: function(elem, includeHidden) {
	        elem = this.getRawNode(elem);
	
	        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	        var elemStyle = $window.getComputedStyle(elem);
	        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
	      },
	
	      /**
	       * Provides the closest scrollable ancestor.
	       * A port of the jQuery UI scrollParent method:
	       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
	       *
	       * @param {element} elem - The element to find the scroll parent of.
	       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	       *   default is false.
	       * @param {boolean=} [includeSelf=false] - Should the element being passed be
	       * included in the scrollable llokup.
	       *
	       * @returns {element} A HTML element.
	       */
	      scrollParent: function(elem, includeHidden, includeSelf) {
	        elem = this.getRawNode(elem);
	
	        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	        var documentEl = $document[0].documentElement;
	        var elemStyle = $window.getComputedStyle(elem);
	        if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
	          return elem;
	        }
	        var excludeStatic = elemStyle.position === 'absolute';
	        var scrollParent = elem.parentElement || documentEl;
	
	        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
	          return documentEl;
	        }
	
	        while (scrollParent.parentElement && scrollParent !== documentEl) {
	          var spStyle = $window.getComputedStyle(scrollParent);
	          if (excludeStatic && spStyle.position !== 'static') {
	            excludeStatic = false;
	          }
	
	          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
	            break;
	          }
	          scrollParent = scrollParent.parentElement;
	        }
	
	        return scrollParent;
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's position function:
	       * http://api.jquery.com/position/ - distance to closest positioned
	       * ancestor.  Does not account for margins by default like jQuery position.
	       *
	       * @param {element} elem - The element to caclulate the position on.
	       * @param {boolean=} [includeMargins=false] - Should margins be accounted
	       * for, default is false.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**width**: the width of the element</li>
	       *     <li>**height**: the height of the element</li>
	       *     <li>**top**: distance to top edge of offset parent</li>
	       *     <li>**left**: distance to left edge of offset parent</li>
	       *   </ul>
	       */
	      position: function(elem, includeMagins) {
	        elem = this.getRawNode(elem);
	
	        var elemOffset = this.offset(elem);
	        if (includeMagins) {
	          var elemStyle = $window.getComputedStyle(elem);
	          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
	          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
	        }
	        var parent = this.offsetParent(elem);
	        var parentOffset = {top: 0, left: 0};
	
	        if (parent !== $document[0].documentElement) {
	          parentOffset = this.offset(parent);
	          parentOffset.top += parent.clientTop - parent.scrollTop;
	          parentOffset.left += parent.clientLeft - parent.scrollLeft;
	        }
	
	        return {
	          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
	          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
	          top: Math.round(elemOffset.top - parentOffset.top),
	          left: Math.round(elemOffset.left - parentOffset.left)
	        };
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's offset function:
	       * http://api.jquery.com/offset/ - distance to viewport.  Does
	       * not account for borders, margins, or padding on the body
	       * element.
	       *
	       * @param {element} elem - The element to calculate the offset on.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**width**: the width of the element</li>
	       *     <li>**height**: the height of the element</li>
	       *     <li>**top**: distance to top edge of viewport</li>
	       *     <li>**right**: distance to bottom edge of viewport</li>
	       *   </ul>
	       */
	      offset: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var elemBCR = elem.getBoundingClientRect();
	        return {
	          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
	          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
	          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
	          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
	        };
	      },
	
	      /**
	       * Provides offset distance to the closest scrollable ancestor
	       * or viewport.  Accounts for border and scrollbar width.
	       *
	       * Right and bottom dimensions represent the distance to the
	       * respective edge of the viewport element.  If the element
	       * edge extends beyond the viewport, a negative value will be
	       * reported.
	       *
	       * @param {element} elem - The element to get the viewport offset for.
	       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
	       * of the first scrollable element, default is false.
	       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
	       * be accounted for, default is true.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**top**: distance to the top content edge of viewport element</li>
	       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
	       *     <li>**left**: distance to the left content edge of viewport element</li>
	       *     <li>**right**: distance to the right content edge of viewport element</li>
	       *   </ul>
	       */
	      viewportOffset: function(elem, useDocument, includePadding) {
	        elem = this.getRawNode(elem);
	        includePadding = includePadding !== false ? true : false;
	
	        var elemBCR = elem.getBoundingClientRect();
	        var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};
	
	        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
	        var offsetParentBCR = offsetParent.getBoundingClientRect();
	
	        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
	        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
	        if (offsetParent === $document[0].documentElement) {
	          offsetBCR.top += $window.pageYOffset;
	          offsetBCR.left += $window.pageXOffset;
	        }
	        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
	        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;
	
	        if (includePadding) {
	          var offsetParentStyle = $window.getComputedStyle(offsetParent);
	          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
	          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
	          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
	          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
	        }
	
	        return {
	          top: Math.round(elemBCR.top - offsetBCR.top),
	          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
	          left: Math.round(elemBCR.left - offsetBCR.left),
	          right: Math.round(offsetBCR.right - elemBCR.right)
	        };
	      },
	
	      /**
	       * Provides an array of placement values parsed from a placement string.
	       * Along with the 'auto' indicator, supported placement strings are:
	       *   <ul>
	       *     <li>top: element on top, horizontally centered on host element.</li>
	       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
	       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
	       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
	       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
	       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
	       *     <li>left: element on left, vertically centered on host element.</li>
	       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
	       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
	       *     <li>right: element on right, vertically centered on host element.</li>
	       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
	       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
	       *   </ul>
	       * A placement string with an 'auto' indicator is expected to be
	       * space separated from the placement, i.e: 'auto bottom-left'  If
	       * the primary and secondary placement values do not match 'top,
	       * bottom, left, right' then 'top' will be the primary placement and
	       * 'center' will be the secondary placement.  If 'auto' is passed, true
	       * will be returned as the 3rd value of the array.
	       *
	       * @param {string} placement - The placement string to parse.
	       *
	       * @returns {array} An array with the following values
	       * <ul>
	       *   <li>**[0]**: The primary placement.</li>
	       *   <li>**[1]**: The secondary placement.</li>
	       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
	       * </ul>
	       */
	      parsePlacement: function(placement) {
	        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
	        if (autoPlace) {
	          placement = placement.replace(PLACEMENT_REGEX.auto, '');
	        }
	
	        placement = placement.split('-');
	
	        placement[0] = placement[0] || 'top';
	        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
	          placement[0] = 'top';
	        }
	
	        placement[1] = placement[1] || 'center';
	        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
	          placement[1] = 'center';
	        }
	
	        if (autoPlace) {
	          placement[2] = true;
	        } else {
	          placement[2] = false;
	        }
	
	        return placement;
	      },
	
	      /**
	       * Provides coordinates for an element to be positioned relative to
	       * another element.  Passing 'auto' as part of the placement parameter
	       * will enable smart placement - where the element fits. i.e:
	       * 'auto left-top' will check to see if there is enough space to the left
	       * of the hostElem to fit the targetElem, if not place right (same for secondary
	       * top placement).  Available space is calculated using the viewportOffset
	       * function.
	       *
	       * @param {element} hostElem - The element to position against.
	       * @param {element} targetElem - The element to position.
	       * @param {string=} [placement=top] - The placement for the targetElem,
	       *   default is 'top'. 'center' is assumed as secondary placement for
	       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
	       *   <ul>
	       *     <li>top</li>
	       *     <li>top-right</li>
	       *     <li>top-left</li>
	       *     <li>bottom</li>
	       *     <li>bottom-left</li>
	       *     <li>bottom-right</li>
	       *     <li>left</li>
	       *     <li>left-top</li>
	       *     <li>left-bottom</li>
	       *     <li>right</li>
	       *     <li>right-top</li>
	       *     <li>right-bottom</li>
	       *   </ul>
	       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
	       *   be calculated from the body element, default is false.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**top**: Value for targetElem top.</li>
	       *     <li>**left**: Value for targetElem left.</li>
	       *     <li>**placement**: The resolved placement.</li>
	       *   </ul>
	       */
	      positionElements: function(hostElem, targetElem, placement, appendToBody) {
	        hostElem = this.getRawNode(hostElem);
	        targetElem = this.getRawNode(targetElem);
	
	        // need to read from prop to support tests.
	        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
	        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');
	
	        placement = this.parsePlacement(placement);
	
	        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
	        var targetElemPos = {top: 0, left: 0, placement: ''};
	
	        if (placement[2]) {
	          var viewportOffset = this.viewportOffset(hostElem, appendToBody);
	
	          var targetElemStyle = $window.getComputedStyle(targetElem);
	          var adjustedSize = {
	            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
	            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
	          };
	
	          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
	                         placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
	                         placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
	                         placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
	                         placement[0];
	
	          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
	                         placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
	                         placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
	                         placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
	                         placement[1];
	
	          if (placement[1] === 'center') {
	            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
	              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
	                placement[1] = 'left';
	              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
	                placement[1] = 'right';
	              }
	            } else {
	              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
	              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
	                placement[1] = 'top';
	              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
	                placement[1] = 'bottom';
	              }
	            }
	          }
	        }
	
	        switch (placement[0]) {
	          case 'top':
	            targetElemPos.top = hostElemPos.top - targetHeight;
	            break;
	          case 'bottom':
	            targetElemPos.top = hostElemPos.top + hostElemPos.height;
	            break;
	          case 'left':
	            targetElemPos.left = hostElemPos.left - targetWidth;
	            break;
	          case 'right':
	            targetElemPos.left = hostElemPos.left + hostElemPos.width;
	            break;
	        }
	
	        switch (placement[1]) {
	          case 'top':
	            targetElemPos.top = hostElemPos.top;
	            break;
	          case 'bottom':
	            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
	            break;
	          case 'left':
	            targetElemPos.left = hostElemPos.left;
	            break;
	          case 'right':
	            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
	            break;
	          case 'center':
	            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
	            } else {
	              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
	            }
	            break;
	        }
	
	        targetElemPos.top = Math.round(targetElemPos.top);
	        targetElemPos.left = Math.round(targetElemPos.left);
	        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];
	
	        return targetElemPos;
	      },
	
	      /**
	       * Provides a way to adjust the top positioning after first
	       * render to correctly align element to top after content
	       * rendering causes resized element height
	       *
	       * @param {array} placementClasses - The array of strings of classes
	       * element should have.
	       * @param {object} containerPosition - The object with container
	       * position information
	       * @param {number} initialHeight - The initial height for the elem.
	       * @param {number} currentHeight - The current height for the elem.
	       */
	      adjustTop: function(placementClasses, containerPosition, initialHeight, currentHeight) {
	        if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
	          return {
	            top: containerPosition.top - currentHeight + 'px'
	          };
	        }
	      },
	
	      /**
	       * Provides a way for positioning tooltip & dropdown
	       * arrows when using placement options beyond the standard
	       * left, right, top, or bottom.
	       *
	       * @param {element} elem - The tooltip/dropdown element.
	       * @param {string} placement - The placement for the elem.
	       */
	      positionArrow: function(elem, placement) {
	        elem = this.getRawNode(elem);
	
	        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
	        if (!innerElem) {
	          return;
	        }
	
	        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');
	
	        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
	        if (!arrowElem) {
	          return;
	        }
	
	        var arrowCss = {
	          top: '',
	          bottom: '',
	          left: '',
	          right: ''
	        };
	
	        placement = this.parsePlacement(placement);
	        if (placement[1] === 'center') {
	          // no adjustment necessary - just reset styles
	          angular.element(arrowElem).css(arrowCss);
	          return;
	        }
	
	        var borderProp = 'border-' + placement[0] + '-width';
	        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];
	
	        var borderRadiusProp = 'border-';
	        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	          borderRadiusProp += placement[0] + '-' + placement[1];
	        } else {
	          borderRadiusProp += placement[1] + '-' + placement[0];
	        }
	        borderRadiusProp += '-radius';
	        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];
	
	        switch (placement[0]) {
	          case 'top':
	            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'bottom':
	            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'left':
	            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'right':
	            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
	            break;
	        }
	
	        arrowCss[placement[1]] = borderRadius;
	
	        angular.element(arrowElem).css(arrowCss);
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position'])
	
	.value('$datepickerPopupLiteralWarning', true)
	
	.constant('uibDatepickerPopupConfig', {
	  altInputFormats: [],
	  appendToBody: false,
	  clearText: 'Clear',
	  closeOnDateSelection: true,
	  closeText: 'Done',
	  currentText: 'Today',
	  datepickerPopup: 'yyyy-MM-dd',
	  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
	  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
	  html5Types: {
	    date: 'yyyy-MM-dd',
	    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
	    'month': 'yyyy-MM'
	  },
	  onOpenFocus: true,
	  showButtonBar: true,
	  placement: 'auto bottom-left'
	})
	
	.controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning',
	function($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
	  var cache = {},
	    isHtml5DateInput = false;
	  var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
	    datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, scrollParentEl,
	    ngModel, ngModelOptions, $popup, altInputFormats, watchListeners = [];
	
	  this.init = function(_ngModel_) {
	    ngModel = _ngModel_;
	    ngModelOptions = extractOptions(ngModel);
	    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
	      $scope.$parent.$eval($attrs.closeOnDateSelection) :
	      datepickerPopupConfig.closeOnDateSelection;
	    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
	      $scope.$parent.$eval($attrs.datepickerAppendToBody) :
	      datepickerPopupConfig.appendToBody;
	    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
	      $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
	    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
	      $attrs.datepickerPopupTemplateUrl :
	      datepickerPopupConfig.datepickerPopupTemplateUrl;
	    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
	      $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
	    altInputFormats = angular.isDefined($attrs.altInputFormats) ?
	      $scope.$parent.$eval($attrs.altInputFormats) :
	      datepickerPopupConfig.altInputFormats;
	
	    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
	      $scope.$parent.$eval($attrs.showButtonBar) :
	      datepickerPopupConfig.showButtonBar;
	
	    if (datepickerPopupConfig.html5Types[$attrs.type]) {
	      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
	      isHtml5DateInput = true;
	    } else {
	      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
	      $attrs.$observe('uibDatepickerPopup', function(value, oldValue) {
	        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
	        // Invalidate the $modelValue to ensure that formatters re-run
	        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
	        if (newDateFormat !== dateFormat) {
	          dateFormat = newDateFormat;
	          ngModel.$modelValue = null;
	
	          if (!dateFormat) {
	            throw new Error('uibDatepickerPopup must have a date format specified.');
	          }
	        }
	      });
	    }
	
	    if (!dateFormat) {
	      throw new Error('uibDatepickerPopup must have a date format specified.');
	    }
	
	    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
	      throw new Error('HTML5 date input types do not support custom formats.');
	    }
	
	    // popup element used to display calendar
	    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');
	
	    popupEl.attr({
	      'ng-model': 'date',
	      'ng-change': 'dateSelection(date)',
	      'template-url': datepickerPopupTemplateUrl
	    });
	
	    // datepicker element
	    datepickerEl = angular.element(popupEl.children()[0]);
	    datepickerEl.attr('template-url', datepickerTemplateUrl);
	
	    if (!$scope.datepickerOptions) {
	      $scope.datepickerOptions = {};
	    }
	
	    if (isHtml5DateInput) {
	      if ($attrs.type === 'month') {
	        $scope.datepickerOptions.datepickerMode = 'month';
	        $scope.datepickerOptions.minMode = 'month';
	      }
	    }
	
	    datepickerEl.attr('datepicker-options', 'datepickerOptions');
	
	    if (!isHtml5DateInput) {
	      // Internal API to maintain the correct ng-invalid-[key] class
	      ngModel.$$parserName = 'date';
	      ngModel.$validators.date = validator;
	      ngModel.$parsers.unshift(parseDate);
	      ngModel.$formatters.push(function(value) {
	        if (ngModel.$isEmpty(value)) {
	          $scope.date = value;
	          return value;
	        }
	
	        if (angular.isNumber(value)) {
	          value = new Date(value);
	        }
	
	        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
	
	        return dateParser.filter($scope.date, dateFormat);
	      });
	    } else {
	      ngModel.$formatters.push(function(value) {
	        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
	        return value;
	      });
	    }
	
	    // Detect changes in the view from the text box
	    ngModel.$viewChangeListeners.push(function() {
	      $scope.date = parseDateString(ngModel.$viewValue);
	    });
	
	    $element.on('keydown', inputKeydownBind);
	
	    $popup = $compile(popupEl)($scope);
	    // Prevent jQuery cache memory leak (template is now redundant after linking)
	    popupEl.remove();
	
	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else {
	      $element.after($popup);
	    }
	
	    $scope.$on('$destroy', function() {
	      if ($scope.isOpen === true) {
	        if (!$rootScope.$$phase) {
	          $scope.$apply(function() {
	            $scope.isOpen = false;
	          });
	        }
	      }
	
	      $popup.remove();
	      $element.off('keydown', inputKeydownBind);
	      $document.off('click', documentClickBind);
	      if (scrollParentEl) {
	        scrollParentEl.off('scroll', positionPopup);
	      }
	      angular.element($window).off('resize', positionPopup);
	
	      //Clear all watch listeners on destroy
	      while (watchListeners.length) {
	        watchListeners.shift()();
	      }
	    });
	  };
	
	  $scope.getText = function(key) {
	    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
	  };
	
	  $scope.isDisabled = function(date) {
	    if (date === 'today') {
	      date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
	    }
	
	    var dates = {};
	    angular.forEach(['minDate', 'maxDate'], function(key) {
	      if (!$scope.datepickerOptions[key]) {
	        dates[key] = null;
	      } else if (angular.isDate($scope.datepickerOptions[key])) {
	        dates[key] = new Date($scope.datepickerOptions[key]);
	      } else {
	        if ($datepickerPopupLiteralWarning) {
	          $log.warn('Literal date support has been deprecated, please switch to date object usage');
	        }
	
	        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
	      }
	    });
	
	    return $scope.datepickerOptions &&
	      dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
	      dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
	  };
	
	  $scope.compare = function(date1, date2) {
	    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	  };
	
	  // Inner change
	  $scope.dateSelection = function(dt) {
	    $scope.date = dt;
	    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
	    $element.val(date);
	    ngModel.$setViewValue(date);
	
	    if (closeOnDateSelection) {
	      $scope.isOpen = false;
	      $element[0].focus();
	    }
	  };
	
	  $scope.keydown = function(evt) {
	    if (evt.which === 27) {
	      evt.stopPropagation();
	      $scope.isOpen = false;
	      $element[0].focus();
	    }
	  };
	
	  $scope.select = function(date, evt) {
	    evt.stopPropagation();
	
	    if (date === 'today') {
	      var today = new Date();
	      if (angular.isDate($scope.date)) {
	        date = new Date($scope.date);
	        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
	      } else {
	        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
	        date.setHours(0, 0, 0, 0);
	      }
	    }
	    $scope.dateSelection(date);
	  };
	
	  $scope.close = function(evt) {
	    evt.stopPropagation();
	
	    $scope.isOpen = false;
	    $element[0].focus();
	  };
	
	  $scope.disabled = angular.isDefined($attrs.disabled) || false;
	  if ($attrs.ngDisabled) {
	    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(disabled) {
	      $scope.disabled = disabled;
	    }));
	  }
	
	  $scope.$watch('isOpen', function(value) {
	    if (value) {
	      if (!$scope.disabled) {
	        $timeout(function() {
	          positionPopup();
	
	          if (onOpenFocus) {
	            $scope.$broadcast('uib:datepicker.focus');
	          }
	
	          $document.on('click', documentClickBind);
	
	          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	          if (appendToBody || $position.parsePlacement(placement)[2]) {
	            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
	            if (scrollParentEl) {
	              scrollParentEl.on('scroll', positionPopup);
	            }
	          } else {
	            scrollParentEl = null;
	          }
	
	          angular.element($window).on('resize', positionPopup);
	        }, 0, false);
	      } else {
	        $scope.isOpen = false;
	      }
	    } else {
	      $document.off('click', documentClickBind);
	      if (scrollParentEl) {
	        scrollParentEl.off('scroll', positionPopup);
	      }
	      angular.element($window).off('resize', positionPopup);
	    }
	  });
	
	  function cameltoDash(string) {
	    return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
	  }
	
	  function parseDateString(viewValue) {
	    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
	    if (isNaN(date)) {
	      for (var i = 0; i < altInputFormats.length; i++) {
	        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
	        if (!isNaN(date)) {
	          return date;
	        }
	      }
	    }
	    return date;
	  }
	
	  function parseDate(viewValue) {
	    if (angular.isNumber(viewValue)) {
	      // presumably timestamp to date object
	      viewValue = new Date(viewValue);
	    }
	
	    if (!viewValue) {
	      return null;
	    }
	
	    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
	      return viewValue;
	    }
	
	    if (angular.isString(viewValue)) {
	      var date = parseDateString(viewValue);
	      if (!isNaN(date)) {
	        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
	      }
	    }
	
	    return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
	  }
	
	  function validator(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	
	    if (!$attrs.ngRequired && !value) {
	      return true;
	    }
	
	    if (angular.isNumber(value)) {
	      value = new Date(value);
	    }
	
	    if (!value) {
	      return true;
	    }
	
	    if (angular.isDate(value) && !isNaN(value)) {
	      return true;
	    }
	
	    if (angular.isString(value)) {
	      return !isNaN(parseDateString(value));
	    }
	
	    return false;
	  }
	
	  function documentClickBind(event) {
	    if (!$scope.isOpen && $scope.disabled) {
	      return;
	    }
	
	    var popup = $popup[0];
	    var dpContainsTarget = $element[0].contains(event.target);
	    // The popup node may not be an element node
	    // In some browsers (IE) only element nodes have the 'contains' function
	    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
	    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
	      $scope.$apply(function() {
	        $scope.isOpen = false;
	      });
	    }
	  }
	
	  function inputKeydownBind(evt) {
	    if (evt.which === 27 && $scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.$apply(function() {
	        $scope.isOpen = false;
	      });
	      $element[0].focus();
	    } else if (evt.which === 40 && !$scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.$apply(function() {
	        $scope.isOpen = true;
	      });
	    }
	  }
	
	  function positionPopup() {
	    if ($scope.isOpen) {
	      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
	      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	      var position = $position.positionElements($element, dpElement, placement, appendToBody);
	      dpElement.css({top: position.top + 'px', left: position.left + 'px'});
	      if (dpElement.hasClass('uib-position-measure')) {
	        dpElement.removeClass('uib-position-measure');
	      }
	    }
	  }
	
	  function extractOptions(ngModelCtrl) {
	    var ngModelOptions;
	
	    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
	      // guarantee a value
	      ngModelOptions = angular.isObject(ngModelCtrl.$options) ?
	        ngModelCtrl.$options :
	        {
	          timezone: null
	        };
	
	      // mimic 1.6+ api
	      ngModelOptions.getOption = function (key) {
	        return ngModelOptions[key];
	      };
	    } else { // in angular >=1.6 $options is always present
	      ngModelOptions = ngModelCtrl.$options;
	    }
	
	    return ngModelOptions;
	  }
	
	  $scope.$on('uib:datepicker.mode', function() {
	    $timeout(positionPopup, 0, false);
	  });
	}])
	
	.directive('uibDatepickerPopup', function() {
	  return {
	    require: ['ngModel', 'uibDatepickerPopup'],
	    controller: 'UibDatepickerPopupController',
	    scope: {
	      datepickerOptions: '=?',
	      isOpen: '=?',
	      currentText: '@',
	      clearText: '@',
	      closeText: '@'
	    },
	    link: function(scope, element, attrs, ctrls) {
	      var ngModel = ctrls[0],
	        ctrl = ctrls[1];
	
	      ctrl.init(ngModel);
	    }
	  };
	})
	
	.directive('uibDatepickerPopupWrap', function() {
	  return {
	    restrict: 'A',
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
	    }
	  };
	});
	
	angular.module('ui.bootstrap.debounce', [])
	/**
	 * A helper, internal service that debounces a function
	 */
	  .factory('$$debounce', ['$timeout', function($timeout) {
	    return function(callback, debounceTime) {
	      var timeoutPromise;
	
	      return function() {
	        var self = this;
	        var args = Array.prototype.slice.call(arguments);
	        if (timeoutPromise) {
	          $timeout.cancel(timeoutPromise);
	        }
	
	        timeoutPromise = $timeout(function() {
	          callback.apply(self, args);
	        }, debounceTime);
	      };
	    };
	  }]);
	
	angular.module('ui.bootstrap.multiMap', [])
	/**
	 * A helper, internal data structure that stores all references attached to key
	 */
	  .factory('$$multiMap', function() {
	    return {
	      createNew: function() {
	        var map = {};
	
	        return {
	          entries: function() {
	            return Object.keys(map).map(function(key) {
	              return {
	                key: key,
	                value: map[key]
	              };
	            });
	          },
	          get: function(key) {
	            return map[key];
	          },
	          hasKey: function(key) {
	            return !!map[key];
	          },
	          keys: function() {
	            return Object.keys(map);
	          },
	          put: function(key, value) {
	            if (!map[key]) {
	              map[key] = [];
	            }
	
	            map[key].push(value);
	          },
	          remove: function(key, value) {
	            var values = map[key];
	
	            if (!values) {
	              return;
	            }
	
	            var idx = values.indexOf(value);
	
	            if (idx !== -1) {
	              values.splice(idx, 1);
	            }
	
	            if (!values.length) {
	              delete map[key];
	            }
	          }
	        };
	      }
	    };
	  });
	
	angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position'])
	
	.constant('uibDropdownConfig', {
	  appendToOpenClass: 'uib-dropdown-open',
	  openClass: 'open'
	})
	
	.service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function($document, $rootScope, $$multiMap) {
	  var openScope = null;
	  var openedContainers = $$multiMap.createNew();
	
	  this.isOnlyOpen = function(dropdownScope, appendTo) {
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var openDropdown = openedDropdowns.reduce(function(toClose, dropdown) {
	        if (dropdown.scope === dropdownScope) {
	          return dropdown;
	        }
	
	        return toClose;
	      }, {});
	      if (openDropdown) {
	        return openedDropdowns.length === 1;
	      }
	    }
	
	    return false;
	  };
	
	  this.open = function(dropdownScope, element, appendTo) {
	    if (!openScope) {
	      $document.on('click', closeDropdown);
	    }
	
	    if (openScope && openScope !== dropdownScope) {
	      openScope.isOpen = false;
	    }
	
	    openScope = dropdownScope;
	
	    if (!appendTo) {
	      return;
	    }
	
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var openedScopes = openedDropdowns.map(function(dropdown) {
	        return dropdown.scope;
	      });
	      if (openedScopes.indexOf(dropdownScope) === -1) {
	        openedContainers.put(appendTo, {
	          scope: dropdownScope
	        });
	      }
	    } else {
	      openedContainers.put(appendTo, {
	        scope: dropdownScope
	      });
	    }
	  };
	
	  this.close = function(dropdownScope, element, appendTo) {
	    if (openScope === dropdownScope) {
	      $document.off('click', closeDropdown);
	      $document.off('keydown', this.keybindFilter);
	      openScope = null;
	    }
	
	    if (!appendTo) {
	      return;
	    }
	
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var dropdownToClose = openedDropdowns.reduce(function(toClose, dropdown) {
	        if (dropdown.scope === dropdownScope) {
	          return dropdown;
	        }
	
	        return toClose;
	      }, {});
	      if (dropdownToClose) {
	        openedContainers.remove(appendTo, dropdownToClose);
	      }
	    }
	  };
	
	  var closeDropdown = function(evt) {
	    // This method may still be called during the same mouse event that
	    // unbound this event handler. So check openScope before proceeding.
	    if (!openScope || !openScope.isOpen) { return; }
	
	    if (evt && openScope.getAutoClose() === 'disabled') { return; }
	
	    if (evt && evt.which === 3) { return; }
	
	    var toggleElement = openScope.getToggleElement();
	    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    if (evt && openScope.getAutoClose() === 'outsideClick' &&
	      dropdownElement && dropdownElement[0].contains(evt.target)) {
	      return;
	    }
	
	    openScope.focusToggleElement();
	    openScope.isOpen = false;
	
	    if (!$rootScope.$$phase) {
	      openScope.$apply();
	    }
	  };
	
	  this.keybindFilter = function(evt) {
	    if (!openScope) {
	      // see this.close as ESC could have been pressed which kills the scope so we can not proceed
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    var toggleElement = openScope.getToggleElement();
	    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
	    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
	    if (evt.which === 27) {
	      evt.stopPropagation();
	      openScope.focusToggleElement();
	      closeDropdown();
	    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      openScope.focusDropdownEntry(evt.which);
	    }
	  };
	}])
	
	.controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
	  var self = this,
	    scope = $scope.$new(), // create a child scope so we are not polluting original one
	    templateScope,
	    appendToOpenClass = dropdownConfig.appendToOpenClass,
	    openClass = dropdownConfig.openClass,
	    getIsOpen,
	    setIsOpen = angular.noop,
	    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
	    keynavEnabled = false,
	    selectedOption = null,
	    body = $document.find('body');
	
	  $element.addClass('dropdown');
	
	  this.init = function() {
	    if ($attrs.isOpen) {
	      getIsOpen = $parse($attrs.isOpen);
	      setIsOpen = getIsOpen.assign;
	
	      $scope.$watch(getIsOpen, function(value) {
	        scope.isOpen = !!value;
	      });
	    }
	
	    keynavEnabled = angular.isDefined($attrs.keyboardNav);
	  };
	
	  this.toggle = function(open) {
	    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen(scope, scope.isOpen);
	    }
	
	    return scope.isOpen;
	  };
	
	  // Allow other directives to watch status
	  this.isOpen = function() {
	    return scope.isOpen;
	  };
	
	  scope.getToggleElement = function() {
	    return self.toggleElement;
	  };
	
	  scope.getAutoClose = function() {
	    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
	  };
	
	  scope.getElement = function() {
	    return $element;
	  };
	
	  scope.isKeynavEnabled = function() {
	    return keynavEnabled;
	  };
	
	  scope.focusDropdownEntry = function(keyCode) {
	    var elems = self.dropdownMenu ? //If append to body is used.
	      angular.element(self.dropdownMenu).find('a') :
	      $element.find('ul').eq(0).find('a');
	
	    switch (keyCode) {
	      case 40: {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = 0;
	        } else {
	          self.selectedOption = self.selectedOption === elems.length - 1 ?
	            self.selectedOption :
	            self.selectedOption + 1;
	        }
	        break;
	      }
	      case 38: {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = elems.length - 1;
	        } else {
	          self.selectedOption = self.selectedOption === 0 ?
	            0 : self.selectedOption - 1;
	        }
	        break;
	      }
	    }
	    elems[self.selectedOption].focus();
	  };
	
	  scope.getDropdownElement = function() {
	    return self.dropdownMenu;
	  };
	
	  scope.focusToggleElement = function() {
	    if (self.toggleElement) {
	      self.toggleElement[0].focus();
	    }
	  };
	
	  function removeDropdownMenu() {
	    $element.append(self.dropdownMenu);
	  }
	
	  scope.$watch('isOpen', function(isOpen, wasOpen) {
	    var appendTo = null,
	      appendToBody = false;
	
	    if (angular.isDefined($attrs.dropdownAppendTo)) {
	      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
	      if (appendToEl) {
	        appendTo = angular.element(appendToEl);
	      }
	    }
	
	    if (angular.isDefined($attrs.dropdownAppendToBody)) {
	      var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
	      if (appendToBodyValue !== false) {
	        appendToBody = true;
	      }
	    }
	
	    if (appendToBody && !appendTo) {
	      appendTo = body;
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      if (isOpen) {
	        appendTo.append(self.dropdownMenu);
	        $element.on('$destroy', removeDropdownMenu);
	      } else {
	        $element.off('$destroy', removeDropdownMenu);
	        removeDropdownMenu();
	      }
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
	        css,
	        rightalign,
	        scrollbarPadding,
	        scrollbarWidth = 0;
	
	      css = {
	        top: pos.top + 'px',
	        display: isOpen ? 'block' : 'none'
	      };
	
	      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
	      if (!rightalign) {
	        css.left = pos.left + 'px';
	        css.right = 'auto';
	      } else {
	        css.left = 'auto';
	        scrollbarPadding = $position.scrollbarPadding(appendTo);
	
	        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	          scrollbarWidth = scrollbarPadding.scrollbarWidth;
	        }
	
	        css.right = window.innerWidth - scrollbarWidth -
	          (pos.left + $element.prop('offsetWidth')) + 'px';
	      }
	
	      // Need to adjust our positioning to be relative to the appendTo container
	      // if it's not the body element
	      if (!appendToBody) {
	        var appendOffset = $position.offset(appendTo);
	
	        css.top = pos.top - appendOffset.top + 'px';
	
	        if (!rightalign) {
	          css.left = pos.left - appendOffset.left + 'px';
	        } else {
	          css.right = window.innerWidth -
	            (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
	        }
	      }
	
	      self.dropdownMenu.css(css);
	    }
	
	    var openContainer = appendTo ? appendTo : $element;
	    var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
	    var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
	    var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);
	
	    if (hasOpenClass === !isOpen) {
	      var toggleClass;
	      if (appendTo) {
	        toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
	      } else {
	        toggleClass = isOpen ? 'addClass' : 'removeClass';
	      }
	      $animate[toggleClass](openContainer, dropdownOpenClass).then(function() {
	        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	          toggleInvoker($scope, { open: !!isOpen });
	        }
	      });
	    }
	
	    if (isOpen) {
	      if (self.dropdownMenuTemplateUrl) {
	        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
	          templateScope = scope.$new();
	          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
	            var newEl = dropdownElement;
	            self.dropdownMenu.replaceWith(newEl);
	            self.dropdownMenu = newEl;
	            $document.on('keydown', uibDropdownService.keybindFilter);
	          });
	        });
	      } else {
	        $document.on('keydown', uibDropdownService.keybindFilter);
	      }
	
	      scope.focusToggleElement();
	      uibDropdownService.open(scope, $element, appendTo);
	    } else {
	      uibDropdownService.close(scope, $element, appendTo);
	      if (self.dropdownMenuTemplateUrl) {
	        if (templateScope) {
	          templateScope.$destroy();
	        }
	        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
	        self.dropdownMenu.replaceWith(newEl);
	        self.dropdownMenu = newEl;
	      }
	
	      self.selectedOption = null;
	    }
	
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen($scope, isOpen);
	    }
	  });
	}])
	
	.directive('uibDropdown', function() {
	  return {
	    controller: 'UibDropdownController',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      dropdownCtrl.init();
	    }
	  };
	})
	
	.directive('uibDropdownMenu', function() {
	  return {
	    restrict: 'A',
	    require: '?^uibDropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
	        return;
	      }
	
	      element.addClass('dropdown-menu');
	
	      var tplUrl = attrs.templateUrl;
	      if (tplUrl) {
	        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
	      }
	
	      if (!dropdownCtrl.dropdownMenu) {
	        dropdownCtrl.dropdownMenu = element;
	      }
	    }
	  };
	})
	
	.directive('uibDropdownToggle', function() {
	  return {
	    require: '?^uibDropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl) {
	        return;
	      }
	
	      element.addClass('dropdown-toggle');
	
	      dropdownCtrl.toggleElement = element;
	
	      var toggleDropdown = function(event) {
	        event.preventDefault();
	
	        if (!element.hasClass('disabled') && !attrs.disabled) {
	          scope.$apply(function() {
	            dropdownCtrl.toggle();
	          });
	        }
	      };
	
	      element.on('click', toggleDropdown);
	
	      // WAI-ARIA
	      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
	        element.attr('aria-expanded', !!isOpen);
	      });
	
	      scope.$on('$destroy', function() {
	        element.off('click', toggleDropdown);
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.stackedMap', [])
	/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */
	  .factory('$$stackedMap', function() {
	    return {
	      createNew: function() {
	        var stack = [];
	
	        return {
	          add: function(key, value) {
	            stack.push({
	              key: key,
	              value: value
	            });
	          },
	          get: function(key) {
	            for (var i = 0; i < stack.length; i++) {
	              if (key === stack[i].key) {
	                return stack[i];
	              }
	            }
	          },
	          keys: function() {
	            var keys = [];
	            for (var i = 0; i < stack.length; i++) {
	              keys.push(stack[i].key);
	            }
	            return keys;
	          },
	          top: function() {
	            return stack[stack.length - 1];
	          },
	          remove: function(key) {
	            var idx = -1;
	            for (var i = 0; i < stack.length; i++) {
	              if (key === stack[i].key) {
	                idx = i;
	                break;
	              }
	            }
	            return stack.splice(idx, 1)[0];
	          },
	          removeTop: function() {
	            return stack.pop();
	          },
	          length: function() {
	            return stack.length;
	          }
	        };
	      }
	    };
	  });
	angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
	/**
	 * Pluggable resolve mechanism for the modal resolve resolution
	 * Supports UI Router's $resolve service
	 */
	  .provider('$uibResolve', function() {
	    var resolve = this;
	    this.resolver = null;
	
	    this.setResolver = function(resolver) {
	      this.resolver = resolver;
	    };
	
	    this.$get = ['$injector', '$q', function($injector, $q) {
	      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
	      return {
	        resolve: function(invocables, locals, parent, self) {
	          if (resolver) {
	            return resolver.resolve(invocables, locals, parent, self);
	          }
	
	          var promises = [];
	
	          angular.forEach(invocables, function(value) {
	            if (angular.isFunction(value) || angular.isArray(value)) {
	              promises.push($q.resolve($injector.invoke(value)));
	            } else if (angular.isString(value)) {
	              promises.push($q.resolve($injector.get(value)));
	            } else {
	              promises.push($q.resolve(value));
	            }
	          });
	
	          return $q.all(promises).then(function(resolves) {
	            var resolveObj = {};
	            var resolveIter = 0;
	            angular.forEach(invocables, function(value, key) {
	              resolveObj[key] = resolves[resolveIter++];
	            });
	
	            return resolveObj;
	          });
	        }
	      };
	    }];
	  })
	
	/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */
	  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
	  function($animate, $injector, $modalStack) {
	    return {
	      restrict: 'A',
	      compile: function(tElement, tAttrs) {
	        tElement.addClass(tAttrs.backdropClass);
	        return linkFn;
	      }
	    };
	
	    function linkFn(scope, element, attrs) {
	      if (attrs.modalInClass) {
	        $animate.addClass(element, attrs.modalInClass);
	
	        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	          var done = setIsAsync();
	          if (scope.modalOptions.animation) {
	            $animate.removeClass(element, attrs.modalInClass).then(done);
	          } else {
	            done();
	          }
	        });
	      }
	    }
	  }])
	
	  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
	  function($modalStack, $q, $animateCss, $document) {
	    return {
	      scope: {
	        index: '@'
	      },
	      restrict: 'A',
	      transclude: true,
	      templateUrl: function(tElement, tAttrs) {
	        return tAttrs.templateUrl || 'uib/template/modal/window.html';
	      },
	      link: function(scope, element, attrs) {
	        element.addClass(attrs.windowTopClass || '');
	        scope.size = attrs.size;
	
	        scope.close = function(evt) {
	          var modal = $modalStack.getTop();
	          if (modal && modal.value.backdrop &&
	            modal.value.backdrop !== 'static' &&
	            evt.target === evt.currentTarget) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            $modalStack.dismiss(modal.key, 'backdrop click');
	          }
	        };
	
	        // moved from template to fix issue #2280
	        element.on('click', scope.close);
	
	        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	        // We can detect that by using this property in the template associated with this directive and then use
	        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	        scope.$isRendered = true;
	
	        // Deferred object that will be resolved when this modal is rendered.
	        var modalRenderDeferObj = $q.defer();
	        // Resolve render promise post-digest
	        scope.$$postDigest(function() {
	          modalRenderDeferObj.resolve();
	        });
	
	        modalRenderDeferObj.promise.then(function() {
	          var animationPromise = null;
	
	          if (attrs.modalInClass) {
	            animationPromise = $animateCss(element, {
	              addClass: attrs.modalInClass
	            }).start();
	
	            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	              var done = setIsAsync();
	              $animateCss(element, {
	                removeClass: attrs.modalInClass
	              }).start().then(done);
	            });
	          }
	
	
	          $q.when(animationPromise).then(function() {
	            // Notify {@link $modalStack} that modal is rendered.
	            var modal = $modalStack.getTop();
	            if (modal) {
	              $modalStack.modalRendered(modal.key);
	            }
	
	            /**
	             * If something within the freshly-opened modal already has focus (perhaps via a
	             * directive that causes focus) then there's no need to try to focus anything.
	             */
	            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
	              var inputWithAutofocus = element[0].querySelector('[autofocus]');
	              /**
	               * Auto-focusing of a freshly-opened modal element causes any child elements
	               * with the autofocus attribute to lose focus. This is an issue on touch
	               * based devices which will show and then hide the onscreen keyboard.
	               * Attempts to refocus the autofocus element via JavaScript will not reopen
	               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	               * the modal element if the modal does not contain an autofocus element.
	               */
	              if (inputWithAutofocus) {
	                inputWithAutofocus.focus();
	              } else {
	                element[0].focus();
	              }
	            }
	          });
	        });
	      }
	    };
	  }])
	
	  .directive('uibModalAnimationClass', function() {
	    return {
	      compile: function(tElement, tAttrs) {
	        if (tAttrs.modalAnimation) {
	          tElement.addClass(tAttrs.uibModalAnimationClass);
	        }
	      }
	    };
	  })
	
	  .directive('uibModalTransclude', ['$animate', function($animate) {
	    return {
	      link: function(scope, element, attrs, controller, transclude) {
	        transclude(scope.$parent, function(clone) {
	          element.empty();
	          $animate.enter(clone, element);
	        });
	      }
	    };
	  }])
	
	  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
	    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
	    function($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
	      var OPENED_MODAL_CLASS = 'modal-open';
	
	      var backdropDomEl, backdropScope;
	      var openedWindows = $$stackedMap.createNew();
	      var openedClasses = $$multiMap.createNew();
	      var $modalStack = {
	        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
	      };
	      var topModalIndex = 0;
	      var previousTopOpenedModal = null;
	      var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';
	
	      //Modal focus behavior
	      var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
	        'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
	        'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
	      var scrollbarPadding;
	      var SNAKE_CASE_REGEXP = /[A-Z]/g;
	
	      // TODO: extract into common dependency with tooltip
	      function snake_case(name) {
	        var separator = '-';
	        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	          return (pos ? separator : '') + letter.toLowerCase();
	        });
	      }
	
	      function isVisible(element) {
	        return !!(element.offsetWidth ||
	          element.offsetHeight ||
	          element.getClientRects().length);
	      }
	
	      function backdropIndex() {
	        var topBackdropIndex = -1;
	        var opened = openedWindows.keys();
	        for (var i = 0; i < opened.length; i++) {
	          if (openedWindows.get(opened[i]).value.backdrop) {
	            topBackdropIndex = i;
	          }
	        }
	
	        // If any backdrop exist, ensure that it's index is always
	        // right below the top modal
	        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
	          topBackdropIndex = topModalIndex;
	        }
	        return topBackdropIndex;
	      }
	
	      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
	        if (backdropScope) {
	          backdropScope.index = newBackdropIndex;
	        }
	      });
	
	      function removeModalWindow(modalInstance, elementToReceiveFocus) {
	        var modalWindow = openedWindows.get(modalInstance).value;
	        var appendToElement = modalWindow.appendTo;
	
	        //clean up the stack
	        openedWindows.remove(modalInstance);
	        previousTopOpenedModal = openedWindows.top();
	        if (previousTopOpenedModal) {
	          topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
	        }
	
	        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
	          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
	          openedClasses.remove(modalBodyClass, modalInstance);
	          var areAnyOpen = openedClasses.hasKey(modalBodyClass);
	          appendToElement.toggleClass(modalBodyClass, areAnyOpen);
	          if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	            if (scrollbarPadding.originalRight) {
	              appendToElement.css({paddingRight: scrollbarPadding.originalRight + 'px'});
	            } else {
	              appendToElement.css({paddingRight: ''});
	            }
	            scrollbarPadding = null;
	          }
	          toggleTopWindowClass(true);
	        }, modalWindow.closedDeferred);
	        checkRemoveBackdrop();
	
	        //move focus to specified element if available, or else to body
	        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
	          elementToReceiveFocus.focus();
	        } else if (appendToElement.focus) {
	          appendToElement.focus();
	        }
	      }
	
	      // Add or remove "windowTopClass" from the top window in the stack
	      function toggleTopWindowClass(toggleSwitch) {
	        var modalWindow;
	
	        if (openedWindows.length() > 0) {
	          modalWindow = openedWindows.top().value;
	          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
	        }
	      }
	
	      function checkRemoveBackdrop() {
	        //remove backdrop if no longer needed
	        if (backdropDomEl && backdropIndex() === -1) {
	          var backdropScopeRef = backdropScope;
	          removeAfterAnimate(backdropDomEl, backdropScope, function() {
	            backdropScopeRef = null;
	          });
	          backdropDomEl = undefined;
	          backdropScope = undefined;
	        }
	      }
	
	      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
	        var asyncDeferred;
	        var asyncPromise = null;
	        var setIsAsync = function() {
	          if (!asyncDeferred) {
	            asyncDeferred = $q.defer();
	            asyncPromise = asyncDeferred.promise;
	          }
	
	          return function asyncDone() {
	            asyncDeferred.resolve();
	          };
	        };
	        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);
	
	        // Note that it's intentional that asyncPromise might be null.
	        // That's when setIsAsync has not been called during the
	        // NOW_CLOSING_EVENT broadcast.
	        return $q.when(asyncPromise).then(afterAnimating);
	
	        function afterAnimating() {
	          if (afterAnimating.done) {
	            return;
	          }
	          afterAnimating.done = true;
	
	          $animate.leave(domEl).then(function() {
	            if (done) {
	              done();
	            }
	
	            domEl.remove();
	            if (closedDeferred) {
	              closedDeferred.resolve();
	            }
	          });
	
	          scope.$destroy();
	        }
	      }
	
	      $document.on('keydown', keydownListener);
	
	      $rootScope.$on('$destroy', function() {
	        $document.off('keydown', keydownListener);
	      });
	
	      function keydownListener(evt) {
	        if (evt.isDefaultPrevented()) {
	          return evt;
	        }
	
	        var modal = openedWindows.top();
	        if (modal) {
	          switch (evt.which) {
	            case 27: {
	              if (modal.value.keyboard) {
	                evt.preventDefault();
	                $rootScope.$apply(function() {
	                  $modalStack.dismiss(modal.key, 'escape key press');
	                });
	              }
	              break;
	            }
	            case 9: {
	              var list = $modalStack.loadFocusElementList(modal);
	              var focusChanged = false;
	              if (evt.shiftKey) {
	                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
	                  focusChanged = $modalStack.focusLastFocusableElement(list);
	                }
	              } else {
	                if ($modalStack.isFocusInLastItem(evt, list)) {
	                  focusChanged = $modalStack.focusFirstFocusableElement(list);
	                }
	              }
	
	              if (focusChanged) {
	                evt.preventDefault();
	                evt.stopPropagation();
	              }
	
	              break;
	            }
	          }
	        }
	      }
	
	      $modalStack.open = function(modalInstance, modal) {
	        var modalOpener = $document[0].activeElement,
	          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;
	
	        toggleTopWindowClass(false);
	
	        // Store the current top first, to determine what index we ought to use
	        // for the current top modal
	        previousTopOpenedModal = openedWindows.top();
	
	        openedWindows.add(modalInstance, {
	          deferred: modal.deferred,
	          renderDeferred: modal.renderDeferred,
	          closedDeferred: modal.closedDeferred,
	          modalScope: modal.scope,
	          backdrop: modal.backdrop,
	          keyboard: modal.keyboard,
	          openedClass: modal.openedClass,
	          windowTopClass: modal.windowTopClass,
	          animation: modal.animation,
	          appendTo: modal.appendTo
	        });
	
	        openedClasses.put(modalBodyClass, modalInstance);
	
	        var appendToElement = modal.appendTo,
	            currBackdropIndex = backdropIndex();
	
	        if (currBackdropIndex >= 0 && !backdropDomEl) {
	          backdropScope = $rootScope.$new(true);
	          backdropScope.modalOptions = modal;
	          backdropScope.index = currBackdropIndex;
	          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
	          backdropDomEl.attr({
	            'class': 'modal-backdrop',
	            'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
	            'uib-modal-animation-class': 'fade',
	            'modal-in-class': 'in'
	          });
	          if (modal.backdropClass) {
	            backdropDomEl.addClass(modal.backdropClass);
	          }
	
	          if (modal.animation) {
	            backdropDomEl.attr('modal-animation', 'true');
	          }
	          $compile(backdropDomEl)(backdropScope);
	          $animate.enter(backdropDomEl, appendToElement);
	          if ($uibPosition.isScrollable(appendToElement)) {
	            scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
	            if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	              appendToElement.css({paddingRight: scrollbarPadding.right + 'px'});
	            }
	          }
	        }
	
	        var content;
	        if (modal.component) {
	          content = document.createElement(snake_case(modal.component.name));
	          content = angular.element(content);
	          content.attr({
	            resolve: '$resolve',
	            'modal-instance': '$uibModalInstance',
	            close: '$close($value)',
	            dismiss: '$dismiss($value)'
	          });
	        } else {
	          content = modal.content;
	        }
	
	        // Set the top modal index based on the index of the previous top modal
	        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
	        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
	        angularDomEl.attr({
	          'class': 'modal',
	          'template-url': modal.windowTemplateUrl,
	          'window-top-class': modal.windowTopClass,
	          'role': 'dialog',
	          'aria-labelledby': modal.ariaLabelledBy,
	          'aria-describedby': modal.ariaDescribedBy,
	          'size': modal.size,
	          'index': topModalIndex,
	          'animate': 'animate',
	          'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
	          'tabindex': -1,
	          'uib-modal-animation-class': 'fade',
	          'modal-in-class': 'in'
	        }).append(content);
	        if (modal.windowClass) {
	          angularDomEl.addClass(modal.windowClass);
	        }
	
	        if (modal.animation) {
	          angularDomEl.attr('modal-animation', 'true');
	        }
	
	        appendToElement.addClass(modalBodyClass);
	        if (modal.scope) {
	          // we need to explicitly add the modal index to the modal scope
	          // because it is needed by ngStyle to compute the zIndex property.
	          modal.scope.$$topModalIndex = topModalIndex;
	        }
	        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);
	
	        openedWindows.top().value.modalDomEl = angularDomEl;
	        openedWindows.top().value.modalOpener = modalOpener;
	
	        applyAriaHidden(angularDomEl);
	
	        function applyAriaHidden(el) {
	          if (!el || el[0].tagName === 'BODY') {
	            return;
	          }
	
	          getSiblings(el).forEach(function(sibling) {
	            var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
	              ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);
	
	            if (!ariaHiddenCount) {
	              ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
	            }
	
	            sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
	            sibling.setAttribute('aria-hidden', 'true');
	          });
	
	          return applyAriaHidden(el.parent());
	
	          function getSiblings(el) {
	            var children = el.parent() ? el.parent().children() : [];
	
	            return Array.prototype.filter.call(children, function(child) {
	              return child !== el[0];
	            });
	          }
	        }
	      };
	
	      function broadcastClosing(modalWindow, resultOrReason, closing) {
	        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
	      }
	
	      function unhideBackgroundElements() {
	        Array.prototype.forEach.call(
	          document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
	          function(hiddenEl) {
	            var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
	              newHiddenCount = ariaHiddenCount - 1;
	            hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);
	
	            if (!newHiddenCount) {
	              hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
	              hiddenEl.removeAttribute('aria-hidden');
	            }
	          }
	        );
	      }
	
	      $modalStack.close = function(modalInstance, result) {
	        var modalWindow = openedWindows.get(modalInstance);
	        unhideBackgroundElements();
	        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.resolve(result);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	
	        return !modalWindow;
	      };
	
	      $modalStack.dismiss = function(modalInstance, reason) {
	        var modalWindow = openedWindows.get(modalInstance);
	        unhideBackgroundElements();
	        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.reject(reason);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	        return !modalWindow;
	      };
	
	      $modalStack.dismissAll = function(reason) {
	        var topModal = this.getTop();
	        while (topModal && this.dismiss(topModal.key, reason)) {
	          topModal = this.getTop();
	        }
	      };
	
	      $modalStack.getTop = function() {
	        return openedWindows.top();
	      };
	
	      $modalStack.modalRendered = function(modalInstance) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow) {
	          modalWindow.value.renderDeferred.resolve();
	        }
	      };
	
	      $modalStack.focusFirstFocusableElement = function(list) {
	        if (list.length > 0) {
	          list[0].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.focusLastFocusableElement = function(list) {
	        if (list.length > 0) {
	          list[list.length - 1].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.isModalFocused = function(evt, modalWindow) {
	        if (evt && modalWindow) {
	          var modalDomEl = modalWindow.value.modalDomEl;
	          if (modalDomEl && modalDomEl.length) {
	            return (evt.target || evt.srcElement) === modalDomEl[0];
	          }
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInFirstItem = function(evt, list) {
	        if (list.length > 0) {
	          return (evt.target || evt.srcElement) === list[0];
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInLastItem = function(evt, list) {
	        if (list.length > 0) {
	          return (evt.target || evt.srcElement) === list[list.length - 1];
	        }
	        return false;
	      };
	
	      $modalStack.loadFocusElementList = function(modalWindow) {
	        if (modalWindow) {
	          var modalDomE1 = modalWindow.value.modalDomEl;
	          if (modalDomE1 && modalDomE1.length) {
	            var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
	            return elements ?
	              Array.prototype.filter.call(elements, function(element) {
	                return isVisible(element);
	              }) : elements;
	          }
	        }
	      };
	
	      return $modalStack;
	    }])
	
	  .provider('$uibModal', function() {
	    var $modalProvider = {
	      options: {
	        animation: true,
	        backdrop: true, //can also be false or 'static'
	        keyboard: true
	      },
	      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
	        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
	          var $modal = {};
	
	          function getTemplatePromise(options) {
	            return options.template ? $q.when(options.template) :
	              $templateRequest(angular.isFunction(options.templateUrl) ?
	                options.templateUrl() : options.templateUrl);
	          }
	
	          var promiseChain = null;
	          $modal.getPromiseChain = function() {
	            return promiseChain;
	          };
	
	          $modal.open = function(modalOptions) {
	            var modalResultDeferred = $q.defer();
	            var modalOpenedDeferred = $q.defer();
	            var modalClosedDeferred = $q.defer();
	            var modalRenderDeferred = $q.defer();
	
	            //prepare an instance of a modal to be injected into controllers and returned to a caller
	            var modalInstance = {
	              result: modalResultDeferred.promise,
	              opened: modalOpenedDeferred.promise,
	              closed: modalClosedDeferred.promise,
	              rendered: modalRenderDeferred.promise,
	              close: function (result) {
	                return $modalStack.close(modalInstance, result);
	              },
	              dismiss: function (reason) {
	                return $modalStack.dismiss(modalInstance, reason);
	              }
	            };
	
	            //merge and clean up options
	            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	            modalOptions.resolve = modalOptions.resolve || {};
	            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);
	
	            if (!modalOptions.appendTo.length) {
	              throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
	            }
	
	            //verify options
	            if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
	              throw new Error('One of component or template or templateUrl options is required.');
	            }
	
	            var templateAndResolvePromise;
	            if (modalOptions.component) {
	              templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
	            } else {
	              templateAndResolvePromise =
	                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
	            }
	
	            function resolveWithTemplate() {
	              return templateAndResolvePromise;
	            }
	
	            // Wait for the resolution of the existing promise chain.
	            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	            // Then add to $modalStack and resolve opened.
	            // Finally clean up the chain variable if no subsequent modal has overwritten it.
	            var samePromise;
	            samePromise = promiseChain = $q.all([promiseChain])
	              .then(resolveWithTemplate, resolveWithTemplate)
	              .then(function resolveSuccess(tplAndVars) {
	                var providedScope = modalOptions.scope || $rootScope;
	
	                var modalScope = providedScope.$new();
	                modalScope.$close = modalInstance.close;
	                modalScope.$dismiss = modalInstance.dismiss;
	
	                modalScope.$on('$destroy', function() {
	                  if (!modalScope.$$uibDestructionScheduled) {
	                    modalScope.$dismiss('$uibUnscheduledDestruction');
	                  }
	                });
	
	                var modal = {
	                  scope: modalScope,
	                  deferred: modalResultDeferred,
	                  renderDeferred: modalRenderDeferred,
	                  closedDeferred: modalClosedDeferred,
	                  animation: modalOptions.animation,
	                  backdrop: modalOptions.backdrop,
	                  keyboard: modalOptions.keyboard,
	                  backdropClass: modalOptions.backdropClass,
	                  windowTopClass: modalOptions.windowTopClass,
	                  windowClass: modalOptions.windowClass,
	                  windowTemplateUrl: modalOptions.windowTemplateUrl,
	                  ariaLabelledBy: modalOptions.ariaLabelledBy,
	                  ariaDescribedBy: modalOptions.ariaDescribedBy,
	                  size: modalOptions.size,
	                  openedClass: modalOptions.openedClass,
	                  appendTo: modalOptions.appendTo
	                };
	
	                var component = {};
	                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};
	
	                if (modalOptions.component) {
	                  constructLocals(component, false, true, false);
	                  component.name = modalOptions.component;
	                  modal.component = component;
	                } else if (modalOptions.controller) {
	                  constructLocals(ctrlLocals, true, false, true);
	
	                  // the third param will make the controller instantiate later,private api
	                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
	                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
	                  if (modalOptions.controllerAs && modalOptions.bindToController) {
	                    ctrlInstance = ctrlInstantiate.instance;
	                    ctrlInstance.$close = modalScope.$close;
	                    ctrlInstance.$dismiss = modalScope.$dismiss;
	                    angular.extend(ctrlInstance, {
	                      $resolve: ctrlLocals.$scope.$resolve
	                    }, providedScope);
	                  }
	
	                  ctrlInstance = ctrlInstantiate();
	
	                  if (angular.isFunction(ctrlInstance.$onInit)) {
	                    ctrlInstance.$onInit();
	                  }
	                }
	
	                if (!modalOptions.component) {
	                  modal.content = tplAndVars[0];
	                }
	
	                $modalStack.open(modalInstance, modal);
	                modalOpenedDeferred.resolve(true);
	
	                function constructLocals(obj, template, instanceOnScope, injectable) {
	                  obj.$scope = modalScope;
	                  obj.$scope.$resolve = {};
	                  if (instanceOnScope) {
	                    obj.$scope.$uibModalInstance = modalInstance;
	                  } else {
	                    obj.$uibModalInstance = modalInstance;
	                  }
	
	                  var resolves = template ? tplAndVars[1] : tplAndVars;
	                  angular.forEach(resolves, function(value, key) {
	                    if (injectable) {
	                      obj[key] = value;
	                    }
	
	                    obj.$scope.$resolve[key] = value;
	                  });
	                }
	            }, function resolveError(reason) {
	              modalOpenedDeferred.reject(reason);
	              modalResultDeferred.reject(reason);
	            })['finally'](function() {
	              if (promiseChain === samePromise) {
	                promiseChain = null;
	              }
	            });
	
	            return modalInstance;
	          };
	
	          return $modal;
	        }
	      ]
	    };
	
	    return $modalProvider;
	  });
	
	angular.module('ui.bootstrap.paging', [])
	/**
	 * Helper internal service for generating common controller code between the
	 * pager and pagination components
	 */
	.factory('uibPaging', ['$parse', function($parse) {
	  return {
	    create: function(ctrl, $scope, $attrs) {
	      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
	      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
	      ctrl._watchers = [];
	
	      ctrl.init = function(ngModelCtrl, config) {
	        ctrl.ngModelCtrl = ngModelCtrl;
	        ctrl.config = config;
	
	        ngModelCtrl.$render = function() {
	          ctrl.render();
	        };
	
	        if ($attrs.itemsPerPage) {
	          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function(value) {
	            ctrl.itemsPerPage = parseInt(value, 10);
	            $scope.totalPages = ctrl.calculateTotalPages();
	            ctrl.updatePage();
	          }));
	        } else {
	          ctrl.itemsPerPage = config.itemsPerPage;
	        }
	
	        $scope.$watch('totalItems', function(newTotal, oldTotal) {
	          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
	            $scope.totalPages = ctrl.calculateTotalPages();
	            ctrl.updatePage();
	          }
	        });
	      };
	
	      ctrl.calculateTotalPages = function() {
	        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
	        return Math.max(totalPages || 0, 1);
	      };
	
	      ctrl.render = function() {
	        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
	      };
	
	      $scope.selectPage = function(page, evt) {
	        if (evt) {
	          evt.preventDefault();
	        }
	
	        var clickAllowed = !$scope.ngDisabled || !evt;
	        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
	          if (evt && evt.target) {
	            evt.target.blur();
	          }
	          ctrl.ngModelCtrl.$setViewValue(page);
	          ctrl.ngModelCtrl.$render();
	        }
	      };
	
	      $scope.getText = function(key) {
	        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
	      };
	
	      $scope.noPrevious = function() {
	        return $scope.page === 1;
	      };
	
	      $scope.noNext = function() {
	        return $scope.page === $scope.totalPages;
	      };
	
	      ctrl.updatePage = function() {
	        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable
	
	        if ($scope.page > $scope.totalPages) {
	          $scope.selectPage($scope.totalPages);
	        } else {
	          ctrl.ngModelCtrl.$render();
	        }
	      };
	
	      $scope.$on('$destroy', function() {
	        while (ctrl._watchers.length) {
	          ctrl._watchers.shift()();
	        }
	      });
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
	
	.controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function($scope, $attrs, uibPaging, uibPagerConfig) {
	  $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;
	
	  uibPaging.create(this, $scope, $attrs);
	}])
	
	.constant('uibPagerConfig', {
	  itemsPerPage: 10,
	  previousText: '« Previous',
	  nextText: 'Next »',
	  align: true
	})
	
	.directive('uibPager', ['uibPagerConfig', function(uibPagerConfig) {
	  return {
	    scope: {
	      totalItems: '=',
	      previousText: '@',
	      nextText: '@',
	      ngDisabled: '='
	    },
	    require: ['uibPager', '?ngModel'],
	    restrict: 'A',
	    controller: 'UibPagerController',
	    controllerAs: 'pager',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/pager/pager.html';
	    },
	    link: function(scope, element, attrs, ctrls) {
	      element.addClass('pager');
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	        return; // do nothing if no ng-model
	      }
	
	      paginationCtrl.init(ngModelCtrl, uibPagerConfig);
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
	.controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
	  var ctrl = this;
	  // Setup configuration parameters
	  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
	    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
	    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
	    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
	    pageLabel = angular.isDefined($attrs.pageLabel) ? function(idx) { return $scope.$parent.$eval($attrs.pageLabel, {$page: idx}); } : angular.identity;
	  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
	  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
	  $attrs.$set('role', 'menu');
	
	  uibPaging.create(this, $scope, $attrs);
	
	  if ($attrs.maxSize) {
	    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function(value) {
	      maxSize = parseInt(value, 10);
	      ctrl.render();
	    }));
	  }
	
	  // Create page object used in template
	  function makePage(number, text, isActive) {
	    return {
	      number: number,
	      text: text,
	      active: isActive
	    };
	  }
	
	  function getPages(currentPage, totalPages) {
	    var pages = [];
	
	    // Default page limits
	    var startPage = 1, endPage = totalPages;
	    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;
	
	    // recompute if maxSize
	    if (isMaxSized) {
	      if (rotate) {
	        // Current page is displayed in the middle of the visible ones
	        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
	        endPage = startPage + maxSize - 1;
	
	        // Adjust if limit is exceeded
	        if (endPage > totalPages) {
	          endPage = totalPages;
	          startPage = endPage - maxSize + 1;
	        }
	      } else {
	        // Visible pages are paginated with maxSize
	        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;
	
	        // Adjust last page if limit is exceeded
	        endPage = Math.min(startPage + maxSize - 1, totalPages);
	      }
	    }
	
	    // Add page number links
	    for (var number = startPage; number <= endPage; number++) {
	      var page = makePage(number, pageLabel(number), number === currentPage);
	      pages.push(page);
	    }
	
	    // Add links to move between page sets
	    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
	      if (startPage > 1) {
	        if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
	        var previousPageSet = makePage(startPage - 1, '...', false);
	        pages.unshift(previousPageSet);
	      }
	        if (boundaryLinkNumbers) {
	          if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
	            var secondPageLink = makePage(2, '2', false);
	            pages.unshift(secondPageLink);
	          }
	          //add the first page
	          var firstPageLink = makePage(1, '1', false);
	          pages.unshift(firstPageLink);
	        }
	      }
	
	      if (endPage < totalPages) {
	        if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
	        var nextPageSet = makePage(endPage + 1, '...', false);
	        pages.push(nextPageSet);
	      }
	        if (boundaryLinkNumbers) {
	          if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
	            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
	            pages.push(secondToLastPageLink);
	          }
	          //add the last page
	          var lastPageLink = makePage(totalPages, totalPages, false);
	          pages.push(lastPageLink);
	        }
	      }
	    }
	    return pages;
	  }
	
	  var originalRender = this.render;
	  this.render = function() {
	    originalRender();
	    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
	      $scope.pages = getPages($scope.page, $scope.totalPages);
	    }
	  };
	}])
	
	.constant('uibPaginationConfig', {
	  itemsPerPage: 10,
	  boundaryLinks: false,
	  boundaryLinkNumbers: false,
	  directionLinks: true,
	  firstText: 'First',
	  previousText: 'Previous',
	  nextText: 'Next',
	  lastText: 'Last',
	  rotate: true,
	  forceEllipses: false
	})
	
	.directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, uibPaginationConfig) {
	  return {
	    scope: {
	      totalItems: '=',
	      firstText: '@',
	      previousText: '@',
	      nextText: '@',
	      lastText: '@',
	      ngDisabled:'='
	    },
	    require: ['uibPagination', '?ngModel'],
	    restrict: 'A',
	    controller: 'UibPaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
	    },
	    link: function(scope, element, attrs, ctrls) {
	      element.addClass('pagination');
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
	    }
	  };
	}]);
	
	/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */
	angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])
	
	/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */
	.provider('$uibTooltip', function() {
	  // The default options tooltip and popover.
	  var defaultOptions = {
	    placement: 'top',
	    placementClassPrefix: '',
	    animation: true,
	    popupDelay: 0,
	    popupCloseDelay: 0,
	    useContentExp: false
	  };
	
	  // Default hide triggers for each show trigger
	  var triggerMap = {
	    'mouseenter': 'mouseleave',
	    'click': 'click',
	    'outsideClick': 'outsideClick',
	    'focus': 'blur',
	    'none': ''
	  };
	
	  // The options specified to the provider globally.
	  var globalOptions = {};
	
	  /**
	   * `options({})` allows global configuration of all tooltips in the
	   * application.
	   *
	   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	   *     // place tooltips left instead of top by default
	   *     $tooltipProvider.options( { placement: 'left' } );
	   *   });
	   */
		this.options = function(value) {
			angular.extend(globalOptions, value);
		};
	
	  /**
	   * This allows you to extend the set of trigger mappings available. E.g.:
	   *
	   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
	   */
	  this.setTriggers = function setTriggers(triggers) {
	    angular.extend(triggerMap, triggers);
	  };
	
	  /**
	   * This is a helper function for translating camel-case to snake_case.
	   */
	  function snake_case(name) {
	    var regexp = /[A-Z]/g;
	    var separator = '-';
	    return name.replace(regexp, function(letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  /**
	   * Returns the actual instance of the $tooltip service.
	   * TODO support multiple triggers
	   */
	  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
	    var openedTooltips = $$stackedMap.createNew();
	    $document.on('keyup', keypressListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('keyup', keypressListener);
	    });
	
	    function keypressListener(e) {
	      if (e.which === 27) {
	        var last = openedTooltips.top();
	        if (last) {
	          last.value.close();
	          last = null;
	        }
	      }
	    }
	
	    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
	      options = angular.extend({}, defaultOptions, globalOptions, options);
	
	      /**
	       * Returns an object of show and hide triggers.
	       *
	       * If a trigger is supplied,
	       * it is used to show the tooltip; otherwise, it will use the `trigger`
	       * option passed to the `$tooltipProvider.options` method; else it will
	       * default to the trigger supplied to this directive factory.
	       *
	       * The hide trigger is based on the show trigger. If the `trigger` option
	       * was passed to the `$tooltipProvider.options` method, it will use the
	       * mapped trigger from `triggerMap` or the passed trigger if the map is
	       * undefined; otherwise, it uses the `triggerMap` value of the show
	       * trigger; else it will just use the show trigger.
	       */
	      function getTriggers(trigger) {
	        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
	        var hide = show.map(function(trigger) {
	          return triggerMap[trigger] || trigger;
	        });
	        return {
	          show: show,
	          hide: hide
	        };
	      }
	
	      var directiveName = snake_case(ttType);
	
	      var startSym = $interpolate.startSymbol();
	      var endSym = $interpolate.endSymbol();
	      var template =
	        '<div '+ directiveName + '-popup ' +
	          'uib-title="' + startSym + 'title' + endSym + '" ' +
	          (options.useContentExp ?
	            'content-exp="contentExp()" ' :
	            'content="' + startSym + 'content' + endSym + '" ') +
	          'origin-scope="origScope" ' +
	          'class="uib-position-measure ' + prefix + '" ' +
	          'tooltip-animation-class="fade"' +
	          'uib-tooltip-classes ' +
	          'ng-class="{ in: isOpen }" ' +
	          '>' +
	        '</div>';
	
	      return {
	        compile: function(tElem, tAttrs) {
	          var tooltipLinker = $compile(template);
	
	          return function link(scope, element, attrs, tooltipCtrl) {
	            var tooltip;
	            var tooltipLinkedScope;
	            var transitionTimeout;
	            var showTimeout;
	            var hideTimeout;
	            var positionTimeout;
	            var adjustmentTimeout;
	            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
	            var triggers = getTriggers(undefined);
	            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
	            var ttScope = scope.$new(true);
	            var repositionScheduled = false;
	            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
	            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
	            var observers = [];
	            var lastPlacement;
	
	            var positionTooltip = function() {
	              // check if tooltip exists and is not empty
	              if (!tooltip || !tooltip.html()) { return; }
	
	              if (!positionTimeout) {
	                positionTimeout = $timeout(function() {
	                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
	                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
	                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
	                  var placementClasses = ttPosition.placement.split('-');
	
	                  if (!tooltip.hasClass(placementClasses[0])) {
	                    tooltip.removeClass(lastPlacement.split('-')[0]);
	                    tooltip.addClass(placementClasses[0]);
	                  }
	
	                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
	                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
	                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
	                  }
	
	                  adjustmentTimeout = $timeout(function() {
	                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
	                    if (adjustment) {
	                      tooltip.css(adjustment);
	                    }
	                    adjustmentTimeout = null;
	                  }, 0, false);
	
	                  // first time through tt element will have the
	                  // uib-position-measure class or if the placement
	                  // has changed we need to position the arrow.
	                  if (tooltip.hasClass('uib-position-measure')) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                    tooltip.removeClass('uib-position-measure');
	                  } else if (lastPlacement !== ttPosition.placement) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                  }
	                  lastPlacement = ttPosition.placement;
	
	                  positionTimeout = null;
	                }, 0, false);
	              }
	            };
	
	            // Set up the correct scope to allow transclusion later
	            ttScope.origScope = scope;
	
	            // By default, the tooltip is not open.
	            // TODO add ability to start tooltip opened
	            ttScope.isOpen = false;
	
	            function toggleTooltipBind() {
	              if (!ttScope.isOpen) {
	                showTooltipBind();
	              } else {
	                hideTooltipBind();
	              }
	            }
	
	            // Show the tooltip with delay if specified, otherwise show it immediately
	            function showTooltipBind() {
	              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
	                return;
	              }
	
	              cancelHide();
	              prepareTooltip();
	
	              if (ttScope.popupDelay) {
	                // Do nothing if the tooltip was already scheduled to pop-up.
	                // This happens if show is triggered multiple times before any hide is triggered.
	                if (!showTimeout) {
	                  showTimeout = $timeout(show, ttScope.popupDelay, false);
	                }
	              } else {
	                show();
	              }
	            }
	
	            function hideTooltipBind() {
	              cancelShow();
	
	              if (ttScope.popupCloseDelay) {
	                if (!hideTimeout) {
	                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
	                }
	              } else {
	                hide();
	              }
	            }
	
	            // Show the tooltip popup element.
	            function show() {
	              cancelShow();
	              cancelHide();
	
	              // Don't show empty tooltips.
	              if (!ttScope.content) {
	                return angular.noop;
	              }
	
	              createTooltip();
	
	              // And show the tooltip.
	              ttScope.$evalAsync(function() {
	                ttScope.isOpen = true;
	                assignIsOpen(true);
	                positionTooltip();
	              });
	            }
	
	            function cancelShow() {
	              if (showTimeout) {
	                $timeout.cancel(showTimeout);
	                showTimeout = null;
	              }
	
	              if (positionTimeout) {
	                $timeout.cancel(positionTimeout);
	                positionTimeout = null;
	              }
	            }
	
	            // Hide the tooltip popup element.
	            function hide() {
	              if (!ttScope) {
	                return;
	              }
	
	              // First things first: we don't show it anymore.
	              ttScope.$evalAsync(function() {
	                if (ttScope) {
	                  ttScope.isOpen = false;
	                  assignIsOpen(false);
	                  // And now we remove it from the DOM. However, if we have animation, we
	                  // need to wait for it to expire beforehand.
	                  // FIXME: this is a placeholder for a port of the transitions library.
	                  // The fade transition in TWBS is 150ms.
	                  if (ttScope.animation) {
	                    if (!transitionTimeout) {
	                      transitionTimeout = $timeout(removeTooltip, 150, false);
	                    }
	                  } else {
	                    removeTooltip();
	                  }
	                }
	              });
	            }
	
	            function cancelHide() {
	              if (hideTimeout) {
	                $timeout.cancel(hideTimeout);
	                hideTimeout = null;
	              }
	
	              if (transitionTimeout) {
	                $timeout.cancel(transitionTimeout);
	                transitionTimeout = null;
	              }
	            }
	
	            function createTooltip() {
	              // There can only be one tooltip element per directive shown at once.
	              if (tooltip) {
	                return;
	              }
	
	              tooltipLinkedScope = ttScope.$new();
	              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
	                if (appendToBody) {
	                  $document.find('body').append(tooltip);
	                } else {
	                  element.after(tooltip);
	                }
	              });
	
	              openedTooltips.add(ttScope, {
	                close: hide
	              });
	
	              prepObservers();
	            }
	
	            function removeTooltip() {
	              cancelShow();
	              cancelHide();
	              unregisterObservers();
	
	              if (tooltip) {
	                tooltip.remove();
	                
	                tooltip = null;
	                if (adjustmentTimeout) {
	                  $timeout.cancel(adjustmentTimeout);
	                }
	              }
	
	              openedTooltips.remove(ttScope);
	              
	              if (tooltipLinkedScope) {
	                tooltipLinkedScope.$destroy();
	                tooltipLinkedScope = null;
	              }
	            }
	
	            /**
	             * Set the initial scope values. Once
	             * the tooltip is created, the observers
	             * will be added to keep things in sync.
	             */
	            function prepareTooltip() {
	              ttScope.title = attrs[prefix + 'Title'];
	              if (contentParse) {
	                ttScope.content = contentParse(scope);
	              } else {
	                ttScope.content = attrs[ttType];
	              }
	
	              ttScope.popupClass = attrs[prefix + 'Class'];
	              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
	              var placement = $position.parsePlacement(ttScope.placement);
	              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];
	
	              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
	              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
	              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
	              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
	            }
	
	            function assignIsOpen(isOpen) {
	              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
	                isOpenParse.assign(scope, isOpen);
	              }
	            }
	
	            ttScope.contentExp = function() {
	              return ttScope.content;
	            };
	
	            /**
	             * Observe the relevant attributes.
	             */
	            attrs.$observe('disabled', function(val) {
	              if (val) {
	                cancelShow();
	              }
	
	              if (val && ttScope.isOpen) {
	                hide();
	              }
	            });
	
	            if (isOpenParse) {
	              scope.$watch(isOpenParse, function(val) {
	                if (ttScope && !val === ttScope.isOpen) {
	                  toggleTooltipBind();
	                }
	              });
	            }
	
	            function prepObservers() {
	              observers.length = 0;
	
	              if (contentParse) {
	                observers.push(
	                  scope.$watch(contentParse, function(val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    }
	                  })
	                );
	
	                observers.push(
	                  tooltipLinkedScope.$watch(function() {
	                    if (!repositionScheduled) {
	                      repositionScheduled = true;
	                      tooltipLinkedScope.$$postDigest(function() {
	                        repositionScheduled = false;
	                        if (ttScope && ttScope.isOpen) {
	                          positionTooltip();
	                        }
	                      });
	                    }
	                  })
	                );
	              } else {
	                observers.push(
	                  attrs.$observe(ttType, function(val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    } else {
	                      positionTooltip();
	                    }
	                  })
	                );
	              }
	
	              observers.push(
	                attrs.$observe(prefix + 'Title', function(val) {
	                  ttScope.title = val;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                })
	              );
	
	              observers.push(
	                attrs.$observe(prefix + 'Placement', function(val) {
	                  ttScope.placement = val ? val : options.placement;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                })
	              );
	            }
	
	            function unregisterObservers() {
	              if (observers.length) {
	                angular.forEach(observers, function(observer) {
	                  observer();
	                });
	                observers.length = 0;
	              }
	            }
	
	            // hide tooltips/popovers for outsideClick trigger
	            function bodyHideTooltipBind(e) {
	              if (!ttScope || !ttScope.isOpen || !tooltip) {
	                return;
	              }
	              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
	              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
	                hideTooltipBind();
	              }
	            }
	
	            // KeyboardEvent handler to hide the tooltip on Escape key press
	            function hideOnEscapeKey(e) {
	              if (e.which === 27) {
	                hideTooltipBind();
	              }
	            }
	
	            var unregisterTriggers = function() {
	              triggers.show.forEach(function(trigger) {
	                if (trigger === 'outsideClick') {
	                  element.off('click', toggleTooltipBind);
	                } else {
	                  element.off(trigger, showTooltipBind);
	                  element.off(trigger, toggleTooltipBind);
	                }
	                element.off('keypress', hideOnEscapeKey);
	              });
	              triggers.hide.forEach(function(trigger) {
	                if (trigger === 'outsideClick') {
	                  $document.off('click', bodyHideTooltipBind);
	                } else {
	                  element.off(trigger, hideTooltipBind);
	                }
	              });
	            };
	
	            function prepTriggers() {
	              var showTriggers = [], hideTriggers = [];
	              var val = scope.$eval(attrs[prefix + 'Trigger']);
	              unregisterTriggers();
	
	              if (angular.isObject(val)) {
	                Object.keys(val).forEach(function(key) {
	                  showTriggers.push(key);
	                  hideTriggers.push(val[key]);
	                });
	                triggers = {
	                  show: showTriggers,
	                  hide: hideTriggers
	                };
	              } else {
	                triggers = getTriggers(val);
	              }
	
	              if (triggers.show !== 'none') {
	                triggers.show.forEach(function(trigger, idx) {
	                  if (trigger === 'outsideClick') {
	                    element.on('click', toggleTooltipBind);
	                    $document.on('click', bodyHideTooltipBind);
	                  } else if (trigger === triggers.hide[idx]) {
	                    element.on(trigger, toggleTooltipBind);
	                  } else if (trigger) {
	                    element.on(trigger, showTooltipBind);
	                    element.on(triggers.hide[idx], hideTooltipBind);
	                  }
	                  element.on('keypress', hideOnEscapeKey);
	                });
	              }
	            }
	
	            prepTriggers();
	
	            var animation = scope.$eval(attrs[prefix + 'Animation']);
	            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
	
	            var appendToBodyVal;
	            var appendKey = prefix + 'AppendToBody';
	            if (appendKey in attrs && attrs[appendKey] === undefined) {
	              appendToBodyVal = true;
	            } else {
	              appendToBodyVal = scope.$eval(attrs[appendKey]);
	            }
	
	            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;
	
	            // Make sure tooltip is destroyed and removed.
	            scope.$on('$destroy', function onDestroyTooltip() {
	              unregisterTriggers();
	              removeTooltip();
	              ttScope = null;
	            });
	          };
	        }
	      };
	    };
	  }];
	})
	
	// This is mostly ngInclude code but with a custom scope
	.directive('uibTooltipTemplateTransclude', [
	         '$animate', '$sce', '$compile', '$templateRequest',
	function ($animate, $sce, $compile, $templateRequest) {
	  return {
	    link: function(scope, elem, attrs) {
	      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
	
	      var changeCounter = 0,
	        currentScope,
	        previousElement,
	        currentElement;
	
	      var cleanupLastIncludeContent = function() {
	        if (previousElement) {
	          previousElement.remove();
	          previousElement = null;
	        }
	
	        if (currentScope) {
	          currentScope.$destroy();
	          currentScope = null;
	        }
	
	        if (currentElement) {
	          $animate.leave(currentElement).then(function() {
	            previousElement = null;
	          });
	          previousElement = currentElement;
	          currentElement = null;
	        }
	      };
	
	      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
	        var thisChangeId = ++changeCounter;
	
	        if (src) {
	          //set the 2nd param to true to ignore the template request error so that the inner
	          //contents and scope can be cleaned up.
	          $templateRequest(src, true).then(function(response) {
	            if (thisChangeId !== changeCounter) { return; }
	            var newScope = origScope.$new();
	            var template = response;
	
	            var clone = $compile(template)(newScope, function(clone) {
	              cleanupLastIncludeContent();
	              $animate.enter(clone, elem);
	            });
	
	            currentScope = newScope;
	            currentElement = clone;
	
	            currentScope.$emit('$includeContentLoaded', src);
	          }, function() {
	            if (thisChangeId === changeCounter) {
	              cleanupLastIncludeContent();
	              scope.$emit('$includeContentError', src);
	            }
	          });
	          scope.$emit('$includeContentRequested', src);
	        } else {
	          cleanupLastIncludeContent();
	        }
	      });
	
	      scope.$on('$destroy', cleanupLastIncludeContent);
	    }
	  };
	}])
	
	/**
	 * Note that it's intentional that these classes are *not* applied through $animate.
	 * They must not be animated as they're expected to be present on the tooltip on
	 * initialization.
	 */
	.directive('uibTooltipClasses', ['$uibPosition', function($uibPosition) {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      // need to set the primary position so the
	      // arrow has space during position measure.
	      // tooltip.positionTooltip()
	      if (scope.placement) {
	        // // There are no top-left etc... classes
	        // // in TWBS, so we need the primary position.
	        var position = $uibPosition.parsePlacement(scope.placement);
	        element.addClass(position[0]);
	      }
	
	      if (scope.popupClass) {
	        element.addClass(scope.popupClass);
	      }
	
	      if (scope.animation) {
	        element.addClass(attrs.tooltipAnimationClass);
	      }
	    }
	  };
	}])
	
	.directive('uibTooltipPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { content: '@' },
	    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
	  };
	})
	
	.directive('uibTooltip', [ '$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
	}])
	
	.directive('uibTooltipTemplatePopup', function() {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&', originScope: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
	  };
	})
	
	.directive('uibTooltipTemplate', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibTooltipHtmlPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
	  };
	})
	
	.directive('uibTooltipHtml', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]);
	
	/**
	 * The following features are still outstanding: popup delay, animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, and selector delegatation.
	 */
	angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])
	
	.directive('uibPopoverTemplatePopup', function() {
	  return {
	    restrict: 'A',
	    scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
	    templateUrl: 'uib/template/popover/popover-template.html'
	  };
	})
	
	.directive('uibPopoverTemplate', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibPopoverHtmlPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&', uibTitle: '@' },
	    templateUrl: 'uib/template/popover/popover-html.html'
	  };
	})
	
	.directive('uibPopoverHtml', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibPopoverPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { uibTitle: '@', content: '@' },
	    templateUrl: 'uib/template/popover/popover.html'
	  };
	})
	
	.directive('uibPopover', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopover', 'popover', 'click');
	}]);
	
	angular.module('ui.bootstrap.progressbar', [])
	
	.constant('uibProgressConfig', {
	  animate: true,
	  max: 100
	})
	
	.controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function($scope, $attrs, progressConfig) {
	  var self = this,
	      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
	
	  this.bars = [];
	  $scope.max = getMaxOrDefault();
	
	  this.addBar = function(bar, element, attrs) {
	    if (!animate) {
	      element.css({'transition': 'none'});
	    }
	
	    this.bars.push(bar);
	
	    bar.max = getMaxOrDefault();
	    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';
	
	    bar.$watch('value', function(value) {
	      bar.recalculatePercentage();
	    });
	
	    bar.recalculatePercentage = function() {
	      var totalPercentage = self.bars.reduce(function(total, bar) {
	        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
	        return total + bar.percent;
	      }, 0);
	
	      if (totalPercentage > 100) {
	        bar.percent -= totalPercentage - 100;
	      }
	    };
	
	    bar.$on('$destroy', function() {
	      element = null;
	      self.removeBar(bar);
	    });
	  };
	
	  this.removeBar = function(bar) {
	    this.bars.splice(this.bars.indexOf(bar), 1);
	    this.bars.forEach(function (bar) {
	      bar.recalculatePercentage();
	    });
	  };
	
	  //$attrs.$observe('maxParam', function(maxParam) {
	  $scope.$watch('maxParam', function(maxParam) {
	    self.bars.forEach(function(bar) {
	      bar.max = getMaxOrDefault();
	      bar.recalculatePercentage();
	    });
	  });
	
	  function getMaxOrDefault () {
	    return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
	  }
	}])
	
	.directive('uibProgress', function() {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    require: 'uibProgress',
	    scope: {
	      maxParam: '=?max'
	    },
	    templateUrl: 'uib/template/progressbar/progress.html'
	  };
	})
	
	.directive('uibBar', function() {
	  return {
	    replace: true,
	    transclude: true,
	    require: '^uibProgress',
	    scope: {
	      value: '=',
	      type: '@'
	    },
	    templateUrl: 'uib/template/progressbar/bar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, element, attrs);
	    }
	  };
	})
	
	.directive('uibProgressbar', function() {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    scope: {
	      value: '=',
	      maxParam: '=?max',
	      type: '@'
	    },
	    templateUrl: 'uib/template/progressbar/progressbar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
	    }
	  };
	});
	
	angular.module('ui.bootstrap.rating', [])
	
	.constant('uibRatingConfig', {
	  max: 5,
	  stateOn: null,
	  stateOff: null,
	  enableReset: true,
	  titles: ['one', 'two', 'three', 'four', 'five']
	})
	
	.controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function($scope, $attrs, ratingConfig) {
	  var ngModelCtrl = { $setViewValue: angular.noop },
	    self = this;
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.push(function(value) {
	      if (angular.isNumber(value) && value << 0 !== value) {
	        value = Math.round(value);
	      }
	
	      return value;
	    });
	
	    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
	    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
	    this.enableReset = angular.isDefined($attrs.enableReset) ?
	      $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;
	    var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
	    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
	      tmpTitles : ratingConfig.titles;
	
	    var ratingStates = angular.isDefined($attrs.ratingStates) ?
	      $scope.$parent.$eval($attrs.ratingStates) :
	      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
	    $scope.range = this.buildTemplateObjects(ratingStates);
	  };
	
	  this.buildTemplateObjects = function(states) {
	    for (var i = 0, n = states.length; i < n; i++) {
	      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
	    }
	    return states;
	  };
	
	  this.getTitle = function(index) {
	    if (index >= this.titles.length) {
	      return index + 1;
	    }
	
	    return this.titles[index];
	  };
	
	  $scope.rate = function(value) {
	    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
	      var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;
	      ngModelCtrl.$setViewValue(newViewValue);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.enter = function(value) {
	    if (!$scope.readonly) {
	      $scope.value = value;
	    }
	    $scope.onHover({value: value});
	  };
	
	  $scope.reset = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	    $scope.onLeave();
	  };
	
	  $scope.onKeydown = function(evt) {
	    if (/(37|38|39|40)/.test(evt.which)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
	    }
	  };
	
	  this.render = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	    $scope.title = self.getTitle($scope.value - 1);
	  };
	}])
	
	.directive('uibRating', function() {
	  return {
	    require: ['uibRating', 'ngModel'],
	    restrict: 'A',
	    scope: {
	      readonly: '=?readOnly',
	      onHover: '&',
	      onLeave: '&'
	    },
	    controller: 'UibRatingController',
	    templateUrl: 'uib/template/rating/rating.html',
	    link: function(scope, element, attrs, ctrls) {
	      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	      ratingCtrl.init(ngModelCtrl);
	    }
	  };
	});
	
	angular.module('ui.bootstrap.tabs', [])
	
	.controller('UibTabsetController', ['$scope', function ($scope) {
	  var ctrl = this,
	    oldIndex;
	  ctrl.tabs = [];
	
	  ctrl.select = function(index, evt) {
	    if (!destroyed) {
	      var previousIndex = findTabIndex(oldIndex);
	      var previousSelected = ctrl.tabs[previousIndex];
	      if (previousSelected) {
	        previousSelected.tab.onDeselect({
	          $event: evt,
	          $selectedIndex: index
	        });
	        if (evt && evt.isDefaultPrevented()) {
	          return;
	        }
	        previousSelected.tab.active = false;
	      }
	
	      var selected = ctrl.tabs[index];
	      if (selected) {
	        selected.tab.onSelect({
	          $event: evt
	        });
	        selected.tab.active = true;
	        ctrl.active = selected.index;
	        oldIndex = selected.index;
	      } else if (!selected && angular.isDefined(oldIndex)) {
	        ctrl.active = null;
	        oldIndex = null;
	      }
	    }
	  };
	
	  ctrl.addTab = function addTab(tab) {
	    ctrl.tabs.push({
	      tab: tab,
	      index: tab.index
	    });
	    ctrl.tabs.sort(function(t1, t2) {
	      if (t1.index > t2.index) {
	        return 1;
	      }
	
	      if (t1.index < t2.index) {
	        return -1;
	      }
	
	      return 0;
	    });
	
	    if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
	      var newActiveIndex = findTabIndex(tab.index);
	      ctrl.select(newActiveIndex);
	    }
	  };
	
	  ctrl.removeTab = function removeTab(tab) {
	    var index;
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].tab === tab) {
	        index = i;
	        break;
	      }
	    }
	
	    if (ctrl.tabs[index].index === ctrl.active) {
	      var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
	        index - 1 : index + 1 % ctrl.tabs.length;
	      ctrl.select(newActiveTabIndex);
	    }
	
	    ctrl.tabs.splice(index, 1);
	  };
	
	  $scope.$watch('tabset.active', function(val) {
	    if (angular.isDefined(val) && val !== oldIndex) {
	      ctrl.select(findTabIndex(val));
	    }
	  });
	
	  var destroyed;
	  $scope.$on('$destroy', function() {
	    destroyed = true;
	  });
	
	  function findTabIndex(index) {
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].index === index) {
	        return i;
	      }
	    }
	  }
	}])
	
	.directive('uibTabset', function() {
	  return {
	    transclude: true,
	    replace: true,
	    scope: {},
	    bindToController: {
	      active: '=?',
	      type: '@'
	    },
	    controller: 'UibTabsetController',
	    controllerAs: 'tabset',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/tabs/tabset.html';
	    },
	    link: function(scope, element, attrs) {
	      scope.vertical = angular.isDefined(attrs.vertical) ?
	        scope.$parent.$eval(attrs.vertical) : false;
	      scope.justified = angular.isDefined(attrs.justified) ?
	        scope.$parent.$eval(attrs.justified) : false;
	    }
	  };
	})
	
	.directive('uibTab', ['$parse', function($parse) {
	  return {
	    require: '^uibTabset',
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/tabs/tab.html';
	    },
	    transclude: true,
	    scope: {
	      heading: '@',
	      index: '=?',
	      classes: '@?',
	      onSelect: '&select', //This callback is called in contentHeadingTransclude
	                          //once it inserts the tab's content into the dom
	      onDeselect: '&deselect'
	    },
	    controller: function() {
	      //Empty controller so other directives can require being 'under' a tab
	    },
	    controllerAs: 'tab',
	    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
	      scope.disabled = false;
	      if (attrs.disable) {
	        scope.$parent.$watch($parse(attrs.disable), function(value) {
	          scope.disabled = !! value;
	        });
	      }
	
	      if (angular.isUndefined(attrs.index)) {
	        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
	          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function(t) { return t.index; })) + 1;
	        } else {
	          scope.index = 0;
	        }
	      }
	
	      if (angular.isUndefined(attrs.classes)) {
	        scope.classes = '';
	      }
	
	      scope.select = function(evt) {
	        if (!scope.disabled) {
	          var index;
	          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
	            if (tabsetCtrl.tabs[i].tab === scope) {
	              index = i;
	              break;
	            }
	          }
	
	          tabsetCtrl.select(index, evt);
	        }
	      };
	
	      tabsetCtrl.addTab(scope);
	      scope.$on('$destroy', function() {
	        tabsetCtrl.removeTab(scope);
	      });
	
	      //We need to transclude later, once the content container is ready.
	      //when this link happens, we're inside a tab heading.
	      scope.$transcludeFn = transclude;
	    }
	  };
	}])
	
	.directive('uibTabHeadingTransclude', function() {
	  return {
	    restrict: 'A',
	    require: '^uibTab',
	    link: function(scope, elm) {
	      scope.$watch('headingElement', function updateHeadingElement(heading) {
	        if (heading) {
	          elm.html('');
	          elm.append(heading);
	        }
	      });
	    }
	  };
	})
	
	.directive('uibTabContentTransclude', function() {
	  return {
	    restrict: 'A',
	    require: '^uibTabset',
	    link: function(scope, elm, attrs) {
	      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;
	
	      //Now our tab is ready to be transcluded: both the tab heading area
	      //and the tab content area are loaded.  Transclude 'em both.
	      tab.$transcludeFn(tab.$parent, function(contents) {
	        angular.forEach(contents, function(node) {
	          if (isTabHeading(node)) {
	            //Let tabHeadingTransclude know.
	            tab.headingElement = node;
	          } else {
	            elm.append(node);
	          }
	        });
	      });
	    }
	  };
	
	  function isTabHeading(node) {
	    return node.tagName && (
	      node.hasAttribute('uib-tab-heading') ||
	      node.hasAttribute('data-uib-tab-heading') ||
	      node.hasAttribute('x-uib-tab-heading') ||
	      node.tagName.toLowerCase() === 'uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'x-uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'uib:tab-heading'
	    );
	  }
	});
	
	angular.module('ui.bootstrap.timepicker', [])
	
	.constant('uibTimepickerConfig', {
	  hourStep: 1,
	  minuteStep: 1,
	  secondStep: 1,
	  showMeridian: true,
	  showSeconds: false,
	  meridians: null,
	  readonlyInput: false,
	  mousewheel: true,
	  arrowkeys: true,
	  showSpinners: true,
	  templateUrl: 'uib/template/timepicker/timepicker.html'
	})
	
	.controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
	  var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
	  var selected = new Date(),
	    watchers = [],
	    ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	    meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
	    padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;
	
	  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
	  $element.removeAttr('tabindex');
	
	  this.init = function(ngModelCtrl_, inputs) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.unshift(function(modelValue) {
	      return modelValue ? new Date(modelValue) : null;
	    });
	
	    var hoursInputEl = inputs.eq(0),
	        minutesInputEl = inputs.eq(1),
	        secondsInputEl = inputs.eq(2);
	
	    hoursModelCtrl = hoursInputEl.controller('ngModel');
	    minutesModelCtrl = minutesInputEl.controller('ngModel');
	    secondsModelCtrl = secondsInputEl.controller('ngModel');
	
	    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
	
	    if (mousewheel) {
	      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    }
	
	    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
	    if (arrowkeys) {
	      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    }
	
	    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
	    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	  };
	
	  var hourStep = timepickerConfig.hourStep;
	  if ($attrs.hourStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function(value) {
	      hourStep = +value;
	    }));
	  }
	
	  var minuteStep = timepickerConfig.minuteStep;
	  if ($attrs.minuteStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
	      minuteStep = +value;
	    }));
	  }
	
	  var min;
	  watchers.push($scope.$parent.$watch($parse($attrs.min), function(value) {
	    var dt = new Date(value);
	    min = isNaN(dt) ? undefined : dt;
	  }));
	
	  var max;
	  watchers.push($scope.$parent.$watch($parse($attrs.max), function(value) {
	    var dt = new Date(value);
	    max = isNaN(dt) ? undefined : dt;
	  }));
	
	  var disabled = false;
	  if ($attrs.ngDisabled) {
	    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(value) {
	      disabled = value;
	    }));
	  }
	
	  $scope.noIncrementHours = function() {
	    var incrementedSelected = addMinutes(selected, hourStep * 60);
	    return disabled || incrementedSelected > max ||
	      incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementHours = function() {
	    var decrementedSelected = addMinutes(selected, -hourStep * 60);
	    return disabled || decrementedSelected < min ||
	      decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noIncrementMinutes = function() {
	    var incrementedSelected = addMinutes(selected, minuteStep);
	    return disabled || incrementedSelected > max ||
	      incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementMinutes = function() {
	    var decrementedSelected = addMinutes(selected, -minuteStep);
	    return disabled || decrementedSelected < min ||
	      decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noIncrementSeconds = function() {
	    var incrementedSelected = addSeconds(selected, secondStep);
	    return disabled || incrementedSelected > max ||
	      incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementSeconds = function() {
	    var decrementedSelected = addSeconds(selected, -secondStep);
	    return disabled || decrementedSelected < min ||
	      decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noToggleMeridian = function() {
	    if (selected.getHours() < 12) {
	      return disabled || addMinutes(selected, 12 * 60) > max;
	    }
	
	    return disabled || addMinutes(selected, -12 * 60) < min;
	  };
	
	  var secondStep = timepickerConfig.secondStep;
	  if ($attrs.secondStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function(value) {
	      secondStep = +value;
	    }));
	  }
	
	  $scope.showSeconds = timepickerConfig.showSeconds;
	  if ($attrs.showSeconds) {
	    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function(value) {
	      $scope.showSeconds = !!value;
	    }));
	  }
	
	  // 12H / 24H mode
	  $scope.showMeridian = timepickerConfig.showMeridian;
	  if ($attrs.showMeridian) {
	    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
	      $scope.showMeridian = !!value;
	
	      if (ngModelCtrl.$error.time) {
	        // Evaluate from template
	        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
	        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	          selected.setHours(hours);
	          refresh();
	        }
	      } else {
	        updateTemplate();
	      }
	    }));
	  }
	
	  // Get $scope.hours in 24H mode if valid
	  function getHoursFromTemplate() {
	    var hours = +$scope.hours;
	    var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
	      hours >= 0 && hours < 24;
	    if (!valid || $scope.hours === '') {
	      return undefined;
	    }
	
	    if ($scope.showMeridian) {
	      if (hours === 12) {
	        hours = 0;
	      }
	      if ($scope.meridian === meridians[1]) {
	        hours = hours + 12;
	      }
	    }
	    return hours;
	  }
	
	  function getMinutesFromTemplate() {
	    var minutes = +$scope.minutes;
	    var valid = minutes >= 0 && minutes < 60;
	    if (!valid || $scope.minutes === '') {
	      return undefined;
	    }
	    return minutes;
	  }
	
	  function getSecondsFromTemplate() {
	    var seconds = +$scope.seconds;
	    return seconds >= 0 && seconds < 60 ? seconds : undefined;
	  }
	
	  function pad(value, noPad) {
	    if (value === null) {
	      return '';
	    }
	
	    return angular.isDefined(value) && value.toString().length < 2 && !noPad ?
	      '0' + value : value.toString();
	  }
	
	  // Respond on mousewheel spin
	  this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
	    var isScrollingUp = function(e) {
	      if (e.originalEvent) {
	        e = e.originalEvent;
	      }
	      //pick correct delta variable depending on event
	      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
	      return e.detail || delta > 0;
	    };
	
	    hoursInputEl.on('mousewheel wheel', function(e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
	      }
	      e.preventDefault();
	    });
	
	    minutesInputEl.on('mousewheel wheel', function(e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
	      }
	      e.preventDefault();
	    });
	
	     secondsInputEl.on('mousewheel wheel', function(e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
	      }
	      e.preventDefault();
	    });
	  };
	
	  // Respond on up/down arrowkeys
	  this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
	    hoursInputEl.on('keydown', function(e) {
	      if (!disabled) {
	        if (e.which === 38) { // up
	          e.preventDefault();
	          $scope.incrementHours();
	          $scope.$apply();
	        } else if (e.which === 40) { // down
	          e.preventDefault();
	          $scope.decrementHours();
	          $scope.$apply();
	        }
	      }
	    });
	
	    minutesInputEl.on('keydown', function(e) {
	      if (!disabled) {
	        if (e.which === 38) { // up
	          e.preventDefault();
	          $scope.incrementMinutes();
	          $scope.$apply();
	        } else if (e.which === 40) { // down
	          e.preventDefault();
	          $scope.decrementMinutes();
	          $scope.$apply();
	        }
	      }
	    });
	
	    secondsInputEl.on('keydown', function(e) {
	      if (!disabled) {
	        if (e.which === 38) { // up
	          e.preventDefault();
	          $scope.incrementSeconds();
	          $scope.$apply();
	        } else if (e.which === 40) { // down
	          e.preventDefault();
	          $scope.decrementSeconds();
	          $scope.$apply();
	        }
	      }
	    });
	  };
	
	  this.setupInputEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
	    if ($scope.readonlyInput) {
	      $scope.updateHours = angular.noop;
	      $scope.updateMinutes = angular.noop;
	      $scope.updateSeconds = angular.noop;
	      return;
	    }
	
	    var invalidate = function(invalidHours, invalidMinutes, invalidSeconds) {
	      ngModelCtrl.$setViewValue(null);
	      ngModelCtrl.$setValidity('time', false);
	      if (angular.isDefined(invalidHours)) {
	        $scope.invalidHours = invalidHours;
	        if (hoursModelCtrl) {
	          hoursModelCtrl.$setValidity('hours', false);
	        }
	      }
	
	      if (angular.isDefined(invalidMinutes)) {
	        $scope.invalidMinutes = invalidMinutes;
	        if (minutesModelCtrl) {
	          minutesModelCtrl.$setValidity('minutes', false);
	        }
	      }
	
	      if (angular.isDefined(invalidSeconds)) {
	        $scope.invalidSeconds = invalidSeconds;
	        if (secondsModelCtrl) {
	          secondsModelCtrl.$setValidity('seconds', false);
	        }
	      }
	    };
	
	    $scope.updateHours = function() {
	      var hours = getHoursFromTemplate(),
	        minutes = getMinutesFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	        selected.setHours(hours);
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(true);
	        } else {
	          refresh('h');
	        }
	      } else {
	        invalidate(true);
	      }
	    };
	
	    hoursInputEl.on('blur', function(e) {
	      ngModelCtrl.$setTouched();
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if ($scope.hours === null || $scope.hours === '') {
	        invalidate(true);
	      } else if (!$scope.invalidHours && $scope.hours < 10) {
	        $scope.$apply(function() {
	          $scope.hours = pad($scope.hours, !padHours);
	        });
	      }
	    });
	
	    $scope.updateMinutes = function() {
	      var minutes = getMinutesFromTemplate(),
	        hours = getHoursFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        selected.setHours(hours);
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(undefined, true);
	        } else {
	          refresh('m');
	        }
	      } else {
	        invalidate(undefined, true);
	      }
	    };
	
	    minutesInputEl.on('blur', function(e) {
	      ngModelCtrl.$setTouched();
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if ($scope.minutes === null) {
	        invalidate(undefined, true);
	      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
	        $scope.$apply(function() {
	          $scope.minutes = pad($scope.minutes);
	        });
	      }
	    });
	
	    $scope.updateSeconds = function() {
	      var seconds = getSecondsFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(seconds)) {
	        selected.setSeconds(seconds);
	        refresh('s');
	      } else {
	        invalidate(undefined, undefined, true);
	      }
	    };
	
	    secondsInputEl.on('blur', function(e) {
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
	        $scope.$apply( function() {
	          $scope.seconds = pad($scope.seconds);
	        });
	      }
	    });
	
	  };
	
	  this.render = function() {
	    var date = ngModelCtrl.$viewValue;
	
	    if (isNaN(date)) {
	      ngModelCtrl.$setValidity('time', false);
	      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	    } else {
	      if (date) {
	        selected = date;
	      }
	
	      if (selected < min || selected > max) {
	        ngModelCtrl.$setValidity('time', false);
	        $scope.invalidHours = true;
	        $scope.invalidMinutes = true;
	      } else {
	        makeValid();
	      }
	      updateTemplate();
	    }
	  };
	
	  // Call internally when we know that model is valid.
	  function refresh(keyboardChange) {
	    makeValid();
	    ngModelCtrl.$setViewValue(new Date(selected));
	    updateTemplate(keyboardChange);
	  }
	
	  function makeValid() {
	    if (hoursModelCtrl) {
	      hoursModelCtrl.$setValidity('hours', true);
	    }
	
	    if (minutesModelCtrl) {
	      minutesModelCtrl.$setValidity('minutes', true);
	    }
	
	    if (secondsModelCtrl) {
	      secondsModelCtrl.$setValidity('seconds', true);
	    }
	
	    ngModelCtrl.$setValidity('time', true);
	    $scope.invalidHours = false;
	    $scope.invalidMinutes = false;
	    $scope.invalidSeconds = false;
	  }
	
	  function updateTemplate(keyboardChange) {
	    if (!ngModelCtrl.$modelValue) {
	      $scope.hours = null;
	      $scope.minutes = null;
	      $scope.seconds = null;
	      $scope.meridian = meridians[0];
	    } else {
	      var hours = selected.getHours(),
	        minutes = selected.getMinutes(),
	        seconds = selected.getSeconds();
	
	      if ($scope.showMeridian) {
	        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
	      }
	
	      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
	      if (keyboardChange !== 'm') {
	        $scope.minutes = pad(minutes);
	      }
	      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	
	      if (keyboardChange !== 's') {
	        $scope.seconds = pad(seconds);
	      }
	      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	    }
	  }
	
	  function addSecondsToSelected(seconds) {
	    selected = addSeconds(selected, seconds);
	    refresh();
	  }
	
	  function addMinutes(selected, minutes) {
	    return addSeconds(selected, minutes*60);
	  }
	
	  function addSeconds(date, seconds) {
	    var dt = new Date(date.getTime() + seconds * 1000);
	    var newDate = new Date(date);
	    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
	    return newDate;
	  }
	
	  function modelIsEmpty() {
	    return ($scope.hours === null || $scope.hours === '') &&
	      ($scope.minutes === null || $scope.minutes === '') &&
	      (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
	  }
	
	  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
	    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;
	
	  $scope.incrementHours = function() {
	    if (!$scope.noIncrementHours()) {
	      addSecondsToSelected(hourStep * 60 * 60);
	    }
	  };
	
	  $scope.decrementHours = function() {
	    if (!$scope.noDecrementHours()) {
	      addSecondsToSelected(-hourStep * 60 * 60);
	    }
	  };
	
	  $scope.incrementMinutes = function() {
	    if (!$scope.noIncrementMinutes()) {
	      addSecondsToSelected(minuteStep * 60);
	    }
	  };
	
	  $scope.decrementMinutes = function() {
	    if (!$scope.noDecrementMinutes()) {
	      addSecondsToSelected(-minuteStep * 60);
	    }
	  };
	
	  $scope.incrementSeconds = function() {
	    if (!$scope.noIncrementSeconds()) {
	      addSecondsToSelected(secondStep);
	    }
	  };
	
	  $scope.decrementSeconds = function() {
	    if (!$scope.noDecrementSeconds()) {
	      addSecondsToSelected(-secondStep);
	    }
	  };
	
	  $scope.toggleMeridian = function() {
	    var minutes = getMinutesFromTemplate(),
	        hours = getHoursFromTemplate();
	
	    if (!$scope.noToggleMeridian()) {
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
	      } else {
	        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
	      }
	    }
	  };
	
	  $scope.blur = function() {
	    ngModelCtrl.$setTouched();
	  };
	
	  $scope.$on('$destroy', function() {
	    while (watchers.length) {
	      watchers.shift()();
	    }
	  });
	}])
	
	.directive('uibTimepicker', ['uibTimepickerConfig', function(uibTimepickerConfig) {
	  return {
	    require: ['uibTimepicker', '?^ngModel'],
	    restrict: 'A',
	    controller: 'UibTimepickerController',
	    controllerAs: 'timepicker',
	    scope: {},
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
	    },
	    link: function(scope, element, attrs, ctrls) {
	      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (ngModelCtrl) {
	        timepickerCtrl.init(ngModelCtrl, element.find('input'));
	      }
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])
	
	/**
	 * A helper service that can parse typeahead's syntax (string provided by users)
	 * Extracted to a separate service for ease of unit testing
	 */
	  .factory('uibTypeaheadParser', ['$parse', function($parse) {
	    //                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000
	    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
	    return {
	      parse: function(input) {
	        var match = input.match(TYPEAHEAD_REGEXP);
	        if (!match) {
	          throw new Error(
	            'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
	              ' but got "' + input + '".');
	        }
	
	        return {
	          itemName: match[3],
	          source: $parse(match[4]),
	          viewMapper: $parse(match[2] || match[1]),
	          modelMapper: $parse(match[1])
	        };
	      }
	    };
	  }])
	
	  .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
	    function(originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
	    var HOT_KEYS = [9, 13, 27, 38, 40];
	    var eventDebounceTime = 200;
	    var modelCtrl, ngModelOptions;
	    //SUPPORTED ATTRIBUTES (OPTIONS)
	
	    //minimal no of characters that needs to be entered before typeahead kicks-in
	    var minLength = originalScope.$eval(attrs.typeaheadMinLength);
	    if (!minLength && minLength !== 0) {
	      minLength = 1;
	    }
	
	    originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
	        minLength = !newVal && newVal !== 0 ? 1 : newVal;
	    });
	
	    //minimal wait time after last character typed before typeahead kicks-in
	    var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;
	
	    //should it restrict model values to the ones selected from the popup only?
	    var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
	    originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
	      isEditable = newVal !== false;
	    });
	
	    //binding to a variable that indicates if matches are being retrieved asynchronously
	    var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;
	
	    //a function to determine if an event should cause selection
	    var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function(scope, vals) {
	      var evt = vals.$event;
	      return evt.which === 13 || evt.which === 9;
	    };
	
	    //a callback executed when a match is selected
	    var onSelectCallback = $parse(attrs.typeaheadOnSelect);
	
	    //should it select highlighted popup value when losing focus?
	    var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;
	
	    //binding to a variable that indicates if there were no results after the query is completed
	    var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;
	
	    var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;
	
	    var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;
	
	    var appendTo = attrs.typeaheadAppendTo ?
	      originalScope.$eval(attrs.typeaheadAppendTo) : null;
	
	    var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;
	
	    //If input matches an item of the list exactly, select it automatically
	    var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;
	
	    //binding to a variable that indicates if dropdown is open
	    var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;
	
	    var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;
	
	    //INTERNAL VARIABLES
	
	    //model setter executed upon match selection
	    var parsedModel = $parse(attrs.ngModel);
	    var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
	    var $setModelValue = function(scope, newValue) {
	      if (angular.isFunction(parsedModel(originalScope)) &&
	        ngModelOptions.getOption('getterSetter')) {
	        return invokeModelSetter(scope, {$$$p: newValue});
	      }
	
	      return parsedModel.assign(scope, newValue);
	    };
	
	    //expressions used by typeahead
	    var parserResult = typeaheadParser.parse(attrs.uibTypeahead);
	
	    var hasFocus;
	
	    //Used to avoid bug in iOS webview where iOS keyboard does not fire
	    //mousedown & mouseup events
	    //Issue #3699
	    var selected;
	
	    //create a child scope for the typeahead directive so we are not polluting original scope
	    //with typeahead-specific data (matches, query etc.)
	    var scope = originalScope.$new();
	    var offDestroy = originalScope.$on('$destroy', function() {
	      scope.$destroy();
	    });
	    scope.$on('$destroy', offDestroy);
	
	    // WAI-ARIA
	    var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	    element.attr({
	      'aria-autocomplete': 'list',
	      'aria-expanded': false,
	      'aria-owns': popupId
	    });
	
	    var inputsContainer, hintInputElem;
	    //add read-only input to show hint
	    if (showHint) {
	      inputsContainer = angular.element('<div></div>');
	      inputsContainer.css('position', 'relative');
	      element.after(inputsContainer);
	      hintInputElem = element.clone();
	      hintInputElem.attr('placeholder', '');
	      hintInputElem.attr('tabindex', '-1');
	      hintInputElem.val('');
	      hintInputElem.css({
	        'position': 'absolute',
	        'top': '0px',
	        'left': '0px',
	        'border-color': 'transparent',
	        'box-shadow': 'none',
	        'opacity': 1,
	        'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
	        'color': '#999'
	      });
	      element.css({
	        'position': 'relative',
	        'vertical-align': 'top',
	        'background-color': 'transparent'
	      });
	
	      if (hintInputElem.attr('id')) {
	        hintInputElem.removeAttr('id'); // remove duplicate id if present.
	      }
	      inputsContainer.append(hintInputElem);
	      hintInputElem.after(element);
	    }
	
	    //pop-up element used to display matches
	    var popUpEl = angular.element('<div uib-typeahead-popup></div>');
	    popUpEl.attr({
	      id: popupId,
	      matches: 'matches',
	      active: 'activeIdx',
	      select: 'select(activeIdx, evt)',
	      'move-in-progress': 'moveInProgress',
	      query: 'query',
	      position: 'position',
	      'assign-is-open': 'assignIsOpen(isOpen)',
	      debounce: 'debounceUpdate'
	    });
	    //custom item template
	    if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
	      popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
	    }
	
	    if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
	      popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
	    }
	
	    var resetHint = function() {
	      if (showHint) {
	        hintInputElem.val('');
	      }
	    };
	
	    var resetMatches = function() {
	      scope.matches = [];
	      scope.activeIdx = -1;
	      element.attr('aria-expanded', false);
	      resetHint();
	    };
	
	    var getMatchId = function(index) {
	      return popupId + '-option-' + index;
	    };
	
	    // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
	    // This attribute is added or removed automatically when the `activeIdx` changes.
	    scope.$watch('activeIdx', function(index) {
	      if (index < 0) {
	        element.removeAttr('aria-activedescendant');
	      } else {
	        element.attr('aria-activedescendant', getMatchId(index));
	      }
	    });
	
	    var inputIsExactMatch = function(inputValue, index) {
	      if (scope.matches.length > index && inputValue) {
	        return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
	      }
	
	      return false;
	    };
	
	    var getMatchesAsync = function(inputValue, evt) {
	      var locals = {$viewValue: inputValue};
	      isLoadingSetter(originalScope, true);
	      isNoResultsSetter(originalScope, false);
	      $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
	        //it might happen that several async queries were in progress if a user were typing fast
	        //but we are interested only in responses that correspond to the current view value
	        var onCurrentRequest = inputValue === modelCtrl.$viewValue;
	        if (onCurrentRequest && hasFocus) {
	          if (matches && matches.length > 0) {
	            scope.activeIdx = focusFirst ? 0 : -1;
	            isNoResultsSetter(originalScope, false);
	            scope.matches.length = 0;
	
	            //transform labels
	            for (var i = 0; i < matches.length; i++) {
	              locals[parserResult.itemName] = matches[i];
	              scope.matches.push({
	                id: getMatchId(i),
	                label: parserResult.viewMapper(scope, locals),
	                model: matches[i]
	              });
	            }
	
	            scope.query = inputValue;
	            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
	            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
	            //due to other elements being rendered
	            recalculatePosition();
	
	            element.attr('aria-expanded', true);
	
	            //Select the single remaining option if user input matches
	            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
	              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
	                $$debounce(function() {
	                  scope.select(0, evt);
	                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
	              } else {
	                scope.select(0, evt);
	              }
	            }
	
	            if (showHint) {
	              var firstLabel = scope.matches[0].label;
	              if (angular.isString(inputValue) &&
	                inputValue.length > 0 &&
	                firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
	                hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
	              } else {
	                hintInputElem.val('');
	              }
	            }
	          } else {
	            resetMatches();
	            isNoResultsSetter(originalScope, true);
	          }
	        }
	        if (onCurrentRequest) {
	          isLoadingSetter(originalScope, false);
	        }
	      }, function() {
	        resetMatches();
	        isLoadingSetter(originalScope, false);
	        isNoResultsSetter(originalScope, true);
	      });
	    };
	
	    // bind events only if appendToBody params exist - performance feature
	    if (appendToBody) {
	      angular.element($window).on('resize', fireRecalculating);
	      $document.find('body').on('scroll', fireRecalculating);
	    }
	
	    // Declare the debounced function outside recalculating for
	    // proper debouncing
	    var debouncedRecalculate = $$debounce(function() {
	      // if popup is visible
	      if (scope.matches.length) {
	        recalculatePosition();
	      }
	
	      scope.moveInProgress = false;
	    }, eventDebounceTime);
	
	    // Default progress type
	    scope.moveInProgress = false;
	
	    function fireRecalculating() {
	      if (!scope.moveInProgress) {
	        scope.moveInProgress = true;
	        scope.$digest();
	      }
	
	      debouncedRecalculate();
	    }
	
	    // recalculate actual position and set new values to scope
	    // after digest loop is popup in right position
	    function recalculatePosition() {
	      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	      scope.position.top += element.prop('offsetHeight');
	    }
	
	    //we need to propagate user's query so we can higlight matches
	    scope.query = undefined;
	
	    //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	    var timeoutPromise;
	
	    var scheduleSearchWithTimeout = function(inputValue) {
	      timeoutPromise = $timeout(function() {
	        getMatchesAsync(inputValue);
	      }, waitTime);
	    };
	
	    var cancelPreviousTimeout = function() {
	      if (timeoutPromise) {
	        $timeout.cancel(timeoutPromise);
	      }
	    };
	
	    resetMatches();
	
	    scope.assignIsOpen = function (isOpen) {
	      isOpenSetter(originalScope, isOpen);
	    };
	
	    scope.select = function(activeIdx, evt) {
	      //called from within the $digest() cycle
	      var locals = {};
	      var model, item;
	
	      selected = true;
	      locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
	      model = parserResult.modelMapper(originalScope, locals);
	      $setModelValue(originalScope, model);
	      modelCtrl.$setValidity('editable', true);
	      modelCtrl.$setValidity('parse', true);
	
	      onSelectCallback(originalScope, {
	        $item: item,
	        $model: model,
	        $label: parserResult.viewMapper(originalScope, locals),
	        $event: evt
	      });
	
	      resetMatches();
	
	      //return focus to the input element if a match was selected via a mouse click event
	      // use timeout to avoid $rootScope:inprog error
	      if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
	        $timeout(function() { element[0].focus(); }, 0, false);
	      }
	    };
	
	    //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
	    element.on('keydown', function(evt) {
	      //typeahead is open and an "interesting" key was pressed
	      if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
	        return;
	      }
	
	      var shouldSelect = isSelectEvent(originalScope, {$event: evt});
	
	      /**
	       * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
	       * or
	       * shift + tab is pressed to bring focus to the previous element
	       * then clear the results
	       */
	      if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
	        resetMatches();
	        scope.$digest();
	        return;
	      }
	
	      evt.preventDefault();
	      var target;
	      switch (evt.which) {
	        case 27: // escape
	          evt.stopPropagation();
	
	          resetMatches();
	          originalScope.$digest();
	          break;
	        case 38: // up arrow
	          scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
	          scope.$digest();
	          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
	          target.parentNode.scrollTop = target.offsetTop;
	          break;
	        case 40: // down arrow
	          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
	          scope.$digest();
	          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
	          target.parentNode.scrollTop = target.offsetTop;
	          break;
	        default:
	          if (shouldSelect) {
	            scope.$apply(function() {
	              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
	                $$debounce(function() {
	                  scope.select(scope.activeIdx, evt);
	                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
	              } else {
	                scope.select(scope.activeIdx, evt);
	              }
	            });
	          }
	      }
	    });
	
	    element.on('focus', function (evt) {
	      hasFocus = true;
	      if (minLength === 0 && !modelCtrl.$viewValue) {
	        $timeout(function() {
	          getMatchesAsync(modelCtrl.$viewValue, evt);
	        }, 0);
	      }
	    });
	
	    element.on('blur', function(evt) {
	      if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
	        selected = true;
	        scope.$apply(function() {
	          if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
	            $$debounce(function() {
	              scope.select(scope.activeIdx, evt);
	            }, scope.debounceUpdate.blur);
	          } else {
	            scope.select(scope.activeIdx, evt);
	          }
	        });
	      }
	      if (!isEditable && modelCtrl.$error.editable) {
	        modelCtrl.$setViewValue();
	        scope.$apply(function() {
	          // Reset validity as we are clearing
	          modelCtrl.$setValidity('editable', true);
	          modelCtrl.$setValidity('parse', true);
	        });
	        element.val('');
	      }
	      hasFocus = false;
	      selected = false;
	    });
	
	    // Keep reference to click handler to unbind it.
	    var dismissClickHandler = function(evt) {
	      // Issue #3973
	      // Firefox treats right click as a click on document
	      if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
	        resetMatches();
	        if (!$rootScope.$$phase) {
	          originalScope.$digest();
	        }
	      }
	    };
	
	    $document.on('click', dismissClickHandler);
	
	    originalScope.$on('$destroy', function() {
	      $document.off('click', dismissClickHandler);
	      if (appendToBody || appendTo) {
	        $popup.remove();
	      }
	
	      if (appendToBody) {
	        angular.element($window).off('resize', fireRecalculating);
	        $document.find('body').off('scroll', fireRecalculating);
	      }
	      // Prevent jQuery cache memory leak
	      popUpEl.remove();
	
	      if (showHint) {
	          inputsContainer.remove();
	      }
	    });
	
	    var $popup = $compile(popUpEl)(scope);
	
	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else if (appendTo) {
	      angular.element(appendTo).eq(0).append($popup);
	    } else {
	      element.after($popup);
	    }
	
	    this.init = function(_modelCtrl) {
	      modelCtrl = _modelCtrl;
	      ngModelOptions = extractOptions(modelCtrl);
	
	      scope.debounceUpdate = $parse(ngModelOptions.getOption('debounce'))(originalScope);
	
	      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
	      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
	      modelCtrl.$parsers.unshift(function(inputValue) {
	        hasFocus = true;
	
	        if (minLength === 0 || inputValue && inputValue.length >= minLength) {
	          if (waitTime > 0) {
	            cancelPreviousTimeout();
	            scheduleSearchWithTimeout(inputValue);
	          } else {
	            getMatchesAsync(inputValue);
	          }
	        } else {
	          isLoadingSetter(originalScope, false);
	          cancelPreviousTimeout();
	          resetMatches();
	        }
	
	        if (isEditable) {
	          return inputValue;
	        }
	
	        if (!inputValue) {
	          // Reset in case user had typed something previously.
	          modelCtrl.$setValidity('editable', true);
	          return null;
	        }
	
	        modelCtrl.$setValidity('editable', false);
	        return undefined;
	      });
	
	      modelCtrl.$formatters.push(function(modelValue) {
	        var candidateViewValue, emptyViewValue;
	        var locals = {};
	
	        // The validity may be set to false via $parsers (see above) if
	        // the model is restricted to selected values. If the model
	        // is set manually it is considered to be valid.
	        if (!isEditable) {
	          modelCtrl.$setValidity('editable', true);
	        }
	
	        if (inputFormatter) {
	          locals.$model = modelValue;
	          return inputFormatter(originalScope, locals);
	        }
	
	        //it might happen that we don't have enough info to properly render input value
	        //we need to check for this situation and simply return model value if we can't apply custom formatting
	        locals[parserResult.itemName] = modelValue;
	        candidateViewValue = parserResult.viewMapper(originalScope, locals);
	        locals[parserResult.itemName] = undefined;
	        emptyViewValue = parserResult.viewMapper(originalScope, locals);
	
	        return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
	      });
	    };
	
	    function extractOptions(ngModelCtrl) {
	      var ngModelOptions;
	
	      if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
	        // guarantee a value
	        ngModelOptions = ngModelCtrl.$options || {};
	
	        // mimic 1.6+ api
	        ngModelOptions.getOption = function (key) {
	          return ngModelOptions[key];
	        };
	      } else { // in angular >=1.6 $options is always present
	        ngModelOptions = ngModelCtrl.$options;
	      }
	
	      return ngModelOptions;
	    }
	  }])
	
	  .directive('uibTypeahead', function() {
	    return {
	      controller: 'UibTypeaheadController',
	      require: ['ngModel', 'uibTypeahead'],
	      link: function(originalScope, element, attrs, ctrls) {
	        ctrls[1].init(ctrls[0]);
	      }
	    };
	  })
	
	  .directive('uibTypeaheadPopup', ['$$debounce', function($$debounce) {
	    return {
	      scope: {
	        matches: '=',
	        query: '=',
	        active: '=',
	        position: '&',
	        moveInProgress: '=',
	        select: '&',
	        assignIsOpen: '&',
	        debounce: '&'
	      },
	      replace: true,
	      templateUrl: function(element, attrs) {
	        return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
	      },
	      link: function(scope, element, attrs) {
	        scope.templateUrl = attrs.templateUrl;
	
	        scope.isOpen = function() {
	          var isDropdownOpen = scope.matches.length > 0;
	          scope.assignIsOpen({ isOpen: isDropdownOpen });
	          return isDropdownOpen;
	        };
	
	        scope.isActive = function(matchIdx) {
	          return scope.active === matchIdx;
	        };
	
	        scope.selectActive = function(matchIdx) {
	          scope.active = matchIdx;
	        };
	
	        scope.selectMatch = function(activeIdx, evt) {
	          var debounce = scope.debounce();
	          if (angular.isNumber(debounce) || angular.isObject(debounce)) {
	            $$debounce(function() {
	              scope.select({activeIdx: activeIdx, evt: evt});
	            }, angular.isNumber(debounce) ? debounce : debounce['default']);
	          } else {
	            scope.select({activeIdx: activeIdx, evt: evt});
	          }
	        };
	      }
	    };
	  }])
	
	  .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
	    return {
	      scope: {
	        index: '=',
	        match: '=',
	        query: '='
	      },
	      link: function(scope, element, attrs) {
	        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
	        $templateRequest(tplUrl).then(function(tplContent) {
	          var tplEl = angular.element(tplContent.trim());
	          element.replaceWith(tplEl);
	          $compile(tplEl)(scope);
	        });
	      }
	    };
	  }])
	
	  .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
	    var isSanitizePresent;
	    isSanitizePresent = $injector.has('$sanitize');
	
	    function escapeRegexp(queryToEscape) {
	      // Regex: capture the whole query string and replace it with the string that will be used to match
	      // the results, for example if the capture is "a" the result will be \a
	      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    }
	
	    function containsHtml(matchItem) {
	      return /<.*>/g.test(matchItem);
	    }
	
	    return function(matchItem, query) {
	      if (!isSanitizePresent && containsHtml(matchItem)) {
	        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
	      }
	      matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
	      if (!isSanitizePresent) {
	        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
	      }
	      return matchItem;
	    };
	  }]);
	
	angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/accordion/accordion-group.html",
	    "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
	    "  <h4 class=\"panel-title\">\n" +
	    "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
	    "  </h4>\n" +
	    "</div>\n" +
	    "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
	    "  <div class=\"panel-body\" ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/accordion/accordion.html",
	    "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
	}]);
	
	angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/alert/alert.html",
	    "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
	    "  <span aria-hidden=\"true\">&times;</span>\n" +
	    "  <span class=\"sr-only\">Close</span>\n" +
	    "</button>\n" +
	    "<div ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/carousel/carousel.html",
	    "<div class=\"carousel-inner\" ng-transclude></div>\n" +
	    "<a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\">\n" +
	    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
	    "  <span class=\"sr-only\">previous</span>\n" +
	    "</a>\n" +
	    "<a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\">\n" +
	    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
	    "  <span class=\"sr-only\">next</span>\n" +
	    "</a>\n" +
	    "<ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
	    "  <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
	    "    <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
	    "  </li>\n" +
	    "</ol>\n" +
	    "");
	}]);
	
	angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/carousel/slide.html",
	    "<div class=\"text-center\" ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/datepicker.html",
	    "<div ng-switch=\"datepickerMode\">\n" +
	    "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" +
	    "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" +
	    "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/day.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
	    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
	    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
	    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
	    "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
	    "        id=\"{{::dt.uid}}\"\n" +
	    "        ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
	    "          uib-is-class=\"\n" +
	    "            'btn-info' for selectedDt,\n" +
	    "            'active' for activeDt\n" +
	    "            on dt\"\n" +
	    "          ng-click=\"select(dt.date)\"\n" +
	    "          ng-disabled=\"::dt.disabled\"\n" +
	    "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/month.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
	    "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
	    "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
	    "        id=\"{{::dt.uid}}\"\n" +
	    "        ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" class=\"btn btn-default\"\n" +
	    "          uib-is-class=\"\n" +
	    "            'btn-info' for selectedDt,\n" +
	    "            'active' for activeDt\n" +
	    "            on dt\"\n" +
	    "          ng-click=\"select(dt.date)\"\n" +
	    "          ng-disabled=\"::dt.disabled\"\n" +
	    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/datepicker/popup.html",
	    "<div>\n" +
	    "  <ul class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
	    "    <li ng-transclude></li>\n" +
	    "    <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
	    "      <span class=\"btn-group pull-left\">\n" +
	    "        <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
	    "        <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
	    "      </span>\n" +
	    "      <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
	    "    </li>\n" +
	    "  </ul>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/year.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
	    "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
	    "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
	    "        id=\"{{::dt.uid}}\"\n" +
	    "        ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" class=\"btn btn-default\"\n" +
	    "          uib-is-class=\"\n" +
	    "            'btn-info' for selectedDt,\n" +
	    "            'active' for activeDt\n" +
	    "            on dt\"\n" +
	    "          ng-click=\"select(dt.date)\"\n" +
	    "          ng-disabled=\"::dt.disabled\"\n" +
	    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepickerPopup/popup.html",
	    "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
	    "  <li ng-transclude></li>\n" +
	    "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
	    "    <span class=\"btn-group pull-left\">\n" +
	    "      <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
	    "      <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
	    "    </span>\n" +
	    "    <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
	    "  </li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	
	angular.module("uib/template/modal/backdrop.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/modal/backdrop.html",
	    "<div class=\"modal-backdrop\"\n" +
	    "     uib-modal-animation-class=\"fade\"\n" +
	    "     modal-in-class=\"in\"\n" +
	    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
	    "></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/modal/window.html",
	    "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/pager/pager.html",
	    "<li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
	    "<li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
	    "");
	}]);
	
	angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/pagination/pagination.html",
	    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\"\n" +
	    "  uib-tooltip-template-transclude=\"contentExp()\"\n" +
	    "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover-html.html",
	    "<div class=\"arrow\"></div>\n" +
	    "\n" +
	    "<div class=\"popover-inner\">\n" +
	    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
	    "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover-template.html",
	    "<div class=\"arrow\"></div>\n" +
	    "\n" +
	    "<div class=\"popover-inner\">\n" +
	    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
	    "    <div class=\"popover-content\"\n" +
	    "      uib-tooltip-template-transclude=\"contentExp()\"\n" +
	    "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover.html",
	    "<div class=\"arrow\"></div>\n" +
	    "\n" +
	    "<div class=\"popover-inner\">\n" +
	    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
	    "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/bar.html",
	    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/progress.html",
	    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
	}]);
	
	angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/progressbar.html",
	    "<div class=\"progress\">\n" +
	    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/rating/rating.html",
	    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
	    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
	    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
	    "</span>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tabs/tab.html",
	    "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
	    "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
	    "</li>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tabs/tabset.html",
	    "<div>\n" +
	    "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
	    "  <div class=\"tab-content\">\n" +
	    "    <div class=\"tab-pane\"\n" +
	    "         ng-repeat=\"tab in tabset.tabs\"\n" +
	    "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
	    "         uib-tab-content-transclude=\"tab\">\n" +
	    "    </div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/timepicker/timepicker.html",
	    "<table class=\"uib-timepicker\">\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
	    "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td>&nbsp;</td>\n" +
	    "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
	    "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td ng-show=\"showMeridian\"></td>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
	    "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
	    "      </td>\n" +
	    "      <td class=\"uib-separator\">:</td>\n" +
	    "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
	    "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
	    "      </td>\n" +
	    "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
	    "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
	    "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
	    "      </td>\n" +
	    "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
	    "    </tr>\n" +
	    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
	    "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td>&nbsp;</td>\n" +
	    "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
	    "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td ng-show=\"showMeridian\"></td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/typeahead/typeahead-match.html",
	    "<a href\n" +
	    "   tabindex=\"-1\"\n" +
	    "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
	    "   ng-attr-title=\"{{match.label}}\"></a>\n" +
	    "");
	}]);
	
	angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/typeahead/typeahead-popup.html",
	    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
	    "    <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
	    "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
	    "    </li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	angular.module('ui.bootstrap.carousel').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>'); angular.$$uibCarouselCss = true; });
	angular.module('ui.bootstrap.datepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'); angular.$$uibDatepickerCss = true; });
	angular.module('ui.bootstrap.position').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'); angular.$$uibPositionCss = true; });
	angular.module('ui.bootstrap.datepickerPopup').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'); angular.$$uibDatepickerpopupCss = true; });
	angular.module('ui.bootstrap.tooltip').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'); angular.$$uibTooltipCss = true; });
	angular.module('ui.bootstrap.timepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>'); angular.$$uibTimepickerCss = true; });
	angular.module('ui.bootstrap.typeahead').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'); angular.$$uibTypeaheadCss = true; });

/***/ },

/***/ 144:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(143);
	
	module.exports = 'ui.bootstrap';


/***/ },

/***/ 145:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(146);
	module.exports = 'ui.grid';


/***/ },

/***/ 146:
/***/ function(module, exports) {

	/*!
	 * ui-grid - v4.11.1 - 2022-02-23
	 * Copyright (c) 2022 ; License: MIT 
	 */
	
	(function() {
		'use strict';
	
		angular.module('ui.grid.i18n', []);
		angular.module('ui.grid', ['ui.grid.i18n']);
	})();
	
	(function() {
	  'use strict';
	  /**
	   *  @ngdoc overview
	   *  @name ui.grid.autoResize
	   *
	   *  @description
	   *
	   *  #ui.grid.autoResize
	   *
	   *  <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   *  This module provides auto-resizing functionality to UI-Grid.
	   */
	  var module = angular.module('ui.grid.autoResize', ['ui.grid']);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.autoResize.directive:uiGridAutoResize
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Stacks on top of the ui-grid directive and
	   *  adds the a watch to the grid's height and width which refreshes
	   *  the grid content whenever its dimensions change.
	   *
	   */
	  module.directive('uiGridAutoResize', ['gridUtil', function(gridUtil) {
	    return {
	      require: 'uiGrid',
	      scope: false,
	      link: function($scope, $elm, $attrs, uiGridCtrl) {
	        var debouncedRefresh;
	
	        function getDimensions() {
	          return {
	            width: gridUtil.elementWidth($elm),
	            height: gridUtil.elementHeight($elm)
	          };
	        }
	
	        function refreshGrid(prevWidth, prevHeight, width, height) {
	          if ($elm[0].offsetParent !== null) {
	            uiGridCtrl.grid.gridWidth = width;
	            uiGridCtrl.grid.gridHeight = height;
	            uiGridCtrl.grid.queueGridRefresh()
	              .then(function() {
	                uiGridCtrl.grid.api.core.raise.gridDimensionChanged(prevHeight, prevWidth, height, width);
	              });
	          }
	        }
	
	        debouncedRefresh = gridUtil.debounce(refreshGrid, 400);
	
	        $scope.$watchCollection(getDimensions, function(newValues, oldValues) {
	          if (!angular.equals(newValues, oldValues)) {
	            debouncedRefresh(oldValues.width, oldValues.height, newValues.width, newValues.height);
	          }
	        });
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   *  @ngdoc overview
	   *  @name ui.grid.cellNav
	   *
	   *  @description
	
	      #ui.grid.cellNav
	
	      <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	
	      This module provides cell navigation functionality to UI-Grid.
	   */
	  var module = angular.module('ui.grid.cellNav', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.cellNav.constant:uiGridCellNavConstants
	   *
	   *  @description constants available in cellNav
	   */
	  module.constant('uiGridCellNavConstants', {
	    FEATURE_NAME: 'gridCellNav',
	    CELL_NAV_EVENT: 'cellNav',
	    direction: {LEFT: 0, RIGHT: 1, UP: 2, DOWN: 3, PG_UP: 4, PG_DOWN: 5},
	    EVENT_TYPE: {
	      KEYDOWN: 0,
	      CLICK: 1,
	      CLEAR: 2
	    }
	  });
	
	
	  module.factory('uiGridCellNavFactory', ['gridUtil', 'uiGridConstants', 'uiGridCellNavConstants', 'GridRowColumn', '$q',
	    function (gridUtil, uiGridConstants, uiGridCellNavConstants, GridRowColumn, $q) {
	      /**
	       *  @ngdoc object
	       *  @name ui.grid.cellNav.object:CellNav
	       *  @description returns a CellNav prototype function
	       *  @param {object} rowContainer container for rows
	       *  @param {object} colContainer parent column container
	       *  @param {object} leftColContainer column container to the left of parent
	       *  @param {object} rightColContainer column container to the right of parent
	       */
	      var UiGridCellNav = function UiGridCellNav(rowContainer, colContainer, leftColContainer, rightColContainer) {
	        this.rows = rowContainer.visibleRowCache;
	        this.columns = colContainer.visibleColumnCache;
	        this.leftColumns = leftColContainer ? leftColContainer.visibleColumnCache : [];
	        this.rightColumns = rightColContainer ? rightColContainer.visibleColumnCache : [];
	        this.bodyContainer = rowContainer;
	      };
	
	      /** returns focusable columns of all containers */
	      UiGridCellNav.prototype.getFocusableCols = function () {
	        var allColumns = this.leftColumns.concat(this.columns, this.rightColumns);
	
	        return allColumns.filter(function (col) {
	          return col.colDef.allowCellFocus;
	        });
	      };
	
	      /**
	       *  @ngdoc object
	       *  @name ui.grid.cellNav.api:GridRow
	       *
	       *  @description GridRow settings for cellNav feature, these are available to be
	       *  set only internally (for example, by other features)
	       */
	
	      /**
	       *  @ngdoc object
	       *  @name allowCellFocus
	       *  @propertyOf  ui.grid.cellNav.api:GridRow
	       *  @description Enable focus on a cell within this row.  If set to false then no cells
	       *  in this row can be focused - group header rows as an example would set this to false.
	       *  <br/>Defaults to true
	       */
	      /** returns focusable rows */
	      UiGridCellNav.prototype.getFocusableRows = function () {
	        return this.rows.filter(function(row) {
	          return row.allowCellFocus !== false;
	        });
	      };
	
	      UiGridCellNav.prototype.getNextRowCol = function (direction, curRow, curCol) {
	        switch (direction) {
	          case uiGridCellNavConstants.direction.LEFT:
	            return this.getRowColLeft(curRow, curCol);
	          case uiGridCellNavConstants.direction.RIGHT:
	            return this.getRowColRight(curRow, curCol);
	          case uiGridCellNavConstants.direction.UP:
	            return this.getRowColUp(curRow, curCol);
	          case uiGridCellNavConstants.direction.DOWN:
	            return this.getRowColDown(curRow, curCol);
	          case uiGridCellNavConstants.direction.PG_UP:
	            return this.getRowColPageUp(curRow, curCol);
	          case uiGridCellNavConstants.direction.PG_DOWN:
	            return this.getRowColPageDown(curRow, curCol);
	        }
	      };
	
	      UiGridCellNav.prototype.initializeSelection = function () {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        if (focusableCols.length === 0 || focusableRows.length === 0) {
	          return null;
	        }
	
	        return new GridRowColumn(focusableRows[0], focusableCols[0]); // return same row
	      };
	
	      UiGridCellNav.prototype.getRowColLeft = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        // could not find column in focusable Columns so set it to 1
	        if (curColIndex === -1) {
	          curColIndex = 1;
	        }
	
	        var nextColIndex = curColIndex === 0 ? focusableCols.length - 1 : curColIndex - 1;
	
	        // get column to left
	        if (nextColIndex >= curColIndex) {
	          // On the first row
	          // if (curRowIndex === 0 && curColIndex === 0) {
	          //   return null;
	          // }
	          if (curRowIndex === 0) {
	            return new GridRowColumn(curRow, focusableCols[nextColIndex]); // return same row
	          }
	          else {
	            // up one row and far right column
	            return new GridRowColumn(focusableRows[curRowIndex - 1], focusableCols[nextColIndex]);
	          }
	        }
	        else {
	          return new GridRowColumn(curRow, focusableCols[nextColIndex]);
	        }
	      };
	
	
	
	      UiGridCellNav.prototype.getRowColRight = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        // could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	        var nextColIndex = curColIndex === focusableCols.length - 1 ? 0 : curColIndex + 1;
	
	        if (nextColIndex <= curColIndex) {
	          if (curRowIndex === focusableRows.length - 1) {
	            return new GridRowColumn(curRow, focusableCols[nextColIndex]); // return same row
	          }
	          else {
	            // down one row and far left column
	            return new GridRowColumn(focusableRows[curRowIndex + 1], focusableCols[nextColIndex]);
	          }
	        }
	        else {
	          return new GridRowColumn(curRow, focusableCols[nextColIndex]);
	        }
	      };
	
	      UiGridCellNav.prototype.getRowColDown = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        // could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	
	        if (curRowIndex === focusableRows.length - 1) {
	          return new GridRowColumn(curRow, focusableCols[curColIndex]); // return same row
	        }
	        else {
	          // down one row
	          return new GridRowColumn(focusableRows[curRowIndex + 1], focusableCols[curColIndex]);
	        }
	      };
	
	      UiGridCellNav.prototype.getRowColPageDown = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        // could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	
	        var pageSize = this.bodyContainer.minRowsToRender();
	        if (curRowIndex >= focusableRows.length - pageSize) {
	          return new GridRowColumn(focusableRows[focusableRows.length - 1], focusableCols[curColIndex]); // return last row
	        }
	        else {
	          // down one page
	          return new GridRowColumn(focusableRows[curRowIndex + pageSize], focusableCols[curColIndex]);
	        }
	      };
	
	      UiGridCellNav.prototype.getRowColUp = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        // could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	
	        if (curRowIndex === 0) {
	          return new GridRowColumn(curRow, focusableCols[curColIndex]); // return same row
	        }
	        else {
	          // up one row
	          return new GridRowColumn(focusableRows[curRowIndex - 1], focusableCols[curColIndex]);
	        }
	      };
	
	      UiGridCellNav.prototype.getRowColPageUp = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        // could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	
	        var pageSize = this.bodyContainer.minRowsToRender();
	        if (curRowIndex - pageSize < 0) {
	          return new GridRowColumn(focusableRows[0], focusableCols[curColIndex]); // return first row
	        }
	        else {
	          // up one page
	          return new GridRowColumn(focusableRows[curRowIndex - pageSize], focusableCols[curColIndex]);
	        }
	      };
	      return UiGridCellNav;
	    }]);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.cellNav.service:uiGridCellNavService
	   *
	   *  @description Services for cell navigation features. If you don't like the key maps we use,
	   *  or the direction cells navigation, override with a service decorator (see angular docs)
	   */
	  module.service('uiGridCellNavService', ['gridUtil', 'uiGridConstants', 'uiGridCellNavConstants', '$q', 'uiGridCellNavFactory', 'GridRowColumn', 'ScrollEvent',
	    function (gridUtil, uiGridConstants, uiGridCellNavConstants, $q, UiGridCellNav, GridRowColumn, ScrollEvent) {
	
	      var service = {
	
	        initializeGrid: function (grid) {
	          grid.registerColumnBuilder(service.cellNavColumnBuilder);
	
	
	          /**
	           * @ngdoc object
	           * @name ui.grid.cellNav.Grid:cellNav
	           * @description cellNav properties added to grid class
	           */
	          grid.cellNav = {};
	          grid.cellNav.lastRowCol = null;
	          grid.cellNav.focusedCells = [];
	
	          service.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.cellNav.api:PublicApi
	           *
	           *  @description Public Api for cellNav feature
	           */
	          var publicApi = {
	            events: {
	              cellNav: {
	                /**
	                 * @ngdoc event
	                 * @name navigate
	                 * @eventOf  ui.grid.cellNav.api:PublicApi
	                 * @description raised when the active cell is changed
	                 * <pre>
	                 *      gridApi.cellNav.on.navigate(scope,function(newRowcol, oldRowCol) {})
	                 * </pre>
	                 * @param {object} newRowCol new position
	                 * @param {object} oldRowCol old position
	                 */
	                navigate: function (newRowCol, oldRowCol) {},
	                /**
	                 * @ngdoc event
	                 * @name viewPortKeyDown
	                 * @eventOf  ui.grid.cellNav.api:PublicApi
	                 * @description  is raised when the viewPort receives a keyDown event. Cells never get focus in uiGrid
	                 * due to the difficulties of setting focus on a cell that is not visible in the viewport.  Use this
	                 * event whenever you need a keydown event on a cell
	                 * <br/>
	                 * @param {object} event keydown event
	                 * @param {object} rowCol current rowCol position
	                 */
	                viewPortKeyDown: function (event, rowCol) {},
	
	                /**
	                 * @ngdoc event
	                 * @name viewPortKeyPress
	                 * @eventOf  ui.grid.cellNav.api:PublicApi
	                 * @description  is raised when the viewPort receives a keyPress event. Cells never get focus in uiGrid
	                 * due to the difficulties of setting focus on a cell that is not visible in the viewport.  Use this
	                 * event whenever you need a keypress event on a cell
	                 * <br/>
	                 * @param {object} event keypress event
	                 * @param {object} rowCol current rowCol position
	                 */
	                viewPortKeyPress: function (event, rowCol) {}
	              }
	            },
	            methods: {
	              cellNav: {
	                /**
	                 * @ngdoc function
	                 * @name scrollToFocus
	                 * @methodOf  ui.grid.cellNav.api:PublicApi
	                 * @description brings the specified row and column into view, and sets focus
	                 * to that cell
	                 * @param {object} rowEntity gridOptions.data[] array instance to make visible and set focus
	                 * @param {object} colDef to make visible and set focus
	                 * @returns {promise} a promise that is resolved after any scrolling is finished
	                 */
	                scrollToFocus: function (rowEntity, colDef) {
	                  return service.scrollToFocus(grid, rowEntity, colDef);
	                },
	
	                /**
	                 * @ngdoc function
	                 * @name getFocusedCell
	                 * @methodOf  ui.grid.cellNav.api:PublicApi
	                 * @description returns the current (or last if Grid does not have focus) focused row and column
	                 * <br> value is null if no selection has occurred
	                 */
	                getFocusedCell: function () {
	                  return grid.cellNav.lastRowCol;
	                },
	
	                /**
	                 * @ngdoc function
	                 * @name getCurrentSelection
	                 * @methodOf  ui.grid.cellNav.api:PublicApi
	                 * @description returns an array containing the current selection
	                 * <br> array is empty if no selection has occurred
	                 */
	                getCurrentSelection: function () {
	                  return grid.cellNav.focusedCells;
	                },
	
	                /**
	                 * @ngdoc function
	                 * @name rowColSelectIndex
	                 * @methodOf  ui.grid.cellNav.api:PublicApi
	                 * @description returns the index in the order in which the GridRowColumn was selected, returns -1 if the GridRowColumn
	                 * isn't selected
	                 * @param {object} rowCol the rowCol to evaluate
	                 */
	                rowColSelectIndex: function (rowCol) {
	                  // return gridUtil.arrayContainsObjectWithProperty(grid.cellNav.focusedCells, 'col.uid', rowCol.col.uid) &&
	                  var index = -1;
	                  for (var i = 0; i < grid.cellNav.focusedCells.length; i++) {
	                    if (grid.cellNav.focusedCells[i].col.uid === rowCol.col.uid &&
	                      grid.cellNav.focusedCells[i].row.uid === rowCol.row.uid) {
	                      index = i;
	                      break;
	                    }
	                  }
	                  return index;
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	        },
	
	        defaultGridOptions: function (gridOptions) {
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.cellNav.api:GridOptions
	           *
	           *  @description GridOptions for cellNav feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name modifierKeysToMultiSelectCells
	           *  @propertyOf  ui.grid.cellNav.api:GridOptions
	           *  @description Enable multiple cell selection only when using the ctrlKey or shiftKey.
	           *  <br/>Defaults to false
	           */
	          gridOptions.modifierKeysToMultiSelectCells = gridOptions.modifierKeysToMultiSelectCells === true;
	
	          /**
	           *  @ngdoc array
	           *  @name keyDownOverrides
	           *  @propertyOf  ui.grid.cellNav.api:GridOptions
	           *  @description An array of event objects to override on keydown. If an event is overridden, the viewPortKeyDown event will
	           *               be raised with the overridden events, allowing custom keydown behavior.
	           *  <br/>Defaults to []
	           */
	          gridOptions.keyDownOverrides = gridOptions.keyDownOverrides || [];
	
	        },
	
	        /**
	         * @ngdoc service
	         * @name decorateRenderContainers
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @description  decorates grid renderContainers with cellNav functions
	         */
	        decorateRenderContainers: function (grid) {
	
	          var rightContainer = grid.hasRightContainer() ? grid.renderContainers.right : null;
	          var leftContainer = grid.hasLeftContainer() ? grid.renderContainers.left : null;
	
	          if (leftContainer !== null) {
	            grid.renderContainers.left.cellNav = new UiGridCellNav(grid.renderContainers.body, leftContainer, rightContainer, grid.renderContainers.body);
	          }
	          if (rightContainer !== null) {
	            grid.renderContainers.right.cellNav = new UiGridCellNav(grid.renderContainers.body, rightContainer, grid.renderContainers.body, leftContainer);
	          }
	
	          grid.renderContainers.body.cellNav = new UiGridCellNav(grid.renderContainers.body, grid.renderContainers.body, leftContainer, rightContainer);
	        },
	
	        /**
	         * @ngdoc service
	         * @name getDirection
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @description  determines which direction to for a given keyDown event
	         * @returns {uiGridCellNavConstants.direction} direction
	         */
	        getDirection: function (evt) {
	          if (evt.keyCode === uiGridConstants.keymap.LEFT ||
	            (evt.keyCode === uiGridConstants.keymap.TAB && evt.shiftKey)) {
	            return uiGridCellNavConstants.direction.LEFT;
	          }
	          if (evt.keyCode === uiGridConstants.keymap.RIGHT ||
	            evt.keyCode === uiGridConstants.keymap.TAB) {
	            return uiGridCellNavConstants.direction.RIGHT;
	          }
	
	          if (evt.keyCode === uiGridConstants.keymap.UP ||
	            (evt.keyCode === uiGridConstants.keymap.ENTER && evt.shiftKey) ) {
	            return uiGridCellNavConstants.direction.UP;
	          }
	
	          if (evt.keyCode === uiGridConstants.keymap.PG_UP) {
	            return uiGridCellNavConstants.direction.PG_UP;
	          }
	
	          if (evt.keyCode === uiGridConstants.keymap.DOWN ||
	            evt.keyCode === uiGridConstants.keymap.ENTER && !(evt.ctrlKey || evt.altKey)) {
	            return uiGridCellNavConstants.direction.DOWN;
	          }
	
	          if (evt.keyCode === uiGridConstants.keymap.PG_DOWN) {
	            return uiGridCellNavConstants.direction.PG_DOWN;
	          }
	
	          return null;
	        },
	
	        /**
	         * @ngdoc service
	         * @name cellNavColumnBuilder
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @description columnBuilder function that adds cell navigation properties to grid column
	         * @returns {promise} promise that will load any needed templates when resolved
	         */
	        cellNavColumnBuilder: function (colDef, col, gridOptions) {
	          var promises = [];
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.cellNav.api:ColumnDef
	           *
	           *  @description Column Definitions for cellNav feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name allowCellFocus
	           *  @propertyOf  ui.grid.cellNav.api:ColumnDef
	           *  @description Enable focus on a cell within this column.
	           *  <br/>Defaults to true
	           */
	          colDef.allowCellFocus = colDef.allowCellFocus === undefined ? true : colDef.allowCellFocus;
	
	          return $q.all(promises);
	        },
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @name scrollToFocus
	         * @description Scroll the grid such that the specified
	         * row and column is in view, and set focus to the cell in that row and column
	         * @param {Grid} grid the grid you'd like to act upon, usually available
	         * from gridApi.grid
	         * @param {object} rowEntity gridOptions.data[] array instance to make visible and set focus to
	         * @param {object} colDef to make visible and set focus to
	         * @returns {promise} a promise that is resolved after any scrolling is finished
	         */
	        scrollToFocus: function (grid, rowEntity, colDef) {
	          var gridRow = null, gridCol = null;
	
	          if (typeof(rowEntity) !== 'undefined' && rowEntity !== null) {
	            gridRow = grid.getRow(rowEntity);
	          }
	
	          if (typeof(colDef) !== 'undefined' && colDef !== null) {
	            gridCol = grid.getColumn(colDef.name ? colDef.name : colDef.field);
	          }
	          return grid.api.core.scrollToIfNecessary(gridRow, gridCol).then(function () {
	            var rowCol = { row: gridRow, col: gridCol };
	
	            // Broadcast the navigation
	            if (gridRow !== null && gridCol !== null) {
	              grid.cellNav.broadcastCellNav(rowCol, null, null);
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @name getLeftWidth
	         * @description Get the current drawn width of the columns in the
	         * grid up to the numbered column, and add an apportionment for the
	         * column that we're on.  So if we are on column 0, we want to scroll
	         * 0% (i.e. exclude this column from calc).  If we're on the last column
	         * we want to scroll to 100% (i.e. include this column in the calc). So
	         * we include (thisColIndex / totalNumberCols) % of this column width
	         * @param {Grid} grid the grid you'd like to act upon, usually available
	         * from gridApi.grid
	         * @param {GridColumn} upToCol the column to total up to and including
	         */
	        getLeftWidth: function (grid, upToCol) {
	          var width = 0;
	
	          if (!upToCol) {
	            return width;
	          }
	
	          var lastIndex = grid.renderContainers.body.visibleColumnCache.indexOf( upToCol );
	
	          // total column widths up-to but not including the passed in column
	          grid.renderContainers.body.visibleColumnCache.forEach( function( col, index ) {
	            if ( index < lastIndex ) {
	              width += col.drawnWidth;
	            }
	          });
	
	          // pro-rata the final column based on % of total columns.
	          var percentage = lastIndex === 0 ? 0 : (lastIndex + 1) / grid.renderContainers.body.visibleColumnCache.length;
	          width += upToCol.drawnWidth * percentage;
	
	          return width;
	        }
	      };
	
	      return service;
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.cellNav.directive:uiCellNav
	   *  @element div
	   *  @restrict EA
	   *
	   *  @description Adds cell navigation features to the grid columns
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.cellNav']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name'},
	        {name: 'title'}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-cellnav></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridCellnav', ['gridUtil', 'uiGridCellNavService', 'uiGridCellNavConstants', 'uiGridConstants', 'GridRowColumn', '$timeout', '$compile', 'i18nService',
	    function (gridUtil, uiGridCellNavService, uiGridCellNavConstants, uiGridConstants, GridRowColumn, $timeout, $compile, i18nService) {
	      return {
	        replace: true,
	        priority: -150,
	        require: '^uiGrid',
	        scope: false,
	        controller: function () {},
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              var _scope = $scope;
	
	              var grid = uiGridCtrl.grid;
	              uiGridCellNavService.initializeGrid(grid);
	
	              uiGridCtrl.cellNav = {};
	
	              // Ensure that the object has all of the methods we expect it to
	              uiGridCtrl.cellNav.makeRowCol = function (obj) {
	                if (!(obj instanceof GridRowColumn)) {
	                  obj = new GridRowColumn(obj.row, obj.col);
	                }
	                return obj;
	              };
	
	              uiGridCtrl.cellNav.getActiveCell = function () {
	                var elms = $elm[0].getElementsByClassName('ui-grid-cell-focus');
	                if (elms.length > 0) {
	                  return elms[0];
	                }
	
	                return undefined;
	              };
	
	              uiGridCtrl.cellNav.broadcastCellNav = grid.cellNav.broadcastCellNav = function (newRowCol, modifierDown, originEvt) {
	                modifierDown = !(modifierDown === undefined || !modifierDown);
	
	                newRowCol = uiGridCtrl.cellNav.makeRowCol(newRowCol);
	
	                uiGridCtrl.cellNav.broadcastFocus(newRowCol, modifierDown, originEvt);
	                _scope.$broadcast(uiGridCellNavConstants.CELL_NAV_EVENT, newRowCol, modifierDown, originEvt);
	              };
	
	              uiGridCtrl.cellNav.clearFocus = grid.cellNav.clearFocus = function () {
	                grid.cellNav.focusedCells = [];
	                _scope.$broadcast(uiGridCellNavConstants.CELL_NAV_EVENT);
	              };
	
	              uiGridCtrl.cellNav.broadcastFocus = function (rowCol, modifierDown, originEvt) {
	                modifierDown = !(modifierDown === undefined || !modifierDown);
	
	                rowCol = uiGridCtrl.cellNav.makeRowCol(rowCol);
	
	                var row = rowCol.row,
	                  col = rowCol.col;
	
	                var rowColSelectIndex = uiGridCtrl.grid.api.cellNav.rowColSelectIndex(rowCol);
	
	                if (grid.cellNav.lastRowCol === null || rowColSelectIndex === -1 || (grid.cellNav.lastRowCol.col === col && grid.cellNav.lastRowCol.row === row)) {
	                  var newRowCol = new GridRowColumn(row, col);
	
	                  if (grid.cellNav.lastRowCol === null || grid.cellNav.lastRowCol.row !== newRowCol.row || grid.cellNav.lastRowCol.col !== newRowCol.col || grid.options.enableCellEditOnFocus) {
	                    grid.api.cellNav.raise.navigate(newRowCol, grid.cellNav.lastRowCol, originEvt);
	                    grid.cellNav.lastRowCol = newRowCol;
	                  }
	                  if (uiGridCtrl.grid.options.modifierKeysToMultiSelectCells && modifierDown) {
	                    grid.cellNav.focusedCells.push(rowCol);
	                  } else {
	                    grid.cellNav.focusedCells = [rowCol];
	                  }
	                } else if (grid.options.modifierKeysToMultiSelectCells && modifierDown &&
	                  rowColSelectIndex >= 0) {
	
	                  grid.cellNav.focusedCells.splice(rowColSelectIndex, 1);
	                }
	              };
	
	              uiGridCtrl.cellNav.handleKeyDown = function (evt) {
	                var direction = uiGridCellNavService.getDirection(evt);
	                if (direction === null) {
	                  return null;
	                }
	
	                var containerId = 'body';
	                if (evt.uiGridTargetRenderContainerId) {
	                  containerId = evt.uiGridTargetRenderContainerId;
	                }
	
	                // Get the last-focused row+col combo
	                var lastRowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                if (lastRowCol) {
	                  // Figure out which new row+combo we're navigating to
	                  var rowCol = uiGridCtrl.grid.renderContainers[containerId].cellNav.getNextRowCol(direction, lastRowCol.row, lastRowCol.col);
	                  var focusableCols = uiGridCtrl.grid.renderContainers[containerId].cellNav.getFocusableCols();
	                  var rowColSelectIndex = uiGridCtrl.grid.api.cellNav.rowColSelectIndex(rowCol);
	                  // Shift+tab on top-left cell should exit cellnav on render container
	                  if (
	                    // Navigating left
	                    direction === uiGridCellNavConstants.direction.LEFT &&
	                    // New col is last col (i.e. wrap around)
	                    rowCol.col === focusableCols[focusableCols.length - 1] &&
	                    // Staying on same row, which means we're at first row
	                    rowCol.row === lastRowCol.row &&
	                    evt.keyCode === uiGridConstants.keymap.TAB &&
	                    evt.shiftKey
	                  ) {
	                    grid.cellNav.focusedCells.splice(rowColSelectIndex, 1);
	                    uiGridCtrl.cellNav.clearFocus();
	                    return true;
	                  }
	                  // Tab on bottom-right cell should exit cellnav on render container
	                  else if (
	                    direction === uiGridCellNavConstants.direction.RIGHT &&
	                    // New col is first col (i.e. wrap around)
	                    rowCol.col === focusableCols[0] &&
	                    // Staying on same row, which means we're at first row
	                    rowCol.row === lastRowCol.row &&
	                    evt.keyCode === uiGridConstants.keymap.TAB &&
	                    !evt.shiftKey
	                  ) {
	                    grid.cellNav.focusedCells.splice(rowColSelectIndex, 1);
	                    uiGridCtrl.cellNav.clearFocus();
	                    return true;
	                  }
	
	                  // Scroll to the new cell, if it's not completely visible within the render container's viewport
	                  grid.scrollToIfNecessary(rowCol.row, rowCol.col).then(function () {
	                    uiGridCtrl.cellNav.broadcastCellNav(rowCol, null, evt);
	                  });
	
	
	                  evt.stopPropagation();
	                  evt.preventDefault();
	
	                  return false;
	                }
	              };
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	              var grid = uiGridCtrl.grid;
	              var usesAria = true;
	
	              // Detect whether we are using ngAria
	              // (if ngAria module is not used then the stuff inside addAriaLiveRegion
	              // is not used and provides extra fluff)
	              try {
	                angular.module('ngAria');
	              }
	              catch (err) {
	                usesAria = false;
	              }
	
	              function addAriaLiveRegion() {
	                // Thanks to google docs for the inspiration behind how to do this
	                // XXX: Why is this entire mess nessasary?
	                // Because browsers take a lot of coercing to get them to read out live regions
	                // http://www.paciellogroup.com/blog/2012/06/html5-accessibility-chops-aria-rolealert-browser-support/
	                var ariaNotifierDomElt = '<div ' +
	                                           'id="' + grid.id +'-aria-speakable" ' +
	                                           'class="ui-grid-a11y-ariascreenreader-speakable ui-grid-offscreen" ' +
	                                           'aria-live="assertive" ' +
	                                           'role="alert" ' +
	                                           'aria-atomic="true" ' +
	                                           'aria-hidden="false" ' +
	                                           'aria-relevant="additions" ' +
	                                           '>' +
	                                           '&nbsp;' +
	                                         '</div>';
	
	                var ariaNotifier = $compile(ariaNotifierDomElt)($scope);
	                $elm.prepend(ariaNotifier);
	                $scope.$on(uiGridCellNavConstants.CELL_NAV_EVENT, function (evt, rowCol, modifierDown, originEvt) {
	                  /*
	                   * If the cell nav event was because of a focus event then we don't want to
	                   * change the notifier text.
	                   * Reasoning: Voice Over fires a focus events when moving arround the grid.
	                   * If the screen reader is handing the grid nav properly then we don't need to
	                   * use the alert to notify the user of the movement.
	                   * In all other cases we do want a notification event.
	                   */
	                  if (originEvt && originEvt.type === 'focus') {return;}
	
	                  function setNotifyText(text) {
	                    if (text === ariaNotifier.text().trim()) {return;}
	                    ariaNotifier[0].style.clip = 'rect(0px,0px,0px,0px)';
	                    /*
	                     * This is how google docs handles clearing the div. Seems to work better than setting the text of the div to ''
	                     */
	                    ariaNotifier[0].innerHTML = "";
	                    ariaNotifier[0].style.visibility = 'hidden';
	                    ariaNotifier[0].style.visibility = 'visible';
	                    if (text !== '') {
	                      ariaNotifier[0].style.clip = 'auto';
	                      /*
	                       * The space after the text is something that google docs does.
	                       */
	                      ariaNotifier[0].appendChild(document.createTextNode(text + " "));
	                      ariaNotifier[0].style.visibility = 'hidden';
	                      ariaNotifier[0].style.visibility = 'visible';
	                    }
	                  }
	
	                  function getAppendedColumnHeaderText(col) {
	                    return ', ' + i18nService.getSafeText('headerCell.aria.column') + ' ' + col.displayName;
	                  }
	
	                  function getCellDisplayValue(currentRowColumn) {
	                    var prefix = '';
	
	                    if (currentRowColumn.col.field === 'selectionRowHeaderCol') {
	                      // This is the case when the 'selection' feature is used in the grid and the user has moved
	                      // to or inside of the left grid container which holds the checkboxes for selecting rows.
	                      // This is necessary for Accessibility. Without this a screen reader cannot determine if the row
	                      // is or is not currently selected.
	                        prefix = (currentRowColumn.row.isSelected ? i18nService.getSafeText('search.aria.selected') : i18nService.getSafeText('search.aria.notSelected')) + ', ';
	                      }
	                      return prefix + grid.getCellDisplayValue(currentRowColumn.row, currentRowColumn.col);
	                    }
	
	                  var values = [];
	                  var currentSelection = grid.api.cellNav.getCurrentSelection();
	                  for (var i = 0; i < currentSelection.length; i++) {
	                    var cellDisplayValue = getCellDisplayValue(currentSelection[i]) + getAppendedColumnHeaderText(currentSelection[i].col);
	                    values.push(cellDisplayValue);
	                  }
	                  setNotifyText(values.toString());
	                });
	              }
	              // Only add the ngAria stuff it will be used
	              if (usesAria) {
	                addAriaLiveRegion();
	              }
	            }
	          };
	        }
	      };
	    }]);
	
	  module.directive('uiGridRenderContainer', ['$timeout', '$document', 'gridUtil', 'uiGridConstants', 'uiGridCellNavService', '$compile','uiGridCellNavConstants',
	    function ($timeout, $document, gridUtil, uiGridConstants, uiGridCellNavService, $compile, uiGridCellNavConstants) {
	      return {
	        replace: true,
	        priority: -99999, // this needs to run very last
	        require: ['^uiGrid', 'uiGridRenderContainer', '?^uiGridCellnav'],
	        scope: false,
	        compile: function () {
	          return {
	            post: function ($scope, $elm, $attrs, controllers) {
	              var uiGridCtrl = controllers[0],
	                 renderContainerCtrl = controllers[1],
	                 uiGridCellnavCtrl = controllers[2];
	
	              // Skip attaching cell-nav specific logic if the directive is not attached above us
	              if (!uiGridCtrl.grid.api.cellNav) { return; }
	
	              var containerId = renderContainerCtrl.containerId;
	
	              var grid = uiGridCtrl.grid;
	
	              // run each time a render container is created
	              uiGridCellNavService.decorateRenderContainers(grid);
	
	              // focusser only created for body
	              if (containerId !== 'body') {
	                return;
	              }
	
	              if (uiGridCtrl.grid.options.modifierKeysToMultiSelectCells) {
	                $elm.attr('aria-multiselectable', true);
	              }
	              else {
	                $elm.attr('aria-multiselectable', false);
	              }
	
	              // add an element with no dimensions that can be used to set focus and capture keystrokes
	              var focuser = $compile('<div class="ui-grid-focuser" role="region" aria-live="assertive" aria-atomic="false" tabindex="0" aria-controls="' + grid.id +'-aria-speakable '+ grid.id + '-grid-container' +'" aria-owns="' + grid.id + '-grid-container' + '"></div>')($scope);
	              $elm.append(focuser);
	
	              focuser.on('focus', function (evt) {
	                evt.uiGridTargetRenderContainerId = containerId;
	                var rowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                if (rowCol === null) {
	                  rowCol = uiGridCtrl.grid.renderContainers[containerId].cellNav.getNextRowCol(uiGridCellNavConstants.direction.DOWN, null, null);
	                  if (rowCol.row && rowCol.col) {
	                    uiGridCtrl.cellNav.broadcastCellNav(rowCol);
	                  }
	                }
	              });
	
	              uiGridCellnavCtrl.setAriaActivedescendant = function(id) {
	                $elm.attr('aria-activedescendant', id);
	              };
	
	              uiGridCellnavCtrl.removeAriaActivedescendant = function(id) {
	                if ($elm.attr('aria-activedescendant') === id) {
	                  $elm.attr('aria-activedescendant', '');
	                }
	              };
	
	
	              uiGridCtrl.focus = function () {
	                gridUtil.focus.byElement(focuser[0]);
	                // allow for first time grid focus
	              };
	
	              var viewPortKeyDownWasRaisedForRowCol = null;
	              // Bind to keydown events in the render container
	              focuser.on('keydown', function (evt) {
	                evt.uiGridTargetRenderContainerId = containerId;
	                var rowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                var raiseViewPortKeyDown = uiGridCtrl.grid.options.keyDownOverrides.some(function (override) {
	                  return Object.keys(override).every( function (property) {
	                      return override[property] === evt[property];
	                  });
	                });
	                var result = raiseViewPortKeyDown ? null : uiGridCtrl.cellNav.handleKeyDown(evt);
	                if (result === null) {
	                  uiGridCtrl.grid.api.cellNav.raise.viewPortKeyDown(evt, rowCol, uiGridCtrl.cellNav.handleKeyDown);
	                  viewPortKeyDownWasRaisedForRowCol = rowCol;
	                }
	              });
	              // Bind to keypress events in the render container
	              // keypress events are needed by edit function so the key press
	              // that initiated an edit is not lost
	              // must fire the event in a timeout so the editor can
	              // initialize and subscribe to the event on another event loop
	              focuser.on('keypress', function (evt) {
	                if (viewPortKeyDownWasRaisedForRowCol) {
	                  $timeout(function () {
	                    uiGridCtrl.grid.api.cellNav.raise.viewPortKeyPress(evt, viewPortKeyDownWasRaisedForRowCol);
	                  }, 4);
	
	                  viewPortKeyDownWasRaisedForRowCol = null;
	                }
	              });
	
	              $scope.$on('$destroy', function() {
	                // Remove all event handlers associated with this focuser.
	                focuser.off();
	              });
	            }
	          };
	        }
	      };
	    }]);
	
	  module.directive('uiGridViewport',
	    function () {
	      return {
	        replace: true,
	        priority: -99999, // this needs to run very last
	        require: ['^uiGrid', '^uiGridRenderContainer', '?^uiGridCellnav'],
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            },
	            post: function ($scope, $elm, $attrs, controllers) {
	              var uiGridCtrl = controllers[0],
	                renderContainerCtrl = controllers[1];
	
	              // Skip attaching cell-nav specific logic if the directive is not attached above us
	              if (!uiGridCtrl.grid.api.cellNav) { return; }
	
	              var containerId = renderContainerCtrl.containerId;
	              // no need to process for other containers
	              if (containerId !== 'body') {
	                return;
	              }
	
	              var grid = uiGridCtrl.grid;
	
	              grid.api.core.on.scrollBegin($scope, function () {
	
	                // Skip if there's no currently-focused cell
	                var lastRowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                if (lastRowCol === null) {
	                  return;
	                }
	
	                // if not in my container, move on
	                // todo: worry about horiz scroll
	                if (!renderContainerCtrl.colContainer.containsColumn(lastRowCol.col)) {
	                  return;
	                }
	
	                uiGridCtrl.cellNav.clearFocus();
	
	              });
	
	              grid.api.core.on.scrollEnd($scope, function (args) {
	                // Skip if there's no currently-focused cell
	                var lastRowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                if (lastRowCol === null) {
	                  return;
	                }
	
	                // if not in my container, move on
	                // todo: worry about horiz scroll
	                if (!renderContainerCtrl.colContainer.containsColumn(lastRowCol.col)) {
	                  return;
	                }
	
	                uiGridCtrl.cellNav.broadcastCellNav(lastRowCol);
	              });
	
	              grid.api.cellNav.on.navigate($scope, function () {
	                // focus again because it can be lost
	                 uiGridCtrl.focus();
	              });
	            }
	          };
	        }
	      };
	    });
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.cellNav.directive:uiGridCell
	   *  @element div
	   *  @restrict A
	   *  @description Stacks on top of ui.grid.uiGridCell to provide cell navigation
	   */
	  module.directive('uiGridCell', ['$timeout', '$document', 'uiGridCellNavService', 'gridUtil', 'uiGridCellNavConstants', 'uiGridConstants', 'GridRowColumn',
	    function ($timeout, $document, uiGridCellNavService, gridUtil, uiGridCellNavConstants, uiGridConstants, GridRowColumn) {
	      return {
	        priority: -150, // run after default uiGridCell directive and ui.grid.edit uiGridCell
	        restrict: 'A',
	        require: ['^uiGrid', '?^uiGridCellnav'],
	        scope: false,
	        link: function ($scope, $elm, $attrs, controllers) {
	          var uiGridCtrl = controllers[0],
	              uiGridCellnavCtrl = controllers[1];
	          // Skip attaching cell-nav specific logic if the directive is not attached above us
	          if (!uiGridCtrl.grid.api.cellNav) { return; }
	
	          if (!$scope.col.colDef.allowCellFocus) {
	            return;
	          }
	
	          // Convinience local variables
	          var grid = uiGridCtrl.grid;
	          $scope.focused = false;
	
	          // Make this cell focusable but only with javascript/a mouse click
	          $elm.attr('tabindex', -1);
	
	          // When a cell is clicked, broadcast a cellNav event saying that this row+col combo is now focused
	          $elm.find('div').on('click', function (evt) {
	            uiGridCtrl.cellNav.broadcastCellNav(new GridRowColumn($scope.row, $scope.col), evt.ctrlKey || evt.metaKey, evt);
	
	            evt.stopPropagation();
	            $scope.$apply();
	          });
	
	
	          /*
	           * XXX Hack for screen readers.
	           * This allows the grid to focus using only the screen reader cursor.
	           * Since the focus event doesn't include key press information we can't use it
	           * as our primary source of the event.
	           */
	          $elm.on('mousedown', preventMouseDown);
	
	          // turn on and off for edit events
	          if (uiGridCtrl.grid.api.edit) {
	            uiGridCtrl.grid.api.edit.on.beginCellEdit($scope, function () {
	              $elm.off('mousedown', preventMouseDown);
	            });
	
	            uiGridCtrl.grid.api.edit.on.afterCellEdit($scope, function () {
	              $elm.on('mousedown', preventMouseDown);
	            });
	
	            uiGridCtrl.grid.api.edit.on.cancelCellEdit($scope, function () {
	              $elm.on('mousedown', preventMouseDown);
	            });
	          }
	
	          // In case we created a new row, and we are the new created row by ngRepeat
	          // then this cell content might have been selected previously
	          refreshCellFocus();
	
	          function preventMouseDown(evt) {
	            // Prevents the foucus event from firing if the click event is already going to fire.
	            // If both events fire it will cause bouncing behavior.
	            evt.preventDefault();
	          }
	
	          // You can only focus on elements with a tabindex value
	          $elm.on('focus', function (evt) {
	            uiGridCtrl.cellNav.broadcastCellNav(new GridRowColumn($scope.row, $scope.col), false, evt);
	            evt.stopPropagation();
	            $scope.$apply();
	          });
	
	          // This event is fired for all cells.  If the cell matches, then focus is set
	          $scope.$on(uiGridCellNavConstants.CELL_NAV_EVENT, refreshCellFocus);
	
	          // Refresh cell focus when a new row id added to the grid
	          var dataChangeDereg = uiGridCtrl.grid.registerDataChangeCallback(function (grid) {
	            // Clear the focus if it's set to avoid the wrong cell getting focused during
	            // a short period of time (from now until $timeout function executed)
	            clearFocus();
	
	            $scope.$applyAsync(refreshCellFocus);
	          }, [uiGridConstants.dataChange.ROW]);
	
	          function refreshCellFocus() {
	            var isFocused = grid.cellNav.focusedCells.some(function (focusedRowCol, index) {
	              return (focusedRowCol.row === $scope.row && focusedRowCol.col === $scope.col);
	            });
	            if (isFocused) {
	              setFocused();
	            } else {
	              clearFocus();
	            }
	          }
	
	          function setFocused() {
	            if (!$scope.focused) {
	              var div = $elm.find('div');
	              div.addClass('ui-grid-cell-focus');
	              $elm.attr('aria-selected', true);
	              uiGridCellnavCtrl.setAriaActivedescendant($elm.attr('id'));
	              $scope.focused = true;
	            }
	          }
	
	          function clearFocus() {
	            if ($scope.focused) {
	              var div = $elm.find('div');
	              div.removeClass('ui-grid-cell-focus');
	              $elm.attr('aria-selected', false);
	              uiGridCellnavCtrl.removeAriaActivedescendant($elm.attr('id'));
	              $scope.focused = false;
	            }
	          }
	
	          $scope.$on('$destroy', function () {
	            dataChangeDereg();
	
	            // .off withouth paramaters removes all handlers
	            $elm.find('div').off();
	            $elm.off();
	          });
	        }
	      };
	    }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc object
	   * @name ui.grid.service:uiGridConstants
	   * @description Constants for use across many grid features
	   *
	   */
	
	
	  angular.module('ui.grid').constant('uiGridConstants', {
	    LOG_DEBUG_MESSAGES: true,
	    LOG_WARN_MESSAGES: true,
	    LOG_ERROR_MESSAGES: true,
	    CUSTOM_FILTERS: /CUSTOM_FILTERS/g,
	    COL_FIELD: /COL_FIELD/g,
	    MODEL_COL_FIELD: /MODEL_COL_FIELD/g,
	    TOOLTIP: /title=\"TOOLTIP\"/g,
	    DISPLAY_CELL_TEMPLATE: /DISPLAY_CELL_TEMPLATE/g,
	    TEMPLATE_REGEXP: /<.+>/,
	    FUNC_REGEXP: /(\([^)]*\))?$/,
	    DOT_REGEXP: /\./g,
	    APOS_REGEXP: /'/g,
	    BRACKET_REGEXP: /^(.*)((?:\s*\[\s*\d+\s*\]\s*)|(?:\s*\[\s*"(?:[^"\\]|\\.)*"\s*\]\s*)|(?:\s*\[\s*'(?:[^'\\]|\\.)*'\s*\]\s*))(.*)$/,
	    COL_CLASS_PREFIX: 'ui-grid-col',
	    ENTITY_BINDING: '$$this',
	    events: {
	      GRID_SCROLL: 'uiGridScroll',
	      COLUMN_MENU_SHOWN: 'uiGridColMenuShown',
	      ITEM_DRAGGING: 'uiGridItemDragStart', // For any item being dragged
	      COLUMN_HEADER_CLICK: 'uiGridColumnHeaderClick'
	    },
	    // copied from http://www.lsauer.com/2011/08/javascript-keymap-keycodes-in-json.html
	    keymap: {
	      TAB: 9,
	      STRG: 17,
	      CAPSLOCK: 20,
	      CTRL: 17,
	      CTRLRIGHT: 18,
	      CTRLR: 18,
	      SHIFT: 16,
	      RETURN: 13,
	      ENTER: 13,
	      BACKSPACE: 8,
	      BCKSP: 8,
	      ALT: 18,
	      ALTR: 17,
	      ALTRIGHT: 17,
	      SPACE: 32,
	      WIN: 91,
	      MAC: 91,
	      FN: null,
	      PG_UP: 33,
	      PG_DOWN: 34,
	      UP: 38,
	      DOWN: 40,
	      LEFT: 37,
	      RIGHT: 39,
	      ESC: 27,
	      DEL: 46,
	      F1: 112,
	      F2: 113,
	      F3: 114,
	      F4: 115,
	      F5: 116,
	      F6: 117,
	      F7: 118,
	      F8: 119,
	      F9: 120,
	      F10: 121,
	      F11: 122,
	      F12: 123
	    },
	     /**
	     * @ngdoc object
	     * @name ASC
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used in {@link ui.grid.class:GridOptions.columnDef#properties_sort columnDef.sort} and
	     * {@link ui.grid.class:GridOptions.columnDef#properties_sortDirectionCycle columnDef.sortDirectionCycle}
	     * to configure the sorting direction of the column
	     */
	    ASC: 'asc',
	     /**
	     * @ngdoc object
	     * @name DESC
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used in {@link ui.grid.class:GridOptions.columnDef#properties_sort columnDef.sort} and
	     * {@link ui.grid.class:GridOptions.columnDef#properties_sortDirectionCycle columnDef.sortDirectionCycle}
	     * to configure the sorting direction of the column
	     */
	    DESC: 'desc',
	
	
	     /**
	     * @ngdoc object
	     * @name filter
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used in {@link ui.grid.class:GridOptions.columnDef#properties_filter columnDef.filter}
	     * to configure filtering on the column
	     *
	     * `SELECT` and `INPUT` are used with the `type` property of the filter, the rest are used to specify
	     * one of the built-in conditions.
	     *
	     * Available `condition` options are:
	     * - `uiGridConstants.filter.STARTS_WITH`
	     * - `uiGridConstants.filter.ENDS_WITH`
	     * - `uiGridConstants.filter.CONTAINS`
	     * - `uiGridConstants.filter.GREATER_THAN`
	     * - `uiGridConstants.filter.GREATER_THAN_OR_EQUAL`
	     * - `uiGridConstants.filter.LESS_THAN`
	     * - `uiGridConstants.filter.LESS_THAN_OR_EQUAL`
	     * - `uiGridConstants.filter.NOT_EQUAL`
	     *
	     *
	     * Available `type` options are:
	     * - `uiGridConstants.filter.SELECT` - use a dropdown box for the cell header filter field
	     * - `uiGridConstants.filter.INPUT` - use a text box for the cell header filter field
	     */
	    filter: {
	      STARTS_WITH: 2,
	      ENDS_WITH: 4,
	      EXACT: 8,
	      CONTAINS: 16,
	      GREATER_THAN: 32,
	      GREATER_THAN_OR_EQUAL: 64,
	      LESS_THAN: 128,
	      LESS_THAN_OR_EQUAL: 256,
	      NOT_EQUAL: 512,
	      SELECT: 'select',
	      INPUT: 'input'
	    },
	
	    /**
	     * @ngdoc object
	     * @name aggregationTypes
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used in {@link ui.grid.class:GridOptions.columnDef#properties_aggregationType columnDef.aggregationType}
	     * to specify the type of built-in aggregation the column should use.
	     *
	     * Available options are:
	     * - `uiGridConstants.aggregationTypes.sum` - add the values in this column to produce the aggregated value
	     * - `uiGridConstants.aggregationTypes.count` - count the number of rows to produce the aggregated value
	     * - `uiGridConstants.aggregationTypes.avg` - average the values in this column to produce the aggregated value
	     * - `uiGridConstants.aggregationTypes.min` - use the minimum value in this column as the aggregated value
	     * - `uiGridConstants.aggregationTypes.max` - use the maximum value in this column as the aggregated value
	     */
	    aggregationTypes: {
	      sum: 2,
	      count: 4,
	      avg: 8,
	      min: 16,
	      max: 32
	    },
	
	    /**
	     * @ngdoc array
	     * @name CURRENCY_SYMBOLS
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description A list of all presently circulating currency symbols that was copied from
	     * https://en.wikipedia.org/wiki/Currency_symbol#List_of_presently-circulating_currency_symbols
	     *
	     * Can be used on {@link ui.grid.class:rowSorter} to create a number string regex that ignores currency symbols.
	     */
	    CURRENCY_SYMBOLS: ['¤', '؋', 'Ar', 'Ƀ', '฿', 'B/.', 'Br', 'Bs.', 'Bs.F.', 'GH₵', '¢', 'c', 'Ch.', '₡', 'C$', 'D', 'ден',
	      'دج', '.د.ب', 'د.ع', 'JD', 'د.ك', 'ل.د', 'дин', 'د.ت', 'د.م.', 'د.إ', 'Db', '$', '₫', 'Esc', '€', 'ƒ', 'Ft', 'FBu',
	      'FCFA', 'CFA', 'Fr', 'FRw', 'G', 'gr', '₲', 'h', '₴', '₭', 'Kč', 'kr', 'kn', 'MK', 'ZK', 'Kz', 'K', 'L', 'Le', 'лв',
	      'E', 'lp', 'M', 'KM', 'MT', '₥', 'Nfk', '₦', 'Nu.', 'UM', 'T$', 'MOP$', '₱', 'Pt.', '£', 'ج.م.', 'LL', 'LS', 'P', 'Q',
	      'q', 'R', 'R$', 'ر.ع.', 'ر.ق', 'ر.س', '៛', 'RM', 'p', 'Rf.', '₹', '₨', 'SRe', 'Rp', '₪', 'Ksh', 'Sh.So.', 'USh', 'S/',
	      'SDR', 'сом', '৳	', 'WS$', '₮', 'VT', '₩', '¥', 'zł'],
	
	    /**
	     * @ngdoc object
	     * @name scrollDirection
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Set on {@link ui.grid.class:Grid#properties_scrollDirection Grid.scrollDirection},
	     * to indicate the direction the grid is currently scrolling in
	     *
	     * Available options are:
	     * - `uiGridConstants.scrollDirection.UP` - set when the grid is scrolling up
	     * - `uiGridConstants.scrollDirection.DOWN` - set when the grid is scrolling down
	     * - `uiGridConstants.scrollDirection.LEFT` - set when the grid is scrolling left
	     * - `uiGridConstants.scrollDirection.RIGHT` - set when the grid is scrolling right
	     * - `uiGridConstants.scrollDirection.NONE` - set when the grid is not scrolling, this is the default
	     */
	    scrollDirection: {
	      UP: 'up',
	      DOWN: 'down',
	      LEFT: 'left',
	      RIGHT: 'right',
	      NONE: 'none'
	
	    },
	
	    /**
	     * @ngdoc object
	     * @name dataChange
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used with {@link ui.grid.api:PublicApi#methods_notifyDataChange PublicApi.notifyDataChange},
	     * {@link ui.grid.class:Grid#methods_callDataChangeCallbacks Grid.callDataChangeCallbacks},
	     * and {@link ui.grid.class:Grid#methods_registerDataChangeCallback Grid.registerDataChangeCallback}
	     * to specify the type of the event(s).
	     *
	     * Available options are:
	     * - `uiGridConstants.dataChange.ALL` - listeners fired on any of these events, fires listeners on all events.
	     * - `uiGridConstants.dataChange.EDIT` - fired when the data in a cell is edited
	     * - `uiGridConstants.dataChange.ROW` - fired when a row is added or removed
	     * - `uiGridConstants.dataChange.COLUMN` - fired when the column definitions are modified
	     * - `uiGridConstants.dataChange.OPTIONS` - fired when the grid options are modified
	     */
	    dataChange: {
	      ALL: 'all',
	      EDIT: 'edit',
	      ROW: 'row',
	      COLUMN: 'column',
	      OPTIONS: 'options'
	    },
	
	    /**
	     * @ngdoc object
	     * @name scrollbars
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used with {@link ui.grid.class:GridOptions#properties_enableHorizontalScrollbar GridOptions.enableHorizontalScrollbar}
	     * and {@link ui.grid.class:GridOptions#properties_enableVerticalScrollbar GridOptions.enableVerticalScrollbar}
	     * to specify the scrollbar policy for that direction.
	     *
	     * Available options are:
	     * - `uiGridConstants.scrollbars.NEVER` - never show scrollbars in this direction
	     * - `uiGridConstants.scrollbars.ALWAYS` - always show scrollbars in this direction
	     * - `uiGridConstants.scrollbars.WHEN_NEEDED` - shows scrollbars in this direction when needed
	     */
	
	    scrollbars: {
	      NEVER: 0,
	      ALWAYS: 1,
	      WHEN_NEEDED: 2
	    }
	  });
	
	})();
	
	angular.module('ui.grid').directive('uiGridCell', ['$compile', '$parse', 'gridUtil', 'uiGridConstants', function ($compile, $parse, gridUtil, uiGridConstants) {
	  return {
	    priority: 0,
	    scope: false,
	    require: '?^uiGrid',
	    compile: function() {
	      return {
	        pre: function($scope, $elm, $attrs, uiGridCtrl) {
	          function compileTemplate() {
	            var compiledElementFn = $scope.col.compiledElementFn;
	
	            compiledElementFn($scope, function(clonedElement, scope) {
	              $elm.append(clonedElement);
	            });
	          }
	
	          // If the grid controller is present, use it to get the compiled cell template function
	          if (uiGridCtrl && $scope.col.compiledElementFn) {
	             compileTemplate();
	          }
	
	          // No controller, compile the element manually (for unit tests)
	          else {
	            if ( uiGridCtrl && !$scope.col.compiledElementFn ) {
	              $scope.col.getCompiledElementFn()
	                .then(function (compiledElementFn) {
	                  compiledElementFn($scope, function(clonedElement, scope) {
	                    $elm.append(clonedElement);
	                  });
	                }).catch(angular.noop);
	            }
	            else {
	              var html = $scope.col.cellTemplate
	                .replace(uiGridConstants.MODEL_COL_FIELD, 'row.entity.' + gridUtil.preEval($scope.col.field))
	                .replace(uiGridConstants.COL_FIELD, 'grid.getCellValue(row, col)');
	
	              var cellElement = $compile(html)($scope);
	              $elm.append(cellElement);
	            }
	          }
	        },
	        post: function($scope, $elm) {
	          var initColClass = $scope.col.getColClass(false),
	            classAdded;
	
	          $elm.addClass(initColClass);
	
	          function updateClass( grid ) {
	            var contents = $elm;
	
	            if ( classAdded ) {
	              contents.removeClass( classAdded );
	              classAdded = null;
	            }
	
	            if (angular.isFunction($scope.col.cellClass)) {
	              classAdded = $scope.col.cellClass($scope.grid, $scope.row, $scope.col, $scope.rowRenderIndex, $scope.colRenderIndex);
	            }
	            else {
	              classAdded = $scope.col.cellClass;
	            }
	            contents.addClass(classAdded);
	          }
	
	          if ($scope.col.cellClass) {
	            updateClass();
	          }
	
	          // Register a data change watch that would get triggered whenever someone edits a cell or modifies column defs
	          var dataChangeDereg = $scope.grid.registerDataChangeCallback( updateClass, [uiGridConstants.dataChange.COLUMN, uiGridConstants.dataChange.EDIT]);
	
	          // watch the col and row to see if they change - which would indicate that we've scrolled or sorted or otherwise
	          // changed the row/col that this cell relates to, and we need to re-evaluate cell classes and maybe other things
	          function cellChangeFunction( n, o ) {
	            if ( n !== o ) {
	              if ( classAdded || $scope.col.cellClass ) {
	                updateClass();
	              }
	
	              // See if the column's internal class has changed
	              var newColClass = $scope.col.getColClass(false);
	
	              if (newColClass !== initColClass) {
	                $elm.removeClass(initColClass);
	                $elm.addClass(newColClass);
	                initColClass = newColClass;
	              }
	            }
	          }
	
	          // TODO(c0bra): Turn this into a deep array watch
	          var rowWatchDereg = $scope.$watch( 'row', cellChangeFunction );
	
	          function deregisterFunction() {
	            dataChangeDereg();
	            rowWatchDereg();
	          }
	
	          $scope.$on('$destroy', deregisterFunction);
	          $elm.on('$destroy', deregisterFunction);
	        }
	      };
	    }
	  };
	}]);
	
	(function() {
	
	angular.module('ui.grid')
	.service('uiGridColumnMenuService', [ 'i18nService', 'uiGridConstants', 'gridUtil',
	function ( i18nService, uiGridConstants, gridUtil ) {
	/**
	 *  @ngdoc service
	 *  @name ui.grid.service:uiGridColumnMenuService
	 *
	 *  @description Services for working with column menus, factored out
	 *  to make the code easier to understand
	 */
	
	  var service = {
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name initialize
	     * @description  Sets defaults, puts a reference to the $scope on
	     * the uiGridController
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {controller} uiGridCtrl the uiGridController for the grid
	     * we're on
	     *
	     */
	    initialize: function( $scope, uiGridCtrl ) {
	      $scope.grid = uiGridCtrl.grid;
	
	      // Store a reference to this link/controller in the main uiGrid controller
	      // to allow showMenu later
	      uiGridCtrl.columnMenuScope = $scope;
	
	      // Save whether we're shown or not so the columns can check
	      $scope.menuShown = false;
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name setColMenuItemWatch
	     * @description  Setup a watch on $scope.col.menuItems, and update
	     * menuItems based on this.  $scope.col needs to be set by the column
	     * before calling the menu.
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     */
	    setColMenuItemWatch: function ( $scope ) {
	      var deregFunction = $scope.$watch('col.menuItems', function (n) {
	        if (typeof(n) !== 'undefined' && n && angular.isArray(n)) {
	          n.forEach(function (item) {
	            if (typeof(item.context) === 'undefined' || !item.context) {
	              item.context = {};
	            }
	            item.context.col = $scope.col;
	          });
	
	          $scope.menuItems = $scope.defaultMenuItems.concat(n);
	        }
	        else {
	          $scope.menuItems = $scope.defaultMenuItems;
	        }
	      });
	
	      $scope.$on( '$destroy', deregFunction );
	    },
	
	    getGridOption: function( $scope, option ) {
	      return typeof($scope.grid) !== 'undefined' && $scope.grid && $scope.grid.options && $scope.grid.options[option];
	    },
	
	    /**
	     * @ngdoc boolean
	     * @name enableSorting
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) True by default. When enabled, this setting adds sort
	     * widgets to the column header, allowing sorting of the data in the individual column.
	     */
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name sortable
	     * @description  determines whether this column is sortable
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     *
	     */
	    sortable: function( $scope ) {
	      return Boolean( this.getGridOption($scope, 'enableSorting') && typeof($scope.col) !== 'undefined' && $scope.col && $scope.col.enableSorting);
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name isActiveSort
	     * @description  determines whether the requested sort direction is current active, to
	     * allow highlighting in the menu
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {string} direction the direction that we'd have selected for us to be active
	     *
	     */
	    isActiveSort: function( $scope, direction ) {
	      return Boolean(typeof($scope.col) !== 'undefined' && typeof($scope.col.sort) !== 'undefined' &&
	              typeof($scope.col.sort.direction) !== 'undefined' && $scope.col.sort.direction === direction);
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name suppressRemoveSort
	     * @description  determines whether we should suppress the removeSort option
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     *
	     */
	    suppressRemoveSort: function( $scope ) {
	      return Boolean($scope.col && $scope.col.suppressRemoveSort);
	    },
	
	
	    /**
	     * @ngdoc boolean
	     * @name enableHiding
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) True by default. When set to false, this setting prevents a user from hiding the column
	     * using the column menu or the grid menu.
	     */
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name hideable
	     * @description  determines whether a column can be hidden, by checking the enableHiding columnDef option
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     *
	     */
	    hideable: function( $scope ) {
	      return Boolean(
	        (this.getGridOption($scope, 'enableHiding') &&
	        typeof($scope.col) !== 'undefined' && $scope.col &&
	        ($scope.col.colDef && $scope.col.colDef.enableHiding !== false || !$scope.col.colDef)) ||
	        (!this.getGridOption($scope, 'enableHiding') && $scope.col && $scope.col.colDef && $scope.col.colDef.enableHiding)
	      );
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name getDefaultMenuItems
	     * @description  returns the default menu items for a column menu
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     *
	     */
	    getDefaultMenuItems: function( $scope ) {
	      return [
	        {
	          title: function() {return i18nService.getSafeText('sort.ascending');},
	          icon: 'ui-grid-icon-sort-alt-up',
	          action: function($event) {
	            $event.stopPropagation();
	            $scope.sortColumn($event, uiGridConstants.ASC);
	          },
	          shown: function () {
	            return service.sortable( $scope );
	          },
	          active: function() {
	            return service.isActiveSort( $scope, uiGridConstants.ASC);
	          }
	        },
	        {
	          title: function() {return i18nService.getSafeText('sort.descending');},
	          icon: 'ui-grid-icon-sort-alt-down',
	          action: function($event) {
	            $event.stopPropagation();
	            $scope.sortColumn($event, uiGridConstants.DESC);
	          },
	          shown: function() {
	            return service.sortable( $scope );
	          },
	          active: function() {
	            return service.isActiveSort( $scope, uiGridConstants.DESC);
	          }
	        },
	        {
	          title: function() {return i18nService.getSafeText('sort.remove');},
	          icon: 'ui-grid-icon-cancel',
	          action: function ($event) {
	            $event.stopPropagation();
	            $scope.unsortColumn();
	          },
	          shown: function() {
	            return service.sortable( $scope ) &&
	                   typeof($scope.col) !== 'undefined' && (typeof($scope.col.sort) !== 'undefined' &&
	                   typeof($scope.col.sort.direction) !== 'undefined') && $scope.col.sort.direction !== null &&
	                  !service.suppressRemoveSort( $scope );
	          }
	        },
	        {
	          title: function() {return i18nService.getSafeText('column.hide');},
	          icon: 'ui-grid-icon-cancel',
	          shown: function() {
	            return service.hideable( $scope );
	          },
	          action: function ($event) {
	            $event.stopPropagation();
	            $scope.hideColumn();
	          }
	        }
	      ];
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name getColumnElementPosition
	     * @description  gets the position information needed to place the column
	     * menu below the column header
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {GridColumn} column the column we want to position below
	     * @param {element} $columnElement the column element we want to position below
	     * @returns {hash} containing left, top, offset, height, width
	     *
	     */
	    getColumnElementPosition: function( $scope, column, $columnElement ) {
	      var positionData = {};
	
	      positionData.left = $columnElement[0].offsetLeft;
	      positionData.top = $columnElement[0].offsetTop;
	      positionData.parentLeft = $columnElement[0].offsetParent.offsetLeft;
	
	      // Get the grid scrollLeft
	      positionData.offset = 0;
	      if (column.grid.options.offsetLeft) {
	        positionData.offset = column.grid.options.offsetLeft;
	      }
	
	      positionData.height = gridUtil.elementHeight($columnElement, true);
	      positionData.width = gridUtil.elementWidth($columnElement, true);
	
	      return positionData;
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name repositionMenu
	     * @description  Reposition the menu below the new column.  If the menu has no child nodes
	     * (i.e. it's not currently visible) then we guess it's width at 100, we'll be called again
	     * later to fix it
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {GridColumn} column the column we want to position below
	     * @param {hash} positionData a hash containing left, top, offset, height, width
	     * @param {element} $elm the column menu element that we want to reposition
	     * @param {element} $columnElement the column element that we want to reposition underneath
	     *
	     */
	    repositionMenu: function( $scope, column, positionData, $elm, $columnElement ) {
	      var menu = $elm[0].querySelectorAll('.ui-grid-menu');
	
	      // It's possible that the render container of the column we're attaching to is
	      // offset from the grid (i.e. pinned containers), we need to get the difference in the offsetLeft
	      // between the render container and the grid
	      var renderContainerElm = gridUtil.closestElm($columnElement, '.ui-grid-render-container'),
	        renderContainerOffset = renderContainerElm.getBoundingClientRect().left - $scope.grid.element[0].getBoundingClientRect().left,
	        containerScrollLeft = renderContainerElm.querySelectorAll('.ui-grid-viewport')[0].scrollLeft;
	
	      // repositionMenu is now always called after it's visible in the DOM,
	      // allowing us to simply get the width every time the menu is opened
	      var myWidth = gridUtil.elementWidth(menu, true),
	        paddingRight = column.lastMenuPaddingRight ? column.lastMenuPaddingRight : ( $scope.lastMenuPaddingRight ? $scope.lastMenuPaddingRight : 10);
	
	      if ( menu.length !== 0 ) {
	        var mid = menu[0].querySelectorAll('.ui-grid-menu-mid');
	
	        if ( mid.length !== 0 ) {
	          // TODO(c0bra): use padding-left/padding-right based on document direction (ltr/rtl), place menu on proper side
	          // Get the column menu right padding
	          paddingRight = parseInt(gridUtil.getStyles(angular.element(menu)[0])['paddingRight'], 10);
	          $scope.lastMenuPaddingRight = paddingRight;
	          column.lastMenuPaddingRight = paddingRight;
	        }
	      }
	
	      var left = positionData.left + renderContainerOffset - containerScrollLeft + positionData.parentLeft + positionData.width + paddingRight;
	
	      if (left < positionData.offset + myWidth) {
	        left = Math.max(positionData.left - containerScrollLeft + positionData.parentLeft - paddingRight + myWidth, positionData.offset + myWidth);
	      }
	
	      $elm.css('left', left + 'px');
	      $elm.css('top', (positionData.top + positionData.height) + 'px');
	    }
	  };
	  return service;
	}])
	
	
	.directive('uiGridColumnMenu', ['$timeout', 'gridUtil', 'uiGridConstants', 'uiGridColumnMenuService', '$document',
	function ($timeout, gridUtil, uiGridConstants, uiGridColumnMenuService, $document) {
	/**
	 * @ngdoc directive
	 * @name ui.grid.directive:uiGridColumnMenu
	 * @description  Provides the column menu framework, leverages uiGridMenu underneath
	 *
	 */
	
	  return {
	    priority: 0,
	    scope: true,
	    require: '^uiGrid',
	    templateUrl: 'ui-grid/uiGridColumnMenu',
	    replace: true,
	    link: function ($scope, $elm, $attrs, uiGridCtrl) {
	      uiGridColumnMenuService.initialize( $scope, uiGridCtrl );
	
	      $scope.defaultMenuItems = uiGridColumnMenuService.getDefaultMenuItems( $scope );
	
	      // Set the menu items for use with the column menu. The user can later add additional items via the watch
	      $scope.menuItems = $scope.defaultMenuItems;
	      uiGridColumnMenuService.setColMenuItemWatch( $scope );
	
	      function updateCurrentColStatus(menuShown) {
	        if ($scope.col) {
	          $scope.col.menuShown = menuShown;
	        }
	      }
	
	      /**
	       * @ngdoc method
	       * @methodOf ui.grid.directive:uiGridColumnMenu
	       * @name showMenu
	       * @description Shows the column menu.  If the menu is already displayed it
	       * calls the menu to ask it to hide (it will animate), then it repositions the menu
	       * to the right place whilst hidden (it will make an assumption on menu width),
	       * then it asks the menu to show (it will animate), then it repositions the menu again
	       * once we can calculate it's size.
	       * @param {GridColumn} column the column we want to position below
	       * @param {element} $columnElement the column element we want to position below
	       */
	      $scope.showMenu = function(column, $columnElement, event) {
	        // Update the menu status for the current column
	        updateCurrentColStatus(false);
	        // Swap to this column
	        $scope.col = column;
	        updateCurrentColStatus(true);
	
	        // Get the position information for the column element
	        var colElementPosition = uiGridColumnMenuService.getColumnElementPosition( $scope, column, $columnElement );
	
	        if ($scope.menuShown) {
	          // we want to hide, then reposition, then show, but we want to wait for animations
	          // we set a variable, and then rely on the menu-hidden event to call the reposition and show
	          $scope.colElement = $columnElement;
	          $scope.colElementPosition = colElementPosition;
	          $scope.hideThenShow = true;
	
	          $scope.$broadcast('hide-menu', { originalEvent: event });
	        } else {
	          $scope.menuShown = true;
	
	          $scope.colElement = $columnElement;
	          $scope.colElementPosition = colElementPosition;
	          $scope.$broadcast('show-menu', { originalEvent: event });
	        }
	      };
	
	
	      /**
	       * @ngdoc method
	       * @methodOf ui.grid.directive:uiGridColumnMenu
	       * @name hideMenu
	       * @description Hides the column menu.
	       * @param {boolean} broadcastTrigger true if we were triggered by a broadcast
	       * from the menu itself - in which case don't broadcast again as we'll get
	       * an infinite loop
	       */
	      $scope.hideMenu = function( broadcastTrigger ) {
	        $scope.menuShown = false;
	        updateCurrentColStatus(false);
	        if ( !broadcastTrigger ) {
	          $scope.$broadcast('hide-menu');
	        }
	      };
	
	
	      $scope.$on('menu-hidden', function() {
	        var menuItems = angular.element($elm[0].querySelector('.ui-grid-menu-items'))[0];
	
	        $elm[0].removeAttribute('style');
	
	        if ( $scope.hideThenShow ) {
	          delete $scope.hideThenShow;
	
	          $scope.$broadcast('show-menu');
	
	          $scope.menuShown = true;
	        } else {
	          $scope.hideMenu( true );
	
	          if ($scope.col && $scope.col.visible) {
	            // Focus on the menu button
	            gridUtil.focus.bySelector($document, '.ui-grid-header-cell.' + $scope.col.getColClass()+ ' .ui-grid-column-menu-button', $scope.col.grid, false)
	                .catch(angular.noop);
	          }
	        }
	
	        if (menuItems) {
	          menuItems.onkeydown = null;
	          angular.forEach(menuItems.children, function removeHandlers(item) {
	            item.onkeydown = null;
	          });
	        }
	      });
	
	      $scope.$on('menu-shown', function() {
	        $timeout(function() {
	          uiGridColumnMenuService.repositionMenu( $scope, $scope.col, $scope.colElementPosition, $elm, $scope.colElement );
	
	          var hasVisibleMenuItems = $scope.menuItems.some(function (menuItem) {
	              return menuItem.shown();
	          });
	
	          // automatically set the focus to the first button element in the now open menu.
	          if (hasVisibleMenuItems) {
	            gridUtil.focus.bySelector($document, '.ui-grid-menu-items .ui-grid-menu-item:not(.ng-hide)', true)
	                .catch(angular.noop);
	          }
	
	          delete $scope.colElementPosition;
	          delete $scope.columnElement;
	          addKeydownHandlersToMenu();
	        });
	      });
	
	
	      /* Column methods */
	      $scope.sortColumn = function (event, dir) {
	        event.stopPropagation();
	
	        $scope.grid.sortColumn($scope.col, dir, true)
	          .then(function () {
	            $scope.grid.refresh();
	            $scope.hideMenu();
	          }).catch(angular.noop);
	      };
	
	      $scope.unsortColumn = function () {
	        $scope.col.unsort();
	
	        $scope.grid.refresh();
	        $scope.hideMenu();
	      };
	
	      function addKeydownHandlersToMenu() {
	        var menu = angular.element($elm[0].querySelector('.ui-grid-menu-items'))[0],
	          menuItems,
	          visibleMenuItems = [];
	
	        if (menu) {
	          menu.onkeydown = function closeMenu(event) {
	            if (event.keyCode === uiGridConstants.keymap.ESC) {
	              event.preventDefault();
	              $scope.hideMenu();
	            }
	          };
	
	          menuItems = menu.querySelectorAll('.ui-grid-menu-item:not(.ng-hide)');
	          angular.forEach(menuItems, function filterVisibleItems(item) {
	            if (item.offsetParent !== null) {
	              this.push(item);
	            }
	          }, visibleMenuItems);
	
	          if (visibleMenuItems.length) {
	            if (visibleMenuItems.length === 1) {
	              visibleMenuItems[0].onkeydown = function singleItemHandler(event) {
	                circularFocusHandler(event, true);
	              };
	            } else {
	              visibleMenuItems[0].onkeydown = function firstItemHandler(event) {
	                circularFocusHandler(event, false, event.shiftKey, visibleMenuItems.length - 1);
	              };
	              visibleMenuItems[visibleMenuItems.length - 1].onkeydown = function lastItemHandler(event) {
	                circularFocusHandler(event, false, !event.shiftKey, 0);
	              };
	            }
	          }
	        }
	
	        function circularFocusHandler(event, isSingleItem, shiftKeyStatus, index) {
	          if (event.keyCode === uiGridConstants.keymap.TAB) {
	            if (isSingleItem) {
	              event.preventDefault();
	            } else if (shiftKeyStatus) {
	              event.preventDefault();
	              visibleMenuItems[index].focus();
	            }
	          }
	        }
	      }
	
	      // Since we are hiding this column the default hide action will fail so we need to focus somewhere else.
	      var setFocusOnHideColumn = function() {
	        $timeout(function() {
	          // Get the UID of the first
	          var focusToGridMenu = function() {
	            return gridUtil.focus.byId('grid-menu', $scope.grid);
	          };
	
	          var thisIndex;
	          $scope.grid.columns.some(function(element, index) {
	            if (angular.equals(element, $scope.col)) {
	              thisIndex = index;
	              return true;
	            }
	          });
	
	          var previousVisibleCol;
	          // Try and find the next lower or nearest column to focus on
	          $scope.grid.columns.some(function(element, index) {
	            if (!element.visible) {
	              return false;
	            } // This columns index is below the current column index
	            else if ( index < thisIndex) {
	              previousVisibleCol = element;
	            } // This elements index is above this column index and we haven't found one that is lower
	            else if ( index > thisIndex && !previousVisibleCol) {
	              // This is the next best thing
	              previousVisibleCol = element;
	              // We've found one so use it.
	              return true;
	            } // We've reached an element with an index above this column and the previousVisibleCol variable has been set
	            else if (index > thisIndex && previousVisibleCol) {
	              // We are done.
	              return true;
	            }
	          });
	          // If found then focus on it
	          if (previousVisibleCol) {
	            var colClass = previousVisibleCol.getColClass();
	            gridUtil.focus.bySelector($document, '.ui-grid-header-cell.' + colClass+ ' .ui-grid-header-cell-primary-focus', true).then(angular.noop, function(reason) {
	              if (reason !== 'canceled') { // If this is canceled then don't perform the action
	                // The fallback action is to focus on the grid menu
	                return focusToGridMenu();
	              }
	            }).catch(angular.noop);
	          } else {
	            // Fallback action to focus on the grid menu
	            focusToGridMenu();
	          }
	        });
	      };
	
	      $scope.hideColumn = function () {
	        $scope.col.colDef.visible = false;
	        $scope.col.visible = false;
	
	        $scope.grid.queueGridRefresh();
	        $scope.hideMenu();
	        $scope.grid.api.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
	        $scope.grid.api.core.raise.columnVisibilityChanged( $scope.col );
	
	        // We are hiding so the default action of focusing on the button that opened this menu will fail.
	        setFocusOnHideColumn();
	      };
	    },
	
	    controller: ['$scope', function ($scope) {
	      var self = this;
	
	      $scope.$watch('menuItems', function (n) {
	        self.menuItems = n;
	      });
	    }]
	  };
	}]);
	})();
	
	(function() {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridFilter', ['$compile', '$templateCache', 'i18nService', 'gridUtil', function ($compile, $templateCache, i18nService, gridUtil) {
	
	    return {
	      compile: function() {
	        return {
	          pre: function ($scope, $elm) {
	            $scope.col.updateFilters = function( filterable ) {
	              $elm.children().remove();
	              if ( filterable ) {
	                var template = $scope.col.filterHeaderTemplate;
	                if (template === undefined && $scope.col.providedFilterHeaderTemplate !== '') {
	                  if ($scope.col.filterHeaderTemplatePromise) {
	                    $scope.col.filterHeaderTemplatePromise.then(function () {
	                      template = $scope.col.filterHeaderTemplate;
	                      $elm.append($compile(template)($scope));
	                    });
	                  }
	                }
	                else {
	                  $elm.append($compile(template)($scope));
	                }
	              }
	            };
	
	            $scope.$on( '$destroy', function() {
	              delete $scope.col.filterable;
	              delete $scope.col.updateFilters;
	            });
	          },
	          post: function ($scope, $elm) {
	            $scope.aria = i18nService.getSafeText('headerCell.aria');
	            $scope.removeFilter = function(colFilter, index) {
	              colFilter.term = null;
	              // Set the focus to the filter input after the action disables the button
	              gridUtil.focus.bySelector($elm, '.ui-grid-filter-input-' + index);
	            };
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridFooterCell', ['$timeout', 'gridUtil', 'uiGridConstants', '$compile',
	  function ($timeout, gridUtil, uiGridConstants, $compile) {
	    return {
	      priority: 0,
	      scope: {
	        col: '=',
	        row: '=',
	        renderIndex: '='
	      },
	      replace: true,
	      require: '^uiGrid',
	      compile: function compile() {
	        return {
	          pre: function ($scope, $elm) {
	            var template = $scope.col.footerCellTemplate;
	
	            if (template === undefined && $scope.col.providedFooterCellTemplate !== '') {
	              if ($scope.col.footerCellTemplatePromise) {
	                $scope.col.footerCellTemplatePromise.then(function () {
	                  template = $scope.col.footerCellTemplate;
	                  $elm.append($compile(template)($scope));
	                });
	              }
	            }
	            else {
	              $elm.append($compile(template)($scope));
	            }
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            // $elm.addClass($scope.col.getColClass(false));
	            $scope.grid = uiGridCtrl.grid;
	
	            var initColClass = $scope.col.getColClass(false);
	
	            $elm.addClass(initColClass);
	
	            // apply any footerCellClass
	            var classAdded;
	
	            var updateClass = function() {
	              var contents = $elm;
	
	              if ( classAdded ) {
	                contents.removeClass( classAdded );
	                classAdded = null;
	              }
	
	              if (angular.isFunction($scope.col.footerCellClass)) {
	                classAdded = $scope.col.footerCellClass($scope.grid, $scope.row, $scope.col, $scope.rowRenderIndex, $scope.colRenderIndex);
	              }
	              else {
	                classAdded = $scope.col.footerCellClass;
	              }
	              contents.addClass(classAdded);
	            };
	
	            if ($scope.col.footerCellClass) {
	              updateClass();
	            }
	
	            $scope.col.updateAggregationValue();
	
	            // Register a data change watch that would get triggered whenever someone edits a cell or modifies column defs
	            var dataChangeDereg = $scope.grid.registerDataChangeCallback( updateClass, [uiGridConstants.dataChange.COLUMN]);
	
	            // listen for visible rows change and update aggregation values
	            $scope.grid.api.core.on.rowsRendered( $scope, $scope.col.updateAggregationValue );
	            $scope.grid.api.core.on.rowsRendered( $scope, updateClass );
	            $scope.$on( '$destroy', dataChangeDereg );
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridFooter', ['$templateCache', '$compile', 'uiGridConstants', 'gridUtil', '$timeout', function ($templateCache, $compile, uiGridConstants, gridUtil, $timeout) {
	
	    return {
	      restrict: 'EA',
	      replace: true,
	      // priority: 1000,
	      require: ['^uiGrid', '^uiGridRenderContainer'],
	      scope: true,
	      compile: function ($elm, $attrs) {
	        return {
	          pre: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            $scope.grid = uiGridCtrl.grid;
	            $scope.colContainer = containerCtrl.colContainer;
	
	            containerCtrl.footer = $elm;
	
	            var footerTemplate = $scope.grid.options.footerTemplate;
	            gridUtil.getTemplate(footerTemplate)
	              .then(function (contents) {
	                var template = angular.element(contents);
	
	                var newElm = $compile(template)($scope);
	                $elm.append(newElm);
	
	                if (containerCtrl) {
	                  // Inject a reference to the footer viewport (if it exists) into the grid controller for use in the horizontal scroll handler below
	                  var footerViewport = $elm[0].getElementsByClassName('ui-grid-footer-viewport')[0];
	
	                  if (footerViewport) {
	                    containerCtrl.footerViewport = footerViewport;
	                  }
	                }
	              }).catch(angular.noop);
	          },
	
	          post: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            // gridUtil.logDebug('ui-grid-footer link');
	
	            var grid = uiGridCtrl.grid;
	
	            // Don't animate footer cells
	            gridUtil.disableAnimations($elm);
	
	            containerCtrl.footer = $elm;
	
	            var footerViewport = $elm[0].getElementsByClassName('ui-grid-footer-viewport')[0];
	            if (footerViewport) {
	              containerCtrl.footerViewport = footerViewport;
	            }
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	
	(function() {
		'use strict';
	
		angular.module('ui.grid').directive('uiGridGridFooter', ['$templateCache', '$compile', 'uiGridConstants', 'gridUtil',
			function($templateCache, $compile, uiGridConstants, gridUtil) {
				return {
					restrict: 'EA',
					replace: true,
					require: '^uiGrid',
					scope: true,
					compile: function() {
						return {
							pre: function($scope, $elm, $attrs, uiGridCtrl) {
								$scope.grid = uiGridCtrl.grid;
	
								var footerTemplate = $scope.grid.options.gridFooterTemplate;
	
								gridUtil.getTemplate(footerTemplate)
									.then(function(contents) {
										var template = angular.element(contents),
											newElm = $compile(template)($scope);
	
										$elm.append(newElm);
									}).catch(angular.noop);
							}
						};
					}
				};
			}]);
	})();
	
	(function() {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridHeaderCell', ['$compile', '$timeout', '$window', '$document', 'gridUtil', 'uiGridConstants', 'ScrollEvent', 'i18nService', '$rootScope',
	  function ($compile, $timeout, $window, $document, gridUtil, uiGridConstants, ScrollEvent, i18nService, $rootScope) {
	    // Do stuff after mouse has been down this many ms on the header cell
	    var mousedownTimeout = 500,
	      changeModeTimeout = 500; // length of time between a touch event and a mouse event being recognised again, and vice versa
	
	    return {
	      priority: 0,
	      scope: {
	        col: '=',
	        row: '=',
	        renderIndex: '='
	      },
	      require: ['^uiGrid', '^uiGridRenderContainer'],
	      replace: true,
	      compile: function() {
	        return {
	          pre: function ($scope, $elm) {
	            var template = $scope.col.headerCellTemplate;
	            if (template === undefined && $scope.col.providedHeaderCellTemplate !== '') {
	              if ($scope.col.headerCellTemplatePromise) {
	                $scope.col.headerCellTemplatePromise.then(function () {
	                  template = $scope.col.headerCellTemplate;
	                  $elm.append($compile(template)($scope));
	                });
	              }
	            }
	            else {
	              $elm.append($compile(template)($scope));
	            }
	          },
	
	          post: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var renderContainerCtrl = controllers[1];
	
	            $scope.i18n = {
	              headerCell: i18nService.getSafeText('headerCell'),
	              sort: i18nService.getSafeText('sort')
	            };
	            $scope.isSortPriorityVisible = function() {
	              // show sort priority if column is sorted and there is at least one other sorted column
	              return $scope.col && $scope.col.sort && angular.isNumber($scope.col.sort.priority) && $scope.grid.columns.some(function(element, index) {
	                  return angular.isNumber(element.sort.priority) && element !== $scope.col;
	                });
	            };
	            $scope.getSortDirectionAriaLabel = function() {
	              var col = $scope.col;
	              // Trying to recreate this sort of thing but it was getting messy having it in the template.
	              // Sort direction {{col.sort.direction == asc ? 'ascending' : ( col.sort.direction == desc ? 'descending': 'none')}}.
	              // {{col.sort.priority ? {{columnPriorityText}} {{col.sort.priority}} : ''}
	              var label = col.sort && col.sort.direction === uiGridConstants.ASC ? $scope.i18n.sort.ascending : ( col.sort && col.sort.direction === uiGridConstants.DESC ? $scope.i18n.sort.descending : $scope.i18n.sort.none);
	
	              if ($scope.isSortPriorityVisible()) {
	                label = label + '. ' + $scope.i18n.headerCell.priority + ' ' + (col.sort.priority + 1);
	              }
	              return label;
	            };
	
	            $scope.grid = uiGridCtrl.grid;
	
	            $scope.renderContainer = uiGridCtrl.grid.renderContainers[renderContainerCtrl.containerId];
	
	            var initColClass = $scope.col.getColClass(false);
	            $elm.addClass(initColClass);
	
	            // Hide the menu by default
	            $scope.menuShown = false;
	            $scope.col.menuShown = false;
	
	            // Put asc and desc sort directions in scope
	            $scope.asc = uiGridConstants.ASC;
	            $scope.desc = uiGridConstants.DESC;
	
	            // Store a reference to menu element
	            var $contentsElm = angular.element( $elm[0].querySelectorAll('.ui-grid-cell-contents') );
	
	
	            // apply any headerCellClass
	            var classAdded,
	              previousMouseX;
	
	            // filter watchers
	            var filterDeregisters = [];
	
	
	            /*
	             * Our basic approach here for event handlers is that we listen for a down event (mousedown or touchstart).
	             * Once we have a down event, we need to work out whether we have a click, a drag, or a
	             * hold.  A click would sort the grid (if sortable).  A drag would be used by moveable, so
	             * we ignore it.  A hold would open the menu.
	             *
	             * So, on down event, we put in place handlers for move and up events, and a timer.  If the
	             * timer expires before we see a move or up, then we have a long press and hence a column menu open.
	             * If the up happens before the timer, then we have a click, and we sort if the column is sortable.
	             * If a move happens before the timer, then we are doing column move, so we do nothing, the moveable feature
	             * will handle it.
	             *
	             * To deal with touch enabled devices that also have mice, we only create our handlers when
	             * we get the down event, and we create the corresponding handlers - if we're touchstart then
	             * we get touchmove and touchend, if we're mousedown then we get mousemove and mouseup.
	             *
	             * We also suppress the click action whilst this is happening - otherwise after the mouseup there
	             * will be a click event and that can cause the column menu to close
	             *
	             */
	            $scope.downFn = function( event ) {
	              event.stopPropagation();
	
	              if (typeof(event.originalEvent) !== 'undefined' && event.originalEvent !== undefined) {
	                event = event.originalEvent;
	              }
	
	              // Don't show the menu if it's not the left button
	              if (event.button && event.button !== 0) {
	                return;
	              }
	              previousMouseX = event.pageX;
	
	              $scope.mousedownStartTime = (new Date()).getTime();
	              $scope.mousedownTimeout = $timeout(function() { }, mousedownTimeout);
	
	              $scope.mousedownTimeout.then(function () {
	                if ( $scope.colMenu ) {
	                  uiGridCtrl.columnMenuScope.showMenu($scope.col, $elm, event);
	                }
	              }).catch(angular.noop);
	
	              uiGridCtrl.fireEvent(uiGridConstants.events.COLUMN_HEADER_CLICK, {event: event, columnName: $scope.col.colDef.name});
	
	              $scope.offAllEvents();
	              if ( event.type === 'touchstart') {
	                $document.on('touchend', $scope.upFn);
	                $document.on('touchmove', $scope.moveFn);
	              } else if ( event.type === 'mousedown' ) {
	                $document.on('mouseup', $scope.upFn);
	                $document.on('mousemove', $scope.moveFn);
	              }
	            };
	
	            $scope.upFn = function( event ) {
	              event.stopPropagation();
	              $timeout.cancel($scope.mousedownTimeout);
	              $scope.offAllEvents();
	              $scope.onDownEvents(event.type);
	
	              var mousedownEndTime = (new Date()).getTime();
	              var mousedownTime = mousedownEndTime - $scope.mousedownStartTime;
	
	              if (mousedownTime > mousedownTimeout) {
	                // long click, handled above with mousedown
	              }
	              else {
	                // short click
	                if ( $scope.sortable ) {
	                  $scope.handleClick(event);
	                }
	              }
	            };
	
	            $scope.handleKeyDown = function(event) {
	              if (event.keyCode === 32 || event.keyCode === 13) {
	                event.preventDefault();
	                $scope.handleClick(event);
	              }
	            };
	
	            $scope.moveFn = function( event ) {
	              // Chrome is known to fire some bogus move events.
	              var changeValue = event.pageX - previousMouseX;
	              if ( changeValue === 0 ) { return; }
	
	              // we're a move, so do nothing and leave for column move (if enabled) to take over
	              $timeout.cancel($scope.mousedownTimeout);
	              $scope.offAllEvents();
	              $scope.onDownEvents(event.type);
	            };
	
	            $scope.clickFn = function ( event ) {
	              event.stopPropagation();
	              $contentsElm.off('click', $scope.clickFn);
	            };
	
	
	            $scope.offAllEvents = function() {
	              $contentsElm.off('touchstart', $scope.downFn);
	              $contentsElm.off('mousedown', $scope.downFn);
	
	              $document.off('touchend', $scope.upFn);
	              $document.off('mouseup', $scope.upFn);
	
	              $document.off('touchmove', $scope.moveFn);
	              $document.off('mousemove', $scope.moveFn);
	
	              $contentsElm.off('click', $scope.clickFn);
	            };
	
	            $scope.onDownEvents = function( type ) {
	              // If there is a previous event, then wait a while before
	              // activating the other mode - i.e. if the last event was a touch event then
	              // don't enable mouse events for a wee while (500ms or so)
	              // Avoids problems with devices that emulate mouse events when you have touch events
	
	              switch (type) {
	                case 'touchmove':
	                case 'touchend':
	                  $contentsElm.on('click', $scope.clickFn);
	                  $contentsElm.on('touchstart', $scope.downFn);
	                  $timeout(function() {
	                    $contentsElm.on('mousedown', $scope.downFn);
	                  }, changeModeTimeout);
	                  break;
	                case 'mousemove':
	                case 'mouseup':
	                  $contentsElm.on('click', $scope.clickFn);
	                  $contentsElm.on('mousedown', $scope.downFn);
	                  $timeout(function() {
	                    $contentsElm.on('touchstart', $scope.downFn);
	                  }, changeModeTimeout);
	                  break;
	                default:
	                  $contentsElm.on('click', $scope.clickFn);
	                  $contentsElm.on('touchstart', $scope.downFn);
	                  $contentsElm.on('mousedown', $scope.downFn);
	              }
	            };
	
	            var setFilter = function (updateFilters) {
	              if ( updateFilters ) {
	                if ( typeof($scope.col.updateFilters) !== 'undefined' ) {
	                  $scope.col.updateFilters($scope.col.filterable);
	                }
	
	                // if column is filterable add a filter watcher
	                if ($scope.col.filterable) {
	                  $scope.col.filters.forEach( function(filter, i) {
	                    filterDeregisters.push($scope.$watch('col.filters[' + i + '].term', function(n, o) {
	                      if (n !== o) {
	                        uiGridCtrl.grid.api.core.raise.filterChanged( $scope.col );
	                        uiGridCtrl.grid.api.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
	                        uiGridCtrl.grid.queueGridRefresh();
	                      }
	                    }));
	                  });
	                  $scope.$on('$destroy', function() {
	                    filterDeregisters.forEach( function(filterDeregister) {
	                      filterDeregister();
	                    });
	                  });
	                } else {
	                  filterDeregisters.forEach( function(filterDeregister) {
	                    filterDeregister();
	                  });
	                }
	              }
	            };
	
	            var updateHeaderOptions = function() {
	              var contents = $elm;
	
	              if ( classAdded ) {
	                contents.removeClass( classAdded );
	                classAdded = null;
	              }
	
	              if (angular.isFunction($scope.col.headerCellClass)) {
	                classAdded = $scope.col.headerCellClass($scope.grid, $scope.row, $scope.col, $scope.rowRenderIndex, $scope.colRenderIndex);
	              }
	              else {
	                classAdded = $scope.col.headerCellClass;
	              }
	              contents.addClass(classAdded);
	
	              $scope.$applyAsync(function() {
	                var rightMostContainer = $scope.grid.renderContainers['right'] && $scope.grid.renderContainers['right'].visibleColumnCache.length ?
	                $scope.grid.renderContainers['right'] : $scope.grid.renderContainers['body'];
	                $scope.isLastCol = uiGridCtrl.grid.options && uiGridCtrl.grid.options.enableGridMenu &&
	                  $scope.col === rightMostContainer.visibleColumnCache[ rightMostContainer.visibleColumnCache.length - 1 ];
	              });
	
	              // Figure out whether this column is sortable or not
	              $scope.sortable = Boolean($scope.col.enableSorting);
	
	              // Figure out whether this column is filterable or not
	              var oldFilterable = $scope.col.filterable;
	              $scope.col.filterable = Boolean(uiGridCtrl.grid.options.enableFiltering && $scope.col.enableFiltering);
	
	              setFilter(oldFilterable !== $scope.col.filterable);
	
	              // figure out whether we support column menus
	              $scope.colMenu = ($scope.col.grid.options && $scope.col.grid.options.enableColumnMenus !== false &&
	                      $scope.col.colDef && $scope.col.colDef.enableColumnMenu !== false);
	
	              /**
	               * @ngdoc property
	               * @name enableColumnMenu
	               * @propertyOf ui.grid.class:GridOptions.columnDef
	               * @description if column menus are enabled, controls the column menus for this specific
	               * column (i.e. if gridOptions.enableColumnMenus, then you can control column menus
	               * using this option. If gridOptions.enableColumnMenus === false then you get no column
	               * menus irrespective of the value of this option ).  Defaults to true.
	               *
	               * By default column menu's trigger is hidden before mouse over, but you can always force it to be visible with CSS:
	               *
	               * <pre>
	               *  .ui-grid-column-menu-button {
	               *    display: block;
	               *  }
	               * </pre>
	               */
	              /**
	              * @ngdoc property
	              * @name enableColumnMenus
	              * @propertyOf ui.grid.class:GridOptions.columnDef
	              * @description Override for column menus everywhere - if set to false then you get no
	              * column menus.  Defaults to true.
	              *
	              */
	
	              $scope.offAllEvents();
	
	              if ($scope.sortable || $scope.colMenu) {
	                $scope.onDownEvents();
	
	                $scope.$on('$destroy', function () {
	                  $scope.offAllEvents();
	                });
	              }
	            };
	
	            updateHeaderOptions();
	
	            if ($scope.col.filterContainer === 'columnMenu' && $scope.col.filterable) {
	              $rootScope.$on('menu-shown', function() {
	                $scope.$applyAsync(function () {
	                  setFilter($scope.col.filterable);
	                });
	              });
	            }
	
	            // Register a data change watch that would get triggered whenever someone edits a cell or modifies column defs
	            var dataChangeDereg = $scope.grid.registerDataChangeCallback( updateHeaderOptions, [uiGridConstants.dataChange.COLUMN]);
	
	            $scope.$on( '$destroy', dataChangeDereg );
	
	            $scope.handleClick = function(event) {
	              // If the shift key is being held down, add this column to the sort
	              // Sort this column then rebuild the grid's rows
	              uiGridCtrl.grid.sortColumn($scope.col, event.shiftKey)
	                .then(function () {
	                  if (uiGridCtrl.columnMenuScope) { uiGridCtrl.columnMenuScope.hideMenu(); }
	                  uiGridCtrl.grid.refresh();
	                }).catch(angular.noop);
	            };
	
	            $scope.headerCellArrowKeyDown = function(event) {
	              if (event.keyCode === uiGridConstants.keymap.SPACE || event.keyCode === uiGridConstants.keymap.ENTER) {
	                event.preventDefault();
	                $scope.toggleMenu(event);
	              }
	            };
	
	            $scope.toggleMenu = function(event) {
	              event.stopPropagation();
	
	              // If the menu is already showing and we're the column the menu is on
	              if (uiGridCtrl.columnMenuScope.menuShown && uiGridCtrl.columnMenuScope.col === $scope.col) {
	                // ... hide it
	                uiGridCtrl.columnMenuScope.hideMenu();
	              }
	              // If the menu is NOT showing or is showing in a different column
	              else {
	                // ... show it on our column
	                uiGridCtrl.columnMenuScope.showMenu($scope.col, $elm);
	              }
	            };
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function() {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridHeader', ['$templateCache', '$compile', 'uiGridConstants', 'gridUtil', '$timeout', 'ScrollEvent',
	    function($templateCache, $compile, uiGridConstants, gridUtil, $timeout, ScrollEvent) {
	    var defaultTemplate = 'ui-grid/ui-grid-header',
	      emptyTemplate = 'ui-grid/ui-grid-no-header';
	
	    return {
	      restrict: 'EA',
	      replace: true,
	      require: ['^uiGrid', '^uiGridRenderContainer'],
	      scope: true,
	      compile: function() {
	        return {
	          pre: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0],
	              containerCtrl = controllers[1];
	
	            $scope.grid = uiGridCtrl.grid;
	            $scope.colContainer = containerCtrl.colContainer;
	
	            updateHeaderReferences();
	
	            var headerTemplate;
	            if (!$scope.grid.options.showHeader) {
	              headerTemplate = emptyTemplate;
	            }
	            else {
	              headerTemplate = ($scope.grid.options.headerTemplate) ? $scope.grid.options.headerTemplate : defaultTemplate;
	            }
	
	            gridUtil.getTemplate(headerTemplate)
	              .then(function (contents) {
	                var template = angular.element(contents);
	
	                var newElm = $compile(template)($scope);
	                $elm.replaceWith(newElm);
	
	                // And update $elm to be the new element
	                $elm = newElm;
	
	                updateHeaderReferences();
	
	                if (containerCtrl) {
	                  // Inject a reference to the header viewport (if it exists) into the grid controller for use in the horizontal scroll handler below
	                  var headerViewport = $elm[0].getElementsByClassName('ui-grid-header-viewport')[0];
	
	
	                  if (headerViewport) {
	                    containerCtrl.headerViewport = headerViewport;
	                    angular.element(headerViewport).on('scroll', scrollHandler);
	                    $scope.$on('$destroy', function () {
	                      angular.element(headerViewport).off('scroll', scrollHandler);
	                    });
	                  }
	                }
	
	                $scope.grid.queueRefresh();
	              }).catch(angular.noop);
	
	            function updateHeaderReferences() {
	              containerCtrl.header = containerCtrl.colContainer.header = $elm;
	
	              var headerCanvases = $elm[0].getElementsByClassName('ui-grid-header-canvas');
	
	              if (headerCanvases.length > 0) {
	                containerCtrl.headerCanvas = containerCtrl.colContainer.headerCanvas = headerCanvases[0];
	              }
	              else {
	                containerCtrl.headerCanvas = null;
	              }
	            }
	
	            function scrollHandler() {
	              if (uiGridCtrl.grid.isScrollingHorizontally) {
	                return;
	              }
	              var newScrollLeft = gridUtil.normalizeScrollLeft(containerCtrl.headerViewport, uiGridCtrl.grid);
	              var horizScrollPercentage = containerCtrl.colContainer.scrollHorizontal(newScrollLeft);
	
	              var scrollEvent = new ScrollEvent(uiGridCtrl.grid, null, containerCtrl.colContainer, ScrollEvent.Sources.ViewPortScroll);
	              scrollEvent.newScrollLeft = newScrollLeft;
	              if ( horizScrollPercentage > -1 ) {
	                scrollEvent.x = { percentage: horizScrollPercentage };
	              }
	
	              uiGridCtrl.grid.scrollContainers(null, scrollEvent);
	            }
	          },
	
	          post: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            // gridUtil.logDebug('ui-grid-header link');
	
	            var grid = uiGridCtrl.grid;
	
	            // Don't animate header cells
	            gridUtil.disableAnimations($elm);
	
	            function updateColumnWidths() {
	              // this styleBuilder always runs after the renderContainer, so we can rely on the column widths
	              // already being populated correctly
	
	              var columnCache = containerCtrl.colContainer.visibleColumnCache;
	
	              // Build the CSS
	              // uiGridCtrl.grid.columns.forEach(function (column) {
	              var ret = '';
	              var canvasWidth = 0;
	              columnCache.forEach(function (column) {
	                ret = ret + column.getColClassDefinition();
	                canvasWidth += column.drawnWidth;
	              });
	
	              containerCtrl.colContainer.canvasWidth = canvasWidth;
	
	              // Return the styles back to buildStyles which pops them into the `customStyles` scope variable
	              return ret;
	            }
	
	            containerCtrl.header = $elm;
	
	            var headerViewport = $elm[0].getElementsByClassName('ui-grid-header-viewport')[0];
	            if (headerViewport) {
	              containerCtrl.headerViewport = headerViewport;
	            }
	
	            // todo: remove this if by injecting gridCtrl into unit tests
	            if (uiGridCtrl) {
	              uiGridCtrl.grid.registerStyleComputation({
	                priority: 15,
	                func: updateColumnWidths
	              });
	            }
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function() {
	
	angular.module('ui.grid')
	.service('uiGridGridMenuService', [ 'gridUtil', 'i18nService', 'uiGridConstants', function( gridUtil, i18nService, uiGridConstants ) {
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.uiGridGridMenuService
	   *
	   *  @description Methods for working with the grid menu
	   */
	
	  var service = {
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @name initialize
	     * @description Sets up the gridMenu. Most importantly, sets our
	     * scope onto the grid object as grid.gridMenuScope, allowing us
	     * to operate when passed only the grid.  Second most importantly,
	     * we register the 'addToGridMenu' and 'removeFromGridMenu' methods
	     * on the core api.
	     * @param {$scope} $scope the scope of this gridMenu
	     * @param {Grid} grid the grid to which this gridMenu is associated
	     */
	    initialize: function( $scope, grid ) {
	      grid.gridMenuScope = $scope;
	      $scope.grid = grid;
	      $scope.registeredMenuItems = [];
	
	      // not certain this is needed, but would be bad to create a memory leak
	      $scope.$on('$destroy', function() {
	        if ( $scope.grid && $scope.grid.gridMenuScope ) {
	          $scope.grid.gridMenuScope = null;
	        }
	        if ( $scope.grid ) {
	          $scope.grid = null;
	        }
	        if ( $scope.registeredMenuItems ) {
	          $scope.registeredMenuItems = null;
	        }
	      });
	
	      $scope.registeredMenuItems = [];
	
	      /**
	       * @ngdoc function
	       * @name addToGridMenu
	       * @methodOf ui.grid.api:PublicApi
	       * @description add items to the grid menu.  Used by features
	       * to add their menu items if they are enabled, can also be used by
	       * end users to add menu items.  This method has the advantage of allowing
	       * remove again, which can simplify management of which items are included
	       * in the menu when.  (Noting that in most cases the shown and active functions
	       * provide a better way to handle visibility of menu items)
	       * @param {Grid} grid the grid on which we are acting
	       * @param {array} items menu items in the format as described in the tutorial, with
	       * the added note that if you want to use remove you must also specify an `id` field,
	       * which is provided when you want to remove an item.  The id should be unique.
	       *
	       */
	      grid.api.registerMethod( 'core', 'addToGridMenu', service.addToGridMenu );
	
	      /**
	       * @ngdoc function
	       * @name removeFromGridMenu
	       * @methodOf ui.grid.api:PublicApi
	       * @description Remove an item from the grid menu based on a provided id. Assumes
	       * that the id is unique, removes only the last instance of that id. Does nothing if
	       * the specified id is not found
	       * @param {Grid} grid the grid on which we are acting
	       * @param {string} id the id we'd like to remove from the menu
	       *
	       */
	      grid.api.registerMethod( 'core', 'removeFromGridMenu', service.removeFromGridMenu );
	    },
	
	
	    /**
	     * @ngdoc function
	     * @name addToGridMenu
	     * @propertyOf ui.grid.uiGridGridMenuService
	     * @description add items to the grid menu.  Used by features
	     * to add their menu items if they are enabled, can also be used by
	     * end users to add menu items.  This method has the advantage of allowing
	     * remove again, which can simplify management of which items are included
	     * in the menu when.  (Noting that in most cases the shown and active functions
	     * provide a better way to handle visibility of menu items)
	     * @param {Grid} grid the grid on which we are acting
	     * @param {array} menuItems menu items in the format as described in the tutorial, with
	     * the added note that if you want to use remove you must also specify an `id` field,
	     * which is provided when you want to remove an item.  The id should be unique.
	     *
	     */
	    addToGridMenu: function( grid, menuItems ) {
	      if ( !angular.isArray( menuItems ) ) {
	        gridUtil.logError( 'addToGridMenu: menuItems must be an array, and is not, not adding any items');
	      } else {
	        if ( grid.gridMenuScope ) {
	          grid.gridMenuScope.registeredMenuItems = grid.gridMenuScope.registeredMenuItems ? grid.gridMenuScope.registeredMenuItems : [];
	          grid.gridMenuScope.registeredMenuItems = grid.gridMenuScope.registeredMenuItems.concat( menuItems );
	        } else {
	          gridUtil.logError( 'Asked to addToGridMenu, but gridMenuScope not present.  Timing issue?  Please log issue with ui-grid');
	        }
	      }
	    },
	
	
	    /**
	     * @ngdoc function
	     * @name removeFromGridMenu
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @description Remove an item from the grid menu based on a provided id.  Assumes
	     * that the id is unique, removes only the last instance of that id.  Does nothing if
	     * the specified id is not found.  If there is no gridMenuScope or registeredMenuItems
	     * then do nothing silently - the desired result is those menu items not be present and they
	     * aren't.
	     * @param {Grid} grid the grid on which we are acting
	     * @param {string} id the id we'd like to remove from the menu
	     *
	     */
	    removeFromGridMenu: function( grid, id ) {
	      var foundIndex = -1;
	
	      if ( grid && grid.gridMenuScope ) {
	        grid.gridMenuScope.registeredMenuItems.forEach( function( value, index ) {
	          if ( value.id === id ) {
	            if (foundIndex > -1) {
	              gridUtil.logError( 'removeFromGridMenu: found multiple items with the same id, removing only the last' );
	            } else {
	
	              foundIndex = index;
	            }
	          }
	        });
	      }
	
	      if ( foundIndex > -1 ) {
	        grid.gridMenuScope.registeredMenuItems.splice( foundIndex, 1 );
	      }
	    },
	
	
	    /**
	     * @ngdoc array
	     * @name gridMenuCustomItems
	     * @propertyOf ui.grid.class:GridOptions
	     * @description (optional) An array of menu items that should be added to
	     * the gridMenu.  Follow the format documented in the tutorial for column
	     * menu customisation.  The context provided to the action function will
	     * include context.grid.  An alternative if working with dynamic menus is to use the
	     * provided api - core.addToGridMenu and core.removeFromGridMenu, which handles
	     * some of the management of items for you.
	     *
	     */
	    /**
	     * @ngdoc boolean
	     * @name gridMenuShowHideColumns
	     * @propertyOf ui.grid.class:GridOptions
	     * @description true by default, whether the grid menu should allow hide/show
	     * of columns
	     *
	     */
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @name getMenuItems
	     * @description Decides the menu items to show in the menu.  This is a
	     * combination of:
	     *
	     * - the default menu items that are always included,
	     * - any menu items that have been provided through the addMenuItem api. These
	     *   are typically added by features within the grid
	     * - any menu items included in grid.options.gridMenuCustomItems.  These can be
	     *   changed dynamically, as they're always recalculated whenever we show the
	     *   menu
	     * @param {$scope} $scope the scope of this gridMenu, from which we can find all
	     * the information that we need
	     * @returns {Array} an array of menu items that can be shown
	     */
	    getMenuItems: function( $scope ) {
	      var menuItems = [
	        // this is where we add any menu items we want to always include
	      ];
	
	      if ( $scope.grid.options.gridMenuCustomItems ) {
	        if ( !angular.isArray( $scope.grid.options.gridMenuCustomItems ) ) {
	          gridUtil.logError( 'gridOptions.gridMenuCustomItems must be an array, and is not');
	        } else {
	          menuItems = menuItems.concat( $scope.grid.options.gridMenuCustomItems );
	        }
	      }
	
	      var clearFilters = [{
	        title: i18nService.getSafeText('gridMenu.clearAllFilters'),
	        action: function ($event) {
	          $scope.grid.clearAllFilters();
	        },
	        shown: function() {
	          return $scope.grid.options.enableFiltering;
	        },
	        order: 100
	      }];
	      menuItems = menuItems.concat( clearFilters );
	
	      menuItems = menuItems.concat( $scope.registeredMenuItems );
	
	      if ( $scope.grid.options.gridMenuShowHideColumns !== false ) {
	        menuItems = menuItems.concat( service.showHideColumns( $scope ) );
	      }
	
	      menuItems.sort(function(a, b) {
	        return a.order - b.order;
	      });
	
	      return menuItems;
	    },
	
	
	    /**
	     * @ngdoc array
	     * @name gridMenuTitleFilter
	     * @propertyOf ui.grid.class:GridOptions
	     * @description (optional) A function that takes a title string
	     * (usually the col.displayName), and converts it into a display value.  The function
	     * must return either a string or a promise.
	     *
	     * Used for internationalization of the grid menu column names - for angular-translate
	     * you can pass $translate as the function, for i18nService you can pass getSafeText as the
	     * function
	     * @example
	     * <pre>
	     *   gridOptions = {
	     *     gridMenuTitleFilter: $translate
	     *   }
	     * </pre>
	     */
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @name showHideColumns
	     * @description Adds two menu items for each of the columns in columnDefs.  One
	     * menu item for hide, one menu item for show.  Each is visible when appropriate
	     * (show when column is not visible, hide when column is visible).  Each toggles
	     * the visible property on the columnDef using toggleColumnVisibility
	     * @param {$scope} $scope of a gridMenu, which contains a reference to the grid
	     */
	    showHideColumns: function( $scope ) {
	      var showHideColumns = [];
	      if ( !$scope.grid.options.columnDefs || $scope.grid.options.columnDefs.length === 0 || $scope.grid.columns.length === 0 ) {
	        return showHideColumns;
	      }
	
	      function isColumnVisible(colDef) {
	        return colDef.visible === true || colDef.visible === undefined;
	      }
	
	      function getColumnIcon(colDef) {
	        return isColumnVisible(colDef) ? 'ui-grid-icon-ok' : 'ui-grid-icon-cancel';
	      }
	
	      $scope.grid.options.gridMenuTitleFilter = $scope.grid.options.gridMenuTitleFilter ? $scope.grid.options.gridMenuTitleFilter : function( title ) { return title; };
	
	      $scope.grid.options.columnDefs.forEach( function( colDef, index ) {
	        if ( $scope.grid.options.enableHiding !== false && colDef.enableHiding !== false || colDef.enableHiding ) {
	          // add hide menu item - shows an OK icon as we only show when column is already visible
	          var menuItem = {
	            icon: getColumnIcon(colDef),
	            action: function($event) {
	              $event.stopPropagation();
	
	              service.toggleColumnVisibility( this.context.gridCol );
	
	              if ($event.target && $event.target.firstChild) {
	                if (angular.element($event.target)[0].nodeName === 'I') {
	                  $event.target.className = getColumnIcon(this.context.gridCol.colDef);
	                }
	                else {
	                  $event.target.firstChild.className = getColumnIcon(this.context.gridCol.colDef);
	                }
	              }
	            },
	            shown: function() {
	              return this.context.gridCol.colDef.enableHiding !== false;
	            },
	            context: { gridCol: $scope.grid.getColumn(colDef.name || colDef.field) },
	            leaveOpen: true,
	            order: 301 + index
	          };
	          service.setMenuItemTitle( menuItem, colDef, $scope.grid );
	          showHideColumns.push( menuItem );
	        }
	      });
	
	      // add header for columns
	      if ( showHideColumns.length ) {
	        showHideColumns.unshift({
	          title: i18nService.getSafeText('gridMenu.columns'),
	          order: 300,
	          templateUrl: 'ui-grid/ui-grid-menu-header-item'
	        });
	      }
	
	      return showHideColumns;
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @name setMenuItemTitle
	     * @description Handles the response from gridMenuTitleFilter, adding it directly to the menu
	     * item if it returns a string, otherwise waiting for the promise to resolve or reject then
	     * putting the result into the title
	     * @param {object} menuItem the menuItem we want to put the title on
	     * @param {object} colDef the colDef from which we can get displayName, name or field
	     * @param {Grid} grid the grid, from which we can get the options.gridMenuTitleFilter
	     *
	     */
	    setMenuItemTitle: function( menuItem, colDef, grid ) {
	      var title = grid.options.gridMenuTitleFilter( colDef.displayName || gridUtil.readableColumnName(colDef.name) || colDef.field );
	
	      if ( typeof(title) === 'string' ) {
	        menuItem.title = title;
	      } else if ( title.then ) {
	        // must be a promise
	        menuItem.title = "";
	        title.then( function( successValue ) {
	          menuItem.title = successValue;
	        }, function( errorValue ) {
	          menuItem.title = errorValue;
	        }).catch(angular.noop);
	      } else {
	        gridUtil.logError('Expected gridMenuTitleFilter to return a string or a promise, it has returned neither, bad config');
	        menuItem.title = 'badconfig';
	      }
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @name toggleColumnVisibility
	     * @description Toggles the visibility of an individual column.  Expects to be
	     * provided a context that has on it a gridColumn, which is the column that
	     * we'll operate upon.  We change the visibility, and refresh the grid as appropriate
	     * @param {GridColumn} gridCol the column that we want to toggle
	     *
	     */
	    toggleColumnVisibility: function( gridCol ) {
	      gridCol.colDef.visible = !( gridCol.colDef.visible === true || gridCol.colDef.visible === undefined );
	
	      gridCol.grid.refresh();
	      gridCol.grid.api.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
	      gridCol.grid.api.core.raise.columnVisibilityChanged( gridCol );
	    }
	  };
	
	  return service;
	}])
	
	.directive('uiGridMenuButton', ['gridUtil', 'uiGridConstants', 'uiGridGridMenuService', 'i18nService',
	function (gridUtil, uiGridConstants, uiGridGridMenuService, i18nService) {
	
	  return {
	    priority: 0,
	    scope: true,
	    require: ['^uiGrid'],
	    templateUrl: 'ui-grid/ui-grid-menu-button',
	    replace: true,
	
	    link: function ($scope, $elm, $attrs, controllers) {
	      var uiGridCtrl = controllers[0];
	
	      // For the aria label
	      $scope.i18n = {
	        aria: i18nService.getSafeText('gridMenu.aria')
	      };
	
	      uiGridGridMenuService.initialize($scope, uiGridCtrl.grid);
	
	      $scope.shown = false;
	
	      $scope.toggleOnKeydown = function(event) {
	        if (
	          event.keyCode === uiGridConstants.keymap.ENTER ||
	          event.keyCode === uiGridConstants.keymap.SPACE ||
	          (event.keyCode === uiGridConstants.keymap.ESC && $scope.shown)
	        ) {
	          $scope.toggleMenu();
	        }
	      };
	
	      $scope.toggleMenu = function () {
	        if ( $scope.shown ) {
	          $scope.$broadcast('hide-menu');
	          $scope.shown = false;
	        } else {
	          $scope.menuItems = uiGridGridMenuService.getMenuItems( $scope );
	          $scope.$broadcast('show-menu');
	          $scope.shown = true;
	        }
	      };
	
	      $scope.$on('menu-hidden', function() {
	        $scope.shown = false;
	        gridUtil.focus.bySelector($elm, '.ui-grid-icon-container');
	      });
	    }
	  };
	}]);
	})();
	
	(function() {
	
	/**
	 * @ngdoc directive
	 * @name ui.grid.directive:uiGridMenu
	 * @element style
	 * @restrict A
	 *
	 * @description
	 * Allows us to interpolate expressions in `<style>` elements. Angular doesn't do this by default as it can/will/might? break in IE8.
	 *
	 * @example
	 <doc:example module="app">
	 <doc:source>
	 <script>
	 var app = angular.module('app', ['ui.grid']);
	
	 app.controller('MainCtrl', ['$scope', function ($scope) {
	
	 }]);
	 </script>
	
	 <div ng-controller="MainCtrl">
	   <div ui-grid-menu shown="true"  ></div>
	 </div>
	 </doc:source>
	 <doc:scenario>
	 </doc:scenario>
	 </doc:example>
	 */
	angular.module('ui.grid')
	
	.directive('uiGridMenu', ['$compile', '$timeout', '$window', '$document', 'gridUtil', 'uiGridConstants', 'i18nService',
	function ($compile, $timeout, $window, $document, gridUtil, uiGridConstants, i18nService) {
	  return {
	    priority: 0,
	    scope: {
	      // shown: '&',
	      menuItems: '=',
	      autoHide: '=?',
	      col: '=?'
	    },
	    require: '?^uiGrid',
	    templateUrl: 'ui-grid/uiGridMenu',
	    replace: false,
	    link: function ($scope, $elm, $attrs, uiGridCtrl) {
	      $scope.dynamicStyles = '';
	      if (uiGridCtrl && uiGridCtrl.grid && uiGridCtrl.grid.options && uiGridCtrl.grid.options.gridMenuTemplate) {
	        var gridMenuTemplate = uiGridCtrl.grid.options.gridMenuTemplate;
	        gridUtil.getTemplate(gridMenuTemplate).then(function (contents) {
	          var template = angular.element(contents);
	          var newElm = $compile(template)($scope);
	          $elm.replaceWith(newElm);
	        }).catch(angular.noop);
	      }
	
	      var setupHeightStyle = function(gridHeight) {
	        // menu appears under header row, so substract that height from it's total
	        // additional 20px for general padding
	        var gridMenuMaxHeight = gridHeight - uiGridCtrl.grid.headerHeight - 20;
	        $scope.dynamicStyles = [
	          '.grid' + uiGridCtrl.grid.id + ' .ui-grid-menu-mid {',
	          'max-height: ' + gridMenuMaxHeight + 'px;',
	          '}'
	        ].join(' ');
	      };
	
	      if (uiGridCtrl) {
	        setupHeightStyle(uiGridCtrl.grid.gridHeight);
	        uiGridCtrl.grid.api.core.on.gridDimensionChanged($scope, function(oldGridHeight, oldGridWidth, newGridHeight, newGridWidth) {
	          setupHeightStyle(newGridHeight);
	        });
	      }
	
	      $scope.i18n = {
	        close: i18nService.getSafeText('columnMenu.close')
	      };
	
	    // *** Show/Hide functions ******
	      $scope.showMenu = function(event, args) {
	        if ( !$scope.shown ) {
	
	          /*
	           * In order to animate cleanly we remove the ng-if, wait a digest cycle, then
	           * animate the removal of the ng-hide.  We can't successfully (so far as I can tell)
	           * animate removal of the ng-if, as the menu items aren't there yet.  And we don't want
	           * to rely on ng-show only, as that leaves elements in the DOM that are needlessly evaluated
	           * on scroll events.
	           *
	           * Note when testing animation that animations don't run on the tutorials.  When debugging it looks
	           * like they do, but angular has a default $animate provider that is just a stub, and that's what's
	           * being called.  ALso don't be fooled by the fact that your browser has actually loaded the
	           * angular-translate.js, it's not using it.  You need to test animations in an external application.
	           */
	          $scope.shown = true;
	
	          // Must be a timeout in order to work properly in Firefox. Issue #6533
	          $timeout(function() {
	            $scope.shownMid = true;
	            $scope.$emit('menu-shown');
	          });
	        } else if ( !$scope.shownMid ) {
	          // we're probably doing a hide then show, so we don't need to wait for ng-if
	          $scope.shownMid = true;
	          $scope.$emit('menu-shown');
	        }
	
	        var docEventType = 'click';
	        if (args && args.originalEvent && args.originalEvent.type && args.originalEvent.type === 'touchstart') {
	          docEventType = args.originalEvent.type;
	        }
	
	        // Turn off an existing document click handler
	        angular.element(document).off('click touchstart', applyHideMenu);
	
	        // Turn on the document click handler, but in a timeout so it doesn't apply to THIS click if there is one
	        $timeout(function() {
	          angular.element(document).on(docEventType, applyHideMenu);
	        });
	      };
	
	
	      $scope.hideMenu = function(event) {
	        if ( $scope.shown ) {
	          /*
	           * In order to animate cleanly we animate the addition of ng-hide, then use a $timeout to
	           * set the ng-if (shown = false) after the animation runs.  In theory we can cascade off the
	           * callback on the addClass method, but it is very unreliable with unit tests for no discernable reason.
	           *
	           * The user may have clicked on the menu again whilst
	           * we're waiting, so we check that the mid isn't shown before applying the ng-if.
	           */
	          $scope.shownMid = false;
	          $timeout( function() {
	            if ( !$scope.shownMid ) {
	              $scope.shown = false;
	              $scope.$emit('menu-hidden');
	            }
	          }, 40);
	        }
	
	        angular.element(document).off('click touchstart', applyHideMenu);
	      };
	
	      $scope.$on('hide-menu', function (event, args) {
	        $scope.hideMenu(event, args);
	      });
	
	      $scope.$on('show-menu', function (event, args) {
	        $scope.showMenu(event, args);
	      });
	
	
	    // *** Auto hide when click elsewhere ******
	      var applyHideMenu = function(event) {
	        if ($scope.shown) {
	          if ($scope.col && $scope.col.filterContainer === 'columnMenu') {
	            var elm = document.querySelector('.ui-grid-column-menu').querySelector('[ui-grid-filter]');
	            if (elm && elm.contains(event.target)) {
	              return false;
	            }
	          }
	
	          $scope.$apply(function () {
	            $scope.hideMenu();
	          });
	        }
	      };
	
	      $scope.checkKeyDown = function(event) {
	        var setFocus = function(elm) {
	          elm.focus();
	          event.preventDefault();
	        };
	        if (event.keyCode === uiGridConstants.keymap.ESC) {
	          $scope.hideMenu();
	        } else if (event.keyCode === uiGridConstants.keymap.TAB) {
	          var firstMenuItem, lastMenuItem;
	          var menuItemButtons = $elm[0].querySelectorAll('button:not(.ng-hide)');
	          if (menuItemButtons.length > 0) {
	            firstMenuItem = menuItemButtons[0];
	            lastMenuItem = menuItemButtons[menuItemButtons.length - 1];
	            if (event.target.parentElement.id === lastMenuItem.parentElement.id && !event.shiftKey) {
	              setFocus(firstMenuItem);
	            } else if (event.target.parentElement.id === firstMenuItem.parentElement.id && event.shiftKey) {
	              setFocus(lastMenuItem);
	            }
	          }
	        }
	      };
	
	      if (typeof($scope.autoHide) === 'undefined' || $scope.autoHide === undefined) {
	        $scope.autoHide = true;
	      }
	
	      if ($scope.autoHide) {
	        angular.element($window).on('resize', applyHideMenu);
	      }
	
	      $scope.$on('$destroy', function unbindEvents() {
	        angular.element($window).off('resize', applyHideMenu);
	        angular.element(document).off('click touchstart', applyHideMenu);
	      });
	
	      if (uiGridCtrl) {
	       $scope.$on('$destroy', uiGridCtrl.grid.api.core.on.scrollBegin($scope, applyHideMenu ));
	      }
	
	      $scope.$on('$destroy', $scope.$on(uiGridConstants.events.ITEM_DRAGGING, applyHideMenu ));
	    }
	  };
	}])
	
	.directive('uiGridMenuItem', ['gridUtil', '$compile', 'i18nService', function (gridUtil, $compile, i18nService) {
	  return {
	    priority: 0,
	    scope: {
	      name: '=',
	      active: '=',
	      action: '=',
	      icon: '=',
	      shown: '=',
	      context: '=',
	      templateUrl: '=',
	      leaveOpen: '=',
	      screenReaderOnly: '='
	    },
	    require: ['?^uiGrid'],
	    templateUrl: 'ui-grid/uiGridMenuItem',
	    replace: false,
	    compile: function() {
	      return {
	        pre: function ($scope, $elm) {
	          if ($scope.templateUrl) {
	            gridUtil.getTemplate($scope.templateUrl)
	                .then(function (contents) {
	                  var template = angular.element(contents);
	
	                  var newElm = $compile(template)($scope);
	                  $elm.replaceWith(newElm);
	                }).catch(angular.noop);
	          }
	        },
	        post: function ($scope, $elm, $attrs, controllers) {
	          var uiGridCtrl = controllers[0];
	
	          // TODO(c0bra): validate that shown and active are functions if they're defined. An exception is already thrown above this though
	          // if (typeof($scope.shown) !== 'undefined' && $scope.shown && typeof($scope.shown) !== 'function') {
	          //   throw new TypeError("$scope.shown is defined but not a function");
	          // }
	          if (typeof($scope.shown) === 'undefined' || $scope.shown === null) {
	            $scope.shown = function() { return true; };
	          }
	
	          $scope.itemShown = function () {
	            var context = {};
	            if ($scope.context) {
	              context.context = $scope.context;
	            }
	
	            if (typeof(uiGridCtrl) !== 'undefined' && uiGridCtrl) {
	              context.grid = uiGridCtrl.grid;
	            }
	
	            return $scope.shown.call(context);
	          };
	
	          $scope.itemAction = function($event, title) {
	            $event.stopPropagation();
	
	            if (typeof($scope.action) === 'function') {
	              var context = {};
	
	              if ($scope.context) {
	                context.context = $scope.context;
	              }
	
	              // Add the grid to the function call context if the uiGrid controller is present
	              if (typeof(uiGridCtrl) !== 'undefined' && uiGridCtrl) {
	                context.grid = uiGridCtrl.grid;
	              }
	
	              $scope.action.call(context, $event, title);
	
	              if ( !$scope.leaveOpen ) {
	                $scope.$emit('hide-menu');
	              } else {
	                // Maintain focus on the selected item
	                var correctParent = $event.target.parentElement;
	
	                // nodeName of 'I' means target is i element, need the next parent
	                if (angular.element($event.target)[0].nodeName === 'I') {
	                  correctParent = correctParent.parentElement;
	                }
	
	                gridUtil.focus.bySelector(correctParent, 'button[type=button]', true);
	              }
	            }
	          };
	
	          $scope.label = function() {
	            var toBeDisplayed = $scope.name;
	
	            if (typeof($scope.name) === 'function') {
	              toBeDisplayed = $scope.name.call();
	            }
	
	            return toBeDisplayed;
	          };
	
	          $scope.i18n = i18nService.get();
	        }
	      };
	    }
	  };
	}]);
	
	})();
	
	(function() {
	  'use strict';
	  /**
	   * @ngdoc overview
	   * @name ui.grid.directive:uiGridOneBind
	   * @summary A group of directives that provide a one time bind to a dom element.
	   * @description A group of directives that provide a one time bind to a dom element.
	   * As one time bindings are not supported in Angular 1.2.* this directive provdes this capability.
	   * This is done to reduce the number of watchers on the dom.
	   * <br/>
	   * <h2>Short Example ({@link ui.grid.directive:uiGridOneBindSrc ui-grid-one-bind-src})</h2>
	   * <pre>
	        <div ng-init="imageName = 'myImageDir.jpg'">
	          <img ui-grid-one-bind-src="imageName"></img>
	        </div>
	     </pre>
	   * Will become:
	   * <pre>
	       <div ng-init="imageName = 'myImageDir.jpg'">
	         <img ui-grid-one-bind-src="imageName" src="myImageDir.jpg"></img>
	       </div>
	     </pre>
	     </br>
	     <h2>Short Example ({@link ui.grid.directive:uiGridOneBindText ui-grid-one-bind-text})</h2>
	   * <pre>
	        <div ng-init="text='Add this text'" ui-grid-one-bind-text="text"></div>
	     </pre>
	   * Will become:
	   * <pre>
	   <div ng-init="text='Add this text'" ui-grid-one-bind-text="text">Add this text</div>
	     </pre>
	     </br>
	   * <b>Note:</b> This behavior is slightly different for the {@link ui.grid.directive:uiGridOneBindIdGrid uiGridOneBindIdGrid}
	   * and {@link ui.grid.directive:uiGridOneBindAriaLabelledbyGrid uiGridOneBindAriaLabelledbyGrid} directives.
	   *
	   */
	  // https://github.com/joshkurz/Black-Belt-AngularJS-Directives/blob/master/directives/Optimization/oneBind.js
	  var oneBinders = angular.module('ui.grid');
	  angular.forEach([
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindSrc
	       * @memberof ui.grid.directive:uiGridOneBind
	       * @element img
	       * @restrict A
	       * @param {String} uiGridOneBindSrc The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the src dom tag.
	       *
	       */
	      {tag: 'Src', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindText
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindText The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the text dom tag.
	       */
	      {tag: 'Text', method: 'text'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindHref
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindHref The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the href dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Href', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindClass
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindClass The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @param {Object} uiGridOneBindClass The object that you want to bind. At least one of the values in the object must be something other than null or undefined for the watcher to be removed.
	       *                                    this is to prevent the watcher from being removed before the scope is initialized.
	       * @param {Array} uiGridOneBindClass An array of classes to bind to this element.
	       * @description One time binding for the class dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Class', method: 'addClass'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindHtml
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindHtml The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the html method on a dom element. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Html', method: 'html'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAlt
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindAlt The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the alt dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Alt', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindStyle
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindStyle The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the style dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Style', method: 'css'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindValue
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindValue The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the value dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Value', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindId
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindId The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the value dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Id', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindIdGrid
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindIdGrid The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the id dom tag.
	       * <h1>Important Note!</h1>
	       * If the id tag passed as a parameter does <b>not</b> contain the grid id as a substring
	       * then the directive will search the scope and the parent controller (if it is a uiGridController) for the grid.id value.
	       * If this value is found then it is appended to the begining of the id tag. If the grid is not found then the directive throws an error.
	       * This is done in order to ensure uniqueness of id tags across the grid.
	       * This is to prevent two grids in the same document having duplicate id tags.
	       */
	      {tag: 'Id', directiveName: 'IdGrid', method: 'attr', appendGridId: true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindTitle
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindTitle The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the title dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Title', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaLabel
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindAriaLabel The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-label dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       *<br/>
	       * <pre>
	            <div ng-init="text='Add this text'" ui-grid-one-bind-aria-label="text"></div>
	         </pre>
	       * Will become:
	       * <pre>
	            <div ng-init="text='Add this text'" ui-grid-one-bind-aria-label="text" aria-label="Add this text"></div>
	         </pre>
	       */
	      {tag: 'Label', method: 'attr', aria: true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaLabelledby
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindAriaLabelledby The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-labelledby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       *<br/>
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby="anId"></div>
	         </pre>
	       * Will become:
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby="anId" aria-labelledby="gridID32"></div>
	         </pre>
	       */
	      {tag: 'Labelledby', method: 'attr', aria: true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaLabelledbyGrid
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindAriaLabelledbyGrid The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-labelledby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       * Works somewhat like {@link ui.grid.directive:uiGridOneBindIdGrid} however this one supports a list of ids (seperated by a space) and will dynamically add the
	       * grid id to each one.
	       *<br/>
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby-grid="anId"></div>
	         </pre>
	       * Will become ([grid.id] will be replaced by the actual grid id):
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby-grid="anId" aria-labelledby-Grid="[grid.id]-gridID32"></div>
	         </pre>
	       */
	      {tag: 'Labelledby', directiveName: 'LabelledbyGrid', appendGridId: true, method: 'attr', aria: true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaDescribedby
	       * @element ANY
	       * @restrict A
	       * @param {String} uiGridOneBindAriaDescribedby The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-describedby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       *<br/>
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby="anId"></div>
	         </pre>
	       * Will become:
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby="anId" aria-describedby="gridID32"></div>
	         </pre>
	       */
	      {tag: 'Describedby', method: 'attr', aria: true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaDescribedbyGrid
	       * @element ANY
	       * @restrict A
	       * @param {String} uiGridOneBindAriaDescribedbyGrid The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-labelledby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       * Works somewhat like {@link ui.grid.directive:uiGridOneBindIdGrid} however this one supports a list of ids (seperated by a space) and will dynamically add the
	       * grid id to each one.
	       *<br/>
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby-grid="anId"></div>
	         </pre>
	       * Will become ([grid.id] will be replaced by the actual grid id):
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby-grid="anId" aria-describedby="[grid.id]-gridID32"></div>
	         </pre>
	       */
	      {tag: 'Describedby', directiveName: 'DescribedbyGrid', appendGridId: true, method: 'attr', aria: true}],
	    function(v) {
	
	      var baseDirectiveName = 'uiGridOneBind';
	      // If it is an aria tag then append the aria label seperately
	      // This is done because the aria tags are formatted aria-* and the directive name can't have a '-' character in it.
	      // If the diretiveName has to be overridden then it does so here. This is because the tag being modified and the directive sometimes don't
	      // match up.
	      var directiveName = (v.aria ? baseDirectiveName + 'Aria' : baseDirectiveName) + (v.directiveName ? v.directiveName : v.tag);
	      oneBinders.directive(directiveName, ['gridUtil', function(gridUtil) {
	        return {
	          restrict: 'A',
	          require: ['?uiGrid','?^uiGrid'],
	          link: function(scope, iElement, iAttrs, controllers) {
	            /* Appends the grid id to the beginning of the value. */
	            var appendGridId = function(val) {
	              var grid; // Get an instance of the grid if its available
	
	              // If its available in the scope then we don't need to try to find it elsewhere
	              if (scope.grid) {
	                grid = scope.grid;
	              }
	
	              // Another possible location to try to find the grid
	              else if (scope.col && scope.col.grid) {
	                grid = scope.col.grid;
	              }
	
	              // Last ditch effort: Search through the provided controllers.
	              else if (!controllers.some( // Go through the controllers till one has the element we need
	                function(controller) {
	                  if (controller && controller.grid) {
	                    grid = controller.grid;
	                    return true; // We've found the grid
	                  }
	              })) {
	                // We tried our best to find it for you
	                gridUtil.logError("["+directiveName+"] A valid grid could not be found to bind id. Are you using this directive " +
	                                 "within the correct scope? Trying to generate id: [gridID]-" + val);
	                throw new Error("No valid grid could be found");
	              }
	
	              if (grid) {
	                var idRegex = new RegExp(grid.id.toString());
	
	                // If the grid id hasn't been appended already in the template declaration
	                if (!idRegex.test(val)) {
	                  val = grid.id.toString() + '-' + val;
	                }
	              }
	              return val;
	            };
	
	            // The watch returns a function to remove itself.
	            var rmWatcher = scope.$watch(iAttrs[directiveName], function(newV) {
	              if (newV) {
	                // If we are trying to add an id element then we also apply the grid id if it isn't already there
	                if (v.appendGridId) {
	                  var newIdString = null;
	
	                  // Append the id to all of the new ids.
	                  angular.forEach( newV.split(' '), function(s) {
	                    newIdString = (newIdString ? (newIdString + ' ') : '') +  appendGridId(s);
	                  });
	                  newV = newIdString;
	                }
	
	                // Append this newValue to the dom element.
	                switch (v.method) {
	                  case 'attr': // The attr method takes two paraams the tag and the value
	                    if (v.aria) {
	                      // If it is an aria element then append the aria prefix
	                      iElement[v.method]('aria-' + v.tag.toLowerCase(),newV);
	                    } else {
	                      iElement[v.method](v.tag.toLowerCase(),newV);
	                    }
	                    break;
	                  case 'addClass':
	                    // Pulled from https://github.com/Pasvaz/bindonce/blob/master/bindonce.js
	                    if (angular.isObject(newV) && !angular.isArray(newV)) {
	                      var results = [],
	                        nonNullFound = false; // We don't want to remove the binding unless the key is actually defined
	
	                      angular.forEach(newV, function (value, index) {
	                        if (value !== null && typeof(value) !== "undefined") {
	                          nonNullFound = true; // A non null value for a key was found so the object must have been initialized
	                          if (value) {results.push(index);}
	                        }
	                      });
	                      // A non null value for a key wasn't found so assume that the scope values haven't been fully initialized
	                      if (!nonNullFound) {
	                        return; // If not initialized then the watcher should not be removed yet.
	                      }
	                      newV = results;
	                    }
	
	                    if (newV) {
	                      iElement.addClass(angular.isArray(newV) ? newV.join(' ') : newV);
	                    } else {
	                      return;
	                    }
	                    break;
	                  default:
	                    iElement[v.method](newV);
	                    break;
	                }
	
	                // Removes the watcher on itself after the bind
	                rmWatcher();
	              }
	            // True ensures that equality is determined using angular.equals instead of ===
	            }, true); // End rm watchers
	          } // End compile function
	        }; // End directive return
	      } // End directive function
	    ]); // End directive
	  }); // End angular foreach
	})();
	
	(function() {
		'use strict';
	
		var module = angular.module('ui.grid');
	
		module.directive('uiGridRenderContainer', ['$timeout', '$document', 'uiGridConstants', 'gridUtil', 'ScrollEvent',
			function($timeout, $document, uiGridConstants, gridUtil, ScrollEvent) {
				return {
					replace: true,
					transclude: true,
					templateUrl: 'ui-grid/uiGridRenderContainer',
					require: ['^uiGrid', 'uiGridRenderContainer'],
					scope: {
						containerId: '=',
						rowContainerName: '=',
						colContainerName: '=',
						bindScrollHorizontal: '=',
						bindScrollVertical: '=',
						enableVerticalScrollbar: '=',
						enableHorizontalScrollbar: '='
					},
					controller: 'uiGridRenderContainer as RenderContainer',
					compile: function() {
						return {
							pre: function prelink($scope, $elm, $attrs, controllers) {
								var rowContainer, colContainer,
									uiGridCtrl = controllers[0],
									containerCtrl = controllers[1],
									grid = $scope.grid = uiGridCtrl.grid;
	
								// Verify that the render container for this element exists
								if (!$scope.rowContainerName) {
									throw new Error('No row render container name specified');
								}
								if (!$scope.colContainerName) {
									throw new Error('No column render container name specified');
								}
	
								if (!grid.renderContainers[$scope.rowContainerName]) {
									throw new Error('Row render container "' + $scope.rowContainerName + '" is not registered.');
								}
								if (!grid.renderContainers[$scope.colContainerName]) {
									throw new Error('Column render container "' + $scope.colContainerName + '" is not registered.');
								}
	
								rowContainer = $scope.rowContainer = grid.renderContainers[$scope.rowContainerName];
								colContainer = $scope.colContainer = grid.renderContainers[$scope.colContainerName];
	
								containerCtrl.containerId = $scope.containerId;
								containerCtrl.rowContainer = rowContainer;
								containerCtrl.colContainer = colContainer;
							},
							post: function postlink($scope, $elm, $attrs, controllers) {
								var uiGridCtrl = controllers[0],
									containerCtrl = controllers[1],
									grid = uiGridCtrl.grid,
									rowContainer = containerCtrl.rowContainer,
									colContainer = containerCtrl.colContainer,
									scrollTop = null,
									scrollLeft = null,
									renderContainer = grid.renderContainers[$scope.containerId];
	
								// Put the container name on this element as a class
								$elm.addClass('ui-grid-render-container-' + $scope.containerId);
	
								// Scroll the render container viewport when the mousewheel is used
								gridUtil.on.mousewheel($elm, function(event) {
									var scrollEvent = new ScrollEvent(grid, rowContainer, colContainer, ScrollEvent.Sources.RenderContainerMouseWheel);
	
									if (event.deltaY !== 0) {
										var scrollYAmount = event.deltaY * -1 * event.deltaFactor;
	
										scrollTop = containerCtrl.viewport[0].scrollTop;
	
										// Get the scroll percentage
										scrollEvent.verticalScrollLength = rowContainer.getVerticalScrollLength();
										var scrollYPercentage = (scrollTop + scrollYAmount) / scrollEvent.verticalScrollLength;
	
										// If we should be scrolled 100%, make sure the scrollTop matches the maximum scroll length
										//   Viewports that have "overflow: hidden" don't let the mousewheel scroll all the way to the bottom without this check
										if (scrollYPercentage >= 1 && scrollTop < scrollEvent.verticalScrollLength) {
											containerCtrl.viewport[0].scrollTop = scrollEvent.verticalScrollLength;
										}
	
										// Keep scrollPercentage within the range 0-1.
										if (scrollYPercentage < 0) { scrollYPercentage = 0; }
										else if (scrollYPercentage > 1) { scrollYPercentage = 1; }
	
										scrollEvent.y = {percentage: scrollYPercentage, pixels: scrollYAmount};
									}
									if (event.deltaX !== 0) {
										var scrollXAmount = event.deltaX * event.deltaFactor;
	
										// Get the scroll percentage
										scrollLeft = gridUtil.normalizeScrollLeft(containerCtrl.viewport, grid);
										scrollEvent.horizontalScrollLength = (colContainer.getCanvasWidth() - colContainer.getViewportWidth());
										var scrollXPercentage = (scrollLeft + scrollXAmount) / scrollEvent.horizontalScrollLength;
	
										// Keep scrollPercentage within the range 0-1.
										if (scrollXPercentage < 0) { scrollXPercentage = 0; }
										else if (scrollXPercentage > 1) { scrollXPercentage = 1; }
	
										scrollEvent.x = {percentage: scrollXPercentage, pixels: scrollXAmount};
									}
	
									// Let the parent container scroll if the grid is already at the top/bottom
									if (!((event.deltaY !== 0 && (scrollEvent.atTop(scrollTop) || scrollEvent.atBottom(scrollTop))) ||
										(event.deltaX !== 0 && (scrollEvent.atLeft(scrollLeft) || scrollEvent.atRight(scrollLeft))))) {
										event.preventDefault();
										event.stopPropagation();
										scrollEvent.fireThrottledScrollingEvent('', scrollEvent);
									}
								});
	
								$elm.bind('$destroy', function() {
									$elm.unbind('keydown');
	
									['touchstart', 'touchmove', 'touchend', 'keydown', 'wheel', 'mousewheel',
										'DomMouseScroll', 'MozMousePixelScroll'].forEach(function(eventName) {
										$elm.unbind(eventName);
									});
								});
	
								// TODO(c0bra): Handle resizing the inner canvas based on the number of elements
								function update() {
									var ret = '';
	
									var canvasWidth = colContainer.canvasWidth;
									var viewportWidth = colContainer.getViewportWidth();
	
									var canvasHeight = rowContainer.getCanvasHeight();
	
									var viewportHeight = rowContainer.getViewportHeight();
									// shorten the height to make room for a scrollbar placeholder
									if (colContainer.needsHScrollbarPlaceholder()) {
										viewportHeight -= grid.scrollbarHeight;
									}
	
									var headerViewportWidth,
										footerViewportWidth;
									headerViewportWidth = footerViewportWidth = colContainer.getHeaderViewportWidth();
	
									// Set canvas dimensions
									ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId
										+ ' .ui-grid-canvas { width: ' + canvasWidth + 'px; height: ' + canvasHeight + 'px; }';
	
									ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId
										+ ' .ui-grid-header-canvas { width: ' + (canvasWidth + grid.scrollbarWidth) + 'px; }';
	
									if (renderContainer.explicitHeaderCanvasHeight) {
										// get height from body container
										var reHCHeight = document.querySelector(
											'.grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-body .ui-grid-header-canvas');
	
										if (reHCHeight) {
											renderContainer.explicitHeaderCanvasHeight = reHCHeight.offsetHeight;
										}
	
										ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId
											+ ' .ui-grid-header-canvas { height: ' + renderContainer.explicitHeaderCanvasHeight + 'px; }';
									}
									else {
										ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId
											+ ' .ui-grid-header-canvas { height: inherit; }';
									}
	
									ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId
										+ ' .ui-grid-viewport { width: ' + viewportWidth + 'px; height: ' + viewportHeight + 'px; }';
									ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId
										+ ' .ui-grid-header-viewport { width: ' + headerViewportWidth + 'px; }';
	
									ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId
										+ ' .ui-grid-footer-canvas { width: ' + (canvasWidth + grid.scrollbarWidth) + 'px; }';
									ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId
										+ ' .ui-grid-footer-viewport { width: ' + footerViewportWidth + 'px; }';
	
									return ret;
								}
	
								uiGridCtrl.grid.registerStyleComputation({
									priority: 6,
									func: update
								});
							}
						};
					}
				};
			}]);
	
		module.controller('uiGridRenderContainer', ['$scope', 'gridUtil', function($scope, gridUtil) {
		}]);
	})();
	
	(function() {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridRow', function() {
	    return {
	      replace: true,
	      require: ['^uiGrid', '^uiGridRenderContainer'],
	      scope: {
	         row: '=uiGridRow',
	         // rowRenderIndex is added to scope to give the true visual index of the row to any directives that need it
	         rowRenderIndex: '='
	      },
	      compile: function() {
	        return {
	          pre: function($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            $scope.grid = uiGridCtrl.grid;
	            $scope.colContainer = containerCtrl.colContainer;
	
	            // Function for attaching the template to this scope
	            var clonedElement, cloneScope;
	            function compileTemplate() {
	              $scope.row.getRowTemplateFn.then(function (compiledElementFn) {
	                // var compiledElementFn = $scope.row.compiledElementFn;
	
	                // Create a new scope for the contents of this row, so we can destroy it later if need be
	                var newScope = $scope.$new();
	
	                compiledElementFn(newScope, function (newElm, scope) {
	                  // If we already have a cloned element, we need to remove it and destroy its scope
	                  if (clonedElement) {
	                    clonedElement.remove();
	                    cloneScope.$destroy();
	                  }
	
	                  // Empty the row and append the new element
	                  $elm.empty().append(newElm);
	
	                  // Save the new cloned element and scope
	                  clonedElement = newElm;
	                  cloneScope = newScope;
	                });
	              }).catch(angular.noop);
	            }
	
	            // Initially attach the compiled template to this scope
	            compileTemplate();
	
	            // If the row's compiled element function changes, we need to replace this element's contents with the new compiled template
	            $scope.$watch('row.getRowTemplateFn', function (newFunc, oldFunc) {
	              if (newFunc !== oldFunc) {
	                compileTemplate();
	              }
	            });
	          },
	          post: function($scope, $elm) {
	            $scope.row.element = $elm;
	          }
	        };
	      }
	    };
	  });
	})();
	
	(function() {
	// 'use strict';
	
	  /**
	   * @ngdoc directive
	   * @name ui.grid.directive:uiGridStyle
	   * @element style
	   * @restrict A
	   *
	   * @description
	   * Allows us to interpolate expressions in `<style>` elements. Angular doesn't do this by default as it can/will/might? break in IE8.
	   *
	   * @example
	   <doc:example module="app">
	   <doc:source>
	   <script>
	   var app = angular.module('app', ['ui.grid']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	          $scope.myStyle = '.blah { border: 1px solid }';
	        }]);
	   </script>
	
	   <div ng-controller="MainCtrl">
	   <style ui-grid-style>{{ myStyle }}</style>
	   <span class="blah">I am in a box.</span>
	   </div>
	   </doc:source>
	   <doc:scenario>
	      xit('should apply the right class to the element', function () {
	        element(by.css('.blah')).getCssValue('border-top-width')
	          .then(function(c) {
	            expect(c).toContain('1px');
	          });
	      });
	   </doc:scenario>
	   </doc:example>
	   */
	
	
	  angular.module('ui.grid').directive('uiGridStyle', ['gridUtil', '$interpolate', function(gridUtil, $interpolate) {
	    return {
	      link: function($scope, $elm) {
	        var interpolateFn = $interpolate($elm.text(), true);
	
	        if (interpolateFn) {
	          $scope.$watch(interpolateFn, function(value) {
	            for (var i = 0; i < $elm.length; i++) {
	              $elm[i].textContent = value;
	            }
	          });
	        }
	      }
	    };
	  }]);
	})();
	
	(function() {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridViewport', ['gridUtil', 'ScrollEvent',
	    function(gridUtil, ScrollEvent) {
	      return {
	        replace: true,
	        scope: {},
	        controllerAs: 'Viewport',
	        templateUrl: 'ui-grid/uiGridViewport',
	        require: ['^uiGrid', '^uiGridRenderContainer'],
	        link: function($scope, $elm, $attrs, controllers) {
	          // gridUtil.logDebug('viewport post-link');
	
	          var uiGridCtrl = controllers[0];
	          var containerCtrl = controllers[1];
	
	          $scope.containerCtrl = containerCtrl;
	
	          var rowContainer = containerCtrl.rowContainer;
	          var colContainer = containerCtrl.colContainer;
	
	          var grid = uiGridCtrl.grid;
	
	          $scope.grid = uiGridCtrl.grid;
	
	          // Put the containers in scope so we can get rows and columns from them
	          $scope.rowContainer = containerCtrl.rowContainer;
	          $scope.colContainer = containerCtrl.colContainer;
	
	          // Register this viewport with its container
	          containerCtrl.viewport = $elm;
	
	          /**
	           * @ngdoc function
	           * @name customScroller
	           * @methodOf ui.grid.class:GridOptions
	           * @description (optional) uiGridViewport.on('scroll', scrollHandler) by default.
	           * A function that allows you to provide your own scroller function. It is particularly helpful if you want to use third party scrollers
	           * as this allows you to do that.
	           *
	           * <div class="alert alert-info" role="alert"> <strong>NOTE:</strong> It is important to remember to always pass in an event object to
	           * the scrollHandler as the grid scrolling behavior will break without it.</div>
	           * <h5>Example</h5>
	           * <pre>
	           *   $scope.gridOptions = {
	           *       customScroller: function myScrolling(uiGridViewport, scrollHandler) {
	           *           uiGridViewport.on('scroll', function myScrollingOverride(event) {
	           *               // Do something here
	           *
	           *               scrollHandler(event);
	           *           });
	           *       }
	           *   };
	           * </pre>
	           * @param {object} uiGridViewport Element being scrolled. (this gets passed in by the grid).
	           * @param {function} scrollHandler Function that needs to be called when scrolling happens. (this gets passed in by the grid).
	           */
	          if (grid && grid.options && grid.options.customScroller) {
	            grid.options.customScroller($elm, scrollHandler);
	          } else {
	            $elm.on('scroll', scrollHandler);
	          }
	
	          var ignoreScroll = false;
	
	          function scrollHandler() {
	            var newScrollTop = $elm[0].scrollTop;
	            var newScrollLeft = gridUtil.normalizeScrollLeft($elm, grid);
	
	            var vertScrollPercentage = rowContainer.scrollVertical(newScrollTop);
	            var horizScrollPercentage = colContainer.scrollHorizontal(newScrollLeft);
	
	            var scrollEvent = new ScrollEvent(grid, rowContainer, colContainer, ScrollEvent.Sources.ViewPortScroll);
	            scrollEvent.newScrollLeft = newScrollLeft;
	            scrollEvent.newScrollTop = newScrollTop;
	            if ( horizScrollPercentage > -1 ) {
	              scrollEvent.x = { percentage: horizScrollPercentage };
	            }
	
	            if ( vertScrollPercentage > -1 ) {
	              scrollEvent.y = { percentage: vertScrollPercentage };
	            }
	
	            grid.scrollContainers($scope.$parent.containerId, scrollEvent);
	          }
	
	          if ($scope.$parent.bindScrollVertical) {
	            grid.addVerticalScrollSync($scope.$parent.containerId, syncVerticalScroll);
	          }
	
	          if ($scope.$parent.bindScrollHorizontal) {
	            grid.addHorizontalScrollSync($scope.$parent.containerId, syncHorizontalScroll);
	            grid.addHorizontalScrollSync($scope.$parent.containerId + 'header', syncHorizontalHeader);
	            grid.addHorizontalScrollSync($scope.$parent.containerId + 'footer', syncHorizontalFooter);
	          }
	
	          function syncVerticalScroll(scrollEvent) {
	            containerCtrl.prevScrollArgs = scrollEvent;
	            $elm[0].scrollTop = scrollEvent.getNewScrollTop(rowContainer,containerCtrl.viewport);
	          }
	
	          function syncHorizontalScroll(scrollEvent) {
	            containerCtrl.prevScrollArgs = scrollEvent;
	            var newScrollLeft = scrollEvent.getNewScrollLeft(colContainer, containerCtrl.viewport);
	
	            $elm[0].scrollLeft =  gridUtil.denormalizeScrollLeft(containerCtrl.viewport,newScrollLeft, grid);
	          }
	
	          function syncHorizontalHeader(scrollEvent) {
	            var newScrollLeft = scrollEvent.getNewScrollLeft(colContainer, containerCtrl.viewport);
	
	            if (containerCtrl.headerViewport) {
	              containerCtrl.headerViewport.scrollLeft = gridUtil.denormalizeScrollLeft(containerCtrl.viewport,newScrollLeft, grid);
	            }
	          }
	
	          function syncHorizontalFooter(scrollEvent) {
	            var newScrollLeft = scrollEvent.getNewScrollLeft(colContainer, containerCtrl.viewport);
	
	            if (containerCtrl.footerViewport) {
	              containerCtrl.footerViewport.scrollLeft =  gridUtil.denormalizeScrollLeft(containerCtrl.viewport,newScrollLeft, grid);
	            }
	          }
	
	          $scope.$on('$destroy', function unbindEvents() {
	            $elm.off();
	          });
	        },
	        controller: ['$scope', function ($scope) {
	          this.rowStyle = function () {
	            var rowContainer = $scope.rowContainer;
	            var colContainer = $scope.colContainer;
	
	            var styles = {};
	
	            if (rowContainer.currentTopRow !== 0) {
	              // top offset based on hidden rows count
	              var translateY = "translateY("+ (rowContainer.currentTopRow * rowContainer.grid.options.rowHeight)  +"px)";
	
	              styles['transform'] = translateY;
	              styles['-webkit-transform'] = translateY;
	              styles['-ms-transform'] = translateY;
	            }
	
	            if (colContainer.currentFirstColumn !== 0) {
	              if (colContainer.grid.isRTL()) {
	                styles['margin-right'] = colContainer.columnOffset + 'px';
	              }
	              else {
	                styles['margin-left'] = colContainer.columnOffset + 'px';
	              }
	            }
	
	            return styles;
	          };
	        }]
	      };
	    }
	  ]);
	
	})();
	
	(function() {
		angular.module('ui.grid')
			.directive('uiGridVisible', function uiGridVisibleAction() {
				return function($scope, $elm, $attr) {
					$scope.$watch($attr.uiGridVisible, function(visible) {
						$elm[visible ? 'removeClass' : 'addClass']('ui-grid-invisible');
					});
				};
			});
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.grid').controller('uiGridController', ['$scope', '$element', '$attrs', 'gridUtil', '$q', 'uiGridConstants',
	                    'gridClassFactory', '$parse', '$compile',
	    function ($scope, $elm, $attrs, gridUtil, $q, uiGridConstants,
	              gridClassFactory, $parse, $compile) {
	      // gridUtil.logDebug('ui-grid controller');
	      var self = this;
	      var deregFunctions = [];
	
	      self.grid = gridClassFactory.createGrid($scope.uiGrid);
	
	      // assign $scope.$parent if appScope not already assigned
	      self.grid.appScope = self.grid.appScope || $scope.$parent;
	
	      $elm.addClass('grid' + self.grid.id);
	      self.grid.rtl = gridUtil.getStyles($elm[0])['direction'] === 'rtl';
	
	
	      // angular.extend(self.grid.options, );
	
	      // all properties of grid are available on scope
	      $scope.grid = self.grid;
	
	      if ($attrs.uiGridColumns) {
	        deregFunctions.push( $attrs.$observe('uiGridColumns', function(value) {
	          self.grid.options.columnDefs = angular.isString(value) ? angular.fromJson(value) : value;
	          self.grid.buildColumns()
	            .then(function() {
	              self.grid.preCompileCellTemplates();
	
	              self.grid.refreshCanvas(true);
	            }).catch(angular.noop);
	        }) );
	      }
	
	      // prevents an error from being thrown when the array is not defined yet and fastWatch is on
	      function getSize(array) {
	        return array ? array.length : 0;
	      }
	
	      // if fastWatch is set we watch only the length and the reference, not every individual object
	      if (self.grid.options.fastWatch) {
	        self.uiGrid = $scope.uiGrid;
	        if (angular.isString($scope.uiGrid.data)) {
	          deregFunctions.push( $scope.$parent.$watch($scope.uiGrid.data, dataWatchFunction) );
	          deregFunctions.push( $scope.$parent.$watch(function() {
	            if ( self.grid.appScope[$scope.uiGrid.data] ) {
	              return self.grid.appScope[$scope.uiGrid.data].length;
	            } else {
	              return undefined;
	            }
	          }, dataWatchFunction) );
	        } else {
	          deregFunctions.push( $scope.$parent.$watch(function() { return $scope.uiGrid.data; }, dataWatchFunction) );
	          deregFunctions.push( $scope.$parent.$watch(function() { return getSize($scope.uiGrid.data); }, function() { dataWatchFunction($scope.uiGrid.data); }) );
	        }
	        deregFunctions.push( $scope.$parent.$watch(function() { return $scope.uiGrid.columnDefs; }, columnDefsWatchFunction) );
	        deregFunctions.push( $scope.$parent.$watch(function() { return getSize($scope.uiGrid.columnDefs); }, function() { columnDefsWatchFunction($scope.uiGrid.columnDefs); }) );
	      } else {
	        if (angular.isString($scope.uiGrid.data)) {
	          deregFunctions.push( $scope.$parent.$watchCollection($scope.uiGrid.data, dataWatchFunction) );
	        } else {
	          deregFunctions.push( $scope.$parent.$watchCollection(function() { return $scope.uiGrid.data; }, dataWatchFunction) );
	        }
	        deregFunctions.push( $scope.$parent.$watchCollection(function() { return $scope.uiGrid.columnDefs; }, columnDefsWatchFunction) );
	      }
	
	
	      function columnDefsWatchFunction(n, o) {
	        if (n && n !== o) {
	          self.grid.options.columnDefs = $scope.uiGrid.columnDefs;
	          self.grid.callDataChangeCallbacks(uiGridConstants.dataChange.COLUMN, {
	            orderByColumnDefs: true,
	            preCompileCellTemplates: true
	          });
	        }
	      }
	
	      var mostRecentData;
	
	      function dataWatchFunction(newData) {
	        // gridUtil.logDebug('dataWatch fired');
	        var promises = [];
	
	        if ( self.grid.options.fastWatch ) {
	          if (angular.isString($scope.uiGrid.data)) {
	            newData = self.grid.appScope.$eval($scope.uiGrid.data);
	          } else {
	            newData = $scope.uiGrid.data;
	          }
	        }
	
	        mostRecentData = newData;
	
	        if (newData) {
	          // columns length is greater than the number of row header columns, which don't count because they're created automatically
	          var hasColumns = self.grid.columns.length > (self.grid.rowHeaderColumns ? self.grid.rowHeaderColumns.length : 0);
	
	          if (
	            // If we have no columns
	            !hasColumns &&
	            // ... and we don't have a ui-grid-columns attribute, which would define columns for us
	            !$attrs.uiGridColumns &&
	            // ... and we have no pre-defined columns
	            self.grid.options.columnDefs.length === 0 &&
	            // ... but we DO have data
	            newData.length > 0
	          ) {
	            // ... then build the column definitions from the data that we have
	            self.grid.buildColumnDefsFromData(newData);
	          }
	
	          // If we haven't built columns before and either have some columns defined or some data defined
	          if (!hasColumns && (self.grid.options.columnDefs.length > 0 || newData.length > 0)) {
	            // Build the column set, then pre-compile the column cell templates
	            promises.push(self.grid.buildColumns()
	              .then(function() {
	                self.grid.preCompileCellTemplates();
	              }).catch(angular.noop));
	          }
	
	          $q.all(promises).then(function() {
	            // use most recent data, rather than the potentially outdated data passed into watcher handler
	            self.grid.modifyRows(mostRecentData)
	              .then(function () {
	                // if (self.viewport) {
	                  self.grid.redrawInPlace(true);
	                // }
	
	                $scope.$evalAsync(function() {
	                  self.grid.refreshCanvas(true);
	                  self.grid.callDataChangeCallbacks(uiGridConstants.dataChange.ROW);
	                });
	              }).catch(angular.noop);
	          }).catch(angular.noop);
	        }
	      }
	
	      var styleWatchDereg = $scope.$watch(function () { return self.grid.styleComputations; }, function() {
	        self.grid.refreshCanvas(true);
	      });
	
	      $scope.$on('$destroy', function() {
	        deregFunctions.forEach( function( deregFn ) { deregFn(); });
	        styleWatchDereg();
	      });
	
	      self.fireEvent = function(eventName, args) {
	        args = args || {};
	
	        // Add the grid to the event arguments if it's not there
	        if (angular.isUndefined(args.grid)) {
	          args.grid = self.grid;
	        }
	
	        $scope.$broadcast(eventName, args);
	      };
	
	      self.innerCompile = function innerCompile(elm) {
	        $compile(elm)($scope);
	      };
	    }]);
	
	/**
	 *  @ngdoc directive
	 *  @name ui.grid.directive:uiGrid
	 *  @element div
	 *  @restrict EA
	 *  @param {Object} uiGrid Options for the grid to use
	 *
	 *  @description Create a very basic grid.
	 *
	 *  @example
	    <example module="app">
	      <file name="app.js">
	        var app = angular.module('app', ['ui.grid']);
	
	        app.controller('MainCtrl', ['$scope', function ($scope) {
	          $scope.data = [
	            { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	          ];
	        }]);
	      </file>
	      <file name="index.html">
	        <div ng-controller="MainCtrl">
	          <div ui-grid="{ data: data }"></div>
	        </div>
	      </file>
	    </example>
	 */
	angular.module('ui.grid').directive('uiGrid', uiGridDirective);
	
	uiGridDirective.$inject = ['$window', 'gridUtil', 'uiGridConstants'];
	function uiGridDirective($window, gridUtil, uiGridConstants) {
	  return {
	    templateUrl: 'ui-grid/ui-grid',
	    scope: {
	      uiGrid: '='
	    },
	    replace: true,
	    transclude: true,
	    controller: 'uiGridController',
	    compile: function () {
	      return {
	        post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          var grid = uiGridCtrl.grid;
	          // Initialize scrollbars (TODO: move to controller??)
	          uiGridCtrl.scrollbars = [];
	          grid.element = $elm;
	
	
	          // See if the grid has a rendered width, if not, wait a bit and try again
	          var sizeCheckInterval = 100; // ms
	          var maxSizeChecks = 20; // 2 seconds total
	          var sizeChecks = 0;
	
	          // Setup (event listeners) the grid
	          setup();
	
	          // And initialize it
	          init();
	
	          // Mark rendering complete so API events can happen
	          grid.renderingComplete();
	
	          // If the grid doesn't have size currently, wait for a bit to see if it gets size
	          checkSize();
	
	          /*-- Methods --*/
	
	          function checkSize() {
	            // If the grid has no width and we haven't checked more than <maxSizeChecks> times, check again in <sizeCheckInterval> milliseconds
	            if ($elm[0].offsetWidth <= 0 && sizeChecks < maxSizeChecks) {
	              setTimeout(checkSize, sizeCheckInterval);
	              sizeChecks++;
	            } else {
	              $scope.$applyAsync(init);
	            }
	          }
	
	          // Setup event listeners and watchers
	          function setup() {
	            var deregisterLeftWatcher, deregisterRightWatcher;
	
	            // Bind to window resize events
	            angular.element($window).on('resize', gridResize);
	
	            // Unbind from window resize events when the grid is destroyed
	            $elm.on('$destroy', function () {
	              angular.element($window).off('resize', gridResize);
	              deregisterLeftWatcher();
	              deregisterRightWatcher();
	            });
	
	            // If we add a left container after render, we need to watch and react
	            deregisterLeftWatcher = $scope.$watch(function () { return grid.hasLeftContainer();}, function (newValue, oldValue) {
	              if (newValue === oldValue) {
	                return;
	              }
	              grid.refreshCanvas(true);
	            });
	
	            // If we add a right container after render, we need to watch and react
	            deregisterRightWatcher = $scope.$watch(function () { return grid.hasRightContainer();}, function (newValue, oldValue) {
	              if (newValue === oldValue) {
	                return;
	              }
	              grid.refreshCanvas(true);
	            });
	          }
	
	          // Initialize the directive
	          function init() {
	            grid.gridWidth = $scope.gridWidth = gridUtil.elementWidth($elm);
	
	            // Default canvasWidth to the grid width, in case we don't get any column definitions to calculate it from
	            grid.canvasWidth = uiGridCtrl.grid.gridWidth;
	
	            grid.gridHeight = $scope.gridHeight = gridUtil.elementHeight($elm);
	
	            // If the grid isn't tall enough to fit a single row, it's kind of useless. Resize it to fit a minimum number of rows
	            if (grid.gridHeight - grid.scrollbarHeight <= grid.options.rowHeight && grid.options.enableMinHeightCheck) {
	              autoAdjustHeight();
	            }
	
	            // Run initial canvas refresh
	            grid.refreshCanvas(true);
	          }
	
	          // Set the grid's height ourselves in the case that its height would be unusably small
	          function autoAdjustHeight() {
	            // Figure out the new height
	            var contentHeight = grid.options.minRowsToShow * grid.options.rowHeight;
	            var headerHeight = grid.options.showHeader ? grid.options.headerRowHeight : 0;
	            var footerHeight = grid.calcFooterHeight();
	
	            var scrollbarHeight = 0;
	            if (grid.options.enableHorizontalScrollbar === uiGridConstants.scrollbars.ALWAYS) {
	              scrollbarHeight = gridUtil.getScrollbarWidth();
	            }
	
	            var maxNumberOfFilters = 0;
	            // Calculates the maximum number of filters in the columns
	            angular.forEach(grid.options.columnDefs, function(col) {
	              if (col.hasOwnProperty('filter')) {
	                if (maxNumberOfFilters < 1) {
	                    maxNumberOfFilters = 1;
	                }
	              }
	              else if (col.hasOwnProperty('filters')) {
	                if (maxNumberOfFilters < col.filters.length) {
	                    maxNumberOfFilters = col.filters.length;
	                }
	              }
	            });
	
	            if (grid.options.enableFiltering  && !maxNumberOfFilters) {
	              var allColumnsHaveFilteringTurnedOff = grid.options.columnDefs.length && grid.options.columnDefs.every(function(col) {
	                return col.enableFiltering === false;
	              });
	
	              if (!allColumnsHaveFilteringTurnedOff) {
	                maxNumberOfFilters = 1;
	              }
	            }
	
	            var filterHeight = maxNumberOfFilters * headerHeight;
	
	            var newHeight = headerHeight + contentHeight + footerHeight + scrollbarHeight + filterHeight;
	
	            $elm.css('height', newHeight + 'px');
	
	            grid.gridHeight = $scope.gridHeight = gridUtil.elementHeight($elm);
	          }
	
	          // Resize the grid on window resize events
	          function gridResize() {
	            if (!gridUtil.isVisible($elm)) {
	              return;
	            }
	            grid.gridWidth = $scope.gridWidth = gridUtil.elementWidth($elm);
	            grid.gridHeight = $scope.gridHeight = gridUtil.elementHeight($elm);
	
	            grid.refreshCanvas(true);
	          }
	        }
	      };
	    }
	  };
	}
	})();
	
	(function() {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridPinnedContainer', ['gridUtil', function (gridUtil) {
	    return {
	      restrict: 'EA',
	      replace: true,
	      template: '<div class="ui-grid-pinned-container">'
	              + '<div ui-grid-render-container container-id="side"'
	              + ' row-container-name="\'body\'" col-container-name="side"'
	              + ' bind-scroll-vertical="true"'
	              + ' class="{{ side }} ui-grid-render-container-{{ side }}"></div>'
	              + '</div>',
	      scope: {
	        side: '=uiGridPinnedContainer'
	      },
	      require: '^uiGrid',
	      compile: function compile() {
	        return {
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            // gridUtil.logDebug('ui-grid-pinned-container ' + $scope.side + ' link');
	
	            var grid = uiGridCtrl.grid;
	
	            var myWidth = 0;
	
	            $elm.addClass('ui-grid-pinned-container-' + $scope.side);
	
	            // Monkey-patch the viewport width function
	            if ($scope.side === 'left' || $scope.side === 'right') {
	              grid.renderContainers[$scope.side].getViewportWidth = monkeyPatchedGetViewportWidth;
	            }
	
	            function monkeyPatchedGetViewportWidth() {
	              /*jshint validthis: true */
	              var self = this;
	
	              var viewportWidth = 0;
	              self.visibleColumnCache.forEach(function (column) {
	                viewportWidth += column.drawnWidth;
	              });
	
	              var adjustment = self.getViewportAdjustment();
	
	              viewportWidth = viewportWidth + adjustment.width;
	
	              return viewportWidth;
	            }
	
	            function updateContainerWidth() {
	              if ($scope.side === 'left' || $scope.side === 'right') {
	                var cols = grid.renderContainers[$scope.side].visibleColumnCache;
	                var width = 0;
	                for (var i = 0; i < cols.length; i++) {
	                  var col = cols[i];
	                  width += col.drawnWidth || col.width || 0;
	                }
	
	                return width;
	              }
	            }
	
	            function updateContainerDimensions() {
	              var ret = '';
	
	              // Column containers
	              if ($scope.side === 'left' || $scope.side === 'right') {
	                myWidth = updateContainerWidth();
	
	                // gridUtil.logDebug('myWidth', myWidth);
	
	                // TODO(c0bra): Subtract sum of col widths from grid viewport width and update it
	                $elm.attr('style', null);
	
	             //   var myHeight = grid.renderContainers.body.getViewportHeight(); // + grid.horizontalScrollbarHeight;
	
	                ret += '.grid' + grid.id + ' .ui-grid-pinned-container-' + $scope.side + ', .grid' + grid.id + ' .ui-grid-pinned-container-' + $scope.side + ' .ui-grid-render-container-' + $scope.side + ' .ui-grid-viewport { width: ' + myWidth + 'px; } ';
	              }
	
	              return ret;
	            }
	
	            grid.renderContainers.body.registerViewportAdjuster(function (adjustment) {
	              myWidth = updateContainerWidth();
	
	              // Subtract our own width
	              adjustment.width -= myWidth;
	              adjustment.side = $scope.side;
	
	              return adjustment;
	            });
	
	            // Register style computation to adjust for columns in `side`'s render container
	            grid.registerStyleComputation({
	              priority: 15,
	              func: updateContainerDimensions
	            });
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('en', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filter for column',
	            removeFilter: 'Remove Filter',
	            columnMenuButtonLabel: 'Column Menu',
	            column: 'Column'
	          },
	          priority: 'Priority:',
	          filterLabel: "Filter for column: "
	        },
	        aggregate: {
	          label: 'items'
	        },
	        groupPanel: {
	          description: 'Drag a column header here and drop it to group by that column.'
	        },
	        search: {
	          aria: {
	            selected: 'Row selected',
	            notSelected: 'Row not selected'
	          },
	          placeholder: 'Search...',
	          showingItems: 'Showing Items:',
	          selectedItems: 'Selected Items:',
	          totalItems: 'Total Items:',
	          size: 'Page Size:',
	          first: 'First Page',
	          next: 'Next Page',
	          previous: 'Previous Page',
	          last: 'Last Page'
	        },
	        selection: {
	          aria: {
	            row: 'Row'
	          },
	          selectAll: 'Select All',
	          displayName: 'Row Selection Checkbox'
	        },
	        menu: {
	          text: 'Choose Columns:'
	        },
	        sort: {
	          ascending: 'Sort Ascending',
	          descending: 'Sort Descending',
	          none: 'Sort None',
	          remove: 'Remove Sort'
	        },
	        column: {
	          hide: 'Hide Column'
	        },
	        aggregation: {
	          count: 'total rows: ',
	          sum: 'total: ',
	          avg: 'avg: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Pin Left',
	          pinRight: 'Pin Right',
	          unpin: 'Unpin'
	        },
	        columnMenu: {
	          close: 'Close'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Grid Menu'
	          },
	          columns: 'Columns:',
	          importerTitle: 'Import file',
	          exporterAllAsCsv: 'Export all data as csv',
	          exporterVisibleAsCsv: 'Export visible data as csv',
	          exporterSelectedAsCsv: 'Export selected data as csv',
	          exporterAllAsPdf: 'Export all data as pdf',
	          exporterVisibleAsPdf: 'Export visible data as pdf',
	          exporterSelectedAsPdf: 'Export selected data as pdf',
	          exporterAllAsExcel: 'Export all data as excel',
	          exporterVisibleAsExcel: 'Export visible data as excel',
	          exporterSelectedAsExcel: 'Export selected data as excel',
	          clearAllFilters: 'Clear all filters'
	        },
	        importer: {
	          noHeaders: 'Column names were unable to be derived, does the file have a header?',
	          noObjects: 'Objects were not able to be derived, was there data in the file other than headers?',
	          invalidCsv: 'File was unable to be processed, is it valid CSV?',
	          invalidJson: 'File was unable to be processed, is it valid Json?',
	          jsonNotArray: 'Imported json file must contain an array, aborting.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Page to first',
	            pageBack: 'Page back',
	            pageSelected: 'Selected page',
	            pageForward: 'Page forward',
	            pageToLast: 'Page to last'
	          },
	          sizes: 'items per page',
	          totalItems: 'items',
	          through: 'through',
	          of: 'of'
	        },
	        grouping: {
	          group: 'Group',
	          ungroup: 'Ungroup',
	          aggregate_count: 'Agg: Count',
	          aggregate_sum: 'Agg: Sum',
	          aggregate_max: 'Agg: Max',
	          aggregate_min: 'Agg: Min',
	          aggregate_avg: 'Agg: Avg',
	          aggregate_remove: 'Agg: Remove'
	        },
	        validate: {
	          error: 'Error:',
	          minLength: 'Value should be at least THRESHOLD characters long.',
	          maxLength: 'Value should be at most THRESHOLD characters long.',
	          required: 'A value is needed.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
	
	angular.module('ui.grid')
	.factory('Grid', ['$q', '$compile', '$parse', 'gridUtil', 'uiGridConstants', 'GridOptions', 'GridColumn', 'GridRow', 'GridApi', 'rowSorter', 'rowSearcher', 'GridRenderContainer', '$timeout','ScrollEvent',
	    function($q, $compile, $parse, gridUtil, uiGridConstants, GridOptions, GridColumn, GridRow, GridApi, rowSorter, rowSearcher, GridRenderContainer, $timeout, ScrollEvent) {
	
	  /**
	   * @ngdoc object
	   * @name ui.grid.api:PublicApi
	   * @description Public Api for the core grid features
	   *
	   */
	
	  /**
	   * @ngdoc function
	   * @name ui.grid.class:Grid
	   * @description Grid is the main viewModel.  Any properties or methods needed to maintain state are defined in
	   * this prototype.  One instance of Grid is created per Grid directive instance.
	   * @param {object} options Object map of options to pass into the grid. An 'id' property is expected.
	   */
	  var Grid = function Grid(options) {
	    var self = this;
	    // Get the id out of the options, then remove it
	    if (options !== undefined && typeof(options.id) !== 'undefined' && options.id) {
	      if (!/^[_a-zA-Z0-9-]+$/.test(options.id)) {
	        throw new Error("Grid id '" + options.id + '" is invalid. It must follow CSS selector syntax rules.');
	      }
	    }
	    else {
	      throw new Error('No ID provided. An ID must be given when creating a grid.');
	    }
	
	    self.id = options.id;
	    delete options.id;
	
	    // Get default options
	    self.options = GridOptions.initialize( options );
	
	    /**
	     * @ngdoc object
	     * @name appScope
	     * @propertyOf ui.grid.class:Grid
	     * @description reference to the application scope (the parent scope of the ui-grid element).  Assigned in ui-grid controller
	     * <br/>
	     * use gridOptions.appScopeProvider to override the default assignment of $scope.$parent with any reference
	     */
	    self.appScope = self.options.appScopeProvider;
	
	    self.headerHeight = self.options.headerRowHeight;
	
	
	    /**
	     * @ngdoc object
	     * @name footerHeight
	     * @propertyOf ui.grid.class:Grid
	     * @description returns the total footer height gridFooter + columnFooter
	     */
	    self.footerHeight = self.calcFooterHeight();
	
	
	    /**
	     * @ngdoc object
	     * @name columnFooterHeight
	     * @propertyOf ui.grid.class:Grid
	     * @description returns the total column footer height
	     */
	    self.columnFooterHeight = self.calcColumnFooterHeight();
	
	    self.rtl = false;
	    self.gridHeight = 0;
	    self.gridWidth = 0;
	    self.columnBuilders = [];
	    self.rowBuilders = [];
	    self.rowsProcessors = [];
	    self.columnsProcessors = [];
	    self.styleComputations = [];
	    self.viewportAdjusters = [];
	    self.rowHeaderColumns = [];
	    self.dataChangeCallbacks = {};
	    self.verticalScrollSyncCallBackFns = {};
	    self.horizontalScrollSyncCallBackFns = {};
	
	    // self.visibleRowCache = [];
	
	    // Set of 'render' containers for self grid, which can render sets of rows
	    self.renderContainers = {};
	
	    // Create a
	    self.renderContainers.body = new GridRenderContainer('body', self);
	
	    self.cellValueGetterCache = {};
	
	    // Cached function to use with custom row templates
	    self.getRowTemplateFn = null;
	
	
	    // representation of the rows on the grid.
	    // these are wrapped references to the actual data rows (options.data)
	    self.rows = [];
	
	    // represents the columns on the grid
	    self.columns = [];
	
	    /**
	     * @ngdoc boolean
	     * @name isScrollingVertically
	     * @propertyOf ui.grid.class:Grid
	     * @description set to true when Grid is scrolling vertically. Set to false via debounced method
	     */
	    self.isScrollingVertically = false;
	
	    /**
	     * @ngdoc boolean
	     * @name isScrollingHorizontally
	     * @propertyOf ui.grid.class:Grid
	     * @description set to true when Grid is scrolling horizontally. Set to false via debounced method
	     */
	    self.isScrollingHorizontally = false;
	
	    /**
	     * @ngdoc property
	     * @name scrollDirection
	     * @propertyOf ui.grid.class:Grid
	     * @description set one of the {@link ui.grid.service:uiGridConstants#properties_scrollDirection uiGridConstants.scrollDirection}
	     *  values (UP, DOWN, LEFT, RIGHT, NONE), which tells us which direction we are scrolling.
	     * Set to NONE via debounced method
	     */
	    self.scrollDirection = uiGridConstants.scrollDirection.NONE;
	
	    // if true, grid will not respond to any scroll events
	    self.disableScrolling = false;
	
	
	    function vertical (scrollEvent) {
	      self.isScrollingVertically = false;
	      self.api.core.raise.scrollEnd(scrollEvent);
	      self.scrollDirection = uiGridConstants.scrollDirection.NONE;
	    }
	
	    var debouncedVertical = gridUtil.debounce(vertical, self.options.scrollDebounce);
	    var debouncedVerticalMinDelay = gridUtil.debounce(vertical, 0);
	
	    function horizontal (scrollEvent) {
	      self.isScrollingHorizontally = false;
	      self.api.core.raise.scrollEnd(scrollEvent);
	      self.scrollDirection = uiGridConstants.scrollDirection.NONE;
	    }
	
	    var debouncedHorizontal = gridUtil.debounce(horizontal, self.options.scrollDebounce);
	    var debouncedHorizontalMinDelay = gridUtil.debounce(horizontal, 0);
	
	
	    /**
	     * @ngdoc function
	     * @name flagScrollingVertically
	     * @methodOf ui.grid.class:Grid
	     * @description sets isScrollingVertically to true and sets it to false in a debounced function
	     */
	    self.flagScrollingVertically = function(scrollEvent) {
	      if (!self.isScrollingVertically && !self.isScrollingHorizontally) {
	        self.api.core.raise.scrollBegin(scrollEvent);
	      }
	      self.isScrollingVertically = true;
	      if (self.options.scrollDebounce === 0 || !scrollEvent.withDelay) {
	        debouncedVerticalMinDelay(scrollEvent);
	      }
	      else {
	        debouncedVertical(scrollEvent);
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name flagScrollingHorizontally
	     * @methodOf ui.grid.class:Grid
	     * @description sets isScrollingHorizontally to true and sets it to false in a debounced function
	     */
	    self.flagScrollingHorizontally = function(scrollEvent) {
	      if (!self.isScrollingVertically && !self.isScrollingHorizontally) {
	        self.api.core.raise.scrollBegin(scrollEvent);
	      }
	      self.isScrollingHorizontally = true;
	      if (self.options.scrollDebounce === 0 || !scrollEvent.withDelay) {
	        debouncedHorizontalMinDelay(scrollEvent);
	      }
	      else {
	        debouncedHorizontal(scrollEvent);
	      }
	    };
	
	    self.scrollbarHeight = 0;
	    self.scrollbarWidth = 0;
	    if (self.options.enableHorizontalScrollbar !== uiGridConstants.scrollbars.NEVER) {
	      self.scrollbarHeight = gridUtil.getScrollbarWidth();
	    }
	
	    if (self.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER) {
	      self.scrollbarWidth = gridUtil.getScrollbarWidth();
	    }
	
	    self.api = new GridApi(self);
	
	    /**
	     * @ngdoc function
	     * @name refresh
	     * @methodOf ui.grid.api:PublicApi
	     * @description Refresh the rendered grid on screen.
	     * The refresh method re-runs both the columnProcessors and the
	     * rowProcessors, as well as calling refreshCanvas to update all
	     * the grid sizing.  In general you should prefer to use queueGridRefresh
	     * instead, which is basically a debounced version of refresh.
	     *
	     * If you only want to resize the grid, not regenerate all the rows
	     * and columns, you should consider directly calling refreshCanvas instead.
	     *
	     * @param {boolean} [rowsAltered] Optional flag for refreshing when the number of rows has changed
	     */
	    self.api.registerMethod( 'core', 'refresh', this.refresh );
	
	    /**
	     * @ngdoc function
	     * @name queueGridRefresh
	     * @methodOf ui.grid.api:PublicApi
	     * @description Request a refresh of the rendered grid on screen, if multiple
	     * calls to queueGridRefresh are made within a digest cycle only one will execute.
	     * The refresh method re-runs both the columnProcessors and the
	     * rowProcessors, as well as calling refreshCanvas to update all
	     * the grid sizing.  In general you should prefer to use queueGridRefresh
	     * instead, which is basically a debounced version of refresh.
	     *
	     */
	    self.api.registerMethod( 'core', 'queueGridRefresh', this.queueGridRefresh );
	
	    /**
	     * @ngdoc function
	     * @name refreshRows
	     * @methodOf ui.grid.api:PublicApi
	     * @description Runs only the rowProcessors, columns remain as they were.
	     * It then calls redrawInPlace and refreshCanvas, which adjust the grid sizing.
	     * @returns {promise} promise that is resolved when render completes?
	     *
	     */
	    self.api.registerMethod( 'core', 'refreshRows', this.refreshRows );
	
	    /**
	     * @ngdoc function
	     * @name queueRefresh
	     * @methodOf ui.grid.api:PublicApi
	     * @description Requests execution of refreshCanvas, if multiple requests are made
	     * during a digest cycle only one will run.  RefreshCanvas updates the grid sizing.
	     * @returns {promise} promise that is resolved when render completes?
	     *
	     */
	    self.api.registerMethod( 'core', 'queueRefresh', this.queueRefresh );
	
	    /**
	     * @ngdoc function
	     * @name handleWindowResize
	     * @methodOf ui.grid.api:PublicApi
	     * @description Trigger a grid resize, normally this would be picked
	     * up by a watch on window size, but in some circumstances it is necessary
	     * to call this manually
	     * @returns {promise} promise that is resolved when render completes?
	     *
	     */
	    self.api.registerMethod( 'core', 'handleWindowResize', this.handleWindowResize );
	
	
	    /**
	     * @ngdoc function
	     * @name addRowHeaderColumn
	     * @methodOf ui.grid.api:PublicApi
	     * @description adds a row header column to the grid
	     * @param {object} column def
	     * @param {number} order Determines order of header column on grid.  Lower order means header
	     * is positioned to the left of higher order headers
	     *
	     */
	    self.api.registerMethod( 'core', 'addRowHeaderColumn', this.addRowHeaderColumn );
	
	    /**
	     * @ngdoc function
	     * @name scrollToIfNecessary
	     * @methodOf ui.grid.api:PublicApi
	     * @description Scrolls the grid to make a certain row and column combo visible,
	     *   in the case that it is not completely visible on the screen already.
	     * @param {GridRow} gridRow row to make visible
	     * @param {GridColumn} gridCol column to make visible
	     * @returns {promise} a promise that is resolved when scrolling is complete
	     *
	     */
	    self.api.registerMethod( 'core', 'scrollToIfNecessary', function(gridRow, gridCol) { return self.scrollToIfNecessary(gridRow, gridCol);} );
	
	    /**
	     * @ngdoc function
	     * @name scrollTo
	     * @methodOf ui.grid.api:PublicApi
	     * @description Scroll the grid such that the specified
	     * row and column is in view
	     * @param {object} rowEntity gridOptions.data[] array instance to make visible
	     * @param {object} colDef to make visible
	     * @returns {promise} a promise that is resolved after any scrolling is finished
	     */
	    self.api.registerMethod( 'core', 'scrollTo', function (rowEntity, colDef) { return self.scrollTo(rowEntity, colDef);}  );
	
	    /**
	     * @ngdoc function
	     * @name registerRowsProcessor
	     * @methodOf ui.grid.api:PublicApi
	     * @description
	     * Register a "rows processor" function. When the rows are updated,
	     * the grid calls each registered "rows processor", which has a chance
	     * to alter the set of rows (sorting, etc) as long as the count is not
	     * modified.
	     *
	     * @param {function(renderedRowsToProcess, columns )} processorFunction rows processor function, which
	     * is run in the context of the grid (i.e. this for the function will be the grid), and must
	     * return the updated rows list, which is passed to the next processor in the chain
	     * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
	     * for other people to inject rows processors at intermediate priorities.  Lower priority rowsProcessors run earlier.
	     *
	     * At present allRowsVisible is running at 50, sort manipulations running at 60-65, filter is running at 100,
	     * sort is at 200, grouping and treeview at 400-410, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
	     */
	    self.api.registerMethod( 'core', 'registerRowsProcessor', this.registerRowsProcessor  );
	
	    /**
	     * @ngdoc function
	     * @name registerColumnsProcessor
	     * @methodOf ui.grid.api:PublicApi
	     * @description
	     * Register a "columns processor" function. When the columns are updated,
	     * the grid calls each registered "columns processor", which has a chance
	     * to alter the set of columns as long as the count is not
	     * modified.
	     *
	     * @param {function(renderedColumnsToProcess, rows )} processorFunction columns processor function, which
	     * is run in the context of the grid (i.e. this for the function will be the grid), and must
	     * return the updated columns list, which is passed to the next processor in the chain
	     * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
	     * for other people to inject columns processors at intermediate priorities.  Lower priority columnsProcessors run earlier.
	     *
	     * At present allRowsVisible is running at 50, filter is running at 100, sort is at 200, grouping at 400, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
	     */
	    self.api.registerMethod( 'core', 'registerColumnsProcessor', this.registerColumnsProcessor  );
	
	    /**
	     * @ngdoc function
	     * @name sortHandleNulls
	     * @methodOf ui.grid.api:PublicApi
	     * @description A null handling method that can be used when building custom sort
	     * functions
	     * @example
	     * <pre>
	     *   mySortFn = function(a, b) {
	     *   var nulls = $scope.gridApi.core.sortHandleNulls(a, b);
	     *   if ( nulls !== null ) {
	     *     return nulls;
	     *   } else {
	     *     // your code for sorting here
	     *   };
	     * </pre>
	     * @param {object} a sort value a
	     * @param {object} b sort value b
	     * @returns {number} null if there were no nulls/undefineds, otherwise returns
	     * a sort value that should be passed back from the sort function
	     *
	     */
	    self.api.registerMethod( 'core', 'sortHandleNulls', rowSorter.handleNulls );
	
	    /**
	     * @ngdoc function
	     * @name sortChanged
	     * @methodOf  ui.grid.api:PublicApi
	     * @description The sort criteria on one or more columns has
	     * changed.  Provides as parameters the grid and the output of
	     * getColumnSorting, which is an array of gridColumns
	     * that have sorting on them, sorted in priority order.
	     *
	     * @param {$scope} scope The scope of the controller. This is used to deregister this event when the scope is destroyed.
	     * @param {Function} callBack Will be called when the event is emited. The function passes back the grid and an array of
	     * columns with sorts on them, in priority order.
	     *
	     * @example
	     * <pre>
	     *      gridApi.core.on.sortChanged( $scope, function(grid, sortColumns) {
	     *        // do something
	     *      });
	     * </pre>
	     */
	    self.api.registerEvent( 'core', 'sortChanged' );
	
	      /**
	     * @ngdoc function
	     * @name columnVisibilityChanged
	     * @methodOf  ui.grid.api:PublicApi
	     * @description The visibility of a column has changed,
	     * the column itself is passed out as a parameter of the event.
	     *
	     * @param {$scope} scope The scope of the controller. This is used to deregister this event when the scope is destroyed.
	     * @param {Function} callBack Will be called when the event is emited. The function passes back the GridCol that has changed.
	     *
	     * @example
	     * <pre>
	     *      gridApi.core.on.columnVisibilityChanged( $scope, function (column) {
	     *        // do something
	     *      } );
	     * </pre>
	     */
	    self.api.registerEvent( 'core', 'columnVisibilityChanged' );
	
	    /**
	     * @ngdoc method
	     * @name notifyDataChange
	     * @methodOf ui.grid.api:PublicApi
	     * @description Notify the grid that a data or config change has occurred,
	     * where that change isn't something the grid was otherwise noticing.  This
	     * might be particularly relevant where you've changed values within the data
	     * and you'd like cell classes to be re-evaluated, or changed config within
	     * the columnDef and you'd like headerCellClasses to be re-evaluated.
	     * @param {string} type one of the
	     * {@link ui.grid.service:uiGridConstants#properties_dataChange uiGridConstants.dataChange}
	     * values (ALL, ROW, EDIT, COLUMN, OPTIONS), which tells us which refreshes to fire.
	     *
	     * - ALL: listeners fired on any of these events, fires listeners on all events.
	     * - ROW: fired when a row is added or removed.
	     * - EDIT: fired when the data in a cell is edited.
	     * - COLUMN: fired when the column definitions are modified.
	     * - OPTIONS: fired when the grid options are modified.
	     */
	    self.api.registerMethod( 'core', 'notifyDataChange', this.notifyDataChange );
	
	    /**
	     * @ngdoc method
	     * @name clearAllFilters
	     * @methodOf ui.grid.api:PublicApi
	     * @description Clears all filters and optionally refreshes the visible rows.
	     * @param {object} refreshRows Defaults to true.
	     * @param {object} clearConditions Defaults to false.
	     * @param {object} clearFlags Defaults to false.
	     * @returns {promise} If `refreshRows` is true, returns a promise of the rows refreshing.
	     */
	    self.api.registerMethod('core', 'clearAllFilters', this.clearAllFilters);
	
	    self.registerDataChangeCallback( self.columnRefreshCallback, [uiGridConstants.dataChange.COLUMN]);
	    self.registerDataChangeCallback( self.processRowsCallback, [uiGridConstants.dataChange.EDIT]);
	    self.registerDataChangeCallback( self.updateFooterHeightCallback, [uiGridConstants.dataChange.OPTIONS]);
	
	    self.registerStyleComputation({
	      priority: 10,
	      func: self.getFooterStyles
	    });
	  };
	
	   Grid.prototype.calcFooterHeight = function () {
	     if (!this.hasFooter()) {
	       return 0;
	     }
	
	     var height = 0;
	     if (this.options.showGridFooter) {
	       height += this.options.gridFooterHeight;
	     }
	
	     height += this.calcColumnFooterHeight();
	
	     return height;
	   };
	
	   Grid.prototype.calcColumnFooterHeight = function () {
	     var height = 0;
	
	     if (this.options.showColumnFooter) {
	       height += this.options.columnFooterHeight;
	     }
	
	     return height;
	   };
	
	   Grid.prototype.getFooterStyles = function () {
	     var style = '.grid' + this.id + ' .ui-grid-footer-aggregates-row { height: ' + this.options.columnFooterHeight + 'px; }';
	     style += ' .grid' + this.id + ' .ui-grid-footer-info { height: ' + this.options.gridFooterHeight + 'px; }';
	     return style;
	   };
	
	  Grid.prototype.hasFooter = function () {
	   return this.options.showGridFooter || this.options.showColumnFooter;
	  };
	
	  /**
	   * @ngdoc function
	   * @name isRTL
	   * @methodOf ui.grid.class:Grid
	   * @description Returns true if grid is RightToLeft
	   */
	  Grid.prototype.isRTL = function () {
	    return this.rtl;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name registerColumnBuilder
	   * @methodOf ui.grid.class:Grid
	   * @description When the build creates columns from column definitions, the columnbuilders will be called to add
	   * additional properties to the column.
	   * @param {function(colDef, col, gridOptions)} columnBuilder function to be called
	   */
	  Grid.prototype.registerColumnBuilder = function registerColumnBuilder(columnBuilder) {
	    this.columnBuilders.push(columnBuilder);
	  };
	
	  /**
	   * @ngdoc function
	   * @name buildColumnDefsFromData
	   * @methodOf ui.grid.class:Grid
	   * @description Populates columnDefs from the provided data
	   * @param {function(colDef, col, gridOptions)} rowBuilder function to be called
	   */
	  Grid.prototype.buildColumnDefsFromData = function (dataRows) {
	    this.options.columnDefs =  gridUtil.getColumnsFromData(dataRows, this.options.excludeProperties);
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerRowBuilder
	   * @methodOf ui.grid.class:Grid
	   * @description When the build creates rows from gridOptions.data, the rowBuilders will be called to add
	   * additional properties to the row.
	   * @param {function(row, gridOptions)} rowBuilder function to be called
	   */
	  Grid.prototype.registerRowBuilder = function registerRowBuilder(rowBuilder) {
	    this.rowBuilders.push(rowBuilder);
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerDataChangeCallback
	   * @methodOf ui.grid.class:Grid
	   * @description When a data change occurs, the data change callbacks of the specified type
	   * will be called.  The rules are:
	   *
	   * - when the data watch fires, that is considered a ROW change (the data watch only notices
	   *   added or removed rows)
	   * - when the api is called to inform us of a change, the declared type of that change is used
	   * - when a cell edit completes, the EDIT callbacks are triggered
	   * - when the columnDef watch fires, the COLUMN callbacks are triggered
	   * - when the options watch fires, the OPTIONS callbacks are triggered
	   *
	   * For a given event:
	   * - ALL calls ROW, EDIT, COLUMN, OPTIONS and ALL callbacks
	   * - ROW calls ROW and ALL callbacks
	   * - EDIT calls EDIT and ALL callbacks
	   * - COLUMN calls COLUMN and ALL callbacks
	   * - OPTIONS calls OPTIONS and ALL callbacks
	   *
	   * @param {function(grid)} callback function to be called
	   * @param {array} types the types of data change you want to be informed of.  Values from
	   * the {@link ui.grid.service:uiGridConstants#properties_dataChange uiGridConstants.dataChange}
	   *  values ( ALL, EDIT, ROW, COLUMN, OPTIONS ).  Optional and defaults to ALL
	   * @returns {function} deregister function - a function that can be called to deregister this callback
	   */
	  Grid.prototype.registerDataChangeCallback = function registerDataChangeCallback(callback, types, _this) {
	    var self = this,
	      uid = gridUtil.nextUid();
	
	    if ( !types ) {
	      types = [uiGridConstants.dataChange.ALL];
	    }
	    if ( !Array.isArray(types)) {
	      gridUtil.logError("Expected types to be an array or null in registerDataChangeCallback, value passed was: " + types );
	    }
	    this.dataChangeCallbacks[uid] = { callback: callback, types: types, _this: _this };
	
	    return function() {
	      delete self.dataChangeCallbacks[uid];
	    };
	  };
	
	  /**
	   * @ngdoc function
	   * @name callDataChangeCallbacks
	   * @methodOf ui.grid.class:Grid
	   * @description Calls the callbacks based on the type of data change that
	   * has occurred. Always calls the ALL callbacks, calls the ROW, EDIT, COLUMN and OPTIONS callbacks if the
	   * event type is matching, or if the type is ALL.
	   * @param {string} type the type of event that occurred - one of the
	   * {@link ui.grid.service:uiGridConstants#properties_dataChange uiGridConstants.dataChange}
	   *  values (ALL, ROW, EDIT, COLUMN, OPTIONS)
	   */
	  Grid.prototype.callDataChangeCallbacks = function callDataChangeCallbacks(type, options) {
	    angular.forEach( this.dataChangeCallbacks, function( callback, uid ) {
	      if ( callback.types.indexOf( uiGridConstants.dataChange.ALL ) !== -1 ||
	           callback.types.indexOf( type ) !== -1 ||
	           type === uiGridConstants.dataChange.ALL ) {
	        if (callback._this) {
	           callback.callback.apply(callback._this, this, options);
	        }
	        else {
	          callback.callback(this, options);
	        }
	      }
	    }, this);
	  };
	
	  /**
	   * @ngdoc function
	   * @name notifyDataChange
	   * @methodOf ui.grid.class:Grid
	   * @description Notifies us that a data change has occurred, used in the public
	   * api for users to tell us when they've changed data or some other event that
	   * our watches cannot pick up
	   * @param {string} type the type of event that occurred - one of the
	   * uiGridConstants.dataChange values (ALL, ROW, EDIT, COLUMN, OPTIONS)
	   *
	   * - ALL: listeners fired on any of these events, fires listeners on all events.
	   * - ROW: fired when a row is added or removed.
	   * - EDIT: fired when the data in a cell is edited.
	   * - COLUMN: fired when the column definitions are modified.
	   * - OPTIONS: fired when the grid options are modified.
	   */
	  Grid.prototype.notifyDataChange = function notifyDataChange(type) {
	    var constants = uiGridConstants.dataChange;
	
	    if ( type === constants.ALL ||
	         type === constants.COLUMN ||
	         type === constants.EDIT ||
	         type === constants.ROW ||
	         type === constants.OPTIONS ) {
	      this.callDataChangeCallbacks( type );
	    }
	    else {
	      gridUtil.logError("Notified of a data change, but the type was not recognised, so no action taken, type was: " + type);
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name columnRefreshCallback
	   * @methodOf ui.grid.class:Grid
	   * @description refreshes the grid when a column refresh
	   * is notified, which triggers handling of the visible flag.
	   * This is called on uiGridConstants.dataChange.COLUMN, and is
	   * registered as a dataChangeCallback in grid.js
	   * @param {object} grid The grid object.
	   * @param {object} options Any options passed into the callback.
	   */
	  Grid.prototype.columnRefreshCallback = function columnRefreshCallback(grid, options) {
	    grid.buildColumns(options);
	    grid.queueGridRefresh();
	  };
	
	  /**
	   * @ngdoc function
	   * @name processRowsCallback
	   * @methodOf ui.grid.class:Grid
	   * @description calls the row processors, specifically
	   * intended to reset the sorting when an edit is called,
	   * registered as a dataChangeCallback on uiGridConstants.dataChange.EDIT
	   * @param {object} grid The grid object.
	   */
	  Grid.prototype.processRowsCallback = function processRowsCallback( grid ) {
	    grid.queueGridRefresh();
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name updateFooterHeightCallback
	   * @methodOf ui.grid.class:Grid
	   * @description recalculates the footer height,
	   * registered as a dataChangeCallback on uiGridConstants.dataChange.OPTIONS
	   * @param {object} grid The grid object.
	   */
	  Grid.prototype.updateFooterHeightCallback = function updateFooterHeightCallback( grid ) {
	    grid.footerHeight = grid.calcFooterHeight();
	    grid.columnFooterHeight = grid.calcColumnFooterHeight();
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name getColumn
	   * @methodOf ui.grid.class:Grid
	   * @description returns a grid column for the column name
	   * @param {string} name column name
	   */
	  Grid.prototype.getColumn = function getColumn(name) {
	    return rowColumnFinder(this.columns, function (column) {
	      return column.colDef.name === name;
	    });
	  };
	
	  /**
	   * @ngdoc function
	   * @name getColDef
	   * @methodOf ui.grid.class:Grid
	   * @description returns a grid colDef for the column name
	   * @param {string} name column.field
	   */
	  Grid.prototype.getColDef = function getColDef(name) {
	    return rowColumnFinder(this.options.columnDefs, function (colDef) {
	      return colDef.name === name;
	    });
	  };
	
	  /**
	   * @ngdoc function
	   * @name assignTypes
	   * @methodOf ui.grid.class:Grid
	   * @description uses the first row of data to assign colDef.type for any types not defined.
	   */
	  /**
	   * @ngdoc property
	   * @name type
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description the type of the column, used in sorting.  If not provided then the
	   * grid will guess the type.  Add this only if the grid guessing is not to your
	   * satisfaction.  One of:
	   * - 'string'
	   * - 'boolean'
	   * - 'number'
	   * - 'date'
	   * - 'object'
	   * - 'numberStr'
	   * Note that if you choose date, your dates should be in a javascript date type
	   *
	   */
	  Grid.prototype.assignTypes = function() {
	    var self = this;
	
	    self.options.columnDefs.forEach(function (colDef, index) {
	      // Assign colDef type if not specified
	      if (!colDef.type) {
	        var col = new GridColumn(colDef, index, self);
	        var firstRow = self.rows.length > 0 ? self.rows[0] : null;
	        if (firstRow) {
	          colDef.type = gridUtil.guessType(self.getCellValue(firstRow, col));
	        }
	        else {
	          colDef.type = 'string';
	        }
	      }
	    });
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name isRowHeaderColumn
	   * @methodOf ui.grid.class:Grid
	   * @description returns true if the column is a row Header
	   * @param {object} column column
	   */
	  Grid.prototype.isRowHeaderColumn = function isRowHeaderColumn(column) {
	    return this.rowHeaderColumns.indexOf(column) !== -1;
	  };
	
	  /**
	  * @ngdoc function
	  * @name addRowHeaderColumn
	  * @methodOf ui.grid.class:Grid
	  * @description adds a row header column to the grid
	  * @param {object} colDef Column definition object.
	  * @param {float} order Number that indicates where the column should be placed in the grid.
	  * @param {boolean} stopColumnBuild Prevents the buildColumn callback from being triggered. This is useful to improve
	  * performance of the grid during initial load.
	  */
	  Grid.prototype.addRowHeaderColumn = function addRowHeaderColumn(colDef, order, stopColumnBuild) {
	    var self = this;
	
	    // default order
	    if (order === undefined) {
	      order = 0;
	    }
	
	    var rowHeaderCol = new GridColumn(colDef, gridUtil.nextUid(), self);
	    rowHeaderCol.isRowHeader = true;
	    if (self.isRTL()) {
	      self.createRightContainer();
	      rowHeaderCol.renderContainer = 'right';
	    }
	    else {
	      self.createLeftContainer();
	      rowHeaderCol.renderContainer = 'left';
	    }
	
	    // relies on the default column builder being first in array, as it is instantiated
	    // as part of grid creation
	    self.columnBuilders[0](colDef,rowHeaderCol,self.options)
	      .then(function() {
	        rowHeaderCol.enableFiltering = false;
	        rowHeaderCol.enableSorting = false;
	        rowHeaderCol.enableHiding = false;
	        rowHeaderCol.headerPriority = order;
	        self.rowHeaderColumns.push(rowHeaderCol);
	        self.rowHeaderColumns = self.rowHeaderColumns.sort(function (a, b) {
	          return a.headerPriority - b.headerPriority;
	        });
	
	        if (!stopColumnBuild) {
	          self.buildColumns()
	            .then(function() {
	              self.preCompileCellTemplates();
	              self.queueGridRefresh();
	            }).catch(angular.noop);
	        }
	      }).catch(angular.noop);
	  };
	
	  /**
	   * @ngdoc function
	   * @name getOnlyDataColumns
	   * @methodOf ui.grid.class:Grid
	   * @description returns all columns except for rowHeader columns
	   */
	  Grid.prototype.getOnlyDataColumns = function getOnlyDataColumns() {
	    var self = this,
	      cols = [];
	
	    self.columns.forEach(function (col) {
	      if (self.rowHeaderColumns.indexOf(col) === -1) {
	        cols.push(col);
	      }
	    });
	    return cols;
	  };
	
	  /**
	   * @ngdoc function
	   * @name buildColumns
	   * @methodOf ui.grid.class:Grid
	   * @description creates GridColumn objects from the columnDefinition.  Calls each registered
	   * columnBuilder to further process the column
	   * @param {object} opts An object contains options to use when building columns
	   *
	   * * **orderByColumnDefs**: defaults to **false**. When true, `buildColumns` will reorder existing columns according to the order within the column definitions.
	   *
	   * @returns {Promise} a promise to load any needed column resources
	   */
	  Grid.prototype.buildColumns = function buildColumns(opts) {
	    var options = {
	      orderByColumnDefs: false
	    };
	
	    angular.extend(options, opts);
	
	    // gridUtil.logDebug('buildColumns');
	    var self = this;
	    var builderPromises = [];
	    var headerOffset = self.rowHeaderColumns.length;
	    var i;
	
	    // Remove any columns for which a columnDef cannot be found
	    // Deliberately don't use forEach, as it doesn't like splice being called in the middle
	    // Also don't cache columns.length, as it will change during this operation
	    for (i = 0; i < self.columns.length; i++) {
	      if (!self.getColDef(self.columns[i].name)) {
	        self.columns.splice(i, 1);
	        i--;
	      }
	    }
	
	    // add row header columns to the grid columns array _after_ columns without columnDefs have been removed
	    // rowHeaderColumns is ordered by priority so insert in reverse
	    for (var j = self.rowHeaderColumns.length - 1; j >= 0; j--) {
	      self.columns.unshift(self.rowHeaderColumns[j]);
	    }
	
	    // look at each column def, and update column properties to match.  If the column def
	    // doesn't have a column, then splice in a new gridCol
	    self.options.columnDefs.forEach(function (colDef, index) {
	      self.preprocessColDef(colDef);
	      var col = self.getColumn(colDef.name);
	
	      if (!col) {
	        col = new GridColumn(colDef, gridUtil.nextUid(), self);
	        self.columns.splice(index + headerOffset, 0, col);
	      }
	      else {
	        // tell updateColumnDef that the column was pre-existing
	        col.updateColumnDef(colDef, false);
	      }
	
	      self.columnBuilders.forEach(function (builder) {
	        builderPromises.push(builder.call(self, colDef, col, self.options));
	      });
	    });
	
	    /*** Reorder columns if necessary ***/
	    if (!!options.orderByColumnDefs) {
	      // Create a shallow copy of the columns as a cache
	      var columnCache = self.columns.slice(0);
	
	      // We need to allow for the "row headers" when mapping from the column defs array to the columns array
	      //   If we have a row header in columns[0] and don't account for it   we'll overwrite it with the column in columnDefs[0]
	
	      // Go through all the column defs, use the shorter of columns length and colDefs.length because if a user has given two columns the same name then
	      // columns will be shorter than columnDefs.  In this situation we'll avoid an error, but the user will still get an unexpected result
	      var len = Math.min(self.options.columnDefs.length, self.columns.length);
	      for (i = 0; i < len; i++) {
	        // If the column at this index has a different name than the column at the same index in the column defs...
	        if (self.columns[i + headerOffset].name !== self.options.columnDefs[i].name) {
	          // Replace the one in the cache with the appropriate column
	          columnCache[i + headerOffset] = self.getColumn(self.options.columnDefs[i].name);
	        }
	        else {
	          // Otherwise just copy over the one from the initial columns
	          columnCache[i + headerOffset] = self.columns[i + headerOffset];
	        }
	      }
	
	      // Empty out the columns array, non-destructively
	      self.columns.length = 0;
	
	      // And splice in the updated, ordered columns from the cache
	      Array.prototype.splice.apply(self.columns, [0, 0].concat(columnCache));
	    }
	
	    return $q.all(builderPromises).then(function() {
	      if (self.rows.length > 0) {
	        self.assignTypes();
	      }
	      if (options.preCompileCellTemplates) {
	        self.preCompileCellTemplates();
	      }
	    }).catch(angular.noop);
	  };
	
	  Grid.prototype.preCompileCellTemplate = function(col) {
	    var self = this;
	    var html = col.cellTemplate.replace(uiGridConstants.MODEL_COL_FIELD, self.getQualifiedColField(col));
	    html = html.replace(uiGridConstants.COL_FIELD, 'grid.getCellValue(row, col)');
	
	    col.compiledElementFn = $compile(html);
	
	    if (col.compiledElementFnDefer) {
	      col.compiledElementFnDefer.resolve(col.compiledElementFn);
	    }
	  };
	
	/**
	 * @ngdoc function
	 * @name preCompileCellTemplates
	 * @methodOf ui.grid.class:Grid
	 * @description precompiles all cell templates
	 */
	  Grid.prototype.preCompileCellTemplates = function() {
	    var self = this;
	    self.columns.forEach(function (col) {
	      if ( col.cellTemplate ) {
	        self.preCompileCellTemplate( col );
	      } else if ( col.cellTemplatePromise ) {
	        col.cellTemplatePromise.then( function() {
	          self.preCompileCellTemplate( col );
	        }).catch(angular.noop);
	      }
	    });
	  };
	
	  /**
	   * @ngdoc function
	   * @name getGridQualifiedColField
	   * @methodOf ui.grid.class:Grid
	   * @description Returns the $parse-able accessor for a column within its $scope
	   * @param {GridColumn} col col object
	   */
	  Grid.prototype.getQualifiedColField = function (col) {
	    var base = 'row.entity';
	    if ( col.field === uiGridConstants.ENTITY_BINDING ) {
	      return base;
	    }
	    return gridUtil.preEval(base + '.' + col.field);
	  };
	
	  /**
	   * @ngdoc function
	   * @name createLeftContainer
	   * @methodOf ui.grid.class:Grid
	   * @description creates the left render container if it doesn't already exist
	   */
	  Grid.prototype.createLeftContainer = function() {
	    if (!this.hasLeftContainer()) {
	      this.renderContainers.left = new GridRenderContainer('left', this, { disableColumnOffset: true });
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name createRightContainer
	   * @methodOf ui.grid.class:Grid
	   * @description creates the right render container if it doesn't already exist
	   */
	  Grid.prototype.createRightContainer = function() {
	    if (!this.hasRightContainer()) {
	      this.renderContainers.right = new GridRenderContainer('right', this, { disableColumnOffset: true });
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name hasLeftContainer
	   * @methodOf ui.grid.class:Grid
	   * @description returns true if leftContainer exists
	   */
	  Grid.prototype.hasLeftContainer = function() {
	    return this.renderContainers.left !== undefined;
	  };
	
	  /**
	   * @ngdoc function
	   * @name hasRightContainer
	   * @methodOf ui.grid.class:Grid
	   * @description returns true if rightContainer exists
	   */
	  Grid.prototype.hasRightContainer = function() {
	    return this.renderContainers.right !== undefined;
	  };
	
	
	      /**
	   * undocumented function
	   * @name preprocessColDef
	   * @methodOf ui.grid.class:Grid
	   * @description defaults the name property from field to maintain backwards compatibility with 2.x
	   * validates that name or field is present
	   */
	  Grid.prototype.preprocessColDef = function preprocessColDef(colDef) {
	    var self = this;
	
	    if (!colDef.field && !colDef.name) {
	      throw new Error('colDef.name or colDef.field property is required');
	    }
	
	    // maintain backwards compatibility with 2.x
	    // field was required in 2.x.  now name is required
	    if (colDef.name === undefined && colDef.field !== undefined) {
	      // See if the column name already exists:
	      var newName = colDef.field,
	        counter = 2;
	      while (self.getColumn(newName)) {
	        newName = colDef.field + counter.toString();
	        counter++;
	      }
	      colDef.name = newName;
	    }
	  };
	
	  // Return a list of items that exist in the `n` array but not the `o` array. Uses optional property accessors passed as third & fourth parameters
	  Grid.prototype.newInN = function newInN(o, n, oAccessor, nAccessor) {
	    var self = this;
	
	    var t = [];
	    for (var i = 0; i < n.length; i++) {
	      var nV = nAccessor ? n[i][nAccessor] : n[i];
	
	      var found = false;
	      for (var j = 0; j < o.length; j++) {
	        var oV = oAccessor ? o[j][oAccessor] : o[j];
	        if (self.options.rowEquality(nV, oV)) {
	          found = true;
	          break;
	        }
	      }
	      if (!found) {
	        t.push(nV);
	      }
	    }
	
	    return t;
	  };
	
	  var rowColumnFinder = function(array, func) {
	    if (array && array.length) {
	      if (angular.isFunction(array.find)) {
	        return array.find(func) || null;
	      }
	
	      var result = null;
	      array.every(function (entry) {
	        if (func(entry)) {
	          result = entry;
	          return false;
	        }
	        return true;
	      });
	      return result;
	    }
	    return null;
	  }
	
	  /**
	   * @ngdoc function
	   * @name getRow
	   * @methodOf ui.grid.class:Grid
	   * @description returns the GridRow that contains the rowEntity
	   * @param {object} rowEntity the gridOptions.data array element instance
	   * @param {array} lookInRows [optional] the rows to look in - if not provided then
	   * looks in grid.rows
	   */
	  Grid.prototype.getRow = function getRow(rowEntity, lookInRows) {
	    var self = this;
	    lookInRows = lookInRows == void 0 ? this.rows : lookInRows;
	    return rowColumnFinder(lookInRows, function (row) {
	      return self.options.rowEquality(row.entity, rowEntity);
	    });
	  };
	
	  /**
	   * @ngdoc function
	   * @name getRowsByKey
	   * @methodOf ui.grid.class:Grid
	   * @description returns the GridRows who have an key that is equal to comparator
	   * @param {boolean} isInEntity if true then key is in entity else it's directly in row
	   * @param {(string|number)} key the key to look for
	   * @param {any} comparator the value that key should have
	   * @param {array} lookInRows [optional] the rows to look in - if not provided then
	   * looks in grid.rows
	   */
	  Grid.prototype.getRowsByKey = function getRowsByKey(isInEntity, key, comparator, lookInRows) {
	    if ( key == void 0 ) {
	      return null;
	    }
	
	    lookInRows = lookInRows == void 0 ? this.rows : lookInRows;
	    var func = isInEntity ? function (row) {
	      return row.entity != void 0 && row.entity.hasOwnProperty(key) && row.entity[key] === comparator;
	    } : function (row) {
	      return row.hasOwnProperty(key) && row[key] === comparator;
	    }
	
	    return lookInRows.filter(func);
	  };
	
	  /**
	   * @ngdoc function
	   * @name findRowByKey
	   * @methodOf ui.grid.class:Grid
	   * @description returns the first GridRow which has an key that is equal to comparator
	   * @param {boolean} isInEntity if true then key is in entity else it's directly in row
	   * @param {(string|number)} key the key to look for
	   * @param {any} comparator the value that key should have
	   * @param {array} lookInRows [optional] the rows to look in - if not provided then
	   * looks in grid.rows
	   */
	  Grid.prototype.findRowByKey = function findRowByKey(isInEntity, key, comparator, lookInRows) {
	    var result = null;
	    if ( key != void 0 ) {
	      lookInRows = lookInRows == void 0 ? this.rows : lookInRows;
	      var func = isInEntity ? function (row) {
	        if ( row.entity != void 0 && row.entity.hasOwnProperty(key) && row.entity[key] === comparator ) {
	          result = row;
	          return false;
	        }
	        return true;
	      } : function (row) {
	        if ( row.hasOwnProperty(key) && row[key] === comparator ) {
	          result = row;
	          return false;
	        }
	        return true;
	      }
	
	      lookInRows.every(func);
	    }
	    return result
	  };
	
	  /**
	   * @ngdoc function
	   * @name modifyRows
	   * @methodOf ui.grid.class:Grid
	   * @description creates or removes GridRow objects from the newRawData array.  Calls each registered
	   * rowBuilder to further process the row
	   * @param {array} newRawData Modified set of data
	   *
	   * This method aims to achieve three things:
	   * 1. the resulting rows array is in the same order as the newRawData, we'll call
	   * rowsProcessors immediately after to sort the data anyway
	   * 2. if we have row hashing available, we try to use the rowHash to find the row
	   * 3. no memory leaks - rows that are no longer in newRawData need to be garbage collected
	   *
	   * The basic logic flow makes use of the newRawData, oldRows and oldHash, and creates
	   * the newRows and newHash
	   *
	   * ```
	   * newRawData.forEach newEntity
	   *   if (hashing enabled)
	   *     check oldHash for newEntity
	   *   else
	   *     look for old row directly in oldRows
	   *   if !oldRowFound     // must be a new row
	   *     create newRow
	   *   append to the newRows and add to newHash
	   *   run the processors
	   * ```
	   *
	   * Rows are identified using the hashKey if configured.  If not configured, then rows
	   * are identified using the gridOptions.rowEquality function
	   *
	   * This method is useful when trying to select rows immediately after loading data without
	   * using a $timeout/$interval, e.g.:
	   *
	   *   $scope.gridOptions.data =  someData;
	   *   $scope.gridApi.grid.modifyRows($scope.gridOptions.data);
	   *   $scope.gridApi.selection.selectRow($scope.gridOptions.data[0]);
	   *
	   * OR to persist row selection after data update (e.g. rows selected, new data loaded, want
	   * originally selected rows to be re-selected))
	   */
	  Grid.prototype.modifyRows = function modifyRows(newRawData) {
	    var self = this;
	    var oldRows = self.rows.slice(0);
	    var oldRowHash = self.rowHashMap || self.createRowHashMap();
	    var allRowsSelected = true;
	    self.rowHashMap = self.createRowHashMap();
	    self.rows.length = 0;
	
	    newRawData.forEach( function( newEntity, i ) {
	      var newRow, oldRow;
	
	      if ( self.options.enableRowHashing ) {
	        // if hashing is enabled, then this row will be in the hash if we already know about it
	        oldRow = oldRowHash.get( newEntity );
	      } else {
	        // otherwise, manually search the oldRows to see if we can find this row
	        oldRow = self.getRow(newEntity, oldRows);
	      }
	
	      // update newRow to have an entity
	      if ( oldRow ) {
	        newRow = oldRow;
	        newRow.entity = newEntity;
	      }
	
	      // if we didn't find the row, it must be new, so create it
	      if ( !newRow ) {
	        newRow = self.processRowBuilders(new GridRow(newEntity, i, self));
	      }
	
	      self.rows.push( newRow );
	      self.rowHashMap.put( newEntity, newRow );
	      if (!newRow.isSelected) {
	        allRowsSelected = false;
	      }
	    });
	
	    if (self.selection && self.rows.length) {
	      self.selection.selectAll = allRowsSelected;
	    }
	
	    self.assignTypes();
	
	    var p1 = $q.when(self.processRowsProcessors(self.rows))
	      .then(function (renderableRows) {
	        return self.setVisibleRows(renderableRows);
	      }).catch(angular.noop);
	
	    var p2 = $q.when(self.processColumnsProcessors(self.columns))
	      .then(function (renderableColumns) {
	        return self.setVisibleColumns(renderableColumns);
	      }).catch(angular.noop);
	
	    return $q.all([p1, p2]);
	  };
	
	
	  /**
	   * Private Undocumented Method
	   * @name addRows
	   * @methodOf ui.grid.class:Grid
	   * @description adds the newRawData array of rows to the grid and calls all registered
	   * rowBuilders. this keyword will reference the grid
	   */
	  Grid.prototype.addRows = function addRows(newRawData) {
	    var self = this,
	      existingRowCount = self.rows.length;
	
	    for (var i = 0; i < newRawData.length; i++) {
	      var newRow = self.processRowBuilders(new GridRow(newRawData[i], i + existingRowCount, self));
	
	      if (self.options.enableRowHashing) {
	        var found = self.rowHashMap.get(newRow.entity);
	        if (found) {
	          found.row = newRow;
	        }
	      }
	
	      self.rows.push(newRow);
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name processRowBuilders
	   * @methodOf ui.grid.class:Grid
	   * @description processes all RowBuilders for the gridRow
	   * @param {GridRow} gridRow reference to gridRow
	   * @returns {GridRow} the gridRow with all additional behavior added
	   */
	  Grid.prototype.processRowBuilders = function processRowBuilders(gridRow) {
	    var self = this;
	
	    self.rowBuilders.forEach(function (builder) {
	      builder.call(self, gridRow, self.options);
	    });
	
	    return gridRow;
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerStyleComputation
	   * @methodOf ui.grid.class:Grid
	   * @description registered a styleComputation function
	   *
	   * If the function returns a value it will be appended into the grid's `<style>` block
	   * @param {function($scope)} styleComputationInfo function
	   */
	  Grid.prototype.registerStyleComputation = function registerStyleComputation(styleComputationInfo) {
	    this.styleComputations.push(styleComputationInfo);
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerRowsProcessor
	   * @methodOf ui.grid.class:Grid
	   * @description
	   *
	   * Register a "rows processor" function. When the rows are updated,
	   * the grid calls each registered "rows processor", which has a chance
	   * to alter the set of rows (sorting, etc) as long as the count is not
	   * modified.
	   *
	   * @param {function(renderedRowsToProcess, columns )} processor rows processor function, which
	   * is run in the context of the grid (i.e. this for the function will be the grid), and must
	   * return the updated rows list, which is passed to the next processor in the chain
	   * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
	   * for other people to inject rows processors at intermediate priorities.  Lower priority rowsProcessors run earlier.
	   *
	   * At present all rows visible is running at 50, filter is running at 100, sort is at 200, grouping at 400, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
	   *
	   */
	  Grid.prototype.registerRowsProcessor = function registerRowsProcessor(processor, priority) {
	    if (!angular.isFunction(processor)) {
	      throw 'Attempt to register non-function rows processor: ' + processor;
	    }
	
	    this.rowsProcessors.push({processor: processor, priority: priority});
	    this.rowsProcessors.sort(function sortByPriority( a, b ) {
	      return a.priority - b.priority;
	    });
	  };
	
	  /**
	   * @ngdoc function
	   * @name removeRowsProcessor
	   * @methodOf ui.grid.class:Grid
	   * @param {function(renderableRows)} processor processor function
	   * @description Remove a registered rows processor
	   */
	  Grid.prototype.removeRowsProcessor = function removeRowsProcessor(processor) {
	    var idx = -1;
	    this.rowsProcessors.forEach(function(rowsProcessor, index) {
	      if ( rowsProcessor.processor === processor ) {
	        idx = index;
	      }
	    });
	
	    if ( idx !== -1 ) {
	      this.rowsProcessors.splice(idx, 1);
	    }
	  };
	
	  /**
	   * Private Undocumented Method
	   * @name processRowsProcessors
	   * @methodOf ui.grid.class:Grid
	   * @param {Array[GridRow]} renderableRows The array of "renderable" rows
	   * @description Run all the registered rows processors on the array of renderable rows
	   */
	  Grid.prototype.processRowsProcessors = function processRowsProcessors(renderableRows) {
	    var self = this;
	
	    // Create a shallow copy of the rows so that we can safely sort them without altering the original grid.rows sort order
	    var myRenderableRows = renderableRows.slice(0);
	
	    // Return myRenderableRows with no processing if we have no rows processors
	    if (self.rowsProcessors.length === 0) {
	      return $q.when(myRenderableRows);
	    }
	
	    // Counter for iterating through rows processors
	    var i = 0;
	
	    // Promise for when we're done with all the processors
	    var finished = $q.defer();
	
	    // This function will call the processor in self.rowsProcessors at index 'i', and then
	    //   when done will call the next processor in the list, using the output from the processor
	    //   at i as the argument for 'renderedRowsToProcess' on the next iteration.
	    //
	    //   If we're at the end of the list of processors, we resolve our 'finished' callback with
	    //   the result.
	    function startProcessor(i, renderedRowsToProcess) {
	      // Get the processor at 'i'
	      var processor = self.rowsProcessors[i].processor;
	
	      // Call the processor, passing in the rows to process and the current columns
	      //   (note: it's wrapped in $q.when() in case the processor does not return a promise)
	      return $q.when( processor.call(self, renderedRowsToProcess, self.columns) )
	        .then(function handleProcessedRows(processedRows) {
	          // Check for errors
	          if (!processedRows) {
	            throw "Processor at index " + i + " did not return a set of renderable rows";
	          }
	
	          if (!angular.isArray(processedRows)) {
	            throw "Processor at index " + i + " did not return an array";
	          }
	
	          // Processor is done, increment the counter
	          i++;
	
	          // If we're not done with the processors, call the next one
	          if (i <= self.rowsProcessors.length - 1) {
	            return startProcessor(i, processedRows);
	          }
	          // We're done! Resolve the 'finished' promise
	          else {
	            finished.resolve(processedRows);
	          }
	        }).catch(function(error) {
	          throw error;
	        });
	    }
	
	    // Start on the first processor
	    startProcessor(0, myRenderableRows);
	
	    return finished.promise;
	  };
	
	  Grid.prototype.setVisibleRows = function setVisibleRows(rows) {
	    var self = this;
	
	    // Reset all the render container row caches
	    for (var i in self.renderContainers) {
	      var container = self.renderContainers[i];
	
	      container.canvasHeightShouldUpdate = true;
	
	      if ( typeof(container.visibleRowCache) === 'undefined' ) {
	        container.visibleRowCache = [];
	      } else {
	        container.visibleRowCache.length = 0;
	      }
	    }
	
	    // rows.forEach(function (row) {
	    for (var ri = 0; ri < rows.length; ri++) {
	      var row = rows[ri];
	
	      var targetContainer = (typeof(row.renderContainer) !== 'undefined' && row.renderContainer) ? row.renderContainer : 'body';
	
	      // If the row is visible
	      if (row.visible) {
	        self.renderContainers[targetContainer].visibleRowCache.push(row);
	      }
	    }
	    self.api.core.raise.rowsVisibleChanged(this.api);
	    self.api.core.raise.rowsRendered(this.api);
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerColumnsProcessor
	   * @methodOf ui.grid.class:Grid
	   * @param {function(renderedColumnsToProcess, rows)} processor column processor function, which
	   * is run in the context of the grid (i.e. this for the function will be the grid), and
	   * which must return an updated renderedColumnsToProcess which can be passed to the next processor
	   * in the chain
	   * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
	   * for other people to inject columns processors at intermediate priorities.  Lower priority columnsProcessors run earlier.
	   *
	   * At present all rows visible is running at 50, filter is running at 100, sort is at 200, grouping at 400, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
	   * @description
	
	     Register a "columns processor" function. When the columns are updated,
	     the grid calls each registered "columns processor", which has a chance
	     to alter the set of columns, as long as the count is not modified.
	   */
	  Grid.prototype.registerColumnsProcessor = function registerColumnsProcessor(processor, priority) {
	    if (!angular.isFunction(processor)) {
	      throw 'Attempt to register non-function rows processor: ' + processor;
	    }
	
	    this.columnsProcessors.push({processor: processor, priority: priority});
	    this.columnsProcessors.sort(function sortByPriority( a, b ) {
	      return a.priority - b.priority;
	    });
	  };
	
	  Grid.prototype.removeColumnsProcessor = function removeColumnsProcessor(processor) {
	    var idx = this.columnsProcessors.indexOf(processor);
	
	    if (typeof(idx) !== 'undefined' && idx !== undefined) {
	      this.columnsProcessors.splice(idx, 1);
	    }
	  };
	
	  Grid.prototype.processColumnsProcessors = function processColumnsProcessors(renderableColumns) {
	    var self = this;
	
	    // Create a shallow copy of the rows so that we can safely sort them without altering the original grid.rows sort order
	    var myRenderableColumns = renderableColumns.slice(0);
	
	    // Return myRenderableRows with no processing if we have no rows processors
	    if (self.columnsProcessors.length === 0) {
	      return $q.when(myRenderableColumns);
	    }
	
	    // Promise for when we're done with all the processors
	    var finished = $q.defer();
	
	    // This function will call the processor in self.rowsProcessors at index 'i', and then
	    //   when done will call the next processor in the list, using the output from the processor
	    //   at i as the argument for 'renderedRowsToProcess' on the next iteration.
	    //
	    //   If we're at the end of the list of processors, we resolve our 'finished' callback with
	    //   the result.
	    function startProcessor(i, renderedColumnsToProcess) {
	      // Get the processor at 'i'
	      var processor = self.columnsProcessors[i].processor;
	
	      // Call the processor, passing in the rows to process and the current columns
	      //   (note: it's wrapped in $q.when() in case the processor does not return a promise)
	      return $q.when( processor.call(self, renderedColumnsToProcess, self.rows) )
	        .then(function handleProcessedRows(processedColumns) {
	          // Check for errors
	          if (!processedColumns) {
	            throw "Processor at index " + i + " did not return a set of renderable rows";
	          }
	
	          if (!angular.isArray(processedColumns)) {
	            throw "Processor at index " + i + " did not return an array";
	          }
	
	          // Processor is done, increment the counter
	          i++;
	
	          // If we're not done with the processors, call the next one
	          if (i <= self.columnsProcessors.length - 1) {
	            return startProcessor(i, myRenderableColumns);
	          }
	          // We're done! Resolve the 'finished' promise
	          else {
	            finished.resolve(myRenderableColumns);
	          }
	        }).catch(angular.noop);
	    }
	
	    // Start on the first processor
	    startProcessor(0, myRenderableColumns);
	
	    return finished.promise;
	  };
	
	  Grid.prototype.setVisibleColumns = function setVisibleColumns(columns) {
	    // gridUtil.logDebug('setVisibleColumns');
	
	    var self = this;
	
	    // Reset all the render container row caches
	    for (var i in self.renderContainers) {
	      var container = self.renderContainers[i];
	
	      container.visibleColumnCache.length = 0;
	    }
	
	    for (var ci = 0; ci < columns.length; ci++) {
	      var column = columns[ci];
	
	      // If the column is visible
	      if (column.visible) {
	        // If the column has a container specified
	        if (typeof(column.renderContainer) !== 'undefined' && column.renderContainer) {
	          self.renderContainers[column.renderContainer].visibleColumnCache.push(column);
	        }
	        // If not, put it into the body container
	        else {
	          self.renderContainers.body.visibleColumnCache.push(column);
	        }
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name handleWindowResize
	   * @methodOf ui.grid.class:Grid
	   * @description Triggered when the browser window resizes; automatically resizes the grid
	   * @returns {Promise} A resolved promise once the window resize has completed.
	   */
	  Grid.prototype.handleWindowResize = function handleWindowResize($event) {
	    var self = this;
	
	    self.gridWidth = gridUtil.elementWidth(self.element);
	    self.gridHeight = gridUtil.elementHeight(self.element);
	
	    return self.queueRefresh();
	  };
	
	  /**
	   * @ngdoc function
	   * @name queueRefresh
	   * @methodOf ui.grid.class:Grid
	   * @description queues a grid refreshCanvas, a way of debouncing all the refreshes we might otherwise issue
	   */
	  Grid.prototype.queueRefresh = function queueRefresh() {
	    var self = this;
	
	    if (self.refreshCanceller) {
	      $timeout.cancel(self.refreshCanceller);
	    }
	
	    self.refreshCanceller = $timeout(function () {
	      self.refreshCanvas(true);
	    });
	
	    self.refreshCanceller.then(function () {
	      self.refreshCanceller = null;
	    }).catch(angular.noop);
	
	    return self.refreshCanceller;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name queueGridRefresh
	   * @methodOf ui.grid.class:Grid
	   * @description queues a grid refresh, a way of debouncing all the refreshes we might otherwise issue
	   */
	  Grid.prototype.queueGridRefresh = function queueGridRefresh() {
	    var self = this;
	
	    if (self.gridRefreshCanceller) {
	      $timeout.cancel(self.gridRefreshCanceller);
	    }
	
	    self.gridRefreshCanceller = $timeout(function () {
	      self.refresh(true);
	    });
	
	    self.gridRefreshCanceller.then(function () {
	      self.gridRefreshCanceller = null;
	    }).catch(angular.noop);
	
	    return self.gridRefreshCanceller;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name updateCanvasHeight
	   * @methodOf ui.grid.class:Grid
	   * @description flags all render containers to update their canvas height
	   */
	  Grid.prototype.updateCanvasHeight = function updateCanvasHeight() {
	    var self = this;
	
	    for (var containerId in self.renderContainers) {
	      if (self.renderContainers.hasOwnProperty(containerId)) {
	        var container = self.renderContainers[containerId];
	        container.canvasHeightShouldUpdate = true;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name buildStyles
	   * @methodOf ui.grid.class:Grid
	   * @description calls each styleComputation function
	   */
	  Grid.prototype.buildStyles = function buildStyles() {
	    var self = this;
	
	    // gridUtil.logDebug('buildStyles');
	
	    self.customStyles = '';
	
	    self.styleComputations
	      .sort(function(a, b) {
	        if (a.priority === null) { return 1; }
	        if (b.priority === null) { return -1; }
	        if (a.priority === null && b.priority === null) { return 0; }
	        return a.priority - b.priority;
	      })
	      .forEach(function (compInfo) {
	        // this used to provide $scope as a second parameter, but I couldn't find any
	        // style builders that used it, so removed it as part of moving to grid from controller
	        var ret = compInfo.func.call(self);
	
	        if (angular.isString(ret)) {
	          self.customStyles += '\n' + ret;
	        }
	      });
	  };
	
	
	  Grid.prototype.minColumnsToRender = function minColumnsToRender() {
	    var self = this;
	    var viewport = this.getViewportWidth();
	
	    var min = 0;
	    var totalWidth = 0;
	    self.columns.forEach(function(col, i) {
	      if (totalWidth < viewport) {
	        totalWidth += col.drawnWidth;
	        min++;
	      }
	      else {
	        var currWidth = 0;
	        for (var j = i; j >= i - min; j--) {
	          currWidth += self.columns[j].drawnWidth;
	        }
	        if (currWidth < viewport) {
	          min++;
	        }
	      }
	    });
	
	    return min;
	  };
	
	  Grid.prototype.getBodyHeight = function getBodyHeight() {
	    return this.getViewportHeight();
	  };
	
	  // NOTE: viewport drawable height is the height of the grid minus the header row height (including any border)
	  // TODO(c0bra): account for footer height
	  Grid.prototype.getViewportHeight = function getViewportHeight() {
	    var self = this;
	
	    var viewPortHeight = this.gridHeight - this.headerHeight - this.footerHeight;
	
	    // Account for native horizontal scrollbar, if present
	    // if (typeof(this.horizontalScrollbarHeight) !== 'undefined' && this.horizontalScrollbarHeight !== undefined && this.horizontalScrollbarHeight > 0) {
	    //   viewPortHeight = viewPortHeight - this.horizontalScrollbarHeight;
	    // }
	
	    var adjustment = self.getViewportAdjustment();
	
	    viewPortHeight = viewPortHeight + adjustment.height;
	
	    // gridUtil.logDebug('viewPortHeight', viewPortHeight);
	
	    return viewPortHeight > 0 ? viewPortHeight : 0;
	  };
	
	  Grid.prototype.getViewportWidth = function getViewportWidth() {
	    var self = this;
	
	    var viewPortWidth = this.gridWidth;
	
	    // if (typeof(this.verticalScrollbarWidth) !== 'undefined' && this.verticalScrollbarWidth !== undefined && this.verticalScrollbarWidth > 0) {
	    //   viewPortWidth = viewPortWidth - this.verticalScrollbarWidth;
	    // }
	
	    var adjustment = self.getViewportAdjustment();
	
	    viewPortWidth = viewPortWidth + adjustment.width;
	
	    // gridUtil.logDebug('getviewPortWidth', viewPortWidth);
	
	    return viewPortWidth;
	  };
	
	  Grid.prototype.getHeaderViewportWidth = function getHeaderViewportWidth() {
	    return this.getViewportWidth();
	  };
	
	  Grid.prototype.addVerticalScrollSync = function (containerId, callBackFn) {
	    this.verticalScrollSyncCallBackFns[containerId] = callBackFn;
	  };
	
	  Grid.prototype.addHorizontalScrollSync = function (containerId, callBackFn) {
	    this.horizontalScrollSyncCallBackFns[containerId] = callBackFn;
	  };
	
	/**
	 * Scroll needed containers by calling their ScrollSyncs
	 * @param sourceContainerId the containerId that has already set it's top/left.
	 *         can be empty string which means all containers need to set top/left
	 * @param scrollEvent
	 */
	  Grid.prototype.scrollContainers = function (sourceContainerId, scrollEvent) {
	    if (scrollEvent.y) {
	      // default for no container Id (ex. mousewheel means that all containers must set scrollTop/Left)
	      var verts = ['body','left', 'right'];
	
	      this.flagScrollingVertically(scrollEvent);
	
	      if (sourceContainerId === 'body') {
	        verts = ['left', 'right'];
	      }
	      else if (sourceContainerId === 'left') {
	        verts = ['body', 'right'];
	      }
	      else if (sourceContainerId === 'right') {
	        verts = ['body', 'left'];
	      }
	
	      for (var i = 0; i < verts.length; i++) {
	        var id = verts[i];
	        if (this.verticalScrollSyncCallBackFns[id]) {
	          this.verticalScrollSyncCallBackFns[id](scrollEvent);
	        }
	      }
	
	    }
	
	    if (scrollEvent.x) {
	      // default for no container Id (ex. mousewheel means that all containers must set scrollTop/Left)
	      var horizs = ['body','bodyheader', 'bodyfooter'];
	
	      this.flagScrollingHorizontally(scrollEvent);
	      if (sourceContainerId === 'body') {
	        horizs = ['bodyheader', 'bodyfooter'];
	      }
	
	      for (var j = 0; j < horizs.length; j++) {
	        var idh = horizs[j];
	        if (this.horizontalScrollSyncCallBackFns[idh]) {
	          this.horizontalScrollSyncCallBackFns[idh](scrollEvent);
	        }
	      }
	    }
	  };
	
	  Grid.prototype.registerViewportAdjuster = function registerViewportAdjuster(func) {
	    this.viewportAdjusters.push(func);
	  };
	
	  Grid.prototype.removeViewportAdjuster = function registerViewportAdjuster(func) {
	    var idx = this.viewportAdjusters.indexOf(func);
	
	    if (typeof(idx) !== 'undefined' && idx !== undefined) {
	      this.viewportAdjusters.splice(idx, 1);
	    }
	  };
	
	  Grid.prototype.getViewportAdjustment = function getViewportAdjustment() {
	    var self = this;
	
	    var adjustment = { height: 0, width: 0 };
	
	    self.viewportAdjusters.forEach(function (func) {
	      adjustment = func.call(this, adjustment);
	    });
	
	    return adjustment;
	  };
	
	  Grid.prototype.getVisibleRowCount = function getVisibleRowCount() {
	    // return this.visibleRowCache.length;
	    return this.renderContainers.body.visibleRowCache.length;
	  };
	
	   Grid.prototype.getVisibleRows = function getVisibleRows() {
	    return this.renderContainers.body.visibleRowCache;
	   };
	
	  Grid.prototype.getVisibleColumnCount = function getVisibleColumnCount() {
	    // return this.visibleRowCache.length;
	    return this.renderContainers.body.visibleColumnCache.length;
	  };
	
	
	  Grid.prototype.searchRows = function searchRows(renderableRows) {
	    return rowSearcher.search(this, renderableRows, this.columns);
	  };
	
	  Grid.prototype.sortByColumn = function sortByColumn(renderableRows) {
	    return rowSorter.sort(this, renderableRows, this.columns);
	  };
	
	  /**
	   * @ngdoc function
	   * @name getCellValue
	   * @methodOf ui.grid.class:Grid
	   * @description Gets the value of a cell for a particular row and column
	   * @param {GridRow} row Row to access
	   * @param {GridColumn} col Column to access
	   */
	  Grid.prototype.getCellValue = function getCellValue(row, col) {
	    if ( typeof(row.entity[ '$$' + col.uid ]) !== 'undefined' ) {
	      return row.entity[ '$$' + col.uid].rendered;
	    }
	    else if (this.options.flatEntityAccess && typeof(col.field) !== 'undefined' ) {
	      return row.entity[col.field];
	    }
	    else {
	      if (!col.cellValueGetterCache) {
	        col.cellValueGetterCache = $parse(row.getEntityQualifiedColField(col));
	      }
	
	      return col.cellValueGetterCache(row);
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name getCellDisplayValue
	   * @methodOf ui.grid.class:Grid
	   * @description Gets the displayed value of a cell after applying any the `cellFilter`
	   * @param {GridRow} row Row to access
	   * @param {GridColumn} col Column to access
	   */
	  Grid.prototype.getCellDisplayValue = function getCellDisplayValue(row, col) {
	    if ( !col.cellDisplayGetterCache ) {
	      var custom_filter = col.cellFilter ? " | " + col.cellFilter : "";
	
	      if (typeof(row.entity['$$' + col.uid]) !== 'undefined') {
	        col.cellDisplayGetterCache = $parse(row.entity['$$' + col.uid].rendered + custom_filter);
	      }
	      else if (this.options.flatEntityAccess && typeof(col.field) !== 'undefined') {
	        var colField = col.field.replace(/(')|(\\)/g, "\\$&");
	
	        col.cellDisplayGetterCache = $parse('entity[\'' + colField + '\']' + custom_filter);
	      }
	      else {
	        col.cellDisplayGetterCache = $parse(row.getEntityQualifiedColField(col) + custom_filter);
	      }
	    }
	
	    var rowWithCol = angular.extend({}, row, {col: col});
	
	    return col.cellDisplayGetterCache(rowWithCol);
	  };
	
	
	  Grid.prototype.getNextColumnSortPriority = function getNextColumnSortPriority() {
	    var self = this,
	        p = 0;
	
	    self.columns.forEach(function (col) {
	      if (col.sort && col.sort.priority !== undefined && col.sort.priority >= p) {
	        p = col.sort.priority + 1;
	      }
	    });
	
	    return p;
	  };
	
	  /**
	   * @ngdoc function
	   * @name resetColumnSorting
	   * @methodOf ui.grid.class:Grid
	   * @description Return the columns that the grid is currently being sorted by
	   * @param {GridColumn} [excludedColumn] Optional GridColumn to exclude from having its sorting reset
	   */
	  Grid.prototype.resetColumnSorting = function resetColumnSorting(excludeCol) {
	    var self = this;
	
	    self.columns.forEach(function (col) {
	      if (col !== excludeCol && !col.suppressRemoveSort) {
	        col.sort = {};
	      }
	    });
	  };
	
	  /**
	   * @ngdoc function
	   * @name getColumnSorting
	   * @methodOf ui.grid.class:Grid
	   * @description Return the columns that the grid is currently being sorted by
	   * @returns {Array[GridColumn]} An array of GridColumn objects
	   */
	  Grid.prototype.getColumnSorting = function getColumnSorting() {
	    var self = this;
	
	    var sortedCols = [], myCols;
	
	    // Iterate through all the columns, sorted by priority
	    // Make local copy of column list, because sorting is in-place and we do not want to
	    // change the original sequence of columns
	    myCols = self.columns.slice(0);
	    myCols.sort(rowSorter.prioritySort).forEach(function (col) {
	      if (col.sort && typeof(col.sort.direction) !== 'undefined' && col.sort.direction && (col.sort.direction === uiGridConstants.ASC || col.sort.direction === uiGridConstants.DESC)) {
	        sortedCols.push(col);
	      }
	    });
	
	    return sortedCols;
	  };
	
	  /**
	   * @ngdoc function
	   * @name sortColumn
	   * @methodOf ui.grid.class:Grid
	   * @description Set the sorting on a given column, optionally resetting any existing sorting on the Grid.
	   * Emits the sortChanged event whenever the sort criteria are changed.
	   * @param {GridColumn} column Column to set the sorting on
	   * @param {uiGridConstants.ASC|uiGridConstants.DESC} [direction] Direction to sort by, either descending or ascending.
	   *   If not provided, the column will iterate through the sort directions
	   *   specified in the {@link ui.grid.class:GridOptions.columnDef#sortDirectionCycle sortDirectionCycle} attribute.
	   * @param {boolean} [add] Add this column to the sorting. If not provided or set to `false`, the Grid will reset any existing sorting and sort
	   *   by this column only
	   * @returns {Promise} A resolved promise that supplies the column.
	   */
	
	  Grid.prototype.sortColumn = function sortColumn(column, directionOrAdd, add) {
	    var self = this,
	        direction = null;
	
	    if (typeof(column) === 'undefined' || !column) {
	      throw new Error('No column parameter provided');
	    }
	
	    // Second argument can either be a direction or whether to add this column to the existing sort.
	    //   If it's a boolean, it's an add, otherwise, it's a direction
	    if (typeof(directionOrAdd) === 'boolean') {
	      add = directionOrAdd;
	    }
	    else {
	      direction = directionOrAdd;
	    }
	
	    if (!add || (self.options && self.options.suppressMultiSort)) {
	      self.resetColumnSorting(column);
	      column.sort.priority = undefined;
	      // Get the actual priority since there may be columns which have suppressRemoveSort set
	      column.sort.priority = self.getNextColumnSortPriority();
	    }
	    else if (column.sort.priority === undefined) {
	      column.sort.priority = self.getNextColumnSortPriority();
	    }
	
	    if (!direction) {
	      // Find the current position in the cycle (or -1).
	      var i = column.sortDirectionCycle.indexOf(column.sort && column.sort.direction ? column.sort.direction : null);
	      // Proceed to the next position in the cycle (or start at the beginning).
	      i = (i+1) % column.sortDirectionCycle.length;
	      // If suppressRemoveSort is set, and the next position in the cycle would
	      // remove the sort, skip it.
	      if (column.colDef && column.suppressRemoveSort && !column.sortDirectionCycle[i]) {
	        i = (i+1) % column.sortDirectionCycle.length;
	      }
	
	      if (column.sortDirectionCycle[i]) {
	        column.sort.direction = column.sortDirectionCycle[i];
	      } else {
	        removeSortOfColumn(column, self);
	      }
	    }
	    else {
	      column.sort.direction = direction;
	    }
	
	    self.api.core.raise.sortChanged( self, self.getColumnSorting() );
	
	    return $q.when(column);
	  };
	
	  var removeSortOfColumn = function removeSortOfColumn(column, grid) {
	    // Decrease priority for every col where priority is higher than the removed sort's priority.
	    grid.columns.forEach(function (col) {
	      if (col.sort && col.sort.priority !== undefined && col.sort.priority > column.sort.priority) {
	        col.sort.priority -= 1;
	      }
	    });
	
	    // Remove sort
	    column.sort = {};
	  };
	
	  /**
	   * communicate to outside world that we are done with initial rendering
	   */
	  Grid.prototype.renderingComplete = function() {
	    if (angular.isFunction(this.options.onRegisterApi)) {
	      this.options.onRegisterApi(this.api);
	    }
	    this.api.core.raise.renderingComplete( this.api );
	  };
	
	  Grid.prototype.createRowHashMap = function createRowHashMap() {
	    var self = this;
	
	    var hashMap = new RowHashMap();
	    hashMap.grid = self;
	
	    return hashMap;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name refresh
	   * @methodOf ui.grid.class:Grid
	   * @description Refresh the rendered grid on screen.
	   * @param {boolean} [rowsAltered] Optional flag for refreshing when the number of rows has changed.
	   */
	  Grid.prototype.refresh = function refresh(rowsAltered) {
	    var self = this;
	
	    var p1 = self.processRowsProcessors(self.rows).then(function (renderableRows) {
	      self.setVisibleRows(renderableRows);
	    }).catch(angular.noop);
	
	    var p2 = self.processColumnsProcessors(self.columns).then(function (renderableColumns) {
	      self.setVisibleColumns(renderableColumns);
	    }).catch(angular.noop);
	
	    return $q.all([p1, p2]).then(function () {
	      self.refreshCanvas(true);
	      self.redrawInPlace(rowsAltered);
	    }).catch(angular.noop);
	  };
	
	  /**
	   * @ngdoc function
	   * @name refreshRows
	   * @methodOf ui.grid.class:Grid
	   * @description Refresh the rendered rows on screen?  Note: not functional at present
	   * @returns {promise} promise that is resolved when render completes?
	   *
	   */
	  Grid.prototype.refreshRows = function refreshRows() {
	    var self = this;
	
	    return self.processRowsProcessors(self.rows)
	      .then(function (renderableRows) {
	        self.setVisibleRows(renderableRows);
	
	        self.redrawInPlace();
	
	        self.refreshCanvas( true );
	      }).catch(angular.noop);
	  };
	
	  /**
	   * @ngdoc function
	   * @name refreshCanvas
	   * @methodOf ui.grid.class:Grid
	   * @description Builds all styles and recalculates much of the grid sizing
	   * @param {object} buildStyles optional parameter.  Use TBD
	   * @returns {promise} promise that is resolved when the canvas
	   * has been refreshed
	   *
	   */
	  Grid.prototype.refreshCanvas = function(buildStyles) {
	    var self = this;
	
	    // gridUtil.logDebug('refreshCanvas');
	
	    var p = $q.defer();
	
	    // Get all the header heights
	    var containerHeadersToRecalc = [];
	    for (var containerId in self.renderContainers) {
	      if (self.renderContainers.hasOwnProperty(containerId)) {
	        var container = self.renderContainers[containerId];
	
	        // Skip containers that have no canvasWidth set yet
	        if (container.canvasWidth === null || isNaN(container.canvasWidth)) {
	          continue;
	        }
	
	        if (container.header || container.headerCanvas) {
	          container.explicitHeaderHeight = container.explicitHeaderHeight || null;
	          container.explicitHeaderCanvasHeight = container.explicitHeaderCanvasHeight || null;
	
	          containerHeadersToRecalc.push(container);
	        }
	      }
	    }
	
	    // Build the styles without the explicit header heights
	    if (buildStyles) {
	      self.buildStyles();
	    }
	
	    /*
	     *
	     * Here we loop through the headers, measuring each element as well as any header "canvas" it has within it.
	     *
	     * If any header is less than the largest header height, it will be resized to that so that we don't have headers
	     * with different heights, which looks like a rendering problem
	     *
	     * We'll do the same thing with the header canvases, and give the header CELLS an explicit height if their canvas
	     * is smaller than the largest canvas height. That was header cells without extra controls like filtering don't
	     * appear shorter than other cells.
	     *
	     */
	    if (containerHeadersToRecalc.length > 0) {
	      // Putting in a timeout as it's not calculating after the grid element is rendered and filled out
	      $timeout(function() {
	        // var oldHeaderHeight = self.grid.headerHeight;
	        // self.grid.headerHeight = gridUtil.outerElementHeight(self.header);
	
	        var rebuildStyles = false;
	
	        // Get all the header heights
	        var maxHeaderHeight = 0;
	        var maxHeaderCanvasHeight = 0;
	        var i, container;
	        var getHeight = function(oldVal, newVal) {
	          if ( oldVal !== newVal) {
	            rebuildStyles = true;
	          }
	          return newVal;
	        };
	        for (i = 0; i < containerHeadersToRecalc.length; i++) {
	          container = containerHeadersToRecalc[i];
	
	          // Skip containers that have no canvasWidth set yet
	          if (container.canvasWidth === null || isNaN(container.canvasWidth)) {
	            continue;
	          }
	
	          if (container.header) {
	            var headerHeight = container.headerHeight = getHeight(container.headerHeight, gridUtil.outerElementHeight(container.header));
	
	            // Get the "inner" header height, that is the height minus the top and bottom borders, if present. We'll use it to make sure all the headers have a consistent height
	            var topBorder = gridUtil.getBorderSize(container.header, 'top');
	            var bottomBorder = gridUtil.getBorderSize(container.header, 'bottom');
	            var innerHeaderHeight = parseInt(headerHeight - topBorder - bottomBorder, 10);
	
	            innerHeaderHeight  = innerHeaderHeight < 0 ? 0 : innerHeaderHeight;
	
	            container.innerHeaderHeight = innerHeaderHeight;
	
	            // If the header doesn't have an explicit height set, save the largest header height for use later
	            //   Explicit header heights are based off of the max we are calculating here. We never want to base the max on something we're setting explicitly
	            if (!container.explicitHeaderHeight && innerHeaderHeight > maxHeaderHeight) {
	              maxHeaderHeight = innerHeaderHeight;
	            }
	          }
	
	          if (container.headerCanvas) {
	            var headerCanvasHeight = container.headerCanvasHeight = getHeight(container.headerCanvasHeight, parseInt(gridUtil.outerElementHeight(container.headerCanvas), 10));
	
	
	            // If the header doesn't have an explicit canvas height, save the largest header canvas height for use later
	            //   Explicit header heights are based off of the max we are calculating here. We never want to base the max on something we're setting explicitly
	            if (!container.explicitHeaderCanvasHeight && headerCanvasHeight > maxHeaderCanvasHeight) {
	              maxHeaderCanvasHeight = headerCanvasHeight;
	            }
	          }
	        }
	
	        // Go through all the headers
	        for (i = 0; i < containerHeadersToRecalc.length; i++) {
	          container = containerHeadersToRecalc[i];
	
	          /* If:
	              1. We have a max header height
	              2. This container has a header height defined
	              3. And either this container has an explicit header height set, OR its header height is less than the max
	
	              then:
	
	              Give this container's header an explicit height so it will line up with the tallest header
	          */
	          if (
	            maxHeaderHeight > 0 && typeof(container.headerHeight) !== 'undefined' && container.headerHeight !== null &&
	            (container.explicitHeaderHeight || container.headerHeight < maxHeaderHeight)
	          ) {
	            container.explicitHeaderHeight = getHeight(container.explicitHeaderHeight, maxHeaderHeight);
	          }
	
	          // Do the same as above except for the header canvas
	          if (
	            maxHeaderCanvasHeight > 0 && typeof(container.headerCanvasHeight) !== 'undefined' && container.headerCanvasHeight !== null &&
	            (container.explicitHeaderCanvasHeight || container.headerCanvasHeight < maxHeaderCanvasHeight)
	          ) {
	            container.explicitHeaderCanvasHeight = getHeight(container.explicitHeaderCanvasHeight, maxHeaderCanvasHeight);
	          }
	        }
	
	        // Rebuild styles if the header height has changed
	        //   The header height is used in body/viewport calculations and those are then used in other styles so we need it to be available
	        if (buildStyles && rebuildStyles) {
	          self.buildStyles();
	        }
	
	        p.resolve();
	      });
	    }
	    else {
	      // Timeout still needs to be here to trigger digest after styles have been rebuilt
	      $timeout(function() {
	        p.resolve();
	      });
	    }
	
	    return p.promise;
	  };
	
	  function getPrevScrollValue(rowsAdded, prevScrollVal) {
	    return rowsAdded || prevScrollVal > 0 ? prevScrollVal : null;
	  }
	
	  /**
	   * @ngdoc function
	   * @name redrawInPlace
	   * @methodOf ui.grid.class:Grid
	   * @description Redraw the rows and columns based on our current scroll position
	   * @param {boolean} [rowsAdded] Optional to indicate rows are added and the scroll percentage must be recalculated
	   *
	   */
	  Grid.prototype.redrawInPlace = function redrawInPlace(rowsAdded) {
	    // gridUtil.logDebug('redrawInPlace');
	
	    var self = this;
	
	    for (var i in self.renderContainers) {
	      var container = self.renderContainers[i],
	        prevScrollTop = getPrevScrollValue(rowsAdded, container.prevScrollTop),
	        prevScrollLeft = getPrevScrollValue(rowsAdded, container.prevScrollLeft),
	        prevScrolltopPercentage = rowsAdded || prevScrollTop > 0 ? null : container.prevScrolltopPercentage;
	
	      // gridUtil.logDebug('redrawing container', i);
	
	      container.adjustRows(prevScrollTop, prevScrolltopPercentage);
	      container.adjustColumns(prevScrollLeft);
	    }
	  };
	
	    /**
	     * @ngdoc function
	     * @name hasLeftContainerColumns
	     * @methodOf ui.grid.class:Grid
	     * @description returns true if leftContainer has columns
	     */
	    Grid.prototype.hasLeftContainerColumns = function () {
	      return this.hasLeftContainer() && this.renderContainers.left.renderedColumns.length > 0;
	    };
	
	    /**
	     * @ngdoc function
	     * @name hasRightContainerColumns
	     * @methodOf ui.grid.class:Grid
	     * @description returns true if rightContainer has columns
	     */
	    Grid.prototype.hasRightContainerColumns = function () {
	      return this.hasRightContainer() && this.renderContainers.right.renderedColumns.length > 0;
	    };
	
	    // Turn the scroll position into a percentage and make it an argument for a scroll event
	    function getScrollPercentage(scrollPixels, scrollLength) {
	      var percentage = scrollPixels / scrollLength;
	
	      // if the percentage is greater than 1, set it to 1
	      return percentage <= 1 ? percentage : 1;
	    }
	
	    // Only returns the scroll Y position if the percentage is different from the previous
	    function getScrollY(scrollPixels, scrollLength, prevScrolltopPercentage) {
	      var scrollPercentage = getScrollPercentage(scrollPixels, scrollLength);
	
	      if (scrollPercentage !== prevScrolltopPercentage) {
	        return { percentage: getScrollPercentage(scrollPixels, scrollLength) };
	      }
	
	      return undefined;
	    }
	
	    // Only returns the scroll X position if the percentage is different from the previous
	    function getScrollX(horizScrollPixels, horizScrollLength, prevScrollleftPercentage) {
	      var horizPercentage = horizScrollPixels / horizScrollLength;
	      horizPercentage = (horizPercentage > 1) ? 1 : horizPercentage;
	
	      if (horizPercentage !== prevScrollleftPercentage) {
	        return { percentage: horizPercentage  };
	      }
	
	      return undefined;
	    }
	
	    /**
	     * @ngdoc method
	     * @methodOf  ui.grid.class:Grid
	     * @name scrollToIfNecessary
	     * @description Scrolls the grid to make a certain row and column combo visible,
	     *   in the case that it is not completely visible on the screen already.
	     * @param {GridRow} gridRow row to make visible
	     * @param {GridColumn} gridCol column to make visible
	     * @returns {promise} a promise that is resolved when scrolling is complete
	     */
	    Grid.prototype.scrollToIfNecessary = function (gridRow, gridCol) {
	      var self = this;
	
	      var scrollEvent = new ScrollEvent(self, 'uiGrid.scrollToIfNecessary');
	
	      // Alias the visible row and column caches
	      var visRowCache = self.renderContainers.body.visibleRowCache;
	      var visColCache = self.renderContainers.body.visibleColumnCache;
	
	      /*-- Get the top, left, right, and bottom "scrolled" edges of the grid --*/
	
	      // The top boundary is the current Y scroll position
	      var topBound = self.renderContainers.body.prevScrollTop;
	
	      // Don't the let top boundary be less than 0
	      topBound = (topBound < 0) ? 0 : topBound;
	
	      // The left boundary is the current X scroll position
	      var leftBound = self.renderContainers.body.prevScrollLeft;
	
	      // The bottom boundary is the current Y scroll position, plus the height of the grid, but minus the header height.
	      //   Basically this is the viewport height added on to the scroll position
	      var bottomBound = self.renderContainers.body.prevScrollTop + self.gridHeight - self.renderContainers.body.headerHeight - self.footerHeight -  self.scrollbarHeight;
	
	      // If there's a horizontal scrollbar, remove its height from the bottom boundary, otherwise we'll be letting it obscure rows
	      // if (self.horizontalScrollbarHeight) {
	      //   bottomBound = bottomBound - self.horizontalScrollbarHeight;
	      // }
	
	      // The right position is the current X scroll position minus the grid width
	      var rightBound = self.renderContainers.body.prevScrollLeft + Math.ceil(self.renderContainers.body.getViewportWidth());
	
	      // If there's a vertical scrollbar, subtract it from the right boundary or we'll allow it to obscure cells
	      // if (self.verticalScrollbarWidth) {
	      //   rightBound = rightBound - self.verticalScrollbarWidth;
	      // }
	
	      // We were given a row to scroll to
	      if (gridRow !== null) {
	        // This is the index of the row we want to scroll to, within the list of rows that can be visible
	        var seekRowIndex = visRowCache.indexOf(gridRow);
	
	        // Total vertical scroll length of the grid
	        var scrollLength = (self.renderContainers.body.getCanvasHeight() - self.renderContainers.body.getViewportHeight());
	
	        // Add the height of the native horizontal scrollbar to the scroll length, if it's there. Otherwise it will mask over the final row
	        // if (self.horizontalScrollbarHeight && self.horizontalScrollbarHeight > 0) {
	        //   scrollLength = scrollLength + self.horizontalScrollbarHeight;
	        // }
	
	        // This is the minimum amount of pixels we need to scroll vertical in order to see this row.
	        var pixelsToSeeRow = (seekRowIndex * self.options.rowHeight);
	
	        // Don't let the pixels required to see the row be less than zero
	        pixelsToSeeRow = (pixelsToSeeRow < 0) ? 0 : pixelsToSeeRow;
	
	        var scrollPixels;
	
	        // If the scroll position we need to see the row is LESS than the top boundary, i.e. obscured above the top of the self...
	        if (pixelsToSeeRow < Math.floor(topBound)) {
	          // Get the different between the top boundary and the required scroll position and subtract it from the current scroll position\
	          //   to get the full position we need
	          scrollPixels = self.renderContainers.body.prevScrollTop - (topBound - pixelsToSeeRow);
	
	          // Since scrollIfNecessary is called multiple times when enableCellEditOnFocus is true we need to make sure the scrollbarWidth and
	          // footerHeight is accounted for to not cause a loop.
	          if (gridCol && gridCol.colDef && gridCol.colDef.enableCellEditOnFocus) {
	            scrollPixels = scrollPixels - self.footerHeight - self.scrollbarHeight;
	          }
	
	          scrollEvent.y = getScrollY(scrollPixels, scrollLength, self.renderContainers.body.prevScrolltopPercentage);
	        }
	        // Otherwise if the scroll position we need to see the row is MORE than the bottom boundary, i.e. obscured below the bottom of the self...
	        else if (pixelsToSeeRow > Math.ceil(bottomBound)) {
	          // Get the different between the bottom boundary and the required scroll position and add it to the current scroll position
	          //   to get the full position we need
	          scrollPixels = pixelsToSeeRow - bottomBound + self.renderContainers.body.prevScrollTop;
	
	          // Scroll to full position plus the height of one row since scrollPixels points to the top pixel of the row
	          scrollEvent.y = getScrollY(scrollPixels + self.options.rowHeight, scrollLength, self.renderContainers.body.prevScrolltopPercentage);
	        }
	      }
	
	      // We were given a column to scroll to
	      if (gridCol !== null) {
	        // This is the index of the column we want to scroll to, within the list of columns that can be visible
	        var seekColumnIndex = visColCache.indexOf(gridCol);
	
	        // Total horizontal scroll length of the grid
	        var horizScrollLength = (self.renderContainers.body.getCanvasWidth() - self.renderContainers.body.getViewportWidth());
	
	        // This is the minimum amount of pixels we need to scroll horizontal in order to see this column
	        var columnLeftEdge = 0;
	        for (var i = 0; i < seekColumnIndex; i++) {
	          var col = visColCache[i];
	          columnLeftEdge += col.drawnWidth;
	        }
	        columnLeftEdge = (columnLeftEdge < 0) ? 0 : columnLeftEdge;
	
	        var columnRightEdge = columnLeftEdge + gridCol.drawnWidth;
	
	        // Don't let the pixels required to see the column be less than zero
	        columnRightEdge = (columnRightEdge < 0) ? 0 : columnRightEdge;
	
	        var horizScrollPixels;
	
	        // If the scroll position we need to see the column is LESS than the left boundary, i.e. obscured before the left of the self...
	        if (columnLeftEdge < leftBound) {
	          // Get the different between the left boundary and the required scroll position and subtract it from the current scroll position\
	          //   to get the full position we need
	          horizScrollPixels = self.renderContainers.body.prevScrollLeft - (leftBound - columnLeftEdge);
	
	          // Turn the scroll position into a percentage and make it an argument for a scroll event
	          scrollEvent.x = getScrollX(horizScrollPixels, horizScrollLength, self.renderContainers.body.prevScrollleftPercentage);
	        }
	        // Otherwise if the scroll position we need to see the column is MORE than the right boundary, i.e. obscured after the right of the self...
	        else if (columnRightEdge > rightBound) {
	          // Get the different between the right boundary and the required scroll position and add it to the current scroll position
	          //   to get the full position we need
	          horizScrollPixels = columnRightEdge - rightBound + self.renderContainers.body.prevScrollLeft;
	
	          // Turn the scroll position into a percentage and make it an argument for a scroll event
	          scrollEvent.x = getScrollX(horizScrollPixels, horizScrollLength, self.renderContainers.body.prevScrollleftPercentage);
	        }
	      }
	
	      var deferred = $q.defer();
	
	      // If we need to scroll on either the x or y axes, fire a scroll event
	      if (scrollEvent.y || scrollEvent.x) {
	        scrollEvent.withDelay = false;
	        self.scrollContainers('',scrollEvent);
	        var dereg = self.api.core.on.scrollEnd(null,function() {
	          deferred.resolve(scrollEvent);
	          dereg();
	        });
	      }
	      else {
	        deferred.resolve();
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.class:Grid
	     * @name scrollTo
	     * @description Scroll the grid such that the specified
	     * row and column is in view
	     * @param {object} rowEntity gridOptions.data[] array instance to make visible
	     * @param {object} colDef to make visible
	     * @returns {promise} a promise that is resolved after any scrolling is finished
	     */
	    Grid.prototype.scrollTo = function (rowEntity, colDef) {
	      var gridRow = null, gridCol = null;
	
	      if (rowEntity !== null && typeof(rowEntity) !== 'undefined' ) {
	        gridRow = this.getRow(rowEntity);
	      }
	
	      if (colDef !== null && typeof(colDef) !== 'undefined' ) {
	        gridCol = this.getColumn(colDef.name ? colDef.name : colDef.field);
	      }
	      return this.scrollToIfNecessary(gridRow, gridCol);
	    };
	
	  /**
	   * @ngdoc function
	   * @name clearAllFilters
	   * @methodOf ui.grid.class:Grid
	   * @description Clears all filters and optionally refreshes the visible rows.
	   * @param {object} refreshRows Defaults to true.
	   * @param {object} clearConditions Defaults to false.
	   * @param {object} clearFlags Defaults to false.
	   * @returns {promise} If `refreshRows` is true, returns a promise of the rows refreshing.
	   */
	  Grid.prototype.clearAllFilters = function clearAllFilters(refreshRows, clearConditions, clearFlags) {
	    // Default `refreshRows` to true because it will be the most commonly desired behaviour.
	    if (refreshRows === undefined) {
	      refreshRows = true;
	    }
	    if (clearConditions === undefined) {
	      clearConditions = false;
	    }
	    if (clearFlags === undefined) {
	      clearFlags = false;
	    }
	
	    this.columns.forEach(function(column) {
	      column.filters.forEach(function(filter) {
	        filter.term = undefined;
	
	        if (clearConditions) {
	          filter.condition = undefined;
	        }
	
	        if (clearFlags) {
	          filter.flags = undefined;
	        }
	      });
	    });
	
	    if (refreshRows) {
	      return this.refreshRows();
	    }
	  };
	
	
	      // Blatantly stolen from Angular as it isn't exposed (yet? 2.0?)
	  function RowHashMap() {}
	
	  RowHashMap.prototype = {
	    /**
	     * Store key value pair
	     * @param key key to store can be any type
	     * @param value value to store can be any type
	     */
	    put: function(key, value) {
	      this[this.grid.options.rowIdentity(key)] = value;
	    },
	
	    /**
	     * @param key
	     * @returns {Object} the value for the key
	     */
	    get: function(key) {
	      return this[this.grid.options.rowIdentity(key)];
	    },
	
	    /**
	     * Remove the key/value pair
	     * @param key
	     */
	    remove: function(key) {
	      var value = this[key = this.grid.options.rowIdentity(key)];
	      delete this[key];
	      return value;
	    }
	  };
	
	  return Grid;
	}]);
	})();
	
	(function () {
	
	  angular.module('ui.grid')
	    .factory('GridApi', ['$q', '$rootScope', 'gridUtil', 'uiGridConstants', 'GridRow',
	      function ($q, $rootScope, gridUtil, uiGridConstants, GridRow) {
	        /**
	         * @ngdoc function
	         * @name ui.grid.class:GridApi
	         * @description GridApi provides the ability to register public methods events inside the grid and allow
	         * for other components to use the api via featureName.raise.methodName and featureName.on.eventName(function(args) {}.
	         * <br/>
	         * To listen to events, you must add a callback to gridOptions.onRegisterApi
	         * <pre>
	         *   $scope.gridOptions.onRegisterApi = function(gridApi) {
	         *      gridApi.cellNav.on.navigate($scope,function(newRowCol, oldRowCol) {
	         *          $log.log('navigation event');
	         *      });
	         *   };
	         * </pre>
	         * @param {object} grid grid that owns api
	         */
	        var GridApi = function GridApi(grid) {
	          this.grid = grid;
	          this.listeners = [];
	
	          /**
	           * @ngdoc function
	           * @name renderingComplete
	           * @methodOf  ui.grid.api:PublicApi
	           * @description Rendering is complete, called at the same
	           * time as `onRegisterApi`, but provides a way to obtain
	           * that same event within features without stopping end
	           * users from getting at the onRegisterApi method.
	           *
	           * Included in gridApi so that it's always there - otherwise
	           * there is still a timing problem with when a feature can
	           * call this.
	           *
	           * @param {GridApi} gridApi the grid api, as normally
	           * returned in the onRegisterApi method
	           *
	           * @example
	           * <pre>
	           *      gridApi.core.on.renderingComplete( grid );
	           * </pre>
	           */
	          this.registerEvent( 'core', 'renderingComplete' );
	
	          /**
	           * @ngdoc event
	           * @name filterChanged
	           * @eventOf  ui.grid.api:PublicApi
	           * @description  is raised after the filter is changed.  The nature
	           * of the watch expression doesn't allow notification of what changed,
	           * so the receiver of this event will need to re-extract the filter
	           * conditions from the columns.
	           *
	           */
	          this.registerEvent( 'core', 'filterChanged' );
	
	          /**
	           * @ngdoc function
	           * @name setRowInvisible
	           * @methodOf  ui.grid.api:PublicApi
	           * @description Sets an override on the row to make it always invisible,
	           * which will override any filtering or other visibility calculations.
	           * If the row is currently visible then sets it to invisible and calls
	           * both grid refresh and emits the rowsVisibleChanged event
	           * @param {GridRow} row the row we want to make invisible
	           */
	          this.registerMethod( 'core', 'setRowInvisible', GridRow.prototype.setRowInvisible );
	
	          /**
	           * @ngdoc function
	           * @name clearRowInvisible
	           * @methodOf  ui.grid.api:PublicApi
	           * @description Clears any override on visibility for the row so that it returns to
	           * using normal filtering and other visibility calculations.
	           * If the row is currently invisible then sets it to visible and calls
	           * both grid refresh and emits the rowsVisibleChanged event
	           * TODO: if a filter is active then we can't just set it to visible?
	           * @param {GridRow} row the row we want to make visible
	           */
	          this.registerMethod( 'core', 'clearRowInvisible', GridRow.prototype.clearRowInvisible );
	
	          /**
	           * @ngdoc function
	           * @name getVisibleRows
	           * @methodOf  ui.grid.api:PublicApi
	           * @description Returns all visible rows
	           * @param {Grid} grid the grid you want to get visible rows from
	           * @returns {array} an array of gridRow
	           */
	          this.registerMethod( 'core', 'getVisibleRows', this.grid.getVisibleRows );
	
	          /**
	           * @ngdoc event
	           * @name rowsVisibleChanged
	           * @eventOf  ui.grid.api:PublicApi
	           * @description  is raised after the rows that are visible
	           * change.  The filtering is zero-based, so it isn't possible
	           * to say which rows changed (unlike in the selection feature).
	           * We can plausibly know which row was changed when setRowInvisible
	           * is called, but in that situation the user already knows which row
	           * they changed.  When a filter runs we don't know what changed,
	           * and that is the one that would have been useful.
	           *
	           */
	          this.registerEvent( 'core', 'rowsVisibleChanged' );
	
	          /**
	           * @ngdoc event
	           * @name rowsRendered
	           * @eventOf  ui.grid.api:PublicApi
	           * @description  is raised after the cache of visible rows is changed.
	           */
	          this.registerEvent( 'core', 'rowsRendered' );
	
	
	          /**
	           * @ngdoc event
	           * @name scrollBegin
	           * @eventOf  ui.grid.api:PublicApi
	           * @description  is raised when scroll begins.  Is throttled, so won't be raised too frequently
	           */
	          this.registerEvent( 'core', 'scrollBegin' );
	
	          /**
	           * @ngdoc event
	           * @name scrollEnd
	           * @eventOf  ui.grid.api:PublicApi
	           * @description  is raised when scroll has finished.  Is throttled, so won't be raised too frequently
	           */
	          this.registerEvent( 'core', 'scrollEnd' );
	
	          /**
	           * @ngdoc event
	           * @name canvasHeightChanged
	           * @eventOf  ui.grid.api:PublicApi
	           * @description  is raised when the canvas height has changed
	           * <br/>
	           * arguments: oldHeight, newHeight
	           */
	          this.registerEvent( 'core', 'canvasHeightChanged');
	
	          /**
	           * @ngdoc event
	           * @name gridDimensionChanged
	           * @eventOf  ui.grid.api:PublicApi
	           * @description  is raised when the grid dimensions have changed (when autoResize is on)
	           * <br/>
	           * arguments: oldGridHeight, oldGridWidth, newGridHeight, newGridWidth
	           */
	          this.registerEvent( 'core', 'gridDimensionChanged');
	        };
	
	        /**
	         * @ngdoc function
	         * @name ui.grid.class:suppressEvents
	         * @methodOf ui.grid.class:GridApi
	         * @description Used to execute a function while disabling the specified event listeners.
	         * Disables the listenerFunctions, executes the callbackFn, and then enables
	         * the listenerFunctions again
	         * @param {object} listenerFuncs listenerFunc or array of listenerFuncs to suppress. These must be the same
	         * functions that were used in the .on.eventName method
	         * @param {object} callBackFn function to execute
	         * @example
	         * <pre>
	         *    var navigate = function (newRowCol, oldRowCol) {
	         *       //do something on navigate
	         *    }
	         *
	         *    gridApi.cellNav.on.navigate(scope,navigate);
	         *
	         *
	         *    //call the scrollTo event and suppress our navigate listener
	         *    //scrollTo will still raise the event for other listeners
	         *    gridApi.suppressEvents(navigate, function() {
	         *       gridApi.cellNav.scrollTo(aRow, aCol);
	         *    });
	         *
	         * </pre>
	         */
	        GridApi.prototype.suppressEvents = function (listenerFuncs, callBackFn) {
	          var self = this,
	            listeners = angular.isArray(listenerFuncs) ? listenerFuncs : [listenerFuncs];
	
	          // find all registered listeners
	          var foundListeners = self.listeners.filter(function(listener) {
	            return listeners.some(function(l) {
	              return listener.handler === l;
	            });
	          });
	
	          // deregister all the listeners
	          foundListeners.forEach(function(l) {
	            l.dereg();
	          });
	
	          callBackFn();
	
	          // reregister all the listeners
	          foundListeners.forEach(function(l) {
	              l.dereg = registerEventWithAngular(l.eventId, l.handler, self.grid, l._this);
	          });
	        };
	
	        /**
	         * @ngdoc function
	         * @name registerEvent
	         * @methodOf ui.grid.class:GridApi
	         * @description Registers a new event for the given feature.  The event will get a
	         * .raise and .on prepended to it
	         * <br>
	         * .raise.eventName() - takes no arguments
	         * <br/>
	         * <br/>
	         * .on.eventName(scope, callBackFn, _this)
	         * <br/>
	         * scope - a scope reference to add a deregister call to the scopes .$on('destroy').  Scope is optional and can be a null value,
	         * but in this case you must deregister it yourself via the returned deregister function
	         * <br/>
	         * callBackFn - The function to call
	         * <br/>
	         * _this - optional this context variable for callbackFn. If omitted, grid.api will be used for the context
	         * <br/>
	         * .on.eventName returns a dereg funtion that will remove the listener.  It's not necessary to use it as the listener
	         * will be removed when the scope is destroyed.
	         * @param {string} featureName name of the feature that raises the event
	         * @param {string} eventName  name of the event
	         */
	        GridApi.prototype.registerEvent = function (featureName, eventName) {
	          var self = this;
	          if (!self[featureName]) {
	            self[featureName] = {};
	          }
	
	          var feature = self[featureName];
	          if (!feature.on) {
	            feature.on = {};
	            feature.raise = {};
	          }
	
	          var eventId = self.grid.id + featureName + eventName;
	
	          // gridUtil.logDebug('Creating raise event method ' + featureName + '.raise.' + eventName);
	          feature.raise[eventName] = function () {
	            $rootScope.$emit.apply($rootScope, [eventId].concat(Array.prototype.slice.call(arguments)));
	          };
	
	          // gridUtil.logDebug('Creating on event method ' + featureName + '.on.' + eventName);
	          feature.on[eventName] = function (scope, handler, _this) {
	            if ( scope !== null && typeof(scope.$on) === 'undefined' ) {
	              gridUtil.logError('asked to listen on ' + featureName + '.on.' + eventName + ' but scope wasn\'t passed in the input parameters.  It is legitimate to pass null, but you\'ve passed something else, so you probably forgot to provide scope rather than did it deliberately, not registering');
	              return;
	            }
	            var deregAngularOn = registerEventWithAngular(eventId, handler, self.grid, _this);
	
	            // track our listener so we can turn off and on
	            var listener = {handler: handler, dereg: deregAngularOn, eventId: eventId, scope: scope, _this: _this};
	
	            self.listeners.push(listener);
	
	            var removeListener = function() {
	              listener.dereg();
	              var index = self.listeners.indexOf(listener);
	              self.listeners.splice(index,1);
	            };
	
	            // destroy tracking when scope is destroyed
	            if (scope) {
	              scope.$on('$destroy', function() {
	                removeListener();
	              });
	            }
	
	            return removeListener;
	          };
	        };
	
	        function registerEventWithAngular(eventId, handler, grid, _this) {
	          return $rootScope.$on(eventId, function (event) {
	            var args = Array.prototype.slice.call(arguments);
	            args.splice(0, 1); // remove evt argument
	            handler.apply(_this ? _this : grid.api, args);
	          });
	        }
	
	        /**
	         * @ngdoc function
	         * @name registerEventsFromObject
	         * @methodOf ui.grid.class:GridApi
	         * @description Registers features and events from a simple objectMap.
	         * eventObjectMap must be in this format (multiple features allowed)
	         * <pre>
	         * {featureName:
	         *        {
	         *          eventNameOne:function(args) {},
	         *          eventNameTwo:function(args) {}
	         *        }
	         *  }
	         * </pre>
	         * @param {object} eventObjectMap map of feature/event names
	         */
	        GridApi.prototype.registerEventsFromObject = function (eventObjectMap) {
	          var self = this,
	            features = [];
	
	          angular.forEach(eventObjectMap, function (featProp, featPropName) {
	            var feature = {name: featPropName, events: []};
	            angular.forEach(featProp, function (prop, propName) {
	              feature.events.push(propName);
	            });
	            features.push(feature);
	          });
	
	          features.forEach(function (feature) {
	            feature.events.forEach(function (event) {
	              self.registerEvent(feature.name, event);
	            });
	          });
	        };
	
	        /**
	         * @ngdoc function
	         * @name registerMethod
	         * @methodOf ui.grid.class:GridApi
	         * @description Registers a new event for the given feature
	         * @param {string} featureName name of the feature
	         * @param {string} methodName  name of the method
	         * @param {object} callBackFn function to execute
	         * @param {object} _this binds callBackFn 'this' to _this.  Defaults to gridApi.grid
	         */
	        GridApi.prototype.registerMethod = function (featureName, methodName, callBackFn, _this) {
	          if (!this[featureName]) {
	            this[featureName] = {};
	          }
	
	          var feature = this[featureName];
	
	          feature[methodName] = gridUtil.createBoundedWrapper(_this || this.grid, callBackFn);
	        };
	
	        /**
	         * @ngdoc function
	         * @name registerMethodsFromObject
	         * @methodOf ui.grid.class:GridApi
	         * @description Registers features and methods from a simple objectMap.
	         * eventObjectMap must be in this format (multiple features allowed)
	         * <br>
	         * {featureName:
	         *        {
	         *          methodNameOne:function(args) {},
	         *          methodNameTwo:function(args) {}
	         *        }
	         * @param {object} methodMap map of feature/event names
	         * @param {object} _this binds this to _this for all functions.  Defaults to gridApi.grid
	         */
	        GridApi.prototype.registerMethodsFromObject = function (methodMap, _this) {
	          var self = this;
	          var features = [];
	          angular.forEach(methodMap, function (featProp, featPropName) {
	            var feature = {name: featPropName, methods: []};
	            angular.forEach(featProp, function (prop, propName) {
	              feature.methods.push({name: propName, fn: prop});
	            });
	            features.push(feature);
	          });
	
	          features.forEach(function (feature) {
	            feature.methods.forEach(function (method) {
	              self.registerMethod(feature.name, method.name, method.fn, _this);
	            });
	          });
	
	        };
	
	        return GridApi;
	      }]);
	})();
	
	(function() {
	
	angular.module('ui.grid')
	.factory('GridColumn', ['gridUtil', 'uiGridConstants', 'i18nService', function(gridUtil, uiGridConstants, i18nService) {
	
	  /**
	   * ******************************************************************************************
	   * PaulL1: Ugly hack here in documentation.  These properties are clearly properties of GridColumn,
	   * and need to be noted as such for those extending and building ui-grid itself.
	   * However, from an end-developer perspective, they interact with all these through columnDefs,
	   * and they really need to be documented there.  I feel like they're relatively static, and
	   * I can't find an elegant way for ngDoc to reference to both....so I've duplicated each
	   * comment block.  Ugh.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name name
	   * @propertyOf ui.grid.class:GridColumn
	   * @description (mandatory) Each column should have a name, although for backward
	   * compatibility with 2.x name can be omitted if field is present.
	   *
	   * Important - This must be unique to each column on a web page since it can
	   * be used as a key for retrieving information such as custom sort algorithms.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name name
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description (mandatory) Each column should have a name, although for backward
	   * compatibility with 2.x name can be omitted if field is present.
	   *
	   * Important - This must be unique to each column on a web page since it can
	   * be used as a key for retrieving information such as custom sort algorithms.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name displayName
	   * @propertyOf ui.grid.class:GridColumn
	   * @description Column name that will be shown in the header. If displayName is not
	   * provided then one is generated using the name.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name displayName
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description Column name that will be shown in the header. If displayName is not
	   * provided then one is generated using the name.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name field
	   * @propertyOf ui.grid.class:GridColumn
	   * @description field must be provided if you wish to bind to a
	   * property in the data source.  Should be an angular expression that evaluates against grid.options.data
	   * array element.  Can be a complex expression: <code>employee.address.city</code>, or can be a function: <code>employee.getFullAddress()</code>.
	   * See the angular docs on binding expressions.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name field
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description field must be provided if you wish to bind to a
	   * property in the data source.  Should be an angular expression that evaluates against grid.options.data
	   * array element.  Can be a complex expression: <code>employee.address.city</code>, or can be a function: <code>employee.getFullAddress()</code>.    * See the angular docs on binding expressions.    *
	   */
	
	  /**
	   * @ngdoc property
	   * @name filter
	   * @propertyOf ui.grid.class:GridColumn
	   * @description Filter on this column.
	   *
	   * Available built-in conditions and types are listed under {@link jui.grid.service:uiGridConstants#properties_filter uiGridOptions.filter}
	   * @example
	   * <pre>{ term: 'text', condition: uiGridConstants.filter.STARTS_WITH, placeholder: 'type to filter...', ariaLabel: 'Filter for text', flags: { caseSensitive: false }, type: uiGridConstants.filter.SELECT, [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ] }</pre>
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name extraStyle
	   * @propertyOf ui.grid.class:GridColumn
	   * @description additional on this column.
	   * @example
	   * <pre>{extraStyle: {display: 'table-cell'}}</pre>
	   *
	   */
	
	  /**
	   * @ngdoc object
	   * @name ui.grid.class:GridColumn
	   * @description Represents the viewModel for each column.  Any state or methods needed for a Grid Column
	   * are defined on this prototype
	   * @param {ColumnDef} colDef the column def to associate with this column
	   * @param {number} uid the unique and immutable uid we'd like to allocate to this column
	   * @param {Grid} grid the grid we'd like to create this column in
	   */
	  function GridColumn(colDef, uid, grid) {
	    var self = this;
	
	    self.grid = grid;
	    self.uid = uid;
	
	    self.updateColumnDef(colDef, true);
	
	    self.aggregationValue = undefined;
	
	    // The footer cell registers to listen for the rowsRendered event, and calls this.  Needed to be
	    // in something with a scope so that the dereg would get called
	    self.updateAggregationValue = function() {
	
	     // gridUtil.logDebug('getAggregationValue for Column ' + self.colDef.name);
	
	      /**
	       * @ngdoc property
	       * @name aggregationType
	       * @propertyOf ui.grid.class:GridOptions.columnDef
	       * @description The aggregation that you'd like to show in the columnFooter for this
	       * column.  Valid values are in
	       * {@link ui.grid.service:uiGridConstants#properties_aggregationTypes uiGridConstants.aggregationTypes},
	       * and currently include `uiGridConstants.aggregationTypes.count`,
	       * `uiGridConstants.aggregationTypes.sum`, `uiGridConstants.aggregationTypes.avg`, `uiGridConstants.aggregationTypes.min`,
	       * `uiGridConstants.aggregationTypes.max`.
	       *
	       * You can also provide a function as the aggregation type, in this case your function needs to accept the full
	       * set of visible rows, and return a value that should be shown
	       */
	      if (!self.aggregationType) {
	        self.aggregationValue = undefined;
	        return;
	      }
	
	      var result = 0;
	      var visibleRows = self.grid.getVisibleRows();
	
	      var cellValues = function() {
	        var values = [];
	        visibleRows.forEach(function (row) {
	          var cellValue = self.grid.getCellValue(row, self);
	          var cellNumber = Number(cellValue);
	          if (!isNaN(cellNumber)) {
	            values.push(cellNumber);
	          }
	        });
	        return values;
	      };
	
	      if (angular.isFunction(self.aggregationType)) {
	        self.aggregationValue = self.aggregationType(visibleRows, self);
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.count) {
	        self.aggregationValue = self.grid.getVisibleRowCount();
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.sum) {
	        cellValues().forEach(function (value) {
	          result += value;
	        });
	        self.aggregationValue = result;
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.avg) {
	        cellValues().forEach(function (value) {
	          result += value;
	        });
	        result = result / cellValues().length;
	        self.aggregationValue = result;
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.min) {
	        self.aggregationValue = Math.min.apply(null, cellValues());
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.max) {
	        self.aggregationValue = Math.max.apply(null, cellValues());
	      }
	      else {
	        self.aggregationValue = '\u00A0';
	      }
	    };
	
	//     var throttledUpdateAggregationValue = gridUtil.throttle(updateAggregationValue, self.grid.options.aggregationCalcThrottle, { trailing: true, context: self.name });
	
	    /**
	     * @ngdoc function
	     * @name getAggregationValue
	     * @methodOf ui.grid.class:GridColumn
	     * @description gets the aggregation value based on the aggregation type for this column.
	     * Debounced using scrollDebounce option setting
	     */
	    this.getAggregationValue =  function() {
	//      if (!self.grid.isScrollingVertically && !self.grid.isScrollingHorizontally) {
	//        throttledUpdateAggregationValue();
	//      }
	
	      return self.aggregationValue;
	    };
	  }
	
	  /**
	   * @ngdoc function
	   * @name hideColumn
	   * @methodOf ui.grid.class:GridColumn
	   * @description Hides the column by setting colDef.visible = false
	   */
	  GridColumn.prototype.hideColumn = function() {
	    this.colDef.visible = false;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:GridColumn
	   * @name setPropertyOrDefault
	   * @description Sets a property on the column using the passed in columnDef, and
	   * setting the defaultValue if the value cannot be found on the colDef
	   * @param {GridColumn} colDef the column def to look in for the property value
	   * @param {string} propName the property name we'd like to set
	   * @param {object} defaultValue the value to use if the colDef doesn't provide the setting
	   */
	  GridColumn.prototype.setPropertyOrDefault = function (colDef, propName, defaultValue) {
	    var self = this;
	
	    // Use the column definition filter if we were passed it
	    if (typeof(colDef[propName]) !== 'undefined' && colDef[propName]) {
	      self[propName] = colDef[propName];
	    }
	    // Otherwise use our own if it's set
	    else if (typeof(self[propName]) !== 'undefined') {
	      self[propName] = self[propName];
	    }
	    // Default to empty object for the filter
	    else {
	      self[propName] = defaultValue ? defaultValue : {};
	    }
	  };
	
	
	
	  /**
	   * @ngdoc property
	   * @name width
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description sets the column width.  Can be either
	   * a number or a percentage, or an * for auto.
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', width: 100},
	   *                                          { field: 'field2', width: '20%'},
	   *                                          { field: 'field3', width: '*' }]; </pre>
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name allowFloatWidth
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description Allows float number in column width calculation
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', width: 50.5, allowFloatWidth: true},
	   *                                          { field: 'field2', width: '20%', allowFloatWidth: true},
	   *                                          { field: 'field3', width: '*', allowFloatWidth: true }]; </pre>
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name minWidth
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description Sets the minimum column width.  Should be a number.
	   * Defaults to gridOptions.minimumColumnSize if minWidth is not provided.
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', minWidth: 100}]; </pre>
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name maxWidth
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description sets the maximum column width.  Should be a number.
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', maxWidth: 100}]; </pre>
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name visible
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description sets whether or not the column is visible
	   * </br>Default is true
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [
	   *     { field: 'field1', visible: true},
	   *     { field: 'field2', visible: false }
	   *   ]; </pre>
	   *
	   */
	
	 /**
	  * @ngdoc property
	  * @name sort
	  * @propertyOf ui.grid.class:GridOptions.columnDef
	  * @description An object of sort information, attributes are:
	  *
	  * - direction: values are {@link ui.grid.service:uiGridConstants#properties_ASC uiGridConstants.ASC}
	  *  or {@link ui.grid.service:uiGridConstants#properties_DESC uiGridConstants.DESC}
	  * - ignoreSort: if set to true this sort is ignored (used by tree to manipulate the sort functionality)
	  * - priority: says what order to sort the columns in (lower priority gets sorted first). Starts from 0.
	  * @example
	  * <pre>
	  *   $scope.gridOptions.columnDefs = [{
	  *     field: 'field1',
	  *     sort: {
	  *       direction: uiGridConstants.ASC,
	  *       ignoreSort: true,
	  *       priority: 0
	  *      }
	  *   }];
	  * </pre>
	  */
	
	
	  /**
	   * @ngdoc property
	   * @name sortingAlgorithm
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description Algorithm to use for sorting this column. Takes 'a' and 'b' parameters
	   * like any normal sorting function with additional 'rowA', 'rowB', and 'direction' parameters
	   * that are the row objects and the current direction of the sort respectively.
	   *
	   */
	
	   /**
	    * @ngdoc property
	    * @name defaultSort
	    * @propertyOf ui.grid.class:GridOptions.columnDef
	    * @description An object of sort information, provides a hidden default ordering of the data
	    * when no user sorts are applied, or when a user-provided sort deems two rows to be equal.
	    *
	    * May be combined with a regular {@link ui.grid.class:GridOptions.columnDef#properties_sort columnDef.sort}
	    * to explicitly sort by that column by default.
	    *
	    * Shares the same object format as {@link ui.grid.class:GridOptions.columnDef#properties_sort columnDef.sort}.
	    *
	    * Note that a defaultSort can never take priority over an explicit sort.
	    * @example
	    * <pre>
	    *   $scope.gridOptions.columnDefs = [{
	    *     field: 'field1',
	    *     defaultSort: {
	    *       direction: uiGridConstants.ASC,
	    *       priority: 0
	    *      }
	    *   }];
	    * </pre>
	    */
	
	  /**
	   * @ngdoc array
	   * @name filters
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description Specify multiple filter fields.
	   * @example
	   * <pre>$scope.gridOptions.columnDefs = [
	   *   {
	   *     field: 'field1', filters: [
	   *       {
	   *         term: 'aa',
	   *         condition: uiGridConstants.filter.STARTS_WITH,
	   *         placeholder: 'starts with...',
	   *         ariaLabel: 'Filter for field1',
	   *         flags: { caseSensitive: false },
	   *         type: uiGridConstants.filter.SELECT,
	   *         selectOptions: [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ]
	   *       },
	   *       {
	   *         condition: uiGridConstants.filter.ENDS_WITH,
	   *         placeholder: 'ends with...'
	   *       }
	   *     ]
	   *   }
	   * ]; </pre>
	   *
	   *
	   */
	
	  /**
	   * @ngdoc array
	   * @name filters
	   * @propertyOf ui.grid.class:GridColumn
	   * @description Filters for this column. Includes 'term' property bound to filter input elements.
	   * @example
	   * <pre>[
	   *   {
	   *     term: 'foo', // ngModel for <input>
	   *     condition: uiGridConstants.filter.STARTS_WITH,
	   *     placeholder: 'starts with...',
	   *     ariaLabel: 'Filter for foo',
	   *     flags: { caseSensitive: false },
	   *     type: uiGridConstants.filter.SELECT,
	   *     selectOptions: [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ]
	   *   },
	   *   {
	   *     term: 'baz',
	   *     condition: uiGridConstants.filter.ENDS_WITH,
	   *     placeholder: 'ends with...'
	   *   }
	   * ] </pre>
	   *
	   *
	   */
	
	  /**
	   * @ngdoc array
	   * @name menuItems
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description used to add menu items to a column.  Refer to the tutorial on this
	   * functionality.  A number of settings are supported:
	   *
	   * - title: controls the title that is displayed in the menu
	   * - icon: the icon shown alongside that title
	   * - action: the method to call when the menu is clicked
	   * - shown: a function to evaluate to determine whether or not to show the item
	   * - active: a function to evaluate to determine whether or not the item is currently selected
	   * - context: context to pass to the action function, available in this.context in your handler
	   * - leaveOpen: if set to true, the menu should stay open after the action, defaults to false
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [
	   *   { field: 'field1', menuItems: [
	   *     {
	   *       title: 'Outer Scope Alert',
	   *       icon: 'ui-grid-icon-info-circled',
	   *       action: function($event) {
	   *         this.context.blargh(); // $scope.blargh() would work too, this is just an example
	   *       },
	   *       shown: function() { return true; },
	   *       active: function() { return true; },
	   *       context: $scope
	   *     },
	   *     {
	   *       title: 'Grid ID',
	   *       action: function() {
	   *         alert('Grid ID: ' + this.grid.id);
	   *       }
	   *     }
	   *   ] }]; </pre>
	   *
	   */
	
	  // Use colDef.displayName as long as it's not undefined, otherwise default to the field name
	  function getDisplayName(colDef) {
	    return (colDef.displayName === undefined)
	      ? gridUtil.readableColumnName(colDef.name)
	      : colDef.displayName;
	  }
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:GridColumn
	   * @name updateColumnDef
	   * @description Moves settings from the columnDef down onto the column,
	   * and sets properties as appropriate
	   * @param {GridColumn} colDef the column def to look in for the property value
	   * @param {boolean} isNew whether the column is being newly created, if not
	   * we're updating an existing column, and some items such as the sort shouldn't
	   * be copied down
	   */
	  GridColumn.prototype.updateColumnDef = function(colDef, isNew) {
	    var self = this;
	
	    self.colDef = colDef;
	
	    if (colDef.name === undefined) {
	      throw new Error('colDef.name is required for column at index ' + self.grid.options.columnDefs.indexOf(colDef));
	    }
	
	    self.displayName = getDisplayName(colDef);
	
	    if (!angular.isNumber(self.width) || !self.hasCustomWidth || colDef.allowCustomWidthOverride) {
	      var colDefWidth = colDef.width;
	      var parseErrorMsg = "Cannot parse column width '" + colDefWidth + "' for column named '" + colDef.name + "'";
	      self.hasCustomWidth = false;
	
	      if (!angular.isString(colDefWidth) && !angular.isNumber(colDefWidth)) {
	        self.width = '*';
	      } else if (angular.isString(colDefWidth)) {
	        // See if it ends with a percent
	        if (gridUtil.endsWith(colDefWidth, '%')) {
	          // If so we should be able to parse the non-percent-sign part to a number
	          var percentStr = colDefWidth.replace(/%/g, '');
	          var percent = parseInt(percentStr, 10);
	          if (isNaN(percent)) {
	            throw new Error(parseErrorMsg);
	          }
	          self.width = colDefWidth;
	        }
	        // And see if it's a number string
	        else if (colDefWidth.match(/^(\d+)$/)) {
	          self.width = parseInt(colDefWidth.match(/^(\d+)$/)[1], 10);
	        }
	        // Otherwise it should be a string of asterisks
	        else if (colDefWidth.match(/^\*+$/)) {
	          self.width = colDefWidth;
	        }
	        // No idea, throw an Error
	        else {
	          throw new Error(parseErrorMsg);
	        }
	      }
	      // Is a number, use it as the width
	      else {
	        self.width = colDefWidth;
	      }
	    }
	
	    function isValidWidthValue(value) {
	      return angular.isString(value) || angular.isNumber(value);
	    }
	
	    ['minWidth', 'maxWidth'].forEach(function (name) {
	      var minOrMaxWidth = colDef[name];
	      var parseErrorMsg = "Cannot parse column " + name + " '" + minOrMaxWidth + "' for column named '" + colDef.name + "'";
	
	      // default minWidth to the minimumColumnSize
	      if (name === 'minWidth' && !isValidWidthValue(minOrMaxWidth) && angular.isDefined(self.grid.options.minimumColumnSize)) {
	        minOrMaxWidth = self.grid.options.minimumColumnSize;
	      }
	
	      if (!isValidWidthValue(minOrMaxWidth)) {
	        // Sets default minWidth and maxWidth values
	        self[name] = ((name === 'minWidth') ? 30 : 9000);
	      } else if (angular.isString(minOrMaxWidth)) {
	        if (minOrMaxWidth.match(/^(\d+)$/)) {
	          self[name] = parseInt(minOrMaxWidth.match(/^(\d+)$/)[1], 10);
	        } else {
	          throw new Error(parseErrorMsg);
	        }
	      } else {
	        self[name] = minOrMaxWidth;
	      }
	    });
	
	    // use field if it is defined; name if it is not
	    self.field = (colDef.field === undefined) ? colDef.name : colDef.field;
	
	    if ( typeof( self.field ) !== 'string' ) {
	      gridUtil.logError( 'Field is not a string, this is likely to break the code, Field is: ' + self.field );
	    }
	
	    self.name = colDef.name;
	    self.displayName = getDisplayName(colDef);
	
	    // self.originalIndex = index;
	
	    self.aggregationType = angular.isDefined(colDef.aggregationType) ? colDef.aggregationType : null;
	    self.footerCellTemplate = angular.isDefined(colDef.footerCellTemplate) ? colDef.footerCellTemplate : null;
	
	    /**
	     * @ngdoc property
	     * @name cellTooltip
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description Whether or not to show a tooltip when a user hovers over the cell.
	     * If set to false, no tooltip.  If true, the cell value is shown in the tooltip (useful
	     * if you have long values in your cells), if a function then that function is called
	     * passing in the row and the col `cellTooltip( row, col )`, and the return value is shown in the tooltip,
	     * if it is a static string then displays that static string.
	     *
	     * Defaults to false
	     *
	     */
	    if ( typeof(colDef.cellTooltip) === 'undefined' || colDef.cellTooltip === false ) {
	      self.cellTooltip = false;
	    } else if ( colDef.cellTooltip === true ) {
	      self.cellTooltip = function(row, col) {
	        return self.grid.getCellValue( row, col );
	      };
	    } else if (typeof(colDef.cellTooltip) === 'function' ) {
	      self.cellTooltip = colDef.cellTooltip;
	    } else {
	      self.cellTooltip = function ( row, col ) {
	        return col.colDef.cellTooltip;
	      };
	    }
	
	    /**
	     * @ngdoc property
	     * @name headerTooltip
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description Whether or not to show a tooltip when a user hovers over the header cell.
	     * If set to false, no tooltip.  If true, the displayName is shown in the tooltip (useful
	     * if you have long values in your headers), if a function then that function is called
	     * passing in the row and the col `headerTooltip( col )`, and the return value is shown in the tooltip,
	     * if a static string then shows that static string.
	     *
	     * Defaults to false
	     *
	     */
	    if ( typeof(colDef.headerTooltip) === 'undefined' || colDef.headerTooltip === false ) {
	      self.headerTooltip = false;
	    }
	    else if ( colDef.headerTooltip === true ) {
	      self.headerTooltip = function(col) {
	        return col.displayName;
	      };
	    }
	    else if (typeof(colDef.headerTooltip) === 'function' ) {
	      self.headerTooltip = colDef.headerTooltip;
	    }
	    else {
	      self.headerTooltip = function ( col ) {
	        return col.colDef.headerTooltip;
	      };
	    }
	
	
	    /**
	     * @ngdoc property
	     * @name footerCellClass
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description footerCellClass can be a string specifying the class to append to a cell
	     * or it can be a function(grid, row, col, rowRenderIndex, colRenderIndex) that returns a class name
	     *
	     */
	    self.footerCellClass = colDef.footerCellClass;
	
	    /**
	     * @ngdoc property
	     * @name cellClass
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description cellClass can be a string specifying the class to append to a cell
	     * or it can be a function(grid, row, col, rowRenderIndex, colRenderIndex) that returns a class name
	     *
	     */
	    self.cellClass = colDef.cellClass;
	
	    /**
	     * @ngdoc property
	     * @name headerCellClass
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description headerCellClass can be a string specifying the class to append to a cell
	     * or it can be a function(grid, row, col, rowRenderIndex, colRenderIndex) that returns a class name
	     *
	     */
	    self.headerCellClass = colDef.headerCellClass;
	
	    /**
	     * @ngdoc property
	     * @name cellFilter
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description cellFilter is a filter to apply to the content of each cell
	     * @example
	     * <pre>
	     *   gridOptions.columnDefs[0].cellFilter = 'date'
	     *
	     */
	    self.cellFilter = colDef.cellFilter ? colDef.cellFilter : "";
	
	    /**
	     * @ngdoc boolean
	     * @name sortCellFiltered
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) False by default. When `true` uiGrid will apply the cellFilter before
	     * sorting the data. Note that when using this option uiGrid will assume that the displayed value is
	     * a string, and use the {@link ui.grid.class:RowSorter#sortAlpha sortAlpha} `sortFn`. It is possible
	     * to return a non-string value from an angularjs filter, in which case you should define a {@link ui.grid.class:GridOptions.columnDef#sortingAlgorithm sortingAlgorithm}
	     * for the column which hanldes the returned type. You may specify one of the `sortingAlgorithms`
	     * found in the {@link ui.grid.RowSorter rowSorter} service.
	     */
	    self.sortCellFiltered = colDef.sortCellFiltered ? true : false;
	
	    /**
	     * @ngdoc boolean
	     * @name filterCellFiltered
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) False by default. When `true` uiGrid will apply the cellFilter before
	     * applying "search" `filters`.
	     */
	    self.filterCellFiltered = colDef.filterCellFiltered ? true : false;
	
	    /**
	     * @ngdoc property
	     * @name headerCellFilter
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description headerCellFilter is a filter to apply to the content of the column header
	     * @example
	     * <pre>
	     *   gridOptions.columnDefs[0].headerCellFilter = 'translate'
	     *
	     */
	    self.headerCellFilter = colDef.headerCellFilter ? colDef.headerCellFilter : "";
	
	    /**
	     * @ngdoc property
	     * @name footerCellFilter
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description footerCellFilter is a filter to apply to the content of the column footer
	     * @example
	     * <pre>
	     *   gridOptions.columnDefs[0].footerCellFilter = 'date'
	     *
	     */
	    self.footerCellFilter = colDef.footerCellFilter ? colDef.footerCellFilter : "";
	
	    self.visible = gridUtil.isNullOrUndefined(colDef.visible) || colDef.visible;
	
	    self.headerClass = colDef.headerClass;
	    // self.cursor = self.sortable ? 'pointer' : 'default';
	
	    // Turn on sorting by default
	    self.enableSorting = typeof(colDef.enableSorting) !== 'undefined' ? colDef.enableSorting : self.grid.options.enableSorting;
	    self.sortingAlgorithm = colDef.sortingAlgorithm;
	
	    /**
	     * @ngdoc property
	     * @name sortDirectionCycle
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) An array of {@link ui.grid.service:uiGridConstants#properties_ASC sort directions},
	     * specifying the order that they should cycle through as the user repeatedly clicks on the column heading.
	     * The default is `[null, uiGridConstants.ASC, uiGridConstants.DESC]`. Null
	     * refers to the unsorted state. This does not affect the initial sort
	     * direction; use the {@link ui.grid.class:GridOptions.columnDef#sort sort}
	     * property for that. If
	     * {@link ui.grid.class:GridOptions.columnDef#suppressRemoveSort suppressRemoveSort}
	     * is also set, the unsorted state will be skipped even if it is listed here.
	     * Each direction may not appear in the list more than once (e.g. `[ASC,
	     * DESC, DESC]` is not allowed), and the list may not be empty.
	     */
	    self.sortDirectionCycle = typeof(colDef.sortDirectionCycle) !== 'undefined' ?
	      colDef.sortDirectionCycle :
	      [null, uiGridConstants.ASC, uiGridConstants.DESC];
	
	    /**
	     * @ngdoc boolean
	     * @name suppressRemoveSort
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) False by default. When enabled, this setting hides the removeSort option
	     * in the menu, and prevents users from manually removing the sort
	     */
	    if ( typeof(self.suppressRemoveSort) === 'undefined') {
	      self.suppressRemoveSort = typeof(colDef.suppressRemoveSort) !== 'undefined' ? colDef.suppressRemoveSort : false;
	    }
	
	    /**
	     * @ngdoc property
	     * @name enableFiltering
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description turn off filtering for an individual column, where
	     * you've turned on filtering for the overall grid
	     * @example
	     * <pre>
	     *   gridOptions.columnDefs[0].enableFiltering = false;
	     *
	     */
	    // Turn on filtering by default (it's disabled by default at the Grid level)
	    self.enableFiltering = typeof(colDef.enableFiltering) !== 'undefined' ? colDef.enableFiltering : true;
	
	    // Place the filter in the header cell by default
	    self.filterContainer = typeof(colDef.filterContainer) !== 'undefined' ? colDef.filterContainer : self.grid.options.filterContainer;
	
	    // self.menuItems = colDef.menuItems;
	    self.setPropertyOrDefault(colDef, 'menuItems', []);
	
	    // Use the column definition sort if we were passed it, but only if this is a newly added column
	    if ( isNew ) {
	      self.setPropertyOrDefault(colDef, 'sort');
	    }
	
	    // Use the column definition defaultSort always, unlike normal sort
	    self.setPropertyOrDefault(colDef, 'defaultSort');
	
	    // Set up default filters array for when one is not provided.
	    //   In other words, this (in column def):
	    //
	    //       filter: { term: 'something', flags: {}, condition: [CONDITION] }
	    //
	    //   is just shorthand for this:
	    //
	    //       filters: [{ term: 'something', flags: {}, condition: [CONDITION] }]
	    //
	    var defaultFilters = [];
	    if (colDef.filter) {
	      defaultFilters.push(colDef.filter);
	    }
	    else if ( colDef.filters ) {
	      defaultFilters = colDef.filters;
	    }
	    else {
	      // Add an empty filter definition object, which will
	      // translate to a guessed condition and no pre-populated
	      // value for the filter <input>.
	      defaultFilters.push({});
	    }
	
	    /**
	     * @ngdoc property
	     * @name filter
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description Specify a single filter field on this column.
	     *
	     * A filter consists of a condition, a term, and a placeholder:
	     *
	     * - condition defines how rows are chosen as matching the filter term. This can be set to
	     * one of the constants in {@link ui.grid.service:uiGridConstants#properties_filter uiGridConstants.filter},
	     * or you can supply a custom filter function
	     * that gets passed the following arguments: [searchTerm, cellValue, row, column].
	     * - term: If set, the filter field will be pre-populated
	     * with this value.
	     * - placeholder: String that will be set to the `<input>.placeholder` attribute.
	     * - ariaLabel: String that will be set to the `<input>.ariaLabel` attribute. This is what is read as a label to screen reader users.
	     * - noTerm: set this to true if you have defined a custom function in condition, and
	     * your custom function doesn't require a term (so it can run even when the term is null)
	     * - rawTerm: set this to true if you have defined a custom function in condition, and
	     * your custom function requires access to the raw unmodified search term that was entered
	     * - flags: only flag currently available is `caseSensitive`, set to false if you don't want
	     * case sensitive matching
	     * - type: defaults to {@link ui.grid.service:uiGridConstants#properties_filter uiGridConstants.filter.INPUT},
	     * which gives a text box.  If set to {@link ui.grid.service:uiGridConstants#properties_filter uiGridConstants.filter.SELECT}
	     * then a select box will be shown with options selectOptions
	     * - selectOptions: options in the format `[ { value: 1, label: 'male' }]`.  No i18n filter is provided, you need
	     * to perform the i18n on the values before you provide them
	     * - disableCancelFilterButton: defaults to false. If set to true then the 'x' button that cancels/clears the filter
	     * will not be shown.
	     * @example
	     * <pre>$scope.gridOptions.columnDefs = [
	     *   {
	     *     field: 'field1',
	     *     filter: {
	     *       term: 'xx',
	     *       condition: uiGridConstants.filter.STARTS_WITH,
	     *       placeholder: 'starts with...',
	     *       ariaLabel: 'Starts with filter for field1',
	     *       flags: { caseSensitive: false },
	     *       type: uiGridConstants.filter.SELECT,
	     *       selectOptions: [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ],
	     *       disableCancelFilterButton: true
	     *     }
	     *   }
	     * ]; </pre>
	     *
	     */
	
	    // Only set filter if this is a newly added column, if we're updating an existing
	    // column then we don't want to put the default filter back if the user may have already
	    // removed it.
	    // However, we do want to keep the settings if they change, just not the term
	    if ( isNew ) {
	      self.setPropertyOrDefault(colDef, 'filter');
	      self.setPropertyOrDefault(colDef, 'extraStyle');
	      self.setPropertyOrDefault(colDef, 'filters', defaultFilters);
	    } else if ( self.filters.length === defaultFilters.length ) {
	      self.filters.forEach( function( filter, index ) {
	        if (typeof(defaultFilters[index].placeholder) !== 'undefined') {
	          filter.placeholder = defaultFilters[index].placeholder;
	        }
	        if (typeof(defaultFilters[index].ariaLabel) !== 'undefined') {
	          filter.ariaLabel = defaultFilters[index].ariaLabel;
	        }
	        if (typeof(defaultFilters[index].flags) !== 'undefined') {
	          filter.flags = defaultFilters[index].flags;
	        }
	        if (typeof(defaultFilters[index].type) !== 'undefined') {
	          filter.type = defaultFilters[index].type;
	        }
	        if (typeof(defaultFilters[index].selectOptions) !== 'undefined') {
	          filter.selectOptions = defaultFilters[index].selectOptions;
	        }
	      });
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name unsort
	   * @methodOf ui.grid.class:GridColumn
	   * @description Removes column from the grid sorting
	   */
	  GridColumn.prototype.unsort = function () {
	    // Decrease priority for every col where priority is higher than the removed sort's priority.
	    var thisPriority = this.sort.priority;
	
	    this.grid.columns.forEach(function (col) {
	      if (col.sort && col.sort.priority !== undefined && col.sort.priority > thisPriority) {
	        col.sort.priority -= 1;
	      }
	    });
	
	    this.sort = {};
	    this.grid.api.core.raise.sortChanged( this.grid, this.grid.getColumnSorting() );
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name getColClass
	   * @methodOf ui.grid.class:GridColumn
	   * @description Returns the class name for the column
	   * @param {bool} prefixDot  if true, will return .className instead of className
	   */
	  GridColumn.prototype.getColClass = function (prefixDot) {
	    var cls = uiGridConstants.COL_CLASS_PREFIX + this.uid;
	
	    return prefixDot ? '.' + cls : cls;
	  };
	
	    /**
	     * @ngdoc function
	     * @name isPinnedLeft
	     * @methodOf ui.grid.class:GridColumn
	     * @description Returns true if column is in the left render container
	     */
	    GridColumn.prototype.isPinnedLeft = function () {
	      return this.renderContainer === 'left';
	    };
	
	    /**
	     * @ngdoc function
	     * @name isPinnedRight
	     * @methodOf ui.grid.class:GridColumn
	     * @description Returns true if column is in the right render container
	     */
	    GridColumn.prototype.isPinnedRight = function () {
	      return this.renderContainer === 'right';
	    };
	
	
	    /**
	   * @ngdoc function
	   * @name getColClassDefinition
	   * @methodOf ui.grid.class:GridColumn
	   * @description Returns the class definition for th column
	   */
	  GridColumn.prototype.getColClassDefinition = function () {
	    return ' .grid' + this.grid.id + ' ' + this.getColClass(true) + ' { min-width: ' + this.drawnWidth + 'px; max-width: ' + this.drawnWidth + 'px; }';
	  };
	
	  /**
	   * @ngdoc function
	   * @name getRenderContainer
	   * @methodOf ui.grid.class:GridColumn
	   * @description Returns the render container object that this column belongs to.
	   *
	   * Columns will be default be in the `body` render container if they aren't allocated to one specifically.
	   */
	  GridColumn.prototype.getRenderContainer = function getRenderContainer() {
	    var self = this;
	
	    var containerId = self.renderContainer;
	
	    if (containerId === null || containerId === '' || containerId === undefined) {
	      containerId = 'body';
	    }
	
	    return self.grid.renderContainers[containerId];
	  };
	
	  /**
	   * @ngdoc function
	   * @name showColumn
	   * @methodOf ui.grid.class:GridColumn
	   * @description Makes the column visible by setting colDef.visible = true
	   */
	  GridColumn.prototype.showColumn = function() {
	      this.colDef.visible = true;
	  };
	
	
	  /**
	   * @ngdoc property
	   * @name aggregationHideLabel
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description defaults to false, if set to true hides the label text
	   * in the aggregation footer, so only the value is displayed.
	   *
	   */
	  /**
	   * @ngdoc function
	   * @name getAggregationText
	   * @methodOf ui.grid.class:GridColumn
	   * @description Gets the aggregation label from colDef.aggregationLabel if
	   * specified or by using i18n, including deciding whether or not to display
	   * based on colDef.aggregationHideLabel.
	   *
	   * @param {string} label the i18n lookup value to use for the column label
	   *
	   */
	  GridColumn.prototype.getAggregationText = function () {
	    var self = this;
	    if ( self.colDef.aggregationHideLabel ) {
	      return '';
	    }
	    else if ( self.colDef.aggregationLabel ) {
	      return self.colDef.aggregationLabel;
	    }
	    else {
	      switch ( self.colDef.aggregationType ) {
	        case uiGridConstants.aggregationTypes.count:
	          return i18nService.getSafeText('aggregation.count');
	        case uiGridConstants.aggregationTypes.sum:
	          return i18nService.getSafeText('aggregation.sum');
	        case uiGridConstants.aggregationTypes.avg:
	          return i18nService.getSafeText('aggregation.avg');
	        case uiGridConstants.aggregationTypes.min:
	          return i18nService.getSafeText('aggregation.min');
	        case uiGridConstants.aggregationTypes.max:
	          return i18nService.getSafeText('aggregation.max');
	        default:
	          return '';
	      }
	    }
	  };
	
	  GridColumn.prototype.getCellTemplate = function () {
	    var self = this;
	
	    return self.cellTemplatePromise;
	  };
	
	  GridColumn.prototype.getCompiledElementFn = function () {
	    var self = this;
	
	    return self.compiledElementFnDefer.promise;
	  };
	
	  return GridColumn;
	}]);
	
	})();
	
	(function() {
	angular.module('ui.grid')
	.factory('GridOptions', ['gridUtil','uiGridConstants', function(gridUtil, uiGridConstants) {
	
	  /**
	   * @ngdoc function
	   * @name ui.grid.class:GridOptions
	   * @description Default GridOptions class.  GridOptions are defined by the application developer and overlaid
	   * over this object.  Setting gridOptions within your controller is the most common method for an application
	   * developer to configure the behaviour of their ui-grid
	   *
	   * @example To define your gridOptions within your controller:
	   * <pre>$scope.gridOptions = {
	   *   data: $scope.myData,
	   *   columnDefs: [
	   *     { name: 'field1', displayName: 'pretty display name' },
	   *     { name: 'field2', visible: false }
	   *  ]
	   * };</pre>
	   *
	   * You can then use this within your html template, when you define your grid:
	   * <pre>&lt;div ui-grid="gridOptions"&gt;&lt;/div&gt;</pre>
	   *
	   * To provide default options for all of the grids within your application, use an angular
	   * decorator to modify the GridOptions factory.
	   * <pre>
	   * app.config(function($provide) {
	   *   $provide.decorator('GridOptions',function($delegate) {
	   *     var gridOptions;
	   *     gridOptions = angular.copy($delegate);
	   *     gridOptions.initialize = function(options) {
	   *       var initOptions;
	   *       initOptions = $delegate.initialize(options);
	   *       initOptions.enableColumnMenus = false;
	   *       return initOptions;
	   *     };
	   *     return gridOptions;
	   *   });
	   * });
	   * </pre>
	   */
	  return {
	    initialize: function( baseOptions ) {
	      /**
	       * @ngdoc function
	       * @name onRegisterApi
	       * @propertyOf ui.grid.class:GridOptions
	       * @description A callback that returns the gridApi once the grid is instantiated, which is
	       * then used to interact with the grid programatically.
	       *
	       * Note that the gridApi.core.renderingComplete event is identical to this
	       * callback, but has the advantage that it can be called from multiple places
	       * if needed
	       *
	       * @example
	       * <pre>
	       *   $scope.gridOptions.onRegisterApi = function ( gridApi ) {
	       *     $scope.gridApi = gridApi;
	       *     $scope.gridApi.selection.selectAllRows( $scope.gridApi.grid );
	       *   };
	       * </pre>
	       *
	       */
	      baseOptions.onRegisterApi = baseOptions.onRegisterApi || angular.noop();
	
	      /**
	       * @ngdoc object
	       * @name data
	       * @propertyOf ui.grid.class:GridOptions
	       * @description (mandatory) Array of data to be rendered into the grid, providing the data source or data binding for
	       * the grid.
	       *
	       * Most commonly the data is an array of objects, where each object has a number of attributes.
	       * Each attribute automatically becomes a column in your grid.  This array could, for example, be sourced from
	       * an angularJS $resource query request.  The array can also contain complex objects, refer the binding tutorial
	       * for examples of that.
	       *
	       * The most flexible usage is to set your data on $scope:
	       *
	       * `$scope.data = data;`
	       *
	       * And then direct the grid to resolve whatever is in $scope.data:
	       *
	       * `$scope.gridOptions.data = 'data';`
	       *
	       * This is the most flexible approach as it allows you to replace $scope.data whenever you feel like it without
	       * getting pointer issues.
	       *
	       * Alternatively you can directly set the data array:
	       *
	       * `$scope.gridOptions.data = [ ];`
	       * or
	       *
	       * `$http.get('/data/100.json')
	       * .success(function(data) {
	       *   $scope.myData = data;
	       *   $scope.gridOptions.data = $scope.myData;
	       *  });`
	       *
	       * Where you do this, you need to take care in updating the data - you can't just update `$scope.myData` to some other
	       * array, you need to update $scope.gridOptions.data to point to that new array as well.
	       *
	       */
	      baseOptions.data = baseOptions.data || [];
	
	      /**
	       * @ngdoc array
	       * @name columnDefs
	       * @propertyOf  ui.grid.class:GridOptions
	       * @description Array of columnDef objects.  Only required property is name.
	       * The individual options available in columnDefs are documented in the
	       * {@link ui.grid.class:GridOptions.columnDef columnDef} section
	       * </br>_field property can be used in place of name for backwards compatibility with 2.x_
	       *  @example
	       *
	       * <pre>var columnDefs = [{name: 'field1'}, {name: 'field2'}];</pre>
	       *
	       */
	      baseOptions.columnDefs = baseOptions.columnDefs || [];
	
	      /**
	       * @ngdoc object
	       * @name ui.grid.class:GridOptions.columnDef
	       * @description Definition / configuration of an individual column, which would typically be
	       * one of many column definitions within the gridOptions.columnDefs array
	       * @example
	       * <pre>{name: 'field1', field: 'field1', filter: { term: 'xxx' }}</pre>
	       *
	       */
	
	      /**
	       * @ngdoc object
	       * @name enableGridMenu
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Takes a boolean that adds a settings icon in the top right of the grid, which floats above
	       * the column header, when true. The menu by default gives access to show/hide columns, but can be
	       * customised to show additional actions.
	       *
	       * See the {@link #!/tutorial/121_grid_menu Grid Menu tutorial} for more detailed information.
	       */
	
	      /**
	       * @ngdoc array
	       * @name excludeProperties
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Array of property names in data to ignore when auto-generating column names.  Provides the
	       * inverse of columnDefs - columnDefs is a list of columns to include, excludeProperties is a list of columns
	       * to exclude.
	       *
	       * If columnDefs is defined, this will be ignored.
	       *
	       * Defaults to ['$$hashKey']
	       */
	
	      baseOptions.excludeProperties = baseOptions.excludeProperties || ['$$hashKey'];
	
	      /**
	       * @ngdoc boolean
	       * @name enableRowHashing
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, this setting allows uiGrid to add
	       * `$$hashKey`-type properties (similar to Angular) to elements in the `data` array. This allows
	       * the grid to maintain state while vastly speeding up the process of altering `data` by adding/moving/removing rows.
	       *
	       * Note that this DOES add properties to your data that you may not want, but they are stripped out when using `angular.toJson()`. IF
	       * you do not want this at all you can disable this setting but you will take a performance hit if you are using large numbers of rows
	       * and are altering the data set often.
	       */
	      baseOptions.enableRowHashing = baseOptions.enableRowHashing !== false;
	
	      /**
	       * @ngdoc function
	       * @name rowIdentity
	       * @methodOf ui.grid.class:GridOptions
	       * @description This function is used to get and, if necessary, set the value uniquely identifying this row (i.e. if an identity is not present it will set one).
	       *
	       * By default it returns the `$$hashKey` property if it exists. If it doesn't it uses gridUtil.nextUid() to generate one
	       */
	      baseOptions.rowIdentity = baseOptions.rowIdentity || function rowIdentity(row) {
	        return gridUtil.hashKey(row);
	      };
	
	      /**
	       * @ngdoc function
	       * @name getRowIdentity
	       * @methodOf ui.grid.class:GridOptions
	       * @description This function returns the identity value uniquely identifying this row, if one is not present it does not set it.
	       *
	       * By default it returns the `$$hashKey` property but can be overridden to use any property or set of properties you want.
	       */
	      baseOptions.getRowIdentity = baseOptions.getRowIdentity || function getRowIdentity(row) {
	        return row.$$hashKey;
	      };
	
	      /**
	       * @ngdoc property
	       * @name flatEntityAccess
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Set to true if your columns are all related directly to fields in a flat object structure - i.e.
	       * each of your columns associate directly with a property on each of the entities in your data array.
	       *
	       * In that situation we can avoid all the logic associated with complex binding to functions or to properties of sub-objects,
	       * which can provide a significant speed improvement with large data sets when filtering or sorting.
	       *
	       * By default false
	       */
	      baseOptions.flatEntityAccess = baseOptions.flatEntityAccess === true;
	
	      /**
	       * @ngdoc property
	       * @name showHeader
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When set to false, this setting will replace the
	       * standard header template with '<div></div>', resulting in no header being shown.
	       */
	      baseOptions.showHeader = typeof(baseOptions.showHeader) !== "undefined" ? baseOptions.showHeader : true;
	
	      /**
	       * @ngdoc property
	       * @name headerRowHeight
	       * @propertyOf ui.grid.class:GridOptions
	       * @description The height of the header in pixels, defaults to 30.
	       * Although, we recommend that you alter header height with CSS rather than using this option:
	       *
	       * <pre>
	       *     .grid .ui-grid-header-cell {
	       *         height: 60px;
	       *     }
	       * </pre>
	       **/
	      if (!baseOptions.showHeader) {
	        baseOptions.headerRowHeight = 0;
	      }
	      else {
	        baseOptions.headerRowHeight = typeof(baseOptions.headerRowHeight) !== "undefined" ? baseOptions.headerRowHeight : 30;
	      }
	
	      /**
	       * @ngdoc property
	       * @name rowHeight
	       * @propertyOf ui.grid.class:GridOptions
	       * @description The height of the row in pixels,  Can be passed as integer or string. defaults to 30.
	       *
	       */
	
	      if (typeof baseOptions.rowHeight === "string") {
	        baseOptions.rowHeight = parseInt(baseOptions.rowHeight) || 30;
	      }
	
	      else {
	        baseOptions.rowHeight = baseOptions.rowHeight || 30;
	      }
	
	      /**
	       * @ngdoc integer
	       * @name minRowsToShow
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Minimum number of rows to show when the grid doesn't have a defined height. Defaults to "10".
	       */
	      baseOptions.minRowsToShow = typeof(baseOptions.minRowsToShow) !== "undefined" ? baseOptions.minRowsToShow : 10;
	
	      /**
	       * @ngdoc property
	       * @name showGridFooter
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Whether or not to show the footer, defaults to false
	       * The footer display Total Rows and Visible Rows (filtered rows)
	       */
	      baseOptions.showGridFooter = baseOptions.showGridFooter === true;
	
	      /**
	       * @ngdoc property
	       * @name showColumnFooter
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Whether or not to show the column footer, defaults to false
	       * The column footer displays column aggregates
	       */
	      baseOptions.showColumnFooter = baseOptions.showColumnFooter === true;
	
	      /**
	       * @ngdoc property
	       * @name columnFooterHeight
	       * @propertyOf ui.grid.class:GridOptions
	       * @description The height of the footer rows (column footer and grid footer) in pixels
	       *
	       */
	      baseOptions.columnFooterHeight = typeof(baseOptions.columnFooterHeight) !== "undefined" ? baseOptions.columnFooterHeight : 30;
	      baseOptions.gridFooterHeight = typeof(baseOptions.gridFooterHeight) !== "undefined" ? baseOptions.gridFooterHeight : 30;
	
	      baseOptions.columnWidth = typeof(baseOptions.columnWidth) !== "undefined" ? baseOptions.columnWidth : 50;
	
	      /**
	       * @ngdoc property
	       * @name maxVisibleColumnCount
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Defaults to 200
	       *
	       */
	      baseOptions.maxVisibleColumnCount = typeof(baseOptions.maxVisibleColumnCount) !== "undefined" ? baseOptions.maxVisibleColumnCount : 200;
	
	      /**
	       * @ngdoc property
	       * @name virtualizationThreshold
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Turn virtualization on when number of data elements goes over this number, defaults to 20
	       */
	      baseOptions.virtualizationThreshold = typeof(baseOptions.virtualizationThreshold) !== "undefined" ? baseOptions.virtualizationThreshold : 20;
	
	      /**
	       * @ngdoc property
	       * @name columnVirtualizationThreshold
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Turn virtualization on when number of columns goes over this number, defaults to 10
	       */
	      baseOptions.columnVirtualizationThreshold = typeof(baseOptions.columnVirtualizationThreshold) !== "undefined" ? baseOptions.columnVirtualizationThreshold : 10;
	
	      /**
	       * @ngdoc property
	       * @name excessRows
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Extra rows to to render outside of the viewport, which helps with smoothness of scrolling.
	       * Defaults to 4
	       */
	      baseOptions.excessRows = typeof(baseOptions.excessRows) !== "undefined" ? baseOptions.excessRows : 4;
	
	      /**
	       * @ngdoc property
	       * @name scrollThreshold
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Throttles the grid scrolling by the amount of rows set, which helps with smoothness of scrolling.
	       * Defaults to 4.
	       */
	      baseOptions.scrollThreshold = typeof(baseOptions.scrollThreshold) !== "undefined" ? baseOptions.scrollThreshold : 4;
	
	      /**
	       * @ngdoc property
	       * @name excessColumns
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Extra columns to to render outside of the viewport, which helps with smoothness of scrolling.
	       * Defaults to 4
	       */
	      baseOptions.excessColumns = typeof(baseOptions.excessColumns) !== "undefined" ? baseOptions.excessColumns : 4;
	
	      /**
	       * @ngdoc property
	       * @name aggregationCalcThrottle
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Default time in milliseconds to throttle aggregation calcuations, defaults to 500ms
	       */
	      baseOptions.aggregationCalcThrottle = typeof(baseOptions.aggregationCalcThrottle) !== "undefined" ? baseOptions.aggregationCalcThrottle : 500;
	
	      /**
	       * @ngdoc property
	       * @name wheelScrollThrottle
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Default time in milliseconds to throttle scroll events to, defaults to 70ms
	       */
	      baseOptions.wheelScrollThrottle = typeof(baseOptions.wheelScrollThrottle) !== "undefined" ? baseOptions.wheelScrollThrottle : 70;
	
	
	      /**
	       * @ngdoc property
	       * @name scrollDebounce
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Default time in milliseconds to debounce scroll events, defaults to 300ms
	       */
	      baseOptions.scrollDebounce = typeof(baseOptions.scrollDebounce) !== "undefined" ? baseOptions.scrollDebounce : 300;
	
	      /**
	       * @ngdoc boolean
	       * @name enableHiding
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, this setting adds ability to hide
	       * the column headers, allowing hiding of the column from the grid.
	       * Column hiding can then be disabled / enabled on individual columns using the columnDefs,
	       * if it set, it will override GridOptions enableHiding setting.
	       */
	      baseOptions.enableHiding = baseOptions.enableHiding !== false;
	
	      /**
	       * @ngdoc boolean
	       * @name enableSorting
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, this setting adds sort
	       * widgets to the column headers, allowing sorting of the data for the entire grid.
	       * Sorting can then be disabled / enabled on individual columns using the columnDefs,
	       * if it set, it will override GridOptions enableSorting setting.
	       */
	      baseOptions.enableSorting = baseOptions.enableSorting !== false;
	
	      /**
	       * @ngdoc boolean
	       * @name suppressMultiSort
	       * @propertyOf ui.grid.class:GridOptions
	       * @description False by default. When enabled, this setting disables the ability
	       * to sort multiple columns by using the shift key or interacting with the column
	       * menu. Instead, each column sort will remove all other sorting.
	       */
	      baseOptions.suppressMultiSort = baseOptions.suppressMultiSort === true;
	
	      /**
	       * @ngdoc boolean
	       * @name enableFiltering
	       * @propertyOf ui.grid.class:GridOptions
	       * @description False by default. When enabled, this setting adds filter
	       * boxes to each column header, allowing filtering within the column for the entire grid.
	       * Filtering can then be disabled on individual columns using the columnDefs.
	       */
	      baseOptions.enableFiltering = baseOptions.enableFiltering === true;
	
	      /**
	       * @ngdoc string
	       * @name filterContainer
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Sets the parent element for the column filter. `headerCell` places
	       * it in the header cell. `columnMenu` places it in the column menu.
	       * Can be changed for individual columns using the columnDefs.
	       * Defaults to `headerCell`
	       */
	      baseOptions.filterContainer = typeof(baseOptions.filterContainer) !== "undefined" ? baseOptions.filterContainer : "headerCell";
	
	      /**
	       * @ngdoc boolean
	       * @name enableColumnMenus
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, this setting displays a column
	       * menu within each column.
	       * By default column menu's trigger is hidden before mouse over, but you can always force it to be visible with CSS:
	       *
	       * <pre>
	       *  .ui-grid-column-menu-button {
	       *    display: block;
	       *  }
	       * </pre>
	       */
	      baseOptions.enableColumnMenus = baseOptions.enableColumnMenus !== false;
	
	      /**
	       * @ngdoc boolean
	       * @name enableVerticalScrollbar
	       * @propertyOf ui.grid.class:GridOptions
	       * @description {@link ui.grid.service:uiGridConstants#properties_scrollbars uiGridConstants.scrollbars.ALWAYS} by default.
	       * This settings controls the vertical scrollbar for the grid.
	       * Supported values: uiGridConstants.scrollbars.ALWAYS, uiGridConstants.scrollbars.NEVER, uiGridConstants.scrollbars.WHEN_NEEDED
	       */
	      baseOptions.enableVerticalScrollbar = typeof(baseOptions.enableVerticalScrollbar) !== "undefined" ? baseOptions.enableVerticalScrollbar : uiGridConstants.scrollbars.ALWAYS;
	
	      /**
	       * @ngdoc boolean
	       * @name enableHorizontalScrollbar
	       * @propertyOf ui.grid.class:GridOptions
	       * @description {@link ui.grid.service:uiGridConstants#properties_scrollbars uiGridConstants.scrollbars.ALWAYS} by default.
	       * This settings controls the horizontal scrollbar for the grid.
	       * Supported values: uiGridConstants.scrollbars.ALWAYS, uiGridConstants.scrollbars.NEVER, uiGridConstants.scrollbars.WHEN_NEEDED
	       */
	      baseOptions.enableHorizontalScrollbar = typeof(baseOptions.enableHorizontalScrollbar) !== "undefined" ? baseOptions.enableHorizontalScrollbar : uiGridConstants.scrollbars.ALWAYS;
	
	      /**
	       * @ngdoc boolean
	       * @name enableMinHeightCheck
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, a newly initialized grid will check to see if it is tall enough to display
	       * at least one row of data.  If the grid is not tall enough, it will resize the DOM element to display minRowsToShow number
	       * of rows.
	       */
	       baseOptions.enableMinHeightCheck = baseOptions.enableMinHeightCheck !== false;
	
	      /**
	       * @ngdoc boolean
	       * @name minimumColumnSize
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Sets the default minimum column width, in other words,
	       * it defines the default value for a column minWidth attribute if that is not otherwise specified.
	       * Should be a number. Defaults to 30 pixels.
	       */
	      baseOptions.minimumColumnSize = typeof(baseOptions.minimumColumnSize) !== "undefined" ? baseOptions.minimumColumnSize : 30;
	
	      /**
	       * @ngdoc function
	       * @name rowEquality
	       * @methodOf ui.grid.class:GridOptions
	       * @description By default, rows are compared using object equality.  This option can be overridden
	       * to compare on any data item property or function
	       * @param {object} entityA First Data Item to compare
	       * @param {object} entityB Second Data Item to compare
	       */
	      baseOptions.rowEquality = baseOptions.rowEquality || function(entityA, entityB) {
	        return entityA === entityB;
	      };
	
	      /**
	       * @ngdoc string
	       * @name headerTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Null by default. When provided, this setting uses a custom header
	       * template, rather than the default template. Can be set to either the name of a template file:
	       * <pre>  $scope.gridOptions.headerTemplate = 'header_template.html';</pre>
	       * inline html
	       * <pre>  $scope.gridOptions.headerTemplate = '<div class="ui-grid-top-panel" style="text-align: center">I am a Custom Grid Header</div>'</pre>
	       * or the id of a precompiled template (TBD how to use this).
	       * </br>Refer to the custom header tutorial for more information.
	       * If you want no header at all, you can set to an empty div:
	       * <pre>  $scope.gridOptions.headerTemplate = '<div></div>';</pre>
	       *
	       * If you want to only have a static header, then you can set to static content.  If
	       * you want to tailor the existing column headers, then you should look at the
	       * current 'ui-grid-header.html' template in github as your starting point.
	       *
	       */
	      baseOptions.headerTemplate = baseOptions.headerTemplate || null;
	
	      /**
	       * @ngdoc string
	       * @name footerTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description (optional) ui-grid/ui-grid-footer by default.  This footer shows the per-column
	       * aggregation totals.
	       * When provided, this setting uses a custom footer template. Can be set to either the name of a template file 'footer_template.html', inline html
	       * <pre>'<div class="ui-grid-bottom-panel" style="text-align: center">I am a Custom Grid Footer</div>'</pre>, or the id
	       * of a precompiled template (TBD how to use this).  Refer to the custom footer tutorial for more information.
	       */
	      baseOptions.footerTemplate = baseOptions.footerTemplate || 'ui-grid/ui-grid-footer';
	
	      /**
	       * @ngdoc string
	       * @name gridFooterTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description (optional) ui-grid/ui-grid-grid-footer by default. This template by default shows the
	       * total items at the bottom of the grid, and the selected items if selection is enabled.
	       */
	      baseOptions.gridFooterTemplate = baseOptions.gridFooterTemplate || 'ui-grid/ui-grid-grid-footer';
	
	      /**
	       * @ngdoc string
	       * @name rowTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description 'ui-grid/ui-grid-row' by default. When provided, this setting uses a
	       * custom row template.  Can be set to either the name of a template file:
	       * <pre> $scope.gridOptions.rowTemplate = 'row_template.html';</pre>
	       * inline html
	       * <pre>  $scope.gridOptions.rowTemplate = '<div style="background-color: aquamarine" ng-click="grid.appScope.fnOne(row)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';</pre>
	       * or the id of a precompiled template (TBD how to use this) can be provided.
	       * </br>Refer to the custom row template tutorial for more information.
	       */
	      baseOptions.rowTemplate = baseOptions.rowTemplate || 'ui-grid/ui-grid-row';
	
	      /**
	      * @ngdoc string
	      * @name gridMenuTemplate
	      * @propertyOf ui.grid.class:GridOptions
	      * @description 'ui-grid/uiGridMenu' by default. When provided, this setting uses a
	      * custom grid menu template.
	      */
	      baseOptions.gridMenuTemplate = baseOptions.gridMenuTemplate || 'ui-grid/uiGridMenu';
	
	            /**
	       * @ngdoc string
	       * @name menuButtonTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description 'ui-grid/ui-grid-menu-button' by default. When provided, this setting uses a custom grid menu button
	       * template. Can be set to either the name of a template file 'menuButton_template.html', inline html
	       * <pre>'<div class="ui-grid-menu-button" ng-click="customToggleMenu()"><div class="ui-grid-icon-container"><i class="ui-grid-icon=menu">&nbsp;</i></div></div><div ui-grid-menu menu-items="menuItems"></div>'</pre>, or the id
	       * of a precompiled template (TBD how to use this).  Refer to the custom footer tutorial for more information.
	       */
	      baseOptions.menuButtonTemplate = baseOptions.menuButtonTemplate || 'ui-grid/ui-grid-menu-button';
	
	      /**
	       * @ngdoc string
	       * @name menuItemTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description 'ui-grid/uiGridMenuItem' by default. When provided, this setting uses a custom grid menu item
	       * template. Can be set to either the name of a template file 'menuItem_template.html', inline html
	       * <pre>'<li class="ui-grid-menu-item"><label>{{name}}</label></li>'</pre>, or the id
	       * of a precompiled template (TBD how to use this).  Refer to the custom footer tutorial for more information.
	       */
	      baseOptions.menuItemTemplate = baseOptions.menuItemTemplate || 'ui-grid/uiGridMenuItem';
	
	      /**
	       * @ngdoc object
	       * @name appScopeProvider
	       * @propertyOf ui.grid.class:GridOptions
	       * @description by default, the parent scope of the ui-grid element will be assigned to grid.appScope
	       * this property allows you to assign any reference you want to grid.appScope
	       */
	      baseOptions.appScopeProvider = baseOptions.appScopeProvider || null;
	
	      return baseOptions;
	    }
	  };
	}]);
	})();
	
	(function() {
	
	angular.module('ui.grid')
	
	  /**
	   * @ngdoc function
	   * @name ui.grid.class:GridRenderContainer
	   * @description The grid has render containers, allowing the ability to have pinned columns.  If the grid
	   * is right-to-left then there may be a right render container, if left-to-right then there may
	   * be a left render container.  There is always a body render container.
	   * @param {string} name The name of the render container ('body', 'left', or 'right')
	   * @param {Grid} grid the grid the render container is in
	   * @param {object} options the render container options
	   */
	.factory('GridRenderContainer', ['gridUtil', 'uiGridConstants', function(gridUtil, uiGridConstants) {
	  function GridRenderContainer(name, grid, options) {
	    var self = this;
	
	    // if (gridUtil.type(grid) !== 'Grid') {
	    //   throw new Error('Grid argument is not a Grid object');
	    // }
	
	    self.name = name;
	
	    self.grid = grid;
	
	    // self.rowCache = [];
	    // self.columnCache = [];
	
	    self.visibleRowCache = [];
	    self.visibleColumnCache = [];
	
	    self.renderedRows = [];
	    self.renderedColumns = [];
	
	    self.prevScrollTop = 0;
	    self.prevScrolltopPercentage = 0;
	    self.prevRowScrollIndex = 0;
	
	    self.prevScrollLeft = 0;
	    self.prevScrollleftPercentage = 0;
	    self.prevColumnScrollIndex = 0;
	
	    self.columnStyles = '';
	
	    self.viewportAdjusters = [];
	
	    /**
	     *  @ngdoc boolean
	     *  @name hasHScrollbar
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description flag to signal that container has a horizontal scrollbar
	     */
	    self.hasHScrollbar = false;
	
	    /**
	     *  @ngdoc boolean
	     *  @name hasVScrollbar
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description flag to signal that container has a vertical scrollbar
	     */
	    self.hasVScrollbar = false;
	
	    /**
	     *  @ngdoc boolean
	     *  @name canvasHeightShouldUpdate
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description flag to signal that container should recalculate the canvas size
	     */
	    self.canvasHeightShouldUpdate = true;
	
	    /**
	     *  @ngdoc boolean
	     *  @name canvasHeight
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description last calculated canvas height value
	     */
	    self.$$canvasHeight = 0;
	
	    if (options && angular.isObject(options)) {
	      angular.extend(self, options);
	    }
	
	    grid.registerStyleComputation({
	      priority: 5,
	      func: function () {
	        self.updateColumnWidths();
	        return self.columnStyles;
	      }
	    });
	  }
	
	
	  GridRenderContainer.prototype.reset = function reset() {
	    // this.rowCache.length = 0;
	    // this.columnCache.length = 0;
	
	    this.visibleColumnCache.length = 0;
	    this.visibleRowCache.length = 0;
	
	    this.renderedRows.length = 0;
	    this.renderedColumns.length = 0;
	  };
	
	  // TODO(c0bra): calculate size?? Should this be in a stackable directive?
	
	
	  GridRenderContainer.prototype.containsColumn = function (col) {
	     return this.visibleColumnCache.indexOf(col) !== -1;
	  };
	
	  GridRenderContainer.prototype.minRowsToRender = function minRowsToRender() {
	    var self = this;
	    var minRows = 0;
	    var rowAddedHeight = 0;
	    var viewPortHeight = self.getViewportHeight();
	    for (var i = self.visibleRowCache.length - 1; rowAddedHeight < viewPortHeight && i >= 0; i--) {
	      rowAddedHeight += self.visibleRowCache[i].height;
	      minRows++;
	    }
	    return minRows;
	  };
	
	  GridRenderContainer.prototype.minColumnsToRender = function minColumnsToRender() {
	    var self = this;
	    var viewportWidth = this.getViewportWidth();
	
	    var min = 0;
	    var totalWidth = 0;
	
	    for (var i = 0; i < self.visibleColumnCache.length; i++) {
	      var col = self.visibleColumnCache[i];
	
	      if (totalWidth < viewportWidth) {
	        totalWidth += col.drawnWidth ? col.drawnWidth : 0;
	        min++;
	      }
	      else {
	        var currWidth = 0;
	        for (var j = i; j >= i - min; j--) {
	          currWidth += self.visibleColumnCache[j].drawnWidth ? self.visibleColumnCache[j].drawnWidth : 0;
	        }
	        if (currWidth < viewportWidth) {
	          min++;
	        }
	      }
	    }
	
	    return min;
	  };
	
	  GridRenderContainer.prototype.getVisibleRowCount = function getVisibleRowCount() {
	    return this.visibleRowCache.length;
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerViewportAdjuster
	   * @methodOf ui.grid.class:GridRenderContainer
	   * @description Registers an adjuster to the render container's available width or height.  Adjusters are used
	   * to tell the render container that there is something else consuming space, and to adjust it's size
	   * appropriately.
	   * @param {function} func the adjuster function we want to register
	   */
	
	  GridRenderContainer.prototype.registerViewportAdjuster = function registerViewportAdjuster(func) {
	    this.viewportAdjusters.push(func);
	  };
	
	  /**
	   * @ngdoc function
	   * @name removeViewportAdjuster
	   * @methodOf ui.grid.class:GridRenderContainer
	   * @description Removes an adjuster, should be used when your element is destroyed
	   * @param {function} func the adjuster function we want to remove
	   */
	  GridRenderContainer.prototype.removeViewportAdjuster = function removeViewportAdjuster(func) {
	    var idx = this.viewportAdjusters.indexOf(func);
	
	    if (idx > -1) {
	      this.viewportAdjusters.splice(idx, 1);
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name getViewportAdjustment
	   * @methodOf ui.grid.class:GridRenderContainer
	   * @description Gets the adjustment based on the viewportAdjusters.
	   * @returns {object} a hash of { height: x, width: y }.  Usually the values will be negative
	   */
	  GridRenderContainer.prototype.getViewportAdjustment = function getViewportAdjustment() {
	    var self = this;
	
	    var adjustment = { height: 0, width: 0 };
	
	    self.viewportAdjusters.forEach(function (func) {
	      adjustment = func.call(this, adjustment);
	    });
	
	    return adjustment;
	  };
	
	  GridRenderContainer.prototype.getMargin = function getMargin(side) {
	    var self = this;
	
	    var amount = 0;
	
	    self.viewportAdjusters.forEach(function (func) {
	      var adjustment = func.call(this, { height: 0, width: 0 });
	
	      if (adjustment.side && adjustment.side === side) {
	        amount += adjustment.width * -1;
	      }
	    });
	
	    return amount;
	  };
	
	  GridRenderContainer.prototype.getViewportHeight = function getViewportHeight() {
	    var self = this;
	
	    var headerHeight = (self.headerHeight) ? self.headerHeight : self.grid.headerHeight;
	
	    var viewPortHeight = self.grid.gridHeight - headerHeight - self.grid.footerHeight;
	
	
	    var adjustment = self.getViewportAdjustment();
	
	    viewPortHeight = viewPortHeight + adjustment.height;
	
	    return viewPortHeight > 0 ? viewPortHeight : 0;
	  };
	
	  GridRenderContainer.prototype.getViewportWidth = function getViewportWidth() {
	    var self = this;
	
	    var viewportWidth = self.grid.gridWidth;
	
	    // if (typeof(self.grid.verticalScrollbarWidth) !== 'undefined' && self.grid.verticalScrollbarWidth !== undefined &&
	    //  self.grid.verticalScrollbarWidth > 0) {
	    //   viewPortWidth = viewPortWidth - self.grid.verticalScrollbarWidth;
	    // }
	
	    // var viewportWidth = 0;\
	    // self.visibleColumnCache.forEach(function (column) {
	    //   viewportWidth += column.drawnWidth;
	    // });
	
	    var adjustment = self.getViewportAdjustment();
	
	    viewportWidth = viewportWidth + adjustment.width;
	
	    return viewportWidth;
	  };
	
	  GridRenderContainer.prototype.getHeaderViewportWidth = function getHeaderViewportWidth() {
	    return this.getViewportWidth();
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name getCanvasHeight
	   * @methodOf ui.grid.class:GridRenderContainer
	   * @description Returns the total canvas height.   Only recalculates if canvasHeightShouldUpdate = false
	   * @returns {number} total height of all the visible rows in the container
	   */
	  GridRenderContainer.prototype.getCanvasHeight = function getCanvasHeight() {
	    var self = this;
	
	    if (!self.canvasHeightShouldUpdate) {
	      return self.$$canvasHeight;
	    }
	
	    var oldCanvasHeight = self.$$canvasHeight;
	
	    self.$$canvasHeight = 0;
	
	    self.visibleRowCache.forEach(function(row) {
	      self.$$canvasHeight += row.height;
	    });
	
	
	    self.canvasHeightShouldUpdate = false;
	
	    self.grid.api.core.raise.canvasHeightChanged(oldCanvasHeight, self.$$canvasHeight);
	
	    return self.$$canvasHeight;
	  };
	
	  GridRenderContainer.prototype.getVerticalScrollLength = function getVerticalScrollLength() {
	    return this.getCanvasHeight() - this.getViewportHeight() + this.grid.scrollbarHeight !== 0 ? this.getCanvasHeight() - this.getViewportHeight() + this.grid.scrollbarHeight : -1;
	  };
	
	  GridRenderContainer.prototype.getHorizontalScrollLength = function getHorizontalScrollLength() {
	    return this.getCanvasWidth() - this.getViewportWidth() + this.grid.scrollbarWidth !== 0 ? this.getCanvasWidth() - this.getViewportWidth() + this.grid.scrollbarWidth : -1;
	  };
	
	  GridRenderContainer.prototype.getCanvasWidth = function getCanvasWidth() {
	    var self = this;
	
	    return self.canvasWidth;
	  };
	
	  GridRenderContainer.prototype.setRenderedRows = function setRenderedRows(newRows) {
	    this.renderedRows.length = newRows.length;
	    for (var i = 0; i < newRows.length; i++) {
	      this.renderedRows[i] = newRows[i];
	    }
	  };
	
	  GridRenderContainer.prototype.setRenderedColumns = function setRenderedColumns(newColumns) {
	    // OLD:
	    this.renderedColumns.length = newColumns.length;
	    for (var i = 0; i < newColumns.length; i++) {
	      this.renderedColumns[i] = newColumns[i];
	    }
	
	    this.updateColumnOffset();
	  };
	
	  GridRenderContainer.prototype.updateColumnOffset = function updateColumnOffset() {
	    // Calculate the width of the columns on the left side that are no longer rendered.
	    //  That will be the offset for the columns as we scroll horizontally.
	    var hiddenColumnsWidth = 0;
	    for (var i = 0; i < this.currentFirstColumn; i++) {
	      hiddenColumnsWidth += this.visibleColumnCache[i].drawnWidth;
	    }
	
	    this.columnOffset = hiddenColumnsWidth;
	  };
	
	  GridRenderContainer.prototype.scrollVertical = function (newScrollTop) {
	    var vertScrollPercentage = -1;
	
	    if (newScrollTop !== this.prevScrollTop) {
	      var yDiff = newScrollTop - this.prevScrollTop;
	
	      if (yDiff > 0 ) { this.grid.scrollDirection = uiGridConstants.scrollDirection.DOWN; }
	      if (yDiff < 0 ) { this.grid.scrollDirection = uiGridConstants.scrollDirection.UP; }
	
	      var vertScrollLength = this.getVerticalScrollLength();
	
	      vertScrollPercentage = newScrollTop / vertScrollLength;
	
	      if (vertScrollPercentage > 1) { vertScrollPercentage = 1; }
	      if (vertScrollPercentage < 0) { vertScrollPercentage = 0; }
	
	      this.adjustScrollVertical(newScrollTop, vertScrollPercentage);
	      return vertScrollPercentage;
	    }
	  };
	
	  GridRenderContainer.prototype.scrollHorizontal = function(newScrollLeft) {
	    var horizScrollPercentage = -1;
	
	    // Handle RTL here
	    if (newScrollLeft !== this.prevScrollLeft) {
	      var xDiff = newScrollLeft - this.prevScrollLeft;
	
	      if (xDiff > 0) { this.grid.scrollDirection = uiGridConstants.scrollDirection.RIGHT; }
	      if (xDiff < 0) { this.grid.scrollDirection = uiGridConstants.scrollDirection.LEFT; }
	
	      var horizScrollLength = this.getHorizontalScrollLength();
	      if (horizScrollLength !== 0) {
	        horizScrollPercentage = newScrollLeft / horizScrollLength;
	      }
	      else {
	        horizScrollPercentage = 0;
	      }
	
	      this.adjustScrollHorizontal(newScrollLeft, horizScrollPercentage);
	      return horizScrollPercentage;
	    }
	  };
	
	  GridRenderContainer.prototype.adjustScrollVertical = function adjustScrollVertical(scrollTop, scrollPercentage, force) {
	    if (this.prevScrollTop === scrollTop && !force) {
	      return;
	    }
	
	    if (typeof(scrollTop) === 'undefined' || scrollTop === undefined || scrollTop === null) {
	      scrollTop = (this.getCanvasHeight() - this.getViewportHeight()) * scrollPercentage;
	    }
	
	    this.adjustRows(scrollTop, scrollPercentage, false);
	
	    this.prevScrollTop = scrollTop;
	    this.prevScrolltopPercentage = scrollPercentage;
	
	    this.grid.queueRefresh();
	  };
	
	  GridRenderContainer.prototype.adjustScrollHorizontal = function adjustScrollHorizontal(scrollLeft, scrollPercentage, force) {
	    if (this.prevScrollLeft === scrollLeft && !force) {
	      return;
	    }
	
	    if (typeof(scrollLeft) === 'undefined' || scrollLeft === undefined || scrollLeft === null) {
	      scrollLeft = (this.getCanvasWidth() - this.getViewportWidth()) * scrollPercentage;
	    }
	
	    this.adjustColumns(scrollLeft);
	
	    this.prevScrollLeft = scrollLeft;
	    this.prevScrollleftPercentage = scrollPercentage;
	
	    this.grid.queueRefresh();
	  };
	
	  GridRenderContainer.prototype.adjustRows = function adjustRows(scrollTop, scrollPercentage, postDataLoaded) {
	    var self = this;
	
	    var minRows = self.minRowsToRender();
	
	    var rowCache = self.visibleRowCache;
	
	    var maxRowIndex = rowCache.length - minRows;
	
	    // Calculate the scroll percentage according to the scrollTop location, if no percentage was provided
	    if ((typeof(scrollPercentage) === 'undefined' || scrollPercentage === null) && scrollTop) {
	      scrollPercentage = scrollTop / self.getVerticalScrollLength();
	    }
	
	    var rowIndex = Math.ceil(Math.min(maxRowIndex, maxRowIndex * scrollPercentage));
	
	    // Define a max row index that we can't scroll past
	    if (rowIndex > maxRowIndex) {
	      rowIndex = maxRowIndex;
	    }
	
	    var newRange = [];
	    if (rowCache.length > self.grid.options.virtualizationThreshold) {
	      if (!(typeof(scrollTop) === 'undefined' || scrollTop === null)) {
	        // Have we hit the threshold going down?
	        if ( !self.grid.suppressParentScrollDown && self.prevScrollTop < scrollTop && rowIndex < self.prevRowScrollIndex + self.grid.options.scrollThreshold && rowIndex < maxRowIndex) {
	          return;
	        }
	        // Have we hit the threshold going up?
	        if ( !self.grid.suppressParentScrollUp && self.prevScrollTop > scrollTop && rowIndex > self.prevRowScrollIndex - self.grid.options.scrollThreshold && rowIndex < maxRowIndex) {
	          return;
	        }
	      }
	
	      var rangeStart = Math.max(0, rowIndex - self.grid.options.excessRows);
	      var rangeEnd = Math.min(rowCache.length, rowIndex + minRows + self.grid.options.excessRows);
	
	      newRange = [rangeStart, rangeEnd];
	    }
	    else {
	      var maxLen = self.visibleRowCache.length;
	      newRange = [0, Math.max(maxLen, minRows + self.grid.options.excessRows)];
	    }
	
	    self.updateViewableRowRange(newRange);
	
	    self.prevRowScrollIndex = rowIndex;
	  };
	
	  GridRenderContainer.prototype.adjustColumns = function adjustColumns(scrollLeft) {
	    var self = this;
	
	    var minCols = self.minColumnsToRender();
	
	    var columnCache = self.visibleColumnCache;
	    var maxColumnIndex = columnCache.length - minCols;
	
	    var colIndex = Math.min(maxColumnIndex, self.getLeftIndex(scrollLeft));
	
	    var newRange = [];
	    if (columnCache.length > self.grid.options.columnVirtualizationThreshold && self.getCanvasWidth() > self.getViewportWidth()) {
	      var rangeStart = Math.max(0, colIndex - self.grid.options.excessColumns);
	      var rangeEnd = Math.min(columnCache.length, colIndex + minCols + self.grid.options.excessColumns);
	
	      newRange = [rangeStart, rangeEnd];
	    }
	    else {
	      var maxLen = self.visibleColumnCache.length;
	
	      newRange = [0, Math.max(maxLen, minCols + self.grid.options.excessColumns)];
	    }
	
	    self.updateViewableColumnRange(newRange);
	
	    self.prevColumnScrollIndex = colIndex;
	  };
	
	  GridRenderContainer.prototype.getLeftIndex = function getLeftIndex(scrollLeft) {
	    var wholeLeftWidth = 0;
	    var index = 0
	    for (index; index < this.visibleColumnCache.length; index++) {
	      if (this.visibleColumnCache[index] && this.visibleColumnCache[index].visible) {
	        // accumulate the whole width of columns on the left side, till the point of visibility is surpassed, this is our wanted index
	        wholeLeftWidth += this.visibleColumnCache[index].drawnWidth;
	        if (wholeLeftWidth >= scrollLeft) {
	          break;
	        }
	      }
	    }
	    return index;
	  }
	
	  // Method for updating the visible rows
	  GridRenderContainer.prototype.updateViewableRowRange = function updateViewableRowRange(renderedRange) {
	    // Slice out the range of rows from the data
	    // var rowArr = uiGridCtrl.grid.rows.slice(renderedRange[0], renderedRange[1]);
	    var rowArr = this.visibleRowCache.slice(renderedRange[0], renderedRange[1]);
	
	    // Define the top-most rendered row
	    this.currentTopRow = renderedRange[0];
	
	    this.setRenderedRows(rowArr);
	  };
	
	  // Method for updating the visible columns
	  GridRenderContainer.prototype.updateViewableColumnRange = function updateViewableColumnRange(renderedRange) {
	    // Slice out the range of rows from the data
	    // var columnArr = uiGridCtrl.grid.columns.slice(renderedRange[0], renderedRange[1]);
	    var columnArr = this.visibleColumnCache.slice(renderedRange[0], renderedRange[1]);
	
	    // Define the left-most rendered columns
	    this.currentFirstColumn = renderedRange[0];
	
	    this.setRenderedColumns(columnArr);
	  };
	
	  GridRenderContainer.prototype.headerCellWrapperStyle = function () {
	    var self = this;
	
	    if (self.currentFirstColumn !== 0) {
	      var offset = self.columnOffset;
	
	      if (self.grid.isRTL()) {
	        return { 'margin-right': offset + 'px' };
	      }
	      else {
	        return { 'margin-left': offset + 'px' };
	      }
	    }
	
	    return null;
	  };
	
	    /**
	     *  @ngdoc boolean
	     *  @name updateColumnWidths
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description Determine the appropriate column width of each column across all render containers.
	     *
	     *  Column width is easy when each column has a specified width.  When columns are variable width (i.e.
	     *  have an * or % of the viewport) then we try to calculate so that things fit in.  The problem is that
	     *  we have multiple render containers, and we don't want one render container to just take the whole viewport
	     *  when it doesn't need to - we want things to balance out across the render containers.
	     *
	     *  To do this, we use this method to calculate all the renderContainers, recognising that in a given render
	     *  cycle it'll get called once per render container, so it needs to return the same values each time.
	     *
	     *  The constraints on this method are therefore:
	     *  - must return the same value when called multiple times, to do this it needs to rely on properties of the
	     *    columns, but not properties that change when this is called (so it shouldn't rely on drawnWidth)
	     *
	     *  The general logic of this method is:
	     *  - calculate our total available width
	     *  - look at all the columns across all render containers, and work out which have widths and which have
	     *    constraints such as % or * or something else
	     *  - for those with *, count the total number of * we see and add it onto a running total, add this column to an * array
	     *  - for those with a %, allocate the % as a percentage of the viewport, having consideration of min and max
	     *  - for those with manual width (in pixels) we set the drawnWidth to the specified width
	     *  - we end up with an asterisks array still to process
	     *  - we look at our remaining width.  If it's greater than zero, we divide it up among the asterisk columns, then process
	     *    them for min and max width constraints
	     *  - if it's zero or less, we set the asterisk columns to their minimum widths
	     *  - we use parseInt quite a bit, as we try to make all our column widths integers
	     */
	  GridRenderContainer.prototype.updateColumnWidths = function () {
	    var self = this;
	
	    var asterisksArray = [],
	        asteriskNum = 0,
	        usedWidthSum = 0,
	        ret = '',
	        pinRightColumn = false,
	        fixedNumberArray = [],
	        percentageArray = [],
	        totalPercentage = 0;
	
	    // Get the width of the viewport
	    var availableWidth = self.grid.getViewportWidth() - self.grid.scrollbarWidth;
	
	    // get all the columns across all render containers, we have to calculate them all or one render container
	    // could consume the whole viewport
	    var columnCache = [];
	    angular.forEach(self.grid.renderContainers, function (container) {
	      columnCache = columnCache.concat(container.visibleColumnCache);
	    });
	
	    // look at each column, process any manual values or %, put the * into an array to look at later
	    columnCache.forEach(function (column) {
	      var width = 0;
	      // Skip hidden columns
	      if (!column.visible) { return; }
	
	      if (pinRightColumn) {
	        availableWidth += self.grid.scrollbarWidth;
	      }
	
	      if (!pinRightColumn && column.colDef.pinnedRight) {
	        pinRightColumn = true;
	      }
	
	      if (angular.isNumber(column.width)) {
	        // pixel width, set to this value
	        if (column.colDef.allowFloatWidth) {
	          width = parseFloat(column.width);
	        } else {
	          width = parseInt(column.width, 10);
	        }
	
	        usedWidthSum = usedWidthSum + width;
	        column.drawnWidth = width;
	
	        fixedNumberArray.push(column);
	      } else if (gridUtil.endsWith(column.width, '%')) {
	        // percentage width, set to percentage of the viewport
	        // round down to int - some browsers don't play nice with float maxWidth
	        var percentageIntegerValue = parseInt(column.width.replace(/%/g, ''), 10);
	        if (column.colDef.allowFloatWidth) {
	          width = parseFloat(percentageIntegerValue / 100 * availableWidth);
	        } else {
	          width = parseInt(percentageIntegerValue / 100 * availableWidth, 10);
	        }
	
	
	        if (width > column.maxWidth) {
	          width = column.maxWidth;
	        }
	
	        if (width < column.minWidth) {
	          width = column.minWidth;
	        }
	
	        usedWidthSum = usedWidthSum + width;
	        column.drawnWidth = width;
	
	        totalPercentage = totalPercentage + percentageIntegerValue;
	        percentageArray.push(column);
	      } else if (angular.isString(column.width) && column.width.indexOf('*') !== -1) {
	        // is an asterisk column, the gridColumn already checked the string consists only of '****'
	        asteriskNum = asteriskNum + column.width.length;
	        asterisksArray.push(column);
	      }
	    });
	
	    // Get the remaining width (available width subtracted by the used widths sum)
	    var remainingWidth = availableWidth - usedWidthSum;
	
	    if (asterisksArray.length > 0) {
	      // the width that each asterisk value would be assigned (this can be negative)
	      var asteriskVal = remainingWidth / asteriskNum;
	
	      asterisksArray.forEach(function (column) {
	        var width = parseInt(column.width.length * asteriskVal, 10);
	
	        if (column.colDef.allowFloatWidth) {
	          width = parseFloat(column.width.length * asteriskVal);
	        }
	
	
	        if (width > column.maxWidth) {
	            width = column.maxWidth;
	        }
	
	        if (width < column.minWidth) {
	            width = column.minWidth;
	        }
	
	        usedWidthSum = usedWidthSum + width;
	        column.drawnWidth = width;
	      });
	    }
	
	    // If there are no columns with asterisk widths then check if there are any with % widths and
	    // use them as a fallback for adjusting column widths up or down if we have remaining grid width
	    // or need to claw some width back
	    var variableWidthColumnArray;
	    if (asterisksArray.length > 0) {
	      variableWidthColumnArray = asterisksArray;
	    } else if (percentageArray.length > 0 && fixedNumberArray.length === 0 && totalPercentage === 100) {
	      variableWidthColumnArray = percentageArray;
	    }
	
	    if (!angular.isUndefined(variableWidthColumnArray)) {
	      // If the grid width didn't divide evenly into the column widths and we have pixels left over, or our
	      // calculated widths would have the grid narrower than the available space,
	      // dole the remainder out one by one to make everything fit
	      var processColumnUpwards = function (column) {
	        if (column.drawnWidth < column.maxWidth && leftoverWidth > 0) {
	          column.drawnWidth++;
	          usedWidthSum++;
	          leftoverWidth--;
	          columnsToChange = true;
	        }
	      };
	
	      var leftoverWidth = availableWidth - usedWidthSum;
	      var columnsToChange = true;
	
	      while (leftoverWidth > 0 && columnsToChange) {
	        columnsToChange = false;
	        variableWidthColumnArray.forEach(processColumnUpwards);
	      }
	
	      // We can end up with too much width even though some columns aren't at their max width, in this situation
	      // we can trim the columns a little
	      var processColumnDownwards = function (column) {
	        if (column.drawnWidth > column.minWidth && excessWidth > 0) {
	          column.drawnWidth--;
	          usedWidthSum--;
	          excessWidth--;
	          columnsToChange = true;
	        }
	      };
	
	      var excessWidth = usedWidthSum - availableWidth;
	      columnsToChange = true;
	
	      while (excessWidth > 0 && columnsToChange) {
	        columnsToChange = false;
	        variableWidthColumnArray.forEach(processColumnDownwards);
	      }
	    }
	
	    // all that was across all the renderContainers, now we need to work out what that calculation decided for
	    // our renderContainer
	    var canvasWidth = 0;
	    self.visibleColumnCache.forEach(function(column) {
	      if ( column.visible ) {
	        canvasWidth = canvasWidth + column.drawnWidth;
	      }
	    });
	
	    // Build the CSS
	    columnCache.forEach(function (column) {
	      ret = ret + column.getColClassDefinition();
	    });
	
	    self.canvasWidth = canvasWidth;
	
	    // Return the styles back to buildStyles which pops them into the `customStyles` scope variable
	    // return ret;
	
	    // Set this render container's column styles so they can be used in style computation
	    this.columnStyles = ret;
	  };
	
	  GridRenderContainer.prototype.needsHScrollbarPlaceholder = function () {
	    var self = this,
	      containerBody;
	
	    if (self.name === 'left' || self.name === 'right' && !this.hasHScrollbar && !this.grid.disableScrolling) {
	      if (self.grid.options.enableHorizontalScrollbar === uiGridConstants.scrollbars.ALWAYS) {
	        return true;
	      }
	      containerBody = this.grid.element[0].querySelector('.ui-grid-render-container-body .ui-grid-viewport');
	      return containerBody.scrollWidth > containerBody.offsetWidth;
	    }
	    return false;
	  };
	
	  GridRenderContainer.prototype.getViewportStyle = function () {
	    var self = this;
	    var styles = {};
	    var scrollbarVisibility = {};
	
	    scrollbarVisibility[uiGridConstants.scrollbars.ALWAYS] = 'scroll';
	    scrollbarVisibility[uiGridConstants.scrollbars.WHEN_NEEDED] = 'auto';
	
	    self.hasHScrollbar = false;
	    self.hasVScrollbar = false;
	
	    if (self.grid.disableScrolling) {
	      styles['overflow-x'] = 'hidden';
	      styles['overflow-y'] = 'hidden';
	      return styles;
	    }
	
	    if (self.name === 'body') {
	      self.hasHScrollbar = self.grid.options.enableHorizontalScrollbar !== uiGridConstants.scrollbars.NEVER;
	      if (!self.grid.isRTL()) {
	        if (!self.grid.hasRightContainerColumns()) {
	          self.hasVScrollbar = self.grid.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER;
	        }
	      }
	      else {
	        if (!self.grid.hasLeftContainerColumns()) {
	          self.hasVScrollbar = self.grid.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER;
	        }
	      }
	    }
	    else if (self.name === 'left') {
	      self.hasVScrollbar = self.grid.isRTL() ? self.grid.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER : false;
	    }
	    else {
	      self.hasVScrollbar = !self.grid.isRTL() ? self.grid.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER : false;
	    }
	
	    styles['overflow-x'] = self.hasHScrollbar ? scrollbarVisibility[self.grid.options.enableHorizontalScrollbar] : 'hidden';
	    styles['overflow-y'] = self.hasVScrollbar ? scrollbarVisibility[self.grid.options.enableVerticalScrollbar] : 'hidden';
	
	    return styles;
	  };
	
	  return GridRenderContainer;
	}]);
	
	})();
	
	(function() {
	
	angular.module('ui.grid')
	.factory('GridRow', ['gridUtil', 'uiGridConstants', function(gridUtil, uiGridConstants) {
	
	   /**
	   * @class GridRow
	   * @ngdoc function
	   * @name ui.grid.class:GridRow
	   * @description GridRow is the viewModel for one logical row on the grid.  A grid Row is not necessarily a one-to-one
	   * relation to gridOptions.data.
	   * @param {object} entity the array item from GridOptions.data
	   * @param {number} index the current position of the row in the array
	   * @param {Grid} grid reference to the parent grid
	   */
	  function GridRow(entity, index, grid) {
	
	     /**
	      *  @ngdoc object
	      *  @name grid
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description A reference back to the grid
	      */
	     this.grid = grid;
	
	     /**
	      *  @ngdoc object
	      *  @name entity
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description A reference to an item in gridOptions.data[]
	      */
	    this.entity = entity;
	
	    /**
	      *  @ngdoc object
	      *  @name index
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description The current position of the row in the array
	      */
	     this.index = index;
	
	     /**
	      *  @ngdoc object
	      *  @name uid
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description  UniqueId of row
	      */
	     this.uid = gridUtil.nextUid();
	
	     /**
	      *  @ngdoc object
	      *  @name visible
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description If true, the row will be rendered
	      */
	    // Default to true
	    this.visible = true;
	
	     /**
	      *  @ngdoc object
	      *  @name isSelected
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description Marks if the row has been selected
	      */
	     // Default to false
	     this.isSelected = false;
	
	
	    this.$$height = grid.options.rowHeight;
	
	  }
	
	    /**
	     *  @ngdoc object
	     *  @name height
	     *  @propertyOf ui.grid.class:GridRow
	     *  @description height of each individual row. changing the height will flag all
	     *  row renderContainers to recalculate their canvas height
	     */
	    Object.defineProperty(GridRow.prototype, 'height', {
	      get: function() {
	        return this.$$height;
	      },
	      set: function(height) {
	        if (height !== this.$$height) {
	          this.grid.updateCanvasHeight();
	          this.$$height = height;
	        }
	      }
	    });
	
	  /**
	   * @ngdoc function
	   * @name getQualifiedColField
	   * @methodOf ui.grid.class:GridRow
	   * @description returns the qualified field name as it exists on scope
	   * ie: row.entity.fieldA
	   * @param {GridColumn} col column instance
	   * @returns {string} resulting name that can be evaluated on scope
	   */
	    GridRow.prototype.getQualifiedColField = function(col) {
	      return 'row.' + this.getEntityQualifiedColField(col);
	    };
	
	    /**
	     * @ngdoc function
	     * @name getEntityQualifiedColField
	     * @methodOf ui.grid.class:GridRow
	     * @description returns the qualified field name minus the row path
	     * ie: entity.fieldA
	     * @param {GridColumn} col column instance
	     * @returns {string} resulting name that can be evaluated against a row
	     */
	  GridRow.prototype.getEntityQualifiedColField = function(col) {
	    var base = 'entity';
	    if ( col.field === uiGridConstants.ENTITY_BINDING ) {
	      return base;
	    }
	    return gridUtil.preEval(base + '.' + col.field);
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name setRowInvisible
	   * @methodOf  ui.grid.class:GridRow
	   * @description Sets an override on the row that forces it to always
	   * be invisible. Emits the rowsVisibleChanged event if it changed the row visibility.
	   *
	   * This method can be called from the api, passing in the gridRow we want
	   * altered.  It should really work by calling gridRow.setRowInvisible, but that's
	   * not the way I coded it, and too late to change now.  Changed to just call
	   * the internal function row.setThisRowInvisible().
	   *
	   * @param {GridRow} row the row we want to set to invisible
	   *
	   */
	  GridRow.prototype.setRowInvisible = function ( row ) {
	    if (row && row.setThisRowInvisible) {
	      row.setThisRowInvisible( 'user' );
	    }
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name clearRowInvisible
	   * @methodOf  ui.grid.class:GridRow
	   * @description Clears an override on the row that forces it to always
	   * be invisible. Emits the rowsVisibleChanged event if it changed the row visibility.
	   *
	   * This method can be called from the api, passing in the gridRow we want
	   * altered.  It should really work by calling gridRow.clearRowInvisible, but that's
	   * not the way I coded it, and too late to change now.  Changed to just call
	   * the internal function row.clearThisRowInvisible().
	   *
	   * @param {GridRow} row the row we want to clear the invisible flag
	   *
	   */
	  GridRow.prototype.clearRowInvisible = function ( row ) {
	    if (row && row.clearThisRowInvisible) {
	      row.clearThisRowInvisible( 'user' );
	    }
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name setThisRowInvisible
	   * @methodOf  ui.grid.class:GridRow
	   * @description Sets an override on the row that forces it to always
	   * be invisible. Emits the rowsVisibleChanged event if it changed the row visibility
	   *
	   * @param {string} reason the reason (usually the module) for the row to be invisible.
	   * E.g. grouping, user, filter
	   * @param {boolean} fromRowsProcessor whether we were called from a rowsProcessor, passed through to evaluateRowVisibility
	   */
	  GridRow.prototype.setThisRowInvisible = function ( reason, fromRowsProcessor ) {
	    if ( !this.invisibleReason ) {
	      this.invisibleReason = {};
	    }
	    this.invisibleReason[reason] = true;
	    this.evaluateRowVisibility( fromRowsProcessor);
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name clearRowInvisible
	   * @methodOf ui.grid.class:GridRow
	   * @description Clears any override on the row visibility, returning it
	   * to normal visibility calculations.  Emits the rowsVisibleChanged
	   * event
	   *
	   * @param {string} reason the reason (usually the module) for the row to be invisible.
	   * E.g. grouping, user, filter
	   * @param {boolean} fromRowsProcessor whether we were called from a rowsProcessor, passed through to evaluateRowVisibility
	   */
	  GridRow.prototype.clearThisRowInvisible = function ( reason, fromRowsProcessor ) {
	    if (typeof(this.invisibleReason) !== 'undefined' ) {
	      delete this.invisibleReason[reason];
	    }
	    this.evaluateRowVisibility( fromRowsProcessor );
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name evaluateRowVisibility
	   * @methodOf ui.grid.class:GridRow
	   * @description Determines whether the row should be visible based on invisibleReason,
	   * and if it changes the row visibility, then emits the rowsVisibleChanged event.
	   *
	   * Queues a grid refresh, but doesn't call it directly to avoid hitting lots of grid refreshes.
	   * @param {boolean} fromRowProcessor if true, then it won't raise events or queue the refresh, the
	   * row processor does that already
	   */
	  GridRow.prototype.evaluateRowVisibility = function ( fromRowProcessor ) {
	    var newVisibility = true;
	    if ( typeof(this.invisibleReason) !== 'undefined' ) {
	      angular.forEach(this.invisibleReason, function( value, key ) {
	        if ( value ) {
	          newVisibility = false;
	        }
	      });
	    }
	
	    if ( typeof(this.visible) === 'undefined' || this.visible !== newVisibility ) {
	      this.visible = newVisibility;
	      if ( !fromRowProcessor ) {
	        this.grid.queueGridRefresh();
	        this.grid.api.core.raise.rowsVisibleChanged(this);
	      }
	    }
	  };
	
	
	  return GridRow;
	}]);
	
	})();
	
	(function() {
	  'use strict';
	  /**
	   * @ngdoc object
	   * @name ui.grid.class:GridRowColumn
	   * @param {GridRow} row The row for this pair
	   * @param {GridColumn} column The column for this pair
	   * @description A row and column pair that represents the intersection of these two entities.
	   * Must be instantiated as a constructor using the `new` keyword.
	   */
	  angular.module('ui.grid')
	  .factory('GridRowColumn', ['$parse', '$filter',
	    function GridRowColumnFactory($parse, $filter) {
	      var GridRowColumn = function GridRowColumn(row, col) {
	        if ( !(this instanceof GridRowColumn)) {
	          throw "Using GridRowColumn as a function insead of as a constructor. Must be called with `new` keyword";
	        }
	
	        /**
	         * @ngdoc object
	         * @name row
	         * @propertyOf ui.grid.class:GridRowColumn
	         * @description {@link ui.grid.class:GridRow }
	         */
	        this.row = row;
	        /**
	         * @ngdoc object
	         * @name col
	         * @propertyOf ui.grid.class:GridRowColumn
	         * @description {@link ui.grid.class:GridColumn }
	         */
	        this.col = col;
	      };
	
	      /**
	       * @ngdoc function
	       * @name getIntersectionValueRaw
	       * @methodOf ui.grid.class:GridRowColumn
	       * @description Gets the intersection of where the row and column meet.
	       * @returns {String|Number|Object} The value from the grid data that this GridRowColumn points too.
	       *          If the column has a cellFilter this will NOT return the filtered value.
	       */
	      GridRowColumn.prototype.getIntersectionValueRaw = function() {
	        var getter = $parse(this.row.getEntityQualifiedColField(this.col));
	        var context = this.row;
	        return getter(context);
	      };
	      return GridRowColumn;
	    }
	  ]);
	})();
	
	(function () {
	  angular.module('ui.grid')
	    .factory('ScrollEvent', ['gridUtil', function (gridUtil) {
	
	      /**
	       * @ngdoc function
	       * @name ui.grid.class:ScrollEvent
	       * @description Model for all scrollEvents
	       * @param {Grid} grid that owns the scroll event
	       * @param {GridRenderContainer} sourceRowContainer that owns the scroll event. Can be null
	       * @param {GridRenderContainer} sourceColContainer that owns the scroll event. Can be null
	       * @param {string} source the source of the event - from uiGridConstants.scrollEventSources or a string value of directive/service/factory.functionName
	       */
	      function ScrollEvent(grid, sourceRowContainer, sourceColContainer, source) {
	        var self = this;
	        if (!grid) {
	          throw new Error("grid argument is required");
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name grid
	         *  @propertyOf  ui.grid.class:ScrollEvent
	         *  @description A reference back to the grid
	         */
	         self.grid = grid;
	
	
	
	        /**
	         *  @ngdoc object
	         *  @name source
	         *  @propertyOf  ui.grid.class:ScrollEvent
	         *  @description the source of the scroll event. limited to values from uiGridConstants.scrollEventSources
	         */
	        self.source = source;
	
	
	        /**
	         *  @ngdoc object
	         *  @name noDelay
	         *  @propertyOf  ui.grid.class:ScrollEvent
	         *  @description most scroll events from the mouse or trackpad require delay to operate properly
	         *  set to false to eliminate delay.  Useful for scroll events that the grid causes, such as scrolling to make a row visible.
	         */
	        self.withDelay = true;
	
	        self.sourceRowContainer = sourceRowContainer;
	        self.sourceColContainer = sourceColContainer;
	
	        self.newScrollLeft = null;
	        self.newScrollTop = null;
	        self.x = null;
	        self.y = null;
	
	        self.verticalScrollLength = -9999999;
	        self.horizontalScrollLength = -999999;
	
	
	        /**
	         *  @ngdoc function
	         *  @name fireThrottledScrollingEvent
	         *  @methodOf  ui.grid.class:ScrollEvent
	         *  @description fires a throttled event using grid.api.core.raise.scrollEvent
	         */
	        self.fireThrottledScrollingEvent = gridUtil.throttle(function(sourceContainerId) {
	          self.grid.scrollContainers(sourceContainerId, self);
	        }, self.grid.options.wheelScrollThrottle, {trailing: true});
	
	      }
	
	
	      /**
	       *  @ngdoc function
	       *  @name getNewScrollLeft
	       *  @methodOf  ui.grid.class:ScrollEvent
	       *  @description returns newScrollLeft property if available; calculates a new value if it isn't
	       */
	      ScrollEvent.prototype.getNewScrollLeft = function(colContainer, viewport) {
	        var self = this;
	
	        if (!self.newScrollLeft) {
	          var scrollWidth = (colContainer.getCanvasWidth() - colContainer.getViewportWidth());
	
	          var oldScrollLeft = gridUtil.normalizeScrollLeft(viewport, self.grid);
	
	          var scrollXPercentage;
	          if (typeof(self.x.percentage) !== 'undefined' && self.x.percentage !== undefined) {
	            scrollXPercentage = self.x.percentage;
	          }
	          else if (typeof(self.x.pixels) !== 'undefined' && self.x.pixels !== undefined) {
	            scrollXPercentage = self.x.percentage = (oldScrollLeft + self.x.pixels) / scrollWidth;
	          }
	          else {
	            throw new Error("No percentage or pixel value provided for scroll event X axis");
	          }
	
	          return Math.max(0, scrollXPercentage * scrollWidth);
	        }
	
	        return self.newScrollLeft;
	      };
	
	
	      /**
	       *  @ngdoc function
	       *  @name getNewScrollTop
	       *  @methodOf  ui.grid.class:ScrollEvent
	       *  @description returns newScrollTop property if available; calculates a new value if it isn't
	       */
	      ScrollEvent.prototype.getNewScrollTop = function(rowContainer, viewport) {
	        var self = this;
	
	
	        if (!self.newScrollTop) {
	          var scrollLength = rowContainer.getVerticalScrollLength();
	
	          var oldScrollTop = viewport[0].scrollTop;
	
	          var scrollYPercentage;
	          if (typeof(self.y.percentage) !== 'undefined' && self.y.percentage !== undefined) {
	            scrollYPercentage = self.y.percentage;
	          }
	          else if (typeof(self.y.pixels) !== 'undefined' && self.y.pixels !== undefined) {
	            scrollYPercentage = self.y.percentage = (oldScrollTop + self.y.pixels) / scrollLength;
	          }
	          else {
	            throw new Error("No percentage or pixel value provided for scroll event Y axis");
	          }
	
	          return Math.max(0, scrollYPercentage * scrollLength);
	        }
	
	        return self.newScrollTop;
	      };
	
	      ScrollEvent.prototype.atTop = function(scrollTop) {
	        return (this.y && (this.y.percentage === 0 || this.verticalScrollLength < 0) && scrollTop === 0);
	      };
	
	      ScrollEvent.prototype.atBottom = function(scrollTop) {
	        return (this.y && (this.y.percentage === 1 || this.verticalScrollLength === 0) && scrollTop > 0);
	      };
	
	      ScrollEvent.prototype.atLeft = function(scrollLeft) {
	        return (this.x && (this.x.percentage === 0 || this.horizontalScrollLength < 0) && scrollLeft === 0);
	      };
	
	      ScrollEvent.prototype.atRight = function(scrollLeft) {
	        return (this.x && (this.x.percentage === 1 || this.horizontalScrollLength ===0) && scrollLeft > 0);
	      };
	
	
	      ScrollEvent.Sources = {
	        ViewPortScroll: 'ViewPortScroll',
	        RenderContainerMouseWheel: 'RenderContainerMouseWheel',
	        RenderContainerTouchMove: 'RenderContainerTouchMove',
	        Other: 99
	      };
	
	      return ScrollEvent;
	    }]);
	
	
	
	})();
	
	(function () {
	  'use strict';
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.service:gridClassFactory
	   *
	   *  @description factory to return dom specific instances of a grid
	   *
	   */
	  angular.module('ui.grid').service('gridClassFactory', ['gridUtil', '$q', '$compile', '$templateCache', 'uiGridConstants', 'Grid', 'GridColumn', 'GridRow',
	    function (gridUtil, $q, $compile, $templateCache, uiGridConstants, Grid, GridColumn, GridRow) {
	
	      var service = {
	        /**
	         * @ngdoc method
	         * @name createGrid
	         * @methodOf ui.grid.service:gridClassFactory
	         * @description Creates a new grid instance. Each instance will have a unique id
	         * @param {object} options An object map of options to pass into the created grid instance.
	         * @returns {Grid} grid
	         */
	        createGrid : function(options) {
	          options = (typeof(options) !== 'undefined') ? options : {};
	          options.id = gridUtil.newId();
	          var grid = new Grid(options);
	
	          // NOTE/TODO: rowTemplate should always be defined...
	          if (grid.options.rowTemplate) {
	            var rowTemplateFnPromise = $q.defer();
	            grid.getRowTemplateFn = rowTemplateFnPromise.promise;
	
	            gridUtil.getTemplate(grid.options.rowTemplate)
	              .then(
	                function (template) {
	                  var rowTemplateFn = $compile(template);
	                  rowTemplateFnPromise.resolve(rowTemplateFn);
	                },
	                function () {
	                  // Todo handle response error here?
	                  throw new Error("Couldn't fetch/use row template '" + grid.options.rowTemplate + "'");
	                }).catch(angular.noop);
	          }
	
	          grid.registerColumnBuilder(service.defaultColumnBuilder);
	
	          // Row builder for custom row templates
	          grid.registerRowBuilder(service.rowTemplateAssigner);
	
	          // Reset all rows to visible initially
	          grid.registerRowsProcessor(function allRowsVisible(rows) {
	            rows.forEach(function (row) {
	              row.evaluateRowVisibility( true );
	            });
	
	            return rows;
	          }, 50);
	
	          grid.registerColumnsProcessor(function applyColumnVisibility(columns) {
	            columns.forEach(function (column) {
	              column.visible = angular.isDefined(column.colDef.visible) ? column.colDef.visible : true;
	            });
	
	            return columns;
	          }, 50);
	
	          grid.registerRowsProcessor(grid.searchRows, 100);
	
	          // Register the default row processor, it sorts rows by selected columns
	          if (grid.options.externalSort && angular.isFunction(grid.options.externalSort)) {
	            grid.registerRowsProcessor(grid.options.externalSort, 200);
	          }
	          else {
	            grid.registerRowsProcessor(grid.sortByColumn, 200);
	          }
	
	          return grid;
	        },
	
	        /**
	         * @ngdoc function
	         * @name defaultColumnBuilder
	         * @methodOf ui.grid.service:gridClassFactory
	         * @description Processes designTime column definitions and applies them to col for the
	         *              core grid features
	         * @param {object} colDef reference to column definition
	         * @param {GridColumn} col reference to gridCol
	         * @param {object} gridOptions reference to grid options
	         */
	        defaultColumnBuilder: function (colDef, col, gridOptions) {
	
	          var templateGetPromises = [];
	
	          // Abstracts the standard template processing we do for every template type.
	          var processTemplate = function( templateType, providedType, defaultTemplate, filterType, tooltipType ) {
	            if ( !colDef[templateType] ) {
	              col[providedType] = defaultTemplate;
	            } else {
	              col[providedType] = colDef[templateType];
	            }
	
	            var templatePromise = gridUtil.getTemplate(col[providedType])
	              .then(
	                function (template) {
	                  if ( angular.isFunction(template) ) { template = template(); }
	                  var tooltipCall = ( tooltipType === 'cellTooltip' )
	                      ? 'col.cellTooltip(row,col)'
	                      : 'col.headerTooltip(col)';
	                  if ( tooltipType && col[tooltipType] === false ) {
	                    template = template.replace(uiGridConstants.TOOLTIP, '');
	                  } else if ( tooltipType && col[tooltipType] ) {
	                    template = template.replace(uiGridConstants.TOOLTIP, 'title="{{' + tooltipCall + ' CUSTOM_FILTERS }}"');
	                  }
	
	                  if ( filterType ) {
	                    col[templateType] = template.replace(uiGridConstants.CUSTOM_FILTERS, function() {
	                      return col[filterType] ? "|" + col[filterType] : "";
	                    });
	                  } else {
	                    col[templateType] = template;
	                  }
	                },
	                function () {
	                  throw new Error("Couldn't fetch/use colDef." + templateType + " '" + colDef[templateType] + "'");
	                }).catch(angular.noop);
	
	            templateGetPromises.push(templatePromise);
	
	            return templatePromise;
	          };
	
	
	          /**
	           * @ngdoc property
	           * @name cellTemplate
	           * @propertyOf ui.grid.class:GridOptions.columnDef
	           * @description a custom template for each cell in this column.  The default
	           * is ui-grid/uiGridCell.  If you are using the cellNav feature, this template
	           * must contain a div that can receive focus.
	           *
	           */
	          col.cellTemplatePromise = processTemplate( 'cellTemplate', 'providedCellTemplate', 'ui-grid/uiGridCell', 'cellFilter', 'cellTooltip' );
	
	          /**
	           * @ngdoc property
	           * @name headerCellTemplate
	           * @propertyOf ui.grid.class:GridOptions.columnDef
	           * @description a custom template for the header for this column.  The default
	           * is ui-grid/uiGridHeaderCell
	           *
	           */
	          col.headerCellTemplatePromise = processTemplate( 'headerCellTemplate', 'providedHeaderCellTemplate', 'ui-grid/uiGridHeaderCell', 'headerCellFilter', 'headerTooltip' );
	
	          /**
	           * @ngdoc property
	           * @name footerCellTemplate
	           * @propertyOf ui.grid.class:GridOptions.columnDef
	           * @description a custom template for the footer for this column.  The default
	           * is ui-grid/uiGridFooterCell
	           *
	           */
	          col.footerCellTemplatePromise = processTemplate( 'footerCellTemplate', 'providedFooterCellTemplate', 'ui-grid/uiGridFooterCell', 'footerCellFilter' );
	
	          /**
	           * @ngdoc property
	           * @name filterHeaderTemplate
	           * @propertyOf ui.grid.class:GridOptions.columnDef
	           * @description a custom template for the filter input.  The default is ui-grid/ui-grid-filter
	           *
	           */
	          col.filterHeaderTemplatePromise = processTemplate( 'filterHeaderTemplate', 'providedFilterHeaderTemplate', 'ui-grid/ui-grid-filter' );
	
	          // Create a promise for the compiled element function
	          col.compiledElementFnDefer = $q.defer();
	
	          return $q.all(templateGetPromises);
	        },
	
	        rowTemplateAssigner: function rowTemplateAssigner(row) {
	          var grid = this;
	
	          // Row has no template assigned to it
	          if (!row.rowTemplate) {
	            // Use the default row template from the grid
	            row.rowTemplate = grid.options.rowTemplate;
	
	            // Use the grid's function for fetching the compiled row template function
	            row.getRowTemplateFn = grid.getRowTemplateFn;
	          }
	          // Row has its own template assigned
	          else {
	            // Create a promise for the compiled row template function
	            var perRowTemplateFnPromise = $q.defer();
	            row.getRowTemplateFn = perRowTemplateFnPromise.promise;
	
	            // Get the row template
	            gridUtil.getTemplate(row.rowTemplate)
	              .then(function (template) {
	                // Compile the template
	                var rowTemplateFn = $compile(template);
	
	                // Resolve the compiled template function promise
	                perRowTemplateFnPromise.resolve(rowTemplateFn);
	              },
	              function () {
	                // Todo handle response error here?
	                throw new Error("Couldn't fetch/use row template '" + row.rowTemplate + "'");
	              });
	          }
	
	          return row.getRowTemplateFn;
	        }
	      };
	
	      // class definitions (moved to separate factories)
	
	      return service;
	    }]);
	
	})();
	
	(function() {
	
	var module = angular.module('ui.grid');
	
	function escapeRegExp(str) {
	  // based on https://github.com/sindresorhus/escape-string-regexp
	  // Escape characters with special meaning either inside or outside character sets.
	  // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
	  return str.replace(/[|\\{}()[\]^$+?*.]/g, '\\$&').replace(/-/g, '\\x2d');
	}
	
	
	/**
	 *  @ngdoc service
	 *  @name ui.grid.service:rowSearcher
	 *
	 *  @description Service for searching/filtering rows based on column value conditions.
	 */
	module.service('rowSearcher', ['gridUtil', 'uiGridConstants', function (gridUtil, uiGridConstants) {
	  var defaultCondition = uiGridConstants.filter.CONTAINS;
	
	  var rowSearcher = {};
	
	  /**
	   * @ngdoc function
	   * @name getTerm
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Get the term from a filter
	   * Trims leading and trailing whitespace
	   * @param {object} filter object to use
	   * @returns {object} Parsed term
	   */
	  rowSearcher.getTerm = function getTerm(filter) {
	    if (typeof(filter.term) === 'undefined') { return filter.term; }
	
	    var term = filter.term;
	
	    // Strip leading and trailing whitespace if the term is a string
	    if (typeof(term) === 'string') {
	      term = term.trim();
	    }
	
	    return term;
	  };
	
	  /**
	   * @ngdoc function
	   * @name stripTerm
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Remove leading and trailing asterisk (*) from the filter's term
	   * @param {object} filter object to use
	   * @returns {uiGridConstants.filter<int>} Value representing the condition constant value
	   */
	  rowSearcher.stripTerm = function stripTerm(filter) {
	    var term = rowSearcher.getTerm(filter);
	
	    if (typeof(term) === 'string') {
	      return escapeRegExp(term.replace(/(^\*|\*$)/g, ''));
	    }
	    else {
	      return term;
	    }
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name guessCondition
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Guess the condition for a filter based on its term
	   * <br>
	   * Defaults to STARTS_WITH. Uses CONTAINS for strings beginning and ending with *s (*bob*).
	   * Uses STARTS_WITH for strings ending with * (bo*). Uses ENDS_WITH for strings starting with * (*ob).
	   * @param {object} filter object to use
	   * @returns {uiGridConstants.filter<int>} Value representing the condition constant value
	   */
	  rowSearcher.guessCondition = function guessCondition(filter) {
	    if (typeof(filter.term) === 'undefined' || !filter.term) {
	      return defaultCondition;
	    }
	
	    var term = rowSearcher.getTerm(filter);
	
	    if (/\*/.test(term)) {// this would check only start and end -> /^\*|\*$/
	      var regexpFlags = (!filter.flags || !filter.flags.caseSensitive) ? 'i' : '';
	      term = escapeRegExp(term);
	      var reText = term.replace(/\\\*/g, '.*?');// this would check only start and end -> /^\\\*|\\\*$/g
	      return new RegExp('^' + reText + '$', regexpFlags);
	    }
	    // Otherwise default to default condition
	    else {
	      return defaultCondition;
	    }
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name setupFilters
	   * @methodOf ui.grid.service:rowSearcher
	   * @description For a given columns filters (either col.filters, or [col.filter] can be passed in),
	   * do all the parsing and pre-processing and store that data into a new filters object.  The object
	   * has the condition, the flags, the stripped term, and a parsed reg exp if there was one.
	   *
	   * We could use a forEach in here, since it's much less performance sensitive, but since we're using
	   * for loops everywhere else in this module...
	   *
	   * @param {array} filters the filters from the column (col.filters or [col.filter])
	   * @returns {array} An array of parsed/preprocessed filters
	   */
	  rowSearcher.setupFilters = function setupFilters( filters ) {
	    var newFilters = [];
	
	    for ( var i = 0; i < filters.length; i++ ) {
	      var filter = filters[i];
	
	      if ( filter.noTerm || !gridUtil.isNullOrUndefined(filter.term) ) {
	        var newFilter = {};
	
	        var regexpFlags = '';
	        if (!filter.flags || !filter.flags.caseSensitive) {
	          regexpFlags += 'i';
	        }
	
	        if ( !gridUtil.isNullOrUndefined(filter.term) ) {
	          // it is possible to have noTerm.
	          if ( filter.rawTerm ) {
	            newFilter.term = filter.term;
	          } else {
	            newFilter.term = rowSearcher.stripTerm(filter);
	          }
	        }
	
	        newFilter.noTerm = filter.noTerm;
	        newFilter.condition = filter.condition || rowSearcher.guessCondition(filter);
	        newFilter.flags = angular.extend( { caseSensitive: false, date: false }, filter.flags );
	
	        switch (newFilter.condition) {
	          case uiGridConstants.filter.STARTS_WITH:
	            newFilter.startswithRE = new RegExp('^' + newFilter.term, regexpFlags);
	            break;
	          case uiGridConstants.filter.ENDS_WITH:
	            newFilter.endswithRE = new RegExp(newFilter.term + '$', regexpFlags);
	            break;
	          case uiGridConstants.filter.EXACT:
	            newFilter.exactRE = new RegExp('^' + newFilter.term + '$', regexpFlags);
	            break;
	          case uiGridConstants.filter.CONTAINS:
	            newFilter.containsRE = new RegExp(newFilter.term, regexpFlags);
	            break;
	        }
	
	        newFilters.push(newFilter);
	      }
	    }
	    return newFilters;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name runColumnFilter
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Runs a single pre-parsed filter against a cell, returning true
	   * if the cell matches that one filter.
	   *
	   * @param {Grid} grid the grid we're working against
	   * @param {GridRow} row the row we're matching against
	   * @param {GridColumn} column the column that we're working against
	   * @param {object} filter the specific, preparsed, filter that we want to test
	   * @returns {boolean} true if we match (row stays visible)
	   */
	  rowSearcher.runColumnFilter = function runColumnFilter(grid, row, column, filter) {
	    // Cache typeof condition
	    var conditionType = typeof(filter.condition);
	
	    // Term to search for.
	    var term = filter.term;
	
	    // Get the column value for this row
	    var value = column.filterCellFiltered ? grid.getCellDisplayValue(row, column) : grid.getCellValue(row, column);
	    if (value == void 0) {
	      value = "";
	    }
	
	    // If the filter's condition is a RegExp, then use it
	    if (filter.condition instanceof RegExp) {
	      return filter.condition.test(value);
	    }
	
	    // If the filter's condition is a function, run it
	    if (conditionType === 'function') {
	      return filter.condition(term, value, row, column);
	    }
	
	    if (filter.startswithRE) {
	      return filter.startswithRE.test(value);
	    }
	
	    if (filter.endswithRE) {
	      return filter.endswithRE.test(value);
	    }
	
	    if (filter.containsRE) {
	      return filter.containsRE.test(value);
	    }
	
	    if (filter.exactRE) {
	      return filter.exactRE.test(value);
	    }
	
	    if (filter.condition === uiGridConstants.filter.NOT_EQUAL) {
	      return !new RegExp('^' + term + '$').test(value);
	    }
	
	    if (typeof(value) === 'number' && typeof(term) === 'string' ) {
	      // if the term has a decimal in it, it comes through as '9\.4', we need to take out the \
	      // the same for negative numbers
	      // TODO: I suspect the right answer is to look at escapeRegExp at the top of this code file, maybe it's not needed?
	      var tempFloat = parseFloat(term.replace(/\\\./,'.').replace(/\\\-/,'-'));
	      if (!isNaN(tempFloat)) {
	        term = tempFloat;
	      }
	    }
	
	    if (filter.flags.date === true) {
	      value = new Date(value);
	      // If the term has a dash in it, it comes through as '\-' -- we need to take out the '\'.
	      term = new Date(term.replace(/\\/g, ''));
	    }
	
	    switch (filter.condition) {
	      case uiGridConstants.filter.GREATER_THAN:
	        return (value > term);
	      case uiGridConstants.filter.GREATER_THAN_OR_EQUAL:
	        return (value >= term);
	      case uiGridConstants.filter.LESS_THAN:
	        return (value < term);
	      case uiGridConstants.filter.LESS_THAN_OR_EQUAL:
	        return (value <= term);
	    }
	
	    return true;
	  };
	
	
	  /**
	   * @ngdoc boolean
	   * @name useExternalFiltering
	   * @propertyOf ui.grid.class:GridOptions
	   * @description False by default. When enabled, this setting suppresses the internal filtering.
	   * All UI logic will still operate, allowing filter conditions to be set and modified.
	   *
	   * The external filter logic can listen for the `filterChange` event, which fires whenever
	   * a filter has been adjusted.
	   */
	  /**
	   * @ngdoc function
	   * @name searchColumn
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Process provided filters on provided column against a given row. If the row meets
	   * the conditions on all the filters, return true.
	   * @param {Grid} grid Grid to search in
	   * @param {GridRow} row Row to search on
	   * @param {GridColumn} column Column with the filters to use
	   * @param {array} filters array of pre-parsed/preprocessed filters to apply
	   * @returns {boolean} Whether the column matches or not.
	   */
	  rowSearcher.searchColumn = function searchColumn(grid, row, column, filters) {
	    if (grid.options.useExternalFiltering) {
	      return true;
	    }
	
	    for (var i = 0; i < filters.length; i++) {
	      var filter = filters[i];
	
	      if ( !gridUtil.isNullOrUndefined(filter.term) && filter.term !== '' || filter.noTerm ) {
	        if (!rowSearcher.runColumnFilter(grid, row, column, filter)) {
	          return false;
	        }
	      }
	    }
	
	    return true;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name search
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Run a search across the given rows and columns, marking any rows that don't
	   * match the stored col.filters or col.filter as invisible.
	   * @param {Grid} grid Grid instance to search inside
	   * @param {Array[GridRow]} rows GridRows to filter
	   * @param {Array[GridColumn]} columns GridColumns with filters to process
	   */
	  rowSearcher.search = function search(grid, rows, columns) {
	    /*
	     * Added performance optimisations into this code base, as this logic creates deeply nested
	     * loops and is therefore very performance sensitive.  In particular, avoiding forEach as
	     * this impacts some browser optimisers (particularly Chrome), using iterators instead
	     */
	
	    // Don't do anything if we weren't passed any rows
	    if (!rows) {
	      return;
	    }
	
	    // don't filter if filtering currently disabled
	    if (!grid.options.enableFiltering) {
	      return rows;
	    }
	
	    // Build list of filters to apply
	    var filterData = [];
	
	    var hasTerm = function( filters ) {
	      var hasTerm = false;
	
	      filters.forEach( function (filter) {
	        if ( !gridUtil.isNullOrUndefined(filter.term) && filter.term !== '' || filter.noTerm ) {
	          hasTerm = true;
	        }
	      });
	
	      return hasTerm;
	    };
	
	    for (var i = 0; i < columns.length; i++) {
	      var col = columns[i];
	
	      if (typeof(col.filters) !== 'undefined' && hasTerm(col.filters) ) {
	        filterData.push( { col: col, filters: rowSearcher.setupFilters(col.filters) } );
	      }
	    }
	
	    if (filterData.length > 0) {
	      // define functions outside the loop, performance optimisation
	      var foreachRow = function(grid, row, col, filters) {
	        if ( row.visible && !rowSearcher.searchColumn(grid, row, col, filters) ) {
	          row.visible = false;
	        }
	      };
	
	      var foreachFilterCol = function(grid, filterData) {
	        for ( var i = 0; i < rows.length; i++) {
	          foreachRow(grid, rows[i], filterData.col, filterData.filters);
	        }
	      };
	
	      // nested loop itself - foreachFilterCol, which in turn calls foreachRow
	      for ( var j = 0; j < filterData.length; j++) {
	        foreachFilterCol( grid, filterData[j] );
	      }
	
	      if (grid.api.core.raise.rowsVisibleChanged) {
	        grid.api.core.raise.rowsVisibleChanged();
	      }
	
	      // drop any invisible rows
	      // keeping these, as needed with filtering for trees - we have to come back and make parent nodes visible if child nodes are selected in the filter
	      // rows = rows.filter(function(row) { return row.visible; });
	
	    }
	
	    return rows;
	  };
	
	  return rowSearcher;
	}]);
	
	})();
	
	(function() {
	
	var module = angular.module('ui.grid');
	
	/**
	 * @ngdoc object
	 * @name ui.grid.class:rowSorter
	 * @description rowSorter provides the default sorting mechanisms,
	 * including guessing column types and applying appropriate sort
	 * algorithms
	 *
	 */
	
	module.service('rowSorter', ['uiGridConstants', function (uiGridConstants) {
	  var rowSorter = {
	    // Cache of sorting functions. Once we create them, we don't want to keep re-doing it
	    //   this takes a piece of data from the cell and tries to determine its type and what sorting
	    //   function to use for it
	    colSortFnCache: {}
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name guessSortFn
	   * @description Assigns a sort function to use based on the itemType in the column
	   * @param {string} itemType one of 'number', 'boolean', 'string', 'date', 'object'.  And
	   * error will be thrown for any other type.
	   * @returns {function} a sort function that will sort that type
	   */
	  rowSorter.guessSortFn = function guessSortFn(itemType) {
	    switch (itemType) {
	      case "number":
	        return rowSorter.sortNumber;
	      case "numberStr":
	        return rowSorter.sortNumberStr;
	      case "boolean":
	        return rowSorter.sortBool;
	      case "string":
	        return rowSorter.sortAlpha;
	      case "date":
	        return rowSorter.sortDate;
	      case "object":
	        return rowSorter.basicSort;
	      default:
	        throw new Error('No sorting function found for type: ' + itemType);
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name handleNulls
	   * @description Sorts nulls and undefined to the bottom (top when
	   * descending).  Called by each of the internal sorters before
	   * attempting to sort.  Note that this method is available on the core api
	   * via gridApi.core.sortHandleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} null if there were no nulls/undefineds, otherwise returns
	   * a sort value that should be passed back from the sort function
	   */
	  rowSorter.handleNulls = function handleNulls(a, b) {
	    // We want to allow zero values and false values to be evaluated in the sort function
	    if ((a == void 0) || (b == void 0)) {
	      // We want to force nulls and such to the bottom when we sort... which effectively is "greater than"
	      if ((a == void 0) && (b == void 0)) {
	        return 0;
	      }
	
	      if (a == void 0) {
	        return 1;
	      }
	      return -1;// b == void 0
	    }
	    return null;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name basicSort
	   * @description Sorts any values that provide the < method, including strings
	   * or numbers.  Handles nulls and undefined through calling handleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.basicSort = function basicSort(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if (nulls !== null) {
	      return nulls;
	    }
	
	    if (a === b) {
	      return 0;
	    }
	
	    if (a < b) {
	      return -1;
	    }
	    return 1;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sortNumber
	   * @description Sorts numerical values.  Handles nulls and undefined through calling handleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortNumber = function sortNumber(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    return (nulls !== null) ? nulls : a - b;
	  };
	
	
	  function parseNumStr(numStr) {
	    if (/^\s*-?Infinity\s*$/.test(numStr)) { // check for positive or negative Infinity and return that
	      return parseFloat(numStr);
	    }
	    return parseFloat(numStr.replace(/[^0-9.eE-]/g, ''));
	  }
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sortNumberStr
	   * @description Sorts numerical values that are stored in a string (i.e. parses them to numbers first).
	   * Handles nulls and undefined through calling handleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortNumberStr = function sortNumberStr(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if (nulls !== null) {
	      return nulls;
	    }
	
	    var numA = parseNumStr(a), // The parsed number form of 'a'
	        numB = parseNumStr(b); // The parsed number form of 'b'
	
	    // If 'a' couldn't be parsed to float, flag it as bad
	    var badA = isNaN(numA),
	        badB = isNaN(numB);
	
	    // We want bad ones to get pushed to the bottom... which effectively is "greater than"
	    if (badA || badB) {
	      return (badA && badB) ? 0 : (badA ? 1 : -1);
	    }
	
	    return numA - numB;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sortAlpha
	   * @description Sorts string values. Handles nulls and undefined through calling handleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortAlpha = function sortAlpha(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if (nulls !== null) {
	      return nulls;
	    }
	
	    var strA = a.toString().toLowerCase(),
	        strB = b.toString().toLowerCase();
	    return strA === strB ? 0 : strA.localeCompare(strB);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sortDate
	   * @description Sorts date values. Handles nulls and undefined through calling handleNulls.
	   * Handles date strings by converting to Date object if not already an instance of Date
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortDate = function sortDate(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if (nulls !== null) {
	      return nulls;
	    }
	
	    var timeA = (a instanceof Date) ? a.getTime() : new Date(a).getTime();
	    var timeB = (b instanceof Date) ? b.getTime() : new Date(b).getTime();
	    return timeA === timeB ? 0 : (timeA < timeB ? -1 : 1);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sortBool
	   * @description Sorts boolean values, true is considered larger than false.
	   * Handles nulls and undefined through calling handleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortBool = function sortBool(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if (nulls !== null) {
	      return nulls;
	    }
	
	    if ((a && b) || (!a && !b)) {
	      return 0;
	    }
	    return a ? 1 : -1;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name getSortFn
	   * @description Get the sort function for the column.  Looks first in
	   * rowSorter.colSortFnCache using the column name, failing that it
	   * looks at col.sortingAlgorithm (and puts it in the cache), failing that
	   * it guesses the sort algorithm based on the data type.
	   *
	   * The cache currently seems a bit pointless, as none of the work we do is
	   * processor intensive enough to need caching.  Presumably in future we might
	   * inspect the row data itself to guess the sort function, and in that case
	   * it would make sense to have a cache, the infrastructure is in place to allow
	   * that.
	   *
	   * @param {Grid} grid the grid to consider
	   * @param {GridColumn} col the column to find a function for
	   * @param {array} rows an array of grid rows.  Currently unused, but presumably in future
	   * we might inspect the rows themselves to decide what sort of data might be there
	   * @returns {function} the sort function chosen for the column
	   */
	  rowSorter.getSortFn = function getSortFn(col) {
	    // See if we already figured out what to use to sort the column and have it in the cache
	    if (rowSorter.colSortFnCache[col.colDef.name]) {
	      return rowSorter.colSortFnCache[col.colDef.name];
	    }
	    // If the column has its OWN sorting algorithm, use that
	    if (col.sortingAlgorithm != void 0) {
	      rowSorter.colSortFnCache[col.colDef.name] = col.sortingAlgorithm;
	      return col.sortingAlgorithm;
	    }
	    // Always default to sortAlpha when sorting after a cellFilter
	    if (col.sortCellFiltered && col.cellFilter) {
	      rowSorter.colSortFnCache[col.colDef.name] = rowSorter.sortAlpha;
	      return rowSorter.sortAlpha;
	    }
	
	    // Try and guess what sort function to use
	    // Guess the sort function
	    var sortFn = rowSorter.guessSortFn(col.colDef.type);
	
	    // If we found a sort function, cache it
	    if (sortFn) {
	      rowSorter.colSortFnCache[col.colDef.name] = sortFn;
	      return sortFn;
	    }
	    // We assign the alpha sort because anything that is null/undefined will never get passed to
	    // the actual sorting function. It will get caught in our null check and returned to be sorted
	    // down to the bottom
	    return rowSorter.sortAlpha;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name prioritySort
	   * @description Used where multiple columns are present in the sort criteria,
	   * we determine which column should take precedence in the sort by sorting
	   * the columns based on their sort.priority
	   *
	   * @param {gridColumn} a column a
	   * @param {gridColumn} b column b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.prioritySort = function (a, b) {
	    // Both columns have a sort priority
	    if (a.sort && a.sort.priority !== undefined && b.sort && b.sort.priority !== undefined) {
	      // A is higher priority
	      if (a.sort.priority < b.sort.priority) {
	        return -1;
	      }
	      // Equal
	      if (a.sort.priority === b.sort.priority) {
	        return 0;
	      }
	      // B is higher
	      return 1;
	    }
	    // Only A has a priority
	    if (a.sort && a.sort.priority !== undefined) {
	      return -1;
	    }
	    // Only B has a priority
	    if (b.sort && b.sort.priority !== undefined) {
	      return 1;
	    }
	    // Neither has a priority
	    return 0;
	  };
	
	
	  /**
	   * @ngdoc object
	   * @name useExternalSorting
	   * @propertyOf ui.grid.class:GridOptions
	   * @description Prevents the internal sorting from executing.  Events will
	   * still be fired when the sort changes, and the sort information on
	   * the columns will be updated, allowing an external sorter (for example,
	   * server sorting) to be implemented.  Defaults to false.
	   *
	   */
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sort
	   * @description sorts the grid
	   * @param {Object} grid the grid itself
	   * @param {array} rows the rows to be sorted
	   * @param {array} columns the columns in which to look
	   * for sort criteria
	   * @returns {array} sorted rows
	   */
	  rowSorter.sort = function rowSorterSort(grid, rows, columns) {
	    // first make sure we are even supposed to do work
	    if (!rows) {
	      return;
	    }
	
	    if (grid.options.useExternalSorting) {
	      return rows;
	    }
	
	    // Build the list of columns to sort by
	    var sortCols = [];
	    var defaultSortCols = [];
	    columns.forEach(function (col) {
	      if (col.sort && !col.sort.ignoreSort && col.sort.direction && (col.sort.direction === uiGridConstants.ASC || col.sort.direction === uiGridConstants.DESC)) {
	        sortCols.push({
	          col: col,
	          sort: col.sort
	        });
	      } else if ( col.defaultSort && col.defaultSort.direction && (col.defaultSort.direction === uiGridConstants.ASC || col.defaultSort.direction === uiGridConstants.DESC) ) {
	        defaultSortCols.push({
	          col: col,
	          sort: col.defaultSort
	        });
	      }
	    });
	
	    // Sort the "sort columns" by their sort priority
	    sortCols = sortCols.sort(rowSorter.prioritySort);
	    defaultSortCols = defaultSortCols.sort(rowSorter.prioritySort);
	    sortCols = sortCols.concat(defaultSortCols);
	
	    // Now rows to sort by, maintain original order
	    if (sortCols.length === 0) {
	      return rows;
	    }
	
	    // Re-usable variables
	    var col, direction;
	
	    // put a custom index field on each row, used to make a stable sort out of unstable sorts (e.g. Chrome)
	    rows.forEach(function (row, idx) {
	      row.entity.$$uiGridIndex = idx;
	    });
	
	    // Now actually sort the data
	    var rowSortFn = function (rowA, rowB) {
	      var tem = 0,
	          idx = 0,
	          sortFn;
	
	      while (tem === 0 && idx < sortCols.length) {
	        // grab the metadata for the rest of the logic
	        col = sortCols[idx].col;
	        direction = sortCols[idx].sort.direction;
	
	        sortFn = rowSorter.getSortFn(col);
	
	        // Webpack's compress will hoist and combine propA, propB into one var and break sorting functionality
	        // Wrapping in function prevents that unexpected behavior
	        var props = getCellValues(grid, rowA, rowB, col);
	        tem = sortFn(props[0], props[1], rowA, rowB, direction, col);
	
	        idx++;
	      }
	
	      // Chrome doesn't implement a stable sort function.  If our sort returns 0
	      // (i.e. the items are equal), and we're at the last sort column in the list,
	      // then return the previous order using our custom
	      // index variable
	      if (tem === 0 ) {
	        return rowA.entity.$$uiGridIndex - rowB.entity.$$uiGridIndex;
	      }
	
	      // Made it this far, we don't have to worry about null & undefined
	      return (direction === uiGridConstants.ASC) ? tem : 0 - tem;
	    };
	
	    var newRows = rows.sort(rowSortFn);
	
	    // remove the custom index field on each row, used to make a stable sort out of unstable sorts (e.g. Chrome)
	    rows.forEach(function (row, idx) {
	      delete row.entity.$$uiGridIndex;
	    });
	
	    return newRows;
	  };
	
	  function getCellValues(grid, rowA, rowB, col) {
	    var propA, propB;
	
	    if ( col.sortCellFiltered ) {
	      propA = grid.getCellDisplayValue(rowA, col);
	      propB = grid.getCellDisplayValue(rowB, col);
	    } else {
	      propA = grid.getCellValue(rowA, col);
	      propB = grid.getCellValue(rowB, col);
	    }
	
	    return [propA, propB];
	  }
	
	  return rowSorter;
	}]);
	
	})();
	
	(function() {
	
	var module = angular.module('ui.grid');
	
	var bindPolyfill;
	if (typeof Function.prototype.bind !== "function") {
	  bindPolyfill = function() {
	    var slice = Array.prototype.slice;
	    return function(context) {
	      var fn = this,
	        args = slice.call(arguments, 1);
	      if (args.length) {
	        return function() {
	          return arguments.length ? fn.apply(context, args.concat(slice.call(arguments))) : fn.apply(context, args);
	        };
	      }
	      return function() {
	        return arguments.length ? fn.apply(context, arguments) : fn.call(context);
	      };
	    };
	  };
	}
	
	function  getStyles (elem) {
	  var e = elem;
	  if (typeof(e.length) !== 'undefined' && e.length) {
	    e = elem[0];
	  }
	
	  return e.ownerDocument.defaultView.getComputedStyle(e, null);
	}
	
	var rnumnonpx = new RegExp( "^(" + (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source + ")(?!px)[a-z%]+$", "i" ),
	    // swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
	    // see here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	    rdisplayswap = /^(block|none|table(?!-c[ea]).+)/,
	    cssShow = { position: "absolute", visibility: "hidden", display: "block" };
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	  var i = extra === ( isBorderBox ? 'border' : 'content' ) ?
	          // If we already have the right measurement, avoid augmentation
	          4 :
	          // Otherwise initialize for horizontal or vertical properties
	          name === 'width' ? 1 : 0,
	
	          val = 0;
	
	  var sides = ['Top', 'Right', 'Bottom', 'Left'];
	
	  for ( ; i < 4; i += 2 ) {
	    var side = sides[i];
	    // dump('side', side);
	
	    // both box models exclude margin, so add it if we want it
	    if ( extra === 'margin' ) {
	      var marg = parseFloat(styles[extra + side]);
	      if (!isNaN(marg)) {
	        val += marg;
	      }
	    }
	    // dump('val1', val);
	
	    if ( isBorderBox ) {
	      // border-box includes padding, so remove it if we want content
	      if ( extra === 'content' ) {
	        var padd = parseFloat(styles['padding' + side]);
	        if (!isNaN(padd)) {
	          val -= padd;
	          // dump('val2', val);
	        }
	      }
	
	      // at this point, extra isn't border nor margin, so remove border
	      if ( extra !== 'margin' ) {
	        var bordermarg = parseFloat(styles['border' + side + 'Width']);
	        if (!isNaN(bordermarg)) {
	          val -= bordermarg;
	          // dump('val3', val);
	        }
	      }
	    }
	    else {
	      // at this point, extra isn't content, so add padding
	      var nocontentPad = parseFloat(styles['padding' + side]);
	      if (!isNaN(nocontentPad)) {
	        val += nocontentPad;
	        // dump('val4', val);
	      }
	
	      // at this point, extra isn't content nor padding, so add border
	      if ( extra !== 'padding') {
	        var nocontentnopad = parseFloat(styles['border' + side + 'Width']);
	        if (!isNaN(nocontentnopad)) {
	          val += nocontentnopad;
	          // dump('val5', val);
	        }
	      }
	    }
	  }
	
	  // dump('augVal', val);
	
	  return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	  // Start with offset property, which is equivalent to the border-box value
	  var valueIsBorderBox = true,
	          val, // = name === 'width' ? elem.offsetWidth : elem.offsetHeight,
	          styles = getStyles(elem),
	          isBorderBox = styles['boxSizing'] === 'border-box';
	
	  // some non-html elements return undefined for offsetWidth, so check for null/undefined
	  // svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	  // MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	  if ( val <= 0 || val == null ) {
	    // Fall back to computed then uncomputed css if necessary
	    val = styles[name];
	    if ( val < 0 || val == null ) {
	      val = elem.style[ name ];
	    }
	
	    // Computed unit is not pixels. Stop here and return.
	    if ( rnumnonpx.test(val) ) {
	      return val;
	    }
	
	    // we need the check for style in case a browser which returns unreliable values
	    // for getComputedStyle silently falls back to the reliable elem.style
	    valueIsBorderBox = isBorderBox &&
	            ( true || val === elem.style[ name ] ); // use 'true' instead of 'support.boxSizingReliable()'
	
	    // Normalize "", auto, and prepare for extra
	    val = parseFloat( val ) || 0;
	  }
	
	  // use the active box-sizing model to add/subtract irrelevant styles
	  var ret = ( val +
	    augmentWidthOrHeight(
	      elem,
	      name,
	      extra || ( isBorderBox ? "border" : "content" ),
	      valueIsBorderBox,
	      styles
	    )
	  );
	
	  // dump('ret', ret, val);
	  return ret;
	}
	
	function getLineHeight(elm) {
	  elm = angular.element(elm)[0];
	  var parent = elm.parentElement;
	
	  if (!parent) {
	    parent = document.getElementsByTagName('body')[0];
	  }
	
	  return parseInt( getStyles(parent).fontSize ) || parseInt( getStyles(elm).fontSize ) || 16;
	}
	
	var uid = ['0', '0', '0', '0'];
	var uidPrefix = 'uiGrid-';
	
	/**
	 *  @ngdoc service
	 *  @name ui.grid.service:GridUtil
	 *
	 *  @description Grid utility functions
	 */
	module.service('gridUtil', ['$log', '$window', '$document', '$http', '$templateCache', '$timeout', '$interval', '$injector', '$q', '$interpolate', 'uiGridConstants',
	  function ($log, $window, $document, $http, $templateCache, $timeout, $interval, $injector, $q, $interpolate, uiGridConstants) {
	  var s = {
	
	    augmentWidthOrHeight: augmentWidthOrHeight,
	
	    getStyles: getStyles,
	
	    /**
	     * @ngdoc method
	     * @name createBoundedWrapper
	     * @methodOf ui.grid.service:GridUtil
	     *
	     * @param {object} object to bind 'this' to
	     * @param {method} method to bind
	     * @returns {Function} The wrapper that performs the binding
	     *
	     * @description
	     * Binds given method to given object.
	     *
	     * By means of a wrapper, ensures that ``method`` is always bound to
	     * ``object`` regardless of its calling environment.
	     * Iow, inside ``method``, ``this`` always points to ``object``.
	     *
	     * See http://alistapart.com/article/getoutbindingsituations
	     *
	     */
	    createBoundedWrapper: function(object, method) {
	        return function() {
	            return method.apply(object, arguments);
	        };
	    },
	
	
	    /**
	     * @ngdoc method
	     * @name readableColumnName
	     * @methodOf ui.grid.service:GridUtil
	     *
	     * @param {string} columnName Column name as a string
	     * @returns {string} Column name appropriately capitalized and split apart
	     *
	       @example
	       <example module="app">
	        <file name="app.js">
	          var app = angular.module('app', ['ui.grid']);
	
	          app.controller('MainCtrl', ['$scope', 'gridUtil', function ($scope, gridUtil) {
	            $scope.name = 'firstName';
	            $scope.columnName = function(name) {
	              return gridUtil.readableColumnName(name);
	            };
	          }]);
	        </file>
	        <file name="index.html">
	          <div ng-controller="MainCtrl">
	            <strong>Column name:</strong> <input ng-model="name" />
	            <br>
	            <strong>Output:</strong> <span ng-bind="columnName(name)"></span>
	          </div>
	        </file>
	      </example>
	     */
	    readableColumnName: function (columnName) {
	      // Convert underscores to spaces
	      if (typeof(columnName) === 'undefined' || columnName === undefined || columnName === null) { return columnName; }
	
	      if (typeof(columnName) !== 'string') {
	        columnName = String(columnName);
	      }
	
	      return columnName.replace(/_+/g, ' ')
	        // Replace a completely all-capsed word with a first-letter-capitalized version
	        .replace(/^[A-Z]+$/, function (match) {
	          return match.toLowerCase();
	        })
	        // Capitalize the first letter of words
	        .replace(/([\w\u00C0-\u017F]+)/g, function (match) {
	          return match.charAt(0).toUpperCase() + match.slice(1);
	        })
	        // Put a space in between words that have partial capilizations (i.e. 'firstName' becomes 'First Name')
	        // .replace(/([A-Z]|[A-Z]\w+)([A-Z])/g, "$1 $2");
	        // .replace(/(\w+?|\w)([A-Z])/g, "$1 $2");
	        .replace(/(\w+?(?=[A-Z]))/g, '$1 ');
	    },
	
	    /**
	     * @ngdoc method
	     * @name getColumnsFromData
	     * @methodOf ui.grid.service:GridUtil
	     * @description Return a list of column names, given a data set
	     *
	     * @param {string} data Data array for grid
	     * @returns {Object} Column definitions with field accessor and column name
	     *
	     * @example
	       <pre>
	         var data = [
	           { firstName: 'Bob', lastName: 'Jones' },
	           { firstName: 'Frank', lastName: 'Smith' }
	         ];
	
	         var columnDefs = GridUtil.getColumnsFromData(data, excludeProperties);
	
	         columnDefs == [
	          {
	            field: 'firstName',
	            name: 'First Name'
	          },
	          {
	            field: 'lastName',
	            name: 'Last Name'
	          }
	         ];
	       </pre>
	     */
	    getColumnsFromData: function (data, excludeProperties) {
	      var columnDefs = [];
	
	      if (!data || typeof(data[0]) === 'undefined' || data[0] === undefined) { return []; }
	      if (angular.isUndefined(excludeProperties)) { excludeProperties = []; }
	
	      var item = data[0];
	
	      angular.forEach(item,function (prop, propName) {
	        if ( excludeProperties.indexOf(propName) === -1) {
	          columnDefs.push({
	            name: propName
	          });
	        }
	      });
	
	      return columnDefs;
	    },
	
	    /**
	     * @ngdoc method
	     * @name newId
	     * @methodOf ui.grid.service:GridUtil
	     * @description Return a unique ID string
	     *
	     * @returns {string} Unique string
	     *
	     * @example
	       <pre>
	        var id = GridUtil.newId();
	
	        # 1387305700482;
	       </pre>
	     */
	    newId: (function() {
	      var seedId = new Date().getTime();
	      return function() {
	          return seedId += 1;
	      };
	    })(),
	
	
	    /**
	     * @ngdoc method
	     * @name getTemplate
	     * @methodOf ui.grid.service:GridUtil
	     * @description Get's template from cache / element / url
	     *
	     * @param {string|element|promise} template Either a string representing the template id, a string representing the template url,
	     *   an jQuery/Angualr element, or a promise that returns the template contents to use.
	     * @returns {object} a promise resolving to template contents
	     *
	     * @example
	     <pre>
	     GridUtil.getTemplate(url).then(function (contents) {
	          alert(contents);
	        })
	     </pre>
	     */
	    getTemplate: function (template) {
	      // Try to fetch the template out of the templateCache
	      if ($templateCache.get(template)) {
	        return s.postProcessTemplate($templateCache.get(template));
	      }
	
	      // See if the template is itself a promise
	      if (angular.isFunction(template.then)) {
	        return template.then(s.postProcessTemplate).catch(angular.noop);
	      }
	
	      // If the template is an element, return the element
	      try {
	        if (angular.element(template).length > 0) {
	          return $q.when(template).then(s.postProcessTemplate).catch(angular.noop);
	        }
	      }
	      catch (err) {
	        // do nothing; not valid html
	      }
	
	      // s.logDebug('fetching url', template);
	
	      // Default to trying to fetch the template as a url with $http
	      return $http({ method: 'GET', url: template})
	        .then(
	          function (result) {
	            var templateHtml = result.data.trim();
	            // put in templateCache for next call
	            $templateCache.put(template, templateHtml);
	            return templateHtml;
	          },
	          function (err) {
	            throw new Error("Could not get template " + template + ": " + err);
	          }
	        )
	        .then(s.postProcessTemplate).catch(angular.noop);
	    },
	
	    //
	    postProcessTemplate: function (template) {
	      var startSym = $interpolate.startSymbol(),
	          endSym = $interpolate.endSymbol();
	
	      // If either of the interpolation symbols have been changed, we need to alter this template
	      if (startSym !== '{{' || endSym !== '}}') {
	        template = template.replace(/\{\{/g, startSym);
	        template = template.replace(/\}\}/g, endSym);
	      }
	
	      return $q.when(template);
	    },
	
	    /**
	     * @ngdoc method
	     * @name guessType
	     * @methodOf ui.grid.service:GridUtil
	     * @description guesses the type of an argument
	     *
	     * @param {string/number/bool/object} item variable to examine
	     * @returns {string} one of the following
	     * - 'string'
	     * - 'boolean'
	     * - 'number'
	     * - 'date'
	     * - 'object'
	     */
	    guessType : function (item) {
	      var itemType = typeof(item);
	
	      // Check for numbers and booleans
	      switch (itemType) {
	        case "number":
	        case "boolean":
	        case "string":
	          return itemType;
	        default:
	          if (angular.isDate(item)) {
	            return "date";
	          }
	          return "object";
	      }
	    },
	
	
	  /**
	    * @ngdoc method
	    * @name elementWidth
	    * @methodOf ui.grid.service:GridUtil
	    *
	    * @param {element} elem DOM element
	    * @param {string} [extra] Optional modifier for calculation. Use 'margin' to account for margins on element
	    *
	    * @returns {number} Element width in pixels, accounting for any borders, etc.
	    */
	    elementWidth: function (elem) {
	
	    },
	
	    /**
	    * @ngdoc method
	    * @name elementHeight
	    * @methodOf ui.grid.service:GridUtil
	    *
	    * @param {element} elem DOM element
	    * @param {string} [extra] Optional modifier for calculation. Use 'margin' to account for margins on element
	    *
	    * @returns {number} Element height in pixels, accounting for any borders, etc.
	    */
	    elementHeight: function (elem) {
	
	    },
	
	    isVisible: function (elem) {
	      return !!( elem[0].offsetWidth || elem[0].offsetHeight || elem[0].getClientRects().length )
	    },
	
	    // Thanks to http://stackoverflow.com/a/13382873/888165
	    getScrollbarWidth: function() {
	        var outer = document.createElement("div");
	
	        outer.style.visibility = "hidden";
	        outer.style.width = "100px";
	        outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
	
	        document.body.appendChild(outer);
	
	        var widthNoScroll = outer.offsetWidth;
	        // force scrollbars
	        outer.style.overflow = "scroll";
	        outer.style.position = "absolute"; // force Firefox to draw a scrollbar
	
	        // add innerdiv
	        var inner = document.createElement("div");
	        inner.style.width = "100%";
	        outer.appendChild(inner);
	
	        var widthWithScroll = inner.offsetWidth;
	
	        // remove divs
	        outer.parentNode.removeChild(outer);
	
	        return widthNoScroll - widthWithScroll;
	    },
	
	    swap: function( elem, options, callback, args ) {
	      var ret, name,
	              old = {};
	
	      // Remember the old values, and insert the new ones
	      for ( name in options ) {
	        old[ name ] = elem.style[ name ];
	        elem.style[ name ] = options[ name ];
	      }
	
	      ret = callback.apply( elem, args || [] );
	
	      // Revert the old values
	      for ( name in options ) {
	        elem.style[ name ] = old[ name ];
	      }
	
	      return ret;
	    },
	
	    fakeElement: function( elem, options, callback, args ) {
	      var ret, name,
	          newElement = angular.element(elem).clone()[0];
	
	      for ( name in options ) {
	        newElement.style[ name ] = options[ name ];
	      }
	
	      angular.element(document.body).append(newElement);
	
	      ret = callback.call( newElement, newElement );
	
	      angular.element(newElement).remove();
	
	      return ret;
	    },
	
	    /**
	    * @ngdoc method
	    * @name normalizeWheelEvent
	    * @methodOf ui.grid.service:GridUtil
	    *
	    * @param {event} event A mouse wheel event
	    *
	    * @returns {event} A normalized event
	    *
	    * @description
	    * Given an event from this list:
	    *
	    * `wheel, mousewheel, DomMouseScroll, MozMousePixelScroll`
	    *
	    * "normalize" it
	    * so that it stays consistent no matter what browser it comes from (i.e. scale it correctly and make sure the direction is right.)
	    */
	    normalizeWheelEvent: function (event) {
	      // var toFix = ['wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll'];
	      // var toBind = 'onwheel' in document || document.documentMode >= 9 ? ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'];
	      var lowestDelta, lowestDeltaXY;
	
	      var orgEvent   = event || window.event,
	          args       = [].slice.call(arguments, 1),
	          delta      = 0,
	          deltaX     = 0,
	          deltaY     = 0,
	          absDelta   = 0,
	          absDeltaXY = 0,
	          fn;
	
	      // event = $.event.fix(orgEvent);
	      // event.type = 'mousewheel';
	
	      // NOTE: jQuery masks the event and stores it in the event as originalEvent
	      if (orgEvent.originalEvent) {
	        orgEvent = orgEvent.originalEvent;
	      }
	
	      // Old school scrollwheel delta
	      if ( orgEvent.wheelDelta ) { delta = orgEvent.wheelDelta; }
	      if ( orgEvent.detail )     { delta = orgEvent.detail * -1; }
	
	      // At a minimum, setup the deltaY to be delta
	      deltaY = delta;
	
	      // Firefox < 17 related to DOMMouseScroll event
	      if ( orgEvent.axis !== undefined && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
	          deltaY = 0;
	          deltaX = delta * -1;
	      }
	
	      // New school wheel delta (wheel event)
	      if ( orgEvent.deltaY ) {
	          deltaY = orgEvent.deltaY * -1;
	          delta  = deltaY;
	      }
	      if ( orgEvent.deltaX ) {
	          deltaX = orgEvent.deltaX;
	          delta  = deltaX * -1;
	      }
	
	      // Webkit
	      if ( orgEvent.wheelDeltaY !== undefined ) { deltaY = orgEvent.wheelDeltaY; }
	      if ( orgEvent.wheelDeltaX !== undefined ) { deltaX = orgEvent.wheelDeltaX; }
	
	      // Look for lowest delta to normalize the delta values
	      absDelta = Math.abs(delta);
	      if ( !lowestDelta || absDelta < lowestDelta ) { lowestDelta = absDelta; }
	      absDeltaXY = Math.max(Math.abs(deltaY), Math.abs(deltaX));
	      if ( !lowestDeltaXY || absDeltaXY < lowestDeltaXY ) { lowestDeltaXY = absDeltaXY; }
	
	      // Get a whole value for the deltas
	      fn     = delta > 0 ? 'floor' : 'ceil';
	      delta  = Math[fn](delta  / lowestDelta);
	      deltaX = Math[fn](deltaX / lowestDeltaXY);
	      deltaY = Math[fn](deltaY / lowestDeltaXY);
	
	      return {
	        delta: delta,
	        deltaX: deltaX,
	        deltaY: deltaY
	      };
	    },
	
	    // Stolen from Modernizr
	    // TODO: make this, and everythign that flows from it, robust
	    // http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
	    isTouchEnabled: function() {
	      var bool;
	
	      if (('ontouchstart' in $window) || $window.DocumentTouch && $document instanceof DocumentTouch) {
	        bool = true;
	      }
	
	      return bool;
	    },
	
	    isNullOrUndefined: function(obj) {
	      return (obj === undefined || obj === null);
	    },
	
	    endsWith: function(str, suffix) {
	      if (!str || !suffix || typeof str !== "string") {
	        return false;
	      }
	      return str.indexOf(suffix, str.length - suffix.length) !== -1;
	    },
	
	    arrayContainsObjectWithProperty: function(array, propertyName, propertyValue) {
	        var found = false;
	        angular.forEach(array, function (object) {
	            if (object[propertyName] === propertyValue) {
	                found = true;
	            }
	        });
	        return found;
	    },
	
	    numericAndNullSort: function (a, b) {
	      if (a === null) { return 1; }
	      if (b === null) { return -1; }
	      if (a === null && b === null) { return 0; }
	      return a - b;
	    },
	
	    // Disable ngAnimate animations on an element
	    disableAnimations: function (element) {
	      var $animate;
	      try {
	        $animate = $injector.get('$animate');
	        // See: http://brianhann.com/angular-1-4-breaking-changes-to-be-aware-of/#animate
	        if (angular.version.major > 1 || (angular.version.major === 1 && angular.version.minor >= 4)) {
	          $animate.enabled(element, false);
	        } else {
	          $animate.enabled(false, element);
	        }
	      }
	      catch (e) {}
	    },
	
	    enableAnimations: function (element) {
	      var $animate;
	      try {
	        $animate = $injector.get('$animate');
	        // See: http://brianhann.com/angular-1-4-breaking-changes-to-be-aware-of/#animate
	        if (angular.version.major > 1 || (angular.version.major === 1 && angular.version.minor >= 4)) {
	          $animate.enabled(element, true);
	        } else {
	          $animate.enabled(true, element);
	        }
	        return $animate;
	      }
	      catch (e) {}
	    },
	
	    // Blatantly stolen from Angular as it isn't exposed (yet)
	    nextUid: function nextUid() {
	      var index = uid.length;
	      var digit;
	
	      while (index) {
	        index--;
	        digit = uid[index].charCodeAt(0);
	        if (digit === 57 /*'9'*/) {
	          uid[index] = 'A';
	          return uidPrefix + uid.join('');
	        }
	        if (digit === 90  /*'Z'*/) {
	          uid[index] = '0';
	        } else {
	          uid[index] = String.fromCharCode(digit + 1);
	          return uidPrefix + uid.join('');
	        }
	      }
	      uid.unshift('0');
	
	      return uidPrefix + uid.join('');
	    },
	
	    // Blatantly stolen from Angular as it isn't exposed (yet)
	    hashKey: function hashKey(obj) {
	      var objType = typeof obj,
	          key;
	
	      if (objType === 'object' && obj !== null) {
	        if (typeof (key = obj.$$hashKey) === 'function') {
	          // must invoke on object to keep the right this
	          key = obj.$$hashKey();
	        }
	        else if (typeof(obj.$$hashKey) !== 'undefined' && obj.$$hashKey) {
	          key = obj.$$hashKey;
	        }
	        else if (key === undefined) {
	          key = obj.$$hashKey = s.nextUid();
	        }
	      }
	      else {
	        key = obj;
	      }
	
	      return objType + ': ' + key;
	    },
	
	    resetUids: function () {
	      uid = ['0', '0', '0'];
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil
	     * @name logError
	     * @description wraps the $log method, allowing us to choose different
	     * treatment within ui-grid if we so desired.  At present we only log
	     * error messages if uiGridConstants.LOG_ERROR_MESSAGES is set to true
	     * @param {string} logMessage message to be logged to the console
	     *
	     */
	    logError: function( logMessage ) {
	      if ( uiGridConstants.LOG_ERROR_MESSAGES ) {
	        $log.error( logMessage );
	      }
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil
	     * @name logWarn
	     * @description wraps the $log method, allowing us to choose different
	     * treatment within ui-grid if we so desired.  At present we only log
	     * warning messages if uiGridConstants.LOG_WARN_MESSAGES is set to true
	     * @param {string} logMessage message to be logged to the console
	     *
	     */
	    logWarn: function( logMessage ) {
	      if ( uiGridConstants.LOG_WARN_MESSAGES ) {
	        $log.warn( logMessage );
	      }
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil
	     * @name logDebug
	     * @description wraps the $log method, allowing us to choose different
	     * treatment within ui-grid if we so desired.  At present we only log
	     * debug messages if uiGridConstants.LOG_DEBUG_MESSAGES is set to true
	     *
	     */
	    logDebug: function() {
	      if ( uiGridConstants.LOG_DEBUG_MESSAGES ) {
	        $log.debug.apply($log, arguments);
	      }
	    }
	
	  };
	
	  /**
	   * @ngdoc object
	   * @name focus
	   * @propertyOf ui.grid.service:GridUtil
	   * @description Provides a set of methods to set the document focus inside the grid.
	   * See {@link ui.grid.service:GridUtil.focus} for more information.
	   */
	
	  /**
	   * @ngdoc object
	   * @name ui.grid.service:GridUtil.focus
	   * @description Provides a set of methods to set the document focus inside the grid.
	   * Timeouts are utilized to ensure that the focus is invoked after any other event has been triggered.
	   * e.g. click events that need to run before the focus or
	   * inputs elements that are in a disabled state but are enabled when those events
	   * are triggered.
	   */
	  s.focus = {
	    queue: [],
	    // http://stackoverflow.com/questions/25596399/set-element-focus-in-angular-way
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil.focus
	     * @name byId
	     * @description Sets the focus of the document to the given id value.
	     * If provided with the grid object it will automatically append the grid id.
	     * This is done to encourage unique dom id's as it allows for multiple grids on a
	     * page.
	     * @param {String} id the id of the dom element to set the focus on
	     * @param {Object=} Grid the grid object for this grid instance. See: {@link ui.grid.class:Grid}
	     * @param {Number} Grid.id the unique id for this grid. Already set on an initialized grid object.
	     * @returns {Promise} The `$timeout` promise that will be resolved once focus is set. If another focus is requested before this request is evaluated.
	     * then the promise will fail with the `'canceled'` reason.
	     */
	    byId: function (id, Grid) {
	      this._purgeQueue();
	      var promise = $timeout(function() {
	        var elementID = (Grid && Grid.id ? Grid.id + '-' : '') + id;
	        var element = $window.document.getElementById(elementID);
	        if (element) {
	          element.focus();
	        } else {
	          s.logWarn('[focus.byId] Element id ' + elementID + ' was not found.');
	        }
	      }, 0, false);
	      this.queue.push(promise);
	      return promise;
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil.focus
	     * @name byElement
	     * @description Sets the focus of the document to the given dom element.
	     * @param {(element|angular.element)} element the DOM element to set the focus on
	     * @returns {Promise} The `$timeout` promise that will be resolved once focus is set. If another focus is requested before this request is evaluated.
	     * then the promise will fail with the `'canceled'` reason.
	     */
	    byElement: function(element) {
	      if (!angular.isElement(element)) {
	        s.logWarn("Trying to focus on an element that isn\'t an element.");
	        return $q.reject('not-element');
	      }
	      element = angular.element(element);
	      this._purgeQueue();
	      var promise = $timeout(function() {
	        if (element) {
	          element[0].focus();
	        }
	      }, 0, false);
	      this.queue.push(promise);
	      return promise;
	    },
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil.focus
	     * @name bySelector
	     * @description Sets the focus of the document to the given dom element.
	     * @param {(element|angular.element)} parentElement the parent/ancestor of the dom element that you are selecting using the query selector
	     * @param {String} querySelector finds the dom element using the {@link http://www.w3schools.com/jsref/met_document_queryselector.asp querySelector}
	     * @param {boolean} [aSync=false] If true then the selector will be querried inside of a timeout. Otherwise the selector will be querried imidately
	     * then the focus will be called.
	     * @returns {Promise} The `$timeout` promise that will be resolved once focus is set. If another focus is requested before this request is evaluated.
	     * then the promise will fail with the `'canceled'` reason.
	     */
	    bySelector: function(parentElement, querySelector, aSync) {
	      var self = this;
	      if (!angular.isElement(parentElement)) {
	        throw new Error("The parent element is not an element.");
	      }
	      // Ensure that this is an angular element.
	      // It is fine if this is already an angular element.
	      parentElement = angular.element(parentElement);
	      var focusBySelector = function() {
	        var element = parentElement[0].querySelector(querySelector);
	        return self.byElement(element);
	      };
	      this._purgeQueue();
	      if (aSync) { // Do this asynchronysly
	        var promise = $timeout(focusBySelector, 0, false);
	        this.queue.push(promise);
	        return promise;
	      } else {
	        return focusBySelector();
	      }
	    },
	    _purgeQueue: function() {
	      this.queue.forEach(function(element) {
	        $timeout.cancel(element);
	      });
	      this.queue = [];
	    }
	  };
	
	
	  ['width', 'height'].forEach(function (name) {
	    var capsName = name.charAt(0).toUpperCase() + name.substr(1);
	
	    s['element' + capsName] = function (elem, extra) {
	      var e = elem;
	      if (e && typeof(e.length) !== 'undefined' && e.length) {
	        e = elem[0];
	      }
	
	      if (e && e !== null) {
	        var styles = getStyles(e);
	        return e.offsetWidth === 0 && rdisplayswap.test(styles.display) ?
	          s.swap(e, cssShow, function() {
	            return getWidthOrHeight(e, name, extra );
	          }) :
	          getWidthOrHeight( e, name, extra );
	      } else {
	        return null;
	      }
	    };
	
	    s['outerElement' + capsName] = function (elem, margin) {
	      return elem ? s['element' + capsName].call(this, elem, margin ? 'margin' : 'border') : null;
	    };
	  });
	
	  // http://stackoverflow.com/a/24107550/888165
	  s.closestElm = function closestElm(el, selector) {
	    if (typeof(el.length) !== 'undefined' && el.length) {
	      el = el[0];
	    }
	
	    var matchesFn;
	
	    // find vendor prefix
	    ['matches','webkitMatchesSelector','mozMatchesSelector','msMatchesSelector','oMatchesSelector'].some(function(fn) {
	        if (typeof document.body[fn] === 'function') {
	            matchesFn = fn;
	            return true;
	        }
	        return false;
	    });
	
	    // traverse parents
	    var parent;
	    while (el !== null) {
	      parent = el.parentElement;
	      if (parent !== null && parent[matchesFn](selector)) {
	          return parent;
	      }
	      el = parent;
	    }
	
	    return null;
	  };
	
	  s.type = function (obj) {
	    var text = Function.prototype.toString.call(obj.constructor);
	    return text.match(/function (.*?)\(/)[1];
	  };
	
	  s.getBorderSize = function getBorderSize(elem, borderType) {
	    if (typeof(elem.length) !== 'undefined' && elem.length) {
	      elem = elem[0];
	    }
	
	    var styles = getStyles(elem);
	
	    // If a specific border is supplied, like 'top', read the 'borderTop' style property
	    if (borderType) {
	      borderType = 'border' + borderType.charAt(0).toUpperCase() + borderType.slice(1);
	    }
	    else {
	      borderType = 'border';
	    }
	
	    borderType += 'Width';
	
	    var val = parseInt(styles[borderType], 10);
	
	    if (isNaN(val)) {
	      return 0;
	    }
	    else {
	      return val;
	    }
	  };
	
	  // http://stackoverflow.com/a/22948274/888165
	  // TODO: Opera? Mobile?
	  s.detectBrowser = function detectBrowser() {
	    var userAgent = $window.navigator.userAgent;
	
	    var browsers = {chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, ie: /internet explorer|trident\//i};
	
	    for (var key in browsers) {
	      if (browsers[key].test(userAgent)) {
	        return key;
	      }
	    }
	
	    return 'unknown';
	  };
	
	  // Borrowed from https://github.com/othree/jquery.rtl-scroll-type
	  // Determine the scroll "type" this browser is using for RTL
	  s.rtlScrollType = function rtlScrollType() {
	    if (rtlScrollType.type) {
	      return rtlScrollType.type;
	    }
	
	    var definer = angular.element('<div dir="rtl" style="width: 1px; height: 1px; position: fixed; top: 0px; left: 0px; overflow: hidden"><div style="width: 2px"><span style="display: inline-block; width: 1px"></span><span style="display: inline-block; width: 1px"></span></div></div>')[0],
	        type = 'reverse';
	
	    document.body.appendChild(definer);
	
	    if (definer.scrollLeft > 0) {
	      type = 'default';
	    }
	    else {
	      if (typeof Element !== 'undefined' && Element.prototype.scrollIntoView) {
	        definer.children[0].children[1].scrollIntoView();
	        if (definer.scrollLeft < 0) {
	          type = 'negative';
	        }
	      } else {
	        definer.scrollLeft = 1;
	        if (definer.scrollLeft === 0) {
	          type = 'negative';
	        }
	      }
	    }
	
	    angular.element(definer).remove();
	    rtlScrollType.type = type;
	
	    return type;
	  };
	
	    /**
	     * @ngdoc method
	     * @name normalizeScrollLeft
	     * @methodOf ui.grid.service:GridUtil
	     *
	     * @param {element} element The element to get the `scrollLeft` from.
	     * @param {grid} grid -  grid used to normalize (uses the rtl property)
	     *
	     * @returns {number} A normalized scrollLeft value for the current browser.
	     *
	     * @description
	     * Browsers currently handle RTL in different ways, resulting in inconsistent scrollLeft values. This method normalizes them
	     */
	  s.normalizeScrollLeft = function normalizeScrollLeft(element, grid) {
	    if (typeof(element.length) !== 'undefined' && element.length) {
	      element = element[0];
	    }
	
	    var scrollLeft = element.scrollLeft;
	
	    if (grid.isRTL()) {
	      switch (s.rtlScrollType()) {
	        case 'default':
	          return element.scrollWidth - scrollLeft - element.clientWidth;
	        case 'negative':
	          return Math.abs(scrollLeft);
	        case 'reverse':
	          return scrollLeft;
	      }
	    }
	
	    return scrollLeft;
	  };
	
	  /**
	  * @ngdoc method
	  * @name denormalizeScrollLeft
	  * @methodOf ui.grid.service:GridUtil
	  *
	  * @param {element} element The element to normalize the `scrollLeft` value for
	  * @param {number} scrollLeft The `scrollLeft` value to denormalize.
	  * @param {grid} grid The grid that owns the scroll event.
	  *
	  * @returns {number} A normalized scrollLeft value for the current browser.
	  *
	  * @description
	  * Browsers currently handle RTL in different ways, resulting in inconsistent scrollLeft values. This method denormalizes a value for the current browser.
	  */
	  s.denormalizeScrollLeft = function denormalizeScrollLeft(element, scrollLeft, grid) {
	    if (typeof(element.length) !== 'undefined' && element.length) {
	      element = element[0];
	    }
	
	    if (grid.isRTL()) {
	      switch (s.rtlScrollType()) {
	        case 'default':
	          // Get the max scroll for the element
	          var maxScrollLeft = element.scrollWidth - element.clientWidth;
	
	          // Subtract the current scroll amount from the max scroll
	          return maxScrollLeft - scrollLeft;
	        case 'negative':
	          return scrollLeft * -1;
	        case 'reverse':
	          return scrollLeft;
	      }
	    }
	
	    return scrollLeft;
	  };
	
	    /**
	     * @ngdoc method
	     * @name preEval
	     * @methodOf ui.grid.service:GridUtil
	     *
	     * @param {string} path Path to evaluate
	     *
	     * @returns {string} A path that is normalized.
	     *
	     * @description
	     * Takes a field path and converts it to bracket notation to allow for special characters in path
	     * @example
	     * <pre>
	     * gridUtil.preEval('property') == 'property'
	     * gridUtil.preEval('nested.deep.prop-erty') = "nested['deep']['prop-erty']"
	     * </pre>
	     */
	  s.preEval = function (path) {
	    var m = uiGridConstants.BRACKET_REGEXP.exec(path);
	    if (m) {
	      return (m[1] ? s.preEval(m[1]) : m[1]) + m[2] + (m[3] ? s.preEval(m[3]) : m[3]);
	    } else {
	      path = path.replace(uiGridConstants.APOS_REGEXP, '\\\'');
	      var parts = path.split(uiGridConstants.DOT_REGEXP);
	      var preparsed = [parts.shift()];    // first item must be var notation, thus skip
	      angular.forEach(parts, function (part) {
	        preparsed.push(part.replace(uiGridConstants.FUNC_REGEXP, '\']$1'));
	      });
	      return preparsed.join('[\'');
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name debounce
	   * @methodOf ui.grid.service:GridUtil
	   *
	   * @param {function} func function to debounce
	   * @param {number} wait milliseconds to delay
	   * @param {boolean} immediate execute before delay
	   *
	   * @returns {function} A function that can be executed as debounced function
	   *
	   * @description
	   * Copied from https://github.com/shahata/angular-debounce
	   * Takes a function, decorates it to execute only 1 time after multiple calls, and returns the decorated function
	   * @example
	   * <pre>
	   * var debouncedFunc =  gridUtil.debounce(function() {alert('debounced');}, 500);
	   * debouncedFunc();
	   * debouncedFunc();
	   * debouncedFunc();
	   * </pre>
	   */
	  s.debounce =  function (func, wait, immediate) {
	    var timeout, args, context, result;
	    function debounce() {
	      /* jshint validthis: true */
	      context = this;
	      args = arguments;
	      var later = function () {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	        }
	      };
	      var callNow = immediate && !timeout;
	      if (timeout) {
	        $timeout.cancel(timeout);
	      }
	      timeout = $timeout(later, wait, false);
	      if (callNow) {
	        result = func.apply(context, args);
	      }
	      return result;
	    }
	    debounce.cancel = function () {
	      $timeout.cancel(timeout);
	      timeout = null;
	    };
	    return debounce;
	  };
	
	  /**
	   * @ngdoc method
	   * @name throttle
	   * @methodOf ui.grid.service:GridUtil
	   *
	   * @param {function} func function to throttle
	   * @param {number} wait milliseconds to delay after first trigger
	   * @param {Object} options to use in throttle.
	   *
	   * @returns {function} A function that can be executed as throttled function
	   *
	   * @description
	   * Adapted from debounce function (above)
	   * Potential keys for Params Object are:
	   *    trailing (bool) - whether to trigger after throttle time ends if called multiple times
	   * Updated to use $interval rather than $timeout, as protractor (e2e tests) is able to work with $interval,
	   * but not with $timeout
	   *
	   * Note that when using throttle, you need to use throttle to create a new function upfront, then use the function
	   * return from that call each time you need to call throttle.  If you call throttle itself repeatedly, the lastCall
	   * variable will get overwritten and the throttling won't work
	   *
	   * @example
	   * <pre>
	   * var throttledFunc =  gridUtil.throttle(function() {console.log('throttled');}, 500, {trailing: true});
	   * throttledFunc(); //=> logs throttled
	   * throttledFunc(); //=> queues attempt to log throttled for ~500ms (since trailing param is truthy)
	   * throttledFunc(); //=> updates arguments to keep most-recent request, but does not do anything else.
	   * </pre>
	   */
	  s.throttle = function(func, wait, options) {
	    options = options || {};
	    var lastCall = 0, queued = null, context, args;
	
	    function runFunc(endDate) {
	      lastCall = +new Date();
	      func.apply(context, args);
	      $interval(function() {queued = null; }, 0, 1, false);
	    }
	
	    return function() {
	      /* jshint validthis: true */
	      context = this;
	      args = arguments;
	      if (queued === null) {
	        var sinceLast = +new Date() - lastCall;
	        if (sinceLast > wait) {
	          runFunc();
	        }
	        else if (options.trailing) {
	          queued = $interval(runFunc, wait - sinceLast, 1, false);
	        }
	      }
	    };
	  };
	
	  s.on = {};
	  s.off = {};
	  s._events = {};
	
	  s.addOff = function (eventName) {
	    s.off[eventName] = function (elm, fn) {
	      var idx = s._events[eventName].indexOf(fn);
	      if (idx > 0) {
	        s._events[eventName].removeAt(idx);
	      }
	    };
	  };
	
	  var mouseWheeltoBind = ( 'onwheel' in document || document.documentMode >= 9 ) ? ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'],
	      nullLowestDeltaTimeout,
	      lowestDelta;
	
	  s.on.mousewheel = function (elm, fn) {
	    if (!elm || !fn) { return; }
	
	    var $elm = angular.element(elm);
	
	    // Store the line height and page height for this particular element
	    $elm.data('mousewheel-line-height', getLineHeight($elm));
	    $elm.data('mousewheel-page-height', s.elementHeight($elm));
	    if (!$elm.data('mousewheel-callbacks')) { $elm.data('mousewheel-callbacks', {}); }
	
	    var cbs = $elm.data('mousewheel-callbacks');
	    cbs[fn] = (Function.prototype.bind || bindPolyfill).call(mousewheelHandler, $elm[0], fn);
	
	    // Bind all the mousew heel events
	    for ( var i = mouseWheeltoBind.length; i; ) {
	      $elm.on(mouseWheeltoBind[--i], cbs[fn]);
	    }
	    $elm.on('$destroy', function unbindEvents() {
	      for ( var i = mouseWheeltoBind.length; i; ) {
	        $elm.off(mouseWheeltoBind[--i], cbs[fn]);
	      }
	    });
	  };
	  s.off.mousewheel = function (elm, fn) {
	    var $elm = angular.element(elm);
	
	    var cbs = $elm.data('mousewheel-callbacks');
	    var handler = cbs[fn];
	
	    if (handler) {
	      for ( var i = mouseWheeltoBind.length; i; ) {
	        $elm.off(mouseWheeltoBind[--i], handler);
	      }
	    }
	
	    delete cbs[fn];
	
	    if (Object.keys(cbs).length === 0) {
	      $elm.removeData('mousewheel-line-height');
	      $elm.removeData('mousewheel-page-height');
	      $elm.removeData('mousewheel-callbacks');
	    }
	  };
	
	  function mousewheelHandler(fn, event) {
	    var $elm = angular.element(this);
	
	    var delta      = 0,
	        deltaX     = 0,
	        deltaY     = 0,
	        absDelta   = 0,
	        offsetX    = 0,
	        offsetY    = 0;
	
	    // jQuery masks events
	    if (event.originalEvent) { event = event.originalEvent; }
	
	    if ( 'detail'      in event ) { deltaY = event.detail * -1;      }
	    if ( 'wheelDelta'  in event ) { deltaY = event.wheelDelta;       }
	    if ( 'wheelDeltaY' in event ) { deltaY = event.wheelDeltaY;      }
	    if ( 'wheelDeltaX' in event ) { deltaX = event.wheelDeltaX * -1; }
	
	    // Firefox < 17 horizontal scrolling related to DOMMouseScroll event
	    if ( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
	      deltaX = deltaY * -1;
	      deltaY = 0;
	    }
	
	    // Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
	    delta = deltaY === 0 ? deltaX : deltaY;
	
	    // New school wheel delta (wheel event)
	    if ( 'deltaY' in event ) {
	      deltaY = event.deltaY * -1;
	      delta  = deltaY;
	    }
	    if ( 'deltaX' in event ) {
	      deltaX = event.deltaX;
	      if ( deltaY === 0 ) { delta  = deltaX * -1; }
	    }
	
	    // No change actually happened, no reason to go any further
	    if ( deltaY === 0 && deltaX === 0 ) { return; }
	
	    // Need to convert lines and pages to pixels if we aren't already in pixels
	    // There are three delta modes:
	    //   * deltaMode 0 is by pixels, nothing to do
	    //   * deltaMode 1 is by lines
	    //   * deltaMode 2 is by pages
	    if ( event.deltaMode === 1 ) {
	        var lineHeight = $elm.data('mousewheel-line-height');
	        delta  *= lineHeight;
	        deltaY *= lineHeight;
	        deltaX *= lineHeight;
	    }
	    else if ( event.deltaMode === 2 ) {
	        var pageHeight = $elm.data('mousewheel-page-height');
	        delta  *= pageHeight;
	        deltaY *= pageHeight;
	        deltaX *= pageHeight;
	    }
	
	    // Store lowest absolute delta to normalize the delta values
	    absDelta = Math.max( Math.abs(deltaY), Math.abs(deltaX) );
	
	    if ( !lowestDelta || absDelta < lowestDelta ) {
	      lowestDelta = absDelta;
	
	      // Adjust older deltas if necessary
	      if ( shouldAdjustOldDeltas(event, absDelta) ) {
	        lowestDelta /= 40;
	      }
	    }
	
	    // Get a whole, normalized value for the deltas
	    delta  = Math[ delta  >= 1 ? 'floor' : 'ceil' ](delta  / lowestDelta);
	    deltaX = Math[ deltaX >= 1 ? 'floor' : 'ceil' ](deltaX / lowestDelta);
	    deltaY = Math[ deltaY >= 1 ? 'floor' : 'ceil' ](deltaY / lowestDelta);
	
	    var newEvent = {
	      originalEvent: event,
	      deltaX: deltaX,
	      deltaY: deltaY,
	      deltaFactor: lowestDelta,
	      preventDefault: function () { event.preventDefault(); },
	      stopPropagation: function () { event.stopPropagation(); }
	    };
	
	    // Clearout lowestDelta after sometime to better
	    // handle multiple device types that give
	    // a different lowestDelta
	    // Ex: trackpad = 3 and mouse wheel = 120
	    if (nullLowestDeltaTimeout) { clearTimeout(nullLowestDeltaTimeout); }
	    nullLowestDeltaTimeout = setTimeout(nullLowestDelta, 200);
	
	    fn.call($elm[0], newEvent);
	  }
	
	  function nullLowestDelta() {
	    lowestDelta = null;
	  }
	
	  function shouldAdjustOldDeltas(orgEvent, absDelta) {
	    // If this is an older event and the delta is divisable by 120,
	    // then we are assuming that the browser is treating this as an
	    // older mouse wheel event and that we should divide the deltas
	    // by 40 to try and get a more usable deltaFactor.
	    // Side note, this actually impacts the reported scroll distance
	    // in older browsers and can cause scrolling to be slower than native.
	    // Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
	    return orgEvent.type === 'mousewheel' && absDelta % 120 === 0;
	  }
	
	  return s;
	}]);
	
	// Add 'px' to the end of a number string if it doesn't have it already
	module.filter('px', function() {
	  return function(str) {
	    if (str.match(/^[\d\.]+$/)) {
	      return str + 'px';
	    }
	    else {
	      return str;
	    }
	  };
	});
	
	})();
	
	/**
	 * @ngdoc overview
	 * @name ui.grid.i18n
	 * @description
	 *
	 *  # ui.grid.i18n
	 * This module provides i18n functions to ui.grid and any application that wants to use it
	
	 *
	 * <div doc-module-components="ui.grid.i18n"></div>
	 */
	
	(function () {
	  var DIRECTIVE_ALIASES = ['uiT', 'uiTranslate'];
	  var FILTER_ALIASES = ['t', 'uiTranslate'];
	
	  var module = angular.module('ui.grid.i18n');
	
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.i18n.constant:i18nConstants
	   *
	   *  @description constants available in i18n module
	   */
	  module.constant('i18nConstants', {
	    MISSING: '[MISSING]',
	    UPDATE_EVENT: '$uiI18n',
	
	    LOCALE_DIRECTIVE_ALIAS: 'uiI18n',
	    // default to english
	    DEFAULT_LANG: 'en'
	  });
	
	//    module.config(['$provide', function($provide) {
	//        $provide.decorator('i18nService', ['$delegate', function($delegate) {}])}]);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.i18n.service:i18nService
	   *
	   *  @description Services for i18n
	   */
	  module.service('i18nService', ['$log', '$parse', 'i18nConstants', '$rootScope',
	    function ($log, $parse, i18nConstants, $rootScope) {
	
	      var langCache = {
	        _langs: {},
	        current: null,
	        fallback: i18nConstants.DEFAULT_LANG,
	        get: function (lang) {
	          var self = this,
	            fallbackLang = self.getFallbackLang();
	
	          if (lang !== self.fallback) {
	            return angular.extend({}, self._langs[fallbackLang],
	              self._langs[lang.toLowerCase()]);
	          }
	
	          return self._langs[lang.toLowerCase()];
	        },
	        add: function (lang, strings) {
	          var lower = lang.toLowerCase();
	          if (!this._langs[lower]) {
	            this._langs[lower] = {};
	          }
	          angular.merge(this._langs[lower], strings);
	        },
	        getAllLangs: function () {
	          var langs = [];
	          if (!this._langs) {
	            return langs;
	          }
	
	          for (var key in this._langs) {
	            langs.push(key);
	          }
	
	          return langs;
	        },
	        setCurrent: function (lang) {
	          this.current = lang.toLowerCase();
	        },
	        setFallback: function (lang) {
	          this.fallback = lang.toLowerCase();
	        },
	        getCurrentLang: function () {
	          return this.current;
	        },
	        getFallbackLang: function () {
	          return this.fallback.toLowerCase();
	        }
	      };
	
	      function getMissingText(path) {
	        $log.warn(i18nConstants.MISSING + path);
	        return '';
	      }
	
	      var service = {
	
	        /**
	         * @ngdoc service
	         * @name add
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description  Adds the languages and strings to the cache. Decorate this service to
	         * add more translation strings
	         * @param {string} langs languages to add
	         * @param {object} stringMaps of strings to add grouped by property names
	         * @example
	         * <pre>
	         *      i18nService.add('en', {
	         *         aggregate: {
	         *                 label1: 'items',
	         *                 label2: 'some more items'
	         *                 }
	         *         },
	         *         groupPanel: {
	         *              description: 'Drag a column header here and drop it to group by that column.'
	         *           }
	         *      }
	         * </pre>
	         */
	        add: function (langs, stringMaps) {
	          if (typeof(langs) === 'object') {
	            angular.forEach(langs, function (lang) {
	              if (lang) {
	                langCache.add(lang, stringMaps);
	              }
	            });
	          } else {
	            langCache.add(langs, stringMaps);
	          }
	        },
	
	        /**
	         * @ngdoc service
	         * @name getAllLangs
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description  return all currently loaded languages
	         * @returns {array} string
	         */
	        getAllLangs: function () {
	          return langCache.getAllLangs();
	        },
	
	        /**
	         * @ngdoc service
	         * @name get
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description  return all currently loaded languages
	         * @param {string} lang to return.  If not specified, returns current language
	         * @returns {object} the translation string maps for the language
	         */
	        get: function (lang) {
	          var language = lang ? lang : service.getCurrentLang();
	          return langCache.get(language);
	        },
	
	        /**
	         * @ngdoc service
	         * @name getSafeText
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description  returns the text specified in the path or a Missing text if text is not found
	         * @param {String} path property path to use for retrieving text from string map
	         * @param {String} [lang] to return.  If not specified, returns current language
	         * @returns {object} the translation for the path
	         * @example
	         * <pre>
	         * i18nService.getSafeText('sort.ascending')
	         * </pre>
	         */
	        getSafeText: function (path, lang) {
	          var language = lang || service.getCurrentLang(),
	            trans = langCache.get(language),
	            getter = $parse(path);
	
	          if (!trans) {
	            return getMissingText(path);
	          }
	
	          return getter(trans) || getMissingText(path);
	        },
	
	        /**
	         * @ngdoc service
	         * @name setCurrentLang
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description sets the current language to use in the application
	         * $broadcasts the i18nConstants.UPDATE_EVENT on the $rootScope
	         * @param {string} lang to set
	         * @example
	         * <pre>
	         * i18nService.setCurrentLang('fr');
	         * </pre>
	         */
	        setCurrentLang: function (lang) {
	          if (lang) {
	            langCache.setCurrent(lang);
	            $rootScope.$broadcast(i18nConstants.UPDATE_EVENT);
	          }
	        },
	
	        /**
	         * @ngdoc service
	         * @name setFallbackLang
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description sets the fallback language to use in the application.
	         * The default fallback language is english.
	         * @param {string} lang to set
	         * @example
	         * <pre>
	         * i18nService.setFallbackLang('en');
	         * </pre>
	         */
	        setFallbackLang: function (lang) {
	          if (lang) {
	            langCache.setFallback(lang);
	          }
	        },
	
	        /**
	         * @ngdoc service
	         * @name getCurrentLang
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description returns the current language used in the application
	         */
	        getCurrentLang: function () {
	          var lang = langCache.getCurrentLang();
	          if (!lang) {
	            lang = i18nConstants.DEFAULT_LANG;
	            langCache.setCurrent(lang);
	          }
	          return lang;
	        },
	
	        /**
	         * @ngdoc service
	         * @name getFallbackLang
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description returns the fallback language used in the application
	         */
	        getFallbackLang: function () {
	          return langCache.getFallbackLang();
	        }
	      };
	
	      return service;
	    }]);
	
	  function localeDirective(i18nService, i18nConstants) {
	    return {
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs) {
	            var alias = i18nConstants.LOCALE_DIRECTIVE_ALIAS;
	            // check for watchable property
	            var lang = $scope.$eval($attrs[alias]);
	            if (lang) {
	              $scope.$watch($attrs[alias], function () {
	                i18nService.setCurrentLang(lang);
	              });
	            } else if ($attrs.$$observers) {
	              $attrs.$observe(alias, function () {
	                i18nService.setCurrentLang($attrs[alias] || i18nConstants.DEFAULT_LANG);
	              });
	            }
	          }
	        };
	      }
	    };
	  }
	
	  module.directive('uiI18n', ['i18nService', 'i18nConstants', localeDirective]);
	
	  // directive syntax
	  function uitDirective(i18nService, i18nConstants) {
	    return {
	      restrict: 'EA',
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs) {
	            var listener, observer, prop,
	              alias1 = DIRECTIVE_ALIASES[0],
	              alias2 = DIRECTIVE_ALIASES[1],
	              token = $attrs[alias1] || $attrs[alias2] || $elm.html();
	
	            function translateToken(property) {
	              var safeText = i18nService.getSafeText(property);
	
	              $elm.html(safeText);
	            }
	
	            if ($attrs.$$observers) {
	              prop = $attrs[alias1] ? alias1 : alias2;
	              observer = $attrs.$observe(prop, function (result) {
	                if (result) {
	                  translateToken(result);
	                }
	              });
	            }
	
	            listener = $scope.$on(i18nConstants.UPDATE_EVENT, function() {
	              if (observer) {
	                observer($attrs[alias1] || $attrs[alias2]);
	              } else {
	                // set text based on i18n current language
	                translateToken(token);
	              }
	            });
	            $scope.$on('$destroy', listener);
	
	            translateToken(token);
	          }
	        };
	      }
	    };
	  }
	
	  angular.forEach(DIRECTIVE_ALIASES, function ( alias ) {
	    module.directive(alias, ['i18nService', 'i18nConstants', uitDirective]);
	  });
	
	  // optional filter syntax
	  function uitFilter(i18nService) {
	    return function (data, lang) {
	      // set text based on i18n current language
	      return i18nService.getSafeText(data, lang);
	    };
	  }
	
	  angular.forEach(FILTER_ALIASES, function ( alias ) {
	    module.filter(alias, ['i18nService', uitFilter]);
	  });
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.edit
	   * @description
	   *
	   * # ui.grid.edit
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides cell editing capability to ui.grid. The goal was to emulate keying data in a spreadsheet via
	   * a keyboard.
	   * <br/>
	   * <br/>
	   * To really get the full spreadsheet-like data entry, the ui.grid.cellNav module should be used. This will allow the
	   * user to key data and then tab, arrow, or enter to the cells beside or below.
	   *
	   * <div doc-module-components="ui.grid.edit"></div>
	   */
	
	  var module = angular.module('ui.grid.edit', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.edit.constant:uiGridEditConstants
	   *
	   *  @description constants available in edit module
	   */
	  module.constant('uiGridEditConstants', {
	    EDITABLE_CELL_TEMPLATE: /EDITABLE_CELL_TEMPLATE/g,
	    // must be lowercase because template bulder converts to lower
	    EDITABLE_CELL_DIRECTIVE: /editable_cell_directive/g,
	    events: {
	      BEGIN_CELL_EDIT: 'uiGridEventBeginCellEdit',
	      END_CELL_EDIT: 'uiGridEventEndCellEdit',
	      CANCEL_CELL_EDIT: 'uiGridEventCancelCellEdit'
	    }
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.edit.service:uiGridEditService
	   *
	   *  @description Services for editing features
	   */
	  module.service('uiGridEditService', ['$q', 'uiGridConstants', 'gridUtil',
	    function ($q, uiGridConstants, gridUtil) {
	
	      var service = {
	
	        initializeGrid: function (grid) {
	
	          service.defaultGridOptions(grid.options);
	
	          grid.registerColumnBuilder(service.editColumnBuilder);
	          grid.edit = {};
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.edit.api:PublicApi
	           *
	           *  @description Public Api for edit feature
	           */
	          var publicApi = {
	            events: {
	              edit: {
	                /**
	                 * @ngdoc event
	                 * @name afterCellEdit
	                 * @eventOf  ui.grid.edit.api:PublicApi
	                 * @description raised when cell editing is complete
	                 * <pre>
	                 *      gridApi.edit.on.afterCellEdit(scope,function(rowEntity, colDef) {})
	                 * </pre>
	                 * @param {object} rowEntity the options.data element that was edited
	                 * @param {object} colDef the column that was edited
	                 * @param {object} newValue new value
	                 * @param {object} oldValue old value
	                 */
	                afterCellEdit: function (rowEntity, colDef, newValue, oldValue) {
	                },
	                /**
	                 * @ngdoc event
	                 * @name beginCellEdit
	                 * @eventOf  ui.grid.edit.api:PublicApi
	                 * @description raised when cell editing starts on a cell
	                 * <pre>
	                 *      gridApi.edit.on.beginCellEdit(scope,function(rowEntity, colDef) {})
	                 * </pre>
	                 * @param {object} rowEntity the options.data element that was edited
	                 * @param {object} colDef the column that was edited
	                 * @param {object} triggerEvent the event that triggered the edit.  Useful to prevent losing keystrokes on some
	                 *                 complex editors
	                 */
	                beginCellEdit: function (rowEntity, colDef, triggerEvent) {
	                },
	                /**
	                 * @ngdoc event
	                 * @name cancelCellEdit
	                 * @eventOf  ui.grid.edit.api:PublicApi
	                 * @description raised when cell editing is cancelled on a cell
	                 * <pre>
	                 *      gridApi.edit.on.cancelCellEdit(scope,function(rowEntity, colDef) {})
	                 * </pre>
	                 * @param {object} rowEntity the options.data element that was edited
	                 * @param {object} colDef the column that was edited
	                 */
	                cancelCellEdit: function (rowEntity, colDef) {
	                }
	              }
	            },
	            methods: {
	              edit: { }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	          // grid.api.registerMethodsFromObject(publicApi.methods);
	        },
	
	        defaultGridOptions: function (gridOptions) {
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.edit.api:GridOptions
	           *
	           *  @description Options for configuring the edit feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableCellEdit
	           *  @propertyOf  ui.grid.edit.api:GridOptions
	           *  @description If defined, sets the default value for the editable flag on each individual colDefs
	           *  if their individual enableCellEdit configuration is not defined. Defaults to undefined.
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name cellEditableCondition
	           *  @propertyOf  ui.grid.edit.api:GridOptions
	           *  @description If specified, either a value or function to be used by all columns before editing.
	           *  If false, then editing of cell is not allowed.
	           *  @example
	           *  <pre>
	           *  function($scope, triggerEvent) {
	           *    //use $scope.row.entity, $scope.col.colDef and triggerEvent to determine if editing is allowed
	           *    return true;
	           *  }
	           *  </pre>
	           */
	          gridOptions.cellEditableCondition = gridOptions.cellEditableCondition === undefined ? true : gridOptions.cellEditableCondition;
	
	          /**
	           *  @ngdoc object
	           *  @name editableCellTemplate
	           *  @propertyOf  ui.grid.edit.api:GridOptions
	           *  @description If specified, cellTemplate to use as the editor for all columns.
	           *  <br/> defaults to 'ui-grid/cellTextEditor'
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableCellEditOnFocus
	           *  @propertyOf  ui.grid.edit.api:GridOptions
	           *  @description If true, then editor is invoked as soon as cell receives focus. Default false.
	           *  <br/>_requires cellNav feature and the edit feature to be enabled_
	           */
	            // enableCellEditOnFocus can only be used if cellnav module is used
	          gridOptions.enableCellEditOnFocus = gridOptions.enableCellEditOnFocus === undefined ? false : gridOptions.enableCellEditOnFocus;
	        },
	
	        /**
	         * @ngdoc service
	         * @name editColumnBuilder
	         * @methodOf ui.grid.edit.service:uiGridEditService
	         * @description columnBuilder function that adds edit properties to grid column
	         * @returns {promise} promise that will load any needed templates when resolved
	         */
	        editColumnBuilder: function (colDef, col, gridOptions) {
	
	          var promises = [];
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.edit.api:ColumnDef
	           *
	           *  @description Column Definition for edit feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableCellEdit
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @description enable editing on column
	           */
	          colDef.enableCellEdit = colDef.enableCellEdit === undefined ? (gridOptions.enableCellEdit === undefined ?
	            (colDef.type !== 'object') : gridOptions.enableCellEdit) : colDef.enableCellEdit;
	
	          /**
	           *  @ngdoc object
	           *  @name cellEditableCondition
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @description If specified, either a value or function evaluated before editing cell.  If falsy, then editing of cell is not allowed.
	           *  @example
	           *  <pre>
	           *  function($scope, triggerEvent) {
	           *    //use $scope.row.entity, $scope.col.colDef and triggerEvent to determine if editing is allowed
	           *    return true;
	           *  }
	           *  </pre>
	           */
	          colDef.cellEditableCondition = colDef.cellEditableCondition === undefined ? gridOptions.cellEditableCondition :  colDef.cellEditableCondition;
	
	          /**
	           *  @ngdoc object
	           *  @name editableCellTemplate
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @description cell template to be used when editing this column. Can be Url or text template
	           *  <br/>Defaults to gridOptions.editableCellTemplate
	           */
	          if (colDef.enableCellEdit) {
	            colDef.editableCellTemplate = colDef.editableCellTemplate || gridOptions.editableCellTemplate || 'ui-grid/cellEditor';
	
	            promises.push(gridUtil.getTemplate(colDef.editableCellTemplate)
	              .then(
	              function (template) {
	                col.editableCellTemplate = template;
	              },
	              function (res) {
	                // Todo handle response error here?
	                throw new Error("Couldn't fetch/use colDef.editableCellTemplate '" + colDef.editableCellTemplate + "'");
	              }));
	          }
	
	          /**
	           *  @ngdoc object
	           *  @name enableCellEditOnFocus
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @requires ui.grid.cellNav
	           *  @description If true, then editor is invoked as soon as cell receives focus. Default false.
	           *  <br>_requires both the cellNav feature and the edit feature to be enabled_
	           */
	            // enableCellEditOnFocus can only be used if cellnav module is used
	          colDef.enableCellEditOnFocus = colDef.enableCellEditOnFocus === undefined ? gridOptions.enableCellEditOnFocus : colDef.enableCellEditOnFocus;
	
	
	          /**
	           *  @ngdoc string
	           *  @name editModelField
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @description a bindable string value that is used when binding to edit controls instead of colDef.field
	           *  <br/> example: You have a complex property on and object like state:{abbrev: 'MS',name: 'Mississippi'}.  The
	           *  grid should display state.name in the cell and sort/filter based on the state.name property but the editor
	           *  requires the full state object.
	           *  <br/>colDef.field = 'state.name'
	           *  <br/>colDef.editModelField = 'state'
	           */
	          // colDef.editModelField
	
	          return $q.all(promises);
	        },
	
	        /**
	         * @ngdoc service
	         * @name isStartEditKey
	         * @methodOf ui.grid.edit.service:uiGridEditService
	         * @description  Determines if a keypress should start editing.  Decorate this service to override with your
	         * own key events.  See service decorator in angular docs.
	         * @param {Event} evt keydown event
	         * @returns {boolean} true if an edit should start
	         */
	        isStartEditKey: function (evt) {
	          return !(evt.metaKey ||
	              evt.keyCode === uiGridConstants.keymap.ESC ||
	              evt.keyCode === uiGridConstants.keymap.SHIFT ||
	              evt.keyCode === uiGridConstants.keymap.CTRL ||
	              evt.keyCode === uiGridConstants.keymap.ALT ||
	              evt.keyCode === uiGridConstants.keymap.WIN ||
	              evt.keyCode === uiGridConstants.keymap.CAPSLOCK ||
	
	             evt.keyCode === uiGridConstants.keymap.LEFT ||
	            (evt.keyCode === uiGridConstants.keymap.TAB && evt.shiftKey) ||
	
	            evt.keyCode === uiGridConstants.keymap.RIGHT ||
	            evt.keyCode === uiGridConstants.keymap.TAB ||
	
	            evt.keyCode === uiGridConstants.keymap.UP ||
	            (evt.keyCode === uiGridConstants.keymap.ENTER && evt.shiftKey) ||
	
	            evt.keyCode === uiGridConstants.keymap.DOWN ||
	            evt.keyCode === uiGridConstants.keymap.ENTER);
	        }
	      };
	
	      return service;
	
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridEdit
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds editing features to the ui-grid directive.
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.edit']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true},
	        {name: 'title', enableCellEdit: true}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-edit></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridEdit', ['gridUtil', 'uiGridEditService', function (gridUtil, uiGridEditService) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridEditService.initializeGrid(uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridRenderContainer
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds keydown listeners to renderContainer element so we can capture when to begin edits
	   *
	   */
	  module.directive('uiGridViewport', [ 'uiGridEditConstants',
	    function ( uiGridEditConstants) {
	      return {
	        replace: true,
	        priority: -99998, // run before cellNav
	        require: ['^uiGrid', '^uiGridRenderContainer'],
	        scope: false,
	        compile: function () {
	          return {
	            post: function ($scope, $elm, $attrs, controllers) {
	              var uiGridCtrl = controllers[0];
	
	              // Skip attaching if edit and cellNav is not enabled
	              if (!uiGridCtrl.grid.api.edit || !uiGridCtrl.grid.api.cellNav) { return; }
	
	              var containerId =  controllers[1].containerId;
	              // no need to process for other containers
	              if (containerId !== 'body') {
	                return;
	              }
	
	              // refocus on the grid
	              $scope.$on(uiGridEditConstants.events.CANCEL_CELL_EDIT, function () {
	                uiGridCtrl.focus();
	              });
	              $scope.$on(uiGridEditConstants.events.END_CELL_EDIT, function () {
	                uiGridCtrl.focus();
	              });
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridCell
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Stacks on top of ui.grid.uiGridCell to provide in-line editing capabilities to the cell
	   *  Editing Actions.
	   *
	   *  Binds edit start events to the uiGridCell element.  When the events fire, the gridCell element is appended
	   *  with the columnDef.editableCellTemplate element ('cellEditor.html' by default).
	   *
	   *  The editableCellTemplate should respond to uiGridEditConstants.events.BEGIN\_CELL\_EDIT angular event
	   *  and do the initial steps needed to edit the cell (setfocus on input element, etc).
	   *
	   *  When the editableCellTemplate recognizes that the editing is ended (blur event, Enter key, etc.)
	   *  it should emit the uiGridEditConstants.events.END\_CELL\_EDIT event.
	   *
	   *  If editableCellTemplate recognizes that the editing has been cancelled (esc key)
	   *  it should emit the uiGridEditConstants.events.CANCEL\_CELL\_EDIT event.  The original value
	   *  will be set back on the model by the uiGridCell directive.
	   *
	   *  Events that invoke editing:
	   *    - dblclick
	   *    - F2 keydown (when using cell selection)
	   *
	   *  Events that end editing:
	   *    - Dependent on the specific editableCellTemplate
	   *    - Standards should be blur and enter keydown
	   *
	   *  Events that cancel editing:
	   *    - Dependent on the specific editableCellTemplate
	   *    - Standards should be Esc keydown
	   *
	   *  Grid Events that end editing:
	   *    - uiGridConstants.events.GRID_SCROLL
	   *
	   */
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.edit.api:GridRow
	   *
	   *  @description GridRow options for edit feature, these are available to be
	   *  set internally only, by other features
	   */
	
	  /**
	   *  @ngdoc object
	   *  @name enableCellEdit
	   *  @propertyOf  ui.grid.edit.api:GridRow
	   *  @description enable editing on row, grouping for example might disable editing on group header rows
	   */
	
	  module.directive('uiGridCell',
	    ['$compile', '$injector', '$timeout', 'uiGridConstants', 'uiGridEditConstants', 'gridUtil', '$parse', 'uiGridEditService', '$rootScope', '$q',
	      function ($compile, $injector, $timeout, uiGridConstants, uiGridEditConstants, gridUtil, $parse, uiGridEditService, $rootScope, $q) {
	        var touchstartTimeout = 500;
	        if ($injector.has('uiGridCellNavService')) {
	          var uiGridCellNavService = $injector.get('uiGridCellNavService');
	        }
	
	        return {
	          priority: -100, // run after default uiGridCell directive
	          restrict: 'A',
	          scope: false,
	          require: '?^uiGrid',
	          link: function ($scope, $elm, $attrs, uiGridCtrl) {
	            var html,
	              origCellValue,
	              cellModel,
	              cancelTouchstartTimeout,
	              inEdit = false;
	
	            var editCellScope;
	
	            if (!$scope.col.colDef.enableCellEdit) {
	              return;
	            }
	
	            var cellNavNavigateDereg = function() {};
	            var viewPortKeyDownDereg = function() {};
	
	
	            var setEditable = function() {
	              if ($scope.col.colDef.enableCellEdit && $scope.row.enableCellEdit !== false) {
	                if (!$scope.beginEditEventsWired) { // prevent multiple attachments
	                  registerBeginEditEvents();
	                }
	              } else {
	                if ($scope.beginEditEventsWired) {
	                  cancelBeginEditEvents();
	                }
	              }
	            };
	
	            setEditable();
	
	            var rowWatchDereg = $scope.$watch('row', function (n, o) {
	              if (n !== o) {
	                setEditable();
	              }
	            });
	
	
	            $scope.$on('$destroy', function destroyEvents() {
	              rowWatchDereg();
	              // unbind all jquery events in order to avoid memory leaks
	              $elm.off();
	            });
	
	            function registerBeginEditEvents() {
	              $elm.on('dblclick', beginEdit);
	
	              // Add touchstart handling. If the users starts a touch and it doesn't end after X milliseconds, then start the edit
	              $elm.on('touchstart', touchStart);
	
	              if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	
	                viewPortKeyDownDereg = uiGridCtrl.grid.api.cellNav.on.viewPortKeyDown($scope, function (evt, rowCol) {
	                  if (rowCol === null) {
	                    return;
	                  }
	
	                  if (rowCol.row === $scope.row && rowCol.col === $scope.col && !$scope.col.colDef.enableCellEditOnFocus) {
	                    // important to do this before scrollToIfNecessary
	                    beginEditKeyDown(evt);
	                  }
	                });
	
	                cellNavNavigateDereg = uiGridCtrl.grid.api.cellNav.on.navigate($scope, function (newRowCol, oldRowCol, evt) {
	                  if ($scope.col.colDef.enableCellEditOnFocus) {
	                    // Don't begin edit if the cell hasn't changed
	                    if (newRowCol.row === $scope.row && newRowCol.col === $scope.col &&
	                      (evt === null || (evt && (evt.type === 'click' || evt.type === 'keydown')))) {
	                      $timeout(function() {
	                        beginEdit(evt);
	                      });
	                    }
	                  }
	                });
	              }
	
	              $scope.beginEditEventsWired = true;
	            }
	
	            function touchStart(event) {
	              // jQuery masks events
	              if (typeof(event.originalEvent) !== 'undefined' && event.originalEvent !== undefined) {
	                event = event.originalEvent;
	              }
	
	              // Bind touchend handler
	              $elm.on('touchend', touchEnd);
	
	              // Start a timeout
	              cancelTouchstartTimeout = $timeout(function() { }, touchstartTimeout);
	
	              // Timeout's done! Start the edit
	              cancelTouchstartTimeout.then(function () {
	                // Use setTimeout to start the edit because beginEdit expects to be outside of $digest
	                setTimeout(beginEdit, 0);
	
	                // Undbind the touchend handler, we don't need it anymore
	                $elm.off('touchend', touchEnd);
	              }).catch(angular.noop);
	            }
	
	            // Cancel any touchstart timeout
	            function touchEnd() {
	              $timeout.cancel(cancelTouchstartTimeout);
	              $elm.off('touchend', touchEnd);
	            }
	
	            function cancelBeginEditEvents() {
	              $elm.off('dblclick', beginEdit);
	              $elm.off('keydown', beginEditKeyDown);
	              $elm.off('touchstart', touchStart);
	              cellNavNavigateDereg();
	              viewPortKeyDownDereg();
	              $scope.beginEditEventsWired = false;
	            }
	
	            function beginEditKeyDown(evt) {
	              if (uiGridEditService.isStartEditKey(evt)) {
	                beginEdit(evt);
	              }
	            }
	
	            function shouldEdit(col, row, triggerEvent) {
	              return !row.isSaving &&
	                ( angular.isFunction(col.colDef.cellEditableCondition) ?
	                    col.colDef.cellEditableCondition($scope, triggerEvent) :
	                    col.colDef.cellEditableCondition );
	            }
	
	
	            function beginEdit(triggerEvent) {
	              // we need to scroll the cell into focus before invoking the editor
	              $scope.grid.api.core.scrollToIfNecessary($scope.row, $scope.col)
	                .then(function () {
	                  beginEditAfterScroll(triggerEvent);
	                });
	            }
	
	            /**
	             *  @ngdoc property
	             *  @name editDropdownOptionsArray
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description an array of values in the format
	             *  [ {id: xxx, value: xxx} ], which is populated
	             *  into the edit dropdown
	             *
	             */
	            /**
	             *  @ngdoc property
	             *  @name editDropdownIdLabel
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description the label for the "id" field
	             *  in the editDropdownOptionsArray.  Defaults
	             *  to 'id'
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownOptionsArray: [{code: 1, status: 'active'}, {code: 2, status: 'inactive'}],
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
	             *      ],
	             *  </pre>
	             *
	             */
	            /**
	             *  @ngdoc property
	             *  @name editDropdownRowEntityOptionsArrayPath
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description a path to a property on row.entity containing an
	             *  array of values in the format
	             *  [ {id: xxx, value: xxx} ], which will be used to populate
	             *  the edit dropdown.  This can be used when the dropdown values are dependent on
	             *  the backing row entity.
	             *  If this property is set then editDropdownOptionsArray will be ignored.
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownRowEntityOptionsArrayPath: 'foo.bars[0].baz',
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
	             *      ],
	             *  </pre>
	             *
	             */
	            /**
	             *  @ngdoc service
	             *  @name editDropdownOptionsFunction
	             *  @methodOf ui.grid.edit.api:ColumnDef
	             *  @description a function returning an array of values in the format
	             *  [ {id: xxx, value: xxx} ], which will be used to populate
	             *  the edit dropdown.  This can be used when the dropdown values are dependent on
	             *  the backing row entity with some kind of algorithm.
	             *  If this property is set then both editDropdownOptionsArray and
	             *  editDropdownRowEntityOptionsArrayPath will be ignored.
	             *  @param {object} rowEntity the options.data element that the returned array refers to
	             *  @param {object} colDef the column that implements this dropdown
	             *  @returns {object} an array of values in the format
	             *  [ {id: xxx, value: xxx} ] used to populate the edit dropdown
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownOptionsFunction: function(rowEntity, colDef) {
	             *            if (rowEntity.foo === 'bar') {
	             *              return [{id: 'bar1', value: 'BAR 1'},
	             *                      {id: 'bar2', value: 'BAR 2'},
	             *                      {id: 'bar3', value: 'BAR 3'}];
	             *            } else {
	             *              return [{id: 'foo1', value: 'FOO 1'},
	             *                      {id: 'foo2', value: 'FOO 2'}];
	             *            }
	             *          },
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
	             *      ],
	             *  </pre>
	             *
	             */
	            /**
	             *  @ngdoc property
	             *  @name editDropdownValueLabel
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description the label for the "value" field
	             *  in the editDropdownOptionsArray.  Defaults
	             *  to 'value'
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownOptionsArray: [{code: 1, status: 'active'}, {code: 2, status: 'inactive'}],
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
	             *      ],
	             *  </pre>
	             *
	             */
	            /**
	             *  @ngdoc property
	             *  @name editDropdownFilter
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description A filter that you would like to apply to the values in the options list
	             *  of the dropdown.  For example if you were using angular-translate you might set this
	             *  to `'translate'`
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownOptionsArray: [{code: 1, status: 'active'}, {code: 2, status: 'inactive'}],
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status', editDropdownFilter: 'translate' }
	             *      ],
	             *  </pre>
	             *
	             */
	            function beginEditAfterScroll(triggerEvent) {
	              // If we are already editing, then just skip this so we don't try editing twice...
	              if (inEdit) {
	                return;
	              }
	
	              if (!shouldEdit($scope.col, $scope.row, triggerEvent)) {
	                return;
	              }
	
	              var modelField = $scope.row.getQualifiedColField($scope.col);
	              if ($scope.col.colDef.editModelField) {
	                modelField = gridUtil.preEval('row.entity.' + $scope.col.colDef.editModelField);
	              }
	
	              cellModel = $parse(modelField);
	
	              // get original value from the cell
	              origCellValue = cellModel($scope);
	
	              html = $scope.col.editableCellTemplate;
	              html = html.replace(uiGridConstants.MODEL_COL_FIELD, modelField);
	              html = html.replace(uiGridConstants.COL_FIELD, 'grid.getCellValue(row, col)');
	
	              var optionFilter = $scope.col.colDef.editDropdownFilter ? '|' + $scope.col.colDef.editDropdownFilter : '';
	              html = html.replace(uiGridConstants.CUSTOM_FILTERS, optionFilter);
	
	              var inputType = 'text';
	              switch ($scope.col.colDef.type) {
	                case 'boolean':
	                  inputType = 'checkbox';
	                  break;
	                case 'number':
	                  inputType = 'number';
	                  break;
	                case 'date':
	                  inputType = 'date';
	                  break;
	              }
	              html = html.replace('INPUT_TYPE', inputType);
	
	              // In order to fill dropdown options we use:
	              // - A function/promise or
	              // - An array inside of row entity if no function exists or
	              // - A single array for the whole column if none of the previous exists.
	              var editDropdownOptionsFunction = $scope.col.colDef.editDropdownOptionsFunction;
	              if (editDropdownOptionsFunction) {
	                $q.when(editDropdownOptionsFunction($scope.row.entity, $scope.col.colDef))
	                        .then(function(result) {
	                  $scope.editDropdownOptionsArray = result;
	                });
	              } else {
	                var editDropdownRowEntityOptionsArrayPath = $scope.col.colDef.editDropdownRowEntityOptionsArrayPath;
	                if (editDropdownRowEntityOptionsArrayPath) {
	                  $scope.editDropdownOptionsArray =  resolveObjectFromPath($scope.row.entity, editDropdownRowEntityOptionsArrayPath);
	                }
	                else {
	                  $scope.editDropdownOptionsArray = $scope.col.colDef.editDropdownOptionsArray;
	                }
	              }
	              $scope.editDropdownIdLabel = $scope.col.colDef.editDropdownIdLabel ? $scope.col.colDef.editDropdownIdLabel : 'id';
	              $scope.editDropdownValueLabel = $scope.col.colDef.editDropdownValueLabel ? $scope.col.colDef.editDropdownValueLabel : 'value';
	
	              var createEditor = function() {
	                inEdit = true;
	                cancelBeginEditEvents();
	                var cellElement = angular.element(html);
	                $elm.append(cellElement);
	                editCellScope = $scope.$new();
	                $compile(cellElement)(editCellScope);
	                var gridCellContentsEl = angular.element($elm.children()[0]);
	                gridCellContentsEl.addClass('ui-grid-cell-contents-hidden');
	              };
	              if (!$rootScope.$$phase) {
	                $scope.$apply(createEditor);
	              } else {
	                createEditor();
	              }
	
	              // stop editing when grid is scrolled
	              var deregOnGridScroll = $scope.col.grid.api.core.on.scrollBegin($scope, function () {
	                if ($scope.grid.disableScrolling) {
	                  return;
	                }
	                endEdit();
	                $scope.grid.api.edit.raise.afterCellEdit($scope.row.entity, $scope.col.colDef, cellModel($scope), origCellValue);
	                deregOnGridScroll();
	                deregOnEndCellEdit();
	                deregOnCancelCellEdit();
	              });
	
	              // end editing
	              var deregOnEndCellEdit = $scope.$on(uiGridEditConstants.events.END_CELL_EDIT, function () {
	                endEdit();
	                $scope.grid.api.edit.raise.afterCellEdit($scope.row.entity, $scope.col.colDef, cellModel($scope), origCellValue);
	                deregOnEndCellEdit();
	                deregOnGridScroll();
	                deregOnCancelCellEdit();
	              });
	
	              // cancel editing
	              var deregOnCancelCellEdit = $scope.$on(uiGridEditConstants.events.CANCEL_CELL_EDIT, function () {
	                cancelEdit();
	                deregOnCancelCellEdit();
	                deregOnGridScroll();
	                deregOnEndCellEdit();
	              });
	
	              $scope.$broadcast(uiGridEditConstants.events.BEGIN_CELL_EDIT, triggerEvent);
	              $timeout(function () {
	                // execute in a timeout to give any complex editor templates a cycle to completely render
	                $scope.grid.api.edit.raise.beginCellEdit($scope.row.entity, $scope.col.colDef, triggerEvent);
	              });
	            }
	
	            function endEdit() {
	              $scope.grid.disableScrolling = false;
	              if (!inEdit) {
	                return;
	              }
	
	              // sometimes the events can't keep up with the keyboard and grid focus is lost, so always focus
	              // back to grid here. The focus call needs to be before the $destroy and removal of the control,
	              // otherwise ng-model-options of UpdateOn: 'blur' will not work.
	              if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	                uiGridCtrl.focus();
	              }
	
	              var gridCellContentsEl = angular.element($elm.children()[0]);
	              // remove edit element
	              editCellScope.$destroy();
	              var children = $elm.children();
	              for (var i = 1; i < children.length; i++) {
	                angular.element(children[i]).remove();
	              }
	              gridCellContentsEl.removeClass('ui-grid-cell-contents-hidden');
	              inEdit = false;
	              registerBeginEditEvents();
	              $scope.grid.api.core.notifyDataChange( uiGridConstants.dataChange.EDIT );
	            }
	
	            function cancelEdit() {
	              $scope.grid.disableScrolling = false;
	              if (!inEdit) {
	                return;
	              }
	              cellModel.assign($scope, origCellValue);
	              $scope.$apply();
	
	              $scope.grid.api.edit.raise.cancelCellEdit($scope.row.entity, $scope.col.colDef);
	              endEdit();
	            }
	
	            // resolves a string path against the given object
	            // shamelessly borrowed from
	            // http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key
	            function resolveObjectFromPath(object, path) {
	              path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
	              path = path.replace(/^\./, '');           // strip a leading dot
	              var a = path.split('.');
	              while (a.length) {
	                  var n = a.shift();
	                  if (n in object) {
	                      object = object[n];
	                  } else {
	                      return;
	                  }
	              }
	              return object;
	            }
	          }
	        };
	      }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridEditor
	   *  @element div
	   *  @restrict A
	   *
	   *  @description input editor directive for editable fields.
	   *  Provides EndEdit and CancelEdit events
	   *
	   *  Events that end editing:
	   *     blur and enter keydown
	   *
	   *  Events that cancel editing:
	   *    - Esc keydown
	   *
	   */
	  module.directive('uiGridEditor',
	    ['gridUtil', 'uiGridConstants', 'uiGridEditConstants','$timeout', 'uiGridEditService',
	      function (gridUtil, uiGridConstants, uiGridEditConstants, $timeout, uiGridEditService) {
	        return {
	          scope: true,
	          require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel'],
	          compile: function () {
	            return {
	              pre: function ($scope, $elm, $attrs) {
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	                var uiGridCtrl, renderContainerCtrl, ngModel;
	                if (controllers[0]) { uiGridCtrl = controllers[0]; }
	                if (controllers[1]) { renderContainerCtrl = controllers[1]; }
	                if (controllers[2]) { ngModel = controllers[2]; }
	
	                // set focus at start of edit
	                $scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function () {
	                  // must be in a timeout since it requires a new digest cycle
	                  $timeout(function () {
	                    $elm[0].focus();
	                    // only select text if it is not being replaced below in the cellNav viewPortKeyPress
	                    if ($elm[0].select && ($scope.col.colDef.enableCellEditOnFocus || !(uiGridCtrl && uiGridCtrl.grid.api.cellNav))) {
	                      $elm[0].select();
	                    }
	                    else {
	                      // some browsers (Chrome) stupidly, imo, support the w3 standard that number, email, ...
	                      // fields should not allow setSelectionRange.  We ignore the error for those browsers
	                      // https://www.w3.org/Bugs/Public/show_bug.cgi?id=24796
	                      try {
	                        $elm[0].setSelectionRange($elm[0].value.length, $elm[0].value.length);
	                      }
	                      catch (ex) {
	                        // ignore
	                      }
	                    }
	                  });
	
	                  // set the keystroke that started the edit event
	                  // we must do this because the BeginEdit is done in a different event loop than the intitial
	                  // keydown event
	                  // fire this event for the keypress that is received
	                  if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	                    var viewPortKeyDownUnregister = uiGridCtrl.grid.api.cellNav.on.viewPortKeyPress($scope, function (evt, rowCol) {
	                      if (uiGridEditService.isStartEditKey(evt)) {
	                        var code = typeof evt.which === 'number' ? evt.which : evt.keyCode;
	                        if (code > 0) {
	                          ngModel.$setViewValue(String.fromCharCode(code), evt);
	                          ngModel.$render();
	                        }
	                      }
	                      viewPortKeyDownUnregister();
	                    });
	                  }
	
	                  // macOS will blur the checkbox when clicked in Safari and Firefox,
	                  // to get around this, we disable the blur handler on mousedown,
	                  // and then focus the checkbox and re-enable the blur handler after $timeout
	                  $elm.on('mousedown', function(evt) {
	                    if ($elm[0].type === 'checkbox') {
	                      $elm.off('blur', $scope.stopEdit);
	                      $timeout(function() {
	                        $elm[0].focus();
	                        $elm.on('blur', $scope.stopEdit);
	                      });
	                    }
	                  });
	
	                  if ($elm[0]) {
	                    $elm[0].focus();
	                  }
	                  $elm.on('blur', $scope.stopEdit);
	                });
	
	
	                $scope.deepEdit = false;
	
	                $scope.stopEdit = function (evt) {
	                  if ($scope.inputForm && !$scope.inputForm.$valid) {
	                    evt.stopPropagation();
	                    $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
	                  }
	                  else {
	                    $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
	                  }
	                  $scope.deepEdit = false;
	                };
	
	
	                $elm.on('click', function (evt) {
	                  if ($elm[0].type !== 'checkbox') {
	                    $scope.deepEdit = true;
	                    $scope.$applyAsync(function () {
	                      $scope.grid.disableScrolling = true;
	                    });
	                  }
	                });
	
	                $elm.on('keydown', function (evt) {
	                  switch (evt.keyCode) {
	                    case uiGridConstants.keymap.ESC:
	                      evt.stopPropagation();
	                      $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
	                      break;
	                  }
	
	                  if ($scope.deepEdit &&
	                    (evt.keyCode === uiGridConstants.keymap.LEFT ||
	                     evt.keyCode === uiGridConstants.keymap.RIGHT ||
	                     evt.keyCode === uiGridConstants.keymap.UP ||
	                     evt.keyCode === uiGridConstants.keymap.DOWN)) {
	                    evt.stopPropagation();
	                  }
	                  // Pass the keydown event off to the cellNav service, if it exists
	                  else if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	                    evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
	                    if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
	                      $scope.stopEdit(evt);
	                    }
	                  }
	                  else {
	                    // handle enter and tab for editing not using cellNav
	                    switch (evt.keyCode) {
	                      case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
	                      case uiGridConstants.keymap.TAB:
	                        evt.stopPropagation();
	                        evt.preventDefault();
	                        $scope.stopEdit(evt);
	                        break;
	                    }
	                  }
	
	                  return true;
	                });
	
	                $scope.$on('$destroy', function unbindEvents() {
	                  // unbind all jquery events in order to avoid memory leaks
	                  $elm.off();
	                });
	              }
	            };
	          }
	        };
	      }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:input
	   *  @element input
	   *  @restrict E
	   *
	   *  @description directive to provide binding between input[date] value and ng-model for angular 1.2
	   *  It is similar to input[date] directive of angular 1.3
	   *
	   *  Supported date format for input is 'yyyy-MM-dd'
	   *  The directive will set the $valid property of input element and the enclosing form to false if
	   *  model is invalid date or value of input is entered wrong.
	   *
	   */
	    module.directive('uiGridEditor', ['$filter', function ($filter) {
	      function parseDateString(dateString) {
	        if (typeof(dateString) === 'undefined' || dateString === '') {
	          return null;
	        }
	        var parts = dateString.split('-');
	        if (parts.length !== 3) {
	          return null;
	        }
	        var year = parseInt(parts[0], 10);
	        var month = parseInt(parts[1], 10);
	        var day = parseInt(parts[2], 10);
	
	        if (month < 1 || year < 1 || day < 1) {
	          return null;
	        }
	        return new Date(year, (month - 1), day);
	      }
	      return {
	        priority: -100, // run after default uiGridEditor directive
	        require: '?ngModel',
	        link: function (scope, element, attrs, ngModel) {
	          if (angular.version.minor === 2 && attrs.type && attrs.type === 'date' && ngModel) {
	            ngModel.$formatters.push(function (modelValue) {
	              ngModel.$setValidity(null,(!modelValue || !isNaN(modelValue.getTime())));
	              return $filter('date')(modelValue, 'yyyy-MM-dd');
	            });
	
	            ngModel.$parsers.push(function (viewValue) {
	              if (viewValue && viewValue.length > 0) {
	                var dateValue = parseDateString(viewValue);
	                ngModel.$setValidity(null, (dateValue && !isNaN(dateValue.getTime())));
	                return dateValue;
	              }
	              else {
	                ngModel.$setValidity(null, true);
	                return null;
	              }
	            });
	          }
	        }
	      };
	    }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridEditDropdown
	   *  @element div
	   *  @restrict A
	   *
	   *  @description dropdown editor for editable fields.
	   *  Provides EndEdit and CancelEdit events
	   *
	   *  Events that end editing:
	   *     blur and enter keydown, and any left/right nav
	   *
	   *  Events that cancel editing:
	   *    - Esc keydown
	   *
	   */
	  module.directive('uiGridEditDropdown',
	    ['uiGridConstants', 'uiGridEditConstants', '$timeout',
	      function (uiGridConstants, uiGridEditConstants, $timeout) {
	        return {
	          require: ['?^uiGrid', '?^uiGridRenderContainer'],
	          scope: true,
	          compile: function () {
	            return {
	              pre: function ($scope, $elm, $attrs) {
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	                var uiGridCtrl = controllers[0];
	                var renderContainerCtrl = controllers[1];
	
	                // set focus at start of edit
	                $scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function () {
	                  $timeout(function() {
	                    $elm[0].focus();
	                  });
	
	                  $elm[0].style.width = ($elm[0].parentElement.offsetWidth - 1) + 'px';
	                  $elm.on('blur', function (evt) {
	                    $scope.stopEdit(evt);
	                  });
	                });
	
	
	                $scope.stopEdit = function (evt) {
	                  // no need to validate a dropdown - invalid values shouldn't be
	                  // available in the list
	                  $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
	                };
	
	                $elm.on('keydown', function (evt) {
	                  switch (evt.keyCode) {
	                    case uiGridConstants.keymap.ESC:
	                      evt.stopPropagation();
	                      $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
	                      break;
	                  }
	                  if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	                    evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
	                    if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
	                      $scope.stopEdit(evt);
	                    }
	                  }
	                  else {
	                    // handle enter and tab for editing not using cellNav
	                    switch (evt.keyCode) {
	                      case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
	                      case uiGridConstants.keymap.TAB:
	                        evt.stopPropagation();
	                        evt.preventDefault();
	                        $scope.stopEdit(evt);
	                        break;
	                    }
	                  }
	                  return true;
	                });
	
	                $scope.$on('$destroy', function unbindEvents() {
	                  // unbind jquery events to prevent memory leaks
	                  $elm.off();
	                });
	              }
	            };
	          }
	        };
	      }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridEditFileChooser
	   *  @element div
	   *  @restrict A
	   *
	   *  @description input editor directive for editable fields.
	   *  Provides EndEdit and CancelEdit events
	   *
	   *  Events that end editing:
	   *     blur and enter keydown
	   *
	   *  Events that cancel editing:
	   *    - Esc keydown
	   *
	   */
	  module.directive('uiGridEditFileChooser',
	    ['gridUtil', 'uiGridConstants', 'uiGridEditConstants',
	      function (gridUtil, uiGridConstants, uiGridEditConstants) {
	        return {
	          scope: true,
	          require: ['?^uiGrid', '?^uiGridRenderContainer'],
	          compile: function () {
	            return {
	              pre: function ($scope, $elm, $attrs) {
	
	              },
	              post: function ($scope, $elm) {
	                function handleFileSelect(event) {
	                  var target = event.srcElement || event.target;
	
	                  if (target && target.files && target.files.length > 0) {
	                    /**
	                     *  @ngdoc property
	                     *  @name editFileChooserCallback
	                     *  @propertyOf  ui.grid.edit.api:ColumnDef
	                     *  @description A function that should be called when any files have been chosen
	                     *  by the user.  You should use this to process the files appropriately for your
	                     *  application.
	                     *
	                     *  It passes the gridCol, the gridRow (from which you can get gridRow.entity),
	                     *  and the files.  The files are in the format as returned from the file chooser,
	                     *  an array of files, with each having useful information such as:
	                     *  - `files[0].lastModifiedDate`
	                     *  - `files[0].name`
	                     *  - `files[0].size`  (appears to be in bytes)
	                     *  - `files[0].type`  (MIME type by the looks)
	                     *
	                     *  Typically you would do something with these files - most commonly you would
	                     *  use the filename or read the file itself in.  The example function does both.
	                     *
	                     *  @example
	                     *  <pre>
	                     *  editFileChooserCallBack: function(gridRow, gridCol, files ) {
	                     *    // ignore all but the first file, it can only choose one anyway
	                     *    // set the filename into this column
	                     *    gridRow.entity.filename = file[0].name;
	                     *
	                     *    // read the file and set it into a hidden column, which we may do stuff with later
	                     *    var setFile = function(fileContent) {
	                     *      gridRow.entity.file = fileContent.currentTarget.result;
	                     *    };
	                     *    var reader = new FileReader();
	                     *    reader.onload = setFile;
	                     *    reader.readAsText( files[0] );
	                     *  }
	                     *  </pre>
	                     */
	                    if ( typeof($scope.col.colDef.editFileChooserCallback) === 'function' ) {
	                      $scope.col.colDef.editFileChooserCallback($scope.row, $scope.col, target.files);
	                    } else {
	                      gridUtil.logError('You need to set colDef.editFileChooserCallback to use the file chooser');
	                    }
	
	                    target.form.reset();
	                    $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
	                  } else {
	                    $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
	                  }
	                  $elm[0].removeEventListener('change', handleFileSelect, false);
	                }
	
	                $elm[0].addEventListener('change', handleFileSelect, false);
	
	                $scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function () {
	                  $elm[0].focus();
	                  $elm[0].select();
	
	                  $elm.on('blur', function () {
	                    $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
	                    $elm.off();
	                  });
	                });
	              }
	            };
	          }
	        };
	      }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.emptyBaseLayer
	   * @description
	   *
	   * # ui.grid.emptyBaseLayer
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides the ability to have the background of the ui-grid be empty rows, this would be displayed in the case were
	   * the grid height is greater then the amount of rows displayed.
	   *
	   * <div doc-module-components="ui.grid.emptyBaseLayer"></div>
	   */
	  var module = angular.module('ui.grid.emptyBaseLayer', ['ui.grid']);
	
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.emptyBaseLayer.service:uiGridBaseLayerService
	   *
	   *  @description Services for the empty base layer grid
	   */
	  module.service('uiGridBaseLayerService', ['gridUtil', '$compile', function (gridUtil, $compile) {
	    return {
	      initializeGrid: function (grid, disableEmptyBaseLayer) {
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.emptyBaseLayer.api:GridOptions
	         *
	         *  @description GridOptions for emptyBaseLayer feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	        grid.baseLayer = {
	          emptyRows: []
	        };
	
	        /**
	         *  @ngdoc object
	         *  @name enableEmptyGridBaseLayer
	         *  @propertyOf  ui.grid.emptyBaseLayer.api:GridOptions
	         *  @description Enable empty base layer, which shows empty rows as background on the entire grid
	         *  <br/>Defaults to true, if the directive is used.
	         *  <br/>Set to false either by setting this attribute or passing false to the directive.
	         */
	        // default option to true unless it was explicitly set to false
	        if (grid.options.enableEmptyGridBaseLayer !== false) {
	          grid.options.enableEmptyGridBaseLayer = !disableEmptyBaseLayer;
	        }
	      },
	
	      setNumberOfEmptyRows: function(viewportHeight, grid) {
	        var rowHeight = grid.options.rowHeight,
	          rows = Math.ceil(viewportHeight / rowHeight);
	
	        if (rows > 0) {
	          grid.baseLayer.emptyRows = [];
	          for (var i = 0; i < rows; i++) {
	            grid.baseLayer.emptyRows.push({});
	          }
	        }
	      }
	    };
	  }]);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.emptyBaseLayer.directive:uiGridEmptyBaseLayer
	   *  @description Shows empty rows in the background of the ui-grid, these span
	   *  the full height of the ui-grid, so that there won't be blank space below the shown rows.
	   *  @example
	   *  <pre>
	   *  <div ui-grid="gridOptions" class="grid" ui-grid-empty-base-layer></div>
	   *  </pre>
	   *  Or you can enable/disable it dynamically by passing in true or false. It doesn't
	   *  the value, so it would only be set on initial render.
	   *  <pre>
	   *  <div ui-grid="gridOptions" class="grid" ui-grid-empty-base-layer="false"></div>
	   *  </pre>
	   */
	  module.directive('uiGridEmptyBaseLayer', ['gridUtil', 'uiGridBaseLayerService',
	      '$parse',
	    function (gridUtil, uiGridBaseLayerService, $parse) {
	      return {
	        require: '^uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              var disableEmptyBaseLayer = $parse($attrs.uiGridEmptyBaseLayer)($scope) === false;
	
	              uiGridBaseLayerService.initializeGrid(uiGridCtrl.grid, disableEmptyBaseLayer);
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	              if (!uiGridCtrl.grid.options.enableEmptyGridBaseLayer) {
	                return;
	              }
	
	              var renderBodyContainer = uiGridCtrl.grid.renderContainers.body,
	                viewportHeight = renderBodyContainer.getViewportHeight();
	
	              function heightHasChanged() {
	                var newViewPortHeight = renderBodyContainer.getViewportHeight();
	
	                if (newViewPortHeight !== viewportHeight) {
	                  viewportHeight = newViewPortHeight;
	                  return true;
	                }
	                return false;
	              }
	
	              function getEmptyBaseLayerCss(viewportHeight) {
	                // Set ui-grid-empty-base-layer height
	                return '.grid' + uiGridCtrl.grid.id +
	                  ' .ui-grid-render-container ' +
	                  '.ui-grid-empty-base-layer-container.ui-grid-canvas ' +
	                  '{ height: ' + viewportHeight + 'px; }';
	              }
	
	              uiGridCtrl.grid.registerStyleComputation({
	                func: function() {
	                  if (heightHasChanged()) {
	                    uiGridBaseLayerService.setNumberOfEmptyRows(viewportHeight, uiGridCtrl.grid);
	                  }
	                  return getEmptyBaseLayerCss(viewportHeight);
	                }
	              });
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.emptyBaseLayer.directive:uiGridViewport
	   *  @description stacks on the uiGridViewport directive to append the empty grid base layer html elements to the
	   *  default gridRow template
	   */
	  module.directive('uiGridViewport',
	    ['$compile', 'gridUtil', '$templateCache',
	      function ($compile, gridUtil, $templateCache) {
	        return {
	          priority: -200,
	          scope: false,
	          compile: function ($elm) {
	            var emptyBaseLayerContainer = $templateCache.get('ui-grid/emptyBaseLayerContainer');
	            $elm.prepend(emptyBaseLayerContainer);
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	              }
	            };
	          }
	        };
	      }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.expandable
	   * @description
	   *
	   * # ui.grid.expandable
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides the ability to create subgrids with the ability to expand a row
	   * to show the subgrid.
	   *
	   * <div doc-module-components="ui.grid.expandable"></div>
	   */
	  var module = angular.module('ui.grid.expandable', ['ui.grid']);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.expandable.service:uiGridExpandableService
	   *
	   *  @description Services for the expandable grid
	   */
	  module.service('uiGridExpandableService', ['gridUtil', function (gridUtil) {
	    var service = {
	      initializeGrid: function (grid) {
	
	        grid.expandable = {};
	        grid.expandable.expandedAll = false;
	
	        /**
	         *  @ngdoc boolean
	         *  @name enableOnDblClickExpand
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Defaults to true.
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      onDblClickExpand: false
	         *    }
	         *  </pre>
	         */
	        grid.options.enableOnDblClickExpand = grid.options.enableOnDblClickExpand !== false;
	        /**
	         *  @ngdoc boolean
	         *  @name enableExpandable
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Whether or not to use expandable feature, allows you to turn off expandable on specific grids
	         *  within your application, or in specific modes on _this_ grid. Defaults to true.
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      enableExpandable: false
	         *    }
	         *  </pre>
	         */
	        grid.options.enableExpandable = grid.options.enableExpandable !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name showExpandAllButton
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Whether or not to display the expand all button, allows you to hide expand all button on specific grids
	         *  within your application, or in specific modes on _this_ grid. Defaults to true.
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      showExpandAllButton: false
	         *    }
	         *  </pre>
	         */
	        grid.options.showExpandAllButton = grid.options.showExpandAllButton !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name expandableRowHeight
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Height in pixels of the expanded subgrid.  Defaults to
	         *  150
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      expandableRowHeight: 150
	         *    }
	         *  </pre>
	         */
	        grid.options.expandableRowHeight = grid.options.expandableRowHeight || 150;
	
	        /**
	         *  @ngdoc object
	         *  @name expandableRowHeaderWidth
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Width in pixels of the expandable column. Defaults to 40
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      expandableRowHeaderWidth: 40
	         *    }
	         *  </pre>
	         */
	        grid.options.expandableRowHeaderWidth = grid.options.expandableRowHeaderWidth || 40;
	
	        /**
	         *  @ngdoc object
	         *  @name expandableRowTemplate
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Mandatory. The template for your expanded row
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      expandableRowTemplate: 'expandableRowTemplate.html'
	         *    }
	         *  </pre>
	         */
	        if ( grid.options.enableExpandable && !grid.options.expandableRowTemplate ) {
	          gridUtil.logError( 'You have not set the expandableRowTemplate, disabling expandable module' );
	          grid.options.enableExpandable = false;
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.expandable.api:PublicApi
	         *
	         *  @description Public Api for expandable feature
	         */
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.expandable.api:GridRow
	         *
	         *  @description Additional properties added to GridRow when using the expandable module
	         */
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.expandable.api:GridOptions
	         *
	         *  @description Options for configuring the expandable feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	        var publicApi = {
	          events: {
	            expandable: {
	              /**
	               * @ngdoc event
	               * @name rowExpandedBeforeStateChanged
	               * @eventOf  ui.grid.expandable.api:PublicApi
	               * @description raised when row is expanding or collapsing
	               * <pre>
	               *      gridApi.expandable.on.rowExpandedBeforeStateChanged(scope,function(row, event) {})
	               * </pre>
	               * @param {scope} scope the application scope
	               * @param {GridRow} row the row that was expanded
	               * @param {Event} evt object if raised from an event
	               */
	              rowExpandedBeforeStateChanged: function(scope, row, evt) {},
	
	              /**
	               * @ngdoc event
	               * @name rowExpandedStateChanged
	               * @eventOf  ui.grid.expandable.api:PublicApi
	               * @description raised when row expanded or collapsed
	               * <pre>
	               *      gridApi.expandable.on.rowExpandedStateChanged(scope,function(row, event) {})
	               * </pre>
	               * @param {scope} scope the application scope
	               * @param {GridRow} row the row that was expanded
	               * @param {Event} evt object if raised from an event
	               */
	              rowExpandedStateChanged: function (scope, row, evt) {},
	
	              /**
	               * @ngdoc event
	               * @name rowExpandedRendered
	               * @eventOf  ui.grid.expandable.api:PublicApi
	               * @description raised when expanded row is rendered
	               * <pre>
	               *      gridApi.expandable.on.rowExpandedRendered(scope,function(row, event) {})
	               * </pre>
	               * @param {scope} scope the application scope
	               * @param {GridRow} row the row that was expanded
	               * @param {Event} evt object if raised from an event
	               */
	              rowExpandedRendered: function (scope, row, evt) {}
	            }
	          },
	
	          methods: {
	            expandable: {
	              /**
	               * @ngdoc method
	               * @name toggleRowExpansion
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Toggle a specific row
	               * <pre>
	               *      gridApi.expandable.toggleRowExpansion(rowEntity, event);
	               * </pre>
	               * @param {object} rowEntity the data entity for the row you want to expand
	               * @param {Event} [e] event (if exist)
	               */
	              toggleRowExpansion: function (rowEntity, e) {
	                var row = grid.getRow(rowEntity);
	
	                if (row !== null) {
	                  service.toggleRowExpansion(grid, row, e);
	                }
	              },
	
	              /**
	               * @ngdoc method
	               * @name expandAllRows
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Expand all subgrids.
	               * <pre>
	               *      gridApi.expandable.expandAllRows();
	               * </pre>
	               */
	              expandAllRows: function() {
	                service.expandAllRows(grid);
	              },
	
	              /**
	               * @ngdoc method
	               * @name collapseAllRows
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Collapse all subgrids.
	               * <pre>
	               *      gridApi.expandable.collapseAllRows();
	               * </pre>
	               */
	              collapseAllRows: function() {
	                service.collapseAllRows(grid);
	              },
	
	              /**
	               * @ngdoc method
	               * @name toggleAllRows
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Toggle all subgrids.
	               * <pre>
	               *      gridApi.expandable.toggleAllRows();
	               * </pre>
	               */
	              toggleAllRows: function() {
	                service.toggleAllRows(grid);
	              },
	              /**
	               * @ngdoc function
	               * @name expandRow
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Expand the data row
	               * @param {object} rowEntity gridOptions.data[] array instance
	               */
	              expandRow: function (rowEntity) {
	                var row = grid.getRow(rowEntity);
	
	                if (row !== null && !row.isExpanded) {
	                  service.toggleRowExpansion(grid, row);
	                }
	              },
	              /**
	               * @ngdoc function
	               * @name collapseRow
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Collapse the data row
	               * @param {object} rowEntity gridOptions.data[] array instance
	               */
	              collapseRow: function (rowEntity) {
	                var row = grid.getRow(rowEntity);
	
	                if (row !== null && row.isExpanded) {
	                  service.toggleRowExpansion(grid, row);
	                }
	              },
	              /**
	               * @ngdoc function
	               * @name getExpandedRows
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description returns all expandedRow's entity references
	               */
	              getExpandedRows: function () {
	                return service.getExpandedRows(grid).map(function (gridRow) {
	                  return gridRow.entity;
	                });
	              }
	            }
	          }
	        };
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	
	      /**
	       *
	       * @param grid
	       * @param row
	       * @param {Event} [e] event (if exist)
	       */
	      toggleRowExpansion: function (grid, row, e) {
	        // trigger the "before change" event. Can change row height dynamically this way.
	        grid.api.expandable.raise.rowExpandedBeforeStateChanged(row);
	        /**
	         *  @ngdoc object
	         *  @name isExpanded
	         *  @propertyOf  ui.grid.expandable.api:GridRow
	         *  @description Whether or not the row is currently expanded.
	         *  @example
	         *  <pre>
	         *    $scope.api.expandable.on.rowExpandedStateChanged($scope, function (row) {
	         *      if (row.isExpanded) {
	         *        //...
	         *      }
	         *    });
	         *  </pre>
	         */
	        row.isExpanded = !row.isExpanded;
	        if (angular.isUndefined(row.expandedRowHeight)) {
	          row.expandedRowHeight = grid.options.expandableRowHeight;
	        }
	
	        if (row.isExpanded) {
	          row.height = row.grid.options.rowHeight + row.expandedRowHeight;
	          grid.expandable.expandedAll = service.getExpandedRows(grid).length === grid.rows.length;
	        }
	        else {
	          row.height = row.grid.options.rowHeight;
	          grid.expandable.expandedAll = false;
	        }
	        grid.api.expandable.raise.rowExpandedStateChanged(row, e);
	
	        // fire event on render complete
	        function _tWatcher() {
	          if (row.expandedRendered) {
	            grid.api.expandable.raise.rowExpandedRendered(row, e);
	          }
	          else {
	            window.setTimeout(_tWatcher, 1e2);
	          }
	        }
	        _tWatcher();
	      },
	
	      expandAllRows: function(grid) {
	        grid.renderContainers.body.visibleRowCache.forEach( function(row) {
	          if (!row.isExpanded && !(row.entity.subGridOptions && row.entity.subGridOptions.disableRowExpandable)) {
	            service.toggleRowExpansion(grid, row);
	          }
	        });
	        grid.expandable.expandedAll = true;
	        grid.queueGridRefresh();
	      },
	
	      collapseAllRows: function(grid) {
	        grid.renderContainers.body.visibleRowCache.forEach( function(row) {
	          if (row.isExpanded) {
	            service.toggleRowExpansion(grid, row);
	          }
	        });
	        grid.expandable.expandedAll = false;
	        grid.queueGridRefresh();
	      },
	
	      toggleAllRows: function(grid) {
	        if (grid.expandable.expandedAll) {
	          service.collapseAllRows(grid);
	        }
	        else {
	          service.expandAllRows(grid);
	        }
	      },
	
	      getExpandedRows: function (grid) {
	        return grid.rows.filter(function (row) {
	          return row.isExpanded;
	        });
	      }
	    };
	    return service;
	  }]);
	
	  /**
	   *  @ngdoc object
	   *  @name enableExpandableRowHeader
	   *  @propertyOf  ui.grid.expandable.api:GridOptions
	   *  @description Show a rowHeader to provide the expandable buttons.  If set to false then implies
	   *  you're going to use a custom method for expanding and collapsing the subgrids. Defaults to true.
	   *  @example
	   *  <pre>
	   *    $scope.gridOptions = {
	   *      enableExpandableRowHeader: false
	   *    }
	   *  </pre>
	   */
	
	  module.directive('uiGridExpandable', ['uiGridExpandableService', '$templateCache',
	    function (uiGridExpandableService, $templateCache) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              uiGridExpandableService.initializeGrid(uiGridCtrl.grid);
	
	              if (!uiGridCtrl.grid.options.enableExpandable) {
	                return;
	              }
	
	              if (uiGridCtrl.grid.options.enableExpandableRowHeader !== false ) {
	                var expandableRowHeaderColDef = {
	                  name: 'expandableButtons',
	                  displayName: '',
	                  exporterSuppressExport: true,
	                  enableColumnResizing: false,
	                  enableColumnMenu: false,
	                  width: uiGridCtrl.grid.options.expandableRowHeaderWidth || 30
	                };
	
	                expandableRowHeaderColDef.cellTemplate = $templateCache.get('ui-grid/expandableRowHeader');
	                expandableRowHeaderColDef.headerCellTemplate = $templateCache.get('ui-grid/expandableTopRowHeader');
	                uiGridCtrl.grid.addRowHeaderColumn(expandableRowHeaderColDef, -90);
	              }
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {}
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.expandable.directive:uiGrid
	   *  @description stacks on the uiGrid directive to register child grid with parent row when child is created
	   */
	  module.directive('uiGrid',
	    function () {
	      return {
	        replace: true,
	        priority: 599,
	        require: '^uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	              uiGridCtrl.grid.api.core.on.renderingComplete($scope, function() {
	                // if a parent grid row is on the scope, then add the parentRow property to this childGrid
	                if ($scope.row && $scope.row.grid && $scope.row.grid.options
	                  && $scope.row.grid.options.enableExpandable) {
	
	                  /**
	                   *  @ngdoc directive
	                   *  @name ui.grid.expandable.class:Grid
	                   *  @description Additional Grid properties added by expandable module
	                   */
	
	                  /**
	                   *  @ngdoc object
	                   *  @name parentRow
	                   *  @propertyOf ui.grid.expandable.class:Grid
	                   *  @description reference to the expanded parent row that owns this grid
	                   */
	                  uiGridCtrl.grid.parentRow = $scope.row;
	
	                  // todo: adjust height on parent row when child grid height changes. we need some sort of gridHeightChanged event
	                 // uiGridCtrl.grid.core.on.canvasHeightChanged($scope, function(oldHeight, newHeight) {
	                 //   uiGridCtrl.grid.parentRow = newHeight;
	                 // });
	                }
	              });
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {}
	          };
	        }
	      };
	    });
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.expandable.directive:uiGridExpandableRow
	   *  @description directive to render the Row template on Expand
	   */
	  module.directive('uiGridExpandableRow',
	  ['uiGridExpandableService', '$compile', 'uiGridConstants','gridUtil',
	    function (uiGridExpandableService, $compile, uiGridConstants, gridUtil) {
	
	      return {
	        replace: false,
	        priority: 0,
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm) {
	              gridUtil.getTemplate($scope.grid.options.expandableRowTemplate).then(
	                function (template) {
	                  if ($scope.grid.options.expandableRowScope) {
	                    /**
	                     *  @ngdoc object
	                     *  @name expandableRowScope
	                     *  @propertyOf  ui.grid.expandable.api:GridOptions
	                     *  @description  Variables of object expandableScope will be available in the scope of the expanded subgrid
	                     *  @example
	                     *  <pre>
	                     *    $scope.gridOptions = {
	                     *      expandableRowScope: expandableScope
	                     *    }
	                     *  </pre>
	                     */
	                    var expandableRowScope = $scope.grid.options.expandableRowScope;
	
	                    for (var property in expandableRowScope) {
	                      if (expandableRowScope.hasOwnProperty(property)) {
	                        $scope[property] = expandableRowScope[property];
	                      }
	                    }
	                  }
	                  var expandedRowElement = angular.element(template);
	
	                  expandedRowElement = $compile(expandedRowElement)($scope);
	                  $elm.append(expandedRowElement);
	                  $scope.row.element = $elm;
	                  $scope.row.expandedRendered = true;
	              });
	            },
	
	            post: function ($scope, $elm) {
	              $scope.row.element = $elm;
	              $scope.$on('$destroy', function() {
	                $scope.row.expandedRendered = false;
	              });
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.expandable.directive:uiGridRow
	   *  @description stacks on the uiGridRow directive to add support for expandable rows
	   */
	  module.directive('uiGridRow',
	      function () {
	        return {
	          priority: -200,
	          scope: false,
	          compile: function () {
	            return {
	              pre: function ($scope, $elm) {
	                if (!$scope.grid.options.enableExpandable) {
	                  return;
	                }
	
	                $scope.expandableRow = {};
	
	                $scope.expandableRow.shouldRenderExpand = function () {
	                  return $scope.colContainer.name === 'body'
	                    && $scope.grid.options.enableExpandable !== false
	                    && $scope.row.isExpanded
	                    && (!$scope.grid.isScrollingVertically || $scope.row.expandedRendered);
	                };
	
	                $scope.expandableRow.shouldRenderFiller = function () {
	                  return $scope.row.isExpanded
	                    && (
	                      $scope.colContainer.name !== 'body'
	                      || ($scope.grid.isScrollingVertically && !$scope.row.expandedRendered));
	                };
	
	                if ($scope.grid.options.enableOnDblClickExpand) {
	                  $elm.on('dblclick', function (event) {
	                    // if necessary, it is possible for everyone to stop the processing of a single click OR
	                    // Inside the Config in the output agent to enter a line:
	                    // event.stopPropagation()
	                    $scope.grid.api.expandable.toggleRowExpansion($scope.row.entity, event);
	                  });
	                }
	              },
	              post: function ($scope, $elm, $attrs, controllers) {}
	            };
	          }
	        };
	      });
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.expandable.directive:uiGridViewport
	   *  @description stacks on the uiGridViewport directive to append the expandable row html elements to the
	   *  default gridRow template
	   */
	  module.directive('uiGridViewport',
	    ['$compile', 'gridUtil', '$templateCache',
	      function ($compile, gridUtil, $templateCache) {
	        return {
	          priority: -200,
	          scope: false,
	          compile: function ($elm) {
	
	             // todo: this adds ng-if watchers to each row even if the grid is not using expandable directive
	             //      or options.enableExpandable == false
	             //      The alternative is to compile the template and append to each row in a uiGridRow directive
	
	            var rowRepeatDiv = angular.element($elm.children().children()[0]),
	              expandedRowFillerElement = $templateCache.get('ui-grid/expandableScrollFiller'),
	              expandedRowElement = $templateCache.get('ui-grid/expandableRow');
	
	            rowRepeatDiv.append(expandedRowElement);
	            rowRepeatDiv.append(expandedRowFillerElement);
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	              }
	            };
	          }
	        };
	      }]);
	
	})();
	
	/* global ExcelBuilder */
	/* global console */
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.exporter
	   * @description
	   *
	   * # ui.grid.exporter
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides the ability to export data from the grid.
	   *
	   * Data can be exported in a range of formats, and all data, visible
	   * data, or selected rows can be exported, with all columns or visible
	   * columns.
	   *
	   * No UI is provided, the caller should provide their own UI/buttons
	   * as appropriate, or enable the gridMenu
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.exporter"></div>
	   */
	
	  var module = angular.module('ui.grid.exporter', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.exporter.constant:uiGridExporterConstants
	   *
	   *  @description constants available in exporter module
	   */
	  /**
	   * @ngdoc property
	   * @propertyOf ui.grid.exporter.constant:uiGridExporterConstants
	   * @name ALL
	   * @description export all data, including data not visible.  Can
	   * be set for either rowTypes or colTypes
	   */
	  /**
	   * @ngdoc property
	   * @propertyOf ui.grid.exporter.constant:uiGridExporterConstants
	   * @name VISIBLE
	   * @description export only visible data, including data not visible.  Can
	   * be set for either rowTypes or colTypes
	   */
	  /**
	   * @ngdoc property
	   * @propertyOf ui.grid.exporter.constant:uiGridExporterConstants
	   * @name SELECTED
	   * @description export all data, including data not visible.  Can
	   * be set only for rowTypes, selection of only some columns is
	   * not supported
	   */
	  module.constant('uiGridExporterConstants', {
	    featureName: 'exporter',
	    rowHeaderColName: 'treeBaseRowHeaderCol',
	    selectionRowHeaderColName: 'selectionRowHeaderCol',
	    ALL: 'all',
	    VISIBLE: 'visible',
	    SELECTED: 'selected',
	    CSV_CONTENT: 'CSV_CONTENT',
	    BUTTON_LABEL: 'BUTTON_LABEL',
	    FILE_NAME: 'FILE_NAME'
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.exporter.service:uiGridExporterService
	   *
	   *  @description Services for exporter feature
	   */
	  module.service('uiGridExporterService', ['$filter', '$q', 'uiGridExporterConstants', 'gridUtil', '$compile', '$interval', 'i18nService',
	    function ($filter, $q, uiGridExporterConstants, gridUtil, $compile, $interval, i18nService) {
	      var service = {
	
	        delay: 100,
	
	        initializeGrid: function (grid) {
	
	          // add feature namespace and any properties to grid for needed state
	          grid.exporter = {};
	          this.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.exporter.api:PublicApi
	           *
	           *  @description Public Api for exporter feature
	           */
	          var publicApi = {
	            events: {
	              exporter: {
	              }
	            },
	            methods: {
	              exporter: {
	                /**
	                 * @ngdoc function
	                 * @name csvExport
	                 * @methodOf  ui.grid.exporter.api:PublicApi
	                 * @description Exports rows from the grid in csv format,
	                 * the data exported is selected based on the provided options
	                 * @param {string} rowTypes which rows to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	                 * uiGridExporterConstants.SELECTED
	                 * @param {string} colTypes which columns to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE
	                 */
	                csvExport: function (rowTypes, colTypes) {
	                  service.csvExport(grid, rowTypes, colTypes);
	                },
	                /**
	                 * @ngdoc function
	                 * @name pdfExport
	                 * @methodOf  ui.grid.exporter.api:PublicApi
	                 * @description Exports rows from the grid in pdf format,
	                 * the data exported is selected based on the provided options
	                 * Note that this function has a dependency on pdfMake, all
	                 * going well this has been installed for you.
	                 * The resulting pdf opens in a new browser window.
	                 * @param {string} rowTypes which rows to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	                 * uiGridExporterConstants.SELECTED
	                 * @param {string} colTypes which columns to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE
	                 */
	                pdfExport: function (rowTypes, colTypes) {
	                  service.pdfExport(grid, rowTypes, colTypes);
	                },
	                /**
	                 * @ngdoc function
	                 * @name excelExport
	                 * @methodOf  ui.grid.exporter.api:PublicApi
	                 * @description Exports rows from the grid in excel format,
	                 * the data exported is selected based on the provided options
	                 * @param {string} rowTypes which rows to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	                 * uiGridExporterConstants.SELECTED
	                 * @param {string} colTypes which columns to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE
	                 */
	                excelExport: function (rowTypes, colTypes) {
	                  service.excelExport(grid, rowTypes, colTypes);
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	          if (grid.api.core.addToGridMenu) {
	            service.addToMenu( grid );
	          } else {
	            // order of registration is not guaranteed, register in a little while
	            $interval( function() {
	              if (grid.api.core.addToGridMenu) {
	                service.addToMenu( grid );
	              }
	            }, this.delay, 1);
	          }
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	          // default option to true unless it was explicitly set to false
	          /**
	           * @ngdoc object
	           * @name ui.grid.exporter.api:GridOptions
	           *
	           * @description GridOptions for exporter feature, these are available to be
	           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	          /**
	           * @ngdoc object
	           * @name ui.grid.exporter.api:ColumnDef
	           * @description ColumnDef settings for exporter
	           */
	          /**
	           * @ngdoc object
	           * @name exporterSuppressMenu
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Don't show the export menu button, implying the user
	           * will roll their own UI for calling the exporter
	           * <br/>Defaults to false
	           */
	          gridOptions.exporterSuppressMenu = gridOptions.exporterSuppressMenu === true;
	          /**
	           * @ngdoc object
	           * @name exporterMenuLabel
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The text to show on the exporter menu button
	           * link
	           * <br/>Defaults to 'Export'
	           */
	          gridOptions.exporterMenuLabel = gridOptions.exporterMenuLabel ? gridOptions.exporterMenuLabel : 'Export';
	          /**
	           * @ngdoc object
	           * @name exporterSuppressColumns
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Columns that should not be exported.  The selectionRowHeader is already automatically
	           * suppressed, but if you had a button column or some other "system" column that shouldn't be shown in the
	           * output then add it in this list.  You should provide an array of column names.
	           * <br/>Defaults to: []
	           * <pre>
	           *   gridOptions.exporterSuppressColumns = [ 'buttons' ];
	           * </pre>
	           */
	          gridOptions.exporterSuppressColumns = gridOptions.exporterSuppressColumns ? gridOptions.exporterSuppressColumns : [];
	          /**
	           * @ngdoc object
	           * @name exporterCsvColumnSeparator
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The character to use as column separator
	           * link
	           * <br/>Defaults to ','
	           */
	          gridOptions.exporterCsvColumnSeparator = gridOptions.exporterCsvColumnSeparator ? gridOptions.exporterCsvColumnSeparator : ',';
	          /**
	           * @ngdoc object
	           * @name exporterCsvFilename
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The default filename to use when saving the downloaded csv.
	           * This will only work in some browsers.
	           * <br/>Defaults to 'download.csv'
	           * <pre>
	           *   gridOptions.exporterCsvFilename = "rows.csv"
	           * </pre>
	           * <br/>Or a function returning a string:
	           * <pre>
	           *   gridOptions.exporterCsvFilename = function(grid, rowTypes, colTypes) { return "rows" + rowTypes + ".csv" };
	           * </pre>
	           */
	          gridOptions.exporterCsvFilename = gridOptions.exporterCsvFilename ? gridOptions.exporterCsvFilename : 'download.csv';
	          /**
	           * @ngdoc object
	           * @name exporterPdfFilename
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The default filename to use when saving the downloaded pdf, only used in IE (other browsers open pdfs in a new window)
	           * <br/>Defaults to 'download.pdf'
	           * <pre>
	           *   gridOptions.exporterPdfFilename = "rows.pdf"
	           * </pre>
	           * <br/>Or a function returning a string:
	           * <pre>
	           *   gridOptions.exporterPdfFilename = function(grid, rowTypes, colTypes) { return "rows" + rowTypes + ".pdf" };
	           * </pre>
	           */
	          gridOptions.exporterPdfFilename = gridOptions.exporterPdfFilename ? gridOptions.exporterPdfFilename : 'download.pdf';
	          /**
	           * @ngdoc object
	           * @name exporterExcelFilename
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The default filename to use when saving the downloaded excel, only used in IE (other browsers open excels in a new window)
	           * <br/>Defaults to 'download.xlsx'
	           * <pre>
	           *   gridOptions.exporterExcelFilename = "rows.xlsx"
	           * </pre>
	           * <br/>Or a function returning a string:
	           * <pre>
	           *   gridOptions.exporterExcelFilename = function(grid, rowTypes, colTypes) { return "rows" + rowTypes + ".xlsx" };
	           * </pre>
	           */
	          gridOptions.exporterExcelFilename = gridOptions.exporterExcelFilename ? gridOptions.exporterExcelFilename : 'download.xlsx';
	
	          /**
	           * @ngdoc object
	           * @name exporterExcelSheetName
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The default sheetname to use when saving the downloaded to excel
	           * <br/>Defaults to 'Sheet1'
	           * <pre>
	           *   gridOptions.exporterExcelSheetName = "HitListSheet"
	           * </pre>
	           * <br/>Or a function returning a string:
	           * <pre>
	           *   gridOptions.exporterExcelSheetName = function(grid, rowTypes, colTypes) { return "HitListSheet" + rowTypes };
	           * </pre>
	           */
	          gridOptions.exporterExcelSheetName = gridOptions.exporterExcelSheetName ? gridOptions.exporterExcelSheetName : 'Sheet1';
	
	          /**
	           * @ngdoc object
	           * @name exporterOlderExcelCompatibility
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Some versions of excel don't like the utf-16 BOM on the front, and it comes
	           * through as ï»¿ in the first column header.  Setting this option to false will suppress this, at the
	           * expense of proper utf-16 handling in applications that do recognise the BOM
	           * <br/>Defaults to false
	           */
	          gridOptions.exporterOlderExcelCompatibility = gridOptions.exporterOlderExcelCompatibility === true;
	          /**
	           * @ngdoc object
	           * @name exporterIsExcelCompatible
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Separator header, used to set a custom column separator in a csv file, only works on MS Excel.
	           * Used it on other programs will make csv content display unproperly. Setting this option to false won't add this header.
	           * <br/>Defaults to false
	           */
	          gridOptions.exporterIsExcelCompatible = gridOptions.exporterIsExcelCompatible === true;
	          /**
	           * @ngdoc object
	           * @name exporterMenuItemOrder
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description An option to determine the starting point for the menu items created by the exporter
	           * <br/>Defaults to 200
	           */
	          gridOptions.exporterMenuItemOrder = gridOptions.exporterMenuItemOrder ? gridOptions.exporterMenuItemOrder : 200;
	          /**
	           * @ngdoc object
	           * @name exporterPdfDefaultStyle
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The default style in pdfMake format
	           * <br/>Defaults to:
	           * <pre>
	           *   {
	           *     fontSize: 11
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterPdfDefaultStyle = gridOptions.exporterPdfDefaultStyle ? gridOptions.exporterPdfDefaultStyle : { fontSize: 11 };
	          /**
	           * @ngdoc object
	           * @name exporterPdfTableStyle
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The table style in pdfMake format
	           * <br/>Defaults to:
	           * <pre>
	           *   {
	           *     margin: [0, 5, 0, 15]
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterPdfTableStyle = gridOptions.exporterPdfTableStyle ? gridOptions.exporterPdfTableStyle : { margin: [0, 5, 0, 15] };
	          /**
	           * @ngdoc object
	           * @name exporterPdfTableHeaderStyle
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The tableHeader style in pdfMake format
	           * <br/>Defaults to:
	           * <pre>
	           *   {
	           *     bold: true,
	           *     fontSize: 12,
	           *     color: 'black'
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterPdfTableHeaderStyle = gridOptions.exporterPdfTableHeaderStyle ? gridOptions.exporterPdfTableHeaderStyle : { bold: true, fontSize: 12, color: 'black' };
	          /**
	           * @ngdoc object
	           * @name exporterPdfHeader
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The header section for pdf exports.  Can be
	           * simple text:
	           * <pre>
	           *   gridOptions.exporterPdfHeader = 'My Header';
	           * </pre>
	           * Can be a more complex object in pdfMake format:
	           * <pre>
	           *   gridOptions.exporterPdfHeader = {
	           *     columns: [
	           *       'Left part',
	           *       { text: 'Right part', alignment: 'right' }
	           *     ]
	           *   };
	           * </pre>
	           * Or can be a function, allowing page numbers and the like
	           * <pre>
	           *   gridOptions.exporterPdfHeader: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; };
	           * </pre>
	           */
	          gridOptions.exporterPdfHeader = gridOptions.exporterPdfHeader ? gridOptions.exporterPdfHeader : null;
	          /**
	           * @ngdoc object
	           * @name exporterPdfFooter
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The header section for pdf exports.  Can be
	           * simple text:
	           * <pre>
	           *   gridOptions.exporterPdfFooter = 'My Footer';
	           * </pre>
	           * Can be a more complex object in pdfMake format:
	           * <pre>
	           *   gridOptions.exporterPdfFooter = {
	           *     columns: [
	           *       'Left part',
	           *       { text: 'Right part', alignment: 'right' }
	           *     ]
	           *   };
	           * </pre>
	           * Or can be a function, allowing page numbers and the like
	           * <pre>
	           *   gridOptions.exporterPdfFooter: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; };
	           * </pre>
	           */
	          gridOptions.exporterPdfFooter = gridOptions.exporterPdfFooter ? gridOptions.exporterPdfFooter : null;
	          /**
	           * @ngdoc object
	           * @name exporterPdfOrientation
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The orientation, should be a valid pdfMake value,
	           * 'landscape' or 'portrait'
	           * <br/>Defaults to landscape
	           */
	          gridOptions.exporterPdfOrientation = gridOptions.exporterPdfOrientation ? gridOptions.exporterPdfOrientation : 'landscape';
	          /**
	           * @ngdoc object
	           * @name exporterPdfPageSize
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The orientation, should be a valid pdfMake
	           * paper size, usually 'A4' or 'LETTER'
	           * {@link https://github.com/bpampuch/pdfmake/blob/master/src/standardPageSizes.js pdfMake page sizes}
	           * <br/>Defaults to A4
	           */
	          gridOptions.exporterPdfPageSize = gridOptions.exporterPdfPageSize ? gridOptions.exporterPdfPageSize : 'A4';
	          /**
	           * @ngdoc object
	           * @name exporterPdfMaxGridWidth
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The maxium grid width - the current grid width
	           * will be scaled to match this, with any fixed width columns
	           * being adjusted accordingly.
	           * <br/>Defaults to 720 (for A4 landscape), use 670 for LETTER
	           */
	          gridOptions.exporterPdfMaxGridWidth = gridOptions.exporterPdfMaxGridWidth ? gridOptions.exporterPdfMaxGridWidth : 720;
	          /**
	           * @ngdoc object
	           * @name exporterPdfTableLayout
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A tableLayout in pdfMake format,
	           * controls gridlines and the like.  We use the default
	           * layout usually.
	           * <br/>Defaults to null, which means no layout
	           */
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuAllData
	           * @propertyOf ui.grid.exporter.api:GridOptions
	           * @description Add export all data as cvs/pdf menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuAllData = gridOptions.exporterMenuAllData !== undefined ? gridOptions.exporterMenuAllData : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuVisibleData
	           * @propertyOf ui.grid.exporter.api:GridOptions
	           * @description Add export visible data as cvs/pdf menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuVisibleData = gridOptions.exporterMenuVisibleData !== undefined ? gridOptions.exporterMenuVisibleData : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuSelectedData
	           * @propertyOf ui.grid.exporter.api:GridOptions
	           * @description Add export selected data as cvs/pdf menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuSelectedData = gridOptions.exporterMenuSelectedData !== undefined ? gridOptions.exporterMenuSelectedData : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuCsv
	           * @propertyOf ui.grid.exporter.api:GridOptions
	           * @description Add csv export menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuCsv = gridOptions.exporterMenuCsv !== undefined ? gridOptions.exporterMenuCsv : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuPdf
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Add pdf export menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuPdf = gridOptions.exporterMenuPdf !== undefined ? gridOptions.exporterMenuPdf : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuExcel
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Add excel export menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuExcel = gridOptions.exporterMenuExcel !== undefined ? gridOptions.exporterMenuExcel : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterPdfCustomFormatter
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A custom callback routine that changes the pdf document, adding any
	           * custom styling or content that is supported by pdfMake.  Takes in the complete docDefinition, and
	           * must return an updated docDefinition ready for pdfMake.
	           * @example
	           * In this example we add a style to the style array, so that we can use it in our
	           * footer definition.
	           * <pre>
	           *   gridOptions.exporterPdfCustomFormatter = function ( docDefinition ) {
	           *     docDefinition.styles.footerStyle = { bold: true, fontSize: 10 };
	           *     return docDefinition;
	           *   }
	           *
	           *   gridOptions.exporterPdfFooter = { text: 'My footer', style: 'footerStyle' }
	           * </pre>
	           */
	          gridOptions.exporterPdfCustomFormatter = ( gridOptions.exporterPdfCustomFormatter && typeof( gridOptions.exporterPdfCustomFormatter ) === 'function' ) ? gridOptions.exporterPdfCustomFormatter : function ( docDef ) { return docDef; };
	
	          /**
	           * @ngdoc object
	           * @name exporterHeaderFilterUseName
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Defaults to false, which leads to `displayName` being passed into the headerFilter.
	           * If set to true, then will pass `name` instead.
	           *
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterHeaderFilterUseName = true;
	           * </pre>
	           */
	          gridOptions.exporterHeaderFilterUseName = gridOptions.exporterHeaderFilterUseName === true;
	
	          /**
	           * @ngdoc object
	           * @name exporterHeaderFilter
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A function to apply to the header displayNames before exporting.  Useful for internationalisation,
	           * for example if you were using angular-translate you'd set this to `$translate.instant`.  Note that this
	           * call must be synchronous, it cannot be a call that returns a promise.
	           *
	           * Behaviour can be changed to pass in `name` instead of `displayName` through use of `exporterHeaderFilterUseName: true`.
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterHeaderFilter = function( displayName ) { return 'col: ' + name; };
	           * </pre>
	           * OR
	           * <pre>
	           *   gridOptions.exporterHeaderFilter = $translate.instant;
	           * </pre>
	           */
	
	          /**
	           * @ngdoc function
	           * @name exporterFieldCallback
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A function to call for each field before exporting it.  Allows
	           * massaging of raw data into a display format, for example if you have applied
	           * filters to convert codes into decodes, or you require
	           * a specific date format in the exported content.
	           *
	           * The method is called once for each field exported, and provides the grid, the
	           * gridCol and the GridRow for you to use as context in massaging the data.
	           *
	           * @param {Grid} grid provides the grid in case you have need of it
	           * @param {GridRow} row the row from which the data comes
	           * @param {GridColumn} col the column from which the data comes
	           * @param {object} value the value for your massaging
	           * @returns {object} you must return the massaged value ready for exporting
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterFieldCallback = function ( grid, row, col, value ) {
	           *     if ( col.name === 'status' ) {
	           *       value = decodeStatus( value );
	           *     }
	           *     return value;
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterFieldCallback = gridOptions.exporterFieldCallback ? gridOptions.exporterFieldCallback : defaultExporterFieldCallback;
	
	          /**
	           * @ngdoc function
	           * @name exporterFieldFormatCallback
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A function to call for each field before exporting it.  Allows
	           * general object to be return to modify the format of a cell in the case of
	           * excel exports
	           *
	           * The method is called once for each field exported, and provides the grid, the
	           * gridCol and the GridRow for you to use as context in massaging the data.
	           *
	           * @param {Grid} grid provides the grid in case you have need of it
	           * @param {GridRow} row the row from which the data comes
	           * @param {GridColumn} col the column from which the data comes
	           * @param {object} value the value for your massaging
	           * @returns {object} you must return the massaged value ready for exporting
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterFieldCallback = function ( grid, row, col, value ) {
	           *     if ( col.name === 'status' ) {
	           *       value = decodeStatus( value );
	           *     }
	           *     return value;
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterFieldFormatCallback = gridOptions.exporterFieldFormatCallback ? gridOptions.exporterFieldFormatCallback : function( grid, row, col, value ) { return null; };
	
	          /**
	           * @ngdoc function
	           * @name exporterExcelCustomFormatters
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A function to call to setup formatters and store on docDefinition.
	           *
	           * The method is called at the start and can setup all the formatters to export to excel
	           *
	           * @param {Grid} grid provides the grid in case you have need of it
	           * @param {Workbook} row the row from which the data comes
	           * @param {docDefinition} The docDefinition that will have styles as a object to store formatters
	           * @returns {docDefinition} Updated docDefinition with formatter styles
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterExcelCustomFormatters = function(grid, workbook, docDefinition) {
	           *     const formatters = {};
	           *     const stylesheet = workbook.getStyleSheet();
	           *     const headerFormatDefn = {
	           *       'font': { 'size': 11, 'fontName': 'Calibri', 'bold': true },
	           *       'alignment': { 'wrapText': false }
	           *     };
	           *
	           *     formatters['header'] = headerFormatter;
	           *     Object.assign(docDefinition.styles , formatters);
	           *     grid.docDefinition = docDefinition;
	           *     return docDefinition;
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterExcelCustomFormatters = gridOptions.exporterExcelCustomFormatters ? gridOptions.exporterExcelCustomFormatters : function( grid, workbook, docDefinition ) { return docDefinition; };
	
	          /**
	           * @ngdoc function
	           * @name exporterExcelHeader
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A function to write formatted header data to sheet.
	           *
	           * The method is called to provide custom header building for Excel. This data comes before the grid header
	           *
	           * @param {grid} grid provides the grid in case you have need of it
	           * @param {Workbook} row the row from which the data comes
	           * @param {Sheet} the sheet to insert data
	           * @param {docDefinition} The docDefinition that will have styles as a object to store formatters
	           * @returns {docDefinition} Updated docDefinition with formatter styles
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterExcelCustomFormatters = function (grid, workbook, sheet, docDefinition) {
	           *      const headerFormatter = docDefinition.styles['header'];
	           *      let cols = [];
	           *      // push data in A1 cell with metadata formatter
	           *      cols.push({ value: 'Summary Report', metadata: {style: headerFormatter.id} });
	           *      sheet.data.push(cols);
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterExcelHeader = gridOptions.exporterExcelHeader ? gridOptions.exporterExcelHeader : function( grid, workbook, sheet, docDefinition ) { return null; };
	
	
	          /**
	           * @ngdoc object
	           * @name exporterColumnScaleFactor
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A scaling factor to divide the drawnwidth of a column to convert to target excel column
	           * format size
	           * @example
	           * In this example we add a number to divide the drawnwidth of a column to get the excel width.
	           * <br/>Defaults to 3.5
	           */
	          gridOptions.exporterColumnScaleFactor = gridOptions.exporterColumnScaleFactor ? gridOptions.exporterColumnScaleFactor : 3.5;
	
	          /**
	           * @ngdoc object
	           * @name exporterFieldApplyFilters
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Defaults to false, which leads to filters being evaluated on export           *
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterFieldApplyFilters = true;
	           * </pre>
	           */
	          gridOptions.exporterFieldApplyFilters = gridOptions.exporterFieldApplyFilters === true;
	
	          /**
	           * @ngdoc function
	           * @name exporterAllDataFn
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description This promise is needed when exporting all rows,
	           * and the data need to be provided by server side. Default is null.
	           * @returns {Promise} a promise to load all data from server
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterAllDataFn = function () {
	           *     return $http.get('/data/100.json')
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterAllDataFn = gridOptions.exporterAllDataFn ? gridOptions.exporterAllDataFn : null;
	
	          /**
	           * @ngdoc function
	           * @name exporterAllDataPromise
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description DEPRECATED - exporterAllDataFn used to be
	           * called this, but it wasn't a promise, it was a function that returned
	           * a promise.  Deprecated, but supported for backward compatibility, use
	           * exporterAllDataFn instead.
	           * @returns {Promise} a promise to load all data from server
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterAllDataFn = function () {
	           *     return $http.get('/data/100.json')
	           *   }
	           * </pre>
	           */
	          if ( gridOptions.exporterAllDataFn === null && gridOptions.exporterAllDataPromise ) {
	            gridOptions.exporterAllDataFn = gridOptions.exporterAllDataPromise;
	          }
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name addToMenu
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Adds export items to the grid menu,
	         * allowing the user to select export options
	         * @param {Grid} grid the grid from which data should be exported
	         */
	        addToMenu: function ( grid ) {
	          grid.api.core.addToGridMenu( grid, [
	            {
	              title: i18nService.getSafeText('gridMenu.exporterAllAsCsv'),
	              action: function () {
	                grid.api.exporter.csvExport( uiGridExporterConstants.ALL, uiGridExporterConstants.ALL );
	              },
	              shown: function() {
	                return grid.options.exporterMenuCsv && grid.options.exporterMenuAllData;
	              },
	              order: grid.options.exporterMenuItemOrder
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterVisibleAsCsv'),
	              action: function () {
	                grid.api.exporter.csvExport( uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuCsv && grid.options.exporterMenuVisibleData;
	              },
	              order: grid.options.exporterMenuItemOrder + 1
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterSelectedAsCsv'),
	              action: function () {
	                grid.api.exporter.csvExport( uiGridExporterConstants.SELECTED, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuCsv && grid.options.exporterMenuSelectedData &&
	                       ( grid.api.selection && grid.api.selection.getSelectedRows().length > 0 );
	              },
	              order: grid.options.exporterMenuItemOrder + 2
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterAllAsPdf'),
	              action: function () {
	                grid.api.exporter.pdfExport( uiGridExporterConstants.ALL, uiGridExporterConstants.ALL );
	              },
	              shown: function() {
	                return grid.options.exporterMenuPdf && grid.options.exporterMenuAllData;
	              },
	              order: grid.options.exporterMenuItemOrder + 3
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterVisibleAsPdf'),
	              action: function () {
	                grid.api.exporter.pdfExport( uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuPdf && grid.options.exporterMenuVisibleData;
	              },
	              order: grid.options.exporterMenuItemOrder + 4
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterSelectedAsPdf'),
	              action: function () {
	                grid.api.exporter.pdfExport( uiGridExporterConstants.SELECTED, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuPdf && grid.options.exporterMenuSelectedData &&
	                       ( grid.api.selection && grid.api.selection.getSelectedRows().length > 0 );
	              },
	              order: grid.options.exporterMenuItemOrder + 5
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterAllAsExcel'),
	              action: function () {
	                grid.api.exporter.excelExport( uiGridExporterConstants.ALL, uiGridExporterConstants.ALL );
	              },
	              shown: function() {
	                return grid.options.exporterMenuExcel && grid.options.exporterMenuAllData;
	              },
	              order: grid.options.exporterMenuItemOrder + 6
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterVisibleAsExcel'),
	              action: function () {
	                grid.api.exporter.excelExport( uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuExcel && grid.options.exporterMenuVisibleData;
	              },
	              order: grid.options.exporterMenuItemOrder + 7
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterSelectedAsExcel'),
	              action: function () {
	                grid.api.exporter.excelExport( uiGridExporterConstants.SELECTED, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuExcel && grid.options.exporterMenuSelectedData &&
	                  ( grid.api.selection && grid.api.selection.getSelectedRows().length > 0 );
	              },
	              order: grid.options.exporterMenuItemOrder + 8
	            }
	          ]);
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name csvExport
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Exports rows from the grid in csv format,
	         * the data exported is selected based on the provided options
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        csvExport: function (grid, rowTypes, colTypes) {
	          var self = this;
	          this.loadAllDataIfNeeded(grid, rowTypes, colTypes).then(function() {
	            var exportColumnHeaders = grid.options.showHeader ? self.getColumnHeaders(grid, colTypes) : [];
	            var exportData = self.getData(grid, rowTypes, colTypes);
	            var csvContent = self.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
	
	            var fileName = angular.isFunction(grid.options.exporterCsvFilename) ? grid.options.exporterCsvFilename(grid, rowTypes, colTypes) : grid.options.exporterCsvFilename;
	            self.downloadFile(fileName, csvContent, grid.options.exporterCsvColumnSeparator, grid.options.exporterOlderExcelCompatibility, grid.options.exporterIsExcelCompatible);
	          });
	        },
	
	        /**
	         * @ngdoc function
	         * @name loadAllDataIfNeeded
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description When using server side pagination, use exporterAllDataFn to
	         * load all data before continuing processing.
	         * When using client side pagination, return a resolved promise so processing
	         * continues immediately
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        loadAllDataIfNeeded: function (grid, rowTypes, colTypes) {
	          if ( rowTypes === uiGridExporterConstants.ALL && grid.rows.length !== grid.options.totalItems && grid.options.exporterAllDataFn) {
	            return grid.options.exporterAllDataFn()
	              .then(function(allData) {
	                grid.modifyRows(allData);
	              });
	          } else {
	            var deferred = $q.defer();
	            deferred.resolve();
	            return deferred.promise;
	          }
	        },
	
	        /**
	         * @ngdoc property
	         * @propertyOf ui.grid.exporter.api:ColumnDef
	         * @name exporterSuppressExport
	         * @description Suppresses export for this column.  Used by selection and expandable.
	         */
	
	        /**
	         * @ngdoc function
	         * @name getColumnHeaders
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Gets the column headers from the grid to use
	         * as a title row for the exported file, all headers have
	         * headerCellFilters applied as appropriate.
	         *
	         * Column headers are an array of objects, each object has
	         * name, displayName, width and align attributes.  Only name is
	         * used for csv, all attributes are used for pdf.
	         *
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        getColumnHeaders: function (grid, colTypes) {
	          var headers = [],
	            columns;
	
	          if ( colTypes === uiGridExporterConstants.ALL ) {
	            columns = grid.columns;
	          } else {
	            var leftColumns = grid.renderContainers.left ? grid.renderContainers.left.visibleColumnCache.filter( function( column ) { return column.visible; } ) : [],
	              bodyColumns = grid.renderContainers.body ? grid.renderContainers.body.visibleColumnCache.filter( function( column ) { return column.visible; } ) : [],
	              rightColumns = grid.renderContainers.right ? grid.renderContainers.right.visibleColumnCache.filter( function( column ) { return column.visible; } ) : [];
	
	            columns = leftColumns.concat(bodyColumns, rightColumns);
	          }
	
	          columns.forEach( function( gridCol ) {
	            // $$hashKey check since when grouping and sorting pragmatically this ends up in export. Filtering it out
	            if ( gridCol.colDef.exporterSuppressExport !== true  && gridCol.field !== '$$hashKey' &&
	                 grid.options.exporterSuppressColumns.indexOf( gridCol.name ) === -1 ) {
	              var headerEntry = {
	                name: gridCol.field,
	                displayName: getDisplayName(grid, gridCol),
	                width: gridCol.drawnWidth ? gridCol.drawnWidth : gridCol.width,
	                align: gridCol.colDef.align ? gridCol.colDef.align : (gridCol.colDef.type === 'number' ? 'right' : 'left')
	              };
	
	              headers.push(headerEntry);
	            }
	          });
	
	          return headers;
	        },
	
	        /**
	         * @ngdoc property
	         * @propertyOf ui.grid.exporter.api:ColumnDef
	         * @name exporterPdfAlign
	         * @description the alignment you'd like for this specific column when
	         * exported into a pdf.  Can be 'left', 'right', 'center' or any other
	         * valid pdfMake alignment option.
	         */
	
	        /**
	         * @ngdoc object
	         * @name ui.grid.exporter.api:GridRow
	         * @description GridRow settings for exporter
	         */
	
	        /**
	         * @ngdoc object
	         * @name exporterEnableExporting
	         * @propertyOf  ui.grid.exporter.api:GridRow
	         * @description If set to false, then don't export this row, notwithstanding visible or
	         * other settings
	         * <br/>Defaults to true
	         */
	
	        /**
	         * @ngdoc function
	         * @name getRowsFromNode
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Gets rows from a node. If the node is grouped it will
	         * recurse down into the children to get to the raw data element
	         * which is a row without children (a leaf).
	         * @param {Node} aNode the tree node on the grid
	         * @returns {Array} an array with all child nodes from aNode
	         */
	        getRowsFromNode: function(aNode) {
	          var rows = [];
	
	          // Push parent node if it is not undefined and has values other than 'children'
	          var nodeKeys = aNode ? Object.keys(aNode) : ['children'];
	          if (nodeKeys.length > 1 || nodeKeys[0] != 'children') {
	            rows.push(aNode);
	          }
	
	          if (aNode && aNode.children && aNode.children.length > 0) {
	              for (var i = 0; i < aNode.children.length; i++) {
	                  rows = rows.concat(this.getRowsFromNode(aNode.children[i]));
	              }
	          }
	          return rows;
	        },
	        /**
	         * @ngdoc function
	         * @name getDataSorted
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Gets rows from a node. If the node is grouped it will
	         * recurse down into the children to get to the raw data element
	         * which is a row without children (a leaf). If the grid is not
	         * grouped this will return just the raw rows
	         * @param {Grid} grid the grid from which data should be exported
	         * @returns {Array} an array of leaf nodes
	         */
	        getDataSorted: function (grid) {
	          if (!grid.treeBase || grid.treeBase.numberLevels === 0) {
	            return grid.rows;
	          }
	          var rows = [];
	
	          for (var i = 0; i< grid.treeBase.tree.length; i++) {
	            var nodeRows = this.getRowsFromNode(grid.treeBase.tree[i]);
	
	            for (var j = 0; j<nodeRows.length; j++) {
	              rows.push(nodeRows[j].row);
	            }
	          }
	          return rows;
	        },
	
	        /**
	         * @ngdoc function
	         * @name getData
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Gets data from the grid based on the provided options,
	         * all cells have cellFilters applied as appropriate.  Any rows marked
	         * `exporterEnableExporting: false` will not be exported
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {boolean} applyCellFilters whether or not to get the display value or the raw value of the data
	         */
	        getData: function (grid, rowTypes, colTypes, applyCellFilters) {
	          var data = [],
	            rows,
	            columns;
	
	          switch ( rowTypes ) {
	            case uiGridExporterConstants.ALL:
	              rows = this.getDataSorted(grid, rowTypes, colTypes, applyCellFilters);
	              break;
	            case uiGridExporterConstants.VISIBLE:
	              rows = grid.getVisibleRows();
	              break;
	            case uiGridExporterConstants.SELECTED:
	              if ( grid.api.selection ) {
	                rows = grid.api.selection.getSelectedGridRows();
	              } else {
	                gridUtil.logError('selection feature must be enabled to allow selected rows to be exported');
	              }
	              break;
	          }
	
	          if ( colTypes === uiGridExporterConstants.ALL ) {
	            columns = grid.columns;
	          } else {
	            var leftColumns = grid.renderContainers.left ? grid.renderContainers.left.visibleColumnCache.filter( function( column ) { return column.visible; } ) : [];
	            var bodyColumns = grid.renderContainers.body ? grid.renderContainers.body.visibleColumnCache.filter( function( column ) { return column.visible; } ) : [];
	            var rightColumns = grid.renderContainers.right ? grid.renderContainers.right.visibleColumnCache.filter( function( column ) { return column.visible; } ) : [];
	
	            columns = leftColumns.concat(bodyColumns, rightColumns);
	          }
	
	          rows.forEach(function( row ) {
	            if (row.exporterEnableExporting !== false) {
	              var extractedRow = [];
	
	              columns.forEach( function( gridCol ) {
	                // $$hashKey check since when grouping and sorting programmatically this ends up in export. Filtering it out
	                if ( (gridCol.visible || colTypes === uiGridExporterConstants.ALL ) &&
	                     gridCol.colDef.exporterSuppressExport !== true && gridCol.field !== '$$hashKey' &&
	                     grid.options.exporterSuppressColumns.indexOf( gridCol.name ) === -1 ) {
	                  var cellValue = applyCellFilters ? grid.getCellDisplayValue( row, gridCol ) : grid.getCellValue( row, gridCol ),
	                    extractedField = { value: grid.options.exporterFieldCallback( grid, row, gridCol, cellValue ) },
	                    extension = grid.options.exporterFieldFormatCallback( grid, row, gridCol, cellValue );
	
	                  if (extension) {
	                    Object.assign(extractedField, extension);
	                  }
	                  if ( gridCol.colDef.exporterPdfAlign ) {
	                    extractedField.alignment = gridCol.colDef.exporterPdfAlign;
	                  }
	                  extractedRow.push(extractedField);
	                }
	              });
	
	              data.push(extractedRow);
	            }
	          });
	
	          return data;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name formatAsCsv
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Formats the column headers and data as a CSV,
	         * and sends that data to the user
	         * @param {array} exportColumnHeaders an array of column headers,
	         * where each header is an object with name, width and maybe alignment
	         * @param {array} exportData an array of rows, where each row is
	         * an array of column data
	         * @param {string} separator a string that represents the separator to be used in the csv file
	         * @returns {string} csv the formatted csv as a string
	         */
	        formatAsCsv: function (exportColumnHeaders, exportData, separator) {
	          var self = this,
	            bareHeaders = exportColumnHeaders.map(function(header) { return { value: header.displayName };}),
	            csv = bareHeaders.length > 0 ? (self.formatRowAsCsv(this, separator)(bareHeaders) + '\n') : '';
	
	          csv += exportData.map(this.formatRowAsCsv(this, separator)).join('\n');
	
	          return csv;
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatRowAsCsv
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a csv field, including
	         * quotes around the value
	         * @param {exporterService} exporter pass in exporter
	         * @param {string} separator the string to be used to join the row data
	         * @returns {function} A function that returns a csv-ified version of the row
	         */
	        formatRowAsCsv: function (exporter, separator) {
	          return function (row) {
	            return row.map(exporter.formatFieldAsCsv).join(separator);
	          };
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatFieldAsCsv
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a csv field, including
	         * quotes around the value
	         * @param {field} field the field to be turned into a csv string,
	         * may be of any type
	         * @returns {string} a csv-ified version of the field
	         */
	        formatFieldAsCsv: function (field) {
	          if (field.value == null) { // we want to catch anything null-ish, hence just == not ===
	            return '';
	          }
	          if (typeof(field.value) === 'number') {
	            return field.value;
	          }
	          if (typeof(field.value) === 'boolean') {
	            return (field.value ? 'TRUE' : 'FALSE') ;
	          }
	          if (typeof(field.value) === 'string') {
	            return '"' + field.value.replace(/"/g,'""') + '"';
	          }
	          if (typeof(field.value) === 'object' && !(field.value instanceof Date)) {
	            return '"' + JSON.stringify(field.value).replace(/"/g,'""') + '"';
	          }
	          // if field type is date, numberStr
	          return JSON.stringify(field.value);
	        },
	
	        /**
	         * @ngdoc function
	         * @name isIE
	         * @methodOf ui.grid.exporter.service:uiGridExporterService
	         * @description Checks whether current browser is IE and returns it's version if it is
	        */
	        isIE: function () {
	          var match = navigator.userAgent.search(/(?:Edge|MSIE|Trident\/.*; rv:)/);
	          var isIE = false;
	
	          if (match !== -1) {
	            isIE = true;
	          }
	
	          return isIE;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name downloadFile
	         * @methodOf ui.grid.exporter.service:uiGridExporterService
	         * @description Triggers download of a csv file.  Logic provided
	         * by @cssensei (from his colleagues at https://github.com/ifeelgoods) in issue #2391
	         * @param {string} fileName the filename we'd like our file to be
	         * given
	         * @param {string} csvContent the csv content that we'd like to
	         * download as a file
	         * @param {string} columnSeparator The separator to be used by the columns
	         * @param {boolean} exporterOlderExcelCompatibility whether or not we put a utf-16 BOM on the from (\uFEFF)
	          * @param {boolean} exporterIsExcelCompatible whether or not we add separator header ('sep=X')
	         */
	        downloadFile: function (fileName, csvContent, columnSeparator, exporterOlderExcelCompatibility, exporterIsExcelCompatible) {
	          var D = document,
	            a = D.createElement('a'),
	            strMimeType = 'application/octet-stream;charset=utf-8',
	            rawFile,
	            ieVersion = this.isIE();
	
	          if (exporterIsExcelCompatible) {
	              csvContent = 'sep=' + columnSeparator + '\r\n' + csvContent;
	          }
	
	          // IE10+
	          if (navigator.msSaveBlob) {
	            return navigator.msSaveOrOpenBlob(
	              new Blob(
	                [exporterOlderExcelCompatibility ? "\uFEFF" : '', csvContent],
	                { type: strMimeType } ),
	              fileName
	            );
	          }
	
	          if (ieVersion) {
	            var frame = D.createElement('iframe');
	
	            document.body.appendChild(frame);
	
	            frame.contentWindow.document.open('text/html', 'replace');
	            frame.contentWindow.document.write(csvContent);
	            frame.contentWindow.document.close();
	            frame.contentWindow.focus();
	            frame.contentWindow.document.execCommand('SaveAs', true, fileName);
	
	            document.body.removeChild(frame);
	            return true;
	          }
	
	          // html5 A[download]
	          if ('download' in a) {
	            var blob = new Blob(
	              [exporterOlderExcelCompatibility ? "\uFEFF" : '', csvContent],
	              { type: strMimeType }
	            );
	            rawFile = URL.createObjectURL(blob);
	            a.setAttribute('download', fileName);
	          } else {
	            rawFile = 'data: ' + strMimeType + ',' + encodeURIComponent(csvContent);
	            a.setAttribute('target', '_blank');
	          }
	
	          a.href = rawFile;
	          a.setAttribute('style', 'display:none;');
	          D.body.appendChild(a);
	          setTimeout(function() {
	            if (a.click) {
	              a.click();
	              // Workaround for Safari 5
	            } else if (document.createEvent) {
	              var eventObj = document.createEvent('MouseEvents');
	              eventObj.initEvent('click', true, true);
	              a.dispatchEvent(eventObj);
	            }
	            D.body.removeChild(a);
	
	          }, this.delay);
	        },
	
	        /**
	         * @ngdoc function
	         * @name pdfExport
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Exports rows from the grid in pdf format,
	         * the data exported is selected based on the provided options.
	         * Note that this function has a dependency on pdfMake, which must
	         * be installed.  The resulting pdf opens in a new
	         * browser window.
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        pdfExport: function (grid, rowTypes, colTypes) {
	          var self = this;
	
	          this.loadAllDataIfNeeded(grid, rowTypes, colTypes).then(function () {
	            var exportColumnHeaders = self.getColumnHeaders(grid, colTypes),
	              exportData = self.getData(grid, rowTypes, colTypes),
	              docDefinition = self.prepareAsPdf(grid, exportColumnHeaders, exportData);
	
	            if (self.isIE() || navigator.appVersion.indexOf('Edge') !== -1) {
	              var fileName = angular.isFunction(grid.options.exporterPdfFilename) ? grid.options.exporterPdfFilename(grid, rowTypes, colTypes) : grid.options.exporterPdfFilename;
	              self.downloadPDF(fileName, docDefinition);
	            } else {
	              pdfMake.createPdf(docDefinition).open();
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name downloadPdf
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Generates and retrieves the pdf as a blob, then downloads
	         * it as a file.  Only used in IE, in all other browsers we use the native
	         * pdfMake.open function to just open the PDF
	         * @param {string} fileName the filename to give to the pdf, can be set
	         * through exporterPdfFilename
	         * @param {object} docDefinition a pdf docDefinition that we can generate
	         * and get a blob from
	         */
	        downloadPDF: function (fileName, docDefinition) {
	          var D = document,
	            a = D.createElement('a'),
	            ieVersion;
	
	          ieVersion = this.isIE(); // This is now a boolean value
	          var doc = pdfMake.createPdf(docDefinition);
	          var blob;
	
	          doc.getBuffer( function (buffer) {
	            blob = new Blob([buffer]);
	
	            // IE10+
	            if (navigator.msSaveBlob) {
	              return navigator.msSaveBlob(
	                blob, fileName
	              );
	            }
	
	            // Previously:  && ieVersion < 10
	            // ieVersion now returns a boolean for the
	            // sake of sanity. We just check `msSaveBlob` first.
	            if (ieVersion) {
	              var frame = D.createElement('iframe');
	              document.body.appendChild(frame);
	
	              frame.contentWindow.document.open('text/html', 'replace');
	              frame.contentWindow.document.write(blob);
	              frame.contentWindow.document.close();
	              frame.contentWindow.focus();
	              frame.contentWindow.document.execCommand('SaveAs', true, fileName);
	
	              document.body.removeChild(frame);
	              return true;
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name renderAsPdf
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders the data into a pdf, and opens that pdf.
	         *
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {array} exportColumnHeaders an array of column headers,
	         * where each header is an object with name, width and maybe alignment
	         * @param {array} exportData an array of rows, where each row is
	         * an array of column data
	         * @returns {object} a pdfMake format document definition, ready
	         * for generation
	         */
	        prepareAsPdf: function(grid, exportColumnHeaders, exportData) {
	          var headerWidths = this.calculatePdfHeaderWidths( grid, exportColumnHeaders );
	
	          var headerColumns = exportColumnHeaders.map( function( header ) {
	            return { text: header.displayName, style: 'tableHeader' };
	          });
	
	          var stringData = exportData.map(this.formatRowAsPdf(this));
	
	          var allData = [headerColumns].concat(stringData);
	
	          var docDefinition = {
	            pageOrientation: grid.options.exporterPdfOrientation,
	            pageSize: grid.options.exporterPdfPageSize,
	            content: [{
	              style: 'tableStyle',
	              table: {
	                headerRows: 1,
	                widths: headerWidths,
	                body: allData
	              }
	            }],
	            styles: {
	              tableStyle: grid.options.exporterPdfTableStyle,
	              tableHeader: grid.options.exporterPdfTableHeaderStyle
	            },
	            defaultStyle: grid.options.exporterPdfDefaultStyle
	          };
	
	          if ( grid.options.exporterPdfLayout ) {
	            docDefinition.layout = grid.options.exporterPdfLayout;
	          }
	
	          if ( grid.options.exporterPdfHeader ) {
	            docDefinition.header = grid.options.exporterPdfHeader;
	          }
	
	          if ( grid.options.exporterPdfFooter ) {
	            docDefinition.footer = grid.options.exporterPdfFooter;
	          }
	
	          if ( grid.options.exporterPdfCustomFormatter ) {
	            docDefinition = grid.options.exporterPdfCustomFormatter( docDefinition );
	          }
	          return docDefinition;
	
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name calculatePdfHeaderWidths
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Determines the column widths base on the
	         * widths we got from the grid.  If the column is drawn
	         * then we have a drawnWidth.  If the column is not visible
	         * then we have '*', 'x%' or a width.  When columns are
	         * not visible they don't contribute to the overall gridWidth,
	         * so we need to adjust to allow for extra columns
	         *
	         * Our basic heuristic is to take the current gridWidth, plus
	         * numeric columns and call this the base gridwidth.
	         *
	         * To that we add 100 for any '*' column, and x% of the base gridWidth
	         * for any column that is a %
	         *
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {array} exportHeaders array of header information
	         * @returns {object} an array of header widths
	         */
	        calculatePdfHeaderWidths: function ( grid, exportHeaders ) {
	          var baseGridWidth = 0;
	
	          exportHeaders.forEach(function(value) {
	            if (typeof(value.width) === 'number') {
	              baseGridWidth += value.width;
	            }
	          });
	
	          var extraColumns = 0;
	
	          exportHeaders.forEach(function(value) {
	            if (value.width === '*') {
	              extraColumns += 100;
	            }
	            if (typeof(value.width) === 'string' && value.width.match(/(\d)*%/)) {
	              var percent = parseInt(value.width.match(/(\d)*%/)[0]);
	
	              value.width = baseGridWidth * percent / 100;
	              extraColumns += value.width;
	            }
	          });
	
	          var gridWidth = baseGridWidth + extraColumns;
	
	          return exportHeaders.map(function( header ) {
	            return header.width === '*' ? header.width : header.width * grid.options.exporterPdfMaxGridWidth / gridWidth;
	          });
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatRowAsPdf
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a row in a format consumable by PDF,
	         * mainly meaning casting everything to a string
	         * @param {exporterService} exporter pass in exporter
	         * @param {array} row the row to be turned into a csv string
	         * @returns {string} a csv-ified version of the row
	         */
	        formatRowAsPdf: function ( exporter ) {
	          return function( row ) {
	            return row.map(exporter.formatFieldAsPdfString);
	          };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name formatFieldAsCsv
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a pdf-able field, which
	         * is different from a csv field only in that strings don't have quotes
	         * around them
	         * @param {field} field the field to be turned into a pdf string,
	         * may be of any type
	         * @returns {string} a string-ified version of the field
	         */
	        formatFieldAsPdfString: function (field) {
	          var returnVal;
	
	          if (field.value == null) { // we want to catch anything null-ish, hence just == not ===
	            returnVal = '';
	          } else if (typeof(field.value) === 'number') {
	            returnVal = field.value.toString();
	          } else if (typeof(field.value) === 'boolean') {
	            returnVal = (field.value ? 'TRUE' : 'FALSE') ;
	          } else if (typeof(field.value) === 'string') {
	            returnVal = field.value.replace(/"/g,'""');
	          } else if (field.value instanceof Date) {
	            returnVal = JSON.stringify(field.value).replace(/^"/,'').replace(/"$/,'');
	          } else if (typeof(field.value) === 'object') {
	            returnVal = field.value;
	          } else {
	            returnVal = JSON.stringify(field.value).replace(/^"/,'').replace(/"$/,'');
	          }
	
	          if (field.alignment && typeof(field.alignment) === 'string' ) {
	            returnVal = { text: returnVal, alignment: field.alignment };
	          }
	
	          return returnVal;
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatAsExcel
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Formats the column headers and data as a excel,
	         * and sends that data to the user
	         * @param {array} exportColumnHeaders an array of column headers,
	         * where each header is an object with name, width and maybe alignment
	         * @param {array} exportData an array of rows, where each row is
	         * an array of column data
	         * @param {string} separator a string that represents the separator to be used in the csv file
	         * @returns {string} csv the formatted excel as a string
	         */
	        formatAsExcel: function (exportColumnHeaders, exportData, workbook, sheet, docDefinition) {
	          var bareHeaders = exportColumnHeaders.map(function(header) {return { value: header.displayName };});
	
	          var sheetData = [];
	          var headerData = [];
	          for (var i = 0; i < bareHeaders.length; i++) {
	            // TODO - probably need callback to determine header value and header styling
	            var exportStyle = 'header';
	            switch (exportColumnHeaders[i].align) {
	              case 'center':
	                exportStyle = 'headerCenter';
	                break;
	              case 'right':
	                exportStyle = 'headerRight';
	                break;
	            }
	            var metadata = (docDefinition.styles && docDefinition.styles[exportStyle]) ? {style: docDefinition.styles[exportStyle].id} : null;
	            headerData.push({value: bareHeaders[i].value, metadata: metadata});
	          }
	          sheetData.push(headerData);
	
	          var result = exportData.map(this.formatRowAsExcel(this, workbook, sheet));
	          for (var j = 0; j<result.length; j++) {
	            sheetData.push(result[j]);
	          }
	          return sheetData;
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatRowAsExcel
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a csv field, including
	         * quotes around the value
	         * @param {exporterService} exporter pass in exporter
	         * @param {array} row the row to be turned into a excel string
	         * @returns {array} array of cell objects (i.e. {value: x, metadata: y})
	         */
	        formatRowAsExcel: function (exporter, workbook, sheet) {
	          return function (row) {
	            var values = [];
	            for (var i = 0; i<row.length; i++) {
	              var value = exporter.formatFieldAsExcel(row[i], workbook, sheet);
	              values.push({value: value, metadata: row[i].metadata});
	            }
	            return values;
	          };
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatFieldAsExcel
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a excel-ified field
	         * @param {field} field the field to be excel-ified,
	         * may be of any type
	         * @returns {string} a excel-ified version of the field
	         */
	        formatFieldAsExcel: function (field, workbook, sheet, formatters) {
	          if (field.value == null) { // we want to catch anything null-ish, hence just == not ===
	            return '';
	          }
	          if ((typeof(field.value) === 'number') || (typeof(field.value) === 'string')) {
	            return field.value;
	          }
	          if (typeof(field.value) === 'boolean') {
	            return (field.value ? 'TRUE' : 'FALSE') ;
	          }
	
	          return JSON.stringify(field.value);
	        },
	
	        prepareAsExcel: function(grid, workbook, sheet) {
	          var docDefinition = {
	            styles: {
	
	            }
	          };
	
	          if ( grid.options.exporterExcelCustomFormatters ) {
	            docDefinition = grid.options.exporterExcelCustomFormatters( grid, workbook, docDefinition );
	          }
	          if ( grid.options.exporterExcelHeader ) {
	            if (angular.isFunction( grid.options.exporterExcelHeader )) {
	              grid.options.exporterExcelHeader(grid, workbook, sheet, docDefinition);
	            } else {
	              var headerText = grid.options.exporterExcelHeader.text;
	              var style = grid.options.exporterExcelHeader.style;
	              sheet.data.push([{value: headerText, metadata: {style: docDefinition.styles[style].id}}]);
	            }
	          }
	
	          return docDefinition;
	        },
	
	        excelExport: function (grid, rowTypes, colTypes) {
	          var self = this;
	          this.loadAllDataIfNeeded(grid, rowTypes, colTypes).then(function() {
	            var exportColumnHeaders = grid.options.showHeader ? self.getColumnHeaders(grid, colTypes) : [];
	
	            var aName = 'Sheet1';
	            if (grid.options.exporterExcelSheetName) {
	              aName = angular.isFunction(grid.options.exporterExcelSheetName) ? grid.options.exporterExcelSheetName(grid, rowTypes, colTypes) : grid.options.exporterExcelSheetName;
	            }
	
	            var sheet = new ExcelBuilder.Worksheet({name: aName});
	            var workbook = new ExcelBuilder.Workbook();
	            workbook.addWorksheet(sheet);
	            var docDefinition = self.prepareAsExcel(grid, workbook, sheet);
	
	            // The standard column width in Microsoft Excel 2000 is 8.43 characters based on fixed-width Courier font
	            // Width of 10 in excel is 75 pixels
	            var colWidths = [];
	            var startDataIndex = grid.treeBase ? grid.treeBase.numberLevels : (grid.enableRowSelection ? 1 : 0);
	            for (var i = startDataIndex; i < grid.columns.length; i++) {
	              if (grid.columns[i].field !== uiGridExporterConstants.rowHeaderColName &&
	                grid.columns[i].field !== uiGridExporterConstants.selectionRowHeaderColName) {
	
	                colWidths.push({width: (grid.columns[i].drawnWidth / grid.options.exporterColumnScaleFactor)});
	              }
	            }
	            sheet.setColumns(colWidths);
	
	            var exportData = self.getData(grid, rowTypes, colTypes, grid.options.exporterFieldApplyFilters);
	
	            var excelContent = self.formatAsExcel(exportColumnHeaders, exportData, workbook, sheet, docDefinition);
	            sheet.setData(sheet.data.concat(excelContent));
	
	            ExcelBuilder.Builder.createFile(workbook, {type: 'blob'}).then(function(result) {
	              var fileName = angular.isFunction(grid.options.exporterExcelFilename) ? grid.options.exporterExcelFilename(grid, rowTypes, colTypes) : grid.options.exporterExcelFilename;
	              self.downloadFile(fileName, result, grid.options.exporterCsvColumnSeparator, grid.options.exporterOlderExcelCompatibility);
	            });
	          });
	        }
	      };
	
	      function getDisplayName(grid, gridCol) {
	        if (grid.options.exporterHeaderFilter) {
	          return grid.options.exporterHeaderFilterUseName ?
	            grid.options.exporterHeaderFilter(gridCol.name) :
	            grid.options.exporterHeaderFilter(gridCol.displayName);
	        }
	
	        return gridCol.headerCellFilter ?
	          $filter(gridCol.headerCellFilter)(gridCol.displayName) :
	          gridCol.displayName;
	      }
	
	      function defaultExporterFieldCallback(grid, row, col, value) {
	        // fix to handle cases with 'number : 1' or 'date:"MM-dd-YYYY HH:mm"', etc.. We needed to split the string
	        if (col.cellFilter) {
	          var args, filter, arg1, arg2;
	          // Split on ':' except when in double quotes.
	          args = col.cellFilter.match(/(?:[^:"]+|"[^"]*")+/g);
	          // remove space, single/double to maintain retro-compatibility, but keep spaces in second argument (arg[1])
	          filter = args[0] ? args[0].replace(/[\'\"\s]/g, "") : null;
	          arg1 = args[1] ? args[1].replace(/[\'\"]/g, "").trim() : null;
	          arg2 = args[2] ? args[2].replace(/[\'\"\s]/g, "") : null;
	          return $filter(filter)(value, arg1, arg2);
	        } else {
	          return value;
	        }
	      }
	
	      return service;
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.exporter.directive:uiGridExporter
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds exporter features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.exporter']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.gridOptions = {
	        enableGridMenu: true,
	        exporterMenuCsv: false,
	        columnDefs: [
	          {name: 'name', enableCellEdit: true},
	          {name: 'title', enableCellEdit: true}
	        ],
	        data: $scope.data
	      };
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-exporter></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridExporter', ['uiGridExporterConstants', 'uiGridExporterService', 'gridUtil', '$compile',
	    function (uiGridExporterConstants, uiGridExporterService, gridUtil, $compile) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          uiGridExporterService.initializeGrid(uiGridCtrl.grid);
	          uiGridCtrl.grid.exporter.$scope = $scope;
	        }
	      };
	    }
	  ]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.grouping
	   * @description
	   *
	   * # ui.grid.grouping
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   * This module provides grouping of rows based on the data in them, similar
	   * in concept to excel grouping.  You can group multiple columns, resulting in
	   * nested grouping.
	   *
	   * In concept this feature is similar to sorting + grid footer/aggregation, it
	   * sorts the data based on the grouped columns, then creates group rows that
	   * reflect a break in the data.  Each of those group rows can have aggregations for
	   * the data within that group.
	   *
	   * This feature leverages treeBase to provide the tree functionality itself,
	   * the key thing this feature does therefore is to set treeLevels on the rows
	   * and insert the group headers.
	   *
	   * Design information:
	   * -------------------
	   *
	   * Each column will get new menu items - group by, and aggregate by.  Group by
	   * will cause this column to be sorted (if not already), and will move this column
	   * to the front of the sorted columns (i.e. grouped columns take precedence over
	   * sorted columns).  It will respect the sort order already set if there is one,
	   * and it will allow the sorting logic to change that sort order, it just forces
	   * the column to the front of the sorting.  You can group by multiple columns, the
	   * logic will add this column to the sorting after any already grouped columns.
	   *
	   * Once a grouping is defined, grouping logic is added to the rowsProcessors.  This
	   * will process the rows, identifying a break in the data value, and inserting a grouping row.
	   * Grouping rows have specific attributes on them:
	   *
	   *  - internalRow = true: tells us that this isn't a real row, so we can ignore it
	   *    from any processing that it looking at core data rows.  This is used by the core
	   *    logic (or will be one day), as it's not grouping specific
	   *  - groupHeader = true: tells us this is a groupHeader.  This is used by the grouping logic
	   *    to know if this is a groupHeader row or not
	   *
	   * Since the logic is baked into the rowsProcessors, it should get triggered whenever
	   * row order or filtering or anything like that is changed.  In order to avoid the row instantiation
	   * time, and to preserve state across invocations, we hold a cache of the rows that we created
	   * last time, and we use them again this time if we can.
	   *
	   * By default rows are collapsed, which means all data rows have their visible property
	   * set to false, and only level 0 group rows are set to visible.
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.grouping"></div>
	   */
	
	  var module = angular.module('ui.grid.grouping', ['ui.grid', 'ui.grid.treeBase']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.grouping.constant:uiGridGroupingConstants
	   *
	   *  @description constants available in grouping module, this includes
	   *  all the constants declared in the treeBase module (these are manually copied
	   *  as there isn't an easy way to include constants in another constants file, and
	   *  we don't want to make users include treeBase)
	   *
	   */
	  module.constant('uiGridGroupingConstants', {
	    featureName: "grouping",
	    rowHeaderColName: 'treeBaseRowHeaderCol',
	    EXPANDED: 'expanded',
	    COLLAPSED: 'collapsed',
	    aggregation: {
	      COUNT: 'count',
	      SUM: 'sum',
	      MAX: 'max',
	      MIN: 'min',
	      AVG: 'avg'
	    }
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.grouping.service:uiGridGroupingService
	   *
	   *  @description Services for grouping features
	   */
	  module.service('uiGridGroupingService', ['$q', 'uiGridGroupingConstants', 'gridUtil', 'rowSorter', 'GridRow', 'gridClassFactory', 'i18nService', 'uiGridConstants', 'uiGridTreeBaseService',
	  function ($q, uiGridGroupingConstants, gridUtil, rowSorter, GridRow, gridClassFactory, i18nService, uiGridConstants, uiGridTreeBaseService) {
	    var service = {
	      initializeGrid: function (grid, $scope) {
	        uiGridTreeBaseService.initializeGrid( grid, $scope );
	
	        // add feature namespace and any properties to grid for needed
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.grouping.grid:grouping
	         *
	         *  @description Grid properties and functions added for grouping
	         */
	        grid.grouping = {};
	
	        /**
	         *  @ngdoc property
	         *  @propertyOf ui.grid.grouping.grid:grouping
	         *  @name groupHeaderCache
	         *
	         *  @description Cache that holds the group header rows we created last time, we'll
	         *  reuse these next time, not least because they hold our expanded states.
	         *
	         *  We need to take care with these that they don't become a memory leak, we
	         *  create a new cache each time using the values from the old cache.  This works
	         *  so long as we're creating group rows for invisible rows as well.
	         *
	         *  The cache is a nested hash, indexed on the value we grouped by.  So if we
	         *  grouped by gender then age, we'd maybe have something like:
	         *  ```
	         *    {
	         *      male: {
	         *        row: <pointer to the old row>,
	         *        children: {
	         *          22: { row: <pointer to the old row> },
	         *          31: { row: <pointer to the old row> }
	         *      },
	         *      female: {
	         *        row: <pointer to the old row>,
	         *        children: {
	         *          28: { row: <pointer to the old row> },
	         *          55: { row: <pointer to the old row> }
	         *      }
	         *    }
	         *  ```
	         *
	         *  We create new rows for any missing rows, this means that they come in as collapsed.
	         *
	         */
	        grid.grouping.groupHeaderCache = {};
	
	        service.defaultGridOptions(grid.options);
	
	        grid.registerRowsProcessor(service.groupRows, 400);
	
	        grid.registerColumnBuilder( service.groupingColumnBuilder);
	
	        grid.registerColumnsProcessor(service.groupingColumnProcessor, 400);
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.grouping.api:PublicApi
	         *
	         *  @description Public Api for grouping feature
	         */
	        var publicApi = {
	          events: {
	            grouping: {
	              /**
	               * @ngdoc event
	               * @eventOf ui.grid.grouping.api:PublicApi
	               * @name aggregationChanged
	               * @description raised whenever aggregation is changed, added or removed from a column
	               *
	               * <pre>
	               *      gridApi.grouping.on.aggregationChanged(scope,function(col) {})
	               * </pre>
	               * @param {GridColumn} col the column on which aggregation changed. The aggregation
	               * type is available as `col.treeAggregation.type`
	               */
	              aggregationChanged: {},
	              /**
	               * @ngdoc event
	               * @eventOf ui.grid.grouping.api:PublicApi
	               * @name groupingChanged
	               * @description raised whenever the grouped columns changes
	               *
	               * <pre>
	               *      gridApi.grouping.on.groupingChanged(scope,function(col) {})
	               * </pre>
	               * @param {GridColumn} col the column on which grouping changed. The new grouping is
	               * available as `col.grouping`
	               */
	              groupingChanged: {}
	            }
	          },
	          methods: {
	            grouping: {
	              /**
	               * @ngdoc function
	               * @name getGrouping
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Get the grouping configuration for this grid,
	               * used by the saveState feature.  Adds expandedState to the information
	               * provided by the internal getGrouping, and removes any aggregations that have a source
	               * of grouping (i.e. will be automatically reapplied when we regroup the column)
	               * Returned grouping is an object
	               *   `{ grouping: groupArray, treeAggregations: aggregateArray, expandedState: hash }`
	               * where grouping contains an array of objects:
	               *   `{ field: column.field, colName: column.name, groupPriority: column.grouping.groupPriority }`
	               * and aggregations contains an array of objects:
	               *   `{ field: column.field, colName: column.name, aggregation: column.grouping.aggregation }`
	               * and expandedState is a hash of the currently expanded nodes
	               *
	               * The groupArray will be sorted by groupPriority.
	               *
	               * @param {boolean} getExpanded whether or not to return the expanded state
	               * @returns {object} grouping configuration
	               */
	              getGrouping: function ( getExpanded ) {
	                var grouping = service.getGrouping(grid);
	
	                grouping.grouping.forEach( function( group ) {
	                  group.colName = group.col.name;
	                  delete group.col;
	                });
	
	                grouping.aggregations.forEach( function( aggregation ) {
	                  aggregation.colName = aggregation.col.name;
	                  delete aggregation.col;
	                });
	
	                grouping.aggregations = grouping.aggregations.filter( function( aggregation ) {
	                  return !aggregation.aggregation.source || aggregation.aggregation.source !== 'grouping';
	                });
	
	                if ( getExpanded ) {
	                  grouping.rowExpandedStates = service.getRowExpandedStates( grid.grouping.groupingHeaderCache );
	                }
	
	                return grouping;
	              },
	
	              /**
	               * @ngdoc function
	               * @name setGrouping
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Set the grouping configuration for this grid,
	               * used by the saveState feature, but can also be used by any
	               * user to specify a combined grouping and aggregation configuration
	               * @param {object} config the config you want to apply, in the format
	               * provided out by getGrouping
	               */
	              setGrouping: function ( config ) {
	                service.setGrouping(grid, config);
	              },
	
	              /**
	               * @ngdoc function
	               * @name groupColumn
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Adds this column to the existing grouping, at the end of the priority order.
	               * If the column doesn't have a sort, adds one, by default ASC
	               *
	               * This column will move to the left of any non-group columns, the
	               * move is handled in a columnProcessor, so gets called as part of refresh
	               *
	               * @param {string} columnName the name of the column we want to group
	               */
	              groupColumn: function(columnName) {
	                var column = grid.getColumn(columnName);
	
	                service.groupColumn(grid, column);
	              },
	
	              /**
	               * @ngdoc function
	               * @name ungroupColumn
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Removes the groupPriority from this column.  If the
	               * column was previously aggregated the aggregation will come back.
	               * The sort will remain.
	               *
	               * This column will move to the right of any other group columns, the
	               * move is handled in a columnProcessor, so gets called as part of refresh
	               *
	               * @param {string} columnName the name of the column we want to ungroup
	               */
	              ungroupColumn: function(columnName) {
	                var column = grid.getColumn(columnName);
	
	                service.ungroupColumn(grid, column);
	              },
	
	              /**
	               * @ngdoc function
	               * @name clearGrouping
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Clear any grouped columns and any aggregations.  Doesn't remove sorting,
	               * as we don't know whether that sorting was added by grouping or was there beforehand
	               *
	               */
	              clearGrouping: function() {
	                service.clearGrouping(grid);
	              },
	
	              /**
	               * @ngdoc function
	               * @name aggregateColumn
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Sets the aggregation type on a column, if the
	               * column is currently grouped then it removes the grouping first.
	               * If the aggregationDef is null then will result in the aggregation
	               * being removed
	               *
	               * @param {string} columnName the column we want to aggregate
	               * @param {string|function} aggregationDef one of the recognised types
	               * from uiGridGroupingConstants or a custom aggregation function.
	               * @param {string} aggregationLabel (optional) The label to use for this aggregation.
	               */
	              aggregateColumn: function(columnName, aggregationDef, aggregationLabel) {
	                var column = grid.getColumn(columnName);
	
	                service.aggregateColumn(grid, column, aggregationDef, aggregationLabel);
	              }
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	
	        grid.api.registerMethodsFromObject(publicApi.methods);
	
	        grid.api.core.on.sortChanged($scope, service.tidyPriorities);
	      },
	
	      defaultGridOptions: function (gridOptions) {
	        // default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.grouping.api:GridOptions
	         *
	         *  @description GridOptions for grouping feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enableGrouping
	         *  @propertyOf  ui.grid.grouping.api:GridOptions
	         *  @description Enable row grouping for entire grid.
	         *  <br/>Defaults to true
	         */
	        gridOptions.enableGrouping = gridOptions.enableGrouping !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name groupingShowCounts
	         *  @propertyOf  ui.grid.grouping.api:GridOptions
	         *  @description shows counts on the groupHeader rows. Not that if you are using a cellFilter or a
	         *  sortingAlgorithm which relies on a specific format or data type, showing counts may cause that
	         *  to break, since the group header rows will always be a string with groupingShowCounts enabled.
	         *  <br/>Defaults to true except on columns of types 'date' and 'object'
	         */
	        gridOptions.groupingShowCounts = gridOptions.groupingShowCounts !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name groupingNullLabel
	         *  @propertyOf  ui.grid.grouping.api:GridOptions
	         *  @description The string to use for the grouping header row label on rows which contain a null or undefined value in the grouped column.
	         *  <br/>Defaults to "Null"
	         */
	        gridOptions.groupingNullLabel = typeof(gridOptions.groupingNullLabel) === 'undefined' ? 'Null' : gridOptions.groupingNullLabel;
	
	        /**
	         *  @ngdoc object
	         *  @name enableGroupHeaderSelection
	         *  @propertyOf  ui.grid.grouping.api:GridOptions
	         *  @description Allows group header rows to be selected.
	         *  <br/>Defaults to false
	         */
	        gridOptions.enableGroupHeaderSelection = gridOptions.enableGroupHeaderSelection === true;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name groupingColumnBuilder
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Sets the grouping defaults based on the columnDefs
	       *
	       * @param {object} colDef columnDef we're basing on
	       * @param {GridColumn} col the column we're to update
	       * @param {object} gridOptions the options we should use
	       * @returns {promise} promise for the builder - actually we do it all inline so it's immediately resolved
	       */
	      groupingColumnBuilder: function (colDef, col, gridOptions) {
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.grouping.api:ColumnDef
	         *
	         *  @description ColumnDef for grouping feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enableGrouping
	         *  @propertyOf  ui.grid.grouping.api:ColumnDef
	         *  @description Enable grouping on this column
	         *  <br/>Defaults to true.
	         */
	        if (colDef.enableGrouping === false) {
	          return;
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name grouping
	         *  @propertyOf  ui.grid.grouping.api:ColumnDef
	         *  @description Set the grouping for a column.  Format is:
	         *  ```
	         *    {
	         *      groupPriority: <number, starts at 0, if less than 0 or undefined then we're aggregating in this column>
	         *    }
	         *  ```
	         *
	         *  **Note that aggregation used to be included in grouping, but is now separately set on the column via treeAggregation
	         *  setting in treeBase**
	         *
	         *  We group in the priority order given, this will also put these columns to the high order of the sort irrespective
	         *  of the sort priority given them.  If there is no sort defined then we sort ascending, if there is a sort defined then
	         *  we use that sort.
	         *
	         *  If the groupPriority is undefined or less than 0, then we expect to be aggregating, and we look at the
	         *  aggregation types to determine what sort of aggregation we can do.  Values are in the constants file, but
	         *  include SUM, COUNT, MAX, MIN
	         *
	         *  groupPriorities should generally be sequential, if they're not then the next time getGrouping is called
	         *  we'll renumber them to be sequential.
	         *  <br/>Defaults to undefined.
	         */
	
	        if ( typeof(col.grouping) === 'undefined' && typeof(colDef.grouping) !== 'undefined') {
	          col.grouping = angular.copy(colDef.grouping);
	          if ( typeof(col.grouping.groupPriority) !== 'undefined' && col.grouping.groupPriority > -1 ) {
	            col.treeAggregationFn = uiGridTreeBaseService.nativeAggregations()[uiGridGroupingConstants.aggregation.COUNT].aggregationFn;
	            col.treeAggregationFinalizerFn = service.groupedFinalizerFn;
	          }
	        } else if (typeof(col.grouping) === 'undefined') {
	          col.grouping = {};
	        }
	
	        if (typeof(col.grouping) !== 'undefined' && typeof(col.grouping.groupPriority) !== 'undefined' && col.grouping.groupPriority >= 0) {
	          col.suppressRemoveSort = true;
	        }
	
	        var groupColumn = {
	          name: 'ui.grid.grouping.group',
	          title: i18nService.get().grouping.group,
	          icon: 'ui-grid-icon-indent-right',
	          shown: function () {
	            return typeof(this.context.col.grouping) === 'undefined' ||
	                   typeof(this.context.col.grouping.groupPriority) === 'undefined' ||
	                   this.context.col.grouping.groupPriority < 0;
	          },
	          action: function () {
	            service.groupColumn( this.context.col.grid, this.context.col );
	          }
	        };
	
	        var ungroupColumn = {
	          name: 'ui.grid.grouping.ungroup',
	          title: i18nService.get().grouping.ungroup,
	          icon: 'ui-grid-icon-indent-left',
	          shown: function () {
	            return typeof(this.context.col.grouping) !== 'undefined' &&
	                   typeof(this.context.col.grouping.groupPriority) !== 'undefined' &&
	                   this.context.col.grouping.groupPriority >= 0;
	          },
	          action: function () {
	            service.ungroupColumn( this.context.col.grid, this.context.col );
	          }
	        };
	
	        var aggregateRemove = {
	          name: 'ui.grid.grouping.aggregateRemove',
	          title: i18nService.get().grouping.aggregate_remove,
	          shown: function () {
	            return typeof(this.context.col.treeAggregationFn) !== 'undefined';
	          },
	          action: function () {
	            service.aggregateColumn( this.context.col.grid, this.context.col, null);
	          }
	        };
	
	        // generic adder for the aggregation menus, which follow a pattern
	        var addAggregationMenu = function(type, title) {
	          title = title || i18nService.get().grouping['aggregate_' + type] || type;
	          var menuItem = {
	            name: 'ui.grid.grouping.aggregate' + type,
	            title: title,
	            shown: function () {
	              return typeof(this.context.col.treeAggregation) === 'undefined' ||
	                     typeof(this.context.col.treeAggregation.type) === 'undefined' ||
	                     this.context.col.treeAggregation.type !== type;
	            },
	            action: function () {
	              service.aggregateColumn( this.context.col.grid, this.context.col, type);
	            }
	          };
	
	          if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.aggregate' + type)) {
	            col.menuItems.push(menuItem);
	          }
	        };
	
	        /**
	         *  @ngdoc object
	         *  @name groupingShowGroupingMenu
	         *  @propertyOf  ui.grid.grouping.api:ColumnDef
	         *  @description Show the grouping (group and ungroup items) menu on this column
	         *  <br/>Defaults to true.
	         */
	        if ( col.colDef.groupingShowGroupingMenu !== false ) {
	          if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.group')) {
	            col.menuItems.push(groupColumn);
	          }
	
	          if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.ungroup')) {
	            col.menuItems.push(ungroupColumn);
	          }
	        }
	
	
	        /**
	         *  @ngdoc object
	         *  @name groupingShowAggregationMenu
	         *  @propertyOf  ui.grid.grouping.api:ColumnDef
	         *  @description Show the aggregation menu on this column
	         *  <br/>Defaults to true.
	         */
	        if ( col.colDef.groupingShowAggregationMenu !== false ) {
	          angular.forEach(uiGridTreeBaseService.nativeAggregations(), function(aggregationDef, name) {
	            addAggregationMenu(name);
	          });
	          angular.forEach(gridOptions.treeCustomAggregations, function(aggregationDef, name) {
	            addAggregationMenu(name, aggregationDef.menuTitle);
	          });
	
	          if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.aggregateRemove')) {
	            col.menuItems.push(aggregateRemove);
	          }
	        }
	      },
	
	
	
	
	      /**
	       * @ngdoc function
	       * @name groupingColumnProcessor
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Moves the columns around based on which are grouped
	       *
	       * @param {array} columns the columns to consider rendering
	       * @param {array} rows the grid rows, which we don't use but are passed to us
	       * @returns {array} updated columns array
	       */
	      groupingColumnProcessor: function( columns, rows ) {
	        columns = service.moveGroupColumns(this, columns, rows);
	        return columns;
	      },
	
	      /**
	       * @ngdoc function
	       * @name groupedFinalizerFn
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Used on group columns to display the rendered value and optionally
	       * display the count of rows.
	       *
	       * @param {aggregation} aggregation The aggregation entity for a grouped column
	       */
	      groupedFinalizerFn: function( aggregation ) {
	        var col = this;
	
	        if ( typeof(aggregation.groupVal) !== 'undefined') {
	          aggregation.rendered = aggregation.groupVal;
	          if ( col.grid.options.groupingShowCounts && col.colDef.type !== 'date' && col.colDef.type !== 'object' ) {
	            aggregation.rendered += (' (' + aggregation.value + ')');
	          }
	        } else {
	          aggregation.rendered = null;
	        }
	      },
	
	      /**
	       * @ngdoc function
	       * @name moveGroupColumns
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Moves the column order so that the grouped columns are lined up
	       * to the left (well, unless you're RTL, then it's the right).  By doing this in
	       * the columnsProcessor, we make it transient - when the column is ungrouped it'll
	       * go back to where it was.
	       *
	       * Does nothing if the option `moveGroupColumns` is set to false.
	       *
	       * @param {Grid} grid grid object
	       * @param {array} columns the columns that we should process/move
	       * @returns {array} updated columns
	       */
	      moveGroupColumns: function( grid, columns ) {
	        if ( grid.options.moveGroupColumns === false) {
	          return columns;
	        }
	
	        columns.forEach(function(column, index) {
	          // position used to make stable sort in moveGroupColumns
	          column.groupingPosition = index;
	        });
	
	        columns.sort(function(a, b) {
	          var a_group, b_group;
	
	          if (a.isRowHeader) {
	            a_group = a.headerPriority;
	          }
	          else if ( typeof(a.grouping) === 'undefined' || typeof(a.grouping.groupPriority) === 'undefined' || a.grouping.groupPriority < 0) {
	            a_group = null;
	          }
	          else {
	            a_group = a.grouping.groupPriority;
	          }
	
	          if (b.isRowHeader) {
	            b_group = b.headerPriority;
	          }
	          else if ( typeof(b.grouping) === 'undefined' || typeof(b.grouping.groupPriority) === 'undefined' || b.grouping.groupPriority < 0) {
	            b_group = null;
	          }
	          else {
	            b_group = b.grouping.groupPriority;
	          }
	
	          // groups get sorted to the top
	          if ( a_group !== null && b_group === null) { return -1; }
	          if ( b_group !== null && a_group === null) { return 1; }
	          if ( a_group !== null && b_group !== null) {return a_group - b_group; }
	
	          return a.groupingPosition - b.groupingPosition;
	        });
	
	        columns.forEach( function(column) {
	          delete column.groupingPosition;
	        });
	
	        return columns;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name groupColumn
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Adds this column to the existing grouping, at the end of the priority order.
	       * If the column doesn't have a sort, adds one, by default ASC
	       *
	       * This column will move to the left of any non-group columns, the
	       * move is handled in a columnProcessor, so gets called as part of refresh
	       *
	       * @param {Grid} grid grid object
	       * @param {GridColumn} column the column we want to group
	       */
	      groupColumn: function( grid, column) {
	        if ( typeof(column.grouping) === 'undefined' ) {
	          column.grouping = {};
	        }
	
	        // set the group priority to the next number in the hierarchy
	        var existingGrouping = service.getGrouping( grid );
	        column.grouping.groupPriority = existingGrouping.grouping.length;
	
	        // save sort in order to restore it when column is ungrouped
	        column.previousSort = angular.copy(column.sort);
	
	        // add sort if not present
	        if ( !column.sort ) {
	          column.sort = { direction: uiGridConstants.ASC };
	        } else if ( typeof(column.sort.direction) === 'undefined' || column.sort.direction === null ) {
	          column.sort.direction = uiGridConstants.ASC;
	        }
	
	        column.treeAggregation = { type: uiGridGroupingConstants.aggregation.COUNT, source: 'grouping' };
	
	        if ( column.colDef && angular.isFunction(column.colDef.customTreeAggregationFn) ) {
	          column.treeAggregationFn = column.colDef.customTreeAggregationFn;
	        } else {
	          column.treeAggregationFn = uiGridTreeBaseService.nativeAggregations()[uiGridGroupingConstants.aggregation.COUNT].aggregationFn;
	        }
	
	        column.treeAggregationFinalizerFn = service.groupedFinalizerFn;
	
	        grid.api.grouping.raise.groupingChanged(column);
	        // This indirectly calls service.tidyPriorities( grid );
	        grid.api.core.raise.sortChanged(grid, grid.getColumnSorting());
	
	        grid.queueGridRefresh();
	      },
	
	
	       /**
	       * @ngdoc function
	       * @name ungroupColumn
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Removes the groupPriority from this column.  If the
	       * column was previously aggregated the aggregation will come back.
	       * The sort will remain.
	       *
	       * This column will move to the right of any other group columns, the
	       * move is handled in a columnProcessor, so gets called as part of refresh
	       *
	       * @param {Grid} grid grid object
	       * @param {GridColumn} column the column we want to ungroup
	       */
	      ungroupColumn: function( grid, column) {
	        if ( typeof(column.grouping) === 'undefined' ) {
	          return;
	        }
	
	        delete column.grouping.groupPriority;
	        delete column.treeAggregation;
	        delete column.customTreeAggregationFinalizer;
	
	        if (column.previousSort) {
	          column.sort = column.previousSort;
	          delete column.previousSort;
	        }
	
	        service.tidyPriorities( grid );
	
	        grid.api.grouping.raise.groupingChanged(column);
	        grid.api.core.raise.sortChanged(grid, grid.getColumnSorting());
	
	        grid.queueGridRefresh();
	      },
	
	      /**
	       * @ngdoc function
	       * @name aggregateColumn
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Sets the aggregation type on a column, if the
	       * column is currently grouped then it removes the grouping first.
	       *
	       * @param {Grid} grid grid object
	       * @param {GridColumn} column the column we want to aggregate
	       * @param {string} aggregationType of the recognised types from uiGridGroupingConstants or one of the custom aggregations from gridOptions
	       * @param {string} aggregationLabel to be used instead of the default label. If empty string is passed, label is omitted
	       */
	      aggregateColumn: function( grid, column, aggregationType, aggregationLabel ) {
	        if (typeof(column.grouping) !== 'undefined' && typeof(column.grouping.groupPriority) !== 'undefined' && column.grouping.groupPriority >= 0) {
	          service.ungroupColumn( grid, column );
	        }
	
	        var aggregationDef = {};
	
	        if ( typeof(grid.options.treeCustomAggregations[aggregationType]) !== 'undefined' ) {
	          aggregationDef = grid.options.treeCustomAggregations[aggregationType];
	        } else if ( typeof(uiGridTreeBaseService.nativeAggregations()[aggregationType]) !== 'undefined' ) {
	          aggregationDef = uiGridTreeBaseService.nativeAggregations()[aggregationType];
	        }
	
	        column.treeAggregation = {
	          type: aggregationType,
	          label: ( typeof aggregationLabel === 'string') ?
	            aggregationLabel :
	            i18nService.get().aggregation[aggregationDef.label] || aggregationDef.label
	        };
	        column.treeAggregationFn = aggregationDef.aggregationFn;
	        column.treeAggregationFinalizerFn = aggregationDef.finalizerFn;
	
	        grid.api.grouping.raise.aggregationChanged(column);
	
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name setGrouping
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Set the grouping based on a config object, used by the save state feature
	       * (more specifically, by the restore function in that feature )
	       *
	       * @param {Grid} grid grid object
	       * @param {object} config the config we want to set, same format as that returned by getGrouping
	       */
	      setGrouping: function ( grid, config ) {
	        if ( typeof(config) === 'undefined' ) {
	          return;
	        }
	
	        // first remove any existing grouping
	        service.clearGrouping(grid);
	
	        if ( config.grouping && config.grouping.length && config.grouping.length > 0 ) {
	          config.grouping.forEach( function( group ) {
	            var col = grid.getColumn(group.colName);
	
	            if ( col ) {
	              service.groupColumn( grid, col );
	            }
	          });
	        }
	
	        if ( config.aggregations && config.aggregations.length ) {
	          config.aggregations.forEach( function( aggregation ) {
	            var col = grid.getColumn(aggregation.colName);
	
	            if ( col ) {
	              service.aggregateColumn( grid, col, aggregation.aggregation.type );
	            }
	          });
	        }
	
	        if ( config.rowExpandedStates ) {
	          service.applyRowExpandedStates( grid.grouping.groupingHeaderCache, config.rowExpandedStates );
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name clearGrouping
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Clear any grouped columns and any aggregations.  Doesn't remove sorting,
	       * as we don't know whether that sorting was added by grouping or was there beforehand
	       *
	       * @param {Grid} grid grid object
	       */
	      clearGrouping: function( grid ) {
	        var currentGrouping = service.getGrouping(grid);
	
	        if ( currentGrouping.grouping.length > 0 ) {
	          currentGrouping.grouping.forEach( function( group ) {
	            if (!group.col) {
	              // should have a group.colName if there's no col
	              group.col = grid.getColumn(group.colName);
	            }
	            service.ungroupColumn(grid, group.col);
	          });
	        }
	
	        if ( currentGrouping.aggregations.length > 0 ) {
	          currentGrouping.aggregations.forEach( function( aggregation ) {
	            if (!aggregation.col) {
	              // should have a group.colName if there's no col
	              aggregation.col = grid.getColumn(aggregation.colName);
	            }
	            service.aggregateColumn(grid, aggregation.col, null);
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name tidyPriorities
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Renumbers groupPriority and sortPriority such that
	       * groupPriority is contiguous, and sortPriority either matches
	       * groupPriority (for group columns), and otherwise is contiguous and
	       * higher than groupPriority.
	       *
	       * @param {Grid} grid grid object
	       */
	      tidyPriorities: function( grid ) {
	        // if we're called from sortChanged, grid is in this, not passed as param, the param can be a column or undefined
	        if ( ( typeof(grid) === 'undefined' || typeof(grid.grid) !== 'undefined' ) && typeof(this.grid) !== 'undefined' ) {
	          grid = this.grid;
	        }
	
	        var groupArray = [],
	          sortArray = [];
	
	        grid.columns.forEach( function(column, index) {
	          if ( typeof(column.grouping) !== 'undefined' && typeof(column.grouping.groupPriority) !== 'undefined' && column.grouping.groupPriority >= 0) {
	            groupArray.push(column);
	          }
	          else if ( typeof(column.sort) !== 'undefined' && typeof(column.sort.priority) !== 'undefined' && column.sort.priority >= 0) {
	            sortArray.push(column);
	          }
	        });
	
	        groupArray.sort(function(a, b) { return a.grouping.groupPriority - b.grouping.groupPriority; });
	        groupArray.forEach( function(column, index) {
	          column.grouping.groupPriority = index;
	          column.suppressRemoveSort = true;
	          if ( typeof(column.sort) === 'undefined') {
	            column.sort = {};
	          }
	          column.sort.priority = index;
	        });
	
	        var i = groupArray.length;
	
	        sortArray.sort(function(a, b) { return a.sort.priority - b.sort.priority; });
	        sortArray.forEach(function(column) {
	          column.sort.priority = i;
	          column.suppressRemoveSort = column.colDef.suppressRemoveSort;
	          i++;
	        });
	      },
	
	      /**
	       * @ngdoc function
	       * @name groupRows
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description The rowProcessor that creates the groupHeaders (i.e. does
	       * the actual grouping).
	       *
	       * Assumes it is always called after the sorting processor, guaranteed by the priority setting
	       *
	       * Processes all the rows in order, inserting a groupHeader row whenever there is a change
	       * in value of a grouped row, based on the sortAlgorithm used for the column.  The group header row
	       * is looked up in the groupHeaderCache, and used from there if there is one. The entity is reset
	       * to {} if one is found.
	       *
	       * As it processes it maintains a `processingState` array. This records, for each level of grouping we're
	       * working with, the following information:
	       * ```
	       *   {
	       *     fieldName: name,
	       *     col: col,
	       *     initialised: boolean,
	       *     currentValue: value,
	       *     currentRow: gridRow,
	       *   }
	       * ```
	       * We look for changes in the currentValue at any of the levels.  Where we find a change we:
	       *
	       * - create a new groupHeader row in the array
	       *
	       * @param {array} renderableRows the rows we want to process, usually the output from the previous rowProcessor
	       * @returns {array} the updated rows, including our new group rows
	       */
	      groupRows: function( renderableRows ) {
	        if (renderableRows.length === 0) {
	          return renderableRows;
	        }
	
	        var grid = this;
	        grid.grouping.oldGroupingHeaderCache = grid.grouping.groupingHeaderCache || {};
	        grid.grouping.groupingHeaderCache = {};
	
	        var processingState = service.initialiseProcessingState( grid );
	
	        // processes each of the fields we are grouping by, checks if the value has changed and inserts a groupHeader
	        // Broken out as shouldn't create functions in a loop.
	        var updateProcessingState = function( groupFieldState, stateIndex ) {
	          var fieldValue = grid.getCellValue(row, groupFieldState.col);
	
	          // look for change of value - and insert a header
	          if ( !groupFieldState.initialised || rowSorter.getSortFn(groupFieldState.col)(fieldValue, groupFieldState.currentValue) !== 0 ) {
	            service.insertGroupHeader( grid, renderableRows, i, processingState, stateIndex );
	            i++;
	          }
	        };
	
	        // use a for loop because it's tolerant of the array length changing whilst we go - we can
	        // manipulate the iterator when we insert groupHeader rows
	        for (var i = 0; i < renderableRows.length; i++ ) {
	          var row = renderableRows[i];
	
	          if ( row.visible ) {
	            processingState.forEach( updateProcessingState );
	          }
	        }
	
	        delete grid.grouping.oldGroupingHeaderCache;
	        return renderableRows;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name initialiseProcessingState
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Creates the processing state array that is used
	       * for groupRows.
	       *
	       * @param {Grid} grid grid object
	       * @returns {array} an array in the format described in the groupRows method,
	       * initialised with blank values
	       */
	      initialiseProcessingState: function( grid ) {
	        var processingState = [];
	        var columnSettings = service.getGrouping( grid );
	
	        columnSettings.grouping.forEach( function( groupItem, index) {
	          processingState.push({
	            fieldName: groupItem.field,
	            col: groupItem.col,
	            initialised: false,
	            currentValue: null,
	            currentRow: null
	          });
	        });
	
	        return processingState;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name getGrouping
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Get the grouping settings from the columns.  As a side effect
	       * this always renumbers the grouping starting at 0
	       * @param {Grid} grid grid object
	       * @returns {array} an array of the group fields, in order of priority
	       */
	      getGrouping: function( grid ) {
	        var groupArray = [],
	          aggregateArray = [];
	
	        // get all the grouping
	        grid.columns.forEach(function(column) {
	          if ( column.grouping ) {
	            if ( typeof(column.grouping.groupPriority) !== 'undefined' && column.grouping.groupPriority >= 0) {
	              groupArray.push({ field: column.field, col: column, groupPriority: column.grouping.groupPriority, grouping: column.grouping });
	            }
	          }
	          if ( column.treeAggregation && column.treeAggregation.type ) {
	            aggregateArray.push({ field: column.field, col: column, aggregation: column.treeAggregation });
	          }
	        });
	
	        // sort grouping into priority order
	        groupArray.sort( function(a, b) {
	          return a.groupPriority - b.groupPriority;
	        });
	
	        // renumber the priority in case it was somewhat messed up, then remove the grouping reference
	        groupArray.forEach( function( group, index) {
	          group.grouping.groupPriority = index;
	          group.groupPriority = index;
	          delete group.grouping;
	        });
	
	        return { grouping: groupArray, aggregations: aggregateArray };
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name insertGroupHeader
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Create a group header row, and link it to the various configuration
	       * items that we use.
	       *
	       * Look for the row in the oldGroupingHeaderCache, write the row into the new groupingHeaderCache.
	       *
	       * @param {Grid} grid grid object
	       * @param {array} renderableRows the rows that we are processing
	       * @param {number} rowIndex the row we were up to processing
	       * @param {array} processingState the current processing state
	       * @param {number} stateIndex the processing state item that we were on when we triggered a new group header -
	       * i.e. the column that we want to create a header for
	       */
	      insertGroupHeader: function( grid, renderableRows, rowIndex, processingState, stateIndex ) {
	        // set the value that caused the end of a group into the header row and the processing state
	        var col = processingState[stateIndex].col,
	          newValue = grid.getCellValue(renderableRows[rowIndex], col),
	          newDisplayValue = newValue;
	
	        if ( typeof(newValue) === 'undefined' || newValue === null ) {
	          newDisplayValue = grid.options.groupingNullLabel;
	        }
	
	        function getKeyAsValueForCacheMap(key) {
	          return angular.isObject(key) ? JSON.stringify(key) : key;
	        }
	
	        var cacheItem = grid.grouping.oldGroupingHeaderCache;
	
	        for ( var i = 0; i < stateIndex; i++ ) {
	          if ( cacheItem && cacheItem[getKeyAsValueForCacheMap(processingState[i].currentValue)] ) {
	            cacheItem = cacheItem[getKeyAsValueForCacheMap(processingState[i].currentValue)].children;
	          }
	        }
	
	        var headerRow;
	
	        if ( cacheItem && cacheItem[getKeyAsValueForCacheMap(newValue)]) {
	          headerRow = cacheItem[getKeyAsValueForCacheMap(newValue)].row;
	          headerRow.entity = {};
	        } else {
	          headerRow = new GridRow( {}, null, grid );
	          gridClassFactory.rowTemplateAssigner.call(grid, headerRow);
	        }
	
	        headerRow.entity['$$' + processingState[stateIndex].col.uid] = { groupVal: newDisplayValue };
	        headerRow.treeLevel = stateIndex;
	        headerRow.groupHeader = true;
	        headerRow.internalRow = true;
	        headerRow.enableCellEdit = false;
	        headerRow.enableSelection = grid.options.enableGroupHeaderSelection;
	        processingState[stateIndex].initialised = true;
	        processingState[stateIndex].currentValue = newValue;
	        processingState[stateIndex].currentRow = headerRow;
	
	        // set all processing states below this one to not be initialised - change of this state
	        // means all those need to start again
	        service.finaliseProcessingState( processingState, stateIndex + 1);
	
	        // insert our new header row
	        renderableRows.splice(rowIndex, 0, headerRow);
	
	        // add our new header row to the cache
	        cacheItem = grid.grouping.groupingHeaderCache;
	        for ( i = 0; i < stateIndex; i++ ) {
	          cacheItem = cacheItem[getKeyAsValueForCacheMap(processingState[i].currentValue)].children;
	        }
	        cacheItem[getKeyAsValueForCacheMap(newValue)] = { row: headerRow, children: {} };
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name finaliseProcessingState
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Set all processing states lower than the one that had a break in value to
	       * no longer be initialised.  Render the counts into the entity ready for display.
	       *
	       * @param {array} processingState the current processing state
	       * @param {number} stateIndex the processing state item that we were on when we triggered a new group header, all
	       * processing states after this need to be finalised
	       */
	      finaliseProcessingState: function( processingState, stateIndex ) {
	        for ( var i = stateIndex; i < processingState.length; i++) {
	          processingState[i].initialised = false;
	          processingState[i].currentRow = null;
	          processingState[i].currentValue = null;
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name getRowExpandedStates
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Extract the groupHeaderCache hash, pulling out only the states.
	       *
	       * The example below shows a grid that is grouped by gender then age
	       *
	       * <pre>
	       *   {
	       *     male: {
	       *       state: 'expanded',
	       *       children: {
	       *         22: { state: 'expanded' },
	       *         30: { state: 'collapsed' }
	       *       }
	       *     },
	       *     female: {
	       *       state: 'expanded',
	       *       children: {
	       *         28: { state: 'expanded' },
	       *         55: { state: 'collapsed' }
	       *       }
	       *     }
	       *   }
	       * </pre>
	       *
	       * @param {object} treeChildren The tree children elements object
	       * @returns {object} the expanded states as an object
	       */
	      getRowExpandedStates: function(treeChildren) {
	        if ( typeof(treeChildren) === 'undefined' ) {
	          return {};
	        }
	
	        var newChildren = {};
	
	        angular.forEach( treeChildren, function( value, key ) {
	          newChildren[key] = { state: value.row.treeNode.state };
	          if ( value.children ) {
	            newChildren[key].children = service.getRowExpandedStates( value.children );
	          } else {
	            newChildren[key].children = {};
	          }
	        });
	
	        return newChildren;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name applyRowExpandedStates
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Take a hash in the format as created by getRowExpandedStates,
	       * and apply it to the grid.grouping.groupHeaderCache.
	       *
	       * Takes a treeSubset, and applies to a treeSubset - so can be called
	       * recursively.
	       *
	       * @param {object} currentNode can be grid.grouping.groupHeaderCache, or any of
	       * the children of that hash
	       * @param {object} expandedStates can be the full expanded states, or children
	       * of that expanded states (which hopefully matches the subset of the groupHeaderCache)
	       */
	      applyRowExpandedStates: function( currentNode, expandedStates ) {
	        if ( typeof(expandedStates) === 'undefined' ) {
	          return;
	        }
	
	        angular.forEach(expandedStates, function( value, key ) {
	          if ( currentNode[key] ) {
	            currentNode[key].row.treeNode.state = value.state;
	
	            if (value.children && currentNode[key].children) {
	              service.applyRowExpandedStates( currentNode[key].children, value.children );
	            }
	          }
	        });
	      }
	
	
	    };
	
	    return service;
	
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.grouping.directive:uiGridGrouping
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds grouping features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.grouping']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true},
	        {name: 'title', enableCellEdit: true}
	      ];
	
	      $scope.gridOptions = { columnDefs: $scope.columnDefs, data: $scope.data };
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-grouping></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridGrouping', ['uiGridGroupingConstants', 'uiGridGroupingService',
	  function (uiGridGroupingConstants, uiGridGroupingService) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            if (uiGridCtrl.grid.options.enableGrouping !== false) {
	              uiGridGroupingService.initializeGrid(uiGridCtrl.grid, $scope);
	            }
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	
	(function() {
		angular.module('ui.grid').config(['$provide', function($provide) {
			$provide.decorator('i18nService', ['$delegate', function($delegate) {
				$delegate.add('ar', {
					"headerCell": {
						"aria": {
							"defaultFilterLabel": "التصفيه بالعمود",
							"removeFilter": "محو التصفيه",
							"columnMenuButtonLabel": "قاءمه الاعمده"
						},
						"priority": "أولويه : ",
						"filterLabel": "تصفيه بالاعمده :"
					},
					"aggregate": {
						"label": "العناصر"
					},
					"groupPanel": {
						"description": "اسحب رأس العمود هنا وأسقطه لإنشاء مجموعه"
					},
					"search": {
						"placeholder": "بحث  ...",
						"showingItems": "العناصر الظاهره :",
						"selectedItems": "العناصر المحدده :",
						"totalItems": "عدد العناصر :",
						"size": "حجم الصفحه :",
						"first": "اول صفحه",
						"next": "الصفحه التاليه",
						"previous": "الصفحه الصابقه",
						"last": "الصفحه الاخيره"
					},
					"menu": {
						"text": "اختيار العمود :"
					},
					"sort": {
						"ascending": "ترتيب تصاعدى",
						"descending": "ترتيب تنازلى",
						"none": "عدم التحديد",
						"remove": "حذف الترتيب"
					},
					"column": {
						"hide": "إخفاء عمود"
					},
					"aggregation": {
						"count": "عدد الصفوف: ",
						"sum": "جمع: ",
						"avg": "المتوسط الحسابى: ",
						"min": "الادنى: ",
						"max": "الاقصى: "
					},
					"pinning": {
						"pinLeft": "تثبيت لليسار",
						"pinRight": "تثبيت لليمين",
						"unpin": "فك التثبيت"
					},
					"columnMenu": {
						"close": "غلق"
					},
					"gridMenu": {
						"aria": {
							"buttonLabel": "قائمه الجدول"
						},
						"columns": "الاعمده:",
						"importerTitle": "إدخال ملف",
						"exporterAllAsCsv": "إخراج كل البيانات ك(csv)",
						"exporterVisibleAsCsv": "إخراج كل البيانات الواضحه ك (csv)",
						"exporterSelectedAsCsv": "إخراج كل البيانات المحدده ك (csv)",
						"exporterAllAsPdf": "إخراج كل البيانات ك(pdf)",
						"exporterVisibleAsPdf": "إخراج كل البيانات الواضحه ك (pdf)",
						"exporterSelectedAsPdf": "إخراج كل البيانات المحدده ك (pdf)",
						"clearAllFilters": "محو كل الترشيح"
					},
					"importer": {
						"noHeaders": "اسماء هؤلاء الاعمده غير واضحه، هل يوجد رأس للملف؟",
						"noObjects": "Objects were not able to be derived, was there data in the file other than headers?",
						"invalidCsv": "الملف غير قادر على الاتمام ، هل ال (CSV) صحيح؟",
						"invalidJson": "الملف غير قادر على الاتمام ، هل ال (JSON) صحيح؟",
						"jsonNotArray": "Imported json file must contain an array, aborting."
					},
					"pagination": {
						"aria": {
							"pageToFirst": "الصفحه الاولى",
							"pageBack": "الصفه السابقه",
							"pageSelected": "الصفحه المحدده",
							"pageForward": "الصفحه التاليه",
							"pageToLast": "الصفحه الاخيره"
						},
						"sizes": "عدد العناصر فى الصفحه",
						"totalItems": "عناصر",
						"through": "إلى",
						"of": "من"
					},
					"grouping": {
						"group": "جمع",
						"ungroup": "فك الجمع",
						"aggregate_count": "جمله : العدد",
						"aggregate_sum": "جمله : الحاصل",
						"aggregate_max": "جمله : الاقصى",
						"aggregate_min": "جمله : الاقل",
						"aggregate_avg": "جمله :المتوسط ",
						"aggregate_remove": "جمله : حذف"
					},
					"validate": {
						"error": "خطأ :",
						"minLength": "القيمه لابد ان لا تقل عن THRESHOLD حرف.",
						"maxLength": "القيمه لابد ان لا تزيد عن THRESHOLD حرف.",
						"required": "مطلوب قيمه"
					}
				});
				return $delegate;
			}]);
		}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('bg', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Филттър за колоната',
	            removeFilter: 'Премахни филтър',
	            columnMenuButtonLabel: 'Меню на колоната'
	          },
	          priority: 'Приоритет:',
	          filterLabel: "Филтър за колоната: "
	        },
	        aggregate: {
	          label: 'обекти'
	        },
	        search: {
	          placeholder: 'Търсене...',
	          showingItems: 'Показани обекти:',
	          selectedItems: 'избрани обекти:',
	          totalItems: 'Общо:',
	          size: 'Размер на страницата:',
	          first: 'Първа страница',
	          next: 'Следваща страница',
	          previous: 'Предишна страница',
	          last: 'Последна страница'
	        },
	        menu: {
	          text: 'Избери колони:'
	        },
	        sort: {
	          ascending: 'Сортиране по възходящ ред',
	          descending: 'Сортиране по низходящ ред',
	          none: 'Без сортиране',
	          remove: 'Премахни сортирането'
	        },
	        column: {
	          hide: 'Скрий колоната'
	        },
	        aggregation: {
	          count: 'Общо редове: ',
	          sum: 'общо: ',
	          avg: 'средно: ',
	          min: 'най-малко: ',
	          max: 'най-много: '
	        },
	        pinning: {
	          pinLeft: 'Прикрепи вляво',
	          pinRight: 'Прикрепи вдясно',
	          unpin: 'Премахване'
	        },
	        columnMenu: {
	          close: 'Затвори'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Меню на таблицата'
	          },
	          columns: 'Колони:',
	          importerTitle: 'Импортиране на файл',
	          exporterAllAsCsv: 'Експортиране на данните като csv',
	          exporterVisibleAsCsv: 'Експортиране на видимите данни като csv',
	          exporterSelectedAsCsv: 'Експортиране на избраните данни като csv',
	          exporterAllAsPdf: 'Експортиране на данните като pdf',
	          exporterVisibleAsPdf: 'Експортиране на видимите данни като pdf',
	          exporterSelectedAsPdf: 'Експортиране на избраните данни като pdf',
	          clearAllFilters: 'Премахни всички филтри'
	        },
	        importer: {
	          noHeaders: 'Имената на колоните не успяха да бъдат извлечени, файлът има ли хедър?',
	          noObjects: 'Обектите не успяха да бъдат извлечени, файлът съдържа ли данни, различни от хедър?',
	          invalidCsv: 'Файлът не може да бъде обработеб, уверете се, че е валиден CSV файл',
	          invalidJson: 'Файлът не може да бъде обработеб, уверете се, че е валиден JSON файл',
	          jsonNotArray: 'Импортираният JSON файл трябва да съдържа масив, прекратяване.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Към първа страница',
	            pageBack: 'Страница назад',
	            pageSelected: 'Избрана страница',
	            pageForward: 'Страница напред',
	            pageToLast: 'Към последна страница'
	          },
	          sizes: 'обекта на страница',
	          totalItems: 'обекта',
	          through: 'до',
	          of: 'от'
	        },
	        grouping: {
	          group: 'Групиране',
	          ungroup: 'Премахване на групирането',
	          aggregate_count: 'Сбор: Брой',
	          aggregate_sum: 'Сбор: Сума',
	          aggregate_max: 'Сбор: Максимум',
	          aggregate_min: 'Сбор: Минимум',
	          aggregate_avg: 'Сбор: Средно',
	          aggregate_remove: 'Сбор: Премахване'
	        },
	        validate: {
	          error: 'Грешка:',
	          minLength: 'Стойността трябва да съдържа поне THRESHOLD символа.',
	          maxLength: 'Стойността не трябва да съдържа повече от THRESHOLD символа.',
	          required: 'Необходима е стойност.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      var lang = {
	              aggregate: {
	                  label: 'položky'
	              },
	              groupPanel: {
	                  description: 'Přesuňte záhlaví zde pro vytvoření skupiny dle sloupce.'
	              },
	              search: {
	                  placeholder: 'Hledat...',
	                  showingItems: 'Zobrazuji položky:',
	                  selectedItems: 'Vybrané položky:',
	                  totalItems: 'Celkem položek:',
	                  size: 'Velikost strany:',
	                  first: 'První strana',
	                  next: 'Další strana',
	                  previous: 'Předchozí strana',
	                  last: 'Poslední strana'
	              },
	              menu: {
	                  text: 'Vyberte sloupec:'
	              },
	              sort: {
	                  ascending: 'Seřadit od A-Z',
	                  descending: 'Seřadit od Z-A',
	                  remove: 'Odebrat seřazení'
	              },
	              column: {
	                  hide: 'Schovat sloupec'
	              },
	              aggregation: {
	                  count: 'celkem řádků: ',
	                  sum: 'celkem: ',
	                  avg: 'avg: ',
	                  min: 'min.: ',
	                  max: 'max.: '
	              },
	              pinning: {
	                  pinLeft: 'Zamknout vlevo',
	                  pinRight: 'Zamknout vpravo',
	                  unpin: 'Odemknout'
	              },
	              gridMenu: {
	                  columns: 'Sloupce:',
	                  importerTitle: 'Importovat soubor',
	                  exporterAllAsCsv: 'Exportovat všechna data do csv',
	                  exporterVisibleAsCsv: 'Exportovat viditelná data do csv',
	                  exporterSelectedAsCsv: 'Exportovat vybraná data do csv',
	                  exporterAllAsPdf: 'Exportovat všechna data do pdf',
	                  exporterVisibleAsPdf: 'Exportovat viditelná data do pdf',
	                  exporterSelectedAsPdf: 'Exportovat vybraná data do pdf',
	                  exporterAllAsExcel: 'Exportovat všechna data do excel',
	                  exporterVisibleAsExcel: 'Exportovat viditelná data do excel',
	                  exporterSelectedAsExcel: 'Exportovat vybraná data do excel',
	                  clearAllFilters: 'Odstranit všechny filtry'
	              },
	              importer: {
	                  noHeaders: 'Názvy sloupců se nepodařilo získat, obsahuje soubor záhlaví?',
	                  noObjects: 'Data se nepodařilo zpracovat, obsahuje soubor řádky mimo záhlaví?',
	                  invalidCsv: 'Soubor nelze zpracovat, jedná se o CSV?',
	                  invalidJson: 'Soubor nelze zpracovat, je to JSON?',
	                  jsonNotArray: 'Soubor musí obsahovat json. Ukončuji..'
	              },
	              pagination: {
	                  sizes: 'položek na stránku',
	                  totalItems: 'položek'
	              },
	              grouping: {
	                  group: 'Seskupit',
	                  ungroup: 'Odebrat seskupení',
	                  aggregate_count: 'Agregace: Count',
	                  aggregate_sum: 'Agregace: Sum',
	                  aggregate_max: 'Agregace: Max',
	                  aggregate_min: 'Agregace: Min',
	                  aggregate_avg: 'Agregace: Avg',
	                  aggregate_remove: 'Agregace: Odebrat'
	              }
	          };
	
	          // support varianty of different czech keys.
	          $delegate.add('cs', lang);
	          $delegate.add('cz', lang);
	          $delegate.add('cs-cz', lang);
	          $delegate.add('cs-CZ', lang);
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
		angular.module('ui.grid').config(['$provide', function($provide) {
			$provide.decorator('i18nService', ['$delegate', function($delegate) {
				$delegate.add('da', {
					aggregate: {
						label: 'artikler'
					},
					groupPanel: {
						description: 'Grupér rækker udfra en kolonne ved at trække dens overskift hertil.'
					},
					search: {
						placeholder: 'Søg...',
						showingItems: 'Viste rækker:',
						selectedItems: 'Valgte rækker:',
						totalItems: 'Rækker totalt:',
						size: 'Side størrelse:',
						first: 'Første side',
						next: 'Næste side',
						previous: 'Forrige side',
						last: 'Sidste side'
					},
					menu: {
						text: 'Vælg kolonner:'
					},
					sort: {
						ascending: 'Sorter stigende',
						descending: 'Sorter faldende',
						none: 'Sorter ingen',
						remove: 'Fjern sortering'
					},
					column: {
						hide: 'Skjul kolonne'
					},
					aggregation: {
						count: 'antal rækker: ',
						sum: 'sum: ',
						avg: 'gns: ',
						min: 'min: ',
						max: 'max: '
					},
					pinning: {
						pinLeft: 'Fastgør til venstre',
						pinRight: 'Fastgør til højre',
						unpin: 'Frigør'
					},
					gridMenu: {
						columns: 'Kolonner:',
						importerTitle: 'Importer fil',
						exporterAllAsCsv: 'Eksporter alle data som csv',
						exporterVisibleAsCsv: 'Eksporter synlige data som csv',
						exporterSelectedAsCsv: 'Eksporter markerede data som csv',
						exporterAllAsPdf: 'Eksporter alle data som pdf',
						exporterVisibleAsPdf: 'Eksporter synlige data som pdf',
						exporterSelectedAsPdf: 'Eksporter markerede data som pdf',
						exporterAllAsExcel: 'Eksporter alle data som excel',
						exporterVisibleAsExcel: 'Eksporter synlige data som excel',
						exporterSelectedAsExcel: 'Eksporter markerede data som excel',
						clearAllFilters: 'Clear all filters'
					},
					importer: {
						noHeaders: 'Column names were unable to be derived, does the file have a header?',
						noObjects: 'Objects were not able to be derived, was there data in the file other than headers?',
						invalidCsv: 'File was unable to be processed, is it valid CSV?',
						invalidJson: 'File was unable to be processed, is it valid Json?',
						jsonNotArray: 'Imported json file must contain an array, aborting.'
					},
					pagination: {
						aria: {
							pageToFirst: 'Gå til første',
							pageBack: 'Gå tilbage',
							pageSelected: 'Valgte side',
							pageForward: 'Gå frem',
							pageToLast: 'Gå til sidste'
						},
						sizes: 'genstande per side',
						totalItems: 'genstande',
						through: 'gennem',
						of: 'af'
					}
				});
				return $delegate;
			}]);
		}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function ($provide) {
	    $provide.decorator('i18nService', ['$delegate', function ($delegate) {
	      $delegate.add('de', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filter für Spalte',
	            removeFilter: 'Filter löschen',
	            columnMenuButtonLabel: 'Spaltenmenü',
	            column: 'Spalte'
	          },
	          priority: 'Priorität:',
	          filterLabel: "Filter für Spalte: "
	        },
	        aggregate: {
	          label: 'Eintrag'
	        },
	        groupPanel: {
	          description: 'Ziehen Sie eine Spaltenüberschrift hierhin, um nach dieser Spalte zu gruppieren.'
	        },
	        search: {
	          aria: {
	            selected: 'Zeile markiert',
	            notSelected: 'Zeile nicht markiert'
	          },
	          placeholder: 'Suche...',
	          showingItems: 'Zeige Einträge:',
	          selectedItems: 'Ausgewählte Einträge:',
	          totalItems: 'Einträge gesamt:',
	          size: 'Einträge pro Seite:',
	          first: 'Erste Seite',
	          next: 'Nächste Seite',
	          previous: 'Vorherige Seite',
	          last: 'Letzte Seite'
	        },
	        selection: {
	          aria: {
	            row: 'Zeile'
	          },
	          selectAll: 'Alle auswählen',
	          displayName: 'Zeilenauswahlkasten'
	        },
	        menu: {
	          text: 'Spalten auswählen:'
	        },
	        sort: {
	          ascending: 'aufsteigend sortieren',
	          descending: 'absteigend sortieren',
	          none: 'keine Sortierung',
	          remove: 'Sortierung zurücksetzen'
	        },
	        column: {
	          hide: 'Spalte ausblenden'
	        },
	        aggregation: {
	          count: 'Zeilen insgesamt: ',
	          sum: 'gesamt: ',
	          avg: 'Durchschnitt: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	            pinLeft: 'Links anheften',
	            pinRight: 'Rechts anheften',
	            unpin: 'Lösen'
	        },
	        columnMenu: {
	          close: 'Schließen'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Tabellenmenü'
	          },
	          columns: 'Spalten:',
	          importerTitle: 'Datei importieren',
	          exporterAllAsCsv: 'Alle Daten als CSV exportieren',
	          exporterVisibleAsCsv: 'Sichtbare Daten als CSV exportieren',
	          exporterSelectedAsCsv: 'Markierte Daten als CSV exportieren',
	          exporterAllAsPdf: 'Alle Daten als PDF exportieren',
	          exporterVisibleAsPdf: 'Sichtbare Daten als PDF exportieren',
	          exporterSelectedAsPdf: 'Markierte Daten als PDF exportieren',
	          exporterAllAsExcel: 'Alle Daten als Excel exportieren',
	          exporterVisibleAsExcel: 'Sichtbare Daten als Excel exportieren',
	          exporterSelectedAsExcel: 'Markierte Daten als Excel exportieren',
	          clearAllFilters: 'Alle Filter zurücksetzen'
	        },
	        importer: {
	          noHeaders: 'Es konnten keine Spaltennamen ermittelt werden. Sind in der Datei Spaltendefinitionen enthalten?',
	          noObjects: 'Es konnten keine Zeileninformationen gelesen werden, Sind in der Datei außer den Spaltendefinitionen auch Daten enthalten?',
	          invalidCsv: 'Die Datei konnte nicht eingelesen werden, ist es eine gültige CSV-Datei?',
	          invalidJson: 'Die Datei konnte nicht eingelesen werden. Enthält sie gültiges JSON?',
	          jsonNotArray: 'Die importierte JSON-Datei muß ein Array enthalten. Breche Import ab.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Zum Anfang',
	            pageBack: 'Seite zurück',
	            pageSelected: 'Ausgewählte Seite',
	            pageForward: 'Seite vor',
	            pageToLast: 'Zum Ende'
	          },
	          sizes: 'Einträge pro Seite',
	          totalItems: 'Einträgen',
	          through: 'bis',
	          of: 'von'
	        },
	        grouping: {
	            group: 'Gruppieren',
	            ungroup: 'Gruppierung aufheben',
	            aggregate_count: 'Agg: Anzahl',
	            aggregate_sum: 'Agg: Summe',
	            aggregate_max: 'Agg: Maximum',
	            aggregate_min: 'Agg: Minimum',
	            aggregate_avg: 'Agg: Mittelwert',
	            aggregate_remove: 'Aggregation entfernen'
	        },
	        validate: {
	          error: 'Fehler:',
	          minLength: 'Der Wert sollte mindestens THRESHOLD Zeichen lang sein.',
	          maxLength: 'Der Wert sollte maximal THRESHOLD Zeichen lang sein.',
	          required: 'Ein Wert wird benötigt.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('es-ct', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtre per columna',
	            removeFilter: 'Elimina el filtre',
	            columnMenuButtonLabel: 'Menú de Columna',
	            column: 'Columna'
	          },
	          priority: 'Priority:',
	          filterLabel: 'Filtre per columna: '
	        },
	        aggregate: {
	          label: 'items'
	        },
	        groupPanel: {
	          description: 'Arrossegueu una capçalera de columna aquí i deixeu-lo anar per agrupar per aquesta columna.'
	        },
	        search: {
	          aria: {
	            selected: 'Fila seleccionada',
	            notSelected: 'Fila no seleccionada'
	          },
	          placeholder: 'Cerca...',
	          showingItems: 'Ítems Mostrats:',
	          selectedItems: 'Ítems Seleccionats:',
	          totalItems: 'Ítems Totals:',
	          size: 'Mida de la pàgina:',
	          first: 'Primera Pàgina',
	          next: 'Propera Pàgina',
	          previous: 'Pàgina Anterior',
	          last: 'Última Pàgina'
	        },
	        selection: {
	          aria: {
	            row: 'Fila'
	          },
	          selectAll: 'Seleccionar Todo',
	          displayName: 'Seleccionar Fila'
	        },
	        menu: {
	          text: 'Triar Columnes:'
	        },
	        sort: {
	          ascending: 'Ordena Ascendent',
	          descending: 'Ordena Descendent',
	          none: 'Sense Ordre',
	          remove: 'Eliminar Ordre'
	        },
	        column: {
	          hide: 'Amaga la Columna'
	        },
	        aggregation: {
	          count: 'Files Totals: ',
	          sum: 'total: ',
	          avg: 'mitjà: ',
	          min: 'mín: ',
	          max: 'màx: '
	        },
	        pinning: {
	          pinLeft: "Fixar a l'Esquerra",
	          pinRight: 'Fixar a la Dreta',
	          unpin: 'Treure Fixació'
	        },
	        columnMenu: {
	          close: 'Tanca'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Menú de Quadrícula'
	          },
	          columns: 'Columnes:',
	          importerTitle: 'Importa el fitxer',
	          exporterAllAsCsv: 'Exporta tot com CSV',
	          exporterVisibleAsCsv: 'Exporta les dades visibles com a CSV',
	          exporterSelectedAsCsv: 'Exporta les dades seleccionades com a CSV',
	          exporterAllAsPdf: 'Exporta tot com PDF',
	          exporterVisibleAsPdf: 'Exporta les dades visibles com a PDF',
	          exporterSelectedAsPdf: 'Exporta les dades seleccionades com a PDF',
	          exporterAllAsExcel: 'Exporta tot com Excel',
	          exporterVisibleAsExcel: 'Exporta les dades visibles com Excel',
	          exporterSelectedAsExcel: 'Exporta les dades seleccionades com Excel',
	          clearAllFilters: 'Netejar tots els filtres'
	        },
	        importer: {
	          noHeaders: "No va ser possible derivar els noms de les columnes, té encapçalats l'arxiu?",
	          noObjects: "No va ser possible obtenir registres, conté dades l'arxiu, a part de les capçaleres?",
	          invalidCsv: "No va ser possible processar l'arxiu, ¿és un CSV vàlid?",
	          invalidJson: "No va ser possible processar l'arxiu, ¿és un JSON vàlid?",
	          jsonNotArray: 'El fitxer json importat ha de contenir una matriu, avortant.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Page to first',
	            pageBack: 'Page back',
	            pageSelected: 'Selected page',
	            pageForward: 'Page forward',
	            pageToLast: 'Page to last'
	          },
	          sizes: 'ítems per pàgina',
	          totalItems: 'ítems',
	          through: 'a',
	          of: 'de'
	        },
	        grouping: {
	          group: 'Agrupar',
	          ungroup: 'Desagrupar',
	          aggregate_count: 'Agr: Compte',
	          aggregate_sum: 'Agr: Sum',
	          aggregate_max: 'Agr: Máx',
	          aggregate_min: 'Agr: Mín',
	          aggregate_avg: 'Agr: Mitjà',
	          aggregate_remove: 'Agr: Treure'
	        },
	        validate: {
	          error: 'Error:',
	          minLength: 'El valor ha de tenir almenys caràcters THRESHOLD.',
	          maxLength: 'El valor ha de tenir com a màxim caràcters THRESHOLD.',
	          required: 'Un valor és necessari.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('es', {
	        aggregate: {
	          label: 'Artículos'
	        },
	        groupPanel: {
	          description: 'Arrastre un encabezado de columna aquí y suéltelo para agrupar por esa columna.'
	        },
	        search: {
	          placeholder: 'Buscar...',
	          showingItems: 'Artículos Mostrados:',
	          selectedItems: 'Artículos Seleccionados:',
	          totalItems: 'Artículos Totales:',
	          size: 'Tamaño de Página:',
	          first: 'Primera Página',
	          next: 'Página Siguiente',
	          previous: 'Página Anterior',
	          last: 'Última Página'
	        },
	        selection: {
	          aria: {
	            row: 'Fila'
	          },
	          selectAll: 'Seleccionar Todo',
	          displayName: 'Seleccionar Fila'
	        },
	        menu: {
	          text: 'Elegir columnas:'
	        },
	        sort: {
	          ascending: 'Orden Ascendente',
	          descending: 'Orden Descendente',
	          remove: 'Sin Ordenar'
	        },
	        column: {
	          hide: 'Ocultar la columna'
	        },
	        aggregation: {
	          count: 'filas totales: ',
	          sum: 'total: ',
	          avg: 'media: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Fijar a la Izquierda',
	          pinRight: 'Fijar a la Derecha',
	          unpin: 'Quitar Fijación'
	        },
	        gridMenu: {
	          columns: 'Columnas:',
	          importerTitle: 'Importar archivo',
	          exporterAllAsCsv: 'Exportar todo como csv',
	          exporterVisibleAsCsv: 'Exportar vista como csv',
	          exporterSelectedAsCsv: 'Exportar selección como csv',
	          exporterAllAsPdf: 'Exportar todo como pdf',
	          exporterVisibleAsPdf: 'Exportar vista como pdf',
	          exporterSelectedAsPdf: 'Exportar selección como pdf',
	          exporterAllAsExcel: 'Exportar todo como excel',
	          exporterVisibleAsExcel: 'Exportar vista como excel',
	          exporterSelectedAsExcel: 'Exportar selección como excel',
	          clearAllFilters: 'Limpiar todos los filtros'
	        },
	        importer: {
	          noHeaders: 'No fue posible derivar los nombres de las columnas, ¿tiene encabezados el archivo?',
	          noObjects: 'No fue posible obtener registros, ¿contiene datos el archivo, aparte de los encabezados?',
	          invalidCsv: 'No fue posible procesar el archivo, ¿es un CSV válido?',
	          invalidJson: 'No fue posible procesar el archivo, ¿es un Json válido?',
	          jsonNotArray: 'El archivo json importado debe contener un array, abortando.'
	        },
	        pagination: {
	          aria: {
											pageToFirst: 'Página para primero',
											pageBack: 'Página atrás',
											pageSelected: 'Página seleccionada',
											pageForward: 'Avance de página',
											pageToLast: 'Página para durar'
										},
	          through: 'mediante',
	          sizes: 'registros por página',
	          totalItems: 'registros',
	          of: 'de'
	        },
	        grouping: {
	          group: 'Agrupar',
	          ungroup: 'Desagrupar',
	          aggregate_count: 'Agr: Cont',
	          aggregate_sum: 'Agr: Sum',
	          aggregate_max: 'Agr: Máx',
	          aggregate_min: 'Agr: Min',
	          aggregate_avg: 'Agr: Prom',
	          aggregate_remove: 'Agr: Quitar'
	        }
	      });
	      return $delegate;
	    }]);
	}]);
	})();
	
	/**
	 * Translated by: R. Salarmehr
	 *                M. Hosseynzade
	 *                Using Vajje.com online dictionary.
	 */
	(function () {
	  angular.module('ui.grid').config(['$provide', function ($provide) {
	    $provide.decorator('i18nService', ['$delegate', function ($delegate) {
	      $delegate.add('fa', {
	        aggregate: {
	          label: 'قلم'
	        },
	        groupPanel: {
	          description: 'عنوان یک ستون را بگیر و به گروهی از آن ستون رها کن.'
	        },
	        search: {
	          placeholder: 'جستجو...',
	          showingItems: 'نمایش اقلام:',
	          selectedItems: 'قلم\u200cهای انتخاب شده:',
	          totalItems: 'مجموع اقلام:',
	          size: 'اندازه\u200cی صفحه:',
	          first: 'اولین صفحه',
	          next: 'صفحه\u200cی\u200cبعدی',
	          previous: 'صفحه\u200cی\u200c قبلی',
	          last: 'آخرین صفحه'
	        },
	        menu: {
	          text: 'ستون\u200cهای انتخابی:'
	        },
	        sort: {
	          ascending: 'ترتیب صعودی',
	          descending: 'ترتیب نزولی',
	          remove: 'حذف مرتب کردن'
	        },
	        column: {
	          hide: 'پنهان\u200cکردن ستون'
	        },
	        aggregation: {
	          count: 'تعداد: ',
	          sum: 'مجموع: ',
	          avg: 'میانگین: ',
	          min: 'کمترین: ',
	          max: 'بیشترین: '
	        },
	        pinning: {
	          pinLeft: 'پین کردن سمت چپ',
	          pinRight: 'پین کردن سمت راست',
	          unpin: 'حذف پین'
	        },
	        gridMenu: {
	          columns: 'ستون\u200cها:',
	          importerTitle: 'وارد کردن فایل',
	          exporterAllAsCsv: 'خروجی تمام داده\u200cها در فایل csv',
	          exporterVisibleAsCsv: 'خروجی داده\u200cهای قابل مشاهده در فایل csv',
	          exporterSelectedAsCsv: 'خروجی داده\u200cهای انتخاب\u200cشده در فایل csv',
	          exporterAllAsPdf: 'خروجی تمام داده\u200cها در فایل pdf',
	          exporterVisibleAsPdf: 'خروجی داده\u200cهای قابل مشاهده در فایل pdf',
	          exporterSelectedAsPdf: 'خروجی داده\u200cهای انتخاب\u200cشده در فایل pdf',
	          clearAllFilters: 'پاک کردن تمام فیلتر'
	        },
	        importer: {
	          noHeaders: 'نام ستون قابل استخراج نیست. آیا فایل عنوان دارد؟',
	          noObjects: 'اشیا قابل استخراج نیستند. آیا به جز عنوان\u200cها در فایل داده وجود دارد؟',
	          invalidCsv: 'فایل قابل پردازش نیست. آیا فرمت  csv  معتبر است؟',
	          invalidJson: 'فایل قابل پردازش نیست. آیا فرمت json   معتبر است؟',
	          jsonNotArray: 'فایل json وارد شده باید حاوی آرایه باشد. عملیات ساقط شد.'
	        },
	        pagination: {
	          sizes: 'اقلام در هر صفحه',
	          totalItems: 'اقلام',
	          of: 'از'
	        },
	        grouping: {
	          group: 'گروه\u200cبندی',
	          ungroup: 'حذف گروه\u200cبندی',
	          aggregate_count: 'Agg: تعداد',
	          aggregate_sum: 'Agg: جمع',
	          aggregate_max: 'Agg: بیشینه',
	          aggregate_min: 'Agg: کمینه',
	          aggregate_avg: 'Agg: میانگین',
	          aggregate_remove: 'Agg: حذف'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('fi', {
	        aggregate: {
	          label: 'rivit'
	        },
	        groupPanel: {
	          description: 'Raahaa ja pudota otsikko tähän ryhmittääksesi sarakkeen mukaan.'
	        },
	        search: {
	          placeholder: 'Hae...',
	          showingItems: 'Näytetään rivejä:',
	          selectedItems: 'Valitut rivit:',
	          totalItems: 'Rivejä yht.:',
	          size: 'Näytä:',
	          first: 'Ensimmäinen sivu',
	          next: 'Seuraava sivu',
	          previous: 'Edellinen sivu',
	          last: 'Viimeinen sivu'
	        },
	        menu: {
	          text: 'Valitse sarakkeet:'
	        },
	        sort: {
	          ascending: 'Järjestä nouseva',
	          descending: 'Järjestä laskeva',
	          remove: 'Poista järjestys'
	        },
	        column: {
	          hide: 'Piilota sarake'
	        },
	        aggregation: {
	          count: 'Rivejä yht.: ',
	          sum: 'Summa: ',
	          avg: 'K.a.: ',
	          min: 'Min: ',
	          max: 'Max: '
	        },
	        pinning: {
	         pinLeft: 'Lukitse vasemmalle',
	          pinRight: 'Lukitse oikealle',
	          unpin: 'Poista lukitus'
	        },
	        gridMenu: {
	          columns: 'Sarakkeet:',
	          importerTitle: 'Tuo tiedosto',
	          exporterAllAsCsv: 'Vie tiedot csv-muodossa',
	          exporterVisibleAsCsv: 'Vie näkyvä tieto csv-muodossa',
	          exporterSelectedAsCsv: 'Vie valittu tieto csv-muodossa',
	          exporterAllAsPdf: 'Vie tiedot pdf-muodossa',
	          exporterVisibleAsPdf: 'Vie näkyvä tieto pdf-muodossa',
	          exporterSelectedAsPdf: 'Vie valittu tieto pdf-muodossa',
	          exporterAllAsExcel: 'Vie tiedot excel-muodossa',
	          exporterVisibleAsExcel: 'Vie näkyvä tieto excel-muodossa',
	          exporterSelectedAsExcel: 'Vie valittu tieto excel-muodossa',
	          clearAllFilters: 'Puhdista kaikki suodattimet'
	        },
	        importer: {
	          noHeaders: 'Sarakkeen nimiä ei voitu päätellä, onko tiedostossa otsikkoriviä?',
	          noObjects: 'Tietoja ei voitu lukea, onko tiedostossa muuta kuin otsikkot?',
	          invalidCsv: 'Tiedostoa ei voitu käsitellä, oliko se CSV-muodossa?',
	          invalidJson: 'Tiedostoa ei voitu käsitellä, oliko se JSON-muodossa?',
	          jsonNotArray: 'Tiedosto ei sisältänyt taulukkoa, lopetetaan.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('fr', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtre de la colonne',
	            removeFilter: 'Supprimer le filtre',
	            columnMenuButtonLabel: 'Menu de la colonne'
	          },
	          priority: 'Priorité:',
	          filterLabel: "Filtre de la colonne: "
	        },
	        aggregate: {
	          label: 'éléments'
	        },
	        groupPanel: {
	          description: 'Faites glisser une en-tête de colonne ici pour créer un groupe de colonnes.'
	        },
	        search: {
	          placeholder: 'Recherche...',
	          showingItems: 'Affichage des éléments :',
	          selectedItems: 'Éléments sélectionnés :',
	          totalItems: 'Nombre total d\'éléments:',
	          size: 'Taille de page:',
	          first: 'Première page',
	          next: 'Page Suivante',
	          previous: 'Page précédente',
	          last: 'Dernière page'
	        },
	        selection: {
	          aria: {
	            row: 'Ligne'
	          },
	          selectAll: 'Tout Sélectionner',
	          displayName: 'Sélectionnez la ligne'
	        },
	        menu: {
	          text: 'Choisir des colonnes :'
	        },
	        sort: {
	          ascending: 'Trier par ordre croissant',
	          descending: 'Trier par ordre décroissant',
	          none: 'Aucun tri',
	          remove: 'Enlever le tri'
	        },
	        column: {
	          hide: 'Cacher la colonne'
	        },
	        aggregation: {
	          count: 'lignes totales: ',
	          sum: 'total: ',
	          avg: 'moy: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Épingler à gauche',
	          pinRight: 'Épingler à droite',
	          unpin: 'Détacher'
	        },
	        columnMenu: {
	          close: 'Fermer'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Menu du tableau'
	          },
	          columns: 'Colonnes:',
	          importerTitle: 'Importer un fichier',
	          exporterAllAsCsv: 'Exporter toutes les données en CSV',
	          exporterVisibleAsCsv: 'Exporter les données visibles en CSV',
	          exporterSelectedAsCsv: 'Exporter les données sélectionnées en CSV',
	          exporterAllAsPdf: 'Exporter toutes les données en PDF',
	          exporterVisibleAsPdf: 'Exporter les données visibles en PDF',
	          exporterSelectedAsPdf: 'Exporter les données sélectionnées en PDF',
	          exporterAllAsExcel: 'Exporter toutes les données en Excel',
	          exporterVisibleAsExcel: 'Exporter les données visibles en Excel',
	          exporterSelectedAsExcel: 'Exporter les données sélectionnées en Excel',
	          clearAllFilters: 'Nettoyez tous les filtres'
	        },
	        importer: {
	          noHeaders: 'Impossible de déterminer le nom des colonnes, le fichier possède-t-il une en-tête ?',
	          noObjects: 'Aucun objet trouvé, le fichier possède-t-il des données autres que l\'en-tête ?',
	          invalidCsv: 'Le fichier n\'a pas pu être traité, le CSV est-il valide ?',
	          invalidJson: 'Le fichier n\'a pas pu être traité, le JSON est-il valide ?',
	          jsonNotArray: 'Le fichier JSON importé doit contenir un tableau, abandon.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Aller à la première page',
	            pageBack: 'Page précédente',
	            pageSelected: 'Page sélectionnée',
	            pageForward: 'Page suivante',
	            pageToLast: 'Aller à la dernière page'
	          },
	          sizes: 'éléments par page',
	          totalItems: 'éléments',
	          through: 'à',
	          of: 'sur'
	        },
	        grouping: {
	          group: 'Grouper',
	          ungroup: 'Dégrouper',
	          aggregate_count: 'Agg: Compter',
	          aggregate_sum: 'Agg: Somme',
	          aggregate_max: 'Agg: Max',
	          aggregate_min: 'Agg: Min',
	          aggregate_avg: 'Agg: Moy',
	          aggregate_remove: 'Agg: Retirer'
	        },
	        validate: {
	          error: 'Erreur:',
	          minLength: 'La valeur doit être supérieure ou égale à THRESHOLD caractères.',
	          maxLength: 'La valeur doit être inférieure ou égale à THRESHOLD caractères.',
	          required: 'Une valeur est nécéssaire.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function ($provide) {
	    $provide.decorator('i18nService', ['$delegate', function ($delegate) {
	      $delegate.add('he', {
	        aggregate: {
	          label: 'items'
	        },
	        groupPanel: {
	          description: 'גרור עמודה לכאן ושחרר בכדי לקבץ עמודה זו.'
	        },
	        search: {
	          placeholder: 'חפש...',
	          showingItems: 'מציג:',
	          selectedItems: 'סה"כ נבחרו:',
	          totalItems: 'סה"כ רשומות:',
	          size: 'תוצאות בדף:',
	          first: 'דף ראשון',
	          next: 'דף הבא',
	          previous: 'דף קודם',
	          last: 'דף אחרון'
	        },
	        menu: {
	          text: 'בחר עמודות:'
	        },
	        sort: {
	          ascending: 'סדר עולה',
	          descending: 'סדר יורד',
	          remove: 'בטל'
	        },
	        column: {
	          hide: 'טור הסתר'
	        },
	        aggregation: {
	          count: 'total rows: ',
	          sum: 'total: ',
	          avg: 'avg: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        gridMenu: {
	          columns: 'Columns:',
	          importerTitle: 'Import file',
	          exporterAllAsCsv: 'Export all data as csv',
	          exporterVisibleAsCsv: 'Export visible data as csv',
	          exporterSelectedAsCsv: 'Export selected data as csv',
	          exporterAllAsPdf: 'Export all data as pdf',
	          exporterVisibleAsPdf: 'Export visible data as pdf',
	          exporterSelectedAsPdf: 'Export selected data as pdf',
	          exporterAllAsExcel: 'Export all data as excel',
	          exporterVisibleAsExcel: 'Export visible data as excel',
	          exporterSelectedAsExcel: 'Export selected data as excel',
	          clearAllFilters: 'Clean all filters'
	        },
	        importer: {
	          noHeaders: 'Column names were unable to be derived, does the file have a header?',
	          noObjects: 'Objects were not able to be derived, was there data in the file other than headers?',
	          invalidCsv: 'File was unable to be processed, is it valid CSV?',
	          invalidJson: 'File was unable to be processed, is it valid Json?',
	          jsonNotArray: 'Imported json file must contain an array, aborting.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('hy', {
	        aggregate: {
	          label: 'տվյալներ'
	        },
	        groupPanel: {
	          description: 'Ըստ սյան խմբավորելու համար քաշեք և գցեք վերնագիրն այստեղ։'
	        },
	        search: {
	          placeholder: 'Փնտրում...',
	          showingItems: 'Ցուցադրված տվյալներ՝',
	          selectedItems: 'Ընտրված:',
	          totalItems: 'Ընդամենը՝',
	          size: 'Տողերի քանակը էջում՝',
	          first: 'Առաջին էջ',
	          next: 'Հաջորդ էջ',
	          previous: 'Նախորդ էջ',
	          last: 'Վերջին էջ'
	        },
	        menu: {
	          text: 'Ընտրել սյուները:'
	        },
	        sort: {
	          ascending: 'Աճման կարգով',
	          descending: 'Նվազման կարգով',
	          remove: 'Հանել '
	        },
	        column: {
	          hide: 'Թաքցնել սյունը'
	        },
	        aggregation: {
	          count: 'ընդամենը տող՝ ',
	          sum: 'ընդամենը՝ ',
	          avg: 'միջին՝ ',
	          min: 'մին՝ ',
	          max: 'մաքս՝ '
	        },
	        pinning: {
	          pinLeft: 'Կպցնել ձախ կողմում',
	          pinRight: 'Կպցնել աջ կողմում',
	          unpin: 'Արձակել'
	        },
	        gridMenu: {
	          columns: 'Սյուներ:',
	          importerTitle: 'Ներմուծել ֆայլ',
	          exporterAllAsCsv: 'Արտահանել ամբողջը CSV',
	          exporterVisibleAsCsv: 'Արտահանել երևացող տվյալները CSV',
	          exporterSelectedAsCsv: 'Արտահանել ընտրված տվյալները CSV',
	          exporterAllAsPdf: 'Արտահանել PDF',
	          exporterVisibleAsPdf: 'Արտահանել երևացող տվյալները PDF',
	          exporterSelectedAsPdf: 'Արտահանել ընտրված տվյալները PDF',
	          exporterAllAsExcel: 'Արտահանել excel',
	          exporterVisibleAsExcel: 'Արտահանել երևացող տվյալները excel',
	          exporterSelectedAsExcel: 'Արտահանել ընտրված տվյալները excel',
	          clearAllFilters: 'Մաքրել բոլոր ֆիլտրերը'
	        },
	        importer: {
	          noHeaders: 'Հնարավոր չեղավ որոշել սյան վերնագրերը։ Արդյո՞ք ֆայլը ունի վերնագրեր։',
	          noObjects: 'Հնարավոր չեղավ կարդալ տվյալները։ Արդյո՞ք ֆայլում կան տվյալներ։',
	          invalidCsv: 'Հնարավոր չեղավ մշակել ֆայլը։ Արդյո՞ք այն վավեր CSV է։',
	          invalidJson: 'Հնարավոր չեղավ մշակել ֆայլը։ Արդյո՞ք այն վավեր Json է։',
	          jsonNotArray: 'Ներմուծված json ֆայլը պետք է պարունակի զանգված, կասեցվում է։'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('is', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Sía fyrir dálk',
	            removeFilter: 'Fjarlægja síu',
	            columnMenuButtonLabel: 'Dálkavalmynd'
	          },
	          priority: 'Forgangsröðun:',
	          filterLabel: "Sía fyrir dálka: "
	        },
	        aggregate: {
	          label: 'hlutir'
	        },
	        groupPanel: {
	          description: 'Dragðu dálkhaus hingað til að flokka saman eftir þeim dálki.'
	        },
	        search: {
	          placeholder: 'Leita...',
	          showingItems: 'Sýni hluti:',
	          selectedItems: 'Valdir hlutir:',
	          totalItems: 'Hlutir alls:',
	          size: 'Stærð síðu:',
	          first: 'Fyrsta síða',
	          next: 'Næsta síða',
	          previous: 'Fyrri síða',
	          last: 'Síðasta síða'
	        },
	        menu: {
	          text: 'Veldu dálka:'
	        },
	        sort: {
	          ascending: 'Raða hækkandi',
	          descending: 'Raða lækkandi',
	          none: 'Engin röðun',
	          remove: 'Fjarlægja röðun'
	        },
	        column: {
	          hide: 'Fela dálk'
	        },
	        aggregation: {
	          count: 'fjöldi raða: ',
	          sum: 'summa: ',
	          avg: 'meðaltal: ',
	          min: 'lágmark: ',
	          max: 'hámark: '
	        },
	        pinning: {
	          pinLeft: 'Festa til vinstri',
	          pinRight: 'Festa til hægri',
	          unpin: 'Losa'
	        },
	        columnMenu: {
	          close: 'Loka'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Töflu valmynd'
	          },
	          columns: 'Dálkar:',
	          importerTitle: 'Flytja inn skjal',
	          exporterAllAsCsv: 'Flytja út gögn sem csv',
	          exporterVisibleAsCsv: 'Flytja út sýnileg gögn sem csv',
	          exporterSelectedAsCsv: 'Flytja út valin gögn sem csv',
	          exporterAllAsPdf: 'Flytja út öll gögn sem pdf',
	          exporterVisibleAsPdf: 'Flytja út sýnileg gögn sem pdf',
	          exporterSelectedAsPdf: 'Flytja út valin gögn sem pdf',
	          clearAllFilters: 'Hreinsa allar síur'
	        },
	        importer: {
	          noHeaders: 'Ekki hægt að vinna dálkanöfn úr skjalinu, er skjalið örugglega með haus?',
	          noObjects: 'Ekki hægt að vinna hluti úr skjalinu, voru örugglega gögn í skjalinu önnur en hausinn?',
	          invalidCsv: 'Tókst ekki að vinna skjal, er það örggulega gilt CSV?',
	          invalidJson: 'Tókst ekki að vinna skjal, er það örugglega gilt Json?',
	          jsonNotArray: 'Innflutt json skjal verður að innihalda fylki, hætti við.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Fletta að fyrstu',
	            pageBack: 'Fletta til baka',
	            pageSelected: 'Valin síða',
	            pageForward: 'Fletta áfram',
	            pageToLast: 'Fletta að síðustu'
	          },
	          sizes: 'hlutir á síðu',
	          totalItems: 'hlutir',
	          through: 'gegnum',
	          of: 'af'
	        },
	        grouping: {
	          group: 'Flokka',
	          ungroup: 'Sundurliða',
	          aggregate_count: 'Fjöldi: ',
	          aggregate_sum: 'Summa: ',
	          aggregate_max: 'Hámark: ',
	          aggregate_min: 'Lágmark: ',
	          aggregate_avg: 'Meðaltal: ',
	          aggregate_remove: 'Fjarlægja: '
	        },
	        validate: {
	          error: 'Villa:',
	          minLength: 'Gildi ætti að vera a.m.k. THRESHOLD stafa langt.',
	          maxLength: 'Gildi ætti að vera í mesta lagi THRESHOLD stafa langt.',
	          required: 'Þarf að hafa gildi.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('it', {
	        aggregate: {
	          label: 'elementi'
	        },
	        groupPanel: {
	          description: 'Trascina un\'intestazione all\'interno del gruppo della colonna.'
	        },
	        search: {
	          placeholder: 'Ricerca...',
	          showingItems: 'Mostra:',
	          selectedItems: 'Selezionati:',
	          totalItems: 'Totali:',
	          size: 'Tot Pagine:',
	          first: 'Prima',
	          next: 'Prossima',
	          previous: 'Precedente',
	          last: 'Ultima'
	        },
	        selection: {
	          aria: {
	            row: 'Riga'
	          },
	          selectAll: 'Seleccionar Todo',
	          displayName: 'Seleziona Riga'
	        },
	        menu: {
	          text: 'Scegli le colonne:'
	        },
	        sort: {
	          ascending: 'Asc.',
	          descending: 'Desc.',
	          remove: 'Annulla ordinamento'
	        },
	        column: {
	          hide: 'Nascondi'
	        },
	        aggregation: {
	          count: 'righe totali: ',
	          sum: 'tot: ',
	          avg: 'media: ',
	          min: 'minimo: ',
	          max: 'massimo: '
	        },
	        pinning: {
	         pinLeft: 'Blocca a sx',
	          pinRight: 'Blocca a dx',
	          unpin: 'Blocca in alto'
	        },
	        gridMenu: {
	          columns: 'Colonne:',
	          importerTitle: 'Importa',
	          exporterAllAsCsv: 'Esporta tutti i dati in CSV',
	          exporterVisibleAsCsv: 'Esporta i dati visibili in CSV',
	          exporterSelectedAsCsv: 'Esporta i dati selezionati in CSV',
	          exporterAllAsPdf: 'Esporta tutti i dati in PDF',
	          exporterVisibleAsPdf: 'Esporta i dati visibili in PDF',
	          exporterSelectedAsPdf: 'Esporta i dati selezionati in PDF',
	          exporterAllAsExcel: 'Esporta tutti i dati in excel',
	          exporterVisibleAsExcel: 'Esporta i dati visibili in excel',
	          exporterSelectedAsExcel: 'Esporta i dati selezionati in excel',
	          clearAllFilters: 'Pulire tutti i filtri'
	        },
	        importer: {
	          noHeaders: 'Impossibile reperire i nomi delle colonne, sicuro che siano indicati all\'interno del file?',
	          noObjects: 'Impossibile reperire gli oggetti, sicuro che siano indicati all\'interno del file?',
	          invalidCsv: 'Impossibile elaborare il file, sicuro che sia un CSV?',
	          invalidJson: 'Impossibile elaborare il file, sicuro che sia un JSON valido?',
	          jsonNotArray: 'Errore! Il file JSON da importare deve contenere un array.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Prima',
	            pageBack: 'Indietro',
	            pageSelected: 'Pagina selezionata',
	            pageForward: 'Avanti',
	            pageToLast: 'Ultima'
	          },
	          sizes: 'elementi per pagina',
	          totalItems: 'elementi',
	          through: 'a',
	          of: 'di'
	        },
	        grouping: {
	          group: 'Raggruppa',
	          ungroup: 'Separa',
	          aggregate_count: 'Agg: N. Elem.',
	          aggregate_sum: 'Agg: Somma',
	          aggregate_max: 'Agg: Massimo',
	          aggregate_min: 'Agg: Minimo',
	          aggregate_avg: 'Agg: Media',
	          aggregate_remove: 'Agg: Rimuovi'
	        },
	        validate: {
	          error: 'Errore:',
	          minLength: 'Lunghezza minima pari a THRESHOLD caratteri.',
	          maxLength: 'Lunghezza massima pari a THRESHOLD caratteri.',
	          required: 'Necessario inserire un valore.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ja', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: '列のフィルター',
	            removeFilter: 'フィルターの解除',
	            columnMenuButtonLabel: '列のメニュー'
	          },
	          priority: '優先度:',
	          filterLabel: "列フィルター: "
	        },
	        aggregate: {
	          label: '項目'
	        },
	        groupPanel: {
	          description: 'ここに列ヘッダをドラッグアンドドロップして、その列でグループ化します。'
	        },
	        search: {
	          placeholder: '検索...',
	          showingItems: '表示中の項目:',
	          selectedItems: '選択した項目:',
	          totalItems: '項目の総数:',
	          size: 'ページサイズ:',
	          first: '最初のページ',
	          next: '次のページ',
	          previous: '前のページ',
	          last: '前のページ'
	        },
	        menu: {
	          text: '列の選択:'
	        },
	        sort: {
	          ascending: '昇順に並べ替え',
	          descending: '降順に並べ替え',
	          none: '並べ替え無し',
	          remove: '並べ替えの解除'
	        },
	        column: {
	          hide: '列の非表示'
	        },
	        aggregation: {
	          count: '行数: ',
	          sum: '合計: ',
	          avg: '平均: ',
	          min: '最小: ',
	          max: '最大: '
	        },
	        pinning: {
	          pinLeft: '左に固定',
	          pinRight: '右に固定',
	          unpin: '固定解除'
	        },
	        columnMenu: {
	          close: '閉じる'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'グリッドメニュー'
	          },
	          columns: '列の表示/非表示:',
	          importerTitle: 'ファイルのインポート',
	          exporterAllAsCsv: 'すべてのデータをCSV形式でエクスポート',
	          exporterVisibleAsCsv: '表示中のデータをCSV形式でエクスポート',
	          exporterSelectedAsCsv: '選択したデータをCSV形式でエクスポート',
	          exporterAllAsPdf: 'すべてのデータをPDF形式でエクスポート',
	          exporterVisibleAsPdf: '表示中のデータをPDF形式でエクスポート',
	          exporterSelectedAsPdf: '選択したデータをPDF形式でエクスポート',
	          clearAllFilters: 'すべてのフィルタをクリア'
	        },
	        importer: {
	          noHeaders: '列名を取得できません。ファイルにヘッダが含まれていることを確認してください。',
	          noObjects: 'オブジェクトを取得できません。ファイルにヘッダ以外のデータが含まれていることを確認してください。',
	          invalidCsv: 'ファイルを処理できません。ファイルが有効なCSV形式であることを確認してください。',
	          invalidJson: 'ファイルを処理できません。ファイルが有効なJSON形式であることを確認してください。',
	          jsonNotArray: 'インポートしたJSONファイルには配列が含まれている必要があります。処理を中止します。'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: '最初のページ',
	            pageBack: '前のページ',
	            pageSelected: '現在のページ',
	            pageForward: '次のページ',
	            pageToLast: '最後のページ'
	          },
	          sizes: '件/ページ',
	          totalItems: '件',
	          through: 'から',
	          of: '件/全'
	        },
	        grouping: {
	          group: 'グループ化',
	          ungroup: 'グループ化の解除',
	          aggregate_count: '集計表示: 行数',
	          aggregate_sum: '集計表示: 合計',
	          aggregate_max: '集計表示: 最大',
	          aggregate_min: '集計表示: 最小',
	          aggregate_avg: '集計表示: 平均',
	          aggregate_remove: '集計表示: 解除'
	        },
	        validate: {
	          error: 'Error:',
	          minLength: 'THRESHOLD 文字以上で入力してください。',
	          maxLength: 'THRESHOLD 文字以下で入力してください。',
	          required: '値が必要です。'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ko', {
	        aggregate: {
	          label: '아이템'
	        },
	        groupPanel: {
	          description: '컬럼으로 그룹핑하기 위해서는 컬럼 헤더를 끌어 떨어뜨려 주세요.'
	        },
	        search: {
	          placeholder: '검색...',
	          showingItems: '항목 보여주기:',
	          selectedItems: '선택 항목:',
	          totalItems: '전체 항목:',
	          size: '페이지 크기:',
	          first: '첫번째 페이지',
	          next: '다음 페이지',
	          previous: '이전 페이지',
	          last: '마지막 페이지'
	        },
	        menu: {
	          text: '컬럼을 선택하세요:'
	        },
	        sort: {
	          ascending: '오름차순 정렬',
	          descending: '내림차순 정렬',
	          remove: '소팅 제거'
	        },
	        column: {
	          hide: '컬럼 제거'
	        },
	        aggregation: {
	          count: '전체 갯수: ',
	          sum: '전체: ',
	          avg: '평균: ',
	          min: '최소: ',
	          max: '최대: '
	        },
	        pinning: {
	         pinLeft: '왼쪽 핀',
	          pinRight: '오른쪽 핀',
	          unpin: '핀 제거'
	        },
	        gridMenu: {
	          columns: '컬럼:',
	          importerTitle: '파일 가져오기',
	          exporterAllAsCsv: 'csv로 모든 데이터 내보내기',
	          exporterVisibleAsCsv: 'csv로 보이는 데이터 내보내기',
	          exporterSelectedAsCsv: 'csv로 선택된 데이터 내보내기',
	          exporterAllAsPdf: 'pdf로 모든 데이터 내보내기',
	          exporterVisibleAsPdf: 'pdf로 보이는 데이터 내보내기',
	          exporterSelectedAsPdf: 'pdf로 선택 데이터 내보내기',
	          clearAllFilters: '모든 필터를 청소'
	        },
	        importer: {
	          noHeaders: '컬럼명이 지정되어 있지 않습니다. 파일에 헤더가 명시되어 있는지 확인해 주세요.',
	          noObjects: '데이터가 지정되어 있지 않습니다. 데이터가 파일에 있는지 확인해 주세요.',
	          invalidCsv: '파일을 처리할 수 없습니다. 올바른 csv인지 확인해 주세요.',
	          invalidJson: '파일을 처리할 수 없습니다. 올바른 json인지 확인해 주세요.',
	          jsonNotArray: 'json 파일은 배열을 포함해야 합니다.'
	        },
	        pagination: {
	          sizes: '페이지당 항목',
	          totalItems: '전체 항목'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('nl', {
	        aggregate: {
	          label: 'items'
	        },
	        groupPanel: {
	          description: 'Sleep hier een kolomnaam heen om op te groeperen.'
	        },
	        search: {
	          placeholder: 'Zoeken...',
	          showingItems: 'Getoonde items:',
	          selectedItems: 'Geselecteerde items:',
	          totalItems: 'Totaal aantal items:',
	          size: 'Items per pagina:',
	          first: 'Eerste pagina',
	          next: 'Volgende pagina',
	          previous: 'Vorige pagina',
	          last: 'Laatste pagina'
	        },
	        menu: {
	          text: 'Kies kolommen:'
	        },
	        sort: {
	          ascending: 'Sorteer oplopend',
	          descending: 'Sorteer aflopend',
	          remove: 'Verwijder sortering'
	        },
	        column: {
	          hide: 'Verberg kolom'
	        },
	        aggregation: {
	          count: 'Aantal rijen: ',
	          sum: 'Som: ',
	          avg: 'Gemiddelde: ',
	          min: 'Min: ',
	          max: 'Max: '
	        },
	        pinning: {
	          pinLeft: 'Zet links vast',
	          pinRight: 'Zet rechts vast',
	          unpin: 'Maak los'
	        },
	        gridMenu: {
	          columns: 'Kolommen:',
	          importerTitle: 'Importeer bestand',
	          exporterAllAsCsv: 'Exporteer alle data als csv',
	          exporterVisibleAsCsv: 'Exporteer zichtbare data als csv',
	          exporterSelectedAsCsv: 'Exporteer geselecteerde data als csv',
	          exporterAllAsPdf: 'Exporteer alle data als pdf',
	          exporterVisibleAsPdf: 'Exporteer zichtbare data als pdf',
	          exporterSelectedAsPdf: 'Exporteer geselecteerde data als pdf',
	          exporterAllAsExcel: 'Exporteer alle data als excel',
	          exporterVisibleAsExcel: 'Exporteer zichtbare data als excel',
	          exporterSelectedAsExcel: 'Exporteer alle data als excel',
	          clearAllFilters: 'Alle filters wissen'
	        },
	        importer: {
	          noHeaders: 'Kolomnamen kunnen niet worden afgeleid. Heeft het bestand een header?',
	          noObjects: 'Objecten kunnen niet worden afgeleid. Bevat het bestand data naast de headers?',
	          invalidCsv: 'Het bestand kan niet verwerkt worden. Is het een valide csv bestand?',
	          invalidJson: 'Het bestand kan niet verwerkt worden. Is het valide json?',
	          jsonNotArray: 'Het json bestand moet een array bevatten. De actie wordt geannuleerd.'
	        },
	        pagination: {
	            sizes: 'items per pagina',
	            totalItems: 'items',
	            of: 'van de'
	        },
	        grouping: {
	            group: 'Groepeer',
	            ungroup: 'Groepering opheffen',
	            aggregate_count: 'Agg: Aantal',
	            aggregate_sum: 'Agg: Som',
	            aggregate_max: 'Agg: Max',
	            aggregate_min: 'Agg: Min',
	            aggregate_avg: 'Agg: Gem',
	            aggregate_remove: 'Agg: Verwijder'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('no', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filter for kolonne',
	            removeFilter: 'Fjern filter',
	            columnMenuButtonLabel: 'Kolonnemeny'
	          },
	          priority: 'Prioritet:',
	          filterLabel: "Filter for kolonne: "
	        },
	        aggregate: {
	          label: 'elementer'
	        },
	        groupPanel: {
	          description: 'Trekk en kolonneoverskrift hit og slipp den for å gruppere etter den kolonnen.'
	        },
	        search: {
	          placeholder: 'Søk...',
	          showingItems: 'Viste elementer:',
	          selectedItems: 'Valgte elementer:',
	          totalItems: 'Antall elementer:',
	          size: 'Sidestørrelse:',
	          first: 'Første side',
	          next: 'Neste side',
	          previous: 'Forrige side',
	          last: 'Siste side'
	        },
	        menu: {
	          text: 'Velg kolonner:'
	        },
	        sort: {
	          ascending: 'Sortere stigende',
	          descending: 'Sortere fallende',
	          none: 'Ingen sortering',
	          remove: 'Fjern sortering'
	        },
	        column: {
	          hide: 'Skjul kolonne'
	        },
	        aggregation: {
	          count: 'antall rader: ',
	          sum: 'total: ',
	          avg: 'gjennomsnitt: ',
	          min: 'minimum: ',
	          max: 'maksimum: '
	        },
	        pinning: {
	          pinLeft: 'Fest til venstre',
	          pinRight: 'Fest til høyre',
	          unpin: 'Løsne'
	        },
	        columnMenu: {
	          close: 'Lukk'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Grid Menu'
	          },
	          columns: 'Kolonner:',
	          importerTitle: 'Importer fil',
	          exporterAllAsCsv: 'Eksporter alle data som csv',
	          exporterVisibleAsCsv: 'Eksporter synlige data som csv',
	          exporterSelectedAsCsv: 'Eksporter utvalgte data som csv',
	          exporterAllAsPdf: 'Eksporter alle data som pdf',
	          exporterVisibleAsPdf: 'Eksporter synlige data som pdf',
	          exporterSelectedAsPdf: 'Eksporter utvalgte data som pdf',
	          exporterAllAsExcel: 'Eksporter alle data som excel',
	          exporterVisibleAsExcel: 'Eksporter synlige data som excel',
	          exporterSelectedAsExcel: 'Eksporter utvalgte data som excel',
	          clearAllFilters: 'Clear all filters'
	        },
	        importer: {
	          noHeaders: 'Kolonnenavn kunne ikke avledes. Har filen en overskrift?',
	          noObjects: 'Objekter kunne ikke avledes. Er der andre data i filen enn overskriften?',
	          invalidCsv: 'Filen kunne ikke behandles. Er den gyldig CSV?',
	          invalidJson: 'Filen kunne ikke behandles. Er den gyldig JSON?',
	          jsonNotArray: 'Importert JSON-fil må inneholde en liste. Avbryter.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Gå til første side',
	            pageBack: 'Gå til forrige side',
	            pageSelected: 'Valgte side',
	            pageForward: 'Gå til neste side',
	            pageToLast: 'Gå til siste side'
	          },
	          sizes: 'elementer per side',
	          totalItems: 'elementer',
	          through: 'til',
	          of: 'av'
	        },
	        grouping: {
	          group: 'Gruppere',
	          ungroup: 'Fjerne gruppering',
	          aggregate_count: 'Agr: Antall',
	          aggregate_sum: 'Agr: Sum',
	          aggregate_max: 'Agr: Maksimum',
	          aggregate_min: 'Agr: Minimum',
	          aggregate_avg: 'Agr: Gjennomsnitt',
	          aggregate_remove: 'Agr: Fjern'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('pl', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtr dla kolumny',
	            removeFilter: 'Usuń filtr',
	            columnMenuButtonLabel: 'Opcje kolumny',
	            column: 'Kolumna'
	          },
	          priority: 'Priorytet:',
	          filterLabel: "Filtr dla kolumny: "
	        },
	        aggregate: {
	          label: 'pozycji'
	        },
	        groupPanel: {
	          description: 'Przeciągnij nagłówek kolumny tutaj, aby pogrupować według niej.'
	        },
	        search: {
	          aria: {
	            selected: 'Wiersz zaznaczony',
	            notSelected: 'Wiersz niezaznaczony'
	          },
	          placeholder: 'Szukaj...',
	          showingItems: 'Widoczne pozycje:',
	          selectedItems: 'Zaznaczone pozycje:',
	          totalItems: 'Wszystkich pozycji:',
	          size: 'Rozmiar strony:',
	          first: 'Pierwsza strona',
	          next: 'Następna strona',
	          previous: 'Poprzednia strona',
	          last: 'Ostatnia strona'
	        },
	        menu: {
	          text: 'Wybierz kolumny:'
	        },
	        sort: {
	          ascending: 'Sortuj rosnąco',
	          descending: 'Sortuj malejąco',
	          none: 'Brak sortowania',
	          remove: 'Wyłącz sortowanie'
	        },
	        column: {
	          hide: 'Ukryj kolumnę'
	        },
	        aggregation: {
	          count: 'Razem pozycji: ',
	            sum: 'Razem: ',
	            avg: 'Średnia: ',
	            min: 'Min: ',
	            max: 'Max: '
	        },
	        pinning: {
	          pinLeft: 'Przypnij do lewej',
	          pinRight: 'Przypnij do prawej',
	          unpin: 'Odepnij'
	        },
	        columnMenu: {
	          close: 'Zamknij'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Opcje tabeli'
	          },
	          columns: 'Kolumny:',
	          importerTitle: 'Importuj plik',
	          exporterAllAsCsv: 'Eksportuj wszystkie dane do csv',
	          exporterVisibleAsCsv: 'Eksportuj widoczne dane do csv',
	          exporterSelectedAsCsv: 'Eksportuj zaznaczone dane do csv',
	          exporterAllAsPdf: 'Eksportuj wszystkie dane do pdf',
	          exporterVisibleAsPdf: 'Eksportuj widoczne dane do pdf',
	          exporterSelectedAsPdf: 'Eksportuj zaznaczone dane do pdf',
	          exporterAllAsExcel: 'Eksportuj wszystkie dane do excel',
	          exporterVisibleAsExcel: 'Eksportuj widoczne dane do excel',
	          exporterSelectedAsExcel: 'Eksportuj zaznaczone dane do excel',
	          clearAllFilters: 'Wyczyść filtry'
	        },
	        importer: {
	          noHeaders: 'Nie udało się wczytać nazw kolumn. Czy plik posiada nagłówek?',
	          noObjects: 'Nie udalo się wczytać pozycji. Czy plik zawiera dane?',
	          invalidCsv: 'Nie udało się przetworzyć pliku. Czy to prawidłowy plik CSV?',
	          invalidJson: 'Nie udało się przetworzyć pliku. Czy to prawidłowy plik JSON?',
	          jsonNotArray: 'Importowany plik JSON musi zawierać tablicę. Importowanie przerwane.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Pierwsza strona',
	            pageBack: 'Poprzednia strona',
	            pageSelected: 'Wybrana strona',
	            pageForward: 'Następna strona',
	            pageToLast: 'Ostatnia strona'
	          },
	          sizes: 'pozycji na stronę',
	          totalItems: 'pozycji',
	          through: 'do',
	          of: 'z'
	        },
	        grouping: {
	          group: 'Grupuj',
	          ungroup: 'Rozgrupuj',
	          aggregate_count: 'Zbiorczo: Razem',
	          aggregate_sum: 'Zbiorczo: Suma',
	          aggregate_max: 'Zbiorczo: Max',
	          aggregate_min: 'Zbiorczo: Min',
	          aggregate_avg: 'Zbiorczo: Średnia',
	          aggregate_remove: 'Zbiorczo: Usuń'
	        },
	        validate: {
	          error: 'Błąd:',
	          minLength: 'Wartość powinna składać się z co najmniej THRESHOLD znaków.',
	          maxLength: 'Wartość powinna składać się z przynajmniej THRESHOLD znaków.',
	          required: 'Wartość jest wymagana.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('pt-br', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtro por coluna',
	            removeFilter: 'Remover filtro',
	            columnMenuButtonLabel: 'Menu coluna',
	            column: 'Coluna'
	          },
	          priority: 'Prioridade:',
	          filterLabel: "Filtro por coluna: "
	        },
	        aggregate: {
	          label: 'itens'
	        },
	        groupPanel: {
	          description: 'Arraste e solte uma coluna aqui para agrupar por essa coluna'
	        },
	        search: {
	          aria: {
	            selected: 'Linha selecionada',
	            notSelected: 'Linha não está selecionada'
	          },
	          placeholder: 'Procurar...',
	          showingItems: 'Mostrando os Itens:',
	          selectedItems: 'Items Selecionados:',
	          totalItems: 'Total de Itens:',
	          size: 'Tamanho da Página:',
	          first: 'Primeira Página',
	          next: 'Próxima Página',
	          previous: 'Página Anterior',
	          last: 'Última Página'
	        },
	        selection: {
	          aria: {
	            row: 'Linha'
	          },
	          selectAll: 'Selecionar Tudo',
	          displayName: 'Caixa de Seleção da Linha'
	        },
	        menu: {
	          text: 'Selecione as colunas:'
	        },
	        sort: {
	          ascending: 'Ordenar Ascendente',
	          descending: 'Ordenar Descendente',
	          none: 'Nenhuma Ordem',
	          remove: 'Remover Ordenação'
	        },
	        column: {
	          hide: 'Esconder coluna'
	        },
	        aggregation: {
	          count: 'total de linhas: ',
	          sum: 'total: ',
	          avg: 'med: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Fixar Esquerda',
	          pinRight: 'Fixar Direita',
	          unpin: 'Desprender'
	        },
	        columnMenu: {
	          close: 'Fechar'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Menu Grid'
	          },
	          columns: 'Colunas:',
	          importerTitle: 'Importar arquivo',
	          exporterAllAsCsv: 'Exportar todos os dados como csv',
	          exporterVisibleAsCsv: 'Exportar dados visíveis como csv',
	          exporterSelectedAsCsv: 'Exportar dados selecionados como csv',
	          exporterAllAsPdf: 'Exportar todos os dados como pdf',
	          exporterVisibleAsPdf: 'Exportar dados visíveis como pdf',
	          exporterSelectedAsPdf: 'Exportar dados selecionados como pdf',
	          exporterAllAsExcel: 'Exportar todos os dados como excel',
	          exporterVisibleAsExcel: 'Exportar dados visíveis como excel',
	          exporterSelectedAsExcel: 'Exportar dados selecionados como excel',
	          clearAllFilters: 'Limpar todos os filtros'
	        },
	        importer: {
	          noHeaders: 'Nomes de colunas não puderam ser derivados. O arquivo tem um cabeçalho?',
	          noObjects: 'Objetos não puderam ser derivados. Havia dados no arquivo, além dos cabeçalhos?',
	          invalidCsv: 'Arquivo não pode ser processado. É um CSV válido?',
	          invalidJson: 'Arquivo não pode ser processado. É um Json válido?',
	          jsonNotArray: 'Arquivo json importado tem que conter um array. Abortando.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Primeira página',
	            pageBack: 'Página anterior',
	            pageSelected: 'Página Selecionada',
	            pageForward: 'Proxima',
	            pageToLast: 'Anterior'
	          },
	          sizes: 'itens por página',
	          totalItems: 'itens',
	          through: 'através dos',
	          of: 'de'
	        },
	        grouping: {
	          group: 'Agrupar',
	          ungroup: 'Desagrupar',
	          aggregate_count: 'Agr: Contar',
	          aggregate_sum: 'Agr: Soma',
	          aggregate_max: 'Agr: Max',
	          aggregate_min: 'Agr: Min',
	          aggregate_avg: 'Agr: Med',
	          aggregate_remove: 'Agr: Remover'
	        },
	        validate: {
	          error: 'Erro:',
	          minLength: 'O valor deve ter, no minimo, THRESHOLD caracteres.',
	          maxLength: 'O valor deve ter, no máximo, THRESHOLD caracteres.',
	          required: 'Um valor é necessário.'
	        }
	      });
	      return $delegate;
	    }]);
	}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('pt', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtro por coluna',
	            removeFilter: 'Remover filtro',
	            columnMenuButtonLabel: 'Menu coluna',
	            column: 'Coluna'
	          },
	          priority: 'Prioridade:',
	          filterLabel: "Filtro por coluna: "
	        },
	        aggregate: {
	          label: 'itens'
	        },
	        groupPanel: {
	          description: 'Arraste e solte uma coluna aqui para agrupar por essa coluna'
	        },
	        search: {
	          aria: {
	            selected: 'Linha selecionada',
	            notSelected: 'Linha não está selecionada'
	          },
	          placeholder: 'Procurar...',
	          showingItems: 'Mostrando os Itens:',
	          selectedItems: 'Itens Selecionados:',
	          totalItems: 'Total de Itens:',
	          size: 'Tamanho da Página:',
	          first: 'Primeira Página',
	          next: 'Próxima Página',
	          previous: 'Página Anterior',
	          last: 'Última Página'
	        },
	        selection: {
	          aria: {
	            row: 'Linha'
	          },
	          selectAll: 'Selecionar Tudo',
	          displayName: 'Caixa de Seleção da Linha'
	        },
	        menu: {
	          text: 'Selecione as colunas:'
	        },
	        sort: {
	          ascending: 'Ordenar Ascendente',
	          descending: 'Ordenar Descendente',
	          none: 'Nenhuma Ordem',
	          remove: 'Remover Ordenação'
	        },
	        column: {
	          hide: 'Esconder coluna'
	        },
	        aggregation: {
	          count: 'total de linhas: ',
	          sum: 'total: ',
	          avg: 'med: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Fixar Esquerda',
	          pinRight: 'Fixar Direita',
	          unpin: 'Desprender'
	        },
	        columnMenu: {
	          close: 'Fechar'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Menu Grid'
	          },
	          columns: 'Colunas:',
	          importerTitle: 'Importar ficheiro',
	          exporterAllAsCsv: 'Exportar todos os dados como csv',
	          exporterVisibleAsCsv: 'Exportar dados visíveis como csv',
	          exporterSelectedAsCsv: 'Exportar dados selecionados como csv',
	          exporterAllAsPdf: 'Exportar todos os dados como pdf',
	          exporterVisibleAsPdf: 'Exportar dados visíveis como pdf',
	          exporterSelectedAsPdf: 'Exportar dados selecionados como pdf',
	          exporterAllAsExcel: 'Exportar todos os dados como excel',
	          exporterVisibleAsExcel: 'Exportar dados visíveis como excel',
	          exporterSelectedAsExcel: 'Exportar dados selecionados como excel',
	          clearAllFilters: 'Limpar todos os filtros'
	        },
	        importer: {
	          noHeaders: 'Nomes de colunas não puderam ser derivados. O ficheiro tem um cabeçalho?',
	          noObjects: 'Objetos não puderam ser derivados. Havia dados no ficheiro, além dos cabeçalhos?',
	          invalidCsv: 'Ficheiro não pode ser processado. É um CSV válido?',
	          invalidJson: 'Ficheiro não pode ser processado. É um Json válido?',
	          jsonNotArray: 'Ficheiro json importado tem que conter um array. Interrompendo.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Primeira página',
	            pageBack: 'Página anterior',
	            pageSelected: 'Página Selecionada',
	            pageForward: 'Próxima',
	            pageToLast: 'Anterior'
	          },
	          sizes: 'itens por página',
	          totalItems: 'itens',
	          through: 'a',
	          of: 'de'
	        },
	        grouping: {
	          group: 'Agrupar',
	          ungroup: 'Desagrupar',
	          aggregate_count: 'Agr: Contar',
	          aggregate_sum: 'Agr: Soma',
	          aggregate_max: 'Agr: Max',
	          aggregate_min: 'Agr: Min',
	          aggregate_avg: 'Agr: Med',
	          aggregate_remove: 'Agr: Remover'
	        },
	        validate: {
	          error: 'Erro:',
	          minLength: 'O valor deve ter, no minimo, THRESHOLD caracteres.',
	          maxLength: 'O valor deve ter, no máximo, THRESHOLD caracteres.',
	          required: 'Um valor é necessário.'
	        }
	      });
	      return $delegate;
	    }]);
	}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ro', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtru pentru coloana',
	            removeFilter: 'Sterge filtru',
	            columnMenuButtonLabel: 'Column Menu'
	          },
	          priority: 'Prioritate:',
	          filterLabel: "Filtru pentru coloana:"
	        },
	        aggregate: {
	          label: 'Elemente'
	        },
	        groupPanel: {
	          description: 'Trage un cap de coloana aici pentru a grupa elementele dupa coloana respectiva'
	        },
	        search: {
	          placeholder: 'Cauta...',
	          showingItems: 'Arata elementele:',
	          selectedItems: 'Elementele selectate:',
	          totalItems: 'Total elemente:',
	          size: 'Marime pagina:',
	          first: 'Prima pagina',
	          next: 'Pagina urmatoare',
	          previous: 'Pagina anterioara',
	          last: 'Ultima pagina'
	        },
	        menu: {
	          text: 'Alege coloane:'
	        },
	        sort: {
	          ascending: 'Ordoneaza crescator',
	          descending: 'Ordoneaza descrescator',
	          none: 'Fara ordonare',
	          remove: 'Sterge ordonarea'
	        },
	        column: {
	          hide: 'Ascunde coloana'
	        },
	        aggregation: {
	          count: 'total linii: ',
	          sum: 'total: ',
	          avg: 'medie: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Pin la stanga',
	          pinRight: 'Pin la dreapta',
	          unpin: 'Sterge pinul'
	        },
	        columnMenu: {
	          close: 'Inchide'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Grid Menu'
	          },
	          columns: 'Coloane:',
	          importerTitle: 'Incarca fisier',
	          exporterAllAsCsv: 'Exporta toate datele ca csv',
	          exporterVisibleAsCsv: 'Exporta datele vizibile ca csv',
	          exporterSelectedAsCsv: 'Exporta datele selectate ca csv',
	          exporterAllAsPdf: 'Exporta toate datele ca pdf',
	          exporterVisibleAsPdf: 'Exporta datele vizibile ca pdf',
	          exporterSelectedAsPdf: 'Exporta datele selectate ca csv pdf',
	          clearAllFilters: 'Sterge toate filtrele'
	        },
	        importer: {
	          noHeaders: 'Numele coloanelor nu a putut fi incarcat, acest fisier are un header?',
	          noObjects: 'Datele nu au putut fi incarcate, exista date in fisier in afara numelor de coloane?',
	          invalidCsv: 'Fisierul nu a putut fi procesat, ati incarcat un CSV valid ?',
	          invalidJson: 'Fisierul nu a putut fi procesat, ati incarcat un Json valid?',
	          jsonNotArray: 'Json-ul incarcat trebuie sa contina un array, inchidere.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Prima pagina',
	            pageBack: 'O pagina inapoi',
	            pageSelected: 'Pagina selectata',
	            pageForward: 'O pagina inainte',
	            pageToLast: 'Ultima pagina'
	          },
	          sizes: 'Elemente per pagina',
	          totalItems: 'elemente',
	          through: 'prin',
	          of: 'of'
	        },
	        grouping: {
	          group: 'Grupeaza',
	          ungroup: 'Opreste gruparea',
	          aggregate_count: 'Agg: Count',
	          aggregate_sum: 'Agg: Sum',
	          aggregate_max: 'Agg: Max',
	          aggregate_min: 'Agg: Min',
	          aggregate_avg: 'Agg: Avg',
	          aggregate_remove: 'Agg: Remove'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
		angular.module('ui.grid').config(['$provide', function($provide) {
			$provide.decorator('i18nService', ['$delegate', function($delegate) {
				$delegate.add('rs-lat', {
					headerCell: {
						aria: {
							defaultFilterLabel: 'Filter za kolonu',
							removeFilter: 'Ukloni Filter',
							columnMenuButtonLabel: 'Meni Kolone',
							column: 'Kolona'
						},
						priority: 'Prioritet:',
						filterLabel: "Filter za kolonu: "
					},
					aggregate: {
						label: 'stavke'
					},
					groupPanel: {
						description: 'Ovde prevuci zaglavlje kolone i spusti do grupe pored te kolone.'
					},
					search: {
						aria: {
							selected: 'Red odabran',
							notSelected: 'Red nije odabran'
						},
						placeholder: 'Pretraga...',
						showingItems: 'Prikazane Stavke:',
						selectedItems: 'Odabrane Stavke:',
						totalItems: 'Ukupno Stavki:',
						size: 'Veličina Stranice:',
						first: 'Prva Stranica',
						next: 'Sledeća Stranica',
						previous: 'Prethodna Stranica',
						last: 'Poslednja Stranica'
					},
					menu: {
						text: 'Odaberite kolonu:'
					},
					sort: {
						ascending: 'Sortiraj po rastućem redosledu',
						descending: 'Sortiraj po opadajućem redosledu',
						none: 'Bez Sortiranja',
						remove: 'Ukloni Sortiranje'
					},
					column: {
						hide: 'Sakrij Kolonu'
					},
					aggregation: {
						count: 'ukupno redova: ',
						sum: 'ukupno: ',
						avg: 'prosecno: ',
						min: 'minimum: ',
						max: 'maksimum: '
					},
					pinning: {
						pinLeft: 'Zakači Levo',
						pinRight: 'Zakači Desno',
						unpin: 'Otkači'
					},
					columnMenu: {
						close: 'Zatvori'
					},
					gridMenu: {
						aria: {
							buttonLabel: 'Rešetkasti Meni'
						},
						columns: 'Kolone:',
						importerTitle: 'Importuj fajl',
						exporterAllAsCsv: 'Eksportuj sve podatke kao csv',
						exporterVisibleAsCsv: 'Eksportuj vidljive podatke kao csv',
						exporterSelectedAsCsv: 'Eksportuj obeležene podatke kao csv',
						exporterAllAsPdf: 'Eksportuj sve podatke kao pdf',
						exporterVisibleAsPdf: 'Eksportuj vidljive podake kao pdf',
						exporterSelectedAsPdf: 'Eksportuj odabrane podatke kao pdf',
						exporterAllAsExcel: 'Eksportuj sve podatke kao excel',
						exporterVisibleAsExcel: 'Eksportuj vidljive podatke kao excel',
						exporterSelectedAsExcel: 'Eksportuj odabrane podatke kao excel',
						clearAllFilters: 'Obriši sve filtere'
					},
					importer: {
						noHeaders: 'Kolone se nisu mogle podeliti, da li fajl poseduje heder?',
						noObjects: 'Objecti nisu mogli biti podeljeni, da li je bilo i drugih podataka sem hedera?',
						invalidCsv: 'Fajl nije bilo moguće procesirati, da li je ispravni CSV?',
						invalidJson: 'Fajl nije bilo moguće procesirati, da li je ispravni JSON',
						jsonNotArray: 'Importovani json fajl mora da sadrži niz, prekidam operaciju.'
					},
					pagination: {
						aria: {
							pageToFirst: 'Prva stranica',
							pageBack: 'Stranica pre',
							pageSelected: 'Odabrana stranica',
							pageForward: 'Sledeća stranica',
							pageToLast: 'Poslednja stranica'
						},
						sizes: 'stavki po stranici',
						totalItems: 'stavke',
						through: 'kroz',
						of: 'od'
					},
					grouping: {
						group: 'Grupiši',
						ungroup: 'Odrupiši',
						aggregate_count: 'Agg: Broj',
						aggregate_sum: 'Agg: Suma',
						aggregate_max: 'Agg: Maksimum',
						aggregate_min: 'Agg: Minimum',
						aggregate_avg: 'Agg: Prosečna',
						aggregate_remove: 'Agg: Ukloni'
					},
					validate: {
						error: 'Greška:',
						minLength: 'Vrednost bi trebala da bude duga bar THRESHOLD karaktera.',
						maxLength: 'Vrednost bi trebalo da bude najviše duga THRESHOLD karaktera.',
						required: 'Portreba je vrednost.'
					}
				});
				return $delegate;
			}]);
		}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ru', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Фильтр столбца',
	            removeFilter: 'Удалить фильтр',
	            columnMenuButtonLabel: 'Меню столбца'
	          },
	          priority: 'Приоритет:',
	          filterLabel: "Фильтр столбца: "
	        },
	        aggregate: {
	          label: 'элементы'
	        },
	        groupPanel: {
	          description: 'Для группировки по столбцу перетащите сюда его название.'
	        },
	        search: {
	          placeholder: 'Поиск...',
	          showingItems: 'Показать элементы:',
	          selectedItems: 'Выбранные элементы:',
	          totalItems: 'Всего элементов:',
	          size: 'Размер страницы:',
	          first: 'Первая страница',
	          next: 'Следующая страница',
	          previous: 'Предыдущая страница',
	          last: 'Последняя страница'
	        },
	        menu: {
	          text: 'Выбрать столбцы:'
	        },
	        sort: {
	          ascending: 'По возрастанию',
	          descending: 'По убыванию',
	          none: 'Без сортировки',
	          remove: 'Убрать сортировку'
	        },
	        column: {
	          hide: 'Спрятать столбец'
	        },
	        aggregation: {
	          count: 'всего строк: ',
	          sum: 'итого: ',
	          avg: 'среднее: ',
	          min: 'мин: ',
	          max: 'макс: '
	        },
					pinning: {
						pinLeft: 'Закрепить слева',
						pinRight: 'Закрепить справа',
						unpin: 'Открепить'
					},
	        columnMenu: {
	          close: 'Закрыть'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Меню'
	          },
	          columns: 'Столбцы:',
	          importerTitle: 'Импортировать файл',
	          exporterAllAsCsv: 'Экспортировать всё в CSV',
	          exporterVisibleAsCsv: 'Экспортировать видимые данные в CSV',
	          exporterSelectedAsCsv: 'Экспортировать выбранные данные в CSV',
	          exporterAllAsPdf: 'Экспортировать всё в PDF',
	          exporterVisibleAsPdf: 'Экспортировать видимые данные в PDF',
	          exporterSelectedAsPdf: 'Экспортировать выбранные данные в PDF',
	          exporterAllAsExcel: 'Экспортировать всё в Excel',
	          exporterVisibleAsExcel: 'Экспортировать видимые данные в Excel',
	          exporterSelectedAsExcel: 'Экспортировать выбранные данные в Excel',
	          clearAllFilters: 'Очистить все фильтры'
	        },
	        importer: {
	          noHeaders: 'Не удалось получить названия столбцов, есть ли в файле заголовок?',
	          noObjects: 'Не удалось получить данные, есть ли в файле строки кроме заголовка?',
	          invalidCsv: 'Не удалось обработать файл, это правильный CSV-файл?',
	          invalidJson: 'Не удалось обработать файл, это правильный JSON?',
	          jsonNotArray: 'Импортируемый JSON-файл должен содержать массив, операция отменена.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Первая страница',
	            pageBack: 'Предыдущая страница',
	            pageSelected: 'Выбранная страница',
	            pageForward: 'Следующая страница',
	            pageToLast: 'Последняя страница'
	          },
	          sizes: 'строк на страницу',
	          totalItems: 'строк',
	          through: 'по',
	          of: 'из'
	        },
	        grouping: {
	          group: 'Группировать',
	          ungroup: 'Разгруппировать',
	          aggregate_count: 'Группировать: Количество',
	          aggregate_sum: 'Для группы: Сумма',
	          aggregate_max: 'Для группы: Максимум',
	          aggregate_min: 'Для группы: Минимум',
	          aggregate_avg: 'Для группы: Среднее',
	          aggregate_remove: 'Для группы: Пусто'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
		angular.module('ui.grid').config(['$provide', function($provide) {
			$provide.decorator('i18nService', ['$delegate', function($delegate) {
				$delegate.add('sk', {
					headerCell: {
						aria: {
							defaultFilterLabel: 'Filter pre stĺpec',
							removeFilter: 'Odstrániť filter',
							columnMenuButtonLabel: 'Menu pre stĺpec',
							column: 'Stĺpec'
						},
						priority: 'Priorita:',
						filterLabel: "Filter pre stĺpec: "
					},
					aggregate: {
						label: 'položky'
					},
					groupPanel: {
						description: 'Pretiahni sem názov stĺpca pre zoskupenie podľa toho stĺpca.'
					},
					search: {
						aria: {
							selected: 'Označený riadok',
							notSelected: 'Neoznačený riadok'
						},
						placeholder: 'Hľadaj...',
						showingItems: 'Zobrazujem položky:',
						selectedItems: 'Vybraté položky:',
						totalItems: 'Počet položiek:',
						size: 'Počet:',
						first: 'Prvá strana',
						next: 'Ďalšia strana',
						previous: 'Predchádzajúca strana',
						last: 'Posledná strana'
					},
					menu: {
						text: 'Vyberte stĺpce:'
					},
					sort: {
						ascending: 'Zotriediť vzostupne',
						descending: 'Zotriediť zostupne',
						none: 'Nezotriediť',
						remove: 'Vymazať triedenie'
					},
					column: {
						hide: 'Skryť stĺpec'
					},
					aggregation: {
						count: 'počet riadkov: ',
						sum: 'spolu: ',
						avg: 'avg: ',
						min: 'min: ',
						max: 'max: '
					},
					pinning: {
						pinLeft: 'Pripnúť vľavo',
						pinRight: 'Pripnúť vpravo',
						unpin: 'Odopnúť'
					},
					columnMenu: {
						close: 'Zavrieť'
					},
					gridMenu: {
						aria: {
							buttonLabel: 'Grid Menu'
						},
						columns: 'Stĺpce:',
						importerTitle: 'Importovať súbor',
						exporterAllAsCsv: 'Exportovať všetky údaje ako CSV',
						exporterVisibleAsCsv: 'Exportovť viditeľné údaje ako CSV',
						exporterSelectedAsCsv: 'Exportovať označené údaje ako CSV',
						exporterAllAsPdf: 'Exportovať všetky údaje ako pdf',
						exporterVisibleAsPdf: 'Exportovať viditeľné údaje ako pdf',
						exporterSelectedAsPdf: 'Exportovať označené údaje ako pdf',
						exporterAllAsExcel: 'Exportovať všetky údaje ako excel',
						exporterVisibleAsExcel: 'Exportovať viditeľné údaje ako excel',
						exporterSelectedAsExcel: 'Exportovať označené údaje ako excel',
						clearAllFilters: 'Zrušiť všetky filtre'
					},
					importer: {
						noHeaders: 'Názvy stĺpcov sa nedali odvodiť, má súbor hlavičku?',
						noObjects: 'Objekty nebolo možné odvodiť, existovali iné údaje v súbore ako hlavičky?',
						invalidCsv: 'Súbor sa nepodarilo spracovať, je to platný súbor CSV?',
						invalidJson: 'Súbor nebolo možné spracovať, je to platný súbor typu Json?',
						jsonNotArray: 'Importovaný súbor json musí obsahovať pole, ukončujem.'
					},
					pagination: {
						aria: {
							pageToFirst: 'Strana na začiatok',
							pageBack: 'Strana dozadu',
							pageSelected: 'Označená strana',
							pageForward: 'Strana dopredu',
							pageToLast: 'Strana na koniec'
						},
						sizes: 'položky na stranu',
						totalItems: 'položky spolu',
						through: 'do konca',
						of: 'z'
					},
					grouping: {
						group: 'Zoskupiť',
						ungroup: 'Zrušiť zoskupenie',
						aggregate_count: 'Agg: Počet',
	
						aggregate_sum: 'Agg: Suma',
						aggregate_max: 'Agg: Max',
						aggregate_min: 'Agg: Min',
						aggregate_avg: 'Agg: Avg',
						aggregate_remove: 'Agg: Zrušiť'
					},
					validate: {
						error: 'Chyba:',
						minLength: 'Hodnota by mala mať aspoň THRESHOLD znakov dlhá.',
						maxLength: 'Hodnota by mala byť maximálne THRESHOLD znakov dlhá.',
						required: 'Vyžaduje sa hodnota.'
					}
				});
				return $delegate;
			}]);
		}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('sv', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Kolumnfilter',
	            removeFilter: 'Ta bort filter',
	            columnMenuButtonLabel: 'Kolumnmeny',
	            column: 'Kolumn'
	          },
	          priority: 'Prioritet:',
	          filterLabel: "Filter för kolumn: "
	        },
	        aggregate: {
	          label: 'Poster'
	        },
	        groupPanel: {
	          description: 'Dra en kolumnrubrik hit och släpp den för att gruppera efter den kolumnen.'
	        },
	        search: {
	          aria: {
	            selected: 'Rad är vald',
	            notSelected: 'Rad är inte vald'
	          },
	          placeholder: 'Sök...',
	          showingItems: 'Visar:',
	          selectedItems: 'Valda:',
	          totalItems: 'Antal:',
	          size: 'Sidstorlek:',
	          first: 'Första sidan',
	          next: 'Nästa sida',
	          previous: 'Föregående sida',
	          last: 'Sista sidan'
	        },
	        menu: {
	          text: 'Välj kolumner:'
	        },
	        sort: {
	          ascending: 'Sortera stigande',
	          descending: 'Sortera fallande',
	          none: 'Ingen sortering',
	          remove: 'Inaktivera sortering'
	        },
	        column: {
	          hide: 'Göm kolumn'
	        },
	        aggregation: {
	          count: 'Antal rader: ',
	          sum: 'Summa: ',
	          avg: 'Genomsnitt: ',
	          min: 'Min: ',
	          max: 'Max: '
	        },
	        pinning: {
	          pinLeft: 'Fäst vänster',
	          pinRight: 'Fäst höger',
	          unpin: 'Lösgör'
	        },
	        columnMenu: {
	          close: 'Stäng'
	        },
	        gridMenu: {
	          aria: {
	              buttonLabel: 'Meny'
	          },
	          columns: 'Kolumner:',
	          importerTitle: 'Importera fil',
	          exporterAllAsCsv: 'Exportera all data som CSV',
	          exporterVisibleAsCsv: 'Exportera synlig data som CSV',
	          exporterSelectedAsCsv: 'Exportera markerad data som CSV',
	          exporterAllAsPdf: 'Exportera all data som PDF',
	          exporterVisibleAsPdf: 'Exportera synlig data som PDF',
	          exporterSelectedAsPdf: 'Exportera markerad data som PDF',
	          exporterAllAsExcel: 'Exportera all data till Excel',
	          exporterVisibleAsExcel: 'Exportera synlig data till Excel',
	          exporterSelectedAsExcel: 'Exportera markerad data till Excel',
	          clearAllFilters: 'Nollställ alla filter'
	        },
	        importer: {
	          noHeaders: 'Kolumnnamn kunde inte härledas. Har filen ett sidhuvud?',
	          noObjects: 'Objekt kunde inte härledas. Har filen data undantaget sidhuvud?',
	          invalidCsv: 'Filen kunde inte behandlas, är den en giltig CSV?',
	          invalidJson: 'Filen kunde inte behandlas, är den en giltig JSON?',
	          jsonNotArray: 'Importerad JSON-fil måste innehålla ett fält. Import avbruten.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Gå till första sidan',
	            pageBack: 'Gå en sida bakåt',
	            pageSelected: 'Vald sida',
	            pageForward: 'Gå en sida framåt',
	            pageToLast: 'Gå till sista sidan'
	          },
	          sizes: 'Poster per sida',
	          totalItems: 'Poster',
	          through: 'genom',
	          of: 'av'
	        },
	        grouping: {
	          group: 'Gruppera',
	          ungroup: 'Dela upp',
	          aggregate_count: 'Agg: Antal',
	          aggregate_sum: 'Agg: Summa',
	          aggregate_max: 'Agg: Max',
	          aggregate_min: 'Agg: Min',
	          aggregate_avg: 'Agg: Genomsnitt',
	          aggregate_remove: 'Agg: Ta bort'
	        },
	        validate: {
	          error: 'Error:',
	          minLength: 'Värdet borde vara minst THRESHOLD tecken långt.',
	          maxLength: 'Värdet borde vara max THRESHOLD tecken långt.',
	          required: 'Ett värde krävs.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ta', {
	        aggregate: {
	          label: 'உருப்படிகள்'
	        },
	        groupPanel: {
	          description: 'ஒரு பத்தியை குழுவாக அமைக்க அப்பத்தியின் தலைப்பை இங்கே  இழுத்து வரவும் '
	        },
	        search: {
	          placeholder: 'தேடல் ...',
	          showingItems: 'உருப்படிகளை காண்பித்தல்:',
	          selectedItems: 'தேர்ந்தெடுக்கப்பட்ட  உருப்படிகள்:',
	          totalItems: 'மொத்த உருப்படிகள்:',
	          size: 'பக்க அளவு: ',
	          first: 'முதல் பக்கம்',
	          next: 'அடுத்த பக்கம்',
	          previous: 'முந்தைய பக்கம் ',
	          last: 'இறுதி பக்கம்'
	        },
	        menu: {
	          text: 'பத்திகளை தேர்ந்தெடு:'
	        },
	        sort: {
	          ascending: 'மேலிருந்து கீழாக',
	          descending: 'கீழிருந்து மேலாக',
	          remove: 'வரிசையை நீக்கு'
	        },
	        column: {
	          hide: 'பத்தியை மறைத்து வை '
	        },
	        aggregation: {
	          count: 'மொத்த வரிகள்:',
	          sum: 'மொத்தம்: ',
	          avg: 'சராசரி: ',
	          min: 'குறைந்தபட்ச: ',
	          max: 'அதிகபட்ச: '
	        },
	        pinning: {
	         pinLeft: 'இடதுபுறமாக தைக்க ',
	          pinRight: 'வலதுபுறமாக தைக்க',
	          unpin: 'பிரி'
	        },
	        gridMenu: {
	          columns: 'பத்திகள்:',
	          importerTitle: 'கோப்பு : படித்தல்',
	          exporterAllAsCsv: 'எல்லா தரவுகளையும் கோப்பாக்கு: csv',
	          exporterVisibleAsCsv: 'இருக்கும் தரவுகளை கோப்பாக்கு: csv',
	          exporterSelectedAsCsv: 'தேர்ந்தெடுத்த தரவுகளை கோப்பாக்கு: csv',
	          exporterAllAsPdf: 'எல்லா தரவுகளையும் கோப்பாக்கு: pdf',
	          exporterVisibleAsPdf: 'இருக்கும் தரவுகளை கோப்பாக்கு: pdf',
	          exporterSelectedAsPdf: 'தேர்ந்தெடுத்த தரவுகளை கோப்பாக்கு: pdf',
	          clearAllFilters: 'Clear all filters'
	        },
	        importer: {
	          noHeaders: 'பத்தியின் தலைப்புகளை பெற இயலவில்லை, கோப்பிற்கு தலைப்பு உள்ளதா?',
	          noObjects: 'இலக்குகளை உருவாக்க முடியவில்லை, கோப்பில் தலைப்புகளை தவிர தரவு ஏதேனும் உள்ளதா? ',
	          invalidCsv:	'சரிவர நடைமுறை படுத்த இயலவில்லை, கோப்பு சரிதானா? - csv',
	          invalidJson: 'சரிவர நடைமுறை படுத்த இயலவில்லை, கோப்பு சரிதானா? - json',
	          jsonNotArray: 'படித்த கோப்பில் வரிசைகள் உள்ளது, நடைமுறை ரத்து செய் : json'
	        },
	        pagination: {
	          sizes		: 'உருப்படிகள் / பக்கம்',
	          totalItems	: 'உருப்படிகள் '
	        },
	        grouping: {
	          group	: 'குழு',
	          ungroup : 'பிரி',
	          aggregate_count	: 'மதிப்பீட்டு : எண்ணு',
	          aggregate_sum : 'மதிப்பீட்டு : கூட்டல்',
	          aggregate_max	: 'மதிப்பீட்டு : அதிகபட்சம்',
	          aggregate_min	: 'மதிப்பீட்டு : குறைந்தபட்சம்',
	          aggregate_avg	: 'மதிப்பீட்டு : சராசரி',
	          aggregate_remove : 'மதிப்பீட்டு : நீக்கு'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
		angular.module('ui.grid').config(['$provide', function($provide) {
			$provide.decorator('i18nService', ['$delegate', function($delegate) {
				$delegate.add('tr', {
					headerCell: {
						aria: {
							defaultFilterLabel: 'Sütun için filtre',
							removeFilter: 'Filtreyi Kaldır',
							columnMenuButtonLabel: 'Sütun Menüsü'
						},
						priority: 'Öncelik:',
						filterLabel: "Sütun için filtre: "
					},
					aggregate: {
						label: 'kayıtlar'
					},
					groupPanel: {
						description: 'Sütuna göre gruplamak için sütun başlığını buraya sürükleyin ve bırakın.'
					},
					search: {
						placeholder: 'Arama...',
						showingItems: 'Gösterilen Kayıt:',
						selectedItems: 'Seçili Kayıt:',
						totalItems: 'Toplam Kayıt:',
						size: 'Sayfa Boyutu:',
						first: 'İlk Sayfa',
						next: 'Sonraki Sayfa',
						previous: 'Önceki Sayfa',
						last: 'Son Sayfa'
					},
					menu: {
						text: 'Sütunları Seç:'
					},
					sort: {
						ascending: 'Artan Sırada Sırala',
						descending: 'Azalan Sırada Sırala',
						none: 'Sıralama Yapma',
						remove: 'Sıralamayı Kaldır'
					},
					column: {
						hide: 'Sütunu Gizle'
					},
					aggregation: {
						count: 'toplam satır: ',
						sum: 'toplam: ',
						avg: 'ort: ',
						min: 'min: ',
						max: 'maks: '
					},
					pinning: {
						pinLeft: 'Sola Sabitle',
						pinRight: 'Sağa Sabitle',
						unpin: 'Sabitlemeyi Kaldır'
					},
					columnMenu: {
						close: 'Kapat'
					},
					gridMenu: {
						aria: {
							buttonLabel: 'Tablo Menü'
						},
						columns: 'Sütunlar:',
						importerTitle: 'Dosya içeri aktar',
						exporterAllAsCsv: 'Bütün veriyi CSV olarak dışarı aktar',
						exporterVisibleAsCsv: 'Görünen veriyi CSV olarak dışarı aktar',
						exporterSelectedAsCsv: 'Seçili veriyi CSV olarak dışarı aktar',
						exporterAllAsPdf: 'Bütün veriyi PDF olarak dışarı aktar',
						exporterVisibleAsPdf: 'Görünen veriyi PDF olarak dışarı aktar',
						exporterSelectedAsPdf: 'Seçili veriyi PDF olarak dışarı aktar',
						clearAllFilters: 'Bütün filtreleri kaldır'
					},
					importer: {
						noHeaders: 'Sütun isimleri üretilemiyor, dosyanın bir başlığı var mı?',
						noObjects: 'Nesneler üretilemiyor, dosyada başlıktan başka bir veri var mı?',
						invalidCsv: 'Dosya işlenemedi, geçerli bir CSV dosyası mı?',
						invalidJson: 'Dosya işlenemedi, geçerli bir Json dosyası mı?',
						jsonNotArray: 'Alınan Json dosyasında bir dizi bulunmalıdır, işlem iptal ediliyor.'
					},
					pagination: {
						aria: {
							pageToFirst: 'İlk sayfaya',
							pageBack: 'Geri git',
							pageSelected: 'Seçili sayfa',
							pageForward: 'İleri git',
							pageToLast: 'Sona git'
						},
						sizes: 'Sayfadaki nesne sayısı',
						totalItems: 'kayıtlar',
						through: '', // note(fsw) : turkish dont have this preposition
						of: '' // note(fsw) : turkish dont have this preposition
					},
					grouping: {
						group: 'Grupla',
						ungroup: 'Gruplama',
						aggregate_count: 'Yekun: Sayı',
						aggregate_sum: 'Yekun: Toplam',
						aggregate_max: 'Yekun: Maks',
						aggregate_min: 'Yekun: Min',
						aggregate_avg: 'Yekun: Ort',
						aggregate_remove: 'Yekun: Sil'
					}
				});
				return $delegate;
			}]);
		}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ua', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Фільтр стовпчика',
	            removeFilter: 'Видалити фільтр',
	            columnMenuButtonLabel: 'Меню ствпчика'
	          },
	          priority: 'Пріоритет:',
	          filterLabel: "Фільтр стовпчика: "
	        },
	        aggregate: {
	          label: 'елементи'
	        },
	        groupPanel: {
	          description: 'Для групування за стовпчиком перетягніть сюди його назву.'
	        },
	        search: {
	          placeholder: 'Пошук...',
	          showingItems: 'Показати елементи:',
	          selectedItems: 'Обрані елементи:',
	          totalItems: 'Усього елементів:',
	          size: 'Розмір сторінки:',
	          first: 'Перша сторінка',
	          next: 'Наступна сторінка',
	          previous: 'Попередня сторінка',
	          last: 'Остання сторінка'
	        },
	        menu: {
	          text: 'Обрати ствпчики:'
	        },
	        sort: {
	          ascending: 'За зростанням',
	          descending: 'За спаданням',
	          none: 'Без сортування',
	          remove: 'Прибрати сортування'
	        },
	        column: {
	          hide: 'Приховати стовпчик'
	        },
	        aggregation: {
	          count: 'усього рядків: ',
	          sum: 'ітого: ',
	          avg: 'середнє: ',
	          min: 'мін: ',
	          max: 'макс: '
	        },
					pinning: {
						pinLeft: 'Закріпити ліворуч',
						pinRight: 'Закріпити праворуч',
						unpin: 'Відкріпити'
					},
	        columnMenu: {
	          close: 'Закрити'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Меню'
	          },
	          columns: 'Стовпчики:',
	          importerTitle: 'Імпортувати файл',
	          exporterAllAsCsv: 'Експортувати все в CSV',
	          exporterVisibleAsCsv: 'Експортувати видимі дані в CSV',
	          exporterSelectedAsCsv: 'Експортувати обрані дані в CSV',
	          exporterAllAsPdf: 'Експортувати все в PDF',
	          exporterVisibleAsPdf: 'Експортувати видимі дані в PDF',
	          exporterSelectedAsPdf: 'Експортувати обрані дані в PDF',
	          clearAllFilters: 'Очистити всі фільтри'
	        },
	        importer: {
	          noHeaders: 'Не вдалося отримати назви стовпчиків, чи є в файлі заголовок?',
	          noObjects: 'Не вдалося отримати дані, чи є в файлі рядки окрім заголовка?',
	          invalidCsv: 'Не вдалося обробити файл, чи це коректний CSV-файл?',
	          invalidJson: 'Не вдалося обробити файл, чи це коректний JSON?',
	          jsonNotArray: 'JSON-файл що імпортується повинен містити масив, операцію скасовано.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Перша сторінка',
	            pageBack: 'Попередня сторінка',
	            pageSelected: 'Обрана сторінка',
	            pageForward: 'Наступна сторінка',
	            pageToLast: 'Остання сторінка'
	          },
	          sizes: 'рядків на сторінку',
	          totalItems: 'рядків',
	          through: 'по',
	          of: 'з'
	        },
	        grouping: {
	          group: 'Групувати',
	          ungroup: 'Розгрупувати',
	          aggregate_count: 'Групувати: Кількість',
	          aggregate_sum: 'Для групи: Сума',
	          aggregate_max: 'Для групи: Максимум',
	          aggregate_min: 'Для групи: Мінімум',
	          aggregate_avg: 'Для групи: Серднє',
	          aggregate_remove: 'Для групи: Пусто'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('zh-cn', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: '列过滤器',
	            removeFilter: '移除过滤器',
	            columnMenuButtonLabel: '列菜单'
	          },
	          priority: '优先级:',
	          filterLabel: "列过滤器: "
	        },
	        aggregate: {
	          label: '行'
	        },
	        groupPanel: {
	          description: '拖曳表头到此处进行分组'
	        },
	        search: {
	          placeholder: '查找',
	          showingItems: '已显示行数：',
	          selectedItems: '已选择行数：',
	          totalItems: '总行数：',
	          size: '每页显示行数：',
	          first: '首页',
	          next: '下一页',
	          previous: '上一页',
	          last: '末页'
	        },
	        menu: {
	          text: '选择列：'
	        },
	        sort: {
	          ascending: '升序',
	          descending: '降序',
	          none: '无序',
	          remove: '取消排序'
	        },
	        column: {
	          hide: '隐藏列'
	        },
	        aggregation: {
	          count: '计数：',
	          sum: '求和：',
	          avg: '均值：',
	          min: '最小值：',
	          max: '最大值：'
	        },
	        pinning: {
	          pinLeft: '左侧固定',
	          pinRight: '右侧固定',
	          unpin: '取消固定'
	        },
	        columnMenu: {
	          close: '关闭'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: '表格菜单'
	          },
	          columns: '列：',
	          importerTitle: '导入文件',
	          exporterAllAsCsv: '导出全部数据到CSV',
	          exporterVisibleAsCsv: '导出可见数据到CSV',
	          exporterSelectedAsCsv: '导出已选数据到CSV',
	          exporterAllAsPdf: '导出全部数据到PDF',
	          exporterVisibleAsPdf: '导出可见数据到PDF',
	          exporterSelectedAsPdf: '导出已选数据到PDF',
	          clearAllFilters: '清除所有过滤器'
	        },
	        importer: {
	          noHeaders: '无法获取列名，确定文件包含表头？',
	          noObjects: '无法获取数据，确定文件包含数据？',
	          invalidCsv: '无法处理文件，确定是合法的CSV文件？',
	          invalidJson: '无法处理文件，确定是合法的JSON文件？',
	          jsonNotArray: '导入的文件不是JSON数组！'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: '第一页',
	            pageBack: '上一页',
	            pageSelected: '当前页',
	            pageForward: '下一页',
	            pageToLast: '最后一页'
	          },
	          sizes: '行每页',
	          totalItems: '行',
	          through: '至',
	          of: '共'
	        },
	        grouping: {
	          group: '分组',
	          ungroup: '取消分组',
	          aggregate_count: '合计: 计数',
	          aggregate_sum: '合计: 求和',
	          aggregate_max: '合计: 最大',
	          aggregate_min: '合计: 最小',
	          aggregate_avg: '合计: 平均',
	          aggregate_remove: '合计: 移除'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('zh-tw', {
	        aggregate: {
	          label: '行'
	        },
	        groupPanel: {
	          description: '拖曳表頭到此處進行分組'
	        },
	        search: {
	          placeholder: '查找',
	          showingItems: '已顯示行數：',
	          selectedItems: '已選擇行數：',
	          totalItems: '總行數：',
	          size: '每頁顯示行數：',
	          first: '首頁',
	          next: '下壹頁',
	          previous: '上壹頁',
	          last: '末頁'
	        },
	        menu: {
	          text: '選擇列：'
	        },
	        sort: {
	          ascending: '升序',
	          descending: '降序',
	          remove: '取消排序'
	        },
	        column: {
	          hide: '隱藏列'
	        },
	        aggregation: {
	          count: '計數：',
	          sum: '求和：',
	          avg: '均值：',
	          min: '最小值：',
	          max: '最大值：'
	        },
	        pinning: {
	          pinLeft: '左側固定',
	          pinRight: '右側固定',
	          unpin: '取消固定'
	        },
	        gridMenu: {
	          columns: '列：',
	          importerTitle: '導入文件',
	          exporterAllAsCsv: '導出全部數據到CSV',
	          exporterVisibleAsCsv: '導出可見數據到CSV',
	          exporterSelectedAsCsv: '導出已選數據到CSV',
	          exporterAllAsPdf: '導出全部數據到PDF',
	          exporterVisibleAsPdf: '導出可見數據到PDF',
	          exporterSelectedAsPdf: '導出已選數據到PDF',
	          clearAllFilters: '清除所有过滤器'
	        },
	        importer: {
	          noHeaders: '無法獲取列名，確定文件包含表頭？',
	          noObjects: '無法獲取數據，確定文件包含數據？',
	          invalidCsv: '無法處理文件，確定是合法的CSV文件？',
	          invalidJson: '無法處理文件，確定是合法的JSON文件？',
	          jsonNotArray: '導入的文件不是JSON數組！'
	        },
	        pagination: {
	          sizes: '行每頁',
	          totalItems: '行'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.importer
	   * @description
	   *
	   * # ui.grid.importer
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides the ability to import data into the grid. It
	   * uses the column defs to work out which data belongs in which column,
	   * and creates entities from a configured class (typically a $resource).
	   *
	   * If the rowEdit feature is enabled, it also calls save on those newly
	   * created objects, and then displays any errors in the imported data.
	   *
	   * Currently the importer imports only CSV and json files, although provision has been
	   * made to process other file formats, and these can be added over time.
	   *
	   * For json files, the properties within each object in the json must match the column names
	   * (to put it another way, the importer doesn't process the json, it just copies the objects
	   * within the json into a new instance of the specified object type)
	   *
	   * For CSV import, the default column identification relies on each column in the
	   * header row matching a column.name or column.displayName. Optionally, a column identification
	   * callback can be used.  This allows matching using other attributes, which is particularly
	   * useful if your application has internationalised column headings (i.e. the headings that
	   * the user sees don't match the column names).
	   *
	   * The importer makes use of the grid menu as the UI for requesting an
	   * import.
	   *
	   * <div ui-grid-importer></div>
	   */
	
	  var module = angular.module('ui.grid.importer', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.importer.constant:uiGridImporterConstants
	   *
	   *  @description constants available in importer module
	   */
	
	  module.constant('uiGridImporterConstants', {
	    featureName: 'importer'
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.importer.service:uiGridImporterService
	   *
	   *  @description Services for importer feature
	   */
	  module.service('uiGridImporterService', ['$q', 'uiGridConstants', 'uiGridImporterConstants', 'gridUtil', '$compile', '$interval', 'i18nService', '$window',
	    function ($q, uiGridConstants, uiGridImporterConstants, gridUtil, $compile, $interval, i18nService, $window) {
	
	      var service = {
	
	        initializeGrid: function ($scope, grid) {
	
	          // add feature namespace and any properties to grid for needed state
	          grid.importer = {
	            $scope: $scope
	          };
	
	          this.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.importer.api:PublicApi
	           *
	           *  @description Public Api for importer feature
	           */
	          var publicApi = {
	            events: {
	              importer: {
	              }
	            },
	            methods: {
	              importer: {
	                /**
	                 * @ngdoc function
	                 * @name importFile
	                 * @methodOf  ui.grid.importer.api:PublicApi
	                 * @description Imports a file into the grid using the file object
	                 * provided.  Bypasses the grid menu
	                 * @param {File} fileObject the file we want to import, as a javascript
	                 * File object
	                 */
	                importFile: function ( fileObject ) {
	                  service.importThisFile( grid, fileObject );
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	          if ( grid.options.enableImporter && grid.options.importerShowMenu ) {
	            if ( grid.api.core.addToGridMenu ) {
	              service.addToMenu( grid );
	            } else {
	              // order of registration is not guaranteed, register in a little while
	              $interval( function() {
	                if (grid.api.core.addToGridMenu) {
	                  service.addToMenu( grid );
	                }
	              }, 100, 1);
	            }
	          }
	        },
	
	
	        defaultGridOptions: function (gridOptions) {
	          // default option to true unless it was explicitly set to false
	          /**
	           * @ngdoc object
	           * @name ui.grid.importer.api:GridOptions
	           *
	           * @description GridOptions for importer feature, these are available to be
	           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           * @ngdoc property
	           * @propertyOf ui.grid.importer.api:GridOptions
	           * @name enableImporter
	           * @description Whether or not importer is enabled.  Automatically set
	           * to false if the user's browser does not support the required fileApi.
	           * Otherwise defaults to true.
	           *
	           */
	          if (gridOptions.enableImporter  || gridOptions.enableImporter === undefined) {
	            if ( !($window.hasOwnProperty('File') && $window.hasOwnProperty('FileReader') && $window.hasOwnProperty('FileList') && $window.hasOwnProperty('Blob')) ) {
	              gridUtil.logError('The File APIs are not fully supported in this browser, grid importer cannot be used.');
	              gridOptions.enableImporter = false;
	            } else {
	              gridOptions.enableImporter = true;
	            }
	          } else {
	            gridOptions.enableImporter = false;
	          }
	
	          /**
	           * @ngdoc method
	           * @name importerProcessHeaders
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @description A callback function that will process headers using custom
	           * logic.  Set this callback function if the headers that your user will provide in their
	           * import file don't necessarily match the grid header or field names.  This might commonly
	           * occur where your application is internationalised, and therefore the field names
	           * that the user recognises are in a different language than the field names that
	           * ui-grid knows about.
	           *
	           * Defaults to the internal `processHeaders` method, which seeks to match using both
	           * displayName and column.name.  Any non-matching columns are discarded.
	           *
	           * Your callback routine should respond by processing the header array, and returning an array
	           * of matching column names.  A null value in any given position means "don't import this column"
	           *
	           * <pre>
	           *      gridOptions.importerProcessHeaders: function( grid, headerArray ) {
	           *        var myHeaderColumns = [];
	           *        var thisCol;
	           *        headerArray.forEach( function( value, index ) {
	           *          thisCol = mySpecialLookupFunction( value );
	           *          myHeaderColumns.push( thisCol.name );
	           *        });
	           *
	           *        return myHeaderCols;
	           *      })
	           * </pre>
	           * @param {Grid} grid the grid we're importing into
	           * @param {array} headerArray an array of the text from the first row of the csv file,
	           * which you need to match to column.names
	           * @returns {array} array of matching column names, in the same order as the headerArray
	           *
	           */
	          gridOptions.importerProcessHeaders = gridOptions.importerProcessHeaders || service.processHeaders;
	
	          /**
	           * @ngdoc method
	           * @name importerHeaderFilter
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @description A callback function that will filter (usually translate) a single
	           * header.  Used when you want to match the passed in column names to the column
	           * displayName after the header filter.
	           *
	           * Your callback routine needs to return the filtered header value.
	           * <pre>
	           *      gridOptions.importerHeaderFilter: function( displayName ) {
	           *        return $translate.instant( displayName );
	           *      })
	           * </pre>
	           *
	           * or:
	           * <pre>
	           *      gridOptions.importerHeaderFilter: $translate.instant
	           * </pre>
	           * @param {string} displayName the displayName that we'd like to translate
	           * @returns {string} the translated name
	           *
	           */
	          gridOptions.importerHeaderFilter = gridOptions.importerHeaderFilter || function( displayName ) { return displayName; };
	
	          /**
	           * @ngdoc method
	           * @name importerErrorCallback
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @description A callback function that provides custom error handling, rather
	           * than the standard grid behaviour of an alert box and a console message.  You
	           * might use this to internationalise the console log messages, or to write to a
	           * custom logging routine that returned errors to the server.
	           *
	           * <pre>
	           *      gridOptions.importerErrorCallback: function( grid, errorKey, consoleMessage, context ) {
	           *        myUserDisplayRoutine( errorKey );
	           *        myLoggingRoutine( consoleMessage, context );
	           *      })
	           * </pre>
	           * @param {Grid} grid the grid we're importing into, may be useful if you're positioning messages
	           * in some way
	           * @param {string} errorKey one of the i18n keys the importer can return - importer.noHeaders,
	           * importer.noObjects, importer.invalidCsv, importer.invalidJson, importer.jsonNotArray
	           * @param {string} consoleMessage the English console message that importer would have written
	           * @param {object} context the context data that importer would have appended to that console message,
	           * often the file content itself or the element that is in error
	           *
	           */
	          if ( !gridOptions.importerErrorCallback ||  typeof(gridOptions.importerErrorCallback) !== 'function' ) {
	            delete gridOptions.importerErrorCallback;
	          }
	
	          /**
	           * @ngdoc method
	           * @name importerDataAddCallback
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @description A mandatory callback function that adds data to the source data array.  The grid
	           * generally doesn't add rows to the source data array, it is tidier to handle this through a user
	           * callback.
	           *
	           * <pre>
	           *      gridOptions.importerDataAddCallback: function( grid, newObjects ) {
	           *        $scope.myData = $scope.myData.concat( newObjects );
	           *      })
	           * </pre>
	           * @param {Grid} grid the grid we're importing into, may be useful in some way
	           * @param {array} newObjects an array of new objects that you should add to your data
	           *
	           */
	          if ( gridOptions.enableImporter === true && !gridOptions.importerDataAddCallback ) {
	            gridUtil.logError("You have not set an importerDataAddCallback, importer is disabled");
	            gridOptions.enableImporter = false;
	          }
	
	          /**
	           * @ngdoc object
	           * @name importerNewObject
	           * @propertyOf  ui.grid.importer.api:GridOptions
	           * @description An object on which we call `new` to create each new row before inserting it into
	           * the data array.  Typically this would be a $resource entity, which means that if you're using
	           * the rowEdit feature, you can directly call save on this entity when the save event is triggered.
	           *
	           * Defaults to a vanilla javascript object
	           *
	           * @example
	           * <pre>
	           *   gridOptions.importerNewObject = MyRes;
	           * </pre>
	           *
	           */
	
	          /**
	           * @ngdoc property
	           * @propertyOf ui.grid.importer.api:GridOptions
	           * @name importerShowMenu
	           * @description Whether or not to show an item in the grid menu.  Defaults to true.
	           *
	           */
	          gridOptions.importerShowMenu = gridOptions.importerShowMenu !== false;
	
	          /**
	           * @ngdoc method
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @name importerObjectCallback
	           * @description A callback that massages the data for each object.  For example,
	           * you might have data stored as a code value, but display the decode.  This callback
	           * can be used to change the decoded value back into a code.  Defaults to doing nothing.
	           * @param {Grid} grid in case you need it
	           * @param {object} newObject the new object as importer has created it, modify it
	           * then return the modified version
	           * @returns {object} the modified object
	           * @example
	           * <pre>
	           *   gridOptions.importerObjectCallback = function ( grid, newObject ) {
	           *     switch newObject.status {
	           *       case 'Active':
	           *         newObject.status = 1;
	           *         break;
	           *       case 'Inactive':
	           *         newObject.status = 2;
	           *         break;
	           *     }
	           *     return newObject;
	           *   };
	           * </pre>
	           */
	          gridOptions.importerObjectCallback = gridOptions.importerObjectCallback || function( grid, newObject ) { return newObject; };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name addToMenu
	         * @methodOf  ui.grid.importer.service:uiGridImporterService
	         * @description Adds import menu item to the grid menu,
	         * allowing the user to request import of a file
	         * @param {Grid} grid the grid into which data should be imported
	         */
	        addToMenu: function ( grid ) {
	          grid.api.core.addToGridMenu( grid, [
	            {
	              title: i18nService.getSafeText('gridMenu.importerTitle'),
	              order: 150
	            },
	            {
	              templateUrl: 'ui-grid/importerMenuItemContainer',
	              action: function () {
	                this.grid.api.importer.importAFile( grid );
	              },
	              order: 151
	            }
	          ]);
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name importThisFile
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Imports the provided file into the grid using the file object
	         * provided.  Bypasses the grid menu
	         * @param {Grid} grid the grid we're importing into
	         * @param {File} fileObject the file we want to import, as returned from the File
	         * javascript object
	         */
	        importThisFile: function ( grid, fileObject ) {
	          if (!fileObject) {
	            gridUtil.logError( 'No file object provided to importThisFile, should be impossible, aborting');
	            return;
	          }
	
	          var reader = new FileReader();
	
	          switch ( fileObject.type ) {
	            case 'application/json':
	              reader.onload = service.importJsonClosure( grid );
	              break;
	            default:
	              reader.onload = service.importCsvClosure( grid );
	              break;
	          }
	
	          reader.readAsText( fileObject );
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name importJson
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Creates a function that imports a json file into the grid.
	         * The json data is imported into new objects of type `gridOptions.importerNewObject`,
	         * and if the rowEdit feature is enabled the rows are marked as dirty
	         * @param {Grid} grid the grid we want to import into
	         * @return {function} Function that receives the file that we want to import, as
	         * a FileObject as an argument
	         */
	        importJsonClosure: function( grid ) {
	          return function( importFile ) {
	            var newObjects = [],
	              newObject,
	              importArray = service.parseJson( grid, importFile );
	
	            if (importArray === null) {
	              return;
	            }
	            importArray.forEach(  function( value ) {
	              newObject = service.newObject( grid );
	              angular.extend( newObject, value );
	              newObject = grid.options.importerObjectCallback( grid, newObject );
	              newObjects.push( newObject );
	            });
	
	            service.addObjects( grid, newObjects );
	          };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name parseJson
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Parses a json file, returns the parsed data.
	         * Displays an error if file doesn't parse
	         * @param {Grid} grid the grid that we want to import into
	         * @param {FileObject} importFile the file that we want to import, as
	         * a FileObject
	         * @returns {array} array of objects from the imported json
	         */
	        parseJson: function( grid, importFile ) {
	          var loadedObjects;
	
	          try {
	            loadedObjects = JSON.parse( importFile.target.result );
	          } catch (e) {
	            service.alertError( grid, 'importer.invalidJson', 'File could not be processed, is it valid json? Content was: ', importFile.target.result );
	            return;
	          }
	
	          if ( !Array.isArray( loadedObjects ) ) {
	            service.alertError( grid, 'importer.jsonNotarray', 'Import failed, file is not an array, file was: ', importFile.target.result );
	            return [];
	          } else {
	            return loadedObjects;
	          }
	        },
	
	
	
	        /**
	         * @ngdoc function
	         * @name importCsvClosure
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Creates a function that imports a csv file into the grid
	         * (allowing it to be used in the reader.onload event)
	         * @param {Grid} grid the grid that we want to import into
	         * @return {function} Function that receives the file that we want to import, as
	         * a file object
	         */
	        importCsvClosure: function( grid ) {
	          return function( importFile ) {
	            var importArray = service.parseCsv( importFile );
	
	            if ( !importArray || importArray.length < 1 ) {
	              service.alertError( grid, 'importer.invalidCsv', 'File could not be processed, is it valid csv? Content was: ', importFile.target.result );
	              return;
	            }
	
	            var newObjects = service.createCsvObjects( grid, importArray );
	
	            if ( !newObjects || newObjects.length === 0 ) {
	              service.alertError( grid, 'importer.noObjects', 'Objects were not able to be derived, content was: ', importFile.target.result );
	              return;
	            }
	
	            service.addObjects( grid, newObjects );
	          };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name parseCsv
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Parses a csv file into an array of arrays, with the first
	         * array being the headers, and the remaining arrays being the data.
	         * The logic for this comes from https://github.com/thetalecrafter/excel.js/blob/master/src/csv.js,
	         * which is noted as being under the MIT license.  The code is modified to pass the jscs yoda condition
	         * checker
	         * @param {FileObject} importFile the file that we want to import, as a
	         * file object
	         */
	        parseCsv: function( importFile ) {
	          var csv = importFile.target.result;
	
	          // use the CSV-JS library to parse
	          return CSV.parse(csv);
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name createCsvObjects
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Converts an array of arrays (representing the csv file)
	         * into a set of objects.  Uses the provided `gridOptions.importerNewObject`
	         * to create the objects, and maps the header row into the individual columns
	         * using either `gridOptions.importerProcessHeaders`, or by using a native method
	         * of matching to either the displayName, column name or column field of
	         * the columns in the column defs.  The resulting objects will have attributes
	         * that are named based on the column.field or column.name, in that order.
	         * @param {Grid} grid the grid that we want to import into
	         * @param {Array} importArray the data that we want to import, as an array
	         */
	        createCsvObjects: function( grid, importArray ) {
	          // pull off header row and turn into headers
	          var headerMapping = grid.options.importerProcessHeaders( grid, importArray.shift() );
	
	          if ( !headerMapping || headerMapping.length === 0 ) {
	            service.alertError( grid, 'importer.noHeaders', 'Column names could not be derived, content was: ', importArray );
	            return [];
	          }
	
	          var newObjects = [],
	            newObject;
	
	          importArray.forEach( function( row ) {
	            newObject = service.newObject( grid );
	            if ( row !== null ) {
	              row.forEach( function( field, index ) {
	                if ( headerMapping[index] !== null ) {
	                  newObject[ headerMapping[index] ] = field;
	                }
	              });
	            }
	            newObject = grid.options.importerObjectCallback( grid, newObject );
	            newObjects.push( newObject );
	          });
	
	          return newObjects;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name processHeaders
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Determines the columns that the header row from
	         * a csv (or other) file represents.
	         * @param {Grid} grid the grid we're importing into
	         * @param {array} headerRow the header row that we wish to match against
	         * the column definitions
	         * @returns {array} an array of the attribute names that should be used
	         * for that column, based on matching the headers or creating the headers
	         *
	         */
	        processHeaders: function( grid, headerRow ) {
	          var headers = [];
	
	          if ( !grid.options.columnDefs || grid.options.columnDefs.length === 0 ) {
	            // we are going to create new columnDefs for all these columns, so just remove
	            // spaces from the names to create fields
	            headerRow.forEach( function( value ) {
	              headers.push( value.replace( /[^0-9a-zA-Z\-_]/g, '_' ) );
	            });
	            return headers;
	          }
	          else {
	            var lookupHash = service.flattenColumnDefs( grid, grid.options.columnDefs );
	            headerRow.forEach(  function( value ) {
	              if ( lookupHash[value] ) {
	                headers.push( lookupHash[value] );
	              }
	              else if ( lookupHash[ value.toLowerCase() ] ) {
	                headers.push( lookupHash[ value.toLowerCase() ] );
	              }
	              else {
	                headers.push( null );
	              }
	            });
	            return headers;
	          }
	        },
	
	
	        /**
	         * @name flattenColumnDefs
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Runs through the column defs and creates a hash of
	         * the displayName, name and field, and of each of those values forced to lower case,
	         * with each pointing to the field or name
	         * (whichever is present).  Used to lookup column headers and decide what
	         * attribute name to give to the resulting field.
	         * @param {Grid} grid the grid we're importing into
	         * @param {array} columnDefs the columnDefs that we should flatten
	         * @returns {hash} the flattened version of the column def information, allowing
	         * us to look up a value by `flattenedHash[ headerValue ]`
	         */
	        flattenColumnDefs: function( grid, columnDefs ) {
	          var flattenedHash = {};
	
	          columnDefs.forEach(  function( columnDef) {
	            if ( columnDef.name ) {
	              flattenedHash[ columnDef.name ] = columnDef.field || columnDef.name;
	              flattenedHash[ columnDef.name.toLowerCase() ] = columnDef.field || columnDef.name;
	            }
	
	            if ( columnDef.field ) {
	              flattenedHash[ columnDef.field ] = columnDef.field || columnDef.name;
	              flattenedHash[ columnDef.field.toLowerCase() ] = columnDef.field || columnDef.name;
	            }
	
	            if ( columnDef.displayName ) {
	              flattenedHash[ columnDef.displayName ] = columnDef.field || columnDef.name;
	              flattenedHash[ columnDef.displayName.toLowerCase() ] = columnDef.field || columnDef.name;
	            }
	
	            if ( columnDef.displayName && grid.options.importerHeaderFilter ) {
	              flattenedHash[ grid.options.importerHeaderFilter(columnDef.displayName) ] = columnDef.field || columnDef.name;
	              flattenedHash[ grid.options.importerHeaderFilter(columnDef.displayName).toLowerCase() ] = columnDef.field || columnDef.name;
	            }
	          });
	
	          return flattenedHash;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name addObjects
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Inserts our new objects into the grid data, and
	         * sets the rows to dirty if the rowEdit feature is being used
	         *
	         * Does this by registering a watch on dataChanges, which essentially
	         * is waiting on the result of the grid data watch, and downstream processing.
	         *
	         * When the callback is called, it deregisters itself - we don't want to run
	         * again next time data is added.
	         *
	         * If we never get called, we deregister on destroy.
	         *
	         * @param {Grid} grid the grid we're importing into
	         * @param {array} newObjects the objects we want to insert into the grid data
	         * @returns {object} the new object
	         */
	        addObjects: function( grid, newObjects ) {
	          if ( grid.api.rowEdit ) {
	            var dataChangeDereg = grid.registerDataChangeCallback( function() {
	              grid.api.rowEdit.setRowsDirty( newObjects );
	              dataChangeDereg();
	            }, [uiGridConstants.dataChange.ROW] );
	
	            grid.importer.$scope.$on( '$destroy', dataChangeDereg );
	          }
	
	          grid.importer.$scope.$apply( grid.options.importerDataAddCallback( grid, newObjects ) );
	
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name newObject
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Makes a new object based on `gridOptions.importerNewObject`,
	         * or based on an empty object if not present
	         * @param {Grid} grid the grid we're importing into
	         * @returns {object} the new object
	         */
	        newObject: function( grid ) {
	          if ( typeof(grid.options) !== "undefined" && typeof(grid.options.importerNewObject) !== "undefined" ) {
	            return new grid.options.importerNewObject();
	          }
	          else {
	            return {};
	          }
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name alertError
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Provides an internationalised user alert for the failure,
	         * and logs a console message including diagnostic content.
	         * Optionally, if the the `gridOptions.importerErrorCallback` routine
	         * is defined, then calls that instead, allowing user specified error routines
	         * @param {Grid} grid the grid we're importing into
	         * @param {array} headerRow the header row that we wish to match against
	         * the column definitions
	         */
	        alertError: function( grid, alertI18nToken, consoleMessage, context ) {
	          if ( grid.options.importerErrorCallback ) {
	            grid.options.importerErrorCallback( grid, alertI18nToken, consoleMessage, context );
	          }
	          else {
	            $window.alert(i18nService.getSafeText( alertI18nToken ));
	            gridUtil.logError(consoleMessage + context );
	          }
	        }
	      };
	
	      return service;
	
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.importer.directive:uiGridImporter
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds importer features to grid
	   *
	   */
	  module.directive('uiGridImporter', ['uiGridImporterConstants', 'uiGridImporterService', 'gridUtil', '$compile',
	    function (uiGridImporterConstants, uiGridImporterService, gridUtil, $compile) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          uiGridImporterService.initializeGrid($scope, uiGridCtrl.grid);
	        }
	      };
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.importer.directive:uiGridImporterMenuItem
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Handles the processing from the importer menu item - once a file is
	   *  selected
	   *
	   */
	  module.directive('uiGridImporterMenuItem', ['uiGridImporterConstants', 'uiGridImporterService', 'gridUtil', '$compile',
	    function (uiGridImporterConstants, uiGridImporterService, gridUtil, $compile) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '?^uiGrid',
	        scope: false,
	        templateUrl: 'ui-grid/importerMenuItem',
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          var grid;
	
	          function handleFileSelect(event) {
	            var target = event.srcElement || event.target;
	
	            if (target && target.files && target.files.length === 1) {
	              var fileObject = target.files[0];
	
	              // Define grid if the uiGrid controller is present
	              if (typeof(uiGridCtrl) !== 'undefined' && uiGridCtrl) {
	                grid = uiGridCtrl.grid;
	
	                uiGridImporterService.importThisFile( grid, fileObject );
	                target.form.reset();
	              }
	              else {
	                gridUtil.logError('Could not import file because UI Grid was not found.');
	              }
	            }
	          }
	
	          var fileChooser = $elm[0].querySelectorAll('.ui-grid-importer-file-chooser');
	
	          if ( fileChooser.length !== 1 ) {
	            gridUtil.logError('Found > 1 or < 1 file choosers within the menu item, error, cannot continue');
	          }
	          else {
	            fileChooser[0].addEventListener('change', handleFileSelect, false);
	          }
	        }
	      };
	    }
	  ]);
	})();
	
	(function() {
	  'use strict';
	  /**
	   *  @ngdoc overview
	   *  @name ui.grid.infiniteScroll
	   *
	   *  @description
	   *
	   * #ui.grid.infiniteScroll
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   * This module provides infinite scroll functionality to ui-grid
	   *
	   */
	  var module = angular.module('ui.grid.infiniteScroll', ['ui.grid']);
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	   *
	   *  @description Service for infinite scroll features
	   */
	  module.service('uiGridInfiniteScrollService', ['gridUtil', '$compile', '$rootScope', 'uiGridConstants', 'ScrollEvent', '$q', function (gridUtil, $compile, $rootScope, uiGridConstants, ScrollEvent, $q) {
	    var service = {
	
	      /**
	       * @ngdoc function
	       * @name initializeGrid
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description This method register events and methods into grid public API
	       */
	
	      initializeGrid: function(grid, $scope) {
	        service.defaultGridOptions(grid.options);
	
	        if (!grid.options.enableInfiniteScroll) {
	          return;
	        }
	
	        grid.infiniteScroll = { dataLoading: false };
	        service.setScrollDirections( grid, grid.options.infiniteScrollUp, grid.options.infiniteScrollDown );
	          grid.api.core.on.scrollEnd($scope, service.handleScroll);
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.infiniteScroll.api:PublicAPI
	         *
	         *  @description Public API for infinite scroll feature
	         */
	        var publicApi = {
	          events: {
	            infiniteScroll: {
	
	              /**
	               * @ngdoc event
	               * @name needLoadMoreData
	               * @eventOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description This event fires when scroll reaches bottom percentage of grid
	               * and needs to load data
	               */
	
	              needLoadMoreData: function ($scope, fn) {
	              },
	
	              /**
	               * @ngdoc event
	               * @name needLoadMoreDataTop
	               * @eventOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description This event fires when scroll reaches top percentage of grid
	               * and needs to load data
	               */
	
	              needLoadMoreDataTop: function ($scope, fn) {
	              }
	            }
	          },
	          methods: {
	            infiniteScroll: {
	
	              /**
	               * @ngdoc function
	               * @name dataLoaded
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Call this function when you have loaded the additional data
	               * requested.  You should set scrollUp and scrollDown to indicate
	               * whether there are still more pages in each direction.
	               *
	               * If you call dataLoaded without first calling `saveScrollPercentage` then we will
	               * scroll the user to the start of the newly loaded data, which usually gives a smooth scroll
	               * experience, but can give a jumpy experience with large `infiniteScrollRowsFromEnd` values, and
	               * on variable speed internet connections.  Using `saveScrollPercentage` as demonstrated in the tutorial
	               * should give a smoother scrolling experience for users.
	               *
	               * See infinite_scroll tutorial for example of usage
	               * @param {boolean} scrollUp if set to false flags that there are no more pages upwards, so don't fire
	               * any more infinite scroll events upward
	               * @param {boolean} scrollDown if set to false flags that there are no more pages downwards, so don't
	               * fire any more infinite scroll events downward
	               * @returns {promise} a promise that is resolved when the grid scrolling is fully adjusted.  If you're
	               * planning to remove pages, you should wait on this promise first, or you'll break the scroll positioning
	               */
	              dataLoaded: function( scrollUp, scrollDown ) {
	                service.setScrollDirections(grid, scrollUp, scrollDown);
	
	                return service.adjustScroll(grid).then(function() {
	                  grid.infiniteScroll.dataLoading = false;
	                });
	              },
	
	              /**
	               * @ngdoc function
	               * @name resetScroll
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Call this function when you have taken some action that makes the current
	               * scroll position invalid.  For example, if you're using external sorting and you've resorted
	               * then you might reset the scroll, or if you've otherwise substantially changed the data, perhaps
	               * you've reused an existing grid for a new data set
	               *
	               * You must tell us whether there is data upwards or downwards after the reset
	               *
	               * @param {boolean} scrollUp flag that there are pages upwards, fire
	               * infinite scroll events upward
	               * @param {boolean} scrollDown flag that there are pages downwards, so
	               * fire infinite scroll events downward
	               */
	              resetScroll: function( scrollUp, scrollDown ) {
	                service.setScrollDirections( grid, scrollUp, scrollDown);
	
	                service.adjustInfiniteScrollPosition(grid, 0);
	              },
	
	
	              /**
	               * @ngdoc function
	               * @name saveScrollPercentage
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Saves the scroll percentage and number of visible rows before you adjust the data,
	               * used if you're subsequently going to call `dataRemovedTop` or `dataRemovedBottom`
	               */
	              saveScrollPercentage: function() {
	                grid.infiniteScroll.prevScrollTop = grid.renderContainers.body.prevScrollTop;
	                grid.infiniteScroll.previousVisibleRows = grid.getVisibleRowCount();
	              },
	
	
	              /**
	               * @ngdoc function
	               * @name dataRemovedTop
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Adjusts the scroll position after you've removed data at the top
	               * @param {boolean} scrollUp flag that there are pages upwards, fire
	               * infinite scroll events upward
	               * @param {boolean} scrollDown flag that there are pages downwards, so
	               * fire infinite scroll events downward
	               */
	              dataRemovedTop: function( scrollUp, scrollDown ) {
	                service.dataRemovedTop( grid, scrollUp, scrollDown );
	              },
	
	              /**
	               * @ngdoc function
	               * @name dataRemovedBottom
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Adjusts the scroll position after you've removed data at the bottom
	               * @param {boolean} scrollUp flag that there are pages upwards, fire
	               * infinite scroll events upward
	               * @param {boolean} scrollDown flag that there are pages downwards, so
	               * fire infinite scroll events downward
	               */
	              dataRemovedBottom: function( scrollUp, scrollDown ) {
	                service.dataRemovedBottom( grid, scrollUp, scrollDown );
	              },
	
	              /**
	               * @ngdoc function
	               * @name setScrollDirections
	               * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	               * @description Sets the scrollUp and scrollDown flags, handling nulls and undefined,
	               * and also sets the grid.suppressParentScroll
	               * @param {boolean} scrollUp whether there are pages available up - defaults to false
	               * @param {boolean} scrollDown whether there are pages available down - defaults to true
	               */
	              setScrollDirections:  function ( scrollUp, scrollDown ) {
	                service.setScrollDirections( grid, scrollUp, scrollDown );
	              }
	
	            }
	          }
	        };
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	
	
	      defaultGridOptions: function (gridOptions) {
	        // default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.infiniteScroll.api:GridOptions
	         *
	         *  @description GridOptions for infinite scroll feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enableInfiniteScroll
	         *  @propertyOf  ui.grid.infiniteScroll.api:GridOptions
	         *  @description Enable infinite scrolling for this grid
	         *  <br/>Defaults to true
	         */
	        gridOptions.enableInfiniteScroll = gridOptions.enableInfiniteScroll !== false;
	
	        /**
	         * @ngdoc property
	         * @name infiniteScrollRowsFromEnd
	         * @propertyOf ui.grid.class:GridOptions
	         * @description This setting controls how close to the end of the dataset a user gets before
	         * more data is requested by the infinite scroll, whether scrolling up or down.  This allows you to
	         * 'prefetch' rows before the user actually runs out of scrolling.
	         *
	         * Note that if you set this value too high it may give jumpy scrolling behaviour, if you're getting
	         * this behaviour you could use the `saveScrollPercentageMethod` right before loading your data, and we'll
	         * preserve that scroll position
	         *
	         * <br> Defaults to 20
	         */
	        gridOptions.infiniteScrollRowsFromEnd = gridOptions.infiniteScrollRowsFromEnd || 20;
	
	        /**
	         * @ngdoc property
	         * @name infiniteScrollUp
	         * @propertyOf ui.grid.class:GridOptions
	         * @description Whether you allow infinite scroll up, implying that the first page of data
	         * you have displayed is in the middle of your data set.  If set to true then we trigger the
	         * needMoreDataTop event when the user hits the top of the scrollbar.
	         * <br> Defaults to false
	         */
	        gridOptions.infiniteScrollUp = gridOptions.infiniteScrollUp === true;
	
	        /**
	         * @ngdoc property
	         * @name infiniteScrollDown
	         * @propertyOf ui.grid.class:GridOptions
	         * @description Whether you allow infinite scroll down, implying that the first page of data
	         * you have displayed is in the middle of your data set.  If set to true then we trigger the
	         * needMoreData event when the user hits the bottom of the scrollbar.
	         * <br> Defaults to true
	         */
	        gridOptions.infiniteScrollDown = gridOptions.infiniteScrollDown !== false;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name setScrollDirections
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description Sets the scrollUp and scrollDown flags, handling nulls and undefined,
	       * and also sets the grid.suppressParentScroll
	       * @param {grid} grid the grid we're operating on
	       * @param {boolean} scrollUp whether there are pages available up - defaults to false
	       * @param {boolean} scrollDown whether there are pages available down - defaults to true
	       */
	      setScrollDirections:  function ( grid, scrollUp, scrollDown ) {
	        grid.infiniteScroll.scrollUp = ( scrollUp === true );
	        grid.suppressParentScrollUp = ( scrollUp === true );
	
	        grid.infiniteScroll.scrollDown = ( scrollDown !== false);
	        grid.suppressParentScrollDown = ( scrollDown !== false);
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name handleScroll
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description Called whenever the grid scrolls, determines whether the scroll should
	       * trigger an infinite scroll request for more data
	       * @param {object} args the args from the event
	       */
	      handleScroll:  function (args) {
	        // don't request data if already waiting for data, or if source is coming from ui.grid.adjustInfiniteScrollPosition() function
	        if ( args.grid.infiniteScroll && args.grid.infiniteScroll.dataLoading || args.source === 'ui.grid.adjustInfiniteScrollPosition' ) {
	          return;
	        }
	
	        if (args.y) {
	
	          // If the user is scrolling very quickly all the way to the top/bottom, the scroll handler can get confused
	          // about the direction. First we check if they've gone all the way, and data always is loaded in this case.
	          if (args.y.percentage === 0) {
	            args.grid.scrollDirection = uiGridConstants.scrollDirection.UP;
	            service.loadData(args.grid);
	          }
	          else if (args.y.percentage === 1) {
	            args.grid.scrollDirection = uiGridConstants.scrollDirection.DOWN;
	            service.loadData(args.grid);
	          }
	          else { // Scroll position is somewhere in between top/bottom, so determine whether it's far enough to load more data.
	            var percentage,
	              targetPercentage = args.grid.options.infiniteScrollRowsFromEnd / args.grid.renderContainers.body.visibleRowCache.length;
	
	            if (args.grid.scrollDirection === uiGridConstants.scrollDirection.UP ) {
	              percentage = args.y.percentage;
	              if (percentage <= targetPercentage) {
	                service.loadData(args.grid);
	              }
	            }
	            else if (args.grid.scrollDirection === uiGridConstants.scrollDirection.DOWN) {
	              percentage = 1 - args.y.percentage;
	              if (percentage <= targetPercentage) {
	                service.loadData(args.grid);
	              }
	            }
	          }
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name loadData
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description This function fires 'needLoadMoreData' or 'needLoadMoreDataTop' event based on scrollDirection
	       * and whether there are more pages upwards or downwards.  It also stores the number of rows that we had previously,
	       * and clears out any saved scroll position so that we know whether or not the user calls `saveScrollPercentage`
	       * @param {Grid} grid the grid we're working on
	       */
	      loadData: function (grid) {
	        // save number of currently visible rows to calculate new scroll position later - we know that we want
	        // to be at approximately the row we're currently at
	        grid.infiniteScroll.previousVisibleRows = grid.renderContainers.body.visibleRowCache.length;
	        grid.infiniteScroll.direction = grid.scrollDirection;
	        delete grid.infiniteScroll.prevScrollTop;
	
	        if (grid.scrollDirection === uiGridConstants.scrollDirection.UP && grid.infiniteScroll.scrollUp ) {
	          grid.infiniteScroll.dataLoading = true;
	          grid.api.infiniteScroll.raise.needLoadMoreDataTop();
	        }
	        else if (grid.scrollDirection === uiGridConstants.scrollDirection.DOWN && grid.infiniteScroll.scrollDown ) {
	          grid.infiniteScroll.dataLoading = true;
	          grid.api.infiniteScroll.raise.needLoadMoreData();
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name adjustScroll
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description Once we are informed that data has been loaded, adjust the scroll position to account for that
	       * addition and to make things look clean.
	       *
	       * If we're scrolling up we scroll to the first row of the old data set -
	       * so we're assuming that you would have gotten to the top of the grid (from the 20% need more data trigger) by
	       * the time the data comes back.  If we're scrolling down we scroll to the last row of the old data set - so we're
	       * assuming that you would have gotten to the bottom of the grid (from the 80% need more data trigger) by the time
	       * the data comes back.
	       *
	       * Neither of these are good assumptions, but making this a smoother experience really requires
	       * that trigger to not be a percentage, and to be much closer to the end of the data (say, 5 rows off the end).  Even then
	       * it'd be better still to actually run into the end.  But if the data takes a while to come back, they may have scrolled
	       * somewhere else in the mean-time, in which case they'll get a jump back to the new data.  Anyway, this will do for
	       * now, until someone wants to do better.
	       * @param {Grid} grid the grid we're working on
	       * @returns {promise} a promise that is resolved when scrolling has finished
	       */
	      adjustScroll: function(grid) {
	        var promise = $q.defer();
	        $rootScope.$applyAsync(function () {
	          var viewportHeight, rowHeight, newVisibleRows, oldTop, newTop;
	
	          viewportHeight = grid.getViewportHeight() + grid.headerHeight - grid.renderContainers.body.headerHeight - grid.scrollbarHeight;
	          rowHeight = grid.options.rowHeight;
	
	          if ( grid.infiniteScroll.direction === undefined ) {
	            // called from initialize, tweak our scroll up a little
	            service.adjustInfiniteScrollPosition(grid, 0);
	          }
	
	          newVisibleRows = grid.getVisibleRowCount();
	
	          // in case not enough data is loaded to enable scroller - load more data
	          var canvasHeight = rowHeight * newVisibleRows;
	          if (grid.infiniteScroll.scrollDown && (viewportHeight > canvasHeight)) {
	            grid.api.infiniteScroll.raise.needLoadMoreData();
	          }
	
	          if ( grid.infiniteScroll.direction === uiGridConstants.scrollDirection.UP ) {
	            oldTop = grid.infiniteScroll.prevScrollTop || 0;
	            newTop = oldTop + (newVisibleRows - grid.infiniteScroll.previousVisibleRows)*rowHeight;
	            service.adjustInfiniteScrollPosition(grid, newTop);
	            $rootScope.$applyAsync( function() {
	              promise.resolve();
	            });
	          }
	
	          if ( grid.infiniteScroll.direction === uiGridConstants.scrollDirection.DOWN ) {
	            newTop = grid.infiniteScroll.prevScrollTop || (grid.infiniteScroll.previousVisibleRows*rowHeight - viewportHeight);
	            service.adjustInfiniteScrollPosition(grid, newTop);
	            $rootScope.$applyAsync( function() {
	              promise.resolve();
	            });
	          }
	        }, 0);
	
	        return promise.promise;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name adjustInfiniteScrollPosition
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description This function fires 'needLoadMoreData' or 'needLoadMoreDataTop' event based on scrollDirection
	       * @param {Grid} grid the grid we're working on
	       * @param {number} scrollTop the position through the grid that we want to scroll to
	       */
	      adjustInfiniteScrollPosition: function (grid, scrollTop) {
	        var scrollEvent = new ScrollEvent(grid, null, null, 'ui.grid.adjustInfiniteScrollPosition'),
	          visibleRows = grid.getVisibleRowCount(),
	          viewportHeight = grid.getViewportHeight() + grid.headerHeight - grid.renderContainers.body.headerHeight - grid.scrollbarHeight,
	          rowHeight = grid.options.rowHeight,
	          scrollHeight = visibleRows*rowHeight-viewportHeight;
	
	        // for infinite scroll, if there are pages upwards then never allow it to be at the zero position so the up button can be active
	        if (scrollTop === 0 && grid.infiniteScroll.scrollUp) {
	          // using pixels results in a relative scroll, hence we have to use percentage
	          scrollEvent.y = {pixels: 1};
	        }
	        else {
	          scrollEvent.y = {percentage: scrollTop/scrollHeight};
	        }
	        grid.scrollContainers('', scrollEvent);
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name dataRemovedTop
	       * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	       * @description Adjusts the scroll position after you've removed data at the top. You should
	       * have called `saveScrollPercentage` before you remove the data, and if you're doing this in
	       * response to a `needMoreData` you should wait until the promise from `loadData` has resolved
	       * before you start removing data
	       * @param {Grid} grid the grid we're working on
	       * @param {boolean} scrollUp flag that there are pages upwards, fire
	       * infinite scroll events upward
	       * @param {boolean} scrollDown flag that there are pages downwards, so
	       * fire infinite scroll events downward
	       */
	      dataRemovedTop: function( grid, scrollUp, scrollDown ) {
	        var newVisibleRows, oldTop, newTop, rowHeight;
	        service.setScrollDirections( grid, scrollUp, scrollDown );
	
	        newVisibleRows = grid.renderContainers.body.visibleRowCache.length;
	        oldTop = grid.infiniteScroll.prevScrollTop;
	        rowHeight = grid.options.rowHeight;
	
	        // since we removed from the top, our new scroll row will be the old scroll row less the number
	        // of rows removed
	        newTop = oldTop - ( grid.infiniteScroll.previousVisibleRows - newVisibleRows )*rowHeight;
	
	        service.adjustInfiniteScrollPosition( grid, newTop );
	      },
	
	      /**
	       * @ngdoc function
	       * @name dataRemovedBottom
	       * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	       * @description Adjusts the scroll position after you've removed data at the bottom.  You should
	       * have called `saveScrollPercentage` before you remove the data, and if you're doing this in
	       * response to a `needMoreData` you should wait until the promise from `loadData` has resolved
	       * before you start removing data
	       * @param {Grid} grid the grid we're working on
	       * @param {boolean} scrollUp flag that there are pages upwards, fire
	       * infinite scroll events upward
	       * @param {boolean} scrollDown flag that there are pages downwards, so
	       * fire infinite scroll events downward
	       */
	      dataRemovedBottom: function( grid, scrollUp, scrollDown ) {
	        var newTop;
	
	        service.setScrollDirections( grid, scrollUp, scrollDown );
	
	        newTop = grid.infiniteScroll.prevScrollTop;
	
	        service.adjustInfiniteScrollPosition( grid, newTop );
	      }
	    };
	    return service;
	  }]);
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.infiniteScroll.directive:uiGridInfiniteScroll
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds infinite scroll features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.infiniteScroll']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Alex', car: 'Toyota' },
	            { name: 'Sam', car: 'Lexus' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name'},
	        {name: 'car'}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-infinite-scroll="20"></div>
	   </div>
	   </file>
	   </example>
	   */
	
	  module.directive('uiGridInfiniteScroll', ['uiGridInfiniteScrollService',
	    function (uiGridInfiniteScrollService) {
	      return {
	        priority: -200,
	        scope: false,
	        require: '^uiGrid',
	        compile: function() {
	          return {
	            pre: function($scope, $elm, $attr, uiGridCtrl) {
	              uiGridInfiniteScrollService.initializeGrid(uiGridCtrl.grid, $scope);
	            },
	            post: function($scope, $elm, $attr) {
	            }
	          };
	        }
	      };
	    }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.moveColumns
	   * @description
	   *
	   * # ui.grid.moveColumns
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides column moving capability to ui.grid. It enables to change the position of columns.
	   * <div doc-module-components="ui.grid.moveColumns"></div>
	   */
	  var module = angular.module('ui.grid.moveColumns', ['ui.grid']);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.moveColumns.service:uiGridMoveColumnService
	   *  @description Service for column moving feature.
	   */
	  module.service('uiGridMoveColumnService', ['$q', '$rootScope', '$log', 'ScrollEvent', 'uiGridConstants', 'gridUtil', function ($q, $rootScope, $log, ScrollEvent, uiGridConstants, gridUtil) {
	    var service = {
	      initializeGrid: function (grid) {
	        var self = this;
	        this.registerPublicApi(grid);
	        this.defaultGridOptions(grid.options);
	        grid.moveColumns = {orderCache: []}; // Used to cache the order before columns are rebuilt
	        grid.registerColumnBuilder(self.movableColumnBuilder);
	        grid.registerDataChangeCallback(self.verifyColumnOrder, [uiGridConstants.dataChange.COLUMN]);
	      },
	      registerPublicApi: function (grid) {
	        var self = this;
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.moveColumns.api:PublicApi
	         *  @description Public Api for column moving feature.
	         */
	        var publicApi = {
	          events: {
	            /**
	             * @ngdoc event
	             * @name columnPositionChanged
	             * @eventOf  ui.grid.moveColumns.api:PublicApi
	             * @description raised when column is moved
	             * <pre>
	             *      gridApi.colMovable.on.columnPositionChanged(scope,function(colDef, originalPosition, newPosition) {})
	             * </pre>
	             * @param {object} colDef the column that was moved
	             * @param {integer} originalPosition of the column
	             * @param {integer} finalPosition of the column
	             */
	            colMovable: {
	              columnPositionChanged: function (colDef, originalPosition, newPosition) {
	              }
	            }
	          },
	          methods: {
	            /**
	             * @ngdoc method
	             * @name moveColumn
	             * @methodOf  ui.grid.moveColumns.api:PublicApi
	             * @description Method can be used to change column position.
	             * <pre>
	             *      gridApi.colMovable.moveColumn(oldPosition, newPosition)
	             * </pre>
	             * @param {integer} originalPosition of the column
	             * @param {integer} finalPosition of the column
	             */
	            colMovable: {
	              moveColumn: function (originalPosition, finalPosition) {
	                var columns = grid.columns;
	                if (!angular.isNumber(originalPosition) || !angular.isNumber(finalPosition)) {
	                  gridUtil.logError('MoveColumn: Please provide valid values for originalPosition and finalPosition');
	                  return;
	                }
	                var nonMovableColumns = 0;
	                for (var i = 0; i < columns.length; i++) {
	                  if ((angular.isDefined(columns[i].colDef.visible) && columns[i].colDef.visible === false) || columns[i].isRowHeader === true) {
	                    nonMovableColumns++;
	                  }
	                }
	                if (originalPosition >= (columns.length - nonMovableColumns) || finalPosition >= (columns.length - nonMovableColumns)) {
	                  gridUtil.logError('MoveColumn: Invalid values for originalPosition, finalPosition');
	                  return;
	                }
	                var findPositionForRenderIndex = function (index) {
	                  var position = index;
	                  for (var i = 0; i <= position; i++) {
	                    if (angular.isDefined(columns[i]) && ((angular.isDefined(columns[i].colDef.visible) && columns[i].colDef.visible === false) || columns[i].isRowHeader === true)) {
	                      position++;
	                    }
	                  }
	                  return position;
	                };
	                self.redrawColumnAtPosition(grid, findPositionForRenderIndex(originalPosition), findPositionForRenderIndex(finalPosition));
	              }
	            }
	          }
	        };
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	      defaultGridOptions: function (gridOptions) {
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.moveColumns.api:GridOptions
	         *
	         *  @description Options for configuring the move column feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	        /**
	         *  @ngdoc object
	         *  @name enableColumnMoving
	         *  @propertyOf  ui.grid.moveColumns.api:GridOptions
	         *  @description If defined, sets the default value for the colMovable flag on each individual colDefs
	         *  if their individual enableColumnMoving configuration is not defined. Defaults to true.
	         */
	        gridOptions.enableColumnMoving = gridOptions.enableColumnMoving !== false;
	      },
	      movableColumnBuilder: function (colDef, col, gridOptions) {
	        var promises = [];
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.moveColumns.api:ColumnDef
	         *
	         *  @description Column Definition for move column feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	         */
	        /**
	         *  @ngdoc object
	         *  @name enableColumnMoving
	         *  @propertyOf  ui.grid.moveColumns.api:ColumnDef
	         *  @description Enable column moving for the column.
	         */
	        colDef.enableColumnMoving = colDef.enableColumnMoving === undefined ? gridOptions.enableColumnMoving
	          : colDef.enableColumnMoving;
	        return $q.all(promises);
	      },
	      /**
	       * @ngdoc method
	       * @name updateColumnCache
	       * @methodOf  ui.grid.moveColumns
	       * @description Cache the current order of columns, so we can restore them after new columnDefs are defined
	       */
	      updateColumnCache: function(grid) {
	        grid.moveColumns.orderCache = grid.getOnlyDataColumns();
	      },
	      /**
	       * @ngdoc method
	       * @name verifyColumnOrder
	       * @methodOf  ui.grid.moveColumns
	       * @description dataChangeCallback which uses the cached column order to restore the column order
	       * when it is reset by altering the columnDefs array.
	       */
	      verifyColumnOrder: function(grid) {
	        var headerRowOffset = grid.rowHeaderColumns.length;
	        var newIndex;
	
	        angular.forEach(grid.moveColumns.orderCache, function(cacheCol, cacheIndex) {
	          newIndex = grid.columns.indexOf(cacheCol);
	          if ( newIndex !== -1 && newIndex - headerRowOffset !== cacheIndex ) {
	            var column = grid.columns.splice(newIndex, 1)[0];
	            grid.columns.splice(cacheIndex + headerRowOffset, 0, column);
	          }
	        });
	      },
	      redrawColumnAtPosition: function (grid, originalPosition, newPosition) {
	        var columns = grid.columns;
	
	        if (originalPosition === newPosition) {
	          return;
	        }
	
	        // check columns in between move-range to make sure they are visible columns
	        var pos = (originalPosition < newPosition) ? originalPosition + 1 : originalPosition - 1;
	        var i0 = Math.min(pos, newPosition);
	        for (i0; i0 <= Math.max(pos, newPosition); i0++) {
	          if (columns[i0].visible) {
	            break;
	          }
	        }
	        if (i0 > Math.max(pos, newPosition)) {
	          // no visible column found, column did not visibly move
	          return;
	        }
	
	        var originalColumn = columns[originalPosition];
	        if (originalColumn.colDef.enableColumnMoving) {
	          if (originalPosition > newPosition) {
	            for (var i1 = originalPosition; i1 > newPosition; i1--) {
	              columns[i1] = columns[i1 - 1];
	            }
	          }
	          else if (newPosition > originalPosition) {
	            for (var i2 = originalPosition; i2 < newPosition; i2++) {
	              columns[i2] = columns[i2 + 1];
	            }
	          }
	          columns[newPosition] = originalColumn;
	          service.updateColumnCache(grid);
	          grid.queueGridRefresh();
	          $rootScope.$applyAsync(function () {
	            grid.api.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
	            grid.api.colMovable.raise.columnPositionChanged(originalColumn.colDef, originalPosition, newPosition);
	          });
	        }
	      }
	    };
	    return service;
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.moveColumns.directive:uiGridMoveColumns
	   *  @element div
	   *  @restrict A
	   *  @description Adds column moving features to the ui-grid directive.
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.moveColumns']);
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	        $scope.data = [
	          { name: 'Bob', title: 'CEO', age: 45 },
	          { name: 'Frank', title: 'Lowly Developer', age: 25 },
	          { name: 'Jenny', title: 'Highly Developer', age: 35 }
	        ];
	        $scope.columnDefs = [
	          {name: 'name'},
	          {name: 'title'},
	          {name: 'age'}
	        ];
	      }]);
	   </file>
	   <file name="main.css">
	   .grid {
	      width: 100%;
	      height: 150px;
	    }
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div class="grid" ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-move-columns></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridMoveColumns', ['uiGridMoveColumnService', function (uiGridMoveColumnService) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridMoveColumnService.initializeGrid(uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.moveColumns.directive:uiGridHeaderCell
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Stacks on top of ui.grid.uiGridHeaderCell to provide capability to be able to move it to reposition column.
	   *
	   *  On receiving mouseDown event headerCell is cloned, now as the mouse moves the cloned header cell also moved in the grid.
	   *  In case the moving cloned header cell reaches the left or right extreme of grid, grid scrolling is triggered (if horizontal scroll exists).
	   *  On mouseUp event column is repositioned at position where mouse is released and cloned header cell is removed.
	   *
	   *  Events that invoke cloning of header cell:
	   *    - mousedown
	   *
	   *  Events that invoke movement of cloned header cell:
	   *    - mousemove
	   *
	   *  Events that invoke repositioning of column:
	   *    - mouseup
	   */
	  module.directive('uiGridHeaderCell', ['$q', 'gridUtil', 'uiGridMoveColumnService', '$document', '$log', 'uiGridConstants', 'ScrollEvent',
	    function ($q, gridUtil, uiGridMoveColumnService, $document, $log, uiGridConstants, ScrollEvent) {
	      return {
	        priority: -10,
	        require: '^uiGrid',
	        compile: function () {
	          return {
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	              if ($scope.col.colDef.enableColumnMoving) {
	
	                /*
	                 * Our general approach to column move is that we listen to a touchstart or mousedown
	                 * event over the column header.  When we hear one, then we wait for a move of the same type
	                 * - if we are a touchstart then we listen for a touchmove, if we are a mousedown we listen for
	                 * a mousemove (i.e. a drag) before we decide that there's a move underway.  If there's never a move,
	                 * and we instead get a mouseup or a touchend, then we just drop out again and do nothing.
	                 *
	                 */
	                var $contentsElm = angular.element( $elm[0].querySelectorAll('.ui-grid-cell-contents') );
	
	                var gridLeft;
	                var previousMouseX;
	                var totalMouseMovement;
	                var rightMoveLimit;
	                var elmCloned = false;
	                var movingElm;
	                var reducedWidth;
	                var moveOccurred = false;
	
	                var downFn = function( event ) {
	                  // Setting some variables required for calculations.
	                  gridLeft = $scope.grid.element[0].getBoundingClientRect().left;
	                  if ( $scope.grid.hasLeftContainer() ) {
	                    gridLeft += $scope.grid.renderContainers.left.header[0].getBoundingClientRect().width;
	                  }
	
	                  previousMouseX = event.pageX || (event.originalEvent ? event.originalEvent.pageX : 0);
	                  totalMouseMovement = 0;
	                  rightMoveLimit = gridLeft + $scope.grid.getViewportWidth();
	
	                  if ( event.type === 'mousedown' ) {
	                    $document.on('mousemove', moveFn);
	                    $document.on('mouseup', upFn);
	                  }
	                  else if ( event.type === 'touchstart' ) {
	                    $document.on('touchmove', moveFn);
	                    $document.on('touchend', upFn);
	                  }
	                };
	
	                var moveFn = function( event ) {
	                  var pageX = event.pageX || (event.originalEvent ? event.originalEvent.pageX : 0);
	                  var changeValue = pageX - previousMouseX;
	                  if ( changeValue === 0 ) { return; }
	                  // Disable text selection in Chrome during column move
	                  document.onselectstart = function() { return false; };
	
	                  moveOccurred = true;
	
	                  if (!elmCloned) {
	                    cloneElement();
	                  }
	                  else if (elmCloned) {
	                    moveElement(changeValue);
	                    previousMouseX = pageX;
	                  }
	                };
	
	                var upFn = function( event ) {
	                  // Re-enable text selection after column move
	                  document.onselectstart = null;
	
	                  // Remove the cloned element on mouse up.
	                  if (movingElm) {
	                    movingElm.remove();
	                    elmCloned = false;
	                  }
	
	                  offAllEvents();
	                  onDownEvents();
	
	                  if (!moveOccurred) {
	                    return;
	                  }
	
	                  var columns = $scope.grid.columns;
	                  var columnIndex = 0;
	                  for (var i = 0; i < columns.length; i++) {
	                    if (columns[i].colDef.name !== $scope.col.colDef.name) {
	                      columnIndex++;
	                    }
	                    else {
	                      break;
	                    }
	                  }
	
	                  var targetIndex;
	
	                  // Case where column should be moved to a position on its left
	                  if (totalMouseMovement < 0) {
	                    var totalColumnsLeftWidth = 0;
	                    var il;
	                    if ( $scope.grid.isRTL() ) {
	                      for (il = columnIndex + 1; il < columns.length; il++) {
	                        if (angular.isUndefined(columns[il].colDef.visible) || columns[il].colDef.visible === true) {
	                          totalColumnsLeftWidth += columns[il].drawnWidth || columns[il].width || columns[il].colDef.width;
	                          if (totalColumnsLeftWidth > Math.abs(totalMouseMovement)) {
	                            uiGridMoveColumnService.redrawColumnAtPosition
	                            ($scope.grid, columnIndex, il - 1);
	                            break;
	                          }
	                        }
	                      }
	                    }
	                    else {
	                      for (il = columnIndex - 1; il >= 0; il--) {
	                        if (angular.isUndefined(columns[il].colDef.visible) || columns[il].colDef.visible === true) {
	                          totalColumnsLeftWidth += columns[il].drawnWidth || columns[il].width || columns[il].colDef.width;
	                          if (totalColumnsLeftWidth > Math.abs(totalMouseMovement)) {
	                            uiGridMoveColumnService.redrawColumnAtPosition
	                            ($scope.grid, columnIndex, il + 1);
	                            break;
	                          }
	                        }
	                      }
	                    }
	
	                    // Case where column should be moved to beginning (or end in RTL) of the grid.
	                    if (totalColumnsLeftWidth < Math.abs(totalMouseMovement)) {
	                      targetIndex = 0;
	                      if ( $scope.grid.isRTL() ) {
	                        targetIndex = columns.length - 1;
	                      }
	                      uiGridMoveColumnService.redrawColumnAtPosition
	                      ($scope.grid, columnIndex, targetIndex);
	                    }
	                  }
	
	                  // Case where column should be moved to a position on its right
	                  else if (totalMouseMovement > 0) {
	                    var totalColumnsRightWidth = 0;
	                    var ir;
	                    if ( $scope.grid.isRTL() ) {
	                      for (ir = columnIndex - 1; ir > 0; ir--) {
	                        if (angular.isUndefined(columns[ir].colDef.visible) || columns[ir].colDef.visible === true) {
	                          totalColumnsRightWidth += columns[ir].drawnWidth || columns[ir].width || columns[ir].colDef.width;
	                          if (totalColumnsRightWidth > totalMouseMovement) {
	                            uiGridMoveColumnService.redrawColumnAtPosition
	                            ($scope.grid, columnIndex, ir);
	                            break;
	                          }
	                        }
	                      }
	                    }
	                    else {
	                      for (ir = columnIndex + 1; ir < columns.length; ir++) {
	                        if (angular.isUndefined(columns[ir].colDef.visible) || columns[ir].colDef.visible === true) {
	                          totalColumnsRightWidth += columns[ir].drawnWidth || columns[ir].width || columns[ir].colDef.width;
	                          if (totalColumnsRightWidth > totalMouseMovement) {
	                            uiGridMoveColumnService.redrawColumnAtPosition
	                            ($scope.grid, columnIndex, ir - 1);
	                            break;
	                          }
	                        }
	                      }
	                    }
	
	
	                    // Case where column should be moved to end (or beginning in RTL) of the grid.
	                    if (totalColumnsRightWidth < totalMouseMovement) {
	                      targetIndex = columns.length - 1;
	                      if ( $scope.grid.isRTL() ) {
	                        targetIndex = 0;
	                      }
	                      uiGridMoveColumnService.redrawColumnAtPosition
	                      ($scope.grid, columnIndex, targetIndex);
	                    }
	                  }
	
	
	
	                };
	
	                var onDownEvents = function() {
	                  $contentsElm.on('touchstart', downFn);
	                  $contentsElm.on('mousedown', downFn);
	                };
	
	                var offAllEvents = function() {
	                  $contentsElm.off('touchstart', downFn);
	                  $contentsElm.off('mousedown', downFn);
	
	                  $document.off('mousemove', moveFn);
	                  $document.off('touchmove', moveFn);
	
	                  $document.off('mouseup', upFn);
	                  $document.off('touchend', upFn);
	                };
	
	                onDownEvents();
	
	
	                var cloneElement = function () {
	                  elmCloned = true;
	
	                  // Cloning header cell and appending to current header cell.
	                  movingElm = $elm.clone();
	                  $elm.parent().append(movingElm);
	
	                  // Left of cloned element should be aligned to original header cell.
	                  movingElm.addClass('movingColumn');
	                  var movingElementStyles = {};
	                  movingElementStyles.left = $elm[0].offsetLeft + 'px';
	                  var gridRight = $scope.grid.element[0].getBoundingClientRect().right;
	                  var elmRight = $elm[0].getBoundingClientRect().right;
	                  if (elmRight > gridRight) {
	                    reducedWidth = $scope.col.drawnWidth + (gridRight - elmRight);
	                    movingElementStyles.width = reducedWidth + 'px';
	                  }
	                  movingElm.css(movingElementStyles);
	                };
	
	                var moveElement = function (changeValue) {
	                  // Calculate total column width
	                  var columns = $scope.grid.columns;
	                  var totalColumnWidth = 0;
	                  for (var i = 0; i < columns.length; i++) {
	                    if (angular.isUndefined(columns[i].colDef.visible) || columns[i].colDef.visible === true) {
	                      totalColumnWidth += columns[i].drawnWidth || columns[i].width || columns[i].colDef.width;
	                    }
	                  }
	
	                  // Calculate new position of left of column
	                  var currentElmLeft = movingElm[0].getBoundingClientRect().left - 1;
	                  var currentElmRight = movingElm[0].getBoundingClientRect().right;
	                  var newElementLeft;
	
	                  newElementLeft = currentElmLeft - gridLeft + changeValue;
	                  newElementLeft = newElementLeft < rightMoveLimit ? newElementLeft : rightMoveLimit;
	
	                  // Update css of moving column to adjust to new left value or fire scroll in case column has reached edge of grid
	                  if ((currentElmLeft >= gridLeft || changeValue > 0) && (currentElmRight <= rightMoveLimit || changeValue < 0)) {
	                    movingElm.css({visibility: 'visible', 'left': (movingElm[0].offsetLeft +
	                    (newElementLeft < rightMoveLimit ? changeValue : (rightMoveLimit - currentElmLeft))) + 'px'});
	                  }
	                  else if (totalColumnWidth > Math.ceil(uiGridCtrl.grid.gridWidth)) {
	                    changeValue *= 8;
	                    var scrollEvent = new ScrollEvent($scope.col.grid, null, null, 'uiGridHeaderCell.moveElement');
	                    scrollEvent.x = {pixels: changeValue};
	                    scrollEvent.grid.scrollContainers('',scrollEvent);
	                  }
	
	                  // Calculate total width of columns on the left of the moving column and the mouse movement
	                  var totalColumnsLeftWidth = 0;
	                  for (var il = 0; il < columns.length; il++) {
	                    if (angular.isUndefined(columns[il].colDef.visible) || columns[il].colDef.visible === true) {
	                      if (columns[il].colDef.name !== $scope.col.colDef.name) {
	                        totalColumnsLeftWidth += columns[il].drawnWidth || columns[il].width || columns[il].colDef.width;
	                      }
	                      else {
	                        break;
	                      }
	                    }
	                  }
	                  if ($scope.newScrollLeft === undefined) {
	                    totalMouseMovement += changeValue;
	                  }
	                  else {
	                    totalMouseMovement = $scope.newScrollLeft + newElementLeft - totalColumnsLeftWidth;
	                  }
	
	                  // Increase width of moving column, in case the rightmost column was moved and its width was
	                  // decreased because of overflow
	                  if (reducedWidth < $scope.col.drawnWidth) {
	                    reducedWidth += Math.abs(changeValue);
	                    movingElm.css({'width': reducedWidth + 'px'});
	                  }
	                };
	
	                $scope.$on('$destroy', offAllEvents);
	              }
	            }
	          };
	        }
	      };
	    }]);
	})();
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.pagination
	   *
	   * @description
	   *
	   * # ui.grid.pagination
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides pagination support to ui-grid
	   */
	  var module = angular.module('ui.grid.pagination', ['ng', 'ui.grid']);
	
	  /**
	   * @ngdoc service
	   * @name ui.grid.pagination.service:uiGridPaginationService
	   *
	   * @description Service for the pagination feature
	   */
	  module.service('uiGridPaginationService', ['gridUtil',
	    function (gridUtil) {
	      var service = {
	        /**
	         * @ngdoc method
	         * @name initializeGrid
	         * @methodOf ui.grid.pagination.service:uiGridPaginationService
	         * @description Attaches the service to a certain grid
	         * @param {Grid} grid The grid we want to work with
	         */
	        initializeGrid: function (grid) {
	          service.defaultGridOptions(grid.options);
	
	          /**
	          * @ngdoc object
	          * @name ui.grid.pagination.api:PublicAPI
	          *
	          * @description Public API for the pagination feature
	          */
	          var publicApi = {
	            events: {
	              pagination: {
	              /**
	               * @ngdoc event
	               * @name paginationChanged
	               * @eventOf ui.grid.pagination.api:PublicAPI
	               * @description This event fires when the pageSize or currentPage changes
	               * @param {int} currentPage requested page number
	               * @param {int} pageSize requested page size
	               */
	                paginationChanged: function (currentPage, pageSize) { }
	              }
	            },
	            methods: {
	              pagination: {
	                /**
	                 * @ngdoc method
	                 * @name getPage
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Returns the number of the current page
	                 */
	                getPage: function () {
	                  return grid.options.enablePagination ? grid.options.paginationCurrentPage : null;
	                },
	                /**
	                 * @ngdoc method
	                 * @name getFirstRowIndex
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Returns the index of the first row of the current page.
	                 */
	                getFirstRowIndex: function () {
	                  if (grid.options.useCustomPagination) {
	                    return grid.options.paginationPageSizes.reduce(function(result, size, index) {
	                      return index < grid.options.paginationCurrentPage - 1 ? result + size : result;
	                    }, 0);
	                  }
	                  return ((grid.options.paginationCurrentPage - 1) * grid.options.paginationPageSize);
	                },
	                /**
	                 * @ngdoc method
	                 * @name getLastRowIndex
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Returns the index of the last row of the current page.
	                 */
	                getLastRowIndex: function () {
	                  if (grid.options.useCustomPagination) {
	                    return publicApi.methods.pagination.getFirstRowIndex() + grid.options.paginationPageSizes[grid.options.paginationCurrentPage - 1] - 1;
	                  }
	                  return Math.min(grid.options.paginationCurrentPage * grid.options.paginationPageSize, grid.options.totalItems) - 1;
	                },
	                /**
	                 * @ngdoc method
	                 * @name getTotalPages
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Returns the total number of pages
	                 */
	                getTotalPages: function () {
	                  if (!grid.options.enablePagination) {
	                    return null;
	                  }
	
	                  if (grid.options.useCustomPagination) {
	                    return grid.options.paginationPageSizes.length;
	                  }
	
	                  return (grid.options.totalItems === 0) ? 1 : Math.ceil(grid.options.totalItems / grid.options.paginationPageSize);
	                },
	                /**
	                 * @ngdoc method
	                 * @name nextPage
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Moves to the next page, if possible
	                 */
	                nextPage: function () {
	                  if (!grid.options.enablePagination) {
	                    return;
	                  }
	
	                  if (grid.options.totalItems > 0) {
	                    grid.options.paginationCurrentPage = Math.min(
	                      grid.options.paginationCurrentPage + 1,
	                      publicApi.methods.pagination.getTotalPages()
	                    );
	                  }
	                  else {
	                    grid.options.paginationCurrentPage++;
	                  }
	                },
	                /**
	                 * @ngdoc method
	                 * @name previousPage
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Moves to the previous page, if we're not on the first page
	                 */
	                previousPage: function () {
	                  if (!grid.options.enablePagination) {
	                    return;
	                  }
	
	                  grid.options.paginationCurrentPage = Math.max(grid.options.paginationCurrentPage - 1, 1);
	                },
	                /**
	                 * @ngdoc method
	                 * @name seek
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Moves to the requested page
	                 * @param {int} page The number of the page that should be displayed
	                 */
	                seek: function (page) {
	                  if (!grid.options.enablePagination) {
	                    return;
	                  }
	                  if (!angular.isNumber(page) || page < 1) {
	                    throw 'Invalid page number: ' + page;
	                  }
	
	                  grid.options.paginationCurrentPage = Math.min(page, publicApi.methods.pagination.getTotalPages());
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	          var processPagination = function( renderableRows ) {
	            if (grid.options.useExternalPagination || !grid.options.enablePagination) {
	              return renderableRows;
	            }
	            // client side pagination
	            var pageSize = parseInt(grid.options.paginationPageSize, 10);
	            var currentPage = parseInt(grid.options.paginationCurrentPage, 10);
	
	            var visibleRows = renderableRows.filter(function (row) { return row.visible; });
	            grid.options.totalItems = visibleRows.length;
	
	            var firstRow = publicApi.methods.pagination.getFirstRowIndex();
	            var lastRow  = publicApi.methods.pagination.getLastRowIndex();
	
	            if (firstRow > visibleRows.length) {
	              currentPage = grid.options.paginationCurrentPage = 1;
	              firstRow = (currentPage - 1) * pageSize;
	            }
	            return visibleRows.slice(firstRow, lastRow + 1);
	          };
	
	          grid.registerRowsProcessor(processPagination, 900 );
	
	        },
	        defaultGridOptions: function (gridOptions) {
	          /**
	           * @ngdoc object
	           * @name ui.grid.pagination.api:GridOptions
	           *
	           * @description GridOptions for the pagination feature, these are available to be
	           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           * @ngdoc property
	           * @name enablePagination
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Enables pagination.  Defaults to true.
	           */
	          gridOptions.enablePagination = gridOptions.enablePagination !== false;
	          /**
	           * @ngdoc property
	           * @name enablePaginationControls
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Enables the paginator at the bottom of the grid. Turn this off if you want to implement your
	           *              own controls outside the grid.
	           */
	          gridOptions.enablePaginationControls = gridOptions.enablePaginationControls !== false;
	          /**
	           * @ngdoc property
	           * @name useExternalPagination
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Disables client side pagination. When true, handle the paginationChanged event and set data
	           *              and totalItems.  Defaults to `false`
	           */
	          gridOptions.useExternalPagination = gridOptions.useExternalPagination === true;
	
	          /**
	           * @ngdoc property
	           * @name useCustomPagination
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Disables client-side pagination. When true, handle the `paginationChanged` event and set `data`,
	           *              `firstRowIndex`, `lastRowIndex`, and `totalItems`.  Defaults to `false`.
	           */
	          gridOptions.useCustomPagination = gridOptions.useCustomPagination === true;
	
	          /**
	           * @ngdoc property
	           * @name totalItems
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Total number of items, set automatically when using client side pagination, but needs set by user
	           *              for server side pagination
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.totalItems)) {
	            gridOptions.totalItems = 0;
	          }
	          /**
	           * @ngdoc property
	           * @name paginationPageSizes
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Array of page sizes, defaults to `[250, 500, 1000]`
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.paginationPageSizes)) {
	            gridOptions.paginationPageSizes = [250, 500, 1000];
	          }
	          /**
	           * @ngdoc property
	           * @name paginationPageSize
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Page size, defaults to the first item in paginationPageSizes, or 0 if paginationPageSizes is empty
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.paginationPageSize)) {
	            if (gridOptions.paginationPageSizes.length > 0) {
	              gridOptions.paginationPageSize = gridOptions.paginationPageSizes[0];
	            }
	            else {
	              gridOptions.paginationPageSize = 0;
	            }
	          }
	          /**
	           * @ngdoc property
	           * @name paginationCurrentPage
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Current page number, defaults to 1
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.paginationCurrentPage)) {
	            gridOptions.paginationCurrentPage = 1;
	          }
	
	          /**
	           * @ngdoc property
	           * @name paginationTemplate
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description A custom template for the pager, defaults to `ui-grid/pagination`
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.paginationTemplate)) {
	            gridOptions.paginationTemplate = 'ui-grid/pagination';
	          }
	        },
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.pagination.service:uiGridPaginationService
	         * @name uiGridPaginationService
	         * @description  Raises paginationChanged and calls refresh for client side pagination
	         * @param {Grid} grid the grid for which the pagination changed
	         * @param {int} currentPage requested page number
	         * @param {int} pageSize requested page size
	         */
	        onPaginationChanged: function (grid, currentPage, pageSize) {
	          grid.api.pagination.raise.paginationChanged(currentPage, pageSize);
	          if (!grid.options.useExternalPagination) {
	            grid.queueGridRefresh(); // client side pagination
	          }
	        }
	      };
	
	      return service;
	    }
	  ]);
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.pagination.directive:uiGridPagination
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds pagination features to grid
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.pagination']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Alex', car: 'Toyota' },
	        { name: 'Sam', car: 'Lexus' },
	        { name: 'Joe', car: 'Dodge' },
	        { name: 'Bob', car: 'Buick' },
	        { name: 'Cindy', car: 'Ford' },
	        { name: 'Brian', car: 'Audi' },
	        { name: 'Malcom', car: 'Mercedes Benz' },
	        { name: 'Dave', car: 'Ford' },
	        { name: 'Stacey', car: 'Audi' },
	        { name: 'Amy', car: 'Acura' },
	        { name: 'Scott', car: 'Toyota' },
	        { name: 'Ryan', car: 'BMW' },
	      ];
	
	      $scope.gridOptions = {
	        data: 'data',
	        paginationPageSizes: [5, 10, 25],
	        paginationPageSize: 5,
	        columnDefs: [
	          {name: 'name'},
	          {name: 'car'}
	        ]
	       }
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-pagination></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridPagination', ['gridUtil', 'uiGridPaginationService',
	    function (gridUtil, uiGridPaginationService) {
	      return {
	        priority: -200,
	        scope: false,
	        require: 'uiGrid',
	        link: {
	          pre: function ($scope, $elm, $attr, uiGridCtrl) {
	            uiGridPaginationService.initializeGrid(uiGridCtrl.grid);
	
	            gridUtil.getTemplate(uiGridCtrl.grid.options.paginationTemplate)
	              .then(function (contents) {
	                var template = angular.element(contents);
	
	                $elm.append(template);
	                uiGridCtrl.innerCompile(template);
	              });
	          }
	        }
	      };
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.pagination.directive:uiGridPager
	   *  @element div
	   *
	   *  @description Panel for handling pagination
	   */
	  module.directive('uiGridPager', ['uiGridPaginationService', 'uiGridConstants', 'gridUtil', 'i18nService', 'i18nConstants',
	    function (uiGridPaginationService, uiGridConstants, gridUtil, i18nService, i18nConstants) {
	      return {
	        priority: -200,
	        scope: true,
	        require: '^uiGrid',
	        link: function ($scope, $elm, $attr, uiGridCtrl) {
	          var defaultFocusElementSelector = '.ui-grid-pager-control-input';
	
	          $scope.aria = i18nService.getSafeText('pagination.aria'); // Returns an object with all of the aria labels
	
	          var updateLabels = function() {
	            $scope.paginationApi = uiGridCtrl.grid.api.pagination;
	            $scope.sizesLabel = i18nService.getSafeText('pagination.sizes');
	            $scope.totalItemsLabel = i18nService.getSafeText('pagination.totalItems');
	            $scope.paginationOf = i18nService.getSafeText('pagination.of');
	            $scope.paginationThrough = i18nService.getSafeText('pagination.through');
	          };
	
	          updateLabels();
	
	          $scope.$on(i18nConstants.UPDATE_EVENT, updateLabels);
	
	          var options = uiGridCtrl.grid.options;
	
	          uiGridCtrl.grid.renderContainers.body.registerViewportAdjuster(function (adjustment) {
	            if (options.enablePaginationControls) {
	              adjustment.height = adjustment.height - gridUtil.elementHeight($elm, "padding");
	            }
	            return adjustment;
	          });
	
	          var dataChangeDereg = uiGridCtrl.grid.registerDataChangeCallback(function (grid) {
	            if (!grid.options.useExternalPagination) {
	              grid.options.totalItems = grid.rows.length;
	            }
	          }, [uiGridConstants.dataChange.ROW]);
	
	          $scope.$on('$destroy', dataChangeDereg);
	
	          var deregP = $scope.$watch('grid.options.paginationCurrentPage + grid.options.paginationPageSize', function (newValues, oldValues) {
	            if (newValues === oldValues || oldValues === undefined) {
	              return;
	            }
	
	            if (!angular.isNumber(options.paginationCurrentPage) || options.paginationCurrentPage < 1) {
	              options.paginationCurrentPage = 1;
	              return;
	            }
	
	            if (options.totalItems > 0 && options.paginationCurrentPage > $scope.paginationApi.getTotalPages()) {
	              options.paginationCurrentPage = $scope.paginationApi.getTotalPages();
	              return;
	            }
	
	            uiGridPaginationService.onPaginationChanged($scope.grid, options.paginationCurrentPage, options.paginationPageSize);
	          });
	
	          $scope.$on('$destroy', function() {
	            deregP();
	          });
	
	          $scope.cantPageForward = function () {
	            if ($scope.paginationApi.getTotalPages()) {
	              return $scope.cantPageToLast();
	            }
	            else {
	              return options.data.length < 1;
	            }
	          };
	
	          $scope.cantPageToLast = function () {
	            var totalPages = $scope.paginationApi.getTotalPages();
	
	            return !totalPages || options.paginationCurrentPage >= totalPages;
	          };
	
	          $scope.cantPageBackward = function () {
	            return options.paginationCurrentPage <= 1;
	          };
	
	          var focusToInputIf = function(condition) {
	            if (condition) {
	              gridUtil.focus.bySelector($elm, defaultFocusElementSelector);
	            }
	          };
	
	          // Takes care of setting focus to the middle element when focus is lost
	          $scope.pageFirstPageClick = function () {
	            $scope.paginationApi.seek(1);
	            focusToInputIf($scope.cantPageBackward());
	          };
	
	          $scope.pagePreviousPageClick = function () {
	            $scope.paginationApi.previousPage();
	            focusToInputIf($scope.cantPageBackward());
	          };
	
	          $scope.pageNextPageClick = function () {
	            $scope.paginationApi.nextPage();
	            focusToInputIf($scope.cantPageForward());
	          };
	
	          $scope.pageLastPageClick = function () {
	            $scope.paginationApi.seek($scope.paginationApi.getTotalPages());
	            focusToInputIf($scope.cantPageToLast());
	          };
	        }
	      };
	    }
	  ]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.pinning
	   * @description
	   *
	   * # ui.grid.pinning
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides column pinning to the end user via menu options in the column header
	   *
	   * <div doc-module-components="ui.grid.pinning"></div>
	   */
	
	  var module = angular.module('ui.grid.pinning', ['ui.grid']);
	
	  module.constant('uiGridPinningConstants', {
	    container: {
	      LEFT: 'left',
	      RIGHT: 'right',
	      NONE: ''
	    }
	  });
	
	  module.service('uiGridPinningService', ['gridUtil', 'GridRenderContainer', 'i18nService', 'uiGridPinningConstants', function (gridUtil, GridRenderContainer, i18nService, uiGridPinningConstants) {
	    var service = {
	
	      initializeGrid: function (grid) {
	        service.defaultGridOptions(grid.options);
	
	        // Register a column builder to add new menu items for pinning left and right
	        grid.registerColumnBuilder(service.pinningColumnBuilder);
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.pinning.api:PublicApi
	         *
	         *  @description Public Api for pinning feature
	         */
	        var publicApi = {
	          events: {
	            pinning: {
	              /**
	               * @ngdoc event
	               * @name columnPinned
	               * @eventOf ui.grid.pinning.api:PublicApi
	               * @description raised when column pin state has changed
	               * <pre>
	               *   gridApi.pinning.on.columnPinned(scope, function(colDef){})
	               * </pre>
	               * @param {object} colDef the column that was changed
	               * @param {string} container the render container the column is in ('left', 'right', '')
	               */
	              columnPinned: function(colDef, container) {
	              }
	            }
	          },
	          methods: {
	            pinning: {
	              /**
	               * @ngdoc function
	               * @name pinColumn
	               * @methodOf ui.grid.pinning.api:PublicApi
	               * @description pin column left, right, or none
	               * <pre>
	               *   gridApi.pinning.pinColumn(col, uiGridPinningConstants.container.LEFT)
	               * </pre>
	               * @param {gridColumn} col the column being pinned
	               * @param {string} container one of the recognised types
	               * from uiGridPinningConstants
	               */
	              pinColumn: function(col, container) {
	                service.pinColumn(grid, col, container);
	              }
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	
	      defaultGridOptions: function (gridOptions) {
	        // default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.pinning.api:GridOptions
	         *
	         *  @description GridOptions for pinning feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enablePinning
	         *  @propertyOf  ui.grid.pinning.api:GridOptions
	         *  @description Enable pinning for the entire grid.
	         *  <br/>Defaults to true
	         */
	        gridOptions.enablePinning = gridOptions.enablePinning !== false;
	        /**
	         *  @ngdoc object
	         *  @name hidePinLeft
	         *  @propertyOf  ui.grid.pinning.api:GridOptions
	         *  @description Hide Pin Left for the entire grid.
	         *  <br/>Defaults to false
	         */
	        gridOptions.hidePinLeft = gridOptions.enablePinning && gridOptions.hidePinLeft;
	        /**
	         *  @ngdoc object
	         *  @name hidePinRight
	         *  @propertyOf  ui.grid.pinning.api:GridOptions
	         *  @description Hide Pin Right pinning for the entire grid.
	         *  <br/>Defaults to false
	         */
	        gridOptions.hidePinRight = gridOptions.enablePinning && gridOptions.hidePinRight;
	      },
	
	      pinningColumnBuilder: function (colDef, col, gridOptions) {
	        // default to true unless gridOptions or colDef is explicitly false
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.pinning.api:ColumnDef
	         *
	         *  @description ColumnDef for pinning feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enablePinning
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Enable pinning for the individual column.
	         *  <br/>Defaults to true
	         */
	        colDef.enablePinning = colDef.enablePinning === undefined ? gridOptions.enablePinning : colDef.enablePinning;
	        /**
	         *  @ngdoc object
	         *  @name hidePinLeft
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Hide Pin Left for the individual column.
	         *  <br/>Defaults to false
	         */
	        colDef.hidePinLeft = colDef.hidePinLeft === undefined ? gridOptions.hidePinLeft : colDef.hidePinLeft;
	        /**
	         *  @ngdoc object
	         *  @name hidePinRight
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Hide Pin Right for the individual column.
	         *  <br/>Defaults to false
	         */
	        colDef.hidePinRight = colDef.hidePinRight === undefined ? gridOptions.hidePinRight : colDef.hidePinRight;
	
	        /**
	         *  @ngdoc object
	         *  @name pinnedLeft
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Column is pinned left when grid is rendered
	         *  <br/>Defaults to false
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name pinnedRight
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Column is pinned right when grid is rendered
	         *  <br/>Defaults to false
	         */
	        if (colDef.pinnedLeft) {
	          col.renderContainer = 'left';
	          col.grid.createLeftContainer();
	        }
	        else if (colDef.pinnedRight) {
	          col.renderContainer = 'right';
	          col.grid.createRightContainer();
	        }
	
	        if (!colDef.enablePinning) {
	          return;
	        }
	
	        var pinColumnLeftAction = {
	          name: 'ui.grid.pinning.pinLeft',
	          title: i18nService.get().pinning.pinLeft,
	          icon: 'ui-grid-icon-left-open',
	          shown: function () {
	            return typeof(this.context.col.renderContainer) === 'undefined' || !this.context.col.renderContainer || this.context.col.renderContainer !== 'left';
	          },
	          action: function () {
	            service.pinColumn(this.context.col.grid, this.context.col, uiGridPinningConstants.container.LEFT);
	          }
	        };
	
	        var pinColumnRightAction = {
	          name: 'ui.grid.pinning.pinRight',
	          title: i18nService.get().pinning.pinRight,
	          icon: 'ui-grid-icon-right-open',
	          shown: function () {
	            return typeof(this.context.col.renderContainer) === 'undefined' || !this.context.col.renderContainer || this.context.col.renderContainer !== 'right';
	          },
	          action: function () {
	            service.pinColumn(this.context.col.grid, this.context.col, uiGridPinningConstants.container.RIGHT);
	          }
	        };
	
	        var removePinAction = {
	          name: 'ui.grid.pinning.unpin',
	          title: i18nService.get().pinning.unpin,
	          icon: 'ui-grid-icon-cancel',
	          shown: function () {
	            return typeof(this.context.col.renderContainer) !== 'undefined' && this.context.col.renderContainer !== null && this.context.col.renderContainer !== 'body';
	          },
	          action: function () {
	            service.pinColumn(this.context.col.grid, this.context.col, uiGridPinningConstants.container.NONE);
	          }
	        };
	
	        // Skip from menu if hidePinLeft or hidePinRight is true
	        if (!colDef.hidePinLeft && !gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.pinning.pinLeft')) {
	          col.menuItems.push(pinColumnLeftAction);
	        }
	        if (!colDef.hidePinRight && !gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.pinning.pinRight')) {
	          col.menuItems.push(pinColumnRightAction);
	        }
	        if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.pinning.unpin')) {
	          col.menuItems.push(removePinAction);
	        }
	      },
	
	      pinColumn: function(grid, col, container) {
	        if (container === uiGridPinningConstants.container.NONE) {
	          col.renderContainer = null;
	          col.colDef.pinnedLeft = col.colDef.pinnedRight = false;
	        }
	        else {
	          col.renderContainer = container;
	          if (container === uiGridPinningConstants.container.LEFT) {
	            grid.createLeftContainer();
	          }
	          else if (container === uiGridPinningConstants.container.RIGHT) {
	            grid.createRightContainer();
	          }
	        }
	
	        grid.refresh()
	        .then(function() {
	          grid.api.pinning.raise.columnPinned( col.colDef, container );
	        });
	      }
	    };
	
	    return service;
	  }]);
	
	  module.directive('uiGridPinning', ['gridUtil', 'uiGridPinningService',
	    function (gridUtil, uiGridPinningService) {
	      return {
	        require: 'uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              uiGridPinningService.initializeGrid(uiGridCtrl.grid);
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            }
	          };
	        }
	      };
	    }]);
	})();
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.resizeColumns
	   * @description
	   *
	   * # ui.grid.resizeColumns
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module allows columns to be resized.
	   */
	  var module = angular.module('ui.grid.resizeColumns', ['ui.grid']);
	
	  module.service('uiGridResizeColumnsService', ['gridUtil', '$q', '$rootScope',
	    function (gridUtil, $q, $rootScope) {
	      return {
	        defaultGridOptions: function(gridOptions) {
	          // default option to true unless it was explicitly set to false
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.resizeColumns.api:GridOptions
	           *
	           *  @description GridOptions for resizeColumns feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableColumnResizing
	           *  @propertyOf  ui.grid.resizeColumns.api:GridOptions
	           *  @description Enable column resizing on the entire grid
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableColumnResizing = gridOptions.enableColumnResizing !== false;
	
	          // legacy support
	          // use old name if it is explicitly false
	          if (gridOptions.enableColumnResize === false) {
	            gridOptions.enableColumnResizing = false;
	          }
	        },
	
	        colResizerColumnBuilder: function (colDef, col, gridOptions) {
	          var promises = [];
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.resizeColumns.api:ColumnDef
	           *
	           *  @description ColumnDef for resizeColumns feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableColumnResizing
	           *  @propertyOf  ui.grid.resizeColumns.api:ColumnDef
	           *  @description Enable column resizing on an individual column
	           *  <br/>Defaults to GridOptions.enableColumnResizing
	           */
	          // default to true unless gridOptions or colDef is explicitly false
	          colDef.enableColumnResizing = colDef.enableColumnResizing === undefined ? gridOptions.enableColumnResizing : colDef.enableColumnResizing;
	
	
	          // legacy support of old option name
	          if (colDef.enableColumnResize === false) {
	            colDef.enableColumnResizing = false;
	          }
	
	          return $q.all(promises);
	        },
	
	        registerPublicApi: function (grid) {
	            /**
	             *  @ngdoc object
	             *  @name ui.grid.resizeColumns.api:PublicApi
	             *  @description Public Api for column resize feature.
	             */
	            var publicApi = {
	              events: {
	                /**
	                 * @ngdoc event
	                 * @name columnSizeChanged
	                 * @eventOf  ui.grid.resizeColumns.api:PublicApi
	                 * @description raised when column is resized
	                 * <pre>
	                 *      gridApi.colResizable.on.columnSizeChanged(scope,function(colDef, deltaChange) {})
	                 * </pre>
	                 * @param {object} colDef the column that was resized
	                 * @param {integer} delta of the column size change
	                 */
	                colResizable: {
	                  columnSizeChanged: function (colDef, deltaChange) {
	                  }
	                }
	              }
	            };
	            grid.api.registerEventsFromObject(publicApi.events);
	        },
	
	        fireColumnSizeChanged: function (grid, colDef, deltaChange) {
	          $rootScope.$applyAsync(function () {
	            if ( grid.api.colResizable ) {
	              grid.api.colResizable.raise.columnSizeChanged(colDef, deltaChange);
	            } else {
	              gridUtil.logError("The resizeable api is not registered, this may indicate that you've included the module but not added the 'ui-grid-resize-columns' directive to your grid definition.  Cannot raise any events.");
	            }
	          });
	        },
	
	        // get either this column, or the column next to this column, to resize,
	        // returns the column we're going to resize
	        findTargetCol: function(col, position, rtlMultiplier) {
	          var renderContainer = col.getRenderContainer();
	
	          if (position === 'left') {
	            // Get the column to the left of this one
	            var colIndex = renderContainer.visibleColumnCache.indexOf(col);
	            if (colIndex === 0) {
	              return renderContainer.visibleColumnCache[0];
	            }
	            return renderContainer.visibleColumnCache[colIndex - 1 * rtlMultiplier];
	          } else {
	            return col;
	          }
	        }
	      };
	    }]);
	
	
	  /**
	   * @ngdoc directive
	   * @name ui.grid.resizeColumns.directive:uiGridResizeColumns
	   * @element div
	   * @restrict A
	   * @description
	   * Enables resizing for all columns on the grid. If, for some reason, you want to use the ui-grid-resize-columns directive, but not allow column resizing, you can explicitly set the
	   * option to false. This prevents resizing for the entire grid, regardless of individual columnDef options.
	   *
	   * @example
	   <doc:example module="app">
	   <doc:source>
	   <script>
	   var app = angular.module('app', ['ui.grid', 'ui.grid.resizeColumns']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	          $scope.gridOpts = {
	            data: [
	              { "name": "Ethel Price", "gender": "female", "company": "Enersol" },
	              { "name": "Claudine Neal", "gender": "female", "company": "Sealoud" },
	              { "name": "Beryl Rice", "gender": "female", "company": "Velity" },
	              { "name": "Wilder Gonzales", "gender": "male", "company": "Geekko" }
	            ]
	          };
	        }]);
	   </script>
	
	   <div ng-controller="MainCtrl">
	   <div class="testGrid" ui-grid="gridOpts" ui-grid-resize-columns ></div>
	   </div>
	   </doc:source>
	   <doc:scenario>
	
	   </doc:scenario>
	   </doc:example>
	   */
	  module.directive('uiGridResizeColumns', ['gridUtil', 'uiGridResizeColumnsService', function (gridUtil, uiGridResizeColumnsService) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridResizeColumnsService.defaultGridOptions(uiGridCtrl.grid.options);
	            uiGridCtrl.grid.registerColumnBuilder( uiGridResizeColumnsService.colResizerColumnBuilder);
	            uiGridResizeColumnsService.registerPublicApi(uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	  // Extend the uiGridHeaderCell directive
	  module.directive('uiGridHeaderCell', ['gridUtil', '$templateCache', '$compile', '$q', 'uiGridResizeColumnsService', 'uiGridConstants', function (gridUtil, $templateCache, $compile, $q, uiGridResizeColumnsService, uiGridConstants) {
	    return {
	      // Run after the original uiGridHeaderCell
	      priority: -10,
	      require: '^uiGrid',
	      // scope: false,
	      compile: function() {
	        return {
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            var grid = uiGridCtrl.grid;
	
	            if (grid.options.enableColumnResizing) {
	              var columnResizerElm = $templateCache.get('ui-grid/columnResizer');
	
	              var rtlMultiplier = 1;
	              // when in RTL mode reverse the direction using the rtlMultiplier and change the position to left
	              if (grid.isRTL()) {
	                $scope.position = 'left';
	                rtlMultiplier = -1;
	              }
	
	              var displayResizers = function() {
	
	                // remove any existing resizers.
	                var resizers = $elm[0].getElementsByClassName('ui-grid-column-resizer');
	                for ( var i = 0; i < resizers.length; i++ ) {
	                  angular.element(resizers[i]).remove();
	                }
	
	                // get the target column for the left resizer
	                var otherCol = uiGridResizeColumnsService.findTargetCol($scope.col, 'left', rtlMultiplier);
	                var renderContainer = $scope.col.getRenderContainer();
	
	                // Don't append the left resizer if this is the first column or the column to the left of this one has resizing disabled
	                if (otherCol && renderContainer.visibleColumnCache.indexOf($scope.col) !== 0 && otherCol.colDef.enableColumnResizing !== false) {
	                  var resizerLeft = angular.element(columnResizerElm).clone();
	                  resizerLeft.attr('position', 'left');
	
	                  $elm.prepend(resizerLeft);
	                  $compile(resizerLeft)($scope);
	                }
	
	                // Don't append the right resizer if this column has resizing disabled
	                if ($scope.col.colDef.enableColumnResizing !== false) {
	                  var resizerRight = angular.element(columnResizerElm).clone();
	                  resizerRight.attr('position', 'right');
	
	                  $elm.append(resizerRight);
	                  $compile(resizerRight)($scope);
	                }
	              };
	
	              displayResizers();
	
	              var waitDisplay = function() {
	                $scope.$applyAsync(displayResizers);
	              };
	
	              var dataChangeDereg = grid.registerDataChangeCallback( waitDisplay, [uiGridConstants.dataChange.COLUMN] );
	
	              $scope.$on( '$destroy', dataChangeDereg );
	            }
	          }
	        };
	      }
	    };
	  }]);
	
	
	
	  /**
	   * @ngdoc directive
	   * @name ui.grid.resizeColumns.directive:uiGridColumnResizer
	   * @element div
	   * @restrict A
	   *
	   * @description
	   * Draggable handle that controls column resizing.
	   *
	   * @example
	   <doc:example module="app">
	     <doc:source>
	       <script>
	        var app = angular.module('app', ['ui.grid', 'ui.grid.resizeColumns']);
	
	        app.controller('MainCtrl', ['$scope', function ($scope) {
	          $scope.gridOpts = {
	            enableColumnResizing: true,
	            data: [
	              { "name": "Ethel Price", "gender": "female", "company": "Enersol" },
	              { "name": "Claudine Neal", "gender": "female", "company": "Sealoud" },
	              { "name": "Beryl Rice", "gender": "female", "company": "Velity" },
	              { "name": "Wilder Gonzales", "gender": "male", "company": "Geekko" }
	            ]
	          };
	        }]);
	       </script>
	
	       <div ng-controller="MainCtrl">
	        <div class="testGrid" ui-grid="gridOpts"></div>
	       </div>
	     </doc:source>
	     <doc:scenario>
	      // TODO: e2e specs?
	
	      // TODO: post-resize a horizontal scroll event should be fired
	     </doc:scenario>
	   </doc:example>
	   */
	  module.directive('uiGridColumnResizer', ['$document', 'gridUtil', 'uiGridConstants', 'uiGridResizeColumnsService', function ($document, gridUtil, uiGridConstants, uiGridResizeColumnsService) {
	    var resizeOverlay = angular.element('<div class="ui-grid-resize-overlay"></div>');
	
	    return {
	      priority: 0,
	      scope: {
	        col: '=',
	        position: '@',
	        renderIndex: '='
	      },
	      require: '?^uiGrid',
	      link: function ($scope, $elm, $attrs, uiGridCtrl) {
	        var startX = 0,
	            x = 0,
	            gridLeft = 0,
	            rtlMultiplier = 1;
	
	        // when in RTL mode reverse the direction using the rtlMultiplier and change the position to left
	        if (uiGridCtrl.grid.isRTL()) {
	          $scope.position = 'left';
	          rtlMultiplier = -1;
	        }
	
	        if ($scope.position === 'left') {
	          $elm.addClass('left');
	        }
	        else if ($scope.position === 'right') {
	          $elm.addClass('right');
	        }
	
	        // Refresh the grid canvas
	        //   takes an argument representing the diff along the X-axis that the resize had
	        function refreshCanvas(xDiff) {
	          // Then refresh the grid canvas, rebuilding the styles so that the scrollbar updates its size
	          uiGridCtrl.grid.refreshCanvas(true).then( function() {
	            uiGridCtrl.grid.queueGridRefresh();
	          });
	        }
	
	        // Check that the requested width isn't wider than the maxWidth, or narrower than the minWidth
	        // Returns the new recommended with, after constraints applied
	        function constrainWidth(col, width) {
	          var newWidth = width;
	
	          // If the new width would be less than the column's allowably minimum width, don't allow it
	          if (col.minWidth && newWidth < col.minWidth) {
	            newWidth = col.minWidth;
	          }
	          else if (col.maxWidth && newWidth > col.maxWidth) {
	            newWidth = col.maxWidth;
	          }
	
	          return newWidth;
	        }
	
	
	        /*
	         * Our approach to event handling aims to deal with both touch devices and mouse devices
	         * We register down handlers on both touch and mouse.  When a touchstart or mousedown event
	         * occurs, we register the corresponding touchmove/touchend, or mousemove/mouseend events.
	         *
	         * This way we can listen for both without worrying about the fact many touch devices also emulate
	         * mouse events - basically whichever one we hear first is what we'll go with.
	         */
	        function moveFunction(event, args) {
	          if (event.originalEvent) { event = event.originalEvent; }
	          event.preventDefault();
	
	          x = (event.targetTouches ? event.targetTouches[0] : event).clientX - gridLeft;
	
	          if (x < 0) { x = 0; }
	          else if (x > uiGridCtrl.grid.gridWidth) { x = uiGridCtrl.grid.gridWidth; }
	
	          var col = uiGridResizeColumnsService.findTargetCol($scope.col, $scope.position, rtlMultiplier);
	
	          // Don't resize if it's disabled on this column
	          if (col.colDef.enableColumnResizing === false) {
	            return;
	          }
	
	          if (!uiGridCtrl.grid.element.hasClass('column-resizing')) {
	            uiGridCtrl.grid.element.addClass('column-resizing');
	          }
	
	          // Get the diff along the X axis
	          var xDiff = x - startX;
	
	          // Get the width that this mouse would give the column
	          var newWidth = parseInt(col.drawnWidth + xDiff * rtlMultiplier, 10);
	
	          // check we're not outside the allowable bounds for this column
	          x = x + ( constrainWidth(col, newWidth) - newWidth ) * rtlMultiplier;
	
	          resizeOverlay.css({ left: x + 'px' });
	
	          uiGridCtrl.fireEvent(uiGridConstants.events.ITEM_DRAGGING);
	        }
	
	
	        function upFunction(event) {
	          if (event.originalEvent) { event = event.originalEvent; }
	          event.preventDefault();
	
	          uiGridCtrl.grid.element.removeClass('column-resizing');
	
	          resizeOverlay.remove();
	
	          // Resize the column
	          x = (event.changedTouches ? event.changedTouches[0] : event).clientX - gridLeft;
	          var xDiff = x - startX;
	
	          if (xDiff === 0) {
	            // no movement, so just reset event handlers, including turning back on both
	            // down events - we turned one off when this event started
	            offAllEvents();
	            onDownEvents();
	            return;
	          }
	
	          var col = uiGridResizeColumnsService.findTargetCol($scope.col, $scope.position, rtlMultiplier);
	
	          // Don't resize if it's disabled on this column
	          if (col.colDef.enableColumnResizing === false) {
	            return;
	          }
	
	          // Get the new width
	          var newWidth = parseInt(col.drawnWidth + xDiff * rtlMultiplier, 10);
	
	          // check we're not outside the allowable bounds for this column
	          col.width = constrainWidth(col, newWidth);
	          col.hasCustomWidth = true;
	
	          refreshCanvas(xDiff);
	
	          uiGridResizeColumnsService.fireColumnSizeChanged(uiGridCtrl.grid, col.colDef, xDiff);
	
	          // stop listening of up and move events - wait for next down
	          // reset the down events - we will have turned one off when this event started
	          offAllEvents();
	          onDownEvents();
	        }
	
	
	        var downFunction = function(event, args) {
	          if (event.originalEvent) { event = event.originalEvent; }
	          event.stopPropagation();
	
	          // Get the left offset of the grid
	          // gridLeft = uiGridCtrl.grid.element[0].offsetLeft;
	          gridLeft = uiGridCtrl.grid.element[0].getBoundingClientRect().left;
	
	          // Get the starting X position, which is the X coordinate of the click minus the grid's offset
	          startX = (event.targetTouches ? event.targetTouches[0] : event).clientX - gridLeft;
	
	          // Append the resizer overlay
	          uiGridCtrl.grid.element.append(resizeOverlay);
	
	          // Place the resizer overlay at the start position
	          resizeOverlay.css({ left: startX });
	
	          // Add handlers for move and up events - if we were mousedown then we listen for mousemove and mouseup, if
	          // we were touchdown then we listen for touchmove and touchup.  Also remove the handler for the equivalent
	          // down event - so if we're touchdown, then remove the mousedown handler until this event is over, if we're
	          // mousedown then remove the touchdown handler until this event is over, this avoids processing duplicate events
	          if ( event.type === 'touchstart' ) {
	            $document.on('touchend', upFunction);
	            $document.on('touchmove', moveFunction);
	            $elm.off('mousedown', downFunction);
	          }
	          else {
	            $document.on('mouseup', upFunction);
	            $document.on('mousemove', moveFunction);
	            $elm.off('touchstart', downFunction);
	          }
	        };
	
	        var onDownEvents = function() {
	          $elm.on('mousedown', downFunction);
	          $elm.on('touchstart', downFunction);
	        };
	
	        var offAllEvents = function() {
	          $document.off('mouseup', upFunction);
	          $document.off('touchend', upFunction);
	          $document.off('mousemove', moveFunction);
	          $document.off('touchmove', moveFunction);
	          $elm.off('mousedown', downFunction);
	          $elm.off('touchstart', downFunction);
	        };
	
	        onDownEvents();
	
	
	        // On doubleclick, resize to fit all rendered cells
	        var dblClickFn = function(event, args) {
	          event.stopPropagation();
	
	          var col = uiGridResizeColumnsService.findTargetCol($scope.col, $scope.position, rtlMultiplier);
	
	          // Don't resize if it's disabled on this column
	          if (col.colDef.enableColumnResizing === false) {
	            return;
	          }
	
	          // Go through the rendered rows and find out the max size for the data in this column
	          var maxWidth = 0;
	
	          // Get the parent render container element
	          var renderContainerElm = gridUtil.closestElm($elm, '.ui-grid-render-container');
	
	          // Get the cell contents so we measure correctly. For the header cell we have to account for the sort icon and the menu buttons, if present
	          var cells = renderContainerElm.querySelectorAll('.' + uiGridConstants.COL_CLASS_PREFIX + col.uid + ' .ui-grid-cell-contents');
	          Array.prototype.forEach.call(cells, function (cell) {
	              // Get the cell width
	              // gridUtil.logDebug('width', gridUtil.elementWidth(cell));
	
	              // Account for the menu button if it exists
	              var menuButton;
	              if (angular.element(cell).parent().hasClass('ui-grid-header-cell')) {
	                menuButton = angular.element(cell).parent()[0].querySelectorAll('.ui-grid-column-menu-button');
	              }
	
	              gridUtil.fakeElement(cell, {}, function(newElm) {
	                // Make the element float since it's a div and can expand to fill its container
	                var e = angular.element(newElm);
	                e.attr('style', 'float: left');
	
	                var width = gridUtil.elementWidth(e) + 2;
	
	                if (menuButton) {
	                  var menuButtonWidth = gridUtil.elementWidth(menuButton);
	                  width = width + menuButtonWidth;
	                }
	
	                if (width > maxWidth) {
	                  maxWidth = width;
	                }
	              });
	            });
	
	          // check we're not outside the allowable bounds for this column
	          var newWidth = constrainWidth(col, maxWidth);
	          var xDiff = newWidth - col.drawnWidth;
	          col.width = newWidth;
	          col.hasCustomWidth = true;
	
	          refreshCanvas(xDiff);
	
	          uiGridResizeColumnsService.fireColumnSizeChanged(uiGridCtrl.grid, col.colDef, xDiff);        };
	        $elm.on('dblclick', dblClickFn);
	
	        $elm.on('$destroy', function() {
	          $elm.off('dblclick', dblClickFn);
	          offAllEvents();
	        });
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.rowEdit
	   * @description
	   *
	   * # ui.grid.rowEdit
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module extends the edit feature to provide tracking and saving of rows
	   * of data.  The tutorial provides more information on how this feature is best
	   * used {@link tutorial/205_row_editable here}.
	   * <br/>
	   * This feature depends on usage of the ui-grid-edit feature, and also benefits
	   * from use of ui-grid-cellNav to provide the full spreadsheet-like editing
	   * experience
	   *
	   */
	
	  var module = angular.module('ui.grid.rowEdit', ['ui.grid', 'ui.grid.edit', 'ui.grid.cellNav']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.rowEdit.constant:uiGridRowEditConstants
	   *
	   *  @description constants available in row edit module
	   */
	  module.constant('uiGridRowEditConstants', {
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.rowEdit.service:uiGridRowEditService
	   *
	   *  @description Services for row editing features
	   */
	  module.service('uiGridRowEditService', ['$interval', '$q', 'uiGridConstants', 'uiGridRowEditConstants', 'gridUtil',
	    function ($interval, $q, uiGridConstants, uiGridRowEditConstants, gridUtil) {
	
	      var service = {
	
	        initializeGrid: function (scope, grid) {
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.rowEdit.api:PublicApi
	           *
	           *  @description Public Api for rowEdit feature
	           */
	
	          grid.rowEdit = {};
	
	          var publicApi = {
	            events: {
	              rowEdit: {
	                /**
	                 * @ngdoc event
	                 * @eventOf ui.grid.rowEdit.api:PublicApi
	                 * @name saveRow
	                 * @description raised when a row is ready for saving.  Once your
	                 * row has saved you may need to use angular.extend to update the
	                 * data entity with any changed data from your save (for example,
	                 * lock version information if you're using optimistic locking,
	                 * or last update time/user information).
	                 *
	                 * Your method should call setSavePromise somewhere in the body before
	                 * returning control.  The feature will then wait, with the gridRow greyed out
	                 * whilst this promise is being resolved.
	                 *
	                 * <pre>
	                 *      gridApi.rowEdit.on.saveRow(scope,function(rowEntity) {})
	                 * </pre>
	                 * and somewhere within the event handler:
	                 * <pre>
	                 *      gridApi.rowEdit.setSavePromise( rowEntity, savePromise)
	                 * </pre>
	                 * @param {object} rowEntity the options.data element that was edited
	                 * @returns {promise} Your saveRow method should return a promise, the
	                 * promise should either be resolved (implying successful save), or
	                 * rejected (implying an error).
	                 */
	                saveRow: function (rowEntity) {
	                }
	              }
	            },
	            methods: {
	              rowEdit: {
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name setSavePromise
	                 * @description Sets the promise associated with the row save, mandatory that
	                 * the saveRow event handler calls this method somewhere before returning.
	                 * <pre>
	                 *      gridApi.rowEdit.setSavePromise(rowEntity, savePromise)
	                 * </pre>
	                 * @param {object} rowEntity a data row from the grid for which a save has
	                 * been initiated
	                 * @param {promise} savePromise the promise that will be resolved when the
	                 * save is successful, or rejected if the save fails
	                 *
	                 */
	                setSavePromise: function ( rowEntity, savePromise) {
	                  service.setSavePromise(grid, rowEntity, savePromise);
	                },
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name getDirtyRows
	                 * @description Returns all currently dirty rows
	                 * <pre>
	                 *      gridApi.rowEdit.getDirtyRows(grid)
	                 * </pre>
	                 * @returns {array} An array of gridRows that are currently dirty
	                 *
	                 */
	                getDirtyRows: function () {
	                  return grid.rowEdit.dirtyRows ? grid.rowEdit.dirtyRows : [];
	                },
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name getErrorRows
	                 * @description Returns all currently errored rows
	                 * <pre>
	                 *      gridApi.rowEdit.getErrorRows(grid)
	                 * </pre>
	                 * @returns {array} An array of gridRows that are currently in error
	                 *
	                 */
	                getErrorRows: function () {
	                  return grid.rowEdit.errorRows ? grid.rowEdit.errorRows : [];
	                },
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name flushDirtyRows
	                 * @description Triggers a save event for all currently dirty rows, could
	                 * be used where user presses a save button or navigates away from the page
	                 * <pre>
	                 *      gridApi.rowEdit.flushDirtyRows(grid)
	                 * </pre>
	                 * @returns {promise} a promise that represents the aggregate of all
	                 * of the individual save promises - i.e. it will be resolved when all
	                 * the individual save promises have been resolved.
	                 *
	                 */
	                flushDirtyRows: function () {
	                  return service.flushDirtyRows(grid);
	                },
	
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name setRowsDirty
	                 * @description Sets each of the rows passed in dataRows
	                 * to be dirty. Note that if you have only just inserted the
	                 * rows into your data you will need to wait for a $digest cycle
	                 * before the gridRows are present - so often you would wrap this
	                 * call in a $interval or $timeout. Also, you must pass row.entity
	                 * into this function rather than row objects themselves.
	                 * <pre>
	                 *      $interval( function() {
	                 *        gridApi.rowEdit.setRowsDirty(myDataRows);
	                 *      }, 0, 1);
	                 * </pre>
	                 * @param {array} dataRows the data entities for which the gridRows
	                 * should be set dirty.
	                 *
	                 */
	                setRowsDirty: function ( dataRows) {
	                  service.setRowsDirty(grid, dataRows);
	                },
	
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name setRowsClean
	                 * @description Sets each of the rows passed in dataRows
	                 * to be clean, removing them from the dirty cache and the error cache,
	                 * and clearing the error flag and the dirty flag
	                 * <pre>
	                 *      var gridRows = $scope.gridApi.rowEdit.getDirtyRows();
	                 *      var dataRows = gridRows.map( function( gridRow ) { return gridRow.entity; });
	                 *      $scope.gridApi.rowEdit.setRowsClean( dataRows );
	                 * </pre>
	                 * @param {array} dataRows the data entities for which the gridRows
	                 * should be set clean.
	                 *
	                 */
	                setRowsClean: function ( dataRows) {
	                  service.setRowsClean(grid, dataRows);
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	          grid.api.core.on.renderingComplete( scope, function ( gridApi ) {
	            grid.api.edit.on.afterCellEdit( scope, service.endEditCell );
	            grid.api.edit.on.beginCellEdit( scope, service.beginEditCell );
	            grid.api.edit.on.cancelCellEdit( scope, service.cancelEditCell );
	
	            if ( grid.api.cellNav ) {
	              grid.api.cellNav.on.navigate( scope, service.navigate );
	            }
	          });
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.rowEdit.api:GridOptions
	           *
	           *  @description Options for configuring the rowEdit feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name saveRow
	         * @description  Returns a function that saves the specified row from the grid,
	         * and returns a promise
	         * @param {object} grid the grid for which dirty rows should be flushed
	         * @param {GridRow} gridRow the row that should be saved
	         * @returns {function} the saveRow function returns a function.  That function
	         * in turn, when called, returns a promise relating to the save callback
	         */
	        saveRow: function ( grid, gridRow ) {
	          var self = this;
	
	          return function() {
	            gridRow.isSaving = true;
	
	            if ( gridRow.rowEditSavePromise ) {
	              // don't save the row again if it's already saving - that causes stale object exceptions
	              return gridRow.rowEditSavePromise;
	            }
	
	            var promise = grid.api.rowEdit.raise.saveRow( gridRow.entity );
	
	            if ( gridRow.rowEditSavePromise ) {
	              gridRow.rowEditSavePromise.then( self.processSuccessPromise( grid, gridRow ), self.processErrorPromise( grid, gridRow ));
	            } else {
	              gridUtil.logError( 'A promise was not returned when saveRow event was raised, either nobody is listening to event, or event handler did not return a promise' );
	            }
	            return promise;
	          };
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf  ui.grid.rowEdit.service:uiGridRowEditService
	         * @name setSavePromise
	         * @description Sets the promise associated with the row save, mandatory that
	         * the saveRow event handler calls this method somewhere before returning.
	         * <pre>
	         *      gridApi.rowEdit.setSavePromise(grid, rowEntity)
	         * </pre>
	         * @param {object} grid the grid for which dirty rows should be returned
	         * @param {object} rowEntity a data row from the grid for which a save has
	         * been initiated
	         * @param {promise} savePromise the promise that will be resolved when the
	         * save is successful, or rejected if the save fails
	         *
	         */
	        setSavePromise: function (grid, rowEntity, savePromise) {
	          var gridRow = grid.getRow( rowEntity );
	          gridRow.rowEditSavePromise = savePromise;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name processSuccessPromise
	         * @description  Returns a function that processes the successful
	         * resolution of a save promise
	         * @param {object} grid the grid for which the promise should be processed
	         * @param {GridRow} gridRow the row that has been saved
	         * @returns {function} the success handling function
	         */
	        processSuccessPromise: function ( grid, gridRow ) {
	          var self = this;
	
	          return function() {
	            delete gridRow.isSaving;
	            delete gridRow.isDirty;
	            delete gridRow.isError;
	            delete gridRow.rowEditSaveTimer;
	            delete gridRow.rowEditSavePromise;
	            self.removeRow( grid.rowEdit.errorRows, gridRow );
	            self.removeRow( grid.rowEdit.dirtyRows, gridRow );
	          };
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name processErrorPromise
	         * @description  Returns a function that processes the failed
	         * resolution of a save promise
	         * @param {object} grid the grid for which the promise should be processed
	         * @param {GridRow} gridRow the row that is now in error
	         * @returns {function} the error handling function
	         */
	        processErrorPromise: function ( grid, gridRow ) {
	          return function() {
	            delete gridRow.isSaving;
	            delete gridRow.rowEditSaveTimer;
	            delete gridRow.rowEditSavePromise;
	
	            gridRow.isError = true;
	
	            if (!grid.rowEdit.errorRows) {
	              grid.rowEdit.errorRows = [];
	            }
	            if (!service.isRowPresent( grid.rowEdit.errorRows, gridRow ) ) {
	              grid.rowEdit.errorRows.push( gridRow );
	            }
	          };
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name removeRow
	         * @description  Removes a row from a cache of rows - either
	         * grid.rowEdit.errorRows or grid.rowEdit.dirtyRows.  If the row
	         * is not present silently does nothing.
	         * @param {array} rowArray the array from which to remove the row
	         * @param {GridRow} gridRow the row that should be removed
	         */
	        removeRow: function( rowArray, removeGridRow ) {
	          if (typeof(rowArray) === 'undefined' || rowArray === null) {
	            return;
	          }
	
	          rowArray.forEach( function( gridRow, index ) {
	            if ( gridRow.uid === removeGridRow.uid ) {
	              rowArray.splice( index, 1);
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name isRowPresent
	         * @description  Checks whether a row is already present
	         * in the given array
	         * @param {array} rowArray the array in which to look for the row
	         * @param {GridRow} gridRow the row that should be looked for
	         */
	        isRowPresent: function( rowArray, removeGridRow ) {
	          var present = false;
	          rowArray.forEach( function( gridRow, index ) {
	            if ( gridRow.uid === removeGridRow.uid ) {
	              present = true;
	            }
	          });
	          return present;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name flushDirtyRows
	         * @description Triggers a save event for all currently dirty rows, could
	         * be used where user presses a save button or navigates away from the page
	         * <pre>
	         *      gridApi.rowEdit.flushDirtyRows(grid)
	         * </pre>
	         * @param {object} grid the grid for which dirty rows should be flushed
	         * @returns {promise} a promise that represents the aggregate of all
	         * of the individual save promises - i.e. it will be resolved when all
	         * the individual save promises have been resolved.
	         *
	         */
	        flushDirtyRows: function(grid) {
	          var promises = [];
	          grid.api.rowEdit.getDirtyRows().forEach( function( gridRow ) {
	            service.cancelTimer( grid, gridRow );
	            service.saveRow( grid, gridRow )();
	            promises.push( gridRow.rowEditSavePromise );
	          });
	
	          return $q.all( promises );
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name endEditCell
	         * @description Receives an afterCellEdit event from the edit function,
	         * and sets flags as appropriate.  Only the rowEntity parameter
	         * is processed, although other params are available.  Grid
	         * is automatically provided by the gridApi.
	         * @param {object} rowEntity the data entity for which the cell
	         * was edited
	         */
	        endEditCell: function( rowEntity, colDef, newValue, previousValue ) {
	          var grid = this.grid;
	          var gridRow = grid.getRow( rowEntity );
	          if ( !gridRow ) { gridUtil.logError( 'Unable to find rowEntity in grid data, dirty flag cannot be set' ); return; }
	
	          if ( newValue !== previousValue || gridRow.isDirty ) {
	            if ( !grid.rowEdit.dirtyRows ) {
	              grid.rowEdit.dirtyRows = [];
	            }
	
	            if ( !gridRow.isDirty ) {
	              gridRow.isDirty = true;
	              grid.rowEdit.dirtyRows.push( gridRow );
	            }
	
	            delete gridRow.isError;
	
	            service.considerSetTimer( grid, gridRow );
	          }
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name beginEditCell
	         * @description Receives a beginCellEdit event from the edit function,
	         * and cancels any rowEditSaveTimers if present, as the user is still editing
	         * this row.  Only the rowEntity parameter
	         * is processed, although other params are available.  Grid
	         * is automatically provided by the gridApi.
	         * @param {object} rowEntity the data entity for which the cell
	         * editing has commenced
	         */
	        beginEditCell: function( rowEntity, colDef ) {
	          var grid = this.grid;
	          var gridRow = grid.getRow( rowEntity );
	          if ( !gridRow ) { gridUtil.logError( 'Unable to find rowEntity in grid data, timer cannot be cancelled' ); return; }
	
	          service.cancelTimer( grid, gridRow );
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name cancelEditCell
	         * @description Receives a cancelCellEdit event from the edit function,
	         * and if the row was already dirty, restarts the save timer.  If the row
	         * was not already dirty, then it's not dirty now either and does nothing.
	         *
	         * Only the rowEntity parameter
	         * is processed, although other params are available.  Grid
	         * is automatically provided by the gridApi.
	         *
	         * @param {object} rowEntity the data entity for which the cell
	         * editing was cancelled
	         */
	        cancelEditCell: function( rowEntity, colDef ) {
	          var grid = this.grid;
	          var gridRow = grid.getRow( rowEntity );
	          if ( !gridRow ) { gridUtil.logError( 'Unable to find rowEntity in grid data, timer cannot be set' ); return; }
	
	          service.considerSetTimer( grid, gridRow );
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name navigate
	         * @description cellNav tells us that the selected cell has changed.  If
	         * the new row had a timer running, then stop it similar to in a beginCellEdit
	         * call.  If the old row is dirty and not the same as the new row, then
	         * start a timer on it.
	         * @param {object} newRowCol the row and column that were selected
	         * @param {object} oldRowCol the row and column that was left
	         *
	         */
	        navigate: function( newRowCol, oldRowCol ) {
	          var grid = this.grid;
	          if ( newRowCol.row.rowEditSaveTimer ) {
	            service.cancelTimer( grid, newRowCol.row );
	          }
	
	          if ( oldRowCol && oldRowCol.row && oldRowCol.row !== newRowCol.row ) {
	            service.considerSetTimer( grid, oldRowCol.row );
	          }
	        },
	
	
	        /**
	         * @ngdoc property
	         * @propertyOf ui.grid.rowEdit.api:GridOptions
	         * @name rowEditWaitInterval
	         * @description How long the grid should wait for another change on this row
	         * before triggering a save (in milliseconds).  If set to -1, then saves are
	         * never triggered by timer (implying that the user will call flushDirtyRows()
	         * manually)
	         *
	         * @example
	         * Setting the wait interval to 4 seconds
	         * <pre>
	         *   $scope.gridOptions = { rowEditWaitInterval: 4000 }
	         * </pre>
	         *
	         */
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name considerSetTimer
	         * @description Consider setting a timer on this row (if it is dirty).  if there is a timer running
	         * on the row and the row isn't currently saving, cancel it, using cancelTimer, then if the row is
	         * dirty and not currently saving then set a new timer
	         * @param {object} grid the grid for which we are processing
	         * @param {GridRow} gridRow the row for which the timer should be adjusted
	         *
	         */
	        considerSetTimer: function( grid, gridRow ) {
	          service.cancelTimer( grid, gridRow );
	
	          if ( gridRow.isDirty && !gridRow.isSaving ) {
	            if ( grid.options.rowEditWaitInterval !== -1 ) {
	              var waitTime = grid.options.rowEditWaitInterval ? grid.options.rowEditWaitInterval : 2000;
	              gridRow.rowEditSaveTimer = $interval( service.saveRow( grid, gridRow ), waitTime, 1);
	            }
	          }
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name cancelTimer
	         * @description cancel the $interval for any timer running on this row
	         * then delete the timer itself
	         * @param {object} grid the grid for which we are processing
	         * @param {GridRow} gridRow the row for which the timer should be adjusted
	         *
	         */
	        cancelTimer: function( grid, gridRow ) {
	          if ( gridRow.rowEditSaveTimer && !gridRow.isSaving ) {
	            $interval.cancel(gridRow.rowEditSaveTimer);
	            delete gridRow.rowEditSaveTimer;
	          }
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name setRowsDirty
	         * @description Sets each of the rows passed in dataRows
	         * to be dirty.  note that if you have only just inserted the
	         * rows into your data you will need to wait for a $digest cycle
	         * before the gridRows are present - so often you would wrap this
	         * call in a $interval or $timeout
	         * <pre>
	         *      $interval( function() {
	         *        gridApi.rowEdit.setRowsDirty( myDataRows);
	         *      }, 0, 1);
	         * </pre>
	         * @param {object} grid the grid for which rows should be set dirty
	         * @param {array} dataRows the data entities for which the gridRows
	         * should be set dirty.
	         *
	         */
	        setRowsDirty: function( grid, myDataRows ) {
	          var gridRow;
	          myDataRows.forEach( function( value, index ) {
	            gridRow = grid.getRow( value );
	            if ( gridRow ) {
	              if ( !grid.rowEdit.dirtyRows ) {
	                grid.rowEdit.dirtyRows = [];
	              }
	
	              if ( !gridRow.isDirty ) {
	                gridRow.isDirty = true;
	                grid.rowEdit.dirtyRows.push( gridRow );
	              }
	
	              delete gridRow.isError;
	
	              service.considerSetTimer( grid, gridRow );
	            } else {
	              gridUtil.logError( "requested row not found in rowEdit.setRowsDirty, row was: " + value );
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name setRowsClean
	         * @description Sets each of the rows passed in dataRows
	         * to be clean, clearing the dirty flag and the error flag, and removing
	         * the rows from the dirty and error caches.
	         * @param {object} grid the grid for which rows should be set clean
	         * @param {array} dataRows the data entities for which the gridRows
	         * should be set clean.
	         *
	         */
	        setRowsClean: function( grid, myDataRows ) {
	          var gridRow;
	
	          myDataRows.forEach( function( value, index ) {
	            gridRow = grid.getRow( value );
	            if ( gridRow ) {
	              delete gridRow.isDirty;
	              service.removeRow( grid.rowEdit.dirtyRows, gridRow );
	              service.cancelTimer( grid, gridRow );
	
	              delete gridRow.isError;
	              service.removeRow( grid.rowEdit.errorRows, gridRow );
	            } else {
	              gridUtil.logError( "requested row not found in rowEdit.setRowsClean, row was: " + value );
	            }
	          });
	        }
	
	      };
	
	      return service;
	
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.rowEdit.directive:uiGridEdit
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds row editing features to the ui-grid-edit directive.
	   *
	   */
	  module.directive('uiGridRowEdit', ['gridUtil', 'uiGridRowEditService', 'uiGridEditConstants',
	  function (gridUtil, uiGridRowEditService, uiGridEditConstants) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridRowEditService.initializeGrid($scope, uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.rowEdit.directive:uiGridViewport
	   *  @element div
	   *
	   *  @description Stacks on top of ui.grid.uiGridViewport to alter the attributes used
	   *  for the grid row to allow coloring of saving and error rows
	   */
	  module.directive('uiGridViewport',
	    ['$compile', 'uiGridConstants', 'gridUtil', '$parse',
	      function ($compile, uiGridConstants, gridUtil, $parse) {
	        return {
	          priority: -200, // run after default  directive
	          scope: false,
	          compile: function ($elm, $attrs) {
	            var rowRepeatDiv = angular.element($elm.children().children()[0]);
	
	            var existingNgClass = rowRepeatDiv.attr("ng-class");
	            var newNgClass = '';
	            if ( existingNgClass ) {
	              newNgClass = existingNgClass.slice(0, -1) + ", 'ui-grid-row-dirty': row.isDirty, 'ui-grid-row-saving': row.isSaving, 'ui-grid-row-error': row.isError}";
	            } else {
	              newNgClass = "{'ui-grid-row-dirty': row.isDirty, 'ui-grid-row-saving': row.isSaving, 'ui-grid-row-error': row.isError}";
	            }
	            rowRepeatDiv.attr("ng-class", newNgClass);
	
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	              }
	            };
	          }
	        };
	      }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.saveState
	   * @description
	   *
	   * # ui.grid.saveState
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides the ability to save the grid state, and restore
	   * it when the user returns to the page.
	   *
	   * No UI is provided, the caller should provide their own UI/buttons
	   * as appropriate. Usually the navigate events would be used to save
	   * the grid state and restore it.
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.save-state"></div>
	   */
	
	  var module = angular.module('ui.grid.saveState', ['ui.grid', 'ui.grid.selection', 'ui.grid.cellNav', 'ui.grid.grouping', 'ui.grid.pinning', 'ui.grid.treeView']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.saveState.constant:uiGridSaveStateConstants
	   *
	   *  @description constants available in save state module
	   */
	
	  module.constant('uiGridSaveStateConstants', {
	    featureName: 'saveState'
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.saveState.service:uiGridSaveStateService
	   *
	   *  @description Services for saveState feature
	   */
	  module.service('uiGridSaveStateService',
	    function () {
	      var service = {
	
	        initializeGrid: function (grid) {
	
	          // add feature namespace and any properties to grid for needed state
	          grid.saveState = {};
	          this.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.saveState.api:PublicApi
	           *
	           *  @description Public Api for saveState feature
	           */
	          var publicApi = {
	            events: {
	              saveState: {
	              }
	            },
	            methods: {
	              saveState: {
	                /**
	                 * @ngdoc function
	                 * @name save
	                 * @methodOf  ui.grid.saveState.api:PublicApi
	                 * @description Packages the current state of the grid into
	                 * an object, and provides it to the user for saving
	                 * @returns {object} the state as a javascript object that can be saved
	                 */
	                save: function () {
	                  return service.save(grid);
	                },
	                /**
	                 * @ngdoc function
	                 * @name restore
	                 * @methodOf  ui.grid.saveState.api:PublicApi
	                 * @description Restores the provided state into the grid
	                 * @param {scope} $scope a scope that we can broadcast on
	                 * @param {object} state the state that should be restored into the grid
	                 * @returns {object} the promise created by refresh
	                 */
	                restore: function ( $scope, state) {
	                  return service.restore(grid, $scope, state);
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	        },
	
	        defaultGridOptions: function (gridOptions) {
	          // default option to true unless it was explicitly set to false
	          /**
	           * @ngdoc object
	           * @name ui.grid.saveState.api:GridOptions
	           *
	           * @description GridOptions for saveState feature, these are available to be
	           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	          /**
	           * @ngdoc object
	           * @name saveWidths
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current column widths.  Note that unless
	           * you've provided the user with some way to resize their columns (say
	           * the resize columns feature), then this makes little sense.
	           * <br/>Defaults to true
	           */
	          gridOptions.saveWidths = gridOptions.saveWidths !== false;
	          /**
	           * @ngdoc object
	           * @name saveOrder
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Restore the current column order.  Note that unless
	           * you've provided the user with some way to reorder their columns (for
	           * example the move columns feature), this makes little sense.
	           * <br/>Defaults to true
	           */
	          gridOptions.saveOrder = gridOptions.saveOrder !== false;
	          /**
	           * @ngdoc object
	           * @name saveScroll
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current scroll position.  Note that this
	           * is saved as the percentage of the grid scrolled - so if your
	           * user returns to a grid with a significantly different number of
	           * rows (perhaps some data has been deleted) then the scroll won't
	           * actually show the same rows as before.  If you want to scroll to
	           * a specific row then you should instead use the saveFocus option, which
	           * is the default.
	           *
	           * Note that this element will only be saved if the cellNav feature is
	           * enabled
	           * <br/>Defaults to false
	           */
	          gridOptions.saveScroll = gridOptions.saveScroll === true;
	          /**
	           * @ngdoc object
	           * @name saveFocus
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current focused cell.  On returning
	           * to this focused cell we'll also scroll.  This option is
	           * preferred to the saveScroll option, so is set to true by
	           * default.  If saveScroll is set to true then this option will
	           * be disabled.
	           *
	           * By default this option saves the current row number and column
	           * number, and returns to that row and column.  However, if you define
	           * a saveRowIdentity function, then it will return you to the currently
	           * selected column within that row (in a business sense - so if some
	           * rows have been deleted, it will still find the same data, presuming it
	           * still exists in the list.  If it isn't in the list then it will instead
	           * return to the same row number - i.e. scroll percentage)
	           *
	           * Note that this option will do nothing if the cellNav
	           * feature is not enabled.
	           *
	           * <br/>Defaults to true (unless saveScroll is true)
	           */
	          gridOptions.saveFocus = gridOptions.saveScroll !== true && gridOptions.saveFocus !== false;
	          /**
	           * @ngdoc object
	           * @name saveRowIdentity
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description A function that can be called, passing in a rowEntity,
	           * and that will return a unique id for that row.  This might simply
	           * return the `id` field from that row (if you have one), or it might
	           * concatenate some fields within the row to make a unique value.
	           *
	           * This value will be used to find the same row again and set the focus
	           * to it, if it exists when we return.
	           *
	           * <br/>Defaults to undefined
	           */
	          /**
	           * @ngdoc object
	           * @name saveVisible
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save whether or not columns are visible.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveVisible = gridOptions.saveVisible !== false;
	          /**
	           * @ngdoc object
	           * @name saveSort
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current sort state for each column
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveSort = gridOptions.saveSort !== false;
	          /**
	           * @ngdoc object
	           * @name saveFilter
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current filter state for each column
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveFilter = gridOptions.saveFilter !== false;
	          /**
	           * @ngdoc object
	           * @name saveSelection
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the currently selected rows.  If the `saveRowIdentity` callback
	           * is defined, then it will save the id of the row and select that.  If not, then
	           * it will attempt to select the rows by row number, which will give the wrong results
	           * if the data set has changed in the mean-time.
	           *
	           * Note that this option only does anything
	           * if the selection feature is enabled.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveSelection = gridOptions.saveSelection !== false;
	          /**
	           * @ngdoc object
	           * @name saveGrouping
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the grouping configuration.  If set to true and the
	           * grouping feature is not enabled then does nothing.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveGrouping = gridOptions.saveGrouping !== false;
	          /**
	           * @ngdoc object
	           * @name saveGroupingExpandedStates
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the grouping row expanded states.  If set to true and the
	           * grouping feature is not enabled then does nothing.
	           *
	           * This can be quite a bit of data, in many cases you wouldn't want to save this
	           * information.
	           *
	           * <br/>Defaults to false
	           */
	          gridOptions.saveGroupingExpandedStates = gridOptions.saveGroupingExpandedStates === true;
	          /**
	           * @ngdoc object
	           * @name savePinning
	           * @propertyOf ui.grid.saveState.api:GridOptions
	           * @description Save pinning state for columns.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.savePinning = gridOptions.savePinning !== false;
	          /**
	           * @ngdoc object
	           * @name saveTreeView
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the treeView configuration.  If set to true and the
	           * treeView feature is not enabled then does nothing.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveTreeView = gridOptions.saveTreeView !== false;
	        },
	
	        /**
	         * @ngdoc function
	         * @name save
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the current grid state into an object, and
	         * passes that object back to the caller
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the state ready to be saved
	         */
	        save: function (grid) {
	          var savedState = {};
	
	          savedState.columns = service.saveColumns( grid );
	          savedState.scrollFocus = service.saveScrollFocus( grid );
	          savedState.selection = service.saveSelection( grid );
	          savedState.grouping = service.saveGrouping( grid );
	          savedState.treeView = service.saveTreeView( grid );
	          savedState.pagination = service.savePagination( grid );
	
	          return savedState;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restore
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Applies the provided state to the grid
	         *
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {scope} $scope a scope that we can broadcast on
	         * @param {object} state the state we'd like to restore
	         * @returns {object} the promise created by refresh
	         */
	        restore: function( grid, $scope, state ) {
	          if ( state.columns ) {
	            service.restoreColumns( grid, state.columns );
	          }
	
	          if ( state.scrollFocus ) {
	            service.restoreScrollFocus( grid, $scope, state.scrollFocus );
	          }
	
	          if ( state.selection ) {
	            service.restoreSelection( grid, state.selection );
	          }
	
	          if ( state.grouping ) {
	            service.restoreGrouping( grid, state.grouping );
	          }
	
	          if ( state.treeView ) {
	            service.restoreTreeView( grid, state.treeView );
	          }
	
	          if ( state.pagination ) {
	            service.restorePagination( grid, state.pagination );
	          }
	
	          return grid.refresh();
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveColumns
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the column setup, including sort, filters, ordering,
	         * pinning and column widths.
	         *
	         * Works through the current columns, storing them in order.  Stores the
	         * column name, then the visible flag, width, sort and filters for each column.
	         *
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {array} the columns state ready to be saved
	         */
	        saveColumns: function( grid ) {
	          var columns = [];
	
	          grid.getOnlyDataColumns().forEach( function( column ) {
	            var savedColumn = {};
	            savedColumn.name = column.name;
	
	            if ( grid.options.saveVisible ) {
	              savedColumn.visible = column.visible;
	            }
	
	            if ( grid.options.saveWidths ) {
	              savedColumn.width = column.width;
	            }
	
	            // these two must be copied, not just pointed too - otherwise our saved state is pointing to the same object as current state
	            if ( grid.options.saveSort ) {
	              savedColumn.sort = angular.copy( column.sort );
	            }
	
	            if ( grid.options.saveFilter ) {
	              savedColumn.filters = [];
	              column.filters.forEach( function( filter ) {
	                var copiedFilter = {};
	                angular.forEach( filter, function( value, key) {
	                  if ( key !== 'condition' && key !== '$$hashKey' && key !== 'placeholder') {
	                    copiedFilter[key] = value;
	                  }
	                });
	                savedColumn.filters.push(copiedFilter);
	              });
	            }
	
	            if ( !!grid.api.pinning && grid.options.savePinning ) {
	              savedColumn.pinned = column.renderContainer ? column.renderContainer : '';
	            }
	
	            columns.push( savedColumn );
	          });
	
	          return columns;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveScrollFocus
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the currently scroll or focus.
	         *
	         * If cellNav isn't present then does nothing - we can't return
	         * to the scroll position without cellNav anyway.
	         *
	         * If the cellNav module is present, and saveFocus is true, then
	         * it saves the currently focused cell.  If rowIdentity is present
	         * then saves using rowIdentity, otherwise saves visibleRowNum.
	         *
	         * If the cellNav module is not present, and saveScroll is true, then
	         * it approximates the current scroll row and column, and saves that.
	         *
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the selection state ready to be saved
	         */
	        saveScrollFocus: function( grid ) {
	          if ( !grid.api.cellNav ) {
	            return {};
	          }
	
	          var scrollFocus = {};
	          if ( grid.options.saveFocus ) {
	            scrollFocus.focus = true;
	            var rowCol = grid.api.cellNav.getFocusedCell();
	            if ( rowCol !== null ) {
	              if ( rowCol.col !== null ) {
	                scrollFocus.colName = rowCol.col.colDef.name;
	              }
	              if ( rowCol.row !== null ) {
	                scrollFocus.rowVal = service.getRowVal( grid, rowCol.row );
	              }
	            }
	          }
	
	          if ( grid.options.saveScroll || grid.options.saveFocus && !scrollFocus.colName && !scrollFocus.rowVal ) {
	            scrollFocus.focus = false;
	            if ( grid.renderContainers.body.prevRowScrollIndex ) {
	              scrollFocus.rowVal = service.getRowVal( grid, grid.renderContainers.body.visibleRowCache[ grid.renderContainers.body.prevRowScrollIndex ]);
	            }
	
	            if ( grid.renderContainers.body.prevColScrollIndex ) {
	              scrollFocus.colName = grid.renderContainers.body.visibleColumnCache[ grid.renderContainers.body.prevColScrollIndex ].name;
	            }
	          }
	
	          return scrollFocus;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveSelection
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the currently selected rows, if the selection feature is enabled
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {array} the selection state ready to be saved
	         */
	        saveSelection: function( grid ) {
	          if ( !grid.api.selection || !grid.options.saveSelection ) {
	            return [];
	          }
	
	          return grid.api.selection.getSelectedGridRows().map( function( gridRow ) {
	            return service.getRowVal( grid, gridRow );
	          });
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveGrouping
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the grouping state, if the grouping feature is enabled
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the grouping state ready to be saved
	         */
	        saveGrouping: function( grid ) {
	          if ( !grid.api.grouping || !grid.options.saveGrouping ) {
	            return {};
	          }
	
	          return grid.api.grouping.getGrouping( grid.options.saveGroupingExpandedStates );
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name savePagination
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the pagination state, if the pagination feature is enabled
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the pagination state ready to be saved
	         */
	        savePagination: function( grid ) {
	          if ( !grid.api.pagination || !grid.options.paginationPageSize ) {
	            return {};
	          }
	
	          return {
	            paginationCurrentPage: grid.options.paginationCurrentPage,
	            paginationPageSize: grid.options.paginationPageSize
	          };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveTreeView
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the tree view state, if the tree feature is enabled
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the tree view state ready to be saved
	         */
	        saveTreeView: function( grid ) {
	          if ( !grid.api.treeView || !grid.options.saveTreeView ) {
	            return {};
	          }
	
	          return grid.api.treeView.getTreeView();
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name getRowVal
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Helper function that gets either the rowNum or
	         * the saveRowIdentity, given a gridRow
	         * @param {Grid} grid the grid the row is in
	         * @param {GridRow} gridRow the row we want the rowNum for
	         * @returns {object} an object containing { identity: true/false, row: rowNumber/rowIdentity }
	         *
	         */
	        getRowVal: function( grid, gridRow ) {
	          if ( !gridRow ) {
	            return null;
	          }
	
	          var rowVal = {};
	          if ( grid.options.saveRowIdentity ) {
	            rowVal.identity = true;
	            rowVal.row = grid.options.saveRowIdentity( gridRow.entity );
	          }
	          else {
	            rowVal.identity = false;
	            rowVal.row = grid.renderContainers.body.visibleRowCache.indexOf( gridRow );
	          }
	          return rowVal;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restoreColumns
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Restores the columns, including order, visible, width,
	         * pinning, sort and filters.
	         *
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} columnsState the list of columns we had before, with their state
	         */
	        restoreColumns: function( grid, columnsState ) {
	          var isSortChanged = false;
	
	          columnsState.forEach( function( columnState, index ) {
	            var currentCol = grid.getColumn( columnState.name );
	
	            if ( currentCol && !grid.isRowHeaderColumn(currentCol) ) {
	              if ( grid.options.saveVisible &&
	                   ( currentCol.visible !== columnState.visible ||
	                     currentCol.colDef.visible !== columnState.visible ) ) {
	                currentCol.visible = columnState.visible;
	                currentCol.colDef.visible = columnState.visible;
	                grid.api.core.raise.columnVisibilityChanged(currentCol);
	              }
	
	              if ( grid.options.saveWidths && currentCol.width !== columnState.width) {
	                currentCol.width = columnState.width;
	                currentCol.hasCustomWidth = true;
	              }
	
	              if ( grid.options.saveSort &&
	                   !angular.equals(currentCol.sort, columnState.sort) &&
	                   !( currentCol.sort === undefined && angular.isEmpty(columnState.sort) ) ) {
	                currentCol.sort = angular.copy( columnState.sort );
	                isSortChanged = true;
	              }
	
	              if ( grid.options.saveFilter &&
	                   !angular.equals(currentCol.filters, columnState.filters ) ) {
	                columnState.filters.forEach( function( filter, index ) {
	                  angular.extend( currentCol.filters[index], filter );
	                  if ( typeof(filter.term) === 'undefined' || filter.term === null ) {
	                    delete currentCol.filters[index].term;
	                  }
	                });
	                grid.api.core.raise.filterChanged( currentCol );
	              }
	
	              if ( !!grid.api.pinning && grid.options.savePinning && currentCol.renderContainer !== columnState.pinned ) {
	                grid.api.pinning.pinColumn(currentCol, columnState.pinned);
	              }
	
	              var currentIndex = grid.getOnlyDataColumns().indexOf( currentCol );
	              if (currentIndex !== -1) {
	                if (grid.options.saveOrder && currentIndex !== index) {
	                  var column = grid.columns.splice(currentIndex + grid.rowHeaderColumns.length, 1)[0];
	                  grid.columns.splice(index + grid.rowHeaderColumns.length, 0, column);
	                }
	              }
	            }
	          });
	
	          if ( isSortChanged ) {
	            grid.api.core.raise.sortChanged( grid, grid.getColumnSorting() );
	          }
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restoreScrollFocus
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Scrolls to the position that was saved.  If focus is true, then
	         * sets focus to the specified row/col.  If focus is false, then scrolls to the
	         * specified row/col.
	         *
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {scope} $scope a scope that we can broadcast on
	         * @param {object} scrollFocusState the scroll/focus state ready to be restored
	         */
	        restoreScrollFocus: function( grid, $scope, scrollFocusState ) {
	          if ( !grid.api.cellNav ) {
	            return;
	          }
	
	          var colDef, row;
	          if ( scrollFocusState.colName ) {
	            var colDefs = grid.options.columnDefs.filter( function( colDef ) { return colDef.name === scrollFocusState.colName; });
	            if ( colDefs.length > 0 ) {
	              colDef = colDefs[0];
	            }
	          }
	
	          if ( scrollFocusState.rowVal && scrollFocusState.rowVal.row ) {
	            if ( scrollFocusState.rowVal.identity ) {
	              row = service.findRowByIdentity( grid, scrollFocusState.rowVal );
	            }
	            else {
	              row = grid.renderContainers.body.visibleRowCache[ scrollFocusState.rowVal.row ];
	            }
	          }
	
	          var entity = row && row.entity ? row.entity : null ;
	
	          if ( colDef || entity ) {
	            if (scrollFocusState.focus ) {
	              grid.api.cellNav.scrollToFocus( entity, colDef );
	            }
	            else {
	              grid.scrollTo( entity, colDef );
	            }
	          }
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restoreSelection
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Selects the rows that are provided in the selection
	         * state.  If you are using `saveRowIdentity` and more than one row matches the identity
	         * function then only the first is selected.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} selectionState the selection state ready to be restored
	         */
	        restoreSelection: function( grid, selectionState ) {
	          if ( !grid.api.selection ) {
	            return;
	          }
	
	          grid.api.selection.clearSelectedRows();
	
	          selectionState.forEach(function( rowVal ) {
	            if ( rowVal.identity ) {
	              var foundRow = service.findRowByIdentity( grid, rowVal );
	
	              if ( foundRow ) {
	                grid.api.selection.selectRow( foundRow.entity );
	              }
	
	            }
	            else {
	              grid.api.selection.selectRowByVisibleIndex( rowVal.row );
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restoreGrouping
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Restores the grouping configuration, if the grouping feature
	         * is enabled.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} groupingState the grouping state ready to be restored
	         */
	        restoreGrouping: function( grid, groupingState ) {
	          if ( !grid.api.grouping || typeof(groupingState) === 'undefined' || groupingState === null || angular.equals(groupingState, {}) ) {
	            return;
	          }
	
	          grid.api.grouping.setGrouping( groupingState );
	        },
	
	        /**
	         * @ngdoc function
	         * @name restoreTreeView
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Restores the tree view configuration, if the tree view feature
	         * is enabled.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} treeViewState the tree view state ready to be restored
	         */
	        restoreTreeView: function( grid, treeViewState ) {
	          if ( !grid.api.treeView || typeof(treeViewState) === 'undefined' || treeViewState === null || angular.equals(treeViewState, {}) ) {
	            return;
	          }
	
	          grid.api.treeView.setTreeView( treeViewState );
	        },
	
	        /**
	         * @ngdoc function
	         * @name restorePagination
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Restores the pagination information, if pagination is enabled.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} pagination the pagination object to be restored
	         * @param {number} pagination.paginationCurrentPage the page number to restore
	         * @param {number} pagination.paginationPageSize the number of items displayed per page
	         */
	        restorePagination: function( grid, pagination ) {
	          if ( !grid.api.pagination || !grid.options.paginationPageSize ) {
	            return;
	          }
	
	          grid.options.paginationCurrentPage = pagination.paginationCurrentPage;
	          grid.options.paginationPageSize = pagination.paginationPageSize;
	        },
	
	        /**
	         * @ngdoc function
	         * @name findRowByIdentity
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Finds a row given it's identity value, returns the first found row
	         * if any are found, otherwise returns null if no rows are found.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} rowVal the row we'd like to find
	         * @returns {gridRow} the found row, or null if none found
	         */
	        findRowByIdentity: function( grid, rowVal ) {
	          if ( !grid.options.saveRowIdentity ) {
	            return null;
	          }
	
	          var filteredRows = grid.rows.filter( function( gridRow ) {
	            return ( grid.options.saveRowIdentity( gridRow.entity ) === rowVal.row );
	          });
	
	          if ( filteredRows.length > 0 ) {
	            return filteredRows[0];
	          } else {
	            return null;
	          }
	        }
	      };
	
	      return service;
	    }
	  );
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.saveState.directive:uiGridSaveState
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds saveState features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.saveState']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	        { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.gridOptions = {
	        columnDefs: [
	          {name: 'name'},
	          {name: 'title', enableCellEdit: true}
	        ],
	        data: $scope.data
	      };
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-save-state></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridSaveState', ['uiGridSaveStateConstants', 'uiGridSaveStateService', 'gridUtil', '$compile',
	    function (uiGridSaveStateConstants, uiGridSaveStateService, gridUtil, $compile) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          uiGridSaveStateService.initializeGrid(uiGridCtrl.grid);
	        }
	      };
	    }
	  ]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.selection
	   * @description
	   *
	   * # ui.grid.selection
	   * This module provides row selection
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * <div doc-module-components="ui.grid.selection"></div>
	   */
	
	  var module = angular.module('ui.grid.selection', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.selection.constant:uiGridSelectionConstants
	   *
	   *  @description constants available in selection module
	   */
	  module.constant('uiGridSelectionConstants', {
	    featureName: 'selection',
	    selectionRowHeaderColName: 'selectionRowHeaderCol'
	  });
	
	  // add methods to GridRow
	  angular.module('ui.grid').config(['$provide', function ($provide) {
	    $provide.decorator('GridRow', ['$delegate', function ($delegate) {
	
	      /**
	       *  @ngdoc object
	       *  @name ui.grid.selection.api:GridRow
	       *
	       *  @description GridRow prototype functions added for selection
	       */
	
	      /**
	       *  @ngdoc object
	       *  @name enableSelection
	       *  @propertyOf  ui.grid.selection.api:GridRow
	       *  @description Enable row selection for this row, only settable by internal code.
	       *
	       *  The grouping feature, for example, might set group header rows to not be selectable.
	       *  <br/>Defaults to true
	       */
	
	      /**
	       *  @ngdoc object
	       *  @name isSelected
	       *  @propertyOf  ui.grid.selection.api:GridRow
	       *  @description Selected state of row. Should be readonly. Make any changes to selected state using setSelected().
	       *  <br/>Defaults to false
	       */
	
	      /**
	       *  @ngdoc object
	       *  @name isFocused
	       *  @propertyOf  ui.grid.selection.api:GridRow
	       *  @description Focused state of row. Should be readonly. Make any changes to focused state using setFocused().
	       *  <br/>Defaults to false
	       */
	
	      /**
	       * @ngdoc function
	       * @name setSelected
	       * @methodOf ui.grid.selection.api:GridRow
	       * @description Sets the isSelected property and updates the selectedCount
	       * Changes to isSelected state should only be made via this function
	       * @param {Boolean} selected value to set
	       */
	      $delegate.prototype.setSelected = function (selected) {
	        if (selected !== this.isSelected) {
	          this.isSelected = selected;
	          this.grid.selection.selectedCount += selected ? 1 : -1;
	        }
	      };
	
	      /**
	       * @ngdoc function
	       * @name setFocused
	       * @methodOf ui.grid.selection.api:GridRow
	       * @description Sets the isFocused property
	       * Changes to isFocused state should only be made via this function
	       * @param {Boolean} val value to set
	       */
	      $delegate.prototype.setFocused = function(val) {
	        if (val !== this.isFocused) {
	          this.grid.selection.focusedRow && (this.grid.selection.focusedRow.isFocused = false);
	          this.grid.selection.focusedRow = val ? this : null;
	          this.isFocused = val;
	        }
	      };
	
	      return $delegate;
	    }]);
	  }]);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.selection.service:uiGridSelectionService
	   *
	   *  @description Services for selection features
	   */
	  module.service('uiGridSelectionService',
	    function () {
	      var service = {
	
	        initializeGrid: function (grid) {
	
	          // add feature namespace and any properties to grid for needed
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.selection.grid:selection
	           *
	           *  @description Grid properties and functions added for selection
	           */
	          grid.selection = {
	            lastSelectedRow: null,
	            /**
	             *  @ngdoc object
	             *  @name focusedRow
	             *  @propertyOf  ui.grid.selection.grid:selection
	             *  @description Focused row.
	             */
	            focusedRow: null,
	            selectAll: false
	          };
	
	
	          /**
	           *  @ngdoc object
	           *  @name selectedCount
	           *  @propertyOf  ui.grid.selection.grid:selection
	           *  @description Current count of selected rows
	           *  @example
	           *  var count = grid.selection.selectedCount
	           */
	          grid.selection.selectedCount = 0;
	
	          service.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.selection.api:PublicApi
	           *
	           *  @description Public Api for selection feature
	           */
	          var publicApi = {
	            events: {
	              selection: {
	                /**
	                 * @ngdoc event
	                 * @name rowFocusChanged
	                 * @eventOf  ui.grid.selection.api:PublicApi
	                 * @description  is raised after the row.isFocused state is changed
	                 * @param {object} scope the scope associated with the grid
	                 * @param {GridRow} row the row that was focused/unfocused
	                 * @param {Event} evt object if raised from an event
	                 */
	                rowFocusChanged: function (scope, row, evt) {},
	                /**
	                 * @ngdoc event
	                 * @name rowSelectionChanged
	                 * @eventOf  ui.grid.selection.api:PublicApi
	                 * @description  is raised after the row.isSelected state is changed
	                 * @param {object} scope the scope associated with the grid
	                 * @param {GridRow} row the row that was selected/deselected
	                 * @param {Event} evt object if raised from an event
	                 */
	                rowSelectionChanged: function (scope, row, evt) {
	                },
	                /**
	                 * @ngdoc event
	                 * @name rowSelectionChangedBatch
	                 * @eventOf  ui.grid.selection.api:PublicApi
	                 * @description  is raised after the row.isSelected state is changed
	                 * in bulk, if the `enableSelectionBatchEvent` option is set to true
	                 * (which it is by default).  This allows more efficient processing
	                 * of bulk events.
	                 * @param {object} scope the scope associated with the grid
	                 * @param {array} rows the rows that were selected/deselected
	                 * @param {Event} evt object if raised from an event
	                 */
	                rowSelectionChangedBatch: function (scope, rows, evt) {
	                }
	              }
	            },
	            methods: {
	              selection: {
	                /**
	                 * @ngdoc function
	                 * @name toggleRowSelection
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Toggles data row as selected or unselected
	                 * @param {object} rowEntity gridOptions.data[] array instance
	                 * @param {Event} evt object if raised from an event
	                 */
	                toggleRowSelection: function (rowEntity, evt) {
	                  var row = grid.getRow(rowEntity);
	                  if (row != void 0 && row !== null) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect, true);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectRow
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Select the data row
	                 * @param {object} rowEntity gridOptions.data[] array instance
	                 * @param {Event} evt object if raised from an event
	                 */
	                selectRow: function (rowEntity, evt) {
	                  var row = grid.getRow(rowEntity);
	                  if (row != void 0 && row !== null && !row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect, true);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectRowByVisibleIndex
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Select the specified row by visible index (i.e. if you
	                 * specify row 0 you'll get the first visible row selected).  In this context
	                 * visible means of those rows that are theoretically visible (i.e. not filtered),
	                 * rather than rows currently rendered on the screen.
	                 * @param {number} rowNum index within the rowsVisible array
	                 * @param {Event} evt object if raised from an event
	                 */
	                selectRowByVisibleIndex: function (rowNum, evt) {
	                  var row = grid.renderContainers.body.visibleRowCache[rowNum];
	                  if (row != void 0 && row !== null && typeof (row) !== 'undefined' && !row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect, false);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectRowByKey
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Select the data row
	                 * @param {boolean} isInEntity if true then key is in entity else it's directly in row
	                 * @param {Symbol} key the key to look for
	                 * @param {any} comparator the value that key should have
	                 * @param {Event} evt object if raised from an event
	                 * @param {array} lookInRows [optional] the rows to look in - if not provided then looks in grid.rows
	                */
	                selectRowByKey: function (isInEntity, key, comparator, evt, lookInRows) {
	                  var row = grid.findRowByKey(isInEntity, key, comparator, lookInRows);
	                  if (row != void 0 && row !== null && typeof (row) !== 'undefined' && !row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect, false);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name unSelectRow
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description UnSelect the data row
	                 * @param {object} rowEntity gridOptions.data[] array instance
	                 * @param {Event} evt object if raised from an event
	                 */
	                unSelectRow: function (rowEntity, evt) {
	                  var row = grid.getRow(rowEntity);
	                  if (row != void 0 && row !== null && row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect, true);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name unSelectRowByVisibleIndex
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Unselect the specified row by visible index (i.e. if you
	                 * specify row 0 you'll get the first visible row unselected).  In this context
	                 * visible means of those rows that are theoretically visible (i.e. not filtered),
	                 * rather than rows currently rendered on the screen.
	                 * @param {number} rowNum index within the rowsVisible array
	                 * @param {Event} evt object if raised from an event
	                 */
	                unSelectRowByVisibleIndex: function (rowNum, evt) {
	                  var row = grid.renderContainers.body.visibleRowCache[rowNum];
	                  if (row != void 0 && row !== null && typeof (row) !== 'undefined' &&  row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect, false);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name unSelectRowByKey
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Select the data row
	                 * @param {boolean} isInEntity if true then key is in entity else it's directly in row
	                 * @param {(string|number)} key the key to look for
	                 * @param {any} comparator the value that key should have
	                 * @param {Event} evt object if raised from an event
	                 * @param {array} lookInRows [optional] the rows to look in - if not provided then looks in grid.rows
	                */
	                unSelectRowByKey: function (isInEntity, key, comparator, evt, lookInRows) {
	                  var row = grid.findRowByKey(isInEntity, key, comparator, lookInRows);
	                  if (row != void 0 && row !== null && typeof (row) !== 'undefined' &&  row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect, false);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectAllRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Selects all rows.  Does nothing if multiSelect = false
	                 * @param {Event} evt object if raised from an event
	                 */
	                selectAllRows: function (evt) {
	                  if (grid.options.multiSelect !== false) {
	                    var changedRows = [];
	                    grid.rows.forEach(function (row) {
	                      if (!row.isSelected && row.enableSelection !== false && grid.options.isRowSelectable(row) !== false) {
	                        row.setSelected(true);
	                        service.decideRaiseSelectionEvent(grid, row, changedRows, evt);
	                      }
	                    });
	                    grid.selection.selectAll = true;
	                    service.decideRaiseSelectionBatchEvent(grid, changedRows, evt);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectAllVisibleRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Selects all visible rows.  Does nothing if multiSelect = false
	                 * @param {Event} evt object if raised from an event
	                 */
	                selectAllVisibleRows: function (evt) {
	                  if (grid.options.multiSelect !== false) {
	                    var changedRows = [];
	                    grid.rows.forEach(function(row) {
	                      if (row.visible) {
	                        if (!row.isSelected && row.enableSelection !== false && grid.options.isRowSelectable(row) !== false) {
	                          row.setSelected(true);
	                          service.decideRaiseSelectionEvent(grid, row, changedRows, evt);
	                        }
	                      } else if (row.isSelected) {
	                        row.setSelected(false);
	                        service.decideRaiseSelectionEvent(grid, row, changedRows, evt);
	                      }
	                    });
	                    grid.selection.selectAll = true;
	                    service.decideRaiseSelectionBatchEvent(grid, changedRows, evt);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name clearSelectedRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Unselects all rows
	                 * @param {Event} evt object if raised from an event
	                 */
	                clearSelectedRows: function (evt) {
	                  service.clearSelectedRows(grid, evt);
	                },
	                /**
	                 * @ngdoc function
	                 * @name getSelectedRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description returns all selected Row's entity references
	                 */
	                getSelectedRows: function () {
	                  return service.mapAndFilterRowsByEntity(service.getSelectedRows(grid));
	                },
	                /**
	                 * @ngdoc function
	                 * @name getUnSelectedRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description returns all unselected Row's entity references
	                 */
	                getUnSelectedRows: function () {
	                  return service.mapAndFilterRowsByEntity(service.getUnSelectedRows(grid));
	                },
	                /**
	                 * @ngdoc function
	                 * @name getSelectedGridRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description returns all selectedRow's as gridRows
	                 */
	                getSelectedGridRows: function () {
	                  return service.getSelectedRows(grid);
	                },
	                /**
	                 * @ngdoc function
	                 * @name getSelectedGridRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description returns all unselected Row's as gridRows
	                 */
	                getUnSelectedGridRows: function () {
	                  return service.getUnSelectedRows(grid);
	                },
	                /**
	                 * @ngdoc function
	                 * @name getSelectedCount
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description returns the number of rows selected
	                 */
	                getSelectedCount: function () {
	                  return grid.selection.selectedCount;
	                },
	                /**
	                 * @ngdoc function
	                 * @name setMultiSelect
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Sets the current gridOption.multiSelect to true or false
	                 * @param {bool} multiSelect true to allow multiple rows
	                 */
	                setMultiSelect: function (multiSelect) {
	                  grid.options.multiSelect = multiSelect;
	                },
	                /**
	                 * @ngdoc function
	                 * @name setModifierKeysToMultiSelect
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Sets the current gridOption.modifierKeysToMultiSelect to true or false
	                 * @param {bool} modifierKeysToMultiSelect true to only allow multiple rows when using ctrlKey or shiftKey is used
	                 */
	                setModifierKeysToMultiSelect: function (modifierKeysToMultiSelect) {
	                  grid.options.modifierKeysToMultiSelect = modifierKeysToMultiSelect;
	                },
	                /**
	                 * @ngdoc function
	                 * @name getSelectAllState
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Returns whether or not the selectAll checkbox is currently ticked.  The
	                 * grid doesn't automatically select rows when you add extra data - so when you add data
	                 * you need to explicitly check whether the selectAll is set, and then call setVisible rows
	                 * if it is
	                 */
	                getSelectAllState: function () {
	                  return grid.selection.selectAll;
	                }
	
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	          // default option to true unless it was explicitly set to false
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.selection.api:GridOptions
	           *
	           *  @description GridOptions for selection feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableRowSelection
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable row selection for entire grid.
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableRowSelection = gridOptions.enableRowSelection !== false;
	          /**
	           *  @ngdoc object
	           *  @name multiSelect
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable multiple row selection for entire grid
	           *  <br/>Defaults to true
	           */
	          gridOptions.multiSelect = gridOptions.multiSelect !== false;
	          /**
	           *  @ngdoc object
	           *  @name noUnselect
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Prevent a row from being unselected.  Works in conjunction
	           *  with `multiselect = false` and `gridApi.selection.selectRow()` to allow
	           *  you to create a single selection only grid - a row is always selected, you
	           *  can only select different rows, you can't unselect the row.
	           *  <br/>Defaults to false
	           */
	          gridOptions.noUnselect = gridOptions.noUnselect === true;
	          /**
	           *  @ngdoc object
	           *  @name modifierKeysToMultiSelect
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable multiple row selection only when using the ctrlKey or shiftKey. Requires multiSelect to be true.
	           *  <br/>Defaults to false
	           */
	          gridOptions.modifierKeysToMultiSelect = gridOptions.modifierKeysToMultiSelect === true;
	          /**
	           *  @ngdoc object
	           *  @name enableRowHeaderSelection
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable a row header to be used for selection
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableRowHeaderSelection = gridOptions.enableRowHeaderSelection !== false;
	          /**
	           *  @ngdoc object
	           *  @name enableFullRowSelection
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable selection by clicking anywhere on the row.  Defaults to
	           *  false if `enableRowHeaderSelection` is true, otherwise defaults to true.
	           */
	          if (typeof (gridOptions.enableFullRowSelection) === 'undefined') {
	            gridOptions.enableFullRowSelection = !gridOptions.enableRowHeaderSelection;
	          }
	          /**
	           *  @ngdoc object
	           *  @name enableFocusRowOnRowHeaderClick
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable focuse row by clicking on the row header.  Defaults to
	           *  true if `enableRowHeaderSelection` is true, otherwise defaults to false.
	           */
	          gridOptions.enableFocusRowOnRowHeaderClick = (gridOptions.enableFocusRowOnRowHeaderClick !== false)
	            || !gridOptions.enableRowHeaderSelection;
	          /**
	           *  @ngdoc object
	           *  @name enableSelectRowOnFocus
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable focuse row by clicking on the row anywhere.  Defaults true.
	           */
	          gridOptions.enableSelectRowOnFocus = (gridOptions.enableSelectRowOnFocus !== false);
	          /**
	           *  @ngdoc object
	           *  @name enableSelectAll
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable the select all checkbox at the top of the selectionRowHeader
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableSelectAll = gridOptions.enableSelectAll !== false;
	          /**
	           *  @ngdoc object
	           *  @name enableSelectionBatchEvent
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description If selected rows are changed in bulk, either via the API or
	           *  via the selectAll checkbox, then a separate event is fired.  Setting this
	           *  option to false will cause the rowSelectionChanged event to be called multiple times
	           *  instead
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableSelectionBatchEvent = gridOptions.enableSelectionBatchEvent !== false;
	          /**
	           *  @ngdoc object
	           *  @name selectionRowHeaderWidth
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description can be used to set a custom width for the row header selection column
	           *  <br/>Defaults to 30px
	           */
	          gridOptions.selectionRowHeaderWidth = angular.isDefined(gridOptions.selectionRowHeaderWidth) ? gridOptions.selectionRowHeaderWidth : 30;
	          /**
	           *  @ngdoc object
	           *  @name enableFooterTotalSelected
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Shows the total number of selected items in footer if true.
	           *  <br/>Defaults to true.
	           *  <br/>GridOptions.showGridFooter must also be set to true.
	           */
	          gridOptions.enableFooterTotalSelected = gridOptions.enableFooterTotalSelected !== false;
	
	          /**
	           *  @ngdoc object
	           *  @name isRowSelectable
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Makes it possible to specify a method that evaluates for each row and sets its "enableSelection" property.
	           */
	          gridOptions.isRowSelectable = angular.isDefined(gridOptions.isRowSelectable) ? gridOptions.isRowSelectable : angular.noop;
	        },
	
	        /**
	         * @ngdoc function
	         * @name toggleRowSelection
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Toggles row as selected or unselected
	         * @param {Grid} grid grid object
	         * @param {GridRow} row row to select or deselect
	         * @param {Event} evt object if resulting from event
	         * @param {bool} multiSelect if false, only one row at time can be selected
	         * @param {bool} noUnselect if true then rows cannot be unselected
	         * @param {bool} [canBeInvisible=true] if false, row can only be selected when it's (theoretically) visible
	         */
	         toggleRowSelection: function (grid, row, evt, multiSelect, noUnselect, canBeInvisible) {
	          if ( row.enableSelection === false ) {
	            return;
	          }
	
	          if (canBeInvisible === void 0) {
	            canBeInvisible = true;
	          }
	
	          var selected = row.isSelected;
	
	          if (!multiSelect) {
	            if (!selected) {
	              service.clearSelectedRows(grid, evt);
	            }
	            else if (service.getSelectedRows(grid).length > 1) {
	              selected = false; // Enable reselect of the row
	              service.clearSelectedRows(grid, evt);
	            }
	          }
	
	          // only select row in this case
	          if (!(selected && noUnselect) && (canBeInvisible || row.visible)) {
	            row.setSelected(!selected);
	            if (row.isSelected === true) {
	              grid.selection.lastSelectedRow = row;
	            }
	
	            grid.selection.selectAll = grid.rows.length === service.getSelectedRows(grid).length;
	            grid.api.selection.raise.rowSelectionChanged(row, evt);
	          }
	        },
	        /**
	         * @ngdoc function
	         * @name shiftSelect
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description selects a group of rows from the last selected row using the shift key
	         * @param {Grid} grid grid object
	         * @param {GridRow} row clicked row
	         * @param {Event} evt object if raised from an event
	         * @param {bool} multiSelect if false, does nothing this is for multiSelect only
	         */
	        shiftSelect: function (grid, row, evt, multiSelect) {
	          if (!multiSelect) {
	            return;
	          }
	          var selectedRows = service.getSelectedRows(grid);
	          var fromRow = selectedRows.length > 0 ? grid.renderContainers.body.visibleRowCache.indexOf(grid.selection.lastSelectedRow) : 0;
	          var toRow = grid.renderContainers.body.visibleRowCache.indexOf(row);
	          // reverse select direction
	          if (fromRow > toRow) {
	            var tmp = fromRow;
	            fromRow = toRow;
	            toRow = tmp;
	          }
	
	          var changedRows = [];
	          for (var i = fromRow; i <= toRow; i++) {
	            var rowToSelect = grid.renderContainers.body.visibleRowCache[i];
	            if (rowToSelect) {
	              if (!rowToSelect.isSelected && rowToSelect.enableSelection !== false) {
	                rowToSelect.setSelected(true);
	                grid.selection.lastSelectedRow = rowToSelect;
	                service.decideRaiseSelectionEvent(grid, rowToSelect, changedRows, evt);
	              }
	            }
	          }
	          service.decideRaiseSelectionBatchEvent(grid, changedRows, evt);
	        },
	        /**
	         * @ngdoc function
	         * @name getSelectedRows
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Returns all the selected rows
	         * @param {Grid} grid grid object
	         */
	        getSelectedRows: function (grid) {
	          return grid.rows.filter(function (row) {
	            return row.isSelected;
	          });
	        },
	        /**
	         * @ngdoc function
	         * @name getUnSelectedRows
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Returns all the unselected rows
	         * @param {Grid} grid grid object
	         */
	        getUnSelectedRows: function (grid) {
	          return grid.rows.filter(function (row) {
	            return !row.isSelected;
	          });
	        },
	        /**
	         * @ngdoc function
	         * @name mapAndFilterRowsByEntity
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Filters all rows by entity and then maps them to Array.
	         */
	        mapAndFilterRowsByEntity: function(gridRows) {
	          if (typeof gridRows.reduce === 'function') { // If reduce is available it will be taken, due to better performance
	            return gridRows.reduce(function (previousVal, currentRow) {
	              if (currentRow.entity.hasOwnProperty('$$hashKey') || !angular.isObject(currentRow.entity)) {
	                previousVal.push(currentRow.entity);
	              }
	              return previousVal;
	            }, []);
	          }
	
	          return gridRows.filter(function (gridRow) { // stays as polyfill
	            return gridRow.entity.hasOwnProperty('$$hashKey') || !angular.isObject(gridRow.entity);
	          }).map(function (gridRow) {
	            return gridRow.entity;
	          });
	        },
	
	        /**
	         * @ngdoc function
	         * @name clearSelectedRows
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Clears all selected rows
	         * @param {Grid} grid grid object
	         * @param {Event} evt object if raised from an event
	         */
	        clearSelectedRows: function (grid, evt) {
	          var changedRows = [];
	          service.getSelectedRows(grid).forEach(function (row) {
	            if (row.isSelected && row.enableSelection !== false) {
	              row.setSelected(false);
	              service.decideRaiseSelectionEvent(grid, row, changedRows, evt);
	            }
	          });
	          grid.selection.selectAll = false;
	          grid.selection.selectedCount = 0;
	          service.decideRaiseSelectionBatchEvent(grid, changedRows, evt);
	        },
	
	        /**
	         * @ngdoc function
	         * @name decideRaiseSelectionEvent
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Decides whether to raise a single event or a batch event
	         * @param {Grid} grid grid object
	         * @param {GridRow} row row that has changed
	         * @param {array} changedRows an array to which we can append the changed
	         * @param {Event} evt object if raised from an event
	         * row if we're doing batch events
	         */
	        decideRaiseSelectionEvent: function (grid, row, changedRows, evt) {
	          if (!grid.options.enableSelectionBatchEvent) {
	            grid.api.selection.raise.rowSelectionChanged(row, evt);
	          }
	          else {
	            changedRows.push(row);
	          }
	        },
	
	        /**
	         * @ngdoc function
	         * @name raiseSelectionEvent
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Decides whether we need to raise a batch event, and
	         * raises it if we do.
	         * @param {Grid} grid grid object
	         * @param {array} changedRows an array of changed rows, only populated
	         * @param {Event} evt object if raised from an event
	         * if we're doing batch events
	         */
	        decideRaiseSelectionBatchEvent: function (grid, changedRows, evt) {
	          if (changedRows.length > 0) {
	            grid.api.selection.raise.rowSelectionChangedBatch(changedRows, evt);
	          }
	        }
	      };
	
	      return service;
	    });
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.selection.directive:uiGridSelection
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds selection features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.selection']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true},
	        {name: 'title', enableCellEdit: true}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-selection></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridSelection', ['i18nService', 'uiGridSelectionConstants', 'uiGridSelectionService', 'uiGridConstants',
	    function (i18nService, uiGridSelectionConstants, uiGridSelectionService, uiGridConstants) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              uiGridSelectionService.initializeGrid(uiGridCtrl.grid);
	              if (uiGridCtrl.grid.options.enableRowHeaderSelection) {
	                var selectionRowHeaderDef = {
	                  name: uiGridSelectionConstants.selectionRowHeaderColName,
	                  displayName: i18nService.getSafeText('selection.displayName'),
	                  width: uiGridCtrl.grid.options.selectionRowHeaderWidth,
	                  minWidth: 10,
	                  cellTemplate: 'ui-grid/selectionRowHeader',
	                  headerCellTemplate: 'ui-grid/selectionHeaderCell',
	                  enableColumnResizing: false,
	                  enableColumnMenu: false,
	                  exporterSuppressExport: true,
	                  allowCellFocus: true
	                };
	
	                uiGridCtrl.grid.addRowHeaderColumn(selectionRowHeaderDef, 0);
	              }
	
	              var processorSet = false;
	
	              var processSelectableRows = function (rows) {
	                rows.forEach(function (row) {
	                  row.enableSelection = uiGridCtrl.grid.options.isRowSelectable(row);
	                });
	                return rows;
	              };
	
	              var updateOptions = function () {
	                if (uiGridCtrl.grid.options.isRowSelectable !== angular.noop && processorSet !== true) {
	                  uiGridCtrl.grid.registerRowsProcessor(processSelectableRows, 500);
	                  processorSet = true;
	                }
	              };
	
	              updateOptions();
	
	              var dataChangeDereg = uiGridCtrl.grid.registerDataChangeCallback(updateOptions, [uiGridConstants.dataChange.OPTIONS]);
	
	              $scope.$on('$destroy', dataChangeDereg);
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	            }
	          };
	        }
	      };
	    }]);
	
	  module.directive('uiGridSelectionRowHeaderButtons', ['$templateCache', 'uiGridSelectionService', 'gridUtil',
	    function ($templateCache, uiGridSelectionService, gridUtil) {
	      return {
	        replace: true,
	        restrict: 'E',
	        template: $templateCache.get('ui-grid/selectionRowHeaderButtons'),
	        scope: true,
	        require: '^uiGrid',
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          var self = uiGridCtrl.grid;
	          $scope.selectButtonClick = selectButtonClick;
	          $scope.selectButtonKeyDown = selectButtonKeyDown;
	
	          // On IE, prevent mousedowns on the select button from starting a selection.
	          // If this is not done and you shift+click on another row, the browser will select a big chunk of text
	          if (gridUtil.detectBrowser() === 'ie') {
	            $elm.on('mousedown', selectButtonMouseDown);
	          }
	
	          function selectButtonKeyDown(row, evt) {
	            if (evt.keyCode === 32 || evt.keyCode === 13) {
	              evt.preventDefault();
	              selectButtonClick(row, evt);
	            }
	          }
	
	          function selectButtonClick(row, evt) {
	            evt.stopPropagation();
	
	            if (evt.shiftKey) {
	              uiGridSelectionService.shiftSelect(self, row, evt, self.options.multiSelect);
	            }
	            else if (evt.ctrlKey || evt.metaKey) {
	              uiGridSelectionService.toggleRowSelection(self, row, evt,
	                self.options.multiSelect, self.options.noUnselect, false);
	            }
	            else if (row.groupHeader) {
	              uiGridSelectionService.toggleRowSelection(self, row, evt, self.options.multiSelect, self.options.noUnselect, false);
	              for (var i = 0; i < row.treeNode.children.length; i++) {
	                uiGridSelectionService.toggleRowSelection(self, row.treeNode.children[i].row, evt, self.options.multiSelect, self.options.noUnselect, false);
	              }
	            }
	            else {
	              uiGridSelectionService.toggleRowSelection(self, row, evt,
	                (self.options.multiSelect && !self.options.modifierKeysToMultiSelect), self.options.noUnselect, false);
	            }
	            self.options.enableFocusRowOnRowHeaderClick && row.setFocused(!row.isFocused) && self.api.selection.raise.rowFocusChanged(row, evt);
	          }
	
	          function selectButtonMouseDown(evt) {
	            if (evt.ctrlKey || evt.shiftKey) {
	              evt.target.onselectstart = function () { return false; };
	              window.setTimeout(function () { evt.target.onselectstart = null; }, 0);
	            }
	          }
	
	          $scope.$on('$destroy', function unbindEvents() {
	            $elm.off();
	          });
	        }
	      };
	    }]);
	
	  module.directive('uiGridSelectionSelectAllButtons', ['$templateCache', 'uiGridSelectionService',
	    function ($templateCache, uiGridSelectionService) {
	      return {
	        replace: true,
	        restrict: 'E',
	        template: $templateCache.get('ui-grid/selectionSelectAllButtons'),
	        scope: false,
	        link: function ($scope) {
	          var self = $scope.col.grid;
	
	          $scope.headerButtonKeyDown = function (evt) {
	            if (evt.keyCode === 32 || evt.keyCode === 13) {
	              evt.preventDefault();
	              $scope.headerButtonClick(evt);
	            }
	          };
	
	          $scope.headerButtonClick = function (evt) {
	            if (self.selection.selectAll) {
	              uiGridSelectionService.clearSelectedRows(self, evt);
	              if (self.options.noUnselect) {
	                self.api.selection.selectRowByVisibleIndex(0, evt);
	              }
	              self.selection.selectAll = false;
	            }
	            else if (self.options.multiSelect) {
	              self.api.selection.selectAllVisibleRows(evt);
	              self.selection.selectAll = true;
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.selection.directive:uiGridViewport
	   *  @element div
	   *
	   *  @description Stacks on top of ui.grid.uiGridViewport to alter the attributes used
	   *  for the grid row
	   */
	  module.directive('uiGridViewport',
	      function () {
	        return {
	          priority: -200, // run after default  directive
	          scope: false,
	          compile: function ($elm) {
	            var rowRepeatDiv = angular.element($elm[0].querySelector('.ui-grid-canvas:not(.ui-grid-empty-base-layer-container)').children[0]),
	              newNgClass = "'ui-grid-row-selected': row.isSelected, 'ui-grid-row-focused': row.isFocused}",
	              existingNgClass = rowRepeatDiv.attr('ng-class');
	
	            if (existingNgClass) {
	              newNgClass = existingNgClass.slice(0, -1) + ',' + newNgClass;
	            } else {
	              newNgClass = '{' + newNgClass;
	            }
	            rowRepeatDiv.attr('ng-class', newNgClass);
	
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {},
	              post: function ($scope, $elm, $attrs, controllers) {}
	            };
	          }
	        };
	      });
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.selection.directive:uiGridCell
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Stacks on top of ui.grid.uiGridCell to provide selection feature
	   */
	  module.directive('uiGridCell',
	    ['uiGridConstants', 'uiGridSelectionService',
	      function (uiGridConstants, uiGridSelectionService) {
	        return {
	          priority: -200, // run after default uiGridCell directive
	          restrict: 'A',
	          require: '?^uiGrid',
	          scope: false,
	          link: function ($scope, $elm, $attrs, uiGridCtrl) {
	            var touchStartTime = 0,
	              touchStartPos = {},
	              touchTimeout = 300,
	              touchPosDiff = 100;
	
	            // Bind to keydown events in the render container
	            if (uiGridCtrl.grid.api.cellNav) {
	              uiGridCtrl.grid.api.cellNav.on.viewPortKeyDown($scope, function (evt, rowCol) {
	                if (rowCol === null ||
	                  rowCol.row !== $scope.row ||
	                  rowCol.col !== $scope.col) {
	                  return;
	                }
	
	                if (evt.keyCode === uiGridConstants.keymap.SPACE && $scope.col.colDef.name === 'selectionRowHeaderCol') {
	                  evt.preventDefault();
	                  uiGridSelectionService.toggleRowSelection($scope.grid, $scope.row, evt,
	                    ($scope.grid.options.multiSelect && !$scope.grid.options.modifierKeysToMultiSelect),
	                    $scope.grid.options.noUnselect, false);
	                  $scope.$apply();
	                }
	              });
	            }
	
	            var selectCells = function (evt) {
	              // if you click on expandable icon doesn't trigger selection
	              if (evt.target.className === "ui-grid-icon-minus-squared" || evt.target.className === "ui-grid-icon-plus-squared") {
	                return;
	              }
	
	              // if we get a click, then stop listening for touchend
	              $elm.off('touchend', touchEnd);
	
	              if (evt.shiftKey) {
	                uiGridSelectionService.shiftSelect($scope.grid, $scope.row, evt, $scope.grid.options.multiSelect);
	              }
	              else if (evt.ctrlKey || evt.metaKey) {
	                uiGridSelectionService.toggleRowSelection($scope.grid, $scope.row, evt,
	                  $scope.grid.options.multiSelect, $scope.grid.options.noUnselect, false);
	              }
	              else if ($scope.grid.options.enableSelectRowOnFocus) {
	                uiGridSelectionService.toggleRowSelection($scope.grid, $scope.row, evt,
	                  ($scope.grid.options.multiSelect && !$scope.grid.options.modifierKeysToMultiSelect),
	                  $scope.grid.options.noUnselect, false);
	              }
	              $scope.row.setFocused(!$scope.row.isFocused);
	              $scope.grid.api.selection.raise.rowFocusChanged($scope.row, evt);
	              $scope.$apply();
	
	              // don't re-enable the touchend handler for a little while - some devices generate both, and it will
	              // take a little while to move your hand from the mouse to the screen if you have both modes of input
	              window.setTimeout(function () {
	                $elm.on('touchend', touchEnd);
	              }, touchTimeout);
	            };
	
	            var touchStart = function (evt) {
	              touchStartTime = (new Date()).getTime();
	              touchStartPos = evt.changedTouches[0];
	
	              // if we get a touch event, then stop listening for click
	              $elm.off('click', selectCells);
	            };
	
	            var touchEnd = function (evt) {
	              var touchEndTime = (new Date()).getTime();
	              var touchEndPos = evt.changedTouches[0];
	              var touchTime = touchEndTime - touchStartTime;
	              var touchXDiff = Math.abs(touchStartPos.clientX - touchEndPos.clientX)
	              var touchYDiff = Math.abs(touchStartPos.clientY - touchEndPos.clientY)
	
	
	              if (touchXDiff < touchPosDiff && touchYDiff < touchPosDiff) {
	                if (touchTime < touchTimeout) {
	                // short touch
	                  selectCells(evt);
	                }
	              }
	
	              // don't re-enable the click handler for a little while - some devices generate both, and it will
	              // take a little while to move your hand from the screen to the mouse if you have both modes of input
	              window.setTimeout(function () {
	                $elm.on('click', selectCells);
	              }, touchTimeout);
	            };
	
	            function registerRowSelectionEvents() {
	              if ($scope.grid.options.enableRowSelection && $scope.grid.options.enableFullRowSelection && $scope.col.colDef.name !== 'selectionRowHeaderCol') {
	                $elm.addClass('ui-grid-disable-selection');
	                $elm.on('touchstart', touchStart);
	                $elm.on('touchend', touchEnd);
	                $elm.on('click', selectCells);
	
	                $scope.registered = true;
	              }
	            }
	
	            function unregisterRowSelectionEvents() {
	              if ($scope.registered) {
	                $elm.removeClass('ui-grid-disable-selection');
	                $elm.off('touchstart', touchStart);
	                $elm.off('touchend', touchEnd);
	                $elm.off('click', selectCells);
	
	                $scope.registered = false;
	              }
	            }
	
	            registerRowSelectionEvents();
	
	            // register a dataChange callback so that we can change the selection configuration dynamically
	            // if the user changes the options
	            var dataChangeUnreg = $scope.grid.registerDataChangeCallback(function () {
	              if ($scope.grid.options.enableRowSelection && $scope.grid.options.enableFullRowSelection &&
	                !$scope.registered) {
	                registerRowSelectionEvents();
	              }
	              else if ((!$scope.grid.options.enableRowSelection || !$scope.grid.options.enableFullRowSelection) &&
	                $scope.registered) {
	                unregisterRowSelectionEvents();
	              }
	            }, [uiGridConstants.dataChange.OPTIONS]);
	
	            $elm.on('$destroy', dataChangeUnreg);
	          }
	        };
	      }]);
	
	  module.directive('uiGridGridFooter', ['$compile', 'gridUtil', function ($compile, gridUtil) {
	    return {
	      restrict: 'EA',
	      replace: true,
	      priority: -1000,
	      require: '^uiGrid',
	      scope: true,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            if (!uiGridCtrl.grid.options.showGridFooter) {
	              return;
	            }
	
	            gridUtil.getTemplate('ui-grid/gridFooterSelectedItems')
	              .then(function (contents) {
	                var template = angular.element(contents);
	
	                var newElm = $compile(template)($scope);
	
	                angular.element($elm[0].getElementsByClassName('ui-grid-grid-footer')[0]).append(newElm);
	              });
	          },
	          post: function ($scope, $elm, $attrs, controllers) {
	
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.treeBase
	   * @description
	   *
	   * # ui.grid.treeBase
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   * This module provides base tree handling functions that are shared by other features, notably grouping
	   * and treeView.  It provides a tree view of the data, with nodes in that
	   * tree and leaves.
	   *
	   * Design information:
	   * -------------------
	   *
	   * The raw data that is provided must come with a $$treeLevel on any non-leaf node.  Grouping will create
	   * these on all the group header rows, treeView will expect these to be set in the raw data by the user.
	   * TreeBase will run a rowsProcessor that:
	   *  - builds `treeBase.tree` out of the provided rows
	   *  - permits a recursive sort of the tree
	   *  - maintains the expand/collapse state of each node
	   *  - provides the expand/collapse all button and the expand/collapse buttons
	   *  - maintains the count of children for each node
	   *
	   * Each row is updated with a link to the tree node that represents it.  Refer {@link ui.grid.treeBase.grid:treeBase.tree tree documentation}
	   * for information.
	   *
	   *  TreeBase adds information to the rows
	   *  - treeLevel: if present and > -1 tells us the level (level 0 is the top level)
	   *  - treeNode: pointer to the node in the grid.treeBase.tree that refers
	   *    to this row, allowing us to manipulate the state
	   *
	   * Since the logic is baked into the rowsProcessors, it should get triggered whenever
	   * row order or filtering or anything like that is changed.  We recall the expanded state
	   * across invocations of the rowsProcessors by the reference to the treeNode on the individual
	   * rows.  We rebuild the tree itself quite frequently, when we do this we use the saved treeNodes to
	   * get the state, but we overwrite the other data in that treeNode.
	   *
	   * By default rows are collapsed, which means all data rows have their visible property
	   * set to false, and only level 0 group rows are set to visible.
	   *
	   * We rely on the rowsProcessors to do the actual expanding and collapsing, so we set the flags we want into
	   * grid.treeBase.tree, then call refresh.  This is because we can't easily change the visible
	   * row cache without calling the processors, and once we've built the logic into the rowProcessors we may as
	   * well use it all the time.
	   *
	   * Tree base provides sorting (on non-grouped columns).
	   *
	   * Sorting works in two passes.  The standard sorting is performed for any columns that are important to building
	   * the tree (for example, any grouped columns).  Then after the tree is built, a recursive tree sort is performed
	   * for the remaining sort columns (including the original sort) - these columns are sorted within each tree level
	   * (so all the level 1 nodes are sorted, then all the level 2 nodes within each level 1 node etc).
	   *
	   * To achieve this we make use of the `ignoreSort` property on the sort configuration.  The parent feature (treeView or grouping)
	   * must provide a rowsProcessor that runs with very low priority (typically in the 60-65 range), and that sets
	   * the `ignoreSort`on any sort that it wants to run on the tree.  TreeBase will clear the ignoreSort on all sorts - so it
	   * will turn on any sorts that haven't run.  It will then call a recursive sort on the tree.
	   *
	   * Tree base provides treeAggregation.  It checks the treeAggregation configuration on each column, and aggregates based on
	   * the logic provided as it builds the tree. Footer aggregation from the uiGrid core should not be used with treeBase aggregation,
	   * since it operates on all visible rows, as opposed to to leaf nodes only. Setting `showColumnFooter: true` will show the
	   * treeAggregations in the column footer.  Aggregation information will be collected in the format:
	   *
	   * ```
	   *   {
	   *     type: 'count',
	   *     value: 4,
	   *     label: 'count: ',
	   *     rendered: 'count: 4'
	   *   }
	   * ```
	   *
	   * A callback is provided to format the value once it is finalised (aka a valueFilter).
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.treeBase"></div>
	   */
	
	  var module = angular.module('ui.grid.treeBase', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.treeBase.constant:uiGridTreeBaseConstants
	   *
	   *  @description constants available in treeBase module.
	   *
	   *  These constants are manually copied into grouping and treeView,
	   *  as I haven't found a way to simply include them, and it's not worth
	   *  investing time in for something that changes very infrequently.
	   *
	   */
	  module.constant('uiGridTreeBaseConstants', {
	    featureName: "treeBase",
	    rowHeaderColName: 'treeBaseRowHeaderCol',
	    EXPANDED: 'expanded',
	    COLLAPSED: 'collapsed',
	    aggregation: {
	      COUNT: 'count',
	      SUM: 'sum',
	      MAX: 'max',
	      MIN: 'min',
	      AVG: 'avg'
	    }
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.treeBase.service:uiGridTreeBaseService
	   *
	   *  @description Services for treeBase feature
	   */
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.treeBase.api:ColumnDef
	   *
	   *  @description ColumnDef for tree feature, these are available to be
	   *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	   */
	
	  module.service('uiGridTreeBaseService', ['$q', 'uiGridTreeBaseConstants', 'gridUtil', 'GridRow', 'gridClassFactory', 'i18nService', 'uiGridConstants', 'rowSorter',
	  function ($q, uiGridTreeBaseConstants, gridUtil, GridRow, gridClassFactory, i18nService, uiGridConstants, rowSorter) {
	
	    var service = {
	
	      initializeGrid: function (grid) {
	
	        // add feature namespace and any properties to grid for needed
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeBase.grid:treeBase
	         *
	         *  @description Grid properties and functions added for treeBase
	         */
	        grid.treeBase = {};
	
	        /**
	         *  @ngdoc property
	         *  @propertyOf ui.grid.treeBase.grid:treeBase
	         *  @name numberLevels
	         *
	         *  @description Total number of tree levels currently used, calculated by the rowsProcessor by
	         *  retaining the highest tree level it sees
	         */
	        grid.treeBase.numberLevels = 0;
	
	        /**
	         *  @ngdoc property
	         *  @propertyOf ui.grid.treeBase.grid:treeBase
	         *  @name expandAll
	         *
	         *  @description Whether or not the expandAll box is selected
	         */
	        grid.treeBase.expandAll = false;
	
	        /**
	         *  @ngdoc property
	         *  @propertyOf ui.grid.treeBase.grid:treeBase
	         *  @name tree
	         *
	         *  @description Tree represented as a nested array that holds the state of each node, along with a
	         *  pointer to the row.  The array order is material - we will display the children in the order
	         *  they are stored in the array
	         *
	         *  Each node stores:
	         *
	         *    - the state of this node
	         *    - an array of children of this node
	         *    - a pointer to the parent of this node (reverse pointer, allowing us to walk up the tree)
	         *    - the number of children of this node
	         *    - aggregation information calculated from the nodes
	         *
	         *  ```
	         *    [{
	         *      state: 'expanded',
	         *      row: <reference to row>,
	         *      parentRow: null,
	         *      aggregations: [{
	         *        type: 'count',
	         *        col: <gridCol>,
	         *        value: 2,
	         *        label: 'count: ',
	         *        rendered: 'count: 2'
	         *      }],
	         *      children: [
	         *        {
	         *          state: 'expanded',
	         *          row: <reference to row>,
	         *          parentRow: <reference to row>,
	         *          aggregations: [{
	         *            type: 'count',
	         *            col: '<gridCol>,
	         *            value: 4,
	         *            label: 'count: ',
	         *            rendered: 'count: 4'
	         *          }],
	         *          children: [
	         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'collapsed', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'collapsed', row: <reference to row>, parentRow: <reference to row> }
	         *          ]
	         *        },
	         *        {
	         *          state: 'collapsed',
	         *          row: <reference to row>,
	         *          parentRow: <reference to row>,
	         *          aggregations: [{
	         *            type: 'count',
	         *            col: <gridCol>,
	         *            value: 3,
	         *            label: 'count: ',
	         *            rendered: 'count: 3'
	         *          }],
	         *          children: [
	         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'collapsed', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> }
	         *          ]
	         *        }
	         *      ]
	         *    }, {<another level 0 node maybe>} ]
	         *  ```
	         *  Missing state values are false - meaning they aren't expanded.
	         *
	         *  This is used because the rowProcessors run every time the grid is refreshed, so
	         *  we'd lose the expanded state every time the grid was refreshed.  This instead gives
	         *  us a reliable lookup that persists across rowProcessors.
	         *
	         *  This tree is rebuilt every time we run the rowsProcessors.  Since each row holds a pointer
	         *  to it's tree node we can persist expand/collapse state across calls to rowsProcessor, we discard
	         *  all transient information on the tree (children, childCount) and recalculate it
	         *
	         */
	        grid.treeBase.tree = [];
	
	        service.defaultGridOptions(grid.options);
	
	        grid.registerRowsProcessor(service.treeRows, 410);
	
	        grid.registerColumnBuilder( service.treeBaseColumnBuilder );
	
	        service.createRowHeader( grid );
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeBase.api:PublicApi
	         *
	         *  @description Public Api for treeBase feature
	         */
	        var publicApi = {
	          events: {
	            treeBase: {
	              /**
	               * @ngdoc event
	               * @eventOf ui.grid.treeBase.api:PublicApi
	               * @name rowExpanded
	               * @description raised whenever a row is expanded.  If you are dynamically
	               * rendering your tree you can listen to this event, and then retrieve
	               * the children of this row and load them into the grid data.
	               *
	               * When the data is loaded the grid will automatically refresh to show these new rows
	               *
	               * <pre>
	               *      gridApi.treeBase.on.rowExpanded(scope,function(row) {})
	               * </pre>
	               * @param {gridRow} row the row that was expanded.  You can also
	               * retrieve the grid from this row with row.grid
	               */
	              rowExpanded: {},
	
	              /**
	               * @ngdoc event
	               * @eventOf ui.grid.treeBase.api:PublicApi
	               * @name rowCollapsed
	               * @description raised whenever a row is collapsed.  Doesn't really have
	               * a purpose at the moment, included for symmetry
	               *
	               * <pre>
	               *      gridApi.treeBase.on.rowCollapsed(scope,function(row) {})
	               * </pre>
	               * @param {gridRow} row the row that was collapsed.  You can also
	               * retrieve the grid from this row with row.grid
	               */
	              rowCollapsed: {}
	            }
	          },
	
	          methods: {
	            treeBase: {
	              /**
	               * @ngdoc function
	               * @name expandAllRows
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description Expands all tree rows
	               */
	              expandAllRows: function () {
	                service.expandAllRows(grid);
	              },
	
	              /**
	               * @ngdoc function
	               * @name collapseAllRows
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description collapse all tree rows
	               */
	              collapseAllRows: function () {
	                service.collapseAllRows(grid);
	              },
	
	              /**
	               * @ngdoc function
	               * @name toggleRowTreeState
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description  call expand if the row is collapsed, collapse if it is expanded
	               * @param {gridRow} row the row you wish to toggle
	               */
	              toggleRowTreeState: function (row) {
	                service.toggleRowTreeState(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name expandRow
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description expand the immediate children of the specified row
	               * @param {gridRow} row the row you wish to expand
	               * @param {boolean} recursive true if you wish to expand the row's ancients
	               */
	              expandRow: function (row, recursive) {
	                service.expandRow(grid, row, recursive);
	              },
	
	              /**
	               * @ngdoc function
	               * @name expandRowChildren
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description expand all children of the specified row
	               * @param {gridRow} row the row you wish to expand
	               */
	              expandRowChildren: function (row) {
	                service.expandRowChildren(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name collapseRow
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description collapse  the specified row.  When
	               * you expand the row again, all grandchildren will retain their state
	               * @param {gridRow} row the row you wish to collapse
	               */
	              collapseRow: function ( row ) {
	                service.collapseRow(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name collapseRowChildren
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description collapse all children of the specified row.  When
	               * you expand the row again, all grandchildren will be collapsed
	               * @param {gridRow} row the row you wish to collapse children for
	               */
	              collapseRowChildren: function ( row ) {
	                service.collapseRowChildren(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name getTreeState
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description Get the tree state for this grid,
	               * used by the saveState feature
	               * Returned treeState as an object
	               *   `{ expandedState: { uid: 'expanded', uid: 'collapsed' } }`
	               * where expandedState is a hash of row uid and the current expanded state
	               *
	               * @returns {object} tree state
	               *
	               * TODO - this needs work - we need an identifier that persists across instantiations,
	               * not uid.  This really means we need a row identity defined, but that won't work for
	               * grouping.  Perhaps this needs to be moved up to treeView and grouping, rather than
	               * being in base.
	               */
	              getTreeExpandedState: function () {
	                return { expandedState: service.getTreeState(grid) };
	              },
	
	              /**
	               * @ngdoc function
	               * @name setTreeState
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description Set the expanded states of the tree
	               * @param {object} config the config you want to apply, in the format
	               * provided by getTreeState
	               */
	              setTreeState: function ( config ) {
	                service.setTreeState( grid, config );
	              },
	
	              /**
	               * @ngdoc function
	               * @name getRowChildren
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description Get the children of the specified row
	               * @param {GridRow} row the row you want the children of
	               * @returns {Array} array of children of this row, the children
	               * are all gridRows
	               */
	              getRowChildren: function ( row ) {
	                return row.treeNode.children.map( function( childNode ) {
	                  return childNode.row;
	                });
	              }
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	
	
	      defaultGridOptions: function (gridOptions) {
	        // default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeBase.api:GridOptions
	         *
	         *  @description GridOptions for treeBase feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name treeRowHeaderBaseWidth
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description Base width of the tree header, provides for a single level of tree.  This
	         *  is incremented by `treeIndent` for each extra level
	         *  <br/>Defaults to 30
	         */
	        gridOptions.treeRowHeaderBaseWidth = gridOptions.treeRowHeaderBaseWidth || 30;
	
	        /**
	         *  @ngdoc object
	         *  @name treeIndent
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description Number of pixels of indent for the icon at each tree level, wider indents are visually more pleasing,
	         *  but will make the tree row header wider
	         *  <br/>Defaults to 10
	         */
	        gridOptions.treeIndent = (gridOptions.treeIndent != null) ? gridOptions.treeIndent : 10;
	
	        /**
	         *  @ngdoc object
	         *  @name showTreeRowHeader
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description If set to false, don't create the row header.  You'll need to programmatically control the expand
	         *  states
	         *  <br/>Defaults to true
	         */
	        gridOptions.showTreeRowHeader = gridOptions.showTreeRowHeader !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name showTreeExpandNoChildren
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description If set to true, show the expand/collapse button even if there are no
	         *  children of a node.  You'd use this if you're planning to dynamically load the children
	         *
	         *  <br/>Defaults to true, grouping overrides to false
	         */
	        gridOptions.showTreeExpandNoChildren = gridOptions.showTreeExpandNoChildren !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name treeRowHeaderAlwaysVisible
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description If set to true, row header even if there are no tree nodes
	         *
	         *  <br/>Defaults to true
	         */
	        gridOptions.treeRowHeaderAlwaysVisible = gridOptions.treeRowHeaderAlwaysVisible !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name treeCustomAggregations
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description Define custom aggregation functions. The properties of this object will be
	         *  aggregation types available for use on columnDef with {@link ui.grid.treeBase.api:ColumnDef treeAggregationType} or through the column menu.
	         *  If a function defined here uses the same name as one of the native aggregations, this one will take precedence.
	         *  The object format is:
	         *
	         *  <pre>
	         *    {
	         *      aggregationName: {
	         *        label: (optional) string,
	         *        aggregationFn: function( aggregation, fieldValue, numValue, row ) {...},
	         *        finalizerFn: (optional) function( aggregation ) {...}
	         *      },
	         *      mean: {
	         *        label: 'mean',
	         *        aggregationFn: function( aggregation, fieldValue, numValue ) {
	         *          aggregation.count = (aggregation.count || 1) + 1;
	         *          aggregation.sum = (aggregation.sum || 0) + numValue;
	         *        },
	         *        finalizerFn: function( aggregation ) {
	         *          aggregation.value = aggregation.sum / aggregation.count
	         *        }
	         *      }
	         *    }
	         *  </pre>
	         *
	         *  <br/>The `finalizerFn` may be used to manipulate the value before rendering, or to
	         *  apply a custom rendered value. If `aggregation.rendered` is left undefined, the value will be
	         *  rendered. Note that the native aggregation functions use an `finalizerFn` to concatenate
	         *  the label and the value.
	         *
	         *  <br/>Defaults to {}
	         */
	        gridOptions.treeCustomAggregations = gridOptions.treeCustomAggregations || {};
	
	        /**
	         *  @ngdoc object
	         *  @name enableExpandAll
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description Enable the expand all button at the top of the row header
	         *
	         *  <br/>Defaults to true
	         */
	        gridOptions.enableExpandAll = gridOptions.enableExpandAll !== false;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name treeBaseColumnBuilder
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Sets the tree defaults based on the columnDefs
	       *
	       * @param {object} colDef columnDef we're basing on
	       * @param {GridColumn} col the column we're to update
	       * @param {object} gridOptions the options we should use
	       * @returns {promise} promise for the builder - actually we do it all inline so it's immediately resolved
	       */
	      treeBaseColumnBuilder: function (colDef, col, gridOptions) {
	
	
	        /**
	         *  @ngdoc object
	         *  @name customTreeAggregationFn
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description A custom function that aggregates rows into some form of
	         *  total.  Aggregations run row-by-row, the function needs to be capable of
	         *  creating a running total.
	         *
	         *  The function will be provided the aggregation item (in which you can store running
	         *  totals), the row value that is to be aggregated, and that same row value converted to
	         *  a number (most aggregations work on numbers)
	         *  @example
	         *  <pre>
	         *    customTreeAggregationFn = function ( aggregation, fieldValue, numValue, row ) {
	         *      // calculates the average of the squares of the values
	         *      if ( typeof(aggregation.count) === 'undefined' ) {
	         *        aggregation.count = 0;
	         *      }
	         *      aggregation.count++;
	         *
	         *      if ( !isNaN(numValue) ) {
	         *        if ( typeof(aggregation.total) === 'undefined' ) {
	         *          aggregation.total = 0;
	         *        }
	         *        aggregation.total = aggregation.total + numValue * numValue;
	         *      }
	         *
	         *      aggregation.value = aggregation.total / aggregation.count;
	         *    }
	         *  </pre>
	         *  <br/>Defaults to undefined. May be overwritten by treeAggregationType, the two options should not be used together.
	         */
	        if ( typeof(colDef.customTreeAggregationFn) !== 'undefined' ) {
	          col.treeAggregationFn = colDef.customTreeAggregationFn;
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name treeAggregationType
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description Use one of the native or grid-level aggregation methods for calculating aggregations on this column.
	         *  Native method are in the constants file and include: SUM, COUNT, MIN, MAX, AVG. This may also be the property the
	         *  name of an aggregation function defined with {@link ui.grid.treeBase.api:GridOptions treeCustomAggregations}.
	         *
	         *  <pre>
	         *      treeAggregationType = uiGridTreeBaseConstants.aggregation.SUM,
	         *    }
	         *  </pre>
	         *
	         *  If you are using aggregations you should either:
	         *
	         *   - also use grouping, in which case the aggregations are displayed in the group header, OR
	         *   - use treeView, in which case you can set `treeAggregationUpdateEntity: true` in the colDef, and
	         *     treeBase will store the aggregation information in the entity, or you can set `treeAggregationUpdateEntity: false`
	         *     in the colDef, and you need to manual retrieve the calculated aggregations from the row.treeNode.aggregations
	         *
	         *  <br/>Takes precendence over a treeAggregationFn, the two options should not be used together.
	         *  <br/>Defaults to undefined.
	         */
	        if ( typeof(colDef.treeAggregationType) !== 'undefined' ) {
	          col.treeAggregation = { type: colDef.treeAggregationType };
	          if ( typeof(gridOptions.treeCustomAggregations[colDef.treeAggregationType]) !== 'undefined' ) {
	            col.treeAggregationFn = gridOptions.treeCustomAggregations[colDef.treeAggregationType].aggregationFn;
	            col.treeAggregationFinalizerFn = gridOptions.treeCustomAggregations[colDef.treeAggregationType].finalizerFn;
	            col.treeAggregation.label = gridOptions.treeCustomAggregations[colDef.treeAggregationType].label;
	          }
	          else if ( typeof(service.nativeAggregations()[colDef.treeAggregationType]) !== 'undefined' ) {
	            col.treeAggregationFn = service.nativeAggregations()[colDef.treeAggregationType].aggregationFn;
	            col.treeAggregation.label = service.nativeAggregations()[colDef.treeAggregationType].label;
	          }
	        }
	
	         /**
	         *  @ngdoc object
	         *  @name treeAggregationLabel
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description A custom label to use for this aggregation. If provided we don't use native i18n.
	         */
	        if ( typeof(colDef.treeAggregationLabel) !== 'undefined' ) {
	          if (typeof(col.treeAggregation) === 'undefined' ) {
	            col.treeAggregation = {};
	          }
	          col.treeAggregation.label = colDef.treeAggregationLabel;
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name treeAggregationUpdateEntity
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description Store calculated aggregations into the entity, allowing them
	         *  to be displayed in the grid using a standard cellTemplate.  This defaults to true,
	         *  if you are using grouping then you shouldn't set it to false, as then the aggregations won't
	         *  display.
	         *
	         *  If you are using treeView in most cases you'll want to set this to true.  This will result in
	         *  getCellValue returning the aggregation rather than whatever was stored in the cell attribute on
	         *  the entity.  If you want to render the underlying entity value (and do something else with the aggregation)
	         *  then you could use a custom cellTemplate to display `row.entity.myAttribute`, rather than using getCellValue.
	         *
	         *  <br/>Defaults to true
	         *
	         *  @example
	         *  <pre>
	         *    gridOptions.columns = [{
	         *      name: 'myCol',
	         *      treeAggregation: { type: uiGridTreeBaseConstants.aggregation.SUM },
	         *      treeAggregationUpdateEntity: true
	         *      cellTemplate: '<div>{{row.entity.myCol + " " + row.treeNode.aggregations[0].rendered}}</div>'
	         *    }];
	         * </pre>
	         */
	        col.treeAggregationUpdateEntity = colDef.treeAggregationUpdateEntity !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name customTreeAggregationFinalizerFn
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description A custom function that populates aggregation.rendered, this is called when
	         *  a particular aggregation has been fully calculated, and we want to render the value.
	         *
	         *  With the native aggregation options we just concatenate `aggregation.label` and
	         *  `aggregation.value`, but if you wanted to apply a filter or otherwise manipulate the label
	         *  or the value, you can do so with this function. This function will be called after the
	         *  the default `finalizerFn`.
	         *
	         *  @example
	         *  <pre>
	         *    customTreeAggregationFinalizerFn = function ( aggregation ) {
	         *      aggregation.rendered = aggregation.label + aggregation.value / 100 + '%';
	         *    }
	         *  </pre>
	         *  <br/>Defaults to undefined.
	         */
	        if ( typeof(col.customTreeAggregationFinalizerFn) === 'undefined' ) {
	          col.customTreeAggregationFinalizerFn = colDef.customTreeAggregationFinalizerFn;
	        }
	
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name createRowHeader
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Create the rowHeader.  If treeRowHeaderAlwaysVisible then
	       * set it to visible, otherwise set it to invisible
	       *
	       * @param {Grid} grid grid object
	       */
	      createRowHeader: function( grid ) {
	        var rowHeaderColumnDef = {
	          name: uiGridTreeBaseConstants.rowHeaderColName,
	          displayName: '',
	          width:  grid.options.treeRowHeaderBaseWidth,
	          minWidth: 10,
	          cellTemplate: 'ui-grid/treeBaseRowHeader',
	          headerCellTemplate: 'ui-grid/treeBaseHeaderCell',
	          enableColumnResizing: false,
	          enableColumnMenu: false,
	          exporterSuppressExport: true,
	          allowCellFocus: true
	        };
	
	        rowHeaderColumnDef.visible = grid.options.treeRowHeaderAlwaysVisible;
	        grid.addRowHeaderColumn(rowHeaderColumnDef, -100);
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name expandAllRows
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Expands all nodes in the tree
	       *
	       * @param {Grid} grid grid object
	       */
	      expandAllRows: function (grid) {
	        grid.treeBase.tree.forEach( function( node ) {
	          service.setAllNodes( grid, node, uiGridTreeBaseConstants.EXPANDED);
	        });
	        grid.treeBase.expandAll = true;
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name collapseAllRows
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Collapses all nodes in the tree
	       *
	       * @param {Grid} grid grid object
	       */
	      collapseAllRows: function (grid) {
	        grid.treeBase.tree.forEach( function( node ) {
	          service.setAllNodes( grid, node, uiGridTreeBaseConstants.COLLAPSED);
	        });
	        grid.treeBase.expandAll = false;
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name setAllNodes
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Works through a subset of grid.treeBase.rowExpandedStates, setting
	       * all child nodes (and their descendents) of the provided node to the given state.
	       *
	       * Calls itself recursively on all nodes so as to achieve this.
	       *
	       * @param {Grid} grid the grid we're operating on (so we can raise events)
	       * @param {object} treeNode a node in the tree that we want to update
	       * @param {string} targetState the state we want to set it to
	       */
	      setAllNodes: function (grid, treeNode, targetState) {
	        if ( typeof(treeNode.state) !== 'undefined' && treeNode.state !== targetState ) {
	          treeNode.state = targetState;
	
	          if ( targetState === uiGridTreeBaseConstants.EXPANDED ) {
	            grid.api.treeBase.raise.rowExpanded(treeNode.row);
	          }
	          else {
	            grid.api.treeBase.raise.rowCollapsed(treeNode.row);
	          }
	        }
	
	        // set all child nodes
	        if ( treeNode.children ) {
	          treeNode.children.forEach(function( childNode ) {
	            service.setAllNodes(grid, childNode, targetState);
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name toggleRowTreeState
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Toggles the expand or collapse state of this grouped row, if
	       * it's a parent row
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to toggle
	       */
	      toggleRowTreeState: function ( grid, row ) {
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ) {
	          return;
	        }
	
	        if (row.treeNode.state === uiGridTreeBaseConstants.EXPANDED) {
	          service.collapseRow(grid, row);
	        }
	        else {
	          service.expandRow(grid, row, false);
	        }
	
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name expandRow
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Expands this specific row, showing only immediate children.
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to expand
	       * @param {boolean} recursive true if you wish to expand the row's ancients
	       */
	      expandRow: function ( grid, row, recursive ) {
	        if ( recursive ) {
	          var parents = [];
	          while ( row && typeof(row.treeLevel) !== 'undefined' && row.treeLevel !== null && row.treeLevel >= 0 && row.treeNode.state !== uiGridTreeBaseConstants.EXPANDED ) {
	            parents.push(row);
	            row = row.treeNode.parentRow;
	          }
	
	          if ( parents.length > 0 ) {
	            row = parents.pop();
	            while ( row ) {
	                row.treeNode.state = uiGridTreeBaseConstants.EXPANDED;
	                grid.api.treeBase.raise.rowExpanded(row);
	                row = parents.pop();
	            }
	
	            grid.treeBase.expandAll = service.allExpanded(grid.treeBase.tree);
	            grid.queueGridRefresh();
	          }
	        }
	        else {
	          if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ) {
	            return;
	          }
	
	          if ( row.treeNode.state !== uiGridTreeBaseConstants.EXPANDED ) {
	            row.treeNode.state = uiGridTreeBaseConstants.EXPANDED;
	            grid.api.treeBase.raise.rowExpanded(row);
	            grid.treeBase.expandAll = service.allExpanded(grid.treeBase.tree);
	            grid.queueGridRefresh();
	          }
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name expandRowChildren
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Expands this specific row, showing all children.
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to expand
	       */
	      expandRowChildren: function ( grid, row ) {
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ) {
	          return;
	        }
	
	        service.setAllNodes(grid, row.treeNode, uiGridTreeBaseConstants.EXPANDED);
	        grid.treeBase.expandAll = service.allExpanded(grid.treeBase.tree);
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name collapseRow
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Collapses this specific row
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to collapse
	       */
	      collapseRow: function( grid, row ) {
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ) {
	          return;
	        }
	
	        if ( row.treeNode.state !== uiGridTreeBaseConstants.COLLAPSED ) {
	          row.treeNode.state = uiGridTreeBaseConstants.COLLAPSED;
	          grid.treeBase.expandAll = false;
	          grid.api.treeBase.raise.rowCollapsed(row);
	          grid.queueGridRefresh();
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name collapseRowChildren
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Collapses this specific row and all children
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to collapse
	       */
	      collapseRowChildren: function( grid, row ) {
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ) {
	          return;
	        }
	
	        service.setAllNodes(grid, row.treeNode, uiGridTreeBaseConstants.COLLAPSED);
	        grid.treeBase.expandAll = false;
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name allExpanded
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Returns true if all rows are expanded, false
	       * if they're not.  Walks the tree to determine this.  Used
	       * to set the expandAll state.
	       *
	       * If the node has no children, then return true (it's immaterial
	       * whether it is expanded).  If the node has children, then return
	       * false if this node is collapsed, or if any child node is not all expanded
	       *
	       * @param {object} tree the grid to check
	       * @returns {boolean} whether or not the tree is all expanded
	       */
	      allExpanded: function( tree ) {
	        var allExpanded = true;
	
	        tree.forEach(function( node ) {
	          if ( !service.allExpandedInternal( node ) ) {
	            allExpanded = false;
	          }
	        });
	        return allExpanded;
	      },
	
	      allExpandedInternal: function( treeNode ) {
	        if ( treeNode.children && treeNode.children.length > 0 ) {
	          if ( treeNode.state === uiGridTreeBaseConstants.COLLAPSED ) {
	            return false;
	          }
	          var allExpanded = true;
	          treeNode.children.forEach( function( node ) {
	            if ( !service.allExpandedInternal( node ) ) {
	              allExpanded = false;
	            }
	          });
	          return allExpanded;
	        }
	        else {
	          return true;
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name treeRows
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description The rowProcessor that adds the nodes to the tree, and sets the visible
	       * state of each row based on it's parent state
	       *
	       * Assumes it is always called after the sorting processor, and the grouping processor if there is one.
	       * Performs any tree sorts itself after having built the tree
	       *
	       * Processes all the rows in order, setting the group level based on the $$treeLevel in the associated
	       * entity, and setting the visible state based on the parent's state.
	       *
	       * Calculates the deepest level of tree whilst it goes, and updates that so that the header column can be correctly
	       * sized.
	       *
	       * Aggregates if necessary along the way.
	       *
	       * @param {array} renderableRows the rows we want to process, usually the output from the previous rowProcessor
	       * @returns {array} the updated rows
	       */
	      treeRows: function( renderableRows ) {
	        var grid = this;
	
	        if (renderableRows.length === 0) {
	          service.updateRowHeaderWidth( grid );
	          return renderableRows;
	        }
	
	        grid.treeBase.tree = service.createTree( grid, renderableRows );
	        service.updateRowHeaderWidth( grid );
	
	        service.sortTree( grid );
	        service.fixFilter( grid );
	
	        return service.renderTree( grid.treeBase.tree );
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name createOrUpdateRowHeaderWidth
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Calculates the rowHeader width.
	       *
	       * If rowHeader is always present, updates the width.
	       *
	       * If rowHeader is only sometimes present (`treeRowHeaderAlwaysVisible: false`), determines whether there
	       * should be one, then creates or removes it as appropriate, with the created rowHeader having the
	       * right width.
	       *
	       * If there's never a rowHeader then never creates one: `showTreeRowHeader: false`
	       *
	       * @param {Grid} grid the grid we want to set the row header on
	       */
	      updateRowHeaderWidth: function( grid ) {
	        var rowHeader = grid.getColumn(uiGridTreeBaseConstants.rowHeaderColName),
	          newWidth = grid.options.treeRowHeaderBaseWidth + grid.options.treeIndent * Math.max(grid.treeBase.numberLevels - 1, 0);
	
	        if ( rowHeader && newWidth !== rowHeader.width ) {
	          rowHeader.width = newWidth;
	          grid.queueRefresh();
	        }
	
	        var newVisibility = true;
	
	        if ( grid.options.showTreeRowHeader === false ) {
	          newVisibility = false;
	        }
	        if ( grid.options.treeRowHeaderAlwaysVisible === false && grid.treeBase.numberLevels <= 0 ) {
	          newVisibility = false;
	        }
	        if ( rowHeader  && rowHeader.visible !== newVisibility ) {
	          rowHeader.visible = newVisibility;
	          rowHeader.colDef.visible = newVisibility;
	          grid.queueGridRefresh();
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name renderTree
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Creates an array of rows based on the tree, exporting only
	       * the visible nodes and leaves
	       *
	       * @param {array} nodeList The list of nodes - can be grid.treeBase.tree, or can be node.children when
	       * we're calling recursively
	       * @returns {array} renderable rows
	       */
	      renderTree: function( nodeList ) {
	        var renderableRows = [];
	
	        nodeList.forEach( function ( node ) {
	          if ( node.row.visible ) {
	            renderableRows.push( node.row );
	          }
	          if ( node.state === uiGridTreeBaseConstants.EXPANDED && node.children && node.children.length > 0 ) {
	            renderableRows = renderableRows.concat( service.renderTree( node.children ) );
	          }
	        });
	        return renderableRows;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name createTree
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Creates a tree from the renderableRows
	       *
	       * @param {Grid} grid The grid
	       * @param {array} renderableRows The rows we want to create a tree from
	       * @returns {object} The tree we've build
	       */
	      createTree: function( grid, renderableRows ) {
	        var currentLevel = -1,
	          parentsCache = {},
	          parents = [],
	          currentState;
	
	        grid.treeBase.tree = [];
	        grid.treeBase.numberLevels = 0;
	
	        var aggregations = service.getAggregations( grid );
	
	        function createNode( row ) {
	          if ( !row.internalRow && row.treeLevel !== row.entity.$$treeLevel ) {
	            row.treeLevel = row.entity.$$treeLevel;
	          }
	
	          if ( row.treeLevel <= currentLevel ) {
	            // pop any levels that aren't parents of this level, formatting the aggregation at the same time
	            while ( row.treeLevel <= currentLevel ) {
	              var lastParent = parents.pop();
	              service.finaliseAggregations( lastParent );
	              currentLevel--;
	            }
	
	            // reset our current state based on the new parent, set to expanded if this is a level 0 node
	            if ( parents.length > 0 ) {
	              currentState = service.setCurrentState(parents);
	            }
	            else {
	              currentState = uiGridTreeBaseConstants.EXPANDED;
	            }
	          }
	
	          // If row header as parent exists in parentsCache
	          if (
	            typeof row.treeLevel !== 'undefined' &&
	            row.treeLevel !== null &&
	            row.treeLevel >= 0 &&
	            parentsCache.hasOwnProperty(row.uid)
	          ) {
	            parents.push(parentsCache[row.uid]);
	          }
	
	          // aggregate if this is a leaf node
	          if ( ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ) && row.visible  ) {
	            service.aggregate( grid, row, parents );
	          }
	
	          // add this node to the tree
	          if (!parentsCache.hasOwnProperty(row.uid)) {
	            service.addOrUseNode(grid, row, parents, aggregations);
	          }
	
	          if ( typeof(row.treeLevel) !== 'undefined' && row.treeLevel !== null && row.treeLevel >= 0 ) {
	            if (!parentsCache.hasOwnProperty(row.uid)) {
	              parentsCache[row.uid] = row;
	              parents.push(row);
	            }
	            currentLevel++;
	            currentState = service.setCurrentState(parents);
	          }
	
	          // update the tree number of levels, so we can set header width if we need to
	          if ( grid.treeBase.numberLevels < row.treeLevel + 1) {
	            grid.treeBase.numberLevels = row.treeLevel + 1;
	          }
	        }
	
	        renderableRows.forEach( createNode );
	
	        // finalize remaining aggregations
	        while ( parents.length > 0 ) {
	          var lastParent = parents.pop();
	          service.finaliseAggregations( lastParent );
	        }
	
	        return grid.treeBase.tree;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name addOrUseNode
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Creates a tree node for this row.  If this row already has a treeNode
	       * recorded against it, preserves the state, but otherwise overwrites the data.
	       *
	       * @param {grid} grid The grid we're operating on
	       * @param {gridRow} row The row we want to set
	       * @param {array} parents An array of the parents this row should have
	       * @param {array} aggregationBase Empty aggregation information
	       * @returns {undefined} Updates the parents array, updates the row to have a treeNode, and updates the
	       * grid.treeBase.tree
	       */
	      addOrUseNode: function( grid, row, parents, aggregationBase ) {
	        var newAggregations = [];
	        aggregationBase.forEach( function(aggregation) {
	          newAggregations.push(service.buildAggregationObject(aggregation.col));
	        });
	
	        var newNode = { state: uiGridTreeBaseConstants.COLLAPSED, row: row, parentRow: null, aggregations: newAggregations, children: [] };
	        if ( row.treeNode ) {
	          newNode.state = row.treeNode.state;
	        }
	        if ( parents.length > 0 ) {
	          newNode.parentRow = parents[parents.length - 1];
	        }
	        row.treeNode = newNode;
	
	        if ( parents.length === 0 ) {
	          grid.treeBase.tree.push( newNode );
	        } else {
	          parents[parents.length - 1].treeNode.children.push( newNode );
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name setCurrentState
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Looks at the parents array to determine our current state.
	       * If any node in the hierarchy is collapsed, then return collapsed, otherwise return
	       * expanded.
	       *
	       * @param {array} parents An array of the parents this row should have
	       * @returns {string} The state we should be setting to any nodes we see
	       */
	      setCurrentState: function( parents ) {
	        var currentState = uiGridTreeBaseConstants.EXPANDED;
	
	        parents.forEach( function(parent) {
	          if ( parent.treeNode.state === uiGridTreeBaseConstants.COLLAPSED ) {
	            currentState = uiGridTreeBaseConstants.COLLAPSED;
	          }
	        });
	        return currentState;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name sortTree
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Performs a recursive sort on the tree nodes, sorting the
	       * children of each node and putting them back into the children array.
	       *
	       * Before doing this it turns back on all the sortIgnore - things that were previously
	       * ignored we process now.  Since we're sorting within the nodes, presumably anything
	       * that was already sorted is how we derived the nodes, we can keep those sorts too.
	       *
	       * We only sort tree nodes that are expanded - no point in wasting effort sorting collapsed
	       * nodes
	       *
	       * @param {Grid} grid The grid to get the aggregation information from
	       * @returns {array} The aggregation information
	       */
	      sortTree: function( grid ) {
	        grid.columns.forEach( function( column ) {
	          if ( column.sort && column.sort.ignoreSort ) {
	            delete column.sort.ignoreSort;
	          }
	        });
	
	        grid.treeBase.tree = service.sortInternal( grid, grid.treeBase.tree );
	      },
	
	      sortInternal: function( grid, treeList ) {
	        var rows = treeList.map( function( node ) {
	          return node.row;
	        });
	
	        rows = rowSorter.sort( grid, rows, grid.columns );
	
	        var treeNodes = rows.map( function( row ) {
	          return row.treeNode;
	        });
	
	        treeNodes.forEach( function( node ) {
	          if ( node.state === uiGridTreeBaseConstants.EXPANDED && node.children && node.children.length > 0 ) {
	            node.children = service.sortInternal( grid, node.children );
	          }
	        });
	
	        return treeNodes;
	      },
	
	      /**
	       * @ngdoc function
	       * @name fixFilter
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description After filtering has run, we need to go back through the tree
	       * and make sure the parent rows are always visible if any of the child rows
	       * are visible (filtering may make a child visible, but the parent may not
	       * match the filter criteria)
	       *
	       * This has a risk of being computationally expensive, we do it by walking
	       * the tree and remembering whether there are any invisible nodes on the
	       * way down.
	       *
	       * @param {Grid} grid the grid to fix filters on
	       */
	      fixFilter: function( grid ) {
	        var parentsVisible;
	
	        grid.treeBase.tree.forEach( function( node ) {
	          if ( node.children && node.children.length > 0 ) {
	            parentsVisible = node.row.visible;
	            service.fixFilterInternal( node.children, parentsVisible );
	          }
	        });
	      },
	
	      fixFilterInternal: function( nodes, parentsVisible) {
	        nodes.forEach(function( node ) {
	          if ( node.row.visible && !parentsVisible ) {
	            service.setParentsVisible( node );
	            parentsVisible = true;
	          }
	
	          if ( node.children && node.children.length > 0 ) {
	            if ( service.fixFilterInternal( node.children, ( parentsVisible && node.row.visible ) ) ) {
	              parentsVisible = true;
	            }
	          }
	        });
	
	        return parentsVisible;
	      },
	
	      setParentsVisible: function( node ) {
	        while ( node.parentRow ) {
	          node.parentRow.visible = true;
	          node = node.parentRow.treeNode;
	        }
	      },
	
	      /**
	       * @ngdoc function
	       * @name buildAggregationObject
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Build the object which is stored on the column for holding meta-data about the aggregation.
	       * This method should only be called with columns which have an aggregation.
	       *
	       * @param {GridColumn} column The column which this object relates to
	       * @returns {object} {col: GridColumn object, label: string, type: string (optional)}
	       */
	      buildAggregationObject: function( column ) {
	        var newAggregation = { col: column };
	
	        if ( column.treeAggregation && column.treeAggregation.type ) {
	          newAggregation.type = column.treeAggregation.type;
	        }
	
	        if ( column.treeAggregation && column.treeAggregation.label ) {
	          newAggregation.label = column.treeAggregation.label;
	        }
	
	        return newAggregation;
	      },
	
	      /**
	       * @ngdoc function
	       * @name getAggregations
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Looks through the grid columns to find those with aggregations,
	       * and collates the aggregation information into an array, returns that array
	       *
	       * @param {Grid} grid the grid to get the aggregation information from
	       * @returns {array} the aggregation information
	       */
	      getAggregations: function( grid ) {
	        var aggregateArray = [];
	
	        grid.columns.forEach( function(column) {
	          if ( typeof(column.treeAggregationFn) !== 'undefined' ) {
	            aggregateArray.push( service.buildAggregationObject(column) );
	
	            if ( grid.options.showColumnFooter && typeof(column.colDef.aggregationType) === 'undefined' && column.treeAggregation ) {
	              // Add aggregation object for footer
	              column.treeFooterAggregation = service.buildAggregationObject(column);
	              column.aggregationType = service.treeFooterAggregationType;
	            }
	          }
	        });
	        return aggregateArray;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name aggregate
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Accumulate the data from this row onto the aggregations for each parent
	       *
	       * Iterate over the parents, then iterate over the aggregations for each of those parents,
	       * and perform the aggregation for each individual aggregation
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to set grouping visibility on
	       * @param {array} parents the parents that we would want to aggregate onto
	       */
	      aggregate: function( grid, row, parents ) {
	        if (parents.length === 0 && row.treeNode && row.treeNode.aggregations) {
	          row.treeNode.aggregations.forEach(function(aggregation) {
	            // Calculate aggregations for footer even if there are no grouped rows
	            if (typeof(aggregation.col.treeFooterAggregation) !== 'undefined') {
	              var fieldValue = grid.getCellValue(row, aggregation.col);
	              var numValue = Number(fieldValue);
	              if (aggregation.col.treeAggregationFn) {
	                aggregation.col.treeAggregationFn(aggregation.col.treeFooterAggregation, fieldValue, numValue, row);
	              } else {
	                aggregation.col.treeFooterAggregation.value = undefined;
	              }
	            }
	          });
	        }
	
	        parents.forEach( function( parent, index ) {
	          if (parent.treeNode.aggregations) {
	            parent.treeNode.aggregations.forEach( function( aggregation ) {
	              var fieldValue = grid.getCellValue(row, aggregation.col);
	              var numValue = Number(fieldValue);
	              aggregation.col.treeAggregationFn(aggregation, fieldValue, numValue, row);
	
	              if (index === 0 && typeof(aggregation.col.treeFooterAggregation) !== 'undefined') {
	                if (aggregation.col.treeAggregationFn) {
	                  aggregation.col.treeAggregationFn(aggregation.col.treeFooterAggregation, fieldValue, numValue, row);
	                } else {
	                  aggregation.col.treeFooterAggregation.value = undefined;
	                }
	              }
	            });
	          }
	        });
	      },
	
	
	      // Aggregation routines - no doco needed as self evident
	      nativeAggregations: function() {
	        return {
	          count: {
	            label: i18nService.get().aggregation.count,
	            menuTitle: i18nService.get().grouping.aggregate_count,
	            aggregationFn: function (aggregation, fieldValue, numValue) {
	              if (typeof(aggregation.value) === 'undefined') {
	                aggregation.value = 1;
	              } else {
	                aggregation.value++;
	              }
	            }
	          },
	
	          sum: {
	            label: i18nService.get().aggregation.sum,
	            menuTitle: i18nService.get().grouping.aggregate_sum,
	            aggregationFn: function( aggregation, fieldValue, numValue ) {
	              if (!isNaN(numValue)) {
	                if (typeof(aggregation.value) === 'undefined') {
	                  aggregation.value = numValue;
	                } else {
	                  aggregation.value += numValue;
	                }
	              }
	            }
	          },
	
	          min: {
	            label: i18nService.get().aggregation.min,
	            menuTitle: i18nService.get().grouping.aggregate_min,
	            aggregationFn: function( aggregation, fieldValue, numValue ) {
	              if (typeof(aggregation.value) === 'undefined') {
	                aggregation.value = fieldValue;
	              } else {
	                if (typeof(fieldValue) !== 'undefined' && fieldValue !== null && (fieldValue < aggregation.value || aggregation.value === null)) {
	                  aggregation.value = fieldValue;
	                }
	              }
	            }
	          },
	
	          max: {
	            label: i18nService.get().aggregation.max,
	            menuTitle: i18nService.get().grouping.aggregate_max,
	            aggregationFn: function( aggregation, fieldValue, numValue ) {
	              if ( typeof(aggregation.value) === 'undefined' ) {
	                aggregation.value = fieldValue;
	              } else {
	                if ( typeof(fieldValue) !== 'undefined' && fieldValue !== null && (fieldValue > aggregation.value || aggregation.value === null)) {
	                  aggregation.value = fieldValue;
	                }
	              }
	            }
	          },
	
	          avg: {
	            label: i18nService.get().aggregation.avg,
	            menuTitle: i18nService.get().grouping.aggregate_avg,
	            aggregationFn: function( aggregation, fieldValue, numValue ) {
	              if ( typeof(aggregation.count) === 'undefined' ) {
	                aggregation.count = 1;
	              } else {
	                aggregation.count++;
	              }
	
	              if ( isNaN(numValue) ) {
	                return;
	              }
	
	              if ( typeof(aggregation.value) === 'undefined' || typeof(aggregation.sum) === 'undefined' ) {
	                aggregation.value = numValue;
	                aggregation.sum = numValue;
	              } else {
	                aggregation.sum += numValue;
	                aggregation.value = aggregation.sum / aggregation.count;
	              }
	            }
	          }
	        };
	      },
	
	      /**
	       * @ngdoc function
	       * @name finaliseAggregation
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Helper function used to finalize aggregation nodes and footer cells
	       *
	       * @param {gridRow} row The parent we're finalising
	       * @param {aggregation} aggregation The aggregation object manipulated by the aggregationFn
	       */
	      finaliseAggregation: function(row, aggregation) {
	        if ( aggregation.col.treeAggregationUpdateEntity && typeof(row) !== 'undefined' && typeof(row.entity[ '$$' + aggregation.col.uid ]) !== 'undefined' ) {
	          angular.extend( aggregation, row.entity[ '$$' + aggregation.col.uid ]);
	        }
	
	        if ( typeof(aggregation.col.treeAggregationFinalizerFn) === 'function' ) {
	          aggregation.col.treeAggregationFinalizerFn( aggregation );
	        }
	        if ( typeof(aggregation.col.customTreeAggregationFinalizerFn) === 'function' ) {
	          aggregation.col.customTreeAggregationFinalizerFn( aggregation );
	        }
	        if ( typeof(aggregation.rendered) === 'undefined' ) {
	          aggregation.rendered = aggregation.label ? aggregation.label + aggregation.value : aggregation.value;
	        }
	      },
	
	      /**
	       * @ngdoc function
	       * @name finaliseAggregations
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Format the data from the aggregation into the rendered text
	       * e.g. if we had label: 'sum: ' and value: 25, we'd create 'sum: 25'.
	       *
	       * As part of this we call any formatting callback routines we've been provided.
	       *
	       * We write our aggregation out to the row.entity if treeAggregationUpdateEntity is
	       * set on the column - we don't overwrite any information that's already there, we append
	       * to it so that grouping can have set the groupVal beforehand without us overwriting it.
	       *
	       * We need to copy the data from the row.entity first before we finalise the aggregation,
	       * we need that information for the finaliserFn
	       *
	       * @param {gridRow} row the parent we're finalising
	       */
	      finaliseAggregations: function( row ) {
	        if ( row == null || typeof(row.treeNode.aggregations) === 'undefined' ) {
	          return;
	        }
	
	        row.treeNode.aggregations.forEach( function( aggregation ) {
	          service.finaliseAggregation(row, aggregation);
	
	          if ( aggregation.col.treeAggregationUpdateEntity ) {
	            var aggregationCopy = {};
	
	            angular.forEach( aggregation, function( value, key ) {
	              if ( aggregation.hasOwnProperty(key) && key !== 'col' ) {
	                aggregationCopy[key] = value;
	              }
	            });
	
	            row.entity[ '$$' + aggregation.col.uid ] = aggregationCopy;
	          }
	        });
	      },
	
	      /**
	       * @ngdoc function
	       * @name treeFooterAggregationType
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Uses the tree aggregation functions and finalizers to set the
	       * column footer aggregations.
	       *
	       * @param {rows} rows The visible rows. not used, but accepted to match signature of GridColumn.aggregationType
	       * @param {GridColumn} column The column we are finalizing
	       */
	      treeFooterAggregationType: function( rows, column ) {
	        service.finaliseAggregation(undefined, column.treeFooterAggregation);
	        if ( typeof(column.treeFooterAggregation.value) === 'undefined' || column.treeFooterAggregation.rendered === null ) {
	          // The was apparently no aggregation performed (perhaps this is a grouped column
	          return '';
	        }
	        return column.treeFooterAggregation.rendered;
	      }
	    };
	
	    return service;
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.treeBase.directive:uiGridTreeRowHeaderButtons
	   *  @element div
	   *
	   *  @description Provides the expand/collapse button on rows
	   */
	  module.directive('uiGridTreeBaseRowHeaderButtons', ['$templateCache', 'uiGridTreeBaseService',
	  function ($templateCache, uiGridTreeBaseService) {
	    return {
	      replace: true,
	      restrict: 'E',
	      template: $templateCache.get('ui-grid/treeBaseRowHeaderButtons'),
	      scope: true,
	      require: '^uiGrid',
	      link: function($scope, $elm, $attrs, uiGridCtrl) {
	        var self = uiGridCtrl.grid;
	        $scope.treeButtonClass = function(row) {
	          if ( ( self.options.showTreeExpandNoChildren && row.treeLevel > -1 ) || ( row.treeNode.children && row.treeNode.children.length > 0 ) ) {
	            if (row.treeNode.state === 'expanded' ) {
	              return 'ui-grid-icon-minus-squared';
	            }
	            if (row.treeNode.state === 'collapsed' ) {
	              return 'ui-grid-icon-plus-squared';
	            }
	          }
	        };
	        $scope.treeButtonClick = function(row, evt) {
	          evt.stopPropagation();
	          uiGridTreeBaseService.toggleRowTreeState(self, row, evt);
	        };
	        $scope.treeButtonKeyDown = function (row, evt) {
	          if (evt.keyCode === 32 || evt.keyCode === 13) {
	            $scope.treeButtonClick(row, evt);
	          }
	        };
	      }
	    };
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.treeBase.directive:uiGridTreeBaseExpandAllButtons
	   *  @element div
	   *
	   *  @description Provides the expand/collapse all button
	   */
	  module.directive('uiGridTreeBaseExpandAllButtons', ['$templateCache', 'uiGridTreeBaseService',
	  function ($templateCache, uiGridTreeBaseService) {
	    return {
	      replace: true,
	      restrict: 'E',
	      template: $templateCache.get('ui-grid/treeBaseExpandAllButtons'),
	      scope: false,
	      link: function($scope) {
	        var self = $scope.col.grid;
	        $scope.headerButtonClass = function() {
	          if (self.treeBase.numberLevels > 0 && self.treeBase.expandAll) {
	            return 'ui-grid-icon-minus-squared';
	          }
	          if (self.treeBase.numberLevels > 0 && !self.treeBase.expandAll) {
	            return 'ui-grid-icon-plus-squared';
	          }
	        };
	        $scope.headerButtonClick = function(row, evt) {
	          if ( self.treeBase.expandAll ) {
	            uiGridTreeBaseService.collapseAllRows(self, evt);
	          } else {
	            uiGridTreeBaseService.expandAllRows(self, evt);
	          }
	        };
	        $scope.headerButtonKeyDown = function (evt) {
	          if (evt.keyCode === 32 || evt.keyCode === 13) {
	            $scope.headerButtonClick(self, evt);
	          }
	        };
	      }
	    };
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.treeBase.directive:uiGridViewport
	   *  @element div
	   *
	   *  @description Stacks on top of ui.grid.uiGridViewport to set formatting on a tree header row
	   */
	  module.directive('uiGridViewport',
	    function () {
	      return {
	        priority: -200, // run after default  directive
	        scope: false,
	        compile: function ($elm) {
	          var rowRepeatDiv = angular.element($elm.children().children()[0]);
	
	          var existingNgClass = rowRepeatDiv.attr("ng-class");
	          var newNgClass = '';
	          if ( existingNgClass ) {
	            newNgClass = existingNgClass.slice(0, -1) + ",'ui-grid-tree-header-row': row.treeLevel > -1}";
	          } else {
	            newNgClass = "{'ui-grid-tree-header-row': row.treeLevel > -1}";
	          }
	          rowRepeatDiv.attr("ng-class", newNgClass);
	
	          return {
	            pre: function ($scope, $elm, $attrs, controllers) {
	
	            },
	            post: function ($scope, $elm, $attrs, controllers) {
	            }
	          };
	        }
	      };
	    });
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.treeView
	   * @description
	   *
	   * # ui.grid.treeView
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   * This module provides a tree view of the data that it is provided, with nodes in that
	   * tree and leaves.  Unlike grouping, the tree is an inherent property of the data and must
	   * be provided with your data array.
	   *
	   * Design information:
	   * -------------------
	   *
	   * TreeView uses treeBase for the underlying functionality, and is a very thin wrapper around
	   * that logic.  Most of the design information has now moved to treebase.
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.treeView"></div>
	   */
	
	  var module = angular.module('ui.grid.treeView', ['ui.grid', 'ui.grid.treeBase']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.treeView.constant:uiGridTreeViewConstants
	   *
	   *  @description constants available in treeView module, this includes
	   *  all the constants declared in the treeBase module (these are manually copied
	   *  as there isn't an easy way to include constants in another constants file, and
	   *  we don't want to make users include treeBase)
	   *
	   */
	  module.constant('uiGridTreeViewConstants', {
	    featureName: "treeView",
	    rowHeaderColName: 'treeBaseRowHeaderCol',
	    EXPANDED: 'expanded',
	    COLLAPSED: 'collapsed',
	    aggregation: {
	      COUNT: 'count',
	      SUM: 'sum',
	      MAX: 'max',
	      MIN: 'min',
	      AVG: 'avg'
	    }
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.treeView.service:uiGridTreeViewService
	   *
	   *  @description Services for treeView features
	   */
	  module.service('uiGridTreeViewService', ['$q', 'uiGridTreeViewConstants', 'uiGridTreeBaseConstants', 'uiGridTreeBaseService', 'gridUtil', 'GridRow', 'gridClassFactory', 'i18nService', 'uiGridConstants',
	  function ($q, uiGridTreeViewConstants, uiGridTreeBaseConstants, uiGridTreeBaseService, gridUtil, GridRow, gridClassFactory, i18nService, uiGridConstants) {
	
	    var service = {
	
	      initializeGrid: function (grid, $scope) {
	        uiGridTreeBaseService.initializeGrid( grid, $scope );
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeView.grid:treeView
	         *
	         *  @description Grid properties and functions added for treeView
	         */
	        grid.treeView = {};
	
	        grid.registerRowsProcessor(service.adjustSorting, 60);
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeView.api:PublicApi
	         *
	         *  @description Public Api for treeView feature
	         */
	        var publicApi = {
	          events: {
	            treeView: {
	            }
	          },
	          methods: {
	            treeView: {
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	
	        grid.api.registerMethodsFromObject(publicApi.methods);
	
	      },
	
	      defaultGridOptions: function (gridOptions) {
	        // default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeView.api:GridOptions
	         *
	         *  @description GridOptions for treeView feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         *
	         *  Many tree options are set on treeBase, make sure to look at that feature in
	         *  conjunction with these options.
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enableTreeView
	         *  @propertyOf  ui.grid.treeView.api:GridOptions
	         *  @description Enable row tree view for entire grid.
	         *  <br/>Defaults to true
	         */
	        gridOptions.enableTreeView = gridOptions.enableTreeView !== false;
	
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name adjustSorting
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Trees cannot be sorted the same as flat lists of rows -
	       * trees are sorted recursively within each level - so the children of each
	       * node are sorted, but not the full set of rows.
	       *
	       * To achieve this, we suppress the normal sorting by setting ignoreSort on
	       * each of the sort columns.  When the treeBase rowsProcessor runs it will then
	       * unignore these, and will perform a recursive sort against the tree that it builds.
	       *
	       * @param {array} renderableRows the rows that we need to pass on through
	       * @returns {array} renderableRows that we passed on through
	       */
	      adjustSorting: function( renderableRows ) {
	        var grid = this;
	
	        grid.columns.forEach( function( column ) {
	          if ( column.sort ) {
	            column.sort.ignoreSort = true;
	          }
	        });
	
	        return renderableRows;
	      }
	    };
	
	    return service;
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.treeView.directive:uiGridTreeView
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds treeView features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.treeView']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true},
	        {name: 'title', enableCellEdit: true}
	      ];
	
	      $scope.gridOptions = { columnDefs: $scope.columnDefs, data: $scope.data };
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-tree-view></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridTreeView', ['uiGridTreeViewConstants', 'uiGridTreeViewService', '$templateCache',
	  function (uiGridTreeViewConstants, uiGridTreeViewService, $templateCache) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            if (uiGridCtrl.grid.options.enableTreeView !== false) {
	              uiGridTreeViewService.initializeGrid(uiGridCtrl.grid, $scope);
	            }
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.validate
	   * @description
	   *
	   * # ui.grid.validate
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides the ability to validate cells upon change.
	   *
	   * Design information:
	   * -------------------
	   *
	   * Validation is not based on angularjs validation, since it would work only when editing the field.
	   *
	   * Instead it adds custom properties to any field considered as invalid.
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.expandable"></div>
	   */
	  var module = angular.module('ui.grid.validate', ['ui.grid']);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.validate.service:uiGridValidateService
	   *
	   *  @description Services for validation features
	   */
	  module.service('uiGridValidateService', ['$sce', '$q', '$http', 'i18nService', 'uiGridConstants', function ($sce, $q, $http, i18nService, uiGridConstants) {
	
	    var service = {
	
	      /**
	       *  @ngdoc object
	       *  @name validatorFactories
	       *  @propertyOf ui.grid.validate.service:uiGridValidateService
	       *  @description object containing all the factories used to validate data.<br/>
	       *  These factories will be in the form <br/>
	       *  ```
	       *  {
	       *    validatorFactory: function(argument) {
	       *                        return function(newValue, oldValue, rowEntity, colDef) {
	       *                          return true || false || promise
	       *                        }
	       *                      },
	       *    messageFunction: function(argument) {
	       *                       return string
	       *                     }
	       *  }
	       *  ```
	       *
	       * Promises should return true or false as result according to the result of validation.
	       */
	      validatorFactories: {},
	
	      /**
	       * @ngdoc service
	       * @name setExternalFactoryFunction
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Adds a way to retrieve validators from an external service
	       * <p>Validators from this external service have a higher priority than default
	       * ones
	       * @param {function} externalFactoryFunction a function that accepts name and argument to pass to a
	       * validator factory and that returns an object with the same properties as
	       * you can see in {@link ui.grid.validate.service:uiGridValidateService#properties_validatorFactories validatorFactories}
	       */
	      setExternalFactoryFunction: function(externalFactoryFunction) {
	        service.externalFactoryFunction = externalFactoryFunction;
	      },
	
	      /**
	       * @ngdoc service
	       * @name clearExternalFactory
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Removes any link to external factory from this service
	       */
	      clearExternalFactory: function() {
	        delete service.externalFactoryFunction;
	      },
	
	      /**
	       * @ngdoc service
	       * @name getValidatorFromExternalFactory
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Retrieves a validator by executing a validatorFactory
	       * stored in an external service.
	       * @param {string} name the name of the validator to retrieve
	       * @param {object} argument an argument to pass to the validator factory
	       */
	      getValidatorFromExternalFactory: function(name, argument) {
	        return service.externalFactoryFunction(name, argument).validatorFactory(argument);
	      },
	
	      /**
	       * @ngdoc service
	       * @name getMessageFromExternalFactory
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Retrieves a message stored in an external service.
	       * @param {string} name the name of the validator
	       * @param {object} argument an argument to pass to the message function
	       */
	      getMessageFromExternalFactory: function(name, argument) {
	        return service.externalFactoryFunction(name, argument).messageFunction(argument);
	      },
	
	      /**
	       * @ngdoc service
	       * @name setValidator
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description  Adds a new validator to the service
	       * @param {string} name the name of the validator, must be unique
	       * @param {function} validatorFactory a factory that return a validatorFunction
	       * @param {function} messageFunction a function that return the error message
	       */
	      setValidator: function(name, validatorFactory, messageFunction) {
	        service.validatorFactories[name] = {
	          validatorFactory: validatorFactory,
	          messageFunction: messageFunction
	        };
	      },
	
	      /**
	       * @ngdoc service
	       * @name getValidator
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Returns a validator registered to the service
	       * or retrieved from the external factory
	       * @param {string} name the name of the validator to retrieve
	       * @param {object} argument an argument to pass to the validator factory
	       * @returns {object} the validator function
	       */
	      getValidator: function(name, argument) {
	        if (service.externalFactoryFunction) {
	          var validator = service.getValidatorFromExternalFactory(name, argument);
	          if (validator) {
	            return validator;
	          }
	        }
	        if (!service.validatorFactories[name]) {
	          throw ("Invalid validator name: " + name);
	        }
	        return service.validatorFactories[name].validatorFactory(argument);
	      },
	
	      /**
	       * @ngdoc service
	       * @name getMessage
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Returns the error message related to the validator
	       * @param {string} name the name of the validator
	       * @param {object} argument an argument to pass to the message function
	       * @returns {string} the error message related to the validator
	       */
	      getMessage: function(name, argument) {
	        if (service.externalFactoryFunction) {
	          var message = service.getMessageFromExternalFactory(name, argument);
	          if (message) {
	            return message;
	          }
	        }
	        return service.validatorFactories[name].messageFunction(argument);
	      },
	
	      /**
	       * @ngdoc service
	       * @name isInvalid
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Returns true if the cell (identified by rowEntity, colDef) is invalid
	       * @param {object} rowEntity the row entity of the cell
	       * @param {object} colDef the colDef of the cell
	       * @returns {boolean} true if the cell is invalid
	       */
	      isInvalid: function (rowEntity, colDef) {
	        return rowEntity['$$invalid'+colDef.name];
	      },
	
	      /**
	       * @ngdoc service
	       * @name setInvalid
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Makes the cell invalid by adding the proper field to the entity
	       * @param {object} rowEntity the row entity of the cell
	       * @param {object} colDef the colDef of the cell
	       */
	      setInvalid: function (rowEntity, colDef) {
	        rowEntity['$$invalid'+colDef.name] = true;
	      },
	
	      /**
	       * @ngdoc service
	       * @name setValid
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Makes the cell valid by removing the proper error field from the entity
	       * @param {object} rowEntity the row entity of the cell
	       * @param {object} colDef the colDef of the cell
	       */
	      setValid: function (rowEntity, colDef) {
	        delete rowEntity['$$invalid'+colDef.name];
	      },
	
	      /**
	       * @ngdoc service
	       * @name setError
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Adds the proper error to the entity errors field
	       * @param {object} rowEntity the row entity of the cell
	       * @param {object} colDef the colDef of the cell
	       * @param {string} validatorName the name of the validator that is failing
	       */
	      setError: function(rowEntity, colDef, validatorName) {
	        if (!rowEntity['$$errors'+colDef.name]) {
	          rowEntity['$$errors'+colDef.name] = {};
	        }
	        rowEntity['$$errors'+colDef.name][validatorName] = true;
	      },
	
	      /**
	       * @ngdoc service
	       * @name clearError
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Removes the proper error from the entity errors field
	       * @param {object} rowEntity the row entity of the cell
	       * @param {object} colDef the colDef of the cell
	       * @param {string} validatorName the name of the validator that is failing
	       */
	      clearError: function(rowEntity, colDef, validatorName) {
	        if (!rowEntity['$$errors'+colDef.name]) {
	          return;
	        }
	        if (validatorName in rowEntity['$$errors'+colDef.name]) {
	            delete rowEntity['$$errors'+colDef.name][validatorName];
	        }
	      },
	
	      /**
	       * @ngdoc function
	       * @name getErrorMessages
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description returns an array of i18n-ed error messages.
	       * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	       * @param {object} colDef the column whose errors we are looking for
	       * @returns {array} An array of strings containing all the error messages for the cell
	       */
	      getErrorMessages: function(rowEntity, colDef) {
	        var errors = [];
	
	        if (!rowEntity['$$errors'+colDef.name] || Object.keys(rowEntity['$$errors'+colDef.name]).length === 0) {
	          return errors;
	        }
	
	        Object.keys(rowEntity['$$errors'+colDef.name]).sort().forEach(function(validatorName) {
	          errors.push(service.getMessage(validatorName, colDef.validators[validatorName]));
	        });
	
	        return errors;
	      },
	
	      /**
	       * @ngdoc function
	       * @name getFormattedErrors
	       * @methodOf  ui.grid.validate.service:uiGridValidateService
	       * @description returns the error i18n-ed and formatted in html to be shown inside the page.
	       * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	       * @param {object} colDef the column whose errors we are looking for
	       * @returns {object} An object that can be used in a template (like a cellTemplate) to display the
	       * message inside the page (i.e. inside a div)
	       */
	      getFormattedErrors: function(rowEntity, colDef) {
	        var msgString = "",
	          errors = service.getErrorMessages(rowEntity, colDef);
	
	        if (!errors.length) {
	          return;
	        }
	
	        errors.forEach(function(errorMsg) {
	          msgString += errorMsg + "<br/>";
	        });
	
	        return $sce.trustAsHtml('<p><b>' + i18nService.getSafeText('validate.error') + '</b></p>' + msgString );
	      },
	
	      /**
	       * @ngdoc function
	       * @name getTitleFormattedErrors
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description returns the error i18n-ed and formatted in javaScript to be shown inside an html
	       * title attribute.
	       * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	       * @param {object} colDef the column whose errors we are looking for
	       * @returns {object} An object that can be used in a template (like a cellTemplate) to display the
	       * message inside an html title attribute
	       */
	      getTitleFormattedErrors: function(rowEntity, colDef) {
	        var newLine = "\n",
	          msgString = "",
	          errors = service.getErrorMessages(rowEntity, colDef);
	
	        if (!errors.length) {
	          return;
	        }
	
	        errors.forEach(function(errorMsg) {
	          msgString += errorMsg + newLine;
	        });
	
	        return $sce.trustAsHtml(i18nService.getSafeText('validate.error') + newLine + msgString);
	      },
	
	      /**
	       * @ngdoc function
	       * @name getTitleFormattedErrors
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Executes all validators on a cell (identified by row entity and column definition) and sets or clears errors
	       * @param {object} rowEntity the row entity of the cell we want to run the validators on
	       * @param {object} colDef the column definition of the cell we want to run the validators on
	       * @param {object} newValue the value the user just entered
	       * @param {object} oldValue the value the field had before
	       */
	      runValidators: function(rowEntity, colDef, newValue, oldValue, grid) {
	        if (newValue === oldValue) {
	          // If the value has not changed we perform no validation
	          return;
	        }
	
	        if (typeof(colDef.name) === 'undefined' || !colDef.name) {
	          throw new Error('colDef.name is required to perform validation');
	        }
	
	        service.setValid(rowEntity, colDef);
	
	        var validateClosureFactory = function(rowEntity, colDef, validatorName) {
	          return function(value) {
	            if (!value) {
	              service.setInvalid(rowEntity, colDef);
	              service.setError(rowEntity, colDef, validatorName);
	              if (grid) {
	                grid.api.validate.raise.validationFailed(rowEntity, colDef, newValue, oldValue);
	              }
	            }
	          };
	        };
	
	        var promises = [];
	
	        for (var validatorName in colDef.validators) {
	          service.clearError(rowEntity, colDef, validatorName);
	          var validatorFunction = service.getValidator(validatorName, colDef.validators[validatorName]);
	
	          // We pass the arguments as oldValue, newValue so they are in the same order
	          // as ng-model validators (modelValue, viewValue)
	          var promise = $q.when(validatorFunction(oldValue, newValue, rowEntity, colDef))
	            .then(validateClosureFactory(rowEntity, colDef, validatorName));
	
	          promises.push(promise);
	        }
	
	        return $q.all(promises);
	      },
	
	      /**
	       * @ngdoc function
	       * @name createDefaultValidators
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description adds the basic validators to the list of service validators
	       */
	      createDefaultValidators: function() {
	        service.setValidator('minLength', function (argument) {
	          return function (oldValue, newValue) {
	            if (newValue === undefined || newValue === null || newValue === '') {
	              return true;
	            }
	            return newValue.length >= argument;
	          };
	        }, function(argument) {
	          return i18nService.getSafeText('validate.minLength').replace('THRESHOLD', argument);
	        });
	
	        service.setValidator('maxLength', function (argument) {
	          return function (oldValue, newValue) {
	            if (newValue === undefined || newValue === null || newValue === '') {
	              return true;
	            }
	            return newValue.length <= argument;
	          };
	        }, function(threshold) {
	          return i18nService.getSafeText('validate.maxLength').replace('THRESHOLD', threshold);
	        });
	
	        service.setValidator('required', function (argument) {
	          return function (oldValue, newValue) {
	            if (argument) {
	              return !(newValue === undefined || newValue === null || newValue === '');
	            }
	            return true;
	          };
	        }, function() {
	          return i18nService.getSafeText('validate.required');
	        });
	      },
	
	      initializeGrid: function (scope, grid) {
	        grid.validate = {
	
	          isInvalid: service.isInvalid,
	
	          getErrorMessages: service.getErrorMessages,
	
	          getFormattedErrors: service.getFormattedErrors,
	
	          getTitleFormattedErrors: service.getTitleFormattedErrors,
	
	          runValidators: service.runValidators
	        };
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.validate.api:PublicApi
	         *
	         *  @description Public Api for validation feature
	         */
	        var publicApi = {
	          events: {
	            validate: {
	              /**
	               * @ngdoc event
	               * @name validationFailed
	               * @eventOf ui.grid.validate.api:PublicApi
	               * @description raised when one or more failure happened during validation
	               * <pre>
	               *      gridApi.validate.on.validationFailed(scope, function(rowEntity, colDef, newValue, oldValue){...})
	               * </pre>
	               * @param {object} rowEntity the options.data element whose validation failed
	               * @param {object} colDef the column whose validation failed
	               * @param {object} newValue new value
	               * @param {object} oldValue old value
	               */
	              validationFailed: function (rowEntity, colDef, newValue, oldValue) {
	              }
	            }
	          },
	          methods: {
	            validate: {
	              /**
	               * @ngdoc function
	               * @name isInvalid
	               * @methodOf ui.grid.validate.api:PublicApi
	               * @description checks if a cell (identified by rowEntity, colDef) is invalid
	               * @param {object} rowEntity gridOptions.data[] array instance we want to check
	               * @param {object} colDef the column whose errors we want to check
	               * @returns {boolean} true if the cell value is not valid
	               */
	              isInvalid: function(rowEntity, colDef) {
	                return grid.validate.isInvalid(rowEntity, colDef);
	              },
	              /**
	               * @ngdoc function
	               * @name getErrorMessages
	               * @methodOf ui.grid.validate.api:PublicApi
	               * @description returns an array of i18n-ed error messages.
	               * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	               * @param {object} colDef the column whose errors we are looking for
	               * @returns {array} An array of strings containing all the error messages for the cell
	               */
	              getErrorMessages: function (rowEntity, colDef) {
	                return grid.validate.getErrorMessages(rowEntity, colDef);
	              },
	              /**
	               * @ngdoc function
	               * @name getFormattedErrors
	               * @methodOf ui.grid.validate.api:PublicApi
	               * @description returns the error i18n-ed and formatted in html to be shown inside the page.
	               * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	               * @param {object} colDef the column whose errors we are looking for
	               * @returns {object} An object that can be used in a template (like a cellTemplate) to display the
	               * message inside the page (i.e. inside a div)
	               */
	              getFormattedErrors: function (rowEntity, colDef) {
	                return grid.validate.getFormattedErrors(rowEntity, colDef);
	              },
	              /**
	               * @ngdoc function
	               * @name getTitleFormattedErrors
	               * @methodOf ui.grid.validate.api:PublicApi
	               * @description returns the error i18n-ed and formatted in javaScript to be shown inside an html
	               * title attribute.
	               * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	               * @param {object} colDef the column whose errors we are looking for
	               * @returns {object} An object that can be used in a template (like a cellTemplate) to display the
	               * message inside an html title attribute
	               */
	              getTitleFormattedErrors: function (rowEntity, colDef) {
	                return grid.validate.getTitleFormattedErrors(rowEntity, colDef);
	              }
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	
	        if (grid.edit) {
	          grid.api.edit.on.afterCellEdit(scope, function(rowEntity, colDef, newValue, oldValue) {
	            grid.validate.runValidators(rowEntity, colDef, newValue, oldValue, grid);
	          });
	        }
	
	        service.createDefaultValidators();
	      }
	    };
	
	    return service;
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.validate.directive:uiGridValidate
	   *  @element div
	   *  @restrict A
	   *  @description Adds validating features to the ui-grid directive.
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.edit', 'ui.grid.validate']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true, validators: {minLength: 3, maxLength: 9}, cellTemplate: 'ui-grid/cellTitleValidator'},
	        {name: 'title', enableCellEdit: true, validators: {required: true}, cellTemplate: 'ui-grid/cellTitleValidator'}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-edit ui-grid-validate></div>
	   </div>
	   </file>
	   </example>
	   */
	
	  module.directive('uiGridValidate', ['gridUtil', 'uiGridValidateService', function (gridUtil, uiGridValidateService) {
	    return {
	      priority: 0,
	      replace: true,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridValidateService.initializeGrid($scope, uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	angular.module('ui.grid').run(['$templateCache', function($templateCache) {
	  'use strict';
	
	  $templateCache.put('ui-grid/ui-grid-filter',
	    "<div class=\"ui-grid-filter-container\" ng-style=\"col.extraStyle\" ng-repeat=\"colFilter in col.filters\" ng-class=\"{'ui-grid-filter-cancel-button-hidden' : colFilter.disableCancelFilterButton === true }\"><div ng-if=\"colFilter.type !== 'select'\"><input type=\"text\" class=\"ui-grid-filter-input ui-grid-filter-input-{{$index}}\" ng-model=\"colFilter.term\" ng-attr-placeholder=\"{{colFilter.placeholder || ''}}\" aria-label=\"{{colFilter.ariaLabel || aria.defaultFilterLabel}}\"><div role=\"button\" class=\"ui-grid-filter-button\" ng-click=\"removeFilter(colFilter, $index)\" ng-if=\"!colFilter.disableCancelFilterButton\" ng-disabled=\"colFilter.term === undefined || colFilter.term === null || colFilter.term === ''\" ng-show=\"colFilter.term !== undefined && colFilter.term !== null && colFilter.term !== ''\"><i class=\"ui-grid-icon-cancel\" ui-grid-one-bind-aria-label=\"aria.removeFilter\">&nbsp;</i></div></div><div ng-if=\"colFilter.type === 'select'\"><select class=\"ui-grid-filter-select ui-grid-filter-input-{{$index}}\" ng-model=\"colFilter.term\" ng-show=\"colFilter.selectOptions.length > 0\" ng-attr-placeholder=\"{{colFilter.placeholder || aria.defaultFilterLabel}}\" aria-label=\"{{colFilter.ariaLabel || ''}}\" ng-options=\"option.value as option.label for option in colFilter.selectOptions\"><option value=\"\"></option></select><div role=\"button\" class=\"ui-grid-filter-button-select\" ng-click=\"removeFilter(colFilter, $index)\" ng-if=\"!colFilter.disableCancelFilterButton\" ng-disabled=\"colFilter.term === undefined || colFilter.term === null || colFilter.term === ''\" ng-show=\"colFilter.term !== undefined && colFilter.term != null\"><i class=\"ui-grid-icon-cancel\" ui-grid-one-bind-aria-label=\"aria.removeFilter\">&nbsp;</i></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-footer',
	    "<div class=\"ui-grid-footer-panel ui-grid-footer-aggregates-row\"><!-- tfooter --><div class=\"ui-grid-footer ui-grid-footer-viewport\"><div class=\"ui-grid-footer-canvas\"><div class=\"ui-grid-footer-cell-wrapper\" ng-style=\"colContainer.headerCellWrapperStyle()\"><div role=\"row\" class=\"ui-grid-footer-cell-row\"><div ui-grid-footer-cell role=\"gridcell\" ng-repeat=\"col in colContainer.renderedColumns track by col.uid\" col=\"col\" render-index=\"$index\" class=\"ui-grid-footer-cell ui-grid-clearfix\"></div></div></div></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-grid-footer',
	    "<div class=\"ui-grid-footer-info ui-grid-grid-footer\"><span>{{'search.totalItems' | t}} {{grid.rows.length}}</span> <span ng-if=\"grid.renderContainers.body.visibleRowCache.length !== grid.rows.length\" class=\"ngLabel\">({{\"search.showingItems\" | t}} {{grid.renderContainers.body.visibleRowCache.length}})</span></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-header',
	    "<div role=\"rowgroup\" class=\"ui-grid-header\"><!-- theader --><div class=\"ui-grid-top-panel\"><div class=\"ui-grid-header-viewport\"><div class=\"ui-grid-header-canvas\"><div class=\"ui-grid-header-cell-wrapper\" ng-style=\"colContainer.headerCellWrapperStyle()\"><div role=\"row\" class=\"ui-grid-header-cell-row\"><div role=\"columnheader\" class=\"ui-grid-header-cell ui-grid-clearfix\" ng-repeat=\"col in colContainer.renderedColumns track by col.uid\" ui-grid-header-cell col=\"col\" render-index=\"$index\"></div></div></div></div></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-menu-button',
	    "<div class=\"ui-grid-menu-button\"><div role=\"button\" ui-grid-one-bind-id-grid=\"'grid-menu'\" ui-grid-one-bind-aria-label=\"i18n.aria.buttonLabel\" tabindex=\"0\" class=\"ui-grid-icon-container\" ng-click=\"toggleMenu()\" ng-keydown=\"toggleOnKeydown($event)\" aria-expanded=\"{{shown}}\" aria-haspopup=\"true\"><i class=\"ui-grid-icon-menu\" ui-grid-one-bind-aria-label=\"i18n.aria.buttonLabel\">&nbsp;</i></div><div ui-grid-menu menu-items=\"menuItems\"></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-menu-header-item',
	    "<li role=\"menuitem\"><div class=\"ui-grid-menu-item\" role=\"heading\" aria-level=\"2\" ng-show=\"itemShown()\"><i aria-hidden=\"true\">&nbsp; </i><span ng-bind=\"label()\"></span></div></li>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-no-header',
	    "<div class=\"ui-grid-top-panel\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-row',
	    "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'ui-grid-row-header-cell': col.isRowHeader }\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid',
	    "<div ui-i18n=\"en\" class=\"ui-grid\"><!-- TODO (c0bra): add \"scoped\" attr here, eventually? --><style ui-grid-style>.grid{{ grid.id }} {\n" +
	    "      /* Styles for the grid */\n" +
	    "    }\n" +
	    "\n" +
	    "    .grid{{ grid.id }} .ui-grid-row, .grid{{ grid.id }} .ui-grid-cell, .grid{{ grid.id }} .ui-grid-cell .ui-grid-vertical-bar {\n" +
	    "      height: {{ grid.options.rowHeight }}px;\n" +
	    "    }\n" +
	    "\n" +
	    "    .grid{{ grid.id }} .ui-grid-row:last-child .ui-grid-cell {\n" +
	    "      border-bottom-width: {{ (((grid.getVisibleRowCount() * grid.options.rowHeight) < grid.getViewportHeight()) && '1') || '0' }}px;\n" +
	    "    }\n" +
	    "\n" +
	    "    {{ grid.verticalScrollbarStyles }}\n" +
	    "    {{ grid.horizontalScrollbarStyles }}\n" +
	    "\n" +
	    "    /*\n" +
	    "    .ui-grid[dir=rtl] .ui-grid-viewport {\n" +
	    "      padding-left: {{ grid.verticalScrollbarWidth }}px;\n" +
	    "    }\n" +
	    "    */\n" +
	    "\n" +
	    "    {{ grid.customStyles }}</style><div class=\"ui-grid-contents-wrapper\" role=\"grid\"><div ui-grid-menu-button ng-if=\"grid.options.enableGridMenu\"></div><div ng-if=\"grid.hasLeftContainer()\" style=\"width: 0\" ui-grid-pinned-container=\"'left'\"></div><div ui-grid-render-container container-id=\"'body'\" col-container-name=\"'body'\" row-container-name=\"'body'\" bind-scroll-horizontal=\"true\" bind-scroll-vertical=\"true\" enable-horizontal-scrollbar=\"grid.options.enableHorizontalScrollbar\" enable-vertical-scrollbar=\"grid.options.enableVerticalScrollbar\"></div><div ng-if=\"grid.hasRightContainer()\" style=\"width: 0\" ui-grid-pinned-container=\"'right'\"></div><div ui-grid-grid-footer ng-if=\"grid.options.showGridFooter\"></div><div ui-grid-column-menu ng-if=\"grid.options.enableColumnMenus\"></div><div ng-transclude></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridCell',
	    "<div class=\"ui-grid-cell-contents\" title=\"TOOLTIP\">{{COL_FIELD CUSTOM_FILTERS}}</div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridColumnMenu',
	    "<div class=\"ui-grid-column-menu\"><div ui-grid-menu menu-items=\"menuItems\" col=\"col\"><!-- <div class=\"ui-grid-column-menu\">\n" +
	    "    <div class=\"inner\" ng-show=\"menuShown\">\n" +
	    "      <ul>\n" +
	    "        <div ng-show=\"grid.options.enableSorting\">\n" +
	    "          <li ng-click=\"sortColumn($event, asc)\" ng-class=\"{ 'selected' : col.sort.direction == asc }\"><i class=\"ui-grid-icon-sort-alt-up\"></i> Sort Ascending</li>\n" +
	    "          <li ng-click=\"sortColumn($event, desc)\" ng-class=\"{ 'selected' : col.sort.direction == desc }\"><i class=\"ui-grid-icon-sort-alt-down\"></i> Sort Descending</li>\n" +
	    "          <li ng-show=\"col.sort.direction\" ng-click=\"unsortColumn()\"><i class=\"ui-grid-icon-cancel\"></i> Remove Sort</li>\n" +
	    "        </div>\n" +
	    "      </ul>\n" +
	    "    </div>\n" +
	    "  </div> --></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridFooterCell',
	    "<div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\"><div>{{ col.getAggregationText() + ( col.getAggregationValue() CUSTOM_FILTERS ) }}</div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridHeaderCell',
	    "<div role=\"columnheader\" ng-class=\"{ 'sortable': sortable, 'ui-grid-header-cell-last-col': isLastCol }\" ui-grid-one-bind-aria-labelledby-grid=\"col.uid + '-header-text ' + col.uid + '-sortdir-text'\" aria-sort=\"{{col.sort.direction == asc ? 'ascending' : ( col.sort.direction == desc ? 'descending' : (!col.sort.direction ? 'none' : 'other'))}}\"><div role=\"button\" tabindex=\"0\" ng-keydown=\"handleKeyDown($event)\" class=\"ui-grid-cell-contents ui-grid-header-cell-primary-focus\" col-index=\"renderIndex\" title=\"TOOLTIP\"><span class=\"ui-grid-header-cell-label\" ui-grid-one-bind-id-grid=\"col.uid + '-header-text'\">{{ col.displayName CUSTOM_FILTERS }}</span> <span ui-grid-one-bind-id-grid=\"col.uid + '-sortdir-text'\" ui-grid-visible=\"col.sort.direction\" aria-label=\"{{getSortDirectionAriaLabel()}}\"><i ng-class=\"{ 'ui-grid-icon-up-dir': col.sort.direction == asc, 'ui-grid-icon-down-dir': col.sort.direction == desc, 'ui-grid-icon-blank': !col.sort.direction }\" title=\"{{isSortPriorityVisible() ? i18n.headerCell.priority + ' ' + ( col.sort.priority + 1 )  : null}}\" aria-hidden=\"true\"></i> <sub ui-grid-visible=\"isSortPriorityVisible()\" class=\"ui-grid-sort-priority-number\">{{col.sort.priority + 1}}</sub></span></div><div role=\"button\" tabindex=\"0\" ui-grid-one-bind-id-grid=\"col.uid + '-menu-button'\" class=\"ui-grid-column-menu-button\" ng-if=\"grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false\" ng-click=\"toggleMenu($event)\" ng-keydown=\"headerCellArrowKeyDown($event)\" ui-grid-one-bind-aria-label=\"i18n.headerCell.aria.columnMenuButtonLabel\" aria-expanded=\"{{col.menuShown}}\" aria-haspopup=\"true\"><i class=\"ui-grid-icon-angle-down\" aria-hidden=\"true\">&nbsp;</i></div><div ui-grid-filter ng-hide=\"col.filterContainer === 'columnMenu'\"></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridMenu',
	    "<div class=\"ui-grid-menu\" ng-keydown=\"checkKeyDown($event)\" ng-show=\"shown\"><style ui-grid-style>{{dynamicStyles}}</style><div class=\"ui-grid-menu-mid\" ng-show=\"shownMid\"><div class=\"ui-grid-menu-inner\" ng-if=\"shown\"><ul role=\"menu\" class=\"ui-grid-menu-items\"><li ng-repeat=\"item in menuItems\" role=\"menuitem\" ui-grid-menu-item ui-grid-one-bind-id=\"'menuitem-'+$index\" action=\"item.action\" name=\"item.title\" active=\"item.active\" icon=\"item.icon\" shown=\"item.shown\" context=\"item.context\" template-url=\"item.templateUrl\" leave-open=\"item.leaveOpen\" screen-reader-only=\"item.screenReaderOnly\"></li><li ng-if=\"col.filterable && col.filterContainer === 'columnMenu'\"><div ui-grid-filter></div></li></ul></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridMenuItem',
	    "<button type=\"button\" class=\"ui-grid-menu-item\" ng-click=\"itemAction($event, title)\" ng-show=\"itemShown()\" ng-class=\"{ 'ui-grid-menu-item-active': active(), 'ui-grid-sr-only': (!focus && screenReaderOnly) }\" aria-pressed=\"{{active()}}\" tabindex=\"0\" ng-focus=\"focus=true\" ng-blur=\"focus=false\"><i ng-class=\"icon\" aria-hidden=\"true\">&nbsp; </i>{{ label() }}</button>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridRenderContainer',
	    "<div role=\"presentation\" ui-grid-one-bind-id-grid=\"containerId + '-grid-container'\" class=\"ui-grid-render-container\" ng-style=\"{ 'margin-left': colContainer.getMargin('left') + 'px', 'margin-right': colContainer.getMargin('right') + 'px' }\"><!-- All of these dom elements are replaced in place --><div ui-grid-header></div><div ui-grid-viewport></div><div ng-if=\"colContainer.needsHScrollbarPlaceholder()\" class=\"ui-grid-scrollbar-placeholder\" ng-style=\"{height: colContainer.grid.scrollbarHeight + 'px'}\"></div><ui-grid-footer ng-if=\"grid.options.showColumnFooter\"></ui-grid-footer></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridViewport',
	    "<div role=\"rowgroup\" class=\"ui-grid-viewport\" ng-style=\"colContainer.getViewportStyle()\"><!-- tbody --><div class=\"ui-grid-canvas\"><div ng-repeat=\"(rowRenderIndex, row) in rowContainer.renderedRows track by $index\" class=\"ui-grid-row\" ng-style=\"Viewport.rowStyle(rowRenderIndex)\"><div role=\"row\" ui-grid-row=\"row\" row-render-index=\"rowRenderIndex\"></div></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/cellEditor',
	    "<div><form name=\"inputForm\"><input type=\"INPUT_TYPE\" ng-class=\"'colt' + col.uid\" ui-grid-editor ng-model=\"MODEL_COL_FIELD\"></form></div>"
	  );
	
	
	  $templateCache.put('ui-grid/dropdownEditor',
	    "<div><form name=\"inputForm\"><select ng-class=\"'colt' + col.uid\" ui-grid-edit-dropdown ng-model=\"MODEL_COL_FIELD\" ng-options=\"field[editDropdownIdLabel] as field[editDropdownValueLabel] CUSTOM_FILTERS for field in editDropdownOptionsArray\"></select></form></div>"
	  );
	
	
	  $templateCache.put('ui-grid/fileChooserEditor',
	    "<div><form name=\"inputForm\"><input ng-class=\"'colt' + col.uid\" ui-grid-edit-file-chooser type=\"file\" id=\"files\" name=\"files[]\" ng-model=\"MODEL_COL_FIELD\"></form></div>"
	  );
	
	
	  $templateCache.put('ui-grid/emptyBaseLayerContainer',
	    "<div class=\"ui-grid-empty-base-layer-container ui-grid-canvas\"><div class=\"ui-grid-row\" ng-repeat=\"(rowRenderIndex, row) in grid.baseLayer.emptyRows track by $index\" ng-style=\"Viewport.rowStyle(rowRenderIndex)\"><div><div><div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name\" class=\"ui-grid-cell {{ col.getColClass(false) }}\"></div></div></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/expandableRow',
	    "<div ui-grid-expandable-row ng-if=\"expandableRow.shouldRenderExpand()\" class=\"expandableRow\" style=\"float:left; margin-top: 1px; margin-bottom: 1px\" ng-style=\"{width: (grid.renderContainers.body.getCanvasWidth()) + 'px', height: row.expandedRowHeight + 'px'}\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/expandableRowHeader',
	    "<div class=\"ui-grid-row-header-cell ui-grid-expandable-buttons-cell\"><div class=\"ui-grid-cell-contents\"><i class=\"clickable\" ng-if=\"!(row.groupHeader==true || row.entity.subGridOptions.disableRowExpandable)\" ng-class=\"{ 'ui-grid-icon-plus-squared' : !row.isExpanded, 'ui-grid-icon-minus-squared' : row.isExpanded }\" ng-click=\"grid.api.expandable.toggleRowExpansion(row.entity, $event)\" aria-expanded=\"{{!!row.isExpanded}}\"></i></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/expandableScrollFiller',
	    "<div ng-if=\"expandableRow.shouldRenderFiller()\" ng-class=\"{scrollFiller: true, scrollFillerClass:(colContainer.name === 'body')}\" ng-style=\"{ width: (grid.getViewportWidth()) + 'px', height: row.expandedRowHeight + 2 + 'px', 'margin-left': grid.options.rowHeader.rowHeaderWidth + 'px' }\">&nbsp;</div>"
	  );
	
	
	  $templateCache.put('ui-grid/expandableTopRowHeader',
	    "<div class=\"ui-grid-row-header-cell ui-grid-expandable-buttons-cell\"><div class=\"ui-grid-cell-contents\"><span class=\"ui-grid-cell-empty\" ng-if=\"!grid.options.showExpandAllButton\"></span> <button type=\"button\" class=\"ui-grid-icon-button clickable\" ng-if=\"grid.options.showExpandAllButton\" ng-class=\"{ 'ui-grid-icon-plus-squared' : !grid.expandable.expandedAll, 'ui-grid-icon-minus-squared' : grid.expandable.expandedAll }\" ng-click=\"grid.api.expandable.toggleAllRows()\" aria-expanded=\"{{grid.expandable.expandedAll}}\"></button></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/csvLink',
	    "<span class=\"ui-grid-exporter-csv-link-span\"><a href=\"data:text/csv;charset=UTF-8,CSV_CONTENT\" download=\"FILE_NAME\">LINK_LABEL</a></span>"
	  );
	
	
	  $templateCache.put('ui-grid/importerMenuItem',
	    "<li class=\"ui-grid-menu-item\"><form><input class=\"ui-grid-importer-file-chooser\" type=\"file\" id=\"files\" name=\"files[]\"></form></li>"
	  );
	
	
	  $templateCache.put('ui-grid/importerMenuItemContainer',
	    "<div ui-grid-importer-menu-item></div>"
	  );
	
	
	  $templateCache.put('ui-grid/pagination',
	    "<div class=\"ui-grid-pager-panel\" ui-grid-pager ng-show=\"grid.options.enablePaginationControls\"><div role=\"navigation\" class=\"ui-grid-pager-container\"><div class=\"ui-grid-pager-control\"><button type=\"button\" class=\"ui-grid-pager-first\" ui-grid-one-bind-title=\"aria.pageToFirst\" ui-grid-one-bind-aria-label=\"aria.pageToFirst\" ng-click=\"pageFirstPageClick()\" ng-disabled=\"cantPageBackward()\"><div ng-class=\"grid.isRTL() ? 'last-triangle' : 'first-triangle'\"><div ng-class=\"grid.isRTL() ? 'last-bar-rtl' : 'first-bar'\"></div></div></button> <button type=\"button\" class=\"ui-grid-pager-previous\" ui-grid-one-bind-title=\"aria.pageBack\" ui-grid-one-bind-aria-label=\"aria.pageBack\" ng-click=\"pagePreviousPageClick()\" ng-disabled=\"cantPageBackward()\"><div ng-class=\"grid.isRTL() ? 'last-triangle prev-triangle' : 'first-triangle prev-triangle'\"></div></button> <input type=\"number\" ui-grid-one-bind-title=\"aria.pageSelected\" ui-grid-one-bind-aria-label=\"aria.pageSelected\" class=\"ui-grid-pager-control-input\" ng-model=\"grid.options.paginationCurrentPage\" min=\"1\" max=\"{{ paginationApi.getTotalPages() }}\" step=\"1\" required> <span class=\"ui-grid-pager-max-pages-number\" ng-show=\"paginationApi.getTotalPages() > 0\"><abbr ui-grid-one-bind-title=\"paginationOf\">/ </abbr>{{ paginationApi.getTotalPages() }} </span><button type=\"button\" class=\"ui-grid-pager-next\" ui-grid-one-bind-title=\"aria.pageForward\" ui-grid-one-bind-aria-label=\"aria.pageForward\" ng-click=\"pageNextPageClick()\" ng-disabled=\"cantPageForward()\"><div ng-class=\"grid.isRTL() ? 'first-triangle next-triangle' : 'last-triangle next-triangle'\"></div></button> <button type=\"button\" class=\"ui-grid-pager-last\" ui-grid-one-bind-title=\"aria.pageToLast\" ui-grid-one-bind-aria-label=\"aria.pageToLast\" ng-click=\"pageLastPageClick()\" ng-disabled=\"cantPageToLast()\"><div ng-class=\"grid.isRTL() ? 'first-triangle' : 'last-triangle'\"><div ng-class=\"grid.isRTL() ? 'first-bar-rtl' : 'last-bar'\"></div></div></button></div><div class=\"ui-grid-pager-row-count-picker\" ng-if=\"grid.options.paginationPageSizes.length > 1 && !grid.options.useCustomPagination\"><select ui-grid-one-bind-aria-labelledby-grid=\"'items-per-page-label'\" ng-model=\"grid.options.paginationPageSize\" ng-options=\"o as o for o in grid.options.paginationPageSizes\"></select> <span ui-grid-one-bind-id-grid=\"'items-per-page-label'\" class=\"ui-grid-pager-row-count-label\">&nbsp;{{sizesLabel}}</span></div><span ng-if=\"grid.options.paginationPageSizes.length <= 1\" class=\"ui-grid-pager-row-count-label\">{{grid.options.paginationPageSize}}&nbsp;{{sizesLabel}}</span></div><div class=\"ui-grid-pager-count-container\"><div class=\"ui-grid-pager-count\"><span ng-show=\"grid.options.totalItems > 0\">{{ 1 + paginationApi.getFirstRowIndex() }} <abbr ui-grid-one-bind-title=\"paginationThrough\">- </abbr>{{ 1 + paginationApi.getLastRowIndex() }} {{paginationOf}} {{grid.options.totalItems}} {{totalItemsLabel}}</span></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/columnResizer',
	    "<div ui-grid-column-resizer ng-if=\"grid.options.enableColumnResizing\" class=\"ui-grid-column-resizer\" col=\"col\" position=\"right\" render-index=\"renderIndex\" unselectable=\"on\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/gridFooterSelectedItems',
	    "<span ng-if=\"grid.selection.selectedCount !== 0 && grid.options.enableFooterTotalSelected\">({{\"search.selectedItems\" | t}} {{grid.selection.selectedCount}})</span>"
	  );
	
	
	  $templateCache.put('ui-grid/selectionHeaderCell',
	    "<div><!-- <div class=\"ui-grid-vertical-bar\">&nbsp;</div> --><div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\"><ui-grid-selection-select-all-buttons ng-if=\"grid.options.enableSelectAll\" role=\"checkbox\" ng-model=\"grid.selection.selectAll\"></ui-grid-selection-select-all-buttons></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/selectionRowHeader',
	    "<div class=\"ui-grid-cell-contents ui-grid-disable-selection clickable\"><ui-grid-selection-row-header-buttons></ui-grid-selection-row-header-buttons></div>"
	  );
	
	
	  $templateCache.put('ui-grid/selectionRowHeaderButtons',
	    "<div class=\"ui-grid-selection-row-header-buttons ui-grid-icon-ok clickable\" ng-class=\"{'ui-grid-row-selected': row.isSelected}\" tabindex=\"0\" ng-click=\"selectButtonClick(row, $event)\" ng-keydown=\"selectButtonKeyDown(row, $event)\" ng-attr-aria-label=\"{{('selection.aria.row' | t) + ' ' + (row.index + 1) + ', ' + col.displayName}}\" aria-checked=\"{{row.isSelected}}\" role=\"checkbox\" ng-model=\"row.isSelected\">&nbsp;</div>"
	  );
	
	
	  $templateCache.put('ui-grid/selectionSelectAllButtons',
	    "<div role=\"checkbox\" tabindex=\"0\" class=\"ui-grid-selection-row-header-buttons ui-grid-icon-ok\" ui-grid-one-bind-aria-label=\"'selection.selectAll' | t\" aria-checked=\"{{grid.selection.selectAll}}\" ng-class=\"{'ui-grid-all-selected': grid.selection.selectAll}\" ng-click=\"headerButtonClick($event)\" ng-keydown=\"headerButtonKeyDown($event)\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/treeBaseExpandAllButtons',
	    "<div class=\"ui-grid-tree-base-row-header-buttons\" tabindex=\"0\" ng-class=\"headerButtonClass()\" ng-click=\"headerButtonClick($event)\" ng-keydown=\"headerButtonKeyDown($event)\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/treeBaseHeaderCell',
	    "<div><div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\"><ui-grid-tree-base-expand-all-buttons ng-if=\"grid.options.enableExpandAll\"></ui-grid-tree-base-expand-all-buttons></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/treeBaseRowHeader',
	    "<div class=\"ui-grid-cell-contents\"><ui-grid-tree-base-row-header-buttons></ui-grid-tree-base-row-header-buttons></div>"
	  );
	
	
	  $templateCache.put('ui-grid/treeBaseRowHeaderButtons',
	    "<div class=\"ui-grid-tree-base-row-header-buttons\" ng-class=\"{'ui-grid-tree-base-header': row.treeLevel > -1 }\" tabindex=\"0\" ng-keydown=\"treeButtonKeyDown(row, $event)\" ng-click=\"treeButtonClick(row, $event)\"><i ng-class=\"treeButtonClass(row)\" ng-style=\"{'padding-left': grid.options.treeIndent * row.treeLevel + 'px'}\"></i> &nbsp;</div>"
	  );
	
	
	  $templateCache.put('ui-grid/cellTitleValidator',
	    "<div class=\"ui-grid-cell-contents\" ng-class=\"{invalid:grid.validate.isInvalid(row.entity,col.colDef)}\" title=\"{{grid.validate.getTitleFormattedErrors(row.entity,col.colDef)}}\">{{COL_FIELD CUSTOM_FILTERS}}</div>"
	  );
	
	
	  $templateCache.put('ui-grid/cellTooltipValidator',
	    "<div class=\"ui-grid-cell-contents\" ng-class=\"{invalid:grid.validate.isInvalid(row.entity,col.colDef)}\" tooltip-html-unsafe=\"{{grid.validate.getFormattedErrors(row.entity,col.colDef)}}\" tooltip-enable=\"grid.validate.isInvalid(row.entity,col.colDef)\" tooltip-append-to-body=\"true\" tooltip-placement=\"top\" title=\"TOOLTIP\">{{COL_FIELD CUSTOM_FILTERS}}</div>"
	  );
	
	}]);


/***/ },

/***/ 147:
/***/ function(module, exports) {

	/**
	 * dirPagination - AngularJS module for paginating (almost) anything.
	 *
	 *
	 * Credits
	 * =======
	 *
	 * Daniel Tabuenca: https://groups.google.com/d/msg/angular/an9QpzqIYiM/r8v-3W1X5vcJ
	 * for the idea on how to dynamically invoke the ng-repeat directive.
	 *
	 * I borrowed a couple of lines and a few attribute names from the AngularUI Bootstrap project:
	 * https://github.com/angular-ui/bootstrap/blob/master/src/pagination/pagination.js
	 *
	 * Copyright 2014 Michael Bromley <michael@michaelbromley.co.uk>
	 */
	
	(function() {
	
	    /**
	     * Config
	     */
	    var moduleName = 'angularUtils.directives.dirPagination';
	    var DEFAULT_ID = '__default';
	
	    /**
	     * Module
	     */
	    angular.module(moduleName, [])
	        .directive('dirPaginate', ['$compile', '$parse', 'paginationService', dirPaginateDirective])
	        .directive('dirPaginateNoCompile', noCompileDirective)
	        .directive('dirPaginationControls', ['paginationService', 'paginationTemplate', dirPaginationControlsDirective])
	        .filter('itemsPerPage', ['paginationService', itemsPerPageFilter])
	        .service('paginationService', paginationService)
	        .provider('paginationTemplate', paginationTemplateProvider)
	        .run(['$templateCache',dirPaginationControlsTemplateInstaller]);
	
	    function dirPaginateDirective($compile, $parse, paginationService) {
	
	        return  {
	            terminal: true,
	            multiElement: true,
	            priority: 100,
	            compile: dirPaginationCompileFn
	        };
	
	        function dirPaginationCompileFn(tElement, tAttrs){
	
	            var expression = tAttrs.dirPaginate;
	            // regex taken directly from https://github.com/angular/angular.js/blob/v1.4.x/src/ng/directive/ngRepeat.js#L339
	            var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	            var filterPattern = /\|\s*itemsPerPage\s*:\s*(.*\(\s*\w*\)|([^\)]*?(?=\s+as\s+))|[^\)]*)/;
	            if (match[2].match(filterPattern) === null) {
	                throw 'pagination directive: the \'itemsPerPage\' filter must be set.';
	            }
	            var itemsPerPageFilterRemoved = match[2].replace(filterPattern, '');
	            var collectionGetter = $parse(itemsPerPageFilterRemoved);
	
	            addNoCompileAttributes(tElement);
	
	            // If any value is specified for paginationId, we register the un-evaluated expression at this stage for the benefit of any
	            // dir-pagination-controls directives that may be looking for this ID.
	            var rawId = tAttrs.paginationId || DEFAULT_ID;
	            paginationService.registerInstance(rawId);
	
	            return function dirPaginationLinkFn(scope, element, attrs){
	
	                // Now that we have access to the `scope` we can interpolate any expression given in the paginationId attribute and
	                // potentially register a new ID if it evaluates to a different value than the rawId.
	                var paginationId = $parse(attrs.paginationId)(scope) || attrs.paginationId || DEFAULT_ID;
	                
	                // (TODO: this seems sound, but I'm reverting as many bug reports followed it's introduction in 0.11.0.
	                // Needs more investigation.)
	                // In case rawId != paginationId we deregister using rawId for the sake of general cleanliness
	                // before registering using paginationId
	                // paginationService.deregisterInstance(rawId);
	                paginationService.registerInstance(paginationId);
	
	                var repeatExpression = getRepeatExpression(expression, paginationId);
	                addNgRepeatToElement(element, attrs, repeatExpression);
	
	                removeTemporaryAttributes(element);
	                var compiled =  $compile(element);
	
	                var currentPageGetter = makeCurrentPageGetterFn(scope, attrs, paginationId);
	                paginationService.setCurrentPageParser(paginationId, currentPageGetter, scope);
	
	                if (typeof attrs.totalItems !== 'undefined') {
	                    paginationService.setAsyncModeTrue(paginationId);
	                    scope.$watch(function() {
	                        return $parse(attrs.totalItems)(scope);
	                    }, function (result) {
	                        if (0 <= result) {
	                            paginationService.setCollectionLength(paginationId, result);
	                        }
	                    });
	                } else {
	                    paginationService.setAsyncModeFalse(paginationId);
	                    scope.$watchCollection(function() {
	                        return collectionGetter(scope);
	                    }, function(collection) {
	                        if (collection) {
	                            var collectionLength = (collection instanceof Array) ? collection.length : Object.keys(collection).length;
	                            paginationService.setCollectionLength(paginationId, collectionLength);
	                        }
	                    });
	                }
	
	                // Delegate to the link function returned by the new compilation of the ng-repeat
	                compiled(scope);
	                 
	                // (TODO: Reverting this due to many bug reports in v 0.11.0. Needs investigation as the
	                // principle is sound)
	                // When the scope is destroyed, we make sure to remove the reference to it in paginationService
	                // so that it can be properly garbage collected
	                // scope.$on('$destroy', function destroyDirPagination() {
	                //     paginationService.deregisterInstance(paginationId);
	                // });
	            };
	        }
	
	        /**
	         * If a pagination id has been specified, we need to check that it is present as the second argument passed to
	         * the itemsPerPage filter. If it is not there, we add it and return the modified expression.
	         *
	         * @param expression
	         * @param paginationId
	         * @returns {*}
	         */
	        function getRepeatExpression(expression, paginationId) {
	            var repeatExpression,
	                idDefinedInFilter = !!expression.match(/(\|\s*itemsPerPage\s*:[^|]*:[^|]*)/);
	
	            if (paginationId !== DEFAULT_ID && !idDefinedInFilter) {
	                repeatExpression = expression.replace(/(\|\s*itemsPerPage\s*:\s*[^|\s]*)/, "$1 : '" + paginationId + "'");
	            } else {
	                repeatExpression = expression;
	            }
	
	            return repeatExpression;
	        }
	
	        /**
	         * Adds the ng-repeat directive to the element. In the case of multi-element (-start, -end) it adds the
	         * appropriate multi-element ng-repeat to the first and last element in the range.
	         * @param element
	         * @param attrs
	         * @param repeatExpression
	         */
	        function addNgRepeatToElement(element, attrs, repeatExpression) {
	            if (element[0].hasAttribute('dir-paginate-start') || element[0].hasAttribute('data-dir-paginate-start')) {
	                // using multiElement mode (dir-paginate-start, dir-paginate-end)
	                attrs.$set('ngRepeatStart', repeatExpression);
	                element.eq(element.length - 1).attr('ng-repeat-end', true);
	            } else {
	                attrs.$set('ngRepeat', repeatExpression);
	            }
	        }
	
	        /**
	         * Adds the dir-paginate-no-compile directive to each element in the tElement range.
	         * @param tElement
	         */
	        function addNoCompileAttributes(tElement) {
	            angular.forEach(tElement, function(el) {
	                if (el.nodeType === 1) {
	                    angular.element(el).attr('dir-paginate-no-compile', true);
	                }
	            });
	        }
	
	        /**
	         * Removes the variations on dir-paginate (data-, -start, -end) and the dir-paginate-no-compile directives.
	         * @param element
	         */
	        function removeTemporaryAttributes(element) {
	            angular.forEach(element, function(el) {
	                if (el.nodeType === 1) {
	                    angular.element(el).removeAttr('dir-paginate-no-compile');
	                }
	            });
	            element.eq(0).removeAttr('dir-paginate-start').removeAttr('dir-paginate').removeAttr('data-dir-paginate-start').removeAttr('data-dir-paginate');
	            element.eq(element.length - 1).removeAttr('dir-paginate-end').removeAttr('data-dir-paginate-end');
	        }
	
	        /**
	         * Creates a getter function for the current-page attribute, using the expression provided or a default value if
	         * no current-page expression was specified.
	         *
	         * @param scope
	         * @param attrs
	         * @param paginationId
	         * @returns {*}
	         */
	        function makeCurrentPageGetterFn(scope, attrs, paginationId) {
	            var currentPageGetter;
	            if (attrs.currentPage) {
	                currentPageGetter = $parse(attrs.currentPage);
	            } else {
	                // If the current-page attribute was not set, we'll make our own.
	                // Replace any non-alphanumeric characters which might confuse
	                // the $parse service and give unexpected results.
	                // See https://github.com/michaelbromley/angularUtils/issues/233
	                var defaultCurrentPage = (paginationId + '__currentPage').replace(/\W/g, '_');
	                scope[defaultCurrentPage] = 1;
	                currentPageGetter = $parse(defaultCurrentPage);
	            }
	            return currentPageGetter;
	        }
	    }
	
	    /**
	     * This is a helper directive that allows correct compilation when in multi-element mode (ie dir-paginate-start, dir-paginate-end).
	     * It is dynamically added to all elements in the dir-paginate compile function, and it prevents further compilation of
	     * any inner directives. It is then removed in the link function, and all inner directives are then manually compiled.
	     */
	    function noCompileDirective() {
	        return {
	            priority: 5000,
	            terminal: true
	        };
	    }
	
	    function dirPaginationControlsTemplateInstaller($templateCache) {
	        $templateCache.put('angularUtils.directives.dirPagination.template', '<ul class="pagination" ng-if="1 < pages.length || !autoHide"><li ng-if="boundaryLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(1)">&laquo;</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(pagination.current - 1)">&lsaquo;</a></li><li ng-repeat="pageNumber in pages track by tracker(pageNumber, $index)" ng-class="{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' || ( ! autoHide && pages.length === 1 ) }"><a href="" ng-click="setCurrent(pageNumber)">{{ pageNumber }}</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.current + 1)">&rsaquo;</a></li><li ng-if="boundaryLinks"  ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.last)">&raquo;</a></li></ul>');
	    }
	
	    function dirPaginationControlsDirective(paginationService, paginationTemplate) {
	
	        var numberRegex = /^\d+$/;
	
	        var DDO = {
	            restrict: 'AE',
	            scope: {
	                maxSize: '=?',
	                onPageChange: '&?',
	                paginationId: '=?',
	                autoHide: '=?'
	            },
	            link: dirPaginationControlsLinkFn
	        };
	
	        // We need to check the paginationTemplate service to see whether a template path or
	        // string has been specified, and add the `template` or `templateUrl` property to
	        // the DDO as appropriate. The order of priority to decide which template to use is
	        // (highest priority first):
	        // 1. paginationTemplate.getString()
	        // 2. attrs.templateUrl
	        // 3. paginationTemplate.getPath()
	        var templateString = paginationTemplate.getString();
	        if (templateString !== undefined) {
	            DDO.template = templateString;
	        } else {
	            DDO.templateUrl = function(elem, attrs) {
	                return attrs.templateUrl || paginationTemplate.getPath();
	            };
	        }
	        return DDO;
	
	        function dirPaginationControlsLinkFn(scope, element, attrs) {
	
	            // rawId is the un-interpolated value of the pagination-id attribute. This is only important when the corresponding dir-paginate directive has
	            // not yet been linked (e.g. if it is inside an ng-if block), and in that case it prevents this controls directive from assuming that there is
	            // no corresponding dir-paginate directive and wrongly throwing an exception.
	            var rawId = attrs.paginationId ||  DEFAULT_ID;
	            var paginationId = scope.paginationId || attrs.paginationId ||  DEFAULT_ID;
	
	            if (!paginationService.isRegistered(paginationId) && !paginationService.isRegistered(rawId)) {
	                var idMessage = (paginationId !== DEFAULT_ID) ? ' (id: ' + paginationId + ') ' : ' ';
	                if (window.console) {
	                    console.warn('Pagination directive: the pagination controls' + idMessage + 'cannot be used without the corresponding pagination directive, which was not found at link time.');
	                }
	            }
	
	            if (!scope.maxSize) { scope.maxSize = 9; }
	            scope.autoHide = scope.autoHide === undefined ? true : scope.autoHide;
	            scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : true;
	            scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : false;
	
	            var paginationRange = Math.max(scope.maxSize, 5);
	            scope.pages = [];
	            scope.pagination = {
	                last: 1,
	                current: 1
	            };
	            scope.range = {
	                lower: 1,
	                upper: 1,
	                total: 1
	            };
	
	            scope.$watch('maxSize', function(val) {
	                if (val) {
	                    paginationRange = Math.max(scope.maxSize, 5);
	                    generatePagination();
	                }
	            });
	
	            scope.$watch(function() {
	                if (paginationService.isRegistered(paginationId)) {
	                    return (paginationService.getCollectionLength(paginationId) + 1) * paginationService.getItemsPerPage(paginationId);
	                }
	            }, function(length) {
	                if (0 < length) {
	                    generatePagination();
	                }
	            });
	
	            scope.$watch(function() {
	                if (paginationService.isRegistered(paginationId)) {
	                    return (paginationService.getItemsPerPage(paginationId));
	                }
	            }, function(current, previous) {
	                if (current != previous && typeof previous !== 'undefined') {
	                    goToPage(scope.pagination.current);
	                }
	            });
	
	            scope.$watch(function() {
	                if (paginationService.isRegistered(paginationId)) {
	                    return paginationService.getCurrentPage(paginationId);
	                }
	            }, function(currentPage, previousPage) {
	                if (currentPage != previousPage) {
	                    goToPage(currentPage);
	                }
	            });
	
	            scope.setCurrent = function(num) {
	                if (paginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
	                    num = parseInt(num, 10);
	                    paginationService.setCurrentPage(paginationId, num);
	                }
	            };
	
	            /**
	             * Custom "track by" function which allows for duplicate "..." entries on long lists,
	             * yet fixes the problem of wrongly-highlighted links which happens when using
	             * "track by $index" - see https://github.com/michaelbromley/angularUtils/issues/153
	             * @param id
	             * @param index
	             * @returns {string}
	             */
	            scope.tracker = function(id, index) {
	                return id + '_' + index;
	            };
	
	            function goToPage(num) {
	                if (paginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
	                    var oldPageNumber = scope.pagination.current;
	
	                    scope.pages = generatePagesArray(num, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
	                    scope.pagination.current = num;
	                    updateRangeValues();
	
	                    // if a callback has been set, then call it with the page number as the first argument
	                    // and the previous page number as a second argument
	                    if (scope.onPageChange) {
	                        scope.onPageChange({
	                            newPageNumber : num,
	                            oldPageNumber : oldPageNumber
	                        });
	                    }
	                }
	            }
	
	            function generatePagination() {
	                if (paginationService.isRegistered(paginationId)) {
	                    var page = parseInt(paginationService.getCurrentPage(paginationId)) || 1;
	                    scope.pages = generatePagesArray(page, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
	                    scope.pagination.current = page;
	                    scope.pagination.last = scope.pages[scope.pages.length - 1];
	                    if (scope.pagination.last < scope.pagination.current) {
	                        scope.setCurrent(scope.pagination.last);
	                    } else {
	                        updateRangeValues();
	                    }
	                }
	            }
	
	            /**
	             * This function updates the values (lower, upper, total) of the `scope.range` object, which can be used in the pagination
	             * template to display the current page range, e.g. "showing 21 - 40 of 144 results";
	             */
	            function updateRangeValues() {
	                if (paginationService.isRegistered(paginationId)) {
	                    var currentPage = paginationService.getCurrentPage(paginationId),
	                        itemsPerPage = paginationService.getItemsPerPage(paginationId),
	                        totalItems = paginationService.getCollectionLength(paginationId);
	
	                    scope.range.lower = (currentPage - 1) * itemsPerPage + 1;
	                    scope.range.upper = Math.min(currentPage * itemsPerPage, totalItems);
	                    scope.range.total = totalItems;
	                }
	            }
	            function isValidPageNumber(num) {
	                return (numberRegex.test(num) && (0 < num && num <= scope.pagination.last));
	            }
	        }
	
	        /**
	         * Generate an array of page numbers (or the '...' string) which is used in an ng-repeat to generate the
	         * links used in pagination
	         *
	         * @param currentPage
	         * @param rowsPerPage
	         * @param paginationRange
	         * @param collectionLength
	         * @returns {Array}
	         */
	        function generatePagesArray(currentPage, collectionLength, rowsPerPage, paginationRange) {
	            var pages = [];
	            var totalPages = Math.ceil(collectionLength / rowsPerPage);
	            var halfWay = Math.ceil(paginationRange / 2);
	            var position;
	
	            if (currentPage <= halfWay) {
	                position = 'start';
	            } else if (totalPages - halfWay < currentPage) {
	                position = 'end';
	            } else {
	                position = 'middle';
	            }
	
	            var ellipsesNeeded = paginationRange < totalPages;
	            var i = 1;
	            while (i <= totalPages && i <= paginationRange) {
	                var pageNumber = calculatePageNumber(i, currentPage, paginationRange, totalPages);
	
	                var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
	                var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));
	                if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
	                    pages.push('...');
	                } else {
	                    pages.push(pageNumber);
	                }
	                i ++;
	            }
	            return pages;
	        }
	
	        /**
	         * Given the position in the sequence of pagination links [i], figure out what page number corresponds to that position.
	         *
	         * @param i
	         * @param currentPage
	         * @param paginationRange
	         * @param totalPages
	         * @returns {*}
	         */
	        function calculatePageNumber(i, currentPage, paginationRange, totalPages) {
	            var halfWay = Math.ceil(paginationRange/2);
	            if (i === paginationRange) {
	                return totalPages;
	            } else if (i === 1) {
	                return i;
	            } else if (paginationRange < totalPages) {
	                if (totalPages - halfWay < currentPage) {
	                    return totalPages - paginationRange + i;
	                } else if (halfWay < currentPage) {
	                    return currentPage - halfWay + i;
	                } else {
	                    return i;
	                }
	            } else {
	                return i;
	            }
	        }
	    }
	
	    /**
	     * This filter slices the collection into pages based on the current page number and number of items per page.
	     * @param paginationService
	     * @returns {Function}
	     */
	    function itemsPerPageFilter(paginationService) {
	
	        return function(collection, itemsPerPage, paginationId) {
	            if (typeof (paginationId) === 'undefined') {
	                paginationId = DEFAULT_ID;
	            }
	            if (!paginationService.isRegistered(paginationId)) {
	                throw 'pagination directive: the itemsPerPage id argument (id: ' + paginationId + ') does not match a registered pagination-id.';
	            }
	            var end;
	            var start;
	            if (angular.isObject(collection)) {
	                itemsPerPage = parseInt(itemsPerPage) || 9999999999;
	                if (paginationService.isAsyncMode(paginationId)) {
	                    start = 0;
	                } else {
	                    start = (paginationService.getCurrentPage(paginationId) - 1) * itemsPerPage;
	                }
	                end = start + itemsPerPage;
	                paginationService.setItemsPerPage(paginationId, itemsPerPage);
	
	                if (collection instanceof Array) {
	                    // the array just needs to be sliced
	                    return collection.slice(start, end);
	                } else {
	                    // in the case of an object, we need to get an array of keys, slice that, then map back to
	                    // the original object.
	                    var slicedObject = {};
	                    angular.forEach(keys(collection).slice(start, end), function(key) {
	                        slicedObject[key] = collection[key];
	                    });
	                    return slicedObject;
	                }
	            } else {
	                return collection;
	            }
	        };
	    }
	
	    /**
	     * Shim for the Object.keys() method which does not exist in IE < 9
	     * @param obj
	     * @returns {Array}
	     */
	    function keys(obj) {
	        if (!Object.keys) {
	            var objKeys = [];
	            for (var i in obj) {
	                if (obj.hasOwnProperty(i)) {
	                    objKeys.push(i);
	                }
	            }
	            return objKeys;
	        } else {
	            return Object.keys(obj);
	        }
	    }
	
	    /**
	     * This service allows the various parts of the module to communicate and stay in sync.
	     */
	    function paginationService() {
	
	        var instances = {};
	        var lastRegisteredInstance;
	
	        this.registerInstance = function(instanceId) {
	            if (typeof instances[instanceId] === 'undefined') {
	                instances[instanceId] = {
	                    asyncMode: false
	                };
	                lastRegisteredInstance = instanceId;
	            }
	        };
	
	        this.deregisterInstance = function(instanceId) {
	            delete instances[instanceId];
	        };
	        
	        this.isRegistered = function(instanceId) {
	            return (typeof instances[instanceId] !== 'undefined');
	        };
	
	        this.getLastInstanceId = function() {
	            return lastRegisteredInstance;
	        };
	
	        this.setCurrentPageParser = function(instanceId, val, scope) {
	            instances[instanceId].currentPageParser = val;
	            instances[instanceId].context = scope;
	        };
	        this.setCurrentPage = function(instanceId, val) {
	            instances[instanceId].currentPageParser.assign(instances[instanceId].context, val);
	        };
	        this.getCurrentPage = function(instanceId) {
	            var parser = instances[instanceId].currentPageParser;
	            return parser ? parser(instances[instanceId].context) : 1;
	        };
	
	        this.setItemsPerPage = function(instanceId, val) {
	            instances[instanceId].itemsPerPage = val;
	        };
	        this.getItemsPerPage = function(instanceId) {
	            return instances[instanceId].itemsPerPage;
	        };
	
	        this.setCollectionLength = function(instanceId, val) {
	            instances[instanceId].collectionLength = val;
	        };
	        this.getCollectionLength = function(instanceId) {
	            return instances[instanceId].collectionLength;
	        };
	
	        this.setAsyncModeTrue = function(instanceId) {
	            instances[instanceId].asyncMode = true;
	        };
	
	        this.setAsyncModeFalse = function(instanceId) {
	            instances[instanceId].asyncMode = false;
	        };
	
	        this.isAsyncMode = function(instanceId) {
	            return instances[instanceId].asyncMode;
	        };
	    }
	
	    /**
	     * This provider allows global configuration of the template path used by the dir-pagination-controls directive.
	     */
	    function paginationTemplateProvider() {
	
	        var templatePath = 'angularUtils.directives.dirPagination.template';
	        var templateString;
	
	        /**
	         * Set a templateUrl to be used by all instances of <dir-pagination-controls>
	         * @param {String} path
	         */
	        this.setPath = function(path) {
	            templatePath = path;
	        };
	
	        /**
	         * Set a string of HTML to be used as a template by all instances
	         * of <dir-pagination-controls>. If both a path *and* a string have been set,
	         * the string takes precedence.
	         * @param {String} str
	         */
	        this.setString = function(str) {
	            templateString = str;
	        };
	
	        this.$get = function() {
	            return {
	                getPath: function() {
	                    return templatePath;
	                },
	                getString: function() {
	                    return templateString;
	                }
	            };
	        };
	    }
	})();


/***/ },

/***/ 148:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(147);
	module.exports = 'angularUtils.directives.dirPagination';


/***/ },

/***/ 149:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! angularjs-slider - v6.7.0 - 
	 (c) Rafal Zajac <rzajac@gmail.com>, Valentin Hervieu <valentin@hervi.eu>, Jussi Saarivirta <jusasi@gmail.com>, Angelin Sirbu <angelin.sirbu@gmail.com> - 
	 https://github.com/angular-slider/angularjs-slider - 
	 2019-02-23 */
	/*jslint unparam: true */
	/*global angular: false, console: false, define, module */
	;(function(root, factory) {
	  'use strict'
	  /* istanbul ignore next */
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    // to support bundler like browserify
	    var angularObj = angular || require('angular')
	    if ((!angularObj || !angularObj.module) && typeof angular != 'undefined') {
	      angularObj = angular
	    }
	    module.exports = factory(angularObj)
	  } else {
	    // Browser globals (root is window)
	    factory(root.angular)
	  }
	})(this, function(angular) {
	  'use strict'
	  var module = angular
	    .module('rzModule', [])
	    .factory('RzSliderOptions', function() {
	      var defaultOptions = {
	        floor: 0,
	        ceil: null, //defaults to rz-slider-model
	        step: 1,
	        precision: 0,
	        minRange: null,
	        maxRange: null,
	        restrictedRange: null,
	        pushRange: false,
	        minLimit: null,
	        maxLimit: null,
	        id: null,
	        translate: null,
	        getLegend: null,
	        stepsArray: null,
	        bindIndexForStepsArray: false,
	        draggableRange: false,
	        draggableRangeOnly: false,
	        showSelectionBar: false,
	        showSelectionBarEnd: false,
	        showSelectionBarFromValue: null,
	        showOuterSelectionBars: false,
	        hidePointerLabels: false,
	        hideLimitLabels: false,
	        autoHideLimitLabels: true,
	        readOnly: false,
	        disabled: false,
	        interval: 350,
	        showTicks: false,
	        showTicksValues: false,
	        ticksArray: null,
	        ticksTooltip: null,
	        ticksValuesTooltip: null,
	        vertical: false,
	        getSelectionBarColor: null,
	        getTickColor: null,
	        getPointerColor: null,
	        keyboardSupport: true,
	        scale: 1,
	        enforceStep: true,
	        enforceRange: false,
	        noSwitching: false,
	        onlyBindHandles: false,
	        onStart: null,
	        onChange: null,
	        onEnd: null,
	        rightToLeft: false,
	        reversedControls: false,
	        boundPointerLabels: true,
	        mergeRangeLabelsIfSame: false,
	        labelOverlapSeparator: ' - ',
	        customTemplateScope: null,
	        logScale: false,
	        customValueToPosition: null,
	        customPositionToValue: null,
	        selectionBarGradient: null,
	        ariaLabel: null,
	        ariaLabelledBy: null,
	        ariaLabelHigh: null,
	        ariaLabelledByHigh: null,
	      }
	      var globalOptions = {}
	
	      var factory = {}
	      /**
	       * `options({})` allows global configuration of all sliders in the
	       * application.
	       *
	       *   var app = angular.module( 'App', ['rzModule'], function( RzSliderOptions ) {
	       *     // show ticks for all sliders
	       *     RzSliderOptions.options( { showTicks: true } );
	       *   });
	       */
	      factory.options = function(value) {
	        angular.extend(globalOptions, value)
	      }
	
	      factory.getOptions = function(options) {
	        return angular.extend({}, defaultOptions, globalOptions, options)
	      }
	
	      return factory
	    })
	    .factory('rzThrottle', ['$timeout', function($timeout) {
	      /**
	       * rzThrottle
	       *
	       * Taken from underscore project
	       *
	       * @param {Function} func
	       * @param {number} wait
	       * @param {ThrottleOptions} options
	       * @returns {Function}
	       */
	      return function(func, wait, options) {
	        'use strict'
	        /* istanbul ignore next */
	        var getTime =
	          Date.now ||
	          function() {
	            return new Date().getTime()
	          }
	        var context, args, result
	        var timeout = null
	        var previous = 0
	        options = options || {}
	        var later = function() {
	          previous = getTime()
	          timeout = null
	          result = func.apply(context, args)
	          context = args = null
	        }
	        return function() {
	          var now = getTime()
	          var remaining = wait - (now - previous)
	          context = this
	          args = arguments
	          if (remaining <= 0) {
	            $timeout.cancel(timeout)
	            timeout = null
	            previous = now
	            result = func.apply(context, args)
	            context = args = null
	          } else if (!timeout && options.trailing !== false) {
	            timeout = $timeout(later, remaining)
	          }
	          return result
	        }
	      }
	    }])
	    .factory('RzSlider', ['$timeout', '$document', '$window', '$compile', 'RzSliderOptions', 'rzThrottle', function(
	      $timeout,
	      $document,
	      $window,
	      $compile,
	      RzSliderOptions,
	      rzThrottle
	    ) {
	      'use strict'
	
	      /**
	       * Slider
	       *
	       * @param {ngScope} scope            The AngularJS scope
	       * @param {Element} sliderElem The slider directive element wrapped in jqLite
	       * @constructor
	       */
	      var Slider = function(scope, sliderElem) {
	        /**
	         * The slider's scope
	         *
	         * @type {ngScope}
	         */
	        this.scope = scope
	
	        /**
	         * The slider inner low value (linked to rzSliderModel)
	         * @type {number}
	         */
	        this.lowValue = 0
	
	        /**
	         * The slider inner high value (linked to rzSliderHigh)
	         * @type {number}
	         */
	        this.highValue = 0
	
	        /**
	         * Slider element wrapped in jqLite
	         *
	         * @type {jqLite}
	         */
	        this.sliderElem = sliderElem
	
	        /**
	         * Slider type
	         *
	         * @type {boolean} Set to true for range slider
	         */
	        this.range =
	          this.scope.rzSliderModel !== undefined &&
	          this.scope.rzSliderHigh !== undefined
	
	        /**
	         * Values recorded when first dragging the bar
	         *
	         * @type {Object}
	         */
	        this.dragging = {
	          active: false,
	          value: 0,
	          difference: 0,
	          position: 0,
	          lowLimit: 0,
	          highLimit: 0,
	        }
	
	        /**
	         * property that handle position (defaults to left for horizontal)
	         * @type {string}
	         */
	        this.positionProperty = 'left'
	
	        /**
	         * property that handle dimension (defaults to width for horizontal)
	         * @type {string}
	         */
	        this.dimensionProperty = 'width'
	
	        /**
	         * Half of the width or height of the slider handles
	         *
	         * @type {number}
	         */
	        this.handleHalfDim = 0
	
	        /**
	         * Maximum position the slider handle can have
	         *
	         * @type {number}
	         */
	        this.maxPos = 0
	
	        /**
	         * Precision
	         *
	         * @type {number}
	         */
	        this.precision = 0
	
	        /**
	         * Step
	         *
	         * @type {number}
	         */
	        this.step = 1
	
	        /**
	         * The name of the handle we are currently tracking
	         *
	         * @type {string}
	         */
	        this.tracking = ''
	
	        /**
	         * Minimum value (floor) of the model
	         *
	         * @type {number}
	         */
	        this.minValue = 0
	
	        /**
	         * Maximum value (ceiling) of the model
	         *
	         * @type {number}
	         */
	        this.maxValue = 0
	
	        /**
	         * The delta between min and max value
	         *
	         * @type {number}
	         */
	        this.valueRange = 0
	
	        /**
	         * If showTicks/showTicksValues options are number.
	         * In this case, ticks values should be displayed below the slider.
	         * @type {boolean}
	         */
	        this.intermediateTicks = false
	
	        /**
	         * Set to true if init method already executed
	         *
	         * @type {boolean}
	         */
	        this.initHasRun = false
	
	        /**
	         * Used to call onStart on the first keydown event
	         *
	         * @type {boolean}
	         */
	        this.firstKeyDown = false
	
	        /**
	         * Internal flag to prevent watchers to be called when the sliders value are modified internally.
	         * @type {boolean}
	         */
	        this.internalChange = false
	
	        /**
	         * Internal flag to keep track of the visibility of combo label
	         * @type {boolean}
	         */
	        this.cmbLabelShown = false
	
	        /**
	         * Internal variable to keep track of the focus element
	         */
	        this.currentFocusElement = null
	
	        // Slider DOM elements wrapped in jqLite
	        this.fullBar = null // The whole slider bar
	        this.selBar = null // Highlight between two handles
	        this.minH = null // Left slider handle
	        this.maxH = null // Right slider handle
	        this.flrLab = null // Floor label
	        this.ceilLab = null // Ceiling label
	        this.minLab = null // Label above the low value
	        this.maxLab = null // Label above the high value
	        this.cmbLab = null // Combined label
	        this.ticks = null // The ticks
	
	        // Initialize slider
	        this.init()
	      }
	
	      // Add instance methods
	      Slider.prototype = {
	        /**
	         * Initialize slider
	         *
	         * @returns {undefined}
	         */
	        init: function() {
	          var thrLow,
	            thrHigh,
	            self = this
	
	          var calcDimFn = function() {
	            self.calcViewDimensions()
	          }
	
	          this.applyOptions()
	          this.syncLowValue()
	          if (this.range) this.syncHighValue()
	          this.initElemHandles()
	          this.manageElementsStyle()
	          this.setDisabledState()
	          this.calcViewDimensions()
	          this.setMinAndMax()
	          this.updateRestrictionBar()
	          this.addAccessibility()
	          this.updateCeilLab()
	          this.updateFloorLab()
	          this.initHandles()
	          this.manageEventsBindings()
	
	          // Recalculate slider view dimensions
	          this.scope.$on('reCalcViewDimensions', calcDimFn)
	
	          // Recalculate stuff if view port dimensions have changed
	          angular.element($window).on('resize', calcDimFn)
	
	          this.initHasRun = true
	
	          // Watch for changes to the model
	          thrLow = rzThrottle(function() {
	            self.onLowHandleChange()
	          }, self.options.interval)
	
	          thrHigh = rzThrottle(function() {
	            self.onHighHandleChange()
	          }, self.options.interval)
	
	          this.scope.$on('rzSliderForceRender', function() {
	            self.resetLabelsValue()
	            thrLow()
	            if (self.range) {
	              thrHigh()
	            }
	            self.resetSlider()
	          })
	
	          // Watchers (order is important because in case of simultaneous change,
	          // watchers will be called in the same order)
	          this.scope.$watchCollection('rzSliderOptions()', function(
	            newValue,
	            oldValue
	          ) {
	            if (newValue === oldValue) return
	            self.applyOptions() // need to be called before synchronizing the values
	            self.syncLowValue()
	            if (self.range) self.syncHighValue()
	            self.resetSlider()
	          })
	
	          this.scope.$watch('rzSliderModel', function(newValue, oldValue) {
	            if (self.internalChange) return
	            if (newValue === oldValue) return
	            thrLow()
	          })
	
	          this.scope.$watch('rzSliderHigh', function(newValue, oldValue) {
	            if (self.internalChange) return
	            if (newValue === oldValue) return
	            if (newValue != null) thrHigh()
	            if (
	              (self.range && newValue == null) ||
	              (!self.range && newValue != null)
	            ) {
	              self.applyOptions()
	              self.resetSlider()
	            }
	          })
	
	          this.scope.$on('$destroy', function() {
	            self.unbindEvents()
	            angular.element($window).off('resize', calcDimFn)
	            self.currentFocusElement = null
	          })
	        },
	
	        findStepIndex: function(modelValue) {
	          var index = 0
	          for (var i = 0; i < this.options.stepsArray.length; i++) {
	            var step = this.options.stepsArray[i]
	            if (step === modelValue) {
	              index = i
	              break
	            } else if (angular.isDate(step)) {
	              if (step.getTime() === modelValue.getTime()) {
	                index = i
	                break
	              }
	            } else if (angular.isObject(step)) {
	              if (
	                (angular.isDate(step.value) &&
	                  step.value.getTime() === modelValue.getTime()) ||
	                step.value === modelValue
	              ) {
	                index = i
	                break
	              }
	            }
	          }
	          return index
	        },
	
	        syncLowValue: function() {
	          if (this.options.stepsArray) {
	            if (!this.options.bindIndexForStepsArray)
	              this.lowValue = this.findStepIndex(this.scope.rzSliderModel)
	            else this.lowValue = this.scope.rzSliderModel
	          } else this.lowValue = this.scope.rzSliderModel
	        },
	
	        syncHighValue: function() {
	          if (this.options.stepsArray) {
	            if (!this.options.bindIndexForStepsArray)
	              this.highValue = this.findStepIndex(this.scope.rzSliderHigh)
	            else this.highValue = this.scope.rzSliderHigh
	          } else this.highValue = this.scope.rzSliderHigh
	        },
	
	        getStepValue: function(sliderValue) {
	          var step = this.options.stepsArray[sliderValue]
	          if (angular.isDate(step)) return step
	          if (angular.isObject(step)) return step.value
	          return step
	        },
	
	        applyLowValue: function() {
	          if (this.options.stepsArray) {
	            if (!this.options.bindIndexForStepsArray)
	              this.scope.rzSliderModel = this.getStepValue(this.lowValue)
	            else this.scope.rzSliderModel = this.lowValue
	          } else this.scope.rzSliderModel = this.lowValue
	        },
	
	        applyHighValue: function() {
	          if (this.options.stepsArray) {
	            if (!this.options.bindIndexForStepsArray)
	              this.scope.rzSliderHigh = this.getStepValue(this.highValue)
	            else this.scope.rzSliderHigh = this.highValue
	          } else this.scope.rzSliderHigh = this.highValue
	        },
	
	        /*
	       * Reflow the slider when the low handle changes (called with throttle)
	       */
	        onLowHandleChange: function() {
	          this.syncLowValue()
	          if (this.range) this.syncHighValue()
	          this.setMinAndMax()
	          this.updateLowHandle(this.valueToPosition(this.lowValue))
	          this.updateSelectionBar()
	          this.updateTicksScale()
	          this.updateAriaAttributes()
	          if (this.range) {
	            this.updateCmbLabel()
	          }
	        },
	
	        /*
	       * Reflow the slider when the high handle changes (called with throttle)
	       */
	        onHighHandleChange: function() {
	          this.syncLowValue()
	          this.syncHighValue()
	          this.setMinAndMax()
	          this.updateHighHandle(this.valueToPosition(this.highValue))
	          this.updateSelectionBar()
	          this.updateTicksScale()
	          this.updateCmbLabel()
	          this.updateAriaAttributes()
	        },
	
	        /**
	         * Read the user options and apply them to the slider model
	         */
	        applyOptions: function() {
	          var sliderOptions
	          if (this.scope.rzSliderOptions)
	            sliderOptions = this.scope.rzSliderOptions()
	          else sliderOptions = {}
	
	          this.options = RzSliderOptions.getOptions(sliderOptions)
	
	          if (this.options.step <= 0) this.options.step = 1
	
	          this.range =
	            this.scope.rzSliderModel !== undefined &&
	            this.scope.rzSliderHigh !== undefined
	          this.options.draggableRange =
	            this.range && this.options.draggableRange
	          this.options.draggableRangeOnly =
	            this.range && this.options.draggableRangeOnly
	          if (this.options.draggableRangeOnly) {
	            this.options.draggableRange = true
	          }
	
	          this.options.showTicks =
	            this.options.showTicks ||
	            this.options.showTicksValues ||
	            !!this.options.ticksArray
	          this.scope.showTicks = this.options.showTicks //scope is used in the template
	          if (
	            angular.isNumber(this.options.showTicks) ||
	            this.options.ticksArray
	          )
	            this.intermediateTicks = true
	
	          this.options.showSelectionBar =
	            this.options.showSelectionBar ||
	            this.options.showSelectionBarEnd ||
	            this.options.showSelectionBarFromValue !== null
	
	          if (this.options.stepsArray) {
	            this.parseStepsArray()
	          } else {
	            if (this.options.translate) this.customTrFn = this.options.translate
	            else
	              this.customTrFn = function(value) {
	                return String(value)
	              }
	
	            this.getLegend = this.options.getLegend
	          }
	
	          if (this.options.vertical) {
	            this.positionProperty = 'bottom'
	            this.dimensionProperty = 'height'
	          }
	
	          if (this.options.customTemplateScope)
	            this.scope.custom = this.options.customTemplateScope
	        },
	
	        parseStepsArray: function() {
	          this.options.floor = 0
	          this.options.ceil = this.options.stepsArray.length - 1
	          this.options.step = 1
	
	          if (this.options.translate) {
	            this.customTrFn = this.options.translate
	          } else {
	            this.customTrFn = function(modelValue) {
	              if (this.options.bindIndexForStepsArray)
	                return this.getStepValue(modelValue)
	              return modelValue
	            }
	          }
	
	          this.getLegend = function(index) {
	            var step = this.options.stepsArray[index]
	            if (angular.isObject(step)) return step.legend
	            return null
	          }
	        },
	
	        /**
	         * Resets slider
	         *
	         * @returns {undefined}
	         */
	        resetSlider: function() {
	          this.manageElementsStyle()
	          this.addAccessibility()
	          this.setMinAndMax()
	          this.updateCeilLab()
	          this.updateFloorLab()
	          this.unbindEvents()
	          this.manageEventsBindings()
	          this.setDisabledState()
	          this.calcViewDimensions()
	          this.updateRestrictionBar()
	          this.refocusPointerIfNeeded()
	        },
	
	        refocusPointerIfNeeded: function() {
	          if (this.currentFocusElement) {
	            this.onPointerFocus(
	              this.currentFocusElement.pointer,
	              this.currentFocusElement.ref
	            )
	            this.focusElement(this.currentFocusElement.pointer)
	          }
	        },
	
	        /**
	         * Set the slider children to variables for easy access
	         *
	         * Run only once during initialization
	         *
	         * @returns {undefined}
	         */
	        initElemHandles: function() {
	          // Assign all slider elements to object properties for easy access
	          angular.forEach(
	            this.sliderElem.children(),
	            function(elem, index) {
	              var jElem = angular.element(elem)
	
	              switch (index) {
	                case 0:
	                  this.leftOutSelBar = jElem
	                  break
	                case 1:
	                  this.rightOutSelBar = jElem
	                  break
	                case 2:
	                  this.fullBar = jElem
	                  break
	                case 3:
	                  this.selBar = jElem
	                  break
	                case 4:
	                  this.restrictedBar = jElem
	                  break
	                case 5:
	                  this.minH = jElem
	                  break
	                case 6:
	                  this.maxH = jElem
	                  break
	                case 7:
	                  this.flrLab = jElem
	                  break
	                case 8:
	                  this.ceilLab = jElem
	                  break
	                case 9:
	                  this.minLab = jElem
	                  break
	                case 10:
	                  this.maxLab = jElem
	                  break
	                case 11:
	                  this.cmbLab = jElem
	                  break
	                case 12:
	                  this.ticks = jElem
	                  break
	              }
	            },
	            this
	          )
	
	          // Initialize position cache properties
	          this.selBar.rzsp = 0
	          this.minH.rzsp = 0
	          this.maxH.rzsp = 0
	          this.flrLab.rzsp = 0
	          this.ceilLab.rzsp = 0
	          this.minLab.rzsp = 0
	          this.maxLab.rzsp = 0
	          this.cmbLab.rzsp = 0
	        },
	
	        /**
	         * Update each elements style based on options
	         */
	        manageElementsStyle: function() {
	          if (!this.range) this.maxH.css('display', 'none')
	          else this.maxH.css('display', '')
	
	          this.alwaysHide(
	            this.flrLab,
	            this.options.showTicksValues || this.options.hideLimitLabels
	          )
	          this.alwaysHide(
	            this.ceilLab,
	            this.options.showTicksValues || this.options.hideLimitLabels
	          )
	
	          var hideLabelsForTicks =
	            this.options.showTicksValues && !this.intermediateTicks
	          this.alwaysHide(
	            this.minLab,
	            hideLabelsForTicks || this.options.hidePointerLabels
	          )
	          this.alwaysHide(
	            this.maxLab,
	            hideLabelsForTicks || !this.range || this.options.hidePointerLabels
	          )
	          this.alwaysHide(
	            this.cmbLab,
	            hideLabelsForTicks || !this.range || this.options.hidePointerLabels
	          )
	          this.alwaysHide(
	            this.selBar,
	            !this.range && !this.options.showSelectionBar
	          )
	          this.alwaysHide(
	            this.leftOutSelBar,
	            !this.range || !this.options.showOuterSelectionBars
	          )
	          this.alwaysHide(this.restrictedBar, !this.options.restrictedRange)
	          this.alwaysHide(
	            this.rightOutSelBar,
	            !this.range || !this.options.showOuterSelectionBars
	          )
	
	          if (this.range && this.options.showOuterSelectionBars) {
	            this.fullBar.addClass('rz-transparent')
	          }
	
	          if (this.options.vertical) this.sliderElem.addClass('rz-vertical')
	
	          if (this.options.draggableRange) this.selBar.addClass('rz-draggable')
	          else this.selBar.removeClass('rz-draggable')
	
	          if (this.intermediateTicks && this.options.showTicksValues)
	            this.ticks.addClass('rz-ticks-values-under')
	        },
	
	        alwaysHide: function(el, hide) {
	          el.rzAlwaysHide = hide
	          if (hide) this.hideEl(el)
	          else this.showEl(el)
	        },
	
	        /**
	         * Manage the events bindings based on readOnly and disabled options
	         *
	         * @returns {undefined}
	         */
	        manageEventsBindings: function() {
	          if (this.options.disabled || this.options.readOnly)
	            this.unbindEvents()
	          else this.bindEvents()
	        },
	
	        /**
	         * Set the disabled state based on rzSliderDisabled
	         *
	         * @returns {undefined}
	         */
	        setDisabledState: function() {
	          if (this.options.disabled) {
	            this.sliderElem.attr('disabled', 'disabled')
	          } else {
	            this.sliderElem.attr('disabled', null)
	          }
	        },
	
	        /**
	         * Reset label values
	         *
	         * @return {undefined}
	         */
	        resetLabelsValue: function() {
	          this.minLab.rzsv = undefined
	          this.maxLab.rzsv = undefined
	        },
	
	        /**
	         * Initialize slider handles positions and labels
	         *
	         * Run only once during initialization and every time view port changes size
	         *
	         * @returns {undefined}
	         */
	        initHandles: function() {
	          this.updateLowHandle(this.valueToPosition(this.lowValue))
	
	          /*
	         the order here is important since the selection bar should be
	         updated after the high handle but before the combined label
	         */
	          if (this.range)
	            this.updateHighHandle(this.valueToPosition(this.highValue))
	          this.updateSelectionBar()
	          if (this.range) this.updateCmbLabel()
	
	          this.updateTicksScale()
	        },
	
	        /**
	         * Translate value to human readable format
	         *
	         * @param {number|string} value
	         * @param {jqLite} label
	         * @param {String} which
	         * @param {boolean} [useCustomTr]
	         * @returns {undefined}
	         */
	        translateFn: function(value, label, which, useCustomTr) {
	          useCustomTr = useCustomTr === undefined ? true : useCustomTr
	
	          var valStr = '',
	            getDimension = false,
	            noLabelInjection = label.hasClass('no-label-injection')
	
	          if (useCustomTr) {
	            if (this.options.stepsArray && !this.options.bindIndexForStepsArray)
	              value = this.getStepValue(value)
	            valStr = String(this.customTrFn(value, this.options.id, which))
	          } else {
	            valStr = String(value)
	          }
	
	          if (
	            label.rzsv === undefined ||
	            label.rzsv.length !== valStr.length ||
	            (label.rzsv.length > 0 && label.rzsd === 0)
	          ) {
	            getDimension = true
	            label.rzsv = valStr
	          }
	
	          if (!noLabelInjection) {
	            label.html(valStr)
	          }
	          this.scope[which + 'Label'] = valStr
	
	          // Update width only when length of the label have changed
	          if (getDimension) {
	            this.getDimension(label)
	          }
	        },
	
	        /**
	         * Set maximum and minimum values for the slider and ensure the model and high
	         * value match these limits
	         * @returns {undefined}
	         */
	        setMinAndMax: function() {
	          this.step = +this.options.step
	          this.precision = +this.options.precision
	
	          this.minValue = this.options.floor
	          if (this.options.logScale && this.minValue === 0)
	            throw Error("Can't use floor=0 with logarithmic scale")
	
	          if (this.options.enforceStep) {
	            this.lowValue = this.roundStep(this.lowValue)
	            if (this.range) this.highValue = this.roundStep(this.highValue)
	          }
	
	          if (this.options.ceil != null) this.maxValue = this.options.ceil
	          else
	            this.maxValue = this.options.ceil = this.range
	              ? this.highValue
	              : this.lowValue
	
	          if (this.options.enforceRange) {
	            this.lowValue = this.sanitizeValue(this.lowValue)
	            if (this.range) this.highValue = this.sanitizeValue(this.highValue)
	          }
	
	          this.applyLowValue()
	          if (this.range) this.applyHighValue()
	
	          this.valueRange = this.maxValue - this.minValue
	        },
	
	        /**
	         * Adds accessibility attributes
	         *
	         * Run only once during initialization
	         *
	         * @returns {undefined}
	         */
	        addAccessibility: function() {
	          this.minH.attr('role', 'slider')
	          this.updateAriaAttributes()
	          if (
	            this.options.keyboardSupport &&
	            !(this.options.readOnly || this.options.disabled)
	          )
	            this.minH.attr('tabindex', '0')
	          else this.minH.attr('tabindex', '')
	          if (this.options.vertical)
	            this.minH.attr('aria-orientation', 'vertical')
	          if (this.options.ariaLabel)
	            this.minH.attr('aria-label', this.options.ariaLabel)
	          else if (this.options.ariaLabelledBy)
	            this.minH.attr('aria-labelledby', this.options.ariaLabelledBy)
	
	          if (this.range) {
	            this.maxH.attr('role', 'slider')
	            if (
	              this.options.keyboardSupport &&
	              !(this.options.readOnly || this.options.disabled)
	            )
	              this.maxH.attr('tabindex', '0')
	            else this.maxH.attr('tabindex', '')
	            if (this.options.vertical)
	              this.maxH.attr('aria-orientation', 'vertical')
	            if (this.options.ariaLabelHigh)
	              this.maxH.attr('aria-label', this.options.ariaLabelHigh)
	            else if (this.options.ariaLabelledByHigh)
	              this.maxH.attr('aria-labelledby', this.options.ariaLabelledByHigh)
	          }
	        },
	
	        /**
	         * Updates aria attributes according to current values
	         */
	        updateAriaAttributes: function() {
	          this.minH.attr({
	            'aria-valuenow': this.scope.rzSliderModel,
	            'aria-valuetext': this.customTrFn(
	              this.scope.rzSliderModel,
	              this.options.id,
	              'model'
	            ),
	            'aria-valuemin': this.minValue,
	            'aria-valuemax': this.maxValue,
	          })
	          if (this.range) {
	            this.maxH.attr({
	              'aria-valuenow': this.scope.rzSliderHigh,
	              'aria-valuetext': this.customTrFn(
	                this.scope.rzSliderHigh,
	                this.options.id,
	                'high'
	              ),
	              'aria-valuemin': this.minValue,
	              'aria-valuemax': this.maxValue,
	            })
	          }
	        },
	
	        /**
	         * Calculate dimensions that are dependent on view port size
	         *
	         * Run once during initialization and every time view port changes size.
	         *
	         * @returns {undefined}
	         */
	        calcViewDimensions: function() {
	          var handleWidth = this.getDimension(this.minH)
	
	          this.handleHalfDim = handleWidth / 2
	          this.barDimension = this.getDimension(this.fullBar)
	
	          this.maxPos = this.barDimension - handleWidth
	
	          this.getDimension(this.sliderElem)
	          this.sliderElem.rzsp = this.sliderElem[0].getBoundingClientRect()[
	            this.positionProperty
	          ]
	
	          if (this.initHasRun) {
	            this.updateFloorLab()
	            this.updateCeilLab()
	            this.initHandles()
	            var self = this
	            $timeout(function() {
	              self.updateTicksScale()
	            })
	          }
	        },
	
	        /**
	         * Update the ticks position
	         *
	         * @returns {undefined}
	         */
	        updateTicksScale: function() {
	          if (!this.options.showTicks) return
	
	          var ticksArray = this.options.ticksArray || this.getTicksArray(),
	            translate = this.options.vertical ? 'translateY' : 'translateX',
	            self = this
	
	          if (this.options.rightToLeft) ticksArray.reverse()
	
	          this.scope.ticks = ticksArray.map(function(value) {
	            var legend = null;
	            if (angular.isObject(value)) {
	              legend = value.legend;
	              value = value.value
	            }
	
	            var position = self.valueToPosition(value)
	
	            if (self.options.vertical) position = self.maxPos - position
	
	            var translation = translate + '(' + Math.round(position) + 'px)'
	            var tick = {
	              legend: legend,
	              selected: self.isTickSelected(value),
	              style: {
	                '-webkit-transform': translation,
	                '-moz-transform': translation,
	                '-o-transform': translation,
	                '-ms-transform': translation,
	                transform: translation,
	              },
	            }
	            if (tick.selected && self.options.getSelectionBarColor) {
	              tick.style['background-color'] = self.getSelectionBarColor()
	            }
	            if (!tick.selected && self.options.getTickColor) {
	              tick.style['background-color'] = self.getTickColor(value)
	            }
	            if (self.options.ticksTooltip) {
	              tick.tooltip = self.options.ticksTooltip(value)
	              tick.tooltipPlacement = self.options.vertical ? 'right' : 'top'
	            }
	            if (
	              self.options.showTicksValues === true ||
	              value % self.options.showTicksValues === 0
	            ) {
	              tick.value = self.getDisplayValue(value, 'tick-value')
	              if (self.options.ticksValuesTooltip) {
	                tick.valueTooltip = self.options.ticksValuesTooltip(value)
	                tick.valueTooltipPlacement = self.options.vertical
	                  ? 'right'
	                  : 'top'
	              }
	            }
	            if (self.getLegend) {
	              legend = self.getLegend(value, self.options.id)
	              if (legend) tick.legend = legend
	            }
	            return tick
	          })
	        },
	
	        getTicksArray: function() {
	          var step = this.step,
	            ticksArray = []
	          if (this.intermediateTicks) step = this.options.showTicks
	          for (
	            var value = this.minValue;
	            value <= this.maxValue;
	            value += step
	          ) {
	            ticksArray.push(value)
	          }
	          return ticksArray
	        },
	
	        isTickSelected: function(value) {
	          if (!this.range) {
	            if (this.options.showSelectionBarFromValue !== null) {
	              var center = this.options.showSelectionBarFromValue
	              if (
	                this.lowValue > center &&
	                value >= center &&
	                value <= this.lowValue
	              )
	                return true
	              else if (
	                this.lowValue < center &&
	                value <= center &&
	                value >= this.lowValue
	              )
	                return true
	            } else if (this.options.showSelectionBarEnd) {
	              if (value >= this.lowValue) return true
	            } else if (this.options.showSelectionBar && value <= this.lowValue)
	              return true
	          }
	          if (this.range && value >= this.lowValue && value <= this.highValue)
	            return true
	          return false
	        },
	
	        /**
	         * Update position of the floor label
	         *
	         * @returns {undefined}
	         */
	        updateFloorLab: function() {
	          this.translateFn(this.minValue, this.flrLab, 'floor')
	          this.getDimension(this.flrLab)
	          var position = this.options.rightToLeft
	            ? this.barDimension - this.flrLab.rzsd
	            : 0
	          this.setPosition(this.flrLab, position)
	        },
	
	        /**
	         * Update position of the ceiling label
	         *
	         * @returns {undefined}
	         */
	        updateCeilLab: function() {
	          this.translateFn(this.maxValue, this.ceilLab, 'ceil')
	          this.getDimension(this.ceilLab)
	          var position = this.options.rightToLeft
	            ? 0
	            : this.barDimension - this.ceilLab.rzsd
	          this.setPosition(this.ceilLab, position)
	        },
	
	        /**
	         * Update slider handles and label positions
	         *
	         * @param {string} which
	         * @param {number} newPos
	         */
	        updateHandles: function(which, newPos) {
	          if (which === 'lowValue') this.updateLowHandle(newPos)
	          else this.updateHighHandle(newPos)
	
	          this.updateSelectionBar()
	          this.updateTicksScale()
	          if (this.range) this.updateCmbLabel()
	        },
	
	        /**
	         * Helper function to work out the position for handle labels depending on RTL or not
	         *
	         * @param {string} labelName maxLab or minLab
	         * @param newPos
	         *
	         * @returns {number}
	         */
	        getHandleLabelPos: function(labelName, newPos) {
	          var labelRzsd = this[labelName].rzsd,
	            nearHandlePos = newPos - labelRzsd / 2 + this.handleHalfDim,
	            endOfBarPos = this.barDimension - labelRzsd
	
	          if (!this.options.boundPointerLabels) return nearHandlePos
	
	          if (
	            (this.options.rightToLeft && labelName === 'minLab') ||
	            (!this.options.rightToLeft && labelName === 'maxLab')
	          ) {
	            return Math.min(nearHandlePos, endOfBarPos)
	          } else {
	            return Math.min(Math.max(nearHandlePos, 0), endOfBarPos)
	          }
	        },
	
	        /**
	         * Update low slider handle position and label
	         *
	         * @param {number} newPos
	         * @returns {undefined}
	         */
	        updateLowHandle: function(newPos) {
	          this.setPosition(this.minH, newPos)
	          this.translateFn(this.lowValue, this.minLab, 'model')
	          this.setPosition(
	            this.minLab,
	            this.getHandleLabelPos('minLab', newPos)
	          )
	
	          if (this.options.getPointerColor) {
	            var pointercolor = this.getPointerColor('min')
	            this.scope.minPointerStyle = {
	              backgroundColor: pointercolor,
	            }
	          }
	
	          if (this.options.autoHideLimitLabels) {
	            this.shFloorCeil()
	          }
	        },
	
	        /**
	         * Update high slider handle position and label
	         *
	         * @param {number} newPos
	         * @returns {undefined}
	         */
	        updateHighHandle: function(newPos) {
	          this.setPosition(this.maxH, newPos)
	          this.translateFn(this.highValue, this.maxLab, 'high')
	          this.setPosition(
	            this.maxLab,
	            this.getHandleLabelPos('maxLab', newPos)
	          )
	
	          if (this.options.getPointerColor) {
	            var pointercolor = this.getPointerColor('max')
	            this.scope.maxPointerStyle = {
	              backgroundColor: pointercolor,
	            }
	          }
	          if (this.options.autoHideLimitLabels) {
	            this.shFloorCeil()
	          }
	        },
	
	        /**
	         * Show/hide floor/ceiling label
	         *
	         * @returns {undefined}
	         */
	        shFloorCeil: function() {
	          // Show based only on hideLimitLabels if pointer labels are hidden
	          if (this.options.hidePointerLabels) {
	            return
	          }
	          var flHidden = false,
	            clHidden = false,
	            isMinLabAtFloor = this.isLabelBelowFloorLab(this.minLab),
	            isMinLabAtCeil = this.isLabelAboveCeilLab(this.minLab),
	            isMaxLabAtCeil = this.isLabelAboveCeilLab(this.maxLab),
	            isCmbLabAtFloor = this.isLabelBelowFloorLab(this.cmbLab),
	            isCmbLabAtCeil = this.isLabelAboveCeilLab(this.cmbLab)
	
	          if (isMinLabAtFloor) {
	            flHidden = true
	            this.hideEl(this.flrLab)
	          } else {
	            flHidden = false
	            this.showEl(this.flrLab)
	          }
	
	          if (isMinLabAtCeil) {
	            clHidden = true
	            this.hideEl(this.ceilLab)
	          } else {
	            clHidden = false
	            this.showEl(this.ceilLab)
	          }
	
	          if (this.range) {
	            var hideCeil = this.cmbLabelShown ? isCmbLabAtCeil : isMaxLabAtCeil
	            var hideFloor = this.cmbLabelShown
	              ? isCmbLabAtFloor
	              : isMinLabAtFloor
	
	            if (hideCeil) {
	              this.hideEl(this.ceilLab)
	            } else if (!clHidden) {
	              this.showEl(this.ceilLab)
	            }
	
	            // Hide or show floor label
	            if (hideFloor) {
	              this.hideEl(this.flrLab)
	            } else if (!flHidden) {
	              this.showEl(this.flrLab)
	            }
	          }
	        },
	
	        isLabelBelowFloorLab: function(label) {
	          var isRTL = this.options.rightToLeft,
	            pos = label.rzsp,
	            dim = label.rzsd,
	            floorPos = this.flrLab.rzsp,
	            floorDim = this.flrLab.rzsd
	          return isRTL
	            ? pos + dim >= floorPos - 2
	            : pos <= floorPos + floorDim + 2
	        },
	
	        isLabelAboveCeilLab: function(label) {
	          var isRTL = this.options.rightToLeft,
	            pos = label.rzsp,
	            dim = label.rzsd,
	            ceilPos = this.ceilLab.rzsp,
	            ceilDim = this.ceilLab.rzsd
	          return isRTL ? pos <= ceilPos + ceilDim + 2 : pos + dim >= ceilPos - 2
	        },
	
	        /**
	         * Update restricted area bar
	         *
	         * @returns {undefined}
	         */
	        updateRestrictionBar: function() {
	          var position = 0,
	            dimension = 0
	          if (this.options.restrictedRange) {
	            var from = this.valueToPosition(this.options.restrictedRange.from),
	              to = this.valueToPosition(this.options.restrictedRange.to)
	            dimension = Math.abs(to - from)
	            position = this.options.rightToLeft
	              ? to + this.handleHalfDim
	              : from + this.handleHalfDim
	            this.setDimension(this.restrictedBar, dimension)
	            this.setPosition(this.restrictedBar, position)
	          }
	        },
	
	        /**
	         * Update slider selection bar, combined label and range label
	         *
	         * @returns {undefined}
	         */
	        updateSelectionBar: function() {
	          var position = 0,
	            dimension = 0,
	            isSelectionBarFromRight = this.options.rightToLeft
	              ? !this.options.showSelectionBarEnd
	              : this.options.showSelectionBarEnd,
	            positionForRange = this.options.rightToLeft
	              ? this.maxH.rzsp + this.handleHalfDim
	              : this.minH.rzsp + this.handleHalfDim
	
	          if (this.range) {
	            dimension = Math.abs(this.maxH.rzsp - this.minH.rzsp)
	            position = positionForRange
	          } else {
	            if (this.options.showSelectionBarFromValue !== null) {
	              var center = this.options.showSelectionBarFromValue,
	                centerPosition = this.valueToPosition(center),
	                isModelGreaterThanCenter = this.options.rightToLeft
	                  ? this.lowValue <= center
	                  : this.lowValue > center
	              if (isModelGreaterThanCenter) {
	                dimension = this.minH.rzsp - centerPosition
	                position = centerPosition + this.handleHalfDim
	              } else {
	                dimension = centerPosition - this.minH.rzsp
	                position = this.minH.rzsp + this.handleHalfDim
	              }
	            } else if (isSelectionBarFromRight) {
	              dimension =
	                Math.abs(this.maxPos - this.minH.rzsp) + this.handleHalfDim
	              position = this.minH.rzsp + this.handleHalfDim
	            } else {
	              dimension = this.minH.rzsp + this.handleHalfDim
	              position = 0
	            }
	          }
	          this.setDimension(this.selBar, dimension)
	          this.setPosition(this.selBar, position)
	          if (this.range && this.options.showOuterSelectionBars) {
	            if (this.options.rightToLeft) {
	              this.setDimension(this.rightOutSelBar, position)
	              this.setPosition(this.rightOutSelBar, 0)
	              this.setDimension(
	                this.leftOutSelBar,
	                this.getDimension(this.fullBar) - (position + dimension)
	              )
	              this.setPosition(this.leftOutSelBar, position + dimension)
	            } else {
	              this.setDimension(this.leftOutSelBar, position)
	              this.setPosition(this.leftOutSelBar, 0)
	              this.setDimension(
	                this.rightOutSelBar,
	                this.getDimension(this.fullBar) - (position + dimension)
	              )
	              this.setPosition(this.rightOutSelBar, position + dimension)
	            }
	          }
	          if (this.options.getSelectionBarColor) {
	            var color = this.getSelectionBarColor()
	            this.scope.barStyle = {
	              backgroundColor: color,
	            }
	          } else if (this.options.selectionBarGradient) {
	            var offset =
	                this.options.showSelectionBarFromValue !== null
	                  ? this.valueToPosition(this.options.showSelectionBarFromValue)
	                  : 0,
	              reversed = (offset - position > 0) ^ isSelectionBarFromRight,
	              direction = this.options.vertical
	                ? reversed
	                  ? 'bottom'
	                  : 'top'
	                : reversed
	                  ? 'left'
	                  : 'right'
	            this.scope.barStyle = {
	              backgroundImage:
	                'linear-gradient(to ' +
	                direction +
	                ', ' +
	                this.options.selectionBarGradient.from +
	                ' 0%,' +
	                this.options.selectionBarGradient.to +
	                ' 100%)',
	            }
	            if (this.options.vertical) {
	              this.scope.barStyle.backgroundPosition =
	                'center ' +
	                (offset +
	                  dimension +
	                  position +
	                  (reversed ? -this.handleHalfDim : 0)) +
	                'px'
	              this.scope.barStyle.backgroundSize =
	                '100% ' + (this.barDimension - this.handleHalfDim) + 'px'
	            } else {
	              this.scope.barStyle.backgroundPosition =
	                offset -
	                position +
	                (reversed ? this.handleHalfDim : 0) +
	                'px center'
	              this.scope.barStyle.backgroundSize =
	                this.barDimension - this.handleHalfDim + 'px 100%'
	            }
	          }
	        },
	
	        /**
	         * Wrapper around the getSelectionBarColor of the user to pass to
	         * correct parameters
	         */
	        getSelectionBarColor: function() {
	          if (this.range)
	            return this.options.getSelectionBarColor(
	              this.scope.rzSliderModel,
	              this.scope.rzSliderHigh
	            )
	          return this.options.getSelectionBarColor(this.scope.rzSliderModel)
	        },
	
	        /**
	         * Wrapper around the getPointerColor of the user to pass to
	         * correct parameters
	         */
	        getPointerColor: function(pointerType) {
	          if (pointerType === 'max') {
	            return this.options.getPointerColor(
	              this.scope.rzSliderHigh,
	              pointerType
	            )
	          }
	          return this.options.getPointerColor(
	            this.scope.rzSliderModel,
	            pointerType
	          )
	        },
	
	        /**
	         * Wrapper around the getTickColor of the user to pass to
	         * correct parameters
	         */
	        getTickColor: function(value) {
	          return this.options.getTickColor(value)
	        },
	
	        /**
	         * Update combined label position and value
	         *
	         * @returns {undefined}
	         */
	        updateCmbLabel: function() {
	          var isLabelOverlap = null
	          if (this.options.rightToLeft) {
	            isLabelOverlap =
	              this.minLab.rzsp - this.minLab.rzsd - 10 <= this.maxLab.rzsp
	          } else {
	            isLabelOverlap =
	              this.minLab.rzsp + this.minLab.rzsd + 10 >= this.maxLab.rzsp
	          }
	
	          if (isLabelOverlap) {
	            var lowTr = this.getDisplayValue(this.lowValue, 'model'),
	              highTr = this.getDisplayValue(this.highValue, 'high'),
	              labelVal = ''
	            if (this.options.mergeRangeLabelsIfSame && lowTr === highTr) {
	              labelVal = lowTr
	            } else {
	              labelVal = this.options.rightToLeft
	                ? highTr + this.options.labelOverlapSeparator + lowTr
	                : lowTr + this.options.labelOverlapSeparator + highTr
	            }
	
	            this.translateFn(labelVal, this.cmbLab, 'cmb', false)
	            var pos = this.options.boundPointerLabels
	              ? Math.min(
	                  Math.max(
	                    this.selBar.rzsp +
	                      this.selBar.rzsd / 2 -
	                      this.cmbLab.rzsd / 2,
	                    0
	                  ),
	                  this.barDimension - this.cmbLab.rzsd
	                )
	              : this.selBar.rzsp + this.selBar.rzsd / 2 - this.cmbLab.rzsd / 2
	
	            this.setPosition(this.cmbLab, pos)
	            this.cmbLabelShown = true
	            this.hideEl(this.minLab)
	            this.hideEl(this.maxLab)
	            this.showEl(this.cmbLab)
	          } else {
	            this.cmbLabelShown = false
	            this.updateHighHandle(this.valueToPosition(this.highValue))
	            this.updateLowHandle(this.valueToPosition(this.lowValue))
	            this.showEl(this.maxLab)
	            this.showEl(this.minLab)
	            this.hideEl(this.cmbLab)
	          }
	          if (this.options.autoHideLimitLabels) {
	            this.shFloorCeil()
	          }
	        },
	
	        /**
	         * Return the translated value if a translate function is provided else the original value
	         * @param value
	         * @param which if it's min or max handle
	         * @returns {*}
	         */
	        getDisplayValue: function(value, which) {
	          if (this.options.stepsArray && !this.options.bindIndexForStepsArray) {
	            value = this.getStepValue(value)
	          }
	          return this.customTrFn(value, this.options.id, which)
	        },
	
	        /**
	         * Round value to step and precision based on minValue
	         *
	         * @param {number} value
	         * @param {number} customStep a custom step to override the defined step
	         * @returns {number}
	         */
	        roundStep: function(value, customStep) {
	          var step = customStep ? customStep : this.step,
	            steppedDifference = parseFloat(
	              (value - this.minValue) / step
	            ).toPrecision(12)
	          steppedDifference = Math.round(+steppedDifference) * step
	          var newValue = (this.minValue + steppedDifference).toFixed(
	            this.precision
	          )
	          return +newValue
	        },
	
	        /**
	         * Hide element
	         *
	         * @param element
	         * @returns {jqLite} The jqLite wrapped DOM element
	         */
	        hideEl: function(element) {
	          return element.css({
	            visibility: 'hidden',
	          })
	        },
	
	        /**
	         * Show element
	         *
	         * @param element The jqLite wrapped DOM element
	         * @returns {jqLite} The jqLite
	         */
	        showEl: function(element) {
	          if (!!element.rzAlwaysHide) {
	            return element
	          }
	
	          return element.css({
	            visibility: 'visible',
	          })
	        },
	
	        /**
	         * Set element left/top position depending on whether slider is horizontal or vertical
	         *
	         * @param {jqLite} elem The jqLite wrapped DOM element
	         * @param {number} pos
	         * @returns {number}
	         */
	        setPosition: function(elem, pos) {
	          elem.rzsp = pos
	          var css = {}
	          css[this.positionProperty] = Math.round(pos) + 'px'
	          elem.css(css)
	          return pos
	        },
	
	        /**
	         * Get element width/height depending on whether slider is horizontal or vertical
	         *
	         * @param {jqLite} elem The jqLite wrapped DOM element
	         * @returns {number}
	         */
	        getDimension: function(elem) {
	          var val = elem[0].getBoundingClientRect()
	          if (this.options.vertical)
	            elem.rzsd = (val.bottom - val.top) * this.options.scale
	          else elem.rzsd = (val.right - val.left) * this.options.scale
	          return elem.rzsd
	        },
	
	        /**
	         * Set element width/height depending on whether slider is horizontal or vertical
	         *
	         * @param {jqLite} elem  The jqLite wrapped DOM element
	         * @param {number} dim
	         * @returns {number}
	         */
	        setDimension: function(elem, dim) {
	          elem.rzsd = dim
	          var css = {}
	          css[this.dimensionProperty] = Math.round(dim) + 'px'
	          elem.css(css)
	          return dim
	        },
	
	        /**
	         * Returns a value that is within slider range
	         *
	         * @param {number} val
	         * @returns {number}
	         */
	        sanitizeValue: function(val) {
	          return Math.min(Math.max(val, this.minValue), this.maxValue)
	        },
	
	        /**
	         * Translate value to pixel position
	         *
	         * @param {number} val
	         * @returns {number}
	         */
	        valueToPosition: function(val) {
	          var fn = this.linearValueToPosition
	          if (this.options.customValueToPosition)
	            fn = this.options.customValueToPosition
	          else if (this.options.logScale) fn = this.logValueToPosition
	
	          val = this.sanitizeValue(val)
	          var percent = fn(val, this.minValue, this.maxValue) || 0
	          if (this.options.rightToLeft) percent = 1 - percent
	          return percent * this.maxPos
	        },
	
	        linearValueToPosition: function(val, minVal, maxVal) {
	          var range = maxVal - minVal
	          return (val - minVal) / range
	        },
	
	        logValueToPosition: function(val, minVal, maxVal) {
	          val = Math.log(val)
	          minVal = Math.log(minVal)
	          maxVal = Math.log(maxVal)
	          var range = maxVal - minVal
	          return (val - minVal) / range
	        },
	
	        /**
	         * Translate position to model value
	         *
	         * @param {number} position
	         * @returns {number}
	         */
	        positionToValue: function(position) {
	          var percent = position / this.maxPos
	          if (this.options.rightToLeft) percent = 1 - percent
	          var fn = this.linearPositionToValue
	          if (this.options.customPositionToValue)
	            fn = this.options.customPositionToValue
	          else if (this.options.logScale) fn = this.logPositionToValue
	          return fn(percent, this.minValue, this.maxValue) || 0
	        },
	
	        linearPositionToValue: function(percent, minVal, maxVal) {
	          return percent * (maxVal - minVal) + minVal
	        },
	
	        logPositionToValue: function(percent, minVal, maxVal) {
	          minVal = Math.log(minVal)
	          maxVal = Math.log(maxVal)
	          var value = percent * (maxVal - minVal) + minVal
	          return Math.exp(value)
	        },
	
	        getEventAttr: function(event, attr) {
	          return event.originalEvent === undefined
	            ? event[attr]
	            : event.originalEvent[attr]
	        },
	
	        // Events
	        /**
	         * Get the X-coordinate or Y-coordinate of an event
	         *
	         * @param {Object} event  The event
	         * @param targetTouchId The identifier of the touch with the X/Y coordinates
	         * @returns {number}
	         */
	        getEventXY: function(event, targetTouchId) {
	          /* http://stackoverflow.com/a/12336075/282882 */
	          //noinspection JSLint
	          var clientXY = this.options.vertical ? 'clientY' : 'clientX'
	          if (event[clientXY] !== undefined) {
	            return event[clientXY]
	          }
	
	          var touches = this.getEventAttr(event, 'touches')
	
	          if (targetTouchId !== undefined) {
	            for (var i = 0; i < touches.length; i++) {
	              if (touches[i].identifier === targetTouchId) {
	                return touches[i][clientXY]
	              }
	            }
	          }
	
	          // If no target touch or the target touch was not found in the event
	          // returns the coordinates of the first touch
	          return touches[0][clientXY]
	        },
	
	        /**
	         * Compute the event position depending on whether the slider is horizontal or vertical
	         * @param event
	         * @param targetTouchId If targetTouchId is provided it will be considered the position of that
	         * @returns {number}
	         */
	        getEventPosition: function(event, targetTouchId) {
	          var sliderPos = this.sliderElem.rzsp,
	            eventPos = 0
	          if (this.options.vertical)
	            eventPos = -this.getEventXY(event, targetTouchId) + sliderPos
	          else eventPos = this.getEventXY(event, targetTouchId) - sliderPos
	          return eventPos * this.options.scale - this.handleHalfDim // #346 handleHalfDim is already scaled
	        },
	
	        /**
	         * Get event names for move and event end
	         *
	         * @param {Event}    event    The event
	         *
	         * @return {{moveEvent: string, endEvent: string}}
	         */
	        getEventNames: function(event) {
	          var eventNames = {
	            moveEvent: '',
	            endEvent: '',
	          }
	
	          if (this.getEventAttr(event, 'touches')) {
	            eventNames.moveEvent = 'touchmove'
	            eventNames.endEvent = 'touchend'
	          } else {
	            eventNames.moveEvent = 'mousemove'
	            eventNames.endEvent = 'mouseup'
	          }
	
	          return eventNames
	        },
	
	        /**
	         * Get the handle closest to an event.
	         *
	         * @param event {Event} The event
	         * @returns {jqLite} The handle closest to the event.
	         */
	        getNearestHandle: function(event) {
	          if (!this.range) {
	            return this.minH
	          }
	          var position = this.getEventPosition(event),
	            distanceMin = Math.abs(position - this.minH.rzsp),
	            distanceMax = Math.abs(position - this.maxH.rzsp)
	          if (distanceMin < distanceMax) return this.minH
	          else if (distanceMin > distanceMax) return this.maxH
	          else if (!this.options.rightToLeft)
	            //if event is at the same distance from min/max then if it's at left of minH, we return minH else maxH
	            return position < this.minH.rzsp ? this.minH : this.maxH
	          //reverse in rtl
	          else return position > this.minH.rzsp ? this.minH : this.maxH
	        },
	
	        /**
	         * Wrapper function to focus an angular element
	         *
	         * @param el {AngularElement} the element to focus
	         */
	        focusElement: function(el) {
	          var DOM_ELEMENT = 0
	          el[DOM_ELEMENT].focus()
	        },
	
	        /**
	         * Bind mouse and touch events to slider handles
	         *
	         * @returns {undefined}
	         */
	        bindEvents: function() {
	          var barTracking, barStart, barMove
	
	          if (this.options.draggableRange) {
	            barTracking = 'rzSliderDrag'
	            barStart = this.onDragStart
	            barMove = this.onDragMove
	          } else {
	            barTracking = 'lowValue'
	            barStart = this.onStart
	            barMove = this.onMove
	          }
	
	          if (!this.options.onlyBindHandles) {
	            this.selBar.on(
	              'mousedown',
	              angular.bind(this, barStart, null, barTracking)
	            )
	            this.selBar.on(
	              'mousedown',
	              angular.bind(this, barMove, this.selBar)
	            )
	          }
	
	          if (this.options.draggableRangeOnly) {
	            this.minH.on(
	              'mousedown',
	              angular.bind(this, barStart, null, barTracking)
	            )
	            this.maxH.on(
	              'mousedown',
	              angular.bind(this, barStart, null, barTracking)
	            )
	          } else {
	            this.minH.on(
	              'mousedown',
	              angular.bind(this, this.onStart, this.minH, 'lowValue')
	            )
	            if (this.range) {
	              this.maxH.on(
	                'mousedown',
	                angular.bind(this, this.onStart, this.maxH, 'highValue')
	              )
	            }
	            if (!this.options.onlyBindHandles) {
	              this.fullBar.on(
	                'mousedown',
	                angular.bind(this, this.onStart, null, null)
	              )
	              this.fullBar.on(
	                'mousedown',
	                angular.bind(this, this.onMove, this.fullBar)
	              )
	              this.ticks.on(
	                'mousedown',
	                angular.bind(this, this.onStart, null, null)
	              )
	              this.ticks.on(
	                'mousedown',
	                angular.bind(this, this.onTickClick, this.ticks)
	              )
	            }
	          }
	
	          if (!this.options.onlyBindHandles) {
	            this.selBar.on(
	              'touchstart',
	              angular.bind(this, barStart, null, barTracking)
	            )
	            this.selBar.on(
	              'touchstart',
	              angular.bind(this, barMove, this.selBar)
	            )
	          }
	          if (this.options.draggableRangeOnly) {
	            this.minH.on(
	              'touchstart',
	              angular.bind(this, barStart, null, barTracking)
	            )
	            this.maxH.on(
	              'touchstart',
	              angular.bind(this, barStart, null, barTracking)
	            )
	          } else {
	            this.minH.on(
	              'touchstart',
	              angular.bind(this, this.onStart, this.minH, 'lowValue')
	            )
	            if (this.range) {
	              this.maxH.on(
	                'touchstart',
	                angular.bind(this, this.onStart, this.maxH, 'highValue')
	              )
	            }
	            if (!this.options.onlyBindHandles) {
	              this.fullBar.on(
	                'touchstart',
	                angular.bind(this, this.onStart, null, null)
	              )
	              this.fullBar.on(
	                'touchstart',
	                angular.bind(this, this.onMove, this.fullBar)
	              )
	              this.ticks.on(
	                'touchstart',
	                angular.bind(this, this.onStart, null, null)
	              )
	              this.ticks.on(
	                'touchstart',
	                angular.bind(this, this.onTickClick, this.ticks)
	              )
	            }
	          }
	
	          if (this.options.keyboardSupport) {
	            this.minH.on(
	              'focus',
	              angular.bind(this, this.onPointerFocus, this.minH, 'lowValue')
	            )
	            if (this.range) {
	              this.maxH.on(
	                'focus',
	                angular.bind(this, this.onPointerFocus, this.maxH, 'highValue')
	              )
	            }
	          }
	        },
	
	        /**
	         * Unbind mouse and touch events to slider handles
	         *
	         * @returns {undefined}
	         */
	        unbindEvents: function() {
	          this.minH.off()
	          this.maxH.off()
	          this.fullBar.off()
	          this.selBar.off()
	          this.ticks.off()
	        },
	
	        /**
	         * onStart event handler
	         *
	         * @param {?Object} pointer The jqLite wrapped DOM element; if null, the closest handle is used
	         * @param {?string} ref     The name of the handle being changed; if null, the closest handle's value is modified
	         * @param {Event}   event   The event
	         * @returns {undefined}
	         */
	        onStart: function(pointer, ref, event) {
	          var ehMove,
	            ehEnd,
	            eventNames = this.getEventNames(event)
	
	          event.stopPropagation()
	          event.preventDefault()
	
	          // We have to do this in case the HTML where the sliders are on
	          // have been animated into view.
	          this.calcViewDimensions()
	
	          if (pointer) {
	            this.tracking = ref
	          } else {
	            pointer = this.getNearestHandle(event)
	            this.tracking = pointer === this.minH ? 'lowValue' : 'highValue'
	          }
	
	          pointer.addClass('rz-active')
	
	          if (this.options.keyboardSupport) this.focusElement(pointer)
	
	          ehMove = angular.bind(
	            this,
	            this.dragging.active ? this.onDragMove : this.onMove,
	            pointer
	          )
	          ehEnd = angular.bind(this, this.onEnd, ehMove)
	
	          $document.on(eventNames.moveEvent, ehMove)
	          $document.on(eventNames.endEvent, ehEnd)
	          this.endHandlerToBeRemovedOnEnd = ehEnd
	
	          this.callOnStart()
	
	          var changedTouches = this.getEventAttr(event, 'changedTouches')
	          if (changedTouches) {
	            // Store the touch identifier
	            if (!this.touchId) {
	              this.isDragging = true
	              this.touchId = changedTouches[0].identifier
	            }
	          }
	        },
	
	        /**
	         * onMove event handler
	         *
	         * @param {jqLite} pointer
	         * @param {Event}  event The event
	         * @param {boolean}  fromTick if the event occured on a tick or not
	         * @returns {undefined}
	         */
	        onMove: function(pointer, event, fromTick) {
	          var changedTouches = this.getEventAttr(event, 'changedTouches')
	          var touchForThisSlider
	          if (changedTouches) {
	            for (var i = 0; i < changedTouches.length; i++) {
	              if (changedTouches[i].identifier === this.touchId) {
	                touchForThisSlider = changedTouches[i]
	                break
	              }
	            }
	          }
	
	          if (changedTouches && !touchForThisSlider) {
	            return
	          }
	
	          var newPos = this.getEventPosition(
	              event,
	              touchForThisSlider ? touchForThisSlider.identifier : undefined
	            ),
	            newValue,
	            ceilValue = this.options.rightToLeft
	              ? this.minValue
	              : this.maxValue,
	            flrValue = this.options.rightToLeft ? this.maxValue : this.minValue
	
	          if (newPos <= 0) {
	            newValue = flrValue
	          } else if (newPos >= this.maxPos) {
	            newValue = ceilValue
	          } else {
	            newValue = this.positionToValue(newPos)
	            if (fromTick && angular.isNumber(this.options.showTicks))
	              newValue = this.roundStep(newValue, this.options.showTicks)
	            else newValue = this.roundStep(newValue)
	          }
	          this.positionTrackingHandle(newValue)
	        },
	
	        /**
	         * onEnd event handler
	         *
	         * @param {Event}    event    The event
	         * @param {Function} ehMove   The bound move event handler
	         * @returns {undefined}
	         */
	        onEnd: function(ehMove, event) {
	          var changedTouches = this.getEventAttr(event, 'changedTouches')
	          if (changedTouches && changedTouches[0].identifier !== this.touchId) {
	            return
	          }
	          this.isDragging = false
	          this.touchId = null
	
	          if (!this.options.keyboardSupport) {
	            this.minH.removeClass('rz-active')
	            this.maxH.removeClass('rz-active')
	            this.tracking = ''
	          }
	          this.dragging.active = false
	
	          var eventName = this.getEventNames(event)
	          $document.off(eventName.moveEvent, ehMove)
	          $document.off(eventName.endEvent, this.endHandlerToBeRemovedOnEnd)
	          this.endHandlerToBeRemovedOnEnd = null
	          this.callOnEnd()
	        },
	
	        onTickClick: function(pointer, event) {
	          this.onMove(pointer, event, true)
	        },
	
	        onPointerFocus: function(pointer, ref) {
	          this.tracking = ref
	          pointer.one('blur', angular.bind(this, this.onPointerBlur, pointer))
	          pointer.on('keydown', angular.bind(this, this.onKeyboardEvent))
	          pointer.on('keyup', angular.bind(this, this.onKeyUp))
	          this.firstKeyDown = true
	          pointer.addClass('rz-active')
	
	          this.currentFocusElement = {
	            pointer: pointer,
	            ref: ref,
	          }
	        },
	
	        onKeyUp: function() {
	          this.firstKeyDown = true
	          this.callOnEnd()
	        },
	
	        onPointerBlur: function(pointer) {
	          pointer.off('keydown')
	          pointer.off('keyup')
	          pointer.removeClass('rz-active')
	          if (!this.isDragging) {
	            this.tracking = ''
	            this.currentFocusElement = null
	          }
	        },
	
	        /**
	         * Key actions helper function
	         *
	         * @param {number} currentValue value of the slider
	         *
	         * @returns {?Object} action value mappings
	         */
	        getKeyActions: function(currentValue) {
	          var increaseStep = currentValue + this.step,
	            decreaseStep = currentValue - this.step,
	            increasePage = currentValue + this.valueRange / 10,
	            decreasePage = currentValue - this.valueRange / 10
	
	          if (this.options.reversedControls) {
	            increaseStep = currentValue - this.step
	            decreaseStep = currentValue + this.step
	            increasePage = currentValue - this.valueRange / 10
	            decreasePage = currentValue + this.valueRange / 10
	          }
	
	          //Left to right default actions
	          var actions = {
	            UP: increaseStep,
	            DOWN: decreaseStep,
	            LEFT: decreaseStep,
	            RIGHT: increaseStep,
	            PAGEUP: increasePage,
	            PAGEDOWN: decreasePage,
	            HOME: this.options.reversedControls ? this.maxValue : this.minValue,
	            END: this.options.reversedControls ? this.minValue : this.maxValue,
	          }
	          //right to left means swapping right and left arrows
	          if (this.options.rightToLeft) {
	            actions.LEFT = increaseStep
	            actions.RIGHT = decreaseStep
	            // right to left and vertical means we also swap up and down
	            if (this.options.vertical) {
	              actions.UP = decreaseStep
	              actions.DOWN = increaseStep
	            }
	          }
	          return actions
	        },
	
	        onKeyboardEvent: function(event) {
	          var currentValue = this[this.tracking],
	            keyCode = event.keyCode || event.which,
	            keys = {
	              38: 'UP',
	              40: 'DOWN',
	              37: 'LEFT',
	              39: 'RIGHT',
	              33: 'PAGEUP',
	              34: 'PAGEDOWN',
	              36: 'HOME',
	              35: 'END',
	            },
	            actions = this.getKeyActions(currentValue),
	            key = keys[keyCode],
	            action = actions[key]
	          if (action == null || this.tracking === '') return
	          event.preventDefault()
	
	          if (this.firstKeyDown) {
	            this.firstKeyDown = false
	            this.callOnStart()
	          }
	
	          var self = this
	          $timeout(function() {
	            var newValue = self.roundStep(self.sanitizeValue(action))
	            if (!self.options.draggableRangeOnly) {
	              self.positionTrackingHandle(newValue)
	            } else {
	              var difference = self.highValue - self.lowValue,
	                newMinValue,
	                newMaxValue
	              if (self.tracking === 'lowValue') {
	                newMinValue = newValue
	                newMaxValue = newValue + difference
	                if (newMaxValue > self.maxValue) {
	                  newMaxValue = self.maxValue
	                  newMinValue = newMaxValue - difference
	                }
	              } else {
	                newMaxValue = newValue
	                newMinValue = newValue - difference
	                if (newMinValue < self.minValue) {
	                  newMinValue = self.minValue
	                  newMaxValue = newMinValue + difference
	                }
	              }
	              self.positionTrackingBar(newMinValue, newMaxValue)
	            }
	          })
	        },
	
	        /**
	         * onDragStart event handler
	         *
	         * Handles dragging of the middle bar.
	         *
	         * @param {Object} pointer The jqLite wrapped DOM element
	         * @param {string} ref     One of the refLow, refHigh values
	         * @param {Event}  event   The event
	         * @returns {undefined}
	         */
	        onDragStart: function(pointer, ref, event) {
	          var position = this.getEventPosition(event)
	          this.dragging = {
	            active: true,
	            value: this.positionToValue(position),
	            difference: this.highValue - this.lowValue,
	            lowLimit: this.options.rightToLeft
	              ? this.minH.rzsp - position
	              : position - this.minH.rzsp,
	            highLimit: this.options.rightToLeft
	              ? position - this.maxH.rzsp
	              : this.maxH.rzsp - position,
	          }
	
	          this.onStart(pointer, ref, event)
	        },
	
	        /**
	         * getValue helper function
	         *
	         * gets max or min value depending on whether the newPos is outOfBounds above or below the bar and rightToLeft
	         *
	         * @param {string} type 'max' || 'min' The value we are calculating
	         * @param {number} newPos  The new position
	         * @param {boolean} outOfBounds Is the new position above or below the max/min?
	         * @param {boolean} isAbove Is the new position above the bar if out of bounds?
	         *
	         * @returns {number}
	         */
	        getValue: function(type, newPos, outOfBounds, isAbove) {
	          var isRTL = this.options.rightToLeft,
	            value = null
	
	          if (type === 'min') {
	            if (outOfBounds) {
	              if (isAbove) {
	                value = isRTL
	                  ? this.minValue
	                  : this.maxValue - this.dragging.difference
	              } else {
	                value = isRTL
	                  ? this.maxValue - this.dragging.difference
	                  : this.minValue
	              }
	            } else {
	              value = isRTL
	                ? this.positionToValue(newPos + this.dragging.lowLimit)
	                : this.positionToValue(newPos - this.dragging.lowLimit)
	            }
	          } else {
	            if (outOfBounds) {
	              if (isAbove) {
	                value = isRTL
	                  ? this.minValue + this.dragging.difference
	                  : this.maxValue
	              } else {
	                value = isRTL
	                  ? this.maxValue
	                  : this.minValue + this.dragging.difference
	              }
	            } else {
	              if (isRTL) {
	                value =
	                  this.positionToValue(newPos + this.dragging.lowLimit) +
	                  this.dragging.difference
	              } else {
	                value =
	                  this.positionToValue(newPos - this.dragging.lowLimit) +
	                  this.dragging.difference
	              }
	            }
	          }
	          return this.roundStep(value)
	        },
	
	        /**
	         * onDragMove event handler
	         *
	         * Handles dragging of the middle bar.
	         *
	         * @param {jqLite} pointer
	         * @param {Event}  event The event
	         * @returns {undefined}
	         */
	        onDragMove: function(pointer, event) {
	          var newPos = this.getEventPosition(event),
	            newMinValue,
	            newMaxValue,
	            ceilLimit,
	            flrLimit,
	            isUnderFlrLimit,
	            isOverCeilLimit,
	            flrH,
	            ceilH
	
	          if (this.options.rightToLeft) {
	            ceilLimit = this.dragging.lowLimit
	            flrLimit = this.dragging.highLimit
	            flrH = this.maxH
	            ceilH = this.minH
	          } else {
	            ceilLimit = this.dragging.highLimit
	            flrLimit = this.dragging.lowLimit
	            flrH = this.minH
	            ceilH = this.maxH
	          }
	          isUnderFlrLimit = newPos <= flrLimit
	          isOverCeilLimit = newPos >= this.maxPos - ceilLimit
	
	          if (isUnderFlrLimit) {
	            if (flrH.rzsp === 0) return
	            newMinValue = this.getValue('min', newPos, true, false)
	            newMaxValue = this.getValue('max', newPos, true, false)
	          } else if (isOverCeilLimit) {
	            if (ceilH.rzsp === this.maxPos) return
	            newMaxValue = this.getValue('max', newPos, true, true)
	            newMinValue = this.getValue('min', newPos, true, true)
	          } else {
	            newMinValue = this.getValue('min', newPos, false)
	            newMaxValue = this.getValue('max', newPos, false)
	          }
	          this.positionTrackingBar(newMinValue, newMaxValue)
	        },
	
	        /**
	         * Set the new value and position for the entire bar
	         *
	         * @param {number} newMinValue   the new minimum value
	         * @param {number} newMaxValue   the new maximum value
	         */
	        positionTrackingBar: function(newMinValue, newMaxValue) {
	          if (
	            this.options.minLimit != null &&
	            newMinValue < this.options.minLimit
	          ) {
	            newMinValue = this.options.minLimit
	            newMaxValue = newMinValue + this.dragging.difference
	          }
	          if (
	            this.options.maxLimit != null &&
	            newMaxValue > this.options.maxLimit
	          ) {
	            newMaxValue = this.options.maxLimit
	            newMinValue = newMaxValue - this.dragging.difference
	          }
	
	          this.lowValue = newMinValue
	          this.highValue = newMaxValue
	          this.applyLowValue()
	          if (this.range) this.applyHighValue()
	          this.applyModel(true)
	          this.updateHandles('lowValue', this.valueToPosition(newMinValue))
	          this.updateHandles('highValue', this.valueToPosition(newMaxValue))
	        },
	
	        /**
	         * Set the new value and position to the current tracking handle
	         *
	         * @param {number} newValue new model value
	         */
	        positionTrackingHandle: function(newValue) {
	          var valueChanged = false
	          newValue = this.applyMinMaxLimit(newValue)
	          newValue = this.applyRestrictedRange(newValue)
	          if (this.range) {
	            if (this.options.pushRange) {
	              newValue = this.applyPushRange(newValue)
	              valueChanged = true
	            } else {
	              if (this.options.noSwitching) {
	                if (this.tracking === 'lowValue' && newValue > this.highValue)
	                  newValue = this.applyMinMaxRange(this.highValue)
	                else if (
	                  this.tracking === 'highValue' &&
	                  newValue < this.lowValue
	                )
	                  newValue = this.applyMinMaxRange(this.lowValue)
	              }
	              newValue = this.applyMinMaxRange(newValue)
	              /* This is to check if we need to switch the min and max handles */
	              if (this.tracking === 'lowValue' && newValue > this.highValue) {
	                this.lowValue = this.highValue
	                this.applyLowValue()
	                this.applyModel()
	                this.updateHandles(this.tracking, this.maxH.rzsp)
	                this.updateAriaAttributes()
	                this.tracking = 'highValue'
	                this.minH.removeClass('rz-active')
	                this.maxH.addClass('rz-active')
	                if (this.options.keyboardSupport) this.focusElement(this.maxH)
	                valueChanged = true
	              } else if (
	                this.tracking === 'highValue' &&
	                newValue < this.lowValue
	              ) {
	                this.highValue = this.lowValue
	                this.applyHighValue()
	                this.applyModel()
	                this.updateHandles(this.tracking, this.minH.rzsp)
	                this.updateAriaAttributes()
	                this.tracking = 'lowValue'
	                this.maxH.removeClass('rz-active')
	                this.minH.addClass('rz-active')
	                if (this.options.keyboardSupport) this.focusElement(this.minH)
	                valueChanged = true
	              }
	            }
	          }
	
	          if (this[this.tracking] !== newValue) {
	            this[this.tracking] = newValue
	            if (this.tracking === 'lowValue') this.applyLowValue()
	            else this.applyHighValue()
	            this.applyModel()
	            this.updateHandles(this.tracking, this.valueToPosition(newValue))
	            this.updateAriaAttributes()
	            valueChanged = true
	          }
	
	          if (valueChanged) this.applyModel(true)
	        },
	
	        applyMinMaxLimit: function(newValue) {
	          if (this.options.minLimit != null && newValue < this.options.minLimit)
	            return this.options.minLimit
	          if (this.options.maxLimit != null && newValue > this.options.maxLimit)
	            return this.options.maxLimit
	          return newValue
	        },
	
	        applyMinMaxRange: function(newValue) {
	          var oppositeValue =
	              this.tracking === 'lowValue' ? this.highValue : this.lowValue,
	            difference = Math.abs(newValue - oppositeValue)
	          if (this.options.minRange != null) {
	            if (difference < this.options.minRange) {
	              if (this.tracking === 'lowValue')
	                return this.highValue - this.options.minRange
	              else return this.lowValue + this.options.minRange
	            }
	          }
	          if (this.options.maxRange != null) {
	            if (difference > this.options.maxRange) {
	              if (this.tracking === 'lowValue')
	                return this.highValue - this.options.maxRange
	              else return this.lowValue + this.options.maxRange
	            }
	          }
	          return newValue
	        },
	
	        applyRestrictedRange: function(newValue) {
	          if (
	            this.options.restrictedRange != null &&
	            newValue > this.options.restrictedRange.from &&
	            newValue < this.options.restrictedRange.to
	          ) {
	            var halfWidth =
	              (this.options.restrictedRange.to -
	                this.options.restrictedRange.from) /
	              2
	            if (this.tracking === 'lowValue') {
	              return newValue > this.options.restrictedRange.from + halfWidth
	                ? this.options.restrictedRange.to
	                : this.options.restrictedRange.from
	            }
	            if (this.tracking === 'highValue') {
	              return newValue < this.options.restrictedRange.to - halfWidth
	                ? this.options.restrictedRange.from
	                : this.options.restrictedRange.to
	            }
	          }
	          return newValue
	        },
	
	        applyPushRange: function(newValue) {
	          var difference =
	              this.tracking === 'lowValue'
	                ? this.highValue - newValue
	                : newValue - this.lowValue,
	            minRange =
	              this.options.minRange !== null
	                ? this.options.minRange
	                : this.options.step,
	            maxRange = this.options.maxRange
	          // if smaller than minRange
	          if (difference < minRange) {
	            if (this.tracking === 'lowValue') {
	              this.highValue = Math.min(newValue + minRange, this.maxValue)
	              newValue = this.highValue - minRange
	              this.applyHighValue()
	              this.updateHandles(
	                'highValue',
	                this.valueToPosition(this.highValue)
	              )
	            } else {
	              this.lowValue = Math.max(newValue - minRange, this.minValue)
	              newValue = this.lowValue + minRange
	              this.applyLowValue()
	              this.updateHandles(
	                'lowValue',
	                this.valueToPosition(this.lowValue)
	              )
	            }
	            this.updateAriaAttributes()
	          } else if (maxRange !== null && difference > maxRange) {
	            // if greater than maxRange
	            if (this.tracking === 'lowValue') {
	              this.highValue = newValue + maxRange
	              this.applyHighValue()
	              this.updateHandles(
	                'highValue',
	                this.valueToPosition(this.highValue)
	              )
	            } else {
	              this.lowValue = newValue - maxRange
	              this.applyLowValue()
	              this.updateHandles(
	                'lowValue',
	                this.valueToPosition(this.lowValue)
	              )
	            }
	            this.updateAriaAttributes()
	          }
	          return newValue
	        },
	
	        /**
	         * Apply the model values using scope.$apply.
	         * We wrap it with the internalChange flag to avoid the watchers to be called
	         */
	        applyModel: function(callOnChange) {
	          this.internalChange = true
	          this.scope.$apply()
	          callOnChange && this.callOnChange()
	          this.internalChange = false
	        },
	
	        /**
	         * Call the onStart callback if defined
	         * The callback call is wrapped in a $evalAsync to ensure that its result will be applied to the scope.
	         *
	         * @returns {undefined}
	         */
	        callOnStart: function() {
	          if (this.options.onStart) {
	            var self = this,
	              pointerType = this.tracking === 'lowValue' ? 'min' : 'max'
	            this.scope.$evalAsync(function() {
	              self.options.onStart(
	                self.options.id,
	                self.scope.rzSliderModel,
	                self.scope.rzSliderHigh,
	                pointerType
	              )
	            })
	          }
	        },
	
	        /**
	         * Call the onChange callback if defined
	         * The callback call is wrapped in a $evalAsync to ensure that its result will be applied to the scope.
	         *
	         * @returns {undefined}
	         */
	        callOnChange: function() {
	          if (this.options.onChange) {
	            var self = this,
	              pointerType = this.tracking === 'lowValue' ? 'min' : 'max'
	            this.scope.$evalAsync(function() {
	              self.options.onChange(
	                self.options.id,
	                self.scope.rzSliderModel,
	                self.scope.rzSliderHigh,
	                pointerType
	              )
	            })
	          }
	        },
	
	        /**
	         * Call the onEnd callback if defined
	         * The callback call is wrapped in a $evalAsync to ensure that its result will be applied to the scope.
	         *
	         * @returns {undefined}
	         */
	        callOnEnd: function() {
	          if (this.options.onEnd) {
	            var self = this,
	              pointerType = this.tracking === 'lowValue' ? 'min' : 'max'
	            this.scope.$evalAsync(function() {
	              self.options.onEnd(
	                self.options.id,
	                self.scope.rzSliderModel,
	                self.scope.rzSliderHigh,
	                pointerType
	              )
	            })
	          }
	          this.scope.$emit('slideEnded')
	        },
	      }
	
	      return Slider
	    }])
	    .directive('rzslider', ['RzSlider', function(RzSlider) {
	      'use strict'
	
	      return {
	        restrict: 'AE',
	        replace: true,
	        scope: {
	          rzSliderModel: '=?',
	          rzSliderHigh: '=?',
	          rzSliderOptions: '&?',
	          rzSliderTplUrl: '@',
	        },
	
	        /**
	         * Return template URL
	         *
	         * @param {jqLite} elem
	         * @param {Object} attrs
	         * @return {string}
	         */
	        templateUrl: function(elem, attrs) {
	          //noinspection JSUnresolvedVariable
	          return attrs.rzSliderTplUrl || 'rzSliderTpl.html'
	        },
	
	        link: function(scope, elem) {
	          scope.slider = new RzSlider(scope, elem) //attach on scope so we can test it
	        },
	      }
	    }])
	
	  // IDE assist
	
	  /**
	   * @name ngScope
	   *
	   * @property {number} rzSliderModel
	   * @property {number} rzSliderHigh
	   * @property {Object} rzSliderOptions
	   */
	
	  /**
	   * @name jqLite
	   *
	   * @property {number|undefined} rzsp rzslider label position position
	   * @property {number|undefined} rzsd rzslider element dimension
	   * @property {string|undefined} rzsv rzslider label value/text
	   * @property {Function} css
	   * @property {Function} text
	   */
	
	  /**
	   * @name Event
	   * @property {Array} touches
	   * @property {Event} originalEvent
	   */
	
	  /**
	   * @name ThrottleOptions
	   *
	   * @property {boolean} leading
	   * @property {boolean} trailing
	   */
	
	  module.run(['$templateCache', function($templateCache) {
	  'use strict';
	
	  $templateCache.put('rzSliderTpl.html',
	    "<div class=rzslider><span class=\"rz-bar-wrapper rz-left-out-selection\"><span class=rz-bar></span></span> <span class=\"rz-bar-wrapper rz-right-out-selection\"><span class=rz-bar></span></span> <span class=rz-bar-wrapper><span class=rz-bar></span></span> <span class=rz-bar-wrapper><span class=\"rz-bar rz-selection\" ng-style=barStyle></span></span> <span class=rz-bar-wrapper><span class=\"rz-bar rz-restricted\" ng-style=restrictionStyle></span></span> <span class=\"rz-pointer rz-pointer-min\" ng-style=minPointerStyle></span> <span class=\"rz-pointer rz-pointer-max\" ng-style=maxPointerStyle></span> <span class=\"rz-bubble rz-limit rz-floor\"></span> <span class=\"rz-bubble rz-limit rz-ceil\"></span> <span class=\"rz-bubble rz-model-value\"></span> <span class=\"rz-bubble rz-model-high\"></span> <span class=rz-bubble></span><ul ng-show=showTicks class=rz-ticks><li ng-repeat=\"t in ticks track by $index\" class=rz-tick ng-class=\"{'rz-selected': t.selected}\" ng-style=t.style ng-attr-uib-tooltip=\"{{ t.tooltip }}\" ng-attr-tooltip-placement={{t.tooltipPlacement}} ng-attr-tooltip-append-to-body=\"{{ t.tooltip ? true : undefined}}\"><span ng-if=\"t.value != null\" class=rz-tick-value ng-attr-uib-tooltip=\"{{ t.valueTooltip }}\" ng-attr-tooltip-placement={{t.valueTooltipPlacement}}>{{ t.value }}</span> <span ng-if=\"t.legend != null\" class=rz-tick-legend>{{ t.legend }}</span></li></ul></div>"
	  );
	
	}]);
	
	  return module.name
	})
	;

/***/ },

/***/ 570:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(571);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = process.env.DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(97)))

/***/ },

/***/ 571:
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(820);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },

/***/ 819:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(836)(module)))

/***/ },

/***/ 820:
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ },

/***/ 822:
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["angular"], factory);
		else if(typeof exports === 'object')
			exports["ng-table"] = factory(require("angular"));
		else
			root["ng-table"] = factory(root["angular"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmory imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmory exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 51);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/* unknown exports provided */
	/* all exports used */
	/*!**************************!*\
	  !*** external "angular" ***!
	  \**************************/
	/***/ function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
	
	/***/ },
	/* 1 */
	/* unknown exports provided */
	/* all exports used */
	/*!***************************!*\
	  !*** ./src/core/index.ts ***!
	  \***************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	var angular = __webpack_require__(/*! angular */ 0);
	var data_1 = __webpack_require__(/*! ./data */ 3);
	var grouping_1 = __webpack_require__(/*! ./grouping */ 37);
	var ngTableDefaults_1 = __webpack_require__(/*! ./ngTableDefaults */ 7);
	var ngTableSettings_1 = __webpack_require__(/*! ./ngTableSettings */ 10);
	var ngTableParams_1 = __webpack_require__(/*! ./ngTableParams */ 9);
	var ngTableEventsChannel_1 = __webpack_require__(/*! ./ngTableEventsChannel */ 8);
	var ngTableCoreModule = angular.module('ngTable-core', [])
	    .provider('ngTableDefaultGetData', data_1.NgTableDefaultGetDataProvider)
	    .factory('ngTableDefaultGetGroups', grouping_1.ngTableDefaultGetGroups)
	    .value('ngTableDefaults', ngTableDefaults_1.ngTableDefaults)
	    .service('ngTableEventsChannel', ngTableEventsChannel_1.NgTableEventsChannel)
	    .service('ngTableSettings', ngTableSettings_1.NgTableSettings)
	    .run(ngTableParams_1.NgTableParams.init);
	exports.ngTableCoreModule = ngTableCoreModule;
	// note: if you are using ES6 or typescript prefer:
	// import { NgTableParams } from 'ng-table';
	ngTableCoreModule.value('NgTableParams', ngTableParams_1.NgTableParams);
	var ngTableDefaults_2 = __webpack_require__(/*! ./ngTableDefaults */ 7);
	exports.IDefaults = ngTableDefaults_2.IDefaults;
	__export(__webpack_require__(/*! ./ngTableEventsChannel */ 8));
	var ngTableSettings_2 = __webpack_require__(/*! ./ngTableSettings */ 10);
	exports.ISettings = ngTableSettings_2.ISettings;
	__export(__webpack_require__(/*! ./ngTableParams */ 9));
	__export(__webpack_require__(/*! ./data */ 3));
	__export(__webpack_require__(/*! ./filtering */ 36));
	__export(__webpack_require__(/*! ./grouping/publicExports */ 39));
	__export(__webpack_require__(/*! ./paging */ 40));
	__export(__webpack_require__(/*! ./sorting */ 41));
	
	
	/***/ },
	/* 2 */
	/* unknown exports provided */
	/* all exports used */
	/*!******************************!*\
	  !*** ./src/browser/index.ts ***!
	  \******************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	var angular = __webpack_require__(/*! angular */ 0);
	var ngTable_directive_1 = __webpack_require__(/*! ./ngTable.directive */ 13);
	var ngTableColumn_1 = __webpack_require__(/*! ./ngTableColumn */ 14);
	var ngTableColumnsBinding_directive_1 = __webpack_require__(/*! ./ngTableColumnsBinding.directive */ 15);
	var ngTableController_1 = __webpack_require__(/*! ./ngTableController */ 16);
	exports.NgTableController = ngTableController_1.NgTableController;
	var ngTableDynamic_directive_1 = __webpack_require__(/*! ./ngTableDynamic.directive */ 17);
	var ngTableFilterConfig_1 = __webpack_require__(/*! ./ngTableFilterConfig */ 18);
	exports.NgTableFilterConfigProvider = ngTableFilterConfig_1.NgTableFilterConfigProvider;
	exports.NgTableFilterConfig = ngTableFilterConfig_1.NgTableFilterConfig;
	var ngTableFilterRow_directive_1 = __webpack_require__(/*! ./ngTableFilterRow.directive */ 19);
	var ngTableFilterRowController_1 = __webpack_require__(/*! ./ngTableFilterRowController */ 20);
	var ngTableGroupRow_directive_1 = __webpack_require__(/*! ./ngTableGroupRow.directive */ 21);
	var ngTableGroupRowController_1 = __webpack_require__(/*! ./ngTableGroupRowController */ 22);
	var ngTablePagination_directive_1 = __webpack_require__(/*! ./ngTablePagination.directive */ 23);
	var ngTableSelectFilterDs_directive_1 = __webpack_require__(/*! ./ngTableSelectFilterDs.directive */ 24);
	var ngTableSorterRow_directive_1 = __webpack_require__(/*! ./ngTableSorterRow.directive */ 25);
	var ngTableSorterRowController_1 = __webpack_require__(/*! ./ngTableSorterRowController */ 26);
	__webpack_require__(/*! ./filters/number.html */ 43);
	__webpack_require__(/*! ./filters/select.html */ 45);
	__webpack_require__(/*! ./filters/select-multiple.html */ 44);
	__webpack_require__(/*! ./filters/text.html */ 46);
	__webpack_require__(/*! ./pager.html */ 49);
	__webpack_require__(/*! ./header.html */ 48);
	var ngTableBrowserModule = angular.module('ngTable-browser', [])
	    .directive('ngTable', ngTable_directive_1.ngTable)
	    .service('ngTableColumn', ngTableColumn_1.NgTableColumn)
	    .directive('ngTableColumnsBinding', ngTableColumnsBinding_directive_1.ngTableColumnsBinding)
	    .controller('ngTableController', ngTableController_1.NgTableController)
	    .directive('ngTableDynamic', ngTableDynamic_directive_1.ngTableDynamic)
	    .provider('ngTableFilterConfig', ngTableFilterConfig_1.NgTableFilterConfigProvider)
	    .directive('ngTableFilterRow', ngTableFilterRow_directive_1.ngTableFilterRow)
	    .controller('ngTableFilterRowController', ngTableFilterRowController_1.NgTableFilterRowController)
	    .directive('ngTableGroupRow', ngTableGroupRow_directive_1.ngTableGroupRow)
	    .controller('ngTableGroupRowController', ngTableGroupRowController_1.NgTableGroupRowController)
	    .directive('ngTablePagination', ngTablePagination_directive_1.ngTablePagination)
	    .directive('ngTableSelectFilterDs', ngTableSelectFilterDs_directive_1.ngTableSelectFilterDs)
	    .directive('ngTableSorterRow', ngTableSorterRow_directive_1.ngTableSorterRow)
	    .controller('ngTableSorterRowController', ngTableSorterRowController_1.NgTableSorterRowController);
	exports.ngTableBrowserModule = ngTableBrowserModule;
	__export(__webpack_require__(/*! ./public-interfaces */ 27));
	
	
	/***/ },
	/* 3 */
	/* unknown exports provided */
	/* all exports used */
	/*!********************************!*\
	  !*** ./src/core/data/index.ts ***!
	  \********************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(/*! ./dataSettings */ 28));
	__export(__webpack_require__(/*! ./getData */ 29));
	__export(__webpack_require__(/*! ./interceptor */ 30));
	__export(__webpack_require__(/*! ./ngTableDefaultGetData */ 31));
	__export(__webpack_require__(/*! ./results */ 32));
	
	
	/***/ },
	/* 4 */
	/* unknown exports provided */
	/* all exports used */
	/*!***************************************!*\
	  !*** ./src/core/grouping/getGroup.ts ***!
	  \***************************************/
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	
	
	/***/ },
	/* 5 */
	/* unknown exports provided */
	/* all exports used */
	/*!********************************************!*\
	  !*** ./src/core/grouping/groupSettings.ts ***!
	  \********************************************/
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	
	
	/***/ },
	/* 6 */
	/* unknown exports provided */
	/* all exports used */
	/*!*******************************************!*\
	  !*** ./src/core/grouping/groupingFunc.ts ***!
	  \*******************************************/
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	
	
	/***/ },
	/* 7 */
	/* unknown exports provided */
	/* all exports used */
	/*!*************************************!*\
	  !*** ./src/core/ngTableDefaults.ts ***!
	  \*************************************/
	/***/ function(module, exports) {
	
	"use strict";
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	"use strict";
	/**
	 * Default values for ngTable
	 */
	exports.ngTableDefaults = {
	    params: {},
	    settings: {}
	};
	
	
	/***/ },
	/* 8 */
	/* unknown exports provided */
	/* all exports used */
	/*!******************************************!*\
	  !*** ./src/core/ngTableEventsChannel.ts ***!
	  \******************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	"use strict";
	var ng1 = __webpack_require__(/*! angular */ 0);
	var NgTableEventsChannel = (function () {
	    function NgTableEventsChannel($rootScope) {
	        this.$rootScope = $rootScope;
	        var events = this;
	        events = this.addTableParamsEvent('afterCreated', events);
	        events = this.addTableParamsEvent('afterReloadData', events);
	        events = this.addTableParamsEvent('datasetChanged', events);
	        events = this.addTableParamsEvent('pagesChanged', events);
	        events = this.addTableParamsEvent('afterDataFiltered', events);
	        events = this.addTableParamsEvent('afterDataSorted', events);
	    }
	    NgTableEventsChannel.prototype.addTableParamsEvent = function (eventName, target) {
	        var fnName = eventName.charAt(0).toUpperCase() + eventName.substring(1);
	        var event = (_a = {},
	            _a['on' + fnName] = this.createEventSubscriptionFn(eventName),
	            _a['publish' + fnName] = this.createPublishEventFn(eventName),
	            _a
	        );
	        return ng1.extend(target, event);
	        var _a;
	    };
	    NgTableEventsChannel.prototype.createPublishEventFn = function (eventName) {
	        var _this = this;
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            (_a = _this.$rootScope).$broadcast.apply(_a, ['ngTable:' + eventName].concat(args));
	            var _a;
	        };
	    };
	    NgTableEventsChannel.prototype.createEventSubscriptionFn = function (eventName) {
	        var _this = this;
	        return function (handler, eventSelectorOrScope, eventSelector) {
	            var actualEvtSelector;
	            var scope = _this.$rootScope;
	            if (isScopeLike(eventSelectorOrScope)) {
	                scope = eventSelectorOrScope;
	                actualEvtSelector = createEventSelectorFn(eventSelector);
	            }
	            else {
	                actualEvtSelector = createEventSelectorFn(eventSelectorOrScope);
	            }
	            return scope.$on('ngTable:' + eventName, function (event, params) {
	                var eventArgs = [];
	                for (var _i = 2; _i < arguments.length; _i++) {
	                    eventArgs[_i - 2] = arguments[_i];
	                }
	                // don't send events published by the internal NgTableParams created by ngTableController
	                if (params.isNullInstance)
	                    return;
	                var fnArgs = [params].concat(eventArgs);
	                if (actualEvtSelector.apply(this, fnArgs)) {
	                    handler.apply(this, fnArgs);
	                }
	            });
	        };
	        function createEventSelectorFn(eventSelector) {
	            if (!eventSelector) {
	                return function (publisher) { return true; };
	            }
	            else if (isEventSelectorFunc(eventSelector)) {
	                return eventSelector;
	            }
	            else {
	                // shorthand for subscriber to only receive events from a specific publisher instance
	                return function (publisher) { return publisher === eventSelector; };
	            }
	        }
	        function isEventSelectorFunc(val) {
	            return typeof val === 'function';
	        }
	        function isScopeLike(val) {
	            return val && typeof val.$new === 'function';
	        }
	    };
	    NgTableEventsChannel.$inject = ['$rootScope'];
	    return NgTableEventsChannel;
	}());
	exports.NgTableEventsChannel = NgTableEventsChannel;
	
	
	/***/ },
	/* 9 */
	/* unknown exports provided */
	/* all exports used */
	/*!***********************************!*\
	  !*** ./src/core/ngTableParams.ts ***!
	  \***********************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	"use strict";
	var ng1 = __webpack_require__(/*! angular */ 0);
	var util_1 = __webpack_require__(/*! ./util */ 11);
	/**
	 * @private
	 */
	function isNumber(n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	}
	/**
	 * Parameters manager for an ngTable directive
	 */
	var NgTableParams = (function () {
	    function NgTableParams(baseParameters, baseSettings) {
	        var _this = this;
	        /**
	         * The page of data rows currently being displayed in the table
	         */
	        this.data = [];
	        this.defaultSettings = NgTableParams.ngTableSettings.createDefaults();
	        this.isCommittedDataset = false;
	        this.initialEvents = [];
	        this._params = {
	            page: 1,
	            count: 10,
	            filter: {},
	            sorting: {},
	            group: {}
	        };
	        this._settings = this.defaultSettings;
	        // the ngTableController "needs" to create a dummy/null instance and it's important to know whether an instance
	        // is one of these
	        if (typeof baseParameters === "boolean") {
	            this.isNullInstance = true;
	        }
	        this.reloadPages = (function () {
	            var currentPages;
	            return function () {
	                var oldPages = currentPages;
	                var newPages = _this.generatePagesArray(_this.page(), _this.total(), _this.count());
	                if (!ng1.equals(oldPages, newPages)) {
	                    currentPages = newPages;
	                    NgTableParams.ngTableEventsChannel.publishPagesChanged(_this, newPages, oldPages);
	                }
	            };
	        })();
	        ng1.extend(this._params, NgTableParams.ngTableDefaults.params);
	        this.settings(baseSettings);
	        this.parameters(baseParameters, true);
	        NgTableParams.ngTableEventsChannel.publishAfterCreated(this);
	        // run events during construction after the initial create event. That way a consumer
	        // can subscribe to all events for a table without "dropping" an event
	        ng1.forEach(this.initialEvents, function (event) {
	            event();
	        });
	        this.initialEvents = null;
	    }
	    NgTableParams.prototype.count = function (count) {
	        // reset to first page because can be blank page
	        return count !== undefined ? this.parameters({
	            'count': count,
	            'page': 1
	        }) : this._params.count;
	    };
	    NgTableParams.prototype.filter = function (filter) {
	        if (filter != null && typeof filter === 'object') {
	            return this.parameters({
	                'filter': filter,
	                'page': 1
	            });
	        }
	        else if (filter === true) {
	            var keys = Object.keys(this._params.filter);
	            var significantFilter = {};
	            for (var i = 0; i < keys.length; i++) {
	                var filterValue = this._params.filter[keys[i]];
	                if (filterValue != null && filterValue !== '') {
	                    significantFilter[keys[i]] = filterValue;
	                }
	            }
	            return significantFilter;
	        }
	        else {
	            return this._params.filter;
	        }
	    };
	    /**
	     * Generate array of pages.
	     * When no arguments supplied, the current parameter state of this `NgTableParams` instance will be used
	     * @param currentPage Which page must be active
	     * @param totalItems  Total quantity of items
	     * @param pageSize    Quantity of items on page
	     * @param maxBlocks   Quantity of blocks for pagination
	     * @returns Array of pages
	     */
	    NgTableParams.prototype.generatePagesArray = function (currentPage, totalItems, pageSize, maxBlocks) {
	        if (!arguments.length) {
	            currentPage = this.page();
	            totalItems = this.total();
	            pageSize = this.count();
	        }
	        var maxPage, maxPivotPages, minPage, numPages;
	        maxBlocks = maxBlocks && maxBlocks < 6 ? 6 : maxBlocks;
	        var pages = [];
	        numPages = Math.ceil(totalItems / pageSize);
	        if (numPages > 1) {
	            pages.push({
	                type: 'prev',
	                number: Math.max(1, currentPage - 1),
	                active: currentPage > 1
	            });
	            pages.push({
	                type: 'first',
	                number: 1,
	                active: currentPage > 1,
	                current: currentPage === 1
	            });
	            maxPivotPages = Math.round((this._settings.paginationMaxBlocks - this._settings.paginationMinBlocks) / 2);
	            minPage = Math.max(2, currentPage - maxPivotPages);
	            maxPage = Math.min(numPages - 1, currentPage + maxPivotPages * 2 - (currentPage - minPage));
	            minPage = Math.max(2, minPage - (maxPivotPages * 2 - (maxPage - minPage)));
	            var i = minPage;
	            while (i <= maxPage) {
	                if ((i === minPage && i !== 2) || (i === maxPage && i !== numPages - 1)) {
	                    pages.push({
	                        type: 'more',
	                        active: false
	                    });
	                }
	                else {
	                    pages.push({
	                        type: 'page',
	                        number: i,
	                        active: currentPage !== i,
	                        current: currentPage === i
	                    });
	                }
	                i++;
	            }
	            pages.push({
	                type: 'last',
	                number: numPages,
	                active: currentPage !== numPages,
	                current: currentPage === numPages
	            });
	            pages.push({
	                type: 'next',
	                number: Math.min(numPages, currentPage + 1),
	                active: currentPage < numPages
	            });
	        }
	        return pages;
	    };
	    NgTableParams.prototype.group = function (group, sortDirection) {
	        if (group === undefined) {
	            return this._params.group;
	        }
	        var newParameters = {
	            page: 1
	        };
	        if (util_1.isGroupingFun(group) && sortDirection !== undefined) {
	            group.sortDirection = sortDirection;
	            newParameters.group = group;
	        }
	        else if (typeof group === 'string' && sortDirection !== undefined) {
	            newParameters.group = (_a = {}, _a[group] = sortDirection, _a);
	        }
	        else {
	            newParameters.group = group;
	        }
	        this.parameters(newParameters);
	        return this;
	        var _a;
	    };
	    /**
	     * Returns true when an attempt to `reload` the current `parameter` values have resulted in a failure.
	     * This method will continue to return true until the `reload` is successfully called or when the
	     * `parameter` values have changed
	     */
	    NgTableParams.prototype.hasErrorState = function () {
	        return !!(this.errParamsMemento && ng1.equals(this.errParamsMemento, this.createComparableParams()));
	    };
	    /**
	     * Returns true if `filter` has significant filter value(s) (any value except null, undefined, or empty string),
	     * otherwise false
	     */
	    NgTableParams.prototype.hasFilter = function () {
	        return Object.keys(this.filter(true)).length > 0;
	    };
	    /**
	     * Return true when a change to `filters` require the `reload` method
	     * to be run so as to ensure the data presented to the user reflects these filters
	     */
	    NgTableParams.prototype.hasFilterChanges = function () {
	        var previousFilter = (this.prevParamsMemento && this.prevParamsMemento.params.filter);
	        return !ng1.equals((this._params.filter), previousFilter) || this.hasGlobalSearchFieldChanges();
	    };
	    NgTableParams.prototype.hasGroup = function (group, sortDirection) {
	        if (group == null) {
	            return util_1.isGroupingFun(this._params.group) || Object.keys(this._params.group).length > 0;
	        }
	        if (util_1.isGroupingFun(group)) {
	            if (sortDirection == null) {
	                return this._params.group === group;
	            }
	            else {
	                return this._params.group === group && group.sortDirection === sortDirection;
	            }
	        }
	        else {
	            if (sortDirection == null) {
	                return Object.keys(this._params.group).indexOf(group) !== -1;
	            }
	            else {
	                return this._params.group[group] === sortDirection;
	            }
	        }
	    };
	    /**
	     * Return true when a change to this instance should require the `reload` method
	     * to be run so as to ensure the data rows presented to the user reflects the current state.
	     *
	     * Note that this method will return false when the `reload` method has run but fails. In this case
	     * `hasErrorState` will return true.
	     *
	     * The built-in `ngTable` directives will watch for when this function returns true and will then call
	     * the `reload` method to load its data rows
	     */
	    NgTableParams.prototype.isDataReloadRequired = function () {
	        // note: using != as want to treat null and undefined the same
	        return !this.isCommittedDataset || !ng1.equals(this.createComparableParams(), this.prevParamsMemento)
	            || this.hasGlobalSearchFieldChanges();
	    };
	    /**
	     * Returns true if sorting by the field supplied. Where direction supplied
	     * the field must also be sorted by that direction to return true
	     */
	    NgTableParams.prototype.isSortBy = function (field, direction) {
	        if (direction !== undefined) {
	            return this._params.sorting[field] !== undefined && this._params.sorting[field] == direction;
	        }
	        else {
	            return this._params.sorting[field] !== undefined;
	        }
	    };
	    /**
	     * Returns sorting values in a format that can be consumed by the angular `$orderBy` filter service
	     */
	    NgTableParams.prototype.orderBy = function () {
	        return util_1.convertSortToOrderBy(this._params.sorting);
	    };
	    NgTableParams.prototype.page = function (page) {
	        return page !== undefined ? this.parameters({
	            'page': page
	        }) : this._params.page;
	    };
	    NgTableParams.prototype.parameters = function (newParameters, parseParamsFromUrl) {
	        parseParamsFromUrl = parseParamsFromUrl || false;
	        if (typeof newParameters !== undefined) {
	            for (var key in newParameters) {
	                var value = newParameters[key];
	                if (parseParamsFromUrl && key.indexOf('[') >= 0) {
	                    var keys = key.split(/\[(.*)\]/).reverse();
	                    var lastKey = '';
	                    for (var i = 0, len = keys.length; i < len; i++) {
	                        var name = keys[i];
	                        if (name !== '') {
	                            var v = value;
	                            value = {};
	                            value[lastKey = name] = (isNumber(v) ? parseFloat(v) : v);
	                        }
	                    }
	                    if (lastKey === 'sorting') {
	                        this._params[lastKey] = {};
	                    }
	                    this._params[lastKey] = ng1.extend(this._params[lastKey] || {}, value[lastKey]);
	                }
	                else {
	                    if (key === 'group') {
	                        this._params[key] = this.parseGroup(newParameters[key]);
	                    }
	                    else {
	                        this._params[key] = (isNumber(newParameters[key]) ? parseFloat(newParameters[key]) : newParameters[key]);
	                    }
	                }
	            }
	            this.log('ngTable: set parameters', this._params);
	            return this;
	        }
	        return this._params;
	    };
	    /**
	     * Trigger a reload of the data rows
	     */
	    NgTableParams.prototype.reload = function () {
	        var _this = this;
	        var pData = null;
	        this._settings.$loading = true;
	        this.prevParamsMemento = ng1.copy(this.createComparableParams());
	        this.isCommittedDataset = true;
	        if (this.hasGroup()) {
	            pData = this.runInterceptorPipeline(NgTableParams.$q.when(this._settings.getGroups(this)));
	        }
	        else {
	            var fn = this._settings.getData;
	            pData = this.runInterceptorPipeline(NgTableParams.$q.when(fn(this)));
	        }
	        this.log('ngTable: reload data');
	        var oldData = this.data;
	        return pData.then(function (data) {
	            _this._settings.$loading = false;
	            _this.errParamsMemento = null;
	            _this.data = data;
	            // note: I think it makes sense to publish this event even when data === oldData
	            // subscribers can always set a filter to only receive the event when data !== oldData
	            NgTableParams.ngTableEventsChannel.publishAfterReloadData(_this, data, oldData);
	            _this.reloadPages();
	            return data;
	        }).catch(function (reason) {
	            _this.errParamsMemento = _this.prevParamsMemento;
	            // "rethrow"
	            return NgTableParams.$q.reject(reason);
	        });
	    };
	    NgTableParams.prototype.settings = function (newSettings) {
	        var _this = this;
	        if (ng1.isDefined(newSettings)) {
	            var settings = NgTableParams.ngTableSettings.merge(this._settings, newSettings);
	            var originalDataset_1 = this._settings.dataset;
	            this._settings = settings;
	            // note: using != as want null and undefined to be treated the same
	            var hasDatasetChanged = newSettings.hasOwnProperty('dataset') && (newSettings.dataset != originalDataset_1);
	            if (hasDatasetChanged) {
	                if (this.isCommittedDataset) {
	                    this.page(1); // reset page as a new dataset has been supplied
	                }
	                this.isCommittedDataset = false;
	                var fireEvent = function () {
	                    NgTableParams.ngTableEventsChannel.publishDatasetChanged(_this, newSettings.dataset, originalDataset_1);
	                };
	                if (this.initialEvents) {
	                    this.initialEvents.push(fireEvent);
	                }
	                else {
	                    fireEvent();
	                }
	            }
	            this.log('ngTable: set settings', this._settings);
	            return this;
	        }
	        return this._settings;
	    };
	    NgTableParams.prototype.sorting = function (sorting, direction) {
	        if (typeof sorting === 'string') {
	            this.parameters({
	                'sorting': (_a = {}, _a[sorting] = direction, _a)
	            });
	            return this;
	        }
	        return sorting !== undefined ? this.parameters({
	            'sorting': sorting
	        }) : this._params.sorting;
	        var _a;
	    };
	    NgTableParams.prototype.total = function (total) {
	        return total !== undefined ? this.settings({
	            'total': total
	        }) : this._settings.total;
	    };
	    /**
	     * Returns the current parameter values uri-encoded. Set `asString` to
	     * true for the parameters to be returned as an array of strings of the form 'paramName=value'
	     * otherwise parameters returned as a key-value object
	     */
	    NgTableParams.prototype.url = function (asString) {
	        // this function is an example of Typescript gone bad!!
	        asString = asString || false;
	        var pairs = (asString ? [] : {});
	        for (var key in this._params) {
	            if (this._params.hasOwnProperty(key)) {
	                var item = this._params[key], name = encodeURIComponent(key);
	                if (typeof item === "object") {
	                    for (var subkey in item) {
	                        if (isSignificantValue(item[subkey], key)) {
	                            var pname = name + "[" + encodeURIComponent(subkey) + "]";
	                            collectValue(item[subkey], pname);
	                        }
	                    }
	                }
	                else if (!ng1.isFunction(item) && isSignificantValue(item, key)) {
	                    collectValue(item, name);
	                }
	            }
	        }
	        return pairs;
	        function collectValue(value, key) {
	            if (isArray(pairs)) {
	                pairs.push(key + "=" + encodeURIComponent(value));
	            }
	            else {
	                pairs[key] = encodeURIComponent(value);
	            }
	        }
	        function isArray(pairs) {
	            return asString;
	        }
	        function isSignificantValue(value, key) {
	            return key === "group" ? true : typeof value !== undefined && value !== "";
	        }
	    };
	    NgTableParams.prototype.createComparableParams = function () {
	        var group = this._params.group;
	        return {
	            params: this._params,
	            groupSortDirection: util_1.isGroupingFun(group) ? group.sortDirection : undefined
	        };
	    };
	    NgTableParams.prototype.hasGlobalSearchFieldChanges = function () {
	        var currentVal = (this._params.filter && this._params.filter['$']);
	        var previousVal = (this.prevParamsMemento && this.prevParamsMemento.params.filter && this.prevParamsMemento.params.filter['$']);
	        return !ng1.equals(currentVal, previousVal);
	    };
	    NgTableParams.prototype.log = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i - 0] = arguments[_i];
	        }
	        if (this._settings.debugMode && NgTableParams.$log.debug) {
	            (_a = NgTableParams.$log).debug.apply(_a, args);
	        }
	        var _a;
	    };
	    NgTableParams.prototype.parseGroup = function (group) {
	        var defaultSort = this._settings.groupOptions && this._settings.groupOptions.defaultSort;
	        if (!group) {
	            return group;
	        }
	        else if (util_1.isGroupingFun(group)) {
	            if (group.sortDirection == null) {
	                group.sortDirection = defaultSort;
	            }
	            return group;
	        }
	        else if (typeof group === 'object') {
	            for (var key in group) {
	                if (group[key] == null) {
	                    group[key] = defaultSort;
	                }
	            }
	            return group;
	        }
	        else {
	            return (_a = {},
	                _a[group] = defaultSort,
	                _a
	            );
	        }
	        var _a;
	    };
	    NgTableParams.prototype.runInterceptorPipeline = function (fetchedData) {
	        var _this = this;
	        var interceptors = this._settings.interceptors || [];
	        return interceptors.reduce(function (result, interceptor) {
	            var thenFn = (interceptor.response && interceptor.response.bind(interceptor)) || NgTableParams.$q.when;
	            var rejectFn = (interceptor.responseError && interceptor.responseError.bind(interceptor)) || NgTableParams.$q.reject;
	            return result.then(function (data) {
	                return thenFn(data, _this);
	            }, function (reason) {
	                return rejectFn(reason, _this);
	            });
	        }, fetchedData);
	    };
	    NgTableParams.init = function ($q, $log, ngTableDefaults, ngTableEventsChannel, ngTableSettings) {
	        NgTableParams.$q = $q;
	        NgTableParams.$log = $log;
	        NgTableParams.ngTableDefaults = ngTableDefaults;
	        NgTableParams.ngTableEventsChannel = ngTableEventsChannel;
	        NgTableParams.ngTableSettings = ngTableSettings;
	    };
	    return NgTableParams;
	}());
	exports.NgTableParams = NgTableParams;
	NgTableParams.init.$inject = ['$q', '$log', 'ngTableDefaults', 'ngTableEventsChannel', 'ngTableSettings'];
	
	
	/***/ },
	/* 10 */
	/* unknown exports provided */
	/* all exports used */
	/*!*************************************!*\
	  !*** ./src/core/ngTableSettings.ts ***!
	  \*************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	var ng1 = __webpack_require__(/*! angular */ 0);
	/**
	 * @private
	 */
	var NgTableSettings = (function () {
	    function NgTableSettings(ngTableDefaults, ngTableDefaultGetData, ngTableDefaultGetGroups) {
	        var _this = this;
	        this.ngTableDefaults = ngTableDefaults;
	        this.ngTableDefaultGetData = ngTableDefaultGetData;
	        this.ngTableDefaultGetGroups = ngTableDefaultGetGroups;
	        this.defaults = {
	            $loading: false,
	            dataset: null,
	            total: 0,
	            defaultSort: 'desc',
	            counts: [10, 25, 50, 100],
	            filterOptions: {
	                filterComparator: undefined,
	                filterDelay: 500,
	                filterDelayThreshold: 10000,
	                filterFilterName: undefined,
	                filterFn: undefined,
	                filterLayout: 'stack'
	            },
	            getData: function (params) {
	                return _this.ngTableDefaultGetData(params.settings().dataset, params);
	            },
	            getGroups: this.ngTableDefaultGetGroups,
	            groupOptions: {
	                defaultSort: 'asc',
	                isExpanded: true
	            },
	            interceptors: [],
	            paginationMaxBlocks: 11,
	            paginationMinBlocks: 5,
	            sortingIndicator: 'span'
	        };
	    }
	    NgTableSettings.prototype.createDefaults = function () {
	        return this.merge(this.defaults, this.ngTableDefaults.settings);
	    };
	    NgTableSettings.prototype.merge = function (existing, newSettings) {
	        newSettings = ng1.extend({}, newSettings);
	        if (newSettings.filterOptions) {
	            newSettings.filterOptions = ng1.extend({}, existing.filterOptions || {}, newSettings.filterOptions);
	        }
	        if (newSettings.groupOptions) {
	            newSettings.groupOptions = ng1.extend({}, existing.groupOptions || {}, newSettings.groupOptions);
	        }
	        if (ng1.isArray(newSettings.dataset)) {
	            //auto-set the total from passed in dataset
	            newSettings.total = newSettings.dataset.length;
	        }
	        var results = ng1.extend({}, existing, newSettings);
	        if (ng1.isArray(newSettings.dataset)) {
	            this.optimizeFilterDelay(results);
	        }
	        return ng1.extend({}, existing, newSettings);
	    };
	    NgTableSettings.prototype.optimizeFilterDelay = function (settings) {
	        // don't debounce by default filter input when working with small synchronous datasets
	        if (settings.filterOptions.filterDelay === this.defaults.filterOptions.filterDelay &&
	            settings.total <= settings.filterOptions.filterDelayThreshold &&
	            settings.getData === this.defaults.getData) {
	            settings.filterOptions.filterDelay = 0;
	        }
	    };
	    NgTableSettings.$inject = ['ngTableDefaults', 'ngTableDefaultGetData', 'ngTableDefaultGetGroups'];
	    return NgTableSettings;
	}());
	exports.NgTableSettings = NgTableSettings;
	
	
	/***/ },
	/* 11 */
	/* unknown exports provided */
	/* all exports used */
	/*!**************************!*\
	  !*** ./src/core/util.ts ***!
	  \**************************/
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	/**
	 * @private
	 */
	function convertSortToOrderBy(sorting) {
	    var result = [];
	    for (var column in sorting) {
	        result.push((sorting[column] === "asc" ? "+" : "-") + column);
	    }
	    return result;
	}
	exports.convertSortToOrderBy = convertSortToOrderBy;
	/**
	 * @private
	 */
	function isGroupingFun(val) {
	    return typeof val === 'function';
	}
	exports.isGroupingFun = isGroupingFun;
	
	
	/***/ },
	/* 12 */,
	/* 13 */
	/* unknown exports provided */
	/* all exports used */
	/*!******************************************!*\
	  !*** ./src/browser/ngTable.directive.ts ***!
	  \******************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	var ng1 = __webpack_require__(/*! angular */ 0);
	ngTable.$inject = ['$q', '$parse'];
	/**
	 * Directive that instantiates {@link NgTableController NgTableController}.
	 * @ngdoc directive
	 * @name ngTable
	 * @example
	 *
	 * ```html
	 * <table ng-table="$ctrl.tableParams" show-filter="true" class="table table-bordered">
	 *  <tr ng-repeat="user in $data">
	 *      <td data-title="'Name'" sortable="'name'" filter="{ 'name': 'text' }">
	 *          {{user.name}}
	 *      </td>
	 *      <td data-title="'Age'" sortable="'age'" filter="{ 'age': 'text' }">
	 *          {{user.age}}
	 *      </td>
	 *  </tr>
	 * </table>
	 * ```
	 */
	function ngTable($q, $parse) {
	    return {
	        restrict: 'A',
	        priority: 1001,
	        scope: true,
	        controller: 'ngTableController',
	        compile: function (element) {
	            var columns = [], i = 0, dataRow, groupRow;
	            var rows = [];
	            ng1.forEach(element.find('tr'), function (tr) {
	                rows.push(ng1.element(tr));
	            });
	            dataRow = rows.filter(function (tr) { return !tr.hasClass('ng-table-group'); })[0];
	            groupRow = rows.filter(function (tr) { return tr.hasClass('ng-table-group'); })[0];
	            if (!dataRow) {
	                return undefined;
	            }
	            ng1.forEach(dataRow.find('td'), function (item) {
	                var el = ng1.element(item);
	                if (el.attr('ignore-cell') && 'true' === el.attr('ignore-cell')) {
	                    return;
	                }
	                var getAttrValue = function (attr) {
	                    return el.attr('x-data-' + attr) || el.attr('data-' + attr) || el.attr(attr);
	                };
	                var setAttrValue = function (attr, value) {
	                    if (el.attr('x-data-' + attr)) {
	                        el.attr('x-data-' + attr, value);
	                    }
	                    else if (el.attr('data' + attr)) {
	                        el.attr('data' + attr, value);
	                    }
	                    else {
	                        el.attr(attr, value);
	                    }
	                };
	                var parsedAttribute = function (attr) {
	                    var expr = getAttrValue(attr);
	                    if (!expr) {
	                        return undefined;
	                    }
	                    var localValue;
	                    var getter = function (context) {
	                        if (localValue !== undefined) {
	                            return localValue;
	                        }
	                        return $parse(expr)(context);
	                    };
	                    getter.assign = function ($scope, value) {
	                        var parsedExpr = $parse(expr);
	                        if (parsedExpr.assign) {
	                            // we should be writing back to the parent scope as this is where the expression
	                            // came from
	                            parsedExpr.assign($scope.$parent, value);
	                        }
	                        else {
	                            localValue = value;
	                        }
	                    };
	                    return getter;
	                };
	                var titleExpr = getAttrValue('title-alt') || getAttrValue('title');
	                if (titleExpr) {
	                    el.attr('data-title-text', '{{' + titleExpr + '}}'); // this used in responsive table
	                }
	                // NOTE TO MAINTAINERS: if you add extra fields to a $column be sure to extend ngTableColumn with
	                // a corresponding "safe" default
	                columns.push({
	                    id: i++,
	                    title: parsedAttribute('title'),
	                    titleAlt: parsedAttribute('title-alt'),
	                    headerTitle: parsedAttribute('header-title'),
	                    sortable: parsedAttribute('sortable'),
	                    'class': parsedAttribute('header-class'),
	                    filter: parsedAttribute('filter'),
	                    groupable: parsedAttribute('groupable'),
	                    headerTemplateURL: parsedAttribute('header'),
	                    filterData: parsedAttribute('filter-data'),
	                    show: el.attr("ng-if") ? parsedAttribute('ng-if') : undefined
	                });
	                if (groupRow || el.attr("ng-if")) {
	                    // change ng-if to bind to our column definition which we know will be writable
	                    // because this will potentially increase the $watch count, only do so if we already have an
	                    // ng-if or when we definitely need to change visibility of the columns.
	                    // currently only ngTableGroupRow directive needs to change visibility
	                    setAttrValue('ng-if', '$columns[' + (columns.length - 1) + '].show(this)');
	                }
	            });
	            return function (scope, element, attrs, controller) {
	                scope.$columns = columns = controller.buildColumns(columns);
	                controller.setupBindingsToInternalScope(attrs.ngTable);
	                controller.loadFilterData(columns);
	                controller.compileDirectiveTemplates();
	            };
	        }
	    };
	}
	exports.ngTable = ngTable;
	
	
	/***/ },
	/* 14 */
	/* unknown exports provided */
	/* all exports used */
	/*!**************************************!*\
	  !*** ./src/browser/ngTableColumn.ts ***!
	  \**************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	"use strict";
	var ng1 = __webpack_require__(/*! angular */ 0);
	/**
	 * @private
	 */
	function isScopeLike(object) {
	    return object != null && ng1.isFunction(object.$new);
	}
	/**
	 * @private
	 * Service to construct a $column definition used by {@link ngTable ngTable} directive
	 */
	var NgTableColumn = (function () {
	    function NgTableColumn() {
	    }
	    /**
	     * Creates a $column for use within a header template
	     *
	     * @param column the initial definition for $column to build
	     * @param defaultScope the $scope to supply to the $column getter methods when not supplied by caller
	     * @param columns a reference to the $columns array to make available on the context supplied to the
	     * $column getter methods
	     */
	    NgTableColumn.prototype.buildColumn = function (column, defaultScope, columns) {
	        // note: we're not modifying the original column object. This helps to avoid unintended side affects
	        var extendedCol = Object.create(column);
	        var defaults = this.createDefaults();
	        var _loop_1 = function(prop) {
	            if (extendedCol[prop] === undefined) {
	                extendedCol[prop] = defaults[prop];
	            }
	            if (!ng1.isFunction(extendedCol[prop])) {
	                // wrap raw field values with "getter" functions
	                // - this is to ensure consistency with how ngTable.compile builds columns
	                // - note that the original column object is being "proxied"; this is important
	                //   as it ensure that any changes to the original object will be returned by the "getter"
	                var getterSetter = function getterSetter() {
	                    if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                        getterSetter.assign(null, arguments[0]);
	                    }
	                    else {
	                        return column[prop];
	                    }
	                };
	                getterSetter.assign = function ($scope, value) {
	                    column[prop] = value;
	                };
	                extendedCol[prop] = getterSetter;
	            }
	            // satisfy the arguments expected by the function returned by parsedAttribute in the ngTable directive
	            var getterFn = extendedCol[prop];
	            extendedCol[prop] = function () {
	                if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                    getterFn.assign(defaultScope, arguments[0]);
	                }
	                else {
	                    var scope = arguments[0] || defaultScope;
	                    var context = Object.create(scope);
	                    ng1.extend(context, {
	                        $column: extendedCol,
	                        $columns: columns
	                    });
	                    return getterFn.call(column, context);
	                }
	            };
	            if (getterFn.assign) {
	                extendedCol[prop].assign = getterFn.assign;
	            }
	            else {
	                var wrappedGetterFn_1 = extendedCol[prop];
	                var localValue_1;
	                var getterSetter = function getterSetter() {
	                    if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                        getterSetter.assign(null, arguments[0]);
	                    }
	                    else {
	                        return localValue_1 != undefined ? localValue_1 : wrappedGetterFn_1.apply(extendedCol, arguments);
	                    }
	                };
	                getterSetter.assign = function ($scope, value) {
	                    localValue_1 = value;
	                };
	                extendedCol[prop] = getterSetter;
	            }
	        };
	        for (var prop in defaults) {
	            _loop_1(prop);
	        }
	        return extendedCol;
	    };
	    NgTableColumn.prototype.createDefaults = function () {
	        return {
	            'class': this.createGetterSetter(''),
	            filter: this.createGetterSetter(false),
	            groupable: this.createGetterSetter(false),
	            filterData: ng1.noop,
	            headerTemplateURL: this.createGetterSetter(false),
	            headerTitle: this.createGetterSetter(''),
	            sortable: this.createGetterSetter(false),
	            show: this.createGetterSetter(true),
	            title: this.createGetterSetter(''),
	            titleAlt: this.createGetterSetter('')
	        };
	    };
	    NgTableColumn.prototype.createGetterSetter = function (initialValue) {
	        var value = initialValue;
	        var getterSetter = function getterSetter() {
	            if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                getterSetter.assign(null, arguments[0]);
	            }
	            else {
	                return value;
	            }
	        };
	        getterSetter.assign = function ($scope, newValue) {
	            value = newValue;
	        };
	        return getterSetter;
	    };
	    NgTableColumn.$inject = [];
	    return NgTableColumn;
	}());
	exports.NgTableColumn = NgTableColumn;
	
	
	/***/ },
	/* 15 */
	/* unknown exports provided */
	/* all exports used */
	/*!********************************************************!*\
	  !*** ./src/browser/ngTableColumnsBinding.directive.ts ***!
	  \********************************************************/
	/***/ function(module, exports) {
	
	"use strict";
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	"use strict";
	ngTableColumnsBinding.$inject = ["$parse"];
	/**
	 * One-way data binds the $columns array generated by ngTable/ngTableDynamic to the specified
	 * expression.
	 * This allows the $columns array created for the table to be accessed outside of the html table
	 * markup.
	 *
	 * @ngdoc directive
	 *
	 * @example
	 * ```html
	 * <table ng-table="$ctrl.tableParams" class="table" ng-table-columns-binding="$ctlr.tableColumns">
	 * ```
	 */
	function ngTableColumnsBinding($parse) {
	    var directive = {
	        restrict: 'A',
	        link: linkFn
	    };
	    return directive;
	    function linkFn($scope, $element, $attrs) {
	        var setter = $parse($attrs.ngTableColumnsBinding).assign;
	        if (setter) {
	            $scope.$watch('$columns', function (newColumns) {
	                var shallowClone = (newColumns || []).slice(0);
	                setter($scope, shallowClone);
	            });
	        }
	    }
	}
	exports.ngTableColumnsBinding = ngTableColumnsBinding;
	
	
	/***/ },
	/* 16 */
	/* unknown exports provided */
	/* all exports used */
	/*!******************************************!*\
	  !*** ./src/browser/ngTableController.ts ***!
	  \******************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	"use strict";
	var ng1 = __webpack_require__(/*! angular */ 0);
	var core_1 = __webpack_require__(/*! ../core */ 1);
	/**
	 * The controller for the {@link ngTable ngTable} and {@link ngTableDynamic ngTableDynamic} directives
	 */
	var NgTableController = (function () {
	    function NgTableController($scope, $timeout, $parse, $compile, $attrs, $element, $document, ngTableColumn, ngTableEventsChannel) {
	        this.$scope = $scope;
	        this.$parse = $parse;
	        this.$compile = $compile;
	        this.$attrs = $attrs;
	        this.$element = $element;
	        this.$document = $document;
	        this.ngTableColumn = ngTableColumn;
	        this.ngTableEventsChannel = ngTableEventsChannel;
	        var isFirstTimeLoad = true;
	        $scope.$filterRow = { disabled: false };
	        $scope.$loading = false;
	        // until such times as the directive uses an isolated scope, we need to ensure that the check for
	        // the params field only consults the "own properties" of the $scope. This is to avoid seeing the params
	        // field on a $scope higher up in the prototype chain
	        if (!$scope.hasOwnProperty("params")) {
	            $scope.params = new core_1.NgTableParams(true);
	        }
	        this.delayFilter = (function () {
	            var timer;
	            return function (callback, ms) {
	                $timeout.cancel(timer);
	                timer = $timeout(callback, ms);
	            };
	        })();
	        // watch for when a new NgTableParams is bound to the scope
	        // CRITICAL: the watch must be for reference and NOT value equality; this is because NgTableParams maintains
	        // the current data page as a field. Checking this for value equality would be terrible for performance
	        // and potentially cause an error if the items in that array has circular references
	        this.$scope.$watch('params', function (newParams, oldParams) {
	            if (newParams === oldParams || !newParams) {
	                return;
	            }
	            newParams.reload();
	        }, false);
	        this.subscribeToTableEvents();
	    }
	    Object.defineProperty(NgTableController.prototype, "hasVisibleFilterColumn", {
	        get: function () {
	            var _this = this;
	            if (!this.$scope.$columns)
	                return false;
	            return this.some(this.$scope.$columns, function ($column) {
	                return $column.show(_this.$scope) && !!$column.filter(_this.$scope);
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    NgTableController.prototype.onDataReloadStatusChange = function (newStatus /*, oldStatus*/) {
	        if (!newStatus || this.$scope.params.hasErrorState()) {
	            return;
	        }
	        var currentParams = this.$scope.params;
	        var filterOptions = currentParams.settings().filterOptions;
	        if (currentParams.hasFilterChanges()) {
	            var applyFilter = function () {
	                currentParams.page(1);
	                currentParams.reload();
	            };
	            if (filterOptions.filterDelay) {
	                this.delayFilter(applyFilter, filterOptions.filterDelay);
	            }
	            else {
	                applyFilter();
	            }
	        }
	        else {
	            currentParams.reload();
	        }
	    };
	    NgTableController.prototype.compileDirectiveTemplates = function () {
	        if (!this.$element.hasClass('ng-table')) {
	            this.$scope.templates = {
	                header: (this.$attrs.templateHeader ? this.$attrs.templateHeader : 'ng-table/header.html'),
	                pagination: (this.$attrs.templatePagination ? this.$attrs.templatePagination : 'ng-table/pager.html')
	            };
	            this.$element.addClass('ng-table');
	            var headerTemplate = null;
	            // $element.find('> thead').length === 0 doesn't work on jqlite
	            var theadFound_1 = false;
	            ng1.forEach(this.$element.children(), function (e) {
	                if (e.tagName === 'THEAD') {
	                    theadFound_1 = true;
	                }
	            });
	            if (!theadFound_1) {
	                headerTemplate = ng1.element('<thead ng-include="templates.header"></thead>', this.$document);
	                this.$element.prepend(headerTemplate);
	            }
	            var paginationTemplate = ng1.element('<div ng-table-pagination="params" template-url="templates.pagination"></div>', this.$document);
	            this.$element.after(paginationTemplate);
	            if (headerTemplate) {
	                this.$compile(headerTemplate)(this.$scope);
	            }
	            this.$compile(paginationTemplate)(this.$scope);
	        }
	    };
	    NgTableController.prototype.loadFilterData = function ($columns) {
	        var _this = this;
	        ng1.forEach($columns, function ($column) {
	            var result = $column.filterData(_this.$scope);
	            if (!result) {
	                delete $column.filterData;
	                return undefined;
	            }
	            if (isPromiseLike(result)) {
	                delete $column.filterData;
	                return result.then(function (data) {
	                    // our deferred can eventually return arrays, functions and objects
	                    if (!ng1.isArray(data) && !ng1.isFunction(data) && !ng1.isObject(data)) {
	                        // if none of the above was found - we just want an empty array
	                        data = [];
	                    }
	                    $column.data = data;
	                });
	            }
	            else {
	                return $column.data = result;
	            }
	        });
	        function isPromiseLike(val) {
	            return val && typeof val === 'object' && typeof val.then === 'function';
	        }
	    };
	    NgTableController.prototype.buildColumns = function (columns) {
	        var _this = this;
	        // todo: use strictNullChecks and remove guard clause
	        var result = [];
	        (columns || []).forEach(function (col) {
	            result.push(_this.ngTableColumn.buildColumn(col, _this.$scope, result));
	        });
	        return result;
	    };
	    NgTableController.prototype.parseNgTableDynamicExpr = function (attr) {
	        if (!attr || attr.indexOf(" with ") > -1) {
	            var parts = attr.split(/\s+with\s+/);
	            return {
	                tableParams: parts[0],
	                columns: parts[1]
	            };
	        }
	        else {
	            throw new Error('Parse error (expected example: ng-table-dynamic=\'tableParams with cols\')');
	        }
	    };
	    NgTableController.prototype.setupBindingsToInternalScope = function (tableParamsExpr) {
	        // note: this we're setting up watches to simulate angular's isolated scope bindings
	        var _this = this;
	        // note: is REALLY important to watch for a change to the ngTableParams *reference* rather than
	        // $watch for value equivalence. This is because ngTableParams references the current page of data as
	        // a field and it's important not to watch this
	        this.$scope.$watch(tableParamsExpr, function (params) {
	            if (params === undefined) {
	                return;
	            }
	            _this.$scope.params = params;
	        }, false);
	        this.setupFilterRowBindingsToInternalScope();
	        this.setupGroupRowBindingsToInternalScope();
	    };
	    NgTableController.prototype.setupFilterRowBindingsToInternalScope = function () {
	        var _this = this;
	        if (this.$attrs.showFilter) {
	            this.$scope.$parent.$watch(this.$attrs.showFilter, function (value) {
	                _this.$scope.show_filter = value;
	            });
	        }
	        else {
	            this.$scope.$watch(function () { return _this.hasVisibleFilterColumn; }, function (value) {
	                _this.$scope.show_filter = value;
	            });
	        }
	        if (this.$attrs.disableFilter) {
	            this.$scope.$parent.$watch(this.$attrs.disableFilter, function (value) {
	                _this.$scope.$filterRow.disabled = value;
	            });
	        }
	    };
	    NgTableController.prototype.setupGroupRowBindingsToInternalScope = function () {
	        var _this = this;
	        this.$scope.$groupRow = { show: false };
	        if (this.$attrs.showGroup) {
	            var showGroupGetter_1 = this.$parse(this.$attrs.showGroup);
	            this.$scope.$parent.$watch(showGroupGetter_1, function (value) {
	                _this.$scope.$groupRow.show = value;
	            });
	            if (showGroupGetter_1.assign) {
	                // setup two-way databinding thus allowing ngTableGrowRow to assign to the showGroup expression
	                this.$scope.$watch('$groupRow.show', function (value) {
	                    showGroupGetter_1.assign(_this.$scope.$parent, value);
	                });
	            }
	        }
	        else {
	            this.$scope.$watch('params.hasGroup()', function (newValue) {
	                _this.$scope.$groupRow.show = newValue;
	            });
	        }
	    };
	    NgTableController.prototype.getVisibleColumns = function () {
	        var _this = this;
	        return (this.$scope.$columns || []).filter(function (c) {
	            return c.show(_this.$scope);
	        });
	    };
	    NgTableController.prototype.subscribeToTableEvents = function () {
	        var _this = this;
	        this.$scope.$watch('params.isDataReloadRequired()', function (newStatus /*, oldStatus*/) {
	            _this.onDataReloadStatusChange(newStatus);
	        });
	        this.ngTableEventsChannel.onAfterReloadData(function (params, newDatapage) {
	            var visibleColumns = _this.getVisibleColumns();
	            if (params.hasGroup()) {
	                _this.$scope.$groups = (newDatapage || []);
	                _this.$scope.$groups.visibleColumnCount = visibleColumns.length;
	            }
	            else {
	                _this.$scope.$data = (newDatapage || []);
	                _this.$scope.$data.visibleColumnCount = visibleColumns.length;
	            }
	        }, this.$scope, function (publisher) { return _this.$scope.params === publisher; });
	        this.ngTableEventsChannel.onPagesChanged(function (params, newPages) {
	            _this.$scope.pages = newPages;
	        }, this.$scope, function (publisher) { return _this.$scope.params === publisher; });
	    };
	    NgTableController.prototype.some = function (array, predicate) {
	        var found = false;
	        for (var i = 0; i < array.length; i++) {
	            var obj = array[i];
	            if (predicate(obj)) {
	                found = true;
	                break;
	            }
	        }
	        return found;
	    };
	    NgTableController.$inject = [
	        '$scope', '$timeout', '$parse', '$compile', '$attrs', '$element', '$document', 'ngTableColumn', 'ngTableEventsChannel'
	    ];
	    return NgTableController;
	}());
	exports.NgTableController = NgTableController;
	
	
	/***/ },
	/* 17 */
	/* unknown exports provided */
	/* all exports used */
	/*!*************************************************!*\
	  !*** ./src/browser/ngTableDynamic.directive.ts ***!
	  \*************************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	"use strict";
	var ng1 = __webpack_require__(/*! angular */ 0);
	ngTableDynamic.$inject = [];
	/**
	 * A dynamic version of the {@link ngTable ngTable} directive that accepts a dynamic list of columns
	 * definitions to render
	 * @ngdoc directive
	 *
	 * @example
	 * ```html
	 * <table ng-table-dynamic="$ctrl.tableParams with $ctrl.cols" class="table">
	 *  <tr ng-repeat="row in $data">
	 *    <td ng-repeat="col in $columns">{{row[col.field]}}</td>
	 *  </tr>
	 * </table>
	 * ```
	 */
	function ngTableDynamic() {
	    return {
	        restrict: 'A',
	        priority: 1001,
	        scope: true,
	        controller: 'ngTableController',
	        compile: function (tElement) {
	            var row;
	            // IE 8 fix :not(.ng-table-group) selector
	            ng1.forEach(tElement.find('tr'), function (tr) {
	                tr = ng1.element(tr);
	                if (!tr.hasClass('ng-table-group') && !row) {
	                    row = tr;
	                }
	            });
	            if (!row) {
	                return undefined;
	            }
	            ng1.forEach(row.find('td'), function (item) {
	                var el = ng1.element(item);
	                var getAttrValue = function (attr) {
	                    return el.attr('x-data-' + attr) || el.attr('data-' + attr) || el.attr(attr);
	                };
	                // this used in responsive table
	                var titleExpr = getAttrValue('title');
	                if (!titleExpr) {
	                    el.attr('data-title-text', '{{$columns[$index].titleAlt(this) || $columns[$index].title(this)}}');
	                }
	                var showExpr = el.attr('ng-if');
	                if (!showExpr) {
	                    el.attr('ng-if', '$columns[$index].show(this)');
	                }
	            });
	            return function (scope, element, attrs, controller) {
	                var expr = controller.parseNgTableDynamicExpr(attrs.ngTableDynamic);
	                controller.setupBindingsToInternalScope(expr.tableParams);
	                controller.compileDirectiveTemplates();
	                scope.$watchCollection(expr.columns, function (newCols /*, oldCols*/) {
	                    scope.$columns = controller.buildColumns(newCols);
	                    controller.loadFilterData(scope.$columns);
	                });
	            };
	        }
	    };
	}
	exports.ngTableDynamic = ngTableDynamic;
	
	
	/***/ },
	/* 18 */
	/* unknown exports provided */
	/* all exports used */
	/*!********************************************!*\
	  !*** ./src/browser/ngTableFilterConfig.ts ***!
	  \********************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	"use strict";
	var ng1 = __webpack_require__(/*! angular */ 0);
	/**
	 * The angular provider used to configure the behaviour of the `NgTableFilterConfig` service.
	 */
	var NgTableFilterConfigProvider = (function () {
	    function NgTableFilterConfigProvider($injector) {
	        var _this = this;
	        this.defaultConfig = {
	            defaultBaseUrl: 'ng-table/filters/',
	            defaultExt: '.html',
	            aliasUrls: {}
	        };
	        this.$get = function () {
	            return $injector.instantiate(NgTableFilterConfig, { config: ng1.copy(_this.config) });
	        };
	        this.$get.$inject = [];
	        this.resetConfigs();
	    }
	    /**
	     * Reset back to factory defaults the config values that `NgTableFilterConfig` service will use
	     */
	    NgTableFilterConfigProvider.prototype.resetConfigs = function () {
	        this.config = this.defaultConfig;
	    };
	    /**
	     * Set the config values used by `NgTableFilterConfig` service
	     */
	    NgTableFilterConfigProvider.prototype.setConfig = function (customConfig) {
	        var mergeConfig = ng1.extend({}, this.config, customConfig);
	        mergeConfig.aliasUrls = ng1.extend({}, this.config.aliasUrls, customConfig.aliasUrls);
	        this.config = mergeConfig;
	    };
	    NgTableFilterConfigProvider.$inject = ['$injector'];
	    return NgTableFilterConfigProvider;
	}());
	exports.NgTableFilterConfigProvider = NgTableFilterConfigProvider;
	/**
	 * Exposes configuration values and methods used to return the location of the html
	 * templates used to render the filter row of an ng-table directive
	 */
	var NgTableFilterConfig = (function () {
	    function NgTableFilterConfig(
	        /**
	         * Readonly copy of the final values used to configure the service.
	         */
	        config) {
	        this.config = config;
	    }
	    /**
	     * Return the url of the html filter template registered with the alias supplied
	     */
	    NgTableFilterConfig.prototype.getUrlForAlias = function (aliasName, filterKey) {
	        return this.config.aliasUrls[aliasName] || this.config.defaultBaseUrl + aliasName + this.config.defaultExt;
	    };
	    /**
	     * Return the url of the html filter template for the supplied definition and key.
	     * For more information see the documentation for {@link IFilterTemplateMap}
	     */
	    NgTableFilterConfig.prototype.getTemplateUrl = function (filterDef, filterKey) {
	        var filterName;
	        if (typeof filterDef !== 'string') {
	            filterName = filterDef.id;
	        }
	        else {
	            filterName = filterDef;
	        }
	        if (filterName.indexOf('/') !== -1) {
	            return filterName;
	        }
	        return this.getUrlForAlias(filterName, filterKey);
	    };
	    NgTableFilterConfig.$inject = ['config'];
	    return NgTableFilterConfig;
	}());
	exports.NgTableFilterConfig = NgTableFilterConfig;
	
	
	/***/ },
	/* 19 */
	/* unknown exports provided */
	/* all exports used */
	/*!***************************************************!*\
	  !*** ./src/browser/ngTableFilterRow.directive.ts ***!
	  \***************************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	"use strict";
	var templateUrl = __webpack_require__(/*! ./filterRow.html */ 42);
	ngTableFilterRow.$inject = [];
	/**
	 * directive that renders the filter header row for a table
	 * @ngdoc directive
	 * @example
	 * ```html
	 * <ng-table-filter-row></ng-table-filter-row>
	 * ```
	 */
	function ngTableFilterRow() {
	    var directive = {
	        restrict: 'E',
	        replace: true,
	        templateUrl: templateUrl,
	        scope: true,
	        controller: 'ngTableFilterRowController',
	        controllerAs: '$ctrl'
	    };
	    return directive;
	}
	exports.ngTableFilterRow = ngTableFilterRow;
	
	
	/***/ },
	/* 20 */
	/* unknown exports provided */
	/* all exports used */
	/*!***************************************************!*\
	  !*** ./src/browser/ngTableFilterRowController.ts ***!
	  \***************************************************/
	/***/ function(module, exports) {
	
	"use strict";
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	"use strict";
	/**
	 * Controller for the {@link ngTableFilterRow ngTableFilterRow} directive
	 */
	var NgTableFilterRowController = (function () {
	    function NgTableFilterRowController($scope, ngTableFilterConfig) {
	        this.config = ngTableFilterConfig;
	        // todo: stop doing this. Why?
	        // * scope inheritance makes it hard to know how supplies functions
	        // * scope is not a concept in angular 2
	        // make function available to filter templates
	        $scope.getFilterPlaceholderValue = this.getFilterPlaceholderValue.bind(this);
	    }
	    NgTableFilterRowController.prototype.getFilterCellCss = function (filter, layout) {
	        if (layout !== 'horizontal') {
	            return 's12';
	        }
	        var size = Object.keys(filter).length;
	        var width = parseInt((12 / size).toString(), 10);
	        return 's' + width;
	    };
	    NgTableFilterRowController.prototype.getFilterPlaceholderValue = function (filterDef, filterKey) {
	        if (typeof filterDef === 'string') {
	            return '';
	        }
	        else {
	            return filterDef.placeholder;
	        }
	    };
	    NgTableFilterRowController.$inject = ['$scope', 'ngTableFilterConfig'];
	    return NgTableFilterRowController;
	}());
	exports.NgTableFilterRowController = NgTableFilterRowController;
	
	
	/***/ },
	/* 21 */
	/* unknown exports provided */
	/* all exports used */
	/*!**************************************************!*\
	  !*** ./src/browser/ngTableGroupRow.directive.ts ***!
	  \**************************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	"use strict";
	var templateUrl = __webpack_require__(/*! ./groupRow.html */ 47);
	ngTableGroupRow.$inject = [];
	/**
	 * directive that renders the group header row for a table
	 * @ngdoc directive
	 * @example
	 * ```html
	 * <ng-table-group-row></ng-table-group-row>
	 * ```
	 */
	function ngTableGroupRow() {
	    var directive = {
	        restrict: 'E',
	        replace: true,
	        templateUrl: templateUrl,
	        scope: true,
	        controller: 'ngTableGroupRowController',
	        controllerAs: '$ctrl'
	    };
	    return directive;
	}
	exports.ngTableGroupRow = ngTableGroupRow;
	
	
	/***/ },
	/* 22 */
	/* unknown exports provided */
	/* all exports used */
	/*!**************************************************!*\
	  !*** ./src/browser/ngTableGroupRowController.ts ***!
	  \**************************************************/
	/***/ function(module, exports) {
	
	"use strict";
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	"use strict";
	/**
	 * Controller for the {@link ngTableGroupRow ngTableGroupRow} directive
	 */
	var NgTableGroupRowController = (function () {
	    function NgTableGroupRowController($scope) {
	        var _this = this;
	        this.$scope = $scope;
	        this.groupFns = [];
	        $scope.$watch('params.group()', function (newGrouping) {
	            _this.setGroup(newGrouping);
	        }, true);
	    }
	    NgTableGroupRowController.prototype.getGroupables = function () {
	        var _this = this;
	        var groupableCols = this.$scope.$columns.filter(function ($column) { return !!$column.groupable(_this.$scope); });
	        return this.groupFns.concat(groupableCols);
	    };
	    NgTableGroupRowController.prototype.getGroupTitle = function (group) {
	        return this.isGroupingFunc(group) ? group.title : group.title(this.$scope);
	    };
	    NgTableGroupRowController.prototype.getVisibleColumns = function () {
	        var _this = this;
	        return this.$scope.$columns.filter(function ($column) { return $column.show(_this.$scope); });
	    };
	    NgTableGroupRowController.prototype.groupBy = function (group) {
	        if (this.isSelectedGroup(group)) {
	            this.changeSortDirection();
	        }
	        else {
	            if (this.isGroupingFunc(group)) {
	                this.$scope.params.group(group);
	            }
	            else {
	                // it's OK, we know that groupable will return a string
	                // this is guaranteed by getGroupables returning only
	                // columns that return (truthy) strings
	                this.$scope.params.group(group.groupable(this.$scope));
	            }
	        }
	    };
	    NgTableGroupRowController.prototype.isSelectedGroup = function (group) {
	        if (this.isGroupingFunc(group)) {
	            return group === this.$scope.$selGroup;
	        }
	        else {
	            return group.groupable(this.$scope) === this.$scope.$selGroup;
	        }
	    };
	    NgTableGroupRowController.prototype.toggleDetail = function () {
	        this.$scope.params.settings().groupOptions.isExpanded = !this.$scope.params.settings().groupOptions.isExpanded;
	        return this.$scope.params.reload();
	    };
	    NgTableGroupRowController.prototype.changeSortDirection = function () {
	        var newDirection;
	        if (this.$scope.params.hasGroup(this.$scope.$selGroup, 'asc')) {
	            newDirection = 'desc';
	        }
	        else if (this.$scope.params.hasGroup(this.$scope.$selGroup, 'desc')) {
	            newDirection = '';
	        }
	        else {
	            newDirection = 'asc';
	        }
	        this.$scope.params.group(this.$scope.$selGroup, newDirection);
	    };
	    NgTableGroupRowController.prototype.findGroupColumn = function (groupKey) {
	        var _this = this;
	        return this.$scope.$columns.filter(function ($column) { return $column.groupable(_this.$scope) === groupKey; })[0];
	    };
	    NgTableGroupRowController.prototype.isGroupingFunc = function (val) {
	        return typeof val === 'function';
	    };
	    NgTableGroupRowController.prototype.setGroup = function (grouping) {
	        var existingGroupCol = this.findGroupColumn(this.$scope.$selGroup);
	        if (existingGroupCol && existingGroupCol.show.assign) {
	            existingGroupCol.show.assign(this.$scope, true);
	        }
	        if (this.isGroupingFunc(grouping)) {
	            this.groupFns = [grouping];
	            this.$scope.$selGroup = grouping;
	            this.$scope.$selGroupTitle = grouping.title;
	        }
	        else {
	            // note: currently only one group is implemented
	            var groupKey = Object.keys(grouping || {})[0];
	            var groupedColumn = this.findGroupColumn(groupKey);
	            if (groupedColumn) {
	                this.$scope.$selGroupTitle = groupedColumn.title(this.$scope);
	                this.$scope.$selGroup = groupKey;
	                if (groupedColumn.show.assign) {
	                    groupedColumn.show.assign(this.$scope, false);
	                }
	            }
	        }
	    };
	    NgTableGroupRowController.$inject = ['$scope'];
	    return NgTableGroupRowController;
	}());
	exports.NgTableGroupRowController = NgTableGroupRowController;
	
	
	/***/ },
	/* 23 */
	/* unknown exports provided */
	/* all exports used */
	/*!****************************************************!*\
	  !*** ./src/browser/ngTablePagination.directive.ts ***!
	  \****************************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	"use strict";
	var ng1 = __webpack_require__(/*! angular */ 0);
	ngTablePagination.$inject = ['$compile', '$document', 'ngTableEventsChannel'];
	/**
	 * Directive that renders the table pagination controls
	 * @ngdoc directive
	 */
	function ngTablePagination($compile, $document, ngTableEventsChannel) {
	    return {
	        restrict: 'A',
	        scope: {
	            'params': '=ngTablePagination',
	            'templateUrl': '='
	        },
	        replace: false,
	        link: function (scope, element /*, attrs*/) {
	            ngTableEventsChannel.onAfterReloadData(function (pubParams) {
	                scope.pages = pubParams.generatePagesArray();
	            }, scope, function (pubParams) {
	                return pubParams === scope.params;
	            });
	            scope.$watch('templateUrl', function (templateUrl) {
	                if (templateUrl === undefined) {
	                    return;
	                }
	                var template = ng1.element('<div ng-include="templateUrl"></div>', $document);
	                element.append(template);
	                $compile(template)(scope);
	            });
	        }
	    };
	}
	exports.ngTablePagination = ngTablePagination;
	
	
	/***/ },
	/* 24 */
	/* unknown exports provided */
	/* all exports used */
	/*!********************************************************!*\
	  !*** ./src/browser/ngTableSelectFilterDs.directive.ts ***!
	  \********************************************************/
	/***/ function(module, exports) {
	
	"use strict";
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	"use strict";
	ngTableSelectFilterDs.$inject = [];
	/**
	 * Takes the array returned by $column.filterData and makes it available as `$selectData` on the `$scope`.
	 *
	 * The resulting `$selectData` array will contain an extra item that is suitable to represent the user
	 * "deselecting" an item from a `<select>` tag
	 *
	 * This directive is is focused on providing a datasource to an `ngOptions` directive
	 */
	function ngTableSelectFilterDs() {
	    // note: not using isolated or child scope "by design"
	    // this is to allow this directive to be combined with other directives that do
	    var directive = {
	        restrict: 'A',
	        controller: NgTableSelectFilterDsController
	    };
	    return directive;
	}
	exports.ngTableSelectFilterDs = ngTableSelectFilterDs;
	/**
	 * @private
	 */
	var NgTableSelectFilterDsController = (function () {
	    function NgTableSelectFilterDsController($scope, $parse, $attrs, $q) {
	        var _this = this;
	        this.$scope = $scope;
	        this.$attrs = $attrs;
	        this.$q = $q;
	        this.$column = $parse($attrs.ngTableSelectFilterDs)($scope);
	        $scope.$watch(function () { return _this.$column && _this.$column.data; }, function () { _this.bindDataSource(); });
	    }
	    NgTableSelectFilterDsController.prototype.bindDataSource = function () {
	        var _this = this;
	        this.getSelectListData(this.$column).then(function (data) {
	            if (data && !_this.hasEmptyOption(data)) {
	                data.unshift({ id: '', title: '' });
	            }
	            data = data || [];
	            _this.$scope.$selectData = data;
	        });
	    };
	    NgTableSelectFilterDsController.prototype.hasEmptyOption = function (data) {
	        var isMatch;
	        for (var i = 0; i < data.length; i++) {
	            var item = data[i];
	            if (item && item.id === '') {
	                isMatch = true;
	                break;
	            }
	        }
	        return isMatch;
	    };
	    NgTableSelectFilterDsController.prototype.getSelectListData = function ($column) {
	        var dataInput = $column.data;
	        if (dataInput instanceof Array) {
	            return this.$q.when(dataInput);
	        }
	        else {
	            return this.$q.when(dataInput && dataInput());
	        }
	    };
	    NgTableSelectFilterDsController.$inject = ['$scope', '$parse', '$attrs', '$q'];
	    return NgTableSelectFilterDsController;
	}());
	exports.NgTableSelectFilterDsController = NgTableSelectFilterDsController;
	
	
	/***/ },
	/* 25 */
	/* unknown exports provided */
	/* all exports used */
	/*!***************************************************!*\
	  !*** ./src/browser/ngTableSorterRow.directive.ts ***!
	  \***************************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	"use strict";
	var templateUrl = __webpack_require__(/*! ./sorterRow.html */ 50);
	ngTableSorterRow.$inject = [];
	/**
	 * directive that renders the sorting header row for a table
	 * @ngdoc directive
	 * @example
	 * ```html
	 * <ng-table-sorter-row></ng-table-sorter-row>
	 * ```
	 */
	function ngTableSorterRow() {
	    var directive = {
	        restrict: 'E',
	        replace: true,
	        templateUrl: templateUrl,
	        scope: true,
	        controller: 'ngTableSorterRowController',
	        controllerAs: '$ctrl'
	    };
	    return directive;
	}
	exports.ngTableSorterRow = ngTableSorterRow;
	
	
	/***/ },
	/* 26 */
	/* unknown exports provided */
	/* all exports used */
	/*!***************************************************!*\
	  !*** ./src/browser/ngTableSorterRowController.ts ***!
	  \***************************************************/
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	/**
	 * Controller for the {@link ngTableSorterRow ngTableSorterRow} directive
	 */
	var NgTableSorterRowController = (function () {
	    function NgTableSorterRowController($scope) {
	        this.$scope = $scope;
	    }
	    NgTableSorterRowController.prototype.sortBy = function ($column, event) {
	        var parsedSortable = $column.sortable && $column.sortable();
	        if (!parsedSortable || typeof parsedSortable !== 'string') {
	            return;
	        }
	        else {
	            var defaultSort = this.$scope.params.settings().defaultSort;
	            var inverseSort = (defaultSort === 'asc' ? 'desc' : 'asc');
	            var sorting = this.$scope.params.sorting() && this.$scope.params.sorting()[parsedSortable] && (this.$scope.params.sorting()[parsedSortable] === defaultSort);
	            var sortingParams = (event.ctrlKey || event.metaKey) ? this.$scope.params.sorting() : {};
	            sortingParams[parsedSortable] = (sorting ? inverseSort : defaultSort);
	            this.$scope.params.parameters({
	                sorting: sortingParams
	            });
	        }
	    };
	    NgTableSorterRowController.$inject = ['$scope'];
	    return NgTableSorterRowController;
	}());
	exports.NgTableSorterRowController = NgTableSorterRowController;
	
	
	/***/ },
	/* 27 */
	/* unknown exports provided */
	/* all exports used */
	/*!******************************************!*\
	  !*** ./src/browser/public-interfaces.ts ***!
	  \******************************************/
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	
	
	/***/ },
	/* 28 */
	/* unknown exports provided */
	/* all exports used */
	/*!***************************************!*\
	  !*** ./src/core/data/dataSettings.ts ***!
	  \***************************************/
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	
	
	/***/ },
	/* 29 */
	/* unknown exports provided */
	/* all exports used */
	/*!**********************************!*\
	  !*** ./src/core/data/getData.ts ***!
	  \**********************************/
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	
	
	/***/ },
	/* 30 */
	/* unknown exports provided */
	/* all exports used */
	/*!**************************************!*\
	  !*** ./src/core/data/interceptor.ts ***!
	  \**************************************/
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	
	
	/***/ },
	/* 31 */
	/* unknown exports provided */
	/* all exports used */
	/*!************************************************!*\
	  !*** ./src/core/data/ngTableDefaultGetData.ts ***!
	  \************************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	"use strict";
	var ng1 = __webpack_require__(/*! angular */ 0);
	/**
	 * Implementation of the {@link IDefaultGetDataProvider} interface
	 */
	var NgTableDefaultGetDataProvider = (function () {
	    function NgTableDefaultGetDataProvider() {
	        /**
	         * The name of a angular filter that knows how to apply the values returned by
	         * `NgTableParams.filter()` to restrict an array of data.
	         * (defaults to the angular `filter` filter service)
	         */
	        this.filterFilterName = 'filter';
	        /**
	         * The name of a angular filter that knows how to apply the values returned by
	        * `NgTableParams.orderBy()` to sort an array of data.
	        * (defaults to the angular `orderBy` filter service)
	        */
	        this.sortingFilterName = 'orderBy';
	        var provider = this;
	        this.$get = ngTableDefaultGetData;
	        ngTableDefaultGetData.$inject = ['$filter', 'ngTableEventsChannel'];
	        function ngTableDefaultGetData($filter, ngTableEventsChannel) {
	            var defaultDataOptions = { applyFilter: true, applySort: true, applyPaging: true };
	            getData.applyPaging = applyPaging;
	            getData.getFilterFn = getFilterFn;
	            getData.getOrderByFn = getOrderByFn;
	            return getData;
	            function getFilterFn(params) {
	                var filterOptions = params.settings().filterOptions;
	                if (ng1.isFunction(filterOptions.filterFn)) {
	                    return filterOptions.filterFn;
	                }
	                else {
	                    return $filter(filterOptions.filterFilterName || provider.filterFilterName);
	                }
	            }
	            function getOrderByFn(params) {
	                return $filter(provider.sortingFilterName);
	            }
	            function applyFilter(data, params) {
	                if (!params.hasFilter()) {
	                    return data;
	                }
	                var filter = params.filter(true);
	                var filterKeys = Object.keys(filter);
	                var parsedFilter = filterKeys.reduce(function (result, key) {
	                    result = setPath(result, filter[key], key);
	                    return result;
	                }, {});
	                var filterFn = getFilterFn(params);
	                return filterFn.call(params, data, parsedFilter, params.settings().filterOptions.filterComparator);
	            }
	            function applyPaging(data, params) {
	                var pagedData = data.slice((params.page() - 1) * params.count(), params.page() * params.count());
	                params.total(data.length); // set total for recalc pagination
	                return pagedData;
	            }
	            function applySort(data, params) {
	                var orderBy = params.orderBy();
	                var orderByFn = getOrderByFn(params);
	                return orderBy.length ? orderByFn(data, orderBy) : data;
	            }
	            function getData(data, params) {
	                if (data == null) {
	                    return [];
	                }
	                var options = ng1.extend({}, defaultDataOptions, params.settings().dataOptions);
	                var fData = options.applyFilter ? applyFilter(data, params) : data;
	                ngTableEventsChannel.publishAfterDataFiltered(params, fData);
	                var orderedData = options.applySort ? applySort(fData, params) : fData;
	                ngTableEventsChannel.publishAfterDataSorted(params, orderedData);
	                return options.applyPaging ? applyPaging(orderedData, params) : orderedData;
	            }
	            // Sets the value at any depth in a nested object based on the path
	            // note: adapted from: underscore-contrib#setPath
	            function setPath(obj, value, path) {
	                var keys = path.split('.');
	                var ret = obj;
	                var lastKey = keys[keys.length - 1];
	                var target = ret;
	                var parentPathKeys = keys.slice(0, keys.length - 1);
	                parentPathKeys.forEach(function (key) {
	                    if (!target.hasOwnProperty(key)) {
	                        target[key] = {};
	                    }
	                    target = target[key];
	                });
	                target[lastKey] = value;
	                return ret;
	            }
	        }
	    }
	    return NgTableDefaultGetDataProvider;
	}());
	exports.NgTableDefaultGetDataProvider = NgTableDefaultGetDataProvider;
	
	
	/***/ },
	/* 32 */
	/* unknown exports provided */
	/* all exports used */
	/*!**********************************!*\
	  !*** ./src/core/data/results.ts ***!
	  \**********************************/
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	
	
	/***/ },
	/* 33 */
	/* unknown exports provided */
	/* all exports used */
	/*!************************************************!*\
	  !*** ./src/core/filtering/filterComparator.ts ***!
	  \************************************************/
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	
	
	/***/ },
	/* 34 */
	/* unknown exports provided */
	/* all exports used */
	/*!******************************************!*\
	  !*** ./src/core/filtering/filterFunc.ts ***!
	  \******************************************/
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	
	
	/***/ },
	/* 35 */
	/* unknown exports provided */
	/* all exports used */
	/*!**********************************************!*\
	  !*** ./src/core/filtering/filterSettings.ts ***!
	  \**********************************************/
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	
	
	/***/ },
	/* 36 */
	/* unknown exports provided */
	/* all exports used */
	/*!*************************************!*\
	  !*** ./src/core/filtering/index.ts ***!
	  \*************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(/*! ./filterComparator */ 33));
	__export(__webpack_require__(/*! ./filterFunc */ 34));
	__export(__webpack_require__(/*! ./filterSettings */ 35));
	
	
	/***/ },
	/* 37 */
	/* unknown exports provided */
	/* all exports used */
	/*!************************************!*\
	  !*** ./src/core/grouping/index.ts ***!
	  \************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(/*! ./getGroup */ 4));
	__export(__webpack_require__(/*! ./groupingFunc */ 6));
	__export(__webpack_require__(/*! ./groupSettings */ 5));
	__export(__webpack_require__(/*! ./ngTableDefaultGetGroups */ 38));
	
	
	/***/ },
	/* 38 */
	/* unknown exports provided */
	/* all exports used */
	/*!******************************************************!*\
	  !*** ./src/core/grouping/ngTableDefaultGetGroups.ts ***!
	  \******************************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	var ng1 = __webpack_require__(/*! angular */ 0);
	var util_1 = __webpack_require__(/*! ../util */ 11);
	ngTableDefaultGetGroups.$inject = ['$q', 'ngTableDefaultGetData'];
	/**
	 * Implementation of the {@link IDefaultGetData IDefaultGetData} interface
	 *
	 * @ngdoc service
	 */
	function ngTableDefaultGetGroups($q, ngTableDefaultGetData) {
	    return getGroups;
	    function getGroups(params) {
	        var group = params.group();
	        var groupFn;
	        var sortDirection = undefined;
	        if (util_1.isGroupingFun(group)) {
	            groupFn = group;
	            sortDirection = group.sortDirection;
	        }
	        else {
	            // currently support for only one group implemented
	            var groupField_1 = Object.keys(group)[0];
	            sortDirection = group[groupField_1];
	            groupFn = function (item) {
	                return getPath(item, groupField_1);
	            };
	        }
	        var settings = params.settings();
	        var originalDataOptions = settings.dataOptions;
	        settings.dataOptions = { applyPaging: false };
	        var getData = settings.getData;
	        var gotData = $q.when(getData(params));
	        return gotData.then(function (data) {
	            var groups = {};
	            ng1.forEach(data, function (item) {
	                var groupName = groupFn(item);
	                groups[groupName] = groups[groupName] || {
	                    data: [],
	                    $hideRows: !settings.groupOptions.isExpanded,
	                    value: groupName
	                };
	                groups[groupName].data.push(item);
	            });
	            var result = [];
	            for (var i in groups) {
	                result.push(groups[i]);
	            }
	            if (sortDirection) {
	                var orderByFn = ngTableDefaultGetData.getOrderByFn();
	                var orderBy = util_1.convertSortToOrderBy({
	                    value: sortDirection
	                });
	                result = orderByFn(result, orderBy);
	            }
	            return ngTableDefaultGetData.applyPaging(result, params);
	        }).finally(function () {
	            // restore the real options
	            settings.dataOptions = originalDataOptions;
	        });
	    }
	}
	exports.ngTableDefaultGetGroups = ngTableDefaultGetGroups;
	/**
	 * @private
	 */
	function getPath(obj, ks) {
	    // origianl source https://github.com/documentcloud/underscore-contrib
	    var keys;
	    if (typeof ks === "string") {
	        keys = ks.split(".");
	    }
	    else {
	        keys = ks;
	    }
	    // If we have reached an undefined property
	    // then stop executing and return undefined
	    if (obj === undefined)
	        return void 0;
	    // If the path array has no more elements, we've reached
	    // the intended property and return its value
	    if (keys.length === 0)
	        return obj;
	    // If we still have elements in the path array and the current
	    // value is null, stop executing and return undefined
	    if (obj === null)
	        return void 0;
	    return getPath(obj[keys[0]], keys.slice(1));
	}
	
	
	/***/ },
	/* 39 */
	/* unknown exports provided */
	/* all exports used */
	/*!********************************************!*\
	  !*** ./src/core/grouping/publicExports.ts ***!
	  \********************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(/*! ./getGroup */ 4));
	__export(__webpack_require__(/*! ./groupingFunc */ 6));
	__export(__webpack_require__(/*! ./groupSettings */ 5));
	
	
	/***/ },
	/* 40 */
	/* unknown exports provided */
	/* all exports used */
	/*!**********************************!*\
	  !*** ./src/core/paging/index.ts ***!
	  \**********************************/
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	
	
	/***/ },
	/* 41 */
	/* unknown exports provided */
	/* all exports used */
	/*!***********************************!*\
	  !*** ./src/core/sorting/index.ts ***!
	  \***********************************/
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	
	
	/***/ },
	/* 42 */
	/* unknown exports provided */
	/* all exports used */
	/*!************************************!*\
	  !*** ./src/browser/filterRow.html ***!
	  \************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	var path = 'ng-table/filterRow.html';
	var html = "<tr ng-show=\"show_filter\" class=\"ng-table-filters\">\n    <th data-title-text=\"{{$column.titleAlt(this) || $column.title(this)}}\" ng-repeat=\"$column in $columns\" ng-if=\"$column.show(this)\" class=\"filter {{$column.class(this)}}\"\n        ng-class=\"params.settings().filterOptions.filterLayout === 'horizontal' ? 'filter-horizontal' : ''\">\n        <div ng-repeat=\"(name, filter) in $column.filter(this)\" ng-include=\"$ctrl.config.getTemplateUrl(filter)\" class=\"filter-cell\"\n             ng-class=\"[$ctrl.getFilterCellCss($column.filter(this), params.settings().filterOptions.filterLayout), $last ? 'last' : '']\">\n        </div>\n    </th>\n</tr>\n";
	var angular = __webpack_require__(/*! angular */ 0);
	angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;
	
	/***/ },
	/* 43 */
	/* unknown exports provided */
	/* all exports used */
	/*!*****************************************!*\
	  !*** ./src/browser/filters/number.html ***!
	  \*****************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	var path = 'ng-table/filters/number.html';
	var html = "<input type=\"number\" name=\"{{name}}\" ng-disabled=\"$filterRow.disabled\" ng-model=\"params.filter()[name]\" class=\"input-filter form-control\"\n       placeholder=\"{{getFilterPlaceholderValue(filter, name)}}\"/>\n";
	var angular = __webpack_require__(/*! angular */ 0);
	angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;
	
	/***/ },
	/* 44 */
	/* unknown exports provided */
	/* all exports used */
	/*!**************************************************!*\
	  !*** ./src/browser/filters/select-multiple.html ***!
	  \**************************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	var path = 'ng-table/filters/select-multiple.html';
	var html = "<select ng-options=\"data.id as data.title for data in $column.data\"\n        ng-disabled=\"$filterRow.disabled\"\n        multiple ng-multiple=\"true\"\n        ng-model=\"params.filter()[name]\"\n        class=\"filter filter-select-multiple form-control\" name=\"{{name}}\">\n</select>\n";
	var angular = __webpack_require__(/*! angular */ 0);
	angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;
	
	/***/ },
	/* 45 */
	/* unknown exports provided */
	/* all exports used */
	/*!*****************************************!*\
	  !*** ./src/browser/filters/select.html ***!
	  \*****************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	var path = 'ng-table/filters/select.html';
	var html = "<select ng-options=\"data.id as data.title for data in $selectData\"\n        ng-table-select-filter-ds=\"$column\"\n        ng-disabled=\"$filterRow.disabled\"\n        ng-model=\"params.filter()[name]\"\n        class=\"filter filter-select form-control\" name=\"{{name}}\">\n    <option style=\"display:none\" value=\"\"></option>\n</select>\n";
	var angular = __webpack_require__(/*! angular */ 0);
	angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;
	
	/***/ },
	/* 46 */
	/* unknown exports provided */
	/* all exports used */
	/*!***************************************!*\
	  !*** ./src/browser/filters/text.html ***!
	  \***************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	var path = 'ng-table/filters/text.html';
	var html = "<input type=\"text\" name=\"{{name}}\" ng-disabled=\"$filterRow.disabled\" ng-model=\"params.filter()[name]\" class=\"input-filter form-control\"\n       placeholder=\"{{getFilterPlaceholderValue(filter, name)}}\"/>\n";
	var angular = __webpack_require__(/*! angular */ 0);
	angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;
	
	/***/ },
	/* 47 */
	/* unknown exports provided */
	/* all exports used */
	/*!***********************************!*\
	  !*** ./src/browser/groupRow.html ***!
	  \***********************************/
	/***/ function(module, exports, __webpack_require__) {
	
	var path = 'ng-table/groupRow.html';
	var html = "<tr ng-if=\"params.hasGroup()\" ng-show=\"$groupRow.show\" class=\"ng-table-group-header\">\n    <th colspan=\"{{$ctrl.getVisibleColumns().length}}\" class=\"sortable\" ng-class=\"{\n                    'sort-asc': params.hasGroup($selGroup, 'asc'),\n                    'sort-desc':params.hasGroup($selGroup, 'desc')\n                  }\">\n        <a href=\"\" ng-click=\"isSelectorOpen = !isSelectorOpen\" class=\"ng-table-group-selector\">\n            <strong class=\"sort-indicator\">{{$selGroupTitle}}</strong>\n            <button class=\"btn btn-default btn-xs ng-table-group-close\"\n                    ng-click=\"$groupRow.show = false; $event.preventDefault(); $event.stopPropagation();\">\n                <span class=\"glyphicon glyphicon-remove\"></span>\n            </button>\n            <button class=\"btn btn-default btn-xs ng-table-group-toggle\"\n                    ng-click=\"$ctrl.toggleDetail(); $event.preventDefault(); $event.stopPropagation();\">\n                <span class=\"glyphicon\" ng-class=\"{\n                    'glyphicon-resize-small': params.settings().groupOptions.isExpanded,\n                    'glyphicon-resize-full': !params.settings().groupOptions.isExpanded\n                }\"></span>\n            </button>\n        </a>\n        <div class=\"list-group\" ng-if=\"isSelectorOpen\">\n            <a href=\"\" class=\"list-group-item\" ng-repeat=\"group in $ctrl.getGroupables()\" ng-click=\"$ctrl.groupBy(group)\">\n                <strong>{{ $ctrl.getGroupTitle(group)}}</strong>\n                <strong ng-class=\"$ctrl.isSelectedGroup(group) && 'sort-indicator'\"></strong>\n            </a>\n        </div>\n    </th>\n</tr>\n";
	var angular = __webpack_require__(/*! angular */ 0);
	angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;
	
	/***/ },
	/* 48 */
	/* unknown exports provided */
	/* all exports used */
	/*!*********************************!*\
	  !*** ./src/browser/header.html ***!
	  \*********************************/
	/***/ function(module, exports, __webpack_require__) {
	
	var path = 'ng-table/header.html';
	var html = "<ng-table-group-row></ng-table-group-row>\n<ng-table-sorter-row></ng-table-sorter-row>\n<ng-table-filter-row></ng-table-filter-row>\n";
	var angular = __webpack_require__(/*! angular */ 0);
	angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;
	
	/***/ },
	/* 49 */
	/* unknown exports provided */
	/* all exports used */
	/*!********************************!*\
	  !*** ./src/browser/pager.html ***!
	  \********************************/
	/***/ function(module, exports, __webpack_require__) {
	
	var path = 'ng-table/pager.html';
	var html = "<div class=\"ng-cloak ng-table-pager\" ng-if=\"params.data.length\">\n    <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n        <button ng-repeat=\"count in params.settings().counts\" type=\"button\"\n                ng-class=\"{'active':params.count() == count}\"\n                ng-click=\"params.count(count)\" class=\"btn btn-default\">\n            <span ng-bind=\"count\"></span>\n        </button>\n    </div>\n    <ul ng-if=\"pages.length\" class=\"pagination ng-table-pagination\">\n        <li class=\"page-item\" ng-class=\"{'disabled': !page.active && !page.current, 'active': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n            <a class=\"page-link\" ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">&laquo;</a>\n            <a class=\"page-link\" ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\"><span ng-bind=\"page.number\"></span></a>\n            <a class=\"page-link\" ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\"><span ng-bind=\"page.number\"></span></a>\n            <a class=\"page-link\" ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n            <a class=\"page-link\" ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\"><span ng-bind=\"page.number\"></span></a>\n            <a class=\"page-link\" ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">&raquo;</a>\n        </li>\n    </ul>\n</div>\n";
	var angular = __webpack_require__(/*! angular */ 0);
	angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;
	
	/***/ },
	/* 50 */
	/* unknown exports provided */
	/* all exports used */
	/*!************************************!*\
	  !*** ./src/browser/sorterRow.html ***!
	  \************************************/
	/***/ function(module, exports, __webpack_require__) {
	
	var path = 'ng-table/sorterRow.html';
	var html = "<tr class=\"ng-table-sort-header\">\n    <th title=\"{{$column.headerTitle(this)}}\"\n        ng-repeat=\"$column in $columns\"\n        ng-class=\"{\n                    'sortable': $column.sortable(this),\n                    'sort-asc': params.sorting()[$column.sortable(this)]=='asc',\n                    'sort-desc': params.sorting()[$column.sortable(this)]=='desc'\n                  }\"\n        ng-click=\"$ctrl.sortBy($column, $event)\"\n        ng-if=\"$column.show(this)\"\n        ng-init=\"template = $column.headerTemplateURL(this)\"\n        class=\"header {{$column.class(this)}}\">\n        <div ng-if=\"!template\" class=\"ng-table-header\" ng-class=\"{'sort-indicator': params.settings().sortingIndicator == 'div'}\">\n            <span ng-bind=\"$column.title(this)\" ng-class=\"{'sort-indicator': params.settings().sortingIndicator == 'span'}\"></span>\n        </div>\n        <div ng-if=\"template\" ng-include=\"template\"></div>\n    </th>\n</tr>\n";
	var angular = __webpack_require__(/*! angular */ 0);
	angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;
	
	/***/ },
	/* 51 */
	/* unknown exports provided */
	/* all exports used */
	/*!******************!*\
	  !*** ./index.ts ***!
	  \******************/
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	var ng1 = __webpack_require__(/*! angular */ 0);
	var core_1 = __webpack_require__(/*! ./src/core */ 1);
	var browser_1 = __webpack_require__(/*! ./src/browser */ 2);
	var ngTableModule = ng1.module('ngTable', [core_1.ngTableCoreModule.name, browser_1.ngTableBrowserModule.name]);
	exports.ngTableModule = ngTableModule;
	__export(__webpack_require__(/*! ./src/core */ 1));
	__export(__webpack_require__(/*! ./src/browser */ 2));
	
	
	/***/ }
	/******/ ]);
	});
	//# sourceMappingURL=ng-table.js.map

/***/ },

/***/ 823:
/***/ function(module, exports) {

	/**
	 * oclazyload - Load modules on demand (lazy load) with angularJS
	 * @version v1.0.9
	 * @link https://github.com/ocombe/ocLazyLoad
	 * @license MIT
	 * @author Olivier Combe <olivier.combe@gmail.com>
	 */
	(function (angular, window) {
	    'use strict';
	
	    var regModules = ['ng', 'oc.lazyLoad'],
	        regInvokes = {},
	        regConfigs = [],
	        modulesToLoad = [],
	        // modules to load from angular.module or other sources
	    realModules = [],
	        // real modules called from angular.module
	    recordDeclarations = [],
	        broadcast = angular.noop,
	        runBlocks = {},
	        justLoaded = [];
	
	    var ocLazyLoad = angular.module('oc.lazyLoad', ['ng']);
	
	    ocLazyLoad.provider('$ocLazyLoad', ["$controllerProvider", "$provide", "$compileProvider", "$filterProvider", "$injector", "$animateProvider", function ($controllerProvider, $provide, $compileProvider, $filterProvider, $injector, $animateProvider) {
	        var modules = {},
	            providers = {
	            $controllerProvider: $controllerProvider,
	            $compileProvider: $compileProvider,
	            $filterProvider: $filterProvider,
	            $provide: $provide, // other things (constant, decorator, provider, factory, service)
	            $injector: $injector,
	            $animateProvider: $animateProvider
	        },
	            debug = false,
	            events = false,
	            moduleCache = [],
	            modulePromises = {};
	
	        moduleCache.push = function (value) {
	            if (this.indexOf(value) === -1) {
	                Array.prototype.push.apply(this, arguments);
	            }
	        };
	
	        this.config = function (config) {
	            // If we want to define modules configs
	            if (angular.isDefined(config.modules)) {
	                if (angular.isArray(config.modules)) {
	                    angular.forEach(config.modules, function (moduleConfig) {
	                        modules[moduleConfig.name] = moduleConfig;
	                    });
	                } else {
	                    modules[config.modules.name] = config.modules;
	                }
	            }
	
	            if (angular.isDefined(config.debug)) {
	                debug = config.debug;
	            }
	
	            if (angular.isDefined(config.events)) {
	                events = config.events;
	            }
	        };
	
	        /**
	         * Get the list of existing registered modules
	         * @param element
	         */
	        this._init = function _init(element) {
	            // this is probably useless now because we override angular.bootstrap
	            if (modulesToLoad.length === 0) {
	                var elements = [element],
	                    names = ['ng:app', 'ng-app', 'x-ng-app', 'data-ng-app'],
	                    NG_APP_CLASS_REGEXP = /\sng[:\-]app(:\s*([\w\d_]+);?)?\s/,
	                    append = function append(elm) {
	                    return elm && elements.push(elm);
	                };
	
	                angular.forEach(names, function (name) {
	                    names[name] = true;
	                    append(document.getElementById(name));
	                    name = name.replace(':', '\\:');
	                    if (typeof element[0] !== 'undefined' && element[0].querySelectorAll) {
	                        angular.forEach(element[0].querySelectorAll('.' + name), append);
	                        angular.forEach(element[0].querySelectorAll('.' + name + '\\:'), append);
	                        angular.forEach(element[0].querySelectorAll('[' + name + ']'), append);
	                    }
	                });
	
	                angular.forEach(elements, function (elm) {
	                    if (modulesToLoad.length === 0) {
	                        var className = ' ' + element.className + ' ';
	                        var match = NG_APP_CLASS_REGEXP.exec(className);
	                        if (match) {
	                            modulesToLoad.push((match[2] || '').replace(/\s+/g, ','));
	                        } else {
	                            angular.forEach(elm.attributes, function (attr) {
	                                if (modulesToLoad.length === 0 && names[attr.name]) {
	                                    modulesToLoad.push(attr.value);
	                                }
	                            });
	                        }
	                    }
	                });
	            }
	
	            if (modulesToLoad.length === 0 && !((window.jasmine || window.mocha) && angular.isDefined(angular.mock))) {
	                console.error('No module found during bootstrap, unable to init ocLazyLoad. You should always use the ng-app directive or angular.boostrap when you use ocLazyLoad.');
	            }
	
	            var addReg = function addReg(moduleName) {
	                if (regModules.indexOf(moduleName) === -1) {
	                    // register existing modules
	                    regModules.push(moduleName);
	                    var mainModule = angular.module(moduleName);
	
	                    // register existing components (directives, services, ...)
	                    _invokeQueue(null, mainModule._invokeQueue, moduleName);
	                    _invokeQueue(null, mainModule._configBlocks, moduleName); // angular 1.3+
	
	                    angular.forEach(mainModule.requires, addReg);
	                }
	            };
	
	            angular.forEach(modulesToLoad, function (moduleName) {
	                addReg(moduleName);
	            });
	
	            modulesToLoad = []; // reset for next bootstrap
	            recordDeclarations.pop(); // wait for the next lazy load
	        };
	
	        /**
	         * Like JSON.stringify but that doesn't throw on circular references
	         * @param obj
	         */
	        var stringify = function stringify(obj) {
	            try {
	                return JSON.stringify(obj);
	            } catch (e) {
	                var cache = [];
	                return JSON.stringify(obj, function (key, value) {
	                    if (angular.isObject(value) && value !== null) {
	                        if (cache.indexOf(value) !== -1) {
	                            // Circular reference found, discard key
	                            return;
	                        }
	                        // Store value in our collection
	                        cache.push(value);
	                    }
	                    return value;
	                });
	            }
	        };
	
	        var hashCode = function hashCode(str) {
	            var hash = 0,
	                i,
	                chr,
	                len;
	            if (str.length == 0) {
	                return hash;
	            }
	            for (i = 0, len = str.length; i < len; i++) {
	                chr = str.charCodeAt(i);
	                hash = (hash << 5) - hash + chr;
	                hash |= 0; // Convert to 32bit integer
	            }
	            return hash;
	        };
	
	        function _register(providers, registerModules, params) {
	            if (registerModules) {
	                var k,
	                    moduleName,
	                    moduleFn,
	                    tempRunBlocks = [];
	                for (k = registerModules.length - 1; k >= 0; k--) {
	                    moduleName = registerModules[k];
	                    if (!angular.isString(moduleName)) {
	                        moduleName = getModuleName(moduleName);
	                    }
	                    if (!moduleName || justLoaded.indexOf(moduleName) !== -1 || modules[moduleName] && realModules.indexOf(moduleName) === -1) {
	                        continue;
	                    }
	                    // new if not registered
	                    var newModule = regModules.indexOf(moduleName) === -1;
	                    moduleFn = ngModuleFct(moduleName);
	                    if (newModule) {
	                        regModules.push(moduleName);
	                        _register(providers, moduleFn.requires, params);
	                    }
	                    if (moduleFn._runBlocks.length > 0) {
	                        // new run blocks detected! Replace the old ones (if existing)
	                        runBlocks[moduleName] = [];
	                        while (moduleFn._runBlocks.length > 0) {
	                            runBlocks[moduleName].push(moduleFn._runBlocks.shift());
	                        }
	                    }
	                    if (angular.isDefined(runBlocks[moduleName]) && (newModule || params.rerun)) {
	                        tempRunBlocks = tempRunBlocks.concat(runBlocks[moduleName]);
	                    }
	                    _invokeQueue(providers, moduleFn._invokeQueue, moduleName, params.reconfig);
	                    _invokeQueue(providers, moduleFn._configBlocks, moduleName, params.reconfig); // angular 1.3+
	                    broadcast(newModule ? 'ocLazyLoad.moduleLoaded' : 'ocLazyLoad.moduleReloaded', moduleName);
	                    registerModules.pop();
	                    justLoaded.push(moduleName);
	                }
	                // execute the run blocks at the end
	                var instanceInjector = providers.getInstanceInjector();
	                angular.forEach(tempRunBlocks, function (fn) {
	                    instanceInjector.invoke(fn);
	                });
	            }
	        }
	
	        function _registerInvokeList(args, moduleName) {
	            var invokeList = args[2][0],
	                type = args[1],
	                newInvoke = false;
	            if (angular.isUndefined(regInvokes[moduleName])) {
	                regInvokes[moduleName] = {};
	            }
	            if (angular.isUndefined(regInvokes[moduleName][type])) {
	                regInvokes[moduleName][type] = {};
	            }
	            var onInvoke = function onInvoke(invokeName, invoke) {
	                if (!regInvokes[moduleName][type].hasOwnProperty(invokeName)) {
	                    regInvokes[moduleName][type][invokeName] = [];
	                }
	                if (checkHashes(invoke, regInvokes[moduleName][type][invokeName])) {
	                    newInvoke = true;
	                    regInvokes[moduleName][type][invokeName].push(invoke);
	                    broadcast('ocLazyLoad.componentLoaded', [moduleName, type, invokeName]);
	                }
	            };
	
	            function checkHashes(potentialNew, invokes) {
	                var isNew = true,
	                    newHash;
	                if (invokes.length) {
	                    newHash = signature(potentialNew);
	                    angular.forEach(invokes, function (invoke) {
	                        isNew = isNew && signature(invoke) !== newHash;
	                    });
	                }
	                return isNew;
	            }
	
	            function signature(data) {
	                if (angular.isArray(data)) {
	                    // arrays are objects, we need to test for it first
	                    return hashCode(data.toString());
	                } else if (angular.isObject(data)) {
	                    // constants & values for example
	                    return hashCode(stringify(data));
	                } else {
	                    if (angular.isDefined(data) && data !== null) {
	                        return hashCode(data.toString());
	                    } else {
	                        // null & undefined constants
	                        return data;
	                    }
	                }
	            }
	
	            if (angular.isString(invokeList)) {
	                onInvoke(invokeList, args[2][1]);
	            } else if (angular.isObject(invokeList)) {
	                angular.forEach(invokeList, function (invoke, key) {
	                    if (angular.isString(invoke)) {
	                        // decorators for example
	                        onInvoke(invoke, invokeList[1]);
	                    } else {
	                        // components registered as object lists {"componentName": function() {}}
	                        onInvoke(key, invoke);
	                    }
	                });
	            } else {
	                return false;
	            }
	            return newInvoke;
	        }
	
	        function _invokeQueue(providers, queue, moduleName, reconfig) {
	            if (!queue) {
	                return;
	            }
	
	            var i, len, args, provider;
	            for (i = 0, len = queue.length; i < len; i++) {
	                args = queue[i];
	                if (angular.isArray(args)) {
	                    if (providers !== null) {
	                        if (providers.hasOwnProperty(args[0])) {
	                            provider = providers[args[0]];
	                        } else {
	                            throw new Error('unsupported provider ' + args[0]);
	                        }
	                    }
	                    var isNew = _registerInvokeList(args, moduleName);
	                    if (args[1] !== 'invoke') {
	                        if (isNew && angular.isDefined(provider)) {
	                            provider[args[1]].apply(provider, args[2]);
	                        }
	                    } else {
	                        // config block
	                        var callInvoke = function callInvoke(fct) {
	                            var invoked = regConfigs.indexOf(moduleName + '-' + fct);
	                            if (invoked === -1 || reconfig) {
	                                if (invoked === -1) {
	                                    regConfigs.push(moduleName + '-' + fct);
	                                }
	                                if (angular.isDefined(provider)) {
	                                    provider[args[1]].apply(provider, args[2]);
	                                }
	                            }
	                        };
	                        if (angular.isFunction(args[2][0])) {
	                            callInvoke(args[2][0]);
	                        } else if (angular.isArray(args[2][0])) {
	                            for (var j = 0, jlen = args[2][0].length; j < jlen; j++) {
	                                if (angular.isFunction(args[2][0][j])) {
	                                    callInvoke(args[2][0][j]);
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	
	        function getModuleName(module) {
	            var moduleName = null;
	            if (angular.isString(module)) {
	                moduleName = module;
	            } else if (angular.isObject(module) && module.hasOwnProperty('name') && angular.isString(module.name)) {
	                moduleName = module.name;
	            }
	            return moduleName;
	        }
	
	        function moduleExists(moduleName) {
	            if (!angular.isString(moduleName)) {
	                return false;
	            }
	            try {
	                return ngModuleFct(moduleName);
	            } catch (e) {
	                if (/No module/.test(e) || e.message.indexOf('$injector:nomod') > -1) {
	                    return false;
	                }
	            }
	        }
	
	        this.$get = ["$log", "$rootElement", "$rootScope", "$cacheFactory", "$q", function ($log, $rootElement, $rootScope, $cacheFactory, $q) {
	            var instanceInjector,
	                filesCache = $cacheFactory('ocLazyLoad');
	
	            if (!debug) {
	                $log = {};
	                $log['error'] = angular.noop;
	                $log['warn'] = angular.noop;
	                $log['info'] = angular.noop;
	            }
	
	            // Make this lazy because when $get() is called the instance injector hasn't been assigned to the rootElement yet
	            providers.getInstanceInjector = function () {
	                return instanceInjector ? instanceInjector : instanceInjector = $rootElement.data('$injector') || angular.injector();
	            };
	
	            broadcast = function broadcast(eventName, params) {
	                if (events) {
	                    $rootScope.$broadcast(eventName, params);
	                }
	                if (debug) {
	                    $log.info(eventName, params);
	                }
	            };
	
	            function reject(e) {
	                var deferred = $q.defer();
	                $log.error(e.message);
	                deferred.reject(e);
	                return deferred.promise;
	            }
	
	            return {
	                _broadcast: broadcast,
	
	                _$log: $log,
	
	                /**
	                 * Returns the files cache used by the loaders to store the files currently loading
	                 * @returns {*}
	                 */
	                _getFilesCache: function getFilesCache() {
	                    return filesCache;
	                },
	
	                /**
	                 * Let the service know that it should monitor angular.module because files are loading
	                 * @param watch boolean
	                 */
	                toggleWatch: function toggleWatch(watch) {
	                    if (watch) {
	                        recordDeclarations.push(true);
	                    } else {
	                        recordDeclarations.pop();
	                    }
	                },
	
	                /**
	                 * Let you get a module config object
	                 * @param moduleName String the name of the module
	                 * @returns {*}
	                 */
	                getModuleConfig: function getModuleConfig(moduleName) {
	                    if (!angular.isString(moduleName)) {
	                        throw new Error('You need to give the name of the module to get');
	                    }
	                    if (!modules[moduleName]) {
	                        return null;
	                    }
	                    return angular.copy(modules[moduleName]);
	                },
	
	                /**
	                 * Let you define a module config object
	                 * @param moduleConfig Object the module config object
	                 * @returns {*}
	                 */
	                setModuleConfig: function setModuleConfig(moduleConfig) {
	                    if (!angular.isObject(moduleConfig)) {
	                        throw new Error('You need to give the module config object to set');
	                    }
	                    modules[moduleConfig.name] = moduleConfig;
	                    return moduleConfig;
	                },
	
	                /**
	                 * Returns the list of loaded modules
	                 * @returns {string[]}
	                 */
	                getModules: function getModules() {
	                    return regModules;
	                },
	
	                /**
	                 * Let you check if a module has been loaded into Angular or not
	                 * @param modulesNames String/Object a module name, or a list of module names
	                 * @returns {boolean}
	                 */
	                isLoaded: function isLoaded(modulesNames) {
	                    var moduleLoaded = function moduleLoaded(module) {
	                        var isLoaded = regModules.indexOf(module) > -1;
	                        if (!isLoaded) {
	                            isLoaded = !!moduleExists(module);
	                        }
	                        return isLoaded;
	                    };
	                    if (angular.isString(modulesNames)) {
	                        modulesNames = [modulesNames];
	                    }
	                    if (angular.isArray(modulesNames)) {
	                        var i, len;
	                        for (i = 0, len = modulesNames.length; i < len; i++) {
	                            if (!moduleLoaded(modulesNames[i])) {
	                                return false;
	                            }
	                        }
	                        return true;
	                    } else {
	                        throw new Error('You need to define the module(s) name(s)');
	                    }
	                },
	
	                /**
	                 * Given a module, return its name
	                 * @param module
	                 * @returns {String}
	                 */
	                _getModuleName: getModuleName,
	
	                /**
	                 * Returns a module if it exists
	                 * @param moduleName
	                 * @returns {module}
	                 */
	                _getModule: function getModule(moduleName) {
	                    try {
	                        return ngModuleFct(moduleName);
	                    } catch (e) {
	                        // this error message really suxx
	                        if (/No module/.test(e) || e.message.indexOf('$injector:nomod') > -1) {
	                            e.message = 'The module "' + stringify(moduleName) + '" that you are trying to load does not exist. ' + e.message;
	                        }
	                        throw e;
	                    }
	                },
	
	                /**
	                 * Check if a module exists and returns it if it does
	                 * @param moduleName
	                 * @returns {boolean}
	                 */
	                moduleExists: moduleExists,
	
	                /**
	                 * Load the dependencies, and might try to load new files depending on the config
	                 * @param moduleName (String or Array of Strings)
	                 * @param localParams
	                 * @returns {*}
	                 * @private
	                 */
	                _loadDependencies: function _loadDependencies(moduleName, localParams) {
	                    var loadedModule,
	                        requires,
	                        diff,
	                        promisesList = [],
	                        self = this;
	
	                    moduleName = self._getModuleName(moduleName);
	
	                    if (moduleName === null) {
	                        return $q.when();
	                    } else {
	                        try {
	                            loadedModule = self._getModule(moduleName);
	                        } catch (e) {
	                            return reject(e);
	                        }
	                        // get unloaded requires
	                        requires = self.getRequires(loadedModule);
	                    }
	
	                    angular.forEach(requires, function (requireEntry) {
	                        // If no configuration is provided, try and find one from a previous load.
	                        // If there isn't one, bail and let the normal flow run
	                        if (angular.isString(requireEntry)) {
	                            var config = self.getModuleConfig(requireEntry);
	                            if (config === null) {
	                                moduleCache.push(requireEntry); // We don't know about this module, but something else might, so push it anyway.
	                                return;
	                            }
	                            requireEntry = config;
	                            // ignore the name because it's probably not a real module name
	                            config.name = undefined;
	                        }
	
	                        // Check if this dependency has been loaded previously
	                        if (self.moduleExists(requireEntry.name)) {
	                            // compare against the already loaded module to see if the new definition adds any new files
	                            diff = requireEntry.files.filter(function (n) {
	                                return self.getModuleConfig(requireEntry.name).files.indexOf(n) < 0;
	                            });
	
	                            // If the module was redefined, advise via the console
	                            if (diff.length !== 0) {
	                                self._$log.warn('Module "', moduleName, '" attempted to redefine configuration for dependency. "', requireEntry.name, '"\n Additional Files Loaded:', diff);
	                            }
	
	                            // Push everything to the file loader, it will weed out the duplicates.
	                            if (angular.isDefined(self.filesLoader)) {
	                                // if a files loader is defined
	                                promisesList.push(self.filesLoader(requireEntry, localParams).then(function () {
	                                    return self._loadDependencies(requireEntry);
	                                }));
	                            } else {
	                                return reject(new Error('Error: New dependencies need to be loaded from external files (' + requireEntry.files + '), but no loader has been defined.'));
	                            }
	                            return;
	                        } else if (angular.isArray(requireEntry)) {
	                            var files = [];
	                            angular.forEach(requireEntry, function (entry) {
	                                // let's check if the entry is a file name or a config name
	                                var config = self.getModuleConfig(entry);
	                                if (config === null) {
	                                    files.push(entry);
	                                } else if (config.files) {
	                                    files = files.concat(config.files);
	                                }
	                            });
	                            if (files.length > 0) {
	                                requireEntry = {
	                                    files: files
	                                };
	                            }
	                        } else if (angular.isObject(requireEntry)) {
	                            if (requireEntry.hasOwnProperty('name') && requireEntry['name']) {
	                                // The dependency doesn't exist in the module cache and is a new configuration, so store and push it.
	                                self.setModuleConfig(requireEntry);
	                                moduleCache.push(requireEntry['name']);
	                            }
	                        }
	
	                        // Check if the dependency has any files that need to be loaded. If there are, push a new promise to the promise list.
	                        if (angular.isDefined(requireEntry.files) && requireEntry.files.length !== 0) {
	                            if (angular.isDefined(self.filesLoader)) {
	                                // if a files loader is defined
	                                promisesList.push(self.filesLoader(requireEntry, localParams).then(function () {
	                                    return self._loadDependencies(requireEntry);
	                                }));
	                            } else {
	                                return reject(new Error('Error: the module "' + requireEntry.name + '" is defined in external files (' + requireEntry.files + '), but no loader has been defined.'));
	                            }
	                        }
	                    });
	
	                    // Create a wrapper promise to watch the promise list and resolve it once everything is done.
	                    return $q.all(promisesList);
	                },
	
	                /**
	                 * Inject new modules into Angular
	                 * @param moduleName
	                 * @param localParams
	                 * @param real
	                 */
	                inject: function inject(moduleName) {
	                    var localParams = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	                    var real = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	                    var self = this,
	                        deferred = $q.defer();
	                    if (angular.isDefined(moduleName) && moduleName !== null) {
	                        if (angular.isArray(moduleName)) {
	                            var promisesList = [];
	                            angular.forEach(moduleName, function (module) {
	                                promisesList.push(self.inject(module, localParams, real));
	                            });
	                            return $q.all(promisesList);
	                        } else {
	                            self._addToLoadList(self._getModuleName(moduleName), true, real);
	                        }
	                    }
	                    if (modulesToLoad.length > 0) {
	                        var res = modulesToLoad.slice(); // clean copy
	                        var loadNext = function loadNext(moduleName) {
	                            moduleCache.push(moduleName);
	                            modulePromises[moduleName] = deferred.promise;
	                            self._loadDependencies(moduleName, localParams).then(function success() {
	                                try {
	                                    justLoaded = [];
	                                    _register(providers, moduleCache, localParams);
	                                } catch (e) {
	                                    self._$log.error(e.message);
	                                    deferred.reject(e);
	                                    return;
	                                }
	
	                                if (modulesToLoad.length > 0) {
	                                    loadNext(modulesToLoad.shift()); // load the next in list
	                                } else {
	                                        deferred.resolve(res); // everything has been loaded, resolve
	                                    }
	                            }, function error(err) {
	                                deferred.reject(err);
	                            });
	                        };
	
	                        // load the first in list
	                        loadNext(modulesToLoad.shift());
	                    } else if (localParams && localParams.name && modulePromises[localParams.name]) {
	                        return modulePromises[localParams.name];
	                    } else {
	                        deferred.resolve();
	                    }
	                    return deferred.promise;
	                },
	
	                /**
	                 * Get the list of required modules/services/... for this module
	                 * @param module
	                 * @returns {Array}
	                 */
	                getRequires: function getRequires(module) {
	                    var requires = [];
	                    angular.forEach(module.requires, function (requireModule) {
	                        if (regModules.indexOf(requireModule) === -1) {
	                            requires.push(requireModule);
	                        }
	                    });
	                    return requires;
	                },
	
	                /**
	                 * Invoke the new modules & component by their providers
	                 * @param providers
	                 * @param queue
	                 * @param moduleName
	                 * @param reconfig
	                 * @private
	                 */
	                _invokeQueue: _invokeQueue,
	
	                /**
	                 * Check if a module has been invoked and registers it if not
	                 * @param args
	                 * @param moduleName
	                 * @returns {boolean} is new
	                 */
	                _registerInvokeList: _registerInvokeList,
	
	                /**
	                 * Register a new module and loads it, executing the run/config blocks if needed
	                 * @param providers
	                 * @param registerModules
	                 * @param params
	                 * @private
	                 */
	                _register: _register,
	
	                /**
	                 * Add a module name to the list of modules that will be loaded in the next inject
	                 * @param name
	                 * @param force
	                 * @private
	                 */
	                _addToLoadList: _addToLoadList,
	
	                /**
	                 * Unregister modules (you shouldn't have to use this)
	                 * @param modules
	                 */
	                _unregister: function _unregister(modules) {
	                    if (angular.isDefined(modules)) {
	                        if (angular.isArray(modules)) {
	                            angular.forEach(modules, function (module) {
	                                regInvokes[module] = undefined;
	                            });
	                        }
	                    }
	                }
	            };
	        }];
	
	        // Let's get the list of loaded modules & components
	        this._init(angular.element(window.document));
	    }]);
	
	    var bootstrapFct = angular.bootstrap;
	    angular.bootstrap = function (element, modules, config) {
	        // we use slice to make a clean copy
	        angular.forEach(modules.slice(), function (module) {
	            _addToLoadList(module, true, true);
	        });
	        return bootstrapFct(element, modules, config);
	    };
	
	    var _addToLoadList = function _addToLoadList(name, force, real) {
	        if ((recordDeclarations.length > 0 || force) && angular.isString(name) && modulesToLoad.indexOf(name) === -1) {
	            modulesToLoad.push(name);
	            if (real) {
	                realModules.push(name);
	            }
	        }
	    };
	
	    var ngModuleFct = angular.module;
	    angular.module = function (name, requires, configFn) {
	        _addToLoadList(name, false, true);
	        return ngModuleFct(name, requires, configFn);
	    };
	
	    // CommonJS package manager support:
	    if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
	        module.exports = 'oc.lazyLoad';
	    }
	})(angular, window);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').directive('ocLazyLoad', ["$ocLazyLoad", "$compile", "$animate", "$parse", "$timeout", function ($ocLazyLoad, $compile, $animate, $parse, $timeout) {
	        return {
	            restrict: 'A',
	            terminal: true,
	            priority: 1000,
	            compile: function compile(element, attrs) {
	                // we store the content and remove it before compilation
	                var content = element[0].innerHTML;
	                element.html('');
	
	                return function ($scope, $element, $attr) {
	                    var model = $parse($attr.ocLazyLoad);
	                    $scope.$watch(function () {
	                        return model($scope) || $attr.ocLazyLoad; // it can be a module name (string), an object, an array, or a scope reference to any of this
	                    }, function (moduleName) {
	                        if (angular.isDefined(moduleName)) {
	                            $ocLazyLoad.load(moduleName).then(function () {
	                                // Attach element contents to DOM and then compile them.
	                                // This prevents an issue where IE invalidates saved element objects (HTMLCollections)
	                                // of the compiled contents when attaching to the parent DOM.
	                                $animate.enter(content, $element);
	                                // get the new content & compile it
	                                $compile($element.contents())($scope);
	                            });
	                        }
	                    }, true);
	                };
	            }
	        };
	    }]);
	})(angular);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
	        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", "$window", "$interval", function ($delegate, $q, $window, $interval) {
	            var uaCssChecked = false,
	                useCssLoadPatch = false,
	                anchor = $window.document.getElementsByTagName('head')[0] || $window.document.getElementsByTagName('body')[0];
	
	            /**
	             * Load a js/css file
	             * @param type
	             * @param path
	             * @param params
	             * @returns promise
	             */
	            $delegate.buildElement = function buildElement(type, path, params) {
	                var deferred = $q.defer(),
	                    el,
	                    loaded,
	                    filesCache = $delegate._getFilesCache(),
	                    cacheBuster = function cacheBuster(url) {
	                    var dc = new Date().getTime();
	                    if (url.indexOf('?') >= 0) {
	                        if (url.substring(0, url.length - 1) === '&') {
	                            return url + '_dc=' + dc;
	                        }
	                        return url + '&_dc=' + dc;
	                    } else {
	                        return url + '?_dc=' + dc;
	                    }
	                };
	
	                // Store the promise early so the file load can be detected by other parallel lazy loads
	                // (ie: multiple routes on one page) a 'true' value isn't sufficient
	                // as it causes false positive load results.
	                if (angular.isUndefined(filesCache.get(path))) {
	                    filesCache.put(path, deferred.promise);
	                }
	
	                // Switch in case more content types are added later
	                switch (type) {
	                    case 'css':
	                        el = $window.document.createElement('link');
	                        el.type = 'text/css';
	                        el.rel = 'stylesheet';
	                        el.href = params.cache === false ? cacheBuster(path) : path;
	                        break;
	                    case 'js':
	                        el = $window.document.createElement('script');
	                        el.src = params.cache === false ? cacheBuster(path) : path;
	                        break;
	                    default:
	                        filesCache.remove(path);
	                        deferred.reject(new Error('Requested type "' + type + '" is not known. Could not inject "' + path + '"'));
	                        break;
	                }
	                el.onload = el['onreadystatechange'] = function (e) {
	                    if (el['readyState'] && !/^c|loade/.test(el['readyState']) || loaded) return;
	                    el.onload = el['onreadystatechange'] = null;
	                    loaded = 1;
	                    $delegate._broadcast('ocLazyLoad.fileLoaded', path);
	                    deferred.resolve();
	                };
	                el.onerror = function () {
	                    filesCache.remove(path);
	                    deferred.reject(new Error('Unable to load ' + path));
	                };
	                el.async = params.serie ? 0 : 1;
	
	                var insertBeforeElem = anchor.lastChild;
	                if (params.insertBefore) {
	                    var element = angular.element(angular.isDefined(window.jQuery) ? params.insertBefore : document.querySelector(params.insertBefore));
	                    if (element && element.length > 0) {
	                        insertBeforeElem = element[0];
	                    }
	                }
	                insertBeforeElem.parentNode.insertBefore(el, insertBeforeElem);
	
	                /*
	                 The event load or readystatechange doesn't fire in:
	                 - iOS < 6       (default mobile browser)
	                 - Android < 4.4 (default mobile browser)
	                 - Safari < 6    (desktop browser)
	                 */
	                if (type == 'css') {
	                    if (!uaCssChecked) {
	                        var ua = $window.navigator.userAgent.toLowerCase();
	
	                        // iOS < 6
	                        if (/iP(hone|od|ad)/.test($window.navigator.platform)) {
	                            var v = $window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
	                            var iOSVersion = parseFloat([parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)].join('.'));
	                            useCssLoadPatch = iOSVersion < 6;
	                        } else if (ua.indexOf("android") > -1) {
	                            // Android < 4.4
	                            var androidVersion = parseFloat(ua.slice(ua.indexOf("android") + 8));
	                            useCssLoadPatch = androidVersion < 4.4;
	                        } else if (ua.indexOf('safari') > -1) {
	                            var versionMatch = ua.match(/version\/([\.\d]+)/i);
	                            useCssLoadPatch = versionMatch && versionMatch[1] && parseFloat(versionMatch[1]) < 6;
	                        }
	                    }
	
	                    if (useCssLoadPatch) {
	                        var tries = 1000; // * 20 = 20000 miliseconds
	                        var interval = $interval(function () {
	                            try {
	                                el.sheet.cssRules;
	                                $interval.cancel(interval);
	                                el.onload();
	                            } catch (e) {
	                                if (--tries <= 0) {
	                                    el.onerror();
	                                }
	                            }
	                        }, 20);
	                    }
	                }
	
	                return deferred.promise;
	            };
	
	            return $delegate;
	        }]);
	    }]);
	})(angular);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
	        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
	            /**
	             * The function that loads new files
	             * @param config
	             * @param params
	             * @returns {*}
	             */
	            $delegate.filesLoader = function filesLoader(config) {
	                var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	                var cssFiles = [],
	                    templatesFiles = [],
	                    jsFiles = [],
	                    promises = [],
	                    cachePromise = null,
	                    filesCache = $delegate._getFilesCache();
	
	                $delegate.toggleWatch(true); // start watching angular.module calls
	
	                angular.extend(params, config);
	
	                var pushFile = function pushFile(path) {
	                    var file_type = null,
	                        m;
	                    if (angular.isObject(path)) {
	                        file_type = path.type;
	                        path = path.path;
	                    }
	                    cachePromise = filesCache.get(path);
	                    if (angular.isUndefined(cachePromise) || params.cache === false) {
	
	                        // always check for requirejs syntax just in case
	                        if ((m = /^(css|less|html|htm|js)?(?=!)/.exec(path)) !== null) {
	                            // Detect file type using preceding type declaration (ala requireJS)
	                            file_type = m[1];
	                            path = path.substr(m[1].length + 1, path.length); // Strip the type from the path
	                        }
	
	                        if (!file_type) {
	                            if ((m = /[.](css|less|html|htm|js)?((\?|#).*)?$/.exec(path)) !== null) {
	                                // Detect file type via file extension
	                                file_type = m[1];
	                            } else if (!$delegate.jsLoader.hasOwnProperty('ocLazyLoadLoader') && $delegate.jsLoader.hasOwnProperty('requirejs')) {
	                                // requirejs
	                                file_type = 'js';
	                            } else {
	                                $delegate._$log.error('File type could not be determined. ' + path);
	                                return;
	                            }
	                        }
	
	                        if ((file_type === 'css' || file_type === 'less') && cssFiles.indexOf(path) === -1) {
	                            cssFiles.push(path);
	                        } else if ((file_type === 'html' || file_type === 'htm') && templatesFiles.indexOf(path) === -1) {
	                            templatesFiles.push(path);
	                        } else if (file_type === 'js' || jsFiles.indexOf(path) === -1) {
	                            jsFiles.push(path);
	                        } else {
	                            $delegate._$log.error('File type is not valid. ' + path);
	                        }
	                    } else if (cachePromise) {
	                        promises.push(cachePromise);
	                    }
	                };
	
	                if (params.serie) {
	                    pushFile(params.files.shift());
	                } else {
	                    angular.forEach(params.files, function (path) {
	                        pushFile(path);
	                    });
	                }
	
	                if (cssFiles.length > 0) {
	                    var cssDeferred = $q.defer();
	                    $delegate.cssLoader(cssFiles, function (err) {
	                        if (angular.isDefined(err) && $delegate.cssLoader.hasOwnProperty('ocLazyLoadLoader')) {
	                            $delegate._$log.error(err);
	                            cssDeferred.reject(err);
	                        } else {
	                            cssDeferred.resolve();
	                        }
	                    }, params);
	                    promises.push(cssDeferred.promise);
	                }
	
	                if (templatesFiles.length > 0) {
	                    var templatesDeferred = $q.defer();
	                    $delegate.templatesLoader(templatesFiles, function (err) {
	                        if (angular.isDefined(err) && $delegate.templatesLoader.hasOwnProperty('ocLazyLoadLoader')) {
	                            $delegate._$log.error(err);
	                            templatesDeferred.reject(err);
	                        } else {
	                            templatesDeferred.resolve();
	                        }
	                    }, params);
	                    promises.push(templatesDeferred.promise);
	                }
	
	                if (jsFiles.length > 0) {
	                    var jsDeferred = $q.defer();
	                    $delegate.jsLoader(jsFiles, function (err) {
	                        if (angular.isDefined(err) && ($delegate.jsLoader.hasOwnProperty("ocLazyLoadLoader") || $delegate.jsLoader.hasOwnProperty("requirejs"))) {
	                            $delegate._$log.error(err);
	                            jsDeferred.reject(err);
	                        } else {
	                            jsDeferred.resolve();
	                        }
	                    }, params);
	                    promises.push(jsDeferred.promise);
	                }
	
	                if (promises.length === 0) {
	                    var deferred = $q.defer(),
	                        err = "Error: no file to load has been found, if you're trying to load an existing module you should use the 'inject' method instead of 'load'.";
	                    $delegate._$log.error(err);
	                    deferred.reject(err);
	                    return deferred.promise;
	                } else if (params.serie && params.files.length > 0) {
	                    return $q.all(promises).then(function () {
	                        return $delegate.filesLoader(config, params);
	                    });
	                } else {
	                    return $q.all(promises)['finally'](function (res) {
	                        $delegate.toggleWatch(false); // stop watching angular.module calls
	                        return res;
	                    });
	                }
	            };
	
	            /**
	             * Load a module or a list of modules into Angular
	             * @param module Mixed the name of a predefined module config object, or a module config object, or an array of either
	             * @param params Object optional parameters
	             * @returns promise
	             */
	            $delegate.load = function (originalModule) {
	                var originalParams = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	                var self = this,
	                    config = null,
	                    deferredList = [],
	                    deferred = $q.defer(),
	                    errText;
	
	                // clean copy
	                var module = angular.copy(originalModule);
	                var params = angular.copy(originalParams);
	
	                // If module is an array, break it down
	                if (angular.isArray(module)) {
	                    // Resubmit each entry as a single module
	                    angular.forEach(module, function (m) {
	                        deferredList.push(self.load(m, params));
	                    });
	
	                    // Resolve the promise once everything has loaded
	                    $q.all(deferredList).then(function (res) {
	                        deferred.resolve(res);
	                    }, function (err) {
	                        deferred.reject(err);
	                    });
	
	                    return deferred.promise;
	                }
	
	                // Get or Set a configuration depending on what was passed in
	                if (angular.isString(module)) {
	                    config = self.getModuleConfig(module);
	                    if (!config) {
	                        config = {
	                            files: [module]
	                        };
	                    }
	                } else if (angular.isObject(module)) {
	                    // case {type: 'js', path: lazyLoadUrl + 'testModule.fakejs'}
	                    if (angular.isDefined(module.path) && angular.isDefined(module.type)) {
	                        config = {
	                            files: [module]
	                        };
	                    } else {
	                        config = self.setModuleConfig(module);
	                    }
	                }
	
	                if (config === null) {
	                    var moduleName = self._getModuleName(module);
	                    errText = 'Module "' + (moduleName || 'unknown') + '" is not configured, cannot load.';
	                    $delegate._$log.error(errText);
	                    deferred.reject(new Error(errText));
	                    return deferred.promise;
	                } else {
	                    // deprecated
	                    if (angular.isDefined(config.template)) {
	                        if (angular.isUndefined(config.files)) {
	                            config.files = [];
	                        }
	                        if (angular.isString(config.template)) {
	                            config.files.push(config.template);
	                        } else if (angular.isArray(config.template)) {
	                            config.files.concat(config.template);
	                        }
	                    }
	                }
	
	                var localParams = angular.extend({}, params, config);
	
	                // if someone used an external loader and called the load function with just the module name
	                if (angular.isUndefined(config.files) && angular.isDefined(config.name) && $delegate.moduleExists(config.name)) {
	                    return $delegate.inject(config.name, localParams, true);
	                }
	
	                $delegate.filesLoader(config, localParams).then(function () {
	                    $delegate.inject(null, localParams).then(function (res) {
	                        deferred.resolve(res);
	                    }, function (err) {
	                        deferred.reject(err);
	                    });
	                }, function (err) {
	                    deferred.reject(err);
	                });
	
	                return deferred.promise;
	            };
	
	            // return the patched service
	            return $delegate;
	        }]);
	    }]);
	})(angular);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
	        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
	            /**
	             * cssLoader function
	             * @type Function
	             * @param paths array list of css files to load
	             * @param callback to call when everything is loaded. We use a callback and not a promise
	             * @param params object config parameters
	             * because the user can overwrite cssLoader and it will probably not use promises :(
	             */
	            $delegate.cssLoader = function (paths, callback, params) {
	                var promises = [];
	                angular.forEach(paths, function (path) {
	                    promises.push($delegate.buildElement('css', path, params));
	                });
	                $q.all(promises).then(function () {
	                    callback();
	                }, function (err) {
	                    callback(err);
	                });
	            };
	            $delegate.cssLoader.ocLazyLoadLoader = true;
	
	            return $delegate;
	        }]);
	    }]);
	})(angular);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
	        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
	            /**
	             * jsLoader function
	             * @type Function
	             * @param paths array list of js files to load
	             * @param callback to call when everything is loaded. We use a callback and not a promise
	             * @param params object config parameters
	             * because the user can overwrite jsLoader and it will probably not use promises :(
	             */
	            $delegate.jsLoader = function (paths, callback, params) {
	                var promises = [];
	                angular.forEach(paths, function (path) {
	                    promises.push($delegate.buildElement('js', path, params));
	                });
	                $q.all(promises).then(function () {
	                    callback();
	                }, function (err) {
	                    callback(err);
	                });
	            };
	            $delegate.jsLoader.ocLazyLoadLoader = true;
	
	            return $delegate;
	        }]);
	    }]);
	})(angular);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
	        $provide.decorator('$ocLazyLoad', ["$delegate", "$templateCache", "$q", "$http", function ($delegate, $templateCache, $q, $http) {
	            /**
	             * templatesLoader function
	             * @type Function
	             * @param paths array list of css files to load
	             * @param callback to call when everything is loaded. We use a callback and not a promise
	             * @param params object config parameters for $http
	             * because the user can overwrite templatesLoader and it will probably not use promises :(
	             */
	            $delegate.templatesLoader = function (paths, callback, params) {
	                var promises = [],
	                    filesCache = $delegate._getFilesCache();
	
	                angular.forEach(paths, function (url) {
	                    var deferred = $q.defer();
	                    promises.push(deferred.promise);
	                    $http.get(url, params).success(function (data) {
	                        if (angular.isString(data) && data.length > 0) {
	                            angular.forEach(angular.element(data), function (node) {
	                                if (node.nodeName === 'SCRIPT' && node.type === 'text/ng-template') {
	                                    $templateCache.put(node.id, node.innerHTML);
	                                }
	                            });
	                        }
	                        if (angular.isUndefined(filesCache.get(url))) {
	                            filesCache.put(url, true);
	                        }
	                        deferred.resolve();
	                    }).error(function (err) {
	                        deferred.reject(new Error('Unable to load template file "' + url + '": ' + err));
	                    });
	                });
	                return $q.all(promises).then(function () {
	                    callback();
	                }, function (err) {
	                    callback(err);
	                });
	            };
	            $delegate.templatesLoader.ocLazyLoadLoader = true;
	
	            return $delegate;
	        }]);
	    }]);
	})(angular);
	// Array.indexOf polyfill for IE8
	if (!Array.prototype.indexOf) {
	    Array.prototype.indexOf = function (searchElement, fromIndex) {
	        var k;
	
	        // 1. Let O be the result of calling ToObject passing
	        //    the this value as the argument.
	        if (this == null) {
	            throw new TypeError('"this" is null or not defined');
	        }
	
	        var O = Object(this);
	
	        // 2. Let lenValue be the result of calling the Get
	        //    internal method of O with the argument "length".
	        // 3. Let len be ToUint32(lenValue).
	        var len = O.length >>> 0;
	
	        // 4. If len is 0, return -1.
	        if (len === 0) {
	            return -1;
	        }
	
	        // 5. If argument fromIndex was passed let n be
	        //    ToInteger(fromIndex); else let n be 0.
	        var n = +fromIndex || 0;
	
	        if (Math.abs(n) === Infinity) {
	            n = 0;
	        }
	
	        // 6. If n >= len, return -1.
	        if (n >= len) {
	            return -1;
	        }
	
	        // 7. If n >= 0, then Let k be n.
	        // 8. Else, n<0, Let k be len - abs(n).
	        //    If k is less than 0, then let k be 0.
	        k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
	
	        // 9. Repeat, while k < len
	        while (k < len) {
	            // a. Let Pk be ToString(k).
	            //   This is implicit for LHS operands of the in operator
	            // b. Let kPresent be the result of calling the
	            //    HasProperty internal method of O with argument Pk.
	            //   This step can be combined with c
	            // c. If kPresent is true, then
	            //    i.  Let elementK be the result of calling the Get
	            //        internal method of O with the argument ToString(k).
	            //   ii.  Let same be the result of applying the
	            //        Strict Equality Comparison Algorithm to
	            //        searchElement and elementK.
	            //  iii.  If same is true, return k.
	            if (k in O && O[k] === searchElement) {
	                return k;
	            }
	            k++;
	        }
	        return -1;
	    };
	}

/***/ },

/***/ 836:
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },

/***/ 837:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(838);
	module.exports = 'zingchart-angularjs';


/***/ },

/***/ 838:
/***/ function(module, exports) {

	/**
	* File: zingchart-angularjs.js
	* Version: v1.1.0
	*/
	
	(function(){
	    'use strict';
	    angular.module('zingchart-angularjs', [] )
	    .directive('zingchart', [function(){
	        var currentAutoId = 1;
	
	        return {
	            restrict : 'EA',
	            scope : {
	                id : '@',
	                zcValues : '=',
	                zcJson : '=',
	                zcRender : '=',
			zcLicense : '='
	            },
	            controller : ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
	                var id;
	                // Get or generate id
	                if(!$attrs.id){
	                    id = 'zingchart-auto-' + currentAutoId;
	                    currentAutoId++;
	                    $attrs.id = id;
	                    // newly generated id has to be put back on the element too to meet
	                    // zingcharts requirements
	                    $element.attr('id', id);
	                }
	                else{
	                    if($attrs.id.indexOf('{{') > -1){
	                        id=$scope.id;
	                        $element.attr('id', id);
	                    }
	                    else{
	                        id = $attrs.id;
	                    }
	                }
	
	                var initializing = {
	                    json : true,
	                    values : true,
	                    render : true
	                };
	                $scope.$watchCollection('zcValues', function(){
	                    if(initializing.values){
	                        initializing.values = !initializing.values;
	                        return;
	                    }
	                    if($scope.zcValues){
	                        if(isMultiArray($scope.zcValues)){
	                            zingchart.exec(id, 'setseriesvalues', {
	                                values : $scope.zcValues
	                            });
	                        }
	                        else{
	                            zingchart.exec(id, 'setseriesvalues', {
	                                values : [$scope.zcValues]
	                            });
	                        }
	                    }
	                });
	
	                $scope.$watch('zcLicense', function(newValue, oldValue, scope) {
	                    if(initializing.license){
	                        initializing.license = !initializing.license;
	                        return;
	                    }
	
	                    ZC.LICENSE = scope.zcLicense;
	                    scope.zcLicense = newValue;
	                },true);
	
	                $scope.$watch('zcJson', function(){
	                    if(initializing.json){
	                        initializing.json = !initializing.json;
	                        return;
	                    }
	                    if($attrs.zcJson){
	                        var _json = $scope.zcJson;
	
	                        //Inject values
	                        if($scope.zcValues){
				                injectValues($scope.zcValues, _json);
	                        }
	                        //Inject type
	                        if(JSON.stringify(_json).indexOf('type') === -1){
	                            _json.type = 'line';
	                        }
	                        else{
	                            _json.type = ($attrs.zcType) ? $attrs.zcType : _json.type
	                        }
	                        zingchart.exec(id, 'setdata', {
	                            data : _json
	                        });
	                    }
	                },true);
	
	                $scope.$watch('zcRender', function(newValue, oldValue, scope) {
	                    if(initializing.render){
	                        initializing.render = !initializing.render;
	                        return;
	                    }
	
	                    // Destroy the chart and re-render it with changed attributes
	                    zingchart.exec(scope.id, 'destroy');
	                    scope.zcRender = newValue;
	                    scope.renderChart();
	                },true);
	
	                $scope.renderChart = function (){
	                    var id = $element.attr('id');
	                    //Defaults
	                    var _json = {
	                        data : {
	                            type : 'line',
	                            series : []
	                        },
	                        width : 600,
	                        height: 400
	                    };
				
	                    //Add render object.
	                    if($scope.zcRender){
	                        mergeObject($scope.zcRender, _json);
	                    }
	
	                    //Add JSON object
	                    if($scope.zcJson){
	                        mergeObject($scope.zcJson, _json.data);
	                    }
	
	                    //Add Values
	                    if($scope.zcValues){
	                        injectValues($scope.zcValues, _json.data);
	                    }
	
	                    //Add other properties
	                    _json.data.type = ($attrs.zcType) ? $attrs.zcType : _json.data.type;
	                    _json.height = ($attrs.zcHeight) ? $attrs.zcHeight : _json.height;
	                    _json.width = ($attrs.zcWidth) ? $attrs.zcWidth : _json.width;
	                    _json.id = id;
	
	                    //Set the box-model of the container element if the height or width are defined as 100%.
	                    if(_json.width === "100%" && !$element.css('width')){
	                        $element.css('width', '100%');
	                    }
	                    if(_json.height === "100%" && !$element.css('height')){
	                        $element.css('height', '100%');
	                    }
			    ZC.LICENSE = $scope.zcLicense;
	                    zingchart.render(_json);
	                }
	                
	                $scope.$on('$destroy', function() {
	                    zingchart.exec($scope.id,'destroy');
	                });
	            }],
	            link : function($scope){
	                $scope.renderChart();
	            }
	        };
	    }]);
	
		/**
		* Injects values into each series, and handles multi series cases.
		* @param the values to inject into the config object
		* @param the configuration object itself.
		*/
		function injectValues(values, config) {
			if(typeof config.series === 'undefined'){
				config.series = [];
			}
			//Single Series
			if(!isMultiArray(values)){
				if(config.series[0]){
					config.series[0].values = values;
				}
				else{
					config.series.push({'values' : values});
				}
			}
			//Multi Series
			else{
				for(var i = 0; i < values.length; i++){
					if(config.series[i]){
						config.series[i].values = values[i];
					}
					else{
						config.series.push({'values' : values[i]});
					}
				}
			}
			return config;
		}
	
	    /**
	    *   Helper function to merge an object into another, overwriting properties.
	    *   A shallow, not a recursive merge
	    *   @param {object} fromObj - The object that has properties to be merged
	    *   @param {object} intoObj - The object being merged into (Result)
	    */
	    function mergeObject(fromObj, intoObj){
	        for(var property in fromObj){
	            if (fromObj.hasOwnProperty(property)) {
	                intoObj[property] = fromObj[property];
	            }
	        }
	    }
	
	    /**
	    *   Determines whether an array is multidimensional or not.
	    *   @param {array} _array - The array to test
	    *   @returns {boolean} - true if the array is multidimensional, false otherwise
	    */
	    function isMultiArray(_array){
			return Array.isArray(_array[0]);
	    }
	
	})();


/***/ }

/******/ })));


/** WEBPACK FOOTER **
 ** vendors.min.js
 **/